(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8cae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8cae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8if87", function(module, exports) {
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default true
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.11'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        if (!htmx.config.allowScriptTags) {
            // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
            return;
        }
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // convert <hx-*> custom tags to <template hx type="*"> so they survive HTML parsing
        response = response.replace(/<hx-([a-z]+)((?:\s[^>]*)?)>/gi, '<template hx type="$1"$2>').replace(/<\/hx-[a-z]+>/gi, '</template>');
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) normalizeScriptTags(fragment);
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        return Object.assign({}, obj1, obj2);
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        try {
            const url = new URL(path, window.location.href);
            path = url.pathname + url.search;
        } catch (e) {
        // fallback for malformed URLs
        }
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to search inside of, not including the root itself | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector  the root element to search inside of, not including the root itself | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement,
                target: selector
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(CSS.escape(newNode.tagName) + '#' + CSS.escape(id));
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Element} sourceElement
   * @returns {boolean}
   */ function findAndSwapPartials(fragment, settleInfo, sourceElement) {
        var hxTemplates = findAll(fragment, 'template[hx]');
        forEach(hxTemplates, function(template) {
            var type = getRawAttribute(template, 'type');
            if (type === 'partial') {
                var targetSelector = getAttributeValue(template, 'hx-target') || (template.id ? '#' + CSS.escape(template.id) : null);
                if (targetSelector) {
                    var swapOverride = getAttributeValue(template, 'hx-swap');
                    var swapSpec = getSwapSpecification(template, swapOverride);
                    var targets = querySelectorAllExt(sourceElement || getDocument().body, targetSelector, false);
                    if (targets.length === 0) triggerErrorEvent(getDocument().body, 'htmx:partialErrorNoTarget', {
                        template: template,
                        targetSelector: targetSelector,
                        sourceElement: sourceElement
                    });
                    forEach(targets, function(target) {
                        target = asElement(target);
                        if (target) {
                            var fragment = template.content.cloneNode(true);
                            normalizeScriptTags(fragment);
                            var beforeSwapDetails = {
                                shouldSwap: true,
                                target: target,
                                fragment: fragment
                            };
                            if (!triggerEvent(target, 'htmx:partialBeforeSwap', beforeSwapDetails)) return;
                            target = beforeSwapDetails.target;
                            if (beforeSwapDetails.shouldSwap) swap(target, beforeSwapDetails.fragment, swapSpec, {
                                contextElement: target,
                                afterSwapCallback: function() {
                                    forEach(settleInfo.elts, function(elt) {
                                        triggerEvent(elt, 'htmx:partialAfterSwap', beforeSwapDetails);
                                    });
                                }
                            });
                        }
                    });
                }
            } else triggerEvent(getDocument().body, 'htmx:processTemplate', {
                type: type,
                template: template,
                settleInfo: settleInfo,
                sourceElement: sourceElement
            });
            template.parentNode.removeChild(template);
        });
        return hxTemplates.length > 0;
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            // A detached contextElement's own getRootNode() is its orphaned subtree, not
            // the document, so OOB targets that are still live in the document would be
            // unreachable through it - fall back to the document in that case.
            const rootNode = swapOptions.contextElement && swapOptions.contextElement.isConnected ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = typeof content === 'string' ? makeFragment(content) : content;
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // partial swaps — after oob, before main swap
                var hasPartials = findAndSwapPartials(fragment, settleInfo, swapOptions.contextElement || asElement(target));
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                // if the response contained only <hx-partial> tags and nothing else, skip the main swap
                if (hasPartials && !fragment.childElementCount && !fragment.textContent.trim()) settleInfo.elts = [
                    asElement(target)
                ];
                else swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            removeClassFromElement(target, htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) addClassToElement(elt, htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) removeClassFromElement(elt, htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody) || {};
            for (const eventName of Object.keys(triggers)){
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for (const e of Object.keys(extensions)){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error + (detail.target ? ', ' + detail.target : ''));
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            addClassToElement(ic, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            if (!disabledElement.hasAttribute('disabled')) {
                disabledElement.setAttribute('disabled', '');
                disabledElement.setAttribute('data-disabled-by-htmx', '');
            }
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) removeClassFromElement(ic, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0 && disabledElement.hasAttribute('data-disabled-by-htmx')) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for (const key of Object.keys(varsValues))if (values[key] == null) values[key] = varsValues[key];
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} name
   * @return {boolean}
   */ function hasHeader(xhr, name) {
        return xhr.getResponseHeader(name) !== null;
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for (const key of Object.keys(obj)){
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else for (const header of Object.keys(headers))safelySetHeaderValue(xhr, header, headers[header]);
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, 'HX-Push')) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, 'HX-Push-Url')) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, 'HX-Replace-Url')) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        const pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        let replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        if (replaceUrl === 'false') replaceUrl = null;
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, 'HX-Trigger')) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, 'HX-Location')) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push ?? 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, 'HX-Refresh') && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, 'HX-Redirect')) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, 'HX-Retarget')) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, 'HX-Reswap')) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            addClassToElement(target, htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, 'HX-Reselect')) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, 'HX-Trigger-After-Swap')) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, 'HX-Trigger-After-Settle')) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $609bbda3516a49df$export$2e2bcd8739ae039 = htmx;

});

parcelRequire("8if87");

class $fae8e84091194bdf$var$OverlayNavigation {
    constructor(toggle, navigations){
        this.toggleOpen = toggle.querySelector('[data-action="open"]');
        this.toggleClose = toggle.querySelector('[data-action="close"]');
        this.navigations = navigations;
        this._openNav = null;
        this.applyEvents();
    }
    set openNav(value) {
        const previous = this._openNav;
        this._openNav = value;
        this.onOpenNavChange(value, previous);
    }
    onOpenNavChange(current, previous) {
        const hideToggle = (el)=>{
            el.classList.add('hidden');
            el.setAttribute('aria-hidden', 'true');
        };
        const showToggle = (el)=>{
            el.classList.remove('hidden');
            el.setAttribute('aria-hidden', 'false');
        };
        if (previous) this.closeNavigation(previous);
        if (current) {
            document.body.setAttribute('data-noscroll', '');
            document.body.classList.add("nav-open");
            this.openNavigation(current);
            hideToggle(this.toggleOpen);
            showToggle(this.toggleClose);
        } else {
            document.body.removeAttribute('data-noscroll', '');
            document.body.classList.remove("nav-open");
            showToggle(this.toggleOpen);
            hideToggle(this.toggleClose);
        }
    }
    openNavigation(nav) {
        nav.overlay.classList.add('active');
    }
    closeNavigation(nav) {
        nav.overlay.classList.remove('active');
    }
    applyEvents() {
        Object.values(this.navigations).forEach((nav)=>{
            nav.toggle.addEventListener('click', ()=>{
                this.openNav = nav;
            });
        });
        this.toggleClose.addEventListener('click', ()=>this.openNav = null);
    }
}
const $fae8e84091194bdf$export$ed413954a0d25a18 = ()=>{
    const headerToggle = document.getElementById('mobile-nav-toggle');
    if (!headerToggle) {
        console.error('Mobile navigation toggle not found');
        return;
    }
    const toggles = document.querySelectorAll('[data-overlay-nav]');
    const navigations = [
        ...toggles
    ].reduce((navs, toggle)=>{
        const id = toggle.dataset.overlayNav;
        const overlay = document.getElementById(id);
        if (!overlay) {
            console.error('Navigation target not found');
            return navs;
        }
        return {
            ...navs,
            [id]: {
                overlay: overlay,
                toggle: toggle
            }
        };
    }, {});
    new $fae8e84091194bdf$var$OverlayNavigation(headerToggle, navigations);
};


var $d0e6c103fdd72c14$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $d0e6c103fdd72c14$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $01c55b35388eeff4$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $01c55b35388eeff4$export$2e2bcd8739ae039 = $01c55b35388eeff4$export$33e6c23ebe2ee669;


var $7c36d6f76aae5f22$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $7c36d6f76aae5f22$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $7c36d6f76aae5f22$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $7c36d6f76aae5f22$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $46627959f4a6cf8e$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $46627959f4a6cf8e$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $46627959f4a6cf8e$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $46627959f4a6cf8e$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $46627959f4a6cf8e$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $46627959f4a6cf8e$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $46627959f4a6cf8e$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $46627959f4a6cf8e$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $46627959f4a6cf8e$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $46627959f4a6cf8e$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $46627959f4a6cf8e$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $bc1b2819a5a95bf4$var$doNothing = function() {
    return undefined;
};
var $bc1b2819a5a95bf4$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $bc1b2819a5a95bf4$export$9490b78b888a863f = {
    D: $bc1b2819a5a95bf4$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $bc1b2819a5a95bf4$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $bc1b2819a5a95bf4$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $bc1b2819a5a95bf4$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$bc1b2819a5a95bf4$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $bc1b2819a5a95bf4$export$27a2dd9af757e89c($bc1b2819a5a95bf4$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)($bc1b2819a5a95bf4$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $bc1b2819a5a95bf4$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $68991a5a65b43fc7$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $01c55b35388eeff4$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $bc1b2819a5a95bf4$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $bc1b2819a5a95bf4$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $68991a5a65b43fc7$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $01c55b35388eeff4$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $bc1b2819a5a95bf4$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $68991a5a65b43fc7$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $68991a5a65b43fc7$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $68991a5a65b43fc7$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $68991a5a65b43fc7$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $68991a5a65b43fc7$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $68991a5a65b43fc7$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $68991a5a65b43fc7$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $f56a17c2fb2ad30e$var$__assign = undefined && undefined.__assign || function() {
    $f56a17c2fb2ad30e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f56a17c2fb2ad30e$var$__assign.apply(this, arguments);
};
var $f56a17c2fb2ad30e$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $f56a17c2fb2ad30e$var$DEBOUNCED_CHANGE_MS = 300;
function $f56a17c2fb2ad30e$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e)), $f56a17c2fb2ad30e$var$flatpickr.defaultConfig),
        l10n: (0, $01c55b35388eeff4$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $68991a5a65b43fc7$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $68991a5a65b43fc7$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $68991a5a65b43fc7$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $68991a5a65b43fc7$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $68991a5a65b43fc7$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $7c36d6f76aae5f22$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $7c36d6f76aae5f22$export$61fc7d43ac8f84b0)(triggerChange, $f56a17c2fb2ad30e$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $bc1b2819a5a95bf4$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $46627959f4a6cf8e$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $46627959f4a6cf8e$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $f56a17c2fb2ad30e$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $f56a17c2fb2ad30e$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $68991a5a65b43fc7$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $68991a5a65b43fc7$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $68991a5a65b43fc7$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $68991a5a65b43fc7$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $68991a5a65b43fc7$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.dateFormat || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.altFormat || (0, $d0e6c103fdd72c14$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $d0e6c103fdd72c14$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $d0e6c103fdd72c14$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $f56a17c2fb2ad30e$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $f56a17c2fb2ad30e$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $bc1b2819a5a95bf4$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $f56a17c2fb2ad30e$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $68991a5a65b43fc7$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $46627959f4a6cf8e$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $46627959f4a6cf8e$export$25245567f53f158f)((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $68991a5a65b43fc7$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $d0e6c103fdd72c14$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $7c36d6f76aae5f22$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $46627959f4a6cf8e$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $68991a5a65b43fc7$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $68991a5a65b43fc7$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $bc1b2819a5a95bf4$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $46627959f4a6cf8e$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(isHourElem) && (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $7c36d6f76aae5f22$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $7c36d6f76aae5f22$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $f56a17c2fb2ad30e$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $f56a17c2fb2ad30e$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $f56a17c2fb2ad30e$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $f56a17c2fb2ad30e$var$_flatpickr([
            this
        ], config);
    };
}
var $f56a17c2fb2ad30e$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $f56a17c2fb2ad30e$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $f56a17c2fb2ad30e$var$_flatpickr([
        selector
    ], config);
    else return $f56a17c2fb2ad30e$var$_flatpickr(selector, config);
};
$f56a17c2fb2ad30e$var$flatpickr.defaultConfig = {};
$f56a17c2fb2ad30e$var$flatpickr.l10ns = {
    en: $f56a17c2fb2ad30e$var$__assign({}, (0, $01c55b35388eeff4$export$2e2bcd8739ae039)),
    default: $f56a17c2fb2ad30e$var$__assign({}, (0, $01c55b35388eeff4$export$2e2bcd8739ae039))
};
$f56a17c2fb2ad30e$var$flatpickr.localize = function(l10n) {
    $f56a17c2fb2ad30e$var$flatpickr.l10ns.default = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.l10ns.default), l10n);
};
$f56a17c2fb2ad30e$var$flatpickr.setDefaults = function(config) {
    $f56a17c2fb2ad30e$var$flatpickr.defaultConfig = $f56a17c2fb2ad30e$var$__assign($f56a17c2fb2ad30e$var$__assign({}, $f56a17c2fb2ad30e$var$flatpickr.defaultConfig), config);
};
$f56a17c2fb2ad30e$var$flatpickr.parseDate = (0, $68991a5a65b43fc7$export$cfa2ef2687faeda2)({});
$f56a17c2fb2ad30e$var$flatpickr.formatDate = (0, $68991a5a65b43fc7$export$ff1a0b75284ac636)({});
$f56a17c2fb2ad30e$var$flatpickr.compareDates = (0, $68991a5a65b43fc7$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $f56a17c2fb2ad30e$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $f56a17c2fb2ad30e$var$flatpickr;
var $f56a17c2fb2ad30e$export$2e2bcd8739ae039 = $f56a17c2fb2ad30e$var$flatpickr;


var $ebbf0df47bb07d46$exports = {};
(function(global, factory) {
    factory($ebbf0df47bb07d46$exports);
})($ebbf0df47bb07d46$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $f4551f8e01c5a41c$exports = {};
(function(global, factory) {
    factory($f4551f8e01c5a41c$exports);
})($f4551f8e01c5a41c$exports, function(exports1) {
    'use strict';
    var english = {
        weekdays: {
            shorthand: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        daysInMonth: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        firstDayOfWeek: 0,
        ordinal: function(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch(s % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: [
            "AM",
            "PM"
        ],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: false
    };
    exports1.default = english;
    exports1.english = english;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



const $ac3e1fcae237d601$var$datePickerClass = "datepicker";
function $ac3e1fcae237d601$var$getLocale(elm) {
    const locale = elm.dataset.language;
    if (locale) switch(locale){
        case "DE":
            return {
                ...(0, $ebbf0df47bb07d46$exports.German)
            };
        default:
            return {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($f4551f8e01c5a41c$exports)))
            };
    }
    else return {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($f4551f8e01c5a41c$exports)))
    };
}
function $ac3e1fcae237d601$var$globalConfig(e) {
    return {
        locale: {
            ...$ac3e1fcae237d601$var$getLocale(e),
            firstDayOfWeek: 1
        },
        altInput: true,
        time_24hr: true,
        minuteIncrement: 1,
        allowInput: true
    };
}
const $ac3e1fcae237d601$var$isDate = (date)=>date && date.getMonth() ? true : false;
const $ac3e1fcae237d601$var$largestDate = (dates)=>{
    const filtered = dates.filter((date)=>$ac3e1fcae237d601$var$isDate(date));
    return filtered.length ? filtered.reduce((a, b)=>a > b ? a : b, 0) : null;
};
function $ac3e1fcae237d601$export$ed8a68ffbc322e67(container = document) {
    (0, $f56a17c2fb2ad30e$export$2e2bcd8739ae039).localize({
        firstDayOfWeek: 1
    });
    const renderDatepickers = (container)=>{
        [
            ...container.getElementsByClassName($ac3e1fcae237d601$var$datePickerClass)
        ].forEach((e)=>{
            const { disablePast: disablePast, disableFuture: disableFuture, disableTime: disableTime, minDate: dataMinDate, minInputElement: minInputElement } = e.dataset;
            const classlist = Array.from(e.classList);
            const dateFormat = disableTime ? "Y-m-d" : "Z";
            const altFormat = disableTime ? "d.m.Y" : "d.m.Y H:i";
            const formGroup = e.closest(".form-group");
            const minInputEl = minInputElement && document.querySelector(`[name="${minInputElement}"]`);
            const minInputElValue = minInputEl && minInputEl.value;
            const minInputElementDate = minInputElValue && new Date(minInputElValue);
            const parsedMinDate = dataMinDate && new Date(dataMinDate);
            const nowDate = disablePast && new Date();
            const minDate = $ac3e1fcae237d601$var$largestDate([
                parsedMinDate,
                minInputElementDate,
                nowDate
            ]);
            const f = (0, $f56a17c2fb2ad30e$export$2e2bcd8739ae039)(e, {
                ...$ac3e1fcae237d601$var$globalConfig(e),
                altFormat: altFormat,
                dateFormat: dateFormat,
                enableTime: !disableTime,
                minDate: minDate,
                maxDate: disableFuture ? new Date() : null,
                onChange: function(selectedDates, dateStr, instance) {
                    const helpText = formGroup.querySelector(".datepicker-msg");
                    if (e.dataset.warnPast) {
                        if (new Date() > selectedDates[0]) helpText.textContent = e.dataset.warnPast;
                        else helpText.textContent = "";
                    }
                },
                onReady: function(value, originalValue, instance) {
                    const { altInput: altInput, hourElement: hourElement, minuteElement: minuteElement } = instance;
                    altInput.disabled = e.readOnly; // Workaround for https://github.com/flatpickr/flatpickr/issues/2492
                    classlist.forEach((cls)=>altInput.classList.add(cls));
                    // Manually set time when using keyboard
                    hourElement.addEventListener("keyup", (e)=>{
                        const date = instance.selectedDates[0] || new Date();
                        date.setHours(e.currentTarget.value);
                        instance.setDate(date);
                    });
                    minuteElement.addEventListener("keyup", (e)=>{
                        const date = instance.selectedDates[0] || new Date();
                        date.setMinutes(e.currentTarget.value);
                        instance.setDate(date);
                    });
                }
            });
            if (minInputEl) minInputEl.addEventListener("change", (e)=>{
                const value = new Date(e.currentTarget.value);
                const minDate = $ac3e1fcae237d601$var$largestDate([
                    value,
                    parsedMinDate,
                    nowDate
                ]);
                f.set('minDate', minDate);
            });
        });
    };
    renderDatepickers(container);
    document.addEventListener('htmx:afterSettle', (e)=>{
        renderDatepickers(e.detail.elt);
    });
}


const $df43d05d75fb9bbd$export$7e7c59184b302942 = "An Error occurred";
const $df43d05d75fb9bbd$export$c077d53e8672d0e9 = (form)=>{
    const container = form || document;
    return container.querySelector('[name="_csrf"]').value;
};
const $df43d05d75fb9bbd$export$1ca1ec8b29a4ce27 = (classnames)=>{
    const i = document.createElement("i");
    i.classList.add(...classnames);
    return i;
};
const $df43d05d75fb9bbd$export$c091916f1530334c = (elm)=>{
    elm.classList.add("fade-out", "no-delay");
};
function $df43d05d75fb9bbd$export$536d3099948c8b0a(notificationId) {
    const notification = document.getElementById(notificationId);
    const iconClose = notification ? notification.querySelector(".notification-close") : false;
    if (iconClose) iconClose.addEventListener("click", ()=>$df43d05d75fb9bbd$export$c091916f1530334c(notification));
}
const $df43d05d75fb9bbd$export$cb0ca92a4a718384 = (notificationId, classname, msg)=>{
    const inner = document.createElement("div");
    inner.classList.add("notification", classname);
    inner.textContent = msg instanceof Error ? msg.message : String(msg);
    const closeIcon = $df43d05d75fb9bbd$export$1ca1ec8b29a4ce27([
        "icon-close",
        "notification-close"
    ]);
    const wrapper = document.createElement("div");
    wrapper.classList.add("notification-fixed");
    wrapper.id = notificationId;
    inner.appendChild(closeIcon);
    wrapper.appendChild(inner);
    const notification = document.getElementById(notificationId);
    notification.parentElement.replaceChild(wrapper, notification);
    $df43d05d75fb9bbd$export$536d3099948c8b0a(notificationId);
};
const $df43d05d75fb9bbd$export$74fb9998885c90c9 = async (url, body)=>{
    let formBody = [];
    for(let key in body){
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(body[key]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody.join("&")
    });
};


let $71157344672d24b0$var$assignContactCallback = (option)=>{
    const { hxTarget: hxTarget } = option.dataset;
    const body = document.querySelector("body");
    document.addEventListener("htmx:afterSwap", (e)=>{
        const { elt: elt } = e.detail;
        if (elt.id === hxTarget.substring(1)) {
            body.toggleAttribute("data-noscroll");
            elt.querySelector(".modal-close").addEventListener("click", ()=>{
                body.toggleAttribute("data-noscroll");
                elt.classList.remove("active");
            }, {
                once: true
            });
        }
    }, {
        once: true
    });
};
let $71157344672d24b0$var$callbackOfAttribute = (callback)=>{
    switch(callback){
        case "assign-contact":
            return $71157344672d24b0$var$assignContactCallback;
        default:
            return null;
    }
};
const $71157344672d24b0$var$createTag = (option, name, inputType)=>{
    const item = document.createElement("span");
    item.setAttribute("data-selection-item", "");
    item.innerHTML = option.innerHTML;
    const icon = document.createElement("i");
    icon.classList.add("icon-close");
    const input = document.createElement("input");
    input.setAttribute("type", "checkbox");
    if (inputType) input.setAttribute("data-input-type", inputType);
    input.checked = true;
    input.setAttribute("hidden", "");
    input.value = option.dataset.value;
    input.name = name;
    item.appendChild(icon);
    item.appendChild(input);
    return item;
};
const $71157344672d24b0$var$addRemoveItemListener = (item, callback)=>{
    item.querySelector(".icon-close").addEventListener("click", ()=>{
        item.remove();
        if (callback) callback();
    }, {
        once: true
    });
};
class $71157344672d24b0$var$Search {
    constructor(input){
        const { name: name, inputType: inputType, callback: callback } = input.dataset;
        this.input = input;
        this.name = name;
        this.inputType = inputType;
        this.clickCallack = $71157344672d24b0$var$callbackOfAttribute(callback);
        this.wrapper = this.input.closest(".form-group");
        this.selection = this.wrapper.querySelector("[data-search-selection]");
        this.optionsWrapper = this.wrapper.querySelector(".data-list");
        this.addOptionsCloseListener();
    }
    addSelectedItemsRemoveListeners(callback) {
        [
            ...this.selection.querySelectorAll("[data-selection-item]")
        ].forEach((item)=>$71157344672d24b0$var$addRemoveItemListener(item, callback));
    }
    addOptionsCloseListener() {
        document.addEventListener("click", (e)=>{
            if (!this.wrapper.contains(e.target)) this.optionsWrapper.classList.remove("active");
        });
    }
    createSelectedItem(option) {
        const item = $71157344672d24b0$var$createTag(option, this.name, this.inputType);
        this.selection.appendChild(item);
        $71157344672d24b0$var$addRemoveItemListener(item);
    }
}
class $71157344672d24b0$var$StaticSearch extends $71157344672d24b0$var$Search {
    constructor(input){
        super(input);
        this.options = this.optionsWrapper.querySelectorAll(".data-item");
        this.filterOptions();
        this.addShowOptionsEventListeners();
        this.addInputEventListener();
        this.addClickOptionListener();
        this.addSelectedItemsRemoveListeners(()=>this.filterOptions());
    }
    filterOptions() {
        const value = this.input.value.toLocaleLowerCase();
        const selected = [
            ...this.selection.querySelectorAll("[data-selection-item] input")
        ].map((item)=>item.value);
        this.options.forEach((option)=>{
            if (option.innerText.toLocaleLowerCase().includes(value) && !selected.includes(option.dataset.value)) option.style.display = "flex";
            else option.style.display = "none";
        });
    }
    addShowOptionsEventListeners() {
        this.input.addEventListener("focusin", ()=>{
            this.optionsWrapper.classList.add("active");
        });
    }
    addInputEventListener() {
        this.input.addEventListener("keyup", ()=>{
            this.filterOptions();
        });
    }
    addClickOptionListener() {
        [
            ...this.options
        ].forEach((option)=>{
            option.addEventListener("click", ()=>{
                if (this.clickCallack) this.clickCallack(option);
                else {
                    this.createSelectedItem(option);
                    option.style.display = "none";
                }
            });
        });
    }
}
class $71157344672d24b0$var$DynamicSearch extends $71157344672d24b0$var$Search {
    constructor(input){
        super(input);
        this.addClickOptionListener();
        this.addSelectedItemsRemoveListeners();
    }
    addClickOptionListener() {
        this.wrapper.addEventListener("htmx:afterSwap", (e)=>{
            [
                ...e.detail.elt.querySelectorAll(".data-item")
            ].forEach((option)=>{
                option.addEventListener("click", ()=>{
                    if (this.clickCallack) this.clickCallack(option);
                    else {
                        this.createSelectedItem(option);
                        option.style.display = "none";
                    }
                });
            });
            this.optionsWrapper.classList.add("active");
        });
    }
}
const $71157344672d24b0$export$942ff210707e0e16 = (target)=>{
    const container = target || document;
    [
        ...container.querySelectorAll("[data-search]")
    ].forEach((element)=>{
        if (element.dataset.search === "static") new $71157344672d24b0$var$StaticSearch(element);
        else new $71157344672d24b0$var$DynamicSearch(element);
    });
};


var $0451e076155c8af2$var$je = new WeakSet, $0451e076155c8af2$var$pt = (n)=>{
    n.forEach((t)=>{
        if ($0451e076155c8af2$var$je.has(t)) return;
        $0451e076155c8af2$var$je.add(t);
        let e = t.querySelector(".dropdown");
        t.addEventListener("mouseenter", ()=>{
            e.getBoundingClientRect().right > window.innerWidth ? t.classList.add("left") : t.classList.remove("left"), $0451e076155c8af2$var$je.delete(t);
        }, {
            once: !0
        });
    });
}, $0451e076155c8af2$export$a4db3bf4a43c81e3 = (n)=>{
    let e = (n || document).querySelectorAll(".button-list .has-dropdown");
    $0451e076155c8af2$var$pt(e), window.addEventListener("resize", ()=>{
        $0451e076155c8af2$var$pt(e);
    });
};
var $0451e076155c8af2$var$F = "active";
var $0451e076155c8af2$var$gt = (n, t)=>{
    let e;
    return (...r)=>{
        clearTimeout(e), e = setTimeout(()=>n(...r), t);
    };
}, $0451e076155c8af2$var$mt = new WeakMap, $0451e076155c8af2$var$oe = (n, t, e)=>{
    let r = $0451e076155c8af2$var$mt.get(n) || new Set;
    return r.has(t) ? !1 : (r.add(t), $0451e076155c8af2$var$mt.set(n, r), e(n), !0);
}, $0451e076155c8af2$var$vt = (n, t, e)=>e.indexOf(n) === t, $0451e076155c8af2$var$bt = (n, t)=>{
    let e = t.indexOf(n);
    return e !== -1 && t.splice(e, 1), t;
};
var $0451e076155c8af2$var$We = ".collapsible-body", $0451e076155c8af2$var$Jn = ".collapsible-group", $0451e076155c8af2$var$wt = ".collapsible-header", $0451e076155c8af2$var$zn = ".collapsible-content", $0451e076155c8af2$var$Ct = ".collapsible", $0451e076155c8af2$var$Un = `${$0451e076155c8af2$var$Ct}.standalone`, $0451e076155c8af2$var$Gn = 200, $0451e076155c8af2$var$St = (n, t)=>{
    n.querySelector($0451e076155c8af2$var$wt).setAttribute("aria-expanded", `${t}`);
}, $0451e076155c8af2$var$yt = (n)=>{
    if (n.classList.contains($0451e076155c8af2$var$F)) {
        let t = n.querySelector($0451e076155c8af2$var$We);
        t.style.height = "0px", n.classList.remove($0451e076155c8af2$var$F), $0451e076155c8af2$var$St(n, !1), setTimeout(()=>{
            t.style.removeProperty("height");
        }, $0451e076155c8af2$var$Gn);
    }
}, $0451e076155c8af2$var$Qn = (n)=>{
    let t = n.querySelector($0451e076155c8af2$var$zn).offsetHeight, e = n.querySelector($0451e076155c8af2$var$We);
    e.style.height = `${t}px`, n.classList.add($0451e076155c8af2$var$F), $0451e076155c8af2$var$St(n, !0);
}, $0451e076155c8af2$var$Dt = (n, t)=>{
    let e = n.querySelector($0451e076155c8af2$var$wt), r = n.querySelector($0451e076155c8af2$var$We);
    r && !r.id && (r.id = `collapsible-body-${Math.random().toString(36).slice(2, 9)}`), e && r && e.setAttribute("aria-controls", r.id), e.addEventListener("click", ()=>{
        let l = n.classList.contains($0451e076155c8af2$var$F);
        t && t.forEach((s)=>$0451e076155c8af2$var$yt(s)), l ? t || $0451e076155c8af2$var$yt(n) : $0451e076155c8af2$var$Qn(n);
    });
}, $0451e076155c8af2$export$34107ba18b519094 = (n)=>{
    let t = n || document, e = t.querySelectorAll($0451e076155c8af2$var$Jn), r = t.querySelectorAll($0451e076155c8af2$var$Un);
    e.forEach((l)=>{
        let s = l.querySelectorAll($0451e076155c8af2$var$Ct);
        s.forEach((d)=>{
            $0451e076155c8af2$var$Dt(d, s);
        });
    }), r.forEach((l)=>$0451e076155c8af2$var$Dt(l, !1));
};
function $0451e076155c8af2$var$Zn(n, t) {
    if (!confirm(t)) {
        n.preventDefault(), n.stopImmediatePropagation();
        return;
    }
}
function $0451e076155c8af2$export$7d03d001ca71c65f(n) {
    (n || document).querySelectorAll("[data-confirmable]").forEach((e)=>{
        let r = e.dataset.confirmable || "Are you sure you want to do this?";
        e.addEventListener("submit", (l)=>$0451e076155c8af2$var$Zn(l, r));
    });
}
function $0451e076155c8af2$var$xt(n) {
    return [
        ...n.querySelectorAll("[name]")
    ].reduce((e, r)=>({
            ...e,
            [r.name]: r.value
        }), {});
}
function $0451e076155c8af2$export$70070ff97f1a4ca0(n) {
    let t = n || document, e = {}, r = [
        ...t.querySelectorAll("[data-detect-unsaved-changes]")
    ];
    function l(s) {
        r.find((g, p)=>{
            let M = $0451e076155c8af2$var$xt(g);
            return JSON.stringify(M) !== JSON.stringify(e[p]);
        }) && (s.preventDefault(), s.returnValue = !1);
    }
    r.forEach((s, d)=>{
        let g = $0451e076155c8af2$var$xt(s);
        e[d] = g, s.addEventListener("submit", ()=>{
            window.removeEventListener("beforeunload", l);
        });
    }), window.addEventListener("beforeunload", l), t.querySelectorAll("form").forEach((s)=>{
        let d = s.querySelectorAll("[data-reset-form]");
        d.length && d.forEach((g)=>{
            g.addEventListener("click", ()=>{
                s.reset();
            });
        });
    });
}
var $0451e076155c8af2$var$Xn = ".filter, #filter", $0451e076155c8af2$var$ei = ".filter-search-input, .filter-search input", $0451e076155c8af2$var$ti = "[data-filter-toggle]", $0451e076155c8af2$var$ni = ".filter-clear", $0451e076155c8af2$var$Ot = "[data-filter-name]", $0451e076155c8af2$var$It = "hidden", $0451e076155c8af2$var$ii = 200, $0451e076155c8af2$var$Lt = "data-filter-initialized", $0451e076155c8af2$var$Tt = "false", $0451e076155c8af2$var$qe = "econ-filter-search-caret", $0451e076155c8af2$var$ai = "filter-search-focus", $0451e076155c8af2$var$Ft = (n, t)=>{
    let e = [
        ...n.map((r)=>r?.dataset?.filterDelay),
        t
    ];
    for (let r of e){
        if (r == null || r === "") continue;
        let l = Number(r);
        if (Number.isFinite(l) && l >= 0) return l;
        console.error(`Invalid filter delay "${r}", ignoring it`);
    }
    return $0451e076155c8af2$var$ii;
}, $0451e076155c8af2$var$Nt = (n, t)=>t ? $0451e076155c8af2$var$gt(n, t) : n, $0451e076155c8af2$var$ve = (n)=>{
    n?.requestSubmit();
}, $0451e076155c8af2$var$Ke = (n)=>n.type === "checkbox", $0451e076155c8af2$var$ri = (n)=>n.tagName === "SELECT", $0451e076155c8af2$var$oi = (n, t)=>{
    n.querySelectorAll(`input[data-filter-name="${t}"],select[data-filter-name="${t}"],textarea[data-filter-name="${t}"]`).forEach((r)=>{
        r[$0451e076155c8af2$var$Ke(r) ? "checked" : "value"] = $0451e076155c8af2$var$Ke(r) ? !1 : "";
    });
}, $0451e076155c8af2$var$At = (n)=>n?.getAttribute("data-filter-autosubmit") === $0451e076155c8af2$var$Tt, $0451e076155c8af2$var$be = (n, t, e)=>$0451e076155c8af2$var$At(e) || $0451e076155c8af2$var$At(t) ? !1 : n ? !n.closest(`[data-filter-autosubmit="${$0451e076155c8af2$var$Tt}"]`) : !0, $0451e076155c8af2$var$si = (n, t, e)=>n.id ? `${$0451e076155c8af2$var$qe}:form-${n.id}` : t.id ? `${$0451e076155c8af2$var$qe}:root-${t.id}` : `${$0451e076155c8af2$var$qe}:index-${e}`, $0451e076155c8af2$var$li = ()=>window.performance.timeOrigin + window.performance.now(), $0451e076155c8af2$var$ci = (n)=>{
    let t = window.performance?.timeOrigin;
    return Number.isFinite(n) && Number.isFinite(t) && n <= t;
}, $0451e076155c8af2$var$ui = (n)=>{
    try {
        let t = window.sessionStorage.getItem(n);
        return window.sessionStorage.removeItem(n), t ? JSON.parse(t) : null;
    } catch  {
        return null;
    }
}, $0451e076155c8af2$var$di = (n, t)=>{
    try {
        window.sessionStorage.setItem(n, JSON.stringify({
            caret: t,
            time: $0451e076155c8af2$var$li()
        }));
    } catch  {}
}, $0451e076155c8af2$var$fi = (n, t)=>{
    let e = $0451e076155c8af2$var$ui(t);
    if (!e || !$0451e076155c8af2$var$ci(e.time)) return;
    let r = Math.min(Math.max(Number(e.caret) || 0, 0), n.value.length);
    n.focus(), n.selectionStart !== null && n.setSelectionRange(r, r);
}, $0451e076155c8af2$var$pi = (n, t, e, r)=>{
    let l = n.form || t;
    $0451e076155c8af2$var$oe(l, $0451e076155c8af2$var$ai, ()=>{
        let s = $0451e076155c8af2$var$si(l, e, r);
        l.addEventListener("submit", ()=>{
            document.activeElement === n && $0451e076155c8af2$var$di(s, n.selectionStart ?? n.value.length);
        }), $0451e076155c8af2$var$fi(n, s);
    });
}, $0451e076155c8af2$var$hi = (n, t, e, r)=>{
    let l = n?.querySelector($0451e076155c8af2$var$ei);
    if (!l) return;
    $0451e076155c8af2$var$pi(l, n, t, r);
    let s = $0451e076155c8af2$var$Ft([
        l,
        n,
        t
    ], e), d = $0451e076155c8af2$var$Nt(()=>{
        $0451e076155c8af2$var$be(l, n, t) && $0451e076155c8af2$var$ve(n);
    }, s);
    l.addEventListener("input", ()=>d());
}, $0451e076155c8af2$var$mi = (n, t, e)=>{
    let r = $0451e076155c8af2$var$Ft([
        t,
        n
    ], e), l = $0451e076155c8af2$var$Nt((s)=>{
        $0451e076155c8af2$var$be(s, t, n) && $0451e076155c8af2$var$ve(t);
    }, r);
    n.addEventListener("click", (s)=>{
        let d = s.target.closest($0451e076155c8af2$var$ti), g = s.target.closest($0451e076155c8af2$var$ni);
        if (d && (s.preventDefault(), n.querySelector(`#filter-${CSS.escape(d.dataset.filterToggle)}`)?.classList.toggle($0451e076155c8af2$var$It)), g) {
            s.preventDefault();
            let p = g.dataset.filterName;
            $0451e076155c8af2$var$oi(t, p), $0451e076155c8af2$var$be(g, t, n) && $0451e076155c8af2$var$ve(t), n.querySelector(`#filter-${CSS.escape(p)}`)?.classList.add($0451e076155c8af2$var$It);
        }
    }), n.addEventListener("change", (s)=>{
        s.target.matches($0451e076155c8af2$var$Ot) && $0451e076155c8af2$var$be(s.target, t, n) && $0451e076155c8af2$var$ve(t);
    }, !0), n.addEventListener("input", (s)=>{
        s.target.matches($0451e076155c8af2$var$Ot) && !$0451e076155c8af2$var$Ke(s.target) && !$0451e076155c8af2$var$ri(s.target) && l(s.target);
    }, !0);
};
function $0451e076155c8af2$export$f0860aea97f62ce(n, t = {}) {
    let e = n || document, r = (t || {}).filterDelay;
    e.querySelectorAll($0451e076155c8af2$var$Xn).forEach((s, d)=>{
        if (s.getAttribute($0451e076155c8af2$var$Lt) === "true") return;
        let g = s.querySelector("form");
        g && ($0451e076155c8af2$var$hi(g, s, r, d), $0451e076155c8af2$var$mi(s, g, r), s.setAttribute($0451e076155c8af2$var$Lt, "true"));
    });
}
var $0451e076155c8af2$var$ye = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
], $0451e076155c8af2$var$R = {
    _disable: [],
    allowInput: !1,
    allowInvalidPreload: !1,
    altFormat: "F j, Y",
    altInput: !1,
    altInputClass: "form-control input",
    animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: !0,
    clickOpens: !0,
    closeOnSelect: !0,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: !1,
    enableSeconds: !1,
    enableTime: !1,
    errorHandler: function(n) {
        return typeof console < "u" && console.warn(n);
    },
    getWeek: function(n) {
        var t = new Date(n.getTime());
        t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
        var e = new Date(t.getFullYear(), 0, 4);
        return 1 + Math.round(((t.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: !1,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: !1,
    now: new Date,
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: void 0,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: !1,
    showMonths: 1,
    static: !1,
    time_24hr: !1,
    weekNumbers: !1,
    wrap: !1
};
var $0451e076155c8af2$var$De = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(n) {
        var t = n % 100;
        if (t > 3 && t < 21) return "th";
        switch(t % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: !1
}, $0451e076155c8af2$var$we = $0451e076155c8af2$var$De;
var $0451e076155c8af2$var$I = function(n, t) {
    return t === void 0 && (t = 2), ("000" + n).slice(t * -1);
}, $0451e076155c8af2$var$N = function(n) {
    return n === !0 ? 1 : 0;
};
function $0451e076155c8af2$var$Re(n, t) {
    var e;
    return function() {
        var r = this, l = arguments;
        clearTimeout(e), e = setTimeout(function() {
            return n.apply(r, l);
        }, t);
    };
}
var $0451e076155c8af2$var$Ce = function(n) {
    return n instanceof Array ? n : [
        n
    ];
};
function $0451e076155c8af2$var$L(n, t, e) {
    if (e === !0) return n.classList.add(t);
    n.classList.remove(t);
}
function $0451e076155c8af2$var$D(n, t, e) {
    var r = window.document.createElement(n);
    return t = t || "", e = e || "", r.className = t, e !== void 0 && (r.textContent = e), r;
}
function $0451e076155c8af2$var$se(n) {
    for(; n.firstChild;)n.removeChild(n.firstChild);
}
function $0451e076155c8af2$var$Be(n, t) {
    if (t(n)) return n;
    if (n.parentNode) return $0451e076155c8af2$var$Be(n.parentNode, t);
}
function $0451e076155c8af2$var$le(n, t) {
    var e = $0451e076155c8af2$var$D("div", "numInputWrapper"), r = $0451e076155c8af2$var$D("input", "numInput " + n), l = $0451e076155c8af2$var$D("span", "arrowUp"), s = $0451e076155c8af2$var$D("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), t !== void 0) for(var d in t)r.setAttribute(d, t[d]);
    return e.appendChild(r), e.appendChild(l), e.appendChild(s), e;
}
function $0451e076155c8af2$var$_(n) {
    try {
        if (typeof n.composedPath == "function") {
            var t = n.composedPath();
            return t[0];
        }
        return n.target;
    } catch  {
        return n.target;
    }
}
var $0451e076155c8af2$var$Ve = function() {}, $0451e076155c8af2$var$ce = function(n, t, e) {
    return e.months[t ? "shorthand" : "longhand"][n];
}, $0451e076155c8af2$var$Pt = {
    D: $0451e076155c8af2$var$Ve,
    F: function(n, t, e) {
        n.setMonth(e.months.longhand.indexOf(t));
    },
    G: function(n, t) {
        n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(t));
    },
    H: function(n, t) {
        n.setHours(parseFloat(t));
    },
    J: function(n, t) {
        n.setDate(parseFloat(t));
    },
    K: function(n, t, e) {
        n.setHours(n.getHours() % 12 + 12 * $0451e076155c8af2$var$N(new RegExp(e.amPM[1], "i").test(t)));
    },
    M: function(n, t, e) {
        n.setMonth(e.months.shorthand.indexOf(t));
    },
    S: function(n, t) {
        n.setSeconds(parseFloat(t));
    },
    U: function(n, t) {
        return new Date(parseFloat(t) * 1e3);
    },
    W: function(n, t, e) {
        var r = parseInt(t), l = new Date(n.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
        return l.setDate(l.getDate() - l.getDay() + e.firstDayOfWeek), l;
    },
    Y: function(n, t) {
        n.setFullYear(parseFloat(t));
    },
    Z: function(n, t) {
        return new Date(t);
    },
    d: function(n, t) {
        n.setDate(parseFloat(t));
    },
    h: function(n, t) {
        n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(t));
    },
    i: function(n, t) {
        n.setMinutes(parseFloat(t));
    },
    j: function(n, t) {
        n.setDate(parseFloat(t));
    },
    l: $0451e076155c8af2$var$Ve,
    m: function(n, t) {
        n.setMonth(parseFloat(t) - 1);
    },
    n: function(n, t) {
        n.setMonth(parseFloat(t) - 1);
    },
    s: function(n, t) {
        n.setSeconds(parseFloat(t));
    },
    u: function(n, t) {
        return new Date(parseFloat(t));
    },
    w: $0451e076155c8af2$var$Ve,
    y: function(n, t) {
        n.setFullYear(2e3 + parseFloat(t));
    }
}, $0451e076155c8af2$var$W = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
}, $0451e076155c8af2$var$te = {
    Z: function(n) {
        return n.toISOString();
    },
    D: function(n, t, e) {
        return t.weekdays.shorthand[$0451e076155c8af2$var$te.w(n, t, e)];
    },
    F: function(n, t, e) {
        return $0451e076155c8af2$var$ce($0451e076155c8af2$var$te.n(n, t, e) - 1, !1, t);
    },
    G: function(n, t, e) {
        return $0451e076155c8af2$var$I($0451e076155c8af2$var$te.h(n, t, e));
    },
    H: function(n) {
        return $0451e076155c8af2$var$I(n.getHours());
    },
    J: function(n, t) {
        return t.ordinal !== void 0 ? n.getDate() + t.ordinal(n.getDate()) : n.getDate();
    },
    K: function(n, t) {
        return t.amPM[$0451e076155c8af2$var$N(n.getHours() > 11)];
    },
    M: function(n, t) {
        return $0451e076155c8af2$var$ce(n.getMonth(), !0, t);
    },
    S: function(n) {
        return $0451e076155c8af2$var$I(n.getSeconds());
    },
    U: function(n) {
        return n.getTime() / 1e3;
    },
    W: function(n, t, e) {
        return e.getWeek(n);
    },
    Y: function(n) {
        return $0451e076155c8af2$var$I(n.getFullYear(), 4);
    },
    d: function(n) {
        return $0451e076155c8af2$var$I(n.getDate());
    },
    h: function(n) {
        return n.getHours() % 12 ? n.getHours() % 12 : 12;
    },
    i: function(n) {
        return $0451e076155c8af2$var$I(n.getMinutes());
    },
    j: function(n) {
        return n.getDate();
    },
    l: function(n, t) {
        return t.weekdays.longhand[n.getDay()];
    },
    m: function(n) {
        return $0451e076155c8af2$var$I(n.getMonth() + 1);
    },
    n: function(n) {
        return n.getMonth() + 1;
    },
    s: function(n) {
        return n.getSeconds();
    },
    u: function(n) {
        return n.getTime();
    },
    w: function(n) {
        return n.getDay();
    },
    y: function(n) {
        return String(n.getFullYear()).substring(2);
    }
};
var $0451e076155c8af2$var$$e = function(n) {
    var t = n.config, e = t === void 0 ? $0451e076155c8af2$var$R : t, r = n.l10n, l = r === void 0 ? $0451e076155c8af2$var$De : r, s = n.isMobile, d = s === void 0 ? !1 : s;
    return function(g, p, M) {
        var w = M || l;
        return e.formatDate !== void 0 && !d ? e.formatDate(g, p, w) : p.split("").map(function(O, T, x) {
            return $0451e076155c8af2$var$te[O] && x[T - 1] !== "\\" ? $0451e076155c8af2$var$te[O](g, w, e) : O !== "\\" ? O : "";
        }).join("");
    };
}, $0451e076155c8af2$var$Se = function(n) {
    var t = n.config, e = t === void 0 ? $0451e076155c8af2$var$R : t, r = n.l10n, l = r === void 0 ? $0451e076155c8af2$var$De : r;
    return function(s, d, g, p) {
        if (!(s !== 0 && !s)) {
            var M = p || l, w, O = s;
            if (s instanceof Date) w = new Date(s.getTime());
            else if (typeof s != "string" && s.toFixed !== void 0) w = new Date(s);
            else if (typeof s == "string") {
                var T = d || (e || $0451e076155c8af2$var$R).dateFormat, x = String(s).trim();
                if (x === "today") w = new Date, g = !0;
                else if (e && e.parseDate) w = e.parseDate(s, T);
                else if (/Z$/.test(x) || /GMT$/.test(x)) w = new Date(s);
                else {
                    for(var q = void 0, C = [], B = 0, Ie = 0, K = ""; B < T.length; B++){
                        var V = T[B], G = V === "\\", Le = T[B - 1] === "\\" || G;
                        if ($0451e076155c8af2$var$W[V] && !Le) {
                            K += $0451e076155c8af2$var$W[V];
                            var $ = new RegExp(K).exec(s);
                            $ && (q = !0) && C[V !== "Y" ? "push" : "unshift"]({
                                fn: $0451e076155c8af2$var$Pt[V],
                                val: $[++Ie]
                            });
                        } else G || (K += ".");
                    }
                    w = !e || !e.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0)), C.forEach(function(Q) {
                        var Z = Q.fn, Ae = Q.val;
                        return w = Z(w, Ae, M) || w;
                    }), w = q ? w : void 0;
                }
            }
            if (!(w instanceof Date && !isNaN(w.getTime()))) {
                e.errorHandler(new Error("Invalid date provided: " + O));
                return;
            }
            return g === !0 && w.setHours(0, 0, 0, 0), w;
        }
    };
};
function $0451e076155c8af2$var$P(n, t, e) {
    return e === void 0 && (e = !0), e !== !1 ? new Date(n.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : n.getTime() - t.getTime();
}
var $0451e076155c8af2$var$Yt = function(n, t, e) {
    return n > Math.min(t, e) && n < Math.max(t, e);
}, $0451e076155c8af2$var$Me = function(n, t, e) {
    return n * 3600 + t * 60 + e;
}, $0451e076155c8af2$var$Ht = function(n) {
    var t = Math.floor(n / 3600), e = (n - t * 3600) / 60;
    return [
        t,
        e,
        n - t * 3600 - e * 60
    ];
}, $0451e076155c8af2$var$jt = {
    DAY: 864e5
};
function $0451e076155c8af2$var$Ee(n) {
    var t = n.defaultHour, e = n.defaultMinute, r = n.defaultSeconds;
    if (n.minDate !== void 0) {
        var l = n.minDate.getHours(), s = n.minDate.getMinutes(), d = n.minDate.getSeconds();
        t < l && (t = l), t === l && e < s && (e = s), t === l && e === s && r < d && (r = n.minDate.getSeconds());
    }
    if (n.maxDate !== void 0) {
        var g = n.maxDate.getHours(), p = n.maxDate.getMinutes();
        t = Math.min(t, g), t === g && (e = Math.min(p, e)), t === g && e === p && (r = n.maxDate.getSeconds());
    }
    return {
        hours: t,
        minutes: e,
        seconds: r
    };
}
typeof Object.assign != "function" && (Object.assign = function(n) {
    for(var t = [], e = 1; e < arguments.length; e++)t[e - 1] = arguments[e];
    if (!n) throw TypeError("Cannot convert undefined or null to object");
    for(var r = function(g) {
        g && Object.keys(g).forEach(function(p) {
            return n[p] = g[p];
        });
    }, l = 0, s = t; l < s.length; l++){
        var d = s[l];
        r(d);
    }
    return n;
});
var $0451e076155c8af2$var$A = function() {
    return $0451e076155c8af2$var$A = Object.assign || function(n) {
        for(var t, e = 1, r = arguments.length; e < r; e++){
            t = arguments[e];
            for(var l in t)Object.prototype.hasOwnProperty.call(t, l) && (n[l] = t[l]);
        }
        return n;
    }, $0451e076155c8af2$var$A.apply(this, arguments);
}, $0451e076155c8af2$var$Wt = function() {
    for(var n = 0, t = 0, e = arguments.length; t < e; t++)n += arguments[t].length;
    for(var r = Array(n), l = 0, t = 0; t < e; t++)for(var s = arguments[t], d = 0, g = s.length; d < g; d++, l++)r[l] = s[d];
    return r;
}, $0451e076155c8af2$var$gi = 300;
function $0451e076155c8af2$var$vi(n, t) {
    var e = {
        config: $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, $0451e076155c8af2$var$R), $0451e076155c8af2$var$k.defaultConfig),
        l10n: $0451e076155c8af2$var$we
    };
    e.parseDate = $0451e076155c8af2$var$Se({
        config: e.config,
        l10n: e.l10n
    }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = C, e._setHoursFromDate = T, e._positionCalendar = he, e.changeMonth = Te, e.changeYear = de, e.clear = Dn, e.close = wn, e.onMouseOver = pe, e._createElement = $0451e076155c8af2$var$D, e.createDay = $, e.destroy = Cn, e.isEnabled = J, e.jumpToDate = K, e.updateValue = j, e.open = En, e.redraw = lt, e.set = In, e.setDate = Ln, e.toggle = Nn;
    function r() {
        e.utils = {
            getDaysInMonth: function(i, a) {
                return i === void 0 && (i = e.currentMonth), a === void 0 && (a = e.currentYear), i === 1 && (a % 4 === 0 && a % 100 !== 0 || a % 400 === 0) ? 29 : e.l10n.daysInMonth[i];
            }
        };
    }
    function l() {
        e.element = e.input = n, e.isOpen = !1, xn(), st(), Tn(), An(), r(), e.isMobile || Le(), Ie(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && T(e.config.noCalendar ? e.latestSelectedDateObj : void 0), j(!1)), g();
        var i = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        !e.isMobile && i && he(), E("onReady");
    }
    function s() {
        var i;
        return ((i = e.calendarContainer) === null || i === void 0 ? void 0 : i.getRootNode()).activeElement || document.activeElement;
    }
    function d(i) {
        return i.bind(e);
    }
    function g() {
        var i = e.config;
        i.weekNumbers === !1 && i.showMonths === 1 || i.noCalendar !== !0 && window.requestAnimationFrame(function() {
            if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
                var a = (e.days.offsetWidth + 1) * i.showMonths;
                e.daysContainer.style.width = a + "px", e.calendarContainer.style.width = a + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function p(i) {
        if (e.selectedDates.length === 0) {
            var a = e.config.minDate === void 0 || $0451e076155c8af2$var$P(new Date, e.config.minDate) >= 0 ? new Date : new Date(e.config.minDate.getTime()), o = $0451e076155c8af2$var$Ee(e.config);
            a.setHours(o.hours, o.minutes, o.seconds, a.getMilliseconds()), e.selectedDates = [
                a
            ], e.latestSelectedDateObj = a;
        }
        i !== void 0 && i.type !== "blur" && Yn(i);
        var c = e._input.value;
        O(), j(), e._input.value !== c && e._debouncedChange();
    }
    function M(i, a) {
        return i % 12 + 12 * $0451e076155c8af2$var$N(a === e.l10n.amPM[1]);
    }
    function w(i) {
        switch(i % 24){
            case 0:
            case 12:
                return 12;
            default:
                return i % 12;
        }
    }
    function O() {
        if (!(e.hourElement === void 0 || e.minuteElement === void 0)) {
            var i = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, a = (parseInt(e.minuteElement.value, 10) || 0) % 60, o = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
            e.amPM !== void 0 && (i = M(i, e.amPM.textContent));
            var c = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && $0451e076155c8af2$var$P(e.latestSelectedDateObj, e.config.minDate, !0) === 0, u = e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && $0451e076155c8af2$var$P(e.latestSelectedDateObj, e.config.maxDate, !0) === 0;
            if (e.config.maxTime !== void 0 && e.config.minTime !== void 0 && e.config.minTime > e.config.maxTime) {
                var f = $0451e076155c8af2$var$Me(e.config.minTime.getHours(), e.config.minTime.getMinutes(), e.config.minTime.getSeconds()), b = $0451e076155c8af2$var$Me(e.config.maxTime.getHours(), e.config.maxTime.getMinutes(), e.config.maxTime.getSeconds()), m = $0451e076155c8af2$var$Me(i, a, o);
                if (m > b && m < f) {
                    var y = $0451e076155c8af2$var$Ht(f);
                    i = y[0], a = y[1], o = y[2];
                }
            } else {
                if (u) {
                    var h = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
                    i = Math.min(i, h.getHours()), i === h.getHours() && (a = Math.min(a, h.getMinutes())), a === h.getMinutes() && (o = Math.min(o, h.getSeconds()));
                }
                if (c) {
                    var v = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
                    i = Math.max(i, v.getHours()), i === v.getHours() && a < v.getMinutes() && (a = v.getMinutes()), a === v.getMinutes() && (o = Math.max(o, v.getSeconds()));
                }
            }
            x(i, a, o);
        }
    }
    function T(i) {
        var a = i || e.latestSelectedDateObj;
        a && a instanceof Date && x(a.getHours(), a.getMinutes(), a.getSeconds());
    }
    function x(i, a, o) {
        e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(i % 24, a, o || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = $0451e076155c8af2$var$I(e.config.time_24hr ? i : (12 + i) % 12 + 12 * $0451e076155c8af2$var$N(i % 12 === 0)), e.minuteElement.value = $0451e076155c8af2$var$I(a), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[$0451e076155c8af2$var$N(i >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = $0451e076155c8af2$var$I(o)));
    }
    function q(i) {
        var a = $0451e076155c8af2$var$_(i), o = parseInt(a.value) + (i.delta || 0);
        (o / 1e3 > 1 || i.key === "Enter" && !/[^\d]/.test(o.toString())) && de(o);
    }
    function C(i, a, o, c) {
        if (a instanceof Array) return a.forEach(function(u) {
            return C(i, u, o, c);
        });
        if (i instanceof Array) return i.forEach(function(u) {
            return C(u, a, o, c);
        });
        i.addEventListener(a, o, c), e._handlers.push({
            remove: function() {
                return i.removeEventListener(a, o, c);
            }
        });
    }
    function B() {
        E("onChange");
    }
    function Ie() {
        if (e.config.wrap && [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(o) {
            Array.prototype.forEach.call(e.element.querySelectorAll("[data-" + o + "]"), function(c) {
                return C(c, "click", e[o]);
            });
        }), e.isMobile) {
            Fn();
            return;
        }
        var i = $0451e076155c8af2$var$Re(Mn, 50);
        if (e._debouncedChange = $0451e076155c8af2$var$Re(B, $0451e076155c8af2$var$gi), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && C(e.daysContainer, "mouseover", function(o) {
            e.config.mode === "range" && pe($0451e076155c8af2$var$_(o));
        }), C(e._input, "keydown", at), e.calendarContainer !== void 0 && C(e.calendarContainer, "keydown", at), !e.config.inline && !e.config.static && C(window, "resize", i), window.ontouchstart !== void 0 ? C(window.document, "touchstart", Fe) : C(window.document, "mousedown", Fe), C(window.document, "focus", Fe, {
            capture: !0
        }), e.config.clickOpens === !0 && (C(e._input, "focus", e.open), C(e._input, "click", e.open)), e.daysContainer !== void 0 && (C(e.monthNav, "click", Pn), C(e.monthNav, [
            "keyup",
            "increment"
        ], q), C(e.daysContainer, "click", ct)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
            var a = function(o) {
                return $0451e076155c8af2$var$_(o).select();
            };
            C(e.timeContainer, [
                "increment"
            ], p), C(e.timeContainer, "blur", p, {
                capture: !0
            }), C(e.timeContainer, "click", V), C([
                e.hourElement,
                e.minuteElement
            ], [
                "focus",
                "click"
            ], a), e.secondElement !== void 0 && C(e.secondElement, "focus", function() {
                return e.secondElement && e.secondElement.select();
            }), e.amPM !== void 0 && C(e.amPM, "click", function(o) {
                p(o);
            });
        }
        e.config.allowInput && C(e._input, "blur", Sn);
    }
    function K(i, a) {
        var o = i !== void 0 ? e.parseDate(i) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), c = e.currentYear, u = e.currentMonth;
        try {
            o !== void 0 && (e.currentYear = o.getFullYear(), e.currentMonth = o.getMonth());
        } catch (f) {
            f.message = "Invalid date supplied: " + o, e.config.errorHandler(f);
        }
        a && e.currentYear !== c && (E("onYearChange"), X()), a && (e.currentYear !== c || e.currentMonth !== u) && E("onMonthChange"), e.redraw();
    }
    function V(i) {
        var a = $0451e076155c8af2$var$_(i);
        ~a.className.indexOf("arrow") && G(i, a.classList.contains("arrowUp") ? 1 : -1);
    }
    function G(i, a, o) {
        var c = i && $0451e076155c8af2$var$_(i), u = o || c && c.parentNode && c.parentNode.firstChild, f = _e("increment");
        f.delta = a, u && u.dispatchEvent(f);
    }
    function Le() {
        var i = window.document.createDocumentFragment();
        if (e.calendarContainer = $0451e076155c8af2$var$D("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
            if (i.appendChild(vn()), e.innerContainer = $0451e076155c8af2$var$D("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
                var a = yn(), o = a.weekWrapper, c = a.weekNumbers;
                e.innerContainer.appendChild(o), e.weekNumbers = c, e.weekWrapper = o;
            }
            e.rContainer = $0451e076155c8af2$var$D("div", "flatpickr-rContainer"), e.rContainer.appendChild(nt()), e.daysContainer || (e.daysContainer = $0451e076155c8af2$var$D("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), ue(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), i.appendChild(e.innerContainer);
        }
        e.config.enableTime && i.appendChild(bn()), $0451e076155c8af2$var$L(e.calendarContainer, "rangeMode", e.config.mode === "range"), $0451e076155c8af2$var$L(e.calendarContainer, "animate", e.config.animate === !0), $0451e076155c8af2$var$L(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(i);
        var u = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
        if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!u && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
            var f = $0451e076155c8af2$var$D("div", "flatpickr-wrapper");
            e.element.parentNode && e.element.parentNode.insertBefore(f, e.element), f.appendChild(e.element), e.altInput && f.appendChild(e.altInput), f.appendChild(e.calendarContainer);
        }
        !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
    }
    function $(i, a, o, c) {
        var u = J(a, !0), f = $0451e076155c8af2$var$D("span", i, a.getDate().toString());
        return f.dateObj = a, f.$i = c, f.setAttribute("aria-label", e.formatDate(a, e.config.ariaDateFormat)), i.indexOf("hidden") === -1 && $0451e076155c8af2$var$P(a, e.now) === 0 && (e.todayDateElem = f, f.classList.add("today"), f.setAttribute("aria-current", "date")), u ? (f.tabIndex = -1, Pe(a) && (f.classList.add("selected"), e.selectedDateElem = f, e.config.mode === "range" && ($0451e076155c8af2$var$L(f, "startRange", e.selectedDates[0] && $0451e076155c8af2$var$P(a, e.selectedDates[0], !0) === 0), $0451e076155c8af2$var$L(f, "endRange", e.selectedDates[1] && $0451e076155c8af2$var$P(a, e.selectedDates[1], !0) === 0), i === "nextMonthDay" && f.classList.add("inRange")))) : f.classList.add("flatpickr-disabled"), e.config.mode === "range" && _n(a) && !Pe(a) && f.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && i !== "prevMonthDay" && c % 7 === 6 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(a) + "</span>"), E("onDayCreate", f), f;
    }
    function Q(i) {
        i.focus(), e.config.mode === "range" && pe(i);
    }
    function Z(i) {
        for(var a = i > 0 ? 0 : e.config.showMonths - 1, o = i > 0 ? e.config.showMonths : -1, c = a; c != o; c += i)for(var u = e.daysContainer.children[c], f = i > 0 ? 0 : u.children.length - 1, b = i > 0 ? u.children.length : -1, m = f; m != b; m += i){
            var y = u.children[m];
            if (y.className.indexOf("hidden") === -1 && J(y.dateObj)) return y;
        }
    }
    function Ae(i, a) {
        for(var o = i.className.indexOf("Month") === -1 ? i.dateObj.getMonth() : e.currentMonth, c = a > 0 ? e.config.showMonths : -1, u = a > 0 ? 1 : -1, f = o - e.currentMonth; f != c; f += u)for(var b = e.daysContainer.children[f], m = o - e.currentMonth === f ? i.$i + a : a < 0 ? b.children.length - 1 : 0, y = b.children.length, h = m; h >= 0 && h < y && h != (a > 0 ? y : -1); h += u){
            var v = b.children[h];
            if (v.className.indexOf("hidden") === -1 && J(v.dateObj) && Math.abs(i.$i - h) >= Math.abs(a)) return Q(v);
        }
        e.changeMonth(u), ie(Z(u), 0);
    }
    function ie(i, a) {
        var o = s(), c = fe(o || document.body), u = i !== void 0 ? i : c ? o : e.selectedDateElem !== void 0 && fe(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && fe(e.todayDateElem) ? e.todayDateElem : Z(a > 0 ? 1 : -1);
        u === void 0 ? e._input.focus() : c ? Ae(u, a) : Q(u);
    }
    function mn(i, a) {
        for(var o = (new Date(i, a, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, c = e.utils.getDaysInMonth((a - 1 + 12) % 12, i), u = e.utils.getDaysInMonth(a, i), f = window.document.createDocumentFragment(), b = e.config.showMonths > 1, m = b ? "prevMonthDay hidden" : "prevMonthDay", y = b ? "nextMonthDay hidden" : "nextMonthDay", h = c + 1 - o, v = 0; h <= c; h++, v++)f.appendChild($("flatpickr-day " + m, new Date(i, a - 1, h), h, v));
        for(h = 1; h <= u; h++, v++)f.appendChild($("flatpickr-day", new Date(i, a, h), h, v));
        for(var S = u + 1; S <= 42 - o && (e.config.showMonths === 1 || v % 7 !== 0); S++, v++)f.appendChild($("flatpickr-day " + y, new Date(i, a + 1, S % u), S, v));
        var H = $0451e076155c8af2$var$D("div", "dayContainer");
        return H.appendChild(f), H;
    }
    function ue() {
        if (e.daysContainer !== void 0) {
            $0451e076155c8af2$var$se(e.daysContainer), e.weekNumbers && $0451e076155c8af2$var$se(e.weekNumbers);
            for(var i = document.createDocumentFragment(), a = 0; a < e.config.showMonths; a++){
                var o = new Date(e.currentYear, e.currentMonth, 1);
                o.setMonth(e.currentMonth + a), i.appendChild(mn(o.getFullYear(), o.getMonth()));
            }
            e.daysContainer.appendChild(i), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && pe();
        }
    }
    function X() {
        if (!(e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")) {
            var i = function(c) {
                return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && c < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && c > e.config.maxDate.getMonth());
            };
            e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
            for(var a = 0; a < 12; a++)if (i(a)) {
                var o = $0451e076155c8af2$var$D("option", "flatpickr-monthDropdown-month");
                o.value = new Date(e.currentYear, a).getMonth().toString(), o.textContent = $0451e076155c8af2$var$ce(a, e.config.shorthandCurrentMonth, e.l10n), o.tabIndex = -1, e.currentMonth === a && (o.selected = !0), e.monthsDropdownContainer.appendChild(o);
            }
        }
    }
    function gn() {
        var i = $0451e076155c8af2$var$D("div", "flatpickr-month"), a = window.document.createDocumentFragment(), o;
        e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? o = $0451e076155c8af2$var$D("span", "cur-month") : (e.monthsDropdownContainer = $0451e076155c8af2$var$D("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), C(e.monthsDropdownContainer, "change", function(b) {
            var m = $0451e076155c8af2$var$_(b), y = parseInt(m.value, 10);
            e.changeMonth(y - e.currentMonth), E("onMonthChange");
        }), X(), o = e.monthsDropdownContainer);
        var c = $0451e076155c8af2$var$le("cur-year", {
            tabindex: "-1"
        }), u = c.getElementsByTagName("input")[0];
        u.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && u.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (u.setAttribute("max", e.config.maxDate.getFullYear().toString()), u.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
        var f = $0451e076155c8af2$var$D("div", "flatpickr-current-month");
        return f.appendChild(o), f.appendChild(c), a.appendChild(f), i.appendChild(a), {
            container: i,
            yearElement: u,
            monthElement: o
        };
    }
    function tt() {
        $0451e076155c8af2$var$se(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
        for(var i = e.config.showMonths; i--;){
            var a = gn();
            e.yearElements.push(a.yearElement), e.monthElements.push(a.monthElement), e.monthNav.appendChild(a.container);
        }
        e.monthNav.appendChild(e.nextMonthNav);
    }
    function vn() {
        return e.monthNav = $0451e076155c8af2$var$D("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = $0451e076155c8af2$var$D("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = $0451e076155c8af2$var$D("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, tt(), Object.defineProperty(e, "_hidePrevMonthArrow", {
            get: function() {
                return e.__hidePrevMonthArrow;
            },
            set: function(i) {
                e.__hidePrevMonthArrow !== i && ($0451e076155c8af2$var$L(e.prevMonthNav, "flatpickr-disabled", i), e.__hidePrevMonthArrow = i);
            }
        }), Object.defineProperty(e, "_hideNextMonthArrow", {
            get: function() {
                return e.__hideNextMonthArrow;
            },
            set: function(i) {
                e.__hideNextMonthArrow !== i && ($0451e076155c8af2$var$L(e.nextMonthNav, "flatpickr-disabled", i), e.__hideNextMonthArrow = i);
            }
        }), e.currentYearElement = e.yearElements[0], ge(), e.monthNav;
    }
    function bn() {
        e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
        var i = $0451e076155c8af2$var$Ee(e.config);
        e.timeContainer = $0451e076155c8af2$var$D("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
        var a = $0451e076155c8af2$var$D("span", "flatpickr-time-separator", ":"), o = $0451e076155c8af2$var$le("flatpickr-hour", {
            "aria-label": e.l10n.hourAriaLabel
        });
        e.hourElement = o.getElementsByTagName("input")[0];
        var c = $0451e076155c8af2$var$le("flatpickr-minute", {
            "aria-label": e.l10n.minuteAriaLabel
        });
        if (e.minuteElement = c.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = $0451e076155c8af2$var$I(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? i.hours : w(i.hours)), e.minuteElement.value = $0451e076155c8af2$var$I(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : i.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(o), e.timeContainer.appendChild(a), e.timeContainer.appendChild(c), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
            e.timeContainer.classList.add("hasSeconds");
            var u = $0451e076155c8af2$var$le("flatpickr-second");
            e.secondElement = u.getElementsByTagName("input")[0], e.secondElement.value = $0451e076155c8af2$var$I(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : i.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild($0451e076155c8af2$var$D("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(u);
        }
        return e.config.time_24hr || (e.amPM = $0451e076155c8af2$var$D("span", "flatpickr-am-pm", e.l10n.amPM[$0451e076155c8af2$var$N((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
    }
    function nt() {
        e.weekdayContainer ? $0451e076155c8af2$var$se(e.weekdayContainer) : e.weekdayContainer = $0451e076155c8af2$var$D("div", "flatpickr-weekdays");
        for(var i = e.config.showMonths; i--;){
            var a = $0451e076155c8af2$var$D("div", "flatpickr-weekdaycontainer");
            e.weekdayContainer.appendChild(a);
        }
        return it(), e.weekdayContainer;
    }
    function it() {
        if (e.weekdayContainer) {
            var i = e.l10n.firstDayOfWeek, a = $0451e076155c8af2$var$Wt(e.l10n.weekdays.shorthand);
            i > 0 && i < a.length && (a = $0451e076155c8af2$var$Wt(a.splice(i, a.length), a.splice(0, i)));
            for(var o = e.config.showMonths; o--;)e.weekdayContainer.children[o].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + a.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
        }
    }
    function yn() {
        e.calendarContainer.classList.add("hasWeeks");
        var i = $0451e076155c8af2$var$D("div", "flatpickr-weekwrapper");
        i.appendChild($0451e076155c8af2$var$D("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
        var a = $0451e076155c8af2$var$D("div", "flatpickr-weeks");
        return i.appendChild(a), {
            weekWrapper: i,
            weekNumbers: a
        };
    }
    function Te(i, a) {
        a === void 0 && (a = !0);
        var o = a ? i : i - e.currentMonth;
        o < 0 && e._hidePrevMonthArrow === !0 || o > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += o, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, E("onYearChange"), X()), ue(), E("onMonthChange"), ge());
    }
    function Dn(i, a) {
        if (i === void 0 && (i = !0), a === void 0 && (a = !0), e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, a === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
            var o = $0451e076155c8af2$var$Ee(e.config), c = o.hours, u = o.minutes, f = o.seconds;
            x(c, u, f);
        }
        e.redraw(), i && E("onChange");
    }
    function wn() {
        e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), E("onClose");
    }
    function Cn() {
        e.config !== void 0 && E("onDestroy");
        for(var i = e._handlers.length; i--;)e._handlers[i].remove();
        if (e._handlers = [], e.mobileInput) e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
        else if (e.calendarContainer && e.calendarContainer.parentNode) {
            if (e.config.static && e.calendarContainer.parentNode) {
                var a = e.calendarContainer.parentNode;
                if (a.lastChild && a.removeChild(a.lastChild), a.parentNode) {
                    for(; a.firstChild;)a.parentNode.insertBefore(a.firstChild, a);
                    a.parentNode.removeChild(a);
                }
            } else e.calendarContainer.parentNode.removeChild(e.calendarContainer);
        }
        e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(o) {
            try {
                delete e[o];
            } catch  {}
        });
    }
    function ae(i) {
        return e.calendarContainer.contains(i);
    }
    function Fe(i) {
        if (e.isOpen && !e.config.inline) {
            var a = $0451e076155c8af2$var$_(i), o = ae(a), c = a === e.input || a === e.altInput || e.element.contains(a) || i.path && i.path.indexOf && (~i.path.indexOf(e.input) || ~i.path.indexOf(e.altInput)), u = !c && !o && !ae(i.relatedTarget), f = !e.config.ignoredFocusElements.some(function(b) {
                return b.contains(a);
            });
            u && f && (e.config.allowInput && e.setDate(e._input.value, !1, e.config.altInput ? e.config.altFormat : e.config.dateFormat), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && p(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && e.clear(!1));
        }
    }
    function de(i) {
        if (!(!i || e.config.minDate && i < e.config.minDate.getFullYear() || e.config.maxDate && i > e.config.maxDate.getFullYear())) {
            var a = i, o = e.currentYear !== a;
            e.currentYear = a || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), o && (e.redraw(), E("onYearChange"), X());
        }
    }
    function J(i, a) {
        var o;
        a === void 0 && (a = !0);
        var c = e.parseDate(i, void 0, a);
        if (e.config.minDate && c && $0451e076155c8af2$var$P(c, e.config.minDate, a !== void 0 ? a : !e.minDateHasTime) < 0 || e.config.maxDate && c && $0451e076155c8af2$var$P(c, e.config.maxDate, a !== void 0 ? a : !e.maxDateHasTime) > 0) return !1;
        if (!e.config.enable && e.config.disable.length === 0) return !0;
        if (c === void 0) return !1;
        for(var u = !!e.config.enable, f = (o = e.config.enable) !== null && o !== void 0 ? o : e.config.disable, b = 0, m = void 0; b < f.length; b++){
            if (m = f[b], typeof m == "function" && m(c)) return u;
            if (m instanceof Date && c !== void 0 && m.getTime() === c.getTime()) return u;
            if (typeof m == "string") {
                var y = e.parseDate(m, void 0, !0);
                return y && y.getTime() === c.getTime() ? u : !u;
            } else if (typeof m == "object" && c !== void 0 && m.from && m.to && c.getTime() >= m.from.getTime() && c.getTime() <= m.to.getTime()) return u;
        }
        return !u;
    }
    function fe(i) {
        return e.daysContainer !== void 0 ? i.className.indexOf("hidden") === -1 && i.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(i) : !1;
    }
    function Sn(i) {
        var a = i.target === e._input, o = e._input.value.trimEnd() !== Ye();
        a && o && !(i.relatedTarget && ae(i.relatedTarget)) && e.setDate(e._input.value, !0, i.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
    }
    function at(i) {
        var a = $0451e076155c8af2$var$_(i), o = e.config.wrap ? n.contains(a) : a === e._input, c = e.config.allowInput, u = e.isOpen && (!c || !o), f = e.config.inline && o && !c;
        if (i.keyCode === 13 && o) {
            if (c) return e.setDate(e._input.value, !0, a === e.altInput ? e.config.altFormat : e.config.dateFormat), e.close(), a.blur();
            e.open();
        } else if (ae(a) || u || f) {
            var b = !!e.timeContainer && e.timeContainer.contains(a);
            switch(i.keyCode){
                case 13:
                    b ? (i.preventDefault(), p(), Ne()) : ct(i);
                    break;
                case 27:
                    i.preventDefault(), Ne();
                    break;
                case 8:
                case 46:
                    o && !e.config.allowInput && (i.preventDefault(), e.clear());
                    break;
                case 37:
                case 39:
                    if (!b && !o) {
                        i.preventDefault();
                        var m = s();
                        if (e.daysContainer !== void 0 && (c === !1 || m && fe(m))) {
                            var y = i.keyCode === 39 ? 1 : -1;
                            i.ctrlKey ? (i.stopPropagation(), Te(y), ie(Z(1), 0)) : ie(void 0, y);
                        }
                    } else e.hourElement && e.hourElement.focus();
                    break;
                case 38:
                case 40:
                    i.preventDefault();
                    var h = i.keyCode === 40 ? 1 : -1;
                    e.daysContainer && a.$i !== void 0 || a === e.input || a === e.altInput ? i.ctrlKey ? (i.stopPropagation(), de(e.currentYear - h), ie(Z(1), 0)) : b || ie(void 0, h * 7) : a === e.currentYearElement ? de(e.currentYear - h) : e.config.enableTime && (!b && e.hourElement && e.hourElement.focus(), p(i), e._debouncedChange());
                    break;
                case 9:
                    if (b) {
                        var v = [
                            e.hourElement,
                            e.minuteElement,
                            e.secondElement,
                            e.amPM
                        ].concat(e.pluginElements).filter(function(Y) {
                            return Y;
                        }), S = v.indexOf(a);
                        if (S !== -1) {
                            var H = v[S + (i.shiftKey ? -1 : 1)];
                            i.preventDefault(), (H || e._input).focus();
                        }
                    } else !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(a) && i.shiftKey && (i.preventDefault(), e._input.focus());
                    break;
                default:
                    break;
            }
        }
        if (e.amPM !== void 0 && a === e.amPM) switch(i.key){
            case e.l10n.amPM[0].charAt(0):
            case e.l10n.amPM[0].charAt(0).toLowerCase():
                e.amPM.textContent = e.l10n.amPM[0], O(), j();
                break;
            case e.l10n.amPM[1].charAt(0):
            case e.l10n.amPM[1].charAt(0).toLowerCase():
                e.amPM.textContent = e.l10n.amPM[1], O(), j();
                break;
        }
        (o || ae(a)) && E("onKeyDown", i);
    }
    function pe(i, a) {
        if (a === void 0 && (a = "flatpickr-day"), !(e.selectedDates.length !== 1 || i && (!i.classList.contains(a) || i.classList.contains("flatpickr-disabled")))) {
            for(var o = i ? i.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), c = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), u = Math.min(o, e.selectedDates[0].getTime()), f = Math.max(o, e.selectedDates[0].getTime()), b = !1, m = 0, y = 0, h = u; h < f; h += $0451e076155c8af2$var$jt.DAY)J(new Date(h), !0) || (b = b || h > u && h < f, h < c && (!m || h > m) ? m = h : h > c && (!y || h < y) && (y = h));
            var v = Array.from(e.rContainer.querySelectorAll("*:nth-child(-n+" + e.config.showMonths + ") > ." + a));
            v.forEach(function(S) {
                var H = S.dateObj, Y = H.getTime(), re = m > 0 && Y < m || y > 0 && Y > y;
                if (re) {
                    S.classList.add("notAllowed"), [
                        "inRange",
                        "startRange",
                        "endRange"
                    ].forEach(function(ee) {
                        S.classList.remove(ee);
                    });
                    return;
                } else if (b && !re) return;
                [
                    "startRange",
                    "inRange",
                    "endRange",
                    "notAllowed"
                ].forEach(function(ee) {
                    S.classList.remove(ee);
                }), i !== void 0 && (i.classList.add(o <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), c < o && Y === c ? S.classList.add("startRange") : c > o && Y === c && S.classList.add("endRange"), Y >= m && (y === 0 || Y <= y) && $0451e076155c8af2$var$Yt(Y, c, o) && S.classList.add("inRange"));
            });
        }
    }
    function Mn() {
        e.isOpen && !e.config.static && !e.config.inline && he();
    }
    function En(i, a) {
        if (a === void 0 && (a = e._positionElement), e.isMobile === !0) {
            if (i) {
                i.preventDefault();
                var o = $0451e076155c8af2$var$_(i);
                o && o.blur();
            }
            e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), E("onOpen");
            return;
        } else if (e._input.disabled || e.config.inline) return;
        var c = e.isOpen;
        e.isOpen = !0, c || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), E("onOpen"), he(a)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (i === void 0 || !e.timeContainer.contains(i.relatedTarget)) && setTimeout(function() {
            return e.hourElement.select();
        }, 50);
    }
    function rt(i) {
        return function(a) {
            var o = e.config["_" + i + "Date"] = e.parseDate(a, e.config.dateFormat), c = e.config["_" + (i === "min" ? "max" : "min") + "Date"];
            o !== void 0 && (e[i === "min" ? "minDateHasTime" : "maxDateHasTime"] = o.getHours() > 0 || o.getMinutes() > 0 || o.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter(function(u) {
                return J(u);
            }), !e.selectedDates.length && i === "min" && T(o), j()), e.daysContainer && (lt(), o !== void 0 ? e.currentYearElement[i] = o.getFullYear().toString() : e.currentYearElement.removeAttribute(i), e.currentYearElement.disabled = !!c && o !== void 0 && c.getFullYear() === o.getFullYear());
        };
    }
    function xn() {
        var i = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ], a = $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, JSON.parse(JSON.stringify(n.dataset || {}))), t), o = {};
        e.config.parseDate = a.parseDate, e.config.formatDate = a.formatDate, Object.defineProperty(e.config, "enable", {
            get: function() {
                return e.config._enable;
            },
            set: function(v) {
                e.config._enable = dt(v);
            }
        }), Object.defineProperty(e.config, "disable", {
            get: function() {
                return e.config._disable;
            },
            set: function(v) {
                e.config._disable = dt(v);
            }
        });
        var c = a.mode === "time";
        if (!a.dateFormat && (a.enableTime || c)) {
            var u = $0451e076155c8af2$var$k.defaultConfig.dateFormat || $0451e076155c8af2$var$R.dateFormat;
            o.dateFormat = a.noCalendar || c ? "H:i" + (a.enableSeconds ? ":S" : "") : u + " H:i" + (a.enableSeconds ? ":S" : "");
        }
        if (a.altInput && (a.enableTime || c) && !a.altFormat) {
            var f = $0451e076155c8af2$var$k.defaultConfig.altFormat || $0451e076155c8af2$var$R.altFormat;
            o.altFormat = a.noCalendar || c ? "h:i" + (a.enableSeconds ? ":S K" : " K") : f + (" h:i" + (a.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(e.config, "minDate", {
            get: function() {
                return e.config._minDate;
            },
            set: rt("min")
        }), Object.defineProperty(e.config, "maxDate", {
            get: function() {
                return e.config._maxDate;
            },
            set: rt("max")
        });
        var b = function(v) {
            return function(S) {
                e.config[v === "min" ? "_minTime" : "_maxTime"] = e.parseDate(S, "H:i:S");
            };
        };
        Object.defineProperty(e.config, "minTime", {
            get: function() {
                return e.config._minTime;
            },
            set: b("min")
        }), Object.defineProperty(e.config, "maxTime", {
            get: function() {
                return e.config._maxTime;
            },
            set: b("max")
        }), a.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, o, a);
        for(var m = 0; m < i.length; m++)e.config[i[m]] = e.config[i[m]] === !0 || e.config[i[m]] === "true";
        $0451e076155c8af2$var$ye.filter(function(v) {
            return e.config[v] !== void 0;
        }).forEach(function(v) {
            e.config[v] = $0451e076155c8af2$var$Ce(e.config[v] || []).map(d);
        }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var m = 0; m < e.config.plugins.length; m++){
            var y = e.config.plugins[m](e) || {};
            for(var h in y)$0451e076155c8af2$var$ye.indexOf(h) > -1 ? e.config[h] = $0451e076155c8af2$var$Ce(y[h]).map(d).concat(e.config[h]) : typeof a[h] > "u" && (e.config[h] = y[h]);
        }
        a.altInputClass || (e.config.altInputClass = ot().className + " " + e.config.altInputClass), E("onParseConfig");
    }
    function ot() {
        return e.config.wrap ? n.querySelector("[data-input]") : n;
    }
    function st() {
        typeof e.config.locale != "object" && typeof $0451e076155c8af2$var$k.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error("flatpickr: invalid locale " + e.config.locale)), e.l10n = $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, $0451e076155c8af2$var$k.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? $0451e076155c8af2$var$k.l10ns[e.config.locale] : void 0), $0451e076155c8af2$var$W.D = "(" + e.l10n.weekdays.shorthand.join("|") + ")", $0451e076155c8af2$var$W.l = "(" + e.l10n.weekdays.longhand.join("|") + ")", $0451e076155c8af2$var$W.M = "(" + e.l10n.months.shorthand.join("|") + ")", $0451e076155c8af2$var$W.F = "(" + e.l10n.months.longhand.join("|") + ")", $0451e076155c8af2$var$W.K = "(" + e.l10n.amPM[0] + "|" + e.l10n.amPM[1] + "|" + e.l10n.amPM[0].toLowerCase() + "|" + e.l10n.amPM[1].toLowerCase() + ")";
        var i = $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, t), JSON.parse(JSON.stringify(n.dataset || {})));
        i.time_24hr === void 0 && $0451e076155c8af2$var$k.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = $0451e076155c8af2$var$$e(e), e.parseDate = $0451e076155c8af2$var$Se({
            config: e.config,
            l10n: e.l10n
        });
    }
    function he(i) {
        if (typeof e.config.position == "function") return void e.config.position(e, i);
        if (e.calendarContainer !== void 0) {
            E("onPreCalendarPosition");
            var a = i || e._positionElement, o = Array.prototype.reduce.call(e.calendarContainer.children, function(Vn, $n) {
                return Vn + $n.offsetHeight;
            }, 0), c = e.calendarContainer.offsetWidth, u = e.config.position.split(" "), f = u[0], b = u.length > 1 ? u[1] : null, m = a.getBoundingClientRect(), y = window.innerHeight - m.bottom, h = f === "above" || f !== "below" && y < o && m.top > o, v = window.pageYOffset + m.top + (h ? -o - 2 : a.offsetHeight + 2);
            if ($0451e076155c8af2$var$L(e.calendarContainer, "arrowTop", !h), $0451e076155c8af2$var$L(e.calendarContainer, "arrowBottom", h), !e.config.inline) {
                var S = window.pageXOffset + m.left, H = !1, Y = !1;
                b === "center" ? (S -= (c - m.width) / 2, H = !0) : b === "right" && (S -= c - m.width, Y = !0), $0451e076155c8af2$var$L(e.calendarContainer, "arrowLeft", !H && !Y), $0451e076155c8af2$var$L(e.calendarContainer, "arrowCenter", H), $0451e076155c8af2$var$L(e.calendarContainer, "arrowRight", Y);
                var re = window.document.body.offsetWidth - (window.pageXOffset + m.right), ee = S + c > window.document.body.offsetWidth, Hn = re + c > window.document.body.offsetWidth;
                if ($0451e076155c8af2$var$L(e.calendarContainer, "rightMost", ee), !e.config.static) {
                    if (e.calendarContainer.style.top = v + "px", !ee) e.calendarContainer.style.left = S + "px", e.calendarContainer.style.right = "auto";
                    else if (!Hn) e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = re + "px";
                    else {
                        var He = kn();
                        if (He === void 0) return;
                        var jn = window.document.body.offsetWidth, Wn = Math.max(0, jn / 2 - c / 2), qn = ".flatpickr-calendar.centerMost:before", Kn = ".flatpickr-calendar.centerMost:after", Rn = He.cssRules.length, Bn = "{left:" + m.left + "px;right:auto;}";
                        $0451e076155c8af2$var$L(e.calendarContainer, "rightMost", !1), $0451e076155c8af2$var$L(e.calendarContainer, "centerMost", !0), He.insertRule(qn + "," + Kn + Bn, Rn), e.calendarContainer.style.left = Wn + "px", e.calendarContainer.style.right = "auto";
                    }
                }
            }
        }
    }
    function kn() {
        for(var i = null, a = 0; a < document.styleSheets.length; a++){
            var o = document.styleSheets[a];
            if (o.cssRules) {
                try {
                    o.cssRules;
                } catch  {
                    continue;
                }
                i = o;
                break;
            }
        }
        return i ?? On();
    }
    function On() {
        var i = document.createElement("style");
        return document.head.appendChild(i), i.sheet;
    }
    function lt() {
        e.config.noCalendar || e.isMobile || (X(), ge(), ue());
    }
    function Ne() {
        e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
    }
    function ct(i) {
        i.preventDefault(), i.stopPropagation();
        var a = function(v) {
            return v.classList && v.classList.contains("flatpickr-day") && !v.classList.contains("flatpickr-disabled") && !v.classList.contains("notAllowed");
        }, o = $0451e076155c8af2$var$Be($0451e076155c8af2$var$_(i), a);
        if (o !== void 0) {
            var c = o, u = e.latestSelectedDateObj = new Date(c.dateObj.getTime()), f = (u.getMonth() < e.currentMonth || u.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
            if (e.selectedDateElem = c, e.config.mode === "single") e.selectedDates = [
                u
            ];
            else if (e.config.mode === "multiple") {
                var b = Pe(u);
                b ? e.selectedDates.splice(parseInt(b), 1) : e.selectedDates.push(u);
            } else e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = u, e.selectedDates.push(u), $0451e076155c8af2$var$P(u, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort(function(v, S) {
                return v.getTime() - S.getTime();
            }));
            if (O(), f) {
                var m = e.currentYear !== u.getFullYear();
                e.currentYear = u.getFullYear(), e.currentMonth = u.getMonth(), m && (E("onYearChange"), X()), E("onMonthChange");
            }
            if (ge(), ue(), j(), !f && e.config.mode !== "range" && e.config.showMonths === 1 ? Q(c) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
                var y = e.config.mode === "single" && !e.config.enableTime, h = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
                (y || h) && Ne();
            }
            B();
        }
    }
    var me = {
        locale: [
            st,
            it
        ],
        showMonths: [
            tt,
            g,
            nt
        ],
        minDate: [
            K
        ],
        maxDate: [
            K
        ],
        positionElement: [
            ft
        ],
        clickOpens: [
            function() {
                e.config.clickOpens === !0 ? (C(e._input, "focus", e.open), C(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
            }
        ]
    };
    function In(i, a) {
        if (i !== null && typeof i == "object") {
            Object.assign(e.config, i);
            for(var o in i)me[o] !== void 0 && me[o].forEach(function(c) {
                return c();
            });
        } else e.config[i] = a, me[i] !== void 0 ? me[i].forEach(function(c) {
            return c();
        }) : $0451e076155c8af2$var$ye.indexOf(i) > -1 && (e.config[i] = $0451e076155c8af2$var$Ce(a));
        e.redraw(), j(!0);
    }
    function ut(i, a) {
        var o = [];
        if (i instanceof Array) o = i.map(function(c) {
            return e.parseDate(c, a);
        });
        else if (i instanceof Date || typeof i == "number") o = [
            e.parseDate(i, a)
        ];
        else if (typeof i == "string") switch(e.config.mode){
            case "single":
            case "time":
                o = [
                    e.parseDate(i, a)
                ];
                break;
            case "multiple":
                o = i.split(e.config.conjunction).map(function(c) {
                    return e.parseDate(c, a);
                });
                break;
            case "range":
                o = i.split(e.l10n.rangeSeparator).map(function(c) {
                    return e.parseDate(c, a);
                });
                break;
            default:
                break;
        }
        else e.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(i)));
        e.selectedDates = e.config.allowInvalidPreload ? o : o.filter(function(c) {
            return c instanceof Date && J(c, !1);
        }), e.config.mode === "range" && e.selectedDates.sort(function(c, u) {
            return c.getTime() - u.getTime();
        });
    }
    function Ln(i, a, o) {
        if (a === void 0 && (a = !1), o === void 0 && (o = e.config.dateFormat), i !== 0 && !i || i instanceof Array && i.length === 0) return e.clear(a);
        ut(i, o), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), K(void 0, a), T(), e.selectedDates.length === 0 && e.clear(!1), j(a), a && E("onChange");
    }
    function dt(i) {
        return i.slice().map(function(a) {
            return typeof a == "string" || typeof a == "number" || a instanceof Date ? e.parseDate(a, void 0, !0) : a && typeof a == "object" && a.from && a.to ? {
                from: e.parseDate(a.from, void 0),
                to: e.parseDate(a.to, void 0)
            } : a;
        }).filter(function(a) {
            return a;
        });
    }
    function An() {
        e.selectedDates = [], e.now = e.parseDate(e.config.now) || new Date;
        var i = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
        i && ut(i, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
    }
    function Tn() {
        if (e.input = ot(), !e.input) {
            e.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = $0451e076155c8af2$var$D(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), ft();
    }
    function ft() {
        e._positionElement = e.config.positionElement || e._input;
    }
    function Fn() {
        var i = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
        e.mobileInput = $0451e076155c8af2$var$D("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = i, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = i === "datetime-local" ? "Y-m-d\\TH:i:S" : i === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
        try {
            e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
        } catch  {}
        C(e.mobileInput, "change", function(a) {
            e.setDate($0451e076155c8af2$var$_(a).value, !1, e.mobileFormatStr), E("onChange"), E("onClose");
        });
    }
    function Nn(i) {
        if (e.isOpen === !0) return e.close();
        e.open(i);
    }
    function E(i, a) {
        if (e.config !== void 0) {
            var o = e.config[i];
            if (o !== void 0 && o.length > 0) for(var c = 0; o[c] && c < o.length; c++)o[c](e.selectedDates, e.input.value, e, a);
            i === "onChange" && (e.input.dispatchEvent(_e("change")), e.input.dispatchEvent(_e("input")));
        }
    }
    function _e(i) {
        var a = document.createEvent("Event");
        return a.initEvent(i, !0, !0), a;
    }
    function Pe(i) {
        for(var a = 0; a < e.selectedDates.length; a++){
            var o = e.selectedDates[a];
            if (o instanceof Date && $0451e076155c8af2$var$P(o, i) === 0) return "" + a;
        }
        return !1;
    }
    function _n(i) {
        return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : $0451e076155c8af2$var$P(i, e.selectedDates[0]) >= 0 && $0451e076155c8af2$var$P(i, e.selectedDates[1]) <= 0;
    }
    function ge() {
        e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach(function(i, a) {
            var o = new Date(e.currentYear, e.currentMonth, 1);
            o.setMonth(e.currentMonth + a), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[a].textContent = $0451e076155c8af2$var$ce(o.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = o.getMonth().toString(), i.value = o.getFullYear().toString();
        }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
    }
    function Ye(i) {
        var a = i || (e.config.altInput ? e.config.altFormat : e.config.dateFormat);
        return e.selectedDates.map(function(o) {
            return e.formatDate(o, a);
        }).filter(function(o, c, u) {
            return e.config.mode !== "range" || e.config.enableTime || u.indexOf(o) === c;
        }).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
    }
    function j(i) {
        i === void 0 && (i = !0), e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = Ye(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = Ye(e.config.altFormat)), i !== !1 && E("onValueUpdate");
    }
    function Pn(i) {
        var a = $0451e076155c8af2$var$_(i), o = e.prevMonthNav.contains(a), c = e.nextMonthNav.contains(a);
        o || c ? Te(o ? -1 : 1) : e.yearElements.indexOf(a) >= 0 ? a.select() : a.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : a.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
    }
    function Yn(i) {
        i.preventDefault();
        var a = i.type === "keydown", o = $0451e076155c8af2$var$_(i), c = o;
        e.amPM !== void 0 && o === e.amPM && (e.amPM.textContent = e.l10n.amPM[$0451e076155c8af2$var$N(e.amPM.textContent === e.l10n.amPM[0])]);
        var u = parseFloat(c.getAttribute("min")), f = parseFloat(c.getAttribute("max")), b = parseFloat(c.getAttribute("step")), m = parseInt(c.value, 10), y = i.delta || (a ? i.which === 38 ? 1 : -1 : 0), h = m + b * y;
        if (typeof c.value < "u" && c.value.length === 2) {
            var v = c === e.hourElement, S = c === e.minuteElement;
            h < u ? (h = f + h + $0451e076155c8af2$var$N(!v) + ($0451e076155c8af2$var$N(v) && $0451e076155c8af2$var$N(!e.amPM)), S && G(void 0, -1, e.hourElement)) : h > f && (h = c === e.hourElement ? h - f - $0451e076155c8af2$var$N(!e.amPM) : u, S && G(void 0, 1, e.hourElement)), e.amPM && v && (b === 1 ? h + m === 23 : Math.abs(h - m) > b) && (e.amPM.textContent = e.l10n.amPM[$0451e076155c8af2$var$N(e.amPM.textContent === e.l10n.amPM[0])]), c.value = $0451e076155c8af2$var$I(h);
        }
    }
    return l(), e;
}
function $0451e076155c8af2$var$ne(n, t) {
    for(var e = Array.prototype.slice.call(n).filter(function(d) {
        return d instanceof HTMLElement;
    }), r = [], l = 0; l < e.length; l++){
        var s = e[l];
        try {
            if (s.getAttribute("data-fp-omit") !== null) continue;
            s._flatpickr !== void 0 && (s._flatpickr.destroy(), s._flatpickr = void 0), s._flatpickr = $0451e076155c8af2$var$vi(s, t || {}), r.push(s._flatpickr);
        } catch (d) {
            console.error(d);
        }
    }
    return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(n) {
    return $0451e076155c8af2$var$ne(this, n);
}, HTMLElement.prototype.flatpickr = function(n) {
    return $0451e076155c8af2$var$ne([
        this
    ], n);
});
var $0451e076155c8af2$var$k = function(n, t) {
    return typeof n == "string" ? $0451e076155c8af2$var$ne(window.document.querySelectorAll(n), t) : n instanceof Node ? $0451e076155c8af2$var$ne([
        n
    ], t) : $0451e076155c8af2$var$ne(n, t);
};
$0451e076155c8af2$var$k.defaultConfig = {};
$0451e076155c8af2$var$k.l10ns = {
    en: $0451e076155c8af2$var$A({}, $0451e076155c8af2$var$we),
    default: $0451e076155c8af2$var$A({}, $0451e076155c8af2$var$we)
};
$0451e076155c8af2$var$k.localize = function(n) {
    $0451e076155c8af2$var$k.l10ns.default = $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, $0451e076155c8af2$var$k.l10ns.default), n);
};
$0451e076155c8af2$var$k.setDefaults = function(n) {
    $0451e076155c8af2$var$k.defaultConfig = $0451e076155c8af2$var$A($0451e076155c8af2$var$A({}, $0451e076155c8af2$var$k.defaultConfig), n);
};
$0451e076155c8af2$var$k.parseDate = $0451e076155c8af2$var$Se({});
$0451e076155c8af2$var$k.formatDate = $0451e076155c8af2$var$$e({});
$0451e076155c8af2$var$k.compareDates = $0451e076155c8af2$var$P;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(n) {
    return $0451e076155c8af2$var$ne(this, n);
});
Date.prototype.fp_incr = function(n) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof n == "string" ? parseInt(n, 10) : n));
};
typeof window < "u" && (window.flatpickr = $0451e076155c8af2$var$k);
var $0451e076155c8af2$var$Je = $0451e076155c8af2$var$k;
var $0451e076155c8af2$var$qt = !1, $0451e076155c8af2$var$bi = {
    locale: {
        firstDayOfWeek: 1
    },
    altInput: !0,
    time_24hr: !0,
    minuteIncrement: 1,
    altFormat: "d.m.Y"
}, $0451e076155c8af2$var$yi = {
    allowInput: !0,
    dateFormat: "H:i",
    enableTime: !0,
    noCalendar: !0,
    time_24hr: !0
};
function $0451e076155c8af2$export$ed8a68ffbc322e67(n = null, t = {}) {
    let e = n || document;
    $0451e076155c8af2$var$qt || ($0451e076155c8af2$var$Je.localize({
        firstDayOfWeek: 1
    }), $0451e076155c8af2$var$qt = !0), e.querySelectorAll(".datepicker").forEach((r)=>{
        let l = !!r.dataset.disablePast, s = !!r.dataset.disableFuture, d = !!r.dataset.enableTime, g = !!r.dataset.timeOnly, p = r.dataset.minDate || null, M = r.dataset.maxDate || null, w = null;
        p ? w = p : l && (w = new Date);
        let O = null;
        M ? O = M : s && (O = new Date);
        let T = {
            ...$0451e076155c8af2$var$bi,
            ...d ? {
                altFormat: "d.m.Y H:i"
            } : {},
            ...t,
            minDate: w,
            maxDate: O,
            enableTime: d
        }, x = $0451e076155c8af2$var$Je(r, g ? $0451e076155c8af2$var$yi : T);
        r.disabled && x.altInput && (x.altInput.disabled = !0);
    });
}
var $0451e076155c8af2$var$Rt = new WeakSet;
function $0451e076155c8af2$export$a4d38683f8b8b9ce(n) {
    let t = n || document;
    $0451e076155c8af2$var$Rt.has(t) || ($0451e076155c8af2$var$Rt.add(t), t.addEventListener("change", (e)=>{
        let r = e.target;
        if (!(r instanceof HTMLInputElement) || r.type !== "file") return;
        let l = r.closest(".file-input");
        if (!l) return;
        let s = l.querySelector(".file-name");
        if (!s) return;
        let d = r.files && r.files[0];
        s.textContent = d ? d.name : "";
    }));
}
var $0451e076155c8af2$var$Di = "[data-disable-interfere-submit]", $0451e076155c8af2$var$wi = "[data-filter-name]", $0451e076155c8af2$var$Ci = (n)=>{
    let t = document.createElement("i");
    t.classList.add("icon-spinner-outline", "rotate"), n.classList.add("has-icon"), n.appendChild(t), n.disabled = !0;
};
function $0451e076155c8af2$export$823a7882fb5f7a04(n = null, t = {}) {
    let e = n || document, { enableFor: r, disableFor: l } = t, s = `form${r || ""}:not(${l || $0451e076155c8af2$var$Di})`, d = [
        ...e.querySelectorAll(s)
    ], g = (p)=>{
        let M = (p.getAttribute("method") || p.method || "get").toLowerCase(), w = !!(p.closest(".filter") || p.querySelector($0451e076155c8af2$var$wi));
        return M === "get" && w;
    };
    d.forEach((p)=>{
        if (g(p)) return;
        let M = !1, w = p.querySelectorAll('[type="submit"]');
        p.addEventListener("submit", (O)=>{
            M && O.preventDefault(), w.forEach($0451e076155c8af2$var$Ci), M = !0;
        });
    });
}
var $0451e076155c8af2$var$zt = "No results found.", $0451e076155c8af2$var$Si = "search", $0451e076155c8af2$var$$t = "[data-search]", $0451e076155c8af2$var$Mi = "button.data-item", $0451e076155c8af2$var$Jt = Symbol("live search request failed"), $0451e076155c8af2$var$Ei = (n, t)=>{
    let e = [
        n.dataset.searchDelay,
        t
    ];
    for (let r of e){
        if (r == null || r === "") continue;
        let l = Number(r);
        if (Number.isFinite(l) && l >= 0) return l;
        console.error(`Invalid live search delay "${r}", ignoring it`);
    }
    return 200;
}, $0451e076155c8af2$var$xi = 'You need to specify "data-value-key" and "data-label-key" if the API returns objects or "data-simple-values" if the API returns a list of strings', $0451e076155c8af2$var$ki = '"data-arbitrary-input" is only allowed when "data-simple-values" is activated.', $0451e076155c8af2$var$Ut = (n, t)=>{
    let e = n.closest(".form-group");
    return e ? e.querySelector(t) : n.parentElement ? n.parentElement.querySelector(t) : null;
}, $0451e076155c8af2$var$Gt = (n, t)=>{
    t.parentNode.insertBefore(n, t.nextSibling);
}, $0451e076155c8af2$var$Oi = (n)=>{
    let t = document.createElement("div");
    return t.classList.add("data-list"), t.setAttribute("role", "listbox"), $0451e076155c8af2$var$Gt(t, n), t;
}, $0451e076155c8af2$var$Ii = (n)=>{
    let t = document.createElement("div");
    return t.setAttribute("data-search-selection", ""), t.classList.add("search-selection"), n.parentNode.insertBefore(t, n), t;
}, $0451e076155c8af2$var$Li = (n, t)=>{
    let e = document.createElement("input"), r = n.value, l = n.dataset.preselectLabel;
    return e.type = "hidden", e.name = t, $0451e076155c8af2$var$Gt(e, n), e.value = r || "", l && (n.value = l), e;
}, $0451e076155c8af2$var$Ai = ()=>{
    let n = document.createElement("span");
    return n.classList.add("data-item"), n.textContent = $0451e076155c8af2$var$zt, n;
}, $0451e076155c8af2$var$Ti = (n, t)=>{
    let e = document.createElement("i");
    return e.classList.add("icon-close"), n.appendChild(e), t.type = "text", e;
}, $0451e076155c8af2$var$Qt = (n, t)=>{
    let e = document.createElement("div");
    return e.classList.add(...t), n.parentNode.insertBefore(e, n), e.appendChild(n), e;
}, $0451e076155c8af2$var$Zt = new Set;
document.addEventListener("click", (n)=>{
    $0451e076155c8af2$var$Zt.forEach((t)=>{
        t.container.contains(n.target) || (t.optionsWrapper.classList.remove("active"), t.resetInputIfUnselected());
    });
});
var $0451e076155c8af2$var$xe = class {
    constructor(t, e = {}){
        let { arbitraryInput: r, labelKey: l, name: s, onSelectCallback: d, preselectLabel: g, queryParam: p, resultsKey: M, simpleValues: w, url: O, valueKey: T } = t.dataset;
        if (this.container = t.parentElement, this.input = t, this.latestSearchValue = g || t.value, this.inputWrapper = $0451e076155c8af2$var$Qt(this.input, [
            "relative",
            "grow"
        ]), this.optionsWrapper = $0451e076155c8af2$var$Ut(t, "[data-search-options]"), this.optionsWrapper ? this.optionsWrapper.setAttribute("role", "listbox") : this.optionsWrapper = $0451e076155c8af2$var$Oi(t), this.form = t.closest("form"), this.isMulti = "multi" in t.dataset, this.name = s, this.url = O, this.queryParam = p || $0451e076155c8af2$var$Si, this.valueKey = T, this.labelKey = l, this.simpleValues = t.hasAttribute("data-simple-values") && w !== "false", this.resultsKey = M, this.searchTimeout = null, this.searchDelay = $0451e076155c8af2$var$Ei(t, e.searchDelay), this.latestRequestId = 0, this.suppressFocusOpen = !1, this.arbitraryInput = t.hasAttribute("data-arbitrary-input") && r !== "false", this.onSelectCallback = d, t.dataset.initialSelection) try {
            let x = JSON.parse(t.dataset.initialSelection);
            if (x) {
                let q = s || t.id;
                this.initialSelections = {
                    [q]: x
                };
            }
        } catch (x) {
            console.error("Malformed JSON in data-initial-selection:", x);
        }
        if (this.staticOptions = {}, t.dataset.staticOptions) try {
            let x = JSON.parse(t.dataset.staticOptions);
            if (Array.isArray(x)) {
                let q = s || t.id;
                this.staticOptions = Object.assign({}, this.staticOptions, {
                    [q]: x
                });
            }
        } catch (x) {
            console.error("Malformed JSON in data-static-options:", x);
        }
        if (!this.simpleValues && !this.valueKey && !this.labelKey) throw new Error($0451e076155c8af2$var$xi);
        if (this.arbitraryInput && !this.simpleValues) throw new Error($0451e076155c8af2$var$ki);
        this.liveRegion = document.createElement("div"), this.liveRegion.setAttribute("aria-live", "polite"), this.liveRegion.setAttribute("aria-atomic", "true"), Object.assign(this.liveRegion.style, {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            borderWidth: "0"
        }), this.container.appendChild(this.liveRegion), this.clearIcon = $0451e076155c8af2$var$Ti(this.inputWrapper, this.input), this.addClearListener(), this.addKeyDownListener(), this.addFocusListener(), this.addInputListener(), this.addOptionsKeyboardNavigation(), $0451e076155c8af2$var$Zt.add(this);
    }
    resetInputIfUnselected() {
        if (!this.arbitraryInput) {
            if (this.isMulti) {
                this.input.value && (this.input.value = "");
                return;
            }
            if (this.hiddenInput) {
                if (!this.hiddenInput.value) {
                    this.input.value = "";
                    return;
                }
                this.selectedLabel && (this.input.value = this.selectedLabel);
            }
        }
    }
    normalizeSimpleValue(t) {
        if (t !== null && typeof t == "object") {
            let e = t.value || t.url || this.valueKey && t[this.valueKey] || JSON.stringify(t), r = t.label || t.name || this.labelKey && t[this.labelKey] || JSON.stringify(t);
            return {
                value: e,
                label: r
            };
        }
        return {
            value: t,
            label: t
        };
    }
    optionButtons() {
        return [
            ...this.optionsWrapper.querySelectorAll($0451e076155c8af2$var$Mi)
        ];
    }
    optionsHaveFocus() {
        return this.optionsWrapper.contains(document.activeElement);
    }
    addKeyDownListener() {
        this.input.addEventListener("keydown", (t)=>{
            if (t.key === "ArrowDown") {
                let [e] = this.optionButtons();
                e && (t.preventDefault(), clearTimeout(this.searchTimeout), e.focus());
                return;
            }
            if (t.key === "Enter" && this.isMulti) {
                if (t.preventDefault(), clearTimeout(this.searchTimeout), this.arbitraryInput && this.simpleValues && this.input.value) {
                    this instanceof $0451e076155c8af2$var$ke && (this.createSelectedItem({
                        value: this.input.value,
                        label: this.input.value
                    }), this.input.value = "", this.clearOptions());
                    return;
                }
                this.performSearch(this.input.value);
            }
        });
    }
    async performSearch(t) {
        if (!t) {
            this.cancelPendingSearch(), this.setOptions(this.getStaticOptions("", !0) || []);
            return;
        }
        this.latestSearchValue = t;
        let e = ++this.latestRequestId;
        if (this.showOptions(), !this.url) {
            this.setOptions(this.getStaticOptions(t, !1) || []);
            return;
        }
        this.showLoading();
        let r = await this.fetchResults(t);
        e === this.latestRequestId && this.setOptions(r === $0451e076155c8af2$var$Jt ? [] : this.toOptions(r));
    }
    async fetchResults(t) {
        try {
            let e = await fetch(`${this.url}?${this.queryParam}=${encodeURIComponent(t)}`);
            if (!e.ok) throw new Error(e.status);
            return await e.json();
        } catch  {
            return $0451e076155c8af2$var$Jt;
        }
    }
    toOptions(t) {
        let e = this.resultsKey ? t[this.resultsKey] : t;
        return this.simpleValues ? e : e.map((r)=>({
                value: r[this.valueKey],
                label: r[this.labelKey]
            }));
    }
    showLoading() {
        if (this.optionsHaveFocus()) return;
        let t = document.createElement("i");
        t.classList.add("icon-spinner-outline", "rotate");
        let e = document.createElement("span");
        e.classList.add("inset-xs", "flexrow", "justify-center"), e.appendChild(t), this.optionsWrapper.replaceChildren(e);
    }
    showOptions = ()=>{
        this.optionsWrapper.classList.add("active");
    };
    addFocusListener() {
        this.input.addEventListener("focusin", ()=>{
            if (!this.suppressFocusOpen && (this.showOptions(), !this.url)) {
                let t = this.getStaticOptions("", !0);
                t && this.setOptions(t);
            }
        });
    }
    addClearListener() {
        this.clearIcon.addEventListener("click", ()=>{
            this.input.value = "", this.selectedLabel = "", this.resetSearch(), this.optionsWrapper.classList.remove("active"), this.hiddenInput && (this.hiddenInput.value = "");
        });
    }
    cancelPendingSearch() {
        clearTimeout(this.searchTimeout), this.latestRequestId += 1;
    }
    resetSearch() {
        this.cancelPendingSearch(), this.latestSearchValue = "", this.clearOptions();
    }
    clearOptions() {
        this.optionsHaveFocus() && this.focusInput(), this.optionsWrapper.replaceChildren();
    }
    focusInput() {
        this.suppressFocusOpen = !0, this.input.focus(), this.suppressFocusOpen = !1;
    }
    setOptions(t) {
        let e = this.captureOptionFocus(), r = t.length ? t.map((l)=>this.createOption(l)) : [
            $0451e076155c8af2$var$Ai()
        ];
        this.optionsWrapper.replaceChildren(...r), e?.(), this.liveRegion.textContent = t.length ? `${t.length} result${t.length !== 1 ? "s" : ""} available` : $0451e076155c8af2$var$zt;
    }
    createOption(t) {
        let e = this.simpleValues ? this.normalizeSimpleValue(t) : t, { value: r, label: l } = e, s = document.createElement("button");
        return s.type = "button", s.classList.add("data-item"), s.dataset.value = r, s.textContent = l, s.setAttribute("role", "option"), this.selection && this.selection.includes(r) || this.hiddenInput && this.hiddenInput.value === r ? (s.classList.add("selected"), s.setAttribute("aria-selected", "true")) : (s.setAttribute("aria-selected", "false"), s.addEventListener("click", ()=>this.handleClick(e))), s;
    }
    captureOptionFocus() {
        let t = this.optionButtons(), e = t.indexOf(document.activeElement);
        if (e < 0) return null;
        let r = t[e].dataset.value;
        return ()=>{
            let l = this.optionButtons();
            if (!l.length) {
                this.focusInput();
                return;
            }
            (l.find((d)=>d.dataset.value === r) || l[Math.min(e, l.length - 1)]).focus();
        };
    }
    addInputListener() {
        this.input.addEventListener("input", (t)=>{
            let e = t.currentTarget.value;
            if (clearTimeout(this.searchTimeout), e !== this.latestSearchValue) {
                if (this.hiddenInput && this.arbitraryInput && (this.hiddenInput.value = e), !e) {
                    this.resetSearch();
                    let r = this.getStaticOptions("", !0);
                    r && this.setOptions(r), this.hiddenInput && (this.hiddenInput.value = "");
                    return;
                }
                this.scheduleSearch(e);
            }
        });
    }
    scheduleSearch(t) {
        if (!this.searchDelay) {
            this.performSearch(t);
            return;
        }
        this.searchTimeout = setTimeout(()=>this.performSearch(t), this.searchDelay);
    }
    getStaticOptions(t, e) {
        let r = this.name || this.input.id, l = this.staticOptions && (this.staticOptions[r] || this.staticOptions[this.input.id]);
        if (!l || !Array.isArray(l)) return null;
        let s = (p)=>(p || "").toString().toLowerCase(), d;
        if (this.simpleValues ? l.length && typeof l[0] == "object" ? d = l.map((p)=>p.value && p.label ? p : {
                value: p[this.valueKey] || p.value,
                label: p[this.labelKey] || p.label || p[this.valueKey] || p.value
            }) : d = l.map((p)=>({
                value: p,
                label: p
            })) : d = l.map((p)=>p.value && p.label ? p : {
                value: p[this.valueKey] || p.value,
                label: p[this.labelKey] || p.label || p[this.valueKey] || p.value
            }), e || !t) return d;
        let g = s(t);
        return d.filter((p)=>s(p.label).includes(g));
    }
    addOptionsKeyboardNavigation() {
        this.optionsWrapper.addEventListener("keydown", (t)=>{
            let e = this.optionButtons(), r = e.indexOf(document.activeElement);
            t.key === "ArrowDown" ? (t.preventDefault(), e[r + 1]?.focus()) : t.key === "ArrowUp" ? (t.preventDefault(), r <= 0 ? this.input.focus() : e[r - 1]?.focus()) : t.key === "Escape" && (t.preventDefault(), this.optionsWrapper.classList.remove("active"), this.input.focus());
        });
    }
    handleClick(t) {
        this.onSelectCallback && typeof window[this.onSelectCallback] == "function" && window[this.onSelectCallback](t);
    }
}, $0451e076155c8af2$var$ze = class extends $0451e076155c8af2$var$xe {
    constructor(t, e){
        super(t, e), this.hiddenInput = $0451e076155c8af2$var$Li(t, this.name), this.selectedLabel = this.input.value, this.required = this.input.required, this.setSubmitListener();
    }
    setSubmitListener() {
        this.form && this.form.addEventListener("submit", (t)=>{
            this.required && !this.hiddenInput.value && (t.preventDefault(), this.input.setCustomValidity("Please fill in this field."));
        });
    }
    handleClick(t) {
        if (this.input.setCustomValidity(""), this.optionsWrapper.classList.remove("active"), this.simpleValues) {
            let e = this.normalizeSimpleValue(t);
            this.hiddenInput.value = e.value, this.input.value = e.label, this.selectedLabel = e.label;
        } else this.hiddenInput.value = t.value, this.input.value = t.label, this.selectedLabel = t.label;
        this.clearOptions(), super.handleClick(t);
    }
}, $0451e076155c8af2$var$ke = class extends $0451e076155c8af2$var$xe {
    constructor(t, e){
        super(t, e), this.selectionWrapper = $0451e076155c8af2$var$Ut(this.input, "[data-search-selection]"), this.selectionWrapper || (this.selectionWrapper = $0451e076155c8af2$var$Ii(this.inputWrapper)), this.selection = [], this.arbitraryInput && this.initArbitrarySearchInput(), this.initSelection();
    }
    createSelectedItem({ value: t, label: e }) {
        let r = document.createElement("input");
        r.type = "hidden", r.value = t, r.name = this.name;
        let l = document.createElement("span");
        l.setAttribute("data-selection-item", ""), l.textContent = e;
        let s = document.createElement("i");
        s.classList.add("icon-close"), s.addEventListener("click", ()=>this.removeSelected(l, r.value)), l.appendChild(s), l.appendChild(r), this.selection.includes(r.value) || (this.selectionWrapper.appendChild(l), this.selection.push(r.value));
    }
    initSelection() {
        let t = this.name || this.input.id, e = this.initialSelections && (this.initialSelections[t] || this.initialSelections[this.input.id]);
        e && Array.isArray(e) && e.forEach((l)=>{
            if (this.simpleValues) {
                let s = typeof l == "string" ? l : l.value;
                this.createSelectedItem({
                    value: s,
                    label: s
                });
            } else {
                let s = l.value, d = l.label || l.value;
                this.createSelectedItem({
                    value: s,
                    label: d
                });
            }
        }), [
            ...this.selectionWrapper.querySelectorAll("[data-selection-item]")
        ].filter((l)=>l.dataset.value || l.dataset.label).forEach((l)=>{
            let { value: s, label: d } = l.dataset;
            this.simpleValues ? this.createSelectedItem({
                value: s,
                label: s
            }) : this.createSelectedItem({
                value: s,
                label: d
            }), l.remove();
        });
    }
    removeSelected(t, e) {
        t.remove();
        let r = this.selection.indexOf(e);
        this.selection.splice(r, 1);
    }
    initArbitrarySearchInput() {
        let t = $0451e076155c8af2$var$Qt(this.inputWrapper, [
            "relative",
            "flexrow",
            "flex-gap-xs",
            "align-center"
        ]), e = document.createElement("button");
        e.classList.add("is-icon", "primary", "small");
        let r = document.createElement("i");
        r.classList.add("icon-add"), e.appendChild(r), e.addEventListener("click", (l)=>{
            l.preventDefault();
            let s = this.input.value;
            this.createSelectedItem({
                value: s,
                label: s
            }), this.input.value = "", this.clearOptions();
        }), t.appendChild(e);
    }
    handleClick(t) {
        let e = this.simpleValues ? this.normalizeSimpleValue(t) : t;
        this.createSelectedItem(e), this.input.value = "", this.optionsWrapper.classList.remove("active"), this.clearOptions(), super.handleClick(t);
    }
}, $0451e076155c8af2$export$aa70e201a98a0ce4 = (n, t = $0451e076155c8af2$var$$t, e = {})=>{
    let r = n || document, l = typeof t == "string", s = l ? e : t || {}, d = (l ? t : s.selector) || $0451e076155c8af2$var$$t;
    r.querySelectorAll(d).forEach((g)=>{
        g.dataset.multi ? new $0451e076155c8af2$var$ke(g, s) : new $0451e076155c8af2$var$ze(g, s);
    });
};
var $0451e076155c8af2$var$Fi = "[data-modal]", $0451e076155c8af2$var$Ni = ".modal-body", $0451e076155c8af2$var$_i = ".modal-close", $0451e076155c8af2$var$Pi = ".mobile-nav", $0451e076155c8af2$var$Yi = "[data-modal-keep-open]", $0451e076155c8af2$var$Hi = "mobile-nav-toggle", $0451e076155c8af2$var$nn = "data-modal-overlay", $0451e076155c8af2$var$en = "data-noscroll", $0451e076155c8af2$var$tn = "--scrollbar-compensation", $0451e076155c8af2$var$ji = "econ-modal-opened", $0451e076155c8af2$var$Wi = "econ-modal-closed", $0451e076155c8af2$var$qi = "Open navigation menu", $0451e076155c8af2$var$Ki = "Close navigation menu", $0451e076155c8af2$var$Oe = (n)=>n.classList.contains($0451e076155c8af2$var$F), $0451e076155c8af2$var$an = (n)=>n.setAttribute($0451e076155c8af2$var$nn, ""), $0451e076155c8af2$var$rn = (n, t)=>{
    n.ownerDocument.querySelectorAll(`[data-modal="${CSS.escape(n.id)}"]`).forEach((e)=>{
        e.tagName === "BUTTON" && e.setAttribute("aria-expanded", `${t}`), e.classList.contains($0451e076155c8af2$var$Hi) && e.setAttribute("aria-label", t ? $0451e076155c8af2$var$Ki : $0451e076155c8af2$var$qi);
    });
}, $0451e076155c8af2$var$on = (n)=>{
    let t = n.body;
    if (!t) return;
    let e = !!n.querySelector(`[${$0451e076155c8af2$var$nn}].${$0451e076155c8af2$var$F}`);
    if (e !== t.hasAttribute($0451e076155c8af2$var$en)) {
        if (e) {
            let r = window.innerWidth - n.documentElement.clientWidth;
            t.style.setProperty($0451e076155c8af2$var$tn, `${r}px`);
        } else t.style.removeProperty($0451e076155c8af2$var$tn);
        t.toggleAttribute($0451e076155c8af2$var$en, e);
    }
}, $0451e076155c8af2$var$z = (n, t)=>{
    let e = $0451e076155c8af2$var$Oe(n) !== t;
    return $0451e076155c8af2$var$an(n), n.classList.toggle($0451e076155c8af2$var$F, t), $0451e076155c8af2$var$on(n.ownerDocument), $0451e076155c8af2$var$rn(n, t), e && n.dispatchEvent(new CustomEvent(t ? $0451e076155c8af2$var$ji : $0451e076155c8af2$var$Wi, {
        bubbles: !0
    })), n;
}, $0451e076155c8af2$var$Ue = (n)=>typeof n == "string" ? document.getElementById(n) : n && n.nodeType === 1 ? n : null, $0451e076155c8af2$var$Ri = (n, t)=>{
    if (!n.matches($0451e076155c8af2$var$Pi) || t.button || t.metaKey || t.ctrlKey || t.shiftKey || t.altKey) return !1;
    let e = t.target.closest("a[href]");
    if (!e || e.hasAttribute("download") || e.closest($0451e076155c8af2$var$Yi)) return !1;
    let r = e.getAttribute("target");
    return !r || r === "_self";
}, $0451e076155c8af2$var$Bi = (n)=>$0451e076155c8af2$var$oe(n, "modal-overlay", ()=>{
        $0451e076155c8af2$var$an(n), n.addEventListener("click", (t)=>{
            if (t.target.closest($0451e076155c8af2$var$_i)) {
                t.preventDefault(), $0451e076155c8af2$var$z(n, !1);
                return;
            }
            if ($0451e076155c8af2$var$Ri(n, t)) {
                $0451e076155c8af2$var$z(n, !1);
                return;
            }
            t.target.closest($0451e076155c8af2$var$Ni) || (t.preventDefault(), $0451e076155c8af2$var$z(n, !1));
        });
    }), $0451e076155c8af2$var$Vi = (n, t)=>$0451e076155c8af2$var$oe(n, "modal-trigger", ()=>{
        n.addEventListener("click", (e)=>{
            e.preventDefault(), $0451e076155c8af2$var$z(t, !$0451e076155c8af2$var$Oe(t));
        });
    });
function $0451e076155c8af2$export$60523367a7e10402(n) {
    let t = n || document;
    t.querySelectorAll($0451e076155c8af2$var$Fi).forEach((e)=>{
        let r = e.dataset.modal, l = t.querySelector(`#${CSS.escape(r)}`);
        l && ($0451e076155c8af2$var$Bi(l), $0451e076155c8af2$var$Vi(e, l), $0451e076155c8af2$var$rn(l, $0451e076155c8af2$var$Oe(l)));
    }), $0451e076155c8af2$var$on(t.ownerDocument || t);
}
var $0451e076155c8af2$export$a7f6cffb6b8ba11c = (n)=>{
    let t = $0451e076155c8af2$var$Ue(n);
    return t ? $0451e076155c8af2$var$z(t, !0) : null;
}, $0451e076155c8af2$export$3f6fecd573f3fa48 = (n)=>{
    let t = $0451e076155c8af2$var$Ue(n);
    return t ? $0451e076155c8af2$var$z(t, !1) : null;
}, $0451e076155c8af2$export$313c6d35f75fc0e = (n)=>{
    let t = $0451e076155c8af2$var$Ue(n);
    return t ? $0451e076155c8af2$var$z(t, !$0451e076155c8af2$var$Oe(t)) : null;
};
function $0451e076155c8af2$var$Ui(n) {
    n.classList.add("fade-out", "no-delay");
}
function $0451e076155c8af2$var$Gi(n) {
    let t = n.querySelector(".notification-close");
    t && t.addEventListener("click", ()=>$0451e076155c8af2$var$Ui(n));
}
function $0451e076155c8af2$export$e30e8b9f67d70081(n) {
    (n || document).querySelectorAll(".notification-fixed").forEach($0451e076155c8af2$var$Gi);
}
var $0451e076155c8af2$var$Ge = "sidebar-open", $0451e076155c8af2$var$Qi = "sidebar-opening", $0451e076155c8af2$var$Qe = "sidebar-closed", $0451e076155c8af2$var$Zi = "sidebar-closing", $0451e076155c8af2$var$U = "collapsible-open", $0451e076155c8af2$var$cn = 200, $0451e076155c8af2$var$un = "econ-sidebar-collapsibles", $0451e076155c8af2$var$Ze = "econ-sidebar-open", $0451e076155c8af2$var$Xe = class {
    constructor(t, e){
        this.sidebarEl = t, this.outsideToggle = document.querySelector(".sidebar-outside-switch"), this.innerToggle = t.querySelector(".sidebar-switch"), this.collapsibles = [
            ...t.querySelectorAll(".sidebar-collapsible")
        ], this.sidebarLinks = [
            ...t.querySelectorAll(".sidebar-content a[href]")
        ], this.trackCollapsibles = e.trackCollapsibles, this.openCollapsibles = this.collapsibles.reduce((r, l, s)=>l.classList.contains($0451e076155c8af2$var$U) ? [
                ...r,
                s
            ] : r, []), this.isOpen = this.determineOpenInitially(), this.addEventListeners(), this.findActiveCollapsible(), this.setActiveItems(), this.onOpenChange(), this.trackCollapsibles && this.handleStoredSidebarState();
    }
    get open() {
        return this.isOpen;
    }
    set open(t) {
        this.isOpen !== t && (this.isOpen = t, this.onOpenChange());
    }
    isMobileView() {
        return window.getComputedStyle(this.outsideToggle).display !== "none";
    }
    determineOpenInitially() {
        try {
            if (this.trackCollapsibles && localStorage.getItem($0451e076155c8af2$var$Ze) !== null) return JSON.parse(localStorage.getItem($0451e076155c8af2$var$Ze));
        } catch  {}
        return this.sidebarEl.classList.contains($0451e076155c8af2$var$Qe) ? !1 : this.sidebarEl.classList.contains($0451e076155c8af2$var$Ge) ? !0 : !this.isMobileView();
    }
    addEventListeners() {
        this.innerToggle.addEventListener("click", ()=>this.toggleOpen()), this.outsideToggle.addEventListener("click", ()=>this.toggleOpen()), this.collapsibles.forEach((t, e)=>{
            let r = t.children[0];
            r && r.tagName === "BUTTON" && r.addEventListener("click", ()=>this.toggleCollapsibleOpen(t, e));
        }), document.addEventListener("econ-sidebar-navigated", (t)=>{
            this.setActiveItems(t.detail?.path), this.isMobileView() && (this.open = !1);
        });
    }
    findActiveCollapsible() {
        this.collapsibles.forEach((t)=>{
            let e = [
                ...t.children
            ].find((r)=>r.tagName === "UL");
            e && e.querySelector(`.${$0451e076155c8af2$var$F}`) && t.classList.add($0451e076155c8af2$var$U);
        });
    }
    setActiveItems(t = window.location.pathname) {
        this.collapsibles.forEach((e)=>{
            e.classList.remove($0451e076155c8af2$var$F);
        }), this.sidebarLinks.forEach((e)=>{
            if (e.getAttribute("href") === t) {
                e.classList.add($0451e076155c8af2$var$F);
                let r = e.closest(".sidebar-collapsible");
                r && r.classList.add($0451e076155c8af2$var$F);
            } else e.classList.remove($0451e076155c8af2$var$F);
        });
    }
    onOpenChange() {
        let t = this.isOpen, e = (r)=>{
            this.sidebarEl.classList.add(r), setTimeout(()=>this.sidebarEl.classList.remove(r), $0451e076155c8af2$var$cn);
        };
        t ? (e($0451e076155c8af2$var$Qi), this.sidebarEl.classList.remove($0451e076155c8af2$var$Qe), this.sidebarEl.classList.add($0451e076155c8af2$var$Ge)) : (e($0451e076155c8af2$var$Zi), this.sidebarEl.classList.remove($0451e076155c8af2$var$Ge), this.sidebarEl.classList.add($0451e076155c8af2$var$Qe));
    }
    toggleOpen() {
        this.open = !this.open;
    }
    toggleCollapsibleOpen(t, e) {
        let r = t.classList.contains($0451e076155c8af2$var$U);
        if (!this.isOpen) {
            this.isOpen = !0, setTimeout(()=>{
                t.classList.add($0451e076155c8af2$var$U);
            }, $0451e076155c8af2$var$cn);
            return;
        }
        r ? (t.classList.remove($0451e076155c8af2$var$U), this.openCollapsibles = $0451e076155c8af2$var$bt(e, this.openCollapsibles)) : (t.classList.add($0451e076155c8af2$var$U), this.openCollapsibles = [
            ...this.openCollapsibles,
            e
        ].filter($0451e076155c8af2$var$vt));
    }
    handleStoredSidebarState() {
        window.addEventListener("beforeunload", ()=>this.writeSidebarStateToLocalStorage());
        try {
            this.openCollapsibles = JSON.parse(localStorage.getItem($0451e076155c8af2$var$un)) || [];
        } catch  {
            this.openCollapsibles = [];
        }
        this.openCollapsibles.forEach((t)=>{
            this.collapsibles[t].classList.add($0451e076155c8af2$var$U);
        });
    }
    writeSidebarStateToLocalStorage() {
        try {
            localStorage.setItem($0451e076155c8af2$var$un, JSON.stringify(this.openCollapsibles)), localStorage.setItem($0451e076155c8af2$var$Ze, JSON.stringify(this.open));
        } catch  {}
    }
}, $0451e076155c8af2$export$4b39ebe2dc5b79d6 = (n = {})=>{
    let t = document.querySelector(".sidebar");
    return t ? new $0451e076155c8af2$var$Xe(t, n) : null;
};
var $0451e076155c8af2$var$Xi = (n, t)=>{
    if (!n || n.nodeType !== 1) return;
    let e = new MutationObserver(t);
    return e.observe(n, {
        childList: !0,
        subtree: !0
    }), e;
}, $0451e076155c8af2$var$fn = "hint", $0451e076155c8af2$var$et = "active", $0451e076155c8af2$var$pn = "origin";
function $0451e076155c8af2$var$ea(n) {
    n.classList.add("slist"), n.setAttribute("role", "list");
    let t = n.children, e = null, r = t.length;
    function l(s) {
        s.draggable = !0, s.setAttribute("role", "listitem"), s.addEventListener("dragstart", function() {
            e = this;
            for (let d of t)d.classList.add(d !== e ? $0451e076155c8af2$var$fn : $0451e076155c8af2$var$pn);
        }), s.addEventListener("dragenter", function() {
            if (this !== e) {
                for (let d of t)d.classList.remove($0451e076155c8af2$var$et);
                this.classList.add($0451e076155c8af2$var$et);
            }
        }), s.addEventListener("dragend", function() {
            for (let d of t)d.classList.remove($0451e076155c8af2$var$fn, $0451e076155c8af2$var$pn, $0451e076155c8af2$var$et);
        }), s.addEventListener("dragover", function(d) {
            d.preventDefault();
        }), s.addEventListener("drop", function(d) {
            if (d.preventDefault(), this !== e) {
                let g = 0, p = 0;
                for(let M = 0; M < t.length; M++)e === t[M] && (g = M), this === t[M] && (p = M);
                g < p ? this.parentNode.insertBefore(e, this.nextSibling) : this.parentNode.insertBefore(e, this);
            }
            e = null;
        });
    }
    for (let s of t)l(s);
    $0451e076155c8af2$var$Xi(n, (s)=>{
        if (s[0].target.children.length > r) {
            for (let d of s[0].addedNodes)l(d);
            r = s[0].target.children.length;
        } else s[0].target.children.length < r && r--;
    });
}
function $0451e076155c8af2$export$a11733f716447e79(n) {
    (n || document).querySelectorAll("[data-sortable]").forEach((e)=>{
        $0451e076155c8af2$var$ea(e);
    });
}
function $0451e076155c8af2$export$eb5ff443d10caf06(n = {}, t = null) {
    let { filter: e, flatpickr: r, formSubmitInterfere: l, liveSearch: s, sidebar: d } = n;
    $0451e076155c8af2$export$34107ba18b519094(t), $0451e076155c8af2$export$7d03d001ca71c65f(t), $0451e076155c8af2$export$70070ff97f1a4ca0(t), $0451e076155c8af2$export$ed8a68ffbc322e67(t, r), $0451e076155c8af2$export$a4d38683f8b8b9ce(t), $0451e076155c8af2$export$f0860aea97f62ce(t, e), $0451e076155c8af2$export$823a7882fb5f7a04(t, l), $0451e076155c8af2$export$aa70e201a98a0ce4(t, s), $0451e076155c8af2$export$60523367a7e10402(t), $0451e076155c8af2$export$e30e8b9f67d70081(t), $0451e076155c8af2$export$4b39ebe2dc5b79d6(d), $0451e076155c8af2$export$a11733f716447e79(t), $0451e076155c8af2$export$a4db3bf4a43c81e3(t);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ /**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ /**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ //#region src/compat/_internal/getTag.ts
/**
* Gets the `toStringTag` of `value`.
*
* @private
* @param {T} value The value to query.
* @returns {string} Returns the `Object.prototype.toString.call` result.
*/ function $c84544af3ff2d0ac$export$dad497fe1f6e27c0(value) {
    if (value == null) return value === void 0 ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}


//#region src/compat/_internal/tags.ts
const $2dd302fafaba5cec$export$d26ba21661f22e80 = "[object RegExp]";
const $2dd302fafaba5cec$export$3901fe85d07ea884 = "[object String]";
const $2dd302fafaba5cec$export$bf8ee812b24655d4 = "[object Number]";
const $2dd302fafaba5cec$export$9edaefd43909686f = "[object Boolean]";
const $2dd302fafaba5cec$export$5893fc07141a22f5 = "[object Arguments]";
const $2dd302fafaba5cec$export$683991a64c0554af = "[object Symbol]";
const $2dd302fafaba5cec$export$6db2fef2b8581597 = "[object Date]";
const $2dd302fafaba5cec$export$75d37f0b54c48ce9 = "[object Map]";
const $2dd302fafaba5cec$export$a37d07ee78eb4569 = "[object Set]";
const $2dd302fafaba5cec$export$30c5ab3238b83eeb = "[object Array]";
const $2dd302fafaba5cec$export$efb7244c657e09d9 = "[object Function]";
const $2dd302fafaba5cec$export$2e30fbc9f2b7b0ee = "[object ArrayBuffer]";
const $2dd302fafaba5cec$export$bc65e3276850bd77 = "[object Object]";
const $2dd302fafaba5cec$export$22cd55b42946d950 = "[object Error]";
const $2dd302fafaba5cec$export$da14abe8375f47ee = "[object DataView]";
const $2dd302fafaba5cec$export$c2cc0c112205cb31 = "[object Uint8Array]";
const $2dd302fafaba5cec$export$512ff6aab0cdbe50 = "[object Uint8ClampedArray]";
const $2dd302fafaba5cec$export$4e4c26804f20e52f = "[object Uint16Array]";
const $2dd302fafaba5cec$export$f5d2c16049863c6c = "[object Uint32Array]";
const $2dd302fafaba5cec$export$f9d61a38957fda15 = "[object BigUint64Array]";
const $2dd302fafaba5cec$export$91c7bbbd3303f2e7 = "[object Int8Array]";
const $2dd302fafaba5cec$export$72d152e068382569 = "[object Int16Array]";
const $2dd302fafaba5cec$export$222c6a8899454b8e = "[object Int32Array]";
const $2dd302fafaba5cec$export$16916807c04c97d7 = "[object BigInt64Array]";
const $2dd302fafaba5cec$export$6acb72c43d6c58de = "[object Float32Array]";
const $2dd302fafaba5cec$export$64993ccc604584f0 = "[object Float64Array]";


//#region src/predicate/isPrimitive.ts
/**
* Checks whether a value is a JavaScript primitive.
* JavaScript primitives include null, undefined, strings, numbers, booleans, symbols, and bigints.
*
* @param value The value to check.
* @returns Returns true if `value` is a primitive, false otherwise.
*
* @example
* isPrimitive(null); // true
* isPrimitive(undefined); // true
* isPrimitive('123'); // true
* isPrimitive(false); // true
* isPrimitive(true); // true
* isPrimitive(Symbol('a')); // true
* isPrimitive(123n); // true
* isPrimitive({}); // false
* isPrimitive(new Date()); // false
* isPrimitive(new Map()); // false
* isPrimitive(new Set()); // false
* isPrimitive([1, 2, 3]); // false
*/ function $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c(value) {
    return value == null || typeof value !== "object" && typeof value !== "function";
}


//#region src/predicate/isTypedArray.ts
/**
* Checks if a value is a TypedArray.
* @param x The value to check.
* @returns Returns true if `x` is a TypedArray, false otherwise.
*
* @example
* const arr = new Uint8Array([1, 2, 3]);
* isTypedArray(arr); // true
*
* const regularArray = [1, 2, 3];
* isTypedArray(regularArray); // false
*
* const buffer = new ArrayBuffer(16);
* isTypedArray(buffer); // false
*/ function $616fcc0d104e7da5$export$b119cc7e1840e59c(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


//#region src/compat/_internal/getSymbols.ts
function $889d2deffff707be$export$35a4784e7aa54e28(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}




//#region src/_internal/globalThis.ts
const $3c29c4e3e125982c$export$5bd27d02d683fc4f = typeof globalThis === "object" && globalThis || typeof window === "object" && window || typeof self === "object" && self || typeof $parcel$global === "object" && $parcel$global || function() {
    return this;
}();


//#region src/predicate/isBuffer.ts
/**
* Checks if the given value is a Buffer instance.
*
* This function tests whether the provided value is an instance of Buffer.
* It returns `true` if the value is a Buffer, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `Buffer`.
*
* @param x - The value to check if it is a Buffer.
* @returns Returns `true` if `x` is a Buffer, else `false`.
*
* @example
* const buffer = Buffer.from("test");
* console.log(isBuffer(buffer)); // true
*
* const notBuffer = "not a buffer";
* console.log(isBuffer(notBuffer)); // false
*/ function $9e25127241ed1cb9$export$a7884ebc965f8f54(x) {
    return typeof (0, $3c29c4e3e125982c$export$5bd27d02d683fc4f).Buffer !== "undefined" && (0, $3c29c4e3e125982c$export$5bd27d02d683fc4f).Buffer.isBuffer(x);
}


//#region src/object/cloneDeepWith.ts
/**
* Deeply clones the given object.
*
* You can customize the deep cloning process using the `cloneValue` function.
* The function takes the current value `value`, the property name `key`, and the entire object `obj` as arguments.
* If the function returns a value, that value is used;
* if it returns `undefined`, the default cloning method is used.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @param [cloneValue] - A function to customize the cloning process.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeepWith(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an object with a customizer
* const obj = { a: 1, b: 2 };
* const clonedObj = cloneDeepWith(obj, (value) => {
*   if (typeof value === 'number') {
*     return value * 2; // Double the number
*   }
* });
* console.log(clonedObj); // { a: 2, b: 4 }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an array with a customizer
* const arr = [1, 2, 3];
* const clonedArr = cloneDeepWith(arr, (value) => {
*   if (typeof value === 'number') {
*     return value + 1; // Increment each number
*   }
* });
* console.log(clonedArr); // [2, 3, 4]
* console.log(clonedArr === arr); // false
*/ function $2998c9886974d5e9$export$684657552801b6ad(obj, cloneValue) {
    return $2998c9886974d5e9$export$c02997b71e1192aa(obj, void 0, obj, /* @__PURE__ */ new Map(), cloneValue);
}
function $2998c9886974d5e9$export$c02997b71e1192aa(valueToClone, keyToClone, objectToClone, stack = /* @__PURE__ */ new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== void 0) return cloned;
    if ((0, $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c)(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $2998c9886974d5e9$export$c02997b71e1192aa(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, "index")) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, "input")) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = /* @__PURE__ */ new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $2998c9886974d5e9$export$c02997b71e1192aa(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = /* @__PURE__ */ new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($2998c9886974d5e9$export$c02997b71e1192aa(value, void 0, objectToClone, stack, cloneValue));
        return result;
    }
    if ((0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(valueToClone)) return valueToClone.subarray();
    if ((0, $616fcc0d104e7da5$export$b119cc7e1840e59c)(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $2998c9886974d5e9$export$c02997b71e1192aa(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== "undefined" && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== "undefined" && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== "undefined" && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = structuredClone(valueToClone);
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        result.constructor = valueToClone.constructor;
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === "object" && $2998c9886974d5e9$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $2998c9886974d5e9$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $2998c9886974d5e9$export$65cf5700d290d9fa(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...(0, $889d2deffff707be$export$35a4784e7aa54e28)(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $2998c9886974d5e9$export$c02997b71e1192aa(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $2998c9886974d5e9$var$isCloneableObject(object) {
    switch((0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(object)){
        case 0, $2dd302fafaba5cec$export$5893fc07141a22f5:
        case 0, $2dd302fafaba5cec$export$30c5ab3238b83eeb:
        case 0, $2dd302fafaba5cec$export$2e30fbc9f2b7b0ee:
        case 0, $2dd302fafaba5cec$export$da14abe8375f47ee:
        case 0, $2dd302fafaba5cec$export$9edaefd43909686f:
        case 0, $2dd302fafaba5cec$export$6db2fef2b8581597:
        case 0, $2dd302fafaba5cec$export$6acb72c43d6c58de:
        case 0, $2dd302fafaba5cec$export$64993ccc604584f0:
        case 0, $2dd302fafaba5cec$export$91c7bbbd3303f2e7:
        case 0, $2dd302fafaba5cec$export$72d152e068382569:
        case 0, $2dd302fafaba5cec$export$222c6a8899454b8e:
        case 0, $2dd302fafaba5cec$export$75d37f0b54c48ce9:
        case 0, $2dd302fafaba5cec$export$bf8ee812b24655d4:
        case 0, $2dd302fafaba5cec$export$bc65e3276850bd77:
        case 0, $2dd302fafaba5cec$export$d26ba21661f22e80:
        case 0, $2dd302fafaba5cec$export$a37d07ee78eb4569:
        case 0, $2dd302fafaba5cec$export$3901fe85d07ea884:
        case 0, $2dd302fafaba5cec$export$683991a64c0554af:
        case 0, $2dd302fafaba5cec$export$c2cc0c112205cb31:
        case 0, $2dd302fafaba5cec$export$512ff6aab0cdbe50:
        case 0, $2dd302fafaba5cec$export$4e4c26804f20e52f:
        case 0, $2dd302fafaba5cec$export$f5d2c16049863c6c:
            return true;
        default:
            return false;
    }
}


//#region src/compat/object/cloneDeepWith.ts
/**
* Creates a deep clone of the given object using a customizer function.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @param [cloneValue] - A function to customize the cloning process.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeepWith(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an object with a customizer
* const obj = { a: 1, b: 2 };
* const clonedObj = cloneDeepWith(obj, (value) => {
*   if (typeof value === 'number') {
*     return value * 2; // Double the number
*   }
* });
* console.log(clonedObj); // { a: 2, b: 4 }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an array with a customizer
* const arr = [1, 2, 3];
* const clonedArr = cloneDeepWith(arr, (value) => {
*   if (typeof value === 'number') {
*     return value + 1; // Increment each number
*   }
* });
* console.log(clonedArr); // [2, 3, 4]
* console.log(clonedArr === arr); // false
*/ function $850a6c1e0528b9df$export$684657552801b6ad(obj, customizer) {
    return (0, $2998c9886974d5e9$export$684657552801b6ad)(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== void 0) return cloned;
        if (typeof obj !== "object") return;
        if ((0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(obj) === "[object Object]" && typeof obj.constructor !== "function") {
            const result = {};
            stack.set(obj, result);
            (0, $2998c9886974d5e9$export$65cf5700d290d9fa)(result, obj, object, stack);
            return result;
        }
        switch(Object.prototype.toString.call(obj)){
            case 0, $2dd302fafaba5cec$export$bf8ee812b24655d4:
            case 0, $2dd302fafaba5cec$export$3901fe85d07ea884:
            case 0, $2dd302fafaba5cec$export$9edaefd43909686f:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    (0, $2998c9886974d5e9$export$65cf5700d290d9fa)(result, obj);
                    return result;
                }
            case 0, $2dd302fafaba5cec$export$5893fc07141a22f5:
                {
                    const result = {};
                    (0, $2998c9886974d5e9$export$65cf5700d290d9fa)(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return;
        }
    });
}

//#region src/compat/predicate/isPlainObject.ts
/**
* Checks if a given value is a plain object.
*
* A plain object is an object created by the `{}` literal, `new Object()`, or
* `Object.create(null)`.
*
* This function also handles objects with custom
* `Symbol.toStringTag` properties.
*
* `Symbol.toStringTag` is a built-in symbol that a constructor can use to customize the
* default string description of objects.
*
* @param [object] - The value to check.
* @returns True if the value is a plain object, otherwise false.
*
* @example
* console.log(isPlainObject({})); // true
* console.log(isPlainObject([])); // false
* console.log(isPlainObject(null)); // false
* console.log(isPlainObject(Object.create(null))); // true
* console.log(isPlainObject(new Map())); // false
*/ function $cfdff0c7ad4315d7$export$53b83ca8eaab0383(object) {
    if (typeof object !== "object") return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== "[object Object]") {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        if (!Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}


//#region src/compat/predicate/isObjectLike.ts
/**
* Checks if the given value is object-like.
*
* A value is object-like if its type is object and it is not null.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an object-like value.
*
* @param value - The value to test if it is an object-like.
* @returns `true` if the value is an object-like, `false` otherwise.
*
* @example
* const value1 = { a: 1 };
* const value2 = [1, 2, 3];
* const value3 = 'abc';
* const value4 = () => {};
* const value5 = null;
*
* console.log(isObjectLike(value1)); // true
* console.log(isObjectLike(value2)); // true
* console.log(isObjectLike(value3)); // false
* console.log(isObjectLike(value4)); // false
* console.log(isObjectLike(value5)); // false
*/ function $5789c959de4058ad$export$c10d0b04eaa80a43(value) {
    return typeof value === "object" && value !== null;
}


//#region src/compat/predicate/isElement.ts
/**
* Checks if `value` is likely a DOM element.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a DOM element, else `false`.
*
* @example
* console.log(isElement(document.body)); // true
* console.log(isElement('<body>')); // false
*/ function $7ea5355649bb40ad$export$45a5e7f76e0caa8d(value) {
    return (0, $5789c959de4058ad$export$c10d0b04eaa80a43)(value) && value.nodeType === 1 && !(0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(value);
}

//#region src/compat/predicate/isFunction.ts
/**
* Checks if `value` is a function.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a function, else `false`.
*
* @example
* isFunction(Array.prototype.slice); // true
* isFunction(async function () {}); // true
* isFunction(function* () {}); // true
* isFunction(Proxy); // true
* isFunction(Int8Array); // true
*/ function $943eba72ca89f82b$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

//#region src/compat/predicate/isObject.ts
/**
* Checks if the given value is an object. An object is a value that is
* not a primitive type (string, number, boolean, symbol, null, or undefined).
*
* This function tests whether the provided value is an object or not.
* It returns `true` if the value is an object, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an object value.
*
* @param value - The value to check if it is an object.
* @returns `true` if the value is an object, `false` otherwise.
*
* @example
* const value1 = {};
* const value2 = [1, 2, 3];
* const value3 = () => {};
* const value4 = null;
*
* console.log(isObject(value1)); // true
* console.log(isObject(value2)); // true
* console.log(isObject(value3)); // true
* console.log(isObject(value4)); // false
*/ function $f5c24f51e6d4a764$export$a6cdc56e425d0d0a(value) {
    return value !== null && (typeof value === "object" || typeof value === "function");
}

//#region src/compat/predicate/isString.ts
/**
* Checks if a given value is string.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `string`.
*
* @param value The value to check if it is string.
* @returns Returns `true` if `value` is a string, else `false`.
*
* @example
* const value1 = 'abc';
* const value2 = 123;
* const value3 = true;
*
* console.log(isString(value1)); // true
* console.log(isString(value2)); // false
* console.log(isString(value3)); // false
*/ function $d1398c5596cf9556$export$844ec244b1367d54(value) {
    return typeof value === "string" || value instanceof String;
}

//#region src/function/noop.ts
/**
* A no-operation function that does nothing.
* This can be used as a placeholder or default function.
*
* @example
* noop(); // Does nothing
*
* @returns This function does not return anything.
*/ function $b04d7835dd3a1b71$export$8793edee2d425525() {}





//#region src/object/clone.ts
/**
* Creates a shallow clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A shallow clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = clone(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = clone(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = clone(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*/ function $12e9422b5fc7678c$export$9cd59f9826255e47(obj) {
    if ((0, $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c)(obj)) return obj;
    if (Array.isArray(obj) || (0, $616fcc0d104e7da5$export$b119cc7e1840e59c)(obj) || obj instanceof ArrayBuffer || typeof SharedArrayBuffer !== "undefined" && obj instanceof SharedArrayBuffer) return obj.slice(0);
    const prototype = Object.getPrototypeOf(obj);
    if (prototype == null) return Object.assign(Object.create(prototype), obj);
    const Constructor = prototype.constructor;
    if (obj instanceof Date || obj instanceof Map || obj instanceof Set) return new Constructor(obj);
    if (obj instanceof RegExp) {
        const newRegExp = new Constructor(obj);
        newRegExp.lastIndex = obj.lastIndex;
        return newRegExp;
    }
    if (obj instanceof DataView) return new Constructor(obj.buffer.slice(0));
    if (obj instanceof Error) {
        let newError;
        if (obj instanceof AggregateError) newError = new Constructor(obj.errors, obj.message, {
            cause: obj.cause
        });
        else newError = new Constructor(obj.message, {
            cause: obj.cause
        });
        newError.stack = obj.stack;
        Object.assign(newError, obj);
        return newError;
    }
    if (typeof File !== "undefined" && obj instanceof File) return new Constructor([
        obj
    ], obj.name, {
        type: obj.type,
        lastModified: obj.lastModified
    });
    if (typeof obj === "object") return Object.assign(Object.create(prototype), obj);
    return obj;
}




//#region src/_internal/isUnsafeProperty.ts
/**
* Checks if a property key is unsafe to access or copy directly.
*
* This function is used in functions like `get`, `unset`, and `merge` to prevent
* prototype pollution attacks by identifying `__proto__`, which modifies the object's
* prototype chain. `constructor` and `prototype` stay accessible here because lodash
* keeps reads of them unrestricted; write paths use `isUnsafeToWriteProperty` instead,
* which also blocks those keys.
*
* @param key - The property key to check
* @returns `true` if the property is unsafe to access directly, `false` otherwise
* @internal
*/ function $d0b6ac487e334212$export$1511747d5f3dab08(key) {
    return key === "__proto__";
}




//#region src/compat/object/cloneDeep.ts
/**
* Creates a deep clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = clone(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = cloneDeep(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an array with nested objects
* const arr = [1, { a: 1 }, [1, 2, 3]];
* const clonedArr = cloneDeep(arr);
* arr[1].a = 2;
* console.log(arr); // [1, { a: 2 }, [1, 2, 3]]
* console.log(clonedArr); // [1, { a: 1 }, [1, 2, 3]]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = cloneDeep(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an object with nested objects
* const obj = { a: 1, b: { c: 1 } };
* const clonedObj = cloneDeep(obj);
* obj.b.c = 2;
* console.log(obj); // { a: 1, b: { c: 2 } }
* console.log(clonedObj); // { a: 1, b: { c: 1 } }
* console.log(clonedObj === obj); // false
*/ function $99832fb02f3659fb$export$629a2bd3f5a49ecc(obj) {
    return (0, $850a6c1e0528b9df$export$684657552801b6ad)(obj);
}



//#region src/compat/predicate/isArguments.ts
/**
* Checks if the given value is an arguments object.
*
* This function tests whether the provided value is an arguments object or not.
* It returns `true` if the value is an arguments object, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an arguments object.
*
* @param value - The value to test if it is an arguments object.
* @returns `true` if the value is an arguments, `false` otherwise.
*
* @example
* const args = (function() { return arguments; })();
* const strictArgs = (function() { 'use strict'; return arguments; })();
* const value = [1, 2, 3];
*
* console.log(isArguments(args)); // true
* console.log(isArguments(strictArgs)); // true
* console.log(isArguments(value)); // false
*/ function $01e9c819d0970ac4$export$dbbb9d8cd6fff001(value) {
    return value !== null && typeof value === "object" && (0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(value) === "[object Arguments]";
}



//#region src/predicate/isLength.ts
/**
* Checks if a given value is a valid length.
*
* A valid length is of type `number`, is a non-negative integer, and is less than or equal to
* JavaScript's maximum safe integer (`Number.MAX_SAFE_INTEGER`).
* It returns `true` if the value is a valid length, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the
* argument to a valid length (`number`).
*
* @param value The value to check.
* @returns Returns `true` if `value` is a valid length, else `false`.
*
* @example
* isLength(0); // true
* isLength(42); // true
* isLength(-1); // false
* isLength(1.5); // false
* isLength(Number.MAX_SAFE_INTEGER); // true
* isLength(Number.MAX_SAFE_INTEGER + 1); // false
*/ function $5b441896c9deaaad$export$38db3d147cb3433(value) {
    return Number.isSafeInteger(value) && value >= 0;
}


//#region src/compat/predicate/isArrayLike.ts
/**
* Checks if `value` is array-like.
*
* @param value The value to check.
* @returns Returns `true` if `value` is array-like, else `false`.
*
* @example
* isArrayLike([1, 2, 3]); // true
* isArrayLike('abc'); // true
* isArrayLike({ 0: 'a', length: 1 }); // true
* isArrayLike({}); // false
* isArrayLike(null); // false
* isArrayLike(undefined); // false
*/ function $63d5569bd28740d6$export$1e2f57719e155213(value) {
    return value != null && typeof value !== "function" && (0, $5b441896c9deaaad$export$38db3d147cb3433)(value.length);
}



//#region src/compat/predicate/isArrayLikeObject.ts
/**
* Checks if the given value is a non-primitive, array-like object.
*
* @param value The value to check.
* @returns `true` if the value is a non-primitive, array-like object, `false` otherwise.
*
* @example
* isArrayLikeObject([1, 2, 3]); // true
* isArrayLikeObject({ 0: 'a', length: 1 }); // true
* isArrayLikeObject('abc'); // false
* isArrayLikeObject(()=>{}); // false
*/ function $bd2751da30a6b0ea$export$490a4eac29925978(value) {
    return (0, $5789c959de4058ad$export$c10d0b04eaa80a43)(value) && (0, $63d5569bd28740d6$export$1e2f57719e155213)(value);
}



//#region src/compat/predicate/isTypedArray.ts
/**
* Checks if a value is a TypedArray.
* @param x The value to check.
* @returns Returns true if `x` is a TypedArray, false otherwise.
*
* @example
* const arr = new Uint8Array([1, 2, 3]);
* isTypedArray(arr); // true
*
* const regularArray = [1, 2, 3];
* isTypedArray(regularArray); // false
*
* const buffer = new ArrayBuffer(16);
* isTypedArray(buffer); // false
*/ function $4333556256d3d0c3$export$b119cc7e1840e59c(x) {
    return (0, $616fcc0d104e7da5$export$b119cc7e1840e59c)(x);
}


//#region src/compat/object/mergeWith.ts
/**
* Merges the properties of one or more source objects into the target object using a customizer function.
*
* This function performs a deep merge, recursively merging nested objects and arrays.
* If a property in the source object is an array or object and the corresponding property in the target object is also an array or object, they will be merged.
* If a property in the source object is `undefined`, it will not overwrite a defined property in the target object.
*
* You can provide a custom `merge` function to control how properties are merged. The `merge` function is called for each property that is being merged and receives the following arguments:
*
* - `targetValue`: The current value of the property in the target object.
* - `sourceValue`: The value of the property in the source object.
* - `key`: The key of the property being merged.
* - `target`: The target object.
* - `source`: The source object.
* - `stack`: A `Map` used to keep track of objects that have already been processed to handle circular references.
*
* The `merge` function should return the value to be set in the target object. If it returns `undefined`, a default deep merge will be applied for arrays and objects.
*
* The function can handle multiple source objects and will merge them all into the target object.
*
* @param object - The target object into which the source object properties will be merged. This object is modified in place.
* @param otherArgs - Additional source objects to merge into the target object, including the custom `merge` function.
* @returns The updated target object with properties from the source object(s) merged in.
*
* @example
* const target = { a: 1, b: 2 };
* const source = { b: 3, c: 4 };
*
* mergeWith(target, source, (targetValue, sourceValue) => {
*   if (typeof targetValue === 'number' && typeof sourceValue === 'number') {
*     return targetValue + sourceValue;
*   }
* });
* // Returns { a: 1, b: 5, c: 4 }
* @example
* const target = { a: [1], b: [2] };
* const source = { a: [3], b: [4] };
*
* const result = mergeWith(target, source, (objValue, srcValue) => {
*   if (Array.isArray(objValue)) {
*     return objValue.concat(srcValue);
*   }
* });
*
* expect(result).toEqual({ a: [1, 3], b: [2, 4] });
*/ function $8bb08980612c5c43$export$2ee76fde9ffe109d(object, ...otherArgs) {
    const sources = otherArgs.slice(0, -1);
    const merge = otherArgs[otherArgs.length - 1];
    let result = object;
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        result = $8bb08980612c5c43$var$mergeWithDeep(result, source, merge, /* @__PURE__ */ new Map());
    }
    return result;
}
function $8bb08980612c5c43$var$mergeWithDeep(target, source, merge, stack) {
    if ((0, $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c)(target)) target = Object(target);
    if (source == null || typeof source !== "object") return target;
    if (stack.has(source)) return (0, $12e9422b5fc7678c$export$9cd59f9826255e47)(stack.get(source));
    stack.set(source, target);
    if (Array.isArray(source)) {
        source = source.slice();
        for(let i = 0; i < source.length; i++)if (!(i in source)) source[i] = void 0;
    }
    const sourceKeys = [
        ...Object.keys(source),
        ...(0, $889d2deffff707be$export$35a4784e7aa54e28)(source)
    ];
    for(let i = 0; i < sourceKeys.length; i++){
        const key = sourceKeys[i];
        if ((0, $d0b6ac487e334212$export$1511747d5f3dab08)(key)) continue;
        let sourceValue = source[key];
        let targetValue = target[key];
        if ((0, $01e9c819d0970ac4$export$dbbb9d8cd6fff001)(sourceValue)) sourceValue = {
            ...sourceValue
        };
        if ((0, $01e9c819d0970ac4$export$dbbb9d8cd6fff001)(targetValue)) targetValue = {
            ...targetValue
        };
        if ((0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(sourceValue)) sourceValue = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(sourceValue);
        if (Array.isArray(sourceValue)) {
            if (Array.isArray(targetValue)) {
                const cloned = [];
                const targetKeys = Reflect.ownKeys(targetValue);
                for(let i = 0; i < targetKeys.length; i++){
                    const targetKey = targetKeys[i];
                    cloned[targetKey] = targetValue[targetKey];
                }
                targetValue = cloned;
            } else if ((0, $bd2751da30a6b0ea$export$490a4eac29925978)(targetValue)) {
                const cloned = [];
                for(let i = 0; i < targetValue.length; i++)cloned[i] = targetValue[i];
                targetValue = cloned;
            } else targetValue = [];
        }
        const merged = merge(targetValue, sourceValue, key, target, source, stack);
        if (merged !== void 0) target[key] = merged;
        else if (Array.isArray(sourceValue)) target[key] = $8bb08980612c5c43$var$mergeWithDeep(targetValue, sourceValue, merge, stack);
        else if ((0, $5789c959de4058ad$export$c10d0b04eaa80a43)(targetValue) && (0, $5789c959de4058ad$export$c10d0b04eaa80a43)(sourceValue) && ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(targetValue) || (0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(sourceValue) || (0, $4333556256d3d0c3$export$b119cc7e1840e59c)(targetValue) || (0, $4333556256d3d0c3$export$b119cc7e1840e59c)(sourceValue))) target[key] = $8bb08980612c5c43$var$mergeWithDeep(targetValue, sourceValue, merge, stack);
        else if (targetValue == null && (0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(sourceValue)) target[key] = $8bb08980612c5c43$var$mergeWithDeep({}, sourceValue, merge, stack);
        else if (targetValue == null && (0, $4333556256d3d0c3$export$b119cc7e1840e59c)(sourceValue)) target[key] = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(sourceValue);
        else if (targetValue === void 0 || sourceValue !== void 0) target[key] = sourceValue;
    }
    return target;
}


//#region src/compat/object/merge.ts
/**
* Merges the properties of one or more source objects into the target object.
*
* This function performs a deep merge, recursively merging nested objects and arrays.
* If a property in the source object is an array or object and the corresponding property in the target object is also an array or object, they will be merged.
* If a property in the source object is `undefined`, it will not overwrite a defined property in the target object.
*
* The function can handle multiple source objects and will merge them all into the target object.
*
* @param object - The target object into which the source object properties will be merged. This object is modified in place.
* @param sources - The source objects whose properties will be merged into the target object.
* @returns The updated target object with properties from the source object(s) merged in.
*
* @example
* const target = { a: 1, b: { x: 1, y: 2 } };
* const source = { b: { y: 3, z: 4 }, c: 5 };
*
* const result = merge(target, source);
* console.log(result);
* // Output: { a: 1, b: { x: 1, y: 3, z: 4 }, c: 5 }
*
* @example
* const target = { a: [1, 2], b: { x: 1 } };
* const source = { a: [3], b: { y: 2 } };
*
* const result = merge(target, source);
* console.log(result);
* // Output: { a: [3], b: { x: 1, y: 2 } }
*
* @example
* const target = { a: null };
* const source = { a: [1, 2, 3] };
*
* const result = merge(target, source);
* console.log(result);
* // Output: { a: [1, 2, 3] }
*/ function $b1d877320958e43c$export$4950aa0f605343fb(object, ...sources) {
    return (0, $8bb08980612c5c43$export$2ee76fde9ffe109d)(object, ...sources, (0, $b04d7835dd3a1b71$export$8793edee2d425525));
}


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A helper (module) giving an access to the global DOM objects such as `window` and
* `document`. Accessing these objects using this helper allows easy and bulletproof
* testing, i.e. stubbing native properties:
*
* ```ts
* import { global } from 'ckeditor5';
*
* // This stub will work for any code using global module.
* vi.spyOn( global, 'window', 'get' ).mockReturnValue( {
* 	innerWidth: 10000
* } );
*
* console.log( global.window.innerWidth );
* ```
*/ let $c7bc2cb7e2db0227$export$90b4d2ff6acb88af;
try {
    $c7bc2cb7e2db0227$export$90b4d2ff6acb88af = {
        window: window,
        document: document
    };
} catch  {
    /* v8 ignore start -- @preserve */ $c7bc2cb7e2db0227$export$90b4d2ff6acb88af = {
        window: {},
        document: {}
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/env
*/ /**
* Safely returns `userAgent` from browser's navigator API in a lower case.
* If navigator API is not available it will return an empty string.
*
* @internal
*/ function $c7bc2cb7e2db0227$export$ec33df8f0a07203c() {
    try {
        return navigator.userAgent.toLowerCase();
    } catch  {
        return "";
    }
}
const $c7bc2cb7e2db0227$var$userAgent = /* #__PURE__ */ $c7bc2cb7e2db0227$export$ec33df8f0a07203c();
/**
* A namespace containing environment and browser information.
*/ const $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3 = {
    isMac: /* #__PURE__ */ $c7bc2cb7e2db0227$export$be42ce2f8b7f6528($c7bc2cb7e2db0227$var$userAgent),
    isWindows: /* #__PURE__ */ $c7bc2cb7e2db0227$export$947a840639ff1bf5($c7bc2cb7e2db0227$var$userAgent),
    isGecko: /* #__PURE__ */ $c7bc2cb7e2db0227$export$7fd448e638e933ba($c7bc2cb7e2db0227$var$userAgent),
    isSafari: /* #__PURE__ */ $c7bc2cb7e2db0227$export$49b49e56149f3df2($c7bc2cb7e2db0227$var$userAgent),
    isiOS: /* #__PURE__ */ $c7bc2cb7e2db0227$export$f28c28fb521b0c7d($c7bc2cb7e2db0227$var$userAgent),
    isAndroid: /* #__PURE__ */ $c7bc2cb7e2db0227$export$5da3046e686cbd11($c7bc2cb7e2db0227$var$userAgent),
    isBlink: /* #__PURE__ */ $c7bc2cb7e2db0227$export$782c328869a27dbc($c7bc2cb7e2db0227$var$userAgent),
    get isMediaForcedColors () {
        return $c7bc2cb7e2db0227$export$fc559d81970d3c9();
    },
    get isMotionReduced () {
        return $c7bc2cb7e2db0227$export$e3310e8dfc876383();
    },
    features: {
        isRegExpUnicodePropertySupported: /* #__PURE__ */ $c7bc2cb7e2db0227$export$3215625eff40c145()
    }
};
/**
* Checks if User Agent represented by the string is running on Macintosh.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is running on Macintosh or not.
*/ function $c7bc2cb7e2db0227$export$be42ce2f8b7f6528(userAgent) {
    return userAgent.indexOf("macintosh") > -1;
}
/**
* Checks if User Agent represented by the string is running on Windows.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is running on Windows or not.
*/ function $c7bc2cb7e2db0227$export$947a840639ff1bf5(userAgent) {
    return userAgent.indexOf("windows") > -1;
}
/**
* Checks if User Agent represented by the string is Firefox (Gecko).
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is Firefox or not.
*/ function $c7bc2cb7e2db0227$export$7fd448e638e933ba(userAgent) {
    return !!userAgent.match(/gecko\/\d+/);
}
/**
* Checks if User Agent represented by the string is Safari.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is Safari or not.
*/ function $c7bc2cb7e2db0227$export$49b49e56149f3df2(userAgent) {
    return userAgent.indexOf(" applewebkit/") > -1 && userAgent.indexOf("chrome") === -1;
}
/**
* Checks if User Agent represented by the string is running in iOS.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is running in iOS or not.
*/ function $c7bc2cb7e2db0227$export$f28c28fb521b0c7d(userAgent) {
    return !!userAgent.match(/iphone|ipad/i) || $c7bc2cb7e2db0227$export$be42ce2f8b7f6528(userAgent) && navigator.maxTouchPoints > 0;
}
/**
* Checks if User Agent represented by the string is Android mobile device.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is Safari or not.
*/ function $c7bc2cb7e2db0227$export$5da3046e686cbd11(userAgent) {
    return userAgent.indexOf("android") > -1;
}
/**
* Checks if User Agent represented by the string is Blink engine.
*
* @internal
* @param userAgent **Lowercase** `navigator.userAgent` string.
* @returns Whether User Agent is Blink engine or not.
*/ function $c7bc2cb7e2db0227$export$782c328869a27dbc(userAgent) {
    return userAgent.indexOf("chrome/") > -1 && userAgent.indexOf("edge/") < 0;
}
/**
* Checks if the current environment supports ES2018 Unicode properties like `\p{P}` or `\p{L}`.
* More information about unicode properties might be found
* [in Unicode Standard Annex #44](https://www.unicode.org/reports/tr44/#GC_Values_Table).
*
* @internal
*/ function $c7bc2cb7e2db0227$export$3215625eff40c145() {
    let isSupported = false;
    try {
        isSupported = "\u0107".search(new RegExp("[\\p{L}]", "u")) === 0;
    } catch  {}
    return isSupported;
}
/**
* Checks if the user agent has enabled a forced colors mode (e.g. Windows High Contrast mode).
*
* Returns `false` in environments where `window` global object is not available.
*
* @internal
*/ function $c7bc2cb7e2db0227$export$fc559d81970d3c9() {
    return $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.matchMedia ? $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.matchMedia("(forced-colors: active)").matches : false;
}
/**
* Checks if the user enabled "prefers reduced motion" setting in browser.
*
* Returns `false` in environments where `window` global object is not available.
*
* @internal
*/ function $c7bc2cb7e2db0227$export$e3310e8dfc876383() {
    return $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.matchMedia ? $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.matchMedia("(prefers-reduced-motion)").matches : false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Finds positions of the first and last change in the given string/array and generates a set of changes:
*
* ```ts
* fastDiff( '12a', '12xyza' );
* // [ { index: 2, type: 'insert', values: [ 'x', 'y', 'z' ] } ]
*
* fastDiff( '12a', '12aa' );
* // [ { index: 3, type: 'insert', values: [ 'a' ] } ]
*
* fastDiff( '12xyza', '12a' );
* // [ { index: 2, type: 'delete', howMany: 3 } ]
*
* fastDiff( [ '1', '2', 'a', 'a' ], [ '1', '2', 'a' ] );
* // [ { index: 3, type: 'delete', howMany: 1 } ]
*
* fastDiff( [ '1', '2', 'a', 'b', 'c', '3' ], [ '2', 'a', 'b' ] );
* // [ { index: 0, type: 'insert', values: [ '2', 'a', 'b' ] }, { index: 3, type: 'delete', howMany: 6 } ]
* ```
*
* Passed arrays can contain any type of data, however to compare them correctly custom comparator function
* should be passed as a third parameter:
*
* ```ts
* fastDiff( [ { value: 1 }, { value: 2 } ], [ { value: 1 }, { value: 3 } ], ( a, b ) => {
* 	return a.value === b.value;
* } );
* // [ { index: 1, type: 'insert', values: [ { value: 3 } ] }, { index: 2, type: 'delete', howMany: 1 } ]
* ```
*
* The resulted set of changes can be applied to the input in order to transform it into the output, for example:
*
* ```ts
* let input = '12abc3';
* const output = '2ab';
* const changes = fastDiff( input, output );
*
* changes.forEach( change => {
* 	if ( change.type == 'insert' ) {
* 		input = input.substring( 0, change.index ) + change.values.join( '' ) + input.substring( change.index );
* 	} else if ( change.type == 'delete' ) {
* 		input = input.substring( 0, change.index ) + input.substring( change.index + change.howMany );
* 	}
* } );
*
* // input equals output now
* ```
*
* or in case of arrays:
*
* ```ts
* let input = [ '1', '2', 'a', 'b', 'c', '3' ];
* const output = [ '2', 'a', 'b' ];
* const changes = fastDiff( input, output );
*
* changes.forEach( change => {
* 	if ( change.type == 'insert' ) {
* 		input = input.slice( 0, change.index ).concat( change.values, input.slice( change.index ) );
* 	} else if ( change.type == 'delete' ) {
* 		input = input.slice( 0, change.index ).concat( input.slice( change.index + change.howMany ) );
* 	}
* } );
*
* // input equals output now
* ```
*
* By passing `true` as the fourth parameter (`atomicChanges`) the output of this function will become compatible with
* the {@link module:utils/diff~diff `diff()`} function:
*
* ```ts
* fastDiff( '12a', '12xyza', undefined, true );
* // [ 'equal', 'equal', 'insert', 'insert', 'insert', 'equal' ]
* ```
*
* The default output format of this function is compatible with the output format of
* {@link module:utils/difftochanges~diffToChanges `diffToChanges()`}. The `diffToChanges()` input format is, in turn,
* compatible with the output of {@link module:utils/diff~diff `diff()`}:
*
* ```ts
* const a = '1234';
* const b = '12xyz34';
*
* // Both calls will return the same results (grouped changes format).
* fastDiff( a, b );
* diffToChanges( diff( a, b ) );
*
* // Again, both calls will return the same results (atomic changes format).
* fastDiff( a, b, undefined, true );
* diff( a, b );
* ```
*
* @typeParam T The type of array elements.
* @typeParam AtomicChanges The type of `atomicChanges` parameter (selects the result type).
* @param a Input array or string.
* @param b Input array or string.
* @param cmp Optional function used to compare array values, by default `===` (strict equal operator) is used.
* @param atomicChanges Whether an array of `inset|delete|equal` operations should
* be returned instead of changes set. This makes this function compatible with {@link module:utils/diff~diff `diff()`}.
* Defaults to `false`.
* @returns Array of changes. The elements are either {@link module:utils/diff~DiffResult} or {@link module:utils/difftochanges~Change},
* depending on `atomicChanges` parameter.
*/ function $c7bc2cb7e2db0227$export$b3d8c5da214d9c82(a, b, cmp, atomicChanges) {
    cmp = cmp || function(a, b) {
        return a === b;
    };
    const arrayA = Array.isArray(a) ? a : Array.prototype.slice.call(a);
    const arrayB = Array.isArray(b) ? b : Array.prototype.slice.call(b);
    const changeIndexes = $c7bc2cb7e2db0227$var$findChangeBoundaryIndexes(arrayA, arrayB, cmp);
    return atomicChanges ? $c7bc2cb7e2db0227$var$changeIndexesToAtomicChanges(changeIndexes, arrayB.length) : $c7bc2cb7e2db0227$var$changeIndexesToChanges(arrayB, changeIndexes);
}
/**
* Finds position of the first and last change in the given arrays. For example:
*
* ```ts
* const indexes = findChangeBoundaryIndexes( [ '1', '2', '3', '4' ], [ '1', '3', '4', '2', '4' ] );
* console.log( indexes ); // { firstIndex: 1, lastIndexOld: 3, lastIndexNew: 4 }
* ```
*
* The above indexes means that in the first array the modified part is `1[23]4` and in the second array it is `1[342]4`.
* Based on such indexes, array with `insert`/`delete` operations which allows transforming first value into the second one
* can be generated.
*/ function $c7bc2cb7e2db0227$var$findChangeBoundaryIndexes(arr1, arr2, cmp) {
    const firstIndex = $c7bc2cb7e2db0227$var$findFirstDifferenceIndex(arr1, arr2, cmp);
    if (firstIndex === -1) return {
        firstIndex: -1,
        lastIndexOld: -1,
        lastIndexNew: -1
    };
    const lastIndex = $c7bc2cb7e2db0227$var$findFirstDifferenceIndex($c7bc2cb7e2db0227$var$cutAndReverse(arr1, firstIndex), $c7bc2cb7e2db0227$var$cutAndReverse(arr2, firstIndex), cmp);
    return {
        firstIndex: firstIndex,
        lastIndexOld: arr1.length - lastIndex,
        lastIndexNew: arr2.length - lastIndex
    };
}
/**
* Returns a first index on which given arrays differ. If both arrays are the same, -1 is returned.
*/ function $c7bc2cb7e2db0227$var$findFirstDifferenceIndex(arr1, arr2, cmp) {
    for(let i = 0; i < Math.max(arr1.length, arr2.length); i++)if (arr1[i] === void 0 || arr2[i] === void 0 || !cmp(arr1[i], arr2[i])) return i;
    return -1;
}
/**
* Returns a copy of the given array with `howMany` elements removed starting from the beginning and in reversed order.
*
* @param arr Array to be processed.
* @param howMany How many elements from array beginning to remove.
* @returns Shortened and reversed array.
*/ function $c7bc2cb7e2db0227$var$cutAndReverse(arr, howMany) {
    return arr.slice(howMany).reverse();
}
/**
* Generates changes array based on change indexes from `findChangeBoundaryIndexes` function. This function will
* generate array with 0 (no changes), 1 (deletion or insertion) or 2 records (insertion and deletion).
*
* @param newArray New array for which change indexes were calculated.
* @param changeIndexes Change indexes object from `findChangeBoundaryIndexes` function.
* @returns Array of changes compatible with {@link module:utils/difftochanges~diffToChanges} format.
*/ function $c7bc2cb7e2db0227$var$changeIndexesToChanges(newArray, changeIndexes) {
    const result = [];
    const { firstIndex: firstIndex, lastIndexOld: lastIndexOld, lastIndexNew: lastIndexNew } = changeIndexes;
    if (lastIndexNew - firstIndex > 0) result.push({
        index: firstIndex,
        type: "insert",
        values: newArray.slice(firstIndex, lastIndexNew)
    });
    if (lastIndexOld - firstIndex > 0) result.push({
        index: firstIndex + (lastIndexNew - firstIndex),
        type: "delete",
        howMany: lastIndexOld - firstIndex
    });
    return result;
}
/**
* Generates array with set `equal|insert|delete` operations based on change indexes from `findChangeBoundaryIndexes` function.
*
* @param changeIndexes Change indexes object from `findChangeBoundaryIndexes` function.
* @param newLength Length of the new array on which `findChangeBoundaryIndexes` calculated change indexes.
* @returns Array of changes compatible with {@link module:utils/diff~diff} format.
*/ function $c7bc2cb7e2db0227$var$changeIndexesToAtomicChanges(changeIndexes, newLength) {
    const { firstIndex: firstIndex, lastIndexOld: lastIndexOld, lastIndexNew: lastIndexNew } = changeIndexes;
    if (firstIndex === -1) return Array(newLength).fill("equal");
    let result = [];
    if (firstIndex > 0) result = result.concat(Array(firstIndex).fill("equal"));
    if (lastIndexNew - firstIndex > 0) result = result.concat(Array(lastIndexNew - firstIndex).fill("insert"));
    if (lastIndexOld - firstIndex > 0) result = result.concat(Array(lastIndexOld - firstIndex).fill("delete"));
    if (lastIndexNew < newLength) result = result.concat(Array(newLength - lastIndexNew).fill("equal"));
    return result;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/diff
*/ /**
* Calculates the difference between two arrays or strings producing an array containing a list of changes
* necessary to transform input into output.
*
* ```ts
* diff( 'aba', 'acca' ); // [ 'equal', 'insert', 'insert', 'delete', 'equal' ]
* ```
*
* This function is based on the "O(NP) Sequence Comparison Algorithm" by Sun Wu, Udi Manber, Gene Myers, Webb Miller.
* Unfortunately, while it gives the most precise results, its to complex for longer strings/arrow (above 200 items).
* Therefore, `diff()` automatically switches to {@link module:utils/fastdiff~fastDiff `fastDiff()`} when detecting
* such a scenario. The return formats of both functions are identical.
*
* @param a Input array or string.
* @param b Output array or string.
* @param cmp Optional function used to compare array values, by default === is used.
* @returns Array of changes.
*/ const $c7bc2cb7e2db0227$export$a37e3c603d7117e5 = function(a, b, cmp) {
    cmp = cmp || function(a, b) {
        return a === b;
    };
    const aLength = a.length;
    const bLength = b.length;
    if (aLength > 200 || bLength > 200 || aLength + bLength > 300) return $c7bc2cb7e2db0227$export$a37e3c603d7117e5.fastDiff(a, b, cmp, true);
    let _insert, _delete;
    if (bLength < aLength) {
        const tmp = a;
        a = b;
        b = tmp;
        _insert = "delete";
        _delete = "insert";
    } else {
        _insert = "insert";
        _delete = "delete";
    }
    const m = a.length;
    const n = b.length;
    const delta = n - m;
    const es = {};
    const fp = {};
    function snake(k) {
        const y1 = (fp[k - 1] !== void 0 ? fp[k - 1] : -1) + 1;
        const y2 = fp[k + 1] !== void 0 ? fp[k + 1] : -1;
        const dir = y1 > y2 ? -1 : 1;
        if (es[k + dir]) es[k] = es[k + dir].slice(0);
        if (!es[k]) es[k] = [];
        es[k].push(y1 > y2 ? _insert : _delete);
        let y = Math.max(y1, y2);
        let x = y - k;
        while(x < m && y < n && cmp(a[x], b[y])){
            x++;
            y++;
            es[k].push("equal");
        }
        return y;
    }
    let p = 0;
    let k;
    do {
        for(k = -p; k < delta; k++)fp[k] = snake(k);
        for(k = delta + p; k > delta; k--)fp[k] = snake(k);
        fp[delta] = snake(delta);
        p++;
    }while (fp[delta] !== n);
    return es[delta].slice(1);
};
$c7bc2cb7e2db0227$export$a37e3c603d7117e5.fastDiff = $c7bc2cb7e2db0227$export$b3d8c5da214d9c82;
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Creates a set of changes which need to be applied to the input in order to transform
* it into the output. This function can be used with strings or arrays.
*
* ```ts
* const input = Array.from( 'abc' );
* const output = Array.from( 'xaby' );
* const changes = diffToChanges( diff( input, output ), output );
*
* changes.forEach( change => {
* 	if ( change.type == 'insert' ) {
* 		input.splice( change.index, 0, ...change.values );
* 	} else if ( change.type == 'delete' ) {
* 		input.splice( change.index, change.howMany );
* 	}
* } );
*
* input.join( '' ) == output.join( '' ); // -> true
* ```
*
* @typeParam T The type of output array element.
* @param diff Result of {@link module:utils/diff~diff}.
* @param output The string or array which was passed as diff's output.
* @returns Set of changes (insert or delete) which need to be applied to the input
* in order to transform it into the output.
*/ function $c7bc2cb7e2db0227$export$bdb85aedd6e1f170(diff, output) {
    const changes = [];
    let index = 0;
    let lastOperation = null;
    diff.forEach((change)=>{
        if (change == "equal") {
            pushLast();
            index++;
        } else if (change == "insert") {
            if (lastOperation && lastOperation.type == "insert") lastOperation.values.push(output[index]);
            else {
                pushLast();
                lastOperation = {
                    type: "insert",
                    index: index,
                    values: [
                        output[index]
                    ]
                };
            }
            index++;
        } else if (lastOperation && lastOperation.type == "delete") lastOperation.howMany++;
        else {
            pushLast();
            lastOperation = {
                type: "delete",
                index: index,
                howMany: 1
            };
        }
    });
    pushLast();
    return changes;
    function pushLast() {
        if (lastOperation) {
            changes.push(lastOperation);
            lastOperation = null;
        }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/areconnectedthroughproperties
*/ /**
* Traverses both structures to find out whether there is a reference that is shared between both structures.
*/ function $c7bc2cb7e2db0227$export$4579f2598c8c010(obj1, obj2) {
    if (obj1 === obj2 && $c7bc2cb7e2db0227$var$isObject$1(obj1)) return true;
    const subNodes1 = $c7bc2cb7e2db0227$var$getSubNodes(obj1);
    const subNodes2 = $c7bc2cb7e2db0227$var$getSubNodes(obj2);
    for (const node of subNodes1)if (subNodes2.has(node)) return true;
    return false;
}
/**
* Traverses JS structure and stores all sub-nodes, including the head node.
* It walks into each iterable structures with the `try catch` block to omit errors that might be thrown during
* tree walking. All primitives, functions and built-ins are skipped.
*/ function $c7bc2cb7e2db0227$var$getSubNodes(head) {
    const nodes = [
        head
    ];
    const subNodes = /* @__PURE__ */ new Set();
    while(nodes.length > 0){
        const node = nodes.shift();
        if (subNodes.has(node) || $c7bc2cb7e2db0227$var$shouldNodeBeSkipped(node)) continue;
        subNodes.add(node);
        if (node[Symbol.iterator]) try {
            nodes.push(...node);
        } catch  {}
        else nodes.push(...Object.values(node));
    }
    return subNodes;
}
function $c7bc2cb7e2db0227$var$shouldNodeBeSkipped(node) {
    const type = Object.prototype.toString.call(node);
    return type === "[object Number]" || type === "[object Boolean]" || type === "[object String]" || type === "[object Symbol]" || type === "[object Function]" || type === "[object Date]" || type === "[object RegExp]" || node === void 0 || node === null || node instanceof EventTarget || node instanceof Event;
}
function $c7bc2cb7e2db0227$var$isObject$1(structure) {
    return typeof structure === "object" && structure !== null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/spy
*/ /**
* Creates a spy function (ala Sinon.js) that can be used to inspect call to it.
*
* The following are the present features:
*
* * spy.called: property set to `true` if the function has been called at least once.
*
* @returns The spy function.
*/ function $c7bc2cb7e2db0227$export$fcc0cd19e9fb2b4c() {
    return function spy() {
        spy.called = true;
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/eventinfo
*/ /**
* The event object passed to event callbacks. It is used to provide information about the event as well as a tool to
* manipulate it.
*/ var $c7bc2cb7e2db0227$export$3f63aa522937812c = class {
    /**
	* The object that fired the event.
	*/ source;
    /**
	* The event name.
	*/ name;
    /**
	* Path this event has followed. See {@link module:utils/emittermixin~Emitter#delegate}.
	*/ path;
    /**
	* Stops the event emitter to call further callbacks for this event interaction.
	*/ stop;
    /**
	* Removes the current callback from future interactions of this event.
	*/ off;
    /**
	* The value which will be returned by {@link module:utils/emittermixin~Emitter#fire}.
	*
	* It's `undefined` by default and can be changed by an event listener:
	*
	* ```ts
	* dataController.fire( 'getSelectedContent', ( evt ) => {
	* 	// This listener will make `dataController.fire( 'getSelectedContent' )`
	* 	// always return an empty DocumentFragment.
	* 	evt.return = new DocumentFragment();
	*
	* 	// Make sure no other listeners are executed.
	* 	evt.stop();
	* } );
	* ```
	*/ return;
    /**
	* @param source The emitter.
	* @param name The event name.
	*/ constructor(source, name){
        this.source = source;
        this.name = name;
        this.path = [];
        this.stop = $c7bc2cb7e2db0227$export$fcc0cd19e9fb2b4c();
        this.off = $c7bc2cb7e2db0227$export$fcc0cd19e9fb2b4c();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/uid
*/ /**
* A hash table of hex numbers to avoid using toString() in uid() which is costly.
* [ '00', '01', '02', ..., 'fe', 'ff' ]
*/ const $c7bc2cb7e2db0227$var$HEX_NUMBERS = new Array(256).fill("").map((_, index)=>("0" + index.toString(16)).slice(-2));
/**
* Returns a unique id. The id starts with an "e" character and a randomly generated string of
* 32 alphanumeric characters.
*
* **Note**: The characters the unique id is built from correspond to the hex number notation
* (from "0" to "9", from "a" to "f"). In other words, each id corresponds to an "e" followed
* by 16 8-bit numbers next to each other.
*
* @returns An unique id string.
*/ function $c7bc2cb7e2db0227$export$e2a22331486dcca0() {
    const [r1, r2, r3, r4] = crypto.getRandomValues(/* @__PURE__ */ new Uint32Array(4));
    return "e" + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r1 >> 0 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r1 >> 8 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r1 >> 16 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r1 >> 24 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r2 >> 0 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r2 >> 8 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r2 >> 16 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r2 >> 24 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r3 >> 0 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r3 >> 8 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r3 >> 16 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r3 >> 24 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r4 >> 0 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r4 >> 8 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r4 >> 16 & 255] + $c7bc2cb7e2db0227$var$HEX_NUMBERS[r4 >> 24 & 255];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Provides group of constants to use instead of hardcoding numeric priority values.
*/ const $c7bc2cb7e2db0227$export$7b4ff1aef3781895 = {
    get (priority = "normal") {
        if (typeof priority != "number") return this[priority] || this.normal;
        else return priority;
    },
    highest: 1e5,
    high: 1e3,
    normal: 0,
    low: -1000,
    lowest: -100000
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/inserttopriorityarray
*/ /**
* Inserts any object with priority at correct index by priority so registered objects are always sorted from highest to lowest priority.
*
* @param objects Array of objects with priority to insert object to.
* @param objectToInsert Object with `priority` property.
*/ function $c7bc2cb7e2db0227$export$d415007a4e865351(objects, objectToInsert) {
    const priority = $c7bc2cb7e2db0227$export$7b4ff1aef3781895.get(objectToInsert.priority);
    let left = 0;
    let right = objects.length;
    while(left < right){
        const mid = left + right >> 1;
        if ($c7bc2cb7e2db0227$export$7b4ff1aef3781895.get(objects[mid].priority) < priority) right = mid;
        else left = mid + 1;
    }
    objects.splice(left, 0, objectToInsert);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/ckeditorerror
*/ /**
* URL to the documentation with error codes.
*/ const $c7bc2cb7e2db0227$export$7844c089b21780a = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
/**
* The CKEditor error class.
*
* You should throw `CKEditorError` when:
*
* * An unexpected situation occurred and the editor (most probably) will not work properly. Such exception will be
* reported to the callbacks registered with {@link module:core/errorreporter~onEditorError `onEditorError()`},
* * If the editor is incorrectly integrated or the editor API is used in the wrong way. This way you will give
* feedback to the developer as soon as possible. Keep in mind that for common integration issues which should not
* stop editor initialization (like missing upload adapter, wrong name of a toolbar component) we use
* {@link module:utils/ckeditorerror~logWarning `logWarning()`} and
* {@link module:utils/ckeditorerror~logError `logError()`}
* to improve developers experience and let them see the a working editor as soon as possible.
*
* ```ts
* /**
*  * Error thrown when a plugin cannot be loaded due to JavaScript errors, lack of plugins with a given name, etc.
*  *
*  * @error plugin-load
*  * @param pluginName The name of the plugin that could not be loaded.
*  * @param moduleName The name of the module which tried to load this plugin.
*  *\/
* throw new CKEditorError( 'plugin-load', {
* 	pluginName: 'foo',
* 	moduleName: 'bar'
* } );
* ```
*/ var $c7bc2cb7e2db0227$export$4e727b0db6c2de10 = class CKEditorError extends Error {
    /**
	* A context of the error by which error reporting works out which editor the error came from.
	*/ context;
    /**
	* The additional error data passed to the constructor. Undefined if none was passed.
	*/ data;
    /**
	* Creates an instance of the CKEditorError class.
	*
	* @param errorName The error id in an `error-name` format. A link to this error documentation page will be added
	* to the thrown error's `message`.
	* @param context A context of the error by which {@link module:core/errorreporter~onEditorError error reporting}
	* works out which editor the error came from. Pass the editor, the context, or the plugin or command that throws the error.
	* Pass `null` if the error should not be attributed to any editor (e.g. during the editor initialization).
	* @param data Additional data describing the error. A stringified version of this object
	* will be appended to the error message, so the data are quickly visible in the console. The original
	* data object will also be later available under the {@link #data} property.
	* @param originalError An optional original error that is being wrapped in the `CKEditorError` instance.
	*/ constructor(errorName, context, data, originalError){
        super($c7bc2cb7e2db0227$var$getErrorMessage(errorName, data, originalError));
        this.name = "CKEditorError";
        this.context = context;
        this.data = data;
        if (originalError) this.stack = originalError.stack;
    }
    /**
	* Checks if the error is of the `CKEditorError` type.
	*/ is(type) {
        return type === "CKEditorError";
    }
    /**
	* A utility that ensures that the thrown error is a {@link module:utils/ckeditorerror~CKEditorError} one.
	* Only a {@link module:utils/ckeditorerror~CKEditorError} is reported to the callbacks registered with
	* {@link module:core/errorreporter~onEditorError `onEditorError()`}, so wrapping an unexpected error in one is what
	* makes it reach them.
	*
	* @param error The error to rethrow.
	* @param context An object connected through properties with the editor instance. This context is what error
	* reporting uses to work out which editor the error came from.
	*/ static rethrowUnexpectedError(error, context) {
        if (error.is && error.is("CKEditorError")) throw error;
        /**
		* An unexpected error occurred inside the CKEditor 5 codebase. This error will look like the original one
		* to make the debugging easier.
		*
		* Like any {@link module:utils/ckeditorerror~CKEditorError}, it is reported to the callbacks registered with
		* {@link module:core/errorreporter~onEditorError `onEditorError()`}, naming the editor it came from.
		*
		* @error unexpected-error
		*/ throw new CKEditorError("unexpected-error", context, void 0, error);
    }
};
/**
* Logs a warning to the console with a properly formatted message and adds a link to the documentation.
* Use whenever you want to log a warning to the console.
*
* ```ts
* /**
*  * There was a problem processing the configuration of the toolbar. The item with the given
*  * name does not exist, so it was omitted when rendering the toolbar.
*  *
*  * @error toolbarview-item-unavailable
*  * @param {String} name The name of the component.
*  *\/
* logWarning( 'toolbarview-item-unavailable', { name } );
* ```
*
* See also {@link module:utils/ckeditorerror~CKEditorError} for an explanation when to throw an error and when to log
* a warning or an error to the console.
*
* @param errorName The error name to be logged.
* @param data Additional data to be logged.
*/ function $c7bc2cb7e2db0227$export$ebd6064652549ce9(errorName, data) {
    console.warn(...$c7bc2cb7e2db0227$var$formatConsoleArguments(errorName, data));
}
/**
* Logs an error to the console with a properly formatted message and adds a link to the documentation.
* Use whenever you want to log an error to the console.
*
* ```ts
* /**
*  * There was a problem processing the configuration of the toolbar. The item with the given
*  * name does not exist, so it was omitted when rendering the toolbar.
*  *
*  * @error toolbarview-item-unavailable
*  * @param {String} name The name of the component.
*  *\/
*  logError( 'toolbarview-item-unavailable', { name } );
* ```
*
* **Note**: In most cases logging a warning using {@link module:utils/ckeditorerror~logWarning} is enough.
*
* See also {@link module:utils/ckeditorerror~CKEditorError} for an explanation when to use each method.
*
* @param errorName The error name to be logged.
* @param data Additional data to be logged.
*/ function $c7bc2cb7e2db0227$export$58da9968c3170cb1(errorName, data) {
    console.error(...$c7bc2cb7e2db0227$var$formatConsoleArguments(errorName, data));
}
/**
* Returns formatted link to documentation message.
*/ function $c7bc2cb7e2db0227$var$getLinkToDocumentationMessage(errorName) {
    return `\nRead more: ${$c7bc2cb7e2db0227$export$7844c089b21780a}#error-${errorName}`;
}
/**
* Returns formatted error message.
*/ function $c7bc2cb7e2db0227$var$getErrorMessage(errorName, data, originalError) {
    const processedObjects = /* @__PURE__ */ new WeakSet();
    const circularReferencesReplacer = (key, value)=>{
        if (typeof value === "object" && value !== null) {
            if (processedObjects.has(value)) return `[object ${value.constructor.name}]`;
            processedObjects.add(value);
        }
        return value;
    };
    const stringifiedData = data ? ` ${JSON.stringify(data, circularReferencesReplacer)}` : "";
    const documentationLink = $c7bc2cb7e2db0227$var$getLinkToDocumentationMessage(errorName);
    const originalErrorMessage = originalError ? `\nOriginal error: ${originalError.name}: ${originalError.message}` : "";
    return errorName + stringifiedData + documentationLink + originalErrorMessage;
}
/**
* Returns formatted console error arguments.
*/ function $c7bc2cb7e2db0227$var$formatConsoleArguments(errorName, data) {
    const documentationMessage = $c7bc2cb7e2db0227$var$getLinkToDocumentationMessage(errorName);
    return data ? [
        errorName,
        data,
        documentationMessage
    ] : [
        errorName,
        documentationMessage
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/version
*/ const $c7bc2cb7e2db0227$export$83d89fbfd8236492 = "49.0.1";
const $c7bc2cb7e2db0227$export$e1be5b7438bff8c = new Date(2026, 9, 27);
/* v8 ignore next -- @preserve */ if (globalThis.CKEDITOR_VERSION) /**
* This error is thrown when, due to a mistake in the way CKEditor&nbsp;5 was installed,
* imported, or initialized, some of its modules were evaluated and executed twice.
* Duplicate modules inevitably lead to runtime errors and increased bundle size.
*
* # Check dependency versions
*
* First, make sure that you use the latest version of all CKEditor&nbsp;5 dependencies.
* Depending on the installation method, you should check the versions of the `ckeditor5`,
* `ckeditor5-premium-features`, or `@ckeditor/ckeditor5-<NAME>` packages. If you cannot update
* to the latest version, ensure that all the CKEditor&nbsp;5 packages are
* in the same version.
*
* If you use third-party plugins, make sure to update them, too. If they are incompatible
* with the version of CKEditor&nbsp;5 you use, you may need to downgrade the CKEditor&nbsp;5 packages
* (which we do not recommend). Ask the plugin's author to upgrade the dependencies,
* or fork their project and update it yourself.
*
* # Check imports
*
* The next step is to look at how you import CKEditor&nbsp;5 into your project.
*
* **The {@glink updating/nim-migration/migration-to-new-installation-methods new installation methods}
* are designed to prevent module duplication, so if you are not using them yet, you should consider
* updating your project**. However, several legacy installation methods are still supported for backward
* compatibility, and mixing them may result in module duplication.
*
* These are the most common import methods of the CKEditor&nbsp;5 packages.
*
* - **New installation methods (NIM)** &ndash; Imports from the `ckeditor5` and `ckeditor5-premium-features` packages.
* - **Optimized build** for the new installation methods &ndash; Imports from the `@ckeditor/ckeditor5-<NAME>/dist/index.js`.
* - **Predefined builds** (no longer supported) &ndash; Imports from the `@ckeditor/ckeditor5-build-<NAME>` packages.
* - **Default imports** (legacy) &ndash; Imports from the `@ckeditor/ckeditor5-<NAME>` packages (default export).
* - **`src`** (legacy) &ndash; Imports from the `@ckeditor/ckeditor5-<NAME>/src/*`.
* - **DLL builds** (legacy) &ndash; Imports from the `ckeditor5/build/<NAME>` and `@ckeditor/ckeditor5-<NAME>/build/*`.
*
* The best way to avoid duplicate modules is to avoid mixing these installation methods. For example, if you use imports
* specific to the optimized build, you should use them for all CKEditor&nbsp;5 packages. In addition, since
* the DLL builds already include the core of the editor, they cannot be used with other types of imports.
*
* Here is a matrix showing which installation methods are compatible with each other:
*
* |                  | NIM | Optimized build | Predefined builds | Default imports | `src` | DLL builds |
* |------------------|-----|-----------------|-------------------|-----------------|-------|------------|
* | NIM              | ✅  | ✅              | ❌                | ❌              | ❌    | ❌         |
* | Optimized builds | ✅  | ✅              | ❌                | ❌              | ❌    | ❌         |
* | Predefined build | ❌  | ❌              | ✅                | ❌              | ❌    | ❌         |
* | Default imports  | ❌  | ❌              | ❌                | ✅              | ✅    | ❌         |
* | `src`            | ❌  | ❌              | ❌                | ✅              | ✅    | ❌         |
* | DLL builds       | ❌  | ❌              | ❌                | ❌              | ❌    | ✅         |
*
* If you use any third-party plugins, make sure the way you import them is compatible with
* the way you import CKEditor&nbsp;5.
*
* <details>
* <summary>New installation methods and optimized builds</summary>
*
* If you use the {@glink updating/nim-migration/migration-to-new-installation-methods new installation methods},
* you should only import { code } from the `ckeditor5` and `ckeditor5-premium-features` packages.
* Do not import { code } from the `@ckeditor/ckeditor5-<NAME>` packages unless you follow
* the {@glink getting-started/setup/optimizing-build-size Optimizing build size} guide and the imports from
* the `@ckeditor/ckeditor5-<NAME>` packages end with `/dist/index.js`.
*
* If you use a CDN, ensure that some files are not included twice in your project.
*
* Examples of valid and invalid import paths:
*
* ```js
* import { ClassicEditor, Highlight } from 'ckeditor5'; // ✅
* import { Highlight } from '@ckeditor/ckeditor5-highlight/dist/index.js'; // ✅
* import { Highlight } from '@ckeditor/ckeditor5-highlight/src/highlight.js'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight'; // ❌
* import '@ckeditor/ckeditor5-highlight/build/highlight.js'; // ❌
* ```
* </details>
*
* <details>
* <summary>(Deprecated) Predefined builds</summary>
*
* **As of April, 2025 predefined build are no longer supported. Please refer to the
* {@glink getting-started/index Quick Start} guide
* to choose one of the modern installation and integration methods available**.
*
* If you use the predefined builds, you cannot import any additional plugins.
* These builds already include the editor's core and selected plugins and importing additional
* ones will cause some modules to be bundled and loaded twice.
*
* Examples of valid and invalid import paths:
*
* ```js
* import { ClassicEditor } from '@ckeditor/ckeditor5-build-classic'; // ✅
* import { Highlight } from 'ckeditor5'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight/dist/index.js'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight/src/highlight'; // ❌
* import '@ckeditor/ckeditor5-highlight/build/highlight'; // ❌
* ```
*
* If you are missing some features from the list of plugins, you should switch to the
* {@glink updating/nim-migration/migration-to-new-installation-methods new installation methods}
* which do not have this limitation.
* </details>
*
* <details>
* <summary>(Legacy) Default imports and `src` imports</summary>
*
* If you use the legacy customized installation
* method, you should only import code from the `@ckeditor/ckeditor5-<NAME>` packages. While you can import code from
* the `@ckeditor/ckeditor5-<NAME>/src/*` files, it is not recommended as it can make migration to the new installation
* methods more difficult.
*
* If you use this installation method, you should not import { code } from the `ckeditor5` or `ckeditor5-premium-features` packages.
*
* Examples of valid and invalid import paths:
*
* ```js
* import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic'; // ✅
* import { Highlight } from '@ckeditor/ckeditor5-highlight'; // ✅
* import { Highlight } from '@ckeditor/ckeditor5-highlight/src/highlight.js'; // ✅ (not recommended)
* import { Highlight } from 'ckeditor5'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight/dist/index.js'; // ❌
* import '@ckeditor/ckeditor5-highlight/build/highlight'; // ❌
* ```
* </details>
*
* <details>
* <summary>(Legacy) DLL builds</summary>
*
* If you are using the {@glink updating/nim-migration/dll-builds legacy DLL builds},
* you should not import any non-DLL modules.
*
* Examples of valid and invalid import paths:
*
* ```js
* import 'ckeditor5/build/ckeditor5-dll.js';// ✅
* import '@ckeditor/ckeditor5-editor-classic/build/editor-classic.js';// ✅
* import '@ckeditor/ckeditor5-highlight/build/highlight.js';// ✅
* import { Highlight } from 'ckeditor5'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight/dist/index.js'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight'; // ❌
* import { Highlight } from '@ckeditor/ckeditor5-highlight/src/highlight.js'; // ❌
* ```
* </details>
*
* # Reinstall `node_modules`
*
* Usually, npm and other package managers deduplicate all packages - for example, `ckeditor5` is only installed once
* in `node_modules/`. However, it is known to fail to do so occasionally.
*
* To rule out this possibility, you can try the following:
*
* 1. Remove the `node_modules` directory.
* 2. Remove the `package-lock.json`, `yarn.lock`, or `pnpm-lock.yaml` files (depending on the package manager used).
* 3. Run `npm install` to reinstall all packages.
* 4. Run `npm ls` to check how many times packages like `@ckeditor/ckeditor5-core` are installed.
* If they are installed more than once, verify which package causes that.
*
* @error ckeditor-duplicated-modules
*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("ckeditor-duplicated-modules", null);
else globalThis.CKEDITOR_VERSION = $c7bc2cb7e2db0227$export$83d89fbfd8236492;
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/emittermixin
*/ const $c7bc2cb7e2db0227$var$_listeningTo = Symbol("listeningTo");
const $c7bc2cb7e2db0227$var$_emitterId = Symbol("emitterId");
const $c7bc2cb7e2db0227$var$_delegations = Symbol("delegations");
const $c7bc2cb7e2db0227$var$defaultEmitterClass$1 = /* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594(Object);
function $c7bc2cb7e2db0227$export$1f0c3be316c44594(base) {
    if (!base) return $c7bc2cb7e2db0227$var$defaultEmitterClass$1;
    class Mixin extends base {
        on(event, callback, options) {
            this.listenTo(this, event, callback, options);
        }
        once(event, callback, options) {
            let wasFired = false;
            const onceCallback = (event, ...args)=>{
                if (!wasFired) {
                    wasFired = true;
                    event.off();
                    callback.call(this, event, ...args);
                }
            };
            this.listenTo(this, event, onceCallback, options);
        }
        off(event, callback) {
            this.stopListening(this, event, callback);
        }
        listenTo(emitter, event, callback, options = {}) {
            let emitterInfo, eventCallbacks;
            if (!this[$c7bc2cb7e2db0227$var$_listeningTo]) this[$c7bc2cb7e2db0227$var$_listeningTo] = {};
            const emitters = this[$c7bc2cb7e2db0227$var$_listeningTo];
            if (!$c7bc2cb7e2db0227$export$76b0b39908436bd3(emitter)) $c7bc2cb7e2db0227$export$df1b5ccfb3ce9df8(emitter);
            const emitterId = $c7bc2cb7e2db0227$export$76b0b39908436bd3(emitter);
            if (!(emitterInfo = emitters[emitterId])) emitterInfo = emitters[emitterId] = {
                emitter: emitter,
                callbacks: {}
            };
            if (!(eventCallbacks = emitterInfo.callbacks[event])) eventCallbacks = emitterInfo.callbacks[event] = [];
            eventCallbacks.push(callback);
            $c7bc2cb7e2db0227$var$addEventListener(this, emitter, event, callback, options);
        }
        stopListening(emitter, event, callback) {
            const emitters = this[$c7bc2cb7e2db0227$var$_listeningTo];
            let emitterId = emitter && $c7bc2cb7e2db0227$export$76b0b39908436bd3(emitter);
            const emitterInfo = emitters && emitterId ? emitters[emitterId] : void 0;
            const eventCallbacks = emitterInfo && event ? emitterInfo.callbacks[event] : void 0;
            if (!emitters || emitter && !emitterInfo || event && !eventCallbacks) return;
            if (callback) {
                $c7bc2cb7e2db0227$var$removeEventListener(this, emitter, event, callback);
                if (eventCallbacks.indexOf(callback) !== -1) {
                    if (eventCallbacks.length === 1) delete emitterInfo.callbacks[event];
                    else $c7bc2cb7e2db0227$var$removeEventListener(this, emitter, event, callback);
                }
            } else if (eventCallbacks) {
                while(callback = eventCallbacks.pop())$c7bc2cb7e2db0227$var$removeEventListener(this, emitter, event, callback);
                delete emitterInfo.callbacks[event];
            } else if (emitterInfo) {
                for(event in emitterInfo.callbacks)this.stopListening(emitter, event);
                delete emitters[emitterId];
            } else {
                for(emitterId in emitters)this.stopListening(emitters[emitterId].emitter);
                delete this[$c7bc2cb7e2db0227$var$_listeningTo];
            }
        }
        fire(eventOrInfo, ...args) {
            try {
                const eventInfo = eventOrInfo instanceof $c7bc2cb7e2db0227$export$3f63aa522937812c ? eventOrInfo : new $c7bc2cb7e2db0227$export$3f63aa522937812c(this, eventOrInfo);
                const event = eventInfo.name;
                let callbacks = $c7bc2cb7e2db0227$var$getCallbacksForEvent(this, event);
                eventInfo.path.push(this);
                if (callbacks) {
                    callbacks = callbacks.slice();
                    for(let i = 0; i < callbacks.length; i++){
                        const fn = callbacks[i].callback;
                        fn.call(this, eventInfo, ...args);
                        if (eventInfo.off.called) {
                            delete eventInfo.off.called;
                            this._removeEventListener(event, fn);
                        }
                        if (eventInfo.stop.called) break;
                    }
                }
                const delegations = this[$c7bc2cb7e2db0227$var$_delegations];
                if (delegations) {
                    const destinations = delegations.get(event);
                    const passAllDestinations = delegations.get("*");
                    if (destinations) $c7bc2cb7e2db0227$var$fireDelegatedEvents(destinations, eventInfo, args);
                    if (passAllDestinations) $c7bc2cb7e2db0227$var$fireDelegatedEvents(passAllDestinations, eventInfo, args);
                }
                return eventInfo.return;
            } catch (err) {
                /* v8 ignore next -- @preserve */ $c7bc2cb7e2db0227$export$4e727b0db6c2de10.rethrowUnexpectedError(err, this);
            }
        }
        delegate(...events) {
            return {
                to: (emitter, nameOrFunction)=>{
                    if (!this[$c7bc2cb7e2db0227$var$_delegations]) this[$c7bc2cb7e2db0227$var$_delegations] = /* @__PURE__ */ new Map();
                    events.forEach((eventName)=>{
                        const destinations = this[$c7bc2cb7e2db0227$var$_delegations].get(eventName);
                        if (!destinations) this[$c7bc2cb7e2db0227$var$_delegations].set(eventName, /* @__PURE__ */ new Map([
                            [
                                emitter,
                                nameOrFunction
                            ]
                        ]));
                        else destinations.set(emitter, nameOrFunction);
                    });
                }
            };
        }
        stopDelegating(event, emitter) {
            if (!this[$c7bc2cb7e2db0227$var$_delegations]) return;
            if (!event) this[$c7bc2cb7e2db0227$var$_delegations].clear();
            else if (!emitter) this[$c7bc2cb7e2db0227$var$_delegations].delete(event);
            else {
                const destinations = this[$c7bc2cb7e2db0227$var$_delegations].get(event);
                if (destinations) destinations.delete(emitter);
            }
        }
        _addEventListener(event, callback, options) {
            $c7bc2cb7e2db0227$var$createEventNamespace(this, event);
            const lists = $c7bc2cb7e2db0227$var$getCallbacksListsForNamespace(this, event);
            const callbackDefinition = {
                callback: callback,
                priority: $c7bc2cb7e2db0227$export$7b4ff1aef3781895.get(options.priority)
            };
            for (const callbacks of lists)$c7bc2cb7e2db0227$export$d415007a4e865351(callbacks, callbackDefinition);
        }
        _removeEventListener(event, callback) {
            const lists = $c7bc2cb7e2db0227$var$getCallbacksListsForNamespace(this, event);
            for (const callbacks of lists)for(let i = 0; i < callbacks.length; i++)if (callbacks[i].callback == callback) {
                callbacks.splice(i, 1);
                i--;
            }
        }
    }
    return Mixin;
}
/**
* Checks if `listeningEmitter` listens to an emitter with given `listenedToEmitterId` and if so, returns that emitter.
* If not, returns `null`.
*
* @internal
* @param listeningEmitter An emitter that listens.
* @param listenedToEmitterId Unique emitter id of emitter listened to.
*/ function $c7bc2cb7e2db0227$export$59cc71c40980756b(listeningEmitter, listenedToEmitterId) {
    const listeningTo = listeningEmitter[$c7bc2cb7e2db0227$var$_listeningTo];
    if (listeningTo && listeningTo[listenedToEmitterId]) return listeningTo[listenedToEmitterId].emitter;
    return null;
}
/**
* Sets emitter's unique id.
*
* **Note:** `_emitterId` can be set only once.
*
* @internal
* @param emitter An emitter for which id will be set.
* @param id Unique id to set. If not passed, random unique id will be set.
*/ function $c7bc2cb7e2db0227$export$df1b5ccfb3ce9df8(emitter, id) {
    if (!emitter[$c7bc2cb7e2db0227$var$_emitterId]) emitter[$c7bc2cb7e2db0227$var$_emitterId] = id || $c7bc2cb7e2db0227$export$e2a22331486dcca0();
}
/**
* Returns emitter's unique id.
*
* @internal
* @param emitter An emitter which id will be returned.
*/ function $c7bc2cb7e2db0227$export$76b0b39908436bd3(emitter) {
    return emitter[$c7bc2cb7e2db0227$var$_emitterId];
}
/**
* Gets the internal `_events` property of the given object.
* `_events` property store all lists with callbacks for registered event names.
* If there were no events registered on the object, empty `_events` object is created.
*/ function $c7bc2cb7e2db0227$var$getEvents(source) {
    if (!source._events) Object.defineProperty(source, "_events", {
        value: {}
    });
    return source._events;
}
/**
* Creates event node for generic-specific events relation architecture.
*/ function $c7bc2cb7e2db0227$var$makeEventNode() {
    return {
        callbacks: [],
        childEvents: []
    };
}
/**
* Creates an architecture for generic-specific events relation.
* If needed, creates all events for given eventName, i.e. if the first registered event
* is foo:bar:abc, it will create foo:bar:abc, foo:bar and foo event and tie them together.
* It also copies callbacks from more generic events to more specific events when
* specific events are created.
*/ function $c7bc2cb7e2db0227$var$createEventNamespace(source, eventName) {
    const events = $c7bc2cb7e2db0227$var$getEvents(source);
    if (events[eventName]) return;
    let name = eventName;
    let childEventName = null;
    const newEventNodes = [];
    while(name !== ""){
        if (events[name]) break;
        events[name] = $c7bc2cb7e2db0227$var$makeEventNode();
        newEventNodes.push(events[name]);
        if (childEventName) events[name].childEvents.push(childEventName);
        childEventName = name;
        const colonIndex = name.lastIndexOf(":");
        name = colonIndex > -1 ? name.substring(0, colonIndex) : "";
    }
    if (name !== "") {
        for (const node of newEventNodes)node.callbacks = events[name].callbacks.slice();
        events[name].childEvents.push(childEventName);
    }
}
/**
* Gets an array containing callbacks list for a given event and it's more specific events.
* I.e. if given event is foo:bar and there is also foo:bar:abc event registered, this will
* return callback list of foo:bar and foo:bar:abc (but not foo).
*/ function $c7bc2cb7e2db0227$var$getCallbacksListsForNamespace(source, eventName) {
    const eventNode = $c7bc2cb7e2db0227$var$getEvents(source)[eventName];
    if (!eventNode) return [];
    let callbacksLists = [
        eventNode.callbacks
    ];
    for(let i = 0; i < eventNode.childEvents.length; i++){
        const childCallbacksLists = $c7bc2cb7e2db0227$var$getCallbacksListsForNamespace(source, eventNode.childEvents[i]);
        callbacksLists = callbacksLists.concat(childCallbacksLists);
    }
    return callbacksLists;
}
/**
* Get the list of callbacks for a given event, but only if there any callbacks have been registered.
* If there are no callbacks registered for given event, it checks if this is a specific event and looks
* for callbacks for it's more generic version.
*/ function $c7bc2cb7e2db0227$var$getCallbacksForEvent(source, eventName) {
    if (!source._events) return null;
    let currentEventName = eventName;
    do {
        const event = source._events[currentEventName];
        if (event && event.callbacks && event.callbacks.length) return event.callbacks;
        const colonIndex = currentEventName.lastIndexOf(":");
        currentEventName = colonIndex > -1 ? currentEventName.substring(0, colonIndex) : "";
    }while (currentEventName);
    return null;
}
/**
* Fires delegated events for given map of destinations.
*
* @param destinations A map containing `[ {@link module:utils/emittermixin~Emitter}, "event name" ]` pair destinations.
* @param eventInfo The original event info object.
* @param fireArgs Arguments the original event was fired with.
*/ function $c7bc2cb7e2db0227$var$fireDelegatedEvents(destinations, eventInfo, fireArgs) {
    for (let [emitter, name] of destinations){
        if (!name) name = eventInfo.name;
        else if (typeof name == "function") name = name(eventInfo.name);
        const delegatedInfo = new $c7bc2cb7e2db0227$export$3f63aa522937812c(eventInfo.source, name);
        delegatedInfo.path = [
            ...eventInfo.path
        ];
        emitter.fire(delegatedInfo, ...fireArgs);
    }
}
/**
* Helper for registering event callback on the emitter.
*/ function $c7bc2cb7e2db0227$var$addEventListener(listener, emitter, event, callback, options) {
    if (emitter._addEventListener) emitter._addEventListener(event, callback, options);
    else listener._addEventListener.call(emitter, event, callback, options);
}
/**
* Helper for removing event callback from the emitter.
*/ function $c7bc2cb7e2db0227$var$removeEventListener(listener, emitter, event, callback) {
    if (emitter._removeEventListener) emitter._removeEventListener(event, callback);
    else listener._removeEventListener.call(emitter, event, callback);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/observablemixin
*/ const $c7bc2cb7e2db0227$var$observablePropertiesSymbol = Symbol("observableProperties");
const $c7bc2cb7e2db0227$var$boundObservablesSymbol = Symbol("boundObservables");
const $c7bc2cb7e2db0227$var$boundPropertiesSymbol = Symbol("boundProperties");
const $c7bc2cb7e2db0227$var$decoratedMethods = Symbol("decoratedMethods");
const $c7bc2cb7e2db0227$var$decoratedOriginal = Symbol("decoratedOriginal");
const $c7bc2cb7e2db0227$var$defaultObservableClass = /* #__PURE__ */ $c7bc2cb7e2db0227$export$316ae78324a4e1c0(/* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594());
function $c7bc2cb7e2db0227$export$316ae78324a4e1c0(base) {
    if (!base) return $c7bc2cb7e2db0227$var$defaultObservableClass;
    class Mixin extends base {
        set(name, value) {
            if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(name)) {
                Object.keys(name).forEach((property)=>{
                    this.set(property, name[property]);
                }, this);
                return;
            }
            $c7bc2cb7e2db0227$var$initObservable(this);
            const properties = this[$c7bc2cb7e2db0227$var$observablePropertiesSymbol];
            if (name in this && !properties.has(name)) /**
			* Cannot override an existing property.
			*
			* This error is thrown when trying to {@link module:utils/observablemixin~Observable#set set} a property with
			* a name of an already existing property. For example:
			*
			* ```ts
			* let observable = new Model();
			* observable.property = 1;
			* observable.set( 'property', 2 );			// throws
			*
			* observable.set( 'property', 1 );
			* observable.set( 'property', 2 );			// ok, because this is an existing property.
			* ```
			*
			* @error observable-set-cannot-override
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-set-cannot-override", this);
            Object.defineProperty(this, name, {
                enumerable: true,
                configurable: true,
                get () {
                    return properties.get(name);
                },
                set (value) {
                    const oldValue = properties.get(name);
                    let newValue = this.fire(`set:${name}`, name, value, oldValue);
                    if (newValue === void 0) newValue = value;
                    if (oldValue !== newValue || !properties.has(name)) {
                        properties.set(name, newValue);
                        this.fire(`change:${name}`, name, newValue, oldValue);
                    }
                }
            });
            this[name] = value;
        }
        bind(...bindProperties) {
            if (!bindProperties.length || !$c7bc2cb7e2db0227$var$isStringArray(bindProperties)) /**
			* All properties must be strings.
			*
			* @error observable-bind-wrong-properties
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-wrong-properties", this);
            if (new Set(bindProperties).size !== bindProperties.length) /**
			* Properties must be unique.
			*
			* @error observable-bind-duplicate-properties
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-duplicate-properties", this);
            $c7bc2cb7e2db0227$var$initObservable(this);
            const boundProperties = this[$c7bc2cb7e2db0227$var$boundPropertiesSymbol];
            bindProperties.forEach((propertyName)=>{
                if (boundProperties.has(propertyName)) /**
				* Cannot bind the same property more than once.
				*
				* @error observable-bind-rebind
				*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-rebind", this);
            });
            const bindings = /* @__PURE__ */ new Map();
            bindProperties.forEach((a)=>{
                const binding = {
                    property: a,
                    to: []
                };
                boundProperties.set(a, binding);
                bindings.set(a, binding);
            });
            return {
                to: $c7bc2cb7e2db0227$var$bindTo,
                toMany: $c7bc2cb7e2db0227$var$bindToMany,
                _observable: this,
                _bindProperties: bindProperties,
                _to: [],
                _bindings: bindings
            };
        }
        unbind(...unbindProperties) {
            if (!this[$c7bc2cb7e2db0227$var$observablePropertiesSymbol]) return;
            const boundProperties = this[$c7bc2cb7e2db0227$var$boundPropertiesSymbol];
            const boundObservables = this[$c7bc2cb7e2db0227$var$boundObservablesSymbol];
            if (unbindProperties.length) {
                if (!$c7bc2cb7e2db0227$var$isStringArray(unbindProperties)) /**
				* Properties must be strings.
				*
				* @error observable-unbind-wrong-properties
				*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-unbind-wrong-properties", this);
                unbindProperties.forEach((propertyName)=>{
                    const binding = boundProperties.get(propertyName);
                    if (!binding) return;
                    binding.to.forEach(([toObservable, toProperty])=>{
                        const toProperties = boundObservables.get(toObservable);
                        const toPropertyBindings = toProperties[toProperty];
                        toPropertyBindings.delete(binding);
                        if (!toPropertyBindings.size) delete toProperties[toProperty];
                        if (!Object.keys(toProperties).length) {
                            boundObservables.delete(toObservable);
                            this.stopListening(toObservable, "change");
                        }
                    });
                    boundProperties.delete(propertyName);
                });
            } else {
                boundObservables.forEach((bindings, boundObservable)=>{
                    this.stopListening(boundObservable, "change");
                });
                boundObservables.clear();
                boundProperties.clear();
            }
        }
        decorate(methodName) {
            $c7bc2cb7e2db0227$var$initObservable(this);
            const originalMethod = this[methodName];
            if (!originalMethod) /**
			* Cannot decorate an undefined method.
			*
			* @error observablemixin-cannot-decorate-undefined
			* @param {object} object The object which method should be decorated.
			* @param {string} methodName Name of the method which does not exist.
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observablemixin-cannot-decorate-undefined", this, {
                object: this,
                methodName: methodName
            });
            this.on(methodName, (evt, args)=>{
                evt.return = originalMethod.apply(this, args);
            });
            this[methodName] = function(...args) {
                return this.fire(methodName, args);
            };
            this[methodName][$c7bc2cb7e2db0227$var$decoratedOriginal] = originalMethod;
            if (!this[$c7bc2cb7e2db0227$var$decoratedMethods]) this[$c7bc2cb7e2db0227$var$decoratedMethods] = [];
            this[$c7bc2cb7e2db0227$var$decoratedMethods].push(methodName);
        }
        stopListening(emitter, event, callback) {
            if (!emitter && this[$c7bc2cb7e2db0227$var$decoratedMethods]) {
                for (const methodName of this[$c7bc2cb7e2db0227$var$decoratedMethods])this[methodName] = this[methodName][$c7bc2cb7e2db0227$var$decoratedOriginal];
                delete this[$c7bc2cb7e2db0227$var$decoratedMethods];
            }
            super.stopListening(emitter, event, callback);
        }
        [$c7bc2cb7e2db0227$var$observablePropertiesSymbol];
        [$c7bc2cb7e2db0227$var$decoratedMethods];
        [$c7bc2cb7e2db0227$var$boundPropertiesSymbol];
        [$c7bc2cb7e2db0227$var$boundObservablesSymbol];
    }
    return Mixin;
}
function $c7bc2cb7e2db0227$var$initObservable(observable) {
    if (observable[$c7bc2cb7e2db0227$var$observablePropertiesSymbol]) return;
    Object.defineProperty(observable, $c7bc2cb7e2db0227$var$observablePropertiesSymbol, {
        value: /* @__PURE__ */ new Map()
    });
    Object.defineProperty(observable, $c7bc2cb7e2db0227$var$boundObservablesSymbol, {
        value: /* @__PURE__ */ new Map()
    });
    Object.defineProperty(observable, $c7bc2cb7e2db0227$var$boundPropertiesSymbol, {
        value: /* @__PURE__ */ new Map()
    });
}
/**
* A chaining for {@link module:utils/observablemixin~Observable#bind} providing `.to()` interface.
*
* @param args Arguments of the `.to( args )` binding.
*/ function $c7bc2cb7e2db0227$var$bindTo(...args) {
    const parsedArgs = $c7bc2cb7e2db0227$var$parseBindToArgs(...args);
    const bindingsKeys = Array.from(this._bindings.keys());
    const numberOfBindings = bindingsKeys.length;
    if (!parsedArgs.callback && parsedArgs.to.length > 1) /**
	* Binding multiple observables only possible with callback.
	*
	* @error observable-bind-to-no-callback
	*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-no-callback", this);
    if (numberOfBindings > 1 && parsedArgs.callback) /**
	* Cannot bind multiple properties and use a callback in one binding.
	*
	* @error observable-bind-to-extra-callback
	*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-extra-callback", this);
    parsedArgs.to.forEach((to)=>{
        if (to.properties.length && to.properties.length !== numberOfBindings) /**
		* The number of properties must match.
		*
		* @error observable-bind-to-properties-length
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-properties-length", this);
        if (!to.properties.length) to.properties = this._bindProperties;
    });
    this._to = parsedArgs.to;
    if (parsedArgs.callback) this._bindings.get(bindingsKeys[0]).callback = parsedArgs.callback;
    $c7bc2cb7e2db0227$var$attachBindToListeners(this._observable, this._to);
    $c7bc2cb7e2db0227$var$updateBindToBound(this);
    this._bindProperties.forEach((propertyName)=>{
        $c7bc2cb7e2db0227$var$updateBoundObservableProperty(this._observable, propertyName);
    });
}
/**
* Binds to an attribute in a set of iterable observables.
*/ function $c7bc2cb7e2db0227$var$bindToMany(observables, attribute, callback) {
    if (this._bindings.size > 1) /**
	* Binding one attribute to many observables only possible with one attribute.
	*
	* @error observable-bind-to-many-not-one-binding
	*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-many-not-one-binding", this);
    this.to(...$c7bc2cb7e2db0227$var$getBindingTargets(observables, attribute), callback);
}
/**
* Returns an array of binding components for
* {@link Observable#bind} from a set of iterable observables.
*/ function $c7bc2cb7e2db0227$var$getBindingTargets(observables, attribute) {
    const observableAndAttributePairs = observables.map((observable)=>[
            observable,
            attribute
        ]);
    return Array.prototype.concat.apply([], observableAndAttributePairs);
}
/**
* Check if all entries of the array are of `String` type.
*/ function $c7bc2cb7e2db0227$var$isStringArray(arr) {
    return arr.every((a)=>typeof a == "string");
}
/**
* Parses and validates {@link Observable#bind}`.to( args )` arguments and returns
* an object with a parsed structure. For example
*
* ```ts
* A.bind( 'x' ).to( B, 'a', C, 'b', call );
* ```
*
* becomes
*
* ```ts
* {
* 	to: [
* 		{ observable: B, properties: [ 'a' ] },
* 		{ observable: C, properties: [ 'b' ] },
* 	],
* 	callback: call
* }
*
* @param args Arguments of {@link Observable#bind}`.to( args )`.
*/ function $c7bc2cb7e2db0227$var$parseBindToArgs(...args) {
    if (!args.length) /**
	* Invalid argument syntax in `to()`.
	*
	* @error observable-bind-to-parse-error
	*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-parse-error", null);
    const parsed = {
        to: []
    };
    let lastObservable;
    if (typeof args[args.length - 1] == "function") parsed.callback = args.pop();
    args.forEach((a)=>{
        if (typeof a == "string") lastObservable.properties.push(a);
        else if (typeof a == "object") {
            lastObservable = {
                observable: a,
                properties: []
            };
            parsed.to.push(lastObservable);
        } else throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("observable-bind-to-parse-error", null);
    });
    return parsed;
}
/**
* Synchronizes {@link module:utils/observable#_boundObservables} with {@link Binding}.
*
* @param binding A binding to store in {@link Observable#_boundObservables}.
* @param toObservable A observable, which is a new component of `binding`.
* @param toPropertyName A name of `toObservable`'s property, a new component of the `binding`.
*/ function $c7bc2cb7e2db0227$var$updateBoundObservables(observable, binding, toObservable, toPropertyName) {
    const boundObservables = observable[$c7bc2cb7e2db0227$var$boundObservablesSymbol];
    const bindingsToObservable = boundObservables.get(toObservable);
    const bindings = bindingsToObservable || {};
    if (!bindings[toPropertyName]) bindings[toPropertyName] = /* @__PURE__ */ new Set();
    bindings[toPropertyName].add(binding);
    if (!bindingsToObservable) boundObservables.set(toObservable, bindings);
}
/**
* Synchronizes {@link Observable#_boundProperties} and {@link Observable#_boundObservables}
* with {@link BindChain}.
*
* Assuming the following binding being created
*
* ```ts
* A.bind( 'a', 'b' ).to( B, 'x', 'y' );
* ```
*
* the following bindings were initialized by {@link Observable#bind} in {@link BindChain#_bindings}:
*
* ```ts
* {
* 	a: { observable: A, property: 'a', to: [] },
* 	b: { observable: A, property: 'b', to: [] },
* }
* ```
*
* Iterate over all bindings in this chain and fill their `to` properties with
* corresponding to( ... ) arguments (components of the binding), so
*
* ```ts
* {
* 	a: { observable: A, property: 'a', to: [ B, 'x' ] },
* 	b: { observable: A, property: 'b', to: [ B, 'y' ] },
* }
* ```
*
* Then update the structure of {@link Observable#_boundObservables} with updated
* binding, so it becomes:
*
* ```ts
* Map( {
* 	B: {
* 		x: Set( [
* 			{ observable: A, property: 'a', to: [ [ B, 'x' ] ] }
* 		] ),
* 		y: Set( [
* 			{ observable: A, property: 'b', to: [ [ B, 'y' ] ] },
* 		] )
* 	}
* } )
* ```
*
* @param chain The binding initialized by {@link Observable#bind}.
*/ function $c7bc2cb7e2db0227$var$updateBindToBound(chain) {
    let toProperty;
    chain._bindings.forEach((binding, propertyName)=>{
        chain._to.forEach((to)=>{
            toProperty = to.properties[binding.callback ? 0 : chain._bindProperties.indexOf(propertyName)];
            binding.to.push([
                to.observable,
                toProperty
            ]);
            $c7bc2cb7e2db0227$var$updateBoundObservables(chain._observable, binding, to.observable, toProperty);
        });
    });
}
/**
* Updates an property of a {@link Observable} with a value
* determined by an entry in {@link Observable#_boundProperties}.
*
* @param observable A observable which property is to be updated.
* @param propertyName An property to be updated.
*/ function $c7bc2cb7e2db0227$var$updateBoundObservableProperty(observable, propertyName) {
    const binding = observable[$c7bc2cb7e2db0227$var$boundPropertiesSymbol].get(propertyName);
    let propertyValue;
    if (binding.callback) propertyValue = binding.callback.apply(observable, binding.to.map((to)=>to[0][to[1]]));
    else {
        propertyValue = binding.to[0];
        propertyValue = propertyValue[0][propertyValue[1]];
    }
    if (Object.prototype.hasOwnProperty.call(observable, propertyName)) observable[propertyName] = propertyValue;
    else observable.set(propertyName, propertyValue);
}
/**
* Starts listening to changes in {@link BindChain._to} observables to update
* {@link BindChain._observable} {@link BindChain._bindProperties}. Also sets the
* initial state of {@link BindChain._observable}.
*
* @param chain The chain initialized by {@link Observable#bind}.
*/ function $c7bc2cb7e2db0227$var$attachBindToListeners(observable, toBindings) {
    toBindings.forEach((to)=>{
        const boundObservables = observable[$c7bc2cb7e2db0227$var$boundObservablesSymbol];
        let bindings;
        if (!boundObservables.get(to.observable)) observable.listenTo(to.observable, "change", (evt, propertyName)=>{
            bindings = boundObservables.get(to.observable)[propertyName];
            if (bindings) bindings.forEach((binding)=>{
                $c7bc2cb7e2db0227$var$updateBoundObservableProperty(observable, binding.property);
            });
        });
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isshadowroot
*/ /**
* Checks whether the given object is a native DOM `ShadowRoot`.
*
* A type guard, safe to call on any value, and correct for a root belonging to another document or iframe.
*
* @param obj The object to check.
*/ function $c7bc2cb7e2db0227$export$af51f0f06c0f328a(obj) {
    if (!obj) return false;
    const defaultView = obj.ownerDocument?.defaultView;
    return obj instanceof (defaultView ? defaultView.ShadowRoot : ShadowRoot);
}
/**
* Checks whether the given object is a shadow root the platform itself accepts.
*
* A page may run a shadow DOM polyfill that emulates the boundary in the light DOM instead of asking the
* engine for one – a *synthetic* shadow root. Such a root passes {@link ~isShadowRoot}, because the polyfill
* replaces the global `ShadowRoot` with its own constructor and patches `Symbol.hasInstance` on it. It
* emulates the tree faithfully enough for traversal (`host`, `parentNode`, `contains`, `activeElement` all
* behave), which is why {@link ~isShadowRoot} stays truthful about it, but being no platform object it
* cannot be:
*
* * passed to a DOM API expecting a real root – `Selection#getComposedRanges()` and
*   `Document#caretPositionFromPoint()` reject it while converting their arguments;
* * asked for its selection or stylesheets – those are the members a polyfill cannot emulate, so it
*   usually makes them throw;
* * used as a mount target – its `appendChild()` delegates to the host element, so the node ends up in the
*   surrounding tree rather than at the top of the one it was mounted in.
*
* Use it wherever a root crosses into one of those, and {@link ~isShadowRoot} everywhere else. Answering
* `false` here falls back to the light-DOM path, which is the correct answer for a synthetic root: the
* boundary it emulates is not one the engine actually has, so the document-level APIs already see the real
* nodes behind it.
*
* @internal
* @param obj The object to check.
*/ function $c7bc2cb7e2db0227$var$isNativeShadowRoot(obj) {
    return $c7bc2cb7e2db0227$export$af51f0f06c0f328a(obj) && obj.synthetic !== true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getparentnode
*/ /**
* Returns the node one step up the composed tree, crossing shadow boundaries.
*
* The shadow-aware replacement for `Node#parentNode`, and the primitive for walking from a node outwards to the
* document. It steps over any node, so such a walk visits the `ShadowRoot` nodes on the way and reaches the
* `Document` at the top – to walk elements only, use
* {@link module:utils/dom/getparentelement~getParentElement}. Works for open and closed roots alike.
*
* @param node The node to step up from.
*/ function $c7bc2cb7e2db0227$export$4e12058fc4d51d56(node) {
    return $c7bc2cb7e2db0227$export$af51f0f06c0f328a(node) ? node.host : node.parentNode;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/elementreplacer
*/ /**
* Utility class allowing to hide existing HTML elements or replace them with given ones in a way that doesn't remove
* the original elements from the DOM.
*/ var $c7bc2cb7e2db0227$export$d2f12916c0c3be76 = class {
    /**
	* The elements replaced by {@link #replace} and their replacements.
	*/ _replacedElements;
    constructor(){
        this._replacedElements = [];
    }
    /**
	* Hides the `element` and, if specified, inserts the the given element next to it.
	*
	* The effect of this method can be reverted by {@link #restore}.
	*
	* @param element The element to replace.
	* @param newElement The replacement element. If not passed, then the `element` will just be hidden.
	*/ replace(element, newElement) {
        this._replacedElements.push({
            element: element,
            newElement: newElement
        });
        element.style.display = "none";
        if (newElement) $c7bc2cb7e2db0227$export$4e12058fc4d51d56(element).insertBefore(newElement, element.nextSibling);
    }
    /**
	* Restores what {@link #replace} did.
	*/ restore() {
        this._replacedElements.forEach(({ element: element, newElement: newElement })=>{
            element.style.display = "";
            if (newElement) newElement.remove();
        });
        this._replacedElements = [];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/abortabledebounce
*/ /**
* Returns a function wrapper that will execute the provided function and abort any previous call that is still in progress.
*
* @param func The function to be called. It will be provided with `AbortSignal` as the first parameter.
*/ function $c7bc2cb7e2db0227$export$fa449de2c34088fe(func) {
    let controller = new AbortController();
    function abortable(...args) {
        controller.abort();
        controller = new AbortController();
        return func(controller.signal, ...args);
    }
    abortable.abort = ()=>controller.abort();
    return abortable;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/count
*/ /**
* Returns the number of items return by the iterator.
*
* ```ts
* count( [ 1, 2, 3, 4, 5 ] ); // 5;
* ```
*
* @param iterable Any iterable.
* @returns Number of items returned by that iterable.
*/ function $c7bc2cb7e2db0227$export$85b9a36db797e02b(iterable) {
    let count = 0;
    for (const _ of iterable)count++;
    return count;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/comparearrays
*/ /**
* Compares how given arrays relate to each other. One array can be: same as another array, prefix of another array
* or completely different. If arrays are different, first index at which they differ is returned. Otherwise,
* a flag specifying the relation is returned. Flags are negative numbers, so whenever a number >= 0 is returned
* it means that arrays differ.
*
* ```ts
* compareArrays( [ 0, 2 ], [ 0, 2 ] );		// 'same'
* compareArrays( [ 0, 2 ], [ 0, 2, 1 ] );		// 'prefix'
* compareArrays( [ 0, 2 ], [ 0 ] );			// 'extension'
* compareArrays( [ 0, 2 ], [ 1, 2 ] );		// 0
* compareArrays( [ 0, 2 ], [ 0, 1 ] );		// 1
* ```
*
* @param a Array that is compared.
* @param b Array to compare with.
* @returns How array `a` is related to `b`.
*/ function $c7bc2cb7e2db0227$export$fc16749c794bf6ff(a, b) {
    const minLen = Math.min(a.length, b.length);
    for(let i = 0; i < minLen; i++)if (a[i] != b[i]) return i;
    if (a.length == b.length) return "same";
    else if (a.length < b.length) return "prefix";
    else return "extension";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/isiterable
*/ /**
* Checks if value implements iterator interface.
*
* @param value The value to check.
* @returns True if value implements iterator interface.
*/ function $c7bc2cb7e2db0227$export$9652023d9040757(value) {
    return !!(value && value[Symbol.iterator]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/createelement
*/ /**
* Creates an HTML or SVG element with attributes and children elements.
*
* ```ts
* createElement( document, 'p' ); // <p>
* createElement( document, 'mask', { xmlns: 'http://www.w3.org/2000/svg' } ); // <mask>
* ```
*
* @param doc Document used to create the element.
* @param name Name of the element.
* @param attributes Object where keys represent attribute keys and values represent attribute values.
* @param children Child or any iterable of children. Strings will be automatically turned into Text nodes.
* @returns HTML or SVG element.
*/ function $c7bc2cb7e2db0227$export$c8a8987d4410bf2d(doc, name, attributes = {}, children = []) {
    const namespace = attributes && attributes.xmlns;
    const element = namespace ? doc.createElementNS(namespace, name) : doc.createElement(name);
    for(const key in attributes)element.setAttribute(key, attributes[key]);
    if ((0, $d1398c5596cf9556$export$844ec244b1367d54)(children) || !$c7bc2cb7e2db0227$export$9652023d9040757(children)) children = [
        children
    ];
    for (let child of children){
        if ((0, $d1398c5596cf9556$export$844ec244b1367d54)(child)) child = doc.createTextNode(child);
        element.appendChild(child);
    }
    return element;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/config
*/ /**
* Handles a configuration dictionary.
*
* @typeParam Cfg A type of the configuration dictionary.
*/ var $c7bc2cb7e2db0227$export$29cd7b75162a9425 = class {
    /**
	* Store for the whole configuration.
	*/ _config;
    /**
	* Creates an instance of the {@link ~Config} class.
	*
	* @param configurations The initial configurations to be set. Usually, provided by the user.
	* @param defaultConfigurations The default configurations. Usually, provided by the system.
	*/ constructor(configurations, defaultConfigurations){
        this._config = Object.create(null);
        if (defaultConfigurations) this.define($c7bc2cb7e2db0227$var$cloneConfig(defaultConfigurations));
        if (configurations) this._setObjectToTarget(this._config, configurations);
    }
    set(name, value) {
        this._setToTarget(this._config, name, value);
    }
    define(name, value) {
        this._setToTarget(this._config, name, value, true);
    }
    /**
	* Gets the value for a configuration entry.
	*
	* ```ts
	* config.get( 'name' );
	* ```
	*
	* Deep configurations can be retrieved by separating each part with a dot.
	*
	* ```ts
	* config.get( 'toolbar.collapsed' );
	* ```
	*
	* @param name The configuration name. Configuration names are case-sensitive.
	* @returns The configuration value or `undefined` if the configuration entry was not found.
	*/ get(name) {
        return this._getFromSource(this._config, name);
    }
    /**
	* Iterates over all top level configuration names.
	*/ *names() {
        for (const name of Object.keys(this._config))yield name;
    }
    /**
	* Saves passed configuration to the specified target (nested object).
	*
	* @param target Nested config object.
	* @param name The configuration name or an object from which take properties as
	* configuration entries. Configuration names are case-sensitive.
	* @param value The configuration value. Used if a name is passed.
	* @param isDefine Define if passed configuration should overwrite existing one.
	*/ _setToTarget(target, name, value, isDefine = false) {
        if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(name)) {
            this._setObjectToTarget(target, name, isDefine);
            return;
        }
        const parts = name.split(".");
        name = parts.pop();
        for (const part of parts){
            if (!(0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(target[part])) target[part] = Object.create(null);
            target = target[part];
        }
        if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(value)) {
            if (!(0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(target[name])) target[name] = Object.create(null);
            target = target[name];
            this._setObjectToTarget(target, value, isDefine);
            return;
        }
        if (isDefine && typeof target[name] != "undefined") return;
        target[name] = value;
    }
    /**
	* Get specified configuration from specified source (nested object).
	*
	* @param source level of nested object.
	* @param name The configuration name. Configuration names are case-sensitive.
	* @returns The configuration value or `undefined` if the configuration entry was not found.
	*/ _getFromSource(source, name) {
        const parts = name.split(".");
        name = parts.pop();
        for (const part of parts){
            if (!(0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(source[part])) {
                source = null;
                break;
            }
            source = source[part];
        }
        return source ? $c7bc2cb7e2db0227$var$cloneConfig(source[name]) : void 0;
    }
    /**
	* Iterates through passed object and calls {@link #_setToTarget} method with object key and value for each property.
	*
	* @param target Nested config object.
	* @param configuration Configuration data set
	* @param isDefine Defines if passed configuration is default configuration or not.
	*/ _setObjectToTarget(target, configuration, isDefine) {
        Object.keys(configuration).forEach((key)=>{
            this._setToTarget(target, key, configuration[key], isDefine);
        });
    }
};
/**
* Clones configuration object or value.
*/ function $c7bc2cb7e2db0227$var$cloneConfig(source) {
    return (0, $850a6c1e0528b9df$export$684657552801b6ad)(source, $c7bc2cb7e2db0227$var$leaveItemReferences);
}
/**
* A customized function for cloneDeepWith.
* In case if it's a DOM Element it will leave references to DOM Elements instead of cloning them.
* If it's a function it will leave reference to actuall function.
*/ function $c7bc2cb7e2db0227$var$leaveItemReferences(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value) || typeof value === "function" ? value : void 0;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isnode
*/ /**
* Checks if the object is a native DOM Node.
*/ function $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee(obj) {
    if (obj) {
        if (obj.defaultView) return obj instanceof obj.defaultView.Document;
        else if (obj.ownerDocument && obj.ownerDocument.defaultView) return obj instanceof obj.ownerDocument.defaultView.Node;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/iswindow
*/ /**
* Checks if the object is a native DOM Window.
*/ function $c7bc2cb7e2db0227$export$5a096129d439f843(obj) {
    const stringifiedObject = Object.prototype.toString.apply(obj);
    if (stringifiedObject == "[object Window]") return true;
    if (stringifiedObject == "[object global]") return true;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/emittermixin
*/ const $c7bc2cb7e2db0227$var$defaultEmitterClass = /* #__PURE__ */ $c7bc2cb7e2db0227$export$537a1d64e9da4c8f(/* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594());
const $c7bc2cb7e2db0227$var$ProxyEmitterBase = /* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594();
function $c7bc2cb7e2db0227$export$537a1d64e9da4c8f(base) {
    if (!base) return $c7bc2cb7e2db0227$var$defaultEmitterClass;
    class Mixin extends base {
        listenTo(emitter, event, callback, options = {}) {
            if ($c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee(emitter) || $c7bc2cb7e2db0227$export$5a096129d439f843(emitter) || emitter instanceof $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.EventTarget) {
                if ($c7bc2cb7e2db0227$export$af51f0f06c0f328a(emitter) && !$c7bc2cb7e2db0227$var$isNativeShadowRoot(emitter)) return;
                const proxyOptions = {
                    capture: !!options.useCapture,
                    passive: !!options.usePassive
                };
                const proxyEmitter = this._getProxyEmitter(emitter, proxyOptions) || new $c7bc2cb7e2db0227$var$ProxyEmitter(emitter, proxyOptions);
                this.listenTo(proxyEmitter, event, callback, options);
            } else super.listenTo(emitter, event, callback, options);
        }
        stopListening(emitter, event, callback) {
            if ($c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee(emitter) || $c7bc2cb7e2db0227$export$5a096129d439f843(emitter) || emitter instanceof $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.EventTarget) {
                const proxyEmitters = this._getAllProxyEmitters(emitter);
                for (const proxy of proxyEmitters)this.stopListening(proxy, event, callback);
            } else super.stopListening(emitter, event, callback);
        }
        /**
		* Retrieves ProxyEmitter instance for given DOM Node residing in this Host and given options.
		*
		* @param node DOM Node of the ProxyEmitter.
		* @param options Additional options.
		* @param options.useCapture Indicates that events of this type will be dispatched to the registered
		* listener before being dispatched to any EventTarget beneath it in the DOM tree.
		* @param options.usePassive Indicates that the function specified by listener will never call preventDefault()
		* and prevents blocking browser's main thread by this event handler.
		* @returns ProxyEmitter instance bound to the DOM Node.
		*/ _getProxyEmitter(node, options) {
            return $c7bc2cb7e2db0227$export$59cc71c40980756b(this, $c7bc2cb7e2db0227$var$getProxyEmitterId(node, options));
        }
        /**
		* Retrieves all the ProxyEmitter instances for given DOM Node residing in this Host.
		*
		* @param node DOM Node of the ProxyEmitter.
		*/ _getAllProxyEmitters(node) {
            return [
                {
                    capture: false,
                    passive: false
                },
                {
                    capture: false,
                    passive: true
                },
                {
                    capture: true,
                    passive: false
                },
                {
                    capture: true,
                    passive: true
                }
            ].map((options)=>this._getProxyEmitter(node, options)).filter((proxy)=>!!proxy);
        }
    }
    return Mixin;
}
/**
* Creates a ProxyEmitter instance. Such an instance is a bridge between a DOM Node firing events
* and any Host listening to them. It is backwards compatible with {@link module:utils/emittermixin~Emitter#on}.
* There is a separate instance for each combination of modes (useCapture & usePassive). The mode is concatenated with
* UID stored in HTMLElement to give each instance unique identifier.
*
*                                  listenTo( click, ... )
*                    +-----------------------------------------+
*                    |              stopListening( ... )       |
*     +----------------------------+                           |             addEventListener( click, ... )
*     | Host                       |                           |   +---------------------------------------------+
*     +----------------------------+                           |   |       removeEventListener( click, ... )     |
*     | _listeningTo: {            |                +----------v-------------+                                   |
*     |   UID+mode: {              |                | ProxyEmitter           |                                   |
*     |     emitter: ProxyEmitter, |                +------------------------+                      +------------v----------+
*     |     callbacks: {           |                | events: {              |                      | Node (HTMLElement)    |
*     |       click: [ callbacks ] |                |   click: [ callbacks ] |                      +-----------------------+
*     |     }                      |                | },                     |                      | data-ck-expando: UID  |
*     |   }                        |                | _domNode: Node,        |                      +-----------------------+
*     | }                          |                | _domListeners: {},     |                                   |
*     | +------------------------+ |                | _emitterId: UID+mode   |                                   |
*     | | DomEmitterMixin        | |                +--------------^---------+                                   |
*     | +------------------------+ |                           |   |                                             |
*     +--------------^-------------+                           |   +---------------------------------------------+
*                    |                                         |                  click (DOM Event)
*                    +-----------------------------------------+
*                                fire( click, DOM Event )
*/ var $c7bc2cb7e2db0227$var$ProxyEmitter = class extends $c7bc2cb7e2db0227$var$ProxyEmitterBase {
    _domNode;
    _options;
    /**
	* @param node DOM Node that fires events.
	* @param options Additional options.
	* @param options.useCapture Indicates that events of this type will be dispatched to the registered
	* listener before being dispatched to any EventTarget beneath it in the DOM tree.
	* @param options.usePassive Indicates that the function specified by listener will never call preventDefault()
	* and prevents blocking browser's main thread by this event handler.
	*/ constructor(node, options){
        super();
        $c7bc2cb7e2db0227$export$df1b5ccfb3ce9df8(this, $c7bc2cb7e2db0227$var$getProxyEmitterId(node, options));
        this._domNode = node;
        this._options = options;
    }
    /**
	* Collection of native DOM listeners.
	*/ _domListeners;
    /**
	* Registers a callback function to be executed when an event is fired.
	*
	* It attaches a native DOM listener to the DOM Node. When fired,
	* a corresponding Emitter event will also fire with DOM Event object as an argument.
	*
	* **Note**: This is automatically called by the
	* {@link module:utils/emittermixin~Emitter#listenTo `Emitter#listenTo()`}.
	*
	* @param event The name of the event.
	*/ attach(event) {
        if (this._domListeners && this._domListeners[event]) return;
        const domListener = this._createDomListener(event);
        this._domNode.addEventListener(event, domListener, this._options);
        if (!this._domListeners) this._domListeners = {};
        this._domListeners[event] = domListener;
    }
    /**
	* Stops executing the callback on the given event.
	*
	* **Note**: This is automatically called by the
	* {@link module:utils/emittermixin~Emitter#stopListening `Emitter#stopListening()`}.
	*
	* @param event The name of the event.
	*/ detach(event) {
        let events;
        if (this._domListeners[event] && (!(events = this._events[event]) || !events.callbacks.length)) this._domListeners[event].removeListener();
    }
    /**
	* Adds callback to emitter for given event.
	*
	* @internal
	* @param event The name of the event.
	* @param callback The function to be called on event.
	* @param options Additional options.
	*/ _addEventListener(event, callback, options) {
        this.attach(event);
        $c7bc2cb7e2db0227$export$1f0c3be316c44594().prototype._addEventListener.call(this, event, callback, options);
    }
    /**
	* Removes callback from emitter for given event.
	*
	* @internal
	* @param event The name of the event.
	* @param callback The function to stop being called.
	*/ _removeEventListener(event, callback) {
        $c7bc2cb7e2db0227$export$1f0c3be316c44594().prototype._removeEventListener.call(this, event, callback);
        this.detach(event);
    }
    /**
	* Creates a native DOM listener callback. When the native DOM event
	* is fired it will fire corresponding event on this ProxyEmitter.
	* Note: A native DOM Event is passed as an argument.
	*
	* @param event The name of the event.
	* @returns The DOM listener callback.
	*/ _createDomListener(event) {
        const domListener = (domEvt)=>{
            this.fire(event, domEvt);
        };
        domListener.removeListener = ()=>{
            this._domNode.removeEventListener(event, domListener, this._options);
            delete this._domListeners[event];
        };
        return domListener;
    }
};
/**
* Gets an unique DOM Node identifier. The identifier will be set if not defined.
*
* @returns UID for given DOM Node.
*/ function $c7bc2cb7e2db0227$var$getNodeUID(node) {
    return node["data-ck-expando"] || (node["data-ck-expando"] = $c7bc2cb7e2db0227$export$e2a22331486dcca0());
}
/**
* Gets id of the ProxyEmitter for the given node.
*/ function $c7bc2cb7e2db0227$var$getProxyEmitterId(node, options) {
    let id = $c7bc2cb7e2db0227$var$getNodeUID(node);
    for (const option of Object.keys(options).sort())if (options[option]) id += "-" + option;
    return id;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getparentelement
*/ /**
* Returns the parent element of the given node, crossing shadow boundaries.
*
* The shadow-aware replacement for `Node#parentElement`, which is `null` for a node sitting directly in a
* `ShadowRoot` and so stops an outward walk at the boundary. Works for open and closed roots alike.
*
* @param node The node to get the parent element of.
*/ function $c7bc2cb7e2db0227$export$169e5491001d3ed6(node) {
    const parent = node.parentNode;
    return $c7bc2cb7e2db0227$export$af51f0f06c0f328a(parent) ? parent.host : node.parentElement;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getlayoutparentelement
*/ /**
* Returns the parent element in the **flattened tree**, the one the browser lays out and paints.
*
* The layout-aware counterpart of {@link module:utils/dom/getparentelement~getParentElement}, and the element-only
* form of {@link module:utils/dom/getlayoutparentnode~getLayoutParentNode} – see that one for why the flattened
* tree and the node tree disagree for slotted content, and for when to prefer which.
*
* Use it to walk outwards over the elements that lay a node out: its scrollable ancestors, its clipping ancestors.
* Works for open and closed roots alike, and falls back to the node tree for slotted content inside a closed root,
* whose slot the DOM standard does not expose.
*
* @param node The node to get the layout parent element of.
*/ function $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(node) {
    return node.assignedSlot || $c7bc2cb7e2db0227$export$169e5491001d3ed6(node);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/findclosestscrollableancestor
*/ /**
* Returns the closest scrollable ancestor of a DOM element.
*
* The search crosses shadow DOM boundaries, continuing from the host element of a shadow root instead of
* stopping at it. Without that, an element rendered inside a shadow tree would report no scrollable ancestor at
* all, even when one exists further up in the surrounding document, because the walk goes over `parentElement`,
* which is `null` for a direct child of a shadow root. Works for both open and closed shadow roots.
*
* @param domElement DOM element.
* @returns First ancestor of `domElement` that is scrollable or null if such ancestor doesn't exist.
*/ function $c7bc2cb7e2db0227$export$eb6c9aac129b0a9e(domElement) {
    let element = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(domElement);
    if (!element) return null;
    while(element.tagName != "BODY"){
        const overflow = element.style.overflowY || $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.getComputedStyle(element).overflowY;
        if (overflow === "auto" || overflow === "scroll") break;
        element = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(element);
        if (!element) return null;
    }
    return element;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getlayoutparentnode
*/ /**
* Returns the node one step up the **flattened tree**, the one the browser lays out and paints.
*
* The layout-aware counterpart of {@link module:utils/dom/getparentnode~getParentNode}, which walks the node
* tree. The two agree everywhere except for slotted content: assigning a node to a `<slot>` does not move it, so
* it stays a child of the host in the node tree while rendering inside the slot. A node-tree walk out of such a
* node therefore leaves into the light DOM and skips every element of the shadow tree that actually lays it out.
*
* Use this one for questions about geometry – what scrolls a node, what clips it, what it renders inside – and
* {@link module:utils/dom/getparentnode~getParentNode} for questions about structure, such as what a node is a
* descendant of for the purposes of DOM manipulation or event retargeting. Both cross shadow boundaries and both
* work for open and closed roots alike.
*
* **Note**: `Element#assignedSlot` is `null` when the slot lives in a *closed* shadow root, which the DOM
* standard does not expose. For slotted content inside a closed root this falls back to the node tree and
* answers exactly as {@link module:utils/dom/getparentnode~getParentNode} does.
*
* @param node The node to step up from.
*/ function $c7bc2cb7e2db0227$export$d2695a262dde1327(node) {
    return node.assignedSlot || $c7bc2cb7e2db0227$export$4e12058fc4d51d56(node);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/containsnode
*/ /**
* Checks whether `node` is inside `container`, looking through shadow roots on the way.
*
* Use it instead of `Node#contains()`, which stops at a shadow root: that one says `false` even when
* `container` really is an ancestor, as long as a shadow root sits between the two. A node contains itself
* here, just like it does there.
*
* `container` can also be a `Document` or a `ShadowRoot` – useful for a `scroll` event, for example, whose
* target is the document and not an element. Works with open and closed shadow roots.
*
* @param container The node that may be the ancestor.
* @param node The node to look for. May be `null`, which always gives `false`.
*/ function $c7bc2cb7e2db0227$export$f65a70da047b67c6(container, node) {
    let current = node;
    while(current){
        if (current === container) return true;
        current = $c7bc2cb7e2db0227$export$d2695a262dde1327(current);
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getancestors
*/ /**
* Returns all ancestors of given DOM node, starting from the top-most (root). Includes the given node itself. If the
* node is a part of `DocumentFragment` that `DocumentFragment` will be returned. In contrary, if the node is
* appended to a `Document`, that `Document` will not be returned (algorithms operating on DOM tree care for `Document#documentElement`
* at most, which will be returned).
*
* @param node DOM node.
* @returns Array of given `node` parents.
*/ function $c7bc2cb7e2db0227$export$c6fd3ab3f44300d0(node) {
    const nodes = [];
    let currentNode = node;
    while(currentNode && currentNode.nodeType != Node.DOCUMENT_NODE){
        nodes.unshift(currentNode);
        currentNode = currentNode.parentNode;
    }
    return nodes;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getdatafromelement
*/ /**
* Gets data from a given source element.
*
* @param el The element from which the data will be retrieved.
* @returns The data string.
*/ function $c7bc2cb7e2db0227$export$ff7873b3940f78e3(el) {
    if (el instanceof HTMLTextAreaElement) return el.value;
    return el.innerHTML;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getborderwidths
*/ /**
* Returns an object containing CSS border widths of a specified HTML element.
*
* @param element An element which has CSS borders.
* @returns An object containing `top`, `left`, `right` and `bottom` properties
* with numerical values of the `border-[top,left,right,bottom]-width` CSS styles.
*/ function $c7bc2cb7e2db0227$export$c134363f1f37644f(element) {
    const style = element.ownerDocument.defaultView.getComputedStyle(element);
    return {
        top: parseInt(style.borderTopWidth, 10),
        right: parseInt(style.borderRightWidth, 10),
        bottom: parseInt(style.borderBottomWidth, 10),
        left: parseInt(style.borderLeftWidth, 10)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getrangefrommouseevent
*/ /**
* Returns a DOM range from a given point specified by a mouse event.
*
* **Note**: The point is resolved inside the shadow root the event was dispatched in, so a click inside a shadow
* tree gives a range in that tree rather than one at its host. Works for open and closed shadow roots alike, on
* the engines that honor the `shadowRoots` option of `Document#caretPositionFromPoint()`; elsewhere the range
* still lands beside the host.
*
* @param domEvent The mouse event.
* @returns The DOM range.
*/ function $c7bc2cb7e2db0227$export$70a9dc425da3f6b0(domEvent) {
    if (!domEvent.target) return null;
    const domTarget = domEvent.target;
    const domDoc = domTarget.ownerDocument;
    const x = domEvent.clientX;
    const y = domEvent.clientY;
    let domRange = null;
    if (domDoc.caretPositionFromPoint) {
        const rootNode = domTarget.getRootNode();
        const shadowRoots = $c7bc2cb7e2db0227$var$isNativeShadowRoot(rootNode) ? [
            rootNode
        ] : [];
        const caretPosition = domDoc.caretPositionFromPoint(x, y, {
            shadowRoots: shadowRoots
        });
        if (caretPosition) {
            const offsetNode = caretPosition.offsetNode;
            const maxOffset = offsetNode.nodeType === Node.TEXT_NODE ? offsetNode.data.length : offsetNode.childNodes.length;
            const offset = Math.min(caretPosition.offset, maxOffset);
            domRange = domDoc.createRange();
            domRange.setStart(offsetNode, offset);
            domRange.collapse(true);
        }
    } else if (domDoc.caretRangeFromPoint && domDoc.caretRangeFromPoint(x, y)) domRange = domDoc.caretRangeFromPoint(x, y);
    else if (domEvent.rangeParent) {
        domRange = domDoc.createRange();
        domRange.setStart(domEvent.rangeParent, domEvent.rangeOffset);
        domRange.collapse(true);
    }
    return domRange;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getelementfrompoint
*/ /**
* Returns the topmost element at the given viewport point, looking inside the given shadow roots.
*
* The shadow-aware replacement for `Document#elementFromPoint()`, which retargets a point inside a shadow tree
* to that tree's host and so cannot report the element actually under it.
*
* Pass every shadow root a hit may land in – typically each editable's own `getRootNode()`. Only the innermost
* root containing the point matters, so ancestor roots do not need to be listed, and a point in the light DOM
* needs no roots at all.
*
* The point is hit tested strictly, honoring `pointer-events`, so the answer is the element that a click at
* those coordinates would reach. The exception is an engine that cannot hit test a shadow root, where the point
* is resolved from the nearest caret position instead and may land beside what it really hit.
*
* @param x The horizontal coordinate, relative to the viewport.
* @param y The vertical coordinate, relative to the viewport.
* @param shadowRoots The shadow roots the lookup is allowed to look inside. Empty for the light DOM.
*/ function $c7bc2cb7e2db0227$export$7ec1070137f7ab66(x, y, shadowRoots = []) {
    const doc = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.document;
    const [firstRoot] = shadowRoots;
    if (firstRoot && "elementFromPoint" in firstRoot) for (const root of shadowRoots){
        const element = root.elementFromPoint(x, y);
        if (element && element.getRootNode() === root) return element;
    }
    else if (firstRoot && doc.caretPositionFromPoint) {
        const nativeShadowRoots = shadowRoots.filter($c7bc2cb7e2db0227$var$isNativeShadowRoot);
        const caretPosition = doc.caretPositionFromPoint(x, y, {
            shadowRoots: nativeShadowRoots
        });
        const offsetNode = caretPosition && caretPosition.offsetNode;
        const element = offsetNode && offsetNode.nodeType === Node.TEXT_NODE ? $c7bc2cb7e2db0227$export$169e5491001d3ed6(offsetNode) : offsetNode;
        if ($c7bc2cb7e2db0227$var$isElement$2(element) && nativeShadowRoots.includes(element.getRootNode())) return element;
    }
    return doc.elementFromPoint(x, y);
}
function $c7bc2cb7e2db0227$var$isElement$2(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getpositionedancestor
*/ /**
* Returns the element the given one is laid out against while absolutely positioned – the element whose padding
* box its `top` and `left` are relative to. Returns `null` when there is nothing to compensate for: the element
* is laid out against the initial containing block, is `position: fixed`, or is not rendered at all.
*
* Use it when turning a position measured against the viewport into the `top` and `left` to set on an absolutely
* positioned element, by subtracting the returned element's padding-box offset – the way
* {@link module:utils/dom/rect~Rect#toAbsoluteRect} and {@link module:utils/dom/position~getOptimalPosition} do.
*
* The layout-aware counterpart of `Element#offsetParent`, and what to reach for instead of it: this one follows
* the **flattened tree**, the one the browser lays out, so it stays right for slotted content – an editor slotted
* into a container component – where `offsetParent` names an element that does not lay that content out. Falls
* back to `offsetParent` for slotted content inside a closed root, whose slot the DOM standard does not expose.
*
* @param element The native DOM element to be checked.
*/ function $c7bc2cb7e2db0227$export$f410fd9345261d8c(element) {
    if (!element || !element.isConnected) return null;
    const offsetParent = element.offsetParent;
    if (!offsetParent) return null;
    const slot = $c7bc2cb7e2db0227$var$findSlotCloserThan(element, offsetParent);
    if (!slot) {
        if (offsetParent === offsetParent.ownerDocument.body && !$c7bc2cb7e2db0227$var$isContainingBlock(offsetParent)) return null;
        return offsetParent;
    }
    let candidate = slot;
    while(candidate.localName === "slot" && !$c7bc2cb7e2db0227$var$isContainingBlock(candidate))candidate = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(candidate);
    if ($c7bc2cb7e2db0227$var$isContainingBlock(candidate)) return candidate;
    return $c7bc2cb7e2db0227$export$f410fd9345261d8c(candidate);
}
/**
* Walks outwards from the given node looking for the slot it is assigned to, and stops once `offsetParent` is
* reached – so the result tells which of the two is nearer. A slot means the node tree and the flattened tree
* part ways first; `null` means they agree all the way to `offsetParent`.
*/ function $c7bc2cb7e2db0227$var$findSlotCloserThan(node, offsetParent) {
    let current = node;
    while(current && current !== offsetParent){
        if (current.assignedSlot) return current.assignedSlot;
        current = $c7bc2cb7e2db0227$export$169e5491001d3ed6(current);
    }
    return null;
}
/**
* `contain` values that include layout or paint containment, either of which makes an element the containing
* block of its absolutely positioned descendants. `size` alone does not.
*/ const $c7bc2cb7e2db0227$var$CONTAINING_BLOCK_CONTAIN = /\b(?:layout|paint|strict|content)\b/;
/**
* `will-change` values naming a property that establishes a containing block on its own. `filter` also matches
* `backdrop-filter`, which is intended.
*/ const $c7bc2cb7e2db0227$var$CONTAINING_BLOCK_WILL_CHANGE = /\b(?:transform|perspective|filter|contain)\b/;
/**
* Whether the given element is the containing block of its absolutely positioned descendants.
*
* Needed where `offsetParent` cannot answer: the slot a node is assigned to and the element above it, which it
* cannot be asked about at all – it answers what lies *above* an element, never whether the element itself
* qualifies – and `<body>`, which it also names when nothing above the element establishes a containing block.
* The property list is what Chrome establishes a containing block for, verified against `offsetParent`, which
* agrees with the rendered result in every one of these cases.
*/ function $c7bc2cb7e2db0227$var$isContainingBlock(element) {
    const styles = element.ownerDocument.defaultView.getComputedStyle(element);
    if (styles.display === "contents") return false;
    if (styles.position !== "static") return true;
    return $c7bc2cb7e2db0227$var$isNonInitial(styles.transform, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.translate, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.rotate, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.scale, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.perspective, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.filter, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.backdropFilter, "none") || $c7bc2cb7e2db0227$var$isNonInitial(styles.contentVisibility, "visible") || $c7bc2cb7e2db0227$var$CONTAINING_BLOCK_CONTAIN.test(styles.contain) || $c7bc2cb7e2db0227$var$CONTAINING_BLOCK_WILL_CHANGE.test(styles.willChange);
}
/**
* Whether a computed value is something other than the property's initial value, which is what makes the
* property establish a containing block.
*
* A property the browser does not know has no computed value at all, and the comparison alone would read that
* as a value unlike the initial one. Something unsupported establishes nothing, so it answers `false` instead.
*/ function $c7bc2cb7e2db0227$var$isNonInitial(value, initialValue) {
    return !!value && value !== initialValue;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getactiveelement
*/ /**
* Returns the focused element in the tree the given node lives in.
*
* The shadow-aware replacement for `document.activeElement`, which reports the host of a shadow tree rather
* than the focused element inside it. Pass any node from the tree whose focus is in question – typically the
* element being checked itself. Works for open and closed roots alike.
*
* @param node The node whose tree's active element should be returned.
*/ function $c7bc2cb7e2db0227$export$cd4e5573fbe2b576(node) {
    return node.getRootNode().activeElement ?? null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getshadowroots
*/ /**
* Returns every shadow root the given node renders in, innermost first.
*
* For code that has to act on *all* the shadow boundaries above a node – attaching listeners, injecting styles –
* rather than only the nearest one. Empty for a node in the light DOM, and one entry per boundary for a node
* inside nested trees. Works for open and closed roots alike.
*
* Derived from the tree the node sits in, not from whether that tree is in a document: a node inside a shadow
* root reports that root even while its host is detached, because `attachShadow()` makes the shadow tree – and
* its root – real right away. Callers that only care about the roots a node is currently *rendered* in should
* check `Node#isConnected` themselves.
*
* @param node The node to collect the hosting shadow roots of.
*/ function $c7bc2cb7e2db0227$export$9f54ef76df6accb2(node) {
    const shadowRoots = [];
    let current = node;
    while(current){
        if ($c7bc2cb7e2db0227$export$af51f0f06c0f328a(current)) shadowRoots.push(current);
        current = $c7bc2cb7e2db0227$export$d2695a262dde1327(current);
    }
    return shadowRoots;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getoverlaymountroot
*/ /**
* Returns the DOM tree that a feature's floating UI – its balloons, dialogs and tooltips – should be put in:
* the same one the feature itself is in.
*
* Floating UI would otherwise go into `document.body`. That is outside the shadow root an editor may live in,
* so the UI would leave the tree the editor's styles were loaded into, and lose them.
*
* Being in the same tree means one of three things:
*
* * the shadow root the given element is in, if it is in one. A shadow root passed in returns itself.
* * the `<body>` of that element's own document otherwise, so an editor in an iframe stays in that iframe.
* * `null` while the element is detached, because there is no telling yet which tree it will end up in. Put
*   the UI nowhere for now and ask again once the element is in the DOM.
*
* Feed the result to {@link module:ui/editorui/bodycollection~BodyCollection#syncMountTarget}, and call this
* again whenever the element may have moved. Works with open and closed shadow roots.
*
* @param containerNode The element the floating UI belongs to – usually the feature's container.
*/ function $c7bc2cb7e2db0227$export$da615035af2261f1(containerNode) {
    if (!containerNode.isConnected) return null;
    const root = containerNode.getRootNode();
    return $c7bc2cb7e2db0227$var$isNativeShadowRoot(root) ? root : containerNode.ownerDocument.body;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/adoptglobalstylesheet
*/ /**
* The stylesheet text already adopted into a document, so the same rules are adopted once no matter how many
* editors ask for them, or how many times.
*/ const $c7bc2cb7e2db0227$var$adoptedStyleSheets = /* @__PURE__ */ new WeakMap();
/**
* Ships a stylesheet that has to reach the light DOM, whatever tree the editor itself lives in.
*
* For the few rules that a shadow-scoped theme stylesheet cannot express, because they style nodes no shadow
* root can contain: the `<html>` and `<body>` elements, or third-party UI mounted in `document.body`. Anything
* that styles the editor UI belongs in a theme stylesheet instead, where an integrator can see and override it.
*
* Safe to call from any number of editors sharing a document, and at any time: the same stylesheet text is
* adopted once per document. The stylesheet then stays for the lifetime of the document, inert unless the
* classes it targets are present.
*
* @param doc The document to adopt the stylesheet into.
* @param css The stylesheet text. Pass a constant – repeated calls with the same text are a no-op.
*/ function $c7bc2cb7e2db0227$export$f6603621d2165759(doc, css) {
    const adopted = $c7bc2cb7e2db0227$var$adoptedStyleSheets.get(doc) || /* @__PURE__ */ new Set();
    $c7bc2cb7e2db0227$var$adoptedStyleSheets.set(doc, adopted);
    if (adopted.has(css)) return;
    adopted.add(css);
    const styleSheet = new doc.defaultView.CSSStyleSheet();
    styleSheet.replaceSync(css);
    doc.adoptedStyleSheets.push(styleSheet);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ function $c7bc2cb7e2db0227$export$45b10814cc054894(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns `true` if the given selection is backward, that is, if its `focus` is positioned before its `anchor`.
*
* A replacement for reading `Selection#direction`, which is absent on older engines and reports `'none'` for a
* selection made with the mouse inside a shadow root. The orientation is then recovered from the anchor and
* focus positions instead, so an answer is always available.
*
* @param selection The selection to check.
*/ function $c7bc2cb7e2db0227$export$11be8d61d882cdac(selection) {
    if (selection.isCollapsed) return false;
    if ("direction" in selection && selection.direction != "none") return selection.direction == "backward";
    const range = selection.anchorNode.ownerDocument.createRange();
    try {
        range.setStart(selection.anchorNode, selection.anchorOffset);
        range.setEnd(selection.focusNode, selection.focusOffset);
    } catch  {
        return false;
    }
    const backward = range.collapsed;
    range.detach();
    return backward;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/iscomment
*/ /**
* Checks whether the object is a native DOM Comment node.
*/ function $c7bc2cb7e2db0227$export$3ab01370f5e64ac8(obj) {
    return obj && obj.nodeType === Node.COMMENT_NODE;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/istext
*/ /**
* Checks if the object is a native DOM Text node.
*/ function $c7bc2cb7e2db0227$export$1879817ac5c922b7(obj) {
    return Object.prototype.toString.call(obj) == "[object Text]";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getselection
*/ /**
* Returns the selection of the tree the given node lives in.
*
* Use it instead of `window.getSelection()`, which cannot see into a shadow root: its `anchorNode` and
* `focusNode` point at the host of the tree, not at the nodes selected inside it.
*
* Pass the node the selection is read for, usually an editable. Pass several nodes to cover several editables
* at once. A node in the light DOM gives the document selection, unchanged. Works with open and closed shadow
* roots.
*
* The result behaves like a `Selection` – the part of one the editor uses – so read it and change it the same
* way. It is `null` when there is no selection to read: a detached node, or a document with no window.
*
* One thing this helper cannot fix. In Safari and Chromium browsers, a selection made with the mouse inside a
* shadow root reports no direction, so a backward selection may look forward. Chromium is asked through its own
* API where possible. Safari has none.
*
* @param nodeOrNodes The node (or nodes) whose tree's selection should be returned.
*/ function $c7bc2cb7e2db0227$export$ca798a7e6e94638c(nodeOrNodes) {
    const nodes = $c7bc2cb7e2db0227$export$45b10814cc054894(nodeOrNodes);
    if (!nodes.length) return null;
    const shadowRoots = /* @__PURE__ */ new Set();
    for (const node of nodes){
        const treeRoot = node.getRootNode();
        if ($c7bc2cb7e2db0227$var$isNativeShadowRoot(treeRoot)) shadowRoots.add(treeRoot);
    }
    if (shadowRoots.size) {
        const [firstShadowRoot] = shadowRoots;
        const domWindow = firstShadowRoot.ownerDocument.defaultView;
        if (!domWindow) return null;
        const domSelection = domWindow.getSelection();
        if (domSelection && typeof domSelection.getComposedRanges == "function") return new $c7bc2cb7e2db0227$export$1bed203f6bb52c5f(domSelection, Array.from(shadowRoots));
        for (const shadowRoot of shadowRoots){
            const shadowRootSelection = shadowRoot;
            if (typeof shadowRootSelection.getSelection == "function") {
                const selection = shadowRootSelection.getSelection();
                if (selection?.anchorNode) return selection;
            }
        }
        return domSelection;
    }
    for (const node of nodes){
        if (!node.isConnected) continue;
        const domWindow = node.ownerDocument?.defaultView;
        if (domWindow) return domWindow.getSelection();
    }
    return null;
}
/**
* A `Selection` view over the composed ranges of a set of shadow roots. Read accessors are resolved live
* from the composed ranges on each access, so the view stays in sync with the underlying document selection;
* selection mutations are delegated to it. Only the subset of the `Selection` interface consumed by the
* editor is implemented, so `getSelection()` returns it alongside the native `Selection`.
*/ var $c7bc2cb7e2db0227$export$1bed203f6bb52c5f = class ShadowSelection {
    /**
	* The underlying document-level selection that mutations are delegated to and composed ranges read
	* from.
	*/ _domSelection;
    /**
	* The shadow roots the composed ranges are resolved against.
	*/ _shadowRoots;
    /**
	* Whether the engine only accepts the legacy rest-parameter form of `getComposedRanges()`. This is
	* a fixed property of the engine, so it is detected once (the first call throws on the dictionary
	* form) and cached for all instances, keeping the exception off the selection-read hot path.
	*/ static _useLegacyComposedRanges = false;
    /**
	* @internal
	*/ constructor(domSelection, shadowRoots){
        this._domSelection = domSelection;
        this._shadowRoots = shadowRoots;
    }
    get rangeCount() {
        return this._getRanges().length;
    }
    get isCollapsed() {
        const ranges = this._getRanges();
        return !ranges.length || ranges[0].collapsed;
    }
    get anchorNode() {
        return this._getEndpoint("anchor").node;
    }
    get anchorOffset() {
        return this._getEndpoint("anchor").offset;
    }
    get focusNode() {
        return this._getEndpoint("focus").node;
    }
    get focusOffset() {
        return this._getEndpoint("focus").offset;
    }
    /**
	* The direction of the selection, resolved against the tree the first composed range lives in. It is
	* already computed to orient the anchor and focus endpoints, so exposing it lets consumers read the
	* orientation directly instead of re-deriving it from the endpoints.
	*/ get direction() {
        const ranges = this._getRanges();
        if (!ranges.length) return "none";
        return this._getDirection(ranges[0].startContainer.getRootNode());
    }
    getRangeAt(index) {
        const staticRange = this._getRanges()[index];
        if (!staticRange) throw new DOMException(`Index ${index} is out of range.`, "IndexSizeError");
        const range = this._shadowRoots[0].ownerDocument.createRange();
        range.setStart(staticRange.startContainer, staticRange.startOffset);
        range.setEnd(staticRange.endContainer, staticRange.endOffset);
        return range;
    }
    removeAllRanges() {
        this._domSelection.removeAllRanges();
    }
    addRange(range) {
        this._domSelection.addRange(range);
    }
    collapse(node, offset) {
        this._domSelection.collapse(node, offset);
    }
    extend(node, offset) {
        this._domSelection.extend(node, offset);
    }
    setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset) {
        this._domSelection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
	* The composed ranges fully contained in one of the trees on the path from the given nodes to the
	* document, in document order (start before end).
	*
	* Only ranges whose both endpoints resolve into the same tree can be represented as a live, single-tree
	* `Range`. A range crossing a shadow boundary is therefore dropped, and so is one resolving into an
	* unrelated tree, rather than surfacing foreign nodes. The document itself is one of those trees: it is
	* where every node ends up when walking out of its shadow roots, and it is where a selection made in a
	* sibling light-DOM editable lives, so such a selection is kept rather than dropped.
	*
	* A range with an endpoint outside its container is dropped as well, see `isOffsetInNode()` below.
	*/ _getRanges() {
        const domDocument = this._shadowRoots[0].ownerDocument;
        return this._getComposedRanges().filter((range)=>{
            const rootNode = range.startContainer.getRootNode();
            if (rootNode != range.endContainer.getRootNode()) return false;
            if (rootNode != domDocument && !this._shadowRoots.includes(rootNode)) return false;
            return $c7bc2cb7e2db0227$var$isOffsetInNode(range.startContainer, range.startOffset) && $c7bc2cb7e2db0227$var$isOffsetInNode(range.endContainer, range.endOffset);
        });
    }
    /**
	* The raw composed ranges reported for the shadow roots by the underlying selection.
	*/ _getComposedRanges() {
        const domSelection = this._domSelection;
        const shadowRoots = this._shadowRoots;
        if (ShadowSelection._useLegacyComposedRanges) return domSelection.getComposedRanges(...shadowRoots);
        try {
            return domSelection.getComposedRanges({
                shadowRoots: shadowRoots
            });
        } catch  {
            ShadowSelection._useLegacyComposedRanges = true;
            return domSelection.getComposedRanges(...shadowRoots);
        }
    }
    /**
	* The direction of the underlying selection, preferring the one reported by Blink's shadow-scoped
	* selection, which stays meaningful for a mouse selection made inside a shadow root.
	*/ _getDirection(rootNode) {
        const shadowRootSelection = rootNode.getSelection?.();
        if (shadowRootSelection) {
            if (shadowRootSelection.direction && shadowRootSelection.direction != "none") return shadowRootSelection.direction;
            if (shadowRootSelection.anchorNode) return $c7bc2cb7e2db0227$export$11be8d61d882cdac(shadowRootSelection) ? "backward" : "forward";
        }
        return this._domSelection.direction ?? "forward";
    }
    /**
	* The anchor or focus endpoint of the first composed range.
	*
	* `getComposedRanges()` returns ranges in document order (start before end); the anchor/focus
	* orientation therefore has to come from `Selection#direction`. Known limitation: WebKit and Blink
	* report `direction` as `'none'` for a selection made *with the mouse* inside a shadow root (a
	* keyboard selection reports it correctly). Blink's shadow-scoped selection still knows the direction
	* in that case, so it is consulted first; it is of no use for the ranges themselves, as it covers
	* a single tree only. Safari has no such API, so its mouse selections fall back to forward.
	*/ _getEndpoint(endpoint) {
        const ranges = this._getRanges();
        if (!ranges.length) return {
            node: null,
            offset: 0
        };
        const range = ranges[0];
        const isBackward = this._getDirection(range.startContainer.getRootNode()) == "backward";
        return (endpoint == "anchor" ? !isBackward : isBackward) ? {
            node: range.startContainer,
            offset: range.startOffset
        } : {
            node: range.endContainer,
            offset: range.endOffset
        };
    }
};
/**
* Whether the offset is a position the container can actually hold: within its text for a character-data
* node, within its children for any other node.
*
* Unlike a `Range`, a `StaticRange` is not validated, so the offsets `getComposedRanges()` returns may
* point past the end of their containers. Safari can report a range describing the tree as it was before
* the last DOM mutation, so an offset can outlive the children it pointed at, for example while rendering
* a change that removed the last child of a container. Such an endpoint has no position to resolve to and
* cannot be turned into a `Range` (which validates and throws an `IndexSizeError`), so the whole range is
* left out rather than reported as an out-of-bounds position.
*/ function $c7bc2cb7e2db0227$var$isOffsetInNode(node, offset) {
    return offset <= ($c7bc2cb7e2db0227$export$1879817ac5c922b7(node) || $c7bc2cb7e2db0227$export$3ab01370f5e64ac8(node) ? node.length : node.childNodes.length);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isrange
*/ /**
* Checks if the object is a native DOM Range.
*/ function $c7bc2cb7e2db0227$export$e331ccfa6f694c99(obj) {
    return Object.prototype.toString.apply(obj) == "[object Range]";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/rect
*/ const $c7bc2cb7e2db0227$var$RECT_PROPERTIES = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height"
];
const $c7bc2cb7e2db0227$var$POSITIONING_VALUES = /* @__PURE__ */ new Set([
    "relative",
    "absolute",
    "fixed",
    "sticky"
]);
/**
* A helper class representing a `ClientRect` object, e.g. value returned by
* the native `object.getBoundingClientRect()` method. Provides a set of methods
* to manipulate the rect and compare it against other rect instances.
*/ var $c7bc2cb7e2db0227$export$c79fc6492f3af13d = class Rect {
    /**
	* The "top" value of the rect.
	*
	* @readonly
	*/ top;
    /**
	* The "right" value of the rect.
	*
	* @readonly
	*/ right;
    /**
	* The "bottom" value of the rect.
	*
	* @readonly
	*/ bottom;
    /**
	* The "left" value of the rect.
	*
	* @readonly
	*/ left;
    /**
	* The "width" value of the rect.
	*
	* @readonly
	*/ width;
    /**
	* The "height" value of the rect.
	*
	* @readonly
	*/ height;
    /**
	* The object this rect is for.
	*
	* @readonly
	*/ _source;
    /**
	* Creates an instance of rect.
	*
	* ```ts
	* // Rect of an HTMLElement.
	* const rectA = new Rect( document.body );
	*
	* // Rect of a DOM Range.
	* const rectB = new Rect( document.getSelection().getRangeAt( 0 ) );
	*
	* // Rect of a window (web browser viewport).
	* const rectC = new Rect( window );
	*
	* // Rect out of an object.
	* const rectD = new Rect( { top: 0, right: 10, bottom: 10, left: 0, width: 10, height: 10 } );
	*
	* // Rect out of another Rect instance.
	* const rectE = new Rect( rectD );
	*
	* // Rect out of a ClientRect.
	* const rectF = new Rect( document.body.getClientRects().item( 0 ) );
	* ```
	*
	* **Note**: By default a rect of an HTML element includes its CSS borders and scrollbars (if any)
	* ant the rect of a `window` includes scrollbars too. Use {@link #excludeScrollbarsAndBorders}
	* to get the inner part of the rect.
	*
	* @param source A source object to create the rect.
	*/ constructor(source){
        const isSourceRange = $c7bc2cb7e2db0227$export$e331ccfa6f694c99(source);
        Object.defineProperty(this, "_source", {
            value: source._source || source,
            writable: true,
            enumerable: false
        });
        if ($c7bc2cb7e2db0227$var$isDomElement(source) || isSourceRange) {
            if (isSourceRange) {
                const rangeRects = Rect.getDomRangeRects(source);
                $c7bc2cb7e2db0227$var$copyRectProperties(this, Rect.getBoundingRect(rangeRects));
            } else $c7bc2cb7e2db0227$var$copyRectProperties(this, source.getBoundingClientRect());
        } else if ($c7bc2cb7e2db0227$export$5a096129d439f843(source)) {
            const { innerWidth: innerWidth, innerHeight: innerHeight } = source;
            $c7bc2cb7e2db0227$var$copyRectProperties(this, {
                top: 0,
                right: innerWidth,
                bottom: innerHeight,
                left: 0,
                width: innerWidth,
                height: innerHeight
            });
        } else $c7bc2cb7e2db0227$var$copyRectProperties(this, source);
    }
    /**
	* Returns a clone of the rect.
	*
	* @returns A cloned rect.
	*/ clone() {
        return new Rect(this);
    }
    /**
	* Moves the rect so that its upper–left corner lands in desired `[ x, y ]` location.
	*
	* @param x Desired horizontal location.
	* @param y Desired vertical location.
	* @returns A rect which has been moved.
	*/ moveTo(x, y) {
        this.top = y;
        this.right = x + this.width;
        this.bottom = y + this.height;
        this.left = x;
        return this;
    }
    /**
	* Moves the rect in–place by a dedicated offset.
	*
	* @param x A horizontal offset.
	* @param y A vertical offset
	* @returns A rect which has been moved.
	*/ moveBy(x, y) {
        this.top += y;
        this.right += x;
        this.left += x;
        this.bottom += y;
        return this;
    }
    /**
	* Returns a new rect a a result of intersection with another rect.
	*/ getIntersection(anotherRect) {
        const rect = {
            top: Math.max(this.top, anotherRect.top),
            right: Math.min(this.right, anotherRect.right),
            bottom: Math.min(this.bottom, anotherRect.bottom),
            left: Math.max(this.left, anotherRect.left),
            width: 0,
            height: 0
        };
        rect.width = rect.right - rect.left;
        rect.height = rect.bottom - rect.top;
        if (rect.width < 0 || rect.height < 0) return null;
        else {
            const newRect = new Rect(rect);
            newRect._source = this._source;
            return newRect;
        }
    }
    /**
	* Returns the area of intersection with another rect.
	*
	* @returns Area of intersection.
	*/ getIntersectionArea(anotherRect) {
        const rect = this.getIntersection(anotherRect);
        if (rect) return rect.getArea();
        else return 0;
    }
    /**
	* Returns the area of the rect.
	*/ getArea() {
        return this.width * this.height;
    }
    /**
	* Returns a new rect, a part of the original rect, which is actually visible to the user and is relative to the,`body`,
	* e.g. an original rect cropped by parent element rects which have `overflow` set in CSS
	* other than `"visible"`.
	*
	* If there's no such visible rect, which is when the rect is limited by one or many of
	* the ancestors, `null` is returned.
	*
	* **Note**: This method does not consider the boundaries of the viewport (window).
	* To get a rect cropped by all ancestors and the viewport, use an intersection such as:
	*
	* ```ts
	* const visibleInViewportRect = new Rect( window ).getIntersection( new Rect( source ).getVisible() );
	* ```
	*
	* **Note**: The ancestor walk crosses shadow DOM boundaries, continuing from the host element of a shadow
	* root instead of stopping at it, so a rect inside a shadow tree is still cropped by the ancestors in the
	* surrounding document. Works for open and closed shadow roots alike.
	*
	* @returns A visible rect instance or `null`, if there's none.
	*/ getVisible() {
        const source = this._source;
        let visibleRect = this.clone();
        if ($c7bc2cb7e2db0227$var$isBody(source)) return visibleRect;
        let child = source;
        let parent = null;
        if ($c7bc2cb7e2db0227$var$isDomElement(source)) parent = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(source);
        else if ($c7bc2cb7e2db0227$export$e331ccfa6f694c99(source)) {
            const container = source.commonAncestorContainer;
            parent = $c7bc2cb7e2db0227$export$af51f0f06c0f328a(container) ? container.host : container;
        }
        let lastPositionedChildElement;
        while(parent && !$c7bc2cb7e2db0227$var$isBody(parent)){
            const isNonClippingParent = $c7bc2cb7e2db0227$var$getElementOverflow(parent) === "visible";
            if ($c7bc2cb7e2db0227$var$isPositioned(child)) lastPositionedChildElement = child;
            if (isNonClippingParent || lastPositionedChildElement && $c7bc2cb7e2db0227$var$getElementPosition(lastPositionedChildElement) === "absolute" && !$c7bc2cb7e2db0227$var$isPositioned(parent)) {
                child = parent;
                parent = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(parent);
                continue;
            }
            const parentRect = new Rect(parent);
            const intersectionRect = visibleRect.getIntersection(parentRect);
            if (intersectionRect) {
                if (intersectionRect.getArea() < visibleRect.getArea()) visibleRect = intersectionRect;
            } else return null;
            child = parent;
            parent = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(parent);
        }
        return visibleRect;
    }
    /**
	* Checks if all property values ({@link #top}, {@link #left}, {@link #right},
	* {@link #bottom}, {@link #width} and {@link #height}) are the equal in both rect
	* instances.
	*
	* @param anotherRect A rect instance to compare with.
	* @returns `true` when Rects are equal. `false` otherwise.
	*/ isEqual(anotherRect) {
        for (const prop of $c7bc2cb7e2db0227$var$RECT_PROPERTIES)if (this[prop] !== anotherRect[prop]) return false;
        return true;
    }
    /**
	* Checks whether a rect fully contains another rect instance.
	*
	* @param anotherRect
	* @returns `true` if contains, `false` otherwise.
	*/ contains(anotherRect) {
        const intersectRect = this.getIntersection(anotherRect);
        return !!(intersectRect && intersectRect.isEqual(anotherRect));
    }
    /**
	* Recalculates screen coordinates to coordinates relative to the positioned ancestor offset.
	*/ toAbsoluteRect() {
        const { scrollX: scrollX, scrollY: scrollY } = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window;
        const absoluteRect = this.clone().moveBy(scrollX, scrollY);
        if ($c7bc2cb7e2db0227$var$isDomElement(absoluteRect._source)) {
            const positionedAncestor = $c7bc2cb7e2db0227$export$f410fd9345261d8c(absoluteRect._source);
            if (positionedAncestor) $c7bc2cb7e2db0227$var$shiftRectToCompensatePositionedAncestor(absoluteRect, positionedAncestor);
        }
        return absoluteRect;
    }
    /**
	* Excludes scrollbars and CSS borders from the rect.
	*
	* * Borders are removed when {@link #_source} is an HTML element.
	* * Scrollbars are excluded from HTML elements and the `window`.
	*
	* @returns A rect which has been updated.
	*/ excludeScrollbarsAndBorders() {
        const source = this._source;
        let scrollBarWidth, scrollBarHeight, direction;
        if ($c7bc2cb7e2db0227$export$5a096129d439f843(source)) {
            scrollBarWidth = source.innerWidth - source.document.documentElement.clientWidth;
            scrollBarHeight = source.innerHeight - source.document.documentElement.clientHeight;
            direction = source.getComputedStyle(source.document.documentElement).direction;
        } else {
            const borderWidths = $c7bc2cb7e2db0227$export$c134363f1f37644f(source);
            scrollBarWidth = source.offsetWidth - source.clientWidth - borderWidths.left - borderWidths.right;
            scrollBarHeight = source.offsetHeight - source.clientHeight - borderWidths.top - borderWidths.bottom;
            direction = source.ownerDocument.defaultView.getComputedStyle(source).direction;
            this.left += borderWidths.left;
            this.top += borderWidths.top;
            this.right -= borderWidths.right;
            this.bottom -= borderWidths.bottom;
            this.width = this.right - this.left;
            this.height = this.bottom - this.top;
        }
        this.width -= scrollBarWidth;
        if (direction === "ltr") this.right -= scrollBarWidth;
        else this.left += scrollBarWidth;
        this.height -= scrollBarHeight;
        this.bottom -= scrollBarHeight;
        return this;
    }
    /**
	* Returns an array of rects of the given native DOM Range.
	*
	* Also see {@link module:utils/dom/rect~Rect.getDomElementRects}.
	*
	* @param range A native DOM range.
	* @returns DOM Range rects.
	*/ static getDomRangeRects(range) {
        const rects = [];
        const clientRects = Array.from(range.getClientRects());
        if (clientRects.length) for (const rect of clientRects){
            const r = new Rect(rect);
            r._source = range;
            rects.push(r);
        }
        else {
            let startContainer = range.startContainer;
            if ($c7bc2cb7e2db0227$export$1879817ac5c922b7(startContainer)) startContainer = $c7bc2cb7e2db0227$export$169e5491001d3ed6(startContainer);
            const rect = new Rect(startContainer.getBoundingClientRect());
            rect.right = rect.left;
            rect.width = 0;
            rects.push(rect);
        }
        return rects;
    }
    /**
	* Returns an array of Rects of the given DOM Element based on its native `getClientRects()` method.
	*
	* Also see {@link module:utils/dom/rect~Rect.getDomRangeRects}.
	*/ static getDomElementRects(element) {
        return Array.from(element.getClientRects()).map((clientRect)=>{
            const rect = new Rect(clientRect);
            rect._source = element;
            return rect;
        });
    }
    /**
	* Returns a bounding rectangle that contains all the given `rects`.
	*
	* @param rects A list of rectangles that should be contained in the result rectangle.
	* @returns Bounding rectangle or `null` if no `rects` were given.
	*/ static getBoundingRect(rects) {
        const boundingRectData = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY,
            width: 0,
            height: 0
        };
        let rectangleCount = 0;
        for (const rect of rects){
            rectangleCount++;
            boundingRectData.left = Math.min(boundingRectData.left, rect.left);
            boundingRectData.top = Math.min(boundingRectData.top, rect.top);
            boundingRectData.right = Math.max(boundingRectData.right, rect.right);
            boundingRectData.bottom = Math.max(boundingRectData.bottom, rect.bottom);
        }
        if (rectangleCount == 0) return null;
        boundingRectData.width = boundingRectData.right - boundingRectData.left;
        boundingRectData.height = boundingRectData.bottom - boundingRectData.top;
        return new Rect(boundingRectData);
    }
};
/**
* Acquires all the rect properties from the passed source.
*/ function $c7bc2cb7e2db0227$var$copyRectProperties(rect, source) {
    for (const p of $c7bc2cb7e2db0227$var$RECT_PROPERTIES)rect[p] = source[p];
}
/**
* Checks if provided object is a <body> HTML element.
*/ function $c7bc2cb7e2db0227$var$isBody(value) {
    if (!$c7bc2cb7e2db0227$var$isDomElement(value)) return false;
    return value === value.ownerDocument.body;
}
/**
* Checks if provided object "looks like" a DOM Element and has API required by `Rect` class.
*/ function $c7bc2cb7e2db0227$var$isDomElement(value) {
    return value !== null && typeof value === "object" && value.nodeType === 1 && typeof value.getBoundingClientRect === "function";
}
/**
* Returns the value of the `position` style of an `HTMLElement`.
*/ function $c7bc2cb7e2db0227$var$getElementPosition(element) {
    return element.ownerDocument.defaultView.getComputedStyle(element).position;
}
/**
* Returns the value of the `overflow` style of an `HTMLElement` or a `Range`.
*/ function $c7bc2cb7e2db0227$var$getElementOverflow(element) {
    return element instanceof HTMLElement ? element.ownerDocument.defaultView.getComputedStyle(element).overflow : "visible";
}
/**
* Checks if the given node is positioned in any other way than `position: static`.
*/ function $c7bc2cb7e2db0227$var$isPositioned(node) {
    return node instanceof HTMLElement && $c7bc2cb7e2db0227$var$POSITIONING_VALUES.has($c7bc2cb7e2db0227$var$getElementPosition(node));
}
/**
* For a given absolute Rect coordinates object and a positioned element ancestor, it updates its
* coordinates that make up for the position and the scroll of the ancestor.
*
* This is necessary because while Rects (and DOMRects) are relative to the browser's viewport, their coordinates
* are used in real–life to position elements with `position: absolute`, which are scoped by any positioned
* (and scrollable) ancestors.
*/ function $c7bc2cb7e2db0227$var$shiftRectToCompensatePositionedAncestor(rect, positionedElementAncestor) {
    const ancestorPosition = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(positionedElementAncestor);
    const ancestorBorderWidths = $c7bc2cb7e2db0227$export$c134363f1f37644f(positionedElementAncestor);
    let moveX = 0;
    let moveY = 0;
    moveX -= ancestorPosition.left;
    moveY -= ancestorPosition.top;
    moveX += positionedElementAncestor.scrollLeft;
    moveY += positionedElementAncestor.scrollTop;
    moveX -= ancestorBorderWidths.left;
    moveY -= ancestorBorderWidths.top;
    rect.moveBy(moveX, moveY);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/resizeobserver
*/ /**
* A helper class which instances allow performing custom actions when native DOM elements are resized.
*
* ```ts
* const editableElement = editor.editing.view.getDomRoot();
*
* const observer = new ResizeObserver( editableElement, entry => {
* 	console.log( 'The editable element has been resized in DOM.' );
* 	console.log( entry.target ); // -> editableElement
* 	console.log( entry.contentRect.width ); // -> e.g. '423px'
* } );
* ```
*
* It uses the [native DOM resize observer](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver)
* under the hood.
*/ var $c7bc2cb7e2db0227$export$9caf76241ca21a11 = class ResizeObserver {
    /**
	* The element observed by this observer.
	*/ _element;
    /**
	* The callback executed each time {@link #_element} is resized.
	*/ _callback;
    /**
	* The single native observer instance shared across all {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
	*/ static _observerInstance = null;
    /**
	* A mapping of native DOM elements and their callbacks shared across all
	* {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
	*/ static _elementCallbacks = null;
    /**
	* Creates an instance of the `ResizeObserver` class.
	*
	* @param element A DOM element that is to be observed for resizing. Note that
	* the element must be visible (i.e. not detached from DOM) for the observer to work.
	* @param callback A function called when the observed element was resized. It passes
	* the [`ResizeObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry)
	* object with information about the resize event.
	*/ constructor(element, callback){
        if (!ResizeObserver._observerInstance) ResizeObserver._createObserver();
        this._element = element;
        this._callback = callback;
        ResizeObserver._addElementCallback(element, callback);
        ResizeObserver._observerInstance.observe(element);
    }
    /**
	* The element observed by this observer.
	*/ get element() {
        return this._element;
    }
    /**
	* Destroys the observer which disables the `callback` passed to the {@link #constructor}.
	*/ destroy() {
        ResizeObserver._deleteElementCallback(this._element, this._callback);
    }
    /**
	* Registers a new resize callback for the DOM element.
	*/ static _addElementCallback(element, callback) {
        if (!ResizeObserver._elementCallbacks) ResizeObserver._elementCallbacks = /* @__PURE__ */ new Map();
        let callbacks = ResizeObserver._elementCallbacks.get(element);
        if (!callbacks) {
            callbacks = /* @__PURE__ */ new Set();
            ResizeObserver._elementCallbacks.set(element, callbacks);
        }
        callbacks.add(callback);
    }
    /**
	* Removes a resize callback from the DOM element. If no callbacks are left
	* for the element, it removes the element from the native observer.
	*/ static _deleteElementCallback(element, callback) {
        const callbacks = ResizeObserver._getElementCallbacks(element);
        if (callbacks) {
            callbacks.delete(callback);
            if (!callbacks.size) {
                ResizeObserver._elementCallbacks.delete(element);
                ResizeObserver._observerInstance.unobserve(element);
            }
        }
        if (ResizeObserver._elementCallbacks && !ResizeObserver._elementCallbacks.size) {
            ResizeObserver._observerInstance = null;
            ResizeObserver._elementCallbacks = null;
        }
    }
    /**
	* Returns are registered resize callbacks for the DOM element.
	*/ static _getElementCallbacks(element) {
        if (!ResizeObserver._elementCallbacks) return null;
        return ResizeObserver._elementCallbacks.get(element);
    }
    /**
	* Creates the single native observer shared across all `ResizeObserver` instances.
	*/ static _createObserver() {
        ResizeObserver._observerInstance = new $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.ResizeObserver((entries)=>{
            for (const entry of entries){
                const callbacks = ResizeObserver._getElementCallbacks(entry.target);
                if (callbacks) for (const callback of callbacks)callback(entry);
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/trustedtypes
*/ /**
* The name of the editor's policy. An application that enforces Trusted Types must list it in the `trusted-types` CSP
* directive, or the browser refuses to create the policy.
*/ const $c7bc2cb7e2db0227$var$POLICY_NAME = "ckeditor5";
/**
* An object whose methods return the string they were given. The browser builds the editor's policy from it, because the
* editor writes markup that it created itself, and content that the application loaded into it. It also takes the place of
* that policy when the editor cannot have one, so that both cases behave the same way.
*/ const $c7bc2cb7e2db0227$var$PASS_THROUGH = {
    createHTML: (input)=>input,
    createScript: (input)=>input,
    createScriptURL: (input)=>input
};
/**
* The editor's policy, created on first use. The browser allows each policy name only once per document, so a single
* policy is shared by every editor in the document, by all roots of a multi-root editor, and by editors created later,
* such as one recreated after an error.
*/ let $c7bc2cb7e2db0227$var$policy;
/**
* Whether the application enforces Trusted Types, or `undefined` before the first check. The answer cannot change while
* the document lives, and finding it out makes the browser report a policy violation, so it is checked only once.
*/ let $c7bc2cb7e2db0227$var$isEnforced;
/**
* Prepares an HTML string for a DOM injection sink, which means any place that turns a string into HTML, for example
* `innerHTML` or `DOMParser#parseFromString()`:
*
* ```ts
* element.innerHTML = trustedHtml( '<p>Hello world!</p>' );
* ```
*
* An application can tell the browser to reject plain strings in those places, using the `require-trusted-types-for 'script'`
* CSP directive. A sink then accepts only a `TrustedHTML` object. This function returns such an object when the browser
* supports Trusted Types, and the string it was given when it does not. TypeScript types every sink as taking a
* `string`, so the result is typed that way too, whichever it is. That keeps type casts out of the call sites, but it
* also means the result is not always a real string: pass it to a sink, and do not call string methods on it. For the
* same reason `+=` never works on a sink: it reads the property, joins the strings and assigns a plain one.
*
* An application that enforces Trusted Types must also allow the name of the editor's policy, plus `lit-html` when it
* loads the premium features, whichever of them it uses:
*
* ```
* Content-Security-Policy: require-trusted-types-for 'script'; trusted-types ckeditor5 lit-html;
* ```
*
* The policy returns the string unchanged, because the editor writes markup that it created itself. It makes the browser
* accept the assignment, but it cleans nothing, so pass this function only markup that the calling code produced, and
* never content that came from a user or from a server response. Making sure that the data loaded into the editor is
* safe stays the job of the application, exactly as before.
*
* See the {@glink getting-started/setup/csp#trusted-types Content Security Policy} guide for more information.
*
* @param html The HTML string to prepare.
* @returns A value that can be assigned to a DOM injection sink.
*/ function $c7bc2cb7e2db0227$export$defce004797fe3da(html) {
    if (!$c7bc2cb7e2db0227$var$policy) $c7bc2cb7e2db0227$var$policy = $c7bc2cb7e2db0227$var$createPolicy();
    return $c7bc2cb7e2db0227$var$policy.createHTML(html);
}
/**
* Returns `true` if the application enforces Trusted Types with the `require-trusted-types-for 'script'` CSP directive.
* That is the only case where a DOM injection sink rejects a plain string, so it is also the only case where a feature
* that writes HTML in code the editor cannot reach, for example inside a third-party library, stops working.
*/ function $c7bc2cb7e2db0227$export$d5ff8d8a62c25e80() {
    if ($c7bc2cb7e2db0227$var$isEnforced === void 0) try {
        $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.document.createElement("div").innerHTML = "";
        $c7bc2cb7e2db0227$var$isEnforced = false;
    } catch  {
        $c7bc2cb7e2db0227$var$isEnforced = typeof $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.document.createElement === "function";
    }
    return $c7bc2cb7e2db0227$var$isEnforced;
}
/**
* Prepares the value of an attribute for `setAttribute()`. Under Trusted Types, some attributes accept only the object of
* a Trusted Type, even in a document that is not displayed: an event handler such as `onclick` takes a `TrustedScript`,
* `src` of a `<script>` takes a `TrustedScriptURL`, and `srcdoc` of an `<iframe>` takes a `TrustedHTML`. For such an
* attribute, the editor's policy creates that object from the unchanged value. Any other attribute gets the given string.
* The browser tells which attribute is which, because the list differs between browsers.
*
* Like {@link ~trustedHtml}, it cleans nothing, and its result is typed as a string whichever it is.
*
* @internal
* @param element The element that the attribute is set on.
* @param attributeName The name of the attribute.
* @param value The value of the attribute.
*/ function $c7bc2cb7e2db0227$export$4703b76556f50989(element, attributeName, value) {
    const trustedTypes = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.trustedTypes;
    if (!trustedTypes || typeof trustedTypes.getAttributeType != "function") return value;
    if (!$c7bc2cb7e2db0227$var$policy) $c7bc2cb7e2db0227$var$policy = $c7bc2cb7e2db0227$var$createPolicy();
    switch(trustedTypes.getAttributeType(element.localName, attributeName, element.namespaceURI)){
        case "TrustedHTML":
            return $c7bc2cb7e2db0227$var$policy.createHTML(value);
        case "TrustedScript":
            return $c7bc2cb7e2db0227$var$policy.createScript(value);
        case "TrustedScriptURL":
            return $c7bc2cb7e2db0227$var$policy.createScriptURL(value);
        default:
            return value;
    }
}
/**
* Creates the editor's policy, or returns `PASS_THROUGH` when the browser does not support Trusted Types or the application
* does not allow the policy.
*/ function $c7bc2cb7e2db0227$var$createPolicy() {
    const trustedTypes = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.trustedTypes;
    if (trustedTypes) try {
        return trustedTypes.createPolicy($c7bc2cb7e2db0227$var$POLICY_NAME, $c7bc2cb7e2db0227$var$PASS_THROUGH);
    } catch  {
        if (!$c7bc2cb7e2db0227$export$d5ff8d8a62c25e80()) return $c7bc2cb7e2db0227$var$PASS_THROUGH;
        /**
		* The editor could not create the Trusted Types policy that it needs to write HTML into the DOM. Without the
		* policy it can only write plain strings, which the `require-trusted-types-for 'script'` CSP directive rejects,
		* so the editor cannot start.
		*
		* The browser refuses to create the policy for two reasons:
		*
		* * The `trusted-types` CSP directive does not list the `ckeditor5` policy name. Add it to that directive, next to
		*   any names that are already there:
		*
		*   ```
		*   Content-Security-Policy: require-trusted-types-for 'script'; trusted-types ckeditor5 lit-html;
		*   ```
		*
		* * Something else in the same document already created a policy with that name. Let that code use a different
		*   name, or allow the name to be taken twice:
		*
		*   ```
		*   Content-Security-Policy: require-trusted-types-for 'script'; trusted-types ckeditor5 lit-html 'allow-duplicates';
		*   ```
		*
		* For a detailed overview, check the {@glink getting-started/setup/csp#enabling-trusted-types Content
		* Security Policy} guide.
		*
		* @error trusted-types-policy-creation-failed
		*/ $c7bc2cb7e2db0227$export$ebd6064652549ce9("trusted-types-policy-creation-failed");
    }
    return $c7bc2cb7e2db0227$var$PASS_THROUGH;
}
/**
* Forgets the policy that was created and whether the application enforces Trusted Types, so that both are worked out
* again. Only tests need it, because a document never changes either answer.
*
* @internal
*/ function $c7bc2cb7e2db0227$export$5690a39fa0b98cff() {
    $c7bc2cb7e2db0227$var$policy = void 0;
    $c7bc2cb7e2db0227$var$isEnforced = void 0;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/setdatainelement
*/ /**
* Sets data in a given element.
*
* @param el The element in which the data will be set.
* @param data The data string.
*/ function $c7bc2cb7e2db0227$export$38bb620396ade7f9(el, data) {
    if (el instanceof HTMLTextAreaElement) el.value = data;
    el.innerHTML = $c7bc2cb7e2db0227$export$defce004797fe3da(data);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/tounit
*/ /**
* Returns a helper function, which adds a desired trailing
* `unit` to the passed value.
*
* @param unit An unit like "px" or "em".
*/ function $c7bc2cb7e2db0227$export$d48be2db27a3a8d3(unit) {
    return (value)=>value + unit;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/indexof
*/ /**
* Returns index of the node in the parent element.
*
* @param node Node which index is tested.
* @returns Index of the node in the parent element. Returns 0 if node has no parent.
*/ function $c7bc2cb7e2db0227$export$305f7d4e9d4624f2(node) {
    let index = 0;
    while(node.previousSibling){
        node = node.previousSibling;
        index++;
    }
    return index;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/insertat
*/ /**
* Inserts node to the parent at given index.
*
* @param parentElement Parent element.
* @param index Insertions index.
* @param nodeToInsert Node to insert.
*/ function $c7bc2cb7e2db0227$export$9f200c4466975173(parentElement, index, nodeToInsert) {
    parentElement.insertBefore(nodeToInsert, parentElement.childNodes[index] || null);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isoffline
*/ /**
* Checks whether the browser reports that there is no network connection.
*/ function $c7bc2cb7e2db0227$export$a81aa9769d155ec5() {
    return !$c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.navigator.onLine;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isshadowhostof
*/ /**
* Checks whether the given node is the host of any of the given shadow roots.
*
* Answers "is this a stand-in for something inside one of these roots, rather than the real thing?". A DOM API
* that cannot reach into a shadow tree reports its host in place of the node inside it – most commonly an event
* target, retargeted for a listener that does not live in that tree. Works for open and closed roots alike.
*
* @param node The node to test.
* @param shadowRoots The shadow roots to test against.
*/ function $c7bc2cb7e2db0227$export$e35bfa60228815d9(node, shadowRoots) {
    if (!node) return false;
    for (const root of shadowRoots)if (root.host === node) return true;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/whenelementconnected
*/ /**
* Calls the callback once the given element is connected to a document, and at most once.
*
* For code that has to act on the tree an element lives in – injecting styles, resolving a mount target – but is
* handed the element before it is mounted. The editable of a `DecoupledEditor`, or of any editor created from a
* data string, is put in the DOM by the integrator at an arbitrary point in time. An element that is already
* connected is reported synchronously, so the caller needs no second path for that case.
*
* "Connected" means connected to a document: an element in a shadow tree qualifies once that tree's host does,
* and one in a detached tree never does. It is not a visibility check – the element may be connected while
* having no box of its own, or while an ancestor is not rendered.
*
* The waiting is backed by a {@link module:utils/dom/resizeobserver~ResizeObserver}, so the notification is
* asynchronous and arrives once the element is rendered. For an element mounted into a `display: none` subtree
* the callback may therefore run on the mount or only once that subtree is shown, depending on the engine. It
* runs exactly once either way.
*
* @param element The element to wait for.
* @param callback Called once `element` is connected, or immediately if it already is.
* @returns Cancels the waiting. Safe to call any number of times, and does nothing once the callback has run.
*/ function $c7bc2cb7e2db0227$export$c6a09612176c4440(element, callback) {
    if (element.isConnected) {
        callback();
        return ()=>{};
    }
    let observer = new $c7bc2cb7e2db0227$export$9caf76241ca21a11(element, ()=>{
        if (!element.isConnected || !observer) return;
        observer.destroy();
        observer = null;
        callback();
    });
    return ()=>{
        observer?.destroy();
        observer = null;
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/shadowrootregistry
*/ const $c7bc2cb7e2db0227$var$ShadowRootRegistryBase = /* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594();
/**
* Keeps track of the shadow roots hosting a set of registered DOM nodes (for example an editor UI's editables,
* toolbars and menu bars, or a feature's own UI), so that consumers can, for instance, inject styles or listeners
* into every shadow root those nodes currently live in.
*/ var $c7bc2cb7e2db0227$export$62767248905409ba = class extends $c7bc2cb7e2db0227$var$ShadowRootRegistryBase {
    /**
	* The shadow roots hosting each registered node, as of the last time that node was looked at. Empty for a node
	* that was detached or lived in the light DOM then. Re-derived for every node by each {@link #refresh}, so a
	* node that has since been attached, or moved to another tree, is picked up. The union of the values is
	* {@link #getShadowRoots}.
	*/ _rootsByNode = /* @__PURE__ */ new Map();
    /**
	* Returns the shadow roots currently hosting at least one registered node.
	*/ getShadowRoots() {
        const roots = /* @__PURE__ */ new Set();
        for (const nodeRoots of this._rootsByNode.values())for (const root of nodeRoots)roots.add(root);
        return roots;
    }
    /**
	* Registers a node, so the shadow roots hosting it become a part of {@link #getShadowRoots}.
	*
	* The node does not have to be attached to the DOM yet; while it is not, it simply contributes no shadow root.
	* The next {@link #refresh} picks it up once it is attached.
	*/ registerNode(node) {
        if (this._rootsByNode.has(node)) return;
        const previousRoots = this.getShadowRoots();
        this._rootsByNode.set(node, $c7bc2cb7e2db0227$var$deriveRoots(node));
        this._fireRootChanges(previousRoots);
    }
    /**
	* Unregisters a previously {@link #registerNode registered} node. Shadow roots that no longer host any
	* registered node stop being a part of {@link #getShadowRoots}.
	*/ unregisterNode(node) {
        if (!this._rootsByNode.has(node)) return;
        const previousRoots = this.getShadowRoots();
        this._rootsByNode.delete(node);
        this._fireRootChanges(previousRoots);
    }
    /**
	* Re-derives the shadow roots of every registered node, firing {@link #event:add} for the roots that started
	* hosting one and {@link #event:remove} for those that stopped.
	*
	* Call it whenever a registered node may have been attached, detached, or moved – for example on every editor
	* UI update. Nodes are re-derived rather than resolved once, because the tree a node lives in is not fixed:
	* an editable mounted by the integrator after the editor was created, or moved into a fullscreen container in
	* another tree, ends up somewhere its roots were never derived from.
	*/ refresh() {
        const previousRoots = this.getShadowRoots();
        for (const node of this._rootsByNode.keys())this._rootsByNode.set(node, $c7bc2cb7e2db0227$var$deriveRoots(node));
        this._fireRootChanges(previousRoots);
    }
    /**
	* Unregisters every currently registered node at once, firing {@link #event:remove} for every shadow root
	* that consequently stops being tracked.
	*
	* @internal
	*/ destroy() {
        const previousRoots = this.getShadowRoots();
        this._rootsByNode.clear();
        this._fireRootChanges(previousRoots);
    }
    /**
	* Fires {@link #event:add} and {@link #event:remove} for the difference between the given set of tracked
	* shadow roots and the current one.
	*/ _fireRootChanges(previousRoots) {
        const currentRoots = this.getShadowRoots();
        for (const root of previousRoots)if (!currentRoots.has(root)) this.fire("remove", root);
        for (const root of currentRoots)if (!previousRoots.has(root)) this.fire("add", root);
    }
};
/**
* Some DOM events never reach a listener on `document` if they originate inside a shadow root — `scroll` and
* `mouseenter`/`mouseleave`, for instance, do not cross a shadow boundary at all. This function is how code that
* needs those events anyway reacts to them for every shadow root a registry is currently tracking: it attaches
* `emitter`'s callback directly to each one tracked by `registry`, and keeps that up to date — attaching to
* roots that appear later, detaching from roots that disappear — for as long as the returned function is not
* called.
*
* Attach it alongside the `document` listener rather than instead of it — one covers the light DOM, the other
* each shadow root:
*
* ```ts
* view.listenTo( global.document, 'scroll', repositionOnScroll, { useCapture: true } );
*
* const stopListening = listenToShadowRoots( editor.ui.shadowRootRegistry, {
* 	emitter: view,
* 	event: 'scroll',
* 	callback: repositionOnScroll,
* 	listenerOptions: { useCapture: true }
* } );
* ```
*
* The `useCapture` above is not incidental. The events this function exists for do not bubble when fired on an
* element, so a listener on a shadow root only sees one that originates inside that root during the capture
* phase. Without it the listener is attached but never fires.
*
* Call the returned function to detach.
*
* @param registry The registry whose shadow roots should be listened to.
* @param options Describes the listener to attach to each shadow root.
* @param options.emitter The emitter to which this behavior should be added.
* @param options.event The DOM event to listen to.
* @param options.callback The event handler.
* @param options.listenerOptions Listener options, passed through to `DomEmitter#listenTo()`.
*/ function $c7bc2cb7e2db0227$export$2a57d49549145fbd(registry, { emitter: emitter, event: event, callback: callback, listenerOptions: listenerOptions }) {
    const attachedRoots = /* @__PURE__ */ new Set();
    const sync = ()=>{
        const currentRoots = registry.getShadowRoots();
        for (const root of attachedRoots)if (!currentRoots.has(root)) {
            emitter.stopListening(root, event, callback);
            attachedRoots.delete(root);
        }
        for (const root of currentRoots)if (!attachedRoots.has(root)) {
            emitter.listenTo(root, event, callback, listenerOptions);
            attachedRoots.add(root);
        }
    };
    emitter.listenTo(registry, "add", sync);
    emitter.listenTo(registry, "remove", sync);
    sync();
    return ()=>{
        emitter.stopListening(registry, "add", sync);
        emitter.stopListening(registry, "remove", sync);
        for (const root of attachedRoots)emitter.stopListening(root, event, callback);
        attachedRoots.clear();
    };
}
/**
* The shadow roots a node lives in, or none while it is detached.
*
* A detached node still reports the shadow roots of the tree it sits in – those roots exist whether or not their
* host is in a document – but nothing in them is rendered yet, so there is nothing to listen to or inject into.
*/ function $c7bc2cb7e2db0227$var$deriveRoots(node) {
    return node.isConnected ? $c7bc2cb7e2db0227$export$9f54ef76df6accb2(node) : [];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isvalidattributename
*/ /**
* Checks if the given attribute name is valid in terms of HTML.
*
* @param name Attribute name.
*/ function $c7bc2cb7e2db0227$export$c8238713f6b74780(name) {
    try {
        $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.document.createAttribute(name);
    } catch  {
        return false;
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/isvisible
*/ /**
* Checks whether the element is visible to the user in DOM:
*
* * connected to the root of the document,
* * has no `display: none`,
* * has no ancestors with `display: none`.
*
* **Note**: This helper does not check whether the element is hidden by cropping, overflow, etc..
* To check that, use {@link module:utils/dom/rect~Rect} instead.
*
* **Note**: The ancestor lookup crosses shadow DOM boundaries, so a text node sitting directly in a shadow root
* is resolved against that root's host rather than reported as invisible. Works for open and closed shadow roots
* alike.
*/ function $c7bc2cb7e2db0227$export$795910f5f15a9633(element) {
    if (!element) return false;
    if ($c7bc2cb7e2db0227$export$1879817ac5c922b7(element)) return $c7bc2cb7e2db0227$export$795910f5f15a9633($c7bc2cb7e2db0227$export$169e5491001d3ed6(element));
    if (element.getClientRects) return !!element.getClientRects().length;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/position
*/ /**
* Calculates the `position: absolute` coordinates of a given element so it can be positioned with respect to the
* target in the visually most efficient way, taking various restrictions like viewport or limiter geometry
* into consideration.
*
* **Note**: If there are no position coordinates found that meet the requirements (arguments of this helper),
* `null` is returned.
*
* ```ts
* // The element which is to be positioned.
* const element = document.body.querySelector( '#toolbar' );
*
* // A target to which the element is positioned relatively.
* const target = document.body.querySelector( '#container' );
*
* // Finding the optimal coordinates for the positioning.
* const { left, top, name } = getOptimalPosition( {
* 	element: element,
* 	target: target,
*
* 	// The algorithm will chose among these positions to meet the requirements such
* 	// as "limiter" element or "fitInViewport", set below. The positions are considered
* 	// in the order of the array.
* 	positions: [
* 		//
* 	 	//	[ Target ]
* 		//	+-----------------+
* 		//	|     Element     |
* 		//	+-----------------+
* 		//
* 		targetRect => ( {
* 			top: targetRect.bottom,
* 			left: targetRect.left,
* 			name: 'mySouthEastPosition'
* 		} ),
*
* 		//
* 		//	+-----------------+
* 		//	|     Element     |
* 		//	+-----------------+
* 		//	[ Target ]
* 		//
* 		( targetRect, elementRect ) => ( {
* 			top: targetRect.top - elementRect.height,
* 			left: targetRect.left,
* 			name: 'myNorthEastPosition'
* 		} )
* 	],
*
* 	// Find a position such guarantees the element remains within visible boundaries of <body>.
* 	limiter: document.body,
*
* 	// Find a position such guarantees the element remains within visible boundaries of the browser viewport.
* 	fitInViewport: true
* } );
*
* // The best position which fits into document.body and the viewport. May be useful
* // to set proper class on the `element`.
* console.log( name ); // -> "myNorthEastPosition"
*
* // Using the absolute coordinates which has been found to position the element
* // as in the diagram depicting the "myNorthEastPosition" position.
* element.style.top = top;
* element.style.left = left;
* ```
*
* @param options The input data and configuration of the helper.
*/ function $c7bc2cb7e2db0227$export$75cda5409326f127({ element: element, target: target, positions: positions, limiter: limiter, fitInViewport: fitInViewport, viewportOffsetConfig: viewportOffsetConfig }) {
    if ((0, $943eba72ca89f82b$export$f6e2535fb5126e54)(target)) target = target();
    if ((0, $943eba72ca89f82b$export$f6e2535fb5126e54)(limiter)) limiter = limiter();
    const positionedElementAncestor = $c7bc2cb7e2db0227$export$f410fd9345261d8c(element);
    const constrainedViewportRect = $c7bc2cb7e2db0227$export$1d016c46491e9cd1(viewportOffsetConfig);
    const elementRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(element);
    const visibleTargetRect = $c7bc2cb7e2db0227$var$getVisibleViewportIntersectionRect(target, constrainedViewportRect);
    let bestPosition;
    if (!visibleTargetRect || !constrainedViewportRect.getIntersection(visibleTargetRect)) return null;
    const positionOptions = {
        targetRect: visibleTargetRect,
        elementRect: elementRect,
        positionedElementAncestor: positionedElementAncestor,
        viewportRect: constrainedViewportRect
    };
    if (!limiter && !fitInViewport) bestPosition = new $c7bc2cb7e2db0227$var$PositionObject(positions[0], positionOptions);
    else {
        if (limiter) {
            const visibleLimiterRect = $c7bc2cb7e2db0227$var$getVisibleViewportIntersectionRect(limiter, constrainedViewportRect);
            if (visibleLimiterRect) positionOptions.limiterRect = visibleLimiterRect;
        }
        bestPosition = $c7bc2cb7e2db0227$var$getBestPosition(positions, positionOptions);
    }
    return bestPosition;
}
/**
* Returns intersection of visible source `Rect` with Viewport `Rect`. In case when source `Rect` is not visible
* or there is no intersection between source `Rect` and Viewport `Rect`, `null` will be returned.
*/ function $c7bc2cb7e2db0227$var$getVisibleViewportIntersectionRect(source, viewportRect) {
    const visibleSourceRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(source).getVisible();
    if (!visibleSourceRect) return null;
    return visibleSourceRect.getIntersection(viewportRect);
}
/**
* Returns a viewport `Rect` shrunk by the viewport offset config from all sides.
*/ function $c7bc2cb7e2db0227$export$1d016c46491e9cd1(viewportOffsetConfig) {
    viewportOffsetConfig = Object.assign({
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    }, viewportOffsetConfig);
    const viewportRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d($c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window);
    viewportRect.top += viewportOffsetConfig.top;
    viewportRect.height -= viewportOffsetConfig.top;
    viewportRect.bottom -= viewportOffsetConfig.bottom;
    viewportRect.height -= viewportOffsetConfig.bottom;
    viewportRect.left += viewportOffsetConfig.left;
    viewportRect.right -= viewportOffsetConfig.right;
    viewportRect.width -= viewportOffsetConfig.left + viewportOffsetConfig.right;
    return viewportRect;
}
/**
* For a given array of positioning functions, returns such that provides the best
* fit of the `elementRect` into the `limiterRect` and `viewportRect`.
*/ function $c7bc2cb7e2db0227$var$getBestPosition(positions, options) {
    const { elementRect: elementRect } = options;
    const elementRectArea = elementRect.getArea();
    const positionInstances = positions.map((positioningFunction)=>new $c7bc2cb7e2db0227$var$PositionObject(positioningFunction, options)).filter((position)=>!!position.name);
    let maxFitFactor = 0;
    let bestPosition = null;
    for (const position of positionInstances){
        const { limiterIntersectionArea: limiterIntersectionArea, viewportIntersectionArea: viewportIntersectionArea } = position;
        if (limiterIntersectionArea === elementRectArea) return position;
        const fitFactor = viewportIntersectionArea ** 2 + limiterIntersectionArea ** 2;
        if (fitFactor > maxFitFactor) {
            maxFitFactor = fitFactor;
            bestPosition = position;
        }
    }
    return bestPosition;
}
/**
* A position class which instances are created and used by the {@link module:utils/dom/position~getOptimalPosition} helper.
*
* {@link module:utils/dom/position~Position#top} and {@link module:utils/dom/position~Position#left} properties of the position instance
* translate directly to the `top` and `left` properties in CSS "`position: absolute` coordinate system". If set on the positioned element
* in DOM, they will make it display it in the right place in the viewport.
*/ var $c7bc2cb7e2db0227$var$PositionObject = class {
    name;
    config;
    _positioningFunctionCoordinates;
    _options;
    _cachedRect;
    _cachedAbsoluteRect;
    /**
	* Creates an instance of the {@link module:utils/dom/position~PositionObject} class.
	*
	* @param positioningFunction function The function that defines the expected
	* coordinates the positioned element should move to.
	* @param options options object.
	* @param options.elementRect The positioned element rect.
	* @param options.targetRect The target element rect.
	* @param options.viewportRect The viewport rect.
	* @param options.limiterRect The limiter rect.
	* @param options.positionedElementAncestor Nearest element ancestor element which CSS position is not "static".
	*/ constructor(positioningFunction, options){
        const positioningFunctionOutput = positioningFunction(options.targetRect, options.elementRect, options.viewportRect, options.limiterRect);
        if (!positioningFunctionOutput) return;
        const { left: left, top: top, name: name, config: config } = positioningFunctionOutput;
        this.name = name;
        this.config = config;
        this._positioningFunctionCoordinates = {
            left: left,
            top: top
        };
        this._options = options;
    }
    /**
	* The left value in pixels in the CSS `position: absolute` coordinate system.
	* Set it on the positioned element in DOM to move it to the position.
	*/ get left() {
        return this._absoluteRect.left;
    }
    /**
	* The top value in pixels in the CSS `position: absolute` coordinate system.
	* Set it on the positioned element in DOM to move it to the position.
	*/ get top() {
        return this._absoluteRect.top;
    }
    /**
	* An intersection area between positioned element and limiter within viewport constraints.
	*/ get limiterIntersectionArea() {
        const limiterRect = this._options.limiterRect;
        if (limiterRect) return limiterRect.getIntersectionArea(this._rect);
        return 0;
    }
    /**
	* An intersection area between positioned element and viewport.
	*/ get viewportIntersectionArea() {
        return this._options.viewportRect.getIntersectionArea(this._rect);
    }
    /**
	* An already positioned element rect. A clone of the element rect passed to the constructor
	* but placed in the viewport according to the positioning function.
	*/ get _rect() {
        if (this._cachedRect) return this._cachedRect;
        this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top);
        return this._cachedRect;
    }
    /**
	* An already absolutely positioned element rect. See ({@link #_rect}).
	*/ get _absoluteRect() {
        if (this._cachedAbsoluteRect) return this._cachedAbsoluteRect;
        this._cachedAbsoluteRect = this._rect.toAbsoluteRect();
        return this._cachedAbsoluteRect;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/remove
*/ /**
* Removes given node from parent.
*
* @param node Node to remove.
*/ function $c7bc2cb7e2db0227$export$cd7f480d6b8286c3(node) {
    const parent = $c7bc2cb7e2db0227$export$4e12058fc4d51d56(node);
    if (parent) parent.removeChild(node);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/getvisualviewportoffset
*/ /**
* Returns the visual viewport offsets to adjust elements with `position: fixed` style.
*/ function $c7bc2cb7e2db0227$export$cdd2bda8bf1fea96() {
    const visualViewport = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.visualViewport;
    if (!visualViewport || !($c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isiOS || $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isSafari)) return {
        left: 0,
        top: 0
    };
    return {
        left: Math.max(Math.round(visualViewport.offsetLeft), 0),
        top: Math.max(Math.round(visualViewport.offsetTop), 0)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/dom/scroll
*/ /**
* Makes any page `HTMLElement` or `Range` (`target`) visible inside the browser viewport.
* This helper will scroll all `target` ancestors and the web browser viewport to reveal the target to
* the user. If the `target` is already visible, nothing will happen.
*
* **Note**: The ancestor walk crosses shadow DOM boundaries, continuing from the host element of a shadow root
* instead of stopping at it, so scrollable ancestors in the surrounding document are scrolled too. Works for open
* and closed shadow roots alike.
*
* @param options Additional configuration of the scrolling behavior.
* @param options.target A target, which supposed to become visible to the user.
* @param options.viewportOffset An offset from the edge of the viewport (in pixels)
* the `target` will be moved by if the viewport is scrolled. It enhances the user experience
* by keeping the `target` some distance from the edge of the viewport and thus making it easier to
* read or edit by the user.
* @param options.ancestorOffset An offset from the boundary of scrollable ancestors (if any)
* the `target` will be moved by if the viewport is scrolled. It enhances the user experience
* by keeping the `target` some distance from the edge of the ancestors and thus making it easier to
* read or edit by the user.
* @param options.alignToTop When set `true`, the helper will make sure the `target` is scrolled up
* to the top boundary of the viewport and/or scrollable ancestors if scrolled up. When not set
* (default), the `target` will be revealed by scrolling as little as possible. This option will
* not affect `targets` that must be scrolled down because they will appear at the top of the boundary
* anyway.
*
* ```
*                                             scrollViewportToShowTarget() with            scrollViewportToShowTarget() with
*          Initial state                        alignToTop unset (default)                        alignToTop = true
*
* ┌────────────────────────────────┬─┐       ┌────────────────────────────────┬─┐        ┌────────────────────────────────┬─┐
* │                                │▲│       │                                │▲│        │   [ Target to be revealed ]    │▲│
* │                                │ │       │                                │ │        │                                │ │
* │                                │█│       │                                │ │        │                                │ │
* │                                │█│       │                                │ │        │                                │ │
* │                                │ │       │                                │█│        │                                │ │
* │                                │ │       │                                │█│        │                                │█│
* │                                │ │       │                                │ │        │                                │█│
* │                                │▼│       │   [ Target to be revealed ]    │▼│        │                                │▼│
* └────────────────────────────────┴─┘       └────────────────────────────────┴─┘        └────────────────────────────────┴─┘
*
*
*     [ Target to be revealed ]
*```
*
* @param options.forceScroll When set `true`, the `target` will be aligned to the top of the viewport
* and scrollable ancestors whether it is already visible or not. This option will only work when `alignToTop`
* is `true`
*/ function $c7bc2cb7e2db0227$export$a79393a569aee68b({ target: target, viewportOffset: viewportOffset = 0, ancestorOffset: ancestorOffset = 0, alignToTop: alignToTop, forceScroll: forceScroll }) {
    const targetWindow = $c7bc2cb7e2db0227$var$getWindow(target);
    let currentWindow = targetWindow;
    let currentFrame = null;
    viewportOffset = $c7bc2cb7e2db0227$var$normalizeViewportOffset(viewportOffset);
    while(currentWindow){
        let firstAncestorToScroll;
        if (currentWindow == targetWindow) firstAncestorToScroll = $c7bc2cb7e2db0227$var$getTargetParentElement(target);
        else firstAncestorToScroll = $c7bc2cb7e2db0227$var$getTargetParentElement(currentFrame);
        $c7bc2cb7e2db0227$var$scrollAncestorsToShowRect({
            parent: firstAncestorToScroll,
            getRect: ()=>{
                return $c7bc2cb7e2db0227$var$getRectRelativeToWindow(target, currentWindow);
            },
            alignToTop: alignToTop,
            ancestorOffset: ancestorOffset,
            forceScroll: forceScroll
        });
        let targetRect = $c7bc2cb7e2db0227$var$getRectRelativeToWindow(target, currentWindow);
        const ancestorWindowRelativeRect = $c7bc2cb7e2db0227$var$getRectRelativeToWindow(firstAncestorToScroll, currentWindow);
        if (targetRect.height > ancestorWindowRelativeRect.height) {
            const ancestorTargetIntersection = targetRect.getIntersection(ancestorWindowRelativeRect);
            if (ancestorTargetIntersection) targetRect = ancestorTargetIntersection;
        }
        $c7bc2cb7e2db0227$var$scrollWindowToShowRect({
            window: currentWindow,
            rect: targetRect,
            viewportOffset: viewportOffset,
            alignToTop: alignToTop,
            forceScroll: forceScroll
        });
        if (currentWindow.parent != currentWindow) {
            currentFrame = currentWindow.frameElement;
            currentWindow = currentWindow.parent;
            if (!currentFrame) return;
        } else currentWindow = null;
    }
}
/**
* Makes any page `HTMLElement` or `Range` (target) visible within its scrollable ancestors,
* e.g. if they have `overflow: scroll` CSS style.
*
* **Note**: The ancestor walk crosses shadow DOM boundaries, continuing from the host element of a shadow root
* instead of stopping at it, so scrollable ancestors in the surrounding document are scrolled too. Works for open
* and closed shadow roots alike.
*
* @param target A target, which supposed to become visible to the user.
* @param ancestorOffset An offset between the target and the boundary of scrollable ancestors
* to be maintained while scrolling.
* @param limiterElement The outermost ancestor that should be scrolled. If specified, it can prevent
* scrolling the whole page.
* @param alignToTop When set `true`, the function will make sure the `target` is scrolled up
* to the top boundary of the scrollable ancestors if scrolled up. When not set (default), the `target`
* will be revealed by scrolling as little as possible. This option will not affect target elements that must be
* scrolled down because they will appear at the top of the boundary anyway.
* @param forceScroll When set `true`, the `target` will be aligned to the top of scrollable ancestors
* whether it is already visible or not. This option will only work when `alignToTop` is `true`
*/ function $c7bc2cb7e2db0227$export$66776e82bb6e44ef(target, ancestorOffset, limiterElement, alignToTop, forceScroll) {
    $c7bc2cb7e2db0227$var$scrollAncestorsToShowRect({
        parent: $c7bc2cb7e2db0227$var$getTargetParentElement(target),
        getRect: ()=>new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(target),
        ancestorOffset: ancestorOffset,
        limiterElement: limiterElement,
        alignToTop: alignToTop,
        forceScroll: forceScroll
    });
}
/**
* Makes a given rect visible within its parent window.
*
* Note: Avoid the situation where the caret is still in the viewport, but totally
* at the edge of it. In such situation, if it moved beyond the viewport in the next
* action e.g. after paste, the scrolling would move it to the viewportOffset level
* and it all would look like the caret visually moved up/down:
*
* 1.
* ```
* | foo[]
* |                                    <--- N px of space below the caret
* +---------------------------------...
* ```
*
* 2. *paste*
* 3.
* ```
* |
* |
* +-foo-----------------------------...
*   bar[]                              <--- caret below viewport, scrolling...
* ```
*
* 4. *scrolling*
* 5.
* ```
* |
* | foo
* | bar[]                              <--- caret precisely at the edge
* +---------------------------------...
* ```
*
* To prevent this, this method checks the rects moved by the viewportOffset to cover
* the upper/lower edge of the viewport. It makes sure if the action repeats, there's
* no twitching – it's a purely visual improvement:
*
* 5. (after fix)
* ```
* |
* | foo
* | bar[]
* |                                    <--- N px of space below the caret
* +---------------------------------...
* ```
*
* @param options Additional configuration of the scrolling behavior.
* @param options.window A window which is scrolled to reveal the rect.
* @param options.rect A rect which is to be revealed.
* @param options.viewportOffset An offset from the edge of the viewport (in pixels) the `rect` will be
* moved by if the viewport is scrolled.
* @param options.alignToTop When set `true`, the helper will make sure the `rect` is scrolled up
* to the top boundary of the viewport if scrolled up. When not set (default), the `rect` will be
* revealed by scrolling as little as possible. This option will not affect rects that must be scrolled
* down because they will appear at the top of the boundary anyway.
* @param options.forceScroll When set `true`, the `rect` will be aligned to the top of the viewport
* whether it is already visible or not. This option will only work when `alignToTop` is `true`
*/ function $c7bc2cb7e2db0227$var$scrollWindowToShowRect({ window: window1, rect: rect, alignToTop: alignToTop, forceScroll: forceScroll, viewportOffset: viewportOffset }) {
    const targetShiftedDownRect = rect.clone().moveBy(0, viewportOffset.bottom);
    const targetShiftedUpRect = rect.clone().moveBy(0, -viewportOffset.top);
    const viewportRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(window1).excludeScrollbarsAndBorders();
    const rects = [
        targetShiftedUpRect,
        targetShiftedDownRect
    ];
    const forceScrollToTop = alignToTop && forceScroll;
    const allRectsFitInViewport = rects.every((rect)=>viewportRect.contains(rect));
    let { scrollX: scrollX, scrollY: scrollY } = window1;
    const initialScrollX = scrollX;
    const initialScrollY = scrollY;
    if (forceScrollToTop) scrollY -= viewportRect.top - rect.top + viewportOffset.top;
    else if (!allRectsFitInViewport) {
        if ($c7bc2cb7e2db0227$var$isAbove(targetShiftedUpRect, viewportRect)) scrollY -= viewportRect.top - rect.top + viewportOffset.top;
        else if ($c7bc2cb7e2db0227$var$isBelow(targetShiftedDownRect, viewportRect)) {
            if (alignToTop) scrollY += rect.top - viewportRect.top - viewportOffset.top;
            else scrollY += rect.bottom - viewportRect.bottom + viewportOffset.bottom;
        }
    }
    if (!allRectsFitInViewport) {
        if ($c7bc2cb7e2db0227$var$isLeftOf(rect, viewportRect)) scrollX -= viewportRect.left - rect.left + viewportOffset.left;
        else if ($c7bc2cb7e2db0227$var$isRightOf(rect, viewportRect)) scrollX += rect.right - viewportRect.right + viewportOffset.right;
    }
    if (scrollX != initialScrollX || scrollY !== initialScrollY) window1.scrollTo(scrollX, scrollY);
}
/**
* Recursively scrolls element ancestors to visually reveal a rect.
*
* @param options Additional configuration of the scrolling behavior.
* @param options.parent The first parent ancestor to start scrolling.
* @param options.getRect A function which returns the Rect, which is to be revealed.
* @param options.ancestorOffset An offset from the boundary of scrollable ancestors (if any)
* the `Rect` instance will be moved by if the viewport is scrolled.
* @param options.alignToTop When set `true`, the helper will make sure the `Rect` instance is scrolled up
* to the top boundary of the scrollable ancestors if scrolled up. When not set (default), the `rect`
* will be revealed by scrolling as little as possible. This option will not affect rects that must be
* scrolled down because they will appear at the top of the boundary
* anyway.
* @param options.forceScroll When set `true`, the `rect` will be aligned to the top of scrollable ancestors
* whether it is already visible or not. This option will only work when `alignToTop` is `true`
* @param options.limiterElement The outermost ancestor that should be scrolled. Defaults to the `<body>` element.
*/ function $c7bc2cb7e2db0227$var$scrollAncestorsToShowRect({ parent: parent, getRect: getRect, alignToTop: alignToTop, forceScroll: forceScroll, ancestorOffset: ancestorOffset = 0, limiterElement: limiterElement }) {
    const parentWindow = $c7bc2cb7e2db0227$var$getWindow(parent);
    const forceScrollToTop = alignToTop && forceScroll;
    let parentRect, targetRect, targetFitsInTarget;
    const limiter = limiterElement || parentWindow.document.body;
    let currentParent = parent;
    while(currentParent && currentParent != limiter){
        targetRect = getRect();
        parentRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(currentParent).excludeScrollbarsAndBorders();
        targetFitsInTarget = parentRect.contains(targetRect);
        if (forceScrollToTop) currentParent.scrollTop -= parentRect.top - targetRect.top + ancestorOffset;
        else if (!targetFitsInTarget) {
            if ($c7bc2cb7e2db0227$var$isAbove(targetRect, parentRect)) currentParent.scrollTop -= parentRect.top - targetRect.top + ancestorOffset;
            else if ($c7bc2cb7e2db0227$var$isBelow(targetRect, parentRect)) {
                if (alignToTop) currentParent.scrollTop += targetRect.top - parentRect.top - ancestorOffset;
                else currentParent.scrollTop += targetRect.bottom - parentRect.bottom + ancestorOffset;
            }
        }
        if (!targetFitsInTarget) {
            if ($c7bc2cb7e2db0227$var$isLeftOf(targetRect, parentRect)) currentParent.scrollLeft -= parentRect.left - targetRect.left + ancestorOffset;
            else if ($c7bc2cb7e2db0227$var$isRightOf(targetRect, parentRect)) currentParent.scrollLeft += targetRect.right - parentRect.right + ancestorOffset;
        }
        currentParent = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(currentParent);
    }
}
/**
* Determines if a given `Rect` extends beyond the bottom edge of the second `Rect`.
*/ function $c7bc2cb7e2db0227$var$isBelow(firstRect, secondRect) {
    return firstRect.bottom > secondRect.bottom;
}
/**
* Determines if a given `Rect` extends beyond the top edge of the second `Rect`.
*/ function $c7bc2cb7e2db0227$var$isAbove(firstRect, secondRect) {
    return firstRect.top < secondRect.top;
}
/**
* Determines if a given `Rect` extends beyond the left edge of the second `Rect`.
*/ function $c7bc2cb7e2db0227$var$isLeftOf(firstRect, secondRect) {
    return firstRect.left < secondRect.left;
}
/**
* Determines if a given `Rect` extends beyond the right edge of the second `Rect`.
*/ function $c7bc2cb7e2db0227$var$isRightOf(firstRect, secondRect) {
    return firstRect.right > secondRect.right;
}
/**
* Returns the closest window of an element or range.
*/ function $c7bc2cb7e2db0227$var$getWindow(elementOrRange) {
    if ($c7bc2cb7e2db0227$export$e331ccfa6f694c99(elementOrRange)) return elementOrRange.startContainer.ownerDocument.defaultView;
    else return elementOrRange.ownerDocument.defaultView;
}
/**
* Returns the closest parent of an element or DOM range.
*
* The lookup runs over the flattened tree, so for a target at the top of a shadow root it returns the host
* instead of the shadow root itself, and for slotted content it returns the `<slot>` the content renders in.
* The result only seeds the ancestor walk of {@link ~scrollAncestorsToShowRect} – a cursor, not something
* measured, as that walk takes the target rect separately – so a slot, which generates no box of its own, is a
* valid answer and the walk carries on from inside the shadow tree.
*/ function $c7bc2cb7e2db0227$var$getTargetParentElement(elementOrRange) {
    if ($c7bc2cb7e2db0227$export$e331ccfa6f694c99(elementOrRange)) {
        let parent = elementOrRange.commonAncestorContainer;
        if ($c7bc2cb7e2db0227$export$af51f0f06c0f328a(parent)) return parent.host;
        if ($c7bc2cb7e2db0227$export$1879817ac5c922b7(parent)) parent = $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(parent);
        return parent;
    } else return $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a(elementOrRange);
}
/**
* Returns the rect of an element or range residing in an iframe.
* The result rect is relative to the geometry of the passed window instance.
*
* @param target Element or range which rect should be returned.
* @param relativeWindow A window the rect should be relative to.
*/ function $c7bc2cb7e2db0227$var$getRectRelativeToWindow(target, relativeWindow) {
    const targetWindow = $c7bc2cb7e2db0227$var$getWindow(target);
    const rect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(target);
    if (targetWindow === relativeWindow) return rect;
    else {
        let currentWindow = targetWindow;
        while(currentWindow != relativeWindow){
            const frame = currentWindow.frameElement;
            const frameRect = new $c7bc2cb7e2db0227$export$c79fc6492f3af13d(frame).excludeScrollbarsAndBorders();
            rect.moveBy(frameRect.left, frameRect.top);
            currentWindow = currentWindow.parent;
        }
    }
    return rect;
}
/**
* A helper that explodes the `viewportOffset` configuration if defined as a plain number into an object
* with `top`, `bottom`, `left`, and `right` properties.
*
* If an object value is passed, this helper will pass it through.
*
* @param viewportOffset Viewport offset to be normalized.
*/ function $c7bc2cb7e2db0227$var$normalizeViewportOffset(viewportOffset) {
    if (typeof viewportOffset === "number") return {
        top: viewportOffset,
        bottom: viewportOffset,
        left: viewportOffset,
        right: viewportOffset
    };
    return viewportOffset;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $c7bc2cb7e2db0227$var$modifiersToGlyphsMac = {
    ctrl: "\u2303",
    cmd: "\u2318",
    alt: "\u2325",
    shift: "\u21E7"
};
const $c7bc2cb7e2db0227$var$modifiersToGlyphsNonMac = {
    ctrl: "Ctrl+",
    alt: "Alt+",
    shift: "Shift+"
};
const $c7bc2cb7e2db0227$var$keyCodesToGlyphs = {
    37: "\u2190",
    38: "\u2191",
    39: "\u2192",
    40: "\u2193",
    9: "\u21E5",
    33: "Page Up",
    34: "Page Down"
};
/**
* An object with `keyName => keyCode` pairs for a set of known keys.
*
* Contains:
*
* * `a-z`,
* * `0-9`,
* * `f1-f12`,
* * `` ` ``, `-`, `=`, `[`, `]`, `;`, `'`, `,`, `.`, `/`, `\`,
* * `arrow(left|up|right|bottom)`,
* * `backspace`, `delete`, `end`, `enter`, `esc`, `home`, `tab`,
* * `ctrl`, `cmd`, `shift`, `alt`.
*/ const $c7bc2cb7e2db0227$export$6d3e562ac77a9517 = /* #__PURE__ */ $c7bc2cb7e2db0227$var$generateKnownKeyCodes();
const $c7bc2cb7e2db0227$var$keyCodeNames = /* #__PURE__ */ Object.fromEntries(/* #__PURE__ */ Object.entries($c7bc2cb7e2db0227$export$6d3e562ac77a9517).map(([name, code])=>{
    let prettyKeyName;
    if (code in $c7bc2cb7e2db0227$var$keyCodesToGlyphs) prettyKeyName = $c7bc2cb7e2db0227$var$keyCodesToGlyphs[code];
    else prettyKeyName = name.charAt(0).toUpperCase() + name.slice(1);
    return [
        code,
        prettyKeyName
    ];
}));
/**
* Converts a key name or {@link module:utils/keyboard~KeystrokeInfo keystroke info} into a key code.
*
* Note: Key names are matched with {@link module:utils/keyboard#keyCodes} in a case-insensitive way.
*
* @param key A key name (see {@link module:utils/keyboard#keyCodes}) or a keystroke data object.
* @returns Key or keystroke code.
*/ function $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb(key) {
    let keyCode;
    if (typeof key == "string") {
        keyCode = $c7bc2cb7e2db0227$export$6d3e562ac77a9517[key.toLowerCase()];
        if (!keyCode) /**
		* Unknown key name. Only key names included in the {@link module:utils/keyboard#keyCodes} can be used.
		*
		* @error keyboard-unknown-key
		* @param {string} key Ths specified key name.
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("keyboard-unknown-key", null, {
            key: key
        });
    } else keyCode = key.keyCode + (key.altKey ? $c7bc2cb7e2db0227$export$6d3e562ac77a9517.alt : 0) + (key.ctrlKey ? $c7bc2cb7e2db0227$export$6d3e562ac77a9517.ctrl : 0) + (key.shiftKey ? $c7bc2cb7e2db0227$export$6d3e562ac77a9517.shift : 0) + (key.metaKey ? $c7bc2cb7e2db0227$export$6d3e562ac77a9517.cmd : 0);
    return keyCode;
}
/**
* Parses the keystroke and returns a keystroke code that will match the code returned by
* {@link module:utils/keyboard~getCode} for the corresponding {@link module:utils/keyboard~KeystrokeInfo keystroke info}.
*
* The keystroke can be passed in two formats:
*
* * as a single string – e.g. `ctrl + A`,
* * as an array of {@link module:utils/keyboard~keyCodes known key names} and key codes – e.g.:
*   * `[ 'ctrl', 32 ]` (ctrl + space),
*   * `[ 'ctrl', 'a' ]` (ctrl + A).
*
* Note: Key names are matched with {@link module:utils/keyboard#keyCodes} in a case-insensitive way.
*
* Note: Only keystrokes with a single non-modifier key are supported (e.g. `ctrl+A` is OK, but `ctrl+A+B` is not).
*
* Note: On macOS, keystroke handling is translating the `Ctrl` key to the `Cmd` key and handling only that keystroke.
* For example, a registered keystroke `Ctrl+A` will be translated to `Cmd+A` on macOS. To disable the translation of some keystroke,
* use the forced modifier: `Ctrl!+A` (note the exclamation mark).
*
* @param keystroke The keystroke definition.
* @returns Keystroke code.
*/ function $c7bc2cb7e2db0227$export$970afd9da919f686(keystroke) {
    if (typeof keystroke == "string") keystroke = $c7bc2cb7e2db0227$var$splitKeystrokeText(keystroke);
    return keystroke.map((key)=>typeof key == "string" ? $c7bc2cb7e2db0227$var$getEnvKeyCode(key) : key).reduce((key, sum)=>sum + key, 0);
}
/**
* Translates any keystroke string text like `"Ctrl+A"` to an
* environment–specific keystroke, i.e. `"⌘A"` on macOS.
*
* @param keystroke The keystroke text.
* @param [forcedEnv] The environment to force the key translation to. If not provided, the current environment is used.
* @returns The keystroke text specific for the environment.
*/ function $c7bc2cb7e2db0227$export$bed8b4cac4d8577f(keystroke, forcedEnv) {
    let keystrokeCode = $c7bc2cb7e2db0227$export$970afd9da919f686(keystroke);
    const isMac = forcedEnv ? forcedEnv === "Mac" : $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isMac || $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isiOS;
    return Object.entries(isMac ? $c7bc2cb7e2db0227$var$modifiersToGlyphsMac : $c7bc2cb7e2db0227$var$modifiersToGlyphsNonMac).reduce((modifiers, [name, glyph])=>{
        if ((keystrokeCode & $c7bc2cb7e2db0227$export$6d3e562ac77a9517[name]) != 0) {
            keystrokeCode &= ~$c7bc2cb7e2db0227$export$6d3e562ac77a9517[name];
            modifiers += glyph;
        }
        return modifiers;
    }, "") + (keystrokeCode ? $c7bc2cb7e2db0227$var$keyCodeNames[keystrokeCode] : "");
}
/**
* Returns `true` if the provided key code represents one of the arrow keys.
*
* @param keyCode A key code as in {@link module:utils/keyboard~KeystrokeInfo#keyCode}.
*/ function $c7bc2cb7e2db0227$export$dab661d9166cd5a8(keyCode) {
    return keyCode == $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowright || keyCode == $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowleft || keyCode == $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowup || keyCode == $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowdown;
}
/**
* Returns the direction in which the {@link module:engine/model/documentselection~ModelDocumentSelection selection}
* will move when the provided arrow key code is pressed considering the language direction of the editor content.
*
* For instance, in right–to–left (RTL) content languages, pressing the left arrow means moving the selection right (forward)
* in the model structure. Similarly, pressing the right arrow moves the selection left (backward).
*
* @param keyCode A key code as in {@link module:utils/keyboard~KeystrokeInfo#keyCode}.
* @param contentLanguageDirection The content language direction, corresponding to
* {@link module:utils/locale~Locale#contentLanguageDirection}.
* @returns Localized arrow direction or `undefined` for non-arrow key codes.
*/ function $c7bc2cb7e2db0227$export$ad185f2969a88a73(keyCode, contentLanguageDirection) {
    const isLtrContent = contentLanguageDirection === "ltr";
    switch(keyCode){
        case $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowleft:
            return isLtrContent ? "left" : "right";
        case $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowright:
            return isLtrContent ? "right" : "left";
        case $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowup:
            return "up";
        case $c7bc2cb7e2db0227$export$6d3e562ac77a9517.arrowdown:
            return "down";
    }
}
/**
* Converts a key name to the key code with mapping based on the env.
*
* See: {@link module:utils/keyboard~getCode}.
*
* @param key The key name (see {@link module:utils/keyboard#keyCodes}).
* @returns Key code.
*/ function $c7bc2cb7e2db0227$var$getEnvKeyCode(key) {
    if (key.endsWith("!")) return $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb(key.slice(0, -1));
    const code = $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb(key);
    return ($c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isMac || $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3.isiOS) && code == $c7bc2cb7e2db0227$export$6d3e562ac77a9517.ctrl ? $c7bc2cb7e2db0227$export$6d3e562ac77a9517.cmd : code;
}
/**
* Determines if the provided key code moves the {@link module:engine/model/documentselection~ModelDocumentSelection selection}
* forward or backward considering the language direction of the editor content.
*
* For instance, in right–to–left (RTL) languages, pressing the left arrow means moving forward
* in the model structure. Similarly, pressing the right arrow moves the selection backward.
*
* @param keyCode A key code as in {@link module:utils/keyboard~KeystrokeInfo#keyCode}.
* @param contentLanguageDirection The content language direction, corresponding to
* {@link module:utils/locale~Locale#contentLanguageDirection}.
*/ function $c7bc2cb7e2db0227$export$5fc5d3db3d467e64(keyCode, contentLanguageDirection) {
    const localizedKeyCodeDirection = $c7bc2cb7e2db0227$export$ad185f2969a88a73(keyCode, contentLanguageDirection);
    return localizedKeyCodeDirection === "down" || localizedKeyCodeDirection === "right";
}
function $c7bc2cb7e2db0227$var$generateKnownKeyCodes() {
    const keyCodes = {
        pageup: 33,
        pagedown: 34,
        end: 35,
        home: 36,
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        shift: 2228224,
        alt: 4456448,
        cmd: 8912896
    };
    for(let code = 65; code <= 90; code++){
        const letter = String.fromCharCode(code);
        keyCodes[letter.toLowerCase()] = code;
    }
    for(let code = 48; code <= 57; code++)keyCodes[code - 48] = code;
    for(let code = 112; code <= 123; code++)keyCodes["f" + (code - 111)] = code;
    Object.assign(keyCodes, {
        "'": 222,
        ",": 108,
        "-": 109,
        ".": 110,
        "/": 111,
        ";": 186,
        "=": 187,
        "[": 219,
        "\\": 220,
        "]": 221,
        "`": 223
    });
    return keyCodes;
}
function $c7bc2cb7e2db0227$var$splitKeystrokeText(keystroke) {
    return keystroke.split("+").map((key)=>key.trim());
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $c7bc2cb7e2db0227$var$RTL_LANGUAGE_CODES = [
    "ar",
    "ara",
    "dv",
    "div",
    "fa",
    "per",
    "fas",
    "he",
    "heb",
    "ku",
    "kur",
    "ug",
    "uig",
    "ur",
    "urd"
];
/**
* Helps determine whether a language text direction is LTR or RTL.
*
* @param languageCode The ISO 639-1 or ISO 639-2 language code.
*/ function $c7bc2cb7e2db0227$export$3720542e60e4e185(languageCode) {
    return $c7bc2cb7e2db0227$var$RTL_LANGUAGE_CODES.includes(languageCode) ? "rtl" : "ltr";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /* v8 ignore else -- @preserve */ if (!$c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS) $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS = {};
/**
* Adds translations to existing ones or overrides the existing translations. These translations will later
* be available for the {@link module:utils/locale~Locale#t `t()`} function.
*
* The `translations` is an object which consists of `messageId: translation` pairs. Note that the message ID can be
* either constructed from the message string or from the message ID if it was passed
* (this happens rarely and mostly for short messages or messages with placeholders).
* Since the editor displays only the message string, the message ID can be found either in the source code or in the
* built translations for another language.
*
* ```ts
* add( 'pl', {
* 	'Cancel': 'Anuluj',
* 	'IMAGE': 'obraz', // Note that the `IMAGE` comes from the message ID, while the string can be `image`.
* } );
* ```
*
* If the message is supposed to support various plural forms, make sure to provide an array with the singular form and all plural forms:
*
* ```ts
* add( 'pl', {
* 	'Add space': [ 'Dodaj spację', 'Dodaj %0 spacje', 'Dodaj %0 spacji' ]
* } );
* ```
*
* You should also specify the third argument (the `getPluralForm()` function) that will be used to determine the plural form if no
* language file was loaded for that language. All language files coming from CKEditor 5 sources will have this option set, so
* these plural form rules will be reused by other translations added to the registered languages. The `getPluralForm()` function
* can return either a Boolean or a number.
*
* ```ts
* add( 'en', {
* 	// ... Translations.
* }, n => n !== 1 );
* add( 'pl', {
* 	// ... Translations.
* }, n => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && ( n % 100 < 10 || n % 100 >= 20 ) ? 1 : 2 );
* ```
*
* All translations extend the global `window.CKEDITOR_TRANSLATIONS` object. An example of this object can be found below:
*
* ```ts
* {
* 	pl: {
* 		dictionary: {
* 			'Cancel': 'Anuluj',
* 			'Add space': [ 'Dodaj spację', 'Dodaj %0 spacje', 'Dodaj %0 spacji' ]
* 		},
* 		// A function that returns the plural form index.
* 		getPluralForm: n => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && ( n % 100 < 10 || n % 100 >= 20 ) ? 1 : 2 );
* 	}
* 	// Other languages.
* 	}
* ```
*
* If you cannot import { this function } from this module (e.g. because you use a CKEditor 5 build), you can
* still add translations by extending the global `window.CKEDITOR_TRANSLATIONS` object by using a function like
* the one below:
*
* ```ts
* function addTranslations( language, translations, getPluralForm ) {
* 	if ( !global.window.CKEDITOR_TRANSLATIONS ) {
* 		global.window.CKEDITOR_TRANSLATIONS = {};
* 	}

* 	if ( !global.window.CKEDITOR_TRANSLATIONS[ language ] ) {
* 		global.window.CKEDITOR_TRANSLATIONS[ language ] = {};
* 	}
*
* 	const languageTranslations = global.window.CKEDITOR_TRANSLATIONS[ language ];
*
* 	languageTranslations.dictionary = languageTranslations.dictionary || {};
* 	languageTranslations.getPluralForm = getPluralForm || languageTranslations.getPluralForm;
*
* 	// Extend the dictionary for the given language.
* 	Object.assign( languageTranslations.dictionary, translations );
* }
* ```
*
* @param language Target language.
* @param translations An object with translations which will be added to the dictionary.
* For each message ID the value should be either a translation or an array of translations if the message
* should support plural forms.
* @param getPluralForm A function that returns the plural form index (a number).
*/ function $c7bc2cb7e2db0227$export$e16d8520af44a096(language, translations, getPluralForm) {
    if (!$c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS[language]) $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS[language] = {};
    const languageTranslations = $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS[language];
    languageTranslations.dictionary = languageTranslations.dictionary || {};
    languageTranslations.getPluralForm = getPluralForm || languageTranslations.getPluralForm;
    Object.assign(languageTranslations.dictionary, translations);
}
/**
* **Note:** This method is internal, use {@link module:utils/locale~Locale#t the `t()` function} instead to translate
* the editor UI parts.
*
* This function is responsible for translating messages to the specified language. It uses translations added perviously
* by {@link module:utils/translation-service~add} (a translations dictionary and the `getPluralForm()` function
* to provide accurate translations of plural forms).
*
* When no translation is defined in the dictionary or the dictionary does not exist, this function returns
* the original message string or the message plural depending on the number of elements.
*
* ```ts
* translate( 'pl', { string: 'Cancel' } ); // 'Cancel'
* ```
*
* The third optional argument is the number of elements, based on which the single form or one of the plural forms
* should be picked when the message is supposed to support various plural forms.
*
* ```ts
* translate( 'en', { string: 'Add a space', plural: 'Add %0 spaces' }, 1 ); // 'Add a space'
* translate( 'en', { string: 'Add a space', plural: 'Add %0 spaces' }, 3 ); // 'Add %0 spaces'
* ```
*
* The message should provide an ID using the `id` property when the message strings are not unique and their
* translations should be different.
*
* ```ts
* translate( 'en', { string: 'image', id: 'ADD_IMAGE' } );
* translate( 'en', { string: 'image', id: 'AN_IMAGE' } );
* ```
*
* @internal
* @param language Target language.
* @param message A message that will be translated.
* @param quantity The number of elements for which a plural form should be picked from the target language dictionary.
* @param translations Translations passed in editor config, if not provided use the global `window.CKEDITOR_TRANSLATIONS`.
* @returns Translated sentence.
*/ function $c7bc2cb7e2db0227$export$4ad3db330991f17d(language, message, quantity = 1, translations) {
    if (typeof quantity !== "number") /**
	* An incorrect value was passed to the translation function. This was probably caused
	* by an incorrect message interpolation of a plural form. Note that for messages supporting plural forms
	* the second argument of the `t()` function should always be a number or an array with a number as the first element.
	*
	* @error translation-service-quantity-not-a-number
	*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("translation-service-quantity-not-a-number", null, {
        quantity: quantity
    });
    const normalizedTranslations = translations || $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS;
    const numberOfLanguages = $c7bc2cb7e2db0227$var$getNumberOfLanguages(normalizedTranslations);
    if (numberOfLanguages === 1) language = Object.keys(normalizedTranslations)[0];
    const messageId = message.id || message.string;
    if (numberOfLanguages === 0 || !$c7bc2cb7e2db0227$var$hasTranslation(language, messageId, normalizedTranslations)) {
        if (quantity !== 1) return message.plural;
        return message.string;
    }
    const dictionary = normalizedTranslations[language].dictionary;
    const getPluralForm = normalizedTranslations[language].getPluralForm || ((n)=>n === 1 ? 0 : 1);
    const translation = dictionary[messageId];
    if (typeof translation === "string") return translation;
    return translation[Number(getPluralForm(quantity))];
}
/**
* Clears dictionaries for test purposes.
*
* @internal
*/ function $c7bc2cb7e2db0227$export$70128416b9eb7758() {
    if ($c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS) $c7bc2cb7e2db0227$export$90b4d2ff6acb88af.window.CKEDITOR_TRANSLATIONS = {};
}
/**
* If array then merge objects which are inside otherwise return given object.
*
* @internal
* @param translations Translations passed in editor config.
*/ function $c7bc2cb7e2db0227$export$529f334d9d81c879(translations) {
    return Array.isArray(translations) ? translations.reduce((acc, translation)=>(0, $b1d877320958e43c$export$4950aa0f605343fb)(acc, translation), {}) : translations;
}
/**
* Checks whether the dictionary exists and translation in that dictionary exists.
*/ function $c7bc2cb7e2db0227$var$hasTranslation(language, messageId, translations) {
    return !!translations[language] && !!translations[language].dictionary[messageId];
}
function $c7bc2cb7e2db0227$var$getNumberOfLanguages(translations) {
    return Object.keys(translations).length;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/locale
*/ /**
* Represents the localization services.
*/ var $c7bc2cb7e2db0227$export$d4f428a61c37ddfa = class {
    /**
	* The editor UI language code in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
	*
	* If the {@link #contentLanguage content language} was not specified in the `Locale` constructor,
	* it also defines the language of the content.
	*/ uiLanguage;
    /**
	* Text direction of the {@link #uiLanguage editor UI language}. Either `'ltr'` or `'rtl'`.
	*/ uiLanguageDirection;
    /**
	* The editor content language code in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
	*
	* Usually the same as the {@link #uiLanguage editor language}, it can be customized by passing an optional
	* argument to the `Locale` constructor.
	*/ contentLanguage;
    /**
	* Text direction of the {@link #contentLanguage editor content language}.
	*
	* If the content language was passed directly to the `Locale` constructor, this property represents the
	* direction of that language.
	*
	* If the {@link #contentLanguage editor content language} was derived from the {@link #uiLanguage editor language},
	* the content language direction is the same as the {@link #uiLanguageDirection UI language direction}.
	*
	* The value is either `'ltr'` or `'rtl'`.
	*/ contentLanguageDirection;
    /**
	* Translates the given message to the {@link #uiLanguage}. This method is also available in
	* {@link module:core/editor/editor~Editor#t `Editor`} and {@link module:ui/view~View#t `View`}.
	*
	* This method's context is statically bound to the `Locale` instance and **should always be called as a function**:
	*
	* ```ts
	* const t = locale.t;
	* t( 'Label' );
	* ```
	*
	* The message can be either a string or an object implementing the {@link module:utils/translation-service~Message} interface.
	*
	* The message may contain placeholders (`%<index>`) for value(s) that are passed as a `values` parameter.
	* For an array of values, the `%<index>` will be changed to an element of that array at the given index.
	* For a single value passed as the second argument, only the `%0` placeholders will be changed to the provided value.
	*
	* ```ts
	* t( 'Created file "%0" in %1ms.', [ fileName, timeTaken ] );
	* t( 'Created file "%0", fileName );
	* ```
	*
	* The message supports plural forms. To specify the plural form, use the `plural` property. Singular or plural form
	* will be chosen depending on the first value from the passed `values`. The value of the `plural` property is used
	* as a default plural translation when the translation for the target language is missing.
	*
	* ```ts
	* t( { string: 'Add a space', plural: 'Add %0 spaces' }, 1 ); // 'Add a space' for the English language.
	* t( { string: 'Add a space', plural: 'Add %0 spaces' }, 5 ); // 'Add 5 spaces' for the English language.
	* t( { string: '%1 a space', plural: '%1 %0 spaces' }, [ 2, 'Add' ] ); // 'Add 2 spaces' for the English language.
	*
	* t( { string: 'Add a space', plural: 'Add %0 spaces' }, 1 ); // 'Dodaj spację' for the Polish language.
	* t( { string: 'Add a space', plural: 'Add %0 spaces' }, 5 ); // 'Dodaj 5 spacji' for the Polish language.
	* t( { string: '%1 a space', plural: '%1 %0 spaces' }, [ 2, 'Add' ] ); // 'Dodaj 2 spacje' for the Polish language.
	* ```
	*
	*  * The message should provide an ID using the `id` property when the message strings are not unique and their
	* translations should be different.
	*
	* ```ts
	* translate( 'en', { string: 'image', id: 'ADD_IMAGE' } );
	* translate( 'en', { string: 'image', id: 'AN_IMAGE' } );
	* ```
	*/ t;
    /**
	* Object that contains translations.
	*/ translations;
    /**
	* Creates a new instance of the locale class. Learn more about
	* {@glink getting-started/setup/ui-language configuring the language of the editor}.
	*
	* @param options Locale configuration.
	* @param options.uiLanguage The editor UI language code in the
	* [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format. See {@link #uiLanguage}.
	* @param options.contentLanguage The editor content language code in the
	* [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format. If not specified, the same as `options.language`.
	* See {@link #contentLanguage}.
	* @param options.translations Translations passed as a editor config parameter.
	*/ constructor({ uiLanguage: uiLanguage = "en", contentLanguage: contentLanguage, translations: translations } = {}){
        this.uiLanguage = uiLanguage;
        this.contentLanguage = contentLanguage || this.uiLanguage;
        this.uiLanguageDirection = $c7bc2cb7e2db0227$export$3720542e60e4e185(this.uiLanguage);
        this.contentLanguageDirection = $c7bc2cb7e2db0227$export$3720542e60e4e185(this.contentLanguage);
        this.translations = $c7bc2cb7e2db0227$export$529f334d9d81c879(translations);
        this.t = (message, values)=>this._t(message, values);
    }
    /**
	* An unbound version of the {@link #t} method.
	*/ _t(message, values = []) {
        values = $c7bc2cb7e2db0227$export$45b10814cc054894(values);
        if (typeof message === "string") message = {
            string: message
        };
        const quantity = !!message.plural ? values[0] : 1;
        return $c7bc2cb7e2db0227$var$interpolateString($c7bc2cb7e2db0227$export$4ad3db330991f17d(this.uiLanguage, message, quantity, this.translations), values);
    }
};
/**
* Fills the `%0, %1, ...` string placeholders with values.
*/ function $c7bc2cb7e2db0227$var$interpolateString(string, values) {
    return string.replace(/%(\d+)/g, (match, index)=>{
        return index < values.length ? values[index] : match;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/collection
*/ const $c7bc2cb7e2db0227$var$CollectionBase = /* #__PURE__ */ $c7bc2cb7e2db0227$export$1f0c3be316c44594();
/**
* Collections are ordered sets of objects. Items in the collection can be retrieved by their indexes
* in the collection (like in an array) or by their ids.
*
* If an object without an `id` property is being added to the collection, the `id` property will be generated
* automatically. Note that the automatically generated id is unique only within this single collection instance.
*
* By default an item in the collection is identified by its `id` property. The name of the identifier can be
* configured through the constructor of the collection.
*
* @typeParam T The type of the collection element.
*/ var $c7bc2cb7e2db0227$export$fb8073518f34e6ec = class extends $c7bc2cb7e2db0227$var$CollectionBase {
    /**
	* The internal list of items in the collection.
	*/ _items;
    /**
	* The internal map of items in the collection.
	*/ _itemMap;
    /**
	* The name of the property which is considered to identify an item.
	*/ _idProperty;
    /**
	* A collection instance this collection is bound to as a result
	* of calling {@link #bindTo} method.
	*/ _bindToCollection;
    /**
	* A helper mapping external items of a bound collection ({@link #bindTo})
	* and actual items of this collection. It provides information
	* necessary to properly remove items bound to another collection.
	*
	* See {@link #_bindToInternalToExternalMap}.
	*/ _bindToExternalToInternalMap;
    /**
	* A helper mapping items of this collection to external items of a bound collection
	* ({@link #bindTo}). It provides information necessary to manage the bindings, e.g.
	* to avoid loops in two–way bindings.
	*
	* See {@link #_bindToExternalToInternalMap}.
	*/ _bindToInternalToExternalMap;
    /**
	* Stores indexes of skipped items from bound external collection.
	*/ _skippedIndexesFromExternal;
    constructor(initialItemsOrOptions = {}, options = {}){
        super();
        const hasInitialItems = $c7bc2cb7e2db0227$export$9652023d9040757(initialItemsOrOptions);
        if (!hasInitialItems) options = initialItemsOrOptions;
        this._items = [];
        this._itemMap = /* @__PURE__ */ new Map();
        this._idProperty = options.idProperty || "id";
        this._bindToExternalToInternalMap = /* @__PURE__ */ new WeakMap();
        this._bindToInternalToExternalMap = /* @__PURE__ */ new WeakMap();
        this._skippedIndexesFromExternal = [];
        if (hasInitialItems) for (const item of initialItemsOrOptions){
            this._items.push(item);
            this._itemMap.set(this._getItemIdBeforeAdding(item), item);
        }
    }
    /**
	* The number of items available in the collection.
	*/ get length() {
        return this._items.length;
    }
    /**
	* Returns the first item from the collection or null when collection is empty.
	*/ get first() {
        return this._items[0] || null;
    }
    /**
	* Returns the last item from the collection or null when collection is empty.
	*/ get last() {
        return this._items[this.length - 1] || null;
    }
    /**
	* Adds an item into the collection.
	*
	* If the item does not have an id, then it will be automatically generated and set on the item.
	*
	* @param item
	* @param index The position of the item in the collection. The item
	* is pushed to the collection when `index` not specified.
	* @fires add
	* @fires change
	*/ add(item, index) {
        return this.addMany([
            item
        ], index);
    }
    /**
	* Adds multiple items into the collection.
	*
	* Any item not containing an id will get an automatically generated one.
	*
	* @param items
	* @param index The position of the insertion. Items will be appended if no `index` is specified.
	* @fires add
	* @fires change
	*/ addMany(items, index) {
        if (index === void 0) index = this._items.length;
        else if (index > this._items.length || index < 0) /**
		* The `index` passed to {@link module:utils/collection~Collection#addMany `Collection#addMany()`}
		* is invalid. It must be a number between 0 and the collection's length.
		*
		* @error collection-add-item-invalid-index
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-add-item-invalid-index", this);
        let offset = 0;
        for (const item of items){
            const itemId = this._getItemIdBeforeAdding(item);
            const currentItemIndex = index + offset;
            this._items.splice(currentItemIndex, 0, item);
            this._itemMap.set(itemId, item);
            this.fire("add", item, currentItemIndex);
            offset++;
        }
        this.fire("change", {
            added: items,
            removed: [],
            index: index
        });
        return this;
    }
    /**
	* Gets an item by its ID or index.
	*
	* @param idOrIndex The item ID or index in the collection.
	* @returns The requested item or `null` if such item does not exist.
	*/ get(idOrIndex) {
        let item;
        if (typeof idOrIndex == "string") item = this._itemMap.get(idOrIndex);
        else if (typeof idOrIndex == "number") item = this._items[idOrIndex];
        else /**
		* An index or ID must be given.
		*
		* @error collection-get-invalid-arg
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-get-invalid-arg", this);
        return item || null;
    }
    /**
	* Returns a Boolean indicating whether the collection contains an item.
	*
	* @param itemOrId The item or its ID in the collection.
	* @returns `true` if the collection contains the item, `false` otherwise.
	*/ has(itemOrId) {
        if (typeof itemOrId == "string") return this._itemMap.has(itemOrId);
        else {
            const id = itemOrId[this._idProperty];
            return id && this._itemMap.has(id);
        }
    }
    /**
	* Gets an index of an item in the collection.
	* When an item is not defined in the collection, the index will equal -1.
	*
	* @param itemOrId The item or its ID in the collection.
	* @returns The index of a given item.
	*/ getIndex(itemOrId) {
        let item;
        if (typeof itemOrId == "string") item = this._itemMap.get(itemOrId);
        else item = itemOrId;
        return item ? this._items.indexOf(item) : -1;
    }
    /**
	* Removes an item from the collection.
	*
	* @param subject The item to remove, its ID or index in the collection.
	* @returns The removed item.
	* @fires remove
	* @fires change
	*/ remove(subject) {
        const [item, index] = this._remove(subject);
        this.fire("change", {
            added: [],
            removed: [
                item
            ],
            index: index
        });
        return item;
    }
    /**
	* Executes the callback for each item in the collection and composes an array or values returned by this callback.
	*
	* @typeParam U The result type of the callback.
	* @param callback
	* @param ctx Context in which the `callback` will be called.
	* @returns The result of mapping.
	*/ map(callback, ctx) {
        return this._items.map(callback, ctx);
    }
    /**
	* Performs the specified action for each item in the collection.
	*
	* @param ctx Context in which the `callback` will be called.
	*/ forEach(callback, ctx) {
        this._items.forEach(callback, ctx);
    }
    /**
	* Finds the first item in the collection for which the `callback` returns a true value.
	*
	* @param callback
	* @param ctx Context in which the `callback` will be called.
	* @returns The item for which `callback` returned a true value.
	*/ find(callback, ctx) {
        return this._items.find(callback, ctx);
    }
    /**
	* Returns an array with items for which the `callback` returned a true value.
	*
	* @param callback
	* @param ctx Context in which the `callback` will be called.
	* @returns The array with matching items.
	*/ filter(callback, ctx) {
        return this._items.filter(callback, ctx);
    }
    /**
	* Removes all items from the collection and destroys the binding created using
	* {@link #bindTo}.
	*
	* @fires remove
	* @fires change
	*/ clear() {
        if (this._bindToCollection) {
            this.stopListening(this._bindToCollection);
            this._bindToCollection = null;
        }
        const removedItems = Array.from(this._items);
        while(this.length)this._remove(0);
        this.fire("change", {
            added: [],
            removed: removedItems,
            index: 0
        });
    }
    /**
	* Binds and synchronizes the collection with another one.
	*
	* The binding can be a simple factory:
	*
	* ```ts
	* class FactoryClass {
	* 	public label: string;
	*
	* 	constructor( data: { label: string } ) {
	* 		this.label = data.label;
	* 	}
	* }
	*
	* const source = new Collection<{ label: string }>( { idProperty: 'label' } );
	* const target = new Collection<FactoryClass>();
	*
	* target.bindTo( source ).as( FactoryClass );
	*
	* source.add( { label: 'foo' } );
	* source.add( { label: 'bar' } );
	*
	* console.log( target.length ); // 2
	* console.log( target.get( 1 ).label ); // 'bar'
	*
	* source.remove( 0 );
	* console.log( target.length ); // 1
	* console.log( target.get( 0 ).label ); // 'bar'
	* ```
	*
	* or the factory driven by a custom callback:
	*
	* ```ts
	* class FooClass {
	* 	public label: string;
	*
	* 	constructor( data: { label: string } ) {
	* 		this.label = data.label;
	* 	}
	* }
	*
	* class BarClass {
	* 	public label: string;
	*
	* 	constructor( data: { label: string } ) {
	* 		this.label = data.label;
	* 	}
	* }
	*
	* const source = new Collection<{ label: string }>( { idProperty: 'label' } );
	* const target = new Collection<FooClass | BarClass>();
	*
	* target.bindTo( source ).using( ( item ) => {
	* 	if ( item.label == 'foo' ) {
	* 		return new FooClass( item );
	* 	} else {
	* 		return new BarClass( item );
	* 	}
	* } );
	*
	* source.add( { label: 'foo' } );
	* source.add( { label: 'bar' } );
	*
	* console.log( target.length ); // 2
	* console.log( target.get( 0 ) instanceof FooClass ); // true
	* console.log( target.get( 1 ) instanceof BarClass ); // true
	* ```
	*
	* or the factory out of property name:
	*
	* ```ts
	* const source = new Collection<{ nested: { value: string } }>();
	* const target = new Collection<{ value: string }>();
	*
	* target.bindTo( source ).using( 'nested' );
	*
	* source.add( { nested: { value: 'foo' } } );
	* source.add( { nested: { value: 'bar' } } );
	*
	* console.log( target.length ); // 2
	* console.log( target.get( 0 ).value ); // 'foo'
	* console.log( target.get( 1 ).value ); // 'bar'
	* ```
	*
	* It's possible to skip specified items by returning null value:
	*
	* ```ts
	* const source = new Collection<{ hidden: boolean }>();
	* const target = new Collection<{ hidden: boolean }>();
	*
	* target.bindTo( source ).using( item => {
	* 	if ( item.hidden ) {
	* 		return null;
	* 	}
	*
	* 	return item;
	* } );
	*
	* source.add( { hidden: true } );
	* source.add( { hidden: false } );
	*
	* console.log( source.length ); // 2
	* console.log( target.length ); // 1
	* ```
	*
	* **Note**: {@link #clear} can be used to break the binding.
	*
	* @typeParam S The type of `externalCollection` element.
	* @param externalCollection A collection to be bound.
	* @returns The binding chain object.
	*/ bindTo(externalCollection) {
        if (this._bindToCollection) /**
		* The collection cannot be bound more than once.
		*
		* @error collection-bind-to-rebind
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-bind-to-rebind", this);
        this._bindToCollection = externalCollection;
        return {
            as: (Class)=>{
                this._setUpBindToBinding((item)=>new Class(item));
            },
            using: (callbackOrProperty)=>{
                if (typeof callbackOrProperty == "function") this._setUpBindToBinding(callbackOrProperty);
                else this._setUpBindToBinding((item)=>item[callbackOrProperty]);
            }
        };
    }
    /**
	* Finalizes and activates a binding initiated by {@link #bindTo}.
	*
	* @param factory A function which produces collection items.
	*/ _setUpBindToBinding(factory) {
        const externalCollection = this._bindToCollection;
        const addItem = (evt, externalItem, index)=>{
            const isExternalBoundToThis = externalCollection._bindToCollection == this;
            const externalItemBound = externalCollection._bindToInternalToExternalMap.get(externalItem);
            if (isExternalBoundToThis && externalItemBound) {
                this._bindToExternalToInternalMap.set(externalItem, externalItemBound);
                this._bindToInternalToExternalMap.set(externalItemBound, externalItem);
            } else {
                const item = factory(externalItem);
                if (!item) {
                    this._skippedIndexesFromExternal.push(index);
                    return;
                }
                let finalIndex = index;
                for (const skipped of this._skippedIndexesFromExternal)if (index > skipped) finalIndex--;
                for (const skipped of externalCollection._skippedIndexesFromExternal)if (finalIndex >= skipped) finalIndex++;
                this._bindToExternalToInternalMap.set(externalItem, item);
                this._bindToInternalToExternalMap.set(item, externalItem);
                this.add(item, finalIndex);
                for(let i = 0; i < externalCollection._skippedIndexesFromExternal.length; i++)if (finalIndex <= externalCollection._skippedIndexesFromExternal[i]) externalCollection._skippedIndexesFromExternal[i]++;
            }
        };
        for (const externalItem of externalCollection)addItem(null, externalItem, externalCollection.getIndex(externalItem));
        this.listenTo(externalCollection, "add", addItem);
        this.listenTo(externalCollection, "remove", (evt, externalItem, index)=>{
            const item = this._bindToExternalToInternalMap.get(externalItem);
            if (item) this.remove(item);
            this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((result, skipped)=>{
                if (index < skipped) result.push(skipped - 1);
                if (index > skipped) result.push(skipped);
                return result;
            }, []);
        });
    }
    /**
	* Returns an unique id property for a given `item`.
	*
	* The method will generate new id and assign it to the `item` if it doesn't have any.
	*
	* @param item Item to be added.
	*/ _getItemIdBeforeAdding(item) {
        const idProperty = this._idProperty;
        let itemId;
        if (idProperty in item) {
            itemId = item[idProperty];
            if (typeof itemId != "string") /**
			* This item's ID should be a string.
			*
			* @error collection-add-invalid-id
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-add-invalid-id", this);
            if (this.get(itemId)) /**
			* This item already exists in the collection.
			*
			* @error collection-add-item-already-exists
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-add-item-already-exists", this);
        } else item[idProperty] = itemId = $c7bc2cb7e2db0227$export$e2a22331486dcca0();
        return itemId;
    }
    /**
	* Core {@link #remove} method implementation shared in other functions.
	*
	* In contrast this method **does not** fire the {@link #event:change} event.
	*
	* @param subject The item to remove, its id or index in the collection.
	* @returns Returns an array with the removed item and its index.
	* @fires remove
	*/ _remove(subject) {
        let index, id, item;
        let itemDoesNotExist;
        const idProperty = this._idProperty;
        if (typeof subject == "string") {
            id = subject;
            item = this._itemMap.get(id);
            itemDoesNotExist = !item;
            if (item) index = this._items.indexOf(item);
        } else if (typeof subject == "number") {
            index = subject;
            item = this._items[index];
            itemDoesNotExist = !item;
            if (item) id = item[idProperty];
        } else {
            item = subject;
            id = item[idProperty];
            index = this._items.indexOf(item);
            itemDoesNotExist = index == -1 || !this._itemMap.get(id);
        }
        if (itemDoesNotExist) /**
		* Item not found.
		*
		* @error collection-remove-404
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("collection-remove-404", this);
        this._items.splice(index, 1);
        this._itemMap.delete(id);
        const externalItem = this._bindToInternalToExternalMap.get(item);
        this._bindToInternalToExternalMap.delete(item);
        this._bindToExternalToInternalMap.delete(externalItem);
        this.fire("remove", item, index);
        return [
            item,
            index
        ];
    }
    /**
	* Iterable interface.
	*/ [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/first
*/ /**
* Returns first item of the given `iterator`.
*/ function $c7bc2cb7e2db0227$export$43128fadae87b74a(iterator) {
    const iteratorItem = iterator.next();
    if (iteratorItem.done) return null;
    return iteratorItem.value;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/nth
*/ /**
* Returns `nth` (starts from `0` of course) item of the given `iterable`.
*
* If the iterable is a generator, then it consumes **all its items**.
* If it's a normal iterator, then it consumes **all items up to the given index**.
* Refer to the [Iterators and Generators](https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Iterators_and_Generators)
* guide to learn differences between these interfaces.
*/ function $c7bc2cb7e2db0227$export$6f6258299a22298a(index, iterable) {
    for (const item of iterable){
        if (index === 0) return item;
        index -= 1;
    }
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/focustracker
*/ const $c7bc2cb7e2db0227$var$FocusTrackerBase = /* #__PURE__ */ $c7bc2cb7e2db0227$export$537a1d64e9da4c8f(/* #__PURE__ */ $c7bc2cb7e2db0227$export$316ae78324a4e1c0());
/**
* Allows observing a group of DOM `Element`s or {@link module:ui/view~View view instances} whether at least one of them (or their child)
* is focused.
*
* Used by the {@link module:core/editor/editor~Editor} in order to track whether the focus is still within the application,
* or were used outside of its UI.
*
* **Note** `focus` and `blur` listeners use event capturing, so it is only needed to register wrapper `Element`
* which contain other `focusable` elements. But note that this wrapper element has to be focusable too
* (have e.g. `tabindex="-1"`).
*
* Check out the {@glink framework/deep-dive/ui/focus-tracking "Deep dive into focus tracking"} guide to learn more.
*/ var $c7bc2cb7e2db0227$export$fc044e1b74b9ba94 = class extends $c7bc2cb7e2db0227$var$FocusTrackerBase {
    /**
	* List of registered DOM elements.
	*
	* @internal
	*/ _elements = /* @__PURE__ */ new Set();
    /**
	* List of views with external focus trackers that contribute to the state of this focus tracker.
	*
	* @internal
	*/ _externalViews = /* @__PURE__ */ new Set();
    /**
	* Asynchronous blur event timeout.
	*/ _blurTimeout = null;
    constructor(){
        super();
        this.set("isFocused", false);
        this.set("focusedElement", null);
    }
    /**
	* List of registered DOM elements.
	*
	* **Note**: The list does do not include elements from {@link #externalViews}.
	*/ get elements() {
        return Array.from(this._elements.values());
    }
    /**
	* List of external focusable views that contribute to the state of this focus tracker. See {@link #add} to learn more.
	*/ get externalViews() {
        return Array.from(this._externalViews.values());
    }
    /**
	* Starts tracking a specified DOM element or a {@link module:ui/view~View} instance.
	*
	* * If a DOM element is passed, the focus tracker listens to the `focus` and `blur` events on this element.
	* Tracked elements are listed in {@link #elements}.
	* * If a {@link module:ui/view~View} instance is passed that has a `FocusTracker` instance ({@link ~ViewWithFocusTracker}),
	* the external focus tracker's state ({@link #isFocused}, {@link #focusedElement}) starts contributing to the current tracker instance.
	* This allows for increasing the "reach" of a focus tracker instance, by connecting two or more focus trackers together when DOM
	* elements they track are located in different subtrees in DOM. External focus trackers are listed in {@link #externalViews}.
	* * If a {@link module:ui/view~View} instance is passed that has no `FocusTracker` (**not** a {@link ~ViewWithFocusTracker}),
	* its {@link module:ui/view~View#element} is used to track focus like any other DOM element.
	*/ add(elementOrView) {
        if ($c7bc2cb7e2db0227$var$isElement$1(elementOrView)) this._addElement(elementOrView);
        else if ($c7bc2cb7e2db0227$export$47b5c6ea01196dcc(elementOrView)) this._addView(elementOrView);
        else {
            if (!elementOrView.element) /**
			* The {@link module:ui/view~View} added to the {@link module:utils/focustracker~FocusTracker} does not have an
			* {@link module:ui/view~View#element}. Make sure the view is {@link module:ui/view~View#render} before adding
			* it to the focus tracker.
			*
			* @error focustracker-add-view-missing-element
			*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("focustracker-add-view-missing-element", {
                focusTracker: this,
                view: elementOrView
            });
            this._addElement(elementOrView.element);
        }
    }
    /**
	* Stops tracking focus in the specified DOM element or a {@link module:ui/view~View view instance}. See {@link #add} to learn more.
	*/ remove(elementOrView) {
        if ($c7bc2cb7e2db0227$var$isElement$1(elementOrView)) this._removeElement(elementOrView);
        else if ($c7bc2cb7e2db0227$export$47b5c6ea01196dcc(elementOrView)) this._removeView(elementOrView);
        else this._removeElement(elementOrView.element);
    }
    /**
	* Adds a DOM element to the focus tracker and starts listening to the `focus` and `blur` events on it.
	*/ _addElement(element) {
        if (this._elements.has(element)) /**
		* This element is already tracked by {@link module:utils/focustracker~FocusTracker}.
		*
		* @error focustracker-add-element-already-exist
		*/ throw new $c7bc2cb7e2db0227$export$4e727b0db6c2de10("focustracker-add-element-already-exist", this);
        this.listenTo(element, "focus", ()=>{
            const externalFocusedViewInSubtree = this.externalViews.find((view)=>$c7bc2cb7e2db0227$var$isExternalViewSubtreeFocused(element, view));
            if (externalFocusedViewInSubtree) this._focus(externalFocusedViewInSubtree.element);
            else this._focus(element);
        }, {
            useCapture: true
        });
        this.listenTo(element, "blur", ()=>{
            this._blur();
        }, {
            useCapture: true
        });
        this._elements.add(element);
    }
    /**
	* Removes a DOM element from the focus tracker.
	*/ _removeElement(element) {
        if (this._elements.has(element)) {
            this.stopListening(element);
            this._elements.delete(element);
        }
        if (element === this.focusedElement) this._blur();
    }
    /**
	* Adds an external {@link module:ui/view~View view instance} to this focus tracker and makes it contribute to this focus tracker's
	* state either by its `View#element` or by its `View#focusTracker` instance.
	*/ _addView(view) {
        if (view.element) this._addElement(view.element);
        this.listenTo(view.focusTracker, "change:focusedElement", ()=>{
            if (view.focusTracker.focusedElement) {
                if (view.element) this._focus(view.element);
            } else this._blur();
        });
        this._externalViews.add(view);
    }
    /**
	* Removes an external {@link module:ui/view~View view instance} from this focus tracker.
	*/ _removeView(view) {
        if (view.element) this._removeElement(view.element);
        this.stopListening(view.focusTracker);
        this._externalViews.delete(view);
    }
    /**
	* Destroys the focus tracker by:
	* - Disabling all event listeners attached to tracked elements or external views.
	* - Removing all tracked elements and views that were previously added.
	*/ destroy() {
        this.stopListening();
        this._elements.clear();
        this._externalViews.clear();
        this.isFocused = false;
        this.focusedElement = null;
    }
    /**
	* Stores currently focused element as {@link #focusedElement} and sets {@link #isFocused} `true`.
	*/ _focus(element) {
        this._clearBlurTimeout();
        this.focusedElement = element;
        this.isFocused = true;
    }
    /**
	* Clears currently {@link #focusedElement} and sets {@link #isFocused} `false`.
	*
	* This method uses `setTimeout()` to change order of `blur` and `focus` events calls, ensuring that moving focus between
	* two elements within a single focus tracker's scope, will not cause `[ blurA, focusB ]` sequence but just `[ focusB ]`.
	* The former would cause a momentary change of `#isFocused` to `false` which is not desired because any logic listening to
	* a focus tracker state would experience UI flashes and glitches as the user focus travels across the UI.
	*/ _blur() {
        if (this.elements.find((element)=>element.contains($c7bc2cb7e2db0227$export$cd4e5573fbe2b576(element)))) return;
        if (this.externalViews.find((view)=>{
            return view.focusTracker.isFocused && !view.focusTracker._blurTimeout;
        })) return;
        this._clearBlurTimeout();
        this._blurTimeout = setTimeout(()=>{
            this.focusedElement = null;
            this.isFocused = false;
        }, 0);
    }
    /**
	* Clears the asynchronous blur event timeout on demand. See {@link #_blur} to learn more.
	*/ _clearBlurTimeout() {
        clearTimeout(this._blurTimeout);
        this._blurTimeout = null;
    }
};
/**
* Checks whether a view is an instance of {@link ~ViewWithFocusTracker}.
*/ function $c7bc2cb7e2db0227$export$47b5c6ea01196dcc(view) {
    return "focusTracker" in view && view.focusTracker instanceof $c7bc2cb7e2db0227$export$fc044e1b74b9ba94;
}
function $c7bc2cb7e2db0227$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}
function $c7bc2cb7e2db0227$var$isExternalViewSubtreeFocused(subTreeRoot, view) {
    if ($c7bc2cb7e2db0227$var$isFocusedView(subTreeRoot, view)) return true;
    return !!view.focusTracker.externalViews.find((view)=>$c7bc2cb7e2db0227$var$isFocusedView(subTreeRoot, view));
}
function $c7bc2cb7e2db0227$var$isFocusedView(subTreeRoot, view) {
    return !!view.element && view.element.contains($c7bc2cb7e2db0227$export$cd4e5573fbe2b576(view.element)) && subTreeRoot.contains(view.element);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/keystrokehandler
*/ /**
* Keystroke handler allows registering callbacks for given keystrokes.
*
* The most frequent use of this class is through the {@link module:core/editor/editor~Editor#keystrokes `editor.keystrokes`}
* property. It allows listening to keystrokes executed in the editing view:
*
* ```ts
* editor.keystrokes.set( 'Ctrl+A', ( keyEvtData, cancel ) => {
* 	console.log( 'Ctrl+A has been pressed' );
* 	cancel();
* } );
* ```
*
* However, this utility class can be used in various part of the UI. For instance, a certain {@link module:ui/view~View}
* can use it like this:
*
* ```ts
* class MyView extends View {
* 	constructor() {
* 		this.keystrokes = new KeystrokeHandler();
*
* 		this.keystrokes.set( 'tab', handleTabKey );
* 	}
*
* 	render() {
* 		super.render();
*
* 		this.keystrokes.listenTo( this.element );
* 	}
* }
* ```
*
* That keystroke handler will listen to `keydown` events fired in this view's main element.
*
*/ var $c7bc2cb7e2db0227$export$a783915b2b108628 = class {
    /**
	* Listener used to listen to events for easier keystroke handler destruction.
	*/ _listener;
    /**
	* Creates an instance of the keystroke handler.
	*/ constructor(){
        this._listener = new ($c7bc2cb7e2db0227$export$537a1d64e9da4c8f())();
    }
    /**
	* Starts listening for `keydown` events from a given emitter.
	*/ listenTo(emitter) {
        this._listener.listenTo(emitter, "keydown", (evt, keyEvtData)=>{
            this._listener.fire("_keydown:" + $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb(keyEvtData), keyEvtData);
        });
    }
    /**
	* Registers a handler for the specified keystroke.
	*
	* @param keystroke Keystroke defined in a format accepted by
	* the {@link module:utils/keyboard~parseKeystroke} function.
	* @param callback A function called with the
	* {@link module:engine/view/observer/keyobserver~ViewDocumentKeyEventData key event data} object and
	* a helper function to call both `preventDefault()` and `stopPropagation()` on the underlying event.
	* @param options Additional options.
	*/ set(keystroke, callback, options = {}) {
        const keyCode = $c7bc2cb7e2db0227$export$970afd9da919f686(keystroke);
        const priority = options.priority;
        this._listener.listenTo(this._listener, "_keydown:" + keyCode, (evt, keyEvtData)=>{
            if (options.filter && !options.filter(keyEvtData)) return;
            callback(keyEvtData, ()=>{
                keyEvtData.preventDefault();
                keyEvtData.stopPropagation();
                evt.stop();
            });
            evt.return = true;
        }, {
            priority: priority
        });
    }
    /**
	* Triggers a keystroke handler for a specified key combination, if such a keystroke was {@link #set defined}.
	*
	* @param keyEvtData Key event data.
	* @returns Whether the keystroke was handled.
	*/ press(keyEvtData) {
        return !!this._listener.fire("_keydown:" + $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb(keyEvtData), keyEvtData);
    }
    /**
	* Stops listening to `keydown` events from the given emitter.
	*/ stopListening(emitter) {
        this._listener.stopListening(emitter);
    }
    /**
	* Destroys the keystroke handler.
	*/ destroy() {
        this.stopListening();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/objecttomap
*/ /**
* Transforms object to map.
*
* ```ts
* const map = objectToMap( { 'foo': 1, 'bar': 2 } );
* map.get( 'foo' ); // 1
* ```
*
* **Note**: For mixed data (`Object` or `Iterable`) there's a dedicated {@link module:utils/tomap~toMap} function.
*
* @param obj Object to transform.
* @returns Map created from object.
*/ function $c7bc2cb7e2db0227$export$c92708a98a4b978f(obj) {
    const map = /* @__PURE__ */ new Map();
    for(const key in obj)map.set(key, obj[key]);
    return map;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/tomap
*/ /**
* Transforms object or iterable to map. Iterable needs to be in the format acceptable by the `Map` constructor.
*
* ```ts
* map = toMap( { 'foo': 1, 'bar': 2 } );
* map = toMap( [ [ 'foo', 1 ], [ 'bar', 2 ] ] );
* map = toMap( anotherMap );
* ```
*
* @param data Object or iterable to transform.
* @returns Map created from data.
*/ function $c7bc2cb7e2db0227$export$e98af36a72b77685(data) {
    if ($c7bc2cb7e2db0227$export$9652023d9040757(data)) return new Map(data);
    else return $c7bc2cb7e2db0227$export$c92708a98a4b978f(data);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/mapsequal
*/ /**
* Checks whether given `Map`s are equal, that is has same size and same key-value pairs.
*
* @param mapA The first map to compare.
* @param mapB The second map to compare.
* @returns `true` if given maps are equal, `false` otherwise.
*/ function $c7bc2cb7e2db0227$export$4cdc343ee673ac08(mapA, mapB) {
    if (mapA.size != mapB.size) return false;
    for (const attr of mapA.entries())if (JSON.stringify(attr[1]) !== JSON.stringify(mapB.get(attr[0]))) return false;
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/wait
*/ /**
* Returns a promise that is resolved after the specified time.
*
* @param timeout The time in milliseconds to wait.
* @param options.signal A signal to abort the waiting.
*/ function $c7bc2cb7e2db0227$export$5c069c93d2b7493f(timeout, options = {}) {
    return new Promise((resolve, reject)=>{
        const signal = options.signal || new AbortController().signal;
        signal.throwIfAborted();
        const timer = setTimeout(timeoutHandler, timeout);
        signal.addEventListener("abort", abortHandler, {
            once: true
        });
        function timeoutHandler() {
            signal.removeEventListener("abort", abortHandler);
            resolve();
        }
        function abortHandler() {
            clearTimeout(timer);
            reject(signal.reason);
        }
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/retry
*/ /**
* Tries calling the given callback until it sucessfully resolves.
*
* If the callback fails `maxAttempts` times, the returned promise is rejected with the last error.
*
* @typeParam TResult The result of a successful callback invocation.
* @param callback The function to call until it succeeds.
* @param options Configuration options.
* @param options.maxAttempts Maximum number of attempts.
* @param options.retryDelay The time in milliseconds between attempts. By default it implements exponential back-off policy.
* @param options.signal The signal to abort further retries. The callback itself is not aborted automatically.
*/ async function $c7bc2cb7e2db0227$export$9369b12211e1fce4(callback, options = {}) {
    const { maxAttempts: maxAttempts = 4, retryDelay: retryDelay = $c7bc2cb7e2db0227$export$ce2bf54576c66713(), signal: signal = new AbortController().signal } = options;
    signal.throwIfAborted();
    for(let attempt = 0;; attempt++){
        try {
            return await callback();
        } catch (err) {
            if (attempt + 1 >= maxAttempts) throw err;
        }
        await $c7bc2cb7e2db0227$export$5c069c93d2b7493f(retryDelay(attempt), {
            signal: signal
        });
    }
}
/**
* Creates a function that calculates exponential back-off delay. Pass it as `options.retryDelay` to {@link ~retry}.
*
* @param options.delay Base delay between invocations. Defaults to 1s.
* @param options.factor How much to increase the delay. Defaults to 2x.
* @param options.maxDelay Maximum timeout. Even if higher timeout is calculated, it cannot get higher than this value. Default to 10s.
* @returns The function calculating the delay.
*/ function $c7bc2cb7e2db0227$export$ce2bf54576c66713(options = {}) {
    const { delay: delay = 1e3, factor: factor = 2, maxDelay: maxDelay = 1e4 } = options;
    return (attempt)=>Math.min(factor ** attempt * delay, maxDelay);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/splicearray
*/ /**
* Splices one array into another. To be used instead of `Array.prototype.splice` for better
* performance and because the latter may throw "Maximum call stack size exceeded" error when
* passing huge number of items to insert.
*
* ```ts
* spliceArray( [ 1, 2 ], [ 3, 4 ], 0 );	// [ 3, 4, 1, 2 ]
* spliceArray( [ 1, 2 ], [ 3, 4 ], 1 );	// [ 1, 3, 4, 2 ]
* spliceArray( [ 1, 2 ], [ 3, 4 ], 2 );	// [ 1, 2, 3, 4 ]
* spliceArray( [ 1, 2 ], [],       0 );	// [ 1, 2 ]
* ```
*
* @param targetArray Array to be spliced.
* @param insertArray Array of elements to be inserted to target.
* @param index Index at which nodes should be inserted.
*
* @returns New spliced array.
*/ function $c7bc2cb7e2db0227$export$a4bf84605575402a(targetArray, insertArray, index) {
    const originalLength = targetArray.length;
    const insertLength = insertArray.length;
    for(let i = originalLength - 1; i >= index; i--)targetArray[i + insertLength] = targetArray[i];
    for(let i = 0; i < insertLength; i++)targetArray[index + i] = insertArray[i];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/delay
*/ /**
* Returns a function wrapper that will trigger a function after a specified wait time.
* The timeout can be canceled by calling the cancel function on the returned wrapped function.
*
* @param func The function to wrap.
* @param wait The timeout in ms.
*/ function $c7bc2cb7e2db0227$export$1391212d75b2ee65(func, wait) {
    let timer;
    function delayed(...args) {
        delayed.cancel();
        timer = setTimeout(()=>func(...args), wait);
    }
    delayed.cancel = ()=>{
        clearTimeout(timer);
    };
    return delayed;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/parsebase64encodedobject
*/ /**
* Parses a base64-encoded object and returns the decoded object, or null if the decoding was unsuccessful.
*/ function $c7bc2cb7e2db0227$export$6d464faaef141d67(encoded) {
    try {
        if (!encoded.startsWith("ey")) return null;
        const decoded = atob(encoded.replace(/-/g, "+").replace(/_/g, "/"));
        return JSON.parse(decoded);
    } catch  {
        return null;
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/crc32
*/ /**
* Generates a CRC lookup table.
* This function creates and returns a 256-element array of pre-computed CRC values for quick CRC calculation.
* It uses the polynomial 0xEDB88320 to compute each value in the loop, optimizing future CRC calculations.
*/ function $c7bc2cb7e2db0227$var$makeCrcTable() {
    const crcTable = [];
    for(let n = 0; n < 256; n++){
        let c = n;
        for(let k = 0; k < 8; k++)if (c & 1) c = 3988292384 ^ c >>> 1;
        else c = c >>> 1;
        crcTable[n] = c;
    }
    return crcTable;
}
/**
* Calculates CRC-32 checksum for a given inputData to verify the integrity of data.
*
* @param inputData Accepts a single value (string, number, boolean), an array of strings, or an array of all of the above types.
* Non-string values are converted to strings before calculating the checksum.
* The checksum calculation is based on the concatenated string representation of the input values:
* * `crc32('foo')` is equivalent to `crc32(['foo'])`
* * `crc32(123)` is equivalent to `crc32(['123'])`
* * `crc32(true)` is equivalent to `crc32(['true'])`
* * `crc32(['foo', 123, true])` produces the same result as `crc32('foo123true')`
* * Nested arrays of strings are flattened, so `crc32([['foo', 'bar'], 'baz'])` is equivalent to `crc32(['foobar', 'baz'])`
*
* @returns The CRC-32 checksum, returned as a hexadecimal string.
*/ function $c7bc2cb7e2db0227$export$1cd93882633e45f5(inputData) {
    const dataArray = Array.isArray(inputData) ? inputData : [
        inputData
    ];
    const crcTable = $c7bc2cb7e2db0227$var$makeCrcTable();
    let crc = -1;
    const dataString = dataArray.map((item)=>{
        if (Array.isArray(item)) return item.join("");
        return String(item);
    }).join("");
    for(let i = 0; i < dataString.length; i++){
        const byte = dataString.charCodeAt(i);
        crc = crc >>> 8 ^ crcTable[(crc ^ byte) & 255];
    }
    crc = (crc ^ -1) >>> 0;
    return crc.toString(16).padStart(8, "0");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/collectstylesheets
*/ /**
* A helper function for getting concatenated CSS rules from external stylesheets.
*
* @param stylesheets An array of stylesheet paths delivered by the user through the plugin configuration.
*/ async function $c7bc2cb7e2db0227$export$5120f97bff591865(stylesheets) {
    if (!stylesheets) return "";
    return (await Promise.all(stylesheets.map(async (stylesheet)=>{
        if (stylesheet === "EDITOR_STYLES") return $c7bc2cb7e2db0227$var$getEditorStyles();
        return (await window.fetch(stylesheet)).text();
    }))).join(" ").trim();
}
/**
* A helper function for getting the basic editor content styles for the `.ck-content` class
* and all CSS variables defined in the document.
*/ function $c7bc2cb7e2db0227$var$getEditorStyles() {
    const editorStyles = [];
    const editorCSSVariables = [];
    for (const styleSheet of Array.from(document.styleSheets))if (styleSheet.ownerNode.hasAttribute("data-cke")) {
        for (const rule of Array.from(styleSheet.cssRules))if (rule.cssText.indexOf(".ck-content") !== -1) editorStyles.push(rule.cssText);
        else if (rule.cssText.indexOf(":root") !== -1) editorCSSVariables.push(rule.cssText);
    }
    if (!editorStyles.length) console.warn("The editor stylesheet could not be found in the document. Check your webpack config - style-loader should use data-cke=true attribute for the editor stylesheet.");
    return [
        ...editorCSSVariables,
        ...editorStyles
    ].join(" ").trim();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/formathtml
*/ /**
* A simple (and naive) HTML code formatter that returns a formatted HTML markup that can be easily
* parsed by human eyes. It beautifies the HTML code by adding new lines between elements that behave like block elements
* (https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
* and a few more like `tr`, `td`, and similar ones) and inserting indents for nested content.
*
* WARNING: This function works only on a text that does not contain any indentations or new lines.
* Calling this function on the already formatted text will damage the formatting.
*
* @param input An HTML string to format.
*/ function $c7bc2cb7e2db0227$export$3a8092d2fb888271(input) {
    const elementsToFormat = [
        {
            name: "address",
            isVoid: false
        },
        {
            name: "article",
            isVoid: false
        },
        {
            name: "aside",
            isVoid: false
        },
        {
            name: "blockquote",
            isVoid: false
        },
        {
            name: "details",
            isVoid: false
        },
        {
            name: "dialog",
            isVoid: false
        },
        {
            name: "dd",
            isVoid: false
        },
        {
            name: "div",
            isVoid: false
        },
        {
            name: "dl",
            isVoid: false
        },
        {
            name: "dt",
            isVoid: false
        },
        {
            name: "fieldset",
            isVoid: false
        },
        {
            name: "figcaption",
            isVoid: false
        },
        {
            name: "figure",
            isVoid: false
        },
        {
            name: "footer",
            isVoid: false
        },
        {
            name: "form",
            isVoid: false
        },
        {
            name: "h1",
            isVoid: false
        },
        {
            name: "h2",
            isVoid: false
        },
        {
            name: "h3",
            isVoid: false
        },
        {
            name: "h4",
            isVoid: false
        },
        {
            name: "h5",
            isVoid: false
        },
        {
            name: "h6",
            isVoid: false
        },
        {
            name: "header",
            isVoid: false
        },
        {
            name: "hgroup",
            isVoid: false
        },
        {
            name: "hr",
            isVoid: true
        },
        {
            name: "li",
            isVoid: false
        },
        {
            name: "main",
            isVoid: false
        },
        {
            name: "nav",
            isVoid: false
        },
        {
            name: "ol",
            isVoid: false
        },
        {
            name: "p",
            isVoid: false
        },
        {
            name: "section",
            isVoid: false
        },
        {
            name: "table",
            isVoid: false
        },
        {
            name: "tbody",
            isVoid: false
        },
        {
            name: "td",
            isVoid: false
        },
        {
            name: "th",
            isVoid: false
        },
        {
            name: "thead",
            isVoid: false
        },
        {
            name: "tfoot",
            isVoid: false
        },
        {
            name: "tr",
            isVoid: false
        },
        {
            name: "ul",
            isVoid: false
        }
    ];
    const elementNamesToFormat = elementsToFormat.map((element)=>element.name).join("|");
    const lines = input.replace(new RegExp(`</?(${elementNamesToFormat})( .*?)?>`, "g"), "\n$&\n").replace(/<br[^>]*>/g, "$&\n").split("\n");
    let indentCount = 0;
    let isPreformattedLine = false;
    return lines.map((line)=>{
        isPreformattedLine = $c7bc2cb7e2db0227$var$isPreformattedBlockLine(line, isPreformattedLine);
        if (!line.length && !isPreformattedLine) return "";
        if ($c7bc2cb7e2db0227$var$isNonVoidOpeningTag(line, elementsToFormat)) return $c7bc2cb7e2db0227$var$indentLine(line, indentCount++);
        if ($c7bc2cb7e2db0227$var$isClosingTag(line, elementsToFormat)) return $c7bc2cb7e2db0227$var$indentLine(line, --indentCount);
        if (isPreformattedLine === "middle" || isPreformattedLine === "last") return $c7bc2cb7e2db0227$var$indentLine(line, 0);
        return $c7bc2cb7e2db0227$var$indentLine(line, indentCount);
    }).join("").trimEnd();
}
/**
* Checks, if an argument is an opening tag of a non-void element to be formatted.
*
* @param line String to check.
* @param elementsToFormat Elements to be formatted.
*/ function $c7bc2cb7e2db0227$var$isNonVoidOpeningTag(line, elementsToFormat) {
    return elementsToFormat.some((element)=>{
        if (element.isVoid) return false;
        if (!new RegExp(`<${element.name}( .*?)?>`).test(line)) return false;
        return true;
    });
}
/**
* Checks, if an argument is a closing tag.
*
* @param line String to check.
* @param elementsToFormat Elements to be formatted.
*/ function $c7bc2cb7e2db0227$var$isClosingTag(line, elementsToFormat) {
    return elementsToFormat.some((element)=>{
        return new RegExp(`</${element.name}>`).test(line);
    });
}
/**
* Indents a line by a specified number of characters.
*
* @param line Line to indent.
* @param indentCount Number of characters to use for indentation.
* @param indentChar Indentation character(s). 4 spaces by default.
*/ function $c7bc2cb7e2db0227$var$indentLine(line, indentCount, indentChar = "    ") {
    return `${indentChar.repeat(Math.max(0, indentCount))}${line}\n`;
}
/**
* Checks whether a line belongs to a preformatted (`<pre>`) block.
*
* @param line Line to check.
* @param isPreviousLinePreFormatted Information on whether the previous line was preformatted (and how).
*/ function $c7bc2cb7e2db0227$var$isPreformattedBlockLine(line, isPreviousLinePreFormatted) {
    const isPreOpen = /<pre( .*?)?>/.test(line);
    const isPreClose = /<\/pre>/.test(line);
    if (isPreOpen && isPreClose) return false;
    else if (isPreOpen) return "first";
    else if (isPreClose) return "last";
    else if (isPreviousLinePreFormatted === "first" || isPreviousLinePreFormatted === "middle") return "middle";
    else return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Set of utils to handle unicode characters.
*
* @module utils/unicode
*/ /**
* Checks whether given `character` is a combining mark.
*
* @param character Character to check.
*/ function $c7bc2cb7e2db0227$export$e445153e3d76bc65(character) {
    return !!character && character.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(character);
}
/**
* Checks whether given `character` is a high half of surrogate pair.
*
* Using UTF-16 terminology, a surrogate pair denotes UTF-16 character using two UTF-8 characters. The surrogate pair
* consist of high surrogate pair character followed by low surrogate pair character.
*
* @param character Character to check.
*/ function $c7bc2cb7e2db0227$export$eb99624bce16f43a(character) {
    return !!character && character.length == 1 && /[\ud800-\udbff]/.test(character);
}
/**
* Checks whether given `character` is a low half of surrogate pair.
*
* Using UTF-16 terminology, a surrogate pair denotes UTF-16 character using two UTF-8 characters. The surrogate pair
* consist of high surrogate pair character followed by low surrogate pair character.
*
* @param character Character to check.
*/ function $c7bc2cb7e2db0227$export$94e72cbdad2f0f98(character) {
    return !!character && character.length == 1 && /[\udc00-\udfff]/.test(character);
}
/**
* Checks whether given offset in a string is inside a surrogate pair (between two surrogate halves).
*
* @param string String to check.
* @param offset Offset to check.
*/ function $c7bc2cb7e2db0227$export$910da4ddfe197244(string, offset) {
    return $c7bc2cb7e2db0227$export$eb99624bce16f43a(string.charAt(offset - 1)) && $c7bc2cb7e2db0227$export$94e72cbdad2f0f98(string.charAt(offset));
}
/**
* Checks whether given offset in a string is between base character and combining mark or between two combining marks.
*
* @param string String to check.
* @param offset Offset to check.
*/ function $c7bc2cb7e2db0227$export$1a90459935e74227(string, offset) {
    return $c7bc2cb7e2db0227$export$e445153e3d76bc65(string.charAt(offset));
}
const $c7bc2cb7e2db0227$var$EMOJI_PATTERN = /* #__PURE__ */ $c7bc2cb7e2db0227$var$buildEmojiRegexp();
/**
* Checks whether given offset in a string is inside multi-character emoji sequence.
*
* @param string String to check.
* @param offset Offset to check.
*/ function $c7bc2cb7e2db0227$export$615ed2a6f3bf1115(string, offset) {
    const matches = String(string).matchAll($c7bc2cb7e2db0227$var$EMOJI_PATTERN);
    return Array.from(matches).some((match)=>match.index < offset && offset < match.index + match[0].length);
}
function $c7bc2cb7e2db0227$var$buildEmojiRegexp() {
    const parts = [
        /\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u,
        /\p{Emoji}\u{FE0F}?\u{20E3}/u,
        /\p{Emoji}\u{FE0F}/u,
        /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u
    ];
    const flagSequence = /\p{Regional_Indicator}{2}/u.source;
    const emoji = "(?:" + parts.map((part)=>part.source).join("|") + ")";
    const sequence = `${flagSequence}|${emoji}(?:\u{200D}${emoji})*`;
    return new RegExp(sequence, "ug");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/decodelicensekey
*/ /**
* Parses the provided license key and returns the decoded object, or null if the decoding was unsuccessful.
*
* @param licenseKey The license key to decode.
*/ function $c7bc2cb7e2db0227$export$9cbd9a924c44d1b7(licenseKey) {
    if (!licenseKey) return null;
    const encodedPayload = $c7bc2cb7e2db0227$var$getLicenseKeyPayload(licenseKey);
    if (!encodedPayload) return null;
    return $c7bc2cb7e2db0227$export$6d464faaef141d67(encodedPayload);
}
function $c7bc2cb7e2db0227$var$getLicenseKeyPayload(licenseKey) {
    const parts = licenseKey.split(".");
    if (parts.length != 3) return null;
    return parts[1];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/isfeatureblockedbylicensekey
*/ /**
* Checks whether a feature (represented by an unique id) is blocked by the provided license key.
*
* @param licensePayload Decoded license key.
* @param licenseFeatureCode An unique feature id to check.
*/ function $c7bc2cb7e2db0227$export$817c47d6329f7631(licensePayload, licenseFeatureCode) {
    return (licensePayload.removeFeatures || []).includes(licenseFeatureCode);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module utils/parsedimensionwithunit
*/ /**
* Parses provided string with dimension value and returns extracted numeric value and unit.
*
* 	* If non-string dimension is passed then `null` value is returned.
* 	* If unit is missing then `null` is returned.
* 	* If numeric value part of string is not a number then `null` is returned.
*
* Example:
* 	`"222px"` => `{ value: 222, unit: "px" }`
*	`"99%"` => `{ value: 99, unit: "%" }`

* @param dimension Unsafe string with dimension.
* @returns Parsed dimension with extracted numeric value and units.
* @internal
*/ function $c7bc2cb7e2db0227$export$75edd0f9cff526b0(dimension) {
    if (!dimension) return null;
    const [, rawValue, unit] = dimension.trim().match(/([.,\d]+)(%|px)$/) || [];
    const parsedValue = Number.parseFloat(rawValue);
    if (Number.isNaN(parsedValue)) return null;
    return {
        value: parsedValue,
        unit: unit
    };
}
/**
* Converts dimension between `px` -> `%` and `%` -> `px`.
*
* @param parentDimensionPx	Dimension of parent element that contains measured element.
* @param dimension Measured element dimension.
* @param targetUnit Target unit for conversion.
* @returns Casted dimension.
* @internal
*/ function $c7bc2cb7e2db0227$export$5fa337c2fe4d899a(parentDimensionPx, dimension, targetUnit) {
    if (targetUnit === "px") return {
        value: dimension.value,
        unit: "px"
    };
    return {
        value: dimension.value / parentDimensionPx * 100,
        unit: "%"
    };
}



//#region src/compat/_internal/isDeepKey.ts
/** Matches any deep property path. Examples: `a.b`, `a[0]`, `a["b"]` */ const $671e243dbeff607e$var$regexIsDeepProp = /\.|(\[(?:[^[\]]*|(["'])(?:(?!\2)[^\\]|\\.)*?\2)\])/;
/**
* Checks if a given key is a deep key.
*
* A deep key is a string that contains a dot (.) or square brackets with a property accessor.
*
* @param {PropertyKey} key - The key to check.
* @returns {boolean} - Returns true if the key is a deep key, otherwise false.
*
* Examples:
*
* isDeepKey('a.b') // true
* isDeepKey('a[b]') // true
* isDeepKey('a') // false
* isDeepKey(123) // false
* isDeepKey('a.b.c') // true
* isDeepKey('a[b][c]') // true
* isDeepKey('a.') // false
* isDeepKey('.a') // false
* isDeepKey('a[b') // false
* isDeepKey('a]b]') // false
* isDeepKey('a][b') // false
* isDeepKey('') // false
* isDeepKey('a[0]') // true
*
*/ function $671e243dbeff607e$export$88ed3a5a87f128f0(key) {
    switch(typeof key){
        case "number":
        case "symbol":
            return false;
        case "string":
            if (key === "" || key.startsWith(".") || key.endsWith(".")) return false;
            return $671e243dbeff607e$var$regexIsDeepProp.test(key);
        default:
            return false;
    }
}


//#region src/compat/_internal/toKey.ts
/**
* Converts `value` to a string key if it's not a string or symbol.
*
* @private
* @param {unknown} value The value to inspect.
* @returns {string|symbol} Returns the key.
*/ function $60c0e84f71bed535$export$c0d0115e766e14c3(value) {
    if (typeof value === "string" || typeof value === "symbol") return value;
    if (Object.is(value?.valueOf?.(), -0)) return "-0";
    return String(value);
}



//#region src/compat/predicate/isSymbol.ts
/**
* Check whether a value is a symbol.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `symbol`.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a symbol, else `false`.
* @example
* isSymbol(Symbol.iterator);
* // => true
*
* isSymbol('abc');
* // => false
*/ function $3234d99707a4bfd4$export$a244864fd9645c7f(value) {
    return typeof value === "symbol" || value instanceof Symbol;
}


//#region src/compat/util/toString.ts
/**
* Converts `value` to a string.
*
* An empty string is returned for `null` and `undefined` values.
* The sign of `-0` is preserved.
*
* @param value - The value to convert.
* @returns Returns the converted string.
*
* @example
* toString(null) // returns ''
* toString(undefined) // returns ''
* toString(-0) // returns '-0'
* toString([1, 2, -0]) // returns '1,2,-0'
* toString([Symbol('a'), Symbol('b')]) // returns 'Symbol(a),Symbol(b)'
*/ function $a4d3c4fa68340755$export$f84e8e69fd4488a5(value) {
    if (value == null) return "";
    return $a4d3c4fa68340755$var$baseToString(value);
}
function $a4d3c4fa68340755$var$baseToString(value) {
    if (typeof value === "string") return value;
    if (Array.isArray(value)) return value.map($a4d3c4fa68340755$var$baseToString).join(",");
    if ((0, $3234d99707a4bfd4$export$a244864fd9645c7f)(value)) return value.toString();
    const result = value + "";
    if (result === "0" && Object.is(Number(value), -0)) return "-0";
    return result;
}


//#region src/compat/util/toPath.ts
/**
* Converts a deep key string into an array of path segments.
*
* This function takes a string representing a deep key (e.g., 'a.b.c' or 'a[b][c]') and breaks it down into an array of strings, each representing a segment of the path.
*
* @param deepKey - The deep key string to convert.
* @returns An array of strings, each representing a segment of the path.
*
* Examples:
*
* toPath('a.b.c') // Returns ['a', 'b', 'c']
* toPath('a[b][c]') // Returns ['a', 'b', 'c']
* toPath('.a.b.c') // Returns ['', 'a', 'b', 'c']
* toPath('a["b.c"].d') // Returns ['a', 'b.c', 'd']
* toPath('') // Returns []
* toPath('.a[b].c.d[e]["f.g"].h') // Returns ['', 'a', 'b', 'c', 'd', 'e', 'f.g', 'h']
*/ function $18fb98e16e6d1601$export$440836a238ff8548(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map((0, $60c0e84f71bed535$export$c0d0115e766e14c3));
    if (typeof deepKey === "symbol") return [
        deepKey
    ];
    deepKey = (0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = "";
    let quoteChar = "";
    let bracket = false;
    let bracketHadQuote = false;
    const bracketNumberRegex = /^-?\d+(?:\.\d+)?$/;
    if (deepKey.charCodeAt(0) === 46) result.push("");
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === "\\" && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = "";
            else key += char;
        } else if (bracket) {
            if (char === "\"" || char === "'") {
                quoteChar = char;
                bracketHadQuote = true;
            } else if (char === "]") {
                bracket = false;
                if (!bracketHadQuote && key.includes(".") && !bracketNumberRegex.test(key)) {
                    const segments = key.split(".");
                    for(let i = 0; i < segments.length; i++)if (segments[i] !== "") result.push(segments[i]);
                } else result.push(key);
                key = "";
            } else key += char;
        } else if (char === "[") {
            bracket = true;
            bracketHadQuote = false;
            if (key) {
                result.push(key);
                key = "";
            }
        } else if (char === ".") {
            if (key) {
                result.push(key);
                key = "";
            }
            const next = deepKey[index + 1];
            if (next === void 0 || next === ".") result.push("");
        } else key += char;
        index++;
    }
    if (key) result.push(key);
    return result;
}


//#region src/compat/object/get.ts
/**
* Retrieves the value at a given path from an object. If the resolved value is undefined, the defaultValue is returned instead.
*
* @param object - The object to query.
* @param path - The path of the property to get.
* @param [defaultValue] - The value returned if the resolved value is undefined.
* @returns Returns the resolved value.
*
* @example
* const object = { a: { b: { c: 1 } } };
* get(object, 'a.b.c');
* // => 1
*
* get(object, ['a', 'b', 'c']);
* // => 1
*
* get(object, 'a.b.d', 'default');
* // => 'default'
*/ function $380d1989ac14ff6b$export$3988ae62b71be9a3(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case "string":
            {
                if ((0, $d0b6ac487e334212$export$1511747d5f3dab08)(path)) return defaultValue;
                const result = object[path];
                if (result === void 0) {
                    if ((0, $671e243dbeff607e$export$88ed3a5a87f128f0)(path) && !Object.hasOwn(object, path)) return $380d1989ac14ff6b$export$3988ae62b71be9a3(object, (0, $18fb98e16e6d1601$export$440836a238ff8548)(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case "number":
        case "symbol":
            {
                if (typeof path === "number") path = (0, $60c0e84f71bed535$export$c0d0115e766e14c3)(path);
                const result = object[path];
                if (result === void 0) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $380d1989ac14ff6b$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = "-0";
                else path = String(path);
                if ((0, $d0b6ac487e334212$export$1511747d5f3dab08)(path)) return defaultValue;
                const result = object[path];
                if (result === void 0) return defaultValue;
                return result;
            }
    }
}
function $380d1989ac14ff6b$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ((0, $d0b6ac487e334212$export$1511747d5f3dab08)(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === void 0) return defaultValue;
    return current;
}





//#region src/compat/_internal/isIndex.ts
const $821a38fbe0a02313$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $821a38fbe0a02313$export$ba3dc792055c2f45(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case "number":
            return Number.isInteger(value) && value >= 0 && value < length;
        case "symbol":
            return false;
        case "string":
            return $821a38fbe0a02313$var$IS_UNSIGNED_INTEGER.test(value);
    }
}



//#region src/compat/_internal/isKey.ts
/**  Matches any deep property path. (e.g. `a.b[0].c`)*/ const $be91d3a0be252c7c$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
/**  Matches any word character (alphanumeric & underscore).*/ const $be91d3a0be252c7c$var$regexIsPlainProp = /^\w*$/;
/**
* Checks if `value` is a property name and not a property path. (It's ok that the `value` is not in the keys of the `object`)
* @param {unknown} value The value to check.
* @param {unknown} object The object to query.
* @returns {boolean} Returns `true` if `value` is a property name, else `false`.
*
* @example
* isKey('a', { a: 1 });
* // => true
*
* isKey('a.b', { a: { b: 2 } });
* // => false
*/ function $be91d3a0be252c7c$export$863054953f77118(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === "number" || typeof value === "boolean" || value == null || (0, $3234d99707a4bfd4$export$a244864fd9645c7f)(value)) return true;
    return typeof value === "string" && ($be91d3a0be252c7c$var$regexIsPlainProp.test(value) || !$be91d3a0be252c7c$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}


//#region src/compat/util/eq.ts
/**
* Performs a `SameValueZero` comparison between two values to determine if they are equivalent.
*
* @param value The value to compare.
* @param other The other value to compare.
* @returns Returns `true` if the values are equivalent, else `false`.
*
* @example
* eq(1, 1); // true
* eq(0, -0); // true
* eq(NaN, NaN); // true
* eq('a', Object('a')); // false
*/ function $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}


//#region src/compat/_internal/assignValue.ts
const $5e7f6cdd805ed7f6$export$f7dfb98a7d7122d0 = (object, key, value)=>{
    const objValue = object[key];
    if (!(Object.hasOwn(object, key) && (0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(objValue, value)) || value === void 0 && !(key in object)) object[key] = value;
};


//#region src/_internal/isUnsafeToWriteProperty.ts
/**
* Checks if a property key is unsafe to write to.
*
* Writing through `__proto__`, `constructor`, or `prototype` can reach
* `Object.prototype` and pollute every object, so write paths like `set`,
* `update`, and `zipObjectDeep` abort when a path segment matches one of
* these keys, matching lodash's behavior.
*
* Read paths like `get` and `unset` use `isUnsafeProperty` instead, which
* only blocks `__proto__`; lodash keeps reads of `constructor` and
* `prototype` unrestricted.
*
* @param key - The property key to check
* @returns `true` if the property is unsafe to write to, `false` otherwise
* @internal
*/ function $f6761462742667bc$export$3fea7c29781037a5(key) {
    return key === "__proto__" || key === "constructor" || key === "prototype";
}


//#region src/compat/object/updateWith.ts
/**
* Updates the value at the specified path of the given object using an updater function and a customizer.
* If any part of the path does not exist, it will be created.
*
* @template T - The type of the object.
* @template R - The type of the return value.
* @param obj - The object to modify.
* @param path - The path of the property to update.
* @param updater - The function to produce the updated value.
* @param customizer - The function to customize the update process.
* @returns The modified object.
*
* @example
* const object = { 'a': [{ 'b': { 'c': 3 } }] };
* updateWith(object, 'a[0].b.c', (n) => n * n);
* // => { 'a': [{ 'b': { 'c': 9 } }] }
*/ function $74a1bffa403bb0dd$export$dd416e3f1b2ceb5e(obj, path, updater, customizer) {
    if (obj == null && !(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(obj)) return obj;
    let resolvedPath;
    if ((0, $be91d3a0be252c7c$export$863054953f77118)(path, obj)) resolvedPath = [
        path
    ];
    else if (Array.isArray(path)) resolvedPath = path;
    else resolvedPath = (0, $18fb98e16e6d1601$export$440836a238ff8548)(path);
    const updateValue = updater((0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(obj, resolvedPath));
    let current = obj;
    for(let i = 0; i < resolvedPath.length && current != null; i++){
        const key = (0, $60c0e84f71bed535$export$c0d0115e766e14c3)(resolvedPath[i]);
        if ((0, $f6761462742667bc$export$3fea7c29781037a5)(key)) return obj;
        let newValue;
        if (i === resolvedPath.length - 1) newValue = updateValue;
        else {
            const objValue = current[key];
            const customizerResult = customizer?.(objValue, key, obj);
            newValue = customizerResult !== void 0 ? customizerResult : (0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(objValue) ? objValue : (0, $821a38fbe0a02313$export$ba3dc792055c2f45)(resolvedPath[i + 1]) ? [] : {};
        }
        (0, $5e7f6cdd805ed7f6$export$f7dfb98a7d7122d0)(current, key, newValue);
        current = current[key];
    }
    return obj;
}


//#region src/compat/object/set.ts
/**
* Sets the value at the specified path of the given object. If any part of the path does not exist, it will be created.
*
* @template T - The type of the object.
* @param obj - The object to modify.
* @param path - The path of the property to set.
* @param value - The value to set.
* @returns The modified object.
*
* @example
* // Set a value in a nested object
* const obj = { a: { b: { c: 3 } } };
* set(obj, 'a.b.c', 4);
* console.log(obj.a.b.c); // 4
*
* @example
* // Set a value in an array
* const arr = [1, 2, 3];
* set(arr, 1, 4);
* console.log(arr[1]); // 4
*
* @example
* // Create non-existent path and set value
* const obj = {};
* set(obj, 'a.b.c', 4);
* console.log(obj); // { a: { b: { c: 4 } } }
*/ function $56bb5d9ef9e7bd30$export$adaa4cf7ef1b65be(obj, path, value) {
    return (0, $74a1bffa403bb0dd$export$dd416e3f1b2ceb5e)(obj, path, ()=>value, ()=>void 0);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



//#region src/compat/predicate/isArray.ts
/**
* Checks if the given value is an array.
*
* This function tests whether the provided value is an array or not.
* It returns `true` if the value is an array, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an array.
*
* @param value - The value to test if it is an array.
* @returns `true` if the value is an array, `false` otherwise.
*
* @example
* const value1 = [1, 2, 3];
* const value2 = 'abc';
* const value3 = () => {};
*
* console.log(isArray(value1)); // true
* console.log(isArray(value2)); // false
* console.log(isArray(value3)); // false
*/ function $f5a1104e4a255d4f$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}



//#region src/compat/object/clone.ts
/**
* Creates a shallow clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A shallow clone of the given object.
*
* @example
* // Clone a primitive object
* const num = 29;
* const clonedNum = clone(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = clone(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = clone(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*/ function $e248d0fa19ac08a2$export$9cd59f9826255e47(obj) {
    if ((0, $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c)(obj)) return obj;
    const tag = (0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(obj);
    if (!$e248d0fa19ac08a2$var$isCloneableObject(obj)) return {};
    if ((0, $f5a1104e4a255d4f$export$43bee75e5e14138e)(obj)) {
        const result = Array.from(obj);
        if (obj.length > 0 && typeof obj[0] === "string" && Object.hasOwn(obj, "index")) {
            result.index = obj.index;
            result.input = obj.input;
        }
        return result;
    }
    if ((0, $4333556256d3d0c3$export$b119cc7e1840e59c)(obj)) {
        const typedArray = obj;
        const Ctor = typedArray.constructor;
        return new Ctor(typedArray.buffer, typedArray.byteOffset, typedArray.length);
    }
    if (tag === "[object ArrayBuffer]") return new ArrayBuffer(obj.byteLength);
    if (tag === "[object DataView]") {
        const dataView = obj;
        const buffer = dataView.buffer;
        const byteOffset = dataView.byteOffset;
        const byteLength = dataView.byteLength;
        const clonedBuffer = new ArrayBuffer(byteLength);
        const srcView = new Uint8Array(buffer, byteOffset, byteLength);
        new Uint8Array(clonedBuffer).set(srcView);
        return new DataView(clonedBuffer);
    }
    if (tag === "[object Boolean]" || tag === "[object Number]" || tag === "[object String]") {
        const Ctor = obj.constructor;
        const clone = new Ctor(obj.valueOf());
        if (tag === "[object String]") $e248d0fa19ac08a2$var$cloneStringObjectProperties(clone, obj);
        else $e248d0fa19ac08a2$var$copyOwnProperties(clone, obj);
        return clone;
    }
    if (tag === "[object Date]") return new Date(Number(obj));
    if (tag === "[object RegExp]") {
        const regExp = obj;
        const clone = new RegExp(regExp.source, regExp.flags);
        clone.lastIndex = regExp.lastIndex;
        return clone;
    }
    if (tag === "[object Symbol]") return Object(Symbol.prototype.valueOf.call(obj));
    if (tag === "[object Map]") {
        const map = obj;
        const result = /* @__PURE__ */ new Map();
        map.forEach((obj, key)=>{
            result.set(key, obj);
        });
        return result;
    }
    if (tag === "[object Set]") {
        const set = obj;
        const result = /* @__PURE__ */ new Set();
        set.forEach((obj)=>{
            result.add(obj);
        });
        return result;
    }
    if (tag === "[object Arguments]") {
        const args = obj;
        const result = {};
        $e248d0fa19ac08a2$var$copyOwnProperties(result, args);
        result.length = args.length;
        result[Symbol.iterator] = args[Symbol.iterator];
        return result;
    }
    const result = {};
    $e248d0fa19ac08a2$var$copyPrototype(result, obj);
    $e248d0fa19ac08a2$var$copyOwnProperties(result, obj);
    $e248d0fa19ac08a2$var$copySymbolProperties(result, obj);
    return result;
}
function $e248d0fa19ac08a2$var$isCloneableObject(object) {
    switch((0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(object)){
        case 0, $2dd302fafaba5cec$export$5893fc07141a22f5:
        case 0, $2dd302fafaba5cec$export$30c5ab3238b83eeb:
        case 0, $2dd302fafaba5cec$export$2e30fbc9f2b7b0ee:
        case 0, $2dd302fafaba5cec$export$da14abe8375f47ee:
        case 0, $2dd302fafaba5cec$export$9edaefd43909686f:
        case 0, $2dd302fafaba5cec$export$6db2fef2b8581597:
        case 0, $2dd302fafaba5cec$export$6acb72c43d6c58de:
        case 0, $2dd302fafaba5cec$export$64993ccc604584f0:
        case 0, $2dd302fafaba5cec$export$91c7bbbd3303f2e7:
        case 0, $2dd302fafaba5cec$export$72d152e068382569:
        case 0, $2dd302fafaba5cec$export$222c6a8899454b8e:
        case 0, $2dd302fafaba5cec$export$75d37f0b54c48ce9:
        case 0, $2dd302fafaba5cec$export$bf8ee812b24655d4:
        case 0, $2dd302fafaba5cec$export$bc65e3276850bd77:
        case 0, $2dd302fafaba5cec$export$d26ba21661f22e80:
        case 0, $2dd302fafaba5cec$export$a37d07ee78eb4569:
        case 0, $2dd302fafaba5cec$export$3901fe85d07ea884:
        case 0, $2dd302fafaba5cec$export$683991a64c0554af:
        case 0, $2dd302fafaba5cec$export$c2cc0c112205cb31:
        case 0, $2dd302fafaba5cec$export$512ff6aab0cdbe50:
        case 0, $2dd302fafaba5cec$export$4e4c26804f20e52f:
        case 0, $2dd302fafaba5cec$export$f5d2c16049863c6c:
            return true;
        default:
            return false;
    }
}
function $e248d0fa19ac08a2$var$copyOwnProperties(target, source) {
    for(const key in source)if (Object.hasOwn(source, key)) target[key] = source[key];
}
function $e248d0fa19ac08a2$var$copySymbolProperties(target, source) {
    const symbols = Object.getOwnPropertySymbols(source);
    for(let i = 0; i < symbols.length; i++){
        const symbol = symbols[i];
        if (Object.prototype.propertyIsEnumerable.call(source, symbol)) target[symbol] = source[symbol];
    }
}
function $e248d0fa19ac08a2$var$cloneStringObjectProperties(target, source) {
    const stringLength = source.valueOf().length;
    for(const key in source)if (Object.hasOwn(source, key) && (Number.isNaN(Number(key)) || Number(key) >= stringLength)) target[key] = source[key];
}
function $e248d0fa19ac08a2$var$copyPrototype(target, source) {
    const proto = Object.getPrototypeOf(source);
    if (proto !== null) {
        if (typeof source.constructor === "function") Object.setPrototypeOf(target, proto);
    }
}

//#region src/function/debounce.ts
/**
* Creates a debounced function that delays invoking the provided function until after `debounceMs` milliseconds
* have elapsed since the last time the debounced function was invoked. The debounced function also has a `cancel`
* method to cancel any pending execution.
*
* @template F - The type of function.
* @param func - The function to debounce.
* @param debounceMs - The number of milliseconds to delay.
* @param options - The options object
* @param options.signal - An optional AbortSignal to cancel the debounced function.
* @param options.edges - An optional array specifying whether the function should be invoked on the leading edge, trailing edge, or both.
* @returns A new debounced function with a `cancel` method.
*
* @example
* const debouncedFunction = debounce(() => {
*   console.log('Function executed');
* }, 1000);
*
* // Will log 'Function executed' after 1 second if not called again in that time
* debouncedFunction();
*
* // Will not log anything as the previous call is canceled
* debouncedFunction.cancel();
*
* // With AbortSignal
* const controller = new AbortController();
* const signal = controller.signal;
* const debouncedWithSignal = debounce(() => {
*  console.log('Function executed');
* }, 1000, { signal });
*
* debouncedWithSignal();
*
* // Will cancel the debounced function call
* controller.abort();
*/ function $286e0321a85de49f$export$61fc7d43ac8f84b0(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = void 0;
    let pendingArgs = null;
    const leading = edges != null && edges.includes("leading");
    const trailing = edges == null || edges.includes("trailing");
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = void 0;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = void 0;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener("abort", cancel, {
        once: true
    });
    return debounced;
}


//#region src/compat/function/debounce.ts
function $b19df1c2aca1a652$export$61fc7d43ac8f84b0(func, debounceMs = 0, options = {}) {
    if (typeof options !== "object") options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = "leading";
    if (trailing) edges[1] = "trailing";
    let result = void 0;
    let pendingAt = null;
    const _debounced = (0, $286e0321a85de49f$export$61fc7d43ac8f84b0)(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                if (leading || trailing) result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}




//#region src/compat/_internal/isPrototype.ts
function $6bca962f978040c9$export$b7f732ed64a02056(value) {
    const constructor = value?.constructor;
    return value === (typeof constructor === "function" ? constructor.prototype : Object.prototype);
}




//#region src/compat/util/toNumber.ts
/**
* Converts `value` to a number.
*
* Unlike `Number()`, this function returns `NaN` for symbols.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toNumber(3.2); // => 3.2
* toNumber(Number.MIN_VALUE); // => 5e-324
* toNumber(Infinity); // => Infinity
* toNumber('3.2'); // => 3.2
* toNumber(Symbol.iterator); // => NaN
* toNumber(NaN); // => NaN
*/ function $c8f4cd7c30fd505d$export$a0a81dc3380ce7d3(value) {
    if ((0, $3234d99707a4bfd4$export$a244864fd9645c7f)(value)) return NaN;
    return Number(value);
}


//#region src/compat/util/toFinite.ts
/**
* Converts `value` to a finite number.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toFinite(3.2); // => 3.2
* toFinite(Number.MIN_VALUE); // => 5e-324
* toFinite(Infinity); // => 1.7976931348623157e+308
* toFinite('3.2'); // => 3.2
* toFinite(Symbol.iterator); // => 0
* toFinite(NaN); // => 0
*/ function $5f31f1753456a924$export$7109d1a0d57e8f54(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $c8f4cd7c30fd505d$export$a0a81dc3380ce7d3)(value);
    if (value === Infinity || value === -Infinity) return (value < 0 ? -1 : 1) * Number.MAX_VALUE;
    return value === value ? value : 0;
}


//#region src/compat/util/toInteger.ts
/**
* Converts `value` to an integer.
*
* This function first converts `value` to a finite number. If the result has any decimal places,
* they are removed by rounding down to the nearest whole number.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toInteger(3.2); // => 3
* toInteger(Number.MIN_VALUE); // => 0
* toInteger(Infinity); // => 1.7976931348623157e+308
* toInteger('3.2'); // => 3
* toInteger(Symbol.iterator); // => 0
* toInteger(NaN); // => 0
*/ function $53d35fe43ed039f4$export$f728be4ab20cbf1f(value) {
    const finite = (0, $5f31f1753456a924$export$7109d1a0d57e8f54)(value);
    const remainder = finite % 1;
    return remainder ? finite - remainder : finite;
}


//#region src/compat/util/times.ts
/**
* Invokes the getValue function n times, returning an array of the results.
*
* @template R The return type of the getValue function.
* @param n - The number of times to invoke getValue.
* @param getValue - The function to invoke for each index.
* @returns An array containing the results of invoking getValue n times.
* @example
* times(3, (i) => i * 2); // => [0, 2, 4]
* times(2, () => 'es-toolkit'); // => ['es-toolkit', 'es-toolkit']
*/ function $8e201eadfddbb188$export$b5bc26e198ce73d0(n, getValue) {
    n = (0, $53d35fe43ed039f4$export$f728be4ab20cbf1f)(n);
    if (n < 1 || !Number.isSafeInteger(n)) return [];
    const result = new Array(n);
    for(let i = 0; i < n; i++)result[i] = typeof getValue === "function" ? getValue(i) : i;
    return result;
}


//#region src/compat/object/keysIn.ts
/**
* This function retrieves the names of string-keyed properties from an object, including those inherited from its prototype.
*
* - If the value is not an object, it is converted to an object.
* - Array-like objects are treated like arrays.
* - Sparse arrays with some missing indices are treated like dense arrays.
* - If the value is `null` or `undefined`, an empty array is returned.
* - When handling prototype objects, the `constructor` property is excluded from the results.
*
* @param [object] - The object to inspect for keys.
* @returns An array of string keys from the object.
*
* @example
* const obj = { a: 1, b: 2 };
* console.log(keysIn(obj)); // ['a', 'b']
*
* const arr = [1, 2, 3];
* console.log(keysIn(arr)); // ['0', '1', '2']
*
* function Foo() {}
* Foo.prototype.a = 1;
* console.log(keysIn(new Foo())); // ['a']
*/ function $13d899d5ad986db5$export$6949febaebdbcb7c(object) {
    if (object == null) return [];
    switch(typeof object){
        case "object":
        case "function":
            if ((0, $63d5569bd28740d6$export$1e2f57719e155213)(object)) return $13d899d5ad986db5$var$arrayLikeKeysIn(object);
            if ((0, $6bca962f978040c9$export$b7f732ed64a02056)(object)) return $13d899d5ad986db5$var$prototypeKeysIn(object);
            return $13d899d5ad986db5$var$keysInImpl(object);
        default:
            return $13d899d5ad986db5$var$keysInImpl(Object(object));
    }
}
function $13d899d5ad986db5$var$keysInImpl(object) {
    const result = [];
    for(const key in object)result.push(key);
    return result;
}
function $13d899d5ad986db5$var$prototypeKeysIn(object) {
    return $13d899d5ad986db5$var$keysInImpl(object).filter((key)=>key !== "constructor");
}
function $13d899d5ad986db5$var$arrayLikeKeysIn(object) {
    const indices = (0, $8e201eadfddbb188$export$b5bc26e198ce73d0)(object.length, (index)=>`${index}`);
    const filteredKeys = new Set(indices);
    if ((0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(object)) {
        filteredKeys.add("offset");
        filteredKeys.add("parent");
    }
    if ((0, $4333556256d3d0c3$export$b119cc7e1840e59c)(object)) {
        filteredKeys.add("buffer");
        filteredKeys.add("byteLength");
        filteredKeys.add("byteOffset");
    }
    const inheritedKeys = $13d899d5ad986db5$var$keysInImpl(object).filter((key)=>!filteredKeys.has(key));
    if (Array.isArray(object)) return [
        ...indices,
        ...inheritedKeys
    ];
    return [
        ...indices.filter((index)=>Object.hasOwn(object, index)),
        ...inheritedKeys
    ];
}


//#region src/compat/object/assignIn.ts
/**
* Assigns properties from multiple source objects to a target object.
*
* This function merges the properties of the source objects into the target object,
* including properties from the prototype chain. If a property in the source objects
* is equal to the corresponding property in the target object, it will not be overwritten.
*
* @param object - The target object to which properties will be assigned.
* @param sources - The source objects whose properties will be assigned to the target object.
* @returns The updated target object with properties from the source objects assigned.
*
* @example
* const target = { a: 1 };
* const result = assignIn(target, { b: 2 }, { c: 3 });
* console.log(result); // Output: { a: 1, b: 2, c: 3 }
*/ function $c4c424a07e1933a9$export$64c881bba8e369b4(object, ...sources) {
    for(let i = 0; i < sources.length; i++)$c4c424a07e1933a9$var$assignInImpl(object, sources[i]);
    return object;
}
function $c4c424a07e1933a9$var$assignInImpl(object, source) {
    const keys = (0, $13d899d5ad986db5$export$6949febaebdbcb7c)(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!(key in object) || !(0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(object[key], source[key])) object[key] = source[key];
    }
}






//#region src/compat/predicate/isEmpty.ts
/**
* Checks if a given value is empty.
*
* - If the given value is a string, checks if it is an empty string.
* - If the given value is an array, `Map`, or `Set`, checks if its size is 0.
* - If the given value is an [array-like object](../predicate/isArrayLike.md), checks if its length is 0.
* - If the given value is an object, checks if it is an empty object with no properties.
* - Primitive values (booleans, numbers, or bigints) are considered empty.
*
* @param [value] - The value to check.
* @returns `true` if the value is empty, `false` otherwise.
*
* @example
* isEmpty(); // true
* isEmpty(null); // true
* isEmpty(""); // true
* isEmpty([]); // true
* isEmpty({}); // true
* isEmpty(new Map()); // true
* isEmpty(new Set()); // true
* isEmpty("hello"); // false
* isEmpty([1, 2, 3]); // false
* isEmpty({ a: 1 }); // false
* isEmpty(new Map([["key", "value"]])); // false
* isEmpty(new Set([1, 2, 3])); // false
*/ function $0fbcc62fa6835df5$export$dd1bc94b04021eeb(value) {
    if (value == null) return true;
    if ((0, $63d5569bd28740d6$export$1e2f57719e155213)(value)) {
        if (typeof value.splice !== "function" && typeof value !== "string" && !(0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(value) && !(0, $4333556256d3d0c3$export$b119cc7e1840e59c)(value) && !(0, $01e9c819d0970ac4$export$dbbb9d8cd6fff001)(value)) return false;
        return value.length === 0;
    }
    if (typeof value === "object" || typeof value === "function") {
        if (value instanceof Map || value instanceof Set) return value.size === 0;
        const keys = Object.keys(value);
        if ((0, $6bca962f978040c9$export$b7f732ed64a02056)(value)) return keys.filter((x)=>x !== "constructor").length === 0;
        return keys.length === 0;
    }
    return true;
}






//#region src/predicate/isPlainObject.ts
/**
* Checks if a given value is a plain object.
*
* @param value - The value to check.
* @returns True if the value is a plain object, otherwise false.
*
* @example
* ```typescript
* // ✅👇 True
*
* isPlainObject({ });                       // ✅
* isPlainObject({ key: 'value' });          // ✅
* isPlainObject({ key: new Date() });       // ✅
* isPlainObject(new Object());              // ✅
* isPlainObject(Object.create(null));       // ✅
* isPlainObject({ nested: { key: true} });  // ✅
* isPlainObject(new Proxy({}, {}));         // ✅
* isPlainObject({ [Symbol('tag')]: 'A' });  // ✅
*
* // ✅👇 (cross-realms, node context, workers, ...)
* const runInNewContext = await import('node:vm').then(
*     (mod) => mod.runInNewContext
* );
* isPlainObject(runInNewContext('({})'));   // ✅
*
* // ❌👇 False
*
* class Test { };
* isPlainObject(new Test())           // ❌
* isPlainObject(10);                  // ❌
* isPlainObject(null);                // ❌
* isPlainObject('hello');             // ❌
* isPlainObject([]);                  // ❌
* isPlainObject(new Date());          // ❌
* isPlainObject(new Uint8Array([1])); // ❌
* isPlainObject(Buffer.from('ABC'));  // ❌
* isPlainObject(Promise.resolve({})); // ❌
* isPlainObject(Object.create({}));   // ❌
* isPlainObject(new (class Cls {}));  // ❌
* isPlainObject(globalThis);          // ❌,
* ```
*/ function $4ce6a566ac3b352c$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (!(proto === null || proto === Object.prototype || Object.getPrototypeOf(proto) === null)) return false;
    return Object.prototype.toString.call(value) === "[object Object]";
}



//#region src/predicate/isEqualWith.ts
/**
* Compares two values for equality using a custom comparison function.
*
* The custom function allows for fine-tuned control over the comparison process. If it returns a boolean, that result determines the equality. If it returns undefined, the function falls back to the default equality comparison.
*
* This function also uses the custom equality function to compare values inside objects,
* arrays, maps, sets, and other complex structures, ensuring a deep comparison.
*
* This approach provides flexibility in handling complex comparisons while maintaining efficient default behavior for simpler cases.
*
* The custom comparison function can take up to six parameters:
* - `x`: The value from the first object `a`.
* - `y`: The value from the second object `b`.
* - `property`: The property key used to get `x` and `y`.
* - `xParent`: The parent of the first value `x`.
* - `yParent`: The parent of the second value `y`.
* - `stack`: An internal stack (Map) to handle circular references.
*
* @param a - The first value to compare.
* @param b - The second value to compare.
* @param areValuesEqual - A function to customize the comparison.
*   If it returns a boolean, that result will be used. If it returns undefined,
*   the default equality comparison will be used.
* @returns `true` if the values are equal according to the customizer, otherwise `false`.
*
* @example
* const customizer = (a, b) => {
*   if (typeof a === 'string' && typeof b === 'string') {
*     return a.toLowerCase() === b.toLowerCase();
*   }
* };
* isEqualWith('Hello', 'hello', customizer); // true
* isEqualWith({ a: 'Hello' }, { a: 'hello' }, customizer); // true
* isEqualWith([1, 2, 3], [1, 2, 3], customizer); // true
*/ function $638e15d16692715a$export$dfce45ad55c48ab1(a, b, areValuesEqual) {
    return $638e15d16692715a$var$isEqualWithImpl(a, b, void 0, void 0, void 0, void 0, areValuesEqual);
}
function $638e15d16692715a$var$isEqualWithImpl(a, b, property, aParent, bParent, stack, areValuesEqual) {
    const result = areValuesEqual(a, b, property, aParent, bParent, stack);
    if (result !== void 0) return result;
    if (typeof a === typeof b) switch(typeof a){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return a === b;
        case "number":
            return a === b || Object.is(a, b);
        case "function":
            return a === b;
        case "object":
            return $638e15d16692715a$var$areObjectsEqual(a, b, stack, areValuesEqual);
    }
    return $638e15d16692715a$var$areObjectsEqual(a, b, stack, areValuesEqual);
}
function $638e15d16692715a$var$areObjectsEqual(a, b, stack, areValuesEqual) {
    if (Object.is(a, b)) return true;
    let aTag = (0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(a);
    let bTag = (0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(b);
    if (aTag === "[object Arguments]") aTag = (0, $2dd302fafaba5cec$export$bc65e3276850bd77);
    if (bTag === "[object Arguments]") bTag = (0, $2dd302fafaba5cec$export$bc65e3276850bd77);
    if (aTag !== bTag) return false;
    switch(aTag){
        case 0, $2dd302fafaba5cec$export$3901fe85d07ea884:
            return a.toString() === b.toString();
        case 0, $2dd302fafaba5cec$export$bf8ee812b24655d4:
            return (0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(a.valueOf(), b.valueOf());
        case 0, $2dd302fafaba5cec$export$9edaefd43909686f:
        case 0, $2dd302fafaba5cec$export$6db2fef2b8581597:
        case 0, $2dd302fafaba5cec$export$683991a64c0554af:
            return Object.is(a.valueOf(), b.valueOf());
        case 0, $2dd302fafaba5cec$export$d26ba21661f22e80:
            return a.source === b.source && a.flags === b.flags;
        case 0, $2dd302fafaba5cec$export$efb7244c657e09d9:
            return a === b;
    }
    stack = stack ?? /* @__PURE__ */ new Map();
    const aStack = stack.get(a);
    const bStack = stack.get(b);
    if (aStack != null && bStack != null) return aStack === b;
    stack.set(a, b);
    stack.set(b, a);
    try {
        switch(aTag){
            case 0, $2dd302fafaba5cec$export$75d37f0b54c48ce9:
                if (a.size !== b.size) return false;
                for (const [key, value] of a.entries())if (!b.has(key) || !$638e15d16692715a$var$isEqualWithImpl(value, b.get(key), key, a, b, stack, areValuesEqual)) return false;
                return true;
            case 0, $2dd302fafaba5cec$export$a37d07ee78eb4569:
                {
                    if (a.size !== b.size) return false;
                    const aValues = Array.from(a.values());
                    const bValues = Array.from(b.values());
                    for(let i = 0; i < aValues.length; i++){
                        const aValue = aValues[i];
                        const index = bValues.findIndex((bValue)=>{
                            return $638e15d16692715a$var$isEqualWithImpl(aValue, bValue, void 0, a, b, stack, areValuesEqual);
                        });
                        if (index === -1) return false;
                        bValues.splice(index, 1);
                    }
                    return true;
                }
            case 0, $2dd302fafaba5cec$export$30c5ab3238b83eeb:
            case 0, $2dd302fafaba5cec$export$c2cc0c112205cb31:
            case 0, $2dd302fafaba5cec$export$512ff6aab0cdbe50:
            case 0, $2dd302fafaba5cec$export$4e4c26804f20e52f:
            case 0, $2dd302fafaba5cec$export$f5d2c16049863c6c:
            case 0, $2dd302fafaba5cec$export$f9d61a38957fda15:
            case 0, $2dd302fafaba5cec$export$91c7bbbd3303f2e7:
            case 0, $2dd302fafaba5cec$export$72d152e068382569:
            case 0, $2dd302fafaba5cec$export$222c6a8899454b8e:
            case 0, $2dd302fafaba5cec$export$16916807c04c97d7:
            case 0, $2dd302fafaba5cec$export$6acb72c43d6c58de:
            case 0, $2dd302fafaba5cec$export$64993ccc604584f0:
                if ((0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(a) !== (0, $9e25127241ed1cb9$export$a7884ebc965f8f54)(b)) return false;
                if (a.length !== b.length) return false;
                for(let i = 0; i < a.length; i++)if (!$638e15d16692715a$var$isEqualWithImpl(a[i], b[i], i, a, b, stack, areValuesEqual)) return false;
                return true;
            case 0, $2dd302fafaba5cec$export$2e30fbc9f2b7b0ee:
                if (a.byteLength !== b.byteLength) return false;
                return $638e15d16692715a$var$areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
            case 0, $2dd302fafaba5cec$export$da14abe8375f47ee:
                if (a.byteLength !== b.byteLength || a.byteOffset !== b.byteOffset) return false;
                return $638e15d16692715a$var$areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
            case 0, $2dd302fafaba5cec$export$22cd55b42946d950:
                return a.name === b.name && a.message === b.message;
            case 0, $2dd302fafaba5cec$export$bc65e3276850bd77:
                {
                    if (!($638e15d16692715a$var$areObjectsEqual(a.constructor, b.constructor, stack, areValuesEqual) || (0, $4ce6a566ac3b352c$export$53b83ca8eaab0383)(a) && (0, $4ce6a566ac3b352c$export$53b83ca8eaab0383)(b))) return false;
                    const aKeys = [
                        ...Object.keys(a),
                        ...(0, $889d2deffff707be$export$35a4784e7aa54e28)(a)
                    ];
                    const bKeys = [
                        ...Object.keys(b),
                        ...(0, $889d2deffff707be$export$35a4784e7aa54e28)(b)
                    ];
                    if (aKeys.length !== bKeys.length) return false;
                    for(let i = 0; i < aKeys.length; i++){
                        const propKey = aKeys[i];
                        const aProp = a[propKey];
                        if (!Object.hasOwn(b, propKey)) return false;
                        const bProp = b[propKey];
                        if (!$638e15d16692715a$var$isEqualWithImpl(aProp, bProp, propKey, a, b, stack, areValuesEqual)) return false;
                    }
                    return true;
                }
            default:
                return false;
        }
    } finally{
        stack.delete(a);
        stack.delete(b);
    }
}


//#region src/predicate/isEqual.ts
/**
* Checks if two values are equal, including support for `Date`, `RegExp`, and deep object comparison.
*
* @param a - The first value to compare.
* @param b - The second value to compare.
* @returns `true` if the values are equal, otherwise `false`.
*
* @example
* isEqual(1, 1); // true
* isEqual({ a: 1 }, { a: 1 }); // true
* isEqual(/abc/g, /abc/g); // true
* isEqual(new Date('2020-01-01'), new Date('2020-01-01')); // true
* isEqual([1, 2, 3], [1, 2, 3]); // true
*/ function $a48d2f3392454588$export$248d38f6296296c5(a, b) {
    return (0, $638e15d16692715a$export$dfce45ad55c48ab1)(a, b, (0, $b04d7835dd3a1b71$export$8793edee2d425525));
}

//#region src/function/after.ts
/**
* Creates a function that only executes starting from the `n`-th call.
* The provided function will be invoked starting from the `n`-th call.
*
* This is particularly useful for scenarios involving events or asynchronous operations
* where an action should occur only after a certain number of invocations.
*
* @template F - The type of the function to be invoked.
* @param n - The number of calls required for `func` to execute.
* @param func - The function to be invoked.
* @returns A new function that:
* - Tracks the number of calls.
* - Invokes `func` starting from the `n`-th call.
* - Returns `undefined` if fewer than `n` calls have been made.
* @throws {Error} - Throws an error if `n` is negative.
* @example
*
* const afterFn = after(3, () => {
*  console.log("called")
* });
*
* // Will not log anything.
* afterFn()
* // Will not log anything.
* afterFn()
* // Will log 'called'.
* afterFn()
*/ function $bfb9af236e1622d9$export$742acabee3dd6465(n, func) {
    if (!Number.isInteger(n) || n < 0) throw new Error(`n must be a non-negative integer.`);
    let counter = 0;
    return (...args)=>{
        if (++counter >= n) return func(...args);
    };
}



//#region src/compat/predicate/isEqualWith.ts
/**
* Compares two values for equality using a custom comparison function.
*
* The custom function allows for fine-tuned control over the comparison process. If it returns a boolean, that result determines the equality. If it returns undefined, the function falls back to the default equality comparison.
*
* This function also uses the custom equality function to compare values inside objects,
* arrays, maps, sets, and other complex structures, ensuring a deep comparison.
*
* This approach provides flexibility in handling complex comparisons while maintaining efficient default behavior for simpler cases.
*
* The custom comparison function can take up to six parameters:
* - `x`: The value from the first object `a`.
* - `y`: The value from the second object `b`.
* - `property`: The property key used to get `x` and `y`.
* - `xParent`: The parent of the first value `x`.
* - `yParent`: The parent of the second value `y`.
* - `stack`: An internal stack (Map) to handle circular references.
*
* @param a - The first value to compare.
* @param b - The second value to compare.
* @param [areValuesEqual=noop] - A function to customize the comparison.
*   If it returns a boolean, that result will be used. If it returns undefined,
*   the default equality comparison will be used.
* @returns `true` if the values are equal according to the customizer, otherwise `false`.
*
* @example
* const customizer = (a, b) => {
*   if (typeof a === 'string' && typeof b === 'string') {
*     return a.toLowerCase() === b.toLowerCase();
*   }
* };
* isEqualWith('Hello', 'hello', customizer); // true
* isEqualWith({ a: 'Hello' }, { a: 'hello' }, customizer); // true
* isEqualWith([1, 2, 3], [1, 2, 3], customizer); // true
*/ function $5c9e4268bec214a7$export$dfce45ad55c48ab1(a, b, areValuesEqual) {
    if (typeof areValuesEqual !== "function") areValuesEqual = ()=>void 0;
    return (0, $638e15d16692715a$export$dfce45ad55c48ab1)(a, b, (...args)=>{
        const result = areValuesEqual(...args);
        if (result !== void 0) return Boolean(result);
        if (a instanceof Map && b instanceof Map) return $5c9e4268bec214a7$export$dfce45ad55c48ab1(Array.from(a), Array.from(b), (0, $bfb9af236e1622d9$export$742acabee3dd6465)(2, areValuesEqual));
        if (a instanceof Set && b instanceof Set) return $5c9e4268bec214a7$export$dfce45ad55c48ab1(Array.from(a), Array.from(b), (0, $bfb9af236e1622d9$export$742acabee3dd6465)(2, areValuesEqual));
    });
}


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $b9b9f2bdf9c6137f$var$documentPlaceholders = /* @__PURE__ */ new WeakMap();
let $b9b9f2bdf9c6137f$var$hasDisplayedPlaceholderDeprecationWarning = false;
/**
* A helper that enables a placeholder on the provided view element (also updates its visibility).
* The placeholder is a CSS pseudo–element (with a text content) attached to the element.
*
* To change the placeholder text, change value of the `placeholder` property in the provided `element`.
*
* To disable the placeholder, use {@link module:engine/view/placeholder~disableViewPlaceholder `disableViewPlaceholder()`} helper.
*
* @param options Configuration options of the placeholder.
* @param options.view Editing view instance.
* @param options.element Element that will gain a placeholder. See `options.isDirectHost` to learn more.
* @param options.isDirectHost If set `false`, the placeholder will not be enabled directly
* in the passed `element` but in one of its children (selected automatically, i.e. a first empty child element).
* Useful when attaching placeholders to elements that can host other elements (not just text), for instance,
* editable root elements.
* @param options.text Placeholder text. It's **deprecated** and will be removed soon. Use
* {@link module:engine/view/placeholder~PlaceholderableViewElement#placeholder `options.element.placeholder`} instead.
* @param options.keepOnFocus If set `true`, the placeholder stay visible when the host element is focused.
*/ function $b9b9f2bdf9c6137f$export$60a783c4b7d78e80({ view: view, element: element, text: text, isDirectHost: isDirectHost = true, keepOnFocus: keepOnFocus = false }) {
    const doc = view.document;
    if (!$b9b9f2bdf9c6137f$var$documentPlaceholders.has(doc)) {
        $b9b9f2bdf9c6137f$var$documentPlaceholders.set(doc, /* @__PURE__ */ new Map());
        doc.registerPostFixer((writer)=>$b9b9f2bdf9c6137f$var$updateDocumentPlaceholders($b9b9f2bdf9c6137f$var$documentPlaceholders.get(doc), writer));
        doc.on("change:isComposing", ()=>{
            view.change((writer)=>$b9b9f2bdf9c6137f$var$updateDocumentPlaceholders($b9b9f2bdf9c6137f$var$documentPlaceholders.get(doc), writer));
        }, {
            priority: "high"
        });
    }
    if (element.is("editableElement")) element.on("change:placeholder", (evtInfo, evt, text)=>setPlaceholder(text));
    if (element.placeholder) setPlaceholder(element.placeholder);
    else if (text) setPlaceholder(text);
    if (text) $b9b9f2bdf9c6137f$var$showViewPlaceholderTextDeprecationWarning();
    function setPlaceholder(text) {
        const config = {
            text: text,
            isDirectHost: isDirectHost,
            keepOnFocus: keepOnFocus,
            hostElement: isDirectHost ? element : null
        };
        $b9b9f2bdf9c6137f$var$documentPlaceholders.get(doc).set(element, config);
        view.change((writer)=>$b9b9f2bdf9c6137f$var$updateDocumentPlaceholders([
                [
                    element,
                    config
                ]
            ], writer));
    }
}
/**
* Disables the placeholder functionality from a given element.
*
* See {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`} to learn more.
*/ function $b9b9f2bdf9c6137f$export$dcb1b8b9e0fffbdd(view, element) {
    const doc = element.document;
    if (!$b9b9f2bdf9c6137f$var$documentPlaceholders.has(doc)) return;
    view.change((writer)=>{
        const placeholders = $b9b9f2bdf9c6137f$var$documentPlaceholders.get(doc);
        const config = placeholders.get(element);
        writer.removeAttribute("data-placeholder", config.hostElement);
        $b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36(writer, config.hostElement);
        placeholders.delete(element);
    });
}
/**
* Shows a placeholder in the provided element by changing related attributes and CSS classes.
*
* **Note**: This helper will not update the placeholder visibility nor manage the
* it in any way in the future. What it does is a one–time state change of an element. Use
* {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`} and
* {@link module:engine/view/placeholder~disableViewPlaceholder `disableViewPlaceholder()`} for full
* placeholder functionality.
*
* **Note**: This helper will blindly show the placeholder directly in the root editable element if
* one is passed, which could result in a visual clash if the editable element has some children
* (for instance, an empty paragraph). Use {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`}
* in that case or make sure the correct element is passed to the helper.
*
* @returns `true`, if any changes were made to the `element`.
*/ function $b9b9f2bdf9c6137f$export$8c7c5b4ed6e42344(writer, element) {
    if (!element.hasClass("ck-placeholder")) {
        writer.addClass("ck-placeholder", element);
        return true;
    }
    return false;
}
/**
* Hides a placeholder in the element by changing related attributes and CSS classes.
*
* **Note**: This helper will not update the placeholder visibility nor manage the
* it in any way in the future. What it does is a one–time state change of an element. Use
* {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`} and
* {@link module:engine/view/placeholder~disableViewPlaceholder `disableViewPlaceholder()`} for full
* placeholder functionality.
*
* @returns `true`, if any changes were made to the `element`.
*/ function $b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36(writer, element) {
    if (element.hasClass("ck-placeholder")) {
        writer.removeClass("ck-placeholder", element);
        return true;
    }
    return false;
}
/**
* Checks if a placeholder should be displayed in the element.
*
* **Note**: This helper will blindly check the possibility of showing a placeholder directly in the
* root editable element if one is passed, which may not be the expected result. If an element can
* host other elements (not just text), most likely one of its children should be checked instead
* because it will be the final host for the placeholder. Use
* {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`} in that case or make
* sure the correct element is passed to the helper.
*
* @param element Element that holds the placeholder.
* @param keepOnFocus Focusing the element will keep the placeholder visible.
*/ function $b9b9f2bdf9c6137f$export$41f5caf1b5456035(element, keepOnFocus) {
    if (!element.isAttached()) return false;
    if ($b9b9f2bdf9c6137f$var$hasContent(element)) return false;
    const doc = element.document;
    const selectionAnchor = doc.selection.anchor;
    if (doc.isComposing && selectionAnchor && selectionAnchor.parent === element) return false;
    if (keepOnFocus) return true;
    if (!doc.isFocused) return true;
    return !!selectionAnchor && selectionAnchor.parent !== element;
}
/**
* Anything but uiElement(s) counts as content.
*/ function $b9b9f2bdf9c6137f$var$hasContent(element) {
    for (const child of element.getChildren())if (!child.is("uiElement")) return true;
    return false;
}
/**
* Updates all placeholders associated with a document in a post–fixer callback.
*
* @returns True if any changes were made to the view document.
*/ function $b9b9f2bdf9c6137f$var$updateDocumentPlaceholders(placeholders, writer) {
    const directHostElements = [];
    let wasViewModified = false;
    for (const [element, config] of placeholders)if (config.isDirectHost) {
        directHostElements.push(element);
        if ($b9b9f2bdf9c6137f$var$updatePlaceholder(writer, element, config)) wasViewModified = true;
    }
    for (const [element, config] of placeholders){
        if (config.isDirectHost) continue;
        const hostElement = $b9b9f2bdf9c6137f$var$getChildPlaceholderHostSubstitute(element);
        if (hostElement !== config.hostElement && config.hostElement) {
            writer.removeAttribute("data-placeholder", config.hostElement);
            $b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36(writer, config.hostElement);
            config.hostElement = null;
            wasViewModified = true;
        }
        if (!hostElement) continue;
        if (directHostElements.includes(hostElement)) continue;
        config.hostElement = hostElement;
        if ($b9b9f2bdf9c6137f$var$updatePlaceholder(writer, element, config)) wasViewModified = true;
    }
    return wasViewModified;
}
/**
* Updates a single placeholder in a post–fixer callback.
*
* @returns True if any changes were made to the view document.
*/ function $b9b9f2bdf9c6137f$var$updatePlaceholder(writer, element, config) {
    const { text: text, isDirectHost: isDirectHost, hostElement: hostElement } = config;
    let wasViewModified = false;
    if (hostElement.getAttribute("data-placeholder") !== text) {
        writer.setAttribute("data-placeholder", text, hostElement);
        wasViewModified = true;
    }
    if ((isDirectHost || element.childCount == 1) && $b9b9f2bdf9c6137f$export$41f5caf1b5456035(hostElement, config.keepOnFocus)) {
        if ($b9b9f2bdf9c6137f$export$8c7c5b4ed6e42344(writer, hostElement)) wasViewModified = true;
    } else if ($b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36(writer, hostElement)) wasViewModified = true;
    return wasViewModified;
}
/**
* Gets a child element capable of displaying a placeholder if a parent element can host more
* than just text (for instance, when it is a root editable element). The child element
* can then be used in other placeholder helpers as a substitute of its parent.
*/ function $b9b9f2bdf9c6137f$var$getChildPlaceholderHostSubstitute(parent) {
    if (parent.childCount) {
        const firstChild = parent.getChild(0);
        if (firstChild.is("element") && !firstChild.is("uiElement") && !firstChild.is("attributeElement")) return firstChild;
    }
    return null;
}
/**
* Displays a deprecation warning message in the console, but only once per page load.
*/ function $b9b9f2bdf9c6137f$var$showViewPlaceholderTextDeprecationWarning() {
    if (!$b9b9f2bdf9c6137f$var$hasDisplayedPlaceholderDeprecationWarning) /**
	* The "text" option in the {@link module:engine/view/placeholder~enableViewPlaceholder `enableViewPlaceholder()`}
	* function is deprecated and will be removed soon.
	*
	* See the `#view-element-placeholder` section in the `Update to v39.x` section in the
	* {@glink updating/guides/updating-from-older-versions updating from older versions} guide
	* for more information on how to apply this change.
	*
	* @error enableViewPlaceholder-deprecated-text-option
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("enableViewPlaceholder-deprecated-text-option");
    $b9b9f2bdf9c6137f$var$hasDisplayedPlaceholderDeprecationWarning = true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ var $b9b9f2bdf9c6137f$export$43d75c0e89b2169f = class {
    /* v8 ignore next -- @preserve */ is() {
        throw new Error("is() method is abstract");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/node
*/ const $b9b9f2bdf9c6137f$var$ViewNodeBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$43d75c0e89b2169f);
/**
* Abstract view node class.
*
* This is an abstract class. Its constructor should not be used directly.
* Use the {@link module:engine/view/downcastwriter~ViewDowncastWriter} or {@link module:engine/view/upcastwriter~ViewUpcastWriter}
* to create new instances of view nodes.
*/ var $b9b9f2bdf9c6137f$export$1de540da1a7d61ca = class extends $b9b9f2bdf9c6137f$var$ViewNodeBase {
    /**
	* The document instance to which this node belongs.
	*/ document;
    /**
	* Parent element. Null by default. Set by {@link module:engine/view/element~ViewElement#_insertChild}.
	*/ parent;
    /**
	* Creates a tree view node.
	*
	* @param document The document instance to which this node belongs.
	*/ constructor(document1){
        super();
        this.document = document1;
        this.parent = null;
    }
    /**
	* Index of the node in the parent element or null if the node has no parent.
	*
	* Accessing this property throws an error if this node's parent element does not contain it.
	* This means that view tree got broken.
	*/ get index() {
        let pos;
        if (!this.parent) return null;
        if ((pos = this.parent.getChildIndex(this)) == -1) /**
		* The node's parent does not contain this node. It means that the document tree is corrupted.
		*
		* @error view-node-not-found-in-parent
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-node-not-found-in-parent", this);
        return pos;
    }
    /**
	* Node's next sibling, or `null` if it is the last child.
	*/ get nextSibling() {
        const index = this.index;
        return index !== null && this.parent.getChild(index + 1) || null;
    }
    /**
	* Node's previous sibling, or `null` if it is the first child.
	*/ get previousSibling() {
        const index = this.index;
        return index !== null && this.parent.getChild(index - 1) || null;
    }
    /**
	* Top-most ancestor of the node. If the node has no parent it is the root itself.
	*/ get root() {
        let root = this;
        while(root.parent)root = root.parent;
        return root;
    }
    /**
	* Returns true if the node is in a tree rooted in the document (is a descendant of one of its roots).
	*/ isAttached() {
        return this.root.is("rootElement");
    }
    /**
	* Gets a path to the node. The path is an array containing indices of consecutive ancestors of this node,
	* beginning from {@link module:engine/view/node~ViewNode#root root}, down to this node's index.
	*
	* ```ts
	* const abc = downcastWriter.createText( 'abc' );
	* const foo = downcastWriter.createText( 'foo' );
	* const h1 = downcastWriter.createElement( 'h1', null, downcastWriter.createText( 'header' ) );
	* const p = downcastWriter.createElement( 'p', null, [ abc, foo ] );
	* const div = downcastWriter.createElement( 'div', null, [ h1, p ] );
	* foo.getPath(); // Returns [ 1, 3 ]. `foo` is in `p` which is in `div`. `p` starts at offset 1, while `foo` at 3.
	* h1.getPath(); // Returns [ 0 ].
	* div.getPath(); // Returns [].
	* ```
	*
	* @returns The path.
	*/ getPath() {
        const path = [];
        let node = this;
        while(node.parent){
            path.unshift(node.index);
            node = node.parent;
        }
        return path;
    }
    /**
	* Returns ancestors array of this node.
	*
	* @param options Options object.
	* @param options.includeSelf When set to `true` this node will be also included in parent's array.
	* @param options.parentFirst When set to `true`, array will be sorted from node's parent to root element,
	* otherwise root element will be the first item in the array.
	* @returns Array with ancestors.
	*/ getAncestors(options = {}) {
        const ancestors = [];
        let parent = options.includeSelf ? this : this.parent;
        while(parent){
            ancestors[options.parentFirst ? "push" : "unshift"](parent);
            parent = parent.parent;
        }
        return ancestors;
    }
    /**
	* Returns a {@link module:engine/view/element~ViewElement} or {@link module:engine/view/documentfragment~ViewDocumentFragment}
	* which is a common ancestor of both nodes.
	*
	* @param node The second node.
	* @param options Options object.
	* @param options.includeSelf When set to `true` both nodes will be considered "ancestors" too.
	* Which means that if e.g. node A is inside B, then their common ancestor will be B.
	*/ getCommonAncestor(node, options = {}) {
        const ancestorsA = this.getAncestors(options);
        const ancestorsB = node.getAncestors(options);
        let i = 0;
        while(ancestorsA[i] == ancestorsB[i] && ancestorsA[i])i++;
        return i === 0 ? null : ancestorsA[i - 1];
    }
    /**
	* Returns whether this node is before given node. `false` is returned if nodes are in different trees (for example,
	* in different {@link module:engine/view/documentfragment~ViewDocumentFragment}s).
	*
	* @param node Node to compare with.
	*/ isBefore(node) {
        if (this == node) return false;
        if (this.root !== node.root) return false;
        const thisPath = this.getPath();
        const nodePath = node.getPath();
        const result = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(thisPath, nodePath);
        switch(result){
            case "prefix":
                return true;
            case "extension":
                return false;
            default:
                return thisPath[result] < nodePath[result];
        }
    }
    /**
	* Returns whether this node is after given node. `false` is returned if nodes are in different trees (for example,
	* in different {@link module:engine/view/documentfragment~ViewDocumentFragment}s).
	*
	* @param node Node to compare with.
	*/ isAfter(node) {
        if (this == node) return false;
        if (this.root !== node.root) return false;
        return !this.isBefore(node);
    }
    /**
	* Removes node from parent.
	*
	* @internal
	*/ _remove() {
        this.parent._removeChildren(this.index);
    }
    /**
	* @internal
	* @param type Type of the change.
	* @param node Changed node.
	* @param data Additional data.
	* @fires change
	*/ _fireChange(type, node, data) {
        this.fire(`change:${type}`, node, data);
        if (this.parent) this.parent._fireChange(type, node, data);
    }
    /**
	* Converts `ViewNode` to plain object and returns it.
	*
	* @returns `ViewNode` converted to plain object.
	*/ toJSON() {
        const json = {
            path: this.getPath(),
            type: "Node"
        };
        if (this !== this.root && this.root.is("rootElement")) json.root = this.root.toJSON();
        return json;
    }
};
$b9b9f2bdf9c6137f$export$1de540da1a7d61ca.prototype.is = function(type) {
    return type === "node" || type === "view:node";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/text
*/ /**
* Tree view text node.
*
* The constructor of this class should not be used directly. To create a new text node instance
* use the {@link module:engine/view/downcastwriter~ViewDowncastWriter#createText `ViewDowncastWriter#createText()`}
* method when working on data downcasted from the model or the
* {@link module:engine/view/upcastwriter~ViewUpcastWriter#createText `ViewUpcastWriter#createText()`}
* method when working on non-semantic views.
*/ var $b9b9f2bdf9c6137f$export$1f9d53a26119da3d = class ViewText extends $b9b9f2bdf9c6137f$export$1de540da1a7d61ca {
    /**
	* The text content.
	*
	* Setting the data fires the {@link module:engine/view/node~ViewNode#event:change:text change event}.
	*/ _textData;
    /**
	* Creates a tree view text node.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createText
	* @internal
	* @param document The document instance to which this text node belongs.
	* @param data The text's data.
	*/ constructor(document1, data){
        super(document1);
        this._textData = data;
    }
    /**
	* The text content.
	*/ get data() {
        return this._textData;
    }
    /**
	* The `_data` property is controlled by a getter and a setter.
	*
	* The getter is required when using the addition assignment operator on protected property:
	*
	* ```ts
	* const foo = downcastWriter.createText( 'foo' );
	* const bar = downcastWriter.createText( 'bar' );
	*
	* foo._data += bar.data;   // executes: `foo._data = foo._data + bar.data`
	* console.log( foo.data ); // prints: 'foobar'
	* ```
	*
	* If the protected getter didn't exist, `foo._data` will return `undefined` and result of the merge will be invalid.
	*
	* The setter sets data and fires the {@link module:engine/view/node~ViewNode#event:change:text change event}.
	*
	* @internal
	*/ get _data() {
        return this.data;
    }
    set _data(data) {
        this._fireChange("text", this);
        this._textData = data;
    }
    /**
	* Checks if this text node is similar to other text node.
	* Both nodes should have the same data to be considered as similar.
	*
	* @param otherNode Node to check if it is same as this node.
	*/ isSimilar(otherNode) {
        if (!(otherNode instanceof ViewText)) return false;
        return this === otherNode || this.data === otherNode.data;
    }
    /**
	* Converts `ViewText` instance to plain object and returns it.
	*
	* @returns `ViewText` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "Text";
        json.data = this.data;
        return json;
    }
    /**
	* Clones this node.
	*
	* @internal
	* @returns Text node that is a clone of this node.
	*/ _clone() {
        return new ViewText(this.document, this.data);
    }
};
$b9b9f2bdf9c6137f$export$1f9d53a26119da3d.prototype.is = function(type) {
    return type === "$text" || type === "view:$text" || type === "text" || type === "view:text" || type === "node" || type === "view:node";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/textproxy
*/ /**
* ViewTextProxy is a wrapper for substring of {@link module:engine/view/text~ViewText}. Instance of this class is created by
* {@link module:engine/view/treewalker~ViewTreeWalker} when only a part of {@link module:engine/view/text~ViewText} needs to be returned.
*
* `ViewTextProxy` has an API similar to {@link module:engine/view/text~ViewText Text} and allows to do most of the common tasks performed
* on view nodes.
*
* **Note:** Some `ViewTextProxy` instances may represent whole text node, not just a part of it.
* See {@link module:engine/view/textproxy~ViewTextProxy#isPartial}.
*
* **Note:** `ViewTextProxy` is a readonly interface.
*
* **Note:** `ViewTextProxy` instances are created on the fly basing
* on the current state of parent {@link module:engine/view/text~ViewText}.
* Because of this it is highly unrecommended to store references to `TextProxy instances because they might get
* invalidated due to operations on Document. Also ViewTextProxy is not a {@link module:engine/view/node~ViewNode} so it cannot be
* inserted as a child of {@link module:engine/view/element~ViewElement}.
*
* `ViewTextProxy` instances are created by {@link module:engine/view/treewalker~ViewTreeWalker view tree walker}.
* You should not need to create an instance of this class by your own.
*/ var $b9b9f2bdf9c6137f$export$b0e248170172f65f = class extends $b9b9f2bdf9c6137f$export$43d75c0e89b2169f {
    /**
	* Reference to the {@link module:engine/view/text~ViewText} element which ViewTextProxy is a substring.
	*/ textNode;
    /**
	* Text data represented by this text proxy.
	*/ data;
    /**
	* Offset in the `textNode` where this `ViewTextProxy` instance starts.
	*/ offsetInText;
    /**
	* Creates a text proxy.
	*
	* @internal
	* @param textNode Text node which part is represented by this text proxy.
	* @param offsetInText Offset in {@link module:engine/view/textproxy~ViewTextProxy#textNode text node}
	* from which the text proxy starts.
	* @param length Text proxy length, that is how many text node's characters, starting from `offsetInText` it represents.
	*/ constructor(textNode, offsetInText, length){
        super();
        this.textNode = textNode;
        if (offsetInText < 0 || offsetInText > textNode.data.length) /**
		* Given offsetInText value is incorrect.
		*
		* @error view-textproxy-wrong-offsetintext
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-textproxy-wrong-offsetintext", this);
        if (length < 0 || offsetInText + length > textNode.data.length) /**
		* Given length value is incorrect.
		*
		* @error view-textproxy-wrong-length
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-textproxy-wrong-length", this);
        this.data = textNode.data.substring(offsetInText, offsetInText + length);
        this.offsetInText = offsetInText;
    }
    /**
	* Offset size of this node.
	*/ get offsetSize() {
        return this.data.length;
    }
    /**
	* Flag indicating whether `ViewTextProxy` instance covers only part of the original {@link module:engine/view/text~ViewText text node}
	* (`true`) or the whole text node (`false`).
	*
	* This is `false` when text proxy starts at the very beginning of {@link module:engine/view/textproxy~ViewTextProxy#textNode textNode}
	* ({@link module:engine/view/textproxy~ViewTextProxy#offsetInText offsetInText} equals `0`) and text proxy sizes is equal to
	* text node size.
	*/ get isPartial() {
        return this.data.length !== this.textNode.data.length;
    }
    /**
	* Parent of this text proxy, which is same as parent of text node represented by this text proxy.
	*/ get parent() {
        return this.textNode.parent;
    }
    /**
	* Root of this text proxy, which is same as root of text node represented by this text proxy.
	*/ get root() {
        return this.textNode.root;
    }
    /**
	* {@link module:engine/view/document~ViewDocument View document} that owns this text proxy, or `null` if the text proxy is inside
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}.
	*/ get document() {
        return this.textNode.document;
    }
    /**
	* Returns ancestors array of this text proxy.
	*
	* @param options Options object.
	* @param options.includeSelf When set to `true`, textNode will be also included in parent's array.
	* @param options.parentFirst When set to `true`, array will be sorted from text proxy parent to
	* root element, otherwise root element will be the first item in the array.
	* @returns Array with ancestors.
	*/ getAncestors(options = {}) {
        const ancestors = [];
        let parent = options.includeSelf ? this.textNode : this.parent;
        while(parent !== null){
            ancestors[options.parentFirst ? "push" : "unshift"](parent);
            parent = parent.parent;
        }
        return ancestors;
    }
};
$b9b9f2bdf9c6137f$export$b0e248170172f65f.prototype.is = function(type) {
    return type === "$textProxy" || type === "view:$textProxy" || type === "textProxy" || type === "view:textProxy";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/viewconsumable
*/ /**
* Class used for handling consumption of view {@link module:engine/view/element~ViewElement elements},
* {@link module:engine/view/text~ViewText text nodes} and
* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragments}.
* Element's name and its parts (attributes, classes and styles) can be consumed separately. Consuming an element's name
* does not consume its attributes, classes and styles.
* To add items for consumption use {@link module:engine/conversion/viewconsumable~ViewConsumable#add add method}.
* To test items use {@link module:engine/conversion/viewconsumable~ViewConsumable#test test method}.
* To consume items use {@link module:engine/conversion/viewconsumable~ViewConsumable#consume consume method}.
* To revert already consumed items use {@link module:engine/conversion/viewconsumable~ViewConsumable#revert revert method}.
*
* ```ts
* viewConsumable.add( element, { name: true } ); // Adds element's name as ready to be consumed.
* viewConsumable.add( textNode ); // Adds text node for consumption.
* viewConsumable.add( docFragment ); // Adds document fragment for consumption.
* viewConsumable.test( element, { name: true }  ); // Tests if element's name can be consumed.
* viewConsumable.test( textNode ); // Tests if text node can be consumed.
* viewConsumable.test( docFragment ); // Tests if document fragment can be consumed.
* viewConsumable.consume( element, { name: true }  ); // Consume element's name.
* viewConsumable.consume( textNode ); // Consume text node.
* viewConsumable.consume( docFragment ); // Consume document fragment.
* viewConsumable.revert( element, { name: true }  ); // Revert already consumed element's name.
* viewConsumable.revert( textNode ); // Revert already consumed text node.
* viewConsumable.revert( docFragment ); // Revert already consumed document fragment.
* ```
*/ var $b9b9f2bdf9c6137f$export$39363727173f953f = class ViewConsumable {
    /**
	* Map of consumable elements. If {@link module:engine/view/element~ViewElement element} is used as a key,
	* {@link module:engine/conversion/viewconsumable~ViewElementConsumables ViewElementConsumables} instance is stored as value.
	* For {@link module:engine/view/text~ViewText text nodes} and
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragments} boolean value is stored as value.
	*/ _consumables = /* @__PURE__ */ new Map();
    /**
	* Adds view {@link module:engine/view/element~ViewElement element}, {@link module:engine/view/text~ViewText text node} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment} as ready to be consumed.
	*
	* ```ts
	* viewConsumable.add( p, { name: true } ); // Adds element's name to consume.
	* viewConsumable.add( p, { attributes: 'name' } ); // Adds element's attribute.
	* viewConsumable.add( p, { classes: 'foobar' } ); // Adds element's class.
	* viewConsumable.add( p, { styles: 'color' } ); // Adds element's style
	* viewConsumable.add( p, { attributes: 'name', styles: 'color' } ); // Adds attribute and style.
	* viewConsumable.add( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be provided.
	* viewConsumable.add( textNode ); // Adds text node to consume.
	* viewConsumable.add( docFragment ); // Adds document fragment to consume.
	* ```
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `viewconsumable-invalid-attribute` when `class` or `style`
	* attribute is provided - it should be handled separately by providing actual style/class.
	*
	* ```ts
	* viewConsumable.add( p, { attributes: 'style' } ); // This call will throw an exception.
	* viewConsumable.add( p, { styles: 'color' } ); // This is properly handled style.
	* ```
	*
	* @param consumables Used only if first parameter is {@link module:engine/view/element~ViewElement view element} instance.
	* @param consumables.name If set to true element's name will be included.
	* @param consumables.attributes Attribute name or array of attribute names.
	* @param consumables.classes Class name or array of class names.
	* @param consumables.styles Style name or array of style names.
	*/ add(element, consumables) {
        let elementConsumables;
        if (element.is("$text") || element.is("documentFragment")) {
            this._consumables.set(element, true);
            return;
        }
        if (!this._consumables.has(element)) {
            elementConsumables = new $b9b9f2bdf9c6137f$export$b2fb9823e1a70af4(element);
            this._consumables.set(element, elementConsumables);
        } else elementConsumables = this._consumables.get(element);
        elementConsumables.add(consumables ? $b9b9f2bdf9c6137f$export$503a4f588dd9f576(consumables) : element._getConsumables());
    }
    /**
	* Tests if {@link module:engine/view/element~ViewElement view element}, {@link module:engine/view/text~ViewText text node} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment} can be consumed.
	* It returns `true` when all items included in method's call can be consumed. Returns `false` when
	* first already consumed item is found and `null` when first non-consumable item is found.
	*
	* ```ts
	* viewConsumable.test( p, { name: true } ); // Tests element's name.
	* viewConsumable.test( p, { attributes: 'name' } ); // Tests attribute.
	* viewConsumable.test( p, { classes: 'foobar' } ); // Tests class.
	* viewConsumable.test( p, { styles: 'color' } ); // Tests style.
	* viewConsumable.test( p, { attributes: 'name', styles: 'color' } ); // Tests attribute and style.
	* viewConsumable.test( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be tested.
	* viewConsumable.test( textNode ); // Tests text node.
	* viewConsumable.test( docFragment ); // Tests document fragment.
	* ```
	*
	* Testing classes and styles as attribute will test if all added classes/styles can be consumed.
	*
	* ```ts
	* viewConsumable.test( p, { attributes: 'class' } ); // Tests if all added classes can be consumed.
	* viewConsumable.test( p, { attributes: 'style' } ); // Tests if all added styles can be consumed.
	* ```
	*
	* @param consumables Used only if first parameter is {@link module:engine/view/element~ViewElement view element} instance.
	* @param consumables.name If set to true element's name will be included.
	* @param consumables.attributes Attribute name or array of attribute names.
	* @param consumables.classes Class name or array of class names.
	* @param consumables.styles Style name or array of style names.
	* @returns Returns `true` when all items included in method's call can be consumed. Returns `false`
	* when first already consumed item is found and `null` when first non-consumable item is found.
	*/ test(element, consumables) {
        const elementConsumables = this._consumables.get(element);
        if (elementConsumables === void 0) return null;
        if (element.is("$text") || element.is("documentFragment")) return elementConsumables;
        return elementConsumables.test($b9b9f2bdf9c6137f$export$503a4f588dd9f576(consumables));
    }
    /**
	* Consumes {@link module:engine/view/element~ViewElement view element}, {@link module:engine/view/text~ViewText text node} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}.
	* It returns `true` when all items included in method's call can be consumed, otherwise returns `false`.
	*
	* ```ts
	* viewConsumable.consume( p, { name: true } ); // Consumes element's name.
	* viewConsumable.consume( p, { attributes: 'name' } ); // Consumes element's attribute.
	* viewConsumable.consume( p, { classes: 'foobar' } ); // Consumes element's class.
	* viewConsumable.consume( p, { styles: 'color' } ); // Consumes element's style.
	* viewConsumable.consume( p, { attributes: 'name', styles: 'color' } ); // Consumes attribute and style.
	* viewConsumable.consume( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be consumed.
	* viewConsumable.consume( textNode ); // Consumes text node.
	* viewConsumable.consume( docFragment ); // Consumes document fragment.
	* ```
	*
	* Consuming classes and styles as attribute will test if all added classes/styles can be consumed.
	*
	* ```ts
	* viewConsumable.consume( p, { attributes: 'class' } ); // Consume only if all added classes can be consumed.
	* viewConsumable.consume( p, { attributes: 'style' } ); // Consume only if all added styles can be consumed.
	* ```
	*
	* @param consumables Used only if first parameter is {@link module:engine/view/element~ViewElement view element} instance.
	* @param consumables.name If set to true element's name will be included.
	* @param consumables.attributes Attribute name or array of attribute names.
	* @param consumables.classes Class name or array of class names.
	* @param consumables.styles Style name or array of style names.
	* @returns Returns `true` when all items included in method's call can be consumed,
	* otherwise returns `false`.
	*/ consume(element, consumables) {
        if (element.is("$text") || element.is("documentFragment")) {
            if (!this.test(element, consumables)) return false;
            this._consumables.set(element, false);
            return true;
        }
        const elementConsumables = this._consumables.get(element);
        if (elementConsumables === void 0) return false;
        return elementConsumables.consume($b9b9f2bdf9c6137f$export$503a4f588dd9f576(consumables));
    }
    /**
	* Reverts {@link module:engine/view/element~ViewElement view element}, {@link module:engine/view/text~ViewText text node} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment} so they can be consumed once again.
	* Method does not revert items that were never previously added for consumption, even if they are included in
	* method's call.
	*
	* ```ts
	* viewConsumable.revert( p, { name: true } ); // Reverts element's name.
	* viewConsumable.revert( p, { attributes: 'name' } ); // Reverts element's attribute.
	* viewConsumable.revert( p, { classes: 'foobar' } ); // Reverts element's class.
	* viewConsumable.revert( p, { styles: 'color' } ); // Reverts element's style.
	* viewConsumable.revert( p, { attributes: 'name', styles: 'color' } ); // Reverts attribute and style.
	* viewConsumable.revert( p, { classes: [ 'baz', 'bar' ] } ); // Multiple names can be reverted.
	* viewConsumable.revert( textNode ); // Reverts text node.
	* viewConsumable.revert( docFragment ); // Reverts document fragment.
	* ```
	*
	* Reverting classes and styles as attribute will revert all classes/styles that were previously added for
	* consumption.
	*
	* ```ts
	* viewConsumable.revert( p, { attributes: 'class' } ); // Reverts all classes added for consumption.
	* viewConsumable.revert( p, { attributes: 'style' } ); // Reverts all styles added for consumption.
	* ```
	*
	* @param consumables Used only if first parameter is {@link module:engine/view/element~ViewElement view element} instance.
	* @param consumables.name If set to true element's name will be included.
	* @param consumables.attributes Attribute name or array of attribute names.
	* @param consumables.classes Class name or array of class names.
	* @param consumables.styles Style name or array of style names.
	*/ revert(element, consumables) {
        const elementConsumables = this._consumables.get(element);
        if (elementConsumables !== void 0) {
            if (element.is("$text") || element.is("documentFragment")) this._consumables.set(element, true);
            else elementConsumables.revert($b9b9f2bdf9c6137f$export$503a4f588dd9f576(consumables));
        }
    }
    /**
	* Creates {@link module:engine/conversion/viewconsumable~ViewConsumable ViewConsumable} instance from
	* {@link module:engine/view/node~ViewNode node} or {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}.
	* Instance will contain all elements, child nodes, attributes, styles and classes added for consumption.
	*
	* @param from View node or document fragment from which `ViewConsumable` will be created.
	* @param instance If provided, given `ViewConsumable` instance will be used
	* to add all consumables. It will be returned instead of a new instance.
	*/ static createFrom(from, instance) {
        if (!instance) instance = new ViewConsumable();
        if (from.is("$text")) instance.add(from);
        else if (from.is("element") || from.is("documentFragment")) {
            instance.add(from);
            for (const child of from.getChildren())ViewConsumable.createFrom(child, instance);
        }
        return instance;
    }
};
/**
* This is a private helper-class for {@link module:engine/conversion/viewconsumable~ViewConsumable}.
* It represents and manipulates consumable parts of a single {@link module:engine/view/element~ViewElement}.
*
* @internal
*/ var $b9b9f2bdf9c6137f$export$b2fb9823e1a70af4 = class {
    element;
    /**
	* Flag indicating if name of the element can be consumed.
	*/ _canConsumeName = null;
    /**
	* A map of element's consumables.
	* * For plain attributes the value is a boolean indicating whether the attribute is available to consume.
	* * For token based attributes (like class list and style) the value is a map of tokens to booleans
	* indicating whether the token is available to consume on the given attribute.
	*/ _attributes = /* @__PURE__ */ new Map();
    /**
	* Creates ViewElementConsumables instance.
	*
	* @param from View element from which `ViewElementConsumables` is being created.
	*/ constructor(from){
        this.element = from;
    }
    /**
	* Adds consumable parts of the {@link module:engine/view/element~ViewElement view element}.
	* Element's name itself can be marked to be consumed (when element's name is consumed its attributes, classes and
	* styles still could be consumed):
	*
	* ```ts
	* consumables.add( { name: true } );
	* ```
	*
	* Attributes classes and styles:
	*
	* ```ts
	* consumables.add( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color'] ] } );
	* consumables.add( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
	* ```
	*
	* Note: This method accepts only {@link module:engine/view/element~ViewNormalizedConsumables}.
	* You can use {@link module:engine/conversion/viewconsumable~normalizeConsumables} helper to convert from
	* {@link module:engine/conversion/viewconsumable~Consumables} to `ViewNormalizedConsumables`.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `viewconsumable-invalid-attribute` when `class` or `style`
	* attribute is provided - it should be handled separately by providing `style` and `class` in consumables object.
	*
	* @param consumables Object describing which parts of the element can be consumed.
	*/ add(consumables) {
        if (consumables.name) this._canConsumeName = true;
        for (const [name, token] of consumables.attributes)if (token) {
            let attributeTokens = this._attributes.get(name);
            if (!attributeTokens || typeof attributeTokens == "boolean") {
                attributeTokens = /* @__PURE__ */ new Map();
                this._attributes.set(name, attributeTokens);
            }
            attributeTokens.set(token, true);
        } else if (name == "style" || name == "class") /**
		* Class and style attributes should be handled separately in
		* {@link module:engine/conversion/viewconsumable~ViewConsumable#add `ViewConsumable#add()`}.
		*
		* What you have done is trying to use:
		*
		* ```ts
		* consumables.add( { attributes: [ 'class', 'style' ] } );
		* ```
		*
		* While each class and style should be registered separately:
		*
		* ```ts
		* consumables.add( { classes: 'some-class', styles: 'font-weight' } );
		* ```
		*
		* @error viewconsumable-invalid-attribute
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("viewconsumable-invalid-attribute", this);
        else this._attributes.set(name, true);
    }
    /**
	* Tests if parts of the {@link module:engine/view/element~ViewElement view element} can be consumed.
	*
	* Element's name can be tested:
	*
	* ```ts
	* consumables.test( { name: true } );
	* ```
	*
	* Attributes classes and styles:
	*
	* ```ts
	* consumables.test( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
	* consumables.test( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
	* ```
	*
	* @param consumables Object describing which parts of the element should be tested.
	* @returns `true` when all tested items can be consumed, `null` when even one of the items
	* was never marked for consumption and `false` when even one of the items was already consumed.
	*/ test(consumables) {
        if (consumables.name && !this._canConsumeName) return this._canConsumeName;
        for (const [name, token] of consumables.attributes){
            const value = this._attributes.get(name);
            if (value === void 0) return null;
            if (value === false) return false;
            if (value === true) continue;
            if (!token) {
                for (const tokenValue of value.values())if (!tokenValue) return false;
            } else {
                const tokenValue = value.get(token);
                if (tokenValue === void 0) return null;
                if (!tokenValue) return false;
            }
        }
        return true;
    }
    /**
	* Tests if parts of the {@link module:engine/view/element~ViewElement view element} can be consumed and consumes them if available.
	* It returns `true` when all items included in method's call can be consumed, otherwise returns `false`.
	*
	* Element's name can be consumed:
	*
	* ```ts
	* consumables.consume( { name: true } );
	* ```
	*
	* Attributes classes and styles:
	*
	* ```ts
	* consumables.consume( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
	* consumables.consume( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
	* ```
	*
	* @param consumables Object describing which parts of the element should be consumed.
	* @returns `true` when all tested items can be consumed and `false` when even one of the items could not be consumed.
	*/ consume(consumables) {
        if (!this.test(consumables)) return false;
        if (consumables.name) this._canConsumeName = false;
        for (const [name, token] of consumables.attributes){
            const value = this._attributes.get(name);
            if (typeof value == "boolean") for (const [toConsume] of this.element._getConsumables(name, token).attributes)this._attributes.set(toConsume, false);
            else if (!token) for (const token of value.keys())value.set(token, false);
            else for (const [, toConsume] of this.element._getConsumables(name, token).attributes)value.set(toConsume, false);
        }
        return true;
    }
    /**
	* Revert already consumed parts of {@link module:engine/view/element~ViewElement view Element}, so they can be consumed once again.
	* Element's name can be reverted:
	*
	* ```ts
	* consumables.revert( { name: true } );
	* ```
	*
	* Attributes classes and styles:
	*
	* ```ts
	* consumables.revert( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
	* consumables.revert( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
	* ```
	*
	* @param consumables Object describing which parts of the element should be reverted.
	*/ revert(consumables) {
        if (consumables.name) this._canConsumeName = true;
        for (const [name, token] of consumables.attributes){
            const value = this._attributes.get(name);
            if (value === false) {
                this._attributes.set(name, true);
                continue;
            }
            if (value === void 0 || value === true) continue;
            if (!token) for (const token of value.keys())value.set(token, true);
            else if (value.get(token) === false) value.set(token, true);
        }
    }
};
/**
* Normalizes a {@link module:engine/conversion/viewconsumable~Consumables} or {@link module:engine/view/matcher~Match}
* to a {@link module:engine/view/element~ViewNormalizedConsumables}.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$503a4f588dd9f576(consumables) {
    const attributes = [];
    if ("attributes" in consumables && consumables.attributes) $b9b9f2bdf9c6137f$var$normalizeConsumablePart(attributes, consumables.attributes);
    if ("classes" in consumables && consumables.classes) $b9b9f2bdf9c6137f$var$normalizeConsumablePart(attributes, consumables.classes, "class");
    if ("styles" in consumables && consumables.styles) $b9b9f2bdf9c6137f$var$normalizeConsumablePart(attributes, consumables.styles, "style");
    return {
        name: consumables.name || false,
        attributes: attributes
    };
}
/**
* Normalizes a list of consumable attributes to a common tuple format.
*/ function $b9b9f2bdf9c6137f$var$normalizeConsumablePart(attributes, items, prefix) {
    if (typeof items == "string") {
        attributes.push(prefix ? [
            prefix,
            items
        ] : [
            items
        ]);
        return;
    }
    for (const item of items)if (Array.isArray(item)) attributes.push(item);
    else attributes.push(prefix ? [
        prefix,
        item
    ] : [
        item
    ]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* View matcher class.
* Instance of this class can be used to find {@link module:engine/view/element~ViewElement elements} that match given pattern.
*/ var $b9b9f2bdf9c6137f$export$20214574ec94167d = class {
    _patterns = [];
    /**
	* Creates new instance of Matcher.
	*
	* @param pattern Match patterns. See {@link module:engine/view/matcher~Matcher#add add method} for more information.
	*/ constructor(...pattern){
        this.add(...pattern);
    }
    /**
	* Adds pattern or patterns to matcher instance.
	*
	* ```ts
	* // String.
	* matcher.add( 'div' );
	*
	* // Regular expression.
	* matcher.add( /^\w/ );
	*
	* // Single class.
	* matcher.add( {
	* 	classes: 'foobar'
	* } );
	* ```
	*
	* See {@link module:engine/view/matcher~MatcherPattern} for more examples.
	*
	* Multiple patterns can be added in one call:
	*
	* ```ts
	* matcher.add( 'div', { classes: 'foobar' } );
	* ```
	*
	* @param pattern Object describing pattern details. If string or regular expression
	* is provided it will be used to match element's name. Pattern can be also provided in a form
	* of a function - then this function will be called with each {@link module:engine/view/element~ViewElement element} as a parameter.
	* Function's return value will be stored under `match` key of the object returned from
	* {@link module:engine/view/matcher~Matcher#match match} or {@link module:engine/view/matcher~Matcher#matchAll matchAll} methods.
	*/ add(...pattern) {
        for (let item of pattern){
            if (typeof item == "string" || item instanceof RegExp) item = {
                name: item
            };
            this._patterns.push(item);
        }
    }
    /**
	* Matches elements for currently stored patterns. Returns match information about first found
	* {@link module:engine/view/element~ViewElement element}, otherwise returns `null`.
	*
	* Example of returned object:
	*
	* ```ts
	* {
	* 	element: <instance of found element>,
	* 	pattern: <pattern used to match found element>,
	* 	match: {
	* 		name: true,
	* 		attributes: [
	* 			[ 'title' ],
	* 			[ 'href' ],
	* 			[ 'class', 'foo' ],
	* 			[ 'style', 'color' ],
	* 			[ 'style', 'position' ]
	* 		]
	* 	}
	* }
	* ```
	*
	* You could use the `match` field from the above returned object as an input for the
	* {@link module:engine/conversion/viewconsumable~ViewConsumable#test `ViewConsumable#test()`} and
	* {@link module:engine/conversion/viewconsumable~ViewConsumable#consume `ViewConsumable#consume()`} methods.
	*
	* @see module:engine/view/matcher~Matcher#add
	* @see module:engine/view/matcher~Matcher#matchAll
	* @param element View element to match against stored patterns.
	* @returns The match information about found element or `null`.
	*/ match(...element) {
        for (const singleElement of element)for (const pattern of this._patterns){
            const match = this._isElementMatching(singleElement, pattern);
            if (match) return {
                element: singleElement,
                pattern: pattern,
                match: match
            };
        }
        return null;
    }
    /**
	* Matches elements for currently stored patterns. Returns array of match information with all found
	* {@link module:engine/view/element~ViewElement elements}. If no element is found - returns `null`.
	*
	* @see module:engine/view/matcher~Matcher#add
	* @see module:engine/view/matcher~Matcher#match
	* @param element View element to match against stored patterns.
	* @returns Array with match information about found elements or `null`. For more information
	* see {@link module:engine/view/matcher~Matcher#match match method} description.
	*/ matchAll(...element) {
        const results = [];
        for (const singleElement of element)for (const pattern of this._patterns){
            const match = this._isElementMatching(singleElement, pattern);
            if (match) results.push({
                element: singleElement,
                pattern: pattern,
                match: match
            });
        }
        return results.length > 0 ? results : null;
    }
    /**
	* Returns the name of the element to match if there is exactly one pattern added to the matcher instance
	* and it matches element name defined by `string` (not `RegExp`). Otherwise, returns `null`.
	*
	* @returns Element name trying to match.
	*/ getElementName() {
        if (this._patterns.length !== 1) return null;
        const pattern = this._patterns[0];
        const name = pattern.name;
        return typeof pattern != "function" && name && !(name instanceof RegExp) ? name : null;
    }
    /**
	* Returns match information if {@link module:engine/view/element~ViewElement element} is matching provided pattern.
	* If element cannot be matched to provided pattern - returns `null`.
	*
	* @returns Returns object with match information or null if element is not matching.
	*/ _isElementMatching(element, pattern) {
        if (typeof pattern == "function") {
            const match = pattern(element);
            if (!match || typeof match != "object") return match;
            return $b9b9f2bdf9c6137f$export$503a4f588dd9f576(match);
        }
        const match = {};
        if (pattern.name) {
            match.name = $b9b9f2bdf9c6137f$var$matchName(pattern.name, element.name);
            if (!match.name) return null;
        }
        const attributesMatch = [];
        if (pattern.attributes && !$b9b9f2bdf9c6137f$var$matchAttributes(pattern.attributes, element, attributesMatch)) return null;
        if (pattern.classes && !$b9b9f2bdf9c6137f$var$matchClasses(pattern.classes, element, attributesMatch)) return null;
        if (pattern.styles && !$b9b9f2bdf9c6137f$var$matchStyles(pattern.styles, element, attributesMatch)) return null;
        if (attributesMatch.length) match.attributes = attributesMatch;
        return match;
    }
};
/**
* Returns true if the given `item` matches the pattern.
*
* @internal
* @param pattern A pattern representing a key/value we want to match.
* @param item An actual item key/value (e.g. `'src'`, `'background-color'`, `'ck-widget'`) we're testing against pattern.
*/ function $b9b9f2bdf9c6137f$export$c777eb411bac515(pattern, item) {
    return pattern === true || pattern === item || pattern instanceof RegExp && !!String(item).match(pattern);
}
/**
* Checks if name can be matched by provided pattern.
*
* @returns Returns `true` if name can be matched, `false` otherwise.
*/ function $b9b9f2bdf9c6137f$var$matchName(pattern, name) {
    if (pattern instanceof RegExp) return !!name.match(pattern);
    return pattern === name;
}
/**
* Bring all the possible pattern forms to an array of tuples where first item is a key, second is a value,
* and third optional is a token value.
*
* Examples:
*
* Boolean pattern value:
*
* ```ts
* true
* ```
*
* to
*
* ```ts
* [ [ true, true ] ]
* ```
*
* Textual pattern value:
*
* ```ts
* 'attribute-name-or-class-or-style'
* ```
*
* to
*
* ```ts
* [ [ 'attribute-name-or-class-or-style', true ] ]
* ```
*
* Regular expression:
*
* ```ts
* /^data-.*$/
* ```
*
* to
*
* ```ts
* [ [ /^data-.*$/, true ] ]
* ```
*
* Objects (plain or with `key` and `value` specified explicitly):
*
* ```ts
* {
* 	src: /^https:.*$/
* }
* ```
*
* or
*
* ```ts
* [ {
* 	key: 'src',
* 	value: /^https:.*$/
* } ]
* ```
*
* to:
*
* ```ts
* [ [ 'src', /^https:.*$/ ] ]
* ```
*
* @returns Returns an array of objects or null if provided patterns were not in an expected form.
*/ function $b9b9f2bdf9c6137f$var$normalizePatterns(patterns, prefix) {
    if (Array.isArray(patterns)) return patterns.map((pattern)=>{
        if (typeof pattern !== "object" || pattern instanceof RegExp) return prefix ? [
            prefix,
            pattern,
            true
        ] : [
            pattern,
            true
        ];
        if (pattern.key === void 0 || pattern.value === void 0) (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("matcher-pattern-missing-key-or-value", pattern);
        return prefix ? [
            prefix,
            pattern.key,
            pattern.value
        ] : [
            pattern.key,
            pattern.value
        ];
    });
    if (typeof patterns !== "object" || patterns instanceof RegExp) return [
        prefix ? [
            prefix,
            patterns,
            true
        ] : [
            patterns,
            true
        ]
    ];
    const normalizedPatterns = [];
    for(const key in patterns)if (Object.prototype.hasOwnProperty.call(patterns, key)) normalizedPatterns.push(prefix ? [
        prefix,
        key,
        patterns[key]
    ] : [
        key,
        patterns[key]
    ]);
    return normalizedPatterns;
}
/**
* Checks if attributes of provided element can be matched against provided patterns.
*
* @param patterns Object with information about attributes to match. Each key of the object will be
* used as attribute name. Value of each key can be a string or regular expression to match against attribute value.
* @param  element Element which attributes will be tested.
* @param match An array to populate with matching tuples.
* @returns Returns array with matched attribute names or `null` if no attributes were matched.
*/ function $b9b9f2bdf9c6137f$var$matchAttributes(patterns, element, match) {
    let excludeAttributes;
    if (typeof patterns === "object" && !(patterns instanceof RegExp) && !Array.isArray(patterns)) {
        if (patterns.style !== void 0) (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("matcher-pattern-deprecated-attributes-style-key", patterns);
        if (patterns.class !== void 0) (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("matcher-pattern-deprecated-attributes-class-key", patterns);
    } else excludeAttributes = [
        "class",
        "style"
    ];
    return element._collectAttributesMatch($b9b9f2bdf9c6137f$var$normalizePatterns(patterns), match, excludeAttributes);
}
/**
* Checks if classes of provided element can be matched against provided patterns.
*
* @param patterns Array of strings or regular expressions to match against element's classes.
* @param element Element which classes will be tested.
* @param match An array to populate with matching tuples.
* @returns Returns array with matched class names or `null` if no classes were matched.
*/ function $b9b9f2bdf9c6137f$var$matchClasses(patterns, element, match) {
    return element._collectAttributesMatch($b9b9f2bdf9c6137f$var$normalizePatterns(patterns, "class"), match);
}
/**
* Checks if styles of provided element can be matched against provided patterns.
*
* @param patterns Object with information about styles to match. Each key of the object will be
* used as style name. Value of each key can be a string or regular expression to match against style value.
* @param element Element which styles will be tested.
* @param match An array to populate with matching tuples.
* @returns Returns array with matched style names or `null` if no styles were matched.
*/ function $b9b9f2bdf9c6137f$var$matchStyles(patterns, element, match) {
    return element._collectAttributesMatch($b9b9f2bdf9c6137f$var$normalizePatterns(patterns, "style"), match);
}
/**
* The key-value matcher pattern is missing key or value. Both must be present.
* Refer the documentation: {@link module:engine/view/matcher~MatcherPattern}.
*
* @param pattern Pattern with missing properties.
* @error matcher-pattern-missing-key-or-value
*/ /**
* The key-value matcher pattern for `attributes` option is using deprecated `style` key.
*
* Use `styles` matcher pattern option instead:
*
* ```ts
* // Instead of:
* const pattern = {
* 	attributes: {
* 		key1: 'value1',
* 		key2: 'value2',
* 		style: /^border.*$/
* 	}
* }
*
* // Use:
* const pattern = {
* 	attributes: {
* 		key1: 'value1',
* 		key2: 'value2'
* 	},
* 	styles: /^border.*$/
* }
* ```
*
* Refer to the `#update-to-ckeditor-5-v2910` section in the `Update to v29.x` section in the
* {@glink updating/guides/updating-from-older-versions updating from older versions} guide
* and {@link module:engine/view/matcher~MatcherPattern} documentation.
*
* @param pattern Pattern with missing properties.
* @error matcher-pattern-deprecated-attributes-style-key
*/ /**
* The key-value matcher pattern for `attributes` option is using deprecated `class` key.
*
* Use `classes` matcher pattern option instead:
*
* ```ts
* // Instead of:
* const pattern = {
* 	attributes: {
* 		key1: 'value1',
* 		key2: 'value2',
* 		class: 'foobar'
* 	}
* }
*
* // Use:
* const pattern = {
* 	attributes: {
* 		key1: 'value1',
* 		key2: 'value2'
* 	},
* 	classes: 'foobar'
* }
* ```
*
* Refer to the `#update-to-ckeditor-5-v2910` paragraph in the Update to v29.x guide in the
* {@glink updating/guides/updating-from-older-versions updating from older versions} guide
* and the {@link module:engine/view/matcher~MatcherPattern} documentation.
*
* @param pattern Pattern with missing properties.
* @error matcher-pattern-deprecated-attributes-class-key
*/ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/stylesmap
*/ /**
* Styles map. Allows handling (adding, removing, retrieving) a set of style rules (usually, of an element).
*/ var $b9b9f2bdf9c6137f$export$a256655bfa1a33f5 = class {
    /**
	* Keeps an internal representation of styles map. Normalized styles are kept as object tree to allow unified modification and
	* value access model using lodash's get, set, unset, etc methods.
	*
	* When no style processor rules are defined it acts as simple key-value storage.
	*/ _styles;
    /**
	* Cached list of style names for faster access.
	*/ _cachedStyleNames = null;
    /**
	* Cached list of expanded style names for faster access.
	*/ _cachedExpandedStyleNames = null;
    /**
	* An instance of the {@link module:engine/view/stylesmap~StylesProcessor}.
	*/ _styleProcessor;
    /**
	* Creates Styles instance.
	*/ constructor(styleProcessor){
        this._styles = {};
        this._styleProcessor = styleProcessor;
    }
    /**
	* Returns true if style map has no styles set.
	*/ get isEmpty() {
        return !Object.entries(this._styles).length;
    }
    /**
	* Number of styles defined.
	*/ get size() {
        if (this.isEmpty) return 0;
        return this.getStyleNames().length;
    }
    /**
	* Set styles map to a new value.
	*
	* ```ts
	* styles.setTo( 'border:1px solid blue;margin-top:1px;' );
	* ```
	*/ setTo(inlineStyle) {
        this.clear();
        const parsedStyles = $b9b9f2bdf9c6137f$var$parseInlineStyles(inlineStyle);
        for (const [key, value] of parsedStyles)this._styleProcessor.toNormalizedForm(key, value, this._styles);
        return this;
    }
    /**
	* Checks if a given style is set.
	*
	* ```ts
	* styles.setTo( 'margin-left:1px;' );
	*
	* styles.has( 'margin-left' );    // -> true
	* styles.has( 'padding' );        // -> false
	* ```
	*
	* **Note**: This check supports normalized style names.
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* styles.setTo( 'margin:2px;' );
	*
	* styles.has( 'margin' );         // -> true
	* styles.has( 'margin-top' );     // -> true
	* styles.has( 'margin-left' );    // -> true
	*
	* styles.remove( 'margin-top' );
	*
	* styles.has( 'margin' );         // -> false
	* styles.has( 'margin-top' );     // -> false
	* styles.has( 'margin-left' );    // -> true
	* ```
	*
	* @param name Style name.
	*/ has(name) {
        if (this.isEmpty) return false;
        const propertyDescriptor = this._styleProcessor.getReducedForm(name, this._styles).find(([property])=>property === name);
        return Array.isArray(propertyDescriptor);
    }
    set(nameOrObject, valueOrObject) {
        this._cachedStyleNames = null;
        this._cachedExpandedStyleNames = null;
        if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(nameOrObject)) for (const [key, value] of Object.entries(nameOrObject))this._styleProcessor.toNormalizedForm(key, value, this._styles);
        else this._styleProcessor.toNormalizedForm(nameOrObject, valueOrObject, this._styles);
    }
    /**
	* Removes given style.
	*
	* ```ts
	* styles.setTo( 'background:#f00;margin-right:2px;' );
	*
	* styles.remove( 'background' );
	*
	* styles.toString();   // -> 'margin-right:2px;'
	* ```
	*
	* ***Note**:* This method uses {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules
	* enabled style processor rules} to normalize passed values.
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* styles.setTo( 'margin:1px' );
	*
	* styles.remove( 'margin-top' );
	* styles.remove( 'margin-right' );
	*
	* styles.toString(); // -> 'margin-bottom:1px;margin-left:1px;'
	* ```
	*
	* @param names Style name or an array of names.
	*/ remove(names) {
        const normalizedStylesToRemove = {};
        for (const name of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(names)){
            const path = $b9b9f2bdf9c6137f$var$toPath(name);
            const pathValue = (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(this._styles, path);
            if (pathValue) $b9b9f2bdf9c6137f$var$appendStyleValue(normalizedStylesToRemove, path, pathValue);
            else {
                const value = this.getAsString(name);
                if (value !== void 0) this._styleProcessor.toNormalizedForm(name, value, normalizedStylesToRemove);
            }
        }
        if (Object.keys(normalizedStylesToRemove).length) {
            $b9b9f2bdf9c6137f$var$removeStyles(this._styles, normalizedStylesToRemove);
            this._cachedStyleNames = null;
            this._cachedExpandedStyleNames = null;
        }
    }
    /**
	* Returns a normalized style object or a single value.
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* const styles = new Styles();
	* styles.setTo( 'margin:1px 2px 3em;' );
	*
	* styles.getNormalized( 'margin' );
	* // will log:
	* // {
	* //     top: '1px',
	* //     right: '2px',
	* //     bottom: '3em',
	* //     left: '2px'     // normalized value from margin shorthand
	* // }
	*
	* styles.getNormalized( 'margin-left' ); // -> '2px'
	* ```
	*
	* **Note**: This method will only return normalized styles if a style processor was defined.
	*
	* @param name Style name.
	*/ getNormalized(name) {
        return this._styleProcessor.getNormalized(name, this._styles);
    }
    /**
	* Returns a normalized style string. Styles are sorted by name.
	*
	* ```ts
	* styles.set( 'margin' , '1px' );
	* styles.set( 'background', '#f00' );
	*
	* styles.toString(); // -> 'background:#f00;margin:1px;'
	* ```
	*
	* **Note**: This method supports normalized styles if defined.
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* styles.set( 'margin' , '1px' );
	* styles.set( 'background', '#f00' );
	* styles.remove( 'margin-top' );
	* styles.remove( 'margin-right' );
	*
	* styles.toString(); // -> 'background:#f00;margin-bottom:1px;margin-left:1px;'
	* ```
	*/ toString() {
        if (this.isEmpty) return "";
        return this.getStylesEntries().map((arr)=>arr.join(":")).sort().join(";") + ";";
    }
    /**
	* Returns property as a value string or undefined if property is not set.
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* const styles = new Styles();
	* styles.setTo( 'margin:1px;' );
	* styles.set( 'margin-bottom', '3em' );
	*
	* styles.getAsString( 'margin' ); // -> 'margin: 1px 1px 3em;'
	* ```
	*
	* Note, however, that all sub-values must be set for the longhand property name to return a value:
	*
	* ```ts
	* const styles = new Styles();
	* styles.setTo( 'margin:1px;' );
	* styles.remove( 'margin-bottom' );
	*
	* styles.getAsString( 'margin' ); // -> undefined
	* ```
	*
	* In the above scenario, it is not possible to return a `margin` value, so `undefined` is returned.
	* Instead, you should use:
	*
	* ```ts
	* const styles = new Styles();
	* styles.setTo( 'margin:1px;' );
	* styles.remove( 'margin-bottom' );
	*
	* for ( const styleName of styles.getStyleNames() ) {
	* 	console.log( styleName, styles.getAsString( styleName ) );
	* }
	* // 'margin-top', '1px'
	* // 'margin-right', '1px'
	* // 'margin-left', '1px'
	* ```
	*
	* In general, it is recommend to iterate over style names like in the example above. This way, you will always get all
	* the currently set style values. So, if all the 4 margin values would be set
	* the for-of loop above would yield only `'margin'`, `'1px'`:
	*
	* ```ts
	* const styles = new Styles();
	* styles.setTo( 'margin:1px;' );
	*
	* for ( const styleName of styles.getStyleNames() ) {
	* 	console.log( styleName, styles.getAsString( styleName ) );
	* }
	* // 'margin', '1px'
	* ```
	*
	* **Note**: To get a normalized version of a longhand property use the {@link #getNormalized `#getNormalized()`} method.
	*/ getAsString(propertyName) {
        if (this.isEmpty) return;
        if (this._styles[propertyName] && !(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(this._styles[propertyName])) return this._styles[propertyName];
        const propertyDescriptor = this._styleProcessor.getReducedForm(propertyName, this._styles).find(([property])=>property === propertyName);
        if (Array.isArray(propertyDescriptor)) return propertyDescriptor[1];
    }
    /**
	* Returns all style properties names as they would appear when using {@link #toString `#toString()`}.
	*
	* When `expand` is set to true and there's a shorthand style property set, it will also return all equivalent styles:
	*
	* ```ts
	* stylesMap.setTo( 'margin: 1em' )
	* ```
	*
	* will be expanded to:
	*
	* ```ts
	* [ 'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left' ]
	* ```
	*
	* @param expand Expand shorthand style properties and all return equivalent style representations.
	*/ getStyleNames(expand = false) {
        if (this.isEmpty) return [];
        if (expand) {
            this._cachedExpandedStyleNames ||= this._styleProcessor.getStyleNames(this._styles);
            return this._cachedExpandedStyleNames;
        }
        this._cachedStyleNames ||= this.getStylesEntries().map(([key])=>key);
        return this._cachedStyleNames;
    }
    /**
	* Alias for {@link #getStyleNames}.
	*/ keys() {
        return this.getStyleNames();
    }
    /**
	* Removes all styles.
	*/ clear() {
        this._styles = {};
        this._cachedStyleNames = null;
        this._cachedExpandedStyleNames = null;
    }
    /**
	* Returns `true` if both attributes have the same styles.
	*/ isSimilar(other) {
        if (this.size !== other.size) return false;
        for (const property of this.getStyleNames())if (!other.has(property) || other.getAsString(property) !== this.getAsString(property)) return false;
        return true;
    }
    /**
	* Returns normalized styles entries for further processing.
	*/ getStylesEntries() {
        const parsed = [];
        const keys = Object.keys(this._styles);
        for (const key of keys)parsed.push(...this._styleProcessor.getReducedForm(key, this._styles));
        return parsed;
    }
    /**
	* Clones the attribute value.
	*
	* @internal
	*/ _clone() {
        const clone = new this.constructor(this._styleProcessor);
        clone.set(this.getNormalized());
        return clone;
    }
    /**
	* Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching styles.
	*
	* @internal
	* @param tokenPattern The matched style name pattern.
	* @param valuePattern The matched style value pattern.
	* @returns An array of matching tokens (style names).
	*/ _getTokensMatch(tokenPattern, valuePattern) {
        const match = [];
        for (const styleName of this.getStyleNames(true))if ($b9b9f2bdf9c6137f$export$c777eb411bac515(tokenPattern, styleName)) {
            if (valuePattern === true) {
                match.push(styleName);
                continue;
            }
            const value = this.getAsString(styleName);
            if ($b9b9f2bdf9c6137f$export$c777eb411bac515(valuePattern, value)) match.push(styleName);
        }
        return match.length ? match : void 0;
    }
    /**
	* Returns a list of consumables for the attribute. This includes related styles.
	*
	* Could be filtered by the given style name.
	*
	* @internal
	*/ _getConsumables(name) {
        const result = [];
        if (name) {
            result.push(name);
            for (const relatedName of this._styleProcessor.getRelatedStyles(name))result.push(relatedName);
        } else for (const name of this.getStyleNames()){
            for (const relatedName of this._styleProcessor.getRelatedStyles(name))result.push(relatedName);
            result.push(name);
        }
        return result;
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_canMergeAttributesFrom} to verify if the given attribute can be merged without
	* conflicts into the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other ViewAttributeElement.
	*
	* @internal
	*/ _canMergeFrom(other) {
        for (const key of other.getStyleNames())if (this.has(key) && this.getAsString(key) !== other.getAsString(key)) return false;
        return true;
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_mergeAttributesFrom} to merge a given attribute into the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other ViewAttributeElement.
	*
	* @internal
	*/ _mergeFrom(other) {
        for (const prop of other.getStyleNames())if (!this.has(prop)) this.set(prop, other.getAsString(prop));
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_canSubtractAttributesOf} to verify if the given attribute can be fully
	* subtracted from the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to unwrap the ViewAttributeElement.
	*
	* @internal
	*/ _isMatching(other) {
        for (const key of other.getStyleNames())if (!this.has(key) || this.getAsString(key) !== other.getAsString(key)) return false;
        return true;
    }
};
/**
* Style processor is responsible for writing and reading a normalized styles object.
*/ var $b9b9f2bdf9c6137f$export$c3739f0469d36452 = class {
    _normalizers;
    _extractors;
    _reducers;
    _consumables;
    /**
	* Creates StylesProcessor instance.
	*
	* @internal
	*/ constructor(){
        this._normalizers = /* @__PURE__ */ new Map();
        this._extractors = /* @__PURE__ */ new Map();
        this._reducers = /* @__PURE__ */ new Map();
        this._consumables = /* @__PURE__ */ new Map();
    }
    /**
	* Parse style string value to a normalized object and appends it to styles object.
	*
	* ```ts
	* const styles = {};
	*
	* stylesProcessor.toNormalizedForm( 'margin', '1px', styles );
	*
	* // styles will consist: { margin: { top: '1px', right: '1px', bottom: '1px', left: '1px; } }
	* ```
	*
	* **Note**: To define normalizer callbacks use {@link #setNormalizer}.
	*
	* @param name Name of style property.
	* @param propertyValue Value of style property.
	* @param styles Object holding normalized styles.
	*/ toNormalizedForm(name, propertyValue, styles) {
        if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(propertyValue)) {
            $b9b9f2bdf9c6137f$var$appendStyleValue(styles, $b9b9f2bdf9c6137f$var$toPath(name), propertyValue);
            return;
        }
        if (this._normalizers.has(name)) {
            const { path: path, value: value } = this._normalizers.get(name)(propertyValue);
            $b9b9f2bdf9c6137f$var$appendStyleValue(styles, path, value);
        } else $b9b9f2bdf9c6137f$var$appendStyleValue(styles, name, propertyValue);
    }
    /**
	* Returns a normalized version of a style property.
	*
	* ```ts
	* const styles = {
	* 	margin: { top: '1px', right: '1px', bottom: '1px', left: '1px; },
	* 	background: { color: '#f00' }
	* };
	*
	* stylesProcessor.getNormalized( 'background' );
	* // will return: { color: '#f00' }
	*
	* stylesProcessor.getNormalized( 'margin-top' );
	* // will return: '1px'
	* ```
	*
	* **Note**: In some cases extracting single value requires defining an extractor callback {@link #setExtractor}.
	*
	* @param name Name of style property.
	* @param styles Object holding normalized styles.
	*/ getNormalized(name, styles) {
        if (!name) return (0, $b1d877320958e43c$export$4950aa0f605343fb)({}, styles);
        if (styles[name] !== void 0) return styles[name];
        if (this._extractors.has(name)) {
            const extractor = this._extractors.get(name);
            if (typeof extractor === "string") return (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(styles, extractor);
            const value = extractor(name, styles);
            if (value) return value;
        }
        return (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(styles, $b9b9f2bdf9c6137f$var$toPath(name));
    }
    /**
	* Returns a reduced form of style property form normalized object.
	*
	* For default margin reducer, the below code:
	*
	* ```ts
	* stylesProcessor.getReducedForm( 'margin', {
	* 	margin: { top: '1px', right: '1px', bottom: '2px', left: '1px; }
	* } );
	* ```
	*
	* will return:
	*
	* ```ts
	* [
	* 	[ 'margin', '1px 1px 2px' ]
	* ]
	* ```
	*
	* because it might be represented as a shorthand 'margin' value. However if one of margin long hand values is missing it should return:
	*
	* ```ts
	* [
	* 	[ 'margin-top', '1px' ],
	* 	[ 'margin-right', '1px' ],
	* 	[ 'margin-bottom', '2px' ]
	* 	// the 'left' value is missing - cannot use 'margin' shorthand.
	* ]
	* ```
	*
	* **Note**: To define reducer callbacks use {@link #setReducer}.
	*
	* @param name Name of style property.
	*/ getReducedForm(name, styles) {
        const normalizedValue = this.getNormalized(name, styles);
        if (normalizedValue === void 0) return [];
        if (this._reducers.has(name)) return this._reducers.get(name)(normalizedValue);
        return [
            [
                name,
                normalizedValue
            ]
        ];
    }
    /**
	* Return all style properties. Also expand shorthand properties (e.g. `margin`, `background`) if respective extractor is available.
	*
	* @param styles Object holding normalized styles.
	*/ getStyleNames(styles) {
        const styleNamesKeysSet = /* @__PURE__ */ new Set();
        for (const name of this._consumables.keys()){
            const style = this.getNormalized(name, styles);
            if (style && (typeof style != "object" || Object.keys(style).length)) styleNamesKeysSet.add(name);
        }
        for (const name of Object.keys(styles))styleNamesKeysSet.add(name);
        return Array.from(styleNamesKeysSet);
    }
    /**
	* Returns related style names.
	*
	* ```ts
	* stylesProcessor.getRelatedStyles( 'margin' );
	* // will return: [ 'margin-top', 'margin-right', 'margin-bottom', 'margin-left' ];
	*
	* stylesProcessor.getRelatedStyles( 'margin-top' );
	* // will return: [ 'margin' ];
	* ```
	*
	* **Note**: To define new style relations load an existing style processor or use
	* {@link module:engine/view/stylesmap~StylesProcessor#setStyleRelation `StylesProcessor.setStyleRelation()`}.
	*/ getRelatedStyles(name) {
        return this._consumables.get(name) || [];
    }
    /**
	* Adds a normalizer method for a style property.
	*
	* A normalizer returns describing how the value should be normalized.
	*
	* For instance 'margin' style is a shorthand for four margin values:
	*
	* - 'margin-top'
	* - 'margin-right'
	* - 'margin-bottom'
	* - 'margin-left'
	*
	* and can be written in various ways if some values are equal to others. For instance `'margin: 1px 2em;'` is a shorthand for
	* `'margin-top: 1px;margin-right: 2em;margin-bottom: 1px;margin-left: 2em'`.
	*
	* A normalizer should parse various margin notations as a single object:
	*
	* ```ts
	* const styles = {
	* 	margin: {
	* 		top: '1px',
	* 		right: '2em',
	* 		bottom: '1px',
	* 		left: '2em'
	* 	}
	* };
	* ```
	*
	* Thus a normalizer for 'margin' style should return an object defining style path and value to store:
	*
	* ```ts
	* const returnValue = {
	* 	path: 'margin',
	* 	value: {
	* 		top: '1px',
	* 		right: '2em',
	* 		bottom: '1px',
	* 		left: '2em'
	* 	}
	* };
	* ```
	*
	* Additionally to fully support all margin notations there should be also defined 4 normalizers for longhand margin notations. Below
	* is an example for 'margin-top' style property normalizer:
	*
	* ```ts
	* stylesProcessor.setNormalizer( 'margin-top', valueString => {
	* 	return {
	* 		path: 'margin.top',
	* 		value: valueString
	* 	}
	* } );
	* ```
	*/ setNormalizer(name, callback) {
        this._normalizers.set(name, callback);
    }
    /**
	* Adds a extractor callback for a style property.
	*
	* Most normalized style values are stored as one level objects. It is assumed that `'margin-top'` style will be stored as:
	*
	* ```ts
	* const styles = {
	* 	margin: {
	* 		top: 'value'
	* 	}
	* }
	* ```
	*
	* However, some styles can have conflicting notations and thus it might be harder to extract a style value from shorthand. For instance
	* the 'border-top-style' can be defined using `'border-top:solid'`, `'border-style:solid none none none'` or by `'border:solid'`
	* shorthands. The default border styles processors stores styles as:
	*
	* ```ts
	* const styles = {
	* 	border: {
	* 		style: {
	* 			top: 'solid'
	* 		}
	* 	}
	* }
	* ```
	*
	* as it is better to modify border style independently from other values. On the other part the output of the border might be
	* desired as `border-top`, `border-left`, etc notation.
	*
	* In the above example an extractor should return a side border value that combines style, color and width:
	*
	* ```ts
	* styleProcessor.setExtractor( 'border-top', styles => {
	* 	return {
	* 		color: styles.border.color.top,
	* 		style: styles.border.style.top,
	* 		width: styles.border.width.top
	* 	}
	* } );
	* ```
	*
	* @param callbackOrPath Callback that return a requested value or path string for single values.
	*/ setExtractor(name, callbackOrPath) {
        this._extractors.set(name, callbackOrPath);
    }
    /**
	* Adds a reducer callback for a style property.
	*
	* Reducer returns a minimal notation for given style name. For longhand properties it is not required to write a reducer as
	* by default the direct value from style path is taken.
	*
	* For shorthand styles a reducer should return minimal style notation either by returning single name-value tuple or multiple tuples
	* if a shorthand cannot be used. For instance for a margin shorthand a reducer might return:
	*
	* ```ts
	* const marginShortHandTuple = [
	* 	[ 'margin', '1px 1px 2px' ]
	* ];
	* ```
	*
	* or a longhand tuples for defined values:
	*
	* ```ts
	* // Considering margin.bottom and margin.left are undefined.
	* const marginLonghandsTuples = [
	* 	[ 'margin-top', '1px' ],
	* 	[ 'margin-right', '1px' ]
	* ];
	* ```
	*
	* A reducer obtains a normalized style value:
	*
	* ```ts
	* // Simplified reducer that always outputs 4 values which are always present:
	* stylesProcessor.setReducer( 'margin', margin => {
	* 	return [
	* 		[ 'margin', `${ margin.top } ${ margin.right } ${ margin.bottom } ${ margin.left }` ]
	* 	]
	* } );
	* ```
	*/ setReducer(name, callback) {
        this._reducers.set(name, callback);
    }
    /**
	* Defines a style shorthand relation to other style notations.
	*
	* ```ts
	* stylesProcessor.setStyleRelation( 'margin', [
	* 	'margin-top',
	* 	'margin-right',
	* 	'margin-bottom',
	* 	'margin-left'
	* ] );
	* ```
	*
	* This enables expanding of style names for shorthands. For instance, if defined,
	* {@link module:engine/conversion/viewconsumable~ViewConsumable view consumable} items are automatically created
	* for long-hand margin style notation alongside the `'margin'` item.
	*
	* This means that when an element being converted has a style `margin`, a converter for `margin-left` will work just
	* fine since the view consumable will contain a consumable `margin-left` item (thanks to the relation) and
	* `element.getStyle( 'margin-left' )` will work as well assuming that the style processor was correctly configured.
	* However, once `margin-left` is consumed, `margin` will not be consumable anymore.
	*/ setStyleRelation(shorthandName, styleNames) {
        this._mapStyleNames(shorthandName, styleNames);
        for (const alsoName of styleNames)this._mapStyleNames(alsoName, [
            shorthandName
        ]);
    }
    /**
	* Set two-way binding of style names.
	*/ _mapStyleNames(name, styleNames) {
        if (!this._consumables.has(name)) this._consumables.set(name, []);
        this._consumables.get(name).push(...styleNames);
    }
};
/**
* Parses inline styles and puts property - value pairs into styles map.
*
* @param stylesString Styles to parse.
* @returns Map of parsed properties and values.
*/ function $b9b9f2bdf9c6137f$var$parseInlineStyles(stylesString) {
    let quoteType = null;
    let propertyNameStart = 0;
    let propertyValueStart = 0;
    let propertyName = null;
    const stylesMap = /* @__PURE__ */ new Map();
    if (stylesString === "") return stylesMap;
    if (stylesString.charAt(stylesString.length - 1) != ";") stylesString = stylesString + ";";
    for(let i = 0; i < stylesString.length; i++){
        const char = stylesString.charAt(i);
        if (quoteType === null) switch(char){
            case ":":
                if (!propertyName) {
                    propertyName = stylesString.substr(propertyNameStart, i - propertyNameStart);
                    propertyValueStart = i + 1;
                }
                break;
            case "\"":
            case "'":
                quoteType = char;
                break;
            case ";":
                {
                    const propertyValue = stylesString.substr(propertyValueStart, i - propertyValueStart);
                    if (propertyName) stylesMap.set(propertyName.trim(), propertyValue.trim());
                    propertyName = null;
                    propertyNameStart = i + 1;
                    break;
                }
        }
        else if (char === quoteType) quoteType = null;
    }
    return stylesMap;
}
/**
* Return lodash compatible path from style name.
*/ function $b9b9f2bdf9c6137f$var$toPath(name) {
    return name.replace("-", ".");
}
/**
* Appends style definition to the styles object.
*/ function $b9b9f2bdf9c6137f$var$appendStyleValue(stylesObject, nameOrPath, valueOrObject) {
    let valueToSet = valueOrObject;
    if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(valueOrObject) && !Array.isArray(valueOrObject)) valueToSet = (0, $b1d877320958e43c$export$4950aa0f605343fb)({}, (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(stylesObject, nameOrPath), valueOrObject);
    (0, $56bb5d9ef9e7bd30$export$adaa4cf7ef1b65be)(stylesObject, nameOrPath, valueToSet);
}
/**
* Modifies the `styles` deeply nested object by removing properties defined in `toRemove`.
*/ function $b9b9f2bdf9c6137f$var$removeStyles(styles, toRemove) {
    for (const key of Object.keys(toRemove))if (styles[key] !== null && !Array.isArray(styles[key]) && typeof styles[key] == "object" && typeof toRemove[key] == "object") {
        $b9b9f2bdf9c6137f$var$removeStyles(styles[key], toRemove[key]);
        if (!Object.keys(styles[key]).length) delete styles[key];
    } else delete styles[key];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/tokenlist
*/ /**
* Token list. Allows handling (adding, removing, retrieving) a set of tokens (for example class names).
*/ var $b9b9f2bdf9c6137f$export$7233f0a9cd429212 = class {
    /**
	* The set of tokens.
	*/ _set = /* @__PURE__ */ new Set();
    /**
	* Returns true if token list has no tokens set.
	*/ get isEmpty() {
        return this._set.size == 0;
    }
    /**
	* Number of tokens.
	*/ get size() {
        return this._set.size;
    }
    /**
	* Checks if a given token is set.
	*/ has(name) {
        return this._set.has(name);
    }
    /**
	* Returns all tokens.
	*/ keys() {
        return Array.from(this._set.keys());
    }
    /**
	* Resets the value to the given one.
	*/ setTo(value) {
        this.clear();
        for (const token of value.split(/\s+/))if (token) this._set.add(token);
        return this;
    }
    /**
	* Sets a given token without affecting other tokens.
	*/ set(tokens) {
        for (const token of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(tokens))if (token) this._set.add(token);
    }
    /**
	* Removes given token.
	*/ remove(tokens) {
        for (const token of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(tokens))this._set.delete(token);
    }
    /**
	* Removes all tokens.
	*/ clear() {
        this._set.clear();
    }
    /**
	* Returns a normalized tokens string.
	*/ toString() {
        return Array.from(this._set).join(" ");
    }
    /**
	* Returns `true` if both attributes have the same tokens.
	*/ isSimilar(other) {
        if (this.size !== other.size) return false;
        for (const token of this.keys())if (!other.has(token)) return false;
        return true;
    }
    /**
	* Clones the attribute value.
	*
	* @internal
	*/ _clone() {
        const clone = new this.constructor();
        clone._set = new Set(this._set);
        return clone;
    }
    /**
	* Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching attribute tokens.
	*
	* @internal
	* @param tokenPattern The matched token name pattern.
	* @returns An array of matching tokens.
	*/ _getTokensMatch(tokenPattern) {
        const match = [];
        if (tokenPattern === true) {
            for (const token of this._set.keys())match.push(token);
            return match;
        }
        if (typeof tokenPattern == "string") {
            for (const token of tokenPattern.split(/\s+/))if (this._set.has(token)) match.push(token);
            else return;
            return match;
        }
        for (const token of this._set.keys())if (token.match(tokenPattern)) match.push(token);
        return match.length ? match : void 0;
    }
    /**
	* Returns a list of consumables for the attribute.
	*
	* Could be filtered by the given token name.
	*
	* @internal
	*/ _getConsumables(name) {
        return name ? [
            name
        ] : this.keys();
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_canMergeAttributesFrom} to verify if the given attribute
	* can be merged without conflicts into the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while downcasting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other `AttributeElement`.
	*
	* @internal
	*/ _canMergeFrom() {
        return true;
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_mergeAttributesFrom} to merge a given attribute into the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other ViewAttributeElement.
	*
	* @internal
	*/ _mergeFrom(other) {
        for (const token of other._set.keys())if (!this._set.has(token)) this._set.add(token);
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_canSubtractAttributesOf} to verify if the given attribute
	* can be fully subtracted from the attribute.
	*
	* This method is indirectly used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to unwrap the ViewAttributeElement.
	*
	* @internal
	*/ _isMatching(other) {
        for (const name of other._set.keys())if (!this._set.has(name)) return false;
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/element
*/ /**
* View element.
*
* The editing engine does not define a fixed semantics of its elements (it is "DTD-free").
* This is why the type of the {@link module:engine/view/element~ViewElement} need to
* be defined by the feature developer. When creating an element you should use one of the following methods:
*
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#createContainerElement `downcastWriter#createContainerElement()`}
* in order to create a {@link module:engine/view/containerelement~ViewContainerElement},
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#createAttributeElement `downcastWriter#createAttributeElement()`}
* in order to create a {@link module:engine/view/attributeelement~ViewAttributeElement},
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#createEmptyElement `downcastWriter#createEmptyElement()`}
* in order to create a {@link module:engine/view/emptyelement~ViewEmptyElement}.
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#createUIElement `downcastWriter#createUIElement()`}
* in order to create a {@link module:engine/view/uielement~ViewUIElement}.
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#createEditableElement `downcastWriter#createEditableElement()`}
* in order to create a {@link module:engine/view/editableelement~ViewEditableElement}.
*
* Note that for view elements which are not created from the model, like elements from mutations, paste or
* {@link module:engine/controller/datacontroller~DataController#set data.set} it is not possible to define the type of the element.
* In such cases the {@link module:engine/view/upcastwriter~ViewUpcastWriter#createElement `UpcastWriter#createElement()`} method
* should be used to create generic view elements.
*/ var $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 = class ViewElement extends $b9b9f2bdf9c6137f$export$1de540da1a7d61ca {
    /**
	* Name of the element.
	*/ name;
    /**
	* A list of attribute names that should be rendered in the editing pipeline even though filtering mechanisms
	* implemented in the {@link module:engine/view/domconverter~ViewDomConverter} (for instance,
	* {@link module:engine/view/domconverter~ViewDomConverter#shouldRenderAttribute}) would filter them out.
	*
	* These attributes can be specified as an option when the element is created by
	* the {@link module:engine/view/downcastwriter~ViewDowncastWriter}. To check whether an unsafe an attribute should
	* be permitted, use the {@link #shouldRenderUnsafeAttribute} method.
	*
	* @internal
	*/ _unsafeAttributesToRender = [];
    /**
	* Map of attributes, where attributes names are keys and attributes values are values.
	*/ _attrs;
    /**
	* Array of child nodes.
	*/ _children;
    /**
	* Map of custom properties.
	* Custom properties can be added to element instance, will be cloned but not rendered into DOM.
	*/ _customProperties = /* @__PURE__ */ new Map();
    /**
	* Set of classes associated with element instance.
	*
	* Note that this is just an alias for `this._attrs.get( 'class' );`
	*/ get _classes() {
        return this._attrs.get("class");
    }
    /**
	* Normalized styles.
	*
	* Note that this is just an alias for `this._attrs.get( 'style' );`
	*/ get _styles() {
        return this._attrs.get("style");
    }
    /**
	* Creates a view element.
	*
	* Attributes can be passed in various formats:
	*
	* ```ts
	* new Element( viewDocument, 'div', { class: 'editor', contentEditable: 'true' } ); // object
	* new Element( viewDocument, 'div', [ [ 'class', 'editor' ], [ 'contentEditable', 'true' ] ] ); // map-like iterator
	* new Element( viewDocument, 'div', mapOfAttributes ); // map
	* ```
	*
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attrs, children){
        super(document1);
        this.name = name;
        this._attrs = this._parseAttributes(attrs);
        this._children = [];
        if (children) this._insertChild(0, children);
    }
    /**
	* Number of element's children.
	*/ get childCount() {
        return this._children.length;
    }
    /**
	* Is `true` if there are no nodes inside this element, `false` otherwise.
	*/ get isEmpty() {
        return this._children.length === 0;
    }
    /**
	* Gets child at the given index.
	*
	* @param index Index of child.
	* @returns Child node.
	*/ getChild(index) {
        return this._children[index];
    }
    /**
	* Gets index of the given child node. Returns `-1` if child node is not found.
	*
	* @param node Child node.
	* @returns Index of the child node.
	*/ getChildIndex(node) {
        return this._children.indexOf(node);
    }
    /**
	* Gets child nodes iterator.
	*
	* @returns Child nodes iterator.
	*/ getChildren() {
        return this._children[Symbol.iterator]();
    }
    /**
	* Returns an iterator that contains the keys for attributes. Order of inserting attributes is not preserved.
	*
	* @returns Keys for attributes.
	*/ *getAttributeKeys() {
        if (this._classes) yield "class";
        if (this._styles) yield "style";
        for (const key of this._attrs.keys())if (key != "class" && key != "style") yield key;
    }
    /**
	* Returns iterator that iterates over this element's attributes.
	*
	* Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
	* This format is accepted by native `Map` object and also can be passed in `Node` constructor.
	*/ *getAttributes() {
        for (const [name, value] of this._attrs.entries())yield [
            name,
            String(value)
        ];
    }
    /**
	* Gets attribute by key. If attribute is not present - returns undefined.
	*
	* @param key Attribute key.
	* @returns Attribute value.
	*/ getAttribute(key) {
        return this._attrs.has(key) ? String(this._attrs.get(key)) : void 0;
    }
    /**
	* Returns a boolean indicating whether an attribute with the specified key exists in the element.
	*
	* @param key Attribute key.
	* @returns `true` if attribute with the specified key exists in the element, `false` otherwise.
	*/ hasAttribute(key, token) {
        if (!this._attrs.has(key)) return false;
        if (token !== void 0) {
            if ($b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key) || $b9b9f2bdf9c6137f$var$usesTokenList(this.name, key)) return this._attrs.get(key).has(token);
            else return this._attrs.get(key) === token;
        }
        return true;
    }
    /**
	* Checks if this element is similar to other element.
	* Both elements should have the same name and attributes to be considered as similar. Two similar elements
	* can contain different set of children nodes.
	*/ isSimilar(otherElement) {
        if (!(otherElement instanceof ViewElement)) return false;
        if (this === otherElement) return true;
        if (this.name != otherElement.name) return false;
        if (this._attrs.size !== otherElement._attrs.size) return false;
        for (const [key, value] of this._attrs){
            const otherValue = otherElement._attrs.get(key);
            if (otherValue === void 0) return false;
            if (typeof value == "string" || typeof otherValue == "string") {
                if (otherValue !== value) return false;
            } else if (!value.isSimilar(otherValue)) return false;
        }
        return true;
    }
    /**
	* Returns true if class is present.
	* If more then one class is provided - returns true only when all classes are present.
	*
	* ```ts
	* element.hasClass( 'foo' ); // Returns true if 'foo' class is present.
	* element.hasClass( 'foo', 'bar' ); // Returns true if 'foo' and 'bar' classes are both present.
	* ```
	*/ hasClass(...className) {
        for (const name of className)if (!this._classes || !this._classes.has(name)) return false;
        return true;
    }
    /**
	* Returns iterator that contains all class names.
	*/ getClassNames() {
        const array = this._classes ? this._classes.keys() : [];
        const iterator = array[Symbol.iterator]();
        return Object.assign(array, {
            next: iterator.next.bind(iterator)
        });
    }
    /**
	* Returns style value for the given property name.
	* If the style does not exist `undefined` is returned.
	*
	* **Note**: This method can work with normalized style names if
	* {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
	* See {@link module:engine/view/stylesmap~StylesMap#getAsString `StylesMap#getAsString()`} for details.
	*
	* For an element with style set to `'margin:1px'`:
	*
	* ```ts
	* // Enable 'margin' shorthand processing:
	* editor.data.addStyleProcessorRules( addMarginStylesRules );
	*
	* const element = view.change( writer => {
	* 	const element = writer.createElement();
	* 	writer.setStyle( 'margin', '1px' );
	* 	writer.setStyle( 'margin-bottom', '3em' );
	*
	* 	return element;
	* } );
	*
	* element.getStyle( 'margin' ); // -> 'margin: 1px 1px 3em;'
	* ```
	*/ getStyle(property) {
        return this._styles && this._styles.getAsString(property);
    }
    /**
	* Returns a normalized style object or single style value.
	*
	* For an element with style set to: margin:1px 2px 3em;
	*
	* ```ts
	* element.getNormalizedStyle( 'margin' ) );
	* ```
	*
	* will return:
	*
	* ```ts
	* {
	* 	top: '1px',
	* 	right: '2px',
	* 	bottom: '3em',
	* 	left: '2px'    // a normalized value from margin shorthand
	* }
	* ```
	*
	* and reading for single style value:
	*
	* ```ts
	* styles.getNormalizedStyle( 'margin-left' );
	* ```
	*
	* Will return a `2px` string.
	*
	* **Note**: This method will return normalized values only if
	* {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
	* See {@link module:engine/view/stylesmap~StylesMap#getNormalized `StylesMap#getNormalized()`} for details.
	*
	* @param property Name of CSS property
	*/ getNormalizedStyle(property) {
        return this._styles && this._styles.getNormalized(property);
    }
    /**
	* Returns an array that contains all style names.
	*
	* @param expand Expand shorthand style properties and return all equivalent style representations.
	*/ getStyleNames(expand) {
        return this._styles ? this._styles.getStyleNames(expand) : [];
    }
    /**
	* Returns true if style keys are present.
	* If more then one style property is provided - returns true only when all properties are present.
	*
	* ```ts
	* element.hasStyle( 'color' ); // Returns true if 'border-top' style is present.
	* element.hasStyle( 'color', 'border-top' ); // Returns true if 'color' and 'border-top' styles are both present.
	* ```
	*/ hasStyle(...property) {
        for (const name of property)if (!this._styles || !this._styles.has(name)) return false;
        return true;
    }
    /**
	* Returns ancestor element that match specified pattern.
	* Provided patterns should be compatible with {@link module:engine/view/matcher~Matcher Matcher} as it is used internally.
	*
	* @see module:engine/view/matcher~Matcher
	* @param patterns Patterns used to match correct ancestor. See {@link module:engine/view/matcher~Matcher}.
	* @returns Found element or `null` if no matching ancestor was found.
	*/ findAncestor(...patterns) {
        const matcher = new $b9b9f2bdf9c6137f$export$20214574ec94167d(...patterns);
        let parent = this.parent;
        while(parent && !parent.is("documentFragment")){
            if (matcher.match(parent)) return parent;
            parent = parent.parent;
        }
        return null;
    }
    /**
	* Returns the custom property value for the given key.
	*/ getCustomProperty(key) {
        return this._customProperties.get(key);
    }
    /**
	* Returns an iterator which iterates over this element's custom properties.
	* Iterator provides `[ key, value ]` pairs for each stored property.
	*/ *getCustomProperties() {
        yield* this._customProperties.entries();
    }
    /**
	* Returns identity string based on element's name, styles, classes and other attributes.
	* Two elements that {@link #isSimilar are similar} will have same identity string.
	* It has the following format:
	*
	* ```ts
	* 'name class="class1,class2" style="style1:value1;style2:value2" attr1="val1" attr2="val2"'
	* ```
	*
	* For example:
	*
	* ```ts
	* const element = writer.createContainerElement( 'foo', {
	* 	banana: '10',
	* 	apple: '20',
	* 	style: 'color: red; border-color: white;',
	* 	class: 'baz'
	* } );
	*
	* // returns 'foo class="baz" style="border-color:white;color:red" apple="20" banana="10"'
	* element.getIdentity();
	* ```
	*
	* **Note**: Classes, styles and other attributes are sorted alphabetically.
	*/ getIdentity() {
        const classes = this._classes ? this._classes.keys().sort().join(",") : "";
        const styles = this._styles && String(this._styles);
        const attributes = Array.from(this._attrs).filter(([key])=>key != "style" && key != "class").map((i)=>`${i[0]}="${i[1]}"`).sort().join(" ");
        return this.name + (classes == "" ? "" : ` class="${classes}"`) + (!styles ? "" : ` style="${styles}"`) + (attributes == "" ? "" : ` ${attributes}`);
    }
    /**
	* Decides whether an unsafe attribute is whitelisted and should be rendered in the editing pipeline even though filtering mechanisms
	* like {@link module:engine/view/domconverter~ViewDomConverter#shouldRenderAttribute} say it should not.
	*
	* Unsafe attribute names can be specified when creating an element via {@link module:engine/view/downcastwriter~ViewDowncastWriter}.
	*
	* @param attributeName The name of the attribute to be checked.
	*/ shouldRenderUnsafeAttribute(attributeName) {
        return this._unsafeAttributesToRender.includes(attributeName);
    }
    /**
	* Converts `ViewElement` to plain object and returns it.
	*
	* @returns `ViewElement` converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.name = this.name;
        json.type = "Element";
        if (this._attrs.size) json.attributes = Object.fromEntries(this.getAttributes());
        if (this._children.length > 0) {
            json.children = [];
            for (const node of this._children)json.children.push(node.toJSON());
        }
        return json;
    }
    /**
	* Clones provided element.
	*
	* @internal
	* @param deep If set to `true` clones element and all its children recursively. When set to `false`,
	* element will be cloned without any children.
	* @returns Clone of this element.
	*/ _clone(deep = false) {
        const childrenClone = [];
        if (deep) for (const child of this.getChildren())childrenClone.push(child._clone(deep));
        const cloned = new this.constructor(this.document, this.name, this._attrs, childrenClone);
        cloned._customProperties = new Map(this._customProperties);
        cloned.getFillerOffset = this.getFillerOffset;
        cloned._unsafeAttributesToRender = this._unsafeAttributesToRender;
        return cloned;
    }
    /**
	* {@link module:engine/view/element~ViewElement#_insertChild Insert} a child node or a list of child nodes at the end of this node
	* and sets the parent of these nodes to this element.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#insert
	* @internal
	* @param items Items to be inserted.
	* @fires change
	* @returns Number of appended nodes.
	*/ _appendChild(items) {
        return this._insertChild(this.childCount, items);
    }
    /**
	* Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
	* this element.
	*
	* @internal
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#insert
	* @param index Position where nodes should be inserted.
	* @param items Items to be inserted.
	* @fires change
	* @returns Number of inserted nodes.
	*/ _insertChild(index, items) {
        this._fireChange("children", this, {
            index: index
        });
        let count = 0;
        const nodes = $b9b9f2bdf9c6137f$var$normalize$3(this.document, items);
        for (const node of nodes){
            if (node.parent !== null) node._remove();
            node.parent = this;
            node.document = this.document;
            this._children.splice(index, 0, node);
            index++;
            count++;
        }
        return count;
    }
    /**
	* Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#remove
	* @internal
	* @param index Number of the first node to remove.
	* @param howMany Number of nodes to remove.
	* @fires change
	* @returns The array of removed nodes.
	*/ _removeChildren(index, howMany = 1) {
        this._fireChange("children", this, {
            index: index
        });
        for(let i = index; i < index + howMany; i++)this._children[i].parent = null;
        return this._children.splice(index, howMany);
    }
    /**
	* Adds or overwrite attribute with a specified key and value.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#setAttribute
	* @internal
	* @param key Attribute key.
	* @param value Attribute value.
	* @param overwrite Whether tokenized attribute should override the attribute value or just add a token.
	* @fires change
	*/ _setAttribute(key, value, overwrite = true) {
        this._fireChange("attributes", this);
        if ($b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key) || $b9b9f2bdf9c6137f$var$usesTokenList(this.name, key)) {
            let currentValue = this._attrs.get(key);
            if (!currentValue) {
                currentValue = $b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key) ? new $b9b9f2bdf9c6137f$export$a256655bfa1a33f5(this.document.stylesProcessor) : new $b9b9f2bdf9c6137f$export$7233f0a9cd429212();
                this._attrs.set(key, currentValue);
            }
            if (overwrite) currentValue.setTo(String(value));
            else if ($b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key)) {
                if (Array.isArray(value)) currentValue.set(value[0], value[1]);
                else currentValue.set(value);
            } else currentValue.set(typeof value == "string" ? value.split(/\s+/) : value);
        } else this._attrs.set(key, String(value));
    }
    /**
	* Removes attribute from the element.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#removeAttribute
	* @internal
	* @param key Attribute key.
	* @param tokens Attribute value tokens to remove. The whole attribute is removed if not specified.
	* @returns Returns true if an attribute existed and has been removed.
	* @fires change
	*/ _removeAttribute(key, tokens) {
        this._fireChange("attributes", this);
        if (tokens !== void 0 && ($b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key) || $b9b9f2bdf9c6137f$var$usesTokenList(this.name, key))) {
            const currentValue = this._attrs.get(key);
            if (!currentValue) return false;
            if ($b9b9f2bdf9c6137f$var$usesTokenList(this.name, key) && typeof tokens == "string") tokens = tokens.split(/\s+/);
            currentValue.remove(tokens);
            if (currentValue.isEmpty) return this._attrs.delete(key);
            return false;
        }
        return this._attrs.delete(key);
    }
    /**
	* Adds specified class.
	*
	* ```ts
	* element._addClass( 'foo' ); // Adds 'foo' class.
	* element._addClass( [ 'foo', 'bar' ] ); // Adds 'foo' and 'bar' classes.
	* ```
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#addClass
	* @internal
	* @fires change
	*/ _addClass(className) {
        this._setAttribute("class", className, false);
    }
    /**
	* Removes specified class.
	*
	* ```ts
	* element._removeClass( 'foo' );  // Removes 'foo' class.
	* element._removeClass( [ 'foo', 'bar' ] ); // Removes both 'foo' and 'bar' classes.
	* ```
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#removeClass
	* @internal
	* @fires change
	*/ _removeClass(className) {
        this._removeAttribute("class", className);
    }
    _setStyle(property, value) {
        if (typeof property != "string") this._setAttribute("style", property, false);
        else this._setAttribute("style", [
            property,
            value
        ], false);
    }
    /**
	* Removes specified style.
	*
	* ```ts
	* element._removeStyle( 'color' );  // Removes 'color' style.
	* element._removeStyle( [ 'color', 'border-top' ] ); // Removes both 'color' and 'border-top' styles.
	* ```
	*
	* **Note**: This method can work with normalized style names if
	* {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
	* See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#removeStyle
	* @internal
	* @fires change
	*/ _removeStyle(property) {
        this._removeAttribute("style", property);
    }
    /**
	* Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching attribute tuples
	* (attribute name and optional token).
	*
	* Normalized patterns can be used in following ways:
	* - to match any attribute name with any or no value:
	*
	* ```ts
	* patterns: [
	* 	[ true, true ]
	* ]
	* ```
	*
	* - to match a specific attribute with any value:
	*
	* ```ts
	* patterns: [
	* 	[ 'required', true ]
	* ]
	* ```
	*
	* - to match an attribute name with a RegExp with any value:
	*
	* ```ts
	* patterns: [
	* 	[ /h[1-6]/, true ]
	* ]
	* ```
	*
	* 	- to match a specific attribute with the exact value:
	*
	* ```ts
	* patterns: [
	* 	[ 'rel', 'nofollow' ]
	* ]
	* ```
	*
	* 	- to match a specific attribute with a value matching a RegExp:
	*
	* ```ts
	* patterns: [
	* 	[ 'src', /^https/ ]
	* ]
	* ```
	*
	* 	- to match an attribute name with a RegExp and the exact value:
	*
	* ```ts
	* patterns: [
	* 	[ /^data-property-/, 'foobar' ],
	* ]
	* ```
	*
	* 	- to match an attribute name with a RegExp and match a value with another RegExp:
	*
	* ```ts
	* patterns: [
	* 	[ /^data-property-/, /^foo/ ]
	* ]
	* ```
	*
	* 	- to match a specific style property with the value matching a RegExp:
	*
	* ```ts
	* patterns: [
	* 	[ 'style', 'font-size', /px$/ ]
	* ]
	* ```
	*
	* 	- to match a specific class (class attribute is tokenized so it matches tokens individually):
	*
	* ```ts
	* patterns: [
	* 	[ 'class', 'foo' ]
	* ]
	* ```
	*
	* @internal
	* @param patterns An array of normalized patterns (tuples of 2 or 3 items depending on if tokenized attribute value match is needed).
	* @param match An array to populate with matching tuples.
	* @param exclude Array of attribute names to exclude from match.
	* @returns `true` if element matches all patterns. The matching tuples are pushed to the `match` array.
	*/ _collectAttributesMatch(patterns, match, exclude) {
        for (const [keyPattern, tokenPattern, valuePattern] of patterns){
            let hasKey = false;
            let hasValue = false;
            for (const [key, value] of this._attrs){
                if (exclude && exclude.includes(key) || !$b9b9f2bdf9c6137f$export$c777eb411bac515(keyPattern, key)) continue;
                hasKey = true;
                if (typeof value == "string") {
                    if ($b9b9f2bdf9c6137f$export$c777eb411bac515(tokenPattern, value)) {
                        match.push([
                            key
                        ]);
                        hasValue = true;
                    } else if (!(keyPattern instanceof RegExp)) return false;
                } else {
                    const tokenMatch = value._getTokensMatch(tokenPattern, valuePattern || true);
                    if (tokenMatch) {
                        hasValue = true;
                        for (const tokenMatchItem of tokenMatch)match.push([
                            key,
                            tokenMatchItem
                        ]);
                    } else if (!(keyPattern instanceof RegExp)) return false;
                }
            }
            if (!hasKey || !hasValue) return false;
        }
        return true;
    }
    /**
	* Used by the {@link module:engine/conversion/viewconsumable~ViewConsumable} to collect the
	* {@link module:engine/view/element~ViewNormalizedConsumables} for the element.
	*
	* When `key` and `token` parameters are provided the output is filtered for the specified attribute and it's tokens and related tokens.
	*
	* @internal
	* @param key Attribute name.
	* @param token Reference token to collect all related tokens.
	*/ _getConsumables(key, token) {
        const attributes = [];
        if (key) {
            const value = this._attrs.get(key);
            if (value !== void 0) {
                if (typeof value == "string") attributes.push([
                    key
                ]);
                else for (const prop of value._getConsumables(token))attributes.push([
                    key,
                    prop
                ]);
            }
        } else for (const [key, value] of this._attrs)if (typeof value == "string") attributes.push([
            key
        ]);
        else for (const prop of value._getConsumables())attributes.push([
            key,
            prop
        ]);
        return {
            name: !key,
            attributes: attributes
        };
    }
    /**
	* Verify if the given element can be merged without conflicts into the element.
	*
	* Note that this method is extended by the {@link module:engine/view/attributeelement~ViewAttributeElement} implementation.
	*
	* This method is used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other ViewAttributeElement.
	*
	* @internal
	* @returns Returns `true` if elements can be merged.
	*/ _canMergeAttributesFrom(otherElement) {
        if (this.name != otherElement.name) return false;
        for (const [key, otherValue] of otherElement._attrs){
            const value = this._attrs.get(key);
            if (value === void 0) continue;
            if (typeof value == "string" || typeof otherValue == "string") {
                if (value !== otherValue) return false;
            } else if (!value._canMergeFrom(otherValue)) return false;
        }
        return true;
    }
    /**
	* Merges attributes of a given element into the element.
	* This includes also tokenized attributes like style and class.
	*
	* Note that you should make sure there are no conflicts before merging (see {@link #_canMergeAttributesFrom}).
	*
	* This method is used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to merge it with other ViewAttributeElement.
	*
	* @internal
	*/ _mergeAttributesFrom(otherElement) {
        this._fireChange("attributes", this);
        for (const [key, otherValue] of otherElement._attrs){
            const value = this._attrs.get(key);
            if (value === void 0 || typeof value == "string" || typeof otherValue == "string") this._setAttribute(key, otherValue);
            else value._mergeFrom(otherValue);
        }
    }
    /**
	* Verify if the given element attributes can be fully subtracted from the element.
	*
	* Note that this method is extended by the {@link module:engine/view/attributeelement~ViewAttributeElement} implementation.
	*
	* This method is used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to unwrap the ViewAttributeElement.
	*
	* @internal
	* @returns Returns `true` if elements attributes can be fully subtracted.
	*/ _canSubtractAttributesOf(otherElement) {
        if (this.name != otherElement.name) return false;
        for (const [key, otherValue] of otherElement._attrs){
            const value = this._attrs.get(key);
            if (value === void 0) return false;
            if (typeof value == "string" || typeof otherValue == "string") {
                if (value !== otherValue) return false;
            } else if (!value._isMatching(otherValue)) return false;
        }
        return true;
    }
    /**
	* Removes (subtracts) corresponding attributes of the given element from the element.
	* This includes also tokenized attributes like style and class.
	* All attributes, classes and styles from given element should be present inside the element being unwrapped.
	*
	* Note that you should make sure all attributes could be subtracted before subtracting them (see {@link #_canSubtractAttributesOf}).
	*
	* This method is used by the {@link module:engine/view/downcastwriter~ViewDowncastWriter} while down-casting
	* an {@link module:engine/view/attributeelement~ViewAttributeElement} to unwrap the ViewAttributeElement.
	*
	* @internal
	*/ _subtractAttributesOf(otherElement) {
        this._fireChange("attributes", this);
        for (const [key, otherValue] of otherElement._attrs){
            const value = this._attrs.get(key);
            if (typeof value == "string" || typeof otherValue == "string") this._attrs.delete(key);
            else {
                value.remove(otherValue.keys());
                if (value.isEmpty) this._attrs.delete(key);
            }
        }
    }
    /**
	* Sets a custom property. Unlike attributes, custom properties are not rendered to the DOM,
	* so they can be used to add special data to elements.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#setCustomProperty
	* @internal
	*/ _setCustomProperty(key, value) {
        this._customProperties.set(key, value);
    }
    /**
	* Removes the custom property stored under the given key.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#removeCustomProperty
	* @internal
	* @returns Returns true if property was removed.
	*/ _removeCustomProperty(key) {
        return this._customProperties.delete(key);
    }
    /**
	* Parses attributes provided to the element constructor before they are applied to an element. If attributes are passed
	* as an object (instead of `Iterable`), the object is transformed to the map. Attributes with `null` value are removed.
	* Attributes with non-`String` value are converted to `String`.
	*
	* @param attrs Attributes to parse.
	* @returns Parsed attributes.
	*/ _parseAttributes(attrs) {
        const attrsMap = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(attrs);
        for (const [key, value] of attrsMap)if (value === null) attrsMap.delete(key);
        else if ($b9b9f2bdf9c6137f$var$usesStylesMap(this.name, key)) {
            const newValue = value instanceof $b9b9f2bdf9c6137f$export$a256655bfa1a33f5 ? value._clone() : new $b9b9f2bdf9c6137f$export$a256655bfa1a33f5(this.document.stylesProcessor).setTo(String(value));
            attrsMap.set(key, newValue);
        } else if ($b9b9f2bdf9c6137f$var$usesTokenList(this.name, key)) {
            const newValue = value instanceof $b9b9f2bdf9c6137f$export$7233f0a9cd429212 ? value._clone() : new $b9b9f2bdf9c6137f$export$7233f0a9cd429212().setTo(String(value));
            attrsMap.set(key, newValue);
        } else if (typeof value != "string") attrsMap.set(key, String(value));
        return attrsMap;
    }
};
$b9b9f2bdf9c6137f$export$6a9b2964be74ea54.prototype.is = function(type, name) {
    if (!name) return type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "element" || type === "view:element");
};
/**
* Converts strings to Text and non-iterables to arrays.
*/ function $b9b9f2bdf9c6137f$var$normalize$3(document1, nodes) {
    if (typeof nodes == "string") return [
        new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, nodes)
    ];
    if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes)) nodes = [
        nodes
    ];
    const normalizedNodes = [];
    for (const node of nodes)if (typeof node == "string") normalizedNodes.push(new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, node));
    else if (node instanceof $b9b9f2bdf9c6137f$export$b0e248170172f65f) normalizedNodes.push(new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, node.data));
    else normalizedNodes.push(node);
    return normalizedNodes;
}
/**
* Returns `true` if an attribute on a given element should be handled as a TokenList.
*/ function $b9b9f2bdf9c6137f$var$usesTokenList(elementName, key) {
    return key == "class" || elementName == "a" && key == "rel";
}
/**
* Returns `true` if an attribute on a given element should be handled as a StylesMap.
*/ function $b9b9f2bdf9c6137f$var$usesStylesMap(elementName, key) {
    return key == "style";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/containerelement
*/ /**
* Containers are elements which define document structure. They define boundaries for
* {@link module:engine/view/attributeelement~ViewAttributeElement attributes}.
* They are mostly used for block elements like `<p>` or `<div>`.
*
* Editing engine does not define a fixed HTML DTD. This is why a feature developer needs to choose between various
* types (container element, {@link module:engine/view/attributeelement~ViewAttributeElement attribute element},
* {@link module:engine/view/emptyelement~ViewEmptyElement empty element}, etc) when developing a feature.
*
* The container element should be your default choice when writing a converter, unless:
*
* * this element represents a model text attribute (then use {@link module:engine/view/attributeelement~ViewAttributeElement}),
* * this is an empty element like `<img>` (then use {@link module:engine/view/emptyelement~ViewEmptyElement}),
* * this is a root element,
* * this is a nested editable element (then use  {@link module:engine/view/editableelement~ViewEditableElement}).
*
* To create a new container element instance use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createContainerElement `ViewDowncastWriter#createContainerElement()`}
* method.
*/ var $b9b9f2bdf9c6137f$export$7cd474321d18c0af = class extends $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 {
    /**
	* Creates a container element.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createContainerElement
	* @see module:engine/view/element~ViewElement
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attrs, children){
        super(document1, name, attrs, children);
        this.getFillerOffset = $b9b9f2bdf9c6137f$export$1f46ac43c71ac4b4;
    }
    /**
	* Converts `ViewContainerElement` instance to plain object and returns it.
	*
	* @returns `ViewContainerElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "ContainerElement";
        return json;
    }
};
$b9b9f2bdf9c6137f$export$7cd474321d18c0af.prototype.is = function(type, name) {
    if (!name) return type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element");
};
/**
* Returns block {@link module:engine/view/filler filler} offset or `null` if block filler is not needed.
*
* @returns Block filler offset or `null` if block filler is not needed.
*/ function $b9b9f2bdf9c6137f$export$1f46ac43c71ac4b4() {
    const children = [
        ...this.getChildren()
    ];
    let lastChild = children[this.childCount - 1];
    if (lastChild && lastChild.is("element", "br")) return this.childCount;
    while(lastChild && lastChild.is("attributeElement")){
        lastChild = lastChild.getChild(lastChild.childCount - 1);
        if (lastChild && lastChild.is("element", "br")) return this.childCount;
    }
    for (const child of children)if (!child.is("uiElement")) return null;
    return this.childCount;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/editableelement
*/ const $b9b9f2bdf9c6137f$var$ViewEditableElementBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)($b9b9f2bdf9c6137f$export$7cd474321d18c0af);
/**
* Editable element which can be a {@link module:engine/view/rooteditableelement~ViewRootEditableElement root}
* or nested editable area in the editor.
*
* Editable is automatically read-only when its {@link module:engine/view/document~ViewDocument Document} is read-only.
*
* The constructor of this class shouldn't be used directly. To create new `ViewEditableElement` use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createEditableElement `downcastWriter#createEditableElement()`} method.
*/ var $b9b9f2bdf9c6137f$export$785df0da0fc4f1c8 = class extends $b9b9f2bdf9c6137f$var$ViewEditableElementBase {
    /**
	* Creates an editable element.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createEditableElement
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attributes Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attributes, children){
        super(document1, name, attributes, children);
        this.set("isReadOnly", false);
        this.set("isFocused", false);
        this.set("placeholder", void 0);
        this.bind("isReadOnly").to(document1);
        this.bind("isFocused").to(document1, "isFocused", (isFocused)=>isFocused && document1.selection.editableElement == this);
        this.listenTo(document1.selection, "change", ()=>{
            this.isFocused = document1.isFocused && document1.selection.editableElement == this;
        });
    }
    destroy() {
        this.stopListening();
    }
    /**
	* Converts `ViewEditableElement` instance to plain object and returns it.
	*
	* @returns `ViewEditableElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "EditableElement";
        json.isReadOnly = this.isReadOnly;
        json.isFocused = this.isFocused;
        return json;
    }
};
$b9b9f2bdf9c6137f$export$785df0da0fc4f1c8.prototype.is = function(type, name) {
    if (!name) return type === "editableElement" || type === "view:editableElement" || type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "editableElement" || type === "view:editableElement" || type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element");
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/rooteditableelement
*/ const $b9b9f2bdf9c6137f$var$rootNameSymbol = Symbol("rootName");
/**
* Class representing a single root in the data view. A root can be either
* {@link ~ViewRootEditableElement#isReadOnly editable or read-only},
* but in both cases it is called "an editable". Roots can contain other {@link module:engine/view/editableelement~ViewEditableElement
* editable elements} making them "nested editables".
*/ var $b9b9f2bdf9c6137f$export$a8813c6865859ce = class extends $b9b9f2bdf9c6137f$export$785df0da0fc4f1c8 {
    /**
	* Creates root editable element.
	*
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	*/ constructor(document1, name){
        super(document1, name);
        this.rootName = "main";
    }
    /**
	* Name of this root inside {@link module:engine/view/document~ViewDocument} that is an owner of this root. If no
	* other name is set, `main` name is used.
	*
	* @readonly
	*/ get rootName() {
        return this.getCustomProperty($b9b9f2bdf9c6137f$var$rootNameSymbol);
    }
    set rootName(rootName) {
        this._setCustomProperty($b9b9f2bdf9c6137f$var$rootNameSymbol, rootName);
    }
    /**
	* Converts `ViewRootEditableElement` instance to string and returns it.
	*
	* @returns `ViewRootEditableElement` instance converted to string.
	*/ toJSON() {
        return this.rootName;
    }
    /**
	* Overrides old element name and sets new one.
	* This is needed because view roots are created before they are attached to the DOM.
	* The name of the root element is temporary at this stage. It has to be changed when the
	* view root element is attached to the DOM element.
	*
	* @internal
	* @param name The new name of element.
	*/ set _name(name) {
        this.name = name;
    }
};
$b9b9f2bdf9c6137f$export$a8813c6865859ce.prototype.is = function(type, name) {
    if (!name) return type === "rootElement" || type === "view:rootElement" || type === "editableElement" || type === "view:editableElement" || type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "rootElement" || type === "view:rootElement" || type === "editableElement" || type === "view:editableElement" || type === "containerElement" || type === "view:containerElement" || type === "element" || type === "view:element");
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Position iterator class. It allows to iterate forward and backward over the document.
*/ var $b9b9f2bdf9c6137f$export$c08c3998433b96e1 = class {
    /**
	* Walking direction. Defaults `'forward'`.
	*/ direction;
    /**
	* Iterator boundaries.
	*
	* When the iterator is walking `'forward'` on the end of boundary or is walking `'backward'`
	* on the start of boundary, then `{ done: true }` is returned.
	*
	* If boundaries are not defined they are set before first and after last child of the root node.
	*/ boundaries;
    /**
	* Flag indicating whether all characters from {@link module:engine/view/text~ViewText} should be returned as one
	* {@link module:engine/view/text~ViewText} or one by one as {@link module:engine/view/textproxy~ViewTextProxy}.
	*/ singleCharacters;
    /**
	* Flag indicating whether iterator should enter elements or not. If the iterator is shallow child nodes of any
	* iterated node will not be returned along with `elementEnd` tag.
	*/ shallow;
    /**
	* Flag indicating whether iterator should ignore `elementEnd` tags. If set to `true`, walker will not
	* return a parent node of the start position. Each {@link module:engine/view/element~ViewElement} will be returned once.
	* When set to `false` each element might be returned twice: for `'elementStart'` and `'elementEnd'`.
	*/ ignoreElementEnd;
    /**
	* Iterator position. If start position is not defined then position depends on {@link #direction}. If direction is
	* `'forward'` position starts form the beginning, when direction is `'backward'` position starts from the end.
	*/ _position;
    /**
	* Start boundary parent.
	*/ _boundaryStartParent;
    /**
	* End boundary parent.
	*/ _boundaryEndParent;
    /**
	* Creates a range iterator. All parameters are optional, but you have to specify either `boundaries` or `startPosition`.
	*
	* @param options Object with configuration.
	*/ constructor(options = {}){
        if (!options.boundaries && !options.startPosition) /**
		* Neither boundaries nor starting position have been defined.
		*
		* @error view-tree-walker-no-start-position
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-tree-walker-no-start-position", null);
        if (options.direction && options.direction != "forward" && options.direction != "backward") /**
		* Only `backward` and `forward` direction allowed.
		*
		* @error view-tree-walker-unknown-direction
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-tree-walker-unknown-direction", options.startPosition, {
            direction: options.direction
        });
        this.boundaries = options.boundaries || null;
        if (options.startPosition) this._position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(options.startPosition);
        else this._position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(options.boundaries[options.direction == "backward" ? "end" : "start"]);
        this.direction = options.direction || "forward";
        this.singleCharacters = !!options.singleCharacters;
        this.shallow = !!options.shallow;
        this.ignoreElementEnd = !!options.ignoreElementEnd;
        this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
        this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
    }
    /**
	* Iterable interface.
	*/ [Symbol.iterator]() {
        return this;
    }
    /**
	* Iterator position. If start position is not defined then position depends on {@link #direction}. If direction is
	* `'forward'` position starts form the beginning, when direction is `'backward'` position starts from the end.
	*/ get position() {
        return this._position;
    }
    /**
	* Moves {@link #position} in the {@link #direction} skipping values as long as the callback function returns `true`.
	*
	* For example:
	*
	* ```ts
	* walker.skip( value => value.type == 'text' ); // <p>{}foo</p> -> <p>foo[]</p>
	* walker.skip( value => true ); // Move the position to the end: <p>{}foo</p> -> <p>foo</p>[]
	* walker.skip( value => false ); // Do not move the position.
	* ```
	*
	* @param skip Callback function. Gets {@link module:engine/view/treewalker~ViewTreeWalkerValue} and should
	* return `true` if the value should be skipped or `false` if not.
	*/ skip(skip) {
        let nextResult;
        let prevPosition;
        do {
            prevPosition = this.position;
            nextResult = this.next();
        }while (!nextResult.done && skip(nextResult.value));
        if (!nextResult.done) this._position = prevPosition;
    }
    /**
	* Moves tree walker {@link #position} to provided `position`. Tree walker will
	* continue traversing from that position.
	*
	* Note: in contrary to {@link ~ViewTreeWalker#skip}, this method does not iterate over the nodes along the way.
	* It simply sets the current tree walker position to a new one.
	* From the performance standpoint, it is better to use {@link ~ViewTreeWalker#jumpTo} rather than {@link ~ViewTreeWalker#skip}.
	*
	* If the provided position is before the start boundary, the position will be
	* set to the start boundary. If the provided position is after the end boundary,
	* the position will be set to the end boundary.
	* This is done to prevent the treewalker from traversing outside the boundaries.
	*
	* @param position Position to jump to.
	*/ jumpTo(position) {
        if (this._boundaryStartParent && position.isBefore(this.boundaries.start)) position = this.boundaries.start;
        else if (this._boundaryEndParent && position.isAfter(this.boundaries.end)) position = this.boundaries.end;
        this._position = position.clone();
    }
    /**
	* Gets the next tree walker's value.
	*
	* @returns Object implementing iterator interface, returning
	* information about taken step.
	*/ next() {
        if (this.direction == "forward") return this._next();
        else return this._previous();
    }
    /**
	* Makes a step forward in view. Moves the {@link #position} to the next position and returns the encountered value.
	*/ _next() {
        let position = this.position.clone();
        const previousPosition = this.position;
        const parent = position.parent;
        if (parent.parent === null && position.offset === parent.childCount) return {
            done: true,
            value: void 0
        };
        if (parent === this._boundaryEndParent && position.offset == this.boundaries.end.offset) return {
            done: true,
            value: void 0
        };
        let node;
        if (parent && parent.is("view:$text")) {
            if (position.isAtEnd) {
                this._position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(parent);
                return this._next();
            }
            node = parent.data[position.offset];
        } else node = parent.getChild(position.offset);
        if (typeof node == "string") {
            let textLength;
            if (this.singleCharacters) textLength = 1;
            else textLength = (parent === this._boundaryEndParent ? this.boundaries.end.offset : parent.data.length) - position.offset;
            const textProxy = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(parent, position.offset, textLength);
            position.offset += textLength;
            this._position = position;
            return this._formatReturnValue("text", textProxy, previousPosition, position, textLength);
        }
        if (node && node.is("view:element")) {
            if (!this.shallow) position = new $b9b9f2bdf9c6137f$export$7534acacc32db851(node, 0);
            else {
                if (this.boundaries && this.boundaries.end.isBefore(position)) return {
                    done: true,
                    value: void 0
                };
                position.offset++;
            }
            this._position = position;
            return this._formatReturnValue("elementStart", node, previousPosition, position, 1);
        }
        if (node && node.is("view:$text")) {
            if (this.singleCharacters) {
                position = new $b9b9f2bdf9c6137f$export$7534acacc32db851(node, 0);
                this._position = position;
                return this._next();
            }
            let charactersCount = node.data.length;
            let item;
            if (node == this._boundaryEndParent) {
                charactersCount = this.boundaries.end.offset;
                item = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(node, 0, charactersCount);
                position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item);
            } else {
                item = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(node, 0, node.data.length);
                position.offset++;
            }
            this._position = position;
            return this._formatReturnValue("text", item, previousPosition, position, charactersCount);
        }
        position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(parent);
        this._position = position;
        if (this.ignoreElementEnd) return this._next();
        return this._formatReturnValue("elementEnd", parent, previousPosition, position);
    }
    /**
	* Makes a step backward in view. Moves the {@link #position} to the previous position and returns the encountered value.
	*/ _previous() {
        let position = this.position.clone();
        const previousPosition = this.position;
        const parent = position.parent;
        if (parent.parent === null && position.offset === 0) return {
            done: true,
            value: void 0
        };
        if (parent == this._boundaryStartParent && position.offset == this.boundaries.start.offset) return {
            done: true,
            value: void 0
        };
        let node;
        if (parent.is("view:$text")) {
            if (position.isAtStart) {
                this._position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(parent);
                return this._previous();
            }
            node = parent.data[position.offset - 1];
        } else node = parent.getChild(position.offset - 1);
        if (typeof node == "string") {
            let textLength;
            if (!this.singleCharacters) {
                const startOffset = parent === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                textLength = position.offset - startOffset;
            } else textLength = 1;
            position.offset -= textLength;
            const textProxy = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(parent, position.offset, textLength);
            this._position = position;
            return this._formatReturnValue("text", textProxy, previousPosition, position, textLength);
        }
        if (node && node.is("view:element")) {
            if (this.shallow) {
                position.offset--;
                this._position = position;
                return this._formatReturnValue("elementStart", node, previousPosition, position, 1);
            }
            position = new $b9b9f2bdf9c6137f$export$7534acacc32db851(node, node.childCount);
            this._position = position;
            if (this.ignoreElementEnd) return this._previous();
            return this._formatReturnValue("elementEnd", node, previousPosition, position);
        }
        if (node && node.is("view:$text")) {
            if (this.singleCharacters) {
                position = new $b9b9f2bdf9c6137f$export$7534acacc32db851(node, node.data.length);
                this._position = position;
                return this._previous();
            }
            let charactersCount = node.data.length;
            let item;
            if (node == this._boundaryStartParent) {
                const offset = this.boundaries.start.offset;
                item = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(node, offset, node.data.length - offset);
                charactersCount = item.data.length;
                position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item);
            } else {
                item = new $b9b9f2bdf9c6137f$export$b0e248170172f65f(node, 0, node.data.length);
                position.offset--;
            }
            this._position = position;
            return this._formatReturnValue("text", item, previousPosition, position, charactersCount);
        }
        position = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(parent);
        this._position = position;
        return this._formatReturnValue("elementStart", parent, previousPosition, position, 1);
    }
    /**
	* Format returned data and adjust `previousPosition` and `nextPosition` if
	* reach the bound of the {@link module:engine/view/text~ViewText}.
	*
	* @param type Type of step.
	* @param item Item between old and new position.
	* @param previousPosition Previous position of iterator.
	* @param nextPosition Next position of iterator.
	* @param length Length of the item.
	*/ _formatReturnValue(type, item, previousPosition, nextPosition, length) {
        if (item.is("view:$textProxy")) {
            if (item.offsetInText + item.data.length == item.textNode.data.length) {
                if (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position))) {
                    nextPosition = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item.textNode);
                    this._position = nextPosition;
                } else previousPosition = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item.textNode);
            }
            if (item.offsetInText === 0) {
                if (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position))) {
                    nextPosition = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item.textNode);
                    this._position = nextPosition;
                } else previousPosition = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item.textNode);
            }
        }
        return {
            done: false,
            value: {
                type: type,
                item: item,
                previousPosition: previousPosition,
                nextPosition: nextPosition,
                length: length
            }
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/position
*/ /**
* Position in the view tree. Position is represented by its parent node and an offset in this parent.
*
* In order to create a new position instance use the `createPosition*()` factory methods available in:
*
* * {@link module:engine/view/view~EditingView}
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter}
* * {@link module:engine/view/upcastwriter~ViewUpcastWriter}
*/ var $b9b9f2bdf9c6137f$export$7534acacc32db851 = class ViewPosition extends $b9b9f2bdf9c6137f$export$43d75c0e89b2169f {
    /**
	* Position parent.
	*/ parent;
    /**
	* Position offset.
	*/ offset;
    /**
	* Creates a position.
	*
	* @param parent Position parent.
	* @param offset Position offset.
	*/ constructor(parent, offset){
        super();
        this.parent = parent;
        this.offset = offset;
    }
    /**
	* Node directly after the position. Equals `null` when there is no node after position or position is located
	* inside text node.
	*/ get nodeAfter() {
        if (this.parent.is("$text")) return null;
        return this.parent.getChild(this.offset) || null;
    }
    /**
	* Node directly before the position. Equals `null` when there is no node before position or position is located
	* inside text node.
	*/ get nodeBefore() {
        if (this.parent.is("$text")) return null;
        return this.parent.getChild(this.offset - 1) || null;
    }
    /**
	* Is `true` if position is at the beginning of its {@link module:engine/view/position~ViewPosition#parent parent}, `false` otherwise.
	*/ get isAtStart() {
        return this.offset === 0;
    }
    /**
	* Is `true` if position is at the end of its {@link module:engine/view/position~ViewPosition#parent parent}, `false` otherwise.
	*/ get isAtEnd() {
        const endOffset = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
        return this.offset === endOffset;
    }
    /**
	* Position's root, that is the root of the position's parent element.
	*/ get root() {
        return this.parent.root;
    }
    /**
	* {@link module:engine/view/editableelement~ViewEditableElement ViewEditableElement} instance that contains this position, or `null` if
	* position is not inside an editable element.
	*/ get editableElement() {
        let editable = this.parent;
        while(!(editable instanceof $b9b9f2bdf9c6137f$export$785df0da0fc4f1c8))if (editable.parent) editable = editable.parent;
        else return null;
        return editable;
    }
    /**
	* Returns a new instance of Position with offset incremented by `shift` value.
	*
	* @param shift How position offset should get changed. Accepts negative values.
	* @returns Shifted position.
	*/ getShiftedBy(shift) {
        const shifted = ViewPosition._createAt(this);
        const offset = shifted.offset + shift;
        shifted.offset = offset < 0 ? 0 : offset;
        return shifted;
    }
    /**
	* Gets the farthest position which matches the callback using
	* {@link module:engine/view/treewalker~ViewTreeWalker TreeWalker}.
	*
	* For example:
	*
	* ```ts
	* getLastMatchingPosition( value => value.type == 'text' ); // <p>{}foo</p> -> <p>foo[]</p>
	* getLastMatchingPosition( value => value.type == 'text', { direction: 'backward' } ); // <p>foo[]</p> -> <p>{}foo</p>
	* getLastMatchingPosition( value => false ); // Do not move the position.
	* ```
	*
	* @param skip Callback function. Gets {@link module:engine/view/treewalker~ViewTreeWalkerValue} and should
	* return `true` if the value should be skipped or `false` if not.
	* @param options Object with configuration options. See {@link module:engine/view/treewalker~ViewTreeWalker}.
	* @returns The position after the last item which matches the `skip` callback test.
	*/ getLastMatchingPosition(skip, options = {}) {
        options.startPosition = this;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c08c3998433b96e1(options);
        treeWalker.skip(skip);
        return treeWalker.position;
    }
    /**
	* Returns ancestors array of this position, that is this position's parent and it's ancestors.
	*
	* @returns Array with ancestors.
	*/ getAncestors() {
        if (this.parent.is("documentFragment")) return [
            this.parent
        ];
        else return this.parent.getAncestors({
            includeSelf: true
        });
    }
    /**
	* Returns a {@link module:engine/view/node~ViewNode} or {@link module:engine/view/documentfragment~ViewDocumentFragment}
	* which is a common ancestor of both positions.
	*/ getCommonAncestor(position) {
        const ancestorsA = this.getAncestors();
        const ancestorsB = position.getAncestors();
        let i = 0;
        while(ancestorsA[i] == ancestorsB[i] && ancestorsA[i])i++;
        return i === 0 ? null : ancestorsA[i - 1];
    }
    /**
	* Checks whether this position equals given position.
	*
	* @param otherPosition Position to compare with.
	* @returns True if positions are same.
	*/ isEqual(otherPosition) {
        return this.parent == otherPosition.parent && this.offset == otherPosition.offset;
    }
    /**
	* Checks whether this position is located before given position. When method returns `false` it does not mean that
	* this position is after give one. Two positions may be located inside separate roots and in that situation this
	* method will still return `false`.
	*
	* @see module:engine/view/position~ViewPosition#isAfter
	* @see module:engine/view/position~ViewPosition#compareWith
	* @param otherPosition Position to compare with.
	* @returns Returns `true` if this position is before given position.
	*/ isBefore(otherPosition) {
        return this.compareWith(otherPosition) == "before";
    }
    /**
	* Checks whether this position is located after given position. When method returns `false` it does not mean that
	* this position is before give one. Two positions may be located inside separate roots and in that situation this
	* method will still return `false`.
	*
	* @see module:engine/view/position~ViewPosition#isBefore
	* @see module:engine/view/position~ViewPosition#compareWith
	* @param otherPosition Position to compare with.
	* @returns Returns `true` if this position is after given position.
	*/ isAfter(otherPosition) {
        return this.compareWith(otherPosition) == "after";
    }
    /**
	* Checks whether this position is before, after or in same position that other position. Two positions may be also
	* different when they are located in separate roots.
	*
	* @param otherPosition Position to compare with.
	*/ compareWith(otherPosition) {
        if (this.root !== otherPosition.root) return "different";
        if (this.isEqual(otherPosition)) return "same";
        const thisPath = this.parent.is("node") ? this.parent.getPath() : [];
        const otherPath = otherPosition.parent.is("node") ? otherPosition.parent.getPath() : [];
        thisPath.push(this.offset);
        otherPath.push(otherPosition.offset);
        const result = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(thisPath, otherPath);
        switch(result){
            case "prefix":
                return "before";
            case "extension":
                return "after";
            default:
                return thisPath[result] < otherPath[result] ? "before" : "after";
        }
    }
    /**
	* Creates a {@link module:engine/view/treewalker~ViewTreeWalker TreeWalker} instance with this positions as a start position.
	*
	* @param options Object with configuration options. See {@link module:engine/view/treewalker~ViewTreeWalker}
	*/ getWalker(options = {}) {
        options.startPosition = this;
        return new $b9b9f2bdf9c6137f$export$c08c3998433b96e1(options);
    }
    /**
	* Clones this position.
	*/ clone() {
        return new ViewPosition(this.parent, this.offset);
    }
    /**
	* Converts `ViewPosition` instance to plain object and returns it.
	*
	* @returns `ViewPosition` instance converted to plain object.
	*/ toJSON() {
        return {
            parent: this.parent.toJSON(),
            offset: this.offset
        };
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/view/position~ViewPosition position},
	* * parent element and offset (offset defaults to `0`),
	* * parent element and `'end'` (sets position at the end of that element),
	* * {@link module:engine/view/item~ViewItem view item} and `'before'` or `'after'` (sets position before or after given view item).
	*
	* This method is a shortcut to other constructors such as:
	*
	* * {@link module:engine/view/position~ViewPosition._createBefore},
	* * {@link module:engine/view/position~ViewPosition._createAfter}.
	*
	* @internal
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ static _createAt(itemOrPosition, offset) {
        if (itemOrPosition instanceof ViewPosition) return new this(itemOrPosition.parent, itemOrPosition.offset);
        else {
            const node = itemOrPosition;
            if (offset == "end") offset = node.is("$text") ? node.data.length : node.childCount;
            else if (offset == "before") return this._createBefore(node);
            else if (offset == "after") return this._createAfter(node);
            else if (offset !== 0 && !offset) /**
			* {@link module:engine/view/view~EditingView#createPositionAt `View#createPositionAt()`}
			* requires the offset to be specified when the first parameter is a view item.
			*
			* @error view-createpositionat-offset-required
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-createpositionat-offset-required", node);
            return new ViewPosition(node, offset);
        }
    }
    /**
	* Creates a new position after given view item.
	*
	* @internal
	* @param item View item after which the position should be located.
	*/ static _createAfter(item) {
        if (item.is("$textProxy")) return new ViewPosition(item.textNode, item.offsetInText + item.data.length);
        if (!item.parent) /**
		* You cannot make a position after a root.
		*
		* @error view-position-after-root
		* @param {module:engine/view/node~ViewNode} root A root item.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-position-after-root", item, {
            root: item
        });
        return new ViewPosition(item.parent, item.index + 1);
    }
    /**
	* Creates a new position before given view item.
	*
	* @internal
	* @param item View item before which the position should be located.
	*/ static _createBefore(item) {
        if (item.is("$textProxy")) return new ViewPosition(item.textNode, item.offsetInText);
        if (!item.parent) /**
		* You cannot make a position before a root.
		*
		* @error view-position-before-root
		* @param {module:engine/view/node~ViewNode} root A root item.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-position-before-root", item, {
            root: item
        });
        return new ViewPosition(item.parent, item.index);
    }
};
$b9b9f2bdf9c6137f$export$7534acacc32db851.prototype.is = function(type) {
    return type === "position" || type === "view:position";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/range
*/ /**
* Range in the view tree. A range is represented by its start and end {@link module:engine/view/position~ViewPosition positions}.
*
* In order to create a new position instance use the `createPosition*()` factory methods available in:
*
* * {@link module:engine/view/view~EditingView}
* * {@link module:engine/view/downcastwriter~ViewDowncastWriter}
* * {@link module:engine/view/upcastwriter~ViewUpcastWriter}
*/ var $b9b9f2bdf9c6137f$export$829eb746b222877 = class ViewRange extends $b9b9f2bdf9c6137f$export$43d75c0e89b2169f {
    /**
	* Start position.
	*/ start;
    /**
	* End position.
	*/ end;
    /**
	* Creates a range spanning from `start` position to `end` position.
	*
	* **Note:** Constructor creates it's own {@link module:engine/view/position~ViewPosition} instances basing on passed values.
	*
	* @param start Start position.
	* @param end End position. If not set, range will be collapsed at the `start` position.
	*/ constructor(start, end = null){
        super();
        this.start = start.clone();
        this.end = end ? end.clone() : start.clone();
    }
    /**
	* Iterable interface.
	*
	* Iterates over all {@link module:engine/view/item~ViewItem view items} that are in this range and returns
	* them together with additional information like length or {@link module:engine/view/position~ViewPosition positions},
	* grouped as {@link module:engine/view/treewalker~ViewTreeWalkerValue}.
	*
	* This iterator uses {@link module:engine/view/treewalker~ViewTreeWalker TreeWalker} with `boundaries` set to this range and
	* `ignoreElementEnd` option
	* set to `true`.
	*/ *[Symbol.iterator]() {
        yield* new $b9b9f2bdf9c6137f$export$c08c3998433b96e1({
            boundaries: this,
            ignoreElementEnd: true
        });
    }
    /**
	* Returns whether the range is collapsed, that is it start and end positions are equal.
	*/ get isCollapsed() {
        return this.start.isEqual(this.end);
    }
    /**
	* Returns whether this range is flat, that is if {@link module:engine/view/range~ViewRange#start start} position and
	* {@link module:engine/view/range~ViewRange#end end} position are in the same
	* {@link module:engine/view/position~ViewPosition#parent parent}.
	*/ get isFlat() {
        return this.start.parent === this.end.parent;
    }
    /**
	* Range root element.
	*/ get root() {
        return this.start.root;
    }
    /**
	* Creates a maximal range that has the same content as this range but is expanded in both ways (at the beginning
	* and at the end).
	*
	* For example:
	*
	* ```html
	* <p>Foo</p><p><b>{Bar}</b></p> -> <p>Foo</p>[<p><b>Bar</b>]</p>
	* <p><b>foo</b>{bar}<span></span></p> -> <p><b>foo[</b>bar<span></span>]</p>
	* ```
	*
	* Note that in the sample above:
	*
	* - `<p>` have type of {@link module:engine/view/containerelement~ViewContainerElement},
	* - `<b>` have type of {@link module:engine/view/attributeelement~ViewAttributeElement},
	* - `<span>` have type of {@link module:engine/view/uielement~ViewUIElement}.
	*
	* @returns Enlarged range.
	*/ getEnlarged() {
        let start = this.start.getLastMatchingPosition($b9b9f2bdf9c6137f$var$enlargeTrimSkip, {
            direction: "backward"
        });
        let end = this.end.getLastMatchingPosition($b9b9f2bdf9c6137f$var$enlargeTrimSkip);
        if (start.parent.is("$text") && start.isAtStart) start = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(start.parent);
        if (end.parent.is("$text") && end.isAtEnd) end = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(end.parent);
        return new ViewRange(start, end);
    }
    /**
	* Creates a minimum range that has the same content as this range but is trimmed in both ways (at the beginning
	* and at the end).
	*
	* For example:
	*
	* ```html
	* <p>Foo</p>[<p><b>Bar</b>]</p> -> <p>Foo</p><p><b>{Bar}</b></p>
	* <p><b>foo[</b>bar<span></span>]</p> -> <p><b>foo</b>{bar}<span></span></p>
	* ```
	*
	* Note that in the sample above:
	*
	* - `<p>` have type of {@link module:engine/view/containerelement~ViewContainerElement},
	* - `<b>` have type of {@link module:engine/view/attributeelement~ViewAttributeElement},
	* - `<span>` have type of {@link module:engine/view/uielement~ViewUIElement}.
	*
	* @returns Shrunk range.
	*/ getTrimmed() {
        let start = this.start.getLastMatchingPosition($b9b9f2bdf9c6137f$var$enlargeTrimSkip);
        if (start.isAfter(this.end) || start.isEqual(this.end)) return new ViewRange(start, start);
        let end = this.end.getLastMatchingPosition($b9b9f2bdf9c6137f$var$enlargeTrimSkip, {
            direction: "backward"
        });
        const nodeAfterStart = start.nodeAfter;
        const nodeBeforeEnd = end.nodeBefore;
        if (nodeAfterStart && nodeAfterStart.is("$text")) start = new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeAfterStart, 0);
        if (nodeBeforeEnd && nodeBeforeEnd.is("$text")) end = new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeBeforeEnd, nodeBeforeEnd.data.length);
        return new ViewRange(start, end);
    }
    /**
	* Two ranges are equal if their start and end positions are equal.
	*
	* @param otherRange Range to compare with.
	* @returns `true` if ranges are equal, `false` otherwise
	*/ isEqual(otherRange) {
        return this == otherRange || this.start.isEqual(otherRange.start) && this.end.isEqual(otherRange.end);
    }
    /**
	* Checks whether this range contains given {@link module:engine/view/position~ViewPosition position}.
	*
	* @param position Position to check.
	* @returns `true` if given {@link module:engine/view/position~ViewPosition position} is contained in this range, `false` otherwise.
	*/ containsPosition(position) {
        return position.isAfter(this.start) && position.isBefore(this.end);
    }
    /**
	* Checks whether this range contains given {@link module:engine/view/range~ViewRange range}.
	*
	* @param otherRange Range to check.
	* @param loose Whether the check is loose or strict. If the check is strict (`false`), compared range cannot
	* start or end at the same position as this range boundaries. If the check is loose (`true`), compared range can start, end or
	* even be equal to this range. Note that collapsed ranges are always compared in strict mode.
	* @returns `true` if given {@link module:engine/view/range~ViewRange range} boundaries are contained by this range, `false`
	* otherwise.
	*/ containsRange(otherRange, loose = false) {
        if (otherRange.isCollapsed) loose = false;
        const containsStart = this.containsPosition(otherRange.start) || loose && this.start.isEqual(otherRange.start);
        const containsEnd = this.containsPosition(otherRange.end) || loose && this.end.isEqual(otherRange.end);
        return containsStart && containsEnd;
    }
    /**
	* Computes which part(s) of this {@link module:engine/view/range~ViewRange range} is not a part of given
	* {@link module:engine/view/range~ViewRange range}.
	* Returned array contains zero, one or two {@link module:engine/view/range~ViewRange ranges}.
	*
	* Examples:
	*
	* ```ts
	* let foo = downcastWriter.createText( 'foo' );
	* let img = downcastWriter.createContainerElement( 'img' );
	* let bar = downcastWriter.createText( 'bar' );
	* let p = downcastWriter.createContainerElement( 'p', null, [ foo, img, bar ] );
	*
	* let range = view.createRange( view.createPositionAt( foo, 2 ), view.createPositionAt( bar, 1 ); // "o", img, "b" are in range.
	* let otherRange = view.createRange( // "oo", img, "ba" are in range.
	* 	view.createPositionAt( foo, 1 ),
	* 	view.createPositionAt( bar, 2 )
	* );
	* let transformed = range.getDifference( otherRange );
	* // transformed array has no ranges because `otherRange` contains `range`
	*
	* otherRange = view.createRange( view.createPositionAt( foo, 1 ), view.createPositionAt( p, 2 ); // "oo", img are in range.
	* transformed = range.getDifference( otherRange );
	* // transformed array has one range: from ( p, 2 ) to ( bar, 1 )
	*
	* otherRange = view.createRange( view.createPositionAt( p, 1 ), view.createPositionAt( p, 2 ) ); // img is in range.
	* transformed = range.getDifference( otherRange );
	* // transformed array has two ranges: from ( foo, 1 ) to ( p, 1 ) and from ( p, 2 ) to ( bar, 1 )
	* ```
	*
	* @param otherRange Range to differentiate against.
	* @returns The difference between ranges.
	*/ getDifference(otherRange) {
        const ranges = [];
        if (this.isIntersecting(otherRange)) {
            if (this.containsPosition(otherRange.start)) ranges.push(new ViewRange(this.start, otherRange.start));
            if (this.containsPosition(otherRange.end)) ranges.push(new ViewRange(otherRange.end, this.end));
        } else ranges.push(this.clone());
        return ranges;
    }
    /**
	* Returns an intersection of this {@link module:engine/view/range~ViewRange range}
	* and given {@link module:engine/view/range~ViewRange range}.
	* Intersection is a common part of both of those ranges. If ranges has no common part, returns `null`.
	*
	* Examples:
	*
	* ```ts
	* let foo = downcastWriter.createText( 'foo' );
	* let img = downcastWriter.createContainerElement( 'img' );
	* let bar = downcastWriter.createText( 'bar' );
	* let p = downcastWriter.createContainerElement( 'p', null, [ foo, img, bar ] );
	*
	* let range = view.createRange( view.createPositionAt( foo, 2 ), view.createPositionAt( bar, 1 ); // "o", img, "b" are in range.
	* let otherRange = view.createRange( view.createPositionAt( foo, 1 ), view.createPositionAt( p, 2 ); // "oo", img are in range.
	* let transformed = range.getIntersection( otherRange ); // range from ( foo, 1 ) to ( p, 2 ).
	*
	* otherRange = view.createRange( view.createPositionAt( bar, 1 ), view.createPositionAt( bar, 3 ); "ar" is in range.
	* transformed = range.getIntersection( otherRange ); // null - no common part.
	* ```
	*
	* @param otherRange Range to check for intersection.
	* @returns A common part of given ranges or `null` if ranges have no common part.
	*/ getIntersection(otherRange) {
        if (this.isIntersecting(otherRange)) {
            let commonRangeStart = this.start;
            let commonRangeEnd = this.end;
            if (this.containsPosition(otherRange.start)) commonRangeStart = otherRange.start;
            if (this.containsPosition(otherRange.end)) commonRangeEnd = otherRange.end;
            return new ViewRange(commonRangeStart, commonRangeEnd);
        }
        return null;
    }
    /**
	* Creates a {@link module:engine/view/treewalker~ViewTreeWalker TreeWalker} instance with this range as a boundary.
	*
	* @param options Object with configuration options. See {@link module:engine/view/treewalker~ViewTreeWalker}.
	*/ getWalker(options = {}) {
        options.boundaries = this;
        return new $b9b9f2bdf9c6137f$export$c08c3998433b96e1(options);
    }
    /**
	* Returns a {@link module:engine/view/node~ViewNode} or {@link module:engine/view/documentfragment~ViewDocumentFragment}
	* which is a common ancestor of range's both ends (in which the entire range is contained).
	*/ getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
    }
    /**
	* Returns an {@link module:engine/view/element~ViewElement Element} contained by the range.
	* The element will be returned when it is the **only** node within the range and **fully–contained**
	* at the same time.
	*/ getContainedElement() {
        if (this.isCollapsed) return null;
        let nodeAfterStart = this.start.nodeAfter;
        let nodeBeforeEnd = this.end.nodeBefore;
        if (this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling) nodeAfterStart = this.start.parent.nextSibling;
        if (this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling) nodeBeforeEnd = this.end.parent.previousSibling;
        if (nodeAfterStart && nodeAfterStart.is("element") && nodeAfterStart === nodeBeforeEnd) return nodeAfterStart;
        return null;
    }
    /**
	* Clones this range.
	*/ clone() {
        return new ViewRange(this.start, this.end);
    }
    /**
	* Returns an iterator that iterates over all {@link module:engine/view/item~ViewItem view items} that are in this range and returns
	* them.
	*
	* This method uses {@link module:engine/view/treewalker~ViewTreeWalker} with `boundaries` set to this range
	* and `ignoreElementEnd` option set to `true`. However it returns only {@link module:engine/view/item~ViewItem items},
	* not {@link module:engine/view/treewalker~ViewTreeWalkerValue}.
	*
	* You may specify additional options for the tree walker. See {@link module:engine/view/treewalker~ViewTreeWalker} for
	* a full list of available options.
	*
	* @param options Object with configuration options. See {@link module:engine/view/treewalker~ViewTreeWalker}.
	*/ *getItems(options = {}) {
        options.boundaries = this;
        options.ignoreElementEnd = true;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c08c3998433b96e1(options);
        for (const value of treeWalker)yield value.item;
    }
    /**
	* Returns an iterator that iterates over all {@link module:engine/view/position~ViewPosition positions} that are boundaries or
	* contained in this range.
	*
	* This method uses {@link module:engine/view/treewalker~ViewTreeWalker} with `boundaries` set to this range. However it returns only
	* {@link module:engine/view/position~ViewPosition positions}, not {@link module:engine/view/treewalker~ViewTreeWalkerValue}.
	*
	* You may specify additional options for the tree walker. See {@link module:engine/view/treewalker~ViewTreeWalker} for
	* a full list of available options.
	*
	* @param options Object with configuration options. See {@link module:engine/view/treewalker~ViewTreeWalker}.
	*/ *getPositions(options = {}) {
        options.boundaries = this;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c08c3998433b96e1(options);
        yield treeWalker.position;
        for (const value of treeWalker)yield value.nextPosition;
    }
    /**
	* Checks and returns whether this range intersects with the given range.
	*
	* @param otherRange Range to compare with.
	* @returns True if ranges intersect.
	*/ isIntersecting(otherRange) {
        return this.start.isBefore(otherRange.end) && this.end.isAfter(otherRange.start);
    }
    /**
	* Converts `ViewRange` instance to plain object and returns it.
	*
	* @returns `ViewRange` instance converted to plain object.
	*/ toJSON() {
        return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
        };
    }
    /**
	* Creates a range from the given parents and offsets.
	*
	* @internal
	* @param startElement Start position parent element.
	* @param startOffset Start position offset.
	* @param endElement End position parent element.
	* @param endOffset End position offset.
	* @returns Created range.
	*/ static _createFromParentsAndOffsets(startElement, startOffset, endElement, endOffset) {
        return new this(new $b9b9f2bdf9c6137f$export$7534acacc32db851(startElement, startOffset), new $b9b9f2bdf9c6137f$export$7534acacc32db851(endElement, endOffset));
    }
    /**
	* Creates a new range, spreading from specified {@link module:engine/view/position~ViewPosition position} to a position moved by
	* given `shift`. If `shift` is a negative value, shifted position is treated as the beginning of the range.
	*
	* @internal
	* @param position Beginning of the range.
	* @param shift How long the range should be.
	*/ static _createFromPositionAndShift(position, shift) {
        const start = position;
        const end = position.getShiftedBy(shift);
        return shift > 0 ? new this(start, end) : new this(end, start);
    }
    /**
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* @internal
	* @param element Element which is a parent for the range.
	*/ static _createIn(element) {
        return this._createFromParentsAndOffsets(element, 0, element, element.childCount);
    }
    /**
	* Creates a range that starts before given {@link module:engine/view/item~ViewItem view item} and ends after it.
	*
	* @internal
	*/ static _createOn(item) {
        const size = item.is("$textProxy") ? item.offsetSize : 1;
        return this._createFromPositionAndShift($b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item), size);
    }
};
$b9b9f2bdf9c6137f$export$829eb746b222877.prototype.is = function(type) {
    return type === "range" || type === "view:range";
};
/**
* Function used by getEnlarged and getTrimmed methods.
*/ function $b9b9f2bdf9c6137f$var$enlargeTrimSkip(value) {
    if (value.item.is("attributeElement") || value.item.is("uiElement")) return true;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/selection
*/ const $b9b9f2bdf9c6137f$var$ViewSelectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$43d75c0e89b2169f);
/**
* Class representing an arbirtary selection in the view.
* See also {@link module:engine/view/documentselection~ViewDocumentSelection}.
*
* New selection instances can be created via the constructor or one these methods:
*
* * {@link module:engine/view/view~EditingView#createSelection `View#createSelection()`},
* * {@link module:engine/view/upcastwriter~ViewUpcastWriter#createSelection `UpcastWriter#createSelection()`}.
*
* A selection can consist of {@link module:engine/view/range~ViewRange ranges} that can be set by using
* the {@link module:engine/view/selection~ViewSelection#setTo `Selection#setTo()`} method.
*/ var $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e = class ViewSelection extends $b9b9f2bdf9c6137f$var$ViewSelectionBase {
    /**
	* Stores all ranges that are selected.
	*/ _ranges;
    /**
	* Specifies whether the last added range was added as a backward or forward range.
	*/ _lastRangeBackward;
    /**
	* Specifies whether selection instance is fake.
	*/ _isFake;
    /**
	* Fake selection's label.
	*/ _fakeSelectionLabel;
    /**
	* Creates new selection instance.
	*
	* **Note**: The selection constructor is available as a factory method:
	*
	* * {@link module:engine/view/view~EditingView#createSelection `View#createSelection()`},
	* * {@link module:engine/view/upcastwriter~ViewUpcastWriter#createSelection `UpcastWriter#createSelection()`}.
	*
	* ```ts
	* // Creates empty selection without ranges.
	* const selection = writer.createSelection();
	*
	* // Creates selection at the given range.
	* const range = writer.createRange( start, end );
	* const selection = writer.createSelection( range );
	*
	* // Creates selection at the given ranges
	* const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
	* const selection = writer.createSelection( ranges );
	*
	* // Creates selection from the other selection.
	* const otherSelection = writer.createSelection();
	* const selection = writer.createSelection( otherSelection );
	*
	* // Creates selection from the document selection.
	* const selection = writer.createSelection( editor.editing.view.document.selection );
	*
	* // Creates selection at the given position.
	* const position = writer.createPositionFromPath( root, path );
	* const selection = writer.createSelection( position );
	*
	* // Creates collapsed selection at the position of given item and offset.
	* const paragraph = writer.createContainerElement( 'paragraph' );
	* const selection = writer.createSelection( paragraph, offset );
	*
	* // Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the
	* // first child of that element and ends after the last child of that element.
	* const selection = writer.createSelection( paragraph, 'in' );
	*
	* // Creates a range on an {@link module:engine/view/item~ViewItem item} which starts before the item and ends
	* // just after the item.
	* const selection = writer.createSelection( paragraph, 'on' );
	* ```
	*
	* `Selection`'s constructor allow passing additional options (`backward`, `fake` and `label`) as the last argument.
	*
	* ```ts
	* // Creates backward selection.
	* const selection = writer.createSelection( range, { backward: true } );
	* ```
	*
	* Fake selection does not render as browser native selection over selected elements and is hidden to the user.
	* This way, no native selection UI artifacts are displayed to the user and selection over elements can be
	* represented in other way, for example by applying proper CSS class.
	*
	* Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM
	* (and be  properly handled by screen readers).
	*
	* ```ts
	* // Creates fake selection with label.
	* const selection = writer.createSelection( range, { fake: true, label: 'foo' } );
	* ```
	*
	* @internal
	*/ constructor(...args){
        super();
        this._ranges = [];
        this._lastRangeBackward = false;
        this._isFake = false;
        this._fakeSelectionLabel = "";
        if (args.length) this.setTo(...args);
    }
    /**
	* Returns true if selection instance is marked as `fake`.
	*
	* @see #setTo
	*/ get isFake() {
        return this._isFake;
    }
    /**
	* Returns fake selection label.
	*
	* @see #setTo
	*/ get fakeSelectionLabel() {
        return this._fakeSelectionLabel;
    }
    /**
	* Selection anchor. Anchor may be described as a position where the selection starts. Together with
	* {@link #focus focus} they define the direction of selection, which is important
	* when expanding/shrinking selection. Anchor is always the start or end of the most recent added range.
	* It may be a bit unintuitive when there are multiple ranges in selection.
	*
	* @see #focus
	*/ get anchor() {
        if (!this._ranges.length) return null;
        const range = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? range.end : range.start).clone();
    }
    /**
	* Selection focus. Focus is a position where the selection ends.
	*
	* @see #anchor
	*/ get focus() {
        if (!this._ranges.length) return null;
        const range = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? range.start : range.end).clone();
    }
    /**
	* Returns whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
	* collapsed.
	*/ get isCollapsed() {
        return this.rangeCount === 1 && this._ranges[0].isCollapsed;
    }
    /**
	* Returns number of ranges in selection.
	*/ get rangeCount() {
        return this._ranges.length;
    }
    /**
	* Specifies whether the {@link #focus} precedes {@link #anchor}.
	*/ get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
    }
    /**
	* {@link module:engine/view/editableelement~ViewEditableElement ViewEditableElement} instance that contains this selection, or `null`
	* if the selection is not inside an editable element.
	*/ get editableElement() {
        if (this.anchor) return this.anchor.editableElement;
        return null;
    }
    /**
	* Returns an iterable that contains copies of all ranges added to the selection.
	*/ *getRanges() {
        for (const range of this._ranges)yield range.clone();
    }
    /**
	* Returns copy of the first range in the selection. First range is the one which
	* {@link module:engine/view/range~ViewRange#start start} position
	* {@link module:engine/view/position~ViewPosition#isBefore is before} start
	* position of all other ranges (not to confuse with the first range added to the selection).
	* Returns `null` if no ranges are added to selection.
	*/ getFirstRange() {
        let first = null;
        for (const range of this._ranges)if (!first || range.start.isBefore(first.start)) first = range;
        return first ? first.clone() : null;
    }
    /**
	* Returns copy of the last range in the selection. Last range is the one which {@link module:engine/view/range~ViewRange#end end}
	* position {@link module:engine/view/position~ViewPosition#isAfter is after} end position of all other ranges (not to confuse
	* with the last range added to the selection). Returns `null` if no ranges are added to selection.
	*/ getLastRange() {
        let last = null;
        for (const range of this._ranges)if (!last || range.end.isAfter(last.end)) last = range;
        return last ? last.clone() : null;
    }
    /**
	* Returns copy of the first position in the selection. First position is the position that
	* {@link module:engine/view/position~ViewPosition#isBefore is before} any other position in the selection ranges.
	* Returns `null` if no ranges are added to selection.
	*/ getFirstPosition() {
        const firstRange = this.getFirstRange();
        return firstRange ? firstRange.start.clone() : null;
    }
    /**
	* Returns copy of the last position in the selection. Last position is the position that
	* {@link module:engine/view/position~ViewPosition#isAfter is after} any other position in the selection ranges.
	* Returns `null` if no ranges are added to selection.
	*/ getLastPosition() {
        const lastRange = this.getLastRange();
        return lastRange ? lastRange.end.clone() : null;
    }
    /**
	* Checks whether, this selection is equal to given selection. Selections are equal if they have same directions,
	* same number of ranges and all ranges from one selection equal to a range from other selection.
	*
	* @param otherSelection Selection to compare with.
	* @returns `true` if selections are equal, `false` otherwise.
	*/ isEqual(otherSelection) {
        if (this.isFake != otherSelection.isFake) return false;
        if (this.isFake && this.fakeSelectionLabel != otherSelection.fakeSelectionLabel) return false;
        if (this.rangeCount != otherSelection.rangeCount) return false;
        else if (this.rangeCount === 0) return true;
        if (!this.anchor.isEqual(otherSelection.anchor) || !this.focus.isEqual(otherSelection.focus)) return false;
        for (const thisRange of this._ranges){
            let found = false;
            for (const otherRange of otherSelection._ranges)if (thisRange.isEqual(otherRange)) {
                found = true;
                break;
            }
            if (!found) return false;
        }
        return true;
    }
    /**
	* Checks whether this selection is similar to given selection. Selections are similar if they have same directions, same
	* number of ranges, and all {@link module:engine/view/range~ViewRange#getTrimmed trimmed} ranges from one selection are
	* equal to any trimmed range from other selection.
	*
	* @param otherSelection Selection to compare with.
	* @returns `true` if selections are similar, `false` otherwise.
	*/ isSimilar(otherSelection) {
        if (this.isBackward != otherSelection.isBackward) return false;
        const numOfRangesA = (0, $c7bc2cb7e2db0227$export$85b9a36db797e02b)(this.getRanges());
        if (numOfRangesA != (0, $c7bc2cb7e2db0227$export$85b9a36db797e02b)(otherSelection.getRanges())) return false;
        if (numOfRangesA == 0) return true;
        for (let rangeA of this.getRanges()){
            rangeA = rangeA.getTrimmed();
            let found = false;
            for (let rangeB of otherSelection.getRanges()){
                rangeB = rangeB.getTrimmed();
                if (rangeA.start.isEqual(rangeB.start) && rangeA.end.isEqual(rangeB.end)) {
                    found = true;
                    break;
                }
            }
            if (!found) return false;
        }
        return true;
    }
    /**
	* Returns the selected element. {@link module:engine/view/element~ViewElement Element} is considered as selected if there is only
	* one range in the selection, and that range contains exactly one element.
	* Returns `null` if there is no selected element.
	*/ getSelectedElement() {
        if (this.rangeCount !== 1) return null;
        return this.getFirstRange().getContainedElement();
    }
    /**
	* Sets this selection's ranges and direction to the specified location based on the given
	* {@link module:engine/view/selection~ViewSelectable selectable}.
	*
	* ```ts
	* // Sets selection to the given range.
	* const range = writer.createRange( start, end );
	* selection.setTo( range );
	*
	* // Sets selection to given ranges.
	* const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
	* selection.setTo( range );
	*
	* // Sets selection to the other selection.
	* const otherSelection = writer.createSelection();
	* selection.setTo( otherSelection );
	*
	* // Sets selection to contents of ViewDocumentSelection.
	* selection.setTo( editor.editing.view.document.selection );
	*
	* // Sets collapsed selection at the given position.
	* const position = writer.createPositionAt( root, path );
	* selection.setTo( position );
	*
	* // Sets collapsed selection at the position of given item and offset.
	* selection.setTo( paragraph, offset );
	* ```
	*
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* ```ts
	* selection.setTo( paragraph, 'in' );
	* ```
	*
	* Creates a range on an {@link module:engine/view/item~ViewItem item} which starts before the item and ends just after the item.
	*
	* ```ts
	* selection.setTo( paragraph, 'on' );
	*
	* // Clears selection. Removes all ranges.
	* selection.setTo( null );
	* ```
	*
	* `Selection#setTo()` method allow passing additional options (`backward`, `fake` and `label`) as the last argument.
	*
	* ```ts
	* // Sets selection as backward.
	* selection.setTo( range, { backward: true } );
	* ```
	*
	* Fake selection does not render as browser native selection over selected elements and is hidden to the user.
	* This way, no native selection UI artifacts are displayed to the user and selection over elements can be
	* represented in other way, for example by applying proper CSS class.
	*
	* Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM
	* (and be  properly handled by screen readers).
	*
	* ```ts
	* // Creates fake selection with label.
	* selection.setTo( range, { fake: true, label: 'foo' } );
	* ```
	*
	* @fires change
	*/ setTo(...args) {
        let [selectable, placeOrOffset, options] = args;
        if (typeof placeOrOffset == "object") {
            options = placeOrOffset;
            placeOrOffset = void 0;
        }
        if (selectable === null) {
            this._setRanges([]);
            this._setFakeOptions(options);
        } else if (selectable instanceof ViewSelection || selectable instanceof $b9b9f2bdf9c6137f$export$88e7995732ec83f3) {
            this._setRanges(selectable.getRanges(), selectable.isBackward);
            this._setFakeOptions({
                fake: selectable.isFake,
                label: selectable.fakeSelectionLabel
            });
        } else if (selectable instanceof $b9b9f2bdf9c6137f$export$829eb746b222877) {
            this._setRanges([
                selectable
            ], options && options.backward);
            this._setFakeOptions(options);
        } else if (selectable instanceof $b9b9f2bdf9c6137f$export$7534acacc32db851) {
            this._setRanges([
                new $b9b9f2bdf9c6137f$export$829eb746b222877(selectable)
            ]);
            this._setFakeOptions(options);
        } else if (selectable instanceof $b9b9f2bdf9c6137f$export$1de540da1a7d61ca) {
            const backward = !!options && !!options.backward;
            let range;
            if (placeOrOffset === void 0) /**
			* selection.setTo requires the second parameter when the first parameter is a node.
			*
			* @error view-selection-setto-required-second-parameter
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-selection-setto-required-second-parameter", this);
            else if (placeOrOffset == "in") range = $b9b9f2bdf9c6137f$export$829eb746b222877._createIn(selectable);
            else if (placeOrOffset == "on") range = $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(selectable);
            else range = new $b9b9f2bdf9c6137f$export$829eb746b222877($b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(selectable, placeOrOffset));
            this._setRanges([
                range
            ], backward);
            this._setFakeOptions(options);
        } else if ((0, $c7bc2cb7e2db0227$export$9652023d9040757)(selectable)) {
            this._setRanges(selectable, options && options.backward);
            this._setFakeOptions(options);
        } else /**
		* Cannot set selection to given place.
		*
		* @error view-selection-setto-not-selectable
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-selection-setto-not-selectable", this);
        this.fire("change");
    }
    /**
	* Moves {@link #focus} to the specified location.
	*
	* The location can be specified in the same form as
	* {@link module:engine/view/view~EditingView#createPositionAt view.createPositionAt()}
	* parameters.
	*
	* @fires change
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ setFocus(itemOrPosition, offset) {
        if (this.anchor === null) /**
		* Cannot set selection focus if there are no ranges in selection.
		*
		* @error view-selection-setfocus-no-ranges
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-selection-setfocus-no-ranges", this);
        const newFocus = $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(itemOrPosition, offset);
        if (newFocus.compareWith(this.focus) == "same") return;
        const anchor = this.anchor;
        this._ranges.pop();
        if (newFocus.compareWith(anchor) == "before") this._addRange(new $b9b9f2bdf9c6137f$export$829eb746b222877(newFocus, anchor), true);
        else this._addRange(new $b9b9f2bdf9c6137f$export$829eb746b222877(anchor, newFocus));
        this.fire("change");
    }
    /**
	* Converts `ViewSelection` instance to plain object and returns it.
	*
	* @returns `ViewSelection` instance converted to plain object.
	*/ toJSON() {
        const json = {
            ranges: Array.from(this.getRanges()).map((range)=>range.toJSON())
        };
        if (this.isBackward) json.isBackward = true;
        if (this.isFake) json.isFake = true;
        return json;
    }
    /**
	* Replaces all ranges that were added to the selection with given array of ranges. Last range of the array
	* is treated like the last added range and is used to set {@link #anchor anchor} and {@link #focus focus}.
	* Accepts a flag describing in which way the selection is made.
	*
	* @param newRanges Iterable object of ranges to set.
	* @param isLastBackward Flag describing if last added range was selected forward - from start to end
	* (`false`) or backward - from end to start (`true`). Defaults to `false`.
	*/ _setRanges(newRanges, isLastBackward = false) {
        newRanges = Array.from(newRanges);
        this._ranges = [];
        for (const range of newRanges)this._addRange(range);
        this._lastRangeBackward = !!isLastBackward;
    }
    /**
	* Sets this selection instance to be marked as `fake`. A fake selection does not render as browser native selection
	* over selected elements and is hidden to the user. This way, no native selection UI artifacts are displayed to
	* the user and selection over elements can be represented in other way, for example by applying proper CSS class.
	*
	* Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM (and be
	* properly handled by screen readers).
	*/ _setFakeOptions(options = {}) {
        this._isFake = !!options.fake;
        this._fakeSelectionLabel = options.fake ? options.label || "" : "";
    }
    /**
	* Adds a range to the selection. Added range is copied. This means that passed range is not saved in the
	* selection instance and you can safely operate on it.
	*
	* Accepts a flag describing in which way the selection is made - passed range might be selected from
	* {@link module:engine/view/range~ViewRange#start start} to {@link module:engine/view/range~ViewRange#end end}
	* or from {@link module:engine/view/range~ViewRange#end end} to {@link module:engine/view/range~ViewRange#start start}.
	* The flag is used to set {@link #anchor anchor} and {@link #focus focus} properties.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-selection-range-intersects` if added range intersects
	* with ranges already stored in Selection instance.
	*/ _addRange(range, isBackward = false) {
        if (!(range instanceof $b9b9f2bdf9c6137f$export$829eb746b222877)) /**
		* Selection range set to an object that is not an instance of {@link module:engine/view/range~ViewRange}.
		*
		* @error view-selection-add-range-not-range
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-selection-add-range-not-range", this);
        this._pushRange(range);
        this._lastRangeBackward = !!isBackward;
    }
    /**
	* Adds range to selection - creates copy of given range so it can be safely used and modified.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-selection-range-intersects` if added range intersects
	* with ranges already stored in selection instance.
	*/ _pushRange(range) {
        for (const storedRange of this._ranges)if (range.isIntersecting(storedRange)) /**
		* Trying to add a range that intersects with another range from selection.
		*
		* @error view-selection-range-intersects
		* @param {module:engine/view/range~ViewRange} addedRange Range that was added to the selection.
		* @param {module:engine/view/range~ViewRange} intersectingRange Range from selection that intersects with `addedRange`.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-selection-range-intersects", this, {
            addedRange: range,
            intersectingRange: storedRange
        });
        this._ranges.push(new $b9b9f2bdf9c6137f$export$829eb746b222877(range.start, range.end));
    }
};
$b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e.prototype.is = function(type) {
    return type === "selection" || type === "view:selection";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/documentselection
*/ const $b9b9f2bdf9c6137f$var$ViewDocumentSelectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$43d75c0e89b2169f);
/**
* Class representing the document selection in the view.
*
* Its instance is available in {@link module:engine/view/document~ViewDocument#selection `Document#selection`}.
*
* It is similar to {@link module:engine/view/selection~ViewSelection} but
* it has a read-only API and can be modified only by the writer available in
* the {@link module:engine/view/view~EditingView#change `View#change()`} block
* (so via {@link module:engine/view/downcastwriter~ViewDowncastWriter#setSelection `ViewDowncastWriter#setSelection()`}).
*/ var $b9b9f2bdf9c6137f$export$88e7995732ec83f3 = class extends $b9b9f2bdf9c6137f$var$ViewDocumentSelectionBase {
    /**
	* Selection is used internally (`ViewDocumentSelection` is a proxy to that selection).
	*/ _selection;
    constructor(...args){
        super();
        this._selection = new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e();
        this._selection.delegate("change").to(this);
        if (args.length) this._selection.setTo(...args);
    }
    /**
	* Returns true if selection instance is marked as `fake`.
	*
	* @see #_setTo
	*/ get isFake() {
        return this._selection.isFake;
    }
    /**
	* Returns fake selection label.
	*
	* @see #_setTo
	*/ get fakeSelectionLabel() {
        return this._selection.fakeSelectionLabel;
    }
    /**
	* Selection anchor. Anchor may be described as a position where the selection starts. Together with
	* {@link #focus focus} they define the direction of selection, which is important
	* when expanding/shrinking selection. Anchor is always the start or end of the most recent added range.
	* It may be a bit unintuitive when there are multiple ranges in selection.
	*
	* @see #focus
	*/ get anchor() {
        return this._selection.anchor;
    }
    /**
	* Selection focus. Focus is a position where the selection ends.
	*
	* @see #anchor
	*/ get focus() {
        return this._selection.focus;
    }
    /**
	* Returns whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
	* collapsed.
	*/ get isCollapsed() {
        return this._selection.isCollapsed;
    }
    /**
	* Returns number of ranges in selection.
	*/ get rangeCount() {
        return this._selection.rangeCount;
    }
    /**
	* Specifies whether the {@link #focus} precedes {@link #anchor}.
	*/ get isBackward() {
        return this._selection.isBackward;
    }
    /**
	* {@link module:engine/view/editableelement~ViewEditableElement ViewEditableElement} instance that contains this selection, or `null`
	* if the selection is not inside an editable element.
	*/ get editableElement() {
        return this._selection.editableElement;
    }
    /**
	* Used for the compatibility with the {@link module:engine/view/selection~ViewSelection#isEqual} method.
	*
	* @internal
	*/ get _ranges() {
        return this._selection._ranges;
    }
    /**
	* Returns an iterable that contains copies of all ranges added to the selection.
	*/ *getRanges() {
        yield* this._selection.getRanges();
    }
    /**
	* Returns copy of the first range in the selection. First range is the one which
	* {@link module:engine/view/range~ViewRange#start start} position
	* {@link module:engine/view/position~ViewPosition#isBefore is before} start
	* position of all other ranges (not to confuse with the first range added to the selection).
	* Returns `null` if no ranges are added to selection.
	*/ getFirstRange() {
        return this._selection.getFirstRange();
    }
    /**
	* Returns copy of the last range in the selection. Last range is the one which {@link module:engine/view/range~ViewRange#end end}
	* position {@link module:engine/view/position~ViewPosition#isAfter is after} end position of all other ranges (not to confuse
	* with the last range added to the selection). Returns `null` if no ranges are added to selection.
	*/ getLastRange() {
        return this._selection.getLastRange();
    }
    /**
	* Returns copy of the first position in the selection. First position is the position that
	* {@link module:engine/view/position~ViewPosition#isBefore is before} any other position in the selection ranges.
	* Returns `null` if no ranges are added to selection.
	*/ getFirstPosition() {
        return this._selection.getFirstPosition();
    }
    /**
	* Returns copy of the last position in the selection. Last position is the position that
	* {@link module:engine/view/position~ViewPosition#isAfter is after} any other position in the selection ranges.
	* Returns `null` if no ranges are added to selection.
	*/ getLastPosition() {
        return this._selection.getLastPosition();
    }
    /**
	* Returns the selected element. {@link module:engine/view/element~ViewElement Element} is considered as selected if there is only
	* one range in the selection, and that range contains exactly one element.
	* Returns `null` if there is no selected element.
	*/ getSelectedElement() {
        return this._selection.getSelectedElement();
    }
    /**
	* Checks whether, this selection is equal to given selection. Selections are equal if they have same directions,
	* same number of ranges and all ranges from one selection equal to a range from other selection.
	*
	* @param otherSelection Selection to compare with.
	* @returns `true` if selections are equal, `false` otherwise.
	*/ isEqual(otherSelection) {
        return this._selection.isEqual(otherSelection);
    }
    /**
	* Checks whether this selection is similar to given selection. Selections are similar if they have same directions, same
	* number of ranges, and all {@link module:engine/view/range~ViewRange#getTrimmed trimmed} ranges from one selection are
	* equal to any trimmed range from other selection.
	*
	* @param otherSelection Selection to compare with.
	* @returns `true` if selections are similar, `false` otherwise.
	*/ isSimilar(otherSelection) {
        return this._selection.isSimilar(otherSelection);
    }
    /**
	* Converts `ViewDocumentSelection` instance to plain object and returns it.
	*
	* @returns `ViewDocumentSelection` instance converted to plain object.
	*/ toJSON() {
        return this._selection.toJSON();
    }
    /**
	* Sets this selection's ranges and direction to the specified location based on the given
	* {@link module:engine/view/selection~ViewSelectable selectable}.
	*
	* ```ts
	* // Sets selection to the given range.
	* const range = writer.createRange( start, end );
	* documentSelection._setTo( range );
	*
	* // Sets selection to given ranges.
	* const ranges = [ writer.createRange( start1, end2 ), writer.createRange( start2, end2 ) ];
	* documentSelection._setTo( range );
	*
	* // Sets selection to the other selection.
	* const otherSelection = writer.createSelection();
	* documentSelection._setTo( otherSelection );
	*
	* // Sets collapsed selection at the given position.
	* const position = writer.createPositionAt( root, offset );
	* documentSelection._setTo( position );
	*
	* // Sets collapsed selection at the position of given item and offset.
	* documentSelection._setTo( paragraph, offset );
	* ```
	*
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* ```ts
	* documentSelection._setTo( paragraph, 'in' );
	* ```
	*
	* Creates a range on an {@link module:engine/view/item~ViewItem item} which starts before the item and ends just after the item.
	*
	* ```ts
	* documentSelection._setTo( paragraph, 'on' );
	*
	* // Clears selection. Removes all ranges.
	* documentSelection._setTo( null );
	* ```
	*
	* `Selection#_setTo()` method allow passing additional options (`backward`, `fake` and `label`) as the last argument.
	*
	* ```ts
	* // Sets selection as backward.
	* documentSelection._setTo( range, { backward: true } );
	* ```
	*
	* Fake selection does not render as browser native selection over selected elements and is hidden to the user.
	* This way, no native selection UI artifacts are displayed to the user and selection over elements can be
	* represented in other way, for example by applying proper CSS class.
	*
	* Additionally fake's selection label can be provided. It will be used to des cribe fake selection in DOM
	* (and be  properly handled by screen readers).
	*
	* ```ts
	* // Creates fake selection with label.
	* documentSelection._setTo( range, { fake: true, label: 'foo' } );
	* ```
	*
	* @internal
	* @fires change
	*/ _setTo(...args) {
        this._selection.setTo(...args);
    }
    /**
	* Moves {@link #focus} to the specified location.
	*
	* The location can be specified in the same form as
	* {@link module:engine/view/view~EditingView#createPositionAt view.createPositionAt()}
	* parameters.
	*
	* @internal
	* @fires change
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ _setFocus(itemOrPosition, offset) {
        this._selection.setFocus(itemOrPosition, offset);
    }
};
$b9b9f2bdf9c6137f$export$88e7995732ec83f3.prototype.is = function(type) {
    return type === "selection" || type == "documentSelection" || type == "view:selection" || type == "view:documentSelection";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/bubblingeventinfo
*/ /**
* The event object passed to bubbling event callbacks. It is used to provide information about the event as well as a tool to
* manipulate it.
*/ var $b9b9f2bdf9c6137f$export$56609df77c04b70e = class extends (0, $c7bc2cb7e2db0227$export$3f63aa522937812c) {
    /**
	* The view range that the bubbling should start from.
	*/ startRange;
    /**
	* The current event phase.
	*/ _eventPhase;
    /**
	* The current bubbling target.
	*/ _currentTarget;
    /**
	* @param source The emitter.
	* @param name The event name.
	* @param startRange The view range that the bubbling should start from.
	*/ constructor(source, name, startRange){
        super(source, name);
        this.startRange = startRange;
        this._eventPhase = "none";
        this._currentTarget = null;
    }
    /**
	* The current event phase.
	*/ get eventPhase() {
        return this._eventPhase;
    }
    /**
	* The current bubbling target.
	*/ get currentTarget() {
        return this._currentTarget;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/bubblingemittermixin
*/ const $b9b9f2bdf9c6137f$var$bubblingEmitterSymbol = Symbol("bubblingEmitter");
const $b9b9f2bdf9c6137f$var$callbackMapSymbol = Symbol("bubblingCallbacks");
const $b9b9f2bdf9c6137f$var$contextsSymbol = Symbol("bubblingContexts");
/**
* Bubbling emitter mixin for the view document as described in the {@link ~BubblingEmitter} interface.
*
* This function creates a class that inherits from the provided `base` and implements `Emitter` interface.
* The base class must implement {@link module:utils/emittermixin~Emitter} interface.
*
* ```ts
* class BaseClass extends EmitterMixin() {
* 	// ...
* }
*
* class MyClass extends BubblingEmitterMixin( BaseClass ) {
* 	// This class derives from `BaseClass` and implements the `BubblingEmitter` interface.
* }
* ```
*/ function $b9b9f2bdf9c6137f$export$68decea47106ff51(base) {
    class Mixin extends base {
        fire(eventOrInfo, ...eventArgs) {
            try {
                const eventInfo = eventOrInfo instanceof (0, $c7bc2cb7e2db0227$export$3f63aa522937812c) ? eventOrInfo : new (0, $c7bc2cb7e2db0227$export$3f63aa522937812c)(this, eventOrInfo);
                const bubblingEmitter = $b9b9f2bdf9c6137f$var$getBubblingEmitter(this);
                const customContexts = $b9b9f2bdf9c6137f$var$getCustomContexts(this);
                $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, "capturing", this);
                if ($b9b9f2bdf9c6137f$var$fireListenerFor(bubblingEmitter, "$capture", eventInfo, ...eventArgs)) return eventInfo.return;
                const startRange = eventInfo.startRange || this.selection.getFirstRange();
                const selectedElement = startRange ? startRange.getContainedElement() : null;
                const isCustomContext = selectedElement ? $b9b9f2bdf9c6137f$var$hasMatchingCustomContext(customContexts, selectedElement) : false;
                let node = selectedElement || $b9b9f2bdf9c6137f$var$getDeeperRangeParent(startRange);
                $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, "atTarget", node);
                if (!isCustomContext) {
                    if ($b9b9f2bdf9c6137f$var$fireListenerFor(bubblingEmitter, "$text", eventInfo, ...eventArgs)) return eventInfo.return;
                    $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, "bubbling", node);
                }
                while(node){
                    if (node.is("element") && $b9b9f2bdf9c6137f$var$fireListenerFor(bubblingEmitter, node, eventInfo, ...eventArgs)) return eventInfo.return;
                    node = node.parent;
                    $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, "bubbling", node);
                }
                $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, "bubbling", this);
                $b9b9f2bdf9c6137f$var$fireListenerFor(bubblingEmitter, "$document", eventInfo, ...eventArgs);
                return eventInfo.return;
            } catch (err) {
                (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10).rethrowUnexpectedError(err, this);
            }
        }
        _addEventListener(event, callback, options) {
            const contexts = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.context || "$document");
            const bubblingEmitter = $b9b9f2bdf9c6137f$var$getBubblingEmitter(this);
            const callbacksMap = $b9b9f2bdf9c6137f$var$getCallbackMap(this);
            for (const context of contexts)if (typeof context == "function") $b9b9f2bdf9c6137f$var$getCustomContexts(this).add(context);
            const wrappedCallback = $b9b9f2bdf9c6137f$var$wrapCallback(this, contexts, callback);
            callbacksMap.set(callback, wrappedCallback);
            this.listenTo(bubblingEmitter, event, wrappedCallback, options);
        }
        _removeEventListener(event, callback) {
            const bubblingEmitter = $b9b9f2bdf9c6137f$var$getBubblingEmitter(this);
            const callbacksMap = $b9b9f2bdf9c6137f$var$getCallbackMap(this);
            const wrappedCallback = callbacksMap.get(callback);
            if (wrappedCallback) {
                callbacksMap.delete(callback);
                this.stopListening(bubblingEmitter, event, wrappedCallback);
            }
        }
    }
    return Mixin;
}
/**
* Update the event info bubbling fields.
*
* @param eventInfo The event info object to update.
* @param eventPhase The current event phase.
* @param currentTarget The current bubbling target.
*/ function $b9b9f2bdf9c6137f$var$updateEventInfo(eventInfo, eventPhase, currentTarget) {
    if (eventInfo instanceof $b9b9f2bdf9c6137f$export$56609df77c04b70e) {
        eventInfo._eventPhase = eventPhase;
        eventInfo._currentTarget = currentTarget;
    }
}
/**
* Fires the listener for the specified context. Returns `true` if event was stopped.
*
* @param eventInfo The `EventInfo` object.
* @param eventArgs Additional arguments to be passed to the callbacks.
* @returns True if event stop was called.
*/ function $b9b9f2bdf9c6137f$var$fireListenerFor(emitter, currentTarget, eventInfo, ...eventArgs) {
    emitter.fire(eventInfo, {
        currentTarget: currentTarget,
        eventArgs: eventArgs
    });
    if (eventInfo.stop.called) return true;
    return false;
}
/**
* Returns an event callback wrapped with context check condition.
*/ function $b9b9f2bdf9c6137f$var$wrapCallback(emitter, contexts, callback) {
    return function(event, data) {
        const { currentTarget: currentTarget, eventArgs: eventArgs } = data;
        if (typeof currentTarget == "string") {
            if (contexts.includes(currentTarget)) callback.call(emitter, event, ...eventArgs);
            return;
        }
        if (currentTarget.is("rootElement") && contexts.includes("$root")) {
            callback.call(emitter, event, ...eventArgs);
            return;
        }
        if (contexts.includes(currentTarget.name)) {
            callback.call(emitter, event, ...eventArgs);
            return;
        }
        for (const context of contexts)if (typeof context == "function" && context(currentTarget)) {
            callback.call(emitter, event, ...eventArgs);
            return;
        }
    };
}
/**
* Returns bubbling emitter for the source (emitter).
*/ function $b9b9f2bdf9c6137f$var$getBubblingEmitter(source) {
    if (!source[$b9b9f2bdf9c6137f$var$bubblingEmitterSymbol]) source[$b9b9f2bdf9c6137f$var$bubblingEmitterSymbol] = new ((0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)())();
    return source[$b9b9f2bdf9c6137f$var$bubblingEmitterSymbol];
}
/**
* Returns map of callbacks (original to wrapped one).
*/ function $b9b9f2bdf9c6137f$var$getCallbackMap(source) {
    if (!source[$b9b9f2bdf9c6137f$var$callbackMapSymbol]) source[$b9b9f2bdf9c6137f$var$callbackMapSymbol] = /* @__PURE__ */ new Map();
    return source[$b9b9f2bdf9c6137f$var$callbackMapSymbol];
}
/**
* Returns the set of registered custom contexts.
*/ function $b9b9f2bdf9c6137f$var$getCustomContexts(source) {
    if (!source[$b9b9f2bdf9c6137f$var$contextsSymbol]) source[$b9b9f2bdf9c6137f$var$contextsSymbol] = /* @__PURE__ */ new Set();
    return source[$b9b9f2bdf9c6137f$var$contextsSymbol];
}
/**
* Returns true if any of custom context match the given element.
*/ function $b9b9f2bdf9c6137f$var$hasMatchingCustomContext(customContexts, element) {
    for (const context of customContexts)if (context(element)) return true;
    return false;
}
/**
* Returns the deeper parent element for the range.
*/ function $b9b9f2bdf9c6137f$var$getDeeperRangeParent(range) {
    if (!range) return null;
    const startParent = range.start.parent;
    const endParent = range.end.parent;
    const startPath = startParent.getPath();
    const endPath = endParent.getPath();
    return startPath.length > endPath.length ? startParent : endParent;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/document
*/ const $b9b9f2bdf9c6137f$var$ViewDocumentBase = /* #__PURE__ */ $b9b9f2bdf9c6137f$export$68decea47106ff51(/* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)());
/**
* Document class creates an abstract layer over the content editable area, contains a tree of view elements and
* {@link module:engine/view/documentselection~ViewDocumentSelection view selection} associated with this document.
*/ var $b9b9f2bdf9c6137f$export$c26285651732fb36 = class extends $b9b9f2bdf9c6137f$var$ViewDocumentBase {
    /**
	* Selection done on this document.
	*/ selection;
    /**
	* Roots of the view tree. Collection of the {@link module:engine/view/element~ViewElement view elements}.
	*
	* View roots are created as a result of binding between {@link module:engine/view/document~ViewDocument#roots} and
	* {@link module:engine/model/document~ModelDocument#roots} and this is handled by
	* {@link module:engine/controller/editingcontroller~EditingController}, so to create view root we need to create
	* model root using {@link module:engine/model/document~ModelDocument#createRoot}.
	*/ roots;
    /**
	* The styles processor instance used by this document when normalizing styles.
	*/ stylesProcessor;
    /**
	* Post-fixer callbacks registered to the view document.
	*/ _postFixers = /* @__PURE__ */ new Set();
    /**
	* Creates a Document instance.
	*
	* @param stylesProcessor The styles processor instance.
	*/ constructor(stylesProcessor){
        super();
        this.selection = new $b9b9f2bdf9c6137f$export$88e7995732ec83f3();
        this.roots = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)({
            idProperty: "rootName"
        });
        this.stylesProcessor = stylesProcessor;
        this.set("isReadOnly", false);
        this.set("isFocused", false);
        this.set("isSelecting", false);
        this.set("isComposing", false);
    }
    /**
	* Gets a {@link module:engine/view/document~ViewDocument#roots view root element} with the specified name. If the name is not
	* specific "main" root is returned.
	*
	* @param name Name of the root.
	* @returns The view root element with the specified name or null when there is no root of given name.
	*/ getRoot(name = "main") {
        return this.roots.get(name);
    }
    /**
	* Returns an array with all roots added to the document.
	*/ getRoots() {
        return Array.from(this.roots);
    }
    /**
	* Allows registering post-fixer callbacks. A post-fixers mechanism allows to update the view tree just before it is rendered
	* to the DOM.
	*
	* Post-fixers are executed right after all changes from the outermost change block were applied but
	* before the {@link module:engine/view/view~EditingView#event:render render event} is fired. If a post-fixer callback made
	* a change, it should return `true`. When this happens, all post-fixers are fired again to check if something else should
	* not be fixed in the new document tree state.
	*
	* View post-fixers are useful when you want to apply some fixes whenever the view structure changes. Keep in mind that
	* changes executed in a view post-fixer should not break model-view mapping.
	*
	* The types of changes which should be safe:
	*
	* * adding or removing attribute from elements,
	* * changes inside of {@link module:engine/view/uielement~ViewUIElement UI elements},
	* * {@link module:engine/controller/editingcontroller~EditingController#reconvertItem marking some of the model elements to be
	* re-converted}.
	*
	* Try to avoid changes which touch view structure:
	*
	* * you should not add or remove nor wrap or unwrap any view elements,
	* * you should not change the editor data model in a view post-fixer.
	*
	* As a parameter, a post-fixer callback receives a {@link module:engine/view/downcastwriter~ViewDowncastWriter downcast writer}.
	*
	* Typically, a post-fixer will look like this:
	*
	* ```ts
	* editor.editing.view.document.registerPostFixer( writer => {
	* 	if ( checkSomeCondition() ) {
	* 		writer.doSomething();
	*
	* 		// Let other post-fixers know that something changed.
	* 		return true;
	* 	}
	*
	* 	return false;
	* } );
	* ```
	*
	* Note that nothing happens right after you register a post-fixer (e.g. execute such a code in the console).
	* That is because adding a post-fixer does not execute it.
	* The post-fixer will be executed as soon as any change in the document needs to cause its rendering.
	* If you want to re-render the editor's view after registering the post-fixer then you should do it manually by calling
	* {@link module:engine/view/view~EditingView#forceRender `view.forceRender()`}.
	*
	* If you need to register a callback which is executed when DOM elements are already updated,
	* use {@link module:engine/view/view~EditingView#event:render render event}.
	*/ registerPostFixer(postFixer) {
        this._postFixers.add(postFixer);
    }
    /**
	* Destroys this instance. Makes sure that all observers are destroyed and listeners removed.
	*/ destroy() {
        this.roots.forEach((root)=>root.destroy());
        this.stopListening();
    }
    /**
	* Performs post-fixer loops. Executes post-fixer callbacks as long as none of them has done any changes to the model.
	*
	* @internal
	*/ _callPostFixers(writer) {
        let wasFixed = false;
        do for (const callback of this._postFixers){
            wasFixed = callback(writer);
            if (wasFixed) break;
        }
        while (wasFixed);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/attributeelement
*/ const $b9b9f2bdf9c6137f$var$DEFAULT_PRIORITY = 10;
/**
* Attribute elements are used to represent formatting elements in the view (think – `<b>`, `<span style="font-size: 2em">`, etc.).
* Most often they are created when downcasting model text attributes.
*
* Editing engine does not define a fixed HTML DTD. This is why a feature developer needs to choose between various
* types (container element, {@link module:engine/view/attributeelement~ViewAttributeElement attribute element},
* {@link module:engine/view/emptyelement~ViewEmptyElement empty element}, etc) when developing a feature.
*
* To create a new attribute element instance use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createAttributeElement `ViewDowncastWriter#createAttributeElement()`} method.
*/ var $b9b9f2bdf9c6137f$export$9c94dd4019f314d7 = class extends $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 {
    static DEFAULT_PRIORITY = $b9b9f2bdf9c6137f$var$DEFAULT_PRIORITY;
    /**
	* Element priority. Decides in what order elements are wrapped by {@link module:engine/view/downcastwriter~ViewDowncastWriter}.
	*
	* @internal
	* @readonly
	*/ _priority = $b9b9f2bdf9c6137f$var$DEFAULT_PRIORITY;
    /**
	* Element identifier. If set, it is used by {@link module:engine/view/element~ViewElement#isSimilar},
	* and then two elements are considered similar if, and only if they have the same `_id`.
	*
	* @internal
	* @readonly
	*/ _id = null;
    /**
	* Keeps all the attribute elements that have the same {@link module:engine/view/attributeelement~ViewAttributeElement#id ids}
	* and still exist in the view tree.
	*
	* This property is managed by {@link module:engine/view/downcastwriter~ViewDowncastWriter}.
	*/ _clonesGroup = null;
    /**
	* Creates an attribute element.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createAttributeElement
	* @see module:engine/view/element~ViewElement
	* @protected
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attrs, children){
        super(document1, name, attrs, children);
        this.getFillerOffset = $b9b9f2bdf9c6137f$var$getFillerOffset$3;
    }
    /**
	* Element priority. Decides in what order elements are wrapped by {@link module:engine/view/downcastwriter~ViewDowncastWriter}.
	*/ get priority() {
        return this._priority;
    }
    /**
	* Element identifier. If set, it is used by {@link module:engine/view/element~ViewElement#isSimilar},
	* and then two elements are considered similar if, and only if they have the same `id`.
	*/ get id() {
        return this._id;
    }
    /**
	* Returns all {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} that has the
	* same {@link module:engine/view/attributeelement~ViewAttributeElement#id id} and are in the view tree (were not removed).
	*
	* Note: If this element has been removed from the tree, returned set will not include it.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError attribute-element-get-elements-with-same-id-no-id}
	* if this element has no `id`.
	*
	* @returns Set containing all the attribute elements
	* with the same `id` that were added and not removed from the view tree.
	*/ getElementsWithSameId() {
        if (this.id === null) /**
		* Cannot get elements with the same id for an attribute element without id.
		*
		* @error attribute-element-get-elements-with-same-id-no-id
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("attribute-element-get-elements-with-same-id-no-id", this);
        return new Set(this._clonesGroup);
    }
    /**
	* Checks if this element is similar to other element.
	*
	* If none of elements has set {@link module:engine/view/attributeelement~ViewAttributeElement#id}, then both elements
	* should have the same name, attributes and priority to be considered as similar. Two similar elements can contain
	* different set of children nodes.
	*
	* If at least one element has {@link module:engine/view/attributeelement~ViewAttributeElement#id} set, then both
	* elements have to have the same {@link module:engine/view/attributeelement~ViewAttributeElement#id} value to be
	* considered similar.
	*
	* Similarity is important for {@link module:engine/view/downcastwriter~ViewDowncastWriter}. For example:
	*
	* * two following similar elements can be merged together into one, longer element,
	* * {@link module:engine/view/downcastwriter~ViewDowncastWriter#unwrap} checks similarity of passed element and processed element to
	* decide whether processed element should be unwrapped,
	* * etc.
	*/ isSimilar(otherElement) {
        if (this.id !== null || otherElement.id !== null) return this.id === otherElement.id;
        return super.isSimilar(otherElement) && this.priority == otherElement.priority;
    }
    /**
	* Converts `ViewAttributeElement` instance to plain object and returns it.
	*
	* @returns `ViewAttributeElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "AttributeElement";
        return json;
    }
    /**
	* Clones provided element with priority.
	*
	* @internal
	* @param deep If set to `true` clones element and all its children recursively. When set to `false`,
	* element will be cloned without any children.
	* @returns Clone of this element.
	*/ _clone(deep = false) {
        const cloned = super._clone(deep);
        cloned._priority = this._priority;
        cloned._id = this._id;
        return cloned;
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_mergeAttributesFrom} to verify if the given element can be merged without
	* conflicts into this element.
	*
	* @internal
	*/ _canMergeAttributesFrom(otherElement) {
        if (this.id !== null || otherElement.id !== null || this.priority !== otherElement.priority) return false;
        return super._canMergeAttributesFrom(otherElement);
    }
    /**
	* Used by {@link module:engine/view/element~ViewElement#_subtractAttributesOf} to verify if the given element attributes
	* can be fully subtracted from this element.
	*
	* @internal
	*/ _canSubtractAttributesOf(otherElement) {
        if (this.id !== null || otherElement.id !== null || this.priority !== otherElement.priority) return false;
        return super._canSubtractAttributesOf(otherElement);
    }
};
$b9b9f2bdf9c6137f$export$9c94dd4019f314d7.prototype.is = function(type, name) {
    if (!name) return type === "attributeElement" || type === "view:attributeElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "attributeElement" || type === "view:attributeElement" || type === "element" || type === "view:element");
};
/**
* Returns block {@link module:engine/view/filler~Filler filler} offset or `null` if block filler is not needed.
*
* @returns Block filler offset or `null` if block filler is not needed.
*/ function $b9b9f2bdf9c6137f$var$getFillerOffset$3() {
    if ($b9b9f2bdf9c6137f$var$nonUiChildrenCount(this)) return null;
    let element = this.parent;
    while(element && element.is("attributeElement")){
        if ($b9b9f2bdf9c6137f$var$nonUiChildrenCount(element) > 1) return null;
        element = element.parent;
    }
    if (!element || $b9b9f2bdf9c6137f$var$nonUiChildrenCount(element) > 1) return null;
    return this.childCount;
}
/**
* Returns total count of children that are not {@link module:engine/view/uielement~ViewUIElement UIElements}.
*/ function $b9b9f2bdf9c6137f$var$nonUiChildrenCount(element) {
    return Array.from(element.getChildren()).filter((element)=>!element.is("uiElement")).length;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/emptyelement
*/ /**
* Empty element class. It is used to represent elements that cannot contain any child nodes (for example `<img>` elements).
*
* To create a new empty element use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createEmptyElement `downcastWriter#createEmptyElement()`} method.
*/ var $b9b9f2bdf9c6137f$export$a2e67116aa89395d = class extends $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 {
    /**
	* Creates new instance of ViewEmptyElement.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-emptyelement-cannot-add` when third parameter is passed,
	* to inform that usage of ViewEmptyElement is incorrect (adding child nodes to ViewEmptyElement is forbidden).
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createEmptyElement
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attributes Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attributes, children){
        super(document1, name, attributes, children);
        this.getFillerOffset = $b9b9f2bdf9c6137f$var$getFillerOffset$2;
    }
    /**
	* Converts `ViewEmptyElement` instance to plain object and returns it.
	*
	* @returns `ViewEmptyElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "EmptyElement";
        return json;
    }
    /**
	* Overrides {@link module:engine/view/element~ViewElement#_insertChild} method.
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-emptyelement-cannot-add` to prevent
	* adding any child nodes to ViewEmptyElement.
	*
	* @internal
	*/ _insertChild(index, items) {
        if (items && (items instanceof $b9b9f2bdf9c6137f$export$1de540da1a7d61ca || Array.from(items).length > 0)) /**
		* Cannot add children to {@link module:engine/view/emptyelement~ViewEmptyElement}.
		*
		* @error view-emptyelement-cannot-add
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-emptyelement-cannot-add", [
            this,
            items
        ]);
        return 0;
    }
};
$b9b9f2bdf9c6137f$export$a2e67116aa89395d.prototype.is = function(type, name) {
    if (!name) return type === "emptyElement" || type === "view:emptyElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "emptyElement" || type === "view:emptyElement" || type === "element" || type === "view:element");
};
/**
* Returns `null` because block filler is not needed for ViewEmptyElements.
*/ function $b9b9f2bdf9c6137f$var$getFillerOffset$2() {
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/uielement
*/ /**
* UI element class. It should be used to represent editing UI which needs to be injected into the editing view
* If possible, you should keep your UI outside the editing view. However, if that is not possible,
* UI elements can be used.
*
* How a UI element is rendered is in your control (you pass a callback to
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createUIElement `downcastWriter#createUIElement()`}).
* The editor will ignore your UI element – the selection cannot be placed in it, it is skipped (invisible) when
* the user modifies the selection by using arrow keys and the editor does not listen to any mutations which
* happen inside your UI elements.
*
* The limitation is that you cannot convert a model element to a UI element. UI elements need to be
* created for {@link module:engine/model/markercollection~Marker markers} or as additinal elements
* inside normal {@link module:engine/view/containerelement~ViewContainerElement container elements}.
*
* To create a new UI element use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createUIElement `downcastWriter#createUIElement()`} method.
*/ var $b9b9f2bdf9c6137f$export$3d8082ae114b5652 = class extends $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 {
    /**
	* Creates new instance of UIElement.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-uielement-cannot-add` when third parameter is passed,
	* to inform that usage of UIElement is incorrect (adding child nodes to UIElement is forbidden).
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createUIElement
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attrs, children){
        super(document1, name, attrs, children);
        this.getFillerOffset = $b9b9f2bdf9c6137f$var$getFillerOffset$1;
    }
    /**
	* Overrides {@link module:engine/view/element~ViewElement#_insertChild} method.
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-uielement-cannot-add` to prevent adding any child nodes
	* to UIElement.
	*
	* @internal
	*/ _insertChild(index, items) {
        if (items && (items instanceof $b9b9f2bdf9c6137f$export$1de540da1a7d61ca || Array.from(items).length > 0)) /**
		* Cannot add children to {@link module:engine/view/uielement~ViewUIElement}.
		*
		* @error view-uielement-cannot-add
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-uielement-cannot-add", [
            this,
            items
        ]);
        return 0;
    }
    /**
	* Renders this {@link module:engine/view/uielement~ViewUIElement} to DOM. This method is called by
	* {@link module:engine/view/domconverter~ViewDomConverter}.
	* Do not use inheritance to create custom rendering method, replace `render()` method instead:
	*
	* ```ts
	* const myUIElement = downcastWriter.createUIElement( 'span' );
	* myUIElement.render = function( domDocument, domConverter ) {
	* 	const domElement = this.toDomElement( domDocument );
	*
	* 	domConverter.setContentOf( domElement, '<b>this is ui element</b>' );
	*
	* 	return domElement;
	* };
	* ```
	*
	* If changes in your UI element should trigger some editor UI update you should call
	* the {@link module:ui/editorui/editorui~EditorUI#update `editor.ui.update()`} method
	* after rendering your UI element.
	*
	* @param domConverter Instance of the ViewDomConverter used to optimize the output.
	*/ render(domDocument, domConverter) {
        return this.toDomElement(domDocument);
    }
    /**
	* Creates DOM element based on this view UIElement.
	* Note that each time this method is called new DOM element is created.
	*/ toDomElement(domDocument) {
        const domElement = domDocument.createElement(this.name);
        for (const key of this.getAttributeKeys())domElement.setAttribute(key, (0, $c7bc2cb7e2db0227$export$4703b76556f50989)(domElement, key, this.getAttribute(key)));
        return domElement;
    }
    /**
	* Converts `ViewUIElement` instance to plain object and returns it.
	*
	* @returns `ViewUIElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "UIElement";
        return json;
    }
};
$b9b9f2bdf9c6137f$export$3d8082ae114b5652.prototype.is = function(type, name) {
    if (!name) return type === "uiElement" || type === "view:uiElement" || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "uiElement" || type === "view:uiElement" || type === "element" || type === "view:element");
};
/**
* This function injects UI element handling to the given {@link module:engine/view/document~ViewDocument document}.
*
* A callback is added to {@link module:engine/view/document~ViewDocument#event:keydown document keydown event}.
* The callback handles the situation when right arrow key is pressed and selection is collapsed before a UI element.
* Without this handler, it would be impossible to "jump over" UI element using right arrow key.
*
* @param view View controller to which the quirks handling will be injected.
* @internal
*/ function $b9b9f2bdf9c6137f$export$634b3e76c8e059f7(view) {
    view.document.on("arrowKey", (evt, data)=>$b9b9f2bdf9c6137f$var$jumpOverUiElement(evt, data, view.domConverter), {
        priority: "low"
    });
}
/**
* Returns `null` because block filler is not needed for UIElements.
*/ function $b9b9f2bdf9c6137f$var$getFillerOffset$1() {
    return null;
}
/**
* Selection cannot be placed in a `UIElement`. Whenever it is placed there, it is moved before it. This
* causes a situation when it is impossible to jump over `UIElement` using right arrow key, because the selection
* ends up in ui element (in DOM) and is moved back to the left. This handler fixes this situation.
*/ function $b9b9f2bdf9c6137f$var$jumpOverUiElement(evt, data, domConverter) {
    if (data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowright) {
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(data.domTarget);
        if (!domSelection) return;
        const domSelectionCollapsed = domSelection.rangeCount == 1 && domSelection.getRangeAt(0).collapsed;
        if (domSelectionCollapsed || data.shiftKey) {
            const domParent = domSelection.focusNode;
            const domOffset = domSelection.focusOffset;
            const viewPosition = domConverter.domPositionToView(domParent, domOffset);
            if (viewPosition === null) return;
            let jumpedOverAnyUiElement = false;
            const nextViewPosition = viewPosition.getLastMatchingPosition((value)=>{
                if (value.item.is("uiElement")) jumpedOverAnyUiElement = true;
                if (value.item.is("uiElement") || value.item.is("attributeElement")) return true;
                return false;
            });
            if (jumpedOverAnyUiElement) {
                const newDomPosition = domConverter.viewPositionToDom(nextViewPosition);
                if (domSelectionCollapsed) domSelection.collapse(newDomPosition.parent, newDomPosition.offset);
                else domSelection.extend(newDomPosition.parent, newDomPosition.offset);
            }
        }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/rawelement
*/ /**
* The raw element class.
*
* The raw elements work as data containers ("wrappers", "sandboxes") but their children are not managed or
* even recognized by the editor. This encapsulation allows integrations to maintain custom DOM structures
* in the editor content without, for instance, worrying about compatibility with other editor features.
* Raw elements are a perfect tool for integration with external frameworks and data sources.
*
* Unlike {@link module:engine/view/uielement~ViewUIElement UI elements}, raw elements act like real editor
* content (similar to {@link module:engine/view/containerelement~ViewContainerElement} or
* {@link module:engine/view/emptyelement~ViewEmptyElement}), they are considered by the editor selection and
* {@link module:widget/utils~toWidget they can work as widgets}.
*
* To create a new raw element, use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createRawElement `downcastWriter#createRawElement()`} method.
*/ var $b9b9f2bdf9c6137f$export$533ef497f99ba10c = class extends $b9b9f2bdf9c6137f$export$6a9b2964be74ea54 {
    /**
	* Creates a new instance of a raw element.
	*
	* Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} when the `children`
	* parameter is passed to inform that the usage of `ViewRawElement` is incorrect (adding child nodes to `ViewRawElement` is forbidden).
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#createRawElement
	* @internal
	* @param document The document instance to which this element belongs.
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	*/ constructor(document1, name, attrs, children){
        super(document1, name, attrs, children);
        this.getFillerOffset = $b9b9f2bdf9c6137f$var$getFillerOffset;
    }
    /**
	* Converts `ViewRawElement` instance to plain object and returns it.
	*
	* @returns `ViewRawElement` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.type = "RawElement";
        return json;
    }
    /**
	* Overrides the {@link module:engine/view/element~ViewElement#_insertChild} method.
	* Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} to prevent
	* adding any child nodes to a raw element.
	*
	* @internal
	*/ _insertChild(index, items) {
        if (items && (items instanceof $b9b9f2bdf9c6137f$export$1de540da1a7d61ca || Array.from(items).length > 0)) /**
		* Cannot add children to a {@link module:engine/view/rawelement~ViewRawElement} instance.
		*
		* @error view-rawelement-cannot-add
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-rawelement-cannot-add", [
            this,
            items
        ]);
        return 0;
    }
    /**
	* This allows rendering the children of a {@link module:engine/view/rawelement~ViewRawElement} on the DOM level.
	* This method is called by the {@link module:engine/view/domconverter~ViewDomConverter} with the raw DOM element
	* passed as an argument, leaving the number and shape of the children up to the integrator.
	*
	* This method **must be defined** for the raw element to work:
	*
	* ```ts
	* const myRawElement = downcastWriter.createRawElement( 'div' );
	*
	* myRawElement.render = function( domElement, domConverter ) {
	* 	domConverter.setContentOf( domElement, '<b>This is the raw content of myRawElement.</b>' );
	* };
	* ```
	*
	* @param domElement The native DOM element representing the raw view element.
	* @param domConverter Instance of the ViewDomConverter used to optimize the output.
	*/ render(domElement, domConverter) {}
};
$b9b9f2bdf9c6137f$export$533ef497f99ba10c.prototype.is = function(type, name) {
    if (!name) return type === "rawElement" || type === "view:rawElement" || type === this.name || type === "view:" + this.name || type === "element" || type === "view:element" || type === "node" || type === "view:node";
    else return name === this.name && (type === "rawElement" || type === "view:rawElement" || type === "element" || type === "view:element");
};
/**
* Returns `null` because block filler is not needed for raw elements.
*/ function $b9b9f2bdf9c6137f$var$getFillerOffset() {
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/documentfragment
*/ const $b9b9f2bdf9c6137f$var$ViewDocumentFragmentBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$43d75c0e89b2169f);
/**
* Document fragment.
*
* To create a new document fragment instance use the
* {@link module:engine/view/upcastwriter~ViewUpcastWriter#createDocumentFragment `ViewUpcastWriter#createDocumentFragment()`}
* method.
*/ var $b9b9f2bdf9c6137f$export$574fd53611480ec7 = class extends $b9b9f2bdf9c6137f$var$ViewDocumentFragmentBase {
    /**
	* The document to which this document fragment belongs.
	*/ document;
    /**
	* Array of child nodes.
	*/ _children = [];
    /**
	* Map of custom properties.
	* Custom properties can be added to document fragment instance.
	*/ _customProperties = /* @__PURE__ */ new Map();
    /**
	* Creates new DocumentFragment instance.
	*
	* @internal
	* @param document The document to which this document fragment belongs.
	* @param children A list of nodes to be inserted into the created document fragment.
	*/ constructor(document1, children){
        super();
        this.document = document1;
        if (children) this._insertChild(0, children);
    }
    /**
	* Iterable interface.
	*
	* Iterates over nodes added to this document fragment.
	*/ [Symbol.iterator]() {
        return this._children[Symbol.iterator]();
    }
    /**
	* Number of child nodes in this document fragment.
	*/ get childCount() {
        return this._children.length;
    }
    /**
	* Is `true` if there are no nodes inside this document fragment, `false` otherwise.
	*/ get isEmpty() {
        return this.childCount === 0;
    }
    /**
	* Artificial root of `DocumentFragment`. Returns itself. Added for compatibility reasons.
	*/ get root() {
        return this;
    }
    /**
	* Artificial parent of `DocumentFragment`. Returns `null`. Added for compatibility reasons.
	*/ get parent() {
        return null;
    }
    /**
	* Artificial element name. Returns `undefined`. Added for compatibility reasons.
	*/ get name() {}
    /**
	* Artificial element getFillerOffset. Returns `undefined`. Added for compatibility reasons.
	*/ get getFillerOffset() {}
    /**
	* Returns the custom property value for the given key.
	*/ getCustomProperty(key) {
        return this._customProperties.get(key);
    }
    /**
	* Returns an iterator which iterates over this document fragment's custom properties.
	* Iterator provides `[ key, value ]` pairs for each stored property.
	*/ *getCustomProperties() {
        yield* this._customProperties.entries();
    }
    /**
	* Converts `ViewDocumentFragment` instance to plain object and returns it.
	* Takes care of converting all of this document fragment's children.
	*
	* @returns `ViewDocumentFragment` instance converted to plain object.
	*/ toJSON() {
        const json = [];
        for (const node of this._children)json.push(node.toJSON());
        return json;
    }
    /**
	* {@link module:engine/view/documentfragment~ViewDocumentFragment#_insertChild Insert} a child node or a list of child nodes at the end
	* and sets the parent of these nodes to this fragment.
	*
	* @internal
	* @param items Items to be inserted.
	* @returns Number of appended nodes.
	*/ _appendChild(items) {
        return this._insertChild(this.childCount, items);
    }
    /**
	* Gets child at the given index.
	*
	* @param index Index of child.
	* @returns Child node.
	*/ getChild(index) {
        return this._children[index];
    }
    /**
	* Gets index of the given child node. Returns `-1` if child node is not found.
	*
	* @param node Child node.
	* @returns Index of the child node.
	*/ getChildIndex(node) {
        return this._children.indexOf(node);
    }
    /**
	* Gets child nodes iterator.
	*
	* @returns Child nodes iterator.
	*/ getChildren() {
        return this._children[Symbol.iterator]();
    }
    /**
	* Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
	* this fragment.
	*
	* @internal
	* @param index Position where nodes should be inserted.
	* @param items Items to be inserted.
	* @returns Number of inserted nodes.
	*/ _insertChild(index, items) {
        this._fireChange("children", this, {
            index: index
        });
        let count = 0;
        const nodes = $b9b9f2bdf9c6137f$var$normalize$2(this.document, items);
        for (const node of nodes){
            if (node.parent !== null) node._remove();
            node.parent = this;
            this._children.splice(index, 0, node);
            index++;
            count++;
        }
        return count;
    }
    /**
	* Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
	*
	* @internal
	* @param index Number of the first node to remove.
	* @param howMany Number of nodes to remove.
	* @returns The array of removed nodes.
	*/ _removeChildren(index, howMany = 1) {
        this._fireChange("children", this, {
            index: index
        });
        for(let i = index; i < index + howMany; i++)this._children[i].parent = null;
        return this._children.splice(index, howMany);
    }
    /**
	* @internal
	* @param type Type of the change.
	* @param node Changed node.
	* @param data Additional data.
	* @fires module:engine/view/node~ViewNode#event:change
	*/ _fireChange(type, node, data) {
        this.fire(`change:${type}`, node, data);
    }
    /**
	* Sets a custom property. They can be used to add special data to elements.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#setCustomProperty
	* @internal
	*/ _setCustomProperty(key, value) {
        this._customProperties.set(key, value);
    }
    /**
	* Removes the custom property stored under the given key.
	*
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#removeCustomProperty
	* @internal
	* @returns Returns true if property was removed.
	*/ _removeCustomProperty(key) {
        return this._customProperties.delete(key);
    }
};
$b9b9f2bdf9c6137f$export$574fd53611480ec7.prototype.is = function(type) {
    return type === "documentFragment" || type === "view:documentFragment";
};
/**
* Converts strings to Text and non-iterables to arrays.
*/ function $b9b9f2bdf9c6137f$var$normalize$2(document1, nodes) {
    if (typeof nodes == "string") return [
        new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, nodes)
    ];
    if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes)) nodes = [
        nodes
    ];
    return Array.from(nodes).map((node)=>{
        if (typeof node == "string") return new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, node);
        if (node instanceof $b9b9f2bdf9c6137f$export$b0e248170172f65f) return new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(document1, node.data);
        return node;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/downcastwriter
*/ /**
* View downcast writer.
*
* It provides a set of methods used to manipulate view nodes.
*
* Do not create an instance of this writer manually. To modify a view structure, use
* the {@link module:engine/view/view~EditingView#change `View#change()`} block.
*
* The `ViewDowncastWriter` is designed to work with semantic views which are the views that were/are being downcasted from the model.
* To work with ordinary views (e.g. parsed from a pasted content) use the
* {@link module:engine/view/upcastwriter~ViewUpcastWriter upcast writer}.
*
* Read more about changing the view in the {@glink framework/architecture/editing-engine#changing-the-view Changing the view}
* section of the {@glink framework/architecture/editing-engine Editing engine architecture} guide.
*/ var $b9b9f2bdf9c6137f$export$c1f00b82a18dfdda = class {
    /**
	* The view document instance in which this writer operates.
	*/ document;
    /**
	* Holds references to the attribute groups that share the same {@link module:engine/view/attributeelement~ViewAttributeElement#id id}.
	* The keys are `id`s, the values are `Set`s holding {@link module:engine/view/attributeelement~ViewAttributeElement}s.
	*/ _cloneGroups = /* @__PURE__ */ new Map();
    /**
	* The slot factory used by the `elementToStructure` downcast helper.
	*/ _slotFactory = null;
    /**
	* @param document The view document instance.
	*/ constructor(document1){
        this.document = document1;
    }
    setSelection(...args) {
        this.document.selection._setTo(...args);
    }
    /**
	* Moves {@link module:engine/view/documentselection~ViewDocumentSelection#focus selection's focus} to the specified location.
	*
	* The location can be specified in the same form as
	* {@link module:engine/view/view~EditingView#createPositionAt view.createPositionAt()}
	* parameters.
	*
	* @param itemOrPosition
	* @param offset Offset or one of the flags. Used only when the first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ setSelectionFocus(itemOrPosition, offset) {
        this.document.selection._setFocus(itemOrPosition, offset);
    }
    /**
	* Creates a new {@link module:engine/view/documentfragment~ViewDocumentFragment} instance.
	*
	* @param children A list of nodes to be inserted into the created document fragment.
	* @returns The created document fragment.
	*/ createDocumentFragment(children) {
        return new $b9b9f2bdf9c6137f$export$574fd53611480ec7(this.document, children);
    }
    /**
	* Creates a new {@link module:engine/view/text~ViewText text node}.
	*
	* ```ts
	* writer.createText( 'foo' );
	* ```
	*
	* @param data The text's data.
	* @returns The created text node.
	*/ createText(data) {
        return new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(this.document, data);
    }
    /**
	* Creates a new {@link module:engine/view/attributeelement~ViewAttributeElement}.
	*
	* ```ts
	* writer.createAttributeElement( 'strong' );
	* writer.createAttributeElement( 'a', { href: 'foo.bar' } );
	*
	* // Make `<a>` element contain other attributes element so the `<a>` element is not broken.
	* writer.createAttributeElement( 'a', { href: 'foo.bar' }, { priority: 5 } );
	*
	* // Set `id` of a marker element so it is not joined or merged with "normal" elements.
	* writer.createAttributeElement( 'span', { class: 'my-marker' }, { id: 'marker:my' } );
	* ```
	*
	* @param name Name of the element.
	* @param attributes Element's attributes.
	* @param options Element's options.
	* @param options.priority Element's {@link module:engine/view/attributeelement~ViewAttributeElement#priority priority}.
	* @param options.id Element's {@link module:engine/view/attributeelement~ViewAttributeElement#id id}.
	* @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
	* pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
	* @returns Created element.
	*/ createAttributeElement(name, attributes, options = {}) {
        const attributeElement = new $b9b9f2bdf9c6137f$export$9c94dd4019f314d7(this.document, name, attributes);
        if (typeof options.priority === "number") attributeElement._priority = options.priority;
        if (options.id) attributeElement._id = options.id;
        if (options.renderUnsafeAttributes) attributeElement._unsafeAttributesToRender.push(...options.renderUnsafeAttributes);
        return attributeElement;
    }
    createContainerElement(name, attributes, childrenOrOptions = {}, options = {}) {
        let children = void 0;
        if ($b9b9f2bdf9c6137f$var$isContainerOptions(childrenOrOptions)) options = childrenOrOptions;
        else children = childrenOrOptions;
        const containerElement = new $b9b9f2bdf9c6137f$export$7cd474321d18c0af(this.document, name, attributes, children);
        if (options.renderUnsafeAttributes) containerElement._unsafeAttributesToRender.push(...options.renderUnsafeAttributes);
        return containerElement;
    }
    /**
	* Creates a new {@link module:engine/view/editableelement~ViewEditableElement}.
	*
	* ```ts
	* writer.createEditableElement( 'div' );
	* writer.createEditableElement( 'div', { id: 'foo-1234' } );
	* ```
	*
	* Note: The editable element is to be used in the editing pipeline. Usually, together with
	* {@link module:widget/utils~toWidgetEditable `toWidgetEditable()`}.
	*
	* @param name Name of the element.
	* @param attributes Elements attributes.
	* @param options Element's options.
	* @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
	* pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
	* @returns Created element.
	*/ createEditableElement(name, attributes, options = {}) {
        const editableElement = new $b9b9f2bdf9c6137f$export$785df0da0fc4f1c8(this.document, name, attributes);
        if (options.renderUnsafeAttributes) editableElement._unsafeAttributesToRender.push(...options.renderUnsafeAttributes);
        return editableElement;
    }
    /**
	* Creates a new {@link module:engine/view/emptyelement~ViewEmptyElement}.
	*
	* ```ts
	* writer.createEmptyElement( 'img' );
	* writer.createEmptyElement( 'img', { id: 'foo-1234' } );
	* ```
	*
	* @param name Name of the element.
	* @param attributes Elements attributes.
	* @param options Element's options.
	* @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
	* pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
	* @returns Created element.
	*/ createEmptyElement(name, attributes, options = {}) {
        const emptyElement = new $b9b9f2bdf9c6137f$export$a2e67116aa89395d(this.document, name, attributes);
        if (options.renderUnsafeAttributes) emptyElement._unsafeAttributesToRender.push(...options.renderUnsafeAttributes);
        return emptyElement;
    }
    /**
	* Creates a new {@link module:engine/view/uielement~ViewUIElement}.
	*
	* ```ts
	* writer.createUIElement( 'span' );
	* writer.createUIElement( 'span', { id: 'foo-1234' } );
	* ```
	*
	* A custom render function can be provided as the third parameter:
	*
	* ```ts
	* writer.createUIElement( 'span', null, function( domDocument ) {
	* 	const domElement = this.toDomElement( domDocument );
	* 	domElement.innerHTML = trustedHtml( '<b>this is ui element</b>' );
	*
	* 	return domElement;
	* } );
	* ```
	*
	* The {@link module:utils/dom/trustedtypes~trustedHtml `trustedHtml()`} helper keeps the assignment working in
	* applications that enforce Trusted Types.
	*
	* Unlike {@link #createRawElement raw elements}, UI elements are by no means editor content, for instance,
	* they are ignored by the editor selection system.
	*
	* You should not use UI elements as data containers. Check out {@link #createRawElement} instead.
	*
	* @param name The name of the element.
	* @param attributes Element attributes.
	* @param renderFunction A custom render function.
	* @returns The created element.
	*/ createUIElement(name, attributes, renderFunction) {
        const uiElement = new $b9b9f2bdf9c6137f$export$3d8082ae114b5652(this.document, name, attributes);
        if (renderFunction) uiElement.render = renderFunction;
        return uiElement;
    }
    /**
	* Creates a new {@link module:engine/view/rawelement~ViewRawElement}.
	*
	* ```ts
	* writer.createRawElement( 'span', { id: 'foo-1234' }, function( domElement ) {
	* 	domElement.innerHTML = trustedHtml( '<b>This is the raw content of the raw element.</b>' );
	* } );
	* ```
	*
	* The {@link module:utils/dom/trustedtypes~trustedHtml `trustedHtml()`} helper keeps the assignment working in
	* applications that enforce Trusted Types.
	*
	* Raw elements work as data containers ("wrappers", "sandboxes") but their children are not managed or
	* even recognized by the editor. This encapsulation allows integrations to maintain custom DOM structures
	* in the editor content without, for instance, worrying about compatibility with other editor features.
	* Raw elements are a perfect tool for integration with external frameworks and data sources.
	*
	* Unlike {@link #createUIElement UI elements}, raw elements act like "real" editor content (similar to
	* {@link module:engine/view/containerelement~ViewContainerElement} or {@link module:engine/view/emptyelement~ViewEmptyElement}),
	* and they are considered by the editor selection.
	*
	* You should not use raw elements to render the UI in the editor content. Check out {@link #createUIElement `#createUIElement()`}
	* instead.
	*
	* @param name The name of the element.
	* @param attributes Element attributes.
	* @param renderFunction A custom render function.
	* @param options Element's options.
	* @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
	* pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
	* @returns The created element.
	*/ createRawElement(name, attributes, renderFunction, options = {}) {
        const rawElement = new $b9b9f2bdf9c6137f$export$533ef497f99ba10c(this.document, name, attributes);
        if (renderFunction) rawElement.render = renderFunction;
        if (options.renderUnsafeAttributes) rawElement._unsafeAttributesToRender.push(...options.renderUnsafeAttributes);
        return rawElement;
    }
    setAttribute(key, value, elementOrOverwrite, element) {
        if (element !== void 0) element._setAttribute(key, value, elementOrOverwrite);
        else elementOrOverwrite._setAttribute(key, value);
    }
    removeAttribute(key, elementOrTokens, element) {
        if (element !== void 0) element._removeAttribute(key, elementOrTokens);
        else elementOrTokens._removeAttribute(key);
    }
    /**
	* Adds specified class to the element.
	*
	* ```ts
	* writer.addClass( 'foo', linkElement );
	* writer.addClass( [ 'foo', 'bar' ], linkElement );
	* ```
	*/ addClass(className, element) {
        element._addClass(className);
    }
    /**
	* Removes specified class from the element.
	*
	* ```ts
	* writer.removeClass( 'foo', linkElement );
	* writer.removeClass( [ 'foo', 'bar' ], linkElement );
	* ```
	*/ removeClass(className, element) {
        element._removeClass(className);
    }
    setStyle(property, value, element) {
        if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(property) && element === void 0) value._setStyle(property);
        else element._setStyle(property, value);
    }
    /**
	* Removes specified style from the element.
	*
	* ```ts
	* writer.removeStyle( 'color', element ); // Removes 'color' style.
	* writer.removeStyle( [ 'color', 'border-top' ], element ); // Removes both 'color' and 'border-top' styles.
	* ```
	*
	* **Note**: This method can work with normalized style names if
	* {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
	* See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
	*/ removeStyle(property, element) {
        element._removeStyle(property);
    }
    /**
	* Sets a custom property on element. Unlike attributes, custom properties are not rendered to the DOM,
	* so they can be used to add special data to elements.
	*/ setCustomProperty(key, value, element) {
        element._setCustomProperty(key, value);
    }
    /**
	* Removes a custom property stored under the given key.
	*
	* @returns Returns true if property was removed.
	*/ removeCustomProperty(key, element) {
        return element._removeCustomProperty(key);
    }
    /**
	* Breaks attribute elements at the provided position or at the boundaries of a provided range. It breaks attribute elements
	* up to their first ancestor that is a container element.
	*
	* In following examples `<p>` is a container, `<b>` and `<u>` are attribute elements:
	*
	* ```html
	* <p>foo<b><u>bar{}</u></b></p> -> <p>foo<b><u>bar</u></b>[]</p>
	* <p>foo<b><u>{}bar</u></b></p> -> <p>foo{}<b><u>bar</u></b></p>
	* <p>foo<b><u>b{}ar</u></b></p> -> <p>foo<b><u>b</u></b>[]<b><u>ar</u></b></p>
	* <p><b>fo{o</b><u>ba}r</u></p> -> <p><b>fo</b><b>o</b><u>ba</u><u>r</u></b></p>
	* ```
	*
	* **Note:** {@link module:engine/view/documentfragment~ViewDocumentFragment DocumentFragment} is treated like a container.
	*
	* **Note:** The difference between {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes breakAttributes()} and
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakContainer breakContainer()} is that `breakAttributes()` breaks all
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} that are ancestors of a given `position`,
	* up to the first encountered {@link module:engine/view/containerelement~ViewContainerElement container element}.
	* `breakContainer()` assumes that a given `position` is directly in the container element and breaks that container element.
	*
	* Throws the `view-writer-invalid-range-container` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
	* when the {@link module:engine/view/range~ViewRange#start start}
	* and {@link module:engine/view/range~ViewRange#end end} positions of a passed range are not placed inside same parent container.
	*
	* Throws the `view-writer-cannot-break-empty-element` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
	* when trying to break attributes inside an {@link module:engine/view/emptyelement~ViewEmptyElement ViewEmptyElement}.
	*
	* Throws the `view-writer-cannot-break-ui-element` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
	* when trying to break attributes inside a {@link module:engine/view/uielement~ViewUIElement UIElement}.
	*
	* @see module:engine/view/attributeelement~ViewAttributeElement
	* @see module:engine/view/containerelement~ViewContainerElement
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#breakContainer
	* @param positionOrRange The position where to break attribute elements.
	* @returns The new position or range, after breaking the attribute elements.
	*/ breakAttributes(positionOrRange) {
        if (positionOrRange instanceof $b9b9f2bdf9c6137f$export$7534acacc32db851) return this._breakAttributes(positionOrRange);
        else return this._breakAttributesRange(positionOrRange);
    }
    /**
	* Breaks a {@link module:engine/view/containerelement~ViewContainerElement container view element} into two, at the given position.
	* The position has to be directly inside the container element and cannot be in the root. It does not break the conrainer view element
	* if the position is at the beginning or at the end of its parent element.
	*
	* ```html
	* <p>foo^bar</p> -> <p>foo</p><p>bar</p>
	* <div><p>foo</p>^<p>bar</p></div> -> <div><p>foo</p></div><div><p>bar</p></div>
	* <p>^foobar</p> -> ^<p>foobar</p>
	* <p>foobar^</p> -> <p>foobar</p>^
	* ```
	*
	* **Note:** The difference between {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes breakAttributes()} and
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakContainer breakContainer()} is that `breakAttributes()` breaks all
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} that are ancestors of a given `position`,
	* up to the first encountered {@link module:engine/view/containerelement~ViewContainerElement container element}.
	* `breakContainer()` assumes that the given `position` is directly in the container element and breaks that container element.
	*
	* @see module:engine/view/attributeelement~ViewAttributeElement
	* @see module:engine/view/containerelement~ViewContainerElement
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes
	* @param position The position where to break the element.
	* @returns The position between broken elements. If an element has not been broken,
	* the returned position is placed either before or after it.
	*/ breakContainer(position) {
        const element = position.parent;
        if (!element.is("containerElement")) /**
		* Trying to break an element which is not a container element.
		*
		* @error view-writer-break-non-container-element
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-break-non-container-element", this.document);
        if (!element.parent) /**
		* Trying to break root element.
		*
		* @error view-writer-break-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-break-root", this.document);
        if (position.isAtStart) return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(element);
        else if (!position.isAtEnd) {
            const newElement = element._clone(false);
            this.insert($b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(element), newElement);
            const sourceRange = new $b9b9f2bdf9c6137f$export$829eb746b222877(position, $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(element, "end"));
            const targetPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(newElement, 0);
            this.move(sourceRange, targetPosition);
        }
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(element);
    }
    /**
	* Merges {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements}. It also merges text nodes if needed.
	* Only {@link module:engine/view/attributeelement~ViewAttributeElement#isSimilar similar} attribute elements can be merged.
	*
	* In following examples `<p>` is a container and `<b>` is an attribute element:
	*
	* ```html
	* <p>foo[]bar</p> -> <p>foo{}bar</p>
	* <p><b>foo</b>[]<b>bar</b></p> -> <p><b>foo{}bar</b></p>
	* <p><b foo="bar">a</b>[]<b foo="baz">b</b></p> -> <p><b foo="bar">a</b>[]<b foo="baz">b</b></p>
	* ```
	*
	* It will also take care about empty attributes when merging:
	*
	* ```html
	* <p><b>[]</b></p> -> <p>[]</p>
	* <p><b>foo</b><i>[]</i><b>bar</b></p> -> <p><b>foo{}bar</b></p>
	* ```
	*
	* **Note:** Difference between {@link module:engine/view/downcastwriter~ViewDowncastWriter#mergeAttributes mergeAttributes} and
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#mergeContainers mergeContainers} is that `mergeAttributes` merges two
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} or
	* {@link module:engine/view/text~ViewText text nodes} while `mergeContainer` merges two
	* {@link module:engine/view/containerelement~ViewContainerElement container elements}.
	*
	* @see module:engine/view/attributeelement~ViewAttributeElement
	* @see module:engine/view/containerelement~ViewContainerElement
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#mergeContainers
	* @param position Merge position.
	* @returns Position after merge.
	*/ mergeAttributes(position) {
        const positionOffset = position.offset;
        const positionParent = position.parent;
        if (positionParent.is("$text")) return position;
        if (positionParent.is("attributeElement") && positionParent.childCount === 0) {
            const parent = positionParent.parent;
            const offset = positionParent.index;
            positionParent._remove();
            this._removeFromClonedElementsGroup(positionParent);
            return this.mergeAttributes(new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, offset));
        }
        const nodeBefore = positionParent.getChild(positionOffset - 1);
        const nodeAfter = positionParent.getChild(positionOffset);
        if (!nodeBefore || !nodeAfter) return position;
        if (nodeBefore.is("$text") && nodeAfter.is("$text")) return $b9b9f2bdf9c6137f$var$mergeTextNodes(nodeBefore, nodeAfter);
        else if (nodeBefore.is("attributeElement") && nodeAfter.is("attributeElement") && nodeBefore.isSimilar(nodeAfter)) {
            const count = nodeBefore.childCount;
            nodeBefore._appendChild(nodeAfter.getChildren());
            nodeAfter._remove();
            this._removeFromClonedElementsGroup(nodeAfter);
            return this.mergeAttributes(new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeBefore, count));
        }
        return position;
    }
    /**
	* Merges two {@link module:engine/view/containerelement~ViewContainerElement container elements} that are
	* before and after given position. Precisely, the element after the position is removed and it's contents are
	* moved to element before the position.
	*
	* ```html
	* <p>foo</p>^<p>bar</p> -> <p>foo^bar</p>
	* <div>foo</div>^<p>bar</p> -> <div>foo^bar</div>
	* ```
	*
	* **Note:** Difference between {@link module:engine/view/downcastwriter~ViewDowncastWriter#mergeAttributes mergeAttributes} and
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#mergeContainers mergeContainers} is that `mergeAttributes` merges two
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} or
	* {@link module:engine/view/text~ViewText text nodes} while `mergeContainer` merges two
	* {@link module:engine/view/containerelement~ViewContainerElement container elements}.
	*
	* @see module:engine/view/attributeelement~ViewAttributeElement
	* @see module:engine/view/containerelement~ViewContainerElement
	* @see module:engine/view/downcastwriter~ViewDowncastWriter#mergeAttributes
	* @param position Merge position.
	* @returns Position after merge.
	*/ mergeContainers(position) {
        const prev = position.nodeBefore;
        const next = position.nodeAfter;
        if (!prev || !next || !prev.is("containerElement") || !next.is("containerElement")) /**
		* Element before and after given position cannot be merged.
		*
		* @error view-writer-merge-containers-invalid-position
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-merge-containers-invalid-position", this.document);
        const lastChild = prev.getChild(prev.childCount - 1);
        const newPosition = lastChild instanceof $b9b9f2bdf9c6137f$export$1f9d53a26119da3d ? $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(lastChild, "end") : $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(prev, "end");
        this.move($b9b9f2bdf9c6137f$export$829eb746b222877._createIn(next), $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(prev, "end"));
        this.remove($b9b9f2bdf9c6137f$export$829eb746b222877._createOn(next));
        return newPosition;
    }
    /**
	* Inserts a node or nodes at specified position. Takes care about breaking attributes before insertion
	* and merging them afterwards.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-insert-invalid-node` when nodes to insert
	* contains instances that are not {@link module:engine/view/text~ViewText Texts},
	* {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElements},
	* {@link module:engine/view/containerelement~ViewContainerElement ViewContainerElements},
	* {@link module:engine/view/emptyelement~ViewEmptyElement ViewEmptyElements},
	* {@link module:engine/view/rawelement~ViewRawElement RawElements} or
	* {@link module:engine/view/uielement~ViewUIElement UIElements}.
	*
	* @param position Insertion position.
	* @param nodes Node or nodes to insert.
	* @returns Range around inserted nodes.
	*/ insert(position, nodes) {
        nodes = (0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes) ? [
            ...nodes
        ] : [
            nodes
        ];
        $b9b9f2bdf9c6137f$var$validateNodesToInsert(nodes, this.document);
        const nodeGroups = nodes.reduce((groups, node)=>{
            const lastGroup = groups[groups.length - 1];
            const breakAttributes = !node.is("uiElement");
            if (!lastGroup || lastGroup.breakAttributes != breakAttributes) groups.push({
                breakAttributes: breakAttributes,
                nodes: [
                    node
                ]
            });
            else lastGroup.nodes.push(node);
            return groups;
        }, []);
        let start = null;
        let end = position;
        for (const { nodes: nodes, breakAttributes: breakAttributes } of nodeGroups){
            const range = this._insertNodes(end, nodes, breakAttributes);
            if (!start) start = range.start;
            end = range.end;
        }
        if (!start) return new $b9b9f2bdf9c6137f$export$829eb746b222877(position);
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Removes provided range from the container.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
	* {@link module:engine/view/range~ViewRange#start start} and {@link module:engine/view/range~ViewRange#end end}
	* positions are not placed inside same parent container.
	*
	* @param rangeOrItem Range to remove from container
	* or an {@link module:engine/view/item~ViewItem item} to remove. If range is provided, after removing, it will be updated
	* to a collapsed range showing the new position.
	* @returns Document fragment containing removed nodes.
	*/ remove(rangeOrItem) {
        const range = rangeOrItem instanceof $b9b9f2bdf9c6137f$export$829eb746b222877 ? rangeOrItem : $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(rangeOrItem);
        $b9b9f2bdf9c6137f$var$validateRangeContainer(range, this.document);
        if (range.isCollapsed) return new $b9b9f2bdf9c6137f$export$574fd53611480ec7(this.document);
        const { start: breakStart, end: breakEnd } = this._breakAttributesRange(range, true);
        const parentContainer = breakStart.parent;
        const count = breakEnd.offset - breakStart.offset;
        const removed = parentContainer._removeChildren(breakStart.offset, count);
        for (const node of removed)this._removeFromClonedElementsGroup(node);
        const mergePosition = this.mergeAttributes(breakStart);
        range.start = mergePosition;
        range.end = mergePosition.clone();
        return new $b9b9f2bdf9c6137f$export$574fd53611480ec7(this.document, removed);
    }
    /**
	* Removes matching elements from given range.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
	* {@link module:engine/view/range~ViewRange#start start} and {@link module:engine/view/range~ViewRange#end end}
	* positions are not placed inside same parent container.
	*
	* @param range Range to clear.
	* @param element Element to remove.
	*/ clear(range, element) {
        $b9b9f2bdf9c6137f$var$validateRangeContainer(range, this.document);
        const walker = range.getWalker({
            direction: "backward",
            ignoreElementEnd: true
        });
        for (const current of walker){
            const item = current.item;
            let rangeToRemove;
            if (item.is("element") && element.isSimilar(item)) rangeToRemove = $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(item);
            else if (!current.nextPosition.isAfter(range.start) && item.is("$textProxy")) {
                const parentElement = item.getAncestors().find((ancestor)=>{
                    return ancestor.is("element") && element.isSimilar(ancestor);
                });
                if (parentElement) rangeToRemove = $b9b9f2bdf9c6137f$export$829eb746b222877._createIn(parentElement);
            }
            if (rangeToRemove) {
                if (rangeToRemove.end.isAfter(range.end)) rangeToRemove.end = range.end;
                if (rangeToRemove.start.isBefore(range.start)) rangeToRemove.start = range.start;
                this.remove(rangeToRemove);
            }
        }
    }
    /**
	* Moves nodes from provided range to target position.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
	* {@link module:engine/view/range~ViewRange#start start} and {@link module:engine/view/range~ViewRange#end end}
	* positions are not placed inside same parent container.
	*
	* @param sourceRange Range containing nodes to move.
	* @param targetPosition Position to insert.
	* @returns Range in target container. Inserted nodes are placed between
	* {@link module:engine/view/range~ViewRange#start start} and {@link module:engine/view/range~ViewRange#end end} positions.
	*/ move(sourceRange, targetPosition) {
        let nodes;
        if (targetPosition.isAfter(sourceRange.end)) {
            targetPosition = this._breakAttributes(targetPosition, true);
            const parent = targetPosition.parent;
            const countBefore = parent.childCount;
            sourceRange = this._breakAttributesRange(sourceRange, true);
            nodes = this.remove(sourceRange);
            targetPosition.offset += parent.childCount - countBefore;
        } else nodes = this.remove(sourceRange);
        return this.insert(targetPosition, nodes);
    }
    /**
	* Wraps elements within range with provided {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement}.
	* If a collapsed range is provided, it will be wrapped only if it is equal to view selection.
	*
	* If a collapsed range was passed and is same as selection, the selection
	* will be moved to the inside of the wrapped attribute element.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-invalid-range-container`
	* when {@link module:engine/view/range~ViewRange#start}
	* and {@link module:engine/view/range~ViewRange#end} positions are not placed inside same parent container.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
	* an instance of {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement}.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-nonselection-collapsed-range` when passed range
	* is collapsed and different than view selection.
	*
	* @param range Range to wrap.
	* @param attribute Attribute element to use as wrapper.
	* @returns range Range after wrapping, spanning over wrapping attribute element.
	*/ wrap(range, attribute) {
        if (!(attribute instanceof $b9b9f2bdf9c6137f$export$9c94dd4019f314d7)) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-wrap-invalid-attribute", this.document);
        $b9b9f2bdf9c6137f$var$validateRangeContainer(range, this.document);
        if (!range.isCollapsed) return this._wrapRange(range, attribute);
        else {
            let position = range.start;
            if (position.parent.is("element") && !$b9b9f2bdf9c6137f$var$_hasNonUiChildren(position.parent)) position = position.getLastMatchingPosition((value)=>value.item.is("uiElement"));
            position = this._wrapPosition(position, attribute);
            const viewSelection = this.document.selection;
            if (viewSelection.isCollapsed && viewSelection.getFirstPosition().isEqual(range.start)) this.setSelection(position);
            return new $b9b9f2bdf9c6137f$export$829eb746b222877(position);
        }
    }
    /**
	* Unwraps nodes within provided range from attribute element.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
	* {@link module:engine/view/range~ViewRange#start start} and {@link module:engine/view/range~ViewRange#end end}
	* positions are not placed inside same parent container.
	*/ unwrap(range, attribute) {
        if (!(attribute instanceof $b9b9f2bdf9c6137f$export$9c94dd4019f314d7)) /**
		* The `attribute` passed to {@link module:engine/view/downcastwriter~ViewDowncastWriter#unwrap `ViewDowncastWriter#unwrap()`}
		* must be an instance of {@link module:engine/view/attributeelement~ViewAttributeElement `AttributeElement`}.
		*
		* @error view-writer-unwrap-invalid-attribute
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-unwrap-invalid-attribute", this.document);
        $b9b9f2bdf9c6137f$var$validateRangeContainer(range, this.document);
        if (range.isCollapsed) return range;
        const { start: breakStart, end: breakEnd } = this._breakAttributesRange(range, true);
        const parentContainer = breakStart.parent;
        const newRange = this._unwrapChildren(parentContainer, breakStart.offset, breakEnd.offset, attribute);
        const start = this.mergeAttributes(newRange.start);
        if (!start.isEqual(newRange.start)) newRange.end.offset--;
        const end = this.mergeAttributes(newRange.end);
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Renames element by creating a copy of renamed element but with changed name and then moving contents of the
	* old element to the new one. Keep in mind that this will invalidate all {@link module:engine/view/position~ViewPosition positions}
	* which has renamed element as {@link module:engine/view/position~ViewPosition#parent a parent}.
	*
	* New element has to be created because `Element#tagName` property in DOM is readonly.
	*
	* Since this function creates a new element and removes the given one, the new element is returned to keep reference.
	*
	* @param newName New name for element.
	* @param viewElement Element to be renamed.
	* @returns Element created due to rename.
	*/ rename(newName, viewElement) {
        const newElement = new $b9b9f2bdf9c6137f$export$7cd474321d18c0af(this.document, newName, viewElement.getAttributes());
        this.insert($b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(viewElement), newElement);
        this.move($b9b9f2bdf9c6137f$export$829eb746b222877._createIn(viewElement), $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(newElement, 0));
        this.remove($b9b9f2bdf9c6137f$export$829eb746b222877._createOn(viewElement));
        return newElement;
    }
    /**
	* Cleans up memory by removing obsolete cloned elements group from the writer.
	*
	* Should be used whenever all {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements}
	* with the same {@link module:engine/view/attributeelement~ViewAttributeElement#id id} are going to be removed from the view and
	* the group will no longer be needed.
	*
	* Cloned elements group are not removed automatically in case if the group is still needed after all its elements
	* were removed from the view.
	*
	* Keep in mind that group names are equal to the `id` property of the attribute element.
	*
	* @param groupName Name of the group to clear.
	*/ clearClonedElementsGroup(groupName) {
        this._cloneGroups.delete(groupName);
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/view/position~ViewPosition position},
	* * parent element and offset (offset defaults to `0`),
	* * parent element and `'end'` (sets position at the end of that element),
	* * {@link module:engine/view/item~ViewItem view item} and `'before'` or `'after'` (sets position before or after given view item).
	*
	* This method is a shortcut to other constructors such as:
	*
	* * {@link #createPositionBefore},
	* * {@link #createPositionAfter},
	*
	* @param offset Offset or one of the flags. Used only when the first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ createPositionAt(itemOrPosition, offset) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(itemOrPosition, offset);
    }
    /**
	* Creates a new position after given view item.
	*
	* @param item View item after which the position should be located.
	*/ createPositionAfter(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item);
    }
    /**
	* Creates a new position before given view item.
	*
	* @param item View item before which the position should be located.
	*/ createPositionBefore(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item);
    }
    /**
	* Creates a range spanning from `start` position to `end` position.
	*
	* **Note:** This factory method creates its own {@link module:engine/view/position~ViewPosition} instances basing on passed values.
	*
	* @param start Start position.
	* @param end End position. If not set, range will be collapsed at `start` position.
	*/ createRange(start, end) {
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Creates a range that starts before given {@link module:engine/view/item~ViewItem view item} and ends after it.
	*/ createRangeOn(item) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(item);
    }
    /**
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* @param element Element which is a parent for the range.
	*/ createRangeIn(element) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createIn(element);
    }
    createSelection(...args) {
        return new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(...args);
    }
    /**
	* Creates placeholders for child elements of the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure
	* `elementToStructure()`} conversion helper.
	*
	* ```ts
	* const viewSlot = conversionApi.writer.createSlot();
	* const viewPosition = conversionApi.writer.createPositionAt( viewElement, 0 );
	*
	* conversionApi.writer.insert( viewPosition, viewSlot );
	* ```
	*
	* It could be filtered down to a specific subset of children (only `<foo>` model elements in this case):
	*
	* ```ts
	* const viewSlot = conversionApi.writer.createSlot( node => node.is( 'element', 'foo' ) );
	* const viewPosition = conversionApi.writer.createPositionAt( viewElement, 0 );
	*
	* conversionApi.writer.insert( viewPosition, viewSlot );
	* ```
	*
	* While providing a filtered slot, make sure to provide slots for all child nodes. A single node cannot be downcasted into
	* multiple slots.
	*
	* **Note**: You should not change the order of nodes. View elements should be in the same order as model nodes.
	*
	* @param modeOrFilter The filter for child nodes.
	* @returns The slot element to be placed in to the view structure while processing
	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure `elementToStructure()`}.
	*/ createSlot(modeOrFilter = "children") {
        if (!this._slotFactory) /**
		* The `createSlot()` method is only allowed inside the `elementToStructure` downcast helper callback.
		*
		* @error view-writer-invalid-create-slot-context
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-invalid-create-slot-context", this.document);
        return this._slotFactory(this, modeOrFilter);
    }
    /**
	* Registers a slot factory.
	*
	* @internal
	* @param slotFactory The slot factory.
	*/ _registerSlotFactory(slotFactory) {
        this._slotFactory = slotFactory;
    }
    /**
	* Clears the registered slot factory.
	*
	* @internal
	*/ _clearSlotFactory() {
        this._slotFactory = null;
    }
    /**
	* Inserts a node or nodes at the specified position. Takes care of breaking attributes before insertion
	* and merging them afterwards if requested by the breakAttributes param.
	*
	* @param position Insertion position.
	* @param nodes Node or nodes to insert.
	* @param breakAttributes Whether attributes should be broken.
	* @returns Range around inserted nodes.
	*/ _insertNodes(position, nodes, breakAttributes) {
        let parentElement;
        if (breakAttributes) parentElement = $b9b9f2bdf9c6137f$var$getParentContainer(position);
        else parentElement = position.parent.is("$text") ? position.parent.parent : position.parent;
        if (!parentElement) /**
		* Position's parent container cannot be found.
		*
		* @error view-writer-invalid-position-container
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-invalid-position-container", this.document);
        let insertionPosition;
        if (breakAttributes) insertionPosition = this._breakAttributes(position, true);
        else insertionPosition = position.parent.is("$text") ? $b9b9f2bdf9c6137f$var$breakTextNode(position) : position;
        const length = parentElement._insertChild(insertionPosition.offset, nodes);
        for (const node of nodes)this._addToClonedElementsGroup(node);
        const endPosition = insertionPosition.getShiftedBy(length);
        const start = this.mergeAttributes(insertionPosition);
        if (!start.isEqual(insertionPosition)) endPosition.offset--;
        const end = this.mergeAttributes(endPosition);
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Wraps children with provided `wrapElement`. Only children contained in `parent` element between
	* `startOffset` and `endOffset` will be wrapped.
	*/ _wrapChildren(parent, startOffset, endOffset, wrapElement) {
        let i = startOffset;
        const wrapPositions = [];
        while(i < endOffset){
            const child = parent.getChild(i);
            const isText = child.is("$text");
            const isAttribute = child.is("attributeElement");
            if (isAttribute && child._canMergeAttributesFrom(wrapElement)) {
                child._mergeAttributesFrom(wrapElement);
                wrapPositions.push(new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i));
            } else if (isText || !isAttribute || $b9b9f2bdf9c6137f$var$shouldABeOutsideB(wrapElement, child)) {
                const newAttribute = wrapElement._clone();
                child._remove();
                newAttribute._appendChild(child);
                parent._insertChild(i, newAttribute);
                this._addToClonedElementsGroup(newAttribute);
                wrapPositions.push(new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i));
            } else this._wrapChildren(child, 0, child.childCount, wrapElement);
            i++;
        }
        let offsetChange = 0;
        for (const position of wrapPositions){
            position.offset -= offsetChange;
            if (position.offset == startOffset) continue;
            if (!this.mergeAttributes(position).isEqual(position)) {
                offsetChange++;
                endOffset--;
            }
        }
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createFromParentsAndOffsets(parent, startOffset, parent, endOffset);
    }
    /**
	* Unwraps children from provided `unwrapElement`. Only children contained in `parent` element between
	* `startOffset` and `endOffset` will be unwrapped.
	*/ _unwrapChildren(parent, startOffset, endOffset, unwrapElement) {
        let i = startOffset;
        const unwrapPositions = [];
        while(i < endOffset){
            const child = parent.getChild(i);
            if (!child.is("attributeElement")) {
                i++;
                continue;
            }
            if (child.isSimilar(unwrapElement)) {
                const unwrapped = child.getChildren();
                const count = child.childCount;
                child._remove();
                parent._insertChild(i, unwrapped);
                this._removeFromClonedElementsGroup(child);
                unwrapPositions.push(new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i), new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i + count));
                i += count;
                endOffset += count - 1;
                continue;
            }
            if (child._canSubtractAttributesOf(unwrapElement)) {
                child._subtractAttributesOf(unwrapElement);
                unwrapPositions.push(new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i), new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, i + 1));
                i++;
                continue;
            }
            this._unwrapChildren(child, 0, child.childCount, unwrapElement);
            i++;
        }
        let offsetChange = 0;
        for (const position of unwrapPositions){
            position.offset -= offsetChange;
            if (position.offset == startOffset || position.offset == endOffset) continue;
            if (!this.mergeAttributes(position).isEqual(position)) {
                offsetChange++;
                endOffset--;
            }
        }
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createFromParentsAndOffsets(parent, startOffset, parent, endOffset);
    }
    /**
	* Helper function for `view.writer.wrap`. Wraps range with provided attribute element.
	* This method will also merge newly added attribute element with its siblings whenever possible.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
	* an instance of {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement}.
	*
	* @returns New range after wrapping, spanning over wrapping attribute element.
	*/ _wrapRange(range, attribute) {
        const { start: breakStart, end: breakEnd } = this._breakAttributesRange(range, true);
        const parentContainer = breakStart.parent;
        const newRange = this._wrapChildren(parentContainer, breakStart.offset, breakEnd.offset, attribute);
        const start = this.mergeAttributes(newRange.start);
        if (!start.isEqual(newRange.start)) newRange.end.offset--;
        const end = this.mergeAttributes(newRange.end);
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Helper function for {@link #wrap}. Wraps position with provided attribute element.
	* This method will also merge newly added attribute element with its siblings whenever possible.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
	* an instance of {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement}.
	*
	* @returns New position after wrapping.
	*/ _wrapPosition(position, attribute) {
        if (attribute.isSimilar(position.parent)) return $b9b9f2bdf9c6137f$var$movePositionToTextNode(position.clone());
        if (position.parent.is("$text")) position = $b9b9f2bdf9c6137f$var$breakTextNode(position);
        const fakeElement = this.createAttributeElement("_wrapPosition-fake-element");
        fakeElement._priority = Number.POSITIVE_INFINITY;
        fakeElement.isSimilar = ()=>false;
        position.parent._insertChild(position.offset, fakeElement);
        const wrapRange = new $b9b9f2bdf9c6137f$export$829eb746b222877(position, position.getShiftedBy(1));
        this.wrap(wrapRange, attribute);
        const newPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(fakeElement.parent, fakeElement.index);
        fakeElement._remove();
        const nodeBefore = newPosition.nodeBefore;
        const nodeAfter = newPosition.nodeAfter;
        if (nodeBefore && nodeBefore.is("view:$text") && nodeAfter && nodeAfter.is("view:$text")) return $b9b9f2bdf9c6137f$var$mergeTextNodes(nodeBefore, nodeAfter);
        return $b9b9f2bdf9c6137f$var$movePositionToTextNode(newPosition);
    }
    /**
	* Helper function used by other `ViewDowncastWriter` methods. Breaks attribute elements at the boundaries of given range.
	*
	* @param range Range which `start` and `end` positions will be used to break attributes.
	* @param forceSplitText If set to `true`, will break text nodes even if they are directly in container element.
	* This behavior will result in incorrect view state, but is needed by other view writing methods which then fixes view state.
	* @returns New range with located at break positions.
	*/ _breakAttributesRange(range, forceSplitText = false) {
        const rangeStart = range.start;
        const rangeEnd = range.end;
        $b9b9f2bdf9c6137f$var$validateRangeContainer(range, this.document);
        if (range.isCollapsed) {
            const position = this._breakAttributes(range.start, forceSplitText);
            return new $b9b9f2bdf9c6137f$export$829eb746b222877(position, position);
        }
        const breakEnd = this._breakAttributes(rangeEnd, forceSplitText);
        const count = breakEnd.parent.childCount;
        const breakStart = this._breakAttributes(rangeStart, forceSplitText);
        breakEnd.offset += breakEnd.parent.childCount - count;
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(breakStart, breakEnd);
    }
    /**
	* Helper function used by other `ViewDowncastWriter` methods. Breaks attribute elements at given position.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-cannot-break-empty-element` when break position
	* is placed inside {@link module:engine/view/emptyelement~ViewEmptyElement ViewEmptyElement}.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-cannot-break-ui-element` when break position
	* is placed inside {@link module:engine/view/uielement~ViewUIElement UIElement}.
	*
	* @param position Position where to break attributes.
	* @param forceSplitText If set to `true`, will break text nodes even if they are directly in container element.
	* This behavior will result in incorrect view state, but is needed by other view writing methods which then fixes view state.
	* @returns New position after breaking the attributes.
	*/ _breakAttributes(position, forceSplitText = false) {
        const positionOffset = position.offset;
        const positionParent = position.parent;
        if (position.parent.is("emptyElement")) /**
		* Cannot break an `EmptyElement` instance.
		*
		* This error is thrown if
		* {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes `ViewDowncastWriter#breakAttributes()`}
		* was executed in an incorrect position.
		*
		* @error view-writer-cannot-break-empty-element
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-cannot-break-empty-element", this.document);
        if (position.parent.is("uiElement")) /**
		* Cannot break a `UIElement` instance.
		*
		* This error is thrown if
		* {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes `ViewDowncastWriter#breakAttributes()`}
		* was executed in an incorrect position.
		*
		* @error view-writer-cannot-break-ui-element
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-cannot-break-ui-element", this.document);
        if (position.parent.is("rawElement")) /**
		* Cannot break a `RawElement` instance.
		*
		* This error is thrown if
		* {@link module:engine/view/downcastwriter~ViewDowncastWriter#breakAttributes `ViewDowncastWriter#breakAttributes()`}
		* was executed in an incorrect position.
		*
		* @error view-writer-cannot-break-raw-element
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-cannot-break-raw-element", this.document);
        if (!forceSplitText && positionParent.is("$text") && $b9b9f2bdf9c6137f$var$isContainerOrFragment(positionParent.parent)) return position.clone();
        if ($b9b9f2bdf9c6137f$var$isContainerOrFragment(positionParent)) return position.clone();
        if (positionParent.is("$text")) return this._breakAttributes($b9b9f2bdf9c6137f$var$breakTextNode(position), forceSplitText);
        if (positionOffset == positionParent.childCount) {
            const newPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(positionParent.parent, positionParent.index + 1);
            return this._breakAttributes(newPosition, forceSplitText);
        } else if (positionOffset === 0) {
            const newPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(positionParent.parent, positionParent.index);
            return this._breakAttributes(newPosition, forceSplitText);
        } else {
            const offsetAfter = positionParent.index + 1;
            const clonedNode = positionParent._clone();
            positionParent.parent._insertChild(offsetAfter, clonedNode);
            this._addToClonedElementsGroup(clonedNode);
            const count = positionParent.childCount - positionOffset;
            const nodesToMove = positionParent._removeChildren(positionOffset, count);
            clonedNode._appendChild(nodesToMove);
            const newPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(positionParent.parent, offsetAfter);
            return this._breakAttributes(newPosition, forceSplitText);
        }
    }
    /**
	* Stores the information that an {@link module:engine/view/attributeelement~ViewAttributeElement attribute element} was
	* added to the tree. Saves the reference to the group in the given element and updates the group, so other elements
	* from the group now keep a reference to the given attribute element.
	*
	* The clones group can be obtained using {@link module:engine/view/attributeelement~ViewAttributeElement#getElementsWithSameId}.
	*
	* Does nothing if added element has no {@link module:engine/view/attributeelement~ViewAttributeElement#id id}.
	*
	* @param element Attribute element to save.
	*/ _addToClonedElementsGroup(element) {
        if (!element.root.is("rootElement")) return;
        if (element.is("element")) for (const child of element.getChildren())this._addToClonedElementsGroup(child);
        const id = element.id;
        if (!id) return;
        let group = this._cloneGroups.get(id);
        if (!group) {
            group = /* @__PURE__ */ new Set();
            this._cloneGroups.set(id, group);
        }
        group.add(element);
        element._clonesGroup = group;
    }
    /**
	* Removes all the information about the given {@link module:engine/view/attributeelement~ViewAttributeElement attribute element}
	* from its clones group.
	*
	* Keep in mind, that the element will still keep a reference to the group (but the group will not keep a reference to it).
	* This allows to reference the whole group even if the element was already removed from the tree.
	*
	* Does nothing if the element has no {@link module:engine/view/attributeelement~ViewAttributeElement#id id}.
	*
	* @param element Attribute element to remove.
	*/ _removeFromClonedElementsGroup(element) {
        if (element.is("element")) for (const child of element.getChildren())this._removeFromClonedElementsGroup(child);
        const id = element.id;
        if (!id) return;
        const group = this._cloneGroups.get(id);
        if (!group) return;
        group.delete(element);
    }
};
function $b9b9f2bdf9c6137f$var$_hasNonUiChildren(parent) {
    return Array.from(parent.getChildren()).some((child)=>!child.is("uiElement"));
}
/**
* The `attribute` passed to {@link module:engine/view/downcastwriter~ViewDowncastWriter#wrap `ViewDowncastWriter#wrap()`}
* must be an instance of {@link module:engine/view/attributeelement~ViewAttributeElement `AttributeElement`}.
*
* @error view-writer-wrap-invalid-attribute
*/ /**
* Returns first parent container of specified {@link module:engine/view/position~ViewPosition Position}.
* Position's parent node is checked as first, then next parents are checked.
* Note that {@link module:engine/view/documentfragment~ViewDocumentFragment DocumentFragment} is treated like a container.
*
* @param position Position used as a start point to locate parent container.
* @returns Parent container element or `undefined` if container is not found.
*/ function $b9b9f2bdf9c6137f$var$getParentContainer(position) {
    let parent = position.parent;
    while(!$b9b9f2bdf9c6137f$var$isContainerOrFragment(parent)){
        if (!parent) return;
        parent = parent.parent;
    }
    return parent;
}
/**
* Checks if first {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement} provided to the function
* can be wrapped outside second element. It is done by comparing elements'
* {@link module:engine/view/attributeelement~ViewAttributeElement#priority priorities}, if both have same priority
* {@link module:engine/view/element~ViewElement#getIdentity identities} are compared.
*/ function $b9b9f2bdf9c6137f$var$shouldABeOutsideB(a, b) {
    if (a.priority < b.priority) return true;
    else if (a.priority > b.priority) return false;
    return a.getIdentity() < b.getIdentity();
}
/**
* Returns new position that is moved to near text node. Returns same position if there is no text node before of after
* specified position.
*
* ```html
* <p>foo[]</p>  ->  <p>foo{}</p>
* <p>[]foo</p>  ->  <p>{}foo</p>
* ```
*
* @returns Position located inside text node or same position if there is no text nodes
* before or after position location.
*/ function $b9b9f2bdf9c6137f$var$movePositionToTextNode(position) {
    const nodeBefore = position.nodeBefore;
    if (nodeBefore && nodeBefore.is("$text")) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeBefore, nodeBefore.data.length);
    const nodeAfter = position.nodeAfter;
    if (nodeAfter && nodeAfter.is("$text")) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeAfter, 0);
    return position;
}
/**
* Breaks text node into two text nodes when possible.
*
* ```html
* <p>foo{}bar</p> -> <p>foo[]bar</p>
* <p>{}foobar</p> -> <p>[]foobar</p>
* <p>foobar{}</p> -> <p>foobar[]</p>
* ```
*
* @param position Position that need to be placed inside text node.
* @returns New position after breaking text node.
*/ function $b9b9f2bdf9c6137f$var$breakTextNode(position) {
    if (position.offset == position.parent.data.length) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(position.parent.parent, position.parent.index + 1);
    if (position.offset === 0) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(position.parent.parent, position.parent.index);
    const textToMove = position.parent.data.slice(position.offset);
    position.parent._data = position.parent.data.slice(0, position.offset);
    position.parent.parent._insertChild(position.parent.index + 1, new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(position.root.document, textToMove));
    return new $b9b9f2bdf9c6137f$export$7534acacc32db851(position.parent.parent, position.parent.index + 1);
}
/**
* Merges two text nodes into first node. Removes second node and returns merge position.
*
* @param t1 First text node to merge. Data from second text node will be moved at the end of this text node.
* @param t2 Second text node to merge. This node will be removed after merging.
* @returns Position after merging text nodes.
*/ function $b9b9f2bdf9c6137f$var$mergeTextNodes(t1, t2) {
    const nodeBeforeLength = t1.data.length;
    t1._data += t2.data;
    t2._remove();
    return new $b9b9f2bdf9c6137f$export$7534acacc32db851(t1, nodeBeforeLength);
}
const $b9b9f2bdf9c6137f$var$validNodesToInsert = [
    $b9b9f2bdf9c6137f$export$1f9d53a26119da3d,
    $b9b9f2bdf9c6137f$export$9c94dd4019f314d7,
    $b9b9f2bdf9c6137f$export$7cd474321d18c0af,
    $b9b9f2bdf9c6137f$export$a2e67116aa89395d,
    $b9b9f2bdf9c6137f$export$533ef497f99ba10c,
    $b9b9f2bdf9c6137f$export$3d8082ae114b5652
];
/**
* Checks if provided nodes are valid to insert.
*
* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-insert-invalid-node` when nodes to insert
* contains instances that are not supported ones (see error description for valid ones.
*/ function $b9b9f2bdf9c6137f$var$validateNodesToInsert(nodes, errorContext) {
    for (const node of nodes){
        if (!$b9b9f2bdf9c6137f$var$validNodesToInsert.some((validNode)=>node instanceof validNode)) /**
		* One of the nodes to be inserted is of an invalid type.
		*
		* Nodes to be inserted with {@link module:engine/view/downcastwriter~ViewDowncastWriter#insert `ViewDowncastWriter#insert()`}
		* should be of the following types:
		*
		* * {@link module:engine/view/attributeelement~ViewAttributeElement ViewAttributeElement},
		* * {@link module:engine/view/containerelement~ViewContainerElement ViewContainerElement},
		* * {@link module:engine/view/emptyelement~ViewEmptyElement ViewEmptyElement},
		* * {@link module:engine/view/uielement~ViewUIElement UIElement},
		* * {@link module:engine/view/rawelement~ViewRawElement RawElement},
		* * {@link module:engine/view/text~ViewText Text}.
		*
		* @error view-writer-insert-invalid-node-type
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-insert-invalid-node-type", errorContext);
        if (!node.is("$text")) $b9b9f2bdf9c6137f$var$validateNodesToInsert(node.getChildren(), errorContext);
    }
}
/**
* Checks if node is ViewContainerElement or DocumentFragment, because in most cases they should be treated the same way.
*
* @returns Returns `true` if node is instance of ViewContainerElement or DocumentFragment.
*/ function $b9b9f2bdf9c6137f$var$isContainerOrFragment(node) {
    return node && (node.is("containerElement") || node.is("documentFragment"));
}
/**
* Checks if {@link module:engine/view/range~ViewRange#start range start} and {@link module:engine/view/range~ViewRange#end range end}
* are placed inside same {@link module:engine/view/containerelement~ViewContainerElement container element}.
* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when validation fails.
*/ function $b9b9f2bdf9c6137f$var$validateRangeContainer(range, errorContext) {
    const startContainer = $b9b9f2bdf9c6137f$var$getParentContainer(range.start);
    const endContainer = $b9b9f2bdf9c6137f$var$getParentContainer(range.end);
    if (!startContainer || !endContainer || startContainer !== endContainer) /**
	* The container of the given range is invalid.
	*
	* This may happen if {@link module:engine/view/range~ViewRange#start range start} and
	* {@link module:engine/view/range~ViewRange#end range end} positions are not placed inside the same container element or
	* a parent container for these positions cannot be found.
	*
	* Methods like {@link module:engine/view/downcastwriter~ViewDowncastWriter#wrap `ViewDowncastWriter#remove()`},
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#wrap `ViewDowncastWriter#clean()`},
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#wrap `ViewDowncastWriter#wrap()`},
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#wrap `ViewDowncastWriter#unwrap()`} need to be called
	* on a range that has its start and end positions located in the same container element. Both positions can be
	* nested within other elements (e.g. an attribute element) but the closest container ancestor must be the same.
	*
	* @error view-writer-invalid-range-container
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-writer-invalid-range-container", errorContext);
}
/**
* Checks if the provided argument is a plain object that can be used as options for container element.
*/ function $b9b9f2bdf9c6137f$var$isContainerOptions(childrenOrOptions) {
    return (0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(childrenOrOptions);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Set of utilities related to handling block and inline fillers.
*
* Browsers do not allow to put caret in elements which does not have height. Because of it, we need to fill all
* empty elements which should be selectable with elements or characters called "fillers". Unfortunately there is no one
* universal filler, this is why two types are uses:
*
* * Block filler is an element which fill block elements, like `<p>`. CKEditor uses `<br>` as a block filler during the editing,
* as browsers do natively. So instead of an empty `<p>` there will be `<p><br></p>`. The advantage of block filler is that
* it is transparent for the selection, so when the caret is before the `<br>` and user presses right arrow he will be
* moved to the next paragraph, not after the `<br>`. The disadvantage is that it breaks a block, so it cannot be used
* in the middle of a line of text. The {@link module:engine/view/filler~BR_FILLER `<br>` filler} can be replaced with any other
* character in the data output, for instance {@link module:engine/view/filler~NBSP_FILLER non-breaking space} or
* {@link module:engine/view/filler~MARKED_NBSP_FILLER marked non-breaking space}.
*
* * Inline filler is a filler which does not break a line of text, so it can be used inside the text, for instance in the empty
* `<b>` surrendered by text: `foo<b></b>bar`, if we want to put the caret there. CKEditor uses a sequence of the zero-width
* spaces as an {@link module:engine/view/filler~INLINE_FILLER inline filler} having the predetermined
* {@link module:engine/view/filler~INLINE_FILLER_LENGTH length}. A sequence is used, instead of a single character to
* avoid treating random zero-width spaces as the inline filler. Disadvantage of the inline filler is that it is not
* transparent for the selection. The arrow key moves the caret between zero-width spaces characters, so the additional
* code is needed to handle the caret.
*
* Both inline and block fillers are handled by the {@link module:engine/view/renderer~ViewRenderer renderer} and are not present in the
* view.
*
* @module engine/view/filler
*/ /**
* Non-breaking space filler creator. This function creates the `&nbsp;` text node.
* It defines how the filler is created.
*
* @see module:engine/view/filler~MARKED_NBSP_FILLER
* @see module:engine/view/filler~BR_FILLER
* @internal
*/ const $b9b9f2bdf9c6137f$export$c4fba0b3ea844689 = (domDocument)=>domDocument.createTextNode("\xA0");
/**
* Marked non-breaking space filler creator. This function creates the `<span data-cke-filler="true">&nbsp;</span>` element.
* It defines how the filler is created.
*
* @see module:engine/view/filler~NBSP_FILLER
* @see module:engine/view/filler~BR_FILLER
* @internal
*/ const $b9b9f2bdf9c6137f$export$7b97760a1c0358a1 = (domDocument)=>{
    const span = domDocument.createElement("span");
    span.dataset.ckeFiller = "true";
    span.innerText = "\xA0";
    return span;
};
/**
* `<br>` filler creator. This function creates the `<br data-cke-filler="true">` element.
* It defines how the filler is created.
*
* @see module:engine/view/filler~NBSP_FILLER
* @see module:engine/view/filler~MARKED_NBSP_FILLER
* @internal
*/ const $b9b9f2bdf9c6137f$export$aca8945d5942df7b = (domDocument)=>{
    const fillerBr = domDocument.createElement("br");
    fillerBr.dataset.ckeFiller = "true";
    return fillerBr;
};
/**
* Length of the {@link module:engine/view/filler~INLINE_FILLER INLINE_FILLER}.
*
* @internal
*/ const $b9b9f2bdf9c6137f$export$75d512212e60960c = 7;
/**
* Inline filler which is a sequence of the word joiners.
*
* @internal
*/ const $b9b9f2bdf9c6137f$export$63e39fad2d6f9655 = "\u2060".repeat(7);
/**
* Checks if the node is a text node which starts with the {@link module:engine/view/filler~INLINE_FILLER inline filler}.
*
* ```ts
* startsWithFiller( document.createTextNode( INLINE_FILLER ) ); // true
* startsWithFiller( document.createTextNode( INLINE_FILLER + 'foo' ) ); // true
* startsWithFiller( document.createTextNode( 'foo' ) ); // false
* startsWithFiller( document.createElement( 'p' ) ); // false
* ```
*
* @param domNode DOM node.
* @returns True if the text node starts with the {@link module:engine/view/filler~INLINE_FILLER inline filler}.
* @internal
*/ function $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domNode) {
    if (typeof domNode == "string") return domNode.substr(0, 7) === $b9b9f2bdf9c6137f$export$63e39fad2d6f9655;
    return (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domNode) && domNode.data.substr(0, 7) === $b9b9f2bdf9c6137f$export$63e39fad2d6f9655;
}
/**
* Checks if the text node contains only the {@link module:engine/view/filler~INLINE_FILLER inline filler}.
*
* ```ts
* isInlineFiller( document.createTextNode( INLINE_FILLER ) ); // true
* isInlineFiller( document.createTextNode( INLINE_FILLER + 'foo' ) ); // false
* ```
*
* @param domText DOM text node.
* @returns True if the text node contains only the {@link module:engine/view/filler~INLINE_FILLER inline filler}.
* @internal
*/ function $b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domText) {
    return domText.data.length == 7 && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domText);
}
/**
* Get string data from the text node, removing an {@link module:engine/view/filler~INLINE_FILLER inline filler} from it,
* if text node contains it.
*
* ```ts
* getDataWithoutFiller( document.createTextNode( INLINE_FILLER + 'foo' ) ) == 'foo' // true
* getDataWithoutFiller( document.createTextNode( 'foo' ) ) == 'foo' // true
* ```
*
* @param domText DOM text node, possible with inline filler.
* @returns Data without filler.
* @internal
*/ function $b9b9f2bdf9c6137f$export$58f93c130b8dc873(domText) {
    const data = typeof domText == "string" ? domText : domText.data;
    if ($b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domText)) return data.slice(7);
    return data;
}
/**
* Assign key observer which move cursor from the end of the inline filler to the beginning of it when
* the left arrow is pressed, so the filler does not break navigation.
*
* @param view View controller instance we should inject quirks handling on.
* @internal
*/ function $b9b9f2bdf9c6137f$export$1fc6bd2da514f3d3(view) {
    view.document.on("arrowKey", $b9b9f2bdf9c6137f$var$jumpOverInlineFiller, {
        priority: "low"
    });
}
/**
* Move cursor from the end of the inline filler to the beginning of it when, so the filler does not break navigation.
*/ function $b9b9f2bdf9c6137f$var$jumpOverInlineFiller(evt, data) {
    if (data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowleft) {
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(data.domTarget);
        if (domSelection && domSelection.rangeCount == 1 && domSelection.getRangeAt(0).collapsed) {
            const domParent = domSelection.getRangeAt(0).startContainer;
            const domOffset = domSelection.getRangeAt(0).startOffset;
            if ($b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domParent) && domOffset <= 7) domSelection.collapse(domParent, 0);
        }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/renderer
*/ const $b9b9f2bdf9c6137f$var$ViewRendererBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Renderer is responsible for updating the DOM structure and the DOM selection based on
* the {@link module:engine/view/renderer~ViewRenderer#markToSync information about updated view nodes}.
* In other words, it renders the view to the DOM.
*
* Its main responsibility is to make only the necessary, minimal changes to the DOM. However, unlike in many
* virtual DOM implementations, the primary reason for doing minimal changes is not the performance but ensuring
* that native editing features such as text composition, autocompletion, spell checking, selection's x-index are
* affected as little as possible.
*
* Renderer uses {@link module:engine/view/domconverter~ViewDomConverter} to transform view nodes and positions
* to and from the DOM.
*/ var $b9b9f2bdf9c6137f$export$90ab2f690fef43b1 = class extends $b9b9f2bdf9c6137f$var$ViewRendererBase {
    /**
	* Converter instance.
	*/ domConverter;
    /**
	* Set of nodes which attributes changed and may need to be rendered.
	*/ markedAttributes = /* @__PURE__ */ new Set();
    /**
	* Set of elements which child lists changed and may need to be rendered.
	*/ markedChildren = /* @__PURE__ */ new Set();
    /**
	* Set of text nodes which text data changed and may need to be rendered.
	*/ markedTexts = /* @__PURE__ */ new Set();
    /**
	* View selection. Renderer updates DOM selection based on the view selection.
	*/ selection;
    /**
	* A set of the DOM editing root elements whose selection this renderer manages.
	*/ _domRoots = /* @__PURE__ */ new Set();
    /**
	* The text node in which the inline filler was rendered.
	*/ _inlineFiller = null;
    /**
	* DOM element containing fake selection.
	*/ _fakeSelectionContainer = null;
    /**
	* Creates a renderer instance.
	*
	* @param domConverter Converter instance.
	* @param selection View selection.
	*/ constructor(domConverter, selection){
        super();
        this.domConverter = domConverter;
        this.selection = selection;
        this.set("isFocused", false);
        this.set("isSelecting", false);
        this.set("isComposing", false);
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink && !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this.on("change:isSelecting", ()=>{
            if (!this.isSelecting) this.render();
        });
    }
    /**
	* Marks a view node to be updated in the DOM by {@link #render `render()`}.
	*
	* Note that only view nodes whose parents have corresponding DOM elements need to be marked to be synchronized.
	*
	* @see #markedAttributes
	* @see #markedChildren
	* @see #markedTexts
	*
	* @param type Type of the change.
	* @param node ViewNode to be marked.
	*/ markToSync(type, node) {
        if (type === "text") {
            if (this.domConverter.mapViewToDom(node.parent)) this.markedTexts.add(node);
        } else {
            if (!this.domConverter.mapViewToDom(node)) return;
            if (type === "attributes") this.markedAttributes.add(node);
            else if (type === "children") this.markedChildren.add(node);
            else /**
			* Unknown type passed to Renderer.markToSync.
			*
			* @error view-renderer-unknown-type
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-renderer-unknown-type", this);
        }
    }
    /**
	* Starts tracking an editing root so its DOM selection can later be cleared.
	*
	* @param domRoot The DOM editing root element.
	*/ addDomRoot(domRoot) {
        this._domRoots.add(domRoot);
    }
    /**
	* Stops tracking an editing root (see {@link #addDomRoot}).
	*
	* @param domRoot The DOM editing root element.
	*/ removeDomRoot(domRoot) {
        this._domRoots.delete(domRoot);
    }
    /**
	* Renders all buffered changes ({@link #markedAttributes}, {@link #markedChildren} and {@link #markedTexts}) and
	* the current view selection (if needed) to the DOM by applying a minimal set of changes to it.
	*
	* Renderer tries not to break the text composition (e.g. IME) and x-index of the selection,
	* so it does as little as it is needed to update the DOM.
	*
	* Renderer also handles {@link module:engine/view/filler fillers}. Especially, it checks if the inline filler is needed
	* at the selection position and adds or removes it. To prevent breaking text composition inline filler will not be
	* removed as long as the selection is in the text node which needed it at first.
	*/ render() {
        if (this.isComposing && !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) return;
        let inlineFillerPosition = null;
        const isInlineFillerRenderingPossible = (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink && !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid ? !this.isSelecting : true;
        for (const element of this.markedChildren)this._updateChildrenMappings(element);
        if (isInlineFillerRenderingPossible) {
            if (this._inlineFiller && !this._isSelectionInInlineFiller()) this._removeInlineFiller();
            if (this._inlineFiller) inlineFillerPosition = this._getInlineFillerPosition();
            else if (this._needsInlineFillerAtSelection()) {
                inlineFillerPosition = this.selection.getFirstPosition();
                this.markedChildren.add(inlineFillerPosition.parent);
            }
        } else if (this._inlineFiller && (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(this._inlineFiller)) {
            inlineFillerPosition = this.domConverter.domPositionToView(this._inlineFiller);
            if (inlineFillerPosition && inlineFillerPosition.parent.is("$text")) inlineFillerPosition = $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(inlineFillerPosition.parent);
        }
        for (const element of this.markedAttributes)this._updateAttrs(element);
        for (const element of this.markedChildren)this._updateChildren(element, {
            inlineFillerPosition: inlineFillerPosition
        });
        for (const node of this.markedTexts)if (!this.markedChildren.has(node.parent) && this.domConverter.mapViewToDom(node.parent)) this._updateText(node, {
            inlineFillerPosition: inlineFillerPosition
        });
        if (isInlineFillerRenderingPossible) {
            if (inlineFillerPosition) {
                const fillerDomPosition = this.domConverter.viewPositionToDom(inlineFillerPosition);
                const domDocument = fillerDomPosition.parent.ownerDocument;
                if (!$b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(fillerDomPosition.parent)) this._inlineFiller = $b9b9f2bdf9c6137f$var$addInlineFiller(domDocument, fillerDomPosition.parent, fillerDomPosition.offset);
                else this._inlineFiller = fillerDomPosition.parent;
            } else this._inlineFiller = null;
        }
        this._updateFocus();
        this._updateSelection();
        this.domConverter._clearTemporaryCustomProperties();
        this.markedTexts.clear();
        this.markedAttributes.clear();
        this.markedChildren.clear();
    }
    /**
	* Updates mappings of view element's children.
	*
	* Children that were replaced in the view structure by similar elements (same tag name) are treated as 'replaced'.
	* This means that their mappings can be updated so the new view elements are mapped to the existing DOM elements.
	* Thanks to that these elements do not need to be re-rendered completely.
	*
	* @param viewElement The view element whose children mappings will be updated.
	*/ _updateChildrenMappings(viewElement) {
        const domElement = this.domConverter.mapViewToDom(viewElement);
        if (!domElement) return;
        const actualDomChildren = Array.from(domElement.childNodes);
        const expectedDomChildren = Array.from(this.domConverter.viewChildrenToDom(viewElement, {
            withChildren: false
        }));
        const diff = this._diffNodeLists(actualDomChildren, expectedDomChildren);
        const actions = this._findUpdateActions(diff, actualDomChildren, expectedDomChildren, $b9b9f2bdf9c6137f$var$areSimilarElements);
        if (actions.indexOf("update") !== -1) {
            const counter = {
                equal: 0,
                insert: 0,
                delete: 0
            };
            for (const action of actions)if (action === "update") {
                const insertIndex = counter.equal + counter.insert;
                const deleteIndex = counter.equal + counter.delete;
                const viewChild = viewElement.getChild(insertIndex);
                if (viewChild && !viewChild.is("uiElement") && !viewChild.is("rawElement")) this._updateElementMappings(viewChild, actualDomChildren[deleteIndex]);
                (0, $c7bc2cb7e2db0227$export$cd7f480d6b8286c3)(expectedDomChildren[insertIndex]);
                counter.equal++;
            } else counter[action]++;
        }
    }
    /**
	* Updates mappings of a given view element.
	*
	* @param viewElement The view element whose mappings will be updated.
	* @param domElement The DOM element representing the given view element.
	*/ _updateElementMappings(viewElement, domElement) {
        this.domConverter.unbindDomElement(domElement);
        this.domConverter.bindElements(domElement, viewElement);
        this.markedChildren.add(viewElement);
        this.markedAttributes.add(viewElement);
    }
    /**
	* Gets the position of the inline filler based on the current selection.
	* Here, we assume that we know that the filler is needed and
	* {@link #_isSelectionInInlineFiller is at the selection position}, and, since it is needed,
	* it is somewhere at the selection position.
	*
	* Note: The filler position cannot be restored based on the filler's DOM text node, because
	* when this method is called (before rendering), the bindings will often be broken. View-to-DOM
	* bindings are only dependable after rendering.
	*/ _getInlineFillerPosition() {
        const firstPos = this.selection.getFirstPosition();
        if (firstPos.parent.is("$text")) return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(firstPos.parent);
        else return firstPos;
    }
    /**
	* Returns `true` if the selection has not left the inline filler's text node.
	* If it is `true`, it means that the filler had been added for a reason and the selection did not
	* leave the filler's text node. For example, the user can be in the middle of a composition so it should not be touched.
	*
	* @returns `true` if the inline filler and selection are in the same place.
	*/ _isSelectionInInlineFiller() {
        if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return false;
        const selectionPosition = this.selection.getFirstPosition();
        const position = this.domConverter.viewPositionToDom(selectionPosition);
        if (position && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(position.parent) && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(position.parent)) return true;
        return false;
    }
    /**
	* Removes the inline filler.
	*/ _removeInlineFiller() {
        const domFillerNode = this._inlineFiller;
        if (!$b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domFillerNode)) /**
		* The inline filler node was lost. Most likely, something overwrote the filler text node
		* in the DOM.
		*
		* @error view-renderer-filler-was-lost
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-renderer-filler-was-lost", this);
        if ($b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domFillerNode)) domFillerNode.remove();
        else domFillerNode.data = domFillerNode.data.substr(7);
        this._inlineFiller = null;
    }
    /**
	* Checks if the inline {@link module:engine/view/filler filler} should be added.
	*
	* @returns `true` if the inline filler should be added.
	*/ _needsInlineFillerAtSelection() {
        if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return false;
        const selectionPosition = this.selection.getFirstPosition();
        const selectionParent = selectionPosition.parent;
        const selectionOffset = selectionPosition.offset;
        if (!this.domConverter.mapViewToDom(selectionParent.root)) return false;
        if (!selectionParent.is("element")) return false;
        if (!$b9b9f2bdf9c6137f$var$isEditable(selectionParent)) return false;
        const nodeBefore = selectionPosition.nodeBefore;
        const nodeAfter = selectionPosition.nodeAfter;
        if (nodeBefore instanceof $b9b9f2bdf9c6137f$export$1f9d53a26119da3d || nodeAfter instanceof $b9b9f2bdf9c6137f$export$1f9d53a26119da3d) return false;
        if (selectionOffset === selectionParent.getFillerOffset() && (!nodeBefore || !nodeBefore.is("element", "br"))) return false;
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid && (nodeBefore || nodeAfter)) return false;
        return true;
    }
    /**
	* Checks if text needs to be updated and possibly updates it.
	*
	* @param viewText View text to update.
	* @param options.inlineFillerPosition The position where the inline filler should be rendered.
	*/ _updateText(viewText, options) {
        const domText = this.domConverter.findCorrespondingDomText(viewText);
        let expectedText = this.domConverter.viewToDom(viewText).data;
        const filler = options.inlineFillerPosition;
        if (filler && filler.parent == viewText.parent && filler.offset == viewText.index) expectedText = $b9b9f2bdf9c6137f$export$63e39fad2d6f9655 + expectedText;
        this._updateTextNode(domText, expectedText);
    }
    /**
	* Checks if attribute list needs to be updated and possibly updates it.
	*
	* @param viewElement The view element to update.
	*/ _updateAttrs(viewElement) {
        const domElement = this.domConverter.mapViewToDom(viewElement);
        if (!domElement) return;
        for (const domAttr of Array.from(domElement.attributes)){
            const key = domAttr.name;
            if (!viewElement.hasAttribute(key)) this.domConverter.removeDomElementAttribute(domElement, key);
        }
        for (const key of viewElement.getAttributeKeys())this.domConverter.setDomElementAttribute(domElement, key, viewElement.getAttribute(key), viewElement);
    }
    /**
	* Checks if elements child list needs to be updated and possibly updates it.
	*
	* Note that on Android, to reduce the risk of composition breaks, it tries to update data of an existing
	* child text nodes instead of replacing them completely.
	*
	* @param viewElement View element to update.
	* @param options.inlineFillerPosition The position where the inline filler should be rendered.
	*/ _updateChildren(viewElement, options) {
        const domElement = this.domConverter.mapViewToDom(viewElement);
        if (!domElement) return;
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) {
            let previousDomNode = null;
            for (const domNode of Array.from(domElement.childNodes)){
                if (previousDomNode && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(previousDomNode) && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domNode)) {
                    domElement.normalize();
                    break;
                }
                previousDomNode = domNode;
            }
        }
        const inlineFillerPosition = options.inlineFillerPosition;
        const actualDomChildren = domElement.childNodes;
        const expectedDomChildren = Array.from(this.domConverter.viewChildrenToDom(viewElement, {
            bind: true
        }));
        if (inlineFillerPosition && inlineFillerPosition.parent === viewElement) $b9b9f2bdf9c6137f$var$addInlineFiller(domElement.ownerDocument, expectedDomChildren, inlineFillerPosition.offset);
        const diff = this._diffNodeLists(actualDomChildren, expectedDomChildren);
        const actions = this._findUpdateActions(diff, actualDomChildren, expectedDomChildren, $b9b9f2bdf9c6137f$var$areTextNodes);
        let i = 0;
        const nodesToUnbind = /* @__PURE__ */ new Set();
        for (const action of actions)if (action === "delete") {
            nodesToUnbind.add(actualDomChildren[i]);
            (0, $c7bc2cb7e2db0227$export$cd7f480d6b8286c3)(actualDomChildren[i]);
        } else if (action === "equal" || action === "update") i++;
        i = 0;
        for (const action of actions)if (action === "insert") {
            (0, $c7bc2cb7e2db0227$export$9f200c4466975173)(domElement, i, expectedDomChildren[i]);
            i++;
        } else if (action === "update") {
            this._updateTextNode(actualDomChildren[i], expectedDomChildren[i].data);
            i++;
        } else if (action === "equal") {
            this._markDescendantTextToSync(this.domConverter.domToView(expectedDomChildren[i]));
            i++;
        }
        for (const node of nodesToUnbind)if (!(0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(node)) this.domConverter.unbindDomElement(node);
    }
    /**
	* Shorthand for diffing two arrays or node lists of DOM nodes.
	*
	* @param actualDomChildren Actual DOM children
	* @param expectedDomChildren Expected DOM children.
	* @returns The list of actions based on the {@link module:utils/diff~diff} function.
	*/ _diffNodeLists(actualDomChildren, expectedDomChildren) {
        actualDomChildren = $b9b9f2bdf9c6137f$var$filterOutFakeSelectionContainer(actualDomChildren, this._fakeSelectionContainer);
        return (0, $c7bc2cb7e2db0227$export$a37e3c603d7117e5)(actualDomChildren, expectedDomChildren, $b9b9f2bdf9c6137f$var$sameNodes$1.bind(null, this.domConverter));
    }
    /**
	* Finds DOM nodes that were replaced with the similar nodes (same tag name) in the view. All nodes are compared
	* within one `insert`/`delete` action group, for example:
	*
	* ```
	* Actual DOM:		<p><b>Foo</b>Bar<i>Baz</i><b>Bax</b></p>
	* Expected DOM:	<p>Bar<b>123</b><i>Baz</i><b>456</b></p>
	* Input actions:	[ insert, insert, delete, delete, equal, insert, delete ]
	* Output actions:	[ insert, replace, delete, equal, replace ]
	* ```
	*
	* @param actions Actions array which is a result of the {@link module:utils/diff~diff} function.
	* @param actualDom Actual DOM children
	* @param expectedDom Expected DOM children.
	* @param comparator A comparator function that should return `true` if the given node should be reused
	* (either by the update of a text node data or an element children list for similar elements).
	* @returns Actions array modified with the `update` actions.
	*/ _findUpdateActions(actions, actualDom, expectedDom, comparator) {
        if (actions.indexOf("insert") === -1 || actions.indexOf("delete") === -1) return actions;
        let newActions = [];
        let actualSlice = [];
        let expectedSlice = [];
        const counter = {
            equal: 0,
            insert: 0,
            delete: 0
        };
        for (const action of actions){
            if (action === "insert") expectedSlice.push(expectedDom[counter.equal + counter.insert]);
            else if (action === "delete") actualSlice.push(actualDom[counter.equal + counter.delete]);
            else {
                newActions = newActions.concat((0, $c7bc2cb7e2db0227$export$a37e3c603d7117e5)(actualSlice, expectedSlice, comparator).map((action)=>action === "equal" ? "update" : action));
                newActions.push("equal");
                actualSlice = [];
                expectedSlice = [];
            }
            counter[action]++;
        }
        return newActions.concat((0, $c7bc2cb7e2db0227$export$a37e3c603d7117e5)(actualSlice, expectedSlice, comparator).map((action)=>action === "equal" ? "update" : action));
    }
    /**
	* Checks if text needs to be updated and possibly updates it by removing and inserting only parts
	* of the data from the existing text node to reduce impact on the IME composition.
	*
	* @param domText DOM text node to update.
	* @param expectedText The expected data of a text node.
	*/ _updateTextNode(domText, expectedText) {
        const actualText = domText.data;
        if (actualText == expectedText) return;
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid && this.isComposing && actualText.replace(/\u00A0/g, " ") == expectedText.replace(/\u00A0/g, " ")) return;
        this._updateTextNodeInternal(domText, expectedText);
    }
    /**
	* Part of the `_updateTextNode` method extracted for easier testing.
	*/ _updateTextNodeInternal(domText, expectedText) {
        const actions = (0, $c7bc2cb7e2db0227$export$b3d8c5da214d9c82)(domText.data, expectedText);
        for (const action of actions)if (action.type === "insert") domText.insertData(action.index, action.values.join(""));
        else domText.deleteData(action.index, action.howMany);
    }
    /**
	* Marks text nodes to be synchronized.
	*
	* If a text node is passed, it will be marked. If an element is passed, all descendant text nodes inside it will be marked.
	*
	* @param viewNode View node to sync.
	*/ _markDescendantTextToSync(viewNode) {
        if (!viewNode) return;
        if (viewNode.is("$text")) this.markedTexts.add(viewNode);
        else if (viewNode.is("element")) for (const child of viewNode.getChildren())this._markDescendantTextToSync(child);
    }
    /**
	* Checks if the selection needs to be updated and possibly updates it.
	*/ _updateSelection() {
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink && !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid && this.isSelecting && !this.markedChildren.size) return;
        if (this.selection.rangeCount === 0) {
            this._removeDomSelection();
            this._removeFakeSelection();
            return;
        }
        const domEditable = this.domConverter.mapViewToDom(this.selection.editableElement);
        if (!this.isFocused || !domEditable) {
            if (!this.selection.isFake && this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected) this._removeFakeSelection();
            return;
        }
        if (this.selection.isFake) this._updateFakeSelection(domEditable);
        else if (this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected) {
            this._removeFakeSelection();
            this._updateDomSelection(domEditable);
        } else if (!(this.isComposing && (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid)) this._updateDomSelection(domEditable);
    }
    /**
	* Updates the fake selection.
	*
	* @param domEditable A valid DOM editable where the fake selection container should be added.
	*/ _updateFakeSelection(domEditable) {
        const domDocument = domEditable.ownerDocument;
        if (!this._fakeSelectionContainer) this._fakeSelectionContainer = $b9b9f2bdf9c6137f$var$createFakeSelectionContainer(domDocument);
        const container = this._fakeSelectionContainer;
        this.domConverter.bindFakeSelection(container, this.selection);
        if (!this._fakeSelectionNeedsUpdate(domEditable)) return;
        const containerParent = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(container);
        if (!containerParent || containerParent != domEditable) domEditable.appendChild(container);
        container.textContent = this.selection.fakeSelectionLabel || "\xA0";
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domEditable);
        if (!domSelection) return;
        const domRange = domDocument.createRange();
        domRange.selectNodeContents(container);
        domSelection.setBaseAndExtent(domRange.startContainer, domRange.startOffset, domRange.endContainer, domRange.endOffset);
    }
    /**
	* Updates the DOM selection.
	*
	* @param domEditable A valid DOM editable where the DOM selection should be rendered.
	*/ _updateDomSelection(domEditable) {
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domEditable);
        if (!domSelection) return;
        if (!this._domSelectionNeedsUpdate(domSelection)) return;
        const anchor = this.domConverter.viewPositionToDom(this.selection.anchor);
        const focus = this.domConverter.viewPositionToDom(this.selection.focus);
        domSelection.setBaseAndExtent(anchor.parent, anchor.offset, focus.parent, focus.offset);
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko) $b9b9f2bdf9c6137f$var$fixGeckoSelectionAfterBr(focus, domSelection);
    }
    /**
	* Checks whether a given DOM selection needs to be updated.
	*
	* @param domSelection The DOM selection to check.
	*/ _domSelectionNeedsUpdate(domSelection) {
        if (!this.domConverter.isDomSelectionCorrect(domSelection)) return true;
        const oldViewSelection = domSelection && this.domConverter.domSelectionToView(domSelection);
        if (oldViewSelection && this.selection.isEqual(oldViewSelection)) return false;
        if (!this.selection.isCollapsed && this.selection.isSimilar(oldViewSelection)) return false;
        return true;
    }
    /**
	* Checks whether the fake selection needs to be updated.
	*
	* @param domEditable A valid DOM editable where a new fake selection container should be added.
	*/ _fakeSelectionNeedsUpdate(domEditable) {
        const container = this._fakeSelectionContainer;
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domEditable);
        if (!container || (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(container) !== domEditable) return true;
        if (domSelection && domSelection.anchorNode !== container && !container.contains(domSelection.anchorNode)) return true;
        return container.textContent !== this.selection.fakeSelectionLabel;
    }
    /**
	* Removes the DOM selection.
	*/ _removeDomSelection() {
        for (const domRoot of this._domRoots){
            const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domRoot);
            if (domSelection && domSelection.rangeCount) {
                const activeDomElement = (0, $c7bc2cb7e2db0227$export$cd4e5573fbe2b576)(domRoot);
                const viewElement = activeDomElement && this.domConverter.mapDomToView(activeDomElement);
                if (activeDomElement && viewElement) domSelection.removeAllRanges();
            }
        }
    }
    /**
	* Removes the fake selection.
	*/ _removeFakeSelection() {
        const container = this._fakeSelectionContainer;
        if (container) container.remove();
    }
    /**
	* Checks if focus needs to be updated and possibly updates it.
	*/ _updateFocus() {
        if (this.isFocused) {
            const editable = this.selection.editableElement;
            if (editable) this.domConverter.focus(editable);
        }
    }
};
/**
* Checks if provided element is editable.
*/ function $b9b9f2bdf9c6137f$var$isEditable(element) {
    if (element.getAttribute("contenteditable") == "false") return false;
    const parent = element.findAncestor((element)=>element.hasAttribute("contenteditable"));
    return !parent || parent.getAttribute("contenteditable") == "true";
}
/**
* Adds inline filler at a given position.
*
* The position can be given as an array of DOM nodes and an offset in that array,
* or a DOM parent element and an offset in that element.
*
* @returns The DOM text node that contains an inline filler.
*/ function $b9b9f2bdf9c6137f$var$addInlineFiller(domDocument, domParentOrArray, offset) {
    const childNodes = domParentOrArray instanceof Array ? domParentOrArray : domParentOrArray.childNodes;
    const nodeAfterFiller = childNodes[offset];
    if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(nodeAfterFiller)) {
        nodeAfterFiller.data = $b9b9f2bdf9c6137f$export$63e39fad2d6f9655 + nodeAfterFiller.data;
        return nodeAfterFiller;
    } else {
        const fillerNode = domDocument.createTextNode($b9b9f2bdf9c6137f$export$63e39fad2d6f9655);
        if (Array.isArray(domParentOrArray)) childNodes.splice(offset, 0, fillerNode);
        else (0, $c7bc2cb7e2db0227$export$9f200c4466975173)(domParentOrArray, offset, fillerNode);
        return fillerNode;
    }
}
/**
* Whether two DOM nodes should be considered as similar.
* Nodes are considered similar if they have the same tag name.
*/ function $b9b9f2bdf9c6137f$var$areSimilarElements(node1, node2) {
    return (0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(node1) && (0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(node2) && !(0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(node1) && !(0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(node2) && !(0, $c7bc2cb7e2db0227$export$3ab01370f5e64ac8)(node1) && !(0, $c7bc2cb7e2db0227$export$3ab01370f5e64ac8)(node2) && node1.tagName.toLowerCase() === node2.tagName.toLowerCase();
}
/**
* Whether two DOM nodes are text nodes.
*/ function $b9b9f2bdf9c6137f$var$areTextNodes(node1, node2) {
    return (0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(node1) && (0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(node2) && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(node1) && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(node2);
}
/**
* Whether two dom nodes should be considered as the same.
* Two nodes which are considered the same are:
*
* * Text nodes with the same text.
* * Element nodes represented by the same object.
* * Two block filler elements.
*
* @param blockFillerMode Block filler mode, see {@link module:engine/view/domconverter~ViewDomConverter#blockFillerMode}.
*/ function $b9b9f2bdf9c6137f$var$sameNodes$1(domConverter, actualDomChild, expectedDomChild) {
    if (actualDomChild === expectedDomChild) return true;
    else if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(actualDomChild) && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(expectedDomChild)) return actualDomChild.data === expectedDomChild.data;
    else if (domConverter.isBlockFiller(actualDomChild) && domConverter.isBlockFiller(expectedDomChild)) return true;
    return false;
}
/**
* The following is a Firefox–specific hack (https://github.com/ckeditor/ckeditor5-engine/issues/1439).
* When the native DOM selection is at the end of the block and preceded by <br /> e.g.
*
* ```html
* <p>foo<br/>[]</p>
* ```
*
* which happens a lot when using the soft line break, the browser fails to (visually) move the
* caret to the new line. A quick fix is as simple as force–refreshing the selection with the same range.
*/ function $b9b9f2bdf9c6137f$var$fixGeckoSelectionAfterBr(focus, domSelection) {
    let parent = focus.parent;
    let offset = focus.offset;
    if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(parent) && $b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(parent)) {
        offset = (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(parent) + 1;
        parent = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(parent);
    }
    if (parent.nodeType != Node.ELEMENT_NODE || offset != parent.childNodes.length - 1) return;
    const childAtOffset = parent.childNodes[offset];
    if (childAtOffset && childAtOffset.tagName == "BR") domSelection.addRange(domSelection.getRangeAt(0));
}
function $b9b9f2bdf9c6137f$var$filterOutFakeSelectionContainer(domChildList, fakeSelectionContainer) {
    const childList = Array.from(domChildList);
    if (childList.length == 0 || !fakeSelectionContainer) return childList;
    if (childList[childList.length - 1] == fakeSelectionContainer) childList.pop();
    return childList;
}
/**
* Creates a fake selection container for a given document.
*/ function $b9b9f2bdf9c6137f$var$createFakeSelectionContainer(domDocument) {
    const container = domDocument.createElement("div");
    container.className = "ck-fake-selection-container";
    Object.assign(container.style, {
        position: "fixed",
        top: 0,
        left: "-9999px",
        width: "42px"
    });
    container.textContent = "\xA0";
    return container;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/domconverter
*/ const $b9b9f2bdf9c6137f$var$BR_FILLER_REF = $b9b9f2bdf9c6137f$export$aca8945d5942df7b((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document);
const $b9b9f2bdf9c6137f$var$NBSP_FILLER_REF = $b9b9f2bdf9c6137f$export$c4fba0b3ea844689((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document);
const $b9b9f2bdf9c6137f$var$MARKED_NBSP_FILLER_REF = $b9b9f2bdf9c6137f$export$7b97760a1c0358a1((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document);
const $b9b9f2bdf9c6137f$var$UNSAFE_ATTRIBUTE_NAME_PREFIX = "data-ck-unsafe-attribute-";
const $b9b9f2bdf9c6137f$var$UNSAFE_ELEMENT_REPLACEMENT_ATTRIBUTE = "data-ck-unsafe-element";
/**
* `ViewDomConverter` is a set of tools to do transformations between DOM nodes and view nodes. It also handles
* {@link module:engine/view/domconverter~ViewDomConverter#bindElements bindings} between these nodes.
*
* An instance of the DOM converter is available under
* {@link module:engine/view/view~EditingView#domConverter `editor.editing.view.domConverter`}.
*
* The DOM converter does not check which nodes should be rendered (use {@link module:engine/view/renderer~ViewRenderer}), does not keep the
* state of a tree nor keeps the synchronization between the tree view and
* the DOM tree (use {@link module:engine/view/document~ViewDocument}).
*
* The DOM converter keeps DOM elements to view element bindings, so when the converter gets destroyed, the bindings are lost.
* Two converters will keep separate binding maps, so one tree view can be bound with two DOM trees.
*/ var $b9b9f2bdf9c6137f$export$f7719161406171fa = class {
    document;
    /**
	* Whether to leave the View-to-DOM conversion result unchanged or improve editing experience by filtering out interactive data.
	*/ renderingMode;
    /**
	* The mode of a block filler used by the DOM converter.
	*/ blockFillerMode;
    /**
	* Elements which are considered pre-formatted elements.
	*/ preElements;
    /**
	* Elements which are considered block elements (and hence should be filled with a
	* {@link #isBlockFiller block filler}).
	*
	* Whether an element is considered a block element also affects handling of trailing whitespaces.
	*
	* You can extend this array if you introduce support for block elements which are not yet recognized here.
	*/ blockElements;
    /**
	* A list of elements that exist inline (in text) but their inner structure cannot be edited because
	* of the way they are rendered by the browser. They are mostly HTML form elements but there are other
	* elements such as `<img>` or `<iframe>` that also have non-editable children or no children whatsoever.
	*
	* Whether an element is considered an inline object has an impact on white space rendering (trimming)
	* around (and inside of it). In short, white spaces in text nodes next to inline objects are not trimmed.
	*
	* You can extend this array if you introduce support for inline object elements which are not yet recognized here.
	*/ inlineObjectElements;
    /**
	* A list of elements which may affect the editing experience. To avoid this, those elements are replaced with
	* `<span data-ck-unsafe-element="[element name]"></span>` while rendering in the editing mode.
	*/ unsafeElements;
    /**
	* The DOM Document used by `ViewDomConverter` to create DOM nodes.
	*/ _domDocument;
    /**
	* The DOM-to-view mapping.
	*/ _domToViewMapping = /* @__PURE__ */ new WeakMap();
    /**
	* The view-to-DOM mapping.
	*/ _viewToDomMapping = /* @__PURE__ */ new WeakMap();
    /**
	* Holds the mapping between fake selection containers and corresponding view selections.
	*/ _fakeSelectionMapping = /* @__PURE__ */ new WeakMap();
    /**
	* Matcher for view elements whose content should be treated as raw data
	* and not processed during the conversion from DOM nodes to view elements.
	*/ _rawContentElementMatcher = new $b9b9f2bdf9c6137f$export$20214574ec94167d();
    /**
	* Matcher for inline object view elements. This is an extension of a simple {@link #inlineObjectElements} array of element names.
	*/ _inlineObjectElementMatcher = new $b9b9f2bdf9c6137f$export$20214574ec94167d();
    /**
	* Set of elements with temporary custom properties that require clearing after render.
	*/ _elementsWithTemporaryCustomProperties = /* @__PURE__ */ new Set();
    /**
	* Creates a DOM converter.
	*
	* @param document The view document instance.
	* @param options An object with configuration options.
	* @param options.blockFillerMode The type of the block filler to use.
	* Default value depends on the options.renderingMode:
	*  'nbsp' when options.renderingMode == 'data',
	*  'br' when options.renderingMode == 'editing'.
	* @param options.renderingMode Whether to leave the View-to-DOM conversion result unchanged
	* or improve editing experience by filtering out interactive data.
	*/ constructor(document1, { blockFillerMode: blockFillerMode, renderingMode: renderingMode = "editing" } = {}){
        this.document = document1;
        this.renderingMode = renderingMode;
        this.blockFillerMode = blockFillerMode || (renderingMode === "editing" ? "br" : "nbsp");
        this.preElements = [
            "pre",
            "textarea"
        ];
        this.blockElements = [
            "address",
            "article",
            "aside",
            "blockquote",
            "caption",
            "center",
            "dd",
            "details",
            "dir",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "legend",
            "li",
            "main",
            "menu",
            "nav",
            "ol",
            "p",
            "pre",
            "section",
            "summary",
            "table",
            "tbody",
            "td",
            "tfoot",
            "th",
            "thead",
            "tr",
            "ul"
        ];
        this.inlineObjectElements = [
            "object",
            "iframe",
            "input",
            "button",
            "textarea",
            "select",
            "option",
            "video",
            "embed",
            "audio",
            "img",
            "canvas"
        ];
        this.unsafeElements = [
            "script",
            "style"
        ];
        this._domDocument = this.renderingMode === "editing" ? (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document : (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.implementation.createHTMLDocument("");
    }
    /**
	* The DOM Document used by `ViewDomConverter` to create DOM nodes.
	*/ get domDocument() {
        return this._domDocument;
    }
    /**
	* Binds a given DOM element that represents fake selection to a **position** of a
	* {@link module:engine/view/documentselection~ViewDocumentSelection document selection}.
	* Document selection copy is stored and can be retrieved by the
	* {@link module:engine/view/domconverter~ViewDomConverter#fakeSelectionToView} method.
	*/ bindFakeSelection(domElement, viewDocumentSelection) {
        this._fakeSelectionMapping.set(domElement, new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(viewDocumentSelection));
    }
    /**
	* Returns a {@link module:engine/view/selection~ViewSelection view selection} instance corresponding to a given
	* DOM element that represents fake selection. Returns `undefined` if binding to the given DOM element does not exist.
	*/ fakeSelectionToView(domElement) {
        return this._fakeSelectionMapping.get(domElement);
    }
    /**
	* Binds DOM and view elements, so it will be possible to get corresponding elements using
	* {@link module:engine/view/domconverter~ViewDomConverter#mapDomToView} and
	* {@link module:engine/view/domconverter~ViewDomConverter#mapViewToDom}.
	*
	* @param domElement The DOM element to bind.
	* @param viewElement The view element to bind.
	*/ bindElements(domElement, viewElement) {
        this._domToViewMapping.set(domElement, viewElement);
        this._viewToDomMapping.set(viewElement, domElement);
    }
    /**
	* Unbinds a given DOM element from the view element it was bound to. Unbinding is deep, meaning that all children of
	* the DOM element will be unbound too.
	*
	* @param domElement The DOM element to unbind.
	*/ unbindDomElement(domElement) {
        const viewElement = this._domToViewMapping.get(domElement);
        if (viewElement) {
            this._domToViewMapping.delete(domElement);
            this._viewToDomMapping.delete(viewElement);
            for (const child of domElement.children)this.unbindDomElement(child);
        }
    }
    /**
	* Binds DOM and view document fragments, so it will be possible to get corresponding document fragments using
	* {@link module:engine/view/domconverter~ViewDomConverter#mapDomToView} and
	* {@link module:engine/view/domconverter~ViewDomConverter#mapViewToDom}.
	*
	* @param domFragment The DOM document fragment to bind.
	* @param viewFragment The view document fragment to bind.
	*/ bindDocumentFragments(domFragment, viewFragment) {
        this._domToViewMapping.set(domFragment, viewFragment);
        this._viewToDomMapping.set(viewFragment, domFragment);
    }
    /**
	* Decides whether a given pair of attribute key and value should be passed further down the pipeline.
	*
	* @param elementName Element name in lower case.
	*/ shouldRenderAttribute(attributeKey, attributeValue, elementName) {
        if (this.renderingMode === "data") return true;
        attributeKey = attributeKey.toLowerCase();
        if (attributeKey.startsWith("on")) return false;
        if (attributeKey === "srcdoc") return false;
        if (elementName === "img" && (attributeKey === "src" || attributeKey === "srcset")) return true;
        if (elementName === "source" && attributeKey === "srcset") return true;
        attributeValue = attributeValue.replace(/[\s\u0000-\u0020]+/g, "");
        if (attributeValue.match(/^javascript:/i)) return false;
        if (attributeValue.match(/^data:/i)) {
            const isImage = attributeValue.match(/^data:image\/(png|jpeg|jpg|gif|webp|avif|bmp|x-icon|vnd\.microsoft\.icon|apng|tiff|heic|heif|jxl)($|[;,])/i);
            const isMedia = attributeValue.match(/^data:(audio|video)\/(mp4|mpeg|mp3|ogg|webm|wav|x-wav|aac|flac|quicktime|3gpp)($|[;,])/i);
            if (!isImage && !isMedia) return false;
        }
        return true;
    }
    /**
	* Set `domElement`'s content using provided `html` argument. Apply necessary filtering for the editing pipeline.
	*
	* @param domElement DOM element that should have `html` set as its content.
	* @param html Textual representation of the HTML that will be set on `domElement`.
	*/ setContentOf(domElement, html) {
        if (this.renderingMode === "data") {
            domElement.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(html);
            return;
        }
        const document1 = new DOMParser().parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(html), "text/html");
        const fragment = document1.createDocumentFragment();
        const bodyChildNodes = document1.body.childNodes;
        while(bodyChildNodes.length > 0)fragment.appendChild(bodyChildNodes[0]);
        const treeWalker = document1.createTreeWalker(fragment, NodeFilter.SHOW_ELEMENT);
        const nodes = [];
        let currentNode;
        while(currentNode = treeWalker.nextNode())nodes.push(currentNode);
        for (const currentNode of nodes){
            for (const attributeName of currentNode.getAttributeNames())this.setDomElementAttribute(currentNode, attributeName, currentNode.getAttribute(attributeName));
            const elementName = currentNode.tagName.toLowerCase();
            if (this._shouldRenameElement(elementName)) {
                $b9b9f2bdf9c6137f$var$_logUnsafeElement(elementName);
                currentNode.replaceWith(this._createReplacementDomElement(elementName, currentNode));
            }
        }
        while(domElement.firstChild)domElement.firstChild.remove();
        domElement.append(fragment);
    }
    /**
	* Converts the view to the DOM. For all text nodes, not bound elements and document fragments new items will
	* be created. For bound elements and document fragments the method will return corresponding items.
	*
	* @param viewNode View node or document fragment to transform.
	* @param options Conversion options.
	* @param options.bind Determines whether new elements will be bound.
	* @param options.withChildren If `false`, node's and document fragment's children will not be converted.
	* @returns Converted node or DocumentFragment.
	*/ viewToDom(viewNode, options = {}) {
        if (viewNode.is("$text")) {
            const textData = this._processDataFromViewText(viewNode);
            return this._domDocument.createTextNode(textData);
        } else {
            const viewElementOrFragment = viewNode;
            if (this.mapViewToDom(viewElementOrFragment)) {
                if (viewElementOrFragment.getCustomProperty("editingPipeline:doNotReuseOnce")) this._elementsWithTemporaryCustomProperties.add(viewElementOrFragment);
                else return this.mapViewToDom(viewElementOrFragment);
            }
            let domElement;
            if (viewElementOrFragment.is("documentFragment")) {
                domElement = this._domDocument.createDocumentFragment();
                if (options.bind) this.bindDocumentFragments(domElement, viewElementOrFragment);
            } else if (viewElementOrFragment.is("uiElement")) {
                if (viewElementOrFragment.name === "$comment") domElement = this._domDocument.createComment(viewElementOrFragment.getCustomProperty("$rawContent"));
                else domElement = viewElementOrFragment.render(this._domDocument, this);
                if (options.bind) this.bindElements(domElement, viewElementOrFragment);
                return domElement;
            } else {
                if (this._shouldRenameElement(viewElementOrFragment.name)) {
                    $b9b9f2bdf9c6137f$var$_logUnsafeElement(viewElementOrFragment.name);
                    domElement = this._createReplacementDomElement(viewElementOrFragment.name);
                } else if (viewElementOrFragment.hasAttribute("xmlns")) domElement = this._domDocument.createElementNS(viewElementOrFragment.getAttribute("xmlns"), viewElementOrFragment.name);
                else domElement = this._domDocument.createElement(viewElementOrFragment.name);
                if (viewElementOrFragment.is("rawElement")) viewElementOrFragment.render(domElement, this);
                if (options.bind) this.bindElements(domElement, viewElementOrFragment);
                for (const key of viewElementOrFragment.getAttributeKeys())this.setDomElementAttribute(domElement, key, viewElementOrFragment.getAttribute(key), viewElementOrFragment);
            }
            if (options.withChildren !== false) for (const child of this.viewChildrenToDom(viewElementOrFragment, options))if (domElement instanceof HTMLTemplateElement) domElement.content.appendChild(child);
            else domElement.appendChild(child);
            return domElement;
        }
    }
    /**
	* Sets the attribute on a DOM element.
	*
	* **Note**: To remove the attribute, use {@link #removeDomElementAttribute}.
	*
	* @param domElement The DOM element the attribute should be set on.
	* @param key The name of the attribute.
	* @param value The value of the attribute.
	* @param relatedViewElement The view element related to the `domElement` (if there is any).
	* It helps decide whether the attribute set is unsafe. For instance, view elements created via the
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter} methods can allow certain attributes
	* that would normally be filtered out.
	*/ setDomElementAttribute(domElement, key, value, relatedViewElement) {
        const shouldRenderAttribute = this.shouldRenderAttribute(key, value, domElement.tagName.toLowerCase()) || relatedViewElement && relatedViewElement.shouldRenderUnsafeAttribute(key);
        if (!shouldRenderAttribute) (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("domconverter-unsafe-attribute-detected", {
            domElement: domElement,
            key: key,
            value: value
        });
        if (!(0, $c7bc2cb7e2db0227$export$c8238713f6b74780)(key)) {
            /**
			* Invalid attribute name was ignored during rendering.
			*
			* @error domconverter-invalid-attribute-detected
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("domconverter-invalid-attribute-detected", {
                domElement: domElement,
                key: key,
                value: value
            });
            return;
        }
        if (domElement.hasAttribute(key) && !shouldRenderAttribute) domElement.removeAttribute(key);
        else if (domElement.hasAttribute($b9b9f2bdf9c6137f$var$UNSAFE_ATTRIBUTE_NAME_PREFIX + key) && shouldRenderAttribute) domElement.removeAttribute($b9b9f2bdf9c6137f$var$UNSAFE_ATTRIBUTE_NAME_PREFIX + key);
        const attributeName = shouldRenderAttribute ? key : $b9b9f2bdf9c6137f$var$UNSAFE_ATTRIBUTE_NAME_PREFIX + key;
        domElement.setAttribute(attributeName, (0, $c7bc2cb7e2db0227$export$4703b76556f50989)(domElement, attributeName, value));
    }
    /**
	* Removes an attribute from a DOM element.
	*
	* **Note**: To set the attribute, use {@link #setDomElementAttribute}.
	*
	* @param domElement The DOM element the attribute should be removed from.
	* @param key The name of the attribute.
	*/ removeDomElementAttribute(domElement, key) {
        if (key == $b9b9f2bdf9c6137f$var$UNSAFE_ELEMENT_REPLACEMENT_ATTRIBUTE) return;
        domElement.removeAttribute(key);
        domElement.removeAttribute($b9b9f2bdf9c6137f$var$UNSAFE_ATTRIBUTE_NAME_PREFIX + key);
    }
    /**
	* Converts children of the view element to DOM using the
	* {@link module:engine/view/domconverter~ViewDomConverter#viewToDom} method.
	* Additionally, this method adds block {@link module:engine/view/filler filler} to the list of children, if needed.
	*
	* @param viewElement Parent view element.
	* @param options See {@link module:engine/view/domconverter~ViewDomConverter#viewToDom} options parameter.
	* @returns DOM nodes.
	*/ *viewChildrenToDom(viewElement, options = {}) {
        const fillerPositionOffset = viewElement.getFillerOffset && viewElement.getFillerOffset();
        let offset = 0;
        for (const childView of viewElement.getChildren()){
            if (fillerPositionOffset === offset) yield this._getBlockFiller();
            const transparentRendering = childView.is("element") && !!childView.getCustomProperty("dataPipeline:transparentRendering") && !(0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(childView.getAttributes());
            if (transparentRendering && this.renderingMode == "data") {
                if (childView.is("rawElement")) {
                    const tempElement = this._domDocument.createElement(childView.name);
                    childView.render(tempElement, this);
                    yield* [
                        ...tempElement.childNodes
                    ];
                } else yield* this.viewChildrenToDom(childView, options);
            } else {
                if (transparentRendering) /**
				* The `dataPipeline:transparentRendering` flag is supported only in the data pipeline.
				*
				* @error domconverter-transparent-rendering-unsupported-in-editing-pipeline
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
                    viewElement: childView
                });
                yield this.viewToDom(childView, options);
            }
            offset++;
        }
        if (fillerPositionOffset === offset) yield this._getBlockFiller();
    }
    /**
	* Converts view {@link module:engine/view/range~ViewRange} to DOM range.
	* Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
	*
	* @param viewRange View range.
	* @returns DOM range.
	*/ viewRangeToDom(viewRange) {
        const domStart = this.viewPositionToDom(viewRange.start);
        const domEnd = this.viewPositionToDom(viewRange.end);
        const domRange = this._domDocument.createRange();
        domRange.setStart(domStart.parent, domStart.offset);
        domRange.setEnd(domEnd.parent, domEnd.offset);
        return domRange;
    }
    /**
	* Converts view {@link module:engine/view/position~ViewPosition} to DOM parent and offset.
	*
	* Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
	* If the converted position is directly before inline filler it is moved inside the filler.
	*
	* @param viewPosition View position.
	* @returns DOM position or `null` if view position could not be converted to DOM.
	* DOM position has two properties:
	* * `parent` - DOM position parent.
	* * `offset` - DOM position offset.
	*/ viewPositionToDom(viewPosition) {
        const viewParent = viewPosition.parent;
        if (viewParent.is("$text")) {
            const domParent = this.findCorrespondingDomText(viewParent);
            if (!domParent) return null;
            let offset = viewPosition.offset;
            if ($b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domParent)) offset += 7;
            if (domParent.data && offset > domParent.data.length) offset = domParent.data.length;
            return {
                parent: domParent,
                offset: offset
            };
        } else {
            let domParent, domBefore, domAfter;
            if (viewPosition.offset === 0) {
                domParent = this.mapViewToDom(viewParent);
                if (!domParent) return null;
                domAfter = domParent.childNodes[0];
            } else {
                const nodeBefore = viewPosition.nodeBefore;
                domBefore = nodeBefore.is("$text") ? this.findCorrespondingDomText(nodeBefore) : this.mapViewToDom(nodeBefore);
                if (!domBefore) return null;
                domParent = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domBefore);
                domAfter = domBefore.nextSibling;
            }
            if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domAfter) && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domAfter)) return {
                parent: domAfter,
                offset: 7
            };
            const offset = domBefore ? (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(domBefore) + 1 : 0;
            return {
                parent: domParent,
                offset: offset
            };
        }
    }
    /**
	* Converts DOM to view. For all text nodes, not bound elements and document fragments new items will
	* be created. For bound elements and document fragments function will return corresponding items. For
	* {@link module:engine/view/filler fillers} `null` will be returned.
	* For all DOM elements rendered by {@link module:engine/view/uielement~ViewUIElement} that UIElement will be returned.
	*
	* @param domNode DOM node or document fragment to transform.
	* @param options Conversion options.
	* @param options.bind Determines whether new elements will be bound. False by default.
	* @param options.withChildren If `true`, node's and document fragment's children will be converted too. True by default.
	* @param options.keepOriginalCase If `false`, node's tag name will be converted to lower case. False by default.
	* @param options.skipComments If `false`, comment nodes will be converted to `$comment`
	* {@link module:engine/view/uielement~ViewUIElement view UI elements}. False by default.
	* @returns Converted node or document fragment or `null` if DOM node is a {@link module:engine/view/filler filler}
	* or the given node is an empty text node.
	*/ domToView(domNode, options = {}) {
        const inlineNodes = [];
        const generator = this._domToView(domNode, options, inlineNodes);
        const node = generator.next().value;
        if (!node) return null;
        generator.next();
        this._processDomInlineNodes(null, inlineNodes, options);
        if (this.blockFillerMode == "br" && $b9b9f2bdf9c6137f$var$isViewBrFiller(node)) return null;
        if (node.is("$text") && node.data.length == 0) return null;
        return node;
    }
    /**
	* Converts children of the DOM element to view nodes using
	* the {@link module:engine/view/domconverter~ViewDomConverter#domToView} method.
	* Additionally this method omits block {@link module:engine/view/filler filler}, if it exists in the DOM parent.
	*
	* @param domElement Parent DOM element.
	* @param options See {@link module:engine/view/domconverter~ViewDomConverter#domToView} options parameter.
	* @param inlineNodes An array that will be populated with inline nodes. It's used internally for whitespace processing.
	* @returns View nodes.
	*/ *domChildrenToView(domElement, options = {}, inlineNodes = []) {
        let childNodes;
        if (domElement instanceof HTMLTemplateElement) childNodes = [
            ...domElement.content.childNodes
        ];
        else childNodes = [
            ...domElement.childNodes
        ];
        for(let i = 0; i < childNodes.length; i++){
            const domChild = childNodes[i];
            const generator = this._domToView(domChild, options, inlineNodes);
            const viewChild = generator.next().value;
            if (viewChild !== null) {
                if (this._isBlockViewElement(viewChild)) this._processDomInlineNodes(domElement, inlineNodes, options);
                if (!(this.blockFillerMode == "br" && $b9b9f2bdf9c6137f$var$isViewBrFiller(viewChild))) yield viewChild;
                generator.next();
            }
        }
        this._processDomInlineNodes(domElement, inlineNodes, options);
    }
    /**
	* Converts DOM selection to view {@link module:engine/view/selection~ViewSelection}.
	* Ranges which cannot be converted will be omitted.
	*
	* @param domSelection DOM selection.
	* @returns View selection.
	*/ domSelectionToView(domSelection) {
        if ($b9b9f2bdf9c6137f$var$isGeckoRestrictedDomSelection(domSelection)) return new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e([]);
        if (domSelection.rangeCount === 1) {
            let container = domSelection.getRangeAt(0).startContainer;
            if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(container)) container = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(container);
            const viewSelection = this.fakeSelectionToView(container);
            if (viewSelection) return viewSelection;
        }
        const isBackward = this.isDomSelectionBackward(domSelection);
        const viewRanges = [];
        for(let i = 0; i < domSelection.rangeCount; i++){
            const domRange = domSelection.getRangeAt(i);
            const viewRange = this.domRangeToView(domRange);
            if (viewRange) viewRanges.push(viewRange);
        }
        return new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(viewRanges, {
            backward: isBackward
        });
    }
    /**
	* Converts DOM Range to view {@link module:engine/view/range~ViewRange}.
	* If the start or end position cannot be converted `null` is returned.
	*
	* @param domRange DOM range.
	* @returns View range.
	*/ domRangeToView(domRange) {
        const viewStart = this.domPositionToView(domRange.startContainer, domRange.startOffset);
        const viewEnd = this.domPositionToView(domRange.endContainer, domRange.endOffset);
        if (viewStart && viewEnd) return new $b9b9f2bdf9c6137f$export$829eb746b222877(viewStart, viewEnd);
        return null;
    }
    /**
	* Converts DOM parent and offset to view {@link module:engine/view/position~ViewPosition}.
	*
	* If the position is inside a {@link module:engine/view/filler filler} which has no corresponding view node,
	* position of the filler will be converted and returned.
	*
	* If the position is inside DOM element rendered by {@link module:engine/view/uielement~ViewUIElement}
	* that position will be converted to view position before that UIElement.
	*
	* If structures are too different and it is not possible to find corresponding position then `null` will be returned.
	*
	* @param domParent DOM position parent.
	* @param domOffset DOM position offset. You can skip it when converting the inline filler node.
	* @returns View position.
	*/ domPositionToView(domParent, domOffset = 0) {
        if (this.isBlockFiller(domParent)) return this.domPositionToView((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domParent), (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(domParent));
        const viewElement = this.mapDomToView(domParent);
        if (viewElement && (viewElement.is("uiElement") || viewElement.is("rawElement"))) return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(viewElement);
        if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domParent)) {
            if ($b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domParent)) return this.domPositionToView((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domParent), (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(domParent));
            const viewParent = this.findCorrespondingViewText(domParent);
            let offset = domOffset;
            if (!viewParent) return null;
            if ($b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domParent)) {
                offset -= 7;
                offset = offset < 0 ? 0 : offset;
            }
            return new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewParent, offset);
        } else {
            if (domOffset === 0) {
                const viewParent = this.mapDomToView(domParent);
                if (viewParent) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewParent, 0);
            } else {
                const domBefore = domParent.childNodes[domOffset - 1];
                if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domBefore) && $b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domBefore) || domBefore && this.isBlockFiller(domBefore)) return this.domPositionToView((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domBefore), (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(domBefore));
                const viewBefore = (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domBefore) ? this.findCorrespondingViewText(domBefore) : this.mapDomToView(domBefore);
                if (viewBefore && viewBefore.parent) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewBefore.parent, viewBefore.index + 1);
            }
            return null;
        }
    }
    /**
	* Returns corresponding view {@link module:engine/view/element~ViewElement Element} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment} for provided DOM element or
	* document fragment. If there is no view item {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound}
	* to the given DOM - `undefined` is returned.
	*
	* For all DOM elements rendered by a {@link module:engine/view/uielement~ViewUIElement} or
	* a {@link module:engine/view/rawelement~ViewRawElement}, the parent `UIElement` or `RawElement` will be returned.
	*
	* @param domElementOrDocumentFragment DOM element or document fragment.
	* @returns Corresponding view element, document fragment or `undefined` if no element was bound.
	*/ mapDomToView(domElementOrDocumentFragment) {
        return this.getHostViewElement(domElementOrDocumentFragment) || this._domToViewMapping.get(domElementOrDocumentFragment);
    }
    /**
	* Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound},
	* corresponding text node is returned based on the sibling or parent.
	*
	* If the directly previous sibling is a {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound} element, it is used
	* to find the corresponding text node.
	*
	* If this is a first child in the parent and the parent is a
	* {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound}
	* element, it is used to find the corresponding text node.
	*
	* For all text nodes rendered by a {@link module:engine/view/uielement~ViewUIElement} or
	* a {@link module:engine/view/rawelement~ViewRawElement}, the parent `UIElement` or `RawElement` will be returned.
	*
	* Otherwise `null` is returned.
	*
	* Note that for the block or inline {@link module:engine/view/filler filler} this method returns `null`.
	*
	* @param domText DOM text node.
	* @returns Corresponding view text node or `null`, if it was not possible to find a corresponding node.
	*/ findCorrespondingViewText(domText) {
        if ($b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domText)) return null;
        const hostElement = this.getHostViewElement(domText);
        if (hostElement) return hostElement;
        const previousSibling = domText.previousSibling;
        if (previousSibling) {
            if (!this.isElement(previousSibling)) return null;
            const viewElement = this.mapDomToView(previousSibling);
            if (viewElement) {
                const nextSibling = viewElement.nextSibling;
                if (nextSibling instanceof $b9b9f2bdf9c6137f$export$1f9d53a26119da3d) return nextSibling;
                else return null;
            }
        } else {
            const viewElement = this.mapDomToView((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domText));
            if (viewElement) {
                const firstChild = viewElement.getChild(0);
                if (firstChild instanceof $b9b9f2bdf9c6137f$export$1f9d53a26119da3d) return firstChild;
                else return null;
            }
        }
        return null;
    }
    mapViewToDom(documentFragmentOrElement) {
        return this._viewToDomMapping.get(documentFragmentOrElement);
    }
    /**
	* Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound},
	* corresponding text node is returned based on the sibling or parent.
	*
	* If the directly previous sibling is a {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound} element, it is used
	* to find the corresponding text node.
	*
	* If this is a first child in the parent and the parent is a
	* {@link module:engine/view/domconverter~ViewDomConverter#bindElements bound}
	* element, it is used to find the corresponding text node.
	*
	* Otherwise `null` is returned.
	*
	* @param viewText View text node.
	* @returns Corresponding DOM text node or `null`, if it was not possible to find a corresponding node.
	*/ findCorrespondingDomText(viewText) {
        const previousSibling = viewText.previousSibling;
        if (previousSibling && this.mapViewToDom(previousSibling)) return this.mapViewToDom(previousSibling).nextSibling;
        if (!previousSibling && viewText.parent && this.mapViewToDom(viewText.parent)) return this.mapViewToDom(viewText.parent).childNodes[0];
        return null;
    }
    /**
	* Focuses DOM editable that is corresponding to provided {@link module:engine/view/editableelement~ViewEditableElement}.
	*/ focus(viewEditable) {
        const domEditable = this.mapViewToDom(viewEditable);
        if (!domEditable || (0, $c7bc2cb7e2db0227$export$cd4e5573fbe2b576)(domEditable) === domEditable) return;
        const { scrollX: scrollX, scrollY: scrollY } = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window;
        const scrollPositions = [];
        $b9b9f2bdf9c6137f$var$forEachDomElementAncestor(domEditable, (node)=>{
            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = node;
            scrollPositions.push([
                scrollLeft,
                scrollTop
            ]);
        });
        domEditable.focus({
            preventScroll: true
        });
        $b9b9f2bdf9c6137f$var$forEachDomElementAncestor(domEditable, (node)=>{
            const [scrollLeft, scrollTop] = scrollPositions.shift();
            node.scrollLeft = scrollLeft;
            node.scrollTop = scrollTop;
        });
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.scrollTo(scrollX, scrollY);
    }
    /**
	* Remove DOM selection from blurred editable, so it won't interfere with clicking on dropdowns (especially on iOS).
	*
	* @internal
	*/ _clearDomSelection() {
        const domEditable = this.mapViewToDom(this.document.selection.editableElement);
        if (!domEditable) return;
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domEditable);
        if (!domSelection) return;
        const newViewSelection = this.domSelectionToView(domSelection);
        if (newViewSelection && newViewSelection.rangeCount > 0) domSelection.removeAllRanges();
    }
    /**
	* Returns `true` when `node.nodeType` equals `Node.ELEMENT_NODE`.
	*
	* @param node Node to check.
	*/ isElement(node) {
        return node && node.nodeType == Node.ELEMENT_NODE;
    }
    /**
	* Returns `true` when `node.nodeType` equals `Node.DOCUMENT_FRAGMENT_NODE`.
	*
	* @param node Node to check.
	*/ isDocumentFragment(node) {
        return node && node.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
	* Checks if the node is an instance of the block filler for this DOM converter.
	*
	* ```ts
	* const converter = new ViewDomConverter( viewDocument, { blockFillerMode: 'br' } );
	*
	* converter.isBlockFiller( BR_FILLER( document ) ); // true
	* converter.isBlockFiller( NBSP_FILLER( document ) ); // false
	* ```
	*
	* **Note:**: For the `'nbsp'` mode the method also checks context of a node so it cannot be a detached node.
	*
	* **Note:** A special case in the `'nbsp'` mode exists where the `<br>` in `<p><br></p>` is treated as a block filler.
	*
	* @param domNode DOM node to check.
	* @returns True if a node is considered a block filler for given mode.
	*/ isBlockFiller(domNode) {
        if (this.blockFillerMode == "br") return domNode.isEqualNode($b9b9f2bdf9c6137f$var$BR_FILLER_REF);
        if ($b9b9f2bdf9c6137f$var$isOnlyBrInBlock(domNode, this.blockElements)) return true;
        return domNode.isEqualNode($b9b9f2bdf9c6137f$var$MARKED_NBSP_FILLER_REF) || $b9b9f2bdf9c6137f$var$isNbspBlockFiller(domNode, this.blockElements);
    }
    /**
	* Returns `true` if given selection is a backward selection, that is, if it's `focus` is before `anchor`.
	*
	* @param selection Selection instance to check.
	*/ isDomSelectionBackward(selection) {
        return (0, $c7bc2cb7e2db0227$export$11be8d61d882cdac)(selection);
    }
    /**
	* Returns a parent {@link module:engine/view/uielement~ViewUIElement} or {@link module:engine/view/rawelement~ViewRawElement}
	* that hosts the provided DOM node. Returns `null` if there is no such parent.
	*/ getHostViewElement(domNode) {
        const ancestors = (0, $c7bc2cb7e2db0227$export$c6fd3ab3f44300d0)(domNode);
        ancestors.pop();
        while(ancestors.length){
            const domNode = ancestors.pop();
            const viewNode = this._domToViewMapping.get(domNode);
            if (viewNode && (viewNode.is("uiElement") || viewNode.is("rawElement"))) return viewNode;
        }
        return null;
    }
    /**
	* Checks if the given selection's boundaries are at correct places.
	*
	* The following places are considered as incorrect for selection boundaries:
	*
	* * before or in the middle of an inline filler sequence,
	* * inside a DOM element which represents {@link module:engine/view/uielement~ViewUIElement a view UI element},
	* * inside a DOM element which represents {@link module:engine/view/rawelement~ViewRawElement a view raw element}.
	*
	* @param domSelection The DOM selection object to be checked.
	* @returns `true` if the given selection is at a correct place, `false` otherwise.
	*/ isDomSelectionCorrect(domSelection) {
        return this._isDomSelectionPositionCorrect(domSelection.anchorNode, domSelection.anchorOffset) && this._isDomSelectionPositionCorrect(domSelection.focusNode, domSelection.focusOffset);
    }
    /**
	* Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
	* and not processed during the conversion from DOM nodes to view elements.
	*
	* This is affecting how {@link module:engine/view/domconverter~ViewDomConverter#domToView} and
	* {@link module:engine/view/domconverter~ViewDomConverter#domChildrenToView} process DOM nodes.
	*
	* The raw data can be later accessed by a
	* {@link module:engine/view/element~ViewElement#getCustomProperty custom property of a view element} called `"$rawContent"`.
	*
	* @param pattern Pattern matching a view element whose content should
	* be treated as raw data.
	*/ registerRawContentMatcher(pattern) {
        this._rawContentElementMatcher.add(pattern);
    }
    /**
	* Registers a {@link module:engine/view/matcher~MatcherPattern} for inline object view elements.
	*
	* This is affecting how {@link module:engine/view/domconverter~ViewDomConverter#domToView} and
	* {@link module:engine/view/domconverter~ViewDomConverter#domChildrenToView} process DOM nodes.
	*
	* This is an extension of a simple {@link #inlineObjectElements} array of element names.
	*
	* @param pattern Pattern matching a view element which should be treated as an inline object.
	*/ registerInlineObjectMatcher(pattern) {
        this._inlineObjectElementMatcher.add(pattern);
    }
    /**
	* Clear temporary custom properties.
	*
	* @internal
	*/ _clearTemporaryCustomProperties() {
        for (const element of this._elementsWithTemporaryCustomProperties)element._removeCustomProperty("editingPipeline:doNotReuseOnce");
        this._elementsWithTemporaryCustomProperties.clear();
    }
    /**
	* Returns the block {@link module:engine/view/filler filler} node based on the current {@link #blockFillerMode} setting.
	*/ _getBlockFiller() {
        switch(this.blockFillerMode){
            case "nbsp":
                return $b9b9f2bdf9c6137f$export$c4fba0b3ea844689(this._domDocument);
            case "markedNbsp":
                return $b9b9f2bdf9c6137f$export$7b97760a1c0358a1(this._domDocument);
            case "br":
                return $b9b9f2bdf9c6137f$export$aca8945d5942df7b(this._domDocument);
        }
    }
    /**
	* Checks if the given DOM position is a correct place for selection boundary. See {@link #isDomSelectionCorrect}.
	*
	* @param domParent Position parent.
	* @param offset Position offset.
	* @returns `true` if given position is at a correct place for selection boundary, `false` otherwise.
	*/ _isDomSelectionPositionCorrect(domParent, offset) {
        if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domParent) && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domParent) && offset < 7) return false;
        if (this.isElement(domParent) && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domParent.childNodes[offset])) return false;
        const viewParent = this.mapDomToView(domParent);
        if (viewParent && (viewParent.is("uiElement") || viewParent.is("rawElement"))) return false;
        return true;
    }
    /**
	* Internal generator for {@link #domToView}. Also used by {@link #domChildrenToView}.
	* Separates DOM nodes conversion from whitespaces processing.
	*
	* @param domNode DOM node or document fragment to transform.
	* @param inlineNodes An array of recently encountered inline nodes truncated to the block element boundaries.
	* Used later to process whitespaces.
	*/ *_domToView(domNode, options, inlineNodes) {
        if (this.blockFillerMode != "br" && $b9b9f2bdf9c6137f$var$isOnlyBrInBlock(domNode, this.blockElements)) return null;
        const hostElement = this.getHostViewElement(domNode);
        if (hostElement) return hostElement;
        if ((0, $c7bc2cb7e2db0227$export$3ab01370f5e64ac8)(domNode) && options.skipComments) return null;
        if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(domNode)) {
            if ($b9b9f2bdf9c6137f$export$3f0f3bc790a542b6(domNode)) return null;
            else {
                const textData = domNode.data;
                if (textData === "") return null;
                const textNode = new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(this.document, textData);
                inlineNodes.push(textNode);
                return textNode;
            }
        } else {
            let viewElement = this.mapDomToView(domNode);
            if (viewElement) {
                if (this._isInlineObjectElement(viewElement)) inlineNodes.push(viewElement);
                return viewElement;
            }
            if (this.isDocumentFragment(domNode)) {
                viewElement = new $b9b9f2bdf9c6137f$export$574fd53611480ec7(this.document);
                if (options.bind) this.bindDocumentFragments(domNode, viewElement);
            } else {
                viewElement = this._createViewElement(domNode, options);
                if (options.bind) this.bindElements(domNode, viewElement);
                const attrs = domNode.attributes;
                if (attrs) for(let l = attrs.length, i = 0; i < l; i++)viewElement._setAttribute(attrs[i].name, attrs[i].value);
                if (this._isViewElementWithRawContent(viewElement, options)) {
                    viewElement._setCustomProperty("$rawContent", domNode.innerHTML);
                    if (!this._isBlockViewElement(viewElement)) inlineNodes.push(viewElement);
                    return viewElement;
                }
                if ((0, $c7bc2cb7e2db0227$export$3ab01370f5e64ac8)(domNode)) {
                    viewElement._setCustomProperty("$rawContent", domNode.data);
                    return viewElement;
                }
            }
            yield viewElement;
            const nestedInlineNodes = [];
            if (options.withChildren !== false) for (const child of this.domChildrenToView(domNode, options, nestedInlineNodes))viewElement._appendChild(child);
            if (this._isInlineObjectElement(viewElement)) {
                inlineNodes.push(viewElement);
                this._processDomInlineNodes(null, nestedInlineNodes, options);
            } else for (const inlineNode of nestedInlineNodes)inlineNodes.push(inlineNode);
        }
    }
    /**
	* Internal helper that walks the list of inline view nodes already generated from DOM nodes
	* and handles whitespaces and NBSPs.
	*
	* @param domParent The DOM parent of the given inline nodes. This should be a document fragment or
	* a block element to whitespace processing start cleaning.
	* @param inlineNodes An array of recently encountered inline nodes truncated to the block element boundaries.
	*/ _processDomInlineNodes(domParent, inlineNodes, options) {
        if (!inlineNodes.length) return;
        if (domParent && !this.isDocumentFragment(domParent) && !this._isBlockDomElement(domParent)) return;
        let prevNodeEndsWithSpace = false;
        for(let i = 0; i < inlineNodes.length; i++){
            const node = inlineNodes[i];
            if (!node.is("$text")) {
                prevNodeEndsWithSpace = false;
                continue;
            }
            let data;
            let nodeEndsWithSpace = false;
            if (this._isPreFormatted(node)) data = $b9b9f2bdf9c6137f$export$58f93c130b8dc873(node.data);
            else {
                data = node.data.replace(/[ \n\t\r]{1,}/g, " ");
                nodeEndsWithSpace = /[^\S\u00A0]/.test(data.charAt(data.length - 1));
                const prevNode = i > 0 ? inlineNodes[i - 1] : null;
                const nextNode = i + 1 < inlineNodes.length ? inlineNodes[i + 1] : null;
                const shouldLeftTrim = !prevNode || prevNode.is("element") && prevNode.name == "br" || prevNodeEndsWithSpace;
                const shouldRightTrim = nextNode ? false : !$b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(node.data);
                if (options.withChildren !== false) {
                    if (shouldLeftTrim) data = data.replace(/^ /, "");
                    if (shouldRightTrim) data = data.replace(/ $/, "");
                }
                data = $b9b9f2bdf9c6137f$export$58f93c130b8dc873(data);
                if (this.blockFillerMode != "br" && node.parent) {
                    if ($b9b9f2bdf9c6137f$var$isViewMarkedNbspFiller(node.parent, data)) {
                        data = "";
                        if (node.parent.parent) {
                            node.parent.parent._setCustomProperty("$hasBlockFiller", true);
                            node.parent._remove();
                        }
                    } else if ($b9b9f2bdf9c6137f$var$isViewNbspFiller(node.parent, data, this.blockElements)) {
                        data = "";
                        node.parent._setCustomProperty("$hasBlockFiller", true);
                    }
                }
                data = data.replace(/ \u00A0/g, "  ");
                const isNextNodeInlineObjectElement = nextNode && nextNode.is("element") && nextNode.name != "br";
                const isNextNodeStartingWithSpace = nextNode && nextNode.is("$text") && nextNode.data.charAt(0) == " ";
                if (/[ \u00A0]\u00A0$/.test(data) || !nextNode || isNextNodeInlineObjectElement || isNextNodeStartingWithSpace) data = data.replace(/\u00A0$/, " ");
                if (shouldLeftTrim || prevNode && prevNode.is("element") && prevNode.name != "br") data = data.replace(/^\u00A0/, " ");
            }
            if (data.length == 0 && node.parent) {
                node._remove();
                inlineNodes.splice(i, 1);
                i--;
            } else {
                node._data = data;
                prevNodeEndsWithSpace = nodeEndsWithSpace;
            }
        }
        inlineNodes.length = 0;
    }
    /**
	* Takes text data from a given {@link module:engine/view/text~ViewText#data} and processes it so
	* it is correctly displayed in the DOM.
	*
	* Following changes are done:
	*
	* * a space at the beginning is changed to `&nbsp;` if this is the first text node in its container
	* element or if a previous text node ends with a space character,
	* * space at the end of the text node is changed to `&nbsp;` if there are two spaces at the end of a node or if next node
	* starts with a space or if it is the last text node in its container,
	* * remaining spaces are replaced to a chain of spaces and `&nbsp;` (e.g. `'x   x'` becomes `'x &nbsp; x'`).
	*
	* Content of {@link #preElements} is not processed.
	*
	* @param node View text node to process.
	* @returns Processed text data.
	*/ _processDataFromViewText(node) {
        let data = node.data;
        if (this._isPreFormatted(node)) return data;
        if (data.charAt(0) == " ") {
            const prevNode = this._getTouchingInlineViewNode(node, false);
            if (prevNode && prevNode.is("$textProxy") && this._nodeEndsWithSpace(prevNode) || !prevNode) data = "\xA0" + data.substr(1);
        }
        if (data.charAt(data.length - 1) == " ") {
            const nextNode = this._getTouchingInlineViewNode(node, true);
            const nextStartsWithSpace = nextNode && nextNode.is("$textProxy") && nextNode.data.charAt(0) == " ";
            if (data.charAt(data.length - 2) == " " || !nextNode || nextStartsWithSpace) data = data.substr(0, data.length - 1) + "\xA0";
        }
        return data.replace(/ {2}/g, " \xA0");
    }
    /**
	* Checks whether given node ends with a space character after changing appropriate space characters to `&nbsp;`s.
	*
	* @param  node Node to check.
	* @returns `true` if given `node` ends with space, `false` otherwise.
	*/ _nodeEndsWithSpace(node) {
        if (this._isPreFormatted(node)) return false;
        const data = this._processDataFromViewText(node);
        return data.charAt(data.length - 1) == " ";
    }
    /**
	* Checks whether given text contains preformatted white space. This is the case if
	* * any of node ancestors has a name which is in `preElements` array, or
	* * the closest ancestor that has the `white-space` CSS property sets it to a value that preserves spaces
	*
	* @param node Node to check
	* @returns `true` if given node contains preformatted white space, `false` otherwise.
	*/ _isPreFormatted(node) {
        if ($b9b9f2bdf9c6137f$var$_hasViewParentOfType(node, this.preElements)) return true;
        for (const ancestor of node.getAncestors({
            parentFirst: true
        })){
            if (!ancestor.is("element") || !ancestor.hasStyle("white-space") || ancestor.getStyle("white-space") === "inherit") continue;
            return [
                "pre",
                "pre-wrap",
                "break-spaces"
            ].includes(ancestor.getStyle("white-space"));
        }
        return false;
    }
    /**
	* Helper function. For given {@link module:engine/view/text~ViewText view text node}, it finds previous or next sibling
	* that is contained in the same container element. If there is no such sibling, `null` is returned.
	*
	* @param node Reference node.
	* @returns Touching text node, an inline object
	* or `null` if there is no next or previous touching text node.
	*/ _getTouchingInlineViewNode(node, getNext) {
        const treeWalker = new $b9b9f2bdf9c6137f$export$c08c3998433b96e1({
            startPosition: getNext ? $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(node) : $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(node),
            direction: getNext ? "forward" : "backward"
        });
        for (const { item: item } of treeWalker)if (item.is("$textProxy")) return item;
        else if (item.is("element") && item.getCustomProperty("dataPipeline:transparentRendering")) continue;
        else if (item.is("element", "br")) return null;
        else if (this._isInlineObjectElement(item)) return item;
        else if (item.is("containerElement") || this._isBlockViewElement(item)) return null;
        return null;
    }
    /**
	* Returns `true` if a DOM node belongs to {@link #blockElements}. `false` otherwise.
	*/ _isBlockDomElement(node) {
        return this.isElement(node) && this.blockElements.includes(node.tagName.toLowerCase());
    }
    /**
	* Returns `true` if a view node belongs to {@link #blockElements}. `false` otherwise.
	*/ _isBlockViewElement(node) {
        return node.is("element") && this.blockElements.includes(node.name);
    }
    /**
	* Returns `true` if a DOM node belongs to {@link #inlineObjectElements}. `false` otherwise.
	*/ _isInlineObjectElement(node) {
        if (!node.is("element")) return false;
        return node.name == "br" || this.inlineObjectElements.includes(node.name) || !!this._inlineObjectElementMatcher.match(node);
    }
    /**
	* Creates view element basing on the node type.
	*
	* @param node DOM node to check.
	* @param options Conversion options. See {@link module:engine/view/domconverter~ViewDomConverter#domToView} options parameter.
	*/ _createViewElement(node, options) {
        if ((0, $c7bc2cb7e2db0227$export$3ab01370f5e64ac8)(node)) return new $b9b9f2bdf9c6137f$export$3d8082ae114b5652(this.document, "$comment");
        const viewName = options.keepOriginalCase ? node.tagName : node.tagName.toLowerCase();
        return new $b9b9f2bdf9c6137f$export$6a9b2964be74ea54(this.document, viewName);
    }
    /**
	* Checks if view element's content should be treated as a raw data.
	*
	* @param viewElement View element to check.
	* @param options Conversion options. See {@link module:engine/view/domconverter~ViewDomConverter#domToView} options parameter.
	*/ _isViewElementWithRawContent(viewElement, options) {
        return options.withChildren !== false && viewElement.is("element") && !!this._rawContentElementMatcher.match(viewElement);
    }
    /**
	* Checks whether a given element name should be renamed in a current rendering mode.
	*
	* @param elementName The name of view element.
	*/ _shouldRenameElement(elementName) {
        const name = elementName.toLowerCase();
        return this.renderingMode === "editing" && this.unsafeElements.includes(name);
    }
    /**
	* Return a <span> element with a special attribute holding the name of the original element.
	* Optionally, copy all the attributes of the original element if that element is provided.
	*
	* @param elementName The name of view element.
	* @param originalDomElement The original DOM element to copy attributes and content from.
	*/ _createReplacementDomElement(elementName, originalDomElement) {
        const newDomElement = this._domDocument.createElement("span");
        newDomElement.setAttribute($b9b9f2bdf9c6137f$var$UNSAFE_ELEMENT_REPLACEMENT_ATTRIBUTE, elementName);
        if (originalDomElement) {
            while(originalDomElement.firstChild)newDomElement.appendChild(originalDomElement.firstChild);
            for (const attributeName of originalDomElement.getAttributeNames())newDomElement.setAttribute(attributeName, originalDomElement.getAttribute(attributeName));
        }
        return newDomElement;
    }
};
/**
* Helper function.
* Used to check if given native `Element` or `Text` node has parent with tag name from `types` array.
*
* @returns`true` if such parent exists or `false` if it does not.
*/ function $b9b9f2bdf9c6137f$var$_hasViewParentOfType(node, types) {
    return node.getAncestors().some((parent)=>parent.is("element") && types.includes(parent.name));
}
/**
* A helper that executes given callback for each DOM node's ancestor, starting from the given node
* and ending in document#documentElement.
*
* The walk crosses shadow DOM boundaries, so for a node inside a shadow root it continues through the
* host into the surrounding (light) DOM instead of stopping at the boundary.
*
* @param callback A callback to be executed for each ancestor.
*/ function $b9b9f2bdf9c6137f$var$forEachDomElementAncestor(element, callback) {
    let node = element;
    while(node){
        callback(node);
        node = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(node);
    }
}
/**
* Checks if given DOM node is a nbsp block filler.
*
* A &nbsp; is a block filler only if it is a single child of a block element.
*
* @param domNode DOM node.
*/ function $b9b9f2bdf9c6137f$var$isNbspBlockFiller(domNode, blockElements) {
    return domNode.isEqualNode($b9b9f2bdf9c6137f$var$NBSP_FILLER_REF) && $b9b9f2bdf9c6137f$var$hasBlockParent(domNode, blockElements) && (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domNode).childNodes.length === 1;
}
/**
* Checks if domNode has block parent.
*
* @param domNode DOM node.
*/ function $b9b9f2bdf9c6137f$var$hasBlockParent(domNode, blockElements) {
    const parent = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domNode);
    return !!parent && !!parent.tagName && blockElements.includes(parent.tagName.toLowerCase());
}
/**
* Checks if given view node is a nbsp block filler.
*
* A &nbsp; is a block filler only if it is a single child of a block element.
*/ function $b9b9f2bdf9c6137f$var$isViewNbspFiller(parent, data, blockElements) {
    return data == "\xA0" && parent && parent.is("element") && parent.childCount == 1 && blockElements.includes(parent.name);
}
/**
* Checks if given view node is a marked-nbsp block filler.
*
* A &nbsp; is a block filler only if it is wrapped in `<span data-cke-filler="true">` element.
*/ function $b9b9f2bdf9c6137f$var$isViewMarkedNbspFiller(parent, data) {
    return data == "\xA0" && parent && parent.is("element", "span") && parent.childCount == 1 && parent.hasAttribute("data-cke-filler");
}
/**
* Checks if given view node is a br block filler.
*
* A <br> is a block filler only if it has data-cke-filler attribute set.
*/ function $b9b9f2bdf9c6137f$var$isViewBrFiller(node) {
    return node.is("element", "br") && node.hasAttribute("data-cke-filler");
}
/**
* Special case for `<p><br></p>` in which `<br>` should be treated as filler even when we are not in the 'br' mode.
*/ function $b9b9f2bdf9c6137f$var$isOnlyBrInBlock(domNode, blockElements) {
    return domNode.tagName === "BR" && $b9b9f2bdf9c6137f$var$hasBlockParent(domNode, blockElements) && (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domNode).childNodes.length === 1;
}
/**
* Log to console the information about element that was replaced.
* Check UNSAFE_ELEMENTS for all recognized unsafe elements.
*
* @param elementName The name of the view element.
*/ function $b9b9f2bdf9c6137f$var$_logUnsafeElement(elementName) {
    if (elementName === "script") (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("domconverter-unsafe-script-element-detected");
    if (elementName === "style") (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("domconverter-unsafe-style-element-detected");
}
/**
* In certain cases, Firefox mysteriously assigns so called "restricted objects" to native DOM Range properties.
* Any attempt at accessing restricted object's properties causes errors.
* See: https://github.com/ckeditor/ckeditor5/issues/9635.
*/ function $b9b9f2bdf9c6137f$var$isGeckoRestrictedDomSelection(domSelection) {
    if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko) return false;
    if (!domSelection.rangeCount) return false;
    const container = domSelection.getRangeAt(0).startContainer;
    try {
        Object.prototype.toString.call(container);
    } catch  {
        return true;
    }
    return false;
}
/**
* While rendering the editor content, the {@link module:engine/view/domconverter~ViewDomConverter} detected a `<script>` element that may
* disrupt the editing experience. To avoid this, the `<script>` element was replaced with `<span data-ck-unsafe-element="script"></span>`.
*
* @error domconverter-unsafe-script-element-detected
*/ /**
* While rendering the editor content, the
* {@link module:engine/view/domconverter~ViewDomConverter} detected a `<style>` element that may affect
* the editing experience. To avoid this, the `<style>` element was replaced with `<span data-ck-unsafe-element="style"></span>`.
*
* @error domconverter-unsafe-style-element-detected
*/ /**
* The {@link module:engine/view/domconverter~ViewDomConverter} detected an interactive attribute in the
* {@glink framework/architecture/editing-engine#editing-pipeline editing pipeline}. For the best
* editing experience, the attribute was renamed to `data-ck-unsafe-attribute-[original attribute name]`.
*
* If you are the author of the plugin that generated this attribute and you want it to be preserved
* in the editing pipeline, you can configure this when creating the element
* using {@link module:engine/view/downcastwriter~ViewDowncastWriter} during the
* {@glink framework/architecture/editing-engine#conversion model–view conversion}. Methods such as
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createContainerElement},
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createAttributeElement}, or
* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createEmptyElement}
* accept an option that will disable filtering of specific attributes:
*
* ```ts
* const paragraph = writer.createContainerElement( 'p',
* 	{
* 		class: 'clickable-paragraph',
* 		onclick: 'alert( "Paragraph clicked!" )'
* 	},
* 	{
* 		// Make sure the "onclick" attribute will pass through.
* 		renderUnsafeAttributes: [ 'onclick' ]
* 	}
* );
* ```
*
* @error domconverter-unsafe-attribute-detected
* @param {HTMLElement} domElement The DOM element the attribute was set on.
* @param {string} key The original name of the attribute
* @param {string} value The value of the original attribute
*/ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/observer
*/ const $b9b9f2bdf9c6137f$var$ObserverBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)();
/**
* Abstract base observer class. Observers are classes which listen to DOM events, do the preliminary
* processing and fire events on the {@link module:engine/view/document~ViewDocument} objects.
* Observers can also add features to the view, for instance by updating its status or marking elements
* which need a refresh on DOM events.
*/ var $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b = class extends $b9b9f2bdf9c6137f$var$ObserverBase {
    /**
	* An instance of the view controller.
	*/ view;
    /**
	* A reference to the {@link module:engine/view/document~ViewDocument} object.
	*/ document;
    /**
	* The state of the observer. If it is disabled, no events will be fired.
	*/ _isEnabled = false;
    /**
	* Creates an instance of the observer.
	*/ constructor(view){
        super();
        this.view = view;
        this.document = view.document;
    }
    /**
	* The state of the observer. If it is disabled, no events will be fired.
	*/ get isEnabled() {
        return this._isEnabled;
    }
    /**
	* Enables the observer. This method is called when the observer is registered to the
	* {@link module:engine/view/view~EditingView} and after {@link module:engine/view/view~EditingView#forceRender rendering}
	* (all observers are {@link #disable disabled} before rendering).
	*
	* A typical use case for disabling observers is that mutation observers need to be disabled for the rendering.
	* However, a child class may not need to be disabled, so it can implement an empty method.
	*
	* @see module:engine/view/observer/observer~Observer#disable
	*/ enable() {
        this._isEnabled = true;
    }
    /**
	* Disables the observer. This method is called before
	* {@link module:engine/view/view~EditingView#forceRender rendering} to prevent firing events during rendering.
	*
	* @see module:engine/view/observer/observer~Observer#enable
	*/ disable() {
        this._isEnabled = false;
    }
    /**
	* Disables and destroys the observer, among others removes event listeners created by the observer.
	*/ destroy() {
        this.disable();
        this.stopListening();
    }
    /**
	* Checks whether a given DOM event should be ignored (should not be turned into a synthetic view document event).
	*
	* Currently, an event will be ignored only if its target or any of its ancestors has the `data-cke-ignore-events` attribute.
	* This attribute can be used inside the structures generated by
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter#createUIElement `ViewDowncastWriter#createUIElement()`} to ignore events
	* fired within a UI that should be excluded from CKEditor 5's realms.
	*
	* @param domTarget The DOM event target to check (usually an element, sometimes a text node and
	* potentially sometimes a document, too).
	* @returns Whether this event should be ignored by the observer.
	*/ checkShouldIgnoreEventFromTarget(domTarget) {
        if (domTarget && domTarget.nodeType === 3) domTarget = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(domTarget);
        if (!domTarget || domTarget.nodeType !== 1) return false;
        return domTarget.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/domeventdata
*/ /**
* Information about a DOM event in context of the {@link module:engine/view/document~ViewDocument}.
* It wraps the native event, which usually should not be used as the wrapper contains
* additional data (like key code for keyboard events).
*
* @typeParam TEvent The type of DOM Event that this class represents.
*/ var $b9b9f2bdf9c6137f$export$7f51b38da3783c21 = class {
    /**
	* Instance of the view controller.
	*/ view;
    /**
	* The instance of the document.
	*/ document;
    /**
	* The DOM event.
	*/ domEvent;
    /**
	* The DOM target.
	*/ domTarget;
    /**
	* @param view The instance of the view controller.
	* @param domEvent The DOM event.
	* @param additionalData Additional properties that the instance should contain.
	*/ constructor(view, domEvent, additionalData){
        this.view = view;
        this.document = view.document;
        this.domEvent = domEvent;
        this.domTarget = domEvent.target;
        (0, $c4c424a07e1933a9$export$64c881bba8e369b4)(this, additionalData);
    }
    /**
	* The tree view element representing the target.
	*/ get target() {
        return this.view.domConverter.mapDomToView(this.domTarget);
    }
    /**
	* Prevents the native's event default action.
	*/ preventDefault() {
        this.domEvent.preventDefault();
    }
    /**
	* Stops native event propagation.
	*/ stopPropagation() {
        this.domEvent.stopPropagation();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/domeventobserver
*/ /**
* Base class for DOM event observers. This class handles
* {@link module:engine/view/observer/observer~Observer#observe adding} listeners to DOM elements,
* {@link module:engine/view/observer/observer~Observer#disable disabling} and
* {@link module:engine/view/observer/observer~Observer#enable re-enabling} events.
* Child class needs to define
* {@link module:engine/view/observer/domeventobserver~DomEventObserver#domEventType DOM event type} and
* {@link module:engine/view/observer/domeventobserver~DomEventObserver#onDomEvent callback}.
*
* For instance:
*
* ```ts
* class ClickObserver extends DomEventObserver<'click'> {
* 	// It can also be defined as a normal property in the constructor.
* 	get domEventType(): 'click' {
* 		return 'click';
* 	}
*
* 	onDomEvent( domEvent: MouseEvent ): void {
* 		this.fire( 'click', domEvent );
* 	}
* }
* ```
*
* @typeParam EventType DOM Event type name or an union of those.
* @typeParam AdditionalData Additional data passed along with the event.
*/ var $b9b9f2bdf9c6137f$export$fc1db128570de841 = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* If set to `true` DOM events will be listened on the capturing phase.
	* Default value is `false`.
	*/ useCapture = false;
    /**
	* If set to `true`, indicates that the function specified by listener will never call `preventDefault()`.
	* Default value is `false`.
	*/ usePassive = false;
    /**
	* @inheritDoc
	*/ observe(domElement) {
        (typeof this.domEventType == "string" ? [
            this.domEventType
        ] : this.domEventType).forEach((type)=>{
            this.listenTo(domElement, type, (eventInfo, domEvent)=>{
                if (this.isEnabled && !this.checkShouldIgnoreEventFromTarget(domEvent.target)) this.onDomEvent(domEvent);
            }, {
                useCapture: this.useCapture,
                usePassive: this.usePassive
            });
        });
    }
    /**
	* @inheritDoc
	*/ stopObserving(domElement) {
        this.stopListening(domElement);
    }
    /**
	* Calls `Document#fire()` if observer {@link #isEnabled is enabled}.
	*
	* @see module:utils/emittermixin~Emitter#fire
	* @param eventType The event type (name).
	* @param domEvent The DOM event.
	* @param additionalData The additional data which should extend the
	* {@link module:engine/view/observer/domeventdata~ViewDocumentDomEventData event data} object.
	*/ fire(eventType, domEvent, additionalData) {
        if (this.isEnabled) this.document.fire(eventType, new $b9b9f2bdf9c6137f$export$7f51b38da3783c21(this.view, domEvent, additionalData));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/keyobserver
*/ /**
* Observer for events connected with pressing keyboard keys.
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$export$ed160429b047c3c0 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = [
        "keydown",
        "keyup"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvt) {
        const data = {
            keyCode: domEvt.keyCode,
            altKey: domEvt.altKey,
            ctrlKey: domEvt.ctrlKey,
            shiftKey: domEvt.shiftKey,
            metaKey: domEvt.metaKey,
            get keystroke () {
                return (0, $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb)(this);
            }
        };
        this.fire(domEvt.type, domEvt, data);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/fakeselectionobserver
*/ /**
* Fake selection observer class. If view selection is fake it is placed in dummy DOM container. This observer listens
* on {@link module:engine/view/document~ViewDocument#event:keydown keydown} events and handles moving
* fake view selection to the correct place if arrow keys are pressed.
* Fires {@link module:engine/view/document~ViewDocument#event:selectionChange selectionChange event} simulating natural behaviour of
* {@link module:engine/view/observer/selectionobserver~SelectionObserver SelectionObserver}.
*/ var $b9b9f2bdf9c6137f$export$f1433469b4748837 = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* Fires debounced event `selectionChangeDone`. It uses `es-toolkit#debounce` method to delay function call.
	*/ _fireSelectionChangeDoneDebounced;
    /**
	* Creates new FakeSelectionObserver instance.
	*/ constructor(view){
        super(view);
        this._fireSelectionChangeDoneDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)((data)=>{
            this.document.fire("selectionChangeDone", data);
        }, 200);
    }
    /**
	* @inheritDoc
	*/ observe() {
        const document1 = this.document;
        document1.on("arrowKey", (eventInfo, data)=>{
            if (document1.selection.isFake && this.isEnabled) data.preventDefault();
        }, {
            context: "$capture"
        });
        document1.on("arrowKey", (eventInfo, data)=>{
            if (document1.selection.isFake && this.isEnabled) this._handleSelectionMove(data.keyCode);
        }, {
            priority: "lowest"
        });
    }
    /**
	* @inheritDoc
	*/ stopObserving() {}
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._fireSelectionChangeDoneDebounced.cancel();
    }
    /**
	* Handles collapsing view selection according to given key code. If left or up key is provided - new selection will be
	* collapsed to left. If right or down key is pressed - new selection will be collapsed to right.
	*
	* This method fires {@link module:engine/view/document~ViewDocument#event:selectionChange} and
	* {@link module:engine/view/document~ViewDocument#event:selectionChangeDone} events imitating behaviour of
	* {@link module:engine/view/observer/selectionobserver~SelectionObserver}.
	*/ _handleSelectionMove(keyCode) {
        const selection = this.document.selection;
        const newSelection = new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(selection.getRanges(), {
            backward: selection.isBackward,
            fake: false
        });
        if (keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowleft || keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowup) newSelection.setTo(newSelection.getFirstPosition());
        if (keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowright || keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowdown) newSelection.setTo(newSelection.getLastPosition());
        const data = {
            oldSelection: selection,
            newSelection: newSelection,
            domSelection: null
        };
        this.document.fire("selectionChange", data);
        this._fireSelectionChangeDoneDebounced(data);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/mutationobserver
*/ /**
* Mutation observer's role is to watch for any DOM changes inside the editor that weren't
* done by the editor's {@link module:engine/view/renderer~ViewRenderer} itself and reverting these changes.
*
* It does this by observing all mutations in the DOM, marking related view elements as changed and calling
* {@link module:engine/view/renderer~ViewRenderer#render}. Because all mutated nodes are marked as
* "to be rendered" and the {@link module:engine/view/renderer~ViewRenderer#render `render()`} method is called,
* all changes are reverted in the DOM (the DOM is synced with the editor's view structure).
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$export$d3c1860ee66f291a = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* Reference to the {@link module:engine/view/view~EditingView#domConverter}.
	*/ domConverter;
    /**
	* Native mutation observer config.
	*/ _config;
    /**
	* Observed DOM elements.
	*/ _domElements;
    /**
	* Native mutation observer.
	*/ _mutationObserver;
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        this._config = {
            childList: true,
            characterData: true,
            subtree: true
        };
        this.domConverter = view.domConverter;
        this._domElements = /* @__PURE__ */ new Set();
        this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
    }
    /**
	* Synchronously handles mutations and empties the queue.
	*/ flush() {
        this._onMutations(this._mutationObserver.takeRecords());
    }
    /**
	* @inheritDoc
	*/ observe(domElement) {
        this._domElements.add(domElement);
        if (this.isEnabled) this._mutationObserver.observe(domElement, this._config);
    }
    /**
	* @inheritDoc
	*/ stopObserving(domElement) {
        this._domElements.delete(domElement);
        if (this.isEnabled) {
            this._mutationObserver.disconnect();
            for (const domElement of this._domElements)this._mutationObserver.observe(domElement, this._config);
        }
    }
    /**
	* @inheritDoc
	*/ enable() {
        super.enable();
        for (const domElement of this._domElements)this._mutationObserver.observe(domElement, this._config);
    }
    /**
	* @inheritDoc
	*/ disable() {
        super.disable();
        this._mutationObserver.disconnect();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._mutationObserver.disconnect();
    }
    /**
	* Handles mutations. Mark view elements to sync and call render.
	*
	* @param domMutations Array of native mutations.
	*/ _onMutations(domMutations) {
        if (domMutations.length === 0) return;
        const domConverter = this.domConverter;
        const mutatedTextNodes = /* @__PURE__ */ new Set();
        const elementsWithMutatedChildren = /* @__PURE__ */ new Set();
        for (const mutation of domMutations){
            const element = domConverter.mapDomToView(mutation.target);
            if (!element) continue;
            if (element.is("uiElement") || element.is("rawElement")) continue;
            if (mutation.type === "childList" && !this._isBogusBrMutation(mutation)) elementsWithMutatedChildren.add(element);
        }
        for (const mutation of domMutations){
            const element = domConverter.mapDomToView(mutation.target);
            if (element && (element.is("uiElement") || element.is("rawElement"))) continue;
            if (mutation.type === "characterData") {
                const text = domConverter.findCorrespondingViewText(mutation.target);
                if (text && !elementsWithMutatedChildren.has(text.parent)) mutatedTextNodes.add(text);
                else if (!text && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(mutation.target)) elementsWithMutatedChildren.add(domConverter.mapDomToView((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(mutation.target)));
            }
        }
        const mutations = [];
        for (const textNode of mutatedTextNodes)mutations.push({
            type: "text",
            node: textNode
        });
        for (const viewElement of elementsWithMutatedChildren){
            const domElement = domConverter.mapViewToDom(viewElement);
            const viewChildren = Array.from(viewElement.getChildren());
            const newViewChildren = Array.from(domConverter.domChildrenToView(domElement, {
                withChildren: false
            }));
            if (!(0, $5c9e4268bec214a7$export$dfce45ad55c48ab1)(viewChildren, newViewChildren, $b9b9f2bdf9c6137f$var$sameNodes)) mutations.push({
                type: "children",
                node: viewElement
            });
        }
        if (mutations.length) this.document.fire("mutations", {
            mutations: mutations
        });
    }
    /**
	* Checks if mutation was generated by the browser inserting bogus br on the end of the block element.
	* Such mutations are generated while pressing space or performing native spellchecker correction
	* on the end of the block element in Firefox browser.
	*
	* @param mutation Native mutation object.
	*/ _isBogusBrMutation(mutation) {
        let addedNode = null;
        if (mutation.nextSibling === null && mutation.removedNodes.length === 0 && mutation.addedNodes.length == 1) addedNode = this.domConverter.domToView(mutation.addedNodes[0], {
            withChildren: false
        });
        return addedNode && addedNode.is("element", "br");
    }
};
function $b9b9f2bdf9c6137f$var$sameNodes(child1, child2) {
    if (Array.isArray(child1)) return;
    if (child1 === child2) return true;
    else if (child1.is("$text") && child2.is("$text")) return child1.data === child2.data;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/focusobserver
*/ /**
* {@link module:engine/view/document~ViewDocument#event:focus Focus}
* and {@link module:engine/view/document~ViewDocument#event:blur blur} events observer.
* Focus observer handle also {@link module:engine/view/rooteditableelement~ViewRootEditableElement#isFocused isFocused} property of the
* {@link module:engine/view/rooteditableelement~ViewRootEditableElement root elements}.
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$export$c14091c1727e1823 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* Identifier of the timeout currently used by focus listener to delay rendering execution.
	*/ _renderTimeoutId = null;
    /**
	* Set to `true` if the document is in the process of setting the focus.
	*
	* The flag is used to indicate that setting the focus is in progress.
	*/ _isFocusChanging = false;
    /**
	* @inheritDoc
	*/ domEventType = [
        "focus",
        "blur"
    ];
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        this.useCapture = true;
        const document1 = this.document;
        document1.on("focus", ()=>this._handleFocus());
        document1.on("blur", (evt, data)=>this._handleBlur(data));
        document1.on("beforeinput", ()=>{
            if (!document1.isFocused) this._handleFocus();
        }, {
            priority: "highest"
        });
    }
    /**
	* Finishes setting the document focus state.
	*/ flush() {
        if (this._isFocusChanging) {
            this._isFocusChanging = false;
            this.document.isFocused = true;
        }
    }
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._clearTimeout();
        super.destroy();
    }
    /**
	* The `focus` event handler.
	*/ _handleFocus() {
        this._clearTimeout();
        this._isFocusChanging = true;
        this._renderTimeoutId = setTimeout(()=>{
            this._renderTimeoutId = null;
            this.flush();
            this.view.change(()=>{});
        }, 50);
    }
    /**
	* The `blur` event handler.
	*/ _handleBlur(data) {
        const selectedEditable = this.document.selection.editableElement;
        if (selectedEditable === null || selectedEditable === data.target) {
            this.document.isFocused = false;
            this._isFocusChanging = false;
            this.view.change(()=>{});
        }
    }
    /**
	* Clears timeout.
	*/ _clearTimeout() {
        if (this._renderTimeoutId) {
            clearTimeout(this._renderTimeoutId);
            this._renderTimeoutId = null;
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/selectionobserver
*/ /**
* Selection observer class observes selection changes in the document. If a selection changes on the document this
* observer checks if the DOM selection is different from the {@link module:engine/view/document~ViewDocument#selection view selection}.
* The selection observer fires {@link module:engine/view/document~ViewDocument#event:selectionChange} event only if
* a selection change was the only change in the document and the DOM selection is different from the view selection.
*
* This observer also manages the {@link module:engine/view/document~ViewDocument#isSelecting} property of the view document.
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$export$132935d5515cee7e = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* Instance of the mutation observer. Selection observer calls
	* {@link module:engine/view/observer/mutationobserver~MutationObserver#flush} to ensure that the mutations will be handled
	* before the {@link module:engine/view/document~ViewDocument#event:selectionChange} event is fired.
	*/ mutationObserver;
    /**
	* Instance of the focus observer. Focus observer calls
	* {@link module:engine/view/observer/focusobserver~FocusObserver#flush} to mark the latest focus change as complete.
	*/ focusObserver;
    /**
	* Reference to the view {@link module:engine/view/documentselection~ViewDocumentSelection} object used to compare
	* new selection with it.
	*/ selection;
    /**
	* Reference to the {@link module:engine/view/view~EditingView#domConverter}.
	*/ domConverter;
    /**
	* A set of documents which have added `selectionchange` listener to avoid adding a listener twice to the same
	* document.
	*/ _documents = /* @__PURE__ */ new WeakSet();
    /**
	* Fires debounced event `selectionChangeDone`. It uses `es-toolkit#debounce` method to delay function call.
	*/ _fireSelectionChangeDoneDebounced;
    /**
	* When called, starts clearing the {@link #_loopbackCounter} counter in time intervals. When the number of selection
	* changes exceeds a certain limit within the interval of time, the observer will not fire `selectionChange` but warn about
	* possible infinite selection loop.
	*/ _clearInfiniteLoopInterval;
    /**
	* Unlocks the `isSelecting` state of the view document in case the selection observer did not record this fact
	* correctly (for whatever reason). It is a safeguard (paranoid check), that returns document to the normal state
	* after a certain period of time (debounced, postponed by each selectionchange event).
	*/ _documentIsSelectingInactivityTimeoutDebounced;
    /**
	* Private property to check if the code does not enter infinite loop.
	*/ _loopbackCounter = 0;
    /**
	* A set of DOM trees (editing roots' shadow roots, or documents) that have a pending selection change.
	* Pending selection change is recorded while selection change event is detected on non focused editable.
	*/ _pendingSelectionChange = /* @__PURE__ */ new Set();
    /**
	* The observed editing roots. The DOM selection is resolved against all of them at once, which is what
	* makes it pierce every shadow boundary they live behind.
	*/ _observedDomRoots = /* @__PURE__ */ new Set();
    constructor(view){
        super(view);
        this.mutationObserver = view.getObserver($b9b9f2bdf9c6137f$export$d3c1860ee66f291a);
        this.focusObserver = view.getObserver($b9b9f2bdf9c6137f$export$c14091c1727e1823);
        this.selection = this.document.selection;
        this.domConverter = view.domConverter;
        this._fireSelectionChangeDoneDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)((data)=>{
            this.document.fire("selectionChangeDone", data);
        }, 200);
        this._clearInfiniteLoopInterval = setInterval(()=>this._clearInfiniteLoop(), 1e3);
        this._documentIsSelectingInactivityTimeoutDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(()=>this.document.isSelecting = false, 5e3);
        this.view.document.on("change:isFocused", (evt, name, isFocused)=>{
            if (isFocused && this._pendingSelectionChange.size) {
                this._handleSelectionChange();
                this._pendingSelectionChange.clear();
            }
        });
    }
    /**
	* @inheritDoc
	*/ observe(domElement) {
        const domDocument = domElement.ownerDocument;
        const startDocumentIsSelecting = ()=>{
            this.document.isSelecting = true;
            this._documentIsSelectingInactivityTimeoutDebounced();
        };
        const endDocumentIsSelecting = ()=>{
            if (!this.document.isSelecting) return;
            this._handleSelectionChange();
            this.document.isSelecting = false;
            this._documentIsSelectingInactivityTimeoutDebounced.cancel();
        };
        this.listenTo(domElement, "selectstart", startDocumentIsSelecting, {
            priority: "highest"
        });
        this.listenTo(domElement, "keydown", endDocumentIsSelecting, {
            priority: "highest",
            useCapture: true
        });
        this.listenTo(domElement, "keyup", endDocumentIsSelecting, {
            priority: "highest",
            useCapture: true
        });
        this._observedDomRoots.add(domElement);
        if (this._documents.has(domDocument)) return;
        this.listenTo(domDocument, "mouseup", endDocumentIsSelecting, {
            priority: "highest",
            useCapture: true
        });
        this.listenTo(domDocument, "selectionchange", ()=>{
            if (this.document.isComposing && !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) return;
            this._handleSelectionChange();
            this._documentIsSelectingInactivityTimeoutDebounced();
        });
        this.listenTo(this.view.document, "compositionstart", ()=>{
            this._handleSelectionChange();
        }, {
            priority: "lowest"
        });
        this._documents.add(domDocument);
    }
    /**
	* @inheritDoc
	*/ stopObserving(domElement) {
        this.stopListening(domElement);
        this._observedDomRoots.delete(domElement);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        clearInterval(this._clearInfiniteLoopInterval);
        this._fireSelectionChangeDoneDebounced.cancel();
        this._documentIsSelectingInactivityTimeoutDebounced.cancel();
    }
    /* v8 ignore next 6 -- @preserve */ _reportInfiniteLoop() {}
    /**
	* Selection change listener. {@link module:engine/view/observer/mutationobserver~MutationObserver#flush Flush} mutations, check if
	* a selection changes and fires {@link module:engine/view/document~ViewDocument#event:selectionChange} event on every change
	* and {@link module:engine/view/document~ViewDocument#event:selectionChangeDone} when a selection stop changing.
	*/ _handleSelectionChange() {
        if (!this.isEnabled) return;
        const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(Array.from(this._observedDomRoots));
        if (!domSelection) {
            this.view.hasDomSelection = false;
            return;
        }
        if (this.checkShouldIgnoreEventFromTarget(domSelection.anchorNode)) return;
        this.mutationObserver.flush();
        const newViewSelection = this.domConverter.domSelectionToView(domSelection);
        if (newViewSelection.rangeCount == 0) {
            this.view.hasDomSelection = false;
            return;
        }
        this.view.hasDomSelection = true;
        const domTarget = domSelection.anchorNode.getRootNode();
        this.focusObserver.flush();
        if (!this.view.document.isFocused && !this.view.document.isReadOnly) {
            this._pendingSelectionChange.add(domTarget);
            return;
        }
        this._pendingSelectionChange.delete(domTarget);
        if (this.selection.isEqual(newViewSelection) && this.domConverter.isDomSelectionCorrect(domSelection)) return;
        if (++this._loopbackCounter > 60) {
            this._reportInfiniteLoop();
            return;
        }
        if (!$b9b9f2bdf9c6137f$var$isSelectionWithinRootElements(newViewSelection)) this.view.forceRender();
        else if (this.selection.isSimilar(newViewSelection)) this.view.forceRender();
        else {
            const data = {
                oldSelection: this.selection,
                newSelection: newViewSelection,
                domSelection: domSelection
            };
            this.document.fire("selectionChange", data);
            this._fireSelectionChangeDoneDebounced(data);
        }
    }
    /**
	* Clears `SelectionObserver` internal properties connected with preventing infinite loop.
	*/ _clearInfiniteLoop() {
        this._loopbackCounter = 0;
    }
};
/**
* Checks if all roots of the selection's range boundaries are root elements.
* Returns true if the selection is fully contained within root elements (not orphaned).
*
* @param selection The view selection to check.
* @returns True if all range boundaries are within root elements, false otherwise.
*/ function $b9b9f2bdf9c6137f$var$isSelectionWithinRootElements(selection) {
    return Array.from(selection.getRanges()).flatMap((range)=>[
            range.start.root,
            range.end.root
        ]).every((root)=>root && root.is("rootElement"));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/compositionobserver
*/ /**
* {@link module:engine/view/document~ViewDocument#event:compositionstart Compositionstart},
* {@link module:engine/view/document~ViewDocument#event:compositionupdate compositionupdate} and
* {@link module:engine/view/document~ViewDocument#event:compositionend compositionend} events observer.
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$export$335bb1b1683f8605 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = [
        "compositionstart",
        "compositionupdate",
        "compositionend"
    ];
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        const document1 = this.document;
        document1.on("compositionstart", ()=>{
            document1.isComposing = true;
        });
        document1.on("compositionend", ()=>{
            document1.isComposing = false;
        });
    }
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent, {
            data: domEvent.data
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A facade over the native [`DataTransfer`](https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer) object.
*/ var $b9b9f2bdf9c6137f$export$1eefed0a4af75b0b = class {
    /**
	* The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
	*/ _files;
    /**
	* The native DataTransfer object.
	*/ _native;
    /**
	* @param nativeDataTransfer The native [`DataTransfer`](https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer) object.
	* @param options.cacheFiles Whether `files` list should be initialized in the constructor.
	*/ constructor(nativeDataTransfer, options = {}){
        this._files = options.cacheFiles ? $b9b9f2bdf9c6137f$var$getFiles(nativeDataTransfer) : null;
        this._native = nativeDataTransfer;
    }
    /**
	* The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
	*/ get files() {
        if (!this._files) this._files = $b9b9f2bdf9c6137f$var$getFiles(this._native);
        return this._files;
    }
    /**
	* Returns an array of available native content types.
	*/ get types() {
        return this._native.types;
    }
    /**
	* Gets the data from the data transfer by its MIME type.
	*
	* ```ts
	* dataTransfer.getData( 'text/plain' );
	* ```
	*
	* @param type The MIME type. E.g. `text/html` or `text/plain`.
	*/ getData(type) {
        return this._native.getData(type);
    }
    /**
	* Sets the data in the data transfer.
	*
	* @param type The MIME type. E.g. `text/html` or `text/plain`.
	*/ setData(type, data) {
        this._native.setData(type, data);
    }
    /**
	* The effect that is allowed for a drag operation.
	*/ set effectAllowed(value) {
        this._native.effectAllowed = value;
    }
    get effectAllowed() {
        return this._native.effectAllowed;
    }
    /**
	* The actual drop effect.
	*/ set dropEffect(value) {
        this._native.dropEffect = value;
    }
    get dropEffect() {
        return this._native.dropEffect;
    }
    /**
	* Set a preview image of the dragged content.
	*/ setDragImage(image, x, y) {
        this._native.setDragImage(image, x, y);
    }
    /**
	* Whether the dragging operation was canceled.
	*/ get isCanceled() {
        return this._native.dropEffect == "none" || !!this._native.mozUserCancelled;
    }
};
function $b9b9f2bdf9c6137f$var$getFiles(nativeDataTransfer) {
    const files = Array.from(nativeDataTransfer.files || []);
    const items = Array.from(nativeDataTransfer.items || []);
    if (files.length) return files;
    return items.filter((item)=>item.kind === "file").map((item)=>item.getAsFile());
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/inputobserver
*/ /**
* Observer for events connected with data input.
*
* **Note**: This observer is attached by {@link module:engine/view/view~EditingView} and available by default in all
* editor instances.
*/ var $b9b9f2bdf9c6137f$export$fa30dbb5a55f49c8 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = "beforeinput";
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        const domTargetRanges = domEvent.getTargetRanges();
        const view = this.view;
        const viewDocument = view.document;
        let dataTransfer = null;
        let data = null;
        let targetRanges = [];
        if (domEvent.dataTransfer) dataTransfer = new $b9b9f2bdf9c6137f$export$1eefed0a4af75b0b(domEvent.dataTransfer);
        if (domEvent.data !== null) data = domEvent.data;
        else if (dataTransfer) data = dataTransfer.getData("text/plain");
        if (viewDocument.selection.isFake) {
            targetRanges = Array.from(viewDocument.selection.getRanges());
            domEvent.preventDefault();
        } else if (domTargetRanges.length) targetRanges = domTargetRanges.map((domRange)=>{
            let viewStart = view.domConverter.domPositionToView(domRange.startContainer, domRange.startOffset);
            const viewEnd = view.domConverter.domPositionToView(domRange.endContainer, domRange.endOffset);
            if (viewStart && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(domRange.startContainer) && domRange.startOffset < 7) {
                domEvent.preventDefault();
                let count = 7 - domRange.startOffset;
                viewStart = viewStart.getLastMatchingPosition((value)=>{
                    if (value.item.is("attributeElement") || value.item.is("uiElement")) return true;
                    if (value.item.is("$textProxy") && count--) return true;
                    return false;
                }, {
                    direction: "backward",
                    singleCharacters: true
                });
            }
            if ($b9b9f2bdf9c6137f$var$isFollowedByInlineFiller(domRange.endContainer, domRange.endOffset)) domEvent.preventDefault();
            if (viewStart) return view.createRange(viewStart, viewEnd);
            else if (viewEnd) return view.createRange(viewEnd);
        }).filter((range)=>!!range);
        else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) {
            const domSelection = (0, $c7bc2cb7e2db0227$export$ca798a7e6e94638c)(domEvent.target);
            targetRanges = Array.from(view.domConverter.domSelectionToView(domSelection).getRanges());
        }
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid && domEvent.inputType == "insertCompositionText" && data && data.endsWith("\n")) {
            this.fire(domEvent.type, domEvent, {
                inputType: "insertParagraph",
                targetRanges: [
                    view.createRange(targetRanges[0].end)
                ]
            });
            return;
        }
        if ([
            "insertText",
            "insertReplacementText"
        ].includes(domEvent.inputType) && data && data.includes("\n")) {
            const parts = data.split(/\n{1,2}/g);
            let partTargetRanges = targetRanges;
            domEvent.preventDefault();
            for(let i = 0; i < parts.length; i++){
                const dataPart = parts[i];
                if (dataPart != "") {
                    this.fire(domEvent.type, domEvent, {
                        data: dataPart,
                        dataTransfer: dataTransfer,
                        targetRanges: partTargetRanges,
                        inputType: domEvent.inputType,
                        isComposing: domEvent.isComposing
                    });
                    partTargetRanges = [
                        viewDocument.selection.getFirstRange()
                    ];
                }
                if (i + 1 < parts.length) {
                    this.fire(domEvent.type, domEvent, {
                        inputType: "insertParagraph",
                        targetRanges: partTargetRanges
                    });
                    partTargetRanges = [
                        viewDocument.selection.getFirstRange()
                    ];
                }
            }
            return;
        }
        this.fire(domEvent.type, domEvent, {
            data: data,
            dataTransfer: dataTransfer,
            targetRanges: targetRanges,
            inputType: domEvent.inputType,
            isComposing: domEvent.isComposing
        });
    }
};
/**
* Returns `true` if there is an inline filler just after the position in DOM.
* It walks up the DOM tree if the offset is at the end of the node.
*/ function $b9b9f2bdf9c6137f$var$isFollowedByInlineFiller(node, offset) {
    while((0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(node)){
        if ((0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(node)) {
            if (offset != node.data.length) return false;
        } else if (offset != node.childNodes.length) return false;
        offset = (0, $c7bc2cb7e2db0227$export$305f7d4e9d4624f2)(node) + 1;
        node = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(node);
        if (offset < node.childNodes.length && $b9b9f2bdf9c6137f$export$3d7b0aa05f89e98b(node.childNodes[offset])) return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/arrowkeysobserver
*/ /**
* Arrow keys observer introduces the {@link module:engine/view/document~ViewDocument#event:arrowKey `Document#arrowKey`} event.
*
* Note that this observer is attached by the {@link module:engine/view/view~EditingView} and is available by default.
*/ var $b9b9f2bdf9c6137f$var$ArrowKeysObserver = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        this.document.on("keydown", (event, data)=>{
            if (this.isEnabled && (0, $c7bc2cb7e2db0227$export$dab661d9166cd5a8)(data.keyCode)) {
                const eventInfo = new $b9b9f2bdf9c6137f$export$56609df77c04b70e(this.document, "arrowKey", this.document.selection.getFirstRange());
                this.document.fire(eventInfo, data);
                if (eventInfo.stop.called) event.stop();
            }
        });
    }
    /**
	* @inheritDoc
	*/ observe() {}
    /**
	* @inheritDoc
	*/ stopObserving() {}
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Tab observer introduces the {@link module:engine/view/document~ViewDocument#event:tab `Document#tab`} event.
*
* Note that because {@link module:engine/view/observer/tabobserver~TabObserver} is attached by the
* {@link module:engine/view/view~EditingView}, this event is available by default.
*/ var $b9b9f2bdf9c6137f$export$c209ea36d8caa85d = class extends $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b {
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        const doc = this.document;
        doc.on("keydown", (evt, data)=>{
            if (!this.isEnabled || data.keyCode != (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).tab || data.ctrlKey) return;
            const event = new $b9b9f2bdf9c6137f$export$56609df77c04b70e(doc, "tab", doc.selection.getFirstRange());
            doc.fire(event, data);
            if (event.stop.called) evt.stop();
        });
    }
    /**
	* @inheritDoc
	*/ observe() {}
    /**
	* @inheritDoc
	*/ stopObserving() {}
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/view
*/ const $b9b9f2bdf9c6137f$var$EditingViewBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Editor's view controller class. Its main responsibility is DOM - View management for editing purposes, to provide
* abstraction over the DOM structure and events and hide all browsers quirks.
*
* View controller renders view document to DOM whenever view structure changes. To determine when view can be rendered,
* all changes need to be done using the {@link module:engine/view/view~EditingView#change} method, using
* {@link module:engine/view/downcastwriter~ViewDowncastWriter}:
*
* ```ts
* view.change( writer => {
* 	writer.insert( position, writer.createText( 'foo' ) );
* } );
* ```
*
* View controller also register {@link module:engine/view/observer/observer~Observer observers} which observes changes
* on DOM and fire events on the {@link module:engine/view/document~ViewDocument Document}.
* Note that the following observers are added by the class constructor and are always available:
*
* * {@link module:engine/view/observer/selectionobserver~SelectionObserver},
* * {@link module:engine/view/observer/focusobserver~FocusObserver},
* * {@link module:engine/view/observer/keyobserver~KeyObserver},
* * {@link module:engine/view/observer/fakeselectionobserver~FakeSelectionObserver}.
* * {@link module:engine/view/observer/compositionobserver~CompositionObserver}.
* * {@link module:engine/view/observer/inputobserver~InputObserver}.
* * {@link module:engine/view/observer/arrowkeysobserver~ArrowKeysObserver}.
* * {@link module:engine/view/observer/tabobserver~TabObserver}.
*
* This class also {@link module:engine/view/view~EditingView#attachDomRoot binds the DOM and the view elements}.
*
* If you do not need full a DOM - view management, and only want to transform a tree of view elements to a tree of DOM
* elements you do not need this controller. You can use the {@link module:engine/view/domconverter~ViewDomConverter ViewDomConverter}
* instead.
*/ var $b9b9f2bdf9c6137f$export$4ffdc5ea4ff36c8d = class extends $b9b9f2bdf9c6137f$var$EditingViewBase {
    /**
	* Instance of the {@link module:engine/view/document~ViewDocument} associated with this view controller.
	*/ document;
    /**
	* Instance of the {@link module:engine/view/domconverter~ViewDomConverter domConverter} used by
	* {@link module:engine/view/view~EditingView#_renderer renderer}
	* and {@link module:engine/view/observer/observer~Observer observers}.
	*/ domConverter;
    /**
	* Roots of the DOM tree. Map on the `HTMLElement`s with roots names as keys.
	*/ domRoots = /* @__PURE__ */ new Map();
    /**
	* Instance of the {@link module:engine/view/renderer~ViewRenderer renderer}.
	*/ _renderer;
    /**
	* A DOM root attributes cache. It saves the initial values of DOM root attributes before the DOM element
	* is {@link module:engine/view/view~EditingView#attachDomRoot attached} to the view so later on, when
	* the view is destroyed ({@link module:engine/view/view~EditingView#detachDomRoot}), they can be easily restored.
	* This way, the DOM element can go back to the (clean) state as if the editing view never used it.
	*/ _initialDomRootAttributes = /* @__PURE__ */ new WeakMap();
    /**
	* Map of registered {@link module:engine/view/observer/observer~Observer observers}.
	*/ _observers = /* @__PURE__ */ new Map();
    /**
	* ViewDowncastWriter instance used in {@link #change change method} callbacks.
	*/ _writer;
    /**
	* Is set to `true` when {@link #change view changes} are currently in progress.
	*/ _ongoingChange = false;
    /**
	* Used to prevent calling {@link #forceRender} and {@link #change} during rendering view to the DOM.
	*/ _postFixersInProgress = false;
    /**
	* Internal flag to temporary disable rendering. See the usage in the {@link #_disableRendering}.
	*/ _renderingDisabled = false;
    /**
	* Internal flag that disables rendering when there are no changes since the last rendering.
	* It stores information about changed selection and changed elements from attached document roots.
	*/ _hasChangedSinceTheLastRendering = false;
    /**
	* @param stylesProcessor The styles processor instance.
	*/ constructor(stylesProcessor){
        super();
        this.document = new $b9b9f2bdf9c6137f$export$c26285651732fb36(stylesProcessor);
        this.domConverter = new $b9b9f2bdf9c6137f$export$f7719161406171fa(this.document);
        this.set("isRenderingInProgress", false);
        this.set("hasDomSelection", false);
        this._renderer = new $b9b9f2bdf9c6137f$export$90ab2f690fef43b1(this.domConverter, this.document.selection);
        this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing");
        this._writer = new $b9b9f2bdf9c6137f$export$c1f00b82a18dfdda(this.document);
        this.addObserver($b9b9f2bdf9c6137f$export$d3c1860ee66f291a);
        this.addObserver($b9b9f2bdf9c6137f$export$c14091c1727e1823);
        this.addObserver($b9b9f2bdf9c6137f$export$132935d5515cee7e);
        this.addObserver($b9b9f2bdf9c6137f$export$ed160429b047c3c0);
        this.addObserver($b9b9f2bdf9c6137f$export$f1433469b4748837);
        this.addObserver($b9b9f2bdf9c6137f$export$335bb1b1683f8605);
        this.addObserver($b9b9f2bdf9c6137f$var$ArrowKeysObserver);
        this.addObserver($b9b9f2bdf9c6137f$export$fa30dbb5a55f49c8);
        this.addObserver($b9b9f2bdf9c6137f$export$c209ea36d8caa85d);
        $b9b9f2bdf9c6137f$export$1fc6bd2da514f3d3(this);
        $b9b9f2bdf9c6137f$export$634b3e76c8e059f7(this);
        this.on("render", ()=>{
            this._render();
            this.document.fire("layoutChanged");
            this._hasChangedSinceTheLastRendering = false;
        });
        this.listenTo(this.document.selection, "change", ()=>{
            this._hasChangedSinceTheLastRendering = true;
        });
        this.listenTo(this.document, "change:isFocused", ()=>{
            this._hasChangedSinceTheLastRendering = true;
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS) this.listenTo(this.document, "blur", (evt, data)=>{
            if (!this.domConverter.mapDomToView(data.domEvent.relatedTarget)) this.domConverter._clearDomSelection();
        });
        this.listenTo(this.document, "mutations", (evt, { mutations: mutations })=>{
            mutations.forEach((mutation)=>this._renderer.markToSync(mutation.type, mutation.node));
        }, {
            priority: "low"
        });
        this.listenTo(this.document, "mutations", ()=>{
            this.forceRender();
        }, {
            priority: "lowest"
        });
    }
    /**
	* Attaches a DOM root element to the view element and enable all observers on that element.
	* Also {@link module:engine/view/renderer~ViewRenderer#markToSync mark element} to be synchronized
	* with the view what means that all child nodes will be removed and replaced with content of the view root.
	*
	* This method also will change view element name as the same as tag name of given dom root.
	* Name is always transformed to lower case.
	*
	* **Note:** Use {@link #detachDomRoot `detachDomRoot()`} to revert this action.
	*
	* @param domRoot DOM root element.
	* @param name Name of the root.
	*/ attachDomRoot(domRoot, name = "main") {
        const viewRoot = this.document.getRoot(name);
        viewRoot._name = domRoot.tagName.toLowerCase();
        const initialDomRootAttributes = {};
        for (const { name: name, value: value } of Array.from(domRoot.attributes)){
            initialDomRootAttributes[name] = value;
            if (name === "class") this._writer.addClass(value.split(" "), viewRoot);
            else if (!viewRoot.hasAttribute(name)) this._writer.setAttribute(name, value, viewRoot);
        }
        this._initialDomRootAttributes.set(domRoot, initialDomRootAttributes);
        const updateContenteditableAttribute = ()=>{
            this._writer.setAttribute("contenteditable", (!viewRoot.isReadOnly).toString(), viewRoot);
            if (viewRoot.isReadOnly) this._writer.addClass("ck-read-only", viewRoot);
            else this._writer.removeClass("ck-read-only", viewRoot);
        };
        updateContenteditableAttribute();
        this.domRoots.set(name, domRoot);
        this.domConverter.bindElements(domRoot, viewRoot);
        this._renderer.markToSync("children", viewRoot);
        this._renderer.markToSync("attributes", viewRoot);
        this._renderer.addDomRoot(domRoot);
        viewRoot.on("change:children", (evt, node)=>this._renderer.markToSync("children", node));
        viewRoot.on("change:attributes", (evt, node)=>this._renderer.markToSync("attributes", node));
        viewRoot.on("change:text", (evt, node)=>this._renderer.markToSync("text", node));
        viewRoot.on("change:isReadOnly", ()=>this.change(updateContenteditableAttribute));
        viewRoot.on("change", ()=>{
            this._hasChangedSinceTheLastRendering = true;
        });
        for (const observer of this._observers.values())observer.observe(domRoot, name);
    }
    /**
	* Detaches a DOM root element from the view element and restores its attributes to the state before
	* {@link #attachDomRoot `attachDomRoot()`}.
	*
	* @param name Name of the root to detach.
	*/ detachDomRoot(name) {
        const domRoot = this.domRoots.get(name);
        Array.from(domRoot.attributes).forEach(({ name: name })=>domRoot.removeAttribute(name));
        const initialDomRootAttributes = this._initialDomRootAttributes.get(domRoot);
        for(const attribute in initialDomRootAttributes)domRoot.setAttribute(attribute, (0, $c7bc2cb7e2db0227$export$4703b76556f50989)(domRoot, attribute, initialDomRootAttributes[attribute]));
        this.domRoots.delete(name);
        this.domConverter.unbindDomElement(domRoot);
        this._renderer.removeDomRoot(domRoot);
        for (const observer of this._observers.values())observer.stopObserving(domRoot);
    }
    /**
	* Gets DOM root element.
	*
	* @param name  Name of the root.
	* @returns DOM root element instance.
	*/ getDomRoot(name = "main") {
        return this.domRoots.get(name);
    }
    /**
	* Creates observer of the given type if not yet created, {@link module:engine/view/observer/observer~Observer#enable enables} it
	* and {@link module:engine/view/observer/observer~Observer#observe attaches} to all existing and future
	* {@link #domRoots DOM roots}.
	*
	* Note: Observers are recognized by their constructor (classes). A single observer will be instantiated and used only
	* when registered for the first time. This means that features and other components can register a single observer
	* multiple times without caring whether it has been already added or not.
	*
	* @param ObserverConstructor The constructor of an observer to add.
	* Should create an instance inheriting from {@link module:engine/view/observer/observer~Observer}.
	* @returns Added observer instance.
	*/ addObserver(ObserverConstructor) {
        let observer = this._observers.get(ObserverConstructor);
        if (observer) return observer;
        observer = new ObserverConstructor(this);
        this._observers.set(ObserverConstructor, observer);
        for (const [name, domElement] of this.domRoots)observer.observe(domElement, name);
        observer.enable();
        return observer;
    }
    /**
	* Returns observer of the given type or `undefined` if such observer has not been added yet.
	*
	* @param ObserverConstructor The constructor of an observer to get.
	* @returns Observer instance or undefined.
	*/ getObserver(ObserverConstructor) {
        return this._observers.get(ObserverConstructor);
    }
    /**
	* Disables all added observers.
	*/ disableObservers() {
        for (const observer of this._observers.values())observer.disable();
    }
    /**
	* Enables all added observers.
	*/ enableObservers() {
        for (const observer of this._observers.values())observer.enable();
    }
    /**
	* Scrolls the page viewport and {@link #domRoots} with their ancestors to reveal the
	* caret, **if not already visible to the user**.
	*
	* **Note**: Calling this method fires the {@link module:engine/view/view~ViewScrollToTheSelectionEvent} event that
	* allows custom behaviors.
	*
	* @param options Additional configuration of the scrolling behavior.
	* @param options.viewportOffset A distance between the DOM selection and the viewport boundary to be maintained
	* while scrolling to the selection (default is 20px). Setting this value to `0` will reveal the selection precisely at
	* the viewport boundary.
	* @param options.ancestorOffset A distance between the DOM selection and scrollable DOM root ancestor(s) to be maintained
	* while scrolling to the selection (default is 20px). Setting this value to `0` will reveal the selection precisely at
	* the scrollable ancestor(s) boundary.
	* @param options.alignToTop When set `true`, the DOM selection will be aligned to the top of the viewport if not already visible
	* (see `forceScroll` to learn more).
	* @param options.forceScroll When set `true`, the DOM selection will be aligned to the top of the viewport and scrollable ancestors
	* whether it is already visible or not. This option will only work when `alignToTop` is `true`.
	*/ scrollToTheSelection({ alignToTop: alignToTop, forceScroll: forceScroll, viewportOffset: viewportOffset = 20, ancestorOffset: ancestorOffset = 20 } = {}) {
        const range = this.document.selection.getFirstRange();
        if (!range) return;
        const originalArgs = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)({
            alignToTop: alignToTop,
            forceScroll: forceScroll,
            viewportOffset: viewportOffset,
            ancestorOffset: ancestorOffset
        });
        if (typeof viewportOffset === "number") viewportOffset = {
            top: viewportOffset,
            bottom: viewportOffset,
            left: viewportOffset,
            right: viewportOffset
        };
        const options = {
            target: this.domConverter.viewRangeToDom(range),
            viewportOffset: viewportOffset,
            ancestorOffset: ancestorOffset,
            alignToTop: alignToTop,
            forceScroll: forceScroll
        };
        this.fire("scrollToTheSelection", options, originalArgs);
        (0, $c7bc2cb7e2db0227$export$a79393a569aee68b)(options);
    }
    /**
	* It will focus DOM element representing {@link module:engine/view/editableelement~ViewEditableElement ViewEditableElement}
	* that is currently having selection inside.
	*/ focus() {
        if (!this.document.isFocused) {
            const editable = this.document.selection.editableElement;
            if (editable) {
                this.domConverter.focus(editable);
                this.forceRender();
            }
        }
    }
    /**
	* The `change()` method is the primary way of changing the view. You should use it to modify any node in the view tree.
	* It makes sure that after all changes are made the view is rendered to the DOM (assuming that the view will be changed
	* inside the callback). It prevents situations when the DOM is updated when the view state is not yet correct. It allows
	* to nest calls one inside another and still performs a single rendering after all those changes are made.
	* It also returns the return value of its callback.
	*
	* ```ts
	* const text = view.change( writer => {
	* 	const newText = writer.createText( 'foo' );
	* 	writer.insert( position1, newText );
	*
	* 	view.change( writer => {
	* 		writer.insert( position2, writer.createText( 'bar' ) );
	* 	} );
	*
	* 	writer.remove( range );
	*
	* 	return newText;
	* } );
	* ```
	*
	* When the outermost change block is done and rendering to the DOM is over the
	* {@link module:engine/view/view~EditingView#event:render `View#render`} event is fired.
	*
	* This method throws a `applying-view-changes-on-rendering` error when
	* the change block is used after rendering to the DOM has started.
	*
	* @param callback Callback function which may modify the view.
	* @returns Value returned by the callback.
	*/ change(callback) {
        if (this.isRenderingInProgress || this._postFixersInProgress) /**
		* Thrown when there is an attempt to make changes to the view tree when it is in incorrect state. This may
		* cause some unexpected behaviour and inconsistency between the DOM and the view.
		* This may be caused by:
		*
		* * calling {@link module:engine/view/view~EditingView#change} or {@link module:engine/view/view~EditingView#forceRender}
		* during rendering process,
		* * calling {@link module:engine/view/view~EditingView#change} or {@link module:engine/view/view~EditingView#forceRender}
		* inside of {@link module:engine/view/document~ViewDocument#registerPostFixer post-fixer function}.
		*
		* @error cannot-change-view-tree
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("cannot-change-view-tree", this);
        try {
            if (this._ongoingChange) return callback(this._writer);
            this._ongoingChange = true;
            const callbackResult = callback(this._writer);
            this._ongoingChange = false;
            if (!this._renderingDisabled && this._hasChangedSinceTheLastRendering) {
                this._postFixersInProgress = true;
                this.document._callPostFixers(this._writer);
                this._postFixersInProgress = false;
                this.fire("render");
            }
            return callbackResult;
        } catch (err) {
            (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10).rethrowUnexpectedError(err, this);
        }
    }
    /**
	* Forces rendering {@link module:engine/view/document~ViewDocument view document} to DOM. If any view changes are
	* currently in progress, rendering will start after all {@link #change change blocks} are processed.
	*
	* Note that this method is dedicated for special cases. All view changes should be wrapped in the {@link #change}
	* block and the view will automatically check whether it needs to render DOM or not.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `applying-view-changes-on-rendering` when
	* trying to re-render when rendering to DOM has already started.
	*/ forceRender() {
        this._hasChangedSinceTheLastRendering = true;
        this.getObserver($b9b9f2bdf9c6137f$export$c14091c1727e1823).flush();
        this.change(()=>{});
    }
    /**
	* Destroys this instance. Makes sure that all observers are destroyed and listeners removed.
	*/ destroy() {
        for (const observer of this._observers.values())observer.destroy();
        this.document.destroy();
        this.stopListening();
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/view/position~ViewPosition position},
	* * parent element and offset (offset defaults to `0`),
	* * parent element and `'end'` (sets position at the end of that element),
	* * {@link module:engine/view/item~ViewItem view item} and `'before'` or `'after'` (sets position before or after given view item).
	*
	* This method is a shortcut to other constructors such as:
	*
	* * {@link #createPositionBefore},
	* * {@link #createPositionAfter},
	*
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ createPositionAt(itemOrPosition, offset) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(itemOrPosition, offset);
    }
    /**
	* Creates a new position after given view item.
	*
	* @param item View item after which the position should be located.
	*/ createPositionAfter(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item);
    }
    /**
	* Creates a new position before given view item.
	*
	* @param item View item before which the position should be located.
	*/ createPositionBefore(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item);
    }
    /**
	* Creates a range spanning from `start` position to `end` position.
	*
	* **Note:** This factory method creates it's own {@link module:engine/view/position~ViewPosition} instances basing on passed values.
	*
	* @param start Start position.
	* @param end End position. If not set, range will be collapsed at `start` position.
	*/ createRange(start, end) {
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Creates a range that starts before given {@link module:engine/view/item~ViewItem view item} and ends after it.
	*/ createRangeOn(item) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(item);
    }
    /**
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* @param element Element which is a parent for the range.
	*/ createRangeIn(element) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createIn(element);
    }
    createSelection(...args) {
        return new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(...args);
    }
    /**
	* Disables or enables rendering. If the flag is set to `true` then the rendering will be disabled.
	* If the flag is set to `false` and if there was some change in the meantime, then the rendering action will be performed.
	*
	* @internal
	* @param flag A flag indicates whether the rendering should be disabled.
	*/ _disableRendering(flag) {
        this._renderingDisabled = flag;
        if (flag == false) this.change(()=>{});
    }
    /**
	* Renders all changes. In order to avoid triggering the observers (e.g. selection) all observers are disabled
	* before rendering and re-enabled after that.
	*/ _render() {
        this.isRenderingInProgress = true;
        this.disableObservers();
        this._renderer.render();
        this.enableObservers();
        this.isRenderingInProgress = false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ var $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 = class {
    /* v8 ignore next -- @preserve */ is() {
        throw new Error("is() method is abstract");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/textproxy
*/ /**
* `ModelTextProxy` represents a part of {@link module:engine/model/text~ModelText text node}.
*
* Since {@link module:engine/model/position~ModelPosition positions} can be placed between characters of a text node,
* {@link module:engine/model/range~ModelRange ranges} may contain only parts of text nodes.
* When {@link module:engine/model/range~ModelRange#getItems getting items}
* contained in such range, we need to represent a part of that text node, since returning the whole text node would be incorrect.
* `ModelTextProxy` solves this issue.
*
* `ModelTextProxy` has an API similar to {@link module:engine/model/text~ModelText Text} and allows to do
* most of the common tasks performed on model nodes.
*
* **Note:** Some `ModelTextProxy` instances may represent whole text node, not just a part of it.
* See {@link module:engine/model/textproxy~ModelTextProxy#isPartial}.
*
* **Note:** `ModelTextProxy` is not an instance of {@link module:engine/model/node~ModelNode node}. Keep this in mind when using it as a
* parameter of methods.
*
* **Note:** `ModelTextProxy` is a readonly interface. If you want to perform changes on model data represented by a `ModelTextProxy`
* use {@link module:engine/model/writer~ModelWriter model writer API}.
*
* **Note:** `ModelTextProxy` instances are created on the fly, basing on the current state of model. Because of this, it is
* highly unrecommended to store references to `ModelTextProxy` instances. `ModelTextProxy` instances are not refreshed when
* model changes, so they might get invalidated. Instead, consider creating {@link module:engine/model/liveposition~ModelLivePosition live
* position}.
*
* `ModelTextProxy` instances are created by {@link module:engine/model/treewalker~ModelTreeWalker model tree walker}.
* You should not need to create an instance of this class by your own.
*/ var $b9b9f2bdf9c6137f$export$d28a7ac36232ea43 = class extends $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 {
    /**
	* Text node which part is represented by this text proxy.
	*/ textNode;
    /**
	* Text data represented by this text proxy.
	*/ data;
    /**
	* Offset in {@link module:engine/model/textproxy~ModelTextProxy#textNode text node} from which the text proxy starts.
	*/ offsetInText;
    /**
	* Creates a text proxy.
	*
	* @internal
	* @param textNode Text node which part is represented by this text proxy.
	* @param offsetInText Offset in {@link module:engine/model/textproxy~ModelTextProxy#textNode text node} from which the text proxy
	* starts.
	* @param length Text proxy length, that is how many text node's characters, starting from `offsetInText` it represents.
	*/ constructor(textNode, offsetInText, length){
        super();
        this.textNode = textNode;
        if (offsetInText < 0 || offsetInText > textNode.offsetSize) /**
		* Given `offsetInText` value is incorrect.
		*
		* @error model-textproxy-wrong-offsetintext
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-textproxy-wrong-offsetintext", this);
        if (length < 0 || offsetInText + length > textNode.offsetSize) /**
		* Given `length` value is incorrect.
		*
		* @error model-textproxy-wrong-length
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-textproxy-wrong-length", this);
        this.data = textNode.data.substring(offsetInText, offsetInText + length);
        this.offsetInText = offsetInText;
    }
    /**
	* Offset at which this text proxy starts in it's parent.
	*
	* @see module:engine/model/node~ModelNode#startOffset
	*/ get startOffset() {
        return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
    }
    /**
	* Offset size of this text proxy. Equal to the number of characters represented by the text proxy.
	*
	* @see module:engine/model/node~ModelNode#offsetSize
	*/ get offsetSize() {
        return this.data.length;
    }
    /**
	* Offset at which this text proxy ends in it's parent.
	*
	* @see module:engine/model/node~ModelNode#endOffset
	*/ get endOffset() {
        return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
    }
    /**
	* Flag indicating whether `ModelTextProxy` instance covers only part of the original
	* {@link module:engine/model/text~ModelText text node} (`true`) or the whole text node (`false`).
	*
	* This is `false` when text proxy starts at the very beginning of
	* {@link module:engine/model/textproxy~ModelTextProxy#textNode textNode}
	* ({@link module:engine/model/textproxy~ModelTextProxy#offsetInText offsetInText} equals `0`) and text proxy sizes is equal to
	* text node size.
	*/ get isPartial() {
        return this.offsetSize !== this.textNode.offsetSize;
    }
    /**
	* Parent of this text proxy, which is same as parent of text node represented by this text proxy.
	*/ get parent() {
        return this.textNode.parent;
    }
    /**
	* Root of this text proxy, which is same as root of text node represented by this text proxy.
	*/ get root() {
        return this.textNode.root;
    }
    /**
	* Gets path to this text proxy.
	*
	* @see module:engine/model/node~ModelNode#getPath
	*/ getPath() {
        const path = this.textNode.getPath();
        if (path.length > 0) path[path.length - 1] += this.offsetInText;
        return path;
    }
    /**
	* Returns ancestors array of this text proxy.
	*
	* @param options Options object.
	* @param options.includeSelf When set to `true` this text proxy will be also included in parent's array.
	* @param options.parentFirst When set to `true`, array will be sorted from text proxy parent to root element,
	* otherwise root element will be the first item in the array.
	* @returns Array with ancestors.
	*/ getAncestors(options = {}) {
        const ancestors = [];
        let parent = options.includeSelf ? this : this.parent;
        while(parent){
            ancestors[options.parentFirst ? "push" : "unshift"](parent);
            parent = parent.parent;
        }
        return ancestors;
    }
    /**
	* Checks if this text proxy has an attribute for given key.
	*
	* @param key Key of attribute to check.
	* @returns `true` if attribute with given key is set on text proxy, `false` otherwise.
	*/ hasAttribute(key) {
        return this.textNode.hasAttribute(key);
    }
    /**
	* Gets an attribute value for given key or `undefined` if that attribute is not set on text proxy.
	*
	* @param key Key of attribute to look for.
	* @returns Attribute value or `undefined`.
	*/ getAttribute(key) {
        return this.textNode.getAttribute(key);
    }
    /**
	* Returns iterator that iterates over this node's attributes. Attributes are returned as arrays containing two
	* items. First one is attribute key and second is attribute value.
	*
	* This format is accepted by native `Map` object and also can be passed in `Node` constructor.
	*/ getAttributes() {
        return this.textNode.getAttributes();
    }
    /**
	* Returns iterator that iterates over this node's attribute keys.
	*/ getAttributeKeys() {
        return this.textNode.getAttributeKeys();
    }
};
$b9b9f2bdf9c6137f$export$d28a7ac36232ea43.prototype.is = function(type) {
    return type === "$textProxy" || type === "model:$textProxy" || type === "textProxy" || type === "model:textProxy";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Position iterator class. It allows to iterate forward and backward over the document.
*/ var $b9b9f2bdf9c6137f$export$c24047420d7ab789 = class {
    /**
	* Walking direction. Defaults `'forward'`.
	*/ direction;
    /**
	* Iterator boundaries.
	*
	* When the iterator is walking `'forward'` on the end of boundary or is walking `'backward'`
	* on the start of boundary, then `{ done: true }` is returned.
	*
	* If boundaries are not defined they are set before first and after last child of the root node.
	*/ boundaries;
    /**
	* Flag indicating whether all consecutive characters with the same attributes should be
	* returned as one {@link module:engine/model/textproxy~ModelTextProxy} (`true`) or one by one (`false`).
	*/ singleCharacters;
    /**
	* Flag indicating whether iterator should enter elements or not. If the iterator is shallow child nodes of any
	* iterated node will not be returned along with `elementEnd` tag.
	*/ shallow;
    /**
	* Flag indicating whether iterator should ignore `elementEnd` tags. If the option is true walker will not
	* return a parent node of the start position. If this option is `true` each {@link module:engine/model/element~ModelElement} will
	* be returned once, while if the option is `false` they might be returned twice:
	* for `'elementStart'` and `'elementEnd'`.
	*/ ignoreElementEnd;
    /**
	* Iterator position. This is always static position, even if the initial position was a
	* {@link module:engine/model/liveposition~ModelLivePosition live position}. If start position is not defined then position depends
	* on {@link #direction}. If direction is `'forward'` position starts form the beginning, when direction
	* is `'backward'` position starts from the end.
	*/ _position;
    /**
	* Start boundary cached for optimization purposes.
	*/ _boundaryStartParent;
    /**
	* End boundary cached for optimization purposes.
	*/ _boundaryEndParent;
    /**
	* Parent of the most recently visited node. Cached for optimization purposes.
	*/ _visitedParent;
    /**
	* Creates a range iterator. All parameters are optional, but you have to specify either `boundaries` or `startPosition`.
	*
	* @param options Object with configuration.
	*/ constructor(options){
        if (!options || !options.boundaries && !options.startPosition) /**
		* Neither boundaries nor starting position of a `TreeWalker` have been defined.
		*
		* @error model-tree-walker-no-start-position
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-tree-walker-no-start-position", null);
        const direction = options.direction || "forward";
        if (direction != "forward" && direction != "backward") /**
		* Only `backward` and `forward` direction allowed.
		*
		* @error model-tree-walker-unknown-direction
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-tree-walker-unknown-direction", options, {
            direction: direction
        });
        this.direction = direction;
        this.boundaries = options.boundaries || null;
        if (options.startPosition) this._position = options.startPosition.clone();
        else this._position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]);
        this.position.stickiness = "toNone";
        this.singleCharacters = !!options.singleCharacters;
        this.shallow = !!options.shallow;
        this.ignoreElementEnd = !!options.ignoreElementEnd;
        this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
        this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
        this._visitedParent = this.position.parent;
    }
    /**
	* Iterable interface.
	*
	* @returns {Iterable.<module:engine/model/treewalker~ModelTreeWalkerValue>}
	*/ [Symbol.iterator]() {
        return this;
    }
    /**
	* Iterator position. This is always static position, even if the initial position was a
	* {@link module:engine/model/liveposition~ModelLivePosition live position}. If start position is not defined then position depends
	* on {@link #direction}. If direction is `'forward'` position starts form the beginning, when direction
	* is `'backward'` position starts from the end.
	*/ get position() {
        return this._position;
    }
    /**
	* Moves {@link #position} in the {@link #direction} skipping values as long as the callback function returns `true`.
	*
	* For example:
	*
	* ```ts
	* walker.skip( value => value.type == 'text' ); // <paragraph>[]foo</paragraph> -> <paragraph>foo[]</paragraph>
	* walker.skip( () => true ); // Move the position to the end: <paragraph>[]foo</paragraph> -> <paragraph>foo</paragraph>[]
	* walker.skip( () => false ); // Do not move the position.
	* ```
	*
	* @param skip Callback function. Gets {@link module:engine/model/treewalker~ModelTreeWalkerValue} and should
	* return `true` if the value should be skipped or `false` if not.
	*/ skip(skip) {
        let done, value, prevPosition, prevVisitedParent;
        do {
            prevPosition = this.position;
            prevVisitedParent = this._visitedParent;
            ({ done: done, value: value } = this.next());
        }while (!done && skip(value));
        if (!done) {
            this._position = prevPosition;
            this._visitedParent = prevVisitedParent;
        }
    }
    /**
	* Moves tree walker {@link #position} to provided `position`. Tree walker will
	* continue traversing from that position.
	*
	* Note: in contrary to {@link ~ModelTreeWalker#skip}, this method does not iterate over the nodes along the way.
	* It simply sets the current tree walker position to a new one.
	* From the performance standpoint, it is better to use {@link ~ModelTreeWalker#jumpTo} rather than {@link ~ModelTreeWalker#skip}.
	*
	* If the provided position is before the start boundary, the position will be
	* set to the start boundary. If the provided position is after the end boundary,
	* the position will be set to the end boundary.
	* This is done to prevent the treewalker from traversing outside the boundaries.
	*
	* @param position Position to jump to.
	*/ jumpTo(position) {
        if (this._boundaryStartParent && position.isBefore(this.boundaries.start)) position = this.boundaries.start;
        else if (this._boundaryEndParent && position.isAfter(this.boundaries.end)) position = this.boundaries.end;
        this._position = position.clone();
        this._visitedParent = position.parent;
    }
    /**
	* Gets the next tree walker's value.
	*/ next() {
        if (this.direction == "forward") return this._next();
        else return this._previous();
    }
    /**
	* Makes a step forward in model. Moves the {@link #position} to the next position and returns the encountered value.
	*/ _next() {
        const previousPosition = this.position;
        const position = this.position.clone();
        const parent = this._visitedParent;
        if (parent.parent === null && position.offset === parent.maxOffset) return {
            done: true,
            value: void 0
        };
        if (parent === this._boundaryEndParent && position.offset == this.boundaries.end.offset) return {
            done: true,
            value: void 0
        };
        const textNodeAtPosition = $b9b9f2bdf9c6137f$export$2993b130367a4c05(position, parent);
        const node = textNodeAtPosition || $b9b9f2bdf9c6137f$export$1c6e0df08fc5fdd1(position, parent, textNodeAtPosition);
        if (node && node.is("model:element")) {
            if (!this.shallow) {
                position.path.push(0);
                this._visitedParent = node;
            } else {
                if (this.boundaries && this.boundaries.end.isBefore(position)) return {
                    done: true,
                    value: void 0
                };
                position.offset++;
            }
            this._position = position;
            return $b9b9f2bdf9c6137f$var$formatReturnValue("elementStart", node, previousPosition, position, 1);
        }
        if (node && node.is("model:$text")) {
            let charactersCount;
            if (this.singleCharacters) charactersCount = 1;
            else {
                let offset = node.endOffset;
                if (this._boundaryEndParent == parent && this.boundaries.end.offset < offset) offset = this.boundaries.end.offset;
                charactersCount = offset - position.offset;
            }
            const offsetInTextNode = position.offset - node.startOffset;
            const item = new $b9b9f2bdf9c6137f$export$d28a7ac36232ea43(node, offsetInTextNode, charactersCount);
            position.offset += charactersCount;
            this._position = position;
            return $b9b9f2bdf9c6137f$var$formatReturnValue("text", item, previousPosition, position, charactersCount);
        }
        position.path.pop();
        position.offset++;
        this._position = position;
        this._visitedParent = parent.parent;
        if (this.ignoreElementEnd) return this._next();
        return $b9b9f2bdf9c6137f$var$formatReturnValue("elementEnd", parent, previousPosition, position);
    }
    /**
	* Makes a step backward in model. Moves the {@link #position} to the previous position and returns the encountered value.
	*/ _previous() {
        const previousPosition = this.position;
        const position = this.position.clone();
        const parent = this._visitedParent;
        if (parent.parent === null && position.offset === 0) return {
            done: true,
            value: void 0
        };
        if (parent == this._boundaryStartParent && position.offset == this.boundaries.start.offset) return {
            done: true,
            value: void 0
        };
        const positionParent = position.parent;
        const textNodeAtPosition = $b9b9f2bdf9c6137f$export$2993b130367a4c05(position, positionParent);
        const node = textNodeAtPosition || $b9b9f2bdf9c6137f$export$ae43360a5a8e79d7(position, positionParent, textNodeAtPosition);
        if (node && node.is("model:element")) {
            position.offset--;
            if (this.shallow) {
                this._position = position;
                return $b9b9f2bdf9c6137f$var$formatReturnValue("elementStart", node, previousPosition, position, 1);
            }
            position.path.push(node.maxOffset);
            this._position = position;
            this._visitedParent = node;
            if (this.ignoreElementEnd) return this._previous();
            return $b9b9f2bdf9c6137f$var$formatReturnValue("elementEnd", node, previousPosition, position);
        }
        if (node && node.is("model:$text")) {
            let charactersCount;
            if (this.singleCharacters) charactersCount = 1;
            else {
                let offset = node.startOffset;
                if (this._boundaryStartParent == parent && this.boundaries.start.offset > offset) offset = this.boundaries.start.offset;
                charactersCount = position.offset - offset;
            }
            const offsetInTextNode = position.offset - node.startOffset;
            const item = new $b9b9f2bdf9c6137f$export$d28a7ac36232ea43(node, offsetInTextNode - charactersCount, charactersCount);
            position.offset -= charactersCount;
            this._position = position;
            return $b9b9f2bdf9c6137f$var$formatReturnValue("text", item, previousPosition, position, charactersCount);
        }
        position.path.pop();
        this._position = position;
        this._visitedParent = parent.parent;
        return $b9b9f2bdf9c6137f$var$formatReturnValue("elementStart", parent, previousPosition, position, 1);
    }
};
function $b9b9f2bdf9c6137f$var$formatReturnValue(type, item, previousPosition, nextPosition, length) {
    return {
        done: false,
        value: {
            type: type,
            item: item,
            previousPosition: previousPosition,
            nextPosition: nextPosition,
            length: length
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/position
*/ /**
* Represents a position in the model tree.
*
* A position is represented by its {@link module:engine/model/position~ModelPosition#root} and
* a {@link module:engine/model/position~ModelPosition#path} in that root.
*
* You can create position instances via its constructor or the `createPosition*()` factory methods of
* {@link module:engine/model/model~Model} and {@link module:engine/model/writer~ModelWriter}.
*
* **Note:** Position is based on offsets, not indexes. This means that a position between two text nodes
* `foo` and `bar` has offset `3`, not `1`. See {@link module:engine/model/position~ModelPosition#path} for more information.
*
* Since a position in the model is represented by a {@link module:engine/model/position~ModelPosition#root position root} and
* {@link module:engine/model/position~ModelPosition#path position path} it is possible to create positions placed in non-existing places.
* This requirement is important for operational transformation algorithms.
*
* Also, {@link module:engine/model/operation/operation~Operation operations}
* kept in the {@link module:engine/model/document~ModelDocument#history document history}
* are storing positions (and ranges) which were correct when those operations were applied, but may not be correct
* after the document has changed.
*
* When changes are applied to the model, it may also happen that {@link module:engine/model/position~ModelPosition#parent position parent}
* will change even if position path has not changed. Keep in mind, that if a position leads to non-existing element,
* {@link module:engine/model/position~ModelPosition#parent} and some other properties and methods will throw errors.
*
* In most cases, position with wrong path is caused by an error in code, but it is sometimes needed, as described above.
*/ var $b9b9f2bdf9c6137f$export$86023cc9eabef192 = class ModelPosition extends $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 {
    /**
	* Root of the position path.
	*/ root;
    /**
	* Position of the node in the tree. **Path contains offsets, not indexes.**
	*
	* Position can be placed before, after or in a {@link module:engine/model/node~ModelNode node} if that node has
	* {@link module:engine/model/node~ModelNode#offsetSize} greater than `1`. Items in position path are
	* {@link module:engine/model/node~ModelNode#startOffset starting offsets} of position ancestors, starting from direct root children,
	* down to the position offset in it's parent.
	*
	* ```
	* ROOT
	*  |- P            before: [ 0 ]         after: [ 1 ]
	*  |- UL           before: [ 1 ]         after: [ 2 ]
	*     |- LI        before: [ 1, 0 ]      after: [ 1, 1 ]
	*     |  |- foo    before: [ 1, 0, 0 ]   after: [ 1, 0, 3 ]
	*     |- LI        before: [ 1, 1 ]      after: [ 1, 2 ]
	*        |- bar    before: [ 1, 1, 0 ]   after: [ 1, 1, 3 ]
	* ```
	*
	* `foo` and `bar` are representing {@link module:engine/model/text~ModelText text nodes}. Since text nodes has offset size
	* greater than `1` you can place position offset between their start and end:
	*
	* ```
	* ROOT
	*  |- P
	*  |- UL
	*     |- LI
	*     |  |- f^o|o  ^ has path: [ 1, 0, 1 ]   | has path: [ 1, 0, 2 ]
	*     |- LI
	*        |- b^a|r  ^ has path: [ 1, 1, 1 ]   | has path: [ 1, 1, 2 ]
	* ```
	*/ path;
    /**
	* Position stickiness. See {@link module:engine/model/position~ModelPositionStickiness}.
	*/ stickiness;
    /**
	* Creates a position.
	*
	* @param root Root of the position.
	* @param path Position path. See {@link module:engine/model/position~ModelPosition#path}.
	* @param stickiness Position stickiness. See {@link module:engine/model/position~ModelPositionStickiness}.
	*/ constructor(root, path, stickiness = "toNone"){
        super();
        if (!root.is("element") && !root.is("documentFragment")) /**
		* Position root is invalid.
		*
		* Positions can only be anchored in elements or document fragments.
		*
		* @error model-position-root-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-root-invalid", root);
        if (!Array.isArray(path) || path.length === 0) /**
		* Position path must be an array with at least one item.
		*
		* @error model-position-path-incorrect-format
		* @param {Array.<number>} path A path to the position.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-path-incorrect-format", root, {
            path: path
        });
        if (root.is("rootElement")) path = path.slice();
        else {
            path = [
                ...root.getPath(),
                ...path
            ];
            root = root.root;
        }
        this.root = root;
        this.path = path;
        this.stickiness = stickiness;
    }
    /**
	* Offset at which this position is located in its {@link module:engine/model/position~ModelPosition#parent parent}. It is equal
	* to the last item in position {@link module:engine/model/position~ModelPosition#path path}.
	*
	* @type {Number}
	*/ get offset() {
        return this.path[this.path.length - 1];
    }
    set offset(newOffset) {
        this.path[this.path.length - 1] = newOffset;
    }
    /**
	* Parent element of this position.
	*
	* Keep in mind that `parent` value is calculated when the property is accessed.
	* If {@link module:engine/model/position~ModelPosition#path position path}
	* leads to a non-existing element, `parent` property will throw error.
	*
	* Also it is a good idea to cache `parent` property if it is used frequently in an algorithm (i.e. in a long loop).
	*/ get parent() {
        let parent = this.root;
        for(let i = 0; i < this.path.length - 1; i++){
            parent = parent.getChildAtOffset(this.path[i]);
            if (!parent) /**
			* The position's path is incorrect. This means that a position does not point to
			* a correct place in the tree and hence, some of its methods and getters cannot work correctly.
			*
			* **Note**: Unlike DOM and view positions, in the model, the
			* {@link module:engine/model/position~ModelPosition#parent position's parent} is always an element or a document fragment.
			* The last offset in the
			* {@link module:engine/model/position~ModelPosition#path position's path} is the point in this element
			* where this position points.
			*
			* Read more about model positions and offsets in
			* the {@glink framework/architecture/editing-engine#indexes-and-offsets Editing engine architecture} guide.
			*
			* @error model-position-path-incorrect
			* @param {module:engine/model/position~ModelPosition} position The incorrect position.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-path-incorrect", this, {
                position: this
            });
        }
        if (parent.is("$text")) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-path-incorrect", this, {
            position: this
        });
        return parent;
    }
    /**
	* Position {@link module:engine/model/position~ModelPosition#offset offset} converted to an index in position's parent node. It is
	* equal to the {@link module:engine/model/node~ModelNode#index index} of a node after this position. If position is placed
	* in text node, position index is equal to the index of that text node.
	*/ get index() {
        return this.parent.offsetToIndex(this.offset);
    }
    /**
	* Returns {@link module:engine/model/text~ModelText text node} instance in which this position is placed or `null` if this
	* position is not in a text node.
	*/ get textNode() {
        return $b9b9f2bdf9c6137f$export$2993b130367a4c05(this, this.parent);
    }
    /**
	* Node directly after this position. Returns `null` if this position is at the end of its parent, or if it is in a text node.
	*/ get nodeAfter() {
        const parent = this.parent;
        return $b9b9f2bdf9c6137f$export$1c6e0df08fc5fdd1(this, parent, $b9b9f2bdf9c6137f$export$2993b130367a4c05(this, parent));
    }
    /**
	* Node directly before this position. Returns `null` if this position is at the start of its parent, or if it is in a text node.
	*/ get nodeBefore() {
        const parent = this.parent;
        return $b9b9f2bdf9c6137f$export$ae43360a5a8e79d7(this, parent, $b9b9f2bdf9c6137f$export$2993b130367a4c05(this, parent));
    }
    /**
	* Is `true` if position is at the beginning of its {@link module:engine/model/position~ModelPosition#parent parent}, `false` otherwise.
	*/ get isAtStart() {
        return this.offset === 0;
    }
    /**
	* Is `true` if position is at the end of its {@link module:engine/model/position~ModelPosition#parent parent}, `false` otherwise.
	*/ get isAtEnd() {
        return this.offset == this.parent.maxOffset;
    }
    /**
	* Checks whether the position is valid in current model tree, that is whether it points to an existing place in the model.
	*/ isValid() {
        if (this.offset < 0) return false;
        let parent = this.root;
        for(let i = 0; i < this.path.length - 1; i++){
            parent = parent.getChildAtOffset(this.path[i]);
            if (!parent) return false;
        }
        return this.offset <= parent.maxOffset;
    }
    /**
	* Checks whether this position is before or after given position.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*/ compareWith(otherPosition) {
        if (this.root != otherPosition.root) return "different";
        const result = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(this.path, otherPosition.path);
        switch(result){
            case "same":
                return "same";
            case "prefix":
                return "before";
            case "extension":
                return "after";
            default:
                return this.path[result] < otherPosition.path[result] ? "before" : "after";
        }
    }
    /**
	* Gets the farthest position which matches the callback using
	* {@link module:engine/model/treewalker~ModelTreeWalker TreeWalker}.
	*
	* For example:
	*
	* ```ts
	* getLastMatchingPosition( value => value.type == 'text' );
	* // <paragraph>[]foo</paragraph> -> <paragraph>foo[]</paragraph>
	*
	* getLastMatchingPosition( value => value.type == 'text', { direction: 'backward' } );
	* // <paragraph>foo[]</paragraph> -> <paragraph>[]foo</paragraph>
	*
	* getLastMatchingPosition( value => false );
	* // Do not move the position.
	* ```
	*
	* @param skip Callback function. Gets {@link module:engine/model/treewalker~ModelTreeWalkerValue} and should
	* return `true` if the value should be skipped or `false` if not.
	* @param options Object with configuration options. See {@link module:engine/model/treewalker~ModelTreeWalker}.
	*
	* @returns The position after the last item which matches the `skip` callback test.
	*/ getLastMatchingPosition(skip, options = {}) {
        options.startPosition = this;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789(options);
        treeWalker.skip(skip);
        return treeWalker.position;
    }
    /**
	* Returns a path to this position's parent. Parent path is equal to position
	* {@link module:engine/model/position~ModelPosition#path path} but without the last item.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @returns Path to the parent.
	*/ getParentPath() {
        return this.path.slice(0, -1);
    }
    /**
	* Returns ancestors array of this position, that is this position's parent and its ancestors.
	*
	* @returns Array with ancestors.
	*/ getAncestors() {
        const parent = this.parent;
        if (parent.is("documentFragment")) return [
            parent
        ];
        else return parent.getAncestors({
            includeSelf: true
        });
    }
    /**
	* Returns the parent element of the given name. Returns null if the position is not inside the desired parent.
	*
	* @param parentName The name of the parent element to find.
	*/ findAncestor(parentName) {
        const parent = this.parent;
        if (parent.is("element")) return parent.findAncestor(parentName, {
            includeSelf: true
        });
        return null;
    }
    /**
	* Returns the slice of two position {@link #path paths} which is identical. The {@link #root roots}
	* of these two paths must be identical.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param position The second position.
	* @returns The common path.
	*/ getCommonPath(position) {
        if (this.root != position.root) return [];
        const cmp = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(this.path, position.path);
        const diffAt = typeof cmp == "string" ? Math.min(this.path.length, position.path.length) : cmp;
        return this.path.slice(0, diffAt);
    }
    /**
	* Returns an {@link module:engine/model/element~ModelElement} or {@link module:engine/model/documentfragment~ModelDocumentFragment}
	* which is a common ancestor of both positions. The {@link #root roots} of these two positions must be identical.
	*
	* @param position The second position.
	*/ getCommonAncestor(position) {
        const ancestorsA = this.getAncestors();
        const ancestorsB = position.getAncestors();
        let i = 0;
        while(ancestorsA[i] == ancestorsB[i] && ancestorsA[i])i++;
        return i === 0 ? null : ancestorsA[i - 1];
    }
    /**
	* Returns a new instance of `Position`, that has same {@link #parent parent} but it's offset
	* is shifted by `shift` value (can be a negative value).
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param shift Offset shift. Can be a negative value.
	* @returns Shifted position.
	*/ getShiftedBy(shift) {
        const shifted = this.clone();
        const offset = shifted.offset + shift;
        shifted.offset = offset < 0 ? 0 : offset;
        return shifted;
    }
    /**
	* Checks whether this position is after given position.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @see module:engine/model/position~ModelPosition#isBefore
	* @param  otherPosition Position to compare with.
	* @returns True if this position is after given position.
	*/ isAfter(otherPosition) {
        return this.compareWith(otherPosition) == "after";
    }
    /**
	* Checks whether this position is before given position.
	*
	* **Note:** watch out when using negation of the value returned by this method, because the negation will also
	* be `true` if positions are in different roots and you might not expect this. You should probably use
	* `a.isAfter( b ) || a.isEqual( b )` or `!a.isBefore( p ) && a.root == b.root` in most scenarios. If your
	* condition uses multiple `isAfter` and `isBefore` checks, build them so they do not use negated values, i.e.:
	*
	* ```ts
	* if ( a.isBefore( b ) && c.isAfter( d ) ) {
	* 	// do A.
	* } else {
	* 	// do B.
	* }
	* ```
	*
	* or, if you have only one if-branch:
	*
	* ```ts
	* if ( !( a.isBefore( b ) && c.isAfter( d ) ) {
	* 	// do B.
	* }
	* ```
	*
	* rather than:
	*
	* ```ts
	* if ( !a.isBefore( b ) || && !c.isAfter( d ) ) {
	* 	// do B.
	* } else {
	* 	// do A.
	* }
	* ```
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param otherPosition Position to compare with.
	* @returns True if this position is before given position.
	*/ isBefore(otherPosition) {
        return this.compareWith(otherPosition) == "before";
    }
    /**
	* Checks whether this position is equal to given position.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param otherPosition Position to compare with.
	* @returns True if positions are same.
	*/ isEqual(otherPosition) {
        return this.compareWith(otherPosition) == "same";
    }
    /**
	* Checks whether this position is touching given position. Positions touch when there are no text nodes
	* or empty nodes in a range between them. Technically, those positions are not equal but in many cases
	* they are very similar or even indistinguishable.
	*
	* @param otherPosition Position to compare with.
	* @returns True if positions touch.
	*/ isTouching(otherPosition) {
        if (this.root !== otherPosition.root) return false;
        const commonLevel = Math.min(this.path.length, otherPosition.path.length);
        for(let level = 0; level < commonLevel; level++){
            const diff = this.path[level] - otherPosition.path[level];
            if (diff < -1 || diff > 1) return false;
            else if (diff === 1) return $b9b9f2bdf9c6137f$var$checkTouchingBranch(otherPosition, this, level);
            else if (diff === -1) return $b9b9f2bdf9c6137f$var$checkTouchingBranch(this, otherPosition, level);
        }
        if (this.path.length === otherPosition.path.length) return true;
        else if (this.path.length > otherPosition.path.length) return $b9b9f2bdf9c6137f$var$checkOnlyZeroes(this.path, commonLevel);
        else return $b9b9f2bdf9c6137f$var$checkOnlyZeroes(otherPosition.path, commonLevel);
    }
    /**
	* Checks if two positions are in the same parent.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param position Position to compare with.
	* @returns `true` if positions have the same parent, `false` otherwise.
	*/ hasSameParentAs(position) {
        if (this.root !== position.root) return false;
        const thisParentPath = this.getParentPath();
        const posParentPath = position.getParentPath();
        return (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(thisParentPath, posParentPath) == "same";
    }
    /**
	* Returns a copy of this position that is transformed by given `operation`.
	*
	* The new position's parameters are updated accordingly to the effect of the `operation`.
	*
	* For example, if `n` nodes are inserted before the position, the returned position {@link ~ModelPosition#offset} will be
	* increased by `n`. If the position was in a merged element, it will be accordingly moved to the new element, etc.
	*
	* This method is safe to use it on non-existing positions (for example during operational transformation).
	*
	* @param operation Operation to transform by.
	* @returns Transformed position.
	*/ getTransformedByOperation(operation) {
        let result;
        switch(operation.type){
            case "insert":
                result = this._getTransformedByInsertOperation(operation);
                break;
            case "move":
            case "remove":
            case "reinsert":
                result = this._getTransformedByMoveOperation(operation);
                break;
            case "split":
                result = this._getTransformedBySplitOperation(operation);
                break;
            case "merge":
                result = this._getTransformedByMergeOperation(operation);
                break;
            case "detach":
                result = this._getTransformedByDetachOperation(operation);
                break;
            default:
                result = ModelPosition._createAt(this);
        }
        return result;
    }
    /**
	* Returns a copy of this position transformed by a detach operation.
	*
	* @internal
	*/ _getTransformedByDetachOperation(operation) {
        return this._getTransformedByDeletion(operation.sourcePosition, operation.howMany) || ModelPosition._createAt(operation.sourcePosition);
    }
    /**
	* Returns a copy of this position transformed by an insert operation.
	*
	* @internal
	*/ _getTransformedByInsertOperation(operation) {
        return this._getTransformedByInsertion(operation.position, operation.howMany);
    }
    /**
	* Returns a copy of this position transformed by a move operation.
	*
	* @internal
	*/ _getTransformedByMoveOperation(operation) {
        return this._getTransformedByMove(operation.sourcePosition, operation.targetPosition, operation.howMany);
    }
    /**
	* Returns a copy of this position transformed by a split operation.
	*
	* @internal
	*/ _getTransformedBySplitOperation(operation) {
        const movedRange = operation.movedRange;
        if (movedRange.containsPosition(this) || movedRange.start.isEqual(this) && this.stickiness == "toNext") return this._getCombined(operation.splitPosition, operation.moveTargetPosition);
        else if (operation.graveyardPosition) return this._getTransformedByMove(operation.graveyardPosition, operation.insertionPosition, 1);
        else return this._getTransformedByInsertion(operation.insertionPosition, 1);
    }
    /**
	* Returns a copy of this position transformed by merge operation.
	*
	* @internal
	*/ _getTransformedByMergeOperation(operation) {
        const movedRange = operation.movedRange;
        const isContained = movedRange.containsPosition(this) || movedRange.start.isEqual(this);
        let pos;
        if (isContained) {
            pos = this._getCombined(operation.sourcePosition, operation.targetPosition);
            if (operation.sourcePosition.isBefore(operation.targetPosition)) pos = pos._getTransformedByDeletion(operation.deletionPosition, 1);
        } else if (this.isEqual(operation.deletionPosition)) pos = ModelPosition._createAt(operation.deletionPosition);
        else pos = this._getTransformedByMove(operation.deletionPosition, operation.graveyardPosition, 1);
        return pos;
    }
    /**
	* Returns a copy of this position that is updated by removing `howMany` nodes starting from `deletePosition`.
	* It may happen that this position is in a removed node. If that is the case, `null` is returned instead.
	*
	* @internal
	* @param deletePosition Position before the first removed node.
	* @param howMany How many nodes are removed.
	* @returns Transformed position or `null`.
	*/ _getTransformedByDeletion(deletePosition, howMany) {
        const transformed = ModelPosition._createAt(this);
        if (this.root != deletePosition.root) return transformed;
        if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(deletePosition.getParentPath(), this.getParentPath()) == "same") {
            if (deletePosition.offset < this.offset) {
                if (deletePosition.offset + howMany > this.offset) return null;
                else transformed.offset -= howMany;
            }
        } else if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(deletePosition.getParentPath(), this.getParentPath()) == "prefix") {
            const i = deletePosition.path.length - 1;
            if (deletePosition.offset <= this.path[i]) {
                if (deletePosition.offset + howMany > this.path[i]) return null;
                else transformed.path[i] -= howMany;
            }
        }
        return transformed;
    }
    /**
	* Returns a copy of this position that is updated by inserting `howMany` nodes at `insertPosition`.
	*
	* @internal
	* @param insertPosition Position where nodes are inserted.
	* @param howMany How many nodes are inserted.
	* @returns Transformed position.
	*/ _getTransformedByInsertion(insertPosition, howMany) {
        const transformed = ModelPosition._createAt(this);
        if (this.root != insertPosition.root) return transformed;
        if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(insertPosition.getParentPath(), this.getParentPath()) == "same") {
            if (insertPosition.offset < this.offset || insertPosition.offset == this.offset && this.stickiness != "toPrevious") transformed.offset += howMany;
        } else if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(insertPosition.getParentPath(), this.getParentPath()) == "prefix") {
            const i = insertPosition.path.length - 1;
            if (insertPosition.offset <= this.path[i]) transformed.path[i] += howMany;
        }
        return transformed;
    }
    /**
	* Returns a copy of this position that is updated by moving `howMany` nodes from `sourcePosition` to `targetPosition`.
	*
	* @internal
	* @param sourcePosition Position before the first element to move.
	* @param targetPosition Position where moved elements will be inserted.
	* @param howMany How many consecutive nodes to move, starting from `sourcePosition`.
	* @returns Transformed position.
	*/ _getTransformedByMove(sourcePosition, targetPosition, howMany) {
        targetPosition = targetPosition._getTransformedByDeletion(sourcePosition, howMany);
        if (sourcePosition.isEqual(targetPosition)) return ModelPosition._createAt(this);
        const transformed = this._getTransformedByDeletion(sourcePosition, howMany);
        if (transformed === null || sourcePosition.isEqual(this) && this.stickiness == "toNext" || sourcePosition.getShiftedBy(howMany).isEqual(this) && this.stickiness == "toPrevious") return this._getCombined(sourcePosition, targetPosition);
        else return transformed._getTransformedByInsertion(targetPosition, howMany);
    }
    /**
	* Returns a new position that is a combination of this position and given positions.
	*
	* The combined position is a copy of this position transformed by moving a range starting at `source` position
	* to the `target` position. It is expected that this position is inside the moved range.
	*
	* Example:
	*
	* ```ts
	* let original = model.createPositionFromPath( root, [ 2, 3, 1 ] );
	* let source = model.createPositionFromPath( root, [ 2, 2 ] );
	* let target = model.createPositionFromPath( otherRoot, [ 1, 1, 3 ] );
	* original._getCombined( source, target ); // path is [ 1, 1, 4, 1 ], root is `otherRoot`
	* ```
	*
	* Explanation:
	*
	* We have a position `[ 2, 3, 1 ]` and move some nodes from `[ 2, 2 ]` to `[ 1, 1, 3 ]`. The original position
	* was inside moved nodes and now should point to the new place. The moved nodes will be after
	* positions `[ 1, 1, 3 ]`, `[ 1, 1, 4 ]`, `[ 1, 1, 5 ]`. Since our position was in the second moved node,
	* the transformed position will be in a sub-tree of a node at `[ 1, 1, 4 ]`. Looking at original path, we
	* took care of `[ 2, 3 ]` part of it. Now we have to add the rest of the original path to the transformed path.
	* Finally, the transformed position will point to `[ 1, 1, 4, 1 ]`.
	*
	* @internal
	* @param source Beginning of the moved range.
	* @param target Position where the range is moved.
	* @returns Combined position.
	*/ _getCombined(source, target) {
        const i = source.path.length - 1;
        const combined = ModelPosition._createAt(target);
        combined.stickiness = this.stickiness;
        combined.offset = combined.offset + this.path[i] - source.offset;
        combined.path = [
            ...combined.path,
            ...this.path.slice(i + 1)
        ];
        return combined;
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
        };
    }
    /**
	* Returns a new position that is equal to current position.
	*/ clone() {
        return new this.constructor(this.root, this.path, this.stickiness);
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/model/position~ModelPosition position},
	* * parent element and offset (offset defaults to `0`),
	* * parent element and `'end'` (sets position at the end of that element),
	* * {@link module:engine/model/item~ModelItem model item} and `'before'` or `'after'` (sets position before or after given model item).
	*
	* This method is a shortcut to other factory methods such as:
	*
	* * {@link module:engine/model/position~ModelPosition._createBefore},
	* * {@link module:engine/model/position~ModelPosition._createAfter}.
	*
	* @internal
	* @param offset Offset or one of the flags. Used only when the first parameter
	* is a {@link module:engine/model/item~ModelItem model item}.
	* @param stickiness Position stickiness. Used only when the first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ static _createAt(itemOrPosition, offset, stickiness = "toNone") {
        if (itemOrPosition.is("model:position")) return new ModelPosition(itemOrPosition.root, itemOrPosition.path, itemOrPosition.stickiness);
        else {
            const node = itemOrPosition;
            if (offset == "end") offset = node.maxOffset;
            else if (offset == "before") return this._createBefore(node, stickiness);
            else if (offset == "after") return this._createAfter(node, stickiness);
            else if (offset !== 0 && !offset) /**
			* {@link module:engine/model/model~Model#createPositionAt `Model#createPositionAt()`}
			* requires the offset to be specified when the first parameter is a model item.
			*
			* @error model-createpositionat-offset-required
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-createpositionat-offset-required", [
                this,
                itemOrPosition
            ]);
            if (!node.is("element") && !node.is("documentFragment")) /**
			* Position parent have to be a model element or model document fragment.
			*
			* @error model-position-parent-incorrect
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-parent-incorrect", [
                this,
                itemOrPosition
            ]);
            const path = node.getPath();
            path.push(offset);
            return new this(node.root, path, stickiness);
        }
    }
    /**
	* Creates a new position, after given {@link module:engine/model/item~ModelItem model item}.
	*
	* @internal
	* @param item Item after which the position should be placed.
	* @param stickiness Position stickiness.
	*/ static _createAfter(item, stickiness) {
        if (!item.parent) /**
		* You cannot make a position after a root element.
		*
		* @error model-position-after-root
		* @param {module:engine/model/rootelement~ModelRootElement} root The root element..
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-after-root", [
            this,
            item
        ], {
            root: item
        });
        return this._createAt(item.parent, item.endOffset, stickiness);
    }
    /**
	* Creates a new position, before the given {@link module:engine/model/item~ModelItem model item}.
	*
	* @internal
	* @param item Item before which the position should be placed.
	* @param stickiness Position stickiness.
	*/ static _createBefore(item, stickiness) {
        if (!item.parent) /**
		* You cannot make a position before a root element.
		*
		* @error model-position-before-root
		* @param {module:engine/model/rootelement~ModelRootElement} root The root element..
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-before-root", item, {
            root: item
        });
        return this._createAt(item.parent, item.startOffset, stickiness);
    }
    /**
	* Creates a `Position` instance from given plain object (i.e. parsed JSON string).
	*
	* @param json Plain object to be converted to `Position`.
	* @param doc Document object that will be position owner.
	* @returns `Position` instance created using given plain object.
	*/ static fromJSON(json, doc) {
        if (json.root === "$graveyard") {
            const pos = new ModelPosition(doc.graveyard, json.path);
            pos.stickiness = json.stickiness;
            return pos;
        }
        if (!doc.getRoot(json.root)) /**
		* Cannot create position for document. Root with specified name does not exist.
		*
		* @error model-position-fromjson-no-root
		* @param {string} rootName The root name.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-position-fromjson-no-root", doc, {
            rootName: json.root
        });
        return new ModelPosition(doc.getRoot(json.root), json.path, json.stickiness);
    }
};
$b9b9f2bdf9c6137f$export$86023cc9eabef192.prototype.is = function(type) {
    return type === "position" || type === "model:position";
};
/**
* Returns a text node at the given position.
*
* This is a helper function optimized to reuse the position parent instance for performance reasons.
*
* Normally, you should use {@link module:engine/model/position~ModelPosition#textNode `Position#textNode`}.
* If you start hitting performance issues with {@link module:engine/model/position~ModelPosition#parent `Position#parent`}
* check if your algorithm does not access it multiple times (which can happen directly or indirectly via other position properties).
*
* See https://github.com/ckeditor/ckeditor5/issues/6579.
*
* See also:
*
* * {@link module:engine/model/position~getNodeAfterPosition}
* * {@link module:engine/model/position~getNodeBeforePosition}
*
* @param position
* @param positionParent The parent of the given position.
* @internal
*/ function $b9b9f2bdf9c6137f$export$2993b130367a4c05(position, positionParent) {
    const node = positionParent.getChildAtOffset(position.offset);
    if (node && node.is("$text") && node.startOffset < position.offset) return node;
    return null;
}
/**
* Returns the node after the given position.
*
* This is a helper function optimized to reuse the position parent instance and the calculation of the text node at the
* specific position for performance reasons.
*
* Normally, you should use {@link module:engine/model/position~ModelPosition#nodeAfter `Position#nodeAfter`}.
* If you start hitting performance issues with {@link module:engine/model/position~ModelPosition#parent `Position#parent`} and/or
* {@link module:engine/model/position~ModelPosition#textNode `Position#textNode`}
* check if your algorithm does not access those properties multiple times
* (which can happen directly or indirectly via other position properties).
*
* See https://github.com/ckeditor/ckeditor5/issues/6579 and https://github.com/ckeditor/ckeditor5/issues/6582.
*
* See also:
*
* * {@link module:engine/model/position~getTextNodeAtPosition}
* * {@link module:engine/model/position~getNodeBeforePosition}
*
* @param position Position to check.
* @param positionParent The parent of the given position.
* @param textNode Text node at the given position.
* @internal
*/ function $b9b9f2bdf9c6137f$export$1c6e0df08fc5fdd1(position, positionParent, textNode) {
    if (textNode !== null) return null;
    return positionParent.getChildAtOffset(position.offset);
}
/**
* Returns the node before the given position.
*
* Refer to {@link module:engine/model/position~getNodeBeforePosition} for documentation on when to use this util method.
*
* See also:
*
* * {@link module:engine/model/position~getTextNodeAtPosition}
* * {@link module:engine/model/position~getNodeAfterPosition}
*
* @param position Position to check.
* @param positionParent The parent of the given position.
* @param textNode Text node at the given position.
* @internal
*/ function $b9b9f2bdf9c6137f$export$ae43360a5a8e79d7(position, positionParent, textNode) {
    if (textNode !== null) return null;
    return positionParent.getChild(positionParent.offsetToIndex(position.offset) - 1);
}
/**
* This is a helper function for `Position#isTouching()`.
*
* It checks whether to given positions are touching, considering that they have the same root and paths
* until given level, and at given level they differ by 1 (so they are branching at `level` point).
*
* The exact requirements for touching positions are described in `Position#isTouching()` and also
* in the body of this function.
*
* @param left Position "on the left" (it is before `right`).
* @param right Position "on the right" (it is after `left`).
* @param level Level on which the positions are different.
*/ function $b9b9f2bdf9c6137f$var$checkTouchingBranch(left, right, level) {
    if (level + 1 === left.path.length) return false;
    if (!$b9b9f2bdf9c6137f$var$checkOnlyZeroes(right.path, level + 1)) return false;
    if (!$b9b9f2bdf9c6137f$var$checkOnlyMaxOffset(left, level + 1)) return false;
    return true;
}
/**
* Checks whether for given array, starting from given index until the end of the array, all items are `0`s.
*
* This is a helper function for `Position#isTouching()`.
*/ function $b9b9f2bdf9c6137f$var$checkOnlyZeroes(arr, idx) {
    while(idx < arr.length){
        if (arr[idx] !== 0) return false;
        idx++;
    }
    return true;
}
/**
* Checks whether for given position, starting from given path level, whether the position is at the end of
* its parent and whether each element on the path to the position is also at at the end of its parent.
*
* This is a helper function for `Position#isTouching()`.
*/ function $b9b9f2bdf9c6137f$var$checkOnlyMaxOffset(pos, level) {
    let parent = pos.parent;
    let idx = pos.path.length - 1;
    let add = 0;
    while(idx >= level){
        if (pos.path[idx] + add !== parent.maxOffset) return false;
        add = 1;
        idx--;
        parent = parent.parent;
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/range
*/ /**
* Represents a range in the model tree.
*
* A range is defined by its {@link module:engine/model/range~ModelRange#start} and {@link module:engine/model/range~ModelRange#end}
* positions.
*
* You can create range instances via its constructor or the `createRange*()` factory methods of
* {@link module:engine/model/model~Model} and {@link module:engine/model/writer~ModelWriter}.
*/ var $b9b9f2bdf9c6137f$export$a3091252a5e626ba = class ModelRange extends $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 {
    /**
	* Start position.
	*/ start;
    /**
	* End position.
	*/ end;
    /**
	* Creates a range spanning from `start` position to `end` position.
	*
	* @param start The start position.
	* @param end The end position. If not set, the range will be collapsed at the `start` position.
	*/ constructor(start, end){
        super();
        this.start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(start);
        this.end = end ? $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(end) : $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(start);
        this.start.stickiness = this.isCollapsed ? "toNone" : "toNext";
        this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
    }
    /**
	* Iterable interface.
	*
	* Iterates over all {@link module:engine/model/item~ModelItem items} that are in this range and returns
	* them together with additional information like length or {@link module:engine/model/position~ModelPosition positions},
	* grouped as {@link module:engine/model/treewalker~ModelTreeWalkerValue}.
	* It iterates over all {@link module:engine/model/textproxy~ModelTextProxy text contents} that are inside the range
	* and all the {@link module:engine/model/element~ModelElement}s that are entered into when iterating over this range.
	*
	* This iterator uses {@link module:engine/model/treewalker~ModelTreeWalker} with `boundaries` set to this range
	* and `ignoreElementEnd` option set to `true`.
	*/ *[Symbol.iterator]() {
        yield* new $b9b9f2bdf9c6137f$export$c24047420d7ab789({
            boundaries: this,
            ignoreElementEnd: true
        });
    }
    /**
	* Describes whether the range is collapsed, that is if {@link #start} and
	* {@link #end} positions are equal.
	*/ get isCollapsed() {
        return this.start.isEqual(this.end);
    }
    /**
	* Describes whether this range is flat, that is if {@link #start} position and
	* {@link #end} position are in the same {@link module:engine/model/position~ModelPosition#parent}.
	*/ get isFlat() {
        const startParentPath = this.start.getParentPath();
        const endParentPath = this.end.getParentPath();
        return (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(startParentPath, endParentPath) == "same";
    }
    /**
	* Range root element.
	*/ get root() {
        return this.start.root;
    }
    /**
	* Checks whether this range contains given {@link module:engine/model/position~ModelPosition position}.
	*
	* @param position Position to check.
	* @returns `true` if given {@link module:engine/model/position~ModelPosition position} is contained
	* in this range,`false` otherwise.
	*/ containsPosition(position) {
        return position.isAfter(this.start) && position.isBefore(this.end);
    }
    /**
	* Checks whether this range contains given {@link module:engine/model/range~ModelRange range}.
	*
	* @param otherRange Range to check.
	* @param loose Whether the check is loose or strict. If the check is strict (`false`), compared range cannot
	* start or end at the same position as this range boundaries. If the check is loose (`true`), compared range can start, end or
	* even be equal to this range. Note that collapsed ranges are always compared in strict mode.
	* @returns {Boolean} `true` if given {@link module:engine/model/range~ModelRange range} boundaries are contained by this range,
	* `false` otherwise.
	*/ containsRange(otherRange, loose = false) {
        if (otherRange.isCollapsed) loose = false;
        const containsStart = this.containsPosition(otherRange.start) || loose && this.start.isEqual(otherRange.start);
        const containsEnd = this.containsPosition(otherRange.end) || loose && this.end.isEqual(otherRange.end);
        return containsStart && containsEnd;
    }
    /**
	* Checks whether given {@link module:engine/model/item~ModelItem} is inside this range.
	*/ containsItem(item) {
        const pos = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(item);
        return this.containsPosition(pos) || this.start.isEqual(pos);
    }
    /**
	* Two ranges are equal if their {@link #start} and {@link #end} positions are equal.
	*
	* @param otherRange Range to compare with.
	* @returns `true` if ranges are equal, `false` otherwise.
	*/ isEqual(otherRange) {
        return this.start.isEqual(otherRange.start) && this.end.isEqual(otherRange.end);
    }
    /**
	* Checks and returns whether this range intersects with given range.
	*
	* @param otherRange Range to compare with.
	* @returns `true` if ranges intersect, `false` otherwise.
	*/ isIntersecting(otherRange) {
        return this.start.isBefore(otherRange.end) && this.end.isAfter(otherRange.start);
    }
    /**
	* Computes which part(s) of this {@link module:engine/model/range~ModelRange range} is not a part of given
	* {@link module:engine/model/range~ModelRange range}.
	* Returned array contains zero, one or two {@link module:engine/model/range~ModelRange ranges}.
	*
	* Examples:
	*
	* ```ts
	* let range = model.createRange(
	* 	model.createPositionFromPath( root, [ 2, 7 ] ),
	* 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
	* );
	* let otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 5 ] ) );
	* let transformed = range.getDifference( otherRange );
	* // transformed array has no ranges because `otherRange` contains `range`
	*
	* otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 3 ] ) );
	* transformed = range.getDifference( otherRange );
	* // transformed array has one range: from [ 3 ] to [ 4, 0, 1 ]
	*
	* otherRange = model.createRange( model.createPositionFromPath( root, [ 3 ] ), model.createPositionFromPath( root, [ 4 ] ) );
	* transformed = range.getDifference( otherRange );
	* // transformed array has two ranges: from [ 2, 7 ] to [ 3 ] and from [ 4 ] to [ 4, 0, 1 ]
	* ```
	*
	* @param otherRange Range to differentiate against.
	* @returns The difference between ranges.
	*/ getDifference(otherRange) {
        const ranges = [];
        if (this.isIntersecting(otherRange)) {
            if (this.containsPosition(otherRange.start)) ranges.push(new ModelRange(this.start, otherRange.start));
            if (this.containsPosition(otherRange.end)) ranges.push(new ModelRange(otherRange.end, this.end));
        } else ranges.push(new ModelRange(this.start, this.end));
        return ranges;
    }
    /**
	* Returns an intersection of this {@link module:engine/model/range~ModelRange range} and given
	* {@link module:engine/model/range~ModelRange range}.
	* Intersection is a common part of both of those ranges. If ranges has no common part, returns `null`.
	*
	* Examples:
	*
	* ```ts
	* let range = model.createRange(
	* 	model.createPositionFromPath( root, [ 2, 7 ] ),
	* 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
	* );
	* let otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 2 ] ) );
	* let transformed = range.getIntersection( otherRange ); // null - ranges have no common part
	*
	* otherRange = model.createRange( model.createPositionFromPath( root, [ 3 ] ), model.createPositionFromPath( root, [ 5 ] ) );
	* transformed = range.getIntersection( otherRange ); // range from [ 3 ] to [ 4, 0, 1 ]
	* ```
	*
	* @param otherRange Range to check for intersection.
	* @returns A common part of given ranges or `null` if ranges have no common part.
	*/ getIntersection(otherRange) {
        if (this.isIntersecting(otherRange)) {
            let commonRangeStart = this.start;
            let commonRangeEnd = this.end;
            if (this.containsPosition(otherRange.start)) commonRangeStart = otherRange.start;
            if (this.containsPosition(otherRange.end)) commonRangeEnd = otherRange.end;
            return new ModelRange(commonRangeStart, commonRangeEnd);
        }
        return null;
    }
    /**
	* Returns a range created by joining this {@link module:engine/model/range~ModelRange range} with the given
	* {@link module:engine/model/range~ModelRange range}.
	* If ranges have no common part, returns `null`.
	*
	* Examples:
	*
	* ```ts
	* let range = model.createRange(
	* 	model.createPositionFromPath( root, [ 2, 7 ] ),
	* 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
	* );
	* let otherRange = model.createRange(
	* 	model.createPositionFromPath( root, [ 1 ] ),
	* 	model.createPositionFromPath( root, [ 2 ] )
	* );
	* let transformed = range.getJoined( otherRange ); // null - ranges have no common part
	*
	* otherRange = model.createRange(
	* 	model.createPositionFromPath( root, [ 3 ] ),
	* 	model.createPositionFromPath( root, [ 5 ] )
	* );
	* transformed = range.getJoined( otherRange ); // range from [ 2, 7 ] to [ 5 ]
	* ```
	*
	* @param otherRange Range to be joined.
	* @param loose Whether the intersection check is loose or strict. If the check is strict (`false`),
	* ranges are tested for intersection or whether start/end positions are equal. If the check is loose (`true`),
	* compared range is also checked if it's {@link module:engine/model/position~ModelPosition#isTouching touching} current range.
	* @returns A sum of given ranges or `null` if ranges have no common part.
	*/ getJoined(otherRange, loose = false) {
        let shouldJoin = this.isIntersecting(otherRange);
        if (!shouldJoin) {
            if (this.start.isBefore(otherRange.start)) shouldJoin = loose ? this.end.isTouching(otherRange.start) : this.end.isEqual(otherRange.start);
            else shouldJoin = loose ? otherRange.end.isTouching(this.start) : otherRange.end.isEqual(this.start);
        }
        if (!shouldJoin) return null;
        let startPosition = this.start;
        let endPosition = this.end;
        if (otherRange.start.isBefore(startPosition)) startPosition = otherRange.start;
        if (otherRange.end.isAfter(endPosition)) endPosition = otherRange.end;
        return new ModelRange(startPosition, endPosition);
    }
    /**
	* Computes and returns the smallest set of {@link #isFlat flat} ranges, that covers this range in whole.
	*
	* See an example of a model structure (`[` and `]` are range boundaries):
	*
	* ```
	* root                                                            root
	*  |- element DIV                         DIV             P2              P3             DIV
	*  |   |- element H                   H        P1        f o o           b a r       H         P4
	*  |   |   |- "fir[st"             fir[st     lorem                               se]cond     ipsum
	*  |   |- element P1
	*  |   |   |- "lorem"                                              ||
	*  |- element P2                                                   ||
	*  |   |- "foo"                                                    VV
	*  |- element P3
	*  |   |- "bar"                                                   root
	*  |- element DIV                         DIV             [P2             P3]             DIV
	*  |   |- element H                   H       [P1]       f o o           b a r        H         P4
	*  |   |   |- "se]cond"            fir[st]    lorem                               [se]cond     ipsum
	*  |   |- element P4
	*  |   |   |- "ipsum"
	* ```
	*
	* As it can be seen, letters contained in the range are: `stloremfoobarse`, spread across different parents.
	* We are looking for minimal set of flat ranges that contains the same nodes.
	*
	* Minimal flat ranges for above range `( [ 0, 0, 3 ], [ 3, 0, 2 ] )` will be:
	*
	* ```
	* ( [ 0, 0, 3 ], [ 0, 0, 5 ] ) = "st"
	* ( [ 0, 1 ], [ 0, 2 ] ) = element P1 ("lorem")
	* ( [ 1 ], [ 3 ] ) = element P2, element P3 ("foobar")
	* ( [ 3, 0, 0 ], [ 3, 0, 2 ] ) = "se"
	* ```
	*
	* **Note:** if an {@link module:engine/model/element~ModelElement element} is not wholly contained in this range, it won't be returned
	* in any of the returned flat ranges. See in the example how `H` elements at the beginning and at the end of the range
	* were omitted. Only their parts that were wholly in the range were returned.
	*
	* **Note:** this method is not returning flat ranges that contain no nodes.
	*
	* @returns Array of flat ranges covering this range.
	*/ getMinimalFlatRanges() {
        const ranges = [];
        const diffAt = this.start.getCommonPath(this.end).length;
        const pos = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(this.start);
        let posParent = pos.parent;
        while(pos.path.length > diffAt + 1){
            const howMany = posParent.maxOffset - pos.offset;
            if (howMany !== 0) ranges.push(new ModelRange(pos, pos.getShiftedBy(howMany)));
            pos.path = pos.path.slice(0, -1);
            pos.offset++;
            posParent = posParent.parent;
        }
        while(pos.path.length <= this.end.path.length){
            const offset = this.end.path[pos.path.length - 1];
            const howMany = offset - pos.offset;
            if (howMany !== 0) ranges.push(new ModelRange(pos, pos.getShiftedBy(howMany)));
            pos.offset = offset;
            pos.path.push(0);
        }
        return ranges;
    }
    /**
	* Creates a {@link module:engine/model/treewalker~ModelTreeWalker TreeWalker} instance with this range as a boundary.
	*
	* For example, to iterate over all items in the entire document root:
	*
	* ```ts
	* // Create a range spanning over the entire root content:
	* const range = editor.model.createRangeIn( editor.model.document.getRoot() );
	*
	* // Iterate over all items in this range:
	* for ( const value of range.getWalker() ) {
	* 	console.log( value.item );
	* }
	* ```
	*
	* @param options Object with configuration options. See {@link module:engine/model/treewalker~ModelTreeWalker}.
	*/ getWalker(options = {}) {
        options.boundaries = this;
        return new $b9b9f2bdf9c6137f$export$c24047420d7ab789(options);
    }
    /**
	* Returns an iterator that iterates over all {@link module:engine/model/item~ModelItem items} that are in this range and returns
	* them.
	*
	* This method uses {@link module:engine/model/treewalker~ModelTreeWalker} with `boundaries` set to this range and
	* `ignoreElementEnd` option set to `true`. However it returns only {@link module:engine/model/item~ModelItem model items},
	* not {@link module:engine/model/treewalker~ModelTreeWalkerValue}.
	*
	* You may specify additional options for the tree walker. See {@link module:engine/model/treewalker~ModelTreeWalker} for
	* a full list of available options.
	*
	* @param options Object with configuration options. See {@link module:engine/model/treewalker~ModelTreeWalker}.
	*/ *getItems(options = {}) {
        options.boundaries = this;
        options.ignoreElementEnd = true;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789(options);
        for (const value of treeWalker)yield value.item;
    }
    /**
	* Returns an iterator that iterates over all {@link module:engine/model/position~ModelPosition positions} that are boundaries or
	* contained in this range.
	*
	* This method uses {@link module:engine/model/treewalker~ModelTreeWalker} with `boundaries` set to this range. However it returns only
	* {@link module:engine/model/position~ModelPosition positions}, not {@link module:engine/model/treewalker~ModelTreeWalkerValue}.
	*
	* You may specify additional options for the tree walker. See {@link module:engine/model/treewalker~ModelTreeWalker} for
	* a full list of available options.
	*
	* @param options Object with configuration options. See {@link module:engine/model/treewalker~ModelTreeWalker}.
	*/ *getPositions(options = {}) {
        options.boundaries = this;
        const treeWalker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789(options);
        yield treeWalker.position;
        for (const value of treeWalker)yield value.nextPosition;
    }
    /**
	* Returns a range that is a result of transforming this range by given `operation`.
	*
	* **Note:** transformation may break one range into multiple ranges (for example, when a part of the range is
	* moved to a different part of document tree). For this reason, an array is returned by this method and it
	* may contain one or more `Range` instances.
	*
	* @param operation Operation to transform range by.
	* @returns Range which is the result of transformation.
	*/ getTransformedByOperation(operation) {
        switch(operation.type){
            case "insert":
                return this._getTransformedByInsertOperation(operation);
            case "move":
            case "remove":
            case "reinsert":
                return this._getTransformedByMoveOperation(operation);
            case "split":
                return [
                    this._getTransformedBySplitOperation(operation)
                ];
            case "merge":
                return [
                    this._getTransformedByMergeOperation(operation)
                ];
            case "detach":
                return this._getTransformedByDetachOperation(operation);
        }
        return [
            new ModelRange(this.start, this.end)
        ];
    }
    /**
	* Returns a range that is a result of transforming this range by multiple `operations`.
	*
	* @see module:engine/model/range~ModelRange#getTransformedByOperation
	* @param operations Operations to transform the range by.
	* @returns Range which is the result of transformation.
	*/ getTransformedByOperations(operations) {
        const ranges = [
            new ModelRange(this.start, this.end)
        ];
        for (const operation of operations)for(let i = 0; i < ranges.length; i++){
            const result = ranges[i].getTransformedByOperation(operation);
            ranges.splice(i, 1, ...result);
            i += result.length - 1;
        }
        for(let i = 0; i < ranges.length; i++){
            const range = ranges[i];
            for(let j = i + 1; j < ranges.length; j++){
                const next = ranges[j];
                if (range.containsRange(next) || next.containsRange(range) || range.isEqual(next)) ranges.splice(j, 1);
            }
        }
        return ranges;
    }
    /**
	* Returns an {@link module:engine/model/element~ModelElement} or {@link module:engine/model/documentfragment~ModelDocumentFragment}
	* which is a common ancestor of the range's both ends (in which the entire range is contained).
	*/ getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
    }
    /**
	* Returns an {@link module:engine/model/element~ModelElement Element} contained by the range.
	* The element will be returned when it is the **only** node within the range and **fully–contained**
	* at the same time.
	*/ getContainedElement() {
        if (this.isCollapsed) return null;
        const nodeAfterStart = this.start.nodeAfter;
        const nodeBeforeEnd = this.end.nodeBefore;
        if (nodeAfterStart && nodeAfterStart.is("element") && nodeAfterStart === nodeBeforeEnd) return nodeAfterStart;
        return null;
    }
    /**
	* Converts `Range` to plain object and returns it.
	*
	* @returns `Range` converted to plain object.
	*/ toJSON() {
        return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
        };
    }
    /**
	* Returns a new range that is equal to current range.
	*/ clone() {
        return new this.constructor(this.start, this.end);
    }
    /**
	* Returns a result of transforming a copy of this range by insert operation.
	*
	* One or more ranges may be returned as a result of this transformation.
	*
	* @internal
	*/ _getTransformedByInsertOperation(operation, spread = false) {
        return this._getTransformedByInsertion(operation.position, operation.howMany, spread);
    }
    /**
	* Returns a result of transforming a copy of this range by move operation.
	*
	* One or more ranges may be returned as a result of this transformation.
	*
	* @internal
	*/ _getTransformedByMoveOperation(operation, spread = false) {
        const sourcePosition = operation.sourcePosition;
        const howMany = operation.howMany;
        const targetPosition = operation.targetPosition;
        return this._getTransformedByMove(sourcePosition, targetPosition, howMany, spread);
    }
    /**
	* Returns a result of transforming a copy of this range by split operation.
	*
	* Always one range is returned. The transformation is done in a way to not break the range.
	*
	* @internal
	*/ _getTransformedBySplitOperation(operation) {
        const start = this.start._getTransformedBySplitOperation(operation);
        let end = this.end._getTransformedBySplitOperation(operation);
        if (this.end.isEqual(operation.insertionPosition)) end = this.end.getShiftedBy(1);
        if (start.root != end.root) end = this.end.getShiftedBy(-1);
        return new ModelRange(start, end);
    }
    /**
	* Returns a result of transforming a copy of this range by merge operation.
	*
	* Always one range is returned. The transformation is done in a way to not break the range.
	*
	* @internal
	*/ _getTransformedByMergeOperation(operation) {
        if (this.start.isEqual(operation.targetPosition) && this.end.isEqual(operation.deletionPosition)) return new ModelRange(this.start);
        let start = this.start._getTransformedByMergeOperation(operation);
        let end = this.end._getTransformedByMergeOperation(operation);
        if (start.root != end.root) end = this.end.getShiftedBy(-1);
        if (start.isAfter(end)) {
            if (operation.sourcePosition.isBefore(operation.targetPosition)) {
                start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(end);
                start.offset = 0;
            } else {
                if (!operation.deletionPosition.isEqual(start)) end = operation.deletionPosition;
                start = operation.targetPosition;
            }
            return new ModelRange(start, end);
        }
        return new ModelRange(start, end);
    }
    /**
	* Returns a result of transforming a copy of this range by detach operation.
	*
	* If the range is completely removed, an empty array is returned.
	*
	* @internal
	*/ _getTransformedByDetachOperation(operation) {
        const result = this._getTransformedByDeletion(operation.sourcePosition, operation.howMany);
        return result ? [
            result
        ] : [];
    }
    /**
	* Returns an array containing one or two {@link module:engine/model/range~ModelRange ranges} that are a result of transforming this
	* {@link module:engine/model/range~ModelRange range} by inserting `howMany` nodes at `insertPosition`. Two
	* {@link module:engine/model/range~ModelRange ranges} are returned if the insertion was inside this
	* {@link module:engine/model/range~ModelRange range} and `spread` is set to `true`.
	*
	* Examples:
	*
	* ```ts
	* let range = model.createRange(
	* 	model.createPositionFromPath( root, [ 2, 7 ] ),
	* 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
	* );
	* let transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 1 ] ), 2 );
	* // transformed array has one range from [ 4, 7 ] to [ 6, 0, 1 ]
	*
	* transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 4, 0, 0 ] ), 4 );
	* // transformed array has one range from [ 2, 7 ] to [ 4, 0, 5 ]
	*
	* transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 3, 2 ] ), 4 );
	* // transformed array has one range, which is equal to original range
	*
	* transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 3, 2 ] ), 4, true );
	* // transformed array has two ranges: from [ 2, 7 ] to [ 3, 2 ] and from [ 3, 6 ] to [ 4, 0, 1 ]
	* ```
	*
	* @internal
	* @param insertPosition Position where nodes are inserted.
	* @param howMany How many nodes are inserted.
	* @param spread Flag indicating whether this range should be spread if insertion
	* was inside the range. Defaults to `false`.
	* @returns Result of the transformation.
	*/ _getTransformedByInsertion(insertPosition, howMany, spread = false) {
        if (spread && this.containsPosition(insertPosition)) return [
            new ModelRange(this.start, insertPosition),
            new ModelRange(insertPosition.getShiftedBy(howMany), this.end._getTransformedByInsertion(insertPosition, howMany))
        ];
        else {
            const range = new ModelRange(this.start, this.end);
            range.start = range.start._getTransformedByInsertion(insertPosition, howMany);
            range.end = range.end._getTransformedByInsertion(insertPosition, howMany);
            return [
                range
            ];
        }
    }
    /**
	* Returns an array containing {@link module:engine/model/range~ModelRange ranges} that are a result of transforming this
	* {@link module:engine/model/range~ModelRange range} by moving `howMany` nodes from `sourcePosition` to `targetPosition`.
	*
	* @internal
	* @param sourcePosition Position from which nodes are moved.
	* @param targetPosition Position to where nodes are moved.
	* @param howMany How many nodes are moved.
	* @param spread Whether the range should be spread if the move points inside the range.
	* @returns  Result of the transformation.
	*/ _getTransformedByMove(sourcePosition, targetPosition, howMany, spread = false) {
        if (this.isCollapsed) {
            const newPos = this.start._getTransformedByMove(sourcePosition, targetPosition, howMany);
            return [
                new ModelRange(newPos)
            ];
        }
        const moveRange = ModelRange._createFromPositionAndShift(sourcePosition, howMany);
        const insertPosition = targetPosition._getTransformedByDeletion(sourcePosition, howMany);
        if (this.containsPosition(targetPosition) && !spread) {
            if (moveRange.containsPosition(this.start) || moveRange.containsPosition(this.end)) {
                const start = this.start._getTransformedByMove(sourcePosition, targetPosition, howMany);
                const end = this.end._getTransformedByMove(sourcePosition, targetPosition, howMany);
                return [
                    new ModelRange(start, end)
                ];
            }
        }
        let result;
        const differenceSet = this.getDifference(moveRange);
        let difference = null;
        const common = this.getIntersection(moveRange);
        if (differenceSet.length == 1) difference = new ModelRange(differenceSet[0].start._getTransformedByDeletion(sourcePosition, howMany), differenceSet[0].end._getTransformedByDeletion(sourcePosition, howMany));
        else if (differenceSet.length == 2) difference = new ModelRange(this.start, this.end._getTransformedByDeletion(sourcePosition, howMany));
        if (difference) result = difference._getTransformedByInsertion(insertPosition, howMany, common !== null || spread);
        else result = [];
        if (common) {
            const transformedCommon = new ModelRange(common.start._getCombined(moveRange.start, insertPosition), common.end._getCombined(moveRange.start, insertPosition));
            if (result.length == 2) result.splice(1, 0, transformedCommon);
            else result.push(transformedCommon);
        }
        return result;
    }
    /**
	* Returns a copy of this range that is transformed by deletion of `howMany` nodes from `deletePosition`.
	*
	* If the deleted range is intersecting with the transformed range, the transformed range will be shrank.
	*
	* If the deleted range contains transformed range, `null` will be returned.
	*
	* @internal
	* @param deletePosition Position from which nodes are removed.
	* @param howMany How many nodes are removed.
	* @returns Result of the transformation.
	*/ _getTransformedByDeletion(deletePosition, howMany) {
        let newStart = this.start._getTransformedByDeletion(deletePosition, howMany);
        let newEnd = this.end._getTransformedByDeletion(deletePosition, howMany);
        if (newStart == null && newEnd == null) return null;
        if (newStart == null) newStart = deletePosition;
        if (newEnd == null) newEnd = deletePosition;
        return new ModelRange(newStart, newEnd);
    }
    /**
	* Creates a new range, spreading from specified {@link module:engine/model/position~ModelPosition position} to a position moved by
	* given `shift`. If `shift` is a negative value, shifted position is treated as the beginning of the range.
	*
	* @internal
	* @param position Beginning of the range.
	* @param shift How long the range should be.
	*/ static _createFromPositionAndShift(position, shift) {
        const start = position;
        const end = position.getShiftedBy(shift);
        return shift > 0 ? new this(start, end) : new this(end, start);
    }
    /**
	* Creates a range inside an {@link module:engine/model/element~ModelElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* @internal
	* @param element Element which is a parent for the range.
	*/ static _createIn(element) {
        return new this($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, 0), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, element.maxOffset));
    }
    /**
	* Creates a range that starts before given {@link module:engine/model/item~ModelItem model item} and ends after it.
	*
	* @internal
	*/ static _createOn(item) {
        return this._createFromPositionAndShift($b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(item), item.offsetSize);
    }
    /**
	* Combines all ranges from the passed array into a one range. At least one range has to be passed.
	* Passed ranges must not have common parts.
	*
	* The first range from the array is a reference range. If other ranges start or end on the exactly same position where
	* the reference range, they get combined into one range.
	*
	* ```
	* [  ][]  [    ][ ][             ][ ][]  [  ]  // Passed ranges, shown sorted
	* [    ]                                       // The result of the function if the first range was a reference range.
	*         [                           ]        // The result of the function if the third-to-seventh range was a reference range.
	*                                        [  ]  // The result of the function if the last range was a reference range.
	* ```
	*
	* @internal
	* @param ranges Ranges to combine.
	* @returns Combined range.
	*/ static _createFromRanges(ranges) {
        if (ranges.length === 0) /**
		* At least one range has to be passed to
		* {@link module:engine/model/range~ModelRange._createFromRanges `Range._createFromRanges()`}.
		*
		* @error range-create-from-ranges-empty-array
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("range-create-from-ranges-empty-array", null);
        else if (ranges.length == 1) return ranges[0].clone();
        const ref = ranges[0];
        ranges.sort((a, b)=>{
            return a.start.isAfter(b.start) ? 1 : -1;
        });
        const refIndex = ranges.indexOf(ref);
        const result = new this(ref.start, ref.end);
        for(let i = refIndex - 1; i >= 0; i--)if (ranges[i].end.isEqual(result.start)) result.start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(ranges[i].start);
        else break;
        for(let i = refIndex + 1; i < ranges.length; i++)if (ranges[i].start.isEqual(result.end)) result.end = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(ranges[i].end);
        else break;
        return result;
    }
    /**
	* Creates a `Range` instance from given plain object (i.e. parsed JSON string).
	*
	* @param json Plain object to be converted to `Range`.
	* @param doc Document object that will be range owner.
	* @returns `Range` instance created using given plain object.
	*/ static fromJSON(json, doc) {
        return new this($b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.start, doc), $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.end, doc));
    }
};
$b9b9f2bdf9c6137f$export$a3091252a5e626ba.prototype.is = function(type) {
    return type === "range" || type === "model:range";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/mapper
*/ const $b9b9f2bdf9c6137f$var$MapperBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
const $b9b9f2bdf9c6137f$var$MapperCacheBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Maps elements, positions and markers between the {@link module:engine/view/document~ViewDocument view} and
* the {@link module:engine/model/model model}.
*
* The instance of the Mapper used for the editing pipeline is available in
* {@link module:engine/controller/editingcontroller~EditingController#mapper `editor.editing.mapper`}.
*
* Mapper uses bound elements to find corresponding elements and positions, so, to get proper results,
* all model elements should be {@link module:engine/conversion/mapper~Mapper#bindElements bound}.
*
* To map the complex model to/from view relations, you may provide custom callbacks for the
* {@link module:engine/conversion/mapper~Mapper#event:modelToViewPosition modelToViewPosition event} and
* {@link module:engine/conversion/mapper~Mapper#event:viewToModelPosition viewToModelPosition event} that are fired whenever
* a position mapping request occurs.
* Those events are fired by the {@link module:engine/conversion/mapper~Mapper#toViewPosition toViewPosition}
* and {@link module:engine/conversion/mapper~Mapper#toModelPosition toModelPosition} methods. `Mapper` adds its own default callbacks
* with `'lowest'` priority. To override default `Mapper` mapping, add custom callback with higher priority and
* stop the event.
*/ var $b9b9f2bdf9c6137f$export$ef5ccc0a8fc5a06c = class extends $b9b9f2bdf9c6137f$var$MapperBase {
    /**
	* Model element to view element mapping.
	*/ _modelToViewMapping = /* @__PURE__ */ new WeakMap();
    /**
	* View element to model element mapping.
	*/ _viewToModelMapping = /* @__PURE__ */ new WeakMap();
    /**
	* A map containing callbacks between view element names and functions evaluating length of view elements
	* in model.
	*/ _viewToModelLengthCallbacks = /* @__PURE__ */ new Map();
    /**
	* Model marker name to view elements mapping.
	*
	* Keys are `String`s while values are `Set`s with {@link module:engine/view/element~ViewElement view elements}.
	* One marker (name) can be mapped to multiple elements.
	*/ _markerNameToElements = /* @__PURE__ */ new Map();
    /**
	* View element to model marker names mapping.
	*
	* This is reverse to {@link ~Mapper#_markerNameToElements} map.
	*/ _elementToMarkerNames = /* @__PURE__ */ new Map();
    /**
	* The map of removed view elements with their current root (used for deferred unbinding).
	*/ _deferredBindingRemovals = /* @__PURE__ */ new Map();
    /**
	* Stores marker names of markers which have changed due to unbinding a view element (so it is assumed that the view element
	* has been removed, moved or renamed).
	*/ _unboundMarkerNames = /* @__PURE__ */ new Set();
    /**
	* Manages dynamic cache for the `Mapper` to improve the performance.
	*/ _cache = new $b9b9f2bdf9c6137f$export$9b1415706498766d();
    /**
	* Creates an instance of the mapper.
	*/ constructor(){
        super();
        this.on("modelToViewPosition", (evt, data)=>{
            if (data.viewPosition) return;
            const viewContainer = this._modelToViewMapping.get(data.modelPosition.parent);
            if (!viewContainer) /**
			* A model position could not be mapped to the view because the parent of the model position
			* does not have a mapped view element (might have not been converted yet or it has no converter).
			*
			* Make sure that the model element is correctly converted to the view.
			*
			* @error mapping-model-position-view-parent-not-found
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("mapping-model-position-view-parent-not-found", this, {
                modelPosition: data.modelPosition
            });
            data.viewPosition = this.findPositionIn(viewContainer, data.modelPosition.offset);
        }, {
            priority: "low"
        });
        this.on("viewToModelPosition", (evt, data)=>{
            if (data.modelPosition) return;
            const viewBlock = this.findMappedViewAncestor(data.viewPosition);
            const modelParent = this._viewToModelMapping.get(viewBlock);
            const modelOffset = this._toModelOffset(data.viewPosition.parent, data.viewPosition.offset, viewBlock);
            data.modelPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(modelParent, modelOffset);
        }, {
            priority: "low"
        });
    }
    /**
	* Marks model and view elements as corresponding. Corresponding elements can be retrieved by using
	* the {@link module:engine/conversion/mapper~Mapper#toModelElement toModelElement} and
	* {@link module:engine/conversion/mapper~Mapper#toViewElement toViewElement} methods.
	* The information that elements are bound is also used to translate positions.
	*
	* @param modelElement Model element.
	* @param viewElement View element.
	*/ bindElements(modelElement, viewElement) {
        this._modelToViewMapping.set(modelElement, viewElement);
        this._viewToModelMapping.set(viewElement, modelElement);
    }
    /**
	* Unbinds the given {@link module:engine/view/element~ViewElement view element} from the map.
	*
	* **Note:** view-to-model binding will be removed, if it existed. However, corresponding model-to-view binding
	* will be removed only if model element is still bound to the passed `viewElement`.
	*
	* This behavior allows for re-binding model element to another view element without fear of losing the new binding
	* when the previously bound view element is unbound.
	*
	* @param viewElement View element to unbind.
	* @param options The options object.
	* @param options.defer Controls whether the binding should be removed immediately or deferred until a
	* {@link #flushDeferredBindings `flushDeferredBindings()`} call.
	*/ unbindViewElement(viewElement, options = {}) {
        const modelElement = this.toModelElement(viewElement);
        if (this._elementToMarkerNames.has(viewElement)) for (const markerName of this._elementToMarkerNames.get(viewElement))this._unboundMarkerNames.add(markerName);
        if (options.defer) this._deferredBindingRemovals.set(viewElement, viewElement.root);
        else {
            if (this._viewToModelMapping.delete(viewElement)) this._cache.stopTracking(viewElement);
            if (this._modelToViewMapping.get(modelElement) == viewElement) this._modelToViewMapping.delete(modelElement);
        }
    }
    /**
	* Unbinds the given {@link module:engine/model/element~ModelElement model element} from the map.
	*
	* **Note:** the model-to-view binding will be removed, if it existed. However, the corresponding view-to-model binding
	* will be removed only if the view element is still bound to the passed `modelElement`.
	*
	* This behavior lets for re-binding view element to another model element without fear of losing the new binding
	* when the previously bound model element is unbound.
	*
	* @param modelElement Model element to unbind.
	*/ unbindModelElement(modelElement) {
        const viewElement = this.toViewElement(modelElement);
        this._modelToViewMapping.delete(modelElement);
        if (this._viewToModelMapping.get(viewElement) == modelElement) /* v8 ignore next 4 -- @preserve */ {
            if (this._viewToModelMapping.delete(viewElement)) this._cache.stopTracking(viewElement);
        }
    }
    /**
	* Binds the given marker name with the given {@link module:engine/view/element~ViewElement view element}. The element
	* will be added to the current set of elements bound with the given marker name.
	*
	* @param element Element to bind.
	* @param name Marker name.
	*/ bindElementToMarker(element, name) {
        const elements = this._markerNameToElements.get(name) || /* @__PURE__ */ new Set();
        elements.add(element);
        const names = this._elementToMarkerNames.get(element) || /* @__PURE__ */ new Set();
        names.add(name);
        this._markerNameToElements.set(name, elements);
        this._elementToMarkerNames.set(element, names);
    }
    /**
	* Unbinds an element from given marker name.
	*
	* @param element Element to unbind.
	* @param name Marker name.
	*/ unbindElementFromMarkerName(element, name) {
        const nameToElements = this._markerNameToElements.get(name);
        if (nameToElements) {
            nameToElements.delete(element);
            if (nameToElements.size == 0) this._markerNameToElements.delete(name);
        }
        const elementToNames = this._elementToMarkerNames.get(element);
        if (elementToNames) {
            elementToNames.delete(name);
            if (elementToNames.size == 0) this._elementToMarkerNames.delete(element);
        }
    }
    /**
	* Returns all marker names of markers which have changed due to unbinding a view element (so it is assumed that the view element
	* has been removed, moved or renamed) since the last flush. After returning, the marker names list is cleared.
	*/ flushUnboundMarkerNames() {
        const markerNames = Array.from(this._unboundMarkerNames);
        this._unboundMarkerNames.clear();
        return markerNames;
    }
    /**
	* Unbinds all deferred binding removals of view elements that in the meantime were not re-attached to some root or document fragment.
	*
	* See: {@link #unbindViewElement `unbindViewElement()`}.
	*/ flushDeferredBindings() {
        for (const [viewElement, root] of this._deferredBindingRemovals)if (viewElement.root == root) this.unbindViewElement(viewElement);
        this._deferredBindingRemovals = /* @__PURE__ */ new Map();
    }
    /**
	* Removes all model to view and view to model bindings.
	*/ clearBindings() {
        this._modelToViewMapping = /* @__PURE__ */ new WeakMap();
        this._viewToModelMapping = /* @__PURE__ */ new WeakMap();
        this._markerNameToElements = /* @__PURE__ */ new Map();
        this._elementToMarkerNames = /* @__PURE__ */ new Map();
        this._unboundMarkerNames = /* @__PURE__ */ new Set();
        this._deferredBindingRemovals = /* @__PURE__ */ new Map();
    }
    toModelElement(viewElement) {
        return this._viewToModelMapping.get(viewElement);
    }
    toViewElement(modelElement) {
        return this._modelToViewMapping.get(modelElement);
    }
    /**
	* Gets the corresponding model range.
	*
	* @param viewRange View range.
	* @returns Corresponding model range.
	*/ toModelRange(viewRange) {
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(this.toModelPosition(viewRange.start), this.toModelPosition(viewRange.end));
    }
    /**
	* Gets the corresponding view range.
	*
	* @param modelRange Model range.
	* @returns Corresponding view range.
	*/ toViewRange(modelRange) {
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(this.toViewPosition(modelRange.start), this.toViewPosition(modelRange.end));
    }
    /**
	* Gets the corresponding model position.
	*
	* @fires viewToModelPosition
	* @param viewPosition View position.
	* @returns Corresponding model position.
	*/ toModelPosition(viewPosition) {
        const data = {
            viewPosition: viewPosition,
            mapper: this
        };
        this.fire("viewToModelPosition", data);
        return data.modelPosition;
    }
    /**
	* Gets the corresponding view position.
	*
	* @fires modelToViewPosition
	* @param modelPosition Model position.
	* @param options Additional options for position mapping process.
	* @param options.isPhantom Should be set to `true` if the model position to map is pointing to a place
	* in model tree which no longer exists. For example, it could be an end of a removed model range.
	* @returns Corresponding view position.
	*/ toViewPosition(modelPosition, options = {}) {
        const data = {
            modelPosition: modelPosition,
            mapper: this,
            isPhantom: options.isPhantom
        };
        this.fire("modelToViewPosition", data);
        return data.viewPosition;
    }
    /**
	* Gets all view elements bound to the given marker name.
	*
	* @param name Marker name.
	* @returns View elements bound with the given marker name or `null`
	* if no elements are bound to the given marker name.
	*/ markerNameToElements(name) {
        const boundElements = this._markerNameToElements.get(name);
        if (!boundElements) return null;
        const elements = /* @__PURE__ */ new Set();
        for (const element of boundElements)if (element.is("attributeElement")) for (const clone of element.getElementsWithSameId())elements.add(clone);
        else elements.add(element);
        return elements;
    }
    /**
	* **This method is deprecated and will be removed in one of the future CKEditor 5 releases.**
	*
	* **Using this method will turn off `Mapper` caching system and may degrade performance when operating on bigger documents.**
	*
	* Registers a callback that evaluates the length in the model of a view element with the given name.
	*
	* The callback is fired with one argument, which is a view element instance. The callback is expected to return
	* a number representing the length of the view element in the model.
	*
	* ```ts
	* // List item in view may contain nested list, which have other list items. In model though,
	* // the lists are represented by flat structure. Because of those differences, length of list view element
	* // may be greater than one. In the callback it's checked how many nested list items are in evaluated list item.
	*
	* function getViewListItemLength( element ) {
	* 	let length = 1;
	*
	* 	for ( let child of element.getChildren() ) {
	* 		if ( child.name == 'ul' || child.name == 'ol' ) {
	* 			for ( let item of child.getChildren() ) {
	* 				length += getViewListItemLength( item );
	* 			}
	* 		}
	* 	}
	*
	* 	return length;
	* }
	*
	* mapper.registerViewToModelLength( 'li', getViewListItemLength );
	* ```
	*
	* @param viewElementName Name of view element for which callback is registered.
	* @param lengthCallback Function return a length of view element instance in model.
	* @deprecated
	*/ registerViewToModelLength(viewElementName, lengthCallback) {
        this._viewToModelLengthCallbacks.set(viewElementName, lengthCallback);
    }
    /**
	* For the given `viewPosition`, finds and returns the closest ancestor of this position that has a mapping to
	* the model.
	*
	* @param viewPosition Position for which a mapped ancestor should be found.
	*/ findMappedViewAncestor(viewPosition) {
        let parent = viewPosition.parent;
        while(!this._viewToModelMapping.has(parent))parent = parent.parent;
        return parent;
    }
    /**
	* Calculates model offset based on the view position and the block element.
	*
	* Example:
	*
	* ```html
	* <p>foo<b>ba|r</b></p> // _toModelOffset( b, 2, p ) -> 5
	* ```
	*
	* Is a sum of:
	*
	* ```html
	* <p>foo|<b>bar</b></p> // _toModelOffset( p, 3, p ) -> 3
	* <p>foo<b>ba|r</b></p> // _toModelOffset( b, 2, b ) -> 2
	* ```
	*
	* @param viewParent Position parent.
	* @param viewOffset Position offset.
	* @param viewBlock Block used as a base to calculate offset.
	* @returns Offset in the model.
	*/ _toModelOffset(viewParent, viewOffset, viewBlock) {
        if (viewBlock != viewParent) return this._toModelOffset(viewParent.parent, viewParent.index, viewBlock) + this._toModelOffset(viewParent, viewOffset, viewParent);
        if (viewParent.is("$text")) return viewOffset;
        let modelOffset = 0;
        for(let i = 0; i < viewOffset; i++)modelOffset += this.getModelLength(viewParent.getChild(i));
        return modelOffset;
    }
    /**
	* Gets the length of the view element in the model.
	*
	* The length is calculated as follows:
	* * if a {@link #registerViewToModelLength length mapping callback} is provided for the given `viewNode`, it is used to
	* evaluate the model length (`viewNode` is used as first and only parameter passed to the callback),
	* * length of a {@link module:engine/view/text~ViewText text node} is equal to the length of its
	* {@link module:engine/view/text~ViewText#data data},
	* * length of a {@link module:engine/view/uielement~ViewUIElement ui element} is equal to 0,
	* * length of a mapped {@link module:engine/view/element~ViewElement element} is equal to 1,
	* * length of a non-mapped {@link module:engine/view/element~ViewElement element} is equal to the length of its children.
	*
	* Examples:
	*
	* ```
	* foo                          -> 3 // Text length is equal to its data length.
	* <p>foo</p>                   -> 1 // Length of an element which is mapped is by default equal to 1.
	* <b>foo</b>                   -> 3 // Length of an element which is not mapped is a length of its children.
	* <div><p>x</p><p>y</p></div>  -> 2 // Assuming that <div> is not mapped and <p> are mapped.
	* ```
	*
	* @param viewNode View node.
	* @returns Length of the node in the tree model.
	*/ getModelLength(viewNode) {
        const stack = [
            viewNode
        ];
        let len = 0;
        while(stack.length > 0){
            const node = stack.pop();
            const callback = node.name && this._viewToModelLengthCallbacks.size > 0 && this._viewToModelLengthCallbacks.get(node.name);
            if (callback) len += callback(node);
            else if (this._viewToModelMapping.has(node)) len += 1;
            else if (node.is("$text")) len += node.data.length;
            else if (node.is("uiElement")) continue;
            else for (const child of node.getChildren())stack.push(child);
        }
        return len;
    }
    /**
	* Finds the position in a view element or view document fragment node (or in its children) with the expected model offset.
	*
	* If the passed `viewContainer` is bound to model, `Mapper` will use caching mechanism to improve performance.
	*
	* @param viewContainer Tree view element in which we are looking for the position.
	* @param modelOffset Expected offset.
	* @returns Found position.
	*/ findPositionIn(viewContainer, modelOffset) {
        if (modelOffset === 0) return this._moveViewPositionToTextNode(new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewContainer, 0));
        if (this._viewToModelLengthCallbacks.size == 0 && this._viewToModelMapping.has(viewContainer)) {
            const cacheItem = this._cache.getClosest(viewContainer, modelOffset);
            return this._findPositionStartingFrom(cacheItem.viewPosition, cacheItem.modelOffset, modelOffset, viewContainer, true);
        } else return this._findPositionStartingFrom(new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewContainer, 0), 0, modelOffset, viewContainer, false);
    }
    /**
	* Performs most of the logic for `Mapper#findPositionIn()`.
	*
	* It allows to start looking for the requested model offset from a given starting position, to enable caching. Using the cache,
	* you can set the starting point and skip all the calculations that were already previously done.
	*
	* This method uses recursion to find positions inside deep structures. Example:
	*
	* ```
	* <p>fo<b>bar</b>bom</p>  -> target offset: 4
	* <p>|fo<b>bar</b>bom</p> -> target offset: 4, traversed offset: 0
	* <p>fo|<b>bar</b>bom</p> -> target offset: 4, traversed offset: 2
	* <p>fo<b>bar</b>|bom</p> -> target offset: 4, traversed offset: 5 -> we are too far, look recursively in <b>.
	*
	* <p>fo<b>|bar</b>bom</p> -> target offset: 4, traversed offset: 2
	* <p>fo<b>bar|</b>bom</p> -> target offset: 4, traversed offset: 5 -> we are too far, look inside "bar".
	*
	* <p>fo<b>ba|r</b>bom</p> -> target offset: 4, traversed offset: 2 -> position is inside text node at offset 4-2 = 2.
	* ```
	*
	* @param startViewPosition View position to start looking from.
	* @param startModelOffset Model offset related to `startViewPosition`.
	* @param targetModelOffset Target model offset to find.
	* @param viewContainer Mapped ancestor of `startViewPosition`. `startModelOffset` is the offset inside a model element or model
	* document fragment mapped to `viewContainer`.
	* @param useCache Whether `Mapper` should cache positions while traversing the view tree looking for `expectedModelOffset`.
	* @returns View position mapped to `targetModelOffset`.
	*/ _findPositionStartingFrom(startViewPosition, startModelOffset, targetModelOffset, viewContainer, useCache) {
        let viewParent = startViewPosition.parent;
        let viewOffset = startViewPosition.offset;
        if (viewParent.is("$text")) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewParent, targetModelOffset - startModelOffset);
        let viewNode;
        let traversedModelOffset = startModelOffset;
        let lastLength = 0;
        while(traversedModelOffset < targetModelOffset){
            viewNode = viewParent.getChild(viewOffset);
            if (!viewNode) {
                if (viewParent == viewContainer) /**
				* A model position could not be mapped to the view because specified model offset was too big and could not be
				* found inside the mapped view element or view document fragment.
				*
				* @error mapping-model-offset-not-found
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("mapping-model-offset-not-found", this, {
                    modelOffset: targetModelOffset,
                    viewContainer: viewContainer
                });
                else {
                    viewOffset = viewParent.parent.getChildIndex(viewParent) + 1;
                    viewParent = viewParent.parent;
                    if (useCache) this._cache.save(viewParent, viewOffset, viewContainer, traversedModelOffset);
                    continue;
                }
            }
            if (useCache) lastLength = this._getModelLengthAndCache(viewNode, viewContainer, traversedModelOffset);
            else lastLength = this.getModelLength(viewNode);
            traversedModelOffset += lastLength;
            viewOffset++;
        }
        let viewPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewParent, viewOffset);
        if (useCache) while(viewPosition.isAtEnd && viewPosition.parent !== viewContainer && viewPosition.parent.parent){
            const cacheViewParent = viewPosition.parent.parent;
            const cacheViewOffset = cacheViewParent.getChildIndex(viewPosition.parent) + 1;
            this._cache.save(cacheViewParent, cacheViewOffset, viewContainer, traversedModelOffset);
            viewPosition = new $b9b9f2bdf9c6137f$export$7534acacc32db851(cacheViewParent, cacheViewOffset);
        }
        if (traversedModelOffset == targetModelOffset) return this._moveViewPositionToTextNode(viewPosition);
        else return this._findPositionStartingFrom(new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewNode, 0), traversedModelOffset - lastLength, targetModelOffset, viewContainer, useCache);
    }
    /**
	* Gets the length of the view element in the model and updates cache values after each view item it visits.
	*
	* See also {@link #getModelLength}.
	*
	* @param viewNode View node.
	* @param viewContainer Ancestor of `viewNode` that is a mapped view element.
	* @param modelOffset Model offset at which the `viewNode` starts.
	* @returns Length of the node in the tree model.
	*/ _getModelLengthAndCache(viewNode, viewContainer, modelOffset) {
        let len = 0;
        if (this._viewToModelMapping.has(viewNode)) len = 1;
        else if (viewNode.is("$text")) len = viewNode.data.length;
        else if (!viewNode.is("uiElement")) for (const child of viewNode.getChildren())len += this._getModelLengthAndCache(child, viewContainer, modelOffset + len);
        this._cache.save(viewNode.parent, viewNode.index + 1, viewContainer, modelOffset + len);
        return len;
    }
    /**
	* Because we prefer positions in the text nodes over positions next to text nodes, if the view position was next to a text node,
	* it moves it into the text node instead.
	*
	* ```
	* <p>[]<b>foo</b></p> -> <p>[]<b>foo</b></p> // do not touch if position is not directly next to text
	* <p>foo[]<b>foo</b></p> -> <p>foo{}<b>foo</b></p> // move to text node
	* <p><b>[]foo</b></p> -> <p><b>{}foo</b></p> // move to text node
	* ```
	*
	* @param viewPosition Position potentially next to the text node.
	* @returns Position in the text node if possible.
	*/ _moveViewPositionToTextNode(viewPosition) {
        const nodeBefore = viewPosition.nodeBefore;
        const nodeAfter = viewPosition.nodeAfter;
        if (nodeBefore && nodeBefore.is("view:$text")) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeBefore, nodeBefore.data.length);
        else if (nodeAfter && nodeAfter.is("view:$text")) return new $b9b9f2bdf9c6137f$export$7534acacc32db851(nodeAfter, 0);
        return viewPosition;
    }
};
/**
* Cache mechanism for {@link module:engine/conversion/mapper~Mapper Mapper}.
*
* `MapperCache` improves performance for model-to-view position mapping, which is the main `Mapper` task. Asking for a mapping is much
* more frequent than actually performing changes, and even if the change happens, we can still partially keep the cache. This makes
* caching a useful strategy for `Mapper`.
*
* `MapperCache` will store some data for view elements or view document fragments that are mapped by the `Mapper`. These view items
* are "tracked" by the `MapperCache`. For such view items, we will keep entries of model offsets inside their mapped counterpart. For
* the cached model offsets, we will keep a view position that is inside the tracked item. This allows us to either get the mapping
* instantly, or at least in less steps than when calculating it from the beginning.
*
* Important problem related to caching is invalidating the cache. The cache must be invalidated each time the tracked view item changes.
* Additionally, we should invalidate as small part of the cache as possible. Since all the logic is encapsulated inside `MapperCache`,
* the `MapperCache` listens to view items {@link module:engine/view/node~ViewNodeChangeEvent `change` event} and reacts to it.
* Then, it invalidates just the part of the cache that is "after" the changed part of the view.
*
* As mentioned, `MapperCache` currently is used only for model-to-view position mapping as it was much bigger problem than view-to-model
* mapping. However, it should be possible to use it also for view-to-model.
*
* The main assumptions regarding `MapperCache` are:
*
* * it is an internal tool, used by `Mapper`, transparent to the outside (no additional effort when developing a plugin or a converter),
* * it stores all the necessary data internally, which makes it easier to disable or debug,
* * it is optimized for initial downcast process (long insertions), which is crucial for editor init and data save,
* * it does not save all possible positions mapping for memory considerations, although it is a possible improvement, which may increase
*   performance, as well as simplify some parts of the `MapperCache` logic.
*
* @internal
*/ var $b9b9f2bdf9c6137f$export$9b1415706498766d = class extends $b9b9f2bdf9c6137f$var$MapperCacheBase {
    /**
	* For every view element or document fragment tracked by `MapperCache`, it holds currently cached data, or more precisely,
	* model offset to view position mappings. See also `MappingCache` and `CacheItem`.
	*
	* If an item is tracked by `MapperCache` it has an entry in this structure, so this structure can be used to check which items
	* are tracked by `MapperCache`. When an item is no longer tracked, it is removed from this structure.
	*
	* Although `MappingCache` and `CacheItem` structures allows for caching any model offsets and view positions, we only cache
	* values for model offsets that are after a view node. So, in essence, positions inside text nodes are not cached. However, it takes
	* from one to at most a few steps, to get from a cached position to a position that is inside a view text node.
	*
	* Additionally, only one item per `modelOffset` is cached. There can be several view positions that map to the same `modelOffset`.
	* Only the first save for `modelOffset` is stored.
	*/ _cachedMapping = /* @__PURE__ */ new WeakMap();
    /**
	* When `MapperCache` {@link ~MapperCache#save saves} view position -> model offset mapping, a `CacheItem` is inserted into certain
	* `MappingCache#cacheList` at some index. Additionally, we store that index with the view node that is before the cached view position.
	*
	* This allows to quickly get a cache list item related to certain view node, and hence, for fast cache invalidation.
	*
	* For example, consider view: `<p>Some <strong>bold</strong> text.</p>`, where `<p>` is a view element tracked by `MapperCache`.
	* If all `<p>` children were visited by `MapperCache`, then `<p>` cache list would have four items, related to following model offsets:
	* `0`, `5`, `9`, `15`. Then, view node `"Some "` would have index `1`, `<strong>` index `2`, and `" text." index `3`.
	*
	* Note that the index related with a node is always greater than `0`. The first item in cache list is always for model offset `0`
	* (and view offset `0`), and it is not related to any node.
	*/ _nodeToCacheListIndex = /* @__PURE__ */ new WeakMap();
    /**
	* Callback fired whenever there is a direct or indirect children change in tracked view element or tracked view document fragment.
	*
	* This is specified as a property to make it easier to set as an event callback and to later turn off that event.
	*/ _invalidateOnChildrenChangeCallback = (evt, viewNode, data)=>{
        this._clearCacheInsideParent(viewNode, data.index);
    };
    /**
	* Callback fired whenever a view text node directly or indirectly inside a tracked view element or tracked view document fragment
	* changes its text data.
	*
	* This is specified as a property to make it easier to set as an event callback and to later turn off that event.
	*/ _invalidateOnTextChangeCallback = (evt, viewNode)=>{
        this._clearCacheAfter(viewNode);
    };
    /**
	* Saves cache for given view position mapping <-> model offset mapping. The view position should be after a node (i.e. it cannot
	* be the first position inside its parent, or in other words, `viewOffset` must be greater than `0`).
	*
	* Note, that if `modelOffset` for given `viewContainer` was already saved, the stored view position (i.e. parent+offset) will not
	* be overwritten. However, it is important to still save it, as we still store additional data related to cached view positions.
	*
	* @param viewParent View position parent.
	* @param viewOffset View position offset. Must be greater than `0`.
	* @param viewContainer Tracked view position ascendant (it may be the direct parent of the view position).
	* @param modelOffset Model offset in the model element or document fragment which is mapped to `viewContainer`.
	*/ save(viewParent, viewOffset, viewContainer, modelOffset) {
        const cache = this._cachedMapping.get(viewContainer);
        const cacheItem = cache.cacheMap.get(modelOffset);
        if (cacheItem) {
            const viewChild = viewParent.getChild(viewOffset - 1);
            const index = cacheItem.viewPosition.nodeBefore ? this._nodeToCacheListIndex.get(cacheItem.viewPosition.nodeBefore) : 0;
            this._nodeToCacheListIndex.set(viewChild, index);
            return;
        }
        const newCacheItem = {
            viewPosition: new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewParent, viewOffset),
            modelOffset: modelOffset
        };
        cache.maxModelOffset = modelOffset > cache.maxModelOffset ? modelOffset : cache.maxModelOffset;
        cache.cacheMap.set(modelOffset, newCacheItem);
        let i = cache.cacheList.length - 1;
        while(i >= 0 && cache.cacheList[i].modelOffset > modelOffset)i--;
        cache.cacheList.splice(i + 1, 0, newCacheItem);
        if (viewOffset > 0) {
            const viewChild = viewParent.getChild(viewOffset - 1);
            this._nodeToCacheListIndex.set(viewChild, i + 1);
        }
    }
    /**
	* For given `modelOffset` inside a model element mapped to given `viewContainer`, it returns the closest saved cache item
	* (view position and related model offset) to the requested one.
	*
	* It can be exactly the requested mapping, or it can be mapping that is the closest starting point to look for the requested mapping.
	*
	* `viewContainer` must be a view element or document fragment that is mapped by the {@link ~Mapper Mapper}.
	*
	* If `viewContainer` is not yet tracked by the `MapperCache`, it will be automatically tracked after calling this method.
	*
	* Note: this method will automatically "hoist" cached positions, i.e. it will return a position that is closest to the tracked element.
	*
	* For example, if `<p>` is tracked element, and `^` is cached position:
	*
	* ```
	* <p>This is <strong>some <em>heavily <u>formatted</u>^</em></strong> text.</p>
	* ```
	*
	* If this position would be returned, instead, a position directly in `<p>` would be returned:
	*
	* ```
	* <p>This is <strong>some <em>heavily <u>formatted</u></em></strong>^ text.</p>
	* ```
	*
	* Note, that `modelOffset` for both positions is the same.
	*
	* @param viewContainer Tracked view element or document fragment, which cache will be used.
	* @param modelOffset Model offset in a model element or document fragment, which is mapped to `viewContainer`.
	*/ getClosest(viewContainer, modelOffset) {
        const cache = this._cachedMapping.get(viewContainer);
        let result;
        if (cache) {
            if (modelOffset > cache.maxModelOffset) result = cache.cacheList[cache.cacheList.length - 1];
            else {
                const cacheItem = cache.cacheMap.get(modelOffset);
                if (cacheItem) result = cacheItem;
                else result = this._findInCacheList(cache.cacheList, modelOffset);
            }
        } else result = this.startTracking(viewContainer);
        return {
            modelOffset: result.modelOffset,
            viewPosition: result.viewPosition.clone()
        };
    }
    /**
	* Starts tracking given `viewContainer`, which must be mapped to a model element or model document fragment.
	*
	* Note, that this method is automatically called by
	* {@link module:engine/conversion/mapper~MapperCache#getClosest `MapperCache#getClosest()`} and there is no need to call it manually.
	*
	* This method initializes the cache for `viewContainer` and adds callbacks for
	* {@link module:engine/view/node~ViewNodeChangeEvent `change` event} fired by `viewContainer`. `MapperCache` listens to `change` event
	* on the tracked elements to invalidate the stored cache.
	*/ startTracking(viewContainer) {
        const initialCacheItem = {
            viewPosition: new $b9b9f2bdf9c6137f$export$7534acacc32db851(viewContainer, 0),
            modelOffset: 0
        };
        const initialCache = {
            maxModelOffset: 0,
            cacheList: [
                initialCacheItem
            ],
            cacheMap: /* @__PURE__ */ new Map([
                [
                    0,
                    initialCacheItem
                ]
            ])
        };
        this._cachedMapping.set(viewContainer, initialCache);
        viewContainer.on("change:children", this._invalidateOnChildrenChangeCallback);
        viewContainer.on("change:text", this._invalidateOnTextChangeCallback);
        return initialCacheItem;
    }
    /**
	* Stops tracking given `viewContainer`.
	*
	* It removes the cached data and stops listening to {@link module:engine/view/node~ViewNodeChangeEvent `change` event} on the
	* `viewContainer`.
	*/ stopTracking(viewContainer) {
        viewContainer.off("change:children", this._invalidateOnChildrenChangeCallback);
        viewContainer.off("change:text", this._invalidateOnTextChangeCallback);
        this._cachedMapping.delete(viewContainer);
    }
    /**
	* Invalidates cache inside `viewParent`, starting from given `index` in that parent.
	*
	* This method may clear a bit more cache than just what was saved after given `index`, but it is guaranteed that at least it
	* will invalidate everything after `index`.
	*/ _clearCacheInsideParent(viewParent, index) {
        if (index == 0) {
            if (this._cachedMapping.has(viewParent)) this._clearCacheAll(viewParent);
            else this._clearCacheInsideParent(viewParent.parent, viewParent.index);
        } else {
            const lastValidNode = viewParent.getChild(index - 1);
            this._clearCacheAfter(lastValidNode);
        }
    }
    /**
	* Clears all the cache for given tracked `viewContainer`.
	*/ _clearCacheAll(viewContainer) {
        const cache = this._cachedMapping.get(viewContainer);
        if (cache.maxModelOffset > 0) {
            cache.maxModelOffset = 0;
            cache.cacheList.length = 1;
            cache.cacheMap.clear();
            cache.cacheMap.set(0, cache.cacheList[0]);
        }
    }
    /**
	* Clears all the stored cache that is after given `viewNode`. The `viewNode` can be any node that is inside a tracked view element
	* or view document fragment.
	*
	* In reality, this function may clear a bit more cache than just "starting after" `viewNode`, but it is guaranteed that at least
	* all cache after `viewNode` is invalidated.
	*/ _clearCacheAfter(viewNode) {
        const cacheListIndex = this._nodeToCacheListIndex.get(viewNode);
        if (cacheListIndex === void 0) {
            const viewParent = viewNode.parent;
            if (!this._cachedMapping.has(viewParent)) this._clearCacheInsideParent(viewParent.parent, viewParent.index);
            return;
        }
        let viewContainer = viewNode.parent;
        while(!this._cachedMapping.has(viewContainer))viewContainer = viewContainer.parent;
        this._clearCacheFromCacheIndex(viewContainer, cacheListIndex);
    }
    /**
	* Clears all the cache in the cache list related to given `viewContainer`, starting from `index` (inclusive).
	*/ _clearCacheFromCacheIndex(viewContainer, index) {
        if (index === 0) index = 1;
        const cache = this._cachedMapping.get(viewContainer);
        const cacheItem = cache.cacheList[index - 1];
        if (!cacheItem) return;
        cache.maxModelOffset = cacheItem.modelOffset;
        const clearedItems = cache.cacheList.splice(index);
        for (const item of clearedItems){
            cache.cacheMap.delete(item.modelOffset);
            const viewNode = item.viewPosition.nodeBefore;
            this._nodeToCacheListIndex.delete(viewNode);
        }
    }
    /**
	* Finds a cache item in the given cache list, which `modelOffset` is closest (but smaller or equal) to given `offset`.
	*
	* Since `cacheList` is a sorted array, this uses binary search to retrieve the item quickly.
	*/ _findInCacheList(cacheList, offset) {
        let start = 0;
        let end = cacheList.length - 1;
        let index = end - start >> 1;
        let item = cacheList[index];
        while(start < end){
            if (item.modelOffset < offset) start = index + 1;
            else end = index - 1;
            index = start + (end - start >> 1);
            item = cacheList[index];
        }
        return item.modelOffset <= offset ? item : cacheList[index - 1];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/modelconsumable
*/ /**
* Manages a list of consumable values for the {@link module:engine/model/item~ModelItem model items}.
*
* Consumables are various aspects of the model. A model item can be broken down into separate, single properties that might be
* taken into consideration when converting that item.
*
* `ModelConsumable` is used by {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} while analyzing the changed
* parts of {@link module:engine/model/document~ModelDocument the document}. The added / changed / removed model items are broken down
* into singular properties (the item itself and its attributes). All those parts are saved in `ModelConsumable`. Then,
* during conversion, when the given part of a model item is converted (i.e. the view element has been inserted into the view,
* but without attributes), the consumable value is removed from `ModelConsumable`.
*
* For model items, `ModelConsumable` stores consumable values of one of following types: `insert`, `addattribute:<attributeKey>`,
* `changeattributes:<attributeKey>`, `removeattributes:<attributeKey>`.
*
* In most cases, it is enough to let th {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher}
* gather consumable values, so there is no need to use
* the {@link module:engine/conversion/modelconsumable~ModelConsumable#add add method} directly.
* However, it is important to understand how consumable values can be
* {@link module:engine/conversion/modelconsumable~ModelConsumable#consume consumed}.
* See {@link module:engine/conversion/downcasthelpers default downcast converters} for more information.
*
* Keep in mind that one conversion event may have multiple callbacks (converters) attached to it. Each of those is
* able to convert one or more parts of the model. However, when one of those callbacks actually converts
* something, the others should not, because they would duplicate the results. Using `ModelConsumable` helps to avoid
* this situation, because callbacks should only convert these values that were not yet consumed from `ModelConsumable`.
*
* Consuming multiple values in a single callback:
*
* ```ts
* // Converter for custom `imageBlock` element that might have a `caption` element inside which changes
* // how the image is displayed in the view:
* //
* // Model:
* //
* // [imageBlock]
* //   └─ [caption]
* //       └─ foo
* //
* // View:
* //
* // <figure>
* //   ├─ <img />
* //   └─ <caption>
* //       └─ foo
* modelConversionDispatcher.on( 'insert:imageBlock', ( evt, data, conversionApi ) => {
* 	// First, consume the `imageBlock` element.
* 	conversionApi.consumable.consume( data.item, 'insert' );
*
* 	// Just create normal image element for the view.
* 	// Maybe it will be "decorated" later.
* 	const viewImage = new ViewElement( 'img' );
* 	const insertPosition = conversionApi.mapper.toViewPosition( data.range.start );
* 	const viewWriter = conversionApi.writer;
*
* 	// Check if the `imageBlock` element has children.
* 	if ( data.item.childCount > 0 ) {
* 		const modelCaption = data.item.getChild( 0 );
*
* 		// `modelCaption` insertion change is consumed from consumable values.
* 		// It will not be converted by other converters, but it's children (probably some text) will be.
* 		// Through mapping, converters for text will know where to insert contents of `modelCaption`.
* 		if ( conversionApi.consumable.consume( modelCaption, 'insert' ) ) {
* 			const viewCaption = new ViewElement( 'figcaption' );
*
* 			const viewImageHolder = new ViewElement( 'figure', null, [ viewImage, viewCaption ] );
*
* 			conversionApi.mapper.bindElements( modelCaption, viewCaption );
* 			conversionApi.mapper.bindElements( data.item, viewImageHolder );
* 			viewWriter.insert( insertPosition, viewImageHolder );
* 		}
* 	} else {
* 		conversionApi.mapper.bindElements( data.item, viewImage );
* 		viewWriter.insert( insertPosition, viewImage );
* 	}
*
* 	evt.stop();
* } );
* ```
*/ var $b9b9f2bdf9c6137f$export$347a09ce4e7f1aab = class {
    /**
	* Contains list of consumable values.
	*/ _consumable = /* @__PURE__ */ new Map();
    /**
	* For each {@link module:engine/model/textproxy~ModelTextProxy} added to `ModelConsumable`, this registry holds a parent
	* of that `ModelTextProxy` and the start and end indices of that `ModelTextProxy`. This allows identification of the `ModelTextProxy`
	* instances that point to the same part of the model but are different instances. Each distinct `ModelTextProxy`
	* is given a unique `Symbol` which is then registered as consumable. This process is transparent for the `ModelConsumable`
	* API user because whenever `ModelTextProxy` is added, tested, consumed or reverted, the internal mechanisms of
	* `ModelConsumable` translate `ModelTextProxy` to that unique `Symbol`.
	*/ _textProxyRegistry = /* @__PURE__ */ new Map();
    /**
	* Adds a consumable value to the consumables list and links it with a given model item.
	*
	* ```ts
	* modelConsumable.add( modelElement, 'insert' ); // Add `modelElement` insertion change to consumable values.
	* modelConsumable.add( modelElement, 'addAttribute:bold' ); // Add `bold` attribute insertion on `modelElement` change.
	* modelConsumable.add( modelElement, 'removeAttribute:bold' ); // Add `bold` attribute removal on `modelElement` change.
	* modelConsumable.add( modelSelection, 'selection' ); // Add `modelSelection` to consumable values.
	* modelConsumable.add( modelRange, 'range' ); // Add `modelRange` to consumable values.
	* ```
	*
	* @param item Model item, range or selection that has the consumable.
	* @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
	* Second colon and everything after will be cut. Passing event name is a safe and good practice.
	*/ add(item, type) {
        type = $b9b9f2bdf9c6137f$var$_normalizeConsumableType(type);
        if (item instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) item = this._getSymbolForTextProxy(item);
        if (!this._consumable.has(item)) this._consumable.set(item, /* @__PURE__ */ new Map());
        this._consumable.get(item).set(type, true);
    }
    /**
	* Removes a given consumable value from a given model item.
	*
	* ```ts
	* modelConsumable.consume( modelElement, 'insert' ); // Remove `modelElement` insertion change from consumable values.
	* modelConsumable.consume( modelElement, 'addAttribute:bold' ); // Remove `bold` attribute insertion on `modelElement` change.
	* modelConsumable.consume( modelElement, 'removeAttribute:bold' ); // Remove `bold` attribute removal on `modelElement` change.
	* modelConsumable.consume( modelSelection, 'selection' ); // Remove `modelSelection` from consumable values.
	* modelConsumable.consume( modelRange, 'range' ); // Remove 'modelRange' from consumable values.
	* ```
	*
	* @param item Model item, range or selection from which consumable will be consumed.
	* @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
	* Second colon and everything after will be cut. Passing event name is a safe and good practice.
	* @returns `true` if consumable value was available and was consumed, `false` otherwise.
	*/ consume(item, type) {
        type = $b9b9f2bdf9c6137f$var$_normalizeConsumableType(type);
        if (item instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) item = this._getSymbolForTextProxy(item);
        if (this.test(item, type)) {
            this._consumable.get(item).set(type, false);
            return true;
        } else return false;
    }
    /**
	* Tests whether there is a consumable value of a given type connected with a given model item.
	*
	* ```ts
	* modelConsumable.test( modelElement, 'insert' ); // Check for `modelElement` insertion change.
	* modelConsumable.test( modelElement, 'addAttribute:bold' ); // Check for `bold` attribute insertion on `modelElement` change.
	* modelConsumable.test( modelElement, 'removeAttribute:bold' ); // Check for `bold` attribute removal on `modelElement` change.
	* modelConsumable.test( modelSelection, 'selection' ); // Check if `modelSelection` is consumable.
	* modelConsumable.test( modelRange, 'range' ); // Check if `modelRange` is consumable.
	* ```
	*
	* @param item Model item, range or selection to be tested.
	* @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
	* Second colon and everything after will be cut. Passing event name is a safe and good practice.
	* @returns `null` if such consumable was never added, `false` if the consumable values was
	* already consumed or `true` if it was added and not consumed yet.
	*/ test(item, type) {
        type = $b9b9f2bdf9c6137f$var$_normalizeConsumableType(type);
        if (item instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) item = this._getSymbolForTextProxy(item);
        const itemConsumables = this._consumable.get(item);
        if (itemConsumables === void 0) return null;
        const value = itemConsumables.get(type);
        if (value === void 0) return null;
        return value;
    }
    /**
	* Reverts consuming of a consumable value.
	*
	* ```ts
	* modelConsumable.revert( modelElement, 'insert' ); // Revert consuming `modelElement` insertion change.
	* modelConsumable.revert( modelElement, 'addAttribute:bold' ); // Revert consuming `bold` attribute insert from `modelElement`.
	* modelConsumable.revert( modelElement, 'removeAttribute:bold' ); // Revert consuming `bold` attribute remove from `modelElement`.
	* modelConsumable.revert( modelSelection, 'selection' ); // Revert consuming `modelSelection`.
	* modelConsumable.revert( modelRange, 'range' ); // Revert consuming `modelRange`.
	* ```
	*
	* @param item Model item, range or selection to be reverted.
	* @param type Consumable type.
	* @returns `true` if consumable has been reversed, `false` otherwise. `null` if the consumable has
	* never been added.
	*/ revert(item, type) {
        type = $b9b9f2bdf9c6137f$var$_normalizeConsumableType(type);
        if (item instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) item = this._getSymbolForTextProxy(item);
        const test = this.test(item, type);
        if (test === false) {
            this._consumable.get(item).set(type, true);
            return true;
        } else if (test === true) return false;
        return null;
    }
    /**
	* Verifies if all events from the specified group were consumed.
	*
	* @param eventGroup The events group to verify.
	*/ verifyAllConsumed(eventGroup) {
        const items = [];
        for (const [item, consumables] of this._consumable)for (const [event, canConsume] of consumables){
            const eventPrefix = event.split(":")[0];
            if (canConsume && eventGroup == eventPrefix) items.push({
                event: event,
                item: item.name || item.description
            });
        }
        if (items.length) /**
		* Some of the {@link module:engine/model/item~ModelItem model items} were not consumed while downcasting the model to view.
		*
		* This might be the effect of:
		*
		* * A missing converter for some model elements. Make sure that you registered downcast converters for all model elements.
		* * A custom converter that does not consume converted items. Make sure that you
		* {@link module:engine/conversion/modelconsumable~ModelConsumable#consume consumed} all model elements that you converted
		* from the model to the view.
		* * A custom converter that called `event.stop()`. When providing a custom converter, keep in mind that you should not stop
		* the event. If you stop it then the default converter at the `lowest` priority will not trigger the conversion of this node's
		* attributes and child nodes.
		*
		* @error conversion-model-consumable-not-consumed
		* @param {Array.<module:engine/model/item~ModelItem>} items Items that were not consumed.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-model-consumable-not-consumed", null, {
            items: items
        });
    }
    /**
	* Gets a unique symbol for the passed {@link module:engine/model/textproxy~ModelTextProxy} instance.
	* All `ModelTextProxy` instances that have same parent, same start index and same end index will get the same symbol.
	*
	* Used internally to correctly consume `ModelTextProxy` instances.
	*
	* @internal
	* @param textProxy `ModelTextProxy` instance to get a symbol for.
	* @returns Symbol representing all equal instances of `ModelTextProxy`.
	*/ _getSymbolForTextProxy(textProxy) {
        let symbol = null;
        const startMap = this._textProxyRegistry.get(textProxy.startOffset);
        if (startMap) {
            const endMap = startMap.get(textProxy.endOffset);
            if (endMap) symbol = endMap.get(textProxy.parent);
        }
        if (!symbol) symbol = this._addSymbolForTextProxy(textProxy);
        return symbol;
    }
    /**
	* Adds a symbol for the given {@link module:engine/model/textproxy~ModelTextProxy} instance.
	*
	* Used internally to correctly consume `ModelTextProxy` instances.
	*
	* @param textProxy Text proxy instance.
	* @returns Symbol generated for given `ModelTextProxy`.
	*/ _addSymbolForTextProxy(textProxy) {
        const start = textProxy.startOffset;
        const end = textProxy.endOffset;
        const parent = textProxy.parent;
        const symbol = Symbol("$textProxy:" + textProxy.data);
        let startMap;
        let endMap;
        startMap = this._textProxyRegistry.get(start);
        if (!startMap) {
            startMap = /* @__PURE__ */ new Map();
            this._textProxyRegistry.set(start, startMap);
        }
        endMap = startMap.get(end);
        if (!endMap) {
            endMap = /* @__PURE__ */ new Map();
            startMap.set(end, endMap);
        }
        endMap.set(parent, symbol);
        return symbol;
    }
};
/**
* Returns a normalized consumable type name from the given string. A normalized consumable type name is a string that has
* at most one colon, for example: `insert` or `addMarker:highlight`. If a string to normalize has more "parts" (more colons),
* the further parts are dropped, for example: `addattribute:bold:$text` -> `addattributes:bold`.
*
* @param type Consumable type.
* @returns Normalized consumable type.
*/ function $b9b9f2bdf9c6137f$var$_normalizeConsumableType(type) {
    const parts = type.split(":");
    if (parts[0] == "insert") return parts[0];
    if (parts[0] == "addMarker" || parts[0] == "removeMarker") return type;
    return parts.length > 1 ? parts[0] + ":" + parts[1] : parts[0];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Sorts markers so the downcast result is deterministic regardless of the order
* markers were added to the marker collection.
*
* The sort key is the marker's range, ordered "right-to-left" through the document so that
* a marker's opening boundary is processed *after* any markers nested inside it. This way
* the outer marker wraps the inner ones at conversion time.
*
* Cases (positions shown as `0123456789`, sort result top-to-bottom):
*
* 1. Non-overlapping ranges — sorted by position, last range first:
*
*        a: [--]               →   c, b, a
*        b:     [--]
*        c:        [--]
*
* 2. Adjacent ranges (end === start) — treated as non-overlapping:
*
*        first:  [---]         →   third, second, first
*        second:    [---]
*        third:        [---]
*
* 3. Nested ranges (same start, different ends) — inner first, outer last:
*
*        shorter: [-]          →   shorter, longer
*        longer:  [---]
*
* 4. Partially overlapping ranges — sorted by start position:
*
*        earlier: [---]        →   later, earlier
*        later:     [---]
*
* 5. Identical ranges — fall back to reverse name comparison:
*
*        alpha:   [---]        →   charlie, bravo, alpha
*        bravo:   [---]
*        charlie: [---]
*
* @internal
*/ function $b9b9f2bdf9c6137f$var$compareMarkersForDowncast([name1, range1], [name2, range2]) {
    if (range1.end.compareWith(range2.start) !== "after") return 1;
    else if (range1.start.compareWith(range2.end) !== "before") return -1;
    else switch(range1.start.compareWith(range2.start)){
        case "before":
            return 1;
        case "after":
            return -1;
        default:
            switch(range1.end.compareWith(range2.end)){
                case "before":
                    return -1;
                case "after":
                    return 1;
                default:
                    return name2.localeCompare(name1);
            }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/downcastdispatcher
*/ const $b9b9f2bdf9c6137f$var$DowncastDispatcherBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* The downcast dispatcher is a central point of downcasting (conversion from the model to the view), which is a process of reacting
* to changes in the model and firing a set of events. The callbacks listening to these events are called converters. The
* converters' role is to convert the model changes to changes in view (for example, adding view nodes or
* changing attributes on view elements).
*
* During the conversion process, downcast dispatcher fires events basing on the state of the model and prepares
* data for these events. It is important to understand that the events are connected with the changes done on the model,
* for example: "a node has been inserted" or "an attribute has changed". This is in contrary to upcasting (a view-to-model conversion)
* where you convert the view state (view nodes) to a model tree.
*
* The events are prepared basing on a diff created by the {@link module:engine/model/differ~Differ Differ}, which buffers them
* and then passes to the downcast dispatcher as a diff between the old model state and the new model state.
*
* Note that because the changes are converted, there is a need to have a mapping between the model structure and the view structure.
* To map positions and elements during the downcast (a model-to-view conversion), use {@link module:engine/conversion/mapper~Mapper}.
*
* Downcast dispatcher fires the following events for model tree changes:
*
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert `insert`} &ndash;
* If a range of nodes was inserted to the model tree.
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:remove `remove`} &ndash;
* If a range of nodes was removed from the model tree.
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute `attribute`} &ndash;
* If an attribute was added, changed or removed from a model node.
*
* For {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert `insert`}
* and {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute `attribute`},
* the downcast dispatcher generates {@link module:engine/conversion/modelconsumable~ModelConsumable consumables}.
* These are used to have control over which changes have already been consumed. It is useful when some converters
* overwrite others or convert multiple changes (for example, it converts an insertion of an element and also converts that
* element's attributes during the insertion).
*
* Additionally, downcast dispatcher fires events for {@link module:engine/model/markercollection~Marker marker} changes:
*
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker `addMarker`} &ndash; If a marker was added.
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:removeMarker `removeMarker`} &ndash; If a marker was
* removed.
*
* Note that changing a marker is done through removing the marker from the old range and adding it to the new range,
* so both of these events are fired.
*
* Finally, a downcast dispatcher also handles firing events for the {@link module:engine/model/selection model selection}
* conversion:
*
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:selection `selection`}
* &ndash; Converts the selection from the model to the view.
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute `attribute`}
* &ndash; Fired for every selection attribute.
* * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker `addMarker`}
* &ndash; Fired for every marker that contains a selection.
*
* Unlike the model tree and the markers, the events for selection are not fired for changes but for a selection state.
*
* When providing custom listeners for a downcast dispatcher, remember to check whether a given change has not been
* {@link module:engine/conversion/modelconsumable~ModelConsumable#consume consumed} yet.
*
* When providing custom listeners for a downcast dispatcher, keep in mind that you **should not** stop the event. If you stop it,
* then the default converter at the `lowest` priority will not trigger the conversion of this node's attributes and child nodes.
*
* When providing custom listeners for a downcast dispatcher, remember to use the provided
* {@link module:engine/view/downcastwriter~ViewDowncastWriter view downcast writer} to apply changes to the view document.
*
* You can read more about conversion in the following guide:
*
* * {@glink framework/deep-dive/conversion/downcast Downcast conversion}
*
* An example of a custom converter for the downcast dispatcher:
*
* ```ts
* // You will convert inserting a "paragraph" model element into the model.
* downcastDispatcher.on( 'insert:paragraph', ( evt, data, conversionApi ) => {
* 	// Remember to check whether the change has not been consumed yet and consume it.
* 	if ( !conversionApi.consumable.consume( data.item, 'insert' ) ) {
* 		return;
* 	}
*
* 	// Translate the position in the model to a position in the view.
* 	const viewPosition = conversionApi.mapper.toViewPosition( data.range.start );
*
* 	// Create a <p> element that will be inserted into the view at the `viewPosition`.
* 	const viewElement = conversionApi.writer.createContainerElement( 'p' );
*
* 	// Bind the newly created view element to the model element so positions will map accordingly in the future.
* 	conversionApi.mapper.bindElements( data.item, viewElement );
*
* 	// Add the newly created view element to the view.
* 	conversionApi.writer.insert( viewPosition, viewElement );
* } );
* ```
*/ var $b9b9f2bdf9c6137f$export$a3db87c8d34df7e7 = class extends $b9b9f2bdf9c6137f$var$DowncastDispatcherBase {
    /**
	* A template for an interface passed by the dispatcher to the event callbacks.
	*
	* @internal
	*/ _conversionApi;
    /**
	* A map of already fired events for a given `ModelConsumable`.
	*/ _firedEventsMap;
    /**
	* Creates a downcast dispatcher instance.
	*
	* @see module:engine/conversion/downcastdispatcher~DowncastConversionApi
	*
	* @param conversionApi Additional properties for an interface that will be passed to events fired
	* by the downcast dispatcher.
	*/ constructor(conversionApi){
        super();
        this._conversionApi = {
            dispatcher: this,
            ...conversionApi
        };
        this._firedEventsMap = /* @__PURE__ */ new WeakMap();
    }
    /**
	* Converts changes buffered in the given {@link module:engine/model/differ~Differ model differ}
	* and fires conversion events based on it.
	*
	* @fires insert
	* @fires remove
	* @fires attribute
	* @fires addMarker
	* @fires removeMarker
	* @fires reduceChanges
	* @param differ The differ object with buffered changes.
	* @param markers Markers related to the model fragment to convert.
	* @param writer The view writer that should be used to modify the view document.
	*/ convertChanges(differ, markers, writer) {
        const refreshedItems = differ.getRefreshedItems();
        const conversionApi = this._createConversionApi(writer, refreshedItems);
        for (const change of differ.getMarkersToRemove())this._convertMarkerRemove(change.name, change.range, conversionApi);
        const changes = this._reduceChanges(differ.getChanges(), refreshedItems);
        for (const entry of changes)if (entry.type === "insert") this._convertInsert($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(entry.position, entry.length), conversionApi);
        else if (entry.type === "reinsert") this._convertReinsert($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(entry.position, entry.length), conversionApi);
        else if (entry.type === "remove") this._convertRemove(entry.position, entry.length, entry.name, conversionApi);
        else this._convertAttribute(entry.range, entry.attributeKey, entry.attributeOldValue, entry.attributeNewValue, conversionApi);
        conversionApi.mapper.flushDeferredBindings();
        for (const markerName of conversionApi.mapper.flushUnboundMarkerNames()){
            const markerRange = markers.get(markerName).getRange();
            this._convertMarkerRemove(markerName, markerRange, conversionApi);
            this._convertMarkerAdd(markerName, markerRange, conversionApi);
        }
        const markersToAdd = differ.getMarkersToAdd().sort((a, b)=>$b9b9f2bdf9c6137f$var$compareMarkersForDowncast([
                a.name,
                a.range
            ], [
                b.name,
                b.range
            ]));
        for (const change of markersToAdd)this._convertMarkerAdd(change.name, change.range, conversionApi);
        conversionApi.consumable.verifyAllConsumed("insert");
    }
    /**
	* Starts a conversion of a model range and the provided markers.
	*
	* @fires insert
	* @fires attribute
	* @fires addMarker
	* @param range The inserted range.
	* @param markers The map of markers that should be down-casted.
	* @param writer The view writer that should be used to modify the view document.
	* @param options Optional options object passed to `convertionApi.options`.
	*/ convert(range, markers, writer, options = {}) {
        const conversionApi = this._createConversionApi(writer, void 0, options);
        this._convertInsert(range, conversionApi);
        for (const [name, range] of Array.from(markers).sort($b9b9f2bdf9c6137f$var$compareMarkersForDowncast))this._convertMarkerAdd(name, range, conversionApi);
        conversionApi.consumable.verifyAllConsumed("insert");
    }
    /**
	* Starts the model selection conversion.
	*
	* Fires events for a given {@link module:engine/model/selection~ModelSelection selection} to start the selection conversion.
	*
	* @fires selection
	* @fires addMarker
	* @fires attribute
	* @param selection The selection to convert.
	* @param markers Markers connected with the converted model.
	* @param writer View writer that should be used to modify the view document.
	*/ convertSelection(selection, markers, writer) {
        const conversionApi = this._createConversionApi(writer);
        this.fire("cleanSelection", {
            selection: selection
        }, conversionApi);
        const modelRoot = selection.getFirstPosition().root;
        if (!conversionApi.mapper.toViewElement(modelRoot)) return;
        const markersAtSelection = Array.from(markers.getMarkersAtPosition(selection.getFirstPosition()));
        this._addConsumablesForSelection(conversionApi.consumable, selection, markersAtSelection);
        this.fire("selection", {
            selection: selection
        }, conversionApi);
        if (!selection.isCollapsed) return;
        for (const marker of markersAtSelection)if (conversionApi.consumable.test(selection, "addMarker:" + marker.name)) {
            const markerRange = marker.getRange();
            if (!$b9b9f2bdf9c6137f$var$shouldMarkerChangeBeConverted(selection.getFirstPosition(), marker, conversionApi.mapper)) continue;
            const data = {
                item: selection,
                markerName: marker.name,
                markerRange: markerRange
            };
            this.fire(`addMarker:${marker.name}`, data, conversionApi);
        }
        for (const key of selection.getAttributeKeys())if (conversionApi.consumable.test(selection, "attribute:" + key)) {
            const data = {
                item: selection,
                range: selection.getFirstRange(),
                attributeKey: key,
                attributeOldValue: null,
                attributeNewValue: selection.getAttribute(key)
            };
            this.fire(`attribute:${key}:$text`, data, conversionApi);
        }
    }
    /**
	* Fires insertion conversion of a range of nodes.
	*
	* For each node in the range, {@link #event:insert `insert` event is fired}. For each attribute on each node,
	* {@link #event:attribute `attribute` event is fired}.
	*
	* @fires insert
	* @fires attribute
	* @param range The inserted range.
	* @param conversionApi The conversion API object.
	* @param options.doNotAddConsumables Whether the ModelConsumable should not get populated
	* for items in the provided range.
	*/ _convertInsert(range, conversionApi, options = {}) {
        if (!options.doNotAddConsumables) this._addConsumablesForInsert(conversionApi.consumable, range);
        for (const data of range.getWalker({
            shallow: true
        }))this._testAndFire("insert", $b9b9f2bdf9c6137f$var$walkerValueToEventData(data), conversionApi);
    }
    /**
	* Fires conversion of a single node removal. Fires {@link #event:remove remove event} with provided data.
	*
	* @param position Position from which node was removed.
	* @param length Offset size of removed node.
	* @param name Name of removed node.
	* @param conversionApi The conversion API object.
	*/ _convertRemove(position, length, name, conversionApi) {
        this.fire(`remove:${name}`, {
            position: position,
            length: length
        }, conversionApi);
    }
    /**
	* Starts a conversion of an attribute change on a given `range`.
	*
	* For each node in the given `range`, {@link #event:attribute attribute event} is fired with the passed data.
	*
	* @fires attribute
	* @param range Changed range.
	* @param key Key of the attribute that has changed.
	* @param oldValue Attribute value before the change or `null` if the attribute has not been set before.
	* @param newValue New attribute value or `null` if the attribute has been removed.
	* @param conversionApi The conversion API object.
	*/ _convertAttribute(range, key, oldValue, newValue, conversionApi) {
        this._addConsumablesForRange(conversionApi.consumable, range, `attribute:${key}`);
        for (const value of range){
            const data = {
                item: value.item,
                range: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(value.previousPosition, value.length),
                attributeKey: key,
                attributeOldValue: oldValue,
                attributeNewValue: newValue
            };
            this._testAndFire(`attribute:${key}`, data, conversionApi);
        }
    }
    /**
	* Fires re-insertion conversion (with a `reconversion` flag passed to `remove` and `insert` events)
	* of a range of elements (only elements on the range depth, without children).
	*
	* For each node in the range on its depth (without children), {@link #event:insert `insert` event} is fired.
	* For each attribute on each node, {@link #event:attribute `attribute` event} is fired.
	*
	* @fires insert
	* @fires attribute
	* @param range The range to reinsert.
	* @param conversionApi The conversion API object.
	*/ _convertReinsert(range, conversionApi) {
        const walkerValues = Array.from(range.getWalker({
            shallow: true
        }));
        this._addConsumablesForInsert(conversionApi.consumable, walkerValues);
        for (const data of walkerValues.map($b9b9f2bdf9c6137f$var$walkerValueToEventData)){
            this.fire(`remove:${data.item.is("element") ? data.item.name : "$text"}`, {
                position: data.range.start,
                length: data.item.offsetSize,
                reconversion: true
            }, conversionApi);
            this._testAndFire("insert", {
                ...data,
                reconversion: true
            }, conversionApi);
        }
    }
    /**
	* Converts the added marker. Fires the {@link #event:addMarker `addMarker`} event for each item
	* in the marker's range. If the range is collapsed, a single event is dispatched. See the event description for more details.
	*
	* @fires addMarker
	* @param markerName Marker name.
	* @param markerRange The marker range.
	* @param conversionApi The conversion API object.
	*/ _convertMarkerAdd(markerName, markerRange, conversionApi) {
        if (markerRange.root.rootName == "$graveyard") return;
        const eventName = `addMarker:${markerName}`;
        conversionApi.consumable.add(markerRange, eventName);
        this.fire(eventName, {
            markerName: markerName,
            markerRange: markerRange
        }, conversionApi);
        if (!conversionApi.consumable.consume(markerRange, eventName)) return;
        this._addConsumablesForRange(conversionApi.consumable, markerRange, eventName);
        for (const item of markerRange.getItems()){
            if (!conversionApi.consumable.test(item, eventName)) continue;
            const data = {
                item: item,
                range: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item),
                markerName: markerName,
                markerRange: markerRange
            };
            this.fire(eventName, data, conversionApi);
        }
    }
    /**
	* Fires the conversion of the marker removal. Fires the {@link #event:removeMarker `removeMarker`} event with the provided data.
	*
	* @fires removeMarker
	* @param markerName Marker name.
	* @param markerRange The marker range.
	* @param conversionApi The conversion API object.
	*/ _convertMarkerRemove(markerName, markerRange, conversionApi) {
        if (markerRange.root.rootName == "$graveyard") return;
        this.fire(`removeMarker:${markerName}`, {
            markerName: markerName,
            markerRange: markerRange
        }, conversionApi);
    }
    /**
	* Fires the reduction of changes buffered in the {@link module:engine/model/differ~Differ `Differ`}.
	*
	* Features can replace selected {@link module:engine/model/differ~DifferItem `DifferItem`}s with `reinsert` entries to trigger
	* reconversion. The {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure
	* `DowncastHelpers.elementToStructure()`} is using this event to trigger reconversion.
	*
	* @fires reduceChanges
	*/ _reduceChanges(changes, refreshedItems) {
        const data = {
            changes: changes,
            refreshedItems: refreshedItems
        };
        this.fire("reduceChanges", data);
        return data.changes;
    }
    /**
	* Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with values to consume from a given range,
	* assuming that the range has just been inserted to the model.
	*
	* @param consumable The consumable.
	* @param walkerValues The walker values for the inserted range.
	* @returns The values to consume.
	*/ _addConsumablesForInsert(consumable, walkerValues) {
        for (const value of walkerValues){
            const item = value.item;
            if (consumable.test(item, "insert") === null) {
                consumable.add(item, "insert");
                for (const key of item.getAttributeKeys())consumable.add(item, "attribute:" + key);
            }
        }
        return consumable;
    }
    /**
	* Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with values to consume for a given range.
	*
	* @param consumable The consumable.
	* @param range The affected range.
	* @param type Consumable type.
	* @returns The values to consume.
	*/ _addConsumablesForRange(consumable, range, type) {
        for (const item of range.getItems())consumable.add(item, type);
        return consumable;
    }
    /**
	* Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with selection consumable values.
	*
	* @param consumable The consumable.
	* @param selection The selection to create the consumable from.
	* @param markers Markers that contain the selection.
	* @returns The values to consume.
	*/ _addConsumablesForSelection(consumable, selection, markers) {
        consumable.add(selection, "selection");
        for (const marker of markers)consumable.add(selection, "addMarker:" + marker.name);
        for (const key of selection.getAttributeKeys())consumable.add(selection, "attribute:" + key);
        return consumable;
    }
    /**
	* Tests whether given event wasn't already fired and if so, fires it.
	*
	* @fires insert
	* @fires attribute
	* @param type Event type.
	* @param data Event data.
	* @param conversionApi The conversion API object.
	*/ _testAndFire(type, data, conversionApi) {
        const eventName = $b9b9f2bdf9c6137f$var$getEventName(type, data);
        const itemKey = data.item.is("$textProxy") ? conversionApi.consumable._getSymbolForTextProxy(data.item) : data.item;
        const eventsFiredForConversion = this._firedEventsMap.get(conversionApi);
        const eventsFiredForItem = eventsFiredForConversion.get(itemKey);
        if (!eventsFiredForItem) eventsFiredForConversion.set(itemKey, /* @__PURE__ */ new Set([
            eventName
        ]));
        else if (!eventsFiredForItem.has(eventName)) eventsFiredForItem.add(eventName);
        else return;
        this.fire(eventName, data, conversionApi);
    }
    /**
	* Fires not already fired events for setting attributes on just inserted item.
	*
	* @param item The model item to convert attributes for.
	* @param conversionApi The conversion API object.
	*/ _testAndFireAddAttributes(item, conversionApi) {
        const data = {
            item: item,
            range: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item)
        };
        for (const key of data.item.getAttributeKeys()){
            data.attributeKey = key;
            data.attributeOldValue = null;
            data.attributeNewValue = data.item.getAttribute(key);
            this._testAndFire(`attribute:${key}`, data, conversionApi);
        }
    }
    /**
	* Builds an instance of the {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi} from a template and a given
	* {@link module:engine/view/downcastwriter~ViewDowncastWriter `ViewDowncastWriter`} and options object.
	*
	* @param writer View writer that should be used to modify the view document.
	* @param refreshedItems A set of model elements that should not reuse their
	* previous view representations.
	* @param options Optional options passed to `convertionApi.options`.
	* @return The conversion API object.
	*/ _createConversionApi(writer, refreshedItems = /* @__PURE__ */ new Set(), options = {}) {
        const conversionApi = {
            ...this._conversionApi,
            consumable: new $b9b9f2bdf9c6137f$export$347a09ce4e7f1aab(),
            writer: writer,
            options: options,
            convertItem: (item)=>this._convertInsert($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item), conversionApi),
            convertChildren: (element)=>this._convertInsert($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(element), conversionApi, {
                    doNotAddConsumables: true
                }),
            convertAttributes: (item)=>this._testAndFireAddAttributes(item, conversionApi),
            canReuseView: (viewElement)=>!refreshedItems.has(conversionApi.mapper.toModelElement(viewElement))
        };
        this._firedEventsMap.set(conversionApi, /* @__PURE__ */ new Map());
        return conversionApi;
    }
};
/**
* Helper function, checks whether change of `marker` at `modelPosition` should be converted. Marker changes are not
* converted if they happen inside an element with custom conversion method.
*/ function $b9b9f2bdf9c6137f$var$shouldMarkerChangeBeConverted(modelPosition, marker, mapper) {
    const range = marker.getRange();
    const ancestors = Array.from(modelPosition.getAncestors());
    ancestors.shift();
    ancestors.reverse();
    return !ancestors.some((element)=>{
        if (range.containsItem(element)) return !!mapper.toViewElement(element).getCustomProperty("addHighlight");
    });
}
function $b9b9f2bdf9c6137f$var$getEventName(type, data) {
    return `${type}:${data.item.is("element") ? data.item.name : "$text"}`;
}
function $b9b9f2bdf9c6137f$var$walkerValueToEventData(value) {
    return {
        item: value.item,
        range: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(value.previousPosition, value.length)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/node
*/ /**
* Model node. Most basic structure of model tree.
*
* This is an abstract class that is a base for other classes representing different nodes in model.
*
* **Note:** If a node is detached from the model tree, you can manipulate it using it's API.
* However, it is **very important** that nodes already attached to model tree should be only changed through
* {@link module:engine/model/writer~ModelWriter Writer API}.
*
* Changes done by `Node` methods, like {@link module:engine/model/element~ModelElement#_insertChild _insertChild} or
* {@link module:engine/model/node~ModelNode#_setAttribute _setAttribute}
* do not generate {@link module:engine/model/operation/operation~Operation operations}
* which are essential for correct editor work if you modify nodes in {@link module:engine/model/document~ModelDocument document} root.
*
* The flow of working on `Node` (and classes that inherits from it) is as such:
* 1. You can create a `Node` instance, modify it using it's API.
* 2. Add `Node` to the model using `Batch` API.
* 3. Change `Node` that was already added to the model using `Batch` API.
*
* Similarly, you cannot use `Batch` API on a node that has not been added to the model tree, with the exception
* of {@link module:engine/model/writer~ModelWriter#insert inserting} that node to the model tree.
*
* Be aware that using {@link module:engine/model/writer~ModelWriter#remove remove from Batch API} does not allow to use `Node` API because
* the information about `Node` is still kept in model document.
*
* In case of {@link module:engine/model/element~ModelElement element node}, adding and removing children also counts as changing a node and
* follows same rules.
*/ var $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb = class extends $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 {
    /**
	* Parent of this node. It could be {@link module:engine/model/element~ModelElement}
	* or {@link module:engine/model/documentfragment~ModelDocumentFragment}.
	* Equals to `null` if the node has no parent.
	*/ parent = null;
    /**
	* Attributes set on this node.
	*/ _attrs;
    /**
	* Index of this node in its parent or `null` if the node has no parent.
	*
	* @internal
	*/ _index = null;
    /**
	* Offset at which this node starts in its parent or `null` if the node has no parent.
	*
	* @internal
	*/ _startOffset = null;
    /**
	* Creates a model node.
	*
	* This is an abstract class, so this constructor should not be used directly.
	*
	* @param attrs Node's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
	*/ constructor(attrs){
        super();
        this._attrs = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(attrs);
    }
    /**
	* {@link module:engine/model/document~ModelDocument Document} that owns this root element.
	*/ get document() {
        return null;
    }
    /**
	* Index of this node in its parent or `null` if the node has no parent.
	*/ get index() {
        return this._index;
    }
    /**
	* Offset at which this node starts in its parent. It is equal to the sum of {@link #offsetSize offsetSize}
	* of all its previous siblings. Equals to `null` if node has no parent.
	*/ get startOffset() {
        return this._startOffset;
    }
    /**
	* Offset size of this node.
	*
	* Represents how much "offset space" is occupied by the node in its parent. It is important for
	* {@link module:engine/model/position~ModelPosition position}. When node has `offsetSize` greater
	* than `1`, position can be placed between that node start and end. `offsetSize` greater than `1` is for
	* nodes that represents more than one entity, i.e. a {@link module:engine/model/text~ModelText text node}.
	*/ get offsetSize() {
        return 1;
    }
    /**
	* Offset at which this node ends in its parent. It is equal to the sum of this node's
	* {@link module:engine/model/node~ModelNode#startOffset start offset} and {@link #offsetSize offset size}.
	* Equals to `null` if the node has no parent.
	*/ get endOffset() {
        if (this.startOffset === null) return null;
        return this.startOffset + this.offsetSize;
    }
    /**
	* Node's next sibling or `null` if the node is a last child of it's parent or if the node has no parent.
	*/ get nextSibling() {
        const index = this.index;
        return index !== null && this.parent.getChild(index + 1) || null;
    }
    /**
	* Node's previous sibling or `null` if the node is a first child of it's parent or if the node has no parent.
	*/ get previousSibling() {
        const index = this.index;
        return index !== null && this.parent.getChild(index - 1) || null;
    }
    /**
	* The top-most ancestor of the node. If node has no parent it is the root itself. If the node is a part
	* of {@link module:engine/model/documentfragment~ModelDocumentFragment}, it's `root` is equal to that `DocumentFragment`.
	*/ get root() {
        let root = this;
        while(root.parent)root = root.parent;
        return root;
    }
    /**
	* Returns `true` if the node is inside a document root that is attached to the document.
	*/ isAttached() {
        return this.parent === null ? false : this.root.isAttached();
    }
    /**
	* Gets path to the node. The path is an array containing starting offsets of consecutive ancestors of this node,
	* beginning from {@link module:engine/model/node~ModelNode#root root}, down to this node's starting offset. The path can be used to
	* create {@link module:engine/model/position~ModelPosition Position} instance.
	*
	* ```ts
	* const abc = new Text( 'abc' );
	* const foo = new Text( 'foo' );
	* const h1 = new ModelElement( 'h1', null, new Text( 'header' ) );
	* const p = new ModelElement( 'p', null, [ abc, foo ] );
	* const div = new ModelElement( 'div', null, [ h1, p ] );
	* foo.getPath(); // Returns [ 1, 3 ]. `foo` is in `p` which is in `div`. `p` starts at offset 1, while `foo` at 3.
	* h1.getPath(); // Returns [ 0 ].
	* div.getPath(); // Returns [].
	* ```
	*/ getPath() {
        const path = [];
        let node = this;
        while(node.parent){
            path.unshift(node.startOffset);
            node = node.parent;
        }
        return path;
    }
    /**
	* Returns ancestors array of this node.
	*
	* @param options Options object.
	* @param options.includeSelf When set to `true` this node will be also included in parent's array.
	* @param options.parentFirst When set to `true`, array will be sorted from node's parent to root element,
	* otherwise root element will be the first item in the array.
	* @returns Array with ancestors.
	*/ getAncestors(options = {}) {
        const ancestors = [];
        let parent = options.includeSelf ? this : this.parent;
        while(parent){
            ancestors[options.parentFirst ? "push" : "unshift"](parent);
            parent = parent.parent;
        }
        return ancestors;
    }
    /**
	* Returns a {@link module:engine/model/element~ModelElement} or {@link module:engine/model/documentfragment~ModelDocumentFragment}
	* which is a common ancestor of both nodes.
	*
	* @param node The second node.
	* @param options Options object.
	* @param options.includeSelf When set to `true` both nodes will be considered "ancestors" too.
	* Which means that if e.g. node A is inside B, then their common ancestor will be B.
	*/ getCommonAncestor(node, options = {}) {
        const ancestorsA = this.getAncestors(options);
        const ancestorsB = node.getAncestors(options);
        let i = 0;
        while(ancestorsA[i] == ancestorsB[i] && ancestorsA[i])i++;
        return i === 0 ? null : ancestorsA[i - 1];
    }
    /**
	* Returns whether this node is before given node. `false` is returned if nodes are in different trees (for example,
	* in different {@link module:engine/model/documentfragment~ModelDocumentFragment}s).
	*
	* @param node Node to compare with.
	*/ isBefore(node) {
        if (this == node) return false;
        if (this.root !== node.root) return false;
        const thisPath = this.getPath();
        const nodePath = node.getPath();
        const result = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(thisPath, nodePath);
        switch(result){
            case "prefix":
                return true;
            case "extension":
                return false;
            default:
                return thisPath[result] < nodePath[result];
        }
    }
    /**
	* Returns whether this node is after given node. `false` is returned if nodes are in different trees (for example,
	* in different {@link module:engine/model/documentfragment~ModelDocumentFragment}s).
	*
	* @param node Node to compare with.
	*/ isAfter(node) {
        if (this == node) return false;
        if (this.root !== node.root) return false;
        return !this.isBefore(node);
    }
    /**
	* Checks if the node has an attribute with given key.
	*
	* @param key Key of attribute to check.
	* @returns `true` if attribute with given key is set on node, `false` otherwise.
	*/ hasAttribute(key) {
        return this._attrs.has(key);
    }
    /**
	* Gets an attribute value for given key or `undefined` if that attribute is not set on node.
	*
	* @param key Key of attribute to look for.
	* @returns Attribute value or `undefined`.
	*/ getAttribute(key) {
        return this._attrs.get(key);
    }
    /**
	* Returns iterator that iterates over this node's attributes.
	*
	* Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
	* This format is accepted by native `Map` object and also can be passed in `Node` constructor.
	*/ getAttributes() {
        return this._attrs.entries();
    }
    /**
	* Returns iterator that iterates over this node's attribute keys.
	*/ getAttributeKeys() {
        return this._attrs.keys();
    }
    /**
	* Converts `Node` to plain object and returns it.
	*
	* @returns `Node` converted to plain object.
	*/ toJSON() {
        const json = {};
        if (this._attrs.size) json.attributes = Array.from(this._attrs).reduce((result, attr)=>{
            result[attr[0]] = attr[1];
            return result;
        }, {});
        return json;
    }
    /**
	* Creates a copy of this node, that is a node with exactly same attributes, and returns it.
	*
	* @internal
	* @returns Node with same attributes as this node.
	*/ _clone(_deep) {
        return new this.constructor(this._attrs);
    }
    /**
	* Removes this node from its parent.
	*
	* @internal
	* @see module:engine/model/writer~ModelWriter#remove
	*/ _remove() {
        this.parent._removeChildren(this.index);
    }
    /**
	* Sets attribute on the node. If attribute with the same key already is set, it's value is overwritten.
	*
	* @see module:engine/model/writer~ModelWriter#setAttribute
	* @internal
	* @param key Key of attribute to set.
	* @param value Attribute value.
	*/ _setAttribute(key, value) {
        this._attrs.set(key, value);
    }
    /**
	* Removes all attributes from the node and sets given attributes.
	*
	* @see module:engine/model/writer~ModelWriter#setAttributes
	* @internal
	* @param attrs Attributes to set. See {@link module:utils/tomap~toMap} for a list of accepted values.
	*/ _setAttributesTo(attrs) {
        this._attrs = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(attrs);
    }
    /**
	* Removes an attribute with given key from the node.
	*
	* @see module:engine/model/writer~ModelWriter#removeAttribute
	* @internal
	* @param key Key of attribute to remove.
	* @returns `true` if the attribute was set on the element, `false` otherwise.
	*/ _removeAttribute(key) {
        return this._attrs.delete(key);
    }
    /**
	* Removes all attributes from the node.
	*
	* @see module:engine/model/writer~ModelWriter#clearAttributes
	* @internal
	*/ _clearAttributes() {
        this._attrs.clear();
    }
};
$b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb.prototype.is = function(type) {
    return type === "node" || type === "model:node";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/selection
*/ const $b9b9f2bdf9c6137f$var$ModelSelectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$68dcb975ec9fb725);
/**
* Selection is a set of {@link module:engine/model/range~ModelRange ranges}. It has a direction specified by its
* {@link module:engine/model/selection~ModelSelection#anchor anchor} and {@link module:engine/model/selection~ModelSelection#focus focus}
* (it can be {@link module:engine/model/selection~ModelSelection#isBackward forward or backward}).
* Additionally, selection may have its own attributes (think – whether text typed in in this selection
* should have those attributes – e.g. whether you type a bolded text).
*/ var $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 = class ModelSelection extends $b9b9f2bdf9c6137f$var$ModelSelectionBase {
    /**
	* Specifies whether the last added range was added as a backward or forward range.
	*/ _lastRangeBackward = false;
    /**
	* List of attributes set on current selection.
	*/ _attrs = /* @__PURE__ */ new Map();
    /** @internal */ _ranges = [];
    /**
	* Creates a new selection instance based on the given {@link module:engine/model/selection~ModelSelectable selectable}
	* or creates an empty selection if no arguments were passed.
	*
	* ```ts
	* // Creates empty selection without ranges.
	* const selection = writer.createSelection();
	*
	* // Creates selection at the given range.
	* const range = writer.createRange( start, end );
	* const selection = writer.createSelection( range );
	*
	* // Creates selection at the given ranges
	* const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
	* const selection = writer.createSelection( ranges );
	*
	* // Creates selection from the other selection.
	* // Note: It doesn't copy selection attributes.
	* const otherSelection = writer.createSelection();
	* const selection = writer.createSelection( otherSelection );
	*
	* // Creates selection from the given document selection.
	* // Note: It doesn't copy selection attributes.
	* const documentSelection = model.document.selection;
	* const selection = writer.createSelection( documentSelection );
	*
	* // Creates selection at the given position.
	* const position = writer.createPositionFromPath( root, path );
	* const selection = writer.createSelection( position );
	*
	* // Creates selection at the given offset in the given element.
	* const paragraph = writer.createElement( 'paragraph' );
	* const selection = writer.createSelection( paragraph, offset );
	*
	* // Creates a range inside an {@link module:engine/model/element~ModelElement element} which starts before the
	* // first child of that element and ends after the last child of that element.
	* const selection = writer.createSelection( paragraph, 'in' );
	*
	* // Creates a range on an {@link module:engine/model/item~ModelItem item} which starts before the item and ends
	* // just after the item.
	* const selection = writer.createSelection( paragraph, 'on' );
	* ```
	*
	* Selection's constructor allow passing additional options (`'backward'`) as the last argument.
	*
	* ```ts
	* // Creates backward selection.
	* const selection = writer.createSelection( range, { backward: true } );
	* ```
	*
	* @internal
	*/ constructor(...args){
        super();
        if (args.length) this.setTo(...args);
    }
    /**
	* Selection anchor. Anchor is the position from which the selection was started. If a user is making a selection
	* by dragging the mouse, the anchor is where the user pressed the mouse button (the beginning of the selection).
	*
	* Anchor and {@link #focus} define the direction of the selection, which is important
	* when expanding/shrinking selection. The focus moves, while the anchor should remain in the same place.
	*
	* Anchor is always set to the {@link module:engine/model/range~ModelRange#start start} or
	* {@link module:engine/model/range~ModelRange#end end} position of the last of selection's ranges. Whether it is
	* the `start` or `end` depends on the specified `options.backward`. See the {@link #setTo `setTo()`} method.
	*
	* May be set to `null` if there are no ranges in the selection.
	*
	* @see #focus
	*/ get anchor() {
        if (this._ranges.length > 0) {
            const range = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? range.end : range.start;
        }
        return null;
    }
    /**
	* Selection focus. Focus is the position where the selection ends. If a user is making a selection
	* by dragging the mouse, the focus is where the mouse cursor is.
	*
	* May be set to `null` if there are no ranges in the selection.
	*
	* @see #anchor
	*/ get focus() {
        if (this._ranges.length > 0) {
            const range = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? range.start : range.end;
        }
        return null;
    }
    /**
	* Whether the selection is collapsed. Selection is collapsed when there is exactly one range in it
	* and it is collapsed.
	*/ get isCollapsed() {
        if (this._ranges.length === 1) return this._ranges[0].isCollapsed;
        else return false;
    }
    /**
	* Returns the number of ranges in the selection.
	*/ get rangeCount() {
        return this._ranges.length;
    }
    /**
	* Specifies whether the selection's {@link #focus} precedes the selection's {@link #anchor}.
	*/ get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
    }
    /**
	* Checks whether this selection is equal to the given selection. Selections are equal if they have the same directions,
	* the same number of ranges and all ranges from one selection equal to ranges from the another selection.
	*
	* @param otherSelection Selection to compare with.
	* @returns `true` if selections are equal, `false` otherwise.
	*/ isEqual(otherSelection) {
        if (this.rangeCount != otherSelection.rangeCount) return false;
        else if (this.rangeCount === 0) return true;
        if (!this.anchor.isEqual(otherSelection.anchor) || !this.focus.isEqual(otherSelection.focus)) return false;
        for (const thisRange of this._ranges){
            let found = false;
            for (const otherRange of otherSelection._ranges)if (thisRange.isEqual(otherRange)) {
                found = true;
                break;
            }
            if (!found) return false;
        }
        return true;
    }
    /**
	* Returns an iterable object that iterates over copies of selection ranges.
	*/ *getRanges() {
        for (const range of this._ranges)yield new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(range.start, range.end);
    }
    /**
	* Returns a copy of the first range in the selection.
	* First range is the one which {@link module:engine/model/range~ModelRange#start start} position
	* {@link module:engine/model/position~ModelPosition#isBefore is before} start position of all other ranges
	* (not to confuse with the first range added to the selection).
	*
	* Returns `null` if there are no ranges in selection.
	*/ getFirstRange() {
        let first = null;
        for (const range of this._ranges)if (!first || range.start.isBefore(first.start)) first = range;
        return first ? new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(first.start, first.end) : null;
    }
    /**
	* Returns a copy of the last range in the selection.
	* Last range is the one which {@link module:engine/model/range~ModelRange#end end} position
	* {@link module:engine/model/position~ModelPosition#isAfter is after} end position of all other
	* ranges (not to confuse with the range most recently added to the selection).
	*
	* Returns `null` if there are no ranges in selection.
	*/ getLastRange() {
        let last = null;
        for (const range of this._ranges)if (!last || range.end.isAfter(last.end)) last = range;
        return last ? new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(last.start, last.end) : null;
    }
    /**
	* Returns the first position in the selection.
	* First position is the position that {@link module:engine/model/position~ModelPosition#isBefore is before}
	* any other position in the selection.
	*
	* Returns `null` if there are no ranges in selection.
	*/ getFirstPosition() {
        const first = this.getFirstRange();
        return first ? first.start.clone() : null;
    }
    /**
	* Returns the last position in the selection.
	* Last position is the position that {@link module:engine/model/position~ModelPosition#isAfter is after}
	* any other position in the selection.
	*
	* Returns `null` if there are no ranges in selection.
	*/ getLastPosition() {
        const lastRange = this.getLastRange();
        return lastRange ? lastRange.end.clone() : null;
    }
    /**
	* Sets this selection's ranges and direction to the specified location based on the given
	* {@link module:engine/model/selection~ModelSelectable selectable}.
	*
	* ```ts
	* // Removes all selection's ranges.
	* selection.setTo( null );
	*
	* // Sets selection to the given range.
	* const range = writer.createRange( start, end );
	* selection.setTo( range );
	*
	* // Sets selection to given ranges.
	* const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
	* selection.setTo( ranges );
	*
	* // Sets selection to other selection.
	* // Note: It doesn't copy selection attributes.
	* const otherSelection = writer.createSelection();
	* selection.setTo( otherSelection );
	*
	* // Sets selection to the given document selection.
	* // Note: It doesn't copy selection attributes.
	* const documentSelection = new ModelDocumentSelection( doc );
	* selection.setTo( documentSelection );
	*
	* // Sets collapsed selection at the given position.
	* const position = writer.createPositionFromPath( root, path );
	* selection.setTo( position );
	*
	* // Sets collapsed selection at the position of the given node and an offset.
	* selection.setTo( paragraph, offset );
	* ```
	*
	* Creates a range inside an {@link module:engine/model/element~ModelElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* ```ts
	* selection.setTo( paragraph, 'in' );
	* ```
	*
	* Creates a range on an {@link module:engine/model/item~ModelItem item} which starts before the item and ends just after the item.
	*
	* ```ts
	* selection.setTo( paragraph, 'on' );
	* ```
	*
	* `Selection#setTo()` method allows passing additional options (`backward`) as the last argument.
	*
	* ```ts
	* // Sets backward selection.
	* const selection = writer.createSelection( range, { backward: true } );
	* ```
	*/ setTo(...args) {
        let [selectable, placeOrOffset, options] = args;
        if (typeof placeOrOffset == "object") {
            options = placeOrOffset;
            placeOrOffset = void 0;
        }
        if (selectable === null) this._setRanges([]);
        else if (selectable instanceof ModelSelection) this._setRanges(selectable.getRanges(), selectable.isBackward);
        else if (selectable && typeof selectable.getRanges == "function") this._setRanges(selectable.getRanges(), selectable.isBackward);
        else if (selectable instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba) this._setRanges([
            selectable
        ], !!options && !!options.backward);
        else if (selectable instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) this._setRanges([
            new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(selectable)
        ]);
        else if (selectable instanceof $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb) {
            const backward = !!options && !!options.backward;
            let range;
            if (placeOrOffset == "in") range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(selectable);
            else if (placeOrOffset == "on") range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(selectable);
            else if (placeOrOffset !== void 0) range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(selectable, placeOrOffset));
            else /**
			* selection.setTo requires the second parameter when the first parameter is a node.
			*
			* @error model-selection-setto-required-second-parameter
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-selection-setto-required-second-parameter", [
                this,
                selectable
            ]);
            this._setRanges([
                range
            ], backward);
        } else if ((0, $c7bc2cb7e2db0227$export$9652023d9040757)(selectable)) this._setRanges(selectable, options && !!options.backward);
        else /**
		* Cannot set the selection to the given place.
		*
		* Invalid parameters were specified when setting the selection. Common issues:
		*
		* * A {@link module:engine/model/textproxy~ModelTextProxy} instance was passed instead of
		* a real {@link module:engine/model/text~ModelText}.
		* * View nodes were passed instead of model nodes.
		* * `null`/`undefined` was passed.
		*
		* @error model-selection-setto-not-selectable
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-selection-setto-not-selectable", [
            this,
            selectable
        ]);
    }
    /**
	* Replaces all ranges that were added to the selection with given array of ranges. Last range of the array
	* is treated like the last added range and is used to set {@link module:engine/model/selection~ModelSelection#anchor} and
	* {@link module:engine/model/selection~ModelSelection#focus}. Accepts a flag describing in which direction the selection is made.
	*
	* @fires change:range
	* @param newRanges Ranges to set.
	* @param isLastBackward Flag describing if last added range was selected forward - from start to end (`false`)
	* or backward - from end to start (`true`).
	*/ _setRanges(newRanges, isLastBackward = false) {
        const ranges = Array.from(newRanges);
        const anyNewRange = ranges.some((newRange)=>{
            if (!(newRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba)) /**
			* Selection range set to an object that is not an instance of {@link module:engine/model/range~ModelRange}.
			*
			* Only {@link module:engine/model/range~ModelRange} instances can be used to set a selection.
			* Common mistakes leading to this error are:
			*
			* * using DOM `Range` object,
			* * incorrect CKEditor 5 installation with multiple `ckeditor5-engine` packages having different versions.
			*
			* @error model-selection-set-ranges-not-range
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-selection-set-ranges-not-range", [
                this,
                newRanges
            ]);
            return this._ranges.every((oldRange)=>{
                return !oldRange.isEqual(newRange);
            });
        });
        if (ranges.length === this._ranges.length && !anyNewRange) return;
        this._replaceAllRanges(ranges);
        this._lastRangeBackward = !!isLastBackward;
        this.fire("change:range", {
            directChange: true
        });
    }
    /**
	* Moves {@link module:engine/model/selection~ModelSelection#focus} to the specified location.
	*
	* The location can be specified in the same form as
	* {@link module:engine/model/writer~ModelWriter#createPositionAt writer.createPositionAt()} parameters.
	*
	* @fires change:range
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ setFocus(itemOrPosition, offset) {
        if (this.anchor === null) /**
		* Cannot set selection focus if there are no ranges in selection.
		*
		* @error model-selection-setfocus-no-ranges
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-selection-setfocus-no-ranges", [
            this,
            itemOrPosition
        ]);
        const newFocus = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(itemOrPosition, offset);
        if (newFocus.compareWith(this.focus) == "same") return;
        const anchor = this.anchor;
        if (this._ranges.length) this._popRange();
        if (newFocus.compareWith(anchor) == "before") {
            this._pushRange(new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(newFocus, anchor));
            this._lastRangeBackward = true;
        } else {
            this._pushRange(new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(anchor, newFocus));
            this._lastRangeBackward = false;
        }
        this.fire("change:range", {
            directChange: true
        });
    }
    /**
	* Gets an attribute value for given key or `undefined` if that attribute is not set on the selection.
	*
	* @param key Key of attribute to look for.
	* @returns Attribute value or `undefined`.
	*/ getAttribute(key) {
        return this._attrs.get(key);
    }
    /**
	* Returns iterable that iterates over this selection's attributes.
	*
	* Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
	* This format is accepted by native `Map` object and also can be passed in `Node` constructor.
	*/ getAttributes() {
        return this._attrs.entries();
    }
    /**
	* Returns iterable that iterates over this selection's attribute keys.
	*/ getAttributeKeys() {
        return this._attrs.keys();
    }
    /**
	* Checks if the selection has an attribute for given key.
	*
	* @param key Key of attribute to check.
	* @returns `true` if attribute with given key is set on selection, `false` otherwise.
	*/ hasAttribute(key) {
        return this._attrs.has(key);
    }
    /**
	* Removes an attribute with given key from the selection.
	*
	* If given attribute was set on the selection, fires the {@link #event:change:range} event with
	* removed attribute key.
	*
	* @fires change:attribute
	* @param key Key of attribute to remove.
	*/ removeAttribute(key) {
        if (this.hasAttribute(key)) {
            this._attrs.delete(key);
            this.fire("change:attribute", {
                attributeKeys: [
                    key
                ],
                directChange: true
            });
        }
    }
    /**
	* Sets attribute on the selection. If attribute with the same key already is set, it's value is overwritten.
	*
	* If the attribute value has changed, fires the {@link #event:change:range} event with
	* the attribute key.
	*
	* @fires change:attribute
	* @param key Key of attribute to set.
	* @param value Attribute value.
	*/ setAttribute(key, value) {
        if (this.getAttribute(key) !== value) {
            this._attrs.set(key, value);
            this.fire("change:attribute", {
                attributeKeys: [
                    key
                ],
                directChange: true
            });
        }
    }
    /**
	* Returns the selected element. {@link module:engine/model/element~ModelElement Element} is considered as selected if there is only
	* one range in the selection, and that range contains exactly one element.
	* Returns `null` if there is no selected element.
	*/ getSelectedElement() {
        if (this.rangeCount !== 1) return null;
        return this.getFirstRange().getContainedElement();
    }
    /**
	* Gets elements of type {@link module:engine/model/schema~ModelSchema#isBlock "block"} touched by the selection.
	*
	* This method's result can be used for example to apply block styling to all blocks covered by this selection.
	*
	* **Note:** `getSelectedBlocks()` returns blocks that are nested in other non-block elements
	* but will not return blocks nested in other blocks.
	*
	* In this case the function will return exactly all 3 paragraphs (note: `<blockQuote>` is not a block itself):
	*
	* ```xml
	* <paragraph>[a</paragraph>
	* <blockQuote>
	* 	<paragraph>b</paragraph>
	* </blockQuote>
	* <paragraph>c]d</paragraph>
	* ```
	*
	* In this case the paragraph will also be returned, despite the collapsed selection:
	*
	* ```xml
	* <paragraph>[]a</paragraph>
	* ```
	*
	* In such a scenario, however, only blocks A, B & E will be returned as blocks C & D are nested in block B:
	*
	* ```xml
	* [<blockA></blockA>
	* <blockB>
	* 	<blockC></blockC>
	* 	<blockD></blockD>
	* </blockB>
	* <blockE></blockE>]
	* ```
	*
	* If the selection is inside a block all the inner blocks (A & B) are returned:
	*
	* ```xml
	* <block>
	* 	<blockA>[a</blockA>
	* 	<blockB>b]</blockB>
	* </block>
	* ```
	*
	* **Special case**: Selection ignores first and/or last blocks if nothing (from user perspective) is selected in them.
	*
	* ```xml
	* // Selection ends and the beginning of the last block.
	* <paragraph>[a</paragraph>
	* <paragraph>b</paragraph>
	* <paragraph>]c</paragraph> // This block will not be returned
	*
	* // Selection begins at the end of the first block.
	* <paragraph>a[</paragraph> // This block will not be returned
	* <paragraph>b</paragraph>
	* <paragraph>c]</paragraph>
	*
	* // Selection begings at the end of the first block and ends at the beginning of the last block.
	* <paragraph>a[</paragraph> // This block will not be returned
	* <paragraph>b</paragraph>
	* <paragraph>]c</paragraph> // This block will not be returned
	* ```
	*/ *getSelectedBlocks() {
        const visited = /* @__PURE__ */ new WeakSet();
        for (const range of this.getRanges()){
            const startBlock = $b9b9f2bdf9c6137f$var$getParentBlock$1(range.start, visited);
            if ($b9b9f2bdf9c6137f$var$isStartBlockSelected(startBlock, range)) yield startBlock;
            const treewalker = range.getWalker();
            for (const value of treewalker){
                const block = value.item;
                if (value.type == "elementEnd" && $b9b9f2bdf9c6137f$var$isUnvisitedTopBlock(block, visited, range)) yield block;
                else if (value.type == "elementStart" && block.is("model:element") && block.root.document.model.schema.isBlock(block)) treewalker.jumpTo($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(block, "end"));
            }
            const endBlock = $b9b9f2bdf9c6137f$var$getParentBlock$1(range.end, visited);
            if ($b9b9f2bdf9c6137f$var$isEndBlockSelected(endBlock, range)) yield endBlock;
        }
    }
    /**
	* Checks whether the selection contains the entire content of the given element. This means that selection must start
	* at a position {@link module:engine/model/position~ModelPosition#isTouching touching} the element's start and ends at position
	* touching the element's end.
	*
	* By default, this method will check whether the entire content of the selection's current root is selected.
	* Useful to check if e.g. the user has just pressed <kbd>Ctrl</kbd> + <kbd>A</kbd>.
	*/ containsEntireContent(element = this.anchor.root) {
        const limitStartPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, 0);
        const limitEndPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, "end");
        return limitStartPosition.isTouching(this.getFirstPosition()) && limitEndPosition.isTouching(this.getLastPosition());
    }
    /**
	* Converts `Selection` to plain object and returns it.
	*
	* @returns `Selection` converted to plain object.
	*/ toJSON() {
        const json = {
            ranges: Array.from(this.getRanges()).map((range)=>range.toJSON())
        };
        const attributes = Object.fromEntries(this.getAttributes());
        if (Object.keys(attributes).length) json.attributes = attributes;
        if (this.isBackward) json.isBackward = true;
        return json;
    }
    /**
	* Adds given range to internal {@link #_ranges ranges array}. Throws an error
	* if given range is intersecting with any range that is already stored in this selection.
	*/ _pushRange(range) {
        this._checkRange(range);
        this._ranges.push(new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(range.start, range.end));
    }
    /**
	* Checks if given range intersects with ranges that are already in the selection. Throws an error if it does.
	*/ _checkRange(range) {
        for(let i = 0; i < this._ranges.length; i++)if (range.isIntersecting(this._ranges[i])) /**
		* Trying to add a range that intersects with another range in the selection.
		*
		* @error model-selection-range-intersects
		* @param {module:engine/model/range~ModelRange} addedRange Range that was added to the selection.
		* @param {module:engine/model/range~ModelRange} intersectingRange Range in the selection that intersects with `addedRange`.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-selection-range-intersects", [
            this,
            range
        ], {
            addedRange: range,
            intersectingRange: this._ranges[i]
        });
    }
    /**
	* Replaces all the ranges by the given ones.
	* Uses {@link #_popRange _popRange} and {@link #_pushRange _pushRange} to ensure proper ranges removal and addition.
	*/ _replaceAllRanges(ranges) {
        this._removeAllRanges();
        for (const range of ranges)this._pushRange(range);
    }
    /**
	* Deletes ranges from internal range array. Uses {@link #_popRange _popRange} to
	* ensure proper ranges removal.
	*/ _removeAllRanges() {
        while(this._ranges.length > 0)this._popRange();
    }
    /**
	* Removes most recently added range from the selection.
	*/ _popRange() {
        this._ranges.pop();
    }
};
$b9b9f2bdf9c6137f$export$d7de888343eb5ed6.prototype.is = function(type) {
    return type === "selection" || type === "model:selection";
};
/**
* Checks whether the given element extends $block in the schema and has a parent (is not a root).
* Marks it as already visited.
*/ function $b9b9f2bdf9c6137f$var$isUnvisitedBlock(element, visited) {
    if (visited.has(element)) return false;
    visited.add(element);
    return element.root.document.model.schema.isBlock(element) && !!element.parent;
}
/**
* Checks if the given element is a $block was not previously visited and is a top block in a range.
*/ function $b9b9f2bdf9c6137f$var$isUnvisitedTopBlock(element, visited, range) {
    return $b9b9f2bdf9c6137f$var$isUnvisitedBlock(element, visited) && $b9b9f2bdf9c6137f$var$isTopBlockInRange(element, range);
}
/**
* Finds the lowest element in position's ancestors which is a block.
* It will search until first ancestor that is a limit element.
* Marks all ancestors as already visited to not include any of them later on.
*/ function $b9b9f2bdf9c6137f$var$getParentBlock$1(position, visited) {
    const schema = position.parent.root.document.model.schema;
    const ancestors = position.parent.getAncestors({
        parentFirst: true,
        includeSelf: true
    });
    let hasParentLimit = false;
    const block = ancestors.find((element)=>{
        if (hasParentLimit) return false;
        hasParentLimit = schema.isLimit(element);
        return !hasParentLimit && $b9b9f2bdf9c6137f$var$isUnvisitedBlock(element, visited);
    });
    ancestors.forEach((element)=>visited.add(element));
    return block;
}
/**
* Checks if the blocks is not nested in other block inside a range.
*/ function $b9b9f2bdf9c6137f$var$isTopBlockInRange(block, range) {
    const parentBlock = $b9b9f2bdf9c6137f$var$findAncestorBlock(block);
    if (!parentBlock) return true;
    return !range.containsRange($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(parentBlock), true);
}
/**
* If a selection starts at the end of a block, that block is not returned as from the user's perspective this block wasn't selected.
* See [#11585](https://github.com/ckeditor/ckeditor5/issues/11585) for more details.
*
* ```xml
* <paragraph>a[</paragraph> // This block will not be returned
* <paragraph>b</paragraph>
* <paragraph>c]</paragraph>
* ```
*
* Collapsed selection is not affected by it:
*
* ```xml
* <paragraph>a[]</paragraph> // This block will be returned
* ```
*/ function $b9b9f2bdf9c6137f$var$isStartBlockSelected(startBlock, range) {
    if (!startBlock) return false;
    if (range.isCollapsed || startBlock.isEmpty) return true;
    if (range.start.isTouching($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(startBlock, startBlock.maxOffset))) return false;
    return $b9b9f2bdf9c6137f$var$isTopBlockInRange(startBlock, range);
}
/**
* If a selection ends at the beginning of a block, that block is not returned as from the user's perspective this block wasn't selected.
* See [#984](https://github.com/ckeditor/ckeditor5-engine/issues/984) for more details.
*
* ```xml
* <paragraph>[a</paragraph>
* <paragraph>b</paragraph>
* <paragraph>]c</paragraph> // this block will not be returned
* ```
*
* Collapsed selection is not affected by it:
*
* ```xml
* <paragraph>[]a</paragraph> // this block will be returned
* ```
*/ function $b9b9f2bdf9c6137f$var$isEndBlockSelected(endBlock, range) {
    if (!endBlock) return false;
    if (range.isCollapsed || endBlock.isEmpty) return true;
    if (range.end.isTouching($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(endBlock, 0))) return false;
    return $b9b9f2bdf9c6137f$var$isTopBlockInRange(endBlock, range);
}
/**
* Returns first ancestor block of a node.
*/ function $b9b9f2bdf9c6137f$var$findAncestorBlock(node) {
    const schema = node.root.document.model.schema;
    let parent = node.parent;
    while(parent){
        if (schema.isBlock(parent)) return parent;
        parent = parent.parent;
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/liverange
*/ const $b9b9f2bdf9c6137f$var$ModelLiveRangeBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$a3091252a5e626ba);
/**
* `ModelLiveRange` is a type of {@link module:engine/model/range~ModelRange Range}
* that updates itself as {@link module:engine/model/document~ModelDocument document}
* is changed through operations. It may be used as a bookmark.
*
* **Note:** Be very careful when dealing with `ModelLiveRange`. Each `ModelLiveRange` instance bind events that might
* have to be unbound. Use {@link module:engine/model/liverange~ModelLiveRange#detach detach} whenever you don't need
* `ModelLiveRange` anymore.
*/ var $b9b9f2bdf9c6137f$export$a20b9237842cdd3f = class ModelLiveRange extends $b9b9f2bdf9c6137f$var$ModelLiveRangeBase {
    /**
	* Creates a live range.
	*
	* @see module:engine/model/range~ModelRange
	*/ constructor(start, end, model){
        super(start, end);
        const root = this.root;
        const boundModel = model || (root.is("rootElement") ? root.document.model : null);
        if (!boundModel) /**
		* LiveRange's root has to be an instance of ModelRootElement or have a reference to a model instance.
		*
		* @error model-liverange-no-model-reference
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-liverange-no-model-reference", root);
        $b9b9f2bdf9c6137f$var$bindWithModel$1.call(this, boundModel);
    }
    /**
	* Unbinds all events previously bound by `ModelLiveRange`. Use it whenever you don't need `ModelLiveRange` instance
	* anymore (i.e. when leaving scope in which it was declared or before re-assigning variable that was
	* referring to it).
	*/ detach() {
        this.stopListening();
    }
    /**
	* Creates a {@link module:engine/model/range~ModelRange range instance} that is equal to this live range.
	*/ toRange() {
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(this.start, this.end);
    }
    /**
	* Creates a `ModelLiveRange` instance that is equal to the given range.
	*/ static fromRange(range) {
        return new ModelLiveRange(range.start, range.end);
    }
    /**
	* Creates a `ModelLiveRange` for a range rooted in
	* a {@link module:engine/model/documentfragment~ModelDocumentFragment document fragment}.
	*
	* Document fragment does not belong to a document, so the live range is bound to the provided `model` and keeps
	* itself in sync with every operation applied to that fragment (e.g. while editing clipboard content).
	*
	* @internal
	*/ static _fromRangeInDocumentFragment(range, model) {
        return new this(range.start, range.end, model);
    }
};
$b9b9f2bdf9c6137f$export$a20b9237842cdd3f.prototype.is = function(type) {
    return type === "liveRange" || type === "model:liveRange" || type == "range" || type === "model:range";
};
/**
* Binds this `ModelLiveRange` to the given model, so the range updates itself on every operation applied to it.
*/ function $b9b9f2bdf9c6137f$var$bindWithModel$1(model) {
    const isDetached = !this.root.is("rootElement");
    this.listenTo(model, "applyOperation", (event, args)=>{
        const operation = args[0];
        if (!isDetached && !operation.isDocumentOperation) return;
        $b9b9f2bdf9c6137f$var$transform$2.call(this, operation);
    }, {
        priority: "low"
    });
}
/**
* Updates this range accordingly to the updates applied to the model. Bases on change events.
*/ function $b9b9f2bdf9c6137f$var$transform$2(operation) {
    const ranges = this.getTransformedByOperation(operation);
    if (ranges.length === 0) {
        const deletionPosition = operation.sourcePosition;
        this.start = deletionPosition;
        this.end = deletionPosition;
        this.fire("change:drop", this.toRange(), {
            deletionPosition: deletionPosition
        });
        return;
    }
    const result = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromRanges(ranges);
    const boundariesChanged = !result.isEqual(this);
    const contentChanged = $b9b9f2bdf9c6137f$var$doesOperationChangeRangeContent(this, operation);
    let deletionPosition = null;
    if (boundariesChanged) {
        if (result.root.rootName == "$graveyard") {
            if (operation.type == "remove") deletionPosition = operation.sourcePosition;
            else deletionPosition = operation.deletionPosition;
        }
        const oldRange = this.toRange();
        this.start = result.start;
        this.end = result.end;
        this.fire("change:range", oldRange, {
            deletionPosition: deletionPosition
        });
    } else if (contentChanged) this.fire("change:content", this.toRange(), {
        deletionPosition: deletionPosition
    });
}
/**
* Checks whether given operation changes something inside the range (even if it does not change boundaries).
*/ function $b9b9f2bdf9c6137f$var$doesOperationChangeRangeContent(range, operation) {
    switch(operation.type){
        case "insert":
            return range.containsPosition(operation.position);
        case "move":
        case "remove":
        case "reinsert":
        case "merge":
            return range.containsPosition(operation.sourcePosition) || range.start.isEqual(operation.sourcePosition) || range.containsPosition(operation.targetPosition);
        case "split":
            return range.containsPosition(operation.splitPosition) || range.containsPosition(operation.insertionPosition);
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/text
*/ /**
* Model text node. Type of {@link module:engine/model/node~ModelNode node} that
* contains {@link module:engine/model/text~ModelText#data text data}.
*
* **Important:** see {@link module:engine/model/node~ModelNode} to read about restrictions using `Text` and `Node` API.
*
* **Note:** keep in mind that `Text` instances might indirectly got removed from model tree when model is changed.
* This happens when {@link module:engine/model/writer~ModelWriter model writer} is used to change model and the text node is merged with
* another text node. Then, both text nodes are removed and a new text node is inserted into the model. Because of
* this behavior, keeping references to `Text` is not recommended. Instead, consider creating
* {@link module:engine/model/liveposition~ModelLivePosition live position} placed before the text node.
*/ var $b9b9f2bdf9c6137f$export$7d1212a712b16fb5 = class ModelText extends $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb {
    /**
	* Text data contained in this text node.
	*
	* @internal
	*/ _data;
    /**
	* Creates a text node.
	*
	* **Note:** Constructor of this class shouldn't be used directly in the code.
	* Use the {@link module:engine/model/writer~ModelWriter#createText} method instead.
	*
	* @internal
	* @param data Node's text.
	* @param attrs Node's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
	*/ constructor(data, attrs){
        super(attrs);
        this._data = data || "";
    }
    /**
	* @inheritDoc
	*/ get offsetSize() {
        return this.data.length;
    }
    /**
	* Returns a text data contained in the node.
	*/ get data() {
        return this._data;
    }
    /**
	* Converts `Text` instance to plain object and returns it.
	*
	* @returns`Text` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.data = this.data;
        return json;
    }
    /**
	* Creates a copy of this text node and returns it. Created text node has same text data and attributes as original text node.
	*
	* @internal
	* @returns `Text` instance created using given plain object.
	*/ _clone() {
        return new ModelText(this.data, this.getAttributes());
    }
    /**
	* Creates a `Text` instance from given plain object (i.e. parsed JSON string).
	*
	* @param json Plain object to be converted to `Text`.
	* @returns `Text` instance created using given plain object.
	*/ static fromJSON(json) {
        return new ModelText(json.data, json.attributes);
    }
};
$b9b9f2bdf9c6137f$export$7d1212a712b16fb5.prototype.is = function(type) {
    return type === "$text" || type === "model:$text" || type === "text" || type === "model:text" || type === "node" || type === "model:node";
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/documentselection
*/ const $b9b9f2bdf9c6137f$var$storePrefix = "selection:";
const $b9b9f2bdf9c6137f$var$ModelDocumentSelectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$68dcb975ec9fb725);
/**
* `ModelDocumentSelection` is a special selection which is used as the
* {@link module:engine/model/document~ModelDocument#selection document's selection}.
* There can be only one instance of `ModelDocumentSelection` per document.
*
* Document selection can only be changed by using the {@link module:engine/model/writer~ModelWriter} instance
* inside the {@link module:engine/model/model~Model#change `change()`} block, as it provides a secure way to modify model.
*
* `ModelDocumentSelection` is automatically updated upon changes in the {@link module:engine/model/document~ModelDocument document}
* to always contain valid ranges. Its attributes are inherited from the text unless set explicitly.
*
* Differences between {@link module:engine/model/selection~ModelSelection} and `ModelDocumentSelection` are:
* * there is always a range in `ModelDocumentSelection` - even if no ranges were added there is a "default range"
* present in the selection,
* * ranges added to this selection updates automatically when the document changes,
* * attributes of `ModelDocumentSelection` are updated automatically according to selection ranges.
*
* Since `ModelDocumentSelection` uses {@link module:engine/model/liverange~ModelLiveRange live ranges}
* and is updated when {@link module:engine/model/document~ModelDocument document}
* changes, it cannot be set on {@link module:engine/model/node~ModelNode nodes}
* that are inside {@link module:engine/model/documentfragment~ModelDocumentFragment document fragment}.
* If you need to represent a selection in document fragment,
* use {@link module:engine/model/selection~ModelSelection Selection class} instead.
*/ var $b9b9f2bdf9c6137f$export$7ad0b188284367aa = class extends $b9b9f2bdf9c6137f$var$ModelDocumentSelectionBase {
    /**
	* Selection used internally by that class (`ModelDocumentSelection` is a proxy to that selection).
	*/ _selection;
    /**
	* Creates an empty live selection for given {@link module:engine/model/document~ModelDocument}.
	*
	* @param doc Document which owns this selection.
	*/ constructor(doc){
        super();
        this._selection = new $b9b9f2bdf9c6137f$var$LiveSelection(doc);
        this._selection.delegate("change:range").to(this);
        this._selection.delegate("change:attribute").to(this);
        this._selection.delegate("change:marker").to(this);
    }
    /**
	* Describes whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
	* collapsed.
	*/ get isCollapsed() {
        return this._selection.isCollapsed;
    }
    /**
	* Selection anchor. Anchor may be described as a position where the most recent part of the selection starts.
	* Together with {@link #focus} they define the direction of selection, which is important
	* when expanding/shrinking selection. Anchor is always {@link module:engine/model/range~ModelRange#start start} or
	* {@link module:engine/model/range~ModelRange#end end} position of the most recently added range.
	*
	* Is set to `null` if there are no ranges in selection.
	*
	* @see #focus
	*/ get anchor() {
        return this._selection.anchor;
    }
    /**
	* Selection focus. Focus is a position where the selection ends.
	*
	* Is set to `null` if there are no ranges in selection.
	*
	* @see #anchor
	*/ get focus() {
        return this._selection.focus;
    }
    /**
	* Number of ranges in selection.
	*/ get rangeCount() {
        return this._selection.rangeCount;
    }
    /**
	* Describes whether `Documentselection` has own range(s) set, or if it is defaulted to
	* {@link module:engine/model/document~ModelDocument#_getDefaultRange document's default range}.
	*/ get hasOwnRange() {
        return this._selection.hasOwnRange;
    }
    /**
	* Specifies whether the {@link #focus}
	* precedes {@link #anchor}.
	*
	* @readonly
	* @type {Boolean}
	*/ get isBackward() {
        return this._selection.isBackward;
    }
    /**
	* Describes whether the gravity is overridden (using {@link module:engine/model/writer~ModelWriter#overrideSelectionGravity}) or not.
	*
	* Note that the gravity remains overridden as long as will not be restored the same number of times as it was overridden.
	*/ get isGravityOverridden() {
        return this._selection.isGravityOverridden;
    }
    /**
	* A collection of selection {@link module:engine/model/markercollection~Marker markers}.
	* Marker is a selection marker when selection range is inside the marker range.
	*
	* **Note**: Only markers from {@link ~ModelDocumentSelection#observeMarkers observed markers groups} are collected.
	*/ get markers() {
        return this._selection.markers;
    }
    /**
	* Used for the compatibility with the {@link module:engine/model/selection~ModelSelection#isEqual} method.
	*
	* @internal
	*/ get _ranges() {
        return this._selection._ranges;
    }
    /**
	* Returns an iterable that iterates over copies of selection ranges.
	*/ getRanges() {
        return this._selection.getRanges();
    }
    /**
	* Returns the first position in the selection.
	* First position is the position that {@link module:engine/model/position~ModelPosition#isBefore is before}
	* any other position in the selection.
	*
	* Returns `null` if there are no ranges in selection.
	*/ getFirstPosition() {
        return this._selection.getFirstPosition();
    }
    /**
	* Returns the last position in the selection.
	* Last position is the position that {@link module:engine/model/position~ModelPosition#isAfter is after}
	* any other position in the selection.
	*
	* Returns `null` if there are no ranges in selection.
	*/ getLastPosition() {
        return this._selection.getLastPosition();
    }
    /**
	* Returns a copy of the first range in the selection.
	* First range is the one which {@link module:engine/model/range~ModelRange#start start} position
	* {@link module:engine/model/position~ModelPosition#isBefore is before} start position of all other ranges
	* (not to confuse with the first range added to the selection).
	*
	* Returns `null` if there are no ranges in selection.
	*/ getFirstRange() {
        return this._selection.getFirstRange();
    }
    /**
	* Returns a copy of the last range in the selection.
	* Last range is the one which {@link module:engine/model/range~ModelRange#end end} position
	* {@link module:engine/model/position~ModelPosition#isAfter is after} end position of all
	* other ranges (not to confuse with the range most recently added to the selection).
	*
	* Returns `null` if there are no ranges in selection.
	*/ getLastRange() {
        return this._selection.getLastRange();
    }
    /**
	* Gets elements of type {@link module:engine/model/schema~ModelSchema#isBlock "block"} touched by the selection.
	*
	* This method's result can be used for example to apply block styling to all blocks covered by this selection.
	*
	* **Note:** `getSelectedBlocks()` returns blocks that are nested in other non-block elements
	* but will not return blocks nested in other blocks.
	*
	* In this case the function will return exactly all 3 paragraphs (note: `<blockQuote>` is not a block itself):
	*
	* ```
	* <paragraph>[a</paragraph>
	* <blockQuote>
	* 	<paragraph>b</paragraph>
	* </blockQuote>
	* <paragraph>c]d</paragraph>
	* ```
	*
	* In this case the paragraph will also be returned, despite the collapsed selection:
	*
	* ```
	* <paragraph>[]a</paragraph>
	* ```
	*
	* In such a scenario, however, only blocks A, B & E will be returned as blocks C & D are nested in block B:
	*
	* ```
	* [<blockA></blockA>
	* <blockB>
	* 	<blockC></blockC>
	* 	<blockD></blockD>
	* </blockB>
	* <blockE></blockE>]
	* ```
	*
	* If the selection is inside a block all the inner blocks (A & B) are returned:
	*
	* ```
	* <block>
	* 	<blockA>[a</blockA>
	* 	<blockB>b]</blockB>
	* </block>
	* ```
	*
	* **Special case**: If a selection ends at the beginning of a block, that block is not returned as from user perspective
	* this block wasn't selected. See [#984](https://github.com/ckeditor/ckeditor5-engine/issues/984) for more details.
	*
	* ```
	* <paragraph>[a</paragraph>
	* <paragraph>b</paragraph>
	* <paragraph>]c</paragraph> // this block will not be returned
	* ```
	*/ getSelectedBlocks() {
        return this._selection.getSelectedBlocks();
    }
    /**
	* Returns the selected element. {@link module:engine/model/element~ModelElement Element} is considered as selected if there is only
	* one range in the selection, and that range contains exactly one element.
	* Returns `null` if there is no selected element.
	*/ getSelectedElement() {
        return this._selection.getSelectedElement();
    }
    /**
	* Checks whether the selection contains the entire content of the given element. This means that selection must start
	* at a position {@link module:engine/model/position~ModelPosition#isTouching touching} the element's start and ends at position
	* touching the element's end.
	*
	* By default, this method will check whether the entire content of the selection's current root is selected.
	* Useful to check if e.g. the user has just pressed <kbd>Ctrl</kbd> + <kbd>A</kbd>.
	*/ containsEntireContent(element) {
        return this._selection.containsEntireContent(element);
    }
    /**
	* Unbinds all events previously bound by document selection.
	*/ destroy() {
        this._selection.destroy();
    }
    /**
	* Returns iterable that iterates over this selection's attribute keys.
	*/ getAttributeKeys() {
        return this._selection.getAttributeKeys();
    }
    /**
	* Returns iterable that iterates over this selection's attributes.
	*
	* Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
	* This format is accepted by native `Map` object and also can be passed in `Node` constructor.
	*/ getAttributes() {
        return this._selection.getAttributes();
    }
    /**
	* Gets an attribute value for given key or `undefined` if that attribute is not set on the selection.
	*
	* @param key Key of attribute to look for.
	* @returns Attribute value or `undefined`.
	*/ getAttribute(key) {
        return this._selection.getAttribute(key);
    }
    /**
	* Checks if the selection has an attribute for given key.
	*
	* @param key Key of attribute to check.
	* @returns `true` if attribute with given key is set on selection, `false` otherwise.
	*/ hasAttribute(key) {
        return this._selection.hasAttribute(key);
    }
    /**
	* Refreshes selection attributes and markers according to the current position in the model.
	*/ refresh() {
        this._selection.updateMarkers();
        this._selection._updateAttributes(false);
    }
    /**
	* Registers a marker group prefix or a marker name to be collected in the
	* {@link ~ModelDocumentSelection#markers selection markers collection}.
	*
	* See also {@link module:engine/model/markercollection~MarkerCollection#getMarkersGroup `MarkerCollection#getMarkersGroup()`}.
	*
	* @param prefixOrName The marker group prefix or marker name.
	*/ observeMarkers(prefixOrName) {
        this._selection.observeMarkers(prefixOrName);
    }
    /**
	* Converts `DocumentSelection` to plain object and returns it.
	*
	* @returns `DocumentSelection` converted to plain object.
	*/ toJSON() {
        return this._selection.toJSON();
    }
    /**
	* Moves {@link module:engine/model/documentselection~ModelDocumentSelection#focus} to the specified location.
	* Should be used only within the {@link module:engine/model/writer~ModelWriter#setSelectionFocus} method.
	*
	* The location can be specified in the same form as
	* {@link module:engine/model/writer~ModelWriter#createPositionAt writer.createPositionAt()} parameters.
	*
	* @see module:engine/model/writer~ModelWriter#setSelectionFocus
	* @internal
	* @param offset Offset or one of the flags. Used only when
	* first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ _setFocus(itemOrPosition, offset) {
        this._selection.setFocus(itemOrPosition, offset);
    }
    /**
	* Sets this selection's ranges and direction to the specified location based on the given
	* {@link module:engine/model/selection~ModelSelectable selectable}.
	* Should be used only within the {@link module:engine/model/writer~ModelWriter#setSelection} method.
	*
	* @see module:engine/model/writer~ModelWriter#setSelection
	* @internal
	*/ _setTo(...args) {
        this._selection.setTo(...args);
    }
    /**
	* Sets attribute on the selection. If attribute with the same key already is set, it's value is overwritten.
	* Should be used only within the {@link module:engine/model/writer~ModelWriter#setSelectionAttribute} method.
	*
	* @see module:engine/model/writer~ModelWriter#setSelectionAttribute
	* @internal
	* @param key Key of the attribute to set.
	* @param value Attribute value.
	*/ _setAttribute(key, value) {
        this._selection.setAttribute(key, value);
    }
    /**
	* Removes an attribute with given key from the selection.
	* If the given attribute was set on the selection, fires the {@link module:engine/model/selection~ModelSelection#event:change:range}
	* event with removed attribute key.
	* Should be used only within the {@link module:engine/model/writer~ModelWriter#removeSelectionAttribute} method.
	*
	* @see module:engine/model/writer~ModelWriter#removeSelectionAttribute
	* @internal
	* @param key Key of the attribute to remove.
	*/ _removeAttribute(key) {
        this._selection.removeAttribute(key);
    }
    /**
	* Returns an iterable that iterates through all selection attributes stored in current selection's parent.
	*
	* @internal
	*/ _getStoredAttributes() {
        return this._selection.getStoredAttributes();
    }
    /**
	* Temporarily changes the gravity of the selection from the left to the right.
	*
	* The gravity defines from which direction the selection inherits its attributes. If it's the default left
	* gravity, the selection (after being moved by the the user) inherits attributes from its left hand side.
	* This method allows to temporarily override this behavior by forcing the gravity to the right.
	*
	* It returns an unique identifier which is required to restore the gravity. It guarantees the symmetry
	* of the process.
	*
	* @see module:engine/model/writer~ModelWriter#overrideSelectionGravity
	* @internal
	* @returns The unique id which allows restoring the gravity.
	*/ _overrideGravity() {
        return this._selection.overrideGravity();
    }
    /**
	* Restores the {@link ~ModelDocumentSelection#_overrideGravity overridden gravity}.
	*
	* Restoring the gravity is only possible using the unique identifier returned by
	* {@link ~ModelDocumentSelection#_overrideGravity}. Note that the gravity remains overridden as long as won't be restored
	* the same number of times it was overridden.
	*
	* @see module:engine/model/writer~ModelWriter#restoreSelectionGravity
	* @internal
	* @param uid The unique id returned by {@link #_overrideGravity}.
	*/ _restoreGravity(uid) {
        this._selection.restoreGravity(uid);
    }
    /**
	* Generates and returns an attribute key for selection attributes store, basing on original attribute key.
	*
	* @internal
	* @param key Attribute key to convert.
	* @returns Converted attribute key, applicable for selection store.
	*/ static _getStoreAttributeKey(key) {
        return $b9b9f2bdf9c6137f$var$storePrefix + key;
    }
    /**
	* Checks whether the given attribute key is an attribute stored on an element.
	*
	* @internal
	*/ static _isStoreAttributeKey(key) {
        return key.startsWith($b9b9f2bdf9c6137f$var$storePrefix);
    }
    /**
	* Drop selection attribute key prefix.
	*
	* @internal
	*/ static _dropStoreAttributeKeyPrefix(key) {
        if (key.startsWith($b9b9f2bdf9c6137f$var$storePrefix)) return key.substring(10);
        return key;
    }
};
$b9b9f2bdf9c6137f$export$7ad0b188284367aa.prototype.is = function(type) {
    return type === "selection" || type == "model:selection" || type == "documentSelection" || type == "model:documentSelection";
};
/**
* `LiveSelection` is used internally by {@link module:engine/model/documentselection~ModelDocumentSelection}
* and shouldn't be used directly.
*
* `LiveSelection` is automatically updated upon changes in the {@link module:engine/model/document~ModelDocument document}
* to always contain valid ranges. Its attributes are inherited from the text unless set explicitly.
*
* Differences between {@link module:engine/model/selection~ModelSelection} and `LiveSelection` are:
* * there is always a range in `LiveSelection` - even if no ranges were added there is a "default range"
* present in the selection,
* * ranges added to this selection updates automatically when the document changes,
* * attributes of `LiveSelection` are updated automatically according to selection ranges.
*/ var $b9b9f2bdf9c6137f$var$LiveSelection = class extends $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 {
    /**
	* List of selection markers.
	* Marker is a selection marker when selection range is inside the marker range.
	*/ markers = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)({
        idProperty: "name"
    });
    /**
	* Document which owns this selection.
	*/ _model;
    /**
	* Document which owns this selection.
	*/ _document;
    /**
	* Keeps mapping of attribute name to priority with which the attribute got modified (added/changed/removed)
	* last time. Possible values of priority are: `'low'` and `'normal'`.
	*
	* Priorities are used by internal `LiveSelection` mechanisms. All attributes set using `LiveSelection`
	* attributes API are set with `'normal'` priority.
	*/ _attributePriority = /* @__PURE__ */ new Map();
    /**
	* Position to which the selection should be set if the last selection range was moved to the graveyard.
	*/ _selectionRestorePosition = null;
    /**
	* Flag that informs whether the selection ranges have changed. It is changed on true when `LiveRange#change:range` event is fired.
	*/ _hasChangedRange = false;
    /**
	* Each overriding gravity adds an UID to the set and each removal removes it.
	* Gravity is overridden when there's at least one UID in the set.
	* Gravity is restored when the set is empty.
	* This is to prevent conflicts when gravity is overridden by more than one feature at the same time.
	*/ _overriddenGravityRegister = /* @__PURE__ */ new Set();
    /**
	* Prefixes of marker names that should affect `LiveSelection#markers` collection.
	*/ _observedMarkers = /* @__PURE__ */ new Set();
    /**
	* Creates an empty live selection for given {@link module:engine/model/document~ModelDocument}.
	*
	* @param doc Document which owns this selection.
	*/ constructor(doc){
        super();
        this._model = doc.model;
        this._document = doc;
        this.listenTo(this._model, "applyOperation", (evt, args)=>{
            const operation = args[0];
            if (!operation.isDocumentOperation || operation.type == "marker" || operation.type == "rename" || operation.type == "noop") return;
            if (this._ranges.length == 0 && this._selectionRestorePosition) this._fixGraveyardSelection(this._selectionRestorePosition);
            this._selectionRestorePosition = null;
            if (this._hasChangedRange) {
                this._hasChangedRange = false;
                this.fire("change:range", {
                    directChange: false
                });
            }
        }, {
            priority: "lowest"
        });
        this.on("change:range", ()=>{
            this._validateSelectionRanges(this.getRanges());
        });
        this.listenTo(this._model.markers, "update", (evt, marker, oldRange, newRange)=>{
            this._updateMarker(marker, newRange);
        });
        this.listenTo(this._document, "change", (evt, batch)=>{
            $b9b9f2bdf9c6137f$var$clearAttributesStoredInElement(this._model, batch);
        });
    }
    get isCollapsed() {
        return this._ranges.length === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
    }
    get anchor() {
        return super.anchor || this._document._getDefaultRange().start;
    }
    get focus() {
        return super.focus || this._document._getDefaultRange().end;
    }
    get rangeCount() {
        return this._ranges.length ? this._ranges.length : 1;
    }
    /**
	* Describes whether `LiveSelection` has own range(s) set, or if it is defaulted to
	* {@link module:engine/model/document~ModelDocument#_getDefaultRange document's default range}.
	*/ get hasOwnRange() {
        return this._ranges.length > 0;
    }
    /**
	* When set to `true` then selection attributes on node before the caret won't be taken
	* into consideration while updating selection attributes.
	*/ get isGravityOverridden() {
        return !!this._overriddenGravityRegister.size;
    }
    /**
	* Unbinds all events previously bound by live selection.
	*/ destroy() {
        for(let i = 0; i < this._ranges.length; i++)this._ranges[i].detach();
        this.stopListening();
    }
    *getRanges() {
        if (this._ranges.length) yield* super.getRanges();
        else yield this._document._getDefaultRange();
    }
    getFirstRange() {
        return super.getFirstRange() || this._document._getDefaultRange();
    }
    getLastRange() {
        return super.getLastRange() || this._document._getDefaultRange();
    }
    setTo(...args) {
        super.setTo(...args);
        this._updateAttributes(true);
        this.updateMarkers();
    }
    setFocus(itemOrPosition, offset) {
        super.setFocus(itemOrPosition, offset);
        this._updateAttributes(true);
        this.updateMarkers();
    }
    setAttribute(key, value) {
        if (this._setAttribute(key, value)) {
            const attributeKeys = [
                key
            ];
            this.fire("change:attribute", {
                attributeKeys: attributeKeys,
                directChange: true
            });
        }
    }
    removeAttribute(key) {
        if (this._removeAttribute(key)) {
            const attributeKeys = [
                key
            ];
            this.fire("change:attribute", {
                attributeKeys: attributeKeys,
                directChange: true
            });
        }
    }
    overrideGravity() {
        const overrideUid = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
        this._overriddenGravityRegister.add(overrideUid);
        if (this._overriddenGravityRegister.size === 1) this._updateAttributes(true);
        return overrideUid;
    }
    restoreGravity(uid) {
        if (!this._overriddenGravityRegister.has(uid)) /**
		* Restoring gravity for an unknown UID is not possible. Make sure you are using a correct
		* UID obtained from the {@link module:engine/model/writer~ModelWriter#overrideSelectionGravity} to restore.
		*
		* @error document-selection-gravity-wrong-restore
		* @param {string} uid The unique identifier returned by
		* {@link module:engine/model/documentselection~ModelDocumentSelection#_overrideGravity}.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("document-selection-gravity-wrong-restore", this, {
            uid: uid
        });
        this._overriddenGravityRegister.delete(uid);
        if (!this.isGravityOverridden) this._updateAttributes(true);
    }
    observeMarkers(prefixOrName) {
        this._observedMarkers.add(prefixOrName);
        this.updateMarkers();
    }
    _replaceAllRanges(ranges) {
        this._validateSelectionRanges(ranges);
        super._replaceAllRanges(ranges);
    }
    _popRange() {
        this._ranges.pop().detach();
    }
    _pushRange(range) {
        const liveRange = this._prepareRange(range);
        if (liveRange) this._ranges.push(liveRange);
    }
    /**
	* Converts `LiveSelection` to plain object and returns it.
	*
	* @returns `LiveSelection` converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        if (this.markers.length) json.markers = this.markers.map((marker)=>marker.toJSON());
        return json;
    }
    _validateSelectionRanges(ranges) {
        for (const range of ranges)if (!this._document._validateSelectionRange(range)) /**
		* Range from {@link module:engine/model/documentselection~ModelDocumentSelection document selection}
		* starts or ends at incorrect position.
		*
		* @error document-selection-wrong-position
		* @param {module:engine/model/range~ModelRange} range The invalid range.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("document-selection-wrong-position", this, {
            range: range
        });
    }
    /**
	* Prepares given range to be added to selection. Checks if it is correct,
	* converts it to {@link module:engine/model/liverange~ModelLiveRange ModelLiveRange}
	* and sets listeners listening to the range's change event.
	*/ _prepareRange(range) {
        this._checkRange(range);
        if (range.root == this._document.graveyard) return;
        const liveRange = $b9b9f2bdf9c6137f$export$a20b9237842cdd3f.fromRange(range);
        liveRange.on("change:range", (evt, oldRange, data)=>{
            this._hasChangedRange = true;
            if (liveRange.root == this._document.graveyard) {
                this._selectionRestorePosition = data.deletionPosition;
                const index = this._ranges.indexOf(liveRange);
                this._ranges.splice(index, 1);
                liveRange.detach();
            }
        });
        return liveRange;
    }
    updateMarkers() {
        if (!this._observedMarkers.size) return;
        const markers = [];
        let changed = false;
        for (const marker of this._model.markers){
            const markerGroup = marker.name.split(":", 1)[0];
            if (!this._observedMarkers.has(markerGroup)) continue;
            const markerRange = marker.getRange();
            for (const selectionRange of this.getRanges())if (markerRange.containsRange(selectionRange, !selectionRange.isCollapsed)) markers.push(marker);
        }
        const oldMarkers = Array.from(this.markers);
        for (const marker of markers)if (!this.markers.has(marker)) {
            this.markers.add(marker);
            changed = true;
        }
        for (const marker of Array.from(this.markers))if (!markers.includes(marker)) {
            this.markers.remove(marker);
            changed = true;
        }
        if (changed) this.fire("change:marker", {
            oldMarkers: oldMarkers,
            directChange: false
        });
    }
    _updateMarker(marker, markerRange) {
        const markerGroup = marker.name.split(":", 1)[0];
        if (!this._observedMarkers.has(markerGroup)) return;
        let changed = false;
        const oldMarkers = Array.from(this.markers);
        const hasMarker = this.markers.has(marker);
        if (!markerRange) {
            if (hasMarker) {
                this.markers.remove(marker);
                changed = true;
            }
        } else {
            let contained = false;
            for (const selectionRange of this.getRanges())if (markerRange.containsRange(selectionRange, !selectionRange.isCollapsed)) {
                contained = true;
                break;
            }
            if (contained && !hasMarker) {
                this.markers.add(marker);
                changed = true;
            } else if (!contained && hasMarker) {
                this.markers.remove(marker);
                changed = true;
            }
        }
        if (changed) this.fire("change:marker", {
            oldMarkers: oldMarkers,
            directChange: false
        });
    }
    /**
	* Updates this selection attributes according to its ranges and the {@link module:engine/model/document~ModelDocument model document}.
	*/ _updateAttributes(clearAll) {
        const newAttributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(this._getSurroundingAttributes());
        const oldAttributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(this.getAttributes());
        if (clearAll) {
            this._attributePriority = /* @__PURE__ */ new Map();
            this._attrs = /* @__PURE__ */ new Map();
        } else for (const [key, priority] of this._attributePriority)if (priority == "low") {
            this._attrs.delete(key);
            this._attributePriority.delete(key);
        }
        this._setAttributesTo(newAttributes);
        const changed = [];
        for (const [newKey, newValue] of this.getAttributes())if (!oldAttributes.has(newKey) || oldAttributes.get(newKey) !== newValue) changed.push(newKey);
        for (const [oldKey] of oldAttributes)if (!this.hasAttribute(oldKey)) changed.push(oldKey);
        if (changed.length > 0) this.fire("change:attribute", {
            attributeKeys: changed,
            directChange: false
        });
    }
    /**
	* Internal method for setting `LiveSelection` attribute. Supports attribute priorities (through `directChange`
	* parameter).
	*/ _setAttribute(key, value, directChange = true) {
        const priority = directChange ? "normal" : "low";
        if (priority == "low" && this._attributePriority.get(key) == "normal") return false;
        if (super.getAttribute(key) === value) return false;
        this._attrs.set(key, value);
        this._attributePriority.set(key, priority);
        return true;
    }
    /**
	* Internal method for removing `LiveSelection` attribute. Supports attribute priorities (through `directChange`
	* parameter).
	*
	* NOTE: Even if attribute is not present in the selection but is provided to this method, it's priority will
	* be changed according to `directChange` parameter.
	*/ _removeAttribute(key, directChange = true) {
        const priority = directChange ? "normal" : "low";
        if (priority == "low" && this._attributePriority.get(key) == "normal") return false;
        this._attributePriority.set(key, priority);
        if (!super.hasAttribute(key)) return false;
        this._attrs.delete(key);
        return true;
    }
    /**
	* Internal method for setting multiple `LiveSelection` attributes. Supports attribute priorities (through
	* `directChange` parameter).
	*/ _setAttributesTo(attrs) {
        const changed = /* @__PURE__ */ new Set();
        for (const [oldKey, oldValue] of this.getAttributes()){
            if (attrs.get(oldKey) === oldValue) continue;
            this._removeAttribute(oldKey, false);
        }
        for (const [key, value] of attrs)if (this._setAttribute(key, value, false)) changed.add(key);
        return changed;
    }
    /**
	* Returns an iterable that iterates through all selection attributes stored in current selection's parent.
	*/ *getStoredAttributes() {
        const selectionParent = this.getFirstPosition().parent;
        if (this.isCollapsed && selectionParent.isEmpty) {
            for (const key of selectionParent.getAttributeKeys())if (key.startsWith($b9b9f2bdf9c6137f$var$storePrefix)) yield [
                key.substr(10),
                selectionParent.getAttribute(key)
            ];
        }
    }
    /**
	* Checks model text nodes that are closest to the selection's first position and returns attributes of first
	* found element. If there are no text nodes in selection's first position parent, it returns selection
	* attributes stored in that parent.
	*/ _getSurroundingAttributes() {
        const position = this.getFirstPosition();
        const schema = this._model.schema;
        if (position.root.rootName == "$graveyard") return null;
        let attrs = null;
        if (!this.isCollapsed) {
            const range = this.getFirstRange();
            for (const value of range){
                if (value.item.is("element") && schema.isObject(value.item)) {
                    attrs = $b9b9f2bdf9c6137f$var$getTextAttributes(value.item, schema);
                    break;
                }
                if (value.type == "text") {
                    attrs = value.item.getAttributes();
                    break;
                }
            }
        } else {
            const nodeBefore = position.textNode ? position.textNode : position.nodeBefore;
            const nodeAfter = position.textNode ? position.textNode : position.nodeAfter;
            if (!this.isGravityOverridden) attrs = $b9b9f2bdf9c6137f$var$getTextAttributes(nodeBefore, schema);
            if (!attrs) attrs = $b9b9f2bdf9c6137f$var$getTextAttributes(nodeAfter, schema);
            if (!this.isGravityOverridden && !attrs) attrs = $b9b9f2bdf9c6137f$var$getTextAttributes(nodeBefore, schema, "backward");
            if (!attrs) attrs = $b9b9f2bdf9c6137f$var$getTextAttributes(nodeAfter, schema, "forward");
            if (!attrs) attrs = this.getStoredAttributes();
        }
        return attrs;
    }
    /**
	* Fixes the selection after all its ranges got removed.
	* @param deletionPosition Position where the deletion happened.
	*/ _fixGraveyardSelection(deletionPosition) {
        const selectionRange = this._model.schema.getNearestSelectionRange(deletionPosition);
        if (selectionRange) this._pushRange(selectionRange);
    }
};
/**
* Helper function for {@link module:engine/model/liveselection~LiveSelection#_updateAttributes}.
*
* It checks if the passed model node is a text node and, if so, returns its attributes.
* If not, it checks if item is an inline element and does the same. Otherwise, it returns `null`.
*/ function $b9b9f2bdf9c6137f$var$getTextAttributes(startNode, schema, scan = "self") {
    if (!startNode) return null;
    for (const node of $b9b9f2bdf9c6137f$var$siblingNodes(startNode, scan)){
        if (!node) return null;
        if (node instanceof $b9b9f2bdf9c6137f$export$7d1212a712b16fb5) return node.getAttributes();
        if (!schema.isInline(node)) continue;
        const isObject = schema.isObject(node);
        const attributes = [];
        for (const [key, value] of node.getAttributes())if (schema.checkAttribute("$text", key) && (!isObject || schema.getAttributeProperties(key).copyFromObject !== false)) attributes.push([
            key,
            value
        ]);
        return attributes;
    }
    return null;
}
/**
* Returns sibling nodes from the given start node.
*/ function* $b9b9f2bdf9c6137f$var$siblingNodes(startNode, scan) {
    if (scan == "self") yield startNode;
    else {
        let node = startNode;
        while(node){
            node = scan == "backward" ? node.previousSibling : node.nextSibling;
            yield node;
        }
    }
    return null;
}
/**
* Removes selection attributes from element which is not empty anymore.
*/ function $b9b9f2bdf9c6137f$var$clearAttributesStoredInElement(model, batch) {
    const differ = model.document.differ;
    for (const entry of differ.getChanges()){
        if (entry.type != "insert") continue;
        const changeParent = entry.position.parent;
        if (entry.length === changeParent.maxOffset) model.enqueueChange(batch, (writer)=>{
            const storedAttributes = Array.from(changeParent.getAttributeKeys()).filter((key)=>key.startsWith($b9b9f2bdf9c6137f$var$storePrefix));
            for (const key of storedAttributes)writer.removeAttribute(key, changeParent);
        });
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/nodelist
*/ /**
* Provides an interface to operate on a list of {@link module:engine/model/node~ModelNode nodes}. `NodeList` is used internally
* in classes like {@link module:engine/model/element~ModelElement Element}
* or {@link module:engine/model/documentfragment~ModelDocumentFragment ModelDocumentFragment}.
*/ var $b9b9f2bdf9c6137f$export$a6b5dd876e414da1 = class {
    /**
	* Nodes contained in this node list.
	*/ _nodes = [];
    /**
	* This array maps numbers (offsets) to node that is placed at that offset.
	*
	* This array is similar to `_nodes` with the difference that one node may occupy multiple consecutive items in the array.
	*
	* This array is needed to quickly retrieve a node that is placed at given offset.
	*/ _offsetToNode = [];
    /**
	* Creates a node list.
	*
	* @internal
	* @param nodes Nodes contained in this node list.
	*/ constructor(nodes){
        if (nodes) this._insertNodes(0, nodes);
    }
    /**
	* Iterable interface.
	*
	* Iterates over all nodes contained inside this node list.
	*/ [Symbol.iterator]() {
        return this._nodes[Symbol.iterator]();
    }
    /**
	* Number of nodes contained inside this node list.
	*/ get length() {
        return this._nodes.length;
    }
    /**
	* Sum of {@link module:engine/model/node~ModelNode#offsetSize offset sizes} of all nodes contained inside this node list.
	*/ get maxOffset() {
        return this._offsetToNode.length;
    }
    /**
	* Gets the node at the given index. Returns `null` if incorrect index was passed.
	*/ getNode(index) {
        return this._nodes[index] || null;
    }
    /**
	* Gets the node at the given offset. Returns `null` if incorrect offset was passed.
	*/ getNodeAtOffset(offset) {
        return this._offsetToNode[offset] || null;
    }
    /**
	* Returns an index of the given node or `null` if given node does not have a parent.
	*
	* This is an alias to {@link module:engine/model/node~ModelNode#index}.
	*/ getNodeIndex(node) {
        return node.index;
    }
    /**
	* Returns the offset at which given node is placed in its parent or `null` if given node does not have a parent.
	*
	* This is an alias to {@link module:engine/model/node~ModelNode#startOffset}.
	*/ getNodeStartOffset(node) {
        return node.startOffset;
    }
    /**
	* Converts index to offset in node list.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `model-nodelist-index-out-of-bounds` if given index is less
	* than `0` or more than {@link #length}.
	*/ indexToOffset(index) {
        if (index == this._nodes.length) return this.maxOffset;
        const node = this._nodes[index];
        if (!node) /**
		* Given index cannot be found in the node list.
		*
		* @error model-nodelist-index-out-of-bounds
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-nodelist-index-out-of-bounds", this);
        return this.getNodeStartOffset(node);
    }
    /**
	* Converts offset in node list to index.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `model-nodelist-offset-out-of-bounds` if given offset is less
	* than `0` or more than {@link #maxOffset}.
	*/ offsetToIndex(offset) {
        if (offset == this._offsetToNode.length) return this._nodes.length;
        const node = this._offsetToNode[offset];
        if (!node) /**
		* Given offset cannot be found in the node list.
		*
		* @error model-nodelist-offset-out-of-bounds
		* @param {number} offset The offset value.
		* @param {module:engine/model/nodelist~ModelNodeList} nodeList Stringified node list.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-nodelist-offset-out-of-bounds", this, {
            offset: offset,
            nodeList: this
        });
        return this.getNodeIndex(node);
    }
    /**
	* Inserts given nodes at given index.
	*
	* @internal
	* @param index Index at which nodes should be inserted.
	* @param nodes Nodes to be inserted.
	*/ _insertNodes(index, nodes) {
        const nodesArray = [];
        for (const node of nodes){
            if (!(node instanceof $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb)) /**
			* Trying to insert an object which is not a Node instance.
			*
			* @error model-nodelist-insertnodes-not-node
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-nodelist-insertnodes-not-node", this);
            nodesArray.push(node);
        }
        let offset = this.indexToOffset(index);
        (0, $c7bc2cb7e2db0227$export$a4bf84605575402a)(this._nodes, nodesArray, index);
        (0, $c7bc2cb7e2db0227$export$a4bf84605575402a)(this._offsetToNode, $b9b9f2bdf9c6137f$var$makeOffsetsArray(nodesArray), offset);
        for(let i = index; i < this._nodes.length; i++){
            this._nodes[i]._index = i;
            this._nodes[i]._startOffset = offset;
            offset += this._nodes[i].offsetSize;
        }
    }
    /**
	* Removes one or more nodes starting at the given index.
	*
	* @internal
	* @param indexStart Index of the first node to remove.
	* @param howMany Number of nodes to remove.
	* @returns Array containing removed nodes.
	*/ _removeNodes(indexStart, howMany = 1) {
        if (howMany == 0) return [];
        let offset = this.indexToOffset(indexStart);
        const nodes = this._nodes.splice(indexStart, howMany);
        const lastNode = nodes[nodes.length - 1];
        const removedOffsetSum = lastNode.startOffset + lastNode.offsetSize - offset;
        this._offsetToNode.splice(offset, removedOffsetSum);
        for (const node of nodes){
            node._index = null;
            node._startOffset = null;
        }
        for(let i = indexStart; i < this._nodes.length; i++){
            this._nodes[i]._index = i;
            this._nodes[i]._startOffset = offset;
            offset += this._nodes[i].offsetSize;
        }
        return nodes;
    }
    /**
	* Removes children nodes provided as an array. These nodes do not need to be direct siblings.
	*
	* This method is faster than removing nodes one by one, as it recalculates offsets only once.
	*
	* @internal
	* @param nodes Array of nodes.
	*/ _removeNodesArray(nodes) {
        if (nodes.length == 0) return;
        for (const node of nodes){
            node._index = null;
            node._startOffset = null;
        }
        this._nodes = this._nodes.filter((node)=>node.index !== null);
        this._offsetToNode = this._offsetToNode.filter((node)=>node.index !== null);
        let offset = 0;
        for(let i = 0; i < this._nodes.length; i++){
            this._nodes[i]._index = i;
            this._nodes[i]._startOffset = offset;
            offset += this._nodes[i].offsetSize;
        }
    }
    /**
	* Converts `NodeList` instance to an array containing nodes that were inserted in the node list. Nodes
	* are also converted to their plain object representation.
	*
	* @returns `NodeList` instance converted to `Array`.
	*/ toJSON() {
        return this._nodes.map((node)=>node.toJSON());
    }
};
/**
* Creates an array of nodes in the format as in {@link module:engine/model/nodelist~ModelNodeList#_offsetToNode}, i.e. one node will
* occupy multiple items if its offset size is greater than one.
*/ function $b9b9f2bdf9c6137f$var$makeOffsetsArray(nodes) {
    const offsets = [];
    let index = 0;
    for (const node of nodes)for(let i = 0; i < node.offsetSize; i++)offsets[index++] = node;
    return offsets;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/element
*/ /**
* Model element. Type of {@link module:engine/model/node~ModelNode node} that has a
* {@link module:engine/model/element~ModelElement#name name} and {@link module:engine/model/element~ModelElement#getChildren child nodes}.
*
* **Important**: see {@link module:engine/model/node~ModelNode} to read about restrictions using `Element` and `Node` API.
*/ var $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 = class ModelElement extends $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb {
    /**
	* Element name.
	*/ name;
    /**
	* List of children nodes.
	*/ _children = new $b9b9f2bdf9c6137f$export$a6b5dd876e414da1();
    /**
	* Creates a model element.
	*
	* **Note:** Constructor of this class shouldn't be used directly in the code.
	* Use the {@link module:engine/model/writer~ModelWriter#createElement} method instead.
	*
	* @internal
	* @param name Element's name.
	* @param attrs Element's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
	* @param children One or more nodes to be inserted as children of created element.
	*/ constructor(name, attrs, children){
        super(attrs);
        this.name = name;
        if (children) this._insertChild(0, children);
    }
    /**
	* Number of this element's children.
	*/ get childCount() {
        return this._children.length;
    }
    /**
	* Sum of {@link module:engine/model/node~ModelNode#offsetSize offset sizes} of all of this element's children.
	*/ get maxOffset() {
        return this._children.maxOffset;
    }
    /**
	* Is `true` if there are no nodes inside this element, `false` otherwise.
	*/ get isEmpty() {
        return this.childCount === 0;
    }
    /**
	* Gets the child at the given index. Returns `null` if incorrect index was passed.
	*
	* @param index Index in this element.
	* @returns Child node.
	*/ getChild(index) {
        return this._children.getNode(index);
    }
    /**
	* Gets the child at the given offset. Returns `null` if incorrect index was passed.
	*
	* @param offset Offset in this element.
	* @returns Child node.
	*/ getChildAtOffset(offset) {
        return this._children.getNodeAtOffset(offset);
    }
    /**
	* Returns an iterator that iterates over all of this element's children.
	*/ getChildren() {
        return this._children[Symbol.iterator]();
    }
    /**
	* Returns an index of the given child node. Returns `null` if given node is not a child of this element.
	*
	* @param node Child node to look for.
	* @returns Child node's index in this element.
	*/ getChildIndex(node) {
        return this._children.getNodeIndex(node);
    }
    /**
	* Returns the starting offset of given child. Starting offset is equal to the sum of
	* {@link module:engine/model/node~ModelNode#offsetSize offset sizes} of all node's siblings that are before it. Returns `null` if
	* given node is not a child of this element.
	*
	* @param node Child node to look for.
	* @returns Child node's starting offset.
	*/ getChildStartOffset(node) {
        return this._children.getNodeStartOffset(node);
    }
    /**
	* Returns index of a node that occupies given offset. If given offset is too low, returns `0`. If given offset is
	* too high, returns {@link module:engine/model/element~ModelElement#getChildIndex index after last child}.
	*
	* ```ts
	* const textNode = new Text( 'foo' );
	* const pElement = new Element( 'p' );
	* const divElement = new Element( [ textNode, pElement ] );
	* divElement.offsetToIndex( -1 ); // Returns 0, because offset is too low.
	* divElement.offsetToIndex( 0 ); // Returns 0, because offset 0 is taken by `textNode` which is at index 0.
	* divElement.offsetToIndex( 1 ); // Returns 0, because `textNode` has `offsetSize` equal to 3, so it occupies offset 1 too.
	* divElement.offsetToIndex( 2 ); // Returns 0.
	* divElement.offsetToIndex( 3 ); // Returns 1.
	* divElement.offsetToIndex( 4 ); // Returns 2. There are no nodes at offset 4, so last available index is returned.
	* ```
	*/ offsetToIndex(offset) {
        return this._children.offsetToIndex(offset);
    }
    /**
	* Returns a descendant node by its path relative to this element.
	*
	* ```ts
	* // <this>a<b>c</b></this>
	* this.getNodeByPath( [ 0 ] );     // -> "a"
	* this.getNodeByPath( [ 1 ] );     // -> <b>
	* this.getNodeByPath( [ 1, 0 ] );  // -> "c"
	* ```
	*
	* @param relativePath Path of the node to find, relative to this element.
	*/ getNodeByPath(relativePath) {
        let node = this;
        for (const offset of relativePath)node = node.getChildAtOffset(offset);
        return node;
    }
    /**
	* Returns the parent element of the given name. Returns null if the element is not inside the desired parent.
	*
	* @param parentName The name of the parent element to find.
	* @param options Options object.
	* @param options.includeSelf When set to `true` this node will be also included while searching.
	*/ findAncestor(parentName, options = {}) {
        let parent = options.includeSelf ? this : this.parent;
        while(parent){
            if (parent.name === parentName) return parent;
            parent = parent.parent;
        }
        return null;
    }
    /**
	* Converts `Element` instance to plain object and returns it. Takes care of converting all of this element's children.
	*
	* @returns `Element` instance converted to plain object.
	*/ toJSON() {
        const json = super.toJSON();
        json.name = this.name;
        if (this._children.length > 0) {
            json.children = [];
            for (const node of this._children)json.children.push(node.toJSON());
        }
        return json;
    }
    /**
	* Creates a copy of this element and returns it. Created element has the same name and attributes as the original element.
	* If clone is deep, the original element's children are also cloned. If not, then empty element is returned.
	*
	* @internal
	* @param deep If set to `true` clones element and all its children recursively. When set to `false`,
	* element will be cloned without any child.
	*/ _clone(deep = false) {
        const children = deep ? $b9b9f2bdf9c6137f$var$cloneNodes(this._children) : void 0;
        return new ModelElement(this.name, this.getAttributes(), children);
    }
    /**
	* {@link module:engine/model/element~ModelElement#_insertChild Inserts} one or more nodes at the end of this element.
	*
	* @see module:engine/model/writer~ModelWriter#append
	* @internal
	* @param nodes Nodes to be inserted.
	*/ _appendChild(nodes) {
        this._insertChild(this.childCount, nodes);
    }
    /**
	* Inserts one or more nodes at the given index and sets {@link module:engine/model/node~ModelNode#parent parent} of these nodes
	* to this element.
	*
	* @see module:engine/model/writer~ModelWriter#insert
	* @internal
	* @param index Index at which nodes should be inserted.
	* @param items Items to be inserted.
	*/ _insertChild(index, items) {
        const nodes = $b9b9f2bdf9c6137f$var$normalize$1(items);
        for (const node of nodes){
            if (node.parent !== null) node._remove();
            node.parent = this;
        }
        this._children._insertNodes(index, nodes);
    }
    /**
	* Removes one or more nodes starting at the given index and sets
	* {@link module:engine/model/node~ModelNode#parent parent} of these nodes to `null`.
	*
	* @see module:engine/model/writer~ModelWriter#remove
	* @internal
	* @param index Index of the first node to remove.
	* @param howMany Number of nodes to remove.
	* @returns Array containing removed nodes.
	*/ _removeChildren(index, howMany = 1) {
        const nodes = this._children._removeNodes(index, howMany);
        for (const node of nodes)node.parent = null;
        return nodes;
    }
    /**
	* Removes children nodes provided as an array and sets
	* the {@link module:engine/model/node~ModelNode#parent parent} of these nodes to `null`.
	*
	* These nodes do not need to be direct siblings.
	*
	* This method is faster than removing nodes one by one, as it recalculates offsets only once.
	*
	* @internal
	* @param nodes Array of nodes.
	*/ _removeChildrenArray(nodes) {
        this._children._removeNodesArray(nodes);
        for (const node of nodes)node.parent = null;
    }
    /**
	* Creates an `Element` instance from given plain object (i.e. parsed JSON string).
	* Converts `Element` children to proper nodes.
	*
	* @param json Plain object to be converted to `Element`.
	* @returns `Element` instance created using given plain object.
	*/ static fromJSON(json) {
        let children;
        if (json.children) {
            children = [];
            for (const child of json.children)if (child.name) children.push(ModelElement.fromJSON(child));
            else children.push($b9b9f2bdf9c6137f$export$7d1212a712b16fb5.fromJSON(child));
        }
        return new ModelElement(json.name, json.attributes, children);
    }
};
$b9b9f2bdf9c6137f$export$ce4fb8eac15afe31.prototype.is = function(type, name) {
    if (!name) return type === "element" || type === "model:element" || type === "node" || type === "model:node";
    return name === this.name && (type === "element" || type === "model:element");
};
/**
* Converts strings to Text and non-iterables to arrays.
*/ function $b9b9f2bdf9c6137f$var$normalize$1(nodes) {
    if (typeof nodes == "string") return [
        new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(nodes)
    ];
    if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes)) nodes = [
        nodes
    ];
    const normalizedNodes = [];
    for (const node of nodes)if (typeof node == "string") normalizedNodes.push(new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(node));
    else if (node instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) normalizedNodes.push(new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(node.data, node.getAttributes()));
    else normalizedNodes.push(node);
    return normalizedNodes;
}
function $b9b9f2bdf9c6137f$var$cloneNodes(nodes) {
    const clonedNodes = [];
    for (const node of nodes)clonedNodes.push(node._clone(true));
    return clonedNodes;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/conversionhelpers
*/ /**
* Base class for conversion helpers.
*/ var $b9b9f2bdf9c6137f$export$1e3da93261a57296 = class {
    _dispatchers;
    /**
	* Creates a conversion helpers instance.
	*/ constructor(dispatchers){
        this._dispatchers = dispatchers;
    }
    /**
	* Registers a conversion helper.
	*
	* **Note**: See full usage example in the `{@link module:engine/conversion/conversion~Conversion#for conversion.for()}`
	* method description.
	*
	* @param conversionHelper The function to be called on event.
	*/ add(conversionHelper) {
        for (const dispatcher of this._dispatchers)conversionHelper(dispatcher);
        return this;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Contains downcast (model-to-view) converters for {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher}.
*
* @module engine/conversion/downcasthelpers
*/ /**
* Downcast conversion helper functions.
*
* Learn more about {@glink framework/deep-dive/conversion/downcast downcast helpers}.
*
* @extends module:engine/conversion/conversionhelpers~ConversionHelpers
*/ var $b9b9f2bdf9c6137f$export$368723eff4b0f393 = class extends $b9b9f2bdf9c6137f$export$1e3da93261a57296 {
    /**
	* Model element to view element conversion helper.
	*
	* This conversion results in creating a view element. For example, model `<paragraph>Foo</paragraph>` becomes `<p>Foo</p>` in the view.
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: 'paragraph',
	* 	view: 'p'
	* } );
	*
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: 'paragraph',
	* 	view: 'div',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: 'fancyParagraph',
	* 	view: {
	* 		name: 'p',
	* 		classes: 'fancy'
	* 	}
	* } );
	*
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: 'heading',
	* 	view: ( modelElement, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createContainerElement( 'h' + modelElement.getAttribute( 'level' ) );
	* 	}
	* } );
	* ```
	*
	* The element-to-element conversion supports the reconversion mechanism. It can be enabled by using either the `attributes` or
	* the `children` props on a model description. You will find a couple examples below.
	*
	* In order to reconvert an element if any of its direct children have been added or removed, use the `children` property on a `model`
	* description. For example, this model:
	*
	* ```xml
	* <box>
	* 	<paragraph>Some text.</paragraph>
	* </box>
	* ```
	*
	* will be converted into this structure in the view:
	*
	* ```html
	* <div class="box" data-type="single">
	* 	<p>Some text.</p>
	* </div>
	* ```
	*
	* But if more items were inserted in the model:
	*
	* ```xml
	* <box>
	* 	<paragraph>Some text.</paragraph>
	* 	<paragraph>Other item.</paragraph>
	* </box>
	* ```
	*
	* it will be converted into this structure in the view (note the element `data-type` change):
	*
	* ```html
	* <div class="box" data-type="multiple">
	* 	<p>Some text.</p>
	* 	<p>Other item.</p>
	* </div>
	* ```
	*
	* Such a converter would look like this (note that the `paragraph` elements are converted separately):
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: {
	* 		name: 'box',
	* 		children: true
	* 	},
	* 	view: ( modelElement, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createContainerElement( 'div', {
	* 			class: 'box',
	* 			'data-type': modelElement.childCount == 1 ? 'single' : 'multiple'
	* 		} );
	* 	}
	* } );
	* ```
	*
	* In order to reconvert element if any of its attributes have been updated, use the `attributes` property on a `model`
	* description. For example, this model:
	*
	* ```xml
	* <heading level="2">Some text.</heading>
	* ```
	*
	* will be converted into this structure in the view:
	*
	* ```html
	* <h2>Some text.</h2>
	* ```
	*
	* But if the `heading` element's `level` attribute has been updated to `3` for example, then
	* it will be converted into this structure in the view:
	*
	* ```html
	* <h3>Some text.</h3>
	* ```
	*
	* Such a converter would look as follows:
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).elementToElement( {
	* 	model: {
	* 		name: 'heading',
	* 		attributes: 'level'
	* 	},
	* 	view: ( modelElement, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createContainerElement( 'h' + modelElement.getAttribute( 'level' ) );
	* 	}
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* You can read more about the element-to-element conversion in the
	* {@glink framework/deep-dive/conversion/downcast downcast conversion} guide.
	*
	* @param config Conversion configuration.
	* @param config.model The description or a name of the model element to convert.
	* @param config.view A view element definition or a function that takes the model element and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
	* as parameters and returns a view container element.
	* @param config.converterPriority Converter priority.
	*/ elementToElement(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastElementToElement(config));
    }
    /**
	* The model element to view structure (several elements) conversion helper.
	*
	* This conversion results in creating a view structure with one or more slots defined for the child nodes.
	* For example, a model `<table>` may become this structure in the view:
	*
	* ```html
	* <figure class="table">
	* 	<table>
	* 		<tbody>${ slot for table rows }</tbody>
	* 	</table>
	* </figure>
	* ```
	*
	* The children of the model's `<table>` element will be inserted into the `<tbody>` element.
	* If the `elementToElement()` helper was used, the children would be inserted into the `<figure>`.
	*
	* Imagine a table feature where for this model structure:
	*
	* ```xml
	* <table headingRows="1">
	* 	<tableRow> ... table cells 1 ... </tableRow>
	* 	<tableRow> ... table cells 2 ... </tableRow>
	* 	<tableRow> ... table cells 3 ... </tableRow>
	* 	<caption>Caption text</caption>
	* </table>
	* ```
	*
	* we want to generate this view structure:
	*
	* ```html
	* <figure class="table">
	* 	<table>
	* 		<thead>
	* 			<tr> ... table cells 1 ... </tr>
	* 		</thead>
	* 		<tbody>
	* 			<tr> ... table cells 2 ... </tr>
	* 			<tr> ... table cells 3 ... </tr>
	* 		</tbody>
	* 	</table>
	* 	<figcaption>Caption text</figcaption>
	* </figure>
	* ```
	*
	* The converter has to take the `headingRows` attribute into consideration when allocating the `<tableRow>` elements
	* into the `<tbody>` and `<thead>` elements. Hence, we need two slots and need to define proper filter callbacks for them.
	*
	* Additionally, all elements other than `<tableRow>` should be placed outside the `<table>` tag.
	* In the example above, this will handle the table caption.
	*
	* Such a converter would look like this:
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).elementToStructure( {
	* 	model: {
	* 		name: 'table',
	* 		attributes: [ 'headingRows' ]
	* 	},
	* 	view: ( modelElement, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		const figureElement = writer.createContainerElement( 'figure', { class: 'table' } );
	* 		const tableElement = writer.createContainerElement( 'table' );
	*
	* 		writer.insert( writer.createPositionAt( figureElement, 0 ), tableElement );
	*
	* 		const headingRows = modelElement.getAttribute( 'headingRows' ) || 0;
	*
	* 		if ( headingRows > 0 ) {
	* 			const tableHead = writer.createContainerElement( 'thead' );
	*
	* 			const headSlot = writer.createSlot( node => node.is( 'element', 'tableRow' ) && node.index < headingRows );
	*
	* 			writer.insert( writer.createPositionAt( tableElement, 'end' ), tableHead );
	* 			writer.insert( writer.createPositionAt( tableHead, 0 ), headSlot );
	* 		}
	*
	* 		if ( headingRows < tableUtils.getRows( table ) ) {
	* 			const tableBody = writer.createContainerElement( 'tbody' );
	*
	* 			const bodySlot = writer.createSlot( node => node.is( 'element', 'tableRow' ) && node.index >= headingRows );
	*
	* 			writer.insert( writer.createPositionAt( tableElement, 'end' ), tableBody );
	* 			writer.insert( writer.createPositionAt( tableBody, 0 ), bodySlot );
	* 		}
	*
	* 		const restSlot = writer.createSlot( node => !node.is( 'element', 'tableRow' ) );
	*
	* 		writer.insert( writer.createPositionAt( figureElement, 'end' ), restSlot );
	*
	* 		return figureElement;
	* 	}
	* } );
	* ```
	*
	* Note: The children of a model element that's being converted must be allocated in the same order in the view
	* in which they are placed in the model.
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The description or a name of the model element to convert.
	* @param config.view A function that takes the model element and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as parameters
	* and returns a view container element with slots for model child nodes to be converted into.
	* @param config.converterPriority Converter priority.
	*/ elementToStructure(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastElementToStructure(config));
    }
    /**
	* Model attribute to view element conversion helper.
	*
	* This conversion results in wrapping view nodes with a view attribute element. For example, a model text node with
	* `"Foo"` as data and the `bold` attribute becomes `<strong>Foo</strong>` in the view.
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: 'bold',
	* 	view: 'strong'
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: 'bold',
	* 	view: 'b',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: 'invert',
	* 	view: {
	* 		name: 'span',
	* 		classes: [ 'font-light', 'bg-dark' ]
	* 	}
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: {
	* 		key: 'fontSize',
	* 		values: [ 'big', 'small' ]
	* 	},
	* 	view: {
	* 		big: {
	* 			name: 'span',
	* 			styles: {
	* 				'font-size': '1.2em'
	* 			}
	* 		},
	* 		small: {
	* 			name: 'span',
	* 			styles: {
	* 				'font-size': '0.8em'
	* 			}
	* 		}
	* 	}
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: 'bold',
	* 	view: ( modelAttributeValue, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createAttributeElement( 'span', {
	* 			style: 'font-weight:' + modelAttributeValue
	* 		} );
	* 	}
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToElement( {
	* 	model: {
	* 		key: 'color',
	* 		name: '$text'
	* 	},
	* 	view: ( modelAttributeValue, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createAttributeElement( 'span', {
	* 			style: 'color:' + modelAttributeValue
	* 		} );
	* 	}
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The key of the attribute to convert from or a `{ key, values }` object. `values` is an array
	* of `String`s with possible values if the model attribute is an enumerable.
	* @param config.view A view element definition or a function
	* that takes the model attribute value and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as parameters and returns a view
	* attribute element. If `config.model.values` is given, `config.view` should be an object assigning values from `config.model.values`
	* to view element definitions or functions.
	* @param config.converterPriority Converter priority.
	*/ attributeToElement(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastAttributeToElement(config));
    }
    /**
	* Model attribute to view attribute conversion helper.
	*
	* This conversion results in adding an attribute to a view node, basing on an attribute from a model node. For example,
	* `<imageInline src='foo.jpg'></imageInline>` is converted to `<img src='foo.jpg'></img>`.
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: 'source',
	* 	view: 'src'
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: 'source',
	* 	view: 'href',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: {
	* 		name: 'imageInline',
	* 		key: 'source'
	* 	},
	* 	view: 'src'
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: {
	* 		name: 'styled',
	* 		values: [ 'dark', 'light' ]
	* 	},
	* 	view: {
	* 		dark: {
	* 			key: 'class',
	* 			value: [ 'styled', 'styled-dark' ]
	* 		},
	* 		light: {
	* 			key: 'class',
	* 			value: [ 'styled', 'styled-light' ]
	* 		}
	* 	}
	* } );
	*
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: 'styled',
	* 	view: modelAttributeValue => ( {
	* 		key: 'class',
	* 		value: 'styled-' + modelAttributeValue
	* 	} )
	* } );
	* ```
	*
	* **Note**: Downcasting to a style property requires providing `value` as an object:
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).attributeToAttribute( {
	* 	model: 'lineHeight',
	* 	view: modelAttributeValue => ( {
	* 		key: 'style',
	* 		value: {
	* 			'line-height': modelAttributeValue,
	* 			'border-bottom': '1px dotted #ba2'
	* 		}
	* 	} )
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The key of the attribute to convert from or a `{ key, values, [ name ] }` object describing
	* the attribute key, possible values and, optionally, an element name to convert from.
	* @param config.view A view attribute key, or a `{ key, value }` object or a function that takes the model attribute value and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
	* as parameters and returns a `{ key, value }` object. If the `key` is `'class'`, the `value` can be a `String` or an
	* array of `String`s. If the `key` is `'style'`, the `value` is an object with key-value pairs. In other cases, `value` is a `String`.
	* If `config.model.values` is set, `config.view` should be an object assigning values from `config.model.values` to
	* `{ key, value }` objects or a functions.
	* @param config.converterPriority Converter priority.
	*/ attributeToAttribute(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastAttributeToAttribute(config));
    }
    /**
	* Model marker to view element conversion helper.
	*
	* **Note**: This method should be used mainly for editing the downcast and it is recommended
	* to use the {@link #markerToData `#markerToData()`} helper instead.
	*
	* This helper may produce invalid HTML code (e.g. a span between table cells).
	* It should only be used when you are sure that the produced HTML will be semantically correct.
	*
	* This conversion results in creating a view element on the boundaries of the converted marker. If the converted marker
	* is collapsed, only one element is created. For example, a model marker set like this: `<paragraph>F[oo b]ar</paragraph>`
	* becomes `<p>F<span data-marker="search"></span>oo b<span data-marker="search"></span>ar</p>` in the view.
	*
	* ```ts
	* editor.conversion.for( 'editingDowncast' ).markerToElement( {
	* 	model: 'search',
	* 	view: 'marker-search'
	* } );
	*
	* editor.conversion.for( 'editingDowncast' ).markerToElement( {
	* 	model: 'search',
	* 	view: 'search-result',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'editingDowncast' ).markerToElement( {
	* 	model: 'search',
	* 	view: {
	* 		name: 'span',
	* 		attributes: {
	* 			'data-marker': 'search'
	* 		}
	* 	}
	* } );
	*
	* editor.conversion.for( 'editingDowncast' ).markerToElement( {
	* 	model: 'search',
	* 	view: ( markerData, conversionApi ) => {
	* 		const { writer } = conversionApi;
	*
	* 		return writer.createUIElement( 'span', {
	* 			'data-marker': 'search',
	* 			'data-start': markerData.isOpening
	* 		} );
	* 	}
	* } );
	* ```
	*
	* If a function is passed as the `config.view` parameter, it will be used to generate both boundary elements. The function
	* receives the `data` object and {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
	* as a parameters and should return an instance of the
	* {@link module:engine/view/uielement~ViewUIElement view UI element}. The `data` object and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi `conversionApi`} are passed from
	* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker}. Additionally,
	* the `data.isOpening` parameter is passed, which is set to `true` for the marker start boundary element, and `false` for
	* the marker end boundary element.
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The name of the model marker (or model marker group) to convert.
	* @param config.view A view element definition or a function that takes the model marker data and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as a parameters
	* and returns a view UI element.
	* @param config.converterPriority Converter priority.
	*/ markerToElement(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastMarkerToElement(config));
    }
    /**
	* Model marker to highlight conversion helper.
	*
	* This conversion results in creating a highlight on view nodes. For this kind of conversion,
	* the {@link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor} should be provided.
	*
	* For text nodes, a `<span>` {@link module:engine/view/attributeelement~ViewAttributeElement} is created and it wraps all text nodes
	* in the converted marker range. For example, a model marker set like this: `<paragraph>F[oo b]ar</paragraph>` becomes
	* `<p>F<span class="comment">oo b</span>ar</p>` in the view.
	*
	* {@link module:engine/view/containerelement~ViewContainerElement} may provide a custom way of handling highlight. Most often,
	* the element itself is given classes and attributes described in the highlight descriptor (instead of being wrapped in `<span>`).
	* For example, a model marker set like this:
	* `[<imageInline src="foo.jpg"></imageInline>]` becomes `<img src="foo.jpg" class="comment"></img>` in the view.
	*
	* For container elements, the conversion is two-step. While the converter processes the highlight descriptor and passes it
	* to a container element, it is the container element instance itself that applies values from the highlight descriptor.
	* So, in a sense, the converter takes care of stating what should be applied on what, while the element decides how to apply that.
	*
	* ```ts
	* editor.conversion.for( 'downcast' ).markerToHighlight( { model: 'comment', view: { classes: 'comment' } } );
	*
	* editor.conversion.for( 'downcast' ).markerToHighlight( {
	* 	model: 'comment',
	* 	view: { classes: 'comment' },
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'downcast' ).markerToHighlight( {
	* 	model: 'comment',
	* 	view: ( data, conversionApi ) => {
	* 		// Assuming that the marker name is in a form of comment:commentType:commentId.
	* 		const [ , commentType, commentId ] = data.markerName.split( ':' );
	*
	* 		return {
	* 			classes: [ 'comment', 'comment-' + commentType ],
	* 			attributes: { 'data-comment-id': commentId }
	* 		};
	* 	}
	* } );
	* ```
	*
	* If a function is passed as the `config.view` parameter, it will be used to generate the highlight descriptor. The function
	* receives the `data` object and {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
	* as the parameters and should return a
	* {@link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor highlight descriptor}.
	* The `data` object properties are passed from {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker}.
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The name of the model marker (or model marker group) to convert.
	* @param config.view A highlight descriptor that will be used for highlighting or a function that takes the model marker data and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as a parameters
	* and returns a highlight descriptor.
	* @param config.converterPriority Converter priority.
	*/ markerToHighlight(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastMarkerToHighlight(config));
    }
    /**
	* Model marker converter for data downcast.
	*
	* This conversion creates a representation for model marker boundaries in the view:
	*
	* * If the marker boundary is before or after a model element, a view attribute is set on a corresponding view element.
	* * In other cases, a view element with the specified tag name is inserted at the corresponding view position.
	*
	* Typically, the marker names use the `group:uniqueId:otherData` convention. For example: `comment:e34zfk9k2n459df53sjl34:zx32c`.
	* The default configuration for this conversion is that the first part is the `group` part and the rest of
	* the marker name becomes the `name` part.
	*
	* Tag and attribute names and values are generated from the marker name:
	*
	* * The templates for attributes are `data-[group]-start-before="[name]"`, `data-[group]-start-after="[name]"`,
	* `data-[group]-end-before="[name]"` and `data-[group]-end-after="[name]"`.
	* * The templates for view elements are `<[group]-start name="[name]">` and `<[group]-end name="[name]">`.
	*
	* Attributes mark whether the given marker's start or end boundary is before or after the given element.
	* The `data-[group]-start-before` and `data-[group]-end-after` attributes are favored.
	* The other two are used when the former two cannot be used.
	*
	* The conversion configuration can take a function that will generate different group and name parts.
	* If such a function is set as the `config.view` parameter, it is passed a marker name and it is expected to return an object with two
	* properties: `group` and `name`. If the function returns a falsy value, the conversion will not take place.
	*
	* Basic usage:
	*
	* ```ts
	* // Using the default conversion.
	* // In this case, all markers with names starting with 'comment:' will be converted.
	* // The `group` parameter will be set to `comment`.
	* // The `name` parameter will be the rest of the marker name (without the `:`).
	* editor.conversion.for( 'dataDowncast' ).markerToData( {
	* 	model: 'comment'
	* } );
	* ```
	*
	* An example of a view that may be generated by this conversion (assuming a marker with the name `comment:commentId:uid` marked
	* by `[]`):
	*
	* ```
	* // Model:
	* <paragraph>Foo[bar</paragraph>
	* <imageBlock src="abc.jpg"></imageBlock>]
	*
	* // View:
	* <p>Foo<comment-start name="commentId:uid"></comment-start>bar</p>
	* <figure data-comment-end-after="commentId:uid" class="image"><img src="abc.jpg" /></figure>
	* ```
	*
	* In the example above, the comment starts before "bar" and ends after the image.
	*
	* If the `name` part is empty, the following view may be generated:
	*
	* ```html
	* <p>Foo <myMarker-start></myMarker-start>bar</p>
	* <figure data-myMarker-end-after="" class="image"><img src="abc.jpg" /></figure>
	* ```
	*
	* **Note:** A situation where some markers have the `name` part and some do not, is incorrect and should be avoided.
	*
	* Examples where `data-group-start-after` and `data-group-end-before` are used:
	*
	* ```
	* // Model:
	* <blockQuote>[]<paragraph>Foo</paragraph></blockQuote>
	*
	* // View:
	* <blockquote><p data-group-end-before="name" data-group-start-before="name">Foo</p></blockquote>
	* ```
	*
	* Similarly, when a marker is collapsed after the last element:
	*
	* ```
	* // Model:
	* <blockQuote><paragraph>Foo</paragraph>[]</blockQuote>
	*
	* // View:
	* <blockquote><p data-group-end-after="name" data-group-start-after="name">Foo</p></blockquote>
	* ```
	*
	* When there are multiple markers from the same group stored in the same attribute of the same element, their
	* name parts are put together in the attribute value, for example: `data-group-start-before="name1,name2,name3"`.
	*
	* Other examples of usage:
	*
	* ```ts
	* // Using a custom function which is the same as the default conversion:
	* editor.conversion.for( 'dataDowncast' ).markerToData( {
	* 	model: 'comment',
	* 	view: markerName => ( {
	* 		group: 'comment',
	* 		name: markerName.substr( 8 ) // Removes 'comment:' part.
	* 	} )
	* } );
	*
	* // Using the converter priority:
	* editor.conversion.for( 'dataDowncast' ).markerToData( {
	* 	model: 'comment',
	* 	view: markerName => ( {
	* 		group: 'comment',
	* 		name: markerName.substr( 8 ) // Removes 'comment:' part.
	* 	} ),
	* 	converterPriority: 'high'
	* } );
	* ```
	*
	* This kind of conversion is useful for saving data into the database, so it should be used in the data conversion pipeline.
	*
	* See the {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} API guide to learn how to
	* add a converter to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.model The name of the model marker (or the model marker group) to convert.
	* @param config.view A function that takes the model marker name and
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as the parameters
	* and returns an object with the `group` and `name` properties.
	* @param config.converterPriority Converter priority.
	*/ markerToData(config) {
        return this.add($b9b9f2bdf9c6137f$var$downcastMarkerToData(config));
    }
};
/**
* Function factory that creates a default downcast converter for text insertion changes.
*
* The converter automatically consumes the corresponding value from the consumables list and stops the event (see
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher}).
*
* ```ts
* modelDispatcher.on( 'insert:$text', insertText() );
* ```
*
* @returns Insert text event converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$45ce91c8ab754ab7() {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const viewWriter = conversionApi.writer;
        const viewPosition = conversionApi.mapper.toViewPosition(data.range.start);
        const viewText = viewWriter.createText(data.item.data);
        viewWriter.insert(viewPosition, viewText);
    };
}
/**
* Function factory that creates a default downcast converter for triggering attributes and children conversion.
*
* @returns The converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$f67751480ebc37c() {
    return (evt, data, conversionApi)=>{
        conversionApi.convertAttributes(data.item);
        if (!data.reconversion && data.item.is("element") && !data.item.isEmpty) conversionApi.convertChildren(data.item);
    };
}
/**
* Function factory that creates a default downcast converter for node remove changes.
*
* ```ts
* modelDispatcher.on( 'remove', remove() );
* ```
*
* @returns Remove event converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$f83769e5e3df9387() {
    return (evt, data, conversionApi)=>{
        if (data.reconversion) return;
        const viewStart = conversionApi.mapper.toViewPosition(data.position);
        const modelEnd = data.position.getShiftedBy(data.length);
        const viewEnd = conversionApi.mapper.toViewPosition(modelEnd, {
            isPhantom: true
        });
        $b9b9f2bdf9c6137f$var$removeRangeAndUnbind(conversionApi.writer.createRange(viewStart, viewEnd).getTrimmed(), conversionApi);
    };
}
/**
* Creates a `<span>` {@link module:engine/view/attributeelement~ViewAttributeElement view attribute element} from the information
* provided by the {@link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor highlight descriptor} object. If the priority
* is not provided in the descriptor, the default priority will be used.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$4ee7bde47a096a72(writer, descriptor) {
    const viewElement = writer.createAttributeElement("span", descriptor.attributes);
    if (descriptor.classes) viewElement._addClass(descriptor.classes);
    if (typeof descriptor.priority === "number") viewElement._priority = descriptor.priority;
    viewElement._id = descriptor.id;
    return viewElement;
}
/**
* Function factory that creates a converter which converts a non-collapsed
* {@link module:engine/model/selection~ModelSelection model selection}
* to a {@link module:engine/view/documentselection~ViewDocumentSelection view selection}. The converter consumes appropriate
* value from the `consumable` object and maps model positions from the selection to view positions.
*
* ```ts
* modelDispatcher.on( 'selection', convertRangeSelection() );
* ```
*
* @returns Selection converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$4bf288faba1f60fa() {
    return (evt, data, conversionApi)=>{
        const selection = data.selection;
        if (selection.isCollapsed) return;
        if (!conversionApi.consumable.consume(selection, "selection")) return;
        const viewRanges = [];
        for (const range of selection.getRanges())viewRanges.push(conversionApi.mapper.toViewRange(range));
        conversionApi.writer.setSelection(viewRanges, {
            backward: selection.isBackward
        });
    };
}
/**
* Function factory that creates a converter which converts a collapsed
* {@link module:engine/model/selection~ModelSelection model selection} to
* a {@link module:engine/view/documentselection~ViewDocumentSelection view selection}. The converter consumes appropriate
* value from the `consumable` object, maps the model selection position to the view position and breaks
* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} at the selection position.
*
* ```ts
* modelDispatcher.on( 'selection', convertCollapsedSelection() );
* ```
*
* An example of the view state before and after converting the collapsed selection:
*
* ```
*    <p><strong>f^oo<strong>bar</p>
* -> <p><strong>f</strong>^<strong>oo</strong>bar</p>
* ```
*
* By breaking attribute elements like `<strong>`, the selection is in a correct element. Then, when the selection attribute is
* converted, broken attributes might be merged again, or the position where the selection is may be wrapped
* with different, appropriate attribute elements.
*
* See also {@link module:engine/conversion/downcasthelpers~cleanSelection} which does a clean-up
* by merging attributes.
*
* @returns Selection converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$d9fb6c173d870a4c() {
    return (evt, data, conversionApi)=>{
        const selection = data.selection;
        if (!selection.isCollapsed) return;
        if (!conversionApi.consumable.consume(selection, "selection")) return;
        const viewWriter = conversionApi.writer;
        const modelPosition = selection.getFirstPosition();
        const viewPosition = conversionApi.mapper.toViewPosition(modelPosition);
        const brokenPosition = viewWriter.breakAttributes(viewPosition);
        viewWriter.setSelection(brokenPosition);
    };
}
/**
* Function factory that creates a converter which cleans artifacts after the previous
* {@link module:engine/model/selection~ModelSelection model selection} conversion. It removes all empty
* {@link module:engine/view/attributeelement~ViewAttributeElement view attribute elements} and merges
* sibling attributes at all start and end positions of all ranges.
*
* ```
*    <p><strong>^</strong></p>
* -> <p>^</p>
*
*    <p><strong>foo</strong>^<strong>bar</strong>bar</p>
* -> <p><strong>foo^bar<strong>bar</p>
*
*    <p><strong>foo</strong><em>^</em><strong>bar</strong>bar</p>
* -> <p><strong>foo^bar<strong>bar</p>
* ```
*
* This listener should be assigned before any converter for the new selection:
*
* ```ts
* modelDispatcher.on( 'cleanSelection', cleanSelection() );
* ```
*
* See {@link module:engine/conversion/downcasthelpers~convertCollapsedSelection}
* which does the opposite by breaking attributes in the selection position.
*
* @returns Selection converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$e49a4d261c3abb06() {
    return (evt, data, conversionApi)=>{
        const viewWriter = conversionApi.writer;
        const viewSelection = viewWriter.document.selection;
        for (const range of viewSelection.getRanges())if (range.isCollapsed) {
            if (range.end.parent.isAttached()) conversionApi.writer.mergeAttributes(range.start);
        }
        viewWriter.setSelection(null);
    };
}
/**
* Function factory that creates a converter which converts the set/change/remove attribute changes from the model to the view.
* It can also be used to convert selection attributes. In that case, an empty attribute element will be created and the
* selection will be put inside it.
*
* Attributes from the model are converted to a view element that will be wrapping these view nodes that are bound to
* model elements having the given attribute. This is useful for attributes like `bold` that may be set on text nodes in the model
* but are represented as an element in the view:
*
* ```
* [paragraph]              MODEL ====> VIEW        <p>
* 	|- a {bold: true}                             |- <b>
* 	|- b {bold: true}                             |   |- ab
* 	|- c                                          |- c
* 	```
*
* Passed `Function` will be provided with the attribute value and then all the parameters of the
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute `attribute` event}.
* It is expected that the function returns an {@link module:engine/view/element~ViewElement}.
* The result of the function will be the wrapping element.
* When the provided `Function` does not return any element, no conversion will take place.
*
* The converter automatically consumes the corresponding value from the consumables list and stops the event (see
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher}).
*
* ```ts
* modelDispatcher.on( 'attribute:bold', wrap( ( modelAttributeValue, { writer } ) => {
* 	return writer.createAttributeElement( 'strong' );
* } );
* ```
*
* @internal
* @param elementCreator Function returning a view element that will be used for wrapping.
* @returns Set/change attribute converter.
*/ function $b9b9f2bdf9c6137f$export$ef9cb34a60d615c1(elementCreator) {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.test(data.item, evt.name)) return;
        const oldViewElement = elementCreator(data.attributeOldValue, conversionApi, data);
        const newViewElement = elementCreator(data.attributeNewValue, conversionApi, data);
        if (!oldViewElement && !newViewElement) return;
        conversionApi.consumable.consume(data.item, evt.name);
        const viewWriter = conversionApi.writer;
        const viewSelection = viewWriter.document.selection;
        if (data.item instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 || data.item instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) viewWriter.wrap(viewSelection.getFirstRange(), newViewElement);
        else {
            let viewRange = conversionApi.mapper.toViewRange(data.range);
            if (data.attributeOldValue !== null && oldViewElement) viewRange = viewWriter.unwrap(viewRange, oldViewElement);
            if (data.attributeNewValue !== null && newViewElement) viewWriter.wrap(viewRange, newViewElement);
        }
    };
}
/**
* Function factory that creates a converter which converts node insertion changes from the model to the view.
* The function passed will be provided with all the parameters of the dispatcher's
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert `insert` event}.
* It is expected that the function returns an {@link module:engine/view/element~ViewElement}.
* The result of the function will be inserted into the view.
*
* The converter automatically consumes the corresponding value from the consumables list and binds the model and view elements.
*
* ```ts
* downcastDispatcher.on(
* 	'insert:myElem',
* 	insertElement( ( modelItem, { writer } ) => {
* 		const text = writer.createText( 'myText' );
* 		const myElem = writer.createElement( 'myElem', { myAttr: 'my-' + modelItem.getAttribute( 'myAttr' ) }, text );
*
* 		// Do something fancy with `myElem` using `modelItem` or other parameters.
*
* 		return myElem;
* 	}
* ) );
* ```
*
* @internal
* @param  elementCreator Function returning a view element, which will be inserted.
* @param consumer Function defining element consumption process.
* By default this function just consume passed item insertion.
* @returns Insert element event converter.
*/ function $b9b9f2bdf9c6137f$export$df72b18897e1fd28(elementCreator, consumer = $b9b9f2bdf9c6137f$var$defaultConsumer) {
    return (evt, data, conversionApi)=>{
        if (!consumer(data.item, conversionApi.consumable, {
            preflight: true
        })) return;
        const viewElement = elementCreator(data.item, conversionApi, data);
        if (!viewElement) return;
        consumer(data.item, conversionApi.consumable);
        const viewPosition = data.reconversion && $b9b9f2bdf9c6137f$var$removeElementAndUnbind(data.item, conversionApi) || conversionApi.mapper.toViewPosition(data.range.start);
        conversionApi.mapper.bindElements(data.item, viewElement);
        conversionApi.writer.insert(viewPosition, viewElement);
        conversionApi.convertAttributes(data.item);
        $b9b9f2bdf9c6137f$var$reinsertOrConvertNodes(viewElement, data.item.getChildren(), conversionApi, {
            reconversion: data.reconversion
        });
    };
}
/**
* Function factory that creates a converter which converts a single model node insertion to a view structure.
*
* It is expected that the passed element creator function returns an {@link module:engine/view/element~ViewElement} with attached slots
* created with `writer.createSlot()` to indicate where child nodes should be converted.
*
* @see module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure
*
* @internal
* @param elementCreator Function returning a view structure, which will be inserted.
* @param consumer A callback that is expected to consume all the consumables
* that were used by the element creator.
* @returns Insert element event converter.
*/ function $b9b9f2bdf9c6137f$export$ee4a60f5f30bcea2(elementCreator, consumer) {
    return (evt, data, conversionApi)=>{
        if (!consumer(data.item, conversionApi.consumable, {
            preflight: true
        })) return;
        const slotsMap = /* @__PURE__ */ new Map();
        conversionApi.writer._registerSlotFactory($b9b9f2bdf9c6137f$var$createSlotFactory(data.item, slotsMap, conversionApi));
        const viewElement = elementCreator(data.item, conversionApi, data);
        conversionApi.writer._clearSlotFactory();
        if (!viewElement) return;
        $b9b9f2bdf9c6137f$var$validateSlotsChildren(data.item, slotsMap, conversionApi);
        consumer(data.item, conversionApi.consumable);
        const viewPosition = data.reconversion && $b9b9f2bdf9c6137f$var$removeElementAndUnbind(data.item, conversionApi) || conversionApi.mapper.toViewPosition(data.range.start);
        conversionApi.mapper.bindElements(data.item, viewElement);
        conversionApi.writer.insert(viewPosition, viewElement);
        conversionApi.convertAttributes(data.item);
        $b9b9f2bdf9c6137f$var$fillSlots(viewElement, slotsMap, conversionApi, {
            reconversion: data.reconversion
        });
    };
}
/**
* Function factory that creates a converter which converts marker adding change to the
* {@link module:engine/view/uielement~ViewUIElement view UI element}.
*
* The view UI element that will be added to the view depends on the passed parameter. See {@link ~insertElement}.
* In case of a non-collapsed range, the UI element will not wrap nodes but separate elements will be placed at the beginning
* and at the end of the range.
*
* This converter binds created UI elements with the marker name using {@link module:engine/conversion/mapper~Mapper#bindElementToMarker}.
*
* @internal
* @param elementCreator A view UI element or a function returning the view element that will be inserted.
* @returns Insert element event converter.
*/ function $b9b9f2bdf9c6137f$export$d6d83508304a361a(elementCreator) {
    return (evt, data, conversionApi)=>{
        data.isOpening = true;
        const viewStartElement = elementCreator(data, conversionApi);
        data.isOpening = false;
        const viewEndElement = elementCreator(data, conversionApi);
        if (!viewStartElement || !viewEndElement) return;
        const { markerRange: markerRange, markerName: markerName } = data;
        if (markerRange.isCollapsed && !conversionApi.consumable.consume(markerRange, evt.name)) return;
        for (const value of markerRange)if (!conversionApi.consumable.consume(value.item, evt.name)) return;
        const mapper = conversionApi.mapper;
        const viewWriter = conversionApi.writer;
        viewWriter.setCustomProperty("markerBoundaryType", "start", viewStartElement);
        viewWriter.setCustomProperty("markerBoundaryName", markerName, viewStartElement);
        viewWriter.setCustomProperty("markerBoundaryType", "end", viewEndElement);
        viewWriter.setCustomProperty("markerBoundaryName", markerName, viewEndElement);
        const getBoundaryModelPosition = (name, type)=>{
            const elements = mapper.markerNameToElements(name);
            if (elements) {
                for (const el of elements)if (el.getCustomProperty("markerBoundaryType") === type) return mapper.toModelPosition(viewWriter.createPositionBefore(el));
            }
            return null;
        };
        if (!markerRange.isCollapsed) {
            const endViewPosition = mapper.toViewPosition(markerRange.end).getLastMatchingPosition(({ item: item })=>{
                if (!item.is("uiElement") || item.getCustomProperty("markerBoundaryType") !== "end") return false;
                const existingName = item.getCustomProperty("markerBoundaryName");
                const existingStartPos = getBoundaryModelPosition(existingName, "start");
                if (!existingStartPos) return false;
                const cmp = existingStartPos.compareWith(markerRange.start);
                if (cmp === "same") return existingName.localeCompare(markerName) > 0;
                return cmp === "after";
            });
            viewWriter.insert(endViewPosition, viewEndElement);
            mapper.bindElementToMarker(viewEndElement, markerName);
        }
        const startViewPosition = mapper.toViewPosition(markerRange.start).getLastMatchingPosition(({ item: item })=>{
            if (!item.is("uiElement")) return false;
            const boundaryType = item.getCustomProperty("markerBoundaryType");
            if (!boundaryType) return false;
            if (boundaryType === "end") return true;
            const existingName = item.getCustomProperty("markerBoundaryName");
            const existingEndPos = getBoundaryModelPosition(existingName, "end");
            if (!existingEndPos) return markerRange.isCollapsed;
            if (markerRange.isCollapsed) return true;
            const cmp = existingEndPos.compareWith(markerRange.end);
            if (cmp === "same") return existingName.localeCompare(markerName) < 0;
            return cmp === "after";
        });
        viewWriter.insert(startViewPosition, viewStartElement);
        mapper.bindElementToMarker(viewStartElement, markerName);
        evt.stop();
    };
}
/**
* Removes given view range content and unbinds removed elements.
*/ function $b9b9f2bdf9c6137f$var$removeRangeAndUnbind(viewRange, conversionApi) {
    const removed = conversionApi.writer.remove(viewRange);
    for (const child of conversionApi.writer.createRangeIn(removed).getItems())conversionApi.mapper.unbindViewElement(child, {
        defer: true
    });
    return viewRange.start;
}
/**
* Removes view element for given model element and unbinds removed view elements.
*/ function $b9b9f2bdf9c6137f$var$removeElementAndUnbind(modelElement, conversionApi) {
    const viewElement = conversionApi.mapper.toViewElement(modelElement);
    return viewElement && $b9b9f2bdf9c6137f$var$removeRangeAndUnbind(conversionApi.writer.createRangeOn(viewElement), conversionApi);
}
/**
* Function factory that returns a default downcast converter for removing a {@link module:engine/view/uielement~ViewUIElement UI element}
* based on marker remove change.
*
* This converter unbinds elements from the marker name.
*
* @returns Removed UI element converter.
*/ function $b9b9f2bdf9c6137f$var$removeUIElement() {
    return (evt, data, conversionApi)=>{
        const elements = conversionApi.mapper.markerNameToElements(data.markerName);
        if (!elements) return;
        for (const element of elements){
            conversionApi.mapper.unbindElementFromMarkerName(element, data.markerName);
            conversionApi.writer.clear(conversionApi.writer.createRangeOn(element), element);
        }
        conversionApi.writer.clearClonedElementsGroup(data.markerName);
        evt.stop();
    };
}
/**
* Function factory that creates a default converter for model markers.
*
* See {@link DowncastHelpers#markerToData} for more information what type of view is generated.
*
* This converter binds created UI elements and affected view elements with the marker name
* using {@link module:engine/conversion/mapper~Mapper#bindElementToMarker}.
*
* @returns Add marker converter.
*/ function $b9b9f2bdf9c6137f$var$insertMarkerData(viewCreator) {
    return (evt, data, conversionApi)=>{
        const viewMarkerData = viewCreator(data.markerName, conversionApi);
        if (!viewMarkerData) return;
        const markerRange = data.markerRange;
        if (!conversionApi.consumable.consume(markerRange, evt.name)) return;
        $b9b9f2bdf9c6137f$var$handleMarkerBoundary(markerRange, false, conversionApi, data, viewMarkerData);
        $b9b9f2bdf9c6137f$var$handleMarkerBoundary(markerRange, true, conversionApi, data, viewMarkerData);
        evt.stop();
    };
}
/**
* Helper function for `insertMarkerData()` that marks a marker boundary at the beginning or end of given `range`.
*/ function $b9b9f2bdf9c6137f$var$handleMarkerBoundary(range, isStart, conversionApi, data, viewMarkerData) {
    const modelPosition = isStart ? range.start : range.end;
    const elementAfter = modelPosition.nodeAfter && modelPosition.nodeAfter.is("element") ? modelPosition.nodeAfter : null;
    const elementBefore = modelPosition.nodeBefore && modelPosition.nodeBefore.is("element") ? modelPosition.nodeBefore : null;
    if (elementAfter || elementBefore) {
        let modelElement;
        let isBefore;
        if (isStart && elementAfter || !isStart && !elementBefore) {
            modelElement = elementAfter;
            isBefore = true;
        } else {
            modelElement = elementBefore;
            isBefore = false;
        }
        const viewElement = conversionApi.mapper.toViewElement(modelElement);
        if (viewElement) {
            $b9b9f2bdf9c6137f$var$insertMarkerAsAttribute(viewElement, isStart, isBefore, conversionApi, data, viewMarkerData);
            return;
        }
    }
    $b9b9f2bdf9c6137f$var$insertMarkerAsElement(conversionApi.mapper.toViewPosition(modelPosition), isStart, conversionApi, data, viewMarkerData);
}
/**
* Helper function for `insertMarkerData()` that marks a marker boundary in the view as an attribute on a view element.
*/ function $b9b9f2bdf9c6137f$var$insertMarkerAsAttribute(viewElement, isStart, isBefore, conversionApi, data, viewMarkerData) {
    const attributeName = `data-${viewMarkerData.group}-${isStart ? "start" : "end"}-${isBefore ? "before" : "after"}`;
    const markerNames = viewElement.hasAttribute(attributeName) ? viewElement.getAttribute(attributeName).split(",") : [];
    markerNames.unshift(viewMarkerData.name);
    conversionApi.writer.setAttribute(attributeName, markerNames.join(","), viewElement);
    conversionApi.mapper.bindElementToMarker(viewElement, data.markerName);
}
/**
* Helper function for `insertMarkerData()` that marks a marker boundary in the view as a separate view ui element.
*/ function $b9b9f2bdf9c6137f$var$insertMarkerAsElement(position, isStart, conversionApi, data, viewMarkerData) {
    const viewElementName = `${viewMarkerData.group}-${isStart ? "start" : "end"}`;
    const attrs = viewMarkerData.name ? {
        "name": viewMarkerData.name
    } : null;
    const viewElement = conversionApi.writer.createUIElement(viewElementName, attrs);
    conversionApi.writer.insert(position, viewElement);
    conversionApi.mapper.bindElementToMarker(viewElement, data.markerName);
}
/**
* Function factory that creates a converter for removing a model marker data added by the {@link #insertMarkerData} converter.
*
* @returns Remove marker converter.
*/ function $b9b9f2bdf9c6137f$var$removeMarkerData(viewCreator) {
    return (evt, data, conversionApi)=>{
        const viewData = viewCreator(data.markerName, conversionApi);
        if (!viewData) return;
        const elements = conversionApi.mapper.markerNameToElements(data.markerName);
        if (!elements) return;
        for (const element of elements){
            conversionApi.mapper.unbindElementFromMarkerName(element, data.markerName);
            if (element.is("containerElement")) {
                removeMarkerFromAttribute(`data-${viewData.group}-start-before`, element);
                removeMarkerFromAttribute(`data-${viewData.group}-start-after`, element);
                removeMarkerFromAttribute(`data-${viewData.group}-end-before`, element);
                removeMarkerFromAttribute(`data-${viewData.group}-end-after`, element);
            } else conversionApi.writer.clear(conversionApi.writer.createRangeOn(element), element);
        }
        conversionApi.writer.clearClonedElementsGroup(data.markerName);
        evt.stop();
        function removeMarkerFromAttribute(attributeName, element) {
            if (element.hasAttribute(attributeName)) {
                const markerNames = new Set(element.getAttribute(attributeName).split(","));
                markerNames.delete(viewData.name);
                if (markerNames.size == 0) conversionApi.writer.removeAttribute(attributeName, element);
                else conversionApi.writer.setAttribute(attributeName, Array.from(markerNames).join(","), element);
            }
        }
    };
}
/**
* Function factory that creates a converter which converts the set/change/remove attribute changes from the model to the view.
*
* Attributes from the model are converted to the view element attributes in the view. You may provide a custom function to generate
* a key-value attribute pair to add/change/remove. If not provided, model attributes will be converted to view element
* attributes on a one-to-one basis.
*
* *Note:** The provided attribute creator should always return the same `key` for a given attribute from the model.
*
* The converter automatically consumes the corresponding value from the consumables list and stops the event (see
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher}).
*
* ```ts
* modelDispatcher.on( 'attribute:customAttr:myElem', changeAttribute( ( value, data ) => {
* 	// Change attribute key from `customAttr` to `class` in the view.
* 	const key = 'class';
* 	let value = data.attributeNewValue;
*
* 	// Force attribute value to 'empty' if the model element is empty.
* 	if ( data.item.childCount === 0 ) {
* 		value = 'empty';
* 	}
*
* 	// Return the key-value pair.
* 	return { key, value };
* } ) );
* ```
*
* @param attributeCreator Function returning an object with two properties: `key` and `value`, which
* represent the attribute key and attribute value to be set on a {@link module:engine/view/element~ViewElement view element}.
* The function is passed the model attribute value as the first parameter and additional data about the change as the second parameter.
* @returns Set/change attribute converter.
*/ function $b9b9f2bdf9c6137f$var$changeAttribute(attributeCreator) {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.test(data.item, evt.name)) return;
        const oldAttribute = attributeCreator(data.attributeOldValue, conversionApi, data);
        const newAttribute = attributeCreator(data.attributeNewValue, conversionApi, data);
        if (!oldAttribute && !newAttribute) return;
        conversionApi.consumable.consume(data.item, evt.name);
        const viewElement = conversionApi.mapper.toViewElement(data.item);
        const viewWriter = conversionApi.writer;
        if (!viewElement) /**
		* This error occurs when a {@link module:engine/model/textproxy~ModelTextProxy text node's} attribute is to be downcasted
		* by an {@link module:engine/conversion/conversion~Conversion#attributeToAttribute `Attribute to Attribute converter`}.
		* In most cases it is caused by converters misconfiguration when only "generic" converter is defined:
		*
		* ```ts
		* editor.conversion.for( 'downcast' ).attributeToAttribute( {
		* 	model: 'attribute-name',
		* 	view: 'attribute-name'
		* } ) );
		* ```
		*
		* and given attribute is used on text node, for example:
		*
		* ```ts
		* model.change( writer => {
		* 	writer.insertText( 'Foo', { 'attribute-name': 'bar' }, parent, 0 );
		* } );
		* ```
		*
		* In such cases, to convert the same attribute for both {@link module:engine/model/element~ModelElement}
		* and {@link module:engine/model/textproxy~ModelTextProxy `Text`} nodes, text specific
		* {@link module:engine/conversion/conversion~Conversion#attributeToElement `Attribute to Element converter`}
		* with higher {@link module:utils/priorities~PriorityString priority} must also be defined:
		*
		* ```ts
		* editor.conversion.for( 'downcast' ).attributeToElement( {
		* 	model: {
		* 		key: 'attribute-name',
		* 		name: '$text'
		* 	},
		* 	view: ( value, { writer } ) => {
		* 		return writer.createAttributeElement( 'span', { 'attribute-name': value } );
		* 	},
		* 	converterPriority: 'high'
		* } ) );
		* ```
		*
		* @error conversion-attribute-to-attribute-on-text
		* @param {object} data The conversion data.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-attribute-to-attribute-on-text", conversionApi.dispatcher, data);
        if (data.attributeOldValue !== null && oldAttribute) {
            let value = oldAttribute.value;
            if (oldAttribute.key == "style") {
                if (typeof oldAttribute.value == "string") value = new $b9b9f2bdf9c6137f$export$a256655bfa1a33f5(viewWriter.document.stylesProcessor).setTo(oldAttribute.value).getStylesEntries().map(([key])=>key);
                else value = Object.keys(oldAttribute.value);
            }
            viewWriter.removeAttribute(oldAttribute.key, value, viewElement);
        }
        if (data.attributeNewValue !== null && newAttribute) {
            let value = newAttribute.value;
            if (newAttribute.key == "style" && typeof newAttribute.value == "string") value = Object.fromEntries(new $b9b9f2bdf9c6137f$export$a256655bfa1a33f5(viewWriter.document.stylesProcessor).setTo(newAttribute.value).getStylesEntries());
            viewWriter.setAttribute(newAttribute.key, value, false, viewElement);
        }
    };
}
/**
* Function factory that creates a converter which converts the text inside marker's range. The converter wraps the text with
* {@link module:engine/view/attributeelement~ViewAttributeElement} created from the provided descriptor.
* See {link module:engine/conversion/downcasthelpers~createViewElementFromDowncastHighlightDescriptor}.
*
* It can also be used to convert the selection that is inside a marker. In that case, an empty attribute element will be
* created and the selection will be put inside it.
*
* If the highlight descriptor does not provide the `priority` property, `10` will be used.
*
* If the highlight descriptor does not provide the `id` property, the name of the marker will be used.
*
* This converter binds the created {@link module:engine/view/attributeelement~ViewAttributeElement attribute elemens} with the marker name
* using the {@link module:engine/conversion/mapper~Mapper#bindElementToMarker} method.
*/ function $b9b9f2bdf9c6137f$var$highlightText(highlightDescriptor) {
    return (evt, data, conversionApi)=>{
        if (!data.item) return;
        if (!(data.item instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 || data.item instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) && !data.item.is("$textProxy")) return;
        const descriptor = $b9b9f2bdf9c6137f$var$prepareDescriptor(highlightDescriptor, data, conversionApi);
        if (!descriptor) return;
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const viewWriter = conversionApi.writer;
        const viewElement = $b9b9f2bdf9c6137f$export$4ee7bde47a096a72(viewWriter, descriptor);
        const viewSelection = viewWriter.document.selection;
        if (data.item instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 || data.item instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) viewWriter.wrap(viewSelection.getFirstRange(), viewElement);
        else {
            const viewRange = conversionApi.mapper.toViewRange(data.range);
            const rangeAfterWrap = viewWriter.wrap(viewRange, viewElement);
            for (const element of rangeAfterWrap.getItems())if (element.is("attributeElement") && element.isSimilar(viewElement)) {
                conversionApi.mapper.bindElementToMarker(element, data.markerName);
                break;
            }
        }
    };
}
/**
* Converter function factory. It creates a function which applies the marker's highlight to an element inside the marker's range.
*
* The converter checks if an element has the `addHighlight` function stored as a
* {@link module:engine/view/element~ViewElement#_setCustomProperty custom property} and, if so, uses it to apply the highlight.
* In such case the converter will consume all element's children, assuming that they were handled by the element itself.
*
* When the `addHighlight` custom property is not present, the element is not converted in any special way.
* This means that converters will proceed to convert the element's child nodes.
*
* If the highlight descriptor does not provide the `priority` property, `10` will be used.
*
* If the highlight descriptor does not provide the `id` property, the name of the marker will be used.
*
* This converter binds altered {@link module:engine/view/containerelement~ViewContainerElement container elements}
* with the marker name using the {@link module:engine/conversion/mapper~Mapper#bindElementToMarker} method.
*/ function $b9b9f2bdf9c6137f$var$highlightElement(highlightDescriptor) {
    return (evt, data, conversionApi)=>{
        if (!data.item) return;
        if (!(data.item instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) return;
        const descriptor = $b9b9f2bdf9c6137f$var$prepareDescriptor(highlightDescriptor, data, conversionApi);
        if (!descriptor) return;
        if (!conversionApi.consumable.test(data.item, evt.name)) return;
        const viewElement = conversionApi.mapper.toViewElement(data.item);
        if (viewElement && viewElement.getCustomProperty("addHighlight")) {
            conversionApi.consumable.consume(data.item, evt.name);
            for (const value of $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(data.item))conversionApi.consumable.consume(value.item, evt.name);
            viewElement.getCustomProperty("addHighlight")(viewElement, descriptor, conversionApi.writer);
            conversionApi.mapper.bindElementToMarker(viewElement, data.markerName);
        }
    };
}
/**
* Function factory that creates a converter which converts the removing model marker to the view.
*
* Both text nodes and elements are handled by this converter but they are handled a bit differently.
*
* Text nodes are unwrapped using the {@link module:engine/view/attributeelement~ViewAttributeElement attribute element} created from the
* provided highlight descriptor. See {link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor}.
*
* For elements, the converter checks if an element has the `removeHighlight` function stored as a
* {@link module:engine/view/element~ViewElement#_setCustomProperty custom property}. If so, it uses it to remove the highlight.
* In such case, the children of that element will not be converted.
*
* When `removeHighlight` is not present, the element is not converted in any special way.
* The converter will proceed to convert the element's child nodes instead.
*
* If the highlight descriptor does not provide the `priority` property, `10` will be used.
*
* If the highlight descriptor does not provide the `id` property, the name of the marker will be used.
*
* This converter unbinds elements from the marker name.
*/ function $b9b9f2bdf9c6137f$var$removeHighlight(highlightDescriptor) {
    return (evt, data, conversionApi)=>{
        if (data.markerRange.isCollapsed) return;
        const descriptor = $b9b9f2bdf9c6137f$var$prepareDescriptor(highlightDescriptor, data, conversionApi);
        if (!descriptor) return;
        const viewHighlightElement = $b9b9f2bdf9c6137f$export$4ee7bde47a096a72(conversionApi.writer, descriptor);
        const elements = conversionApi.mapper.markerNameToElements(data.markerName);
        if (!elements) return;
        for (const element of elements){
            conversionApi.mapper.unbindElementFromMarkerName(element, data.markerName);
            if (element.is("attributeElement")) conversionApi.writer.unwrap(conversionApi.writer.createRangeOn(element), viewHighlightElement);
            else element.getCustomProperty("removeHighlight")(element, descriptor.id, conversionApi.writer);
        }
        conversionApi.writer.clearClonedElementsGroup(data.markerName);
        evt.stop();
    };
}
/**
* Model element to view element conversion helper.
*
* See {@link ~DowncastHelpers#elementToElement `.elementToElement()` downcast helper} for examples and config params description.
*
* @param config Conversion configuration.
* @param config.model The description or a name of the model element to convert.
* @param config.model.attributes List of attributes triggering element reconversion.
* @param config.model.children Should reconvert element if the list of model child nodes changed.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastElementToElement(config) {
    const model = $b9b9f2bdf9c6137f$var$normalizeModelElementConfig(config.model);
    const view = $b9b9f2bdf9c6137f$var$normalizeToElementConfig(config.view, "container");
    if (model.attributes.length) model.children = true;
    return (dispatcher)=>{
        dispatcher.on(`insert:${model.name}`, $b9b9f2bdf9c6137f$export$df72b18897e1fd28(view, $b9b9f2bdf9c6137f$var$createConsumer(model)), {
            priority: config.converterPriority || "normal"
        });
        if (model.children || model.attributes.length) dispatcher.on("reduceChanges", $b9b9f2bdf9c6137f$var$createChangeReducer(model), {
            priority: "low"
        });
    };
}
/**
* Model element to view structure conversion helper.
*
* See {@link ~DowncastHelpers#elementToStructure `.elementToStructure()` downcast helper} for examples and config params description.
*
* @param config Conversion configuration.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastElementToStructure(config) {
    const model = $b9b9f2bdf9c6137f$var$normalizeModelElementConfig(config.model);
    const view = $b9b9f2bdf9c6137f$var$normalizeToElementConfig(config.view, "container");
    model.children = true;
    return (dispatcher)=>{
        if (dispatcher._conversionApi.schema.checkChild(model.name, "$text")) /**
		* This error occurs when a {@link module:engine/model/element~ModelElement model element} is downcasted
		* via {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure} helper but the element was
		* allowed to host `$text` by the {@link module:engine/model/schema~ModelSchema model schema}.
		*
		* For instance, this may be the result of `myElement` allowing the content of
		* {@glink framework/deep-dive/schema#generic-items `$block`} in its schema definition:
		*
		* ```ts
		* // Element definition in schema.
		* schema.register( 'myElement', {
		* 	allowContentOf: '$block',
		*
		* 	// ...
		* } );
		*
		* // ...
		*
		* // Conversion of myElement with the use of elementToStructure().
		* editor.conversion.for( 'downcast' ).elementToStructure( {
		* 	model: 'myElement',
		* 	view: ( modelElement, { writer } ) => {
		* 		// ...
		* 	}
		* } );
		* ```
		*
		* In such case, {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToElement `elementToElement()`} helper
		* can be used instead to get around this problem:
		*
		* ```ts
		* editor.conversion.for( 'downcast' ).elementToElement( {
		* 	model: 'myElement',
		* 	view: ( modelElement, { writer } ) => {
		* 		// ...
		* 	}
		* } );
		* ```
		*
		* @error conversion-element-to-structure-disallowed-text
		* @param {string} elementName The name of the element the structure is to be created for.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-element-to-structure-disallowed-text", dispatcher, {
            elementName: model.name
        });
        dispatcher.on(`insert:${model.name}`, $b9b9f2bdf9c6137f$export$ee4a60f5f30bcea2(view, $b9b9f2bdf9c6137f$var$createConsumer(model)), {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on("reduceChanges", $b9b9f2bdf9c6137f$var$createChangeReducer(model), {
            priority: "low"
        });
    };
}
/**
* Model attribute to view element conversion helper.
*
* See {@link ~DowncastHelpers#attributeToElement `.attributeToElement()` downcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.model The key of the attribute to convert from or a `{ key, values }` object. `values` is an array
* of `String`s with possible values if the model attribute is an enumerable.
* @param config.view A view element definition or a function that takes the model attribute value and
* {@link module:engine/view/downcastwriter~ViewDowncastWriter view downcast writer} as parameters and returns a view attribute element.
* If `config.model.values` is given, `config.view` should be an object assigning values from `config.model.values` to view element
* definitions or functions.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastAttributeToElement(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    let model = config.model;
    if (typeof model == "string") model = {
        key: model
    };
    let eventName = `attribute:${model.key}`;
    if (model.name) eventName += ":" + model.name;
    if (model.values) for (const modelValue of model.values)config.view[modelValue] = $b9b9f2bdf9c6137f$var$normalizeToElementConfig(config.view[modelValue], "attribute");
    else config.view = $b9b9f2bdf9c6137f$var$normalizeToElementConfig(config.view, "attribute");
    const elementCreator = $b9b9f2bdf9c6137f$var$getFromAttributeCreator(config);
    return (dispatcher)=>{
        dispatcher.on(eventName, $b9b9f2bdf9c6137f$export$ef9cb34a60d615c1(elementCreator), {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* Model attribute to view attribute conversion helper.
*
* See {@link ~DowncastHelpers#attributeToAttribute `.attributeToAttribute()` downcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.model The key of the attribute to convert from or a `{ key, values, [ name ] }` object describing
* the attribute key, possible values and, optionally, an element name to convert from.
* @param config.view A view attribute key, or a `{ key, value }` object or a function that takes the model attribute value and returns
* a `{ key, value }` object.
* If `key` is `'class'`, `value` can be a `String` or an array of `String`s. If `key` is `'style'`, `value` is an object with
* key-value pairs. In other cases, `value` is a `String`.
* If `config.model.values` is set, `config.view` should be an object assigning values from `config.model.values` to
* `{ key, value }` objects or a functions.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastAttributeToAttribute(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    let model = config.model;
    if (typeof model == "string") model = {
        key: model
    };
    let eventName = `attribute:${model.key}`;
    if (model.name) eventName += ":" + model.name;
    if (model.values) for (const modelValue of model.values)config.view[modelValue] = $b9b9f2bdf9c6137f$var$normalizeToAttributeConfig(config.view[modelValue]);
    else config.view = $b9b9f2bdf9c6137f$var$normalizeToAttributeConfig(config.view);
    const elementCreator = $b9b9f2bdf9c6137f$var$getFromAttributeCreator(config);
    return (dispatcher)=>{
        dispatcher.on(eventName, $b9b9f2bdf9c6137f$var$changeAttribute(elementCreator), {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* Model marker to view element conversion helper.
*
* See {@link ~DowncastHelpers#markerToElement `.markerToElement()` downcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.model The name of the model marker (or model marker group) to convert.
* @param config.view A view element definition or a function that takes the model marker data as a parameter and returns a view UI element.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastMarkerToElement(config) {
    const view = $b9b9f2bdf9c6137f$var$normalizeToElementConfig(config.view, "ui");
    return (dispatcher)=>{
        dispatcher.on(`addMarker:${config.model}`, $b9b9f2bdf9c6137f$export$d6d83508304a361a(view), {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on(`removeMarker:${config.model}`, $b9b9f2bdf9c6137f$var$removeUIElement(), {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* Model marker to view data conversion helper.
*
* See {@link ~DowncastHelpers#markerToData `markerToData()` downcast helper} to learn more.
*
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastMarkerToData(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    const group = config.model;
    let view = config.view;
    if (!view) view = (markerName)=>({
            group: group,
            name: markerName.substr(config.model.length + 1)
        });
    return (dispatcher)=>{
        dispatcher.on(`addMarker:${group}`, $b9b9f2bdf9c6137f$var$insertMarkerData(view), {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on(`removeMarker:${group}`, $b9b9f2bdf9c6137f$var$removeMarkerData(view), {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* Model marker to highlight conversion helper.
*
* See {@link ~DowncastHelpers#markerToElement `.markerToElement()` downcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.model The name of the model marker (or model marker group) to convert.
* @param config.view A highlight descriptor that will be used for highlighting or a function that takes
* the model marker data as a parameter and returns a highlight descriptor.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$downcastMarkerToHighlight(config) {
    return (dispatcher)=>{
        dispatcher.on(`addMarker:${config.model}`, $b9b9f2bdf9c6137f$var$highlightText(config.view), {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on(`addMarker:${config.model}`, $b9b9f2bdf9c6137f$var$highlightElement(config.view), {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on(`removeMarker:${config.model}`, $b9b9f2bdf9c6137f$var$removeHighlight(config.view), {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* Takes `config.model`, and converts it to an object with normalized structure.
*
* @param model Model configuration or element name.
*/ function $b9b9f2bdf9c6137f$var$normalizeModelElementConfig(model) {
    if (typeof model == "string") model = {
        name: model
    };
    return {
        name: model.name,
        attributes: model.attributes ? (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(model.attributes) : [],
        children: !!model.children
    };
}
/**
* Takes `config.view`, and if it is an {@link module:engine/view/elementdefinition~ViewElementDefinition}, converts it
* to a function (because lower level converters accept only element creator functions).
*
* @param view View configuration.
* @param viewElementType View element type to create.
* @returns Element creator function to use in lower level converters.
*/ function $b9b9f2bdf9c6137f$var$normalizeToElementConfig(view, viewElementType) {
    if (typeof view == "function") return view;
    return (modelData, conversionApi)=>$b9b9f2bdf9c6137f$var$createViewElementFromDefinition(view, conversionApi, viewElementType);
}
/**
* Creates a view element instance from the provided {@link module:engine/view/elementdefinition~ViewElementDefinition} and class.
*/ function $b9b9f2bdf9c6137f$var$createViewElementFromDefinition(viewElementDefinition, conversionApi, viewElementType) {
    if (typeof viewElementDefinition == "string") viewElementDefinition = {
        name: viewElementDefinition
    };
    let element;
    const viewWriter = conversionApi.writer;
    const attributes = Object.assign({}, viewElementDefinition.attributes);
    if (viewElementType == "container") element = viewWriter.createContainerElement(viewElementDefinition.name, attributes);
    else if (viewElementType == "attribute") {
        const options = {
            priority: viewElementDefinition.priority || $b9b9f2bdf9c6137f$export$9c94dd4019f314d7.DEFAULT_PRIORITY
        };
        element = viewWriter.createAttributeElement(viewElementDefinition.name, attributes, options);
    } else element = viewWriter.createUIElement(viewElementDefinition.name, attributes);
    if (viewElementDefinition.styles) {
        const keys = Object.keys(viewElementDefinition.styles);
        for (const key of keys)viewWriter.setStyle(key, viewElementDefinition.styles[key], element);
    }
    if (viewElementDefinition.classes) {
        const classes = viewElementDefinition.classes;
        if (typeof classes == "string") viewWriter.addClass(classes, element);
        else for (const className of classes)viewWriter.addClass(className, element);
    }
    return element;
}
function $b9b9f2bdf9c6137f$var$getFromAttributeCreator(config) {
    if (config.model.values) return (modelAttributeValue, conversionApi, data)=>{
        const view = config.view[modelAttributeValue];
        if (view) return view(modelAttributeValue, conversionApi, data);
        return null;
    };
    else return config.view;
}
/**
* Takes the configuration, adds default parameters if they do not exist and normalizes other parameters to be used in downcast converters
* for generating a view attribute.
*
* @param view View configuration.
*/ function $b9b9f2bdf9c6137f$var$normalizeToAttributeConfig(view) {
    if (typeof view == "string") return (modelAttributeValue)=>({
            key: view,
            value: modelAttributeValue
        });
    else if (typeof view == "object") {
        if (view.value) return ()=>view;
        else return (modelAttributeValue)=>({
                key: view.key,
                value: modelAttributeValue
            });
    } else return view;
}
/**
* Helper function for `highlight`. Prepares the actual descriptor object using value passed to the converter.
*/ function $b9b9f2bdf9c6137f$var$prepareDescriptor(highlightDescriptor, data, conversionApi) {
    const descriptor = typeof highlightDescriptor == "function" ? highlightDescriptor(data, conversionApi) : {
        ...highlightDescriptor
    };
    if (!descriptor) return null;
    if (!descriptor.priority) descriptor.priority = 10;
    if (!descriptor.id) descriptor.id = data.markerName;
    return descriptor;
}
/**
* Creates a function that checks a single differ diff item whether it should trigger reconversion.
*
* @param model A normalized `config.model` converter configuration.
* @param model.name The name of element.
* @param model.attributes The list of attribute names that should trigger reconversion.
* @param model.children Whether the child list change should trigger reconversion.
*/ function $b9b9f2bdf9c6137f$var$createChangeReducerCallback(model) {
    return (node, change)=>{
        if (!node.is("element", model.name)) return false;
        if (change.type == "attribute") {
            if (model.attributes.includes(change.attributeKey)) return true;
        } else if (model.children) return true;
        return false;
    };
}
/**
* Creates a `reduceChanges` event handler for reconversion.
*
* @param model A normalized `config.model` converter configuration.
* @param model.name The name of element.
* @param model.attributes The list of attribute names that should trigger reconversion.
* @param model.children Whether the child list change should trigger reconversion.
*/ function $b9b9f2bdf9c6137f$var$createChangeReducer(model) {
    const shouldReplace = $b9b9f2bdf9c6137f$var$createChangeReducerCallback(model);
    return (evt, data)=>{
        const reducedChanges = [];
        if (!data.reconvertedElements) data.reconvertedElements = /* @__PURE__ */ new Set();
        for (const change of data.changes){
            const node = change.type == "attribute" ? change.range.start.nodeAfter : change.position.parent;
            if (!node || !shouldReplace(node, change) || change.type == "reinsert") {
                reducedChanges.push(change);
                continue;
            }
            if (change.type == "insert" && change.action == "rename") data.refreshedItems.add(change.position.nodeAfter);
            if (!data.reconvertedElements.has(node)) {
                data.reconvertedElements.add(node);
                const position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(node);
                let changeIndex = reducedChanges.length;
                for(let i = reducedChanges.length - 1; i >= 0; i--){
                    const change = reducedChanges[i];
                    const positionRelation = (change.type == "attribute" ? change.range.start : change.position).compareWith(position);
                    if (positionRelation == "before" || change.type == "remove" && positionRelation == "same") break;
                    changeIndex = i;
                }
                reducedChanges.splice(changeIndex, 0, {
                    type: "reinsert",
                    name: node.name,
                    position: position,
                    length: 1
                });
            }
        }
        data.changes = reducedChanges;
    };
}
/**
* Creates a function that checks if an element and its watched attributes can be consumed and consumes them.
*
* @param model A normalized `config.model` converter configuration.
* @param model.name The name of element.
* @param model.attributes The list of attribute names that should trigger reconversion.
* @param model.children Whether the child list change should trigger reconversion.
*/ function $b9b9f2bdf9c6137f$var$createConsumer(model) {
    return (node, consumable, options = {})=>{
        const events = [
            "insert"
        ];
        for (const attributeName of model.attributes)if (node.hasAttribute(attributeName)) events.push(`attribute:${attributeName}`);
        if (!events.every((event)=>consumable.test(node, event))) return false;
        if (!options.preflight) events.forEach((event)=>consumable.consume(node, event));
        return true;
    };
}
/**
* Creates a function that creates view slots.
*
* @returns Function exposed by the writer as `createSlot()`.
*/ function $b9b9f2bdf9c6137f$var$createSlotFactory(element, slotsMap, conversionApi) {
    return (writer, modeOrFilter)=>{
        const slot = writer.createContainerElement("$slot");
        let children;
        if (modeOrFilter === "children") children = Array.from(element.getChildren());
        else if (typeof modeOrFilter == "function") children = Array.from(element.getChildren()).filter((element)=>modeOrFilter(element));
        else /**
		* Unknown slot mode was provided to `writer.createSlot()` in the downcast converter.
		*
		* @error conversion-slot-mode-unknown
		* @param {never} modeOrFilter The specified mode or filter.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-slot-mode-unknown", conversionApi.dispatcher, {
            modeOrFilter: modeOrFilter
        });
        slotsMap.set(slot, children);
        return slot;
    };
}
/**
* Checks if all children are covered by slots and there is no child that landed in multiple slots.
*/ function $b9b9f2bdf9c6137f$var$validateSlotsChildren(element, slotsMap, conversionApi) {
    const childrenInSlots = Array.from(slotsMap.values()).flat();
    const uniqueChildrenInSlots = new Set(childrenInSlots);
    if (uniqueChildrenInSlots.size != childrenInSlots.length) /**
	* Filters provided to `writer.createSlot()` overlap (at least two filters accept the same child element).
	*
	* @error conversion-slot-filter-overlap
	* @param {module:engine/model/element~ModelElement} element The element of which children would not be properly
	* allocated to multiple slots.
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-slot-filter-overlap", conversionApi.dispatcher, {
        element: element
    });
    if (uniqueChildrenInSlots.size != element.childCount) /**
	* Filters provided to `writer.createSlot()` are incomplete and exclude at least one children element (one of
	* the children elements would not be assigned to any of the slots).
	*
	* @error conversion-slot-filter-incomplete
	* @param {module:engine/model/element~ModelElement} element The element of which children would not be properly
	* allocated to multiple slots.
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-slot-filter-incomplete", conversionApi.dispatcher, {
        element: element
    });
}
/**
* Fill slots with appropriate view elements.
*/ function $b9b9f2bdf9c6137f$var$fillSlots(viewElement, slotsMap, conversionApi, options) {
    conversionApi.mapper.on("modelToViewPosition", toViewPositionMapping, {
        priority: "highest"
    });
    let currentSlot = null;
    let currentSlotNodes = null;
    for ([currentSlot, currentSlotNodes] of slotsMap){
        $b9b9f2bdf9c6137f$var$reinsertOrConvertNodes(viewElement, currentSlotNodes, conversionApi, options);
        conversionApi.writer.setCustomProperty("$structureSlotParent", true, currentSlot.parent);
        conversionApi.writer.move(conversionApi.writer.createRangeIn(currentSlot), conversionApi.writer.createPositionBefore(currentSlot));
        conversionApi.writer.remove(currentSlot);
    }
    conversionApi.mapper.off("modelToViewPosition", toViewPositionMapping);
    function toViewPositionMapping(evt, data) {
        const element = data.modelPosition.nodeAfter;
        const index = currentSlotNodes.indexOf(element);
        if (index < 0) return;
        data.viewPosition = data.mapper.findPositionIn(currentSlot, index);
    }
}
/**
* Inserts view representation of `nodes` into the `viewElement` either by bringing back just removed view nodes
* or by triggering conversion for them.
*/ function $b9b9f2bdf9c6137f$var$reinsertOrConvertNodes(viewElement, modelNodes, conversionApi, options) {
    for (const modelChildNode of modelNodes)if (!$b9b9f2bdf9c6137f$var$reinsertNode(viewElement.root, modelChildNode, conversionApi, options)) conversionApi.convertItem(modelChildNode);
}
/**
* Checks if the view for the given model element could be reused and reinserts it to the view.
*
* @returns `false` if view element can't be reused.
*/ function $b9b9f2bdf9c6137f$var$reinsertNode(viewRoot, modelNode, conversionApi, options) {
    const { writer: writer, mapper: mapper } = conversionApi;
    if (!options.reconversion) return false;
    const viewChildNode = mapper.toViewElement(modelNode);
    if (!viewChildNode || viewChildNode.root == viewRoot) return false;
    if (!conversionApi.canReuseView(viewChildNode)) return false;
    writer.move(writer.createRangeOn(viewChildNode), mapper.toViewPosition($b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(modelNode)));
    return true;
}
/**
* The default consumer for insert events.
*
* @param item Model item.
* @param consumable The model consumable.
* @param options.preflight Whether should consume or just check if can be consumed.
*/ function $b9b9f2bdf9c6137f$var$defaultConsumer(item, consumable, { preflight: preflight } = {}) {
    if (preflight) return consumable.test(item, "insert");
    else return consumable.consume(item, "insert");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Fixes all empty roots.
*
* @internal
* @param writer The model writer.
* @returns `true` if any change has been applied, `false` otherwise.
*/ function $b9b9f2bdf9c6137f$export$5245497caaaa7808(writer) {
    const { schema: schema, document: document1 } = writer.model;
    for (const root of document1.getRoots())if (root.isEmpty && !schema.checkChild(root, "$text")) {
        if (schema.checkChild(root, "paragraph")) {
            writer.insertElement("paragraph", root);
            return true;
        }
    }
    return false;
}
/**
* Checks if the given node wrapped with a paragraph would be accepted by the schema in the given position.
*
* @internal
* @param position The position at which to check.
* @param nodeOrType The child node or child type to check.
* @param schema A schema instance used for element validation.
*/ function $b9b9f2bdf9c6137f$export$576a60d33a9343e9(position, nodeOrType, schema) {
    const context = schema.createContext(position);
    if (!schema.checkChild(context, "paragraph")) return false;
    if (!schema.checkChild(context.push("paragraph"), nodeOrType)) return false;
    return true;
}
/**
* Inserts a new paragraph at the given position and returns a position inside that paragraph.
*
* @internal
* @param position The position where a paragraph should be inserted.
* @param writer The model writer.
* @returns  Position inside the created paragraph.
*/ function $b9b9f2bdf9c6137f$export$26e14cf0958eab58(position, writer) {
    const paragraph = writer.createElement("paragraph");
    writer.insert(paragraph, position);
    return writer.createPositionAt(paragraph, 0);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Contains the {@link module:engine/view/view view} to {@link module:engine/model/model model} converters for
* {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher}.
*
* @module engine/conversion/upcasthelpers
*/ /**
* Upcast conversion helper functions.
*
* Learn more about {@glink framework/deep-dive/conversion/upcast upcast helpers}.
*
* @extends module:engine/conversion/conversionhelpers~ConversionHelpers
*/ var $b9b9f2bdf9c6137f$export$3240fbf7657c4a54 = class extends $b9b9f2bdf9c6137f$export$1e3da93261a57296 {
    /**
	* View element to model element conversion helper.
	*
	* This conversion results in creating a model element. For example,
	* view `<p>Foo</p>` becomes `<paragraph>Foo</paragraph>` in the model.
	*
	* Keep in mind that the element will be inserted only if it is allowed
	* by {@link module:engine/model/schema~ModelSchema schema} configuration.
	*
	* ```ts
	* editor.conversion.for( 'upcast' ).elementToElement( {
	* 	view: 'p',
	* 	model: 'paragraph'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToElement( {
	* 	view: 'p',
	* 	model: 'paragraph',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToElement( {
	* 	view: {
	* 		name: 'p',
	* 		classes: 'fancy'
	* 	},
	* 	model: 'fancyParagraph'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToElement( {
	* 	view: {
	* 		name: 'p',
	* 		classes: 'heading'
	* 	},
	* 	model: ( viewElement, conversionApi ) => {
	* 		const modelWriter = conversionApi.writer;
	*
	* 		return modelWriter.createElement( 'heading', { level: viewElement.getAttribute( 'data-level' ) } );
	* 	}
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.view Pattern matching all view elements which should be converted. If not set, the converter
	* will fire for every view element.
	* @param config.model Name of the model element, a model element instance or a function that takes a view element
	* and {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API}
	* and returns a model element. The model element will be inserted in the model.
	* @param config.converterPriority Converter priority.
	*/ elementToElement(config) {
        return this.add($b9b9f2bdf9c6137f$var$upcastElementToElement(config));
    }
    /**
	* View element to model attribute conversion helper.
	*
	* This conversion results in setting an attribute on a model node. For example, view `<strong>Foo</strong>` becomes
	* `Foo` {@link module:engine/model/text~ModelText model text node} with `bold` attribute set to `true`.
	*
	* This helper is meant to set a model attribute on all the elements that are inside the converted element:
	*
	* ```
	* <strong>Foo</strong>   -->   <strong><p>Foo</p></strong>   -->   <paragraph><$text bold="true">Foo</$text></paragraph>
	* ```
	*
	* Above is a sample of HTML code, that goes through autoparagraphing (first step) and then is converted (second step).
	* Even though `<strong>` is over `<p>` element, `bold="true"` was added to the text. See
	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#attributeToAttribute} for comparison.
	*
	* Keep in mind that the attribute will be set only if it is allowed by
	* {@link module:engine/model/schema~ModelSchema schema} configuration.
	*
	* ```ts
	* editor.conversion.for( 'upcast' ).elementToAttribute( {
	* 	view: 'strong',
	* 	model: 'bold'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToAttribute( {
	* 	view: 'strong',
	* 	model: 'bold',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToAttribute( {
	* 	view: {
	* 		name: 'span',
	* 		classes: 'bold'
	* 	},
	* 	model: 'bold'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToAttribute( {
	* 	view: {
	* 		name: 'span',
	* 		classes: [ 'styled', 'styled-dark' ]
	* 	},
	* 	model: {
	* 		key: 'styled',
	* 		value: 'dark'
	* 	}
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToAttribute( {
	* 	view: {
	* 		name: 'span',
	* 		styles: {
	* 			'font-size': /[\s\S]+/
	* 		}
	* 	},
	* 	model: {
	* 		key: 'fontSize',
	* 		value: ( viewElement, conversionApi ) => {
	* 			const fontSize = viewElement.getStyle( 'font-size' );
	* 			const value = fontSize.substr( 0, fontSize.length - 2 );
	*
	* 			if ( value <= 10 ) {
	* 				return 'small';
	* 			} else if ( value > 12 ) {
	* 				return 'big';
	* 			}
	*
	* 			return null;
	* 		}
	* 	}
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.view Pattern matching all view elements which should be converted.
	* @param config.model Model attribute key or an object with `key` and `value` properties, describing
	* the model attribute. `value` property may be set as a function that takes a view element and
	* {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the value.
	* If `String` is given, the model attribute value will be set to `true`.
	* @param config.converterPriority Converter priority. Defaults to `low`.
	*/ elementToAttribute(config) {
        return this.add($b9b9f2bdf9c6137f$var$upcastElementToAttribute(config));
    }
    /**
	* View attribute to model attribute conversion helper.
	*
	* This conversion results in setting an attribute on a model node. For example, view `<img src="foo.jpg"></img>` becomes
	* `<imageBlock source="foo.jpg"></imageBlock>` in the model.
	*
	* This helper is meant to convert view attributes from view elements which got converted to the model, so the view attribute
	* is set only on the corresponding model node:
	*
	* ```
	* <div class="dark"><div>foo</div></div>    -->    <div dark="true"><div>foo</div></div>
	* ```
	*
	* Above, `class="dark"` attribute is added only to the `<div>` elements that has it. This is in contrast to
	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToAttribute} which sets attributes for
	* all the children in the model:
	*
	* ```
	* <strong>Foo</strong>   -->   <strong><p>Foo</p></strong>   -->   <paragraph><$text bold="true">Foo</$text></paragraph>
	* ```
	*
	* Above is a sample of HTML code, that goes through autoparagraphing (first step) and then is converted (second step).
	* Even though `<strong>` is over `<p>` element, `bold="true"` was added to the text.
	*
	* Keep in mind that the attribute will be set only if it is allowed by
	* {@link module:engine/model/schema~ModelSchema schema} configuration.
	*
	* ```ts
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: 'src',
	* 	model: 'source'
	* } );
	*
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: { key: 'src' },
	* 	model: 'source'
	* } );
	*
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: { key: 'src' },
	* 	model: 'source',
	* 	converterPriority: 'normal'
	* } );
	*
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: {
	* 		key: 'data-style',
	* 		value: /[\s\S]+/
	* 	},
	* 	model: 'styled'
	* } );
	*
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: {
	* 		name: 'img',
	* 		key: 'class',
	* 		value: 'styled-dark'
	* 	},
	* 	model: {
	* 		key: 'styled',
	* 		value: 'dark'
	* 	}
	* } );
	*
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: {
	* 		key: 'class',
	* 		value: /styled-[\S]+/
	* 	},
	* 	model: {
	* 		key: 'styled'
	* 		value: ( viewElement, conversionApi ) => {
	* 			const regexp = /styled-([\S]+)/;
	* 			const match = viewElement.getAttribute( 'class' ).match( regexp );
	*
	* 			return match[ 1 ];
	* 		}
	* 	}
	* } );
	* ```
	*
	* Converting styles works a bit differently as it requires `view.styles` to be an object and by default
	* a model attribute will be set to `true` by such a converter. You can set the model attribute to any value by providing the `value`
	* callback that returns the desired value.
	*
	* ```ts
	* // Default conversion of font-weight style will result in setting bold attribute to true.
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: {
	* 		styles: {
	* 			'font-weight': 'bold'
	* 		}
	* 	},
	* 	model: 'bold'
	* } );
	*
	* // This converter will pass any style value to the `lineHeight` model attribute.
	* editor.conversion.for( 'upcast' ).attributeToAttribute( {
	* 	view: {
	* 		styles: {
	* 			'line-height': /[\s\S]+/
	* 		}
	* 	},
	* 	model: {
	* 		key: 'lineHeight',
	* 		value: ( viewElement, conversionApi ) => viewElement.getStyle( 'line-height' )
	* 	}
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.view Specifies which view attribute will be converted. If a `String` is passed,
	* attributes with given key will be converted. If an `Object` is passed, it must have a required `key` property,
	* specifying view attribute key, and may have an optional `value` property, specifying view attribute value and optional `name`
	* property specifying a view element name from/on which the attribute should be converted. `value` can be given as a `String`,
	* a `RegExp` or a function callback, that takes view attribute value as the only parameter and returns `Boolean`.
	* @param config.model Model attribute key or an object with `key` and `value` properties, describing
	* the model attribute. `value` property may be set as a function that takes a view element and
	* {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the value.
	* If `String` is given, the model attribute value will be same as view attribute value.
	* @param config.converterPriority Converter priority. Defaults to `low`.
	*/ attributeToAttribute(config) {
        return this.add($b9b9f2bdf9c6137f$var$upcastAttributeToAttribute(config));
    }
    /**
	* View element to model marker conversion helper.
	*
	* This conversion results in creating a model marker. For example, if the marker was stored in a view as an element:
	* `<p>Fo<span data-marker="comment" data-comment-id="7"></span>o</p><p>B<span data-marker="comment" data-comment-id="7"></span>ar</p>`,
	* after the conversion is done, the marker will be available in
	* {@link module:engine/model/model~Model#markers model document markers}.
	*
	* **Note**: When this helper is used in the data upcast in combination with
	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`} in the data downcast,
	* then invalid HTML code (e.g. a span between table cells) may be produced by the latter converter.
	*
	* In most of the cases, the {@link #dataToMarker} should be used instead.
	*
	* ```ts
	* editor.conversion.for( 'upcast' ).elementToMarker( {
	* 	view: 'marker-search',
	* 	model: 'search'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToMarker( {
	* 	view: 'marker-search',
	* 	model: 'search',
	* 	converterPriority: 'high'
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToMarker( {
	* 	view: 'marker-search',
	* 	model: ( viewElement, conversionApi ) => 'comment:' + viewElement.getAttribute( 'data-comment-id' )
	* } );
	*
	* editor.conversion.for( 'upcast' ).elementToMarker( {
	* 	view: {
	* 		name: 'span',
	* 		attributes: {
	* 			'data-marker': 'search'
	* 		}
	* 	},
	* 	model: 'search'
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.view Pattern matching all view elements which should be converted.
	* @param config.model Name of the model marker, or a function that takes a view element and returns
	* a model marker name.
	* @param config.converterPriority Converter priority.
	*/ elementToMarker(config) {
        return this.add($b9b9f2bdf9c6137f$var$upcastElementToMarker(config));
    }
    /**
	* View-to-model marker conversion helper.
	*
	* Converts view data created by {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`}
	* back to a model marker.
	*
	* This converter looks for specific view elements and view attributes that mark marker boundaries. See
	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`} to learn what view data
	* is expected by this converter.
	*
	* The `config.view` property is equal to the marker group name to convert.
	*
	* By default, this converter creates markers with the `group:name` name convention (to match the default `markerToData` conversion).
	*
	* The conversion configuration can take a function that will generate a marker name.
	* If such function is set as the `config.model` parameter, it is passed the `name` part from the view element or attribute and it is
	* expected to return a string with the marker name.
	*
	* Basic usage:
	*
	* ```ts
	* // Using the default conversion.
	* // In this case, all markers from the `comment` group will be converted.
	* // The conversion will look for `<comment-start>` and `<comment-end>` tags and
	* // `data-comment-start-before`, `data-comment-start-after`,
	* // `data-comment-end-before` and `data-comment-end-after` attributes.
	* editor.conversion.for( 'upcast' ).dataToMarker( {
	* 	view: 'comment'
	* } );
	* ```
	*
	* An example of a model that may be generated by this conversion:
	*
	* ```
	* // View:
	* <p>Foo<comment-start name="commentId:uid"></comment-start>bar</p>
	* <figure data-comment-end-after="commentId:uid" class="image"><img src="abc.jpg" /></figure>
	*
	* // Model:
	* <paragraph>Foo[bar</paragraph>
	* <imageBlock src="abc.jpg"></imageBlock>]
	* ```
	*
	* Where `[]` are boundaries of a marker that will receive the `comment:commentId:uid` name.
	*
	* Other examples of usage:
	*
	* ```ts
	* // Using a custom function which is the same as the default conversion:
	* editor.conversion.for( 'upcast' ).dataToMarker( {
	* 	view: 'comment',
	* 	model: ( name, conversionApi ) => 'comment:' + name,
	* } );
	*
	* // Using the converter priority:
	* editor.conversion.for( 'upcast' ).dataToMarker( {
	* 	view: 'comment',
	* 	model: ( name, conversionApi ) => 'comment:' + name,
	* 	converterPriority: 'high'
	* } );
	* ```
	*
	* See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
	* to the conversion process.
	*
	* @param config Conversion configuration.
	* @param config.view The marker group name to convert.
	* @param config.model A function that takes the `name` part from the view element or attribute and
	* {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the marker name.
	* @param config.converterPriority Converter priority.
	*/ dataToMarker(config) {
        return this.add($b9b9f2bdf9c6137f$var$upcastDataToMarker(config));
    }
};
/**
* Function factory, creates a converter that converts
* {@link module:engine/view/documentfragment~ViewDocumentFragment view document fragment}
* or all children of {@link module:engine/view/element~ViewElement} into
* {@link module:engine/model/documentfragment~ModelDocumentFragment model document fragment}.
* This is the "entry-point" converter for upcast (view to model conversion). This converter starts the conversion of all children
* of passed view document fragment. Those children {@link module:engine/view/node~ViewNode view nodes} are then
* handled by other converters.
*
* This also a "default", last resort converter for all view elements that has not been converted by other converters.
* When a view element is being converted to the model but it does not have converter specified, that view element
* will be converted to {@link module:engine/model/documentfragment~ModelDocumentFragment model document fragment} and returned.
*
* @returns Universal converter for view {@link module:engine/view/documentfragment~ViewDocumentFragment fragments} and
* {@link module:engine/view/element~ViewElement elements} that returns
* {@link module:engine/model/documentfragment~ModelDocumentFragment model fragment} with children of converted view item.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$ac74e2a6eadb85c7() {
    return (evt, data, conversionApi)=>{
        if (!data.modelRange && conversionApi.consumable.consume(data.viewItem, {
            name: true
        })) {
            const { modelRange: modelRange, modelCursor: modelCursor } = conversionApi.convertChildren(data.viewItem, data.modelCursor);
            data.modelRange = modelRange;
            data.modelCursor = modelCursor;
        }
    };
}
/**
* Function factory, creates a converter that converts
* {@link module:engine/view/text~ViewText} to {@link module:engine/model/text~ModelText}.
*
* @returns {@link module:engine/view/text~ViewText View text} converter.
* @internal
*/ function $b9b9f2bdf9c6137f$export$f86caf7f35a4e003() {
    return (evt, data, { schema: schema, consumable: consumable, writer: writer })=>{
        let position = data.modelCursor;
        if (!consumable.test(data.viewItem)) return;
        if (!schema.checkChild(position, "$text")) {
            if (!$b9b9f2bdf9c6137f$export$576a60d33a9343e9(position, "$text", schema)) return;
            if (data.viewItem.data.trim().length == 0) return;
            position = $b9b9f2bdf9c6137f$export$26e14cf0958eab58(position, writer);
        }
        consumable.consume(data.viewItem);
        const text = writer.createText(data.viewItem.data);
        writer.insert(text, position);
        data.modelRange = writer.createRange(position, position.getShiftedBy(text.offsetSize));
        data.modelCursor = data.modelRange.end;
    };
}
/**
* Function factory, creates a callback function which converts a {@link module:engine/view/selection~ViewSelection
* view selection} taken from the {@link module:engine/view/document~ViewDocument#event:selectionChange} event
* and sets in on the {@link module:engine/model/document~ModelDocument#selection model}.
*
* **Note**: because there is no view selection change dispatcher nor any other advanced view selection to model
* conversion mechanism, the callback should be set directly on view document.
*
* ```ts
* view.document.on( 'selectionChange', convertSelectionChange( modelDocument, mapper ) );
* ```
*
* @param model Data model.
* @param mapper Conversion mapper.
* @returns {@link module:engine/view/document~ViewDocument#event:selectionChange} callback function.
* @internal
*/ function $b9b9f2bdf9c6137f$export$19f53eb20fc080f0(model, mapper) {
    return (evt, data)=>{
        const viewSelection = data.newSelection;
        const ranges = [];
        for (const viewRange of viewSelection.getRanges())ranges.push(mapper.toModelRange(viewRange));
        const modelSelection = model.createSelection(ranges, {
            backward: viewSelection.isBackward
        });
        if (!modelSelection.isEqual(model.document.selection)) model.change((writer)=>{
            writer.setSelection(modelSelection);
        });
    };
}
/**
* View element to model element conversion helper.
*
* See {@link ~UpcastHelpers#elementToElement `.elementToElement()` upcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.view Pattern matching all view elements which should be converted. If not
* set, the converter will fire for every view element.
* @param config.model Name of the model element, a model element
* instance or a function that takes a view element and returns a model element. The model element will be inserted in the model.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$upcastElementToElement(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    const converter = $b9b9f2bdf9c6137f$var$prepareToElementConverter(config);
    const elementName = $b9b9f2bdf9c6137f$var$getViewElementNameFromConfig(config.view);
    const eventName = elementName ? `element:${elementName}` : "element";
    return (dispatcher)=>{
        dispatcher.on(eventName, converter, {
            priority: config.converterPriority || "normal"
        });
    };
}
/**
* View element to model attribute conversion helper.
*
* See {@link ~UpcastHelpers#elementToAttribute `.elementToAttribute()` upcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.view Pattern matching all view elements which should be converted.
* @param config.model Model attribute key or an object with `key` and `value` properties, describing
* the model attribute. `value` property may be set as a function that takes a view element and returns the value.
* If `String` is given, the model attribute value will be set to `true`.
* @param config.converterPriority Converter priority. Defaults to `low`.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$upcastElementToAttribute(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    $b9b9f2bdf9c6137f$var$normalizeModelAttributeConfig(config);
    const converter = $b9b9f2bdf9c6137f$var$prepareToAttributeConverter(config, false);
    const elementName = $b9b9f2bdf9c6137f$var$getViewElementNameFromConfig(config.view);
    const eventName = elementName ? `element:${elementName}` : "element";
    return (dispatcher)=>{
        dispatcher.on(eventName, converter, {
            priority: config.converterPriority || "low"
        });
    };
}
/**
* View attribute to model attribute conversion helper.
*
* See {@link ~UpcastHelpers#attributeToAttribute `.attributeToAttribute()` upcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.view Specifies which view attribute will be converted. If a `String` is passed,
* attributes with given key will be converted. If an `Object` is passed, it must have a required `key` property,
* specifying view attribute key, and may have an optional `value` property, specifying view attribute value and optional `name`
* property specifying a view element name from/on which the attribute should be converted. `value` can be given as a `String`,
* a `RegExp` or a function callback, that takes view attribute value as the only parameter and returns `Boolean`.
* @param config.model Model attribute key or an object with `key` and `value` properties, describing
* the model attribute. `value` property may be set as a function that takes a view element and returns the value.
* If `String` is given, the model attribute value will be same as view attribute value.
* @param config.converterPriority Converter priority. Defaults to `low`.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$upcastAttributeToAttribute(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    let viewKey = null;
    if (typeof config.view == "string" || config.view.key) viewKey = $b9b9f2bdf9c6137f$var$normalizeViewAttributeKeyValueConfig(config);
    $b9b9f2bdf9c6137f$var$normalizeModelAttributeConfig(config, viewKey);
    const converter = $b9b9f2bdf9c6137f$var$prepareToAttributeConverter(config, true);
    return (dispatcher)=>{
        dispatcher.on("element", converter, {
            priority: config.converterPriority || "low"
        });
    };
}
/**
* View element to model marker conversion helper.
*
* See {@link ~UpcastHelpers#elementToMarker `.elementToMarker()` upcast helper} for examples.
*
* @param config Conversion configuration.
* @param config.view Pattern matching all view elements which should be converted.
* @param config.model Name of the model marker, or a function that takes a view element and returns
* a model marker name.
* @param config.converterPriority Converter priority.
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$upcastElementToMarker(config) {
    const model = $b9b9f2bdf9c6137f$var$normalizeElementToMarkerModelConfig(config.model);
    return $b9b9f2bdf9c6137f$var$upcastElementToElement({
        ...config,
        model: model
    });
}
/**
* View data to model marker conversion helper.
*
* See {@link ~UpcastHelpers#dataToMarker} to learn more.
*
* @returns Conversion helper.
*/ function $b9b9f2bdf9c6137f$var$upcastDataToMarker(config) {
    config = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(config);
    if (!config.model) config.model = (name)=>{
        return name ? config.view + ":" + name : config.view;
    };
    const normalizedConfig = {
        view: config.view,
        model: config.model
    };
    const converterStart = $b9b9f2bdf9c6137f$var$prepareToElementConverter($b9b9f2bdf9c6137f$var$normalizeDataToMarkerConfig(normalizedConfig, "start"));
    const converterEnd = $b9b9f2bdf9c6137f$var$prepareToElementConverter($b9b9f2bdf9c6137f$var$normalizeDataToMarkerConfig(normalizedConfig, "end"));
    return (dispatcher)=>{
        dispatcher.on(`element:${config.view}-start`, converterStart, {
            priority: config.converterPriority || "normal"
        });
        dispatcher.on(`element:${config.view}-end`, converterEnd, {
            priority: config.converterPriority || "normal"
        });
        const basePriority = (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low;
        const maxPriority = (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).highest;
        const priorityFactor = (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).get(config.converterPriority) / maxPriority;
        dispatcher.on("element", $b9b9f2bdf9c6137f$var$upcastAttributeToMarker(normalizedConfig), {
            priority: basePriority + priorityFactor
        });
    };
}
/**
* Function factory, returns a callback function which converts view attributes to a model marker.
*
* The converter looks for elements with `data-group-start-before`, `data-group-start-after`, `data-group-end-before`
* and `data-group-end-after` attributes and inserts `$marker` model elements before/after those elements.
* `group` part is specified in `config.view`.
*
* @returns Marker converter.
*/ function $b9b9f2bdf9c6137f$var$upcastAttributeToMarker(config) {
    return (evt, data, conversionApi)=>{
        const attrName = `data-${config.view}`;
        if (!conversionApi.consumable.test(data.viewItem, {
            attributes: attrName + "-end-after"
        }) && !conversionApi.consumable.test(data.viewItem, {
            attributes: attrName + "-start-after"
        }) && !conversionApi.consumable.test(data.viewItem, {
            attributes: attrName + "-end-before"
        }) && !conversionApi.consumable.test(data.viewItem, {
            attributes: attrName + "-start-before"
        })) return;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        if (conversionApi.consumable.consume(data.viewItem, {
            attributes: attrName + "-end-after"
        })) addMarkerElements(data.modelRange.end, data.viewItem.getAttribute(attrName + "-end-after").split(","));
        if (conversionApi.consumable.consume(data.viewItem, {
            attributes: attrName + "-start-after"
        })) addMarkerElements(data.modelRange.end, data.viewItem.getAttribute(attrName + "-start-after").split(","));
        if (conversionApi.consumable.consume(data.viewItem, {
            attributes: attrName + "-end-before"
        })) addMarkerElements(data.modelRange.start, data.viewItem.getAttribute(attrName + "-end-before").split(","));
        if (conversionApi.consumable.consume(data.viewItem, {
            attributes: attrName + "-start-before"
        })) addMarkerElements(data.modelRange.start, data.viewItem.getAttribute(attrName + "-start-before").split(","));
        function addMarkerElements(position, markerViewNames) {
            for (const markerViewName of markerViewNames){
                const markerName = config.model(markerViewName, conversionApi);
                const element = conversionApi.writer.createElement("$marker", {
                    "data-name": markerName
                });
                conversionApi.writer.insert(element, position);
                if (data.modelCursor.isEqual(position)) data.modelCursor = data.modelCursor.getShiftedBy(1);
                else data.modelCursor = data.modelCursor._getTransformedByInsertion(position, 1);
                data.modelRange = data.modelRange._getTransformedByInsertion(position, 1)[0];
            }
        }
    };
}
/**
* Helper function for from-view-element conversion. Checks if `config.view` directly specifies converted view element's name
* and if so, returns it.
*
* @param config Conversion view config.
* @returns View element name or `null` if name is not directly set.
*/ function $b9b9f2bdf9c6137f$var$getViewElementNameFromConfig(viewConfig) {
    if (typeof viewConfig == "string") return viewConfig;
    if (typeof viewConfig == "object" && typeof viewConfig.name == "string") return viewConfig.name;
    return null;
}
/**
* Helper for to-model-element conversion. Takes a config object and returns a proper converter function.
*
* @param config Conversion configuration.
* @returns View to model converter.
*/ function $b9b9f2bdf9c6137f$var$prepareToElementConverter(config) {
    const matcher = new $b9b9f2bdf9c6137f$export$20214574ec94167d(config.view);
    return (evt, data, conversionApi)=>{
        const matcherResult = matcher.match(data.viewItem);
        if (!matcherResult) return;
        const match = matcherResult.match;
        match.name = true;
        if (!conversionApi.consumable.test(data.viewItem, match)) return;
        const modelElement = $b9b9f2bdf9c6137f$var$getModelElement(config.model, data.viewItem, conversionApi);
        if (!modelElement) return;
        if (!conversionApi.safeInsert(modelElement, data.modelCursor)) return;
        conversionApi.consumable.consume(data.viewItem, match);
        conversionApi.convertChildren(data.viewItem, modelElement);
        conversionApi.updateConversionResult(modelElement, data);
    };
}
/**
* Helper function for upcasting-to-element converter. Takes the model configuration, the converted view element
* and a writer instance and returns a model element instance to be inserted in the model.
*
* @param model Model conversion configuration.
* @param input The converted view node.
* @param conversionApi The upcast conversion API.
*/ function $b9b9f2bdf9c6137f$var$getModelElement(model, input, conversionApi) {
    if (model instanceof Function) return model(input, conversionApi);
    else return conversionApi.writer.createElement(model);
}
/**
* Helper function view-attribute-to-model-attribute helper. Normalizes `config.view` which was set as `String` or
* as an `Object` with `key`, `value` and `name` properties. Normalized `config.view` has is compatible with
* {@link module:engine/view/matcher~MatcherPattern}.
*
* @param config Conversion config.
* @returns Key of the converted view attribute.
*/ function $b9b9f2bdf9c6137f$var$normalizeViewAttributeKeyValueConfig(config) {
    if (typeof config.view == "string") config.view = {
        key: config.view
    };
    const key = config.view.key;
    const value = typeof config.view.value == "undefined" ? /[\s\S]*/ : config.view.value;
    let normalized;
    if (key == "class" || key == "style") normalized = {
        [key == "class" ? "classes" : "styles"]: value
    };
    else normalized = {
        attributes: {
            [key]: value
        }
    };
    if (config.view.name) normalized.name = config.view.name;
    config.view = normalized;
    return key;
}
/**
* Helper function that normalizes `config.model` in from-model-attribute conversion. `config.model` can be set
* as a `String`, an `Object` with only `key` property or an `Object` with `key` and `value` properties. Normalized
* `config.model` is an `Object` with `key` and `value` properties.
*
* @param config Conversion config.
* @param viewAttributeKeyToCopy Key of the converted view attribute. If it is set, model attribute value
* will be equal to view attribute value.
*/ function $b9b9f2bdf9c6137f$var$normalizeModelAttributeConfig(config, viewAttributeKeyToCopy = null) {
    const defaultModelValue = viewAttributeKeyToCopy === null ? true : (viewElement)=>viewElement.getAttribute(viewAttributeKeyToCopy);
    config.model = {
        key: typeof config.model != "object" ? config.model : config.model.key,
        value: typeof config.model != "object" || typeof config.model.value == "undefined" ? defaultModelValue : config.model.value
    };
}
/**
* Helper for to-model-attribute conversion. Takes the model attribute name and conversion configuration and returns
* a proper converter function.
*
* @param config Conversion configuration. It is possible to provide multiple configurations in an array.
* @param shallow If set to `true` the attribute will be set only on top-level nodes. Otherwise, it will be set
* on all elements in the range.
*/ function $b9b9f2bdf9c6137f$var$prepareToAttributeConverter(config, shallow) {
    const matcher = new $b9b9f2bdf9c6137f$export$20214574ec94167d(config.view);
    return (evt, data, conversionApi)=>{
        if (!data.modelRange && shallow) return;
        const match = matcher.match(data.viewItem);
        if (!match) return;
        if ($b9b9f2bdf9c6137f$var$onlyViewNameIsDefined(config.view, data.viewItem)) match.match.name = true;
        else delete match.match.name;
        if (!conversionApi.consumable.test(data.viewItem, match.match)) return;
        const modelKey = config.model.key;
        const modelValue = typeof config.model.value == "function" ? config.model.value(data.viewItem, conversionApi, data) : config.model.value;
        if (modelValue === null || modelValue === void 0) return;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        if ($b9b9f2bdf9c6137f$var$setAttributeOn(data.modelRange, {
            key: modelKey,
            value: modelValue
        }, shallow, conversionApi)) {
            if (conversionApi.consumable.test(data.viewItem, {
                name: true
            })) match.match.name = true;
            conversionApi.consumable.consume(data.viewItem, match.match);
        }
    };
}
/**
* Helper function that checks if element name should be consumed in attribute converters.
*
* @param viewConfig Conversion view config.
*/ function $b9b9f2bdf9c6137f$var$onlyViewNameIsDefined(viewConfig, viewItem) {
    const configToTest = typeof viewConfig == "function" ? viewConfig(viewItem) : viewConfig;
    if (typeof configToTest == "object" && !$b9b9f2bdf9c6137f$var$getViewElementNameFromConfig(configToTest)) return false;
    return !configToTest.classes && !configToTest.attributes && !configToTest.styles;
}
/**
* Helper function for to-model-attribute converter. Sets model attribute on given range.
* Checks {@link module:engine/model/schema~ModelSchema} to ensure proper model structure.
*
* If any node on the given range has already defined an attribute with the same name, its value will not be updated.
*
* @param modelRange Model range on which attribute should be set.
* @param modelAttribute Model attribute to set.
* @param conversionApi Conversion API.
* @param shallow If set to `true` the attribute will be set only on top-level nodes. Otherwise, it will be set
* on all elements in the range.
* @returns `true` if attribute was set on at least one node from given `modelRange`.
*/ function $b9b9f2bdf9c6137f$var$setAttributeOn(modelRange, modelAttribute, shallow, conversionApi) {
    let result = false;
    for (const node of Array.from(modelRange.getItems({
        shallow: shallow
    }))){
        if (!conversionApi.schema.checkAttribute(node, modelAttribute.key)) continue;
        result = true;
        if (node.hasAttribute(modelAttribute.key)) continue;
        conversionApi.writer.setAttribute(modelAttribute.key, modelAttribute.value, node);
    }
    return result;
}
/**
* Helper function for upcasting-to-marker conversion. Takes the config in a format requested by `upcastElementToMarker()`
* function and converts it to a format that is supported by `upcastElementToElement()` function.
*/ function $b9b9f2bdf9c6137f$var$normalizeElementToMarkerModelConfig(model) {
    return (viewElement, conversionApi)=>{
        const markerName = typeof model == "string" ? model : model(viewElement, conversionApi);
        return conversionApi.writer.createElement("$marker", {
            "data-name": markerName
        });
    };
}
/**
* Helper function for upcasting-to-marker conversion. Takes the config in a format requested by `upcastDataToMarker()`
* function and converts it to a format that is supported by `upcastElementToElement()` function.
*/ function $b9b9f2bdf9c6137f$var$normalizeDataToMarkerConfig(config, type) {
    const elementCreatorFunction = (viewElement, conversionApi)=>{
        const viewName = viewElement.getAttribute("name");
        const markerName = config.model(viewName, conversionApi);
        return conversionApi.writer.createElement("$marker", {
            "data-name": markerName
        });
    };
    return {
        view: `${config.view}-${type}`,
        model: elementCreatorFunction
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/controller/editingcontroller
*/ const $b9b9f2bdf9c6137f$var$EditingControllerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* A controller for the editing pipeline. The editing pipeline controls the {@link ~EditingController#model model} rendering,
* including selection handling. It also creates the {@link ~EditingController#view view} which builds a
* browser-independent virtualization over the DOM elements. The editing controller also attaches default converters.
*/ var $b9b9f2bdf9c6137f$export$fc8cb26747d0035c = class extends $b9b9f2bdf9c6137f$var$EditingControllerBase {
    /**
	* Editor model.
	*/ model;
    /**
	* Editing view controller.
	*/ view;
    /**
	* A mapper that describes the model-view binding.
	*/ mapper;
    /**
	* Downcast dispatcher that converts changes from the model to the {@link #view editing view}.
	*/ downcastDispatcher;
    /**
	* Creates an editing controller instance.
	*
	* @param model Editing model.
	* @param stylesProcessor The styles processor instance.
	*/ constructor(model, stylesProcessor){
        super();
        this.model = model;
        this.view = new $b9b9f2bdf9c6137f$export$4ffdc5ea4ff36c8d(stylesProcessor);
        this.mapper = new $b9b9f2bdf9c6137f$export$ef5ccc0a8fc5a06c();
        this.downcastDispatcher = new $b9b9f2bdf9c6137f$export$a3db87c8d34df7e7({
            mapper: this.mapper,
            schema: model.schema
        });
        const doc = this.model.document;
        const selection = doc.selection;
        const markers = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", ()=>{
            this.view._disableRendering(true);
        }, {
            priority: "highest"
        });
        this.listenTo(this.model, "_afterChanges", ()=>{
            this.view._disableRendering(false);
        }, {
            priority: "lowest"
        });
        this.listenTo(doc, "change", ()=>{
            this.view.change((writer)=>{
                this.downcastDispatcher.convertChanges(doc.differ, markers, writer);
                this.downcastDispatcher.convertSelection(selection, markers, writer);
            });
        }, {
            priority: "low"
        });
        this.listenTo(this.view.document, "selectionChange", $b9b9f2bdf9c6137f$export$19f53eb20fc080f0(this.model, this.mapper));
        this.downcastDispatcher.on("insert:$text", $b9b9f2bdf9c6137f$export$45ce91c8ab754ab7(), {
            priority: "lowest"
        });
        this.downcastDispatcher.on("insert", $b9b9f2bdf9c6137f$export$f67751480ebc37c(), {
            priority: "lowest"
        });
        this.downcastDispatcher.on("remove", $b9b9f2bdf9c6137f$export$f83769e5e3df9387(), {
            priority: "low"
        });
        this.downcastDispatcher.on("cleanSelection", $b9b9f2bdf9c6137f$export$e49a4d261c3abb06());
        this.downcastDispatcher.on("selection", $b9b9f2bdf9c6137f$export$4bf288faba1f60fa(), {
            priority: "low"
        });
        this.downcastDispatcher.on("selection", $b9b9f2bdf9c6137f$export$d9fb6c173d870a4c(), {
            priority: "low"
        });
        this.view.document.roots.bindTo(this.model.document.roots).using((root)=>{
            if (root.rootName == "$graveyard") return null;
            const viewRoot = new $b9b9f2bdf9c6137f$export$a8813c6865859ce(this.view.document, root.name);
            viewRoot.rootName = root.rootName;
            this.mapper.bindElements(root, viewRoot);
            return viewRoot;
        });
    }
    /**
	* Removes all event listeners attached to the `EditingController`. Destroys all objects created
	* by `EditingController` that need to be destroyed.
	*/ destroy() {
        this.view.destroy();
        this.stopListening();
    }
    /**
	* Calling this method will refresh the marker by triggering the downcast conversion for it.
	*
	* Reconverting the marker is useful when you want to change its {@link module:engine/view/element~ViewElement view element}
	* without changing any marker data. For instance:
	*
	* ```ts
	* let isCommentActive = false;
	*
	* model.conversion.markerToHighlight( {
	* 	model: 'comment',
	* 	view: data => {
	* 		const classes = [ 'comment-marker' ];
	*
	* 		if ( isCommentActive ) {
	* 			classes.push( 'comment-marker--active' );
	* 		}
	*
	* 		return { classes };
	* 	}
	* } );
	*
	* // ...
	*
	* // Change the property that indicates if marker is displayed as active or not.
	* isCommentActive = true;
	*
	* // Reconverting will downcast and synchronize the marker with the new isCommentActive state value.
	* editor.editing.reconvertMarker( 'comment' );
	* ```
	*
	* **Note**: If you want to reconvert a model item, use {@link #reconvertItem} instead.
	*
	* @param markerOrName Name of a marker to update, or a marker instance.
	*/ reconvertMarker(markerOrName) {
        const markerName = typeof markerOrName == "string" ? markerOrName : markerOrName.name;
        const currentMarker = this.model.markers.get(markerName);
        if (!currentMarker) /**
		* The marker with the provided name does not exist and cannot be reconverted.
		*
		* @error editingcontroller-reconvertmarker-marker-not-exist
		* @param {string} markerName The name of the reconverted marker.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editingcontroller-reconvertmarker-marker-not-exist", this, {
            markerName: markerName
        });
        this.model.change(()=>{
            this.model.markers._refresh(currentMarker);
        });
    }
    /**
	* Calling this method will downcast a model item on demand (by requesting a refresh in the {@link module:engine/model/differ~Differ}).
	*
	* You can use it if you want the view representation of a specific item updated as a response to external modifications. For instance,
	* when the view structure depends not only on the associated model data but also on some external state.
	*
	* **Note**: If you want to reconvert a model marker, use {@link #reconvertMarker} instead.
	*
	* @param item Item to refresh.
	*/ reconvertItem(item) {
        this.model.change(()=>{
            this.model.document.differ._refreshItem(item);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/schema
*/ const $b9b9f2bdf9c6137f$var$ModelSchemaBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The model's schema. It defines the allowed and disallowed structures of nodes as well as nodes' attributes.
* The schema is usually defined by the features and based on them, the editing framework and features
* make decisions on how to change and process the model.
*
* The instance of schema is available in {@link module:engine/model/model~Model#schema `editor.model.schema`}.
*
* Read more about the schema in:
*
* * The {@glink framework/architecture/editing-engine#schema schema section} of the
* {@glink framework/architecture/editing-engine Introduction to the Editing engine architecture} guide.
* * The {@glink framework/deep-dive/schema Schema deep-dive} guide.
*/ var $b9b9f2bdf9c6137f$export$1f5e8c4238f1bbae = class extends $b9b9f2bdf9c6137f$var$ModelSchemaBase {
    _sourceDefinitions = {};
    /**
	* A dictionary containing attribute properties.
	*/ _attributeProperties = Object.create(null);
    /**
	* Stores additional callbacks registered for schema items, which are evaluated when {@link ~ModelSchema#checkChild} is called.
	*
	* Keys are schema item names for which the callbacks are registered. Values are arrays with the callbacks.
	*
	* Some checks are added under {@link ~ModelSchema#_genericCheckSymbol} key, these are
	* evaluated for every {@link ~ModelSchema#checkChild} call.
	*/ _customChildChecks = /* @__PURE__ */ new Map();
    /**
	* Stores additional callbacks registered for attribute names, which are evaluated when {@link ~ModelSchema#checkAttribute} is called.
	*
	* Keys are schema attribute names for which the callbacks are registered. Values are arrays with the callbacks.
	*
	* Some checks are added under {@link ~ModelSchema#_genericCheckSymbol} key, these are evaluated for every
	* {@link ~ModelSchema#checkAttribute} call.
	*/ _customAttributeChecks = /* @__PURE__ */ new Map();
    _genericCheckSymbol = Symbol("$generic");
    _compiledDefinitions;
    /**
	* Creates a schema instance.
	*/ constructor(){
        super();
        this.decorate("checkChild");
        this.decorate("checkAttribute");
        this.on("checkAttribute", (evt, args)=>{
            args[0] = new $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a(args[0]);
        }, {
            priority: "highest"
        });
        this.on("checkChild", (evt, args)=>{
            args[0] = new $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a(args[0]);
            args[1] = this.getDefinition(args[1]);
        }, {
            priority: "highest"
        });
    }
    /**
	* Registers a schema item. Can only be called once for every item name.
	*
	* ```ts
	* schema.register( 'paragraph', {
	* 	inheritAllFrom: '$block'
	* } );
	* ```
	*/ register(itemName, definition) {
        if (this._sourceDefinitions[itemName]) /**
		* A single item cannot be registered twice in the schema.
		*
		* This situation may happen when:
		*
		* * Two or more plugins called {@link module:engine/model/schema~ModelSchema#register `register()`} with the same name.
		* This will usually mean that there is a collision between plugins which try to use the same element in the model.
		* Unfortunately, the only way to solve this is by modifying one of these plugins to use a unique model element name.
		* * A single plugin was loaded twice. This happens when it is installed by npm/yarn in two versions
		* and usually means one or more of the following issues:
		*     * a version mismatch (two of your dependencies require two different versions of this plugin),
		*     * incorrect imports (this plugin is somehow imported twice in a way which confuses webpack),
		*     * mess in `node_modules/` (`rm -rf node_modules/` may help).
		*
		* **Note:** Check the logged `itemName` to better understand which plugin was duplicated/conflicting.
		*
		* @param itemName The name of the model element that is being registered twice.
		* @error schema-cannot-register-item-twice
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("schema-cannot-register-item-twice", this, {
            itemName: itemName
        });
        this._sourceDefinitions[itemName] = [
            Object.assign({}, definition)
        ];
        this._clearCache();
    }
    /**
	* Extends a {@link #register registered} item's definition.
	*
	* Extending properties such as `allowIn` will add more items to the existing properties,
	* while redefining properties such as `isBlock` will override the previously defined ones.
	*
	* ```ts
	* schema.register( 'foo', {
	* 	allowIn: '$root',
	* 	isBlock: true;
	* } );
	* schema.extend( 'foo', {
	* 	allowIn: 'blockQuote',
	* 	isBlock: false
	* } );
	*
	* schema.getDefinition( 'foo' );
	* //	{
	* //		allowIn: [ '$root', 'blockQuote' ],
	* // 		isBlock: false
	* //	}
	* ```
	*/ extend(itemName, definition) {
        if (!this._sourceDefinitions[itemName]) /**
		* Cannot extend an item which was not registered yet.
		*
		* This error happens when a plugin tries to extend the schema definition of an item which was not
		* {@link module:engine/model/schema~ModelSchema#register registered} yet.
		*
		* @param itemName The name of the model element which is being extended.
		* @error schema-cannot-extend-missing-item
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("schema-cannot-extend-missing-item", this, {
            itemName: itemName
        });
        this._sourceDefinitions[itemName].push(Object.assign({}, definition));
        this._clearCache();
    }
    /**
	* Returns data of all registered items.
	*
	* This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
	* checking a list of all block elements, etc).
	* Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
	* in other cases.
	*/ getDefinitions() {
        if (!this._compiledDefinitions) this._compile();
        return this._compiledDefinitions;
    }
    /**
	* Returns a definition of the given item or `undefined` if an item is not registered.
	*
	* This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
	* checking a list of all block elements, etc).
	* Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
	* in other cases.
	*/ getDefinition(item) {
        let itemName;
        if (typeof item == "string") itemName = item;
        else if ("is" in item && (item.is("$text") || item.is("$textProxy"))) itemName = "$text";
        else itemName = item.name;
        return this.getDefinitions()[itemName];
    }
    /**
	* Returns `true` if the given item is registered in the schema.
	*
	* ```ts
	* schema.isRegistered( 'paragraph' ); // -> true
	* schema.isRegistered( editor.model.document.getRoot() ); // -> true
	* schema.isRegistered( 'foo' ); // -> false
	* ```
	*/ isRegistered(item) {
        return !!this.getDefinition(item);
    }
    /**
	* Returns `true` if the given item is defined to be
	* a block by the {@link module:engine/model/schema~ModelSchemaItemDefinition}'s `isBlock` property.
	*
	* ```ts
	* schema.isBlock( 'paragraph' ); // -> true
	* schema.isBlock( '$root' ); // -> false
	*
	* const paragraphElement = writer.createElement( 'paragraph' );
	* schema.isBlock( paragraphElement ); // -> true
	* ```
	*
	* See the {@glink framework/deep-dive/schema#block-elements Block elements} section of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isBlock(item) {
        const def = this.getDefinition(item);
        return !!(def && def.isBlock);
    }
    /**
	* Returns `true` if the given item should be treated as a limit element.
	*
	* It considers an item to be a limit element if its
	* {@link module:engine/model/schema~ModelSchemaItemDefinition}'s
	* {@link module:engine/model/schema~ModelSchemaItemDefinition#isLimit `isLimit`} or
	* {@link module:engine/model/schema~ModelSchemaItemDefinition#isObject `isObject`} property
	* was set to `true`.
	*
	* ```ts
	* schema.isLimit( 'paragraph' ); // -> false
	* schema.isLimit( '$root' ); // -> true
	* schema.isLimit( editor.model.document.getRoot() ); // -> true
	* schema.isLimit( 'imageBlock' ); // -> true
	* ```
	*
	* See the {@glink framework/deep-dive/schema#limit-elements Limit elements} section of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isLimit(item) {
        const def = this.getDefinition(item);
        if (!def) return false;
        return !!(def.isLimit || def.isObject);
    }
    /**
	* Returns `true` if the given item should be treated as an object element.
	*
	* It considers an item to be an object element if its
	* {@link module:engine/model/schema~ModelSchemaItemDefinition}'s
	* {@link module:engine/model/schema~ModelSchemaItemDefinition#isObject `isObject`} property
	* was set to `true`.
	*
	* ```ts
	* schema.isObject( 'paragraph' ); // -> false
	* schema.isObject( 'imageBlock' ); // -> true
	*
	* const imageElement = writer.createElement( 'imageBlock' );
	* schema.isObject( imageElement ); // -> true
	* ```
	*
	* See the {@glink framework/deep-dive/schema#object-elements Object elements} section of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isObject(item) {
        const def = this.getDefinition(item);
        if (!def) return false;
        return !!(def.isObject || def.isLimit && def.isSelectable && def.isContent);
    }
    /**
	* Returns `true` if the given item is defined to be
	* an inline element by the {@link module:engine/model/schema~ModelSchemaItemDefinition}'s `isInline` property.
	*
	* ```ts
	* schema.isInline( 'paragraph' ); // -> false
	* schema.isInline( 'softBreak' ); // -> true
	*
	* const text = writer.createText( 'foo' );
	* schema.isInline( text ); // -> true
	* ```
	*
	* See the {@glink framework/deep-dive/schema#inline-elements Inline elements} section of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isInline(item) {
        const def = this.getDefinition(item);
        return !!(def && def.isInline);
    }
    /**
	* Returns `true` if the given item is defined to be
	* a selectable element by the {@link module:engine/model/schema~ModelSchemaItemDefinition}'s `isSelectable` property.
	*
	* ```ts
	* schema.isSelectable( 'paragraph' ); // -> false
	* schema.isSelectable( 'heading1' ); // -> false
	* schema.isSelectable( 'imageBlock' ); // -> true
	* schema.isSelectable( 'tableCell' ); // -> true
	*
	* const text = writer.createText( 'foo' );
	* schema.isSelectable( text ); // -> false
	* ```
	*
	* See the {@glink framework/deep-dive/schema#selectable-elements Selectable elements section} of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isSelectable(item) {
        const def = this.getDefinition(item);
        if (!def) return false;
        return !!(def.isSelectable || def.isObject);
    }
    /**
	* Returns `true` if the given item is defined to be
	* a content by the {@link module:engine/model/schema~ModelSchemaItemDefinition}'s `isContent` property.
	*
	* ```ts
	* schema.isContent( 'paragraph' ); // -> false
	* schema.isContent( 'heading1' ); // -> false
	* schema.isContent( 'imageBlock' ); // -> true
	* schema.isContent( 'horizontalLine' ); // -> true
	*
	* const text = writer.createText( 'foo' );
	* schema.isContent( text ); // -> true
	* ```
	*
	* See the {@glink framework/deep-dive/schema#content-elements Content elements section} of
	* the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ isContent(item) {
        const def = this.getDefinition(item);
        if (!def) return false;
        return !!(def.isContent || def.isObject);
    }
    /**
	* Checks whether the given node can be a child of the given context.
	*
	* ```ts
	* schema.checkChild( model.document.getRoot(), paragraph ); // -> false
	*
	* schema.register( 'paragraph', {
	* 	allowIn: '$root'
	* } );
	*
	* schema.checkChild( model.document.getRoot(), paragraph ); // -> true
	* ```
	*
	* Both {@link module:engine/model/schema~ModelSchema#addChildCheck callback checks} and declarative rules (added when
	* {@link module:engine/model/schema~ModelSchema#register registering} and
	* {@link module:engine/model/schema~ModelSchema#extend extending} items)
	* are evaluated when this method is called.
	*
	* Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
	*
	* Note that when verifying whether the given node can be a child of the given context, the schema also verifies the entire
	* context &ndash; from its root to its last element. Therefore, it is possible for `checkChild()` to return `false` even though
	* the `context` last element can contain the checked child. It happens if one of the `context` elements does not allow its child.
	* When `context` is verified, {@link module:engine/model/schema~ModelSchema#addChildCheck custom checks} are considered as well.
	*
	* @fires checkChild
	* @param context The context in which the child will be checked.
	* @param def The child to check.
	*/ checkChild(context, def) {
        if (!def) return false;
        return this._checkContextMatch(context, def);
    }
    /**
	* Checks whether the given attribute can be applied in the given context (on the last item of the context).
	*
	* ```ts
	* schema.checkAttribute( textNode, 'bold' ); // -> false
	*
	* schema.extend( '$text', {
	* 	allowAttributes: 'bold'
	* } );
	*
	* schema.checkAttribute( textNode, 'bold' ); // -> true
	* ```
	*
	* Both {@link module:engine/model/schema~ModelSchema#addAttributeCheck callback checks} and declarative rules (added when
	* {@link module:engine/model/schema~ModelSchema#register registering} and
	* {@link module:engine/model/schema~ModelSchema#extend extending} items)
	* are evaluated when this method is called.
	*
	* Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
	*
	* @fires checkAttribute
	* @param context The context in which the attribute will be checked.
	* @param attributeName Name of attribute to check in the given context.
	*/ checkAttribute(context, attributeName) {
        const def = this.getDefinition(context.last);
        if (!def) return false;
        const isAllowed = this._evaluateAttributeChecks(context, attributeName);
        return isAllowed !== void 0 ? isAllowed : def.allowAttributes.includes(attributeName);
    }
    /**
	* Checks whether the given element (`elementToMerge`) can be merged with the specified base element (`positionOrBaseElement`).
	*
	* In other words &ndash; both elements are not a limit elements and whether `elementToMerge`'s children
	* {@link #checkChild are allowed} in the `positionOrBaseElement`.
	*
	* This check ensures that elements merged with {@link module:engine/model/writer~ModelWriter#merge `Writer#merge()`}
	* will be valid.
	*
	* Instead of elements, you can pass the instance of the {@link module:engine/model/position~ModelPosition} class as the
	* `positionOrBaseElement`. It means that the elements before and after the position will be checked whether they can be merged.
	*
	* @param positionOrBaseElement The position or base element to which the `elementToMerge` will be merged.
	* @param elementToMerge The element to merge. Required if `positionOrBaseElement` is an element.
	*/ checkMerge(positionOrBaseElement, elementToMerge) {
        if (positionOrBaseElement instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) {
            const nodeBefore = positionOrBaseElement.nodeBefore;
            const nodeAfter = positionOrBaseElement.nodeAfter;
            if (!(nodeBefore instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
			* The node before the merge position must be an element.
			*
			* @error schema-check-merge-no-element-before
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("schema-check-merge-no-element-before", this);
            if (!(nodeAfter instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
			* The node after the merge position must be an element.
			*
			* @error schema-check-merge-no-element-after
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("schema-check-merge-no-element-after", this);
            return this.checkMerge(nodeBefore, nodeAfter);
        }
        if (this.isLimit(positionOrBaseElement) || this.isLimit(elementToMerge)) return false;
        for (const child of elementToMerge.getChildren())if (!this.checkChild(positionOrBaseElement, child)) return false;
        return true;
    }
    /**
	* Allows registering a callback to the {@link #checkChild} method calls.
	*
	* Callbacks allow you to implement rules which are not otherwise possible to achieve
	* by using the declarative API of {@link module:engine/model/schema~ModelSchemaItemDefinition}.
	*
	* Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
	*
	* For example, by using this method you can disallow elements in specific contexts:
	*
	* ```ts
	* // Disallow `heading1` inside a `blockQuote` that is inside a table.
	* schema.addChildCheck( ( context, childDefinition ) => {
	* 	if ( context.endsWith( 'tableCell blockQuote' ) ) {
	* 		return false;
	* 	}
	* }, 'heading1' );
	* ```
	*
	* You can skip the optional `itemName` parameter to evaluate the callback for every `checkChild()` call.
	*
	* ```ts
	* // Inside specific custom element, allow only children, which allows for a specific attribute.
	* schema.addChildCheck( ( context, childDefinition ) => {
	* 	if ( context.endsWith( 'myElement' ) ) {
	* 		return childDefinition.allowAttributes.includes( 'myAttribute' );
	* 	}
	* } );
	* ```
	*
	* Please note that the generic callbacks may affect the editor performance and should be avoided if possible.
	*
	* When one of the callbacks makes a decision (returns `true` or `false`) the processing is finished and other callbacks are not fired.
	* Callbacks are fired in the order they were added, however generic callbacks are fired before callbacks added for a specified item.
	*
	* You can also use `checkChild` event, if you need even better control. The result from the example above could also be
	* achieved with following event callback:
	*
	* ```ts
	* schema.on( 'checkChild', ( evt, args ) => {
	* 	const context = args[ 0 ];
	* 	const childDefinition = args[ 1 ];
	*
	* 	if ( context.endsWith( 'myElement' ) ) {
	* 		// Prevent next listeners from being called.
	* 		evt.stop();
	* 		// Set the `checkChild()` return value.
	* 		evt.return = childDefinition.allowAttributes.includes( 'myAttribute' );
	* 	}
	* }, { priority: 'high' } );
	* ```
	*
	* Note that the callback checks and declarative rules checks are processed on `normal` priority.
	*
	* Adding callbacks this way can also negatively impact editor performance.
	*
	* @param callback The callback to be called. It is called with two parameters:
	* {@link module:engine/model/schema~ModelSchemaContext} (context) instance and
	* {@link module:engine/model/schema~ModelSchemaCompiledItemDefinition} (definition). The callback may return `true/false` to
	* override `checkChild()`'s return value. If it does not return a boolean value, the default algorithm (or other callbacks) will define
	* `checkChild()`'s return value.
	* @param itemName Name of the schema item for which the callback is registered. If specified, the callback will be run only for
	* `checkChild()` calls which `def` parameter matches the `itemName`. Otherwise, the callback will run for every `checkChild` call.
	*/ addChildCheck(callback, itemName) {
        const key = itemName !== void 0 ? itemName : this._genericCheckSymbol;
        const checks = this._customChildChecks.get(key) || [];
        checks.push(callback);
        this._customChildChecks.set(key, checks);
    }
    /**
	* Allows registering a callback to the {@link #checkAttribute} method calls.
	*
	* Callbacks allow you to implement rules which are not otherwise possible to achieve
	* by using the declarative API of {@link module:engine/model/schema~ModelSchemaItemDefinition}.
	*
	* Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
	*
	* For example, by using this method you can disallow setting attributes on nodes in specific contexts:
	*
	* ```ts
	* // Disallow setting `bold` on text inside `heading1` element:
	* schema.addAttributeCheck( context => {
	* 	if ( context.endsWith( 'heading1 $text' ) ) {
	* 		return false;
	* 	}
	* }, 'bold' );
	* ```
	*
	* You can skip the optional `attributeName` parameter to evaluate the callback for every `checkAttribute()` call.
	*
	* ```ts
	* // Disallow formatting attributes on text inside custom `myTitle` element:
	* schema.addAttributeCheck( ( context, attributeName ) => {
	* 	if ( context.endsWith( 'myTitle $text' ) && schema.getAttributeProperties( attributeName ).isFormatting ) {
	* 		return false;
	* 	}
	* } );
	* ```
	*
	* Please note that the generic callbacks may affect the editor performance and should be avoided if possible.
	*
	* When one of the callbacks makes a decision (returns `true` or `false`) the processing is finished and other callbacks are not fired.
	* Callbacks are fired in the order they were added, however generic callbacks are fired before callbacks added for a specified item.
	*
	* You can also use {@link #event:checkAttribute} event, if you need even better control. The result from the example above could also
	* be achieved with following event callback:
	*
	* ```ts
	* schema.on( 'checkAttribute', ( evt, args ) => {
	* 	const context = args[ 0 ];
	* 	const attributeName = args[ 1 ];
	*
	* 	if ( context.endsWith( 'myTitle $text' ) && schema.getAttributeProperties( attributeName ).isFormatting ) {
	* 		// Prevent next listeners from being called.
	* 		evt.stop();
	* 		// Set the `checkAttribute()` return value.
	* 		evt.return = false;
	* 	}
	* }, { priority: 'high' } );
	* ```
	*
	* Note that the callback checks and declarative rules checks are processed on `normal` priority.
	*
	* Adding callbacks this way can also negatively impact editor performance.
	*
	* @param callback The callback to be called. It is called with two parameters:
	* {@link module:engine/model/schema~ModelSchemaContext `context`} and attribute name. The callback may return `true` or `false`, to
	* override `checkAttribute()`'s return value. If it does not return a boolean value, the default algorithm (or other callbacks)
	* will define `checkAttribute()`'s return value.
	* @param attributeName Name of the attribute for which the callback is registered. If specified, the callback will be run only for
	* `checkAttribute()` calls with matching `attributeName`. Otherwise, the callback will run for every `checkAttribute()` call.
	*/ addAttributeCheck(callback, attributeName) {
        const key = attributeName !== void 0 ? attributeName : this._genericCheckSymbol;
        const checks = this._customAttributeChecks.get(key) || [];
        checks.push(callback);
        this._customAttributeChecks.set(key, checks);
    }
    /**
	* This method allows assigning additional metadata to the model attributes. For example,
	* {@link module:engine/model/schema~ModelAttributeProperties `AttributeProperties#isFormatting` property} is
	* used to mark formatting attributes (like `bold` or `italic`).
	*
	* ```ts
	* // Mark bold as a formatting attribute.
	* schema.setAttributeProperties( 'bold', {
	* 	isFormatting: true
	* } );
	*
	* // Override code not to be considered a formatting markup.
	* schema.setAttributeProperties( 'code', {
	* 	isFormatting: false
	* } );
	* ```
	*
	* Properties are not limited to members defined in the
	* {@link module:engine/model/schema~ModelAttributeProperties `AttributeProperties` type} and you can also use custom properties:
	*
	* ```ts
	* schema.setAttributeProperties( 'blockQuote', {
	* 	customProperty: 'value'
	* } );
	* ```
	*
	* Subsequent calls with the same attribute will extend its custom properties:
	*
	* ```ts
	* schema.setAttributeProperties( 'blockQuote', {
	* 	one: 1
	* } );
	*
	* schema.setAttributeProperties( 'blockQuote', {
	* 	two: 2
	* } );
	*
	* console.log( schema.getAttributeProperties( 'blockQuote' ) );
	* // Logs: { one: 1, two: 2 }
	* ```
	*
	* @param attributeName A name of the attribute to receive the properties.
	* @param properties A dictionary of properties.
	*/ setAttributeProperties(attributeName, properties) {
        this._attributeProperties[attributeName] = Object.assign(this.getAttributeProperties(attributeName), properties);
    }
    /**
	* Returns properties associated with a given model attribute. See {@link #setAttributeProperties `setAttributeProperties()`}.
	*
	* @param attributeName A name of the attribute.
	*/ getAttributeProperties(attributeName) {
        return this._attributeProperties[attributeName] || Object.create(null);
    }
    /**
	* Returns the lowest {@link module:engine/model/schema~ModelSchema#isLimit limit element} containing the entire
	* selection/range/position or the root otherwise.
	*
	* @param selectionOrRangeOrPosition The selection/range/position to check.
	* @returns The lowest limit element containing the entire `selectionOrRangeOrPosition`.
	*/ getLimitElement(selectionOrRangeOrPosition) {
        let element;
        if (selectionOrRangeOrPosition instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) element = selectionOrRangeOrPosition.parent;
        else element = (selectionOrRangeOrPosition instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba ? [
            selectionOrRangeOrPosition
        ] : Array.from(selectionOrRangeOrPosition.getRanges())).reduce((element, range)=>{
            const rangeCommonAncestor = range.getCommonAncestor();
            if (!element) return rangeCommonAncestor;
            return element.getCommonAncestor(rangeCommonAncestor, {
                includeSelf: true
            });
        }, null);
        while(!this.isLimit(element))if (element.parent) element = element.parent;
        else break;
        return element;
    }
    /**
	* Checks whether the attribute is allowed in selection:
	*
	* * if the selection is not collapsed, then checks if the attribute is allowed on any of nodes in that range,
	* * if the selection is collapsed, then checks if on the selection position there's a text with the
	* specified attribute allowed.
	*
	* @param selection Selection which will be checked.
	* @param attribute The name of the attribute to check.
	*/ checkAttributeInSelection(selection, attribute) {
        if (selection.isCollapsed) {
            const context = [
                ...selection.getFirstPosition().getAncestors(),
                new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5("", selection.getAttributes())
            ];
            return this.checkAttribute(context, attribute);
        } else {
            const ranges = selection.getRanges();
            for (const range of ranges)for (const value of range)if (this.checkAttribute(value.item, attribute)) return true;
        }
        return false;
    }
    /**
	* Transforms the given set of ranges into a set of ranges where the given attribute is allowed (and can be applied).
	*
	* @param ranges Ranges to be validated.
	* @param attribute The name of the attribute to check.
	* @param options Optional configuration.
	* @param options.includeEmptyRanges When `true`, empty ranges that allow the attribute are also included
	* in the returned ranges.
	* @returns Ranges in which the attribute is allowed.
	*/ *getValidRanges(ranges, attribute, options = {}) {
        ranges = $b9b9f2bdf9c6137f$var$convertToMinimalFlatRanges(ranges);
        for (const range of ranges)yield* this._getValidRangesForRange(range, attribute, options);
    }
    /**
	* Basing on given `position`, finds and returns a {@link module:engine/model/range~ModelRange range} which is
	* nearest to that `position` and is a correct range for selection.
	*
	* The correct selection range might be collapsed when it is located in a position where the text node can be placed.
	* Non-collapsed range is returned when selection can be placed around element marked as an "object" in
	* the {@link module:engine/model/schema~ModelSchema schema}.
	*
	* Direction of searching for the nearest correct selection range can be specified as:
	*
	* * `both` - searching will be performed in both ways,
	* * `forward` - searching will be performed only forward,
	* * `backward` - searching will be performed only backward.
	*
	* When valid selection range cannot be found, `null` is returned.
	*
	* @param position Reference position where new selection range should be looked for.
	* @param direction Search direction.
	* @returns Nearest selection range or `null` if one cannot be found.
	*/ getNearestSelectionRange(position, direction = "both") {
        if (position.root.rootName == "$graveyard") return null;
        if (this.checkChild(position, "$text")) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(position);
        let backwardWalker, forwardWalker;
        const limitElement = position.getAncestors().reverse().find((item)=>this.isLimit(item)) || position.root;
        if (direction == "both" || direction == "backward") backwardWalker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789({
            boundaries: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(limitElement),
            startPosition: position,
            direction: "backward"
        });
        if (direction == "both" || direction == "forward") forwardWalker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789({
            boundaries: $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(limitElement),
            startPosition: position
        });
        for (const data of $b9b9f2bdf9c6137f$var$combineWalkers(backwardWalker, forwardWalker)){
            const type = data.walker == backwardWalker ? "elementEnd" : "elementStart";
            const value = data.value;
            if (value.type == type && this.isObject(value.item)) return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(value.item);
            if (this.checkChild(value.nextPosition, "$text")) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(value.nextPosition);
        }
        return null;
    }
    /**
	* Tries to find position ancestors that allow to insert a given node.
	* It starts searching from the given position and goes node by node to the top of the model tree
	* as long as a {@link module:engine/model/schema~ModelSchema#isLimit limit element}, an
	* {@link module:engine/model/schema~ModelSchema#isObject object element} or a topmost ancestor is not reached.
	*
	* @param position The position that the search will start from.
	* @param node The node for which an allowed parent should be found or its name.
	* @returns Allowed parent or null if nothing was found.
	*/ findAllowedParent(position, node) {
        let parent = position.parent;
        while(parent){
            if (this.checkChild(parent, node)) return parent;
            if (this.isLimit(parent)) return null;
            parent = parent.parent;
        }
        return null;
    }
    /**
	* Sets attributes allowed by the schema on a given node.
	*
	* @param node A node to set attributes on.
	* @param attributes Attributes keys and values.
	* @param writer An instance of the model writer.
	*/ setAllowedAttributes(node, attributes, writer) {
        const model = writer.model;
        for (const [attributeName, attributeValue] of Object.entries(attributes))if (model.schema.checkAttribute(node, attributeName)) writer.setAttribute(attributeName, attributeValue, node);
    }
    /**
	* Removes attributes disallowed by the schema.
	*
	* @param nodes Nodes that will be filtered.
	*/ removeDisallowedAttributes(nodes, writer) {
        for (const node of nodes)if (node.is("$text")) $b9b9f2bdf9c6137f$var$removeDisallowedAttributeFromNode(this, node, writer);
        else {
            const positionsInRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(node).getPositions();
            for (const position of positionsInRange){
                const item = position.nodeBefore || position.parent;
                $b9b9f2bdf9c6137f$var$removeDisallowedAttributeFromNode(this, item, writer);
            }
        }
    }
    /**
	* Gets attributes of a node that have a given property.
	*
	* @param node Node to get attributes from.
	* @param propertyName Name of the property that attribute must have to return it.
	* @param propertyValue Desired value of the property that we want to check.
	* When `undefined` attributes will be returned if they have set a given property no matter what the value is. If specified it will
	* return attributes which given property's value is equal to this parameter.
	* @returns Object with attributes' names as key and attributes' values as value.
	*/ getAttributesWithProperty(node, propertyName, propertyValue) {
        const attributes = {};
        for (const [attributeName, attributeValue] of node.getAttributes()){
            const attributeProperties = this.getAttributeProperties(attributeName);
            if (attributeProperties[propertyName] === void 0) continue;
            if (propertyValue === void 0 || propertyValue === attributeProperties[propertyName]) attributes[attributeName] = attributeValue;
        }
        return attributes;
    }
    /**
	* Creates an instance of the schema context.
	*/ createContext(context) {
        return new $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a(context);
    }
    _clearCache() {
        this._compiledDefinitions = null;
    }
    _compile() {
        const definitions = {};
        const sourceRules = this._sourceDefinitions;
        const itemNames = Object.keys(sourceRules);
        for (const itemName of itemNames)definitions[itemName] = $b9b9f2bdf9c6137f$var$compileBaseItemRule(sourceRules[itemName], itemName);
        const items = Object.values(definitions);
        for (const item of items){
            $b9b9f2bdf9c6137f$var$propagateAllowIn(definitions, item);
            $b9b9f2bdf9c6137f$var$propagateAllowChildren(definitions, item);
            $b9b9f2bdf9c6137f$var$propagateDisallowIn(definitions, item);
            $b9b9f2bdf9c6137f$var$propagateDisallowChildren(definitions, item);
        }
        for (const item of items)$b9b9f2bdf9c6137f$var$resolveDisallows(definitions, item);
        for (const item of items)$b9b9f2bdf9c6137f$var$compileAllowContentOf(definitions, item);
        for (const item of items)$b9b9f2bdf9c6137f$var$compileAllowWhere(definitions, item);
        for (const item of items)$b9b9f2bdf9c6137f$var$compileAllowAttributesOf(definitions, item);
        for (const item of items)$b9b9f2bdf9c6137f$var$compileInheritPropertiesFrom(definitions, item);
        this._compiledDefinitions = $b9b9f2bdf9c6137f$var$compileDefinitions(definitions);
    }
    _checkContextMatch(context, def) {
        const parentItem = context.last;
        let isAllowed = this._evaluateChildChecks(context, def);
        isAllowed = isAllowed !== void 0 ? isAllowed : def.allowIn.includes(parentItem.name);
        if (!isAllowed) return false;
        const parentItemDefinition = this.getDefinition(parentItem);
        const parentContext = context.trimLast();
        if (!parentItemDefinition) return false;
        if (parentContext.length == 0) return true;
        return this._checkContextMatch(parentContext, parentItemDefinition);
    }
    /**
	* Calls child check callbacks to decide whether `def` is allowed in `context`. It uses both generic and specific (defined for `def`
	* item) callbacks. If neither callback makes a decision, `undefined` is returned.
	*
	* Note that the first callback that makes a decision "wins", i.e., if any callback returns `true` or `false`, then the processing
	* is over and that result is returned.
	*/ _evaluateChildChecks(context, def) {
        const genericChecks = this._customChildChecks.get(this._genericCheckSymbol) || [];
        const childChecks = this._customChildChecks.get(def.name) || [];
        for (const check of [
            ...genericChecks,
            ...childChecks
        ]){
            const result = check(context, def);
            if (result !== void 0) return result;
        }
    }
    /**
	* Calls attribute check callbacks to decide whether `attributeName` can be set on the last element of `context`. It uses both
	* generic and specific (defined for `attributeName`) callbacks. If neither callback makes a decision, `undefined` is returned.
	*
	* Note that the first callback that makes a decision "wins", i.e., if any callback returns `true` or `false`, then the processing
	* is over and that result is returned.
	*/ _evaluateAttributeChecks(context, attributeName) {
        const genericChecks = this._customAttributeChecks.get(this._genericCheckSymbol) || [];
        const childChecks = this._customAttributeChecks.get(attributeName) || [];
        for (const check of [
            ...genericChecks,
            ...childChecks
        ]){
            const result = check(context, attributeName);
            if (result !== void 0) return result;
        }
    }
    /**
	* Takes a flat range and an attribute name. Traverses the range recursively and deeply to find and return all ranges
	* inside the given range on which the attribute can be applied.
	*
	* This is a helper function for {@link ~ModelSchema#getValidRanges}.
	*
	* @param range The range to process.
	* @param attribute The name of the attribute to check.
	* @returns Ranges in which the attribute is allowed.
	*/ *_getValidRangesForRange(range, attribute, options) {
        let start = range.start;
        let end = range.start;
        for (const item of range.getItems({
            shallow: true
        })){
            if (item.is("element")) {
                if (options.includeEmptyRanges && item.isEmpty) {
                    const context = this.createContext(item);
                    if (this.checkChild(context, "$text") && this.checkAttribute(context.push("$text"), attribute)) yield $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(item);
                } else yield* this._getValidRangesForRange($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(item), attribute, options);
            }
            if (!this.checkAttribute(item, attribute)) {
                if (!start.isEqual(end)) yield new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, end);
                start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAfter(item);
            }
            end = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAfter(item);
        }
        if (!start.isEqual(end)) yield new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, end);
    }
    /**
	* Returns a model range which is optimal (in terms of UX) for inserting a widget block.
	*
	* For instance, if a selection is in the middle of a paragraph, the collapsed range before this paragraph
	* will be returned so that it is not split. If the selection is at the end of a paragraph,
	* the collapsed range after this paragraph will be returned.
	*
	* Note: If the selection is placed in an empty block, the range in that block will be returned. If that range
	* is then passed to {@link module:engine/model/model~Model#insertContent}, the block will be fully replaced
	* by the inserted widget block.
	*
	* @internal
	* @param selection The selection based on which the insertion position should be calculated.
	* @param place The place where to look for optimal insertion range.
	* The `auto` value will determine itself the best position for insertion.
	* The `before` value will try to find a position before selection.
	* The `after` value will try to find a position after selection.
	* @returns The optimal range.
	*/ findOptimalInsertionRange(selection, place) {
        const selectedElement = selection.getSelectedElement();
        if (selectedElement && this.isObject(selectedElement) && !this.isInline(selectedElement)) {
            if (place == "before" || place == "after") return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(selectedElement, place));
            return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(selectedElement);
        }
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if (!firstBlock) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(selection.focus);
        if (firstBlock.isEmpty) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(firstBlock, 0));
        const positionAfter = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAfter(firstBlock);
        if (selection.focus.isTouching(positionAfter)) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(positionAfter);
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(firstBlock));
    }
};
/**
* A schema context &ndash; a list of ancestors of a given position in the document.
*
* Considering such position:
*
* ```xml
* <$root>
* 	<blockQuote>
* 		<paragraph>
* 			^
* 		</paragraph>
* 	</blockQuote>
* </$root>
* ```
*
* The context of this position is its {@link module:engine/model/position~ModelPosition#getAncestors lists of ancestors}:
*
*		[ rootElement, blockQuoteElement, paragraphElement ]
*
* Contexts are used in the {@link module:engine/model/schema~ModelSchema#event:checkChild `Schema#checkChild`} and
* {@link module:engine/model/schema~ModelSchema#event:checkAttribute `Schema#checkAttribute`} events as a definition
* of a place in the document where the check occurs. The context instances are created based on the first arguments
* of the {@link module:engine/model/schema~ModelSchema#checkChild `Schema#checkChild()`} and
* {@link module:engine/model/schema~ModelSchema#checkAttribute `Schema#checkAttribute()`} methods so when
* using these methods you need to use {@link module:engine/model/schema~ModelSchemaContextDefinition}s.
*/ var $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a = class ModelSchemaContext {
    _items;
    /**
	* Creates an instance of the context.
	*/ constructor(context){
        if (context instanceof ModelSchemaContext) return context;
        let items;
        if (typeof context == "string") items = [
            context
        ];
        else if (!Array.isArray(context)) items = context.getAncestors({
            includeSelf: true
        });
        else items = context;
        this._items = items.map($b9b9f2bdf9c6137f$var$mapContextItem);
    }
    /**
	* The number of items.
	*/ get length() {
        return this._items.length;
    }
    /**
	* The last item (the lowest node).
	*/ get last() {
        return this._items[this._items.length - 1];
    }
    /**
	* Iterable interface.
	*
	* Iterates over all context items.
	*/ [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
    }
    /**
	* Returns a new schema context instance with an additional item.
	*
	* Item can be added as:
	*
	* ```ts
	* const context = new ModelSchemaContext( [ '$root' ] );
	*
	* // An element.
	* const fooElement = writer.createElement( 'fooElement' );
	* const newContext = context.push( fooElement ); // [ '$root', 'fooElement' ]
	*
	* // A text node.
	* const text = writer.createText( 'foobar' );
	* const newContext = context.push( text ); // [ '$root', '$text' ]
	*
	* // A string (element name).
	* const newContext = context.push( 'barElement' ); // [ '$root', 'barElement' ]
	* ```
	*
	* **Note** {@link module:engine/model/node~ModelNode} that is already in the model tree will be added as the only item
	* (without ancestors).
	*
	* @param item An item that will be added to the current context.
	* @returns A new schema context instance with an additional item.
	*/ push(item) {
        const ctx = new ModelSchemaContext([
            item
        ]);
        ctx._items = [
            ...this._items,
            ...ctx._items
        ];
        return ctx;
    }
    /**
	* Returns a new schema context that is based on this context but has the last item removed.
	*
	* ```ts
	* const ctxParagraph = new ModelSchemaContext( [ '$root', 'blockQuote', 'paragraph' ] );
	* const ctxBlockQuote = ctxParagraph.trimLast(); // Items in `ctxBlockQuote` are: `$root` an `blockQuote`.
	* const ctxRoot = ctxBlockQuote.trimLast(); // Items in `ctxRoot` are: `$root`.
	* ```
	*
	* @returns A new reduced schema context instance.
	*/ trimLast() {
        const ctx = new ModelSchemaContext([]);
        ctx._items = this._items.slice(0, -1);
        return ctx;
    }
    /**
	* Gets an item on the given index.
	*/ getItem(index) {
        return this._items[index];
    }
    /**
	* Returns the names of items.
	*/ *getNames() {
        yield* this._items.map((item)=>item.name);
    }
    /**
	* Checks whether the context ends with the given nodes.
	*
	* ```ts
	* const ctx = new ModelSchemaContext( [ rootElement, paragraphElement, textNode ] );
	*
	* ctx.endsWith( '$text' ); // -> true
	* ctx.endsWith( 'paragraph $text' ); // -> true
	* ctx.endsWith( '$root' ); // -> false
	* ctx.endsWith( 'paragraph' ); // -> false
	* ```
	*/ endsWith(query) {
        return Array.from(this.getNames()).join(" ").endsWith(query);
    }
    /**
	* Checks whether the context starts with the given nodes.
	*
	* ```ts
	* const ctx = new ModelSchemaContext( [ rootElement, paragraphElement, textNode ] );
	*
	* ctx.endsWith( '$root' ); // -> true
	* ctx.endsWith( '$root paragraph' ); // -> true
	* ctx.endsWith( '$text' ); // -> false
	* ctx.endsWith( 'paragraph' ); // -> false
	* ```
	*/ startsWith(query) {
        return Array.from(this.getNames()).join(" ").startsWith(query);
    }
};
function $b9b9f2bdf9c6137f$var$compileBaseItemRule(sourceItemRules, itemName) {
    const itemRule = {
        name: itemName,
        allowIn: /* @__PURE__ */ new Set(),
        allowChildren: /* @__PURE__ */ new Set(),
        disallowIn: /* @__PURE__ */ new Set(),
        disallowChildren: /* @__PURE__ */ new Set(),
        allowContentOf: /* @__PURE__ */ new Set(),
        allowWhere: /* @__PURE__ */ new Set(),
        allowAttributes: /* @__PURE__ */ new Set(),
        disallowAttributes: /* @__PURE__ */ new Set(),
        allowAttributesOf: /* @__PURE__ */ new Set(),
        inheritTypesFrom: /* @__PURE__ */ new Set()
    };
    $b9b9f2bdf9c6137f$var$copyTypes(sourceItemRules, itemRule);
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowIn");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowChildren");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "disallowIn");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "disallowChildren");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowContentOf");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowWhere");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowAttributes");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "disallowAttributes");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "allowAttributesOf");
    $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, "inheritTypesFrom");
    $b9b9f2bdf9c6137f$var$resolveInheritAll(sourceItemRules, itemRule);
    return itemRule;
}
function $b9b9f2bdf9c6137f$var$propagateAllowIn(definitions, item) {
    for (const parentName of item.allowIn){
        const parentItem = definitions[parentName];
        if (parentItem) parentItem.allowChildren.add(item.name);
        else item.allowIn.delete(parentName);
    }
}
function $b9b9f2bdf9c6137f$var$propagateAllowChildren(definitions, item) {
    for (const childName of item.allowChildren){
        const childItem = definitions[childName];
        if (childItem) childItem.allowIn.add(item.name);
        else item.allowChildren.delete(childName);
    }
}
function $b9b9f2bdf9c6137f$var$propagateDisallowIn(definitions, item) {
    for (const parentName of item.disallowIn){
        const parentItem = definitions[parentName];
        if (parentItem) parentItem.disallowChildren.add(item.name);
        else item.disallowIn.delete(parentName);
    }
}
function $b9b9f2bdf9c6137f$var$propagateDisallowChildren(definitions, item) {
    for (const childName of item.disallowChildren){
        const childItem = definitions[childName];
        if (childItem) childItem.disallowIn.add(item.name);
        else item.disallowChildren.delete(childName);
    }
}
function $b9b9f2bdf9c6137f$var$resolveDisallows(definitions, item) {
    for (const childName of item.disallowChildren)item.allowChildren.delete(childName);
    for (const parentName of item.disallowIn)item.allowIn.delete(parentName);
    for (const attributeName of item.disallowAttributes)item.allowAttributes.delete(attributeName);
}
function $b9b9f2bdf9c6137f$var$compileAllowContentOf(definitions, item) {
    for (const allowContentOfItemName of item.allowContentOf){
        const baseItem = definitions[allowContentOfItemName];
        if (!baseItem) continue;
        baseItem.disallowChildren.forEach((childName)=>{
            if (item.allowChildren.has(childName)) return;
            item.disallowChildren.add(childName);
            definitions[childName].disallowIn.add(item.name);
        });
        baseItem.allowChildren.forEach((childName)=>{
            if (item.disallowChildren.has(childName)) return;
            item.allowChildren.add(childName);
            definitions[childName].allowIn.add(item.name);
        });
    }
}
function $b9b9f2bdf9c6137f$var$compileAllowWhere(definitions, item) {
    for (const allowWhereItemName of item.allowWhere){
        const baseItem = definitions[allowWhereItemName];
        if (!baseItem) continue;
        baseItem.disallowIn.forEach((parentName)=>{
            if (item.allowIn.has(parentName)) return;
            item.disallowIn.add(parentName);
            definitions[parentName].disallowChildren.add(item.name);
        });
        baseItem.allowIn.forEach((parentName)=>{
            if (item.disallowIn.has(parentName)) return;
            item.allowIn.add(parentName);
            definitions[parentName].allowChildren.add(item.name);
        });
    }
}
function $b9b9f2bdf9c6137f$var$compileDefinitions(definitions) {
    const finalDefinitions = {};
    for (const item of Object.values(definitions))finalDefinitions[item.name] = {
        name: item.name,
        isBlock: !!item.isBlock,
        isContent: !!item.isContent,
        isInline: !!item.isInline,
        isLimit: !!item.isLimit,
        isObject: !!item.isObject,
        isSelectable: !!item.isSelectable,
        allowIn: Array.from(item.allowIn).filter((name)=>!!definitions[name]),
        allowChildren: Array.from(item.allowChildren).filter((name)=>!!definitions[name]),
        allowAttributes: Array.from(item.allowAttributes)
    };
    return finalDefinitions;
}
function $b9b9f2bdf9c6137f$var$compileAllowAttributesOf(definitions, item) {
    for (const allowAttributeOfItemName of item.allowAttributesOf){
        const baseItem = definitions[allowAttributeOfItemName];
        if (!baseItem) return;
        baseItem.allowAttributes.forEach((attributeName)=>{
            if (item.disallowAttributes.has(attributeName)) return;
            item.allowAttributes.add(attributeName);
        });
    }
}
function $b9b9f2bdf9c6137f$var$compileInheritPropertiesFrom(definitions, item) {
    for (const inheritPropertiesOfItemName of item.inheritTypesFrom){
        const inheritFrom = definitions[inheritPropertiesOfItemName];
        if (inheritFrom) {
            const typeNames = Object.keys(inheritFrom).filter((name)=>name.startsWith("is"));
            for (const name of typeNames)if (!(name in item)) item[name] = inheritFrom[name];
        }
    }
}
function $b9b9f2bdf9c6137f$var$copyTypes(sourceItemRules, itemRule) {
    for (const sourceItemRule of sourceItemRules){
        const typeNames = Object.keys(sourceItemRule).filter((name)=>name.startsWith("is"));
        for (const name of typeNames)itemRule[name] = !!sourceItemRule[name];
    }
}
function $b9b9f2bdf9c6137f$var$copyProperty(sourceItemRules, itemRule, propertyName) {
    for (const sourceItemRule of sourceItemRules){
        let value = sourceItemRule[propertyName];
        if (typeof value == "string") value = [
            value
        ];
        if (Array.isArray(value)) value.forEach((singleValue)=>itemRule[propertyName].add(singleValue));
    }
}
function $b9b9f2bdf9c6137f$var$resolveInheritAll(sourceItemRules, itemRule) {
    for (const sourceItemRule of sourceItemRules){
        const inheritFrom = sourceItemRule.inheritAllFrom;
        if (inheritFrom) {
            itemRule.allowContentOf.add(inheritFrom);
            itemRule.allowWhere.add(inheritFrom);
            itemRule.allowAttributesOf.add(inheritFrom);
            itemRule.inheritTypesFrom.add(inheritFrom);
        }
    }
}
function $b9b9f2bdf9c6137f$var$mapContextItem(ctxItem) {
    if (typeof ctxItem == "string" || ctxItem.is("documentFragment")) return {
        name: typeof ctxItem == "string" ? ctxItem : "$documentFragment",
        *getAttributeKeys () {},
        getAttribute () {}
    };
    else return {
        name: ctxItem.is("element") ? ctxItem.name : "$text",
        *getAttributeKeys () {
            yield* ctxItem.getAttributeKeys();
        },
        getAttribute (key) {
            return ctxItem.getAttribute(key);
        }
    };
}
/**
* Generator function returning values from provided walkers, switching between them at each iteration. If only one walker
* is provided it will return data only from that walker.
*
* @param backward Walker iterating in backward direction.
* @param forward Walker iterating in forward direction.
* @returns Object returned at each iteration contains `value` and `walker` (informing which walker returned
* given value) fields.
*/ function* $b9b9f2bdf9c6137f$var$combineWalkers(backward, forward) {
    let done = false;
    while(!done){
        done = true;
        if (backward) {
            const step = backward.next();
            if (!step.done) {
                done = false;
                yield {
                    walker: backward,
                    value: step.value
                };
            }
        }
        if (forward) {
            const step = forward.next();
            if (!step.done) {
                done = false;
                yield {
                    walker: forward,
                    value: step.value
                };
            }
        }
    }
}
/**
* Takes an array of non-intersecting ranges. For each of them gets minimal flat ranges covering that range and returns
* all those minimal flat ranges.
*
* @param ranges Ranges to process.
* @returns Minimal flat ranges of given `ranges`.
*/ function* $b9b9f2bdf9c6137f$var$convertToMinimalFlatRanges(ranges) {
    for (const range of ranges)yield* range.getMinimalFlatRanges();
}
function $b9b9f2bdf9c6137f$var$removeDisallowedAttributeFromNode(schema, node, writer) {
    for (const attribute of node.getAttributeKeys())if (!schema.checkAttribute(node, attribute)) writer.removeAttribute(attribute, node);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/upcastdispatcher
*/ const $b9b9f2bdf9c6137f$var$UpcastDispatcherBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Upcast dispatcher is a central point of the view-to-model conversion, which is a process of
* converting a given {@link module:engine/view/documentfragment~ViewDocumentFragment view document fragment} or
* {@link module:engine/view/element~ViewElement view element} into a correct model structure.
*
* During the conversion process, the dispatcher fires events for all {@link module:engine/view/node~ViewNode view nodes}
* from the converted view document fragment.
* Special callbacks called "converters" should listen to these events in order to convert the view nodes.
*
* The second parameter of the callback is the `data` object with the following properties:
*
* * `data.viewItem` contains a {@link module:engine/view/node~ViewNode view node} or a
* {@link module:engine/view/documentfragment~ViewDocumentFragment view document fragment}
* that is converted at the moment and might be handled by the callback.
* * `data.modelRange` is used to point to the result
* of the current conversion (e.g. the element that is being inserted)
* and is always a {@link module:engine/model/range~ModelRange} when the conversion succeeds.
* * `data.modelCursor` is a {@link module:engine/model/position~ModelPosition position} on which the converter should insert
* the newly created items.
*
* The third parameter of the callback is an instance of {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi}
* which provides additional tools for converters.
*
* You can read more about conversion in the {@glink framework/deep-dive/conversion/upcast Upcast conversion} guide.
*
* Examples of event-based converters:
*
* ```ts
* // A converter for links (<a>).
* editor.data.upcastDispatcher.on( 'element:a', ( evt, data, conversionApi ) => {
* 	if ( conversionApi.consumable.consume( data.viewItem, { name: true, attributes: [ 'href' ] } ) ) {
* 		// The <a> element is inline and is represented by an attribute in the model.
* 		// This is why you need to convert only children.
* 		const { modelRange } = conversionApi.convertChildren( data.viewItem, data.modelCursor );
*
* 		for ( let item of modelRange.getItems() ) {
* 			if ( conversionApi.schema.checkAttribute( item, 'linkHref' ) ) {
* 				conversionApi.writer.setAttribute( 'linkHref', data.viewItem.getAttribute( 'href' ), item );
* 			}
* 		}
* 	}
* } );
*
* // Convert <p> element's font-size style.
* // Note: You should use a low-priority observer in order to ensure that
* // it is executed after the element-to-element converter.
* editor.data.upcastDispatcher.on( 'element:p', ( evt, data, conversionApi ) => {
* 	const { consumable, schema, writer } = conversionApi;
*
* 	if ( !consumable.consume( data.viewItem, { style: 'font-size' } ) ) {
* 		return;
* 	}
*
* 	const fontSize = data.viewItem.getStyle( 'font-size' );
*
* 	// Do not go for the model element after data.modelCursor because it might happen
* 	// that a single view element was converted to multiple model elements. Get all of them.
* 	for ( const item of data.modelRange.getItems( { shallow: true } ) ) {
* 		if ( schema.checkAttribute( item, 'fontSize' ) ) {
* 			writer.setAttribute( 'fontSize', fontSize, item );
* 		}
* 	}
* }, { priority: 'low' } );
*
* // Convert all elements which have no custom converter into a paragraph (autoparagraphing).
* editor.data.upcastDispatcher.on( 'element', ( evt, data, conversionApi ) => {
* 	// Check if an element can be converted.
* 	if ( !conversionApi.consumable.test( data.viewItem, { name: data.viewItem.name } ) ) {
* 		// When an element is already consumed by higher priority converters, do nothing.
* 		return;
* 	}
*
* 	const paragraph = conversionApi.writer.createElement( 'paragraph' );
*
* 	// Try to safely insert a paragraph at the model cursor - it will find an allowed parent for the current element.
* 	if ( !conversionApi.safeInsert( paragraph, data.modelCursor ) ) {
* 		// When an element was not inserted, it means that you cannot insert a paragraph at this position.
* 		return;
* 	}
*
* 	// Consume the inserted element.
* 	conversionApi.consumable.consume( data.viewItem, { name: data.viewItem.name } ) );
*
* 	// Convert the children to a paragraph.
* 	const { modelRange } = conversionApi.convertChildren( data.viewItem,  paragraph ) );
*
* 	// Update `modelRange` and `modelCursor` in the `data` as a conversion result.
* 	conversionApi.updateConversionResult( paragraph, data );
* }, { priority: 'low' } );
* ```
*
* @fires viewCleanup
* @fires element
* @fires text
* @fires documentFragment
*/ var $b9b9f2bdf9c6137f$export$1f0967356c557e87 = class extends $b9b9f2bdf9c6137f$var$UpcastDispatcherBase {
    /**
	* An interface passed by the dispatcher to the event callbacks.
	*/ conversionApi;
    /**
	* The list of elements that were created during splitting.
	*
	* After the conversion process, the list is cleared.
	*/ _splitParts = /* @__PURE__ */ new Map();
    /**
	* The list of cursor parent elements that were created during splitting.
	*
	* After the conversion process the list is cleared.
	*/ _cursorParents = /* @__PURE__ */ new Map();
    /**
	* The position in the temporary structure where the converted content is inserted. The structure reflects the context of
	* the target position where the content will be inserted. This property is built based on the context parameter of the
	* convert method.
	*/ _modelCursor = null;
    /**
	* The list of elements that were created during the splitting but should not get removed on conversion end even if they are empty.
	*
	* The list is cleared after the conversion process.
	*/ _emptyElementsToKeep = /* @__PURE__ */ new Set();
    /**
	* Creates an upcast dispatcher that operates using the passed API.
	*
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi
	* @param conversionApi Additional properties for an interface that will be passed to events fired
	* by the upcast dispatcher.
	*/ constructor(conversionApi){
        super();
        this.conversionApi = {
            ...conversionApi,
            consumable: null,
            writer: null,
            store: null,
            convertItem: (viewItem, modelCursor)=>this._convertItem(viewItem, modelCursor),
            convertChildren: (viewElement, positionOrElement)=>this._convertChildren(viewElement, positionOrElement),
            safeInsert: (modelNode, position)=>this._safeInsert(modelNode, position),
            updateConversionResult: (modelElement, data)=>this._updateConversionResult(modelElement, data),
            splitToAllowedParent: (modelNode, modelCursor)=>this._splitToAllowedParent(modelNode, modelCursor),
            getSplitParts: (modelElement)=>this._getSplitParts(modelElement),
            keepEmptyElement: (modelElement)=>this._keepEmptyElement(modelElement)
        };
    }
    /**
	* Starts the conversion process. The entry point for the conversion.
	*
	* **Note:** The default `context` value is `[ '$root' ]`, which only matches the generic root. When the editor uses
	* a custom root {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the target
	* {@link module:engine/model/rootelement~ModelRootElement root element} (or its configured model element name)
	* explicitly, otherwise the conversion result may be wrong.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*
	* @fires element
	* @fires text
	* @fires documentFragment
	* @param viewElement The part of the view to be converted.
	* @param writer An instance of the model writer.
	* @param context Elements will be converted according to this context.
	* @returns Model data that is the result of the conversion process
	* wrapped in `DocumentFragment`. Converted marker elements will be set as the document fragment's
	* {@link module:engine/model/documentfragment~ModelDocumentFragment#markers static markers map}.
	*/ convert(viewElement, writer, context = [
        "$root"
    ]) {
        this.fire("viewCleanup", viewElement);
        this._modelCursor = $b9b9f2bdf9c6137f$var$createContextTree(context, writer);
        this.conversionApi.writer = writer;
        this.conversionApi.consumable = $b9b9f2bdf9c6137f$export$39363727173f953f.createFrom(viewElement);
        this.conversionApi.store = {};
        const { modelRange: modelRange } = this._convertItem(viewElement, this._modelCursor);
        const documentFragment = writer.createDocumentFragment();
        if (modelRange) {
            this._removeEmptyElements();
            const parent = this._modelCursor.parent;
            const children = parent._removeChildren(0, parent.childCount);
            documentFragment._insertChild(0, children);
            documentFragment.markers = $b9b9f2bdf9c6137f$var$extractMarkersFromModelFragment(documentFragment, writer);
        }
        this._modelCursor = null;
        this._splitParts.clear();
        this._cursorParents.clear();
        this._emptyElementsToKeep.clear();
        this.conversionApi.writer = null;
        this.conversionApi.store = null;
        return documentFragment;
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#convertItem
	*/ _convertItem(viewItem, modelCursor) {
        const data = {
            viewItem: viewItem,
            modelCursor: modelCursor,
            modelRange: null
        };
        if (viewItem.is("element")) this.fire(`element:${viewItem.name}`, data, this.conversionApi);
        else if (viewItem.is("$text")) this.fire("text", data, this.conversionApi);
        else this.fire("documentFragment", data, this.conversionApi);
        if (data.modelRange && !(data.modelRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba)) /**
		* Incorrect conversion result was dropped.
		*
		* {@link module:engine/model/range~ModelRange Model range} should be a conversion result.
		*
		* @error view-conversion-dispatcher-incorrect-result
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("view-conversion-dispatcher-incorrect-result", this);
        return {
            modelRange: data.modelRange,
            modelCursor: data.modelCursor
        };
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#convertChildren
	*/ _convertChildren(viewItem, elementOrModelCursor) {
        let nextModelCursor = elementOrModelCursor.is("position") ? elementOrModelCursor : $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(elementOrModelCursor, 0);
        const modelRange = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(nextModelCursor);
        for (const viewChild of Array.from(viewItem.getChildren())){
            const result = this._convertItem(viewChild, nextModelCursor);
            if (result.modelRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba) {
                modelRange.end = result.modelRange.end;
                nextModelCursor = result.modelCursor;
            }
        }
        return {
            modelRange: modelRange,
            modelCursor: nextModelCursor
        };
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#safeInsert
	*/ _safeInsert(modelNode, position) {
        const splitResult = this._splitToAllowedParent(modelNode, position);
        if (!splitResult) return false;
        this.conversionApi.writer.insert(modelNode, splitResult.position);
        return true;
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#updateConversionResult
	*/ _updateConversionResult(modelElement, data) {
        const parts = this._getSplitParts(modelElement);
        const writer = this.conversionApi.writer;
        if (!data.modelRange) data.modelRange = writer.createRange(writer.createPositionBefore(modelElement), writer.createPositionAfter(parts[parts.length - 1]));
        const savedCursorParent = this._cursorParents.get(modelElement);
        if (savedCursorParent) data.modelCursor = writer.createPositionAt(savedCursorParent, 0);
        else data.modelCursor = data.modelRange.end;
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#splitToAllowedParent
	*/ _splitToAllowedParent(node, modelCursor) {
        const { schema: schema, writer: writer } = this.conversionApi;
        let allowedParent = schema.findAllowedParent(modelCursor, node);
        if (allowedParent) {
            if (allowedParent === modelCursor.parent) return {
                position: modelCursor
            };
            if (this._modelCursor.parent.getAncestors().includes(allowedParent)) allowedParent = null;
        }
        if (!allowedParent) {
            if (!$b9b9f2bdf9c6137f$export$576a60d33a9343e9(modelCursor, node, schema)) return null;
            return {
                position: $b9b9f2bdf9c6137f$export$26e14cf0958eab58(modelCursor, writer)
            };
        }
        const splitResult = this.conversionApi.writer.split(modelCursor, allowedParent);
        const stack = [];
        for (const treeWalkerValue of splitResult.range.getWalker())if (treeWalkerValue.type == "elementEnd") stack.push(treeWalkerValue.item);
        else {
            const originalPart = stack.pop();
            const splitPart = treeWalkerValue.item;
            this._registerSplitPair(originalPart, splitPart);
        }
        const cursorParent = splitResult.range.end.parent;
        this._cursorParents.set(node, cursorParent);
        return {
            position: splitResult.position,
            cursorParent: cursorParent
        };
    }
    /**
	* Registers that a `splitPart` element is a split part of the `originalPart` element.
	*
	* The data set by this method is used by {@link #_getSplitParts} and {@link #_removeEmptyElements}.
	*/ _registerSplitPair(originalPart, splitPart) {
        if (!this._splitParts.has(originalPart)) this._splitParts.set(originalPart, [
            originalPart
        ]);
        const list = this._splitParts.get(originalPart);
        this._splitParts.set(splitPart, list);
        list.push(splitPart);
    }
    /**
	* @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#getSplitParts
	*/ _getSplitParts(element) {
        let parts;
        if (!this._splitParts.has(element)) parts = [
            element
        ];
        else parts = this._splitParts.get(element);
        return parts;
    }
    /**
	* Mark an element that were created during the splitting to not get removed on conversion end even if it is empty.
	*/ _keepEmptyElement(element) {
        this._emptyElementsToKeep.add(element);
    }
    /**
	* Checks if there are any empty elements created while splitting and removes them.
	*
	* This method works recursively to re-check empty elements again after at least one element was removed in the initial call,
	* as some elements might have become empty after other empty elements were removed from them.
	*/ _removeEmptyElements() {
        const toRemove = /* @__PURE__ */ new Map();
        for (const element of this._splitParts.keys())if (element.isEmpty && !this._emptyElementsToKeep.has(element)) {
            const children = toRemove.get(element.parent) || [];
            children.push(element);
            this._splitParts.delete(element);
            toRemove.set(element.parent, children);
        }
        for (const [parent, children] of toRemove)parent._removeChildrenArray(children);
        if (toRemove.size) this._removeEmptyElements();
    }
};
/**
* Traverses given model item and searches elements which marks marker range. Found element is removed from
* ModelDocumentFragment but path of this element is stored in a Map which is then returned.
*
* @param modelItem Fragment of model.
* @returns List of static markers.
*/ function $b9b9f2bdf9c6137f$var$extractMarkersFromModelFragment(modelItem, writer) {
    const markerElements = /* @__PURE__ */ new Set();
    const markers = /* @__PURE__ */ new Map();
    const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(modelItem).getItems();
    for (const item of range)if (item.is("element", "$marker")) markerElements.add(item);
    for (const markerElement of markerElements){
        const markerName = markerElement.getAttribute("data-name");
        const currentPosition = writer.createPositionBefore(markerElement);
        if (!markers.has(markerName)) markers.set(markerName, new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(currentPosition.clone()));
        else markers.get(markerName).end = currentPosition.clone();
        writer.remove(markerElement);
    }
    return markers;
}
/**
* Creates model fragment according to given context and returns position in the bottom (the deepest) element.
*/ function $b9b9f2bdf9c6137f$var$createContextTree(contextDefinition, writer) {
    let position;
    for (const item of new $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a(contextDefinition)){
        const attributes = {};
        for (const key of item.getAttributeKeys())attributes[key] = item.getAttribute(key);
        const current = writer.createElement(item.name, attributes);
        if (position) writer.insert(current, position);
        position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(current, 0);
    }
    return position;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Basic HTML writer. It uses the native `innerHTML` property for basic conversion
* from a document fragment to an HTML string.
*
* @internal
*/ var $b9b9f2bdf9c6137f$export$aea2d4ac5edc84ae = class {
    /**
	* Returns an HTML string created from the document fragment.
	*/ getHtml(fragment) {
        const container = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.implementation.createHTMLDocument("").createElement("div");
        container.appendChild(fragment);
        return container.innerHTML;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/dataprocessor/htmldataprocessor
*/ /**
* The HTML data processor class.
* This data processor implementation uses HTML as input and output data.
*/ var $b9b9f2bdf9c6137f$export$770f0f0cb3c9452 = class {
    /**
	* A DOM parser instance used to parse an HTML string to an HTML document.
	*/ domParser;
    /**
	* A DOM converter used to convert DOM elements to view elements.
	*/ domConverter;
    /**
	* A basic HTML writer instance used to convert DOM elements to an HTML string.
	*/ htmlWriter;
    skipComments = true;
    /**
	* Creates a new instance of the HTML data processor class.
	*
	* @param document The view document instance.
	*/ constructor(document1){
        this.domParser = new DOMParser();
        this.domConverter = new $b9b9f2bdf9c6137f$export$f7719161406171fa(document1, {
            renderingMode: "data"
        });
        this.htmlWriter = new $b9b9f2bdf9c6137f$export$aea2d4ac5edc84ae();
    }
    /**
	* Converts a provided {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}
	* to data format &ndash; in this case to an HTML string.
	*
	* @returns HTML string.
	*/ toData(viewFragment) {
        const domFragment = this.domConverter.viewToDom(viewFragment);
        return this.htmlWriter.getHtml(domFragment);
    }
    /**
	* Converts the provided HTML string to a view tree.
	*
	* @param data An HTML string.
	* @returns A converted view element.
	*/ toView(data) {
        const domFragment = this._toDom(data);
        return this.domConverter.domToView(domFragment, {
            skipComments: this.skipComments
        });
    }
    /**
	* Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
	* and not processed during the conversion from the DOM to the view elements.
	*
	* The raw data can be later accessed by a
	* {@link module:engine/view/element~ViewElement#getCustomProperty custom property of a view element} called `"$rawContent"`.
	*
	* @param pattern Pattern matching all view elements whose content should be treated as raw data.
	*/ registerRawContentMatcher(pattern) {
        this.domConverter.registerRawContentMatcher(pattern);
    }
    /**
	* If the processor is set to use marked fillers, it will insert `&nbsp;` fillers wrapped in `<span>` elements
	* (`<span data-cke-filler="true">&nbsp;</span>`) instead of regular `&nbsp;` characters.
	*
	* This mode allows for a more precise handling of the block fillers (so they do not leak into the editor content) but
	* bloats the editor data with additional markup.
	*
	* This mode may be required by some features and will be turned on by them automatically.
	*
	* @param type Whether to use the default or the marked `&nbsp;` block fillers.
	*/ useFillerType(type) {
        this.domConverter.blockFillerMode = type == "marked" ? "markedNbsp" : "nbsp";
    }
    /**
	* Converts an HTML string to its DOM representation. Returns a document fragment containing nodes parsed from
	* the provided data.
	*/ _toDom(data) {
        if (!/<(?:html|body|head|meta)(?:\s[^>]*)?>/i.test(data.trim().slice(0, 1e4))) data = `<body>${data}</body>`;
        const document1 = this.domParser.parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(data), "text/html");
        const fragment = document1.createDocumentFragment();
        const bodyChildNodes = document1.body.childNodes;
        while(bodyChildNodes.length > 0)fragment.appendChild(bodyChildNodes[0]);
        return fragment;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/controller/datacontroller
*/ const $b9b9f2bdf9c6137f$var$DataControllerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Controller for the data pipeline. The data pipeline controls how data is retrieved from the document
* and set inside it. Hence, the controller features two methods which allow to {@link ~DataController#get get}
* and {@link ~DataController#set set} data of the {@link ~DataController#model model}
* using the given:
*
* * {@link module:engine/dataprocessor/dataprocessor~DataProcessor data processor},
* * downcast converters,
* * upcast converters.
*
* An instance of the data controller is always available in the {@link module:core/editor/editor~Editor#data `editor.data`}
* property:
*
* ```ts
* editor.data.get( { rootName: 'customRoot' } ); // -> '<p>Hello!</p>'
* ```
*/ var $b9b9f2bdf9c6137f$export$af704488d7d0ffb8 = class extends $b9b9f2bdf9c6137f$var$DataControllerBase {
    /**
	* Data model.
	*/ model;
    /**
	* Mapper used for the conversion. It has no permanent bindings, because these are created while getting data and
	* are cleared directly after the data are converted. However, the mapper is defined as a class property, because
	* it needs to be passed to the `DowncastDispatcher` as a conversion API.
	*/ mapper;
    /**
	* Downcast dispatcher used by the {@link #get get method}. Downcast converters should be attached to it.
	*/ downcastDispatcher;
    /**
	* Upcast dispatcher used by the {@link #set set method}. Upcast converters should be attached to it.
	*/ upcastDispatcher;
    /**
	* The view document used by the data controller.
	*/ viewDocument;
    /**
	* Styles processor used during the conversion.
	*/ stylesProcessor;
    /**
	* Data processor used specifically for HTML conversion.
	*/ htmlProcessor;
    /**
	* Data processor used during the conversion.
	* Same instance as {@link #htmlProcessor} by default. Can be replaced at run time to handle different format, e.g. XML or Markdown.
	*/ processor;
    /**
	* The view downcast writer just for data conversion purposes, i.e. to modify
	* the {@link #viewDocument}.
	*/ _viewWriter;
    /**
	* Creates a data controller instance.
	*
	* @param model Data model.
	* @param stylesProcessor The styles processor instance.
	*/ constructor(model, stylesProcessor){
        super();
        this.model = model;
        this.mapper = new $b9b9f2bdf9c6137f$export$ef5ccc0a8fc5a06c();
        this.downcastDispatcher = new $b9b9f2bdf9c6137f$export$a3db87c8d34df7e7({
            mapper: this.mapper,
            schema: model.schema
        });
        this.downcastDispatcher.on("insert:$text", $b9b9f2bdf9c6137f$export$45ce91c8ab754ab7(), {
            priority: "lowest"
        });
        this.downcastDispatcher.on("insert", $b9b9f2bdf9c6137f$export$f67751480ebc37c(), {
            priority: "lowest"
        });
        this.upcastDispatcher = new $b9b9f2bdf9c6137f$export$1f0967356c557e87({
            schema: model.schema
        });
        this.viewDocument = new $b9b9f2bdf9c6137f$export$c26285651732fb36(stylesProcessor);
        this.stylesProcessor = stylesProcessor;
        this.htmlProcessor = new $b9b9f2bdf9c6137f$export$770f0f0cb3c9452(this.viewDocument);
        this.processor = this.htmlProcessor;
        this._viewWriter = new $b9b9f2bdf9c6137f$export$c1f00b82a18dfdda(this.viewDocument);
        this.upcastDispatcher.on("text", $b9b9f2bdf9c6137f$export$f86caf7f35a4e003(), {
            priority: "lowest"
        });
        this.upcastDispatcher.on("element", $b9b9f2bdf9c6137f$export$ac74e2a6eadb85c7(), {
            priority: "lowest"
        });
        this.upcastDispatcher.on("documentFragment", $b9b9f2bdf9c6137f$export$ac74e2a6eadb85c7(), {
            priority: "lowest"
        });
        (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)().prototype.decorate.call(this, "init");
        (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)().prototype.decorate.call(this, "set");
        (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)().prototype.decorate.call(this, "get");
        (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)().prototype.decorate.call(this, "toView");
        (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)().prototype.decorate.call(this, "toModel");
        this.on("init", ()=>{
            this.fire("ready");
        }, {
            priority: "lowest"
        });
        this.on("ready", ()=>{
            this.model.enqueueChange({
                isUndoable: false
            }, $b9b9f2bdf9c6137f$export$5245497caaaa7808);
        }, {
            priority: "lowest"
        });
    }
    /**
	* Returns the model's data converted by downcast dispatchers attached to {@link #downcastDispatcher} and
	* formatted by the {@link #processor data processor}.
	*
	* A warning is logged when you try to retrieve data for a detached root, as most probably this is a mistake. A detached root should
	* be treated like it is removed, and you should not save its data. Note, that the detached root data is always an empty string.
	*
	* @fires get
	* @param options Additional configuration for the retrieved data. `DataController` provides two optional
	* properties: `rootName` and `trim`. Other properties of this object are specified by various editor features.
	* @param options.rootName Root name. Default 'main'.
	* @param options.trim Whether returned data should be trimmed. This option is set to `empty` by default,
	* which means whenever editor content is considered empty, an empty string will be returned. To turn off trimming completely
	* use `'none'`. In such cases the exact content will be returned (for example a `<p>&nbsp;</p>` for an empty editor).
	* @returns Output data.
	*/ get(options = {}) {
        const { rootName: rootName = "main", trim: trim = "empty" } = options;
        if (!this._checkIfRootsExists([
            rootName
        ])) /**
		* Cannot get data from a non-existing root. This error is thrown when
		* {@link module:engine/controller/datacontroller~DataController#get `DataController#get()` method}
		* is called with a non-existent root name. For example, if there is an editor instance with only `main` root,
		* calling {@link module:engine/controller/datacontroller~DataController#get} like:
		*
		* ```ts
		* data.get( { rootName: 'root2' } );
		* ```
		*
		* will throw this error.
		*
		* @error datacontroller-get-non-existent-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("datacontroller-get-non-existent-root", this);
        const root = this.model.document.getRoot(rootName);
        if (!root.isAttached()) /**
		* Retrieving document data for a detached root.
		*
		* This usually indicates an error as a detached root should be considered "removed" and should not be included in the
		* document data.
		*
		* @error datacontroller-get-detached-root
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("datacontroller-get-detached-root", this);
        if (trim === "empty" && !this.model.hasContent(root, {
            ignoreWhitespaces: true
        })) return "";
        return this.stringify(root, options);
    }
    /**
	* Returns the content of the given {@link module:engine/model/element~ModelElement model's element} or
	* {@link module:engine/model/documentfragment~ModelDocumentFragment model document fragment} converted by the downcast converters
	* attached to the {@link #downcastDispatcher} and formatted by the {@link #processor data processor}.
	*
	* @param modelElementOrFragment The element whose content will be stringified.
	* @param options Additional configuration passed to the conversion process.
	* @returns Output data.
	*/ stringify(modelElementOrFragment, options = {}) {
        const viewDocumentFragment = this.toView(modelElementOrFragment, options);
        return this.processor.toData(viewDocumentFragment);
    }
    /**
	* Returns the content of the given {@link module:engine/model/element~ModelElement model element} or
	* {@link module:engine/model/documentfragment~ModelDocumentFragment model document fragment} converted by the downcast
	* converters attached to {@link #downcastDispatcher} into a
	* {@link module:engine/view/documentfragment~ViewDocumentFragment view document fragment}.
	*
	* @fires toView
	* @param modelElementOrFragment Element or document fragment whose content will be converted.
	* @param options Additional configuration that will be available through the
	* {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi#options} during the conversion process.
	* @returns Output view ModelDocumentFragment.
	*/ toView(modelElementOrFragment, options = {}) {
        const viewDocument = this.viewDocument;
        const viewWriter = this._viewWriter;
        this.mapper.clearBindings();
        const modelRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(modelElementOrFragment);
        const viewDocumentFragment = new $b9b9f2bdf9c6137f$export$574fd53611480ec7(viewDocument);
        this.mapper.bindElements(modelElementOrFragment, viewDocumentFragment);
        const markers = modelElementOrFragment.is("documentFragment") ? modelElementOrFragment.markers : $b9b9f2bdf9c6137f$var$_getMarkersRelativeToElement(modelElementOrFragment);
        this.downcastDispatcher.convert(modelRange, markers, viewWriter, options);
        return viewDocumentFragment;
    }
    /**
	* Sets the initial input data parsed by the {@link #processor data processor} and
	* converted by the {@link #upcastDispatcher view-to-model converters}.
	* Initial data can be only set to a document whose {@link module:engine/model/document~ModelDocument#version} is equal 0.
	*
	* **Note** This method is {@link module:utils/observablemixin~Observable#decorate decorated} which is
	* used by e.g. collaborative editing plugin that syncs remote data on init.
	*
	* When data is passed as a string, it is initialized on the default `main` root:
	*
	* ```ts
	* dataController.init( '<p>Foo</p>' ); // Initializes data on the `main` root only, as no other is specified.
	* ```
	*
	* To initialize data on a different root or multiple roots at once, an object containing `rootName` - `data` pairs should be passed:
	*
	* ```ts
	* dataController.init( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Initializes data on both the `main` and `title` roots.
	* ```
	*
	* @fires init
	* @param data Input data as a string or an object containing the `rootName` - `data`
	* pairs to initialize data on multiple roots at once.
	* @returns Promise that is resolved after the data is set on the editor.
	*/ init(data) {
        if (this.model.document.version) /**
		* Cannot set initial data to a non-empty {@link module:engine/model/document~ModelDocument}.
		* Initial data should be set once, during the {@link module:core/editor/editor~Editor} initialization,
		* when the {@link module:engine/model/document~ModelDocument#version} is equal 0.
		*
		* @error datacontroller-init-document-not-empty
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("datacontroller-init-document-not-empty", this);
        let initialData = {};
        if (typeof data === "string") initialData.main = data;
        else initialData = data;
        if (!this._checkIfRootsExists(Object.keys(initialData))) /**
		* Cannot init data on a non-existent root. This error is thrown when
		* {@link module:engine/controller/datacontroller~DataController#init DataController#init() method}
		* is called with non-existent root name. For example, if there is an editor instance with only `main` root,
		* calling {@link module:engine/controller/datacontroller~DataController#init} like:
		*
		* ```ts
		* data.init( { main: '<p>Foo</p>', root2: '<p>Bar</p>' } );
		* ```
		*
		* will throw this error.
		*
		* @error datacontroller-init-non-existent-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("datacontroller-init-non-existent-root", this);
        this.model.enqueueChange({
            isUndoable: false
        }, (writer)=>{
            for (const rootName of Object.keys(initialData)){
                const modelRoot = this.model.document.getRoot(rootName);
                writer.insert(this.parse(initialData[rootName], modelRoot), modelRoot, 0);
            }
        });
        return Promise.resolve();
    }
    /**
	* Sets the input data parsed by the {@link #processor data processor} and
	* converted by the {@link #upcastDispatcher view-to-model converters}.
	* This method can be used any time to replace existing editor data with the new one without clearing the
	* {@link module:engine/model/document~ModelDocument#history document history}.
	*
	* This method also creates a batch with all the changes applied. If all you need is to parse data, use
	* the {@link #parse} method.
	*
	* When data is passed as a string it is set on the default `main` root:
	*
	* ```ts
	* dataController.set( '<p>Foo</p>' ); // Sets data on the `main` root, as no other is specified.
	* ```
	*
	* To set data on a different root or multiple roots at once, an object containing `rootName` - `data` pairs should be passed:
	*
	* ```ts
	* dataController.set( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Sets data on the `main` and `title` roots as specified.
	* ```
	*
	* To set the data with a preserved undo stack and add the change to the undo stack, set `{ isUndoable: true }` as a `batchType` option.
	*
	* ```ts
	* dataController.set( '<p>Foo</p>', { batchType: { isUndoable: true } } );
	* ```
	*
	* @fires set
	* @param data Input data as a string or an object containing the `rootName` - `data`
	* pairs to set data on multiple roots at once.
	* @param options Options for setting data.
	* @param options.batchType The batch type that will be used to create a batch for the changes applied by this method.
	* By default, the batch will be set as {@link module:engine/model/batch~Batch#isUndoable not undoable} and the undo stack will be
	* cleared after the new data is applied (all undo steps will be removed). If the batch type `isUndoable` flag is be set to `true`,
	* the undo stack will be preserved instead and not cleared when new data is applied.
	*/ set(data, options = {}) {
        let newData = {};
        if (typeof data === "string") newData.main = data;
        else newData = data;
        if (!this._checkIfRootsExists(Object.keys(newData))) /**
		* Cannot set data on a non-existent root. This error is thrown when the
		* {@link module:engine/controller/datacontroller~DataController#set DataController#set() method}
		* is called with non-existent root name. For example, if there is an editor instance with only the default `main` root,
		* calling {@link module:engine/controller/datacontroller~DataController#set} like:
		*
		* ```ts
		* data.set( { main: '<p>Foo</p>', root2: '<p>Bar</p>' } );
		* ```
		*
		* will throw this error.
		*
		* @error datacontroller-set-non-existent-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("datacontroller-set-non-existent-root", this);
        this.model.enqueueChange(options.batchType || {}, (writer)=>{
            writer.setSelection(null);
            writer.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
            for (const rootName of Object.keys(newData)){
                const modelRoot = this.model.document.getRoot(rootName);
                writer.remove(writer.createRangeIn(modelRoot));
                writer.insert(this.parse(newData[rootName], modelRoot), modelRoot, 0);
            }
        });
    }
    /**
	* Returns the data parsed by the {@link #processor data processor} and then converted by upcast converters
	* attached to the {@link #upcastDispatcher}.
	*
	* **Note:** The default `context` value is `'$root'`, which only matches the generic root. When the editor uses a
	* custom root {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the target
	* {@link module:engine/model/rootelement~ModelRootElement root element} (or its configured model element name)
	* explicitly, otherwise the conversion result may be wrong.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*
	* @see #set
	* @param data Data to parse.
	* @param context Base context in which the view will be converted to the model.
	* See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
	* @returns Parsed data.
	*/ parse(data, context = "$root") {
        const viewDocumentFragment = this.processor.toView(data);
        return this.toModel(viewDocumentFragment, context);
    }
    /**
	* Returns the result of the given {@link module:engine/view/element~ViewElement view element} or
	* {@link module:engine/view/documentfragment~ViewDocumentFragment view document fragment} converted by the
	* {@link #upcastDispatcher view-to-model converters}, wrapped by {@link module:engine/model/documentfragment~ModelDocumentFragment}.
	*
	* When marker elements were converted during the conversion process, it will be set as a document fragment's
	* {@link module:engine/model/documentfragment~ModelDocumentFragment#markers static markers map}.
	*
	* **Note:** The default `context` value is `'$root'`, which only matches the generic root. When the editor uses a
	* custom root {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the target
	* {@link module:engine/model/rootelement~ModelRootElement root element} (or its configured model element name)
	* explicitly, otherwise the conversion result may be wrong.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*
	* @fires toModel
	* @param viewElementOrFragment The element or document fragment whose content will be converted.
	* @param context Base context in which the view will be converted to the model.
	* See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
	* @returns Output document fragment.
	*/ toModel(viewElementOrFragment, context = "$root") {
        return this.model.change((writer)=>{
            return this.upcastDispatcher.convert(viewElementOrFragment, writer, context);
        });
    }
    /**
	* Adds the style processor normalization rules.
	*
	* You can implement your own rules as well as use one of the available processor rules:
	*
	* * background: {@link module:engine/view/styles/background~addBackgroundStylesRules}
	* * border: {@link module:engine/view/styles/border~addBorderStylesRules}
	* * margin: {@link module:engine/view/styles/margin~addMarginStylesRules}
	* * padding: {@link module:engine/view/styles/padding~addPaddingStylesRules}
	*/ addStyleProcessorRules(callback) {
        callback(this.stylesProcessor);
    }
    /**
	* Registers a {@link module:engine/view/matcher~MatcherPattern} on an {@link #htmlProcessor htmlProcessor}
	* and a {@link #processor processor} for view elements whose content should be treated as raw data
	* and not processed during the conversion from DOM to view elements.
	*
	* The raw data can be later accessed by the
	* {@link module:engine/view/element~ViewElement#getCustomProperty view element custom property}
	* `"$rawContent"`.
	*
	* @param pattern Pattern matching all view elements whose content should be treated as a raw data.
	*/ registerRawContentMatcher(pattern) {
        if (this.processor && this.processor !== this.htmlProcessor) this.processor.registerRawContentMatcher(pattern);
        this.htmlProcessor.registerRawContentMatcher(pattern);
    }
    /**
	* Removes all event listeners set by the DataController.
	*/ destroy() {
        this.stopListening();
    }
    /**
	* Checks whether all provided root names are actually existing editor roots.
	*
	* @param rootNames Root names to check.
	* @returns Whether all provided root names are existing editor roots.
	*/ _checkIfRootsExists(rootNames) {
        for (const rootName of rootNames)if (!this.model.document.getRoot(rootName)) return false;
        return true;
    }
};
/**
* Helper function for downcast conversion.
*
* Takes a document element (element that is added to a model document) and checks which markers are inside it. If the marker is collapsed
* at element boundary, it is considered as contained inside the element and marker range is returned. Otherwise, if the marker is
* intersecting with the element, the intersection is returned.
*/ function $b9b9f2bdf9c6137f$var$_getMarkersRelativeToElement(element) {
    const result = [];
    const doc = element.root.document;
    if (!doc) return /* @__PURE__ */ new Map();
    const elementRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(element);
    for (const marker of doc.model.markers){
        const markerRange = marker.getRange();
        const isMarkerCollapsed = markerRange.isCollapsed;
        const isMarkerAtElementBoundary = markerRange.start.isEqual(elementRange.start) || markerRange.end.isEqual(elementRange.end);
        if (isMarkerCollapsed && isMarkerAtElementBoundary) result.push([
            marker.name,
            markerRange
        ]);
        else {
            const updatedMarkerRange = elementRange.getIntersection(markerRange);
            if (updatedMarkerRange) result.push([
                marker.name,
                updatedMarkerRange
            ]);
        }
    }
    return new Map(result);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/conversion/conversion
*/ /**
* A utility class that helps add converters to upcast and downcast dispatchers.
*
* We recommend reading the {@glink framework/deep-dive/conversion/intro editor conversion} guide first to
* understand the core concepts of the conversion mechanisms.
*
* An instance of the conversion manager is available in the
* {@link module:core/editor/editor~Editor#conversion `editor.conversion`} property
* and by default has the following groups of dispatchers (i.e. directions of conversion):
*
* * `downcast` (editing and data downcasts)
* * `editingDowncast`
* * `dataDowncast`
* * `upcast`
*
* # One-way converters
*
* To add a converter to a specific group, use the {@link module:engine/conversion/conversion~Conversion#for `for()`}
* method:
*
* ```ts
* // Add a converter to editing downcast and data downcast.
* editor.conversion.for( 'downcast' ).elementToElement( config ) );
*
* // Add a converter to the data pipepline only:
* editor.conversion.for( 'dataDowncast' ).elementToElement( dataConversionConfig ) );
*
* // And a slightly different one for the editing pipeline:
* editor.conversion.for( 'editingDowncast' ).elementToElement( editingConversionConfig ) );
* ```
*
* See {@link module:engine/conversion/conversion~Conversion#for `for()`} method documentation to learn more about
* available conversion helpers and how to use your custom ones.
*
* # Two-way converters
*
* Besides using one-way converters via the `for()` method, you can also use other methods available in this
* class to add two-way converters (upcast and downcast):
*
* * {@link module:engine/conversion/conversion~Conversion#elementToElement `elementToElement()`} &ndash;
* Model element to view element and vice versa.
* * {@link module:engine/conversion/conversion~Conversion#attributeToElement `attributeToElement()`} &ndash;
* Model attribute to view element and vice versa.
* * {@link module:engine/conversion/conversion~Conversion#attributeToAttribute `attributeToAttribute()`} &ndash;
* Model attribute to view attribute and vice versa.
*/ var $b9b9f2bdf9c6137f$export$4690203fd259f070 = class {
    /**
	* Maps dispatchers group name to ConversionHelpers instances.
	*/ _helpers = /* @__PURE__ */ new Map();
    _downcast;
    _upcast;
    /**
	* Creates a new conversion instance.
	*/ constructor(downcastDispatchers, upcastDispatchers){
        this._downcast = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(downcastDispatchers);
        this._createConversionHelpers({
            name: "downcast",
            dispatchers: this._downcast,
            isDowncast: true
        });
        this._upcast = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(upcastDispatchers);
        this._createConversionHelpers({
            name: "upcast",
            dispatchers: this._upcast,
            isDowncast: false
        });
    }
    /**
	* Define an alias for registered dispatcher.
	*
	* ```ts
	* const conversion = new Conversion(
	* 	[ dataDowncastDispatcher, editingDowncastDispatcher ],
	* 	upcastDispatcher
	* );
	*
	* conversion.addAlias( 'dataDowncast', dataDowncastDispatcher );
	* ```
	*
	* @param alias An alias of a dispatcher.
	* @param dispatcher Dispatcher which should have an alias.
	*/ addAlias(alias, dispatcher) {
        const isDowncast = this._downcast.includes(dispatcher);
        if (!this._upcast.includes(dispatcher) && !isDowncast) /**
		* Trying to register an alias for a dispatcher that nas not been registered.
		*
		* @error conversion-add-alias-dispatcher-not-registered
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-add-alias-dispatcher-not-registered", this);
        this._createConversionHelpers({
            name: alias,
            dispatchers: [
                dispatcher
            ],
            isDowncast: isDowncast
        });
    }
    /**
	* Provides a chainable API to assign converters to a conversion dispatchers group.
	*
	* If the given group name has not been registered, the
	* {@link module:utils/ckeditorerror~CKEditorError `conversion-for-unknown-group` error} is thrown.
	*
	* You can use conversion helpers available directly in the `for()` chain or your custom ones via
	* the {@link module:engine/conversion/conversionhelpers~ConversionHelpers#add `add()`} method.
	*
	* # Using built-in conversion helpers
	*
	* The `for()` chain comes with a set of conversion helpers which you can use like this:
	*
	* ```ts
	* editor.conversion.for( 'downcast' )
	* 	.elementToElement( config1 )        // Adds an element-to-element downcast converter.
	* 	.attributeToElement( config2 );     // Adds an attribute-to-element downcast converter.
	*
	* editor.conversion.for( 'upcast' )
	* 	.elementToAttribute( config3 );     // Adds an element-to-attribute upcast converter.
	* ```
	*
	* Refer to the documentation of built-in conversion helpers to learn about their configuration options.
	*
	* * downcast (model-to-view) conversion helpers:
	*
	*	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToElement `elementToElement()`},
	*	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement `attributeToElement()`},
	*	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToAttribute `attributeToAttribute()`}.
	*	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToElement `markerToElement()`}.
	*	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToHighlight `markerToHighlight()`}.
	*
	* * upcast (view-to-model) conversion helpers:
	*
	*	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToElement `elementToElement()`},
	*	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToAttribute `elementToAttribute()`},
	*	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#attributeToAttribute `attributeToAttribute()`}.
	*	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToMarker `elementToMarker()`}.
	*
	* # Using custom conversion helpers
	*
	* If you need to implement an atypical converter, you can do so by calling:
	*
	* ```ts
	* editor.conversion.for( direction ).add( customHelper );
	* ```
	*
	* The `.add()` method takes exactly one parameter, which is a function. This function should accept one parameter that
	* is a dispatcher instance. The function should add an actual converter to the passed dispatcher instance.
	*
	* Example:
	*
	* ```ts
	* editor.conversion.for( 'upcast' ).add( dispatcher => {
	* 	dispatcher.on( 'element:a',  ( evt, data, conversionApi ) => {
	* 		// Do something with a view <a> element.
	* 	} );
	* } );
	* ```
	*
	* Refer to the documentation of {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher}
	* and {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} to learn how to write
	* custom converters.
	*
	* @param groupName The name of dispatchers group to add the converters to.
	*/ for(groupName) {
        if (!this._helpers.has(groupName)) /**
		* Trying to add a converter to an unknown dispatchers group.
		*
		* @error conversion-for-unknown-group
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-for-unknown-group", this);
        return this._helpers.get(groupName);
    }
    /**
	* Sets up converters between the model and the view that convert a model element to a view element (and vice versa).
	* For example, the model `<paragraph>Foo</paragraph>` is turned into `<p>Foo</p>` in the view.
	*
	* ```ts
	* // A simple conversion from the `paragraph` model element to the `<p>` view element (and vice versa).
	* editor.conversion.elementToElement( { model: 'paragraph', view: 'p' } );
	*
	* // Override other converters by specifying a converter definition with a higher priority.
	* editor.conversion.elementToElement( { model: 'paragraph', view: 'div', converterPriority: 'high' } );
	*
	* // View specified as an object instead of a string.
	* editor.conversion.elementToElement( {
	* 	model: 'fancyParagraph',
	* 	view: {
	* 		name: 'p',
	* 		classes: 'fancy'
	* 	}
	* } );
	*
	* // Use `upcastAlso` to define other view elements that should also be converted to a `paragraph` element.
	* editor.conversion.elementToElement( {
	* 	model: 'paragraph',
	* 	view: 'p',
	* 	upcastAlso: [
	* 		'div',
	* 		{
	* 			// Any element with the `display: block` style.
	* 			styles: {
	* 				display: 'block'
	* 			}
	* 		}
	* 	]
	* } );
	*
	* // `upcastAlso` set as callback enables a conversion of a wide range of different view elements.
	* editor.conversion.elementToElement( {
	* 	model: 'heading',
	* 	view: 'h2',
	* 	// Convert "heading-like" paragraphs to headings.
	* 	upcastAlso: viewElement => {
	* 		const fontSize = viewElement.getStyle( 'font-size' );
	*
	* 		if ( !fontSize ) {
	* 			return null;
	* 		}
	*
	* 		const match = fontSize.match( /(\d+)\s*px/ );
	*
	* 		if ( !match ) {
	* 			return null;
	* 		}
	*
	* 		const size = Number( match[ 1 ] );
	*
	* 		if ( size > 26 ) {
	* 			// Returned value can be an object with the matched properties.
	* 			// These properties will be "consumed" during the conversion.
	* 			// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
	*
	* 			return { name: true, styles: [ 'font-size' ] };
	* 		}
	*
	* 		return null;
	* 	}
	* } );
	* ```
	*
	* `definition.model` is a `String` with a model element name to convert from or to.
	*
	* @param definition The converter definition.
	*/ elementToElement(definition) {
        this.for("downcast").elementToElement(definition);
        for (const { model: model, view: view } of $b9b9f2bdf9c6137f$var$_getAllUpcastDefinitions(definition))this.for("upcast").elementToElement({
            model: model,
            view: view,
            converterPriority: definition.converterPriority
        });
    }
    /**
	* Sets up converters between the model and the view that convert a model attribute to a view element (and vice versa).
	* For example, a model text node with `"Foo"` as data and the `bold` attribute will be turned to `<strong>Foo</strong>` in the view.
	*
	* ```ts
	* // A simple conversion from the `bold=true` attribute to the `<strong>` view element (and vice versa).
	* editor.conversion.attributeToElement( { model: 'bold', view: 'strong' } );
	*
	* // Override other converters by specifying a converter definition with a higher priority.
	* editor.conversion.attributeToElement( { model: 'bold', view: 'b', converterPriority: 'high' } );
	*
	* // View specified as an object instead of a string.
	* editor.conversion.attributeToElement( {
	* 	model: 'bold',
	* 	view: {
	* 		name: 'span',
	* 		classes: 'bold'
	* 	}
	* } );
	*
	* // Use `config.model.name` to define the conversion only from a given node type, `$text` in this case.
	* // The same attribute on different elements may then be handled by a different converter.
	* editor.conversion.attributeToElement( {
	* 	model: {
	* 		key: 'textDecoration',
	* 		values: [ 'underline', 'lineThrough' ],
	* 		name: '$text'
	* 	},
	* 	view: {
	* 		underline: {
	* 			name: 'span',
	* 			styles: {
	* 				'text-decoration': 'underline'
	* 			}
	* 		},
	* 		lineThrough: {
	* 			name: 'span',
	* 			styles: {
	* 				'text-decoration': 'line-through'
	* 			}
	* 		}
	* 	}
	* } );
	*
	* // Use `upcastAlso` to define other view elements that should also be converted to the `bold` attribute.
	* editor.conversion.attributeToElement( {
	* 	model: 'bold',
	* 	view: 'strong',
	* 	upcastAlso: [
	* 		'b',
	* 		{
	* 			name: 'span',
	* 			classes: 'bold'
	* 		},
	* 		{
	* 			name: 'span',
	* 			styles: {
	* 				'font-weight': 'bold'
	* 			}
	* 		},
	* 		viewElement => {
	* 			const fontWeight = viewElement.getStyle( 'font-weight' );
	*
	* 			if ( viewElement.is( 'element', 'span' ) && fontWeight && /\d+/.test() && Number( fontWeight ) > 500 ) {
	* 				// Returned value can be an object with the matched properties.
	* 				// These properties will be "consumed" during the conversion.
	* 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
	*
	* 				return {
	* 					name: true,
	* 					styles: [ 'font-weight' ]
	* 				};
	* 			}
	* 		}
	* 	]
	* } );
	*
	* // Conversion from and to a model attribute key whose value is an enum (`fontSize=big|small`).
	* // `upcastAlso` set as callback enables a conversion of a wide range of different view elements.
	* editor.conversion.attributeToElement( {
	* 	model: {
	* 		key: 'fontSize',
	* 		values: [ 'big', 'small' ]
	* 	},
	* 	view: {
	* 		big: {
	* 			name: 'span',
	* 			styles: {
	* 				'font-size': '1.2em'
	* 			}
	* 		},
	* 		small: {
	* 			name: 'span',
	* 			styles: {
	* 				'font-size': '0.8em'
	* 			}
	* 		}
	* 	},
	* 	upcastAlso: {
	* 		big: viewElement => {
	* 			const fontSize = viewElement.getStyle( 'font-size' );
	*
	* 			if ( !fontSize ) {
	* 				return null;
	* 			}
	*
	* 			const match = fontSize.match( /(\d+)\s*px/ );
	*
	* 			if ( !match ) {
	* 				return null;
	* 			}
	*
	* 			const size = Number( match[ 1 ] );
	*
	* 			if ( viewElement.is( 'element', 'span' ) && size > 10 ) {
	* 				// Returned value can be an object with the matched properties.
	* 				// These properties will be "consumed" during the conversion.
	* 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
	*
	* 				return { name: true, styles: [ 'font-size' ] };
	* 			}
	*
	* 			return null;
	* 		},
	* 		small: viewElement => {
	* 			const fontSize = viewElement.getStyle( 'font-size' );
	*
	* 			if ( !fontSize ) {
	* 				return null;
	* 			}
	*
	* 			const match = fontSize.match( /(\d+)\s*px/ );
	*
	* 			if ( !match ) {
	* 				return null;
	* 			}
	*
	* 			const size = Number( match[ 1 ] );
	*
	* 			if ( viewElement.is( 'element', 'span' ) && size < 10 ) {
	* 				// Returned value can be an object with the matched properties.
	* 				// These properties will be "consumed" during the conversion.
	* 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
	*
	* 				return { name: true, styles: [ 'font-size' ] };
	* 			}
	*
	* 			return null;
	* 		}
	* 	}
	* } );
	* ```
	*
	* The `definition.model` parameter specifies which model attribute should be converted from or to. It can be a `{ key, value }` object
	* describing the attribute key and value to convert or a `String` specifying just the attribute key (in such a case
	* `value` is set to `true`).
	*
	* @param definition The converter definition.
	*/ attributeToElement(definition) {
        this.for("downcast").attributeToElement(definition);
        for (const { model: model, view: view } of $b9b9f2bdf9c6137f$var$_getAllUpcastDefinitions(definition))this.for("upcast").elementToAttribute({
            view: view,
            model: model,
            converterPriority: definition.converterPriority
        });
    }
    /**
	* Sets up converters between the model and the view that convert a model attribute to a view attribute (and vice versa). For example,
	* `<imageBlock src='foo.jpg'></imageBlock>` is converted to `<img src='foo.jpg'></img>` (the same attribute key and value).
	* This type of converters is intended to be used with {@link module:engine/model/element~ModelElement model element} nodes.
	* To convert the text attributes,
	* the {@link module:engine/conversion/conversion~Conversion#attributeToElement `attributeToElement converter`}should be set up.
	*
	* ```ts
	* // A simple conversion from the `source` model attribute to the `src` view attribute (and vice versa).
	* editor.conversion.attributeToAttribute( { model: 'source', view: 'src' } );
	*
	* // Attribute values are strictly specified.
	* editor.conversion.attributeToAttribute( {
	* 	model: {
	* 		name: 'imageInline',
	* 		key: 'aside',
	* 		values: [ 'aside' ]
	* 	},
	* 	view: {
	* 		aside: {
	* 			name: 'img',
	* 			key: 'class',
	* 			value: [ 'aside', 'half-size' ]
	* 		}
	* 	}
	* } );
	*
	* // Set the style attribute.
	* editor.conversion.attributeToAttribute( {
	* 	model: {
	* 		name: 'imageInline',
	* 		key: 'aside',
	* 		values: [ 'aside' ]
	* 	},
	* 	view: {
	* 		aside: {
	* 			name: 'img',
	* 			key: 'style',
	* 			value: {
	* 				float: 'right',
	* 				width: '50%',
	* 				margin: '5px'
	* 			}
	* 		}
	* 	}
	* } );
	*
	* // Conversion from and to a model attribute key whose value is an enum (`align=right|center`).
	* // Use `upcastAlso` to define other view elements that should also be converted to the `align=right` attribute.
	* editor.conversion.attributeToAttribute( {
	* 	model: {
	* 		key: 'align',
	* 		values: [ 'right', 'center' ]
	* 	},
	* 	view: {
	* 		right: {
	* 			key: 'class',
	* 			value: 'align-right'
	* 		},
	* 		center: {
	* 			key: 'class',
	* 			value: 'align-center'
	* 		}
	* 	},
	* 	upcastAlso: {
	* 		right: {
	* 			styles: {
	* 				'text-align': 'right'
	* 			}
	* 		},
	* 		center: {
	* 			styles: {
	* 				'text-align': 'center'
	* 			}
	* 		}
	* 	}
	* } );
	* ```
	*
	* The `definition.model` parameter specifies which model attribute should be converted from and to.
	* It can be a `{ key, [ values ], [ name ] }` object or a `String`, which will be treated like `{ key: definition.model }`.
	* The `key` property is the model attribute key to convert from and to.
	* The `values` are the possible model attribute values. If the `values` parameter is not set, the model attribute value
	* will be the same as the view attribute value.
	* If `name` is set, the conversion will be set up only for model elements with the given name.
	*
	* The `definition.view` parameter specifies which view attribute should be converted from and to.
	* It can be a `{ key, value, [ name ] }` object or a `String`, which will be treated like `{ key: definition.view }`.
	* The `key` property is the view attribute key to convert from and to.
	* The `value` is the view attribute value to convert from and to. If `definition.value` is not set, the view attribute value will be
	* the same as the model attribute value.
	* If `key` is `'class'`, `value` can be a `String` or an array of `String`s.
	* If `key` is `'style'`, `value` is an object with key-value pairs.
	* In other cases, `value` is a `String`.
	* If `name` is set, the conversion will be set up only for model elements with the given name.
	* If `definition.model.values` is set, `definition.view` is an object that assigns values from `definition.model.values`
	* to `{ key, value, [ name ] }` objects.
	*
	* `definition.upcastAlso` specifies which other matching view elements should also be upcast to the given model configuration.
	* If `definition.model.values` is set, `definition.upcastAlso` should be an object assigning values from `definition.model.values`
	* to {@link module:engine/view/matcher~MatcherPattern}s or arrays of {@link module:engine/view/matcher~MatcherPattern}s.
	*
	* **Note:** `definition.model` and `definition.view` form should be mirrored, so the same types of parameters should
	* be given in both parameters.
	*
	* @param definition The converter definition.
	* @param definition.model The model attribute to convert from and to.
	* @param definition.view The view attribute to convert from and to.
	* @param definition.upcastAlso Any view element matching `definition.upcastAlso` will also be converted to the given model attribute.
	* `definition.upcastAlso` is used only if `config.model.values` is specified.
	*/ attributeToAttribute(definition) {
        this.for("downcast").attributeToAttribute(definition);
        for (const { model: model, view: view } of $b9b9f2bdf9c6137f$var$_getAllUpcastDefinitions(definition))this.for("upcast").attributeToAttribute({
            view: view,
            model: model
        });
    }
    /**
	* Creates and caches conversion helpers for given dispatchers group.
	*
	* @param options Group name.
	* @param options.name Group name.
	* @param options.dispatchers Dispatchers to register.
	* @param options.isDowncast Whether downcast group.
	*/ _createConversionHelpers({ name: name, dispatchers: dispatchers, isDowncast: isDowncast }) {
        if (this._helpers.has(name)) /**
		* Trying to register a group name that has already been registered.
		*
		* @error conversion-group-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("conversion-group-exists", this);
        const helpers = isDowncast ? new $b9b9f2bdf9c6137f$export$368723eff4b0f393(dispatchers) : new $b9b9f2bdf9c6137f$export$3240fbf7657c4a54(dispatchers);
        this._helpers.set(name, helpers);
    }
};
/**
* Helper function that creates a joint array out of an item passed in `definition.view` and items passed in
* `definition.upcastAlso`.
*/ function* $b9b9f2bdf9c6137f$var$_getAllUpcastDefinitions(definition) {
    if (definition.model.values) for (const value of definition.model.values){
        const model = {
            key: definition.model.key,
            value: value
        };
        const view = definition.view[value];
        yield* $b9b9f2bdf9c6137f$var$_getUpcastDefinition(model, view, definition.upcastAlso ? definition.upcastAlso[value] : void 0);
    }
    else yield* $b9b9f2bdf9c6137f$var$_getUpcastDefinition(definition.model, definition.view, definition.upcastAlso);
}
function* $b9b9f2bdf9c6137f$var$_getUpcastDefinition(model, view, upcastAlso) {
    yield {
        model: model,
        view: view
    };
    if (upcastAlso) for (const upcastAlsoItem of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(upcastAlso))yield {
        model: model,
        view: upcastAlsoItem
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/dataprocessor/xmldataprocessor
*/ /**
* The XML data processor class.
* This data processor implementation uses XML as input and output data.
* This class is needed because unlike HTML, XML allows to use any tag with any value.
* For example, `<link>Text</link>` is a valid XML but invalid HTML.
*/ var $b9b9f2bdf9c6137f$export$1e715f285cf5346f = class {
    /**
	* A list of namespaces allowed to use in the XML input.
	*
	* For example, registering namespaces [ 'attribute', 'container' ] allows to use `<attirbute:tagName></attribute:tagName>`
	* and `<container:tagName></container:tagName>` input. It is mainly for debugging.
	*/ namespaces;
    /**
	* DOM parser instance used to parse an XML string to an XML document.
	*/ domParser;
    /**
	* DOM converter used to convert DOM elements to view elements.
	*/ domConverter;
    /**
	* A basic HTML writer instance used to convert DOM elements to an XML string.
	* There is no need to use a dedicated XML writer because the basic HTML writer works well in this case.
	*/ htmlWriter;
    skipComments = true;
    /**
	* Creates a new instance of the XML data processor class.
	*
	* @param document The view document instance.
	* @param options Configuration options.
	* @param options.namespaces A list of namespaces allowed to use in the XML input.
	*/ constructor(document1, options = {}){
        this.namespaces = options.namespaces || [];
        this.domParser = new DOMParser();
        this.domConverter = new $b9b9f2bdf9c6137f$export$f7719161406171fa(document1, {
            renderingMode: "data"
        });
        this.htmlWriter = new $b9b9f2bdf9c6137f$export$aea2d4ac5edc84ae();
    }
    /**
	* Converts the provided {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}
	* to data format &ndash; in this case an XML string.
	*
	* @returns An XML string.
	*/ toData(viewFragment) {
        const domFragment = this.domConverter.viewToDom(viewFragment);
        return this.htmlWriter.getHtml(domFragment);
    }
    /**
	* Converts the provided XML string to a view tree.
	*
	* @param data An XML string.
	* @returns A converted view element.
	*/ toView(data) {
        const domFragment = this._toDom(data);
        return this.domConverter.domToView(domFragment, {
            keepOriginalCase: true,
            skipComments: this.skipComments
        });
    }
    /**
	* Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
	* and not processed during the conversion from XML to view elements.
	*
	* The raw data can be later accessed by a
	* {@link module:engine/view/element~ViewElement#getCustomProperty custom property of a view element} called `"$rawContent"`.
	*
	* @param pattern Pattern matching all view elements whose content should be treated as raw data.
	*/ registerRawContentMatcher(pattern) {
        this.domConverter.registerRawContentMatcher(pattern);
    }
    /**
	* If the processor is set to use marked fillers, it will insert `&nbsp;` fillers wrapped in `<span>` elements
	* (`<span data-cke-filler="true">&nbsp;</span>`) instead of regular `&nbsp;` characters.
	*
	* This mode allows for a more precise handling of block fillers (so they do not leak into editor content) but
	* bloats the editor data with additional markup.
	*
	* This mode may be required by some features and will be turned on by them automatically.
	*
	* @param type Whether to use the default or the marked `&nbsp;` block fillers.
	*/ useFillerType(type) {
        this.domConverter.blockFillerMode = type == "marked" ? "markedNbsp" : "nbsp";
    }
    /**
	* Converts an XML string to its DOM representation. Returns a document fragment containing nodes parsed from
	* the provided data.
	*/ _toDom(data) {
        data = `<xml ${this.namespaces.map((nsp)=>`xmlns:${nsp}="nsp"`).join(" ")}>${data}</xml>`;
        const parsedDocument = this.domParser.parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(data), "text/xml");
        const parserError = parsedDocument.querySelector("parsererror");
        if (parserError) throw new Error("Parse error - " + parserError.textContent);
        const fragment = parsedDocument.createDocumentFragment();
        const nodes = parsedDocument.documentElement.childNodes;
        while(nodes.length > 0)fragment.appendChild(nodes[0]);
        return fragment;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Abstract base operation class.
*/ var $b9b9f2bdf9c6137f$export$ab5aad00225c5662 = class {
    /**
	* {@link module:engine/model/document~ModelDocument#version} on which operation can be applied. If you try to
	* {@link module:engine/model/model~Model#applyOperation apply} operation with different base version than the
	* {@link module:engine/model/document~ModelDocument#version document version} the
	* {@link module:utils/ckeditorerror~CKEditorError model-document-applyOperation-wrong-version} error is thrown.
	*/ baseVersion;
    /**
	* Defines whether operation is executed on attached or detached {@link module:engine/model/item~ModelItem items}.
	*/ isDocumentOperation;
    /**
	* {@link module:engine/model/batch~Batch Batch} to which the operation is added or `null` if the operation is not
	* added to any batch yet.
	*
	* Note, that a {@link #isDocumentOperation non-document operation} has this property always set to `null`, and is never added
	* to any batch.
	*/ batch;
    /**
	* Base operation constructor.
	*
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(baseVersion){
        this.baseVersion = baseVersion;
        this.isDocumentOperation = this.baseVersion !== null;
        this.batch = null;
    }
    /**
	* Checks whether the operation's parameters are correct and the operation can be correctly executed. Throws
	* an error if operation is not valid.
	*
	* @internal
	*/ _validate() {}
    /**
	* Custom toJSON method to solve child-parent circular dependencies.
	*
	* @returns Clone of this object with the operation property replaced with string.
	*/ toJSON() {
        const json = Object.assign({}, this);
        json.__className = this.constructor.className;
        delete json.batch;
        delete json.isDocumentOperation;
        return json;
    }
    /**
	* Name of the operation class used for serialization.
	*/ static get className() {
        return "Operation";
    }
    /**
	* Creates `Operation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return new this(json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/utils
*/ /**
* Inserts given nodes at given position.
*
* @internal
* @param position Position at which nodes should be inserted.
* @param nodes Nodes to insert.
* @returns Range spanning over inserted elements.
*/ function $b9b9f2bdf9c6137f$export$364d9b27c805f441(position, nodes) {
    const normalizedNodes = $b9b9f2bdf9c6137f$export$2b9abef6ff2aac7b(nodes);
    const offset = normalizedNodes.reduce((sum, node)=>sum + node.offsetSize, 0);
    const parent = position.parent;
    $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(position);
    const index = position.index;
    parent._insertChild(index, normalizedNodes);
    $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(parent, index + normalizedNodes.length);
    $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(parent, index);
    return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(position, position.getShiftedBy(offset));
}
/**
* Removed nodes in given range. Only {@link module:engine/model/range~ModelRange#isFlat flat} ranges are accepted.
*
* @internal
* @param range Range containing nodes to remove.
*/ function $b9b9f2bdf9c6137f$export$acf4a1780ce6fa8b(range) {
    if (!range.isFlat) /**
	* Trying to remove a range which starts and ends in different element.
	*
	* @error operation-utils-remove-range-not-flat
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("operation-utils-remove-range-not-flat", this);
    const parent = range.start.parent;
    $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(range.start);
    $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(range.end);
    const removed = parent._removeChildren(range.start.index, range.end.index - range.start.index);
    $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(parent, range.start.index);
    return removed;
}
/**
* Moves nodes in given range to given target position. Only {@link module:engine/model/range~ModelRange#isFlat flat} ranges are accepted.
*
* @internal
* @param sourceRange Range containing nodes to move.
* @param targetPosition Position to which nodes should be moved.
* @returns Range containing moved nodes.
*/ function $b9b9f2bdf9c6137f$export$51208bb7851e37dd(sourceRange, targetPosition) {
    if (!sourceRange.isFlat) /**
	* Trying to move a range which starts and ends in different element.
	*
	* @error operation-utils-move-range-not-flat
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("operation-utils-move-range-not-flat", this);
    const nodes = $b9b9f2bdf9c6137f$export$acf4a1780ce6fa8b(sourceRange);
    targetPosition = targetPosition._getTransformedByDeletion(sourceRange.start, sourceRange.end.offset - sourceRange.start.offset);
    return $b9b9f2bdf9c6137f$export$364d9b27c805f441(targetPosition, nodes);
}
/**
* Sets given attribute on nodes in given range. The attributes are only set on top-level nodes of the range, not on its children.
*
* @internal
* @param range Range containing nodes that should have the attribute set. Must be a flat range.
* @param key Key of attribute to set.
* @param value Attribute value.
*/ function $b9b9f2bdf9c6137f$export$12a73600ed0dd7e8(range, key, value) {
    $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(range.start);
    $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(range.end);
    for (const item of range.getItems({
        shallow: true
    })){
        const node = item.is("$textProxy") ? item.textNode : item;
        if (value !== null) node._setAttribute(key, value);
        else node._removeAttribute(key);
        $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(node.parent, node.index);
    }
    $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(range.end.parent, range.end.index);
}
/**
* Normalizes given object or an array of objects to an array of {@link module:engine/model/node~ModelNode nodes}. See
* {@link ~ModelNodeSet NodeSet} for details on how normalization is performed.
*
* @internal
* @param nodes Objects to normalize.
* @returns Normalized nodes.
*/ function $b9b9f2bdf9c6137f$export$2b9abef6ff2aac7b(nodes) {
    const normalized = [];
    function convert(nodes) {
        if (typeof nodes == "string") normalized.push(new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(nodes));
        else if (nodes instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) normalized.push(new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(nodes.data, nodes.getAttributes()));
        else if (nodes instanceof $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb) normalized.push(nodes);
        else if ((0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes)) for (const node of nodes)convert(node);
    }
    convert(nodes);
    for(let i = 1; i < normalized.length; i++){
        const node = normalized[i];
        const prev = normalized[i - 1];
        if (node instanceof $b9b9f2bdf9c6137f$export$7d1212a712b16fb5 && prev instanceof $b9b9f2bdf9c6137f$export$7d1212a712b16fb5 && $b9b9f2bdf9c6137f$var$_haveSameAttributes(node, prev)) {
            normalized.splice(i - 1, 2, new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(prev.data + node.data, prev.getAttributes()));
            i--;
        }
    }
    return normalized;
}
/**
* Checks if nodes before and after given index in given element are {@link module:engine/model/text~ModelText text nodes} and
* merges them into one node if they have same attributes.
*
* Merging is done by removing two text nodes and inserting a new text node containing data from both merged text nodes.
*
* @param element Parent element of nodes to merge.
* @param index Index between nodes to merge.
*/ function $b9b9f2bdf9c6137f$var$_mergeNodesAtIndex(element, index) {
    const nodeBefore = element.getChild(index - 1);
    const nodeAfter = element.getChild(index);
    if (nodeBefore && nodeAfter && nodeBefore.is("$text") && nodeAfter.is("$text") && $b9b9f2bdf9c6137f$var$_haveSameAttributes(nodeBefore, nodeAfter)) {
        const mergedNode = new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(nodeBefore.data + nodeAfter.data, nodeBefore.getAttributes());
        element._removeChildren(index - 1, 2);
        element._insertChild(index - 1, mergedNode);
    }
}
/**
* Checks if given position is in a text node, and if so, splits the text node in two text nodes, each of them
* containing a part of original text node.
*
* @param position Position at which node should be split.
*/ function $b9b9f2bdf9c6137f$var$_splitNodeAtPosition(position) {
    const textNode = position.textNode;
    const element = position.parent;
    if (textNode) {
        const offsetDiff = position.offset - textNode.startOffset;
        const index = textNode.index;
        element._removeChildren(index, 1);
        const firstPart = new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(textNode.data.substr(0, offsetDiff), textNode.getAttributes());
        const secondPart = new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(textNode.data.substr(offsetDiff), textNode.getAttributes());
        element._insertChild(index, [
            firstPart,
            secondPart
        ]);
    }
}
/**
* Checks whether two given nodes have same attributes.
*
* @param nodeA Node to check.
* @param nodeB Node to check.
* @returns `true` if nodes have same attributes, `false` otherwise.
*/ function $b9b9f2bdf9c6137f$var$_haveSameAttributes(nodeA, nodeB) {
    const iteratorA = nodeA.getAttributes();
    const iteratorB = nodeB.getAttributes();
    for (const attr of iteratorA){
        if (attr[1] !== nodeB.getAttribute(attr[0])) return false;
        iteratorB.next();
    }
    return iteratorB.next().done;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/moveoperation
*/ /**
* Operation to move a range of {@link module:engine/model/item~ModelItem model items}
* to given {@link module:engine/model/position~ModelPosition target position}.
*/ var $b9b9f2bdf9c6137f$export$4a4db945c69349dc = class MoveOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position before the first {@link module:engine/model/item~ModelItem model item} to move.
	*/ sourcePosition;
    /**
	* Offset size of moved range.
	*/ howMany;
    /**
	* Position at which moved nodes will be inserted.
	*/ targetPosition;
    /**
	* Creates a move operation.
	*
	* @param sourcePosition Position before the first {@link module:engine/model/item~ModelItem model item} to move.
	* @param howMany Offset size of moved range. Moved range will start from `sourcePosition` and end at
	* `sourcePosition` with offset shifted by `howMany`.
	* @param targetPosition Position at which moved nodes will be inserted.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(sourcePosition, howMany, targetPosition, baseVersion){
        super(baseVersion);
        this.sourcePosition = sourcePosition.clone();
        this.sourcePosition.stickiness = "toNext";
        this.howMany = howMany;
        this.targetPosition = targetPosition.clone();
        this.targetPosition.stickiness = "toNone";
    }
    /**
	* @inheritDoc
	*/ get type() {
        if (this.targetPosition.root.rootName == this.sourcePosition.root.rootName) return "move";
        else if (this.targetPosition.root.rootName == "$graveyard") return "remove";
        else if (this.sourcePosition.root.rootName == "$graveyard") return "reinsert";
        return "move";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return [
            this.sourceRange,
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.targetPosition, 0)
        ];
    }
    /**
	* Returns the range that is moved by this operation. This is equal to a range starting at {@link #sourcePosition} spanning over
	* {@link #howMany} nodes.
	*/ get sourceRange() {
        return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.sourcePosition, this.howMany);
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        return new MoveOperation(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
    }
    /**
	* Returns the start position of the moved range after it got moved. This may be different than
	* {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition} in some cases, i.e. when a range is moved
	* inside the same parent but {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition targetPosition}
	* is after {@link module:engine/model/operation/moveoperation~MoveOperation#sourcePosition sourcePosition}.
	*
	* ```
	*  vv              vv
	* abcdefg ===> adefbcg
	*      ^          ^
	*      targetPos  movedRangeStart
	*      offset 6   offset 4
	*```
	*/ getMovedRangeStart() {
        return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        const newTargetPosition = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
        return new MoveOperation(this.getMovedRangeStart(), this.howMany, newTargetPosition, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        const sourceElement = this.sourcePosition.parent;
        const targetElement = this.targetPosition.parent;
        const sourceOffset = this.sourcePosition.offset;
        const targetOffset = this.targetPosition.offset;
        if (sourceOffset + this.howMany > sourceElement.maxOffset) /**
		* The nodes which should be moved do not exist.
		*
		* @error move-operation-nodes-do-not-exist
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("move-operation-nodes-do-not-exist", this);
        else if (sourceElement === targetElement && sourceOffset < targetOffset && targetOffset < sourceOffset + this.howMany) /**
		* Trying to move a range of nodes into the middle of that range.
		*
		* @error move-operation-range-into-itself
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("move-operation-range-into-itself", this);
        else if (this.sourcePosition.root == this.targetPosition.root) {
            if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
                const i = this.sourcePosition.path.length - 1;
                if (this.targetPosition.path[i] >= sourceOffset && this.targetPosition.path[i] < sourceOffset + this.howMany) /**
				* Trying to move a range of nodes into one of nodes from that range.
				*
				* @error move-operation-node-into-itself
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("move-operation-node-into-itself", this);
            }
        }
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        $b9b9f2bdf9c6137f$export$51208bb7851e37dd(this.sourceRange, this.targetPosition);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.sourcePosition = this.sourcePosition.toJSON();
        json.targetPosition = this.targetPosition.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "MoveOperation";
    }
    /**
	* Creates `MoveOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        const sourcePosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.sourcePosition, document1);
        const targetPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.targetPosition, document1);
        return new this(sourcePosition, json.howMany, targetPosition, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/insertoperation
*/ /**
* Operation to insert one or more nodes at given position in the model.
*/ var $b9b9f2bdf9c6137f$export$2b3d431b09bf039a = class InsertOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position of insertion.
	*
	* @readonly
	*/ position;
    /**
	* List of nodes to insert.
	*
	* @readonly
	*/ nodes;
    /**
	* Flag deciding how the operation should be transformed. If set to `true`, nodes might get additional attributes
	* during operational transformation. This happens when the operation insertion position is inside of a range
	* where attributes have changed.
	*/ shouldReceiveAttributes;
    /**
	* Creates an insert operation.
	*
	* @param position Position of insertion.
	* @param nodes The list of nodes to be inserted.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(position, nodes, baseVersion){
        super(baseVersion);
        this.position = position.clone();
        this.position.stickiness = "toNone";
        this.nodes = new $b9b9f2bdf9c6137f$export$a6b5dd876e414da1($b9b9f2bdf9c6137f$export$2b9abef6ff2aac7b(nodes));
        this.shouldReceiveAttributes = false;
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "insert";
    }
    /**
	* Total offset size of inserted nodes.
	*/ get howMany() {
        return this.nodes.maxOffset;
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return this.position.clone();
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        const nodes = new $b9b9f2bdf9c6137f$export$a6b5dd876e414da1([
            ...this.nodes
        ].map((node)=>node._clone(true)));
        const insert = new InsertOperation(this.position, nodes, this.baseVersion);
        insert.shouldReceiveAttributes = this.shouldReceiveAttributes;
        return insert;
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        const graveyard = this.position.root.document.graveyard;
        const gyPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(graveyard, [
            0
        ]);
        return new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(this.position, this.nodes.maxOffset, gyPosition, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        const targetElement = this.position.parent;
        if (!targetElement || targetElement.maxOffset < this.position.offset) /**
		* Insertion position is invalid.
		*
		* @error insert-operation-position-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insert-operation-position-invalid", this);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        const originalNodes = this.nodes;
        this.nodes = new $b9b9f2bdf9c6137f$export$a6b5dd876e414da1([
            ...originalNodes
        ].map((node)=>node._clone(true)));
        $b9b9f2bdf9c6137f$export$364d9b27c805f441(this.position, originalNodes);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.position = this.position.toJSON();
        json.nodes = this.nodes.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "InsertOperation";
    }
    /**
	* Creates `InsertOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        const children = [];
        for (const child of json.nodes)if (child.name) children.push($b9b9f2bdf9c6137f$export$ce4fb8eac15afe31.fromJSON(child));
        else children.push($b9b9f2bdf9c6137f$export$7d1212a712b16fb5.fromJSON(child));
        const insert = new InsertOperation($b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.position, document1), children, json.baseVersion);
        insert.shouldReceiveAttributes = json.shouldReceiveAttributes;
        return insert;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/splitoperation
*/ /**
* Operation to split {@link module:engine/model/element~ModelElement an element} at given
* {@link module:engine/model/operation/splitoperation~SplitOperation#splitPosition split position} into two elements,
* both containing a part of the element's original content.
*/ var $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd = class SplitOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position at which an element should be split.
	*/ splitPosition;
    /**
	* Total offset size of elements that are in the split element after `position`.
	*/ howMany;
    /**
	* Position at which the clone of split element (or element from graveyard) will be inserted.
	*/ insertionPosition;
    /**
	* Position in the graveyard root before the element which should be used as a parent of the nodes after `position`.
	* If it is not set, a copy of the the `position` parent will be used.
	*
	* The default behavior is to clone the split element. Element from graveyard is used during undo.
	*/ graveyardPosition;
    /**
	* Creates a split operation.
	*
	* @param splitPosition Position at which an element should be split.
	* @param howMany Total offset size of elements that are in the split element after `position`.
	* @param insertionPosition Position at which the clone of split element (or element from graveyard) will be inserted.
	* @param graveyardPosition Position in the graveyard root before the element which
	* should be used as a parent of the nodes after `position`. If it is not set, a copy of the the `position` parent will be used.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(splitPosition, howMany, insertionPosition, graveyardPosition, baseVersion){
        super(baseVersion);
        this.splitPosition = splitPosition.clone();
        this.splitPosition.stickiness = "toNext";
        this.howMany = howMany;
        this.insertionPosition = insertionPosition;
        this.graveyardPosition = graveyardPosition ? graveyardPosition.clone() : null;
        if (this.graveyardPosition) this.graveyardPosition.stickiness = "toNext";
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "split";
    }
    /**
	* Position inside the new clone of a split element.
	*
	* This is a position where nodes that are after the split position will be moved to.
	*/ get moveTargetPosition() {
        const path = this.insertionPosition.path.slice();
        path.push(0);
        return new $b9b9f2bdf9c6137f$export$86023cc9eabef192(this.insertionPosition.root, path);
    }
    /**
	* Artificial range that contains all the nodes from the split element that will be moved to the new element.
	* The range starts at {@link #splitPosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
	*/ get movedRange() {
        const end = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(this.splitPosition, end);
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        const ranges = [
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.splitPosition, 0),
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.insertionPosition, 0)
        ];
        if (this.graveyardPosition) ranges.push($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.graveyardPosition, 0));
        return ranges;
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*
	* @returns Clone of this operation.
	*/ clone() {
        return new SplitOperation(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        const graveyard = this.splitPosition.root.document.graveyard;
        const graveyardPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(graveyard, [
            0
        ]);
        return new $b9b9f2bdf9c6137f$export$6df6642276507f83(this.moveTargetPosition, this.howMany, this.splitPosition, graveyardPosition, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        const element = this.splitPosition.parent;
        const offset = this.splitPosition.offset;
        if (!element || element.maxOffset < offset) /**
		* Split position is invalid.
		*
		* @error split-operation-position-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("split-operation-position-invalid", this);
        else if (!element.parent) /**
		* Cannot split root element.
		*
		* @error split-operation-split-in-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("split-operation-split-in-root", this);
        else if (this.howMany !== Number.NEGATIVE_INFINITY && this.howMany != element.maxOffset - this.splitPosition.offset) /**
		* Split operation specifies wrong number of nodes to move.
		*
		* @error split-operation-how-many-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("split-operation-how-many-invalid", this);
        else if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) /**
		* Graveyard position invalid.
		*
		* @error split-operation-graveyard-position-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("split-operation-graveyard-position-invalid", this);
        this.howMany = this.splitPosition.parent.maxOffset - this.splitPosition.offset;
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        const splitElement = this.splitPosition.parent;
        if (this.graveyardPosition) $b9b9f2bdf9c6137f$export$51208bb7851e37dd($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
        else {
            const newElement = splitElement._clone();
            $b9b9f2bdf9c6137f$export$364d9b27c805f441(this.insertionPosition, newElement);
        }
        const sourceRange = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(splitElement, this.splitPosition.offset), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(splitElement, splitElement.maxOffset));
        $b9b9f2bdf9c6137f$export$51208bb7851e37dd(sourceRange, this.moveTargetPosition);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.splitPosition = this.splitPosition.toJSON();
        json.insertionPosition = this.insertionPosition.toJSON();
        if (this.graveyardPosition) json.graveyardPosition = this.graveyardPosition.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "SplitOperation";
    }
    /**
	* Helper function that returns a default insertion position basing on given `splitPosition`. The default insertion
	* position is after the split element.
	*/ static getInsertionPosition(splitPosition) {
        const path = splitPosition.path.slice(0, -1);
        path[path.length - 1]++;
        return new $b9b9f2bdf9c6137f$export$86023cc9eabef192(splitPosition.root, path, "toPrevious");
    }
    /**
	* Creates `SplitOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        const splitPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.splitPosition, document1);
        const insertionPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.insertionPosition, document1);
        const graveyardPosition = json.graveyardPosition ? $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.graveyardPosition, document1) : null;
        return new this(splitPosition, json.howMany, insertionPosition, graveyardPosition, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/mergeoperation
*/ /**
* Operation to merge two {@link module:engine/model/element~ModelElement elements}.
*
* The merged element is the parent of {@link ~MergeOperation#sourcePosition} and it is merged into the parent of
* {@link ~MergeOperation#targetPosition}. All nodes from the merged element are moved to {@link ~MergeOperation#targetPosition}.
*
* The merged element is moved to the graveyard at {@link ~MergeOperation#graveyardPosition}.
*/ var $b9b9f2bdf9c6137f$export$6df6642276507f83 = class MergeOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position inside the merged element. All nodes from that element after that position will be moved to {@link #targetPosition}.
	*/ sourcePosition;
    /**
	* Summary offset size of nodes which will be moved from the merged element to the new parent.
	*/ howMany;
    /**
	* Position which the nodes from the merged elements will be moved to.
	*/ targetPosition;
    /**
	* Position in graveyard to which the merged element will be moved.
	*/ graveyardPosition;
    /**
	* Creates a merge operation.
	*
	* @param sourcePosition Position inside the merged element. All nodes from that
	* element after that position will be moved to {@link #targetPosition}.
	* @param howMany Summary offset size of nodes which will be moved from the merged element to the new parent.
	* @param targetPosition Position which the nodes from the merged elements will be moved to.
	* @param graveyardPosition Position in graveyard to which the merged element will be moved.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(sourcePosition, howMany, targetPosition, graveyardPosition, baseVersion){
        super(baseVersion);
        this.sourcePosition = sourcePosition.clone();
        this.sourcePosition.stickiness = "toPrevious";
        this.howMany = howMany;
        this.targetPosition = targetPosition.clone();
        this.targetPosition.stickiness = "toNext";
        this.graveyardPosition = graveyardPosition.clone();
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "merge";
    }
    /**
	* Position before the merged element (which will be deleted).
	*/ get deletionPosition() {
        return new $b9b9f2bdf9c6137f$export$86023cc9eabef192(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
    }
    /**
	* Artificial range that contains all the nodes from the merged element that will be moved to {@link ~MergeOperation#sourcePosition}.
	* The range starts at {@link ~MergeOperation#sourcePosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
	*/ get movedRange() {
        const end = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(this.sourcePosition, end);
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        const mergedElement = this.sourcePosition.parent;
        return [
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(mergedElement),
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.targetPosition, 0),
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.graveyardPosition, 0)
        ];
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        return new MergeOperation(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        const targetPosition = this.targetPosition._getTransformedByMergeOperation(this);
        const path = this.sourcePosition.path.slice(0, -1);
        const insertionPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(this.sourcePosition.root, path)._getTransformedByMergeOperation(this);
        return new $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd(targetPosition, this.howMany, insertionPosition, this.graveyardPosition, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        const sourceElement = this.sourcePosition.parent;
        const targetElement = this.targetPosition.parent;
        if (!sourceElement.parent) /**
		* Merge source position is invalid. The element to be merged must have a parent node.
		*
		* @error merge-operation-source-position-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("merge-operation-source-position-invalid", this);
        else if (!targetElement.parent) /**
		* Merge target position is invalid. The element to be merged must have a parent node.
		*
		* @error merge-operation-target-position-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("merge-operation-target-position-invalid", this);
        else if (this.howMany !== Number.NEGATIVE_INFINITY && this.howMany != sourceElement.maxOffset) /**
		* Merge operation specifies wrong number of nodes to move.
		*
		* @error merge-operation-how-many-invalid
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("merge-operation-how-many-invalid", this);
        this.howMany = this.sourcePosition.parent.maxOffset;
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        const mergedElement = this.sourcePosition.parent;
        const sourceRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(mergedElement);
        $b9b9f2bdf9c6137f$export$51208bb7851e37dd(sourceRange, this.targetPosition);
        $b9b9f2bdf9c6137f$export$51208bb7851e37dd($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(mergedElement), this.graveyardPosition);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.sourcePosition = json.sourcePosition.toJSON();
        json.targetPosition = json.targetPosition.toJSON();
        json.graveyardPosition = json.graveyardPosition.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "MergeOperation";
    }
    /**
	* Creates `MergeOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        const sourcePosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.sourcePosition, document1);
        const targetPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.targetPosition, document1);
        const graveyardPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.graveyardPosition, document1);
        return new this(sourcePosition, json.howMany, targetPosition, graveyardPosition, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/markeroperation
*/ var $b9b9f2bdf9c6137f$export$80e018754b96197a = class MarkerOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Marker name.
	*
	* @readonly
	*/ name;
    /**
	* Marker range before the change.
	*
	* @readonly
	*/ oldRange;
    /**
	* Marker range after the change.
	*
	* @readonly
	*/ newRange;
    /**
	* Specifies whether the marker operation affects the data produced by the data pipeline
	* (is persisted in the editor's data).
	*
	* @readonly
	*/ affectsData;
    /**
	* Marker collection on which change should be executed.
	*/ _markers;
    /**
	* @param name Marker name.
	* @param oldRange Marker range before the change.
	* @param newRange Marker range after the change.
	* @param markers Marker collection on which change should be executed.
	* @param affectsData Specifies whether the marker operation affects the data produced by the data pipeline
	* (is persisted in the editor's data).
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(name, oldRange, newRange, markers, affectsData, baseVersion){
        super(baseVersion);
        this.name = name;
        this.oldRange = oldRange ? oldRange.clone() : null;
        this.newRange = newRange ? newRange.clone() : null;
        this.affectsData = affectsData;
        this._markers = markers;
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "marker";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        const ranges = [];
        if (this.oldRange) ranges.push(this.oldRange.clone());
        if (this.newRange) {
            if (this.oldRange) ranges.push(...this.newRange.getDifference(this.oldRange));
            else ranges.push(this.newRange.clone());
        }
        return ranges;
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        return new MarkerOperation(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        return new MarkerOperation(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        if (this.newRange) this._markers._set(this.name, this.newRange, true, this.affectsData);
        else this._markers._remove(this.name);
    }
    /**
	* @inheritDoc
	* @internal
	*/ toJSON() {
        const json = super.toJSON();
        if (this.oldRange) json.oldRange = this.oldRange.toJSON();
        if (this.newRange) json.newRange = this.newRange.toJSON();
        delete json._markers;
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "MarkerOperation";
    }
    /**
	* Creates `MarkerOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return new MarkerOperation(json.name, json.oldRange ? $b9b9f2bdf9c6137f$export$a3091252a5e626ba.fromJSON(json.oldRange, document1) : null, json.newRange ? $b9b9f2bdf9c6137f$export$a3091252a5e626ba.fromJSON(json.newRange, document1) : null, document1.model.markers, json.affectsData, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/attributeoperation
*/ /**
* Operation to change nodes' attribute.
*
* Using this class you can add, remove or change value of the attribute.
*/ var $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2 = class AttributeOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Range on which operation should be applied.
	*
	* @readonly
	*/ range;
    /**
	* Key of an attribute to change or remove.
	*
	* @readonly
	*/ key;
    /**
	* Old value of the attribute with given key or `null`, if attribute was not set before.
	*
	* @readonly
	*/ oldValue;
    /**
	* New value of the attribute with given key or `null`, if operation should remove attribute.
	*
	* @readonly
	*/ newValue;
    /**
	* Creates an operation that changes, removes or adds attributes.
	*
	* If only `newValue` is set, attribute will be added on a node. Note that all nodes in operation's range must not
	* have an attribute with the same key as the added attribute.
	*
	* If only `oldValue` is set, then attribute with given key will be removed. Note that all nodes in operation's range
	* must have an attribute with that key added.
	*
	* If both `newValue` and `oldValue` are set, then the operation will change the attribute value. Note that all nodes in
	* operation's ranges must already have an attribute with given key and `oldValue` as value
	*
	* @param range Range on which the operation should be applied. Must be a flat range.
	* @param key Key of an attribute to change or remove.
	* @param oldValue Old value of the attribute with given key or `null`, if attribute was not set before.
	* @param newValue New value of the attribute with given key or `null`, if operation should remove attribute.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(range, key, oldValue, newValue, baseVersion){
        super(baseVersion);
        this.range = range.clone();
        this.key = key;
        this.oldValue = oldValue === void 0 ? null : oldValue;
        this.newValue = newValue === void 0 ? null : newValue;
    }
    /**
	* @inheritDoc
	*/ get type() {
        if (this.oldValue === null) return "addAttribute";
        else if (this.newValue === null) return "removeAttribute";
        else return "changeAttribute";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return this.range.clone();
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        return new AttributeOperation(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        return new AttributeOperation(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.range = this.range.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        if (!this.range.isFlat) /**
		* The range to change is not flat.
		*
		* @error attribute-operation-range-not-flat
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("attribute-operation-range-not-flat", this);
        for (const item of this.range.getItems({
            shallow: true
        })){
            if (this.oldValue !== null && !(0, $a48d2f3392454588$export$248d38f6296296c5)(item.getAttribute(this.key), this.oldValue)) /**
			* Changed node has different attribute value than operation's old attribute value.
			*
			* @error attribute-operation-wrong-old-value
			* @param {module:engine/model/item~ModelItem} root The item element.
			* @param {string} key The key of the attribute.
			* @param {never} value The value.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("attribute-operation-wrong-old-value", this, {
                item: item,
                key: this.key,
                value: this.oldValue
            });
            if (this.oldValue === null && this.newValue !== null && item.hasAttribute(this.key)) /**
			* The attribute with given key already exists for the given node.
			*
			* @error attribute-operation-attribute-exists
			* @param {module:engine/model/item~ModelItem} root The item element.
			* @param {string} key The key of the attribute.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("attribute-operation-attribute-exists", this, {
                node: item,
                key: this.key
            });
        }
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        if (!(0, $a48d2f3392454588$export$248d38f6296296c5)(this.oldValue, this.newValue)) $b9b9f2bdf9c6137f$export$12a73600ed0dd7e8(this.range, this.key, this.newValue);
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "AttributeOperation";
    }
    /**
	* Creates `AttributeOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return new AttributeOperation($b9b9f2bdf9c6137f$export$a3091252a5e626ba.fromJSON(json.range, document1), json.key, json.oldValue, json.newValue, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/nooperation
*/ /**
* Operation which is doing nothing ("empty operation", "do-nothing operation", "noop"). This is an operation,
* which when executed does not change the tree model. It still has some parameters defined for transformation purposes.
*
* In most cases this operation is a result of transforming operations. When transformation returns
* {@link module:engine/model/operation/nooperation~NoOperation} it means that changes done by the transformed operation
* have already been applied.
*/ var $b9b9f2bdf9c6137f$export$61a108126838e575 = class NoOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    get type() {
        return "noop";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return null;
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*/ clone() {
        return new NoOperation(this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        return new NoOperation(this.baseVersion + 1);
    }
    /** @internal */ _execute() {}
    /**
	* @inheritDoc
	*/ static get className() {
        return "NoOperation";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/renameoperation
*/ /**
* Operation to change element's name.
*
* Using this class you can change element's name.
*/ var $b9b9f2bdf9c6137f$export$8dc329ebf40a8040 = class RenameOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position before an element to change.
	*/ position;
    /**
	* Current name of the element.
	*/ oldName;
    /**
	* New name for the element.
	*/ newName;
    /**
	* Creates an operation that changes element's name.
	*
	* @param position Position before an element to change.
	* @param oldName Current name of the element.
	* @param newName New name for the element.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(position, oldName, newName, baseVersion){
        super(baseVersion);
        this.position = position;
        this.position.stickiness = "toNext";
        this.oldName = oldName;
        this.newName = newName;
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "rename";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return this.position.nodeAfter;
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*
	* @returns Clone of this operation.
	*/ clone() {
        return new RenameOperation(this.position.clone(), this.oldName, this.newName, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        return new RenameOperation(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        const element = this.position.nodeAfter;
        if (!(element instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
		* Given position is invalid or node after it is not instance of Element.
		*
		* @error rename-operation-wrong-position
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rename-operation-wrong-position", this);
        else if (this.oldName !== "" && element.name !== this.oldName) /**
		* Element to change has different name than operation's old name.
		*
		* @error rename-operation-wrong-name
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rename-operation-wrong-name", this);
        this.oldName = element.name;
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        const element = this.position.nodeAfter;
        element.name = this.newName;
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.position = this.position.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "RenameOperation";
    }
    /**
	* Creates `RenameOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return new RenameOperation($b9b9f2bdf9c6137f$export$86023cc9eabef192.fromJSON(json.position, document1), json.oldName, json.newName, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/rootattributeoperation
*/ /**
* Operation to change root element's attribute. Using this class you can add, remove or change value of the attribute.
*
* This operation is needed, because root elements can't be changed through
* {@link module:engine/model/operation/attributeoperation~AttributeOperation}.
* It is because {@link module:engine/model/operation/attributeoperation~AttributeOperation}
* requires a range to change and root element can't
* be a part of range because every {@link module:engine/model/position~ModelPosition} has to be inside a root.
* {@link module:engine/model/position~ModelPosition} can't be created before a root element.
*/ var $b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef = class RootAttributeOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Root element to change.
	*/ root;
    /**
	* Key of an attribute to change or remove.
	*/ key;
    /**
	* Old value of the attribute with given key or `null`, if attribute was not set before.
	*
	* @readonly
	*/ oldValue;
    /**
	* New value of the attribute with given key or `null`, if operation should remove attribute.
	*
	* @readonly
	*/ newValue;
    /**
	* Creates an operation that changes, removes or adds attributes on root element.
	*
	* @see module:engine/model/operation/attributeoperation~AttributeOperation
	* @param root Root element to change.
	* @param key Key of an attribute to change or remove.
	* @param oldValue Old value of the attribute with given key or `null`, if attribute was not set before.
	* @param newValue New value of the attribute with given key or `null`, if operation should remove attribute.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation
	* can be applied or `null` if the operation operates on detached (non-document) tree.
	*/ constructor(root, key, oldValue, newValue, baseVersion){
        super(baseVersion);
        this.root = root;
        this.key = key;
        this.oldValue = oldValue === void 0 ? null : oldValue;
        this.newValue = newValue === void 0 ? null : newValue;
    }
    /**
	* @inheritDoc
	*/ get type() {
        if (this.oldValue === null) return "addRootAttribute";
        else if (this.newValue === null) return "removeRootAttribute";
        else return "changeRootAttribute";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return this.root;
    }
    /**
	* Creates and returns an operation that has the same parameters as this operation.
	*
	* @returns Clone of this operation.
	*/ clone() {
        return new RootAttributeOperation(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
    /**
	* See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
	*/ getReversed() {
        return new RootAttributeOperation(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        if (this.root != this.root.root || this.root.is("documentFragment")) /**
		* The element to change is not a root element.
		*
		* @error rootattribute-operation-not-a-root
		* @param {module:engine/model/rootelement~ModelRootElement} root The root element.
		* @param {string} key The key of the attribute.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rootattribute-operation-not-a-root", this, {
            root: this.root,
            key: this.key
        });
        if (this.oldValue !== null && !(0, $a48d2f3392454588$export$248d38f6296296c5)(this.root.getAttribute(this.key), this.oldValue)) /**
		* The attribute which should be removed does not exist for the given node.
		*
		* @error rootattribute-operation-wrong-old-value
		* @param {module:engine/model/rootelement~ModelRootElement} root The root element.
		* @param {string} key The key of the attribute.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rootattribute-operation-wrong-old-value", this, {
            root: this.root,
            key: this.key
        });
        if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) /**
		* The attribute with given key already exists for the given node.
		*
		* @error rootattribute-operation-attribute-exists
		* @param {module:engine/model/rootelement~ModelRootElement} root The root element.
		* @param {string} key The key of the attribute.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rootattribute-operation-attribute-exists", this, {
            root: this.root,
            key: this.key
        });
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        if (this.newValue !== null) this.root._setAttribute(this.key, this.newValue);
        else this.root._removeAttribute(this.key);
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.root = this.root.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "RootAttributeOperation";
    }
    /**
	* Creates `RootAttributeOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        if (!document1.getRoot(json.root)) /**
		* Cannot create RootAttributeOperation for document. Root with the specified name does not exist.
		*
		* @error rootattribute-operation-fromjson-no-root
		* @param {string} rootName The root name.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("rootattribute-operation-fromjson-no-root", this, {
            rootName: json.root
        });
        return new RootAttributeOperation(document1.getRoot(json.root), json.key, json.oldValue, json.newValue, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/rootoperation
*/ /**
* Operation that creates (or attaches) or detaches a root element.
*/ var $b9b9f2bdf9c6137f$export$58241c4268d122b7 = class RootOperation extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Root name to create or detach.
	*/ rootName;
    /**
	* Root element name.
	*/ elementName;
    /**
	* Specifies whether the operation adds (`true`) or detaches the root (`false`).
	*/ isAdd;
    /**
	* Document which owns the root.
	*/ _document;
    /**
	* Creates an operation that creates or removes a root element.
	*
	* @param rootName Root name to create or detach.
	* @param elementName Root element name.
	* @param isAdd Specifies whether the operation adds (`true`) or detaches the root (`false`).
	* @param document Document which owns the root.
	* @param baseVersion Document {@link module:engine/model/document~ModelDocument#version} on which operation can be applied.
	*/ constructor(rootName, elementName, isAdd, document1, baseVersion){
        super(baseVersion);
        this.rootName = rootName;
        this.elementName = elementName;
        this.isAdd = isAdd;
        this._document = document1;
        if (!this._document.getRoot(this.rootName)) {
            const root = this._document.createRoot(this.elementName, this.rootName);
            root._isAttached = false;
        }
    }
    /**
	* @inheritDoc
	*/ get type() {
        return this.isAdd ? "addRoot" : "detachRoot";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return this._document.getRoot(this.rootName);
    }
    /**
	* @inheritDoc
	*/ clone() {
        return new RootOperation(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
    }
    /**
	* @inheritDoc
	*/ getReversed() {
        return new RootOperation(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
    }
    /**
	* @inheritDoc
	*/ _execute() {
        this._document.getRoot(this.rootName)._isAttached = this.isAdd;
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        delete json._document;
        return json;
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "RootOperation";
    }
    /**
	* Creates `RootOperation` object from deserialized object, i.e. from parsed JSON string.
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return new RootOperation(json.rootName, json.elementName, json.isAdd, document1, json.baseVersion);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/operationfactory
*/ const $b9b9f2bdf9c6137f$var$operations = {};
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2.className] = $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$2b3d431b09bf039a.className] = $b9b9f2bdf9c6137f$export$2b3d431b09bf039a;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$80e018754b96197a.className] = $b9b9f2bdf9c6137f$export$80e018754b96197a;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$4a4db945c69349dc.className] = $b9b9f2bdf9c6137f$export$4a4db945c69349dc;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$61a108126838e575.className] = $b9b9f2bdf9c6137f$export$61a108126838e575;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$ab5aad00225c5662.className] = $b9b9f2bdf9c6137f$export$ab5aad00225c5662;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$8dc329ebf40a8040.className] = $b9b9f2bdf9c6137f$export$8dc329ebf40a8040;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef.className] = $b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$58241c4268d122b7.className] = $b9b9f2bdf9c6137f$export$58241c4268d122b7;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.className] = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd;
$b9b9f2bdf9c6137f$var$operations[$b9b9f2bdf9c6137f$export$6df6642276507f83.className] = $b9b9f2bdf9c6137f$export$6df6642276507f83;
/**
* A factory class for creating operations.
*/ var $b9b9f2bdf9c6137f$export$3420ec38c4e386fa = class {
    /**
	* Creates an operation instance from a JSON object (parsed JSON string).
	*
	* @param json Deserialized JSON object.
	* @param document Document on which this operation will be applied.
	*/ static fromJSON(json, document1) {
        return $b9b9f2bdf9c6137f$var$operations[json.__className].fromJSON(json, document1);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/transform
*/ const $b9b9f2bdf9c6137f$var$transformations = /* @__PURE__ */ new Map();
/**
* Sets a transformation function to be be used to transform instances of class `OperationA` by instances of class `OperationB`.
*
* The `transformationFunction` is passed three parameters:
*
* * `a` - operation to be transformed, an instance of `OperationA`,
* * `b` - operation to be transformed by, an instance of `OperationB`,
* * {@link module:engine/model/operation/transform~TransformationContext `context`} - object with additional information about
* transformation context.
*
* The `transformationFunction` should return transformation result, which is an array with one or multiple
* {@link module:engine/model/operation/operation~Operation operation} instances.
*
* @param transformationFunction Function to use for transforming.
*/ function $b9b9f2bdf9c6137f$var$setTransformation(OperationA, OperationB, transformationFunction) {
    let aGroup = $b9b9f2bdf9c6137f$var$transformations.get(OperationA);
    if (!aGroup) {
        aGroup = /* @__PURE__ */ new Map();
        $b9b9f2bdf9c6137f$var$transformations.set(OperationA, aGroup);
    }
    aGroup.set(OperationB, transformationFunction);
}
/**
* Returns a previously set transformation function for transforming an instance of `OperationA` by an instance of `OperationB`.
*
* If no transformation was set for given pair of operations, {@link module:engine/model/operation/transform~noUpdateTransformation}
* is returned. This means that if no transformation was set, the `OperationA` instance will not change when transformed
* by the `OperationB` instance.
*
* @returns Function set to transform an instance of `OperationA` by an instance of `OperationB`.
*/ function $b9b9f2bdf9c6137f$var$getTransformation(OperationA, OperationB) {
    const aGroup = $b9b9f2bdf9c6137f$var$transformations.get(OperationA);
    if (aGroup && aGroup.has(OperationB)) return aGroup.get(OperationB);
    return $b9b9f2bdf9c6137f$var$noUpdateTransformation;
}
/**
* A transformation function that only clones operation to transform, without changing it.
*/ function $b9b9f2bdf9c6137f$var$noUpdateTransformation(a) {
    return [
        a
    ];
}
/**
* Transforms operation `a` by operation `b`.
*
* @param a Operation to be transformed.
* @param b Operation to transform by.
* @param context Transformation context for this transformation.
* @returns Transformation result.
* @internal
*/ function $b9b9f2bdf9c6137f$export$e1c9df2da5213af5(a, b, context = {}) {
    const transformationFunction = $b9b9f2bdf9c6137f$var$getTransformation(a.constructor, b.constructor);
    try {
        a = a.clone();
        return transformationFunction(a, b, context);
    } catch (e) {
        throw e;
    }
}
/**
* Performs a transformation of two sets of operations - `operationsA` and `operationsB`. The transformation is two-way -
* both transformed `operationsA` and transformed `operationsB` are returned.
*
* Note, that the first operation in each set should base on the same document state (
* {@link module:engine/model/document~ModelDocument#version document version}).
*
* It is assumed that `operationsA` are "more important" during conflict resolution between two operations.
*
* New copies of both passed arrays and operations inside them are returned. Passed arguments are not altered.
*
* Base versions of the transformed operations sets are updated accordingly. For example, assume that base versions are `4`
* and there are `3` operations in `operationsA` and `5` operations in `operationsB`. Then:
*
* * transformed `operationsA` will start from base version `9` (`4` base version + `5` operations B),
* * transformed `operationsB` will start from base version `7` (`4` base version + `3` operations A).
*
* If no operation was broken into two during transformation, then both sets will end up with an operation that bases on version `11`:
*
* * transformed `operationsA` start from `9` and there are `3` of them, so the last will have `baseVersion` equal to `11`,
* * transformed `operationsB` start from `7` and there are `5` of them, so the last will have `baseVersion` equal to `11`.
*
* @param operationsA
* @param operationsB
* @param options Additional transformation options.
* @param options.document Document which the operations change.
* @param options.useRelations Whether during transformation relations should be used (used during undo for better conflict resolution).
* @param options.padWithNoOps Whether additional {@link module:engine/model/operation/nooperation~NoOperation}s
* should be added to the transformation results to force the same last base version for both transformed sets (in case
* if some operations got broken into multiple operations during transformation).
* @param options.forceWeakRemove If set to `false`, remove operation will be always stronger than move operation,
* so the removed nodes won't end up back in the document root. When set to `true`, context data will be used.
* @returns Transformation result.
*/ function $b9b9f2bdf9c6137f$export$96d3a21d249d408c(operationsA, operationsB, options) {
    operationsA = operationsA.slice();
    operationsB = operationsB.slice();
    const contextFactory = new $b9b9f2bdf9c6137f$var$ContextFactory(options.document, options.useRelations, options.forceWeakRemove);
    contextFactory.setOriginalOperations(operationsA);
    contextFactory.setOriginalOperations(operationsB);
    const originalOperations = contextFactory.originalOperations;
    if (operationsA.length == 0 || operationsB.length == 0) return {
        operationsA: operationsA,
        operationsB: operationsB,
        originalOperations: originalOperations
    };
    const nextTransformIndex = /* @__PURE__ */ new WeakMap();
    for (const op of operationsA)nextTransformIndex.set(op, 0);
    const data = {
        nextBaseVersionA: operationsA[operationsA.length - 1].baseVersion + 1,
        nextBaseVersionB: operationsB[operationsB.length - 1].baseVersion + 1,
        originalOperationsACount: operationsA.length,
        originalOperationsBCount: operationsB.length
    };
    let i = 0;
    while(i < operationsA.length){
        const opA = operationsA[i];
        const indexB = nextTransformIndex.get(opA);
        if (indexB == operationsB.length) {
            i++;
            continue;
        }
        const opB = operationsB[indexB];
        const newOpsA = $b9b9f2bdf9c6137f$export$e1c9df2da5213af5(opA, opB, contextFactory.getContext(opA, opB, true));
        const newOpsB = $b9b9f2bdf9c6137f$export$e1c9df2da5213af5(opB, opA, contextFactory.getContext(opB, opA, false));
        contextFactory.updateRelation(opA, opB);
        contextFactory.setOriginalOperations(newOpsA, opA);
        contextFactory.setOriginalOperations(newOpsB, opB);
        for (const newOpA of newOpsA)nextTransformIndex.set(newOpA, indexB + newOpsB.length);
        operationsA.splice(i, 1, ...newOpsA);
        operationsB.splice(indexB, 1, ...newOpsB);
    }
    $b9b9f2bdf9c6137f$var$handlePartialMarkerOperations(operationsA);
    $b9b9f2bdf9c6137f$var$handlePartialMarkerOperations(operationsB);
    if (options.padWithNoOps) {
        const brokenOperationsACount = operationsA.length - data.originalOperationsACount;
        const brokenOperationsBCount = operationsB.length - data.originalOperationsBCount;
        $b9b9f2bdf9c6137f$var$padWithNoOps(operationsA, brokenOperationsBCount - brokenOperationsACount);
        $b9b9f2bdf9c6137f$var$padWithNoOps(operationsB, brokenOperationsACount - brokenOperationsBCount);
    }
    $b9b9f2bdf9c6137f$var$updateBaseVersions(operationsA, data.nextBaseVersionB);
    $b9b9f2bdf9c6137f$var$updateBaseVersions(operationsB, data.nextBaseVersionA);
    return {
        operationsA: operationsA,
        operationsB: operationsB,
        originalOperations: originalOperations
    };
}
/**
* Gathers additional data about operations processed during transformation. Can be used to obtain contextual information
* about two operations that are about to be transformed. This contextual information can be used for better conflict resolution.
*/ var $b9b9f2bdf9c6137f$var$ContextFactory = class {
    originalOperations;
    _history;
    _useRelations;
    _forceWeakRemove;
    _relations;
    /**
	* Creates `ContextFactory` instance.
	*
	* @param document Document which the operations change.
	* @param useRelations Whether during transformation relations should be used (used during undo for
	* better conflict resolution).
	* @param forceWeakRemove If set to `false`, remove operation will be always stronger than move operation,
	* so the removed nodes won't end up back in the document root. When set to `true`, context data will be used.
	*/ constructor(document1, useRelations, forceWeakRemove = false){
        this.originalOperations = /* @__PURE__ */ new Map();
        this._history = document1.history;
        this._useRelations = useRelations;
        this._forceWeakRemove = !!forceWeakRemove;
        this._relations = /* @__PURE__ */ new Map();
    }
    /**
	* Sets "original operation" for given operations.
	*
	* During transformation process, operations are cloned, then changed, then processed again, sometimes broken into two
	* or multiple operations. When gathering additional data it is important that all operations can be somehow linked
	* so a cloned and transformed "version" still kept track of the data assigned earlier to it.
	*
	* The original operation object will be used as such an universal linking id. Throughout the transformation process
	* all cloned operations will refer to "the original operation" when storing and reading additional data.
	*
	* If `takeFrom` is not set, each operation from `operations` array will be assigned itself as "the original operation".
	* This should be used as an initialization step.
	*
	* If `takeFrom` is set, each operation from `operations` will be assigned the same original operation as assigned
	* for `takeFrom` operation. This should be used to update original operations. It should be used in a way that
	* `operations` are the result of `takeFrom` transformation to ensure proper "original operation propagation".
	*/ setOriginalOperations(operations, takeFrom = null) {
        const originalOperation = takeFrom ? this.originalOperations.get(takeFrom) : null;
        for (const operation of operations)this.originalOperations.set(operation, originalOperation || operation);
    }
    /**
	* Saves a relation between operations `opA` and `opB`.
	*
	* Relations are then later used to help solve conflicts when operations are transformed.
	*/ updateRelation(opA, opB) {
        if (opA instanceof $b9b9f2bdf9c6137f$export$4a4db945c69349dc) {
            if (opB instanceof $b9b9f2bdf9c6137f$export$6df6642276507f83) {
                if (opA.targetPosition.isEqual(opB.sourcePosition) || opB.movedRange.containsPosition(opA.targetPosition)) this._setRelation(opA, opB, "insertAtSource");
                else if (opA.targetPosition.isEqual(opB.deletionPosition)) this._setRelation(opA, opB, "insertBetween");
                else if (opA.targetPosition.isAfter(opB.sourcePosition)) this._setRelation(opA, opB, "moveTargetAfter");
                else if (opA.howMany > 1 && opA.sourcePosition.isEqual(opB.deletionPosition)) this._setRelation(opA, opB, "firstToMoveMerged");
                else if (opA.howMany > 1 && opA.sourcePosition.getShiftedBy(opA.howMany - 1).isEqual(opB.deletionPosition)) this._setRelation(opA, opB, "lastToMoveMerged");
            } else if (opB instanceof $b9b9f2bdf9c6137f$export$4a4db945c69349dc) {
                if (opA.targetPosition.isEqual(opB.sourcePosition) || opA.targetPosition.isBefore(opB.sourcePosition)) this._setRelation(opA, opB, "insertBefore");
                else this._setRelation(opA, opB, "insertAfter");
            }
        } else if (opA instanceof $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd) {
            if (opB instanceof $b9b9f2bdf9c6137f$export$6df6642276507f83) {
                if (opA.splitPosition.isBefore(opB.sourcePosition)) this._setRelation(opA, opB, "splitBefore");
            } else if (opB instanceof $b9b9f2bdf9c6137f$export$4a4db945c69349dc) {
                if (opA.splitPosition.isEqual(opB.sourcePosition) || opA.splitPosition.isBefore(opB.sourcePosition)) this._setRelation(opA, opB, "splitBefore");
                else {
                    const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(opB.sourcePosition, opB.howMany);
                    if (opA.splitPosition.hasSameParentAs(opB.sourcePosition) && range.containsPosition(opA.splitPosition)) {
                        const howMany = range.end.offset - opA.splitPosition.offset;
                        const offset = opA.splitPosition.offset - range.start.offset;
                        this._setRelation(opA, opB, {
                            howMany: howMany,
                            offset: offset
                        });
                    }
                }
            }
        } else if (opA instanceof $b9b9f2bdf9c6137f$export$6df6642276507f83) {
            if (opB instanceof $b9b9f2bdf9c6137f$export$6df6642276507f83) {
                if (!opA.targetPosition.isEqual(opB.sourcePosition)) this._setRelation(opA, opB, "mergeTargetNotMoved");
                if (opA.sourcePosition.isEqual(opB.targetPosition)) this._setRelation(opA, opB, "mergeSourceNotMoved");
                if (opA.sourcePosition.isEqual(opB.sourcePosition)) this._setRelation(opA, opB, "mergeSameElement");
            } else if (opB instanceof $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd) {
                if (opA.sourcePosition.isEqual(opB.splitPosition)) this._setRelation(opA, opB, "splitAtSource");
            } else if (opB instanceof $b9b9f2bdf9c6137f$export$4a4db945c69349dc && opB.howMany > 0) {
                if (opA.sourcePosition.isEqual(opB.sourcePosition.getShiftedBy(opB.howMany))) this._setRelation(opA, opB, "mergeSourceAffected");
                if (opA.targetPosition.isEqual(opB.sourcePosition)) this._setRelation(opA, opB, "mergeTargetWasBefore");
            }
        } else if (opA instanceof $b9b9f2bdf9c6137f$export$80e018754b96197a) {
            const markerRange = opA.newRange;
            if (!markerRange) return;
            if (opB instanceof $b9b9f2bdf9c6137f$export$6df6642276507f83) {
                const wasInLeftElement = markerRange.start.isEqual(opB.targetPosition);
                const wasStartBeforeMergedElement = markerRange.start.isEqual(opB.deletionPosition);
                const wasEndBeforeMergedElement = markerRange.end.isEqual(opB.deletionPosition);
                const wasInRightElement = markerRange.end.isEqual(opB.sourcePosition);
                if (wasInLeftElement || wasStartBeforeMergedElement || wasEndBeforeMergedElement || wasInRightElement) this._setRelation(opA, opB, {
                    wasInLeftElement: wasInLeftElement,
                    wasStartBeforeMergedElement: wasStartBeforeMergedElement,
                    wasEndBeforeMergedElement: wasEndBeforeMergedElement,
                    wasInRightElement: wasInRightElement
                });
            }
        }
    }
    /**
	* Evaluates and returns contextual information about two given operations `opA` and `opB` which are about to be transformed.
	*/ getContext(opA, opB, aIsStrong) {
        return {
            aIsStrong: aIsStrong,
            aWasUndone: this._wasUndone(opA),
            bWasUndone: this._wasUndone(opB),
            abRelation: this._useRelations ? this._getRelation(opA, opB) : null,
            baRelation: this._useRelations ? this._getRelation(opB, opA) : null,
            forceWeakRemove: this._forceWeakRemove
        };
    }
    /**
	* Returns whether given operation `op` has already been undone.
	*
	* Information whether an operation was undone gives more context when making a decision when two operations are in conflict.
	*/ _wasUndone(op) {
        const originalOp = this.originalOperations.get(op);
        return originalOp.wasUndone || this._history.isUndoneOperation(originalOp);
    }
    /**
	* Returns a relation between `opA` and an operation which is undone by `opB`. This can be `String` value if a relation
	* was set earlier or `null` if there was no relation between those operations.
	*
	* This is a little tricky to understand, so let's compare it to `ContextFactory#_wasUndone`.
	*
	* When `wasUndone( opB )` is used, we check if the `opB` has already been undone. It is obvious, that the
	* undoing operation must happen after the undone operation. So, essentially, we have `opB`, we take document history,
	* we look forward in the future and ask if in that future `opB` was undone.
	*
	* Relations is a backward process to `wasUndone()`.
	*
	* Long story short - using relations is asking what happened in the past. Looking back. This time we have an undoing
	* operation `opB` which has undone some other operation. When there is a transformation `opA` x `opB` and there is
	* a conflict to solve and `opB` is an undoing operation, we can look back in the history and see what was a relation
	* between `opA` and the operation which `opB` undone. Basing on that relation from the past, we can now make
	* a better decision when resolving a conflict between two operations, because we know more about the context of
	* those two operations.
	*
	* This is why this function does not return a relation directly between `opA` and `opB` because we need to look
	* back to search for a meaningful contextual information.
	*/ _getRelation(opA, opB) {
        const origB = this.originalOperations.get(opB);
        const undoneB = this._history.getUndoneOperation(origB);
        if (!undoneB) return null;
        const origA = this.originalOperations.get(opA);
        const relationsA = this._relations.get(origA);
        if (relationsA) return relationsA.get(undoneB) || null;
        return null;
    }
    /**
	* Helper function for `ContextFactory#updateRelations`.
	*/ _setRelation(opA, opB, relation) {
        const origA = this.originalOperations.get(opA);
        const origB = this.originalOperations.get(opB);
        let relationsA = this._relations.get(origA);
        if (!relationsA) {
            relationsA = /* @__PURE__ */ new Map();
            this._relations.set(origA, relationsA);
        }
        relationsA.set(origB, relation);
    }
};
/**
* An utility function that updates {@link module:engine/model/operation/operation~Operation#baseVersion base versions}
* of passed operations.
*
* The function simply sets `baseVersion` as a base version of the first passed operation and then increments it for
* each following operation in `operations`.
*
* @param operations Operations to update.
* @param baseVersion Base version to set for the first operation in `operations`.
*/ function $b9b9f2bdf9c6137f$var$updateBaseVersions(operations, baseVersion) {
    for (const operation of operations)operation.baseVersion = baseVersion++;
}
/**
* Adds `howMany` instances of {@link module:engine/model/operation/nooperation~NoOperation} to `operations` set.
*/ function $b9b9f2bdf9c6137f$var$padWithNoOps(operations, howMany) {
    for(let i = 0; i < howMany; i++)operations.push(new $b9b9f2bdf9c6137f$export$61a108126838e575(0));
}
/**
* Transformed operations set may include marker operations which were broken into multiple marker operations during transformation.
* It represents marker range being broken into multiple pieces as the transformation was processed. Each partial marker operation is
* a piece of the original marker range.
*
* These partial marker operations ("marker range pieces") should be "glued" together if, after transformations, the ranges ended up
* next to each other.
*
* If the ranges did not end up next to each other, then partial marker operations should be discarded, as the marker range cannot
* be broken into two pieces.
*
* There is always one "reference" marker operation (the original operation) and there may be some partial marker operations. Partial
* marker operations have base version set to `-1`. If the `operations` set includes partial marker operations, then they are always
* after the original marker operation.
*
* See also `MarkerOperation` x `MoveOperation` transformation.
* See also https://github.com/ckeditor/ckeditor5/pull/17071.
*/ function $b9b9f2bdf9c6137f$var$handlePartialMarkerOperations(operations) {
    const markerOps = /* @__PURE__ */ new Map();
    for(let i = 0; i < operations.length; i++){
        const op = operations[i];
        if (!(op instanceof $b9b9f2bdf9c6137f$export$80e018754b96197a)) continue;
        if (op.baseVersion !== -1) markerOps.set(op.name, {
            op: op,
            ranges: op.newRange ? [
                op.newRange
            ] : []
        });
        else {
            /* v8 ignore next -- @preserve */ if (op.newRange) {
                const partialRanges = markerOps.get(op.name).ranges;
                if (!partialRanges[0].containsRange(op.newRange, true)) partialRanges.push(op.newRange);
            }
            operations.splice(i, 1);
            i--;
        }
    }
    for (const { op: op, ranges: ranges } of markerOps.values())if (ranges.length) op.newRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromRanges(ranges);
    else op.newRange = null;
}
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, (a, b, context)=>{
    if (a.key === b.key && a.range.start.hasSameParentAs(b.range.start)) {
        const operations = a.range.getDifference(b.range).map((range)=>{
            return new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, a.key, a.oldValue, a.newValue, 0);
        });
        const common = a.range.getIntersection(b.range);
        if (common) {
            if (context.aIsStrong) operations.push(new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(common, b.key, b.newValue, a.newValue, 0));
        }
        if (operations.length == 0) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
        return operations;
    } else return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    if (a.range.start.hasSameParentAs(b.position) && a.range.containsPosition(b.position)) {
        const result = a.range._getTransformedByInsertion(b.position, b.howMany, !b.shouldReceiveAttributes).map((r)=>{
            return new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(r, a.key, a.oldValue, a.newValue, a.baseVersion);
        });
        if (b.shouldReceiveAttributes) {
            const op = $b9b9f2bdf9c6137f$var$_getComplementaryAttributeOperations(b, a.key, a.oldValue);
            if (op) result.unshift(op);
        }
        return result;
    }
    a.range = a.range._getTransformedByInsertion(b.position, b.howMany, false)[0];
    return [
        a
    ];
});
/**
* Helper function for `AttributeOperation` x `InsertOperation` (and reverse) transformation.
*
* For given `insertOperation` it checks the inserted node if it has an attribute `key` set to a value different
* than `newValue`. If so, it generates an `AttributeOperation` which changes the value of `key` attribute to `newValue`.
*/ function $b9b9f2bdf9c6137f$var$_getComplementaryAttributeOperations(insertOperation, key, newValue) {
    const insertValue = insertOperation.nodes.getNode(0).getAttribute(key);
    if (insertValue == newValue) return null;
    const range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(insertOperation.position, insertOperation.position.getShiftedBy(insertOperation.howMany));
    return new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, key, insertValue, newValue, 0);
}
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b)=>{
    const ranges = [];
    if (a.range.start.hasSameParentAs(b.deletionPosition)) {
        if (a.range.containsPosition(b.deletionPosition) || a.range.start.isEqual(b.deletionPosition)) ranges.push($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(b.graveyardPosition, 1));
    }
    const range = a.range._getTransformedByMergeOperation(b);
    if (!range.isCollapsed) ranges.push(range);
    return ranges.map((range)=>{
        return new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, a.key, a.oldValue, a.newValue, a.baseVersion);
    });
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b)=>{
    return $b9b9f2bdf9c6137f$var$_breakRangeByMoveOperation(a.range, b).map((range)=>new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, a.key, a.oldValue, a.newValue, a.baseVersion));
});
/**
* Helper function for `AttributeOperation` x `MoveOperation` transformation.
*
* Takes the passed `range` and transforms it by move operation `moveOp` in a specific way. Only top-level nodes of `range`
* are considered to be in the range. If move operation moves nodes deep from inside of the range, those nodes won't
* be included in the result. In other words, top-level nodes of the ranges from the result are exactly the same as
* top-level nodes of the original `range`.
*
* This is important for `AttributeOperation` because, for its range, it changes only the top-level nodes. So we need to
* track only how those nodes have been affected by `MoveOperation`.
*/ function $b9b9f2bdf9c6137f$var$_breakRangeByMoveOperation(range, moveOp) {
    const moveRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(moveOp.sourcePosition, moveOp.howMany);
    let common = null;
    let difference = [];
    if (moveRange.containsRange(range, true)) common = range;
    else if (range.start.hasSameParentAs(moveRange.start)) {
        difference = range.getDifference(moveRange);
        common = range.getIntersection(moveRange);
    } else difference = [
        range
    ];
    const result = [];
    for (let diff of difference){
        diff = diff._getTransformedByDeletion(moveOp.sourcePosition, moveOp.howMany);
        const targetPosition = moveOp.getMovedRangeStart();
        const spread = diff.start.hasSameParentAs(targetPosition);
        const diffs = diff._getTransformedByInsertion(targetPosition, moveOp.howMany, spread);
        result.push(...diffs);
    }
    if (common) result.push(common._getTransformedByMove(moveOp.sourcePosition, moveOp.targetPosition, moveOp.howMany, false)[0]);
    return result;
}
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b)=>{
    if (a.range.end.isEqual(b.insertionPosition)) {
        if (!b.graveyardPosition) a.range.end.offset++;
        return [
            a
        ];
    }
    if (a.range.start.hasSameParentAs(b.splitPosition) && a.range.containsPosition(b.splitPosition)) {
        const secondPart = a.clone();
        secondPart.range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(b.moveTargetPosition.clone(), a.range.end._getCombined(b.splitPosition, b.moveTargetPosition));
        a.range.end = b.splitPosition.clone();
        a.range.end.stickiness = "toPrevious";
        return [
            a,
            secondPart
        ];
    }
    a.range = a.range._getTransformedBySplitOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$2b3d431b09bf039a, $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2, (a, b)=>{
    const result = [
        a
    ];
    if (a.shouldReceiveAttributes && a.position.hasSameParentAs(b.range.start) && b.range.containsPosition(a.position)) {
        const op = $b9b9f2bdf9c6137f$var$_getComplementaryAttributeOperations(a, b.key, b.newValue);
        if (op) result.push(op);
    }
    return result;
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$2b3d431b09bf039a, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b, context)=>{
    if (a.position.isEqual(b.position) && context.aIsStrong) return [
        a
    ];
    a.position = a.position._getTransformedByInsertOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$2b3d431b09bf039a, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b)=>{
    a.position = a.position._getTransformedByMoveOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$2b3d431b09bf039a, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b)=>{
    a.position = a.position._getTransformedBySplitOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$2b3d431b09bf039a, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b)=>{
    a.position = a.position._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$80e018754b96197a, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    if (a.oldRange) a.oldRange = a.oldRange._getTransformedByInsertOperation(b)[0];
    if (a.newRange) a.newRange = a.newRange._getTransformedByInsertOperation(b)[0];
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$80e018754b96197a, $b9b9f2bdf9c6137f$export$80e018754b96197a, (a, b, context)=>{
    if (a.name == b.name) {
        if (context.aIsStrong) a.oldRange = b.newRange ? b.newRange.clone() : null;
        else return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
    }
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$80e018754b96197a, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b)=>{
    if (a.oldRange) a.oldRange = a.oldRange._getTransformedByMergeOperation(b);
    if (a.newRange) a.newRange = a.newRange._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$80e018754b96197a, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b)=>{
    const result = [
        a
    ];
    if (a.oldRange) a.oldRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromRanges(a.oldRange._getTransformedByMoveOperation(b));
    if (a.newRange) {
        const ranges = a.newRange._getTransformedByMoveOperation(b);
        a.newRange = ranges[0];
        for(let i = 1; i < ranges.length; i++){
            const op = a.clone();
            op.oldRange = null;
            op.newRange = ranges[i];
            op.baseVersion = -1;
            result.push(op);
        }
    }
    return result;
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$80e018754b96197a, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b, context)=>{
    if (a.oldRange) a.oldRange = a.oldRange._getTransformedBySplitOperation(b);
    if (a.newRange) {
        if (context.abRelation) {
            const aNewRange = a.newRange._getTransformedBySplitOperation(b);
            if (a.newRange.start.isEqual(b.splitPosition)) {
                if (context.abRelation.wasStartBeforeMergedElement) a.newRange.start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(b.insertionPosition);
                else if (context.abRelation.wasInLeftElement) a.newRange.start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(a.newRange.start);
                else a.newRange.start = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(b.moveTargetPosition);
            } else a.newRange.start = aNewRange.start;
            if (a.newRange.end.isEqual(b.splitPosition)) {
                if (a.newRange.end.isEqual(b.splitPosition) && context.abRelation.wasEndBeforeMergedElement) a.newRange.end = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(b.insertionPosition);
                else if (context.abRelation.wasInRightElement) a.newRange.end = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(b.moveTargetPosition);
                else a.newRange.end = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(a.newRange.end);
            } else a.newRange.end = aNewRange.end;
            return [
                a
            ];
        }
        a.newRange = a.newRange._getTransformedBySplitOperation(b);
    }
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$6df6642276507f83, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    if (a.sourcePosition.hasSameParentAs(b.position)) a.howMany += b.howMany;
    a.sourcePosition = a.sourcePosition._getTransformedByInsertOperation(b);
    a.targetPosition = a.targetPosition._getTransformedByInsertOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$6df6642276507f83, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b, context)=>{
    if (a.sourcePosition.isEqual(b.sourcePosition) && a.targetPosition.isEqual(b.targetPosition)) {
        if (!context.bWasUndone) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
        else {
            const path = b.graveyardPosition.path.slice();
            path.push(0);
            a.sourcePosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(b.graveyardPosition.root, path);
            a.howMany = 0;
            return [
                a
            ];
        }
    }
    if (a.sourcePosition.isEqual(b.sourcePosition) && !a.targetPosition.isEqual(b.targetPosition) && !context.bWasUndone && context.abRelation != "splitAtSource") {
        const aToGraveyard = a.targetPosition.root.rootName == "$graveyard";
        const bToGraveyard = b.targetPosition.root.rootName == "$graveyard";
        if (bToGraveyard && !aToGraveyard || !(aToGraveyard && !bToGraveyard) && context.aIsStrong) {
            const sourcePosition = b.targetPosition._getTransformedByMergeOperation(b);
            const targetPosition = a.targetPosition._getTransformedByMergeOperation(b);
            return [
                new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(sourcePosition, a.howMany, targetPosition, 0)
            ];
        } else return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
    }
    if (a.sourcePosition.hasSameParentAs(b.targetPosition)) a.howMany += b.howMany;
    a.sourcePosition = a.sourcePosition._getTransformedByMergeOperation(b);
    a.targetPosition = a.targetPosition._getTransformedByMergeOperation(b);
    if (!a.graveyardPosition.isEqual(b.graveyardPosition) || !context.aIsStrong) a.graveyardPosition = a.graveyardPosition._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$6df6642276507f83, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b, context)=>{
    const removedRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(b.sourcePosition, b.howMany);
    if (b.type == "remove" && !context.bWasUndone) {
        if (a.deletionPosition.hasSameParentAs(b.sourcePosition) && removedRange.containsPosition(a.sourcePosition)) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
    }
    if (b.sourcePosition.getShiftedBy(b.howMany).isEqual(a.sourcePosition)) a.sourcePosition.stickiness = "toNone";
    else if (b.targetPosition.isEqual(a.sourcePosition) && context.abRelation == "mergeSourceAffected") a.sourcePosition.stickiness = "toNext";
    else if (b.sourcePosition.isEqual(a.targetPosition)) {
        a.targetPosition.stickiness = "toNone";
        a.howMany -= b.howMany;
    } else if (b.targetPosition.isEqual(a.targetPosition) && context.abRelation == "mergeTargetWasBefore") {
        a.targetPosition.stickiness = "toPrevious";
        a.howMany += b.howMany;
    } else {
        if (a.sourcePosition.hasSameParentAs(b.targetPosition)) a.howMany += b.howMany;
        if (a.sourcePosition.hasSameParentAs(b.sourcePosition)) a.howMany -= b.howMany;
    }
    a.sourcePosition = a.sourcePosition._getTransformedByMoveOperation(b);
    a.targetPosition = a.targetPosition._getTransformedByMoveOperation(b);
    a.sourcePosition.stickiness = "toPrevious";
    a.targetPosition.stickiness = "toNext";
    if (!a.graveyardPosition.isEqual(b.targetPosition)) a.graveyardPosition = a.graveyardPosition._getTransformedByMoveOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$6df6642276507f83, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b, context)=>{
    if (b.graveyardPosition) {
        a.graveyardPosition = a.graveyardPosition._getTransformedByDeletion(b.graveyardPosition, 1);
        if (a.deletionPosition.isEqual(b.graveyardPosition)) a.howMany = b.howMany;
    }
    if (a.targetPosition.isEqual(b.splitPosition)) {
        if (b.graveyardPosition && a.deletionPosition.isEqual(b.graveyardPosition) || context.abRelation == "mergeTargetNotMoved") {
            a.sourcePosition = a.sourcePosition._getTransformedBySplitOperation(b);
            return [
                a
            ];
        }
    }
    if (a.sourcePosition.isEqual(b.splitPosition)) {
        if (context.abRelation == "mergeSourceNotMoved") {
            a.howMany = 0;
            a.targetPosition = a.targetPosition._getTransformedBySplitOperation(b);
            return [
                a
            ];
        }
        if (context.abRelation == "mergeSameElement" || a.sourcePosition.offset > 0) {
            a.sourcePosition = b.moveTargetPosition.clone();
            a.targetPosition = a.targetPosition._getTransformedBySplitOperation(b);
            return [
                a
            ];
        }
    }
    if (a.sourcePosition.hasSameParentAs(b.splitPosition)) a.howMany = b.splitPosition.offset;
    a.sourcePosition = a.sourcePosition._getTransformedBySplitOperation(b);
    a.targetPosition = a.targetPosition._getTransformedBySplitOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$4a4db945c69349dc, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    const transformed = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(a.sourcePosition, a.howMany)._getTransformedByInsertOperation(b, false)[0];
    a.sourcePosition = transformed.start;
    a.howMany = transformed.end.offset - transformed.start.offset;
    if (!a.targetPosition.isEqual(b.position)) a.targetPosition = a.targetPosition._getTransformedByInsertOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$4a4db945c69349dc, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b, context)=>{
    const rangeA = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(a.sourcePosition, a.howMany);
    const rangeB = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(b.sourcePosition, b.howMany);
    let aIsStrong = context.aIsStrong;
    let insertBefore = !context.aIsStrong;
    if (context.abRelation == "insertBefore" || context.baRelation == "insertAfter") insertBefore = true;
    else if (context.abRelation == "insertAfter" || context.baRelation == "insertBefore") insertBefore = false;
    let newTargetPosition;
    if (a.targetPosition.isEqual(b.targetPosition) && insertBefore) newTargetPosition = a.targetPosition._getTransformedByDeletion(b.sourcePosition, b.howMany);
    else newTargetPosition = a.targetPosition._getTransformedByMove(b.sourcePosition, b.targetPosition, b.howMany);
    if ($b9b9f2bdf9c6137f$var$_moveTargetIntoMovedRange(a, b) && $b9b9f2bdf9c6137f$var$_moveTargetIntoMovedRange(b, a)) return [
        b.getReversed()
    ];
    if (rangeA.containsPosition(b.targetPosition) && rangeA.containsRange(rangeB, true)) {
        rangeA.start = rangeA.start._getTransformedByMove(b.sourcePosition, b.targetPosition, b.howMany);
        rangeA.end = rangeA.end._getTransformedByMove(b.sourcePosition, b.targetPosition, b.howMany);
        return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges([
            rangeA
        ], newTargetPosition);
    }
    if (rangeB.containsPosition(a.targetPosition) && rangeB.containsRange(rangeA, true)) {
        rangeA.start = rangeA.start._getCombined(b.sourcePosition, b.getMovedRangeStart());
        rangeA.end = rangeA.end._getCombined(b.sourcePosition, b.getMovedRangeStart());
        return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges([
            rangeA
        ], newTargetPosition);
    }
    const aCompB = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(a.sourcePosition.getParentPath(), b.sourcePosition.getParentPath());
    if (aCompB == "prefix" || aCompB == "extension") {
        rangeA.start = rangeA.start._getTransformedByMove(b.sourcePosition, b.targetPosition, b.howMany);
        rangeA.end = rangeA.end._getTransformedByMove(b.sourcePosition, b.targetPosition, b.howMany);
        return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges([
            rangeA
        ], newTargetPosition);
    }
    if (a.type == "remove" && b.type != "remove" && !context.aWasUndone && !context.forceWeakRemove) aIsStrong = true;
    else if (a.type != "remove" && b.type == "remove" && !context.bWasUndone && !context.forceWeakRemove) aIsStrong = false;
    const ranges = [];
    const difference = rangeA.getDifference(rangeB);
    for (const range of difference){
        range.start = range.start._getTransformedByDeletion(b.sourcePosition, b.howMany);
        range.end = range.end._getTransformedByDeletion(b.sourcePosition, b.howMany);
        const shouldSpread = (0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(range.start.getParentPath(), b.getMovedRangeStart().getParentPath()) == "same";
        const newRanges = range._getTransformedByInsertion(b.getMovedRangeStart(), b.howMany, shouldSpread);
        ranges.push(...newRanges);
    }
    const common = rangeA.getIntersection(rangeB);
    if (common !== null && aIsStrong) {
        common.start = common.start._getCombined(b.sourcePosition, b.getMovedRangeStart());
        common.end = common.end._getCombined(b.sourcePosition, b.getMovedRangeStart());
        if (ranges.length === 0) ranges.push(common);
        else if (ranges.length == 1) {
            if (rangeB.start.isBefore(rangeA.start) || rangeB.start.isEqual(rangeA.start)) ranges.unshift(common);
            else ranges.push(common);
        } else ranges.splice(1, 0, common);
    }
    if (ranges.length === 0) return [
        new $b9b9f2bdf9c6137f$export$61a108126838e575(a.baseVersion)
    ];
    return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges(ranges, newTargetPosition);
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$4a4db945c69349dc, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b, context)=>{
    let newTargetPosition = a.targetPosition.clone();
    if (!a.targetPosition.isEqual(b.insertionPosition) || !b.graveyardPosition || context.abRelation == "moveTargetAfter") newTargetPosition = a.targetPosition._getTransformedBySplitOperation(b);
    if (a.sourcePosition.isEqual(b.insertionPosition) && context.abRelation == "firstToMoveMerged") {
        a.howMany++;
        a.targetPosition = newTargetPosition;
        return [
            a
        ];
    }
    const moveRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(a.sourcePosition, a.howMany);
    if (moveRange.end.isEqual(b.insertionPosition)) {
        if (!b.graveyardPosition || context.abRelation == "lastToMoveMerged") a.howMany++;
        a.targetPosition = newTargetPosition;
        return [
            a
        ];
    }
    if (moveRange.start.hasSameParentAs(b.splitPosition) && moveRange.containsPosition(b.splitPosition)) {
        let rightRange = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(b.splitPosition, moveRange.end);
        rightRange = rightRange._getTransformedBySplitOperation(b);
        return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges([
            new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(moveRange.start, b.splitPosition),
            rightRange
        ], newTargetPosition);
    }
    if (a.targetPosition.isEqual(b.splitPosition) && context.abRelation == "insertAtSource") newTargetPosition = b.moveTargetPosition;
    if (a.targetPosition.isEqual(b.insertionPosition) && context.abRelation == "insertBetween") newTargetPosition = a.targetPosition;
    const ranges = [
        moveRange._getTransformedBySplitOperation(b)
    ];
    if (b.graveyardPosition) {
        const movesGraveyardElement = moveRange.start.isEqual(b.graveyardPosition) || moveRange.containsPosition(b.graveyardPosition);
        if (a.howMany > 1 && movesGraveyardElement && !context.aWasUndone) ranges.push($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(b.insertionPosition, 1));
    }
    return $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges(ranges, newTargetPosition);
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$4a4db945c69349dc, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b, context)=>{
    const movedRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(a.sourcePosition, a.howMany);
    if (b.deletionPosition.hasSameParentAs(a.sourcePosition) && movedRange.containsPosition(b.sourcePosition)) {
        if (a.type == "remove" && !context.forceWeakRemove) {
            if (!context.aWasUndone) {
                const results = [];
                let gyMoveSource = b.graveyardPosition.clone();
                let splitNodesMoveSource = b.targetPosition._getTransformedByMergeOperation(b);
                const aTarget = a.targetPosition.getTransformedByOperation(b);
                if (a.howMany > 1) {
                    results.push(new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(a.sourcePosition, a.howMany - 1, aTarget, 0));
                    gyMoveSource = gyMoveSource._getTransformedByMove(a.sourcePosition, aTarget, a.howMany - 1);
                    splitNodesMoveSource = splitNodesMoveSource._getTransformedByMove(a.sourcePosition, aTarget, a.howMany - 1);
                }
                const gyMoveTarget = b.deletionPosition._getCombined(a.sourcePosition, aTarget);
                const gyMove = new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(gyMoveSource, 1, gyMoveTarget, 0);
                const splitNodesMoveTargetPath = gyMove.getMovedRangeStart().path.slice();
                splitNodesMoveTargetPath.push(0);
                const splitNodesMoveTarget = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(gyMove.targetPosition.root, splitNodesMoveTargetPath);
                splitNodesMoveSource = splitNodesMoveSource._getTransformedByMove(gyMoveSource, gyMoveTarget, 1);
                const splitNodesMove = new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(splitNodesMoveSource, b.howMany, splitNodesMoveTarget, 0);
                results.push(gyMove);
                results.push(splitNodesMove);
                return results;
            }
        } else if (a.howMany == 1) {
            if (!context.bWasUndone) return [
                new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
            ];
            else {
                a.sourcePosition = b.graveyardPosition.clone();
                a.targetPosition = a.targetPosition._getTransformedByMergeOperation(b);
                return [
                    a
                ];
            }
        }
    }
    const transformed = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(a.sourcePosition, a.howMany)._getTransformedByMergeOperation(b);
    a.sourcePosition = transformed.start;
    a.howMany = transformed.end.offset - transformed.start.offset;
    a.targetPosition = a.targetPosition._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$8dc329ebf40a8040, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    a.position = a.position._getTransformedByInsertOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$8dc329ebf40a8040, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b)=>{
    if (a.position.isEqual(b.deletionPosition)) {
        a.position = b.graveyardPosition.clone();
        a.position.stickiness = "toNext";
        return [
            a
        ];
    }
    a.position = a.position._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$8dc329ebf40a8040, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b)=>{
    a.position = a.position._getTransformedByMoveOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$8dc329ebf40a8040, $b9b9f2bdf9c6137f$export$8dc329ebf40a8040, (a, b, context)=>{
    if (a.position.isEqual(b.position)) {
        if (context.aIsStrong) a.oldName = b.newName;
        else return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
    }
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$8dc329ebf40a8040, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b)=>{
    const renamePath = a.position.path;
    const splitPath = b.splitPosition.getParentPath();
    if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(renamePath, splitPath) == "same" && !b.graveyardPosition) return [
        a,
        new $b9b9f2bdf9c6137f$export$8dc329ebf40a8040(a.position.getShiftedBy(1), a.oldName, a.newName, 0)
    ];
    a.position = a.position._getTransformedBySplitOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef, $b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef, (a, b, context)=>{
    if (a.root === b.root && a.key === b.key) {
        if (!context.aIsStrong) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
        else a.oldValue = b.newValue;
    }
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$58241c4268d122b7, $b9b9f2bdf9c6137f$export$58241c4268d122b7, (a, b)=>{
    if (a.rootName === b.rootName && a.isAdd === b.isAdd) return [
        new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
    ];
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, $b9b9f2bdf9c6137f$export$2b3d431b09bf039a, (a, b)=>{
    if (a.splitPosition.hasSameParentAs(b.position) && a.splitPosition.offset < b.position.offset) a.howMany += b.howMany;
    a.splitPosition = a.splitPosition._getTransformedByInsertOperation(b);
    a.insertionPosition = a.insertionPosition._getTransformedByInsertOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, $b9b9f2bdf9c6137f$export$6df6642276507f83, (a, b, context)=>{
    if (!a.graveyardPosition && !context.bWasUndone && a.splitPosition.hasSameParentAs(b.sourcePosition)) {
        const splitPath = b.graveyardPosition.path.slice();
        splitPath.push(0);
        const splitPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(b.graveyardPosition.root, splitPath);
        const insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(new $b9b9f2bdf9c6137f$export$86023cc9eabef192(b.graveyardPosition.root, splitPath));
        const additionalSplit = new $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd(splitPosition, 0, insertionPosition, null, 0);
        a.splitPosition = a.splitPosition._getTransformedByMergeOperation(b);
        a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
        a.graveyardPosition = additionalSplit.insertionPosition.clone();
        a.graveyardPosition.stickiness = "toNext";
        return [
            additionalSplit,
            a
        ];
    }
    if (a.splitPosition.hasSameParentAs(b.deletionPosition) && !a.splitPosition.isAfter(b.deletionPosition)) a.howMany--;
    if (a.splitPosition.hasSameParentAs(b.targetPosition)) a.howMany += b.howMany;
    a.splitPosition = a.splitPosition._getTransformedByMergeOperation(b);
    a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
    if (a.graveyardPosition) a.graveyardPosition = a.graveyardPosition._getTransformedByMergeOperation(b);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, $b9b9f2bdf9c6137f$export$4a4db945c69349dc, (a, b, context)=>{
    const rangeToMove = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(b.sourcePosition, b.howMany);
    if (a.graveyardPosition) {
        const gyElementMoved = rangeToMove.start.isEqual(a.graveyardPosition) || rangeToMove.containsPosition(a.graveyardPosition);
        if (!context.bWasUndone && gyElementMoved) {
            const sourcePosition = a.splitPosition._getTransformedByMoveOperation(b);
            const newParentPosition = a.graveyardPosition._getTransformedByMoveOperation(b);
            const newTargetPath = newParentPosition.path.slice();
            newTargetPath.push(0);
            const newTargetPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(newParentPosition.root, newTargetPath);
            return [
                new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(sourcePosition, a.howMany, newTargetPosition, 0)
            ];
        }
        a.graveyardPosition = a.graveyardPosition._getTransformedByMoveOperation(b);
    }
    const splitAtTarget = a.splitPosition.isEqual(b.targetPosition);
    if (splitAtTarget && (context.baRelation == "insertAtSource" || context.abRelation == "splitBefore")) {
        a.howMany += b.howMany;
        a.splitPosition = a.splitPosition._getTransformedByDeletion(b.sourcePosition, b.howMany);
        a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
        return [
            a
        ];
    }
    if (splitAtTarget && context.abRelation && context.abRelation.howMany) {
        const { howMany: howMany, offset: offset } = context.abRelation;
        a.howMany += howMany;
        a.splitPosition = a.splitPosition.getShiftedBy(offset);
        return [
            a
        ];
    }
    if (a.splitPosition.hasSameParentAs(b.sourcePosition) && rangeToMove.containsPosition(a.splitPosition)) {
        const howManyRemoved = b.howMany - (a.splitPosition.offset - b.sourcePosition.offset);
        a.howMany -= howManyRemoved;
        if (a.splitPosition.hasSameParentAs(b.targetPosition) && a.splitPosition.offset < b.targetPosition.offset) a.howMany += b.howMany;
        a.splitPosition = b.sourcePosition.clone();
        a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
        return [
            a
        ];
    }
    if (!b.sourcePosition.isEqual(b.targetPosition)) {
        if (a.splitPosition.hasSameParentAs(b.sourcePosition) && a.splitPosition.offset <= b.sourcePosition.offset) a.howMany -= b.howMany;
        if (a.splitPosition.hasSameParentAs(b.targetPosition) && a.splitPosition.offset < b.targetPosition.offset) a.howMany += b.howMany;
    }
    a.splitPosition.stickiness = "toNone";
    a.splitPosition = a.splitPosition._getTransformedByMoveOperation(b);
    a.splitPosition.stickiness = "toNext";
    if (a.graveyardPosition) a.insertionPosition = a.insertionPosition._getTransformedByMoveOperation(b);
    else a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
    return [
        a
    ];
});
$b9b9f2bdf9c6137f$var$setTransformation($b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd, (a, b, context)=>{
    if (a.splitPosition.isEqual(b.splitPosition)) {
        if (!a.graveyardPosition && !b.graveyardPosition) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
        if (a.graveyardPosition && b.graveyardPosition && a.graveyardPosition.isEqual(b.graveyardPosition)) return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
        if (context.abRelation == "splitBefore") {
            a.howMany = 0;
            a.graveyardPosition = a.graveyardPosition._getTransformedBySplitOperation(b);
            return [
                a
            ];
        }
    }
    if (a.graveyardPosition && b.graveyardPosition && a.graveyardPosition.isEqual(b.graveyardPosition)) {
        const aInGraveyard = a.splitPosition.root.rootName == "$graveyard";
        const bInGraveyard = b.splitPosition.root.rootName == "$graveyard";
        if (bInGraveyard && !aInGraveyard || !(aInGraveyard && !bInGraveyard) && context.aIsStrong) {
            const result = [];
            if (b.howMany) result.push(new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(b.moveTargetPosition, b.howMany, b.splitPosition, 0));
            if (a.howMany) result.push(new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(a.splitPosition, a.howMany, a.moveTargetPosition, 0));
            return result;
        } else return [
            new $b9b9f2bdf9c6137f$export$61a108126838e575(0)
        ];
    }
    if (a.graveyardPosition) a.graveyardPosition = a.graveyardPosition._getTransformedBySplitOperation(b);
    if (a.splitPosition.isEqual(b.insertionPosition) && context.abRelation == "splitBefore") {
        a.howMany++;
        return [
            a
        ];
    }
    if (b.splitPosition.isEqual(a.insertionPosition) && context.baRelation == "splitBefore") {
        const newPositionPath = b.insertionPosition.path.slice();
        newPositionPath.push(0);
        const newPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(b.insertionPosition.root, newPositionPath);
        return [
            a,
            new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(a.insertionPosition, 1, newPosition, 0)
        ];
    }
    if (a.splitPosition.hasSameParentAs(b.splitPosition) && a.splitPosition.offset < b.splitPosition.offset) a.howMany -= b.howMany;
    a.splitPosition = a.splitPosition._getTransformedBySplitOperation(b);
    a.insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(a.splitPosition);
    return [
        a
    ];
});
/**
* Checks whether `MoveOperation` `targetPosition` is inside a node from the moved range of the other `MoveOperation`.
*/ function $b9b9f2bdf9c6137f$var$_moveTargetIntoMovedRange(a, b) {
    return a.targetPosition._getTransformedByDeletion(b.sourcePosition, b.howMany) === null;
}
/**
* Helper function for `MoveOperation` x `MoveOperation` transformation. Converts given ranges and target position to
* move operations and returns them.
*
* Ranges and target position will be transformed on-the-fly when generating operations.
*
* Given `ranges` should be in the order of how they were in the original transformed operation.
*
* Given `targetPosition` is the target position of the first range from `ranges`.
*/ function $b9b9f2bdf9c6137f$var$_makeMoveOperationsFromRanges(ranges, targetPosition) {
    const operations = [];
    for(let i = 0; i < ranges.length; i++){
        const range = ranges[i];
        const op = new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(range.start, range.end.offset - range.start.offset, targetPosition, 0);
        operations.push(op);
        for(let j = i + 1; j < ranges.length; j++)ranges[j] = ranges[j]._getTransformedByMove(op.sourcePosition, op.targetPosition, op.howMany)[0];
        targetPosition = targetPosition._getTransformedByMove(op.sourcePosition, op.targetPosition, op.howMany);
    }
    return operations;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/liveposition
*/ const $b9b9f2bdf9c6137f$var$ModelLivePositionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$86023cc9eabef192);
/**
* `ModelLivePosition` is a type of {@link module:engine/model/position~ModelPosition Position}
* that updates itself as {@link module:engine/model/document~ModelDocument document}
* is changed through operations. It may be used as a bookmark.
*
* **Note:** Contrary to {@link module:engine/model/position~ModelPosition}, `ModelLivePosition` works only in roots that are
* {@link module:engine/model/rootelement~ModelRootElement}.
* If {@link module:engine/model/documentfragment~ModelDocumentFragment} is passed, error will be thrown.
*
* **Note:** Be very careful when dealing with `ModelLivePosition`. Each `ModelLivePosition` instance bind events that might
* have to be unbound.
* Use {@link module:engine/model/liveposition~ModelLivePosition#detach} whenever you don't need `ModelLivePosition` anymore.
*/ var $b9b9f2bdf9c6137f$export$e9dab424d71bca79 = class extends $b9b9f2bdf9c6137f$var$ModelLivePositionBase {
    /**
	* Creates a live position.
	*
	* @see module:engine/model/position~ModelPosition
	*/ constructor(root, path, stickiness = "toNone", model){
        super(root, path, stickiness);
        const boundModel = model || (this.root.is("rootElement") ? this.root.document.model : null);
        if (!boundModel) /**
		* LivePosition's root has to be an instance of ModelRootElement or have a reference to a model instance.
		*
		* @error model-liveposition-no-model-reference
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-liveposition-no-model-reference", root);
        $b9b9f2bdf9c6137f$var$bindWithModel.call(this, boundModel);
    }
    /**
	* Unbinds all events previously bound by `ModelLivePosition`. Use it whenever you don't need `ModelLivePosition` instance
	* anymore (i.e. when leaving scope in which it was declared or before re-assigning variable that was
	* referring to it).
	*/ detach() {
        this.stopListening();
    }
    /**
	* Creates a {@link module:engine/model/position~ModelPosition position instance}, which is equal to this live position.
	*/ toPosition() {
        return new $b9b9f2bdf9c6137f$export$86023cc9eabef192(this.root, this.path.slice(), this.stickiness);
    }
    /**
	* Creates a `ModelLivePosition` instance that is equal to position.
	*/ static fromPosition(position, stickiness) {
        return new this(position.root, position.path.slice(), stickiness ? stickiness : position.stickiness);
    }
    /**
	* Creates a `ModelLivePosition` for a position rooted in
	* a {@link module:engine/model/documentfragment~ModelDocumentFragment document fragment}.
	*
	* Document fragment does not belong to a document, so the live position is bound to the provided `model` and keeps
	* itself in sync with every operation applied to that fragment (e.g. while editing clipboard content).
	*
	* @internal
	*/ static _fromPositionInDocumentFragment(position, model, stickiness) {
        return new this(position.root, position.path.slice(), stickiness ? stickiness : position.stickiness, model);
    }
};
$b9b9f2bdf9c6137f$export$e9dab424d71bca79.prototype.is = function(type) {
    return type === "livePosition" || type === "model:livePosition" || type == "position" || type === "model:position";
};
/**
* Binds this `ModelLivePosition` to the given model, so the position updates itself on every operation applied to it.
*/ function $b9b9f2bdf9c6137f$var$bindWithModel(model) {
    const isDetached = !this.root.is("rootElement");
    this.listenTo(model, "applyOperation", (event, args)=>{
        const operation = args[0];
        if (!isDetached && !operation.isDocumentOperation) return;
        $b9b9f2bdf9c6137f$var$transform$1.call(this, operation);
    }, {
        priority: "low"
    });
}
/**
* Updates this position accordingly to the updates applied to the model. Bases on change events.
*/ function $b9b9f2bdf9c6137f$var$transform$1(operation) {
    const result = this.getTransformedByOperation(operation);
    if (!this.isEqual(result)) {
        const oldPosition = this.toPosition();
        this.path = result.path;
        this.root = result.root;
        this.fire("change", oldPosition);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/batch
*/ /**
* A batch instance groups model changes ({@link module:engine/model/operation/operation~Operation operations}). All operations
* grouped in a single batch can be reverted together, so you can also think about a batch as of a single undo step. If you want
* to extend a given undo step, you can add more changes to the batch using {@link module:engine/model/model~Model#enqueueChange}:
*
* ```ts
* model.enqueueChange( batch, writer => {
* 	writer.insertText( 'foo', paragraph, 'end' );
* } );
* ```
*
* @see module:engine/model/model~Model#enqueueChange
* @see module:engine/model/model~Model#change
*/ var $b9b9f2bdf9c6137f$export$33b107562567fc47 = class {
    /**
	* An array of operations that compose this batch.
	*/ operations;
    /**
	* Whether the batch can be undone through the undo feature.
	*/ isUndoable;
    /**
	* Whether the batch includes operations created locally (`true`) or operations created on other, remote editors (`false`).
	*/ isLocal;
    /**
	* Whether the batch was created by the undo feature and undoes other operations.
	*/ isUndo;
    /**
	* Whether the batch includes operations connected with typing.
	*/ isTyping;
    /**
	* Creates a batch instance.
	*
	* @see module:engine/model/model~Model#enqueueChange
	* @see module:engine/model/model~Model#change
	* @param type A set of flags that specify the type of the batch. Batch type can alter how some of the features work
	* when encountering a given `Batch` instance (for example, when a feature listens to applied operations).
	*/ constructor(type = {}){
        if (typeof type === "string") {
            type = type === "transparent" ? {
                isUndoable: false
            } : {};
            /**
			* The string value for a `type` property of the `Batch` constructor has been deprecated and will be removed in the near future.
			* Please refer to the {@link module:engine/model/batch~Batch#constructor `Batch` constructor API documentation} for more
			* information.
			*
			* @error batch-constructor-deprecated-string-type
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("batch-constructor-deprecated-string-type");
        }
        const { isUndoable: isUndoable = true, isLocal: isLocal = true, isUndo: isUndo = false, isTyping: isTyping = false } = type;
        this.operations = [];
        this.isUndoable = isUndoable;
        this.isLocal = isLocal;
        this.isUndo = isUndo;
        this.isTyping = isTyping;
    }
    /**
	* Returns the base version of this batch, which is equal to the base version of the first operation in the batch.
	* If there are no operations in the batch or neither operation has the base version set, it returns `null`.
	*/ get baseVersion() {
        for (const op of this.operations)if (op.baseVersion !== null) return op.baseVersion;
        return null;
    }
    /**
	* Adds an operation to the batch instance.
	*
	* @param operation An operation to add.
	* @returns The added operation.
	*/ addOperation(operation) {
        if (operation.isDocumentOperation) {
            operation.batch = this;
            this.operations.push(operation);
        }
        return operation;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/differ
*/ /**
* Calculates the difference between two model states.
*
* Receives operations that are to be applied on the model document. Marks parts of the model document tree which
* are changed and saves the state of these elements before the change. Then, it compares saved elements with the
* changed elements, after all changes are applied on the model document. Calculates the diff between saved
* elements and new ones and returns a change set.
*/ var $b9b9f2bdf9c6137f$export$2bb42ee3c96bc74d = class Differ {
    /**
	* Priority of the {@link ~Differ#_elementState element states}. States on higher indexes of the array can overwrite states on the lower
	* indexes.
	*/ static _statesPriority = [
        void 0,
        "refresh",
        "rename",
        "move"
    ];
    /**
	* Reference to the model's marker collection.
	*/ _markerCollection;
    /**
	* A map that stores changes that happened in a given element.
	*
	* The keys of the map are references to the model elements.
	* The values of the map are arrays with changes that were done on this element.
	*/ _changesInElement = /* @__PURE__ */ new Map();
    /**
	* Stores a snapshot for these model nodes that might have changed.
	*
	* This complements {@link ~Differ#_elementChildrenSnapshots `_elementChildrenSnapshots`}.
	*
	* See also {@link ~DifferSnapshot}.
	*/ _elementsSnapshots = /* @__PURE__ */ new Map();
    /**
	* For each element or document fragment inside which there was a change, it stores a snapshot of the child nodes list (an array
	* of children snapshots that represent the state in the element / fragment before any change has happened).
	*
	* This complements {@link ~Differ#_elementsSnapshots `_elementsSnapshots`}.
	*
	* See also {@link ~DifferSnapshot}.
	*/ _elementChildrenSnapshots = /* @__PURE__ */ new Map();
    /**
	* Keeps the state for a given element, describing how the element was changed so far. It is used to evaluate the `action` property
	* of diff items returned by {@link ~Differ#getChanges}.
	*
	* Possible values, in the order from the lowest priority to the highest priority:
	*
	* * `'refresh'` - element was refreshed,
	* * `'rename'` - element was renamed,
	* * `'move'` - element was moved (or, usually, removed, that is moved to the graveyard).
	*
	* Element that was refreshed, may change its state to `'rename'` if it was later renamed, or to `'move'` if it was removed.
	* But the element cannot change its state from `'move'` to `'rename'`, or from `'rename'` to `'refresh'`.
	*
	* Only already existing elements are registered in `_elementState`. If a new element was inserted as a result of a buffered operation,
	* it is not be registered in `_elementState`.
	*/ _elementState = /* @__PURE__ */ new Map();
    /**
	* A map that stores all changed markers.
	*
	* The keys of the map are marker names.
	*
	* The values of the map are objects with the following properties:
	*
	* * `oldMarkerData`,
	* * `newMarkerData`.
	*/ _changedMarkers = /* @__PURE__ */ new Map();
    /**
	* A map that stores all roots that have been changed.
	*
	* The keys are the names of the roots while value represents the changes.
	*/ _changedRoots = /* @__PURE__ */ new Map();
    /**
	* Stores the number of changes that were processed. Used to order the changes chronologically. It is important
	* when changes are sorted.
	*/ _changeCount = 0;
    /**
	* For efficiency purposes, `Differ` stores the change set returned by the differ after {@link #getChanges} call.
	* Cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
	* return the cached value instead of calculating it again.
	*
	* This property stores those changes that did not take place in graveyard root.
	*/ _cachedChanges = null;
    /**
	* For efficiency purposes, `Differ` stores the change set returned by the differ after the {@link #getChanges} call.
	* The cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
	* return the cached value instead of calculating it again.
	*
	* This property stores all changes evaluated by `Differ`, including those that took place in the graveyard.
	*/ _cachedChangesWithGraveyard = null;
    /**
	* Set of model items that were marked to get refreshed in {@link #_refreshItem}.
	*/ _refreshedItems = /* @__PURE__ */ new Set();
    /**
	* Creates a `Differ` instance.
	*
	* @param markerCollection Model's marker collection.
	*/ constructor(markerCollection){
        this._markerCollection = markerCollection;
    }
    /**
	* Informs whether there are any changes buffered in `Differ`.
	*/ get isEmpty() {
        return this._changesInElement.size == 0 && this._changedMarkers.size == 0 && this._changedRoots.size == 0;
    }
    /**
	* Buffers the given operation. **An operation has to be buffered before it is executed.**
	*
	* @param operationToBuffer An operation to buffer.
	*/ bufferOperation(operationToBuffer) {
        const operation = operationToBuffer;
        switch(operation.type){
            case "insert":
                if (this._isInInsertedElement(operation.position.parent)) return;
                this._markInsert(operation.position.parent, operation.position.offset, operation.nodes.maxOffset);
                break;
            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
                for (const item of operation.range.getItems({
                    shallow: true
                })){
                    if (this._isInInsertedElement(item.parent)) continue;
                    this._markAttribute(item);
                }
                break;
            case "remove":
            case "move":
            case "reinsert":
                {
                    if (operation.sourcePosition.isEqual(operation.targetPosition) || operation.sourcePosition.getShiftedBy(operation.howMany).isEqual(operation.targetPosition)) return;
                    const sourceParentInserted = this._isInInsertedElement(operation.sourcePosition.parent);
                    const targetParentInserted = this._isInInsertedElement(operation.targetPosition.parent);
                    if (!sourceParentInserted) this._markRemove(operation.sourcePosition.parent, operation.sourcePosition.offset, operation.howMany);
                    if (!targetParentInserted) this._markInsert(operation.targetPosition.parent, operation.getMovedRangeStart().offset, operation.howMany);
                    const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(operation.sourcePosition, operation.howMany);
                    for (const node of range.getItems({
                        shallow: true
                    }))this._setElementState(node, "move");
                    break;
                }
            case "rename":
                {
                    if (this._isInInsertedElement(operation.position.parent)) return;
                    this._markRemove(operation.position.parent, operation.position.offset, 1);
                    this._markInsert(operation.position.parent, operation.position.offset, 1);
                    const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(operation.position, 1);
                    for (const marker of this._markerCollection.getMarkersIntersectingRange(range)){
                        const markerData = marker.getData();
                        this.bufferMarkerChange(marker.name, markerData, markerData);
                    }
                    this._setElementState(operation.position.nodeAfter, "rename");
                    break;
                }
            case "split":
                {
                    const splitElement = operation.splitPosition.parent;
                    if (!this._isInInsertedElement(splitElement)) {
                        this._markRemove(splitElement, operation.splitPosition.offset, operation.howMany);
                        const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(operation.splitPosition, operation.howMany);
                        for (const node of range.getItems({
                            shallow: true
                        }))this._setElementState(node, "move");
                    }
                    if (!this._isInInsertedElement(operation.insertionPosition.parent)) this._markInsert(operation.insertionPosition.parent, operation.insertionPosition.offset, 1);
                    if (operation.graveyardPosition) {
                        this._markRemove(operation.graveyardPosition.parent, operation.graveyardPosition.offset, 1);
                        this._setElementState(operation.graveyardPosition.nodeAfter, "move");
                    }
                    break;
                }
            case "merge":
                {
                    const mergedElement = operation.sourcePosition.parent;
                    if (!this._isInInsertedElement(mergedElement.parent)) this._markRemove(mergedElement.parent, mergedElement.startOffset, 1);
                    const graveyardParent = operation.graveyardPosition.parent;
                    this._markInsert(graveyardParent, operation.graveyardPosition.offset, 1);
                    this._setElementState(mergedElement, "move");
                    const mergedIntoElement = operation.targetPosition.parent;
                    if (!this._isInInsertedElement(mergedIntoElement)) {
                        this._markInsert(mergedIntoElement, operation.targetPosition.offset, mergedElement.maxOffset);
                        const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(operation.sourcePosition, operation.howMany);
                        for (const node of range.getItems({
                            shallow: true
                        }))this._setElementState(node, "move");
                    }
                    break;
                }
            case "detachRoot":
            case "addRoot":
                {
                    const root = operation.affectedSelectable;
                    if (!root._isLoaded) return;
                    if (root.isAttached() == operation.isAdd) return;
                    this._bufferRootStateChange(operation.rootName, operation.isAdd);
                    break;
                }
            case "addRootAttribute":
            case "removeRootAttribute":
            case "changeRootAttribute":
                {
                    if (!operation.root._isLoaded) return;
                    const rootName = operation.root.rootName;
                    this._bufferRootAttributeChange(rootName, operation.key, operation.oldValue, operation.newValue);
                    break;
                }
        }
        this._cachedChanges = null;
    }
    /**
	* Buffers a marker change.
	*
	* @param markerName The name of the marker that changed.
	* @param oldMarkerData Marker data before the change.
	* @param newMarkerData Marker data after the change.
	*/ bufferMarkerChange(markerName, oldMarkerData, newMarkerData) {
        if (oldMarkerData.range && oldMarkerData.range.root.is("rootElement") && !oldMarkerData.range.root._isLoaded) oldMarkerData.range = null;
        if (newMarkerData.range && newMarkerData.range.root.is("rootElement") && !newMarkerData.range.root._isLoaded) newMarkerData.range = null;
        let buffered = this._changedMarkers.get(markerName);
        if (!buffered) {
            buffered = {
                newMarkerData: newMarkerData,
                oldMarkerData: oldMarkerData
            };
            this._changedMarkers.set(markerName, buffered);
        } else buffered.newMarkerData = newMarkerData;
        if (buffered.oldMarkerData.range == null && newMarkerData.range == null) this._changedMarkers.delete(markerName);
    }
    /**
	* Returns all markers that should be removed as a result of buffered changes.
	*
	* @returns Markers to remove. Each array item is an object containing the `name` and `range` properties.
	*/ getMarkersToRemove() {
        const result = [];
        for (const [name, change] of this._changedMarkers)if (change.oldMarkerData.range != null) result.push({
            name: name,
            range: change.oldMarkerData.range
        });
        return result;
    }
    /**
	* Returns all markers which should be added as a result of buffered changes.
	*
	* @returns Markers to add. Each array item is an object containing the `name` and `range` properties.
	*/ getMarkersToAdd() {
        const result = [];
        for (const [name, change] of this._changedMarkers)if (change.newMarkerData.range != null) result.push({
            name: name,
            range: change.newMarkerData.range
        });
        return result;
    }
    /**
	* Returns all markers which changed.
	*/ getChangedMarkers() {
        return Array.from(this._changedMarkers).map(([name, change])=>({
                name: name,
                data: {
                    oldRange: change.oldMarkerData.range,
                    newRange: change.newMarkerData.range
                }
            }));
    }
    /**
	* Checks whether some of the buffered changes affect the editor data.
	*
	* Types of changes which affect the editor data:
	*
	* * model structure changes,
	* * attribute changes,
	* * a root is added or detached,
	* * changes of markers which were defined as `affectsData`,
	* * changes of markers' `affectsData` property.
	*/ hasDataChanges() {
        if (this.getChanges().length) return true;
        if (this._changedRoots.size > 0) return true;
        for (const { newMarkerData: newMarkerData, oldMarkerData: oldMarkerData } of this._changedMarkers.values()){
            if (newMarkerData.affectsData !== oldMarkerData.affectsData) return true;
            if (newMarkerData.affectsData) {
                const markerAdded = newMarkerData.range && !oldMarkerData.range;
                const markerRemoved = !newMarkerData.range && oldMarkerData.range;
                const markerChanged = newMarkerData.range && oldMarkerData.range && !newMarkerData.range.isEqual(oldMarkerData.range);
                if (markerAdded || markerRemoved || markerChanged) return true;
            }
        }
        return false;
    }
    /**
	* Calculates the diff between the old model tree state (the state before the first buffered operations since the last {@link #reset}
	* call) and the new model tree state (actual one). It should be called after all buffered operations are executed.
	*
	* The diff set is returned as an array of {@link module:engine/model/differ~DifferItem diff items}, each describing a change done
	* on the model. The items are sorted by the position on which the change happened. If a position
	* {@link module:engine/model/position~ModelPosition#isBefore is before} another one, it will be on an earlier index in the diff set.
	*
	* **Note**: Elements inside inserted element will not have a separate diff item, only the top most element change will be reported.
	*
	* Because calculating the diff is a costly operation, the result is cached. If no new operation was buffered since the
	* previous {@link #getChanges} call, the next call will return the cached value.
	*
	* @param options Additional options.
	* @param options.includeChangesInGraveyard If set to `true`, also changes that happened
	* in the graveyard root will be returned. By default, changes in the graveyard root are not returned.
	* @returns Diff between the old and the new model tree state.
	*/ getChanges(options = {}) {
        if (this._cachedChanges) {
            if (options.includeChangesInGraveyard) return this._cachedChangesWithGraveyard.slice();
            else return this._cachedChanges.slice();
        }
        let diffSet = [];
        for (const element of this._changesInElement.keys()){
            const changes = this._changesInElement.get(element).sort((a, b)=>{
                if (a.offset === b.offset) {
                    if (a.type != b.type) return a.type == "remove" ? -1 : 1;
                    return 0;
                }
                return a.offset < b.offset ? -1 : 1;
            });
            const childrenBefore = this._elementChildrenSnapshots.get(element);
            const childrenAfter = $b9b9f2bdf9c6137f$var$_getChildrenSnapshots(element.getChildren());
            const diffInstructions = $b9b9f2bdf9c6137f$var$_generateDiffInstructionsFromChanges(childrenBefore.length, changes);
            let i = 0;
            let j = 0;
            for (const instruction of diffInstructions)if (instruction === "i") {
                const action = this._getDiffActionForNode(childrenAfter[i].node, "insert");
                const childSnapshotBefore = this._elementsSnapshots.get(childrenAfter[i].node);
                const diffItem = this._getInsertDiff(element, i, action, childrenAfter[i], childSnapshotBefore);
                diffSet.push(diffItem);
                i++;
            } else if (instruction === "r") {
                const action = this._getDiffActionForNode(childrenBefore[j].node, "remove");
                const diffItem = this._getRemoveDiff(element, i, action, childrenBefore[j]);
                diffSet.push(diffItem);
                j++;
            } else if (instruction === "a") {
                const beforeAttributes = childrenBefore[j].attributes;
                const afterAttributes = childrenAfter[i].attributes;
                let range;
                if (childrenAfter[i].name == "$text") range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, i), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, i + 1));
                else {
                    const index = element.offsetToIndex(i);
                    range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, i), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element.getChild(index), 0));
                }
                const diffItems = this._getAttributesDiff(range, beforeAttributes, afterAttributes);
                diffSet.push(...diffItems);
                i++;
                j++;
            } else {
                i++;
                j++;
            }
        }
        diffSet.sort((a, b)=>{
            if (a.position.root != b.position.root) return a.position.root.rootName < b.position.root.rootName ? -1 : 1;
            if (a.position.isEqual(b.position)) return a.changeCount - b.changeCount;
            return a.position.isBefore(b.position) ? -1 : 1;
        });
        for(let i = 1, prevIndex = 0; i < diffSet.length; i++){
            const prevDiff = diffSet[prevIndex];
            const thisDiff = diffSet[i];
            const isConsecutiveTextRemove = prevDiff.type == "remove" && thisDiff.type == "remove" && prevDiff.name == "$text" && thisDiff.name == "$text" && prevDiff.position.isEqual(thisDiff.position);
            const isConsecutiveTextAdd = prevDiff.type == "insert" && thisDiff.type == "insert" && prevDiff.name == "$text" && thisDiff.name == "$text" && prevDiff.position.parent == thisDiff.position.parent && prevDiff.position.offset + prevDiff.length == thisDiff.position.offset;
            const isConsecutiveAttributeChange = prevDiff.type == "attribute" && thisDiff.type == "attribute" && prevDiff.position.parent == thisDiff.position.parent && prevDiff.range.isFlat && thisDiff.range.isFlat && prevDiff.position.offset + prevDiff.length == thisDiff.position.offset && prevDiff.attributeKey == thisDiff.attributeKey && prevDiff.attributeOldValue == thisDiff.attributeOldValue && prevDiff.attributeNewValue == thisDiff.attributeNewValue;
            if (isConsecutiveTextRemove || isConsecutiveTextAdd || isConsecutiveAttributeChange) {
                prevDiff.length++;
                if (isConsecutiveAttributeChange) prevDiff.range.end = prevDiff.range.end.getShiftedBy(1);
                diffSet[i] = null;
            } else prevIndex = i;
        }
        diffSet = diffSet.filter((v)=>v);
        for (const item of diffSet){
            delete item.changeCount;
            if (item.type == "attribute") {
                delete item.position;
                delete item.length;
            }
        }
        this._changeCount = 0;
        this._cachedChangesWithGraveyard = diffSet;
        this._cachedChanges = diffSet.filter($b9b9f2bdf9c6137f$var$_changesInGraveyardFilter);
        if (options.includeChangesInGraveyard) return this._cachedChangesWithGraveyard.slice();
        else return this._cachedChanges.slice();
    }
    /**
	* Returns all roots that have changed (either were attached, or detached, or their attributes changed).
	*
	* @returns Diff between the old and the new roots state.
	*/ getChangedRoots() {
        return Array.from(this._changedRoots.values()).map((diffItem)=>{
            const entry = {
                ...diffItem
            };
            if (entry.state !== void 0) delete entry.attributes;
            return entry;
        });
    }
    /**
	* Returns a set of model items that were marked to get refreshed.
	*/ getRefreshedItems() {
        return new Set(this._refreshedItems);
    }
    /**
	* Resets `Differ`. Removes all buffered changes.
	*/ reset() {
        this._changesInElement.clear();
        this._elementChildrenSnapshots.clear();
        this._elementsSnapshots.clear();
        this._elementState.clear();
        this._changedMarkers.clear();
        this._changedRoots.clear();
        this._refreshedItems.clear();
        this._cachedChanges = null;
    }
    /**
	* Marks the given `item` in differ to be "refreshed". It means that the item will be marked as removed and inserted
	* in the differ changes set, so it will be effectively re-converted when the differ changes are handled by a dispatcher.
	*
	* @internal
	* @param item Item to refresh.
	*/ _refreshItem(item) {
        if (this._isInInsertedElement(item.parent)) return;
        this._markRemove(item.parent, item.startOffset, item.offsetSize);
        this._markInsert(item.parent, item.startOffset, item.offsetSize);
        this._refreshedItems.add(item);
        this._setElementState(item, "refresh");
        const range = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item);
        for (const marker of this._markerCollection.getMarkersIntersectingRange(range)){
            const markerData = marker.getData();
            this.bufferMarkerChange(marker.name, markerData, markerData);
        }
        this._cachedChanges = null;
    }
    /**
	* Buffers all the data related to given root like it was all just added to the editor.
	*
	* Following changes are buffered:
	*
	* * root is attached,
	* * all root content is inserted,
	* * all root attributes are added,
	* * all markers inside the root are added.
	*
	* @internal
	*/ _bufferRootLoad(root) {
        if (!root.isAttached()) return;
        this._bufferRootStateChange(root.rootName, true);
        this._markInsert(root, 0, root.maxOffset);
        for (const key of root.getAttributeKeys())this._bufferRootAttributeChange(root.rootName, key, null, root.getAttribute(key));
        for (const marker of this._markerCollection)if (marker.getRange().root == root) {
            const markerData = marker.getData();
            this.bufferMarkerChange(marker.name, {
                ...markerData,
                range: null
            }, markerData);
        }
    }
    /**
	* Buffers the root state change after the root was attached or detached
	*/ _bufferRootStateChange(rootName, isAttached) {
        if (!this._changedRoots.has(rootName)) {
            this._changedRoots.set(rootName, {
                name: rootName,
                state: isAttached ? "attached" : "detached"
            });
            return;
        }
        const diffItem = this._changedRoots.get(rootName);
        if (diffItem.state !== void 0) {
            delete diffItem.state;
            if (diffItem.attributes === void 0) this._changedRoots.delete(rootName);
        } else diffItem.state = isAttached ? "attached" : "detached";
    }
    /**
	* Buffers a root attribute change.
	*/ _bufferRootAttributeChange(rootName, key, oldValue, newValue) {
        const diffItem = this._changedRoots.get(rootName) || {
            name: rootName
        };
        const attrs = diffItem.attributes || {};
        if (attrs[key]) {
            const attrEntry = attrs[key];
            if (newValue === attrEntry.oldValue) delete attrs[key];
            else attrEntry.newValue = newValue;
        } else attrs[key] = {
            oldValue: oldValue,
            newValue: newValue
        };
        if (Object.entries(attrs).length === 0) {
            delete diffItem.attributes;
            if (diffItem.state === void 0) this._changedRoots.delete(rootName);
        } else {
            diffItem.attributes = attrs;
            this._changedRoots.set(rootName, diffItem);
        }
    }
    /**
	* Saves and handles an insert change.
	*/ _markInsert(parent, offset, howMany) {
        if (parent.root.is("rootElement") && !parent.root._isLoaded) return;
        const changeItem = {
            type: "insert",
            offset: offset,
            howMany: howMany,
            count: this._changeCount++
        };
        this._markChange(parent, changeItem);
    }
    /**
	* Saves and handles a remove change.
	*/ _markRemove(parent, offset, howMany) {
        if (parent.root.is("rootElement") && !parent.root._isLoaded) return;
        const changeItem = {
            type: "remove",
            offset: offset,
            howMany: howMany,
            count: this._changeCount++
        };
        this._markChange(parent, changeItem);
        this._removeAllNestedChanges(parent, offset, howMany);
    }
    /**
	* Saves and handles an attribute change.
	*/ _markAttribute(item) {
        if (item.root.is("rootElement") && !item.root._isLoaded) return;
        const changeItem = {
            type: "attribute",
            offset: item.startOffset,
            howMany: item.offsetSize,
            count: this._changeCount++
        };
        this._markChange(item.parent, changeItem);
    }
    /**
	* Saves and handles a model change.
	*/ _markChange(parent, changeItem) {
        this._makeSnapshots(parent);
        const changes = this._getChangesForElement(parent);
        this._handleChange(changeItem, changes);
        changes.push(changeItem);
        for(let i = 0; i < changes.length; i++)if (changes[i].howMany < 1) {
            changes.splice(i, 1);
            i--;
        }
    }
    /**
	* Tries to set given state for given item.
	*
	* This method does simple validation (it sets the state only for model elements, not for text proxy nodes). It also follows state
	* setting rules, that is, `'refresh'` cannot overwrite `'rename'`, and `'rename'` cannot overwrite `'move'`.
	*/ _setElementState(node, state) {
        if (!node.is("element")) return;
        const currentStatePriority = Differ._statesPriority.indexOf(this._elementState.get(node));
        if (Differ._statesPriority.indexOf(state) > currentStatePriority) this._elementState.set(node, state);
    }
    /**
	* Returns a value for {@link ~DifferItemAction `action`} property for diff items returned by {@link ~Differ#getChanges}.
	* This method aims to return `'rename'` or `'refresh'` when it should, and `diffItemType` ("default action") in all other cases.
	*
	* It bases on a few factors:
	*
	* * for text nodes, the method always returns `diffItemType`,
	* * for newly inserted element, the method returns `diffItemType`,
	* * if {@link ~Differ#_elementState element state} was not recorded, the method returns `diffItemType`,
	* * if state was recorded, and it was `'move'` (default action), the method returns `diffItemType`,
	* * finally, if state was `'refresh'` or `'rename'`, the method returns the state value.
	*/ _getDiffActionForNode(node, diffItemType) {
        if (!node.is("element")) return diffItemType;
        if (!this._elementsSnapshots.has(node)) return diffItemType;
        const state = this._elementState.get(node);
        if (!state || state == "move") return diffItemType;
        return state;
    }
    /**
	* Gets an array of changes that have already been saved for a given element.
	*/ _getChangesForElement(element) {
        let changes;
        if (this._changesInElement.has(element)) changes = this._changesInElement.get(element);
        else {
            changes = [];
            this._changesInElement.set(element, changes);
        }
        return changes;
    }
    /**
	* Creates and saves a snapshot for all children of the given element.
	*/ _makeSnapshots(element) {
        if (this._elementChildrenSnapshots.has(element)) return;
        const childrenSnapshots = $b9b9f2bdf9c6137f$var$_getChildrenSnapshots(element.getChildren());
        this._elementChildrenSnapshots.set(element, childrenSnapshots);
        for (const snapshot of childrenSnapshots)this._elementsSnapshots.set(snapshot.node, snapshot);
    }
    /**
	* For a given newly saved change, compares it with a change already done on the element and modifies the incoming
	* change and/or the old change.
	*
	* @param inc Incoming (new) change.
	* @param changes An array containing all the changes done on that element.
	*/ _handleChange(inc, changes) {
        inc.nodesToHandle = inc.howMany;
        for (const old of changes){
            const incEnd = inc.offset + inc.howMany;
            const oldEnd = old.offset + old.howMany;
            if (inc.type == "insert") {
                if (old.type == "insert") {
                    if (inc.offset <= old.offset) old.offset += inc.howMany;
                    else if (inc.offset < oldEnd) {
                        old.howMany += inc.nodesToHandle;
                        inc.nodesToHandle = 0;
                    }
                }
                if (old.type == "remove") {
                    if (inc.offset < old.offset) old.offset += inc.howMany;
                }
                if (old.type == "attribute") {
                    if (inc.offset <= old.offset) old.offset += inc.howMany;
                    else if (inc.offset < oldEnd) {
                        const howMany = old.howMany;
                        old.howMany = inc.offset - old.offset;
                        changes.unshift({
                            type: "attribute",
                            offset: incEnd,
                            howMany: howMany - old.howMany,
                            count: this._changeCount++
                        });
                    }
                }
            }
            if (inc.type == "remove") {
                if (old.type == "insert") {
                    if (incEnd <= old.offset) old.offset -= inc.howMany;
                    else if (incEnd <= oldEnd) {
                        if (inc.offset < old.offset) {
                            const intersectionLength = incEnd - old.offset;
                            old.offset = inc.offset;
                            old.howMany -= intersectionLength;
                            inc.nodesToHandle -= intersectionLength;
                        } else {
                            old.howMany -= inc.nodesToHandle;
                            inc.nodesToHandle = 0;
                        }
                    } else if (inc.offset <= old.offset) {
                        inc.nodesToHandle -= old.howMany;
                        old.howMany = 0;
                    } else if (inc.offset < oldEnd) {
                        const intersectionLength = oldEnd - inc.offset;
                        old.howMany -= intersectionLength;
                        inc.nodesToHandle -= intersectionLength;
                    }
                }
                if (old.type == "remove") {
                    if (incEnd <= old.offset) old.offset -= inc.howMany;
                    else if (inc.offset < old.offset) {
                        inc.nodesToHandle += old.howMany;
                        old.howMany = 0;
                    }
                }
                if (old.type == "attribute") {
                    if (incEnd <= old.offset) old.offset -= inc.howMany;
                    else if (inc.offset < old.offset) {
                        const intersectionLength = incEnd - old.offset;
                        old.offset = inc.offset;
                        old.howMany -= intersectionLength;
                    } else if (inc.offset < oldEnd) {
                        if (incEnd <= oldEnd) {
                            const howMany = old.howMany;
                            old.howMany = inc.offset - old.offset;
                            const howManyAfter = howMany - old.howMany - inc.nodesToHandle;
                            changes.unshift({
                                type: "attribute",
                                offset: inc.offset,
                                howMany: howManyAfter,
                                count: this._changeCount++
                            });
                        } else old.howMany -= oldEnd - inc.offset;
                    }
                }
            }
            if (inc.type == "attribute") {
                if (old.type == "insert") {
                    if (inc.offset < old.offset && incEnd > old.offset) {
                        if (incEnd > oldEnd) {
                            const attributePart = {
                                type: "attribute",
                                offset: oldEnd,
                                howMany: incEnd - oldEnd,
                                count: this._changeCount++
                            };
                            this._handleChange(attributePart, changes);
                            changes.push(attributePart);
                        }
                        inc.nodesToHandle = old.offset - inc.offset;
                        inc.howMany = inc.nodesToHandle;
                    } else if (inc.offset >= old.offset && inc.offset < oldEnd) {
                        if (incEnd > oldEnd) {
                            inc.nodesToHandle = incEnd - oldEnd;
                            inc.offset = oldEnd;
                        } else inc.nodesToHandle = 0;
                    }
                }
                if (old.type == "remove") {
                    if (inc.offset < old.offset && incEnd > old.offset) {
                        const attributePart = {
                            type: "attribute",
                            offset: old.offset,
                            howMany: incEnd - old.offset,
                            count: this._changeCount++
                        };
                        this._handleChange(attributePart, changes);
                        changes.push(attributePart);
                        inc.nodesToHandle = old.offset - inc.offset;
                        inc.howMany = inc.nodesToHandle;
                    }
                }
                if (old.type == "attribute") {
                    if (inc.offset >= old.offset && incEnd <= oldEnd) {
                        inc.nodesToHandle = 0;
                        inc.howMany = 0;
                        inc.offset = 0;
                    } else if (inc.offset <= old.offset && incEnd >= oldEnd) old.howMany = 0;
                }
            }
        }
        inc.howMany = inc.nodesToHandle;
        delete inc.nodesToHandle;
    }
    /**
	* Returns an object with a single insert change description.
	*
	* @param parent The element in which the change happened.
	* @param offset The offset at which change happened.
	* @param action Further specifies what kind of action led to generating this change.
	* @param elementSnapshot Snapshot of the inserted node after changes.
	* @param elementSnapshotBefore Snapshot of the inserted node before changes.
	* @returns The diff item.
	*/ _getInsertDiff(parent, offset, action, elementSnapshot, elementSnapshotBefore) {
        const diffItem = {
            type: "insert",
            position: $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(parent, offset),
            name: elementSnapshot.name,
            attributes: new Map(elementSnapshot.attributes),
            length: 1,
            changeCount: this._changeCount++,
            action: action
        };
        if (action != "insert" && elementSnapshotBefore) diffItem.before = {
            name: elementSnapshotBefore.name,
            attributes: new Map(elementSnapshotBefore.attributes)
        };
        return diffItem;
    }
    /**
	* Returns an object with a single remove change description.
	*
	* @param parent The element in which change happened.
	* @param offset The offset at which change happened.
	* @param action Further specifies what kind of action led to generating this change.
	* @param elementSnapshot The snapshot of the removed node before changes.
	* @returns The diff item.
	*/ _getRemoveDiff(parent, offset, action, elementSnapshot) {
        return {
            type: "remove",
            action: action,
            position: $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(parent, offset),
            name: elementSnapshot.name,
            attributes: new Map(elementSnapshot.attributes),
            length: 1,
            changeCount: this._changeCount++
        };
    }
    /**
	* Returns an array of objects where each one is a single attribute change description.
	*
	* @param range The range where the change happened.
	* @param oldAttributes A map, map iterator or compatible object that contains attributes before the change.
	* @param newAttributes A map, map iterator or compatible object that contains attributes after the change.
	* @returns An array containing one or more diff items.
	*/ _getAttributesDiff(range, oldAttributes, newAttributes) {
        const diffs = [];
        newAttributes = new Map(newAttributes);
        for (const [key, oldValue] of oldAttributes){
            const newValue = newAttributes.has(key) ? newAttributes.get(key) : null;
            if (newValue !== oldValue) diffs.push({
                type: "attribute",
                position: range.start,
                range: range.clone(),
                length: 1,
                attributeKey: key,
                attributeOldValue: oldValue,
                attributeNewValue: newValue,
                changeCount: this._changeCount++
            });
            newAttributes.delete(key);
        }
        for (const [key, newValue] of newAttributes)diffs.push({
            type: "attribute",
            position: range.start,
            range: range.clone(),
            length: 1,
            attributeKey: key,
            attributeOldValue: null,
            attributeNewValue: newValue,
            changeCount: this._changeCount++
        });
        return diffs;
    }
    /**
	* Checks whether given element or any of its parents is an element that is buffered as an inserted element.
	*/ _isInInsertedElement(element) {
        const parent = element.parent;
        if (!parent) return false;
        const changes = this._changesInElement.get(parent);
        const offset = element.startOffset;
        if (changes) {
            for (const change of changes)if (change.type == "insert" && offset >= change.offset && offset < change.offset + change.howMany) return true;
        }
        return this._isInInsertedElement(parent);
    }
    /**
	* Removes deeply all buffered changes that are registered in elements from range specified by `parent`, `offset`
	* and `howMany`.
	*/ _removeAllNestedChanges(parent, offset, howMany) {
        const range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(parent, offset), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(parent, offset + howMany));
        for (const item of range.getItems({
            shallow: true
        }))if (item.is("element")) {
            this._changesInElement.delete(item);
            this._removeAllNestedChanges(item, 0, item.maxOffset);
        }
    }
};
/**
* Returns a snapshot for the specified child node. Text node snapshots have the `name` property set to `$text`.
*/ function $b9b9f2bdf9c6137f$var$_getSingleNodeSnapshot(node) {
    return {
        node: node,
        name: node.is("$text") ? "$text" : node.name,
        attributes: new Map(node.getAttributes())
    };
}
/**
* Returns an array that is a copy of passed child list with the exception that text nodes are split to one or more
* objects, each representing one character and attributes set on that character.
*/ function $b9b9f2bdf9c6137f$var$_getChildrenSnapshots(children) {
    const snapshots = [];
    for (const child of children)if (child.is("$text")) for(let i = 0; i < child.data.length; ++i)snapshots.push($b9b9f2bdf9c6137f$var$_getSingleNodeSnapshot(child));
    else snapshots.push($b9b9f2bdf9c6137f$var$_getSingleNodeSnapshot(child));
    return snapshots;
}
/**
* Generates array of diff instructions for given changes set.
*
* Generated actions are:
*
* - 'e' for 'equal' - when item at that position did not change,
* - 'i' for 'insert' - when item at that position was inserted,
* - 'r' for 'remove' - when item at that position was removed,
* - 'a' for 'attribute' - when item at that position has it attributes changed.
*
* Example (assume that uppercase letters have bold attribute, compare with function code):
*
* children before:	fooBAR
* children after:	foxybAR
*
* changes: type: remove, offset: 1, howMany: 1
*			type: insert, offset: 2, howMany: 2
*			type: attribute, offset: 4, howMany: 1
*
* Expected actions: equal (f), remove (o), equal (o), insert (x), insert (y), attribute (b), equal (A), equal (R)
*
* Steps taken by the script:
*
* 1. change = "type: remove, offset: 1, howMany: 1"; offset = 0; oldChildrenHandled = 0
*    1.1 between this change and the beginning is one not-changed node, fill with one equal action, one old child has been handled
*    1.2 this change removes one node, add one remove action
*    1.3 change last visited `offset` to 1
*    1.4 since an old child has been removed, one more old child has been handled
*    1.5 actions at this point are: equal, remove
*
* 2. change = "type: insert, offset: 2, howMany: 2"; offset = 1; oldChildrenHandled = 2
*    2.1 between this change and previous change is one not-changed node, add equal action, another one old children has been handled
*    2.2 this change inserts two nodes, add two insert actions
*    2.3 change last visited offset to the end of the inserted range, that is 4
*    2.4 actions at this point are: equal, remove, equal, insert, insert
*
* 3. change = "type: attribute, offset: 4, howMany: 1"; offset = 4, oldChildrenHandled = 3
*    3.1 between this change and previous change are no not-changed nodes
*    3.2 this change changes one node, add one attribute action
*    3.3 change last visited `offset` to the end of change range, that is 5
*    3.4 since an old child has been changed, one more old child has been handled
*    3.5 actions at this point are: equal, remove, equal, insert, insert, attribute
*
* 4. after loop oldChildrenHandled = 4, oldChildrenLength = 6 (fooBAR is 6 characters)
*    4.1 fill up with two equal actions
*
* The result actions are: equal, remove, equal, insert, insert, attribute, equal, equal.
*/ function $b9b9f2bdf9c6137f$var$_generateDiffInstructionsFromChanges(oldChildrenLength, changes) {
    const diff = [];
    let offset = 0;
    let oldChildrenHandled = 0;
    for (const change of changes){
        if (change.offset > offset) {
            for(let i = 0; i < change.offset - offset; i++)diff.push("e");
            oldChildrenHandled += change.offset - offset;
        }
        if (change.type == "insert") {
            for(let i = 0; i < change.howMany; i++)diff.push("i");
            offset = change.offset + change.howMany;
        } else if (change.type == "remove") {
            for(let i = 0; i < change.howMany; i++)diff.push("r");
            offset = change.offset;
            oldChildrenHandled += change.howMany;
        } else {
            if (change.howMany > 1500) for(let i = 0; i < change.howMany; i++)diff.push("a");
            else diff.push(..."a".repeat(change.howMany).split(""));
            offset = change.offset + change.howMany;
            oldChildrenHandled += change.howMany;
        }
    }
    if (oldChildrenHandled < oldChildrenLength) for(let i = 0; i < oldChildrenLength - oldChildrenHandled - offset; i++)diff.push("e");
    return diff;
}
/**
* Filter callback for `Array.filter` that filters out change entries that are in graveyard.
*/ function $b9b9f2bdf9c6137f$var$_changesInGraveyardFilter(entry) {
    const posInGy = "position" in entry && entry.position.root.rootName == "$graveyard";
    const rangeInGy = "range" in entry && entry.range.root.rootName == "$graveyard";
    return !posInGy && !rangeInGy;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* `History` keeps the track of all the operations applied to the {@link module:engine/model/document~ModelDocument document}.
*/ var $b9b9f2bdf9c6137f$export$84202caead5689ba = class {
    /**
	* Operations added to the history.
	*/ _operations = [];
    /**
	* Holds an information which {@link module:engine/model/operation/operation~Operation operation} undoes which
	* {@link module:engine/model/operation/operation~Operation operation}.
	*
	* Keys of the map are "undoing operations", that is operations that undone some other operations. For each key, the
	* value is an operation that has been undone by the "undoing operation".
	*/ _undoPairs = /* @__PURE__ */ new Map();
    /**
	* Holds all undone operations.
	*/ _undoneOperations = /* @__PURE__ */ new Set();
    /**
	* A map that allows retrieving the operations fast based on the given base version.
	*/ _baseVersionToOperationIndex = /* @__PURE__ */ new Map();
    /**
	* The history version.
	*/ _version = 0;
    /**
	* The gap pairs kept in the <from,to> format.
	*
	* Anytime the `history.version` is set to a version larger than `history.version + 1`,
	* a new <lastHistoryVersion, newHistoryVersion> entry is added to the map.
	*/ _gaps = /* @__PURE__ */ new Map();
    /**
	* The version of the last operation in the history.
	*
	* The history version is incremented automatically when a new operation is added to the history.
	* Setting the version manually should be done only in rare circumstances when a gap is planned
	* between history versions. When doing so, a gap will be created and the history will accept adding
	* an operation with base version equal to the new history version.
	*/ get version() {
        return this._version;
    }
    set version(version) {
        if (this._operations.length && version > this._version + 1) this._gaps.set(this._version, version);
        this._version = version;
    }
    /**
	* The last history operation.
	*/ get lastOperation() {
        return this._operations[this._operations.length - 1];
    }
    /**
	* Adds an operation to the history and increments the history version.
	*
	* The operation's base version should be equal to the history version. Otherwise an error is thrown.
	*/ addOperation(operation) {
        if (operation.baseVersion !== this.version) /**
		* Only operations with matching versions can be added to the history.
		*
		* @error model-document-history-addoperation-incorrect-version
		* @param {module:engine/model/operation/operation~Operation} operation The current operation.
		* @param {number} historyVersion The current document history version.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-document-history-addoperation-incorrect-version", this, {
            operation: operation,
            historyVersion: this.version
        });
        this._operations.push(operation);
        this._version++;
        this._baseVersionToOperationIndex.set(operation.baseVersion, this._operations.length - 1);
    }
    /**
	* Returns operations from the given range of operation base versions that were added to the history.
	*
	* Note that there may be gaps in operations base versions.
	*
	* @param fromBaseVersion Base version from which operations should be returned (inclusive).
	* @param toBaseVersion Base version up to which operations should be returned (exclusive).
	* @returns History operations for the given range, in chronological order.
	*/ getOperations(fromBaseVersion, toBaseVersion = this.version) {
        if (!this._operations.length) return [];
        const firstOperation = this._operations[0];
        if (fromBaseVersion === void 0) fromBaseVersion = firstOperation.baseVersion;
        let inclusiveTo = toBaseVersion - 1;
        for (const [gapFrom, gapTo] of this._gaps){
            if (fromBaseVersion > gapFrom && fromBaseVersion < gapTo) fromBaseVersion = gapTo;
            if (inclusiveTo > gapFrom && inclusiveTo < gapTo) inclusiveTo = gapFrom - 1;
        }
        if (inclusiveTo < firstOperation.baseVersion || fromBaseVersion > this.lastOperation.baseVersion) return [];
        let fromIndex = this._baseVersionToOperationIndex.get(fromBaseVersion);
        if (fromIndex === void 0) fromIndex = 0;
        let toIndex = this._baseVersionToOperationIndex.get(inclusiveTo);
        if (toIndex === void 0) toIndex = this._operations.length - 1;
        return this._operations.slice(fromIndex, toIndex + 1);
    }
    /**
	* Returns operation from the history that bases on given `baseVersion`.
	*
	* @param baseVersion Base version of the operation to get.
	* @returns Operation with given base version or `undefined` if there is no such operation in history.
	*/ getOperation(baseVersion) {
        const operationIndex = this._baseVersionToOperationIndex.get(baseVersion);
        if (operationIndex === void 0) return;
        return this._operations[operationIndex];
    }
    /**
	* Marks in history that one operation is an operation that is undoing the other operation. By marking operation this way,
	* history is keeping more context information about operations, which helps in operational transformation.
	*
	* @param undoneOperation Operation which is undone by `undoingOperation`.
	* @param undoingOperation Operation which undoes `undoneOperation`.
	*/ setOperationAsUndone(undoneOperation, undoingOperation) {
        this._undoPairs.set(undoingOperation, undoneOperation);
        this._undoneOperations.add(undoneOperation);
    }
    /**
	* Checks whether given `operation` is undoing any other operation.
	*
	* @param operation Operation to check.
	* @returns `true` if given `operation` is undoing any other operation, `false` otherwise.
	*/ isUndoingOperation(operation) {
        return this._undoPairs.has(operation);
    }
    /**
	* Checks whether given `operation` has been undone by any other operation.
	*
	* @param operation Operation to check.
	* @returns `true` if given `operation` has been undone any other operation, `false` otherwise.
	*/ isUndoneOperation(operation) {
        return this._undoneOperations.has(operation);
    }
    /**
	* For given `undoingOperation`, returns the operation which has been undone by it.
	*
	* @returns Operation that has been undone by given `undoingOperation` or `undefined`
	* if given `undoingOperation` is not undoing any other operation.
	*/ getUndoneOperation(undoingOperation) {
        return this._undoPairs.get(undoingOperation);
    }
    /**
	* Resets the history of operations.
	*/ reset() {
        this._version = 0;
        this._undoPairs = /* @__PURE__ */ new Map();
        this._operations = [];
        this._undoneOperations = /* @__PURE__ */ new Set();
        this._gaps = /* @__PURE__ */ new Map();
        this._baseVersionToOperationIndex = /* @__PURE__ */ new Map();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/rootelement
*/ /**
* Type of {@link module:engine/model/element~ModelElement} that is a root of a model tree.
*/ var $b9b9f2bdf9c6137f$export$4294c3610dee24e8 = class extends $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 {
    /**
	* Unique root name used to identify this root element by {@link module:engine/model/document~ModelDocument}.
	*/ rootName;
    /**
	* Document that is an owner of this root.
	*/ _document;
    /**
	* @internal
	*/ _isAttached = true;
    /**
	* Informs if the root element is loaded (default).
	*
	* @internal
	*/ _isLoaded = true;
    /**
	* Creates root element.
	*
	* @param document Document that is an owner of this root.
	* @param name Node name.
	* @param rootName Unique root name used to identify this root element by {@link module:engine/model/document~ModelDocument}.
	*/ constructor(document1, name, rootName = "main"){
        super(name);
        this._document = document1;
        this.rootName = rootName;
    }
    /**
	* {@link module:engine/model/document~ModelDocument Document} that owns this root element.
	*/ get document() {
        return this._document;
    }
    /**
	* Informs if the root element is currently attached to the document, or not.
	*
	* A detached root is equivalent to being removed and cannot contain any children or markers.
	*
	* By default, a newly added root is attached. It can be detached using
	* {@link module:engine/model/writer~ModelWriter#detachRoot `Writer#detachRoot`}. A detached root can be re-attached again using
	* {@link module:engine/model/writer~ModelWriter#addRoot `Writer#addRoot`}.
	*/ isAttached() {
        return this._isAttached;
    }
    /**
	* Converts `RootElement` instance to `string` containing its name.
	*
	* @returns `RootElement` instance converted to `string`.
	*/ toJSON() {
        return this.rootName;
    }
};
$b9b9f2bdf9c6137f$export$4294c3610dee24e8.prototype.is = function(type, name) {
    if (!name) return type === "rootElement" || type === "model:rootElement" || type === "element" || type === "model:element" || type === "node" || type === "model:node";
    return name === this.name && (type === "rootElement" || type === "model:rootElement" || type === "element" || type === "model:element");
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/document
*/ const $b9b9f2bdf9c6137f$var$graveyardName = "$graveyard";
const $b9b9f2bdf9c6137f$var$ModelDocumentBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Data model's document. It contains the model's structure, its selection and the history of changes.
*
* Read more about working with the model in
* {@glink framework/architecture/editing-engine#model introduction to the the editing engine's architecture}.
*
* Usually, the document contains just one {@link module:engine/model/document~ModelDocument#roots root element}, so
* you can retrieve it by just calling {@link module:engine/model/document~ModelDocument#getRoot} without specifying its name:
*
* ```ts
* model.document.getRoot(); // -> returns the main root
* ```
*
* However, the document may contain multiple roots – e.g. when the editor has multiple editable areas
* (e.g. a title and a body of a message).
*/ var $b9b9f2bdf9c6137f$export$58ff3996fb255ace = class extends $b9b9f2bdf9c6137f$var$ModelDocumentBase {
    /**
	* The {@link module:engine/model/model~Model model} that the document is a part of.
	*/ model;
    /**
	* The document's history.
	*/ history;
    /**
	* The selection in this document.
	*/ selection;
    /**
	* A list of roots that are owned and managed by this document. Use {@link #createRoot}, {@link #getRoot} and
	* {@link #getRootNames} to manipulate it.
	*/ roots;
    /**
	* The model differ object. Its role is to buffer changes done on the model document and then calculate a diff of those changes.
	*/ differ;
    /**
	* Defines whether the document is in a read-only mode.
	*
	* The user should not be able to change the data of a document that is read-only.
	*
	* @readonly
	*/ isReadOnly;
    /**
	* Post-fixer callbacks registered to the model document.
	*/ _postFixers;
    /**
	* A flag that indicates whether the selection has changed since last change block.
	*/ _hasSelectionChangedFromTheLastChangeBlock;
    /**
	* Creates an empty document instance with no {@link #roots} (other than
	* the {@link #graveyard graveyard root}).
	*/ constructor(model){
        super();
        this.model = model;
        this.history = new $b9b9f2bdf9c6137f$export$84202caead5689ba();
        this.selection = new $b9b9f2bdf9c6137f$export$7ad0b188284367aa(this);
        this.roots = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)({
            idProperty: "rootName"
        });
        this.differ = new $b9b9f2bdf9c6137f$export$2bb42ee3c96bc74d(model.markers);
        this.isReadOnly = false;
        this._postFixers = /* @__PURE__ */ new Set();
        this._hasSelectionChangedFromTheLastChangeBlock = false;
        this.createRoot("$root", $b9b9f2bdf9c6137f$var$graveyardName);
        this.listenTo(model, "applyOperation", (evt, args)=>{
            const operation = args[0];
            if (operation.isDocumentOperation) this.differ.bufferOperation(operation);
        }, {
            priority: "high"
        });
        this.listenTo(model, "applyOperation", (evt, args)=>{
            const operation = args[0];
            if (operation.isDocumentOperation) this.history.addOperation(operation);
        }, {
            priority: "low"
        });
        this.listenTo(this.selection, "change", ()=>{
            this._hasSelectionChangedFromTheLastChangeBlock = true;
        });
        this.listenTo(model.markers, "update", (evt, marker, oldRange, newRange, oldMarkerData)=>{
            const newMarkerData = {
                ...marker.getData(),
                range: newRange
            };
            this.differ.bufferMarkerChange(marker.name, oldMarkerData, newMarkerData);
            if (oldRange === null) marker.on("change", (evt, oldRange)=>{
                const markerData = marker.getData();
                this.differ.bufferMarkerChange(marker.name, {
                    ...markerData,
                    range: oldRange
                }, markerData);
            });
        });
        this.registerPostFixer((writer)=>{
            let result = false;
            for (const root of this.roots)if (!root.isAttached() && !root.isEmpty) {
                writer.remove(writer.createRangeIn(root));
                result = true;
            }
            for (const marker of this.model.markers)if (!marker.getRange().root.isAttached()) {
                writer.removeMarker(marker);
                result = true;
            }
            return result;
        });
    }
    /**
	* The document version. Every applied operation increases the version number. It is used to
	* ensure that operations are applied on a proper document version.
	*
	* This property is equal to {@link module:engine/model/history~History#version `model.Document#history#version`}.
	*
	* If the {@link module:engine/model/operation/operation~Operation#baseVersion base version} does not match the document version,
	* a {@link module:utils/ckeditorerror~CKEditorError model-document-applyoperation-wrong-version} error is thrown.
	*/ get version() {
        return this.history.version;
    }
    set version(version) {
        this.history.version = version;
    }
    /**
	* The graveyard tree root. A document always has a graveyard root that stores removed nodes.
	*/ get graveyard() {
        return this.getRoot($b9b9f2bdf9c6137f$var$graveyardName);
    }
    /**
	* Creates a new root.
	*
	* **Note:** do not use this method after the editor has been initialized! If you want to dynamically add a root, use
	* {@link module:engine/model/writer~ModelWriter#addRoot `model.Writer#addRoot`} instead.
	*
	* **Note:** The default `elementName` value is `'$root'`. When the editor uses a custom root
	* {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the configured model element
	* name explicitly so the created root matches the schema the features expect.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*
	* @param elementName The element name. Defaults to `'$root'` which also has some basic schema defined
	* (e.g. `$block` elements are allowed inside the `$root`). Make sure to define a proper schema if you use a different name.
	* @param rootName A unique root name.
	* @returns The created root.
	*/ createRoot(elementName = "$root", rootName = "main") {
        if (this.roots.get(rootName)) /**
		* A root with the specified name already exists.
		*
		* @error model-document-createroot-name-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-document-createroot-name-exists", this, {
            name: rootName
        });
        const root = new $b9b9f2bdf9c6137f$export$4294c3610dee24e8(this, elementName, rootName);
        this.roots.add(root);
        return root;
    }
    /**
	* Removes all event listeners set by the document instance.
	*/ destroy() {
        this.selection.destroy();
        this.stopListening();
    }
    /**
	* Returns a root by its name.
	*
	* Detached roots are returned by this method. This is to be able to operate on the detached root (for example, to be able to create
	* a position inside such a root for undo feature purposes).
	*
	* @param name The root name of the root to return.
	* @returns The root registered under a given name or `null` when there is no root with the given name.
	*/ getRoot(name = "main") {
        return this.roots.get(name);
    }
    /**
	* Returns an array with names of all roots added to the document (except the {@link #graveyard graveyard root}).
	*
	* Detached roots **are not** returned by this method by default. This is to make sure that all features or algorithms that operate
	* on the document data know which roots are still a part of the document and should be processed.
	*
	* @param includeDetached Specified whether detached roots should be returned as well.
	*/ getRootNames(includeDetached = false) {
        return this.getRoots(includeDetached).map((root)=>root.rootName);
    }
    /**
	* Returns an array with all roots added to the document (except the {@link #graveyard graveyard root}).
	*
	* Detached roots **are not** returned by this method by default. This is to make sure that all features or algorithms that operate
	* on the document data know which roots are still a part of the document and should be processed.
	*
	* @param includeDetached Specified whether detached roots should be returned as well.
	*/ getRoots(includeDetached = false) {
        return this.roots.filter((root)=>root != this.graveyard && (includeDetached || root.isAttached()) && root._isLoaded);
    }
    /**
	* Used to register a post-fixer callback. A post-fixer mechanism guarantees that the features
	* will operate on a correct model state.
	*
	* An execution of a feature may lead to an incorrect document tree state. The callbacks are used to fix the document tree after
	* it has changed. Post-fixers are fired just after all changes from the outermost change block were applied but
	* before the {@link module:engine/model/document~ModelDocument#event:change change event} is fired. If a post-fixer callback made
	* a change, it should return `true`. When this happens, all post-fixers are fired again to check if something else should
	* not be fixed in the new document tree state.
	*
	* As a parameter, a post-fixer callback receives a {@link module:engine/model/writer~ModelWriter writer} instance connected with the
	* executed changes block. Thanks to that, all changes done by the callback will be added to the same
	* {@link module:engine/model/batch~Batch batch} (and undo step) as the original changes. This makes post-fixer changes transparent
	* for the user.
	*
	* An example of a post-fixer is a callback that checks if all the data were removed from the editor. If so, the
	* callback should add an empty paragraph so that the editor is never empty:
	*
	* ```ts
	* document.registerPostFixer( writer => {
	* 	const changes = document.differ.getChanges();
	*
	* 	// Check if the changes lead to an empty root in the editor.
	* 	for ( const entry of changes ) {
	* 		if ( entry.type == 'remove' && entry.position.root.isEmpty ) {
	* 			writer.insertElement( 'paragraph', entry.position.root, 0 );
	*
	* 			// It is fine to return early, even if multiple roots would need to be fixed.
	* 			// All post-fixers will be fired again, so if there are more empty roots, those will be fixed, too.
	* 			return true;
	* 		}
	* 	}
	*
	* 	return false;
	* } );
	* ```
	*/ registerPostFixer(postFixer) {
        this._postFixers.add(postFixer);
    }
    /**
	* A custom `toJSON()` method to solve child-parent circular dependencies.
	*
	* @returns A clone of this object with the document property changed to a string.
	*/ toJSON() {
        const json = (0, $e248d0fa19ac08a2$export$9cd59f9826255e47)(this);
        json.selection = "[engine.model.DocumentSelection]";
        json.model = "[engine.model.Model]";
        return json;
    }
    /**
	* Check if there were any changes done on document, and if so, call post-fixers,
	* fire `change` event for features and conversion and then reset the differ.
	* Fire `change:data` event when at least one operation or buffered marker changes the data.
	*
	* @internal
	* @fires change
	* @fires change:data
	* @param writer The writer on which post-fixers will be called.
	*/ _handleChangeBlock(writer) {
        if (this._hasDocumentChangedFromTheLastChangeBlock()) {
            this._callPostFixers(writer);
            this.selection.refresh();
            if (this.differ.hasDataChanges()) this.fire("change:data", writer.batch);
            else this.fire("change", writer.batch);
            this.selection.refresh();
            this.differ.reset();
        }
        this._hasSelectionChangedFromTheLastChangeBlock = false;
    }
    /**
	* Returns whether there is a buffered change or if the selection has changed from the last
	* {@link module:engine/model/model~Model#enqueueChange `enqueueChange()` block}
	* or {@link module:engine/model/model~Model#change `change()` block}.
	*
	* @returns Returns `true` if document has changed from the last `change()` or `enqueueChange()` block.
	*/ _hasDocumentChangedFromTheLastChangeBlock() {
        return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
    }
    /**
	* Returns the default root for this document which is either the first root that was added to the document using
	* {@link #createRoot} or the {@link #graveyard graveyard root} if no other roots were created.
	*
	* @returns The default root for this document.
	*/ _getDefaultRoot() {
        const roots = this.getRoots();
        return roots.length ? roots[0] : this.graveyard;
    }
    /**
	* Returns the default range for this selection. The default range is a collapsed range that starts and ends
	* at the beginning of this selection's document {@link #_getDefaultRoot default root}.
	*
	* @internal
	*/ _getDefaultRange() {
        const defaultRoot = this._getDefaultRoot();
        const model = this.model;
        const schema = model.schema;
        const position = model.createPositionFromPath(defaultRoot, [
            0
        ]);
        return schema.getNearestSelectionRange(position) || model.createRange(position);
    }
    /**
	* Checks whether a given {@link module:engine/model/range~ModelRange range} is a valid range for
	* the {@link #selection document's selection}.
	*
	* @internal
	* @param range A range to check.
	* @returns `true` if `range` is valid, `false` otherwise.
	*/ _validateSelectionRange(range) {
        return range.start.isValid() && range.end.isValid() && $b9b9f2bdf9c6137f$var$validateTextNodePosition(range.start) && $b9b9f2bdf9c6137f$var$validateTextNodePosition(range.end);
    }
    /**
	* Performs post-fixer loops. Executes post-fixer callbacks as long as none of them has done any changes to the model.
	*
	* @param writer The writer on which post-fixer callbacks will be called.
	*/ _callPostFixers(writer) {
        let wasFixed = false;
        do for (const callback of this._postFixers){
            this.selection.refresh();
            wasFixed = callback(writer);
            if (wasFixed) break;
        }
        while (wasFixed);
    }
};
/**
* Checks whether given range boundary position is valid for document selection, meaning that is not between
* unicode surrogate pairs or base character and combining marks.
*/ function $b9b9f2bdf9c6137f$var$validateTextNodePosition(rangeBoundary) {
    const textNode = rangeBoundary.textNode;
    if (textNode) {
        const data = textNode.data;
        const offset = rangeBoundary.offset - textNode.startOffset;
        return !(0, $c7bc2cb7e2db0227$export$910da4ddfe197244)(data, offset) && !(0, $c7bc2cb7e2db0227$export$1a90459935e74227)(data, offset);
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/markercollection
*/ const $b9b9f2bdf9c6137f$var$MarkerCollectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
const $b9b9f2bdf9c6137f$var$MarkerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)($b9b9f2bdf9c6137f$export$68dcb975ec9fb725);
/**
* The collection of all {@link module:engine/model/markercollection~Marker markers} attached to the document.
* It lets you {@link module:engine/model/markercollection~MarkerCollection#get get} markers or track them using
* {@link module:engine/model/markercollection~MarkerCollection#event:update} event.
*
* To create, change or remove makers use {@link module:engine/model/writer~ModelWriter model writers'} methods:
* {@link module:engine/model/writer~ModelWriter#addMarker} or {@link module:engine/model/writer~ModelWriter#removeMarker}. Since
* the writer is the only proper way to change the data model it is not possible to change markers directly using this
* collection. All markers created by the writer will be automatically added to this collection.
*
* By default there is one marker collection available as {@link module:engine/model/model~Model#markers model property}.
*
* @see module:engine/model/markercollection~Marker
*/ var $b9b9f2bdf9c6137f$export$6e315ea0a0a1025 = class extends $b9b9f2bdf9c6137f$var$MarkerCollectionBase {
    /**
	* Stores {@link ~Marker markers} added to the collection.
	*/ _markers = /* @__PURE__ */ new Map();
    /**
	* Iterable interface.
	*
	* Iterates over all {@link ~Marker markers} added to the collection.
	*/ [Symbol.iterator]() {
        return this._markers.values();
    }
    /**
	* Checks if given {@link ~Marker marker} or marker name is in the collection.
	*
	* @param markerOrName Name of marker or marker instance to check.
	* @returns `true` if marker is in the collection, `false` otherwise.
	*/ has(markerOrName) {
        const markerName = markerOrName instanceof $b9b9f2bdf9c6137f$export$e98856a975cab58e ? markerOrName.name : markerOrName;
        return this._markers.has(markerName);
    }
    /**
	* Returns {@link ~Marker marker} with given `markerName`.
	*
	* @param markerName Name of marker to get.
	* @returns Marker with given name or `null` if such marker was
	* not added to the collection.
	*/ get(markerName) {
        return this._markers.get(markerName) || null;
    }
    /**
	* Creates and adds a {@link ~Marker marker} to the `MarkerCollection` with given name on given
	* {@link module:engine/model/range~ModelRange range}.
	*
	* If `MarkerCollection` already had a marker with given name (or {@link ~Marker marker} was passed), the marker in
	* collection is updated and {@link module:engine/model/markercollection~MarkerCollection#event:update} event is fired
	* but only if there was a change (marker range or {@link module:engine/model/markercollection~Marker#managedUsingOperations}
	* flag has changed.
	*
	* @internal
	* @fires update
	* @param markerOrName Name of marker to set or marker instance to update.
	* @param range Marker range.
	* @param managedUsingOperations Specifies whether the marker is managed using operations.
	* @param affectsData Specifies whether the marker affects the data produced by the data pipeline
	* (is persisted in the editor's data).
	* @returns `Marker` instance which was added or updated.
	*/ _set(markerOrName, range, managedUsingOperations = false, affectsData = false) {
        const markerName = markerOrName instanceof $b9b9f2bdf9c6137f$export$e98856a975cab58e ? markerOrName.name : markerOrName;
        if (markerName.includes(",")) /**
		* Marker name cannot contain the "," character.
		*
		* @error markercollection-incorrect-marker-name
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("markercollection-incorrect-marker-name", this);
        const oldMarker = this._markers.get(markerName);
        if (oldMarker) {
            const oldMarkerData = oldMarker.getData();
            const oldRange = oldMarker.getRange();
            let hasChanged = false;
            if (!oldRange.isEqual(range)) {
                oldMarker._attachLiveRange($b9b9f2bdf9c6137f$export$a20b9237842cdd3f.fromRange(range));
                hasChanged = true;
            }
            if (managedUsingOperations != oldMarker.managedUsingOperations) {
                oldMarker._managedUsingOperations = managedUsingOperations;
                hasChanged = true;
            }
            if (typeof affectsData === "boolean" && affectsData != oldMarker.affectsData) {
                oldMarker._affectsData = affectsData;
                hasChanged = true;
            }
            if (hasChanged) this.fire(`update:${markerName}`, oldMarker, oldRange, range, oldMarkerData);
            return oldMarker;
        }
        const liveRange = $b9b9f2bdf9c6137f$export$a20b9237842cdd3f.fromRange(range);
        const marker = new $b9b9f2bdf9c6137f$export$e98856a975cab58e(markerName, liveRange, managedUsingOperations, affectsData);
        this._markers.set(markerName, marker);
        this.fire(`update:${markerName}`, marker, null, range, {
            ...marker.getData(),
            range: null
        });
        return marker;
    }
    /**
	* Removes given {@link ~Marker marker} or a marker with given name from the `MarkerCollection`.
	*
	* @internal
	* @fires update
	* @param markerOrName Marker or name of a marker to remove.
	* @returns `true` if marker was found and removed, `false` otherwise.
	*/ _remove(markerOrName) {
        const markerName = markerOrName instanceof $b9b9f2bdf9c6137f$export$e98856a975cab58e ? markerOrName.name : markerOrName;
        const oldMarker = this._markers.get(markerName);
        if (oldMarker) {
            this._markers.delete(markerName);
            this.fire(`update:${markerName}`, oldMarker, oldMarker.getRange(), null, oldMarker.getData());
            this._destroyMarker(oldMarker);
            return true;
        }
        return false;
    }
    /**
	* Fires an {@link module:engine/model/markercollection~MarkerCollection#event:update} event for the given {@link ~Marker marker}
	* but does not change the marker. Useful to force {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast
	* conversion} for the marker.
	*
	* @internal
	* @fires update
	* @param markerOrName Marker or name of a marker to refresh.
	*/ _refresh(markerOrName) {
        const markerName = markerOrName instanceof $b9b9f2bdf9c6137f$export$e98856a975cab58e ? markerOrName.name : markerOrName;
        const marker = this._markers.get(markerName);
        if (!marker) /**
		* Marker with provided name does not exists.
		*
		* @error markercollection-refresh-marker-not-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("markercollection-refresh-marker-not-exists", this);
        const range = marker.getRange();
        this.fire(`update:${markerName}`, marker, range, range, marker.getData());
    }
    /**
	* Returns iterator that iterates over all markers, which ranges
	* contain given {@link module:engine/model/position~ModelPosition position}.
	*/ *getMarkersAtPosition(position) {
        for (const marker of this)if (marker.getRange().containsPosition(position)) yield marker;
    }
    /**
	* Returns iterator that iterates over all markers, which intersects with given {@link module:engine/model/range~ModelRange range}.
	*/ *getMarkersIntersectingRange(range) {
        for (const marker of this)if (marker.getRange().getIntersection(range) !== null) yield marker;
    }
    /**
	* Destroys marker collection and all markers inside it.
	*/ destroy() {
        for (const marker of this._markers.values())this._destroyMarker(marker);
        this._markers.clear();
        this.stopListening();
    }
    /**
	* Iterates over all markers that starts with given `prefix`.
	*
	* ```ts
	* const markerFooA = markersCollection._set( 'foo:a', rangeFooA );
	* const markerFooB = markersCollection._set( 'foo:b', rangeFooB );
	* const markerBarA = markersCollection._set( 'bar:a', rangeBarA );
	* const markerFooBarA = markersCollection._set( 'foobar:a', rangeFooBarA );
	* Array.from( markersCollection.getMarkersGroup( 'foo' ) ); // [ markerFooA, markerFooB ]
	* Array.from( markersCollection.getMarkersGroup( 'a' ) ); // []
	* ```
	*/ *getMarkersGroup(prefix) {
        for (const marker of this._markers.values())if (marker.name.startsWith(prefix + ":")) yield marker;
    }
    /**
	* Destroys the marker.
	*/ _destroyMarker(marker) {
        marker.stopListening();
        marker._detachLiveRange();
    }
};
/**
* `Marker` is a continuous part of the model (like a range), is named and represents some kind of information about the
* marked part of the model document. In contrary to {@link module:engine/model/node~ModelNode nodes}, which are building blocks of
* the model document tree, markers are not stored directly in the document tree but in the
* {@link module:engine/model/model~Model#markers model markers' collection}. Still, they are document data, by giving
* additional meaning to the part of a model document between marker start and marker end.
*
* In this sense, markers are similar to adding and converting attributes on nodes. The difference is that attribute is
* connected with a given node (e.g. a character is bold no matter if it gets moved or content around it changes).
* Markers on the other hand are continuous ranges and are characterized by their start and end position. This means that
* any character in the marker is marked by the marker. For example, if a character is moved outside of marker it stops being
* "special" and the marker is shrunk. Similarly, when a character is moved into the marker from other place in document
* model, it starts being "special" and the marker is enlarged.
*
* Another upside of markers is that finding marked part of document is fast and easy. Using attributes to mark some nodes
* and then trying to find that part of document would require traversing whole document tree. Marker gives instant access
* to the range which it is marking at the moment.
*
* Markers are built from a name and a range.
*
* Range of the marker is updated automatically when document changes, using
* {@link module:engine/model/liverange~ModelLiveRange live range} mechanism.
*
* Name is used to group and identify markers. Names have to be unique, but markers can be grouped by
* using common prefixes, separated with `:`, for example: `user:john` or `search:3`. That's useful in term of creating
* namespaces for custom elements (e.g. comments, highlights). You can use this prefixes in
* {@link module:engine/model/markercollection~MarkerCollection#event:update} listeners to listen on changes in a group of markers.
* For instance: `model.markers.on( 'update:user', callback );` will be called whenever any `user:*` markers changes.
*
* There are two types of markers.
*
* 1. Markers managed directly, without using operations. They are added directly by {@link module:engine/model/writer~ModelWriter}
* to the {@link module:engine/model/markercollection~MarkerCollection} without any additional mechanism. They can be used
* as bookmarks or visual markers. They are great for showing results of the find, or select link when the focus is in the input.
*
* 1. Markers managed using operations. These markers are also stored in {@link module:engine/model/markercollection~MarkerCollection}
* but changes in these markers is managed the same way all other changes in the model structure - using operations.
* Therefore, they are handled in the undo stack and synchronized between clients if the collaboration plugin is enabled.
* This type of markers is useful for solutions like spell checking or comments.
*
* Both type of them should be added / updated by {@link module:engine/model/writer~ModelWriter#addMarker}
* and removed by {@link module:engine/model/writer~ModelWriter#removeMarker} methods.
*
* ```ts
* model.change( ( writer ) => {
* 	const marker = writer.addMarker( name, { range, usingOperation: true } );
*
* 	// ...
*
* 	writer.removeMarker( marker );
* } );
* ```
*
* See {@link module:engine/model/writer~ModelWriter} to find more examples.
*
* Since markers need to track change in the document, for efficiency reasons, it is best to create and keep as little
* markers as possible and remove them as soon as they are not needed anymore.
*
* Markers can be downcasted and upcasted.
*
* Markers downcast happens on {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker} and
* {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:removeMarker} events.
* Use {@link module:engine/conversion/downcasthelpers downcast converters} or attach a custom converter to mentioned events.
* For {@link module:engine/controller/datacontroller~DataController data pipeline}, marker should be downcasted to an element.
* Then, it can be upcasted back to a marker. Again, use {@link module:engine/conversion/upcasthelpers upcast converters} or
* attach a custom converter to {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element}.
*
* `Marker` instances are created and destroyed only by {@link ~MarkerCollection MarkerCollection}.
*/ var $b9b9f2bdf9c6137f$export$e98856a975cab58e = class extends $b9b9f2bdf9c6137f$var$MarkerBase {
    /**
	* Marker's name.
	*/ name;
    /**
	* Flag indicates if the marker is managed using operations or not.
	*
	* @internal
	*/ _managedUsingOperations;
    /**
	* Specifies whether the marker affects the data produced by the data pipeline
	* (is persisted in the editor's data).
	*
	* @internal
	*/ _affectsData;
    /**
	* Range marked by the marker.
	*/ _liveRange;
    /**
	* Creates a marker instance.
	*
	* @param name Marker name.
	* @param liveRange Range marked by the marker.
	* @param managedUsingOperations Specifies whether the marker is managed using operations.
	* @param affectsData Specifies whether the marker affects the data produced by the data pipeline (is persisted in the editor's data).
	*/ constructor(name, liveRange, managedUsingOperations, affectsData){
        super();
        this.name = name;
        this._liveRange = this._attachLiveRange(liveRange);
        this._managedUsingOperations = managedUsingOperations;
        this._affectsData = affectsData;
    }
    /**
	* A value indicating if the marker is managed using operations.
	* See {@link ~Marker marker class description} to learn more about marker types.
	* See {@link module:engine/model/writer~ModelWriter#addMarker}.
	*/ get managedUsingOperations() {
        if (!this._liveRange) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("marker-destroyed", this);
        return this._managedUsingOperations;
    }
    /**
	* A value indicating if the marker changes the data.
	*/ get affectsData() {
        if (!this._liveRange) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("marker-destroyed", this);
        return this._affectsData;
    }
    /**
	* Returns the marker data (properties defining the marker).
	*/ getData() {
        return {
            range: this.getRange(),
            affectsData: this.affectsData,
            managedUsingOperations: this.managedUsingOperations
        };
    }
    /**
	* Returns current marker start position.
	*/ getStart() {
        if (!this._liveRange) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("marker-destroyed", this);
        return this._liveRange.start.clone();
    }
    /**
	* Returns current marker end position.
	*/ getEnd() {
        if (!this._liveRange) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("marker-destroyed", this);
        return this._liveRange.end.clone();
    }
    /**
	* Returns a range that represents the current state of the marker.
	*
	* Keep in mind that returned value is a {@link module:engine/model/range~ModelRange Range}, not a
	* {@link module:engine/model/liverange~ModelLiveRange ModelLiveRange}. This means that it is up-to-date and relevant only
	* until next model document change. Do not store values returned by this method. Instead, store {@link ~Marker#name}
	* and get `Marker` instance from {@link module:engine/model/markercollection~MarkerCollection MarkerCollection} every
	* time there is a need to read marker properties. This will guarantee that the marker has not been removed and
	* that it's data is up-to-date.
	*/ getRange() {
        if (!this._liveRange) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("marker-destroyed", this);
        return this._liveRange.toRange();
    }
    /**
	* Converts `Marker` to plain object and returns it.
	*
	* @returns `Marker` converted to plain object.
	*/ toJSON() {
        return {
            name: this.name,
            range: this._liveRange?.toJSON(),
            usingOperations: this._managedUsingOperations,
            affectsData: this._affectsData
        };
    }
    /**
	* Binds new live range to the marker and detach the old one if is attached.
	*
	* @internal
	* @param liveRange Live range to attach
	* @returns Attached live range.
	*/ _attachLiveRange(liveRange) {
        if (this._liveRange) this._detachLiveRange();
        liveRange.delegate("change:range").to(this);
        liveRange.delegate("change:content").to(this);
        this._liveRange = liveRange;
        return liveRange;
    }
    /**
	* Unbinds and destroys currently attached live range.
	*
	* @internal
	*/ _detachLiveRange() {
        this._liveRange.stopDelegating("change:range", this);
        this._liveRange.stopDelegating("change:content", this);
        this._liveRange.detach();
        this._liveRange = null;
    }
};
$b9b9f2bdf9c6137f$export$e98856a975cab58e.prototype.is = function(type) {
    return type === "marker" || type === "model:marker";
};
/**
* Cannot use a {@link module:engine/model/markercollection~MarkerCollection#destroy destroyed marker} instance.
*
* @error marker-destroyed
*/ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/operation/detachoperation
*/ /**
* Operation to permanently remove node from detached root.
* Note this operation is only a local operation and won't be send to the other clients.
*
* @internal
*/ var $b9b9f2bdf9c6137f$export$5cd016ed8b42bc6 = class extends $b9b9f2bdf9c6137f$export$ab5aad00225c5662 {
    /**
	* Position before the first {@link module:engine/model/item~ModelItem model item} to detach.
	*/ sourcePosition;
    /**
	* Offset size of moved range.
	*/ howMany;
    /**
	* Creates an insert operation.
	*
	* @param sourcePosition Position before the first {@link module:engine/model/item~ModelItem model item} to move.
	* @param howMany Offset size of moved range. Moved range will start from `sourcePosition` and end at
	* `sourcePosition` with offset shifted by `howMany`.
	*/ constructor(sourcePosition, howMany){
        super(null);
        this.sourcePosition = sourcePosition.clone();
        this.howMany = howMany;
    }
    /**
	* @inheritDoc
	*/ get type() {
        return "detach";
    }
    /**
	* @inheritDoc
	*/ get affectedSelectable() {
        return null;
    }
    /**
	* @inheritDoc
	*/ toJSON() {
        const json = super.toJSON();
        json.sourcePosition = this.sourcePosition.toJSON();
        return json;
    }
    /**
	* @inheritDoc
	* @internal
	*/ _validate() {
        if (this.sourcePosition.root.document) /**
		* Cannot detach document node.
		*
		* @error detach-operation-on-document-node
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("detach-operation-on-document-node", this);
    }
    /**
	* @inheritDoc
	* @internal
	*/ _execute() {
        $b9b9f2bdf9c6137f$export$acf4a1780ce6fa8b($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(this.sourcePosition, this.howMany));
    }
    /**
	* @inheritDoc
	*/ static get className() {
        return "DetachOperation";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/documentfragment
*/ /**
* ModelDocumentFragment represents a part of model which does not have a common root but its top-level nodes
* can be seen as siblings. In other words, it is a detached part of model tree, without a root.
*
* ModelDocumentFragment has own {@link module:engine/model/markercollection~MarkerCollection}. Markers from this collection
* will be set to the {@link module:engine/model/model~Model#markers model markers} by a
* {@link module:engine/model/writer~ModelWriter#insert} function.
*/ var $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 = class ModelDocumentFragment extends $b9b9f2bdf9c6137f$export$68dcb975ec9fb725 {
    /**
	* ModelDocumentFragment static markers map. This is a list of names and {@link module:engine/model/range~ModelRange ranges}
	* which will be set as Markers to {@link module:engine/model/model~Model#markers model markers collection}
	* when ModelDocumentFragment will be inserted to the document.
	*/ markers = /* @__PURE__ */ new Map();
    /**
	* List of nodes contained inside the document fragment.
	*/ _children = new $b9b9f2bdf9c6137f$export$a6b5dd876e414da1();
    /**
	* Creates an empty `ModelDocumentFragment`.
	*
	* **Note:** Constructor of this class shouldn't be used directly in the code.
	* Use the {@link module:engine/model/writer~ModelWriter#createDocumentFragment} method instead.
	*
	* @internal
	* @param children Nodes to be contained inside the `ModelDocumentFragment`.
	*/ constructor(children){
        super();
        if (children) this._insertChild(0, children);
    }
    /**
	* Returns an iterator that iterates over all nodes contained inside this document fragment.
	*/ [Symbol.iterator]() {
        return this.getChildren();
    }
    /**
	* Number of this document fragment's children.
	*/ get childCount() {
        return this._children.length;
    }
    /**
	* Sum of {@link module:engine/model/node~ModelNode#offsetSize offset sizes} of all of this document fragment's children.
	*/ get maxOffset() {
        return this._children.maxOffset;
    }
    /**
	* Is `true` if there are no nodes inside this document fragment, `false` otherwise.
	*/ get isEmpty() {
        return this.childCount === 0;
    }
    /**
	* Artificial next sibling. Returns `null`. Added for compatibility reasons.
	*/ get nextSibling() {
        return null;
    }
    /**
	* Artificial previous sibling. Returns `null`. Added for compatibility reasons.
	*/ get previousSibling() {
        return null;
    }
    /**
	* Artificial root of `ModelDocumentFragment`. Returns itself. Added for compatibility reasons.
	*/ get root() {
        return this;
    }
    /**
	* Artificial parent of `ModelDocumentFragment`. Returns `null`. Added for compatibility reasons.
	*/ get parent() {
        return null;
    }
    /**
	* Artificial owner of `ModelDocumentFragment`. Returns `null`. Added for compatibility reasons.
	*/ get document() {
        return null;
    }
    /**
	* Returns `false` as `ModelDocumentFragment` by definition is not attached to a document. Added for compatibility reasons.
	*/ isAttached() {
        return false;
    }
    /**
	* Returns empty array. Added for compatibility reasons.
	*/ getAncestors() {
        return [];
    }
    /**
	* Gets the child at the given index. Returns `null` if incorrect index was passed.
	*
	* @param index Index in this document fragment.
	* @returns Child node.
	*/ getChild(index) {
        return this._children.getNode(index);
    }
    /**
	* Gets the child at the given offset. Returns `null` if incorrect index was passed.
	*
	* @param offset Offset in this document fragment.
	* @returns Child node.
	*/ getChildAtOffset(offset) {
        return this._children.getNodeAtOffset(offset);
    }
    /**
	* Returns an iterator that iterates over all of this document fragment's children.
	*/ getChildren() {
        return this._children[Symbol.iterator]();
    }
    /**
	* Returns an index of the given child node. Returns `null` if given node is not a child of this document fragment.
	*
	* @param node Child node to look for.
	* @returns Child node's index.
	*/ getChildIndex(node) {
        return this._children.getNodeIndex(node);
    }
    /**
	* Returns the starting offset of given child. Starting offset is equal to the sum of
	* {@link module:engine/model/node~ModelNode#offsetSize offset sizes} of all node's siblings that are before it. Returns `null` if
	* given node is not a child of this document fragment.
	*
	* @param node Child node to look for.
	* @returns Child node's starting offset.
	*/ getChildStartOffset(node) {
        return this._children.getNodeStartOffset(node);
    }
    /**
	* Returns path to a `ModelDocumentFragment`, which is an empty array. Added for compatibility reasons.
	*/ getPath() {
        return [];
    }
    /**
	* Returns a descendant node by its path relative to this element.
	*
	* ```ts
	* // <this>a<b>c</b></this>
	* this.getNodeByPath( [ 0 ] );     // -> "a"
	* this.getNodeByPath( [ 1 ] );     // -> <b>
	* this.getNodeByPath( [ 1, 0 ] );  // -> "c"
	* ```
	*
	* @param relativePath Path of the node to find, relative to this element.
	*/ getNodeByPath(relativePath) {
        let node = this;
        for (const offset of relativePath)node = node.getChildAtOffset(offset);
        return node;
    }
    /**
	* Converts offset "position" to index "position".
	*
	* Returns index of a node that occupies given offset. If given offset is too low, returns `0`. If given offset is
	* too high, returns index after last child.
	*
	* ```ts
	* const textNode = new Text( 'foo' );
	* const pElement = new Element( 'p' );
	* const docFrag = new ModelDocumentFragment( [ textNode, pElement ] );
	* docFrag.offsetToIndex( -1 ); // Returns 0, because offset is too low.
	* docFrag.offsetToIndex( 0 ); // Returns 0, because offset 0 is taken by `textNode` which is at index 0.
	* docFrag.offsetToIndex( 1 ); // Returns 0, because `textNode` has `offsetSize` equal to 3, so it occupies offset 1 too.
	* docFrag.offsetToIndex( 2 ); // Returns 0.
	* docFrag.offsetToIndex( 3 ); // Returns 1.
	* docFrag.offsetToIndex( 4 ); // Returns 2. There are no nodes at offset 4, so last available index is returned.
	* ```
	*
	* @param offset Offset to look for.
	* @returns Index of a node that occupies given offset.
	*/ offsetToIndex(offset) {
        return this._children.offsetToIndex(offset);
    }
    /**
	* Converts `ModelDocumentFragment` instance to plain object and returns it.
	* Takes care of converting all of this document fragment's children.
	*
	* @returns `ModelDocumentFragment` instance converted to plain object.
	*/ toJSON() {
        const json = [];
        for (const node of this._children)json.push(node.toJSON());
        return json;
    }
    /**
	* Creates a `ModelDocumentFragment` instance from given plain object (i.e. parsed JSON string).
	* Converts `ModelDocumentFragment` children to proper nodes.
	*
	* @param json Plain object to be converted to `ModelDocumentFragment`.
	* @returns `ModelDocumentFragment` instance created using given plain object.
	*/ static fromJSON(json) {
        const children = [];
        for (const child of json)if (child.name) children.push($b9b9f2bdf9c6137f$export$ce4fb8eac15afe31.fromJSON(child));
        else children.push($b9b9f2bdf9c6137f$export$7d1212a712b16fb5.fromJSON(child));
        return new ModelDocumentFragment(children);
    }
    /**
	* {@link #_insertChild Inserts} one or more nodes at the end of this document fragment.
	*
	* @internal
	* @param items Items to be inserted.
	*/ _appendChild(items) {
        this._insertChild(this.childCount, items);
    }
    /**
	* Inserts one or more nodes at the given index and sets {@link module:engine/model/node~ModelNode#parent parent} of these nodes
	* to this document fragment.
	*
	* @internal
	* @param index Index at which nodes should be inserted.
	* @param items Items to be inserted.
	*/ _insertChild(index, items) {
        const nodes = $b9b9f2bdf9c6137f$var$normalize(items);
        for (const node of nodes){
            if (node.parent !== null) node._remove();
            node.parent = this;
        }
        this._children._insertNodes(index, nodes);
    }
    /**
	* Removes one or more nodes starting at the given index
	* and sets {@link module:engine/model/node~ModelNode#parent parent} of these nodes to `null`.
	*
	* @internal
	* @param index Index of the first node to remove.
	* @param howMany Number of nodes to remove.
	* @returns Array containing removed nodes.
	*/ _removeChildren(index, howMany = 1) {
        const nodes = this._children._removeNodes(index, howMany);
        for (const node of nodes)node.parent = null;
        return nodes;
    }
    /**
	* Removes children nodes provided as an array and sets
	* the {@link module:engine/model/node~ModelNode#parent parent} of these nodes to `null`.
	*
	* These nodes do not need to be direct siblings.
	*
	* This method is faster than removing nodes one by one, as it recalculates offsets only once.
	*
	* @internal
	* @param nodes Array of nodes.
	*/ _removeChildrenArray(nodes) {
        this._children._removeNodesArray(nodes);
        for (const node of nodes)node.parent = null;
    }
};
$b9b9f2bdf9c6137f$export$c30b4c7f930a26a2.prototype.is = function(type) {
    return type === "documentFragment" || type === "model:documentFragment";
};
/**
* Converts strings to Text and non-iterables to arrays.
*/ function $b9b9f2bdf9c6137f$var$normalize(nodes) {
    if (typeof nodes == "string") return [
        new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(nodes)
    ];
    if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(nodes)) nodes = [
        nodes
    ];
    return Array.from(nodes).map((node)=>{
        if (typeof node == "string") return new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(node);
        if (node instanceof $b9b9f2bdf9c6137f$export$d28a7ac36232ea43) return new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(node.data, node.getAttributes());
        return node;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/writer
*/ /**
* The model can only be modified by using the writer. It should be used whenever you want to create a node, modify
* child nodes, attributes or text, set the selection's position and its attributes.
*
* The instance of the writer is only available in the {@link module:engine/model/model~Model#change `change()`} or
* {@link module:engine/model/model~Model#enqueueChange `enqueueChange()`}.
*
* ```ts
* model.change( writer => {
* 	writer.insertText( 'foo', paragraph, 'end' );
* } );
* ```
*
* Note that the writer should never be stored and used outside of the `change()` and
* `enqueueChange()` blocks.
*
* Note that writer's methods do not check the {@link module:engine/model/schema~ModelSchema}. It is possible
* to create incorrect model structures by using the writer. Read more about in
* {@glink framework/deep-dive/schema#who-checks-the-schema "Who checks the schema?"}.
*
* @see module:engine/model/model~Model#change
* @see module:engine/model/model~Model#enqueueChange
*/ var $b9b9f2bdf9c6137f$export$35468caec0799533 = class {
    /**
	* Instance of the model on which this writer operates.
	*/ model;
    /**
	* The batch to which this writer will add changes.
	*/ batch;
    /**
	* Creates a writer instance.
	*
	* **Note:** It is not recommended to use it directly. Use {@link module:engine/model/model~Model#change `Model#change()`} or
	* {@link module:engine/model/model~Model#enqueueChange `Model#enqueueChange()`} instead.
	*
	* @internal
	*/ constructor(model, batch){
        this.model = model;
        this.batch = batch;
    }
    /**
	* Creates a new {@link module:engine/model/text~ModelText text node}.
	*
	* ```ts
	* writer.createText( 'foo' );
	* writer.createText( 'foo', { bold: true } );
	* ```
	*
	* @param data Text data.
	* @param attributes Text attributes.
	* @returns {module:engine/model/text~ModelText} Created text node.
	*/ createText(data, attributes) {
        return new $b9b9f2bdf9c6137f$export$7d1212a712b16fb5(data, attributes);
    }
    /**
	* Creates a new {@link module:engine/model/element~ModelElement element}.
	*
	* ```ts
	* writer.createElement( 'paragraph' );
	* writer.createElement( 'paragraph', { alignment: 'center' } );
	* ```
	*
	* @param name Name of the element.
	* @param attributes Elements attributes.
	* @returns Created element.
	*/ createElement(name, attributes) {
        return new $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31(name, attributes);
    }
    /**
	* Creates a new {@link module:engine/model/documentfragment~ModelDocumentFragment document fragment}.
	*
	* @returns Created document fragment.
	*/ createDocumentFragment() {
        return new $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2();
    }
    /**
	* Creates a copy of the element and returns it. Created element has the same name and attributes as the original element.
	* If clone is deep, the original element's children are also cloned. If not, then empty element is returned.
	*
	* @param element The element to clone.
	* @param deep If set to `true` clones element and all its children recursively. When set to `false`,
	* element will be cloned without any child.
	*/ cloneElement(element, deep = true) {
        return element._clone(deep);
    }
    /**
	* Inserts item on given position.
	*
	* ```ts
	* const paragraph = writer.createElement( 'paragraph' );
	* writer.insert( paragraph, position );
	* ```
	*
	* Instead of using position you can use parent and offset:
	*
	* ```ts
	* const text = writer.createText( 'foo' );
	* writer.insert( text, paragraph, 5 );
	* ```
	*
	* You can also use `end` instead of the offset to insert at the end:
	*
	* ```ts
	* const text = writer.createText( 'foo' );
	* writer.insert( text, paragraph, 'end' );
	* ```
	*
	* Or insert before or after another element:
	*
	* ```ts
	* const paragraph = writer.createElement( 'paragraph' );
	* writer.insert( paragraph, anotherParagraph, 'after' );
	* ```
	*
	* These parameters works the same way as {@link #createPositionAt `writer.createPositionAt()`}.
	*
	* Note that if the item already has parent it will be removed from the previous parent.
	*
	* Note that you cannot re-insert a node from a document to a different document or a document fragment. In this case,
	* `model-writer-insert-forbidden-move` is thrown.
	*
	* If you want to move {@link module:engine/model/range~ModelRange range} instead of an
	* {@link module:engine/model/item~ModelItem item} use {@link module:engine/model/writer~ModelWriter#move `Writer#move()`}.
	*
	* **Note:** For a paste-like content insertion mechanism see
	* {@link module:engine/model/model~Model#insertContent `model.insertContent()`}.
	*
	* @param item Item or document fragment to insert.
	* @param offset Offset or one of the flags. Used only when second parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ insert(item, itemOrPosition, offset = 0) {
        this._assertWriterUsedCorrectly();
        if (item instanceof $b9b9f2bdf9c6137f$export$7d1212a712b16fb5 && item.data == "") return;
        const position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(itemOrPosition, offset);
        if (item.parent) {
            if ($b9b9f2bdf9c6137f$var$isSameTree(item.root, position.root)) {
                this.move($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item), position);
                return;
            } else if (item.root.document) /**
			* Cannot move a node from a document to a different tree.
			* It is forbidden to move a node that was already in a document outside of it.
			*
			* @error model-writer-insert-forbidden-move
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("model-writer-insert-forbidden-move", this);
            else this.remove(item);
        }
        const version = position.root.document ? position.root.document.version : null;
        const children = item instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 ? item._removeChildren(0, item.childCount) : item;
        const insert = new $b9b9f2bdf9c6137f$export$2b3d431b09bf039a(position, children, version);
        if (item instanceof $b9b9f2bdf9c6137f$export$7d1212a712b16fb5) insert.shouldReceiveAttributes = true;
        this.batch.addOperation(insert);
        this.model.applyOperation(insert);
        if (item instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2) for (const [markerName, markerRange] of item.markers){
            const rangeRootPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(markerRange.root, 0);
            const options = {
                range: new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(markerRange.start._getCombined(rangeRootPosition, position), markerRange.end._getCombined(rangeRootPosition, position)),
                usingOperation: true,
                affectsData: true
            };
            if (this.model.markers.has(markerName)) this.updateMarker(markerName, options);
            else this.addMarker(markerName, options);
        }
    }
    insertText(text, attributes, itemOrPosition, offset) {
        if (attributes instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 || attributes instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 || attributes instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) this.insert(this.createText(text), attributes, itemOrPosition);
        else this.insert(this.createText(text, attributes), itemOrPosition, offset);
    }
    insertElement(name, attributes, itemOrPositionOrOffset, offset) {
        if (attributes instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 || attributes instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 || attributes instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) this.insert(this.createElement(name), attributes, itemOrPositionOrOffset);
        else this.insert(this.createElement(name, attributes), itemOrPositionOrOffset, offset);
    }
    /**
	* Inserts item at the end of the given parent.
	*
	* ```ts
	* const paragraph = writer.createElement( 'paragraph' );
	* writer.append( paragraph, root );
	* ```
	*
	* Note that if the item already has parent it will be removed from the previous parent.
	*
	* If you want to move {@link module:engine/model/range~ModelRange range} instead of an
	* {@link module:engine/model/item~ModelItem item} use {@link module:engine/model/writer~ModelWriter#move `Writer#move()`}.
	*
	* @param item Item or document fragment to insert.
	*/ append(item, parent) {
        this.insert(item, parent, "end");
    }
    appendText(text, attributes, parent) {
        if (attributes instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 || attributes instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31) this.insert(this.createText(text), attributes, "end");
        else this.insert(this.createText(text, attributes), parent, "end");
    }
    appendElement(name, attributes, parent) {
        if (attributes instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2 || attributes instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31) this.insert(this.createElement(name), attributes, "end");
        else this.insert(this.createElement(name, attributes), parent, "end");
    }
    /**
	* Sets value of the attribute with given key on a {@link module:engine/model/item~ModelItem model item}
	* or on a {@link module:engine/model/range~ModelRange range}.
	*
	* @param key Attribute key.
	* @param value Attribute new value.
	* @param itemOrRange Model item or range on which the attribute will be set.
	*/ setAttribute(key, value, itemOrRange) {
        this._assertWriterUsedCorrectly();
        if (itemOrRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba) {
            const ranges = itemOrRange.getMinimalFlatRanges();
            for (const range of ranges)$b9b9f2bdf9c6137f$var$setAttributeOnRange(this, key, value, range);
        } else $b9b9f2bdf9c6137f$var$setAttributeOnItem(this, key, value, itemOrRange);
    }
    /**
	* Sets values of attributes on a {@link module:engine/model/item~ModelItem model item}
	* or on a {@link module:engine/model/range~ModelRange range}.
	*
	* ```ts
	* writer.setAttributes( {
	* 	bold: true,
	* 	italic: true
	* }, range );
	* ```
	*
	* @param attributes Attributes keys and values.
	* @param itemOrRange Model item or range on which the attributes will be set.
	*/ setAttributes(attributes, itemOrRange) {
        for (const [key, val] of (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(attributes))this.setAttribute(key, val, itemOrRange);
    }
    /**
	* Removes an attribute with given key from a {@link module:engine/model/item~ModelItem model item}
	* or from a {@link module:engine/model/range~ModelRange range}.
	*
	* @param key Attribute key.
	* @param itemOrRange Model item or range from which the attribute will be removed.
	*/ removeAttribute(key, itemOrRange) {
        this._assertWriterUsedCorrectly();
        if (itemOrRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba) {
            const ranges = itemOrRange.getMinimalFlatRanges();
            for (const range of ranges)$b9b9f2bdf9c6137f$var$setAttributeOnRange(this, key, null, range);
        } else $b9b9f2bdf9c6137f$var$setAttributeOnItem(this, key, null, itemOrRange);
    }
    /**
	* Removes all attributes from all elements in the range or from the given item.
	*
	* @param itemOrRange Model item or range from which all attributes will be removed.
	*/ clearAttributes(itemOrRange) {
        this._assertWriterUsedCorrectly();
        const removeAttributesFromItem = (item)=>{
            for (const attribute of item.getAttributeKeys())this.removeAttribute(attribute, item);
        };
        if (!(itemOrRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba)) removeAttributesFromItem(itemOrRange);
        else for (const item of itemOrRange.getItems())removeAttributesFromItem(item);
    }
    /**
	* Moves all items in the source range to the target position.
	*
	* ```ts
	* writer.move( sourceRange, targetPosition );
	* ```
	*
	* Instead of the target position you can use parent and offset or define that range should be moved to the end
	* or before or after chosen item:
	*
	* ```ts
	* // Moves all items in the range to the paragraph at offset 5:
	* writer.move( sourceRange, paragraph, 5 );
	* // Moves all items in the range to the end of a blockquote:
	* writer.move( sourceRange, blockquote, 'end' );
	* // Moves all items in the range to a position after an image:
	* writer.move( sourceRange, image, 'after' );
	* ```
	*
	* These parameters work the same way as {@link #createPositionAt `writer.createPositionAt()`}.
	*
	* Note that items can be moved only within the same tree. It means that you can move items within the same root
	* (element or document fragment) or between {@link module:engine/model/document~ModelDocument#roots documents roots},
	* but you cannot move items from document fragment to the document or from one detached element to another. Use
	* {@link module:engine/model/writer~ModelWriter#insert} in such cases.
	*
	* @param range Source range.
	* @param offset Offset or one of the flags. Used only when second parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ move(range, itemOrPosition, offset) {
        this._assertWriterUsedCorrectly();
        if (!(range instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba)) /**
		* Invalid range to move.
		*
		* @error writer-move-invalid-range
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-move-invalid-range", this);
        if (!range.isFlat) /**
		* Range to move is not flat.
		*
		* @error writer-move-range-not-flat
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-move-range-not-flat", this);
        const position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(itemOrPosition, offset);
        if (position.isEqual(range.start)) return;
        this._addOperationForAffectedMarkers("move", range);
        if (!$b9b9f2bdf9c6137f$var$isSameTree(range.root, position.root)) /**
		* Range is going to be moved within not the same document. Please use
		* {@link module:engine/model/writer~ModelWriter#insert insert} instead.
		*
		* @error writer-move-different-document
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-move-different-document", this);
        const version = range.root.document ? range.root.document.version : null;
        const operation = new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(range.start, range.end.offset - range.start.offset, position, version);
        this.batch.addOperation(operation);
        this.model.applyOperation(operation);
    }
    /**
	* Removes given model {@link module:engine/model/item~ModelItem item} or {@link module:engine/model/range~ModelRange range}.
	*
	* @param itemOrRange Model item or range to remove.
	*/ remove(itemOrRange) {
        this._assertWriterUsedCorrectly();
        const ranges = (itemOrRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba ? itemOrRange : $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(itemOrRange)).getMinimalFlatRanges().reverse();
        for (const flat of ranges){
            this._addOperationForAffectedMarkers("move", flat);
            $b9b9f2bdf9c6137f$var$applyRemoveOperation(flat.start, flat.end.offset - flat.start.offset, this.batch, this.model);
        }
    }
    /**
	* Merges two siblings at the given position.
	*
	* Node before and after the position have to be an element. Otherwise `writer-merge-no-element-before` or
	* `writer-merge-no-element-after` error will be thrown.
	*
	* @param position Position between merged elements.
	*/ merge(position) {
        this._assertWriterUsedCorrectly();
        const nodeBefore = position.nodeBefore;
        const nodeAfter = position.nodeAfter;
        this._addOperationForAffectedMarkers("merge", position);
        if (!(nodeBefore instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
		* Node before merge position must be an element.
		*
		* @error writer-merge-no-element-before
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-merge-no-element-before", this);
        if (!(nodeAfter instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
		* Node after merge position must be an element.
		*
		* @error writer-merge-no-element-after
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-merge-no-element-after", this);
        if (!position.root.document) this._mergeDetached(position);
        else this._merge(position);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createPositionFromPath `Model#createPositionFromPath()`}.
	*
	* @param root Root of the position.
	* @param path Position path. See {@link module:engine/model/position~ModelPosition#path}.
	* @param stickiness Position stickiness. See {@link module:engine/model/position~ModelPositionStickiness}.
	*/ createPositionFromPath(root, path, stickiness) {
        return this.model.createPositionFromPath(root, path, stickiness);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createPositionAt `Model#createPositionAt()`}.
	*
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ createPositionAt(itemOrPosition, offset) {
        return this.model.createPositionAt(itemOrPosition, offset);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createPositionAfter `Model#createPositionAfter()`}.
	*
	* @param item Item after which the position should be placed.
	*/ createPositionAfter(item) {
        return this.model.createPositionAfter(item);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createPositionBefore `Model#createPositionBefore()`}.
	*
	* @param item Item after which the position should be placed.
	*/ createPositionBefore(item) {
        return this.model.createPositionBefore(item);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createRange `Model#createRange()`}.
	*
	* @param start Start position.
	* @param end End position. If not set, range will be collapsed at `start` position.
	*/ createRange(start, end) {
        return this.model.createRange(start, end);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createRangeIn `Model#createRangeIn()`}.
	*
	* @param element Element which is a parent for the range.
	*/ createRangeIn(element) {
        return this.model.createRangeIn(element);
    }
    /**
	* Shortcut for {@link module:engine/model/model~Model#createRangeOn `Model#createRangeOn()`}.
	*
	* @param element Element which is a parent for the range.
	*/ createRangeOn(element) {
        return this.model.createRangeOn(element);
    }
    createSelection(...args) {
        return this.model.createSelection(...args);
    }
    /**
	* Performs merge action in a detached tree.
	*
	* @param position Position between merged elements.
	*/ _mergeDetached(position) {
        const nodeBefore = position.nodeBefore;
        const nodeAfter = position.nodeAfter;
        this.move($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(nodeAfter), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(nodeBefore, "end"));
        this.remove(nodeAfter);
    }
    /**
	* Performs merge action in a non-detached tree.
	*
	* @param position Position between merged elements.
	*/ _merge(position) {
        const targetPosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(position.nodeBefore, "end");
        const sourcePosition = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(position.nodeAfter, 0);
        const graveyard = position.root.document.graveyard;
        const graveyardPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(graveyard, [
            0
        ]);
        const version = position.root.document.version;
        const merge = new $b9b9f2bdf9c6137f$export$6df6642276507f83(sourcePosition, position.nodeAfter.maxOffset, targetPosition, graveyardPosition, version);
        this.batch.addOperation(merge);
        this.model.applyOperation(merge);
    }
    /**
	* Renames the given element.
	*
	* @param element The element to rename.
	* @param newName New element name.
	*/ rename(element, newName) {
        this._assertWriterUsedCorrectly();
        if (!(element instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) /**
		* Trying to rename an object which is not an instance of Element.
		*
		* @error writer-rename-not-element-instance
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-rename-not-element-instance", this);
        const version = element.root.document ? element.root.document.version : null;
        const renameOperation = new $b9b9f2bdf9c6137f$export$8dc329ebf40a8040($b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(element), element.name, newName, version);
        this.batch.addOperation(renameOperation);
        this.model.applyOperation(renameOperation);
    }
    /**
	* Splits elements starting from the given position and going to the top of the model tree as long as given
	* `limitElement` is reached. When `limitElement` is not defined then only the parent of the given position will be split.
	*
	* The element needs to have a parent. It cannot be a root element nor a document fragment.
	* The `writer-split-element-no-parent` error will be thrown if you try to split an element with no parent.
	*
	* @param position Position of split.
	* @param limitElement Stop splitting when this element will be reached.
	* @returns Split result with properties:
	* * `position` - Position between split elements.
	* * `range` - Range that stars from the end of the first split element and ends at the beginning of the first copy element.
	*/ split(position, limitElement) {
        this._assertWriterUsedCorrectly();
        let splitElement = position.parent;
        if (!splitElement.parent) /**
		* Element with no parent cannot be split.
		*
		* @error writer-split-element-no-parent
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-split-element-no-parent", this);
        if (!limitElement) limitElement = splitElement.parent;
        if (!position.parent.getAncestors({
            includeSelf: true
        }).includes(limitElement)) /**
		* Limit element is not a position ancestor.
		*
		* @error writer-split-invalid-limit-element
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-split-invalid-limit-element", this);
        let firstSplitElement;
        let firstCopyElement;
        do {
            const version = splitElement.root.document ? splitElement.root.document.version : null;
            const howMany = splitElement.maxOffset - position.offset;
            const insertionPosition = $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd.getInsertionPosition(position);
            const split = new $b9b9f2bdf9c6137f$export$e67ffaab2eea63dd(position, howMany, insertionPosition, null, version);
            this.batch.addOperation(split);
            this.model.applyOperation(split);
            if (!firstSplitElement && !firstCopyElement) {
                firstSplitElement = splitElement;
                firstCopyElement = position.parent.nextSibling;
            }
            position = this.createPositionAfter(position.parent);
            splitElement = position.parent;
        }while (splitElement !== limitElement);
        return {
            position: position,
            range: new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(firstSplitElement, "end"), $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(firstCopyElement, 0))
        };
    }
    /**
	* Wraps the given range with the given element or with a new element (if a string was passed).
	*
	* **Note:** range to wrap should be a "flat range" (see {@link module:engine/model/range~ModelRange#isFlat `Range#isFlat`}).
	* If not, an error will be thrown.
	*
	* @param range Range to wrap.
	* @param elementOrString Element or name of element to wrap the range with.
	*/ wrap(range, elementOrString) {
        this._assertWriterUsedCorrectly();
        if (!range.isFlat) /**
		* Range to wrap is not flat.
		*
		* @error writer-wrap-range-not-flat
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-wrap-range-not-flat", this);
        const element = elementOrString instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 ? elementOrString : new $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31(elementOrString);
        if (element.childCount > 0) /**
		* Element to wrap with is not empty.
		*
		* @error writer-wrap-element-not-empty
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-wrap-element-not-empty", this);
        if (element.parent !== null) /**
		* Element to wrap with is already attached to a tree model.
		*
		* @error writer-wrap-element-attached
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-wrap-element-attached", this);
        this.insert(element, range.start);
        const shiftedRange = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(range.start.getShiftedBy(1), range.end.getShiftedBy(1));
        this.move(shiftedRange, $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(element, 0));
    }
    /**
	* Unwraps children of the given element – all its children are moved before it and then the element is removed.
	* Throws error if you try to unwrap an element which does not have a parent.
	*
	* @param element Element to unwrap.
	*/ unwrap(element) {
        this._assertWriterUsedCorrectly();
        if (element.parent === null) /**
		* Trying to unwrap an element which has no parent.
		*
		* @error writer-unwrap-element-no-parent
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-unwrap-element-no-parent", this);
        this.move($b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(element), this.createPositionAfter(element));
        this.remove(element);
    }
    /**
	* Adds a {@link module:engine/model/markercollection~Marker marker}. Marker is a named range, which tracks
	* changes in the document and updates its range automatically, when model tree changes.
	*
	* As the first parameter you can set marker name.
	*
	* The required `options.usingOperation` parameter lets you decide if the marker should be managed by operations or not. See
	* {@link module:engine/model/markercollection~Marker marker class description} to learn about the difference between
	* markers managed by operations and not-managed by operations.
	*
	* The `options.affectsData` parameter, which defaults to `false`, allows you to define if a marker affects the data. It should be
	* `true` when the marker change changes the data returned by the
	* {@link module:core/editor/editor~Editor#getData `editor.getData()`} method.
	* When set to `true` it fires the {@link module:engine/model/document~ModelDocument#event:change:data `change:data`} event.
	* When set to `false` it fires the {@link module:engine/model/document~ModelDocument#event:change `change`} event.
	*
	* Create marker directly base on marker's name:
	*
	* ```ts
	* addMarker( markerName, { range, usingOperation: false } );
	* ```
	*
	* Create marker using operation:
	*
	* ```ts
	* addMarker( markerName, { range, usingOperation: true } );
	* ```
	*
	* Create marker that affects the editor data:
	*
	* ```ts
	* addMarker( markerName, { range, usingOperation: false, affectsData: true } );
	* ```
	*
	* Note: For efficiency reasons, it's best to create and keep as little markers as possible.
	*
	* @see module:engine/model/markercollection~Marker
	* @param name Name of a marker to create - must be unique.
	* @param options.usingOperation Flag indicating that the marker should be added by MarkerOperation.
	* See {@link module:engine/model/markercollection~Marker#managedUsingOperations}.
	* @param options.range Marker range.
	* @param options.affectsData Flag indicating that the marker changes the editor data.
	* @returns Marker that was set.
	*/ addMarker(name, options) {
        this._assertWriterUsedCorrectly();
        if (!options || typeof options.usingOperation != "boolean") /**
		* The `options.usingOperation` parameter is required when adding a new marker.
		*
		* @error writer-addmarker-no-usingoperation
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-addmarker-no-usingoperation", this);
        const usingOperation = options.usingOperation;
        const range = options.range;
        const affectsData = options.affectsData === void 0 ? false : options.affectsData;
        if (this.model.markers.has(name)) /**
		* Marker with provided name already exists.
		*
		* @error writer-addmarker-marker-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-addmarker-marker-exists", this);
        if (!range) /**
		* Range parameter is required when adding a new marker.
		*
		* @error writer-addmarker-no-range
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-addmarker-no-range", this);
        if (!usingOperation) return this.model.markers._set(name, range, usingOperation, affectsData);
        $b9b9f2bdf9c6137f$var$applyMarkerOperation(this, name, null, range, affectsData);
        return this.model.markers.get(name);
    }
    /**
	* Adds, updates or refreshes a {@link module:engine/model/markercollection~Marker marker}. Marker is a named range, which tracks
	* changes in the document and updates its range automatically, when model tree changes. Still, it is possible to change the
	* marker's range directly using this method.
	*
	* As the first parameter you can set marker name or instance. If none of them is provided, new marker, with a unique
	* name is created and returned.
	*
	* **Note**: If you want to change the {@link module:engine/view/element~ViewElement view element}
	* of the marker while its data in the model
	* remains the same, use the dedicated {@link module:engine/controller/editingcontroller~EditingController#reconvertMarker} method.
	*
	* The `options.usingOperation` parameter lets you change if the marker should be managed by operations or not. See
	* {@link module:engine/model/markercollection~Marker marker class description} to learn about the difference between
	* markers managed by operations and not-managed by operations. It is possible to change this option for an existing marker.
	*
	* The `options.affectsData` parameter, which defaults to `false`, allows you to define if a marker affects the data. It should be
	* `true` when the marker change changes the data returned by
	* the {@link module:core/editor/editor~Editor#getData `editor.getData()`} method.
	* When set to `true` it fires the {@link module:engine/model/document~ModelDocument#event:change:data `change:data`} event.
	* When set to `false` it fires the {@link module:engine/model/document~ModelDocument#event:change `change`} event.
	*
	* Update marker directly base on marker's name:
	*
	* ```ts
	* updateMarker( markerName, { range } );
	* ```
	*
	* Update marker using operation:
	*
	* ```ts
	* updateMarker( marker, { range, usingOperation: true } );
	* updateMarker( markerName, { range, usingOperation: true } );
	* ```
	*
	* Change marker's option (start using operations to manage it):
	*
	* ```ts
	* updateMarker( marker, { usingOperation: true } );
	* ```
	*
	* Change marker's option (inform the engine, that the marker does not affect the data anymore):
	*
	* ```ts
	* updateMarker( markerName, { affectsData: false } );
	* ```
	*
	* @see module:engine/model/markercollection~Marker
	* @param markerOrName Name of a marker to update, or a marker instance.
	* @param options If options object is not defined then marker will be refreshed by triggering
	* downcast conversion for this marker with the same data.
	* @param options.range Marker range to update.
	* @param options.usingOperation Flag indicated whether the marker should be added by MarkerOperation.
	* See {@link module:engine/model/markercollection~Marker#managedUsingOperations}.
	* @param options.affectsData Flag indicating that the marker changes the editor data.
	*/ updateMarker(markerOrName, options) {
        this._assertWriterUsedCorrectly();
        const markerName = typeof markerOrName == "string" ? markerOrName : markerOrName.name;
        const currentMarker = this.model.markers.get(markerName);
        if (!currentMarker) /**
		* Marker with provided name does not exist and will not be updated.
		*
		* @error writer-updatemarker-marker-not-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-updatemarker-marker-not-exists", this);
        if (!options) {
            /**
			* The usage of `writer.updateMarker()` only to reconvert (refresh) a
			* {@link module:engine/model/markercollection~Marker model marker} was deprecated and may not work in the future.
			* Please update your code to use
			* {@link module:engine/controller/editingcontroller~EditingController#reconvertMarker `editor.editing.reconvertMarker()`}
			* instead.
			*
			* @error writer-updatemarker-reconvert-using-editingcontroller
			* @param markerName The name of the updated marker.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("writer-updatemarker-reconvert-using-editingcontroller", {
                markerName: markerName
            });
            this.model.markers._refresh(currentMarker);
            return;
        }
        const hasUsingOperationDefined = typeof options.usingOperation == "boolean";
        const affectsDataDefined = typeof options.affectsData == "boolean";
        const affectsData = affectsDataDefined ? options.affectsData : currentMarker.affectsData;
        if (!hasUsingOperationDefined && !options.range && !affectsDataDefined) /**
		* One of the options is required - provide range, usingOperations or affectsData.
		*
		* @error writer-updatemarker-wrong-options
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-updatemarker-wrong-options", this);
        const currentRange = currentMarker.getRange();
        const updatedRange = options.range ? options.range : currentRange;
        if (hasUsingOperationDefined && options.usingOperation !== currentMarker.managedUsingOperations) {
            if (options.usingOperation) $b9b9f2bdf9c6137f$var$applyMarkerOperation(this, markerName, null, updatedRange, affectsData);
            else {
                $b9b9f2bdf9c6137f$var$applyMarkerOperation(this, markerName, currentRange, null, affectsData);
                this.model.markers._set(markerName, updatedRange, void 0, affectsData);
            }
            return;
        }
        if (currentMarker.managedUsingOperations) $b9b9f2bdf9c6137f$var$applyMarkerOperation(this, markerName, currentRange, updatedRange, affectsData);
        else this.model.markers._set(markerName, updatedRange, void 0, affectsData);
    }
    /**
	* Removes given {@link module:engine/model/markercollection~Marker marker} or marker with given name.
	* The marker is removed accordingly to how it has been created, so if the marker was created using operation,
	* it will be destroyed using operation.
	*
	* @param markerOrName Marker or marker name to remove.
	*/ removeMarker(markerOrName) {
        this._assertWriterUsedCorrectly();
        const name = typeof markerOrName == "string" ? markerOrName : markerOrName.name;
        if (!this.model.markers.has(name)) /**
		* Trying to remove marker which does not exist.
		*
		* @error writer-removemarker-no-marker
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-removemarker-no-marker", this);
        const marker = this.model.markers.get(name);
        if (!marker.managedUsingOperations) {
            this.model.markers._remove(name);
            return;
        }
        const oldRange = marker.getRange();
        $b9b9f2bdf9c6137f$var$applyMarkerOperation(this, name, oldRange, null, marker.affectsData);
    }
    /**
	* Adds a new root to the document (or re-attaches a {@link #detachRoot detached root}).
	*
	* Throws an error, if trying to add a root that is already added and attached.
	*
	* **Note:** The default `elementName` value is `'$root'`. When the editor uses a custom root
	* {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the configured model element
	* name explicitly so the added root matches the schema the features expect.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*
	* @param rootName Name of the added root.
	* @param elementName The element name. Defaults to `'$root'` which also has some basic schema defined
	* (e.g. `$block` elements are allowed inside the `$root`). Make sure to define a proper schema if you use a different name.
	* @returns The added root element.
	*/ addRoot(rootName, elementName = "$root") {
        this._assertWriterUsedCorrectly();
        const root = this.model.document.getRoot(rootName);
        if (root && root.isAttached()) /**
		* Root with provided name already exists and is attached.
		*
		* @error writer-addroot-root-exists
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-addroot-root-exists", this);
        const document1 = this.model.document;
        const operation = new $b9b9f2bdf9c6137f$export$58241c4268d122b7(rootName, elementName, true, document1, document1.version);
        this.batch.addOperation(operation);
        this.model.applyOperation(operation);
        return this.model.document.getRoot(rootName);
    }
    /**
	* Detaches the root from the document.
	*
	* All content and markers are removed from the root upon detaching. New content and new markers cannot be added to the root, as long
	* as it is detached.
	*
	* A root cannot be fully removed from the document, it can be only detached. A root is permanently removed only after you
	* re-initialize the editor and do not specify the root in the initial data.
	*
	* A detached root can be re-attached using {@link #addRoot}.
	*
	* Throws an error if the root does not exist or the root is already detached.
	*
	* @param rootOrName Name of the detached root.
	*/ detachRoot(rootOrName) {
        this._assertWriterUsedCorrectly();
        const root = typeof rootOrName == "string" ? this.model.document.getRoot(rootOrName) : rootOrName;
        if (!root || !root.isAttached()) /**
		* Root with provided name does not exist or is already detached.
		*
		* @error writer-detachroot-no-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-detachroot-no-root", this);
        for (const marker of this.model.markers)if (marker.getRange().root === root) this.removeMarker(marker);
        for (const key of root.getAttributeKeys())this.removeAttribute(key, root);
        this.remove(this.createRangeIn(root));
        const document1 = this.model.document;
        const operation = new $b9b9f2bdf9c6137f$export$58241c4268d122b7(root.rootName, root.name, false, document1, document1.version);
        this.batch.addOperation(operation);
        this.model.applyOperation(operation);
    }
    setSelection(...args) {
        this._assertWriterUsedCorrectly();
        this.model.document.selection._setTo(...args);
    }
    /**
	* Moves {@link module:engine/model/documentselection~ModelDocumentSelection#focus} to the specified location.
	*
	* The location can be specified in the same form as
	* {@link #createPositionAt `writer.createPositionAt()`} parameters.
	*
	* @param itemOrPosition
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ setSelectionFocus(itemOrPosition, offset) {
        this._assertWriterUsedCorrectly();
        this.model.document.selection._setFocus(itemOrPosition, offset);
    }
    setSelectionAttribute(keyOrObjectOrIterable, value) {
        this._assertWriterUsedCorrectly();
        if (typeof keyOrObjectOrIterable === "string") this._setSelectionAttribute(keyOrObjectOrIterable, value);
        else for (const [key, value] of (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(keyOrObjectOrIterable))this._setSelectionAttribute(key, value);
    }
    /**
	* Removes attribute(s) with given key(s) from the selection.
	*
	* Remove one attribute:
	*
	* ```ts
	* writer.removeSelectionAttribute( 'italic' );
	* ```
	*
	* Remove multiple attributes:
	*
	* ```ts
	* writer.removeSelectionAttribute( [ 'italic', 'bold' ] );
	* ```
	*
	* @param keyOrIterableOfKeys Key of the attribute to remove or an iterable of attribute keys to remove.
	*/ removeSelectionAttribute(keyOrIterableOfKeys) {
        this._assertWriterUsedCorrectly();
        if (typeof keyOrIterableOfKeys === "string") this._removeSelectionAttribute(keyOrIterableOfKeys);
        else for (const key of keyOrIterableOfKeys)this._removeSelectionAttribute(key);
    }
    /**
	* Temporarily changes the {@link module:engine/model/documentselection~ModelDocumentSelection#isGravityOverridden gravity}
	* of the selection from left to right.
	*
	* The gravity defines from which direction the selection inherits its attributes. If it's the default left gravity,
	* then the selection (after being moved by the user) inherits attributes from its left-hand side.
	* This method allows to temporarily override this behavior by forcing the gravity to the right.
	*
	* For the following model fragment:
	*
	* ```xml
	* <$text bold="true" linkHref="url">bar[]</$text><$text bold="true">biz</$text>
	* ```
	*
	* * Default gravity: selection will have the `bold` and `linkHref` attributes.
	* * Overridden gravity: selection will have `bold` attribute.
	*
	* **Note**: It returns an unique identifier which is required to restore the gravity. It guarantees the symmetry
	* of the process.
	*
	* @returns The unique id which allows restoring the gravity.
	*/ overrideSelectionGravity() {
        return this.model.document.selection._overrideGravity();
    }
    /**
	* Restores {@link ~ModelWriter#overrideSelectionGravity} gravity to default.
	*
	* Restoring the gravity is only possible using the unique identifier returned by
	* {@link ~ModelWriter#overrideSelectionGravity}. Note that the gravity remains overridden as long as won't be restored
	* the same number of times it was overridden.
	*
	* @param uid The unique id returned by {@link ~ModelWriter#overrideSelectionGravity}.
	*/ restoreSelectionGravity(uid) {
        this.model.document.selection._restoreGravity(uid);
    }
    /**
	* @param key Key of the attribute to remove.
	* @param value Attribute value.
	*/ _setSelectionAttribute(key, value) {
        const selection = this.model.document.selection;
        if (selection.isCollapsed && selection.anchor.parent.isEmpty) {
            const storeKey = $b9b9f2bdf9c6137f$export$7ad0b188284367aa._getStoreAttributeKey(key);
            this.setAttribute(storeKey, value, selection.anchor.parent);
        }
        selection._setAttribute(key, value);
    }
    /**
	* @param key Key of the attribute to remove.
	*/ _removeSelectionAttribute(key) {
        const selection = this.model.document.selection;
        if (selection.isCollapsed && selection.anchor.parent.isEmpty) {
            const storeKey = $b9b9f2bdf9c6137f$export$7ad0b188284367aa._getStoreAttributeKey(key);
            this.removeAttribute(storeKey, selection.anchor.parent);
        }
        selection._removeAttribute(key);
    }
    /**
	* Throws `writer-detached-writer-tries-to-modify-model` error when the writer is used outside of the `change()` block.
	*/ _assertWriterUsedCorrectly() {
        /**
		* Trying to use a writer outside a {@link module:engine/model/model~Model#change `change()`} or
		* {@link module:engine/model/model~Model#enqueueChange `enqueueChange()`} blocks.
		*
		* The writer can only be used inside these blocks which ensures that the model
		* can only be changed during such "sessions".
		*
		* @error writer-incorrect-use
		*/ if (this.model._currentWriter !== this) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("writer-incorrect-use", this);
    }
    /**
	* For given action `type` and `positionOrRange` where the action happens, this function finds all affected markers
	* and applies a marker operation with the new marker range equal to the current range. Thanks to this, the marker range
	* can be later correctly processed during undo.
	*
	* Exposed so that code applying operations directly to the model can reproduce the same marker bookkeeping.
	*
	* @internal
	* @param type Writer action type.
	* @param positionOrRange Position or range where the writer action happens.
	*/ _addOperationForAffectedMarkers(type, positionOrRange) {
        for (const marker of this.model.markers){
            if (!marker.managedUsingOperations) continue;
            const markerRange = marker.getRange();
            let isAffected;
            if (type === "move") {
                const range = positionOrRange;
                isAffected = range.containsPosition(markerRange.start) || range.start.isEqual(markerRange.start) || range.containsPosition(markerRange.end) || range.end.isEqual(markerRange.end);
            } else {
                const position = positionOrRange;
                const elementBefore = position.nodeBefore;
                const elementAfter = position.nodeAfter;
                const affectedInLeftElement = markerRange.start.parent == elementBefore && markerRange.start.isAtEnd;
                const affectedInRightElement = markerRange.end.parent == elementAfter && markerRange.end.offset == 0;
                const affectedAfterLeftElement = markerRange.end.nodeAfter == elementAfter;
                const affectedBeforeRightElement = markerRange.start.nodeAfter == elementAfter;
                isAffected = affectedInLeftElement || affectedInRightElement || affectedAfterLeftElement || affectedBeforeRightElement;
            }
            if (isAffected) this.updateMarker(marker.name, {
                range: markerRange
            });
        }
    }
};
/**
* Sets given attribute to each node in given range. When attribute value is null then attribute will be removed.
*
* Because attribute operation needs to have the same attribute value on the whole range, this function splits
* the range into smaller parts.
*
* Given `range` must be flat.
*/ function $b9b9f2bdf9c6137f$var$setAttributeOnRange(writer, key, value, range) {
    const model = writer.model;
    const doc = model.document;
    let lastSplitPosition = range.start;
    let position;
    let valueBefore;
    let valueAfter;
    for (const val of range.getWalker({
        shallow: true
    })){
        valueAfter = val.item.getAttribute(key);
        if (position && valueBefore != valueAfter) {
            if (valueBefore != value) addOperation();
            lastSplitPosition = position;
        }
        position = val.nextPosition;
        valueBefore = valueAfter;
    }
    if (position instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192 && position != lastSplitPosition && valueBefore != value) addOperation();
    function addOperation() {
        const range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(lastSplitPosition, position);
        const version = range.root.document ? doc.version : null;
        const operation = new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, key, valueBefore, value, version);
        writer.batch.addOperation(operation);
        model.applyOperation(operation);
    }
}
/**
* Sets given attribute to the given node. When attribute value is null then attribute will be removed.
*/ function $b9b9f2bdf9c6137f$var$setAttributeOnItem(writer, key, value, item) {
    const model = writer.model;
    const doc = model.document;
    const previousValue = item.getAttribute(key);
    let range, operation;
    if (previousValue != value) {
        if (item.root === item) {
            const version = item.document ? doc.version : null;
            operation = new $b9b9f2bdf9c6137f$export$f8e3cfc239cfc2ef(item, key, previousValue, value, version);
        } else {
            range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba($b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(item), writer.createPositionAfter(item));
            const version = range.root.document ? doc.version : null;
            operation = new $b9b9f2bdf9c6137f$export$26d99b4b48a0ccc2(range, key, previousValue, value, version);
        }
        writer.batch.addOperation(operation);
        model.applyOperation(operation);
    }
}
/**
* Creates and applies marker operation to {@link module:engine/model/operation/operation~Operation operation}.
*/ function $b9b9f2bdf9c6137f$var$applyMarkerOperation(writer, name, oldRange, newRange, affectsData) {
    const model = writer.model;
    const doc = model.document;
    const operation = new $b9b9f2bdf9c6137f$export$80e018754b96197a(name, oldRange, newRange, model.markers, !!affectsData, doc.version);
    writer.batch.addOperation(operation);
    model.applyOperation(operation);
}
/**
* Creates `MoveOperation` or `DetachOperation` that removes `howMany` nodes starting from `position`.
* The operation will be applied on given model instance and added to given operation instance.
*
* @param position Position from which nodes are removed.
* @param howMany Number of nodes to remove.
* @param batch Batch to which the operation will be added.
* @param model Model instance on which operation will be applied.
*/ function $b9b9f2bdf9c6137f$var$applyRemoveOperation(position, howMany, batch, model) {
    let operation;
    if (position.root.document) {
        const doc = model.document;
        const graveyardPosition = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(doc.graveyard, [
            0
        ]);
        operation = new $b9b9f2bdf9c6137f$export$4a4db945c69349dc(position, howMany, graveyardPosition, doc.version);
    } else operation = new $b9b9f2bdf9c6137f$export$5cd016ed8b42bc6(position, howMany);
    batch.addOperation(operation);
    model.applyOperation(operation);
}
/**
* Returns `true` if both root elements are the same element or both are documents root elements.
*
* Elements in the same tree can be moved (for instance you can move element form one documents root to another, or
* within the same document fragment), but when element supposed to be moved from document fragment to the document, or
* to another document it should be removed and inserted to avoid problems with OT. This is because features like undo or
* collaboration may track changes on the document but ignore changes on detached fragments and should not get
* unexpected `move` operation.
*/ function $b9b9f2bdf9c6137f$var$isSameTree(rootA, rootB) {
    if (rootA === rootB) return true;
    if (rootA instanceof $b9b9f2bdf9c6137f$export$4294c3610dee24e8 && rootB instanceof $b9b9f2bdf9c6137f$export$4294c3610dee24e8) return true;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/utils/selection-post-fixer
*/ /**
* Injects selection post-fixer to the model.
*
* The role of the selection post-fixer is to ensure that the selection is in a correct place
* after a {@link module:engine/model/model~Model#change `change()`} block was executed.
*
* The correct position means that:
*
* * All collapsed selection ranges are in a place where the {@link module:engine/model/schema~ModelSchema}
* allows a `$text`.
* * None of the selection's non-collapsed ranges crosses a {@link module:engine/model/schema~ModelSchema#isLimit limit element}
* boundary (a range must be rooted within one limit element).
* * Only {@link module:engine/model/schema~ModelSchema#isSelectable selectable elements} can be selected from the outside
* (e.g. `[<paragraph>foo</paragraph>]` is invalid). This rule applies independently to both selection ends, so this
* selection is correct: `<paragraph>f[oo</paragraph><imageBlock></imageBlock>]`.
*
* If the position is not correct, the post-fixer will automatically correct it.
*
* ## Fixing a non-collapsed selection
*
* See as an example a selection that starts in a P1 element and ends inside the text of a TD element
* (`[` and `]` are range boundaries and `(l)` denotes an element defined as `isLimit=true`):
*
* ```
* root
*  |- element P1
*  |   |- "foo"                                      root
*  |- element TABLE (l)                   P1         TABLE             P2
*  |   |- element TR (l)                 f o[o     TR      TR         b a r
*  |   |   |- element TD (l)                       TD      TD
*  |   |       |- "aaa"                          a]a a    b b b
*  |   |- element TR (l)
*  |   |   |- element TD (l)                           ||
*  |   |       |- "bbb"                                ||
*  |- element P2                                       VV
*  |   |- "bar"
*                                                    root
*                                         P1         TABLE]            P2
*                                        f o[o     TR      TR         b a r
*                                                  TD      TD
*                                                a a a    b b b
* ```
*
* In the example above, the TABLE, TR and TD are defined as `isLimit=true` in the schema. The range which is not contained within
* a single limit element must be expanded to select the outermost limit element. The range end is inside the text node of the TD element.
* As the TD element is a child of the TR and TABLE elements, where both are defined as `isLimit=true` in the schema, the range must be
* expanded to select the whole TABLE element.
*
* **Note** If the selection contains multiple ranges, the method returns a minimal set of ranges that are not intersecting after expanding
* them to select `isLimit=true` elements.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$62456067b2c6c63d(model) {
    model.document.registerPostFixer((writer)=>$b9b9f2bdf9c6137f$var$selectionPostFixer(writer, model));
}
/**
* The selection post-fixer.
*/ function $b9b9f2bdf9c6137f$var$selectionPostFixer(writer, model) {
    const selection = model.document.selection;
    const schema = model.schema;
    const ranges = [];
    let wasFixed = false;
    for (const modelRange of selection.getRanges()){
        const correctedRange = $b9b9f2bdf9c6137f$export$40475a88db3fce3(modelRange, schema);
        if (correctedRange && !correctedRange.isEqual(modelRange)) {
            ranges.push(correctedRange);
            wasFixed = true;
        } else ranges.push(modelRange);
    }
    if (wasFixed) writer.setSelection($b9b9f2bdf9c6137f$export$2c2bfced5c48029d(ranges), {
        backward: selection.isBackward
    });
    return false;
}
/**
* Tries fixing a range if it's incorrect.
*
* **Note:** This helper is used by the selection post-fixer and to fix the `beforeinput` target ranges.
*
* @returns Returns fixed range or null if range is valid.
* @internal
*/ function $b9b9f2bdf9c6137f$export$40475a88db3fce3(range, schema) {
    if (range.isCollapsed) return $b9b9f2bdf9c6137f$var$tryFixingCollapsedRange(range, schema);
    return $b9b9f2bdf9c6137f$var$tryFixingNonCollapsedRage(range, schema);
}
/**
* Tries to fix collapsed ranges.
*
* * Fixes situation when a range is in a place where $text is not allowed
*
* @param range Collapsed range to fix.
* @returns Returns fixed range or null if range is valid.
*/ function $b9b9f2bdf9c6137f$var$tryFixingCollapsedRange(range, schema) {
    const originalPosition = range.start;
    const nearestSelectionRange = schema.getNearestSelectionRange(originalPosition);
    if (!nearestSelectionRange) {
        const ancestorObject = originalPosition.getAncestors().reverse().find((item)=>schema.isObject(item));
        if (ancestorObject) return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(ancestorObject);
        return null;
    }
    if (!nearestSelectionRange.isCollapsed) return nearestSelectionRange;
    const fixedPosition = nearestSelectionRange.start;
    if (originalPosition.isEqual(fixedPosition)) return null;
    return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(fixedPosition);
}
/**
* Tries to fix an expanded range.
*
* @param range Expanded range to fix.
* @returns Returns fixed range or null if range is valid.
*/ function $b9b9f2bdf9c6137f$var$tryFixingNonCollapsedRage(range, schema) {
    const { start: start, end: end } = range;
    const isTextAllowedOnStart = schema.checkChild(start, "$text");
    const isTextAllowedOnEnd = schema.checkChild(end, "$text");
    const startLimitElement = schema.getLimitElement(start);
    const endLimitElement = schema.getLimitElement(end);
    if (startLimitElement === endLimitElement) {
        if (isTextAllowedOnStart && isTextAllowedOnEnd) return null;
        if ($b9b9f2bdf9c6137f$var$checkSelectionOnNonLimitElements(start, end, schema)) {
            const fixedStart = start.nodeAfter && schema.isSelectable(start.nodeAfter) ? null : schema.getNearestSelectionRange(start, "forward");
            const fixedEnd = end.nodeBefore && schema.isSelectable(end.nodeBefore) ? null : schema.getNearestSelectionRange(end, "backward");
            const rangeStart = fixedStart ? fixedStart.start : start;
            const rangeEnd = fixedEnd ? fixedEnd.end : end;
            return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(rangeStart, rangeEnd);
        }
    }
    const isStartInLimit = startLimitElement && !startLimitElement.is("rootElement");
    const isEndInLimit = endLimitElement && !endLimitElement.is("rootElement");
    if (isStartInLimit || isEndInLimit) {
        const bothInSameParent = start.nodeAfter && end.nodeBefore && start.nodeAfter.parent === end.nodeBefore.parent;
        const expandStart = isStartInLimit && (!bothInSameParent || !$b9b9f2bdf9c6137f$var$isSelectable(start.nodeAfter, schema));
        const expandEnd = isEndInLimit && (!bothInSameParent || !$b9b9f2bdf9c6137f$var$isSelectable(end.nodeBefore, schema));
        let fixedStart = start;
        let fixedEnd = end;
        if (expandStart) fixedStart = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore($b9b9f2bdf9c6137f$var$findOutermostLimitAncestor(startLimitElement, schema));
        if (expandEnd) fixedEnd = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAfter($b9b9f2bdf9c6137f$var$findOutermostLimitAncestor(endLimitElement, schema));
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(fixedStart, fixedEnd);
    }
    return null;
}
/**
* Finds the outer-most ancestor.
*/ function $b9b9f2bdf9c6137f$var$findOutermostLimitAncestor(startingNode, schema) {
    let isLimitNode = startingNode;
    let parent = isLimitNode;
    while(schema.isLimit(parent) && parent.parent){
        isLimitNode = parent;
        parent = parent.parent;
    }
    return isLimitNode;
}
/**
* Checks whether any of range boundaries is placed around non-limit elements.
*/ function $b9b9f2bdf9c6137f$var$checkSelectionOnNonLimitElements(start, end, schema) {
    const startIsOnBlock = start.nodeAfter && !schema.isLimit(start.nodeAfter) || schema.checkChild(start, "$text");
    const endIsOnBlock = end.nodeBefore && !schema.isLimit(end.nodeBefore) || schema.checkChild(end, "$text");
    return startIsOnBlock || endIsOnBlock;
}
/**
* Returns a minimal non-intersecting array of ranges without duplicates.
*
* @param ranges Ranges to merge.
* @returns Array of unique and non-intersecting ranges.
* @internal
*/ function $b9b9f2bdf9c6137f$export$2c2bfced5c48029d(ranges) {
    const rangesToMerge = [
        ...ranges
    ];
    const rangeIndexesToRemove = /* @__PURE__ */ new Set();
    let currentRangeIndex = 1;
    while(currentRangeIndex < rangesToMerge.length){
        const currentRange = rangesToMerge[currentRangeIndex];
        const previousRanges = rangesToMerge.slice(0, currentRangeIndex);
        for (const [previousRangeIndex, previousRange] of previousRanges.entries()){
            if (rangeIndexesToRemove.has(previousRangeIndex)) continue;
            if (currentRange.isEqual(previousRange)) rangeIndexesToRemove.add(previousRangeIndex);
            else if (currentRange.isIntersecting(previousRange)) {
                rangeIndexesToRemove.add(previousRangeIndex);
                rangeIndexesToRemove.add(currentRangeIndex);
                const mergedRange = currentRange.getJoined(previousRange);
                rangesToMerge.push(mergedRange);
            }
        }
        currentRangeIndex++;
    }
    return rangesToMerge.filter((_, index)=>!rangeIndexesToRemove.has(index));
}
/**
* Checks if node exists and if it's a selectable.
*/ function $b9b9f2bdf9c6137f$var$isSelectable(node, schema) {
    return node && schema.isSelectable(node);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/utils/deletecontent
*/ /**
* Deletes content of the selection and merge siblings. The resulting selection is always collapsed.
*
* **Note:** Use {@link module:engine/model/model~Model#deleteContent} instead of this function.
* This function is only exposed to be reusable in algorithms
* which change the {@link module:engine/model/model~Model#deleteContent}
* method's behavior.
*
* @param model The model in context of which the insertion should be performed.
* @param selection Selection of which the content should be deleted.
* @param options.leaveUnmerged Whether to merge elements after removing the content of the selection.
*
* For example `<heading>x[x</heading><paragraph>y]y</paragraph>` will become:
*
* * `<heading>x^y</heading>` with the option disabled (`leaveUnmerged == false`)
* * `<heading>x^</heading><paragraph>y</paragraph>` with enabled (`leaveUnmerged == true`).
*
* Note: {@link module:engine/model/schema~ModelSchema#isObject object} and {@link module:engine/model/schema~ModelSchema#isLimit limit}
* elements will not be merged.
*
* @param options.doNotResetEntireContent Whether to skip replacing the entire content with a
* paragraph when the entire content was selected.
*
* For example `<heading>[x</heading><paragraph>y]</paragraph>` will become:
*
* * `<paragraph>^</paragraph>` with the option disabled (`doNotResetEntireContent == false`)
* * `<heading>^</heading>` with enabled (`doNotResetEntireContent == true`).
*
* @param options.doNotAutoparagraph Whether to create a paragraph if after content deletion selection is moved
* to a place where text cannot be inserted.
*
* For example `<paragraph>x</paragraph>[<imageBlock src="foo.jpg"></imageBlock>]` will become:
*
* * `<paragraph>x</paragraph><paragraph>[]</paragraph>` with the option disabled (`doNotAutoparagraph == false`)
* * `<paragraph>x</paragraph>[]` with the option enabled (`doNotAutoparagraph == true`).
*
* If you use this option you need to make sure to handle invalid selections yourself or leave
* them to the selection post-fixer (may not always work).
*
* **Note:** If there is no valid position for the selection, the paragraph will always be created:
*
* `[<imageBlock src="foo.jpg"></imageBlock>]` -> `<paragraph>[]</paragraph>`.
*
* @param options.doNotFixSelection Whether given selection-to-remove should be fixed if it ends at the beginning of an element.
*
* By default, `deleteContent()` will fix selection before performing a deletion, so that the selection does not end at the beginning of
* an element. For example, selection `<heading>[Heading</heading><paragraph>]Some text.</paragraph>` will be treated as it was
* `<heading>[Heading]</heading><paragraph>Some text.</paragraph>`. As a result, the elements will not get merged.
*
* If selection is as in example, visually, the next element (paragraph) is not selected and it may be confusing for the user that
* the elements got merged. Selection is set up like this by browsers when a user triple-clicks on some text.
*
* However, in some cases, it is expected to remove content exactly as selected in the selection, without any fixing. In these cases,
* this flag can be set to `true`, which will prevent fixing the selection.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$1602924c71efd22f(model, selection, options = {}) {
    if (selection.isCollapsed) return;
    const selRange = selection.getFirstRange();
    if (selRange.root.rootName == "$graveyard") return;
    const schema = model.schema;
    const documentSelection = model.document.selection;
    const selectionIsDocumentSelection = $b9b9f2bdf9c6137f$var$isRelatedToDocumentSelection(selection, documentSelection, selRange);
    const selectionAttributes = Array.from(documentSelection.getAttributes());
    const selectionParentWasEmpty = !!documentSelection.getFirstRange()?.start.parent.isEmpty;
    model.change((writer)=>{
        if (!options.doNotResetEntireContent && $b9b9f2bdf9c6137f$var$shouldEntireContentBeReplacedWithParagraph(schema, selection)) {
            $b9b9f2bdf9c6137f$var$replaceEntireContentWithParagraph(writer, selection);
            return;
        }
        const attributesForAutoparagraph = {};
        if (!options.doNotAutoparagraph) {
            const selectedElement = selection.getSelectedElement();
            if (selectedElement) Object.assign(attributesForAutoparagraph, schema.getAttributesWithProperty(selectedElement, "copyOnReplace", true));
        }
        let startPosition, endPosition;
        if (selRange.root instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2) {
            startPosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._fromPositionInDocumentFragment(selRange.start, model, "toPrevious");
            endPosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._fromPositionInDocumentFragment(selRange.end, model, "toNext");
        } else if (!options.doNotFixSelection) [startPosition, endPosition] = $b9b9f2bdf9c6137f$var$getLivePositionsForSelectedBlocks(selRange);
        else {
            startPosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(selRange.start, "toPrevious");
            endPosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(selRange.end, "toNext");
        }
        if (!startPosition.isTouching(endPosition)) writer.remove(writer.createRange(startPosition, endPosition));
        if (!options.leaveUnmerged) {
            $b9b9f2bdf9c6137f$var$mergeBranches(writer, startPosition, endPosition);
            schema.removeDisallowedAttributes(startPosition.parent.getChildren(), writer);
        }
        $b9b9f2bdf9c6137f$var$collapseSelectionAt(writer, selection, startPosition);
        if (!options.doNotAutoparagraph && $b9b9f2bdf9c6137f$var$shouldAutoparagraph(schema, startPosition)) $b9b9f2bdf9c6137f$var$insertParagraph(writer, startPosition, selection, attributesForAutoparagraph);
        if (selectionIsDocumentSelection) $b9b9f2bdf9c6137f$var$restoreSelectionAttributesOnEmptyParent(writer, selectionAttributes, selectionParentWasEmpty);
        startPosition.detach();
        endPosition.detach();
    });
}
/**
* Returns the live positions for the range adjusted to span only blocks selected from the user perspective. Example:
*
* ```
* <heading1>[foo</heading1>
* <paragraph>bar</paragraph>
* <heading1>]abc</heading1>  <-- this block is not considered as selected
* ```
*
* This is the same behavior as in Selection#getSelectedBlocks() "special case".
*/ function $b9b9f2bdf9c6137f$var$getLivePositionsForSelectedBlocks(range) {
    const model = range.root.document.model;
    const startPosition = range.start;
    let endPosition = range.end;
    if (model.hasContent(range, {
        ignoreMarkers: true
    })) {
        const endBlock = $b9b9f2bdf9c6137f$var$getParentBlock(endPosition);
        if (endBlock && endPosition.isTouching(model.createPositionAt(endBlock, 0))) {
            const selection = model.createSelection(range);
            model.modifySelection(selection, {
                direction: "backward"
            });
            const newEndPosition = selection.getLastPosition();
            const skippedRange = model.createRange(newEndPosition, endPosition);
            if (!model.hasContent(skippedRange, {
                ignoreMarkers: true
            })) endPosition = newEndPosition;
        }
    }
    return [
        $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(startPosition, "toPrevious"),
        $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(endPosition, "toNext")
    ];
}
/**
* Finds the lowest element in position's ancestors which is a block.
* Returns null if a limit element is encountered before reaching a block element.
*/ function $b9b9f2bdf9c6137f$var$getParentBlock(position) {
    const element = position.parent;
    const schema = element.root.document.model.schema;
    const ancestors = element.getAncestors({
        parentFirst: true,
        includeSelf: true
    });
    for (const element of ancestors){
        if (schema.isLimit(element)) return null;
        if (schema.isBlock(element)) return element;
    }
}
/**
* This function is a result of reaching the Ballmer's peak for just the right amount of time.
* Even I had troubles documenting it after a while and after reading it again I couldn't believe that it really works.
*/ function $b9b9f2bdf9c6137f$var$mergeBranches(writer, startPosition, endPosition) {
    const model = writer.model;
    if (!$b9b9f2bdf9c6137f$var$checkShouldMerge(writer.model.schema, startPosition, endPosition)) return;
    const [startAncestor, endAncestor] = $b9b9f2bdf9c6137f$var$getAncestorsJustBelowCommonAncestor(startPosition, endPosition);
    if (!startAncestor || !endAncestor) return;
    if (!model.hasContent(startAncestor, {
        ignoreMarkers: true
    }) && model.hasContent(endAncestor, {
        ignoreMarkers: true
    })) $b9b9f2bdf9c6137f$var$mergeBranchesRight(writer, startPosition, endPosition, startAncestor.parent);
    else $b9b9f2bdf9c6137f$var$mergeBranchesLeft(writer, startPosition, endPosition, startAncestor.parent);
}
/**
* Merging blocks to the left (properties of the left block are preserved).
* Simple example:
*
* ```
* <heading1>foo[</heading1>    ->  <heading1>foo[bar</heading1>]
* <paragraph>]bar</paragraph>  ->              --^
* ```
*
* Nested example:
*
* ```
* <blockQuote>                     ->  <blockQuote>
*     <heading1>foo[</heading1>    ->      <heading1>foo[bar</heading1>
* </blockQuote>                    ->  </blockQuote>]    ^
* <blockBlock>                     ->                    |
*     <paragraph>]bar</paragraph>  ->                 ---
* </blockBlock>                    ->
* ```
*/ function $b9b9f2bdf9c6137f$var$mergeBranchesLeft(writer, startPosition, endPosition, commonAncestor) {
    const startElement = startPosition.parent;
    const endElement = endPosition.parent;
    if (startElement == commonAncestor || endElement == commonAncestor) return;
    startPosition = writer.createPositionAfter(startElement);
    endPosition = writer.createPositionBefore(endElement);
    if (!endPosition.isEqual(startPosition)) writer.insert(endElement, startPosition);
    writer.merge(startPosition);
    while(endPosition.parent.isEmpty){
        const parentToRemove = endPosition.parent;
        endPosition = writer.createPositionBefore(parentToRemove);
        writer.remove(parentToRemove);
    }
    if (!$b9b9f2bdf9c6137f$var$checkShouldMerge(writer.model.schema, startPosition, endPosition)) return;
    $b9b9f2bdf9c6137f$var$mergeBranchesLeft(writer, startPosition, endPosition, commonAncestor);
}
/**
* Merging blocks to the right (properties of the right block are preserved).
* Simple example:
*
* ```
* <heading1>foo[</heading1>    ->            --v
* <paragraph>]bar</paragraph>  ->  [<paragraph>foo]bar</paragraph>
* ```
*
* Nested example:
*
* ```
* <blockQuote>                     ->
*     <heading1>foo[</heading1>    ->              ---
* </blockQuote>                    ->                 |
* <blockBlock>                     ->  [<blockBlock>  v
*     <paragraph>]bar</paragraph>  ->      <paragraph>foo]bar</paragraph>
* </blockBlock>                    ->  </blockBlock>
* ```
*/ function $b9b9f2bdf9c6137f$var$mergeBranchesRight(writer, startPosition, endPosition, commonAncestor) {
    const startElement = startPosition.parent;
    const endElement = endPosition.parent;
    if (startElement == commonAncestor || endElement == commonAncestor) return;
    startPosition = writer.createPositionAfter(startElement);
    endPosition = writer.createPositionBefore(endElement);
    if (!endPosition.isEqual(startPosition)) writer.insert(startElement, endPosition);
    while(startPosition.parent.isEmpty){
        const parentToRemove = startPosition.parent;
        startPosition = writer.createPositionBefore(parentToRemove);
        writer.remove(parentToRemove);
    }
    endPosition = writer.createPositionBefore(endElement);
    $b9b9f2bdf9c6137f$var$mergeRight(writer, endPosition);
    if (!$b9b9f2bdf9c6137f$var$checkShouldMerge(writer.model.schema, startPosition, endPosition)) return;
    $b9b9f2bdf9c6137f$var$mergeBranchesRight(writer, startPosition, endPosition, commonAncestor);
}
/**
* There is no right merge operation so we need to simulate it.
*/ function $b9b9f2bdf9c6137f$var$mergeRight(writer, position) {
    const startElement = position.nodeBefore;
    const endElement = position.nodeAfter;
    if (startElement.name != endElement.name) writer.rename(startElement, endElement.name);
    writer.clearAttributes(startElement);
    writer.setAttributes(Object.fromEntries(endElement.getAttributes()), startElement);
    writer.merge(position);
}
/**
* Verifies if merging is needed and possible. It's not needed if both positions are in the same element
* and it's not possible if some element is a limit or the range crosses a limit element.
*/ function $b9b9f2bdf9c6137f$var$checkShouldMerge(schema, startPosition, endPosition) {
    const startElement = startPosition.parent;
    const endElement = endPosition.parent;
    if (startElement == endElement) return false;
    if (schema.isLimit(startElement) || schema.isLimit(endElement)) return false;
    return $b9b9f2bdf9c6137f$var$isCrossingLimitElement(startPosition, endPosition, schema);
}
/**
* Returns the elements that are the ancestors of the provided positions that are direct children of the common ancestor.
*/ function $b9b9f2bdf9c6137f$var$getAncestorsJustBelowCommonAncestor(positionA, positionB) {
    const ancestorsA = positionA.getAncestors();
    const ancestorsB = positionB.getAncestors();
    let i = 0;
    while(ancestorsA[i] && ancestorsA[i] == ancestorsB[i])i++;
    return [
        ancestorsA[i],
        ancestorsB[i]
    ];
}
function $b9b9f2bdf9c6137f$var$shouldAutoparagraph(schema, position) {
    const isTextAllowed = schema.checkChild(position, "$text");
    const isParagraphAllowed = schema.checkChild(position, "paragraph");
    return !isTextAllowed && isParagraphAllowed;
}
/**
* Check if parents of two positions can be merged by checking if there are no limit/object
* boundaries between those two positions.
*
* E.g. in <bQ><p>x[]</p></bQ><widget><caption>{}</caption></widget>
* we'll check <p>, <bQ>, <widget> and <caption>.
* Usually, widget and caption are marked as objects/limits in the schema, so in this case merging will be blocked.
*/ function $b9b9f2bdf9c6137f$var$isCrossingLimitElement(leftPos, rightPos, schema) {
    const rangeToCheck = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(leftPos, rightPos);
    for (const value of rangeToCheck.getWalker())if (schema.isLimit(value.item)) return false;
    return true;
}
function $b9b9f2bdf9c6137f$var$insertParagraph(writer, position, selection, attributes = {}) {
    const paragraph = writer.createElement("paragraph");
    writer.model.schema.setAllowedAttributes(paragraph, attributes, writer);
    writer.insert(paragraph, position);
    $b9b9f2bdf9c6137f$var$collapseSelectionAt(writer, selection, writer.createPositionAt(paragraph, 0));
}
function $b9b9f2bdf9c6137f$var$replaceEntireContentWithParagraph(writer, selection) {
    const limitElement = writer.model.schema.getLimitElement(selection);
    writer.remove(writer.createRangeIn(limitElement));
    $b9b9f2bdf9c6137f$var$insertParagraph(writer, writer.createPositionAt(limitElement, 0), selection);
}
/**
* We want to replace the entire content with a paragraph when:
* * the entire content is selected,
* * selection contains at least two elements,
* * whether the paragraph is allowed in schema in the common ancestor.
*/ function $b9b9f2bdf9c6137f$var$shouldEntireContentBeReplacedWithParagraph(schema, selection) {
    const limitElement = schema.getLimitElement(selection);
    if (!selection.containsEntireContent(limitElement)) return false;
    const range = selection.getFirstRange();
    if (range.start.parent == range.end.parent) return false;
    return schema.checkChild(limitElement, "paragraph");
}
/**
* Helper function that sets the selection. Depending whether given `selection` is a document selection or not,
* uses a different method to set it.
*/ function $b9b9f2bdf9c6137f$var$collapseSelectionAt(writer, selection, positionOrRange) {
    if (selection instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) writer.setSelection(positionOrRange);
    else selection.setTo(positionOrRange);
}
/**
* Restores the document selection attributes after a deletion that leaves the selection in an empty parent block.
* This preserves the pre-delete formatting (e.g. bold, italic) so that subsequent typing continues in the same style.
*
* Attributes are only restored when:
* - There were attributes on the selection before the deletion.
* - The deletion left the document selection's parent block empty.
* - The parent block was **not** already empty before the deletion — this ensures that attributes are not
*   re-applied when `deleteContent()` was called on a completely unrelated block.
*/ function $b9b9f2bdf9c6137f$var$restoreSelectionAttributesOnEmptyParent(writer, selectionAttributes, selectionParentWasEmpty) {
    if (!selectionAttributes.length) return;
    const documentSelection = writer.model.document.selection;
    if (!documentSelection.anchor.parent.isEmpty) return;
    if (selectionParentWasEmpty) return;
    for (const [key, value] of selectionAttributes)if (writer.model.schema.getAttributeProperties(key).isFormatting && writer.model.schema.checkAttributeInSelection(documentSelection, key)) writer.setSelectionAttribute(key, value);
}
/**
* Checks whether the provided selection is related to the document selection.
*
* Returns `true` when:
* - the selection is a `DocumentSelection` instance, or
* - the document selection is collapsed and sits at the start or end of the given range, or
* - the document selection is not collapsed and its range intersects the given range.
*/ function $b9b9f2bdf9c6137f$var$isRelatedToDocumentSelection(selection, documentSelection, selRange) {
    if (selection instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) return true;
    if (documentSelection.isCollapsed) {
        const position = documentSelection.getFirstPosition();
        return position.isEqual(selRange.start) || position.isEqual(selRange.end);
    }
    return !!documentSelection.getFirstRange()?.isIntersecting(selRange);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Gets a clone of the selected content.
*
* For example, for the following selection:
*
* ```html
* <p>x</p><quote><p>y</p><h>fir[st</h></quote><p>se]cond</p><p>z</p>
* ```
*
* It will return a document fragment with such a content:
*
* ```html
* <quote><h>st</h></quote><p>se</p>
* ```
*
* @param model The model in context of which the selection modification should be performed.
* @param selection The selection of which content will be returned.
* @internal
*/ function $b9b9f2bdf9c6137f$export$805513d154ea59fd(model, selection) {
    return model.change((writer)=>{
        const frag = writer.createDocumentFragment();
        const range = selection.getFirstRange();
        if (!range || range.isCollapsed) return frag;
        const root = range.start.root;
        const commonPath = range.start.getCommonPath(range.end);
        const commonParent = root.getNodeByPath(commonPath);
        let flatSubtreeRange;
        if (range.start.parent == range.end.parent) flatSubtreeRange = range;
        else flatSubtreeRange = writer.createRange(writer.createPositionAt(commonParent, range.start.path[commonPath.length]), writer.createPositionAt(commonParent, range.end.path[commonPath.length] + 1));
        const howMany = flatSubtreeRange.end.offset - flatSubtreeRange.start.offset;
        for (const item of flatSubtreeRange.getItems({
            shallow: true
        }))if (item.is("$textProxy")) writer.appendText(item.data, item.getAttributes(), frag);
        else writer.append(writer.cloneElement(item, true), frag);
        if (flatSubtreeRange != range) {
            const newRange = range._getTransformedByMove(flatSubtreeRange.start, writer.createPositionAt(frag, 0), howMany)[0];
            const leftExcessRange = writer.createRange(writer.createPositionAt(frag, 0), newRange.start);
            $b9b9f2bdf9c6137f$var$removeRangeContent(writer.createRange(newRange.end, writer.createPositionAt(frag, "end")), writer);
            $b9b9f2bdf9c6137f$var$removeRangeContent(leftExcessRange, writer);
        }
        return frag;
    });
}
function $b9b9f2bdf9c6137f$var$removeRangeContent(range, writer) {
    const parentsToCheck = [];
    Array.from(range.getItems({
        direction: "backward"
    })).map((item)=>writer.createRangeOn(item)).filter((itemRange)=>{
        return (itemRange.start.isAfter(range.start) || itemRange.start.isEqual(range.start)) && (itemRange.end.isBefore(range.end) || itemRange.end.isEqual(range.end));
    }).forEach((itemRange)=>{
        parentsToCheck.push(itemRange.start.parent);
        writer.remove(itemRange);
    });
    parentsToCheck.forEach((parentToCheck)=>{
        let parent = parentToCheck;
        while(parent.parent && parent.isEmpty){
            const removeRange = writer.createRangeOn(parent);
            parent = parent.parent;
            writer.remove(removeRange);
        }
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/utils/insertcontent
*/ /**
* Inserts content into the editor (specified selection) as one would expect the paste functionality to work.
*
* It takes care of removing the selected content, splitting elements (if needed), inserting elements and merging elements appropriately.
*
* Some examples:
*
* ```html
* <p>x^</p> + <p>y</p> => <p>x</p><p>y</p> => <p>xy[]</p>
* <p>x^y</p> + <p>z</p> => <p>x</p>^<p>y</p> + <p>z</p> => <p>x</p><p>z</p><p>y</p> => <p>xz[]y</p>
* <p>x^y</p> + <img /> => <p>x</p>^<p>y</p> + <img /> => <p>x</p><img /><p>y</p>
* <p>x</p><p>^</p><p>z</p> + <p>y</p> => <p>x</p><p>y[]</p><p>z</p> (no merging)
* <p>x</p>[<img />]<p>z</p> + <p>y</p> => <p>x</p>^<p>z</p> + <p>y</p> => <p>x</p><p>y[]</p><p>z</p>
* ```
*
* If an instance of {@link module:engine/model/selection~ModelSelection} is passed as `selectable` it will be modified
* to the insertion selection (equal to a range to be selected after insertion).
*
* If `selectable` is not passed, the content will be inserted using the current selection of the model document.
*
* **Note:** Use {@link module:engine/model/model~Model#insertContent} instead of this function.
* This function is only exposed to be reusable in algorithms which change the {@link module:engine/model/model~Model#insertContent}
* method's behavior.
*
* @param model The model in context of which the insertion should be performed.
* @param content The content to insert.
* @param selectable Selection into which the content should be inserted.
* @returns Range which contains all the performed changes. This is a range that, if removed,
* would return the model to the state before the insertion. If no changes were preformed by `insertContent`, returns a range collapsed
* at the insertion position.
* @internal
*/ function $b9b9f2bdf9c6137f$export$afd9f74aae45a476(model, content, selectable) {
    return model.change((writer)=>{
        const selection = selectable ? selectable : model.document.selection;
        if (!selection.isCollapsed) model.deleteContent(selection, {
            doNotAutoparagraph: true
        });
        const insertion = new $b9b9f2bdf9c6137f$var$Insertion(model, writer, selection.anchor);
        const fakeMarkerElements = [];
        let nodesToInsert;
        if (content.is("documentFragment")) {
            if (content.markers.size) {
                const markersPosition = [];
                for (const [name, range] of content.markers){
                    const { start: start, end: end } = range;
                    const isCollapsed = start.isEqual(end);
                    markersPosition.push({
                        position: start,
                        name: name,
                        isCollapsed: isCollapsed
                    }, {
                        position: end,
                        name: name,
                        isCollapsed: isCollapsed
                    });
                }
                markersPosition.sort(({ position: posA }, { position: posB })=>posA.isBefore(posB) ? 1 : -1);
                for (const { position: position, name: name, isCollapsed: isCollapsed } of markersPosition){
                    let fakeElement = null;
                    let collapsed = null;
                    const isAtBeginning = position.parent === content && position.isAtStart;
                    const isAtEnd = position.parent === content && position.isAtEnd;
                    if (!isAtBeginning && !isAtEnd) {
                        fakeElement = writer.createElement("$marker");
                        writer.insert(fakeElement, position);
                    } else if (isCollapsed) collapsed = isAtBeginning ? "start" : "end";
                    fakeMarkerElements.push({
                        name: name,
                        element: fakeElement,
                        collapsed: collapsed
                    });
                }
            }
            nodesToInsert = content.getChildren();
        } else nodesToInsert = [
            content
        ];
        insertion.handleNodes(nodesToInsert);
        let newRange = insertion.getSelectionRange();
        if (content.is("documentFragment") && fakeMarkerElements.length) {
            const selectionLiveRange = newRange ? $b9b9f2bdf9c6137f$export$a20b9237842cdd3f.fromRange(newRange) : null;
            const markersData = {};
            for(let i = fakeMarkerElements.length - 1; i >= 0; i--){
                const { name: name, element: element, collapsed: collapsed } = fakeMarkerElements[i];
                const isStartBoundary = !markersData[name];
                if (isStartBoundary) markersData[name] = [];
                if (element) {
                    const elementPosition = writer.createPositionAt(element, "before");
                    markersData[name].push(elementPosition);
                    writer.remove(element);
                } else {
                    const rangeOnInsertion = insertion.getAffectedRange();
                    if (!rangeOnInsertion) {
                        if (collapsed) markersData[name].push(insertion.position);
                        continue;
                    }
                    if (collapsed) markersData[name].push(rangeOnInsertion[collapsed]);
                    else markersData[name].push(isStartBoundary ? rangeOnInsertion.start : rangeOnInsertion.end);
                }
            }
            for (const [name, [start, end]] of Object.entries(markersData))if (start && end && start.root === end.root && start.root.document && !writer.model.markers.has(name)) writer.addMarker(name, {
                usingOperation: true,
                affectsData: true,
                range: new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, end)
            });
            if (selectionLiveRange) {
                newRange = selectionLiveRange.toRange();
                selectionLiveRange.detach();
            }
        }
        if (newRange) {
            if (selection instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) writer.setSelection(newRange);
            else selection.setTo(newRange);
        }
        const affectedRange = insertion.getAffectedRange() || model.createRange(selection.anchor);
        insertion.destroy();
        return affectedRange;
    });
}
/**
* Utility class for performing content insertion.
*/ var $b9b9f2bdf9c6137f$var$Insertion = class {
    /**
	* The model in context of which the insertion should be performed.
	*/ model;
    /**
	* Batch to which operations will be added.
	*/ writer;
    /**
	* The position at which (or near which) the next node will be inserted.
	*/ position;
    /**
	* Elements with which the inserted elements can be merged.
	*
	* ```html
	* <p>x^</p><p>y</p> + <p>z</p> (can merge to <p>x</p>)
	* <p>x</p><p>^y</p> + <p>z</p> (can merge to <p>y</p>)
	* <p>x^y</p> + <p>z</p> (can merge to <p>xy</p> which will be split during the action,
	* 						so both its pieces will be added to this set)
	* ```
	*/ canMergeWith;
    /**
	* Schema of the model.
	*/ schema;
    /**
	* The temporary ModelDocumentFragment used for grouping multiple nodes for single insert operation.
	*/ _documentFragment;
    /**
	* The current position in the temporary ModelDocumentFragment.
	*/ _documentFragmentPosition;
    /**
	* The reference to the first inserted node.
	*/ _firstNode = null;
    /**
	* The reference to the last inserted node.
	*/ _lastNode = null;
    /**
	* The reference to the last auto paragraph node.
	*/ _lastAutoParagraph = null;
    /**
	* The array of nodes that should be cleaned of not allowed attributes and sub-nodes.
	*/ _filterAttributesAndChildrenOf = [];
    /**
	* Beginning of the affected range. See {@link module:engine/model/utils/insertcontent~Insertion#getAffectedRange}.
	*/ _affectedStart = null;
    /**
	* End of the affected range. See {@link module:engine/model/utils/insertcontent~Insertion#getAffectedRange}.
	*/ _affectedEnd = null;
    _nodeToSelect = null;
    constructor(model, writer, position){
        this.model = model;
        this.writer = writer;
        this.position = position;
        this.canMergeWith = /* @__PURE__ */ new Set([
            this.position.parent
        ]);
        this.schema = model.schema;
        this._documentFragment = writer.createDocumentFragment();
        this._documentFragmentPosition = writer.createPositionAt(this._documentFragment, 0);
    }
    /**
	* Handles insertion of a set of nodes.
	*
	* @param nodes Nodes to insert.
	*/ handleNodes(nodes) {
        for (const node of Array.from(nodes))if (node.offsetSize > 0) this._handleNode(node);
        this._insertPartialFragment();
        if (this._lastAutoParagraph) this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph);
        this._mergeOnRight();
        this.schema.removeDisallowedAttributes(this._filterAttributesAndChildrenOf, this.writer);
        if (this.model._config?.get("experimentalFlags.modelInsertContentDeepSchemaVerification") !== false) this._removeDisallowedChildren(this._filterAttributesAndChildrenOf);
        this._filterAttributesAndChildrenOf = [];
    }
    /**
	* Removes disallowed children from nodes that were inserted or modified during insertion.
	*/ _removeDisallowedChildren(nodes) {
        const nodesArray = Array.from(nodes);
        for (const node of nodesArray){
            if (!node.is("element")) continue;
            const remove = [];
            const unwrap = [];
            const walker = this.writer.createRangeIn(node).getWalker({
                ignoreElementEnd: true
            });
            for (const { item: item } of walker){
                const itemParent = item.parent;
                if (!this.schema.checkChild(itemParent, item)) {
                    if (item.is("element") && !this.schema.isObject(item)) {
                        unwrap.push(item);
                        nodesArray.push(itemParent);
                    } else remove.push(item);
                    walker.jumpTo(this.writer.createPositionAfter(item));
                }
            }
            for (const item of unwrap)this.writer.unwrap(item);
            for (const item of remove)this.writer.remove(item);
        }
    }
    /**
	* Updates the last node after the auto paragraphing.
	*
	* @param node The last auto paragraphing node.
	*/ _updateLastNodeFromAutoParagraph(node) {
        const positionAfterLastNode = this.writer.createPositionAfter(this._lastNode);
        const positionAfterNode = this.writer.createPositionAfter(node);
        if (positionAfterNode.isAfter(positionAfterLastNode)) {
            this._lastNode = node;
            /* v8 ignore if -- @preserve */ if (this.position.parent != node || !this.position.isAtEnd) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insertcontent-invalid-insertion-position", this);
            this.position = positionAfterNode;
            this._setAffectedBoundaries(this.position);
        }
    }
    /**
	* Returns range to be selected after insertion.
	* Returns `null` if there is no valid range to select after insertion.
	*/ getSelectionRange() {
        if (this._nodeToSelect) return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(this._nodeToSelect);
        return this.model.schema.getNearestSelectionRange(this.position);
    }
    /**
	* Returns a range which contains all the performed changes. This is a range that, if removed, would return the model to the state
	* before the insertion. Returns `null` if no changes were done.
	*/ getAffectedRange() {
        if (!this._affectedStart) return null;
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(this._affectedStart, this._affectedEnd);
    }
    /**
	* Destroys `Insertion` instance.
	*/ destroy() {
        if (this._affectedStart) this._affectedStart.detach();
        if (this._affectedEnd) this._affectedEnd.detach();
    }
    /**
	* Handles insertion of a single node.
	*/ _handleNode(node) {
        if (!this._checkAndSplitToAllowedPosition(node)) {
            if (!this.schema.isObject(node)) this._handleDisallowedNode(node);
            return;
        }
        node = this._appendToFragment(node);
        if (!this._firstNode) this._firstNode = node;
        this._lastNode = node;
    }
    /**
	* Inserts the temporary ModelDocumentFragment into the model.
	*/ _insertPartialFragment() {
        if (this._documentFragment.isEmpty) return;
        const livePosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(this.position, "toNext");
        this._setAffectedBoundaries(this.position);
        if (this._documentFragment.getChild(0) == this._firstNode) {
            this.writer.insert(this._firstNode, this.position);
            this._mergeOnLeft();
            this.position = livePosition.toPosition();
        }
        if (!this._documentFragment.isEmpty) this.writer.insert(this._documentFragment, this.position);
        this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0);
        this.position = livePosition.toPosition();
        livePosition.detach();
    }
    /**
	* @param node The disallowed node which needs to be handled.
	*/ _handleDisallowedNode(node) {
        if (node.is("element")) this.handleNodes(node.getChildren());
    }
    /**
	* Append a node to the temporary ModelDocumentFragment.
	*
	* @param node The node to insert.
	*/ _appendToFragment(node) {
        /* v8 ignore if -- @preserve */ if (!this.schema.checkChild(this.position, node)) /**
		* Given node cannot be inserted on the given position.
		*
		* @error insertcontent-wrong-position
		* @param {module:engine/model/node~ModelNode} node Node to insert.
		* @param {module:engine/model/position~ModelPosition} position Position to insert the node at.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insertcontent-wrong-position", this, {
            node: node,
            position: this.position
        });
        this.writer.insert(node, this._documentFragmentPosition);
        this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(node.offsetSize);
        if (!node.parent) node = this._documentFragmentPosition.nodeBefore;
        if (this.schema.isObject(node) && !this.schema.checkChild(this.position, "$text")) this._nodeToSelect = node;
        else this._nodeToSelect = null;
        this._filterAttributesAndChildrenOf.push(node);
        return node;
    }
    /**
	* Sets `_affectedStart` and `_affectedEnd` to the given `position`. Should be used before a change is done during insertion process to
	* mark the affected range.
	*
	* This method is used before inserting a node or splitting a parent node. `_affectedStart` and `_affectedEnd` are also changed
	* during merging, but the logic there is more complicated so it is left out of this function.
	*/ _setAffectedBoundaries(position) {
        if (!this._affectedStart) this._affectedStart = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(position, "toPrevious");
        if (!this._affectedEnd || this._affectedEnd.isBefore(position)) {
            if (this._affectedEnd) this._affectedEnd.detach();
            this._affectedEnd = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(position, "toNext");
        }
    }
    /**
	* Merges the previous sibling of the first node if it should be merged.
	*
	* After the content was inserted we may try to merge it with its siblings.
	* This should happen only if the selection was in those elements initially.
	*/ _mergeOnLeft() {
        const node = this._firstNode;
        if (!(node instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) return;
        if (!this._canMergeLeft(node)) return;
        const mergePosLeft = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createBefore(node);
        mergePosLeft.stickiness = "toNext";
        const livePosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(this.position, "toNext");
        if (this._affectedStart.isEqual(mergePosLeft)) {
            this._affectedStart.detach();
            this._affectedStart = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createAt(mergePosLeft.nodeBefore, "end", "toPrevious");
        }
        if (this._firstNode === this._lastNode) {
            this._firstNode = mergePosLeft.nodeBefore;
            this._lastNode = mergePosLeft.nodeBefore;
        }
        this.writer.merge(mergePosLeft);
        if (mergePosLeft.isEqual(this._affectedEnd) && this._firstNode === this._lastNode) {
            this._affectedEnd.detach();
            this._affectedEnd = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createAt(mergePosLeft.nodeBefore, "end", "toNext");
        }
        this.position = livePosition.toPosition();
        livePosition.detach();
        this._filterAttributesAndChildrenOf.push(this.position.parent);
        mergePosLeft.detach();
    }
    /**
	* Merges the next sibling of the last node if it should be merged.
	*
	* After the content was inserted we may try to merge it with its siblings.
	* This should happen only if the selection was in those elements initially.
	*/ _mergeOnRight() {
        const node = this._lastNode;
        if (!(node instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31)) return;
        if (!this._canMergeRight(node)) return;
        const mergePosRight = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createAfter(node);
        mergePosRight.stickiness = "toNext";
        /* v8 ignore if -- @preserve */ if (!this.position.isEqual(mergePosRight)) /**
		* An internal error occurred when merging inserted content with its siblings.
		* The insertion position should equal the merge position.
		*
		* If you encountered this error, report it back to the CKEditor 5 team
		* with as many details as possible regarding the content being inserted and the insertion position.
		*
		* @error insertcontent-invalid-insertion-position
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insertcontent-invalid-insertion-position", this);
        this.position = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(mergePosRight.nodeBefore, "end");
        const livePosition = $b9b9f2bdf9c6137f$export$e9dab424d71bca79.fromPosition(this.position, "toPrevious");
        if (this._affectedEnd.isEqual(mergePosRight)) {
            this._affectedEnd.detach();
            this._affectedEnd = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createAt(mergePosRight.nodeBefore, "end", "toNext");
        }
        if (this._firstNode === this._lastNode) {
            this._firstNode = mergePosRight.nodeBefore;
            this._lastNode = mergePosRight.nodeBefore;
        }
        this.writer.merge(mergePosRight);
        if (mergePosRight.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode) {
            this._affectedStart.detach();
            this._affectedStart = $b9b9f2bdf9c6137f$export$e9dab424d71bca79._createAt(mergePosRight.nodeBefore, 0, "toPrevious");
        }
        this.position = livePosition.toPosition();
        livePosition.detach();
        this._filterAttributesAndChildrenOf.push(this.position.parent);
        mergePosRight.detach();
    }
    /**
	* Checks whether specified node can be merged with previous sibling element.
	*
	* @param node The node which could potentially be merged.
	*/ _canMergeLeft(node) {
        const previousSibling = node.previousSibling;
        return previousSibling instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 && this.canMergeWith.has(previousSibling) && this.model.schema.checkMerge(previousSibling, node);
    }
    /**
	* Checks whether specified node can be merged with next sibling element.
	*
	* @param node The node which could potentially be merged.
	*/ _canMergeRight(node) {
        const nextSibling = node.nextSibling;
        return nextSibling instanceof $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31 && this.canMergeWith.has(nextSibling) && this.model.schema.checkMerge(node, nextSibling);
    }
    /**
	* Inserts a paragraph and moves the insertion position into it.
	*/ _insertAutoParagraph() {
        this._insertPartialFragment();
        const paragraph = this.writer.createElement("paragraph");
        this.writer.insert(paragraph, this.position);
        this._setAffectedBoundaries(this.position);
        this._lastAutoParagraph = paragraph;
        this.position = this.writer.createPositionAt(paragraph, 0);
    }
    /**
	* @returns Whether an allowed position was found.
	* `false` is returned if the node isn't allowed at any position up in the tree, `true` if was.
	*/ _checkAndSplitToAllowedPosition(node) {
        const allowedIn = this._getAllowedIn(this.position.parent, node);
        if (!allowedIn) return false;
        if (allowedIn != this.position.parent) this._insertPartialFragment();
        while(allowedIn != this.position.parent)if (this.position.isAtStart) {
            const parent = this.position.parent;
            this.position = this.writer.createPositionBefore(parent);
            if (parent.isEmpty && parent.parent === allowedIn) this.writer.remove(parent);
        } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);
        else {
            const tempPos = this.writer.createPositionAfter(this.position.parent);
            this._setAffectedBoundaries(this.position);
            this.writer.split(this.position);
            this.position = tempPos;
            this.canMergeWith.add(this.position.nodeAfter);
        }
        if (!this.schema.checkChild(this.position.parent, node)) this._insertAutoParagraph();
        return true;
    }
    /**
	* Gets the element in which the given node is allowed. It checks the passed element and all its ancestors.
	*
	* It also verifies if auto-paragraphing could help.
	*
	* @param contextElement The element in which context the node should be checked.
	* @param childNode The node to check.
	*/ _getAllowedIn(contextElement, childNode) {
        const context = this.schema.createContext(contextElement);
        if (this.schema.checkChild(context, childNode)) return contextElement;
        if (this.schema.checkChild(context, "paragraph") && this.schema.checkChild(context.push("paragraph"), childNode)) return contextElement;
        if (this.schema.isLimit(contextElement)) return null;
        return this._getAllowedIn(contextElement.parent, childNode);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Inserts an {@glink framework/deep-dive/schema#object-elements object element} at a specific position in the editor content.
*
* **Note:** Use {@link module:engine/model/model~Model#insertObject} instead of this function.
* This function is only exposed to be reusable in algorithms which change the {@link module:engine/model/model~Model#insertObject}
* method's behavior.
*
* **Note**: For more documentation and examples, see {@link module:engine/model/model~Model#insertObject}.
*
* @param model The model in context of which the insertion should be performed.
* @param object An object to be inserted into the model document.
* @param selectable A selectable where the content should be inserted. If not specified, the current
* {@link module:engine/model/document~ModelDocument#selection document selection} will be used instead.
* @param options Additional options.
* @param options.findOptimalPosition An option that, when set, adjusts the insertion position (relative to
* `selectable` and `placeOrOffset`) so that the content of `selectable` is not split upon insertion (a.k.a. non-destructive insertion).
* * When `'auto'`, the algorithm will decide whether to insert the object before or after `selectable` to avoid content splitting.
* * When `'before'`, the closest position before `selectable` will be used that will not result in content splitting.
* * When `'after'`, the closest position after `selectable` will be used that will not result in content splitting.
*
* Note that this option works only for block objects. Inline objects are inserted into text and do not split blocks.
* @param options.setSelection An option that, when set, moves the
* {@link module:engine/model/document~ModelDocument#selection document selection} after inserting the object.
* * When `'on'`, the document selection will be set on the inserted object.
* * When `'after'`, the document selection will move to the closest text node after the inserted object. If there is no
* such text node, a paragraph will be created and the document selection will be moved inside it.
* @returns A range which contains all the performed changes. This is a range that, if removed,
* would return the model to the state before the insertion. If no changes were preformed by `insertObject()`, returns a range collapsed
* at the insertion position.
*/ function $b9b9f2bdf9c6137f$export$aea1c5f155d8e519(model, object, selectable, options = {}) {
    if (!model.schema.isObject(object)) /**
	* Tried to insert an element with {@link module:engine/model/utils/insertobject insertObject()} function
	* that is not defined as an object in schema.
	* See {@link module:engine/model/schema~ModelSchemaItemDefinition#isObject `SchemaItemDefinition`}.
	* If you want to insert content that is not an object you might want to use
	* {@link module:engine/model/utils/insertcontent insertContent()} function.
	* @error insertobject-element-not-an-object
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insertobject-element-not-an-object", model, {
        object: object
    });
    const originalSelection = selectable ? selectable : model.document.selection;
    let insertionSelection = originalSelection;
    if (options.findOptimalPosition && model.schema.isBlock(object)) insertionSelection = model.createSelection(model.schema.findOptimalInsertionRange(originalSelection, options.findOptimalPosition));
    const firstSelectedBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(originalSelection.getSelectedBlocks());
    const attributesToCopy = {};
    if (firstSelectedBlock) Object.assign(attributesToCopy, model.schema.getAttributesWithProperty(firstSelectedBlock, "copyOnReplace", true));
    return model.change((writer)=>{
        if (!insertionSelection.isCollapsed) model.deleteContent(insertionSelection, {
            doNotAutoparagraph: true
        });
        let elementToInsert = object;
        const insertionPositionParent = insertionSelection.anchor.parent;
        const context = model.schema.createContext(insertionPositionParent);
        if (!model.schema.checkChild(context, object) && model.schema.checkChild(context, "paragraph") && model.schema.checkChild(context.push("paragraph"), object)) {
            elementToInsert = writer.createElement("paragraph");
            writer.insert(object, elementToInsert);
        }
        model.schema.setAllowedAttributes(elementToInsert, attributesToCopy, writer);
        const affectedRange = model.insertContent(elementToInsert, insertionSelection);
        if (affectedRange.isCollapsed) return affectedRange;
        if (options.setSelection) $b9b9f2bdf9c6137f$var$updateSelection(writer, object, options.setSelection, attributesToCopy);
        return affectedRange;
    });
}
/**
* Updates document selection based on given `place` parameter in relation to `contextElement` element.
*
* @param writer An instance of the model writer.
* @param contextElement An element to set the attributes on.
* @param place The place where selection should be set in relation to the `contextElement` element.
* Value `on` will set selection on the passed `contextElement`. Value `after` will set selection after `contextElement`.
* @param attributes Attributes keys and values to set on a paragraph that this function can create when
* `place` parameter is equal to `after` but there is no element with `$text` node to set selection in.
*/ function $b9b9f2bdf9c6137f$var$updateSelection(writer, contextElement, place, paragraphAttributes) {
    const model = writer.model;
    if (place == "on") {
        writer.setSelection(contextElement, "on");
        return;
    }
    if (place != "after") /**
	* The unsupported `options.setSelection` parameter was passed
	* to the {@link module:engine/model/utils/insertobject insertObject()} function.
	* Check the {@link module:engine/model/utils/insertobject insertObject()} API documentation for allowed
	* `options.setSelection` parameter values.
	*
	* @error insertobject-invalid-place-parameter-value
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("insertobject-invalid-place-parameter-value", model);
    let nextElement = contextElement.nextSibling;
    if (model.schema.isInline(contextElement)) {
        writer.setSelection(contextElement, "after");
        return;
    }
    if (!(nextElement && model.schema.checkChild(nextElement, "$text")) && model.schema.checkChild(contextElement.parent, "paragraph")) {
        nextElement = writer.createElement("paragraph");
        model.schema.setAllowedAttributes(nextElement, paragraphAttributes, writer);
        model.insertContent(nextElement, writer.createPositionAfter(contextElement));
    }
    if (nextElement) writer.setSelection(nextElement, 0);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/utils/modifyselection
*/ const $b9b9f2bdf9c6137f$var$wordBoundaryCharacters = " ,.?!:;\"-()";
/**
* Modifies the selection. Currently, the supported modifications are:
*
* * Extending. The selection focus is moved in the specified `options.direction` with a step specified in `options.unit`.
* Possible values for `unit` are:
*  * `'character'` (default) - moves selection by one user-perceived character. In most cases this means moving by one
*  character in `String` sense. However, unicode also defines "combing marks". These are special symbols, that combines
*  with a symbol before it ("base character") to create one user-perceived character. For example, `q̣̇` is a normal
*  letter `q` with two "combining marks": upper dot (`Ux0307`) and lower dot (`Ux0323`). For most actions, i.e. extending
*  selection by one position, it is correct to include both "base character" and all of it's "combining marks". That is
*  why `'character'` value is most natural and common method of modifying selection.
*  * `'codePoint'` - moves selection by one unicode code point. In contrary to, `'character'` unit, this will insert
*  selection between "base character" and "combining mark", because "combining marks" have their own unicode code points.
*  However, for technical reasons, unicode code points with values above `UxFFFF` are represented in native `String` by
*  two characters, called "surrogate pairs". Halves of "surrogate pairs" have a meaning only when placed next to each other.
*  For example `𨭎` is represented in `String` by `\uD862\uDF4E`. Both `\uD862` and `\uDF4E` do not have any meaning
*  outside the pair (are rendered as ? when alone). Position between them would be incorrect. In this case, selection
*  extension will include whole "surrogate pair".
*  * `'word'` - moves selection by a whole word.
*
* **Note:** if you extend a forward selection in a backward direction you will in fact shrink it.
*
* **Note:** Use {@link module:engine/model/model~Model#modifySelection} instead of this function.
* This function is only exposed to be reusable in algorithms
* which change the {@link module:engine/model/model~Model#modifySelection}
* method's behavior.
*
* @param model The model in context of which the selection modification should be performed.
* @param selection The selection to modify.
* @param options.direction The direction in which the selection should be modified. Default 'forward'.
* @param options.unit The unit by which selection should be modified. Default 'character'.
* @param options.treatEmojiAsSingleUnit Whether multi-characer emoji sequences should be handled as single unit.
* @internal
*/ function $b9b9f2bdf9c6137f$export$53c2050837f17461(model, selection, options = {}) {
    const schema = model.schema;
    const isForward = options.direction != "backward";
    const unit = options.unit ? options.unit : "character";
    const treatEmojiAsSingleUnit = !!options.treatEmojiAsSingleUnit;
    const focus = selection.focus;
    const walker = new $b9b9f2bdf9c6137f$export$c24047420d7ab789({
        boundaries: $b9b9f2bdf9c6137f$var$getSearchRange(focus, isForward),
        singleCharacters: true,
        direction: isForward ? "forward" : "backward"
    });
    const data = {
        walker: walker,
        schema: schema,
        isForward: isForward,
        unit: unit,
        treatEmojiAsSingleUnit: treatEmojiAsSingleUnit
    };
    let next;
    while(next = walker.next()){
        if (next.done) return;
        const position = $b9b9f2bdf9c6137f$var$tryExtendingTo(data, next.value);
        if (position) {
            if (selection instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) model.change((writer)=>{
                writer.setSelectionFocus(position);
            });
            else selection.setFocus(position);
            return;
        }
    }
}
/**
* Checks whether the selection can be extended to the the walker's next value (next position).
*/ function $b9b9f2bdf9c6137f$var$tryExtendingTo(data, value) {
    const { isForward: isForward, walker: walker, unit: unit, schema: schema, treatEmojiAsSingleUnit: treatEmojiAsSingleUnit } = data;
    const { type: type, item: item, nextPosition: nextPosition } = value;
    if (type == "text") {
        if (data.unit === "word") return $b9b9f2bdf9c6137f$var$getCorrectWordBreakPosition(walker, isForward);
        return $b9b9f2bdf9c6137f$var$getCorrectPosition(walker, unit, treatEmojiAsSingleUnit);
    }
    if (type == (isForward ? "elementStart" : "elementEnd")) {
        if (schema.isSelectable(item)) return $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(item, isForward ? "after" : "before");
        if (schema.checkChild(nextPosition, "$text")) return nextPosition;
    } else {
        if (schema.isLimit(item)) {
            walker.skip(()=>true);
            return;
        }
        if (schema.checkChild(nextPosition, "$text")) return nextPosition;
    }
}
/**
* Finds a correct position by walking in a text node and checking whether selection can be extended to given position
* or should be extended further.
*/ function $b9b9f2bdf9c6137f$var$getCorrectPosition(walker, unit, treatEmojiAsSingleUnit) {
    const textNode = walker.position.textNode;
    if (textNode) {
        const data = textNode.data;
        let offset = walker.position.offset - textNode.startOffset;
        while((0, $c7bc2cb7e2db0227$export$910da4ddfe197244)(data, offset) || unit == "character" && (0, $c7bc2cb7e2db0227$export$1a90459935e74227)(data, offset) || treatEmojiAsSingleUnit && (0, $c7bc2cb7e2db0227$export$615ed2a6f3bf1115)(data, offset)){
            walker.next();
            offset = walker.position.offset - textNode.startOffset;
        }
    }
    return walker.position;
}
/**
* Finds a correct position of a word break by walking in a text node and checking whether selection can be extended to given position
* or should be extended further.
*/ function $b9b9f2bdf9c6137f$var$getCorrectWordBreakPosition(walker, isForward) {
    let textNode = walker.position.textNode;
    if (!textNode) textNode = isForward ? walker.position.nodeAfter : walker.position.nodeBefore;
    while(textNode && textNode.is("$text")){
        const offset = walker.position.offset - textNode.startOffset;
        if ($b9b9f2bdf9c6137f$var$isAtNodeBoundary(textNode, offset, isForward)) textNode = isForward ? walker.position.nodeAfter : walker.position.nodeBefore;
        else if ($b9b9f2bdf9c6137f$var$isAtWordBoundary(textNode.data, offset, isForward)) break;
        else walker.next();
    }
    return walker.position;
}
function $b9b9f2bdf9c6137f$var$getSearchRange(start, isForward) {
    const root = start.root;
    const searchEnd = $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(root, isForward ? "end" : 0);
    if (isForward) return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, searchEnd);
    else return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(searchEnd, start);
}
/**
* Checks if selection is on word boundary.
*/ function $b9b9f2bdf9c6137f$var$isAtWordBoundary(data, offset, isForward) {
    const offsetToCheck = offset + (isForward ? 0 : -1);
    return $b9b9f2bdf9c6137f$var$wordBoundaryCharacters.includes(data.charAt(offsetToCheck));
}
/**
* Checks if selection is on node boundary.
*/ function $b9b9f2bdf9c6137f$var$isAtNodeBoundary(textNode, offset, isForward) {
    return offset === (isForward ? textNode.offsetSize : 0);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/model/model
*/ const $b9b9f2bdf9c6137f$var$ModelBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Editor's data model. Read about the model in the
* {@glink framework/architecture/editing-engine engine architecture} guide.
*/ var $b9b9f2bdf9c6137f$export$a1edc412be3e1841 = class extends $b9b9f2bdf9c6137f$var$ModelBase {
    /**
	* Model's marker collection.
	*/ markers;
    /**
	* Model's document.
	*/ document;
    /**
	* Model's schema.
	*/ schema;
    /**
	* Stores all configurations specific to editor instance.
	*
	* @internal
	*/ _config;
    /**
	* All callbacks added by {@link module:engine/model/model~Model#change} or
	* {@link module:engine/model/model~Model#enqueueChange} methods waiting to be executed.
	*/ _pendingChanges;
    /**
	* The last created and currently used writer instance.
	*/ _currentWriter;
    constructor(config){
        super();
        this.markers = new $b9b9f2bdf9c6137f$export$6e315ea0a0a1025();
        this.document = new $b9b9f2bdf9c6137f$export$58ff3996fb255ace(this);
        this.schema = new $b9b9f2bdf9c6137f$export$1f5e8c4238f1bbae();
        this._config = config;
        this._pendingChanges = [];
        this._currentWriter = null;
        [
            "deleteContent",
            "modifySelection",
            "getSelectedContent",
            "applyOperation"
        ].forEach((methodName)=>this.decorate(methodName));
        this.on("applyOperation", (evt, args)=>{
            args[0]._validate();
        }, {
            priority: "highest"
        });
        this.schema.register("$root", {
            isLimit: true
        });
        this.schema.register("$inlineRoot", {
            allowContentOf: "$block",
            allowAttributesOf: "$root",
            isLimit: true
        });
        this.schema.register("$container", {
            allowIn: [
                "$root",
                "$container"
            ]
        });
        this.schema.register("$block", {
            allowIn: [
                "$root",
                "$container"
            ],
            isBlock: true
        });
        this.schema.register("$blockObject", {
            allowWhere: "$block",
            isBlock: true,
            isObject: true
        });
        this.schema.register("$inlineObject", {
            allowWhere: "$text",
            allowAttributesOf: "$text",
            isInline: true,
            isObject: true
        });
        this.schema.register("$text", {
            allowIn: "$block",
            isInline: true,
            isContent: true
        });
        this.schema.register("$clipboardHolder", {
            allowContentOf: [
                "$root",
                "$inlineRoot"
            ],
            allowChildren: "$text",
            isLimit: true
        });
        this.schema.register("$documentFragment", {
            allowContentOf: [
                "$root",
                "$inlineRoot"
            ],
            allowChildren: "$text",
            isLimit: true
        });
        this.schema.register("$marker");
        this.schema.addChildCheck(()=>true, "$marker");
        $b9b9f2bdf9c6137f$export$62456067b2c6c63d(this);
        this.document.registerPostFixer($b9b9f2bdf9c6137f$export$5245497caaaa7808);
        this.on("insertContent", (evt, [content, selectable])=>{
            evt.return = $b9b9f2bdf9c6137f$export$afd9f74aae45a476(this, content, selectable);
        });
        this.on("insertObject", (evt, [element, selection, options])=>{
            evt.return = $b9b9f2bdf9c6137f$export$aea1c5f155d8e519(this, element, selection, options);
        });
        this.on("canEditAt", (evt)=>{
            const canEditAt = !this.document.isReadOnly;
            evt.return = canEditAt;
            if (!canEditAt) evt.stop();
        });
    }
    /**
	* The `change()` method is the primary way of changing the model. You should use it to modify all document nodes
	* (including detached nodes – i.e. nodes not added to the {@link module:engine/model/model~Model#document model document}),
	* the {@link module:engine/model/document~ModelDocument#selection document's selection}, and
	* {@link module:engine/model/model~Model#markers model markers}.
	*
	* ```ts
	* model.change( writer => {
	* 	writer.insertText( 'foo', paragraph, 'end' );
	* } );
	* ```
	*
	* All changes inside the change block use the same {@link module:engine/model/batch~Batch} so they are combined
	* into a single undo step.
	*
	* ```ts
	* model.change( writer => {
	* 	writer.insertText( 'foo', paragraph, 'end' ); // foo.
	*
	* 	model.change( writer => {
	* 		writer.insertText( 'bar', paragraph, 'end' ); // foobar.
	* 	} );
	*
	* 	writer.insertText( 'bom', paragraph, 'end' ); // foobarbom.
	* } );
	* ```
	*
	* The callback of the `change()` block is executed synchronously.
	*
	* You can also return a value from the change block.
	*
	* ```ts
	* const img = model.change( writer => {
	* 	return writer.createElement( 'img' );
	* } );
	* ```
	*
	* @see #enqueueChange
	* @typeParam TReturn The return type of the provided callback.
	* @param callback Callback function which may modify the model.
	*/ change(callback) {
        try {
            if (this._pendingChanges.length === 0) {
                this._pendingChanges.push({
                    batch: new $b9b9f2bdf9c6137f$export$33b107562567fc47(),
                    callback: callback
                });
                return this._runPendingChanges()[0];
            } else return callback(this._currentWriter);
        } catch (err) {
            (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10).rethrowUnexpectedError(err, this);
        }
    }
    enqueueChange(batchOrType, callback) {
        try {
            if (!batchOrType) batchOrType = new $b9b9f2bdf9c6137f$export$33b107562567fc47();
            else if (typeof batchOrType === "function") {
                callback = batchOrType;
                batchOrType = new $b9b9f2bdf9c6137f$export$33b107562567fc47();
            } else if (!(batchOrType instanceof $b9b9f2bdf9c6137f$export$33b107562567fc47)) batchOrType = new $b9b9f2bdf9c6137f$export$33b107562567fc47(batchOrType);
            this._pendingChanges.push({
                batch: batchOrType,
                callback: callback
            });
            if (this._pendingChanges.length == 1) this._runPendingChanges();
        } catch (err) {
            (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10).rethrowUnexpectedError(err, this);
        }
    }
    /**
	* {@link module:utils/observablemixin~Observable#decorate Decorated} function for applying
	* {@link module:engine/model/operation/operation~Operation operations} to the model.
	*
	* This is a low-level way of changing the model. It is exposed for very specific use cases (like the undo feature).
	* Normally, to modify the model, you will want to use {@link module:engine/model/writer~ModelWriter `Writer`}.
	* See also {@glink framework/architecture/editing-engine#changing-the-model Changing the model} section
	* of the {@glink framework/architecture/editing-engine Editing architecture} guide.
	*
	* @param operation The operation to apply.
	*/ applyOperation(operation) {
        operation._execute();
    }
    /**
	* Inserts content at the position in the editor specified by the selection, as one would expect the paste
	* functionality to work.
	*
	* **Note**: If you want to insert an {@glink framework/deep-dive/schema#object-elements object element}
	* (e.g. a {@link module:widget/utils~toWidget widget}), see {@link #insertObject} instead.
	*
	* This is a high-level method. It takes the {@link #schema schema} into consideration when inserting
	* the content, clears the given selection's content before inserting nodes and moves the selection
	* to its target position at the end of the process.
	* It can split elements, merge them, wrap bare text nodes with paragraphs, etc. &ndash; just like the
	* pasting feature should do.
	*
	* For lower-level methods see {@link module:engine/model/writer~ModelWriter `Writer`}.
	*
	* This method, unlike {@link module:engine/model/writer~ModelWriter `Writer`}'s methods, does not have to be used
	* inside a {@link #change `change()` block}.
	*
	* # Conversion and schema
	*
	* Inserting elements and text nodes into the model is not enough to make CKEditor 5 render that content
	* to the user. CKEditor 5 implements a model-view-controller architecture and what `model.insertContent()` does
	* is only adding nodes to the model. Additionally, you need to define
	* {@glink framework/architecture/editing-engine#conversion converters} between the model and view
	* and define those nodes in the {@glink framework/architecture/editing-engine#schema schema}.
	*
	* So, while this method may seem similar to CKEditor 4 `editor.insertHtml()` (in fact, both methods
	* are used for paste-like content insertion), the CKEditor 5 method cannot be use to insert arbitrary HTML
	* unless converters are defined for all elements and attributes in that HTML.
	*
	* # Examples
	*
	* Using `insertContent()` with a manually created model structure:
	*
	* ```ts
	* // Let's create a document fragment containing such content as:
	* //
	* // <paragraph>foo</paragraph>
	* // <blockQuote>
	* //    <paragraph>bar</paragraph>
	* // </blockQuote>
	* const docFrag = editor.model.change( writer => {
	* 	const p1 = writer.createElement( 'paragraph' );
	* 	const p2 = writer.createElement( 'paragraph' );
	* 	const blockQuote = writer.createElement( 'blockQuote' );
	* 	const docFrag = writer.createDocumentFragment();
	*
	* 	writer.append( p1, docFrag );
	* 	writer.append( blockQuote, docFrag );
	* 	writer.append( p2, blockQuote );
	* 	writer.insertText( 'foo', p1 );
	* 	writer.insertText( 'bar', p2 );
	*
	* 	return docFrag;
	* } );
	*
	* // insertContent() does not have to be used in a change() block. It can, though,
	* // so this code could be moved to the callback defined above.
	* editor.model.insertContent( docFrag );
	* ```
	*
	* Using `insertContent()` with an HTML string converted to a model document fragment (similar to the pasting mechanism):
	*
	* ```ts
	* // You can create your own HtmlDataProcessor instance or use editor.data.processor
	* // if you have not overridden the default one (which is the HtmlDataProcessor instance).
	* const htmlDP = new HtmlDataProcessor( viewDocument );
	*
	* // Convert an HTML string to a view document fragment:
	* const viewFragment = htmlDP.toView( htmlString );
	*
	* // Convert the view document fragment to a model document fragment
	* // in the context of $root. This conversion takes the schema into
	* // account so if, for example, the view document fragment contained a bare text node,
	* // this text node cannot be a child of $root, so it will be automatically
	* // wrapped with a <paragraph>. You can define the context yourself (in the second parameter),
	* // and e.g. convert the content like it would happen in a <paragraph>.
	* // Note: The clipboard feature uses a custom context called $clipboardHolder
	* // which has a loosened schema.
	* const modelFragment = editor.data.toModel( viewFragment );
	*
	* editor.model.insertContent( modelFragment );
	* ```
	*
	* By default this method will use the document selection but it can also be used with a position, range or selection instance.
	*
	* ```ts
	* // Insert text at the current document selection position.
	* editor.model.change( writer => {
	* 	editor.model.insertContent( writer.createText( 'x' ) );
	* } );
	*
	* // Insert text at a given position - the document selection will not be modified.
	* editor.model.change( writer => {
	* 	editor.model.insertContent( writer.createText( 'x' ), doc.getRoot(), 2 );
	*
	* 	// Which is a shorthand for:
	* 	editor.model.insertContent( writer.createText( 'x' ), writer.createPositionAt( doc.getRoot(), 2 ) );
	* } );
	* ```
	*
	* If you want the document selection to be moved to the inserted content, use the
	* {@link module:engine/model/writer~ModelWriter#setSelection `setSelection()`} method of the writer after inserting
	* the content:
	*
	* ```ts
	* editor.model.change( writer => {
	* 	const paragraph = writer.createElement( 'paragraph' );
	*
	* 	// Insert an empty paragraph at the beginning of the root.
	* 	editor.model.insertContent( paragraph, writer.createPositionAt( editor.model.document.getRoot(), 0 ) );
	*
	* 	// Move the document selection to the inserted paragraph.
	* 	writer.setSelection( paragraph, 'in' );
	* } );
	* ```
	*
	* If an instance of the {@link module:engine/model/selection~ModelSelection model selection} is passed as `selectable`,
	* the new content will be inserted at the passed selection (instead of document selection):
	*
	* ```ts
	* editor.model.change( writer => {
	* 	// Create a selection in a paragraph that will be used as a place of insertion.
	* 	const selection = writer.createSelection( paragraph, 'in' );
	*
	* 	// Insert the new text at the created selection.
	* 	editor.model.insertContent( writer.createText( 'x' ), selection );
	*
	* 	// insertContent() modifies the passed selection instance so it can be used to set the document selection.
	* 	// Note: This is not necessary when you passed the document selection to insertContent().
	* 	writer.setSelection( selection );
	* } );
	* ```
	*
	* @fires insertContent
	* @param content The content to insert.
	* @param selectable The selection into which the content should be inserted.
	* If not provided the current model document selection will be used.
	* @param placeOrOffset To be used when a model item was passed as `selectable`.
	* This param defines a position in relation to that item.
	* at the insertion position.
	*/ insertContent(content, selectable, placeOrOffset, ...rest) {
        const selection = $b9b9f2bdf9c6137f$var$normalizeSelectable(selectable, placeOrOffset);
        return this.fire("insertContent", [
            content,
            selection,
            placeOrOffset,
            ...rest
        ]);
    }
    /**
	* Inserts an {@glink framework/deep-dive/schema#object-elements object element} at a specific position in the editor content.
	*
	* This is a high-level API:
	* * It takes the {@link #schema schema} into consideration,
	* * It clears the content of passed `selectable` before inserting,
	* * It can move the selection at the end of the process,
	* * It will copy the selected block's attributes to preserve them upon insertion,
	* * It can split elements or wrap inline objects with paragraphs if they are not allowed in target position,
	* * etc.
	*
	* # Notes
	*
	* * If you want to insert a non-object content, see {@link #insertContent} instead.
	* * For lower-level API, see {@link module:engine/model/writer~ModelWriter `Writer`}.
	* * Unlike {@link module:engine/model/writer~ModelWriter `Writer`}, this method does not have to be used inside
	* a {@link #change `change()` block}.
	* * Inserting object into the model is not enough to make CKEditor 5 render that content to the user.
	* CKEditor 5 implements a model-view-controller architecture and what `model.insertObject()` does
	* is only adding nodes to the model. Additionally, you need to define
	* {@glink framework/architecture/editing-engine#conversion converters} between the model and view
	* and define those nodes in the {@glink framework/architecture/editing-engine#schema schema}.
	*
	* # Examples
	*
	* Use the following code to insert an object at the current selection and keep the selection on the inserted element:
	*
	* ```ts
	* const rawHtmlEmbedElement = writer.createElement( 'rawHtml' );
	*
	* model.insertObject( rawHtmlEmbedElement, null, null, {
	* 	setSelection: 'on'
	* } );
	* ```
	*
	* Use the following code to insert an object at the current selection and nudge the selection after the inserted object:
	*
	* ```ts
	* const pageBreakElement = writer.createElement( 'pageBreak' );
	*
	* model.insertObject( pageBreakElement, null, null, {
	* 	setSelection: 'after'
	* } );
	* ```
	*
	* Use the following code to insert an object at the current selection and avoid splitting the content (non-destructive insertion):
	*
	* ```ts
	* const tableElement = writer.createElement( 'table' );
	*
	* model.insertObject( tableElement, null, null, {
	* 	findOptimalPosition: 'auto'
	* } );
	* ```
	*
	* Use the following code to insert an object at the specific range (also: replace the content of the range):
	*
	* ```ts
	* const tableElement = writer.createElement( 'table' );
	* const range = model.createRangeOn( model.document.getRoot().getChild( 1 ) );
	*
	* model.insertObject( tableElement, range );
	* ```
	*
	* @param element An object to be inserted into the model document.
	* @param selectable A selectable where the content should be inserted. If not specified, the current
	* {@link module:engine/model/document~ModelDocument#selection document selection} will be used instead.
	* @param placeOrOffset Specifies the exact place or offset for the insertion to take place, relative to `selectable`.
	* @param options Additional options.
	* @param options.findOptimalPosition An option that, when set, adjusts the insertion position (relative to
	* `selectable` and `placeOrOffset`) so that the content of `selectable` is not split upon insertion (a.k.a. non-destructive insertion).
	* * When `'auto'`, the algorithm will decide whether to insert the object before or after `selectable` to avoid content splitting.
	* * When `'before'`, the closest position before `selectable` will be used that will not result in content splitting.
	* * When `'after'`, the closest position after `selectable` will be used that will not result in content splitting.
	*
	* Note that this option only works for block objects. Inline objects are inserted into text and do not split blocks.
	* @param options.setSelection An option that, when set, moves the
	* {@link module:engine/model/document~ModelDocument#selection document selection} after inserting the object.
	* * When `'on'`, the document selection will be set on the inserted object.
	* * When `'after'`, the document selection will move to the closest text node after the inserted object. If there is no
	* such text node, a paragraph will be created and the document selection will be moved inside it.
	* at the insertion position.
	*/ insertObject(element, selectable, placeOrOffset, options, ...rest) {
        const selection = $b9b9f2bdf9c6137f$var$normalizeSelectable(selectable, placeOrOffset);
        return this.fire("insertObject", [
            element,
            selection,
            options,
            options,
            ...rest
        ]);
    }
    /**
	* Deletes content of the selection and merge siblings. The resulting selection is always collapsed.
	*
	* **Note:** For the sake of predictability, the resulting selection should always be collapsed.
	* In cases where a feature wants to modify deleting behavior so selection isn't collapsed
	* (e.g. a table feature may want to keep row selection after pressing <kbd>Backspace</kbd>),
	* then that behavior should be implemented in the view's listener. At the same time, the table feature
	* will need to modify this method's behavior too, e.g. to "delete contents and then collapse
	* the selection inside the last selected cell" or "delete the row and collapse selection somewhere near".
	* That needs to be done in order to ensure that other features which use `deleteContent()` will work well with tables.
	*
	* @fires deleteContent
	* @param selection Selection of which the content should be deleted.
	* @param options.leaveUnmerged Whether to merge elements after removing the content of the selection.
	*
	* For example `<heading1>x[x</heading1><paragraph>y]y</paragraph>` will become:
	*
	* * `<heading1>x^y</heading1>` with the option disabled (`leaveUnmerged == false`)
	* * `<heading1>x^</heading1><paragraph>y</paragraph>` with enabled (`leaveUnmerged == true`).
	*
	* Note: {@link module:engine/model/schema~ModelSchema#isObject object} and {@link module:engine/model/schema~ModelSchema#isLimit limit}
	* elements will not be merged.
	*
	* @param options.doNotResetEntireContent Whether to skip replacing the entire content with a
	* paragraph when the entire content was selected.
	*
	* For example `<heading1>[x</heading1><paragraph>y]</paragraph>` will become:
	*
	* * `<paragraph>^</paragraph>` with the option disabled (`doNotResetEntireContent == false`)
	* * `<heading1>^</heading1>` with enabled (`doNotResetEntireContent == true`)
	*
	* @param options.doNotAutoparagraph Whether to create a paragraph if after content deletion selection is moved
	* to a place where text cannot be inserted.
	*
	* For example `<paragraph>x</paragraph>[<imageBlock src="foo.jpg"></imageBlock>]` will become:
	*
	* * `<paragraph>x</paragraph><paragraph>[]</paragraph>` with the option disabled (`doNotAutoparagraph == false`)
	* * `<paragraph>x[]</paragraph>` with the option enabled (`doNotAutoparagraph == true`).
	*
	* **Note:** if there is no valid position for the selection, the paragraph will always be created:
	*
	* `[<imageBlock src="foo.jpg"></imageBlock>]` -> `<paragraph>[]</paragraph>`.
	*
	* @param options.direction The direction in which the content is being consumed.
	* Deleting backward corresponds to using the <kbd>Backspace</kbd> key, while deleting content forward corresponds to
	* the <kbd>Shift</kbd>+<kbd>Backspace</kbd> keystroke.
	*/ deleteContent(selection, options) {
        $b9b9f2bdf9c6137f$export$1602924c71efd22f(this, selection, options);
    }
    /**
	* Modifies the selection. Currently, the supported modifications are:
	*
	* * Extending. The selection focus is moved in the specified `options.direction` with a step specified in `options.unit`.
	* Possible values for `unit` are:
	*  * `'character'` (default) - moves selection by one user-perceived character. In most cases this means moving by one
	*  character in `String` sense. However, unicode also defines "combing marks". These are special symbols, that combines
	*  with a symbol before it ("base character") to create one user-perceived character. For example, `q̣̇` is a normal
	*  letter `q` with two "combining marks": upper dot (`Ux0307`) and lower dot (`Ux0323`). For most actions, i.e. extending
	*  selection by one position, it is correct to include both "base character" and all of it's "combining marks". That is
	*  why `'character'` value is most natural and common method of modifying selection.
	*  * `'codePoint'` - moves selection by one unicode code point. In contrary to, `'character'` unit, this will insert
	*  selection between "base character" and "combining mark", because "combining marks" have their own unicode code points.
	*  However, for technical reasons, unicode code points with values above `UxFFFF` are represented in native `String` by
	*  two characters, called "surrogate pairs". Halves of "surrogate pairs" have a meaning only when placed next to each other.
	*  For example `𨭎` is represented in `String` by `\uD862\uDF4E`. Both `\uD862` and `\uDF4E` do not have any meaning
	*  outside the pair (are rendered as ? when alone). Position between them would be incorrect. In this case, selection
	*  extension will include whole "surrogate pair".
	*  * `'word'` - moves selection by a whole word.
	*
	* **Note:** if you extend a forward selection in a backward direction you will in fact shrink it.
	*
	* @fires modifySelection
	* @param selection The selection to modify.
	* @param options.direction The direction in which the selection should be modified.
	* @param options.unit The unit by which selection should be modified.
	* @param options.treatEmojiAsSingleUnit Whether multi-characer emoji sequences should be handled as single unit.
	*/ modifySelection(selection, options) {
        $b9b9f2bdf9c6137f$export$53c2050837f17461(this, selection, options);
    }
    /**
	* Gets a clone of the selected content.
	*
	* For example, for the following selection:
	*
	* ```html
	* <paragraph>x</paragraph>
	* <blockQuote>
	* 	<paragraph>y</paragraph>
	* 	<heading1>fir[st</heading1>
	* </blockQuote>
	* <paragraph>se]cond</paragraph>
	* <paragraph>z</paragraph>
	* ```
	*
	* It will return a document fragment with such a content:
	*
	* ```html
	* <blockQuote>
	* 	<heading1>st</heading1>
	* </blockQuote>
	* <paragraph>se</paragraph>
	* ```
	*
	* @fires getSelectedContent
	* @param selection The selection of which content will be returned.
	*/ getSelectedContent(selection) {
        return $b9b9f2bdf9c6137f$export$805513d154ea59fd(this, selection);
    }
    /**
	* Checks whether given `subject` has any meaningful content.
	*
	* Meaningful content is:
	*
	* * any text node (`options.ignoreWhitespaces` allows controlling whether this text node must also contain
	* any non-whitespace characters),
	* * or any {@link module:engine/model/schema~ModelSchema#isContent content element},
	* * or any {@link module:engine/model/markercollection~Marker marker} which
	* {@link module:engine/model/markercollection~Marker#_affectsData affects data}.
	*
	* This means that a range containing an empty `<paragraph></paragraph>` is not considered to have a meaningful content.
	* However, a range containing an `<imageBlock></imageBlock>` (which would normally be marked in the schema as an object element)
	* is considered non-empty.
	*
	* @param subject Subject to check if includes meaningful content. Could be a model range, an element, a document fragment, or a
	* selection.
	* @param options.ignoreWhitespaces Whether text node with whitespaces only should be considered empty.
	* @param options.ignoreMarkers Whether markers should be ignored.
	*/ hasContent(subject, options = {}) {
        let ranges;
        if (subject.is("selection")) ranges = Array.from(subject.getRanges());
        else if (subject.is("range")) ranges = [
            subject
        ];
        else ranges = [
            $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(subject)
        ];
        for (const range of ranges)if (this._rangeHasContent(range, options)) return true;
        return false;
    }
    /**
	* Checks whether given range has any meaningful content.
	*
	* Helper method for {@link #hasContent}.
	*/ _rangeHasContent(range, options) {
        if (range.isCollapsed) return false;
        const { ignoreWhitespaces: ignoreWhitespaces = false, ignoreMarkers: ignoreMarkers = false } = options;
        if (!ignoreMarkers) {
            for (const intersectingMarker of this.markers.getMarkersIntersectingRange(range))if (intersectingMarker.affectsData) return true;
        }
        for (const item of range.getItems())if (this.schema.isContent(item)) {
            if (item.is("$textProxy")) {
                if (!ignoreWhitespaces) return true;
                else if (item.data.search(/\S/) !== -1) return true;
            } else return true;
        }
        return false;
    }
    /**
	* Check whether given selectable is at a place in the model where it can be edited (returns `true`) or not (returns `false`).
	*
	* Should be used instead of {@link module:core/editor/editor~Editor#isReadOnly} to check whether a user action can happen at
	* given selectable. It may be decorated and used differently in different environment (e.g. multi-root editor can disable
	* a particular root).
	*
	* This method is decorated. Although this method accepts any parameter of `Selectable` type, the
	* {@link ~Model#event:canEditAt `canEditAt` event} is fired with `selectable` normalized to an instance of
	* {@link module:engine/model/selection~ModelSelection} or {@link module:engine/model/documentselection~ModelDocumentSelection}
	*
	* @fires canEditAt
	*/ canEditAt(selectable) {
        const selection = $b9b9f2bdf9c6137f$var$normalizeSelectable(selectable);
        return this.fire("canEditAt", [
            selection
        ]);
    }
    /**
	* Creates a position from the given root and path in that root.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createPositionFromPath `Writer#createPositionFromPath()`}.
	*
	* @param root Root of the position.
	* @param path Position path. See {@link module:engine/model/position~ModelPosition#path}.
	* @param stickiness Position stickiness. See {@link module:engine/model/position~ModelPositionStickiness}.
	*/ createPositionFromPath(root, path, stickiness) {
        return new $b9b9f2bdf9c6137f$export$86023cc9eabef192(root, path, stickiness);
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/model/position~ModelPosition position},
	* * a parent element and offset in that element,
	* * a parent element and `'end'` (the position will be set at the end of that element),
	* * a {@link module:engine/model/item~ModelItem model item} and `'before'` or `'after'`
	* (the position will be set before or after the given model item).
	*
	* This method is a shortcut to other factory methods such as:
	*
	* * {@link module:engine/model/model~Model#createPositionBefore `createPositionBefore()`},
	* * {@link module:engine/model/model~Model#createPositionAfter `createPositionAfter()`}.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createPositionAt `Writer#createPositionAt()`},
	*
	* @param itemOrPosition
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~ModelItem model item}.
	*/ createPositionAt(itemOrPosition, offset) {
        return $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAt(itemOrPosition, offset);
    }
    /**
	* Creates a new position after the given {@link module:engine/model/item~ModelItem model item}.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createPositionAfter `Writer#createPositionAfter()`}.
	*
	* @param item Item after which the position should be placed.
	*/ createPositionAfter(item) {
        return $b9b9f2bdf9c6137f$export$86023cc9eabef192._createAfter(item);
    }
    /**
	* Creates a new position before the given {@link module:engine/model/item~ModelItem model item}.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createPositionBefore `Writer#createPositionBefore()`}.
	*
	* @param item Item before which the position should be placed.
	*/ createPositionBefore(item) {
        return $b9b9f2bdf9c6137f$export$86023cc9eabef192._createBefore(item);
    }
    /**
	* Creates a range spanning from the `start` position to the `end` position.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createRange `Writer#createRange()`}:
	*
	* ```ts
	* model.change( writer => {
	* 	const range = writer.createRange( start, end );
	* } );
	* ```
	*
	* @param start Start position.
	* @param end End position. If not set, the range will be collapsed to the `start` position.
	*/ createRange(start, end) {
        return new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, end);
    }
    /**
	* Creates a range inside the given element which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* Note: This method is also available as
	* {@link module:engine/model/writer~ModelWriter#createRangeIn `Writer#createRangeIn()`}:
	*
	* ```ts
	* model.change( writer => {
	* 	const range = writer.createRangeIn( paragraph );
	* } );
	* ```
	*
	* @param element Element which is a parent for the range.
	*/ createRangeIn(element) {
        return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createIn(element);
    }
    /**
	* Creates a range that starts before the given {@link module:engine/model/item~ModelItem model item} and ends after it.
	*
	* Note: This method is also available on `writer` instance as
	* {@link module:engine/model/writer~ModelWriter#createRangeOn `Writer.createRangeOn()`}:
	*
	* ```ts
	* model.change( writer => {
	* 	const range = writer.createRangeOn( paragraph );
	* } );
	* ```
	*
	* @param item
	*/ createRangeOn(item) {
        return $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(item);
    }
    createSelection(...args) {
        return new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(...args);
    }
    /**
	* Creates a {@link module:engine/model/batch~Batch} instance.
	*
	* **Note:** In most cases creating a batch instance is not necessary as they are created when using:
	*
	* * {@link #change `change()`},
	* * {@link #enqueueChange `enqueueChange()`}.
	*
	* @param type {@link module:engine/model/batch~Batch#constructor The type} of the batch.
	*/ createBatch(type) {
        return new $b9b9f2bdf9c6137f$export$33b107562567fc47(type);
    }
    /**
	* Creates an operation instance from a JSON object (parsed JSON string).
	*
	* This is an alias for {@link module:engine/model/operation/operationfactory~OperationFactory.fromJSON `OperationFactory.fromJSON()`}.
	*
	* @param json Deserialized JSON object.
	*/ createOperationFromJSON(json) {
        return $b9b9f2bdf9c6137f$export$3420ec38c4e386fa.fromJSON(json, this.document);
    }
    /**
	* Removes all events listeners set by model instance and destroys {@link module:engine/model/document~ModelDocument}.
	*/ destroy() {
        this.document.destroy();
        this.markers.destroy();
        this.stopListening();
    }
    /**
	* Common part of {@link module:engine/model/model~Model#change} and {@link module:engine/model/model~Model#enqueueChange}
	* which calls callbacks and returns array of values returned by these callbacks.
	*/ _runPendingChanges() {
        const ret = [];
        this.fire("_beforeChanges");
        try {
            while(this._pendingChanges.length){
                const currentBatch = this._pendingChanges[0].batch;
                this._currentWriter = new $b9b9f2bdf9c6137f$export$35468caec0799533(this, currentBatch);
                const callbackReturnValue = this._pendingChanges[0].callback(this._currentWriter);
                ret.push(callbackReturnValue);
                this.document._handleChangeBlock(this._currentWriter);
                this._pendingChanges.shift();
                this._currentWriter = null;
            }
        } finally{
            this._pendingChanges.length = 0;
            this._currentWriter = null;
            this.fire("_afterChanges");
        }
        return ret;
    }
};
/**
* Normalizes a selectable to a Selection or ModelDocumentSelection.
*/ function $b9b9f2bdf9c6137f$var$normalizeSelectable(selectable, placeOrOffset) {
    if (!selectable) return;
    if (selectable instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 || selectable instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) return selectable;
    if (selectable instanceof $b9b9f2bdf9c6137f$export$f15b179a1cc9e2bb) {
        if (placeOrOffset || placeOrOffset === 0) return new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectable, placeOrOffset);
        else if (selectable.is("rootElement")) return new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectable, "in");
        else return new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectable, "on");
    }
    return new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectable);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/clickobserver
*/ /**
* {@link module:engine/view/document~ViewDocument#event:click Click} event observer.
*
* Note that this observer is not available by default. To make it available it needs to be added to
* {@link module:engine/view/view~EditingView view controller} by a {@link module:engine/view/view~EditingView#addObserver} method.
*/ var $b9b9f2bdf9c6137f$export$2386d691512b3680 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = "click";
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/mouseobserver
*/ /**
* Mouse events observer.
*
* Note that this observer is not available by default. To make it available it needs to be added to
* {@link module:engine/view/view~EditingView} by {@link module:engine/view/view~EditingView#addObserver} method.
*/ var $b9b9f2bdf9c6137f$export$7bb344c59ad5b029 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = [
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/touchobserver
*/ /**
* Touch events observer.
*
* Note that this observer is not available by default. To make it available it needs to be added to
* {@link module:engine/view/view~EditingView} by {@link module:engine/view/view~EditingView#addObserver} method.
*/ var $b9b9f2bdf9c6137f$export$dc50353e92fd1e05 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/observer/pointerobserver
*/ /**
* Pointer events observer.
*
* Note that this observer is not available by default. To make it available it needs to be added to
* {@link module:engine/view/view~EditingView} by {@link module:engine/view/view~EditingView#addObserver} method.
*/ var $b9b9f2bdf9c6137f$export$6b46599a2e720b2 = class extends $b9b9f2bdf9c6137f$export$fc1db128570de841 {
    /**
	* @inheritDoc
	*/ domEventType = [
        "pointerdown",
        "pointerup",
        "pointermove"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/upcastwriter
*/ /**
* View upcast writer. It provides a set of methods used to manipulate non-semantic view trees.
*
* It should be used only while working on a non-semantic view
* (e.g. a view created from HTML string on paste).
* To manipulate a view which was or is being downcasted from the the model use the
* {@link module:engine/view/downcastwriter~ViewDowncastWriter downcast writer}.
*
* Read more about changing the view in the {@glink framework/architecture/editing-engine#changing-the-view Changing the view}
* section of the {@glink framework/architecture/editing-engine Editing engine architecture} guide.
*
* Unlike `ViewDowncastWriter`, which is available in the {@link module:engine/view/view~EditingView#change `View#change()`} block,
* `ViewUpcastWriter` can be created wherever you need it:
*
* ```ts
* const writer = new ViewUpcastWriter( viewDocument );
* const text = writer.createText( 'foo!' );
*
* writer.appendChild( text, someViewElement );
* ```
*/ var $b9b9f2bdf9c6137f$export$562b90ad4b8bb065 = class {
    /**
	* The view document instance in which this upcast writer operates.
	*/ document;
    /**
	* @param document The view document instance in which this upcast writer operates.
	*/ constructor(document1){
        this.document = document1;
    }
    /**
	* Creates a new {@link module:engine/view/documentfragment~ViewDocumentFragment} instance.
	*
	* @param children A list of nodes to be inserted into the created document fragment.
	* @returns The created document fragment.
	*/ createDocumentFragment(children) {
        return new $b9b9f2bdf9c6137f$export$574fd53611480ec7(this.document, children);
    }
    /**
	* Creates a new {@link module:engine/view/element~ViewElement} instance.
	*
	* Attributes can be passed in various formats:
	*
	* ```ts
	* upcastWriter.createElement( 'div', { class: 'editor', contentEditable: 'true' } ); // object
	* upcastWriter.createElement( 'div', [ [ 'class', 'editor' ], [ 'contentEditable', 'true' ] ] ); // map-like iterator
	* upcastWriter.createElement( 'div', mapOfAttributes ); // map
	* ```
	*
	* @param name Node name.
	* @param attrs Collection of attributes.
	* @param children A list of nodes to be inserted into created element.
	* @returns Created element.
	*/ createElement(name, attrs, children) {
        return new $b9b9f2bdf9c6137f$export$6a9b2964be74ea54(this.document, name, attrs, children);
    }
    /**
	* Creates a new {@link module:engine/view/text~ViewText} instance.
	*
	* @param data The text's data.
	* @returns The created text node.
	*/ createText(data) {
        return new $b9b9f2bdf9c6137f$export$1f9d53a26119da3d(this.document, data);
    }
    /**
	* Clones the provided element.
	*
	* @see module:engine/view/element~ViewElement#_clone
	* @param element Element to be cloned.
	* @param deep If set to `true` clones element and all its children recursively. When set to `false`,
	* element will be cloned without any children.
	* @returns Clone of this element.
	*/ clone(element, deep = false) {
        return element._clone(deep);
    }
    /**
	* Appends a child node or a list of child nodes at the end of this node
	* and sets the parent of these nodes to this element.
	*
	* @see module:engine/view/element~ViewElement#_appendChild
	* @param items Items to be inserted.
	* @param element Element to which items will be appended.
	* @returns Number of appended nodes.
	*/ appendChild(items, element) {
        return element._appendChild(items);
    }
    /**
	* Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
	* this element.
	*
	* @see module:engine/view/element~ViewElement#_insertChild
	* @param index Offset at which nodes should be inserted.
	* @param items Items to be inserted.
	* @param element Element to which items will be inserted.
	* @returns Number of inserted nodes.
	*/ insertChild(index, items, element) {
        return element._insertChild(index, items);
    }
    /**
	* Removes the given number of child nodes starting at the given index and set the parent of these nodes to `null`.
	*
	* @see module:engine/view/element~ViewElement#_removeChildren
	* @param index Offset from which nodes will be removed.
	* @param howMany Number of nodes to remove.
	* @param element Element which children will be removed.
	* @returns The array containing removed nodes.
	*/ removeChildren(index, howMany, element) {
        return element._removeChildren(index, howMany);
    }
    /**
	* Removes given element from the view structure. Will not have effect on detached elements.
	*
	* @param element Element which will be removed.
	* @returns The array containing removed nodes.
	*/ remove(element) {
        const parent = element.parent;
        if (parent) return this.removeChildren(parent.getChildIndex(element), 1, parent);
        return [];
    }
    /**
	* Replaces given element with the new one in the view structure. Will not have effect on detached elements.
	*
	* @param oldElement Element which will be replaced.
	* @param newElement Element which will be inserted in the place of the old element.
	* @returns Whether old element was successfully replaced.
	*/ replace(oldElement, newElement) {
        const parent = oldElement.parent;
        if (parent) {
            const index = parent.getChildIndex(oldElement);
            this.removeChildren(index, 1, parent);
            this.insertChild(index, newElement, parent);
            return true;
        }
        return false;
    }
    /**
	* Removes given element from view structure and places its children in its position.
	* It does nothing if element has no parent.
	*
	* @param element Element to unwrap.
	*/ unwrapElement(element) {
        const parent = element.parent;
        if (parent) {
            const index = parent.getChildIndex(element);
            this.remove(element);
            this.insertChild(index, element.getChildren(), parent);
        }
    }
    /**
	* Renames element by creating a copy of a given element but with its name changed and then moving contents of the
	* old element to the new one.
	*
	* Since this function creates a new element and removes the given one, the new element is returned to keep reference.
	*
	* @param newName New element name.
	* @param  element Element to be renamed.
	* @returns New element or null if the old element was not replaced (happens for detached elements).
	*/ rename(newName, element) {
        const newElement = new $b9b9f2bdf9c6137f$export$6a9b2964be74ea54(this.document, newName, element.getAttributes(), element.getChildren());
        return this.replace(element, newElement) ? newElement : null;
    }
    /**
	* Adds or overwrites element's attribute with a specified key and value.
	*
	* ```ts
	* writer.setAttribute( 'href', 'http://ckeditor.com', linkElement );
	* ```
	*
	* @see module:engine/view/element~ViewElement#_setAttribute
	* @param key Attribute key.
	* @param value Attribute value.
	* @param element Element for which attribute will be set.
	*/ setAttribute(key, value, element) {
        element._setAttribute(key, value);
    }
    /**
	* Removes attribute from the element.
	*
	* ```ts
	* writer.removeAttribute( 'href', linkElement );
	* ```
	*
	* @see module:engine/view/element~ViewElement#_removeAttribute
	* @param key Attribute key.
	* @param element Element from which attribute will be removed.
	*/ removeAttribute(key, element) {
        element._removeAttribute(key);
    }
    /**
	* Adds specified class to the element.
	*
	* ```ts
	* writer.addClass( 'foo', linkElement );
	* writer.addClass( [ 'foo', 'bar' ], linkElement );
	* ```
	*
	* @see module:engine/view/element~ViewElement#_addClass
	* @param className Single class name or array of class names which will be added.
	* @param element Element for which class will be added.
	*/ addClass(className, element) {
        element._addClass(className);
    }
    /**
	* Removes specified class from the element.
	*
	* ```ts
	* writer.removeClass( 'foo', linkElement );
	* writer.removeClass( [ 'foo', 'bar' ], linkElement );
	* ```
	*
	* @see module:engine/view/element~ViewElement#_removeClass
	* @param className Single class name or array of class names which will be removed.
	* @param element Element from which class will be removed.
	*/ removeClass(className, element) {
        element._removeClass(className);
    }
    setStyle(property, valueOrElement, element) {
        if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(property) && element === void 0) valueOrElement._setStyle(property);
        else element._setStyle(property, valueOrElement);
    }
    /**
	* Removes specified style from the element.
	*
	* ```ts
	* writer.removeStyle( 'color', element );  // Removes 'color' style.
	* writer.removeStyle( [ 'color', 'border-top' ], element ); // Removes both 'color' and 'border-top' styles.
	* ```
	*
	* **Note**: This method can work with normalized style names if
	* {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
	* See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
	*
	* @see module:engine/view/element~ViewElement#_removeStyle
	* @param property Style property name or names to be removed.
	* @param element Element from which style will be removed.
	*/ removeStyle(property, element) {
        element._removeStyle(property);
    }
    /**
	* Sets a custom property on element. Unlike attributes, custom properties are not rendered to the DOM,
	* so they can be used to add special data to elements.
	*
	* @see module:engine/view/element~ViewElement#_setCustomProperty
	* @param key Custom property name/key.
	* @param value Custom property value to be stored.
	* @param element Element for which custom property will be set.
	*/ setCustomProperty(key, value, element) {
        element._setCustomProperty(key, value);
    }
    /**
	* Removes a custom property stored under the given key.
	*
	* @see module:engine/view/element~ViewElement#_removeCustomProperty
	* @param key Name/key of the custom property to be removed.
	* @param element Element from which the custom property will be removed.
	* @returns Returns true if property was removed.
	*/ removeCustomProperty(key, element) {
        return element._removeCustomProperty(key);
    }
    /**
	* Creates position at the given location. The location can be specified as:
	*
	* * a {@link module:engine/view/position~ViewPosition position},
	* * parent element and offset (offset defaults to `0`),
	* * parent element and `'end'` (sets position at the end of that element),
	* * {@link module:engine/view/item~ViewItem view item} and `'before'` or `'after'` (sets position before or after given view item).
	*
	* This method is a shortcut to other constructors such as:
	*
	* * {@link #createPositionBefore},
	* * {@link #createPositionAfter},
	*
	* @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~ViewItem view item}.
	*/ createPositionAt(itemOrPosition, offset) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAt(itemOrPosition, offset);
    }
    /**
	* Creates a new position after given view item.
	*
	* @param item View item after which the position should be located.
	*/ createPositionAfter(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createAfter(item);
    }
    /**
	* Creates a new position before given view item.
	*
	* @param item View item before which the position should be located.
	*/ createPositionBefore(item) {
        return $b9b9f2bdf9c6137f$export$7534acacc32db851._createBefore(item);
    }
    /**
	* Creates a range spanning from `start` position to `end` position.
	*
	* **Note:** This factory method creates it's own {@link module:engine/view/position~ViewPosition} instances basing on passed values.
	*
	* @param start Start position.
	* @param end End position. If not set, range will be collapsed at `start` position.
	*/ createRange(start, end) {
        return new $b9b9f2bdf9c6137f$export$829eb746b222877(start, end);
    }
    /**
	* Creates a range that starts before given {@link module:engine/view/item~ViewItem view item} and ends after it.
	*/ createRangeOn(item) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createOn(item);
    }
    /**
	* Creates a range inside an {@link module:engine/view/element~ViewElement element} which starts before the first child of
	* that element and ends after the last child of that element.
	*
	* @param element Element which is a parent for the range.
	*/ createRangeIn(element) {
        return $b9b9f2bdf9c6137f$export$829eb746b222877._createIn(element);
    }
    createSelection(...args) {
        return new $b9b9f2bdf9c6137f$export$c0bd8b7bd721d71e(...args);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $b9b9f2bdf9c6137f$var$HEX_COLOR_REGEXP = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const $b9b9f2bdf9c6137f$var$RGB_COLOR_REGEXP = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i;
const $b9b9f2bdf9c6137f$var$RGBA_COLOR_REGEXP = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
const $b9b9f2bdf9c6137f$var$HSL_COLOR_REGEXP = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i;
const $b9b9f2bdf9c6137f$var$HSLA_COLOR_REGEXP = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
const $b9b9f2bdf9c6137f$var$CSS_SHORTHAND_VALUE_REGEXP = /\w+\((?:[^()]|\([^()]*\))*\)|\S+/gi;
const $b9b9f2bdf9c6137f$var$COLOR_NAMES = /* @__PURE__ */ new Set([
    "black",
    "silver",
    "gray",
    "white",
    "maroon",
    "red",
    "purple",
    "fuchsia",
    "green",
    "lime",
    "olive",
    "yellow",
    "navy",
    "blue",
    "teal",
    "aqua",
    "orange",
    "aliceblue",
    "antiquewhite",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "blanchedalmond",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "greenyellow",
    "grey",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "limegreen",
    "linen",
    "magenta",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "oldlace",
    "olivedrab",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "whitesmoke",
    "yellowgreen",
    "activeborder",
    "activecaption",
    "appworkspace",
    "background",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "captiontext",
    "graytext",
    "highlight",
    "highlighttext",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infobackground",
    "infotext",
    "menu",
    "menutext",
    "scrollbar",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "window",
    "windowframe",
    "windowtext",
    "rebeccapurple",
    "currentcolor",
    "transparent"
]);
/**
* Checks if string contains [color](https://developer.mozilla.org/en-US/docs/Web/CSS/color) CSS value.
*
* ```ts
* isColorStyleValue( '#f00' );						// true
* isColorStyleValue( '#AA00BB33' );				// true
* isColorStyleValue( 'rgb(0, 0, 250)' );			// true
* isColorStyleValue( 'hsla(240, 100%, 50%, .7)' );	// true
* isColorStyleValue( 'deepskyblue' );				// true
* ```
*
* **Note**: It does not support CSS Level 4 whitespace syntax, system colors and radius values for HSL colors.
*/ function $b9b9f2bdf9c6137f$export$4a7c3f499aa3bc3c(string) {
    if (string.startsWith("#")) return $b9b9f2bdf9c6137f$var$HEX_COLOR_REGEXP.test(string);
    if (string.startsWith("rgb")) return $b9b9f2bdf9c6137f$var$RGB_COLOR_REGEXP.test(string) || $b9b9f2bdf9c6137f$var$RGBA_COLOR_REGEXP.test(string);
    if (string.startsWith("hsl")) return $b9b9f2bdf9c6137f$var$HSL_COLOR_REGEXP.test(string) || $b9b9f2bdf9c6137f$var$HSLA_COLOR_REGEXP.test(string);
    return $b9b9f2bdf9c6137f$var$COLOR_NAMES.has(string.toLowerCase());
}
const $b9b9f2bdf9c6137f$var$lineStyleValues = [
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset"
];
/**
* Checks if string contains [line style](https://developer.mozilla.org/en-US/docs/Web/CSS/border-style) CSS value.
*/ function $b9b9f2bdf9c6137f$export$315beb29c1cc1fa1(string) {
    return $b9b9f2bdf9c6137f$var$lineStyleValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$lengthRegExp = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
/**
* Checks if string contains [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length) CSS value.
*/ function $b9b9f2bdf9c6137f$export$1c20de4d9563b5aa(string) {
    return $b9b9f2bdf9c6137f$var$lengthRegExp.test(string);
}
const $b9b9f2bdf9c6137f$var$PERCENTAGE_VALUE_REGEXP = /^[+-]?[0-9]*([.][0-9]+)?%$/;
/**
* Checks if string contains [percentage](https://developer.mozilla.org/en-US/docs/Web/CSS/percentage) CSS value.
*/ function $b9b9f2bdf9c6137f$export$573cb1d40169758d(string) {
    return $b9b9f2bdf9c6137f$var$PERCENTAGE_VALUE_REGEXP.test(string);
}
const $b9b9f2bdf9c6137f$var$sizeValues = [
    "auto",
    "cover",
    "contain"
];
/**
* Checks if a string is a valid CSS `background-size` value token.
*/ function $b9b9f2bdf9c6137f$var$isSizeStyleValue(value) {
    return $b9b9f2bdf9c6137f$var$sizeValues.includes(value) || $b9b9f2bdf9c6137f$export$1c20de4d9563b5aa(value) || $b9b9f2bdf9c6137f$export$573cb1d40169758d(value);
}
const $b9b9f2bdf9c6137f$var$repeatValues = [
    "repeat-x",
    "repeat-y",
    "repeat",
    "space",
    "round",
    "no-repeat"
];
/**
* Checks if string contains [background repeat](https://developer.mozilla.org/en-US/docs/Web/CSS/background-repeat) CSS value.
*/ function $b9b9f2bdf9c6137f$export$b567d1a7df2737d1(string) {
    return $b9b9f2bdf9c6137f$var$repeatValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$positionValues = [
    "center",
    "top",
    "bottom",
    "left",
    "right"
];
/**
* Checks if string contains [background position](https://developer.mozilla.org/en-US/docs/Web/CSS/background-position) CSS value.
*/ function $b9b9f2bdf9c6137f$export$e36889080593d95f(string) {
    return $b9b9f2bdf9c6137f$var$positionValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$attachmentValues = [
    "fixed",
    "scroll",
    "local"
];
/**
* Checks if string contains [background attachment](https://developer.mozilla.org/en-US/docs/Web/CSS/background-attachment) CSS value.
*/ function $b9b9f2bdf9c6137f$export$e52edf8241e8f4ad(string) {
    return $b9b9f2bdf9c6137f$var$attachmentValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$originValues = [
    "border-box",
    "padding-box",
    "content-box"
];
/**
* Checks if string contains [background origin](https://developer.mozilla.org/en-US/docs/Web/CSS/background-origin) CSS value.
*/ function $b9b9f2bdf9c6137f$var$isOriginStyleValue(string) {
    return $b9b9f2bdf9c6137f$var$originValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$clipValues = [
    "border-box",
    "padding-box",
    "content-box",
    "text"
];
/**
* Checks if string contains [background clip](https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip) CSS value.
*/ function $b9b9f2bdf9c6137f$var$isClipStyleValue(string) {
    return $b9b9f2bdf9c6137f$var$clipValues.includes(string);
}
const $b9b9f2bdf9c6137f$var$urlRegExp = /^url\(/;
/**
* Checks if string contains [URL](https://developer.mozilla.org/en-US/docs/Web/CSS/url) CSS value.
*/ function $b9b9f2bdf9c6137f$export$a643a4de63265948(string) {
    return $b9b9f2bdf9c6137f$var$urlRegExp.test(string);
}
/**
* Parses box sides as individual values.
*/ function $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(value = "") {
    if (value === "") return {
        top: void 0,
        right: void 0,
        bottom: void 0,
        left: void 0
    };
    const values = $b9b9f2bdf9c6137f$export$a4300fed3b5ef665(value);
    const top = values[0];
    const bottom = values[2] || top;
    const right = values[1] || top;
    return {
        top: top,
        bottom: bottom,
        right: right,
        left: values[3] || right
    };
}
/**
* Default reducer for CSS properties that concerns edges of a box
* [shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties) notations:
*
* ```ts
* stylesProcessor.setReducer( 'padding', getBoxSidesStyleValueReducer( 'padding' ) );
* ```
*/ function $b9b9f2bdf9c6137f$export$a022091305d38261(styleShorthand) {
    return (value)=>{
        const { top: top, right: right, bottom: bottom, left: left } = value;
        const reduced = [];
        if (![
            top,
            right,
            left,
            bottom
        ].every((value)=>!!value)) {
            if (top) reduced.push([
                styleShorthand + "-top",
                top
            ]);
            if (right) reduced.push([
                styleShorthand + "-right",
                right
            ]);
            if (bottom) reduced.push([
                styleShorthand + "-bottom",
                bottom
            ]);
            if (left) reduced.push([
                styleShorthand + "-left",
                left
            ]);
        } else reduced.push([
            styleShorthand,
            $b9b9f2bdf9c6137f$export$164e80a7f5b95e2e(value)
        ]);
        return reduced;
    };
}
/**
* Returns a [shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties) notation
* of a CSS property value.
*
* ```ts
* getBoxSidesStyleShorthandValue( { top: '1px', right: '1px', bottom: '2px', left: '1px' } );
* // will return '1px 1px 2px'
* ```
*/ function $b9b9f2bdf9c6137f$export$164e80a7f5b95e2e({ top: top, right: right, bottom: bottom, left: left }) {
    const out = [];
    if (left !== right) out.push(top, right, bottom, left);
    else if (bottom !== top) out.push(top, right, bottom);
    else if (right !== top) out.push(top, right);
    else out.push(top);
    return out.join(" ");
}
/**
* Creates a normalizer for a [shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties) 1-to-4 value.
*
* ```ts
* stylesProcessor.setNormalizer( 'margin', getPositionStyleShorthandNormalizer( 'margin' ) );
* ```
*/ function $b9b9f2bdf9c6137f$export$36200610a6f50bf9(shorthand) {
    return (value)=>{
        return {
            path: shorthand,
            value: $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(value)
        };
    };
}
/**
* Parses parts of a 1-to-4 value notation - handles some CSS values with spaces (like RGB()).
*
* ```ts
* getShorthandStylesValues( 'red blue RGB(0, 0, 0)');
* // will return [ 'red', 'blue', 'RGB(0, 0, 0)' ]
* ```
*/ function $b9b9f2bdf9c6137f$export$a4300fed3b5ef665(string) {
    const matches = string.trim().slice(0, 1500).matchAll($b9b9f2bdf9c6137f$var$CSS_SHORTHAND_VALUE_REGEXP);
    return Array.from(matches).map((i)=>i[0]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/view/styles/background
*/ /**
* CSS initial values for background longhand properties.
*/ const $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES = {
    image: "none",
    repeat: "repeat",
    position: "0% 0%",
    size: "auto",
    origin: "padding-box",
    clip: "border-box",
    attachment: "scroll"
};
/**
* CSS function names that represent image values in the `background` shorthand.
*/ const $b9b9f2bdf9c6137f$var$IMAGE_FUNCTIONS = [
    "linear-gradient",
    "repeating-linear-gradient",
    "radial-gradient",
    "repeating-radial-gradient",
    "conic-gradient",
    "repeating-conic-gradient",
    "url"
];
/**
* Adds background CSS styles processing rules to the given `StylesProcessor`.
*
* Registers normalizers for the `background` shorthand and its longhand properties,
* reducers that serialize them back to CSS strings, and the relation mapping between them.
*
* ```ts
* editor.data.addStyleProcessorRules( addBackgroundStylesRules );
* ```
*
* @param stylesProcessor The styles processor instance to register rules on.
*/ function $b9b9f2bdf9c6137f$export$422a7ff0e667c6c8(stylesProcessor) {
    stylesProcessor.setNormalizer("background-color", $b9b9f2bdf9c6137f$var$getBackgroundColorNormalizer());
    for(const property in $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES){
        stylesProcessor.setNormalizer(`background-${property}`, $b9b9f2bdf9c6137f$var$getBackgroundArrayPropertyNormalizer(`background.${property}`));
        stylesProcessor.setReducer(`background-${property}`, $b9b9f2bdf9c6137f$var$getBackgroundArrayPropertyReducer(`background-${property}`));
    }
    stylesProcessor.setNormalizer("background", $b9b9f2bdf9c6137f$var$getBackgroundNormalizer());
    stylesProcessor.setReducer("background", $b9b9f2bdf9c6137f$var$getBackgroundReducer());
    stylesProcessor.setStyleRelation("background", [
        "background-color",
        "background-image",
        "background-repeat",
        "background-position",
        "background-size",
        "background-attachment",
        "background-origin",
        "background-clip"
    ]);
}
/**
* Returns a normalizer for the `background` shorthand property.
*
* Parses the raw CSS value into comma-separated layers and merges them into
* a structured `Background` object stored under the `background` path.
*/ function $b9b9f2bdf9c6137f$var$getBackgroundNormalizer() {
    return (value)=>{
        const layers = $b9b9f2bdf9c6137f$var$parseBackgroundIntoLayers(value);
        if (!layers.length) layers.push({
            ...$b9b9f2bdf9c6137f$var$getDefaultBackgroundLayer(),
            color: value
        });
        return {
            path: "background",
            value: $b9b9f2bdf9c6137f$var$normalizeBackgroundLayers(layers)
        };
    };
}
/**
* Returns a normalizer for the `background-color` longhand property.
*
* Stores the raw color value directly under the `background.color` path.
*/ function $b9b9f2bdf9c6137f$var$getBackgroundColorNormalizer() {
    return (value)=>({
            path: "background.color",
            value: value
        });
}
/**
* Returns a normalizer for a comma-separated background array longhand property
* (e.g. `background-image`, `background-repeat`, `background-position`, `background-attachment`).
*
* Splits the raw value by top-level commas and stores the resulting array under the given path.
*
* @param path The target style path, e.g. `'background.image'`.
*/ function $b9b9f2bdf9c6137f$var$getBackgroundArrayPropertyNormalizer(path) {
    return (value)=>({
            path: path,
            value: $b9b9f2bdf9c6137f$var$splitByTopLevelCommas(value)
        });
}
/**
* Returns a reducer for a comma-separated background array longhand property
* (e.g. `background-image`, `background-repeat`, `background-position`, `background-attachment`).
*
* Serializes an array of per-layer values back into a comma-separated CSS string.
*
* @param property The CSS property name to output, e.g. `'background-image'`.
*/ function $b9b9f2bdf9c6137f$var$getBackgroundArrayPropertyReducer(property) {
    return (value)=>{
        return [
            [
                property,
                value.join(", ")
            ]
        ];
    };
}
/**
* Returns a reducer for the `background` property. Depending on which longhand properties are present, it either:
*
* * Serializes into a concise `background` shorthand if all required longhand properties are present and non-empty, or
* * Serializes into individual longhand properties for those that have defined values.
*
* This prevents overwriting external stylesheet rules with default values that were not explicitly set in the model.
* For example, if only `background-color` is defined in the model, we emit just `background-color` rather than
* the full `background` shorthand, which would reset all other sub-properties to their initial values.
*/ function $b9b9f2bdf9c6137f$var$getBackgroundReducer() {
    return (value)=>{
        const background = value;
        if (Object.keys($b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES).every((key)=>{
            const value = background[key];
            return value !== void 0 && (!Array.isArray(value) || value.length > 0);
        })) return $b9b9f2bdf9c6137f$var$serializeToShorthandBackground(background);
        return $b9b9f2bdf9c6137f$var$serializeToLonghandBackground(background);
    };
}
/**
* Serializes a structured `Background` object into a concise CSS `background` shorthand string.
*/ function $b9b9f2bdf9c6137f$var$serializeToShorthandBackground(background) {
    const result = [];
    const shorthand = $b9b9f2bdf9c6137f$var$extractBackgroundLayers(background).map((layer)=>$b9b9f2bdf9c6137f$var$serializeBackgroundLayer(layer).trim()).filter(Boolean).join(", ");
    if (shorthand) result.push([
        "background",
        shorthand
    ]);
    return result;
}
/**
* Serializes a structured `Background` object into individual CSS longhand properties for those that have defined values.
* Each longhand property is serialized into a comma-separated string of per-layer values.
*
* This is used when not all required longhand properties are present, to avoid emitting default values for missing properties
* and potentially overwriting external stylesheet rules.
*/ function $b9b9f2bdf9c6137f$var$serializeToLonghandBackground(background) {
    const result = [];
    for(const key in $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES){
        const value = background[key];
        if (Array.isArray(value)) result.push([
            `background-${key}`,
            value.join(", ")
        ]);
    }
    if (background.color !== void 0) result.push([
        "background-color",
        background.color
    ]);
    return result;
}
/**
* Serializes a single `BackgroundLayer` into a CSS background layer string.
* Properties equal to their CSS initial values are omitted.
*
* @param layer A single background layer to serialize.
* @returns A space-separated CSS string for the layer, or an empty string if no parts are present.
*/ function $b9b9f2bdf9c6137f$var$serializeBackgroundLayer(layer) {
    const parts = [];
    if (layer.image && layer.image !== $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.image) parts.push(layer.image);
    const positionStr = layer.position.join(" ");
    const isPositionDefault = !positionStr || positionStr === $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.position;
    if (!isPositionDefault) parts.push(positionStr);
    const sizeStr = layer.size.join(" ");
    if (!(!sizeStr || sizeStr === $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.size)) {
        if (isPositionDefault) parts.push("0% 0%");
        parts.push("/", sizeStr);
    }
    const repeatStr = layer.repeat.join(" ");
    if (repeatStr && repeatStr !== $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.repeat) parts.push(repeatStr);
    if (layer.attachment && layer.attachment !== $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.attachment) parts.push(layer.attachment);
    const isOriginDefault = layer.origin === $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.origin;
    const isClipDefault = layer.clip === $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.clip;
    if (!isOriginDefault || !isClipDefault) {
        parts.push(layer.origin);
        if (layer.clip !== layer.origin) parts.push(layer.clip);
    }
    if (layer.color) parts.push(layer.color);
    return parts.join(" ");
}
/**
* Splits a structured `Background` object into an array of individual `BackgroundLayer` objects.
*
* The number of layers is determined by the longest array among the longhand properties.
* The `color` value, if present, is always assigned to the last layer (per CSS spec).
*
* @param background The structured background object to split.
* @returns An array of per-layer background objects.
*
* @example
* // Input: { image: [ 'url(a.png)', 'url(b.png)' ], repeat: [ 'no-repeat', 'repeat' ], color: 'blue' }
* // Output: [
* //   { image: 'url(a.png)', repeat: [ 'no-repeat' ] },
* //   { image: 'url(b.png)', repeat: [ 'repeat' ], color: 'blue' }
* // ]
*/ function $b9b9f2bdf9c6137f$var$extractBackgroundLayers(background) {
    const layerCount = $b9b9f2bdf9c6137f$var$getTotalBackgroundLayers(background);
    const layers = Array.from({
        length: layerCount
    }, (_, i)=>{
        const layer = $b9b9f2bdf9c6137f$var$getDefaultBackgroundLayer();
        if (background.image?.[i]) layer.image = background.image[i];
        if (background.position?.[i]) layer.position = background.position[i].split(" ");
        if (background.size?.[i]) layer.size = background.size[i].split(" ");
        if (background.repeat?.[i]) layer.repeat = background.repeat[i].split(" ");
        if (background.attachment?.[i]) layer.attachment = background.attachment[i];
        if (background.origin?.[i]) layer.origin = background.origin[i];
        if (background.clip?.[i]) layer.clip = background.clip[i];
        return layer;
    });
    if (background.color) layers.at(-1).color = background.color;
    return layers;
}
/**
* Determines the total number of background layers based on the longest array among the longhand properties in the `Background` object.
*
* @param background The structured background object to analyze.
* @returns The total number of layers, which is the maximum length among the longhand property arrays.
*/ function $b9b9f2bdf9c6137f$var$getTotalBackgroundLayers(background) {
    let layersCount = 0;
    for (const value of Object.values(background))if (Array.isArray(value) && value.length > layersCount) layersCount = value.length;
    return layersCount;
}
/**
* Merges an array of `BackgroundLayer` objects into a single structured `Background` object,
* storing each longhand property as an array of per-layer values.
*
* Each input layer always has all properties defined (via `getDefaultBackgroundLayer`),
* so the resulting arrays are fully populated for every layer.
*
* @param layers An array of parsed background layers.
* @returns A merged `Background` object.
*
* @example
* // Input: [ { image: 'url(a.png)', repeat: [ 'no-repeat' ], position: [ '0%', '0%' ], ... }, { image: 'none', color: 'red', ... } ]
* // Output: {
* //   image: [ 'url(a.png)', 'none' ],
* //   position: [ '0% 0%', '0% 0%' ],
* //   repeat: [ 'no-repeat', 'repeat' ],
* //   ...
* //   color: 'red'
* // }
*/ function $b9b9f2bdf9c6137f$var$normalizeBackgroundLayers(layers) {
    const background = {
        image: [],
        position: [],
        size: [],
        repeat: [],
        attachment: [],
        origin: [],
        clip: []
    };
    for (const layer of layers){
        background.position.push(layer.position.join(" "));
        background.size.push(layer.size.join(" "));
        background.repeat.push(layer.repeat.join(" "));
        background.image.push(layer.image);
        background.attachment.push(layer.attachment);
        background.origin.push(layer.origin);
        background.clip.push(layer.clip);
    }
    if (layers.at(-1)?.color) background.color = layers.at(-1).color;
    return background;
}
/**
* Parses a raw CSS `background` value and splits it into an array of `BackgroundLayer` objects,
* one per comma-separated layer.
*
* The CSS `background` shorthand syntax is:
* `background: [ <bg-layer> , ]* <final-bg-layer>`
*
* Commas inside function calls (e.g. `rgba()`, `linear-gradient()`) are correctly ignored
* during splitting.
*
* @param value The raw CSS background value string.
* @returns An array of parsed background layers.
*
* @example
* splitBackgroundIntoLayers( 'url(a.png) no-repeat, red' );
* // → [ { image: 'url(a.png)', repeat: [ 'no-repeat' ] }, { color: 'red' } ]
*/ function $b9b9f2bdf9c6137f$var$parseBackgroundIntoLayers(value) {
    return $b9b9f2bdf9c6137f$var$splitByTopLevelCommas(value).map($b9b9f2bdf9c6137f$var$parseBackgroundLayer).filter((obj)=>obj !== null);
}
/**
* Parses a single CSS background layer string into a structured `BackgroundLayer` object.
*
* First extracts any image function (gradient or `url()`), then classifies the remaining
* space-separated tokens as repeat, position, attachment, or color values.
*
* @param layer A single (non-comma-separated) background layer string.
* @returns A structured background layer object. If no valid properties were found, returns `null`.
*
* @example
* parseBackgroundLayer( 'url(bg.png) top left no-repeat fixed' );
* // → { image: 'url(bg.png)', position: [ 'top', 'left' ], repeat: [ 'no-repeat' ], attachment: 'fixed' }
*/ function $b9b9f2bdf9c6137f$var$parseBackgroundLayer(layer) {
    const background = {};
    const { value: valueWithoutImage, image: image } = $b9b9f2bdf9c6137f$var$extractBackgroundImage(layer);
    const parts = $b9b9f2bdf9c6137f$export$a4300fed3b5ef665(valueWithoutImage);
    if (image) background.image = image;
    for(let i = 0; i < parts.length; i++){
        const part = parts[i];
        if (part === "/") {
            background.size = [];
            while(i + 1 < parts.length && $b9b9f2bdf9c6137f$var$isSizeStyleValue(parts[i + 1]))background.size.push(parts[++i]);
        } else if ($b9b9f2bdf9c6137f$export$b567d1a7df2737d1(part)) {
            background.repeat ||= [];
            background.repeat.push(part);
        } else if ($b9b9f2bdf9c6137f$export$e36889080593d95f(part) || $b9b9f2bdf9c6137f$export$573cb1d40169758d(part)) {
            background.position ||= [];
            background.position.push(part);
            if (i + 1 < parts.length && $b9b9f2bdf9c6137f$export$573cb1d40169758d(part) && $b9b9f2bdf9c6137f$export$573cb1d40169758d(parts[i + 1])) background.position.push(parts[++i]);
        } else if ($b9b9f2bdf9c6137f$export$e52edf8241e8f4ad(part)) background.attachment = part;
        else if ($b9b9f2bdf9c6137f$var$isClipStyleValue(part)) {
            if ($b9b9f2bdf9c6137f$var$isOriginStyleValue(part) && !background.origin) {
                background.origin = part;
                background.clip = part;
            } else background.clip = part;
        } else if ($b9b9f2bdf9c6137f$export$4a7c3f499aa3bc3c(part)) background.color = part;
    }
    if ((0, $0fbcc62fa6835df5$export$dd1bc94b04021eeb)(background)) return null;
    return {
        ...$b9b9f2bdf9c6137f$var$getDefaultBackgroundLayer(),
        ...background
    };
}
/**
* Returns a `BackgroundLayer` object with all properties set to their CSS initial values.
*
* Used as the base when parsing the `background` shorthand so that every property of a parsed
* layer always has a defined value.
*
* @returns A background layer with default values.
*/ function $b9b9f2bdf9c6137f$var$getDefaultBackgroundLayer() {
    return {
        attachment: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.attachment,
        image: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.image,
        origin: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.origin,
        clip: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.clip,
        position: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.position.split(" "),
        repeat: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.repeat.split(" "),
        size: $b9b9f2bdf9c6137f$var$BACKGROUND_INITIAL_ARRAY_VALUES.size.split(" ")
    };
}
/**
* Extracts the first CSS image function (`linear-gradient`, `url`, etc.) from a raw CSS value string
* and returns it separately along with the remaining string with the image function removed.
*
* Handles arbitrarily nested parentheses correctly (e.g. `rgba()` inside a gradient).
* Only one image function is extracted per call — the caller is responsible for looping
* if multiple image functions may be present.
*
* @param value The raw CSS value string to process.
* @returns An object with `value` (the string with the image function removed) and
*          `image` (the extracted function string, or `null` if none was found).
*
* @example
* extractBackgroundImage( 'linear-gradient(red, blue) no-repeat' );
* // → { value: ' no-repeat', image: 'linear-gradient(red, blue)' }
*/ function $b9b9f2bdf9c6137f$var$extractBackgroundImage(value) {
    for (const imageFunction of $b9b9f2bdf9c6137f$var$IMAGE_FUNCTIONS){
        const prefix = imageFunction + "(";
        const firstIndex = value.indexOf(prefix);
        if (firstIndex < 0) continue;
        let acc = imageFunction;
        let nesting = 0;
        for(let i = firstIndex + imageFunction.length; i < value.length; i++){
            const char = value[i];
            if (char === "(") nesting++;
            else if (char === ")") nesting--;
            acc += char;
            if (nesting === 0) return {
                value: value.slice(0, firstIndex) + value.slice(i + 1),
                image: acc
            };
        }
    }
    if (value.includes("none")) return {
        value: value.replace("none", ""),
        image: "none"
    };
    return {
        value: value,
        image: null
    };
}
/**
* Splits a CSS value string by commas that are at the top level (i.e. not inside parentheses).
*
* This is necessary because commas appear both as layer separators in the `background` shorthand
* and as argument separators inside functions like `rgba()` or `linear-gradient()`.
*
* @param value The CSS value string to split.
* @returns An array of trimmed top-level comma-separated segments.
*
* @example
* splitByTopLevelCommas( 'linear-gradient(red, blue), center' );
* // → [ 'linear-gradient(red, blue)', 'center' ]
*/ function $b9b9f2bdf9c6137f$var$splitByTopLevelCommas(value) {
    const parts = [];
    let current = "";
    let nesting = 0;
    for (const char of value){
        if (char === "(") nesting++;
        else if (char === ")") nesting--;
        else if (char === "," && nesting === 0) {
            parts.push(current.trim());
            current = "";
            continue;
        }
        current += char;
    }
    if (current.trim()) parts.push(current.trim());
    return parts;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Adds a border CSS styles processing rules.
*
* ```ts
* editor.data.addStyleProcessorRules( addBorderStylesRules );
* ```
*
* This rules merges all [border](https://developer.mozilla.org/en-US/docs/Web/CSS/border) styles notation shorthands:
*
* - border
* - border-top
* - border-right
* - border-bottom
* - border-left
* - border-color
* - border-style
* - border-width
*
* and all corresponding longhand forms (like `border-top-color`, `border-top-style`, etc).
*
* It does not handle other shorthands (like `border-radius` or `border-image`).
*/ function $b9b9f2bdf9c6137f$export$46159d29aabaeb2c(stylesProcessor) {
    stylesProcessor.setNormalizer("border", $b9b9f2bdf9c6137f$var$getBorderNormalizer());
    stylesProcessor.setNormalizer("border-top", $b9b9f2bdf9c6137f$var$getBorderPositionNormalizer("top"));
    stylesProcessor.setNormalizer("border-right", $b9b9f2bdf9c6137f$var$getBorderPositionNormalizer("right"));
    stylesProcessor.setNormalizer("border-bottom", $b9b9f2bdf9c6137f$var$getBorderPositionNormalizer("bottom"));
    stylesProcessor.setNormalizer("border-left", $b9b9f2bdf9c6137f$var$getBorderPositionNormalizer("left"));
    stylesProcessor.setNormalizer("border-color", $b9b9f2bdf9c6137f$var$getBorderPropertyNormalizer("color"));
    stylesProcessor.setNormalizer("border-width", $b9b9f2bdf9c6137f$var$getBorderPropertyNormalizer("width"));
    stylesProcessor.setNormalizer("border-style", $b9b9f2bdf9c6137f$var$getBorderPropertyNormalizer("style"));
    stylesProcessor.setNormalizer("border-top-color", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("color", "top"));
    stylesProcessor.setNormalizer("border-top-style", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("style", "top"));
    stylesProcessor.setNormalizer("border-top-width", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("width", "top"));
    stylesProcessor.setNormalizer("border-right-color", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("color", "right"));
    stylesProcessor.setNormalizer("border-right-style", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("style", "right"));
    stylesProcessor.setNormalizer("border-right-width", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("width", "right"));
    stylesProcessor.setNormalizer("border-bottom-color", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("color", "bottom"));
    stylesProcessor.setNormalizer("border-bottom-style", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("style", "bottom"));
    stylesProcessor.setNormalizer("border-bottom-width", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("width", "bottom"));
    stylesProcessor.setNormalizer("border-left-color", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("color", "left"));
    stylesProcessor.setNormalizer("border-left-style", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("style", "left"));
    stylesProcessor.setNormalizer("border-left-width", $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer("width", "left"));
    stylesProcessor.setExtractor("border-top", $b9b9f2bdf9c6137f$var$getBorderPositionExtractor("top"));
    stylesProcessor.setExtractor("border-right", $b9b9f2bdf9c6137f$var$getBorderPositionExtractor("right"));
    stylesProcessor.setExtractor("border-bottom", $b9b9f2bdf9c6137f$var$getBorderPositionExtractor("bottom"));
    stylesProcessor.setExtractor("border-left", $b9b9f2bdf9c6137f$var$getBorderPositionExtractor("left"));
    stylesProcessor.setExtractor("border-top-color", "border.color.top");
    stylesProcessor.setExtractor("border-right-color", "border.color.right");
    stylesProcessor.setExtractor("border-bottom-color", "border.color.bottom");
    stylesProcessor.setExtractor("border-left-color", "border.color.left");
    stylesProcessor.setExtractor("border-top-width", "border.width.top");
    stylesProcessor.setExtractor("border-right-width", "border.width.right");
    stylesProcessor.setExtractor("border-bottom-width", "border.width.bottom");
    stylesProcessor.setExtractor("border-left-width", "border.width.left");
    stylesProcessor.setExtractor("border-top-style", "border.style.top");
    stylesProcessor.setExtractor("border-right-style", "border.style.right");
    stylesProcessor.setExtractor("border-bottom-style", "border.style.bottom");
    stylesProcessor.setExtractor("border-left-style", "border.style.left");
    stylesProcessor.setReducer("border-color", $b9b9f2bdf9c6137f$export$a022091305d38261("border-color"));
    stylesProcessor.setReducer("border-style", $b9b9f2bdf9c6137f$export$a022091305d38261("border-style"));
    stylesProcessor.setReducer("border-width", $b9b9f2bdf9c6137f$export$a022091305d38261("border-width"));
    stylesProcessor.setReducer("border-top", $b9b9f2bdf9c6137f$var$getBorderPositionReducer("top"));
    stylesProcessor.setReducer("border-right", $b9b9f2bdf9c6137f$var$getBorderPositionReducer("right"));
    stylesProcessor.setReducer("border-bottom", $b9b9f2bdf9c6137f$var$getBorderPositionReducer("bottom"));
    stylesProcessor.setReducer("border-left", $b9b9f2bdf9c6137f$var$getBorderPositionReducer("left"));
    stylesProcessor.setReducer("border", $b9b9f2bdf9c6137f$var$getBorderReducer());
    stylesProcessor.setStyleRelation("border", [
        "border-color",
        "border-style",
        "border-width",
        "border-top",
        "border-right",
        "border-bottom",
        "border-left",
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color",
        "border-top-style",
        "border-right-style",
        "border-bottom-style",
        "border-left-style",
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ]);
    stylesProcessor.setStyleRelation("border-color", [
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color"
    ]);
    stylesProcessor.setStyleRelation("border-style", [
        "border-top-style",
        "border-right-style",
        "border-bottom-style",
        "border-left-style"
    ]);
    stylesProcessor.setStyleRelation("border-width", [
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ]);
    stylesProcessor.setStyleRelation("border-top", [
        "border-top-color",
        "border-top-style",
        "border-top-width"
    ]);
    stylesProcessor.setStyleRelation("border-right", [
        "border-right-color",
        "border-right-style",
        "border-right-width"
    ]);
    stylesProcessor.setStyleRelation("border-bottom", [
        "border-bottom-color",
        "border-bottom-style",
        "border-bottom-width"
    ]);
    stylesProcessor.setStyleRelation("border-left", [
        "border-left-color",
        "border-left-style",
        "border-left-width"
    ]);
}
function $b9b9f2bdf9c6137f$var$getBorderNormalizer() {
    return (value)=>{
        const { color: color, style: style, width: width } = $b9b9f2bdf9c6137f$var$normalizeBorderShorthand(value);
        return {
            path: "border",
            value: {
                color: $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(color),
                style: $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(style),
                width: $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(width)
            }
        };
    };
}
function $b9b9f2bdf9c6137f$var$getBorderPositionNormalizer(side) {
    return (value)=>{
        const { color: color, style: style, width: width } = $b9b9f2bdf9c6137f$var$normalizeBorderShorthand(value);
        const border = {};
        if (color !== void 0) border.color = {
            [side]: color
        };
        if (style !== void 0) border.style = {
            [side]: style
        };
        if (width !== void 0) border.width = {
            [side]: width
        };
        return {
            path: "border",
            value: border
        };
    };
}
function $b9b9f2bdf9c6137f$var$getBorderPropertyNormalizer(propertyName) {
    return (value)=>{
        return {
            path: "border",
            value: $b9b9f2bdf9c6137f$var$toBorderPropertyShorthand(value, propertyName)
        };
    };
}
function $b9b9f2bdf9c6137f$var$toBorderPropertyShorthand(value, property) {
    return {
        [property]: $b9b9f2bdf9c6137f$export$4ba4d4f108069a51(value)
    };
}
function $b9b9f2bdf9c6137f$var$getBorderPropertyPositionNormalizer(property, side) {
    return (value)=>{
        return {
            path: "border",
            value: {
                [property]: {
                    [side]: value
                }
            }
        };
    };
}
function $b9b9f2bdf9c6137f$var$getBorderPositionExtractor(which) {
    return (name, styles)=>{
        if (styles.border) return $b9b9f2bdf9c6137f$var$extractBorderPosition(styles.border, which);
    };
}
function $b9b9f2bdf9c6137f$var$extractBorderPosition(border, which) {
    const value = {};
    if (border.width && border.width[which]) value.width = border.width[which];
    if (border.style && border.style[which]) value.style = border.style[which];
    if (border.color && border.color[which]) value.color = border.color[which];
    return value;
}
function $b9b9f2bdf9c6137f$var$normalizeBorderShorthand(string) {
    const result = {};
    const parts = $b9b9f2bdf9c6137f$export$a4300fed3b5ef665(string);
    for (const part of parts)if ($b9b9f2bdf9c6137f$export$1c20de4d9563b5aa(part) || /thin|medium|thick/.test(part)) result.width = part;
    else if ($b9b9f2bdf9c6137f$export$315beb29c1cc1fa1(part)) result.style = part;
    else result.color = part;
    return result;
}
/**
* The border reducer factory.
*
* It tries to produce the most optimal output for the specified styles.
*
* For a border style:
*
* ```css
* style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
* ```
*
* It will produce: `border-style: solid`.
* For a border style and color:
*
* ```css
* color: {top: "#ff0", bottom: "#ff0", right: "#ff0", left: "#ff0"}
* style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
* ```
*
* It will produce: `border-color: #ff0; border-style: solid`.
* If all border parameters are specified:
*
* ```css
* color: {top: "#ff0", bottom: "#ff0", right: "#ff0", left: "#ff0"}
* style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
* width: {top: "2px", bottom: "2px", right: "2px", left: "2px"}
* ```
*
* It will combine everything into a single property: `border: 2px solid #ff0`.
*
* The definitions are merged only if all border selectors have the same values.
*/ function $b9b9f2bdf9c6137f$var$getBorderReducer() {
    return (value)=>{
        const topStyles = $b9b9f2bdf9c6137f$var$extractBorderPosition(value, "top");
        const rightStyles = $b9b9f2bdf9c6137f$var$extractBorderPosition(value, "right");
        const bottomStyles = $b9b9f2bdf9c6137f$var$extractBorderPosition(value, "bottom");
        const leftStyles = $b9b9f2bdf9c6137f$var$extractBorderPosition(value, "left");
        const borderStyles = [
            topStyles,
            rightStyles,
            bottomStyles,
            leftStyles
        ];
        const borderStylesByType = {
            width: getReducedStyleValueForType(borderStyles, "width"),
            style: getReducedStyleValueForType(borderStyles, "style"),
            color: getReducedStyleValueForType(borderStyles, "color")
        };
        const reducedBorderStyle = $b9b9f2bdf9c6137f$var$reduceBorderPosition(borderStylesByType, "all");
        if (reducedBorderStyle.length) return reducedBorderStyle;
        return [
            ...Object.entries(borderStylesByType).reduce((reducedStyleTypes, [type, value])=>{
                if (value) {
                    reducedStyleTypes.push([
                        `border-${type}`,
                        value
                    ]);
                    borderStyles.forEach((style)=>delete style[type]);
                }
                return reducedStyleTypes;
            }, []),
            ...$b9b9f2bdf9c6137f$var$reduceBorderPosition(topStyles, "top"),
            ...$b9b9f2bdf9c6137f$var$reduceBorderPosition(rightStyles, "right"),
            ...$b9b9f2bdf9c6137f$var$reduceBorderPosition(bottomStyles, "bottom"),
            ...$b9b9f2bdf9c6137f$var$reduceBorderPosition(leftStyles, "left")
        ];
    };
    /**
	* @param styles The array of objects with `style`, `color`, `width` properties.
	*/ function getReducedStyleValueForType(styles, type) {
        return styles.map((style)=>style[type]).reduce((result, style)=>result == style ? result : null);
    }
}
function $b9b9f2bdf9c6137f$var$getBorderPositionReducer(which) {
    return (value)=>$b9b9f2bdf9c6137f$var$reduceBorderPosition(value, which);
}
/**
* Returns an array with reduced border styles depending on the specified values.
*
* If all border properties (width, style, color) are specified, the returned selector will be
* merged into a group: `border-*: [width] [style] [color]`.
*
* Otherwise, the specific definitions will be returned: `border-(width|style|color)-*: [value]`.
*
* @param value Styles if defined.
* @param which The border position.
*/ function $b9b9f2bdf9c6137f$var$reduceBorderPosition(value, which) {
    const borderTypes = [];
    if (value && value.width) borderTypes.push("width");
    if (value && value.style) borderTypes.push("style");
    if (value && value.color) borderTypes.push("color");
    if (borderTypes.length == 3) {
        const borderValue = borderTypes.map((item)=>value[item]).join(" ");
        return [
            which == "all" ? [
                "border",
                borderValue
            ] : [
                `border-${which}`,
                borderValue
            ]
        ];
    }
    if (which == "all") return [];
    return borderTypes.map((type)=>{
        return [
            `border-${which}-${type}`,
            value[type]
        ];
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Adds a margin CSS styles processing rules.
*
* ```ts
* editor.data.addStyleProcessorRules( addMarginStylesRules );
* ```
*/ function $b9b9f2bdf9c6137f$export$45e932fc987e4c1e(stylesProcessor) {
    stylesProcessor.setNormalizer("margin", $b9b9f2bdf9c6137f$export$36200610a6f50bf9("margin"));
    stylesProcessor.setNormalizer("margin-top", (value)=>({
            path: "margin.top",
            value: value
        }));
    stylesProcessor.setNormalizer("margin-right", (value)=>({
            path: "margin.right",
            value: value
        }));
    stylesProcessor.setNormalizer("margin-bottom", (value)=>({
            path: "margin.bottom",
            value: value
        }));
    stylesProcessor.setNormalizer("margin-left", (value)=>({
            path: "margin.left",
            value: value
        }));
    stylesProcessor.setReducer("margin", $b9b9f2bdf9c6137f$export$a022091305d38261("margin"));
    stylesProcessor.setStyleRelation("margin", [
        "margin-top",
        "margin-right",
        "margin-bottom",
        "margin-left"
    ]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Adds a padding CSS styles processing rules.
*
* ```ts
* editor.data.addStyleProcessorRules( addPaddingStylesRules );
* ```
*/ function $b9b9f2bdf9c6137f$export$9ba7212def70900f(stylesProcessor) {
    stylesProcessor.setNormalizer("padding", $b9b9f2bdf9c6137f$export$36200610a6f50bf9("padding"));
    stylesProcessor.setNormalizer("padding-top", (value)=>({
            path: "padding.top",
            value: value
        }));
    stylesProcessor.setNormalizer("padding-right", (value)=>({
            path: "padding.right",
            value: value
        }));
    stylesProcessor.setNormalizer("padding-bottom", (value)=>({
            path: "padding.bottom",
            value: value
        }));
    stylesProcessor.setNormalizer("padding-left", (value)=>({
            path: "padding.left",
            value: value
        }));
    stylesProcessor.setReducer("padding", $b9b9f2bdf9c6137f$export$a022091305d38261("padding"));
    stylesProcessor.setStyleRelation("padding", [
        "padding-top",
        "padding-right",
        "padding-bottom",
        "padding-left"
    ]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/dev-utils/view
*/ /**
* Collection of methods for manipulating the {@link module:engine/view/view view} for testing purposes.
*/ const $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN = "[";
const $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_END_TOKEN = "]";
const $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN = "{";
const $b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN = "}";
const $b9b9f2bdf9c6137f$var$allowedTypes = {
    "container": $b9b9f2bdf9c6137f$export$7cd474321d18c0af,
    "attribute": $b9b9f2bdf9c6137f$export$9c94dd4019f314d7,
    "empty": $b9b9f2bdf9c6137f$export$a2e67116aa89395d,
    "ui": $b9b9f2bdf9c6137f$export$3d8082ae114b5652,
    "raw": $b9b9f2bdf9c6137f$export$533ef497f99ba10c
};
const $b9b9f2bdf9c6137f$var$domConverterStub = {
    setContentOf: (node, html)=>{
        node.innerHTML = html;
    }
};
/**
* Writes the content of the {@link module:engine/view/document~ViewDocument document} to an HTML-like string.
*
* @param view The view to stringify.
* @param options.withoutSelection Whether to write the selection. When set to `true`, the selection will
* not be included in the returned string.
* @param options.rootName The name of the root from which the data should be stringified. If not provided,
* the default `main` name will be used.
* @param options.showType When set to `true`, the type of elements will be printed (`<container:p>`
* instead of `<p>`, `<attribute:b>` instead of `<b>` and `<empty:img>` instead of `<img>`).
* @param options.showPriority When set to `true`, the attribute element's priority will be printed
* (`<span view-priority="12">`, `<b view-priority="10">`).
* @param options.renderUIElements When set to `true`, the inner content of each
* {@link module:engine/view/uielement~ViewUIElement} will be printed.
* @param options.renderRawElements When set to `true`, the inner content of each
* {@link module:engine/view/rawelement~ViewRawElement} will be printed.
* @param options.domConverter When set to an actual {@link module:engine/view/domconverter~ViewDomConverter ViewDomConverter}
* instance, it lets the conversion go through exactly the same flow the editing view is going through,
* i.e. with view data filtering. Otherwise the simple stub is used.
* @returns The stringified data.
*/ const $b9b9f2bdf9c6137f$export$5d963788fc278e12 = /* #__PURE__ */ (()=>{
    const getViewData = function(view, options = {}) {
        if (!(view instanceof $b9b9f2bdf9c6137f$export$4ffdc5ea4ff36c8d)) throw new TypeError("View needs to be an instance of module:engine/view/view~EditingView.");
        const document1 = view.document;
        const withoutSelection = !!options.withoutSelection;
        const rootName = options.rootName || "main";
        const root = document1.getRoot(rootName);
        const stringifyOptions = {
            showType: options.showType,
            showPriority: options.showPriority,
            renderUIElements: options.renderUIElements,
            renderRawElements: options.renderRawElements,
            ignoreRoot: true,
            domConverter: options.domConverter,
            skipListItemIds: options.skipListItemIds
        };
        return withoutSelection ? getViewData._stringify(root, null, stringifyOptions) : getViewData._stringify(root, document1.selection, stringifyOptions);
    };
    getViewData._stringify = $b9b9f2bdf9c6137f$export$bc692b4166ff5e36;
    return getViewData;
})();
/**
* Sets the content of a view {@link module:engine/view/document~ViewDocument document} provided as an HTML-like string.
*
* @param data An HTML-like string to write into the document.
* @param options.rootName The root name where _parseViewd data will be stored. If not provided,
* the default `main` name will be used.
*/ const $b9b9f2bdf9c6137f$export$cb840b334282e4e0 = /* #__PURE__ */ (()=>{
    const setViewData = function(view, data, options = {}) {
        if (!(view instanceof $b9b9f2bdf9c6137f$export$4ffdc5ea4ff36c8d)) throw new TypeError("View needs to be an instance of module:engine/view/view~EditingView.");
        const document1 = view.document;
        const rootName = options.rootName || "main";
        const root = document1.getRoot(rootName);
        view.change((writer)=>{
            const result = setViewData._parse(data, {
                rootElement: root
            });
            if (result.view && result.selection) writer.setSelection(result.selection);
        });
    };
    setViewData._parse = $b9b9f2bdf9c6137f$export$7909f33e0f44f9f9;
    return setViewData;
})();
/**
* Converts view elements to HTML-like string representation.
*
* A root element can be provided as {@link module:engine/view/text~ViewText text}:
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* stringify( text ); // 'foobar'
* ```
*
* or as an {@link module:engine/view/element~ViewElement element}:
*
* ```ts
* const element = downcastWriter.createElement( 'p', null, downcastWriter.createText( 'foobar' ) );
* stringify( element ); // '<p>foobar</p>'
* ```
*
* or as a {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}:
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* const b = downcastWriter.createElement( 'b', { name: 'test' }, text );
* const p = downcastWriter.createElement( 'p', { style: 'color:red;' } );
* const fragment = downcastWriter.createDocumentFragment( [ p, b ] );
*
* stringify( fragment ); // '<p style="color:red;"></p><b name="test">foobar</b>'
* ```
*
* Additionally, a {@link module:engine/view/documentselection~ViewDocumentSelection selection} instance can be provided.
* Ranges from the selection will then be included in the output data.
* If a range position is placed inside the element node, it will be represented with `[` and `]`:
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* const b = downcastWriter.createElement( 'b', null, text );
* const p = downcastWriter.createElement( 'p', null, b );
* const selection = downcastWriter.createSelection(
* 	downcastWriter.createRangeIn( p )
* );
*
* stringify( p, selection ); // '<p>[<b>foobar</b>]</p>'
* ```
*
* If a range is placed inside the text node, it will be represented with `{` and `}`:
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* const b = downcastWriter.createElement( 'b', null, text );
* const p = downcastWriter.createElement( 'p', null, b );
* const selection = downcastWriter.createSelection(
* 	downcastWriter.createRange( downcastWriter.createPositionAt( text, 1 ), downcastWriter.createPositionAt( text, 5 ) )
* );
*
* stringify( p, selection ); // '<p><b>f{ooba}r</b></p>'
* ```
*
* ** Note: **
* It is possible to unify selection markers to `[` and `]` for both (inside and outside text)
* by setting the `sameSelectionCharacters=true` option. It is mainly used when the view stringify option is used by
* model utilities.
*
* Multiple ranges are supported:
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* const selection = downcastWriter.createSelection( [
* 	downcastWriter.createRange( downcastWriter.createPositionAt( text, 0 ), downcastWriter.createPositionAt( text, 1 ) ),
* 	downcastWriter.createRange( downcastWriter.createPositionAt( text, 3 ), downcastWriter.createPositionAt( text, 5 ) )
* ] );
*
* stringify( text, selection ); // '{f}oo{ba}r'
* ```
*
* A {@link module:engine/view/range~ViewRange range} or {@link module:engine/view/position~ViewPosition position} instance can be provided
* instead of the {@link module:engine/view/documentselection~ViewDocumentSelection selection} instance. If a range instance
* is provided, it will be converted to a selection containing this range. If a position instance is provided, it will
* be converted to a selection containing one range collapsed at this position.
*
* ```ts
* const text = downcastWriter.createText( 'foobar' );
* const range = downcastWriter.createRange( downcastWriter.createPositionAt( text, 0 ), downcastWriter.createPositionAt( text, 1 ) );
* const position = downcastWriter.createPositionAt( text, 3 );
*
* stringify( text, range ); // '{f}oobar'
* stringify( text, position ); // 'foo{}bar'
* ```
*
* An additional `options` object can be provided.
* If `options.showType` is set to `true`, element's types will be
* presented for {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements},
* {@link module:engine/view/containerelement~ViewContainerElement container elements}
* {@link module:engine/view/emptyelement~ViewEmptyElement empty elements}
* and {@link module:engine/view/uielement~ViewUIElement UI elements}:
*
* ```ts
* const attribute = downcastWriter.createAttributeElement( 'b' );
* const container = downcastWriter.createContainerElement( 'p' );
* const empty = downcastWriter.createEmptyElement( 'img' );
* const ui = downcastWriter.createUIElement( 'span' );
* getData( attribute, null, { showType: true } ); // '<attribute:b></attribute:b>'
* getData( container, null, { showType: true } ); // '<container:p></container:p>'
* getData( empty, null, { showType: true } ); // '<empty:img></empty:img>'
* getData( ui, null, { showType: true } ); // '<ui:span></ui:span>'
* ```
*
* If `options.showPriority` is set to `true`, a priority will be displayed for all
* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements}.
*
* ```ts
* const attribute = downcastWriter.createAttributeElement( 'b' );
* attribute._priority = 20;
* getData( attribute, null, { showPriority: true } ); // <b view-priority="20"></b>
* ```
*
* If `options.showAttributeElementId` is set to `true`, the attribute element's id will be displayed for all
* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements} that have it set.
*
* ```ts
* const attribute = downcastWriter.createAttributeElement( 'span' );
* attribute._id = 'marker:foo';
* getData( attribute, null, { showAttributeElementId: true } ); // <span view-id="marker:foo"></span>
* ```
*
* @param node The node to stringify.
* @param selectionOrPositionOrRange A selection instance whose ranges will be included in the returned string data.
* If a range instance is provided, it will be converted to a selection containing this range. If a position instance
* is provided, it will be converted to a selection containing one range collapsed at this position.
* @param options An object with additional options.
* @param options.showType When set to `true`, the type of elements will be printed (`<container:p>`
* instead of `<p>`, `<attribute:b>` instead of `<b>` and `<empty:img>` instead of `<img>`).
* @param options.showPriority When set to `true`,  the attribute element's priority will be printed
* (`<span view-priority="12">`, `<b view-priority="10">`).
* @param options.showAttributeElementId When set to `true`, attribute element's id will be printed
* (`<span id="marker:foo">`).
* @param options.ignoreRoot When set to `true`, the root's element opening and closing will not be printed.
* Mainly used by the `getData` function to ignore the {@link module:engine/view/document~ViewDocument document's} root element.
* @param options.sameSelectionCharacters When set to `true`, the selection inside the text will be marked as
*  `{` and `}` and the selection outside the text as `[` and `]`. When set to `false`, both will be marked as `[` and `]` only.
* @param options.renderUIElements When set to `true`, the inner content of each
* {@link module:engine/view/uielement~ViewUIElement} will be printed.
* @param options.renderRawElements When set to `true`, the inner content of each
* {@link module:engine/view/rawelement~ViewRawElement} will be printed.
* @param options.domConverter When set to an actual {@link module:engine/view/domconverter~ViewDomConverter ViewDomConverter}
* instance, it lets the conversion go through exactly the same flow the editing view is going through,
* i.e. with view data filtering. Otherwise the simple stub is used.
* @returns An HTML-like string representing the view.
*/ function $b9b9f2bdf9c6137f$export$bc692b4166ff5e36(node, selectionOrPositionOrRange = null, options = {}) {
    let selection;
    if (selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$7534acacc32db851 || selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$829eb746b222877) selection = new $b9b9f2bdf9c6137f$export$88e7995732ec83f3(selectionOrPositionOrRange);
    else selection = selectionOrPositionOrRange;
    return new $b9b9f2bdf9c6137f$var$ViewStringify(node, selection, options).stringify();
}
/**
* Parses an HTML-like string and returns a view tree.
* A simple string will be converted to a {@link module:engine/view/text~ViewText text} node:
*
* ```ts
* _parseView( 'foobar' ); // Returns an instance of text.
* ```
*
* {@link module:engine/view/element~ViewElement Elements} will be _parseViewd with attributes as children:
*
* ```ts
* _parseView( '<b name="baz">foobar</b>' ); // Returns an instance of element with the `baz` attribute and a text child node.
* ```
*
* Multiple nodes provided on root level will be converted to a
* {@link module:engine/view/documentfragment~ViewDocumentFragment document fragment}:
*
* ```ts
* _parseView( '<b>foo</b><i>bar</i>' ); // Returns a document fragment with two child elements.
* ```
*
* The method can _parseView multiple {@link module:engine/view/range~ViewRange ranges} provided in string data and return a
* {@link module:engine/view/documentselection~ViewDocumentSelection selection} instance containing these ranges. Ranges placed inside
* {@link module:engine/view/text~ViewText text} nodes should be marked using `{` and `}` brackets:
*
* ```ts
* const { text, selection } = _parseView( 'f{ooba}r' );
* ```
*
* Ranges placed outside text nodes should be marked using `[` and `]` brackets:
*
* ```ts
* const { root, selection } = _parseView( '<p>[<b>foobar</b>]</p>' );
* ```
*
* ** Note: **
* It is possible to unify selection markers to `[` and `]` for both (inside and outside text)
* by setting `sameSelectionCharacters=true` option. It is mainly used when the view _parseView option is used by model utilities.
*
* Sometimes there is a need for defining the order of ranges inside the created selection. This can be achieved by providing
* the range order array as an additional parameter:
*
* ```ts
* const { root, selection } = _parseView( '{fo}ob{ar}{ba}z', { order: [ 2, 3, 1 ] } );
* ```
*
* In the example above, the first range (`{fo}`) will be added to the selection as the second one, the second range (`{ar}`) will be
* added as the third and the third range (`{ba}`) will be added as the first one.
*
* If the selection's last range should be added as a backward one
* (so the {@link module:engine/view/documentselection~ViewDocumentSelection#anchor selection anchor} is represented
* by the `end` position and {@link module:engine/view/documentselection~ViewDocumentSelection#focus selection focus} is
* represented by the `start` position), use the `lastRangeBackward` flag:
*
* ```ts
* const { root, selection } = _parseView( `{foo}bar{baz}`, { lastRangeBackward: true } );
* ```
*
* Some more examples and edge cases:
*
* ```ts
* // Returns an empty document fragment.
* _parseView( '' );
*
* // Returns an empty document fragment and a collapsed selection.
* const { root, selection } = _parseView( '[]' );
*
* // Returns an element and a selection that is placed inside the document fragment containing that element.
* const { root, selection } = _parseView( '[<a></a>]' );
* ```
*
* @param data An HTML-like string to be parsed.
* @param options.order An array with the order of parsed ranges added to the returned
* {@link module:engine/view/documentselection~ViewDocumentSelection Selection} instance. Each element should represent the
* desired position of each range in the selection instance. For example: `[2, 3, 1]` means that the first range will be
* placed as the second, the second as the third and the third as the first.
* @param options.lastRangeBackward If set to `true`, the last range will be added as backward to the returned
* {@link module:engine/view/documentselection~ViewDocumentSelection selection} instance.
* @param options.rootElement The default root to use when parsing elements.
* When set to `null`, the root element will be created automatically. If set to
* {@link module:engine/view/element~ViewElement Element} or
* {@link module:engine/view/documentfragment~ViewDocumentFragment DocumentFragment},
* this node will be used as the root for all parsed nodes.
* @param options.sameSelectionCharacters When set to `false`, the selection inside the text should be marked using
* `{` and `}` and the selection outside the ext using `[` and `]`. When set to `true`, both should be marked with `[` and `]` only.
* @returns Returns the parsed view node or an object with two fields: `view` and `selection` when selection ranges were included in the
* data to parse.
*/ function $b9b9f2bdf9c6137f$export$7909f33e0f44f9f9(data, options = {}) {
    const viewDocument = new $b9b9f2bdf9c6137f$export$c26285651732fb36(new $b9b9f2bdf9c6137f$export$c3739f0469d36452());
    options.order = options.order || [];
    const rangeParser = new $b9b9f2bdf9c6137f$var$RangeParser({
        sameSelectionCharacters: options.sameSelectionCharacters
    });
    const processor = new $b9b9f2bdf9c6137f$export$1e715f285cf5346f(viewDocument, {
        namespaces: Object.keys($b9b9f2bdf9c6137f$var$allowedTypes)
    });
    if (options.inlineObjectElements) processor.domConverter.inlineObjectElements.push(...options.inlineObjectElements);
    let view = processor.toView(data);
    view = $b9b9f2bdf9c6137f$var$_convertViewElements(view);
    if (options.rootElement) {
        const root = options.rootElement;
        const nodes = view._removeChildren(0, view.childCount);
        root._removeChildren(0, root.childCount);
        root._appendChild(nodes);
        view = root;
    }
    const ranges = rangeParser._parseView(view, options.order);
    if (view.is("documentFragment") && view.childCount === 1) view = view.getChild(0);
    if (ranges.length) {
        const selection = new $b9b9f2bdf9c6137f$export$88e7995732ec83f3(ranges, {
            backward: !!options.lastRangeBackward
        });
        return {
            view: view,
            selection: selection
        };
    }
    if (view.parent) view._remove();
    return view;
}
/**
* Private helper class used for converting ranges represented as text inside view {@link module:engine/view/text~ViewText text nodes}.
*/ var $b9b9f2bdf9c6137f$var$RangeParser = class {
    sameSelectionCharacters;
    _positions;
    /**
	* Creates a range parser instance.
	*
	* @param options The range parser configuration.
	* @param options.sameSelectionCharacters When set to `true`, the selection inside the text is marked as
	* `{` and `}` and the selection outside the text as `[` and `]`. When set to `false`, both are marked as `[` and `]`.
	*/ constructor(options){
        this.sameSelectionCharacters = !!options.sameSelectionCharacters;
    }
    /**
	* Parses the view and returns ranges represented inside {@link module:engine/view/text~ViewText text nodes}.
	* The method will remove all occurrences of `{`, `}`, `[` and `]` from found text nodes. If a text node is empty after
	* the process, it will be removed, too.
	*
	* @param node The starting node.
	* @param order The order of ranges. Each element should represent the desired position of the range after
	* sorting. For example: `[2, 3, 1]` means that the first range will be placed as the second, the second as the third and the third
	* as the first.
	* @returns An array with ranges found.
	*/ _parseView(node, order) {
        this._positions = [];
        this._getPositions(node);
        let ranges = this._createRanges();
        if (order.length) {
            if (order.length != ranges.length) throw new Error(`Parse error - there are ${ranges.length} ranges found, but ranges order array contains ${order.length} elements.`);
            ranges = this._sortRanges(ranges, order);
        }
        return ranges;
    }
    /**
	* Gathers positions of brackets inside the view tree starting from the provided node. The method will remove all occurrences of
	* `{`, `}`, `[` and `]` from found text nodes. If a text node is empty after the process, it will be removed, too.
	*
	* @param node Staring node.
	*/ _getPositions(node) {
        if (node.is("documentFragment") || node.is("element")) {
            const children = [
                ...node.getChildren()
            ];
            for (const child of children)this._getPositions(child);
        }
        if (node.is("$text")) {
            const regexp = new RegExp(`[${$b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN}${$b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN}\\${$b9b9f2bdf9c6137f$var$ELEMENT_RANGE_END_TOKEN}\\${$b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN}]`, "g");
            let text = node.data;
            let match;
            let offset = 0;
            const brackets = [];
            while(match = regexp.exec(text)){
                const index = match.index;
                const bracket = match[0];
                brackets.push({
                    bracket: bracket,
                    textOffset: index - offset
                });
                offset++;
            }
            text = text.replace(regexp, "");
            node._data = text;
            const index = node.index;
            const parent = node.parent;
            if (!text) node._remove();
            for (const item of brackets)if (text) {
                if (this.sameSelectionCharacters || !this.sameSelectionCharacters && (item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN || item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN)) this._positions.push({
                    bracket: item.bracket,
                    position: new $b9b9f2bdf9c6137f$export$7534acacc32db851(node, item.textOffset)
                });
                else {
                    if (!this.sameSelectionCharacters && item.textOffset !== 0 && item.textOffset !== text.length) throw new Error(`Parse error - range delimiter '${item.bracket}' is placed inside text node.`);
                    const offset = item.textOffset === 0 ? index : index + 1;
                    this._positions.push({
                        bracket: item.bracket,
                        position: new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, offset)
                    });
                }
            } else {
                if (!this.sameSelectionCharacters && item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN || item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN) throw new Error(`Parse error - text range delimiter '${item.bracket}' is placed inside empty text node. `);
                this._positions.push({
                    bracket: item.bracket,
                    position: new $b9b9f2bdf9c6137f$export$7534acacc32db851(parent, index)
                });
            }
        }
    }
    /**
	* Sorts ranges in a given order. Range order should be an array and each element should represent the desired position
	* of the range after sorting.
	* For example: `[2, 3, 1]` means that the first range will be placed as the second, the second as the third and the third
	* as the first.
	*
	* @param ranges Ranges to sort.
	* @param rangesOrder An array with new range order.
	* @returns Sorted ranges array.
	*/ _sortRanges(ranges, rangesOrder) {
        const sortedRanges = [];
        let index = 0;
        for (const newPosition of rangesOrder){
            if (ranges[newPosition - 1] === void 0) throw new Error("Parse error - provided ranges order is invalid.");
            sortedRanges[newPosition - 1] = ranges[index];
            index++;
        }
        return sortedRanges;
    }
    /**
	* Uses all found bracket positions to create ranges from them.
	*/ _createRanges() {
        const ranges = [];
        let range = null;
        for (const item of this._positions){
            if (!range && (item.bracket == $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_END_TOKEN || item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN)) throw new Error(`Parse error - end of range was found '${item.bracket}' but range was not started before.`);
            if (range && (item.bracket == $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN || item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN)) throw new Error(`Parse error - start of range was found '${item.bracket}' but one range is already started.`);
            if (item.bracket == $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN || item.bracket == $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN) range = new $b9b9f2bdf9c6137f$export$829eb746b222877(item.position, item.position);
            else {
                range.end = item.position;
                ranges.push(range);
                range = null;
            }
        }
        if (range !== null) throw new Error("Parse error - range was started but no end delimiter was found.");
        return ranges;
    }
};
/**
* Private helper class used for converting the view tree to a string.
*/ var $b9b9f2bdf9c6137f$var$ViewStringify = class {
    root;
    selection;
    ranges;
    showType;
    showPriority;
    showAttributeElementId;
    ignoreRoot;
    sameSelectionCharacters;
    renderUIElements;
    renderRawElements;
    domConverter;
    skipListItemIds;
    /**
	* Creates a view stringify instance.
	*
	* @param selection A selection whose ranges should also be converted to a string.
	* @param options An options object.
	* @param options.showType When set to `true`, the type of elements will be printed (`<container:p>`
	* instead of `<p>`, `<attribute:b>` instead of `<b>` and `<empty:img>` instead of `<img>`).
	* @param options.showPriority When set to `true`, the attribute element's priority will be printed.
	* @param options.ignoreRoot When set to `true`, the root's element opening and closing tag will not
	* be outputted.
	* @param options.sameSelectionCharacters When set to `true`, the selection inside the text is marked as
	* `{` and `}` and the selection outside the text as `[` and `]`. When set to `false`, both are marked as `[` and `]`.
	* @param options.renderUIElements When set to `true`, the inner content of each
	* {@link module:engine/view/uielement~ViewUIElement} will be printed.
	* @param options.renderRawElements When set to `true`, the inner content of each
	* @param options.domConverter When set to an actual {@link module:engine/view/domconverter~ViewDomConverter ViewDomConverter}
	* instance, it lets the conversion go through exactly the same flow the editing view is going through,
	* i.e. with view data filtering. Otherwise the simple stub is used.
	* {@link module:engine/view/rawelement~ViewRawElement} will be printed.
	* @param options.skipListItemIds When set to `true`, `<li>` elements will not have `listItemId` attribute. By default it's hidden
	* because it's randomly generated and hard to verify properly, while bringing little value.
	*/ constructor(root, selection, options){
        this.root = root;
        this.selection = selection;
        this.ranges = [];
        if (selection) this.ranges = [
            ...selection.getRanges()
        ];
        this.showType = !!options.showType;
        this.showPriority = !!options.showPriority;
        this.showAttributeElementId = !!options.showAttributeElementId;
        this.ignoreRoot = !!options.ignoreRoot;
        this.sameSelectionCharacters = !!options.sameSelectionCharacters;
        this.renderUIElements = !!options.renderUIElements;
        this.renderRawElements = !!options.renderRawElements;
        this.domConverter = options.domConverter || $b9b9f2bdf9c6137f$var$domConverterStub;
        this.skipListItemIds = options.skipListItemIds !== void 0 ? !!options.skipListItemIds : true;
    }
    /**
	* Converts the view to a string.
	*
	* @returns String representation of the view elements.
	*/ stringify() {
        let result = "";
        this._walkView(this.root, (chunk)=>{
            result += chunk;
        });
        if (this.skipListItemIds) result = result.replaceAll(/ data-list-item-id="[^"]+"/g, "");
        return result;
    }
    /**
	* Executes a simple walker that iterates over all elements in the view tree starting from the root element.
	* Calls the `callback` with parsed chunks of string data.
	*/ _walkView(root, callback) {
        const ignore = this.ignoreRoot && this.root === root;
        if (root.is("element") || root.is("documentFragment")) {
            if (root.is("element") && !ignore) callback(this._stringifyElementOpen(root));
            if (this.renderUIElements && root.is("uiElement")) callback(root.render(document, this.domConverter).innerHTML);
            else if (this.renderRawElements && root.is("rawElement")) {
                const rawContentContainer = document.createElement("div");
                root.render(rawContentContainer, this.domConverter);
                callback(rawContentContainer.innerHTML);
            } else {
                let offset = 0;
                callback(this._stringifyElementRanges(root, offset));
                for (const child of root.getChildren()){
                    this._walkView(child, callback);
                    offset++;
                    callback(this._stringifyElementRanges(root, offset));
                }
            }
            if (root.is("element") && !ignore) callback(this._stringifyElementClose(root));
        }
        if (root.is("$text")) callback(this._stringifyTextRanges(root));
    }
    /**
	* Checks if a given {@link module:engine/view/element~ViewElement element} has
	* a {@link module:engine/view/range~ViewRange#start range start}
	* or a {@link module:engine/view/range~ViewRange#start range end} placed at a given offset and returns its string representation.
	*/ _stringifyElementRanges(element, offset) {
        let start = "";
        let end = "";
        let collapsed = "";
        for (const range of this.ranges){
            if (range.start.parent == element && range.start.offset === offset) {
                if (range.isCollapsed) collapsed += "[]";
                else start += $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN;
            }
            if (range.end.parent === element && range.end.offset === offset && !range.isCollapsed) end += $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_END_TOKEN;
        }
        return end + collapsed + start;
    }
    /**
	* Checks if a given {@link module:engine/view/element~ViewElement Text node} has a
	* {@link module:engine/view/range~ViewRange#start range start} or a
	* {@link module:engine/view/range~ViewRange#start range end} placed somewhere inside. Returns a string representation of text
	* with range delimiters placed inside.
	*/ _stringifyTextRanges(node) {
        const length = node.data.length;
        const data = node.data.split("");
        let rangeStartToken, rangeEndToken;
        if (this.sameSelectionCharacters) {
            rangeStartToken = $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_START_TOKEN;
            rangeEndToken = $b9b9f2bdf9c6137f$var$ELEMENT_RANGE_END_TOKEN;
        } else {
            rangeStartToken = $b9b9f2bdf9c6137f$var$TEXT_RANGE_START_TOKEN;
            rangeEndToken = $b9b9f2bdf9c6137f$var$TEXT_RANGE_END_TOKEN;
        }
        data[length] = "";
        const result = data.map((letter)=>{
            return {
                letter: letter,
                start: "",
                end: "",
                collapsed: ""
            };
        });
        for (const range of this.ranges){
            const start = range.start;
            const end = range.end;
            if (start.parent == node && start.offset >= 0 && start.offset <= length) {
                if (range.isCollapsed) result[end.offset].collapsed += rangeStartToken + rangeEndToken;
                else result[start.offset].start += rangeStartToken;
            }
            if (end.parent == node && end.offset >= 0 && end.offset <= length && !range.isCollapsed) result[end.offset].end += rangeEndToken;
        }
        return result.map((item)=>item.end + item.collapsed + item.start + item.letter).join("");
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element} to an opening tag.
	*
	* Depending on the current configuration, the opening tag can be simple (`<a>`), contain a type prefix (`<container:p>`,
	* `<attribute:a>` or `<empty:img>`), contain priority information ( `<attribute:a view-priority="20">` ),
	* or contain element id ( `<attribute:span view-id="foo">` ). Element attributes will also be included
	* (`<a href="https://ckeditor.com" name="foobar">`).
	*/ _stringifyElementOpen(element) {
        const priority = this._stringifyElementPriority(element);
        const id = this._stringifyElementId(element);
        return `<${[
            [
                this._stringifyElementType(element),
                element.name
            ].filter((i)=>i !== "").join(":"),
            priority,
            id,
            this._stringifyElementAttributes(element)
        ].filter((i)=>i !== "").join(" ")}>`;
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element} to a closing tag.
	* Depending on the current configuration, the closing tag can be simple (`</a>`) or contain a type prefix (`</container:p>`,
	* `</attribute:a>` or `</empty:img>`).
	*/ _stringifyElementClose(element) {
        return `</${[
            this._stringifyElementType(element),
            element.name
        ].filter((i)=>i !== "").join(":")}>`;
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element's} type to its string representation
	*
	* Returns:
	* * 'attribute' for {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements},
	* * 'container' for {@link module:engine/view/containerelement~ViewContainerElement container elements},
	* * 'empty' for {@link module:engine/view/emptyelement~ViewEmptyElement empty elements},
	* * 'ui' for {@link module:engine/view/uielement~ViewUIElement UI elements},
	* * 'raw' for {@link module:engine/view/rawelement~ViewRawElement raw elements},
	* * an empty string when the current configuration is preventing showing elements' types.
	*/ _stringifyElementType(element) {
        if (this.showType) {
            for(const type in $b9b9f2bdf9c6137f$var$allowedTypes)if (element instanceof $b9b9f2bdf9c6137f$var$allowedTypes[type]) return type;
        }
        return "";
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element} to its priority representation.
	*
	* The priority string representation will be returned when the passed element is an instance of
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute element} and the current configuration allows to show the
	* priority. Otherwise returns an empty string.
	*/ _stringifyElementPriority(element) {
        if (this.showPriority && element.is("attributeElement")) return `view-priority="${element.priority}"`;
        return "";
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element} to its id representation.
	*
	* The id string representation will be returned when the passed element is an instance of
	* {@link module:engine/view/attributeelement~ViewAttributeElement attribute element}, the element has an id
	* and the current configuration allows to show the id. Otherwise returns an empty string.
	*/ _stringifyElementId(element) {
        if (this.showAttributeElementId && element.is("attributeElement") && element.id) return `view-id="${element.id}"`;
        return "";
    }
    /**
	* Converts the passed {@link module:engine/view/element~ViewElement element} attributes to their string representation.
	* If an element has no attributes, an empty string is returned.
	*/ _stringifyElementAttributes(element) {
        const attributes = [];
        const keys = [
            ...element.getAttributeKeys()
        ].sort();
        for (const attribute of keys){
            let attributeValue;
            if (attribute === "class") attributeValue = [
                ...element.getClassNames()
            ].sort().join(" ");
            else if (attribute === "style") attributeValue = [
                ...element.getStyleNames()
            ].sort().map((style)=>`${style}:${element.getStyle(style).replace(/"/g, "&quot;")}`).join(";");
            else attributeValue = element.getAttribute(attribute);
            attributes.push(`${attribute}="${attributeValue}"`);
        }
        return attributes.join(" ");
    }
};
/**
* Converts {@link module:engine/view/element~ViewElement elements} to
* {@link module:engine/view/attributeelement~ViewAttributeElement attribute elements},
* {@link module:engine/view/containerelement~ViewContainerElement container elements},
* {@link module:engine/view/emptyelement~ViewEmptyElement empty elements} or
* {@link module:engine/view/uielement~ViewUIElement UI elements}.
* It converts the whole tree starting from the `rootNode`. The conversion is based on element names.
* See the `_convertElement` method for more details.
*
* @param rootNode The root node to convert.
* @returns The root node of converted elements.
*/ function $b9b9f2bdf9c6137f$var$_convertViewElements(rootNode) {
    if (rootNode.is("element") || rootNode.is("documentFragment")) {
        const convertedElement = rootNode.is("documentFragment") ? new $b9b9f2bdf9c6137f$export$574fd53611480ec7(rootNode.document) : $b9b9f2bdf9c6137f$var$_convertElement(rootNode.document, rootNode);
        for (const child of [
            ...rootNode.getChildren()
        ]){
            if (convertedElement.is("emptyElement")) throw new Error("Parse error - cannot parse inside ViewEmptyElement.");
            else if (convertedElement.is("uiElement")) throw new Error("Parse error - cannot parse inside UIElement.");
            else if (convertedElement.is("rawElement")) throw new Error("Parse error - cannot parse inside RawElement.");
            convertedElement._appendChild($b9b9f2bdf9c6137f$var$_convertViewElements(child));
        }
        return convertedElement;
    }
    return rootNode;
}
/**
* Converts an {@link module:engine/view/element~ViewElement element} to
* {@link module:engine/view/attributeelement~ViewAttributeElement attribute element},
* {@link module:engine/view/containerelement~ViewContainerElement container element},
* {@link module:engine/view/emptyelement~ViewEmptyElement empty element} or
* {@link module:engine/view/uielement~ViewUIElement UI element}.
* If the element's name is in the format of `attribute:b`, it will be converted to
* an {@link module:engine/view/attributeelement~ViewAttributeElement attribute element} with a priority of 11.
* Additionally, attribute elements may have specified priority (for example `view-priority="11"`) and/or
* id (for example `view-id="foo"`).
* If the element's name is in the format of `container:p`, it will be converted to
* a {@link module:engine/view/containerelement~ViewContainerElement container element}.
* If the element's name is in the format of `empty:img`, it will be converted to
* an {@link module:engine/view/emptyelement~ViewEmptyElement empty element}.
* If the element's name is in the format of `ui:span`, it will be converted to
* a {@link module:engine/view/uielement~ViewUIElement UI element}.
* If the element's name does not contain any additional information, a {@link module:engine/view/element~ViewElement view Element} will be
* returned.
*
* @param viewElement A view element to convert.
* @returns A tree view element converted according to its name.
*/ function $b9b9f2bdf9c6137f$var$_convertElement(viewDocument, viewElement) {
    const info = $b9b9f2bdf9c6137f$var$_convertElementNameAndInfo(viewElement);
    const ElementConstructor = $b9b9f2bdf9c6137f$var$allowedTypes[info.type];
    const newElement = ElementConstructor ? new ElementConstructor(viewDocument, info.name) : new $b9b9f2bdf9c6137f$export$6a9b2964be74ea54(viewDocument, info.name);
    if (newElement.is("attributeElement")) {
        if (info.priority !== null) newElement._priority = info.priority;
        if (info.id !== null) newElement._id = info.id;
    }
    for (const attributeKey of viewElement.getAttributeKeys())newElement._setAttribute(attributeKey, viewElement.getAttribute(attributeKey));
    return newElement;
}
/**
* Converts the `view-priority` attribute and the {@link module:engine/view/element~ViewElement#name element's name} information needed for
* creating {@link module:engine/view/attributeelement~ViewAttributeElement attribute element},
* {@link module:engine/view/containerelement~ViewContainerElement container element},
* {@link module:engine/view/emptyelement~ViewEmptyElement empty element} or
* {@link module:engine/view/uielement~ViewUIElement UI element}.
* The name can be provided in two formats: as a simple element's name (`div`), or as a type and name (`container:div`,
* `attribute:span`, `empty:img`, `ui:span`);
*
* @param viewElement The element whose name should be converted.
* @returns An object with parsed information:
* * `name` The parsed name of the element.
* * `type` The parsed type of the element. It can be `attribute`, `container` or `empty`.
* * `priority` The parsed priority of the element.
*/ function $b9b9f2bdf9c6137f$var$_convertElementNameAndInfo(viewElement) {
    const parts = viewElement.name.split(":");
    const priority = $b9b9f2bdf9c6137f$var$_convertPriority(viewElement.getAttribute("view-priority"));
    const id = viewElement.hasAttribute("view-id") ? viewElement.getAttribute("view-id") : null;
    viewElement._removeAttribute("view-priority");
    viewElement._removeAttribute("view-id");
    if (parts.length == 1) return {
        name: parts[0],
        type: priority !== null ? "attribute" : null,
        priority: priority,
        id: id
    };
    const type = $b9b9f2bdf9c6137f$var$_convertType(parts[0]);
    if (type) return {
        name: parts[1],
        type: type,
        priority: priority,
        id: id
    };
    throw new Error(`Parse error - cannot parse element's name: ${viewElement.name}.`);
}
/**
* Checks if the element's type is allowed. Returns `attribute`, `container`, `empty` or `null`.
*/ function $b9b9f2bdf9c6137f$var$_convertType(type) {
    return type in $b9b9f2bdf9c6137f$var$allowedTypes ? type : null;
}
/**
* Checks if a given priority is allowed. Returns null if the priority cannot be converted.
*/ function $b9b9f2bdf9c6137f$var$_convertPriority(priorityString) {
    const priority = parseInt(priorityString, 10);
    if (!isNaN(priority)) return priority;
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/dev-utils/model
*/ /**
* Collection of methods for manipulating the {@link module:engine/model/model model} for testing purposes.
*/ /**
* Writes the content of a model {@link module:engine/model/document~ModelDocument document} to an HTML-like string.
*
* ```ts
* getData( editor.model ); // -> '<paragraph>Foo![]</paragraph>'
* ```
*
* **Note:** A {@link module:engine/model/text~ModelText text} node that contains attributes will be represented as:
*
* ```xml
* <$text attribute="value">Text data</$text>
* ```
*
* **Note:** Using this tool in production-grade code is not recommended. It was designed for development, prototyping,
* debugging and testing.
*
* @param options.withoutSelection Whether to write the selection. When set to `true`, the selection will
* not be included in the returned string.
* @param options.rootName The name of the root from which the data should be stringified. If not provided,
* the default `main` name will be used.
* @param options.convertMarkers Whether to include markers in the returned string.
* @returns The stringified data.
*/ const $b9b9f2bdf9c6137f$export$fc6706058361eef2 = /* #__PURE__ */ (()=>{
    const getModelData = function(model, options = {}) {
        if (!(model instanceof $b9b9f2bdf9c6137f$export$a1edc412be3e1841)) throw new TypeError("Model needs to be an instance of module:engine/model/model~Model.");
        const rootName = options.rootName || "main";
        const root = model.document.getRoot(rootName);
        return getModelData._stringify(root, options.withoutSelection ? null : model.document.selection, options.convertMarkers ? model.markers : null);
    };
    getModelData._stringify = $b9b9f2bdf9c6137f$export$c2a51ea804b3a2f9;
    return getModelData;
})();
/**
* Sets the content of a model {@link module:engine/model/document~ModelDocument document} provided as an HTML-like string.
*
* ```ts
* setData( editor.model, '<paragraph>Foo![]</paragraph>' );
* ```
*
* **Note:** Remember to register elements in the {@link module:engine/model/model~Model#schema model's schema} before
* trying to use them.
*
* **Note:** To create a {@link module:engine/model/text~ModelText text} node that contains attributes use:
*
* ```xml
* <$text attribute="value">Text data</$text>
* ```
*
* **Note:** Using this tool in production-grade code is not recommended. It was designed for development, prototyping,
* debugging and testing.
*
* @param data HTML-like string to write into the document.
* @param options.rootName Root name where parsed data will be stored. If not provided, the default `main`
* name will be used.
* @param options.selectionAttributes A list of attributes which will be passed to the selection.
* @param options.lastRangeBackward If set to `true`, the last range will be added as backward.
* @param options.batchType Batch type used for inserting elements. See {@link module:engine/model/batch~Batch#constructor}.
*/ const $b9b9f2bdf9c6137f$export$e1c966984cb8b131 = /* #__PURE__ */ (()=>{
    const setModelData = function(model, data, options = {}) {
        if (!(model instanceof $b9b9f2bdf9c6137f$export$a1edc412be3e1841)) throw new TypeError("Model needs to be an instance of module:engine/model/model~Model.");
        let modelDocumentFragment;
        let selection = null;
        const modelRoot = model.document.getRoot(options.rootName || "main");
        const parsedResult = setModelData._parse(data, model.schema, {
            lastRangeBackward: options.lastRangeBackward,
            selectionAttributes: options.selectionAttributes,
            context: [
                modelRoot.name
            ],
            inlineObjectElements: options.inlineObjectElements
        });
        if ("model" in parsedResult) {
            modelDocumentFragment = parsedResult.model;
            selection = parsedResult.selection;
        } else modelDocumentFragment = parsedResult;
        if (options.batchType !== void 0) model.enqueueChange(options.batchType, writeToModel);
        else model.change(writeToModel);
        function writeToModel(writer) {
            writer.remove(writer.createRangeIn(modelRoot));
            writer.insert(modelDocumentFragment, modelRoot);
            writer.setSelection(null);
            writer.removeSelectionAttribute(model.document.selection.getAttributeKeys());
            if (selection) {
                const ranges = [];
                for (const range of selection.getRanges()){
                    const start = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(modelRoot, range.start.path);
                    const end = new $b9b9f2bdf9c6137f$export$86023cc9eabef192(modelRoot, range.end.path);
                    ranges.push(new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(start, end));
                }
                writer.setSelection(ranges, {
                    backward: selection.isBackward
                });
                if (options.selectionAttributes) writer.setSelectionAttribute(selection.getAttributes());
            }
        }
    };
    setModelData._parse = $b9b9f2bdf9c6137f$export$6e60594137b150c0;
    return setModelData;
})();
/**
* Converts model nodes to HTML-like string representation.
*
* **Note:** A {@link module:engine/model/text~ModelText text} node that contains attributes will be represented as:
*
* ```xml
* <$text attribute="value">Text data</$text>
* ```
*
* @param node A node to stringify.
* @param selectionOrPositionOrRange A selection instance whose ranges will be included in the returned string data.
* If a range instance is provided, it will be converted to a selection containing this range. If a position instance
* is provided, it will be converted to a selection containing one range collapsed at this position.
* @param markers Markers to include.
* @returns An HTML-like string representing the model.
*/ function $b9b9f2bdf9c6137f$export$c2a51ea804b3a2f9(node, selectionOrPositionOrRange = null, markers = null) {
    const model = new $b9b9f2bdf9c6137f$export$a1edc412be3e1841();
    const mapper = new $b9b9f2bdf9c6137f$export$ef5ccc0a8fc5a06c();
    let selection = null;
    let range;
    if (node instanceof $b9b9f2bdf9c6137f$export$4294c3610dee24e8 || node instanceof $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2) range = model.createRangeIn(node);
    else if (!node.parent) {
        const fragment = new $b9b9f2bdf9c6137f$export$c30b4c7f930a26a2(node);
        range = model.createRangeIn(fragment);
    } else range = new $b9b9f2bdf9c6137f$export$a3091252a5e626ba(model.createPositionBefore(node), model.createPositionAfter(node));
    if (selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6) selection = selectionOrPositionOrRange;
    else if (selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa) selection = selectionOrPositionOrRange;
    else if (selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$a3091252a5e626ba) selection = new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectionOrPositionOrRange);
    else if (selectionOrPositionOrRange instanceof $b9b9f2bdf9c6137f$export$86023cc9eabef192) selection = new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(selectionOrPositionOrRange);
    const stylesProcessor = new $b9b9f2bdf9c6137f$export$c3739f0469d36452();
    const view = new $b9b9f2bdf9c6137f$export$4ffdc5ea4ff36c8d(stylesProcessor);
    const viewDocument = view.document;
    const viewRoot = new $b9b9f2bdf9c6137f$export$a8813c6865859ce(viewDocument, "div");
    viewRoot.rootName = "main";
    viewDocument.roots.add(viewRoot);
    const downcastDispatcher = new $b9b9f2bdf9c6137f$export$a3db87c8d34df7e7({
        mapper: mapper,
        schema: model.schema
    });
    mapper.bindElements(node.root, viewRoot);
    downcastDispatcher.on("insert:$text", $b9b9f2bdf9c6137f$export$45ce91c8ab754ab7());
    downcastDispatcher.on("insert", $b9b9f2bdf9c6137f$export$f67751480ebc37c(), {
        priority: "lowest"
    });
    downcastDispatcher.on("attribute", (evt, data, conversionApi)=>{
        if (data.item instanceof $b9b9f2bdf9c6137f$export$d7de888343eb5ed6 || data.item instanceof $b9b9f2bdf9c6137f$export$7ad0b188284367aa || data.item.is("$textProxy")) $b9b9f2bdf9c6137f$export$ef9cb34a60d615c1((modelAttributeValue, { writer: writer })=>{
            return writer.createAttributeElement("model-text-with-attributes", {
                [data.attributeKey]: $b9b9f2bdf9c6137f$var$stringifyAttributeValue(modelAttributeValue)
            });
        })(evt, data, conversionApi);
    });
    downcastDispatcher.on("insert", $b9b9f2bdf9c6137f$export$df72b18897e1fd28((modelItem)=>{
        const attributes = $b9b9f2bdf9c6137f$var$convertAttributes(modelItem.getAttributes(), $b9b9f2bdf9c6137f$var$stringifyAttributeValue);
        return new $b9b9f2bdf9c6137f$export$7cd474321d18c0af(viewDocument, modelItem.name, attributes);
    }));
    downcastDispatcher.on("selection", $b9b9f2bdf9c6137f$export$4bf288faba1f60fa());
    downcastDispatcher.on("selection", $b9b9f2bdf9c6137f$export$d9fb6c173d870a4c());
    downcastDispatcher.on("addMarker", $b9b9f2bdf9c6137f$export$d6d83508304a361a((data, { writer: writer })=>{
        const name = data.markerName + ":" + (data.isOpening ? "start" : "end");
        return writer.createUIElement(name);
    }));
    const markersMap = /* @__PURE__ */ new Map();
    if (markers) for (const marker of Array.from(markers).sort((a, b)=>a.name < b.name ? 1 : -1))markersMap.set(marker.name, marker.getRange());
    const writer = view._writer;
    downcastDispatcher.convert(range, markersMap, writer);
    if (selection) downcastDispatcher.convertSelection(selection, markers || model.markers, writer);
    let data = $b9b9f2bdf9c6137f$export$bc692b4166ff5e36(viewRoot, viewDocument.selection, {
        sameSelectionCharacters: true
    });
    data = data.substr(5, data.length - 11);
    view.destroy();
    return data.replace(/* @__PURE__ */ new RegExp("model-text-with-attributes", "g"), "$text");
}
/**
* Parses an HTML-like string and returns the model {@link module:engine/model/rootelement~ModelRootElement rootElement}.
*
* **Note:** To create a {@link module:engine/model/text~ModelText text} node that contains attributes use:
*
* ```xml
* <$text attribute="value">Text data</$text>
* ```
*
* **Note:** The default `options.context` value is `'$root'`, which only matches the generic root. When the editor
* uses a custom root {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`}, pass the target
* {@link module:engine/model/rootelement~ModelRootElement root element} (or its configured model element name)
* explicitly, otherwise the conversion result may be wrong.
* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
*
* @param data HTML-like string to be parsed.
* @param schema A schema instance used by converters for element validation.
* @param options Additional configuration.
* @param options.selectionAttributes A list of attributes which will be passed to the selection.
* @param options.lastRangeBackward If set to `true`, the last range will be added as backward.
* @param options.context The conversion context. If not provided, the default `'$root'` will be used.
* @returns Returns the parsed model node or an object with two fields: `model` and `selection`,
* when selection ranges were included in the data to parse.
*/ function $b9b9f2bdf9c6137f$export$6e60594137b150c0(data, schema, options = {}) {
    const mapper = new $b9b9f2bdf9c6137f$export$ef5ccc0a8fc5a06c();
    data = data.replace(/* @__PURE__ */ new RegExp("\\$text", "g"), "model-text-with-attributes");
    const parsedResult = $b9b9f2bdf9c6137f$export$7909f33e0f44f9f9(data, {
        sameSelectionCharacters: true,
        lastRangeBackward: !!options.lastRangeBackward,
        inlineObjectElements: options.inlineObjectElements
    });
    let viewDocumentFragment;
    let viewSelection = null;
    let selection = null;
    if ("view" in parsedResult && "selection" in parsedResult) {
        viewDocumentFragment = parsedResult.view;
        viewSelection = parsedResult.selection;
    } else viewDocumentFragment = parsedResult;
    const modelController = new $b9b9f2bdf9c6137f$export$a1edc412be3e1841();
    const upcastDispatcher = new $b9b9f2bdf9c6137f$export$1f0967356c557e87({
        schema: schema
    });
    upcastDispatcher.on("documentFragment", $b9b9f2bdf9c6137f$var$convertToModelFragment$1(mapper));
    upcastDispatcher.on("element:model-text-with-attributes", $b9b9f2bdf9c6137f$var$convertToModelText());
    upcastDispatcher.on("element", $b9b9f2bdf9c6137f$var$convertToModelElement(mapper));
    upcastDispatcher.on("text", $b9b9f2bdf9c6137f$var$convertToModelText());
    let model = modelController.change((writer)=>upcastDispatcher.convert(viewDocumentFragment.root, writer, options.context || "$root"));
    mapper.bindElements(model, viewDocumentFragment.root);
    if (model.childCount == 1) model = model.getChild(0);
    if (viewSelection) {
        const ranges = [];
        for (const viewRange of viewSelection.getRanges())ranges.push(mapper.toModelRange(viewRange));
        selection = new $b9b9f2bdf9c6137f$export$d7de888343eb5ed6(ranges, {
            backward: viewSelection.isBackward
        });
        for (const [key, value] of (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(options.selectionAttributes || []))selection.setAttribute(key, value);
    }
    if (selection) return {
        model: model,
        selection: selection
    };
    return model;
}
function $b9b9f2bdf9c6137f$var$convertToModelFragment$1(mapper) {
    return (evt, data, conversionApi)=>{
        const childrenResult = conversionApi.convertChildren(data.viewItem, data.modelCursor);
        mapper.bindElements(data.modelCursor.parent, data.viewItem);
        Object.assign(data, childrenResult);
        evt.stop();
    };
}
function $b9b9f2bdf9c6137f$var$convertToModelElement(mapper) {
    return (evt, data, conversionApi)=>{
        const elementName = data.viewItem.name;
        if (!conversionApi.schema.checkChild(data.modelCursor, elementName)) throw new Error(`Element '${elementName}' was not allowed in given position.`);
        const attributes = $b9b9f2bdf9c6137f$var$convertAttributes(data.viewItem.getAttributes(), $b9b9f2bdf9c6137f$var$parseAttributeValue);
        const element = conversionApi.writer.createElement(data.viewItem.name, attributes);
        conversionApi.writer.insert(element, data.modelCursor);
        mapper.bindElements(element, data.viewItem);
        conversionApi.convertChildren(data.viewItem, element);
        data.modelRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createOn(element);
        data.modelCursor = data.modelRange.end;
        evt.stop();
    };
}
function $b9b9f2bdf9c6137f$var$convertToModelText() {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.schema.checkChild(data.modelCursor, "$text")) throw new Error("Text was not allowed in given position.");
        let node;
        if (data.viewItem.is("element")) {
            const attributes = $b9b9f2bdf9c6137f$var$convertAttributes(data.viewItem.getAttributes(), $b9b9f2bdf9c6137f$var$parseAttributeValue);
            const viewText = data.viewItem.getChild(0);
            node = conversionApi.writer.createText(viewText.data, attributes);
        } else node = conversionApi.writer.createText(data.viewItem.data);
        conversionApi.writer.insert(node, data.modelCursor);
        data.modelRange = $b9b9f2bdf9c6137f$export$a3091252a5e626ba._createFromPositionAndShift(data.modelCursor, node.offsetSize);
        data.modelCursor = data.modelRange.end;
        evt.stop();
    };
}
function $b9b9f2bdf9c6137f$var$parseAttributeValue(attribute) {
    try {
        return JSON.parse(attribute);
    } catch  {
        return attribute;
    }
}
function $b9b9f2bdf9c6137f$var$stringifyAttributeValue(data) {
    if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(data)) return JSON.stringify(data);
    return data;
}
function* $b9b9f2bdf9c6137f$var$convertAttributes(attributes, converter) {
    for (const [key, value] of attributes)yield [
        key,
        converter(value)
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Note: This package is used only internally for debugging purposes and should not be used
* in other environments. It uses a few special methods not existing in the default
* building process. That is also why there are no tests for this file.
*
* @module engine/dev-utils/utils
*/ /**
* Helper function, converts a map to the 'key1="value1" key2="value1"' format.
*
* @param map Map to convert.
* @returns Converted map.
* @internal
*/ function $b9b9f2bdf9c6137f$export$8b9d3f796d96369d(map) {
    let string = "";
    for (const entry of map)string += ` ${entry[0]}=${JSON.stringify(entry[1])}`;
    return string;
}
/**
* Helper function, converts a map to the `{"key1":"value1","key2":"value2"}` format.
*
* @param map Map to convert.
* @returns Converted map.
* @internal
*/ function $b9b9f2bdf9c6137f$export$2972522f0e60e266(map) {
    const obj = {};
    for (const entry of map)obj[entry[0]] = entry[1];
    return JSON.stringify(obj);
}
const $b9b9f2bdf9c6137f$var$treeDump = Symbol("_treeDump");
const $b9b9f2bdf9c6137f$var$maxTreeDumpLength = 20;
/**
* Helper function that stores the `document` state for a given `version`.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$3b83199687b07f47(document1, version) {
    console.log(document1, version);
    let string = "";
    for (const root of document1.roots)string += root.printTree() + "\n";
    document1[$b9b9f2bdf9c6137f$var$treeDump][version] = string.substr(0, string.length - 1);
    const overflow = document1[$b9b9f2bdf9c6137f$var$treeDump].length - $b9b9f2bdf9c6137f$var$maxTreeDumpLength;
    if (overflow > 0) document1[$b9b9f2bdf9c6137f$var$treeDump][overflow - 1] = null;
}
/**
* Helper function that initializes document dumping.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$ea24d6979abcd534(document1) {
    document1[$b9b9f2bdf9c6137f$var$treeDump] = [];
}
/**
* Helper function that logs document for the given version.
*
* @internal
*/ function $b9b9f2bdf9c6137f$export$7d55bdff754612fb(document1, version) {
    console.log("--------------------");
    if (document1[$b9b9f2bdf9c6137f$var$treeDump][version]) console.log(document1[$b9b9f2bdf9c6137f$var$treeDump][version]);
    else console.log("Tree log unavailable for given version: " + version);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module engine/dev-utils/operationreplayer
*/ /**
* Operation replayer is a development tool created for easy replaying of operations on the document from stringified operations.
*
* @internal
*/ var $b9b9f2bdf9c6137f$export$f26ac23f5eff5f3b = class {
    _model;
    _logSeparator;
    _operationsToReplay;
    /**
	* @param model Data model.
	* @param logSeparator Separator between operations.
	* @param stringifiedOperations Operations to replay.
	*/ constructor(model, logSeparator, stringifiedOperations){
        this._model = model;
        this._logSeparator = logSeparator;
        this.setStringifiedOperations(stringifiedOperations);
    }
    /**
	* Parses the given string containing stringified operations and sets parsed operations as operations to replay.
	*
	* @param stringifiedOperations Stringified operations to replay.
	*/ setStringifiedOperations(stringifiedOperations) {
        if (stringifiedOperations === "") {
            this._operationsToReplay = [];
            return;
        }
        this._operationsToReplay = stringifiedOperations.split(this._logSeparator).map((stringifiedOperation)=>JSON.parse(stringifiedOperation));
    }
    /**
	* Returns operations to replay.
	*/ getOperationsToReplay() {
        return this._operationsToReplay;
    }
    /**
	* Applies all operations with a delay between actions.
	*
	* @param timeInterval Time between applying operations.
	*/ play(timeInterval = 1e3) {
        const operationReplayer = this;
        return new Promise((res, rej)=>{
            play();
            function play() {
                operationReplayer.applyNextOperation().then((isFinished)=>{
                    if (isFinished) return res();
                    setTimeout(play, timeInterval);
                }).catch((err)=>{
                    rej(err);
                });
            }
        });
    }
    /**
	* Applies `numberOfOperations` operations, beginning after the last applied operation (or first, if no operations were applied).
	*
	* @param numberOfOperations The number of operations to apply.
	*/ applyOperations(numberOfOperations) {
        if (numberOfOperations <= 0) return;
        return this.applyNextOperation().then((isFinished)=>{
            if (!isFinished) return this.applyOperations(numberOfOperations - 1);
        });
    }
    /**
	* Applies all operations to replay at once.
	*/ applyAllOperations() {
        return this.applyNextOperation().then((isFinished)=>{
            if (!isFinished) return this.applyAllOperations();
        });
    }
    /**
	* Applies the next operation to replay. Returns a promise with the `isFinished` parameter that is `true` if the last
	* operation in the replayer has been applied, `false` otherwise.
	*/ applyNextOperation() {
        const model = this._model;
        return new Promise((res)=>{
            model.enqueueChange((writer)=>{
                const operationJson = this._operationsToReplay.shift();
                if (!operationJson) return res(true);
                const operation = $b9b9f2bdf9c6137f$export$3420ec38c4e386fa.fromJSON(operationJson, model.document);
                writer.batch.addOperation(operation);
                model.applyOperation(operation);
                res(false);
            });
        });
    }
};


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/plugin
*/ const $7ca4ca5784e50ca9$var$PluginBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The base class for CKEditor plugin classes.
*/ var $7ca4ca5784e50ca9$export$901cf72dabf2112a = class extends $7ca4ca5784e50ca9$var$PluginBase {
    /**
	* The editor instance.
	*
	* Note that most editors implement the {@link module:core/editor/editor~Editor#ui} property.
	* However, editors with an external UI (i.e. Bootstrap-based) or a headless editor may not have this property or
	* throw an error when accessing it.
	*
	* Because of above, to make plugins more universal, it is recommended to split features into:
	*  - The "editing" part that uses the {@link module:core/editor/editor~Editor} class without `ui` property.
	*  - The "UI" part that uses the {@link module:core/editor/editor~Editor} class and accesses `ui` property.
	*/ editor;
    /**
	* Holds identifiers for {@link #forceDisabled} mechanism.
	*/ _disableStack = /* @__PURE__ */ new Set();
    /**
	* @inheritDoc
	*/ constructor(editor){
        super();
        this.editor = editor;
        this.set("isEnabled", true);
    }
    /**
	* Disables the plugin.
	*
	* Plugin may be disabled by multiple features or algorithms (at once). When disabling a plugin, unique id should be passed
	* (e.g. feature name). The same identifier should be used when {@link #clearForceDisabled enabling back} the plugin.
	* The plugin becomes enabled only after all features {@link #clearForceDisabled enabled it back}.
	*
	* Disabling and enabling a plugin:
	*
	* ```ts
	* plugin.isEnabled; // -> true
	* plugin.forceDisabled( 'MyFeature' );
	* plugin.isEnabled; // -> false
	* plugin.clearForceDisabled( 'MyFeature' );
	* plugin.isEnabled; // -> true
	* ```
	*
	* Plugin disabled by multiple features:
	*
	* ```ts
	* plugin.forceDisabled( 'MyFeature' );
	* plugin.forceDisabled( 'OtherFeature' );
	* plugin.clearForceDisabled( 'MyFeature' );
	* plugin.isEnabled; // -> false
	* plugin.clearForceDisabled( 'OtherFeature' );
	* plugin.isEnabled; // -> true
	* ```
	*
	* Multiple disabling with the same identifier is redundant:
	*
	* ```ts
	* plugin.forceDisabled( 'MyFeature' );
	* plugin.forceDisabled( 'MyFeature' );
	* plugin.clearForceDisabled( 'MyFeature' );
	* plugin.isEnabled; // -> true
	* ```
	*
	* **Note:** some plugins or algorithms may have more complex logic when it comes to enabling or disabling certain plugins,
	* so the plugin might be still disabled after {@link #clearForceDisabled} was used.
	*
	* @param id Unique identifier for disabling. Use the same id when {@link #clearForceDisabled enabling back} the plugin.
	*/ forceDisabled(id) {
        this._disableStack.add(id);
        if (this._disableStack.size == 1) {
            this.on("set:isEnabled", $7ca4ca5784e50ca9$var$forceDisable$1, {
                priority: "highest"
            });
            this.isEnabled = false;
        }
    }
    /**
	* Clears forced disable previously set through {@link #forceDisabled}. See {@link #forceDisabled}.
	*
	* @param id Unique identifier, equal to the one passed in {@link #forceDisabled} call.
	*/ clearForceDisabled(id) {
        this._disableStack.delete(id);
        if (this._disableStack.size == 0) {
            this.off("set:isEnabled", $7ca4ca5784e50ca9$var$forceDisable$1);
            this.isEnabled = true;
        }
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this.stopListening();
    }
    /**
	* @inheritDoc
	*/ static get isContextPlugin() {
        return false;
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get isOfficialPlugin() {
        return false;
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get isPremiumPlugin() {
        return false;
    }
};
/**
* Helper function that forces plugin to be disabled.
*/ function $7ca4ca5784e50ca9$var$forceDisable$1(evt) {
    evt.return = false;
    evt.stop();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/command
*/ const $7ca4ca5784e50ca9$var$CommandBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Base class for the CKEditor commands.
*
* Commands are the main way to manipulate the editor contents and state. They are mostly used by UI elements (or by other
* commands) to make changes in the model. Commands are available in every part of the code that has access to
* the {@link module:core/editor/editor~Editor editor} instance.
*
* Instances of registered commands can be retrieved from {@link module:core/editor/editor~Editor#commands `editor.commands`}.
* The easiest way to execute a command is through {@link module:core/editor/editor~Editor#execute `editor.execute()`}.
*
* By default, commands are disabled when the editor is in the {@link module:core/editor/editor~Editor#isReadOnly read-only} mode
* but commands with the {@link module:core/command~Command#affectsData `affectsData`} flag set to `false` will not be disabled.
*/ var $7ca4ca5784e50ca9$export$cc7e12c76513e857 = class extends $7ca4ca5784e50ca9$var$CommandBase {
    /**
	* The editor on which this command will be used.
	*/ editor;
    /**
	* A flag indicating whether a command's `isEnabled` state should be changed depending on where the document
	* selection is placed.
	*
	* By default, it is set to `true`. If the document selection is placed in a
	* {@link module:engine/model/model~Model#canEditAt non-editable} place (such as non-editable root), the command becomes disabled.
	*
	* The flag should be changed to `false` in a concrete command's constructor if the command should not change its `isEnabled`
	* accordingly to the document selection.
	*/ _isEnabledBasedOnSelection;
    /**
	* A flag indicating whether a command execution changes the editor data or not.
	*
	* @see #affectsData
	*/ _affectsData;
    /**
	* Holds identifiers for {@link #forceDisabled} mechanism.
	*/ _disableStack;
    /**
	* `Command` class is commonly put in `config.plugins` array.
	*
	* This property helps with better error detection.
	*
	* @internal
	*/ static get _throwErrorWhenUsedAsAPlugin() {
        return true;
    }
    /**
	* Creates a new `Command` instance.
	*
	* @param editor The editor on which this command will be used.
	*/ constructor(editor){
        super();
        this.editor = editor;
        this.set("value", void 0);
        this.set("isEnabled", false);
        this._affectsData = true;
        this._isEnabledBasedOnSelection = true;
        this._disableStack = /* @__PURE__ */ new Set();
        this.decorate("execute");
        this.listenTo(this.editor.model.document, "change", ()=>{
            this.refresh();
        });
        this.listenTo(editor, "change:isReadOnly", ()=>{
            this.refresh();
        });
        this.on("set:isEnabled", (evt)=>{
            if (!this.affectsData) return;
            const selection = editor.model.document.selection;
            const canEditAtSelection = !(selection.getFirstPosition().root.rootName == "$graveyard") && editor.model.canEditAt(selection);
            if (editor.isReadOnly || this._isEnabledBasedOnSelection && !canEditAtSelection) {
                evt.return = false;
                evt.stop();
            }
        }, {
            priority: "highest"
        });
        this.on("execute", (evt)=>{
            if (!this.isEnabled) evt.stop();
        }, {
            priority: "high"
        });
    }
    /**
	* A flag indicating whether a command execution changes the editor data or not.
	*
	* Commands with `affectsData` set to `false` will not be automatically disabled in
	* the {@link module:core/editor/editor~Editor#isReadOnly read-only mode} and
	* {@glink features/read-only#related-features other editor modes} with restricted user write permissions.
	*
	* **Note:** You do not have to set it for your every command. It is `true` by default.
	*
	* @default true
	*/ get affectsData() {
        return this._affectsData;
    }
    set affectsData(affectsData) {
        this._affectsData = affectsData;
    }
    /**
	* Refreshes the command. The command should update its {@link #isEnabled} and {@link #value} properties
	* in this method.
	*
	* This method is automatically called when
	* {@link module:engine/model/document~ModelDocument#event:change any changes are applied to the document}.
	*/ refresh() {
        this.isEnabled = true;
    }
    /**
	* Disables the command.
	*
	* Command may be disabled by multiple features or algorithms (at once). When disabling a command, unique id should be passed
	* (e.g. the feature name). The same identifier should be used when {@link #clearForceDisabled enabling back} the command.
	* The command becomes enabled only after all features {@link #clearForceDisabled enabled it back}.
	*
	* Disabling and enabling a command:
	*
	* ```ts
	* command.isEnabled; // -> true
	* command.forceDisabled( 'MyFeature' );
	* command.isEnabled; // -> false
	* command.clearForceDisabled( 'MyFeature' );
	* command.isEnabled; // -> true
	* ```
	*
	* Command disabled by multiple features:
	*
	* ```ts
	* command.forceDisabled( 'MyFeature' );
	* command.forceDisabled( 'OtherFeature' );
	* command.clearForceDisabled( 'MyFeature' );
	* command.isEnabled; // -> false
	* command.clearForceDisabled( 'OtherFeature' );
	* command.isEnabled; // -> true
	* ```
	*
	* Multiple disabling with the same identifier is redundant:
	*
	* ```ts
	* command.forceDisabled( 'MyFeature' );
	* command.forceDisabled( 'MyFeature' );
	* command.clearForceDisabled( 'MyFeature' );
	* command.isEnabled; // -> true
	* ```
	*
	* **Note:** some commands or algorithms may have more complex logic when it comes to enabling or disabling certain commands,
	* so the command might be still disabled after {@link #clearForceDisabled} was used.
	*
	* @param id Unique identifier for disabling. Use the same id when {@link #clearForceDisabled enabling back} the command.
	*/ forceDisabled(id) {
        this._disableStack.add(id);
        if (this._disableStack.size == 1) {
            this.on("set:isEnabled", $7ca4ca5784e50ca9$var$forceDisable, {
                priority: "highest"
            });
            this.isEnabled = false;
        }
    }
    /**
	* Clears forced disable previously set through {@link #forceDisabled}. See {@link #forceDisabled}.
	*
	* @param id Unique identifier, equal to the one passed in {@link #forceDisabled} call.
	*/ clearForceDisabled(id) {
        this._disableStack.delete(id);
        if (this._disableStack.size == 0) {
            this.off("set:isEnabled", $7ca4ca5784e50ca9$var$forceDisable);
            this.refresh();
        }
    }
    /**
	* Executes the command.
	*
	* A command may accept parameters. They will be passed from {@link module:core/editor/editor~Editor#execute `editor.execute()`}
	* to the command.
	*
	* The `execute()` method will automatically abort when the command is disabled ({@link #isEnabled} is `false`).
	* This behavior is implemented by a high priority listener to the {@link #event:execute} event.
	*
	* In order to see how to disable a command from "outside" see the {@link #isEnabled} documentation.
	*
	* This method may return a value, which would be forwarded all the way down to the
	* {@link module:core/editor/editor~Editor#execute `editor.execute()`}.
	*
	* @fires execute
	*/ execute(...args) {}
    /**
	* Destroys the command.
	*/ destroy() {
        this.stopListening();
    }
};
/**
* Helper function that forces command to be disabled.
*/ function $7ca4ca5784e50ca9$var$forceDisable(evt) {
    evt.return = false;
    evt.stop();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/multicommand
*/ /**
* A CKEditor command that aggregates other commands.
*
* This command is used to proxy multiple commands. The multi-command is enabled when
* at least one of its registered child commands is enabled.
* When executing a multi-command, the first enabled command with highest priority will be executed.
*
* ```ts
* const multiCommand = new MultiCommand( editor );
*
* const commandFoo = new Command( editor );
* const commandBar = new Command( editor );
*
* // Register a child command.
* multiCommand.registerChildCommand( commandFoo );
* // Register a child command with a low priority.
* multiCommand.registerChildCommand( commandBar, { priority: 'low' } );
*
* // Enable one of the commands.
* commandBar.isEnabled = true;
*
* multiCommand.execute(); // Will execute commandBar.
* ```
*/ var $7ca4ca5784e50ca9$export$83b9598429c26b85 = class extends $7ca4ca5784e50ca9$export$cc7e12c76513e857 {
    /**
	* Registered child commands definitions.
	*/ _childCommandsDefinitions = [];
    /**
	* @inheritDoc
	*/ refresh() {}
    /**
	* Executes the first enabled command which has the highest priority of all registered child commands.
	*
	* @returns The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
	*/ execute(...args) {
        const command = this._getFirstEnabledCommand();
        return !!command && command.execute(args);
    }
    /**
	* Registers a child command.
	*
	* @param options An object with configuration options.
	* @param options.priority Priority of a command to register.
	*/ registerChildCommand(command, options = {}) {
        (0, $c7bc2cb7e2db0227$export$d415007a4e865351)(this._childCommandsDefinitions, {
            command: command,
            priority: options.priority || "normal"
        });
        command.on("change:isEnabled", ()=>this._checkEnabled());
        this._checkEnabled();
    }
    /**
	* Checks if any of child commands is enabled.
	*/ _checkEnabled() {
        this.isEnabled = !!this._getFirstEnabledCommand();
    }
    /**
	* Returns a first enabled command with the highest priority or `undefined` if none of them is enabled.
	*/ _getFirstEnabledCommand() {
        const commandDefinition = this._childCommandsDefinitions.find(({ command: command })=>command.isEnabled);
        return commandDefinition && commandDefinition.command;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/commandcollection
*/ /**
* Collection of commands. Its instance is available in {@link module:core/editor/editor~Editor#commands `editor.commands`}.
*/ var $7ca4ca5784e50ca9$export$6b7de9fa8c10e581 = class {
    /**
	* Command map.
	*/ _commands;
    /**
	* Creates collection instance.
	*/ constructor(){
        this._commands = /* @__PURE__ */ new Map();
    }
    /**
	* Registers a new command.
	*
	* @param commandName The name of the command.
	*/ add(commandName, command) {
        this._commands.set(commandName, command);
    }
    /**
	* Retrieves a command from the collection.
	*
	* @param commandName The name of the command.
	*/ get(commandName) {
        return this._commands.get(commandName);
    }
    /**
	* Executes a command.
	*
	* @param commandName The name of the command.
	* @param commandParams Command parameters.
	* @returns The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
	*/ execute(commandName, ...commandParams) {
        const command = this.get(commandName);
        if (!command) /**
		* Command does not exist.
		*
		* @error commandcollection-command-not-found
		* @param {string} commandName Name of the command.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("commandcollection-command-not-found", this, {
            commandName: commandName
        });
        return command.execute(...commandParams);
    }
    /**
	* Returns iterator of command names.
	*/ *names() {
        yield* this._commands.keys();
    }
    /**
	* Returns iterator of command instances.
	*/ *commands() {
        yield* this._commands.values();
    }
    /**
	* Iterable interface.
	*
	* Returns `[ commandName, commandInstance ]` pairs.
	*/ [Symbol.iterator]() {
        return this._commands[Symbol.iterator]();
    }
    /**
	* Destroys all collection commands.
	*/ destroy() {
        for (const command of this.commands())command.destroy();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/plugincollection
*/ const $7ca4ca5784e50ca9$var$PluginCollectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Manages a list of CKEditor plugins, including loading, resolving dependencies and initialization.
*/ var $7ca4ca5784e50ca9$export$5908a802ac6e3d12 = class extends $7ca4ca5784e50ca9$var$PluginCollectionBase {
    _context;
    _plugins = /* @__PURE__ */ new Map();
    /**
	* A map of plugin constructors that can be retrieved by their names.
	*/ _availablePlugins;
    /**
	* Map of {@link module:core/contextplugin~ContextPlugin context plugins} which can be retrieved by their constructors or instances.
	*/ _contextPlugins;
    /**
	* Creates an instance of the plugin collection class.
	* Allows loading and initializing plugins and their dependencies.
	* Allows providing a list of already loaded plugins. These plugins will not be destroyed along with this collection.
	*
	* @param availablePlugins Plugins (constructors) which the collection will be able to use
	* when {@link module:core/plugincollection~PluginCollection#init} is used with the plugin names (strings, instead of constructors).
	* Usually, the editor will pass its built-in plugins to the collection so they can later be
	* used in `config.plugins` or `config.removePlugins` by names.
	* @param contextPlugins A list of already initialized plugins represented by a `[ PluginConstructor, pluginInstance ]` pair.
	*/ constructor(context, availablePlugins = [], contextPlugins = []){
        super();
        this._context = context;
        this._availablePlugins = /* @__PURE__ */ new Map();
        for (const PluginConstructor of availablePlugins)if (PluginConstructor.pluginName) this._availablePlugins.set(PluginConstructor.pluginName, PluginConstructor);
        this._contextPlugins = /* @__PURE__ */ new Map();
        for (const [PluginConstructor, pluginInstance] of contextPlugins){
            this._contextPlugins.set(PluginConstructor, pluginInstance);
            this._contextPlugins.set(pluginInstance, PluginConstructor);
            if (PluginConstructor.pluginName) this._availablePlugins.set(PluginConstructor.pluginName, PluginConstructor);
        }
    }
    /**
	* Iterable interface.
	*
	* Returns `[ PluginConstructor, pluginInstance ]` pairs.
	*/ *[Symbol.iterator]() {
        for (const entry of this._plugins)if (typeof entry[0] == "function") yield entry;
    }
    /**
	* Gets the plugin instance by its constructor or name.
	*
	* ```ts
	* // Check if 'Clipboard' plugin was loaded.
	* if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
	* 	// Get clipboard plugin instance
	* 	const clipboard = editor.plugins.get( 'ClipboardPipeline' );
	*
	* 	this.listenTo( clipboard, 'inputTransformation', ( evt, data ) => {
	* 		// Do something on clipboard input.
	* 	} );
	* }
	* ```
	*
	* **Note**: This method will throw an error if a plugin is not loaded. Use `{@link #has editor.plugins.has()}`
	* to check if a plugin is available.
	*
	* @param key The plugin constructor or {@link module:core/plugin~PluginStaticMembers#pluginName name}.
	*/ get(key) {
        const plugin = this._plugins.get(key);
        if (!plugin) {
            let pluginName = key;
            if (typeof key == "function") pluginName = key.pluginName || key.name;
            /**
			* The plugin is not loaded and could not be obtained.
			*
			* Plugin classes (constructors) need to be provided to the editor and must be loaded before they can be obtained from
			* the plugin collection.
			*
			* **Note**: You can use `{@link module:core/plugincollection~PluginCollection#has editor.plugins.has()}`
			* to check if a plugin was loaded.
			*
			* @error plugincollection-plugin-not-loaded
			* @param {string} plugin The name of the plugin which is not loaded.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-not-loaded", this._context, {
                plugin: pluginName
            });
        }
        return plugin;
    }
    /**
	* Checks if a plugin is loaded.
	*
	* ```ts
	* // Check if the 'Clipboard' plugin was loaded.
	* if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
	* 	// Now use the clipboard plugin instance:
	* 	const clipboard = editor.plugins.get( 'ClipboardPipeline' );
	*
	* 	// ...
	* }
	* ```
	*
	* @param key The plugin constructor or {@link module:core/plugin~PluginStaticMembers#pluginName name}.
	*/ has(key) {
        return this._plugins.has(key);
    }
    /**
	* Initializes a set of plugins and adds them to the collection.
	*
	* @param plugins An array of {@link module:core/plugin~PluginInterface plugin constructors}
	* or {@link module:core/plugin~PluginStaticMembers#pluginName plugin names}.
	* @param pluginsToRemove Names of the plugins or plugin constructors
	* that should not be loaded (despite being specified in the `plugins` array).
	* @param pluginsSubstitutions An array of {@link module:core/plugin~PluginInterface plugin constructors}
	* that will be used to replace plugins of the same names that were passed in `plugins` or that are in their dependency tree.
	* A useful option for replacing built-in plugins while creating tests (for mocking their APIs). Plugins that will be replaced
	* must follow these rules:
	*   * The new plugin must be a class.
	*   * The new plugin must be named.
	*   * Both plugins must not depend on other plugins.
	* @returns A promise which gets resolved once all plugins are loaded and available in the collection.
	*/ async init(plugins, pluginsToRemove = [], pluginsSubstitutions = []) {
        const that = this;
        const context = this._context;
        findAvailablePluginConstructors(plugins);
        validatePlugins(plugins);
        const pluginConstructors = [
            ...getPluginConstructors(plugins.filter((plugin)=>!isPluginRemoved(plugin, pluginsToRemove)))
        ];
        substitutePlugins(pluginConstructors, pluginsSubstitutions);
        const pluginInstances = loadPlugins(pluginConstructors);
        await initPlugins(pluginInstances, "init");
        await initPlugins(pluginInstances, "afterInit");
        return pluginInstances;
        function isPluginConstructor(plugin) {
            return typeof plugin === "function";
        }
        function isContextPlugin(plugin) {
            return isPluginConstructor(plugin) && !!plugin.isContextPlugin;
        }
        function isPluginRemoved(plugin, pluginsToRemove) {
            return pluginsToRemove.some((removedPlugin)=>{
                if (removedPlugin === plugin) return true;
                if (getPluginName(plugin) === removedPlugin) return true;
                if (getPluginName(removedPlugin) === plugin) return true;
                return false;
            });
        }
        function getPluginName(plugin) {
            return isPluginConstructor(plugin) ? plugin.pluginName || plugin.name : plugin;
        }
        function findAvailablePluginConstructors(plugins, processed = /* @__PURE__ */ new Set()) {
            plugins.forEach((plugin)=>{
                if (!isPluginConstructor(plugin)) return;
                if (processed.has(plugin)) return;
                processed.add(plugin);
                if (plugin.pluginName && !that._availablePlugins.has(plugin.pluginName)) that._availablePlugins.set(plugin.pluginName, plugin);
                if (plugin.requires) findAvailablePluginConstructors(plugin.requires, processed);
            });
        }
        function getPluginConstructors(plugins, processed = /* @__PURE__ */ new Set()) {
            return plugins.map((plugin)=>{
                return isPluginConstructor(plugin) ? plugin : that._availablePlugins.get(plugin);
            }).reduce((result, plugin)=>{
                if (processed.has(plugin)) return result;
                processed.add(plugin);
                if (plugin.requires) {
                    validatePlugins(plugin.requires, plugin);
                    getPluginConstructors(plugin.requires, processed).forEach((plugin)=>result.add(plugin));
                }
                return result.add(plugin);
            }, /* @__PURE__ */ new Set());
        }
        function validatePlugins(plugins, parentPluginConstructor = null) {
            plugins.map((plugin)=>{
                return isPluginConstructor(plugin) ? plugin : that._availablePlugins.get(plugin) || plugin;
            }).forEach((plugin)=>{
                checkPluginConstructor(plugin);
                checkMissingPlugin(plugin, parentPluginConstructor);
                checkContextPlugin(plugin, parentPluginConstructor);
                checkRemovedPlugin(plugin, parentPluginConstructor);
            });
        }
        function checkPluginConstructor(plugin) {
            if (typeof plugin !== "function") return;
            if (plugin._throwErrorWhenUsedAsAPlugin) /**
			* The provided class constructor is not a plugin.
			*
			* This error is usually caused by passing an editor, context, or command
			* constructor in the `config.plugins` array.
			*
			* @param {String} name The name of the provided constructor.
			* @error plugincollection-plugin-invalid-constructor
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-invalid-constructor", context, {
                name: plugin.name
            });
        }
        function checkMissingPlugin(plugin, parentPluginConstructor) {
            if (isPluginConstructor(plugin)) return;
            if (parentPluginConstructor) /**
			* A required "soft" dependency was not found on the plugin list.
			*
			* When configuring the editor, either prior to building (via
			* {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}) or when
			* creating a new instance of the editor (e.g. via
			* {@link module:core/editor/editorconfig~EditorConfig#plugins `config.plugins`}), you need to provide
			* some of the dependencies for other plugins that you used.
			*
			* This error is thrown when one of these dependencies was not provided. The name of the missing plugin
			* can be found in `missingPlugin` and the plugin that required it in `requiredBy`.
			*
			* In order to resolve it, you need to import the missing plugin and add it to the
			* current list of plugins (`Editor.builtinPlugins` or `config.plugins`/`config.extraPlugins`).
			*
			* Soft requirements were introduced in version 26.0.0. If you happen to stumble upon this error
			* when upgrading to version 26.0.0, read also the `Update to v26.x` section in the
			* {@glink updating/guides/updating-from-older-versions updating from older versions} guide.
			*
			* @error plugincollection-soft-required
			* @param {string} missingPlugin The name of the required plugin.
			* @param {string} requiredBy The name of the plugin that requires the other plugin.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-soft-required", context, {
                missingPlugin: plugin,
                requiredBy: getPluginName(parentPluginConstructor)
            });
            /**
			* A plugin is not available and could not be loaded.
			*
			* Plugin classes (constructors) need to be provided to the editor before they can be loaded by name.
			* This is usually done in the now deprecated CKEditor 5 builds by setting
			* the {@link module:core/editor/editor~Editor.builtinPlugins} property.
			*
			* **If you see this warning when using one of the deprecated CKEditor 5 Builds**,
			* it means that you tried to enable a plugin that was not included in that build. This may be due to a typo
			* in the plugin name or simply because that plugin was not a part of this build.
			*
			* **Predefined builds are no longer supported and you need to
			* {@glink updating/nim-migration/migration-to-new-installation-methods migrate to new installation methods}**.
			*
			* **If you see this warning when using one of the editor creators directly** (not a build), then it means
			* that you tried loading plugins by name. However, unlike CKEditor 4, CKEditor 5 does not implement a "plugin loader".
			* This means that CKEditor 5 does not know where to load the plugin modules from. Therefore, you need to
			* provide each plugin through a reference (as a constructor function). Check out the examples in the
			* {@glink getting-started/installation/cloud/quick-start Quick start} guide.
			*
			* @error plugincollection-plugin-not-found
			* @param {string} plugin The name of the plugin which could not be loaded.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-not-found", context, {
                plugin: plugin
            });
        }
        function checkContextPlugin(plugin, parentPluginConstructor) {
            if (!isContextPlugin(parentPluginConstructor)) return;
            if (isContextPlugin(plugin)) return;
            /**
			* If a plugin is a context plugin, all plugins it requires should also be context plugins
			* instead of plugins. In other words, if one plugin can be used in the context,
			* all its requirements should also be ready to be used in the context. Note that the context
			* provides only a part of the API provided by the editor. If one plugin needs a full
			* editor API, all plugins which require it are considered as plugins that need a full
			* editor API.
			*
			* @error plugincollection-context-required
			* @param {string} plugin The name of the required plugin.
			* @param {string} requiredBy The name of the parent plugin.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-context-required", context, {
                plugin: getPluginName(plugin),
                requiredBy: getPluginName(parentPluginConstructor)
            });
        }
        function checkRemovedPlugin(plugin, parentPluginConstructor) {
            if (!parentPluginConstructor) return;
            if (!isPluginRemoved(plugin, pluginsToRemove)) return;
            /**
			* Cannot load a plugin because one of its dependencies is listed in the `removePlugins` option.
			*
			* @error plugincollection-required
			* @param {string} plugin The name of the required plugin.
			* @param {string} requiredBy The name of the parent plugin.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-required", context, {
                plugin: getPluginName(plugin),
                requiredBy: getPluginName(parentPluginConstructor)
            });
        }
        function loadPlugins(pluginConstructors) {
            return pluginConstructors.map((PluginConstructor)=>{
                let pluginInstance = that._contextPlugins.get(PluginConstructor);
                pluginInstance = pluginInstance || new PluginConstructor(context);
                that._add(PluginConstructor, pluginInstance);
                return pluginInstance;
            });
        }
        function initPlugins(pluginInstances, method) {
            return pluginInstances.reduce((promise, plugin)=>{
                if (!plugin[method]) return promise;
                if (that._contextPlugins.has(plugin)) return promise;
                return promise.then(plugin[method].bind(plugin));
            }, Promise.resolve());
        }
        /**
		* Replaces plugin constructors with the specified set of plugins.
		*/ function substitutePlugins(pluginConstructors, pluginsSubstitutions) {
            for (const pluginItem of pluginsSubstitutions){
                if (typeof pluginItem != "function") /**
				* The plugin replacing an existing plugin must be a function.
				*
				* @error plugincollection-replace-plugin-invalid-type
				* @param {never} pluginItem The plugin item.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-replace-plugin-invalid-type", null, {
                    pluginItem: pluginItem
                });
                const pluginName = pluginItem.pluginName;
                if (!pluginName) /**
				* The plugin replacing an existing plugin must have a name.
				*
				* @error plugincollection-replace-plugin-missing-name
				* @param {module:core/plugin~PluginConstructor} pluginItem The plugin item.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-replace-plugin-missing-name", null, {
                    pluginItem: pluginItem
                });
                if (pluginItem.requires && pluginItem.requires.length) /**
				* The plugin replacing an existing plugin cannot depend on other plugins.
				*
				* @error plugincollection-plugin-for-replacing-cannot-have-dependencies
				* @param {string} pluginName The name of the plugin.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                    pluginName: pluginName
                });
                const pluginToReplace = that._availablePlugins.get(pluginName);
                if (!pluginToReplace) /**
				* The replaced plugin does not exist in the
				* {@link module:core/plugincollection~PluginCollection available plugins} collection.
				*
				* @error plugincollection-plugin-for-replacing-not-exist
				* @param {string} pluginName The name of the plugin.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-for-replacing-not-exist", null, {
                    pluginName: pluginName
                });
                const indexInPluginConstructors = pluginConstructors.indexOf(pluginToReplace);
                if (indexInPluginConstructors === -1) {
                    if (that._contextPlugins.has(pluginToReplace)) return;
                    /**
					* The replaced plugin will not be loaded so it cannot be replaced.
					*
					* @error plugincollection-plugin-for-replacing-not-loaded
					* @param {string} pluginName The name of the plugin.
					*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-for-replacing-not-loaded", null, {
                        pluginName: pluginName
                    });
                }
                if (pluginToReplace.requires && pluginToReplace.requires.length) /**
				* The replaced plugin cannot depend on other plugins.
				*
				* @error plugincollection-replaced-plugin-cannot-have-dependencies
				* @param {string} pluginName The name of the plugin.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                    pluginName: pluginName
                });
                pluginConstructors.splice(indexInPluginConstructors, 1, pluginItem);
                that._availablePlugins.set(pluginName, pluginItem);
            }
        }
    }
    /**
	* Destroys all loaded plugins.
	*/ destroy() {
        const promises = [];
        for (const [, pluginInstance] of this)if (typeof pluginInstance.destroy == "function" && !this._contextPlugins.has(pluginInstance)) promises.push(pluginInstance.destroy());
        return Promise.all(promises);
    }
    /**
	* Adds the plugin to the collection. Exposed mainly for testing purposes.
	*
	* @param PluginConstructor The plugin constructor.
	* @param plugin The instance of the plugin.
	*/ _add(PluginConstructor, plugin) {
        this._plugins.set(PluginConstructor, plugin);
        const pluginName = PluginConstructor.pluginName;
        if (!pluginName) return;
        if (this._plugins.has(pluginName)) /**
		* Two plugins with the same {@link module:core/plugin~PluginStaticMembers#pluginName} were loaded.
		* This will lead to runtime conflicts between these plugins.
		*
		* In practice, this warning usually means that new plugins were added to an existing CKEditor 5 build.
		* Plugins should always be added to a source version of the editor (`@ckeditor/ckeditor5-editor-*`),
		* not to an editor imported from one of the `@ckeditor/ckeditor5-build-*` packages.
		*
		* Check your import paths and the list of plugins passed to
		* {@link module:core/editor/editor~Editor.create `Editor.create()`}
		* or specified in {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}.
		*
		* Predefined builds are a deprecated solution and we strongly advise
		* {@glink updating/nim-migration/migration-to-new-installation-methods migrating to new installation methods}.
		*
		* The second option is that your `node_modules/` directory contains duplicated versions of the same
		* CKEditor 5 packages. Normally, on clean installations, npm deduplicates packages in `node_modules/`, so
		* it may be enough to call `rm -rf node_modules && npm i`. However, if you installed conflicting versions
		* of some packages, their dependencies may need to be installed in more than one version which may lead to this
		* warning.
		*
		* Technically speaking, this error occurs because after adding a plugin to an existing editor build
		* the dependencies of this plugin are being duplicated.
		* They are already built into that editor build and now get added for the second time as dependencies
		* of the plugin you are installing.
		*
		* @error plugincollection-plugin-name-conflict
		* @param {string} pluginName The duplicated plugin name.
		* @param {module:core/plugin~PluginConstructor} plugin1 The first plugin constructor.
		* @param {module:core/plugin~PluginConstructor} plugin2 The second plugin constructor.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("plugincollection-plugin-name-conflict", null, {
            pluginName: pluginName,
            plugin1: this._plugins.get(pluginName).constructor,
            plugin2: PluginConstructor
        });
        this._plugins.set(pluginName, plugin);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/errorattribution/getsubnodes
*/ /**
* @internal
*/ function $7ca4ca5784e50ca9$var$getSubNodes(head, excludedProperties = /* @__PURE__ */ new Set()) {
    const nodes = [
        head
    ];
    const subNodes = /* @__PURE__ */ new Set();
    let nodeIndex = 0;
    while(nodes.length > nodeIndex){
        const node = nodes[nodeIndex++];
        if (subNodes.has(node) || !$7ca4ca5784e50ca9$var$shouldNodeBeIncluded(node) || excludedProperties.has(node)) continue;
        subNodes.add(node);
        if (Symbol.iterator in node) try {
            for (const n of node)nodes.push(n);
        } catch  {}
        else for(const key in node){
            if (key === "defaultValue") continue;
            nodes.push(node[key]);
        }
    }
    return subNodes;
}
function $7ca4ca5784e50ca9$var$shouldNodeBeIncluded(node) {
    const type = Object.prototype.toString.call(node);
    const typeOfNode = typeof node;
    return !(typeOfNode === "number" || typeOfNode === "boolean" || typeOfNode === "string" || typeOfNode === "symbol" || typeOfNode === "function" || type === "[object Date]" || type === "[object RegExp]" || type === "[object Module]" || node === void 0 || node === null || node._watchdogExcluded || node instanceof EventTarget || node instanceof Event);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Editors that are currently ready.
*
* Error attribution walks object graphs, and that walk answers "is this reachable from that" — a test
* between two objects rather than a lookup. Naming what an error belongs to therefore means running the
* test once per live editor, and this is the list to run it against.
*
* Held weakly. An editor is removed when it is destroyed, but an integrator may simply drop one instead —
* a single-page application changing route, for example. Holding those strongly would keep an editor alive
* that nothing else refers to, turning a leak that garbage collection would have cleaned up into one that
* it cannot.
*
* Temporary. It exists only for as long as attribution walks graphs; once every object that may be passed
* as an error context can name its editor directly, the answer is a single property read and this module
* goes away. It is kept behind functions rather than exposed as the set itself, and it is deliberately not
* exported from the package index, so that removal is not a breaking change.
*/ const $7ca4ca5784e50ca9$var$editors = /* @__PURE__ */ new Set();
/**
* Adds an editor to the list of the ones error attribution may be asked about.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$_addLiveEditor(editor) {
    $7ca4ca5784e50ca9$var$editors.add(new WeakRef(editor));
}
/**
* Removes an editor from the list of the ones error attribution may be asked about.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$_removeLiveEditor(editor) {
    for (const reference of $7ca4ca5784e50ca9$var$editors)if (reference.deref() === editor) {
        $7ca4ca5784e50ca9$var$editors.delete(reference);
        return;
    }
}
/**
* The editors error attribution may be asked about, in the order they became ready.
*
* References whose editor has been collected are dropped on the way through. That is the only cleanup
* there is, and it is enough: the list is read whenever an error is reported, and an entry left behind
* until then costs one dead reference.
*
* @internal
*/ function* $7ca4ca5784e50ca9$var$_getLiveEditors() {
    yield* $7ca4ca5784e50ca9$var$read($7ca4ca5784e50ca9$var$editors);
}
/**
* Contexts an integrator created, held the same way and for the same reason as the editors above.
*
* A context created by an editor for itself is not here. It holds that editor alone, so asking it would
* only repeat what asking the editor already answered.
*/ const $7ca4ca5784e50ca9$var$contexts = /* @__PURE__ */ new Set();
/**
* Adds a context to the list of the ones error attribution may be asked about.
*
* Adding one twice registers it once, the way adding to a set does. Removal takes one entry, so a second
* registration would outlive the removal on destroy and a destroyed context would keep being named.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$_addLiveContext(context) {
    if ($7ca4ca5784e50ca9$var$_isLiveContext(context)) return;
    $7ca4ca5784e50ca9$var$contexts.add(new WeakRef(context));
}
/**
* Removes a context from the list of the ones error attribution may be asked about.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$_removeLiveContext(context) {
    for (const reference of $7ca4ca5784e50ca9$var$contexts)if (reference.deref() === context) {
        $7ca4ca5784e50ca9$var$contexts.delete(reference);
        return;
    }
}
/**
* The contexts error attribution may be asked about, in the order they were created.
*
* @internal
*/ function* $7ca4ca5784e50ca9$var$_getLiveContexts() {
    yield* $7ca4ca5784e50ca9$var$read($7ca4ca5784e50ca9$var$contexts);
}
/**
* Whether the context is one of those attribution may name.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$_isLiveContext(context) {
    for (const liveContext of $7ca4ca5784e50ca9$var$_getLiveContexts())if (liveContext === context) return true;
    return false;
}
/**
* Yields what is still alive, dropping the references whose object has been collected on the way through.
*/ function* $7ca4ca5784e50ca9$var$read(references) {
    for (const reference of references){
        const value = reference.deref();
        if (value) yield value;
        else references.delete(reference);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/errorattribution/areconnectedthroughproperties
*/ /**
* Traverses both structures to find out whether there is a reference that is shared between both structures.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$areConnectedThroughProperties(target1, target2, excludedNodes = /* @__PURE__ */ new Set()) {
    if (target1 === target2 && $7ca4ca5784e50ca9$var$isObject(target1)) return true;
    const subNodes1 = $7ca4ca5784e50ca9$var$getSubNodes(target1, excludedNodes);
    const subNodes2 = $7ca4ca5784e50ca9$var$getSubNodes(target2, excludedNodes);
    for (const node of subNodes1)if (subNodes2.has(node)) return true;
    return false;
}
function $7ca4ca5784e50ca9$var$isObject(structure) {
    return typeof structure === "object" && structure !== null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editingkeystrokehandler
*/ /**
* A keystroke handler for editor editing. Its instance is available
* in {@link module:core/editor/editor~Editor#keystrokes} so plugins
* can register their keystrokes.
*
* E.g. an undo plugin would do this:
*
* ```ts
* editor.keystrokes.set( 'Ctrl+Z', 'undo' );
* editor.keystrokes.set( 'Ctrl+Shift+Z', 'redo' );
* editor.keystrokes.set( 'Ctrl+Y', 'redo' );
* ```
*/ var $7ca4ca5784e50ca9$export$acdfeffa549276f2 = class extends (0, $c7bc2cb7e2db0227$export$a783915b2b108628) {
    /**
	* The editor instance.
	*/ editor;
    /**
	* Creates an instance of the keystroke handler.
	*/ constructor(editor){
        super();
        this.editor = editor;
    }
    /**
	* Registers a handler for the specified keystroke.
	*
	* The handler can be specified as a command name or a callback.
	*
	* @param keystroke Keystroke defined in a format accepted by
	* the {@link module:utils/keyboard~parseKeystroke} function.
	* @param callback If a string is passed, then the keystroke will
	* {@link module:core/editor/editor~Editor#execute execute a command}.
	* If a function, then it will be called with the
	* {@link module:engine/view/observer/keyobserver~ViewDocumentKeyEventData key event data} object and
	* a `cancel()` helper to both `preventDefault()` and `stopPropagation()` of the event.
	* @param options Additional options.
	* @param options.priority The priority of the keystroke callback. The higher the priority value
	* the sooner the callback will be executed. Keystrokes having the same priority
	* are called in the order they were added.
	*/ set(keystroke, callback, options = {}) {
        if (typeof callback == "string") {
            const commandName = callback;
            callback = (evtData, cancel)=>{
                this.editor.execute(commandName);
                cancel();
            };
        }
        super.set(keystroke, callback, options);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/accessibility
*/ const $7ca4ca5784e50ca9$var$DEFAULT_CATEGORY_ID = "contentEditing";
/**
* @internal
*/ const $7ca4ca5784e50ca9$export$bd262f07e0d166f7 = "common";
/**
* A common namespace for various accessibility features of the editor.
*
* **Information about editor keystrokes**
*
* * The information about keystrokes available in the editor is stored in the {@link #keystrokeInfos} property.
* * New info entries can be added using the {@link #addKeystrokeInfoCategory}, {@link #addKeystrokeInfoGroup},
* and {@link #addKeystrokeInfos} methods.
*/ var $7ca4ca5784e50ca9$export$ea0f6181e3388ffd = class {
    /**
	* Stores information about keystrokes brought by editor features for the users to interact with the editor, mainly
	* keystroke combinations and their accessible labels.
	*
	* This information is particularly useful for screen reader and other assistive technology users. It gets displayed
	* by the {@link module:ui/editorui/accessibilityhelp/accessibilityhelp~AccessibilityHelp Accessibility help} dialog.
	*
	* Keystrokes are organized in categories and groups. They can be added using ({@link #addKeystrokeInfoCategory},
	* {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfos}) methods.
	*
	* Please note that:
	* * two categories are always available:
	*   * `'contentEditing'` for keystrokes related to content creation,
	*   * `'navigation'` for keystrokes related to navigation in the UI and the content.
	* * unless specified otherwise, new keystrokes are added into the `'contentEditing'` category and the `'common'`
	* keystroke group within that category while using the {@link #addKeystrokeInfos} method.
	*/ keystrokeInfos = /* @__PURE__ */ new Map();
    /**
	* The editor instance.
	*/ _editor;
    /**
	* @inheritDoc
	*/ constructor(editor){
        this._editor = editor;
        const isMenuBarVisible = editor.config.get("menuBar.isVisible");
        const t = editor.locale.t;
        this.addKeystrokeInfoCategory({
            id: $7ca4ca5784e50ca9$var$DEFAULT_CATEGORY_ID,
            label: t("Content editing keystrokes"),
            description: t("These keyboard shortcuts allow for quick access to content editing features.")
        });
        const navigationKeystrokes = [
            {
                label: t("Close contextual balloons, dropdowns, and dialogs"),
                keystroke: "Esc"
            },
            {
                label: t("Open the accessibility help dialog"),
                keystroke: "Alt+0"
            },
            {
                label: t("Move focus between form fields (inputs, buttons, etc.)"),
                keystroke: [
                    [
                        "Tab"
                    ],
                    [
                        "Shift+Tab"
                    ]
                ]
            },
            {
                label: t("Move focus to the toolbar, navigate between toolbars"),
                keystroke: "Alt+F10",
                mayRequireFn: true
            },
            {
                label: t("Navigate through the toolbar or menu bar"),
                keystroke: [
                    [
                        "arrowup"
                    ],
                    [
                        "arrowright"
                    ],
                    [
                        "arrowdown"
                    ],
                    [
                        "arrowleft"
                    ]
                ]
            },
            {
                label: t("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
                keystroke: [
                    [
                        "Enter"
                    ],
                    [
                        "Space"
                    ]
                ]
            }
        ];
        if (isMenuBarVisible) navigationKeystrokes.push({
            label: t("Move focus to the menu bar, navigate between menu bars"),
            keystroke: "Alt+F9",
            mayRequireFn: true
        });
        this.addKeystrokeInfoCategory({
            id: "navigation",
            label: t("User interface and content navigation keystrokes"),
            description: t("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
            groups: [
                {
                    id: "common",
                    keystrokes: navigationKeystrokes
                }
            ]
        });
    }
    /**
	* Adds a top-level category in the {@link #keystrokeInfos keystroke information database} with a label and optional description.
	*
	* Categories organize keystrokes and help users to find the right keystroke. Each category can have multiple groups
	* of keystrokes that narrow down the context in which the keystrokes are available. Every keystroke category comes
	* with a `'common'` group by default.
	*
	* By default, two categories are available:
	* * `'contentEditing'` for keystrokes related to content creation,
	* * `'navigation'` for keystrokes related to navigation in the UI and the content.
	*
	* To create a new keystroke category with new groups, use the following code:
	*
	* ```js
	* class MyPlugin extends Plugin {
	* 	// ...
	* 	init() {
	* 		const editor = this.editor;
	* 		const t = editor.t;
	*
	* 		// ...
	*
	* 		editor.accessibility.addKeystrokeInfoCategory( {
	* 			id: 'myCategory',
	* 			label: t( 'My category' ),
	* 			description: t( 'My category description.' ),
	* 			groups: [
	* 				{
	* 					id: 'myGroup',
	* 					label: t( 'My keystroke group' ),
	* 					keystrokes: [
	* 						{
	* 							label: t( 'Keystroke label 1' ),
	* 							keystroke: 'Ctrl+Shift+N'
	* 						},
	* 						{
	* 							label: t( 'Keystroke label 2' ),
	* 							keystroke: 'Ctrl+Shift+M'
	* 						}
	* 					]
	* 				}
	* 			]
	* 		};
	* 	}
	* }
	* ```
	*
	* See {@link #keystrokeInfos}, {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfos}.
	*/ addKeystrokeInfoCategory({ id: id, label: label, description: description, groups: groups }) {
        this.keystrokeInfos.set(id, {
            id: id,
            label: label,
            description: description,
            groups: /* @__PURE__ */ new Map()
        });
        this.addKeystrokeInfoGroup({
            categoryId: id,
            id: $7ca4ca5784e50ca9$export$bd262f07e0d166f7
        });
        if (groups) groups.forEach((group)=>{
            this.addKeystrokeInfoGroup({
                categoryId: id,
                ...group
            });
        });
    }
    /**
	* Adds a group of keystrokes in a specific category to the {@link #keystrokeInfos keystroke information database}.
	*
	* Groups narrow down the context in which the keystrokes are available. When `categoryId` is not specified,
	* the group goes to the `'contentEditing'` category (default).
	*
	* To create a new group within an existing category, use the following code:
	*
	* ```js
	* class MyPlugin extends Plugin {
	* 	// ...
	* 	init() {
	* 		const editor = this.editor;
	* 		const t = editor.t;
	*
	* 		// ...
	*
	* 		editor.accessibility.addKeystrokeInfoGroup( {
	* 			id: 'myGroup',
	* 			categoryId: 'navigation',
	* 			label: t( 'My keystroke group' ),
	* 			keystrokes: [
	* 				{
	* 					label: t( 'Keystroke label 1' ),
	* 					keystroke: 'Ctrl+Shift+N'
	* 				},
	* 				{
	* 					label: t( 'Keystroke label 2' ),
	* 					keystroke: 'Ctrl+Shift+M'
	* 				}
	* 			]
	* 		} );
	* 	}
	* }
	* ```
	*
	* See {@link #keystrokeInfos}, {@link #addKeystrokeInfoCategory}, and {@link #addKeystrokeInfos}.
	*/ addKeystrokeInfoGroup({ categoryId: categoryId = $7ca4ca5784e50ca9$var$DEFAULT_CATEGORY_ID, id: id, label: label, keystrokes: keystrokes }) {
        const category = this.keystrokeInfos.get(categoryId);
        if (!category) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("accessibility-unknown-keystroke-info-category", this._editor, {
            groupId: id,
            categoryId: categoryId
        });
        category.groups.set(id, {
            id: id,
            label: label,
            keystrokes: keystrokes || []
        });
    }
    /**
	* Adds information about keystrokes to the {@link #keystrokeInfos keystroke information database}.
	*
	* Keystrokes without specified `groupId` or `categoryId` go to the `'common'` group in the `'contentEditing'` category (default).
	*
	* To add a keystroke brought by your plugin (using default group and category), use the following code:
	*
	* ```js
	* class MyPlugin extends Plugin {
	* 	// ...
	* 	init() {
	* 		const editor = this.editor;
	* 		const t = editor.t;
	*
	* 		// ...
	*
	* 		editor.accessibility.addKeystrokeInfos( {
	* 			keystrokes: [
	* 				{
	* 					label: t( 'Keystroke label' ),
	* 					keystroke: 'CTRL+B'
	* 				}
	* 			]
	* 		} );
	* 	}
	* }
	* ```
	* To add a keystroke in a specific existing `'widget'` group in the default `'contentEditing'` category:
	*
	* ```js
	* class MyPlugin extends Plugin {
	* 	// ...
	* 	init() {
	* 		const editor = this.editor;
	* 		const t = editor.t;
	*
	* 		// ...
	*
	* 		editor.accessibility.addKeystrokeInfos( {
	* 			// Add a keystroke to the existing "widget" group.
	* 			groupId: 'widget',
	* 			keystrokes: [
	* 				{
	* 					label: t( 'A an action on a selected widget' ),
	* 					keystroke: 'Ctrl+D',
	* 				}
	* 			]
	* 		} );
	* 	}
	* }
	* ```
	*
	* To add a keystroke to another existing category (using default group):
	*
	* ```js
	* class MyPlugin extends Plugin {
	* 	// ...
	* 	init() {
	* 		const editor = this.editor;
	* 		const t = editor.t;
	*
	* 		// ...
	*
	* 		editor.accessibility.addKeystrokeInfos( {
	* 			// Add keystrokes to the "navigation" category (one of defaults).
	* 			categoryId: 'navigation',
	* 			keystrokes: [
	* 				{
	* 					label: t( 'Keystroke label' ),
	* 					keystroke: 'CTRL+B'
	* 				}
	* 			]
	* 		} );
	* 	}
	* }
	* ```
	*
	* See {@link #keystrokeInfos}, {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfoCategory}.
	*/ addKeystrokeInfos({ categoryId: categoryId = $7ca4ca5784e50ca9$var$DEFAULT_CATEGORY_ID, groupId: groupId = $7ca4ca5784e50ca9$export$bd262f07e0d166f7, keystrokes: keystrokes }) {
        if (!this.keystrokeInfos.has(categoryId)) /**
		* Cannot add keystrokes in an unknown category. Use
		* {@link module:core/accessibility~Accessibility#addKeystrokeInfoCategory}
		* to add a new category or make sure the specified category exists.
		*
		* @error accessibility-unknown-keystroke-info-category
		* @param {string} categoryId The id of the unknown keystroke category.
		* @param {module:core/accessibility~AddKeystrokeInfosData#keystrokes} keystrokes Keystroke definitions about to be added.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("accessibility-unknown-keystroke-info-category", this._editor, {
            categoryId: categoryId,
            keystrokes: keystrokes
        });
        const category = this.keystrokeInfos.get(categoryId);
        if (!category.groups.has(groupId)) /**
		* Cannot add keystrokes to an unknown group.
		*
		* Use {@link module:core/accessibility~Accessibility#addKeystrokeInfoGroup}
		* to add a new group or make sure the specified group exists.
		*
		* @error accessibility-unknown-keystroke-info-group
		* @param {string} groupId The id of the unknown keystroke group.
		* @param {string} categoryId The id of category the unknown group should belong to.
		* @param {module:core/accessibility~AddKeystrokeInfosData#keystrokes} keystrokes Keystroke definitions about to be added.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("accessibility-unknown-keystroke-info-group", this._editor, {
            groupId: groupId,
            categoryId: categoryId,
            keystrokes: keystrokes
        });
        category.groups.get(groupId).keystrokes.push(...keystrokes);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/utils/editorusagedata
*/ /**
* This part of the code is not executed in open-source implementations using a GPL key.
* It only runs when a specific license key is provided. If you are uncertain whether
* this applies to your installation, please contact our support team.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$4fc62c90cdc835ab(editor) {
    return {
        sessionId: $7ca4ca5784e50ca9$var$getSessionId(),
        pageSessionId: $7ca4ca5784e50ca9$var$getPageSessionID(),
        hostname: window.location.hostname,
        version: globalThis.CKEDITOR_VERSION,
        type: $7ca4ca5784e50ca9$var$getEditorType(editor),
        plugins: $7ca4ca5784e50ca9$var$getPluginsUsageData(editor.plugins),
        distribution: $7ca4ca5784e50ca9$var$getDistributionUsageData(),
        env: $7ca4ca5784e50ca9$var$getEnvUsageData(),
        integration: Object.create(null),
        menuBar: {
            isVisible: !!editor.config.get("menuBar.isVisible")
        },
        language: {
            ui: editor.locale.uiLanguage,
            content: editor.locale.contentLanguage
        },
        toolbar: {
            main: $7ca4ca5784e50ca9$var$getToolbarUsageData(editor.config.get("toolbar")),
            block: $7ca4ca5784e50ca9$var$getToolbarUsageData(editor.config.get("blockToolbar")),
            balloon: $7ca4ca5784e50ca9$var$getToolbarUsageData(editor.config.get("balloonToolbar"))
        }
    };
}
function $7ca4ca5784e50ca9$var$getEditorType(editor) {
    return Object.getPrototypeOf(editor).constructor.editorName;
}
function $7ca4ca5784e50ca9$var$getPluginsUsageData(collection) {
    return Array.from(collection).filter(([PluginConstructor])=>!!PluginConstructor.pluginName).map(([PluginConstructor])=>{
        const { pluginName: pluginName, isContextPlugin: isContextPlugin, isOfficialPlugin: isOfficialPlugin, isPremiumPlugin: isPremiumPlugin } = PluginConstructor;
        return {
            isContext: !!isContextPlugin,
            isOfficial: !!isOfficialPlugin,
            isPremium: !!isPremiumPlugin,
            name: pluginName
        };
    });
}
function $7ca4ca5784e50ca9$var$getToolbarUsageData(toolbarConfig) {
    if (!toolbarConfig) return;
    const normalizedToolbar = Array.isArray(toolbarConfig) ? {
        items: toolbarConfig
    } : toolbarConfig;
    const flattenToolbarConfigNames = extractToolbarConfigItemsNames(normalizedToolbar.items || []);
    return {
        isMultiline: flattenToolbarConfigNames.includes("-"),
        shouldNotGroupWhenFull: !!normalizedToolbar.shouldNotGroupWhenFull,
        items: stripToolbarSeparatorItems(flattenToolbarConfigNames)
    };
    function stripToolbarSeparatorItems(items) {
        return items.filter((item)=>item !== "|" && item !== "-");
    }
    function extractToolbarConfigItemsNames(items) {
        return items.flatMap((item)=>{
            if (typeof item === "string") return [
                item
            ];
            return extractToolbarConfigItemsNames(item.items);
        });
    }
}
function $7ca4ca5784e50ca9$var$getDistributionUsageData() {
    return {
        channel: window[Symbol.for("cke distribution")] || "sh"
    };
}
function $7ca4ca5784e50ca9$var$getEnvUsageData() {
    let os = "unknown";
    let browser = "unknown";
    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isMac) os = "mac";
    else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isWindows) os = "windows";
    else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS) os = "ios";
    else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) os = "android";
    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko) browser = "gecko";
    else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink) browser = "blink";
    else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari) browser = "safari";
    return {
        os: os,
        browser: browser
    };
}
function $7ca4ca5784e50ca9$var$getSessionId() {
    if (!localStorage.getItem("__ckeditor-session-id")) localStorage.setItem("__ckeditor-session-id", (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)());
    return localStorage.getItem("__ckeditor-session-id");
}
function $7ca4ca5784e50ca9$var$getPageSessionID() {
    (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.CKEDITOR_PAGE_SESSION_ID = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.CKEDITOR_PAGE_SESSION_ID || (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
    return (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.CKEDITOR_PAGE_SESSION_ID;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/editor
*/ const $7ca4ca5784e50ca9$var$EditorBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The class representing a basic, generic editor.
*
* Check out the list of its subclasses to learn about specific editor implementations.
*
* All editor implementations (like {@link module:editor-classic/classiceditor~ClassicEditor} or
* {@link module:editor-inline/inlineeditor~InlineEditor}) should extend this class. They can add their
* own methods and properties.
*
* When you are implementing a plugin, this editor represents the API
* which your plugin can expect to get when using its {@link module:core/plugin~Plugin#editor} property.
*
* This API should be sufficient in order to implement the "editing" part of your feature
* (schema definition, conversion, commands, keystrokes, etc.).
* It does not define the editor UI, which is available only if
* the specific editor implements also the {@link ~Editor#ui} property
* (as most editor implementations do).
*/ var $7ca4ca5784e50ca9$export$7cda8d932e2f33c0 = class extends $7ca4ca5784e50ca9$var$EditorBase {
    /**
	* A required name of the editor class. The name should reflect the constructor name.
	*/ static get editorName() {
        return "Editor";
    }
    /**
	* A namespace for the accessibility features of the editor.
	*/ accessibility;
    /**
	* Commands registered to the editor.
	*
	* Use the shorthand {@link #execute `editor.execute()`} method to execute commands:
	*
	* ```ts
	* // Execute the bold command:
	* editor.execute( 'bold' );
	*
	* // Check the state of the bold command:
	* editor.commands.get( 'bold' ).value;
	* ```
	*/ commands;
    /**
	* Stores all configurations specific to this editor instance.
	*
	* ```ts
	* editor.config.get( 'image.toolbar' );
	* // -> [ 'imageStyle:block', 'imageStyle:side', '|', 'toggleImageCaption', 'imageTextAlternative' ]
	* ```
	*/ config;
    /**
	* Conversion manager through which you can register model-to-view and view-to-model converters.
	*
	* See the {@link module:engine/conversion/conversion~Conversion} documentation to learn how to add converters.
	*/ conversion;
    /**
	* The {@link module:engine/controller/datacontroller~DataController data controller}.
	* Used e.g. for setting and retrieving the editor data.
	*/ data;
    /**
	* The {@link module:engine/controller/editingcontroller~EditingController editing controller}.
	* Controls user input and rendering the content for editing.
	*/ editing;
    /**
	* The locale instance.
	*/ locale;
    /**
	* The editor's model.
	*
	* The central point of the editor's abstract data model.
	*/ model;
    /**
	* The plugins loaded and in use by this editor instance.
	*
	* ```ts
	* editor.plugins.get( 'ClipboardPipeline' ); // -> An instance of the clipboard pipeline plugin.
	* ```
	*/ plugins;
    /**
	* An instance of the {@link module:core/editingkeystrokehandler~EditingKeystrokeHandler}.
	*
	* It allows setting simple keystrokes:
	*
	* ```ts
	* // Execute the bold command on Ctrl+E:
	* editor.keystrokes.set( 'Ctrl+E', 'bold' );
	*
	* // Execute your own callback:
	* editor.keystrokes.set( 'Ctrl+E', ( data, cancel ) => {
	* 	console.log( data.keyCode );
	*
	* 	// Prevent the default (native) action and stop the underlying keydown event
	* 	// so no other editor feature will interfere.
	* 	cancel();
	* } );
	* ```
	*
	* Note: Certain typing-oriented keystrokes (like <kbd>Backspace</kbd> or <kbd>Enter</kbd>) are handled
	* by a low-level mechanism and trying to listen to them via the keystroke handler will not work reliably.
	* To handle these specific keystrokes, see the events fired by the
	* {@link module:engine/view/document~ViewDocument editing view document} (`editor.editing.view.document`).
	*/ keystrokes;
    /**
	* Shorthand for {@link module:utils/locale~Locale#t}.
	*
	* @see module:utils/locale~Locale#t
	*/ t;
    /**
	* The default configuration which is built into the editor class.
	*
	* It was used in the now deprecated CKEditor 5 builds to provide the default configuration options
	* which are later used during the editor initialization.
	*
	* ```ts
	* ClassicEditor.defaultConfig = {
	* 	foo: 1,
	* 	bar: 2
	* };
	*
	* ClassicEditor
	* 	.create( sourceElement )
	* 	.then( editor => {
	* 		editor.config.get( 'foo' ); // -> 1
	* 		editor.config.get( 'bar' ); // -> 2
	* 	} );
	*
	* // The default options can be overridden by the configuration passed to create().
	* ClassicEditor
	* 	.create( { bar: 3 } )
	* 	.then( editor => {
	* 		editor.config.get( 'foo' ); // -> 1
	* 		editor.config.get( 'bar' ); // -> 3
	* 	} );
	* ```
	*
	* See also {@link module:core/editor/editor~Editor.builtinPlugins}.
	*/ static defaultConfig;
    /**
	* An array of plugins built into this editor class.
	*
	* It is used in the now deprecated CKEditor 5 builds to provide a list of plugins which are later automatically initialized
	* during the editor initialization.
	*
	* They will be automatically initialized by the editor, unless listed in `config.removePlugins` and
	* unless `config.plugins` is passed.
	*
	* ```ts
	* // Build some plugins into the editor class first.
	* ClassicEditor.builtinPlugins = [ FooPlugin, BarPlugin ];
	*
	* // Normally, you need to define config.plugins, but since ClassicEditor.builtinPlugins was
	* // defined, now you can call create() without any configuration.
	* ClassicEditor
	* 	.create( sourceElement )
	* 	.then( editor => {
	* 		editor.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
	* 		editor.plugins.get( BarPlugin ); // -> An instance of the Bar plugin.
	* 	} );
	*
	* ClassicEditor
	* 	.create( {
	* 		// Do not initialize these plugins (note: it is defined by a string):
	* 		removePlugins: [ 'Foo' ]
	* 	} )
	* 	.then( editor => {
	* 		editor.plugins.get( FooPlugin ); // -> Undefined.
	* 		editor.config.get( BarPlugin ); // -> An instance of the Bar plugin.
	* 	} );
	*
	* ClassicEditor
	* 	.create( {
	* 		// Load only this plugin. It can also be defined by a string if
	* 		// this plugin was built into the editor class.
	* 		plugins: [ FooPlugin ]
	* 	} )
	* 	.then( editor => {
	* 		editor.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
	* 		editor.config.get( BarPlugin ); // -> Undefined.
	* 	} );
	* ```
	*
	* See also {@link module:core/editor/editor~Editor.defaultConfig}.
	*/ static builtinPlugins;
    /**
	* The editor context.
	* When it is not provided through the configuration, the editor creates it.
	*/ _context;
    /**
	* Objects that error attribution must not walk into when deciding whether something belongs to this
	* editor — see {@link module:core/context~Context#_errorExclusions}.
	*
	* Exposed here because `_context` is protected and attribution runs outside this class.
	*
	* It has to be a getter rather than a property. Editors sharing a context share one exclusion set, and
	* the set is not a member of itself, so holding it in a property would put the same object on every
	* editor — and the search would find it there and match them all. A getter lives on the prototype and
	* is not enumerable, so the search does not see it, and the only route left to the set runs through the
	* context, which is excluded.
	*
	* @internal
	*/ get _errorExclusions() {
        return this._context._errorExclusions;
    }
    /**
	* A set of lock IDs for the {@link #isReadOnly} getter.
	*/ _readOnlyLocks;
    /**
	* Holds attributes keys that were passed in
	* {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots.<rootName>.modelAttributes`}
	*  or {@link module:core/editor/editorconfig~EditorConfig#root `config.root.modelAttributes`}.
	*/ _registeredRootsAttributesKeys = /* @__PURE__ */ new Set();
    /**
	* `Editor` class is commonly put in `config.plugins` array.
	*
	* This property helps with better error detection.
	*
	* @internal
	*/ static get _throwErrorWhenUsedAsAPlugin() {
        return true;
    }
    /**
	* Creates a new instance of the editor class.
	*
	* Usually, not to be used directly. See the static {@link module:core/editor/editor~Editor.create `create()`} method.
	*
	* @param config The editor configuration.
	*/ constructor(config = {}){
        super();
        if (typeof config !== "object" || Array.isArray(config)) /**
		* Editor configuration must be an object.
		*
		* A common cause of this error is passing an Editor class (for example
		* `ClassicEditor`) in the `config.plugins` array. In such case, the editor
		* constructor is called with an Editor or Context instance instead of
		* the configuration object.
		*
		* @error editor-config-invalid-type
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-config-invalid-type");
        if ("sanitizeHtml" in config) /**
		* Configuration property `config.sanitizeHtml` was removed in CKEditor version 43.1.0 and is no longer supported.
		*
		* Please use `config.htmlEmbed.sanitizeHtml` and/or `config.mergeFields.sanitizeHtml` instead.
		*
		* @error editor-config-sanitizehtml-not-supported
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-config-sanitizehtml-not-supported");
        const constructor = this.constructor;
        const { translations: defaultTranslations, ...defaultConfig } = constructor.defaultConfig || {};
        const { translations: translations = defaultTranslations, ...rest } = config;
        const language = config.language || defaultConfig.language;
        this._context = config.context || new $7ca4ca5784e50ca9$export$841858b892ce1f4c({
            language: language,
            translations: translations
        });
        this._context._addEditor(this, !config.context);
        const availablePlugins = Array.from(constructor.builtinPlugins || []);
        this.config = new (0, $c7bc2cb7e2db0227$export$29cd7b75162a9425)(rest, defaultConfig);
        this.config.define("plugins", availablePlugins);
        this.config.define(this._context._getEditorConfig());
        checkLicenseKeyIsDefined(this.config);
        this.plugins = new $7ca4ca5784e50ca9$export$5908a802ac6e3d12(this, availablePlugins, this._context.plugins);
        this.locale = this._context.locale;
        this.t = this.locale.t;
        this._readOnlyLocks = /* @__PURE__ */ new Set();
        this.commands = new $7ca4ca5784e50ca9$export$6b7de9fa8c10e581();
        this.set("state", "initializing");
        this.once("ready", ()=>this.state = "ready", {
            priority: "high"
        });
        this.once("destroy", ()=>this.state = "destroyed", {
            priority: "high"
        });
        this.once("ready", ()=>$7ca4ca5784e50ca9$var$_addLiveEditor(this), {
            priority: "high"
        });
        this.once("destroy", ()=>$7ca4ca5784e50ca9$var$_removeLiveEditor(this), {
            priority: "high"
        });
        this.model = new (0, $b9b9f2bdf9c6137f$export$a1edc412be3e1841)(this.config);
        this.on("change:isReadOnly", ()=>{
            this.model.document.isReadOnly = this.isReadOnly;
        });
        const stylesProcessor = new (0, $b9b9f2bdf9c6137f$export$c3739f0469d36452)();
        this.data = new (0, $b9b9f2bdf9c6137f$export$af704488d7d0ffb8)(this.model, stylesProcessor);
        this.editing = new (0, $b9b9f2bdf9c6137f$export$fc8cb26747d0035c)(this.model, stylesProcessor);
        this.editing.view.document.bind("isReadOnly").to(this);
        this.conversion = new (0, $b9b9f2bdf9c6137f$export$4690203fd259f070)([
            this.editing.downcastDispatcher,
            this.data.downcastDispatcher
        ], this.data.upcastDispatcher);
        this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher);
        this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher);
        this.keystrokes = new $7ca4ca5784e50ca9$export$acdfeffa549276f2(this);
        this.keystrokes.listenTo(this.editing.view.document);
        this.accessibility = new $7ca4ca5784e50ca9$export$ea0f6181e3388ffd(this);
        verifyLicenseKey(this);
        function checkLicenseKeyIsDefined(config) {
            let licenseKey = config.get("licenseKey");
            if (!licenseKey && window.CKEDITOR_GLOBAL_LICENSE_KEY) {
                licenseKey = window.CKEDITOR_GLOBAL_LICENSE_KEY;
                config.set("licenseKey", licenseKey);
            }
            if (!licenseKey) /**
			* The `licenseKey` property is missing in the editor configuration.
			*
			* * If you are using the editor in a commercial setup, please provide your license key.
			* * If you still need to acquire a key, please [contact us](https://ckeditor.com/contact/) or
			*   [create a free account with a 14 day premium features trial](https://portal.ckeditor.com/checkout?plan=free).
			* * If you are using the editor under a GPL license or another license from our Open Source Initiative,
			*   use the 'GPL' license key instead.
			*
			* ```js
			* ClassicEditor.create( {
			* 	attachTo: document.querySelector( '#editor' ),
			* 	licenseKey: '<YOUR_LICENSE_KEY>', // Or 'GPL'.
			* 	// ... Other configuration options ...
			* } ) ;
			*
			* @error license-key-missing
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-missing");
        }
        function verifyLicenseKey(editor) {
            const licenseKey = editor.config.get("licenseKey");
            const distributionChannel = window[Symbol.for("cke distribution")] || "sh";
            function blockEditor(reason, name) {
                editor.enableReadOnlyMode(Symbol("invalidLicense"));
                editor._showLicenseError(reason, name);
            }
            function hasAllRequiredFields(licensePayload) {
                return [
                    "exp",
                    "jti",
                    "vc"
                ].every((field)=>field in licensePayload);
            }
            function getCrcInputData(licensePayload) {
                return Object.getOwnPropertyNames(licensePayload).sort().filter((key)=>key != "vc" && licensePayload[key] != null).map((key)=>licensePayload[key]);
            }
            function checkLicensedHosts(licensedHosts) {
                const { hostname: hostname } = new URL(window.location.href);
                if (licensedHosts.includes(hostname)) return true;
                const segments = hostname.split(".");
                return licensedHosts.filter((host)=>host.includes("*")).map((host)=>host.split(".")).filter((host)=>host.length <= segments.length).map((host)=>Array(segments.length - host.length).fill(host[0] === "*" ? "*" : "").concat(host)).some((octets)=>segments.every((segment, index)=>octets[index] === segment || octets[index] === "*"));
            }
            function warnAboutNonProductionLicenseKey(licenseType) {
                const capitalizedLicenseType = licenseType[0].toUpperCase() + licenseType.slice(1);
                const article = licenseType === "evaluation" ? "an" : "a";
                console.info(`%cCKEditor 5 ${capitalizedLicenseType} License`, "color: #ffffff; background: #743CCD; font-size: 14px; padding: 4px 8px; border-radius: 4px;");
                console.warn(`\u{26A0}\u{FE0F} You are using ${article} ${licenseType} license of CKEditor 5${licenseType === "trial" ? " which is for evaluation purposes only" : ""}. For production usage, please obtain a production license at https://portal.ckeditor.com/`);
            }
            if (licenseKey == "GPL") {
                if (distributionChannel == "cloud") blockEditor("distributionChannel");
                return;
            }
            const licensePayload = (0, $c7bc2cb7e2db0227$export$9cbd9a924c44d1b7)(licenseKey);
            if (!licensePayload) {
                blockEditor("invalid");
                return;
            }
            if (!hasAllRequiredFields(licensePayload)) {
                blockEditor("invalid");
                return;
            }
            if (licensePayload.distributionChannel && !(0, $c7bc2cb7e2db0227$export$45b10814cc054894)(licensePayload.distributionChannel).includes(distributionChannel)) {
                blockEditor("distributionChannel");
                return;
            }
            if ((0, $c7bc2cb7e2db0227$export$1cd93882633e45f5)(getCrcInputData(licensePayload)) != licensePayload.vc.toLowerCase()) {
                blockEditor("invalid");
                return;
            }
            if (/* @__PURE__ */ new Date(licensePayload.exp * 1e3) < (0, $c7bc2cb7e2db0227$export$e1be5b7438bff8c)) {
                blockEditor("expired");
                return;
            }
            const licensedHosts = licensePayload.licensedHosts;
            if (licensedHosts && licensedHosts.length > 0 && !checkLicensedHosts(licensedHosts)) {
                blockEditor("domainLimit");
                return;
            }
            if ([
                "evaluation",
                "trial"
            ].includes(licensePayload.licenseType) && licensePayload.exp * 1e3 < Date.now()) {
                blockEditor("expired");
                return;
            }
            if ([
                "development",
                "evaluation",
                "trial"
            ].includes(licensePayload.licenseType)) {
                const { licenseType: licenseType } = licensePayload;
                window.CKEDITOR_WARNING_SUPPRESSIONS = window.CKEDITOR_WARNING_SUPPRESSIONS || {};
                if (!window.CKEDITOR_WARNING_SUPPRESSIONS[licenseType]) {
                    warnAboutNonProductionLicenseKey(licenseType);
                    window.CKEDITOR_WARNING_SUPPRESSIONS[licenseType] = true;
                }
            }
            if (licensePayload.licenseType === "evaluation") {
                const timerId = setTimeout(()=>{
                    blockEditor("evaluationLimit");
                }, 6e5);
                editor.on("destroy", ()=>{
                    clearTimeout(timerId);
                });
            }
            if (licensePayload.usageEndpoint) editor.once("ready", ()=>{
                const request = {
                    requestId: (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)(),
                    requestTime: Math.round(Date.now() / 1e3),
                    license: licenseKey,
                    editor: $7ca4ca5784e50ca9$var$collectUsageData(editor)
                };
                /**
				* This part of the code is not executed in open-source implementations using a GPL key.
				* It only runs when a specific license key is provided. If you are uncertain whether
				* this applies to your installation, please contact our support team.
				*/ editor._sendUsageRequest(licensePayload.usageEndpoint, request).then((response)=>{
                    const { status: status, message: message } = response;
                    if (message) console.warn(message);
                    if (status != "ok") blockEditor("usageLimit");
                }, ()=>{
                    /**
					* Your license key cannot be validated due to a network issue.
					* Please ensure that your setup does not block requests to the validation endpoint.
					*
					* @error license-key-validation-endpoint-not-reachable
					* @param {string} url The URL that was attempted to be reached for validation.
					*/ (0, $c7bc2cb7e2db0227$export$58da9968c3170cb1)("license-key-validation-endpoint-not-reachable", {
                        url: licensePayload.usageEndpoint
                    });
                });
            }, {
                priority: "high"
            });
        }
    }
    /**
	* Defines whether the editor is in the read-only mode.
	*
	* In read-only mode the editor {@link #commands commands} are disabled so it is not possible
	* to modify the document by using them. Also, the editable element(s) become non-editable.
	*
	* In order to make the editor read-only, you need to call the {@link #enableReadOnlyMode} method:
	*
	* ```ts
	* editor.enableReadOnlyMode( 'feature-id' );
	* ```
	*
	* Later, to turn off the read-only mode, call {@link #disableReadOnlyMode}:
	*
	* ```ts
	* editor.disableReadOnlyMode( 'feature-id' );
	* ```
	*
	* @readonly
	* @observable
	*/ get isReadOnly() {
        return this._readOnlyLocks.size > 0;
    }
    set isReadOnly(value) {
        /**
		* The {@link module:core/editor/editor~Editor#isReadOnly Editor#isReadOnly} property is read-only since version `34.0.0`
		* and can be set only using {@link module:core/editor/editor~Editor#enableReadOnlyMode `Editor#enableReadOnlyMode( lockId )`} and
		* {@link module:core/editor/editor~Editor#disableReadOnlyMode `Editor#disableReadOnlyMode( lockId )`}.
		*
		* Usage before version `34.0.0`:
		*
		* ```ts
		* editor.isReadOnly = true;
		* editor.isReadOnly = false;
		* ```
		*
		* Usage since version `34.0.0`:
		*
		* ```ts
		* editor.enableReadOnlyMode( 'my-feature-id' );
		* editor.disableReadOnlyMode( 'my-feature-id' );
		* ```
		*
		* @error editor-isreadonly-has-no-setter
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-isreadonly-has-no-setter");
    }
    /**
	* Turns on the read-only mode in the editor.
	*
	* Editor can be switched to or out of the read-only mode by many features, under various circumstances. The editor supports locking
	* mechanism for the read-only mode. It enables easy control over the read-only mode when many features wants to turn it on or off at
	* the same time, without conflicting with each other. It guarantees that you will not make the editor editable accidentally (which
	* could lead to errors).
	*
	* Each read-only mode request is identified by a unique id (also called "lock"). If multiple plugins requested to turn on the
	* read-only mode, then, the editor will become editable only after all these plugins turn the read-only mode off (using the same ids).
	*
	* Note, that you cannot force the editor to disable the read-only mode if other plugins set it.
	*
	* After the first `enableReadOnlyMode()` call, the {@link #isReadOnly `isReadOnly` property} will be set to `true`:
	*
	* ```ts
	* editor.isReadOnly; // `false`.
	* editor.enableReadOnlyMode( 'my-feature-id' );
	* editor.isReadOnly; // `true`.
	* ```
	*
	* You can turn off the read-only mode ("clear the lock") using the {@link #disableReadOnlyMode `disableReadOnlyMode()`} method:
	*
	* ```ts
	* editor.enableReadOnlyMode( 'my-feature-id' );
	* // ...
	* editor.disableReadOnlyMode( 'my-feature-id' );
	* editor.isReadOnly; // `false`.
	* ```
	*
	* All "locks" need to be removed to enable editing:
	*
	* ```ts
	* editor.enableReadOnlyMode( 'my-feature-id' );
	* editor.enableReadOnlyMode( 'my-other-feature-id' );
	* // ...
	* editor.disableReadOnlyMode( 'my-feature-id' );
	* editor.isReadOnly; // `true`.
	* editor.disableReadOnlyMode( 'my-other-feature-id' );
	* editor.isReadOnly; // `false`.
	* ```
	*
	* @param lockId A unique ID for setting the editor to the read-only state.
	*/ enableReadOnlyMode(lockId) {
        if (typeof lockId !== "string" && typeof lockId !== "symbol") /**
		* The lock ID is missing or it is not a string or symbol.
		*
		* @error editor-read-only-lock-id-invalid
		* @param {never} lockId Lock ID.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-read-only-lock-id-invalid", null, {
            lockId: lockId
        });
        if (this._readOnlyLocks.has(lockId)) return;
        this._readOnlyLocks.add(lockId);
        if (this._readOnlyLocks.size === 1) this.fire("change:isReadOnly", "isReadOnly", true, false);
    }
    /**
	* Removes the read-only lock from the editor with given lock ID.
	*
	* When no lock is present on the editor anymore, then the {@link #isReadOnly `isReadOnly` property} will be set to `false`.
	*
	* @param lockId The lock ID for setting the editor to the read-only state.
	*/ disableReadOnlyMode(lockId) {
        if (typeof lockId !== "string" && typeof lockId !== "symbol") throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-read-only-lock-id-invalid", null, {
            lockId: lockId
        });
        if (!this._readOnlyLocks.has(lockId)) return;
        this._readOnlyLocks.delete(lockId);
        if (this._readOnlyLocks.size === 0) this.fire("change:isReadOnly", "isReadOnly", false, true);
    }
    /**
	* Sets the data in the editor.
	*
	* ```ts
	* editor.setData( '<p>This is editor!</p>' );
	* ```
	*
	* If your editor implementation uses multiple roots, you should pass an object with keys corresponding
	* to the editor root names and values equal to the data that should be set in each root:
	*
	* ```ts
	* editor.setData( {
	*     header: '<p>Content for header part.</p>',
	*     content: '<p>Content for main part.</p>',
	*     footer: '<p>Content for footer part.</p>'
	* } );
	* ```
	*
	* By default the editor accepts HTML. This can be controlled by injecting a different data processor.
	* See the {@glink features/markdown Markdown output} guide for more details.
	*
	* @param data Input data.
	*/ setData(data) {
        this.data.set(data);
    }
    /**
	* Gets the data from the editor.
	*
	* ```ts
	* editor.getData(); // -> '<p>This is editor!</p>'
	* ```
	*
	* If your editor implementation uses multiple roots, you should pass root name as one of the options:
	*
	* ```ts
	* editor.getData( { rootName: 'header' } ); // -> '<p>Content for header part.</p>'
	* ```
	*
	* By default, the editor outputs HTML. This can be controlled by injecting a different data processor.
	* See the {@glink features/markdown Markdown output} guide for more details.
	*
	* A warning is logged when you try to retrieve data for a detached root, as most probably this is a mistake. A detached root should
	* be treated like it is removed, and you should not save its data. Note, that the detached root data is always an empty string.
	*
	* @param options Additional configuration for the retrieved data.
	* Editor features may introduce more configuration options that can be set through this parameter.
	* @param options.rootName Root name. Defaults to `'main'`.
	* @param options.trim Whether returned data should be trimmed. This option is set to `'empty'` by default,
	* which means that whenever editor content is considered empty, an empty string is returned. To turn off trimming
	* use `'none'`. In such cases exact content will be returned (for example `'<p>&nbsp;</p>'` for an empty editor).
	* @returns Output data.
	*/ getData(options) {
        return this.data.get(options);
    }
    /**
	* Loads and initializes plugins specified in the configuration.
	*
	* @returns A promise which resolves once the initialization is completed, providing an array of loaded plugins.
	*/ async initPlugins() {
        const config = this.config;
        const plugins = config.get("plugins");
        const removePlugins = config.get("removePlugins") || [];
        const extraPlugins = config.get("extraPlugins") || [];
        const substitutePlugins = config.get("substitutePlugins") || [];
        const loadedPlugins = await this.plugins.init(plugins.concat(extraPlugins), removePlugins, substitutePlugins);
        checkPluginsAllowedByLicenseKey(this);
        return loadedPlugins;
        function checkPluginsAllowedByLicenseKey(editor) {
            const licenseKey = editor.config.get("licenseKey");
            if (licenseKey === "GPL") return;
            const decodedPayload = (0, $c7bc2cb7e2db0227$export$9cbd9a924c44d1b7)(licenseKey);
            if (!decodedPayload) return;
            const disallowedPlugin = [
                ...editor.plugins
            ].map(([pluginConstructor])=>pluginConstructor).find((pluginConstructor)=>{
                if (!pluginConstructor.pluginName) return false;
                if (!pluginConstructor.licenseFeatureCode) return false;
                return (0, $c7bc2cb7e2db0227$export$817c47d6329f7631)(decodedPayload, pluginConstructor.licenseFeatureCode);
            });
            if (disallowedPlugin) {
                editor.enableReadOnlyMode(Symbol("invalidLicense"));
                editor._showLicenseError("pluginNotAllowed", disallowedPlugin.pluginName);
            }
        }
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* **Note** The editor cannot be destroyed during the initialization phase so if it is called
	* while the editor {@link #state is being initialized}, it will wait for the editor initialization before destroying it.
	*
	* @fires destroy
	* @returns A promise that resolves once the editor instance is fully destroyed.
	*/ async destroy() {
        if (this.state == "initializing") await new Promise((resolve)=>this.once("ready", resolve));
        this.fire("destroy");
        this.stopListening();
        this.commands.destroy();
        await this.plugins.destroy();
        this.model.destroy();
        this.data.destroy();
        this.editing.destroy();
        this.keystrokes.destroy();
        await this._context._removeEditor(this);
    }
    /**
	* Executes the specified command with given parameters.
	*
	* Shorthand for:
	*
	* ```ts
	* editor.commands.get( commandName ).execute( ... );
	* ```
	*
	* @param commandName The name of the command to execute.
	* @param commandParams Command parameters.
	* @returns The value returned by the {@link module:core/commandcollection~CommandCollection#execute `commands.execute()`}.
	*/ execute(commandName, ...commandParams) {
        try {
            return this.commands.execute(commandName, ...commandParams);
        } catch (err) {
            /* v8 ignore next -- @preserve */ (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10).rethrowUnexpectedError(err, this);
        }
    }
    /**
	* Focuses the editor.
	*
	* **Note** To explicitly focus the editing area of the editor, use the
	* {@link module:engine/view/view~EditingView#focus `editor.editing.view.focus()`} method of the editing view.
	*
	* Check out the {@glink framework/deep-dive/ui/focus-tracking#focus-in-the-editor-ui Focus in the editor UI} section
	* of the {@glink framework/deep-dive/ui/focus-tracking Deep dive into focus tracking} guide to learn more.
	*/ focus() {
        this.editing.view.focus();
    }
    /**
	* Registers a given string as a root attribute key. Registered root attributes are added to
	* the {@link module:engine/model/schema~ModelSchema schema}.
	*
	* **Note:** Attributes passed in the configuration for multi-root editors
	* ({@link module:core/editor/editorconfig~EditorConfig#roots `config.roots.<rootName>.modelAttributes`}) or
	* single-root editors ({@link module:core/editor/editorconfig~EditorConfig#root `config.root.modelAttributes`})
	* are automatically registered when the editor is initialized. However, registering the same attribute twice
	* does not have any negative impact, so it is recommended to use this method in any feature that uses
	* root attributes.
	*
	* **Note:** Registered attributes are attached only to the generic `$root` schema element. A custom root
	* {@link module:core/editor/editorconfig~RootConfig#modelElement `modelElement`} must opt into the `$root`
	* attribute chain via `allowAttributesOf: '$root'` to inherit these attributes.
	* See the {@glink framework/deep-dive/schema#custom-root-elements Custom root elements} section of the
	* {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
	*/ registerRootAttribute(key) {
        if (this._registeredRootsAttributesKeys.has(key)) return;
        this._registeredRootsAttributesKeys.add(key);
        this.editing.model.schema.extend("$root", {
            allowAttributes: key
        });
    }
    /**
	* Returns attributes for the specified root.
	* If no root name is provided, it returns attributes for the 'main' root by default.
	*
	* Note: all and only {@link ~Editor#registerRootAttribute registered} roots attributes will be returned.
	* If a registered root attribute is not set for a given root, `null` will be returned.
	*/ getRootAttributes(rootName = "main") {
        const root = this.model.document.getRoot(rootName);
        if (!root) /**
		* The requested root does not exist. Please ensure that the provided root name
		* is correct and that the root has been properly initialized in the document.
		*
		* @error get-root-attributes-missing-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("get-root-attributes-missing-root", this, {
            rootName: rootName
        });
        const rootAttributes = {};
        for (const key of this._registeredRootsAttributesKeys)rootAttributes[key] = root.hasAttribute(key) ? root.getAttribute(key) : null;
        return rootAttributes;
    }
    /**
	* Creates and initializes a new editor instance.
	*
	* This is an abstract method. Every editor type needs to implement its own initialization logic.
	*
	* See the `create()` methods of the existing editor types to learn how to use them:
	*
	* * {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`}
	* * {@link module:editor-balloon/ballooneditor~BalloonEditor.create `BalloonEditor.create()`}
	* * {@link module:editor-decoupled/decouplededitor~DecoupledEditor.create `DecoupledEditor.create()`}
	* * {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`}
	*/ static create(...args) {
        throw new Error("This is an abstract method.");
    }
    /**
	* The {@link module:core/context~Context} class.
	*
	* Exposed as a static editor member for easier access in editor builds.
	*
	* A getter rather than a field, for the same reason as {@link ~Editor.onEditorError}: a field would
	* read `Context` while this class is being defined, and the error reporter puts this module and
	* `context.ts` in an import cycle, so at that moment `Context` is not always initialized yet.
	*/ static get Context() {
        return $7ca4ca5784e50ca9$export$841858b892ce1f4c;
    }
    /**
	* {@link module:core/errorreporter~onEditorError `onEditorError()`}, reachable without importing it.
	*
	* Code that is handed an editor class rather than importing one — a framework integration, above all —
	* cannot import from CKEditor at all. Importing anything as a value loads the npm build, and an
	* application that meant to load CKEditor from a CDN is then refused. Reading the function off the class
	* it was given avoids that, and it also lands on the copy of this package the editor itself came from.
	*
	* ```ts
	* const off = ClassicEditor.onEditorError( ( { error, source } ) => {
	* 	if ( source !== myEditor ) {
	* 		return;
	* 	}
	*
	* 	reportToMyErrorTracker( error );
	* } );
	* ```
	*
	* The same page-level registration as the exported function — not a registration scoped to this editor
	* class. Prefer the import wherever imports are an option.
	*
	* A getter rather than a field: this module and the error reporter already refer to each other, so
	* reading its export while defining this class would read it before it exists. A getter body runs on
	* access, long after both modules are done. It also keeps the property off the list of the class's own
	* enumerable properties, which a field would have joined.
	*/ static get onEditorError() {
        return $7ca4ca5784e50ca9$export$7397e636447e6d91;
    }
    _showLicenseError(reason, name) {
        setTimeout(()=>{
            if (reason == "invalid") /**
			* The license key provided is invalid. Please ensure that it is copied correctly
			* from the [Customer Portal](http://portal.ckeditor.com). If the issue persists,
			* please [contact our customer support](https://ckeditor.com/contact/).
			*
			* @error invalid-license-key
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("invalid-license-key");
            if (reason == "expired") /**
			* Your license key has expired.
			*
			* If you used our free trial, you either need to switch to
			* [open-source license](https://ckeditor.com/docs/ckeditor5/latest/getting-started/licensing/license-and-legal.html), or
			* in case of a commercial plan, change the trial key to production key or development key.
			* Switching from trial, you also need to align the editor configuration to the features available in your plan.
			*
			* If you already had one of our Cloud or Custom plans, please renew your license in the
			* [Customer Portal](https://portal.ckeditor.com).
			*
			* @error license-key-expired
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-expired");
            if (reason == "domainLimit") /**
			* The provided license does not allow the editor to run on this domain.
			* Some license keys are restricted to local test environments only.
			* For more details, please refer to the
			* {@glink getting-started/licensing/license-key-and-activation#license-key-types license key type documentation}.
			*
			* @error license-key-domain-limit
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-domain-limit");
            if (reason == "pluginNotAllowed") {
                const gluePluginName = name.replace(/(Editing|UI)$/, "");
                const containsGluePlugin = this.plugins.has(gluePluginName);
                /**
				* The plugin you are trying to use is not permitted under your current license.
				* Please check the available features on the
				* [Customer Portal](https://portal.ckeditor.com) or
				* [contact support](https://ckeditor.com/contact/) for more information.
				*
				* @error license-key-plugin-not-allowed
				* @param {String} pluginName The plugin you tried to load.
				*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-plugin-not-allowed", null, {
                    pluginName: containsGluePlugin ? gluePluginName : name
                });
            }
            if (reason == "featureNotAllowed") /**
			* The feature you are trying to use is not permitted under your current license.
			* Please check the available features on the
			* [Customer Portal](https://portal.ckeditor.com) or
			* [contact support](https://ckeditor.com/contact/) for more information.
			*
			* @error license-key-feature-not-allowed
			* @param {String} featureName The feature you tried to use.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-feature-not-allowed", null, {
                featureName: name
            });
            if (reason == "evaluationLimit") /**
			* You have exceeded the editor operation limit available for your evaluation license key.
			* Please restart the editor to continue using it.
			* {@glink getting-started/licensing/license-key-and-activation#license-key-types Read more about license key types}.
			*
			* @error license-key-evaluation-limit
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-evaluation-limit");
            if (reason == "trialLimit") /**
			* You have exceeded the editor operation limit for your trial license key.
			* Please restart the editor to continue using it.
			* {@glink getting-started/licensing/license-key-and-activation#license-key-types Read more about license key types}.
			*
			* @error license-key-trial-limit
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-trial-limit");
            if (reason == "developmentLimit") /**
			* You have exceeded the operation limit for your development license key within the editor.
			* Please restart the editor to continue using it.
			* {@glink getting-started/licensing/license-key-and-activation#license-key-types Read more about license key types}.
			*
			* @error license-key-development-limit
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-development-limit");
            if (reason == "usageLimit") /**
			* You have reached the usage limit of your license key. This can occur in the following situations:
			*
			* * You are on a free subscription without a connected payment method and have exceeded the allowed usage threshold.
			* * Your account has overdue invoices and the grace period has ended.
			*
			* To extend the limit and restore access, please update the required details in the
			* [Customer Portal](https://portal.ckeditor.com) or
			* [contact our customer support](https://ckeditor.com/contact).
			*
			* @error license-key-usage-limit
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-usage-limit");
            /* v8 ignore else -- @preserve */ if (reason == "distributionChannel") /**
			* Your license does not allow the current distribution channel.
			*
			* These are the available distribution channels:
			* * Self-hosted - the editor is installed via npm or from a ZIP package
			* * Cloud - the editor is run from CDN
			*
			* The licenses available include:
			* * GPL license for open-source users.
			* * Commercial plans (Cloud or sales-assisted).
			*
			* The relation between distribution channels and licenses works as follows:
			* * With the 'GPL' license key, you may use the editor installed via npm or a ZIP package (self-hosted).
			* * With the CKEditor Cloud plans, you may use the editor via our CDN.
			* * With the CKEditor Custom plans, depending on your plan details, you can use the editor via npm
			*   or a ZIP package (self-hosted) or Cloud (CDN).
			*
			* {@glink getting-started/licensing/usage-based-billing#key-terms Read more about distributions in the documentation}.
			* Please verify your installation or [contact support](https://ckeditor.com/contact/) for assistance.
			* Should you need to migrate your installation from npm to CDN, please refer to our
			* [dedicated migration guides](https://ckeditor.com/docs/ckeditor5/latest/updating/migrations/vanilla-js.html).
			*
			* @error license-key-invalid-distribution-channel
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("license-key-invalid-distribution-channel");
        }, 0);
        this._showLicenseError = ()=>{};
    }
    /**
	* This part of the code is _not_ executed in installations under the GPL license (with `config.licenseKey = 'GPL'`).
	*
	* It is only executed when a specific license key is provided. If you are uncertain whether
	* this applies to your installation, please contact our support team.
	*/ async _sendUsageRequest(endpoint, request) {
        const headers = new Headers({
            "Content-Type": "application/json"
        });
        const response = await fetch(new URL(endpoint), {
            method: "POST",
            headers: headers,
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new Error(`HTTP Response: ${response.status}`);
        return response.json();
    }
};
function $7ca4ca5784e50ca9$var$collectUsageData(editor) {
    const collectedData = $7ca4ca5784e50ca9$export$4fc62c90cdc835ab(editor);
    function setUsageData(path, value) {
        if ((0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(collectedData, path) !== void 0) /**
		* The error thrown when trying to set the usage data path that was already set.
		* Make sure that you are not setting the same path multiple times.
		*
		* @error editor-usage-data-path-already-set
		* @param {string} path The path that was already set.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-usage-data-path-already-set", {
            path: path
        });
        (0, $56bb5d9ef9e7bd30$export$adaa4cf7ef1b65be)(collectedData, path, value);
    }
    editor.fire("collectUsageData", {
        setUsageData: setUsageData
    });
    return collectedData;
}
/**
* This error is thrown when trying to pass a `<textarea>` element to a `create()` function of an editor class.
*
* The only editor type which can be initialized on `<textarea>` elements is
* the {@glink getting-started/setup/editor-types#classic-editor classic editor}.
* This editor hides the passed element and inserts its own UI next to it. Other types of editors reuse the passed element as their root
* editable element and therefore `<textarea>` is not appropriate for them. Use a `<div>` or another text container instead:
*
* ```html
* <div id="editor">
* 	<p>Initial content.</p>
* </div>
* ```
*
* @error editor-wrong-element
*/ /**
* You are running [CKEditor 5 Long-term Support Edition (LTS)](https://ckeditor.com/ckeditor-5-lts/),
* but the provided license key does not include access to the LTS version, or the key is invalid.
*
* Please ensure that it is copied correctly from the [Customer Portal](http://portal.ckeditor.com/),
* and if the issue persists, please [contact our customer support](https://ckeditor.com/contact/).
*
* In case you intended to use the [LTS Edition](https://ckeditor.com/ckeditor-5-lts/),
* but have not yet made a purchase, please [contact our sales team](https://ckeditor.com/contact-sales/)
*
* If you did not intend to use LTS, please note that all releases in the v47.7 line are
* for LTS subscribers only. To use a non-LTS edition, either upgrade to v48 or newer,
* which is our standard [latest](https://ckeditor.com/docs/ckeditor5/latest/updating/guides/changelog.html)
* release line, or stay on a version 47.6.2 or earlier.
*
* @error license-key-lts-not-allowed
*/ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/resolveerrorsource
*/ /**
* Answers what an error came from, given the context it was thrown with.
*
* Returns every editor the error can be attributed to, or the contexts when no editor claims it. The list is
* empty when no answer can be given. That is not necessarily a bug: it also happens for a context that is
* `null`, omitted, or an object that shares nothing with any editor currently running.
*
* @internal
*/ function $7ca4ca5784e50ca9$var$resolveErrorSources(context) {
    if (context instanceof $7ca4ca5784e50ca9$export$7cda8d932e2f33c0) return [
        context
    ];
    if (context instanceof $7ca4ca5784e50ca9$export$841858b892ce1f4c && $7ca4ca5784e50ca9$var$_isLiveContext(context)) return [
        context
    ];
    if (!context || typeof context != "object") return [];
    const editors = Array.from($7ca4ca5784e50ca9$var$_getLiveEditors()).filter((editor)=>$7ca4ca5784e50ca9$var$areConnectedThroughProperties(editor, context, editor._errorExclusions));
    if (editors.length) return editors;
    return Array.from($7ca4ca5784e50ca9$var$_getLiveContexts()).filter((liveContext)=>$7ca4ca5784e50ca9$var$areConnectedThroughProperties(liveContext, context) && !$7ca4ca5784e50ca9$var$belongsToAnyEditorIn(liveContext, context));
}
/**
* Whether an editor in the context owns the error, whether or not that editor is ready.
*
* Everything in a context is reachable from it through {@link module:core/context~Context#editors}, so a
* context matches an error from any editor inside it. The loop above only asks ready editors, which leaves
* a window on either side of an editor's life — still starting up, or already tearing down — where the
* editor cannot answer for itself and the context would answer instead. A context has no ready state to
* filter on, so such an error would be reported when it should not be.
*
* Asking the editors first closes that window: an editor claims its own errors regardless of readiness,
* which keeps the context from claiming them, and the readiness check then drops them.
*/ function $7ca4ca5784e50ca9$var$belongsToAnyEditorIn(liveContext, context) {
    return Array.from(liveContext.editors).some((editor)=>$7ca4ca5784e50ca9$var$areConnectedThroughProperties(editor, context, editor._errorExclusions));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/errorreporter
*/ /**
* Watches `window` for errors that escaped an editor and hands them to registered callbacks.
*
* There is one instance per page, kept below as module state. It is a class rather than a set of closures
* so that tests can build a fresh one instead of fighting leftover module state.
*/ var $7ca4ca5784e50ca9$var$EditorErrorReporter = class {
    /**
	* Holders rather than the callbacks themselves, so that registering the same function twice produces
	* two independent registrations and one unsubscribe call removes only its own.
	*/ _registrations = /* @__PURE__ */ new Set();
    /**
	* Errors already handed out. An error can reach both listeners, and a rejected promise carrying an
	* error that also fired `error` would otherwise be reported twice.
	*/ _reported = /* @__PURE__ */ new WeakSet();
    /**
	* Declared here rather than created in `_attach()`, so that the reference handed to
	* `removeEventListener()` is provably the one `addEventListener()` was given.
	*/ _onError = (event)=>{
        this._handle(event.error);
    };
    _onRejection = (event)=>{
        this._handle(event.reason);
    };
    _isAttached = false;
    add(callback) {
        const registration = {
            callback: callback
        };
        this._registrations.add(registration);
        this._attach();
        return ()=>{
            if (this._registrations.delete(registration)) this._detach();
        };
    }
    /**
	* Listeners go up with the first registration rather than on import, so a bundle that only imports this
	* module never touches `window`. Registering does, in line with the rest of the editor — this is browser
	* code.
	*/ _attach() {
        if (this._isAttached || this._registrations.size === 0) return;
        this._isAttached = true;
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.addEventListener("error", this._onError);
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.addEventListener("unhandledrejection", this._onRejection);
    }
    _detach() {
        if (!this._isAttached || this._registrations.size > 0) return;
        this._isAttached = false;
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.removeEventListener("error", this._onError);
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.removeEventListener("unhandledrejection", this._onRejection);
    }
    _handle(error) {
        if (!$7ca4ca5784e50ca9$var$isCKEditorError(error) || this._reported.has(error)) return;
        const sources = $7ca4ca5784e50ca9$var$resolveErrorSources(error.context).filter((source)=>!(source instanceof $7ca4ca5784e50ca9$export$7cda8d932e2f33c0) || source.state === "ready");
        if (!sources.length) return;
        this._reported.add(error);
        for (const source of sources)for (const { callback: callback } of Array.from(this._registrations))try {
            callback({
                error: error,
                source: source
            });
        } catch (callbackError) {
            console.error("An error happened in an editor error callback.", callbackError);
        }
    }
};
function $7ca4ca5784e50ca9$var$isCKEditorError(error) {
    if (!(error instanceof Error)) return false;
    const candidate = error;
    return typeof candidate.is == "function" && candidate.is("CKEditorError");
}
const $7ca4ca5784e50ca9$var$reporter = /* #__PURE__ -- @preserve */ new $7ca4ca5784e50ca9$var$EditorErrorReporter();
/**
* Registers a callback for errors that escape an editor, and returns a function that unregisters it.
*
* ```ts
* const off = onEditorError( ( { error, source } ) => {
* 	if ( source !== myEditor ) {
* 		return;
* 	}
*
* 	reportToMyErrorTracker( error );
* } );
* ```
*
* There is one registration surface for the whole page rather than one per editor, so an integrator running
* several editors compares `source` with their own instance, as above. Registering the same callback twice
* gives two independent registrations, and each unregisters on its own.
*
* One error can reach the callback more than once, once for every editor it is attributed to — see
* {@link module:core/errorreporter~EditorErrorData#source}.
*
* Reporting only. Nothing is restarted and nothing is swallowed — the error still reaches the console.
*/ function $7ca4ca5784e50ca9$export$7397e636447e6d91(callback) {
    return $7ca4ca5784e50ca9$var$reporter.add(callback);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/context
*/ /**
* Provides a common, higher-level environment for solutions that use multiple {@link module:core/editor/editor~Editor editors}
* or plugins that work outside the editor. Use it instead of {@link module:core/editor/editor~Editor.create `Editor.create()`}
* in advanced application integrations.
*
* All configuration options passed to a context will be used as default options for the editor instances initialized in that context.
*
* {@link module:core/contextplugin~ContextPlugin Context plugins} passed to a context instance will be shared among all
* editor instances initialized in this context. These will be the same plugin instances for all the editors.
*
* **Note:** The context can only be initialized with {@link module:core/contextplugin~ContextPlugin context plugins}
* (e.g. [comments](https://ckeditor.com/collaboration/comments/)). Regular {@link module:core/plugin~Plugin plugins} require an
* editor instance to work and cannot be added to a context.
*
* **Note:** You can add a context plugin to an editor instance, though.
*
* If you are using multiple editor instances on one page and use any context plugins, create a context to share the configuration and
* plugins among these editors. Some plugins will use the information about all existing editors to better integrate between them.
*
* If you are using plugins that do not require an editor to work (e.g. [comments](https://ckeditor.com/collaboration/comments/)),
* enable and configure them using the context.
*
* If you are using only a single editor on each page, use {@link module:core/editor/editor~Editor.create `Editor.create()`} instead.
* In such a case, a context instance will be created by the editor instance in a transparent way.
*
* See {@link ~Context.create `Context.create()`} for usage examples.
*/ var $7ca4ca5784e50ca9$export$841858b892ce1f4c = class {
    /**
	* Stores all the configurations specific to this context instance.
	*/ config;
    /**
	* The plugins loaded and in use by this context instance.
	*/ plugins;
    locale;
    /**
	* Shorthand for {@link module:utils/locale~Locale#t}.
	*/ t;
    /**
	* A list of editors that this context instance is injected to.
	*/ editors;
    /**
	* Everything reachable from this context, with the editors in it left out.
	*
	* Error attribution decides whether an object belongs to an editor by looking for anything the two have
	* in common. Every editor in a context can be reached from every other one through
	* {@link #editors}, so without excluding what the context itself owns, any error would look like it
	* belongs to any editor.
	*
	* Filled in by {@link ~Context#initPlugins}, so it covers a context created through
	* {@link ~Context.create} as well as one built by hand, as long as its plugins were initialized. A
	* context an editor made for itself never gets there, because the editor initializes its own plugins
	* instead: it holds that editor alone, so there is nothing to tell apart.
	*
	* Temporary, for as long as attribution walks object graphs.
	*
	* @internal
	*/ _errorExclusions;
    /**
	* The default configuration which is built into the `Context` class.
	*
	* It was used in the now deprecated CKEditor 5 builds featuring `Context` to provide the default configuration options
	* which are later used during the context initialization.
	*
	* ```ts
	* Context.defaultConfig = {
	* 	foo: 1,
	* 	bar: 2
	* };
	*
	* Context
	* 	.create()
	* 	.then( context => {
	* 		context.config.get( 'foo' ); // -> 1
	* 		context.config.get( 'bar' ); // -> 2
	* 	} );
	*
	* // The default options can be overridden by the configuration passed to create().
	* Context
	* 	.create( { bar: 3 } )
	* 	.then( context => {
	* 		context.config.get( 'foo' ); // -> 1
	* 		context.config.get( 'bar' ); // -> 3
	* 	} );
	* ```
	*
	* See also {@link module:core/context~Context.builtinPlugins `Context.builtinPlugins`}
	* and {@link module:core/editor/editor~Editor.defaultConfig `Editor.defaultConfig`}.
	*/ static defaultConfig;
    /**
	* An array of plugins built into the `Context` class.
	*
	* It was used in the now deprecated CKEditor 5 builds featuring `Context` to provide the default configuration options
	* which are later used during the context initialization.
	*
	* They will be automatically initialized by `Context` unless `config.plugins` is passed.
	*
	* ```ts
	* // Build some context plugins into the Context class first.
	* Context.builtinPlugins = [ FooPlugin, BarPlugin ];
	*
	* // Normally, you need to define config.plugins, but since Context.builtinPlugins was
	* // defined, now you can call create() without any configuration.
	* Context
	* 	.create()
	* 	.then( context => {
	* 		context.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
	* 		context.plugins.get( BarPlugin ); // -> An instance of the Bar plugin.
	* 	} );
	* ```
	*
	* See also {@link module:core/context~Context.defaultConfig `Context.defaultConfig`}
	* and {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}.
	*/ static builtinPlugins;
    /**
	* Reference to the editor which created the context.
	* Null when the context was created outside of the editor.
	*
	* It is used to destroy the context when removing the editor that has created the context.
	*/ _contextOwner = null;
    /**
	* Creates a context instance with a given configuration.
	*
	* Usually not to be used directly. See the static {@link module:core/context~Context.create `create()`} method.
	*
	* @param config The context configuration.
	*/ constructor(config){
        const { translations: translations, ...rest } = config || {};
        this.config = new (0, $c7bc2cb7e2db0227$export$29cd7b75162a9425)(rest, this.constructor.defaultConfig);
        const availablePlugins = this.constructor.builtinPlugins;
        this.config.define("plugins", availablePlugins);
        this.plugins = new $7ca4ca5784e50ca9$export$5908a802ac6e3d12(this, availablePlugins);
        const languageConfig = this.config.get("language") || {};
        this.locale = new (0, $c7bc2cb7e2db0227$export$d4f428a61c37ddfa)({
            uiLanguage: typeof languageConfig === "string" ? languageConfig : languageConfig.ui,
            contentLanguage: this.config.get("language.content"),
            translations: translations
        });
        this.t = this.locale.t;
        this.editors = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    }
    /**
	* Loads and initializes plugins specified in the configuration.
	*
	* @returns A promise which resolves once the initialization is completed, providing an array of loaded plugins.
	*/ initPlugins() {
        const plugins = this.config.get("plugins") || [];
        const substitutePlugins = this.config.get("substitutePlugins") || [];
        for (const Plugin of plugins.concat(substitutePlugins)){
            if (typeof Plugin != "function") /**
			* Only a constructor function is allowed as a {@link module:core/contextplugin~ContextPlugin context plugin}.
			*
			* @error context-initplugins-constructor-only
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("context-initplugins-constructor-only", null, {
                Plugin: Plugin
            });
            if (Plugin.isContextPlugin !== true) /**
			* Only a plugin marked as a {@link module:core/contextplugin~ContextPlugin.isContextPlugin context plugin}
			* is allowed to be used with a context.
			*
			* @error context-initplugins-invalid-plugin
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("context-initplugins-invalid-plugin", null, {
                Plugin: Plugin
            });
        }
        return this.plugins.init(plugins, [], substitutePlugins).then((loadedPlugins)=>{
            this._errorExclusions = $7ca4ca5784e50ca9$var$getSubNodes(this, new Set(this.editors));
            $7ca4ca5784e50ca9$var$_addLiveContext(this);
            return loadedPlugins;
        });
    }
    /**
	* Destroys the context instance and all editors used with the context,
	* releasing all resources used by the context.
	*
	* @returns A promise that resolves once the context instance is fully destroyed.
	*/ destroy() {
        $7ca4ca5784e50ca9$var$_removeLiveContext(this);
        return Promise.all(Array.from(this.editors, (editor)=>editor.destroy())).then(()=>this.plugins.destroy());
    }
    /**
	* Adds a reference to the editor which is used with this context.
	*
	* When the given editor has created the context, the reference to this editor will be stored
	* as a {@link ~Context#_contextOwner}.
	*
	* This method should only be used by the editor.
	*
	* @internal
	* @param isContextOwner Stores the given editor as a context owner.
	*/ _addEditor(editor, isContextOwner) {
        if (this._contextOwner) /**
		* Cannot add multiple editors to the context which is created by the editor.
		*
		* @error context-addeditor-private-context
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("context-addeditor-private-context");
        this.editors.add(editor);
        if (isContextOwner) this._contextOwner = editor;
    }
    /**
	* Removes a reference to the editor which was used with this context.
	* When the context was created by the given editor, the context will be destroyed.
	*
	* This method should only be used by the editor.
	*
	* @internal
	* @return A promise that resolves once the editor is removed from the context or when the context was destroyed.
	*/ _removeEditor(editor) {
        if (this.editors.has(editor)) this.editors.remove(editor);
        if (this._contextOwner === editor) return this.destroy();
        return Promise.resolve();
    }
    /**
	* Returns the context configuration which will be copied to the editors created using this context.
	*
	* The configuration returned by this method has the plugins configuration removed &ndash; plugins are shared with all editors
	* through another mechanism.
	*
	* This method should only be used by the editor.
	*
	* @internal
	* @returns Configuration as a plain object.
	*/ _getEditorConfig() {
        const result = {};
        for (const name of this.config.names())if (![
            "plugins",
            "removePlugins",
            "extraPlugins"
        ].includes(name)) result[name] = this.config.get(name);
        return result;
    }
    /**
	* Creates and initializes a new context instance.
	*
	* ```ts
	* const commonConfig = { ... }; // Configuration for all the plugins and editors.
	* const editorPlugins = [ ... ]; // Regular plugins here.
	*
	* Context
	* 	.create( {
	* 		// Only context plugins here.
	* 		plugins: [ ... ],
	*
	* 		// Configure the language for all the editors (it cannot be overwritten).
	* 		language: { ... },
	*
	* 		// Configuration for context plugins.
	* 		comments: { ... },
	* 		...
	*
	* 		// Default configuration for editor plugins.
	* 		toolbar: { ... },
	* 		image: { ... },
	* 		...
	* 	} )
	* 	.then( context => {
	* 		const promises = [];
	*
	* 		promises.push( ClassicEditor.create(
	* 			document.getElementById( 'editor1' ),
	* 			{
	* 				editorPlugins,
	* 				context
	* 			}
	* 		) );
	*
	* 		promises.push( ClassicEditor.create(
	* 			document.getElementById( 'editor2' ),
	* 			{
	* 				editorPlugins,
	* 				context,
	* 				toolbar: { ... } // You can overwrite the configuration of the context.
	* 			}
	* 		) );
	*
	* 		return Promise.all( promises );
	* 	} );
	* ```
	*
	* @param config The context configuration.
	* @returns A promise resolved once the context is ready. The promise resolves with the created context instance.
	*/ static create(config) {
        return new Promise((resolve)=>{
            const context = new this(config);
            resolve(context.initPlugins().then(()=>context));
        });
    }
    /**
	* {@link module:core/errorreporter~onEditorError `onEditorError()`}, reachable without importing it.
	*
	* The same accessor as {@link module:core/editor/editor~Editor.onEditorError `Editor.onEditorError`},
	* and here for the same reason. A context is the only handle some integrations have: a component that
	* provides a shared context holds no editor class at all.
	*/ static get onEditorError() {
        return $7ca4ca5784e50ca9$export$7397e636447e6d91;
    }
    /**
	* `Context` class is commonly put in `config.plugins` array.
	*
	* This property helps with better error detection.
	*
	* @internal
	*/ static get _throwErrorWhenUsedAsAPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/contextplugin
*/ const $7ca4ca5784e50ca9$var$ContextPluginBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The base class for {@link module:core/context~Context} plugin classes.
*
* A context plugin can either be initialized for an {@link module:core/editor/editor~Editor editor} or for
* a {@link module:core/context~Context context}. In other words, it can either
* work within one editor instance or with one or more editor instances that use a single context.
* It is the context plugin's role to implement handling for both modes.
*
* There are a few rules for interaction between the editor plugins and context plugins:
*
* * A context plugin can require another context plugin.
* * An {@link module:core/plugin~Plugin editor plugin} can require a context plugin.
* * A context plugin MUST NOT require an {@link module:core/plugin~Plugin editor plugin}.
*/ var $7ca4ca5784e50ca9$export$a3df350528b28529 = class extends $7ca4ca5784e50ca9$var$ContextPluginBase {
    /**
	* The context or editor instance.
	*/ context;
    /**
	* Creates a new plugin instance.
	*/ constructor(context){
        super();
        this.context = context;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this.stopListening();
    }
    /**
	* @inheritDoc
	*/ static get isContextPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return false;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A plugin that records user actions and editor state changes for debugging purposes. It tracks commands execution, model operations,
* UI interactions, and document events. It just collects data locally, and does not send it anywhere, integrator is responsible
* for gathering data from this plugin for further processing.
*
* **Important! `ActionsRecorder` is an experimental feature, and may become deprecated.**
*
* By default, plugin stores latest 1000 action entries. Integrator can register an `onError` callback to collect those entries
* in case of exception. Integrator should augment this data with application specific data such as page-id or session-id,
* depending on the application. Augmented data should be processed by the integrator, for example integrator should send it
* to some data collecting endpoint for later analysis.
*
* Example:
*
* ```ts
* 	ClassicEditor
* 		.create( {
* 			plugins: [ ActionsRecorder, ... ],
* 			actionsRecorder: {
* 				maxEntries: 1000, // This is the default value and could be adjusted.
*
* 				onError( error, entries ) {
* 					console.error( 'ActionsRecorder - Error detected:', error );
* 					console.warn( 'Actions recorded before error:', entries );
*
* 					this.flushEntries();
*
* 					// Integrator should send and store the entries. The error is already in the last entry in serializable form.
* 				}
* 			}
* 		} )
* 		.then( ... )
* 		.catch( ... );
* ```
*
* Alternatively integrator could continuously collect actions in batches and send them to theirs endpoint for later analysis:
*
* ```ts
* 	ClassicEditor
* 		.create( {
* 			plugins: [ ActionsRecorder, ... ],
* 			actionsRecorder: {
* 				maxEntries: 50, // This is the batch size.
*
* 				onMaxEntries() {
* 					const entries = this.getEntries();
*
* 					this.flushEntries();
*
* 					console.log( 'ActionsRecorder - Batch of entries:', entries );
*
* 					// Integrator should send and store the entries.
* 				},
*
* 				onError( error, entries ) {
* 					console.error( 'ActionsRecorder - Error detected:', error );
* 					console.warn( 'Actions recorded before error:', entries );
*
* 					this.flushEntries();
*
* 					// Integrator should send and store the entries. The error is already in the last entry in serializable form.
* 				}
* 			}
* 		} )
* 		.then( ... )
* 		.catch( ... );
* ```
*
* See {@link module:core/actionsrecorderconfig~ActionsRecorderConfig plugin configuration} for more details.
*
*/ var $7ca4ca5784e50ca9$export$1fb57a9df3a6a02c = class {
    /**
	* The editor instance.
	*/ editor;
    /**
	* Array storing all recorded action entries with their context and state snapshots.
	*/ _entries = [];
    /**
	* Stack tracking nested action frames to maintain call hierarchy.
	*/ _frameStack = [];
    /**
	* Set of already reported errors used to notify only once for each error (not on every try-catch nested block).
	*/ _errors = /* @__PURE__ */ new Set();
    /**
	* Maximum number of action entries to keep in memory.
	*/ _maxEntries;
    /**
	* Error callback.
	*/ _errorCallback;
    /**
	* Filter function to determine which entries should be stored.
	*/ _filterCallback;
    /**
	* Callback triggered every time count of recorded entries reaches maxEntries.
	*/ _maxEntriesCallback;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ActionsRecorder";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        this.editor = editor;
        editor.config.define("actionsRecorder.maxEntries", 1e3);
        const config = editor.config.get("actionsRecorder");
        this._maxEntries = config.maxEntries;
        this._filterCallback = config.onFilter;
        this._errorCallback = config.onError;
        this._maxEntriesCallback = config.onMaxEntries || this._maxEntriesDefaultHandler;
        this._tapCommands();
        this._tapOperationApply();
        this._tapModelMethods();
        this._tapModelSelection();
        this._tapComponentFactory();
        this._tapViewDocumentEvents();
    }
    /**
	* Returns all recorded action entries.
	*/ getEntries() {
        return this._entries.slice();
    }
    /**
	* Flushes all recorded entries.
	*/ flushEntries() {
        this._entries = [];
    }
    /**
	* Creates a new action frame and adds it to the recording stack.
	*
	* @param action The name/type of the action being recorded.
	* @param params Optional parameters associated with the event.
	* @returns The created call frame object.
	*/ _enterFrame(action, params) {
        const callFrame = {
            timeStamp: /* @__PURE__ */ new Date().toISOString(),
            ...this._frameStack.length && {
                parentEntry: this._frameStack.at(-1)
            },
            action: action,
            params: params?.map((param)=>$7ca4ca5784e50ca9$var$serializeValue(param)),
            before: this._buildStateSnapshot()
        };
        if (!this._filterCallback || this._filterCallback(callFrame, this._entries)) this._entries.push(callFrame);
        this._frameStack.push(callFrame);
        return callFrame;
    }
    /**
	* Closes an action frame and records its final state and results.
	*
	* @param callFrame The call frame to close.
	* @param result Optional result value from the action.
	* @param error Optional error that occurred during the action.
	*/ _leaveFrame(callFrame, result, error) {
        const topFrame = this._frameStack.pop();
        if (!topFrame || topFrame !== callFrame) return;
        if (result !== void 0) topFrame.result = $7ca4ca5784e50ca9$var$serializeValue(result);
        if (error) topFrame.error = $7ca4ca5784e50ca9$var$serializeValue(error);
        topFrame.after = this._buildStateSnapshot();
        if (error) this._callErrorCallback(error);
        if (this._frameStack.length == 0) this._errors.clear();
        if (this._entries.length >= this._maxEntries) this._maxEntriesCallback();
    }
    /**
	* Builds a snapshot of the current editor state including document version,
	* read-only status, focus state, and model selection.
	*
	* @returns An object containing the current editor state snapshot.
	*/ _buildStateSnapshot() {
        const { model: model, isReadOnly: isReadOnly, editing: editing } = this.editor;
        return {
            documentVersion: model.document.version,
            editorReadOnly: isReadOnly,
            editorFocused: editing.view.document.isFocused,
            modelSelection: $7ca4ca5784e50ca9$var$serializeValue(model.document.selection)
        };
    }
    /**
	* Sets up recording for all editor commands, both existing and future ones.
	* Taps into the command execution to track when commands are run.
	*/ _tapCommands() {
        for (const [commandName, command] of this.editor.commands)this._tapCommand(commandName, command);
        $7ca4ca5784e50ca9$var$tapObjectMethod(this.editor.commands, "add", {
            before: (callContext, [commandName, command])=>{
                this._tapCommand(commandName, command);
                return false;
            }
        });
    }
    /**
	* Sets up recording for model operation applications.
	* Tracks when operations are applied to the model document.
	*/ _tapOperationApply() {
        $7ca4ca5784e50ca9$var$tapObjectMethod(this.editor.model, "applyOperation", {
            before: (callContext, [operation])=>{
                if (operation.baseVersion === null) return false;
                callContext.callFrame = this._enterFrame("model.applyOperation", [
                    operation
                ]);
                return true;
            },
            after: (callContext)=>{
                this._leaveFrame(callContext.callFrame);
            },
            error: (callContext, error)=>{
                this._leaveFrame(callContext.callFrame, void 0, error);
            }
        });
    }
    /**
	* Sets up recording for key model methods like insertContent, insertObject, and deleteContent.
	* These methods represent high-level model manipulation operations.
	*/ _tapModelMethods() {
        for (const methodName of [
            "insertContent",
            "insertObject",
            "deleteContent"
        ])$7ca4ca5784e50ca9$var$tapObjectMethod(this.editor.model, methodName, {
            before: (callContext, ...params)=>{
                callContext.callFrame = this._enterFrame(`model.${methodName}`, params);
                return true;
            },
            after: (callContext, result)=>{
                this._leaveFrame(callContext.callFrame, result);
            },
            error: (callContext, error)=>{
                this._leaveFrame(callContext.callFrame, void 0, error);
            }
        });
    }
    /**
	* Sets up recording for model selection changes.
	* Tracks when the selection range, attributes, or markers change.
	*/ _tapModelSelection() {
        this._tapFireMethod(this.editor.model.document.selection, [
            "change:range",
            "change:attribute",
            "change:marker"
        ], {
            eventSource: "model-selection"
        });
    }
    /**
	* Sets up recording for a specific command execution.
	*
	* @param commandName The name of the command to record.
	* @param command The command instance to tap into.
	*/ _tapCommand(commandName, command) {
        $7ca4ca5784e50ca9$var$tapObjectMethod(command, "execute", {
            before: (callContext, params)=>{
                callContext.callFrame = this._enterFrame(`commands.${commandName}:execute`, params);
                return true;
            },
            after: (callContext, result)=>{
                this._leaveFrame(callContext.callFrame, result);
            },
            error: (callContext, error)=>{
                this._leaveFrame(callContext.callFrame, void 0, error);
            }
        });
    }
    /**
	* Sets up recording for UI component factory creation and component interactions.
	* Tracks when components are created and their execute events.
	*/ _tapComponentFactory() {
        $7ca4ca5784e50ca9$var$tapObjectMethod(this.editor.ui.componentFactory, "create", {
            before: (callContext, [componentName])=>{
                callContext.componentName = componentName;
                callContext.callFrame = this._enterFrame(`component-factory.create:${componentName}`);
                return true;
            },
            after: (callContext, componentInstance)=>{
                const executeContext = {
                    ...callContext,
                    eventSource: `component.${callContext.componentName}`
                };
                if (typeof componentInstance.fire == "function") this._tapFireMethod(componentInstance, [
                    "execute"
                ], executeContext);
                if (typeof componentInstance.panelView?.fire == "function") this._tapFireMethod(componentInstance.panelView, [
                    "execute"
                ], executeContext);
                if (typeof componentInstance.buttonView?.actionView?.fire == "function") this._tapFireMethod(componentInstance.buttonView.actionView, [
                    "execute"
                ], executeContext);
                this._leaveFrame(callContext.callFrame);
            },
            error: (callContext, error)=>{
                this._leaveFrame(callContext.callFrame, void 0, error);
            }
        });
    }
    /**
	* Sets up recording for view document events like clicks, keyboard input,
	* selection changes, and other user interactions.
	*/ _tapViewDocumentEvents() {
        this._tapFireMethod(this.editor.editing.view.document, [
            "click",
            "mousedown",
            "mouseup",
            "pointerdown",
            "pointerup",
            "focus",
            "blur",
            "keydown",
            "keyup",
            "selectionChange",
            "compositionstart",
            "compositionend",
            "beforeinput",
            "mutations",
            "enter",
            "delete",
            "insertText",
            "paste",
            "copy",
            "cut",
            "dragstart",
            "drop"
        ], {
            eventSource: "observers"
        });
    }
    /**
	* Sets up recording for specific events fired by an emitter object.
	*
	* @param emitter The object that fires events to be recorded.
	* @param eventNames Array of event names to record.
	* @param context Additional context to include with recorded events.
	*/ _tapFireMethod(emitter, eventNames, context = {}) {
        $7ca4ca5784e50ca9$var$tapObjectMethod(emitter, "fire", {
            before: (callContext, [eventInfoOrName, ...params])=>{
                const eventName = typeof eventInfoOrName == "string" ? eventInfoOrName : eventInfoOrName.name;
                if (!eventNames.includes(eventName)) return false;
                callContext.callFrame = this._enterFrame(`${callContext.eventSource}:${eventName}`, params);
                return true;
            },
            after: (callContext, result)=>{
                this._leaveFrame(callContext.callFrame, result);
            },
            error: (callContext, error)=>{
                this._leaveFrame(callContext.callFrame, void 0, error);
            }
        }, context);
    }
    /**
	* Triggers error callback.
	*/ _callErrorCallback(error) {
        if (!this._errorCallback || this._errors.has(error)) return;
        this._errors.add(error);
        try {
            this._errorCallback(error, this.getEntries());
        } catch (observerError) {
            console.error("ActionsRecorder onError callback error:", observerError);
        }
    }
    /**
	* The default handler for maxEntries callback.
	*/ _maxEntriesDefaultHandler() {
        this._entries.shift();
    }
};
/**
* Creates a wrapper around a method to record its calls, results, and errors.
*
* @internal
*
* @param object The object containing the method to tap.
* @param methodName The name of the method to tap.
* @param tap The tap configuration with before/after/error hooks.
* @param context Additional context to include with the method calls.
*/ function $7ca4ca5784e50ca9$var$tapObjectMethod(object, methodName, tap, context = {}) {
    const originalMethod = object[methodName];
    if (originalMethod[Symbol.for("Tapped method")]) return;
    object[methodName] = (...args)=>{
        const callContext = Object.assign({}, context);
        let shouldHandle;
        try {
            shouldHandle = tap.before?.(callContext, args);
            const result = originalMethod.apply(object, args);
            if (shouldHandle) tap.after?.(callContext, result);
            return result;
        } catch (error) {
            if (shouldHandle) tap.error?.(callContext, error);
            throw error;
        }
    };
    object[methodName][Symbol.for("Tapped method")] = originalMethod;
}
/**
* Serializes a value into a JSON-serializable format.
*
* @internal
*
* @param value The value to serialize.
* @param visited Set of already serialized objects to avoid circular references.
* @returns A JSON-serializable representation of the value.
*/ function $7ca4ca5784e50ca9$var$serializeValue(value, visited = /* @__PURE__ */ new WeakSet()) {
    if (!value || [
        "boolean",
        "number",
        "string"
    ].includes(typeof value)) return value;
    if (typeof value.toJSON == "function") {
        const jsonData = value.toJSON();
        if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(jsonData) || Array.isArray(jsonData) || [
            "string",
            "number",
            "boolean"
        ].includes(typeof jsonData)) return $7ca4ca5784e50ca9$var$serializeValue(jsonData, visited);
    }
    if (value instanceof Error) return {
        name: value.name,
        message: value.message,
        stack: value.stack
    };
    if ($7ca4ca5784e50ca9$var$isTypeCheckable(value) || typeof value != "object") return {
        type: typeof value,
        constructor: value.constructor?.name || "unknown",
        string: String(value)
    };
    if (value instanceof File || value instanceof Blob || value instanceof FormData || value instanceof DataTransfer) return String(value);
    if (visited.has(value)) return;
    visited.add(value);
    if (Array.isArray(value)) return value.length ? value.map((item)=>$7ca4ca5784e50ca9$var$serializeValue(item, visited)) : void 0;
    const result = {};
    const ignoreFields = [];
    if (value.domEvent) {
        ignoreFields.push("domEvent", "domTarget", "view", "document");
        result.domEvent = $7ca4ca5784e50ca9$var$serializeDomEvent(value.domEvent);
        result.target = $7ca4ca5784e50ca9$var$serializeValue(value.target);
        if (value.dataTransfer) result.dataTransfer = {
            types: value.dataTransfer.types,
            htmlData: value.dataTransfer.getData("text/html"),
            files: $7ca4ca5784e50ca9$var$serializeValue(value.dataTransfer.files)
        };
    }
    for (const [key, val] of Object.entries(value)){
        if (key.startsWith("_") || ignoreFields.includes(key) || typeof val == "function") continue;
        const serializedValue = $7ca4ca5784e50ca9$var$serializeValue(val, visited);
        if (serializedValue !== void 0) result[key] = serializedValue;
    }
    if (Symbol.iterator in value) {
        const items = Array.from(value[Symbol.iterator]()).map((item)=>$7ca4ca5784e50ca9$var$serializeValue(item, visited));
        if (items.length) result._items = items;
    }
    return Object.keys(result).length ? result : void 0;
}
/**
* Serializes a DOM event into a plain object representation.
*
* Extracts common properties from DOM events such as type, target information,
* coordinates, key codes, and other relevant event data for debugging purposes.
*
* @param event The DOM event to serialize.
* @returns A serialized object containing the event's key properties.
*/ function $7ca4ca5784e50ca9$var$serializeDomEvent(event) {
    let serialized = {
        type: event.type,
        target: serializeDOMTarget(event.target)
    };
    if (event instanceof MouseEvent) serialized = {
        ...serialized,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey,
        metaKey: event.metaKey
    };
    if (event instanceof KeyboardEvent) serialized = {
        ...serialized,
        key: event.key,
        code: event.code,
        keyCode: event.keyCode,
        ctrlKey: event.ctrlKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey,
        metaKey: event.metaKey,
        repeat: event.repeat
    };
    if (event instanceof InputEvent) serialized = {
        ...serialized,
        data: event.data,
        inputType: event.inputType,
        isComposing: event.isComposing
    };
    if (event instanceof PointerEvent) serialized = {
        ...serialized,
        isPrimary: event.isPrimary
    };
    /**
	* Serializes a DOM event target into a plain object representation.
	*
	* @param target The DOM event target to serialize.
	* @returns A serialized object containing the target's information.
	*/ function serializeDOMTarget(target) {
        if (!target) return null;
        if (target instanceof Element) return {
            tagName: target.tagName,
            className: target.className,
            id: target.id
        };
        if (target instanceof Window || target instanceof Document) return {
            type: target.constructor.name
        };
        return {};
    }
    return serialized;
}
/**
* Checks if a value is type-checkable, meaning it has an `is` method.
*/ function $7ca4ca5784e50ca9$var$isTypeCheckable(value) {
    return value && typeof value.is === "function";
}
/* v8 ignore stop -- @preserve */ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/utils/attachtoform
*/ /**
* Checks if the editor is initialized on a `<textarea>` element that belongs to a form. If yes, it updates the editor's element
* content before submitting the form.
*
* This helper requires the {@link module:core/editor/utils/elementapimixin~ElementApi ElementApi interface}.
*
* @param editor Editor instance.
*/ function $7ca4ca5784e50ca9$export$49c9860462f722d8(editor) {
    if (!(0, $943eba72ca89f82b$export$f6e2535fb5126e54)(editor.updateSourceElement)) /**
	* The editor passed to `attachToForm()` must implement the
	* {@link module:core/editor/utils/elementapimixin~ElementApi} interface.
	*
	* @error attachtoform-missing-elementapi-interface
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("attachtoform-missing-elementapi-interface", editor);
    const sourceElement = editor.sourceElement;
    if ($7ca4ca5784e50ca9$var$isTextArea(sourceElement) && sourceElement.form) {
        let originalSubmit;
        const form = sourceElement.form;
        const onSubmit = ()=>editor.updateSourceElement();
        if ((0, $943eba72ca89f82b$export$f6e2535fb5126e54)(form.submit)) {
            originalSubmit = form.submit;
            form.submit = ()=>{
                onSubmit();
                originalSubmit.apply(form);
            };
        }
        form.addEventListener("submit", onSubmit);
        editor.on("destroy", ()=>{
            form.removeEventListener("submit", onSubmit);
            if (originalSubmit) form.submit = originalSubmit;
        });
    }
}
function $7ca4ca5784e50ca9$var$isTextArea(sourceElement) {
    return !!sourceElement && sourceElement.tagName.toLowerCase() === "textarea";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/utils/elementapimixin
*/ /**
* Implementation of the {@link module:core/editor/utils/elementapimixin~ElementApi}.
*/ function $7ca4ca5784e50ca9$export$d727bee3703dbc10(base) {
    class Mixin extends base {
        sourceElement;
        updateSourceElement(data) {
            if (!this.sourceElement) /**
			* Cannot update the source element of a detached editor.
			*
			* The {@link module:core/editor/utils/elementapimixin~ElementApi#updateSourceElement `updateSourceElement()`}
			* method cannot be called if you did not pass an element to `Editor.create()`.
			*
			* @error editor-missing-sourceelement
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-missing-sourceelement", this);
            const shouldUpdateSourceElement = this.config.get("updateSourceElementOnDestroy");
            const isSourceElementTextArea = this.sourceElement instanceof HTMLTextAreaElement;
            if (!shouldUpdateSourceElement && !isSourceElementTextArea) {
                (0, $c7bc2cb7e2db0227$export$38bb620396ade7f9)(this.sourceElement, "");
                return;
            }
            const dataToSet = typeof data === "string" ? data : this.data.get();
            (0, $c7bc2cb7e2db0227$export$38bb620396ade7f9)(this.sourceElement, dataToSet);
        }
    }
    return Mixin;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/utils/securesourceelement
*/ /**
* Marks the source element on which the editor was initialized. This prevents other editor instances from using this element.
*
* Running multiple editor instances on the same source element causes various issues and it is
* crucial this helper is called as soon as the source element is known to prevent collisions.
*
* @param editor Editor instance.
* @param sourceElement Element to bind with the editor instance.
*/ function $7ca4ca5784e50ca9$export$a7d1ef409587e25(editor, sourceElement) {
    if (sourceElement.ckeditorInstance) /**
	* A DOM element used to create the editor (e.g.
	* {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`})
	* has already been used to create another editor instance. Make sure each editor is
	* created with a unique DOM element.
	*
	* @error editor-source-element-already-used
	* @param {HTMLElement} element DOM element that caused the collision.
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-source-element-already-used", editor);
    sourceElement.ckeditorInstance = editor;
    editor.once("destroy", ()=>{
        delete sourceElement.ckeditorInstance;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $7ca4ca5784e50ca9$var$CONFIG_FIELDS_AS_ROOT_ATTRIBUTES = [
    [
        "description",
        "$description"
    ],
    [
        "title",
        "$title"
    ]
];
/**
* Registers and initializes root attributes from the editor configuration:
*
* * the attributes from
* {@link module:core/editor/editorconfig~RootConfig#modelAttributes `config.root(s).<rootName>.modelAttributes`}, and
* * the {@link module:core/editor/editorconfig~RootConfig#description `description`} and
* {@link module:core/editor/editorconfig~RootConfig#title `title`} fields, stored as the `$description` and `$title`
* root attributes respectively.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$58a114a982b34496(editor) {
    const rootsConfig = editor.config.get("roots");
    for (const [rootName, rootConfig] of Object.entries(rootsConfig)){
        let modelAttributes = null;
        for (const [configField, attributeKey] of $7ca4ca5784e50ca9$var$CONFIG_FIELDS_AS_ROOT_ATTRIBUTES){
            if (rootConfig[configField] == null || rootConfig.modelAttributes && attributeKey in rootConfig.modelAttributes) continue;
            modelAttributes = modelAttributes || {
                ...rootConfig.modelAttributes
            };
            modelAttributes[attributeKey] = rootConfig[configField];
        }
        if (modelAttributes) editor.config.set(`roots.${rootName}.modelAttributes`, modelAttributes);
    }
    const normalizedRootsConfig = editor.config.get("roots");
    let hasRootAttributes = false;
    for (const rootConfig of Object.values(normalizedRootsConfig))for (const key of Object.keys(rootConfig.modelAttributes || {})){
        editor.registerRootAttribute(key);
        hasRootAttributes = true;
    }
    if (!hasRootAttributes) return;
    editor.data.once("init", ()=>{
        editor.model.enqueueChange({
            isUndoable: false
        }, (writer)=>{
            for (const [rootName, rootConfig] of Object.entries(normalizedRootsConfig)){
                const root = editor.model.document.getRoot(rootName);
                if (!root) continue;
                for (const [key, value] of Object.entries(rootConfig.modelAttributes || {}))if (value !== null) writer.setAttribute(key, value, root);
            }
        });
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Normalizes the editor roots configuration. It ensures that all root configurations are defined in `config.roots`
* and that they have `initialData` defined.
*
* It normalizes a single-root configuration (where `config.root` is used) to a multi-root configuration
* (where all roots are defined in `config.roots`). This is considered a standard configuration format,
* so the editor features can always expect roots to be defined in `config.roots`.
*
* It also handles legacy configuration options, such as `config.initialData`, `config.placeholder`, and `config.label`.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$30c905284d284ef1(sourceElementsOrData, config, defaultRootName = "main", separateAttachTo = false) {
    const mainRootConfig = config.get("root");
    const rootsConfig = config.get("roots") || Object.create(null);
    if (!(0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(rootsConfig)) /**
	* The {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots`} option
	* must be a plain object (an object literal or `Object.create( null )`). Objects with a
	* custom prototype (e.g. created via `Object.create( someProto )`) or class instances
	* are not accepted, because internal configuration processing relies on a known
	* prototype chain to detect nested configuration objects.
	*
	* Replace the value with a plain object before passing it to the editor:
	*
	* ```ts
	* // Wrong
	* MultiRootEditor.create( {
	*     roots: Object.assign( Object.create( {} ), { intro: { ... } } )
	* } );
	*
	* // Right
	* MultiRootEditor.create( {
	*     roots: { intro: { ... } }
	* } );
	* ```
	*
	* @error editor-create-roots-not-plain-object
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-roots-not-plain-object", null);
    if (mainRootConfig) {
        if (!defaultRootName) /**
		* The {@link module:core/editor/editorconfig~EditorConfig#root `config.root`} option is designed
		* for single-root editors and cannot be used with the
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor multi-root editor}.
		*
		* To configure a multi-root editor, define each root individually using
		* {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots`}:
		*
		* ```ts
		* MultiRootEditor.create( {
		* 	roots: {
		* 		header: { initialData: '<p>Header</p>' },
		* 		content: { initialData: '<p>Content</p>' }
		* 	}
		* } );
		* ```
		*
		* @error editor-create-multi-root-with-main
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-multi-root-with-main", null);
        else if (defaultRootName in rootsConfig) /**
		* Both {@link module:core/editor/editorconfig~EditorConfig#root `config.root`} and
		* `config.roots.main` are set, but they both configure the same default editing root,
		* which creates an ambiguity. Use one or the other:
		*
		* * {@link module:core/editor/editorconfig~EditorConfig#root `config.root`} for a single-root editor.
		* * {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots`} when defining
		* multiple roots.
		*
		* @error editor-create-roots-with-main
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-roots-with-main", null);
    }
    if (defaultRootName && !rootsConfig[defaultRootName]) rootsConfig[defaultRootName] = mainRootConfig || Object.create(null);
    const sourceElementIsPlainObject = $7ca4ca5784e50ca9$var$isSourceElementsOrDataRecord(sourceElementsOrData);
    const legacyInitialData = $7ca4ca5784e50ca9$var$getLegacyInitialData(config, sourceElementIsPlainObject, defaultRootName);
    const rootNames = Array.from(/* @__PURE__ */ new Set([
        ...sourceElementIsPlainObject ? Object.keys(sourceElementsOrData) : [],
        ...Object.keys(rootsConfig),
        ...Object.keys(legacyInitialData)
    ]));
    for (const rootName of rootNames){
        const rootConfig = rootsConfig[rootName] || Object.create(null);
        const sourceElementOrDataForRoot = sourceElementIsPlainObject ? sourceElementsOrData[rootName] : sourceElementsOrData;
        if (!separateAttachTo && $7ca4ca5784e50ca9$var$isElement$1(sourceElementOrDataForRoot)) {
            if (rootConfig.element) /**
			* The root element is specified both as the first argument of the editor `create()` method
			* (e.g. {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`} or
			* {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`})
			* and in {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`}
			* (or `config.roots.<rootName>.element` for the
			* {@link module:editor-multi-root/multirooteditor~MultiRootEditor multi-root editor}).
			*
			* Passing the element as the first argument is deprecated. Remove it and use
			* {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`}
			* (or `config.roots.<rootName>.element` for the multi-root editor) instead.
			*
			* @error editor-create-root-element-overspecified
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-root-element-overspecified", null);
            rootConfig.element = sourceElementOrDataForRoot;
        }
        if (separateAttachTo && $7ca4ca5784e50ca9$var$isElement$1(rootConfig.element)) {
            /**
			* The {@link module:editor-classic/classiceditor~ClassicEditor} cannot use an existing DOM element as
			* {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`} because the classic
			* editor replaces the source element with its own UI rather than editing inline within it. The passed
			* element is ignored along with its content, so any markup inside it will not be used as the editor's
			* initial data. Use {@link module:core/editor/editorconfig~EditorConfig#attachTo `config.attachTo`}
			* to specify the DOM element the editor should replace, or pass the initial data via
			* {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}.
			*
			* A tag name string (e.g. `'h1'`) or a
			* {@link module:core/editor/editorconfig~ViewRootElementDefinition view root element definition} are still
			* accepted - they describe the editable root element the classic editor creates inside its UI box.
			*
			* @error editor-create-root-element-not-supported
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("editor-create-root-element-not-supported");
            rootConfig.element = void 0;
        }
        if (rootConfig.initialData === void 0) {
            if (legacyInitialData[rootName] === void 0) {
                const rootConfigElement = $7ca4ca5784e50ca9$var$isElement$1(rootConfig.element) ? rootConfig.element : void 0;
                rootConfig.initialData = $7ca4ca5784e50ca9$var$getInitialData(sourceElementOrDataForRoot || rootConfigElement || separateAttachTo && config.get("attachTo") || "");
            } else if (sourceElementOrDataForRoot && !$7ca4ca5784e50ca9$var$isElement$1(sourceElementOrDataForRoot)) /**
			* The initial data is specified both as the first argument of the editor `create()` method
			* (e.g. {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`} or
			* {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`})
			* and in the deprecated {@link module:core/editor/editorconfig~EditorConfig#initialData `config.initialData`}.
			*
			* Passing initial data as the first argument is deprecated. Remove it and use
			* {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}
			* (or `config.roots.<rootName>.initialData` for the multi-root editor) instead.
			*
			* @error editor-create-initial-data-overspecified
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-initial-data-overspecified", null);
            else rootConfig.initialData = legacyInitialData[rootName];
        } else if (sourceElementOrDataForRoot && !$7ca4ca5784e50ca9$var$isElement$1(sourceElementOrDataForRoot)) /**
		* The initial data is specified both as the first argument of the editor `create()` method
		* (e.g. {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`} or
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`})
		* and in {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}
		* (or `config.roots.<rootName>.initialData` for the multi-root editor).
		*
		* Passing initial data as the first argument is deprecated. Remove it and use
		* {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}
		* (or `config.roots.<rootName>.initialData` for the multi-root editor) instead.
		*
		* @error editor-create-root-initial-data-overspecified
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-root-initial-data-overspecified", null);
        else if (legacyInitialData[rootName] !== void 0) /**
		* The initial data is specified both in
		* {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}
		* (or `config.roots.<rootName>.initialData` for the multi-root editor) and in the deprecated
		* {@link module:core/editor/editorconfig~EditorConfig#initialData `config.initialData`}.
		*
		* The `config.initialData` option is deprecated. Remove it and use
		* {@link module:core/editor/editorconfig~RootConfig#initialData `config.root.initialData`}
		* (or `config.roots.<rootName>.initialData` for the multi-root editor) instead.
		*
		* @error editor-create-legacy-initial-data-overspecified
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-legacy-initial-data-overspecified", null);
        rootConfig.placeholder ??= $7ca4ca5784e50ca9$var$getLegacyPlainConfigValue(config, "placeholder", rootName);
        rootConfig.label ??= $7ca4ca5784e50ca9$var$getLegacyPlainConfigValue(config, "label", rootName);
        rootConfig.modelElement ||= "$root";
        rootConfig.element = $7ca4ca5784e50ca9$export$f646a7cd436ca16e(rootConfig.element);
        rootsConfig[rootName] = rootConfig;
    }
    if (separateAttachTo && $7ca4ca5784e50ca9$var$isElement$1(sourceElementsOrData)) {
        if (config.get("attachTo")) /**
		* The element to attach the editor to is specified both as the first argument of
		* {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`}
		* and in {@link module:core/editor/editorconfig~EditorConfig#attachTo `config.attachTo`}.
		*
		* Passing the element as the first argument is deprecated. Remove it and use
		* {@link module:core/editor/editorconfig~EditorConfig#attachTo `config.attachTo`} instead.
		*
		* @error editor-create-attachto-overspecified
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-attachto-overspecified", null);
        config.set("attachTo", sourceElementsOrData);
    }
    if (!separateAttachTo && config.get("attachTo")) /**
	* The {@link module:core/editor/editorconfig~EditorConfig#attachTo `config.attachTo`} option is only
	* available for the {@link module:editor-classic/classiceditor~ClassicEditor} because it replaces the
	* given DOM element with its own UI. Other editor types (e.g. inline, balloon, decoupled) render inside
	* the root element directly, so `config.attachTo` is not applicable.
	*
	* Remove the `attachTo` option from the editor configuration and use
	* {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`}
	* (or `config.roots.<rootName>.element` for the multi-root editor) to specify the DOM element instead.
	*
	* @error editor-create-attachto-ignored
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-create-attachto-ignored", null);
    config.set("roots", rootsConfig);
}
/**
* Normalizes the parameters passed to the editor constructor when a single root is used. It supports both of the following signatures:
*
* ```ts
* new Editor( editorConfig: EditorConfig );
* new Editor( sourceElementOrData: HTMLElement | string, editorConfig: EditorConfig );
* ```
*
* @internal
*/ function $7ca4ca5784e50ca9$export$4bbd8134967c9cee(sourceElementOrDataOrConfig, editorConfig) {
    if (typeof sourceElementOrDataOrConfig === "string" || $7ca4ca5784e50ca9$var$isElement$1(sourceElementOrDataOrConfig) || editorConfig && Object.keys(editorConfig).length) return {
        sourceElementOrData: sourceElementOrDataOrConfig,
        editorConfig: editorConfig
    };
    else return {
        sourceElementOrData: "",
        editorConfig: sourceElementOrDataOrConfig
    };
}
/**
* Normalizes the parameters passed to the editor constructor when a multi root is used. It supports both of the following signatures:
*
* ```ts
* new Editor( editorConfig: EditorConfig );
* new Editor( sourceElementsOrData: Record<string, string> | Record<string, HTMLElement>, editorConfig: EditorConfig );
* ```
*
* @internal
*/ function $7ca4ca5784e50ca9$export$61c65c2e6b0dda5e(sourceElementOrDataOrConfig, editorConfig) {
    if (editorConfig && Object.keys(editorConfig).length || Object.keys(sourceElementOrDataOrConfig).length == 0 || Object.values(sourceElementOrDataOrConfig).every((value)=>typeof value === "string" || $7ca4ca5784e50ca9$var$isElement$1(value))) return {
        sourceElementsOrData: sourceElementOrDataOrConfig,
        editorConfig: editorConfig
    };
    else return {
        sourceElementsOrData: {},
        editorConfig: sourceElementOrDataOrConfig
    };
}
/**
* Type guard to check if the provided value is a plain object containing source elements or data.
*/ function $7ca4ca5784e50ca9$var$isSourceElementsOrDataRecord(sourceElementsOrData) {
    return !!sourceElementsOrData && typeof sourceElementsOrData == "object" && !Array.isArray(sourceElementsOrData) && !$7ca4ca5784e50ca9$var$isElement$1(sourceElementsOrData);
}
/**
* Retrieve data from source element or return the string data as is.
*/ function $7ca4ca5784e50ca9$var$getInitialData(sourceElementOrData) {
    return $7ca4ca5784e50ca9$var$isElement$1(sourceElementOrData) ? (0, $c7bc2cb7e2db0227$export$ff7873b3940f78e3)(sourceElementOrData) : sourceElementOrData;
}
/**
* Retrieve legacy configuration value for `initialData` from the config.
* Normalize single-root config so returned value is always an object with root names as keys.
*/ function $7ca4ca5784e50ca9$var$getLegacyInitialData(config, sourceElementIsObject, defaultRootName) {
    return sourceElementIsObject || !defaultRootName ? config.get("initialData") || Object.create(null) : {
        [defaultRootName]: config.get("initialData")
    };
}
/**
* Retrieve legacy configuration value for `placeholder` or `label` from the config for a specific root.
*/ function $7ca4ca5784e50ca9$var$getLegacyPlainConfigValue(config, key, rootName) {
    const legacyValue = config.get(key);
    if (legacyValue) return typeof legacyValue == "string" ? legacyValue : legacyValue[rootName];
}
/**
* Normalizes the value passed in {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`} into a
* canonical form (`HTMLElement` or {@link module:core/editor/editorconfig~ViewRootElementDefinition}) that the UI layer
* can consume directly.
*
* Accepts:
*
* * an existing `HTMLElement` - returned as is, so the editor wraps it in place,
* * a tag name string (e.g. `'h1'`) - turned into `{ name: 'h1' }`,
* * a {@link module:core/editor/editorconfig~ViewRootElementDefinition} object - reshaped so `classes` becomes an
* array and `attributes.class` is lifted into it.
*
* The `class` attribute may be passed either as the dedicated `classes` field (string or array of strings) or as a
* `class` key inside `attributes`. They are concatenated. The `style` attribute may be passed either as the `styles`
* object or as a `style` string inside `attributes`. When both are provided, the object form takes precedence and a
* warning is logged.
*
* The `<textarea>` tag name is rejected as it cannot host a rich-text editable.
*
* Already used internally by {@link ~normalizeRootsConfig `normalizeRootsConfig()`} for `config.root.element` /
* `config.roots.*.element`. Exported for callers that bypass the regular config-normalization pass, e.g.
* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#addRoot `MultiRootEditor.addRoot()`}
* and {@link module:editor-multi-root/multirooteditor~MultiRootEditor#createEditable `MultiRootEditor.createEditable()`}.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$f646a7cd436ca16e(spec) {
    if (spec == null) return;
    if ($7ca4ca5784e50ca9$var$isElement$1(spec)) {
        $7ca4ca5784e50ca9$var$assertAllowedTagName(spec.tagName);
        return spec;
    }
    if (typeof spec === "string") {
        $7ca4ca5784e50ca9$var$assertAllowedTagName(spec);
        return {
            name: spec
        };
    }
    const { name: name, classes: classes, styles: styles, attributes: attributes } = spec;
    if (name !== void 0) $7ca4ca5784e50ca9$var$assertAllowedTagName(name);
    const { class: attrClass, style: attrStyle, ...restAttributes } = attributes || {};
    const hadAttrClass = !!attributes && "class" in attributes;
    const hasStyles = !!styles && Object.keys(styles).length > 0;
    const stylesOverrode = hasStyles && !!attrStyle;
    if (stylesOverrode) /**
	* Both the {@link module:core/editor/editorconfig~ViewRootElementDefinition#styles `styles`} object
	* and the {@link module:core/editor/editorconfig~ViewRootElementDefinition#attributes `attributes.style`}
	* string were provided in {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`}.
	* Provide one or the other - the object form takes precedence.
	*
	* @error editor-root-element-styles-overspecified
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("editor-root-element-styles-overspecified");
    const normalizedClasses = [
        ...$7ca4ca5784e50ca9$var$tokenizeClasses(classes),
        ...$7ca4ca5784e50ca9$var$tokenizeClasses(attrClass)
    ];
    const normalizedAttributes = {
        ...restAttributes
    };
    if (hadAttrClass) normalizedAttributes.class = "";
    if (stylesOverrode) normalizedAttributes.style = "";
    else if (attrStyle) normalizedAttributes.style = attrStyle;
    return {
        ...name !== void 0 && {
            name: name
        },
        ...normalizedClasses.length && {
            classes: normalizedClasses
        },
        ...hasStyles && {
            styles: styles
        },
        ...Object.keys(normalizedAttributes).length && {
            attributes: normalizedAttributes
        }
    };
}
/**
* Splits a class value (string, array of strings, or `undefined`) into individual class tokens.
* Whitespace-separated tokens within a single string are split into separate array entries and empty entries are dropped.
*/ function $7ca4ca5784e50ca9$var$tokenizeClasses(value) {
    if (!value) return [];
    return (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(value).flatMap((token)=>token.split(/\s+/)).filter(Boolean);
}
/**
* Throws when the given value cannot be used as an editable root tag name.
*
* Rejects values that are not a valid HTML tag name (non-strings, empty strings, names with whitespace,
* angle brackets, slashes, or other invalid characters) with `editor-wrong-element-name`.
*
* Also rejects the `<textarea>` and `<input>` tags with `editor-wrong-element` - they are form fields
* and cannot contain other HTML elements, so the editor cannot render rich-text content inside them.
*
* To fix the error, use a tag that can contain other elements - for example `'div'`, `'section'`, `'article'`,
* or a heading like `'h1'`. You can also omit the `name` field to use the default `'div'`.
*/ function $7ca4ca5784e50ca9$var$assertAllowedTagName(name) {
    if (typeof name !== "string" || !/^[A-Za-z][A-Za-z0-9_-]*$/.test(name)) /**
	* The value supplied as the editable root tag name in
	* {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`} or
	* `config.roots.<rootName>.element` is not a valid HTML tag name.
	*
	* Valid HTML tag names start with a letter and contain only letters, digits, hyphens, or underscores
	* (e.g. `'div'`, `'h1'`, `'my-element'`; uppercase variants such as `'DIV'` and `'H1'` are also accepted).
	* Whitespace, angle brackets, slashes, empty strings, and non-string values are not allowed.
	*
	* @error editor-wrong-element-name
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-wrong-element-name", null, {
        name: name
    });
    if ([
        "textarea",
        "input"
    ].includes(name.toLowerCase())) /**
	* The DOM tag name specified in {@link module:core/editor/editorconfig~RootConfig#element `config.root.element`}
	* cannot be used as an editor's editable root. The `<textarea>` and `<input>` elements are form fields and
	* cannot contain other HTML elements, so the editor cannot render rich-text content inside them.
	*
	* To fix the error, use a tag that can contain other elements - for example `'div'`, `'section'`, `'article'`,
	* or a heading like `'h1'`. You can also omit the `name` field to use the default `'div'`.
	*
	* @error editor-wrong-element
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-wrong-element", null);
}
/**
* An alias for `isElement` from `es-toolkit/compat` with additional type guard.
*/ function $7ca4ca5784e50ca9$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/editor/utils/verifyrootelements
*/ /**
* Verifies that all model root elements are registered in the schema as limit elements.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$d1de9dbb66389037(editor) {
    const schema = editor.model.schema;
    const document = editor.model.document;
    for (const root of document.roots){
        if (root === document.graveyard || !root.isAttached()) continue;
        if (!schema.isLimit(root)) /**
		* The model root element must be a {@link module:engine/model/schema~ModelSchemaItemDefinition#isLimit limit element}.
		* The element name specified in
		* {@link module:core/editor/editorconfig~RootConfig#modelElement `config.root.modelElement`}
		* (or `config.roots.<rootName>.modelElement`) must be registered in the schema
		* with `isLimit` set to `true`.
		*
		* @error editor-root-element-is-not-limit
		* @param rootName The name of the root that uses a non-limit element.
		* @param elementName The name of the model element used for the root.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-root-element-is-not-limit", null, {
            rootName: root.rootName,
            elementName: root.name
        });
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns whether the model root with the given name accepts `$block` children according to the editor's schema.
*
* Call this once the plugin initialization phase is finished — typically during UI init or right after creating
* a new editable — so the schema reflects any plugin-registered root types or additional content rules.
*
* @internal
*/ function $7ca4ca5784e50ca9$export$d4e62b677f4a6c36(editor, rootName) {
    const root = editor.model.document.getRoot(rootName);
    return editor.model.schema.checkChild(root, "$block");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module core/pendingactions
*/ /**
* The list of pending editor actions.
*
* This plugin should be used to synchronise plugins that execute long-lasting actions
* (e.g. file upload) with the editor integration. It gives the developer who integrates the editor
* an easy way to check if there are any actions pending whenever such information is needed.
* All plugins that register a pending action also provide a message about the action that is ongoing
* which can be displayed to the user. This lets them decide if they want to interrupt the action or wait.
*
* Adding and updating a pending action:
*
* ```ts
* const pendingActions = editor.plugins.get( 'PendingActions' );
* const action = pendingActions.add( 'Upload in progress: 0%.' );
*
* // You can update the message:
* action.message = 'Upload in progress: 10%.';
* ```
*
* Removing a pending action:
*
* ```ts
* const pendingActions = editor.plugins.get( 'PendingActions' );
* const action = pendingActions.add( 'Unsaved changes.' );
*
* pendingActions.remove( action );
* ```
*
* Getting pending actions:
*
* ```ts
* const pendingActions = editor.plugins.get( 'PendingActions' );
*
* const action1 = pendingActions.add( 'Action 1' );
* const action2 = pendingActions.add( 'Action 2' );
*
* pendingActions.first; // Returns action1
* Array.from( pendingActions ); // Returns [ action1, action2 ]
* ```
*
* This plugin is used by features like {@link module:upload/filerepository~FileRepository} to register their ongoing actions
* and by features like {@link module:autosave/autosave~Autosave} to detect whether there are any ongoing actions.
* Read more about saving the data in the
* {@glink getting-started/setup/getting-and-setting-data Saving and getting data} guide.
*/ var $7ca4ca5784e50ca9$export$55d9b916408ffdd5 = class extends $7ca4ca5784e50ca9$export$a3df350528b28529 {
    /**
	* A list of pending actions.
	*/ _actions;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PendingActions";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.set("hasAny", false);
        this._actions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)({
            idProperty: "_id"
        });
        this._actions.delegate("add", "remove").to(this);
    }
    /**
	* Adds an action to the list of pending actions.
	*
	* This method returns an action object with an observable message property.
	* The action object can be later used in the {@link #remove} method. It also allows you to change the message.
	*
	* @param message The action message.
	* @returns An observable object that represents a pending action.
	*/ add(message) {
        if (typeof message !== "string") /**
		* The message must be a string.
		*
		* @error pendingactions-add-invalid-message
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("pendingactions-add-invalid-message", this);
        const action = new ((0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)())();
        action.set("message", message);
        this._actions.add(action);
        this.hasAny = true;
        return action;
    }
    /**
	* Removes an action from the list of pending actions.
	*
	* @param action An action object.
	*/ remove(action) {
        this._actions.remove(action);
        this.hasAny = !!this._actions.length;
    }
    /**
	* Returns the first action from the list or null if the list is empty
	*
	* @returns The pending action object.
	*/ get first() {
        return this._actions.get(0);
    }
    /**
	* Iterable interface.
	*/ [Symbol.iterator]() {
        return this._actions[Symbol.iterator]();
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 

/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module upload/filereader
*/ const $fd8e3f82b47092fc$var$FileReaderBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Wrapper over the native `FileReader`.
*/ var $fd8e3f82b47092fc$export$3c8f13373e08d457 = class extends $fd8e3f82b47092fc$var$FileReaderBase {
    total;
    /**
	* Instance of native FileReader.
	*/ _reader;
    /**
	* Holds the data of an already loaded file. The file must be first loaded
	* by using {@link module:upload/filereader~FileReader#read `read()`}.
	*/ _data;
    /**
	* Creates an instance of the FileReader.
	*/ constructor(){
        super();
        const reader = new window.FileReader();
        this._reader = reader;
        this._data = void 0;
        this.set("loaded", 0);
        reader.onprogress = (evt)=>{
            this.loaded = evt.loaded;
        };
    }
    /**
	* Returns error that occurred during file reading.
	*/ get error() {
        return this._reader.error;
    }
    /**
	* Holds the data of an already loaded file. The file must be first loaded
	* by using {@link module:upload/filereader~FileReader#read `read()`}.
	*/ get data() {
        return this._data;
    }
    /**
	* Reads the provided file.
	*
	* @param file Native File object.
	* @returns Returns a promise that will be resolved with file's content.
	* The promise will be rejected in case of an error or when the reading process is aborted.
	*/ read(file) {
        const reader = this._reader;
        this.total = file.size;
        return new Promise((resolve, reject)=>{
            reader.onload = ()=>{
                const result = reader.result;
                this._data = result;
                resolve(result);
            };
            reader.onerror = ()=>{
                reject("error");
            };
            reader.onabort = ()=>{
                reject("aborted");
            };
            this._reader.readAsDataURL(file);
        });
    }
    /**
	* Aborts file reader.
	*/ abort() {
        this._reader.abort();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module upload/filerepository
*/ const $fd8e3f82b47092fc$var$FileLoaderBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* File repository plugin. A central point for managing file upload.
*
* To use it, first you need an upload adapter. Upload adapter's job is to handle communication with the server
* (sending the file and handling server's response). You can use one of the existing plugins introducing upload adapters
* (e.g. {@link module:adapter-ckfinder/uploadadapter~CKFinderUploadAdapter}) or write your own one – see
* the {@glink framework/deep-dive/upload-adapter Custom image upload adapter deep-dive} guide.
*
* Then, you can use {@link module:upload/filerepository~FileRepository#createLoader `createLoader()`} and the returned
* {@link module:upload/filerepository~FileLoader} instance to load and upload files.
*/ var $fd8e3f82b47092fc$export$db17b98b9d8ffd51 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Collection of loaders associated with this repository.
	*/ loaders = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    /**
	* Loaders mappings used to retrieve loaders references.
	*/ _loadersMap = /* @__PURE__ */ new Map();
    /**
	* Reference to a pending action registered in a {@link module:core/pendingactions~PendingActions} plugin
	* while upload is in progress. When there is no upload then value is `null`.
	*/ _pendingAction = null;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FileRepository";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        this.loaders.on("change", ()=>this._updatePendingAction());
        this.set("uploaded", 0);
        this.set("uploadTotal", null);
        this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (uploaded, total)=>{
            return total ? uploaded / total * 100 : 0;
        });
    }
    /**
	* Returns the loader associated with specified file or promise.
	*
	* To get loader by id use `fileRepository.loaders.get( id )`.
	*
	* @param fileOrPromise Native file or promise handle.
	*/ getLoader(fileOrPromise) {
        return this._loadersMap.get(fileOrPromise) || null;
    }
    /**
	* Creates a loader instance for the given file.
	*
	* Requires {@link #createUploadAdapter} factory to be defined.
	*
	* @param fileOrPromise Native File object or native Promise object which resolves to a File.
	*/ createLoader(fileOrPromise) {
        if (!this.createUploadAdapter) {
            /**
			* You need to enable an upload adapter in order to be able to upload files.
			*
			* This warning shows up when {@link module:upload/filerepository~FileRepository} is being used
			* without {@link module:upload/filerepository~FileRepository#createUploadAdapter defining an upload adapter}.
			*
			* **If you see this warning when using one of the now deprecated CKEditor 5 builds**
			* it means that you did not configure any of the upload adapters available by default in those builds.
			*
			* Predefined builds are a deprecated solution and we strongly advise
			* {@glink updating/nim-migration/migration-to-new-installation-methods migrating to new installation methods}.
			*
			* See the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn which upload
			* adapters are available in the builds and how to configure them.
			*
			* Otherwise, if you see this warning, there is a chance that you enabled
			* a feature like {@link module:image/imageupload~ImageUpload},
			* or {@link module:image/imageupload/imageuploadui~ImageUploadUI} but you did not enable any upload adapter.
			* You can choose one of the existing upload adapters listed in the
			* {@glink features/images/image-upload/image-upload "Image upload overview"}.
			*
			* You can also implement your {@glink framework/deep-dive/upload-adapter own image upload adapter}.
			*
			* @error filerepository-no-upload-adapter
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("filerepository-no-upload-adapter");
            return null;
        }
        const loader = new $fd8e3f82b47092fc$export$98435a25b5cf7b2b(Promise.resolve(fileOrPromise), this.createUploadAdapter);
        this.loaders.add(loader);
        this._loadersMap.set(fileOrPromise, loader);
        if (fileOrPromise instanceof Promise) loader.file.then((file)=>{
            this._loadersMap.set(file, loader);
        }).catch(()=>{});
        loader.on("change:uploaded", ()=>{
            let aggregatedUploaded = 0;
            for (const loader of this.loaders)aggregatedUploaded += loader.uploaded;
            this.uploaded = aggregatedUploaded;
        });
        loader.on("change:uploadTotal", ()=>{
            let aggregatedTotal = 0;
            for (const loader of this.loaders)if (loader.uploadTotal) aggregatedTotal += loader.uploadTotal;
            this.uploadTotal = aggregatedTotal;
        });
        return loader;
    }
    /**
	* Destroys the given loader.
	*
	* @param fileOrPromiseOrLoader File or Promise associated with that loader or loader itself.
	*/ destroyLoader(fileOrPromiseOrLoader) {
        const loader = fileOrPromiseOrLoader instanceof $fd8e3f82b47092fc$export$98435a25b5cf7b2b ? fileOrPromiseOrLoader : this.getLoader(fileOrPromiseOrLoader);
        loader._destroy();
        this.loaders.remove(loader);
        this._loadersMap.forEach((value, key)=>{
            if (value === loader) this._loadersMap.delete(key);
        });
    }
    /**
	* Registers or deregisters pending action bound with upload progress.
	*/ _updatePendingAction() {
        const pendingActions = this.editor.plugins.get((0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5));
        if (this.loaders.length) {
            if (!this._pendingAction) {
                const t = this.editor.t;
                const getMessage = (value)=>`${t("Upload in progress")} ${parseInt(value)}%.`;
                this._pendingAction = pendingActions.add(getMessage(this.uploadedPercent));
                this._pendingAction.bind("message").to(this, "uploadedPercent", getMessage);
            }
        } else {
            pendingActions.remove(this._pendingAction);
            this._pendingAction = null;
        }
    }
};
/**
* File loader class.
*
* It is used to control the process of reading the file and uploading it using the specified upload adapter.
*/ var $fd8e3f82b47092fc$export$98435a25b5cf7b2b = class extends $fd8e3f82b47092fc$var$FileLoaderBase {
    /**
	* Unique id of FileLoader instance.
	*
	* @readonly
	*/ id;
    /**
	* Additional wrapper over the initial file promise passed to this loader.
	*/ _filePromiseWrapper;
    /**
	* Adapter instance associated with this file loader.
	*/ _adapter;
    /**
	* FileReader used by FileLoader.
	*/ _reader;
    /**
	* Creates a new instance of `FileLoader`.
	*
	* @param filePromise A promise which resolves to a file instance.
	* @param uploadAdapterCreator The function which returns {@link module:upload/filerepository~UploadAdapter} instance.
	*/ constructor(filePromise, uploadAdapterCreator){
        super();
        this.id = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
        this._filePromiseWrapper = this._createFilePromiseWrapper(filePromise);
        this._adapter = uploadAdapterCreator(this);
        this._reader = new $fd8e3f82b47092fc$export$3c8f13373e08d457();
        this.set("status", "idle");
        this.set("uploaded", 0);
        this.set("uploadTotal", null);
        this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (uploaded, total)=>{
            return total ? uploaded / total * 100 : 0;
        });
        this.set("uploadResponse", null);
    }
    /**
	* A `Promise` which resolves to a `File` instance associated with this file loader.
	*/ get file() {
        if (!this._filePromiseWrapper) return Promise.resolve(null);
        else return this._filePromiseWrapper.promise.then((file)=>this._filePromiseWrapper ? file : null);
    }
    /**
	* Returns the file data. To read its data, you need for first load the file
	* by using the {@link module:upload/filerepository~FileLoader#read `read()`} method.
	*/ get data() {
        return this._reader.data;
    }
    /**
	* Reads file using {@link module:upload/filereader~FileReader}.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-read-wrong-status` when status
	* is different than `idle`.
	*
	* Example usage:
	*
	* ```ts
	* fileLoader.read()
	* 	.then( data => { ... } )
	* 	.catch( err => {
	* 		if ( err === 'aborted' ) {
	* 			console.log( 'Reading aborted.' );
	* 		} else {
	* 			console.log( 'Reading error.', err );
	* 		}
	* 	} );
	* ```
	*
	* @returns Returns promise that will be resolved with read data. Promise will be rejected if error
	* occurs or if read process is aborted.
	*/ read() {
        if (this.status != "idle") /**
		* You cannot call read if the status is different than idle.
		*
		* @error filerepository-read-wrong-status
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("filerepository-read-wrong-status", this);
        this.status = "reading";
        return this.file.then((file)=>this._reader.read(file)).then((data)=>{
            if (this.status !== "reading") throw this.status;
            this.status = "idle";
            return data;
        }).catch((err)=>{
            if (err === "aborted") {
                this.status = "aborted";
                throw "aborted";
            }
            this.status = "error";
            throw this._reader.error ? this._reader.error : err;
        });
    }
    /**
	* Reads file using the provided {@link module:upload/filerepository~UploadAdapter}.
	*
	* Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-upload-wrong-status` when status
	* is different than `idle`.
	* Example usage:
	*
	* ```ts
	* fileLoader.upload()
	* 	.then( data => { ... } )
	* 	.catch( e => {
	* 		if ( e === 'aborted' ) {
	* 			console.log( 'Uploading aborted.' );
	* 		} else {
	* 			console.log( 'Uploading error.', e );
	* 		}
	* 	} );
	* ```
	*
	* @returns Returns promise that will be resolved with response data. Promise will be rejected if error
	* occurs or if read process is aborted.
	*/ upload() {
        if (this.status != "idle") /**
		* You cannot call upload if the status is different than idle.
		*
		* @error filerepository-upload-wrong-status
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("filerepository-upload-wrong-status", this);
        this.status = "uploading";
        return this.file.then(()=>this._adapter.upload()).then((data)=>{
            this.uploadResponse = data;
            this.status = "idle";
            return data;
        }).catch((err)=>{
            if (this.status === "aborted") throw "aborted";
            this.status = "error";
            throw err;
        });
    }
    /**
	* Aborts loading process.
	*/ abort() {
        const status = this.status;
        this.status = "aborted";
        if (!this._filePromiseWrapper.isFulfilled) {
            this._filePromiseWrapper.promise.catch(()=>{});
            this._filePromiseWrapper.rejecter("aborted");
        } else if (status == "reading") this._reader.abort();
        else if (status == "uploading" && this._adapter.abort) this._adapter.abort();
        this._destroy();
    }
    /**
	* Performs cleanup.
	*
	* @internal
	*/ _destroy() {
        this._filePromiseWrapper = void 0;
        this._reader = void 0;
        this._adapter = void 0;
        this.uploadResponse = void 0;
    }
    /**
	* Wraps a given file promise into another promise giving additional
	* control (resolving, rejecting, checking if fulfilled) over it.
	*
	* @param filePromise The initial file promise to be wrapped.
	*/ _createFilePromiseWrapper(filePromise) {
        const wrapper = {};
        wrapper.promise = new Promise((resolve, reject)=>{
            wrapper.rejecter = reject;
            wrapper.isFulfilled = false;
            filePromise.then((file)=>{
                wrapper.isFulfilled = true;
                resolve(file);
            }).catch((err)=>{
                wrapper.isFulfilled = true;
                reject(err);
            });
        });
        return wrapper;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module upload/adapters/base64uploadadapter
*/ /**
* A plugin that converts images inserted into the editor into [Base64 strings](https://en.wikipedia.org/wiki/Base64)
* in the {@glink getting-started/setup/getting-and-setting-data editor output}.
*
* This kind of image upload does not require server processing – images are stored with the rest of the text and
* displayed by the web browser without additional requests.
*
* Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn about
* other ways to upload images into CKEditor 5.
*/ var $fd8e3f82b47092fc$export$403e55c272751576 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $fd8e3f82b47092fc$export$db17b98b9d8ffd51
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Base64UploadAdapter";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "B64A";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.plugins.get($fd8e3f82b47092fc$export$db17b98b9d8ffd51).createUploadAdapter = (loader)=>new $fd8e3f82b47092fc$var$Adapter$1(loader);
    }
};
/**
* The upload adapter that converts images inserted into the editor into Base64 strings.
*/ var $fd8e3f82b47092fc$var$Adapter$1 = class {
    /**
	* `FileLoader` instance to use during the upload.
	*/ loader;
    reader;
    /**
	* Creates a new adapter instance.
	*/ constructor(loader){
        this.loader = loader;
    }
    /**
	* Starts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#upload
	*/ upload() {
        return new Promise((resolve, reject)=>{
            const reader = this.reader = new window.FileReader();
            reader.addEventListener("load", ()=>{
                resolve({
                    default: reader.result
                });
            });
            reader.addEventListener("error", (err)=>{
                reject(err);
            });
            reader.addEventListener("abort", ()=>{
                reject();
            });
            this.loader.file.then((file)=>{
                reader.readAsDataURL(file);
            });
        });
    }
    /**
	* Aborts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#abort
	*/ abort() {
        this.reader.abort();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module upload/adapters/simpleuploadadapter
*/ /**
* The Simple upload adapter allows uploading images to an application running on your server using
* the [`XMLHttpRequest`](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest) API with a
* minimal {@link module:upload/uploadconfig~SimpleUploadConfig editor configuration}.
*
* ```ts
* ClassicEditor
* 	.create( {
* 		simpleUpload: {
* 			uploadUrl: 'http://example.com',
* 			headers: {
* 				...
* 			}
* 		}
* 	} )
* 	.then( ... )
* 	.catch( ... );
* ```
*
* See the {@glink features/images/image-upload/simple-upload-adapter "Simple upload adapter"} guide to learn how to
* learn more about the feature (configuration, server–side requirements, etc.).
*
* Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn about
* other ways to upload images into CKEditor 5.
*/ var $fd8e3f82b47092fc$export$619706cce33950ba = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $fd8e3f82b47092fc$export$db17b98b9d8ffd51
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SimpleUploadAdapter";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "SUA";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const options = this.editor.config.get("simpleUpload");
        if (!options) return;
        if (!options.uploadUrl) {
            /**
			* The {@link module:upload/uploadconfig~SimpleUploadConfig#uploadUrl `config.simpleUpload.uploadUrl`}
			* configuration required by the {@link module:upload/adapters/simpleuploadadapter~SimpleUploadAdapter `SimpleUploadAdapter`}
			* is missing. Make sure the correct URL is specified for the image upload to work properly.
			*
			* @error simple-upload-adapter-missing-uploadurl
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("simple-upload-adapter-missing-uploadurl");
            return;
        }
        this.editor.plugins.get($fd8e3f82b47092fc$export$db17b98b9d8ffd51).createUploadAdapter = (loader)=>{
            return new $fd8e3f82b47092fc$var$Adapter(loader, options);
        };
    }
};
/**
* Upload adapter.
*/ var $fd8e3f82b47092fc$var$Adapter = class {
    /**
	* FileLoader instance to use during the upload.
	*/ loader;
    /**
	* The configuration of the adapter.
	*/ options;
    xhr;
    /**
	* Creates a new adapter instance.
	*/ constructor(loader, options){
        this.loader = loader;
        this.options = options;
    }
    /**
	* Starts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#upload
	*/ upload() {
        return this.loader.file.then((file)=>new Promise((resolve, reject)=>{
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file);
            }));
    }
    /**
	* Aborts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#abort
	*/ abort() {
        if (this.xhr) this.xhr.abort();
    }
    /**
	* Initializes the `XMLHttpRequest` object using the URL specified as
	* {@link module:upload/uploadconfig~SimpleUploadConfig#uploadUrl `simpleUpload.uploadUrl`} in the editor's
	* configuration.
	*/ _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
        xhr.open("POST", this.options.uploadUrl, true);
        xhr.responseType = "json";
    }
    /**
	* Initializes XMLHttpRequest listeners
	*
	* @param resolve Callback function to be called when the request is successful.
	* @param reject Callback function to be called when the request cannot be completed.
	* @param file Native File object.
	*/ _initListeners(resolve, reject, file) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${file.name}.`;
        xhr.addEventListener("error", ()=>reject(genericErrorText));
        xhr.addEventListener("abort", ()=>reject());
        xhr.addEventListener("load", ()=>{
            const response = xhr.response;
            if (!response || response.error) return reject(response && response.error && response.error.message ? response.error.message : genericErrorText);
            const urls = response.url ? {
                default: response.url
            } : response.urls;
            resolve({
                ...response,
                urls: urls
            });
        });
        /* v8 ignore else -- @preserve */ if (xhr.upload) xhr.upload.addEventListener("progress", (evt)=>{
            /* v8 ignore else -- @preserve */ if (evt.lengthComputable) {
                loader.uploadTotal = evt.total;
                loader.uploaded = evt.loaded;
            }
        });
    }
    /**
	* Prepares the data and sends the request.
	*
	* @param file File instance to be uploaded.
	*/ _sendRequest(file) {
        let headers = this.options.headers || {};
        if (typeof headers === "function") headers = headers(file);
        const withCredentials = this.options.withCredentials || false;
        for (const headerName of Object.keys(headers))this.xhr.setRequestHeader(headerName, headers[headerName]);
        this.xhr.withCredentials = withCredentials;
        const data = new FormData();
        data.append("upload", file);
        this.xhr.send(data);
    }
};


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module adapter-ckfinder/utils
*/ const $c1535c9df13f8c33$var$TOKEN_COOKIE_NAME = "ckCsrfToken";
const $c1535c9df13f8c33$var$TOKEN_LENGTH = 40;
const $c1535c9df13f8c33$var$tokenCharset = "abcdefghijklmnopqrstuvwxyz0123456789";
/**
* Returns the CSRF token value. The value is a hash stored in `document.cookie`
* under the `ckCsrfToken` key. The CSRF token can be used to secure the communication
* between the web browser and the CKFinder server.
*
* @internal
*/ function $c1535c9df13f8c33$export$d3886ac6e468cf77() {
    let token = $c1535c9df13f8c33$export$bdf4000d0cb95a84($c1535c9df13f8c33$var$TOKEN_COOKIE_NAME);
    if (!token || token.length != $c1535c9df13f8c33$var$TOKEN_LENGTH) {
        token = $c1535c9df13f8c33$var$generateToken($c1535c9df13f8c33$var$TOKEN_LENGTH);
        $c1535c9df13f8c33$export$618ae9a7649ae98c($c1535c9df13f8c33$var$TOKEN_COOKIE_NAME, token);
    }
    return token;
}
/**
* Returns the value of the cookie with a given name or `null` if the cookie is not found.
*
* @internal
*/ function $c1535c9df13f8c33$export$bdf4000d0cb95a84(name) {
    name = name.toLowerCase();
    const parts = document.cookie.split(";");
    for (const part of parts){
        const pair = part.split("=");
        if (decodeURIComponent(pair[0].trim().toLowerCase()) === name) return decodeURIComponent(pair[1]);
    }
    return null;
}
/**
* Sets the value of the cookie with a given name.
*
* @internal
*/ function $c1535c9df13f8c33$export$618ae9a7649ae98c(name, value) {
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";path=/";
}
/**
* Generates the CSRF token with the given length.
*/ function $c1535c9df13f8c33$var$generateToken(length) {
    let result = "";
    const randValues = new Uint8Array(length);
    window.crypto.getRandomValues(randValues);
    for(let j = 0; j < randValues.length; j++){
        const character = $c1535c9df13f8c33$var$tokenCharset.charAt(randValues[j] % 36);
        result += Math.random() > .5 ? character.toUpperCase() : character;
    }
    return result;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module adapter-ckfinder/uploadadapter
*/ /**
* A plugin that enables file uploads in CKEditor 5 using the CKFinder server–side connector.
*
* See the {@glink features/file-management/ckfinder "CKFinder file manager integration"} guide to learn how to configure
* and use this feature as well as find out more about the full integration with the file manager
* provided by the {@link module:ckfinder/ckfinder~CKFinder} plugin.
*
* Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} guide to learn
* about other ways to upload images into CKEditor 5.
*/ var $c1535c9df13f8c33$export$83349e247298922 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKFinderUploadAdapter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const url = this.editor.config.get("ckfinder.uploadUrl");
        if (!url) return;
        this.editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51)).createUploadAdapter = (loader)=>new $c1535c9df13f8c33$var$UploadAdapter(loader, url, this.editor.t);
    }
};
/**
* Upload adapter for CKFinder.
*/ var $c1535c9df13f8c33$var$UploadAdapter = class {
    /**
	* FileLoader instance to use during the upload.
	*/ loader;
    /**
	* Upload URL.
	*/ url;
    /**
	* Locale translation method.
	*/ t;
    xhr;
    /**
	* Creates a new adapter instance.
	*/ constructor(loader, url, t){
        this.loader = loader;
        this.url = url;
        this.t = t;
    }
    /**
	* Starts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#upload
	*/ upload() {
        return this.loader.file.then((file)=>{
            return new Promise((resolve, reject)=>{
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file);
            });
        });
    }
    /**
	* Aborts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#abort
	*/ abort() {
        if (this.xhr) this.xhr.abort();
    }
    /**
	* Initializes the XMLHttpRequest object.
	*/ _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
        xhr.open("POST", this.url, true);
        xhr.responseType = "json";
    }
    /**
	* Initializes XMLHttpRequest listeners.
	*
	* @param resolve Callback function to be called when the request is successful.
	* @param reject Callback function to be called when the request cannot be completed.
	* @param file File instance to be uploaded.
	*/ _initListeners(resolve, reject, file) {
        const xhr = this.xhr;
        const loader = this.loader;
        const t = this.t;
        const genericError = t("Cannot upload file:") + ` ${file.name}.`;
        xhr.addEventListener("error", ()=>reject(genericError));
        xhr.addEventListener("abort", ()=>reject());
        xhr.addEventListener("load", ()=>{
            const response = xhr.response;
            if (!response || !response.uploaded) return reject(response && response.error && response.error.message ? response.error.message : genericError);
            resolve({
                default: response.url
            });
        });
        /* v8 ignore else -- @preserve */ if (xhr.upload) xhr.upload.addEventListener("progress", (evt)=>{
            if (evt.lengthComputable) {
                loader.uploadTotal = evt.total;
                loader.uploaded = evt.loaded;
            }
        });
    }
    /**
	* Prepares the data and sends the request.
	*
	* @param file File instance to be uploaded.
	*/ _sendRequest(file) {
        const data = new FormData();
        data.append("upload", file);
        data.append("ckCsrfToken", $c1535c9df13f8c33$export$d3886ac6e468cf77());
        this.xhr.send(data);
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 

/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
//#region src/string/escape.ts
const $27dbd09f31a3ce03$var$htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
};
/**
* Converts the characters "&", "<", ">", '"', and "'" in `str` to their corresponding HTML entities.
* For example, "<" becomes "&lt;".
*
* @param str  The string to escape.
* @returns Returns the escaped string.
*
* @example
* escape('This is a <div> element.'); // returns 'This is a &lt;div&gt; element.'
* escape('This is a "quote"'); // returns 'This is a &quot;quote&quot;'
* escape("This is a 'quote'"); // returns 'This is a &#39;quote&#39;'
* escape('This is a & symbol'); // returns 'This is a &amp; symbol'
*/ function $27dbd09f31a3ce03$export$4e7f196112fea3c5(str) {
    return str.replace(/[&<>"']/g, (match)=>$27dbd09f31a3ce03$var$htmlEscapes[match]);
}



//#region src/compat/string/escape.ts
/**
* Converts the characters "&", "<", ">", '"', and "'" in `str` to their corresponding HTML entities.
* For example, "<" becomes "&lt;".
*
* @param str  The string to escape.
* @returns Returns the escaped string.
*
* @example
* escape('This is a <div> element.'); // returns 'This is a &lt;div&gt; element.'
* escape('This is a "quote"'); // returns 'This is a &quot;quote&quot;'
* escape("This is a 'quote'"); // returns 'This is a &#39;quote&#39;'
* escape('This is a & symbol'); // returns 'This is a &amp; symbol'
*/ function $dc9a4a74e8d22318$export$4e7f196112fea3c5(string) {
    return (0, $27dbd09f31a3ce03$export$4e7f196112fea3c5)((0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(string));
}

//#region src/string/escapeRegExp.ts
/**
* Escapes the RegExp special characters "^", "$", "\\", ".", "*", "+", "?", "(", ")", "[", "]", "{", "}", and "|" in `str`.
*
* @param str The string to escape.
* @returns Returns the escaped string.
*
* @example
* import { escapeRegExp } from 'es-toolkit/string';
*
* escapeRegExp('[es-toolkit](https://es-toolkit.dev/)'); // returns '\[es-toolkit\]\(https://es-toolkit\.dev/\)'
*/ function $ebfb6bf46d041394$export$7c57da42ce8e346f(str) {
    return str.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
}



//#region src/compat/string/escapeRegExp.ts
/**
* Escapes the RegExp special characters "^", "$", "\\", ".", "*", "+", "?", "(", ")", "[", "]", "{", "}", and "|" in `str`.
*
* @param str The string to escape.
* @returns Returns the escaped string.
*
* @example
* import { escapeRegExp } from 'es-toolkit/string';
*
* escapeRegExp('[es-toolkit](https://es-toolkit.dev/)'); // returns '\[es-toolkit\]\(https://es-toolkit\.dev/\)'
*/ function $16b28203d45236dc$export$7c57da42ce8e346f(str) {
    return (0, $ebfb6bf46d041394$export$7c57da42ce8e346f)((0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(str));
}


//#region src/compat/function/throttle.ts
/**
* Creates a throttled function that only invokes the provided function at most once
* per every `throttleMs` milliseconds. Subsequent calls to the throttled function
* within the wait time will not trigger the execution of the original function.
*
* @template F - The type of function.
* @param func - The function to throttle.
* @param throttleMs - The number of milliseconds to throttle executions to.
* @param options - The options object
* @param options.signal - An optional AbortSignal to cancel the throttled function.
* @param options.leading - If `true`, the function will be invoked on the leading edge of the timeout.
* @param options.trailing - If `true`, the function will be invoked on the trailing edge of the timeout.
* @returns A new throttled function that accepts the same parameters as the original function.
*
* @example
* const throttledFunction = throttle(() => {
*   console.log('Function executed');
* }, 1000);
*
* // Will log 'Function executed' immediately
* throttledFunction();
*
* // Will not log anything as it is within the throttle time
* throttledFunction();
*
* // After 1 second
* setTimeout(() => {
*   throttledFunction(); // Will log 'Function executed'
* }, 1000);
*/ function $a6974e6fde7d8b9c$export$de363e709c412c8a(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}



/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ var $e8dc502aba5ac3f5$export$5e6a1e6ee0d54ae4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 6.628a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8.5 9.125a.3.3 0 0 0-.253-.296L5.11 8.327a.75.75 0 1 1 .388-1.449l4.04.716c.267.072.624.08.893.009l4.066-.724a.75.75 0 1 1 .388 1.45l-3.132.5a.3.3 0 0 0-.253.296v1.357a.3.3 0 0 0 .018.102l1.615 4.438a.75.75 0 0 1-1.41.513l-1.35-3.71a.3.3 0 0 0-.281-.197h-.209a.3.3 0 0 0-.282.198l-1.35 3.711a.75.75 0 0 1-1.41-.513l1.64-4.509a.3.3 0 0 0 .019-.103z\"/><path d=\"M10 18.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17m0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$bf31056a1f5bc20 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M4 1.5h12A3.5 3.5 0 0 1 19.5 5v8l-.005.192a3.5 3.5 0 0 1-2.927 3.262l-.062.008v1.813a1.5 1.5 0 0 1-2.193 1.33l-.371-.193-.38-.212a13.5 13.5 0 0 1-3.271-2.63l-.062-.07H4A3.5 3.5 0 0 1 .5 13V5A3.5 3.5 0 0 1 4 1.5M4 3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6.924a11.9 11.9 0 0 0 3.71 3.081l.372.194v-3.268L14.962 15H16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z\"/><path d=\"M9.75 5a.75.75 0 0 0-.75.75v2.5H6.5a.75.75 0 0 0 0 1.5H9v2.5a.75.75 0 0 0 1.5 0v-2.5H13a.75.75 0 0 0 0-1.5h-2.5v-2.5A.75.75 0 0 0 9.75 5\"/></svg>";
var $e8dc502aba5ac3f5$export$6aa1321d71749bbc = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M13.903 7.617a3.35 3.35 0 0 0 1.98 1.98L19 10.752l-3.117 1.153a3.35 3.35 0 0 0-1.98 1.98l-1.154 3.117-1.153-3.116a3.35 3.35 0 0 0-1.98-1.98L6.5 10.75l3.116-1.153a3.35 3.35 0 0 0 1.98-1.98L12.75 4.5zm-9.647 4.755c.15.404.469.723.872.872l1.372.507-1.372.507c-.403.15-.722.468-.872.872L3.75 16.5l-.507-1.371a1.48 1.48 0 0 0-.872-.872L1 13.75l1.37-.507a1.48 1.48 0 0 0 .873-.872L3.75 11zM6.441 2.87c.204.55.639.985 1.19 1.189L9.5 4.75l-1.87.691A2.02 2.02 0 0 0 6.44 6.63L5.75 8.5l-.692-1.87a2.01 2.01 0 0 0-1.19-1.189L2 4.751l1.869-.692a2.02 2.02 0 0 0 1.19-1.189L5.748 1z\"/></svg>";
var $e8dc502aba5ac3f5$export$a490b700a4a6b1b8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m13.749 15.5.691-1.87c.204-.55.638-.984 1.189-1.188l1.87-.692-1.87-.692A2.01 2.01 0 0 1 14.44 9.87L13.75 8l-.692 1.87c-.204.55-.638.984-1.189 1.188l-1.87.692 1.87.692c.55.204.985.638 1.189 1.188zm.5-11.5a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1 0-1.5zm-4 4a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5zm-3 4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$e11c212c6dff53a8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M.773 12.536a.75.75 0 0 1 .945.498l.018.051a9 9 0 0 0 .42.964c.317.62.799 1.397 1.473 2.072.701.7 1.38 1.191 1.88 1.505a8 8 0 0 0 .746.417l.037.016.005.003a.75.75 0 0 1-.522 1.404l-.072-.027-.01-.004-.018-.008-.058-.027a10 10 0 0 1-.905-.504 12.3 12.3 0 0 1-2.143-1.715c-.82-.82-1.388-1.744-1.748-2.451a10 10 0 0 1-.5-1.145l-.026-.075-.006-.021-.003-.007v-.003l-.001-.001L1 13.25l-.715.228a.75.75 0 0 1 .488-.942M13.314.953a.75.75 0 0 1 .913-.419l.072.028.009.004.018.007.059.028q.075.034.204.1c.172.09.413.223.701.404a12.3 12.3 0 0 1 2.143 1.715c.82.82 1.387 1.744 1.748 2.45a10 10 0 0 1 .499 1.145l.026.075.007.022.003.007v.003h.001c-.002.002-.043.015-.715.228l.715-.227a.751.751 0 0 1-1.43.455l-.004-.011-.017-.052a9 9 0 0 0-.42-.964c-.317-.619-.8-1.397-1.474-2.07a10.8 10.8 0 0 0-1.88-1.507 8 8 0 0 0-.746-.417l-.036-.015-.006-.003a.75.75 0 0 1-.39-.986M11.29 6.84a3.76 3.76 0 0 0 2.22 2.22L17 10.35l-3.49 1.292a3.76 3.76 0 0 0-2.219 2.22L10 17.35l-1.292-3.49a3.76 3.76 0 0 0-2.22-2.22L3 10.35l3.49-1.291A3.76 3.76 0 0 0 8.71 6.84L10 3.35zm6.009 8.66a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M14.8 18a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M3.798 2.001a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.499 2.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0\"/></svg>";
var $e8dc502aba5ac3f5$export$a4d6d63ef9e4b7db = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" viewBox=\"0 0 18 18\"><path fill=\"currentColor\" d=\"M.471 10.832a.675.675 0 0 1 .85.448l.017.047q.022.065.07.189c.066.165.168.402.309.678.284.557.718 1.257 1.325 1.864a9.8 9.8 0 0 0 1.692 1.356 7 7 0 0 0 .671.375l.033.014.005.003a.675.675 0 0 1-.47 1.264l-.065-.025-.008-.004-.017-.007-.052-.024-.184-.09c-.155-.08-.372-.2-.631-.364a11 11 0 0 1-1.929-1.543C1.35 14.274.84 13.443.514 12.807a9 9 0 0 1-.449-1.03l-.024-.068-.006-.02-.002-.005v-.003H.032l.643-.206-.643.205a.676.676 0 0 1 .44-.848M11.758.408a.676.676 0 0 1 .822-.377l.065.025.007.003.017.007.053.025q.066.03.184.09c.154.08.371.2.63.363.52.326 1.214.829 1.929 1.544.739.738 1.249 1.57 1.573 2.206a9 9 0 0 1 .45 1.03l.023.067.006.02.003.006v.003l-.643.205.644-.205a.676.676 0 0 1-1.287.41l-.004-.01-.015-.046-.072-.19a8 8 0 0 0-.307-.678c-.284-.557-.719-1.257-1.326-1.864a9.8 9.8 0 0 0-1.691-1.355 7 7 0 0 0-.672-.375l-.033-.015-.005-.002a.675.675 0 0 1-.351-.887M9.937 5.706a3.38 3.38 0 0 0 1.996 1.997l3.142 1.162-3.142 1.162a3.38 3.38 0 0 0-1.996 1.998l-1.162 3.14-1.162-3.14a3.38 3.38 0 0 0-1.998-1.998l-3.14-1.162 3.14-1.162a3.38 3.38 0 0 0 1.998-1.997l1.162-3.141zm5.407 7.794a.675.675 0 1 1 1.35 0 .675.675 0 0 1-1.35 0m-2.249 2.25a.675.675 0 1 1 1.35 0 .675.675 0 0 1-1.35 0M3.194 1.35a.675.675 0 1 1 1.35 0 .675.675 0 0 1-1.35 0M.944 3.601a.675.675 0 1 1 1.35 0 .675.675 0 0 1-1.35 0\"/></svg>";
var $e8dc502aba5ac3f5$export$3d369a77ff7654fe = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M11.282 2.775a4.274 4.274 0 0 1 5.466.466 4.23 4.23 0 0 1 .47 5.443.75.75 0 0 1-.113.907.75.75 0 0 1-.913.114 4.27 4.27 0 0 1-2.846.759l-2.625 2.362a1 1 0 0 1 .015.14v4.788a.75.75 0 0 1-1.5 0v-3.59l-2.678 2.41a1.26 1.26 0 0 1-1.083.298l-1.134-.226-1.062 1.058a.75.75 0 0 1-1.059-1.063l1.06-1.056-.224-1.121c-.078-.39.035-.792.3-1.085l6.14-6.752c-.09-.983.165-1.99.761-2.83a.75.75 0 0 1 .113-.906.75.75 0 0 1 .912-.116m-6.73 11.519.164.82a1 1 0 0 1 .097.097l.834.165 6.027-5.426a4.26 4.26 0 0 1-1.665-1.658zm6.779-9.39a2.73 2.73 0 0 0 .455 3.274 2.77 2.77 0 0 0 3.294.456zm4.359-.6a2.77 2.77 0 0 0-3.294-.456l3.748 3.728a2.73 2.73 0 0 0-.454-3.272\" clip-rule=\"evenodd\"/><path d=\"M4.44 1.87c.205.55.639.985 1.19 1.189l1.87.691-1.87.691c-.551.204-.985.64-1.19 1.19L3.75 7.5l-.693-1.87A2.01 2.01 0 0 0 1.87 4.442L0 3.751l1.87-.691c.55-.204.984-.64 1.188-1.19L3.75 0z\"/></svg>";
var $e8dc502aba5ac3f5$export$9f9d5ad3d44cf77f = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15.739 13.009c0-.416.44-.644.749-.422l.06.05 3.297 3.232.036.039a.53.53 0 0 1 0 .666l-.036.039-3.297 3.232c-.288.283-.747.098-.803-.292l-.006-.08v-1.468c-.343.04-.898.142-1.57.404l-.189.077c-.654.276-1.15.766-1.464 1.156l-.123.16a.48.48 0 0 1-.574.163.516.516 0 0 1-.314-.56l.064-.388c.074-.426.184-.955.335-1.474.196-.676.483-1.408.906-1.854l.113-.114c.986-.957 2.195-1.094 2.816-1.094zM.773 12.536a.75.75 0 0 1 .945.498l.018.052a9 9 0 0 0 .42.964c.316.619.8 1.396 1.473 2.07.701.702 1.38 1.193 1.88 1.507a8 8 0 0 0 .746.417l.037.015.005.003a.75.75 0 0 1-.522 1.404l-.072-.027-.01-.004-.018-.008-.058-.027a10 10 0 0 1-.905-.504 12.3 12.3 0 0 1-2.143-1.715c-.82-.82-1.388-1.744-1.748-2.45a10 10 0 0 1-.5-1.145l-.026-.076-.006-.021-.003-.007v-.003H.285a.75.75 0 0 1 .488-.943M11.29 6.84a3.76 3.76 0 0 0 2.22 2.218L17 10.35l-3.49 1.291a3.76 3.76 0 0 0-2.22 2.22L10 17.35l-1.291-3.49a3.76 3.76 0 0 0-2.22-2.22l-3.49-1.29 3.49-1.292a3.76 3.76 0 0 0 2.22-2.218l1.29-3.49zM13.314.953a.75.75 0 0 1 .913-.42l.072.028.01.004.018.008.058.027q.076.035.204.1c.172.09.413.223.702.404.576.362 1.348.92 2.142 1.715.82.82 1.388 1.744 1.748 2.451a10 10 0 0 1 .5 1.145l.026.075.006.021.003.007v.003l.001.001a.75.75 0 0 1-1.43.455l-.003-.01-.018-.052-.079-.21a9 9 0 0 0-.342-.754c-.315-.62-.798-1.397-1.472-2.071a10.8 10.8 0 0 0-1.88-1.506 8 8 0 0 0-.746-.417l-.037-.016-.005-.003a.75.75 0 0 1-.391-.985M2.05 3.75a.75.75 0 1 1-.002 1.502.75.75 0 0 1 .001-1.501M4.548 1.25a.75.75 0 1 1 0 1.501.75.75 0 0 1 0-1.5\"/></svg>";
var $e8dc502aba5ac3f5$export$94c4f3ac4378cda8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7.591 16.502c.421 0 .762.336.762.75s-.341.75-.762.75h-5.08a.757.757 0 0 1-.761-.751c0-.414.34-.749.761-.749zm3.302-8.942c0-1.009 1.135-1.576 1.952-1.056l.158.12 4.817 4.182c.576.5.572 1.386-.008 1.882L12.996 16.8c-.823.702-2.103.127-2.103-.945V14.46H2.511a.756.756 0 0 1-.761-.75c0-.414.34-.75.761-.75h8.636c.701 0 1.27.56 1.27 1.25v1.098l4.176-3.568-4.175-3.627V9.28c0 .69-.57 1.25-1.271 1.25H2.511a.756.756 0 0 1-.761-.75c0-.414.34-.75.761-.75h8.382zm6.047-5.689c.205.55.639.986 1.19 1.19l1.869.691-1.87.691c-.55.204-.984.64-1.188 1.19l-.692 1.869-.692-1.87a2.01 2.01 0 0 0-1.188-1.189l-1.87-.691 1.87-.691c.55-.204.984-.64 1.188-1.19l.691-1.869zM7.591 5.502c.421 0 .762.336.762.75s-.34.75-.762.75h-5.08a.756.756 0 0 1-.761-.75c0-.414.34-.75.761-.75z\"/></svg>";
var $e8dc502aba5ac3f5$export$689b1e0b74e42cad = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.413 12.037 10.487 19l-3.421-3.446 1.053-1.058 2.37 2.386 5.873-5.902z\"/><path fill-rule=\"evenodd\" d=\"m12.976 12.465-1.004 1.009-.737-1.995H5.378l-1.39 3.492H2.5L7.463 3H9.05zm-7.1-2.183h4.764L8.257 4.496z\" clip-rule=\"evenodd\"/><path d=\"M16.958 1.87c.203.55.634.985 1.182 1.189l1.859.691-1.86.691a2.01 2.01 0 0 0-1.181 1.19L16.27 7.5l-.689-1.87A2 2 0 0 0 14.4 4.442l-1.858-.691L14.4 3.06c.548-.204.98-.64 1.182-1.19L16.27 0z\"/></svg>";
var $e8dc502aba5ac3f5$export$1213f94a08427673 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M14.832 15.502a.75.75 0 0 1 .754.749.75.75 0 0 1-.755.749H7.28a.753.753 0 0 1-.756-.749c0-.414.339-.749.756-.749zm1.237-12.5a.946.946 0 0 1 .851 1.322c-.69 1.575-1.272 2.683-1.893 3.406-.563.655-1.17 1.005-1.884 1.126-.449 1.736-1.662 2.854-2.73 3.527a8.8 8.8 0 0 1-2.038.937q-.092.029-.146.042l-.042.012-.013.003H8.17l-.002.002a.76.76 0 0 1-.917-.546.75.75 0 0 1 .55-.908l.002-.001.023-.006.104-.03a7.3 7.3 0 0 0 1.673-.77c.952-.6 1.888-1.526 2.14-2.92a.97.97 0 0 1 .91-.792l.168-.014c.382-.05.694-.212 1.056-.633.377-.438.782-1.133 1.293-2.229-2.808.253-5.14 2.025-6.952 4.332-1.991 2.537-3.253 5.6-3.728 7.563a.757.757 0 0 1-.911.553.75.75 0 0 1-.559-.903c.519-2.144 1.867-5.409 4.007-8.134 2.136-2.72 5.164-5.024 9.042-4.939M4.44 1.87c.205.55.64.985 1.19 1.189l1.87.691-1.87.691c-.55.204-.985.64-1.19 1.19L3.75 7.5l-.692-1.87a2.01 2.01 0 0 0-1.19-1.189L0 3.75l1.869-.691c.55-.204.985-.64 1.19-1.19L3.748 0z\"/></svg>";
var $e8dc502aba5ac3f5$export$9feab77cced9381 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m16.25 0 .69 1.87c.205.55.639.984 1.19 1.188L20 3.75l-1.87.692a2.02 2.02 0 0 0-1.19 1.188l-.69 1.87-.693-1.87a2.01 2.01 0 0 0-1.188-1.188l-1.87-.692 1.87-.692c.55-.204.985-.638 1.188-1.188z\"/><path d=\"M10 1c.704 0 1.053-.003 1.474.09.445.099.635.613.426 1.019-.163.315-.523.465-.875.423C10.712 2.495 10.42 2.5 10 2.5a7.5 7.5 0 1 0 7.5 7.5c0-.26-.047-.582-.102-.89a.82.82 0 0 1 .458-.89c.456-.214 1.007.027 1.08.525.053.375.064.746.064 1.255a9 9 0 1 1-9-9\"/><path d=\"M7.05 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.2 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.2 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0\"/></svg>";
var $e8dc502aba5ac3f5$export$89389c92ebf7b715 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7.718 5.12c.285.77.893 1.378 1.663 1.663l2.618.97-2.618.968a2.82 2.82 0 0 0-1.663 1.664l-.969 2.617-.969-2.617A2.82 2.82 0 0 0 4.117 8.72l-2.618-.969 2.618-.969A2.82 2.82 0 0 0 5.78 5.12l.969-2.618zm10.609 9.086a.75.75 0 0 1 0 1.492l-.078.004h-8a.75.75 0 0 1 0-1.5h8zm-.077-4.504a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm.002-4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zM3.461 12.749c.136.367.425.657.791.793l1.247.46-1.247.46a1.34 1.34 0 0 0-.79.793l-.463 1.247-.46-1.246a1.34 1.34 0 0 0-.793-.793l-1.247-.46 1.247-.461a1.34 1.34 0 0 0 .792-.793L3 11.502z\"/></svg>";
var $e8dc502aba5ac3f5$export$cfef3fea479ee07a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m14.57 9.33-8.194 8.194H3.598V14.75l8.193-8.198 2.779 2.78Zm-.108-5.14a.73.73 0 0 1 .522.217l1.734 1.73a.736.736 0 0 1 0 1.043l-1.355 1.36-2.78-2.78 1.357-1.352a.74.74 0 0 1 .522-.218M4.05.19l.692 1.869c.204.55.638.985 1.189 1.189l1.87.691-1.87.692c-.55.204-.985.638-1.189 1.189L4.05 7.69l-.69-1.87a2.01 2.01 0 0 0-1.19-1.189L.3 3.94l1.87-.691c.55-.204.985-.638 1.189-1.189z\"/></svg>";
var $e8dc502aba5ac3f5$export$f90c14284764e46 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M19 19h-1.486l-1.289-3.5h-5.85L8.989 19H7.501l4.957-12h1.586zm-8.13-4.7h4.76l-2.38-5.8z\" clip-rule=\"evenodd\"/><path d=\"M5.648.5c.414 0 .75.337.75.751v.95h4.35a.75.75 0 0 1 0 1.5H9.486c-.337 1.817-1.254 4.38-3.062 6.917.234.25.42.434.56.563a5 5 0 0 0 .293.253h.001a.75.75 0 0 1-.857 1.231H6.42l-.003-.002-.004-.003-.01-.008-.028-.02-.092-.072a7 7 0 0 1-.317-.278 12 12 0 0 1-.472-.463c-1.345 1.606-2.094 2.28-4.376 3.584a.75.75 0 0 1-.736-1.306c2.018-.997 2.852-1.878 4.11-3.42-.546-.738-.982-1.637-1.286-2.357a19 19 0 0 1-.563-1.516l-.008-.026-.002-.007-.001-.002-.019-.076A.75.75 0 0 1 4.04 6.26l.026.072.001.004.006.02.025.078.101.297c.09.255.22.61.388 1.005.233.553.525 1.152.852 1.67C6.86 7.313 7.63 5.146 7.953 3.7H.948a.75.75 0 0 1 0-1.5h3.95v-.949A.75.75 0 0 1 5.648.5m11.293 1.37c.204.55.638.984 1.189 1.188l1.869.692-1.87.691c-.55.204-.984.638-1.188 1.189L16.25 7.5l-.692-1.87a2.01 2.01 0 0 0-1.188-1.19l-1.87-.691 1.87-.692c.55-.204.985-.638 1.188-1.189L16.25 0z\"/></svg>";
var $e8dc502aba5ac3f5$export$f886f842a0c3c87a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M.773 12.536a.75.75 0 0 1 .945.498l.018.051a9 9 0 0 0 .42.964c.317.62.799 1.397 1.473 2.072.701.7 1.38 1.191 1.88 1.505a8 8 0 0 0 .746.417l.037.016.005.003a.75.75 0 0 1-.522 1.404l-.072-.027-.01-.004-.018-.008-.058-.027a10 10 0 0 1-.905-.504 12.3 12.3 0 0 1-2.143-1.715c-.82-.82-1.388-1.744-1.748-2.451a10 10 0 0 1-.5-1.145l-.026-.075-.006-.021-.003-.007v-.003l-.001-.001L1 13.25l-.715.228a.75.75 0 0 1 .488-.942M13.314.953a.75.75 0 0 1 .913-.419l.072.028.009.004.018.007.059.028q.075.034.204.1c.172.09.413.223.701.404a12.3 12.3 0 0 1 2.143 1.715c.82.82 1.387 1.744 1.748 2.45a10 10 0 0 1 .499 1.145l.026.075.007.022.003.007v.003h.001c-.002.002-.043.015-.715.228l.715-.227a.751.751 0 0 1-1.43.455l-.004-.011-.017-.052a9 9 0 0 0-.42-.964c-.317-.619-.8-1.397-1.474-2.07a10.8 10.8 0 0 0-1.88-1.507 8 8 0 0 0-.746-.417l-.036-.015-.006-.003a.75.75 0 0 1-.39-.986M11.29 6.84a3.76 3.76 0 0 0 2.22 2.22L17 10.35l-3.49 1.292a3.76 3.76 0 0 0-2.219 2.22L10 17.35l-1.292-3.49a3.76 3.76 0 0 0-2.22-2.22L3 10.35l3.49-1.291A3.76 3.76 0 0 0 8.71 6.84L10 3.35zm6.009 8.66a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M14.8 18a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M3.798 2.001a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.499 2.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0\"/></svg>";
var $e8dc502aba5ac3f5$export$ceb3ef46036ed0a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M16.942 1.87c.203.55.637.985 1.188 1.189L20 3.75l-1.87.691a2.01 2.01 0 0 0-1.188 1.19L16.249 7.5l-.691-1.87a2.01 2.01 0 0 0-1.19-1.189L12.5 3.75l1.87-.691c.55-.204.985-.639 1.189-1.19L16.249 0zm2.03 5.43c.305 0 .58.192.671.483a7 7 0 0 1 .352 2.4 9 9 0 0 1-9.361 8.809 9 9 0 0 1-7.662-4.917L4.1 12.946A7.502 7.502 0 0 0 18.5 10c0-1.017-.1-1.266-.5-2.2-.097-.224.143-.5.387-.5z\"/><path d=\"m11.5 9.999 3.195 3.196-1.06 1.06-3.536-3.536-.1-.112V5h1.5zM10.7 1q.168 0 .336.006a.703.703 0 0 1 .664.716c0 .451-.398.795-.849.785a7 7 0 0 0-.531.007c-1.015.052-1.71.309-2.623.756a7.5 7.5 0 0 0-4.17 6.125l.965-.737a.75.75 0 0 1 .979.057l.073.083a.75.75 0 0 1-.058.978l-.083.072-2.27 1.738a.75.75 0 0 1-.972-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 1.107-1.005l.074.082.531.68a9 9 0 0 1 5.32-7.218C8.519 1.259 9.453 1 10.7 1\"/></svg>";
var $e8dc502aba5ac3f5$export$828b0812a275deff = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.75.75 0 0 1-.511.187.75.75 0 0 1-.511-.187M4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$a36e1e8e01d62636 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75m0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75\"/></svg>";
var $e8dc502aba5ac3f5$export$e9b166ff0ced1423 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75\"/></svg>";
var $e8dc502aba5ac3f5$export$df3b17223210ab85 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75\"/></svg>";
var $e8dc502aba5ac3f5$export$29541e77ab082032 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.75 11.875a.75.75 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.75.75 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.75.75 0 0 1-.508.184.75.75 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75\"/></svg>";
var $e8dc502aba5ac3f5$export$bd03fac3c90d8fee = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75m0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75m0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75m0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75\"/></svg>";
var $e8dc502aba5ac3f5$export$f53e4c3135e2e1b3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.75.75 0 0 1 .511-.187.75.75 0 0 1 .511.187M15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$403194946ee83bdf = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 .75a9.25 9.25 0 1 1 0 18.5 9.25 9.25 0 0 1 0-18.5m0 1.5a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5m0 2.022a.75.75 0 0 1 .743.649l.007.101v8.165l2.714-2.705a.75.75 0 0 1 .977-.07l.084.072a.75.75 0 0 1 .07.976l-.072.084-3.994 3.981a.75.75 0 0 1-.975.073l-.084-.073-3.99-3.98a.75.75 0 0 1 .975-1.135l.085.072 2.71 2.706V5.022a.75.75 0 0 1 .75-.75\"/></svg>";
var $e8dc502aba5ac3f5$export$3577c0003511ce2d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 19.25a9.25 9.25 0 1 0 0-18.5 9.25 9.25 0 0 0 0 18.5m0-1.5a7.75 7.75 0 1 1 0-15.5 7.75 7.75 0 0 1 0 15.5m0-2.022a.75.75 0 0 0 .743-.649l.007-.101V6.813l2.714 2.705a.75.75 0 0 0 .977.07l.084-.072a.75.75 0 0 0 .07-.976l-.072-.084-3.994-3.981a.75.75 0 0 0-.975-.073l-.084.073-3.99 3.98a.75.75 0 0 0 .975 1.135l.085-.072 2.71-2.706v8.166c0 .414.336.75.75.75\"/></svg>";
var $e8dc502aba5ac3f5$export$1d3fc6e952f4058b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.187 17H5.773q-.956 0-1.364-.415-.41-.416-.409-1.323V4.738q0-.926.419-1.332.418-.405 1.354-.406h4.68q1.035 0 1.793.124.76.124 1.36.478.512.296.906.75a3.26 3.26 0 0 1 .808 2.162q0 2.102-2.167 3.075 2.846.879 2.847 3.421a3.76 3.76 0 0 1-2.296 3.504 6 6 0 0 1-1.517.377q-.857.11-2 .11zm-.217-6.217H7v4.087h3.069q2.965 0 2.965-2.072 0-1.061-.768-1.537-.768-.478-2.296-.478M7 5.13v3.619h2.606q1.093 0 1.69-.2a1.6 1.6 0 0 0 .91-.765q.247-.4.247-.897 0-1.06-.778-1.409-.778-.348-2.375-.348z\"/></svg>";
var $e8dc502aba5ac3f5$export$ad8f165eec14886a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\"><path d=\"M2 14.436V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12.436a.5.5 0 0 1-.819.385l-3.862-3.2a.5.5 0 0 0-.638 0l-3.862 3.2A.5.5 0 0 1 2 14.436\" class=\"ck-icon__fill\"/></svg>";
var $e8dc502aba5ac3f5$export$7e626e36f15bda71 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.68 3.417a.24.24 0 0 0-.24.236v12.66l3.793-3.102a1.215 1.215 0 0 1 1.534 0l3.793 3.103V3.654a.24.24 0 0 0-.24-.237zM4 3.653C4 2.74 4.752 2 5.68 2h8.64c.928 0 1.68.74 1.68 1.653v13.164c0 1-1.185 1.547-1.967.908L10 14.426l-4.033 3.299c-.782.64-1.967.092-1.967-.908z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$3f43d461a1b0411e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4.4 2.24c-.11 0-.2.092-.2.207v11.077l3.16-2.714a.975.975 0 0 1 1.28 0l3.16 2.714V2.447a.203.203 0 0 0-.2-.207zM3 2.447C3 1.647 3.627 1 4.4 1h7.2c.773 0 1.4.648 1.4 1.447v11.518c0 .875-.988 1.354-1.64.794L8 11.873 4.64 14.76c-.652.56-1.64.081-1.64-.794z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$37bba31b62772ac = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\"><path d=\"M4.216 2.031a.503.503 0 0 0-.489.516v9.42l2.648-2.324a.94.94 0 0 1 1.25 0l2.648 2.324v-9.42a.503.503 0 0 0-.489-.516zm-1.466.516C2.75 1.693 3.406 1 4.216 1h5.568c.81 0 1.466.693 1.466 1.547v9.42c0 .873-.965 1.351-1.602.793L7 10.436 4.352 12.76c-.637.558-1.602.08-1.602-.793z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$d0737da289edbce8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.95 4a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.25a.75.75 0 0 1 1.5 0V17a2 2 0 0 1-2 2H3l-.204-.01A2 2 0 0 1 1 17V6a2 2 0 0 1 2-2z\"/><path d=\"M17.483 3c.27 0 .529.107.72.296a1.007 1.007 0 0 1 0 1.429l-7.432 7.48a1 1 0 0 1-.758.294 1.02 1.02 0 0 1-.757-.295L6.31 9.381a1.01 1.01 0 0 1-.235-1.11 1 1 0 0 1 .556-.551 1.03 1.03 0 0 1 1.117.232l2.264 2.148 6.75-6.804c.191-.19.45-.296.72-.296\"/></svg>";
var $e8dc502aba5ac3f5$export$78e56a5c94c9a22a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.95 4a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.25a.75.75 0 0 1 1.5 0V17a2 2 0 0 1-2 2H3l-.204-.01A2 2 0 0 1 1 17V6a2 2 0 0 1 2-2zm8.554-3a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m2.74 3.759a.81.81 0 0 0-1.148 0l-1.592 1.593-1.593-1.593a.812.812 0 1 0-1.148 1.15L11.355 7.5 9.763 9.092a.813.813 0 0 0 1.148 1.15l1.593-1.593 1.592 1.592a.812.812 0 1 0 1.148-1.15L13.652 7.5l1.592-1.592a.813.813 0 0 0 0-1.15\"/><path d=\"M3.95 4a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.25a.75.75 0 0 1 1.5 0V17a2 2 0 0 1-2 2H3l-.204-.01A2 2 0 0 1 1 17V6a2 2 0 0 1 2-2zm8.554-3a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m2.74 3.759a.81.81 0 0 0-1.148 0l-1.592 1.593-1.593-1.593a.812.812 0 1 0-1.148 1.15L11.355 7.5 9.763 9.092a.813.813 0 0 0 1.148 1.15l1.593-1.593 1.592 1.592a.812.812 0 1 0 1.148-1.15L13.652 7.5l1.592-1.592a.813.813 0 0 0 0-1.15Z\"/></svg>";
var $e8dc502aba5ac3f5$export$94f556c754647abd = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.95 4a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.25a.75.75 0 0 1 1.5 0V17a2 2 0 0 1-2 2H3l-.204-.01A2 2 0 0 1 1 17V6a2 2 0 0 1 2-2z\"/><path d=\"m6.923 13.22.205-.305q-.389-.198-.436-.371-.048-.18.101-.733.124-.329.147-.521a4 4 0 0 0 0-.634q-.274-.816-.248-1.102.026-.288.416-.756L13.033.56q.708-1.194 2.8.158 2.09 1.354 1.561 2.35l-5.143 9.067q-.209.541-.46.685-.255.141-1.08.183-.335.11-.646.279a2.7 2.7 0 0 0-.46.41q-.384.348-.552.349-.126 0-.46-.2l-.27.359-1.401-.98zm-.244.364 1.379.965-.344.451H5.728z\"/></svg>";
var $e8dc502aba5ac3f5$export$3ffee1eb83242296 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.5 9.303V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6 6 0 0 0-1.5-1.228M16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5z\"/><path d=\"M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10M15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1z\"/></svg>";
var $e8dc502aba5ac3f5$export$9ad93805e560c2d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.91 18.255a.747.747 0 0 1 .663.746.747.747 0 0 1-.664.746l-.075.004H8.382a.745.745 0 0 1-.74-.75c0-.414.331-.75.74-.75h3.452z\"/><path fill-rule=\"evenodd\" d=\"M10.104 3.752c.807 0 1.59.193 2.415.548l.404.185c.913.452 1.62 1.026 2.129 1.77.578.848.852 1.85.95 2.991l.014.258c.031 1.26-.537 2.059-1.096 2.722-.562.665-1.05 1.151-1.322 1.935l-.053.161c-.204.698-.397 1.704-.504 2.314a1.34 1.34 0 0 1-1.308 1.114H8.476c-.65 0-1.196-.476-1.308-1.114a31 31 0 0 0-.354-1.743l-.15-.57c-.258-.882-.776-1.387-1.375-2.097-.596-.707-1.203-1.57-1.082-2.98l.045-.422c.126-.968.4-1.827.906-2.568.58-.851 1.422-1.478 2.533-1.956l.307-.126c.713-.274 1.401-.422 2.106-.422m0 1.5c-.492 0-1.001.102-1.582.325l-.254.104c-.927.398-1.513.87-1.894 1.43-.337.492-.551 1.106-.656 1.909l-.038.356c-.07.806.224 1.272.732 1.874.506.599 1.299 1.384 1.67 2.645l.084.307c.181.688.338 1.508.435 2.048h3.007c.112-.624.304-1.619.52-2.355l.075-.232c.394-1.127 1.12-1.852 1.594-2.413.476-.565.764-1.01.74-1.727l-.008-.147c-.084-.981-.308-1.702-.693-2.266-.334-.49-.824-.912-1.563-1.277l-.332-.152c-.688-.296-1.274-.43-1.837-.43\" clip-rule=\"evenodd\"/><path d=\"M3.597 13.637a.73.73 0 0 1 1.045 0 .76.76 0 0 1 0 1.06l-1.05 1.064-.056.052a.73.73 0 0 1-.99-.052.76.76 0 0 1-.05-1.004l.05-.057zm11.761 0a.73.73 0 0 1 1.045 0l1.05 1.063.05.057c.237.294.22.73-.05 1.004a.73.73 0 0 1-.99.052l-.055-.052-1.05-1.064a.76.76 0 0 1 0-1.06M2.472 8.257c.409 0 .74.336.74.75s-.331.75-.74.75L.99 9.756l-.075-.004a.746.746 0 0 1-.664-.746c0-.388.291-.708.664-.746l.075-.004zm16.614.003a.747.747 0 0 1 .664.746.746.746 0 0 1-.664.746l-.075.004h-1.483a.745.745 0 0 1-.74-.75c0-.413.331-.75.74-.75h1.483zM3.334 2.581c.27-.274.7-.29.99-.05l.055.05 1.048 1.065a.76.76 0 0 1 0 1.061.73.73 0 0 1-1.045 0L3.334 3.642l-.05-.057a.76.76 0 0 1 .05-1.004m12.343-.051a.73.73 0 0 1 .989.051.76.76 0 0 1 .05 1.004l-.05.057-1.048 1.065a.73.73 0 0 1-1.046 0 .76.76 0 0 1 0-1.06l1.049-1.066zM10.007.251c.383 0 .698.296.736.674l.003.076.001 1.505c0 .414-.33.75-.738.75a.745.745 0 0 1-.74-.75L9.268 1l.004-.076a.745.745 0 0 1 .735-.674\"/></svg>";
var $e8dc502aba5ac3f5$export$368e6033157c630e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75m-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75m6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75m-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75\"/></svg>";
var $e8dc502aba5ac3f5$export$6102dea6073ecfc0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414z\"/></svg>";
var $e8dc502aba5ac3f5$export$ccdbc3d0432988b9 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2\"/><path fill-opacity=\".6\" d=\"M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492z\"/></svg>";
var $e8dc502aba5ac3f5$export$63227a0b63c5cc22 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.789 3 0 17h1.664l1.664-4.027h6.797l.227.548c.046-.172.112-.352.209-.545.217-.436.556-.609.898-.798L7.664 3H5.79Zm.938 1.758 2.777 6.715H3.949zM15.956 7.5c-1.584-.02-3.226.824-3.843 2.882l1.495.106c.904-2.082 4.594-2.13 4.375.534-3.245 1.024-4.838.117-6.082 2.62-.208.418-.17 1.57.54 2.397s2.014 1.149 3.409.85 2.24-1.386 2.24-1.386L18.205 17h1.493l-.059-1.72-.056-5.274C19.51 8.612 17.75 7.524 15.956 7.5m2.027 4.696s.641 2.453-1.528 3.27c-3.376 1.269-4.188-2.141-1.775-2.638 1.704-.352 1.873-.25 3.303-.632\"/></svg>";
var $e8dc502aba5ac3f5$export$41713cd023818a26 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.972 16.615a1 1 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a1 1 0 0 1-.745.292\"/></svg>";
var $e8dc502aba5ac3f5$export$59f995884fc5e26a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M16.435 5.506a.75.75 0 0 1 1.197.899l-.067.089-6.992 8a.75.75 0 0 1-1.05.078l-.079-.078-7.008-8a.75.75 0 0 1 1.049-1.066l.08.078 6.442 7.354z\"/></svg>\n";
var $e8dc502aba5ac3f5$export$c13ba04fa7e7e8e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M14.494 16.435a.75.75 0 0 1-.899 1.197l-.089-.067-8-6.992a.75.75 0 0 1-.078-1.05l.078-.079 8-7.008a.75.75 0 0 1 1.066 1.049l-.078.08-7.354 6.442z\"/></svg>\n";
var $e8dc502aba5ac3f5$export$3f284407ead563ae = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.506 16.435a.75.75 0 0 0 .899 1.197l.089-.067 8-6.992a.75.75 0 0 0 .078-1.05l-.078-.079-8-7.008a.75.75 0 0 0-1.066 1.049l.078.08 7.354 6.442z\"/></svg>\n";
var $e8dc502aba5ac3f5$export$744aedc8c31adee6 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M16.435 14.494a.75.75 0 0 0 1.197-.899l-.067-.089-6.992-8a.75.75 0 0 0-1.05-.078l-.079.078-7.008 8a.75.75 0 0 0 1.049 1.066l.08-.078 6.442-7.354z\"/></svg>";
var $e8dc502aba5ac3f5$export$3875818f0ac85745 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037H5.06l5.058-5.078L6.617 9.15a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v4.354a3.5 3.5 0 0 1 1.5.049V2.1c0-.63-.547-1.1-1.2-1.1zm11.713 2.803a2.147 2.147 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.642-3.11 2.13 2.13 0 0 0-1.873-.978M8.089 17.635v2.388h2.389l7.046-7.046-2.39-2.39zm11.282-6.507a.64.64 0 0 0 .139-.692.6.6 0 0 0-.139-.205l-1.49-1.488a.63.63 0 0 0-.899 0l-1.166 1.163 2.39 2.39z\"/></svg>";
var $e8dc502aba5ac3f5$export$e04bcc6127e699bf = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.538 9.44 6.362 6.362a1.503 1.503 0 1 1-2.125 2.125L9.418 11.56l-6.365 6.365A1.5 1.5 0 1 1 .93 15.803L7.295 9.44.93 3.075A1.5 1.5 0 0 1 3.052.955L9.416 7.32 15.78.955a1.5 1.5 0 0 1 2.123 2.12z\"/></svg>";
var $e8dc502aba5ac3f5$export$b3d4fc19a235faba = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174m2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207M16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.009 15l.003 1H3v-1zm2.188-2-1.471 1H5v-1zM10 11v.095L8.668 12H7v-1zm4-2v1H7V9zm0-2v1H7V7zm-4-2v1H5V5zM6 3v1H3V3z\"/></svg>";
var $e8dc502aba5ac3f5$export$e332a83b9159d69d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m12.5 5.7 5.2 3.9v1.3l-5.6 4c-.1.2-.3.2-.5.2-.3-.1-.6-.7-.6-1l.3-.4 4.7-3.5L11.5 7l-.2-.2c-.1-.3-.1-.6 0-.8.2-.2.5-.4.8-.4a.8.8 0 0 1 .4.1m-5.2 0L2 9.6v1.3l5.6 4c.1.2.3.2.5.2.3-.1.7-.7.6-1 0-.1 0-.3-.2-.4l-5-3.5L8.2 7l.2-.2c.1-.3.1-.6 0-.8-.2-.2-.5-.4-.8-.4a.8.8 0 0 0-.3.1\"/></svg>";
var $e8dc502aba5ac3f5$export$bfab37ea42bb58bf = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.333 2 .19 2.263a6 6 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a6 6 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a6 6 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a6 6 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a6 6 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a6 6 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a6 6 0 0 1 1.46-.605L8.666 2zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466\"/></svg>";
var $e8dc502aba5ac3f5$export$d421729af42ed38a = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M4 1.5h12A3.5 3.5 0 0 1 19.5 5v8l-.005.192a3.5 3.5 0 0 1-2.927 3.262l-.062.008v1.813a1.5 1.5 0 0 1-2.193 1.33l-.371-.193-.38-.212a13.5 13.5 0 0 1-3.271-2.63l-.062-.07H4A3.5 3.5 0 0 1 .5 13V5A3.5 3.5 0 0 1 4 1.5M4 3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6.924a11.9 11.9 0 0 0 3.71 3.081l.372.194v-3.268L14.962 15H16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm1.55 5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5\"/></svg>\n";
var $e8dc502aba5ac3f5$export$7083423a6e6e029e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.209 18.717A8.5 8.5 0 1 1 18.686 9.6h-.008l.002.12a3 3 0 0 1-2.866 2.997h-.268l-.046-.002v.002h-4.791a2 2 0 1 0 0 4 1 1 0 1 1-.128 1.992 9 9 0 0 1-.372.008m-3.918-7.01a1.25 1.25 0 1 0-2.415-.648 1.25 1.25 0 0 0 2.415.647ZM5.723 8.18a1.25 1.25 0 1 0 .647-2.414 1.25 1.25 0 0 0-.647 2.414M9.76 6.155a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415m4.028 1.759a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415\"/></svg>";
var $e8dc502aba5ac3f5$export$79e493651ed727fa = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0\" class=\"ck-icon__fill\"/><path d=\"M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z\"/></svg>";
var $e8dc502aba5ac3f5$export$31f20febaa50f755 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M14 3.5A3.5 3.5 0 0 1 17.5 7v6l-.005.192a3.5 3.5 0 0 1-2.927 3.262l-.062.008v1.813a1.5 1.5 0 0 1-2.193 1.33l-.37-.193-.38-.212a13.5 13.5 0 0 1-3.272-2.63l-.062-.07-4.729-.046a3.5 3.5 0 0 1-3.5-3.5v-6a3.5 3.5 0 0 1 3.5-3.5zM3.5 4.954a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2L8.924 15a11.9 11.9 0 0 0 3.71 3.081l.372.194v-3.268L12.962 15H14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z\" clip-rule=\"evenodd\"/><path d=\"M16.5.5h-10a3.5 3.5 0 0 0-3.162 2h1.84A2 2 0 0 1 6.5 2h10a2 2 0 0 1 2 2v8.873a3.5 3.5 0 0 0 1.495-2.681L20 10V4A3.5 3.5 0 0 0 16.5.5\"/><path d=\"M12.013 7.453a.75.75 0 0 1 .034 1.06l-3.75 4a.75.75 0 0 1-1.045.048l-2.25-2a.75.75 0 0 1 .996-1.122l1.704 1.515 3.25-3.467a.75.75 0 0 1 1.061-.034\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$c49b0ff75638404d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15.5 6.5a3.5 3.5 0 0 1 3.495 3.308L19 10v2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-2l.005-.192A3.5 3.5 0 0 1 15.5 6.5m0 7.5a.5.5 0 0 0-.492.41L15 14.5v2a.5.5 0 0 0 .992.09L16 16.5v-2a.5.5 0 0 0-.5-.5m0-6a2 2 0 0 0-2 2v2h4v-2a2 2 0 0 0-2-2m-9.25 8a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5zm0-5a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5zm3-5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5zm6-5a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$34c248d31dc7803c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.25 16a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5zm0-5a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5zm3-5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5zm6-5a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5zm.25 5.5a3.5 3.5 0 0 1 3.143 1.959.75.75 0 0 1-1.36.636A2 2 0 0 0 13.5 10v2H19a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-2l.005-.192A3.5 3.5 0 0 1 15.5 6.5m0 7.5a.5.5 0 0 0-.492.41L15 14.5v2a.5.5 0 0 0 .992.09L16 16.5v-2a.5.5 0 0 0-.5-.5\"/></svg>";
var $e8dc502aba5ac3f5$export$d7fcaa15ec616aba = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5 2.801a.7.7 0 0 0-.7.7v11.5a.8.8 0 0 1-1.6 0v-11.5a2.3 2.3 0 0 1 2.3-2.3h6.5a.8.8 0 0 1 0 1.6zm.7 3.7a2.3 2.3 0 0 1 2.3-2.3h7a2.3 2.3 0 0 1 2.3 2.3v10a2.3 2.3 0 0 1-2.3 2.3H8a2.3 2.3 0 0 1-2.3-2.3zm2.3-.7a.7.7 0 0 0-.7.7v10a.7.7 0 0 0 .7.7h7a.7.7 0 0 0 .7-.7v-10a.7.7 0 0 0-.7-.7z\"/></svg>";
var $e8dc502aba5ac3f5$export$84ac927778fdc063 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M2.75 1.701a.95.95 0 0 1 .95-.95h7.61l5.94 5.94V18.3a.95.95 0 0 1-.95.95H3.7a.95.95 0 0 1-.95-.95zm1.5.55v15.5h11.5v-10H11.2a.95.95 0 0 1-.95-.95v-4.55zm7.5 1.06 2.94 2.94h-2.94z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$292286b0203a4b09 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1.95.001a.95.95 0 0 0-.95.95v16.6c0 .525.425.95.95.95h5.641c.415 0 .75-.313.75-.727 0-.415-.335-.773-.75-.773H2.5v-15.5h6v4.55c0 .525.425.95.95.95H14V8.24c0 .414.342.75.757.75a.744.744 0 0 0 .743-.75v-2.3L9.56.001zm10.99 5.5L10 2.561v2.94z\"/><path d=\"M18.03 11.531a.75.75 0 0 0-1.06-1.06L12 15.44l-2.47-2.47a.75.75 0 0 0-1.06 1.06L12 17.56z\"/></svg>";
var $e8dc502aba5ac3f5$export$27724be3b46f28ac = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M1.95.001a.95.95 0 0 0-.95.95v16.6c0 .525.425.95.95.95h5.641c.415 0 .75-.32.75-.735a.763.763 0 0 0-.75-.765H2.5v-15.5h6v4.55c0 .525.425.95.95.95H14v1.25c0 .414.342.75.757.75a.744.744 0 0 0 .743-.75v-2.31L9.56 0zm10.99 5.5L10 2.561v2.94z\"/><path d=\"M11.47 10.47a.75.75 0 0 1 1.06 0l2.97 2.97 2.97-2.97a.75.75 0 0 1 1.06 1.061l-2.97 2.97 2.97 2.97a.75.75 0 0 1-1.06 1.06l-2.97-2.97-2.97 2.97a.75.75 0 1 1-1.06-1.06l2.97-2.97-2.97-2.97a.75.75 0 0 1 0-1.06\"/></svg>";
var $e8dc502aba5ac3f5$export$8400771822998e0f = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M1 .95A.95.95 0 0 1 1.95 0h7.61l5.94 5.94v3.249A6 6 0 0 0 14 9V7H9.45a.95.95 0 0 1-.95-.95V1.5h-6V17h5.841c.191.54.457 1.044.785 1.5H1.95a.95.95 0 0 1-.95-.95zm9 1.61 2.94 2.94H10z\"/><path d=\"M12.895 17.79c.805 0 1.553-.243 2.173-.661l2.653 2.653a.75.75 0 0 0 1.06-1.061l-2.652-2.653a3.895 3.895 0 1 0-3.233 1.722m0-1.6a2.295 2.295 0 1 1 0-4.59 2.295 2.295 0 0 1 0 4.59\"/></g></svg>";
var $e8dc502aba5ac3f5$export$82591e8db156c9c0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.474 19.467a1.88 1.88 0 0 1-1.882-1.881V4.415a1.88 1.88 0 0 1 1.882-1.882h15.053a1.88 1.88 0 0 1 1.881 1.882v13.17a1.88 1.88 0 0 1-1.881 1.882zm5.645-1.41h9.408a.47.47 0 0 0 .47-.471V4.415a.47.47 0 0 0-.47-.47H8.119zM6.707 3.943H2.474a.47.47 0 0 0-.47.47v13.172a.47.47 0 0 0 .47.47h4.233z\"/></svg>";
var $e8dc502aba5ac3f5$export$7b19f5c5fdff86c4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5 9.5a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 5 8H3.5a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 .5.5zm.5 2.5a.5.5 0 0 1-.5.5H3.5A.5.5 0 0 1 3 12v-.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5zM5 6.5a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 5 5H3.5a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5z\"/><path d=\"M2 19a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zm6-1.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H8zm-1.5-15H2a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h4.5z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$da3a225fdca174e1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5z\"/><path fill-opacity=\".256\" d=\"M1 1h14v14H1z\"/><g class=\"ck-icon__selected-indicator\"><path d=\"M7 0h2v1H7zM0 7h1v2H0zm15 0h1v2h-1zm-8 8h2v1H7z\"/><path fill-opacity=\".254\" d=\"M1 1h14v14H1z\"/></g></svg>";
var $e8dc502aba5ac3f5$export$88be5dc0e2fd244c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m7 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m7 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m-7 6.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m7 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0\"/></svg>";
var $e8dc502aba5ac3f5$export$c61408bd47dcc7d1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.972 3.115A.75.75 0 0 1 6.374 3c.14 0 .28.037.402.115l3.229 2.059 3.228-2.057a.75.75 0 0 1 .805 0l3.629 2.31h.002a.757.757 0 0 1 0 1.264h-.002L15.034 8.37l2.633 1.678h.002a.756.756 0 0 1 0 1.262h-.002l-3.63 2.312a1 1 0 0 1-.161.076c.234.08.409.275.482.5a.75.75 0 0 1-.322.854l-3.629 2.308a.75.75 0 0 1-.805 0l-3.63-2.31a.75.75 0 0 1-.229-1.031l.076-.122h.022a.75.75 0 0 1 .32-.189.8.8 0 0 1-.19-.086l-3.63-2.312a.756.756 0 0 1 0-1.264l2.632-1.678-2.632-1.676a.757.757 0 0 1 0-1.263zm2.64 2.946L6.374 4.635 4.136 6.06l2.238 1.423L8.612 6.06Zm7.262 0-2.236-1.426-2.239 1.426 2.237 1.423zm-3.637 2.306-2.232-1.422-2.233 1.422 2.235 1.422zm-3.625 2.31L6.374 9.253l-2.238 1.426 2.238 1.424 2.238-1.424Zm7.262 0-2.236-1.425-2.239 1.426 2.237 1.424 2.238-1.424Zm-2.64 2.944-3.23-2.056-3.228 2.056a.8.8 0 0 1-.185.084.7.7 0 0 1 .185.08l3.229 2.057 3.226-2.055a.8.8 0 0 1 .18-.084.8.8 0 0 1-.178-.082Z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$48d0dd33d947d151 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"><path d=\"M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136z\"/></svg>";
var $e8dc502aba5ac3f5$export$43992051189b9fa5 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 13.598v2.777h2.778l8.194-8.193-2.78-2.78L3 13.6zm13.12-7.566a.735.735 0 0 0 0-1.044l-1.734-1.73a.735.735 0 0 0-1.044 0L11.985 4.61l2.78 2.78 1.354-1.358z\"/></svg>";
var $e8dc502aba5ac3f5$export$8bd591d4b34dcafa = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8.5 8.25a1.25 1.25 0 1 1-2.499.001A1.25 1.25 0 0 1 8.5 8.25m5.5 0a1.25 1.25 0 1 1-2.499.001A1.25 1.25 0 0 1 14 8.25m-6.873 3.838a.75.75 0 1 0-1.254.824C6.88 14.444 8.423 15.25 10 15.25c1.578 0 3.12-.805 4.127-2.338a.75.75 0 0 0-1.254-.824C12.13 13.221 11.048 13.75 10 13.75c-1.047 0-2.13-.529-2.873-1.662\" clip-rule=\"evenodd\"/><path d=\"M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15\"/></svg>";
var $e8dc502aba5ac3f5$export$6ce1521e49717004 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053z\"/><path d=\"M4 18h5.523v-1H4zm-2 0h1v-1H2z\"/></svg>";
var $e8dc502aba5ac3f5$export$66493327321323ad = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.9 4.385a1.2 1.2 0 0 0-.44.44h.002l-5.284 9.15a1.2 1.2 0 0 0 1.04 1.8h10.564a1.2 1.2 0 0 0 1.04-1.8l-5.282-9.15a1.2 1.2 0 0 0-1.64-.44m.05 8.363a.3.3 0 0 1 .115-.023h.9a.3.3 0 0 1 .3.3v.9a.3.3 0 0 1-.3.3h-.9a.3.3 0 0 1-.3-.3v-.9a.3.3 0 0 1 .185-.277m-.185-4.723a.3.3 0 0 1 .3-.3h.9a.3.3 0 0 1 .3.3v3.4a.3.3 0 0 1-.3.3h-.9a.3.3 0 0 1-.3-.3z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$21835e319e55b164 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19 4.5 14 0H3v6.5h1.5v-5h8v5h5V11H19zM14 2l3.3 3H14zm-1.548 16.5 1.25 1.5H3v-3h1.5v1.5zm7.374-1.657a.75.75 0 1 0-1.152-.96L17.5 17.29V13H16v4.29l-1.174-1.408a.75.75 0 1 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0z\"/><path d=\"M1.63 14.24V12.3h.88c.66 0 1.14-.15 1.46-.45s.48-.71.48-1.24c0-.52-.15-.91-.44-1.2C3.7 9.15 3.28 9 2.69 9H0v5.24zm.4-3h-.4v-1.17h.46c.3 0 .5.05.62.17.1.11.16.25.16.42 0 .16-.06.3-.19.41s-.34.16-.66.16zm5.7 3c.28 0 .6-.05.96-.14.26-.07.5-.21.73-.42.22-.2.4-.47.53-.77.12-.31.19-.75.19-1.3 0-.37-.04-.7-.13-1.02a2.3 2.3 0 0 0-.42-.84c-.19-.24-.43-.43-.72-.56C8.57 9.06 8.2 9 7.72 9h-2.4v5.24zm-.4-1.19h-.4v-2.86h.4c.43 0 .73.1.91.3s.27.59.27 1.14c0 .42-.04.73-.12.91a.76.76 0 0 1-.34.4c-.14.07-.38.11-.72.11m5.3 1.2V12.1h2.02v-1.06h-2.03v-.91H15V9h-4v5.24h1.62z\"/></svg>";
var $e8dc502aba5ac3f5$export$2f94039c7dde826c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.826 16.843a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0z\"/><path d=\"m14 0 5 4.5v9.741a2.74 2.74 0 0 0-1.5-.617V6.5h-5v-5h-8v3H3V0zm0 2v3h3.3zM3 17.5h6.746q.15.331.391.623l.731.877H3z\"/><path d=\"M8.5 6a1.5 1.5 0 0 1 1.493 1.356L10 7.5v7a1.5 1.5 0 0 1-1.356 1.493L8.5 16h-7a1.5 1.5 0 0 1-1.493-1.356L0 14.5v-7a1.5 1.5 0 0 1 1.356-1.493L1.5 6zM7.483 8.795l-.042.088-.986 2.534-.947-2.528-.043-.092a.601.601 0 0 0-1.042.008l-.042.093-.883 2.465-.937-2.475-.042-.089a.6.6 0 0 0-1.107.42l.027.093 1.514 4 .044.092a.6.6 0 0 0 1.041-.01l.041-.092.88-2.458.925 2.467.046.096a.6.6 0 0 0 1.032 0l.043-.09 1.554-4 .028-.093a.6.6 0 0 0-1.104-.43z\"/></svg>";
var $e8dc502aba5ac3f5$export$e7fa0500a4c7ffc1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 6.002a4 4 0 1 1 0 8 4 4 0 0 1 0-8m1.2 1.2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M10.02 3.003c1.249.032 2.49.494 3.617 1.116 1.133.625 2.2 1.44 3.109 2.235a28.6 28.6 0 0 1 2.858 2.898l.171.204.046.054.012.016.004.004v.002a.8.8 0 0 1 .11.193l.02.05q.013.045.02.09l.01.054a.7.7 0 0 1 0 .146q-.002.032-.009.065l-.017.082-.024.061q-.014.038-.03.075l-.01.019a1 1 0 0 1-.06.093l-.002-.002h-.001l.002.003h-.001l-.004.005-.012.016-.046.058-.17.21a27.5 27.5 0 0 1-2.861 2.977c-.912.811-1.981 1.635-3.12 2.252-1.132.614-2.387 1.053-3.652 1.02-1.249-.031-2.49-.493-3.618-1.115-1.133-.626-2.199-1.44-3.108-2.235a28.6 28.6 0 0 1-3.029-3.102l-.045-.055-.012-.016-.004-.004-.001-.002a1 1 0 0 1-.065-.092l-.007-.015q-.025-.045-.041-.094l-.017-.042q-.014-.044-.02-.092-.007-.026-.01-.053Q0 10.042 0 10q-.002-.033 0-.065.004-.04.013-.079l.013-.06a1 1 0 0 1 .031-.084q.011-.03.025-.058l.012-.022a1 1 0 0 1 .06-.09h.001V9.54l.004-.005.012-.016.046-.057.17-.211a27.5 27.5 0 0 1 2.86-2.977c.911-.81 1.98-1.635 3.119-2.252 1.133-.614 2.388-1.052 3.652-1.02m-.04 1.499c-.902-.023-1.89.293-2.897.84-1.002.543-1.976 1.289-2.836 2.054a26 26 0 0 0-2.103 2.112l-.014.016a.695.695 0 0 0 .007.932 27 27 0 0 0 2.105 2.064c.861.753 1.838 1.495 2.846 2.051 1.013.56 2.014.906 2.931.93.903.022 1.89-.293 2.898-.84 1.002-.544 1.977-1.288 2.837-2.054a26 26 0 0 0 2.117-2.13.695.695 0 0 0-.008-.93 27 27 0 0 0-2.104-2.064c-.862-.753-1.839-1.495-2.847-2.052-1.014-.56-2.014-.906-2.932-.93\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$d129d5423de9899d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.97 2.97a.75.75 0 0 1 1.06 0L5.56 4.5q.397-.254.807-.477c1.133-.614 2.388-1.052 3.652-1.02 1.25.032 2.492.494 3.618 1.116 1.133.625 2.2 1.44 3.109 2.235a29 29 0 0 1 2.858 2.898q.112.13.171.204l.046.055.012.015.004.004v.002q.07.091.11.193l.02.05q.013.045.02.09l.01.054a1 1 0 0 1 0 .146q-.002.033-.009.065l-.017.082-.024.061q-.014.039-.03.075l-.01.019a1 1 0 0 1-.06.093l-.003-.002.002.003h-.002l-.003.006-.012.015-.046.058-.17.21a27.5 27.5 0 0 1-2.861 2.978q-.508.452-1.072.892l1.35 1.35a.75.75 0 0 1-1.02 1.098 1 1 0 0 0-.08-.097l-13-13-.043-.039a.75.75 0 0 1 .083-.961m1.27 4.432a26 26 0 0 0-2.096 2.106l-.014.016a.695.695 0 0 0 .007.932 27 27 0 0 0 2.105 2.064c.861.753 1.838 1.495 2.846 2.051 1.013.56 2.014.906 2.931.93.612.015 1.26-.128 1.93-.39l1.14 1.14c-.984.466-2.043.776-3.109.749-1.249-.032-2.491-.494-3.618-1.116-1.132-.626-2.199-1.44-3.108-2.235a28.6 28.6 0 0 1-3.029-3.102l-.045-.055-.012-.016-.004-.004-.001-.002a1 1 0 0 1-.065-.092l-.007-.015a1 1 0 0 1-.041-.094l-.017-.042q-.014-.045-.02-.091-.007-.027-.01-.054Q0 10.042 0 10v-.064q.004-.04.013-.079l.013-.06a1 1 0 0 1 .031-.084q.011-.03.025-.058l.012-.022a1 1 0 0 1 .06-.09h.001V9.54l.004-.005.012-.016.046-.057.17-.211a27.6 27.6 0 0 1 2.788-2.913zm6.522 6.523a4 4 0 0 1-.762.077 4 4 0 0 1-3.926-4.766zM9.98 4.502c-.902-.023-1.89.293-2.897.84q-.218.117-.434.248l1.103 1.102a4 4 0 0 1 5.557 5.557l1.3 1.3c.397-.301.782-.619 1.145-.942a26 26 0 0 0 2.117-2.13.696.696 0 0 0-.008-.93 27 27 0 0 0-2.104-2.064c-.861-.753-1.84-1.495-2.847-2.052-1.014-.559-2.014-.906-2.932-.93m1.22 2.7c-.809 0-1.466.64-1.497 1.441l1.555 1.555a1.5 1.5 0 0 0-.058-2.996\"/></svg>";
var $e8dc502aba5ac3f5$export$20076b897deffd6a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.01 2C5.59 2 2 5.59 2 10.01a8.01 8.01 0 0 0 6.775 7.914.75.75 0 0 0 .598-.17.75.75 0 0 0 .262-.565v-5.02a.75.75 0 0 0-.22-.524.75.75 0 0 0-.526-.221H7.77v-.627h1.12a.75.75 0 0 0 .525-.22c.14-.14.22-.329.22-.526V8.324c0-.466.122-1.083.524-1.48.33-.326 1.017-.6 2.332-.43v.408c-.152.012-.305.017-.457.04-.335.048-.662.136-.943.326-.313.21-.497.505-.59.804s-.107.602-.107.88v1.18a.746.746 0 0 0 .744.746h1.158l-.098.63h-1.06a.744.744 0 0 0-.744.744v5.017a.75.75 0 0 0 .26.567q.123.105.28.148a.75.75 0 0 0 .319.022A8.012 8.012 0 0 0 10.01 2m0 1.486a6.52 6.52 0 0 1 6.521 6.524c0 2.945-1.973 5.386-4.65 6.197v-3.291h.951a.75.75 0 0 0 .736-.63l.332-2.12a.74.74 0 0 0-.17-.6.75.75 0 0 0-.564-.26h-1.285V8.87c0-.252.024-.384.039-.433q.003-.011.002-.016c.016-.011.104-.055.326-.088a7 7 0 0 1 .984-.05.75.75 0 0 0 .528-.218.74.74 0 0 0 .217-.527V5.76a.75.75 0 0 0-.586-.729c-2.04-.438-3.433-.083-4.278.75-.818.807-.968 1.884-.968 2.543v.983H7.027a.74.74 0 0 0-.525.22.74.74 0 0 0-.219.526v2.119c0 .197.08.386.219.525.14.14.328.221.525.221h1.118v3.291c-2.681-.809-4.659-3.25-4.659-6.197a6.523 6.523 0 0 1 6.524-6.526\"/></svg>";
var $e8dc502aba5ac3f5$export$e422ccc855bc8826 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.146 11.22a.75.75 0 0 1 1.061 0l3.677 3.678a.75.75 0 0 1-1.06 1.06l-2.397-2.396v5.689a.75.75 0 0 1-1.5 0v-5.69L3.53 15.959a.75.75 0 0 1-1.06-1.06z\"/><path fill-rule=\"evenodd\" d=\"M17.75 5.94v11.61a.95.95 0 0 1-.95.951h-6.3a.75.75 0 0 1 0-1.5h5.75v-10H11.7a.95.95 0 0 1-.95-.95V1.5h-6v8.66l-1.5 1.5V.95A.95.95 0 0 1 4.2 0h7.61zm-5.5-.439h2.94l-2.94-2.94z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$dd9478159cd90ed0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m12.87 13.786 1.532-1.286 3.857 4.596a1 1 0 1 1-1.532 1.286z\"/><path d=\"M16.004 8.5a6.5 6.5 0 0 1-9.216 5.905c-1.154-.53-.863-1.415-.663-1.615.194-.194.564-.592 1.635-.141a4.5 4.5 0 0 0 5.89-5.904l-.104-.227 1.332-1.331c.045-.046.196-.041.224.007a6.47 6.47 0 0 1 .902 3.306m-3.4-5.715c.562.305.742 1.106.354 1.494s-.995.414-1.476.178a4.5 4.5 0 0 0-6.086 5.882l.114.236-1.348 1.349c-.038.037-.17.022-.198-.023a6.5 6.5 0 0 1 5.54-9.9 6.5 6.5 0 0 1 3.1.784\"/><path d=\"M4.001 11.93.948 8.877a.2.2 0 0 1 .141-.341h6.106a.2.2 0 0 1 .141.341L4.283 11.93a.2.2 0 0 1-.282 0m11.083-6.789 3.053 3.053a.2.2 0 0 1-.14.342H11.89a.2.2 0 0 1-.14-.342l3.052-3.053a.2.2 0 0 1 .282 0\"/></svg>";
var $e8dc502aba5ac3f5$export$4117c670ac25fa00 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m8.38 9.262H7.62L10 5.506zm.532 1.285L14.34 16h1.426L10.804 4H9.196L4.234 16H5.66l1.428-3.453z\"/></svg>";
var $e8dc502aba5ac3f5$export$31253b9d9ec5390e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M12.4 10.3 10 4.5l-2.4 5.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2\"/></svg>";
var $e8dc502aba5ac3f5$export$6a130398be26b750 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.03 3h6.149a.75.75 0 1 1 0 1.5h-5.514zm1.27 3h4.879a.75.75 0 1 1 0 1.5h-4.244zm1.27 3h3.609a.75.75 0 1 1 0 1.5h-2.973zm-2.754 2.5L8.038 4.785 5.261 11.5zm.62 1.5H4.641l-1.666 4.028H1.312l5.789-14h1.875l5.789 14h-1.663z\"/></svg>";
var $e8dc502aba5ac3f5$export$22a74c9119a12cf9 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.816 11.5 7.038 4.785 4.261 11.5zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663zm7.55 2.279.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825q0-.063.002-.123l-.77.77-.707-.707L17.207 2.5l2.265 2.265-.707.707-.782-.782q.003.065.003.135z\"/></svg>";
var $e8dc502aba5ac3f5$export$adc0815d85c10553 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M19.832 7.469V1h-1.004q-.21.59-.778 1.03-.567.443-1.05.6v1.121a4.3 4.3 0 0 0 1.595-.936v4.654zM5.465 7.452q1.19 0 1.934.27t1.094.682q.35.405.49 1.029.08.387.08 1.398v2.021q0 2.115.095 2.68.105.556.404 1.07H7.916a3.1 3.1 0 0 1-.315-1.103q-.876.716-1.69 1.01a5 5 0 0 1-1.733.296q-1.531 0-2.355-.716-.822-.725-.823-1.846 0-.657.307-1.196.315-.547.814-.876a4 4 0 0 1 1.138-.497q.465-.118 1.4-.228 1.908-.219 2.81-.522.009-.312.009-.397 0-.926-.447-1.305-.603-.514-1.794-.514-1.111 0-1.646.379-.525.37-.779 1.322l-1.54-.202q.21-.953.69-1.533.483-.59 1.392-.902.911-.32 2.11-.32m7.048 1.034Q13.51 7.26 15.06 7.26q.858 0 1.62.343.77.334 1.26.952.5.61.78 1.475a6 6 0 0 1 .28 1.854q0 2.341-1.182 3.62t-2.837 1.278q-1.645 0-2.582-1.347v1.141h-1.461V4h1.575zm-5.044 3.625q-.858.337-2.573.574-.972.134-1.375.303a1.35 1.35 0 0 0-.622.497 1.24 1.24 0 0 0-.218.716q0 .606.472 1.01.482.405 1.4.405.912 0 1.62-.379.71-.387 1.043-1.052.253-.515.253-1.517zM14.92 8.53q-1.033 0-1.786.884-.753.875-.753 2.54 0 1.638.455 2.367.744 1.193 2.014 1.193 1.032 0 1.785-.875.753-.884.753-2.625 0-1.785-.727-2.634-.717-.85-1.741-.85\"/></svg>";
var $e8dc502aba5ac3f5$export$7180bd615122b78e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.5 5.75a.75.75 0 0 1 0-1.5H15a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V6.81l-2.72 2.72a.75.75 0 0 1-1.06-1.06l2.72-2.72zm-1.97 4.72a.75.75 0 0 1 0 1.06l-2.72 2.72H8.5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v1.69l2.72-2.72a.75.75 0 0 1 1.06 0\"/><path d=\"M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m16 1.5H2a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5\"/></svg>";
var $e8dc502aba5ac3f5$export$98b1ae70ec39316e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15.53 5.53a.75.75 0 0 0-1.06-1.06l-2.72 2.72V5.5a.75.75 0 0 0-1.5 0V9a.75.75 0 0 0 .75.75h3.5a.75.75 0 0 0 0-1.5h-1.69zM5.5 10.25a.75.75 0 0 0 0 1.5h1.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l2.72-2.72v1.69a.75.75 0 0 0 1.5 0V11a.75.75 0 0 0-.75-.75z\"/><path d=\"M0 2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm18.5 0a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$2127b225fa9d83f4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7.666 3a.74.74 0 0 0-.371.1.75.75 0 0 0-.275.267l-4.918 8.397a.74.74 0 0 0-.006.744l2.46 4.318a.75.75 0 0 0 .65.377h9.606a.75.75 0 0 0 .65-.377l2.46-4.318a.74.74 0 0 0 .002-.735l-4.688-8.392a.75.75 0 0 0-.654-.38H7.666Zm1.285 1.492h3.195l3.854 6.9h-3.1zm-1.293.742L9.223 7.97l-4.016 6.988-1.6-2.813zm2.424 4.237 1.098 1.922H8.977zM8.12 12.885h7.87l-1.61 2.825H6.494z\"/></svg>";
var $e8dc502aba5ac3f5$export$dd24607a7bbcfb14 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.258 3.082c0-.594.486-1.082 1.08-1.082a4.38 4.38 0 0 1 4.239 5.489c-.18.688-.633 1.245-1.109 1.767h3.468c.595 0 1.082.488 1.082 1.082a4.382 4.382 0 0 1-5.49 4.24v-.001c-.689-.18-1.246-.633-1.768-1.109v3.468c0 .595-.487 1.082-1.082 1.082a4.38 4.38 0 0 1-4.111-2.866 4.4 4.4 0 0 1-.125-2.624c.18-.689.632-1.246 1.108-1.768H3.082A1.085 1.085 0 0 1 2 9.68a4.382 4.382 0 0 1 5.49-4.238c.69.18 1.246.632 1.768 1.108zm3.164 1.32c-.435-.46-1.043-.667-1.662-.767v5.49c.619-.1 1.227-.307 1.662-.766a2.875 2.875 0 0 0 0-3.958ZM7.21 6.918a2.88 2.88 0 0 0-2.93.789c-.396.423-.569.983-.658 1.55h5.56c-.045-.295-.091-.59-.224-.859a2.88 2.88 0 0 0-1.748-1.48m9.254 3.841h-5.653l.013.1c.012.098.025.197.053.292a2.873 2.873 0 0 0 4.862 1.158 3 3 0 0 0 .398-.54v-.001q.167-.294.263-.619c.026-.092.038-.188.05-.283zm-8.872 4.86c.437.459 1.045.666 1.665.766V10.89c-1.369.222-2.456 1.314-2.456 2.747 0 .738.283 1.447.791 1.981Z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$bac470d93529d4c7 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19 9v10h-2v-8h-2V9zM4 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11H4v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1z\"/></svg>";
var $e8dc502aba5ac3f5$export$1802ef05a0e02fcb = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1zm16.076 8.343V18.5h-6.252q.1-.94.61-1.78.507-.841 2.005-2.232 1.206-1.124 1.479-1.523.368-.552.368-1.092 0-.597-.32-.917-.321-.32-.886-.32-.559 0-.889.336t-.38 1.117l-1.778-.178q.159-1.473.997-2.114t2.095-.64q1.377 0 2.164.742t.787 1.847q0 .629-.225 1.197-.225.567-.714 1.19-.324.412-1.168 1.187-.845.774-1.07 1.028a3 3 0 0 0-.365.495z\"/></svg>";
var $e8dc502aba5ac3f5$export$b1fdd40685827e35 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1zm9.989 7.53 1.726-.209q.082.66.445 1.01.36.348.876.349.552 0 .93-.42.377-.418.377-1.13 0-.672-.362-1.066a1.15 1.15 0 0 0-.882-.393q-.342 0-.819.133l.197-1.453q.723.019 1.105-.315.38-.333.38-.885 0-.47-.279-.75-.28-.278-.743-.278a1.07 1.07 0 0 0-.78.317q-.324.317-.394.927l-1.644-.28q.172-.844.517-1.348.347-.505.965-.794a3.24 3.24 0 0 1 1.387-.289q1.314 0 2.108.838.654.685.653 1.549 0 1.225-1.339 1.955.8.171 1.28.768.478.597.478 1.441 0 1.226-.895 2.088-.894.864-2.228.864-1.263 0-2.094-.727-.832-.727-.965-1.901z\"/></svg>";
var $e8dc502aba5ac3f5$export$1453f3b4cc22752 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1zm13.55 10v-1.873h-3.81v-1.561l4.037-5.91h1.498v5.904h1.156v1.567h-1.156V18.5zm0-3.44v-3.18l-2.14 3.18z\"/></svg>";
var $e8dc502aba5ac3f5$export$6d7f7031d9f2177d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1zm9.578 7.607 1.777-.184q.076.603.45.955a1.223 1.223 0 0 0 1.81-.101q.387-.455.387-1.368 0-.857-.384-1.286-.384-.428-1-.428-.768 0-1.377.679l-1.448-.21.915-4.843h4.716v1.67H15.56l-.28 1.58a2.7 2.7 0 0 1 1.219-.298 2.68 2.68 0 0 1 2.012.863q.825.864.825 2.241a3.36 3.36 0 0 1-.666 2.05q-.907 1.232-2.52 1.232-1.29 0-2.101-.692-.813-.691-.971-1.86\"/></svg>";
var $e8dc502aba5ac3f5$export$81e8db89b599e5e6 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1zm15.595 2.973-1.726.19q-.064-.532-.33-.787-.267-.253-.692-.253-.565 0-.956.507-.39.508-.492 2.114.667-.787 1.657-.787 1.117 0 1.914.85.797.852.797 2.197 0 1.428-.838 2.291-.838.864-2.152.864-1.41 0-2.317-1.095t-.908-3.59q0-2.558.946-3.688t2.457-1.13q1.059 0 1.755.594.694.593.885 1.723m-4.043 3.891q0 .87.4 1.343.398.473.914.473.495 0 .825-.388.33-.386.33-1.27 0-.906-.355-1.329a1.12 1.12 0 0 0-.89-.422q-.513 0-.869.403c-.356.403-.355.666-.355 1.19\"/></svg>";
var $e8dc502aba5ac3f5$export$86933bc301bbb319 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1\"/><path d=\"M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052zM11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z\"/></svg>";
var $e8dc502aba5ac3f5$export$b03f1fdb262e3614 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 9h16v2H2z\"/></svg>";
var $e8dc502aba5ac3f5$export$32881376bf9e1b12 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965zM2 10H1v5h1v-2h2v2h1v-5H4v2H2zm7 0H6v1h1v4h1v-4h1zm8 0h-1v5h3v-1h-2zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5M10 7v1H4V7zm3-2v1H4V5zm-3-2v1H4V3z\"/></svg>";
var $e8dc502aba5ac3f5$export$a3743a0d9f1cf347 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.201 1c-.662 0-1.2.47-1.2 1.1v14.248c0 .64.533 1.152 1.185 1.152h6.623v-7.236L6.617 9.15a.694.694 0 0 0-.957-.033L1.602 13.55V2.553l14.798.003V9.7H18V2.1c0-.63-.547-1.1-1.2-1.1zm11.723 2.805a2.1 2.1 0 0 0-1.621.832 2.127 2.127 0 0 0 1.136 3.357 2.13 2.13 0 0 0 2.611-1.506 2.13 2.13 0 0 0-.76-2.244 2.13 2.13 0 0 0-1.366-.44Z\"/><path d=\"M19.898 12.369v6.187a.844.844 0 0 1-.844.844h-8.719a.844.844 0 0 1-.843-.844v-7.312a.844.844 0 0 1 .843-.844h2.531a.84.84 0 0 1 .597.248l.838.852h4.75c.223 0 .441.114.6.272a.84.84 0 0 1 .247.597m-1.52.654-4.377.02-1.1-1.143H11v6h7.4l-.023-4.877Z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$ce763e1c75a88f49 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.66 9.118a.693.693 0 0 1 .956.032l3.65 3.411 2.422-2.238a.695.695 0 0 1 .945 0L17.5 13.6V2.5h-15v11.1zM17.8 1c.652 0 1.2.47 1.2 1.1v14.362c0 .64-.532 1.038-1.184 1.038H2.184C1.532 17.5 1 17.103 1 16.462V2.1C1 1.47 1.537 1 2.2 1zm-5.655 6a2.13 2.13 0 0 1 .157-2.364A2.133 2.133 0 1 1 12.145 7\"/></svg>";
var $e8dc502aba5ac3f5$export$1bc502c48e40c39 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h9.494a3 3 0 0 1-.414-.287 3 3 0 0 1-1.055-2.03 3 3 0 0 1 .693-2.185l.383-.455-.02.018-3.65-3.41a.695.695 0 0 0-.957-.034L1.5 13.6V2.5h15v5.535a2.97 2.97 0 0 1 1.412.932l.088.105V2.1c0-.63-.547-1.1-1.2-1.1zm11.713 2.803a2.146 2.146 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.644-3.11 2.13 2.13 0 0 0-1.875-.978\"/><path d=\"M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.8.8 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79\"/><path d=\"M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.8.8 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79\"/></svg>";
var $e8dc502aba5ac3f5$export$ec40730d4a74e656 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h7.029a5.4 5.4 0 0 1 .615-4.338l.762-1.232-2.975-2.78a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v6.023q.675.195 1.307.573l.058.033q.068.042.135.086V2.1c0-.63-.547-1.1-1.2-1.1zm11.713 2.803a2.15 2.15 0 0 0-1.611.834 2.1 2.1 0 0 0-.438 1.158 2.14 2.14 0 0 0 1.277 2.096 2.132 2.132 0 0 0 2.645-3.11 2.13 2.13 0 0 0-1.873-.978\"/><path d=\"M16.63 10.294a3.003 3.003 0 0 0-4.142.887l-.117.177a.65.65 0 0 0-.096.492.66.66 0 0 0 .278.418.7.7 0 0 0 .944-.234 1.74 1.74 0 0 1 2.478-.463 1.87 1.87 0 0 1 .476 2.55.64.64 0 0 0-.071.5.65.65 0 0 0 .309.396.627.627 0 0 0 .869-.19l.027-.041a3.226 3.226 0 0 0-.956-4.492Zm-6.061 3.78-.044.066a3.23 3.23 0 0 0 .82 4.403 3.005 3.005 0 0 0 4.275-.798l.13-.197a.63.63 0 0 0 .092-.475.64.64 0 0 0-.268-.402.713.713 0 0 0-.99.26l-.018.029a1.74 1.74 0 0 1-2.477.461 1.87 1.87 0 0 1-.475-2.55l.029-.047a.65.65 0 0 0 .086-.485.66.66 0 0 0-.275-.408l-.04-.027a.61.61 0 0 0-.845.17\"/><path d=\"M15.312 13.925c.24-.36.154-.838-.19-1.067-.346-.23-.82-.124-1.059.236l-1.268 1.907c-.239.36-.153.838.192 1.067.345.23.818.123 1.057-.236z\"/></svg>";
var $e8dc502aba5ac3f5$export$968ff8d3dd6c69d6 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822zM14 5V2l3.3 3zm-3.692 12.5q.093.157.213.303L11.52 19H8v-.876a2.24 2.24 0 0 0 1.82-.624zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z\"/></svg>";
var $e8dc502aba5ac3f5$export$88efd14fd1fd8768 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m14 0 5 4.5v8.892l-1.5-1.8V6.5h-5v-5h-8v3H3V0zm0 2v3h3.3zm-3.26 16a2.8 2.8 0 0 1-.469-.5H3V19h9.25v-.374A2.74 2.74 0 0 1 10.74 18\"/><path d=\"M8.5 6a1.5 1.5 0 0 1 1.493 1.356L10 7.5v7a1.5 1.5 0 0 1-1.356 1.493L8.5 16h-7a1.5 1.5 0 0 1-1.493-1.356L0 14.5v-7a1.5 1.5 0 0 1 1.356-1.493L1.5 6zM7.483 8.795l-.042.088-.986 2.534-.947-2.528-.043-.092a.601.601 0 0 0-1.042.008l-.042.093-.883 2.465-.937-2.475-.042-.089a.6.6 0 0 0-1.107.42l.027.093 1.514 4 .044.092a.6.6 0 0 0 1.041-.01l.041-.092.88-2.458.925 2.467.046.096a.602.602 0 0 0 1.032 0l.043-.09 1.554-4 .028-.093a.6.6 0 0 0-1.104-.43zm4.191 6.612a.75.75 0 1 0 1.152.96L14 14.96V20h1.5v-5.04l1.174 1.408a.75.75 0 1 0 1.152-.96l-2.346-2.816a.95.95 0 0 0-1.46 0z\"/></svg>";
var $e8dc502aba5ac3f5$export$6c638b4f8a44828d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75M2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5M1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z\"/></svg>";
var $e8dc502aba5ac3f5$export$340bfce9b4df026b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 8.251a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75m0-3.5a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75\"/><path fill-rule=\"evenodd\" d=\"M10 .751a9.25 9.25 0 1 1 0 18.5 9.25 9.25 0 0 1 0-18.5m0 1.5a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$c32b303c04e00237 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><circle cx=\"10\" cy=\"9.8\" r=\"1.5\"/><path d=\"M13.25 2.75V2h.035a6 6 0 0 1 .363.014c.21.013.517.041.785.109.397.1.738.281 1.007.55s.429.587.524.907c.182.608.15 1.314.108 1.913l-.03.408c-.038.487-.073.93-.053 1.353.026.527.136.879.333 1.112.223.263.494.428.72.528a2 2 0 0 0 .335.117l.01.002.613.109v.628h-2.402a3.3 3.3 0 0 1-.42-.415c-.509-.601-.655-1.345-.687-2.009-.025-.527.02-1.094.059-1.592l.026-.347c.044-.621.044-1.067-.049-1.377a.63.63 0 0 0-.148-.276.64.64 0 0 0-.313-.157 3 3 0 0 0-.512-.066 6 6 0 0 0-.286-.01h-.016L13.25 3.5h-.75V2h.75z\"/><path d=\"M13.25 16.75v.75h.035a7 7 0 0 0 .363-.014 4.6 4.6 0 0 0 .785-.109c.397-.1.738-.28 1.007-.55.268-.269.429-.587.524-.907.182-.608.15-1.314.108-1.912l-.03-.41c-.038-.486-.073-.93-.053-1.352.026-.527.136-.879.333-1.112.223-.263.494-.428.72-.528a2 2 0 0 1 .335-.117l.01-.002.613-.109V9.75h-2.402a3.3 3.3 0 0 0-.42.416c-.509.6-.655 1.344-.687 2.008-.025.527.02 1.095.059 1.592l.026.347c.044.621.044 1.067-.049 1.378a.63.63 0 0 1-.148.275.64.64 0 0 1-.313.157 3 3 0 0 1-.512.066 6 6 0 0 1-.286.01l-.016.001H12.5v1.5h.75zm-6.5-14V2h-.035a6 6 0 0 0-.363.014 4.6 4.6 0 0 0-.785.109 2.13 2.13 0 0 0-1.008.55 2.1 2.1 0 0 0-.524.907c-.181.608-.15 1.314-.108 1.913l.031.408c.038.487.073.93.052 1.353-.025.527-.136.879-.333 1.112a2 2 0 0 1-.718.528 2 2 0 0 1-.337.117l-.01.002L2 9.122v.628h2.402a3.3 3.3 0 0 0 .42-.415c.509-.601.654-1.345.686-2.009.026-.527-.019-1.094-.058-1.592q-.015-.18-.026-.347c-.044-.621-.044-1.067.048-1.377a.63.63 0 0 1 .149-.276.64.64 0 0 1 .312-.157c.13-.032.323-.054.513-.066a6 6 0 0 1 .286-.01h.015L6.75 3.5h.75V2h-.75zm0 14v.75h-.035a7 7 0 0 1-.363-.014 4.6 4.6 0 0 1-.785-.109 2.13 2.13 0 0 1-1.008-.55 2.1 2.1 0 0 1-.524-.907c-.181-.608-.15-1.314-.108-1.912l.031-.41c.038-.486.073-.93.052-1.352-.025-.527-.136-.879-.333-1.112a2 2 0 0 0-.718-.528 2 2 0 0 0-.337-.117l-.01-.002L2 10.378V9.75h2.402q.218.178.42.416c.509.6.654 1.344.686 2.008.026.527-.019 1.095-.058 1.592q-.015.18-.026.347c-.044.621-.044 1.067.048 1.378a.63.63 0 0 0 .149.275.64.64 0 0 0 .312.157c.13.032.323.054.513.066a6 6 0 0 0 .286.01l.015.001H7.5v1.5h-.75z\"/></svg>";
var $e8dc502aba5ac3f5$export$3feafef056916dd7 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m9.586 14.633.021.004q-.054.502.393.962.123.125.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15q.711-.106 1.005-.334.235-.182.404-.597l2.416-9.55a1.05 1.05 0 0 0-.281-.823 1.1 1.1 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195q-.564.084-.823.296-.323.263-.623.79z\"/></svg>";
var $e8dc502aba5ac3f5$export$4465df3ce5678da4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".16\" d=\"M35 20a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H15.5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M8.508 9.561q.567-.44.778-1.03h1.004V15H9.053v-4.654a4.3 4.3 0 0 1-1.595.936v-1.121q.483-.158 1.05-.6m4.525 4.204V15h-1.235v-1.235zm1.299 10.204v-6.47h-1.004q-.21.59-.778 1.03-.567.444-1.05.6v1.122a4.3 4.3 0 0 0 1.595-.936v4.654zm2.743 0v-1.235H15.84v1.235zm4.099 0v-6.47H20.17q-.21.59-.778 1.03-.567.444-1.05.6v1.122a4.3 4.3 0 0 0 1.595-.936v4.654zm2.743 0v-1.235h-1.235v1.235zM19.032 27.5v6.469h-1.237v-4.654a4.3 4.3 0 0 1-1.595.936V29.13q.483-.158 1.05-.6.568-.44.778-1.03zm2.743 5.234v1.235H20.54v-1.235zm4.357 1.335v-6.47h-1.004q-.21.59-.778 1.03-.567.444-1.05.6v1.122a4.3 4.3 0 0 0 1.595-.936v4.654zm2.743 0v-1.235H27.64v1.235zm4.357 0v-6.47h-1.004q-.21.59-.778 1.03-.567.444-1.05.6v1.122a4.3 4.3 0 0 0 1.595-.936v4.654zm2.743 0v-1.235H34.74v1.235z\"/></svg>";
var $e8dc502aba5ac3f5$export$8336ca915e22e66d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m17.975 15.279.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825q0-.063.002-.123l-.77.77L15 4.765 17.196 2.5l2.265 2.265-.707.707-.782-.782q.003.065.003.135zM1 15.75c0 .414.273.75.61.75h8.067a.56.56 0 0 0 .43-.22.85.85 0 0 0 .18-.53.85.85 0 0 0-.18-.53.56.56 0 0 0-.43-.22H1.609a.56.56 0 0 0-.43.22.85.85 0 0 0-.179.53m0-12c0 .414.273.75.61.75h11.78a.56.56 0 0 0 .431-.22.85.85 0 0 0 .179-.53.85.85 0 0 0-.178-.53.56.56 0 0 0-.431-.22H1.609a.56.56 0 0 0-.43.22.85.85 0 0 0-.179.53m0 4c0 .414.273.75.61.75h11.78a.56.56 0 0 0 .431-.22.85.85 0 0 0 .179-.53.85.85 0 0 0-.178-.53.56.56 0 0 0-.431-.22H1.609a.56.56 0 0 0-.43.22.85.85 0 0 0-.179.53m0 4c0 .414.273.75.61.75h11.78a.56.56 0 0 0 .431-.22.85.85 0 0 0 .179-.53.85.85 0 0 0-.178-.53.56.56 0 0 0-.431-.22H1.609a.56.56 0 0 0-.43.22.85.85 0 0 0-.179.53\"/></svg>";
var $e8dc502aba5ac3f5$export$23da1e9f164f7ea1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.8.8 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.7.7 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294zm5.494-5.335a.8.8 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.8.8 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955m-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184\"/></svg>";
var $e8dc502aba5ac3f5$export$20b3a853460b572d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4\"/></svg>";
var $e8dc502aba5ac3f5$export$c720d164e64a9c5d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M5.714 15.11q.935 0 1.46-.66.632-.799.632-2.627 0-1.832-.629-2.624-.527-.668-1.463-.668t-1.459.66q-.633.8-.633 2.619 0 1.854.576 2.577.577.723 1.516.723m0-1.024a.6.6 0 0 1-.398-.14q-.173-.141-.287-.565-.115-.424-.115-1.558c0-1.134.043-1.294.128-1.613q.096-.37.272-.512a.62.62 0 0 1 .4-.143.6.6 0 0 1 .398.143q.173.143.288.567t.114 1.558c0 1.134-.043 1.292-.128 1.608q-.096.37-.272.512a.62.62 0 0 1-.4.143m6.078.914V8.531H10.79q-.21.59-.778 1.03-.567.442-1.05.6v1.121a4.3 4.3 0 0 0 1.595-.936V15zm3.344 0v-1.235h-1.235V15zm-9.422 9.11q.935 0 1.46-.66.632-.799.632-2.627 0-1.833-.629-2.624-.527-.668-1.463-.668t-1.459.66q-.633.8-.633 2.619 0 1.854.576 2.577.577.723 1.516.723m0-1.024a.6.6 0 0 1-.398-.14q-.173-.142-.287-.565-.115-.424-.115-1.558c0-1.134.043-1.294.128-1.613q.096-.37.272-.512a.62.62 0 0 1 .4-.143.6.6 0 0 1 .398.143q.173.142.288.567t.114 1.558c0 1.134-.043 1.292-.128 1.608q-.096.37-.272.512a.62.62 0 0 1-.4.143m7.088.914v-1.147H10.35q.097-.167.253-.343.155-.175.74-.712t.81-.821q.338-.431.493-.824.156-.394.156-.829 0-.765-.544-1.279-.546-.514-1.499-.514-.87 0-1.45.444t-.69 1.463l1.23.124q.036-.54.264-.774t.615-.233q.391 0 .613.222t.222.635q0 .374-.255.756-.189.277-1.024 1.055-1.037.962-1.388 1.544-.352.583-.422 1.233zm2.334 0v-1.235h-1.235V24zM5.714 34.11q.935 0 1.46-.66.632-.799.632-2.627 0-1.832-.629-2.624-.527-.668-1.463-.668t-1.459.66q-.633.8-.633 2.619 0 1.854.576 2.577.577.723 1.516.723m0-1.024a.6.6 0 0 1-.398-.14q-.173-.142-.287-.565-.115-.424-.115-1.558c0-1.134.043-1.294.128-1.613q.096-.37.272-.512a.62.62 0 0 1 .4-.143.6.6 0 0 1 .398.143q.173.142.288.567t.114 1.558c0 1.134-.043 1.292-.128 1.608q-.096.37-.272.512a.62.62 0 0 1-.4.143m4.992 1.024q.924 0 1.543-.598.62-.597.62-1.446 0-.585-.332-.997a1.5 1.5 0 0 0-.886-.532q.927-.505.927-1.353 0-.598-.452-1.073-.55-.58-1.46-.58a2.25 2.25 0 0 0-.96.2 1.6 1.6 0 0 0-.667.55q-.24.349-.359.933l1.139.194q.048-.422.272-.642t.54-.22q.321 0 .515.194c.194.194.193.302.193.518q0 .383-.264.613-.263.231-.764.218l-.136 1.006q.33-.092.566-.092.36 0 .611.272.25.273.25.739 0 .492-.26.782a.83.83 0 0 1-.644.29.84.84 0 0 1-.607-.242q-.25-.241-.308-.698l-1.195.145q.093.813.668 1.316t1.45.503m4.43-.11v-1.235h-1.235V34z\"/></svg>";
var $e8dc502aba5ac3f5$export$74e351a6539a1711 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M10.29 15V8.531H9.286q-.21.59-.778 1.03-.567.442-1.05.6v1.121a4.3 4.3 0 0 0 1.595-.936V15h1.235zm3.343 0v-1.235h-1.235V15zM11.3 24v-1.147H8.848q.096-.167.252-.343.156-.175.74-.712.585-.536.81-.821.338-.431.494-.824.156-.394.156-.829 0-.765-.545-1.279t-1.499-.514q-.87 0-1.45.444t-.69 1.463l1.23.124q.036-.54.264-.774.23-.233.616-.233.39 0 .613.222t.222.635q0 .374-.255.756-.19.277-1.024 1.055-1.038.962-1.389 1.544T6.971 24zm2.333 0v-1.235h-1.235V24zM9.204 34.11q.922 0 1.542-.598.62-.597.62-1.446 0-.585-.332-.997a1.5 1.5 0 0 0-.886-.532q.928-.505.928-1.353 0-.598-.453-1.073-.549-.58-1.459-.58a2.25 2.25 0 0 0-.96.2 1.6 1.6 0 0 0-.668.55q-.24.349-.358.933l1.138.194q.048-.422.272-.642t.54-.22q.322 0 .515.194c.193.194.193.302.193.518q0 .383-.263.613-.263.231-.765.218l-.136 1.006q.33-.092.567-.092.36 0 .61.272.251.273.251.739 0 .492-.261.782a.83.83 0 0 1-.644.29.84.84 0 0 1-.607-.242q-.251-.241-.307-.698l-1.196.145q.093.813.668 1.316t1.45.503zm4.43-.11v-1.235h-1.236V34h1.235z\"/></svg>";
var $e8dc502aba5ac3f5$export$fc09f3e2a4c01af2 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6\"/></svg>";
var $e8dc502aba5ac3f5$export$c3c2f8ecd2b13747 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M9.62 14.105q.408 0 .768-.153c.36-.153.466-.257.677-.462q.013.036.044.145.07.242.119.365h1.221a2.7 2.7 0 0 1-.222-.626q-.06-.293-.059-.908l.013-1.441q0-.804-.165-1.105-.165-.302-.569-.497-.405-.195-1.23-.195-.91 0-1.371.325-.462.325-.65 1.002l1.12.202q.114-.326.299-.455.184-.13.514-.13.488 0 .663.152.176.151.176.508v.123q-.333.14-1.2.303-.641.123-.982.288t-.53.474a1.33 1.33 0 0 0-.188.706q0 .598.415.988.416.391 1.136.391zm.368-.87a.68.68 0 0 1-.492-.189.6.6 0 0 1-.193-.448q0-.263.241-.435.159-.105.673-.215a7 7 0 0 0 .751-.19v.247q0 .443-.048.602a.77.77 0 0 1-.295.409 1.07 1.07 0 0 1-.637.22zm4.645.765v-1.235h-1.235V14zM10.2 25.105q.813 0 1.382-.646.57-.645.57-1.84 0-1.156-.559-1.774a1.82 1.82 0 0 0-1.41-.617q-.783 0-1.354.65v-2.32H7.594V25h1.147v-.686a1.9 1.9 0 0 0 .67.592q.39.2.79.2zm-.299-.975q-.531 0-.852-.492-.23-.348-.229-1.073 0-.703.295-1.048a.93.93 0 0 1 .738-.345q.453 0 .743.354t.29 1.154q0 .751-.288 1.1t-.697.35m4.478.87v-1.235h-1.234V25zm-4.017 9.105q.9 0 1.437-.426.536-.426.725-1.261l-1.213-.207q-.092.489-.316.688a.83.83 0 0 1-.576.2.92.92 0 0 1-.75-.343q-.278-.343-.278-1.173 0-.747.274-1.066.275-.318.736-.318.348 0 .565.184t.28.55l1.216-.22q-.22-.751-.722-1.119-.504-.366-1.356-.366-1.042 0-1.653.643-.61.645-.61 1.8 0 1.143.608 1.788.609.646 1.633.646M14.633 34v-1.235h-1.235V34z\"/></svg>";
var $e8dc502aba5ac3f5$export$7b30e2981f4a59e2 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M11.88 8.7V7.558h-1.234V8.7zm0 5.3V9.333h-1.234V14zm2.5 0v-1.235h-1.234V14zm-4.75 4.7v-1.142H8.395V18.7zm0 5.3v-4.667H8.395V24zm2.5-5.3v-1.142h-1.234V18.7zm0 5.3v-4.667h-1.234V24zm2.501 0v-1.235h-1.235V24zM7.38 28.7v-1.142H6.145V28.7zm0 5.3v-4.667H6.145V34zm2.5-5.3v-1.142H8.646V28.7zm0 5.3v-4.667H8.646V34zm2.5-5.3v-1.142h-1.234V28.7zm0 5.3v-4.667h-1.234V34zm2.501 0v-1.235h-1.235V34z\"/></svg>";
var $e8dc502aba5ac3f5$export$e0694167faa6e519 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M14 27v6H8v-6zm0-9v6H8v-6zm0-9v6H8V9z\"/></svg>";
var $e8dc502aba5ac3f5$export$6d77053cfbac4c75 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"m7.88 15 .532-1.463h2.575L11.549 15h1.415l-2.58-6.442H9.01L6.5 15zm2.69-2.549H8.811l.87-2.39.887 2.39zM14.88 15v-1.235h-1.234V15zM9.352 25q1.244-.009 1.569-.044.518-.057.872-.305.354-.249.558-.664t.205-.855q0-.558-.317-.97-.315-.414-.905-.585a1.5 1.5 0 0 0 .661-.567 1.5 1.5 0 0 0 .244-.83q0-.419-.197-.754a1.65 1.65 0 0 0-.495-.539 1.7 1.7 0 0 0-.672-.266q-.375-.063-1.14-.063H7.158V25zm.142-3.88H8.46v-1.49h.747q.918 0 1.112.022.325.04.49.226.165.188.165.486a.68.68 0 0 1-.192.503.86.86 0 0 1-.525.23 12 12 0 0 1-.944.023h.18zm.17 2.795H8.46v-1.723h1.05q.888 0 1.154.092.266.093.406.295a.84.84 0 0 1 .14.492q0 .342-.181.547a.8.8 0 0 1-.473.257q-.189.04-.892.04M14.88 25v-1.235h-1.234V25zm-5.018 9.11q1.037 0 1.711-.512t.965-1.567l-1.261-.4q-.163.708-.536 1.037-.375.33-.892.33-.704 0-1.143-.519-.44-.518-.44-1.74 0-1.15.447-1.665.445-.514 1.162-.514.52 0 .881.29.362.29.477.79l1.288-.307q-.22-.774-.66-1.187-.738-.698-1.92-.698-1.353 0-2.184.89-.83.89-.83 2.498 0 1.521.825 2.397.826.877 2.11.877M14.88 34v-1.235h-1.234V34z\"/></svg>";
var $e8dc502aba5ac3f5$export$66cbb0c8ed453255 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><path fill-opacity=\".163\" d=\"M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\"/><path d=\"M11.916 15V8.558h-1.301V15zm2.465 0v-1.235h-1.235V15zM9.665 25v-6.442h-1.3V25zm2.5 0v-6.442h-1.3V25zm2.466 0v-1.235h-1.235V25zm-7.216 9v-6.442h-1.3V34zm2.5 0v-6.442h-1.3V34zm2.501 0v-6.442h-1.3V34zm2.465 0v-1.235h-1.235V34z\"/></svg>";
var $e8dc502aba5ac3f5$export$def316efafc017e5 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"><path fill-opacity=".163" d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z"/><path d="M14.88 15v-1.235h-1.234V15zm0 10v-1.235h-1.234V25zm0 9v-1.235h-1.234V34z"/><text x="9" y="15" font-family="sans-serif" font-size="8" font-weight="bold" text-anchor="middle">\u0661</text><text x="9" y="25" font-family="sans-serif" font-size="8" font-weight="bold" text-anchor="middle">\u0662</text><text x="9" y="34" font-family="sans-serif" font-size="8" font-weight="bold" text-anchor="middle">\u0663</text></svg>';
var $e8dc502aba5ac3f5$export$6d84f37d8e2f5929 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M4.2 3c-.584 0-1.145.23-1.557.643A2.2 2.2 0 0 0 2 5.199v8.719a2.194 2.194 0 0 0 2.2 2.195h11.624a2.194 2.194 0 0 0 2.196-2.195V7.621a2.194 2.194 0 0 0-2.195-2.2h-5.393l-1.237-2.06A.75.75 0 0 0 8.56 3zm0 1.488h3.935l1.236 2.06a.75.75 0 0 0 .64.362h5.813a.71.71 0 0 1 .707.71v6.298a.707.707 0 0 1-.707.707H4.2a.71.71 0 0 1-.71-.707V5.199a.71.71 0 0 1 .71-.71Z\"/></svg>";
var $e8dc502aba5ac3f5$export$bfc5043f33fb4eee = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 1c3.314 0 5.8 2.686 5.8 6v1.9l.303.005c.504.052.897.478.897.995v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8c0-.517.393-.943.897-.995L4.2 8.9V7c0-3.314 2.486-6 5.8-6m0 1.5C7.515 2.5 5.7 4.515 5.7 7v1.9h8.6V7c0-2.485-1.815-4.5-4.3-4.5\"/></svg>";
var $e8dc502aba5ac3f5$export$a753bdb7a147cf80 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m12.68 13.74 4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474M13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0\"/></svg>";
var $e8dc502aba5ac3f5$export$a4b4e00a05330141 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.1 11.1 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.5.5 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304q-.387.166-.757.365l6.239 6.24-.006.005.78.78q-.582.141-1.174.215l-1.11-1.11h.011L4.55 8.197a7 7 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10 10 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a3 3 0 0 0-.124.2q-.065.116-.108.241a.5.5 0 0 0-.028.133.3.3 0 0 0 .008.072 1 1 0 0 0 .082.226q.1.2.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93m7.07.531a4.63 4.63 0 0 1 1.108 5.992l.345.344.046-.018a9.3 9.3 0 0 0 2-1.112q.385-.281.727-.613.207-.2.392-.431.109-.135.203-.286.086-.14.148-.292a1 1 0 0 0 .036-.12.3.3 0 0 0 .008-.072.5.5 0 0 0-.028-.133 1 1 0 0 0-.036-.096 2 2 0 0 0-.071-.145 3 3 0 0 0-.125-.2 4 4 0 0 0-.263-.335 5.4 5.4 0 0 0-.53-.523 8 8 0 0 0-1.054-.768 9.8 9.8 0 0 0-1.879-.891q-.506-.178-1.027-.301m-2.85.21-.069.002a.5.5 0 0 0-.254.097.496.496 0 0 0-.104.679.5.5 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.49.49 0 0 0 .45.287h.008a.5.5 0 0 0 .35-.158.48.48 0 0 0 .13-.335.6.6 0 0 0-.048-.219 3.4 3.4 0 0 0-.36-.723 3.44 3.44 0 0 0-2.791-1.543l-.028-.001z\"/></svg>";
var $e8dc502aba5ac3f5$export$954e6fcf1af69108 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15.346 9.422a.151.151 0 0 1 .284 0l.548 1.484a.15.15 0 0 0 .09.089l1.483.549a.151.151 0 0 1 0 .284l-1.483.548a.15.15 0 0 0-.09.09l-.548 1.483a.15.15 0 0 1-.142.1.15.15 0 0 1-.142-.1l-.549-1.483a.15.15 0 0 0-.09-.09l-1.483-.548a.15.15 0 0 1 0-.284l1.484-.549a.15.15 0 0 0 .089-.09zm.96-7.68a.151.151 0 0 1 .284 0l.549 1.483a.15.15 0 0 0 .089.09l1.483.548a.15.15 0 0 1 .072.229.15.15 0 0 1-.072.055l-1.483.549a.15.15 0 0 0-.09.09l-.548 1.482a.151.151 0 0 1-.284 0l-.549-1.483a.15.15 0 0 0-.09-.09l-1.483-.548a.151.151 0 0 1 0-.284l1.484-.549a.15.15 0 0 0 .09-.089zm-8.641 0a.151.151 0 0 1 .284 0l.549 1.483a.15.15 0 0 0 .09.09l1.482.548a.15.15 0 0 1 .072.229.15.15 0 0 1-.072.055l-1.483.549a.15.15 0 0 0-.09.09L7.95 6.267a.151.151 0 0 1-.284 0l-.549-1.483a.15.15 0 0 0-.089-.09l-1.483-.548a.151.151 0 0 1 0-.284l1.483-.549a.15.15 0 0 0 .09-.089l.548-1.483zm7.055 6.204a.85.85 0 0 0 .25-.591.82.82 0 0 0-.241-.588l-1.943-1.938a.8.8 0 0 0-.588-.241.84.84 0 0 0-.591.25l-1.545 1.539 3.115 3.115z\"/><path d=\"M1.19 15.636a.96.96 0 0 1 .281-.679l7.835-7.834 3.121 3.12-7.834 7.835a.96.96 0 0 1-1.358 0l-1.764-1.764a.96.96 0 0 1-.28-.678Zm9.22-5.391-1.121-1.12-6.479 6.478 1.121 1.121z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$e3e30194a664a060 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.798 1.59 3.002 12.875l1.895 1.852 2.521 1.402 6.997-12.194z\" class=\"ck-icon__fill\"/><path d=\"m2.556 16.727.234-.348q-.445-.226-.498-.426-.054-.206.115-.837.14-.375.169-.595a4.5 4.5 0 0 0 0-.725q-.313-.931-.284-1.26.03-.327.475-.862l6.77-9.414q.808-1.365 3.199.18 2.39 1.549 1.784 2.686l-5.877 10.36q-.237.618-.526.782-.29.163-1.232.21-.543.196-.738.318t-.526.47q-.44.397-.632.397-.143 0-.524-.226l-.31.41zm-.279.415 1.575 1.103-.392.515H1.19zm8.1-13.656-4.953 6.9L8.75 12.57l4.247-7.574q.263-.375-1.092-1.192-1.354-.819-1.528-.32zM8.244 18.5 9.59 17h9.406v1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$217583bb4605c9c3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M16.754 2.501a.75.75 0 0 1 .75.75v5.2a.75.75 0 1 1-1.5 0V5.06L11.98 9.086a.75.75 0 0 1-1.061-1.061L14.943 4h-3.389a.75.75 0 0 1 0-1.5zM3.25 17.504a.75.75 0 0 1-.75-.75v-5.2a.75.75 0 0 1 1.5 0v3.39l4.023-4.023a.75.75 0 1 1 1.061 1.06l-4.023 4.023H8.45a.75.75 0 0 1 0 1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$55c39fa63267dcf8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 42\"><path d=\"M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098s-4.538-.083-4.538-1.678 2.032-3.43 4.538-4.098c.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556L49 17zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.99 1.99 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17m29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155zM20.6 21.375v1.616h1.616v-1.616zm0 3.231v1.616h1.616v-1.616zm0 3.231v1.616h1.616v-1.616zm0 3.231v1.616h1.616v-1.616zm0 3.231v1.616h1.616v-1.616zm0 3.231v1.616h1.616V37.53zm24.233-16.155v1.616h1.615v-1.616zm0 3.231v1.616h1.615v-1.616zm0 3.231v1.616h1.615v-1.616zm0 3.231v1.616h1.615v-1.616zm0 3.231v1.616h1.615v-1.616zm0 3.231v1.616h1.615V37.53zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35z\"/></svg>";
var $e8dc502aba5ac3f5$export$6819bb515dea7c36 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\"><path d=\"M1.587 1.5c-.612 0-.601-.029-.601.551v14.84c0 .59-.01.559.591.559h18.846c.602 0 .591.03.591-.56V2.052c0-.58.01-.55-.591-.55H1.587Zm.701.971h1.003v1H2.288zm16.448 0h1.003v1h-1.003zm-14.24 1h13.008v12H4.467zm-2.208 1h1.003v1H2.288zm16.448 0h1.003v1h-1.003zm-16.448 2h1.003v1H2.288zm16.448 0h1.003v1h-1.003zm-16.448 2h1.003v1H2.288zm16.448 0h1.003v1h-1.003zm-16.448 2h1.003v1H2.288zm16.448 0h1.003v1h-1.003zm-16.448 2h1.003l-.029 1h-.974zm16.448 0h1.003v1h-1.003zm-16.448 2h.974v1h-.974zm16.448 0h1.003v1h-1.003z\"/><path d=\"M8.374 6.648a.4.4 0 0 1 .395-.4.4.4 0 0 1 .2.049l5.148 2.824a.4.4 0 0 1 0 .7l-5.148 2.824a.403.403 0 0 1-.595-.35z\"/></svg>";
var $e8dc502aba5ac3f5$export$a34b984f72eb4aab = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.45 9.304a.75.75 0 0 1-.75-.75v-5.2a.75.75 0 0 1 1.5 0v3.39l4.023-4.023a.75.75 0 0 1 1.06 1.06l-4.022 4.023h3.389a.75.75 0 0 1 0 1.5zm-2.896 1.397a.75.75 0 0 1 .75.75v5.2a.75.75 0 0 1-1.5 0v-3.39L3.78 17.286a.75.75 0 1 1-1.06-1.061l4.022-4.023H3.354a.75.75 0 0 1 0-1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$74eeff1f56a2ac9e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7.85 6.5a.75.75 0 0 1 0-1.5h9.5a.75.75 0 1 1 0 1.5zM3 8V2.7H.5v1h1V8zm10.42 6.185a.75.75 0 0 0 .53 1.28h3.4a.75.75 0 1 0 0-1.5h-3.4a.75.75 0 0 0-.53.22m-7.784-6.15V6.8H4.4v1.235zM9 17.865v-5.3H6.5v1h1v4.3zm2.636.035v-1.235H10.4V17.9zM3.2 17.865v-5.3H.7v1h1v4.3zm2.636.035v-1.235H4.6V17.9z\"/></svg>";
var $e8dc502aba5ac3f5$export$ce5b94cabe8af42c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382z\"/></svg>";
var $e8dc502aba5ac3f5$export$918ed117a955e214 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0m1 15H9v-2h2zm0-4H9V5h2z\"/></svg>";
var $e8dc502aba5ac3f5$export$8cf58c969bb2bf96 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75M3.5 3v5H2V3.7H1v-1h2.5zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001q-.073.607-.333.988-.263.381-1.244 1.312H4.3v1h-4zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75\"/></svg>";
var $e8dc502aba5ac3f5$export$bb4e522eef459e3d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm0 12h16v1.5H2z\" opacity=\".5\"/><path d=\"M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H6.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$4385231065a264c8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm0 12h16v1.5H2z\" opacity=\".5\"/><path d=\"M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1m-1.505.5H3.504V12h12.991z\"/></svg>";
var $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z\" opacity=\".5\"/><path d=\"M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H3.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$5fcb2c20a0a41738 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z\" opacity=\".5\"/><path d=\"M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H9.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$de8b7d50233806bc = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z\" opacity=\".5\"/><path d=\"M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H3.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$109641c0512af225 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm0 12h16v1.5H2z\" opacity=\".5\"/><path d=\"M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H3.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$12c57266ee03e50a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3h16v1.5H2zm0 12h16v1.5H2z\" opacity=\".5\"/><path d=\"M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1m-1.506.5H9.5V12h6.997z\"/></svg>";
var $e8dc502aba5ac3f5$export$8877d472d8bae6e3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M.95 1.43a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h.75v6.3H.95a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-.65h1.932l1.539-1.5H5v-.95a.95.95 0 0 0-.95-.95H3.2v-6.3h.85A.95.95 0 0 0 5 5.48v-.55h10v.55a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-3.1a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95v1.05H5V2.38a.95.95 0 0 0-.95-.95zm.55 3.5v-2h2v2zm0 9.3v2h2v-2zm15-11.3v2h2v-2zM8.139 20.004v-2.388l7.045-7.048 2.391 2.391-7.046 7.046zm11.421-9.101a.6.6 0 0 1-.138.206l-1.165 1.168-2.391-2.391 1.167-1.163a.6.6 0 0 1 .206-.138.6.6 0 0 1 .243-.049.63.63 0 0 1 .449.187l1.491 1.488c.059.059.108.129.138.206s.049.16.049.243a.6.6 0 0 1-.049.243\"/></svg>";
var $e8dc502aba5ac3f5$export$76e3fa0e80a872d8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 17v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zM1 15.5v1H0v-1zm19 0v1h-1v-1zm-19-2v1H0v-1zm19 0v1h-1v-1zm-19-2v1H0v-1zm19 0v1h-1v-1zm-19-2v1H0v-1zm19 0v1h-1v-1zm-19-2v1H0v-1zm19 0v1h-1v-1zm-19-2v1H0v-1zm19 0v1h-1v-1zm0-2v1h-1v-1zm-19 0v1H0v-1zM14.5 2v1h-1V2zm2 0v1h-1V2zm2 0v1h-1V2zm-8 0v1h-1V2zm-2 0v1h-1V2zm-2 0v1h-1V2zm-2 0v1h-1V2zm8 0v1h-1V2zm-10 0v1h-1V2z\"/><path d=\"M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2m0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.49.49 0 0 1-.476-.5V4c0-.276.213-.5.476-.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$62e00d4298f7a20b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 16.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zM1 15v1H0v-1zm19 0v1h-1v-1zM1 13v1H0v-1zm19 0v1h-1v-1zM1 11v1H0v-1zm19 0v1h-1v-1zM1 9v1H0V9zm19 0v1h-1V9zM1 7v1H0V7zm19 0v1h-1V7zM1 5v1H0V5zm19 0v1h-1V5zm0-2v1h-1V3zM1 3v1H0V3zm13.5-1.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm-8 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm8 0v1h-1v-1zm-10 0v1h-1v-1z\"/><path d=\"M13 5.5H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2M13 7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 2 7z\"/></svg>";
var $e8dc502aba5ac3f5$export$d617f0cc61264eda = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 16.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zM1 15v1H0v-1zm19 0v1h-1v-1zM1 13v1H0v-1zm19 0v1h-1v-1zM1 11v1H0v-1zm19 0v1h-1v-1zM1 9v1H0V9zm19 0v1h-1V9zM1 7v1H0V7zm19 0v1h-1V7zM1 5v1H0V5zm19 0v1h-1V5zm0-2v1h-1V3zM1 3v1H0V3zm13.5-1.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm-8 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm8 0v1h-1v-1zm-10 0v1h-1v-1z\"/><path d=\"M10 7.5H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2M10 9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 2 9z\"/></svg>";
var $e8dc502aba5ac3f5$export$d5ebd621e65c3406 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 16.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zM1 15v1H0v-1zm19 0v1h-1v-1zM1 13v1H0v-1zm19 0v1h-1v-1zM1 11v1H0v-1zm19 0v1h-1v-1zM1 9v1H0V9zm19 0v1h-1V9zM1 7v1H0V7zm19 0v1h-1V7zM1 5v1H0V5zm19 0v1h-1V5zm0-2v1h-1V3zM1 3v1H0V3zm13.5-1.5v1h-1v-1zm2 0v1h-1v-1zm2 0v1h-1v-1zm-8 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1zm8 0v1h-1v-1zm-10 0v1h-1v-1z\"/><path d=\"M7 9.5H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M7 11a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4A.5.5 0 0 1 2 11z\"/></svg>";
var $e8dc502aba5ac3f5$export$d1a0834971add62c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.223 5.001a5.28 5.28 0 0 0-4.408 2.258c-3.224.423-4.908 4.123-3.032 6.814l.004.008.002.004c.48.627 1.712 1.84 3.588 1.84h7.936c.667 0 1.32-.179 1.894-.522a3.84 3.84 0 0 0 1.381-1.46v-.005c1.13-2.16-.133-4.777-2.488-5.298-.617-1.853-2.177-3.242-4.111-3.565a5 5 0 0 0-.766-.074m-.092 1.5a3 3 0 0 1 .23.008c.077.004.154.014.231.021l.226.035a5 5 0 0 1 .45.116 3 3 0 0 1 .433.166 4 4 0 0 1 .606.348 4 4 0 0 1 .37.293 4 4 0 0 1 .33.348 3.5 3.5 0 0 1 .505.778 3 3 0 0 0-.42.117q-.123.044-.244.094l-1.49.627-2.686-1.61a4.4 4.4 0 0 0-1.002-.445c.015-.01.032-.026.047-.039a4 4 0 0 1 .4-.289 4 4 0 0 1 .424-.23 3 3 0 0 1 .219-.094q.112-.043.225-.076a4 4 0 0 1 .222-.06q.117-.029.233-.05.112-.022.228-.033.115-.011.233-.02.116-.005.23-.005m-3.8 2.193h.003c.54.001 1.111.156 1.551.428l1.783 1.07-5.867 2.471c-.535-1.29-.15-2.788 1.059-3.537l.007-.004a2.9 2.9 0 0 1 1.463-.428Zm7.974 1.33.152.008q.13.011.258.033a2 2 0 0 1 .477.145 2.2 2.2 0 0 1 .918.756q.07.1.127.2a2.3 2.3 0 0 1 .269.919c.004.081.008.165.002.248q-.006.083-.02.166l-3.507-2.102.459-.193.015-.008a2 2 0 0 1 .41-.125 2.3 2.3 0 0 1 .44-.047m-3.008 1.112 4.506 2.699a2.2 2.2 0 0 1-.338.26 2.2 2.2 0 0 1-.668.275q-.116.027-.24.04c-.081.007-.164.015-.246.015H6.373a3 3 0 0 1-.168-.004 2 2 0 0 1-.164-.016l-.154-.023q-.077-.01-.15-.026a3 3 0 0 1-.77-.3 3 3 0 0 1-.21-.133c-.012-.008-.019-.016-.03-.024z\"/></svg>";
var $e8dc502aba5ac3f5$export$df711828ef358c9e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1\"/><path d=\"M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052zM11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z\"/></svg>";
var $e8dc502aba5ac3f5$export$d69403c92e089a83 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75m5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75M2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5m1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z\"/></svg>";
var $e8dc502aba5ac3f5$export$610436cce4c8959f = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.598.687h1.5v5h-1.5zm14.5 0h1.5v5h-1.5z\"/><path d=\"M19.598 4.187v1.5h-16v-1.5zm-16 14.569h1.5v-5h-1.5zm14.5 0h1.5v-5h-1.5z\"/><path d=\"M19.598 15.256v-1.5h-16v1.5zM5.081 9h6v2h-6zm8 0h6v2h-6zm-9.483 1L0 12.5v-5z\"/></svg>";
var $e8dc502aba5ac3f5$export$ca13467524a7577f = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"2 2 56 18\"><path d=\"m12.527 14.733-.514.022-.057-.057-.058-.058.006-2.44.007-2.44-.834-.023-.833-.022.023-.406.024-.405.536-.1.536-.098.25-.145.25-.145.17-.429.172-.428.399-.024.398-.023v7.08l.02.059.02.059zm17.894.016h-.457l.043-.138.043-.137.635-2.004.636-2.004.437-1.375.436-1.375.055-.196.054-.197.38-.024.378-.024.07.069.07.07-1.162 3.667-1.16 3.667zm11.733 0h-.55V9.72h-1.65v-.864h.385l.4-.086.398-.086.233-.195.232-.196.138-.386.137-.387h.827v7.229zm6.404 0h-.51V13.02h-3.143v-1.01l1.044-1.44 1.045-1.44.59-.824.592-.825h.854l.02 2.298.021 2.298h1.02v.943H49.07v1.729zM47 12.06l1.008-.022.022-1.4.021-1.401-.07.044-.07.043-.901 1.279-.901 1.278-.058.1-.059.101zM12.256 22.893l-10.53.01-.157-.038-.157-.038-.255-.12L.9 22.59v-.19l.228-.218.228-.218.16.086.16.085h20.922l.16-.085.16-.086.228.218.227.218v.189l-.294.146-.295.147z\"/></svg>";
var $e8dc502aba5ac3f5$export$dea691ed7a8176cf = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 20\"><mask id=\"a\" width=\"17\" height=\"18\" x=\"13\" y=\"1\" maskUnits=\"userSpaceOnUse\"><path d=\"M13 1h17v18H13z\"/><path d=\"M14 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1z\"/><path d=\"M27 3.25a1.5 1.5 0 0 1 1.5 1.5v1.7a2.25 2.25 0 0 1-1.932 2.226l-4.424.632a.75.75 0 0 0-.644.743V11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H20a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-.95a2.25 2.25 0 0 1 1.932-2.226l4.424-.632A.75.75 0 0 0 27 6.449z\"/></mask><path d=\"M14 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1z\"/><path d=\"M27 3.25a1.5 1.5 0 0 1 1.5 1.5v1.7a2.25 2.25 0 0 1-1.932 2.226l-4.424.632a.75.75 0 0 0-.644.743V11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H20a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-.95a2.25 2.25 0 0 1 1.932-2.226l4.424-.632A.75.75 0 0 0 27 6.449z\"/><path d=\"M14 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1z\" mask=\"url(#a)\"/><path d=\"M27 3.25a1.5 1.5 0 0 1 1.5 1.5v1.7a2.25 2.25 0 0 1-1.932 2.226l-4.424.632a.75.75 0 0 0-.644.743V11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H20a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-.95a2.25 2.25 0 0 1 1.932-2.226l4.424-.632A.75.75 0 0 0 27 6.449z\" mask=\"url(#a)\"/><mask id=\"b\" width=\"12\" height=\"17\" x=\"1.75\" y=\"1.165\" maskUnits=\"userSpaceOnUse\"><path d=\"M1.75 1.165h12v17h-12z\"/><path d=\"m12.25 9.96-9.5-7.795 2 12.124 2.384-2.53 2.75 4.762 1.732-1-2.75-4.763z\"/></mask><path d=\"m12.25 9.96-9.5-7.795 2 12.124 2.384-2.53 2.75 4.762 1.732-1-2.75-4.763z\"/><path d=\"m12.25 9.96-9.5-7.795 2 12.124 2.384-2.53 2.75 4.762 1.732-1-2.75-4.763z\" mask=\"url(#b)\"/></svg>";
var $e8dc502aba5ac3f5$export$87bd6c139408b9be = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 20\" width=\"30\" height=\"20\">\n  <path d=\"M14 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1V3Z\" fill=\"#000\"/>\n  <path d=\"M27 3.25a1.5 1.5 0 0 1 1.5 1.5v1.7a2.25 2.25 0 0 1-1.932 2.226l-4.424.632a.75.75 0 0 0-.644.743V11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H20a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-.95a2.25 2.25 0 0 1 1.932-2.226l4.424-.632A.75.75 0 0 0 27 6.449V3.25Z\" fill=\"#000\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.855 2.25H27a2.5 2.5 0 0 1 2.5 2.5v1.7a3.25 3.25 0 0 1-2.79 3.216l-4.21.602a2 2 0 0 1 1 1.732v5a2 2 0 0 1-2 2H20a2 2 0 0 1-2-2v-5a2 2 0 0 1 1-1.732v-.217A3.25 3.25 0 0 1 21.129 7H15a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 1.855 1.25ZM20 10.05V11a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1v-.95c0-.016 0-.033.002-.05a.75.75 0 0 1 .642-.692l4.424-.632A2.25 2.25 0 0 0 28.5 6.45V4.75a1.496 1.496 0 0 0-1.5-1.5v3.2a.75.75 0 0 1-.644.742l-4.424.632A2.25 2.25 0 0 0 20 10.05ZM15 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H15Z\" fill=\"#fff\"/>\n  <path d=\"M2.5 2.5A.5.5 0 0 1 3 2h2.5a.5.5 0 0 1 .354.146l.646.647.646-.647A.5.5 0 0 1 7.5 2H10a.5.5 0 0 1 0 1H7.707L7 3.707V10h.5a.5.5 0 0 1 0 1H7v4.793l.707.707H10a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.354-.146l-.646-.647-.646.647a.5.5 0 0 1-.354.146H3a.5.5 0 0 1 0-1h2.293L6 15.793V11h-.5a.5.5 0 0 1 0-1H6V3.707L5.293 3H3a.5.5 0 0 1-.5-.5Z\" fill=\"#000\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m5.793 3.5-.5-.5H3a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .354.146l.145.146.501.5.646-.646A.5.5 0 0 1 7.5 2H10a.5.5 0 0 1 0 1H7.707L7 3.707V10h.5a.5.5 0 0 1 0 1H7v4.793l.707.707H10a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.354-.146l-.646-.647-.5.5-.146.147a.5.5 0 0 1-.354.146H3a.5.5 0 0 1 0-1h2.293L6 15.793V11h-.5a.5.5 0 0 1 0-1H6V3.707L5.793 3.5Zm-.914.5L5 4.121v4.964a1.5 1.5 0 0 0 0 2.83v3.464l-.121.121H3a1.5 1.5 0 0 0 0 3h2.5a1.5 1.5 0 0 0 1-.382 1.5 1.5 0 0 0 1 .382H10a1.5 1.5 0 0 0 0-3H8.121L8 15.379v-3.464a1.5 1.5 0 0 0 0-2.83V4.121L8.121 4H10a1.5 1.5 0 0 0 0-3H7.5a1.5 1.5 0 0 0-1 .382A1.5 1.5 0 0 0 5.5 1H3a1.5 1.5 0 1 0 0 3h1.879Z\" fill=\"#fff\"/>\n</svg>\n";
var $e8dc502aba5ac3f5$export$660c0a8a39d7d45c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z\"/><path d=\"M16 3.25a1.5 1.5 0 0 1 1.5 1.5v1.7a2.25 2.25 0 0 1-1.932 2.226l-4.424.632a.75.75 0 0 0-.644.743V11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1v-.95a2.25 2.25 0 0 1 1.932-2.226l4.424-.632A.75.75 0 0 0 16 6.449z\"/></svg>";
var $e8dc502aba5ac3f5$export$a10fbc76a15d89b0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8.514.5c1.007 0 2.056.352 2.866.96.813.611 1.449 1.539 1.449 2.69v7.8c0 .777-.382 1.457-.888 1.93-.505.474-1.195.8-1.92.82-1.473.04-2.848-1.237-2.848-2.75v-3.7a.75.75 0 0 1 1.5 0v3.7c0 .642.65 1.268 1.306 1.25.312-.008.663-.157.938-.414.274-.256.412-.562.412-.836v-7.8c0-.556-.303-1.08-.85-1.49A3.4 3.4 0 0 0 8.513 2a3.4 3.4 0 0 0-1.946.65c-.556.41-.868.934-.868 1.5v.028l-.001.013-.002.055-.006.212-.02.787c-.015.67-.034 1.605-.046 2.663-.025 2.123-.025 4.729.074 6.704.058 1.155.628 1.948 1.466 2.478.864.547 2.017.81 3.135.81 1.114 0 2.092-.265 2.789-.785.671-.5 1.152-1.286 1.213-2.503a80 80 0 0 0 .074-5.299 82 82 0 0 0-.073-2.283L14.301 7v-.086A.75.75 0 0 1 15.8 6.91v.013l.002.033.005.127c.005.11.013.273.02.48.017.413.035 1.007.048 1.725a82 82 0 0 1-.075 5.4c-.082 1.63-.758 2.843-1.815 3.631-1.032.77-2.358 1.082-3.684 1.082-1.322 0-2.774-.306-3.939-1.044-1.191-.754-2.076-1.962-2.161-3.669-.101-2.024-.101-4.67-.076-6.796.012-1.066.03-2.006.047-2.68.007-.337.015-.608.02-.794l.006-.215.002-.056v-.02c.009-1.162.663-2.082 1.477-2.683A4.9 4.9 0 0 1 8.514.5\"/></svg>";
var $e8dc502aba5ac3f5$export$dd7301757b50d467 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5M5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1\"/></svg>";
var $e8dc502aba5ac3f5$export$20da9dff06d8cce3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m7.3 17.37-.061.088a1.52 1.52 0 0 1-.934.535l-4.178.663-.806-4.153a1.5 1.5 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346zM6.07 16.512l-3.276-2.295.53 2.73zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328M8 18.5 9.375 17H19v1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$738188e7152fb4f8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10.126 2.268 2.002 13.874l1.895 1.852 2.521 1.402L14.47 5.481l-1.543-2.568z\" class=\"ck-icon__fill\"/><path d=\"m4.5 18.088-2.645-1.852-.04-2.95-.006-.005.006-.008v-.025l.011.008L8.73 2.97q.249-.348.567-.557l-1.212.308L4.604 7.9l-.83-.558 3.694-5.495 2.708-.69 1.65 1.145.046.018.85-1.216 2.16 1.512-.856 1.222c.828.967 1.144 2.141.432 3.158L7.55 17.286l.006.005zm-.634.166-1.976.516-.026-1.918zM9.968 3.817l-.006-.004-6.123 9.184 3.277 2.294 6.108-9.162.005.003c.317-.452-.16-1.332-1.064-1.966-.891-.624-1.865-.776-2.197-.349M8.245 18.5 9.59 17h9.406v1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$2f99ec4b9363cd5b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4\"/></svg>";
var $e8dc502aba5ac3f5$export$4b2505a64d1f53bd = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18m3.45-9.872a1 1 0 0 1 0 1.744l-4.96 2.79A1 1 0 0 1 7 12.79V7.21a1 1 0 0 1 1.49-.872z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$7b7ad8f03d93a9da = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1\"/></svg>";
var $e8dc502aba5ac3f5$export$481a525d19bc1a40 = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"9.00037\" cy=\"9.79993\" r=\"1.5\"/>\n<path d=\"M5.75024 2.75005C5.75019 2.00005 5.75006 2.00005 5.75006 2.00005L5.74877 2.00005L5.74647 2.00006L5.73927 2.00009L5.71503 2.0003C5.6947 2.00053 5.66619 2.00098 5.63111 2.00185C5.56123 2.0036 5.46388 2.00707 5.35241 2.01402C5.14095 2.02722 4.83482 2.05536 4.56712 2.12276C4.1703 2.22267 3.82938 2.40399 3.55967 2.67392C3.29221 2.94161 3.1311 3.26001 3.03544 3.5803C2.85401 4.18776 2.8854 4.89393 2.92747 5.49256C2.9373 5.6324 2.94792 5.76849 2.95828 5.90131C2.99629 6.38849 3.03087 6.83163 3.01038 7.25369C2.98475 7.78147 2.87469 8.13279 2.6777 8.3656C2.45517 8.6286 2.1841 8.79405 1.95875 8.89436C1.84756 8.94386 1.75282 8.97509 1.68956 8.99319C1.65813 9.00219 1.63513 9.00776 1.62253 9.01062L1.61304 9.01269L1.00024 9.12173V9.75005H3.4023C3.54579 9.63123 3.68814 9.49364 3.82278 9.33451C4.33087 8.73405 4.47638 7.99036 4.50861 7.32643C4.5342 6.79933 4.48942 6.23163 4.4502 5.73429C4.44071 5.61404 4.43155 5.49785 4.42378 5.3874C4.38011 4.76596 4.37986 4.32043 4.4727 4.00956C4.51418 3.87069 4.56668 3.78828 4.62078 3.73414C4.67264 3.68223 4.76124 3.6207 4.93336 3.57736C5.06269 3.5448 5.25656 3.52293 5.44585 3.51111C5.53475 3.50556 5.61296 3.50277 5.66854 3.50139C5.6962 3.5007 5.71789 3.50036 5.73209 3.5002L5.74748 3.50007L5.75054 3.50005L6.5003 3.5L6.50019 2L5.75006 2.00005L5.75024 2.75005Z\"/>\n<path d=\"M5.75024 16.7501C5.75019 17.5001 5.75006 17.5001 5.75006 17.5001L5.74877 17.5001L5.74647 17.5001L5.73927 17.5L5.71503 17.4998C5.6947 17.4996 5.66619 17.4991 5.63111 17.4983C5.56123 17.4965 5.46388 17.493 5.35241 17.4861C5.14095 17.4729 4.83482 17.4448 4.56712 17.3774C4.1703 17.2774 3.82938 17.0961 3.55967 16.8262C3.29221 16.5585 3.1311 16.2401 3.03544 15.9198C2.85401 15.3124 2.8854 14.6062 2.92747 14.0076C2.9373 13.8677 2.94792 13.7316 2.95828 13.5988C2.99629 13.1116 3.03087 12.6685 3.01038 12.2464C2.98475 11.7186 2.87469 11.3673 2.6777 11.1345C2.45517 10.8715 2.1841 10.7061 1.95875 10.6058C1.84756 10.5563 1.75282 10.525 1.68956 10.5069C1.65813 10.4979 1.63513 10.4924 1.62253 10.4895L1.61304 10.4874L1.00024 10.3784V9.75005H3.4023C3.54579 9.86887 3.68814 10.0065 3.82278 10.1656C4.33087 10.7661 4.47638 11.5098 4.50861 12.1737C4.5342 12.7008 4.48942 13.2685 4.4502 13.7658C4.44071 13.8861 4.43155 14.0023 4.42378 14.1127C4.38011 14.7341 4.37986 15.1797 4.4727 15.4906C4.51418 15.6294 4.56668 15.7118 4.62078 15.766C4.67264 15.8179 4.76124 15.8794 4.93336 15.9228C5.06269 15.9553 5.25656 15.9772 5.44585 15.989C5.53475 15.9945 5.61296 15.9973 5.66854 15.9987C5.6962 15.9994 5.71789 15.9998 5.73209 15.9999L5.74748 16L5.75054 16.0001L6.5003 16.0001L6.50019 17.5001L5.75006 17.5001L5.75024 16.7501Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.2514 2.00005L12.2501 2.00005L11.5 2L11.4999 3.5L12.2496 3.50005L12.2527 3.50007L12.2681 3.5002C12.2823 3.50036 12.304 3.5007 12.3316 3.50139C12.3872 3.50277 12.4654 3.50556 12.5543 3.51111C12.7436 3.52293 12.9375 3.5448 13.0668 3.57736C13.2389 3.6207 13.3275 3.68223 13.3794 3.73414C13.4335 3.78828 13.486 3.87069 13.5275 4.00956C13.6203 4.32043 13.6201 4.76596 13.5764 5.3874C13.5686 5.49785 13.5595 5.61404 13.55 5.73429C13.5108 6.23163 13.466 6.79933 13.4916 7.32643C13.5238 7.99036 13.6693 8.73405 14.1774 9.33451C14.312 9.49364 14.4544 9.63123 14.5979 9.75005C14.4544 9.86887 14.312 10.0065 14.1774 10.1656C13.7121 10.7154 13.5509 11.3854 13.5023 12.0042C13.6011 12.0012 13.7003 11.9997 13.7999 11.9997C14.208 11.9997 14.6093 12.0247 15.0018 12.0729C15.0416 11.6402 15.1479 11.3408 15.3225 11.1345C15.545 10.8715 15.8161 10.7061 16.0414 10.6058C16.1526 10.5563 16.2474 10.525 16.3106 10.5069C16.342 10.4979 16.365 10.4924 16.3776 10.4895L16.3871 10.4874L16.9999 10.3784V9.75005V9.12173L16.3871 9.01269L16.3776 9.01062C16.365 9.00776 16.342 9.00219 16.3106 8.99319C16.2474 8.97509 16.1526 8.94386 16.0414 8.89436C15.8161 8.79405 15.545 8.6286 15.3225 8.3656C15.1255 8.13279 15.0154 7.78147 14.9898 7.25369C14.9693 6.83163 15.0039 6.38849 15.0419 5.90131C15.0523 5.76849 15.0629 5.6324 15.0727 5.49256C15.1148 4.89393 15.1462 4.18776 14.9647 3.5803C14.8691 3.26001 14.708 2.94161 14.4405 2.67392C14.1708 2.40399 13.8299 2.22267 13.433 2.12276C13.1654 2.05536 12.8592 2.02722 12.6478 2.01402C12.5363 2.00707 12.4389 2.0036 12.3691 2.00185C12.334 2.00098 12.3055 2.00053 12.2851 2.0003L12.2609 2.00009L12.2537 2.00006L12.2514 2.00005Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.00335 17.2062L9.00308 17.2065C8.7234 17.5118 8.24919 17.5327 7.94372 17.2532C7.63816 16.9735 7.61716 16.4991 7.89681 16.1935L8.45008 16.6999C7.89681 16.1935 7.89697 16.1934 7.89713 16.1932L7.89751 16.1928L7.89844 16.1918L7.90098 16.189L7.90879 16.1806L7.93517 16.1526C7.95746 16.1292 7.98914 16.0963 8.02971 16.0555C8.11079 15.9738 8.22768 15.8597 8.37644 15.724C8.6732 15.4532 9.10079 15.0927 9.62744 14.7314C10.6647 14.0198 12.1659 13.2499 13.8501 13.2499C15.5343 13.2499 17.0355 14.0198 18.0727 14.7314C18.5994 15.0927 19.027 15.4532 19.3237 15.724C19.4725 15.8597 19.5894 15.9738 19.6705 16.0555C19.711 16.0963 19.7427 16.1292 19.765 16.1526L19.7914 16.1806L19.7992 16.189L19.8017 16.1918L19.8027 16.1928L19.803 16.1932C19.8032 16.1934 19.8034 16.1935 19.2501 16.6999L19.8034 16.1935C20.083 16.4991 20.062 16.9735 19.7565 17.2532C19.4511 17.5326 18.9772 17.5118 18.6975 17.207L18.6971 17.2065L18.6968 17.2062L18.6945 17.2037L18.6783 17.1865C18.6629 17.1704 18.6386 17.1452 18.6059 17.1123C18.5404 17.0463 18.4414 16.9494 18.3127 16.8321C18.0546 16.5966 17.6814 16.282 17.2242 15.9683C16.9805 15.8012 16.7185 15.6381 16.4421 15.4883C16.7016 15.9322 16.8502 16.4487 16.8502 16.9999C16.8502 18.6567 15.5071 19.9999 13.8502 19.9999C12.1934 19.9999 10.8502 18.6567 10.8502 16.9999C10.8502 16.4486 10.9989 15.932 11.2584 15.4881C10.9819 15.6379 10.7198 15.8011 10.476 15.9683C10.0188 16.282 9.64555 16.5966 9.38746 16.8321C9.25879 16.9494 9.15975 17.0463 9.09425 17.1123C9.06153 17.1452 9.03726 17.1704 9.02192 17.1865L9.00572 17.2037L9.00335 17.2062Z\"/>\n<circle cx=\"14.8253\" cy=\"16.1749\" r=\"1.125\" fill=\"white\"/>\n</svg>\n";
var $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z\"/></svg>";
var $e8dc502aba5ac3f5$export$61207fb985d79449 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15 2.5H5v4h10zm-1 1v2H6v-2z\"/><path d=\"M16 5.5a2.5 2.5 0 0 1 2.495 2.336L18.5 8v5a2.5 2.5 0 0 1-2.336 2.495L16 15.5h-1V14h1a1 1 0 0 0 .993-.883L17 13V8a1 1 0 0 0-.883-.993L16 7H4a1 1 0 0 0-.993.883L3 8v5a1 1 0 0 0 .883.993L4 14h1v1.5H4a2.5 2.5 0 0 1-2.495-2.336L1.5 13V8a2.5 2.5 0 0 1 2.336-2.495L4 5.5zM6.5 8a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z\"/><path d=\"M15 12H5v7h10zm-1 1v5H6v-5z\"/><path d=\"M7 14h6v1H7zm0 2h6v1H7z\"/></svg>";
var $e8dc502aba5ac3f5$export$c90ae6cb81bd21fc = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"53\" height=\"10\" viewBox=\"0 0 53 10\"><path fill=\"#1C2331\" d=\"M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z\"/><path fill=\"#AFE229\" d=\"M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z\"/><path fill=\"#771BFF\" d=\"m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z\"/></svg>\n";
var $e8dc502aba5ac3f5$export$2478ed0e296e2752 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003z\"/></svg>";
var $e8dc502aba5ac3f5$export$1d0eab454e4ed93b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.75.75 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.8.8 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032z\"/></svg>";
var $e8dc502aba5ac3f5$export$e8ec8c95cde4bd24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.106 4.946c.272.274.27.712.033 1.016a6.1 6.1 0 0 0-1.291 3.764c0 3.375 2.722 6.111 6.08 6.111q.418 0 .822-.057l-.964-.968-.048-.054a.71.71 0 0 1 .048-.943.7.7 0 0 1 .939-.05l.053.05 1.984 1.994c.143.144.21.335.204.523a.7.7 0 0 1-.156.495l-.048.053-1.984 1.994a.7.7 0 0 1-.992 0 .71.71 0 0 1 0-.997l.645-.647a8 8 0 0 1-.504.018c-4.132 0-7.482-3.368-7.482-7.522 0-1.803.632-3.458 1.684-4.754.248-.304.701-.304.977-.026M9.057.464a.7.7 0 0 1 .992 0 .71.71 0 0 1 0 .997l-.966.97q.46-.058.938-.058c4.132 0 7.483 3.367 7.483 7.521a7.5 7.5 0 0 1-1.685 4.754c-.247.304-.7.304-.977.026-.271-.273-.27-.712-.032-1.016a6.1 6.1 0 0 0 1.29-3.764c0-3.375-2.721-6.11-6.079-6.111a6 6 0 0 0-.673.039l.701.705.049.053a.71.71 0 0 1-.049.944.7.7 0 0 1-.939.048l-.053-.048L7.073 3.53a.7.7 0 0 1-.203-.524.7.7 0 0 1 .155-.495l.048-.053z\"/></svg>";
var $e8dc502aba5ac3f5$export$618ec83dcd45a999 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.2 7h9.2c.6 0 1 .4 1 1v9.9c0 .5-.4 1-1 1H5.2a1 1 0 0 1-1-1V8c0-.6.4-1 1-1m1 1.5c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h.5c.2 0 .5-.2.5-.5V9c0-.3-.3-.5-.5-.5zm3.2 0c-.2 0-.5.2-.5.5v8c0 .3.3.5.5.5h.5c.3 0 .5-.2.5-.5V9c0-.3-.2-.5-.5-.5h-.4zm3.5 0c-.2 0-.5.2-.5.5v8c0 .3.3.5.5.5h.5c.3 0 .5-.2.5-.5V9c0-.3-.2-.5-.5-.5zm-1.4-7.1H8.3L6.5 3.6H3.8c-.5 0-.7.3-.7.8s.2.7.7.7h12c.6 0 .9-.2.9-.7s-.3-.8-1-.8h-2.4z\"/></svg>";
var $e8dc502aba5ac3f5$export$548c63ef546ca223 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8.69 14.915q.08.078.36.093a.366.366 0 0 1 .345.485l-.003.01a.74.74 0 0 1-.697.497h-2.67a.374.374 0 0 1-.353-.496l.013-.038a.68.68 0 0 1 .644-.458q.295-.018.386-.093a.3.3 0 0 0 .072-.11L9.592 4.5H6.269q-.538-.026-.75.09-.213.117-.442.563c-.192.29-.516.464-.864.464H4.17a.43.43 0 0 1-.407-.569L4.46 3h13.08l-.62 2.043a.81.81 0 0 1-.775.574h-.114a.486.486 0 0 1-.486-.486q.002-.426-.167-.54-.168-.114-.766-.091h-3.28l-2.68 10.257q-.009.111.038.158M3 17h8a.5.5 0 1 1 0 1H3a.5.5 0 1 1 0-1m11.299 1.17a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.06-1.06l1.415 1.414 1.414-1.415a.75.75 0 1 1 1.06 1.06l-1.413 1.415 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z\"/></svg>";
var $e8dc502aba5ac3f5$export$634dbcc269865bc0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M5.2 7h9.2c.6 0 1 .4 1 1v9.9c0 .5-.4 1-1 1H5.2a1 1 0 0 1-1-1V8c0-.6.4-1 1-1m1 1.5c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h.5c.2 0 .5-.2.5-.5V9c0-.3-.3-.5-.5-.5zm3.2 0c-.2 0-.5.2-.5.5v8c0 .3.3.5.5.5h.5c.3 0 .5-.2.5-.5V9c0-.3-.2-.5-.5-.5zm3.5 0c-.2 0-.5.2-.5.5v8c0 .3.3.5.5.5h.5c.3 0 .5-.2.5-.5V9c0-.3-.2-.5-.5-.5zm-1.4-7.1H8.3L6.5 3.6H3.8c-.5 0-.7.3-.7.8s.2.7.7.7h12c.6 0 .9-.2.9-.7s-.3-.8-1-.8h-2.4z\"/></svg>";
var $e8dc502aba5ac3f5$export$2fae954303ecc7ac = "<svg viewBox=\"0 0 10 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038\"/></svg>";
var $e8dc502aba5ac3f5$export$7292604516f58f0a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1\"/><path d=\"M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052zM11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z\"/></svg>";
var $e8dc502aba5ac3f5$export$e27d4bbbb9b81a2 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.61 2.66a1.406 1.406 0 1 0-1.407 0v.891H3.28a2.11 2.11 0 0 0-2.11 2.11v10.312a2.11 2.11 0 0 0 2.11 2.109h5.684l-.054-1.157.18-.25H3.28a.703.703 0 0 1-.703-.702V5.66c0-.389.315-.704.703-.704h11.25c.388 0 .703.315.703.704v2.484l.358-.497a2.5 2.5 0 0 1 1.048-.84V5.66a2.11 2.11 0 0 0-2.11-2.11H9.61z\"/><path d=\"M5.625 10.817c.518 0 .937-.63.937-1.407 0-.776-.42-1.406-.937-1.406s-.938.63-.938 1.406c0 .777.42 1.407.938 1.407m7.5-1.407c0 .777-.42 1.407-.938 1.407s-.937-.63-.937-1.407c0-.776.42-1.406.937-1.406s.938.63.938 1.406M.937 8.004A.937.937 0 0 0 0 8.942v1.875c0 .517.42.937.937.937zm5.191 4.506a.78.78 0 0 1 1.085.216c.272.408.907.707 1.693.707s1.421-.3 1.693-.707a.782.782 0 0 1 1.302.868c-.666 1-1.906 1.403-2.995 1.403s-2.329-.404-2.995-1.403a.78.78 0 0 1 .217-1.085Zm10.859-3.6-.622.864 2.879 2.074.622-.864a.71.71 0 0 0-.161-.99l-1.728-1.245a.71.71 0 0 0-.99.161m-5.352 11.041a.355.355 0 0 1-.449-.31l-.214-2.38 4.978-6.911 2.88 2.074-4.978 6.91z\"/></svg>";
var $e8dc502aba5ac3f5$export$5be171d1c905ebb6 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75m18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75m-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2z\"/></svg>";
var $e8dc502aba5ac3f5$export$7bfd8d3d608a6631 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.583.45a.95.95 0 0 0-.95.95v5.3h1.5V1.95h4.75V.45zm17.05.95a.95.95 0 0 0-.95-.95h-5.3v1.5h4.75V6.7h1.5zm0 16.1a.95.95 0 0 1-.95.95h-5.3v-1.5h4.75V12.2h1.5zm-18 0c0 .525.425.95.95.95h5.3v-1.5h-4.75V12.2h-1.5zm5-10.8a.75.75 0 1 0 0 1.5h8a.75.75 0 1 0 0-1.5zm0 4a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$f8295d9ceeb6d2d6 = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.734 6.375H1.75a.75.75 0 0 1 0-1.5h1.984a2.626 2.626 0 0 1 5.032 0h9.48a.75.75 0 0 1 0 1.5h-9.48a2.626 2.626 0 0 1-5.032 0Zm1.141-.75a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0ZM16.263 14.625h1.983a.75.75 0 0 1 0 1.5h-1.983a2.626 2.626 0 0 1-5.033 0H1.75a.75.75 0 0 1 0-1.5h9.48a2.626 2.626 0 0 1 5.033 0Zm-1.142.75a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z\"/></svg>\n";
var $e8dc502aba5ac3f5$export$d3b56579d316b709 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m6.395 9.196 2.545-.007V6.498a.6.6 0 0 1 .598-.598h.299a.6.6 0 0 1 .598.598v6.877a.6.6 0 0 1-.598.598h-.299a.6.6 0 0 1-.598-.598v-2.691l-2.545.007v2.691a.6.6 0 0 1-.598.598h-.299a.6.6 0 0 1-.598-.598V6.505a.6.6 0 0 1 .598-.598h.299a.6.6 0 0 1 .598.598zm8.699 4.221V6.462a.56.56 0 0 0-.562-.562h-.782a1 1 0 0 0-.39.08l-1.017.43a.56.56 0 0 0-.343.517v.197c0 .4.406.67.775.519l.819-.337v6.111c0 .31.251.562.561.562h.377c.31 0 .562-.251.562-.562M0 15.417v1.5h1.5v-1.5zm18.5 0v1.5H20v-1.5zm0-3.084v1.5H20v-1.5zm0-3.083v1.5H20v-1.5zm0-3.083v1.5H20v-1.5zM0 18.5v.5a1 1 0 0 0 1 1h.5v-1.5zm3.083 0V20h1.5v-1.5zm3.084 0V20h1.5v-1.5zm3.083 0V20h1.5v-1.5zm3.083 0V20h1.5v-1.5zm3.084 0V20h1.5v-1.5zm3.083 0V20h.5a1 1 0 0 0 1-1v-.5z\"/><path d=\"M0 1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.583h-1.5V1.5h-17v12.333H0z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$1fd8d2618c68896e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.23 2.93a.88.88 0 0 1 1.248 0l1.47 1.468q.298-.186.605-.353c1.066-.58 2.247-.992 3.438-.961 1.176.03 2.344.464 3.405 1.05 1.066.588 2.069 1.355 2.925 2.104a27 27 0 0 1 2.852 2.918l.043.052.011.016.005.004a.7.7 0 0 1 .103.183l.018.047.02.083.01.05.002.078-.003.062-.01.06q-.005.038-.016.077l-.02.06-.03.07-.01.016-.056.087-.002-.001.002.002h-.002l-.003.006-.011.014-.044.054-.161.2a26 26 0 0 1-2.693 2.803q-.414.367-.868.73l1.256 1.256a.881.881 0 0 1-.785 1.49.87.87 0 0 0-.25-.55L3.444 3.872a.9.9 0 0 0-.465-.245.88.88 0 0 1 .252-.698m1.19 4.413A25 25 0 0 0 2.58 9.204l-.013.016a.654.654 0 0 0 .006.876c.484.53 1.173 1.236 1.98 1.943.812.708 1.73 1.407 2.679 1.93.954.527 1.896.853 2.76.876.52.013 1.07-.094 1.635-.298l1.082 1.082c-.877.395-1.812.651-2.754.626-1.176-.03-2.345-.464-3.406-1.05-1.066-.587-2.068-1.354-2.924-2.103a27 27 0 0 1-2.851-2.918l-.044-.052-.01-.014-.005-.004v-.002a1 1 0 0 1-.06-.087l-.008-.014q-.022-.044-.038-.089l-.016-.04-.02-.086q-.005-.024-.007-.05-.006-.039-.003-.075v-.06q.004-.038.012-.076l.012-.056q.013-.041.03-.08l.023-.054.012-.02.055-.086h.002l-.002-.001.003-.005.012-.015.043-.054.16-.2A26 26 0 0 1 3.42 6.343zm6.057 6.058q-.247.035-.506.035a3.765 3.765 0 0 1-3.73-4.27zm-.524-8.906c-.85-.021-1.779.276-2.727.79l-.25.142L8.011 6.46a3.77 3.77 0 0 1 1.96-.555 3.765 3.765 0 0 1 3.766 3.764 3.77 3.77 0 0 1-.558 1.96l1.272 1.271c.323-.25.637-.513.936-.778a25 25 0 0 0 1.977-1.988l.015-.016a.655.655 0 0 0-.006-.878 26 26 0 0 0-1.981-1.941c-.81-.708-1.73-1.407-2.679-1.932-.954-.526-1.896-.852-2.76-.874m1.148 2.541a1.41 1.41 0 0 0-1.384 1.132l1.662 1.662a1.412 1.412 0 0 0-.278-2.794\"/></svg>";
var $e8dc502aba5ac3f5$export$4c67668db93c262b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><g fill-rule=\"evenodd\"><path d=\"M9.972 5.906a3.765 3.765 0 1 1 0 7.53 3.765 3.765 0 0 1 0-7.53m1.13 1.13a1.412 1.412 0 1 0 0 2.823 1.412 1.412 0 0 0 0-2.824\"/><path d=\"M9.99 3.084c1.177.03 2.345.465 3.406 1.05 1.066.588 2.07 1.355 2.925 2.105a27 27 0 0 1 2.852 2.917q.027.036.043.053l.011.015.004.003v.002q.068.084.103.183l.019.047.019.083.01.05a.7.7 0 0 1 0 .139q-.002.031-.01.06l-.016.078q-.009.029-.022.058-.012.035-.028.07l-.01.018-.056.087-.002-.002v.004l-.004.005-.012.015-.042.054-.161.198a26 26 0 0 1-2.694 2.803c-.856.762-1.863 1.537-2.933 2.117-1.066.58-2.247.992-3.438.962-1.176-.03-2.345-.465-3.406-1.05-1.066-.59-2.07-1.355-2.924-2.103a27 27 0 0 1-2.851-2.92l-.044-.052-.011-.015-.003-.004v-.001a1 1 0 0 1-.062-.088l-.006-.013-.039-.088-.016-.042q-.013-.043-.02-.086-.006-.025-.008-.05L.56 9.669v-.06q.005-.036.013-.075l.012-.056.03-.08.023-.054.012-.022.055-.083v.001h.001v-.002l.005-.005.01-.015.044-.054q.055-.071.16-.198a26 26 0 0 1 2.692-2.801c.858-.764 1.864-1.54 2.935-2.12 1.066-.58 2.247-.99 3.438-.961m-.037 1.411c-.85-.022-1.779.276-2.727.79-.943.511-1.859 1.214-2.67 1.934A24 24 0 0 0 2.58 9.207l-.014.015a.654.654 0 0 0 .007.877c.484.53 1.173 1.235 1.98 1.943.813.709 1.73 1.406 2.68 1.93.953.527 1.894.853 2.759.875.849.021 1.778-.276 2.727-.79.943-.512 1.86-1.212 2.67-1.933a25 25 0 0 0 1.977-1.989l.015-.016a.654.654 0 0 0-.007-.875 26 26 0 0 0-1.98-1.943c-.812-.71-1.73-1.407-2.68-1.932-.953-.525-1.894-.853-2.759-.874\"/></g></svg>";
var $e8dc502aba5ac3f5$export$fee690a0bb150b1d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m12.5 0 5 4.5v15.003h-16V0zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692z\"/><path d=\"M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0\"/></svg>";
var $e8dc502aba5ac3f5$export$77b455dec4c6ab24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.288 1.496c.244-.661 1.18-.661 1.424 0l1.513 4.09a3.7 3.7 0 0 0 2.188 2.188l4.091 1.514c.661.244.66 1.18 0 1.424l-4.09 1.513a3.7 3.7 0 0 0-2.189 2.19l-1.513 4.09c-.244.66-1.18.66-1.424 0l-1.513-4.09a3.7 3.7 0 0 0-2.19-2.19l-4.09-1.513c-.66-.244-.66-1.18 0-1.424l4.09-1.514a3.7 3.7 0 0 0 2.189-2.188zM9.168 6.1A5.2 5.2 0 0 1 6.1 9.167L3.851 10l2.25.832a5.2 5.2 0 0 1 3.066 3.067L10 16.148l.832-2.25a5.2 5.2 0 0 1 3.066-3.066L16.147 10l-2.25-.833a5.2 5.2 0 0 1-3.065-3.066L10 3.852z\"/></svg>";
var $e8dc502aba5ac3f5$export$ff198a8945f3463c = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 2.5a7.47 7.47 0 0 1 4.231 1.31 7.27 7.27 0 0 1 2.703 3.454 7.13 7.13 0 0 1 .199 4.353c-.39 1.436-1.475 2.72-2.633 3.677h2.013c0-.226.092-.443.254-.603a.876.876 0 0 1 1.229 0c.163.16.254.377.254.603v.853c0 .209-.078.41-.22.567a.87.87 0 0 1-.547.28l-.101.006h-4.695a.517.517 0 0 1-.516-.518v-1.265c0-.21.128-.398.317-.489a5.6 5.6 0 0 0 2.492-2.371 5.46 5.46 0 0 0 .552-3.693 5.53 5.53 0 0 0-1.955-3.2A5.7 5.7 0 0 0 10 4.206 5.7 5.7 0 0 0 6.419 5.46 5.53 5.53 0 0 0 4.46 8.663a5.46 5.46 0 0 0 .554 3.695 5.6 5.6 0 0 0 2.497 2.37.55.55 0 0 1 .317.49v1.264c0 .286-.23.518-.516.518H2.618a.88.88 0 0 1-.614-.25.85.85 0 0 1-.254-.603v-.853c0-.226.091-.443.254-.603a.876.876 0 0 1 1.228 0c.163.16.255.377.255.603h1.925c-1.158-.958-2.155-2.241-2.545-3.678a7.13 7.13 0 0 1 .199-4.352 7.27 7.27 0 0 1 2.703-3.455A7.5 7.5 0 0 1 10 2.5\"/></svg>";
var $e8dc502aba5ac3f5$export$5284e8ae56e1ddfb = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 3.778C2 2.796 2.796 2 3.778 2h12.444C17.204 2 18 2.796 18 3.778v12.444c0 .982-.796 1.778-1.778 1.778H3.778A1.78 1.78 0 0 1 2 16.222z\"/></svg>";
var $e8dc502aba5ac3f5$export$a0b6b67f472a14e3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0M7 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$2e0f33c68ec2356e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6M6.8 9 6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z\"/><path d=\"M3 10.5V9h14v1.5z\"/></svg>";
var $e8dc502aba5ac3f5$export$f5a445dbb52095b4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M15.875 4.419a.75.75 0 0 0-1.5 0v7.25H6.818l2.33-1.955a.75.75 0 0 0-.963-1.15l-3.792 3.182a.75.75 0 0 0-.17.945c.046.11.118.208.21.284l3.788 3.18a.75.75 0 1 0 .965-1.149l-2.19-1.837h7.629c.69 0 1.25-.56 1.25-1.25z\"/></svg>";
var $e8dc502aba5ac3f5$export$5834a66e6db90bd0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m7.03 10.349 3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53zm8.147 7.829h2.549q.38 0 .58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393q-.158.162-.48.162h-3.594q-.367 0-.572-.197a.62.62 0 0 1-.205-.463q0-.171.132-.453a1.6 1.6 0 0 1 .288-.444q.65-.654 1.172-1.122t.747-.615q.401-.275.667-.553t.405-.57.139-.57a1.01 1.01 0 0 0-.554-.917 1.2 1.2 0 0 0-.56-.133q-.639 0-1.005.546a2.3 2.3 0 0 0-.164.39 1.6 1.6 0 0 1-.258.488q-.144.17-.423.17a.56.56 0 0 1-.405-.156.57.57 0 0 1-.161-.427q0-.327.151-.683.152-.357.452-.646c.3-.289.454-.349.762-.467a3 3 0 0 1 1.081-.178q.747 0 1.274.228a1.92 1.92 0 0 1 1.004 1.032 1.98 1.98 0 0 1-.156 1.794q-.3.48-.613.754-.312.273-1.048.857-.735.584-1.008.906a3 3 0 0 0-.24.309z\"/></svg>";
var $e8dc502aba5ac3f5$export$bd9211873848bcce = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"m7.184 10.353 3.818-3.819a.8.8 0 0 1 1.132 1.132l-3.82 3.818 3.82 3.818a.802.802 0 0 1-.873 1.306.8.8 0 0 1-.26-.174l-3.817-3.82-3.818 3.82a.8.8 0 0 1-1.305-.26.8.8 0 0 1 .173-.872l3.82-3.818-3.82-3.818a.8.8 0 0 1 1.132-1.132l3.818 3.82M15.68 6.88h2.549q.38 0 .58.153a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393q-.158.162-.48.162h-3.594q-.367 0-.572-.197A.62.62 0 0 1 14 7.34q0-.171.132-.453a1.6 1.6 0 0 1 .288-.444q.65-.654 1.172-1.122t.747-.615q.401-.275.667-.553.266-.277.405-.57.14-.291.139-.57a1.01 1.01 0 0 0-.554-.917 1.2 1.2 0 0 0-.56-.133q-.639 0-1.005.546a2.3 2.3 0 0 0-.164.39 1.6 1.6 0 0 1-.258.488q-.144.17-.423.17a.56.56 0 0 1-.405-.156.57.57 0 0 1-.161-.427q0-.327.151-.683.152-.357.452-.646t.762-.467A3 3 0 0 1 16.466 1q.747 0 1.274.228c.456.2.816.57 1.004 1.032a1.99 1.99 0 0 1-.156 1.794q-.3.48-.613.754-.312.273-1.048.857-.735.583-1.008.906-.131.146-.24.309z\"/></svg>";
var $e8dc502aba5ac3f5$export$be160212d9876860 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5zM2 12h5V8H2zm10-4H8v4h4zM2 2v5h5V2zm0 16h5v-5H2zM13 7h5V2h-5zM8 2v5h4V2z\" opacity=\".6\"/><path d=\"m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43zM13 6a1 1 0 0 1 1 1v3.172a2 2 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.98 1.98 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm-1 2H8v4h4z\"/></svg>";
var $e8dc502aba5ac3f5$export$8f3defc247629bdb = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1M2 2v16h16V2z\" opacity=\".6\"/><path d=\"M18 7v1H2V7zm0 5v1H2v-1z\" opacity=\".6\"/><path d=\"M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1m-2 1H8v4h4zm0 6H8v4h4zm0 6H8v4h4z\"/></svg>";
var $e8dc502aba5ac3f5$export$2c52ce7602b10937 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1M2 2v16h16V2z\" opacity=\".6\"/><path d=\"M7 2h1v16H7zm5 0h1v7h-1zm6 5v1H2V7zM8 12v1H2v-1z\" opacity=\".6\"/><path d=\"M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m1 2v9h10V9z\"/></svg>";
var $e8dc502aba5ac3f5$export$71192d4f3da7e3b8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 19a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8.022a6.5 6.5 0 0 0-1.5-.709V2a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h6.313c.173.534.412 1.037.709 1.5z\"/><path d=\"M9.174 14a6.5 6.5 0 0 0-.155 1H6v-1zm.848-2a6.5 6.5 0 0 0-.524 1H4v-1zm2.012-2c-.448.283-.86.62-1.224 1H6v-1zM12 4v1H4V4zm2 3V6H6v1zm1 2V8H7v1z\"/><path d=\"M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M15.5 13a.5.5 0 0 0-.5.5V15h-1.5a.5.5 0 0 0 0 1H15v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16v-1.5a.5.5 0 0 0-.5-.5\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$f0a4ba08c77f7861 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2zm4 6H8v4h4z\" opacity=\".6\"/><path d=\"m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2 2 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z\"/></svg>";
var $e8dc502aba5ac3f5$export$b5a8f408cb97d6f8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1M2 2v16h16V2z\" opacity=\".6\"/><path d=\"M7 2h1v16H7zm5 0h1v16h-1z\" opacity=\".6\"/><path d=\"M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 2v4h4V8zm6 0v4h4V8zm6 0v4h4V8z\"/></svg>";
var $e8dc502aba5ac3f5$export$84f497075f5b07be = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 5.5v3h4v-3zm0 4v3h4v-3zm0 4v3h4v-3zm5 3h4v-3H8zm5 0h4v-3h-4zm4-4v-3h-4v3zm0-4v-3h-4v3zm1.5 8A1.5 1.5 0 0 1 17 18H3a1.5 1.5 0 0 1-1.5-1.5V3c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5zm-6.5-4v-3H8v3zm0-4v-3H8v3z\"/></svg>";
var $e8dc502aba5ac3f5$export$40566f18736a7d62 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.5 4.121C1.5 2.95 2.426 2 3.568 2h12.864c1.142 0 2.068.95 2.068 2.121V16.38c0 1.171-.926 2.121-2.068 2.121H3.568c-1.142 0-2.068-.95-2.068-2.121zm2.068-.707a.7.7 0 0 0-.69.707V6.38h14.244V4.12a.7.7 0 0 0-.69-.707zm13.554 4.38h-4.968v3.939h4.968zm0 5.353h-4.968v3.939h4.278c.381 0 .69-.317.69-.707zm-6.347 3.939V7.794H2.878v8.585c0 .39.309.707.69.707z\"/></svg>";
var $e8dc502aba5ac3f5$export$2503a932d03c3b22 = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\">\n    <path fill=\"#F0F0F0\" d=\"M2 0h41s2 0 2 2v41s0 2 -2 2h-41s-2 0 -2 -2v-41s0 -2 2 -2\" />\n    <path fill=\"#D5D5D5\" d=\"M11 10h10s1 0 1 1v24s0 1 -1 1h-10s-1 0 -1 -1v-24s0 -1 1 -1\" />\n    <path fill=\"#D5D5D5\" d=\"M25 10h10s1 0 1 1v10s0 1 -1 1h-10s-1 0 -1 -1v-10s0 -1 1 -1\" />\n    <path fill=\"#D5D5D5\" d=\"M25 24h10s1 0 1 1v10s0 1 -1 1h-10s-1 0 -1 -1v-10s0 -1 1 -1\" />\n</svg>\n";
var $e8dc502aba5ac3f5$export$a306f48a7cb235d4 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M8 0H3a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M2.5 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM13 0h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 1.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5zm0 8.5h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2m0 1.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$fcce8fc510acb082 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.035 1C2.446 1 2 1.54 2 2.098V10.5h1.5v-8h13v8H18V2.098C18 1.539 17.48 1 16.9 1zm10.453 2.61a1.89 1.89 0 0 0-1.442.736 1.89 1.89 0 0 0 1.011 2.976 1.9 1.9 0 0 0 2.253-1.114 1.887 1.887 0 0 0-1.822-2.598M7.463 8.163a.6.6 0 0 0-.432.154L5.071 10.5h5.119L7.88 8.348a.63.63 0 0 0-.417-.185m6.236 1.059a.62.62 0 0 0-.42.164L12.07 10.5h2.969l-.92-1.113a.62.62 0 0 0-.42-.165M.91 11.5a.91.91 0 0 0-.91.912v6.877c0 .505.405.91.91.91h18.178a.91.91 0 0 0 .912-.91v-6.877a.91.91 0 0 0-.912-.912zM3.668 13h1.947l2.135 5.7H5.898l-.28-.946H3.601l-.278.945H1.516zm4.947 0h1.801v4.3h2.7v1.4h-4.5zm4.5 0h5.4v1.4h-1.798v4.3h-1.701v-4.3h-1.9zm-8.517 1.457-.614 2.059h1.262z\"/></svg>";
var $e8dc502aba5ac3f5$export$fe7c634bfc18e397 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.816 11.5 7.038 4.785 4.261 11.5zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663z\"/><path d=\"m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254z\"/></svg>";
var $e8dc502aba5ac3f5$export$28a5f19964cd4a0b = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M14.5 10.001a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-6 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-6 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0\"/></svg>";
var $e8dc502aba5ac3f5$export$820c380d63c981c7 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m5.977 2 .708 1.914A2.06 2.06 0 0 0 7.902 5.13l1.914.708-1.914.709a2.06 2.06 0 0 0-1.217 1.216l-.708 1.914-.708-1.914a2.06 2.06 0 0 0-1.216-1.216l-1.914-.709 1.914-.708a2.06 2.06 0 0 0 1.216-1.216zm6.87 3.417 1.135 3.067a3.3 3.3 0 0 0 1.95 1.95L19 11.57l-3.067 1.135a3.3 3.3 0 0 0-1.95 1.95l-1.136 3.067-1.135-3.067a3.3 3.3 0 0 0-1.95-1.95l-3.068-1.136 3.068-1.135a3.3 3.3 0 0 0 1.95-1.95zm-8.418 8.276-.534-1.443-.534 1.443c-.158.425-.493.76-.918.918L1 15.145l1.443.534c.425.157.76.492.918.917l.534 1.443.534-1.443a1.55 1.55 0 0 1 .917-.917l1.443-.534-1.443-.534a1.55 1.55 0 0 1-.917-.918\"/></svg>";
var $e8dc502aba5ac3f5$export$765be1eabc10674d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><circle cx=\"9.5\" cy=\"4.5\" r=\"1.5\"/><circle cx=\"9.5\" cy=\"10.5\" r=\"1.5\"/><circle cx=\"9.5\" cy=\"16.5\" r=\"1.5\"/></svg>";
var $e8dc502aba5ac3f5$export$a3bf9796214bd9ac = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M6.05 8.609v8.38c0 1.11.903 2.01 2.017 2.01h7.553c.896 0 1.684-.588 1.936-1.445l2.361-8.041a2.012 2.012 0 0 0-1.935-2.575h-4.353l.788-2.618a2.01 2.01 0 0 0-1.294-2.485l-.698-.232a2.02 2.02 0 0 0-2.269.725l-3.72 5.098c-.25.344-.386.758-.386 1.183m1.513 8.38V8.61c0-.107.034-.21.096-.296l3.72-5.099a.505.505 0 0 1 .567-.18l.699.231a.5.5 0 0 1 .323.621l-1.177 3.912a.503.503 0 0 0 .483.647h5.708c.336 0 .578.322.484.644l-2.362 8.041a.504.504 0 0 1-.484.362H8.067a.503.503 0 0 1-.504-.503M3.328 6.937H1.714C.767 6.937 0 7.703 0 8.647v8.644C0 18.234.767 19 1.714 19h1.614c.946 0 1.714-.766 1.714-1.71V8.647c0-.943-.768-1.709-1.714-1.709m-1.815 1.71c0-.112.09-.202.201-.202h1.614c.111 0 .201.09.201.201v8.645a.2.2 0 0 1-.201.2H1.714a.2.2 0 0 1-.201-.2z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$e7f503e9349f950a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M13.95 11.89V3.51c0-1.11-.903-2.01-2.017-2.01H4.38c-.896 0-1.684.589-1.936 1.446l-2.361 8.04a2.012 2.012 0 0 0 1.935 2.576h4.353l-.788 2.618a2.01 2.01 0 0 0 1.294 2.485l.698.232a2.02 2.02 0 0 0 2.269-.725l3.72-5.099c.25-.343.386-.757.386-1.182m-1.513-8.38v8.38c0 .107-.034.21-.096.296l-3.72 5.1a.505.505 0 0 1-.567.18l-.699-.232a.5.5 0 0 1-.323-.62L8.209 12.7a.503.503 0 0 0-.483-.647H2.018a.503.503 0 0 1-.484-.643l2.362-8.042a.504.504 0 0 1 .484-.361h7.553c.278 0 .504.225.504.502m4.235 10.053h1.614c.947 0 1.714-.765 1.714-1.709V3.21c0-.944-.767-1.709-1.714-1.709h-1.614c-.946 0-1.714.765-1.714 1.709v8.644c0 .944.768 1.709 1.714 1.709m1.815-1.709c0 .111-.09.201-.201.201h-1.614a.2.2 0 0 1-.201-.2V3.208c0-.111.09-.201.201-.201h1.614a.2.2 0 0 1 .201.2z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$573bad8c14308a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m2.315 14.705 2.224-2.24a.69.69 0 0 1 .963 0 .664.664 0 0 1 0 .949L2.865 16.07a.7.7 0 0 1-.112.089.65.65 0 0 1-.852-.051L.688 14.886a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0zm5.185.045a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75M2.329 5.745l2.21-2.226a.69.69 0 0 1 .963 0 .664.664 0 0 1 0 .95L2.865 7.125a.7.7 0 0 1-.496.196.64.64 0 0 1-.468-.187L.688 5.912a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.73.736zM7.5 5.75A.75.75 0 0 1 8.25 5h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75\"/></svg>";
var $e8dc502aba5ac3f5$export$86c714b58260ec18 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 2.28C2 1.574 2.574 1 3.272 1l11.456.001c.703 0 1.272.573 1.272 1.28v8.453l-1.5 1.464V2.465c0-.003-11-.005-11-.005V16.5h2.356q.188.34.462.62l.868.88-3.914-.001A1.274 1.274 0 0 1 2 16.719z\"/><path d=\"M14.525 18H9.293l-1.48-1.5h3.75l.332.336.344-.336H14.5v-2.207L16 12.83v3.73zm-4.819-5.362a2.84 2.84 0 0 0-1.38-.36 2.8 2.8 0 0 0-1.602.5H6.18a.635.635 0 0 1-.633-.639.64.64 0 0 1 .633-.639h3.133a.639.639 0 0 1 .393 1.138m-4.16-6.484c0-.353.292-.64.636-.64h5.682a.637.637 0 0 1 .449 1.09.64.64 0 0 1-.449.188H6.182a.636.636 0 0 1-.635-.639zm0 2.984c0-.352.292-.638.636-.638h5.682a.635.635 0 0 1 .45 1.088.64.64 0 0 1-.45.189H6.182a.636.636 0 0 1-.636-.639\"/><path d=\"m13.117 19.374 6.192-6.044a1.316 1.316 0 0 0 0-1.876 1.354 1.354 0 0 0-1.899 0l-5.515 5.382-2.63-2.666a1.3 1.3 0 0 0-.938-.393 1.32 1.32 0 0 0-.939.394 1.354 1.354 0 0 0 0 1.898l3.49 3.538a1.32 1.32 0 0 0 1.447.29 2.7 2.7 0 0 0 .792-.523\" style=\"fill:#1fb11f\"/></svg>";
var $e8dc502aba5ac3f5$export$78b2a9e7f1977867 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 2.28C2 1.574 2.574 1 3.272 1l11.456.001c.703 0 1.272.573 1.272 1.28v8.106l-.889.899-.611-.619V2.465c0-.003-11-.005-11-.005V16.5h6.458l-.136.138-.003.003c-.372.378-.628.85-.745 1.359l-5.802-.001A1.274 1.274 0 0 1 2 16.719zM14.338 18h-3.676q.09-.169.227-.308l1.178-1.192H14.5v-3.699l.61.618.89-.899v4.199c0 .383-.168.726-.431.96l-.457-.462z\"/><path d=\"M9.043 11.5a2.85 2.85 0 0 0 .066 1.278H6.18a.635.635 0 0 1-.632-.639.64.64 0 0 1 .633-.639h2.863Zm3.45-2.267a2.82 2.82 0 0 0-2.434.544H6.182a.636.636 0 0 1-.636-.639c0-.352.292-.638.636-.638h5.682a.635.635 0 0 1 .629.733M5.546 6.154c0-.353.292-.64.636-.64h5.682a.637.637 0 0 1 .449 1.09.64.64 0 0 1-.449.188H6.182a.636.636 0 0 1-.635-.639z\"/><path d=\"m15.11 13.42 2.348-2.374a1.32 1.32 0 0 1 1.877 0 1.354 1.354 0 0 1 0 1.9l-2.346 2.372 2.346 2.374a1.354 1.354 0 0 1 0 1.898 1.316 1.316 0 0 1-1.877 0l-2.346-2.373-2.346 2.373a1.316 1.316 0 0 1-1.877 0 1.354 1.354 0 0 1 0-1.898l2.346-2.374-2.346-2.373a1.354 1.354 0 0 1 0-1.899 1.32 1.32 0 0 1 1.877 0l2.346 2.374z\" style=\"fill:#da2020\"/></svg>";
var $e8dc502aba5ac3f5$export$27dcac7d05ef8b6a = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M6.182 5.514a.643.643 0 0 0-.636.64v-.001a.636.636 0 0 0 .636.639h5.682a.64.64 0 0 0 .636-.638.637.637 0 0 0-.636-.64zm0 2.986a.642.642 0 0 0-.588.882.64.64 0 0 0 .588.395h5.682a.64.64 0 0 0 .636-.639.635.635 0 0 0-.636-.638zm-.002 3a.64.64 0 0 0 0 1.278h3.133a.64.64 0 0 0 0-1.278zm5.592 6.808.154-.23q-.292-.148-.328-.28-.037-.135.076-.551.093-.248.11-.393a3 3 0 0 0 0-.479q-.206-.614-.186-.83.02-.218.313-.57l4.465-6.207q.534-.9 2.11.118 1.576 1.021 1.177 1.772l-3.876 6.833q-.157.407-.347.515c-.128.07-.4.119-.813.139a3 3 0 0 0-.487.21q-.191.135-.347.31-.29.261-.416.262-.095 0-.346-.15l-.204.27zm-.184.274 1.039.727-.26.34h-1.496z\"/><path d=\"M3.272 1A1.28 1.28 0 0 0 2 2.28v14.439a1.276 1.276 0 0 0 1.272 1.28h6.838a2.1 2.1 0 0 1 .003-.61 4 4 0 0 1 .156-.67l.025-.069v-.008l-.042-.142H3.5V2.46s11 .002 11 .005v6.341l.627-.872c.204-.32.49-.614.873-.819V2.281c0-.707-.569-1.28-1.272-1.28zM16 9.29l-1.5 2.085V16.5h-2.708q.007.177-.007.354l-.013.075-.001.005a3 3 0 0 1-.097.312q-.04.152-.062.266a.7.7 0 0 0-.014.287.25.25 0 0 0 .068.105 1 1 0 0 0 .088.074l.017.011.016.01h.175L14.73 18c.697 0 1.271-.573 1.271-1.281v-7.43Z\" clip-rule=\"evenodd\"/></svg>";
var $e8dc502aba5ac3f5$export$25f9abeb294dfbd0 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8s3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4\"/></svg>";
var $e8dc502aba5ac3f5$export$25d76e2a7827833e = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.75.75 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.8.8 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032z\"/></svg>";
var $e8dc502aba5ac3f5$export$c3a99d63f29863e8 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.8.8 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.7.7 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294zm5.494-5.335a.8.8 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.8.8 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955m-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184m4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06z\"/></svg>";
var $e8dc502aba5ac3f5$export$fea48ea21d3098cc = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037H5.06l5.058-5.078L6.617 9.15a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v4.354a3.5 3.5 0 0 1 1.5.049V2.1c0-.63-.547-1.1-1.2-1.1zm11.713 2.803a2.147 2.147 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.642-3.11 2.13 2.13 0 0 0-1.873-.978M8.089 17.635v2.388h2.389l7.046-7.046-2.39-2.39zm11.282-6.507a.64.64 0 0 0 .139-.692.6.6 0 0 0-.139-.205l-1.49-1.488a.63.63 0 0 0-.899 0l-1.166 1.163 2.39 2.39z\"/></svg>";
var $e8dc502aba5ac3f5$export$9df01264d33acb0d = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\"><path d=\"M1.801 1.4C1.138 1.4.6 1.87.6 2.5v14.363c0 .64.534 1.037 1.186 1.037h9.494a3 3 0 0 1-.414-.287A3 3 0 0 1 9.81 15.59v-.007a3 3 0 0 1 .693-2.186l.383-.455-.02.018-3.65-3.41a.695.695 0 0 0-.957-.034L2.1 14V2.9h15v5.535a2.97 2.97 0 0 1 1.412.932l.088.105V2.5c0-.63-.547-1.1-1.2-1.1zm11.713 2.803a2.146 2.146 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.644-3.11 2.13 2.13 0 0 0-1.875-.978\"/><path d=\"M16.122 19.5a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 0 0 1.211-1.015l-3.351-3.995a.79.79 0 0 0-.996-.179.8.8 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79\"/><path d=\"M16.122 19.5a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 0 0 1.211-1.015l-3.351-3.995a.79.79 0 0 0-.996-.179.8.8 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79\"/></svg>";
var $e8dc502aba5ac3f5$export$f8aba3f521e648ad = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M12.748 2a4.62 4.62 0 0 0-3.174 1.362L8.02 4.915a.783.783 0 0 0 .002 1.11.786.786 0 0 0 1.11 0l1.55-1.553c1.185-1.185 3.024-1.195 4.116-.104l.851.854c1.092 1.091 1.083 2.927-.101 4.11l-1.555 1.554a.787.787 0 0 0 .557 1.34.78.78 0 0 0 .553-.23l1.554-1.552c1.758-1.757 1.838-4.597.102-6.332l-.854-.853A4.3 4.3 0 0 0 12.748 2m-.488 4.973a.78.78 0 0 0-.553.23L7.2 11.71l-.004.002a.784.784 0 0 0 1.11 1.107l.003-.002 4.504-4.505a.785.785 0 0 0-.554-1.339Zm-6.79.815a.8.8 0 0 0-.554.234L3.36 9.573c-1.757 1.758-1.836 4.597-.101 6.332l.853.852c1.736 1.734 4.572 1.655 6.33-.102l1.547-1.547.006-.008a.78.78 0 0 0 .244-.554.78.78 0 0 0-.799-.797.77.77 0 0 0-.56.248l-1.545 1.547c-1.184 1.184-3.021 1.195-4.113.104l-.854-.854c-1.091-1.091-1.083-2.927.102-4.111l1.552-1.555a.8.8 0 0 0 .233-.555.8.8 0 0 0-.06-.3.8.8 0 0 0-.173-.253s-.104-.14-.183-.185c-.051-.03-.133-.047-.37-.047Z\"/></svg>";
var $e8dc502aba5ac3f5$export$19b17a93dd1982ba = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\"><path d=\"M5.5 5C8.538 5 11 7.015 11 9.5q0 .255-.034.5H.034A4 4 0 0 1 0 9.5C0 7.015 2.462 5 5.5 5m0-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5\"/></svg>";
var $e8dc502aba5ac3f5$export$fe0e5b4deacbcef6 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.273 17.818 2 18l.182-1.273 4.363-4.363 1.091 1.09zM18 7.818c-.897.897-1.997 1.284-2.847.732l-2.971 3.632c1.205 1.205.841 2.795-.364 4l-8-8c1.205-1.205 2.795-1.569 4-.364l3.632-2.972c-.552-.85-.165-1.949.732-2.846z\"/></svg>";
var $e8dc502aba5ac3f5$export$5be70e40251e6f9b = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.27988 2.40003H6.71988V6.72003H5.27988V2.40003ZM6.72009 8.16003H5.28009V9.60003H6.72009V8.16003Z\" fill=\"#DB3700\"/>\n</svg>\n";
var $e8dc502aba5ac3f5$export$e01761752a6251f3 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M20 10.001c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m-9.662 8.493a9 9 0 0 1-.676 0c-.838-1.316-1.492-2.931-1.877-4.743h4.43c-.385 1.812-1.039 3.427-1.877 4.743m1.815-.268c.671-1.327 1.184-2.84 1.497-4.475h3.98a8.52 8.52 0 0 1-5.477 4.475m6.046-5.975a8.5 8.5 0 0 0 .301-2.25 8.5 8.5 0 0 0-.301-2.25h-4.323a20.3 20.3 0 0 1 0 4.5zm-.569-6a8.52 8.52 0 0 0-5.477-4.475c.671 1.327 1.184 2.84 1.497 4.475zm-7.292-4.743c.838 1.316 1.492 2.93 1.877 4.743h-4.43c.385-1.812 1.039-3.427 1.877-4.743a9 9 0 0 1 .676 0m-2.49.268c-.672 1.327-1.185 2.84-1.498 4.475H2.37a8.52 8.52 0 0 1 5.477-4.475M1.8 7.751a8.5 8.5 0 0 0-.301 2.25c0 .779.105 1.533.301 2.25h4.323a20.3 20.3 0 0 1 0-4.5zm.569 6a8.52 8.52 0 0 0 5.477 4.475c-.671-1.327-1.184-2.84-1.497-4.475zm10.095-1.5h-4.93a18.5 18.5 0 0 1 0-4.5h4.93a18.5 18.5 0 0 1 0 4.5\" clip-rule=\"evenodd\"/></svg>";


/**
 * @module color-parse
 */ const $3cbe7ab7f006e2aa$var$colors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
for(const key in $3cbe7ab7f006e2aa$var$colors)Object.freeze($3cbe7ab7f006e2aa$var$colors[key]);
var $3cbe7ab7f006e2aa$export$2e2bcd8739ae039 = Object.freeze($3cbe7ab7f006e2aa$var$colors);


var $7709f00c9a7c855e$export$2e2bcd8739ae039 = $7709f00c9a7c855e$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $7709f00c9a7c855e$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $7709f00c9a7c855e$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === 'number') return {
        space: 'rgb',
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === 'number') return {
        space: 'rgb',
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)[cstr]) {
        parts = (0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)[cstr].slice();
        space = 'rgb';
    } else if (cstr === 'transparent') {
        alpha = 0;
        space = 'rgb';
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === '#') {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = 'rgb';
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, '');
        var dims = space === 'cmyk' ? 4 : space === 'gray' ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === 'color') space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === '%') {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === 'rgb') return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === 'h') return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === 'l' && !i) return x * 100;
                // lab A B -> -125..125
                if (space === 'lab') return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === 'lch') return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === 'o' && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === 'oklab') return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === 'oklch') return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === 'h' || i === 2 && space[space.length - 1] === 'h') {
                //<base-hue>
                if ($7709f00c9a7c855e$var$baseHues[x] !== undefined) return $7709f00c9a7c855e$var$baseHues[x];
                //<deg>
                if (x.endsWith('deg')) return parseFloat(x);
                //<turn>
                if (x.endsWith('turn')) return parseFloat(x) * 360;
                if (x.endsWith('grad')) return parseFloat(x) * 360 / 400;
                if (x.endsWith('rad')) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === 'none') return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = cstr.match(/([a-z])/ig)?.join('')?.toLowerCase() || 'rgb';
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


/* MIT license */ /* eslint-disable no-mixed-operators */ 
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $20868059344c9b7a$var$reverseKeywords = {};
for (const key of Object.keys((0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)))$20868059344c9b7a$var$reverseKeywords[(0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)[key]] = key;
const $20868059344c9b7a$var$convert = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    oklab: {
        channels: 3,
        labels: [
            'okl',
            'oka',
            'okb'
        ]
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    oklch: {
        channels: 3,
        labels: [
            'okl',
            'okc',
            'okh'
        ]
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
var $20868059344c9b7a$export$2e2bcd8739ae039 = $20868059344c9b7a$var$convert;
// LAB f(t) constant
const $20868059344c9b7a$var$LAB_FT = (6 / 29) ** 3;
// SRGB non-linear transform functions
function $20868059344c9b7a$var$srgbNonlinearTransform(c) {
    const cc = c > 0.0031308 ? 1.055 * c ** (1 / 2.4) - 0.055 : c * 12.92;
    return Math.min(Math.max(0, cc), 1);
}
function $20868059344c9b7a$var$srgbNonlinearTransformInv(c) {
    return c > 0.04045 ? ((c + 0.055) / 1.055) ** 2.4 : c / 12.92;
}
// Hide .channels and .labels properties
for (const model of Object.keys($20868059344c9b7a$var$convert)){
    if (!('channels' in $20868059344c9b7a$var$convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in $20868059344c9b7a$var$convert[model])) throw new Error('missing channel labels property: ' + model);
    if ($20868059344c9b7a$var$convert[model].labels.length !== $20868059344c9b7a$var$convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    const { channels: channels, labels: labels } = $20868059344c9b7a$var$convert[model];
    delete $20868059344c9b7a$var$convert[model].channels;
    delete $20868059344c9b7a$var$convert[model].labels;
    Object.defineProperty($20868059344c9b7a$var$convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty($20868059344c9b7a$var$convert[model], 'labels', {
        value: labels
    });
}
$20868059344c9b7a$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    switch(max){
        case min:
            h = 0;
            break;
        case r:
            h = (g - b) / delta;
            break;
        case g:
            h = 2 + (b - r) / delta;
            break;
        case b:
            h = 4 + (r - g) / delta;
            break;
    }
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$20868059344c9b7a$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        switch(v){
            case r:
                h = bdif - gdif;
                break;
            case g:
                h = 1 / 3 + rdif - bdif;
                break;
            case b:
                h = 2 / 3 + gdif - rdif;
                break;
        }
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$20868059344c9b7a$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $20868059344c9b7a$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$20868059344c9b7a$var$convert.rgb.oklab = function(rgb) {
    // Assume sRGB
    const r = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[0] / 255);
    const g = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[1] / 255);
    const b = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[2] / 255);
    const lp = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    const mp = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    const sp = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    const l = 0.2104542553 * lp + 0.793617785 * mp - 0.0040720468 * sp;
    const aa = 1.9779984951 * lp - 2.428592205 * mp + 0.4505937099 * sp;
    const bb = 0.0259040371 * lp + 0.7827717662 * mp - 0.808675766 * sp;
    return [
        l * 100,
        aa * 100,
        bb * 100
    ];
};
$20868059344c9b7a$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $20868059344c9b7a$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$20868059344c9b7a$var$convert.rgb.keyword = function(rgb) {
    const reversed = $20868059344c9b7a$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Number.POSITIVE_INFINITY;
    let currentClosestKeyword;
    for (const keyword of Object.keys((0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039))){
        const value = (0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)[keyword];
        // Compute comparative distance
        const distance = $20868059344c9b7a$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$20868059344c9b7a$var$convert.keyword.rgb = function(keyword) {
    return (0, $3cbe7ab7f006e2aa$export$2e2bcd8739ae039)[keyword];
};
$20868059344c9b7a$var$convert.rgb.xyz = function(rgb) {
    // Assume sRGB
    const r = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[0] / 255);
    const g = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[1] / 255);
    const b = $20868059344c9b7a$var$srgbNonlinearTransformInv(rgb[2] / 255);
    const x = r * 0.4124564 + g * 0.3575761 + b * 0.1804375;
    const y = r * 0.2126729 + g * 0.7151522 + b * 0.072175;
    const z = r * 0.0193339 + g * 0.119192 + b * 0.9503041;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$20868059344c9b7a$var$convert.rgb.lab = function(rgb) {
    const xyz = $20868059344c9b7a$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > $20868059344c9b7a$var$LAB_FT ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > $20868059344c9b7a$var$LAB_FT ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > $20868059344c9b7a$var$LAB_FT ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$20868059344c9b7a$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t3;
    let value;
    if (s === 0) {
        value = l * 255;
        return [
            value,
            value,
            value
        ];
    }
    const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) value = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) value = t2;
        else if (3 * t3 < 2) value = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else value = t1;
        rgb[i] = value * 255;
    }
    return rgb;
};
$20868059344c9b7a$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$20868059344c9b7a$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$20868059344c9b7a$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$20868059344c9b7a$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    // eslint-disable-next-line no-bitwise
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces, default-case-last */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces, default-case-last */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$20868059344c9b7a$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$20868059344c9b7a$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2404542 + y * -1.5371385 + z * -0.4985314;
    g = x * -0.969266 + y * 1.8760108 + z * 0.041556;
    b = x * 0.0556434 + y * -0.2040259 + z * 1.0572252;
    // Assume sRGB
    r = $20868059344c9b7a$var$srgbNonlinearTransform(r);
    g = $20868059344c9b7a$var$srgbNonlinearTransform(g);
    b = $20868059344c9b7a$var$srgbNonlinearTransform(b);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$20868059344c9b7a$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > $20868059344c9b7a$var$LAB_FT ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > $20868059344c9b7a$var$LAB_FT ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > $20868059344c9b7a$var$LAB_FT ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$20868059344c9b7a$var$convert.xyz.oklab = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    const lp = Math.cbrt(0.8189330101 * x + 0.3618667424 * y - 0.1288597137 * z);
    const mp = Math.cbrt(0.0329845436 * x + 0.9293118715 * y + 0.0361456387 * z);
    const sp = Math.cbrt(0.0482003018 * x + 0.2643662691 * y + 0.633851707 * z);
    const l = 0.2104542553 * lp + 0.793617785 * mp - 0.0040720468 * sp;
    const a = 1.9779984951 * lp - 2.428592205 * mp + 0.4505937099 * sp;
    const b = 0.0259040371 * lp + 0.7827717662 * mp - 0.808675766 * sp;
    return [
        l * 100,
        a * 100,
        b * 100
    ];
};
$20868059344c9b7a$var$convert.oklab.oklch = function(oklab) {
    return $20868059344c9b7a$var$convert.lab.lch(oklab);
};
$20868059344c9b7a$var$convert.oklab.xyz = function(oklab) {
    const ll = oklab[0] / 100;
    const a = oklab[1] / 100;
    const b = oklab[2] / 100;
    const l = (0.999999998 * ll + 0.396337792 * a + 0.215803758 * b) ** 3;
    const m = (1.000000008 * ll - 0.105561342 * a - 0.063854175 * b) ** 3;
    const s = (1.000000055 * ll - 0.089484182 * a - 1.291485538 * b) ** 3;
    const x = 1.227013851 * l - 0.55779998 * m + 0.281256149 * s;
    const y = -0.040580178 * l + 1.11225687 * m - 0.071676679 * s;
    const z = -0.076381285 * l - 0.421481978 * m + 1.58616322 * s;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$20868059344c9b7a$var$convert.oklab.rgb = function(oklab) {
    const ll = oklab[0] / 100;
    const aa = oklab[1] / 100;
    const bb = oklab[2] / 100;
    const l = (ll + 0.3963377774 * aa + 0.2158037573 * bb) ** 3;
    const m = (ll - 0.1055613458 * aa - 0.0638541728 * bb) ** 3;
    const s = (ll - 0.0894841775 * aa - 1.291485548 * bb) ** 3;
    // Assume sRGB
    const r = $20868059344c9b7a$var$srgbNonlinearTransform(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s);
    const g = $20868059344c9b7a$var$srgbNonlinearTransform(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s);
    const b = $20868059344c9b7a$var$srgbNonlinearTransform(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$20868059344c9b7a$var$convert.oklch.oklab = function(oklch) {
    return $20868059344c9b7a$var$convert.lch.lab(oklch);
};
$20868059344c9b7a$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > $20868059344c9b7a$var$LAB_FT ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > $20868059344c9b7a$var$LAB_FT ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > $20868059344c9b7a$var$LAB_FT ? z2 : (z - 16 / 116) / 7.787;
    // Illuminant D65 XYZ Tristrimulus Values
    // https://en.wikipedia.org/wiki/CIE_1931_color_space
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$20868059344c9b7a$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$20868059344c9b7a$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$20868059344c9b7a$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $20868059344c9b7a$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    /* eslint-enable no-bitwise */ if (value === 2) ansi += 60;
    return ansi;
};
$20868059344c9b7a$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $20868059344c9b7a$var$convert.rgb.ansi16($20868059344c9b7a$var$convert.hsv.rgb(args), args[2]);
};
$20868059344c9b7a$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    // eslint-disable-next-line no-bitwise
    if (r >> 4 === g >> 4 && g >> 4 === b >> 4) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$20868059344c9b7a$var$convert.ansi16.rgb = function(args) {
    args = args[0];
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (Math.trunc(args > 50) + 1) * 0.5;
    /* eslint-disable no-bitwise */ const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    /* eslint-enable no-bitwise */ return [
        r,
        g,
        b
    ];
};
$20868059344c9b7a$var$convert.ansi256.rgb = function(args) {
    args = args[0];
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$20868059344c9b7a$var$convert.rgb.hex = function(args) {
    /* eslint-disable no-bitwise */ const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    /* eslint-enable no-bitwise */ const string = integer.toString(16).toUpperCase();
    return '000000'.slice(string.length) + string;
};
$20868059344c9b7a$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f\d]{6}|[a-f\d]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = [
        ...colorString
    ].map((char)=>char + char).join('');
    const integer = Number.parseInt(colorString, 16);
    /* eslint-disable no-bitwise */ const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    /* eslint-enable no-bitwise */ return [
        r,
        g,
        b
    ];
};
$20868059344c9b7a$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let hue;
    const grayscale = chroma < 1 ? min / (1 - chroma) : 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$20868059344c9b7a$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2 * s * l : 2 * s * (1 - l);
    let f = 0;
    if (c < 1) f = (l - 0.5 * c) / (1 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$20868059344c9b7a$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$20868059344c9b7a$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$20868059344c9b7a$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1 - c);
    let f = 0;
    if (v > 0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$20868059344c9b7a$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1 - c) + 0.5 * c;
    let s = 0;
    if (l > 0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$20868059344c9b7a$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$20868059344c9b7a$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$20868059344c9b7a$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$20868059344c9b7a$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$20868059344c9b7a$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$20868059344c9b7a$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$20868059344c9b7a$var$convert.gray.hsv = $20868059344c9b7a$var$convert.gray.hsl;
$20868059344c9b7a$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$20868059344c9b7a$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$20868059344c9b7a$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$20868059344c9b7a$var$convert.gray.hex = function(gray) {
    /* eslint-disable no-bitwise */ const value = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (value << 16) + (value << 8) + value;
    /* eslint-enable no-bitwise */ const string = integer.toString(16).toUpperCase();
    return '000000'.slice(string.length) + string;
};
$20868059344c9b7a$var$convert.rgb.gray = function(rgb) {
    const value = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        value / 255 * 100
    ];
};



/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $7a6a881e446fb5de$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys((0, $20868059344c9b7a$export$2e2bcd8739ae039));
    for(let { length: length } = models, i = 0; i < length; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $7a6a881e446fb5de$var$deriveBFS(fromModel) {
    const graph = $7a6a881e446fb5de$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length > 0){
        const current = queue.pop();
        const adjacents = Object.keys((0, $20868059344c9b7a$export$2e2bcd8739ae039)[current]);
        for(let { length: length } = adjacents, i = 0; i < length; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $7a6a881e446fb5de$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $7a6a881e446fb5de$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = (0, $20868059344c9b7a$export$2e2bcd8739ae039)[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $7a6a881e446fb5de$var$link((0, $20868059344c9b7a$export$2e2bcd8739ae039)[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
function $7a6a881e446fb5de$var$route(fromModel) {
    const graph = $7a6a881e446fb5de$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let { length: length } = models, i = 0; i < length; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $7a6a881e446fb5de$var$wrapConversion(toModel, graph);
    }
    return conversion;
}
var $7a6a881e446fb5de$export$2e2bcd8739ae039 = $7a6a881e446fb5de$var$route;


const $5d8c9af4dc0cc118$var$convert = {};
const $5d8c9af4dc0cc118$var$models = Object.keys((0, $20868059344c9b7a$export$2e2bcd8739ae039));
function $5d8c9af4dc0cc118$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $5d8c9af4dc0cc118$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(let { length: length } = result, i = 0; i < length; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
for (const fromModel of $5d8c9af4dc0cc118$var$models){
    $5d8c9af4dc0cc118$var$convert[fromModel] = {};
    Object.defineProperty($5d8c9af4dc0cc118$var$convert[fromModel], 'channels', {
        value: (0, $20868059344c9b7a$export$2e2bcd8739ae039)[fromModel].channels
    });
    Object.defineProperty($5d8c9af4dc0cc118$var$convert[fromModel], 'labels', {
        value: (0, $20868059344c9b7a$export$2e2bcd8739ae039)[fromModel].labels
    });
    const routes = (0, $7a6a881e446fb5de$export$2e2bcd8739ae039)(fromModel);
    const routeModels = Object.keys(routes);
    for (const toModel of routeModels){
        const fn = routes[toModel];
        $5d8c9af4dc0cc118$var$convert[fromModel][toModel] = $5d8c9af4dc0cc118$var$wrapRounded(fn);
        $5d8c9af4dc0cc118$var$convert[fromModel][toModel].raw = $5d8c9af4dc0cc118$var$wrapRaw(fn);
    }
}
var $5d8c9af4dc0cc118$export$2e2bcd8739ae039 = $5d8c9af4dc0cc118$var$convert;


// Clamps a value between an upper and lower bound.
// We use ternary operators because it makes the minified code
// 2 times shorter then `Math.min(Math.max(a,b),c)`
const $88ec5295358fcee1$export$7d15b64cf5a3a4c4 = (number, min = 0, max = 1)=>{
    return number > max ? max : number < min ? min : number;
};
const $88ec5295358fcee1$export$2077e0241d6afd3c = (number, digits = 0, base = Math.pow(10, digits))=>{
    return Math.round(base * number) / base;
};


/**
 * Valid CSS <angle> units.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/angle
 */ const $6e6b48ba2ada0ae3$var$angleUnits = {
    grad: 0.9,
    turn: 360,
    rad: 360 / (Math.PI * 2)
};
const $6e6b48ba2ada0ae3$export$b46408e00e83b492 = (hex)=>$6e6b48ba2ada0ae3$export$f4deeebdec6065f9($6e6b48ba2ada0ae3$export$9665a07d9187b414(hex));
const $6e6b48ba2ada0ae3$export$9665a07d9187b414 = (hex)=>{
    if (hex[0] === '#') hex = hex.substring(1);
    if (hex.length < 6) return {
        r: parseInt(hex[0] + hex[0], 16),
        g: parseInt(hex[1] + hex[1], 16),
        b: parseInt(hex[2] + hex[2], 16),
        a: hex.length === 4 ? (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(parseInt(hex[3] + hex[3], 16) / 255, 2) : 1
    };
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16),
        a: hex.length === 8 ? (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(parseInt(hex.substring(6, 8), 16) / 255, 2) : 1
    };
};
const $6e6b48ba2ada0ae3$export$7c374483fd1c382f = (value, unit = 'deg')=>{
    return Number(value) * ($6e6b48ba2ada0ae3$var$angleUnits[unit] || 1);
};
const $6e6b48ba2ada0ae3$export$f1cc23c1d78956ee = (hslString)=>{
    const matcher = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hslString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $6e6b48ba2ada0ae3$export$cad8462dfe655319({
        h: $6e6b48ba2ada0ae3$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        l: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $6e6b48ba2ada0ae3$export$da6b3453e45f3684 = $6e6b48ba2ada0ae3$export$f1cc23c1d78956ee;
const $6e6b48ba2ada0ae3$export$cad8462dfe655319 = ({ h: h, s: s, l: l, a: a })=>{
    s *= (l < 50 ? l : 100 - l) / 100;
    return {
        h: h,
        s: s > 0 ? 2 * s / (l + s) * 100 : 0,
        v: l + s,
        a: a
    };
};
const $6e6b48ba2ada0ae3$export$8f550ac642b2adec = (hsva)=>$6e6b48ba2ada0ae3$export$ffee5509a14af63d($6e6b48ba2ada0ae3$export$e41dcd4e52af69bc(hsva));
const $6e6b48ba2ada0ae3$export$ea93620c892f6b62 = ({ h: h, s: s, v: v, a: a })=>{
    const hh = (200 - s) * v / 100;
    return {
        h: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(h),
        s: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hh > 0 && hh < 200 ? s * v / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
        l: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hh / 2),
        a: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(a, 2)
    };
};
const $6e6b48ba2ada0ae3$export$d4f32970db1e882f = (hsva)=>{
    const { h: h, s: s, v: v } = $6e6b48ba2ada0ae3$export$e238eb0805b2bdfe(hsva);
    return `hsv(${h}, ${s}%, ${v}%)`;
};
const $6e6b48ba2ada0ae3$export$31b9c8c33b563570 = (hsva)=>{
    const { h: h, s: s, v: v, a: a } = $6e6b48ba2ada0ae3$export$e238eb0805b2bdfe(hsva);
    return `hsva(${h}, ${s}%, ${v}%, ${a})`;
};
const $6e6b48ba2ada0ae3$export$5088895f11133875 = (hsva)=>{
    const { h: h, s: s, l: l } = $6e6b48ba2ada0ae3$export$ea93620c892f6b62(hsva);
    return `hsl(${h}, ${s}%, ${l}%)`;
};
const $6e6b48ba2ada0ae3$export$9d8fe27c1d6d5ed0 = (hsva)=>{
    const { h: h, s: s, l: l, a: a } = $6e6b48ba2ada0ae3$export$ea93620c892f6b62(hsva);
    return `hsla(${h}, ${s}%, ${l}%, ${a})`;
};
const $6e6b48ba2ada0ae3$export$e41dcd4e52af69bc = ({ h: h, s: s, v: v, a: a })=>{
    h = h / 360 * 6;
    s = s / 100;
    v = v / 100;
    const hh = Math.floor(h), b = v * (1 - s), c = v * (1 - (h - hh) * s), d = v * (1 - (1 - h + hh) * s), module = hh % 6;
    return {
        r: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)([
            v,
            c,
            b,
            b,
            d,
            v
        ][module] * 255),
        g: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)([
            d,
            v,
            v,
            c,
            b,
            b
        ][module] * 255),
        b: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)([
            b,
            b,
            d,
            v,
            v,
            c
        ][module] * 255),
        a: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(a, 2)
    };
};
const $6e6b48ba2ada0ae3$export$48759cfe1e576e90 = (hsva)=>{
    const { r: r, g: g, b: b } = $6e6b48ba2ada0ae3$export$e41dcd4e52af69bc(hsva);
    return `rgb(${r}, ${g}, ${b})`;
};
const $6e6b48ba2ada0ae3$export$4f8847fa6078ef9d = (hsva)=>{
    const { r: r, g: g, b: b, a: a } = $6e6b48ba2ada0ae3$export$e41dcd4e52af69bc(hsva);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
const $6e6b48ba2ada0ae3$export$b2d5debb615cb646 = (hsvString)=>{
    const matcher = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hsvString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $6e6b48ba2ada0ae3$export$e238eb0805b2bdfe({
        h: $6e6b48ba2ada0ae3$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        v: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $6e6b48ba2ada0ae3$export$6b2bc07f8f228168 = $6e6b48ba2ada0ae3$export$b2d5debb615cb646;
const $6e6b48ba2ada0ae3$export$8a47db680f105266 = (rgbaString)=>{
    const matcher = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(rgbaString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $6e6b48ba2ada0ae3$export$f4deeebdec6065f9({
        r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
        g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
        b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
        a: match[7] === undefined ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
    });
};
const $6e6b48ba2ada0ae3$export$43c951a6cd314995 = $6e6b48ba2ada0ae3$export$8a47db680f105266;
const $6e6b48ba2ada0ae3$var$format = (number)=>{
    const hex = number.toString(16);
    return hex.length < 2 ? '0' + hex : hex;
};
const $6e6b48ba2ada0ae3$export$ffee5509a14af63d = ({ r: r, g: g, b: b, a: a })=>{
    const alphaHex = a < 1 ? $6e6b48ba2ada0ae3$var$format((0, $88ec5295358fcee1$export$2077e0241d6afd3c)(a * 255)) : '';
    return '#' + $6e6b48ba2ada0ae3$var$format(r) + $6e6b48ba2ada0ae3$var$format(g) + $6e6b48ba2ada0ae3$var$format(b) + alphaHex;
};
const $6e6b48ba2ada0ae3$export$f4deeebdec6065f9 = ({ r: r, g: g, b: b, a: a })=>{
    const max = Math.max(r, g, b);
    const delta = max - Math.min(r, g, b);
    // prettier-ignore
    const hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
    return {
        h: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(60 * (hh < 0 ? hh + 6 : hh)),
        s: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(max ? delta / max * 100 : 0),
        v: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(max / 255 * 100),
        a: a
    };
};
const $6e6b48ba2ada0ae3$export$e238eb0805b2bdfe = (hsva)=>({
        h: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.h),
        s: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.s),
        v: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.v),
        a: (0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.a, 2)
    });
const $6e6b48ba2ada0ae3$export$e1a7c5bad5659d47 = ({ r: r, g: g, b: b })=>({
        r: r,
        g: g,
        b: b
    });
const $6e6b48ba2ada0ae3$export$933a8dde080f58ff = ({ h: h, s: s, l: l })=>({
        h: h,
        s: s,
        l: l
    });
const $6e6b48ba2ada0ae3$export$fc6c9f0fcd96330f = (hsva)=>{
    const { h: h, s: s, v: v } = $6e6b48ba2ada0ae3$export$e238eb0805b2bdfe(hsva);
    return {
        h: h,
        s: s,
        v: v
    };
};


const $0aff6f8a4bc1d069$export$2123f06676026de7 = (first, second)=>{
    if (first === second) return true;
    for(const prop in first){
        // The following allows for a type-safe calling of this function (first & second have to be HSL, HSV, or RGB)
        // with type-unsafe iterating over object keys. TS does not allow this without an index (`[key: string]: number`)
        // on an object to define how iteration is normally done. To ensure extra keys are not allowed on our types,
        // we must cast our object to unknown (as RGB demands `r` be a key, while `Record<string, x>` does not care if
        // there is or not), and then as a type TS can iterate over.
        if (first[prop] !== second[prop]) return false;
    }
    return true;
};
const $0aff6f8a4bc1d069$export$6ece4d09186dd7d4 = (first, second)=>{
    return first.replace(/\s/g, '') === second.replace(/\s/g, '');
};
const $0aff6f8a4bc1d069$export$30c81f1d8f88a836 = (first, second)=>{
    if (first.toLowerCase() === second.toLowerCase()) return true;
    // To compare colors like `#FFF` and `ffffff` we convert them into RGB objects
    return $0aff6f8a4bc1d069$export$2123f06676026de7((0, $6e6b48ba2ada0ae3$export$9665a07d9187b414)(first), (0, $6e6b48ba2ada0ae3$export$9665a07d9187b414)(second));
};


const $5cc5c9f03fa6820f$var$cache = {};
const $5cc5c9f03fa6820f$export$5dfe2efd653fcea4 = (html)=>{
    let template = $5cc5c9f03fa6820f$var$cache[html];
    if (!template) {
        template = document.createElement('template');
        template.innerHTML = html;
        $5cc5c9f03fa6820f$var$cache[html] = template;
    }
    return template;
};
const $5cc5c9f03fa6820f$export$46ff36df9b99bc25 = (target, type, detail)=>{
    target.dispatchEvent(new CustomEvent(type, {
        bubbles: true,
        detail: detail
    }));
};




let $998c34c358a62bb8$var$hasTouched = false;
// Check if an event was triggered by touch
const $998c34c358a62bb8$var$isTouch = (e)=>'touches' in e;
// Prevent mobile browsers from handling mouse events (conflicting with touch ones).
// If we detected a touch interaction before, we prefer reacting to touch events only.
const $998c34c358a62bb8$var$isValid = (event)=>{
    if ($998c34c358a62bb8$var$hasTouched && !$998c34c358a62bb8$var$isTouch(event)) return false;
    if (!$998c34c358a62bb8$var$hasTouched) $998c34c358a62bb8$var$hasTouched = $998c34c358a62bb8$var$isTouch(event);
    return true;
};
const $998c34c358a62bb8$var$pointerMove = (target, event)=>{
    const pointer = $998c34c358a62bb8$var$isTouch(event) ? event.touches[0] : event;
    const rect = target.el.getBoundingClientRect();
    (0, $5cc5c9f03fa6820f$export$46ff36df9b99bc25)(target.el, 'move', target.getMove({
        x: (0, $88ec5295358fcee1$export$7d15b64cf5a3a4c4)((pointer.pageX - (rect.left + window.pageXOffset)) / rect.width),
        y: (0, $88ec5295358fcee1$export$7d15b64cf5a3a4c4)((pointer.pageY - (rect.top + window.pageYOffset)) / rect.height)
    }));
};
const $998c34c358a62bb8$var$keyMove = (target, event)=>{
    // We use `keyCode` instead of `key` to reduce the size of the library.
    const keyCode = event.keyCode;
    // Ignore all keys except arrow ones, Page Up, Page Down, Home and End.
    if (keyCode > 40 || target.xy && keyCode < 37 || keyCode < 33) return;
    // Do not scroll page by keys when color picker element has focus.
    event.preventDefault();
    // Send relative offset to the parent component.
    (0, $5cc5c9f03fa6820f$export$46ff36df9b99bc25)(target.el, 'move', target.getMove({
        x: keyCode === 39 // Arrow Right
         ? 0.01 : keyCode === 37 // Arrow Left
         ? -0.01 : keyCode === 34 // Page Down
         ? 0.05 : keyCode === 33 // Page Up
         ? -0.05 : keyCode === 35 // End
         ? 1 : keyCode === 36 // Home
         ? -1 : 0,
        y: keyCode === 40 // Arrow down
         ? 0.01 : keyCode === 38 // Arrow Up
         ? -0.01 : 0
    }, true));
};
class $998c34c358a62bb8$export$472062a354075cee {
    constructor(root, part, aria, xy){
        const template = (0, $5cc5c9f03fa6820f$export$5dfe2efd653fcea4)(`<div role="slider" tabindex="0" part="${part}" ${aria}><div part="${part}-pointer"></div></div>`);
        root.appendChild(template.content.cloneNode(true));
        const el = root.querySelector(`[part=${part}]`);
        el.addEventListener('mousedown', this);
        el.addEventListener('touchstart', this);
        el.addEventListener('keydown', this);
        this.el = el;
        this.xy = xy;
        this.nodes = [
            el.firstChild,
            el
        ];
    }
    set dragging(state) {
        const toggleEvent = state ? document.addEventListener : document.removeEventListener;
        toggleEvent($998c34c358a62bb8$var$hasTouched ? 'touchmove' : 'mousemove', this);
        toggleEvent($998c34c358a62bb8$var$hasTouched ? 'touchend' : 'mouseup', this);
    }
    handleEvent(event) {
        switch(event.type){
            case 'mousedown':
            case 'touchstart':
                event.preventDefault();
                // event.button is 0 in mousedown for left button activation
                if (!$998c34c358a62bb8$var$isValid(event) || !$998c34c358a62bb8$var$hasTouched && event.button != 0) return;
                this.el.focus();
                $998c34c358a62bb8$var$pointerMove(this, event);
                this.dragging = true;
                break;
            case 'mousemove':
            case 'touchmove':
                event.preventDefault();
                $998c34c358a62bb8$var$pointerMove(this, event);
                break;
            case 'mouseup':
            case 'touchend':
                this.dragging = false;
                break;
            case 'keydown':
                $998c34c358a62bb8$var$keyMove(this, event);
                break;
        }
    }
    style(styles) {
        styles.forEach((style, i)=>{
            for(const p in style)this.nodes[i].style.setProperty(p, style[p]);
        });
    }
}




class $0f8f33cb686852fd$export$3e22a96a58989a47 extends (0, $998c34c358a62bb8$export$472062a354075cee) {
    constructor(root){
        super(root, 'hue', 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
    }
    update({ h: h }) {
        this.h = h;
        this.style([
            {
                left: `${h / 360 * 100}%`,
                color: (0, $6e6b48ba2ada0ae3$export$5088895f11133875)({
                    h: h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute('aria-valuenow', `${(0, $88ec5295358fcee1$export$2077e0241d6afd3c)(h)}`);
    }
    getMove(offset, key) {
        // Hue measured in degrees of the color circle ranging from 0 to 360
        return {
            h: key ? (0, $88ec5295358fcee1$export$7d15b64cf5a3a4c4)(this.h + offset.x * 360, 0, 360) : 360 * offset.x
        };
    }
}





class $c7bcf36f54cc95d5$export$c4dbe12ffaee3c8e extends (0, $998c34c358a62bb8$export$472062a354075cee) {
    constructor(root){
        super(root, 'saturation', 'aria-label="Color"', true);
    }
    update(hsva) {
        this.hsva = hsva;
        this.style([
            {
                top: `${100 - hsva.v}%`,
                left: `${hsva.s}%`,
                color: (0, $6e6b48ba2ada0ae3$export$5088895f11133875)(hsva)
            },
            {
                'background-color': (0, $6e6b48ba2ada0ae3$export$5088895f11133875)({
                    h: hsva.h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute('aria-valuetext', `Saturation ${(0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.s)}%, Brightness ${(0, $88ec5295358fcee1$export$2077e0241d6afd3c)(hsva.v)}%`);
    }
    getMove(offset, key) {
        // Saturation and brightness always fit into [0, 100] range
        return {
            s: key ? (0, $88ec5295358fcee1$export$7d15b64cf5a3a4c4)(this.hsva.s + offset.x * 100, 0, 100) : offset.x * 100,
            v: key ? (0, $88ec5295358fcee1$export$7d15b64cf5a3a4c4)(this.hsva.v - offset.y * 100, 0, 100) : Math.round(100 - offset.y * 100)
        };
    }
}


var $b88d6417d7c84cde$export$2e2bcd8739ae039 = `:host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}`;


var $f4f39bc35985dfcc$export$2e2bcd8739ae039 = `[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}`;


var $a6dc66d54ee7021b$export$2e2bcd8739ae039 = `[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}`;


const $88c515df4bef566c$var$$isSame = Symbol('same');
const $88c515df4bef566c$var$$color = Symbol('color');
const $88c515df4bef566c$var$$hsva = Symbol('hsva');
const $88c515df4bef566c$var$$update = Symbol('update');
const $88c515df4bef566c$var$$parts = Symbol('parts');
const $88c515df4bef566c$export$639d3bf3586a8ae1 = Symbol('css');
const $88c515df4bef566c$export$6892090d606d23aa = Symbol('sliders');
class $88c515df4bef566c$export$9feb1bc2e5f1ccb3 extends HTMLElement {
    static get observedAttributes() {
        return [
            'color'
        ];
    }
    get [$88c515df4bef566c$export$639d3bf3586a8ae1]() {
        return [
            (0, $b88d6417d7c84cde$export$2e2bcd8739ae039),
            (0, $f4f39bc35985dfcc$export$2e2bcd8739ae039),
            (0, $a6dc66d54ee7021b$export$2e2bcd8739ae039)
        ];
    }
    get [$88c515df4bef566c$export$6892090d606d23aa]() {
        return [
            (0, $c7bcf36f54cc95d5$export$c4dbe12ffaee3c8e),
            (0, $0f8f33cb686852fd$export$3e22a96a58989a47)
        ];
    }
    get color() {
        return this[$88c515df4bef566c$var$$color];
    }
    set color(newColor) {
        if (!this[$88c515df4bef566c$var$$isSame](newColor)) {
            const newHsva = this.colorModel.toHsva(newColor);
            this[$88c515df4bef566c$var$$update](newHsva);
            this[$88c515df4bef566c$var$$color] = newColor;
        }
    }
    constructor(){
        super();
        const template = (0, $5cc5c9f03fa6820f$export$5dfe2efd653fcea4)(`<style>${this[$88c515df4bef566c$export$639d3bf3586a8ae1].join('')}</style>`);
        const root = this.attachShadow({
            mode: 'open'
        });
        root.appendChild(template.content.cloneNode(true));
        root.addEventListener('move', this);
        this[$88c515df4bef566c$var$$parts] = this[$88c515df4bef566c$export$6892090d606d23aa].map((slider)=>new slider(root));
    }
    connectedCallback() {
        // A user may set a property on an _instance_ of an element,
        // before its prototype has been connected to this class.
        // If so, we need to run it through the proper class setter.
        if (this.hasOwnProperty('color')) {
            const value = this.color;
            delete this['color'];
            this.color = value;
        } else if (!this.color) this.color = this.colorModel.defaultColor;
    }
    attributeChangedCallback(_attr, _oldVal, newVal) {
        const color = this.colorModel.fromAttr(newVal);
        if (!this[$88c515df4bef566c$var$$isSame](color)) this.color = color;
    }
    handleEvent(event) {
        // Merge the current HSV color object with updated params.
        const oldHsva = this[$88c515df4bef566c$var$$hsva];
        const newHsva = {
            ...oldHsva,
            ...event.detail
        };
        this[$88c515df4bef566c$var$$update](newHsva);
        let newColor;
        if (!(0, $0aff6f8a4bc1d069$export$2123f06676026de7)(newHsva, oldHsva) && !this[$88c515df4bef566c$var$$isSame](newColor = this.colorModel.fromHsva(newHsva))) {
            this[$88c515df4bef566c$var$$color] = newColor;
            (0, $5cc5c9f03fa6820f$export$46ff36df9b99bc25)(this, 'color-changed', {
                value: newColor
            });
        }
    }
    [$88c515df4bef566c$var$$isSame](color) {
        return this.color && this.colorModel.equal(color, this.color);
    }
    [$88c515df4bef566c$var$$update](hsva) {
        this[$88c515df4bef566c$var$$hsva] = hsva;
        this[$88c515df4bef566c$var$$parts].forEach((part)=>part.update(hsva));
    }
}




const $76bf0a72600f66c5$var$colorModel = {
    defaultColor: '#000',
    toHsva: (0, $6e6b48ba2ada0ae3$export$b46408e00e83b492),
    fromHsva: ({ h: h, s: s, v: v })=>(0, $6e6b48ba2ada0ae3$export$8f550ac642b2adec)({
            h: h,
            s: s,
            v: v,
            a: 1
        }),
    equal: (0, $0aff6f8a4bc1d069$export$30c81f1d8f88a836),
    fromAttr: (color)=>color
};
class $76bf0a72600f66c5$export$aac89129a4eb37b4 extends (0, $88c515df4bef566c$export$9feb1bc2e5f1ccb3) {
    get colorModel() {
        return $76bf0a72600f66c5$var$colorModel;
    }
}



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/viewcollection
*/ /**
* Collects {@link module:ui/view~View} instances.
*
* ```ts
* const parentView = new ParentView( locale );
* const collection = new ViewCollection( locale );
*
* collection.setParent( parentView.element );
*
* const viewA = new ChildView( locale );
* const viewB = new ChildView( locale );
* ```
*
* View collection renders and manages view {@link module:ui/view~View#element elements}:
*
* ```ts
* collection.add( viewA );
* collection.add( viewB );
*
* console.log( parentView.element.firsChild ); // -> viewA.element
* console.log( parentView.element.lastChild ); // -> viewB.element
* ```
*
* It {@link module:ui/viewcollection~ViewCollection#delegate propagates} DOM events too:
*
* ```ts
* // Delegate #click and #keydown events from viewA and viewB to the parentView.
* collection.delegate( 'click' ).to( parentView );
*
* parentView.on( 'click', ( evt ) => {
* 	console.log( `${ evt.source } has been clicked.` );
* } );
*
* // This event will be delegated to the parentView.
* viewB.fire( 'click' );
* ```
*
* **Note**: A view collection can be used directly in the {@link module:ui/template~TemplateDefinition definition}
* of a {@link module:ui/template~Template template}.
*/ var $29fd27cb9bdab9d2$export$ff20b327de53fba7 = class extends (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec) {
    /**
	* A parent element within which child views are rendered and managed in DOM.
	*/ _parentElement;
    /**
	* Creates a new instance of the {@link module:ui/viewcollection~ViewCollection}.
	*
	* @param initialItems The initial items of the collection.
	*/ constructor(initialItems = []){
        super(initialItems, {
            idProperty: "viewUid"
        });
        this.on("add", (evt, view, index)=>{
            this._renderViewIntoCollectionParent(view, index);
        });
        this.on("remove", (evt, view)=>{
            if (view.element && this._parentElement) view.element.remove();
        });
        this._parentElement = null;
    }
    /**
	* Destroys the view collection along with child views.
	* See the view {@link module:ui/view~View#destroy} method.
	*/ destroy() {
        this.map((view)=>view.destroy());
    }
    /**
	* Sets the parent HTML element of this collection. When parent is set, {@link #add adding} and
	* {@link #remove removing} views in the collection synchronizes their
	* {@link module:ui/view~View#element elements} in the parent element.
	*
	* @param elementOrDocFragment A new parent element or document fragment.
	*/ setParent(elementOrDocFragment) {
        this._parentElement = elementOrDocFragment;
        for (const view of this)this._renderViewIntoCollectionParent(view);
    }
    /**
	* Delegates selected events coming from within views in the collection to any
	* {@link module:utils/emittermixin~Emitter}.
	*
	* For the following views and collection:
	*
	* ```ts
	* const viewA = new View();
	* const viewB = new View();
	* const viewC = new View();
	*
	* const views = parentView.createCollection();
	*
	* views.delegate( 'eventX' ).to( viewB );
	* views.delegate( 'eventX', 'eventY' ).to( viewC );
	*
	* views.add( viewA );
	* ```
	*
	* the `eventX` is delegated (fired by) `viewB` and `viewC` along with `customData`:
	*
	* ```ts
	* viewA.fire( 'eventX', customData );
	* ```
	*
	* and `eventY` is delegated (fired by) `viewC` along with `customData`:
	*
	* ```ts
	* viewA.fire( 'eventY', customData );
	* ```
	*
	* See {@link module:utils/emittermixin~Emitter#delegate}.
	*
	* @param events {@link module:ui/view~View} event names to be delegated to another
	* {@link module:utils/emittermixin~Emitter}.
	* @returns Object with `to` property, a function which accepts the destination
	* of {@link module:utils/emittermixin~Emitter#delegate delegated} events.
	*/ delegate(...events) {
        if (!events.length || !$29fd27cb9bdab9d2$var$isStringArray(events)) /**
		* All event names must be strings.
		*
		* @error ui-viewcollection-delegate-wrong-events
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-viewcollection-delegate-wrong-events", this);
        return {
            to: (dest)=>{
                for (const view of this)for (const evtName of events)view.delegate(evtName).to(dest);
                this.on("add", (evt, view)=>{
                    for (const evtName of events)view.delegate(evtName).to(dest);
                });
                this.on("remove", (evt, view)=>{
                    for (const evtName of events)view.stopDelegating(evtName, dest);
                });
            }
        };
    }
    /**
	* This method {@link module:ui/view~View#render renders} a new view added to the collection.
	*
	* If the {@link #_parentElement parent element} of the collection is set, this method also adds
	* the view's {@link module:ui/view~View#element} as a child of the parent in DOM at a specified index.
	*
	* **Note**: If index is not specified, the view's element is pushed as the last child
	* of the parent element.
	*
	* @param view A new view added to the collection.
	* @param index An index the view holds in the collection. When not specified,
	* the view is added at the end.
	*/ _renderViewIntoCollectionParent(view, index) {
        if (!view.isRendered) view.render();
        if (view.element && this._parentElement) this._parentElement.insertBefore(view.element, this._parentElement.children[index]);
    }
    /**
	* Removes a child view from the collection. If the {@link #setParent parent element} of the
	* collection has been set, the {@link module:ui/view~View#element element} of the view is also removed
	* in DOM, reflecting the order of the collection.
	*
	* See the {@link #add} method.
	*
	* @param subject The view to remove, its id or index in the collection.
	* @returns The removed view.
	*/ remove(subject) {
        return super.remove(subject);
    }
};
/**
* Check if all entries of the array are of `String` type.
*
* @param arr An array to be checked.
*/ function $29fd27cb9bdab9d2$var$isStringArray(arr) {
    return arr.every((a)=>typeof a == "string");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/template
*/ const $29fd27cb9bdab9d2$var$xhtmlNs = "http://www.w3.org/1999/xhtml";
const $29fd27cb9bdab9d2$var$TemplateBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* A basic Template class. It renders a DOM HTML element or text from a
* {@link module:ui/template~TemplateDefinition definition} and supports element attributes, children,
* bindings to {@link module:utils/observablemixin~Observable observables} and DOM event propagation.
*
* A simple template can look like this:
*
* ```ts
* const bind = Template.bind( observable, emitter );
*
* new Template( {
* 	tag: 'p',
* 	attributes: {
* 		class: 'foo',
* 		style: {
* 			backgroundColor: 'yellow'
* 		}
* 	},
* 	on: {
* 		click: bind.to( 'clicked' )
* 	},
* 	children: [
* 		'A paragraph.'
* 	]
* } ).render();
* ```
*
* and it will render the following HTML element:
*
* ```html
* <p class="foo" style="background-color: yellow;">A paragraph.</p>
* ```
*
* Additionally, the `observable` will always fire `clicked` upon clicking `<p>` in the DOM.
*
* See {@link module:ui/template~TemplateDefinition} to know more about templates and complex
* template definitions.
*/ var $29fd27cb9bdab9d2$export$14416b8d99d47caa = class extends $29fd27cb9bdab9d2$var$TemplateBase {
    ns;
    /**
	* The tag (`tagName`) of this template, e.g. `div`. It also indicates that the template
	* renders to an HTML element.
	*/ tag;
    /**
	* The text of the template. It also indicates that the template renders to a DOM text node.
	*/ text;
    /**
	* The attributes of the template, e.g. `{ id: [ 'ck-id' ] }`, corresponding with
	* the attributes of an HTML element.
	*
	* **Note**: This property only makes sense when {@link #tag} is defined.
	*/ attributes;
    /**
	* The children of the template. They can be either:
	* * independent instances of {@link ~Template} (sub–templates),
	* * native DOM Nodes.
	*
	* **Note**: This property only makes sense when {@link #tag} is defined.
	*/ children;
    /**
	* The DOM event listeners of the template.
	*/ eventListeners;
    /**
	* Indicates whether this particular Template instance has been
	* {@link #render rendered}.
	*/ _isRendered;
    /**
	* The data used by the {@link #revert} method to restore a node to its original state.
	*
	* See: {@link #apply}.
	*/ _revertData;
    /**
	* Creates an instance of the {@link ~Template} class.
	*
	* @param def The definition of the template.
	*/ constructor(def){
        super();
        Object.assign(this, $29fd27cb9bdab9d2$var$normalize($29fd27cb9bdab9d2$var$clone(def)));
        this._isRendered = false;
        this._revertData = null;
    }
    /**
	* Renders a DOM Node (an HTML element or text) out of the template.
	*
	* ```ts
	* const domNode = new Template( { ... } ).render();
	* ```
	*
	* See: {@link #apply}.
	*/ render() {
        const node = this._renderNode({
            intoFragment: true
        });
        this._isRendered = true;
        return node;
    }
    /**
	* Applies the template to an existing DOM Node, either HTML element or text.
	*
	* **Note:** No new DOM nodes will be created. Applying extends:
	*
	* {@link module:ui/template~TemplateDefinition attributes},
	* {@link module:ui/template~TemplateDefinition event listeners}, and
	* `textContent` of {@link module:ui/template~TemplateDefinition children} only.
	*
	* **Note:** Existing `class` and `style` attributes are extended when a template
	* is applied to an HTML element, while other attributes and `textContent` are overridden.
	*
	* **Note:** The process of applying a template can be easily reverted using the
	* {@link module:ui/template~Template#revert} method.
	*
	* ```ts
	* const element = document.createElement( 'div' );
	* const observable = new Model( { divClass: 'my-div' } );
	* const emitter = Object.create( EmitterMixin );
	* const bind = Template.bind( observable, emitter );
	*
	* new Template( {
	* 	attributes: {
	* 		id: 'first-div',
	* 		class: bind.to( 'divClass' )
	* 	},
	* 	on: {
	* 		click: bind( 'elementClicked' ) // Will be fired by the observable.
	* 	},
	* 	children: [
	* 		'Div text.'
	* 	]
	* } ).apply( element );
	*
	* console.log( element.outerHTML ); // -> '<div id="first-div" class="my-div"></div>'
	* ```
	*
	* @see module:ui/template~Template#render
	* @see module:ui/template~Template#revert
	* @param node Root node for the template to apply.
	*/ apply(node) {
        this._revertData = $29fd27cb9bdab9d2$var$getEmptyRevertData();
        this._renderNode({
            node: node,
            intoFragment: false,
            isApplying: true,
            revertData: this._revertData
        });
        return node;
    }
    /**
	* Reverts a template {@link module:ui/template~Template#apply applied} to a DOM node.
	*
	* @param node The root node for the template to revert. In most of the cases, it is the
	* same node used by {@link module:ui/template~Template#apply}.
	*/ revert(node) {
        if (!this._revertData) /**
		* Attempting to revert a template which has not been applied yet.
		*
		* @error ui-template-revert-not-applied
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-template-revert-not-applied", [
            this,
            node
        ]);
        this._revertTemplateFromNode(node, this._revertData);
    }
    /**
	* Returns an iterator which traverses the template in search of {@link module:ui/view~View}
	* instances and returns them one by one.
	*
	* ```ts
	* const viewFoo = new View();
	* const viewBar = new View();
	* const viewBaz = new View();
	* const template = new Template( {
	* 	tag: 'div',
	* 	children: [
	* 		viewFoo,
	* 		{
	* 			tag: 'div',
	* 			children: [
	* 				viewBar
	* 			]
	* 		},
	* 		viewBaz
	* 	]
	* } );
	*
	* // Logs: viewFoo, viewBar, viewBaz
	* for ( const view of template.getViews() ) {
	* 	console.log( view );
	* }
	* ```
	*/ *getViews() {
        function* search(def) {
            if (def.children) {
                for (const child of def.children)if ($29fd27cb9bdab9d2$var$isView(child)) yield child;
                else if ($29fd27cb9bdab9d2$var$isTemplate(child)) yield* search(child);
            }
        }
        yield* search(this);
    }
    /**
	* An entry point to the interface which binds DOM nodes to
	* {@link module:utils/observablemixin~Observable observables}.
	* There are two types of bindings:
	*
	* * HTML element attributes or text `textContent` synchronized with attributes of an
	* {@link module:utils/observablemixin~Observable}. Learn more about {@link module:ui/template~BindChain#to}
	* and {@link module:ui/template~BindChain#if}.
	*
	* ```ts
	* const bind = Template.bind( observable, emitter );
	*
	* new Template( {
	* 	attributes: {
	* 		// Binds the element "class" attribute to observable#classAttribute.
	* 		class: bind.to( 'classAttribute' )
	* 	}
	* } ).render();
	* ```
	*
	* * DOM events fired on HTML element propagated through
	* {@link module:utils/observablemixin~Observable}. Learn more about {@link module:ui/template~BindChain#to}.
	*
	* ```ts
	* const bind = Template.bind( observable, emitter );
	*
	* new Template( {
	* 	on: {
	* 		// Will be fired by the observable.
	* 		click: bind( 'elementClicked' )
	* 	}
	* } ).render();
	* ```
	*
	* Also see {@link module:ui/view~View#bindTemplate}.
	*
	* @param observable An observable which provides boundable attributes.
	* @param emitter An emitter that listens to observable attribute
	* changes or DOM Events (depending on the kind of the binding). Usually, a {@link module:ui/view~View} instance.
	*/ static bind(observable, emitter) {
        return {
            to (eventNameOrFunctionOrAttribute, callback) {
                return new $29fd27cb9bdab9d2$export$3ae4d338e63ea04b({
                    eventNameOrFunction: eventNameOrFunctionOrAttribute,
                    attribute: eventNameOrFunctionOrAttribute,
                    observable: observable,
                    emitter: emitter,
                    callback: callback
                });
            },
            if (attribute, valueIfTrue, callback) {
                return new $29fd27cb9bdab9d2$export$9bc7b790d090b6c8({
                    observable: observable,
                    emitter: emitter,
                    attribute: attribute,
                    valueIfTrue: valueIfTrue,
                    callback: callback
                });
            }
        };
    }
    /**
	* Extends an existing {@link module:ui/template~Template} instance with some additional content
	* from another {@link module:ui/template~TemplateDefinition}.
	*
	* ```ts
	* const bind = Template.bind( observable, emitter );
	*
	* const template = new Template( {
	* 	tag: 'p',
	* 	attributes: {
	* 		class: 'a',
	* 		data-x: bind.to( 'foo' )
	* 	},
	* 	children: [
	* 		{
	* 			tag: 'span',
	* 			attributes: {
	* 				class: 'b'
	* 			},
	* 			children: [
	* 				'Span'
	* 			]
	* 		}
	* 	]
	*  } );
	*
	* // Instance-level extension.
	* Template.extend( template, {
	* 	attributes: {
	* 		class: 'b',
	* 		data-x: bind.to( 'bar' )
	* 	},
	* 	children: [
	* 		{
	* 			attributes: {
	* 				class: 'c'
	* 			}
	* 		}
	* 	]
	* } );
	*
	* // Child extension.
	* Template.extend( template.children[ 0 ], {
	* 	attributes: {
	* 		class: 'd'
	* 	}
	* } );
	* ```
	*
	* the `outerHTML` of `template.render()` is:
	*
	* ```html
	* <p class="a b" data-x="{ observable.foo } { observable.bar }">
	* 	<span class="b c d">Span</span>
	* </p>
	* ```
	*
	* @param template An existing template instance to be extended.
	* @param def Additional definition to be applied to a template.
	*/ static extend(template, def) {
        if (template._isRendered) /**
		* Extending a template after rendering may not work as expected. To make sure
		* the {@link module:ui/template~Template.extend extending} works for an element,
		* make sure it happens before {@link module:ui/template~Template#render} is called.
		*
		* @error template-extend-render
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("template-extend-render", [
            this,
            template
        ]);
        $29fd27cb9bdab9d2$var$extendTemplate(template, $29fd27cb9bdab9d2$var$normalize($29fd27cb9bdab9d2$var$clone(def)));
    }
    /**
	* Renders a DOM Node (either an HTML element or text) out of the template.
	*
	* @param data Rendering data.
	*/ _renderNode(data) {
        let isInvalid;
        if (data.node) isInvalid = this.tag && this.text;
        else isInvalid = this.tag ? this.text : !this.text;
        if (isInvalid) /**
		* Node definition cannot have the "tag" and "text" properties at the same time.
		* Node definition must have either "tag" or "text" when rendering a new Node.
		*
		* @error ui-template-wrong-syntax
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-template-wrong-syntax", this);
        if (this.text) return this._renderText(data);
        else return this._renderElement(data);
    }
    /**
	* Renders an HTML element out of the template.
	*
	* @param data Rendering data.
	*/ _renderElement(data) {
        let node = data.node;
        if (!node) node = data.node = document.createElementNS(this.ns || $29fd27cb9bdab9d2$var$xhtmlNs, this.tag);
        this._renderAttributes(data);
        this._renderElementChildren(data);
        this._setUpListeners(data);
        return node;
    }
    /**
	* Renders a text node out of {@link module:ui/template~Template#text}.
	*
	* @param data Rendering data.
	*/ _renderText(data) {
        let node = data.node;
        if (node) data.revertData.text = node.textContent;
        else node = data.node = document.createTextNode("");
        if ($29fd27cb9bdab9d2$var$hasTemplateBinding(this.text)) this._bindToObservable({
            schema: this.text,
            updater: $29fd27cb9bdab9d2$var$getTextUpdater(node),
            data: data
        });
        else node.textContent = this.text.join("");
        return node;
    }
    /**
	* Renders HTML element attributes out of {@link module:ui/template~Template#attributes}.
	*
	* @param data Rendering data.
	*/ _renderAttributes(data) {
        if (!this.attributes) return;
        const node = data.node;
        const revertData = data.revertData;
        for(const attrName in this.attributes){
            const domAttrValue = node.getAttribute(attrName);
            const attrValue = this.attributes[attrName];
            if (revertData) revertData.attributes[attrName] = domAttrValue;
            const attrNs = $29fd27cb9bdab9d2$var$isNamespaced(attrValue) ? attrValue[0].ns : null;
            if ($29fd27cb9bdab9d2$var$hasTemplateBinding(attrValue)) {
                const valueToBind = $29fd27cb9bdab9d2$var$isNamespaced(attrValue) ? attrValue[0].value : attrValue;
                if (revertData && $29fd27cb9bdab9d2$var$shouldExtend(attrName)) valueToBind.unshift(domAttrValue);
                this._bindToObservable({
                    schema: valueToBind,
                    updater: $29fd27cb9bdab9d2$var$getAttributeUpdater(node, attrName, attrNs),
                    data: data
                });
            } else if (attrName == "style" && typeof attrValue[0] !== "string") this._renderStyleAttribute(attrValue[0], data);
            else {
                if (revertData && domAttrValue && $29fd27cb9bdab9d2$var$shouldExtend(attrName)) attrValue.unshift(domAttrValue);
                const value = attrValue.map((val)=>val ? val.value || val : val).reduce((prev, next)=>prev.concat(next), []).reduce($29fd27cb9bdab9d2$var$arrayValueReducer, "");
                if (!$29fd27cb9bdab9d2$var$isFalsy(value)) node.setAttributeNS(attrNs, attrName, value);
            }
        }
    }
    /**
	* Renders the `style` attribute of an HTML element based on
	* {@link module:ui/template~Template#attributes}.
	*
	* A style attribute is an object with static values:
	*
	* ```ts
	* attributes: {
	* 	style: {
	* 		color: 'red',
	* 		'--color': 'red'
	* 	}
	* }
	* ```
	*
	* or values bound to {@link module:ui/model~UIModel} properties:
	*
	* ```ts
	* attributes: {
	* 	style: {
	* 		color: bind.to( ... ),
	* 		'--color': bind.to( ... )
	* 	}
	* }
	* ```
	*
	* Note: The `style` attribute is rendered without setting the namespace. It does not seem to be
	* needed.
	*
	* @param styles Styles located in `attributes.style` of {@link module:ui/template~TemplateDefinition}.
	* @param data Rendering data.
	*/ _renderStyleAttribute(styles, data) {
        const node = data.node;
        for(const styleName in styles){
            const styleValue = styles[styleName];
            if ($29fd27cb9bdab9d2$var$hasTemplateBinding(styleValue)) this._bindToObservable({
                schema: [
                    styleValue
                ],
                updater: $29fd27cb9bdab9d2$var$getStyleUpdater(node, styleName),
                data: data
            });
            else if ($29fd27cb9bdab9d2$var$isCssVariable(styleName)) node.style.setProperty(styleName, styleValue);
            else node.style[styleName] = styleValue;
        }
    }
    /**
	* Recursively renders HTML element's children from {@link module:ui/template~Template#children}.
	*
	* @param data Rendering data.
	*/ _renderElementChildren(data) {
        const node = data.node;
        const container = data.intoFragment ? document.createDocumentFragment() : node;
        const isApplying = data.isApplying;
        let childIndex = 0;
        for (const child of this.children)if ($29fd27cb9bdab9d2$var$isViewCollection(child)) {
            if (!isApplying) {
                child.setParent(node);
                for (const view of child)container.appendChild(view.element);
            }
        } else if ($29fd27cb9bdab9d2$var$isView(child)) {
            if (!isApplying) {
                if (!child.isRendered) child.render();
                container.appendChild(child.element);
            }
        } else if ((0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(child)) container.appendChild(child);
        else if (isApplying) {
            const revertData = data.revertData;
            const childRevertData = $29fd27cb9bdab9d2$var$getEmptyRevertData();
            revertData.children.push(childRevertData);
            child._renderNode({
                intoFragment: false,
                node: container.childNodes[childIndex++],
                isApplying: true,
                revertData: childRevertData
            });
        } else container.appendChild(child.render());
        if (data.intoFragment) node.appendChild(container);
    }
    /**
	* Activates `on` event listeners from the {@link module:ui/template~TemplateDefinition}
	* on an HTML element.
	*
	* @param data Rendering data.
	*/ _setUpListeners(data) {
        if (!this.eventListeners) return;
        for(const key in this.eventListeners){
            const revertBindings = this.eventListeners[key].map((schemaItem)=>{
                const [domEvtName, domSelector] = key.split("@");
                return schemaItem.activateDomEventListener(domEvtName, domSelector, data);
            });
            if (data.revertData) data.revertData.bindings.push(revertBindings);
        }
    }
    /**
	* For a given {@link module:ui/template~TemplateValueSchema} containing {@link module:ui/template~TemplateBinding}
	* activates the binding and sets its initial value.
	*
	* Note: {@link module:ui/template~TemplateValueSchema} can be for HTML element attributes or
	* text node `textContent`.
	*
	* @param options Binding options.
	* @param options.updater A function which updates the DOM (like attribute or text).
	* @param options.data Rendering data.
	*/ _bindToObservable({ schema: schema, updater: updater, data: data }) {
        const revertData = data.revertData;
        $29fd27cb9bdab9d2$var$syncValueSchemaValue(schema, updater, data);
        const revertBindings = schema.filter((item)=>!$29fd27cb9bdab9d2$var$isFalsy(item)).filter((item)=>item.observable).map((templateBinding)=>templateBinding.activateAttributeListener(schema, updater, data));
        if (revertData) revertData.bindings.push(revertBindings);
    }
    /**
	* Reverts {@link module:ui/template~RenderData#revertData template data} from a node to
	* return it to the original state.
	*
	* @param node A node to be reverted.
	* @param revertData An object that stores information about what changes have been made by
	* {@link #apply} to the node. See {@link module:ui/template~RenderData#revertData} for more information.
	*/ _revertTemplateFromNode(node, revertData) {
        for (const binding of revertData.bindings)for (const revertBinding of binding)revertBinding();
        if (revertData.text) {
            node.textContent = revertData.text;
            return;
        }
        const element = node;
        for(const attrName in revertData.attributes){
            const attrValue = revertData.attributes[attrName];
            if (attrValue === null) element.removeAttribute(attrName);
            else element.setAttribute(attrName, attrValue);
        }
        for(let i = 0; i < revertData.children.length; ++i)this._revertTemplateFromNode(element.childNodes[i], revertData.children[i]);
    }
};
/**
* Describes a binding created by the {@link module:ui/template~Template.bind} interface.
*
* @internal
*/ var $29fd27cb9bdab9d2$export$2a8775bc42223060 = class {
    /**
	* The name of the {@link module:ui/template~TemplateBinding#observable observed attribute}.
	*/ attribute;
    /**
	* An observable instance of the binding. It either:
	*
	* * provides the attribute with the value,
	* * or passes the event when a corresponding DOM event is fired.
	*/ observable;
    /**
	* An {@link module:utils/emittermixin~Emitter} used by the binding to:
	*
	* * listen to the attribute change in the {@link module:ui/template~TemplateBinding#observable},
	* * or listen to the event in the DOM.
	*/ emitter;
    /**
	* A custom function to process the value of the {@link module:ui/template~TemplateBinding#attribute}.
	*/ callback;
    /**
	* Creates an instance of the {@link module:ui/template~TemplateBinding} class.
	*
	* @param def The definition of the binding.
	*/ constructor(def){
        this.attribute = def.attribute;
        this.observable = def.observable;
        this.emitter = def.emitter;
        this.callback = def.callback;
    }
    /**
	* Returns the value of the binding. It is the value of the {@link module:ui/template~TemplateBinding#attribute} in
	* {@link module:ui/template~TemplateBinding#observable}. The value may be processed by the
	* {@link module:ui/template~TemplateBinding#callback}, if such has been passed to the binding.
	*
	* @param node A native DOM node, passed to the custom {@link module:ui/template~TemplateBinding#callback}.
	* @returns The value of {@link module:ui/template~TemplateBinding#attribute} in
	* {@link module:ui/template~TemplateBinding#observable}.
	*/ getValue(node) {
        const value = this.observable[this.attribute];
        return this.callback ? this.callback(value, node) : value;
    }
    /**
	* Activates the listener which waits for changes of the {@link module:ui/template~TemplateBinding#attribute} in
	* {@link module:ui/template~TemplateBinding#observable}, then updates the DOM with the aggregated
	* value of {@link module:ui/template~TemplateValueSchema}.
	*
	* @param schema A full schema to generate an attribute or text in the DOM.
	* @param updater A DOM updater function used to update the native DOM attribute or text.
	* @param data Rendering data.
	* @returns A function to sever the listener binding.
	*/ activateAttributeListener(schema, updater, data) {
        const callback = ()=>$29fd27cb9bdab9d2$var$syncValueSchemaValue(schema, updater, data);
        this.emitter.listenTo(this.observable, `change:${this.attribute}`, callback);
        return ()=>{
            this.emitter.stopListening(this.observable, `change:${this.attribute}`, callback);
        };
    }
};
/**
* Describes either:
*
* * a binding to an {@link module:utils/observablemixin~Observable},
* * or a native DOM event binding.
*
* It is created by the {@link module:ui/template~BindChain#to} method.
*
* @internal
*/ var $29fd27cb9bdab9d2$export$3ae4d338e63ea04b = class extends $29fd27cb9bdab9d2$export$2a8775bc42223060 {
    eventNameOrFunction;
    constructor(def){
        super(def);
        this.eventNameOrFunction = def.eventNameOrFunction;
    }
    /**
	* Activates the listener for the native DOM event, which when fired, is propagated by
	* the {@link module:ui/template~TemplateBinding#emitter}.
	*
	* @param domEvtName The name of the native DOM event.
	* @param domSelector The selector in the DOM to filter delegated events.
	* @param data Rendering data.
	* @returns A function to sever the listener binding.
	*/ activateDomEventListener(domEvtName, domSelector, data) {
        const callback = (evt, domEvt)=>{
            if (!domSelector || domEvt.target.matches(domSelector)) {
                if (typeof this.eventNameOrFunction == "function") this.eventNameOrFunction(domEvt);
                else this.observable.fire(this.eventNameOrFunction, domEvt);
            }
        };
        this.emitter.listenTo(data.node, domEvtName, callback);
        return ()=>{
            this.emitter.stopListening(data.node, domEvtName, callback);
        };
    }
};
/**
* Describes a binding to {@link module:utils/observablemixin~Observable} created by the {@link module:ui/template~BindChain#if}
* method.
*
* @internal
*/ var $29fd27cb9bdab9d2$export$9bc7b790d090b6c8 = class extends $29fd27cb9bdab9d2$export$2a8775bc42223060 {
    /**
	* The value of the DOM attribute or text to be set if the {@link module:ui/template~TemplateBinding#attribute} in
	* {@link module:ui/template~TemplateBinding#observable} is `true`.
	*/ valueIfTrue;
    constructor(def){
        super(def);
        this.valueIfTrue = def.valueIfTrue;
    }
    /**
	* @inheritDoc
	*/ getValue(node) {
        return $29fd27cb9bdab9d2$var$isFalsy(super.getValue(node)) ? false : this.valueIfTrue || true;
    }
};
/**
* Checks whether given {@link module:ui/template~TemplateValueSchema} contains a
* {@link module:ui/template~TemplateBinding}.
*/ function $29fd27cb9bdab9d2$var$hasTemplateBinding(schema) {
    if (!schema) return false;
    if (schema.value) schema = schema.value;
    if (Array.isArray(schema)) return schema.some($29fd27cb9bdab9d2$var$hasTemplateBinding);
    else if (schema instanceof $29fd27cb9bdab9d2$export$2a8775bc42223060) return true;
    return false;
}
/**
* Checks whether the given name is a valid CSS variable name.
*
* A valid CSS variable name starts with two dashes (`--`), followed by a letter, underscore (`_`),
* or dash (`-`), and can be followed by any combination of letters, digits, underscores, dashes,
* or additional dashes.
*
* @param name The name to validate as a CSS variable.
* @returns True if the name is a valid CSS variable, false otherwise.
*/ function $29fd27cb9bdab9d2$var$isCssVariable(name) {
    return /^--[a-zA-Z_-][\w-]*$/.test(name);
}
/**
* Assembles the value using {@link module:ui/template~TemplateValueSchema} and stores it in a form of
* an Array. Each entry of the Array corresponds to one of {@link module:ui/template~TemplateValueSchema}
* items.
*
* @param node DOM Node updated when {@link module:utils/observablemixin~Observable} changes.
*/ function $29fd27cb9bdab9d2$var$getValueSchemaValue(schema, node) {
    return schema.map((schemaItem)=>{
        if (schemaItem instanceof $29fd27cb9bdab9d2$export$2a8775bc42223060) return schemaItem.getValue(node);
        return schemaItem;
    });
}
/**
* A function executed each time the bound Observable attribute changes, which updates the DOM with a value
* constructed from {@link module:ui/template~TemplateValueSchema}.
*
* @param updater A function which updates the DOM (like attribute or text).
* @param node DOM Node updated when {@link module:utils/observablemixin~Observable} changes.
*/ function $29fd27cb9bdab9d2$var$syncValueSchemaValue(schema, updater, { node: node }) {
    const values = $29fd27cb9bdab9d2$var$getValueSchemaValue(schema, node);
    let value;
    if (schema.length == 1 && schema[0] instanceof $29fd27cb9bdab9d2$export$9bc7b790d090b6c8) value = values[0];
    else value = values.reduce($29fd27cb9bdab9d2$var$arrayValueReducer, "");
    if ($29fd27cb9bdab9d2$var$isFalsy(value)) updater.remove();
    else updater.set(value);
}
/**
* Returns an object consisting of `set` and `remove` functions, which
* can be used in the context of DOM Node to set or reset `textContent`.
* @see module:ui/view~View#_bindToObservable
*
* @param node DOM Node to be modified.
*/ function $29fd27cb9bdab9d2$var$getTextUpdater(node) {
    return {
        set (value) {
            node.textContent = value;
        },
        remove () {
            node.textContent = "";
        }
    };
}
/**
* Returns an object consisting of `set` and `remove` functions, which
* can be used in the context of DOM Node to set or reset an attribute.
* @see module:ui/view~View#_bindToObservable
*
* @param el DOM Node to be modified.
* @param attrName Name of the attribute to be modified.
* @param ns Namespace to use.
*/ function $29fd27cb9bdab9d2$var$getAttributeUpdater(el, attrName, ns) {
    return {
        set (value) {
            el.setAttributeNS(ns, attrName, value);
        },
        remove () {
            el.removeAttributeNS(ns, attrName);
        }
    };
}
/**
* Returns an object consisting of `set` and `remove` functions, which
* can be used in the context of CSSStyleDeclaration to set or remove a style.
* @see module:ui/view~View#_bindToObservable
*
* @param el DOM Node to be modified.
* @param styleName Name of the style to be modified.
*/ function $29fd27cb9bdab9d2$var$getStyleUpdater(el, styleName) {
    return {
        set (value) {
            if ($29fd27cb9bdab9d2$var$isCssVariable(styleName)) el.style.setProperty(styleName, value);
            else el.style[styleName] = value;
        },
        remove () {
            if ($29fd27cb9bdab9d2$var$isCssVariable(styleName)) el.style.removeProperty(styleName);
            else el.style[styleName] = null;
        }
    };
}
/**
* Clones definition of the template.
*/ function $29fd27cb9bdab9d2$var$clone(def) {
    return (0, $850a6c1e0528b9df$export$684657552801b6ad)(def, (value)=>{
        if (value && (value instanceof $29fd27cb9bdab9d2$export$2a8775bc42223060 || $29fd27cb9bdab9d2$var$isTemplate(value) || $29fd27cb9bdab9d2$var$isView(value) || $29fd27cb9bdab9d2$var$isViewCollection(value))) return value;
    });
}
/**
* Normalizes given {@link module:ui/template~TemplateDefinition}.
*
* See:
*  * {@link normalizeAttributes}
*  * {@link normalizeListeners}
*  * {@link normalizePlainTextDefinition}
*  * {@link normalizeTextDefinition}
*
* @param def A template definition.
* @returns Normalized definition.
*/ function $29fd27cb9bdab9d2$var$normalize(def) {
    if (typeof def == "string") def = $29fd27cb9bdab9d2$var$normalizePlainTextDefinition(def);
    else if (def.text) $29fd27cb9bdab9d2$var$normalizeTextDefinition(def);
    if (def.on) {
        def.eventListeners = $29fd27cb9bdab9d2$var$normalizeListeners(def.on);
        delete def.on;
    }
    if (!def.text) {
        if (def.attributes) $29fd27cb9bdab9d2$var$normalizeAttributes(def.attributes);
        const children = [];
        if (def.children) {
            if ($29fd27cb9bdab9d2$var$isViewCollection(def.children)) children.push(def.children);
            else for (const child of def.children)if ($29fd27cb9bdab9d2$var$isTemplate(child) || $29fd27cb9bdab9d2$var$isView(child) || (0, $c7bc2cb7e2db0227$export$8ee0fc9ee280b4ee)(child)) children.push(child);
            else children.push(new $29fd27cb9bdab9d2$export$14416b8d99d47caa(child));
        }
        def.children = children;
    }
    return def;
}
/**
* Normalizes "attributes" section of {@link module:ui/template~TemplateDefinition}.
*
* ```
* attributes: {
* 	a: 'bar',
* 	b: {@link module:ui/template~TemplateBinding},
* 	c: {
* 		value: 'bar'
* 	}
* }
* ```
*
* becomes
*
* ```
* attributes: {
* 	a: [ 'bar' ],
* 	b: [ {@link module:ui/template~TemplateBinding} ],
* 	c: {
* 		value: [ 'bar' ]
* 	}
* }
* ```
*/ function $29fd27cb9bdab9d2$var$normalizeAttributes(attributes) {
    for(const a in attributes){
        if (attributes[a].value) attributes[a].value = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(attributes[a].value);
        $29fd27cb9bdab9d2$var$arrayify(attributes, a);
    }
}
/**
* Normalizes "on" section of {@link module:ui/template~TemplateDefinition}.
*
* ```
* on: {
* 	a: 'bar',
* 	b: {@link module:ui/template~TemplateBinding},
* 	c: [ {@link module:ui/template~TemplateBinding}, () => { ... } ]
* }
* ```
*
* becomes
*
* ```
* on: {
* 	a: [ 'bar' ],
* 	b: [ {@link module:ui/template~TemplateBinding} ],
* 	c: [ {@link module:ui/template~TemplateBinding}, () => { ... } ]
* }
* ```
*
* @returns Object containing normalized listeners.
*/ function $29fd27cb9bdab9d2$var$normalizeListeners(listeners) {
    for(const l in listeners)$29fd27cb9bdab9d2$var$arrayify(listeners, l);
    return listeners;
}
/**
* Normalizes "string" {@link module:ui/template~TemplateDefinition}.
*
* ```
* "foo"
* ```
*
* becomes
*
* ```
* { text: [ 'foo' ] },
* ```
*
* @returns Normalized template definition.
*/ function $29fd27cb9bdab9d2$var$normalizePlainTextDefinition(def) {
    return {
        text: [
            def
        ]
    };
}
/**
* Normalizes text {@link module:ui/template~TemplateDefinition}.
*
* ```
* children: [
* 	{ text: 'def' },
* 	{ text: {@link module:ui/template~TemplateBinding} }
* ]
* ```
*
* becomes
*
* ```
* children: [
* 	{ text: [ 'def' ] },
* 	{ text: [ {@link module:ui/template~TemplateBinding} ] }
* ]
* ```
*/ function $29fd27cb9bdab9d2$var$normalizeTextDefinition(def) {
    def.text = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(def.text);
}
/**
* Wraps an entry in Object in an Array, if not already one.
*
* ```
* {
* 	x: 'y',
* 	a: [ 'b' ]
* }
* ```
*
* becomes
*
* ```
* {
* 	x: [ 'y' ],
* 	a: [ 'b' ]
* }
* ```
*/ function $29fd27cb9bdab9d2$var$arrayify(obj, key) {
    obj[key] = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(obj[key]);
}
/**
* A helper which concatenates the value avoiding unwanted
* leading white spaces.
*/ function $29fd27cb9bdab9d2$var$arrayValueReducer(prev, cur) {
    if ($29fd27cb9bdab9d2$var$isFalsy(cur)) return prev;
    else if ($29fd27cb9bdab9d2$var$isFalsy(prev)) return cur;
    else return `${prev} ${cur}`;
}
/**
* Extends one object defined in the following format:
*
* ```
* {
* 	key1: [Array1],
* 	key2: [Array2],
* 	...
* 	keyN: [ArrayN]
* }
* ```
*
* with another object of the same data format.
*
* @param obj Base object.
* @param ext Object extending base.
*/ function $29fd27cb9bdab9d2$var$extendObjectValueArray(obj, ext) {
    for(const a in ext)if (obj[a]) obj[a].push(...ext[a]);
    else obj[a] = ext[a];
}
/**
* A helper for {@link module:ui/template~Template#extend}. Recursively extends {@link module:ui/template~Template} instance
* with content from {@link module:ui/template~TemplateDefinition}. See {@link module:ui/template~Template#extend} to learn more.
*
* @param def A template instance to be extended.
* @param def A definition which is to extend the template instance.
* @param Error context.
*/ function $29fd27cb9bdab9d2$var$extendTemplate(template, def) {
    if (def.attributes) {
        if (!template.attributes) template.attributes = {};
        $29fd27cb9bdab9d2$var$extendObjectValueArray(template.attributes, def.attributes);
    }
    if (def.eventListeners) {
        if (!template.eventListeners) template.eventListeners = {};
        $29fd27cb9bdab9d2$var$extendObjectValueArray(template.eventListeners, def.eventListeners);
    }
    if (def.text) template.text.push(...def.text);
    if (def.children && def.children.length) {
        if (template.children.length != def.children.length) /**
		* The number of children in extended definition does not match.
		*
		* @error ui-template-extend-children-mismatch
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-template-extend-children-mismatch", template);
        let childIndex = 0;
        for (const childDef of def.children)$29fd27cb9bdab9d2$var$extendTemplate(template.children[childIndex++], childDef);
    }
}
/**
* Checks if value is "falsy".
* Note: 0 (Number) is not "falsy" in this context.
*
* @param value Value to be checked.
*/ function $29fd27cb9bdab9d2$var$isFalsy(value) {
    return !value && value !== 0;
}
/**
* Checks if the item is an instance of {@link module:ui/view~View}
*
* @param value Value to be checked.
*/ function $29fd27cb9bdab9d2$var$isView(item) {
    return item instanceof $29fd27cb9bdab9d2$export$27a5bd065ad55220;
}
/**
* Checks if the item is an instance of {@link module:ui/template~Template}
*
* @param value Value to be checked.
*/ function $29fd27cb9bdab9d2$var$isTemplate(item) {
    return item instanceof $29fd27cb9bdab9d2$export$14416b8d99d47caa;
}
/**
* Checks if the item is an instance of {@link module:ui/viewcollection~ViewCollection}
*
* @param value Value to be checked.
*/ function $29fd27cb9bdab9d2$var$isViewCollection(item) {
    return item instanceof $29fd27cb9bdab9d2$export$ff20b327de53fba7;
}
/**
* Checks if value array contains the one with namespace.
*/ function $29fd27cb9bdab9d2$var$isNamespaced(attrValue) {
    return (0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(attrValue[0]) && attrValue[0].ns;
}
/**
* Creates an empty skeleton for {@link module:ui/template~Template#revert}
* data.
*/ function $29fd27cb9bdab9d2$var$getEmptyRevertData() {
    return {
        children: [],
        bindings: [],
        attributes: {}
    };
}
/**
* Checks whether an attribute should be extended when
* {@link module:ui/template~Template#apply} is called.
*
* @param attrName Attribute name to check.
*/ function $29fd27cb9bdab9d2$var$shouldExtend(attrName) {
    return attrName == "class" || attrName == "style";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/view
*/ const $29fd27cb9bdab9d2$var$ViewBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)(/* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)());
/**
* The basic view class, which represents an HTML element created out of a
* {@link module:ui/view~View#template}. Views are building blocks of the user interface and handle
* interaction
*
* Views {@link module:ui/view~View#registerChild aggregate} children in
* {@link module:ui/view~View#createCollection collections} and manage the life cycle of DOM
* listeners e.g. by handling rendering and destruction.
*
* See the {@link module:ui/template~TemplateDefinition} syntax to learn more about shaping view
* elements, attributes and listeners.
*
* ```ts
* class SampleView extends View {
* 	constructor( locale ) {
* 		super( locale );
*
* 		const bind = this.bindTemplate;
*
* 		// Views define their interface (state) using observable attributes.
* 		this.set( 'elementClass', 'bar' );
*
* 		this.setTemplate( {
* 			tag: 'p',
*
* 			// The element of the view can be defined with its children.
* 			children: [
* 				'Hello',
* 				{
* 					tag: 'b',
* 					children: [ 'world!' ]
* 				}
* 			],
* 			attributes: {
* 				class: [
* 					'foo',
*
* 					// Observable attributes control the state of the view in DOM.
* 					bind.to( 'elementClass' )
* 				]
* 			},
* 			on: {
* 				// Views listen to DOM events and propagate them.
* 				click: bind.to( 'clicked' )
* 			}
* 		} );
* 	}
* }
*
* const view = new SampleView( locale );
*
* view.render();
*
* // Append <p class="foo bar">Hello<b>world</b></p> to the <body>
* document.body.appendChild( view.element );
*
* // Change the class attribute to <p class="foo baz">Hello<b>world</b></p>
* view.elementClass = 'baz';
*
* // Respond to the "click" event in DOM by executing a custom action.
* view.on( 'clicked', () => {
* 	console.log( 'The view has been clicked!' );
* } );
* ```
*
* @property {TElement | null} element An HTML element of the view. `null` until {@link module:ui/view~View#render rendered}
* from the {@link module:ui/view~View#template template}. The class-level example above illustrates typical usage. The
* full description, fenced examples, and assignment note are in the block comment immediately above the `element` field
* in the source.
*/ var $29fd27cb9bdab9d2$export$27a5bd065ad55220 = class extends $29fd27cb9bdab9d2$var$ViewBase {
    element;
    /**
	* Set `true` when the view has already been {@link module:ui/view~View#render rendered}.
	*
	* @readonly
	*/ isRendered;
    /**
	* A set of tools to localize the user interface.
	*
	* Also see {@link module:core/editor/editor~Editor#locale}.
	*
	* @readonly
	*/ locale;
    /**
	* Shorthand for {@link module:utils/locale~Locale#t}.
	*
	* Note: If {@link #locale} instance hasn't been passed to the view this method may not
	* be available.
	*
	* @see module:utils/locale~Locale#t
	*/ t;
    /**
	* Template of this view. It provides the {@link #element} representing
	* the view in DOM, which is {@link #render rendered}.
	*/ template;
    /**
	* Collections registered with {@link #createCollection}.
	*/ _viewCollections;
    /**
	* A collection of view instances, which have been added directly
	* into the {@link module:ui/template~Template#children}.
	*/ _unboundChildren;
    /**
	* Cached {@link module:ui/template~BindChain bind chain} object created by the
	* {@link #template}. See {@link #bindTemplate}.
	*/ _bindTemplate;
    /**
	* Creates an instance of the {@link module:ui/view~View} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super();
        this.element = null;
        this.isRendered = false;
        this.locale = locale;
        this.t = locale && locale.t;
        this._viewCollections = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        this._unboundChildren = this.createCollection();
        this._viewCollections.on("add", (evt, collection)=>{
            collection.locale = locale;
            collection.t = locale && locale.t;
        });
        this.decorate("render");
    }
    /**
	* Shorthand for {@link module:ui/template~Template.bind}, a binding
	* {@link module:ui/template~BindChain interface} pre–configured for the view instance.
	*
	* It provides {@link module:ui/template~BindChain#to `to()`} and
	* {@link module:ui/template~BindChain#if `if()`} methods that initialize bindings with
	* observable attributes and attach DOM listeners.
	*
	* ```ts
	* class SampleView extends View {
	* 	constructor( locale ) {
	* 		super( locale );
	*
	* 		const bind = this.bindTemplate;
	*
	* 		// These {@link module:utils/observablemixin~Observable observable} attributes will control
	* 		// the state of the view in DOM.
	* 		this.set( {
	* 			elementClass: 'foo',
	* 		 	isEnabled: true
	* 		 } );
	*
	* 		this.setTemplate( {
	* 			tag: 'p',
	*
	* 			attributes: {
	* 				// The class HTML attribute will follow elementClass
	* 				// and isEnabled view attributes.
	* 				class: [
	* 					bind.to( 'elementClass' )
	* 					bind.if( 'isEnabled', 'present-when-enabled' )
	* 				]
	* 			},
	*
	* 			on: {
	* 				// The view will fire the "clicked" event upon clicking <p> in DOM.
	* 				click: bind.to( 'clicked' )
	* 			}
	* 		} );
	* 	}
	* }
	* ```
	*/ get bindTemplate() {
        if (this._bindTemplate) return this._bindTemplate;
        return this._bindTemplate = $29fd27cb9bdab9d2$export$14416b8d99d47caa.bind(this, this);
    }
    /**
	* Creates a new collection of views, which can be used as
	* {@link module:ui/template~Template#children} of this view.
	*
	* ```ts
	* class SampleView extends View {
	* 	constructor( locale ) {
	* 		super( locale );
	*
	* 		const child = new ChildView( locale );
	* 		this.items = this.createCollection( [ child ] );
	*
	* 		this.setTemplate( {
	* 			tag: 'p',
	*
	* 			// `items` collection will render here.
	* 			children: this.items
	* 		} );
	* 	}
	* }
	*
	* const view = new SampleView( locale );
	* view.render();
	*
	* // It will append <p><child#element></p> to the <body>.
	* document.body.appendChild( view.element );
	* ```
	*
	* @param views Initial views of the collection.
	* @returns A new collection of view instances.
	*/ createCollection(views) {
        const collection = new $29fd27cb9bdab9d2$export$ff20b327de53fba7(views);
        this._viewCollections.add(collection);
        return collection;
    }
    /**
	* Registers a new child view under the view instance. Once registered, a child
	* view is managed by its parent, including {@link #render rendering}
	* and {@link #destroy destruction}.
	*
	* To revert this, use {@link #deregisterChild}.
	*
	* ```ts
	* class SampleView extends View {
	* 	constructor( locale ) {
	* 		super( locale );
	*
	* 		this.childA = new SomeChildView( locale );
	* 		this.childB = new SomeChildView( locale );
	*
	* 		this.setTemplate( { tag: 'p' } );
	*
	* 		// Register the children.
	* 		this.registerChild( [ this.childA, this.childB ] );
	* 	}
	*
	* 	render() {
	* 		super.render();
	*
	* 		this.element.appendChild( this.childA.element );
	* 		this.element.appendChild( this.childB.element );
	* 	}
	* }
	*
	* const view = new SampleView( locale );
	*
	* view.render();
	*
	* // Will append <p><childA#element><b></b><childB#element></p>.
	* document.body.appendChild( view.element );
	* ```
	*
	* **Note**: There's no need to add child views if they're already referenced in the
	* {@link #template}:
	*
	* ```ts
	* class SampleView extends View {
	* 	constructor( locale ) {
	* 		super( locale );
	*
	* 		this.childA = new SomeChildView( locale );
	* 		this.childB = new SomeChildView( locale );
	*
	* 		this.setTemplate( {
	* 			tag: 'p',
	*
	* 			// These children will be added automatically. There's no
	* 			// need to call {@link #registerChild} for any of them.
	* 			children: [ this.childA, this.childB ]
	* 		} );
	* 	}
	*
	* 	// ...
	* }
	* ```
	*
	* @param children Children views to be registered.
	*/ registerChild(children) {
        if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(children)) children = [
            children
        ];
        for (const child of children)this._unboundChildren.add(child);
    }
    /**
	* The opposite of {@link #registerChild}. Removes a child view from this view instance.
	* Once removed, the child is no longer managed by its parent, e.g. it can safely
	* become a child of another parent view.
	*
	* @see #registerChild
	* @param children Child views to be removed.
	*/ deregisterChild(children) {
        if (!(0, $c7bc2cb7e2db0227$export$9652023d9040757)(children)) children = [
            children
        ];
        for (const child of children)this._unboundChildren.remove(child);
    }
    /**
	* Sets the {@link #template} of the view with with given definition.
	*
	* A shorthand for:
	*
	* ```ts
	* view.setTemplate( definition );
	* ```
	*
	* @param definition Definition of view's template.
	*/ setTemplate(definition) {
        this.template = new $29fd27cb9bdab9d2$export$14416b8d99d47caa(definition);
    }
    /**
	* {@link module:ui/template~Template.extend Extends} the {@link #template} of the view with
	* with given definition.
	*
	* A shorthand for:
	*
	* ```ts
	* Template.extend( view.template, definition );
	* ```
	*
	* **Note**: Is requires the {@link #template} to be already set. See {@link #setTemplate}.
	*
	* @param definition Definition which extends the {@link #template}.
	*/ extendTemplate(definition) {
        $29fd27cb9bdab9d2$export$14416b8d99d47caa.extend(this.template, definition);
    }
    /**
	* Recursively renders the view.
	*
	* Once the view is rendered:
	* * the {@link #element} becomes an HTML element out of {@link #template},
	* * the {@link #isRendered} flag is set `true`.
	*
	* **Note**: The children of the view:
	* * defined directly in the {@link #template}
	* * residing in collections created by the {@link #createCollection} method,
	* * and added by {@link #registerChild}
	* are also rendered in the process.
	*
	* In general, `render()` method is the right place to keep the code which refers to the
	* {@link #element} and should be executed at the very beginning of the view's life cycle.
	*
	* It is possible to {@link module:ui/template~Template.extend} the {@link #template} before
	* the view is rendered. To allow an early customization of the view (e.g. by its parent),
	* such references should be done in `render()`.
	*
	* ```ts
	* class SampleView extends View {
	* 	constructor() {
	* 		this.setTemplate( {
	* 			// ...
	* 		} );
	* 	},
	*
	* 	render() {
	* 		// View#element becomes available.
	* 		super.render();
	*
	* 		// The "scroll" listener depends on #element.
	* 		this.listenTo( window, 'scroll', () => {
	* 			// A reference to #element would render the #template and make it non-extendable.
	* 			if ( window.scrollY > 0 ) {
	* 				this.element.scrollLeft = 100;
	* 			} else {
	* 				this.element.scrollLeft = 0;
	* 			}
	* 		} );
	* 	}
	* }
	*
	* const view = new SampleView();
	*
	* // Let's customize the view before it gets rendered.
	* view.extendTemplate( {
	* 	attributes: {
	* 		class: [
	* 			'additional-class'
	* 		]
	* 	}
	* } );
	*
	* // Late rendering allows customization of the view.
	* view.render();
	* ```
	*/ render() {
        if (this.isRendered) /**
		* This View has already been rendered.
		*
		* @error ui-view-render-already-rendered
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-view-render-already-rendered", this);
        if (this.template) {
            this.element = this.template.render();
            this.registerChild(this.template.getViews());
        }
        this.isRendered = true;
    }
    /**
	* Recursively destroys the view instance and child views added by {@link #registerChild} and
	* residing in collections created by the {@link #createCollection}.
	*
	* Destruction disables all event listeners:
	* * created on the view, e.g. `view.on( 'event', () => {} )`,
	* * defined in the {@link #template} for DOM events.
	*/ destroy() {
        this.stopListening();
        this._viewCollections.map((c)=>c.destroy());
        if (this.template && this.template._revertData) this.template.revert(this.element);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The politeness level of an `aria-live` announcement.
*
* Available keys are:
* * `AriaLiveAnnouncerPoliteness.POLITE`,
* * `AriaLiveAnnouncerPoliteness.ASSERTIVE`
*
* [Learn more](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions#Politeness_levels).
*/ const $29fd27cb9bdab9d2$export$c716e2ef56cd41f1 = {
    POLITE: "polite",
    ASSERTIVE: "assertive"
};
/**
* An accessibility helper that manages all ARIA live regions associated with an editor instance. ARIA live regions announce changes
* to the state of the editor features.
*
* These announcements are consumed and propagated by screen readers and give users a better understanding of the current
* state of the editor.
*
* To announce a state change to an editor use the {@link #announce} method:
*
* ```ts
* editor.ui.ariaLiveAnnouncer.announce( 'Text of an announcement.' );
* ```
*/ var $29fd27cb9bdab9d2$export$dd4ec0a44a434104 = class {
    /**
	* The editor instance.
	*/ editor;
    /**
	* The view that aggregates all `aria-live` regions.
	*/ view;
    /**
	* @inheritDoc
	*/ constructor(editor){
        this.editor = editor;
        /**
		* Some screen readers only look at changes in the aria-live region.
		* They might not read a region that already has content when it is added.
		* To stop this problem, make sure to set up regions for all politeness settings when the editor starts.
		*/ editor.once("ready", ()=>{
            for (const politeness of Object.values($29fd27cb9bdab9d2$export$c716e2ef56cd41f1))this.announce("", politeness);
        });
    }
    /**
	* Sets an announcement text to an aria region that is then announced by a screen reader to the user.
	*
	* If the aria region of a specified politeness does not exist, it will be created and can be re-used later.
	*
	* The default announcement politeness level is `'polite'`.
	*
	* ```ts
	* // Most screen readers will queue announcements from multiple aria-live regions and read them out in the order they were emitted.
	* editor.ui.ariaLiveAnnouncer.announce( 'Image uploaded.' );
	* editor.ui.ariaLiveAnnouncer.announce( 'Connection lost. Reconnecting.' );
	* ```
	*/ announce(announcement, attributes = $29fd27cb9bdab9d2$export$c716e2ef56cd41f1.POLITE) {
        const editor = this.editor;
        if (!editor.ui.view) return;
        if (!this.view) {
            this.view = new $29fd27cb9bdab9d2$export$f3f93bcf06eec621(editor.locale);
            editor.ui.view.body.add(this.view);
        }
        const { politeness: politeness, isUnsafeHTML: isUnsafeHTML } = typeof attributes === "string" ? {
            politeness: attributes
        } : attributes;
        let politenessRegionView = this.view.regionViews.find((view)=>view.politeness === politeness);
        if (!politenessRegionView) {
            politenessRegionView = new $29fd27cb9bdab9d2$export$e9b58b50f1969d77(editor, politeness);
            this.view.regionViews.add(politenessRegionView);
        }
        politenessRegionView.announce({
            announcement: announcement,
            isUnsafeHTML: isUnsafeHTML
        });
    }
};
/**
* The view that aggregates all `aria-live` regions.
*/ var $29fd27cb9bdab9d2$export$f3f93bcf06eec621 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of all views that represent individual `aria-live` regions.
	*/ regionViews;
    constructor(locale){
        super(locale);
        this.regionViews = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-aria-live-announcer"
                ]
            },
            children: this.regionViews
        });
    }
};
/**
* The view that represents a single `aria-live`.
*/ var $29fd27cb9bdab9d2$export$e9b58b50f1969d77 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Current politeness level of the region.
	*/ politeness;
    /**
	* DOM converter used to sanitize unsafe HTML passed to {@link #announce} method.
	*/ _domConverter;
    /**
	* Interval used to remove additions. It prevents accumulation of added nodes in region.
	*/ _pruneAnnouncementsInterval;
    constructor(editor, politeness){
        super(editor.locale);
        this.setTemplate({
            tag: "div",
            attributes: {
                "aria-live": politeness,
                "aria-relevant": "additions"
            },
            children: [
                {
                    tag: "ul",
                    attributes: {
                        class: [
                            "ck",
                            "ck-aria-live-region-list"
                        ]
                    }
                }
            ]
        });
        editor.on("destroy", ()=>{
            /* v8 ignore else -- @preserve */ if (this._pruneAnnouncementsInterval !== null) {
                clearInterval(this._pruneAnnouncementsInterval);
                this._pruneAnnouncementsInterval = null;
            }
        });
        this.politeness = politeness;
        this._domConverter = editor.data.htmlProcessor.domConverter;
        this._pruneAnnouncementsInterval = setInterval(()=>{
            if (this.element && this._listElement.firstChild) this._listElement.firstChild.remove();
        }, 5e3);
    }
    /**
	* Appends new announcement to region.
	*/ announce({ announcement: announcement, isUnsafeHTML: isUnsafeHTML }) {
        if (!announcement.trim().length) return;
        const messageListItem = document.createElement("li");
        if (isUnsafeHTML) this._domConverter.setContentOf(messageListItem, announcement);
        else messageListItem.innerText = announcement;
        this._listElement.appendChild(messageListItem);
    }
    /**
	* Return current announcements list HTML element.
	*/ get _listElement() {
        return this.element.querySelector("ul");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/bindings/clickoutsidehandler
*/ /**
* Handles clicking **outside** of a specified set of elements, then fires an action.
*
* **Note**: Actually, the action is executed upon `mousedown`, not `click`. It prevents
* certain issues when the user keeps holding the mouse button and the UI cannot react
* properly.
*
* @param options Configuration options.
* @param options.emitter The emitter to which this behavior should be added.
* @param options.activator Function returning a `Boolean`, to determine whether the handler is active.
* @param options.contextElements Array of HTML elements or a callback returning an array of HTML elements
* that determine the scope of the handler. Clicking any of them or their descendants will **not** fire the callback.
* @param options.callback An action executed by the handler.
*/ function $29fd27cb9bdab9d2$export$16d2a52659b91b8a({ emitter: emitter, activator: activator, callback: callback, contextElements: contextElements }) {
    const listenedRoots = /* @__PURE__ */ new WeakSet();
    let insideContext = false;
    function getContextElements() {
        return (typeof contextElements == "function" ? contextElements() : contextElements).filter((element)=>element);
    }
    function listenToContextElementRoots(contextElements) {
        for (const contextElement of contextElements){
            const root = contextElement.getRootNode();
            if (root === document || !(0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(root) || listenedRoots.has(root)) continue;
            listenedRoots.add(root);
            emitter.listenTo(root, "mousedown", (evt, domEvt)=>{
                if (activator() && $29fd27cb9bdab9d2$var$isInsideContext(domEvt, getContextElements())) insideContext = true;
            });
        }
    }
    emitter.listenTo(document, "mousedown", ()=>{
        if (activator()) listenToContextElementRoots(getContextElements());
        insideContext = false;
    }, {
        useCapture: true
    });
    emitter.listenTo(document, "mousedown", (evt, domEvt)=>{
        if (activator() && !$29fd27cb9bdab9d2$var$isInsideContext(domEvt, getContextElements()) && !insideContext) callback();
        insideContext = false;
    });
}
/**
* Returns true when the given DOM event target is indide any of context elements.
*/ function $29fd27cb9bdab9d2$var$isInsideContext(domEvt, contextElements) {
    for (const contextElement of contextElements)if (contextElement.contains(domEvt.target)) return true;
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A mixin that brings the possibility to temporarily disable CSS transitions using
* {@link module:ui/view~View} methods. It is helpful when, for instance, the transitions should not happen
* when the view is first displayed but they should work normal in other cases.
*
* The methods to control the CSS transitions are:
* * `disableCssTransitions()` – Adds the `.ck-transitions-disabled` class to the
* {@link module:ui/view~View#element view element}.
* * `enableCssTransitions()` – Removes the `.ck-transitions-disabled` class from the
* {@link module:ui/view~View#element view element}.
*
* The usage comes down to:
*
* ```ts
* const MyViewWithCssTransitionDisabler = CssTransitionDisablerMixin( MyView );
* const view = new MyViewWithCssTransitionDisabler();
*
* // ...
*
* view.disableCssTransitions();
* view.show();
* view.enableCssTransitions();
* ```
*
* @param view View instance that should get this functionality.
*/ function $29fd27cb9bdab9d2$export$715574b9e52d1468(view) {
    class Mixin extends view {
        disableCssTransitions() {
            this._isCssTransitionsDisabled = true;
        }
        enableCssTransitions() {
            this._isCssTransitionsDisabled = false;
        }
        constructor(...args){
            super(...args);
            this.set("_isCssTransitionsDisabled", false);
            this.initializeCssTransitionDisablerMixin();
        }
        initializeCssTransitionDisablerMixin() {
            if (this.template) this.extendTemplate({
                attributes: {
                    class: [
                        this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")
                    ]
                }
            });
        }
    }
    return Mixin;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A mixin that brings the possibility to observe dragging of the view element.
* The view has to implement the {@link ~DraggableView} interface to use it:
*
* ```js
* export class MyDraggableView extends DraggableViewMixin( View ) implements DraggableView {
* 		// ...
* }
* ```
*
* Creating a class extending it attaches a set of mouse and touch listeners allowing to observe dragging of the view element:
* * `mousedown` and `touchstart` on the view element - starting the dragging.
* * `mousemove` and `touchmove` on the document - updating the view coordinates.
* * `mouseup` and `touchend` on the document - stopping the dragging.
*
* The mixin itself does not provide a visual feedback (that is, the dragged element does not change its position) -
* it is up to the developer to implement it.
*/ function $29fd27cb9bdab9d2$export$c315ca8d42e0291b(view) {
    class DraggableMixin extends view {
        /**
		* A bound version of {@link #_onDrag}.
		*/ _onDragBound = this._onDrag.bind(this);
        /**
		* A bound version of {@link #_onDragEnd}.
		*/ _onDragEndBound = this._onDragEnd.bind(this);
        /**
		* The last coordinates of the view. It is updated on every mouse move.
		*/ _lastDraggingCoordinates = {
            x: 0,
            y: 0
        };
        /**
		* @inheritDoc
		*/ constructor(...args){
            super(...args);
            this.on("render", ()=>{
                this._attachListeners();
            });
            this.set("isDragging", false);
        }
        /**
		* Attaches the listeners for the drag start.
		*/ _attachListeners() {
            this.listenTo(this.element, "mousedown", this._onDragStart.bind(this));
            this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
        }
        /**
		* Attaches the listeners for the dragging and drag end.
		*/ _attachDragListeners() {
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mouseup", this._onDragEndBound);
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "touchend", this._onDragEndBound);
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mousemove", this._onDragBound);
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "touchmove", this._onDragBound);
        }
        /**
		* Detaches the listeners after the drag end.
		*/ _detachDragListeners() {
            this.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mouseup", this._onDragEndBound);
            this.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "touchend", this._onDragEndBound);
            this.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mousemove", this._onDragBound);
            this.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "touchmove", this._onDragBound);
        }
        /**
		* Starts the dragging listeners and sets the initial view coordinates.
		*/ _onDragStart(evt, domEvt) {
            if (!this._isHandleElementPressed(domEvt)) return;
            this._attachDragListeners();
            let x;
            let y;
            if (domEvt instanceof MouseEvent) {
                x = domEvt.clientX;
                y = domEvt.clientY;
            } else {
                x = domEvt.touches[0].clientX;
                y = domEvt.touches[0].clientY;
            }
            this._lastDraggingCoordinates = {
                x: x,
                y: y
            };
            this.isDragging = true;
        }
        /**
		* Updates the view coordinates and fires the `drag` event.
		*/ _onDrag(evt, domEvt) {
            if (!this.isDragging) {
                this._detachDragListeners();
                return;
            }
            let newX;
            let newY;
            if (domEvt instanceof MouseEvent) {
                newX = domEvt.clientX;
                newY = domEvt.clientY;
            } else {
                newX = domEvt.touches[0].clientX;
                newY = domEvt.touches[0].clientY;
            }
            domEvt.preventDefault();
            this.fire("drag", {
                deltaX: Math.round(newX - this._lastDraggingCoordinates.x),
                deltaY: Math.round(newY - this._lastDraggingCoordinates.y)
            });
            this._lastDraggingCoordinates = {
                x: newX,
                y: newY
            };
        }
        /**
		* Stops the dragging and detaches the listeners.
		*/ _onDragEnd() {
            this._detachDragListeners();
            this.isDragging = false;
        }
        /**
		* Checks if the drag handle element was pressed.
		*/ _isHandleElementPressed(domEvt) {
            if (!this.dragHandleElement) return false;
            return this.dragHandleElement === domEvt.target || domEvt.target instanceof HTMLElement && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(this.dragHandleElement, domEvt.target);
        }
    }
    return DraggableMixin;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A handler useful for {@link module:ui/view~View views} working as HTML forms. It intercepts a native DOM
* `submit` event, prevents the default web browser behavior (navigation and page reload) and
* fires the `submit` event on a view instead. Such a custom event can be then used by any
* {@link module:utils/dom/emittermixin~DomEmitter emitter}, e.g. to serialize the form data.
*
* ```ts
* import { submitHandler } from '@ckeditor/ckeditor5-ui/src/bindings/submithandler';
*
* // ...
*
* class AnyFormView extends View {
* 	constructor() {
* 		super();
*
* 		// ...
*
* 		submitHandler( {
* 			view: this
* 		} );
* 	}
* }
*
* // ...
*
* const view = new AnyFormView();
*
* // A sample listener attached by an emitter working with the view.
* this.listenTo( view, 'submit', () => {
* 	saveTheFormData();
* 	hideTheForm();
* } );
* ```
*
* @param options Configuration options.
* @param options.view The view which DOM `submit` events should be handled.
*/ function $29fd27cb9bdab9d2$export$4ce568c1357045cd({ view: view }) {
    view.listenTo(view.element, "submit", (evt, domEvt)=>{
        domEvt.preventDefault();
        view.fire("submit");
    }, {
        useCapture: true
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A helper that adds a keyboard navigation support (arrow up/down/left/right) for grids.
*
* @param options Configuration options.
* @param options.keystrokeHandler Keystroke handler to register navigation with arrow keys.
* @param options.focusTracker A focus tracker for grid elements.
* @param options.gridItems A collection of grid items.
* @param options.numberOfColumns Number of columns in the grid. Can be specified as a function that returns
* the number (e.g. for responsive grids).
* @param options.uiLanguageDirection String of ui language direction.
*/ function $29fd27cb9bdab9d2$export$4c1942d3074fe5f4({ keystrokeHandler: keystrokeHandler, focusTracker: focusTracker, gridItems: gridItems, numberOfColumns: numberOfColumns, uiLanguageDirection: uiLanguageDirection }) {
    const getNumberOfColumns = typeof numberOfColumns === "number" ? ()=>numberOfColumns : numberOfColumns;
    keystrokeHandler.set("arrowright", getGridItemFocuser((focusedElementIndex, gridItems)=>{
        return uiLanguageDirection === "rtl" ? getLeftElementIndex(focusedElementIndex, gridItems.length) : getRightElementIndex(focusedElementIndex, gridItems.length);
    }));
    keystrokeHandler.set("arrowleft", getGridItemFocuser((focusedElementIndex, gridItems)=>{
        return uiLanguageDirection === "rtl" ? getRightElementIndex(focusedElementIndex, gridItems.length) : getLeftElementIndex(focusedElementIndex, gridItems.length);
    }));
    keystrokeHandler.set("arrowup", getGridItemFocuser((focusedElementIndex, gridItems)=>{
        let nextIndex = focusedElementIndex - getNumberOfColumns();
        if (nextIndex < 0) {
            nextIndex = focusedElementIndex + getNumberOfColumns() * Math.floor(gridItems.length / getNumberOfColumns());
            if (nextIndex > gridItems.length - 1) nextIndex -= getNumberOfColumns();
        }
        return nextIndex;
    }));
    keystrokeHandler.set("arrowdown", getGridItemFocuser((focusedElementIndex, gridItems)=>{
        let nextIndex = focusedElementIndex + getNumberOfColumns();
        if (nextIndex > gridItems.length - 1) nextIndex = focusedElementIndex % getNumberOfColumns();
        return nextIndex;
    }));
    function getGridItemFocuser(getIndexToFocus) {
        return (evt)=>{
            const focusedElement = gridItems.find((item)=>item.element === focusTracker.focusedElement);
            const nextIndexToFocus = getIndexToFocus(gridItems.getIndex(focusedElement), gridItems);
            gridItems.get(nextIndexToFocus).focus();
            evt.stopPropagation();
            evt.preventDefault();
        };
    }
    /**
	* Function returning the next index.
	*
	* ```
	* before: [ ][x][ ]	after: [ ][ ][x]
	* index = 1            index = 2
	* ```
	*
	* If current index is last, function returns first index.
	*
	* ```
	* before: [ ][ ][x]	after: [x][ ][ ]
	* index = 2            index = 0
	* ```
	*
	* @param elementIndex Number of current index.
	* @param collectionLength A count of collection items.
	*/ function getRightElementIndex(elementIndex, collectionLength) {
        if (elementIndex === collectionLength - 1) return 0;
        else return elementIndex + 1;
    }
    /**
	* Function returning the previous index.
	*
	* ```
	* before: [ ][x][ ]	after: [x][ ][ ]
	* index = 1            index = 0
	* ```
	*
	* If current index is first, function returns last index.
	*
	* ```
	* before: [x][ ][ ]	after: [ ][ ][x]
	* index = 0            index = 2
	* ```
	*
	* @param elementIndex Number of current index.
	* @param collectionLength A count of collection items.
	*/ function getLeftElementIndex(elementIndex, collectionLength) {
        if (elementIndex === 0) return collectionLength - 1;
        else return elementIndex - 1;
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/label/labelview
*/ /**
* The label view class.
*/ var $29fd27cb9bdab9d2$export$84062398251b1ba = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* An unique id of the label. It can be used by other UI components to reference
	* the label, for instance, using the `aria-describedby` DOM attribute.
	*/ id;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.set("text", void 0);
        this.set("for", void 0);
        this.id = `ck-editor__label_${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "label",
            attributes: {
                class: [
                    "ck",
                    "ck-label"
                ],
                id: this.id,
                for: bind.to("for")
            },
            children: [
                {
                    text: bind.to("text")
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/accessibilityhelp/accessibilityhelpcontentview
*/ /**
* The view displaying keystrokes in the Accessibility help dialog.
*/ var $29fd27cb9bdab9d2$export$f52f2f74dc80426 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(locale, keystrokes){
        super(locale);
        const t = locale.t;
        const helpLabel = new $29fd27cb9bdab9d2$export$84062398251b1ba();
        helpLabel.text = t("Help Contents. To close this dialog press ESC.");
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-accessibility-help-dialog__content"
                ],
                "aria-labelledby": helpLabel.id,
                role: "document",
                tabindex: -1
            },
            children: [
                (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "p", {}, t("Below, you can find a list of keyboard shortcuts that can be used in the editor.")),
                ...this._createCategories(Array.from(keystrokes.values())),
                helpLabel
            ]
        });
    }
    /**
	* @inheritDoc
	*/ focus() {
        this.element.focus();
    }
    /**
	* Creates `<section><h3>Category label</h3>...</section>` elements for each category of keystrokes.
	*/ _createCategories(categories) {
        return categories.map((categoryDefinition)=>{
            const elements = [
                (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "h3", {}, categoryDefinition.label),
                ...Array.from(categoryDefinition.groups.values()).map((groupDefinition)=>this._createGroup(groupDefinition)).flat()
            ];
            if (categoryDefinition.description) elements.splice(1, 0, (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "p", {}, categoryDefinition.description));
            return (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "section", {}, elements);
        });
    }
    /**
	* Creates `[<h4>Optional label</h4>]<dl>...</dl>` elements for each group of keystrokes in a category.
	*/ _createGroup(groupDefinition) {
        const definitionAndDescriptionElements = groupDefinition.keystrokes.sort((a, b)=>a.label.localeCompare(b.label)).map((keystrokeDefinition)=>this._createGroupRow(keystrokeDefinition)).flat();
        const elements = [
            (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "dl", {}, definitionAndDescriptionElements)
        ];
        if (groupDefinition.label) elements.unshift((0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "h4", {}, groupDefinition.label));
        return elements;
    }
    /**
	* Creates `<dt>Keystroke label</dt><dd>Keystroke definition</dd>` elements for each keystroke in a group.
	*/ _createGroupRow(keystrokeDefinition) {
        const t = this.locale.t;
        const dt = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "dt");
        const dd = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "dd");
        const normalizedKeystrokeDefinition = $29fd27cb9bdab9d2$var$normalizeKeystrokeDefinition(keystrokeDefinition.keystroke);
        const keystrokeAlternativeHTMLs = [];
        for (const keystrokeAlternative of normalizedKeystrokeDefinition)keystrokeAlternativeHTMLs.push(keystrokeAlternative.map($29fd27cb9bdab9d2$var$keystrokeToEnvKbd).join(""));
        dt.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(keystrokeDefinition.label);
        dd.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(keystrokeAlternativeHTMLs.join(", ") + (keystrokeDefinition.mayRequireFn && (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isMac ? ` ${t("(may require <kbd>Fn</kbd>)")}` : ""));
        return [
            dt,
            dd
        ];
    }
};
function $29fd27cb9bdab9d2$var$keystrokeToEnvKbd(keystroke) {
    return (0, $c7bc2cb7e2db0227$export$bed8b4cac4d8577f)(keystroke).split("+").map((part)=>`<kbd>${part}</kbd>`).join("+");
}
function $29fd27cb9bdab9d2$var$normalizeKeystrokeDefinition(definition) {
    if (typeof definition === "string") return [
        [
            definition
        ]
    ];
    if (typeof definition[0] === "string") return [
        definition
    ];
    return definition;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/icon/iconview
*/ /**
* The icon view class.
*/ var $29fd27cb9bdab9d2$export$212c60ac61334981 = class IconView extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A list of presentational attributes that can be set on the `<svg>` element and should be preserved
	* when the icon {@link module:ui/icon/iconview~IconView#content content} is loaded.
	*
	* See the [specification](https://www.w3.org/TR/SVG/styling.html#TermPresentationAttribute) to learn more.
	*/ static presentationalAttributeNames = [
        "alignment-baseline",
        "baseline-shift",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-rendering",
        "cursor",
        "direction",
        "display",
        "dominant-baseline",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "mask",
        "opacity",
        "overflow",
        "paint-order",
        "pointer-events",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-overflow",
        "text-rendering",
        "transform",
        "unicode-bidi",
        "vector-effect",
        "visibility",
        "white-space",
        "word-spacing",
        "writing-mode"
    ];
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        const bind = this.bindTemplate;
        this.set("content", "");
        this.set("viewBox", "0 0 20 20");
        this.set("fillColor", "");
        this.set("isColorInherited", true);
        this.set("isVisible", true);
        this.setTemplate({
            tag: "svg",
            ns: "http://www.w3.org/2000/svg",
            attributes: {
                class: [
                    "ck",
                    "ck-icon",
                    bind.if("isVisible", "ck-hidden", (value)=>!value),
                    "ck-reset_all-excluded",
                    bind.if("isColorInherited", "ck-icon_inherit-color")
                ],
                viewBox: bind.to("viewBox"),
                "aria-hidden": true
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this._updateXMLContent();
        this._colorFillPaths();
        this.on("change:content", ()=>{
            this._updateXMLContent();
            this._colorFillPaths();
        });
        this.on("change:fillColor", ()=>{
            this._colorFillPaths();
        });
    }
    /**
	* Updates the {@link #element} with the value of {@link #content}.
	*/ _updateXMLContent() {
        if (this.content) {
            const svg = new DOMParser().parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(this.content.trim()), "image/svg+xml").querySelector("svg");
            if (!svg) /**
			* The provided icon content is not a valid SVG.
			*
			* @error ui-iconview-invalid-svg
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-iconview-invalid-svg", this);
            const viewBox = svg.getAttribute("viewBox");
            if (viewBox) this.viewBox = viewBox;
            for (const { name: name, value: value } of Array.from(svg.attributes))if (IconView.presentationalAttributeNames.includes(name)) this.element.setAttribute(name, value);
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            while(svg.childNodes.length > 0)this.element.appendChild(svg.childNodes[0]);
        }
    }
    /**
	* Fills all child `path.ck-icon__fill` with the `#fillColor`.
	*/ _colorFillPaths() {
        if (this.fillColor) this.element.querySelectorAll(".ck-icon__fill").forEach((path)=>{
            path.style.fill = this.fillColor;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/button/buttonlabelview
*/ /**
* A default implementation of the button view's label. It comes with a dynamic text support
* via {@link module:ui/button/buttonlabelview~ButtonLabelView#text} property.
*/ var $29fd27cb9bdab9d2$export$b940bfdc83894cd1 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        this.set({
            style: void 0,
            text: void 0,
            id: void 0
        });
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-button__label"
                ],
                style: bind.to("style"),
                id: bind.to("id")
            },
            children: [
                {
                    text: bind.to("text")
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/button/buttonview
*/ /**
* The button view class.
*
* ```ts
* const view = new ButtonView();
*
* view.set( {
* 	label: 'A button',
* 	keystroke: 'Ctrl+B',
* 	tooltip: true,
* 	withText: true
* } );
*
* view.render();
*
* document.body.append( view.element );
* ```
*/ var $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views inside of the button {@link #element}.
	*/ children;
    /**
	* Label of the button view. Its text is configurable using the {@link #label label attribute}.
	*
	* If not configured otherwise in the `constructor()`, by default the label is an instance
	* of {@link module:ui/button/buttonlabelview~ButtonLabelView}.
	*/ labelView;
    /**
	* The icon view of the button. Will be added to {@link #children} when the
	* {@link #icon icon attribute} is defined.
	*/ iconView;
    /**
	* A view displaying the keystroke of the button next to the {@link #labelView label}.
	* Added to {@link #children} when the {@link #withKeystroke `withKeystroke` attribute}
	* is defined.
	*/ keystrokeView;
    /**
	* Delayed focus function for focus handling in Safari.
	*/ _focusDelayed = null;
    /**
	* Creates an instance of the button view class.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param labelView The instance of the button's label. If not provided, an instance of
	* {@link module:ui/button/buttonlabelview~ButtonLabelView} is used.
	*/ constructor(locale, labelView = new $29fd27cb9bdab9d2$export$b940bfdc83894cd1()){
        super(locale);
        const bind = this.bindTemplate;
        const ariaLabelUid = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
        this.set("_ariaPressed", false);
        this.set("_ariaChecked", false);
        this.set("ariaLabel", void 0);
        this.set("ariaLabelledBy", `ck-editor__aria-label_${ariaLabelUid}`);
        this.set("class", void 0);
        this.set("labelStyle", void 0);
        this.set("icon", void 0);
        this.set("isEnabled", true);
        this.set("isOn", false);
        this.set("isVisible", true);
        this.set("isToggleable", false);
        this.set("keystroke", void 0);
        this.set("label", void 0);
        this.set("role", void 0);
        this.set("tabindex", -1);
        this.set("tooltip", false);
        this.set("tooltipPosition", "s");
        this.set("type", "button");
        this.set("withText", false);
        this.set("withKeystroke", false);
        this.children = this.createCollection();
        this.labelView = this._setupLabelView(labelView);
        this.iconView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        this.iconView.extendTemplate({
            attributes: {
                class: "ck-button__icon"
            }
        });
        this.iconView.bind("content").to(this, "icon");
        this.keystrokeView = this._createKeystrokeView();
        this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
        const template = {
            tag: "button",
            attributes: {
                class: [
                    "ck",
                    "ck-button",
                    bind.to("class"),
                    bind.if("isEnabled", "ck-disabled", (value)=>!value),
                    bind.if("isVisible", "ck-hidden", (value)=>!value),
                    bind.to("isOn", (value)=>value ? "ck-on" : "ck-off"),
                    bind.if("withText", "ck-button_with-text"),
                    bind.if("withKeystroke", "ck-button_with-keystroke")
                ],
                role: bind.to("role"),
                type: bind.to("type", (value)=>value ? value : "button"),
                tabindex: bind.to("tabindex"),
                "aria-checked": bind.to("_ariaChecked"),
                "aria-pressed": bind.to("_ariaPressed"),
                "aria-label": bind.to("ariaLabel"),
                "aria-labelledby": bind.to("ariaLabelledBy"),
                "aria-disabled": bind.if("isEnabled", true, (value)=>!value),
                "data-cke-tooltip-text": bind.to("_tooltipString"),
                "data-cke-tooltip-position": bind.to("tooltipPosition")
            },
            children: this.children,
            on: {
                click: bind.to((evt)=>{
                    if (this.isEnabled) this.fire("execute");
                    else evt.preventDefault();
                })
            }
        };
        this.bind("_ariaPressed").to(this, "isOn", this, "isToggleable", this, "role", (isOn, isToggleable, role)=>{
            if (!isToggleable || $29fd27cb9bdab9d2$var$isCheckableRole(role)) return false;
            return String(!!isOn);
        });
        this.bind("_ariaChecked").to(this, "isOn", this, "isToggleable", this, "role", (isOn, isToggleable, role)=>{
            if (!isToggleable || !$29fd27cb9bdab9d2$var$isCheckableRole(role)) return false;
            return String(!!isOn);
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari) {
            /* v8 ignore else -- @preserve */ if (!this._focusDelayed) this._focusDelayed = (0, $c7bc2cb7e2db0227$export$1391212d75b2ee65)(()=>this.focus(), 0);
            template.on.mousedown = bind.to(()=>{
                this._focusDelayed();
            });
            template.on.mouseup = bind.to(()=>{
                this._focusDelayed.cancel();
            });
        }
        this.setTemplate(template);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        if (this.icon) this.children.add(this.iconView);
        this.on("change:icon", (evt, prop, newIcon, oldIcon)=>{
            if (newIcon && !oldIcon) this.children.add(this.iconView, 0);
            else if (!newIcon && oldIcon) this.children.remove(this.iconView);
        });
        this.children.add(this.labelView);
        if (this.withKeystroke && this.keystroke) this.children.add(this.keystrokeView);
    }
    /**
	* Focuses the {@link #element} of the button.
	*/ focus() {
        this.element.focus();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        if (this._focusDelayed) this._focusDelayed.cancel();
        super.destroy();
    }
    /**
	* Binds the label view instance it with button attributes.
	*/ _setupLabelView(labelView) {
        labelView.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy");
        return labelView;
    }
    /**
	* Creates a view that displays a keystroke next to a {@link #labelView label }
	* and binds it with button attributes.
	*/ _createKeystrokeView() {
        const keystrokeView = new $29fd27cb9bdab9d2$export$27a5bd065ad55220();
        keystrokeView.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-button__keystroke"
                ]
            },
            children: [
                {
                    text: this.bindTemplate.to("keystroke", (text)=>(0, $c7bc2cb7e2db0227$export$bed8b4cac4d8577f)(text))
                }
            ]
        });
        return keystrokeView;
    }
    /**
	* Gets the text for the tooltip from the combination of
	* {@link #tooltip}, {@link #label} and {@link #keystroke} attributes.
	*
	* @see #tooltip
	* @see #_tooltipString
	* @param tooltip Button tooltip.
	* @param label Button label.
	* @param keystroke Button keystroke.
	*/ _getTooltipString(tooltip, label, keystroke) {
        if (tooltip) {
            if (typeof tooltip == "string") return tooltip;
            else {
                if (keystroke) keystroke = (0, $c7bc2cb7e2db0227$export$bed8b4cac4d8577f)(keystroke);
                if (tooltip instanceof Function) return tooltip(label, keystroke);
                else return `${label}${keystroke ? ` (${keystroke})` : ""}`;
            }
        }
        return "";
    }
};
/**
* Checks if `aria-checkbox` can be used with specified role.
*/ function $29fd27cb9bdab9d2$var$isCheckableRole(role) {
    switch(role){
        case "radio":
        case "checkbox":
        case "option":
        case "switch":
        case "menuitemcheckbox":
        case "menuitemradio":
            return true;
        default:
            return false;
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/formheader/formheaderview
*/ /**
* The class component representing a form header view. It should be used in more advanced forms to
* describe the main purpose of the form.
*
* By default the component contains a bolded label view that has to be set. The label is usually a short (at most 3-word) string.
* The component can also be extended by any other elements, like: icons, dropdowns, etc.
*
* It is used i.a.
* by {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView}.
*
* The latter is an example, where the component has been extended by {@link module:ui/dropdown/dropdownview~DropdownView} view.
*/ var $29fd27cb9bdab9d2$export$27806e9e63215c18 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of header items.
	*/ children;
    /**
	* The icon view instance. Defined only if icon was passed in the constructor's options.
	*/ iconView;
    /**
	* Creates an instance of the form header class.
	*
	* @param locale The locale instance.
	* @param options.label A label.
	* @param options.class An additional class.
	*/ constructor(locale, options = {}){
        super(locale);
        const bind = this.bindTemplate;
        this.set("label", options.label || "");
        this.set("class", options.class || null);
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-form__header",
                    bind.to("class")
                ]
            },
            children: this.children
        });
        if (options.icon) {
            this.iconView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
            this.iconView.content = options.icon;
            this.children.add(this.iconView);
        }
        const label = new $29fd27cb9bdab9d2$export$27a5bd065ad55220(locale);
        label.setTemplate({
            tag: "h2",
            attributes: {
                class: [
                    "ck",
                    "ck-form__header__label"
                ],
                role: "presentation"
            },
            children: [
                {
                    text: bind.to("label")
                }
            ]
        });
        this.children.add(label);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/focuscycler
*/ const $29fd27cb9bdab9d2$var$FocusCyclerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* A utility class that helps cycling over {@link module:ui/focuscycler~FocusableView focusable views} in a
* {@link module:ui/viewcollection~ViewCollection} when the focus is tracked by the
* {@link module:utils/focustracker~FocusTracker} instance. It helps implementing keyboard
* navigation in HTML forms, toolbars, lists and the like.
*
* To work properly it requires:
* * a collection of focusable (HTML `tabindex` attribute) views that implement the `focus()` method,
* * an associated focus tracker to determine which view is focused.
*
* A simple cycler setup can look like this:
*
* ```ts
* const focusables = new ViewCollection<FocusableView>();
* const focusTracker = new FocusTracker();
*
* // Add focusable views to the focus tracker.
* focusTracker.add( ... );
* ```
*
* Then, the cycler can be used manually:
*
* ```ts
* const cycler = new FocusCycler( { focusables, focusTracker } );
*
* // Will focus the first focusable view in #focusables.
* cycler.focusFirst();
*
* // Will log the next focusable item in #focusables.
* console.log( cycler.next );
* ```
*
* Alternatively, it can work side by side with the {@link module:utils/keystrokehandler~KeystrokeHandler}:
*
* ```ts
* const keystrokeHandler = new KeystrokeHandler();
*
* // Activate the keystroke handler.
* keystrokeHandler.listenTo( sourceOfEvents );
*
* const cycler = new FocusCycler( {
* 	focusables, focusTracker, keystrokeHandler,
* 	actions: {
* 		// When arrowup of arrowleft is detected by the #keystrokeHandler,
* 		// focusPrevious() will be called on the cycler.
* 		focusPrevious: [ 'arrowup', 'arrowleft' ],
* 	}
* } );
* ```
*
* Check out the {@glink framework/deep-dive/ui/focus-tracking "Deep dive into focus tracking"} guide to learn more.
*/ var $29fd27cb9bdab9d2$export$679be10c531010f6 = class extends $29fd27cb9bdab9d2$var$FocusCyclerBase {
    /**
	* A {@link module:ui/focuscycler~FocusableView focusable views} collection that the cycler operates on.
	*/ focusables;
    /**
	* A focus tracker instance that the cycler uses to determine the current focus
	* state in {@link #focusables}.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
	* which can respond to certain keystrokes and cycle the focus.
	*/ keystrokeHandler;
    /**
	* Actions that the cycler can take when a keystroke is pressed. Requires
	* `options.keystrokeHandler` to be passed and working. When an action is
	* performed, `preventDefault` and `stopPropagation` will be called on the event
	* the keystroke fired in the DOM.
	*
	* ```ts
	* actions: {
	* 	// Will call #focusPrevious() when arrowleft or arrowup is pressed.
	* 	focusPrevious: [ 'arrowleft', 'arrowup' ],
	*
	* 	// Will call #focusNext() when arrowdown is pressed.
	* 	focusNext: 'arrowdown'
	* }
	* ```
	*/ actions;
    /**
	* Creates an instance of the focus cycler utility.
	*
	* @param options Configuration options.
	*/ constructor(options){
        super();
        this.focusables = options.focusables;
        this.focusTracker = options.focusTracker;
        this.keystrokeHandler = options.keystrokeHandler;
        this.actions = options.actions;
        if (options.actions && options.keystrokeHandler) for(const methodName in options.actions){
            let actions = options.actions[methodName];
            if (typeof actions == "string") actions = [
                actions
            ];
            for (const keystroke of actions)options.keystrokeHandler.set(keystroke, (data, cancel)=>{
                this[methodName]();
                cancel();
            }, options.keystrokeHandlerOptions);
        }
        this.on("forwardCycle", ()=>this.focusFirst(), {
            priority: "low"
        });
        this.on("backwardCycle", ()=>this.focusLast(), {
            priority: "low"
        });
    }
    /**
	* Returns the first focusable view in {@link #focusables}.
	* Returns `null` if there is none.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ get first() {
        return this.focusables.find($29fd27cb9bdab9d2$var$isDomFocusable) || null;
    }
    /**
	* Returns the last focusable view in {@link #focusables}.
	* Returns `null` if there is none.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ get last() {
        return this.focusables.filter($29fd27cb9bdab9d2$var$isDomFocusable).slice(-1)[0] || null;
    }
    /**
	* Returns the next focusable view in {@link #focusables} based on {@link #current}.
	* Returns `null` if there is none.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ get next() {
        return this._getDomFocusableItem(1);
    }
    /**
	* Returns the previous focusable view in {@link #focusables} based on {@link #current}.
	* Returns `null` if there is none.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ get previous() {
        return this._getDomFocusableItem(-1);
    }
    /**
	* An index of the view in the {@link #focusables} which is focused according
	* to {@link #focusTracker}. Returns `null` when there is no such view.
	*/ get current() {
        let index = null;
        if (this.focusTracker.focusedElement === null) return null;
        this.focusables.find((view, viewIndex)=>{
            const focused = view.element === this.focusTracker.focusedElement;
            if (focused) index = viewIndex;
            return focused;
        });
        return index;
    }
    /**
	* Focuses the {@link #first} item in {@link #focusables}.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ focusFirst() {
        this._focus(this.first, 1);
    }
    /**
	* Focuses the {@link #last} item in {@link #focusables}.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ focusLast() {
        this._focus(this.last, -1);
    }
    /**
	* Focuses the {@link #next} item in {@link #focusables}.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ focusNext() {
        const next = this.next;
        if (next && this.focusables.getIndex(next) === this.current) {
            this.fire("forwardCycle");
            return;
        }
        if (next === this.first) this.fire("forwardCycle");
        else this._focus(next, 1);
    }
    /**
	* Focuses the {@link #previous} item in {@link #focusables}.
	*
	* **Note**: Hidden views (e.g. with `display: none`) are ignored.
	*/ focusPrevious() {
        const previous = this.previous;
        if (previous && this.focusables.getIndex(previous) === this.current) {
            this.fire("backwardCycle");
            return;
        }
        if (previous === this.last) this.fire("backwardCycle");
        else this._focus(previous, -1);
    }
    /**
	* Allows for creating continuous focus cycling across multiple focus cyclers and their collections of {@link #focusables}.
	*
	* It starts listening to the {@link module:ui/focuscycler~FocusCyclerForwardCycleEvent} and
	* {@link module:ui/focuscycler~FocusCyclerBackwardCycleEvent} events of the chained focus cycler and engages,
	* whenever the user reaches the last (forwards navigation) or first (backwards navigation) focusable view
	* and would normally start over. Instead, the navigation continues on the higher level (flattens).
	*
	* For instance, for the following nested focus navigation structure, the focus would get stuck the moment
	* the AB gets focused and its focus cycler starts managing it:
	*
	*	   ┌────────────┐   ┌──────────────────────────────────┐   ┌────────────┐
	*	   │ AA         │   │ AB                               │   │ AC         │
	*	   │            │   │                                  │   │            │
	*	   │            │   │    ┌─────┐  ┌─────┐  ┌─────┐     │   │            │
	*	   │            │   │ ┌──► ABA ├──► ABB ├──► ABC ├───┐ │   │            │
	*	   │            ├───► │  └─────┘  └─────┘  └─────┘   │ │   │            │
	*	   │            │   │ │                              │ │   │            │
	*	   │            │   │ │                              │ │   │            │
	*	   │            │   │ └──────────────────────────────┘ │   │            │
	*	   │            │   │                                  │   │            │
	*	   └────────────┘   └──────────────────────────────────┘   └────────────┘
	*
	* Chaining a focus tracker that manages AA, AB, and AC with the focus tracker that manages ABA, ABB, and ABC
	* creates a seamless navigation experience instead:
	*
	*	   ┌────────────┐   ┌──────────────────────────────────┐   ┌────────────┐
	*	   │ AA         │   │ AB                               │   │ AC         │
	*	   │            │   │                                  │   │            │
	*	   │            │   │    ┌─────┐  ┌─────┐  ┌─────┐     │   │            │
	*	   │            │   │ ┌──► ABA ├──► ABB ├──► ABC ├──┐  │   │            │
	*	┌──►            ├───┼─┘  └─────┘  └─────┘  └─────┘  └──┼───►            ├──┐
	*	│  │            │   │                                  │   │            │  │
	*	│  │            │   │                                  │   │            │  │
	*	│  │            │   │                                  │   │            │  │
	*	│  │            │   │                                  │   │            │  │
	*	│  └────────────┘   └──────────────────────────────────┘   └────────────┘  │
	*	│                                                                          │
	*	│                                                                          │
	*	└──────────────────────────────────────────────────────────────────────────┘
	*
	* See {@link #unchain} to reverse the chaining.
	*/ chain(chainedFocusCycler) {
        const getCurrentFocusedView = ()=>{
            if (this.current === null) return null;
            return this.focusables.get(this.current);
        };
        this.listenTo(chainedFocusCycler, "forwardCycle", (evt)=>{
            const oldCurrent = getCurrentFocusedView();
            this.focusNext();
            if (oldCurrent !== getCurrentFocusedView()) evt.stop();
        }, {
            priority: "low"
        });
        this.listenTo(chainedFocusCycler, "backwardCycle", (evt)=>{
            const oldCurrent = getCurrentFocusedView();
            this.focusPrevious();
            if (oldCurrent !== getCurrentFocusedView()) evt.stop();
        }, {
            priority: "low"
        });
    }
    /**
	* Reverses a chaining made by {@link #chain}.
	*/ unchain(otherFocusCycler) {
        this.stopListening(otherFocusCycler);
    }
    /**
	* Focuses the given view if it exists.
	*
	* @param view The view to be focused
	* @param direction The direction of the focus if the view has focusable children.
	* @returns
	*/ _focus(view, direction) {
        if (view && this.focusTracker.focusedElement !== view.element) view.focus(direction);
    }
    /**
	* Returns the next or previous focusable view in {@link #focusables} with respect
	* to {@link #current}.
	*
	* @param step Either `1` for checking forward from {@link #current} or `-1` for checking backwards.
	*/ _getDomFocusableItem(step) {
        const collectionLength = this.focusables.length;
        if (!collectionLength) return null;
        const current = this.current;
        if (current === null) return this[step === 1 ? "first" : "last"];
        let focusableItem = this.focusables.get(current);
        let index = (current + collectionLength + step) % collectionLength;
        do {
            const focusableItemCandidate = this.focusables.get(index);
            if ($29fd27cb9bdab9d2$var$isDomFocusable(focusableItemCandidate)) {
                focusableItem = focusableItemCandidate;
                break;
            }
            index = (index + collectionLength + step) % collectionLength;
        }while (index !== current);
        return focusableItem;
    }
};
/**
* Checks whether a view can be focused (has `focus()` method and is visible).
*
* @param view A view to be checked.
*/ function $29fd27cb9bdab9d2$var$isDomFocusable(view) {
    return $29fd27cb9bdab9d2$export$4c063cf1350e6fed(view) && (0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(view.element);
}
/**
* Checks whether a view is {@link ~FocusableView}.
*
* @param view A view to be checked.
*/ function $29fd27cb9bdab9d2$export$4c063cf1350e6fed(view) {
    return !!("focus" in view && typeof view.focus == "function");
}
/**
* Checks whether a view is an instance of {@link ~ViewWithFocusCycler}.
*
* @param view A view to be checked.
*/ function $29fd27cb9bdab9d2$export$7d2bc1147a6c668d(view) {
    return $29fd27cb9bdab9d2$export$4c063cf1350e6fed(view) && "focusCycler" in view && view.focusCycler instanceof $29fd27cb9bdab9d2$export$679be10c531010f6;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dialog/dialogactionsview
*/ /**
* A dialog actions view class. It contains button views which are used to execute dialog actions.
*/ var $29fd27cb9bdab9d2$export$4af5a153f7397663 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of button views.
	*/ children;
    /**
	* A keystroke handler instance.
	*/ keystrokes;
    /**
	* A focus cycler instance.
	*/ focusCycler;
    /**
	* A focus tracker instance.
	*/ _focusTracker;
    /**
	* A collection of focusable views.
	*/ _focusables;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.children = this.createCollection();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this._focusables = new $29fd27cb9bdab9d2$export$ff20b327de53fba7();
        this.focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this._focusables,
            focusTracker: this._focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-dialog__actions"
                ]
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Creates the button views based on the given definitions.
	* Then adds them to the {@link #children} collection and to the focus cycler.
	*/ setButtons(definitions) {
        for (const definition of definitions){
            const button = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(this.locale);
            let property;
            button.on("execute", ()=>definition.onExecute());
            if (definition.onCreate) definition.onCreate(button);
            for(property in definition)if (property != "onExecute" && property != "onCreate") button.set(property, definition[property]);
            button.extendTemplate({
                attributes: {
                    class: "ck-button_standard"
                }
            });
            this.children.add(button);
        }
        this._updateFocusCyclableItems();
    }
    /**
	* @inheritDoc
	*/ focus(direction) {
        if (direction === -1) this.focusCycler.focusLast();
        else this.focusCycler.focusFirst();
    }
    /**
	* Adds all elements from the {@link #children} collection to the {@link #_focusables} collection
	* and to the {@link #_focusTracker} instance.
	*/ _updateFocusCyclableItems() {
        Array.from(this.children).forEach((v)=>{
            this._focusables.add(v);
            this._focusTracker.add(v.element);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dialog/dialogcontentview
*/ /**
* A dialog content view class.
*/ var $29fd27cb9bdab9d2$export$292bbb646cacd0fd = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of content items.
	*/ children;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-dialog__content"
                ]
            },
            children: this.children
        });
    }
    /**
	* Removes all the child views.
	*/ reset() {
        while(this.children.length)this.children.remove(0);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dialog/dialogview
*/ /**
* Available dialog view positions:
*
* * `DialogViewPosition.SCREEN_CENTER` &ndash; A fixed position in the center of the screen.
* * `DialogViewPosition.EDITOR_CENTER` &ndash; A dynamic position in the center of the editor editable area.
* * `DialogViewPosition.EDITOR_TOP_SIDE` &ndash; A dynamic position at the top-right (for the left-to-right languages)
* or top-left (for right-to-left languages) corner of the editor editable area.
* * `DialogViewPosition.EDITOR_TOP_CENTER` &ndash; A dynamic position at the top-center of the editor editable area.
* * `DialogViewPosition.EDITOR_BOTTOM_CENTER` &ndash; A dynamic position at the bottom-center of the editor editable area.
* * `DialogViewPosition.EDITOR_ABOVE_CENTER` &ndash; A dynamic position centered above the editor editable area.
* * `DialogViewPosition.EDITOR_BELOW_CENTER` &ndash; A dynamic position centered below the editor editable area.
*
* The position of a dialog is specified by a {@link module:ui/dialog/dialog~DialogDefinition#position `position` property} of a
* definition passed to the {@link module:ui/dialog/dialog~Dialog#show} method.
*/ const $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb = {
    SCREEN_CENTER: "screen-center",
    EDITOR_CENTER: "editor-center",
    EDITOR_TOP_SIDE: "editor-top-side",
    EDITOR_TOP_CENTER: "editor-top-center",
    EDITOR_BOTTOM_CENTER: "editor-bottom-center",
    EDITOR_ABOVE_CENTER: "editor-above-center",
    EDITOR_BELOW_CENTER: "editor-below-center"
};
const $29fd27cb9bdab9d2$var$toPx$6 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
const $29fd27cb9bdab9d2$var$DialogViewBase = /* #__PURE__ */ $29fd27cb9bdab9d2$export$c315ca8d42e0291b($29fd27cb9bdab9d2$export$27a5bd065ad55220);
/**
* A dialog view class.
*/ var $29fd27cb9bdab9d2$export$9adfefb9e06546bf = class DialogView extends $29fd27cb9bdab9d2$var$DialogViewBase {
    /**
	* A collection of the child views inside of the dialog.
	* A dialog can have 3 optional parts: header, content, and actions.
	*/ parts;
    /**
	* A header view of the dialog. It is also a drag handle of the dialog.
	*/ headerView;
    /**
	* A close button view. It is automatically added to the header view if present.
	*/ closeButtonView;
    /**
	* A view with the action buttons available to the user.
	*/ actionsView;
    /**
	* A default dialog element offset from the reference element (e.g. editor editable area).
	*/ static defaultOffset = 15;
    /**
	* A view with the dialog content.
	*/ contentView;
    /**
	* A keystroke handler instance.
	*/ keystrokes;
    /**
	* A focus tracker instance.
	*/ focusTracker;
    /**
	* A flag indicating if the dialog was moved manually. If so, its position
	* will not be updated automatically upon window resize or document scroll.
	*/ wasMoved = false;
    /**
	* A callback returning the DOM root that requested the dialog.
	*/ _getDomRootElement;
    /**
	* A callback returning the configured editor viewport offset.
	*/ _getViewportOffset;
    /**
	* The list of the focusable elements inside the dialog view.
	*/ _focusables;
    /**
	* The focus cycler instance.
	*/ _focusCycler;
    /**
	* @inheritDoc
	*/ constructor(locale, { getDomRootElement: getDomRootElement, getViewportOffset: getViewportOffset, keystrokeHandlerOptions: keystrokeHandlerOptions }){
        super(locale);
        const bind = this.bindTemplate;
        const t = locale.t;
        this.set("className", "");
        this.set("ariaLabel", t("Editor dialog"));
        this.set("isModal", false);
        this.set("position", $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.SCREEN_CENTER);
        this.set("_isVisible", false);
        this.set("_isTransparent", false);
        this.set("_top", 0);
        this.set("_left", 0);
        this._getDomRootElement = getDomRootElement;
        this._getViewportOffset = getViewportOffset;
        this.decorate("moveTo");
        this.parts = this.createCollection();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this._focusables = new $29fd27cb9bdab9d2$export$ff20b327de53fba7();
        this._focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            },
            keystrokeHandlerOptions: keystrokeHandlerOptions
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-dialog-overlay",
                    bind.if("isModal", "ck-dialog-overlay__transparent", (isModal)=>!isModal),
                    bind.if("_isVisible", "ck-hidden", (value)=>!value)
                ],
                tabindex: "-1"
            },
            children: [
                {
                    tag: "div",
                    attributes: {
                        tabindex: "-1",
                        class: [
                            "ck",
                            "ck-dialog",
                            bind.if("isModal", "ck-dialog_modal"),
                            bind.to("className")
                        ],
                        role: "dialog",
                        "aria-label": bind.to("ariaLabel"),
                        style: {
                            top: bind.to("_top", (top)=>$29fd27cb9bdab9d2$var$toPx$6(top)),
                            left: bind.to("_left", (left)=>$29fd27cb9bdab9d2$var$toPx$6(left)),
                            visibility: bind.if("_isTransparent", "hidden")
                        }
                    },
                    children: this.parts
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.keystrokes.set("Esc", (data, cancel)=>{
            if (!data.defaultPrevented) {
                this.fire("close", {
                    source: "escKeyPress"
                });
                cancel();
            }
        });
        this.on("drag", (evt, { deltaX: deltaX, deltaY: deltaY })=>{
            this.wasMoved = true;
            this.moveBy(deltaX, deltaY);
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize", ()=>{
            if (this._isVisible && !this.wasMoved) this.updatePosition();
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", ()=>{
            if (this._isVisible && !this.wasMoved) this.updatePosition();
        });
        this.on("change:_isVisible", (evt, name, isVisible)=>{
            if (isVisible) {
                this._isTransparent = true;
                setTimeout(()=>{
                    this.updatePosition();
                    this._isTransparent = false;
                    this.focus();
                }, 10);
            }
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Returns the element that should be used as a drag handle.
	*/ get dragHandleElement() {
        if (this.headerView && !this.isModal) return this.headerView.element;
        else return null;
    }
    /**
	* Creates the dialog parts. Which of them are created depends on the arguments passed to the method.
	* There are no rules regarding the dialog construction, that is, no part is mandatory.
	* Each part can only be created once.
	*
	* @internal
	*/ setupParts({ icon: icon, title: title, hasCloseButton: hasCloseButton = true, content: content, actionButtons: actionButtons }) {
        if (title) {
            this.headerView = new $29fd27cb9bdab9d2$export$27806e9e63215c18(this.locale, {
                icon: icon
            });
            if (hasCloseButton) {
                this.closeButtonView = this._createCloseButton();
                this.headerView.children.add(this.closeButtonView);
            }
            this.headerView.label = title;
            this.ariaLabel = title;
            this.parts.add(this.headerView, 0);
        }
        if (content) {
            if (content instanceof $29fd27cb9bdab9d2$export$27a5bd065ad55220) content = [
                content
            ];
            this.contentView = new $29fd27cb9bdab9d2$export$292bbb646cacd0fd(this.locale);
            this.contentView.children.addMany(content);
            this.parts.add(this.contentView);
        }
        if (actionButtons) {
            this.actionsView = new $29fd27cb9bdab9d2$export$4af5a153f7397663(this.locale);
            this.actionsView.setButtons(actionButtons);
            this.parts.add(this.actionsView);
        }
        this._updateFocusCyclableItems();
    }
    /**
	* Focuses the first focusable element inside the dialog.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Normalizes the passed coordinates to make sure the dialog view
	* is displayed within the visible viewport and moves it there.
	*
	* @internal
	*/ moveTo(left, top) {
        const viewportRect = this._getViewportRect();
        const dialogRect = this._getDialogRect();
        if (left + dialogRect.width > viewportRect.right) left = viewportRect.right - dialogRect.width;
        if (left < viewportRect.left) left = viewportRect.left;
        if (top < viewportRect.top) top = viewportRect.top;
        this._moveTo(left, top);
    }
    /**
	* Moves the dialog to the specified coordinates.
	*/ _moveTo(left, top) {
        this._left = left;
        this._top = top;
    }
    /**
	* Moves the dialog by the specified offset.
	*
	* @internal
	*/ moveBy(left, top) {
        this.moveTo(this._left + left, this._top + top);
    }
    /**
	* Moves the dialog view to the off-screen position.
	* Used when there is no space to display the dialog.
	*/ _moveOffScreen() {
        this._moveTo(-9999, -9999);
    }
    /**
	* Recalculates the dialog according to the set position and viewport,
	* and moves it to the new position.
	*/ updatePosition() {
        if (!this.element || !this.element.isConnected) return;
        const viewportRect = this._getViewportRect();
        let configuredPosition = this.position;
        let domRootRect = null;
        let visibleDomRootRect = null;
        if (!this._getDomRootElement()) configuredPosition = $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.SCREEN_CENTER;
        else ({ domRootRect: domRootRect, visibleDomRootRect: visibleDomRootRect } = this._getDomRootRects(viewportRect));
        const defaultOffset = DialogView.defaultOffset;
        const dialogRect = this._getDialogRect();
        if (this.position == null) return;
        else if (typeof this.position == "function") {
            const coords = this.position(dialogRect, visibleDomRootRect, domRootRect);
            if (coords == null) {
                this._moveOffScreen();
                return;
            }
            this._moveTo(coords.left, coords.top);
            return;
        }
        switch(configuredPosition){
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_TOP_SIDE:
                if (visibleDomRootRect) {
                    const leftCoordinate = this.locale.contentLanguageDirection === "ltr" ? visibleDomRootRect.right - dialogRect.width - defaultOffset : visibleDomRootRect.left + defaultOffset;
                    this.moveTo(leftCoordinate, visibleDomRootRect.top + defaultOffset);
                } else this._moveOffScreen();
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_CENTER:
                if (visibleDomRootRect) this.moveTo(Math.round(visibleDomRootRect.left + visibleDomRootRect.width / 2 - dialogRect.width / 2), Math.round(visibleDomRootRect.top + visibleDomRootRect.height / 2 - dialogRect.height / 2));
                else this._moveOffScreen();
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.SCREEN_CENTER:
                this.moveTo(Math.round((viewportRect.width - dialogRect.width) / 2), Math.round((viewportRect.height - dialogRect.height) / 2));
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_TOP_CENTER:
                if (visibleDomRootRect) this.moveTo(Math.round(visibleDomRootRect.left + visibleDomRootRect.width / 2 - dialogRect.width / 2), visibleDomRootRect.top + defaultOffset);
                else this._moveOffScreen();
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_BOTTOM_CENTER:
                if (visibleDomRootRect) this.moveTo(Math.round(visibleDomRootRect.left + visibleDomRootRect.width / 2 - dialogRect.width / 2), visibleDomRootRect.bottom - dialogRect.height - defaultOffset);
                else this._moveOffScreen();
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_ABOVE_CENTER:
                if (visibleDomRootRect) this.moveTo(Math.round(visibleDomRootRect.left + visibleDomRootRect.width / 2 - dialogRect.width / 2), visibleDomRootRect.top - dialogRect.height - defaultOffset);
                else this._moveOffScreen();
                break;
            case $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_BELOW_CENTER:
                if (visibleDomRootRect) this.moveTo(Math.round(visibleDomRootRect.left + visibleDomRootRect.width / 2 - dialogRect.width / 2), visibleDomRootRect.bottom + defaultOffset);
                else this._moveOffScreen();
        }
    }
    /**
	* Calculates the {@link #_getDomRootElement DOM root element's} Rect and its corresponding visible DOM root Rect.
	*
	* The visible Rect is the part of the DOM root Rect that is actually visible to the user
	* (see {@link module:utils/dom/rect~Rect#getVisible}), and overlaps with the viewport.
	*
	* **Note**: It might be that the visible DOM root Rect is not available (root off the screen, cropped by parent elements, etc.)
	* but its general DOM root Rect is still available.
	*/ _getDomRootRects(viewportRect) {
        const domRootRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._getDomRootElement());
        let visibleDomRootRect = domRootRect.getVisible();
        if (visibleDomRootRect) visibleDomRootRect = viewportRect.getIntersection(visibleDomRootRect);
        return {
            visibleDomRootRect: visibleDomRootRect,
            domRootRect: domRootRect
        };
    }
    /**
	* Calculates the dialog element rect.
	*/ _getDialogRect() {
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.element.firstElementChild);
    }
    /**
	* Returns a viewport `Rect` shrunk by the viewport offset config from all sides.
	*/ _getViewportRect() {
        const viewportRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window);
        if (this.isModal) return viewportRect;
        return (0, $c7bc2cb7e2db0227$export$1d016c46491e9cd1)(this._getViewportOffset());
    }
    /**
	* Collects all focusable elements inside the dialog parts
	* and adds them to the focus tracker and focus cycler.
	*/ _updateFocusCyclableItems() {
        const focusables = [];
        if (this.contentView) {
            for (const child of this.contentView.children)if ($29fd27cb9bdab9d2$export$4c063cf1350e6fed(child)) focusables.push(child);
        }
        if (this.actionsView) focusables.push(this.actionsView);
        if (this.closeButtonView) focusables.push(this.closeButtonView);
        focusables.forEach((focusable)=>{
            this._focusables.add(focusable);
            this.focusTracker.add(focusable.element);
            if ($29fd27cb9bdab9d2$export$7d2bc1147a6c668d(focusable)) this._focusCycler.chain(focusable.focusCycler);
        });
    }
    /**
	* Creates the close button view that is displayed in the header view corner.
	*/ _createCloseButton() {
        const buttonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(this.locale);
        const t = this.locale.t;
        buttonView.set({
            label: t("Close"),
            tooltip: true,
            icon: (0, $e8dc502aba5ac3f5$export$6102dea6073ecfc0)
        });
        buttonView.on("execute", ()=>this.fire("close", {
                source: "closeButton"
            }));
        return buttonView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $29fd27cb9bdab9d2$var$SCROLL_LOCK_STYLES = ".ck-dialog-scroll-locked{overflow:hidden}";
/**
* The dialog controller class. It is used to show and hide the {@link module:ui/dialog/dialogview~DialogView}.
*/ var $29fd27cb9bdab9d2$export$3ddf2d174ce01153 = class Dialog extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The currently visible dialog view instance.
	*/ view;
    /**
	* The `Dialog` plugin instance which most recently showed the dialog.
	*
	* Only one dialog can be visible at once, even if there are many editor instances on the page.
	* If an editor wants to show a dialog, it should first hide the dialog that is already opened.
	* But only the `Dialog` instance that showed the dialog is able able to properly hide it.
	* This is why we need to store it in a globally available space (static property).
	* This way every `Dialog` plugin in every editor is able to correctly close any open dialog window.
	*/ static _visibleDialogPlugin;
    /**
	* A configurable callback called when the dialog is hidden.
	*/ _onHide;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Dialog";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        const t = editor.t;
        this._initShowHideListeners();
        this._initFocusToggler();
        this._initMultiRootIntegration();
        this.set({
            id: null,
            isOpen: false
        });
        editor.accessibility.addKeystrokeInfos({
            categoryId: "navigation",
            keystrokes: [
                {
                    label: t("Move focus in and out of an active dialog window"),
                    keystroke: "Ctrl+F6",
                    mayRequireFn: true
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (Dialog._visibleDialogPlugin === this) this._unlockBodyScroll();
    }
    /**
	* Initiates listeners for the `show` and `hide` events emitted by this plugin.
	*
	* We could not simply decorate the {@link #show} and {@link #hide} methods to fire events,
	* because they would be fired in the wrong order &ndash; first would be `show` and then `hide`
	* (because showing the dialog actually starts with hiding the previously visible one).
	* Hence, we added private methods {@link #_show} and {@link #_hide} which are called on events
	* in the desired sequence.
	*/ _initShowHideListeners() {
        this.on("show", (evt, args)=>{
            this._show(args);
        });
        this.on("show", (evt, args)=>{
            if (args.onShow) args.onShow(this);
        }, {
            priority: "low"
        });
        this.on("hide", ()=>{
            if (Dialog._visibleDialogPlugin) Dialog._visibleDialogPlugin._hide();
        });
        this.on("hide", ()=>{
            if (this._onHide) {
                this._onHide(this);
                this._onHide = void 0;
            }
        }, {
            priority: "low"
        });
    }
    /**
	* Initiates keystroke handler for toggling the focus between the editor and the dialog view.
	*/ _initFocusToggler() {
        const editor = this.editor;
        editor.keystrokes.set("Ctrl+F6", (data, cancel)=>{
            if (!this.isOpen || this.view.isModal) return;
            if (this.view.focusTracker.isFocused) editor.editing.view.focus();
            else this.view.focus();
            cancel();
        });
    }
    /**
	* Provides an integration between the root attaching and detaching and positioning of the view.
	*/ _initMultiRootIntegration() {
        const model = this.editor.model;
        model.document.on("change:data", ()=>{
            if (!this.view) return;
            const changedRoots = model.document.differ.getChangedRoots();
            for (const changes of changedRoots)if (changes.state) this.view.updatePosition();
        });
    }
    /**
	* Displays a dialog window.
	*
	* This method requires a {@link ~DialogDefinition} that defines the dialog's content, title, icon, action buttons, etc.
	*
	* For example, the following definition will create a dialog with:
	* * A header consisting of an icon, a title, and a "Close" button (it is added by default).
	* * A content consisting of a view with a single paragraph.
	* * A footer consisting of two buttons: "Yes" and "No".
	*
	* ```js
	* // Create the view that will be used as the dialog's content.
	* const textView = new View( locale );
	*
	* textView.setTemplate( {
	* 	tag: 'div',
	* 	attributes: {
	* 		style: {
	* 			padding: 'var(--ck-spacing-large)',
	* 			whiteSpace: 'initial',
	* 			width: '100%',
	* 			maxWidth: '500px'
	* 		},
	* 		tabindex: -1
	* 	},
	* 	children: [
	* 		'Lorem ipsum dolor sit amet...'
	* 	]
	* } );
	*
	* // Show the dialog.
	* editor.plugins.get( 'Dialog' ).show( {
	*	id: 'myDialog',
	* 	icon: 'myIcon', // This should be an SVG string.
	* 	title: 'My dialog',
	* 	content: textView,
	* 	actionButtons: [
	*		{
	*			label: t( 'Yes' ),
	*			class: 'ck-button-action',
	*			withText: true,
	*			onExecute: () => dialog.hide()
	*		},
	*		{
	*			label: t( 'No' ),
	*			withText: true,
	*			onExecute: () => dialog.hide()
	*		}
	*	]
	* } );
	* ```
	*
	* By specifying the {@link ~DialogDefinition#onShow} and {@link ~DialogDefinition#onHide} callbacks
	* it is also possible to add callbacks that will be called when the dialog is shown or hidden.
	*
	* For example, the callbacks in the following definition:
	* * Disable the default behavior of the <kbd>Esc</kbd> key.
	* * Fire a custom event when the dialog gets hidden.
	*
	* ```js
	* editor.plugins.get( 'Dialog' ).show( {
	* 	// ...
	* 	onShow: dialog => {
	* 		dialog.view.on( 'close', ( evt, data ) => {
	* 			// Only prevent the event from the "Esc" key - do not affect the other ways of closing the dialog.
	* 			if ( data.source === 'escKeyPress' ) {
	* 				evt.stop();
	* 			}
	* 		} );
	* 	},
	* 	onHide: dialog => {
	* 		dialog.fire( 'dialogDestroyed' );
	* 	}
	* } );
	* ```
	*
	* Internally, calling this method:
	* 1. Hides the currently visible dialog (if any) calling the {@link #hide} method
	* (fires the {@link ~DialogHideEvent hide event}).
	* 2. Fires the {@link ~DialogShowEvent show event} which allows for adding callbacks that customize the
	* behavior of the dialog.
	* 3. Shows the dialog.
	*/ show(dialogDefinition) {
        this.hide();
        this.fire(`show:${dialogDefinition.id}`, dialogDefinition);
    }
    /**
	* Handles creating the {@link module:ui/dialog/dialogview~DialogView} instance and making it visible.
	*/ _show({ id: id, icon: icon, title: title, hasCloseButton: hasCloseButton = true, content: content, actionButtons: actionButtons, className: className, isModal: isModal, position: position, onHide: onHide, getRootName: getRootName, keystrokeHandlerOptions: keystrokeHandlerOptions }) {
        const editor = this.editor;
        this.view = new $29fd27cb9bdab9d2$export$9adfefb9e06546bf(editor.locale, {
            getDomRootElement: ()=>{
                const rootName = getRootName?.() ?? this.editor.model.document.selection.anchor.root.rootName;
                if (!rootName || !editor.editing.view.domRoots.has(rootName)) return null;
                return editor.editing.view.getDomRoot(rootName) ?? null;
            },
            getViewportOffset: ()=>{
                return editor.ui.viewportOffset;
            },
            keystrokeHandlerOptions: keystrokeHandlerOptions
        });
        const view = this.view;
        view.on("close", ()=>{
            this.hide();
        });
        editor.ui.view.body.add(view);
        editor.keystrokes.listenTo(view.element);
        if (!position) position = isModal ? $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.SCREEN_CENTER : $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb.EDITOR_CENTER;
        if (isModal) this._lockBodyScroll();
        view.set({
            position: position,
            _isVisible: true,
            className: className,
            isModal: isModal
        });
        view.setupParts({
            icon: icon,
            title: title,
            hasCloseButton: hasCloseButton,
            content: content,
            actionButtons: actionButtons
        });
        this.id = id;
        if (onHide) this._onHide = onHide;
        this.isOpen = true;
        Dialog._visibleDialogPlugin = this;
    }
    /**
	* Hides the dialog. This method is decorated to enable interacting on the {@link ~DialogHideEvent hide event}.
	*
	* See {@link #show}.
	*/ hide() {
        if (Dialog._visibleDialogPlugin) Dialog._visibleDialogPlugin.fire(`hide:${Dialog._visibleDialogPlugin.id}`);
    }
    /**
	* Destroys the {@link module:ui/dialog/dialogview~DialogView} and cleans up the stored dialog state.
	*/ _hide() {
        if (!this.view) return;
        const editor = this.editor;
        const view = this.view;
        if (view.isModal) this._unlockBodyScroll();
        if (view.contentView) view.contentView.reset();
        editor.ui.view.body.remove(view);
        editor.ui.focusTracker.remove(view.element);
        editor.keystrokes.stopListening(view.element);
        view.destroy();
        editor.editing.view.focus();
        this.id = null;
        this.isOpen = false;
        Dialog._visibleDialogPlugin = null;
    }
    /**
	* Makes the <body> unscrollable (e.g. when the modal shows up).
	*/ _lockBodyScroll() {
        (0, $c7bc2cb7e2db0227$export$f6603621d2165759)(document, $29fd27cb9bdab9d2$var$SCROLL_LOCK_STYLES);
        document.documentElement.classList.add("ck-dialog-scroll-locked");
    }
    /**
	* Makes the <body> scrollable again (e.g. once the modal hides).
	*/ _unlockBodyScroll() {
        document.documentElement.classList.remove("ck-dialog-scroll-locked");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Button that is used as dropdown list item entry.
*/ var $29fd27cb9bdab9d2$export$244268489b08fe2c = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    /**
	* Holds the view for the check icon of a button list item.
	*/ _checkIconHolderView = new $29fd27cb9bdab9d2$export$65d60eff454262d();
    /**
	* @inheritDoc
	*/ constructor(locale, labelView = new $29fd27cb9bdab9d2$export$b940bfdc83894cd1()){
        super(locale, labelView);
        this.set({
            hasCheckSpace: false,
            _hasCheck: this.isToggleable
        });
        const bind = this.bindTemplate;
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-list-item-button",
                    bind.if("isToggleable", "ck-list-item-button_toggleable")
                ]
            }
        });
        this.bind("_hasCheck").to(this, "hasCheckSpace", this, "isToggleable", (hasCheckSpace, isToggleable)=>hasCheckSpace || isToggleable);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        if (this._hasCheck) this.children.add(this._checkIconHolderView, 0);
        this._watchCheckIconHolderMount();
    }
    /**
	* Renders the check icon if the button is toggleable.
	*/ _watchCheckIconHolderMount() {
        this._checkIconHolderView.bind("isOn").to(this, "isOn", (value)=>this.isToggleable && value);
        this.on("change:_hasCheck", (evt, propertyName, hasCheck)=>{
            const { children: children, _checkIconHolderView: _checkIconHolderView } = this;
            if (hasCheck) children.add(_checkIconHolderView, 0);
            else children.remove(_checkIconHolderView);
        });
    }
};
/**
* @internal
*/ var $29fd27cb9bdab9d2$export$65d60eff454262d = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of child views.
	*/ children;
    /**
	* The view for the check icon of the button list item.
	*/ _checkIconView = this._createCheckIconView();
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        const bind = this.bindTemplate;
        this.children = this.createCollection();
        this.set("isOn", false);
        this.setTemplate({
            tag: "span",
            children: this.children,
            attributes: {
                class: [
                    "ck",
                    "ck-list-item-button__check-holder",
                    bind.to("isOn", (isOn)=>isOn ? "ck-on" : "ck-off")
                ]
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        if (this.isOn) this.children.add(this._checkIconView, 0);
        this._watchCheckIconMount();
    }
    /**
	* Renders the check icon if the button is toggleable.
	*/ _watchCheckIconMount() {
        this.on("change:isOn", (evt, propertyName, isOn)=>{
            const { children: children, _checkIconView: _checkIconView } = this;
            if (isOn && !children.has(_checkIconView)) children.add(_checkIconView);
            else if (!isOn && children.has(_checkIconView)) children.remove(_checkIconView);
        });
    }
    /**
	* Creates a check icon view.
	*/ _createCheckIconView() {
        const iconView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        iconView.content = (0, $e8dc502aba5ac3f5$export$41713cd023818a26);
        iconView.extendTemplate({
            attributes: {
                class: "ck-list-item-button__check-icon"
            }
        });
        return iconView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A menu bar list button view. Buttons like this one execute user actions.
*/ var $29fd27cb9bdab9d2$export$6d96eff7641aad53 = class extends $29fd27cb9bdab9d2$export$244268489b08fe2c {
    /**
	* Creates an instance of the menu bar list button view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.set({
            withText: true,
            withKeystroke: true,
            tooltip: false,
            role: "menuitem"
        });
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-menu-bar__menu__item__button"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/accessibilityhelp/accessibilityhelp
*/ /**
* A plugin that brings the accessibility help dialog to the editor available under the <kbd>Alt</kbd>+<kbd>0</kbd>
* keystroke and via the "Accessibility help" toolbar button. The dialog displays a list of keystrokes that can be used
* by the user to perform various actions in the editor.
*
* Keystroke information is loaded from {@link module:core/accessibility~Accessibility#keystrokeInfos}. New entries can be
* added using the API provided by the {@link module:core/accessibility~Accessibility} class.
*/ var $29fd27cb9bdab9d2$export$a96e32aec1700e7e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The view that displays the dialog content (list of keystrokes).
	* Created when the dialog is opened for the first time.
	*/ contentView = null;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $29fd27cb9bdab9d2$export$3ddf2d174ce01153
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AccessibilityHelp";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        editor.ui.componentFactory.add("accessibilityHelp", ()=>{
            const button = this._createButton($29fd27cb9bdab9d2$export$4ca10aae50aa7bfa);
            button.set({
                tooltip: true,
                withText: false,
                label: t("Accessibility help")
            });
            return button;
        });
        editor.ui.componentFactory.add("menuBar:accessibilityHelp", ()=>{
            const button = this._createButton($29fd27cb9bdab9d2$export$6d96eff7641aad53);
            button.label = t("Accessibility");
            return button;
        });
        editor.keystrokes.set("Alt+0", (evt, cancel)=>{
            this._toggleDialog();
            cancel();
        });
        this._setupRootLabels();
    }
    /**
	* Creates a button to show accessibility help dialog, for use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        const locale = editor.locale;
        const view = new ButtonClass(locale);
        view.set({
            keystroke: "Alt+0",
            icon: (0, $e8dc502aba5ac3f5$export$5e6a1e6ee0d54ae4),
            isToggleable: true
        });
        view.on("execute", ()=>this._toggleDialog());
        view.bind("isOn").to(dialog, "id", (id)=>id === "accessibilityHelp");
        return view;
    }
    /**
	* Injects a help text into each editing root's `aria-label` attribute allowing assistive technology users
	* to discover the availability of the Accessibility help dialog.
	*/ _setupRootLabels() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const t = editor.t;
        editor.ui.on("ready", ()=>{
            editingView.change((writer)=>{
                for (const root of editingView.document.roots)addAriaLabelTextToRoot(writer, root);
            });
            editor.on("addRoot", (evt, modelRoot)=>{
                const viewRoot = editor.editing.view.document.getRoot(modelRoot.rootName);
                editingView.change((writer)=>addAriaLabelTextToRoot(writer, viewRoot));
            }, {
                priority: "low"
            });
        });
        function addAriaLabelTextToRoot(writer, viewRoot) {
            const newAriaLabel = [
                viewRoot.getAttribute("aria-label"),
                t("Press %0 for help.", [
                    (0, $c7bc2cb7e2db0227$export$bed8b4cac4d8577f)("Alt+0")
                ])
            ].filter((segment)=>segment).join(". ");
            writer.setAttribute("aria-label", newAriaLabel, viewRoot);
        }
    }
    /**
	* Shows the accessibility help dialog. Also, creates {@link #contentView} on demand.
	*/ _toggleDialog() {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        const t = editor.locale.t;
        if (!this.contentView) this.contentView = new $29fd27cb9bdab9d2$export$f52f2f74dc80426(editor.locale, editor.accessibility.keystrokeInfos);
        if (dialog.id === "accessibilityHelp") dialog.hide();
        else dialog.show({
            id: "accessibilityHelp",
            className: "ck-accessibility-help-dialog",
            title: t("Accessibility help"),
            hasCloseButton: true,
            content: this.contentView
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/bodycollection
*/ /**
* This is a special {@link module:ui/viewcollection~ViewCollection} dedicated to elements that are detached from the DOM structure of
* the editor, like floating panels, floating toolbars, dialogs, etc.
*
* The body collection is available under the {@link module:ui/editorui/editoruiview~EditorUIView#body `editor.ui.view.body`} property.
* Any plugin can add a {@link module:ui/view~View view} to this collection.
*
* All views added to a body collection render in a dedicated DOM container (`<div class="ck ck-body ...">...</div>`). All body collection
* containers render in a common shared (`<div class="ck-body-wrapper">...</div>`) in the DOM to limit the pollution of
* the `<body>` element. The resulting DOM structure is as follows:
*
* ```html
* <body>
* 	<!-- Content of the webpage... -->
*
* 	<!-- The shared wrapper for all body collection containers. -->
* 	<div class="ck-body-wrapper">
* 		<!-- The container of the first body collection instance. -->
* 		<div class="ck ck-body ...">
* 			<!-- View elements belonging to the first body collection -->
* 		</div>
*
* 		<!-- The container of the second body collection instance. -->
* 		<div class="ck ck-body ...">...</div>
*
* 		<!-- More body collection containers for the rest of instances... -->
* 	</div>
* </body>
* ```
*
* By default, the {@link module:ui/editorui/editoruiview~EditorUIView `editor.ui.view`} manages the life cycle of the
* {@link module:ui/editorui/editoruiview~EditorUIView#body `editor.ui.view.body`} collection, attaching and detaching it
* when the editor gets created or {@link module:core/editor/editor~Editor#destroy destroyed}.
*
* # Custom body collection instances
*
* Even though most editor instances come with a built-in body collection
* ({@link module:ui/editorui/editoruiview~EditorUIView#body `editor.ui.view.body`}), you can create your own instance of this
* class if you need to control their life cycle.
*
* The life cycle of a custom body collection must be handled manually by the developer using the dedicated API:
* * A body collection will render itself automatically in the DOM as soon as you call {@link ~BodyCollection#attachToDom}.
* * Calling {@link ~BodyCollection#destroy} will remove the collection from the DOM and destroy its views.
*
* **Note**: The shared collection wrapper (`<div class="ck-body-wrapper">...</div>`) gets automatically removed from DOM when the
* last body collection is {@link ~BodyCollection#destroy destroyed} and does not require any special handling.
*/ var $29fd27cb9bdab9d2$export$f96d1f01684ec5c2 = class BodyCollection extends $29fd27cb9bdab9d2$export$ff20b327de53fba7 {
    /**
	* The {@link module:core/editor/editor~Editor#locale editor's locale} instance.
	* See the view {@link module:ui/view~View#locale locale} property.
	*/ locale;
    /**
	* The element holding elements of the body collection.
	*/ _bodyCollectionContainer;
    /**
	* The mount target the {@link #_bodyCollectionContainer} is currently attached to (through the shared
	* wrapper): the `document.body` for editors in the light DOM, or a `ShadowRoot` (or a configured element)
	* for editors living inside a shadow root. Tracked so the collection can be re-mounted into a different
	* target and cleaned up from the right wrapper.
	*/ _mountTarget;
    /**
	* The shared wrapper elements that hold the {@link #_bodyCollectionContainer} elements, keyed by the
	* mount target (the element or shadow root the wrapper is attached to – not the editor's editing root).
	* Body collections attached to the same target (e.g. the same shadow root) share a single wrapper;
	* body collections attached to different targets get separate wrappers.
	*/ static _bodyWrappers = /* @__PURE__ */ new Map();
    /**
	* Creates a new instance of the {@link module:ui/editorui/bodycollection~BodyCollection}.
	*
	* @param locale The {@link module:core/editor/editor~Editor editor's locale} instance.
	* @param initialItems The initial items of the collection.
	*/ constructor(locale, initialItems = []){
        super(initialItems);
        this.locale = locale;
    }
    /**
	* The element holding elements of the body collection. It is created on demand – the first time it is
	* accessed or the collection is {@link #attachToDom attached} – and reused afterwards. Creating it does
	* not attach it to the DOM (that happens in {@link #attachToDom}), so it is available for focus tracking
	* and styling even while the collection is not mounted yet.
	*/ get bodyCollectionContainer() {
        if (!this._bodyCollectionContainer) this._bodyCollectionContainer = new $29fd27cb9bdab9d2$export$14416b8d99d47caa({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-reset_all",
                    "ck-body",
                    "ck-rounded-corners"
                ],
                dir: this.locale.uiLanguageDirection,
                role: "application"
            },
            children: this
        }).render();
        return this._bodyCollectionContainer;
    }
    /**
	* The mount target (element or shadow root) the collection is currently attached to, or `undefined`
	* before {@link #attachToDom} is called or after {@link #unmountFromDom} or {@link #destroy}.
	*/ get mountTarget() {
        return this._mountTarget;
    }
    /**
	* Attaches the body collection to the DOM. You need to execute this method to render the content of
	* the body collection.
	*
	* By default the collection mounts in a shared wrapper under the `document.body`. Pass a `target` to
	* mount it elsewhere – for example inside the {@link module:utils/dom/isshadowroot~isShadowRoot shadow root}
	* an editor lives in, so that floating UI (balloons, dialogs, tooltips) can be styled within that
	* boundary. The `target` may be a regular element or a shadow root, open or closed. Calling this method
	* again with a different `target` re-mounts the already rendered collection into the new location.
	*
	* @param target The element or shadow root to mount the body collection in. Defaults to `document.body`.
	*/ attachToDom(target) {
        const mountTarget = target || document.body;
        const previousMountTarget = this._mountTarget;
        BodyCollection._getBodyWrapper(mountTarget).appendChild(this.bodyCollectionContainer);
        this._mountTarget = mountTarget;
        if (previousMountTarget && previousMountTarget !== mountTarget) BodyCollection._removeBodyWrapperIfEmpty(previousMountTarget);
        if (previousMountTarget !== mountTarget) this.fire("remount");
    }
    /**
	* Keeps the collection mounted in the given target: attaches it there when the target differs from the
	* current {@link #mountTarget} (see {@link #attachToDom}), unmounts it on a `null` target (see
	* {@link #unmountFromDom}), and leaves the DOM untouched when the collection already sits in the target.
	*
	* Designed for repeated calls with a freshly resolved target (for example on every editor UI update, or
	* with the result of {@link module:utils/dom/getoverlaymountroot~getOverlayMountRoot}), as opposed to
	* {@link #attachToDom}, which re-appends the container even when the target did not change.
	*
	* @param target The element or shadow root to mount the body collection in, or `null` to unmount it.
	*/ syncMountTarget(target) {
        if (target) {
            if (this._mountTarget !== target) this.attachToDom(target);
        } else if (this._mountTarget) this.unmountFromDom();
    }
    /**
	* Destroys the body collection: destroys its views and removes their shared container from the DOM. Use this
	* method when you do not need the body collection anymore. For a reversible removal that keeps the views so the
	* collection can be {@link #attachToDom attached} again, use {@link #unmountFromDom} instead.
	*/ destroy() {
        super.destroy();
        this._removeFromDom();
    }
    /**
	* Removes the collection's container from the DOM without destroying its views, so it can be attached
	* again later with {@link #attachToDom} – for example when the editor is temporarily disconnected from
	* the document. For permanent teardown use {@link #destroy} instead.
	*/ unmountFromDom() {
        this._removeFromDom();
    }
    /**
	* Removes the collection's container (and the shared wrapper, if now empty) from the DOM, keeping the
	* container instance so it can be re-attached.
	*/ _removeFromDom() {
        const wasMounted = !!this._mountTarget;
        if (this._bodyCollectionContainer) this._bodyCollectionContainer.remove();
        BodyCollection._removeBodyWrapperIfEmpty(this._mountTarget);
        this._mountTarget = void 0;
        if (wasMounted) this.fire("remount");
    }
    /**
	* Returns the shared wrapper element for the given mount target, creating (and attaching) it if it does
	* not exist yet or is no longer contained by the target. Body collections sharing a target share a wrapper.
	*
	* The staleness check asks whether the target still contains the wrapper rather than testing `isConnected`,
	* so a wrapper stays reused when the target itself is legitimately detached from the document (for example a
	* configured {@link module:core/editor/editorconfig~UiConfig#overlayContainer `ui.overlayContainer`} that
	* is inserted later). Testing `isConnected` there would treat the still-attached wrapper as stale and build
	* a duplicate wrapper for every body collection sharing that target.
	*
	* @param mountTarget The element or shadow root the wrapper is (or should be) attached to.
	*/ static _getBodyWrapper(mountTarget) {
        let wrapper = BodyCollection._bodyWrappers.get(mountTarget);
        if (!wrapper || !mountTarget.contains(wrapper)) {
            wrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(mountTarget.ownerDocument, "div", {
                class: "ck-body-wrapper"
            });
            mountTarget.appendChild(wrapper);
            BodyCollection._bodyWrappers.set(mountTarget, wrapper);
        }
        return wrapper;
    }
    /**
	* Removes the shared wrapper for the given mount target (and forgets it) once it holds no more body
	* collections.
	*
	* @param mountTarget The element or shadow root the wrapper is attached to.
	*/ static _removeBodyWrapperIfEmpty(mountTarget) {
        if (!mountTarget) return;
        const wrapper = BodyCollection._bodyWrappers.get(mountTarget);
        if (wrapper && !wrapper.childElementCount) {
            wrapper.remove();
            BodyCollection._bodyWrappers.delete(mountTarget);
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/panel/balloon/balloonpanelview
*/ const $29fd27cb9bdab9d2$var$toPx$5 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
const $29fd27cb9bdab9d2$var$POSITION_OFF_SCREEN = {
    top: -99999,
    left: -99999,
    name: "arrowless",
    config: {
        withArrow: false
    }
};
/**
* The balloon panel view class.
*
* A floating container which can
* {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#pin pin} to any
* {@link module:utils/dom/position~DomOptimalPositionOptions#target target} in the DOM and remain in that position
* e.g. when the web page is scrolled.
*
* The balloon panel can be used to display contextual, non-blocking UI like forms, toolbars and
* the like in its {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#content} view
* collection.
*
* There is a number of {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}
* that the balloon can use, automatically switching from one to another when the viewport space becomes
* scarce to keep the balloon visible to the user as long as it is possible. The balloon will also
* accept any custom position set provided by the user compatible with the
* {@link module:utils/dom/position~DomOptimalPositionOptions options}.
*
* ```ts
* const panel = new BalloonPanelView( locale );
* const childView = new ChildView();
* const positions = BalloonPanelView.defaultPositions;
*
* panel.render();
*
* // Add a child view to the panel's content collection.
* panel.content.add( childView );
*
* // Start pinning the panel to an element with the "target" id DOM.
* // The balloon will remain pinned until unpin() is called.
* panel.pin( {
* 	target: document.querySelector( '#target' ),
* 	positions: [
* 		positions.northArrowSouth,
* 		positions.southArrowNorth
* 	]
* } );
* ```
*/ var $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c = class BalloonPanelView extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of the child views that creates the balloon panel contents.
	*/ content;
    /**
	* A callback that starts pinning the panel when {@link #isVisible} gets
	* `true`. Used by {@link #pin}.
	*
	* @private
	*/ _pinWhenIsVisibleCallback;
    /**
	* An instance of resize observer used to detect if target element is still visible.
	*/ _resizeObserver;
    /**
	* The nodes the `scroll` listener of the currently pinned panel is attached to: `document` plus every shadow
	* root hosting the positioning target or the limiter. Emptied by {@link #_stopPinning}.
	*
	* A single `document` listener is not enough, because `scroll` is not `composed` — its event path ends at
	* the shadow root it originated in, so not even a capturing listener on `document` sees a scrollable
	* container living inside a shadow root.
	*/ _scrollListenerDomRoots = [];
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("top", 0);
        this.set("left", 0);
        this.set("position", "arrow_nw");
        this.set("isVisible", false);
        this.set("withArrow", true);
        this.set("class", void 0);
        this._pinWhenIsVisibleCallback = null;
        this._resizeObserver = null;
        this.content = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-balloon-panel",
                    bind.to("position", (value)=>`ck-balloon-panel_${value}`),
                    bind.if("isVisible", "ck-balloon-panel_visible"),
                    bind.if("withArrow", "ck-balloon-panel_with-arrow"),
                    bind.to("class")
                ],
                style: {
                    top: bind.to("top", $29fd27cb9bdab9d2$var$toPx$5),
                    left: bind.to("left", $29fd27cb9bdab9d2$var$toPx$5)
                }
            },
            children: this.content
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this.hide();
        super.destroy();
    }
    /**
	* Shows the panel.
	*
	* See {@link #isVisible}.
	*/ show() {
        this.isVisible = true;
    }
    /**
	* Hides the panel.
	*
	* See {@link #isVisible}.
	*/ hide() {
        this.isVisible = false;
    }
    /**
	* Attaches the panel to a specified {@link module:utils/dom/position~DomOptimalPositionOptions#target} with a
	* smart positioning heuristics that chooses from available positions to make sure the panel
	* is visible to the user i.e. within the limits of the viewport.
	*
	* This method accepts configuration {@link module:utils/dom/position~DomOptimalPositionOptions options}
	* to set the `target`, optional `limiter` and `positions` the balloon should choose from.
	*
	* ```ts
	* const panel = new BalloonPanelView( locale );
	* const positions = BalloonPanelView.defaultPositions;
	*
	* panel.render();
	*
	* // Attach the panel to an element with the "target" id DOM.
	* panel.attachTo( {
	* 	target: document.querySelector( '#target' ),
	* 	positions: [
	* 		positions.northArrowSouth,
	* 		positions.southArrowNorth
	* 	]
	* } );
	* ```
	*
	* **Note**: Attaching the panel will also automatically {@link #show} it.
	*
	* **Note**: An attached panel will not follow its target when the window is scrolled or resized.
	* See the {@link #pin} method for a more permanent positioning strategy.
	*
	* @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
	* Default `positions` array is {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
	* @returns Whether the balloon was shown and successfully attached or not. Attaching can fail if the target
	* provided in the options is invisible (e.g. element detached from DOM).
	*/ attachTo(options) {
        const target = $29fd27cb9bdab9d2$var$getDomElement(options.target);
        if (target && !(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(target)) return false;
        this.show();
        const defaultPositions = BalloonPanelView.defaultPositions;
        const positionOptions = Object.assign({}, {
            element: this.element,
            positions: [
                defaultPositions.southArrowNorth,
                defaultPositions.southArrowNorthMiddleWest,
                defaultPositions.southArrowNorthMiddleEast,
                defaultPositions.southArrowNorthWest,
                defaultPositions.southArrowNorthEast,
                defaultPositions.northArrowSouth,
                defaultPositions.northArrowSouthMiddleWest,
                defaultPositions.northArrowSouthMiddleEast,
                defaultPositions.northArrowSouthWest,
                defaultPositions.northArrowSouthEast,
                defaultPositions.viewportStickyNorth
            ],
            limiter: (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body,
            fitInViewport: true
        }, options);
        const optimalPosition = BalloonPanelView._getOptimalPosition(positionOptions) || $29fd27cb9bdab9d2$var$POSITION_OFF_SCREEN;
        const left = parseInt(optimalPosition.left);
        const top = parseInt(optimalPosition.top);
        const position = optimalPosition.name;
        const { withArrow: withArrow = true } = optimalPosition.config || {};
        this.top = top;
        this.left = left;
        this.position = position;
        this.withArrow = withArrow;
        return true;
    }
    /**
	* Works the same way as the {@link #attachTo} method except that the position of the panel is
	* continuously updated when:
	*
	* * any ancestor of the {@link module:utils/dom/position~DomOptimalPositionOptions#target}
	* or {@link module:utils/dom/position~DomOptimalPositionOptions#limiter} is scrolled,
	* * the browser window gets resized or scrolled.
	*
	* Thanks to that, the panel always sticks to the {@link module:utils/dom/position~DomOptimalPositionOptions#target}
	* and is immune to the changing environment.
	*
	* ```ts
	* const panel = new BalloonPanelView( locale );
	* const positions = BalloonPanelView.defaultPositions;
	*
	* panel.render();
	*
	* // Pin the panel to an element with the "target" id DOM.
	* panel.pin( {
	* 	target: document.querySelector( '#target' ),
	* 	positions: [
	* 		positions.northArrowSouth,
	* 		positions.southArrowNorth
	* 	]
	* } );
	* ```
	*
	* To leave the pinned state, use the {@link #unpin} method.
	*
	* **Note**: Pinning the panel will also automatically {@link #show} it.
	*
	* @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
	* Default `positions` array is {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
	*/ pin(options) {
        this.unpin();
        if (!this._startPinning(options)) return;
        this._pinWhenIsVisibleCallback = ()=>{
            if (this.isVisible) this._startPinning(options);
            else this._stopPinning();
        };
        this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
    }
    /**
	* Stops pinning the panel, as set up by {@link #pin}.
	*/ unpin() {
        if (this._pinWhenIsVisibleCallback) {
            this._stopPinning();
            this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback);
            this._pinWhenIsVisibleCallback = null;
            this.hide();
        }
    }
    /**
	* Starts managing the pinned state of the panel. See {@link #pin}.
	*
	* @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
	* @returns Whether the balloon was shown and successfully attached or not. Attaching can fail if the target
	* provided in the options is invisible (e.g. element detached from DOM).
	*/ _startPinning(options) {
        if (!this.attachTo(options)) return false;
        let targetElement = $29fd27cb9bdab9d2$var$getDomElement(options.target);
        const limiterElement = options.limiter ? $29fd27cb9bdab9d2$var$getDomElement(options.limiter) : (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body;
        this._scrollListenerDomRoots = $29fd27cb9bdab9d2$var$getScrollListenerDomRoots([
            targetElement,
            limiterElement
        ]);
        for (const root of this._scrollListenerDomRoots)this.listenTo(root, "scroll", (evt, domEvt)=>{
            const scrollTarget = domEvt.target;
            const isWithinScrollTarget = targetElement && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(scrollTarget, targetElement);
            const isLimiterWithinScrollTarget = limiterElement && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(scrollTarget, limiterElement);
            if (isWithinScrollTarget || isLimiterWithinScrollTarget || !targetElement || !limiterElement) this.attachTo(options);
        }, {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize", ()=>{
            this.attachTo(options);
        });
        if (!this._resizeObserver) {
            if (targetElement && (0, $c7bc2cb7e2db0227$export$1879817ac5c922b7)(targetElement)) targetElement = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(targetElement);
            if (targetElement) {
                const checkVisibility = ()=>{
                    if (!(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(targetElement)) this.unpin();
                };
                this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(targetElement, checkVisibility);
            }
        }
        return true;
    }
    /**
	* Stops managing the pinned state of the panel. See {@link #pin}.
	*/ _stopPinning() {
        for (const root of this._scrollListenerDomRoots)this.stopListening(root, "scroll");
        this._scrollListenerDomRoots = [];
        this.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize");
        if (this._resizeObserver) {
            this._resizeObserver.destroy();
            this._resizeObserver = null;
        }
    }
    /**
	* Returns available {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
	* {@link module:utils/dom/position~PositioningFunction positioning functions} adjusted by the specific offsets.
	*
	* @internal
	* @param options Options to generate positions. If not specified, this helper will simply return
	* {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
	* @param options.sideOffset A custom side offset (in pixels) of each position. If
	* not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.arrowSideOffset the default value}
	* will be used.
	* @param options.heightOffset A custom height offset (in pixels) of each position. If
	* not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.arrowHeightOffset the default value}
	* will be used.
	* @param options.stickyVerticalOffset A custom offset (in pixels) of the `viewportStickyNorth` positioning function.
	* If not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.stickyVerticalOffset the default value}
	* will be used.
	* @param options.config Additional configuration of the balloon balloon panel view.
	* Currently only {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#withArrow} is supported. Learn more
	* about {@link module:utils/dom/position~PositioningFunction positioning functions}.
	*/ static generatePositions(options = {}) {
        const { sideOffset: sideOffset = BalloonPanelView.arrowSideOffset, heightOffset: heightOffset = BalloonPanelView.arrowHeightOffset, stickyVerticalOffset: stickyVerticalOffset = BalloonPanelView.stickyVerticalOffset, config: config } = options;
        return {
            northWestArrowSouthWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left - sideOffset,
                    name: "arrow_sw",
                    ...config && {
                        config: config
                    }
                }),
            northWestArrowSouthMiddleWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left - balloonRect.width * .25 - sideOffset,
                    name: "arrow_smw",
                    ...config && {
                        config: config
                    }
                }),
            northWestArrowSouth: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left - balloonRect.width / 2,
                    name: "arrow_s",
                    ...config && {
                        config: config
                    }
                }),
            northWestArrowSouthMiddleEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left - balloonRect.width * .75 + sideOffset,
                    name: "arrow_sme",
                    ...config && {
                        config: config
                    }
                }),
            northWestArrowSouthEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left - balloonRect.width + sideOffset,
                    name: "arrow_se",
                    ...config && {
                        config: config
                    }
                }),
            northArrowSouthWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left + targetRect.width / 2 - sideOffset,
                    name: "arrow_sw",
                    ...config && {
                        config: config
                    }
                }),
            northArrowSouthMiddleWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width * .25 - sideOffset,
                    name: "arrow_smw",
                    ...config && {
                        config: config
                    }
                }),
            northArrowSouth: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width / 2,
                    name: "arrow_s",
                    ...config && {
                        config: config
                    }
                }),
            northArrowSouthMiddleEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width * .75 + sideOffset,
                    name: "arrow_sme",
                    ...config && {
                        config: config
                    }
                }),
            northArrowSouthEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width + sideOffset,
                    name: "arrow_se",
                    ...config && {
                        config: config
                    }
                }),
            northEastArrowSouthWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.right - sideOffset,
                    name: "arrow_sw",
                    ...config && {
                        config: config
                    }
                }),
            northEastArrowSouthMiddleWest: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.right - balloonRect.width * .25 - sideOffset,
                    name: "arrow_smw",
                    ...config && {
                        config: config
                    }
                }),
            northEastArrowSouth: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.right - balloonRect.width / 2,
                    name: "arrow_s",
                    ...config && {
                        config: config
                    }
                }),
            northEastArrowSouthMiddleEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.right - balloonRect.width * .75 + sideOffset,
                    name: "arrow_sme",
                    ...config && {
                        config: config
                    }
                }),
            northEastArrowSouthEast: (targetRect, balloonRect)=>({
                    top: getNorthTop(targetRect, balloonRect),
                    left: targetRect.right - balloonRect.width + sideOffset,
                    name: "arrow_se",
                    ...config && {
                        config: config
                    }
                }),
            southWestArrowNorthWest: (targetRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left - sideOffset,
                    name: "arrow_nw",
                    ...config && {
                        config: config
                    }
                }),
            southWestArrowNorthMiddleWest: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left - balloonRect.width * .25 - sideOffset,
                    name: "arrow_nmw",
                    ...config && {
                        config: config
                    }
                }),
            southWestArrowNorth: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left - balloonRect.width / 2,
                    name: "arrow_n",
                    ...config && {
                        config: config
                    }
                }),
            southWestArrowNorthMiddleEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left - balloonRect.width * .75 + sideOffset,
                    name: "arrow_nme",
                    ...config && {
                        config: config
                    }
                }),
            southWestArrowNorthEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left - balloonRect.width + sideOffset,
                    name: "arrow_ne",
                    ...config && {
                        config: config
                    }
                }),
            southArrowNorthWest: (targetRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left + targetRect.width / 2 - sideOffset,
                    name: "arrow_nw",
                    ...config && {
                        config: config
                    }
                }),
            southArrowNorthMiddleWest: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width * .25 - sideOffset,
                    name: "arrow_nmw",
                    ...config && {
                        config: config
                    }
                }),
            southArrowNorth: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width / 2,
                    name: "arrow_n",
                    ...config && {
                        config: config
                    }
                }),
            southArrowNorthMiddleEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width * .75 + sideOffset,
                    name: "arrow_nme",
                    ...config && {
                        config: config
                    }
                }),
            southArrowNorthEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width + sideOffset,
                    name: "arrow_ne",
                    ...config && {
                        config: config
                    }
                }),
            southEastArrowNorthWest: (targetRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.right - sideOffset,
                    name: "arrow_nw",
                    ...config && {
                        config: config
                    }
                }),
            southEastArrowNorthMiddleWest: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.right - balloonRect.width * .25 - sideOffset,
                    name: "arrow_nmw",
                    ...config && {
                        config: config
                    }
                }),
            southEastArrowNorth: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.right - balloonRect.width / 2,
                    name: "arrow_n",
                    ...config && {
                        config: config
                    }
                }),
            southEastArrowNorthMiddleEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.right - balloonRect.width * .75 + sideOffset,
                    name: "arrow_nme",
                    ...config && {
                        config: config
                    }
                }),
            southEastArrowNorthEast: (targetRect, balloonRect)=>({
                    top: getSouthTop(targetRect),
                    left: targetRect.right - balloonRect.width + sideOffset,
                    name: "arrow_ne",
                    ...config && {
                        config: config
                    }
                }),
            westArrowEast: (targetRect, balloonRect)=>({
                    top: targetRect.top + targetRect.height / 2 - balloonRect.height / 2,
                    left: targetRect.left - balloonRect.width - heightOffset,
                    name: "arrow_e",
                    ...config && {
                        config: config
                    }
                }),
            eastArrowWest: (targetRect, balloonRect)=>({
                    top: targetRect.top + targetRect.height / 2 - balloonRect.height / 2,
                    left: targetRect.right + heightOffset,
                    name: "arrow_w",
                    ...config && {
                        config: config
                    }
                }),
            viewportStickyNorth: (targetRect, balloonRect, viewportRect)=>{
                const boundaryRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body).getIntersection(viewportRect.getVisible());
                if (!boundaryRect) return null;
                const visibleBoundaryRect = boundaryRect.getVisible();
                if (!targetRect.getIntersection(visibleBoundaryRect)) return null;
                if (!(visibleBoundaryRect.top - targetRect.top - stickyVerticalOffset < balloonRect.height && visibleBoundaryRect.bottom - targetRect.bottom < balloonRect.height)) return null;
                return {
                    top: visibleBoundaryRect.top + stickyVerticalOffset,
                    left: targetRect.left + targetRect.width / 2 - balloonRect.width / 2,
                    name: "arrowless",
                    config: {
                        withArrow: false,
                        ...config
                    }
                };
            }
        };
        /**
		* Returns the top coordinate for positions starting with `north*`.
		*
		* @param targetRect A rect of the target.
		* @param balloonRect A rect of the balloon.
		*/ function getNorthTop(targetRect, balloonRect) {
            return targetRect.top - balloonRect.height - heightOffset;
        }
        /**
		* Returns the top coordinate for positions starting with `south*`.
		*
		* @param targetRect A rect of the target.
		*/ function getSouthTop(targetRect) {
            return targetRect.bottom + heightOffset;
        }
    }
    /**
	* A side offset of the arrow tip from the edge of the balloon. Controlled by CSS.
	*
	* ```
	*		 ┌───────────────────────┐
	*		 │                       │
	*		 │         Balloon       │
	*		 │         Content       │
	*		 │                       │
	*		 └──+    +───────────────┘
	*		 |   \  /
	*		 |    \/
	*		>┼─────┼< ─────────────────────── side offset
	*
	* ```
	*
	* @default 25
	*/ static arrowSideOffset = 25;
    /**
	* A height offset of the arrow from the edge of the balloon. Controlled by CSS.
	*
	* ```
	*		 ┌───────────────────────┐
	*		 │                       │
	*		 │         Balloon       │
	*		 │         Content       │      ╱-- arrow height offset
	*		 │                       │      V
	*		 └──+    +───────────────┘ --- ─┼───────
	*		     \  /                       │
	*		      \/                        │
	*		────────────────────────────────┼───────
	*		                                ^
	*
	*
	*		>┼────┼<  arrow height offset
	*		 │    │
	*		 │    ┌────────────────────────┐
	*		 │    │                        │
	*		 │   ╱                         │
	*		 │ ╱            Balloon        │
	*		 │ ╲            Content        │
	*		 │   ╲                         │
	*		 │    │                        │
	*		 │    └────────────────────────┘
	* ```
	*
	* @default 10
	*/ static arrowHeightOffset = 10;
    /**
	* A vertical offset of the balloon panel from the edge of the viewport if sticky.
	* It helps in accessing toolbar buttons underneath the balloon panel.
	*
	* ```
	*		  ┌───────────────────────────────────────────────────┐
	*		  │                      Target                       │
	*		  │                                                   │
	*		  │                            /── vertical offset    │
	*		┌─────────────────────────────V─────────────────────────┐
	*		│ Toolbar            ┌─────────────┐                    │
	*		├────────────────────│   Balloon   │────────────────────┤
	*		│ │                  └─────────────┘                  │ │
	*		│ │                                                   │ │
	*		│ │                                                   │ │
	*		│ │                                                   │ │
	*		│ └───────────────────────────────────────────────────┘ │
	*		│                        Viewport                       │
	*		└───────────────────────────────────────────────────────┘
	* ```
	*
	* @default 20
	*/ static stickyVerticalOffset = 20;
    /**
	* Function used to calculate the optimal position for the balloon.
	*/ static _getOptimalPosition = (0, $c7bc2cb7e2db0227$export$75cda5409326f127);
    /**
	* A default set of positioning functions used by the balloon panel view
	* when attaching using the {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#attachTo} method.
	*
	* The available positioning functions are as follows:
	*
	* **North west**
	*
	* * `northWestArrowSouthWest`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		 V
	*		 [ Target ]
	* ```
	*
	* * `northWestArrowSouthMiddleWest`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		    V
	*		    [ Target ]
	* ```
	*
	* * `northWestArrowSouth`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		         V
	*		         [ Target ]
	* ```
	*
	* * `northWestArrowSouthMiddleEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		             V
	*		             [ Target ]
	* ```
	*
	* * `northWestArrowSouthEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		                 V
	*		                 [ Target ]
	* ```
	*
	* **North**
	*
	* * `northArrowSouthWest`
	*
	* ```
	*		    +-----------------+
	*		    |     Balloon     |
	*		    +-----------------+
	*		     V
	*		[ Target ]
	* ```
	*
	* * `northArrowSouthMiddleWest`
	*
	* ```
	*		 +-----------------+
	*		 |     Balloon     |
	*		 +-----------------+
	*		     V
	*		[ Target ]
	* ```
	* * `northArrowSouth`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		         V
	*		    [ Target ]
	* ```
	*
	* * `northArrowSouthMiddleEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		             V
	*		        [ Target ]
	* ```
	*
	* * `northArrowSouthEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		                V
	*		           [ Target ]
	* ```
	*
	* **North east**
	*
	* * `northEastArrowSouthWest`
	*
	* ```
	*		        +-----------------+
	*		        |     Balloon     |
	*		        +-----------------+
	*		         V
	*		[ Target ]
	* ```
	*
	* * `northEastArrowSouthMiddleWest`
	*
	* ```
	*		     +-----------------+
	*		     |     Balloon     |
	*		     +-----------------+
	*		         V
	*		[ Target ]
	* ```
	*
	* * `northEastArrowSouth`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		         V
	*		[ Target ]
	* ```
	*
	* * `northEastArrowSouthMiddleEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		             V
	*		    [ Target ]
	* ```
	*
	* * `northEastArrowSouthEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	*		                 V
	*		        [ Target ]
	* ```
	*
	* **South**
	*
	* * `southArrowNorthWest`
	*
	* ```
	*		[ Target ]
	*		     ^
	*		    +-----------------+
	*		    |     Balloon     |
	*		    +-----------------+
	* ```
	*
	* * `southArrowNorthMiddleWest`
	*
	* ```
	*		   [ Target ]
	*		        ^
	*		    +-----------------+
	*		    |     Balloon     |
	*		    +-----------------+
	* ```
	*
	* * `southArrowNorth`
	*
	* ```
	*		    [ Target ]
	*		         ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southArrowNorthMiddleEast`
	*
	* ```
	*		            [ Target ]
	*		                 ^
	*		   +-----------------+
	*		   |     Balloon     |
	*		   +-----------------+
	* ```
	*
	* * `southArrowNorthEast`
	*
	* ```
	*		            [ Target ]
	*		                 ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* **South west**
	*
	* * `southWestArrowNorthWest`
	*
	*
	* ```
	*		 [ Target ]
	*		 ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southWestArrowNorthMiddleWest`
	*
	* ```
	*		     [ Target ]
	*		     ^
	*		 +-----------------+
	*		 |     Balloon     |
	*		 +-----------------+
	* ```
	*
	* * `southWestArrowNorth`
	*
	* ```
	*		         [ Target ]
	*		         ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southWestArrowNorthMiddleEast`
	*
	* ```
	*		              [ Target ]
	*		              ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southWestArrowNorthEast`
	*
	* ```
	*		                 [ Target ]
	*		                 ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* **South east**
	*
	* * `southEastArrowNorthWest`
	*
	* ```
	*		[ Target ]
	*		         ^
	*		        +-----------------+
	*		        |     Balloon     |
	*		        +-----------------+
	* ```
	*
	* * `southEastArrowNorthMiddleWest`
	*
	* ```
	*		   [ Target ]
	*		            ^
	*		        +-----------------+
	*		        |     Balloon     |
	*		        +-----------------+
	* ```
	*
	* * `southEastArrowNorth`
	*
	* ```
	*		[ Target ]
	*		         ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southEastArrowNorthMiddleEast`
	*
	* ```
	*		     [ Target ]
	*		              ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* * `southEastArrowNorthEast`
	*
	* ```
	*		        [ Target ]
	*		                 ^
	*		+-----------------+
	*		|     Balloon     |
	*		+-----------------+
	* ```
	*
	* **West**
	*
	* * `westArrowEast`
	*
	* ```
	*		+-----------------+
	*		|     Balloon     |>[ Target ]
	*		+-----------------+
	* ```
	*
	* **East**
	*
	* * `eastArrowWest`
	*
	* ```
	*		           +-----------------+
	*		[ Target ]<|     Balloon     |
	*		           +-----------------+
	* ```
	*
	* **Sticky**
	*
	* * `viewportStickyNorth`
	*
	* ```
	*		    +---------------------------+
	*		    |        [ Target ]         |
	*		    |                           |
	*		+-----------------------------------+
	*		|   |    +-----------------+    |   |
	*		|   |    |     Balloon     |    |   |
	*		|   |    +-----------------+    |   |
	*		|   |                           |   |
	*		|   |                           |   |
	*		|   |                           |   |
	*		|   |                           |   |
	*		|   +---------------------------+   |
	*		|             Viewport              |
	*		+-----------------------------------+
	* ```
	*
	* See {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#attachTo}.
	*
	* Positioning functions must be compatible with {@link module:utils/dom/position~DomPoint}.
	*
	* Default positioning functions with customized offsets can be generated using
	* {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.generatePositions}.
	*
	* The name that the position function returns will be reflected in the balloon panel's class that
	* controls the placement of the "arrow". See {@link #position} to learn more.
	*/ static defaultPositions = /* #__PURE__ */ BalloonPanelView.generatePositions();
};
/**
* Returns the DOM element for given object or null, if there is none,
* e.g. when the passed object is a Rect instance or so.
*/ function $29fd27cb9bdab9d2$var$getDomElement(object) {
    if ((0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(object)) return object;
    if ((0, $c7bc2cb7e2db0227$export$e331ccfa6f694c99)(object)) return object.commonAncestorContainer;
    if (typeof object == "function") return $29fd27cb9bdab9d2$var$getDomElement(object());
    return null;
}
/**
* Returns the nodes a `scroll` listener must be attached to in order to observe scrolling of any container that
* hosts one of the given nodes: `document` plus every shadow root those nodes live in.
*/ function $29fd27cb9bdab9d2$var$getScrollListenerDomRoots(nodes) {
    const roots = /* @__PURE__ */ new Set([
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document
    ]);
    for (const node of nodes){
        if (!node) continue;
        for (const root of (0, $c7bc2cb7e2db0227$export$9f54ef76df6accb2)(node))roots.add(root);
    }
    return Array.from(roots);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $29fd27cb9bdab9d2$var$NARROW_ROOT_HEIGHT_THRESHOLD = 50;
const $29fd27cb9bdab9d2$var$NARROW_ROOT_WIDTH_THRESHOLD = 350;
const $29fd27cb9bdab9d2$var$BadgeBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)();
/**
* A helper that enables the badge feature in the editor and renders a custom view next to the bottom of the editable element
* (editor root, source editing area, etc.) when the editor is focused.
*
* @private
*/ var $29fd27cb9bdab9d2$export$37acb3580601e69a = class extends $29fd27cb9bdab9d2$var$BadgeBase {
    /**
	* Editor instance the helper was created for.
	*/ editor;
    /**
	* A reference to the balloon panel hosting and positioning the badge content.
	*/ _balloonView = null;
    /**
	* A throttled version of the {@link #_showBalloon} method meant for frequent use to avoid performance loss.
	*/ _showBalloonThrottled = (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(()=>this._showBalloon(), 50, {
        leading: true
    });
    /**
	* A reference to the last editable element (root, source editing area, etc.) focused by the user.
	* Since the focus can move to other focusable elements in the UI, this reference allows positioning the balloon over the
	* right element whether the user is typing or using the UI.
	*/ _lastFocusedEditableElement = null;
    /**
	* An additional CSS class added to the `BalloonView`.
	*/ _balloonClass;
    /**
	* Creates a badge for a given editor. The feature is initialized on Editor#ready
	* event.
	*/ constructor(editor, options = {}){
        super();
        this.editor = editor;
        this._balloonClass = options.balloonClass;
        editor.on("ready", ()=>this._handleEditorReady());
    }
    /**
	* Destroys the badge along with its view.
	*/ destroy() {
        const balloon = this._balloonView;
        if (balloon) {
            balloon.unpin();
            this._balloonView = null;
        }
        this._showBalloonThrottled.cancel();
        this.stopListening();
    }
    /**
	* Enables badge label once the editor (ui) is ready.
	*/ _handleEditorReady() {
        const editor = this.editor;
        if (!this._isEnabled()) return;
        if (!editor.ui.view) return;
        editor.ui.focusTracker.on("change:isFocused", (evt, data, isFocused)=>{
            this._updateLastFocusedEditableElement();
            if (isFocused) this._showBalloon();
            else this._hideBalloon();
        });
        editor.ui.focusTracker.on("change:focusedElement", (evt, data, focusedElement)=>{
            this._updateLastFocusedEditableElement();
            if (focusedElement) this._showBalloon();
        });
        editor.ui.on("update", ()=>{
            this._showBalloonThrottled();
        });
    }
    /**
	* Returns normalized configuration for the badge.
	*/ _getNormalizedConfig() {
        return {
            side: this.editor.locale.contentLanguageDirection === "ltr" ? "right" : "left",
            position: "border",
            verticalOffset: 0,
            horizontalOffset: 5
        };
    }
    /**
	* Attempts to display the balloon with the badge view.
	*/ _showBalloon() {
        const attachOptions = this._getBalloonAttachOptions();
        if (!attachOptions) return;
        if (!this._balloonView) this._balloonView = this._createBalloonView();
        this._balloonView.pin(attachOptions);
    }
    /**
	* Hides the badge balloon if already visible.
	*/ _hideBalloon() {
        if (this._balloonView) this._balloonView.unpin();
    }
    /**
	* Creates an instance of the {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView balloon panel}
	* with the badge view inside ready for positioning.
	*/ _createBalloonView() {
        const editor = this.editor;
        const balloon = new $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c();
        const view = this._createBadgeContent();
        balloon.content.add(view);
        if (this._balloonClass) balloon.class = this._balloonClass;
        editor.ui.view.body.add(balloon);
        return balloon;
    }
    /**
	* Returns the options for attaching the balloon to the focused editable element.
	*/ _getBalloonAttachOptions() {
        if (!this._lastFocusedEditableElement) return null;
        const badgeConfig = this._getNormalizedConfig();
        const positioningFunction = badgeConfig.side === "right" ? $29fd27cb9bdab9d2$var$getLowerRightCornerPosition(this._lastFocusedEditableElement, badgeConfig) : $29fd27cb9bdab9d2$var$getLowerLeftCornerPosition(this._lastFocusedEditableElement, badgeConfig);
        return {
            target: this._lastFocusedEditableElement,
            positions: [
                positioningFunction
            ]
        };
    }
    /**
	* Updates the {@link #_lastFocusedEditableElement} based on the state of the global focus tracker.
	*/ _updateLastFocusedEditableElement() {
        const editor = this.editor;
        const isFocused = editor.ui.focusTracker.isFocused;
        const focusedElement = editor.ui.focusTracker.focusedElement;
        if (!isFocused || !focusedElement) {
            this._lastFocusedEditableElement = null;
            return;
        }
        const editableEditorElements = Array.from(editor.ui.getEditableElementsNames()).map((name)=>{
            return editor.ui.getEditableElement(name);
        });
        if (editableEditorElements.includes(focusedElement)) this._lastFocusedEditableElement = focusedElement;
        else this._lastFocusedEditableElement = editableEditorElements[0];
    }
};
function $29fd27cb9bdab9d2$var$getLowerRightCornerPosition(focusedEditableElement, config) {
    return $29fd27cb9bdab9d2$var$getLowerCornerPosition(focusedEditableElement, config, (rootRect, balloonRect)=>{
        return rootRect.left + rootRect.width - balloonRect.width - config.horizontalOffset;
    });
}
function $29fd27cb9bdab9d2$var$getLowerLeftCornerPosition(focusedEditableElement, config) {
    return $29fd27cb9bdab9d2$var$getLowerCornerPosition(focusedEditableElement, config, (rootRect)=>rootRect.left + config.horizontalOffset);
}
function $29fd27cb9bdab9d2$var$getLowerCornerPosition(focusedEditableElement, config, getBalloonLeft) {
    return (visibleEditableElementRect, balloonRect)=>{
        const editableElementRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(focusedEditableElement);
        if (editableElementRect.width < $29fd27cb9bdab9d2$var$NARROW_ROOT_WIDTH_THRESHOLD || editableElementRect.height < $29fd27cb9bdab9d2$var$NARROW_ROOT_HEIGHT_THRESHOLD) return null;
        let balloonTop;
        if (config.position === "inside") balloonTop = editableElementRect.bottom - balloonRect.height;
        else balloonTop = editableElementRect.bottom - balloonRect.height / 2;
        balloonTop -= config.verticalOffset;
        const balloonLeft = getBalloonLeft(editableElementRect, balloonRect);
        const newBalloonPositionVisibleRect = visibleEditableElementRect.clone().moveTo(balloonLeft, balloonTop).getIntersection(balloonRect.clone().moveTo(balloonLeft, balloonTop)).getVisible();
        if (!newBalloonPositionVisibleRect || newBalloonPositionVisibleRect.getArea() < balloonRect.getArea()) return null;
        return {
            top: balloonTop,
            left: balloonLeft,
            name: `position_${config.position}-side_${config.side}`,
            config: {
                withArrow: false
            }
        };
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/poweredby
*/ const $29fd27cb9bdab9d2$var$DEFAULT_LABEL = "Powered by";
/**
* A helper that enables the "powered by" feature in the editor and renders a link to the project's
* webpage next to the bottom of the editable element (editor root, source editing area, etc.) when the editor is focused.
*
* @private
*/ var $29fd27cb9bdab9d2$export$3dbb5766eaeb5b24 = class extends $29fd27cb9bdab9d2$export$37acb3580601e69a {
    constructor(editor){
        super(editor, {
            balloonClass: "ck-powered-by-balloon"
        });
    }
    /**
	* Enables "powered by" label.
	*/ _isEnabled() {
        const editor = this.editor;
        if (editor.config.get("ui.poweredBy.forceVisible")) return true;
        const licenseKey = editor.config.get("licenseKey");
        if (licenseKey == "GPL") return true;
        const licenseContent = (0, $c7bc2cb7e2db0227$export$6d464faaef141d67)(licenseKey.split(".")[1]);
        if (!licenseContent) return true;
        return !licenseContent.whiteLabel;
    }
    /**
	* Creates a "powered by" badge content.
	*/ _createBadgeContent() {
        return new $29fd27cb9bdab9d2$var$PoweredByView(this.editor.locale, this._getNormalizedConfig().label);
    }
    /**
	* Returns the normalized configuration for the "powered by" badge.
	* It takes the user configuration into account and falls back to the default one.
	*/ _getNormalizedConfig() {
        const badgeConfig = super._getNormalizedConfig();
        const userConfig = this.editor.config.get("ui.poweredBy") || {};
        const position = userConfig.position || badgeConfig.position;
        const verticalOffset = position === "inside" ? 5 : badgeConfig.verticalOffset;
        return {
            position: position,
            side: userConfig.side || badgeConfig.side,
            label: userConfig.label === void 0 ? $29fd27cb9bdab9d2$var$DEFAULT_LABEL : userConfig.label,
            verticalOffset: userConfig.verticalOffset !== void 0 ? userConfig.verticalOffset : verticalOffset,
            horizontalOffset: userConfig.horizontalOffset !== void 0 ? userConfig.horizontalOffset : badgeConfig.horizontalOffset,
            forceVisible: !!userConfig.forceVisible
        };
    }
};
/**
* A view displaying a "powered by" label and project logo wrapped in a link.
*/ var $29fd27cb9bdab9d2$var$PoweredByView = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Creates an instance of the "powered by" view.
	*
	* @param locale The localization services instance.
	* @param label The label text.
	*/ constructor(locale, label){
        super(locale);
        const iconView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        const bind = this.bindTemplate;
        iconView.set({
            content: (0, $e8dc502aba5ac3f5$export$c90ae6cb81bd21fc),
            isColorInherited: false
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-powered-by"
                ],
                "aria-hidden": true
            },
            children: [
                {
                    tag: "a",
                    attributes: {
                        href: "https://ckeditor.com/powered-by-ckeditor/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
                        target: "_blank",
                        tabindex: "-1"
                    },
                    children: [
                        ...label ? [
                            {
                                tag: "span",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-powered-by__label"
                                    ]
                                },
                                children: [
                                    label
                                ]
                            }
                        ] : [],
                        iconView
                    ],
                    on: {
                        dragstart: bind.to((evt)=>evt.preventDefault())
                    }
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/button/switchbuttonview
*/ /**
* The switch button view class.
*
* ```ts
* const view = new SwitchButtonView();
*
* view.set( {
* 	withText: true,
* 	label: 'Switch me!'
* } );
*
* view.render();
*
* document.body.append( view.element );
* ```
*/ var $29fd27cb9bdab9d2$export$bb3c559d00882ebd = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    /**
	* The toggle switch of the button.
	*/ toggleSwitchView;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.isToggleable = true;
        this.toggleSwitchView = this._createToggleView();
        this.extendTemplate({
            attributes: {
                class: "ck-switchbutton"
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.toggleSwitchView);
    }
    /**
	* Creates a toggle child view.
	*/ _createToggleView() {
        const toggleSwitchView = new $29fd27cb9bdab9d2$export$27a5bd065ad55220();
        toggleSwitchView.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-button__toggle"
                ]
            },
            children: [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck",
                            "ck-button__toggle__inner"
                        ]
                    }
                }
            ]
        });
        return toggleSwitchView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/tabs/tabbuttonview
*/ /**
* The available positions of the tabs (and their buttons) within a tabs view.
*/ const $29fd27cb9bdab9d2$export$f9d41acc09942247 = [
    "top",
    "left",
    "right"
];
/**
* A button that toggles the visibility of a tab in a tabs view component.
*/ var $29fd27cb9bdab9d2$export$86c4b67f4af02ef6 = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    /**
	* @inheritDoc
	*/ constructor(locale, options = {}){
        super(locale);
        this.isToggleable = true;
        this.set("side", options.side || "top");
        const bind = this.bindTemplate;
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-tab-button",
                    ...(0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.class || []),
                    bind.to("side", (side)=>`ck-tab-button_${side}`),
                    bind.to("class")
                ]
            }
        });
    }
    /**
	* Shows the tab button.
	*/ show() {
        this.set("isVisible", true);
    }
    /**
	* Hides the tab button.
	*/ hide() {
        this.set("isVisible", false);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/tabs/tabpanelview
*/ /**
* A panel that contains the content of a tab in a tabs view component.
*/ var $29fd27cb9bdab9d2$export$470b42f56d238ad1 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of child views.
	*/ children;
    /**
	* @inheritDoc
	*/ constructor(locale, options = {}){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isVisible", false);
        this.set("class", "");
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-tab-panel",
                    ...(0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.class || []),
                    bind.to("class"),
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            },
            children: this.children
        });
    }
    /**
	* Shows the panel.
	*/ show() {
        this.set("isVisible", true);
    }
    /**
	* Hides the panel.
	*/ hide() {
        this.set("isVisible", false);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/button/filedialogbuttonview
*/ const $29fd27cb9bdab9d2$var$FileDialogButtonViewMixinBase = /* #__PURE__ */ $29fd27cb9bdab9d2$export$d2d552b51a576ce0($29fd27cb9bdab9d2$export$4ca10aae50aa7bfa);
const $29fd27cb9bdab9d2$var$FileDialogListItemButtonViewMixinBase = /* #__PURE__ */ $29fd27cb9bdab9d2$export$d2d552b51a576ce0($29fd27cb9bdab9d2$export$244268489b08fe2c);
/**
* The file dialog button view.
*
* This component provides a button that opens the native file selection dialog.
* It can be used to implement the UI of a file upload feature.
*
* ```ts
* const view = new FileDialogButtonView( locale );
*
* view.set( {
* 	acceptedType: 'image/*',
* 	allowMultipleFiles: true
* 	label: t( 'Insert image' ),
* 	icon: imageIcon,
* 	tooltip: true
* } );
*
* view.on( 'done', ( evt, files ) => {
* 	for ( const file of Array.from( files ) ) {
* 		console.log( 'Selected file', file );
* 	}
* } );
* ```
*/ var $29fd27cb9bdab9d2$export$82dd186dd0e8fed2 = class extends $29fd27cb9bdab9d2$var$FileDialogButtonViewMixinBase {
};
/**
* The file dialog button view used in a lists.
*
* This component provides a button that opens the native file selection dialog.
* It can be used to implement the UI of a file upload feature.
*
* ```ts
* const view = new FileDialogListItemButtonView( locale );
*
* view.set( {
* 	acceptedType: 'image/*',
* 	allowMultipleFiles: true
* 	label: t( 'Insert image' ),
* 	icon: imageIcon,
* 	tooltip: true
* } );
*
* view.on( 'done', ( evt, files ) => {
* 	for ( const file of Array.from( files ) ) {
* 		console.log( 'Selected file', file );
* 	}
* } );
* ```
*/ var $29fd27cb9bdab9d2$export$628f00df25efb6ab = class extends $29fd27cb9bdab9d2$var$FileDialogListItemButtonViewMixinBase {
};
/**
* Mixin function that enhances a base button view class with file dialog functionality. It is used
* to create a button view class that opens the native select file dialog when clicked.
*
* The enhanced view includes a button and a hidden file input. When the button is clicked, the file dialog is opened.
* The mixin adds properties and methods to the base class to handle the file selection.
*
* @param view The base class to be enhanced with file dialog functionality.
* @returns A new class that extends the base class and includes the file dialog functionality.
*/ function $29fd27cb9bdab9d2$export$d2d552b51a576ce0(view) {
    class FileDialogView extends view {
        /**
		* A hidden `<input>` view used to execute file dialog.
		*/ _fileInputView;
        /**
		* @inheritDoc
		*/ constructor(...args){
            super(...args);
            this._fileInputView = new $29fd27cb9bdab9d2$var$FileInputView(this.locale);
            this._fileInputView.bind("acceptedType").to(this);
            this._fileInputView.bind("allowMultipleFiles").to(this);
            this._fileInputView.delegate("done").to(this);
            this.on("execute", ()=>{
                this._fileInputView.open();
            });
            this.extendTemplate({
                attributes: {
                    class: "ck-file-dialog-button"
                }
            });
        }
        /**
		* @inheritDoc
		*/ render() {
            super.render();
            this.children.add(this._fileInputView);
        }
    }
    return FileDialogView;
}
/**
* The hidden file input view class.
*/ var $29fd27cb9bdab9d2$var$FileInputView = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.set("acceptedType", void 0);
        this.set("allowMultipleFiles", false);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "input",
            attributes: {
                class: [
                    "ck-hidden"
                ],
                type: "file",
                tabindex: "-1",
                accept: bind.to("acceptedType"),
                multiple: bind.to("allowMultipleFiles")
            },
            on: {
                change: bind.to(/* v8 ignore next -- @preserve */ ()=>{
                    if (this.element?.files?.length) this.fire("done", this.element.files);
                    this.element.value = "";
                })
            }
        });
    }
    /**
	* Opens file dialog.
	*/ open() {
        this.element.click();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/collapsible/collapsibleview
*/ /**
* A collapsible UI component. Consists of a labeled button and a container which can be collapsed
* by clicking the button. The collapsible container can be a host to other UI views.
*
* @internal
*/ var $29fd27cb9bdab9d2$export$8a82f5df0c7d8945 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* The main button that, when clicked, collapses or expands the container with {@link #children}.
	*/ buttonView;
    /**
	* A collection of the child views that can be collapsed by clicking the {@link #buttonView}.
	*/ children;
    /**
	* Creates an instance of the collapsible view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param childViews An optional array of initial child views to be inserted into the collapsible.
	*/ constructor(locale, childViews){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isCollapsed", false);
        this.set("label", "");
        this.buttonView = this._createButtonView();
        this.children = this.createCollection();
        this.set("_collapsibleAriaLabelUid", void 0);
        if (childViews) this.children.addMany(childViews);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-collapsible",
                    bind.if("isCollapsed", "ck-collapsible_collapsed")
                ]
            },
            children: [
                this.buttonView,
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-collapsible__children"
                        ],
                        role: "region",
                        hidden: bind.if("isCollapsed", "hidden"),
                        "aria-labelledby": bind.to("_collapsibleAriaLabelUid")
                    },
                    children: this.children
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
    }
    /**
	* Focuses the first focusable.
	*/ focus() {
        this.buttonView.focus();
    }
    /**
	* Creates the main {@link #buttonView} of the collapsible.
	*/ _createButtonView() {
        const buttonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(this.locale);
        const bind = buttonView.bindTemplate;
        buttonView.set({
            withText: true,
            icon: (0, $e8dc502aba5ac3f5$export$48d0dd33d947d151)
        });
        buttonView.extendTemplate({
            attributes: {
                "aria-expanded": bind.to("isOn", (value)=>String(value))
            }
        });
        buttonView.bind("label").to(this);
        buttonView.bind("isOn").to(this, "isCollapsed", (isCollapsed)=>!isCollapsed);
        buttonView.on("execute", ()=>{
            this.isCollapsed = !this.isCollapsed;
        });
        return buttonView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $29fd27cb9bdab9d2$var$SHADED_LABEL_REGEXP = /^(.+) (\d+)$/;
/**
* Returns color configuration options as defined in `editor.config.(fontColor|fontBackgroundColor).colors` or
* `editor.config.table.(tableProperties|tableCellProperties).(background|border).colors
* but processed to account for editor localization in the correct language.
*
* Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
* when the user configuration is defined because the editor does not exist yet.
*
* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
*/ function $29fd27cb9bdab9d2$export$8609308dd8d581de(locale, options) {
    const localizedColorNames = $29fd27cb9bdab9d2$var$getLocalizedColorNames(locale);
    return options.map((colorOption)=>{
        colorOption.label = $29fd27cb9bdab9d2$var$localizeColorName(colorOption.label, localizedColorNames);
        return colorOption;
    });
}
/**
* Returns the localized name of a color, as displayed next to a color tile or in a suggestion description.
*
* Labels of shaded palettes follow the `<hue> <shade>` pattern, for instance `Blue grey 700`. Such a label is
* translated hue by hue, so a palette built of shades does not need a dictionary entry for every shade. A label
* whose hue is unknown is returned unchanged.
*
* @internal
* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
* @param label The color label to translate.
*/ function $29fd27cb9bdab9d2$export$55dab20d5a1fa672(locale, label) {
    return $29fd27cb9bdab9d2$var$localizeColorName(label, $29fd27cb9bdab9d2$var$getLocalizedColorNames(locale));
}
/**
* Returns the dictionary of translated color names, keyed by their English names.
*/ function $29fd27cb9bdab9d2$var$getLocalizedColorNames(locale) {
    const t = locale.t;
    return {
        Black: t("Black"),
        "Dim grey": t("Dim grey"),
        Grey: t("Grey"),
        "Light grey": t("Light grey"),
        White: t("White"),
        Red: t("Red"),
        Orange: t("Orange"),
        Yellow: t("Yellow"),
        "Light green": t("Light green"),
        Green: t("Green"),
        Aquamarine: t("Aquamarine"),
        Turquoise: t("Turquoise"),
        "Light blue": t("Light blue"),
        Blue: t("Blue"),
        Purple: t("Purple"),
        Indigo: t("Indigo"),
        Cyan: t("Cyan"),
        Teal: t("Teal"),
        Lime: t("Lime"),
        Amber: t("Amber"),
        "Blue grey": t("Blue grey")
    };
}
/**
* Translates a single color label against an already built dictionary.
*/ function $29fd27cb9bdab9d2$var$localizeColorName(label, localizedColorNames) {
    const shadeMatch = label.match($29fd27cb9bdab9d2$var$SHADED_LABEL_REGEXP);
    const hue = shadeMatch ? shadeMatch[1] : label;
    const localizedHue = Object.hasOwn(localizedColorNames, hue) ? localizedColorNames[hue] : void 0;
    if (!localizedHue) return label;
    return shadeMatch ? `${localizedHue} ${shadeMatch[2]}` : localizedHue;
}
/**
* Creates a unified color definition object from color configuration options.
* The object contains the information necessary to both render the UI and initialize the conversion.
*/ function $29fd27cb9bdab9d2$export$ee5a86b42a248fe4(options) {
    return options.map($29fd27cb9bdab9d2$export$549270605bc8f800).filter((option)=>!!option);
}
/**
* Creates a normalized color definition from the user-defined configuration.
* The "normalization" means it will create full
* {@link module:ui/colorgrid/colorgridview~ColorDefinition `ColorDefinition-like`}
* object for string values, and add a `view` property, for each definition.
*/ function $29fd27cb9bdab9d2$export$549270605bc8f800(color) {
    if (typeof color === "string") return {
        model: color,
        label: color,
        hasBorder: false,
        view: {
            name: "span",
            styles: {
                color: color
            }
        }
    };
    else return {
        model: color.color,
        label: color.label || color.color,
        hasBorder: color.hasBorder === void 0 ? false : color.hasBorder,
        view: {
            name: "span",
            styles: {
                color: `${color.color}`
            }
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorgrid/colortileview
*/ /**
* This class represents a single color tile in the {@link module:ui/colorgrid/colorgridview~ColorGridView}.
*/ var $29fd27cb9bdab9d2$export$bc9cd5ed02964426 = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("color", void 0);
        this.set("hasBorder", false);
        this.icon = (0, $e8dc502aba5ac3f5$export$79e493651ed727fa);
        this.extendTemplate({
            attributes: {
                style: {
                    backgroundColor: bind.to("color", (color)=>(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isMediaForcedColors ? null : color)
                },
                class: [
                    "ck",
                    "ck-color-grid__tile",
                    bind.if("hasBorder", "ck-color-selector__color-tile_bordered")
                ]
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.iconView.fillColor = "hsl(0, 0%, 100%)";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The default color palette shared by every feature that displays a color grid: the font color,
* the font background color, and the border and background colors of tables and table cells.
*
* It holds 12 hues in 10 shades each, from `50` to `900`, and fills a 12-column grid. Every row is one
* shade and every column is one hue. The last column is a grey scale from white to black, matching the
* lightness of each row.
*
* Shaded labels follow the `<hue> <shade>` pattern. {@link module:ui/colorgrid/utils~getLocalizedColorOptions}
* translates the hue and keeps the shade number.
*
* @internal
*/ const $29fd27cb9bdab9d2$export$fdf79bef57893a8d = [
    {
        label: "Red 50",
        color: "hsl(351, 100%, 96%)"
    },
    {
        label: "Purple 50",
        color: "hsl(292, 44%, 93%)"
    },
    {
        label: "Indigo 50",
        color: "hsl(231, 44%, 94%)"
    },
    {
        label: "Blue 50",
        color: "hsl(205, 87%, 94%)"
    },
    {
        label: "Cyan 50",
        color: "hsl(187, 72%, 93%)"
    },
    {
        label: "Teal 50",
        color: "hsl(177, 41%, 91%)"
    },
    {
        label: "Light green 50",
        color: "hsl(88, 52%, 94%)"
    },
    {
        label: "Lime 50",
        color: "hsl(66, 71%, 95%)"
    },
    {
        label: "Amber 50",
        color: "hsl(46, 100%, 94%)"
    },
    {
        label: "Orange 50",
        color: "hsl(37, 100%, 94%)"
    },
    {
        label: "Blue grey 50",
        color: "hsl(204, 15%, 94%)"
    },
    {
        label: "White",
        color: "hsl(0, 0%, 100%)",
        hasBorder: true
    },
    {
        label: "Red 100",
        color: "hsl(354, 100%, 90%)"
    },
    {
        label: "Purple 100",
        color: "hsl(291, 46%, 83%)"
    },
    {
        label: "Indigo 100",
        color: "hsl(232, 45%, 84%)"
    },
    {
        label: "Blue 100",
        color: "hsl(207, 89%, 86%)"
    },
    {
        label: "Cyan 100",
        color: "hsl(187, 71%, 82%)"
    },
    {
        label: "Teal 100",
        color: "hsl(175, 41%, 79%)"
    },
    {
        label: "Light green 100",
        color: "hsl(88, 51%, 86%)"
    },
    {
        label: "Lime 100",
        color: "hsl(65, 69%, 86%)"
    },
    {
        label: "Amber 100",
        color: "hsl(45, 100%, 85%)"
    },
    {
        label: "Orange 100",
        color: "hsl(36, 100%, 85%)"
    },
    {
        label: "Blue grey 100",
        color: "hsl(199, 16%, 84%)"
    },
    {
        label: "Grey 100",
        color: "hsl(0, 0%, 96%)"
    },
    {
        label: "Red 200",
        color: "hsl(0, 73%, 77%)"
    },
    {
        label: "Purple 200",
        color: "hsl(291, 47%, 71%)"
    },
    {
        label: "Indigo 200",
        color: "hsl(231, 44%, 74%)"
    },
    {
        label: "Blue 200",
        color: "hsl(207, 90%, 77%)"
    },
    {
        label: "Cyan 200",
        color: "hsl(187, 72%, 71%)"
    },
    {
        label: "Teal 200",
        color: "hsl(174, 42%, 65%)"
    },
    {
        label: "Light green 200",
        color: "hsl(88, 50%, 77%)"
    },
    {
        label: "Lime 200",
        color: "hsl(66, 71%, 77%)"
    },
    {
        label: "Amber 200",
        color: "hsl(45, 100%, 76%)"
    },
    {
        label: "Orange 200",
        color: "hsl(36, 100%, 75%)"
    },
    {
        label: "Blue grey 200",
        color: "hsl(200, 15%, 73%)"
    },
    {
        label: "Grey 200",
        color: "hsl(0, 0%, 93%)"
    },
    {
        label: "Red 300",
        color: "hsl(0, 69%, 68%)"
    },
    {
        label: "Purple 300",
        color: "hsl(291, 47%, 60%)"
    },
    {
        label: "Indigo 300",
        color: "hsl(231, 44%, 64%)"
    },
    {
        label: "Blue 300",
        color: "hsl(207, 89%, 68%)"
    },
    {
        label: "Cyan 300",
        color: "hsl(187, 71%, 59%)"
    },
    {
        label: "Teal 300",
        color: "hsl(174, 42%, 51%)"
    },
    {
        label: "Light green 300",
        color: "hsl(88, 50%, 67%)"
    },
    {
        label: "Lime 300",
        color: "hsl(66, 70%, 68%)"
    },
    {
        label: "Amber 300",
        color: "hsl(46, 100%, 66%)"
    },
    {
        label: "Orange 300",
        color: "hsl(36, 100%, 65%)"
    },
    {
        label: "Blue grey 300",
        color: "hsl(200, 16%, 62%)"
    },
    {
        label: "Grey 300",
        color: "hsl(0, 0%, 88%)"
    },
    {
        label: "Red 400",
        color: "hsl(1, 83%, 63%)"
    },
    {
        label: "Purple 400",
        color: "hsl(291, 47%, 51%)"
    },
    {
        label: "Indigo 400",
        color: "hsl(231, 44%, 56%)"
    },
    {
        label: "Blue 400",
        color: "hsl(207, 90%, 61%)"
    },
    {
        label: "Cyan 400",
        color: "hsl(187, 71%, 50%)"
    },
    {
        label: "Teal 400",
        color: "hsl(174, 63%, 40%)"
    },
    {
        label: "Light green 400",
        color: "hsl(88, 50%, 60%)"
    },
    {
        label: "Lime 400",
        color: "hsl(66, 70%, 61%)"
    },
    {
        label: "Amber 400",
        color: "hsl(45, 100%, 58%)"
    },
    {
        label: "Orange 400",
        color: "hsl(36, 100%, 58%)"
    },
    {
        label: "Blue grey 400",
        color: "hsl(200, 15%, 54%)"
    },
    {
        label: "Grey 400",
        color: "hsl(0, 0%, 74%)"
    },
    {
        label: "Red 500",
        color: "hsl(4, 90%, 58%)"
    },
    {
        label: "Purple 500",
        color: "hsl(291, 64%, 42%)"
    },
    {
        label: "Indigo 500",
        color: "hsl(231, 48%, 48%)"
    },
    {
        label: "Blue 500",
        color: "hsl(207, 90%, 54%)"
    },
    {
        label: "Cyan 500",
        color: "hsl(187, 100%, 42%)"
    },
    {
        label: "Teal 500",
        color: "hsl(174, 100%, 29%)"
    },
    {
        label: "Light green 500",
        color: "hsl(88, 50%, 53%)"
    },
    {
        label: "Lime 500",
        color: "hsl(66, 70%, 54%)"
    },
    {
        label: "Amber 500",
        color: "hsl(45, 100%, 51%)"
    },
    {
        label: "Orange 500",
        color: "hsl(36, 100%, 50%)"
    },
    {
        label: "Blue grey 500",
        color: "hsl(200, 18%, 46%)"
    },
    {
        label: "Grey 500",
        color: "hsl(0, 0%, 62%)"
    },
    {
        label: "Red 600",
        color: "hsl(1, 77%, 55%)"
    },
    {
        label: "Purple 600",
        color: "hsl(288, 65%, 40%)"
    },
    {
        label: "Indigo 600",
        color: "hsl(232, 50%, 45%)"
    },
    {
        label: "Blue 600",
        color: "hsl(208, 79%, 51%)"
    },
    {
        label: "Cyan 600",
        color: "hsl(187, 100%, 38%)"
    },
    {
        label: "Teal 600",
        color: "hsl(174, 100%, 27%)"
    },
    {
        label: "Light green 600",
        color: "hsl(89, 46%, 48%)"
    },
    {
        label: "Lime 600",
        color: "hsl(64, 60%, 50%)"
    },
    {
        label: "Amber 600",
        color: "hsl(42, 100%, 50%)"
    },
    {
        label: "Orange 600",
        color: "hsl(34, 100%, 49%)"
    },
    {
        label: "Blue grey 600",
        color: "hsl(199, 18%, 40%)"
    },
    {
        label: "Grey 600",
        color: "hsl(0, 0%, 46%)"
    },
    {
        label: "Red 700",
        color: "hsl(0, 65%, 51%)"
    },
    {
        label: "Purple 700",
        color: "hsl(282, 68%, 38%)"
    },
    {
        label: "Indigo 700",
        color: "hsl(232, 54%, 41%)"
    },
    {
        label: "Blue 700",
        color: "hsl(210, 79%, 46%)"
    },
    {
        label: "Cyan 700",
        color: "hsl(186, 100%, 33%)"
    },
    {
        label: "Teal 700",
        color: "hsl(173, 100%, 24%)"
    },
    {
        label: "Light green 700",
        color: "hsl(92, 48%, 42%)"
    },
    {
        label: "Lime 700",
        color: "hsl(62, 61%, 44%)"
    },
    {
        label: "Amber 700",
        color: "hsl(38, 100%, 50%)"
    },
    {
        label: "Orange 700",
        color: "hsl(30, 100%, 48%)"
    },
    {
        label: "Blue grey 700",
        color: "hsl(199, 18%, 33%)"
    },
    {
        label: "Grey 700",
        color: "hsl(0, 0%, 38%)"
    },
    {
        label: "Red 800",
        color: "hsl(0, 66%, 47%)"
    },
    {
        label: "Purple 800",
        color: "hsl(277, 70%, 36%)"
    },
    {
        label: "Indigo 800",
        color: "hsl(233, 57%, 37%)"
    },
    {
        label: "Blue 800",
        color: "hsl(212, 80%, 42%)"
    },
    {
        label: "Cyan 800",
        color: "hsl(185, 100%, 28%)"
    },
    {
        label: "Teal 800",
        color: "hsl(173, 100%, 21%)"
    },
    {
        label: "Light green 800",
        color: "hsl(95, 50%, 37%)"
    },
    {
        label: "Lime 800",
        color: "hsl(60, 63%, 38%)"
    },
    {
        label: "Amber 800",
        color: "hsl(34, 100%, 50%)"
    },
    {
        label: "Orange 800",
        color: "hsl(27, 100%, 47%)"
    },
    {
        label: "Blue grey 800",
        color: "hsl(200, 18%, 26%)"
    },
    {
        label: "Grey 800",
        color: "hsl(0, 0%, 26%)"
    },
    {
        label: "Red 900",
        color: "hsl(0, 74%, 41%)"
    },
    {
        label: "Purple 900",
        color: "hsl(267, 75%, 31%)"
    },
    {
        label: "Indigo 900",
        color: "hsl(235, 66%, 30%)"
    },
    {
        label: "Blue 900",
        color: "hsl(217, 85%, 34%)"
    },
    {
        label: "Cyan 900",
        color: "hsl(182, 100%, 20%)"
    },
    {
        label: "Teal 900",
        color: "hsl(170, 100%, 15%)"
    },
    {
        label: "Light green 900",
        color: "hsl(103, 56%, 27%)"
    },
    {
        label: "Lime 900",
        color: "hsl(54, 70%, 30%)"
    },
    {
        label: "Amber 900",
        color: "hsl(26, 100%, 50%)"
    },
    {
        label: "Orange 900",
        color: "hsl(21, 100%, 45%)"
    },
    {
        label: "Blue grey 900",
        color: "hsl(200, 19%, 18%)"
    },
    {
        label: "Black",
        color: "hsl(0, 0%, 0%)"
    }
];
/**
* The number of columns in the {@link module:ui/colorgrid/colors~defaultColors default color palette}.
*
* @internal
*/ const $29fd27cb9bdab9d2$export$d573929527255e12 = 12;
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorgrid/colorgridview
*/ /**
* A grid of {@link module:ui/colorgrid/colortileview~ColorTileView color tiles}.
*/ var $29fd27cb9bdab9d2$export$bc40329c0ccad25a = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A number of columns for the tiles grid.
	*/ columns;
    /**
	* Collection of the child tile views.
	*/ items;
    /**
	* Tracks information about DOM focus in the grid.
	*/ focusTracker;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Creates an instance of a color grid containing {@link module:ui/colorgrid/colortileview~ColorTileView tiles}.
	*
	* @fires execute
	* @param locale The localization services instance.
	* @param options Component configuration
	* @param options.colorDefinitions Array with definitions
	* required to create the {@link module:ui/colorgrid/colortileview~ColorTileView tiles}.
	* @param options.columns A number of columns to display the tiles.
	*/ constructor(locale, options){
        super(locale);
        const colorDefinitions = options && options.colorDefinitions ? options.colorDefinitions : [];
        this.columns = options?.columns || 12;
        const viewStyleAttribute = {
            gridTemplateColumns: `repeat( ${this.columns}, 1fr)`
        };
        this.set("selectedColor", void 0);
        this.items = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.items.on("add", (evt, colorTile)=>{
            colorTile.isOn = colorTile.color === this.selectedColor;
        });
        colorDefinitions.forEach((color)=>{
            const colorTile = new $29fd27cb9bdab9d2$export$bc9cd5ed02964426();
            colorTile.set({
                color: color.color,
                label: color.label,
                tooltip: true,
                hasBorder: color.options.hasBorder
            });
            colorTile.on("execute", ()=>{
                this.fire("execute", {
                    value: color.color,
                    hasBorder: color.options.hasBorder,
                    label: color.label
                });
            });
            this.items.add(colorTile);
        });
        this.setTemplate({
            tag: "div",
            children: this.items,
            attributes: {
                class: [
                    "ck",
                    "ck-color-grid"
                ],
                style: viewStyleAttribute
            }
        });
        this.on("change:selectedColor", (evt, name, selectedColor)=>{
            for (const item of this.items)item.isOn = item.color === selectedColor;
        });
    }
    /**
	* Focuses the first focusable in {@link #items}.
	*/ focus() {
        if (this.items.length) this.items.first.focus();
    }
    /**
	* Focuses the last focusable in {@link #items}.
	*/ focusLast() {
        if (this.items.length) this.items.last.focus();
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        for (const item of this.items)this.focusTracker.add(item.element);
        this.items.on("add", (evt, item)=>{
            this.focusTracker.add(item.element);
        });
        this.items.on("remove", (evt, item)=>{
            this.focusTracker.remove(item.element);
        });
        this.keystrokes.listenTo(this.element);
        $29fd27cb9bdab9d2$export$4c1942d3074fe5f4({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.items,
            numberOfColumns: this.columns,
            uiLanguageDirection: this.locale?.uiLanguageDirection
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorpicker/utils
*/ /**
* Parses and converts the color string to requested format. Handles variety of color spaces
* like `hsl`, `hex` or `rgb`.
*
* @param color
* @returns A color string.
* @internal
*/ function $29fd27cb9bdab9d2$export$8c7ab99396521a55(color, outputFormat) {
    if (!color) return "";
    const colorObject = $29fd27cb9bdab9d2$var$parseColorString(color);
    if (!colorObject) return "";
    if (colorObject.space === outputFormat) return color;
    if (!$29fd27cb9bdab9d2$var$canConvertParsedColor(colorObject)) return "";
    const toColorSpace = (0, $5d8c9af4dc0cc118$export$2e2bcd8739ae039)[colorObject.space][outputFormat];
    if (!toColorSpace) return "";
    return $29fd27cb9bdab9d2$var$formatColorOutput(toColorSpace(colorObject.space === "hex" ? colorObject.hexValue : colorObject.values), outputFormat);
}
/**
* Converts a color string to hex format.
*
* @param color
* @returns A color string.
* @internal
*/ function $29fd27cb9bdab9d2$export$39c36f794e3b729b(color) {
    if (!color) return "";
    const colorObject = $29fd27cb9bdab9d2$var$parseColorString(color);
    if (!colorObject) return "#000";
    if (colorObject.space === "hex") return colorObject.hexValue;
    return $29fd27cb9bdab9d2$export$8c7ab99396521a55(color, "hex");
}
/**
* Registers the custom element in the
* [CustomElementsRegistry](https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry).
* @internal
*/ function $29fd27cb9bdab9d2$export$4c31d2a68e32baf8(elementName, constructor) {
    if (customElements.get(elementName) === void 0) customElements.define(elementName, constructor);
}
/**
* Formats the passed color channels according to the requested format.
*
* @param values
* @param format
* @returns A color string.
*/ function $29fd27cb9bdab9d2$var$formatColorOutput(values, format) {
    switch(format){
        case "hex":
            return `#${values}`;
        case "rgb":
            return `rgb(${values[0]}, ${values[1]}, ${values[2]})`;
        case "hsl":
            return `hsl(${values[0]}, ${values[1]}%, ${values[2]}%)`;
        case "hwb":
            return `hwb(${values[0]}, ${values[1]}, ${values[2]})`;
        case "lab":
            return `lab(${values[0]}% ${values[1]} ${values[2]})`;
        case "lch":
            return `lch(${values[0]}% ${values[1]} ${values[2]})`;
        default:
            return "";
    }
}
function $29fd27cb9bdab9d2$var$parseColorString(colorString) {
    if (colorString.startsWith("#")) {
        const parsedHex = (0, $7709f00c9a7c855e$export$2e2bcd8739ae039)(colorString);
        return {
            space: "hex",
            values: parsedHex.values,
            hexValue: colorString,
            alpha: parsedHex.alpha
        };
    }
    const parsed = (0, $7709f00c9a7c855e$export$2e2bcd8739ae039)(colorString);
    if (!parsed.space) return null;
    return parsed;
}
function $29fd27cb9bdab9d2$var$canConvertParsedColor(parsedColor) {
    return Object.keys((0, $5d8c9af4dc0cc118$export$2e2bcd8739ae039)).includes(parsedColor.space);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/labeledfield/labeledfieldview
*/ /**
* The labeled field view class. It can be used to enhance any view with the following features:
*
* * a label,
* * (optional) an error message,
* * (optional) an info (status) text,
*
* all bound logically by proper DOM attributes for UX and accessibility.  It also provides an interface
* (e.g. observable properties) that allows controlling those additional features.
*
* The constructor of this class requires a callback that returns a view to be labeled. The callback
* is called with unique ids that allow binding of DOM properties:
*
* ```ts
* const labeledInputView = new LabeledFieldView( locale, ( labeledFieldView, viewUid, statusUid ) => {
* 	const inputView = new InputTextView( labeledFieldView.locale );
*
* 	inputView.set( {
* 		id: viewUid,
* 		ariaDescribedById: statusUid
* 	} );
*
* 	inputView.bind( 'isReadOnly' ).to( labeledFieldView, 'isEnabled', value => !value );
* 	inputView.bind( 'hasError' ).to( labeledFieldView, 'errorText', value => !!value );
*
* 	return inputView;
* } );
*
* labeledInputView.label = 'User name';
* labeledInputView.infoText = 'Full name like for instance, John Doe.';
* labeledInputView.render();
*
* document.body.append( labeledInputView.element );
* ```
*
* See {@link module:ui/labeledfield/utils} to discover ready–to–use labeled input helpers for common
* UI components.
*/ var $29fd27cb9bdab9d2$export$698fc40b8eb40673 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* The field view that gets labeled.
	*/ fieldView;
    /**
	* The label view instance that describes the entire view.
	*/ labelView;
    /**
	* The status view for the {@link #fieldView}. It displays {@link #errorText} and
	* {@link #infoText}.
	*/ statusView;
    /**
	* A collection of children of the internal wrapper element. Allows inserting additional DOM elements (views) next to
	* the {@link #fieldView} for easy styling (e.g. positioning).
	*
	* By default, the collection contains {@link #fieldView} and {@link #labelView}.
	*/ fieldWrapperChildren;
    /**
	* Creates an instance of the labeled field view class using a provided creator function
	* that provides the view to be labeled.
	*
	* @param locale The locale instance.
	* @param viewCreator A function that returns a {@link module:ui/view~View}
	* that will be labeled. The following arguments are passed to the creator function:
	*
	* * an instance of the `LabeledFieldView` to allow binding observable properties,
	* * an UID string that connects the {@link #labelView label} and the labeled field view in DOM,
	* * an UID string that connects the {@link #statusView status} and the labeled field view in DOM.
	*/ constructor(locale, viewCreator){
        super(locale);
        const viewUid = `ck-labeled-field-view-${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        const statusUid = `ck-labeled-field-view-status-${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        this.fieldView = viewCreator(this, viewUid, statusUid);
        this.set("label", void 0);
        this.set("isEnabled", true);
        this.set("isEmpty", true);
        this.set("isFocused", false);
        this.set("errorText", null);
        this.set("infoText", null);
        this.set("class", void 0);
        this.set("placeholder", void 0);
        this.labelView = this._createLabelView(viewUid);
        this.statusView = this._createStatusView(statusUid);
        this.fieldWrapperChildren = this.createCollection([
            this.fieldView,
            this.labelView
        ]);
        this.bind("_statusText").to(this, "errorText", this, "infoText", (errorText, infoText)=>errorText || infoText);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-labeled-field-view",
                    bind.to("class"),
                    bind.if("isEnabled", "ck-disabled", (value)=>!value),
                    bind.if("isEmpty", "ck-labeled-field-view_empty"),
                    bind.if("isFocused", "ck-labeled-field-view_focused"),
                    bind.if("placeholder", "ck-labeled-field-view_placeholder"),
                    bind.if("errorText", "ck-error")
                ]
            },
            children: [
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-labeled-field-view__input-wrapper"
                        ]
                    },
                    children: this.fieldWrapperChildren
                },
                this.statusView
            ]
        });
    }
    /**
	* Creates label view class instance and bind with view.
	*
	* @param id Unique id to set as labelView#for attribute.
	*/ _createLabelView(id) {
        const labelView = new $29fd27cb9bdab9d2$export$84062398251b1ba(this.locale);
        labelView.for = id;
        labelView.bind("text").to(this, "label");
        return labelView;
    }
    /**
	* Creates the status view instance. It displays {@link #errorText} and {@link #infoText}
	* next to the {@link #fieldView}. See {@link #_statusText}.
	*
	* @param statusUid Unique id of the status, shared with the {@link #fieldView view's}
	* `aria-describedby` attribute.
	*/ _createStatusView(statusUid) {
        const statusView = new $29fd27cb9bdab9d2$export$27a5bd065ad55220(this.locale);
        const bind = this.bindTemplate;
        statusView.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-labeled-field-view__status",
                    bind.if("errorText", "ck-labeled-field-view__status_error"),
                    bind.if("_statusText", "ck-hidden", (value)=>!value)
                ],
                id: statusUid,
                role: bind.if("errorText", "alert")
            },
            children: [
                {
                    text: bind.to("_statusText")
                }
            ]
        });
        return statusView;
    }
    /**
	* Focuses the {@link #fieldView}.
	*/ focus(direction) {
        this.fieldView.focus(direction);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/input/inputbase
*/ /**
* The base input view class.
*/ var $29fd27cb9bdab9d2$export$36eab7f492831059 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Stores information about the editor UI focus and propagates it so various plugins and components
	* are unified as a focus group.
	*/ focusTracker;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.set("value", void 0);
        this.set("id", void 0);
        this.set("placeholder", void 0);
        this.set("tabIndex", void 0);
        this.set("isReadOnly", false);
        this.set("hasError", false);
        this.set("ariaDescribedById", void 0);
        this.set("ariaLabel", void 0);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.bind("isFocused").to(this.focusTracker);
        this.set("isEmpty", true);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "input",
            attributes: {
                class: [
                    "ck",
                    "ck-input",
                    bind.if("isFocused", "ck-input_focused"),
                    bind.if("isEmpty", "ck-input-text_empty"),
                    bind.if("hasError", "ck-error")
                ],
                id: bind.to("id"),
                placeholder: bind.to("placeholder"),
                tabindex: bind.to("tabIndex"),
                readonly: bind.to("isReadOnly"),
                "aria-invalid": bind.if("hasError", true),
                "aria-describedby": bind.to("ariaDescribedById"),
                "aria-label": bind.to("ariaLabel")
            },
            on: {
                input: bind.to((...args)=>{
                    this.fire("input", ...args);
                    this._updateIsEmpty();
                }),
                change: bind.to(this._updateIsEmpty.bind(this))
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.element);
        this._setDomElementValue(this.value);
        this._updateIsEmpty();
        this.on("change:value", (evt, name, value)=>{
            this._setDomElementValue(value);
            this._updateIsEmpty();
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
    }
    /**
	* Moves the focus to the input and selects the value.
	*/ select() {
        this.element.select();
    }
    /**
	* Focuses the input.
	*/ focus() {
        this.element.focus();
    }
    /**
	* Resets the value of the input
	*/ reset() {
        this.value = this.element.value = "";
        this._updateIsEmpty();
    }
    /**
	* Updates the {@link #isEmpty} property value on demand.
	*/ _updateIsEmpty() {
        this.isEmpty = $29fd27cb9bdab9d2$var$isInputElementEmpty(this.element);
    }
    /**
	* Sets the `value` property of the {@link #element DOM element} on demand.
	*/ _setDomElementValue(value) {
        this.element.value = !value && value !== 0 ? "" : value;
    }
};
function $29fd27cb9bdab9d2$var$isInputElementEmpty(domElement) {
    return !domElement.value;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The input view class.
*/ var $29fd27cb9bdab9d2$export$d046d2870d3b0a10 = class extends $29fd27cb9bdab9d2$export$36eab7f492831059 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.set("inputMode", "text");
        const bind = this.bindTemplate;
        this.extendTemplate({
            attributes: {
                inputmode: bind.to("inputMode")
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/inputtext/inputtextview
*/ /**
* The text input view class.
*/ var $29fd27cb9bdab9d2$export$75906a940df4ae45 = class extends $29fd27cb9bdab9d2$export$d046d2870d3b0a10 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.extendTemplate({
            attributes: {
                type: "text",
                class: [
                    "ck-input-text"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/inputnumber/inputnumberview
*/ /**
* The number input view class.
*/ var $29fd27cb9bdab9d2$export$4585c26baacfcbc7 = class extends $29fd27cb9bdab9d2$export$d046d2870d3b0a10 {
    /**
	* Creates an instance of the input number view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param options The options of the input.
	* @param options.min The value of the `min` DOM attribute (the lowest accepted value).
	* @param options.max The value of the `max` DOM attribute (the highest accepted value).
	* @param options.step The value of the `step` DOM attribute.
	*/ constructor(locale, { min: min, max: max, step: step } = {}){
        super(locale);
        const bind = this.bindTemplate;
        this.set("min", min);
        this.set("max", max);
        this.set("step", step);
        this.extendTemplate({
            attributes: {
                type: "number",
                class: [
                    "ck-input-number"
                ],
                min: bind.to("min"),
                max: bind.to("max"),
                step: bind.to("step")
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/textarea/textareaview
*/ /**
* The textarea view class.
*
* ```ts
* const textareaView = new TextareaView();
*
* textareaView.minRows = 2;
* textareaView.maxRows = 10;
*
* textareaView.render();
*
* document.body.append( textareaView.element );
* ```
*/ var $29fd27cb9bdab9d2$export$a04d12bdcfdada6d = class extends $29fd27cb9bdab9d2$export$36eab7f492831059 {
    /**
	* An instance of the resize observer used to detect when the view is visible or not and update
	* its height if any changes that affect it were made while it was invisible.
	*
	* **Note:** Created in {@link #render}.
	*/ _resizeObserver;
    /**
	* A flag that indicates whether the {@link #_updateAutoGrowHeight} method should be called when the view becomes
	* visible again. See {@link #_resizeObserver}.
	*/ _isUpdateAutoGrowHeightPending = false;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const toPx = (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
        this.set("minRows", 2);
        this.set("maxRows", 5);
        this.set("_height", null);
        this.set("resize", "none");
        this._resizeObserver = null;
        this.on("change:minRows", this._validateMinMaxRows.bind(this));
        this.on("change:maxRows", this._validateMinMaxRows.bind(this));
        const bind = this.bindTemplate;
        this.template.tag = "textarea";
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-textarea"
                ],
                style: {
                    height: bind.to("_height", (height)=>height ? toPx(height) : null),
                    resize: bind.to("resize")
                },
                rows: bind.to("minRows")
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        let wasVisible = false;
        this.on("input", ()=>{
            this._updateAutoGrowHeight(true);
            this.fire("update");
        });
        this.on("change:value", ()=>this._updateAutoGrowHeightWhenVisible());
        this.on("change:placeholder", ()=>this._updateAutoGrowHeightWhenVisible());
        this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(this.element, (evt)=>{
            const isVisible = !!evt.contentRect.width && !!evt.contentRect.height;
            if (!wasVisible && isVisible && this._isUpdateAutoGrowHeightPending) (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.requestAnimationFrame(()=>{
                this._updateAutoGrowHeight();
                this.fire("update");
            });
            wasVisible = isVisible;
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        if (this._resizeObserver) this._resizeObserver.destroy();
    }
    /**
	* @inheritDoc
	*/ reset() {
        super.reset();
        this._updateAutoGrowHeight();
        this.fire("update");
    }
    /**
	* Updates the {@link #_height} of the view once the DOM element reflects the change that triggered the update.
	* If the view is not visible at that moment, the update is deferred until it becomes visible again
	* (see {@link #_resizeObserver}).
	*/ _updateAutoGrowHeightWhenVisible() {
        (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.requestAnimationFrame(()=>{
            if (!(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(this.element)) {
                this._isUpdateAutoGrowHeightPending = true;
                return;
            }
            this._updateAutoGrowHeight();
            this.fire("update");
        });
    }
    /**
	* Updates the {@link #_height} of the view depending on {@link #minRows}, {@link #maxRows}, and the current content size.
	*
	* **Note**: This method overrides manual resize done by the user using a handle. It's a known bug.
	*/ _updateAutoGrowHeight(shouldScroll) {
        const viewElement = this.element;
        if (!viewElement.offsetParent) {
            this._isUpdateAutoGrowHeightPending = true;
            return;
        }
        this._isUpdateAutoGrowHeightPending = false;
        const singleLineContentClone = $29fd27cb9bdab9d2$var$getTextareaElementClone(viewElement, "1");
        const fullTextValueClone = $29fd27cb9bdab9d2$var$getTextareaElementClone(viewElement, viewElement.value);
        const singleLineContentStyles = singleLineContentClone.ownerDocument.defaultView.getComputedStyle(singleLineContentClone);
        const verticalPaddings = parseFloat(singleLineContentStyles.paddingTop) + parseFloat(singleLineContentStyles.paddingBottom);
        const borders = (0, $c7bc2cb7e2db0227$export$c134363f1f37644f)(singleLineContentClone);
        const lineHeight = parseFloat(singleLineContentStyles.lineHeight);
        const verticalBorder = borders.top + borders.bottom;
        const singleLineAreaDefaultHeight = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(singleLineContentClone).height;
        const numberOfLines = Math.round((fullTextValueClone.scrollHeight - verticalPaddings) / lineHeight);
        const maxHeight = this.maxRows * lineHeight + verticalPaddings + verticalBorder;
        const minHeight = numberOfLines === 1 ? singleLineAreaDefaultHeight : this.minRows * lineHeight + verticalPaddings + verticalBorder;
        this._height = Math.min(Math.max(Math.max(numberOfLines, this.minRows) * lineHeight + verticalPaddings + verticalBorder, minHeight), maxHeight);
        if (shouldScroll) viewElement.scrollTop = viewElement.scrollHeight;
        singleLineContentClone.remove();
        fullTextValueClone.remove();
    }
    /**
	* Validates the {@link #minRows} and {@link #maxRows} properties and warns in the console if the configuration is incorrect.
	*/ _validateMinMaxRows() {
        if (this.minRows > this.maxRows) /**
		* The minimum number of rows is greater than the maximum number of rows.
		*
		* @error ui-textarea-view-min-rows-greater-than-max-rows
		* @param {module:ui/textarea/textareaview~TextareaView} textareaView The misconfigured textarea view instance.
		* @param {number} minRows The value of `minRows` property.
		* @param {number} maxRows The value of `maxRows` property.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ui-textarea-view-min-rows-greater-than-max-rows", {
            textareaView: this,
            minRows: this.minRows,
            maxRows: this.maxRows
        });
    }
};
function $29fd27cb9bdab9d2$var$getTextareaElementClone(element, value) {
    const clone = element.cloneNode();
    clone.style.position = "absolute";
    clone.style.top = "-99999px";
    clone.style.left = "-99999px";
    clone.style.height = "auto";
    clone.style.overflow = "hidden";
    clone.style.width = element.ownerDocument.defaultView.getComputedStyle(element).width;
    clone.tabIndex = -1;
    clone.rows = 1;
    clone.value = value;
    (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(element).insertBefore(clone, element);
    return clone;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/dropdownpanelview
*/ /**
* The dropdown panel view class.
*
* See {@link module:ui/dropdown/dropdownview~DropdownView} to learn about the common usage.
*/ var $29fd27cb9bdab9d2$export$4c88ab3d80d9f838 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views in this panel.
	*
	* A common child type is the {@link module:ui/list/listview~ListView} and {@link module:ui/toolbar/toolbarview~ToolbarView}.
	* See {@link module:ui/dropdown/utils~addListToDropdown} and
	* {@link module:ui/dropdown/utils~addToolbarToDropdown} to learn more about child views of dropdowns.
	*/ children;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isVisible", false);
        this.set("position", "se");
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-reset",
                    "ck-dropdown__panel",
                    bind.to("position", (value)=>`ck-dropdown__panel_${value}`),
                    bind.if("isVisible", "ck-dropdown__panel-visible")
                ],
                tabindex: "-1"
            },
            children: this.children,
            on: {
                selectstart: bind.to((evt)=>{
                    const target = evt.target;
                    if (target instanceof Element && target.tagName.toLocaleLowerCase() === "input") return;
                    evt.preventDefault();
                })
            }
        });
    }
    /**
	* Focuses the first view in the {@link #children} collection.
	*
	* See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
	*/ focus() {
        if (this.children.length) {
            const firstChild = this.children.first;
            if (typeof firstChild.focus === "function") firstChild.focus();
            else /**
			* The child view of a dropdown could not be focused because it is missing the `focus()` method.
			*
			* This warning appears when a dropdown {@link module:ui/dropdown/dropdownview~DropdownView#isOpen gets open} and it
			* attempts to focus the {@link module:ui/dropdown/dropdownpanelview~DropdownPanelView#children first child} of its panel
			* but the child does not implement the
			* {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable focusable interface}.
			*
			* Focusing the content of a dropdown on open greatly improves the accessibility. Please make sure the view instance
			* provides the `focus()` method for the best user experience.
			*
			* @error ui-dropdown-panel-focus-child-missing-focus
			* @param {module:ui/view~View} childView Child view.
			* @param {module:ui/dropdown/dropdownpanelview~DropdownPanelView} dropdownPanel A parent of a child.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("ui-dropdown-panel-focus-child-missing-focus", {
                childView: this.children.first,
                dropdownPanel: this
            });
        }
    }
    /**
	* Focuses the view element or last item in view collection on opening dropdown's panel.
	*
	* See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
	*/ focusLast() {
        if (this.children.length) {
            const lastChild = this.children.last;
            if (typeof lastChild.focusLast === "function") lastChild.focusLast();
            else lastChild.focus();
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/dropdownview
*/ /**
* The dropdown view class. It manages the dropdown button and dropdown panel.
*
* In most cases, the easiest way to create a dropdown is by using the {@link module:ui/dropdown/utils~createDropdown}
* util:
*
* ```ts
* const dropdown = createDropdown( locale );
*
* // Configure dropdown's button properties:
* dropdown.buttonView.set( {
* 	label: 'A dropdown',
* 	withText: true
* } );
*
* dropdown.render();
*
* dropdown.panelView.element.textContent = 'Content of the panel';
*
* // Will render a dropdown with a panel containing a "Content of the panel" text.
* document.body.appendChild( dropdown.element );
* ```
*
* If you want to add a richer content to the dropdown panel, you can use the {@link module:ui/dropdown/utils~addListToDropdown}
* and {@link module:ui/dropdown/utils~addToolbarToDropdown} helpers. See more examples in
* {@link module:ui/dropdown/utils~createDropdown} documentation.
*
* If you want to create a completely custom dropdown, then you can compose it manually:
*
* ```ts
* const button = new DropdownButtonView( locale );
* const panel = new DropdownPanelView( locale );
* const dropdown = new DropdownView( locale, button, panel );
*
* button.set( {
* 	label: 'A dropdown',
* 	withText: true
* } );
*
* dropdown.render();
*
* panel.element.textContent = 'Content of the panel';
*
* // Will render a dropdown with a panel containing a "Content of the panel" text.
* document.body.appendChild( dropdown.element );
* ```
*
* However, dropdown created this way will contain little behavior. You will need to implement handlers for actions
* such as {@link module:ui/bindings/clickoutsidehandler~clickOutsideHandler clicking outside an open dropdown}
* (which should close it) and support for arrow keys inside the panel. Therefore, unless you really know what
* you do and you really need to do it, it is recommended to use the {@link module:ui/dropdown/utils~createDropdown} helper.
*/ var $29fd27cb9bdab9d2$export$30eba291eb702857 = class DropdownView extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Button of the dropdown view. Clicking the button opens the {@link #panelView}.
	*/ buttonView;
    /**
	* Panel of the dropdown. It opens when the {@link #buttonView} is
	* {@link module:ui/button/button~Button#event:execute executed} (i.e. clicked).
	*
	* Child views can be added to the panel's `children` collection:
	*
	* ```ts
	* dropdown.panelView.children.add( childView );
	* ```
	*
	* See {@link module:ui/dropdown/dropdownpanelview~DropdownPanelView#children} and
	* {@link module:ui/viewcollection~ViewCollection#add}.
	*/ panelView;
    /**
	* Tracks information about the DOM focus in the dropdown.
	*/ focusTracker;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
	* keystrokes of the dropdown:
	*
	* * <kbd>▼</kbd> opens the dropdown,
	* * <kbd>◀</kbd> and <kbd>Esc</kbd> closes the dropdown.
	*/ keystrokes;
    /**
	* A child {@link module:ui/list/listview~ListView list view} of the dropdown located
	* in its {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
	*
	* **Note**: Only supported when dropdown has list view added using {@link module:ui/dropdown/utils~addListToDropdown}.
	*/ listView;
    /**
	* A child toolbar of the dropdown located in the
	* {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
	*
	* **Note**: Only supported when dropdown has a toolbar added using {@link module:ui/dropdown/utils~addToolbarToDropdown}.
	*/ toolbarView;
    /**
	* A child menu component of the dropdown located
	* in its {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
	*
	* **Note**: Only supported when dropdown has a menu added using {@link module:ui/dropdown/utils~addMenuToDropdown}.
	*/ menuView;
    /**
	* An optional limiter used when {@link #panelPosition} is `'auto'`.
	*
	* By default, the `'auto'` position is only checked against the browser viewport, so a dropdown
	* nested in a scrollable ancestor (e.g. a sidebar list) may pick a position that fits the window
	* but is actually clipped by, or forces extra scrolling in, that ancestor. Set this to the
	* scrollable ancestor (or a callback returning it) to have the optimal position calculation take
	* its visible bounds into account too.
	*
	* @default null
	*/ panelPositionLimiter = null;
    /**
	* Creates an instance of the dropdown.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	*/ constructor(locale, buttonView, panelView){
        super(locale);
        const bind = this.bindTemplate;
        this.buttonView = buttonView;
        this.panelView = panelView;
        this.set("isOpen", false);
        this.set("isEnabled", true);
        this.set("class", void 0);
        this.set("id", void 0);
        this.set("panelPosition", "auto");
        this.panelView.bind("isVisible").to(this, "isOpen");
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-dropdown",
                    bind.to("class"),
                    bind.if("isEnabled", "ck-disabled", (value)=>!value)
                ],
                id: bind.to("id"),
                "aria-describedby": bind.to("ariaDescribedById")
            },
            children: [
                buttonView,
                panelView
            ]
        });
        buttonView.extendTemplate({
            attributes: {
                class: [
                    "ck-dropdown__button"
                ],
                "data-cke-tooltip-disabled": bind.to("isOpen")
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.buttonView.element);
        this.focusTracker.add(this.panelView.element);
        this.listenTo(this.buttonView, "open", ()=>{
            this.isOpen = !this.isOpen;
        });
        this.on("change:isOpen", (evt, name, isOpen)=>{
            if (!isOpen) return;
            if (this.panelPosition === "auto") {
                const limiter = typeof this.panelPositionLimiter === "function" ? this.panelPositionLimiter() : this.panelPositionLimiter;
                const optimalPanelPosition = DropdownView._getOptimalPosition({
                    element: this.panelView.element,
                    target: this.buttonView.element,
                    fitInViewport: true,
                    positions: this._panelPositions,
                    ...limiter ? {
                        limiter: limiter
                    } : {}
                });
                this.panelView.position = optimalPanelPosition ? optimalPanelPosition.name : this._defaultPanelPositionName;
            } else this.panelView.position = this.panelPosition;
        });
        this.keystrokes.listenTo(this.element);
        const closeDropdown = (data, cancel)=>{
            if (this.isOpen) {
                this.isOpen = false;
                cancel();
            }
        };
        this.keystrokes.set("arrowdown", (data, cancel)=>{
            if (this.buttonView.isEnabled && !this.isOpen) {
                this.isOpen = true;
                cancel();
            }
        });
        this.keystrokes.set("arrowright", (data, cancel)=>{
            if (this.isOpen) cancel();
        });
        this.keystrokes.set("arrowleft", closeDropdown);
        this.keystrokes.set("esc", closeDropdown);
    }
    /**
	* Focuses the {@link #buttonView}.
	*/ focus() {
        this.buttonView.focus();
    }
    /**
	* Returns {@link #panelView panel} positions to be used by the
	* {@link module:utils/dom/position~getOptimalPosition `getOptimalPosition()`}
	* utility considering the direction of the language the UI of the editor is displayed in.
	*/ get _panelPositions() {
        const { south: south, north: north, southEast: southEast, southWest: southWest, northEast: northEast, northWest: northWest, southMiddleEast: southMiddleEast, southMiddleWest: southMiddleWest, northMiddleEast: northMiddleEast, northMiddleWest: northMiddleWest } = DropdownView.defaultPanelPositions;
        if (this.locale.uiLanguageDirection !== "rtl") return [
            southEast,
            southWest,
            southMiddleEast,
            southMiddleWest,
            south,
            northEast,
            northWest,
            northMiddleEast,
            northMiddleWest,
            north
        ];
        else return [
            southWest,
            southEast,
            southMiddleWest,
            southMiddleEast,
            south,
            northWest,
            northEast,
            northMiddleWest,
            northMiddleEast,
            north
        ];
    }
    /**
	* Returns the default position of the dropdown panel based on the direction of the UI language.
	* It is used when the {@link #panelPosition} is set to `'auto'` and the panel has not found a
	* suitable position to fit into the viewport.
	*/ get _defaultPanelPositionName() {
        return this.locale.uiLanguageDirection === "rtl" ? "sw" : "se";
    }
    /**
	* A set of positioning functions used by the dropdown view to determine
	* the optimal position (i.e. fitting into the browser viewport) of its
	* {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel} when
	* {@link module:ui/dropdown/dropdownview~DropdownView#panelPosition} is set to 'auto'`.
	*
	* The available positioning functions are as follow:
	*
	* **South**
	*
	* * `south`
	*
	* ```
	*			[ Button ]
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	* ```
	*
	* * `southEast`
	*
	* ```
	*		[ Button ]
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	* ```
	*
	* * `southWest`
	*
	* ```
	*		         [ Button ]
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	* ```
	*
	* * `southMiddleEast`
	*
	* ```
	*		  [ Button ]
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	* ```
	*
	* * `southMiddleWest`
	*
	* ```
	*		       [ Button ]
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	* ```
	*
	* **North**
	*
	* * `north`
	*
	* ```
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	*		    [ Button ]
	* ```
	*
	* * `northEast`
	*
	* ```
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	*		[ Button ]
	* ```
	*
	* * `northWest`
	*
	* ```
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	*		         [ Button ]
	* ```
	*
	* * `northMiddleEast`
	*
	* ```
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	*		  [ Button ]
	* ```
	*
	* * `northMiddleWest`
	*
	* ```
	*		+-----------------+
	*		|      Panel      |
	*		+-----------------+
	*		       [ Button ]
	* ```
	*
	* Positioning functions are compatible with {@link module:utils/dom/position~DomPoint}.
	*
	* The name that position function returns will be reflected in dropdown panel's class that
	* controls its placement. See {@link module:ui/dropdown/dropdownview~DropdownView#panelPosition}
	* to learn more.
	*/ static defaultPanelPositions = {
        south: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.bottom,
                left: buttonRect.left - (panelRect.width - buttonRect.width) / 2,
                name: "s"
            };
        },
        southEast: (buttonRect)=>{
            return {
                top: buttonRect.bottom,
                left: buttonRect.left,
                name: "se"
            };
        },
        southWest: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.bottom,
                left: buttonRect.left - panelRect.width + buttonRect.width,
                name: "sw"
            };
        },
        southMiddleEast: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.bottom,
                left: buttonRect.left - (panelRect.width - buttonRect.width) / 4,
                name: "sme"
            };
        },
        southMiddleWest: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.bottom,
                left: buttonRect.left - (panelRect.width - buttonRect.width) * 3 / 4,
                name: "smw"
            };
        },
        north: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.top - panelRect.height,
                left: buttonRect.left - (panelRect.width - buttonRect.width) / 2,
                name: "n"
            };
        },
        northEast: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.top - panelRect.height,
                left: buttonRect.left,
                name: "ne"
            };
        },
        northWest: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.top - panelRect.height,
                left: buttonRect.left - panelRect.width + buttonRect.width,
                name: "nw"
            };
        },
        northMiddleEast: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.top - panelRect.height,
                left: buttonRect.left - (panelRect.width - buttonRect.width) / 4,
                name: "nme"
            };
        },
        northMiddleWest: (buttonRect, panelRect)=>{
            return {
                top: buttonRect.top - panelRect.height,
                left: buttonRect.left - (panelRect.width - buttonRect.width) * 3 / 4,
                name: "nmw"
            };
        }
    };
    /**
	* A function used to calculate the optimal position for the dropdown panel.
	*/ static _getOptimalPosition = (0, $c7bc2cb7e2db0227$export$75cda5409326f127);
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/button/dropdownbuttonview
*/ /**
* The default dropdown button view class.
*
* ```ts
* const view = new DropdownButtonView();
*
* view.set( {
* 	label: 'A button',
* 	keystroke: 'Ctrl+B',
* 	tooltip: true
* } );
*
* view.render();
*
* document.body.append( view.element );
* ```
*
* Also see the {@link module:ui/dropdown/utils~createDropdown `createDropdown()` util}.
*/ var $29fd27cb9bdab9d2$export$78bc6c5c028686b7 = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    /**
	* An icon that displays arrow to indicate a dropdown button.
	*/ arrowView;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.arrowView = this._createArrowView();
        this.extendTemplate({
            attributes: {
                "aria-haspopup": true,
                "aria-expanded": this.bindTemplate.to("isOn", (value)=>String(value))
            }
        });
        this.delegate("execute").to(this, "open");
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.arrowView);
    }
    /**
	* Creates a {@link module:ui/icon/iconview~IconView} instance as {@link #arrowView}.
	*/ _createArrowView() {
        const arrowView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        arrowView.content = (0, $e8dc502aba5ac3f5$export$48d0dd33d947d151);
        arrowView.extendTemplate({
            attributes: {
                class: "ck-dropdown__arrow"
            }
        });
        return arrowView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Represents a view for a button in a dropdown menu list item.
*/ var $29fd27cb9bdab9d2$export$3b5b82dd5acc6985 = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    id;
    constructor(locale, id, label){
        super(locale);
        this.id = id;
        this.set({
            withText: true,
            withKeystroke: true,
            tooltip: false,
            role: "menuitem",
            label: label
        });
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-dropdown-menu-list__nested-menu__item__button"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/menu/dropdownmenubuttonview
*/ /**
* Represents a view for a dropdown menu button.
*/ var $29fd27cb9bdab9d2$export$a1e7b79e8c242e5b = class extends $29fd27cb9bdab9d2$export$244268489b08fe2c {
    /**
	* An icon that displays an arrow to indicate a direction of the menu.
	*/ arrowView;
    /**
	* Creates an instance of the dropdown menu button view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set({
            withText: true,
            role: "menuitem"
        });
        this.arrowView = this._createArrowView();
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-dropdown-menu-list__nested-menu__button"
                ],
                "aria-haspopup": true,
                "aria-expanded": this.bindTemplate.to("isOn", (value)=>String(value)),
                "data-cke-tooltip-disabled": bind.to("isOn")
            },
            on: {
                "mouseenter": bind.to("mouseenter")
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.arrowView);
    }
    /**
	* Creates the arrow view instance.
	*
	* @private
	*/ _createArrowView() {
        const arrowView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        arrowView.content = (0, $e8dc502aba5ac3f5$export$48d0dd33d947d151);
        arrowView.extendTemplate({
            attributes: {
                class: "ck-dropdown-menu-list__nested-menu__button__arrow"
            }
        });
        return arrowView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/list/listitemview
*/ /**
* The list item view class.
*/ var $29fd27cb9bdab9d2$export$41fd379e664153d8 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views inside of the list item {@link #element}.
	*/ children;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isVisible", true);
        this.children = this.createCollection();
        this.setTemplate({
            tag: "li",
            attributes: {
                class: [
                    "ck",
                    "ck-list__item",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ],
                role: "presentation"
            },
            children: this.children
        });
    }
    /**
	* Focuses the list item.
	*/ focus() {
        if (this.children.first) this.children.first.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/list/listseparatorview
*/ /**
* The list separator view class.
*/ var $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.setTemplate({
            tag: "li",
            attributes: {
                class: [
                    "ck",
                    "ck-list__separator"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/list/listitemgroupview
*/ /**
* The list item group view class.
*/ var $29fd27cb9bdab9d2$export$8480567bf3181a7c = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Label of the group view. Its text is configurable using the {@link #label label attribute}.
	*
	* If a custom label view is not passed in `ListItemGroupView` constructor, the label is an instance
	* of {@link module:ui/label/labelview~LabelView}.
	*/ labelView;
    /**
	* Collection of the child list items inside this group.
	*/ items;
    /**
	* Collection of the child elements of the group.
	*/ children;
    /**
	* Creates an instance of the list item group view class.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param labelView The instance of the group's label. If not provided, an instance of
	* {@link module:ui/label/labelview~LabelView} is used.
	*/ constructor(locale, labelView = new $29fd27cb9bdab9d2$export$84062398251b1ba()){
        super(locale);
        const bind = this.bindTemplate;
        const nestedList = new $29fd27cb9bdab9d2$export$84d0dd190d551cd1(locale);
        this.set({
            label: "",
            isVisible: true
        });
        this.labelView = labelView;
        this.labelView.bind("text").to(this, "label");
        this.children = this.createCollection();
        this.children.addMany([
            this.labelView,
            nestedList
        ]);
        nestedList.set({
            role: "group",
            ariaLabelledBy: labelView.id
        });
        nestedList.focusTracker.destroy();
        nestedList.keystrokes.destroy();
        this.items = nestedList.items;
        this.setTemplate({
            tag: "li",
            attributes: {
                role: "presentation",
                class: [
                    "ck",
                    "ck-list__group",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            },
            children: this.children
        });
    }
    /**
	* Focuses the list item (which is not a separator).
	*/ focus() {
        /* v8 ignore else -- @preserve */ if (this.items) {
            const firstListItem = this.items.find((item)=>!(item instanceof $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0));
            if (firstListItem) firstListItem.focus();
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/list/listview
*/ /**
* The list view class.
*/ var $29fd27cb9bdab9d2$export$84d0dd190d551cd1 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* The collection of focusable views in the list. It is used to determine accessible navigation
	* between the {@link module:ui/list/listitemview~ListItemView list items} and
	* {@link module:ui/list/listitemgroupview~ListItemGroupView list groups}.
	*/ focusables;
    /**
	* Collection of the child list views.
	*/ items;
    /**
	* Tracks information about DOM focus in the list.
	*/ focusTracker;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Helps cycling over focusable {@link #items} in the list.
	*/ _focusCycler;
    /**
	* A cached map of {@link module:ui/list/listitemgroupview~ListItemGroupView} to `change` event listeners for their `items`.
	* Used for accessibility and keyboard navigation purposes.
	*/ _listItemGroupToChangeListeners = /* @__PURE__ */ new WeakMap();
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.focusables = new $29fd27cb9bdab9d2$export$ff20b327de53fba7();
        this.items = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "arrowup",
                focusNext: "arrowdown"
            }
        });
        this.set("ariaLabel", void 0);
        this.set("ariaLabelledBy", void 0);
        this.set("role", void 0);
        this.setTemplate({
            tag: "ul",
            attributes: {
                class: [
                    "ck",
                    "ck-reset",
                    "ck-list"
                ],
                role: bind.to("role"),
                "aria-label": bind.to("ariaLabel"),
                "aria-labelledby": bind.to("ariaLabelledBy")
            },
            children: this.items
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        for (const item of this.items)if (item instanceof $29fd27cb9bdab9d2$export$8480567bf3181a7c) this._registerFocusableItemsGroup(item);
        else if (item instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8) this._registerFocusableListItem(item);
        this.items.on("change", (evt, data)=>{
            for (const removed of data.removed)if (removed instanceof $29fd27cb9bdab9d2$export$8480567bf3181a7c) this._deregisterFocusableItemsGroup(removed);
            else if (removed instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8) this._deregisterFocusableListItem(removed);
            for (const added of Array.from(data.added).reverse())if (added instanceof $29fd27cb9bdab9d2$export$8480567bf3181a7c) this._registerFocusableItemsGroup(added, data.index);
            else this._registerFocusableListItem(added, data.index);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the first focusable in {@link #items}.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the first focusable in {@link #items}.
	*/ focusFirst() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the last focusable in {@link #items}.
	*/ focusLast() {
        this._focusCycler.focusLast();
    }
    /**
	* Registers a list item view in the focus tracker.
	*
	* @param item The list item view to be registered.
	* @param index Index of the list item view in the {@link #items} collection. If not specified, the item will be added at the end.
	*/ _registerFocusableListItem(item, index) {
        this.focusTracker.add(item.element);
        this.focusables.add(item, index);
    }
    /**
	* Removes a list item view from the focus tracker.
	*
	* @param item The list item view to be removed.
	*/ _deregisterFocusableListItem(item) {
        this.focusTracker.remove(item.element);
        this.focusables.remove(item);
    }
    /**
	* Gets a callback that will be called when the `items` collection of a {@link module:ui/list/listitemgroupview~ListItemGroupView}
	* change.
	*
	* @param groupView The group view for which the callback will be created.
	* @returns The callback function to be used for the items `change` event listener in a group.
	*/ _getOnGroupItemsChangeCallback(groupView) {
        return (evt, data)=>{
            for (const removed of data.removed)this._deregisterFocusableListItem(removed);
            for (const added of Array.from(data.added).reverse())this._registerFocusableListItem(added, this.items.getIndex(groupView) + data.index);
        };
    }
    /**
	* Registers a list item group view (and its children) in the focus tracker.
	*
	* @param groupView A group view to be registered.
	* @param groupIndex Index of the group view in the {@link #items} collection. If not specified, the group will be added at the end.
	*/ _registerFocusableItemsGroup(groupView, groupIndex) {
        Array.from(groupView.items).forEach((child, childIndex)=>{
            const registeredChildIndex = typeof groupIndex !== "undefined" ? groupIndex + childIndex : void 0;
            this._registerFocusableListItem(child, registeredChildIndex);
        });
        const groupItemsChangeCallback = this._getOnGroupItemsChangeCallback(groupView);
        this._listItemGroupToChangeListeners.set(groupView, groupItemsChangeCallback);
        groupView.items.on("change", groupItemsChangeCallback);
    }
    /**
	* Removes a list item group view (and its children) from the focus tracker.
	*
	* @param groupView The group view to be removed.
	*/ _deregisterFocusableItemsGroup(groupView) {
        for (const child of groupView.items)this._deregisterFocusableListItem(child);
        groupView.items.off("change", this._listItemGroupToChangeListeners.get(groupView));
        this._listItemGroupToChangeListeners.delete(groupView);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Represents a dropdown menu list view.
*/ var $29fd27cb9bdab9d2$export$3f25934f5c78a973 = class extends $29fd27cb9bdab9d2$export$84d0dd190d551cd1 {
    /**
	* Creates an instance of the dropdown menu list view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.role = "menu";
        this.set("isVisible", true);
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-dropdown-menu-list",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET$1 = 5;
/**
* Contains every positioning function used by {@link module:ui/dropdown/menu/dropdownmenunestedmenuview~DropdownMenuNestedMenuView} that
* decides where the {@link module:ui/dropdown/menu/dropdownmenunestedmenuview~DropdownMenuNestedMenuView#panelView} should be placed.
*
* Positioning functions:
*
*	┌──────┬───────────────┐
*	│      │               │
*	└──────┤               │
*	       │               │
*	       │            ES │
*	       └───────────────┘
*
*	┌───────────────┬──────┐
*	│               │      │
*	│               ├──────┘
*	│               │
*	│ WS            │
*	└───────────────┘
*
*	       ┌───────────────┐
*	       │            EN │
*	       │               │
*	┌──────┤               │
*	│      │               │
*	└──────┴───────────────┘
*
*	┌───────────────┐
*	│ WN            │
*	│               │
*	│               ├──────┐
*	│               │      │
*	└───────────────┴──────┘
*/ const $29fd27cb9bdab9d2$export$99fd46937e4d4b71 = {
    eastSouth: (buttonRect)=>({
            top: buttonRect.top,
            left: buttonRect.right - $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET$1,
            name: "es"
        }),
    eastNorth: (buttonRect, panelRect)=>({
            top: buttonRect.top - panelRect.height + buttonRect.height,
            left: buttonRect.right - $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET$1,
            name: "en"
        }),
    westSouth: (buttonRect, panelRect)=>({
            top: buttonRect.top,
            left: buttonRect.left - panelRect.width + $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET$1,
            name: "ws"
        }),
    westNorth: (buttonRect, panelRect)=>({
            top: buttonRect.top - panelRect.height + buttonRect.height,
            left: buttonRect.left - panelRect.width + $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET$1,
            name: "wn"
        })
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Represents a view for a single item in a dropdown menu list.
*/ var $29fd27cb9bdab9d2$export$401d785a1b5ac85f = class extends $29fd27cb9bdab9d2$export$41fd379e664153d8 {
    /**
	* The view representing either a flat item or a nested menu in a dropdown menu list item.
	*/ childView;
    constructor(locale, parentMenuView, childView){
        super(locale);
        const bind = this.bindTemplate;
        this.childView = childView;
        this.children.add(childView);
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-dropdown-menu-list__nested-menu__item"
                ]
            },
            on: {
                "mouseenter": bind.to("mouseenter")
            }
        });
        if (parentMenuView) {
            this.delegate("mouseenter").to(parentMenuView);
            if (childView instanceof $29fd27cb9bdab9d2$export$3b5b82dd5acc6985) childView.delegate("execute").to(parentMenuView);
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @internal
*/ const $29fd27cb9bdab9d2$export$434c4fe25bac64c1 = {
    /**
	* Move focus to a menu item on mouse hover. If it is a button to open a nested menu, open that menu.
	*/ toggleMenusAndFocusItemsOnHover (rootList) {
        rootList.on("menu:mouseenter", (evt)=>{
            const [pathLeaf] = evt.path;
            evt.source.focus();
            for (const menuView of rootList.menus){
                const isListItemContainingMenu = pathLeaf instanceof $29fd27cb9bdab9d2$export$401d785a1b5ac85f && pathLeaf.childView === menuView;
                menuView.isOpen = (evt.path.includes(menuView) || isListItemContainingMenu) && menuView.isEnabled;
            }
        });
    },
    /**
	* Handles the following case:
	*
	* 1. Hover to open a sub-menu (A). The button has focus.
	* 2. Press arrow up/down to move focus to another sub-menu (B) button.
	* 3. Press arrow right to open the sub-menu (B).
	* 4. The sub-menu (A) should close (if not, there are two open menus).
	*/ closeMenuWhenAnotherOnTheSameLevelOpens (rootList) {
        rootList.on("menu:change:isOpen", (evt, name, isOpen)=>{
            if (!isOpen) return;
            const evtMenu = evt.source;
            for (const menuView of rootList.menus)if (evtMenu.parentMenuView === menuView.parentMenuView && evtMenu !== menuView) menuView.isOpen = false;
        });
    }
};
/**
* @internal
*/ const $29fd27cb9bdab9d2$export$c45b3e7cfab60f61 = {
    /**
	* Open the menu on the right arrow key press (left, in RTL mode). This allows for navigating to sub-menus using the keyboard.
	*/ openOnArrowRightKey (menuView) {
        const keystroke = menuView.locale.uiLanguageDirection === "rtl" ? "arrowleft" : "arrowright";
        menuView.keystrokes.set(keystroke, (data, cancel)=>{
            if (menuView.focusTracker.focusedElement !== menuView.buttonView.element || !menuView.isEnabled) return;
            if (!menuView.isOpen) menuView.isOpen = true;
            menuView.panelView.focus();
            cancel();
        });
    },
    /**
	* Opens the menu on its button click as well as enter and space keys press (if the button is focused).
	*/ openOnButtonClick (menuView) {
        menuView.buttonView.on("execute", ()=>{
            if (menuView.isEnabled) menuView.isOpen = true;
        });
    },
    /**
	* Opens the menu and focuses the panel content upon pressing the Enter key.
	*/ openAndFocusOnEnterKeyPress (menuView) {
        menuView.keystrokes.set("enter", (data, cancel)=>{
            if (menuView.focusTracker.focusedElement !== menuView.buttonView.element) return;
            menuView.isOpen = true;
            menuView.panelView.focus();
            cancel();
        });
    },
    /**
	* Closes the menu on the left key press (right, in RTL mode). This allows for navigating to sub-menus using the keyboard.
	*/ closeOnArrowLeftKey (menuView) {
        const keystroke = menuView.locale.uiLanguageDirection === "rtl" ? "arrowright" : "arrowleft";
        menuView.keystrokes.set(keystroke, (data, cancel)=>{
            if (menuView.isOpen) {
                menuView.focus();
                menuView.isOpen = false;
                cancel();
            }
        });
    },
    closeOnEscKey (menuView) {
        menuView.keystrokes.set("esc", (data, cancel)=>{
            if (menuView.isOpen) {
                menuView.focus();
                menuView.isOpen = false;
                cancel();
            }
        });
    },
    /**
	* Closes the menu when its parent menu closes. This prevents from leaving orphaned open menus.
	*/ closeOnParentClose (menuView, parentMenuView) {
        parentMenuView.on("change:isOpen", (evt, name, isOpen)=>{
            if (!isOpen && evt.source === parentMenuView) menuView.isOpen = false;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Represents the view for the dropdown menu panel.
*/ var $29fd27cb9bdab9d2$export$b7d7bcc438f5b415 = class extends $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c {
    /**
	* Creates an instance of the menu panel view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set({
            isVisible: false,
            position: "se",
            class: null,
            top: 0,
            left: 0
        });
        this.extendTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck-reset",
                    "ck-dropdown-menu__nested-menu__panel"
                ],
                tabindex: "-1"
            },
            on: {
                selectstart: bind.to((evt)=>{
                    if (evt.target.tagName.toLocaleLowerCase() === "input") return;
                    evt.preventDefault();
                })
            }
        });
    }
    /**
	* Focuses the first child of the panel (default) or the last one if the `direction` is `-1`.
	*
	* @param direction The direction to focus. Default is `1`.
	*/ focus(direction = 1) {
        const { content: content } = this;
        if (content.length) {
            if (direction === 1) content.first.focus();
            else content.last.focus();
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/menu/dropdownmenunestedmenuview
*/ /**
* Represents a nested menu view.
*/ var $29fd27cb9bdab9d2$export$25a6ff46b1292bba = class DropdownMenuNestedMenuView extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* An array of delegated events for the dropdown menu definition controller.
	* These events are delegated to the dropdown menu element.
	*/ static DELEGATED_EVENTS = [
        "mouseenter",
        "execute",
        "change:isOpen"
    ];
    id;
    /**
	* Button of the menu view.
	*/ buttonView;
    /**
	* Panel of the menu. It hosts children of the menu.
	*/ panelView;
    /**
	* List of nested menu entries.
	*/ listView;
    /**
	* Tracks information about the DOM focus in the menu.
	*/ focusTracker;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
	* keystrokes of the menu.
	*/ keystrokes;
    _bodyCollection;
    /**
	* Creates a new instance of the DropdownMenuView class.
	*
	* @param locale
	* @param bodyCollection
	* @param id
	* @param label The label for the dropdown menu button.
	* @param parentMenuView The parent dropdown menu view, if any.
	*/ constructor(locale, bodyCollection, id, label, parentMenuView){
        super(locale);
        this._bodyCollection = bodyCollection;
        this.id = id;
        this.set({
            isOpen: false,
            isEnabled: true,
            panelPosition: "w",
            class: void 0,
            parentMenuView: null
        });
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.buttonView = new $29fd27cb9bdab9d2$export$a1e7b79e8c242e5b(locale);
        this.buttonView.delegate("mouseenter").to(this);
        this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled");
        this.buttonView.label = label;
        this.panelView = new $29fd27cb9bdab9d2$export$b7d7bcc438f5b415(locale);
        this.panelView.isVisible = true;
        this.listView = new $29fd27cb9bdab9d2$export$3f25934f5c78a973(locale);
        this.listView.bind("ariaLabel").to(this.buttonView, "label");
        this.panelView.content.add(this.listView);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-dropdown-menu-list__nested-menu",
                    bind.to("class"),
                    bind.if("isEnabled", "ck-disabled", (value)=>!value)
                ],
                role: "presentation"
            },
            children: [
                this.buttonView
            ]
        });
        this.parentMenuView = parentMenuView;
        if (this.parentMenuView) this._handleParentMenuView();
        this._attachBehaviors();
    }
    /**
	* An array of positioning functions used to determine the position of the dropdown menu panel.
	* The order of the functions in the array determines the priority of the positions to be tried.
	* The first function that returns a valid position will be used.
	*
	* @returns {Array<PositioningFunction>} An array of positioning functions.
	* @internal
	*/ get _panelPositions() {
        const { westSouth: westSouth, eastSouth: eastSouth, westNorth: westNorth, eastNorth: eastNorth } = $29fd27cb9bdab9d2$export$99fd46937e4d4b71;
        if (this.locale.uiLanguageDirection === "ltr") return [
            eastSouth,
            eastNorth,
            westSouth,
            westNorth
        ];
        else return [
            westSouth,
            westNorth,
            eastSouth,
            eastNorth
        ];
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.panelView.render();
        this.focusTracker.add(this.buttonView.element);
        this.focusTracker.add(this.panelView.element);
        this.focusTracker.add(this.listView);
        this.keystrokes.listenTo(this.element);
        this._mountPanelOnOpen();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._removePanelFromBody();
        this.panelView.destroy();
        super.destroy();
    }
    /**
	* @inheritDoc
	*/ focus() {
        this.buttonView.focus();
    }
    _handleParentMenuView() {
        this.delegate(...DropdownMenuNestedMenuView.DELEGATED_EVENTS).to(this.parentMenuView);
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.closeOnParentClose(this, this.parentMenuView);
    }
    /**
	* Attach all keyboard behaviors for the menu view.
	*/ _attachBehaviors() {
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.openOnButtonClick(this);
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.openAndFocusOnEnterKeyPress(this);
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.openOnArrowRightKey(this);
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.closeOnEscKey(this);
        $29fd27cb9bdab9d2$export$c45b3e7cfab60f61.closeOnArrowLeftKey(this);
    }
    /**
	* Mounts the portal view in the body when the menu is open and removes it when the menu is closed.
	* Binds keystrokes to the portal view when the menu is open.
	*/ _mountPanelOnOpen() {
        const { panelView: panelView } = this;
        this.on("change:isOpen", (evt, name, isOpen)=>{
            if (evt.source !== this) return;
            if (!isOpen && this._bodyCollection.has(panelView)) {
                this._removePanelFromBody();
                return;
            }
            if (isOpen && !this._bodyCollection.has(panelView)) this._addPanelToBody();
        });
    }
    /**
	* Removes the panel view from the editor's body and removes it from the focus tracker.
	*/ _removePanelFromBody() {
        const { panelView: panelView, keystrokes: keystrokes } = this;
        if (this._bodyCollection.has(panelView)) {
            this._bodyCollection.remove(panelView);
            keystrokes.stopListening(panelView.element);
        }
    }
    /**
	* Adds the panel view to the editor's body and sets up event listeners.
	*/ _addPanelToBody() {
        const { panelView: panelView, buttonView: buttonView, keystrokes: keystrokes } = this;
        /* v8 ignore else -- @preserve */ if (!this._bodyCollection.has(panelView)) {
            this._bodyCollection.add(panelView);
            keystrokes.listenTo(panelView.element);
            panelView.pin({
                positions: this._panelPositions,
                limiter: (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body,
                element: panelView.element,
                target: buttonView.element,
                fitInViewport: true
            });
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/menu/dropdownmenurootlistview
*/ /**
* Creates and manages a multi-level menu UI structure, suitable to be used inside dropdown components.
*
* This class creates a menu structure based on {@link module:ui/dropdown/menu/utils~DropdownMenuDefinition declarative definition}
* passed in the constructor.
*
* Below is an example of a simple definition, that describes a menu with two sub-menus (Menu 1, Menu 2) and four buttons in total (Item A,
* Item B, Item C, Item D):
*
* ```js
* [
* 	{
* 		id: 'menu_1',
* 		menu: 'Menu 1',
* 		children: [
* 			{ id: 'menu_1_a', label: 'Item A' },
* 			{ id: 'menu_1_b', label: 'Item B' }
* 		]
* 	},
* 	{
* 		id: 'menu_2',
* 		menu: 'Menu 2',
* 		children: [
* 			{ id: 'menu_2_c', label: 'Item C' },
* 		]
* 	},
* 	{ id: 'item_d', label: 'Item D' }
* ]
* ```
*
* The menu is build using multiple view classes. The most important are:
*
* * {@link module:ui/dropdown/menu/dropdownmenunestedmenuview~DropdownMenuNestedMenuView `DropdownMenuNestedMenuView`} - "menu" - provides
* a panel with a nested menu, and a button which opens the panel,
* * {@link module:ui/dropdown/menu/dropdownmenulistitembuttonview~DropdownMenuListItemButtonView `DropdownMenuListItemButtonView`} -
* "button" or "leaf button" (as opposed to buttons provided by `DropdownMenuNestedMenuView`) - should trigger some action when pressed.
*
* Instances of these two classes are created based on the data provided in definitions. They are assigned proper IDs and labels.
* Other view classes build a proper DOM structure around menus and buttons.
*
* The `DropdownMenuNestedMenuView` instances provides panels, which may include further menus or buttons. These panels are added to
* a `BodyCollection` view, which means they are appended outside the DOM editor and UI structure.
*
* When "leaf button" is pressed, it fires `execute` event which is delegated to `DropdownMenuRootListView` as `menu:execute` event. You
* can listen to this event to perform an action:
*
* ```js
* rootListView.on( 'menu:execute', evt => {
* 	console.log( evt.source.id ); // E.g. will print 'menu_1_a' when 'Item A' is pressed.
* } );
* ```
*
* All menus and "leaf" buttons created from the definition can be easily accessed through {@link ~DropdownMenuRootListView#menus `menus`}
* and {@link ~DropdownMenuRootListView#buttons `buttons`} properties.
*
* For performance reasons, the whole menu structure is created only when `DropdownMenuRootListView` is rendered for the first time.
*
* It is recommended to use this class together with {@link module:ui/dropdown/utils~addMenuToDropdown `addMenuToDropdown()` helper}.
*/ var $29fd27cb9bdab9d2$export$f2490c05b793f0d = class extends $29fd27cb9bdab9d2$export$3f25934f5c78a973 {
    /**
	* The definitions object used to create the whole menu structure.
	*/ _definition;
    /**
	* Cached array of all menus in the dropdown menu (including nested menus).
	*/ _cachedMenus = [];
    /**
	* Cached array of all buttons in the dropdown menu (including buttons in nested menus).
	*/ _cachedButtons = [];
    /**
	* Editor body collection into which nested menus panels will be appended.
	*/ _bodyCollection;
    /**
	* Creates an instance of the DropdownMenuRootListView class.
	*
	* @param locale
	* @param bodyCollection
	* @param definition The definition object used to create the menu structure.
	*/ constructor(locale, bodyCollection, definition){
        super(locale);
        this._bodyCollection = bodyCollection;
        this._definition = definition;
        this.set("menuPanelClass", void 0);
    }
    /**
	* Returns the array of all menus in the dropdown menu (including nested menus).
	*/ get menus() {
        return Array.from(this._cachedMenus.values());
    }
    /**
	* Returns the array of all buttons in the dropdown menu (including buttons in nested menus).
	*
	* Note, that this includes only "leaf" buttons, as specified in the definition passed in constructor. Buttons created as a part of
	* the nested menus, that open nested menus when hovered or pressed, are not included.
	*/ get buttons() {
        return Array.from(this._cachedButtons.values());
    }
    /**
	* @inheritDoc
	*/ render() {
        this._createStructure(this._definition, null);
        super.render();
        $29fd27cb9bdab9d2$export$434c4fe25bac64c1.toggleMenusAndFocusItemsOnHover(this);
        $29fd27cb9bdab9d2$export$434c4fe25bac64c1.closeMenuWhenAnotherOnTheSameLevelOpens(this);
    }
    /**
	* Closes all nested menus.
	*/ closeMenus() {
        this.menus.forEach((menu)=>{
            menu.isOpen = false;
        });
    }
    /**
	* Recursively creates the whole view tree structure for the dropdown menu, according to the passed `definitions`.
	*
	* @private
	*/ _createStructure(definitions, parentMenuView) {
        const items = [];
        for (const def of definitions){
            let createdView;
            if ("menu" in def) {
                createdView = new $29fd27cb9bdab9d2$export$25a6ff46b1292bba(this.locale, this._bodyCollection, def.id, def.menu, parentMenuView);
                createdView.panelView.bind("class").to(this, "menuPanelClass");
                if (!parentMenuView) createdView.delegate(...$29fd27cb9bdab9d2$export$25a6ff46b1292bba.DELEGATED_EVENTS).to(this, (name)=>`menu:${name}`);
                this._cachedMenus.push(createdView);
                this._createStructure(def.children, createdView);
            } else {
                createdView = new $29fd27cb9bdab9d2$export$3b5b82dd5acc6985(this.locale, def.id, def.label);
                if (!parentMenuView) createdView.delegate("execute").to(this, "menu:execute");
                this._cachedButtons.push(createdView);
            }
            const listItemView = new $29fd27cb9bdab9d2$export$401d785a1b5ac85f(this.locale, parentMenuView, createdView);
            if (!parentMenuView) listItemView.delegate("mouseenter").to(this, "menu:mouseenter");
            items.push(listItemView);
        }
        (parentMenuView ? parentMenuView.listView : this).items.addMany(items);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/toolbarseparatorview
*/ /**
* The toolbar separator view class.
*/ var $29fd27cb9bdab9d2$export$1b338a24f9f00519 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-toolbar__separator"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/toolbarlinebreakview
*/ /**
* The toolbar line break view class.
*/ var $29fd27cb9bdab9d2$export$60f714ad0feaef75 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-toolbar__line-break"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A helper which executes a native `Event.preventDefault()` if the target of an event equals the
* {@link module:ui/view~View#element element of the view}. It shortens the definition of a
* {@link module:ui/view~View#template template}.
*
* ```ts
* // In a class extending View.
* import { preventDefault } from '@ckeditor/ckeditor5-ui/src/bindings/preventdefault';
*
* // ...
*
* this.setTemplate( {
* 	tag: 'div',
*
* 	on: {
* 		// Prevent the default mousedown action on this view.
* 		mousedown: preventDefault( this )
* 	}
* } );
* ```
*
* @param view View instance that defines the template.
* @internal
*/ function $29fd27cb9bdab9d2$export$814687ce359a97(view) {
    return view.bindTemplate.to((evt)=>{
        if (evt.target === view.element) evt.preventDefault();
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Normalizes the toolbar configuration (`config.toolbar`), which:
*
* * may be defined as an `Array`:
*
* ```
* toolbar: [ 'heading', 'bold', 'italic', 'link', ... ]
* ```
*
* * or an `Object`:
*
* ```
* toolbar: {
* 	items: [ 'heading', 'bold', 'italic', 'link', ... ],
* 	removeItems: [ 'bold' ],
* 	...
* }
* ```
*
* * or may not be defined at all (`undefined`)
*
* and returns it in the object form.
*
* @param config The value of `config.toolbar`.
* @returns A normalized toolbar config object.
*/ function $29fd27cb9bdab9d2$export$cddba3238a31417a(config) {
    if (Array.isArray(config)) return {
        items: config,
        removeItems: []
    };
    const predefinedConfigOptions = {
        items: [],
        removeItems: []
    };
    if (!config) return predefinedConfigOptions;
    return {
        ...predefinedConfigOptions,
        ...config
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/toolbarview
*/ /**
* @internal
*/ const $29fd27cb9bdab9d2$export$7c1ec60ab66f3307 = /* #__PURE__ */ (()=>({
        alignLeft: (0, $e8dc502aba5ac3f5$export$df3b17223210ab85),
        bold: (0, $e8dc502aba5ac3f5$export$1d3fc6e952f4058b),
        importExport: (0, $e8dc502aba5ac3f5$export$968ff8d3dd6c69d6),
        paragraph: (0, $e8dc502aba5ac3f5$export$dd7301757b50d467),
        plus: (0, $e8dc502aba5ac3f5$export$7b7ad8f03d93a9da),
        text: (0, $e8dc502aba5ac3f5$export$fe7c634bfc18e397),
        threeVerticalDots: (0, $e8dc502aba5ac3f5$export$765be1eabc10674d),
        pilcrow: (0, $e8dc502aba5ac3f5$export$2f99ec4b9363cd5b),
        dragIndicator: (0, $e8dc502aba5ac3f5$export$88be5dc0e2fd244c)
    }))();
/**
* The toolbar view class.
*/ var $29fd27cb9bdab9d2$export$2e2212e163bc16b8 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A reference to the options object passed to the constructor.
	*/ options;
    /**
	* A collection of toolbar items (buttons, dropdowns, etc.).
	*/ items;
    /**
	* Tracks information about the DOM focus in the toolbar.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
	* to handle keyboard navigation in the toolbar.
	*/ keystrokes;
    /**
	* A (child) view containing {@link #items toolbar items}.
	*/ itemsView;
    /**
	* A top–level collection aggregating building blocks of the toolbar.
	*
	*	┌───────────────── ToolbarView ─────────────────┐
	*	| ┌──────────────── #children ────────────────┐ |
	*	| |   ┌──────────── #itemsView ───────────┐   | |
	*	| |   | [ item1 ] [ item2 ] ... [ itemN ] |   | |
	*	| |   └──────────────────────────────────-┘   | |
	*	| └───────────────────────────────────────────┘ |
	*	└───────────────────────────────────────────────┘
	*
	* By default, it contains the {@link #itemsView} but it can be extended with additional
	* UI elements when necessary.
	*/ children;
    /**
	* A collection of {@link #items} that take part in the focus cycling
	* (i.e. navigation using the keyboard). Usually, it contains a subset of {@link #items} with
	* some optional UI elements that also belong to the toolbar and should be focusable
	* by the user.
	*/ focusables;
    /**
	* Helps cycling over {@link #focusables focusable items} in the toolbar.
	*/ _focusCycler;
    /**
	* An instance of the active toolbar behavior that shapes its look and functionality.
	*
	* See {@link module:ui/toolbar/toolbarview~ToolbarBehavior} to learn more.
	*/ _behavior;
    /**
	* Creates an instance of the {@link module:ui/toolbar/toolbarview~ToolbarView} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	* @param options Configuration options of the toolbar.
	*/ constructor(locale, options){
        super(locale);
        const bind = this.bindTemplate;
        const t = this.t;
        this.options = options || {};
        this.set("ariaLabel", t("Editor toolbar"));
        this.set("maxWidth", "auto");
        this.set("role", "toolbar");
        this.set("isGrouping", !!this.options.shouldGroupWhenFull);
        this.items = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.set("class", void 0);
        this.set("isCompact", false);
        this.set("isVertical", false);
        this.itemsView = new $29fd27cb9bdab9d2$export$28ccc221dce16acb(locale);
        this.children = this.createCollection();
        this.children.add(this.itemsView);
        this.focusables = this.createCollection();
        const isRtl = locale.uiLanguageDirection === "rtl";
        this._focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: [
                    isRtl ? "arrowright" : "arrowleft",
                    "arrowup"
                ],
                focusNext: [
                    isRtl ? "arrowleft" : "arrowright",
                    "arrowdown"
                ]
            }
        });
        const classes = [
            "ck",
            "ck-toolbar",
            bind.to("class"),
            bind.if("isCompact", "ck-toolbar_compact"),
            bind.if("isGrouping", "ck-toolbar_grouping"),
            bind.if("isVertical", "ck-toolbar_vertical")
        ];
        if (this.options.shouldGroupWhenFull && this.options.isFloating) classes.push("ck-toolbar_floating");
        this.setTemplate({
            tag: "div",
            attributes: {
                class: classes,
                role: bind.to("role"),
                "aria-label": bind.to("ariaLabel"),
                style: {
                    maxWidth: bind.to("maxWidth")
                },
                tabindex: -1
            },
            children: this.children,
            on: {
                mousedown: $29fd27cb9bdab9d2$export$814687ce359a97(this)
            }
        });
        this._behavior = this.options.shouldGroupWhenFull ? new $29fd27cb9bdab9d2$var$DynamicGrouping(this) : new $29fd27cb9bdab9d2$var$StaticLayout(this);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.element);
        for (const item of this.items)this.focusTracker.add(item);
        this.items.on("add", (evt, item)=>{
            this.focusTracker.add(item);
        });
        this.items.on("remove", (evt, item)=>{
            this.focusTracker.remove(item);
        });
        this.keystrokes.listenTo(this.element);
        this._behavior.render(this);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._behavior.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
        return super.destroy();
    }
    /**
	* Focuses the first focusable in {@link #focusables}.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the last focusable in {@link #focusables}.
	*/ focusLast() {
        this._focusCycler.focusLast();
    }
    /**
	* A utility that expands the plain toolbar configuration into
	* {@link module:ui/toolbar/toolbarview~ToolbarView#items} using a given component factory.
	*
	* @param itemsOrConfig The toolbar items or the entire toolbar configuration object.
	* @param factory A factory producing toolbar items.
	* @param removeItems An array of items names to be removed from the configuration. When present, applies
	* to this toolbar and all nested ones as well.
	*/ fillFromConfig(itemsOrConfig, factory, removeItems) {
        this.items.addMany(this._buildItemsFromConfig(itemsOrConfig, factory, removeItems));
    }
    /**
	* Changes the behavior of toolbar if it does not fit into the available space.
	*/ switchBehavior(newBehaviorType) {
        if (this._behavior.type !== newBehaviorType) {
            this._behavior.destroy();
            this.itemsView.children.clear();
            this.focusables.clear();
            if (newBehaviorType === "dynamic") {
                this._behavior = new $29fd27cb9bdab9d2$var$DynamicGrouping(this);
                this._behavior.render(this);
                this._behavior.refreshItems();
            } else {
                this._behavior = new $29fd27cb9bdab9d2$var$StaticLayout(this);
                this._behavior.render(this);
            }
        }
    }
    /**
	* A utility that expands the plain toolbar configuration into a list of view items using a given component factory.
	*
	* @param itemsOrConfig The toolbar items or the entire toolbar configuration object.
	* @param factory A factory producing toolbar items.
	* @param removeItems An array of items names to be removed from the configuration. When present, applies
	* to this toolbar and all nested ones as well.
	*/ _buildItemsFromConfig(itemsOrConfig, factory, removeItems) {
        const config = $29fd27cb9bdab9d2$export$cddba3238a31417a(itemsOrConfig);
        const normalizedRemoveItems = removeItems || config.removeItems;
        return this._cleanItemsConfiguration(config.items, factory, normalizedRemoveItems).map((item)=>{
            if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(item)) return this._createNestedToolbarDropdown(item, factory, normalizedRemoveItems);
            else if (item === "|") return new $29fd27cb9bdab9d2$export$1b338a24f9f00519();
            else if (item === "-") return new $29fd27cb9bdab9d2$export$60f714ad0feaef75();
            return factory.create(item);
        }).filter((item)=>!!item);
    }
    /**
	* Cleans up the {@link module:ui/toolbar/toolbarview~ToolbarView#items} of the toolbar by removing unwanted items and
	* duplicated (obsolete) separators or line breaks.
	*
	* @param items The toolbar items configuration.
	* @param factory A factory producing toolbar items.
	* @param removeItems An array of items names to be removed from the configuration.
	* @returns Items after the clean-up.
	*/ _cleanItemsConfiguration(items, factory, removeItems) {
        const filteredItems = items.filter((item, idx, items)=>{
            if (item === "|") return true;
            if (removeItems.indexOf(item) !== -1) return false;
            if (item === "-") {
                if (this.options.shouldGroupWhenFull) {
                    /**
					* The toolbar multiline breaks (`-` items) only work when the automatic button grouping
					* is disabled in the toolbar configuration.
					* To do this, set the `shouldNotGroupWhenFull` option to `true` in the editor configuration:
					*
					* ```ts
					* const config = {
					* 	toolbar: {
					* 		items: [ ... ],
					* 		shouldNotGroupWhenFull: true
					* 	}
					* }
					* ```
					*
					* Learn more about {@link module:core/editor/editorconfig~EditorConfig#toolbar toolbar configuration}.
					*
					* @error toolbarview-line-break-ignored-when-grouping-items
					*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("toolbarview-line-break-ignored-when-grouping-items", items);
                    return false;
                }
                return true;
            }
            if (!(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(item) && !factory.has(item)) {
                /**
				* There was a problem processing the configuration of the toolbar. The item with the given
				* name does not exist so it was omitted when rendering the toolbar.
				*
				* This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
				* to provide a toolbar item has not been loaded or there is a typo in the
				* {@link module:core/editor/editorconfig~EditorConfig#toolbar toolbar configuration}.
				*
				* Make sure the plugin responsible for this toolbar item is loaded and the toolbar configuration
				* is correct, e.g. {@link module:basic-styles/bold~Bold} is loaded for the `'bold'` toolbar item.
				*
				* You can use the following snippet to retrieve all available toolbar items:
				*
				* ```ts
				* Array.from( editor.ui.componentFactory.names() );
				* ```
				*
				* @error toolbarview-item-unavailable
				* @param {string} item The name of the component or nested toolbar definition.
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("toolbarview-item-unavailable", {
                    item: item
                });
                return false;
            }
            return true;
        });
        return this._cleanSeparatorsAndLineBreaks(filteredItems);
    }
    /**
	* Remove leading, trailing, and duplicated separators (`-` and `|`).
	*
	* @returns Toolbar items after the separator and line break clean-up.
	*/ _cleanSeparatorsAndLineBreaks(items) {
        const nonSeparatorPredicate = (item)=>item !== "-" && item !== "|";
        const count = items.length;
        const firstCommandItemIndex = items.findIndex(nonSeparatorPredicate);
        if (firstCommandItemIndex === -1) return [];
        const lastCommandItemIndex = count - items.slice().reverse().findIndex(nonSeparatorPredicate);
        return items.slice(firstCommandItemIndex, lastCommandItemIndex).filter((name, idx, items)=>{
            if (nonSeparatorPredicate(name)) return true;
            return !(idx > 0 && items[idx - 1] === name);
        });
    }
    /**
	* Creates a user-defined dropdown containing a toolbar with items.
	*
	* @param definition A definition of the nested toolbar dropdown.
	* @param definition.label A label of the dropdown.
	* @param definition.icon An icon of the drop-down. One of 'bold', 'plus', 'text', 'importExport', 'alignLeft',
	* 'paragraph' or an SVG string. When `false` is passed, no icon will be used.
	* @param definition.withText When set `true`, the label of the dropdown will be visible. See
	* {@link module:ui/button/buttonview~ButtonView#withText} to learn more.
	* @param definition.tooltip A tooltip of the dropdown button. See
	* {@link module:ui/button/buttonview~ButtonView#tooltip} to learn more. Defaults to `true`.
	* @param componentFactory Component factory used to create items
	* of the nested toolbar.
	*/ _createNestedToolbarDropdown(definition, componentFactory, removeItems) {
        let { label: label, icon: icon, items: items, tooltip: tooltip = true, withText: withText = false } = definition;
        items = this._cleanItemsConfiguration(items, componentFactory, removeItems);
        if (!items.length) return null;
        const locale = this.locale;
        const dropdownView = $29fd27cb9bdab9d2$export$3384a5f07adc0073(locale);
        if (!label) /**
		* A dropdown definition in the toolbar configuration is missing a text label.
		*
		* Without a label, the dropdown becomes inaccessible to users relying on assistive technologies.
		* Make sure the `label` property is set in your drop-down configuration:
		*
		* ```json
		* {
		* 	label: 'A human-readable label',
		* 	icon: '...',
		* 	items: [ ... ]
		* },
		* ```
		*
		* Learn more about {@link module:core/editor/editorconfig~EditorConfig#toolbar toolbar configuration}.
		*
		* @error toolbarview-nested-toolbar-dropdown-missing-label
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("toolbarview-nested-toolbar-dropdown-missing-label", definition);
        dropdownView.class = "ck-toolbar__nested-toolbar-dropdown";
        dropdownView.buttonView.set({
            label: label,
            tooltip: tooltip,
            withText: !!withText
        });
        if (icon !== false) dropdownView.buttonView.icon = $29fd27cb9bdab9d2$export$7c1ec60ab66f3307[icon] || icon || (0, $e8dc502aba5ac3f5$export$765be1eabc10674d);
        else dropdownView.buttonView.withText = true;
        $29fd27cb9bdab9d2$export$c39319333c19bdd7(dropdownView, ()=>dropdownView.toolbarView._buildItemsFromConfig(items, componentFactory, removeItems));
        return dropdownView;
    }
};
/**
* An inner block of the {@link module:ui/toolbar/toolbarview~ToolbarView} hosting its
* {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
*/ var $29fd27cb9bdab9d2$export$28ccc221dce16acb = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of items (buttons, dropdowns, etc.).
	*/ children;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-toolbar__items"
                ]
            },
            children: this.children
        });
    }
};
/**
* A toolbar behavior that makes it static and unresponsive to the changes of the environment.
* At the same time, it also makes it possible to display a toolbar with a vertical layout
* using the {@link module:ui/toolbar/toolbarview~ToolbarView#isVertical} property.
*/ var $29fd27cb9bdab9d2$var$StaticLayout = class {
    /**
	* Toolbar behavior type.
	*/ type = "static";
    /**
	* Creates an instance of the {@link module:ui/toolbar/toolbarview~StaticLayout} toolbar
	* behavior.
	*
	* @param view An instance of the toolbar that this behavior is added to.
	*/ constructor(view){
        view.isGrouping = false;
        view.itemsView.children.bindTo(view.items).using((item)=>item);
        view.focusables.bindTo(view.items).using((item)=>$29fd27cb9bdab9d2$export$4c063cf1350e6fed(item) ? item : null);
    }
    /**
	* @inheritDoc
	*/ render() {}
    /**
	* @inheritDoc
	*/ destroy() {}
};
/**
* A toolbar behavior that makes the items respond to changes in the geometry.
*
* In a nutshell, it groups {@link module:ui/toolbar/toolbarview~ToolbarView#items}
* that do not fit visually into a single row of the toolbar (due to limited space).
* Items that do not fit are aggregated in a dropdown displayed at the end of the toolbar.
*
* ```
*	┌──────────────────────────────────────── ToolbarView ──────────────────────────────────────────┐
*	| ┌─────────────────────────────────────── #children ─────────────────────────────────────────┐ |
*	| |   ┌─────── #itemsView ────────┐ ┌──────────────────────┐ ┌── #groupedItemsDropdown ───┐   | |
*	| |   |       #ungroupedItems     | | ToolbarSeparatorView | |        #groupedItems       |   | |
*	| |   └──────────────────────────-┘ └──────────────────────┘ └────────────────────────────┘   | |
*	| |                                  \---------- only when toolbar items overflow -------/    | |
*	| └───────────────────────────────────────────────────────────────────────────────────────────┘ |
*	└───────────────────────────────────────────────────────────────────────────────────────────────┘
* ```
*/ var $29fd27cb9bdab9d2$var$DynamicGrouping = class {
    /**
	* Toolbar behavior type.
	*/ type = "dynamic";
    /**
	* A toolbar view this behavior belongs to.
	*/ view;
    /**
	* A collection of toolbar children.
	*/ viewChildren;
    /**
	* A collection of focusable toolbar elements.
	*/ viewFocusables;
    /**
	* A view containing toolbar items.
	*/ viewItemsView;
    /**
	* Toolbar focus tracker.
	*/ viewFocusTracker;
    /**
	* Toolbar locale.
	*/ viewLocale;
    /**
	* A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
	* Aggregates items that fit into a single row of the toolbar and were not {@link #groupedItems grouped}
	* into a {@link #groupedItemsDropdown dropdown}. Items of this collection are displayed in the
	* {@link module:ui/toolbar/toolbarview~ToolbarView#itemsView}.
	*
	* When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped, it
	* matches the {@link module:ui/toolbar/toolbarview~ToolbarView#items} collection in size and order.
	*/ ungroupedItems;
    /**
	* A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
	* A collection of the toolbar items that do not fit into a single row of the toolbar.
	* Grouped items are displayed in a dedicated {@link #groupedItemsDropdown dropdown}.
	*
	* When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped,
	* this collection is empty.
	*/ groupedItems;
    /**
	* The dropdown that aggregates {@link #groupedItems grouped items} that do not fit into a single
	* row of the toolbar. It is displayed on demand as the last of
	* {@link module:ui/toolbar/toolbarview~ToolbarView#children toolbar children} and offers another
	* (nested) toolbar which displays items that would normally overflow.
	*/ groupedItemsDropdown;
    /**
	* An instance of the resize observer that helps dynamically determine the geometry of the toolbar
	* and manage items that do not fit into a single row.
	*
	* **Note:** Created in {@link #_enableGroupingOnResize}.
	*
	* @readonly
	*/ resizeObserver = null;
    /**
	* A cached value of the horizontal padding style used by {@link #_updateGrouping}
	* to manage the {@link module:ui/toolbar/toolbarview~ToolbarView#items} that do not fit into
	* a single toolbar line. This value can be reused between updates because it is unlikely that
	* the padding will change and re–using `Window.getComputedStyle()` is expensive.
	*
	* @readonly
	*/ cachedPadding = null;
    /**
	* A flag indicating that an items grouping update has been queued (e.g. due to the toolbar being visible)
	* and should be executed immediately the next time the toolbar shows up.
	*
	* @readonly
	*/ shouldUpdateGroupingOnNextResize = false;
    /**
	* Toolbar element.
	*
	* @readonly
	*/ viewElement;
    /**
	* Creates an instance of the {@link module:ui/toolbar/toolbarview~DynamicGrouping} toolbar
	* behavior.
	*
	* @param view An instance of the toolbar that this behavior is added to.
	*/ constructor(view){
        this.view = view;
        this.viewChildren = view.children;
        this.viewFocusables = view.focusables;
        this.viewItemsView = view.itemsView;
        this.viewFocusTracker = view.focusTracker;
        this.viewLocale = view.locale;
        this.view.isGrouping = true;
        this.ungroupedItems = view.createCollection();
        this.groupedItems = view.createCollection();
        this.groupedItemsDropdown = this._createGroupedItemsDropdown();
        view.itemsView.children.bindTo(this.ungroupedItems).using((item)=>item);
        this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this));
        view.children.on("change", this._updateFocusCyclableItems.bind(this));
        view.items.on("change", (evt, changeData)=>{
            const index = changeData.index;
            const added = Array.from(changeData.added);
            for (const removedItem of changeData.removed)if (index >= this.ungroupedItems.length) this.groupedItems.remove(removedItem);
            else this.ungroupedItems.remove(removedItem);
            for(let currentIndex = index; currentIndex < index + added.length; currentIndex++){
                const addedItem = added[currentIndex - index];
                if (currentIndex > this.ungroupedItems.length) this.groupedItems.add(addedItem, currentIndex - this.ungroupedItems.length);
                else this.ungroupedItems.add(addedItem, currentIndex);
            }
            this._updateGrouping();
        });
    }
    /**
	* Enables dynamic items grouping based on the dimensions of the toolbar.
	*
	* @param view An instance of the toolbar that this behavior is added to.
	*/ render(view) {
        this.viewElement = view.element;
        this._enableGroupingOnResize();
        this._enableGroupingOnMaxWidthChange(view);
    }
    /**
	* Cleans up the internals used by this behavior.
	*/ destroy() {
        this.groupedItemsDropdown.destroy();
        if (this.viewChildren.length > 1) {
            this.viewChildren.remove(this.groupedItemsDropdown);
            this.viewChildren.remove(this.viewChildren.last);
        }
        this.resizeObserver.destroy();
    }
    /**
	* Re-adds all items to the toolbar. Use when the toolbar is re-rendered and the items grouping is lost.
	*/ refreshItems() {
        const view = this.view;
        if (view.items.length) {
            for(let currentIndex = 0; currentIndex < view.items.length; currentIndex++){
                const item = [
                    ...view.items
                ][currentIndex];
                this.ungroupedItems.add(item, currentIndex);
            }
            this._updateGrouping();
        }
    }
    /**
	* When called, it will check if any of the {@link #ungroupedItems} do not fit into a single row of the toolbar,
	* and it will move them to the {@link #groupedItems} when it happens.
	*
	* At the same time, it will also check if there is enough space in the toolbar for the first of the
	* {@link #groupedItems} to be returned back to {@link #ungroupedItems} and still fit into a single row
	* without the toolbar wrapping.
	*/ _updateGrouping() {
        if (!this.viewElement.isConnected) return;
        if (!(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(this.viewElement)) {
            this.shouldUpdateGroupingOnNextResize = true;
            return;
        }
        const initialGroupedItemsCount = this.groupedItems.length;
        let wereItemsGrouped;
        while(this._areItemsOverflowing){
            this._groupLastItem();
            wereItemsGrouped = true;
        }
        if (!wereItemsGrouped && this.groupedItems.length) {
            while(this.groupedItems.length && !this._areItemsOverflowing)this._ungroupFirstItem();
            if (this._areItemsOverflowing) this._groupLastItem();
        }
        if (this.groupedItems.length !== initialGroupedItemsCount) this.view.fire("groupedItemsUpdate");
    }
    /**
	* Returns `true` when {@link module:ui/toolbar/toolbarview~ToolbarView#element} children visually overflow,
	* for instance if the toolbar is narrower than its members. Returns `false` otherwise.
	*/ get _areItemsOverflowing() {
        if (!this.ungroupedItems.length) return false;
        const element = this.viewElement;
        const uiLanguageDirection = this.viewLocale.uiLanguageDirection;
        const lastChildRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(element.lastChild);
        const toolbarRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(element);
        if (!this.cachedPadding) {
            const computedStyle = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(element);
            const paddingProperty = uiLanguageDirection === "ltr" ? "paddingRight" : "paddingLeft";
            this.cachedPadding = Number.parseInt(computedStyle[paddingProperty]);
        }
        const overflowTolerance = 1;
        if (uiLanguageDirection === "ltr") return lastChildRect.right > toolbarRect.right - this.cachedPadding + overflowTolerance;
        else return lastChildRect.left < toolbarRect.left + this.cachedPadding - overflowTolerance;
    }
    /**
	* Enables the functionality that prevents {@link #ungroupedItems} from overflowing (wrapping to the next row)
	* upon resize when there is little space available. Instead, the toolbar items are moved to the
	* {@link #groupedItems} collection and displayed in a dropdown at the end of the row (which has its own nested toolbar).
	*
	* When called, the toolbar will automatically analyze the location of its {@link #ungroupedItems} and "group"
	* them in the dropdown if necessary. It will also observe the browser window for size changes in
	* the future and respond to them by grouping more items or reverting already grouped back, depending
	* on the visual space available.
	*/ _enableGroupingOnResize() {
        let previousWidth;
        this.resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(this.viewElement, (entry)=>{
            if (!previousWidth || previousWidth !== entry.contentRect.width || this.shouldUpdateGroupingOnNextResize) {
                this.shouldUpdateGroupingOnNextResize = false;
                this._updateGrouping();
                previousWidth = entry.contentRect.width;
            }
        });
        this._updateGrouping();
    }
    /**
	* Enables the grouping functionality, just like {@link #_enableGroupingOnResize} but the difference is that
	* it listens to the changes of {@link module:ui/toolbar/toolbarview~ToolbarView#maxWidth} instead.
	*/ _enableGroupingOnMaxWidthChange(view) {
        view.on("change:maxWidth", ()=>{
            this._updateGrouping();
        });
    }
    /**
	* When called, it will remove the last item from {@link #ungroupedItems} and move it back
	* to the {@link #groupedItems} collection.
	*
	* The opposite of {@link #_ungroupFirstItem}.
	*/ _groupLastItem() {
        if (!this.groupedItems.length) {
            this.viewChildren.add(new $29fd27cb9bdab9d2$export$1b338a24f9f00519());
            this.viewChildren.add(this.groupedItemsDropdown);
            this.viewFocusTracker.add(this.groupedItemsDropdown.element);
        }
        this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
    }
    /**
	* Moves the very first item belonging to {@link #groupedItems} back
	* to the {@link #ungroupedItems} collection.
	*
	* The opposite of {@link #_groupLastItem}.
	*/ _ungroupFirstItem() {
        this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first));
        if (!this.groupedItems.length) {
            this.viewChildren.remove(this.groupedItemsDropdown);
            this.viewChildren.remove(this.viewChildren.last);
            this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
        }
    }
    /**
	* Creates the {@link #groupedItemsDropdown} that hosts the members of the {@link #groupedItems}
	* collection when there is not enough space in the toolbar to display all items in a single row.
	*/ _createGroupedItemsDropdown() {
        const locale = this.viewLocale;
        const t = locale.t;
        const dropdown = $29fd27cb9bdab9d2$export$3384a5f07adc0073(locale);
        dropdown.class = "ck-toolbar__grouped-dropdown";
        dropdown.panelPosition = locale.uiLanguageDirection === "ltr" ? "sw" : "se";
        $29fd27cb9bdab9d2$export$c39319333c19bdd7(dropdown, this.groupedItems);
        dropdown.buttonView.set({
            label: t("Show more items"),
            tooltip: true,
            tooltipPosition: locale.uiLanguageDirection === "rtl" ? "se" : "sw",
            icon: (0, $e8dc502aba5ac3f5$export$765be1eabc10674d)
        });
        return dropdown;
    }
    /**
	* Updates the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables focus–cyclable items}
	* collection so it represents the up–to–date state of the UI from the perspective of the user.
	*
	* For instance, the {@link #groupedItemsDropdown} can show up and hide but when it is visible,
	* it must be subject to focus cycling in the toolbar.
	*
	* See the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables collection} documentation
	* to learn more about the purpose of this method.
	*/ _updateFocusCyclableItems() {
        this.viewFocusables.clear();
        this.ungroupedItems.map((item)=>{
            if ($29fd27cb9bdab9d2$export$4c063cf1350e6fed(item)) this.viewFocusables.add(item);
        });
        if (this.groupedItems.length) this.viewFocusables.add(this.groupedItemsDropdown);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/button/splitbuttonview
*/ /**
* The split button view class.
*
* ```ts
* const view = new SplitButtonView();
*
* view.set( {
* 	label: 'A button',
* 	keystroke: 'Ctrl+B',
* 	tooltip: true
* } );
*
* view.render();
*
* document.body.append( view.element );
* ```
*
* Also see the {@link module:ui/dropdown/utils~createDropdown `createDropdown()` util}.
*/ var $29fd27cb9bdab9d2$export$5981ef7d837e6d9 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views inside of the split button {@link #element}.
	*/ children;
    /**
	* A main button of split button.
	*/ actionView;
    /**
	* A secondary button of split button that opens dropdown.
	*/ arrowView;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
	* keystrokes of the split button:
	*
	* * <kbd>▶</kbd> moves focus to arrow view when action view is focused,
	* * <kbd>◀</kbd> moves focus to action view when arrow view is focused.
	*/ keystrokes;
    /**
	* Tracks information about DOM focus in the dropdown.
	*/ focusTracker;
    /**
	* @inheritDoc
	*/ constructor(locale, actionButton){
        super(locale);
        const bind = this.bindTemplate;
        this.set("class", void 0);
        this.set("labelStyle", void 0);
        this.set("icon", void 0);
        this.set("isEnabled", true);
        this.set("isOn", false);
        this.set("isToggleable", false);
        this.set("isVisible", true);
        this.set("keystroke", void 0);
        this.set("withKeystroke", false);
        this.set("label", void 0);
        this.set("tabindex", -1);
        this.set("tooltip", false);
        this.set("tooltipPosition", "s");
        this.set("type", "button");
        this.set("withText", false);
        this.children = this.createCollection();
        this.actionView = this._createActionView(actionButton);
        this.arrowView = this._createArrowView();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-splitbutton",
                    bind.to("class"),
                    bind.if("isVisible", "ck-hidden", (value)=>!value),
                    this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")
                ]
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.actionView);
        this.children.add(this.arrowView);
        this.focusTracker.add(this.actionView.element);
        this.focusTracker.add(this.arrowView.element);
        this.keystrokes.listenTo(this.element);
        this.keystrokes.set("arrowright", (evt, cancel)=>{
            if (this.focusTracker.focusedElement === this.actionView.element) {
                this.arrowView.focus();
                cancel();
            }
        });
        this.keystrokes.set("arrowleft", (evt, cancel)=>{
            if (this.focusTracker.focusedElement === this.arrowView.element) {
                this.actionView.focus();
                cancel();
            }
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the {@link module:ui/button/buttonview~ButtonView#element} of the action part of split button.
	*/ focus() {
        this.actionView.focus();
    }
    /**
	* Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #actionView} and binds it with main split button
	* attributes.
	*/ _createActionView(actionButton) {
        const actionView = actionButton || new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa();
        if (!actionButton) actionView.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this);
        actionView.extendTemplate({
            attributes: {
                class: "ck-splitbutton__action"
            }
        });
        actionView.delegate("execute").to(this);
        return actionView;
    }
    /**
	* Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #arrowView} and binds it with main split button
	* attributes.
	*/ _createArrowView() {
        const arrowView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa();
        const bind = arrowView.bindTemplate;
        arrowView.icon = (0, $e8dc502aba5ac3f5$export$48d0dd33d947d151);
        arrowView.extendTemplate({
            attributes: {
                class: [
                    "ck-splitbutton__arrow"
                ],
                "data-cke-tooltip-disabled": bind.to("isOn"),
                "aria-haspopup": true,
                "aria-expanded": bind.to("isOn", (value)=>String(value))
            }
        });
        arrowView.bind("isEnabled").to(this);
        arrowView.bind("label").to(this);
        arrowView.bind("tooltip").to(this);
        arrowView.delegate("execute").to(this, "open");
        return arrowView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/dropdown/utils
*/ /**
* A helper for creating dropdowns. It creates an instance of a {@link module:ui/dropdown/dropdownview~DropdownView dropdown},
* with a {@link module:ui/dropdown/button/dropdownbutton~DropdownButton button},
* {@link module:ui/dropdown/dropdownpanelview~DropdownPanelView panel} and all standard dropdown's behaviors.
*
* # Creating dropdowns
*
* By default, the default {@link module:ui/dropdown/button/dropdownbuttonview~DropdownButtonView} class is used as
* definition of the button:
*
* ```ts
* const dropdown = createDropdown( model );
*
* // Configure dropdown's button properties:
* dropdown.buttonView.set( {
* 	label: 'A dropdown',
* 	withText: true
* } );
*
* dropdown.render();
*
* // Will render a dropdown labeled "A dropdown" with an empty panel.
* document.body.appendChild( dropdown.element );
* ```
*
* You can also provide other button views (they need to implement the
* {@link module:ui/dropdown/button/dropdownbutton~DropdownButton} interface). For instance, you can use
* {@link module:ui/dropdown/button/splitbuttonview~SplitButtonView} to create a dropdown with a split button.
*
* ```ts
* const dropdown = createDropdown( locale, SplitButtonView );
*
* // Configure dropdown's button properties:
* dropdown.buttonView.set( {
* 	label: 'A dropdown',
* 	withText: true
* } );
*
* dropdown.buttonView.on( 'execute', () => {
* 	// Add the behavior of the "action part" of the split button.
* 	// Split button consists of the "action part" and "arrow part".
* 	// The arrow opens the dropdown while the action part can have some other behavior.
* } );
*
* dropdown.render();
*
* // Will render a dropdown labeled "A dropdown" with an empty panel.
* document.body.appendChild( dropdown.element );
* ```
*
* # Adding content to the dropdown's panel
*
* The content of the panel can be inserted directly into the `dropdown.panelView.element`:
*
* ```ts
* dropdown.panelView.element.textContent = 'Content of the panel';
* ```
*
* However, most of the time you will want to add there either a {@link module:ui/list/listview~ListView list of options}
* or a list of buttons (i.e. a {@link module:ui/toolbar/toolbarview~ToolbarView toolbar}).
* To simplify the task, you can use, respectively, {@link module:ui/dropdown/utils~addListToDropdown} or
* {@link module:ui/dropdown/utils~addToolbarToDropdown} utils.
*
* @param locale The locale instance.
* @param ButtonClassOrInstance The dropdown button view class. Needs to implement the
* {@link module:ui/dropdown/button/dropdownbutton~DropdownButton} interface.
* @returns The dropdown view instance.
*/ function $29fd27cb9bdab9d2$export$3384a5f07adc0073(locale, ButtonClassOrInstance = $29fd27cb9bdab9d2$export$78bc6c5c028686b7) {
    const buttonView = typeof ButtonClassOrInstance == "function" ? new ButtonClassOrInstance(locale) : ButtonClassOrInstance;
    const panelView = new $29fd27cb9bdab9d2$export$4c88ab3d80d9f838(locale);
    const dropdownView = new $29fd27cb9bdab9d2$export$30eba291eb702857(locale, buttonView, panelView);
    buttonView.bind("isEnabled").to(dropdownView);
    if (buttonView instanceof $29fd27cb9bdab9d2$export$5981ef7d837e6d9) buttonView.arrowView.bind("isOn").to(dropdownView, "isOpen");
    else buttonView.bind("isOn").to(dropdownView, "isOpen");
    $29fd27cb9bdab9d2$var$addDefaultBehaviors(dropdownView);
    return dropdownView;
}
/**
* Adds a menu UI component to a dropdown and sets all common behaviors and interactions between the dropdown and the menu.
*
* Use this helper to create multi-level dropdown menus that are displayed in a toolbar.
*
* Internally, it creates an instance of {@link module:ui/dropdown/menu/dropdownmenurootlistview~DropdownMenuRootListView}.
*
* Example:
*
* ```ts
* const definitions = [
* 	{
* 		id: 'menu_1',
* 		menu: 'Menu 1',
* 		children: [
* 			{
* 				id: 'menu_1_a',
* 				label: 'Item A'
* 			},
* 			{
* 				id: 'menu_1_b',
* 				label: 'Item B'
* 			}
* 		]
* 	},
* 	{
* 		id: 'top_a',
* 		label: 'Top Item A'
* 	},
* 	{
* 		id: 'top_b',
* 		label: 'Top Item B'
* 	}
* ];
*
* const dropdownView = createDropdown( editor.locale );
*
* addMenuToDropdown( dropdownView, editor.ui.view.body, definitions );
* ```
*
* After using this helper, the `dropdown` will fire {@link module:ui/dropdown/dropdownview~DropdownViewEvent `execute`} event when
* a nested menu button is pressed.
*
* The helper will make sure that the `dropdownMenuRootListView` is lazy loaded, i.e., the menu component structure will be initialized
* and rendered only after the `dropdown` is opened for the first time.
*
* @param dropdownView A dropdown instance to which the menu component will be added.
* @param body Body collection to which floating menu panels will be added.
* @param definition The menu component definition.
* @param options.ariaLabel Label used by assistive technologies to describe the top-level menu.
*/ function $29fd27cb9bdab9d2$export$ed5cc300f16002bc(dropdownView, body, definition, options = {}) {
    dropdownView.menuView = new $29fd27cb9bdab9d2$export$f2490c05b793f0d(dropdownView.locale, body, definition);
    dropdownView.focusTracker.add(dropdownView.menuView);
    if (dropdownView.isOpen) $29fd27cb9bdab9d2$var$addMenuToOpenDropdown(dropdownView, options);
    else dropdownView.once("change:isOpen", ()=>{
        $29fd27cb9bdab9d2$var$addMenuToOpenDropdown(dropdownView, options);
    }, {
        priority: "highest"
    });
}
function $29fd27cb9bdab9d2$var$addMenuToOpenDropdown(dropdownView, options) {
    const dropdownMenuRootListView = dropdownView.menuView;
    const t = dropdownView.locale.t;
    dropdownMenuRootListView.delegate("menu:execute").to(dropdownView, "execute");
    dropdownMenuRootListView.listenTo(dropdownView, "change:isOpen", (evt, name, isOpen)=>{
        if (!isOpen) dropdownMenuRootListView.closeMenus();
    }, {
        priority: "low"
    });
    dropdownView.panelView.children.add(dropdownMenuRootListView);
    for (const menu of dropdownMenuRootListView.menus)dropdownView.focusTracker.add(menu);
    dropdownMenuRootListView.ariaLabel = options.ariaLabel || t("Dropdown menu");
}
/**
* Adds an instance of {@link module:ui/toolbar/toolbarview~ToolbarView} to a dropdown.
*
* ```ts
* const buttonsCreator = () => {
* 	const buttons = [];
*
* 	// Either create a new ButtonView instance or create existing.
* 	buttons.push( new ButtonView() );
* 	buttons.push( editor.ui.componentFactory.create( 'someButton' ) );
* };
*
* const dropdown = createDropdown( locale );
*
* addToolbarToDropdown( dropdown, buttonsCreator, { isVertical: true } );
*
* // Will render a vertical button dropdown labeled "A button dropdown"
* // with a button group in the panel containing two buttons.
* // Buttons inside the dropdown will be created on first dropdown panel open.
* dropdown.render()
* document.body.appendChild( dropdown.element );
* ```
*
* **Note:** To improve the accessibility, you can tell the dropdown to focus the first active button of the toolbar when the dropdown
* {@link module:ui/dropdown/dropdownview~DropdownView#isOpen gets open}. See the documentation of `options` to learn more.
*
* **Note:** Toolbar view will be created on first open of the dropdown.
*
* See {@link module:ui/dropdown/utils~createDropdown} and {@link module:ui/toolbar/toolbarview~ToolbarView}.
*
* @param dropdownView A dropdown instance to which `ToolbarView` will be added.
* @param options.enableActiveItemFocusOnDropdownOpen When set `true`, the focus will automatically move to the first
* active {@link module:ui/toolbar/toolbarview~ToolbarView#items item} of the toolbar upon
* {@link module:ui/dropdown/dropdownview~DropdownView#isOpen opening} the dropdown. Active items are those with the `isOn` property set
* `true` (for instance {@link module:ui/button/buttonview~ButtonView buttons}). If no active items is found, the toolbar will be focused
* as a whole resulting in the focus moving to its first focusable item (default behavior of
* {@link module:ui/dropdown/dropdownview~DropdownView}).
* @param options.ariaLabel Label used by assistive technologies to describe toolbar element.
* @param options.maxWidth The maximum width of the toolbar element.
* Details: {@link module:ui/toolbar/toolbarview~ToolbarView#maxWidth}.
* @param options.class An additional CSS class added to the toolbar element.
* @param options.isCompact When set true, makes the toolbar look compact with toolbar element.
* @param options.isVertical Controls the orientation of toolbar items.
*/ function $29fd27cb9bdab9d2$export$c39319333c19bdd7(dropdownView, buttonsOrCallback, options = {}) {
    dropdownView.extendTemplate({
        attributes: {
            class: [
                "ck-toolbar-dropdown"
            ]
        }
    });
    if (dropdownView.isOpen) $29fd27cb9bdab9d2$var$addToolbarToOpenDropdown(dropdownView, buttonsOrCallback, options);
    else dropdownView.once("change:isOpen", ()=>$29fd27cb9bdab9d2$var$addToolbarToOpenDropdown(dropdownView, buttonsOrCallback, options), {
        priority: "highest"
    });
    if (options.enableActiveItemFocusOnDropdownOpen) $29fd27cb9bdab9d2$export$52d62fb5806f208(dropdownView, ()=>dropdownView.toolbarView.items.find((item)=>item.isOn));
}
/**
* Adds an instance of {@link module:ui/toolbar/toolbarview~ToolbarView} to a dropdown.
*/ function $29fd27cb9bdab9d2$var$addToolbarToOpenDropdown(dropdownView, buttonsOrCallback, options) {
    const locale = dropdownView.locale;
    const t = locale.t;
    const toolbarView = dropdownView.toolbarView = new $29fd27cb9bdab9d2$export$2e2212e163bc16b8(locale);
    const buttons = typeof buttonsOrCallback == "function" ? buttonsOrCallback() : buttonsOrCallback;
    toolbarView.ariaLabel = options.ariaLabel || t("Dropdown toolbar");
    if (options.maxWidth) toolbarView.maxWidth = options.maxWidth;
    if (options.class) toolbarView.class = options.class;
    if (options.isCompact) toolbarView.isCompact = options.isCompact;
    if (options.isVertical) toolbarView.isVertical = true;
    if (buttons instanceof $29fd27cb9bdab9d2$export$ff20b327de53fba7) toolbarView.items.bindTo(buttons).using((item)=>item);
    else toolbarView.items.addMany(buttons);
    dropdownView.panelView.children.add(toolbarView);
    dropdownView.focusTracker.add(toolbarView);
    toolbarView.items.delegate("execute").to(dropdownView);
}
/**
* Adds an instance of {@link module:ui/list/listview~ListView} to a dropdown.
*
* ```ts
* const items = new Collection<ListDropdownItemDefinition>();
*
* items.add( {
* 	type: 'button',
* 	model: new Model( {
* 		withText: true,
* 		label: 'First item',
* 		labelStyle: 'color: red'
* 	} )
* } );
*
* items.add( {
* 	 type: 'button',
* 	 model: new Model( {
* 		withText: true,
* 		label: 'Second item',
* 		labelStyle: 'color: green',
* 		class: 'foo'
* 	} )
* } );
*
* const dropdown = createDropdown( locale );
*
* addListToDropdown( dropdown, items );
*
* // Will render a dropdown with a list in the panel containing two items.
* dropdown.render()
* document.body.appendChild( dropdown.element );
* ```
*
* The `items` collection passed to this methods controls the presence and attributes of respective
* {@link module:ui/list/listitemview~ListItemView list items}.
*
* **Note:** To improve the accessibility, when a list is added to the dropdown using this helper the dropdown will automatically attempt
* to focus the first active item (a host to a {@link module:ui/button/buttonview~ButtonView} with
* {@link module:ui/button/buttonview~ButtonView#isOn} set `true`) or the very first item when none are active.
*
* **Note:** List view will be created on first open of the dropdown.
*
* See {@link module:ui/dropdown/utils~createDropdown} and {@link module:list/list~List}.
*
* @param dropdownView A dropdown instance to which `ListVIew` will be added.
* @param itemsOrCallback A collection of the list item definitions or a callback returning a list item definitions to populate the list.
* @param options.ariaLabel Label used by assistive technologies to describe list element.
* @param options.role Will be reflected by the `role` DOM attribute in `ListVIew` and used by assistive technologies.
*/ function $29fd27cb9bdab9d2$export$d59f2481d69271ab(dropdownView, itemsOrCallback, options = {}) {
    if (dropdownView.isOpen) $29fd27cb9bdab9d2$var$addListToOpenDropdown(dropdownView, itemsOrCallback, options);
    else dropdownView.once("change:isOpen", ()=>$29fd27cb9bdab9d2$var$addListToOpenDropdown(dropdownView, itemsOrCallback, options), {
        priority: "highest"
    });
    $29fd27cb9bdab9d2$export$52d62fb5806f208(dropdownView, ()=>dropdownView.listView.items.find((item)=>{
            if (item instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8) return item.children.first.isOn;
            return false;
        }));
}
/**
* Adds an instance of {@link module:ui/list/listview~ListView} to a dropdown.
*/ function $29fd27cb9bdab9d2$var$addListToOpenDropdown(dropdownView, itemsOrCallback, options) {
    const locale = dropdownView.locale;
    const listView = dropdownView.listView = new $29fd27cb9bdab9d2$export$84d0dd190d551cd1(locale);
    const items = typeof itemsOrCallback == "function" ? itemsOrCallback() : itemsOrCallback;
    listView.ariaLabel = options.ariaLabel;
    listView.role = options.role;
    $29fd27cb9bdab9d2$var$bindViewCollectionItemsToDefinitions(dropdownView, listView.items, items, locale);
    dropdownView.panelView.children.add(listView);
    listView.items.delegate("execute").to(dropdownView);
}
/**
* A helper to be used on an existing {@link module:ui/dropdown/dropdownview~DropdownView} that focuses
* a specific child in DOM when the dropdown {@link module:ui/dropdown/dropdownview~DropdownView#isOpen gets open}.
*
* @param dropdownView A dropdown instance to which the focus behavior will be added.
* @param childSelectorCallback A callback executed when the dropdown gets open. It should return a {@link module:ui/view~View}
* instance (child of {@link module:ui/dropdown/dropdownview~DropdownView#panelView}) that will get focused or a falsy value.
* If falsy value is returned, a default behavior of the dropdown will engage focusing the first focusable child in
* the {@link module:ui/dropdown/dropdownview~DropdownView#panelView}.
*/ function $29fd27cb9bdab9d2$export$52d62fb5806f208(dropdownView, childSelectorCallback) {
    dropdownView.on("change:isOpen", ()=>{
        if (!dropdownView.isOpen) return;
        const childToFocus = childSelectorCallback();
        if (!childToFocus) return;
        if (typeof childToFocus.focus === "function") childToFocus.focus();
        else /**
		* The child view of a {@link module:ui/dropdown/dropdownview~DropdownView dropdown} is missing the `focus()` method
		* and could not be focused when the dropdown got {@link module:ui/dropdown/dropdownview~DropdownView#isOpen open}.
		*
		* Making the content of a dropdown focusable in this case greatly improves the accessibility. Please make the view instance
		* implements the {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable focusable interface} for the best user
		* experience.
		*
		* @error ui-dropdown-focus-child-on-open-child-missing-focus
		* @param {module:ui/view~View} view Child to focus.
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("ui-dropdown-focus-child-on-open-child-missing-focus", {
            view: childToFocus
        });
    }, {
        priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low - 10
    });
}
/**
* Add a set of default behaviors to dropdown view.
*/ function $29fd27cb9bdab9d2$var$addDefaultBehaviors(dropdownView) {
    $29fd27cb9bdab9d2$var$closeDropdownOnClickOutside(dropdownView);
    $29fd27cb9bdab9d2$var$closeDropdownOnExecute(dropdownView);
    $29fd27cb9bdab9d2$var$closeDropdownOnBlur(dropdownView);
    $29fd27cb9bdab9d2$var$focusDropdownContentsOnArrows(dropdownView);
    $29fd27cb9bdab9d2$var$focusDropdownButtonOnClose(dropdownView);
    $29fd27cb9bdab9d2$var$focusDropdownPanelOnOpen(dropdownView);
}
/**
* Adds a behavior to a dropdownView that closes opened dropdown when user clicks outside the dropdown.
*/ function $29fd27cb9bdab9d2$var$closeDropdownOnClickOutside(dropdownView) {
    $29fd27cb9bdab9d2$export$16d2a52659b91b8a({
        emitter: dropdownView,
        activator: ()=>dropdownView.isRendered && dropdownView.isOpen,
        callback: ()=>{
            dropdownView.isOpen = false;
        },
        contextElements: ()=>[
                dropdownView.element,
                ...$29fd27cb9bdab9d2$var$getFocusTrackerTreeElements(dropdownView.focusTracker).filter((element)=>!(0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(dropdownView.element, element))
            ]
    });
}
/**
* Returns all DOM elements connected to a DropdownView's focus tracker, either directly (same DOM sub-tree)
* or indirectly (external views registered in the focus tracker).
*/ function $29fd27cb9bdab9d2$var$getFocusTrackerTreeElements(focusTracker) {
    return [
        ...focusTracker.elements,
        ...focusTracker.externalViews.flatMap((view)=>$29fd27cb9bdab9d2$var$getFocusTrackerTreeElements(view.focusTracker))
    ];
}
/**
* Adds a behavior to a dropdownView that closes the dropdown view on "execute" event.
*/ function $29fd27cb9bdab9d2$var$closeDropdownOnExecute(dropdownView) {
    dropdownView.on("execute", (evt)=>{
        if (evt.source instanceof $29fd27cb9bdab9d2$export$bb3c559d00882ebd) return;
        dropdownView.isOpen = false;
    });
}
/**
* Adds a behavior to a dropdown view that closes opened dropdown when it loses focus.
*/ function $29fd27cb9bdab9d2$var$closeDropdownOnBlur(dropdownView) {
    dropdownView.focusTracker.on("change:isFocused", (evt, name, isFocused)=>{
        if (isFocused || !dropdownView.isOpen) return;
        dropdownView.isOpen = false;
    });
}
/**
* Adds a behavior to a dropdownView that focuses the dropdown's panel view contents on keystrokes.
*/ function $29fd27cb9bdab9d2$var$focusDropdownContentsOnArrows(dropdownView) {
    dropdownView.keystrokes.set("arrowdown", (data, cancel)=>{
        if (dropdownView.isOpen) {
            dropdownView.panelView.focus();
            cancel();
        }
    });
    dropdownView.keystrokes.set("arrowup", (data, cancel)=>{
        if (dropdownView.isOpen) {
            dropdownView.panelView.focusLast();
            cancel();
        }
    });
}
/**
* Adds a behavior that focuses the #buttonView when the dropdown was closed but focus was within the #panelView element.
* This makes sure the focus is never lost.
*/ function $29fd27cb9bdab9d2$var$focusDropdownButtonOnClose(dropdownView) {
    dropdownView.on("change:isOpen", (evt, name, isOpen)=>{
        if (isOpen) return;
        if (dropdownView.focusTracker.elements.some((element)=>element.contains((0, $c7bc2cb7e2db0227$export$cd4e5573fbe2b576)(element)))) dropdownView.buttonView.focus();
    });
}
/**
* Adds a behavior that focuses the #panelView when dropdown gets open (accessibility).
*/ function $29fd27cb9bdab9d2$var$focusDropdownPanelOnOpen(dropdownView) {
    dropdownView.on("change:isOpen", (evt, name, isOpen)=>{
        if (!isOpen) return;
        dropdownView.panelView.focus();
    }, {
        priority: "low"
    });
}
/**
* This helper populates a dropdown list with items and groups according to the
* collection of item definitions. A permanent binding is created in this process allowing
* dynamic management of the dropdown list content.
*
* @param dropdownView
* @param listItems
* @param definitions
* @param locale
*/ function $29fd27cb9bdab9d2$var$bindViewCollectionItemsToDefinitions(dropdownView, listItems, definitions, locale) {
    $29fd27cb9bdab9d2$var$bindDropdownToggleableButtonsAlignment(listItems);
    listItems.bindTo(definitions).using((def)=>{
        if (def.type === "separator") return new $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0(locale);
        else if (def.type === "group") {
            const groupView = new $29fd27cb9bdab9d2$export$8480567bf3181a7c(locale);
            groupView.set({
                label: def.label
            });
            $29fd27cb9bdab9d2$var$bindViewCollectionItemsToDefinitions(dropdownView, groupView.items, def.items, locale);
            groupView.items.delegate("execute").to(dropdownView);
            return groupView;
        } else if (def.type === "button" || def.type === "switchbutton") {
            const isToggleable = def.model.role === "menuitemcheckbox" || def.model.role === "menuitemradio";
            const listItemView = new $29fd27cb9bdab9d2$export$41fd379e664153d8(locale);
            let buttonView;
            if (def.type === "button") {
                buttonView = new $29fd27cb9bdab9d2$export$244268489b08fe2c(locale, def.labelView);
                buttonView.set({
                    isToggleable: isToggleable
                });
            } else buttonView = new $29fd27cb9bdab9d2$export$bb3c559d00882ebd(locale);
            buttonView.bind(...Object.keys(def.model)).to(def.model);
            buttonView.delegate("execute").to(listItemView);
            listItemView.children.add(buttonView);
            return listItemView;
        }
        return null;
    });
}
/**
* Sets up alignment handling for toggleable buttons in a dropdown list.
*
* Buttons in dropdowns have reserved space for a check icon when they are toggleable.
* When at least one button in the list is toggleable, all other buttons (even non-toggleable ones)
* will have space on their left side to align with toggleable buttons.
*
* This function handles a special case where a new toggleable button is added (or removed) to a list
* where previous buttons weren't toggleable. In that case, those previous buttons will
* automatically allocate space to align with the new toggleable button.
*
* Example:
* ```
* Before adding toggleable button:
* +----------------+
* | Normal Button  |
* +----------------+
* | Another Button |
* +----------------+
*
* After adding toggleable button:
* +-------------------+
* |    Normal Button  |
* +-------------------+
* |    Another Button |
* +-------------------+
* | ✓ Toggle Button   |
* +-------------------+
* ```
*
* @param listItems Collection of list items to observe for toggleable buttons.
*/ function $29fd27cb9bdab9d2$var$bindDropdownToggleableButtonsAlignment(listItems) {
    let toggleableButtonsCount = 0;
    const pickListItemButtonIfPresent = (item)=>{
        if (!(item instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8) || !(item.children.first instanceof $29fd27cb9bdab9d2$export$244268489b08fe2c)) return null;
        return item.children.first;
    };
    const pickListItemToggleableButtonIfPresent = (item)=>{
        const listItemButtonView = pickListItemButtonIfPresent(item);
        if (!listItemButtonView || !listItemButtonView.isToggleable) return null;
        return listItemButtonView;
    };
    const updateAllButtonsCheckSpace = (hasSpace)=>{
        for (const listItem of listItems){
            const listItemButton = pickListItemButtonIfPresent(listItem);
            if (listItemButton) listItemButton.hasCheckSpace = hasSpace;
        }
    };
    listItems.on("change", (evt, data)=>{
        const prevToggleable = toggleableButtonsCount > 0;
        for (const item of data.removed)if (pickListItemToggleableButtonIfPresent(item)) toggleableButtonsCount--;
        for (const item of data.added){
            const button = pickListItemButtonIfPresent(item);
            if (!button) continue;
            if (button.isToggleable) toggleableButtonsCount++;
            button.hasCheckSpace = toggleableButtonsCount > 0;
        }
        const currentToggleable = toggleableButtonsCount > 0;
        if (prevToggleable !== currentToggleable) updateAllButtonsCheckSpace(currentToggleable);
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/labeledfield/utils
*/ /**
* A helper for creating labeled inputs.
*
* It creates an instance of a {@link module:ui/inputtext/inputtextview~InputTextView input text} that is
* logically related to a {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView labeled view} in DOM.
*
* The helper does the following:
*
* * It sets input's `id` and `ariaDescribedById` attributes.
* * It binds input's `isReadOnly` to the labeled view.
* * It binds input's `hasError` to the labeled view.
* * It enables a logic that cleans up the error when user starts typing in the input.
*
* Usage:
*
* ```ts
* const labeledInputView = new LabeledFieldView( locale, createLabeledInputText );
* console.log( labeledInputView.fieldView ); // A text input instance.
* ```
*
* @param labeledFieldView The instance of the labeled field view.
* @param viewUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#labelView labeled view's label} and the input.
* @param statusUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#statusView labeled view's status} and the input.
* @returns The input text view instance.
*/ const $29fd27cb9bdab9d2$export$549636b2b89b8342 = (labeledFieldView, viewUid, statusUid)=>{
    const inputView = new $29fd27cb9bdab9d2$export$75906a940df4ae45(labeledFieldView.locale);
    inputView.set({
        id: viewUid,
        ariaDescribedById: statusUid
    });
    inputView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (value)=>!value);
    inputView.bind("hasError").to(labeledFieldView, "errorText", (value)=>!!value);
    inputView.on("input", ()=>{
        labeledFieldView.errorText = null;
    });
    labeledFieldView.bind("isEmpty", "isFocused", "placeholder").to(inputView);
    return inputView;
};
/**
* A helper for creating labeled number inputs.
*
* It creates an instance of a {@link module:ui/inputnumber/inputnumberview~InputNumberView input number} that is
* logically related to a {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView labeled view} in DOM.
*
* The helper does the following:
*
* * It sets input's `id` and `ariaDescribedById` attributes.
* * It binds input's `isReadOnly` to the labeled view.
* * It binds input's `hasError` to the labeled view.
* * It enables a logic that cleans up the error when user starts typing in the input.
*
* Usage:
*
* ```ts
* const labeledInputView = new LabeledFieldView( locale, createLabeledInputNumber );
* console.log( labeledInputView.fieldView ); // A number input instance.
* ```
*
* @param labeledFieldView The instance of the labeled field view.
* @param viewUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#labelView labeled view's label} and the input.
* @param statusUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#statusView labeled view's status} and the input.
* @returns The input number view instance.
*/ const $29fd27cb9bdab9d2$export$616b4440975f3e79 = (labeledFieldView, viewUid, statusUid)=>{
    const inputView = new $29fd27cb9bdab9d2$export$4585c26baacfcbc7(labeledFieldView.locale);
    inputView.set({
        id: viewUid,
        ariaDescribedById: statusUid,
        inputMode: "numeric"
    });
    inputView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (value)=>!value);
    inputView.bind("hasError").to(labeledFieldView, "errorText", (value)=>!!value);
    inputView.on("input", ()=>{
        labeledFieldView.errorText = null;
    });
    labeledFieldView.bind("isEmpty", "isFocused", "placeholder").to(inputView);
    return inputView;
};
/**
* A helper for creating labeled textarea.
*
* It creates an instance of a {@link module:ui/textarea/textareaview~TextareaView textarea} that is
* logically related to a {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView labeled view} in DOM.
*
* The helper does the following:
*
* * It sets textarea's `id` and `ariaDescribedById` attributes.
* * It binds textarea's `isReadOnly` to the labeled view.
* * It binds textarea's `hasError` to the labeled view.
* * It enables a logic that cleans up the error when user starts typing in the textarea.
*
* Usage:
*
* ```ts
* const labeledTextarea = new LabeledFieldView( locale, createLabeledTextarea );
* console.log( labeledTextarea.fieldView ); // A textarea instance.
* ```
*
* @param labeledFieldView The instance of the labeled field view.
* @param viewUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#labelView labeled view's label} and the textarea.
* @param statusUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#statusView labeled view's status} and the textarea.
* @returns The textarea view instance.
*/ const $29fd27cb9bdab9d2$export$43192fc737d90525 = (labeledFieldView, viewUid, statusUid)=>{
    const textareaView = new $29fd27cb9bdab9d2$export$a04d12bdcfdada6d(labeledFieldView.locale);
    textareaView.set({
        id: viewUid,
        ariaDescribedById: statusUid
    });
    textareaView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (value)=>!value);
    textareaView.bind("hasError").to(labeledFieldView, "errorText", (value)=>!!value);
    textareaView.on("input", ()=>{
        labeledFieldView.errorText = null;
    });
    labeledFieldView.bind("isEmpty", "isFocused", "placeholder").to(textareaView);
    return textareaView;
};
/**
* A helper for creating labeled dropdowns.
*
* It creates an instance of a {@link module:ui/dropdown/dropdownview~DropdownView dropdown} that is
* logically related to a {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView labeled field view}.
*
* The helper does the following:
*
* * It sets dropdown's `id` and `ariaDescribedById` attributes.
* * It binds input's `isEnabled` to the labeled view.
*
* Usage:
*
* ```ts
* const labeledInputView = new LabeledFieldView( locale, createLabeledDropdown );
* console.log( labeledInputView.fieldView ); // A dropdown instance.
* ```
*
* @param labeledFieldView The instance of the labeled field view.
* @param viewUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#labelView labeled view label} and the dropdown.
* @param statusUid A UID string that allows DOM logical connection between the
* {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView#statusView labeled view status} and the dropdown.
* @returns The dropdown view instance.
*/ const $29fd27cb9bdab9d2$export$78775bf7bbba162f = (labeledFieldView, viewUid, statusUid)=>{
    const dropdownView = $29fd27cb9bdab9d2$export$3384a5f07adc0073(labeledFieldView.locale);
    dropdownView.set({
        id: viewUid,
        ariaDescribedById: statusUid
    });
    dropdownView.bind("isEnabled").to(labeledFieldView);
    return dropdownView;
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorpicker/colorpickerview
*/ const $29fd27cb9bdab9d2$var$waitingTime = 150;
/**
* A class which represents a color picker with an input field for defining custom colors.
*/ var $29fd27cb9bdab9d2$export$19fdfaeea7e830ad = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Container for a `#` sign prefix and an input for displaying and defining custom colors
	* in HEX format.
	*/ hexInputRow;
    /**
	* Debounced function updating the `color` property in the component
	* and firing the `ColorPickerColorSelectedEvent`. Executed whenever color in component
	* is changed by the user interaction (through the palette or input).
	*
	* @private
	*/ _debounceColorPickerEvent;
    /**
	* A reference to the configuration of the color picker specified in the constructor.
	*
	* @private
	*/ _config;
    /**
	* Creates a view of color picker.
	*
	* @param locale
	* @param config
	*/ constructor(locale, config = {}){
        super(locale);
        this.set({
            color: "",
            _hexColor: ""
        });
        this.hexInputRow = this._createInputRow();
        const children = this.createCollection();
        if (!config.hideInput) children.add(this.hexInputRow);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-color-picker"
                ],
                tabindex: -1
            },
            children: children
        });
        this._config = config;
        this._debounceColorPickerEvent = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)((color)=>{
            this.set("color", color);
            this.fire("colorSelected", {
                color: this.color
            });
        }, $29fd27cb9bdab9d2$var$waitingTime, {
            leading: true
        });
        this.on("set:color", (evt, propertyName, newValue)=>{
            evt.return = $29fd27cb9bdab9d2$export$8c7ab99396521a55(newValue, this._config.format || "hsl");
        });
        this.on("change:color", ()=>{
            this._hexColor = $29fd27cb9bdab9d2$var$convertColorToCommonHexFormat(this.color);
        });
        this.on("change:_hexColor", ()=>{
            if ((0, $c7bc2cb7e2db0227$export$cd4e5573fbe2b576)(this.picker) !== this.picker) this.picker.setAttribute("color", this._hexColor);
            if ($29fd27cb9bdab9d2$var$convertColorToCommonHexFormat(this.color) != $29fd27cb9bdab9d2$var$convertColorToCommonHexFormat(this._hexColor)) this.color = this._hexColor;
        });
    }
    /**
	* Renders color picker in the view.
	*/ render() {
        super.render();
        $29fd27cb9bdab9d2$export$4c31d2a68e32baf8("hex-color-picker", (0, $76bf0a72600f66c5$export$aac89129a4eb37b4));
        this.picker = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.createElement("hex-color-picker");
        this.picker.setAttribute("class", "hex-color-picker");
        this.picker.setAttribute("tabindex", "-1");
        this._createSlidersView();
        /* v8 ignore else -- @preserve */ if (this.element) {
            if (this.hexInputRow.element) this.element.insertBefore(this.picker, this.hexInputRow.element);
            else this.element.appendChild(this.picker);
            const styleSheetForFocusedColorPicker = document.createElement("style");
            styleSheetForFocusedColorPicker.textContent = "[role=\"slider\"]:focus [part$=\"pointer\"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}";
            this.picker.shadowRoot.appendChild(styleSheetForFocusedColorPicker);
        }
        this.picker.addEventListener("color-changed", (event)=>{
            const color = event.detail.value;
            this._debounceColorPickerEvent(color);
        });
    }
    /**
	* Focuses the first pointer in color picker.
	*
	*/ focus() {
        /* v8 ignore next -- @preserve */ if (!this._config.hideInput && ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko || (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS || (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari || (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink)) this.hexInputRow.children.get(1).focus();
        this.slidersView.first.focus();
    }
    /**
	* Creates collection of sliders in color picker.
	*
	* @private
	*/ _createSlidersView() {
        const slidersView = [
            ...this.picker.shadowRoot.children
        ].filter((item)=>item.getAttribute("role") === "slider").map((slider)=>{
            return new $29fd27cb9bdab9d2$export$cb60be91423cd1fe(slider);
        });
        this.slidersView = this.createCollection();
        slidersView.forEach((item)=>{
            this.slidersView.add(item);
        });
    }
    /**
	* Creates input row for defining custom colors in color picker.
	*
	* @private
	*/ _createInputRow() {
        const colorInput = this._createColorInput();
        return new $29fd27cb9bdab9d2$export$3076ef96c4095920(this.locale, colorInput);
    }
    /**
	* Creates the input where user can type or paste the color in hex format.
	*
	* @private
	*/ _createColorInput() {
        const labeledInput = new $29fd27cb9bdab9d2$export$698fc40b8eb40673(this.locale, $29fd27cb9bdab9d2$export$549636b2b89b8342);
        const { t: t } = this.locale;
        labeledInput.set({
            label: t("HEX"),
            class: "color-picker-hex-input"
        });
        labeledInput.fieldView.bind("value").to(this, "_hexColor", (pickerColor)=>{
            if (labeledInput.isFocused) return labeledInput.fieldView.value;
            else return pickerColor.startsWith("#") ? pickerColor.substring(1) : pickerColor;
        });
        labeledInput.fieldView.on("input", ()=>{
            const inputValue = labeledInput.fieldView.element.value;
            if (inputValue) {
                const maybeHexColor = $29fd27cb9bdab9d2$export$28291eb3f4951265(inputValue);
                if (maybeHexColor) this._debounceColorPickerEvent(maybeHexColor);
            }
        });
        return labeledInput;
    }
    /**
	* Validates the view and returns `false` when some fields are invalid.
	*/ isValid() {
        const { t: t } = this.locale;
        if (this._config.hideInput) return true;
        this.resetValidationStatus();
        if (!this.hexInputRow.getParsedColor()) {
            this.hexInputRow.inputView.errorText = t("Please enter a valid color (e.g. \"ff0000\").");
            return false;
        }
        return true;
    }
    /**
	* Cleans up the supplementary error and information text of input inside the {@link #hexInputRow}
	* bringing them back to the state when the form has been displayed for the first time.
	*
	* See {@link #isValid}.
	*/ resetValidationStatus() {
        this.hexInputRow.inputView.errorText = null;
    }
};
function $29fd27cb9bdab9d2$var$convertColorToCommonHexFormat(inputColor) {
    let ret = $29fd27cb9bdab9d2$export$39c36f794e3b729b(inputColor);
    if (!ret) ret = "#000";
    if (ret.length === 4) ret = "#" + [
        ret[1],
        ret[1],
        ret[2],
        ret[2],
        ret[3],
        ret[3]
    ].join("");
    return ret.toLowerCase();
}
var $29fd27cb9bdab9d2$export$cb60be91423cd1fe = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @param element HTML element of slider in color picker.
	*/ constructor(element){
        super();
        this.element = element;
    }
    /**
	* Focuses element.
	*/ focus() {
        this.element.focus();
    }
};
var $29fd27cb9bdab9d2$var$HashView = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    constructor(locale){
        super(locale);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-color-picker__hash-view"
                ]
            },
            children: "#"
        });
    }
};
var $29fd27cb9bdab9d2$export$3076ef96c4095920 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of row items (buttons, dropdowns, etc.).
	*/ children;
    /**
	* Hex input view element.
	*/ inputView;
    /**
	* Creates an instance of the form row class.
	*
	* @param locale The locale instance.
	* @param inputView Hex color input element.
	*/ constructor(locale, inputView){
        super(locale);
        this.inputView = inputView;
        this.children = this.createCollection([
            new $29fd27cb9bdab9d2$var$HashView(),
            this.inputView
        ]);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-color-picker__row"
                ]
            },
            children: this.children
        });
    }
    /**
	* Returns false if color input value is not in hex format.
	*/ getParsedColor() {
        return $29fd27cb9bdab9d2$export$28291eb3f4951265(this.inputView.fieldView.element.value);
    }
};
/**
* Trim spaces from provided color and check if hex is valid.
*
* @param color Unsafe color string.
* @returns Null if provided color is not hex value.
* @export
* @internal
*/ function $29fd27cb9bdab9d2$export$28291eb3f4951265(color) {
    if (!color) return null;
    const hashLessColor = color.trim().replace(/^#/, "");
    if (![
        3,
        4,
        6,
        8
    ].includes(hashLessColor.length)) return null;
    if (!/^(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})$/.test(hashLessColor)) return null;
    return `#${hashLessColor}`;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $29fd27cb9bdab9d2$var$DocumentColorCollectionBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)((0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec));
/**
* A collection to store document colors. It enforces colors to be unique.
*/ var $29fd27cb9bdab9d2$export$fa050755dd1f9b19 = class extends $29fd27cb9bdab9d2$var$DocumentColorCollectionBase {
    constructor(options){
        super(options);
        this.set("isEmpty", true);
        this.on("change", ()=>{
            this.set("isEmpty", this.length === 0);
        });
    }
    /**
	* Adds a color to the document color collection.
	*
	* This method ensures that no color duplicates are inserted (compared using
	* the color value of the {@link module:ui/colorgrid/colorgridview~ColorDefinition}).
	*
	* If the item does not have an ID, it will be automatically generated and set on the item.
	*
	* @param index The position of the item in the collection. The item is pushed to the collection when `index` is not specified.
	* @fires add
	* @fires change
	*/ add(item, index) {
        if (this.find((element)=>element.color === item.color)) return this;
        return super.add(item, index);
    }
    /**
	* Checks if an object with given colors is present in the document color collection.
	*/ hasColor(color) {
        return !!this.find((item)=>item.color === color);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorselector/colorgridsfragmentview
*/ /**
* One of the fragments of {@link module:ui/colorselector/colorselectorview~ColorSelectorView}.
*
* It provides a UI that allows users to select colors from the a predefined set and from existing document colors.
*
* It consists of the following sub–components:
*
* * A "Remove color" button,
* * A static {@link module:ui/colorgrid/colorgridview~ColorGridView} of colors defined in the configuration,
* * A dynamic {@link module:ui/colorgrid/colorgridview~ColorGridView} of colors used in the document.
* * If color picker is configured, the "Color Picker" button is visible too.
*/ var $29fd27cb9bdab9d2$export$cd71ff558e41ab6a = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of the children of the table.
	*/ items;
    /**
	* An array with objects representing colors to be displayed in the grid.
	*/ colorDefinitions;
    /**
	* Tracks information about the DOM focus in the list.
	*/ focusTracker;
    /**
	* The number of columns in the color grid.
	*/ columns;
    /**
	* Preserves the reference to {@link module:ui/colorselector/documentcolorcollection~DocumentColorCollection} used to collect
	* definitions that store the document colors.
	*
	* @readonly
	*/ documentColors;
    /**
	* The maximum number of colors in the document colors section.
	* If it equals 0, the document colors section is not added.
	*
	* @readonly
	*/ documentColorsCount;
    /**
	* Preserves the reference to {@link module:ui/colorgrid/colorgridview~ColorGridView} used to create
	* the default (static) color set.
	*
	* The property is loaded once the the parent dropdown is opened the first time.
	*
	* @readonly
	*/ staticColorsGrid;
    /**
	* Preserves the reference to {@link module:ui/colorgrid/colorgridview~ColorGridView} used to create
	* the document colors. It remains undefined if the document colors feature is disabled.
	*
	* The property is loaded once the the parent dropdown is opened the first time.
	*
	* @readonly
	*/ documentColorsGrid;
    /**
	* The "Color picker" button view.
	*/ colorPickerButtonView;
    /**
	* The "Remove color" button view.
	*/ removeColorButtonView;
    /**
	* A collection of views that can be focused in the view.
	*
	* @readonly
	*/ _focusables;
    /**
	* Document color section's label.
	*
	* @readonly
	*/ _documentColorsLabel;
    /**
	* The label of the button responsible for removing color attributes.
	*/ _removeButtonLabel;
    /**
	* The label of the button responsible for switching to the color picker component.
	*/ _colorPickerLabel;
    /**
	* Creates an instance of the view.
	*
	* @param locale The localization services instance.
	* @param options Constructor options.
	* @param options.colors An array with definitions of colors to be displayed in the table.
	* @param options.columns The number of columns in the color grid.
	* @param options.removeButtonLabel The label of the button responsible for removing the color.
	* @param options.colorPickerLabel The label of the button responsible for color picker appearing.
	* @param options.documentColorsLabel The label for the section with the document colors.
	* @param options.documentColorsCount The number of colors in the document colors section inside the color dropdown.
	* @param options.focusTracker Tracks information about the DOM focus in the list.
	* @param options.focusables A collection of views that can be focused in the view.
	*/ constructor(locale, { colors: colors, columns: columns, removeButtonLabel: removeButtonLabel, documentColorsLabel: documentColorsLabel, documentColorsCount: documentColorsCount, colorPickerLabel: colorPickerLabel, focusTracker: focusTracker, focusables: focusables }){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isVisible", true);
        this.focusTracker = focusTracker;
        this.items = this.createCollection();
        this.colorDefinitions = colors;
        this.columns = columns;
        this.documentColors = new $29fd27cb9bdab9d2$export$fa050755dd1f9b19();
        this.documentColorsCount = documentColorsCount;
        this._focusables = focusables;
        this._removeButtonLabel = removeButtonLabel;
        this._colorPickerLabel = colorPickerLabel;
        this._documentColorsLabel = documentColorsLabel;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck-color-grids-fragment",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            },
            children: this.items
        });
        this.removeColorButtonView = this._createRemoveColorButton();
        this.items.add(this.removeColorButtonView);
    }
    /**
	* Scans through the editor model and searches for text node attributes with the given attribute name.
	* Found entries are set as document colors.
	*
	* All the previously stored document colors will be lost in the process.
	*
	* @param model The model used as a source to obtain the document colors.
	* @param attributeName Determines the name of the related model's attribute for a given dropdown.
	*/ updateDocumentColors(model, attributeName) {
        const document1 = model.document;
        const maxCount = this.documentColorsCount;
        this.documentColors.clear();
        for (const root of document1.getRoots()){
            const range = model.createRangeIn(root);
            for (const node of range.getItems())if (node.is("$textProxy") && node.hasAttribute(attributeName)) {
                this._addColorToDocumentColors(node.getAttribute(attributeName));
                if (this.documentColors.length >= maxCount) return;
            }
        }
    }
    /**
	* Refreshes the state of the selected color in one or both {@link module:ui/colorgrid/colorgridview~ColorGridView}s
	* available in the {@link module:ui/colorselector/colorselectorview~ColorSelectorView}. It guarantees that the selection will
	* occur only in one of them.
	*/ updateSelectedColors() {
        const documentColorsGrid = this.documentColorsGrid;
        const staticColorsGrid = this.staticColorsGrid;
        const selectedColor = this.selectedColor;
        staticColorsGrid.selectedColor = selectedColor;
        if (documentColorsGrid) documentColorsGrid.selectedColor = selectedColor;
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.staticColorsGrid = this._createStaticColorsGrid();
        this.items.add(this.staticColorsGrid);
        if (this.documentColorsCount) {
            const bind = $29fd27cb9bdab9d2$export$14416b8d99d47caa.bind(this.documentColors, this.documentColors);
            const label = new $29fd27cb9bdab9d2$export$27a5bd065ad55220(this.locale);
            label.setTemplate({
                tag: "span",
                attributes: {
                    class: [
                        "ck",
                        "ck-color-grid__label",
                        bind.if("isEmpty", "ck-hidden")
                    ]
                },
                children: [
                    {
                        text: this._documentColorsLabel
                    }
                ]
            });
            this.items.add(label);
            this.documentColorsGrid = this._createDocumentColorsGrid();
            this.items.add(this.documentColorsGrid);
        }
        this._createColorPickerButton();
        this._addColorSelectorElementsToFocusTracker();
    }
    /**
	* Focuses the component.
	*/ focus() {
        this.removeColorButtonView.focus();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
    }
    /**
	* Handles displaying the color picker button (if it was previously created) and making it focusable.
	*/ addColorPickerButton() {
        if (this.colorPickerButtonView) {
            this.items.add(this.colorPickerButtonView);
            this.focusTracker.add(this.colorPickerButtonView.element);
            this._focusables.add(this.colorPickerButtonView);
        }
    }
    /**
	* Adds color selector elements to focus tracker.
	*/ _addColorSelectorElementsToFocusTracker() {
        this.focusTracker.add(this.removeColorButtonView.element);
        this._focusables.add(this.removeColorButtonView);
        /* v8 ignore else -- @preserve */ if (this.staticColorsGrid) {
            this.focusTracker.add(this.staticColorsGrid.element);
            this._focusables.add(this.staticColorsGrid);
        }
        if (this.documentColorsGrid) {
            this.focusTracker.add(this.documentColorsGrid.element);
            this._focusables.add(this.documentColorsGrid);
        }
    }
    /**
	* Creates the button responsible for displaying the color picker component.
	*/ _createColorPickerButton() {
        this.colorPickerButtonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa();
        this.colorPickerButtonView.set({
            label: this._colorPickerLabel,
            withText: true,
            icon: (0, $e8dc502aba5ac3f5$export$7083423a6e6e029e),
            class: "ck-color-selector__color-picker"
        });
        this.colorPickerButtonView.on("execute", ()=>{
            this.fire("colorPicker:show");
        });
    }
    /**
	* Adds the remove color button as a child of the current view.
	*/ _createRemoveColorButton() {
        const buttonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa();
        buttonView.set({
            withText: true,
            icon: (0, $e8dc502aba5ac3f5$export$6ce1521e49717004),
            label: this._removeButtonLabel
        });
        buttonView.class = "ck-color-selector__remove-color";
        buttonView.on("execute", ()=>{
            this.fire("execute", {
                value: null,
                source: "removeColorButton"
            });
        });
        buttonView.render();
        return buttonView;
    }
    /**
	* Creates a static color grid based on the editor configuration.
	*/ _createStaticColorsGrid() {
        const colorGrid = new $29fd27cb9bdab9d2$export$bc40329c0ccad25a(this.locale, {
            colorDefinitions: this.colorDefinitions,
            columns: this.columns
        });
        colorGrid.on("execute", (evt, data)=>{
            this.fire("execute", {
                value: data.value,
                source: "staticColorsGrid"
            });
        });
        return colorGrid;
    }
    /**
	* Creates the document colors section view and binds it to {@link #documentColors}.
	*/ _createDocumentColorsGrid() {
        const bind = $29fd27cb9bdab9d2$export$14416b8d99d47caa.bind(this.documentColors, this.documentColors);
        const documentColorsGrid = new $29fd27cb9bdab9d2$export$bc40329c0ccad25a(this.locale, {
            columns: this.columns
        });
        documentColorsGrid.extendTemplate({
            attributes: {
                class: bind.if("isEmpty", "ck-hidden")
            }
        });
        documentColorsGrid.items.bindTo(this.documentColors).using((colorObj)=>{
            const colorTile = new $29fd27cb9bdab9d2$export$bc9cd5ed02964426();
            colorTile.set({
                color: colorObj.color,
                hasBorder: colorObj.options?.hasBorder
            });
            if (colorObj.label) colorTile.set({
                label: colorObj.label,
                tooltip: true
            });
            colorTile.on("execute", ()=>{
                this.fire("execute", {
                    value: colorObj.color,
                    source: "documentColorsGrid"
                });
            });
            return colorTile;
        });
        this.documentColors.on("change:isEmpty", (evt, name, val)=>{
            if (val) documentColorsGrid.selectedColor = null;
        });
        return documentColorsGrid;
    }
    /**
	* Adds a given color to the document colors list. If possible, the method will attempt to use
	* data from the {@link #colorDefinitions} (label, color options).
	*
	* @param color A string that stores the value of the recently applied color.
	*/ _addColorToDocumentColors(color) {
        const predefinedColor = this.colorDefinitions.find((definition)=>definition.color === color);
        if (!predefinedColor) this.documentColors.add({
            color: color,
            label: color,
            options: {
                hasBorder: false
            }
        });
        else this.documentColors.add(Object.assign({}, predefinedColor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorselector/colorpickerfragmentview
*/ /**
* One of the fragments of {@link module:ui/colorselector/colorselectorview~ColorSelectorView}.
*
* It allows users to select a color from a color picker.
*
* It consists of the following sub–components:
*
* * A color picker saturation and hue sliders,
* * A text input accepting colors in HEX format,
* * "Save" and "Cancel" action buttons.
*/ var $29fd27cb9bdab9d2$export$471e78eaef4b42b4 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of component's children.
	*/ items;
    /**
	* A view with saturation and hue sliders and color input.
	*/ colorPickerView;
    /**
	* The "Save" button view.
	*/ saveButtonView;
    /**
	* The "Cancel" button view.
	*/ cancelButtonView;
    /**
	* The action bar where are "Save" button and "Cancel" button.
	*/ actionBarView;
    /**
	* Tracks information about the DOM focus in the list.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of views that can be focused in the view.
	*
	* @readonly
	*/ _focusables;
    /**
	* A reference to the configuration of {@link #colorPickerView}. `false` when the view was
	* configured without a color picker.
	*
	* @readonly
	*/ _colorPickerViewConfig;
    /**
	* Creates an instance of the view.
	*
	* @param locale The localization services instance.
	* @param options Constructor options.
	* @param options.focusTracker Tracks information about the DOM focus in the list.
	* @param options.focusables A collection of views that can be focused in the view.
	* @param options.keystrokes An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	* @param options.colorPickerViewConfig The configuration of color picker feature. If set to `false`, the color picker
	* will not be rendered.
	*/ constructor(locale, { focusTracker: focusTracker, focusables: focusables, keystrokes: keystrokes, colorPickerViewConfig: colorPickerViewConfig }){
        super(locale);
        this.items = this.createCollection();
        this.focusTracker = focusTracker;
        this.keystrokes = keystrokes;
        this.set("isVisible", false);
        this.set("selectedColor", void 0);
        this._focusables = focusables;
        this._colorPickerViewConfig = colorPickerViewConfig;
        const bind = this.bindTemplate;
        const { saveButtonView: saveButtonView, cancelButtonView: cancelButtonView } = this._createActionButtons();
        this.saveButtonView = saveButtonView;
        this.cancelButtonView = cancelButtonView;
        this.actionBarView = this._createActionBarView({
            saveButtonView: saveButtonView,
            cancelButtonView: cancelButtonView
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck-color-picker-fragment",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            },
            children: this.items
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        const colorPickerView = new $29fd27cb9bdab9d2$export$19fdfaeea7e830ad(this.locale, {
            ...this._colorPickerViewConfig
        });
        this.colorPickerView = colorPickerView;
        this.colorPickerView.render();
        if (this.selectedColor) colorPickerView.color = this.selectedColor;
        this.listenTo(this, "change:selectedColor", (evt, name, value)=>{
            colorPickerView.color = value;
        });
        this.items.add(this.colorPickerView);
        this.items.add(this.actionBarView);
        this._addColorPickersElementsToFocusTracker();
        this._stopPropagationOnArrowsKeys();
        this._executeOnEnterPress();
        this._executeUponColorChange();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
    }
    /**
	* Focuses the color picker.
	*/ focus() {
        this.colorPickerView.focus();
    }
    /**
	* Reset validation messages.
	*/ resetValidationStatus() {
        this.colorPickerView.resetValidationStatus();
    }
    /**
	* When color picker is focused and "enter" is pressed it executes command.
	*/ _executeOnEnterPress() {
        this.keystrokes.set("enter", (evt)=>{
            if (this.isVisible && this.focusTracker.focusedElement !== this.cancelButtonView.element && this.colorPickerView.isValid()) {
                this.fire("execute", {
                    value: this.selectedColor
                });
                evt.stopPropagation();
                evt.preventDefault();
            }
        });
    }
    /**
	* Removes default behavior of arrow keys in dropdown.
	*/ _stopPropagationOnArrowsKeys() {
        const stopPropagation = (data)=>data.stopPropagation();
        this.keystrokes.set("arrowright", stopPropagation);
        this.keystrokes.set("arrowleft", stopPropagation);
        this.keystrokes.set("arrowup", stopPropagation);
        this.keystrokes.set("arrowdown", stopPropagation);
    }
    /**
	* Adds color picker elements to focus tracker.
	*/ _addColorPickersElementsToFocusTracker() {
        for (const slider of this.colorPickerView.slidersView){
            this.focusTracker.add(slider.element);
            this._focusables.add(slider);
        }
        const input = this.colorPickerView.hexInputRow.children.get(1);
        if (input.element) {
            this.focusTracker.add(input.element);
            this._focusables.add(input);
        }
        this.focusTracker.add(this.saveButtonView.element);
        this._focusables.add(this.saveButtonView);
        this.focusTracker.add(this.cancelButtonView.element);
        this._focusables.add(this.cancelButtonView);
    }
    /**
	* Creates bar containing "Save" and "Cancel" buttons.
	*/ _createActionBarView({ saveButtonView: saveButtonView, cancelButtonView: cancelButtonView }) {
        const actionBarRow = new $29fd27cb9bdab9d2$export$27a5bd065ad55220();
        const children = this.createCollection();
        children.add(saveButtonView);
        children.add(cancelButtonView);
        actionBarRow.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-color-selector_action-bar"
                ]
            },
            children: children
        });
        return actionBarRow;
    }
    /**
	* Creates "Save" and "Cancel" buttons.
	*/ _createActionButtons() {
        const locale = this.locale;
        const t = locale.t;
        const saveButtonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(locale);
        const cancelButtonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(locale);
        saveButtonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$41713cd023818a26),
            class: "ck-button-save",
            type: "button",
            withText: false,
            label: t("Accept")
        });
        cancelButtonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$6102dea6073ecfc0),
            class: "ck-button-cancel",
            type: "button",
            withText: false,
            label: t("Cancel")
        });
        saveButtonView.on("execute", ()=>{
            if (this.colorPickerView.isValid()) this.fire("execute", {
                source: "colorPickerSaveButton",
                value: this.selectedColor
            });
        });
        cancelButtonView.on("execute", ()=>{
            this.fire("colorPicker:cancel");
        });
        return {
            saveButtonView: saveButtonView,
            cancelButtonView: cancelButtonView
        };
    }
    /**
	* Fires the `execute` event if color in color picker has been changed
	* by the user.
	*/ _executeUponColorChange() {
        this.colorPickerView.on("colorSelected", (evt, data)=>{
            this.fire("execute", {
                value: data.color,
                source: "colorPicker"
            });
            this.set("selectedColor", data.color);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/colorselector/colorselectorview
*/ /**
* The configurable color selector view class. It allows users to select colors from a predefined set of colors as well as from
* a color picker.
*
* This meta-view is is made of two components (fragments):
*
* * {@link module:ui/colorselector/colorselectorview~ColorSelectorView#colorGridsFragmentView},
* * {@link module:ui/colorselector/colorselectorview~ColorSelectorView#colorPickerFragmentView}.
*
* ```ts
* const colorDefinitions = [
* 	{ color: '#000', label: 'Black', options: { hasBorder: false } },
* 	{ color: 'rgb(255, 255, 255)', label: 'White', options: { hasBorder: true } },
* 	{ color: 'red', label: 'Red', options: { hasBorder: false } }
* ];
*
* const selectorView = new ColorSelectorView( locale, {
* 	colors: colorDefinitions,
* 	columns: 5,
* 	removeButtonLabel: 'Remove color',
* 	documentColorsLabel: 'Document colors',
* 	documentColorsCount: 4,
* 	colorPickerViewConfig: {
* 		format: 'hsl'
* 	}
* } );
*
* selectorView.appendUI();
* selectorView.selectedColor = 'red';
* selectorView.updateSelectedColors();
*
* selectorView.on<ColorSelectorExecuteEvent>( 'execute', ( evt, data ) => {
* 	console.log( 'Color changed', data.value, data.source );
* } );
*
* selectorView.on<ColorSelectorColorPickerShowEvent>( 'colorPicker:show', ( evt ) => {
* 	console.log( 'Color picker showed up', evt );
* } );
*
* selectorView.on<ColorSelectorColorPickerCancelEvent>( 'colorPicker:cancel', ( evt ) => {
* 	console.log( 'Color picker cancel', evt );
* } );
*
* selectorView.render();
*
* document.body.appendChild( selectorView.element );
* ```
*/ var $29fd27cb9bdab9d2$export$840fffd5af8d58e0 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Tracks information about the DOM focus in the list.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of components.
	*/ items;
    /**
	* A fragment that allows users to select colors from the a predefined set and from existing document colors.
	*/ colorGridsFragmentView;
    /**
	* A fragment that allows users to select a color from a color picker.
	*/ colorPickerFragmentView;
    /**
	* Helps cycling over focusable {@link #items} in the list.
	*
	* @readonly
	*/ _focusCycler;
    /**
	* A collection of views that can be focused in the view.
	*
	* @readonly
	*/ _focusables;
    /**
	* The configuration of color picker sub-component.
	*/ _colorPickerViewConfig;
    /**
	* Creates a view to be inserted as a child of {@link module:ui/dropdown/dropdownview~DropdownView}.
	*
	* @param locale The localization services instance.
	* @param options Constructor options.
	* @param options.colors An array with definitions of colors to be displayed in the table.
	* @param options.columns The number of columns in the color grid.
	* @param options.removeButtonLabel The label of the button responsible for removing the color.
	* @param options.colorPickerLabel The label of the button responsible for color picker appearing.
	* @param options.documentColorsLabel The label for the section with the document colors.
	* @param options.documentColorsCount The number of colors in the document colors section inside the color dropdown.
	* @param options.colorPickerViewConfig The configuration of color picker feature. If set to `false`, the color picker will be hidden.
	*/ constructor(locale, { colors: colors, columns: columns, removeButtonLabel: removeButtonLabel, documentColorsLabel: documentColorsLabel, documentColorsCount: documentColorsCount, colorPickerLabel: colorPickerLabel, colorPickerViewConfig: colorPickerViewConfig }){
        super(locale);
        if (colorPickerViewConfig && (0, $c7bc2cb7e2db0227$export$d5ff8d8a62c25e80)()) {
            /**
			* The color picker is not available, because the application enforces Trusted Types with the
			* `require-trusted-types-for 'script'` CSP directive. The color picker cannot be rendered under that
			* directive, so the editor turns it off.
			*
			* The color palettes and the document colors are not affected. To turn the color picker off yourself, and
			* stop this warning, set the `colorPicker` option of the feature to `false`.
			*
			* For a detailed overview, check the {@glink getting-started/setup/csp#known-limitations Content Security
			* Policy} guide.
			*
			* @error color-picker-unavailable-with-trusted-types
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("color-picker-unavailable-with-trusted-types");
            colorPickerViewConfig = false;
        }
        this.items = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusables = new $29fd27cb9bdab9d2$export$ff20b327de53fba7();
        this._colorPickerViewConfig = colorPickerViewConfig;
        this._focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.colorGridsFragmentView = new $29fd27cb9bdab9d2$export$cd71ff558e41ab6a(locale, {
            colors: colors,
            columns: columns,
            removeButtonLabel: removeButtonLabel,
            documentColorsLabel: documentColorsLabel,
            documentColorsCount: documentColorsCount,
            colorPickerLabel: colorPickerLabel,
            focusTracker: this.focusTracker,
            focusables: this._focusables
        });
        this.colorPickerFragmentView = new $29fd27cb9bdab9d2$export$471e78eaef4b42b4(locale, {
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokes: this.keystrokes,
            colorPickerViewConfig: colorPickerViewConfig
        });
        this.set("_isColorGridsFragmentVisible", true);
        this.set("_isColorPickerFragmentVisible", false);
        this.set("selectedColor", void 0);
        this.colorGridsFragmentView.bind("isVisible").to(this, "_isColorGridsFragmentVisible");
        this.colorPickerFragmentView.bind("isVisible").to(this, "_isColorPickerFragmentVisible");
        /**
		* This is kind of bindings. Unfortunately we could not use this.bind() method because the same property
		* cannot be bound twice. So this is work around how to bind 'selectedColor' property between components.
		*/ this.on("change:selectedColor", (evt, evtName, data)=>{
            this.colorGridsFragmentView.set("selectedColor", data);
            this.colorPickerFragmentView.set("selectedColor", data);
        });
        this.colorGridsFragmentView.on("change:selectedColor", (evt, evtName, data)=>{
            this.set("selectedColor", data);
        });
        this.colorPickerFragmentView.on("change:selectedColor", (evt, evtName, data)=>{
            this.set("selectedColor", data);
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-color-selector"
                ]
            },
            children: this.items
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Renders the internals of the component on demand:
	* * {@link #colorPickerFragmentView},
	* * {@link #colorGridsFragmentView}.
	*
	* It allows for deferring component initialization to improve the performance.
	*
	* See {@link #showColorPickerFragment}, {@link #showColorGridsFragment}.
	*/ appendUI() {
        this._appendColorGridsFragment();
        if (this._colorPickerViewConfig) this._appendColorPickerFragment();
    }
    /**
	* Shows the {@link #colorPickerFragmentView} and hides the {@link #colorGridsFragmentView}.
	*
	* **Note**: It requires {@link #appendUI} to be called first.
	*
	* See {@link #showColorGridsFragment}, {@link ~ColorSelectorView#event:colorPicker:show}.
	*/ showColorPickerFragment() {
        if (!this.colorPickerFragmentView.colorPickerView || this._isColorPickerFragmentVisible) return;
        this._isColorPickerFragmentVisible = true;
        this.colorPickerFragmentView.focus();
        this.colorPickerFragmentView.resetValidationStatus();
        this._isColorGridsFragmentVisible = false;
    }
    /**
	* Shows the {@link #colorGridsFragmentView} and hides the {@link #colorPickerFragmentView}.
	*
	* See {@link #showColorPickerFragment}.
	*
	* **Note**: It requires {@link #appendUI} to be called first.
	*/ showColorGridsFragment() {
        if (this._isColorGridsFragmentVisible) return;
        this._isColorGridsFragmentVisible = true;
        this.colorGridsFragmentView.focus();
        this._isColorPickerFragmentVisible = false;
    }
    /**
	* Focuses the first focusable element in {@link #items}.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the last focusable element in {@link #items}.
	*/ focusLast() {
        this._focusCycler.focusLast();
    }
    /**
	* Scans through the editor model and searches for text node attributes with the given `attributeName`.
	* Found entries are set as document colors in {@link #colorGridsFragmentView}.
	*
	* All the previously stored document colors will be lost in the process.
	*
	* @param model The model used as a source to obtain the document colors.
	* @param attributeName Determines the name of the related model's attribute for a given dropdown.
	*/ updateDocumentColors(model, attributeName) {
        this.colorGridsFragmentView.updateDocumentColors(model, attributeName);
    }
    /**
	* Refreshes the state of the selected color in one or both grids located in {@link #colorGridsFragmentView}.
	*
	* It guarantees that the selection will occur only in one of them.
	*/ updateSelectedColors() {
        this.colorGridsFragmentView.updateSelectedColors();
    }
    /**
	* Appends the view containing static and document color grid views.
	*/ _appendColorGridsFragment() {
        if (this.items.length) return;
        this.items.add(this.colorGridsFragmentView);
        this.colorGridsFragmentView.delegate("execute").to(this);
        this.colorGridsFragmentView.delegate("colorPicker:show").to(this);
    }
    /**
	* Appends the view with the color picker.
	*/ _appendColorPickerFragment() {
        if (this.items.length === 2) return;
        this.items.add(this.colorPickerFragmentView);
        if (this.colorGridsFragmentView.colorPickerButtonView) this.colorGridsFragmentView.colorPickerButtonView.on("execute", ()=>{
            this.showColorPickerFragment();
        });
        this.colorGridsFragmentView.addColorPickerButton();
        this.colorPickerFragmentView.delegate("execute").to(this);
        this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/componentfactory
*/ /**
* A helper class implementing the UI component ({@link module:ui/view~View view}) factory.
*
* It allows functions producing specific UI components to be registered under their unique names
* in the factory. A registered component can be then instantiated by providing its name.
* Note that the names are case insensitive.
*
* ```ts
* // The editor provides localization tools for the factory.
* const factory = new ComponentFactory( editor );
*
* factory.add( 'foo', locale => new FooView( locale ) );
* factory.add( 'bar', locale => new BarView( locale ) );
*
* // An instance of FooView.
* const fooInstance = factory.create( 'foo' );
*
* // Names are case insensitive so this is also allowed:
* const barInstance = factory.create( 'Bar' );
* ```
*
* The {@link module:core/editor/editor~Editor#locale editor locale} is passed to the factory
* function when {@link module:ui/componentfactory~ComponentFactory#create} is called.
*/ var $29fd27cb9bdab9d2$export$27c285552589054d = class {
    /**
	* The editor instance that the factory belongs to.
	*/ editor;
    /**
	* Registered component factories.
	*/ _components = /* @__PURE__ */ new Map();
    /**
	* Creates an instance of the factory.
	*
	* @param editor The editor instance.
	*/ constructor(editor){
        this.editor = editor;
    }
    /**
	* Returns an iterator of registered component names. Names are returned in lower case.
	*/ *names() {
        for (const value of this._components.values())yield value.originalName;
    }
    /**
	* Registers a component factory function that will be used by the
	* {@link #create create} method and called with the
	* {@link module:core/editor/editor~Editor#locale editor locale} as an argument,
	* allowing localization of the {@link module:ui/view~View view}.
	*
	* @param name The name of the component.
	* @param callback The callback that returns the component.
	*/ add(name, callback) {
        this._components.set($29fd27cb9bdab9d2$var$getNormalized(name), {
            callback: callback,
            originalName: name
        });
    }
    /**
	* Creates an instance of a component registered in the factory under a specific name.
	*
	* When called, the {@link module:core/editor/editor~Editor#locale editor locale} is passed to
	* the previously {@link #add added} factory function, allowing localization of the
	* {@link module:ui/view~View view}.
	*
	* @param name The name of the component.
	* @returns The instantiated component view.
	*/ create(name) {
        if (!this.has(name)) /**
		* The required component is not registered in the component factory. Please make sure
		* the provided name is correct and the component has been correctly
		* {@link module:ui/componentfactory~ComponentFactory#add added} to the factory.
		*
		* @error componentfactory-item-missing
		* @param {string} name The name of the missing component.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("componentfactory-item-missing", this, {
            name: name
        });
        return this._components.get($29fd27cb9bdab9d2$var$getNormalized(name)).callback(this.editor.locale);
    }
    /**
	* Checks if a component of a given name is registered in the factory.
	*
	* @param name The name of the component.
	*/ has(name) {
        return this._components.has($29fd27cb9bdab9d2$var$getNormalized(name));
    }
};
/**
* Ensures that the component name used as the key in the internal map is in lower case.
*/ function $29fd27cb9bdab9d2$var$getNormalized(name) {
    return String(name).toLowerCase();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/tooltipmanager
*/ const $29fd27cb9bdab9d2$var$BALLOON_CLASS = "ck-tooltip";
const $29fd27cb9bdab9d2$var$TooltipManagerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)();
/**
* A tooltip manager class for the UI of the editor.
*
* **Note**: Most likely you do not have to use the `TooltipManager` API listed below in order to display tooltips. Popular
* {@glink framework/architecture/ui-library UI components} support tooltips out-of-the-box via observable properties
* (see {@link module:ui/button/buttonview~ButtonView#tooltip} and {@link module:ui/button/buttonview~ButtonView#tooltipPosition}).
*
* # Displaying tooltips
*
* To display a tooltip, set `data-cke-tooltip-text` attribute on any DOM element:
*
* ```ts
* domElement.dataset.ckeTooltipText = 'My tooltip';
* ```
*
* The tooltip will show up whenever the user moves the mouse over the element or the element gets focus in DOM.
*
* # Positioning tooltips
*
* To change the position of the tooltip, use the `data-cke-tooltip-position` attribute (`s`, `se`, `sw`, `n`, `e`, or `w`):
*
* ```ts
* domElement.dataset.ckeTooltipText = 'Tooltip to the north';
* domElement.dataset.ckeTooltipPosition = 'n';
* ```
*
* # Disabling tooltips
*
* In order to disable the tooltip temporarily, use the `data-cke-tooltip-disabled` attribute:
*
* ```ts
* domElement.dataset.ckeTooltipText = 'Disabled. For now.';
* domElement.dataset.ckeTooltipDisabled = 'true';
* ```
*
* # Instant tooltips
*
* To remove the delay before showing or hiding the tooltip, use the `data-cke-tooltip-instant` attribute:
*
* ```ts
* domElement.dataset.ckeTooltipInstant = 'true';
* ```
*
* # Styling tooltips
*
* By default, the tooltip has `.ck-tooltip` class and its text inner `.ck-tooltip__text`.
*
* If your tooltip requires custom styling, using `data-cke-tooltip-class` attribute will add additional class to the balloon
* displaying the tooltip:
*
* ```ts
* domElement.dataset.ckeTooltipText = 'Tooltip with a red text';
* domElement.dataset.ckeTooltipClass = 'my-class';
* ```
*
* ```css
* .ck.ck-tooltip.my-class { color: red }
* ```
*
* **Note**: This class is a singleton. All editor instances re-use the same instance loaded by
* {@link module:ui/editorui/editorui~EditorUI} of the first editor.
*/ var $29fd27cb9bdab9d2$export$3cf29e47efa41626 = class TooltipManager extends $29fd27cb9bdab9d2$var$TooltipManagerBase {
    /**
	* The view rendering text of the tooltip.
	*/ tooltipTextView;
    /**
	* The instance of the balloon panel that renders and positions the tooltip.
	*/ balloonPanelView;
    /**
	* A set of default {@link module:utils/dom/position~PositioningFunction positioning functions} used by the `TooltipManager`
	* to pin tooltips in different positions.
	*/ static defaultBalloonPositions = /* #__PURE__ */ $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c.generatePositions({
        heightOffset: 5,
        sideOffset: 13
    });
    /**
	* Stores the reference to the DOM element the tooltip is attached to. `null` when there's no tooltip
	* in the UI.
	*/ _currentElementWithTooltip = null;
    /**
	* Stores the current tooltip position. `null` when there's no tooltip in the UI.
	*/ _currentTooltipPosition = null;
    /**
	* An instance of the mutation observer that keeps track on target element attributes changes.
	*/ _mutationObserver = null;
    /**
	* A debounced version of {@link #_pinTooltip}. Tooltips show with a delay to avoid flashing and
	* to improve the UX.
	*/ _pinTooltipDebounced;
    /**
	* A debounced version of {@link #_unpinTooltip}. Tooltips hide with a delay to allow hovering of their titles.
	*/ _unpinTooltipDebounced;
    /**
	* Shadow roots the manager currently has listeners attached to.
	*/ _shadowRoots = /* @__PURE__ */ new Set();
    /**
	* Maps each DOM tree (the document or a shadow root) that hosts tooltip-bearing UI to the body collection
	* the shared tooltip balloon should be pinned into for targets in that tree. Rebuilt from
	* {@link module:ui/tooltipmanager~TooltipManager._registrations} by {@link #_rebuild}.
	*/ _bodyCollectionByTree = /* @__PURE__ */ new Map();
    _watchdogExcluded;
    /**
	* The number of holders (editors and features) currently using the singleton, so it is destroyed only when
	* the last one {@link #release releases} it.
	*/ _refCount = 0;
    /**
	* A reference to the `TooltipManager` instance. The class is a singleton and as such,
	* successive attempts at creating instances should return this instance.
	*/ static _instance = null;
    /**
	* The body collections the shared tooltip balloon may be pinned into, each with the sources describing where
	* its tooltip-bearing UI lives: an optional {@link module:utils/dom/shadowrootregistry~ShadowRootRegistry}
	* (the shadow roots its out-of-collection UI occupies) and an optional emitter whose `update` event should
	* reposition a pinned tooltip.
	*/ static _registrations = /* @__PURE__ */ new Map();
    /**
	* Returns the shared `TooltipManager` singleton, creating it – with the given locale – on first use, and
	* marks one more holder as using it. Every caller must later {@link #release} it, so the singleton is
	* destroyed once the last holder is gone.
	*
	* Editors and features obtain the manager this way and then {@link #registerBodyCollection register} the
	* body collection their tooltip-bearing UI renders into. A feature therefore does not need an editor
	* reference to display tooltips – it attaches to the same singleton directly.
	*
	* @param locale The locale used to create the tooltip views on first use.
	*/ static for(locale) {
        if (!TooltipManager._instance) TooltipManager._instance = new TooltipManager(locale);
        TooltipManager._instance._refCount++;
        return TooltipManager._instance;
    }
    /**
	* Creates an instance of the tooltip manager. Private – use {@link module:ui/tooltipmanager~TooltipManager.for} to obtain the shared
	* singleton.
	*/ constructor(locale){
        super();
        this.tooltipTextView = new $29fd27cb9bdab9d2$export$27a5bd065ad55220(locale);
        this.tooltipTextView.set("text", "");
        this.tooltipTextView.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-tooltip__text"
                ]
            },
            children: [
                {
                    text: this.tooltipTextView.bindTemplate.to("text")
                }
            ]
        });
        this.balloonPanelView = new $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c(locale);
        this.balloonPanelView.class = $29fd27cb9bdab9d2$var$BALLOON_CLASS;
        this.balloonPanelView.content.add(this.tooltipTextView);
        this._mutationObserver = $29fd27cb9bdab9d2$var$createMutationObserver(()=>{
            this._updateTooltipPosition();
        });
        this._pinTooltipDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(this._pinTooltip, 600);
        this._unpinTooltipDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(this._unpinTooltip, 400);
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "keydown", this._onKeyDown.bind(this), {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mouseenter", this._onEnterOrFocus.bind(this), {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mouseleave", this._onLeaveOrBlur.bind(this), {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "focus", this._onEnterOrFocus.bind(this), {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "blur", this._onLeaveOrBlur.bind(this), {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", this._onScroll.bind(this), {
            useCapture: true
        });
        this._watchdogExcluded = true;
    }
    /**
	* Marks one holder as done with the singleton (see {@link module:ui/tooltipmanager~TooltipManager.for}). When the last holder
	* releases it, the singleton unpins the tooltip, destroys the shared balloon and drops every listener.
	*/ release() {
        if (this._refCount === 0 || --this._refCount > 0) return;
        this._unpinTooltip();
        this.balloonPanelView.destroy();
        this.stopListening();
        TooltipManager._registrations.clear();
        this._bodyCollectionByTree.clear();
        this._shadowRoots.clear();
        TooltipManager._instance = null;
    }
    /**
	* Registers a body collection the shared tooltip balloon may be pinned into, so that a tooltip triggered
	* inside its DOM tree is hosted there instead of an unrelated one – keeping it in the same shadow tree, not
	* clipped by or mis-styled across a boundary. Editors register their own
	* {@link module:ui/editorui/editoruiview~EditorUIView#body body collection}; features that render floating UI
	* in their own body collection register it too, which is what lets them display tooltips without an editor.
	*
	* @param bodyCollection The body collection to register.
	* @param options Additional sources describing where this collection's tooltip-bearing UI lives.
	* @param options.shadowRootRegistry The shadow roots hosting UI that is *not* inside `bodyCollection` (an
	* editor's editables, toolbar, menu bar). Omit it when all tooltip-bearing UI lives inside the collection.
	* @param options.updateEmitter An emitter whose `update` event should reposition a pinned tooltip (an editor
	* passes its {@link module:ui/editorui/editorui~EditorUI}). Omit it when nothing moves the tooltip anchor.
	*/ registerBodyCollection(bodyCollection, { shadowRootRegistry: shadowRootRegistry, updateEmitter: updateEmitter } = {}) {
        if (TooltipManager._registrations.has(bodyCollection)) return;
        TooltipManager._registrations.set(bodyCollection, {
            shadowRootRegistry: shadowRootRegistry,
            updateEmitter: updateEmitter
        });
        this.listenTo(bodyCollection, "remount", ()=>{
            if (!bodyCollection.mountTarget && bodyCollection.has(this.balloonPanelView) && this._currentElementWithTooltip) this._unpinTooltip();
            this._rebuild();
        });
        if (shadowRootRegistry) {
            this.listenTo(shadowRootRegistry, "add", ()=>this._rebuild());
            this.listenTo(shadowRootRegistry, "remove", ()=>this._rebuild());
        }
        this._rebuild();
    }
    /**
	* Reverts {@link #registerBodyCollection}: stops hosting the shared balloon in the given collection and
	* drops the listeners set up for it. Pulls the shared balloon out first, so it never dangles in a collection
	* that is going away.
	*
	* @param bodyCollection The body collection to unregister.
	*/ unregisterBodyCollection(bodyCollection) {
        const registration = TooltipManager._registrations.get(bodyCollection);
        if (!registration) return;
        TooltipManager._registrations.delete(bodyCollection);
        this.stopListening(bodyCollection);
        if (registration.shadowRootRegistry) this.stopListening(registration.shadowRootRegistry);
        if (registration.updateEmitter && !this._getUpdateEmitters().has(registration.updateEmitter)) this.stopListening(registration.updateEmitter);
        if (bodyCollection.has(this.balloonPanelView)) {
            if (this._currentElementWithTooltip) this._unpinTooltip();
            bodyCollection.remove(this.balloonPanelView);
        }
        this._rebuild();
    }
    /**
	* Returns the distinct `update` emitters of all registered body collections.
	*
	* Deduplicated, because an emitter can be shared by several registrations (an editor and a feature hosting its
	* own overlay layer both follow the editor's UI update) while listeners are attached per emitter, not per
	* registration – listening once per registration would reposition a pinned tooltip several times per update.
	*/ _getUpdateEmitters() {
        const updateEmitters = /* @__PURE__ */ new Set();
        for (const { updateEmitter: updateEmitter } of TooltipManager._registrations.values())if (updateEmitter) updateEmitters.add(updateEmitter);
        return updateEmitters;
    }
    /**
	* Rebuilds {@link #_bodyCollectionByTree} from {@link module:ui/tooltipmanager~TooltipManager._registrations}: every registered
	* collection claims the DOM tree it is mounted in, and – for editors – every shadow root its registry reports (ancestor-inclusive,
	* so nested and decoupled trees resolve too). Then re-syncs the per-shadow-root listeners.
	*/ _rebuild() {
        const map = /* @__PURE__ */ new Map();
        const claim = (tree, bodyCollection)=>{
            if (!map.has(tree)) map.set(tree, bodyCollection);
        };
        for (const [bodyCollection, { shadowRootRegistry: shadowRootRegistry }] of TooltipManager._registrations){
            const mountTarget = bodyCollection.mountTarget;
            if (mountTarget) claim(mountTarget.getRootNode(), bodyCollection);
            if (shadowRootRegistry) for (const root of shadowRootRegistry.getShadowRoots())claim(root, bodyCollection);
        }
        this._bodyCollectionByTree = map;
        this._resyncShadowRootListeners();
    }
    /**
	* Returns {@link #balloonPanelView} {@link module:utils/dom/position~PositioningFunction positioning functions} for a given position
	* name.
	*
	* @param position Name of the position (`s`, `se`, `sw`, `n`, `e`, or `w`).
	* @returns Positioning functions to be used by the {@link #balloonPanelView}.
	*/ static getPositioningFunctions(position) {
        const defaultPositions = TooltipManager.defaultBalloonPositions;
        return ({
            s: [
                defaultPositions.southArrowNorth,
                defaultPositions.southArrowNorthEast,
                defaultPositions.southArrowNorthWest
            ],
            n: [
                defaultPositions.northArrowSouth
            ],
            e: [
                defaultPositions.eastArrowWest
            ],
            w: [
                defaultPositions.westArrowEast
            ],
            sw: [
                defaultPositions.southArrowNorthEast
            ],
            se: [
                defaultPositions.southArrowNorthWest
            ]
        })[position];
    }
    /**
	* Handles hiding tooltips on `keydown` in DOM.
	*
	* @param evt An object containing information about the fired event.
	* @param domEvent The DOM event.
	*/ _onKeyDown(evt, domEvent) {
        if (domEvent.key === "Escape" && this._currentElementWithTooltip) {
            this._unpinTooltip();
            domEvent.stopPropagation();
        }
    }
    /**
	* Handles displaying tooltips on `mouseenter` and `focus` in DOM.
	*
	* @param evt An object containing information about the fired event.
	* @param domEvent The DOM event.
	*/ _onEnterOrFocus(evt, domEvent) {
        if ((0, $c7bc2cb7e2db0227$export$e35bfa60228815d9)(domEvent.target, this._shadowRoots)) return;
        const { target: target } = domEvent;
        const elementWithTooltipAttribute = $29fd27cb9bdab9d2$var$getDescendantWithTooltip(target);
        if (!elementWithTooltipAttribute) {
            if (evt.name === "mouseenter" && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(this.balloonPanelView.element, target)) {
                this._unpinTooltipDebounced.cancel();
                return;
            }
            if (evt.name === "focus") this._unpinTooltip();
            return;
        }
        if (elementWithTooltipAttribute === this._currentElementWithTooltip) {
            this._unpinTooltipDebounced.cancel();
            return;
        }
        this._unpinTooltip();
        if (evt.name === "focus" && !elementWithTooltipAttribute.matches(":hover") || elementWithTooltipAttribute.matches("[data-cke-tooltip-instant]")) this._pinTooltip(elementWithTooltipAttribute, $29fd27cb9bdab9d2$var$getTooltipData(elementWithTooltipAttribute));
        else this._pinTooltipDebounced(elementWithTooltipAttribute, $29fd27cb9bdab9d2$var$getTooltipData(elementWithTooltipAttribute));
    }
    /**
	* Handles hiding tooltips on `mouseleave` and `blur` in DOM.
	*
	* @param evt An object containing information about the fired event.
	* @param domEvent The DOM event.
	*/ _onLeaveOrBlur(evt, domEvent) {
        if ((0, $c7bc2cb7e2db0227$export$e35bfa60228815d9)(domEvent.target, this._shadowRoots)) return;
        const { target: target, relatedTarget: relatedTarget } = domEvent;
        if (evt.name === "mouseleave") {
            if (!(0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(target)) return;
            const balloonElement = this.balloonPanelView.element;
            const isEnteringBalloon = !!balloonElement && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(balloonElement, relatedTarget);
            const isLeavingBalloon = !isEnteringBalloon && target === balloonElement;
            if (isEnteringBalloon) {
                this._unpinTooltipDebounced.cancel();
                return;
            }
            if (!isLeavingBalloon && this._currentElementWithTooltip && target !== this._currentElementWithTooltip) return;
            const descendantWithTooltip = $29fd27cb9bdab9d2$var$getDescendantWithTooltip(target);
            const relatedDescendantWithTooltip = $29fd27cb9bdab9d2$var$getDescendantWithTooltip(relatedTarget);
            if (isLeavingBalloon || descendantWithTooltip && descendantWithTooltip !== relatedDescendantWithTooltip) {
                this._pinTooltipDebounced.cancel();
                if (this._currentElementWithTooltip && this._currentElementWithTooltip.matches("[data-cke-tooltip-instant]") || descendantWithTooltip && descendantWithTooltip.matches("[data-cke-tooltip-instant]")) this._unpinTooltip();
                else this._unpinTooltipDebounced();
            }
        } else {
            if (this._currentElementWithTooltip && target !== this._currentElementWithTooltip) return;
            this._pinTooltipDebounced.cancel();
            this._unpinTooltipDebounced();
        }
    }
    /**
	* Attaches or detaches listeners on shadow roots so they match the shadow roots that host tooltip-bearing UI
	* exactly, i.e. the shadow-root keys of {@link #_bodyCollectionByTree}.
	*
	* The listeners duplicate the ones on `document` for two different reasons:
	*
	* * `mouseenter`, `mouseleave` and `scroll` are not `composed`, so their event path ends at the shadow root
	* they originated in and the `document` listeners never see them at all. Here the per-root listener is what
	* delivers the event.
	* * `focus` and `blur` are `composed`, so the capturing `document` listeners do see them (the capture phase
	* walks the whole composed path even though these events do not bubble) — but with `target` retargeted to
	* the shadow host, which is useless for `getDescendantWithTooltip()`. Here the per-root listener is
	* what provides the real target. It cannot be replaced by reading `composedPath()[0]` on `document`,
	* because that path is truncated at the boundary of a `closed` root.
	*
	* Since the capture phase runs outwards-in, the `document` listener fires *before* these; see the
	* `isShadowHostOf()` guards in {@link #_onEnterOrFocus} and {@link #_onLeaveOrBlur}, which make the
	* outer listeners step aside for the innermost one.
	*/ _resyncShadowRootListeners() {
        const currentRoots = /* @__PURE__ */ new Set();
        for (const tree of this._bodyCollectionByTree.keys())if ((0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(tree)) currentRoots.add(tree);
        for (const root of this._shadowRoots)if (!currentRoots.has(root)) {
            this.stopListening(root);
            this._shadowRoots.delete(root);
        }
        for (const root of currentRoots){
            if (this._shadowRoots.has(root)) continue;
            this.listenTo(root, "mouseenter", this._onEnterOrFocus.bind(this), {
                useCapture: true
            });
            this.listenTo(root, "mouseleave", this._onLeaveOrBlur.bind(this), {
                useCapture: true
            });
            this.listenTo(root, "scroll", this._onScroll.bind(this), {
                useCapture: true
            });
            this.listenTo(root, "focus", this._onEnterOrFocus.bind(this), {
                useCapture: true
            });
            this.listenTo(root, "blur", this._onLeaveOrBlur.bind(this), {
                useCapture: true
            });
            this._shadowRoots.add(root);
        }
    }
    /**
	* Handles hiding tooltips on `scroll` in DOM.
	*
	* @param evt An object containing information about the fired event.
	* @param domEvent The DOM event.
	*/ _onScroll(evt, { target: target }) {
        if (!this._currentElementWithTooltip) return;
        if ((0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(target, this.balloonPanelView.element) && (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(target, this._currentElementWithTooltip)) return;
        this._unpinTooltip();
    }
    /**
	* Pins the tooltip to a specific DOM element.
	*
	* @param targetDomElement Element to be pinned to.
	* @param options Options for the tooltip.
	* @param options.text Text of the tooltip to display.
	* @param options.position The position of the tooltip.
	* @param options.cssClass Additional CSS class of the balloon with the tooltip.
	*/ _pinTooltip(targetDomElement, { text: text, position: position, cssClass: cssClass }) {
        this._unpinTooltip();
        if (!this._moveBalloonToConnectedBodyCollection(targetDomElement)) return;
        this.tooltipTextView.text = text;
        this.balloonPanelView.class = [
            $29fd27cb9bdab9d2$var$BALLOON_CLASS,
            cssClass
        ].filter((className)=>className).join(" ");
        this.balloonPanelView.pin({
            target: targetDomElement,
            positions: TooltipManager.getPositioningFunctions(position)
        });
        this._mutationObserver.attach(targetDomElement);
        for (const updateEmitter of this._getUpdateEmitters())this.listenTo(updateEmitter, "update", this._updateTooltipPosition.bind(this), {
            priority: "low"
        });
        this._currentElementWithTooltip = targetDomElement;
        this._currentTooltipPosition = position;
    }
    /**
	* Moves the shared tooltip balloon into the body collection returned by {@link #_getConnectedBodyCollection},
	* first removing it from any registered body collection that previously hosted it. The balloon is a singleton
	* shared by every registrant, so it must belong to exactly one collection at a time; otherwise unregistering
	* one collection would detach the shared element while another registrant still references it.
	*
	* @param targetDomElement The element the tooltip is being pinned to, used to prefer the body collection
	* that hosts its DOM tree.
	* @returns `true` if a host body collection was found (and the balloon moved into it), `false` when none is
	* registered and the tooltip therefore cannot be shown.
	*/ _moveBalloonToConnectedBodyCollection(targetDomElement) {
        const balloon = this.balloonPanelView;
        const targetBodyCollection = this._getConnectedBodyCollection(targetDomElement);
        if (!targetBodyCollection) return false;
        for (const bodyCollection of TooltipManager._registrations.keys())if (bodyCollection !== targetBodyCollection && bodyCollection.has(balloon)) bodyCollection.remove(balloon);
        if (!targetBodyCollection.has(balloon)) targetBodyCollection.add(balloon);
        return true;
    }
    /**
	* Returns the body collection the shared tooltip balloon should be pinned into. The balloon is a singleton,
	* but each registered body collection can live in a different DOM tree (a shadow root, or a configured
	* `ui.overlayContainer`). To keep the tooltip in the tree of the hovered element — so it is styled by that
	* tree's sheets and not clipped by another root — the tree is looked up in {@link #_bodyCollectionByTree},
	* which maps every tree hosting tooltip-bearing UI (a collection's own mount tree, and an editor's editable,
	* toolbar or menu bar trees) to the collection that should host it.
	*
	* A body collection is mounted lazily and unmounted when its host leaves the document, and a configured
	* `ui.overlayContainer` may be detached — a body in either state would render the balloon outside the
	* document and hide tooltips, so the mount target must be connected, not merely set. When no connected body
	* collection hosts the hovered element's tree, it falls back to the first connected registrant, then to the
	* first registered one, and to `null` when nothing is registered at all.
	*
	* @param targetDomElement The element the tooltip is being pinned to.
	*/ _getConnectedBodyCollection(targetDomElement) {
        const targetRoot = targetDomElement.getRootNode();
        const owning = this._bodyCollectionByTree.get(targetRoot);
        if (owning && owning.mountTarget && owning.mountTarget.isConnected) return owning;
        for (const bodyCollection of TooltipManager._registrations.keys())if (bodyCollection.mountTarget && bodyCollection.mountTarget.isConnected) return bodyCollection;
        return (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(TooltipManager._registrations.keys()) || null;
    }
    /**
	* Unpins the tooltip and cancels all queued pinning.
	*/ _unpinTooltip() {
        this._unpinTooltipDebounced.cancel();
        this._pinTooltipDebounced.cancel();
        this.balloonPanelView.unpin();
        for (const updateEmitter of this._getUpdateEmitters())this.stopListening(updateEmitter, "update");
        this._currentElementWithTooltip = null;
        this._currentTooltipPosition = null;
        this.tooltipTextView.text = "";
        this._mutationObserver.detach();
    }
    /**
	* Updates the position of the tooltip so it stays in sync with the element it is pinned to.
	*
	* Hides the tooltip when the element is no longer visible in DOM or the tooltip text was removed.
	*/ _updateTooltipPosition() {
        if (!this._currentElementWithTooltip) return;
        const tooltipData = $29fd27cb9bdab9d2$var$getTooltipData(this._currentElementWithTooltip);
        if (!(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(this._currentElementWithTooltip) || !tooltipData.text) {
            this._unpinTooltip();
            return;
        }
        this.balloonPanelView.pin({
            target: this._currentElementWithTooltip,
            positions: TooltipManager.getPositioningFunctions(tooltipData.position)
        });
    }
};
function $29fd27cb9bdab9d2$var$getDescendantWithTooltip(element) {
    if (!(0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(element)) return null;
    return element.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])");
}
function $29fd27cb9bdab9d2$var$getTooltipData(element) {
    return {
        text: element.dataset.ckeTooltipText,
        position: element.dataset.ckeTooltipPosition || "s",
        cssClass: element.dataset.ckeTooltipClass || ""
    };
}
function $29fd27cb9bdab9d2$var$createMutationObserver(callback) {
    const mutationObserver = new MutationObserver(()=>{
        callback();
    });
    return {
        attach (element) {
            mutationObserver.observe(element, {
                attributes: true,
                attributeFilter: [
                    "data-cke-tooltip-text",
                    "data-cke-tooltip-position"
                ]
            });
        },
        detach () {
            mutationObserver.disconnect();
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/overlayhost
*/ const $29fd27cb9bdab9d2$var$OverlayHostBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Keeps a feature's floating UI – its balloons, dialogs, panels and the tooltips inside them – in the right DOM
* tree, and keeps it there as the feature moves.
*
* For a feature that renders its UI *outside* an editor, in a container the integrator may put anywhere,
* including inside a shadow root. An editor's own floating UI needs none of this: it is mounted in the root the
* editor lives in and stays there.
*
* # Why it is needed
*
* Floating UI is mounted through a {@link module:ui/editorui/bodycollection~BodyCollection}, and it has to go
* into the same tree as the feature it belongs to. Anywhere else it loses the styles scoped to that tree, and
* its tooltips come out clipped or mis-styled across the shadow boundary.
*
* Doing that by hand means re-mounting the collection whenever the container moves, unmounting it while the
* container is detached, registering and unregistering it with the shared
* {@link module:ui/tooltipmanager~TooltipManager}, tracking the shadow roots of the inline UI so that tooltips
* and click-outside detection reach across boundaries, and tearing it all down in the right order. This class
* does all of it, behind resolvers that say where the feature's UI currently is.
*
* # How to use it
*
* ```ts
* const host = new OverlayHost( locale, {
* 	resolveMountTarget: () => getOverlayMountRoot( featureContainer ),
* 	resolveInlineContainer: () => featureContainer
* } );
*
* host.sync();
* host.bodyCollection.add( balloonPanelView );
* ```
*
* Add the feature's floating views to {@link #bodyCollection}. Call {@link #sync} whenever the container may
* have moved – right before showing a panel, for instance – and {@link #destroy} once the feature goes away.
* It re-syncs on its own too: whenever a view is added to the collection, and on every `update` event of an
* {@link module:ui/overlayhost~OverlayHostOptions#updateEmitter `updateEmitter`}, if one is given.
*
* An editor's {@link module:ui/editorui/editorui~EditorUI} uses this class as well, lending it the body
* collection and shadow root registry it already has.
*/ var $29fd27cb9bdab9d2$export$93bfee0bb4f77b91 = class extends $29fd27cb9bdab9d2$var$OverlayHostBase {
    /**
	* The body collection holding the floating views. Add the feature's balloons and panels here.
	*/ bodyCollection;
    /**
	* Tracks the shadow roots hosting the tooltip-bearing UI that lives outside the {@link #bodyCollection}:
	* the {@link module:ui/overlayhost~OverlayHostOptions#resolveInlineContainer inline UI container} and any
	* nodes registered directly by the owner (an editor registers its editables, toolbars and menu bar).
	*/ shadowRootRegistry;
    /**
	* The shared tooltip manager the {@link #bodyCollection} is registered with.
	*/ _tooltipManager;
    /**
	* See {@link module:ui/overlayhost~OverlayHostOptions#resolveMountTarget}.
	*/ _resolveMountTarget;
    /**
	* See {@link module:ui/overlayhost~OverlayHostOptions#resolveInlineContainer}.
	*/ _resolveInlineContainer;
    /**
	* The inline UI container currently registered with {@link #shadowRootRegistry}, so it can be
	* replaced when the feature moves to a different container.
	*/ _registeredInlineContainer = null;
    /**
	* Whether the {@link #bodyCollection} was created by this host (and is destroyed with it), as opposed to
	* a borrowed one whose owner manages its life cycle.
	*/ _ownsBodyCollection;
    /**
	* Whether the {@link #shadowRootRegistry} was created by this host (and is destroyed with it), as opposed
	* to a borrowed one whose owner manages its life cycle.
	*/ _ownsShadowRootRegistry;
    /**
	* Whether this host acquired its own reference to the shared tooltip manager (and releases it on
	* {@link #destroy}), as opposed to using a borrowed reference whose holder releases it – an editor counts
	* as a single holder no matter how it splits the work internally.
	*/ _ownsTooltipManagerReference;
    /**
	* Whether {@link #destroy} has run, so a repeated call does not release the shared tooltip manager on
	* behalf of another holder.
	*/ _destroyed = false;
    /**
	* Creates the host: the {@link #bodyCollection} (unless a borrowed one is given) and its registration in
	* the shared {@link module:ui/tooltipmanager~TooltipManager}. The collection is not mounted in the DOM
	* yet – call {@link #sync} for that.
	*
	* @param locale The locale of the feature (used by the body collection and the tooltip views).
	* @param options The resolvers describing where the feature UI lives.
	*/ constructor(locale, options){
        super();
        this.bodyCollection = options.bodyCollection || new $29fd27cb9bdab9d2$export$f96d1f01684ec5c2(locale);
        this._ownsBodyCollection = !options.bodyCollection;
        this.shadowRootRegistry = options.shadowRootRegistry || new (0, $c7bc2cb7e2db0227$export$62767248905409ba)();
        this._ownsShadowRootRegistry = !options.shadowRootRegistry;
        this._resolveMountTarget = options.resolveMountTarget;
        this._resolveInlineContainer = options.resolveInlineContainer;
        this._tooltipManager = options.tooltipManager || $29fd27cb9bdab9d2$export$3cf29e47efa41626.for(locale);
        this._ownsTooltipManagerReference = !options.tooltipManager;
        this._tooltipManager.registerBodyCollection(this.bodyCollection, {
            shadowRootRegistry: this.shadowRootRegistry,
            updateEmitter: options.updateEmitter
        });
        if (options.updateEmitter) this.listenTo(options.updateEmitter, "update", ()=>this.sync(), {
            priority: "high"
        });
        this.listenTo(this.bodyCollection, "add", ()=>this.sync());
    }
    /**
	* Brings the host up to date with the resolved targets:
	*
	* * keeps the {@link #bodyCollection} mounted in the target resolved by
	*   {@link module:ui/overlayhost~OverlayHostOptions#resolveMountTarget} (re-mounting only when the target
	*   changes, unmounting on `null`);
	* * keeps the {@link module:ui/overlayhost~OverlayHostOptions#resolveInlineContainer inline UI container}
	*   tracked for tooltips, re-resolving its shadow root in case a detached container has become connected.
	*
	* Idempotent – call it whenever the targets may have changed: after attaching the feature to a container,
	* right before showing a floating panel (an editor's UI may be mounted lazily), or on any relevant layout
	* change.
	*/ sync() {
        this.bodyCollection.syncMountTarget(this._resolveMountTarget());
        if (this._resolveInlineContainer) {
            const container = this._resolveInlineContainer() || null;
            if (container !== this._registeredInlineContainer) {
                if (this._registeredInlineContainer) this.shadowRootRegistry.unregisterNode(this._registeredInlineContainer);
                this._registeredInlineContainer = container;
                if (container) this.shadowRootRegistry.registerNode(container);
            }
        }
        this.shadowRootRegistry.refresh();
    }
    /**
	* Destroys the host: stops hosting tooltips in the {@link #bodyCollection}, releases the shared
	* {@link module:ui/tooltipmanager~TooltipManager} (so it is destroyed with its last holder) and destroys
	* the collection together with its views and the {@link #shadowRootRegistry} – except the borrowed ones,
	* which their owners destroy. Safe to call more than once.
	*/ destroy() {
        if (this._destroyed) return;
        this._destroyed = true;
        this.stopListening();
        this._tooltipManager.unregisterBodyCollection(this.bodyCollection);
        if (this._ownsTooltipManagerReference) this._tooltipManager.release();
        if (this._ownsShadowRootRegistry) this.shadowRootRegistry.destroy();
        if (this._ownsBodyCollection) this.bodyCollection.destroy();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A helper that enables the "evaluation badge" feature in the editor at the bottom of the editable element
* (editor root, source editing area, etc.) when the editor is focused.
*
* @private
*/ var $29fd27cb9bdab9d2$export$19144264d96de685 = class extends $29fd27cb9bdab9d2$export$37acb3580601e69a {
    licenseTypeMessage = {
        evaluation: "For evaluation purposes only",
        trial: "For evaluation purposes only",
        development: "For development purposes only"
    };
    constructor(editor){
        super(editor, {
            balloonClass: "ck-evaluation-badge-balloon"
        });
    }
    /**
	* Enables "evaluation badge" label.
	*/ _isEnabled() {
        const licenseType = $29fd27cb9bdab9d2$var$getLicenseTypeFromLicenseKey(this.editor.config.get("licenseKey"));
        return Boolean(licenseType && this.licenseTypeMessage[licenseType]);
    }
    /**
	* Creates the content of the "evaluation badge".
	*/ _createBadgeContent() {
        const licenseType = $29fd27cb9bdab9d2$var$getLicenseTypeFromLicenseKey(this.editor.config.get("licenseKey"));
        return new $29fd27cb9bdab9d2$var$EvaluationBadgeView(this.editor.locale, this.licenseTypeMessage[licenseType]);
    }
    /**
	* Returns the normalized configuration for the "evaluation badge".
	* It takes 'ui.poweredBy' configuration into account to determine the badge position and side.
	*/ _getNormalizedConfig() {
        const badgeConfig = super._getNormalizedConfig();
        const userConfig = this.editor.config.get("ui.poweredBy") || {};
        return {
            position: userConfig.position || badgeConfig.position,
            side: (userConfig.side || badgeConfig.side) === "left" ? "right" : "left",
            verticalOffset: badgeConfig.verticalOffset,
            horizontalOffset: badgeConfig.horizontalOffset
        };
    }
};
/**
* A view displaying the "evaluation badge".
*/ var $29fd27cb9bdab9d2$var$EvaluationBadgeView = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Creates an instance of the "evaluation badge" view.
	*
	* @param locale The localization services instance.
	* @param label The label text.
	*/ constructor(locale, label){
        super(locale);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-evaluation-badge"
                ],
                "aria-hidden": true
            },
            children: [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck",
                            "ck-evaluation-badge__label"
                        ]
                    },
                    children: [
                        label
                    ]
                }
            ]
        });
    }
};
/**
* Returns the license type based on the license key.
*/ function $29fd27cb9bdab9d2$var$getLicenseTypeFromLicenseKey(licenseKey) {
    if (licenseKey == "GPL") return "GPL";
    const licenseContent = (0, $c7bc2cb7e2db0227$export$6d464faaef141d67)(licenseKey.split(".")[1]);
    if (!licenseContent) return null;
    return licenseContent.licenseType || "production";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A menu bar list item view, a child of {@link module:ui/menubar/menubarmenulistview~MenuBarMenuListView}.
*
* Populate this item with a {@link module:ui/menubar/menubarmenulistitembuttonview~MenuBarMenuListItemButtonView} instance
* or a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} instance to create a sub-menu.
*/ var $29fd27cb9bdab9d2$export$b8932d143ba0ac18 = class extends $29fd27cb9bdab9d2$export$41fd379e664153d8 {
    /**
	* Creates an instance of the list item view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale, parentMenuView){
        super(locale);
        const bind = this.bindTemplate;
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-menu-bar__menu__item"
                ]
            },
            on: {
                "mouseenter": bind.to("mouseenter")
            }
        });
        this.delegate("mouseenter").to(parentMenuView);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/menubar/utils
*/ const $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET = 5;
/**
* Behaviors of the {@link module:ui/menubar/menubarview~MenuBarView} component.
* @internal
*/ const $29fd27cb9bdab9d2$export$6e608be8caac6394 = {
    /**
	* When the bar is already open:
	* * Opens the menu when the user hovers over its button.
	* * Closes open menu when another menu's button gets hovered.
	*/ toggleMenusAndFocusItemsOnHover (menuBarView) {
        menuBarView.on("menu:mouseenter", (evt)=>{
            if (!menuBarView.isFocusBorderEnabled && !menuBarView.isOpen) return;
            if (menuBarView.isOpen) for (const menuView of menuBarView.menus){
                const pathLeaf = evt.path[0];
                const isListItemContainingMenu = pathLeaf instanceof $29fd27cb9bdab9d2$export$b8932d143ba0ac18 && pathLeaf.children.first === menuView;
                menuView.isOpen = (evt.path.includes(menuView) || isListItemContainingMenu) && menuView.isEnabled;
            }
            evt.source.focus();
        });
    },
    /**
	* Moves between top-level menus using the arrow left and right keys.
	*
	* If the menubar has already been open, the arrow keys move focus between top-level menu buttons and open them.
	* If the menubar is closed, the arrow keys only move focus between top-level menu buttons.
	*/ focusCycleMenusOnArrows (menuBarView) {
        const isContentRTL = menuBarView.locale.uiLanguageDirection === "rtl";
        menuBarView.on("menu:arrowright", (evt)=>{
            cycleTopLevelMenus(evt.source, isContentRTL ? -1 : 1);
        });
        menuBarView.on("menu:arrowleft", (evt)=>{
            cycleTopLevelMenus(evt.source, isContentRTL ? 1 : -1);
        });
        function cycleTopLevelMenus(currentMenuView, step) {
            const currentIndex = menuBarView.children.getIndex(currentMenuView);
            const isCurrentMenuViewOpen = currentMenuView.isOpen;
            const menusCount = menuBarView.children.length;
            const menuViewToOpen = menuBarView.children.get((currentIndex + menusCount + step) % menusCount);
            currentMenuView.isOpen = false;
            if (isCurrentMenuViewOpen) menuViewToOpen.isOpen = true;
            menuViewToOpen.buttonView.focus();
        }
    },
    /**
	* Closes the entire sub-menu structure when the bar is closed. This prevents sub-menus from being open if the user
	* closes the entire bar, and then re-opens some top-level menu.
	*/ closeMenusWhenTheBarCloses (menuBarView) {
        menuBarView.on("change:isOpen", ()=>{
            if (!menuBarView.isOpen) menuBarView.menus.forEach((menuView)=>{
                menuView.isOpen = false;
            });
        });
    },
    /**
	* Handles the following case:
	* 1. Hover to open a sub-menu (A). The button has focus.
	* 2. Press arrow up/down to move focus to another sub-menu (B) button.
	* 3. Press arrow right to open the sub-menu (B).
	* 4. The sub-menu (A) should close as it would with `toggleMenusAndFocusItemsOnHover()`.
	*/ closeMenuWhenAnotherOnTheSameLevelOpens (menuBarView) {
        menuBarView.on("menu:change:isOpen", (evt, name, isOpen)=>{
            if (isOpen) menuBarView.menus.filter((menuView)=>{
                return evt.source.parentMenuView === menuView.parentMenuView && evt.source !== menuView && menuView.isOpen;
            }).forEach((menuView)=>{
                menuView.isOpen = false;
            });
        });
    },
    /**
	* Closes the bar when the user clicked outside of it (page body, editor root, etc.).
	*/ closeOnClickOutside (menuBarView) {
        $29fd27cb9bdab9d2$export$16d2a52659b91b8a({
            emitter: menuBarView,
            activator: ()=>menuBarView.isOpen,
            callback: ()=>menuBarView.close(),
            contextElements: ()=>menuBarView.children.map((child)=>child.element)
        });
    },
    /**
	* Tracks the keyboard focus interaction on the menu bar view. It is used to determine if the nested items
	* of the menu bar should render focus rings after first interaction with the keyboard.
	*/ enableFocusHighlightOnInteraction (menuBarView) {
        let isKeyPressed = false;
        menuBarView.on("change:isOpen", (_, evt, isOpen)=>{
            if (!isOpen) {
                if (!isKeyPressed) menuBarView.isFocusBorderEnabled = false;
                isKeyPressed = false;
            }
        });
        menuBarView.listenTo(menuBarView.element, "keydown", ()=>{
            isKeyPressed = true;
        }, {
            useCapture: true
        });
        menuBarView.listenTo(menuBarView.element, "keyup", ()=>{
            isKeyPressed = false;
        }, {
            useCapture: true
        });
        menuBarView.listenTo(menuBarView.element, "focus", ()=>{
            if (isKeyPressed) menuBarView.isFocusBorderEnabled = true;
        }, {
            useCapture: true
        });
    }
};
/**
* Behaviors of the {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} component.
* @internal
*/ const $29fd27cb9bdab9d2$export$4961f96b68698761 = {
    /**
	* If the button of the menu is focused, pressing the arrow down key should open the panel and focus it.
	* This is analogous to the {@link module:ui/dropdown/dropdownview~DropdownView}.
	*/ openAndFocusPanelOnArrowDownKey (menuView) {
        menuView.keystrokes.set("arrowdown", (data, cancel)=>{
            if (menuView.isEnabled && menuView.focusTracker.focusedElement === menuView.buttonView.element) {
                if (!menuView.isOpen) menuView.isOpen = true;
                menuView.panelView.focus();
                cancel();
            }
        });
    },
    /**
	* Open the menu on the right arrow key press. This allows for navigating to sub-menus using the keyboard.
	*/ openOnArrowRightKey (menuView) {
        const keystroke = menuView.locale.uiLanguageDirection === "rtl" ? "arrowleft" : "arrowright";
        menuView.keystrokes.set(keystroke, (data, cancel)=>{
            if (menuView.focusTracker.focusedElement !== menuView.buttonView.element || !menuView.isEnabled) return;
            if (!menuView.isOpen) menuView.isOpen = true;
            menuView.panelView.focus();
            cancel();
        });
    },
    /**
	* Opens the menu on its button click. Note that this behavior only opens but never closes the menu (unlike
	* {@link module:ui/dropdown/dropdownview~DropdownView}).
	*/ openOnButtonClick (menuView) {
        menuView.buttonView.on("execute", ()=>{
            menuView.isOpen = true;
        });
    },
    /**
	* Toggles the menu on its button click. This behavior is analogous to {@link module:ui/dropdown/dropdownview~DropdownView}.
	*/ toggleOnButtonClick (menuView) {
        menuView.buttonView.on("execute", ()=>{
            menuView.isOpen = !menuView.isOpen;
        });
    },
    /**
	* Opens the menu and focuses the panel content upon pressing the Enter key.
	*/ openAndFocusOnEnterKeyPress (menuView) {
        menuView.keystrokes.set("enter", (data, cancel)=>{
            if (menuView.focusTracker.focusedElement !== menuView.buttonView.element) return;
            menuView.isOpen = true;
            menuView.panelView.focus();
            cancel();
        });
    },
    /**
	* Closes the menu on the right left key press. This allows for navigating to sub-menus using the keyboard.
	*/ closeOnArrowLeftKey (menuView) {
        const keystroke = menuView.locale.uiLanguageDirection === "rtl" ? "arrowright" : "arrowleft";
        menuView.keystrokes.set(keystroke, (data, cancel)=>{
            if (menuView.isOpen) {
                menuView.isOpen = false;
                menuView.focus();
                cancel();
            }
        });
    },
    /**
	* Closes the menu on the esc key press. This allows for navigating to sub-menus using the keyboard.
	*/ closeOnEscKey (menuView) {
        menuView.keystrokes.set("esc", (data, cancel)=>{
            if (menuView.isOpen) {
                menuView.isOpen = false;
                menuView.focus();
                cancel();
            }
        });
    },
    /**
	* Closes the menu when its parent menu also closed. This prevents from orphaned open menus when the parent menu re-opens.
	*/ closeOnParentClose (menuView) {
        menuView.parentMenuView.on("change:isOpen", (evt, name, isOpen)=>{
            if (!isOpen && evt.source === menuView.parentMenuView) menuView.isOpen = false;
        });
    }
};
/**
* Contains every positioning function used by {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} that decides where the
* {@link module:ui/menubar/menubarmenuview~MenuBarMenuView#panelView} should be placed.
*
* Top-level menu positioning functions:
*
*	┌──────┐
*	│      │
*	├──────┴────────┐
*	│               │
*	│               │
*	│               │
*	│            SE │
*	└───────────────┘
*
*	         ┌──────┐
*	         │      │
*	┌────────┴──────┤
*	│               │
*	│               │
*	│               │
*	│ SW            │
*	└───────────────┘
*
*	┌───────────────┐
*	│ NW            │
*	│               │
*	│               │
*	│               │
*	└────────┬──────┤
*	         │      │
*	         └──────┘
*
*	┌───────────────┐
*	│            NE │
*	│               │
*	│               │
*	│               │
*	├──────┬────────┘
*	│      │
*	└──────┘
*
* Sub-menu positioning functions:
*
*	┌──────┬───────────────┐
*	│      │               │
*	└──────┤               │
*	       │               │
*	       │            ES │
*	       └───────────────┘
*
*	┌───────────────┬──────┐
*	│               │      │
*	│               ├──────┘
*	│               │
*	│ WS            │
*	└───────────────┘
*
*	       ┌───────────────┐
*	       │            EN │
*	       │               │
*	┌──────┤               │
*	│      │               │
*	└──────┴───────────────┘
*
*	┌───────────────┐
*	│ WN            │
*	│               │
*	│               ├──────┐
*	│               │      │
*	└───────────────┴──────┘
*/ /**
* @internal
*/ const $29fd27cb9bdab9d2$export$abd8eed83527aff8 = {
    southEast: (buttonRect)=>{
        return {
            top: buttonRect.bottom,
            left: buttonRect.left,
            name: "se"
        };
    },
    southWest: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.bottom,
            left: buttonRect.left - panelRect.width + buttonRect.width,
            name: "sw"
        };
    },
    northEast: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.top - panelRect.height,
            left: buttonRect.left,
            name: "ne"
        };
    },
    northWest: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.top - panelRect.height,
            left: buttonRect.left - panelRect.width + buttonRect.width,
            name: "nw"
        };
    },
    eastSouth: (buttonRect)=>{
        return {
            top: buttonRect.top,
            left: buttonRect.right - $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET,
            name: "es"
        };
    },
    eastNorth: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.top - panelRect.height,
            left: buttonRect.right - $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET,
            name: "en"
        };
    },
    westSouth: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.top,
            left: buttonRect.left - panelRect.width + $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET,
            name: "ws"
        };
    },
    westNorth: (buttonRect, panelRect)=>{
        return {
            top: buttonRect.top - panelRect.height,
            left: buttonRect.left - panelRect.width + $29fd27cb9bdab9d2$var$NESTED_PANEL_HORIZONTAL_OFFSET,
            name: "wn"
        };
    }
};
/**
* The default items {@link module:core/editor/editorconfig~EditorConfig#menuBar configuration} of the
* {@link module:ui/menubar/menubarview~MenuBarView} component. It contains names of all menu bar components
* registered in the {@link module:ui/componentfactory~ComponentFactory component factory} (available in the project).
*
* **Note**: Menu bar component names provided by core editor features are prefixed with `menuBar:` in order to distinguish
* them from components referenced by the {@link module:core/editor/editorconfig~EditorConfig#toolbar toolbar configuration}, for instance,
* `'menuBar:bold'` is a menu bar button but `'bold'` is a toolbar button.
*
* Below is the preset menu bar structure (the default value of `config.menuBar.items` property):
*
* ```ts
* [
* 	{
* 		menuId: 'file',
* 		label: 'File',
* 		groups: [
* 			{
* 				groupId: 'export',
* 				items: [
* 					'menuBar:exportPdf',
* 					'menuBar:exportWord'
* 				]
* 			},
* 			{
* 				groupId: 'import',
* 				items: [
* 					'menuBar:importWord'
* 				]
* 			},
* 			{
* 				groupId: 'revisionHistory',
* 				items: [
* 					'menuBar:revisionHistory'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'edit',
* 		label: 'Edit',
* 		groups: [
* 			{
* 				groupId: 'undo',
* 				items: [
* 					'menuBar:undo',
* 					'menuBar:redo'
* 				]
* 			},
* 			{
* 				groupId: 'selectAll',
* 				items: [
* 					'menuBar:selectAll'
* 				]
* 			},
* 			{
* 				groupId: 'findAndReplace',
* 				items: [
* 					'menuBar:findAndReplace'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'view',
* 		label: 'View',
* 		groups: [
* 			{
* 				groupId: 'sourceEditingEnhanced',
* 				items: [
* 					'menuBar:sourceEditingEnhanced'
* 				]
* 			},
* 			{
* 				groupId: 'sourceEditing',
* 				items: [
* 					'menuBar:sourceEditing'
* 				]
* 			},
* 			{
* 				groupId: 'showBlocks',
* 				items: [
* 					'menuBar:showBlocks'
* 				]
* 			},
* 			{
* 				groupId: 'previewMergeFields',
* 				items: [
* 					'menuBar:previewMergeFields'
* 				]
* 			},
* 			{
* 				groupId: 'fullscreen',
* 				items: [
* 					'menuBar:fullscreen'
* 				]
* 			},
* 			{
* 				groupId: 'restrictedEditingException',
* 				items: [
* 					'menuBar:restrictedEditingException'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'insert',
* 		label: 'Insert',
* 		groups: [
* 			{
* 				groupId: 'insertMainWidgets',
* 				items: [
* 					'menuBar:insertImage',
* 					'menuBar:ckbox',
* 					'menuBar:ckfinder',
* 					'menuBar:insertTable'
* 				]
* 			},
* 			{
* 				groupId: 'insertInline',
* 				items: [
* 					'menuBar:link',
* 					'menuBar:insertFootnote',
* 					'menuBar:bookmark',
* 					'menuBar:comment',
* 					'menuBar:insertMergeField',
* 					'menuBar:emoji'
* 				]
* 			},
* 			{
* 				groupId: 'insertMinorWidgets',
* 				items: [
* 					'menuBar:mediaEmbed',
* 					'menuBar:insertTemplate',
* 					'menuBar:blockQuote',
* 					'menuBar:codeBlock',
* 					'menuBar:htmlEmbed'
* 				]
* 			},
* 			{
* 				groupId: 'insertStructureWidgets',
* 				items: [
* 					'menuBar:horizontalLine',
* 					'menuBar:pageBreak',
* 					'menuBar:tableOfContents'
* 				]
* 			},
* 			{
* 				groupId: 'restrictedEditing',
* 				items: [
* 					'menuBar:restrictedEditing'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'format',
* 		label: 'Format',
* 		groups: [
* 			{
* 				groupId: 'textAndFont',
* 				items: [
* 					{
* 						menuId: 'text',
* 						label: 'Text',
* 						groups: [
* 							{
* 								groupId: 'basicStyles',
* 								items: [
* 									'menuBar:bold',
* 									'menuBar:italic',
* 									'menuBar:underline',
* 									'menuBar:strikethrough',
* 									'menuBar:superscript',
* 									'menuBar:subscript',
* 									'menuBar:code'
* 								]
* 							},
* 							{
* 								groupId: 'textPartLanguage',
* 								items: [
* 									'menuBar:textPartLanguage'
* 								]
* 							}
* 						]
* 					},
* 					{
* 						menuId: 'font',
* 						label: 'Font',
* 						groups: [
* 							{
* 								groupId: 'fontProperties',
* 								items: [
* 									'menuBar:fontSize',
* 									'menuBar:fontFamily'
* 								]
* 							},
* 							{
* 								groupId: 'fontColors',
* 								items: [
* 									'menuBar:fontColor',
* 									'menuBar:fontBackgroundColor'
* 								]
* 							},
* 							{
* 								groupId: 'highlight',
* 								items: [
* 									'menuBar:highlight'
* 								]
* 							}
* 						]
* 					},
* 					'menuBar:heading'
* 				]
* 			},
* 			{
* 				groupId: 'list',
* 				items: [
* 					'menuBar:bulletedList',
* 					'menuBar:numberedList',
* 					'menuBar:multiLevelList',
* 					'menuBar:todoList'
* 				]
* 			},
* 			{
* 				groupId: 'indent',
* 				items: [
* 					'menuBar:alignment',
* 					'menuBar:lineHeight',
* 					'menuBar:indent',
* 					'menuBar:outdent'
* 				]
* 			},
* 			{
* 				groupId: 'caseChange',
* 				items: [
* 					'menuBar:caseChange'
* 				]
* 			},
* 			{
* 				groupId: 'removeFormat',
* 				items: [
* 					'menuBar:removeFormat'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'tools',
* 		label: 'Tools',
* 		groups: [
* 			{
* 				groupId: 'aiTools',
* 				items: [
* 					'menuBar:aiAssistant',
* 					'menuBar:aiCommands',
* 					'menuBar:toggleAi',
* 					'menuBar:aiQuickActions'
* 				]
* 			},
* 			{
* 				groupId: 'tools',
* 				items: [
* 					'menuBar:trackChanges',
* 					'menuBar:commentsArchive'
* 				]
* 			}
* 		]
* 	},
* 	{
* 		menuId: 'help',
* 		label: 'Help',
* 		groups: [
* 			{
* 				groupId: 'help',
* 				items: [
* 					'menuBar:accessibilityHelp'
* 				]
* 			}
* 		]
* 	}
* ];
* ```
*
* The menu bar can be customized using the `config.menuBar.removeItems` and `config.menuBar.addItems` properties.
*/ const $29fd27cb9bdab9d2$export$37ec16f94e43dd5e = [
    {
        menuId: "file",
        label: "File",
        groups: [
            {
                groupId: "export",
                items: [
                    "menuBar:exportPdf",
                    "menuBar:exportWord"
                ]
            },
            {
                groupId: "import",
                items: [
                    "menuBar:importWord"
                ]
            },
            {
                groupId: "revisionHistory",
                items: [
                    "menuBar:revisionHistory"
                ]
            }
        ]
    },
    {
        menuId: "edit",
        label: "Edit",
        groups: [
            {
                groupId: "undo",
                items: [
                    "menuBar:undo",
                    "menuBar:redo"
                ]
            },
            {
                groupId: "selectAll",
                items: [
                    "menuBar:selectAll"
                ]
            },
            {
                groupId: "findAndReplace",
                items: [
                    "menuBar:findAndReplace"
                ]
            }
        ]
    },
    {
        menuId: "view",
        label: "View",
        groups: [
            {
                groupId: "sourceEditingEnhanced",
                items: [
                    "menuBar:sourceEditingEnhanced"
                ]
            },
            {
                groupId: "sourceEditing",
                items: [
                    "menuBar:sourceEditing"
                ]
            },
            {
                groupId: "showBlocks",
                items: [
                    "menuBar:showBlocks"
                ]
            },
            {
                groupId: "previewMergeFields",
                items: [
                    "menuBar:previewMergeFields"
                ]
            },
            {
                groupId: "fullscreen",
                items: [
                    "menuBar:fullscreen"
                ]
            },
            {
                groupId: "restrictedEditing",
                items: [
                    "menuBar:restrictedEditing"
                ]
            }
        ]
    },
    {
        menuId: "insert",
        label: "Insert",
        groups: [
            {
                groupId: "insertMainWidgets",
                items: [
                    "menuBar:insertImage",
                    "menuBar:ckbox",
                    "menuBar:ckfinder",
                    "menuBar:insertTable",
                    "menuBar:insertTableLayout"
                ]
            },
            {
                groupId: "insertInline",
                items: [
                    "menuBar:link",
                    "menuBar:insertFootnote",
                    "menuBar:bookmark",
                    "menuBar:comment",
                    "menuBar:insertMergeField",
                    "menuBar:emoji"
                ]
            },
            {
                groupId: "insertMinorWidgets",
                items: [
                    "menuBar:mediaEmbed",
                    "menuBar:insertTemplate",
                    "menuBar:specialCharacters",
                    "menuBar:blockQuote",
                    "menuBar:codeBlock",
                    "menuBar:htmlEmbed"
                ]
            },
            {
                groupId: "insertStructureWidgets",
                items: [
                    "menuBar:horizontalLine",
                    "menuBar:pageBreak",
                    "menuBar:tableOfContents"
                ]
            },
            {
                groupId: "restrictedEditingException",
                items: [
                    "menuBar:restrictedEditingException:inline",
                    "menuBar:restrictedEditingException:block"
                ]
            }
        ]
    },
    {
        menuId: "format",
        label: "Format",
        groups: [
            {
                groupId: "textAndFont",
                items: [
                    {
                        menuId: "text",
                        label: "Text",
                        groups: [
                            {
                                groupId: "basicStyles",
                                items: [
                                    "menuBar:bold",
                                    "menuBar:italic",
                                    "menuBar:underline",
                                    "menuBar:strikethrough",
                                    "menuBar:superscript",
                                    "menuBar:subscript",
                                    "menuBar:code"
                                ]
                            },
                            {
                                groupId: "textPartLanguage",
                                items: [
                                    "menuBar:textPartLanguage"
                                ]
                            }
                        ]
                    },
                    {
                        menuId: "font",
                        label: "Font",
                        groups: [
                            {
                                groupId: "fontProperties",
                                items: [
                                    "menuBar:fontSize",
                                    "menuBar:fontFamily"
                                ]
                            },
                            {
                                groupId: "fontColors",
                                items: [
                                    "menuBar:fontColor",
                                    "menuBar:fontBackgroundColor"
                                ]
                            },
                            {
                                groupId: "highlight",
                                items: [
                                    "menuBar:highlight"
                                ]
                            }
                        ]
                    },
                    "menuBar:heading"
                ]
            },
            {
                groupId: "list",
                items: [
                    "menuBar:bulletedList",
                    "menuBar:numberedList",
                    "menuBar:multiLevelList",
                    "menuBar:todoList"
                ]
            },
            {
                groupId: "indent",
                items: [
                    "menuBar:alignment",
                    "menuBar:lineHeight",
                    "menuBar:indent",
                    "menuBar:outdent"
                ]
            },
            {
                groupId: "caseChange",
                items: [
                    "menuBar:caseChange"
                ]
            },
            {
                groupId: "removeFormat",
                items: [
                    "menuBar:removeFormat"
                ]
            }
        ]
    },
    {
        menuId: "tools",
        label: "Tools",
        groups: [
            {
                groupId: "aiTools",
                items: [
                    "menuBar:aiAssistant",
                    "menuBar:aiCommands",
                    "menuBar:toggleAi",
                    "menuBar:aiQuickActions"
                ]
            },
            {
                groupId: "tools",
                items: [
                    "menuBar:trackChanges",
                    "menuBar:commentsArchive"
                ]
            }
        ]
    },
    {
        menuId: "help",
        label: "Help",
        groups: [
            {
                groupId: "help",
                items: [
                    "menuBar:accessibilityHelp"
                ]
            }
        ]
    }
];
/**
* Performs a cleanup and normalization of the menu bar configuration.
*/ function $29fd27cb9bdab9d2$export$95634c08279e3d6d(config) {
    let configObject;
    if (!("items" in config) || !config.items) configObject = {
        items: (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)($29fd27cb9bdab9d2$export$37ec16f94e43dd5e),
        addItems: [],
        removeItems: [],
        isVisible: true,
        isUsingDefaultConfig: true,
        ...config
    };
    else configObject = {
        items: config.items,
        removeItems: [],
        addItems: [],
        isVisible: true,
        isUsingDefaultConfig: false,
        ...config
    };
    return configObject;
}
/**
* Processes a normalized menu bar config and returns a config clone with the following modifications:
*
* * Removed components that are not available in the component factory,
* * Removed obsolete separators,
* * Purged empty menus,
* * Localized top-level menu labels.
* @internal
*/ function $29fd27cb9bdab9d2$export$f69147cda03478ca({ normalizedConfig: normalizedConfig, locale: locale, componentFactory: componentFactory, extraItems: extraItems }) {
    const configClone = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(normalizedConfig);
    $29fd27cb9bdab9d2$var$handleAdditions(normalizedConfig, configClone, extraItems);
    $29fd27cb9bdab9d2$var$handleRemovals(normalizedConfig, configClone);
    $29fd27cb9bdab9d2$var$handleAdditions(normalizedConfig, configClone, configClone.addItems);
    $29fd27cb9bdab9d2$var$purgeUnavailableComponents(normalizedConfig, configClone, componentFactory);
    $29fd27cb9bdab9d2$var$purgeEmptyMenus(normalizedConfig, configClone);
    $29fd27cb9bdab9d2$var$localizeMenuLabels(configClone, locale);
    return configClone;
}
/**
* Removes items from the menu bar config based on user `removeItems` configuration. Users can remove
* individual items, groups, or entire menus. For each removed item, a warning is logged if the item
* was not found in the configuration.
*/ function $29fd27cb9bdab9d2$var$handleRemovals(originalConfig, config) {
    const itemsToBeRemoved = config.removeItems;
    const successfullyRemovedItems = [];
    config.items = config.items.filter(({ menuId: menuId })=>{
        if (itemsToBeRemoved.includes(menuId)) {
            successfullyRemovedItems.push(menuId);
            return false;
        }
        return true;
    });
    $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (menuDefinition)=>{
        menuDefinition.groups = menuDefinition.groups.filter(({ groupId: groupId })=>{
            if (itemsToBeRemoved.includes(groupId)) {
                successfullyRemovedItems.push(groupId);
                return false;
            }
            return true;
        });
        for (const groupDefinition of menuDefinition.groups)groupDefinition.items = groupDefinition.items.filter((item)=>{
            const itemId = $29fd27cb9bdab9d2$var$getIdFromGroupItem(item);
            if (itemsToBeRemoved.includes(itemId)) {
                successfullyRemovedItems.push(itemId);
                return false;
            }
            return true;
        });
    });
    for (const itemName of itemsToBeRemoved)if (!successfullyRemovedItems.includes(itemName)) /**
	* There was a problem processing the configuration of the menu bar. The item with the given
	* name does could not be removed from the menu bar configuration.
	*
	* This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
	* to provide a menu bar item has not been loaded or there is a typo in the
	* {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar configuration}.
	*
	* @error menu-bar-item-could-not-be-removed
	* @param menuBarConfig The full configuration of the menu bar.
	* @param itemName The name of the item that was not removed from the menu bar.
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("menu-bar-item-could-not-be-removed", {
        menuBarConfig: originalConfig,
        itemName: itemName
    });
}
/**
* Adds provided items to config. It allows for adding menus, groups, and items at arbitrary
* positions in the menu bar. If the position does not exist, a warning is logged.
*/ function $29fd27cb9bdab9d2$var$handleAdditions(originalConfig, config, items) {
    const successFullyAddedItems = [];
    if (items.length == 0) return;
    for (const itemToAdd of items){
        const relation = $29fd27cb9bdab9d2$var$getRelationFromPosition(itemToAdd.position);
        const relativeId = $29fd27cb9bdab9d2$var$getRelativeIdFromPosition(itemToAdd.position);
        if ($29fd27cb9bdab9d2$var$isMenuBarMenuAddition(itemToAdd)) {
            if (!relativeId) {
                if (relation === "start") {
                    config.items.unshift(itemToAdd.menu);
                    successFullyAddedItems.push(itemToAdd);
                } else if (relation === "end") {
                    config.items.push(itemToAdd.menu);
                    successFullyAddedItems.push(itemToAdd);
                }
            } else {
                const topLevelMenuDefinitionIndex = config.items.findIndex((menuDefinition)=>menuDefinition.menuId === relativeId);
                if (topLevelMenuDefinitionIndex != -1) {
                    if (relation === "before") {
                        config.items.splice(topLevelMenuDefinitionIndex, 0, itemToAdd.menu);
                        successFullyAddedItems.push(itemToAdd);
                    } else if (relation === "after") {
                        config.items.splice(topLevelMenuDefinitionIndex + 1, 0, itemToAdd.menu);
                        successFullyAddedItems.push(itemToAdd);
                    }
                } else if ($29fd27cb9bdab9d2$var$addMenuOrItemToGroup(config, itemToAdd.menu, relativeId, relation)) successFullyAddedItems.push(itemToAdd);
            }
        } else if ($29fd27cb9bdab9d2$var$isMenuBarMenuGroupAddition(itemToAdd)) $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (menuDefinition)=>{
            if (menuDefinition.menuId === relativeId) {
                if (relation === "start") {
                    menuDefinition.groups.unshift(itemToAdd.group);
                    successFullyAddedItems.push(itemToAdd);
                } else if (relation === "end") {
                    menuDefinition.groups.push(itemToAdd.group);
                    successFullyAddedItems.push(itemToAdd);
                }
            } else {
                const relativeGroupIndex = menuDefinition.groups.findIndex((group)=>group.groupId === relativeId);
                if (relativeGroupIndex !== -1) {
                    if (relation === "before") {
                        menuDefinition.groups.splice(relativeGroupIndex, 0, itemToAdd.group);
                        successFullyAddedItems.push(itemToAdd);
                    } else if (relation === "after") {
                        menuDefinition.groups.splice(relativeGroupIndex + 1, 0, itemToAdd.group);
                        successFullyAddedItems.push(itemToAdd);
                    }
                }
            }
        });
        else if ($29fd27cb9bdab9d2$var$addMenuOrItemToGroup(config, itemToAdd.item, relativeId, relation)) successFullyAddedItems.push(itemToAdd);
    }
    for (const addedItemConfig of items)if (!successFullyAddedItems.includes(addedItemConfig)) /**
	* There was a problem processing the configuration of the menu bar. The configured item could not be added
	* because the position it was supposed to be added to does not exist.
	*
	* This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
	* to provide a menu bar item has not been loaded or there is a typo in the
	* {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar configuration}.
	*
	* @error menu-bar-item-could-not-be-removed
	* @param {object} menuBarConfig The full configuration of the menu bar.
	* @param {object} addedItemConfig The name of the item that was not removed from the menu bar.
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("menu-bar-item-could-not-be-added", {
        menuBarConfig: originalConfig,
        addedItemConfig: addedItemConfig
    });
}
/**
* Handles adding a sub-menu or an item into a group. The logic is the same for both cases.
*/ function $29fd27cb9bdab9d2$var$addMenuOrItemToGroup(config, itemOrMenuToAdd, relativeId, relation) {
    let wasAdded = false;
    $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (menuDefinition)=>{
        for (const { groupId: groupId, items: groupItems } of menuDefinition.groups){
            if (wasAdded) return;
            if (groupId === relativeId) {
                if (relation === "start") {
                    groupItems.unshift(itemOrMenuToAdd);
                    wasAdded = true;
                } else if (relation === "end") {
                    groupItems.push(itemOrMenuToAdd);
                    wasAdded = true;
                }
            } else {
                const relativeItemIndex = groupItems.findIndex((groupItem)=>{
                    return $29fd27cb9bdab9d2$var$getIdFromGroupItem(groupItem) === relativeId;
                });
                if (relativeItemIndex !== -1) {
                    if (relation === "before") {
                        groupItems.splice(relativeItemIndex, 0, itemOrMenuToAdd);
                        wasAdded = true;
                    } else if (relation === "after") {
                        groupItems.splice(relativeItemIndex + 1, 0, itemOrMenuToAdd);
                        wasAdded = true;
                    }
                }
            }
        }
    });
    return wasAdded;
}
/**
* Removes components from the menu bar configuration that are not available in the factory and would
* not be instantiated. Warns about missing components if the menu bar configuration was specified by the user.
*/ function $29fd27cb9bdab9d2$var$purgeUnavailableComponents(originalConfig, config, componentFactory) {
    $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (menuDefinition)=>{
        for (const groupDefinition of menuDefinition.groups)groupDefinition.items = groupDefinition.items.filter((item)=>{
            const isItemUnavailable = typeof item === "string" && !componentFactory.has(item);
            if (isItemUnavailable && !config.isUsingDefaultConfig) /**
			* There was a problem processing the configuration of the menu bar. The item with the given
			* name does not exist so it was omitted when rendering the menu bar.
			*
			* This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
			* to provide a menu bar item has not been loaded or there is a typo in the
			* {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar configuration}.
			*
			* Make sure the plugin responsible for this menu bar item is loaded and the menu bar configuration
			* is correct, e.g. {@link module:basic-styles/bold/boldui~BoldUI} is loaded for the `'menuBar:bold'`
			* menu bar item.
			*
			* @error menu-bar-item-unavailable
			* @param {object} menuBarConfig The full configuration of the menu bar.
			* @param {object} parentMenuConfig The config of the menu the unavailable component was defined in.
			* @param {string} componentName The name of the unavailable component.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("menu-bar-item-unavailable", {
                menuBarConfig: originalConfig,
                parentMenuConfig: (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(menuDefinition),
                componentName: item
            });
            return !isItemUnavailable;
        });
    });
}
/**
* Removes empty menus from the menu bar configuration to improve the visual UX. Such menus can occur
* when some plugins responsible for providing menu bar items have not been loaded and some part of
* the configuration populated menus using these components exclusively.
*/ function $29fd27cb9bdab9d2$var$purgeEmptyMenus(originalConfig, config) {
    const isUsingDefaultConfig = config.isUsingDefaultConfig;
    let wasSubMenuPurged = false;
    config.items = config.items.filter((menuDefinition)=>{
        if (!menuDefinition.groups.length) {
            $29fd27cb9bdab9d2$var$warnAboutEmptyMenu(originalConfig, menuDefinition, isUsingDefaultConfig);
            return false;
        }
        return true;
    });
    if (!config.items.length) {
        $29fd27cb9bdab9d2$var$warnAboutEmptyMenu(originalConfig, originalConfig, isUsingDefaultConfig);
        return;
    }
    $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (menuDefinition)=>{
        menuDefinition.groups = menuDefinition.groups.filter((groupDefinition)=>{
            if (!groupDefinition.items.length) {
                wasSubMenuPurged = true;
                return false;
            }
            return true;
        });
        for (const groupDefinition of menuDefinition.groups)groupDefinition.items = groupDefinition.items.filter((item)=>{
            if ($29fd27cb9bdab9d2$var$isMenuDefinition(item) && !item.groups.length) {
                $29fd27cb9bdab9d2$var$warnAboutEmptyMenu(originalConfig, item, isUsingDefaultConfig);
                wasSubMenuPurged = true;
                return false;
            }
            return true;
        });
    });
    if (wasSubMenuPurged) $29fd27cb9bdab9d2$var$purgeEmptyMenus(originalConfig, config);
}
function $29fd27cb9bdab9d2$var$warnAboutEmptyMenu(originalConfig, emptyMenuConfig, isUsingDefaultConfig) {
    if (isUsingDefaultConfig) return;
    /**
	* There was a problem processing the configuration of the menu bar. One of the menus
	* is empty so it was omitted when rendering the menu bar.
	*
	* This warning usually shows up when some {@link module:core/plugin~Plugin plugins} responsible for
	* providing menu bar items have not been loaded and the
	* {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar configuration} was not updated.
	*
	* Make sure all necessary editor plugins are loaded and/or update the menu bar configuration
	* to account for the missing menu items.
	*
	* @error menu-bar-menu-empty
	* @param {object} menuBarConfig The full configuration of the menu bar.
	* @param {object} emptyMenuConfig The definition of the menu that has no child items.
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("menu-bar-menu-empty", {
        menuBarConfig: originalConfig,
        emptyMenuConfig: emptyMenuConfig
    });
}
/**
* Localizes the user-config using pre-defined localized category labels.
*/ function $29fd27cb9bdab9d2$var$localizeMenuLabels(config, locale) {
    const t = locale.t;
    const localizedCategoryLabels = {
        "File": t({
            string: "File",
            id: "MENU_BAR_MENU_FILE"
        }),
        "Edit": t({
            string: "Edit",
            id: "MENU_BAR_MENU_EDIT"
        }),
        "View": t({
            string: "View",
            id: "MENU_BAR_MENU_VIEW"
        }),
        "Insert": t({
            string: "Insert",
            id: "MENU_BAR_MENU_INSERT"
        }),
        "Format": t({
            string: "Format",
            id: "MENU_BAR_MENU_FORMAT"
        }),
        "Tools": t({
            string: "Tools",
            id: "MENU_BAR_MENU_TOOLS"
        }),
        "Help": t({
            string: "Help",
            id: "MENU_BAR_MENU_HELP"
        }),
        "Text": t({
            string: "Text",
            id: "MENU_BAR_MENU_TEXT"
        }),
        "Font": t({
            string: "Font",
            id: "MENU_BAR_MENU_FONT"
        })
    };
    $29fd27cb9bdab9d2$var$walkConfigMenus(config.items, (definition)=>{
        if (definition.label in localizedCategoryLabels) definition.label = localizedCategoryLabels[definition.label];
    });
}
/**
* Recursively visits all menu definitions in the config and calls the callback for each of them.
*/ function $29fd27cb9bdab9d2$var$walkConfigMenus(definition, callback) {
    /* v8 ignore else -- @preserve */ if (Array.isArray(definition)) for (const topLevelMenuDefinition of definition)walk(topLevelMenuDefinition);
    function walk(menuDefinition) {
        callback(menuDefinition);
        for (const groupDefinition of menuDefinition.groups)for (const groupItem of groupDefinition.items)if ($29fd27cb9bdab9d2$var$isMenuDefinition(groupItem)) walk(groupItem);
    }
}
function $29fd27cb9bdab9d2$var$isMenuBarMenuAddition(definition) {
    return typeof definition === "object" && "menu" in definition;
}
function $29fd27cb9bdab9d2$var$isMenuBarMenuGroupAddition(definition) {
    return typeof definition === "object" && "group" in definition;
}
function $29fd27cb9bdab9d2$var$getRelationFromPosition(position) {
    if (position.startsWith("start")) return "start";
    else if (position.startsWith("end")) return "end";
    else if (position.startsWith("after")) return "after";
    else return "before";
}
function $29fd27cb9bdab9d2$var$getRelativeIdFromPosition(position) {
    const match = position.match(/^[^:]+:(.+)/);
    if (match) return match[1];
    return null;
}
function $29fd27cb9bdab9d2$var$getIdFromGroupItem(item) {
    return typeof item === "string" ? item : item.menuId;
}
function $29fd27cb9bdab9d2$var$isMenuDefinition(definition) {
    return typeof definition === "object" && "menuId" in definition;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/editorui
*/ const $29fd27cb9bdab9d2$var$EditorUIBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* A class providing the minimal interface that is required to successfully bootstrap any editor UI.
*/ var $29fd27cb9bdab9d2$export$19609b17c3b0114 = class extends $29fd27cb9bdab9d2$var$EditorUIBase {
    /**
	* The editor that the UI belongs to.
	*/ editor;
    /**
	* An instance of the {@link module:ui/componentfactory~ComponentFactory}, a registry used by plugins
	* to register factories of specific UI components.
	*/ componentFactory;
    /**
	* Stores the information about the editor UI focus and propagates it so various plugins and components
	* are unified as a focus group.
	*/ focusTracker;
    /**
	* Manages the tooltips displayed on mouseover and focus across the UI.
	*/ tooltipManager;
    /**
	* A helper that enables the "powered by" feature in the editor and renders a link to the project's webpage.
	*/ poweredBy;
    /**
	* A helper that enables the "evaluation badge" feature in the editor.
	*/ evaluationBadge;
    /**
	* A helper that manages the content of an `aria-live` regions used by editor features to announce status changes
	* to screen readers.
	*/ ariaLiveAnnouncer;
    /**
	* Indicates the UI is ready. Set `true` after {@link #event:ready} event is fired.
	*
	* @readonly
	* @default false
	*/ isReady = false;
    /**
	* Tracks the shadow roots hosting the DOM elements used by the editor UI (editables, toolbars, menu bar).
	*
	* Features that need the DOM events which do not cross a shadow boundary – `scroll`, `mouseenter`,
	* `mouseleave` – attach them to every tracked root with
	* {@link module:utils/dom/shadowrootregistry~listenToShadowRoots `listenToShadowRoots()`}. A feature that
	* has a node in hand wants a shadow-aware helper instead, such as
	* {@link module:utils/dom/getshadowroots~getShadowRoots `getShadowRoots()`}.
	*/ shadowRootRegistry = new (0, $c7bc2cb7e2db0227$export$62767248905409ba)();
    /**
	* Hosts the editor's floating UI: keeps the {@link module:ui/editorui/editoruiview~EditorUIView#body body
	* collection} mounted in the target resolved by {@link #_getBodyCollectionMountTarget} and registers it
	* with the shared tooltip manager. Created once the editor is {@link #isReady ready} – the view does not
	* exist earlier.
	*/ _overlayHost = null;
    /**
	* Stores all editable elements used by the editor instance.
	*/ _editableElementsMap = /* @__PURE__ */ new Map();
    /**
	* All available & focusable toolbars.
	*/ _focusableToolbarDefinitions = [];
    /**
	* All additional menu bar items, groups or menus that have their default location defined.
	*/ _extraMenuBarElements = [];
    /**
	* The last focused element to which focus should return on `Esc` press.
	*/ _lastFocusedForeignElement = null;
    /**
	* The DOM emitter instance used for visual viewport watching.
	*/ _domEmitter;
    /**
	* Creates an instance of the editor UI class.
	*
	* @param editor The editor instance.
	*/ constructor(editor){
        super();
        const editingView = editor.editing.view;
        this.editor = editor;
        this.componentFactory = new $29fd27cb9bdab9d2$export$27c285552589054d(editor);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.tooltipManager = $29fd27cb9bdab9d2$export$3cf29e47efa41626.for(editor.locale);
        this.poweredBy = new $29fd27cb9bdab9d2$export$3dbb5766eaeb5b24(editor);
        this.evaluationBadge = new $29fd27cb9bdab9d2$export$19144264d96de685(editor);
        this.ariaLiveAnnouncer = new $29fd27cb9bdab9d2$export$dd4ec0a44a434104(editor);
        this._initViewportOffset(this._readViewportOffsetFromConfig());
        $29fd27cb9bdab9d2$var$warnIfShadowRootUsedWithoutOverlayContainer(this);
        this.once("ready", ()=>{
            $29fd27cb9bdab9d2$var$warnIfConfiguredOverlayContainerDetached(editor);
            this._overlayHost = new $29fd27cb9bdab9d2$export$93bfee0bb4f77b91(editor.locale, {
                bodyCollection: this.view.body,
                shadowRootRegistry: this.shadowRootRegistry,
                tooltipManager: this.tooltipManager,
                resolveMountTarget: ()=>this._getBodyCollectionMountTarget(),
                updateEmitter: this
            });
            this._bindBodyCollectionWatchers();
            this._overlayHost.sync();
            this.isReady = true;
        });
        this.listenTo(editingView.document, "layoutChanged", this.update.bind(this));
        this.listenTo(editingView, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this));
        this._initFocusTracking();
        this._initVisualViewportSupport();
    }
    /**
	* The main (outermost) DOM element of the editor UI.
	*
	* For example, in {@link module:editor-classic/classiceditor~ClassicEditor} it is a `<div>` which
	* wraps the editable element and the toolbar. In {@link module:editor-inline/inlineeditor~InlineEditor}
	* it is the editable element itself (as there is no other wrapper). However, in
	* {@link module:editor-decoupled/decouplededitor~DecoupledEditor} it is set to `null` because this editor does not
	* come with a single "main" HTML element (its editable element and toolbar are separate).
	*
	* This property can be understood as a shorthand for retrieving the element that a specific editor integration
	* considers to be its main DOM element.
	*/ get element() {
        return null;
    }
    /**
	* Fires the {@link module:ui/editorui/editorui~EditorUI#event:update `update`} event.
	*
	* This method should be called when the editor UI (e.g. positions of its balloons) needs to be updated due to
	* some environmental change which CKEditor 5 is not aware of (e.g. resize of a container in which it is used).
	*/ update() {
        this.fire("update");
    }
    /**
	* Destroys the UI.
	*/ destroy() {
        this.stopListening();
        this.focusTracker.destroy();
        if (this._overlayHost) {
            this._overlayHost.destroy();
            this._overlayHost = null;
        }
        this.tooltipManager.release();
        this.poweredBy.destroy();
        this.evaluationBadge.destroy();
        for (const domElement of this._editableElementsMap.values()){
            domElement.ckeditorInstance = null;
            this.editor.keystrokes.stopListening(domElement);
        }
        this.shadowRootRegistry.destroy();
        this._editableElementsMap = /* @__PURE__ */ new Map();
        this._focusableToolbarDefinitions = [];
        if (this._domEmitter) this._domEmitter.stopListening();
    }
    /**
	* Stores the native DOM editable element used by the editor under a unique name.
	*
	* Also, registers the element in the editor to maintain the accessibility of the UI. When the user is editing text in a focusable
	* editable area, they can use the <kbd>Alt</kbd> + <kbd>F10</kbd> keystroke to navigate over editor toolbars. See {@link #addToolbar}.
	*
	* @param rootName The unique name of the editable element.
	* @param domElement The native DOM editable element.
	*/ setEditableElement(rootName, domElement) {
        this._editableElementsMap.set(rootName, domElement);
        if (!domElement.ckeditorInstance) domElement.ckeditorInstance = this.editor;
        this.focusTracker.add(domElement);
        this.shadowRootRegistry.registerNode(domElement);
        const setUpKeystrokeHandler = ()=>{
            if (this.editor.editing.view.getDomRoot(rootName)) return;
            this.editor.keystrokes.listenTo(domElement);
        };
        if (this.isReady) setUpKeystrokeHandler();
        else this.once("ready", setUpKeystrokeHandler);
    }
    /**
	* Removes the editable from the editor UI. Removes all handlers added by {@link #setEditableElement}.
	*
	* @param rootName The name of the editable element to remove.
	*/ removeEditableElement(rootName) {
        const domElement = this._editableElementsMap.get(rootName);
        if (!domElement) return;
        this._editableElementsMap.delete(rootName);
        this.editor.keystrokes.stopListening(domElement);
        this.focusTracker.remove(domElement);
        this.shadowRootRegistry.unregisterNode(domElement);
        domElement.ckeditorInstance = null;
    }
    /**
	* Returns the editable editor element with the given name or null if editable does not exist.
	*
	* @param rootName The editable name.
	*/ getEditableElement(rootName = "main") {
        return this._editableElementsMap.get(rootName);
    }
    /**
	* Returns array of names of all editor editable elements.
	*/ getEditableElementsNames() {
        return this._editableElementsMap.keys();
    }
    /**
	* Adds a toolbar to the editor UI. Used primarily to maintain the accessibility of the UI.
	*
	* Focusable toolbars can be accessed (focused) by users by pressing the <kbd>Alt</kbd> + <kbd>F10</kbd> keystroke.
	* Successive keystroke presses navigate over available toolbars.
	*
	* @param toolbarView A instance of the toolbar to be registered.
	*/ addToolbar(toolbarView, options = {}) {
        const attach = ()=>{
            this.focusTracker.add(toolbarView);
            this.editor.keystrokes.listenTo(toolbarView.element);
            this.shadowRootRegistry.registerNode(toolbarView.element);
        };
        if (toolbarView.isRendered) attach();
        else toolbarView.once("render", attach);
        this._focusableToolbarDefinitions.push({
            toolbarView: toolbarView,
            options: options
        });
    }
    /**
	* Registers an extra menu bar element, which could be a single item, a group of items, or a menu containing groups.
	*
	* ```ts
	* // Register a new menu bar item.
	* editor.ui.extendMenuBar( {
	*   item: 'menuBar:customFunctionButton',
	*   position: 'after:menuBar:bold'
	* } );
	*
	* // Register a new menu bar group.
	* editor.ui.extendMenuBar( {
	*   group: {
	*     groupId: 'customGroup',
	*     items: [
	*       'menuBar:customFunctionButton'
	*     ]
	*   },
	*   position: 'start:help'
	* } );
	*
	* // Register a new menu bar menu.
	* editor.ui.extendMenuBar( {
	*   menu: {
	*     menuId: 'customMenu',
	*     label: 'customMenu',
	*     groups: [
	*       {
	*         groupId: 'customGroup',
	*         items: [
	*           'menuBar:customFunctionButton'
	*         ]
	*       }
	*     ]
	*   },
	*   position: 'after:help'
	* } );
	* ```
	*/ extendMenuBar(config) {
        this._extraMenuBarElements.push(config);
    }
    /**
	* Initializes menu bar.
	*/ initMenuBar(menuBarView) {
        const menuBarViewElement = menuBarView.element;
        this.focusTracker.add(menuBarViewElement);
        this.editor.keystrokes.listenTo(menuBarViewElement);
        this.shadowRootRegistry.registerNode(menuBarViewElement);
        const normalizedMenuBarConfig = $29fd27cb9bdab9d2$export$95634c08279e3d6d(this.editor.config.get("menuBar") || {});
        menuBarView.fillFromConfig(normalizedMenuBarConfig, this.componentFactory, this._extraMenuBarElements);
        this.editor.keystrokes.set("Esc", (data, cancel)=>{
            if (!menuBarViewElement.contains(this.editor.ui.focusTracker.focusedElement)) return;
            if (this._lastFocusedForeignElement) {
                this._lastFocusedForeignElement.focus();
                this._lastFocusedForeignElement = null;
            } else this.editor.editing.view.focus();
            cancel();
        });
        this.editor.keystrokes.set("Alt+F9", (data, cancel)=>{
            if (menuBarViewElement.contains(this.editor.ui.focusTracker.focusedElement)) return;
            this._saveLastFocusedForeignElement();
            menuBarView.isFocusBorderEnabled = true;
            menuBarView.focus();
            cancel();
        });
    }
    /**
	* Returns viewport offsets object:
	*
	* ```js
	* {
	* 	top: Number,
	* 	right: Number,
	* 	bottom: Number,
	* 	left: Number
	* }
	* ```
	*
	* Only top property is currently supported.
	*/ _readViewportOffsetFromConfig() {
        const editor = this.editor;
        const viewportOffsetConfig = editor.config.get("ui.viewportOffset");
        if (viewportOffsetConfig) return viewportOffsetConfig;
        const legacyOffsetConfig = editor.config.get("toolbar.viewportTopOffset");
        if (legacyOffsetConfig) {
            /**
			* The {@link module:core/editor/editorconfig~EditorConfig#toolbar `EditorConfig#toolbar.viewportTopOffset`}
			* property has been deprecated and will be removed in the near future. Please use
			* {@link module:core/editor/editorconfig~EditorConfig#ui `EditorConfig#ui.viewportOffset`} instead.
			*
			* @error editor-ui-deprecated-viewport-offset-config
			*/ console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead.");
            return {
                top: legacyOffsetConfig
            };
        }
        return {
            top: 0
        };
    }
    /**
	* Starts listening for <kbd>Alt</kbd> + <kbd>F10</kbd> and <kbd>Esc</kbd> keystrokes in the context of focusable
	* {@link #setEditableElement editable elements} and {@link #addToolbar toolbars}
	* to allow users navigate across the UI.
	*/ _initFocusTracking() {
        const editor = this.editor;
        let candidateDefinitions;
        editor.keystrokes.set("Alt+F10", (data, cancel)=>{
            this._saveLastFocusedForeignElement();
            const currentFocusedToolbarDefinition = this._getCurrentFocusedToolbarDefinition();
            if (!currentFocusedToolbarDefinition || !candidateDefinitions) candidateDefinitions = this._getFocusableCandidateToolbarDefinitions();
            for(let i = 0; i < candidateDefinitions.length; i++){
                const candidateDefinition = candidateDefinitions.shift();
                candidateDefinitions.push(candidateDefinition);
                if (candidateDefinition !== currentFocusedToolbarDefinition && this._focusFocusableCandidateToolbar(candidateDefinition)) {
                    if (currentFocusedToolbarDefinition && currentFocusedToolbarDefinition.options.afterBlur) currentFocusedToolbarDefinition.options.afterBlur();
                    break;
                }
            }
            cancel();
        });
        editor.keystrokes.set("Esc", (data, cancel)=>{
            const focusedToolbarDef = this._getCurrentFocusedToolbarDefinition();
            if (!focusedToolbarDef) return;
            if (this._lastFocusedForeignElement) {
                this._lastFocusedForeignElement.focus();
                this._lastFocusedForeignElement = null;
            } else editor.editing.view.focus();
            if (focusedToolbarDef.options.afterBlur) focusedToolbarDef.options.afterBlur();
            cancel();
        });
    }
    /**
	* Saves last focused element that doen not belong to editing view to restore focus on `Esc`.
	*/ _saveLastFocusedForeignElement() {
        const focusedElement = this.focusTracker.focusedElement;
        if (Array.from(this._editableElementsMap.values()).includes(focusedElement) && !Array.from(this.editor.editing.view.domRoots.values()).includes(focusedElement)) this._lastFocusedForeignElement = focusedElement;
    }
    /**
	* Returns definitions of toolbars that could potentially be focused, sorted by their importance for the user.
	*
	* Focusable toolbars candidates are either:
	* * already visible,
	* * have `beforeFocus()` set in their {@link module:ui/editorui/editorui~FocusableToolbarDefinition definition} that suggests that
	* they might show up when called. Keep in mind that determining whether a toolbar will show up (and become focusable) is impossible
	* at this stage because it depends on its implementation, that in turn depends on the editing context (selection).
	*
	* **Note**: Contextual toolbars take precedence over regular toolbars.
	*/ _getFocusableCandidateToolbarDefinitions() {
        const definitions = [];
        for (const toolbarDef of this._focusableToolbarDefinitions){
            const { toolbarView: toolbarView, options: options } = toolbarDef;
            if ((0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(toolbarView.element) || options.beforeFocus) definitions.push(toolbarDef);
        }
        definitions.sort((defA, defB)=>$29fd27cb9bdab9d2$var$getToolbarDefinitionWeight(defA) - $29fd27cb9bdab9d2$var$getToolbarDefinitionWeight(defB));
        return definitions;
    }
    /**
	* Returns a definition of the toolbar that is currently visible and focused (one of its children has focus).
	*
	* `null` is returned when no toolbar is currently focused.
	*/ _getCurrentFocusedToolbarDefinition() {
        for (const definition of this._focusableToolbarDefinitions)if (definition.toolbarView.element && definition.toolbarView.element.contains(this.focusTracker.focusedElement)) return definition;
        return null;
    }
    /**
	* Focuses a focusable toolbar candidate using its definition.
	*
	* @param candidateToolbarDefinition A definition of the toolbar to focus.
	* @returns `true` when the toolbar candidate was focused. `false` otherwise.
	*/ _focusFocusableCandidateToolbar(candidateToolbarDefinition) {
        const { toolbarView: toolbarView, options: { beforeFocus: beforeFocus } } = candidateToolbarDefinition;
        if (beforeFocus) beforeFocus();
        if (!(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(toolbarView.element)) return false;
        toolbarView.focus();
        return true;
    }
    /**
	* Provides an integration between {@link #viewportOffset} and {@link module:utils/dom/scroll~scrollViewportToShowTarget}.
	* It allows the UI-agnostic engine method to consider user-configured viewport offsets specific for the integration.
	*
	* @param evt The `scrollToTheSelection` event info.
	* @param data The payload carried by the `scrollToTheSelection` event.
	*/ _handleScrollToTheSelection(evt, data) {
        const configuredViewportOffset = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            ...this.viewportOffset
        };
        data.viewportOffset.top += configuredViewportOffset.top;
        data.viewportOffset.bottom += configuredViewportOffset.bottom;
        data.viewportOffset.left += configuredViewportOffset.left;
        data.viewportOffset.right += configuredViewportOffset.right;
    }
    /**
	* Resolves where the {@link module:ui/editorui/editoruiview~EditorUIView#body body collection} should be
	* mounted:
	*
	* * the {@link module:core/editor/editorconfig~UiConfig#overlayContainer `ui.overlayContainer`}
	*   configuration, if set;
	* * otherwise, resolved from the first editing root connected to a document (an editor may span several,
	*   for example a multi-root editor): the shadow root that root lives in (open or closed) when there is
	*   one, otherwise `document.body`;
	* * otherwise `null` – no editing root is connected yet, so the body collection is not attached to the
	*   DOM before the editor itself is.
	*
	* Resolving from the connected editing root on every sync also moves the body collection back out
	* of a shadow root if the editing root ever leaves it.
	*/ _getBodyCollectionMountTarget() {
        const configuredTarget = this.editor.config.get("ui.overlayContainer");
        if (configuredTarget) return configuredTarget;
        for (const domRoot of this.editor.editing.view.domRoots.values()){
            const mountRoot = (0, $c7bc2cb7e2db0227$export$da615035af2261f1)(domRoot);
            if (mountRoot) return mountRoot;
        }
        return null;
    }
    /**
	* Ensures that the focus tracker and the shadow root registry are aware of all views' DOM elements in the
	* body collection.
	*/ _bindBodyCollectionWatchers() {
        const body = this.view.body;
        for (const view of body){
            this.focusTracker.add(view.element);
            this.shadowRootRegistry.registerNode(view.element);
        }
        body.on("add", (evt, view)=>{
            this.focusTracker.add(view.element);
            this.shadowRootRegistry.registerNode(view.element);
        });
        body.on("remove", (evt, view)=>{
            this.focusTracker.remove(view.element);
            this.shadowRootRegistry.unregisterNode(view.element);
        });
    }
    /**
	* Set initial viewport offset and setup visualTop augmentation.
	*/ _initViewportOffset(viewportOffsetConfig) {
        this.on("set:viewportOffset", (evt, name, value)=>{
            const visualTop = this._getVisualViewportTopOffset(value);
            if (value.visualTop !== visualTop) evt.return = {
                ...value,
                visualTop: visualTop
            };
        });
        this.set("viewportOffset", viewportOffsetConfig);
    }
    /**
	* Listen to visual viewport changes and update the viewportOffset with the visualTop property
	* according to the visible part of it (visual viewport).
	*/ _initVisualViewportSupport() {
        if (!(0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport) return;
        const updateViewport = ()=>{
            const visualTop = this._getVisualViewportTopOffset(this.viewportOffset);
            if (this.viewportOffset.visualTop !== visualTop) this.viewportOffset = {
                ...this.viewportOffset,
                visualTop: visualTop
            };
        };
        this._domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
        this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport, "scroll", updateViewport);
        this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport, "resize", updateViewport);
    }
    /**
	* Calculate the viewport top offset according to the visible part of it (visual viewport).
	*/ _getVisualViewportTopOffset(viewportOffset) {
        const visualViewportOffsetTop = (0, $c7bc2cb7e2db0227$export$cdd2bda8bf1fea96)().top;
        const viewportTopOffset = viewportOffset.top || 0;
        return visualViewportOffsetTop > viewportTopOffset ? 0 : viewportTopOffset - visualViewportOffsetTop;
    }
};
/**
* Returns a number (weight) for a toolbar definition. Visible toolbars have a higher priority and so do
* contextual toolbars (displayed in the context of a content, for instance, an image toolbar).
*
* A standard invisible toolbar is the heaviest. A visible contextual toolbar is the lightest.
*
* @param toolbarDef A toolbar definition to be weighted.
*/ function $29fd27cb9bdab9d2$var$getToolbarDefinitionWeight(toolbarDef) {
    const { toolbarView: toolbarView, options: options } = toolbarDef;
    let weight = 10;
    if ((0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(toolbarView.element)) weight--;
    if (options.isContextual) weight -= 2;
    return weight;
}
/**
* Warns, when the editor is ready, if a {@link module:core/editor/editorconfig~UiConfig#overlayContainer
* `ui.overlayContainer`} is configured but is not connected to the document. The overlay layer still mounts
* into it, but its floating UI (balloons, dialogs, tooltips) will not be visible until the element is inserted
* into the document.
*
* @param editor The editor to read the configuration from.
*/ function $29fd27cb9bdab9d2$var$warnIfConfiguredOverlayContainerDetached(editor) {
    const configuredContainer = editor.config.get("ui.overlayContainer");
    if (configuredContainer && !configuredContainer.isConnected) /**
	* The element passed as {@link module:core/editor/editorconfig~UiConfig#overlayContainer
	* `config.ui.overlayContainer`} is not connected to the document. The overlay layer mounts into it
	* anyway, but its floating UI (balloons, dialogs, tooltips) stays invisible until the element is
	* inserted into the document.
	*
	* Make sure the configured container is attached to the document before creating the editor, or attach
	* it afterwards.
	*
	* @error ui-overlay-container-not-connected
	* @param {HTMLElement|ShadowRoot} overlayContainer The configured, not connected container.
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("ui-overlay-container-not-connected", {
        overlayContainer: configuredContainer
    });
}
/**
* Warns as soon as the {@link ~EditorUI#shadowRootRegistry shadow root registry} starts tracking the first shadow
* root (i.e. the editor UI turns out to live in shadow DOM) while no
* {@link module:core/editor/editorconfig~UiConfig#overlayContainer `ui.overlayContainer`} is configured.
*
* @param ui The editor UI whose registry and configuration should be checked.
*/ function $29fd27cb9bdab9d2$var$warnIfShadowRootUsedWithoutOverlayContainer(ui) {
    if (ui.editor.config.get("ui.overlayContainer")) return;
    ui.shadowRootRegistry.once("add", (evt, shadowRoot)=>{
        /**
		* The editor UI is rendered inside a shadow root but
		* {@link module:core/editor/editorconfig~UiConfig#overlayContainer `config.ui.overlayContainer`} is not
		* configured. In this case the overlay layer (balloons, dialogs, tooltips) is mounted automatically into
		* the shadow root hosting the editing root.
		*
		* Such an automatically chosen container inherits the layout of the shadow host and its ancestors. If any of
		* them creates a containing block or a stacking context – for example it has `position: relative`,
		* `overflow: hidden`, a `transform`, or a low `z-index` – the floating UI may be misplaced, clipped, or
		* rendered underneath other content of the page.
		*
		* To make sure the floating UI behaves correctly, set the overlay container explicitly. See the
		* {@link module:core/editor/editorconfig~UiConfig#overlayContainer `config.ui.overlayContainer`}
		* documentation to learn where such a container should be located. Configuring it also silences
		* this warning.
		*
		* @error ui-overlay-container-not-configured
		* @param {ShadowRoot} shadowRoot The shadow root the editor UI was detected in.
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("ui-overlay-container-not-configured", {
            shadowRoot: shadowRoot
        });
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/editoruiview
*/ /**
* The editor UI view class. Base class for the editor main views.
*/ var $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views, detached from the DOM
	* structure of the editor, like panels, icons etc.
	*/ body;
    /**
	* Menu bar view instance. Initialized by default in:
	*
	* * balloon editor;
	* * decoupled editor;
	* * multiroot editor.
	*/ menuBarView;
    /**
	* Toolbar view instance. Initialized by default in:
	*
	* * classic editor;
	* * decoupled editor;
	* * inline editor;
	* * multiroot editor.
	*/ toolbar;
    /**
	* Creates an instance of the editor UI view class.
	*
	* @param locale The locale instance.
	*/ constructor(locale){
        super(locale);
        this.body = new $29fd27cb9bdab9d2$export$f96d1f01684ec5c2(locale);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this.body.destroy();
        return super.destroy();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editorui/boxed/boxededitoruiview
*/ /**
* The boxed editor UI view class. This class represents an editor interface
* consisting of a toolbar and an editable area, enclosed within a box.
*/ var $29fd27cb9bdab9d2$export$dbf7aa4890ad2bdb = class extends $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c {
    /**
	* Collection of the child views located in the top (`.ck-editor__top`)
	* area of the UI.
	*/ top;
    /**
	* Collection of the child views located in the main (`.ck-editor__main`)
	* area of the UI.
	*/ main;
    /**
	* Voice label of the UI.
	*/ _voiceLabelView;
    /**
	* Creates an instance of the boxed editor UI view class.
	*
	* @param locale The locale instance..
	*/ constructor(locale){
        super(locale);
        this.top = this.createCollection();
        this.main = this.createCollection();
        this._voiceLabelView = this._createVoiceLabel();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-reset",
                    "ck-editor",
                    "ck-rounded-corners"
                ],
                role: "application",
                dir: locale.uiLanguageDirection,
                lang: locale.uiLanguage,
                "aria-labelledby": this._voiceLabelView.id
            },
            children: [
                this._voiceLabelView,
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-editor__top",
                            "ck-reset_all"
                        ],
                        role: "presentation"
                    },
                    children: this.top
                },
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-editor__main"
                        ],
                        role: "presentation"
                    },
                    children: this.main
                }
            ]
        });
    }
    /**
	* Creates a voice label view instance.
	*/ _createVoiceLabel() {
        const t = this.t;
        const voiceLabel = new $29fd27cb9bdab9d2$export$84062398251b1ba();
        voiceLabel.text = t("Rich Text Editor");
        voiceLabel.extendTemplate({
            attributes: {
                class: "ck-voice-label"
            }
        });
        return voiceLabel;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editableui/editableuiview
*/ /**
* The editable UI view class.
*/ var $29fd27cb9bdab9d2$export$7e5f167b8e25ab90 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* The name of the editable UI view.
	*/ name = null;
    /**
	* The editing view instance the editable is related to. Editable uses the editing
	* view to dynamically modify its certain DOM attributes after {@link #render rendering}.
	*
	* **Note**: The DOM attributes are performed by the editing view and not UI
	* {@link module:ui/view~View#bindTemplate template bindings} because once rendered,
	* the editable DOM element must remain under the full control of the engine to work properly.
	*/ _editingView;
    /**
	* The element which is the main editable element (usually the one with `contentEditable="true"`).
	*/ _editableElement;
    /**
	* Whether an external {@link #_editableElement} was passed into the constructor, which also means
	* the view will not render its {@link #template}.
	*/ _hasExternalElement;
    /**
	* Creates an instance of EditableUIView class.
	*
	* @param locale The locale instance.
	* @param editingView The editing view instance the editable is related to.
	* @param editableElement The editable element. If an existing `HTMLElement` is passed, the view applies its
	* template to it; otherwise the view creates a fresh element (a `<div>` by default, or one matching the given
	* {@link module:core/editor/editorconfig~ViewRootElementDefinition}).
	*/ constructor(locale, editingView, editableElement){
        super(locale);
        const { name: name, classes: classes, styles: styles, attributes: attributes } = ($29fd27cb9bdab9d2$var$isElement$1(editableElement) ? void 0 : editableElement) || {};
        this.set("isFocused", false);
        this.set("isInlineRoot", false);
        this.set("isMainFrameEditingRoot", false);
        this.setTemplate({
            tag: name || "div",
            attributes: {
                ...attributes,
                class: [
                    "ck",
                    "ck-content",
                    "ck-editor__editable",
                    "ck-rounded-corners",
                    this.bindTemplate.if("isInlineRoot", "ck-editor__editable_inline-root"),
                    this.bindTemplate.if("isMainFrameEditingRoot", "ck-editor__editable_root"),
                    ...classes ? (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(classes) : []
                ],
                ...styles && {
                    style: styles
                },
                lang: locale.contentLanguage,
                dir: locale.contentLanguageDirection
            }
        });
        this._editableElement = $29fd27cb9bdab9d2$var$isElement$1(editableElement) ? editableElement : void 0;
        this._hasExternalElement = !!this._editableElement;
        this._editingView = editingView;
    }
    /**
	* Renders the view by either applying the {@link #template} to the existing
	* {@link module:ui/editableui/editableuiview~EditableUIView#_editableElement} or assigning {@link #element}
	* as {@link module:ui/editableui/editableuiview~EditableUIView#_editableElement}.
	*/ render() {
        super.render();
        if (this._hasExternalElement) this.template.apply(this.element = this._editableElement);
        else this._editableElement = this.element;
        this.on("change:isFocused", ()=>this._updateIsFocusedClasses());
        this._updateIsFocusedClasses();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        if (this._hasExternalElement) this.template.revert(this._editableElement);
        super.destroy();
    }
    /**
	* Whether an external {@link #_editableElement} was passed into the constructor, which also means
	* the view will not render its {@link #template}.
	*/ get hasExternalElement() {
        return this._hasExternalElement;
    }
    /**
	* Updates the `ck-focused` and `ck-blurred` CSS classes on the {@link #element} according to
	* the {@link #isFocused} property value using the {@link #_editingView editing view} API.
	*/ _updateIsFocusedClasses() {
        const editingView = this._editingView;
        if (editingView.isRenderingInProgress) updateAfterRender(this);
        else update(this);
        function update(view) {
            editingView.change((writer)=>{
                const viewRoot = editingView.document.getRoot(view.name);
                writer.addClass(view.isFocused ? "ck-focused" : "ck-blurred", viewRoot);
                writer.removeClass(view.isFocused ? "ck-blurred" : "ck-focused", viewRoot);
            });
        }
        function updateAfterRender(view) {
            editingView.once("change:isRenderingInProgress", (evt, name, value)=>{
                if (!value) update(view);
                else updateAfterRender(view);
            });
        }
    }
};
/**
* An alias for `isElement` from `es-toolkit/compat` with additional type guard.
*/ function $29fd27cb9bdab9d2$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/editableui/inline/inlineeditableuiview
*/ /**
* The inline editable UI class implementing an inline {@link module:ui/editableui/editableuiview~EditableUIView}.
*/ var $29fd27cb9bdab9d2$export$7a9e58c3d1414b = class extends $29fd27cb9bdab9d2$export$7e5f167b8e25ab90 {
    /**
	* The cached options object passed to the constructor.
	*/ _options;
    /**
	* Creates an instance of the InlineEditableUIView class.
	*
	* @param locale The locale instance.
	* @param editingView The editing view instance the editable is related to.
	* @param editableElement The editable element. May be an existing `HTMLElement`, a
	* {@link module:core/editor/editorconfig~ViewRootElementDefinition} describing the element to create,
	* or `undefined` to create a default `<div>` element. See
	* {@link module:ui/editableui/editableuiview~EditableUIView}.
	* @param options Additional configuration of the view.
	* @param options.label The label of the editable for assistive technologies. If not provided, a default label is used or,
	* the existing `aria-label` attribute value from the specified `editableElement` is preserved.
	*/ constructor(locale, editingView, editableElement, options = {}){
        super(locale, editingView, editableElement);
        this._options = options;
        this.extendTemplate({
            attributes: {
                role: "textbox",
                class: "ck-editor__editable_inline"
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        const editingView = this._editingView;
        editingView.change((writer)=>{
            const viewRoot = editingView.document.getRoot(this.name);
            writer.setAttribute("aria-label", this.getEditableAriaLabel(), viewRoot);
        });
    }
    /**
	* Returns a normalized label for the editable view based on the environment.
	*/ getEditableAriaLabel() {
        const t = this.locale.t;
        const label = this._options.label;
        const editableElement = this._editableElement;
        const editableName = this.name;
        if (typeof label == "string") return label;
        else if (typeof label === "object") return label[editableName];
        else if (typeof label === "function") return label(this);
        else if (editableElement) {
            const existingLabel = editableElement.getAttribute("aria-label");
            if (existingLabel) return existingLabel;
        }
        return t("Rich Text Editor. Editing area: %0", editableName);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/formrow/formrowview
*/ /**
* The class representing a single row in a form,
*/ var $29fd27cb9bdab9d2$export$bcc7336b534c1c75 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* A collection of row items (buttons, dropdowns, etc.).
	*/ children;
    /**
	* Creates an instance of the form row class.
	*
	* @param locale The locale instance.
	* @param options.labelView When passed, the row gets the `group` and `aria-labelledby`
	* DOM attributes and gets described by the label.
	*/ constructor(locale, options = {}){
        super(locale);
        const bind = this.bindTemplate;
        this.set("class", [
            "ck",
            "ck-form__row",
            ...(0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.class || [])
        ]);
        this.children = this.createCollection();
        if (options.children) options.children.forEach((child)=>this.children.add(child));
        this.set("_role", null);
        this.set("_ariaLabelledBy", null);
        if (options.labelView) this.set({
            _role: "group",
            _ariaLabelledBy: options.labelView.id
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: bind.to("class", (classes)=>classes.join(" ")),
                role: bind.to("_role"),
                "aria-labelledby": bind.to("_ariaLabelledBy")
            },
            children: this.children
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/iframe/iframeview
*/ /**
* The iframe view class.
*
* ```ts
* const iframe = new IframeView();
*
* iframe.render();
* document.body.appendChild( iframe.element );
*
* iframe.on( 'loaded', () => {
* 	console.log( 'The iframe has loaded', iframe.element.contentWindow );
* } );
*
* iframe.element.src = 'https://ckeditor.com';
* ```
*/ var $29fd27cb9bdab9d2$export$fe1e47b5631a50b2 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Creates a new instance of the iframe view.
	*
	* @param locale The locale instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "iframe",
            attributes: {
                class: [
                    "ck",
                    "ck-reset_all"
                ],
                sandbox: "allow-same-origin allow-scripts"
            },
            on: {
                load: bind.to("loaded")
            }
        });
    }
    /**
	* Renders the iframe's {@link #element} and returns a `Promise` for asynchronous
	* child `contentDocument` loading process.
	*
	* @returns A promise which resolves once the iframe `contentDocument` has
	* been {@link #event:loaded}.
	*/ render() {
        return new Promise((resolve)=>{
            this.on("loaded", resolve);
            return super.render();
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/labeledinput/labeledinputview
*/ /**
* The labeled input view class.
*/ var $29fd27cb9bdab9d2$export$106e098051623909 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* The label view.
	*/ labelView;
    /**
	* The input view.
	*/ inputView;
    /**
	* The status view for the {@link #inputView}. It displays {@link #errorText} and
	* {@link #infoText}.
	*/ statusView;
    /**
	* Creates an instance of the labeled input view class.
	*
	* @param locale The locale instance.
	* @param InputView Constructor of the input view.
	*/ constructor(locale, InputView){
        super(locale);
        const inputUid = `ck-input-${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        const statusUid = `ck-status-${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        this.set("label", void 0);
        this.set("value", void 0);
        this.set("isReadOnly", false);
        this.set("errorText", null);
        this.set("infoText", null);
        this.labelView = this._createLabelView(inputUid);
        this.inputView = this._createInputView(InputView, inputUid, statusUid);
        this.statusView = this._createStatusView(statusUid);
        this.bind("_statusText").to(this, "errorText", this, "infoText", (errorText, infoText)=>errorText || infoText);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-labeled-input",
                    bind.if("isReadOnly", "ck-disabled")
                ]
            },
            children: [
                this.labelView,
                this.inputView,
                this.statusView
            ]
        });
    }
    /**
	* Creates label view class instance and bind with view.
	*
	* @param id Unique id to set as labelView#for attribute.
	*/ _createLabelView(id) {
        const labelView = new $29fd27cb9bdab9d2$export$84062398251b1ba(this.locale);
        labelView.for = id;
        labelView.bind("text").to(this, "label");
        return labelView;
    }
    /**
	* Creates input view class instance and bind with view.
	*
	* @param InputView Input view constructor.
	* @param inputUid Unique id to set as inputView#id attribute.
	* @param statusUid Unique id of the status for the input's `aria-describedby` attribute.
	*/ _createInputView(InputView, inputUid, statusUid) {
        const inputView = new InputView(this.locale, statusUid);
        inputView.id = inputUid;
        inputView.ariaDescribedById = statusUid;
        inputView.bind("value").to(this);
        inputView.bind("isReadOnly").to(this);
        inputView.bind("hasError").to(this, "errorText", (value)=>!!value);
        inputView.on("input", ()=>{
            this.errorText = null;
        });
        return inputView;
    }
    /**
	* Creates the status view instance. It displays {@link #errorText} and {@link #infoText}
	* next to the {@link #inputView}. See {@link #_statusText}.
	*
	* @param statusUid Unique id of the status, shared with the input's `aria-describedby` attribute.
	*/ _createStatusView(statusUid) {
        const statusView = new $29fd27cb9bdab9d2$export$27a5bd065ad55220(this.locale);
        const bind = this.bindTemplate;
        statusView.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-labeled-input__status",
                    bind.if("errorText", "ck-labeled-input__status_error"),
                    bind.if("_statusText", "ck-hidden", (value)=>!value)
                ],
                id: statusUid,
                role: bind.if("errorText", "alert")
            },
            children: [
                {
                    text: bind.to("_statusText")
                }
            ]
        });
        return statusView;
    }
    /**
	* Moves the focus to the input and selects the value.
	*/ select() {
        this.inputView.select();
    }
    /**
	* Focuses the input.
	*/ focus() {
        this.inputView.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A filter function that returns matching item and group names in the list view.
*/ function $29fd27cb9bdab9d2$export$b01630edd1e2c0f1(regExp, items) {
    let totalItemsCount = 0;
    let resultsCount = 0;
    for (const groupView of items){
        const group = groupView;
        const groupItems = group.items;
        const isGroupLabelMatching = regExp && !!group.label.match(regExp);
        group.labelView.highlightText(isGroupLabelMatching ? regExp : null);
        for (const listItemView of groupItems){
            const buttonView = listItemView.children.first;
            const labelView = buttonView.labelView;
            if (!regExp) {
                listItemView.isVisible = true;
                labelView.highlightText(null);
            } else {
                const isItemLabelMatching = !!buttonView.label.match(regExp);
                labelView.highlightText(isItemLabelMatching ? regExp : null);
                listItemView.isVisible = isGroupLabelMatching || isItemLabelMatching;
            }
        }
        const visibleInGroupCount = groupItems.filter((listItemView)=>listItemView.isVisible).length;
        totalItemsCount += group.items.length;
        resultsCount += isGroupLabelMatching ? group.items.length : visibleInGroupCount;
        group.isVisible = isGroupLabelMatching || !!visibleInGroupCount;
    }
    return {
        resultsCount: resultsCount,
        totalItemsCount: totalItemsCount
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/notification/notification
*/ /**
* The Notification plugin.
*
* This plugin sends a few types of notifications: `success`, `info` and `warning`. The notifications need to be
* handled and displayed by a plugin responsible for showing the UI of the notifications. Using this plugin for dispatching
* notifications makes it possible to switch the notifications UI.
*
* Note that every unhandled and not stopped `warning` notification will be displayed as a system alert.
* See {@link module:ui/notification/notification~Notification#showWarning}.
*/ var $29fd27cb9bdab9d2$export$14834abbfce3b8cd = class extends (0, $7ca4ca5784e50ca9$export$a3df350528b28529) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Notification";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.on("show:warning", (evt, data)=>{
            window.alert(data.message);
        }, {
            priority: "lowest"
        });
    }
    /**
	* Shows a success notification.
	*
	* By default, it fires the {@link #event:show:success `show:success` event} with the given `data`. The event namespace can be extended
	* using the `data.namespace` option. For example:
	*
	* ```ts
	* showSuccess( 'Image is uploaded.', {
	* 	namespace: 'upload:image'
	* } );
	* ```
	*
	* will fire the `show:success:upload:image` event.
	*
	* You can provide the title of the notification:
	*
	* ```ts
	* showSuccess( 'Image is uploaded.', {
	* 	title: 'Image upload success'
	* } );
	* ```
	*
	* @param message The content of the notification.
	* @param data Additional data.
	* @param data.namespace Additional event namespace.
	* @param data.title The title of the notification.
	*/ showSuccess(message, data = {}) {
        this._showNotification({
            message: message,
            type: "success",
            namespace: data.namespace,
            title: data.title
        });
    }
    /**
	* Shows an information notification.
	*
	* By default, it fires the {@link #event:show:info `show:info` event} with the given `data`. The event namespace can be extended
	* using the `data.namespace` option. For example:
	*
	* ```ts
	* showInfo( 'Editor is offline.', {
	* 	namespace: 'editor:status'
	* } );
	* ```
	*
	* will fire the `show:info:editor:status` event.
	*
	* You can provide the title of the notification:
	*
	* ```ts
	* showInfo( 'Editor is offline.', {
	* 	title: 'Network information'
	* } );
	* ```
	*
	* @param message The content of the notification.
	* @param data Additional data.
	* @param data.namespace Additional event namespace.
	* @param data.title The title of the notification.
	*/ showInfo(message, data = {}) {
        this._showNotification({
            message: message,
            type: "info",
            namespace: data.namespace,
            title: data.title
        });
    }
    /**
	* Shows a warning notification.
	*
	* By default, it fires the {@link #event:show:warning `show:warning` event}
	* with the given `data`. The event namespace can be extended using the `data.namespace` option. For example:
	*
	* ```ts
	* showWarning( 'Image upload error.', {
	* 	namespace: 'upload:image'
	* } );
	* ```
	*
	* will fire the `show:warning:upload:image` event.
	*
	* You can provide the title of the notification:
	*
	* ```ts
	* showWarning( 'Image upload error.', {
	* 	title: 'Upload failed'
	* } );
	* ```
	*
	* Note that each unhandled and not stopped `warning` notification will be displayed as a system alert.
	* The plugin responsible for displaying warnings should `stop()` the event to prevent displaying it as an alert:
	*
	* ```ts
	* notifications.on( 'show:warning', ( evt, data ) => {
	* 	// Do something with the data.
	*
	* 	// Stop this event to prevent displaying it as an alert.
	* 	evt.stop();
	* } );
	* ```
	*
	* You can attach many listeners to the same event and `stop()` this event in a listener with a low priority:
	*
	* ```ts
	* notifications.on( 'show:warning', ( evt, data ) => {
	* 	// Show the warning in the UI, but do not stop it.
	* } );
	*
	* notifications.on( 'show:warning', ( evt, data ) => {
	* 	// Log the warning to some error tracker.
	*
	* 	// Stop this event to prevent displaying it as an alert.
	* 	evt.stop();
	* }, { priority: 'low' } );
	* ```
	*
	* @param message The content of the notification.
	* @param data Additional data.
	* @param data.namespace Additional event namespace.
	* @param data.title The title of the notification.
	*/ showWarning(message, data = {}) {
        this._showNotification({
            message: message,
            type: "warning",
            namespace: data.namespace,
            title: data.title
        });
    }
    /**
	* Fires the `show` event with the specified type, namespace and message.
	*
	* @param data The message data.
	* @param data.message The content of the notification.
	* @param data.type The type of the message.
	* @param data.namespace Additional event namespace.
	* @param data.title The title of the notification.
	*/ _showNotification(data) {
        const event = data.namespace ? `show:${data.type}:${data.namespace}` : `show:${data.type}`;
        this.fire(event, {
            message: data.message,
            type: data.type,
            title: data.title || ""
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/model
*/ const $29fd27cb9bdab9d2$var$UIModelBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The base MVC model class.
*/ var $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b = class extends $29fd27cb9bdab9d2$var$UIModelBase {
    /**
	* Creates a new Model instance.
	*
	* @param attributes The model state attributes to be defined during the instance creation.
	* @param properties The (out of state) properties to be appended to the instance during creation.
	*/ constructor(attributes, properties){
        super();
        if (properties) (0, $c4c424a07e1933a9$export$64c881bba8e369b4)(this, properties);
        if (attributes) this.set(attributes);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/panel/balloon/contextualballoon
*/ const $29fd27cb9bdab9d2$var$toPx$4 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* Provides the common contextual balloon for the editor.
*
* The role of this plugin is to unify the contextual balloons logic, simplify views management and help
* avoid the unnecessary complexity of handling multiple {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
* instances in the editor.
*
* This plugin allows for creating single or multiple panel stacks.
*
* Each stack may have multiple views, with the one on the top being visible. When the visible view is removed from the stack,
* the previous view becomes visible.
*
* It might be useful to implement nested navigation in a balloon. For instance, a toolbar view may contain a link button.
* When you click it, a link view (which lets you set the URL) is created and put on top of the toolbar view, so the link panel
* is displayed. When you finish editing the link and close (remove) the link view, the toolbar view is visible again.
*
* However, there are cases when there are multiple independent balloons to be displayed, for instance, if the selection
* is inside two inline comments at the same time. For such cases, you can create two independent panel stacks.
* The contextual balloon plugin will create a navigation bar to let the users switch between these panel stacks using the "Next"
* and "Previous" buttons.
*
* If there are no views in the current stack, the balloon panel will try to switch to the next stack. If there are no
* panels in any stack, the balloon panel will be hidden.
*
* **Note**: To force the balloon panel to show only one view, even if there are other stacks, use the `singleViewMode=true` option
* when {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon#add adding} a view to a panel.
*
* From the implementation point of view, the contextual ballon plugin is reusing a single
* {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView} instance to display multiple contextual balloon
* panels in the editor. It also creates a special {@link module:ui/panel/balloon/contextualballoon~RotatorView rotator view},
* used to manage multiple panel stacks. Rotator view is a child of the balloon panel view and the parent of the specific
* view you want to display. If there is more than one panel stack to be displayed, the rotator view will add a
* navigation bar. If there is only one stack, the rotator view is transparent (it does not add any UI elements).
*/ var $29fd27cb9bdab9d2$export$d474f494ad2d7f9c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The {@link module:utils/dom/position~DomOptimalPositionOptions#limiter position limiter}
	* for the {@link #view balloon}, used when no `limiter` has been passed into {@link #add}
	* or {@link #updatePosition}.
	*
	* By default, a function that obtains the farthest DOM
	* {@link module:engine/view/rooteditableelement~ViewRootEditableElement}
	* of the {@link module:engine/view/document~ViewDocument#selection}.
	*/ positionLimiter;
    visibleStack;
    /**
	* The map of views and their stacks.
	*/ _viewToStack = /* @__PURE__ */ new Map();
    /**
	* The map of IDs and stacks.
	*/ _idToStack = /* @__PURE__ */ new Map();
    /**
	* The common balloon panel view.
	*/ _view = null;
    /**
	* Rotator view embedded in the contextual balloon.
	* Displays the currently visible view in the balloon and provides navigation for switching stacks.
	*/ _rotatorView = null;
    /**
	* Displays fake panels under the balloon panel view when multiple stacks are added to the balloon.
	*/ _fakePanelsView = null;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ContextualBalloon";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.positionLimiter = ()=>{
            const view = this.editor.editing.view;
            const editableElement = view.document.selection.editableElement;
            if (editableElement) return view.domConverter.mapViewToDom(editableElement.root);
            return null;
        };
        this.decorate("getPositionOptions");
        this.set("visibleView", null);
        this.set("_numberOfStacks", 0);
        this.set("_singleViewMode", false);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this._view) this._view.destroy();
        if (this._rotatorView) this._rotatorView.destroy();
        if (this._fakePanelsView) this._fakePanelsView.destroy();
    }
    /**
	* The common balloon panel view.
	*/ get view() {
        if (!this._view) this._createPanelView();
        return this._view;
    }
    /**
	* Returns `true` when the given view is in one of the stacks. Otherwise returns `false`.
	*/ hasView(view) {
        return Array.from(this._viewToStack.keys()).includes(view);
    }
    /**
	* Adds a new view to the stack and makes it visible if the current stack is visible
	* or it is the first view in the balloon.
	*
	* @param data The configuration of the view.
	* @param data.stackId The ID of the stack that the view is added to. Defaults to `'main'`.
	* @param data.view The content of the balloon.
	* @param data.position Positioning options.
	* @param data.balloonClassName An additional CSS class added to the {@link #view balloon} when visible.
	* @param data.withArrow Whether the {@link #view balloon} should be rendered with an arrow. Defaults to `true`.
	* @param data.singleViewMode Whether the view should be the only visible view even if other stacks were added. Defaults to `false`.
	*/ add(data) {
        if (!this._view) this._createPanelView();
        if (this.hasView(data.view)) /**
		* Trying to add configuration of the same view more than once.
		*
		* @error contextualballoon-add-view-exist
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("contextualballoon-add-view-exist", [
            this,
            data
        ]);
        const stackId = data.stackId || "main";
        if (!this._idToStack.has(stackId)) {
            this._idToStack.set(stackId, /* @__PURE__ */ new Map([
                [
                    data.view,
                    data
                ]
            ]));
            this._viewToStack.set(data.view, this._idToStack.get(stackId));
            this._numberOfStacks = this._idToStack.size;
            if (!this._visibleStack || data.singleViewMode) this.showStack(stackId);
            return;
        }
        const stack = this._idToStack.get(stackId);
        if (data.singleViewMode) this.showStack(stackId);
        stack.set(data.view, data);
        this._viewToStack.set(data.view, stack);
        if (stack === this._visibleStack) this._showView(data);
    }
    /**
	* Removes the given view from the stack. If the removed view was visible,
	* the view preceding it in the stack will become visible instead.
	* When there is no view in the stack, the next stack will be displayed.
	* When there are no more stacks, the balloon will hide.
	*
	* @param view A view to be removed from the balloon.
	*/ remove(view) {
        if (!this.hasView(view)) /**
		* Trying to remove the configuration of the view not defined in the stack.
		*
		* @error contextualballoon-remove-view-not-exist
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("contextualballoon-remove-view-not-exist", [
            this,
            view
        ]);
        const stack = this._viewToStack.get(view);
        if (this._singleViewMode && this.visibleView === view) this._singleViewMode = false;
        if (this.visibleView === view) {
            if (stack.size === 1) {
                if (this._idToStack.size > 1) this._showNextStack();
                else {
                    this.view.hide();
                    this.visibleView = null;
                    this._rotatorView.hideView();
                }
            } else this._showView(Array.from(stack.values())[stack.size - 2]);
        }
        if (stack.size === 1) {
            this._idToStack.delete(this._getStackId(stack));
            this._numberOfStacks = this._idToStack.size;
        } else stack.delete(view);
        this._viewToStack.delete(view);
    }
    /**
	* Updates the position of the balloon using the position data of the first visible view in the stack.
	* When new position data is given, the position data of the currently visible view will be updated.
	*
	* @param position Position options.
	*/ updatePosition(position) {
        if (position) this._visibleStack.get(this.visibleView).position = position;
        this.view.pin(this.getPositionOptions());
        this._fakePanelsView.updatePosition();
    }
    /**
	* Returns position options of the last view in the stack.
	* This keeps the balloon in the same position when the view is changed.
	*/ getPositionOptions() {
        let position = Array.from(this._visibleStack.values()).pop().position;
        if (position) {
            if (!position.limiter) position = Object.assign({}, position, {
                limiter: this.positionLimiter
            });
            position = Object.assign({}, position, {
                viewportOffsetConfig: {
                    ...this.editor.ui.viewportOffset,
                    top: this.editor.ui.viewportOffset.visualTop
                }
            });
        }
        return position;
    }
    /**
	* Shows the last view from the stack of a given ID.
	*/ showStack(id) {
        this.visibleStack = id;
        const stack = this._idToStack.get(id);
        if (!stack) /**
		* Trying to show a stack that does not exist.
		*
		* @error contextualballoon-showstack-stack-not-exist
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("contextualballoon-showstack-stack-not-exist", this);
        if (this._visibleStack === stack) return;
        this._showView(Array.from(stack.values()).pop());
    }
    /**
	* Initializes view instances.
	*/ _createPanelView() {
        this._view = new $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c(this.editor.locale);
        this.editor.ui.view.body.add(this._view);
        this._rotatorView = this._createRotatorView();
        this._fakePanelsView = this._createFakePanelsView();
    }
    /**
	* Returns the stack of the currently visible view.
	*/ get _visibleStack() {
        return this._viewToStack.get(this.visibleView);
    }
    /**
	* Returns the ID of the given stack.
	*/ _getStackId(stack) {
        return Array.from(this._idToStack.entries()).find((entry)=>entry[1] === stack)[0];
    }
    /**
	* Shows the last view from the next stack.
	*/ _showNextStack() {
        const stacks = Array.from(this._idToStack.values());
        let nextIndex = stacks.indexOf(this._visibleStack) + 1;
        if (!stacks[nextIndex]) nextIndex = 0;
        this.showStack(this._getStackId(stacks[nextIndex]));
    }
    /**
	* Shows the last view from the previous stack.
	*/ _showPrevStack() {
        const stacks = Array.from(this._idToStack.values());
        let nextIndex = stacks.indexOf(this._visibleStack) - 1;
        if (!stacks[nextIndex]) nextIndex = stacks.length - 1;
        this.showStack(this._getStackId(stacks[nextIndex]));
    }
    /**
	* Creates a rotator view.
	*/ _createRotatorView() {
        const view = new $29fd27cb9bdab9d2$export$abe46e539bc6e869(this.editor.locale);
        const t = this.editor.locale.t;
        this.view.content.add(view);
        view.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (value, isSingleViewMode)=>{
            return !isSingleViewMode && value > 1;
        });
        view.on("change:isNavigationVisible", ()=>this.updatePosition(), {
            priority: "low"
        });
        view.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (visibleView, numberOfStacks)=>{
            if (numberOfStacks < 2) return "";
            const current = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
            return t("%0 of %1", [
                current,
                numberOfStacks
            ]);
        });
        view.buttonNextView.on("execute", ()=>{
            if (view.focusTracker.isFocused) this.editor.editing.view.focus();
            this._showNextStack();
        });
        view.buttonPrevView.on("execute", ()=>{
            if (view.focusTracker.isFocused) this.editor.editing.view.focus();
            this._showPrevStack();
        });
        return view;
    }
    /**
	* Creates a fake panels view.
	*/ _createFakePanelsView() {
        const view = new $29fd27cb9bdab9d2$var$FakePanelsView(this.editor.locale, this.view);
        view.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (number, isSingleViewMode)=>{
            return !isSingleViewMode && number >= 2 ? Math.min(number - 1, 2) : 0;
        });
        view.listenTo(this.view, "change:top", ()=>view.updatePosition());
        view.listenTo(this.view, "change:left", ()=>view.updatePosition());
        this.editor.ui.view.body.add(view);
        return view;
    }
    /**
	* Sets the view as the content of the balloon and attaches the balloon using position
	* options of the first view.
	*
	* @param data Configuration.
	* @param data.view The view to show in the balloon.
	* @param data.balloonClassName Additional class name which will be added to the {@link #view balloon}.
	* @param data.withArrow Whether the {@link #view balloon} should be rendered with an arrow.
	*/ _showView({ view: view, balloonClassName: balloonClassName = "", withArrow: withArrow = true, singleViewMode: singleViewMode = false }) {
        this.view.class = balloonClassName;
        this.view.withArrow = withArrow;
        this._rotatorView.showView(view);
        this.visibleView = view;
        this.view.pin(this.getPositionOptions());
        this._fakePanelsView.updatePosition();
        if (singleViewMode) this._singleViewMode = true;
    }
};
/**
* Rotator view is a helper class for the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon ContextualBalloon}.
* It is used for displaying the last view from the current stack and providing navigation buttons for switching stacks.
* See the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon ContextualBalloon} documentation to learn more.
* @internal
*/ var $29fd27cb9bdab9d2$export$abe46e539bc6e869 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Used for checking if a view is focused or not.
	*/ focusTracker;
    /**
	* Navigation button for switching the stack to the previous one.
	*/ buttonPrevView;
    /**
	* Navigation button for switching the stack to the next one.
	*/ buttonNextView;
    /**
	* A collection of the child views that creates the rotator content.
	*/ content;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const t = locale.t;
        const bind = this.bindTemplate;
        this.set("isNavigationVisible", true);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.buttonPrevView = this._createButtonView(t("Previous"), (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3));
        this.buttonNextView = this._createButtonView(t("Next"), (0, $e8dc502aba5ac3f5$export$ce5b94cabe8af42c));
        this.content = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-balloon-rotator"
                ],
                "z-index": "-1"
            },
            children: [
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck-balloon-rotator__navigation",
                            bind.to("isNavigationVisible", (value)=>value ? "" : "ck-hidden")
                        ]
                    },
                    children: [
                        this.buttonPrevView,
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "ck-balloon-rotator__counter"
                                ]
                            },
                            children: [
                                {
                                    text: bind.to("counter")
                                }
                            ]
                        },
                        this.buttonNextView
                    ]
                },
                {
                    tag: "div",
                    attributes: {
                        class: "ck-balloon-rotator__content"
                    },
                    children: this.content
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
    }
    /**
	* Shows a given view.
	*
	* @param view The view to show.
	*/ showView(view) {
        this.hideView();
        this.content.add(view);
    }
    /**
	* Hides the currently displayed view.
	*/ hideView() {
        this.content.clear();
    }
    /**
	* Creates a navigation button view.
	*
	* @param label The button label.
	* @param icon The button icon.
	*/ _createButtonView(label, icon) {
        const view = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(this.locale);
        view.set({
            label: label,
            icon: icon,
            tooltip: true
        });
        view.extendTemplate({
            on: {
                mousedown: view.bindTemplate.to((evt)=>evt.preventDefault())
            }
        });
        return view;
    }
};
/**
* Displays additional layers under the balloon when multiple stacks are added to the balloon.
*/ var $29fd27cb9bdab9d2$var$FakePanelsView = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views which creates fake panel content.
	*/ content;
    /**
	* Context.
	*/ _balloonPanelView;
    /**
	* @inheritDoc
	*/ constructor(locale, balloonPanelView){
        super(locale);
        const bind = this.bindTemplate;
        this.set("top", 0);
        this.set("left", 0);
        this.set("height", 0);
        this.set("width", 0);
        this.set("numberOfPanels", 0);
        this.content = this.createCollection();
        this._balloonPanelView = balloonPanelView;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck-fake-panel",
                    bind.to("numberOfPanels", (number)=>number ? "" : "ck-hidden")
                ],
                style: {
                    top: bind.to("top", $29fd27cb9bdab9d2$var$toPx$4),
                    left: bind.to("left", $29fd27cb9bdab9d2$var$toPx$4),
                    width: bind.to("width", $29fd27cb9bdab9d2$var$toPx$4),
                    height: bind.to("height", $29fd27cb9bdab9d2$var$toPx$4)
                }
            },
            children: this.content
        });
        this.on("change:numberOfPanels", (evt, name, next, prev)=>{
            if (next > prev) this._addPanels(next - prev);
            else this._removePanels(prev - next);
            this.updatePosition();
        });
    }
    _addPanels(number) {
        while(number--){
            const view = new $29fd27cb9bdab9d2$export$27a5bd065ad55220();
            view.setTemplate({
                tag: "div"
            });
            this.content.add(view);
            this.registerChild(view);
        }
    }
    _removePanels(number) {
        while(number--){
            const view = this.content.last;
            this.content.remove(view);
            this.deregisterChild(view);
            view.destroy();
        }
    }
    /**
	* Updates coordinates of fake panels.
	*/ updatePosition() {
        if (this.numberOfPanels) {
            const { top: top, left: left } = this._balloonPanelView;
            const { width: width, height: height } = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._balloonPanelView.element);
            Object.assign(this, {
                top: top,
                left: left,
                width: width,
                height: height
            });
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/panel/sticky/stickypanelview
*/ const $29fd27cb9bdab9d2$var$toPx$3 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The sticky panel view class.
*/ var $29fd27cb9bdab9d2$export$26092d970033229e = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views which creates balloon panel contents.
	*/ content;
    /**
	* The panel which accepts children into {@link #content} collection.
	* Also an element which is positioned when {@link #isSticky}.
	*/ contentPanelElement;
    /**
	* A dummy element which visually fills the space as long as the
	* actual panel is sticky. It prevents flickering of the UI.
	*/ _contentPanelPlaceholder;
    /**
	* The shadow roots {@link #limiterElement} lives in, currently covered by their own `scroll` listener
	* (in addition to `document`). `scroll` is not `composed`, so it never crosses a shadow boundary: a
	* listener on `document`, even with `useCapture: true`, never sees a scrollable container inside a shadow
	* root hosting the limiter.
	*/ _scrollListenerShadowRoots = /* @__PURE__ */ new Set();
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isActive", false);
        this.set("isSticky", false);
        this.set("limiterElement", null);
        this.set("limiterBottomOffset", 50);
        this.set("viewportTopOffset", 0);
        this.set("_marginLeft", null);
        this.set("_isStickyToTheBottomOfLimiter", false);
        this.set("_stickyTopOffset", null);
        this.set("_stickyBottomOffset", null);
        this.content = this.createCollection();
        this._contentPanelPlaceholder = new $29fd27cb9bdab9d2$export$14416b8d99d47caa({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-sticky-panel__placeholder"
                ],
                style: {
                    display: bind.to("isSticky", (isSticky)=>isSticky ? "block" : "none"),
                    height: bind.to("isSticky", (isSticky)=>{
                        return isSticky ? $29fd27cb9bdab9d2$var$toPx$3(this._contentPanelRect.height) : null;
                    })
                }
            }
        }).render();
        this.contentPanelElement = new $29fd27cb9bdab9d2$export$14416b8d99d47caa({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-sticky-panel__content",
                    bind.if("isSticky", "ck-sticky-panel__content_sticky"),
                    bind.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")
                ],
                style: {
                    width: bind.to("isSticky", (isSticky)=>{
                        return isSticky ? $29fd27cb9bdab9d2$var$toPx$3(this._contentPanelPlaceholder.getBoundingClientRect().width) : null;
                    }),
                    top: bind.to("_stickyTopOffset", (value)=>value ? $29fd27cb9bdab9d2$var$toPx$3(value) : value),
                    bottom: bind.to("_stickyBottomOffset", (value)=>value ? $29fd27cb9bdab9d2$var$toPx$3(value) : value),
                    marginLeft: bind.to("_marginLeft")
                }
            },
            children: this.content
        }).render();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-sticky-panel"
                ]
            },
            children: [
                this._contentPanelPlaceholder,
                this.contentPanelElement
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.checkIfShouldBeSticky();
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", ()=>{
            this.checkIfShouldBeSticky();
        }, {
            useCapture: true
        });
        this.listenTo(this, "change:limiterElement", ()=>{
            this._syncScrollListenerRoots();
        });
        this.listenTo(this, "change:isActive", ()=>{
            this.checkIfShouldBeSticky();
        });
        if ((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport) {
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport, "scroll", ()=>{
                this.checkIfShouldBeSticky();
            });
            this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport, "resize", ()=>{
                this.checkIfShouldBeSticky();
            });
        }
    }
    /**
	* Attaches or detaches the `scroll` listener on the shadow roots {@link #limiterElement} currently lives in,
	* so they match exactly. See {@link #_scrollListenerShadowRoots}.
	*/ _syncScrollListenerRoots() {
        const currentRoots = this.limiterElement ? new Set((0, $c7bc2cb7e2db0227$export$9f54ef76df6accb2)(this.limiterElement)) : /* @__PURE__ */ new Set();
        for (const root of this._scrollListenerShadowRoots)if (!currentRoots.has(root)) {
            this.stopListening(root, "scroll");
            this._scrollListenerShadowRoots.delete(root);
        }
        for (const root of currentRoots)if (!this._scrollListenerShadowRoots.has(root)) {
            this.listenTo(root, "scroll", this.checkIfShouldBeSticky.bind(this), {
                useCapture: true
            });
            this._scrollListenerShadowRoots.add(root);
        }
    }
    /**
	* Analyzes the environment to decide whether the panel should be sticky or not.
	* Then handles the positioning of the panel.
	*/ checkIfShouldBeSticky() {
        this._syncScrollListenerRoots();
        if (!this.limiterElement || !this.isActive) {
            this._unstick();
            return;
        }
        const limiterRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.limiterElement);
        let visibleLimiterRect = limiterRect.getVisible();
        if (visibleLimiterRect) {
            const windowRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window);
            windowRect.top += this.viewportTopOffset;
            windowRect.height -= this.viewportTopOffset;
            visibleLimiterRect = visibleLimiterRect.getIntersection(windowRect);
        }
        const { left: visualViewportOffsetLeft, top: visualViewportOffsetTop } = (0, $c7bc2cb7e2db0227$export$cdd2bda8bf1fea96)();
        limiterRect.moveBy(visualViewportOffsetLeft, visualViewportOffsetTop);
        if (visibleLimiterRect) visibleLimiterRect.moveBy(visualViewportOffsetLeft, visualViewportOffsetTop);
        if (visibleLimiterRect && limiterRect.top < visibleLimiterRect.top) {
            if (this._contentPanelRect.height + this.limiterBottomOffset > visibleLimiterRect.height) {
                const stickyBottomOffset = Math.max(limiterRect.bottom - visibleLimiterRect.bottom, 0) + this.limiterBottomOffset;
                if (this._contentPanelRect.height + stickyBottomOffset + 1 < limiterRect.height) this._stickToBottomOfLimiter(stickyBottomOffset);
                else this._unstick();
            } else if (this._contentPanelRect.height + this.limiterBottomOffset < limiterRect.height) this._stickToTopOfAncestors(visibleLimiterRect.top);
            else this._unstick();
        } else this._unstick();
    }
    /**
	* Sticks the panel at the given CSS `top` offset.
	*
	* @private
	* @param topOffset
	*/ _stickToTopOfAncestors(topOffset) {
        this.isSticky = true;
        this._isStickyToTheBottomOfLimiter = false;
        this._stickyTopOffset = topOffset;
        this._stickyBottomOffset = null;
        this._marginLeft = $29fd27cb9bdab9d2$var$toPx$3(-(0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.scrollX + (0, $c7bc2cb7e2db0227$export$cdd2bda8bf1fea96)().left);
    }
    /**
	* Sticks the panel at the bottom of the limiter with a given CSS `bottom` offset.
	*
	* @private
	* @param stickyBottomOffset
	*/ _stickToBottomOfLimiter(stickyBottomOffset) {
        this.isSticky = true;
        this._isStickyToTheBottomOfLimiter = true;
        this._stickyTopOffset = null;
        this._stickyBottomOffset = stickyBottomOffset;
        this._marginLeft = $29fd27cb9bdab9d2$var$toPx$3(-(0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.scrollX + (0, $c7bc2cb7e2db0227$export$cdd2bda8bf1fea96)().left);
    }
    /**
	* Unsticks the panel putting it back to its original position.
	*
	* @private
	*/ _unstick() {
        this.isSticky = false;
        this._isStickyToTheBottomOfLimiter = false;
        this._stickyTopOffset = null;
        this._stickyBottomOffset = null;
        this._marginLeft = null;
    }
    /**
	* Returns the bounding rect of the {@link #contentPanelElement}.
	*
	* @private
	*/ get _contentPanelRect() {
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.contentPanelElement);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/search/text/searchtextqueryview
*/ /**
* A search input field for the {@link module:ui/search/text/searchtextview~SearchTextView} component.
*
* @internal
* @extends module:ui/labeledfield/labeledfieldview~LabeledFieldView
*/ var $29fd27cb9bdab9d2$export$dff69c6020aee0dc = class extends $29fd27cb9bdab9d2$export$698fc40b8eb40673 {
    /**
	* The loupe icon displayed next to the {@link #fieldView}.
	*/ iconView;
    /**
	* The button that clears and focuses the {@link #fieldView}.
	*/ resetButtonView;
    /**
	* A reference to the view configuration.
	*/ _viewConfig;
    /**
	* @inheritDoc
	*/ constructor(locale, config){
        const t = locale.t;
        const viewConfig = Object.assign({}, {
            showResetButton: true,
            showIcon: true,
            creator: $29fd27cb9bdab9d2$export$549636b2b89b8342
        }, config);
        super(locale, viewConfig.creator);
        this.label = config.label;
        this._viewConfig = viewConfig;
        if (this._viewConfig.showIcon) {
            this.iconView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
            this.iconView.content = (0, $e8dc502aba5ac3f5$export$a753bdb7a147cf80);
            this.fieldWrapperChildren.add(this.iconView, 0);
            this.extendTemplate({
                attributes: {
                    class: "ck-search__query_with-icon"
                }
            });
        }
        if (this._viewConfig.showResetButton) {
            this.resetButtonView = new $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa(locale);
            this.resetButtonView.set({
                label: t("Clear"),
                icon: (0, $e8dc502aba5ac3f5$export$6102dea6073ecfc0),
                class: "ck-search__reset",
                isVisible: false,
                tooltip: true
            });
            this.resetButtonView.on("execute", ()=>{
                this.reset();
                this.focus();
                this.fire("reset");
            });
            this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", (isEmpty)=>!isEmpty);
            this.fieldWrapperChildren.add(this.resetButtonView);
            this.extendTemplate({
                attributes: {
                    class: "ck-search__query_with-reset"
                }
            });
        }
    }
    /**
	* Resets the search field to its default state.
	*/ reset() {
        this.fieldView.reset();
        if (this._viewConfig.showResetButton) this.resetButtonView.isVisible = false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A view displaying an information text related to different states of {@link module:ui/search/text/searchtextview~SearchTextView}.
*
* @internal
*/ var $29fd27cb9bdab9d2$export$6a8d70d40d7cdf45 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        const bind = this.bindTemplate;
        this.set({
            isVisible: false,
            primaryText: "",
            secondaryText: ""
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-search__info",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ],
                tabindex: -1
            },
            children: [
                {
                    tag: "span",
                    children: [
                        {
                            text: [
                                bind.to("primaryText")
                            ]
                        }
                    ]
                },
                {
                    tag: "span",
                    children: [
                        {
                            text: [
                                bind.to("secondaryText")
                            ]
                        }
                    ]
                }
            ]
        });
    }
    /**
	* Focuses the view
	*/ focus() {
        this.element.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/search/searchresultsview
*/ /**
* A sub-component of {@link module:ui/search/text/searchtextview~SearchTextView}. It hosts the filtered and the information views.
*/ var $29fd27cb9bdab9d2$export$4346cbb3f6673ddd = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Tracks information about the DOM focus in the view.
	*
	* @readonly
	*/ focusTracker;
    /**
	* The collection of the child views inside of the list item {@link #element}.
	*
	* @readonly
	*/ children;
    /**
	* Provides the focus management (keyboard navigation) in the view.
	*
	* @readonly
	*/ _focusCycler;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.children = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-search__results"
                ],
                tabindex: -1
            },
            children: this.children
        });
        this._focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this.children,
            focusTracker: this.focusTracker
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        for (const child of this.children)this.focusTracker.add(child.element);
    }
    /**
	* Focuses the view.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the first child view.
	*/ focusFirst() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the last child view.
	*/ focusLast() {
        this._focusCycler.focusLast();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/search/text/searchtextview
*/ /**
* A search component that allows filtering of an arbitrary view based on a search query
* specified by the user in a text field.
*
*```ts
* // This view must specify the `filter()` and `focus()` methods.
* const filteredView = ...;
*
* const searchView = new SearchTextView( locale, {
* 	searchFieldLabel: 'Search list items',
* 	filteredView
* } );
*
* view.render();
*
* document.body.append( view.element );
* ```
*/ var $29fd27cb9bdab9d2$export$2efe944fc0c6812b = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Tracks information about the DOM focus in the view.
	*
	* @readonly
	*/ focusTracker;
    /**
	* An instance of the keystroke handler managing user interaction and accessibility.
	*
	* @readonly
	*/ keystrokes;
    /**
	* A view hosting the {@link #filteredView} passed in the configuration and the {@link #infoView}.
	*/ resultsView;
    /**
	* The view that is filtered by the search query.
	*/ filteredView;
    /**
	* The view that displays the information about the search results.
	*/ infoView;
    /**
	* The view that allows the user to enter the search query.
	*/ queryView;
    /**
	* Provides the focus management (keyboard navigation) between {@link #queryView} and {@link #filteredView}.
	*
	* @readonly
	*/ focusCycler;
    /**
	* The cached configuration object.
	*
	* @internal
	*/ _config;
    /**
	* Creates an instance of the {@link module:ui/search/text/searchtextview~SearchTextView} class.
	*
	* @param locale The localization services instance.
	* @param config Configuration of the view.
	*/ constructor(locale, config){
        super(locale);
        this._config = config;
        this.filteredView = config.filteredView;
        this.queryView = this._createSearchTextQueryView();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.resultsView = new $29fd27cb9bdab9d2$export$4346cbb3f6673ddd(locale);
        this.children = this.createCollection();
        this.focusableChildren = this.createCollection([
            this.queryView,
            this.resultsView
        ]);
        this.set("isEnabled", true);
        this.set("resultsCount", 0);
        this.set("totalItemsCount", 0);
        if (config.infoView && config.infoView.instance) this.infoView = config.infoView.instance;
        else {
            this.infoView = new $29fd27cb9bdab9d2$export$6a8d70d40d7cdf45();
            this._enableDefaultInfoViewBehavior();
            this.on("render", ()=>{
                this.search("");
            });
        }
        this.resultsView.children.addMany([
            this.infoView,
            this.filteredView
        ]);
        this.focusCycler = new $29fd27cb9bdab9d2$export$679be10c531010f6({
            focusables: this.focusableChildren,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.on("search", (evt, { resultsCount: resultsCount, totalItemsCount: totalItemsCount })=>{
            this.resultsCount = resultsCount;
            this.totalItemsCount = totalItemsCount;
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-search",
                    config.class || null
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.addMany([
            this.queryView,
            this.resultsView
        ]);
        const stopPropagation = (data)=>data.stopPropagation();
        for (const focusableChild of this.focusableChildren)this.focusTracker.add(focusableChild.element);
        this.keystrokes.listenTo(this.element);
        this.keystrokes.set("arrowright", stopPropagation);
        this.keystrokes.set("arrowleft", stopPropagation);
        this.keystrokes.set("arrowup", stopPropagation);
        this.keystrokes.set("arrowdown", stopPropagation);
    }
    /**
	* Focuses the {@link #queryView}.
	*/ focus() {
        this.queryView.focus();
    }
    /**
	* Resets the component to its initial state.
	*/ reset() {
        this.queryView.reset();
        this.search("");
        this.filteredView.element.scrollTo(0, 0);
    }
    /**
	* Searches the {@link #filteredView} for the given query.
	*
	* @internal
	* @param query The search query string.
	*/ search(query) {
        const regExp = query ? new RegExp((0, $16b28203d45236dc$export$7c57da42ce8e346f)(query), "ig") : null;
        const filteringResults = this.filteredView.filter(regExp);
        this.fire("search", {
            query: query,
            ...filteringResults
        });
    }
    /**
	* Creates a search field view based on configured creator..
	*/ _createSearchTextQueryView() {
        const queryView = new $29fd27cb9bdab9d2$export$dff69c6020aee0dc(this.locale, this._config.queryView);
        this.listenTo(queryView.fieldView, "input", ()=>{
            this.search(queryView.fieldView.element.value);
        });
        queryView.on("reset", ()=>this.reset());
        queryView.bind("isEnabled").to(this);
        return queryView;
    }
    /**
	* Initializes the default {@link #infoView} behavior with default text labels when no custom info view
	* was specified in the view config.
	*/ _enableDefaultInfoViewBehavior() {
        const t = this.locale.t;
        const infoView = this.infoView;
        this.on("search", (evt, data)=>{
            if (!data.resultsCount) {
                const defaultTextConfig = this._config.infoView && this._config.infoView.text;
                let primaryText, secondaryText;
                if (data.totalItemsCount) {
                    if (defaultTextConfig?.notFound) {
                        primaryText = defaultTextConfig.notFound.primary;
                        secondaryText = defaultTextConfig.notFound.secondary;
                    } else {
                        primaryText = t("No results found");
                        secondaryText = "";
                    }
                } else if (defaultTextConfig?.noSearchableItems) {
                    primaryText = defaultTextConfig.noSearchableItems.primary;
                    secondaryText = defaultTextConfig.noSearchableItems.secondary;
                } else {
                    primaryText = t("No searchable items");
                    secondaryText = "";
                }
                infoView.set({
                    primaryText: normalizeInfoText(primaryText, data),
                    secondaryText: normalizeInfoText(secondaryText, data),
                    isVisible: true
                });
            } else infoView.set({
                isVisible: false
            });
        });
        function normalizeInfoText(text, { query: query, resultsCount: resultsCount, totalItemsCount: totalItemsCount }) {
            return typeof text === "function" ? text(query, resultsCount, totalItemsCount) : text;
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/autocomplete/autocompleteview
*/ /**
* The autocomplete component's view class. It extends the {@link module:ui/search/text/searchtextview~SearchTextView} class
* with a floating {@link #resultsView} that shows up when the user starts typing and hides when they blur
* the component.
*/ var $29fd27cb9bdab9d2$export$d2b6db6a7279fa83 = class AutocompleteView extends $29fd27cb9bdab9d2$export$2efe944fc0c6812b {
    /**
	* The configuration of the autocomplete view.
	*/ _config;
    /**
	* @inheritDoc
	*/ constructor(locale, config){
        super(locale, config);
        this._config = config;
        const toPx = (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-autocomplete"
                ]
            }
        });
        const bindResultsView = this.resultsView.bindTemplate;
        this.resultsView.set("isVisible", false);
        this.resultsView.set("_position", "s");
        this.resultsView.set("_width", 0);
        this.resultsView.extendTemplate({
            attributes: {
                class: [
                    bindResultsView.if("isVisible", "ck-hidden", (value)=>!value),
                    bindResultsView.to("_position", (value)=>`ck-search__results_${value}`)
                ],
                style: {
                    width: bindResultsView.to("_width", toPx)
                }
            }
        });
        this.focusTracker.on("change:isFocused", (evt, name, isFocused)=>{
            this._updateResultsVisibility();
            if (isFocused) this.resultsView.element.scrollTop = 0;
            else if (config.resetOnBlur) this.queryView.reset();
        });
        this.on("search", ()=>{
            this._updateResultsVisibility();
            this._updateResultsViewWidthAndPosition();
        });
        this.keystrokes.set("esc", (evt, cancel)=>{
            if (!this.resultsView.isVisible) return;
            this.queryView.focus();
            this.resultsView.isVisible = false;
            cancel();
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", ()=>{
            this._updateResultsViewWidthAndPosition();
        });
        this.on("change:isEnabled", ()=>{
            this._updateResultsVisibility();
        });
        this.filteredView.on("execute", (evt, { value: value })=>{
            this.focus();
            this.reset();
            this.queryView.fieldView.value = this.queryView.fieldView.element.value = value;
            this.resultsView.isVisible = false;
        });
        this.resultsView.on("change:isVisible", ()=>{
            this._updateResultsViewWidthAndPosition();
        });
    }
    /**
	* Updates the position of the results view on demand.
	*/ _updateResultsViewWidthAndPosition() {
        if (!this.resultsView.isVisible) return;
        this.resultsView._width = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.queryView.fieldView.element).width;
        const optimalResultsPosition = AutocompleteView._getOptimalPosition({
            element: this.resultsView.element,
            target: this.queryView.element,
            fitInViewport: true,
            positions: AutocompleteView.defaultResultsPositions
        });
        this.resultsView._position = optimalResultsPosition ? optimalResultsPosition.name : "s";
    }
    /**
	* Updates the visibility of the results view on demand.
	*/ _updateResultsVisibility() {
        const queryMinChars = typeof this._config.queryMinChars === "undefined" ? 0 : this._config.queryMinChars;
        const queryLength = this.queryView.fieldView.element.value.length;
        this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && queryLength >= queryMinChars;
    }
    /**
	* Positions for the autocomplete results view. Two positions are defined by default:
	* * `s` - below the search field,
	* * `n` - above the search field.
	*/ static defaultResultsPositions = [
        (fieldRect)=>{
            return {
                top: fieldRect.bottom,
                left: fieldRect.left,
                name: "s"
            };
        },
        (fieldRect, resultsRect)=>{
            return {
                top: fieldRect.top - resultsRect.height,
                left: fieldRect.left,
                name: "n"
            };
        }
    ];
    /**
	* A function used to calculate the optimal position for the dropdown panel.
	*/ static _getOptimalPosition = (0, $c7bc2cb7e2db0227$export$75cda5409326f127);
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/highlightedtext/highlightedtextview
*/ /**
* A class representing a view that displays a text which subset can be highlighted using the
* {@link #highlightText} method.
*/ var $29fd27cb9bdab9d2$export$ef38c77e1c8be211 = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        this.set("text", void 0);
        this.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-highlighted-text"
                ]
            }
        });
        this.on("render", ()=>{
            this.on("change:text", ()=>{
                this._updateInnerHTML((0, $dc9a4a74e8d22318$export$4e7f196112fea3c5)(this.text || ""));
            });
            this._updateInnerHTML((0, $dc9a4a74e8d22318$export$4e7f196112fea3c5)(this.text || ""));
        });
    }
    /**
	* Highlights view's {@link #text} according to the specified `RegExp`. If the passed RegExp is `null`, the
	* highlighting is removed
	*
	* @param regExp
	*/ highlightText(regExp) {
        this._updateInnerHTML($29fd27cb9bdab9d2$var$markText(this.text || "", regExp));
    }
    /**
	* Updates element's `innerHTML` with the passed content.
	*/ _updateInnerHTML(newInnerHTML) {
        this.element.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(newInnerHTML || "");
    }
};
/**
* Replaces `regExp` occurrences with `<mark>` tags in a text.
*
* @param text A text to get marked.
* @param regExp An optional `RegExp`. If not passed, this is a pass-through function.
* @returns A text with `RegExp` occurrences marked by `<mark>`.
*/ function $29fd27cb9bdab9d2$var$markText(text, regExp) {
    if (!regExp) return (0, $dc9a4a74e8d22318$export$4e7f196112fea3c5)(text);
    const textParts = [];
    let lastMatchEnd = 0;
    let matchInfo = regExp.exec(text);
    while(matchInfo !== null){
        const curMatchStart = matchInfo.index;
        if (curMatchStart !== lastMatchEnd) textParts.push({
            text: text.substring(lastMatchEnd, curMatchStart),
            isMatch: false
        });
        textParts.push({
            text: matchInfo[0],
            isMatch: true
        });
        lastMatchEnd = regExp.lastIndex;
        matchInfo = regExp.exec(text);
    }
    if (lastMatchEnd !== text.length) textParts.push({
        text: text.substring(lastMatchEnd),
        isMatch: false
    });
    return textParts.map((part)=>{
        part.text = (0, $dc9a4a74e8d22318$export$4e7f196112fea3c5)(part.text);
        return part;
    }).map((part)=>part.isMatch ? `<mark>${part.text}</mark>` : part.text).join("");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A button label view that can highlight a text fragment.
*/ var $29fd27cb9bdab9d2$export$ac4f375f501ebe6e = class extends $29fd27cb9bdab9d2$export$ef38c77e1c8be211 {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        this.set({
            style: void 0,
            text: void 0,
            id: void 0
        });
        const bind = this.bindTemplate;
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-button__label"
                ],
                style: bind.to("style"),
                id: bind.to("id")
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/highlightedtext/labelwithhighlightview
*/ /**
* A label view that can highlight a text fragment.
*/ var $29fd27cb9bdab9d2$export$4155ac7249772bcf = class extends $29fd27cb9bdab9d2$export$ef38c77e1c8be211 {
    /**
	* @inheritDoc
	*/ id;
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        this.set("for", void 0);
        const bind = this.bindTemplate;
        this.id = `ck-editor__label_${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
        this.extendTemplate({
            attributes: {
                class: [
                    "ck",
                    "ck-label"
                ],
                id: this.id,
                for: bind.to("for")
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/spinner/spinnerview
*/ /**
* The spinner view class.
*/ var $29fd27cb9bdab9d2$export$45145c4b0c38736b = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        this.set("isVisible", false);
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-spinner-container",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ]
            },
            children: [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck",
                            "ck-spinner"
                        ]
                    }
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/balloon/balloontoolbar
*/ const $29fd27cb9bdab9d2$var$toPx$2 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The contextual toolbar.
*
* It uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
*/ var $29fd27cb9bdab9d2$export$cbc3f15db3a8b2ec = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The toolbar view displayed in the balloon.
	*/ toolbarView;
    /**
	* Tracks the focus of the {@link module:ui/editorui/editorui~EditorUI#getEditableElement editable element}
	* and the {@link #toolbarView}. When both are blurred then the toolbar should hide.
	*/ focusTracker;
    /**
	* A cached and normalized `config.balloonToolbar` object.
	*/ _balloonConfig;
    /**
	* An instance of the resize observer that allows to respond to changes in editable's geometry
	* so the toolbar can stay within its boundaries (and group toolbar items that do not fit).
	*
	* **Note**: Used only when `shouldNotGroupWhenFull` was **not** set in the
	* {@link module:core/editor/editorconfig~EditorConfig#balloonToolbar configuration}.
	*
	* **Note:** Created in {@link #init}.
	*/ _resizeObserver = null;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* Fires `_selectionChangeDebounced` event using `es-toolkit#debounce`.
	*
	* This event is an internal plugin event which is fired 200 ms after model selection last change.
	* This is to makes easy test debounced action without need to use `setTimeout`.
	*
	* This function is stored as a plugin property to make possible to cancel
	* trailing debounced invocation on destroy.
	*/ _fireSelectionChangeDebounced;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BalloonToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $29fd27cb9bdab9d2$export$d474f494ad2d7f9c
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._balloonConfig = $29fd27cb9bdab9d2$export$cddba3238a31417a(editor.config.get("balloonToolbar"));
        this.toolbarView = this._createToolbarView();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this._trackFocusableEditableElements();
        this.focusTracker.add(this.toolbarView);
        editor.ui.addToolbar(this.toolbarView, {
            beforeFocus: ()=>this.show(true),
            afterBlur: ()=>this.hide(),
            isContextual: true
        });
        this._balloon = editor.plugins.get($29fd27cb9bdab9d2$export$d474f494ad2d7f9c);
        this._fireSelectionChangeDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(()=>this.fire("_selectionChangeDebounced"), 200);
        this.decorate("show");
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        this.listenTo(this.focusTracker, "change:isFocused", (evt, name, isFocused)=>{
            if (!isFocused && this._isToolbarVisible) this.hide();
            else if (isFocused) this.show();
        });
        this.listenTo(selection, "change:range", (evt, data)=>{
            if (data.directChange || selection.isCollapsed) this.hide();
            this._fireSelectionChangeDebounced();
        });
        this.listenTo(this, "_selectionChangeDebounced", ()=>{
            if (this.editor.editing.view.document.isFocused) this.show();
        });
        if (!this._balloonConfig.shouldNotGroupWhenFull) this.listenTo(editor, "ready", ()=>{
            const editableElement = editor.ui.view.editable.element;
            this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(editableElement, (entry)=>{
                this.toolbarView.maxWidth = $29fd27cb9bdab9d2$var$toPx$2(entry.contentRect.width * .9);
            });
        });
        this.listenTo(this.toolbarView, "groupedItemsUpdate", ()=>{
            this._updatePosition();
        });
        editor.ui.once("ready", ()=>{
            this.toolbarView.fillFromConfig(this._balloonConfig, this.editor.ui.componentFactory);
        });
    }
    /**
	* Returns whether the toolbar is visible in the ContextualBalloon.
	*/ get _isToolbarVisible() {
        return this._balloon.visibleView === this.toolbarView;
    }
    /**
	* Creates the toolbar view instance.
	*/ _createToolbarView() {
        const t = this.editor.locale.t;
        const shouldGroupWhenFull = !this._balloonConfig.shouldNotGroupWhenFull;
        const toolbarView = new $29fd27cb9bdab9d2$export$2e2212e163bc16b8(this.editor.locale, {
            shouldGroupWhenFull: shouldGroupWhenFull,
            isFloating: true
        });
        toolbarView.ariaLabel = t("Editor contextual toolbar");
        toolbarView.render();
        return toolbarView;
    }
    /**
	* Shows the toolbar and attaches it to the selection.
	*
	* Fires {@link #event:show} event which can be stopped to prevent the toolbar from showing up.
	*
	* @param showForCollapsedSelection When set `true`, the toolbar will show despite collapsed selection in the
	* editing view.
	*/ show(showForCollapsedSelection = false) {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const schema = editor.model.schema;
        if (this._balloon.hasView(this.toolbarView)) return;
        if (selection.isCollapsed && !showForCollapsedSelection) return;
        if ($29fd27cb9bdab9d2$var$selectionContainsOnlyMultipleSelectables(selection, schema)) return;
        if (Array.from(this.toolbarView.items).every((item)=>item.isEnabled !== void 0 && !item.isEnabled)) return;
        this.listenTo(this.editor.ui, "update", ()=>{
            this._updatePosition();
        });
        this._balloon.add({
            view: this.toolbarView,
            position: this._getBalloonPositionData(),
            balloonClassName: "ck-toolbar-container"
        });
    }
    /**
	* Hides the toolbar.
	*/ hide() {
        if (this._balloon.hasView(this.toolbarView)) {
            this.stopListening(this.editor.ui, "update");
            this._balloon.remove(this.toolbarView);
        }
    }
    /**
	* Add or remove editable elements to the focus tracker. It watches added and removed roots
	* and adds or removes their editable elements to the focus tracker.
	*/ _trackFocusableEditableElements() {
        const { editor: editor, focusTracker: focusTracker } = this;
        const { editing: editing } = editor;
        editing.view.addObserver(class TrackEditableElements extends (0, $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b) {
            /**
			* @inheritDoc
			*/ observe(domElement) {
                focusTracker.add(domElement);
            }
            /**
			* @inheritDoc
			*/ stopObserving(domElement) {
                focusTracker.remove(domElement);
            }
        });
    }
    /**
	* Returns positioning options for the {@link #_balloon}. They control the way balloon is attached
	* to the selection.
	*/ _getBalloonPositionData() {
        const view = this.editor.editing.view;
        const viewDocument = view.document;
        const viewSelection = viewDocument.selection;
        const isBackward = viewDocument.selection.isBackward;
        return {
            target: ()=>{
                const range = isBackward ? viewSelection.getFirstRange() : viewSelection.getLastRange();
                const rangeRects = (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d).getDomRangeRects(view.domConverter.viewRangeToDom(range));
                if (isBackward) return rangeRects[0];
                else {
                    if (rangeRects.length > 1 && rangeRects[rangeRects.length - 1].width === 0) rangeRects.pop();
                    return rangeRects[rangeRects.length - 1];
                }
            },
            positions: this._getBalloonPositions(isBackward)
        };
    }
    /**
	* Updates the position of the {@link #_balloon} to make up for changes:
	*
	* * in the geometry of the selection it is attached to (e.g. the selection moved in the viewport or expanded or shrunk),
	* * or the geometry of the balloon toolbar itself (e.g. the toolbar has grouped or ungrouped some items and it is shorter or longer).
	*/ _updatePosition() {
        if (this._isToolbarVisible) this._balloon.updatePosition(this._getBalloonPositionData());
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.stopListening();
        this._fireSelectionChangeDebounced.cancel();
        this.toolbarView.destroy();
        this.focusTracker.destroy();
        if (this._resizeObserver) this._resizeObserver.destroy();
    }
    /**
	* Returns toolbar positions for the given direction of the selection.
	*/ _getBalloonPositions(isBackward) {
        const positions = (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari && (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS ? $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c.generatePositions({
            heightOffset: Math.max($29fd27cb9bdab9d2$export$fa83a894fd8a5d2c.arrowHeightOffset, Math.round(20 / (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.visualViewport.scale))
        }) : $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c.defaultPositions;
        return isBackward ? [
            positions.northWestArrowSouth,
            positions.northWestArrowSouthWest,
            positions.northWestArrowSouthEast,
            positions.northWestArrowSouthMiddleEast,
            positions.northWestArrowSouthMiddleWest,
            positions.southWestArrowNorth,
            positions.southWestArrowNorthWest,
            positions.southWestArrowNorthEast,
            positions.southWestArrowNorthMiddleWest,
            positions.southWestArrowNorthMiddleEast
        ] : [
            positions.southEastArrowNorth,
            positions.southEastArrowNorthEast,
            positions.southEastArrowNorthWest,
            positions.southEastArrowNorthMiddleEast,
            positions.southEastArrowNorthMiddleWest,
            positions.northEastArrowSouth,
            positions.northEastArrowSouthEast,
            positions.northEastArrowSouthWest,
            positions.northEastArrowSouthMiddleEast,
            positions.northEastArrowSouthMiddleWest
        ];
    }
};
/**
* Returns "true" when the selection has multiple ranges and each range contains a selectable element
* and nothing else.
*/ function $29fd27cb9bdab9d2$var$selectionContainsOnlyMultipleSelectables(selection, schema) {
    if (selection.rangeCount === 1) return false;
    return [
        ...selection.getRanges()
    ].every((range)=>{
        const element = range.getContainedElement();
        return element && schema.isSelectable(element);
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/block/blockbuttonview
*/ const $29fd27cb9bdab9d2$var$toPx$1 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The block button view class.
*
* This view represents a button attached next to block element where the selection is anchored.
*
* See {@link module:ui/toolbar/block/blocktoolbar~BlockToolbar}.
*/ var $29fd27cb9bdab9d2$export$fd51943d1cc55c1d = class extends $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.isVisible = false;
        this.isToggleable = true;
        this.set("top", 0);
        this.set("left", 0);
        this.extendTemplate({
            attributes: {
                class: "ck-block-toolbar-button",
                style: {
                    top: bind.to("top", (val)=>$29fd27cb9bdab9d2$var$toPx$1(val)),
                    left: bind.to("left", (val)=>$29fd27cb9bdab9d2$var$toPx$1(val))
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/toolbar/block/blocktoolbar
*/ const $29fd27cb9bdab9d2$var$toPx = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The block toolbar plugin.
*
* This plugin provides a button positioned next to the block of content where the selection is anchored.
* Upon clicking the button, a dropdown providing access to editor features shows up, as configured in
* {@link module:core/editor/editorconfig~EditorConfig#blockToolbar}.
*
* By default, the button is displayed next to all elements marked in {@link module:engine/model/schema~ModelSchema}
* as `$block` for which the toolbar provides at least one option.
*
* By default, the button is attached so its right boundary is touching the
* {@link module:engine/view/editableelement~ViewEditableElement}:
*
* ```
*  __ |
* |  ||  This is a block of content that the
*  ¯¯ |  button is attached to. This is a
*     |  block of content that the button is
*     |  attached to.
* ```
*
* The position of the button can be adjusted using the CSS `transform` property:
*
* ```css
* .ck-block-toolbar-button {
* 	transform: translateX( -10px );
* }
* ```
*
* ```
*  __   |
* |  |  |  This is a block of content that the
*  ¯¯   |  button is attached to. This is a
*       |  block of content that the button is
*       |  attached to.
* ```
*
* **Note**: If you plan to run the editor in a right–to–left (RTL) language, keep in mind the button
* will be attached to the **right** boundary of the editable area. In that case, make sure the
* CSS position adjustment works properly by adding the following styles:
*
* ```css
* .ck[dir="rtl"] .ck-block-toolbar-button {
* 	transform: translateX( 10px );
* }
* ```
*/ var $29fd27cb9bdab9d2$export$1daddc6976f637d7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The toolbar view.
	*/ toolbarView;
    /**
	* The balloon panel view, containing the {@link #toolbarView}.
	*/ panelView;
    /**
	* The button view that opens the {@link #toolbarView}.
	*/ buttonView;
    /**
	* An instance of the resize observer that allows to respond to changes in editable's geometry
	* so the toolbar can stay within its boundaries (and group toolbar items that do not fit).
	*
	* **Note**: Used only when `shouldNotGroupWhenFull` was **not** set in the
	* {@link module:core/editor/editorconfig~EditorConfig#blockToolbar configuration}.
	*/ _resizeObserver = null;
    /**
	* A cached and normalized `config.blockToolbar` object.
	*/ _blockToolbarConfig;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BlockToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._blockToolbarConfig = $29fd27cb9bdab9d2$export$cddba3238a31417a(this.editor.config.get("blockToolbar"));
        this.toolbarView = this._createToolbarView();
        this.panelView = this._createPanelView();
        this.buttonView = this._createButtonView();
        $29fd27cb9bdab9d2$export$16d2a52659b91b8a({
            emitter: this.panelView,
            contextElements: [
                this.panelView.element,
                this.buttonView.element
            ],
            activator: ()=>this.panelView.isVisible,
            callback: ()=>this._hidePanel()
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const editBlockText = t("Click to edit block");
        const dragToMoveText = t("Drag to move");
        const editBlockLabel = t("Edit block");
        const isDragDropBlockToolbarPluginLoaded = editor.plugins.has("DragDropBlockToolbar");
        const label = isDragDropBlockToolbarPluginLoaded ? `${editBlockText}\n${dragToMoveText}` : editBlockLabel;
        this.buttonView.label = label;
        if (isDragDropBlockToolbarPluginLoaded) this.buttonView.element.dataset.ckeTooltipClass = "ck-tooltip_multi-line";
        this.listenTo(editor.model.document.selection, "change:range", (evt, data)=>{
            if (data.directChange) this._hidePanel();
        });
        this.listenTo(editor.ui, "update", ()=>this._updateButton());
        this.listenTo(editor, "change:isReadOnly", ()=>this._updateButton(), {
            priority: "low"
        });
        this.listenTo(editor.ui.focusTracker, "change:isFocused", ()=>this._updateButton());
        this.listenTo(this.buttonView, "change:isVisible", (evt, name, isVisible)=>{
            if (isVisible) this.buttonView.listenTo(window, "resize", ()=>this._updateButton());
            else {
                this.buttonView.stopListening(window, "resize");
                this._hidePanel();
            }
        });
        this._repositionButtonOnScroll();
        editor.ui.addToolbar(this.toolbarView, {
            beforeFocus: ()=>this._showPanel(),
            afterBlur: ()=>this._hidePanel()
        });
        editor.ui.once("ready", ()=>{
            this.toolbarView.fillFromConfig(this._blockToolbarConfig, this.editor.ui.componentFactory);
            for (const item of this.toolbarView.items)item.on("execute", ()=>this._hidePanel(true), {
                priority: "high"
            });
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.panelView.destroy();
        this.buttonView.destroy();
        this.toolbarView.destroy();
        if (this._resizeObserver) this._resizeObserver.destroy();
    }
    /**
	* Creates the {@link #toolbarView}.
	*/ _createToolbarView() {
        const t = this.editor.locale.t;
        const shouldGroupWhenFull = !this._blockToolbarConfig.shouldNotGroupWhenFull;
        const toolbarView = new $29fd27cb9bdab9d2$export$2e2212e163bc16b8(this.editor.locale, {
            shouldGroupWhenFull: shouldGroupWhenFull,
            isFloating: true
        });
        toolbarView.ariaLabel = t("Editor block content toolbar");
        return toolbarView;
    }
    /**
	* Creates the {@link #panelView}.
	*/ _createPanelView() {
        const editor = this.editor;
        const panelView = new $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c(editor.locale);
        panelView.content.add(this.toolbarView);
        panelView.class = "ck-toolbar-container";
        editor.ui.view.body.add(panelView);
        this.toolbarView.keystrokes.set("Esc", (evt, cancel)=>{
            this._hidePanel(true);
            cancel();
        });
        return panelView;
    }
    /**
	* Creates the {@link #buttonView}.
	*/ _createButtonView() {
        const editor = this.editor;
        const t = editor.t;
        const buttonView = new $29fd27cb9bdab9d2$export$fd51943d1cc55c1d(editor.locale);
        const iconFromConfig = this._blockToolbarConfig.icon;
        const icon = $29fd27cb9bdab9d2$export$7c1ec60ab66f3307[iconFromConfig] || iconFromConfig || $29fd27cb9bdab9d2$export$7c1ec60ab66f3307.dragIndicator;
        buttonView.set({
            label: t("Edit block"),
            icon: icon,
            withText: false
        });
        buttonView.bind("isOn").to(this.panelView, "isVisible");
        buttonView.bind("tooltip").to(this.panelView, "isVisible", (isVisible)=>!isVisible);
        this.listenTo(buttonView, "execute", ()=>{
            if (!this.panelView.isVisible) this._showPanel();
            else this._hidePanel(true);
        });
        this.listenTo(buttonView, "change:isEnabled", (evt, name, isEnabled)=>{
            if (!isEnabled && this.panelView.isVisible) this._hidePanel(false);
        });
        editor.ui.view.body.add(buttonView);
        return buttonView;
    }
    /**
	* Shows or hides the button.
	* When all the conditions for displaying the button are matched, it shows the button. Hides otherwise.
	*/ _updateButton() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        if (!editor.ui.focusTracker.isFocused) {
            this._hideButton();
            return;
        }
        if (!editor.model.canEditAt(editor.model.document.selection)) {
            this._hideButton();
            return;
        }
        const modelTarget = Array.from(model.document.selection.getSelectedBlocks())[0];
        if (!modelTarget || Array.from(this.toolbarView.items).every((item)=>!item.isEnabled)) {
            this._hideButton();
            return;
        }
        const domTarget = view.domConverter.mapViewToDom(editor.editing.mapper.toViewElement(modelTarget));
        this.buttonView.isVisible = true;
        this._setupToolbarResize();
        this._attachButtonToElement(domTarget);
        if (this.panelView.isVisible) this._showPanel();
    }
    /**
	* Hides the button.
	*/ _hideButton() {
        this.buttonView.isVisible = false;
    }
    /**
	* Shows the {@link #toolbarView} attached to the {@link #buttonView}.
	* If the toolbar is already visible, then it simply repositions it.
	*/ _showPanel() {
        if (!this.buttonView.isVisible) return;
        const wasVisible = this.panelView.isVisible;
        this.panelView.show();
        const editableElement = this._getSelectedEditableElement();
        this.toolbarView.maxWidth = this._getToolbarMaxWidth(editableElement);
        this.panelView.pin({
            target: this.buttonView.element,
            limiter: editableElement
        });
        if (!wasVisible) this.toolbarView.items.get(0).focus();
    }
    /**
	* Returns currently selected editable, based on the model selection.
	*/ _getSelectedEditableElement() {
        const selectedModelRootName = this.editor.model.document.selection.getFirstRange().root.rootName;
        return this.editor.ui.getEditableElement(selectedModelRootName);
    }
    /**
	* Hides the {@link #toolbarView}.
	*
	* @param focusEditable When `true`, the editable will be focused after hiding the panel.
	*/ _hidePanel(focusEditable) {
        this.panelView.isVisible = false;
        if (focusEditable) this.editor.editing.view.focus();
    }
    /**
	* Repositions the button on scroll.
	*/ _repositionButtonOnScroll() {
        const { buttonView: buttonView } = this;
        let pendingAnimationFrame = false;
        const repositionOnScroll = (evt, domEvt)=>{
            if (pendingAnimationFrame) return;
            const editableElement = this._getSelectedEditableElement();
            if (!(0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(domEvt.target, editableElement)) return;
            pendingAnimationFrame = true;
            (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.requestAnimationFrame(()=>{
                this._updateButton();
                pendingAnimationFrame = false;
            });
        };
        let stopListeningToShadowRoots = null;
        buttonView.on("change:isVisible", (evt, name, isVisible)=>{
            if (isVisible) {
                buttonView.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", repositionOnScroll, {
                    useCapture: true,
                    usePassive: true
                });
                stopListeningToShadowRoots = (0, $c7bc2cb7e2db0227$export$2a57d49549145fbd)(this.editor.ui.shadowRootRegistry, {
                    emitter: buttonView,
                    event: "scroll",
                    callback: repositionOnScroll,
                    listenerOptions: {
                        useCapture: true,
                        usePassive: true
                    }
                });
            } else {
                buttonView.stopListening((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "scroll", repositionOnScroll);
                stopListeningToShadowRoots?.();
                stopListeningToShadowRoots = null;
            }
        });
    }
    /**
	* Attaches the {@link #buttonView} to the target block of content.
	*
	* @param targetElement Target element.
	*/ _attachButtonToElement(targetElement) {
        const buttonElement = this.buttonView.element;
        const editableElement = this._getSelectedEditableElement();
        const contentStyles = window.getComputedStyle(targetElement);
        const editableRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(editableElement);
        const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
        const contentLineHeight = parseInt(contentStyles.lineHeight, 10) || parseInt(contentStyles.fontSize, 10) * 1.2;
        const buttonRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(buttonElement);
        const contentRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(targetElement);
        let positionLeft;
        if (this.editor.locale.uiLanguageDirection === "ltr") positionLeft = editableRect.left - buttonRect.width;
        else positionLeft = editableRect.right;
        const positionTop = contentRect.top + contentPaddingTop + (contentLineHeight - buttonRect.height) / 2;
        buttonRect.moveTo(positionLeft, positionTop);
        const absoluteButtonRect = buttonRect.toAbsoluteRect();
        this.buttonView.top = absoluteButtonRect.top;
        this.buttonView.left = absoluteButtonRect.left;
        this._clipButtonToViewport(this.buttonView, editableElement);
    }
    /**
	* Clips the button element to the viewport of the editable element.
	*
	* 	* If the button overflows the editable viewport, it is clipped to make it look like it's cut off by the editable scrollable region.
	* 	* If the button is fully hidden by the top of the editable, it is not clickable but still visible in the DOM.
	*
	* @param buttonView The button view to clip.
	* @param editableElement The editable element whose viewport is used for clipping.
	*/ _clipButtonToViewport(buttonView, editableElement) {
        const absoluteButtonRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(buttonView.element);
        const scrollViewportRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(editableElement).getVisible();
        const setButtonClipping = (...paths)=>{
            buttonView.element.style.clipPath = paths.length ? `polygon(${paths.join(",")})` : "";
        };
        const markAsHidden = (isHidden)=>{
            buttonView.isEnabled = !isHidden;
            buttonView.element.style.pointerEvents = isHidden ? "none" : "";
        };
        if (scrollViewportRect && scrollViewportRect.bottom < absoluteButtonRect.bottom) {
            const delta = Math.min(absoluteButtonRect.height, absoluteButtonRect.bottom - scrollViewportRect.bottom);
            markAsHidden(delta >= absoluteButtonRect.height);
            setButtonClipping("0 0", "100% 0", `100% calc(100% - ${$29fd27cb9bdab9d2$var$toPx(delta)})`, `0 calc(100% - ${$29fd27cb9bdab9d2$var$toPx(delta)}`);
        } else if (scrollViewportRect && scrollViewportRect.top > absoluteButtonRect.top) {
            const delta = Math.min(absoluteButtonRect.height, scrollViewportRect.top - absoluteButtonRect.top);
            markAsHidden(delta >= absoluteButtonRect.height);
            setButtonClipping(`0 ${$29fd27cb9bdab9d2$var$toPx(delta)}`, `100% ${$29fd27cb9bdab9d2$var$toPx(delta)}`, "100% 100%", "0 100%");
        } else {
            markAsHidden(false);
            setButtonClipping();
        }
    }
    /**
	* Creates a resize observer that observes selected editable and resizes the toolbar panel accordingly.
	*/ _setupToolbarResize() {
        const editableElement = this._getSelectedEditableElement();
        if (!this._blockToolbarConfig.shouldNotGroupWhenFull) {
            if (this._resizeObserver && this._resizeObserver.element !== editableElement) {
                this._resizeObserver.destroy();
                this._resizeObserver = null;
            }
            if (!this._resizeObserver) this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(editableElement, ()=>{
                this.toolbarView.maxWidth = this._getToolbarMaxWidth(editableElement);
            });
        }
    }
    /**
	* Gets the {@link #toolbarView} max-width, based on given `editableElement` width plus the distance between the farthest
	* edge of the {@link #buttonView} and the editable.
	*
	* @returns A maximum width that toolbar can have, in pixels.
	*/ _getToolbarMaxWidth(editableElement) {
        const editableRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(editableElement);
        const buttonRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.buttonView.element);
        const offset = this.editor.locale.uiLanguageDirection === "rtl" ? buttonRect.left - editableRect.right + buttonRect.width : editableRect.left - buttonRect.left;
        return $29fd27cb9bdab9d2$var$toPx(editableRect.width + offset);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/menubar/menubarmenubuttonview
*/ /**
* A menu {@link module:ui/menubar/menubarmenuview~MenuBarMenuView#buttonView} class. Buttons like this one
* open both top-level bar menus as well as sub-menus.
*/ var $29fd27cb9bdab9d2$export$e89daab74535810b = class extends $29fd27cb9bdab9d2$export$244268489b08fe2c {
    /**
	* An icon that displays an arrow to indicate a direction of the menu.
	*/ arrowView;
    /**
	* Creates an instance of the menu bar button view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set({
            withText: true,
            role: "menuitem"
        });
        this.arrowView = this._createArrowView();
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-menu-bar__menu__button"
                ],
                "aria-haspopup": true,
                "aria-expanded": this.bindTemplate.to("isOn", (value)=>String(value)),
                "data-cke-tooltip-disabled": bind.to("isOn")
            },
            on: {
                "mouseenter": bind.to("mouseenter")
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.arrowView);
    }
    /**
	* Creates the {@link #arrowView} instance.
	*/ _createArrowView() {
        const arrowView = new $29fd27cb9bdab9d2$export$212c60ac61334981();
        arrowView.content = (0, $e8dc502aba5ac3f5$export$48d0dd33d947d151);
        arrowView.extendTemplate({
            attributes: {
                class: "ck-menu-bar__menu__button__arrow"
            }
        });
        return arrowView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A view representing a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView#panelView} of a menu.
*/ var $29fd27cb9bdab9d2$export$1749730cc6fa78f = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views in this panel.
	*/ children;
    /**
	* Creates an instance of the menu panel view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isVisible", false);
        this.set("position", "se");
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-reset",
                    "ck-menu-bar__menu__panel",
                    bind.to("position", (value)=>`ck-menu-bar__menu__panel_position_${value}`),
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ],
                tabindex: "-1"
            },
            children: this.children,
            on: {
                selectstart: bind.to((evt)=>{
                    if (evt.target.tagName.toLocaleLowerCase() === "input") return;
                    evt.preventDefault();
                })
            }
        });
    }
    /**
	* Focuses the first child of the panel (default) or the last one if the `direction` is `-1`.
	*/ focus(direction = 1) {
        if (this.children.length) {
            if (direction === 1) this.children.first.focus();
            else this.children.last.focus();
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/menubar/menubarmenuview
*/ /**
* A menu view for the {@link module:ui/menubar/menubarview~MenuBarView}. Menus are building blocks of the menu bar,
* they host other sub-menus and menu items (buttons) that users can interact with.
*/ var $29fd27cb9bdab9d2$export$4ba688433f6c2b4f = class MenuBarMenuView extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Button of the menu view.
	*/ buttonView;
    /**
	* Panel of the menu. It hosts children of the menu.
	*/ panelView;
    /**
	* Tracks information about the DOM focus in the menu.
	*/ focusTracker;
    /**
	* Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
	* keystrokes of the menu.
	*/ keystrokes;
    /**
	* Creates an instance of the menu view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.buttonView = new $29fd27cb9bdab9d2$export$e89daab74535810b(locale);
        this.buttonView.delegate("mouseenter").to(this);
        this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled");
        this.panelView = new $29fd27cb9bdab9d2$export$1749730cc6fa78f(locale);
        this.panelView.bind("isVisible").to(this, "isOpen");
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.set("isOpen", false);
        this.set("isEnabled", true);
        this.set("panelPosition", "w");
        this.set("class", void 0);
        this.set("parentMenuView", null);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-menu-bar__menu",
                    bind.to("class"),
                    bind.if("isEnabled", "ck-disabled", (value)=>!value),
                    bind.if("parentMenuView", "ck-menu-bar__menu_top-level", (value)=>!value)
                ]
            },
            children: [
                this.buttonView,
                this.panelView
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.buttonView.element);
        this.focusTracker.add(this.panelView.element);
        this.keystrokes.listenTo(this.element);
        $29fd27cb9bdab9d2$export$4961f96b68698761.closeOnEscKey(this);
        this._closeOnDisabled();
        this._repositionPanelOnOpen();
    }
    /**
	* Attach all keyboard behaviors for the menu bar view.
	*
	* @internal
	*/ _attachBehaviors() {
        if (!this.parentMenuView) {
            this._propagateArrowKeystrokeEvents();
            $29fd27cb9bdab9d2$export$4961f96b68698761.openAndFocusPanelOnArrowDownKey(this);
            $29fd27cb9bdab9d2$export$4961f96b68698761.toggleOnButtonClick(this);
        } else {
            $29fd27cb9bdab9d2$export$4961f96b68698761.openOnButtonClick(this);
            $29fd27cb9bdab9d2$export$4961f96b68698761.openOnArrowRightKey(this);
            $29fd27cb9bdab9d2$export$4961f96b68698761.closeOnArrowLeftKey(this);
            $29fd27cb9bdab9d2$export$4961f96b68698761.openAndFocusOnEnterKeyPress(this);
            $29fd27cb9bdab9d2$export$4961f96b68698761.closeOnParentClose(this);
        }
    }
    /**
	* Fires `arrowright` and `arrowleft` events when the user pressed corresponding arrow keys.
	*/ _propagateArrowKeystrokeEvents() {
        this.keystrokes.set("arrowright", (data, cancel)=>{
            this.fire("arrowright");
            cancel();
        });
        this.keystrokes.set("arrowleft", (data, cancel)=>{
            this.fire("arrowleft");
            cancel();
        });
    }
    /**
	* Closes the menu whenever it gets disabled to avoid leaving an open panel in a non-interactive state.
	*/ _closeOnDisabled() {
        this.on("change:isEnabled", (evt, name, isEnabled)=>{
            if (!isEnabled) this.isOpen = false;
        });
    }
    /**
	* Sets the position of the panel when the menu opens. The panel is positioned
	* so that it optimally uses the available space in the viewport.
	*/ _repositionPanelOnOpen() {
        this.on("change:isOpen", (evt, name, isOpen)=>{
            if (!isOpen) return;
            const optimalPanelPosition = MenuBarMenuView._getOptimalPosition({
                element: this.panelView.element,
                target: this.buttonView.element,
                fitInViewport: true,
                positions: this._panelPositions
            });
            this.panelView.position = optimalPanelPosition ? optimalPanelPosition.name : this._defaultMenuPositionName;
        });
    }
    /**
	* @inheritDoc
	*/ focus() {
        this.buttonView.focus();
    }
    /**
	* Positioning functions for the {@link #panelView} . They change depending on the role of the menu (top-level vs sub-menu) in
	* the {@link module:ui/menubar/menubarview~MenuBarView menu bar} and the UI language direction.
	*/ get _panelPositions() {
        const { southEast: southEast, southWest: southWest, northEast: northEast, northWest: northWest, westSouth: westSouth, eastSouth: eastSouth, westNorth: westNorth, eastNorth: eastNorth } = $29fd27cb9bdab9d2$export$abd8eed83527aff8;
        if (this.locale.uiLanguageDirection === "ltr") {
            if (this.parentMenuView) return [
                eastSouth,
                eastNorth,
                westSouth,
                westNorth
            ];
            else return [
                southEast,
                southWest,
                northEast,
                northWest
            ];
        } else if (this.parentMenuView) return [
            westSouth,
            westNorth,
            eastSouth,
            eastNorth
        ];
        else return [
            southWest,
            southEast,
            northWest,
            northEast
        ];
    }
    /**
	* The default position of the panel when the menu is opened.
	* It is used when the optimal position cannot be calculated.
	*/ get _defaultMenuPositionName() {
        if (this.locale.uiLanguageDirection === "ltr") {
            if (this.parentMenuView) return "es";
            else return "se";
        } else if (this.parentMenuView) return "ws";
        else return "sw";
    }
    /**
	* A function used to calculate the optimal position for the dropdown panel.
	*
	* Referenced for unit testing purposes.
	*/ static _getOptimalPosition = (0, $c7bc2cb7e2db0227$export$75cda5409326f127);
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A list of menu bar items, a child of {@link module:ui/menubar/menubarmenuview~MenuBarMenuView#panelView}.
*
* Use this class to create a list of items (options, buttons) to be displayed in a menu bar.
*
* To populate this list, use {@link module:ui/menubar/menubarmenulistitemview~MenuBarMenuListItemView} instances.
*/ var $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1 = class extends $29fd27cb9bdab9d2$export$84d0dd190d551cd1 {
    /**
	* Creates an instance of the list view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.role = "menu";
        this.items.on("change", this._setItemsCheckSpace.bind(this));
    }
    /**
	* This method adds empty space if there is any toggleable item in the list.
	* It makes the list properly aligned.
	*/ _setItemsCheckSpace() {
        const hasAnyToggleableItem = Array.from(this.items).some((item)=>{
            const listButtonView = $29fd27cb9bdab9d2$var$pickListButtonMenuViewIfPresent(item);
            return listButtonView && listButtonView.isToggleable;
        });
        this.items.forEach((item)=>{
            const listButtonView = $29fd27cb9bdab9d2$var$pickListButtonMenuViewIfPresent(item);
            if (listButtonView) listButtonView.hasCheckSpace = hasAnyToggleableItem;
        });
    }
};
/**
* Picks the first button menu view from the given item if present.
*
* @param item The item to check for a button menu view.
* @returns The first button menu view found in the item, or `null` if not found.
*/ function $29fd27cb9bdab9d2$var$pickListButtonMenuViewIfPresent(item) {
    if (!(item instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8)) return null;
    return item.children.map((child)=>$29fd27cb9bdab9d2$var$isNestedMenuLikeView(child) ? child.buttonView : child).find((item)=>item instanceof $29fd27cb9bdab9d2$export$244268489b08fe2c);
}
/**
* Checks if the given item is a nested menu-like view. `MenuBarMenuView` imports this file
* so to avoid circular dependencies, this function is defined in more generic way.
*
* @param item The item to check.
* @returns `true` if the item is a nested menu-like view, `false` otherwise.
*/ function $29fd27cb9bdab9d2$var$isNestedMenuLikeView(item) {
    return typeof item === "object" && "buttonView" in item && item.buttonView instanceof $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A menu bar list file dialog button view. Buttons like this one execute user actions.
*
* This component provides a button that opens the native file selection dialog.
*/ var $29fd27cb9bdab9d2$export$5f8c3e2cf36794ec = class extends $29fd27cb9bdab9d2$export$628f00df25efb6ab {
    /**
	* Creates an instance of the menu bar list button view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.set({
            withText: true,
            withKeystroke: true,
            tooltip: false,
            role: "menuitem"
        });
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-menu-bar__menu__item__button"
                ]
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ui/menubar/menubarview
*/ const $29fd27cb9bdab9d2$var$EVENT_NAME_DELEGATES = [
    "mouseenter",
    "arrowleft",
    "arrowright",
    "change:isOpen"
];
/**
* The application menu bar component. It brings a set of top-level menus (and sub-menus) that can be used
* to organize and access a large number of buttons.
*/ var $29fd27cb9bdab9d2$export$7215546daccd56dc = class extends $29fd27cb9bdab9d2$export$27a5bd065ad55220 {
    /**
	* Collection of the child views inside the {@link #element}.
	*/ children;
    /**
	* A list of {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} instances registered in the menu bar.
	*
	* @observable
	*/ menus = [];
    /**
	* Creates an instance of the menu bar view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const t = locale.t;
        const bind = this.bindTemplate;
        this.set({
            isOpen: false,
            isFocusBorderEnabled: false
        });
        this._setupIsOpenUpdater();
        this.children = this.createCollection();
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-menu-bar",
                    bind.if("isFocusBorderEnabled", "ck-menu-bar_focus-border-enabled")
                ],
                "aria-label": t("Editor menu bar"),
                role: "menubar"
            },
            children: this.children
        });
    }
    /**
	* A utility that expands a plain menu bar configuration into a structure of menus (also: sub-menus)
	* and items using a given {@link module:ui/componentfactory~ComponentFactory component factory}.
	*
	* See the {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar} in the editor
	* configuration reference to learn how to configure the menu bar.
	*/ fillFromConfig(config, componentFactory, extraItems = []) {
        const locale = this.locale;
        const topLevelCategoryMenuViews = $29fd27cb9bdab9d2$export$f69147cda03478ca({
            normalizedConfig: config,
            locale: locale,
            componentFactory: componentFactory,
            extraItems: extraItems
        }).items.map((menuDefinition)=>this._createMenu({
                componentFactory: componentFactory,
                menuDefinition: menuDefinition
            }));
        this.children.addMany(topLevelCategoryMenuViews);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        $29fd27cb9bdab9d2$export$6e608be8caac6394.toggleMenusAndFocusItemsOnHover(this);
        $29fd27cb9bdab9d2$export$6e608be8caac6394.closeMenusWhenTheBarCloses(this);
        $29fd27cb9bdab9d2$export$6e608be8caac6394.closeMenuWhenAnotherOnTheSameLevelOpens(this);
        $29fd27cb9bdab9d2$export$6e608be8caac6394.focusCycleMenusOnArrows(this);
        $29fd27cb9bdab9d2$export$6e608be8caac6394.closeOnClickOutside(this);
        $29fd27cb9bdab9d2$export$6e608be8caac6394.enableFocusHighlightOnInteraction(this);
    }
    /**
	* Focuses the menu bar.
	*/ focus() {
        if (this.children.first) this.children.first.focus();
    }
    /**
	* Closes all menus in the bar.
	*/ close() {
        for (const topLevelCategoryMenuView of this.children)topLevelCategoryMenuView.isOpen = false;
        this.isOpen = false;
    }
    /**
	* Disables all menus in the bar.
	*/ disable() {
        for (const topLevelCategoryMenuView of this.children)topLevelCategoryMenuView.isEnabled = false;
    }
    /**
	* Enables all menus in the bar.
	*/ enable() {
        for (const topLevelCategoryMenuView of this.children)topLevelCategoryMenuView.isEnabled = true;
    }
    /**
	* Registers a menu view in the menu bar. Every {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} instance must be registered
	* in the menu bar to be properly managed.
	*/ registerMenu(menuView, parentMenuView = null) {
        if (parentMenuView) {
            menuView.delegate(...$29fd27cb9bdab9d2$var$EVENT_NAME_DELEGATES).to(parentMenuView);
            menuView.parentMenuView = parentMenuView;
        } else menuView.delegate(...$29fd27cb9bdab9d2$var$EVENT_NAME_DELEGATES).to(this, (name)=>"menu:" + name);
        menuView._attachBehaviors();
        this.menus.push(menuView);
    }
    /**
	* Creates a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} based on the given definition.
	*/ _createMenu({ componentFactory: componentFactory, menuDefinition: menuDefinition, parentMenuView: parentMenuView }) {
        const locale = this.locale;
        const menuView = new $29fd27cb9bdab9d2$export$4ba688433f6c2b4f(locale);
        this.registerMenu(menuView, parentMenuView);
        menuView.buttonView.set({
            label: menuDefinition.label
        });
        menuView.once("change:isOpen", ()=>{
            const listView = new $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1(locale);
            listView.ariaLabel = menuDefinition.label;
            menuView.panelView.children.add(listView);
            listView.items.addMany(this._createMenuItems({
                menuDefinition: menuDefinition,
                parentMenuView: menuView,
                componentFactory: componentFactory
            }));
        });
        return menuView;
    }
    /**
	* Creates a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} items based on the given definition.
	*/ _createMenuItems({ menuDefinition: menuDefinition, parentMenuView: parentMenuView, componentFactory: componentFactory }) {
        const locale = this.locale;
        const items = [];
        for (const menuGroupDefinition of menuDefinition.groups){
            for (const itemDefinition of menuGroupDefinition.items){
                const menuItemView = new $29fd27cb9bdab9d2$export$b8932d143ba0ac18(locale, parentMenuView);
                if ((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(itemDefinition)) menuItemView.children.add(this._createMenu({
                    componentFactory: componentFactory,
                    menuDefinition: itemDefinition,
                    parentMenuView: parentMenuView
                }));
                else {
                    const componentView = this._createMenuItemContentFromFactory({
                        componentName: itemDefinition,
                        componentFactory: componentFactory,
                        parentMenuView: parentMenuView
                    });
                    if (!componentView) continue;
                    menuItemView.children.add(componentView);
                }
                items.push(menuItemView);
            }
            if (menuGroupDefinition !== menuDefinition.groups[menuDefinition.groups.length - 1]) items.push(new $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0(locale));
        }
        return items;
    }
    /**
	* Uses the component factory to create a content of the menu item (a button or a sub-menu).
	*/ _createMenuItemContentFromFactory({ componentName: componentName, parentMenuView: parentMenuView, componentFactory: componentFactory }) {
        const componentView = componentFactory.create(componentName);
        if (!(componentView instanceof $29fd27cb9bdab9d2$export$4ba688433f6c2b4f || componentView instanceof $29fd27cb9bdab9d2$export$6d96eff7641aad53 || componentView instanceof $29fd27cb9bdab9d2$export$5f8c3e2cf36794ec)) {
            /**
			* Adding unsupported components to the {@link module:ui/menubar/menubarview~MenuBarView} is not possible.
			*
			* A component should be either a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} (sub-menu) or a
			* {@link module:ui/menubar/menubarmenulistitembuttonview~MenuBarMenuListItemButtonView} (button).
			*
			* @error menu-bar-component-unsupported
			* @param {string} componentName A name of the unsupported component used in the configuration.
			* @param {module:ui/view~View} componentView An unsupported component view.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("menu-bar-component-unsupported", {
                componentName: componentName,
                componentView: componentView
            });
            return null;
        }
        this._registerMenuTree(componentView, parentMenuView);
        componentView.on("execute", ()=>{
            this.close();
        });
        return componentView;
    }
    /**
	* Checks component and its children recursively and calls {@link #registerMenu}
	* for each item that is {@link module:ui/menubar/menubarmenuview~MenuBarMenuView}.
	*
	* @internal
	*/ _registerMenuTree(componentView, parentMenuView) {
        if (!(componentView instanceof $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)) {
            componentView.delegate("mouseenter").to(parentMenuView);
            return;
        }
        this.registerMenu(componentView, parentMenuView);
        const menuBarItemsList = componentView.panelView.children.filter((child)=>child instanceof $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)[0];
        if (!menuBarItemsList) {
            componentView.delegate("mouseenter").to(parentMenuView);
            return;
        }
        const nonSeparatorItems = menuBarItemsList.items.filter((item)=>item instanceof $29fd27cb9bdab9d2$export$41fd379e664153d8);
        for (const item of nonSeparatorItems)this._registerMenuTree(item.children.get(0), componentView);
    }
    /**
	* Manages the state of the {@link #isOpen} property of the menu bar. Because the state is a sum of individual
	* top-level menus' states, it's necessary to listen to their changes and update the state accordingly.
	*
	* Additionally, it prevents from unnecessary changes of `isOpen` when one top-level menu opens and another closes
	* (regardless of in which order), maintaining a stable `isOpen === true` in that situation.
	*/ _setupIsOpenUpdater() {
        let closeTimeout;
        this.on("menu:change:isOpen", (evt, name, isOpen)=>{
            clearTimeout(closeTimeout);
            if (isOpen) this.isOpen = true;
            else closeTimeout = setTimeout(()=>{
                this.isOpen = Array.from(this.children).some((menuView)=>menuView.isOpen);
            }, 0);
        });
    }
};



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module alignment/utils
*/ /**
* The list of supported alignment options:
*
* * `'left'`,
* * `'right'`,
* * `'center'`,
* * `'justify'`
*
* @internal
*/ const $1bc37dabbc444659$export$b55d41575c917d27 = [
    "left",
    "right",
    "center",
    "justify"
];
/**
* Checks whether the passed option is supported by {@link module:alignment/alignmentediting~AlignmentEditing}.
*
* @internal
* @param option The option value to check.
*/ function $1bc37dabbc444659$export$1041c6c574aaf6a4(option) {
    return $1bc37dabbc444659$export$b55d41575c917d27.includes(option);
}
/**
* Checks whether alignment is the default one considering the direction
* of the editor content.
*
* @internal
* @param alignment The name of the alignment to check.
* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
*/ function $1bc37dabbc444659$export$de0c1a715376f191(alignment, locale) {
    if (locale.contentLanguageDirection == "rtl") return alignment === "right";
    else return alignment === "left";
}
/**
* Brings the configuration to the common form, an array of objects.
*
* @internal
* @param configuredOptions Alignment plugin configuration.
* @returns Normalized object holding the configuration.
*/ function $1bc37dabbc444659$export$6fe4c6aa47019d34(configuredOptions) {
    const normalizedOptions = configuredOptions.map((option)=>{
        let result;
        if (typeof option == "string") result = {
            name: option
        };
        else result = option;
        return result;
    }).filter((option)=>{
        const isNameValid = $1bc37dabbc444659$export$b55d41575c917d27.includes(option.name);
        if (!isNameValid) /**
		* The `name` in one of the `alignment.options` is not recognized.
		* The available options are: `'left'`, `'right'`, `'center'` and `'justify'`.
		*
		* @error alignment-config-name-not-recognized
		* @param {object} option Options with unknown value of the `name` property.
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("alignment-config-name-not-recognized", {
            option: option
        });
        return isNameValid;
    });
    const classNameCount = normalizedOptions.filter((option)=>Boolean(option.className)).length;
    if (classNameCount && classNameCount < normalizedOptions.length) /**
	* The `className` property has to be defined for all options once at least one option declares `className`.
	*
	* @error alignment-config-classnames-are-missing
	* @param {object} configuredOptions Contents of `alignment.options`.
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("alignment-config-classnames-are-missing", {
        configuredOptions: configuredOptions
    });
    normalizedOptions.forEach((option, index, allOptions)=>{
        const succeedingOptions = allOptions.slice(index + 1);
        if (succeedingOptions.some((item)=>item.name == option.name)) /**
		* The same `name` in one of the `alignment.options` was already declared.
		* Each `name` representing one alignment option can be set exactly once.
		*
		* @error alignment-config-name-already-defined
		* @param {object} option First option that declares given `name`.
		* @param {object} configuredOptions Contents of `alignment.options`.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("alignment-config-name-already-defined", {
            option: option,
            configuredOptions: configuredOptions
        });
        if (option.className) {
            if (succeedingOptions.some((item)=>item.className == option.className)) /**
			* The same `className` in one of the `alignment.options` was already declared.
			*
			* @error alignment-config-classname-already-defined
			* @param {object} option First option that declares given `className`.
			* @param {object} configuredOptions
			* Contents of `alignment.options`.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("alignment-config-classname-already-defined", {
                option: option,
                configuredOptions: configuredOptions
            });
        }
    });
    return normalizedOptions;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module alignment/alignmentcommand
*/ const $1bc37dabbc444659$var$ALIGNMENT = "alignment";
/**
* The alignment command plugin.
*/ var $1bc37dabbc444659$export$86bdacef645ddb24 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const locale = this.editor.locale;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this.editor.model.document.selection.getSelectedBlocks());
        this.isEnabled = Boolean(firstBlock) && this._canBeAligned(firstBlock);
        if (this.isEnabled && firstBlock.hasAttribute("alignment")) this.value = firstBlock.getAttribute("alignment");
        else this.value = locale.contentLanguageDirection === "rtl" ? "right" : "left";
    }
    /**
	* Executes the command. Applies the alignment `value` to the selected blocks.
	* If no `value` is passed, the `value` is the default one or it is equal to the currently selected block's alignment attribute,
	* the command will remove the attribute from the selected blocks.
	*
	* @param options Options for the executed command.
	* @param options.value The value to apply.
	* @fires execute
	*/ execute(options = {}) {
        const editor = this.editor;
        const locale = editor.locale;
        const model = editor.model;
        const doc = model.document;
        const value = options.value;
        model.change((writer)=>{
            const blocks = Array.from(doc.selection.getSelectedBlocks()).filter((block)=>this._canBeAligned(block));
            const currentAlignment = blocks[0].getAttribute("alignment");
            if ($1bc37dabbc444659$export$de0c1a715376f191(value, locale) || currentAlignment === value || !value) $1bc37dabbc444659$var$removeAlignmentFromSelection(blocks, writer);
            else $1bc37dabbc444659$var$setAlignmentOnSelection(blocks, writer, value);
        });
    }
    /**
	* Checks whether a block can have alignment set.
	*
	* @param block The block to be checked.
	*/ _canBeAligned(block) {
        return this.editor.model.schema.checkAttribute(block, $1bc37dabbc444659$var$ALIGNMENT);
    }
};
/**
* Removes the alignment attribute from blocks.
*/ function $1bc37dabbc444659$var$removeAlignmentFromSelection(blocks, writer) {
    for (const block of blocks)writer.removeAttribute($1bc37dabbc444659$var$ALIGNMENT, block);
}
/**
* Sets the alignment attribute on blocks.
*/ function $1bc37dabbc444659$var$setAlignmentOnSelection(blocks, writer, alignment) {
    for (const block of blocks)writer.setAttribute($1bc37dabbc444659$var$ALIGNMENT, alignment, block);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module alignment/alignmentediting
*/ /**
* The alignment editing feature. It introduces the {@link module:alignment/alignmentcommand~AlignmentCommand command} and adds
* the `alignment` attribute for block elements in the {@link module:engine/model/model~Model model}.
*/ var $1bc37dabbc444659$export$1041f73591fa297f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AlignmentEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("alignment", {
            options: $1bc37dabbc444659$export$b55d41575c917d27.map((option)=>({
                    name: option
                }))
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const locale = editor.locale;
        const schema = editor.model.schema;
        const optionsToConvert = $1bc37dabbc444659$export$6fe4c6aa47019d34(editor.config.get("alignment.options")).filter((option)=>$1bc37dabbc444659$export$1041c6c574aaf6a4(option.name) && !$1bc37dabbc444659$export$de0c1a715376f191(option.name, locale));
        const shouldUseClasses = optionsToConvert.some((option)=>!!option.className);
        schema.extend("$block", {
            allowAttributes: "alignment"
        });
        editor.model.schema.setAttributeProperties("alignment", {
            isFormatting: true,
            blockAlignment: $1bc37dabbc444659$var$getBlockAlignmentAttributeProperty(locale)
        });
        if (shouldUseClasses) editor.conversion.attributeToAttribute($1bc37dabbc444659$var$buildClassDefinition(optionsToConvert));
        else editor.conversion.for("downcast").attributeToAttribute($1bc37dabbc444659$var$buildDowncastInlineDefinition(optionsToConvert));
        const upcastInlineDefinitions = $1bc37dabbc444659$var$buildUpcastInlineDefinitions(optionsToConvert);
        for (const definition of upcastInlineDefinitions)editor.conversion.for("upcast").attributeToAttribute(definition);
        const upcastCompatibilityDefinitions = $1bc37dabbc444659$var$buildUpcastCompatibilityDefinitions(optionsToConvert);
        for (const definition of upcastCompatibilityDefinitions)editor.conversion.for("upcast").attributeToAttribute(definition);
        editor.commands.add("alignment", new $1bc37dabbc444659$export$86bdacef645ddb24(editor));
    }
};
/**
* Prepare block alignment mapping for all possible alignment options.
*/ function $1bc37dabbc444659$var$getBlockAlignmentAttributeProperty(locale) {
    const blockAlignment = {
        left: {
            value: "left"
        },
        right: {
            value: "right"
        },
        center: {
            value: "center"
        },
        justify: {
            value: "justify"
        }
    };
    const defaultDirection = locale.contentLanguageDirection == "rtl" ? "right" : "left";
    blockAlignment[defaultDirection].isDefault = true;
    return blockAlignment;
}
/**
* Prepare downcast conversion definition for inline alignment styling.
*/ function $1bc37dabbc444659$var$buildDowncastInlineDefinition(options) {
    const view = {};
    for (const { name: name } of options)view[name] = {
        key: "style",
        value: {
            "text-align": name
        }
    };
    return {
        model: {
            key: "alignment",
            values: options.map((option)=>option.name)
        },
        view: view
    };
}
/**
* Prepare upcast definitions for inline alignment styles.
*/ function $1bc37dabbc444659$var$buildUpcastInlineDefinitions(options) {
    const definitions = [];
    for (const { name: name } of options)definitions.push({
        view: {
            key: "style",
            value: {
                "text-align": name
            }
        },
        model: {
            key: "alignment",
            value: name
        }
    });
    return definitions;
}
/**
* Prepare upcast definitions for deprecated `align` attribute.
*/ function $1bc37dabbc444659$var$buildUpcastCompatibilityDefinitions(options) {
    const definitions = [];
    for (const { name: name } of options)definitions.push({
        view: {
            key: "align",
            value: name
        },
        model: {
            key: "alignment",
            value: name
        }
    });
    return definitions;
}
/**
* Prepare conversion definitions for upcast and downcast alignment with classes.
*/ function $1bc37dabbc444659$var$buildClassDefinition(options) {
    const view = {};
    for (const option of options)view[option.name] = {
        key: "class",
        value: option.className
    };
    return {
        model: {
            key: "alignment",
            values: options.map((option)=>option.name)
        },
        view: view
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module alignment/alignmentui
*/ const $1bc37dabbc444659$var$iconsMap = /* #__PURE__ */ (()=>/* @__PURE__ */ new Map([
        [
            "left",
            (0, $e8dc502aba5ac3f5$export$df3b17223210ab85)
        ],
        [
            "right",
            (0, $e8dc502aba5ac3f5$export$bd03fac3c90d8fee)
        ],
        [
            "center",
            (0, $e8dc502aba5ac3f5$export$a36e1e8e01d62636)
        ],
        [
            "justify",
            (0, $e8dc502aba5ac3f5$export$e9b166ff0ced1423)
        ]
    ]))();
/**
* The default alignment UI plugin.
*
* It introduces the `'alignment:left'`, `'alignment:right'`, `'alignment:center'` and `'alignment:justify'` buttons
* and the `'alignment'` dropdown.
*/ var $1bc37dabbc444659$export$3617c067af186a57 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Returns the localized option titles provided by the plugin.
	*
	* The following localized titles corresponding with
	* {@link module:alignment/alignmentconfig~AlignmentConfig#options} are available:
	*
	* * `'left'`,
	* * `'right'`,
	* * `'center'`,
	* * `'justify'`.
	*
	* @readonly
	*/ get localizedOptionTitles() {
        const t = this.editor.t;
        return {
            "left": t("Align left"),
            "right": t("Align right"),
            "center": t("Align center"),
            "justify": t("Justify")
        };
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AlignmentUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const options = $1bc37dabbc444659$export$6fe4c6aa47019d34(editor.config.get("alignment.options"));
        options.map((option)=>option.name).filter($1bc37dabbc444659$export$1041c6c574aaf6a4).forEach((option)=>this._addButton(option));
        this._addToolbarDropdown(options);
        this._addMenuBarMenu(options);
    }
    /**
	* Helper method for initializing the button and linking it with an appropriate command.
	*
	* @param option The name of the alignment option for which the button is added.
	*/ _addButton(option) {
        this.editor.ui.componentFactory.add(`alignment:${option}`, (locale)=>this._createButton(locale, option));
    }
    /**
	* Helper method for creating the button view element.
	*
	* @param locale Editor locale.
	* @param option The name of the alignment option for which the button is added.
	* @param buttonAttrs Optional parameters passed to button view instance.
	*/ _createButton(locale, option, buttonAttrs = {}) {
        const editor = this.editor;
        const command = editor.commands.get("alignment");
        const buttonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        buttonView.set({
            label: this.localizedOptionTitles[option],
            icon: $1bc37dabbc444659$var$iconsMap.get(option),
            tooltip: true,
            isToggleable: true,
            ...buttonAttrs
        });
        buttonView.bind("isEnabled").to(command);
        buttonView.bind("isOn").to(command, "value", (value)=>value === option);
        this.listenTo(buttonView, "execute", ()=>{
            editor.execute("alignment", {
                value: option
            });
            editor.editing.view.focus();
        });
        return buttonView;
    }
    /**
	* Helper method for initializing the toolnar dropdown and linking it with an appropriate command.
	*
	* @param options The name of the alignment option for which the button is added.
	*/ _addToolbarDropdown(options) {
        const editor = this.editor;
        editor.ui.componentFactory.add("alignment", (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            const tooltipPosition = locale.uiLanguageDirection === "rtl" ? "w" : "e";
            const t = locale.t;
            (0, $29fd27cb9bdab9d2$export$c39319333c19bdd7)(dropdownView, ()=>options.map((option)=>this._createButton(locale, option.name, {
                        tooltipPosition: tooltipPosition
                    })), {
                enableActiveItemFocusOnDropdownOpen: true,
                isVertical: true,
                ariaLabel: t("Text alignment toolbar")
            });
            dropdownView.buttonView.set({
                label: t("Text alignment"),
                tooltip: true
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: "ck-alignment-dropdown"
                }
            });
            const defaultIcon = locale.contentLanguageDirection === "rtl" ? $1bc37dabbc444659$var$iconsMap.get("right") : $1bc37dabbc444659$var$iconsMap.get("left");
            const command = editor.commands.get("alignment");
            dropdownView.buttonView.bind("icon").to(command, "value", (value)=>$1bc37dabbc444659$var$iconsMap.get(value) || defaultIcon);
            dropdownView.bind("isEnabled").to(command, "isEnabled");
            this.listenTo(dropdownView, "execute", ()=>{
                editor.editing.view.focus();
            });
            return dropdownView;
        });
    }
    /**
	* Creates a menu for all alignment options to use either in menu bar.
	*
	* @param options Normalized alignment options from config.
	*/ _addMenuBarMenu(options) {
        const editor = this.editor;
        editor.ui.componentFactory.add("menuBar:alignment", (locale)=>{
            const command = editor.commands.get("alignment");
            const t = locale.t;
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            menuView.bind("isEnabled").to(command);
            listView.set({
                ariaLabel: t("Text alignment"),
                role: "menu"
            });
            menuView.buttonView.set({
                label: t("Text alignment")
            });
            for (const option of options){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.delegate("execute").to(menuView);
                buttonView.set({
                    label: this.localizedOptionTitles[option.name],
                    icon: $1bc37dabbc444659$var$iconsMap.get(option.name),
                    role: "menuitemcheckbox",
                    isToggleable: true
                });
                buttonView.on("execute", ()=>{
                    editor.execute("alignment", {
                        value: option.name
                    });
                    editor.editing.view.focus();
                });
                buttonView.bind("isOn").to(command, "value", (value)=>value === option.name);
                buttonView.bind("isEnabled").to(command, "isEnabled");
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            menuView.panelView.children.add(listView);
            return menuView;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module alignment/alignment
*/ /**
* The text alignment plugin.
*
* For a detailed overview, check the {@glink features/text-alignment Text alignment} feature guide
* and the {@glink api/alignment package page}.
*
* This is a "glue" plugin which loads the {@link module:alignment/alignmentediting~AlignmentEditing} and
* {@link module:alignment/alignmentui~AlignmentUI} plugins.
*/ var $1bc37dabbc444659$export$9d7927214ed7d2cf = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $1bc37dabbc444659$export$1041f73591fa297f,
            $1bc37dabbc444659$export$3617c067af186a57
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Alignment";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Change buffer allows to group atomic changes (like characters that have been typed) into
* {@link module:engine/model/batch~Batch batches}.
*
* Batches represent single undo steps, hence changes added to one single batch are undone together.
*
* The buffer has a configurable limit of atomic changes that it can accommodate. After the limit was
* exceeded (see {@link ~TypingChangeBuffer#input}), a new batch is created in {@link ~TypingChangeBuffer#batch}.
*
* To use the change buffer you need to let it know about the number of changes that were added to the batch:
*
* ```ts
* const buffer = new ChangeBuffer( model, LIMIT );
*
* // Later on in your feature:
* buffer.batch.insert( pos, insertedCharacters );
* buffer.input( insertedCharacters.length );
* ```
*/ var $f1defb5a0a139b4c$export$27e7da161ddce0c9 = class {
    /**
	* The model instance.
	*/ model;
    /**
	* The maximum number of atomic changes which can be contained in one batch.
	*/ limit;
    /**
	* Whether the buffer is locked. A locked buffer cannot be reset unless it gets unlocked.
	*/ _isLocked;
    /**
	* The number of atomic changes in the buffer. Once it exceeds the {@link #limit},
	* the {@link #batch batch} is set to a new one.
	*/ _size;
    /**
	* The current batch instance.
	*/ _batch = null;
    /**
	* The callback to document the change event which later needs to be removed.
	*/ _changeCallback;
    /**
	* The callback to document selection `change:attribute` and `change:range` events which resets the buffer.
	*/ _selectionChangeCallback;
    /**
	* Creates a new instance of the change buffer.
	*
	* @param limit The maximum number of atomic changes which can be contained in one batch.
	*/ constructor(model, limit = 20){
        this.model = model;
        this._size = 0;
        this.limit = limit;
        this._isLocked = false;
        this._changeCallback = (evt, batch)=>{
            if (batch.isLocal && batch.isUndoable && batch !== this._batch) this._reset(true);
        };
        this._selectionChangeCallback = ()=>{
            this._reset();
        };
        this.model.document.on("change", this._changeCallback);
        this.model.document.selection.on("change:range", this._selectionChangeCallback);
        this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
    }
    /**
	* The current batch to which a feature should add its operations. Once the {@link #size}
	* is reached or exceeds the {@link #limit}, the batch is set to a new instance and the size is reset.
	*/ get batch() {
        if (!this._batch) this._batch = this.model.createBatch({
            isTyping: true
        });
        return this._batch;
    }
    /**
	* The number of atomic changes in the buffer. Once it exceeds the {@link #limit},
	* the {@link #batch batch} is set to a new one.
	*/ get size() {
        return this._size;
    }
    /**
	* The input number of changes into the buffer. Once the {@link #size} is
	* reached or exceeds the {@link #limit}, the batch is set to a new instance and the size is reset.
	*
	* @param changeCount The number of atomic changes to input.
	*/ input(changeCount) {
        this._size += changeCount;
        if (this._size >= this.limit) this._reset(true);
    }
    /**
	* Whether the buffer is locked. A locked buffer cannot be reset unless it gets unlocked.
	*/ get isLocked() {
        return this._isLocked;
    }
    /**
	* Locks the buffer.
	*/ lock() {
        this._isLocked = true;
    }
    /**
	* Unlocks the buffer.
	*/ unlock() {
        this._isLocked = false;
    }
    /**
	* Destroys the buffer.
	*/ destroy() {
        this.model.document.off("change", this._changeCallback);
        this.model.document.selection.off("change:range", this._selectionChangeCallback);
        this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
    }
    /**
	* Resets the change buffer.
	*
	* @param ignoreLock Whether internal lock {@link #isLocked} should be ignored.
	*/ _reset(ignoreLock = false) {
        if (!this.isLocked || ignoreLock) {
            this._batch = null;
            this._size = 0;
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/inserttextcommand
*/ /**
* The insert text command. Used by the {@link module:typing/input~Input input feature} to handle typing.
*/ var $f1defb5a0a139b4c$export$c7f352380f257cc2 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Typing's change buffer used to group subsequent changes into batches.
	*/ _buffer;
    /**
	* Creates an instance of the command.
	*
	* @param undoStepSize The maximum number of atomic changes
	* which can be contained in one batch in the command buffer.
	*/ constructor(editor, undoStepSize){
        super(editor);
        this._buffer = new $f1defb5a0a139b4c$export$27e7da161ddce0c9(editor.model, undoStepSize);
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* The current change buffer.
	*/ get buffer() {
        return this._buffer;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._buffer.destroy();
    }
    /**
	* Executes the input command. It replaces the content within the given range with the given text.
	* Replacing is a two step process, first the content within the range is removed and then the new text is inserted
	* at the beginning of the range (which after the removal is a collapsed range).
	*
	* @fires execute
	* @param options The command options.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const doc = model.document;
        const text = options.text || "";
        const textInsertions = text.length;
        let selection = doc.selection;
        if (options.selection) selection = options.selection;
        else if (options.range) selection = model.createSelection(options.range);
        if (!model.canEditAt(selection)) return;
        const resultRange = options.resultRange;
        model.enqueueChange(this._buffer.batch, (writer)=>{
            this._buffer.lock();
            const selectionAttributes = Array.from(doc.selection.getAttributes());
            model.deleteContent(selection);
            if (text) model.insertContent(writer.createText(text, selectionAttributes), selection);
            if (resultRange) writer.setSelection(resultRange);
            else if (!selection.is("documentSelection")) writer.setSelection(selection);
            this._buffer.unlock();
            this._buffer.input(textInsertions);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/inserttextobserver
*/ const $f1defb5a0a139b4c$var$TYPING_INPUT_TYPES = [
    "insertText",
    "insertReplacementText"
];
const $f1defb5a0a139b4c$var$TYPING_INPUT_TYPES_ANDROID = [
    ...$f1defb5a0a139b4c$var$TYPING_INPUT_TYPES,
    "insertCompositionText"
];
/**
* Text insertion observer introduces the {@link module:engine/view/document~ViewDocument#event:insertText} event.
*/ var $f1defb5a0a139b4c$export$9e88204c1fb7bbe0 = class extends (0, $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b) {
    /**
	* Instance of the focus observer. Insert text observer calls
	* {@link module:engine/view/observer/focusobserver~FocusObserver#flush} to mark the latest focus change as complete.
	*/ focusObserver;
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        this.focusObserver = view.getObserver((0, $b9b9f2bdf9c6137f$export$c14091c1727e1823));
        const typingInputTypes = (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid ? $f1defb5a0a139b4c$var$TYPING_INPUT_TYPES_ANDROID : $f1defb5a0a139b4c$var$TYPING_INPUT_TYPES;
        const viewDocument = view.document;
        viewDocument.on("beforeinput", (evt, data)=>{
            if (!this.isEnabled) return;
            const { data: text, targetRanges: targetRanges, inputType: inputType, domEvent: domEvent, isComposing: isComposing } = data;
            if (!typingInputTypes.includes(inputType)) return;
            this.focusObserver.flush();
            const eventInfo = new (0, $c7bc2cb7e2db0227$export$3f63aa522937812c)(viewDocument, "insertText");
            viewDocument.fire(eventInfo, new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, domEvent, {
                text: text,
                selection: view.createSelection(targetRanges),
                isComposing: isComposing
            }));
            if (eventInfo.stop.called) evt.stop();
        });
        if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) viewDocument.on("compositionend", (evt, { data: data, domEvent: domEvent })=>{
            if (!this.isEnabled) return;
            if (!data) return;
            viewDocument.fire("insertText", new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, domEvent, {
                text: data,
                isComposing: true
            }));
        }, {
            priority: "low"
        });
    }
    /**
	* @inheritDoc
	*/ observe() {}
    /**
	* @inheritDoc
	*/ stopObserving() {}
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/input
*/ /**
* Handles text input coming from the keyboard or other input methods.
*/ var $f1defb5a0a139b4c$export$f5b8910cec6cf069 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The queue of `insertText` command executions that are waiting for the DOM to get updated after beforeinput event.
	*/ _typingQueue;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Input";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        const mapper = editor.editing.mapper;
        const modelSelection = model.document.selection;
        this._typingQueue = new $f1defb5a0a139b4c$var$TypingQueue(editor);
        view.addObserver($f1defb5a0a139b4c$export$9e88204c1fb7bbe0);
        const insertTextCommand = new $f1defb5a0a139b4c$export$c7f352380f257cc2(editor, editor.config.get("typing.undoStep") || 20);
        editor.commands.add("insertText", insertTextCommand);
        editor.commands.add("input", insertTextCommand);
        this.listenTo(view.document, "beforeinput", ()=>{
            this._typingQueue.flush("next beforeinput");
        }, {
            priority: "high"
        });
        this.listenTo(view.document, "insertText", (evt, data)=>{
            const { text: text, selection: viewSelection } = data;
            if (view.document.selection.isFake && viewSelection && view.document.selection.isSimilar(viewSelection)) data.preventDefault();
            if (viewSelection && Array.from(viewSelection.getRanges()).some((range)=>!range.isCollapsed)) data.preventDefault();
            if (!insertTextCommand.isEnabled) {
                data.preventDefault();
                return;
            }
            let modelRanges;
            if (viewSelection) modelRanges = Array.from(viewSelection.getRanges()).filter((viewRange)=>{
                return viewRange.root.is("rootElement");
            }).map((viewRange)=>mapper.toModelRange(viewRange)).map((modelRange)=>(0, $b9b9f2bdf9c6137f$export$40475a88db3fce3)(modelRange, model.schema) || modelRange);
            if (!modelRanges || !modelRanges.length) modelRanges = Array.from(modelSelection.getRanges());
            let insertText = text;
            if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) {
                const selectedText = Array.from(modelRanges[0].getItems()).reduce((rangeText, node)=>{
                    return rangeText + (node.is("$textProxy") ? node.data : "");
                }, "");
                if (selectedText) {
                    if (selectedText.length <= insertText.length) {
                        if (insertText.startsWith(selectedText)) {
                            insertText = insertText.substring(selectedText.length);
                            modelRanges[0].start = modelRanges[0].start.getShiftedBy(selectedText.length);
                        }
                    } else if (selectedText.startsWith(insertText)) {
                        modelRanges[0].start = modelRanges[0].start.getShiftedBy(insertText.length);
                        insertText = "";
                    }
                }
                if (insertText.length == 0 && modelRanges[0].isCollapsed) return;
            }
            const commandData = {
                text: insertText,
                selection: model.createSelection(modelRanges)
            };
            this._typingQueue.push(commandData, Boolean(data.isComposing));
            if (data.domEvent.defaultPrevented) this._typingQueue.flush("beforeinput default prevented");
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this.listenTo(view.document, "keydown", (evt, data)=>{
            if (modelSelection.isCollapsed || data.keyCode != 229 || !view.document.isComposing) return;
            $f1defb5a0a139b4c$var$deleteSelectionContent(model, insertTextCommand);
        });
        else this.listenTo(view.document, "compositionstart", ()=>{
            if (modelSelection.isCollapsed) return;
            $f1defb5a0a139b4c$var$deleteSelectionContent(model, insertTextCommand);
        }, {
            priority: "high"
        });
        this.listenTo(view.document, "mutations", (evt, { mutations: mutations })=>{
            if (this._typingQueue.hasAffectedElements()) for (const { node: node } of mutations){
                const viewElement = $f1defb5a0a139b4c$var$findMappedViewAncestor(node, mapper);
                const modelElement = mapper.toModelElement(viewElement);
                if (this._typingQueue.isElementAffected(modelElement)) {
                    this._typingQueue.flush("mutations");
                    return;
                }
            }
        });
        this.listenTo(view.document, "compositionend", ()=>{
            this._typingQueue.flush("before composition end");
        }, {
            priority: "high"
        });
        this.listenTo(view.document, "compositionend", ()=>{
            this._typingQueue.flush("after composition end");
            const mutations = [];
            if (this._typingQueue.hasAffectedElements()) for (const element of this._typingQueue.flushAffectedElements()){
                const viewElement = mapper.toViewElement(element);
                if (!viewElement) continue;
                mutations.push({
                    type: "children",
                    node: viewElement
                });
            }
            if (mutations.length || !(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) view.document.fire("mutations", {
                mutations: mutations
            });
        }, {
            priority: "lowest"
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._typingQueue.destroy();
    }
};
/**
* The queue of `insertText` command executions that are waiting for the DOM to get updated after beforeinput event.
*/ var $f1defb5a0a139b4c$var$TypingQueue = class {
    /**
	* The editor instance.
	*/ editor;
    /**
	* Debounced queue flush as a safety mechanism for cases of mutation observer not triggering.
	*/ flushDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(()=>this.flush("timeout"), 50);
    /**
	* The queue of `insertText` command executions that are waiting for the DOM to get updated after beforeinput event.
	*/ _queue = [];
    /**
	* Whether there is any composition enqueued or plain typing only.
	*/ _isComposing = false;
    /**
	* A set of model elements. The typing happened in those elements. It's used for mutations check.
	*/ _affectedElements = /* @__PURE__ */ new Set();
    /**
	* @inheritDoc
	*/ constructor(editor){
        this.editor = editor;
    }
    /**
	* Destroys the helper object.
	*/ destroy() {
        this.flushDebounced.cancel();
        this._affectedElements.clear();
        while(this._queue.length)this.shift();
    }
    /**
	* Returns the size of the queue.
	*/ get length() {
        return this._queue.length;
    }
    /**
	* Push next insertText command data to the queue.
	*/ push(commandData, isComposing) {
        const commandLiveData = {
            text: commandData.text
        };
        if (commandData.selection) {
            commandLiveData.selectionRanges = [];
            for (const range of commandData.selection.getRanges()){
                commandLiveData.selectionRanges.push((0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f).fromRange(range));
                this._affectedElements.add(range.start.parent);
            }
        }
        this._queue.push(commandLiveData);
        this._isComposing ||= isComposing;
        this.flushDebounced();
    }
    /**
	* Shift the first item from the insertText command data queue.
	*/ shift() {
        const commandLiveData = this._queue.shift();
        const commandData = {
            text: commandLiveData.text
        };
        if (commandLiveData.selectionRanges) {
            const ranges = commandLiveData.selectionRanges.map((liveRange)=>$f1defb5a0a139b4c$var$detachLiveRange(liveRange)).filter((range)=>!!range);
            if (ranges.length) commandData.selection = this.editor.model.createSelection(ranges);
        }
        return commandData;
    }
    /**
	* Applies all queued insertText command executions.
	*
	* @param reason Used only for debugging.
	*/ flush(reason) {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        this.flushDebounced.cancel();
        if (!this._queue.length) return;
        const buffer = editor.commands.get("insertText").buffer;
        model.enqueueChange(buffer.batch, ()=>{
            buffer.lock();
            while(this._queue.length){
                const commandData = this.shift();
                editor.execute("insertText", commandData);
            }
            buffer.unlock();
            if (!this._isComposing) this._affectedElements.clear();
            this._isComposing = false;
        });
        view.scrollToTheSelection();
    }
    /**
	* Returns `true` if the given model element is related to recent typing.
	*/ isElementAffected(element) {
        return this._affectedElements.has(element);
    }
    /**
	* Returns `true` if there are any affected elements in the queue.
	*/ hasAffectedElements() {
        return this._affectedElements.size > 0;
    }
    /**
	* Returns an array of typing-related elements and clears the internal list.
	*/ flushAffectedElements() {
        const result = Array.from(this._affectedElements);
        this._affectedElements.clear();
        return result;
    }
};
/**
* Deletes the content selected by the document selection at the start of composition.
*/ function $f1defb5a0a139b4c$var$deleteSelectionContent(model, insertTextCommand) {
    if (!insertTextCommand.isEnabled) return;
    const buffer = insertTextCommand.buffer;
    buffer.lock();
    model.enqueueChange(buffer.batch, ()=>{
        model.deleteContent(model.document.selection);
    });
    buffer.unlock();
}
/**
* Detaches a ModelLiveRange and returns the static range from it.
*/ function $f1defb5a0a139b4c$var$detachLiveRange(liveRange) {
    const range = liveRange.toRange();
    liveRange.detach();
    if (range.root.rootName == "$graveyard") return null;
    return range;
}
/**
* For the given `viewNode`, finds and returns the closest ancestor of this node that has a mapping to the model.
*/ function $f1defb5a0a139b4c$var$findMappedViewAncestor(viewNode, mapper) {
    let node = viewNode.is("$text") ? viewNode.parent : viewNode;
    while(!mapper.toModelElement(node))node = node.parent;
    return node;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/deletecommand
*/ /**
* The delete command. Used by the {@link module:typing/delete~Delete delete feature} to handle the <kbd>Delete</kbd> and
* <kbd>Backspace</kbd> keys.
*/ var $f1defb5a0a139b4c$export$bcbb37853c82bc7a = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The directionality of the delete describing in what direction it should
	* consume the content when the selection is collapsed.
	*/ direction;
    /**
	* Delete's change buffer used to group subsequent changes into batches.
	*/ _buffer;
    /**
	* Creates an instance of the command.
	*
	* @param direction The directionality of the delete describing in what direction it
	* should consume the content when the selection is collapsed.
	*/ constructor(editor, direction){
        super(editor);
        this.direction = direction;
        this._buffer = new $f1defb5a0a139b4c$export$27e7da161ddce0c9(editor.model, editor.config.get("typing.undoStep"));
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* The current change buffer.
	*/ get buffer() {
        return this._buffer;
    }
    /**
	* Executes the delete command. Depending on whether the selection is collapsed or not, deletes its content
	* or a piece of content in the {@link #direction defined direction}.
	*
	* @fires execute
	* @param options The command options.
	* @param options.unit See {@link module:engine/model/utils/modifyselection~modifySelection}'s options.
	* @param options.sequence A number describing which subsequent delete event it is without the key being released.
	* See the {@link module:engine/view/document~ViewDocument#event:delete} event data.
	* @param options.selection Selection to remove. If not set, current model selection will be used.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const doc = model.document;
        model.enqueueChange(this._buffer.batch, (writer)=>{
            this._buffer.lock();
            const selection = writer.createSelection(options.selection || doc.selection);
            if (!model.canEditAt(selection)) return;
            const sequence = options.sequence || 1;
            const doNotResetEntireContent = selection.isCollapsed;
            if (selection.isCollapsed) model.modifySelection(selection, {
                direction: this.direction,
                unit: options.unit,
                treatEmojiAsSingleUnit: true
            });
            if (this._shouldEntireContentBeReplacedWithParagraph(sequence)) {
                this._replaceEntireContentWithParagraph(writer);
                return;
            }
            if (this._shouldReplaceFirstBlockWithParagraph(selection, sequence)) {
                this.editor.execute("paragraph", {
                    selection: selection
                });
                return;
            }
            if (selection.isCollapsed) return;
            let changeCount = 0;
            selection.getFirstRange().getMinimalFlatRanges().forEach((range)=>{
                changeCount += (0, $c7bc2cb7e2db0227$export$85b9a36db797e02b)(range.getWalker({
                    singleCharacters: true,
                    ignoreElementEnd: true,
                    shallow: true
                }));
            });
            model.deleteContent(selection, {
                doNotResetEntireContent: doNotResetEntireContent,
                direction: this.direction
            });
            this._buffer.input(changeCount);
            writer.setSelection(selection);
            this._buffer.unlock();
        });
    }
    /**
	* If the user keeps <kbd>Backspace</kbd> or <kbd>Delete</kbd> key pressed, the content of the current
	* editable will be cleared. However, this will not yet lead to resetting the remaining block to a paragraph
	* (which happens e.g. when the user does <kbd>Ctrl</kbd> + <kbd>A</kbd>, <kbd>Backspace</kbd>).
	*
	* But, if the user pressed the key in an empty editable for the first time,
	* we want to replace the entire content with a paragraph if:
	*
	* * the current limit element is empty,
	* * the paragraph is allowed in the limit element,
	* * the limit doesn't already have a paragraph inside.
	*
	* See https://github.com/ckeditor/ckeditor5-typing/issues/61.
	*
	* @param sequence A number describing which subsequent delete event it is without the key being released.
	*/ _shouldEntireContentBeReplacedWithParagraph(sequence) {
        if (sequence > 1) return false;
        const model = this.editor.model;
        const selection = model.document.selection;
        const limitElement = model.schema.getLimitElement(selection);
        if (!(selection.isCollapsed && selection.containsEntireContent(limitElement))) return false;
        if (!model.schema.checkChild(limitElement, "paragraph")) return false;
        const limitElementFirstChild = limitElement.getChild(0);
        if (limitElementFirstChild && limitElementFirstChild.is("element", "paragraph")) return false;
        return true;
    }
    /**
	* The entire content is replaced with the paragraph. Selection is moved inside the paragraph.
	*
	* @param writer The model writer.
	*/ _replaceEntireContentWithParagraph(writer) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const limitElement = model.schema.getLimitElement(selection);
        const paragraph = writer.createElement("paragraph");
        writer.remove(writer.createRangeIn(limitElement));
        writer.insert(paragraph, limitElement);
        writer.setSelection(paragraph, 0);
    }
    /**
	* Checks if the selection is inside an empty element that is the first child of the limit element
	* and should be replaced with a paragraph.
	*
	* @param selection The selection.
	* @param sequence A number describing which subsequent delete event it is without the key being released.
	*/ _shouldReplaceFirstBlockWithParagraph(selection, sequence) {
        const model = this.editor.model;
        if (sequence > 1 || this.direction != "backward") return false;
        if (!selection.isCollapsed) return false;
        const position = selection.getFirstPosition();
        const limitElement = model.schema.getLimitElement(position);
        const limitElementFirstChild = limitElement.getChild(0);
        if (position.parent != limitElementFirstChild) return false;
        if (!selection.containsEntireContent(limitElementFirstChild)) return false;
        if (!model.schema.checkChild(limitElement, "paragraph")) return false;
        if (limitElementFirstChild.name == "paragraph") return false;
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/deleteobserver
*/ const $f1defb5a0a139b4c$var$DELETE_CHARACTER = "character";
const $f1defb5a0a139b4c$var$DELETE_WORD = "word";
const $f1defb5a0a139b4c$var$DELETE_CODE_POINT = "codePoint";
const $f1defb5a0a139b4c$var$DELETE_SELECTION = "selection";
const $f1defb5a0a139b4c$var$DELETE_BACKWARD = "backward";
const $f1defb5a0a139b4c$var$DELETE_FORWARD = "forward";
const $f1defb5a0a139b4c$var$DELETE_EVENT_TYPES = {
    deleteContent: {
        unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
        direction: $f1defb5a0a139b4c$var$DELETE_BACKWARD
    },
    deleteContentBackward: {
        unit: $f1defb5a0a139b4c$var$DELETE_CODE_POINT,
        direction: $f1defb5a0a139b4c$var$DELETE_BACKWARD
    },
    deleteWordBackward: {
        unit: $f1defb5a0a139b4c$var$DELETE_WORD,
        direction: $f1defb5a0a139b4c$var$DELETE_BACKWARD
    },
    deleteHardLineBackward: {
        unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
        direction: $f1defb5a0a139b4c$var$DELETE_BACKWARD
    },
    deleteSoftLineBackward: {
        unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
        direction: $f1defb5a0a139b4c$var$DELETE_BACKWARD
    },
    deleteContentForward: {
        unit: $f1defb5a0a139b4c$var$DELETE_CHARACTER,
        direction: $f1defb5a0a139b4c$var$DELETE_FORWARD
    },
    deleteWordForward: {
        unit: $f1defb5a0a139b4c$var$DELETE_WORD,
        direction: $f1defb5a0a139b4c$var$DELETE_FORWARD
    },
    deleteHardLineForward: {
        unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
        direction: $f1defb5a0a139b4c$var$DELETE_FORWARD
    },
    deleteSoftLineForward: {
        unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
        direction: $f1defb5a0a139b4c$var$DELETE_FORWARD
    }
};
/**
* Delete observer introduces the {@link module:engine/view/document~ViewDocument#event:delete} event.
*
* @internal
*/ var $f1defb5a0a139b4c$export$fd38609b8b380620 = class extends (0, $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b) {
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        const document1 = view.document;
        let sequence = 0;
        document1.on("keydown", ()=>{
            sequence++;
        });
        document1.on("keyup", ()=>{
            sequence = 0;
        });
        document1.on("beforeinput", (evt, data)=>{
            if (!this.isEnabled) return;
            const { targetRanges: targetRanges, domEvent: domEvent, inputType: inputType } = data;
            const deleteEventSpec = $f1defb5a0a139b4c$var$DELETE_EVENT_TYPES[inputType];
            if (!deleteEventSpec) return;
            const deleteData = {
                direction: deleteEventSpec.direction,
                unit: deleteEventSpec.unit,
                sequence: sequence
            };
            if (deleteData.unit == $f1defb5a0a139b4c$var$DELETE_SELECTION) deleteData.selectionToRemove = view.createSelection(targetRanges[0]);
            if (inputType === "deleteContentBackward") {
                if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) deleteData.sequence = 1;
                if ($f1defb5a0a139b4c$var$shouldUseTargetRanges(targetRanges)) {
                    deleteData.unit = $f1defb5a0a139b4c$var$DELETE_SELECTION;
                    deleteData.selectionToRemove = view.createSelection(targetRanges);
                }
            }
            const eventInfo = new (0, $b9b9f2bdf9c6137f$export$56609df77c04b70e)(document1, "delete", targetRanges[0]);
            document1.fire(eventInfo, new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, domEvent, deleteData));
            if (eventInfo.stop.called) evt.stop();
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink) $f1defb5a0a139b4c$var$enableChromeWorkaround(this);
    }
    /**
	* @inheritDoc
	*/ observe() {}
    /**
	* @inheritDoc
	*/ stopObserving() {}
};
/**
* Enables workaround for the issue https://github.com/ckeditor/ckeditor5/issues/11904.
*/ function $f1defb5a0a139b4c$var$enableChromeWorkaround(observer) {
    const view = observer.view;
    const document1 = view.document;
    let pressedKeyCode = null;
    let beforeInputReceived = false;
    document1.on("keydown", (evt, { keyCode: keyCode })=>{
        pressedKeyCode = keyCode;
        beforeInputReceived = false;
    });
    document1.on("keyup", (evt, { keyCode: keyCode, domEvent: domEvent })=>{
        const selection = document1.selection;
        const shouldFireDeleteEvent = observer.isEnabled && keyCode == pressedKeyCode && isDeleteKeyCode(keyCode) && !selection.isCollapsed && !beforeInputReceived;
        pressedKeyCode = null;
        if (shouldFireDeleteEvent) {
            const targetRange = selection.getFirstRange();
            const eventInfo = new (0, $b9b9f2bdf9c6137f$export$56609df77c04b70e)(document1, "delete", targetRange);
            const deleteData = {
                unit: $f1defb5a0a139b4c$var$DELETE_SELECTION,
                direction: getDeleteDirection(keyCode),
                selectionToRemove: selection
            };
            document1.fire(eventInfo, new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, domEvent, deleteData));
        }
    });
    document1.on("beforeinput", (evt, { inputType: inputType })=>{
        const deleteEventSpec = $f1defb5a0a139b4c$var$DELETE_EVENT_TYPES[inputType];
        if (isDeleteKeyCode(pressedKeyCode) && deleteEventSpec && deleteEventSpec.direction == getDeleteDirection(pressedKeyCode)) beforeInputReceived = true;
    }, {
        priority: "high"
    });
    document1.on("beforeinput", (evt, { inputType: inputType, data: data })=>{
        if (pressedKeyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).delete && inputType == "insertText" && data == "") evt.stop();
    }, {
        priority: "high"
    });
    function isDeleteKeyCode(keyCode) {
        return keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).backspace || keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).delete;
    }
    function getDeleteDirection(keyCode) {
        return keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).backspace ? $f1defb5a0a139b4c$var$DELETE_BACKWARD : $f1defb5a0a139b4c$var$DELETE_FORWARD;
    }
}
/**
* Verifies whether the given target ranges cover more than a single character and should be used instead of a single code-point deletion.
*/ function $f1defb5a0a139b4c$var$shouldUseTargetRanges(targetRanges) {
    if (targetRanges.length != 1 || targetRanges[0].isCollapsed) return false;
    const walker = targetRanges[0].getWalker({
        direction: "backward",
        singleCharacters: true,
        ignoreElementEnd: true
    });
    let count = 0;
    for (const { nextPosition: nextPosition, item: item } of walker){
        if (nextPosition.parent.is("$text")) {
            const data = nextPosition.parent.data;
            const offset = nextPosition.offset;
            if ((0, $c7bc2cb7e2db0227$export$910da4ddfe197244)(data, offset) || (0, $c7bc2cb7e2db0227$export$1a90459935e74227)(data, offset) || (0, $c7bc2cb7e2db0227$export$615ed2a6f3bf1115)(data, offset)) continue;
            count++;
        } else if (item.is("containerElement") || item.is("emptyElement")) count++;
        if (count > 1) return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/delete
*/ /**
* The delete and backspace feature. Handles keys such as <kbd>Delete</kbd> and <kbd>Backspace</kbd>, other
* keystrokes and user actions that result in deleting content in the editor.
*/ var $f1defb5a0a139b4c$export$bfadae053a633538 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Whether pressing backspace should trigger undo action
	*/ _undoOnBackspace;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Delete";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const modelDocument = editor.model.document;
        view.addObserver($f1defb5a0a139b4c$export$fd38609b8b380620);
        this._undoOnBackspace = false;
        const deleteForwardCommand = new $f1defb5a0a139b4c$export$bcbb37853c82bc7a(editor, "forward");
        editor.commands.add("deleteForward", deleteForwardCommand);
        editor.commands.add("forwardDelete", deleteForwardCommand);
        editor.commands.add("delete", new $f1defb5a0a139b4c$export$bcbb37853c82bc7a(editor, "backward"));
        this.listenTo(viewDocument, "delete", (evt, data)=>{
            if (!viewDocument.isComposing) data.preventDefault();
            const { direction: direction, sequence: sequence, selectionToRemove: selectionToRemove, unit: unit } = data;
            const commandName = direction === "forward" ? "deleteForward" : "delete";
            const commandData = {
                sequence: sequence
            };
            if (unit == "selection") {
                const modelRanges = Array.from(selectionToRemove.getRanges()).map((viewRange)=>editor.editing.mapper.toModelRange(viewRange)).map((modelRange)=>(0, $b9b9f2bdf9c6137f$export$40475a88db3fce3)(modelRange, editor.model.schema) || modelRange);
                commandData.selection = editor.model.createSelection(modelRanges);
            } else commandData.unit = unit;
            editor.execute(commandName, commandData);
            view.scrollToTheSelection();
        }, {
            priority: "low"
        });
        this.listenTo(viewDocument, "keydown", (evt, data)=>{
            if (viewDocument.isComposing || data.keyCode != (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).backspace || !modelDocument.selection.isCollapsed) return;
            const ancestorLimit = editor.model.schema.getLimitElement(modelDocument.selection);
            const limitStartPosition = editor.model.createPositionAt(ancestorLimit, 0);
            if (limitStartPosition.isTouching(modelDocument.selection.getFirstPosition())) {
                data.preventDefault();
                const modelRange = editor.model.schema.getNearestSelectionRange(limitStartPosition, "forward");
                if (!modelRange) return;
                const viewSelection = view.createSelection(editor.editing.mapper.toViewRange(modelRange));
                const targetRange = viewSelection.getFirstRange();
                const eventInfo = new (0, $b9b9f2bdf9c6137f$export$56609df77c04b70e)(document, "delete", targetRange);
                const deleteData = {
                    unit: "selection",
                    direction: "backward",
                    selectionToRemove: viewSelection
                };
                viewDocument.fire(eventInfo, new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, data.domEvent, deleteData));
            }
        });
        if (this.editor.plugins.has("UndoEditing")) {
            this.listenTo(viewDocument, "delete", (evt, data)=>{
                if (this._undoOnBackspace && data.direction == "backward" && data.sequence == 1 && data.unit == "codePoint") {
                    this._undoOnBackspace = false;
                    editor.execute("undo");
                    data.preventDefault();
                    evt.stop();
                }
            }, {
                context: "$capture"
            });
            this.listenTo(modelDocument, "change", ()=>{
                this._undoOnBackspace = false;
            });
        }
    }
    /**
	* If the next user action after calling this method is pressing backspace, it would undo the last change.
	*
	* Requires {@link module:undo/undoediting~UndoEditing} plugin. If not loaded, does nothing.
	*/ requestUndoOnBackspace() {
        if (this.editor.plugins.has("UndoEditing")) this._undoOnBackspace = true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/typing
*/ /**
* The typing feature. It handles typing.
*
* This is a "glue" plugin which loads the {@link module:typing/input~Input} and {@link module:typing/delete~Delete}
* plugins.
*/ var $f1defb5a0a139b4c$export$3997e86453ee41f3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    static get requires() {
        return [
            $f1defb5a0a139b4c$export$f5b8910cec6cf069,
            $f1defb5a0a139b4c$export$bfadae053a633538
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Typing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns the last text line from the given range.
*
* "The last text line" is understood as text (from one or more text nodes) which is limited either by a parent block
* or by inline elements (e.g. `<softBreak>`).
*
* ```ts
* const rangeToCheck = model.createRange(
* 	model.createPositionAt( paragraph, 0 ),
* 	model.createPositionAt( paragraph, 'end' )
* );
*
* const { text, range } = getLastTextLine( rangeToCheck, model );
* ```
*
* For model below, the returned `text` will be "Foo bar baz" and `range` will be set on whole `<paragraph>` content:
*
* ```xml
* <paragraph>Foo bar baz<paragraph>
* ```
*
* However, in below case, `text` will be set to "baz" and `range` will be set only on "baz".
*
* ```xml
* <paragraph>Foo<softBreak></softBreak>bar<softBreak></softBreak>baz<paragraph>
* ```
*/ function $f1defb5a0a139b4c$export$fbaa9c739dad3a12(range, model) {
    let start = range.start;
    return {
        text: Array.from(range.getWalker({
            ignoreElementEnd: false
        })).reduce((rangeText, { item: item })=>{
            if (!(item.is("$text") || item.is("$textProxy"))) {
                start = model.createPositionAfter(item);
                return "";
            }
            return rangeText + item.data;
        }, ""),
        range: model.createRange(start, range.end)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/textwatcher
*/ const $f1defb5a0a139b4c$var$TextWatcherBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The text watcher feature.
*
* Fires the {@link module:typing/textwatcher~TextWatcher#event:matched:data `matched:data`},
* {@link module:typing/textwatcher~TextWatcher#event:matched:selection `matched:selection`} and
* {@link module:typing/textwatcher~TextWatcher#event:unmatched `unmatched`} events on typing or selection changes.
*/ var $f1defb5a0a139b4c$export$72f65615ddd53ad4 = class extends $f1defb5a0a139b4c$var$TextWatcherBase {
    /**
	* The editor's model.
	*/ model;
    /**
	* The function used to match the text.
	*
	* The test callback can return 3 values:
	*
	* * `false` if there is no match,
	* * `true` if there is a match,
	* * an object if there is a match and we want to pass some additional information to the {@link #event:matched:data} event.
	*/ testCallback;
    /**
	* Whether there is a match currently.
	*/ _hasMatch;
    /**
	* Creates a text watcher instance.
	*
	* @param testCallback See {@link module:typing/textwatcher~TextWatcher#testCallback}.
	*/ constructor(model, testCallback){
        super();
        this.model = model;
        this.testCallback = testCallback;
        this._hasMatch = false;
        this.set("isEnabled", true);
        this.on("change:isEnabled", ()=>{
            if (this.isEnabled) this._startListening();
            else {
                this.stopListening(model.document.selection);
                this.stopListening(model.document);
            }
        });
        this._startListening();
    }
    /**
	* Flag indicating whether there is a match currently.
	*/ get hasMatch() {
        return this._hasMatch;
    }
    /**
	* Starts listening to the editor for typing and selection events.
	*/ _startListening() {
        const document1 = this.model.document;
        this.listenTo(document1.selection, "change:range", (evt, { directChange: directChange })=>{
            if (!directChange) return;
            if (!document1.selection.isCollapsed) {
                if (this.hasMatch) {
                    this.fire("unmatched");
                    this._hasMatch = false;
                }
                return;
            }
            this._evaluateTextBeforeSelection("selection");
        });
        this.listenTo(document1, "change:data", (evt, batch)=>{
            if (batch.isUndo || !batch.isLocal) return;
            this._evaluateTextBeforeSelection("data", {
                batch: batch
            });
        });
    }
    /**
	* Checks the editor content for matched text.
	*
	* @fires matched:data
	* @fires matched:selection
	* @fires unmatched
	*
	* @param suffix A suffix used for generating the event name.
	* @param data Data object for event.
	*/ _evaluateTextBeforeSelection(suffix, data = {}) {
        const model = this.model;
        const selection = model.document.selection;
        const rangeBeforeSelection = model.createRange(model.createPositionAt(selection.focus.parent, 0), selection.focus);
        const { text: text, range: range } = $f1defb5a0a139b4c$export$fbaa9c739dad3a12(rangeBeforeSelection, model);
        const testResult = this.testCallback(text);
        if (!testResult && this.hasMatch) this.fire("unmatched");
        this._hasMatch = !!testResult;
        if (testResult) {
            const eventData = Object.assign(data, {
                text: text,
                range: range
            });
            if (typeof testResult == "object") Object.assign(eventData, testResult);
            this.fire(`matched:${suffix}`, eventData);
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/twostepcaretmovement
*/ /**
* This plugin enables the two-step caret (phantom) movement behavior for
* {@link module:typing/twostepcaretmovement~TwoStepCaretMovement#registerAttribute registered attributes}
* on arrow right (<kbd>→</kbd>) and left (<kbd>←</kbd>) key press.
*
* Thanks to this (phantom) caret movement the user is able to type before/after as well as at the
* beginning/end of an attribute.
*
* **Note:** This plugin support right–to–left (Arabic, Hebrew, etc.) content by mirroring its behavior
* but for the sake of simplicity examples showcase only left–to–right use–cases.
*
* # Forward movement
*
* ## "Entering" an attribute:
*
* When this plugin is enabled and registered for the `a` attribute and the selection is right before it
* (at the attribute boundary), pressing the right arrow key will not move the selection but update its
* attributes accordingly:
*
* * When enabled:
*
* ```xml
* foo{}<$text a="true">bar</$text>
* ```
*
* 	<kbd>→</kbd>
*
* ```xml
* foo<$text a="true">{}bar</$text>
* ```
*
* * When disabled:
*
* ```xml
* foo{}<$text a="true">bar</$text>
* ```
*
* 	<kbd>→</kbd>
*
* ```xml
* foo<$text a="true">b{}ar</$text>
* ```
*
*
* ## "Leaving" an attribute:
*
* * When enabled:
*
* ```xml
* <$text a="true">bar{}</$text>baz
* ```
*
* 	<kbd>→</kbd>
*
* ```xml
* <$text a="true">bar</$text>{}baz
* ```
*
* * When disabled:
*
* ```xml
* <$text a="true">bar{}</$text>baz
* ```
*
* 	<kbd>→</kbd>
*
* ```xml
* <$text a="true">bar</$text>b{}az
* ```
*
* # Backward movement
*
* * When enabled:
*
* ```xml
* <$text a="true">bar</$text>{}baz
* ```
*
* 	<kbd>←</kbd>
*
* ```xml
* <$text a="true">bar{}</$text>baz
* ```
*
* * When disabled:
*
* ```xml
* <$text a="true">bar</$text>{}baz
* ```
*
* 	<kbd>←</kbd>
*
* ```xml
* <$text a="true">ba{}r</$text>b{}az
* ```
*
* # Multiple attributes
*
* * When enabled and many attributes starts or ends at the same position:
*
* ```xml
* <$text a="true" b="true">bar</$text>{}baz
* ```
*
* 	<kbd>←</kbd>
*
* ```xml
* <$text a="true" b="true">bar{}</$text>baz
* ```
*
* * When enabled and one procedes another:
*
* ```xml
* <$text a="true">bar</$text><$text b="true">{}bar</$text>
* ```
*
* 	<kbd>←</kbd>
*
* ```xml
* <$text a="true">bar{}</$text><$text b="true">bar</$text>
* ```
*
*/ var $f1defb5a0a139b4c$export$b521f49d1c4c3786 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A set of attributes to handle.
	*/ attributes;
    /**
	* The current UID of the overridden gravity, as returned by
	* {@link module:engine/model/writer~ModelWriter#overrideSelectionGravity}.
	*/ _overrideUid;
    /**
	* A flag indicating that the automatic gravity restoration should not happen upon the next
	* gravity restoration.
	* {@link module:engine/model/selection~ModelSelection#event:change:range} event.
	*/ _isNextGravityRestorationSkipped = false;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TwoStepCaretMovement";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.attributes = /* @__PURE__ */ new Set();
        this._overrideUid = null;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        const locale = editor.locale;
        const modelSelection = model.document.selection;
        this.listenTo(view.document, "arrowKey", (evt, data)=>{
            if (!modelSelection.isCollapsed) return;
            if (data.shiftKey || data.altKey || data.ctrlKey) return;
            const arrowRightPressed = data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowright;
            const arrowLeftPressed = data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowleft;
            if (!arrowRightPressed && !arrowLeftPressed) return;
            const contentDirection = locale.contentLanguageDirection;
            let isMovementHandled;
            if (contentDirection === "ltr" && arrowRightPressed || contentDirection === "rtl" && arrowLeftPressed) isMovementHandled = this._handleForwardMovement(data);
            else isMovementHandled = this._handleBackwardMovement(data);
            if (isMovementHandled === true) evt.stop();
        }, {
            context: "$text",
            priority: "highest"
        });
        this.listenTo(modelSelection, "change:range", (evt, data)=>{
            if (this._isNextGravityRestorationSkipped) {
                this._isNextGravityRestorationSkipped = false;
                return;
            }
            if (!this._isGravityOverridden) return;
            if (!data.directChange && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(modelSelection.getFirstPosition(), this.attributes)) return;
            this._restoreGravity();
        });
        this._enableClickingAfterNode();
        this._enableInsertContentSelectionAttributesFixer();
        this._handleDeleteContentAfterNode();
    }
    /**
	* Registers a given attribute for the two-step caret movement.
	*
	* @param attribute Name of the attribute to handle.
	*/ registerAttribute(attribute) {
        this.attributes.add(attribute);
    }
    /**
	* Updates the document selection and the view according to the two–step caret movement state
	* when moving **forwards**. Executed upon `keypress` in the {@link module:engine/view/view~EditingView}.
	*
	* @internal
	* @param eventData Data of the key press.
	* @returns `true` when the handler prevented caret movement.
	*/ _handleForwardMovement(eventData) {
        const attributes = this.attributes;
        const model = this.editor.model;
        const selection = model.document.selection;
        const position = selection.getFirstPosition();
        if (this._isGravityOverridden) return false;
        if (position.isAtStart && $f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes)) return false;
        if ($f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes)) {
            if (eventData) $f1defb5a0a139b4c$var$preventCaretMovement(eventData);
            if ($f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes) && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes, true)) $f1defb5a0a139b4c$var$clearSelectionAttributes(model, attributes);
            else this._overrideGravity();
            return true;
        }
        return false;
    }
    /**
	* Updates the document selection and the view according to the two–step caret movement state
	* when moving **backwards**. Executed upon `keypress` in the {@link module:engine/view/view~EditingView}.
	*
	* @internal
	* @param eventData Data of the key press.
	* @returns `true` when the handler prevented caret movement
	*/ _handleBackwardMovement(eventData) {
        const attributes = this.attributes;
        const model = this.editor.model;
        const selection = model.document.selection;
        const position = selection.getFirstPosition();
        if (this._isGravityOverridden) {
            if (eventData) $f1defb5a0a139b4c$var$preventCaretMovement(eventData);
            this._restoreGravity();
            if ($f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes, true)) $f1defb5a0a139b4c$var$clearSelectionAttributes(model, attributes);
            else $f1defb5a0a139b4c$var$setSelectionAttributesFromTheNodeBefore(model, attributes, position);
            return true;
        } else {
            if (position.isAtStart) {
                if ($f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes)) {
                    if (eventData) $f1defb5a0a139b4c$var$preventCaretMovement(eventData);
                    $f1defb5a0a139b4c$var$setSelectionAttributesFromTheNodeBefore(model, attributes, position);
                    return true;
                }
                return false;
            }
            if (!$f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes) && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes, true)) {
                if (eventData) $f1defb5a0a139b4c$var$preventCaretMovement(eventData);
                $f1defb5a0a139b4c$var$setSelectionAttributesFromTheNodeBefore(model, attributes, position);
                return true;
            }
            if ($f1defb5a0a139b4c$var$isStepAfterAnyAttributeBoundary(position, attributes)) {
                if (position.isAtEnd && !$f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes) && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes)) {
                    if (eventData) $f1defb5a0a139b4c$var$preventCaretMovement(eventData);
                    $f1defb5a0a139b4c$var$setSelectionAttributesFromTheNodeBefore(model, attributes, position);
                    return true;
                }
                this._isNextGravityRestorationSkipped = true;
                this._overrideGravity();
                return false;
            }
        }
        return false;
    }
    /**
	* Starts listening to {@link module:engine/view/document~ViewDocument#event:mousedown} and
	* {@link module:engine/view/document~ViewDocument#event:selectionChange} and puts the selection before/after a 2-step node
	* if clicked at the beginning/ending of the 2-step node.
	*
	* The purpose of this action is to allow typing around the 2-step node directly after a click.
	*
	* See https://github.com/ckeditor/ckeditor5/issues/1016.
	*/ _enableClickingAfterNode() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const document1 = editor.editing.view.document;
        editor.editing.view.addObserver((0, $b9b9f2bdf9c6137f$export$7bb344c59ad5b029));
        editor.editing.view.addObserver((0, $b9b9f2bdf9c6137f$export$dc50353e92fd1e05));
        let touched = false;
        let clicked = false;
        this.listenTo(document1, "touchstart", ()=>{
            clicked = false;
            touched = true;
        });
        this.listenTo(document1, "mousedown", ()=>{
            clicked = true;
        });
        this.listenTo(document1, "selectionChange", ()=>{
            const attributes = this.attributes;
            if (!clicked && !touched) return;
            clicked = false;
            touched = false;
            if (!selection.isCollapsed) return;
            if (!$f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes)) return;
            const position = selection.getFirstPosition();
            if (!$f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes)) return;
            if (position.isAtStart || $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes, true)) $f1defb5a0a139b4c$var$clearSelectionAttributes(model, attributes);
            else if (!this._isGravityOverridden) this._overrideGravity();
        });
    }
    /**
	* Starts listening to {@link module:engine/model/model~Model#event:insertContent} and corrects the model
	* selection attributes if the selection is at the end of a two-step node after inserting the content.
	*
	* The purpose of this action is to improve the overall UX because the user is no longer "trapped" by the
	* two-step attribute of the selection, and they can type a "clean" (`linkHref`–less) text right away.
	*
	* See https://github.com/ckeditor/ckeditor5/issues/6053.
	*/ _enableInsertContentSelectionAttributesFixer() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const attributes = this.attributes;
        this.listenTo(model, "insertContent", ()=>{
            const position = selection.getFirstPosition();
            if ($f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes) && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes)) $f1defb5a0a139b4c$var$clearSelectionAttributes(model, attributes);
        }, {
            priority: "low"
        });
    }
    /**
	* Starts listening to {@link module:engine/model/model~Model#deleteContent} and checks whether
	* removing a content right after the tow-step attribute.
	*
	* If so, the selection should not preserve the two-step attribute. However, if
	* the {@link module:typing/twostepcaretmovement~TwoStepCaretMovement} plugin is active and
	* the selection has the two-step attribute due to overridden gravity (at the end), the two-step attribute should stay untouched.
	*
	* The purpose of this action is to allow removing the link text and keep the selection outside the link.
	*
	* See https://github.com/ckeditor/ckeditor5/issues/7521.
	*/ _handleDeleteContentAfterNode() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const view = editor.editing.view;
        let isBackspace = false;
        let shouldPreserveAttributes = false;
        this.listenTo(view.document, "delete", (evt, data)=>{
            isBackspace = data.direction === "backward";
        }, {
            priority: "high"
        });
        this.listenTo(model, "deleteContent", ()=>{
            if (!isBackspace) return;
            const position = selection.getFirstPosition();
            shouldPreserveAttributes = $f1defb5a0a139b4c$var$hasAnyAttribute(selection, this.attributes) && !$f1defb5a0a139b4c$var$isStepAfterAnyAttributeBoundary(position, this.attributes);
        }, {
            priority: "high"
        });
        this.listenTo(model, "deleteContent", ()=>{
            if (!isBackspace) return;
            isBackspace = false;
            if (shouldPreserveAttributes) return;
            editor.model.enqueueChange(()=>{
                const position = selection.getFirstPosition();
                if ($f1defb5a0a139b4c$var$hasAnyAttribute(selection, this.attributes) && $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, this.attributes)) {
                    if (position.isAtStart || $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, this.attributes, true)) $f1defb5a0a139b4c$var$clearSelectionAttributes(model, this.attributes);
                    else if (!this._isGravityOverridden) this._overrideGravity();
                }
            });
        }, {
            priority: "low"
        });
    }
    /**
	* `true` when the gravity is overridden for the plugin.
	*/ get _isGravityOverridden() {
        return !!this._overrideUid;
    }
    /**
	* Overrides the gravity using the {@link module:engine/model/writer~ModelWriter model writer}
	* and stores the information about this fact in the {@link #_overrideUid}.
	*
	* A shorthand for {@link module:engine/model/writer~ModelWriter#overrideSelectionGravity}.
	*/ _overrideGravity() {
        this._overrideUid = this.editor.model.change((writer)=>{
            return writer.overrideSelectionGravity();
        });
    }
    /**
	* Restores the gravity using the {@link module:engine/model/writer~ModelWriter model writer}.
	*
	* A shorthand for {@link module:engine/model/writer~ModelWriter#restoreSelectionGravity}.
	*/ _restoreGravity() {
        this.editor.model.change((writer)=>{
            writer.restoreSelectionGravity(this._overrideUid);
            this._overrideUid = null;
        });
    }
};
/**
* Checks whether the selection has any of given attributes.
*/ function $f1defb5a0a139b4c$var$hasAnyAttribute(selection, attributes) {
    for (const observedAttribute of attributes)if (selection.hasAttribute(observedAttribute)) return true;
    return false;
}
/**
* Applies the given attributes to the current selection using using the
* values from the node before the current position. Uses
* the {@link module:engine/model/writer~ModelWriter model writer}.
*/ function $f1defb5a0a139b4c$var$setSelectionAttributesFromTheNodeBefore(model, attributes, position) {
    const nodeBefore = position.nodeBefore;
    model.change((writer)=>{
        if (nodeBefore) {
            const attributes = [];
            const isInlineObject = model.schema.isObject(nodeBefore) && model.schema.isInline(nodeBefore);
            for (const [key, value] of nodeBefore.getAttributes())if (model.schema.checkAttribute("$text", key) && (!isInlineObject || model.schema.getAttributeProperties(key).copyFromObject !== false)) attributes.push([
                key,
                value
            ]);
            writer.setSelectionAttribute(attributes);
        } else writer.removeSelectionAttribute(attributes);
    });
}
/**
* Removes 2-SCM attributes from the selection.
*/ function $f1defb5a0a139b4c$var$clearSelectionAttributes(model, attributes) {
    model.change((writer)=>{
        writer.removeSelectionAttribute(attributes);
    });
}
/**
* Prevents the caret movement in the view by calling `preventDefault` on the event data.
*
* @alias data.preventDefault
*/ function $f1defb5a0a139b4c$var$preventCaretMovement(data) {
    data.preventDefault();
}
/**
* Checks whether the step before `isBetweenDifferentAttributes()`.
*/ function $f1defb5a0a139b4c$var$isStepAfterAnyAttributeBoundary(position, attributes) {
    return $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position.getShiftedBy(-1), attributes);
}
/**
* Checks whether the given position is between different values of given attributes.
*/ function $f1defb5a0a139b4c$var$isBetweenDifferentAttributes(position, attributes, isStrict = false) {
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = position;
    for (const observedAttribute of attributes){
        const attrBefore = nodeBefore ? nodeBefore.getAttribute(observedAttribute) : void 0;
        const attrAfter = nodeAfter ? nodeAfter.getAttribute(observedAttribute) : void 0;
        if (isStrict && (attrBefore === void 0 || attrAfter === void 0)) continue;
        if (attrAfter !== attrBefore) return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/texttransformation
*/ const $f1defb5a0a139b4c$var$TRANSFORMATIONS = {
    copyright: {
        from: "(c)",
        to: "\xa9"
    },
    registeredTrademark: {
        from: "(r)",
        to: "\xae"
    },
    trademark: {
        from: "(tm)",
        to: "\u2122"
    },
    oneHalf: {
        from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
        to: [
            null,
            "\xbd",
            null
        ]
    },
    oneThird: {
        from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
        to: [
            null,
            "\u2153",
            null
        ]
    },
    twoThirds: {
        from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
        to: [
            null,
            "\u2154",
            null
        ]
    },
    oneForth: {
        from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
        to: [
            null,
            "\xbc",
            null
        ]
    },
    threeQuarters: {
        from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
        to: [
            null,
            "\xbe",
            null
        ]
    },
    lessThanOrEqual: {
        from: "<=",
        to: "\u2264"
    },
    greaterThanOrEqual: {
        from: ">=",
        to: "\u2265"
    },
    notEqual: {
        from: "!=",
        to: "\u2260"
    },
    arrowLeft: {
        from: "<-",
        to: "\u2190"
    },
    arrowRight: {
        from: "->",
        to: "\u2192"
    },
    horizontalEllipsis: {
        from: "...",
        to: "\u2026"
    },
    enDash: {
        from: /(^| )(--)( )$/,
        to: [
            null,
            "\u2013",
            null
        ]
    },
    emDash: {
        from: /(^| )(---)( )$/,
        to: [
            null,
            "\u2014",
            null
        ]
    },
    quotesPrimary: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("\""),
        to: [
            null,
            "\u201C",
            null,
            "\u201D"
        ]
    },
    quotesSecondary: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("'"),
        to: [
            null,
            "\u2018",
            null,
            "\u2019"
        ]
    },
    quotesPrimaryEnGb: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("'"),
        to: [
            null,
            "\u2018",
            null,
            "\u2019"
        ]
    },
    quotesSecondaryEnGb: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("\""),
        to: [
            null,
            "\u201C",
            null,
            "\u201D"
        ]
    },
    quotesPrimaryPl: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("\""),
        to: [
            null,
            "\u201E",
            null,
            "\u201D"
        ]
    },
    quotesSecondaryPl: {
        from: $f1defb5a0a139b4c$var$buildQuotesRegExp("'"),
        to: [
            null,
            "\u201A",
            null,
            "\u2019"
        ]
    }
};
const $f1defb5a0a139b4c$var$TRANSFORMATION_GROUPS = {
    symbols: [
        "copyright",
        "registeredTrademark",
        "trademark"
    ],
    mathematical: [
        "oneHalf",
        "oneThird",
        "twoThirds",
        "oneForth",
        "threeQuarters",
        "lessThanOrEqual",
        "greaterThanOrEqual",
        "notEqual",
        "arrowLeft",
        "arrowRight"
    ],
    typography: [
        "horizontalEllipsis",
        "enDash",
        "emDash"
    ],
    quotes: [
        "quotesPrimary",
        "quotesSecondary"
    ]
};
const $f1defb5a0a139b4c$var$DEFAULT_TRANSFORMATIONS = [
    "symbols",
    "mathematical",
    "typography",
    "quotes"
];
/**
* The text transformation plugin.
*/ var $f1defb5a0a139b4c$export$1ce548c794124571 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1defb5a0a139b4c$export$bfadae053a633538,
            $f1defb5a0a139b4c$export$f5b8910cec6cf069
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TextTransformation";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("typing", {
            transformations: {
                include: $f1defb5a0a139b4c$var$DEFAULT_TRANSFORMATIONS
            }
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const modelSelection = this.editor.model.document.selection;
        modelSelection.on("change:range", ()=>{
            const anchor = modelSelection.anchor;
            const isInCodeBlock = !!anchor && anchor.parent.is("element", "codeBlock");
            const isInInlineCode = modelSelection.hasAttribute("code");
            this.isEnabled = !(isInCodeBlock || isInInlineCode);
        });
        this._enableTransformationWatchers();
    }
    /**
	* Create new TextWatcher listening to the editor for typing and selection events.
	*/ _enableTransformationWatchers() {
        const editor = this.editor;
        const model = editor.model;
        const deletePlugin = editor.plugins.get("Delete");
        const normalizedTransformations = $f1defb5a0a139b4c$var$normalizeTransformations(editor.config.get("typing.transformations"));
        const testCallback = (text)=>{
            for (const normalizedTransformation of normalizedTransformations)if (normalizedTransformation.from.test(text)) return {
                normalizedTransformation: normalizedTransformation
            };
        };
        const watcher = new $f1defb5a0a139b4c$export$72f65615ddd53ad4(editor.model, testCallback);
        watcher.on("matched:data", (evt, data)=>{
            if (!data.batch.isTyping) return;
            const { from: from, to: to } = data.normalizedTransformation;
            const matches = from.exec(data.text);
            const replaces = to(matches.slice(1));
            const matchedRange = data.range;
            let changeIndex = matches.index;
            model.enqueueChange((writer)=>{
                for(let i = 1; i < matches.length; i++){
                    const match = matches[i];
                    const replaceWith = replaces[i - 1];
                    if (replaceWith == null) {
                        changeIndex += match.length;
                        continue;
                    }
                    const replacePosition = matchedRange.start.getShiftedBy(changeIndex);
                    const replaceRange = model.createRange(replacePosition, replacePosition.getShiftedBy(match.length));
                    const attributes = $f1defb5a0a139b4c$var$getTextAttributesAfterPosition(replacePosition);
                    model.insertContent(writer.createText(replaceWith, attributes), replaceRange);
                    changeIndex += replaceWith.length;
                }
                model.enqueueChange(()=>{
                    deletePlugin.requestUndoOnBackspace();
                });
            });
        });
        watcher.bind("isEnabled").to(this);
    }
};
/**
* Normalizes the configuration `from` parameter value.
* The normalized value for the `from` parameter is a RegExp instance. If the passed `from` is already a RegExp instance,
* it is returned unchanged.
*/ function $f1defb5a0a139b4c$var$normalizeFrom(from) {
    if (typeof from == "string") return new RegExp(`(${(0, $16b28203d45236dc$export$7c57da42ce8e346f)(from)})$`);
    return from;
}
/**
* Normalizes the configuration `to` parameter value.
* The normalized value for the `to` parameter is a function that takes an array and returns an array. See more in the
* configuration description. If the passed `to` is already a function, it is returned unchanged.
*/ function $f1defb5a0a139b4c$var$normalizeTo(to) {
    if (typeof to == "string") return ()=>[
            to
        ];
    else if (to instanceof Array) return ()=>to;
    return to;
}
/**
* For given `position` returns attributes for the text that is after that position.
* The text can be in the same text node as the position (`foo[]bar`) or in the next text node (`foo[]<$text bold="true">bar</$text>`).
*/ function $f1defb5a0a139b4c$var$getTextAttributesAfterPosition(position) {
    return (position.textNode ? position.textNode : position.nodeAfter).getAttributes();
}
/**
* Returns a RegExp pattern string that detects a sentence inside a quote.
*
* @param quoteCharacter The character to create a pattern for.
*/ function $f1defb5a0a139b4c$var$buildQuotesRegExp(quoteCharacter) {
    return new RegExp(`(^|\\s)(${quoteCharacter})([^${quoteCharacter}]*)(${quoteCharacter})$`);
}
/**
* Reads text transformation config and returns normalized array of transformations objects.
*/ function $f1defb5a0a139b4c$var$normalizeTransformations(config) {
    const extra = config.extra || [];
    const remove = config.remove || [];
    const isNotRemoved = (transformation)=>!remove.includes(transformation);
    return $f1defb5a0a139b4c$var$expandGroupsAndRemoveDuplicates(config.include.concat(extra).filter(isNotRemoved)).filter(isNotRemoved).map((transformation)=>typeof transformation == "string" && $f1defb5a0a139b4c$var$TRANSFORMATIONS[transformation] ? $f1defb5a0a139b4c$var$TRANSFORMATIONS[transformation] : transformation).filter((transformation)=>typeof transformation === "object").map((transformation)=>({
            from: $f1defb5a0a139b4c$var$normalizeFrom(transformation.from),
            to: $f1defb5a0a139b4c$var$normalizeTo(transformation.to)
        }));
}
/**
* Reads definitions and expands named groups if needed to transformation names.
* This method also removes duplicated named transformations if any.
*/ function $f1defb5a0a139b4c$var$expandGroupsAndRemoveDuplicates(definitions) {
    const definedTransformations = /* @__PURE__ */ new Set();
    for (const transformationOrGroup of definitions)if (typeof transformationOrGroup == "string" && $f1defb5a0a139b4c$var$TRANSFORMATION_GROUPS[transformationOrGroup]) for (const transformation of $f1defb5a0a139b4c$var$TRANSFORMATION_GROUPS[transformationOrGroup])definedTransformations.add(transformation);
    else definedTransformations.add(transformationOrGroup);
    return Array.from(definedTransformations);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a model range that covers all consecutive nodes with the same `attributeName` and its `value`
* that intersect the given `position`.
*
* It can be used e.g. to get the entire range on which the `linkHref` attribute needs to be changed when having a
* selection inside a link.
*
* @param position The start position.
* @param attributeName The attribute name.
* @param value The attribute value.
* @param model The model instance.
* @returns The link range.
*/ function $f1defb5a0a139b4c$export$67d698a4bb9f8c2a(position, attributeName, value, model) {
    return model.createRange($f1defb5a0a139b4c$export$a6e075de01e9ca89(position, attributeName, value, true, model), $f1defb5a0a139b4c$export$a6e075de01e9ca89(position, attributeName, value, false, model));
}
/**
* Walks forward or backward (depends on the `lookBack` flag), node by node, as long as they have the same attribute value
* and returns a position just before or after (depends on the `lookBack` flag) the last matched node.
*
* @param position The start position.
* @param attributeName The attribute name.
* @param value The attribute value.
* @param lookBack Whether the walk direction is forward (`false`) or backward (`true`).
* @returns The position just before the last matched node.
*/ function $f1defb5a0a139b4c$export$a6e075de01e9ca89(position, attributeName, value, lookBack, model) {
    let node = position.textNode || (lookBack ? position.nodeBefore : position.nodeAfter);
    let lastNode = null;
    while(node && node.getAttribute(attributeName) == value){
        lastNode = node;
        node = lookBack ? node.previousSibling : node.nextSibling;
    }
    return lastNode ? model.createPositionAt(lastNode, lookBack ? "before" : "after") : position;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module typing/utils/inlinehighlight
*/ /**
* Adds a visual highlight style to an attribute element in which the selection is anchored.
* Together with two-step caret movement, they indicate that the user is typing inside the element.
*
* Highlight is turned on by adding the given class to the attribute element in the view:
*
* * The class is removed before the conversion has started, as callbacks added with the `'highest'` priority
* to {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} events.
* * The class is added in the view post fixer, after other changes in the model tree were converted to the view.
*
* This way, adding and removing the highlight does not interfere with conversion.
*
* Usage:
*
* ```ts
* import { inlineHighlight } from '@ckeditor/ckeditor5-typing/src/utils/inlinehighlight';
*
* // Make `ck-link_selected` class be applied on an `a` element
* // whenever the corresponding `linkHref` attribute element is selected.
* inlineHighlight( editor, 'linkHref', 'a', 'ck-link_selected' );
* ```
*
* @param editor The editor instance.
* @param attributeName The attribute name to check.
* @param tagName The tagName of a view item.
* @param className The class name to apply in the view.
*/ function $f1defb5a0a139b4c$export$cec5d5ee2c77a35c(editor, attributeName, tagName, className) {
    const view = editor.editing.view;
    const highlightedElements = /* @__PURE__ */ new Set();
    view.document.registerPostFixer((writer)=>{
        const selection = editor.model.document.selection;
        let changed = false;
        if (selection.hasAttribute(attributeName)) {
            const modelRange = $f1defb5a0a139b4c$export$67d698a4bb9f8c2a(selection.getFirstPosition(), attributeName, selection.getAttribute(attributeName), editor.model);
            const viewRange = editor.editing.mapper.toViewRange(modelRange);
            for (const item of viewRange.getItems())if (item.is("element", tagName) && !item.hasClass(className)) {
                writer.addClass(className, item);
                highlightedElements.add(item);
                changed = true;
            }
        }
        return changed;
    });
    editor.conversion.for("editingDowncast").add((dispatcher)=>{
        dispatcher.on("insert", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("remove", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("attribute", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("selection", removeHighlight, {
            priority: "highest"
        });
        function removeHighlight() {
            view.change((writer)=>{
                for (const item of highlightedElements.values()){
                    writer.removeClass(className, item);
                    highlightedElements.delete(item);
                }
            });
        }
    });
}




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Creates a listener triggered on {@link module:engine/model/document~ModelDocument#event:change:data `change:data`} event in the document.
* Calls the callback when inserted text matches the regular expression or the command name
* if provided instead of the callback.
*
* Examples of usage:
*
* To convert a paragraph into heading 1 when `- ` is typed, using just the command name:
*
* ```ts
* blockAutoformatEditing( editor, plugin, /^\- $/, 'heading1' );
* ```
*
* To convert a paragraph into heading 1 when `- ` is typed, using just the callback:
*
* ```ts
* blockAutoformatEditing( editor, plugin, /^\- $/, ( context ) => {
* 	const { match } = context;
* 	const headingLevel = match[ 1 ].length;
*
* 	editor.execute( 'heading', {
* 		formatId: `heading${ headingLevel }`
* 	} );
* } );
* ```
*
* @param editor The editor instance.
* @param plugin The autoformat plugin instance.
* @param pattern The regular expression to execute on just inserted text. The regular expression is tested against the text
* from the beginning until the caret position.
* @param callbackOrCommand The callback to execute or the command to run when the text is matched.
* In case of providing the callback, it receives the following parameter:
* * match RegExp.exec() result of matching the pattern to inserted text.
*/ function $58c9e1b8584bd78b$export$69218e6679b43e4e(editor, plugin, pattern, callbackOrCommand) {
    let callback;
    let command = null;
    if (typeof callbackOrCommand == "function") callback = callbackOrCommand;
    else {
        command = editor.commands.get(callbackOrCommand);
        callback = ()=>{
            editor.execute(callbackOrCommand);
        };
    }
    editor.model.document.on("change:data", (evt, batch)=>{
        if (command && !command.isEnabled || !plugin.isEnabled) return;
        const range = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(editor.model.document.selection.getRanges());
        if (!range.isCollapsed) return;
        if (batch.isUndo || !batch.isLocal) return;
        const changes = Array.from(editor.model.document.differ.getChanges());
        const entry = changes[0];
        if (changes.length != 1 || entry.type !== "insert" || entry.name != "$text" || entry.length != 1) return;
        const blockToFormat = entry.position.parent;
        if (blockToFormat.is("element", "codeBlock")) return;
        if (blockToFormat.is("element", "listItem") && typeof callbackOrCommand !== "function" && ![
            "numberedList",
            "bulletedList",
            "todoList"
        ].includes(callbackOrCommand)) return;
        if (command && command.value === true) return;
        const firstNode = blockToFormat.getChild(0);
        const firstNodeRange = editor.model.createRangeOn(firstNode);
        if (!firstNodeRange.containsRange(range) && !range.end.isEqual(firstNodeRange.end)) return;
        const match = pattern.exec(firstNode.data.substr(0, range.end.offset));
        if (!match) return;
        editor.model.enqueueChange((writer)=>{
            const selection = editor.model.document.selection;
            const start = writer.createPositionAt(blockToFormat, 0);
            const end = writer.createPositionAt(blockToFormat, match[0].length);
            const range = new (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f)(start, end);
            if (callback({
                match: match
            }) !== false) {
                const selectionAttributes = Array.from(selection.getAttributes());
                writer.remove(range);
                const selectionRange = selection.getFirstRange();
                const blockRange = writer.createRangeIn(blockToFormat);
                if (blockToFormat.isEmpty && !blockRange.isEqual(selectionRange) && !blockRange.containsRange(selectionRange, true)) writer.remove(blockToFormat);
                $58c9e1b8584bd78b$var$restoreSelectionAttributes(writer, selection, selectionAttributes);
            }
            range.detach();
            editor.model.enqueueChange(()=>{
                editor.plugins.get("Delete").requestUndoOnBackspace();
            });
        });
    });
}
/**
* Restore allowed selection attributes.
*/ function $58c9e1b8584bd78b$var$restoreSelectionAttributes(writer, selection, selectionAttributes) {
    const schema = writer.model.schema;
    const selectionPosition = selection.getFirstPosition();
    let selectionSchemaContext = new (0, $b9b9f2bdf9c6137f$export$c13b6c331bc0a71a)(selectionPosition);
    if (schema.checkChild(selectionSchemaContext, "$text")) selectionSchemaContext = selectionSchemaContext.push("$text");
    for (const [attributeName, attributeValue] of selectionAttributes)if (schema.checkAttribute(selectionSchemaContext, attributeName)) writer.setSelectionAttribute(attributeName, attributeValue);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Enables autoformatting mechanism for a given {@link module:core/editor/editor~Editor}.
*
* It formats the matched text by applying the given model attribute or by running the provided formatting callback.
* On every {@link module:engine/model/document~ModelDocument#event:change:data data change} in the model document
* the autoformatting engine checks the text on the left of the selection
* and executes the provided action if the text matches given criteria (regular expression or callback).
*
* @param editor The editor instance.
* @param plugin The autoformat plugin instance.
* @param testRegexpOrCallback The regular expression or callback to execute on text.
* Provided regular expression *must* have three capture groups. The first and the third capture group
* should match opening and closing delimiters. The second capture group should match the text to format.
*
* ```ts
* // Matches the `**bold text**` pattern.
* // There are three capturing groups:
* // - The first to match the starting `**` delimiter.
* // - The second to match the text to format.
* // - The third to match the ending `**` delimiter.
* inlineAutoformatEditing( editor, plugin, /(\*\*)([^\*]+?)(\*\*)$/g, formatCallback );
* ```
*
* When a function is provided instead of the regular expression, it will be executed with the text to match as a parameter.
* The function should return proper "ranges" to delete and format.
*
* ```ts
* {
* 	remove: [
* 		[ 0, 1 ],	// Remove the first letter from the given text.
* 		[ 5, 6 ]	// Remove the 6th letter from the given text.
* 	],
* 	format: [
* 		[ 1, 5 ]	// Format all letters from 2nd to 5th.
* 	]
* }
* ```
*
* @param formatCallback A callback to apply actual formatting.
* It should return `false` if changes should not be applied (e.g. if a command is disabled).
*
* ```ts
* inlineAutoformatEditing( editor, plugin, /(\*\*)([^\*]+?)(\*\*)$/g, ( writer, rangesToFormat ) => {
* 	const command = editor.commands.get( 'bold' );
*
* 	if ( !command.isEnabled ) {
* 		return false;
* 	}
*
* 	const validRanges = editor.model.schema.getValidRanges( rangesToFormat, 'bold' );
*
* 	for ( let range of validRanges ) {
* 		writer.setAttribute( 'bold', true, range );
* 	}
* } );
* ```
*/ function $58c9e1b8584bd78b$export$1a6e83af5258d9fe(editor, plugin, testRegexpOrCallback, formatCallback) {
    let regExp;
    let testCallback;
    if (testRegexpOrCallback instanceof RegExp) regExp = testRegexpOrCallback;
    else testCallback = testRegexpOrCallback;
    testCallback = testCallback || ((text)=>{
        let result;
        const remove = [];
        const format = [];
        while((result = regExp.exec(text)) !== null){
            if (result && result.length < 4) break;
            let { index: index, "1": leftDel, "2": content, "3": rightDel } = result;
            const found = leftDel + content + rightDel;
            index += result[0].length - found.length;
            const delStart = [
                index,
                index + leftDel.length
            ];
            const delEnd = [
                index + leftDel.length + content.length,
                index + leftDel.length + content.length + rightDel.length
            ];
            remove.push(delStart);
            remove.push(delEnd);
            format.push([
                index + leftDel.length,
                index + leftDel.length + content.length
            ]);
        }
        return {
            remove: remove,
            format: format
        };
    });
    editor.model.document.on("change:data", (evt, batch)=>{
        if (batch.isUndo || !batch.isLocal || !plugin.isEnabled) return;
        const model = editor.model;
        const selection = model.document.selection;
        if (!selection.isCollapsed) return;
        const changes = Array.from(model.document.differ.getChanges());
        const entry = changes[0];
        if (changes.length != 1 || entry.type !== "insert" || entry.name != "$text" || entry.length != 1) return;
        const focus = selection.focus;
        const block = focus.parent;
        const { text: text, range: range } = $58c9e1b8584bd78b$var$getTextAfterCode(model.createRange(model.createPositionAt(block, 0), focus), model);
        const testOutput = testCallback(text);
        const rangesToFormat = $58c9e1b8584bd78b$var$testOutputToRanges(range.start, testOutput.format, model);
        const rangesToRemove = $58c9e1b8584bd78b$var$testOutputToRanges(range.start, testOutput.remove, model);
        if (!(rangesToFormat.length && rangesToRemove.length)) return;
        model.enqueueChange((writer)=>{
            if (formatCallback(writer, rangesToFormat) === false) return;
            for (const range of rangesToRemove.reverse())writer.remove(range);
            model.enqueueChange(()=>{
                editor.plugins.get("Delete").requestUndoOnBackspace();
            });
        });
    });
}
/**
* Converts output of the test function provided to the inlineAutoformatEditing and converts it to the model ranges
* inside provided block.
*/ function $58c9e1b8584bd78b$var$testOutputToRanges(start, arrays, model) {
    return arrays.filter((array)=>array[0] !== void 0 && array[1] !== void 0).map((array)=>{
        return model.createRange(start.getShiftedBy(array[0]), start.getShiftedBy(array[1]));
    });
}
/**
* Returns the last text line after the last code element from the given range.
* It is similar to {@link module:typing/utils/getlasttextline.getLastTextLine `getLastTextLine()`},
* but it ignores any text before the last `code`.
*/ function $58c9e1b8584bd78b$var$getTextAfterCode(range, model) {
    let start = range.start;
    return {
        text: Array.from(range.getItems()).reduce((rangeText, node)=>{
            if (!(node.is("$text") || node.is("$textProxy")) || node.getAttribute("code")) {
                start = model.createPositionAfter(node);
                return "";
            }
            return rangeText + node.data;
        }, ""),
        range: model.createRange(start, range.end)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Enables a set of predefined autoformatting actions.
*
* For a detailed overview, check the {@glink features/autoformat Autoformatting} feature guide
* and the {@glink api/autoformat package page}.
*/ var $58c9e1b8584bd78b$export$8889c40da46082d3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f1defb5a0a139b4c$export$bfadae053a633538)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Autoformat";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const t = this.editor.t;
        this._addListAutoformats();
        this._addBasicStylesAutoformats();
        this._addHeadingAutoformats();
        this._addBlockQuoteAutoformats();
        this._addCodeBlockAutoformats();
        this._addHorizontalLineAutoformats();
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Revert autoformatting action"),
                    keystroke: "Backspace"
                }
            ]
        });
    }
    /**
	* Adds autoformatting related to the {@link module:list/list~List}.
	*
	* When typed:
	* - `* ` or `- ` &ndash; A paragraph will be changed into a bulleted list.
	* - `<number>. ` or `<number>) ` &ndash; A paragraph will be changed into a numbered list.
	* If the paragraph is adjacent to an existing list, the typed number is ignored and the item joins the list
	* as the next sequential item. Otherwise, a new list is created with the `listStart` attribute set to the typed number
	* (when the {@link module:list/listproperties~ListProperties start index feature} is enabled).
	* - `[] ` or `[ ] ` &ndash; A paragraph will be changed into a to-do list.
	* - `[x] ` or `[ x ] ` &ndash; A paragraph will be changed into a checked to-do list.
	*/ _addListAutoformats() {
        const commands = this.editor.commands;
        if (commands.get("bulletedList")) $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^[*-]\s$/, "bulletedList");
        if (commands.get("numberedList")) {
            const numberedListCommand = commands.get("numberedList");
            const hasStartIndexFeature = !!commands.get("listStart");
            $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^(\d+)[.|)]\s$/, ({ match: match })=>{
                if (!numberedListCommand.isEnabled || numberedListCommand.value === true) return false;
                this.editor.execute("numberedList", hasStartIndexFeature ? {
                    additionalAttributes: {
                        listStart: parseInt(match[1])
                    }
                } : void 0);
            });
        }
        if (commands.get("todoList")) $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^\[\s?\]\s$/, "todoList");
        if (commands.get("checkTodoList")) $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^\[\s?x\s?\]\s$/, ()=>{
            this.editor.execute("todoList");
            this.editor.execute("checkTodoList");
        });
    }
    /**
	* Adds autoformatting related to the {@link module:basic-styles/bold~Bold},
	* {@link module:basic-styles/italic~Italic}, {@link module:basic-styles/code~Code}
	* and {@link module:basic-styles/strikethrough~Strikethrough}
	*
	* When typed:
	* - `**foobar**` &ndash; `**` characters are removed and `foobar` is set to bold,
	* - `__foobar__` &ndash; `__` characters are removed and `foobar` is set to bold,
	* - `*foobar*` &ndash; `*` characters are removed and `foobar` is set to italic,
	* - `_foobar_` &ndash; `_` characters are removed and `foobar` is set to italic,
	* - ``` `foobar` &ndash; ``` ` ``` characters are removed and `foobar` is set to code,
	* - `~~foobar~~` &ndash; `~~` characters are removed and `foobar` is set to strikethrough.
	*/ _addBasicStylesAutoformats() {
        const commands = this.editor.commands;
        if (commands.get("bold")) {
            const boldCallback = $58c9e1b8584bd78b$var$getCallbackFunctionForInlineAutoformat(this.editor, "bold");
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, boldCallback);
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, boldCallback);
        }
        if (commands.get("italic")) {
            const italicCallback = $58c9e1b8584bd78b$var$getCallbackFunctionForInlineAutoformat(this.editor, "italic");
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, italicCallback);
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, italicCallback);
        }
        if (commands.get("code")) {
            const codeCallback = $58c9e1b8584bd78b$var$getCallbackFunctionForInlineAutoformat(this.editor, "code");
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(`)([^`]+)(`)$/g, codeCallback);
        }
        if (commands.get("strikethrough")) {
            const strikethroughCallback = $58c9e1b8584bd78b$var$getCallbackFunctionForInlineAutoformat(this.editor, "strikethrough");
            $58c9e1b8584bd78b$export$1a6e83af5258d9fe(this.editor, this, /(~~)([^~]+)(~~)$/g, strikethroughCallback);
        }
    }
    /**
	* Adds autoformatting related to {@link module:heading/heading~Heading}.
	*
	* It is using a number at the end of the command name to associate it with the proper trigger:
	*
	* * `heading` with a `heading1` value will be executed when typing `#`,
	* * `heading` with a `heading2` value will be executed when typing `##`,
	* * ... up to `heading6` for `######`.
	*/ _addHeadingAutoformats() {
        const command = this.editor.commands.get("heading");
        if (command) command.modelElements.filter((name)=>name.match(/^heading[1-6]$/)).forEach((modelName)=>{
            const level = modelName[7];
            const pattern = new RegExp(`^(#{${level}})\\s$`);
            $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, pattern, ()=>{
                if (!command.isEnabled || command.value === modelName) return false;
                this.editor.execute("heading", {
                    value: modelName
                });
            });
        });
    }
    /**
	* Adds autoformatting related to {@link module:block-quote/blockquote~BlockQuote}.
	*
	* When typed:
	* * `> ` &ndash; A paragraph will be changed to a block quote.
	*/ _addBlockQuoteAutoformats() {
        if (this.editor.commands.get("blockQuote")) $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^>\s$/, "blockQuote");
    }
    /**
	* Adds autoformatting related to {@link module:code-block/codeblock~CodeBlock}.
	*
	* When typed:
	* - `` ``` `` &ndash; A paragraph will be changed to a code block.
	*/ _addCodeBlockAutoformats() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        if (editor.commands.get("codeBlock")) $58c9e1b8584bd78b$export$69218e6679b43e4e(editor, this, /^```$/, ()=>{
            if (selection.getFirstPosition().parent.is("element", "listItem")) return false;
            this.editor.execute("codeBlock", {
                usePreviousLanguageChoice: true
            });
        });
    }
    /**
	* Adds autoformatting related to {@link module:horizontal-line/horizontalline~HorizontalLine}.
	*
	* When typed:
	* - `` --- `` &ndash; Will be replaced with a horizontal line.
	*/ _addHorizontalLineAutoformats() {
        if (this.editor.commands.get("horizontalLine")) $58c9e1b8584bd78b$export$69218e6679b43e4e(this.editor, this, /^---$/, "horizontalLine");
    }
};
/**
* Helper function for getting `inlineAutoformatEditing` callbacks that checks if command is enabled.
*/ function $58c9e1b8584bd78b$var$getCallbackFunctionForInlineAutoformat(editor, attributeKey) {
    return (writer, rangesToFormat)=>{
        if (!editor.commands.get(attributeKey).isEnabled) return false;
        const validRanges = editor.model.schema.getValidRanges(rangesToFormat, attributeKey);
        for (const range of validRanges)writer.setAttribute(attributeKey, true, range);
        writer.removeSelectionAttribute(attributeKey);
    };
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module autosave/autosave
*/ /**
* The {@link module:autosave/autosave~Autosave} plugin allows you to automatically save the data (e.g. send it to the server)
* when needed (when the user changed the content).
*
* It listens to the {@link module:engine/model/document~ModelDocument#event:change:data `editor.model.document#change:data`}
* and `window#beforeunload` events and calls the
* {@link module:autosave/autosave~AutosaveAdapter#save `config.autosave.save()`} function.
*
* ```ts
* ClassicEditor
* 	.create( {
* 		attachTo: document.querySelector( '#editor' ),
* 		plugins: [ ArticlePluginSet, Autosave ],
* 		toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
* 		image: {
* 			toolbar: [ 'imageStyle:block', 'imageStyle:side', '|', 'toggleImageCaption', 'imageTextAlternative' ],
* 		},
* 		autosave: {
* 			save( editor: Editor ) {
* 				// The saveData() function must return a promise
* 				// which should be resolved when the data is successfully saved.
* 				return saveData( editor.getData() );
* 			}
* 		}
* 	} );
* ```
*
* Read more about this feature in the {@glink features/autosave Autosave} feature guide.
*/ var $efdb19f0fadd36e2$export$61e9caf654e23bd2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The adapter is an object with a `save()` method. That method will be called whenever
	* the data changes. It might be called some time after the change,
	* since the event is throttled for performance reasons.
	*/ adapter;
    /**
	* Debounced save method. The `save()` method is called the specified `waitingTime` after `debouncedSave()` is called,
	* unless a new action happens in the meantime.
	*/ _debouncedSave;
    /**
	* The last saved document version.
	*/ _lastDocumentVersion;
    /**
	* Promise used for asynchronous save calls.
	*
	* Created to handle the autosave call to an external data source. It resolves when that call is finished. It is re-used if
	* save is called before the promise has been resolved. It is set to `null` if there is no call in progress.
	*/ _savePromise;
    /**
	* DOM emitter.
	*/ _domEmitter;
    /**
	* The configuration of this plugins.
	*/ _config;
    /**
	* Editor's pending actions manager.
	*/ _pendingActions;
    /**
	* Informs whether there should be another autosave callback performed, immediately after current autosave callback finishes.
	*
	* This is set to `true` when there is a save request while autosave callback is already being processed
	* and the model has changed since the last save.
	*/ _makeImmediateSave;
    /**
	* An action that will be added to the pending action manager for actions happening in that plugin.
	*/ _action = null;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Autosave";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5)
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        const config = editor.config.get("autosave") || {};
        const waitingTime = config.waitingTime || 1e3;
        this.set("state", "synchronized");
        this._debouncedSave = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(this._save.bind(this), waitingTime);
        this._lastDocumentVersion = editor.model.document.version;
        this._savePromise = null;
        this._domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
        this._config = config;
        this._pendingActions = editor.plugins.get((0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5));
        this._makeImmediateSave = false;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const doc = editor.model.document;
        this.listenTo(editor, "ready", ()=>{
            this.listenTo(doc, "change:data", (evt, batch)=>{
                if (!this._saveCallbacks.length) return;
                if (!batch.isLocal) return;
                if (this.state === "synchronized") {
                    this.state = "waiting";
                    this._setPendingAction();
                }
                if (this.state === "waiting") this._debouncedSave();
            });
        });
        this.listenTo(editor, "destroy", ()=>this._flush(), {
            priority: "highest"
        });
        /* v8 ignore next -- @preserve */ this._domEmitter.listenTo(window, "beforeunload", (evtInfo, domEvt)=>{
            if (this._pendingActions.hasAny) domEvt.returnValue = this._pendingActions.first.message;
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._domEmitter.stopListening();
        super.destroy();
    }
    /**
	* Immediately calls autosave callback. All previously queued (debounced) callbacks are cleared. If there is already an autosave
	* callback in progress, then the requested save will be performed immediately after the current callback finishes.
	*
	* @returns A promise that will be resolved when the autosave callback is finished.
	*/ save() {
        this._debouncedSave.cancel();
        return this._save();
    }
    /**
	* Invokes the remaining `_save()` method call.
	*/ _flush() {
        this._debouncedSave.flush();
    }
    /**
	* If the adapter is set and a new document version exists,
	* the `_save()` method creates a pending action and calls the `adapter.save()` method.
	* It waits for the result and then removes the created pending action.
	*
	* @returns A promise that will be resolved when the autosave callback is finished.
	*/ _save() {
        if (this._savePromise) {
            this._makeImmediateSave = this.editor.model.document.version > this._lastDocumentVersion;
            return this._savePromise;
        }
        this._setPendingAction();
        this.state = "saving";
        this._lastDocumentVersion = this.editor.model.document.version;
        this._savePromise = Promise.resolve().then(()=>Promise.all(this._saveCallbacks.map((cb)=>cb(this.editor)))).finally(()=>{
            this._savePromise = null;
        }).then(()=>{
            if (this._makeImmediateSave) {
                this._makeImmediateSave = false;
                return this._save();
            } else if (this.editor.model.document.version > this._lastDocumentVersion) {
                this.state = "waiting";
                this._debouncedSave();
            } else {
                this.state = "synchronized";
                this._pendingActions.remove(this._action);
                this._action = null;
            }
        }).catch((err)=>{
            this.state = "error";
            this.state = "saving";
            this._debouncedSave();
            throw err;
        });
        return this._savePromise;
    }
    /**
	* Creates a pending action if it is not set already.
	*/ _setPendingAction() {
        const t = this.editor.t;
        if (!this._action) this._action = this._pendingActions.add(t("Saving changes"));
    }
    /**
	* Saves callbacks.
	*/ get _saveCallbacks() {
        const saveCallbacks = [];
        if (this.adapter && this.adapter.save) saveCallbacks.push(this.adapter.save);
        if (this._config.save) saveCallbacks.push(this._config.save);
        return saveCallbacks;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/attributecommand
*/ /**
* An extension of the base {@link module:core/command~Command} class, which provides utilities for a command
* that toggles a single attribute on a text or an element.
*
* `AttributeCommand` uses {@link module:engine/model/document~ModelDocument#selection}
* to decide which nodes (if any) should be changed, and applies or removes the attribute from them.
*
* The command checks the {@link module:engine/model/model~Model#schema} to decide if it can be enabled
* for the current selection and to which nodes the attribute can be applied.
*/ var $43897c58e8fc0f5a$export$a35e66a9ed27e45e = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The attribute that will be set by the command.
	*/ attributeKey;
    /**
	* @param attributeKey Attribute that will be set by the command.
	*/ constructor(editor, attributeKey){
        super(editor);
        this.attributeKey = attributeKey;
    }
    /**
	* Updates the command's {@link #value} and {@link #isEnabled} based on the current selection.
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.value = this._getValueFromFirstAllowedNode();
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }
    /**
	* Executes the command &ndash; applies the attribute to the selection or removes it from the selection.
	*
	* If the command is active (`value == true`), it will remove attributes. Otherwise, it will set attributes.
	*
	* The execution result differs, depending on the {@link module:engine/model/document~ModelDocument#selection}:
	*
	* * If the selection is on a range, the command applies the attribute to all nodes in that range
	* (if they are allowed to have this attribute by the {@link module:engine/model/schema~ModelSchema schema}).
	* * If the selection is collapsed in a non-empty node, the command applies the attribute to the
	* {@link module:engine/model/document~ModelDocument#selection} itself (note that typed characters copy attributes from the selection).
	* * If the selection is collapsed in an empty node, the command applies the attribute to the parent node of the selection (note
	* that the selection inherits all attributes from a node if it is in an empty node).
	*
	* @fires execute
	* @param options Command options.
	* @param options.forceValue If set, it will force the command behavior. If `true`,
	* the command will apply the attribute, otherwise the command will remove the attribute.
	* If not set, the command will look for its current value to decide what it should do.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const value = options.forceValue === void 0 ? !this.value : options.forceValue;
        model.change((writer)=>{
            if (selection.isCollapsed) {
                if (value) writer.setSelectionAttribute(this.attributeKey, true);
                else writer.removeSelectionAttribute(this.attributeKey);
            } else {
                const ranges = model.schema.getValidRanges(selection.getRanges(), this.attributeKey, {
                    includeEmptyRanges: true
                });
                for (const range of ranges){
                    let itemOrRange = range;
                    let attributeKey = this.attributeKey;
                    if (range.isCollapsed) {
                        itemOrRange = range.start.parent;
                        attributeKey = (0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey(this.attributeKey);
                    }
                    if (value) writer.setAttribute(attributeKey, value, itemOrRange);
                    else writer.removeAttribute(attributeKey, itemOrRange);
                }
            }
        });
    }
    /**
	* Checks the attribute value of the first node in the selection that allows the attribute.
	* For the collapsed selection returns the selection attribute.
	*
	* @returns The attribute value.
	*/ _getValueFromFirstAllowedNode() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        if (selection.isCollapsed) return selection.hasAttribute(this.attributeKey);
        for (const range of selection.getRanges())for (const item of range.getItems())if (schema.checkAttribute(item, this.attributeKey)) return item.hasAttribute(this.attributeKey);
        return false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/bold/boldediting
*/ const $43897c58e8fc0f5a$var$BOLD$1 = "bold";
/**
* The bold editing feature.
*
* It registers the `'bold'` command and introduces the `bold` attribute in the model which renders to the view
* as a `<strong>` element.
*/ var $43897c58e8fc0f5a$export$8bb959263b8dd16f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BoldEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$BOLD$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$BOLD$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$BOLD$1,
            view: "strong",
            upcastAlso: [
                "b",
                (viewElement)=>{
                    const fontWeight = viewElement.getStyle("font-weight");
                    if (!fontWeight) return null;
                    if (fontWeight == "bold" || Number(fontWeight) >= 600) return {
                        name: true,
                        styles: [
                            "font-weight"
                        ]
                    };
                    return null;
                }
            ]
        });
        editor.commands.add($43897c58e8fc0f5a$var$BOLD$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$BOLD$1));
        editor.keystrokes.set("CTRL+B", $43897c58e8fc0f5a$var$BOLD$1);
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Bold text"),
                    keystroke: "CTRL+B"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a function that creates a (toolbar or menu bar) button for a basic style feature.
*
* @internal
*/ function $43897c58e8fc0f5a$export$b4662c7a2efe2e01({ editor: editor, commandName: commandName, plugin: plugin, icon: icon, label: label, keystroke: keystroke }) {
    return (ButtonClass)=>{
        const command = editor.commands.get(commandName);
        const view = new ButtonClass(editor.locale);
        view.set({
            label: label,
            icon: icon,
            keystroke: keystroke,
            isToggleable: true
        });
        view.bind("isEnabled").to(command, "isEnabled");
        view.bind("isOn").to(command, "value");
        if (view instanceof (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)) view.set({
            role: "menuitemcheckbox"
        });
        else view.set({
            tooltip: true
        });
        plugin.listenTo(view, "execute", ()=>{
            editor.execute(commandName);
            editor.editing.view.focus();
        });
        return view;
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/bold/boldui
*/ const $43897c58e8fc0f5a$var$BOLD = "bold";
/**
* The bold UI feature. It introduces the Bold button.
*/ var $43897c58e8fc0f5a$export$f3c8751b3c333ad1 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BoldUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$BOLD,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$1d3fc6e952f4058b),
            label: t("Bold"),
            keystroke: "CTRL+B"
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$BOLD, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:bold", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/bold
*/ /**
* The bold feature.
*
* For a detailed overview check the {@glink features/basic-styles Basic styles feature} guide
* and the {@glink api/basic-styles package page}.
*
* This is a "glue" plugin which loads the {@link module:basic-styles/bold/boldediting~BoldEditing bold editing feature}
* and {@link module:basic-styles/bold/boldui~BoldUI bold UI feature}.
*/ var $43897c58e8fc0f5a$export$95aa4184327d6b72 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$8bb959263b8dd16f,
            $43897c58e8fc0f5a$export$f3c8751b3c333ad1
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Bold";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/code/codeediting
*/ const $43897c58e8fc0f5a$var$CODE$1 = "code";
const $43897c58e8fc0f5a$var$HIGHLIGHT_CLASS = "ck-code_selected";
/**
* The code editing feature.
*
* It registers the `'code'` command and introduces the `code` attribute in the model which renders to the view
* as a `<code>` element.
*/ var $43897c58e8fc0f5a$export$73b210ec8c007d8f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f1defb5a0a139b4c$export$b521f49d1c4c3786)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$CODE$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$CODE$1, {
            isFormatting: true,
            copyOnEnter: false
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$CODE$1,
            view: "code"
        });
        editor.commands.add($43897c58e8fc0f5a$var$CODE$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$CODE$1));
        editor.plugins.get((0, $f1defb5a0a139b4c$export$b521f49d1c4c3786)).registerAttribute($43897c58e8fc0f5a$var$CODE$1);
        (0, $f1defb5a0a139b4c$export$cec5d5ee2c77a35c)(editor, $43897c58e8fc0f5a$var$CODE$1, "code", $43897c58e8fc0f5a$var$HIGHLIGHT_CLASS);
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Move out of an inline code style"),
                    keystroke: [
                        [
                            "arrowleft",
                            "arrowleft"
                        ],
                        [
                            "arrowright",
                            "arrowright"
                        ]
                    ]
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/code/codeui
*/ const $43897c58e8fc0f5a$var$CODE = "code";
/**
* The code UI feature. It introduces the Code button.
*/ var $43897c58e8fc0f5a$export$9f6b2a09c73d3152 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$CODE,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$e332a83b9159d69d),
            label: t("Code")
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$CODE, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:code", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/code
*/ /**
* The code feature.
*
* For a detailed overview check the {@glink features/basic-styles Basic styles feature} guide
* and the {@glink api/basic-styles package page}.
*
* This is a "glue" plugin which loads the {@link module:basic-styles/code/codeediting~CodeEditing code editing feature}
* and {@link module:basic-styles/code/codeui~CodeUI code UI feature}.
*/ var $43897c58e8fc0f5a$export$52f0f02147b12c03 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$73b210ec8c007d8f,
            $43897c58e8fc0f5a$export$9f6b2a09c73d3152
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Code";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/italic/italicediting
*/ const $43897c58e8fc0f5a$var$ITALIC$1 = "italic";
/**
* The italic editing feature.
*
* It registers the `'italic'` command, the <kbd>Ctrl+I</kbd> keystroke and introduces the `italic` attribute in the model
* which renders to the view as an `<i>` element.
*/ var $43897c58e8fc0f5a$export$f1f3452d687ffd0a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ItalicEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$ITALIC$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$ITALIC$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$ITALIC$1,
            view: "i",
            upcastAlso: [
                "em",
                {
                    styles: {
                        "font-style": "italic"
                    }
                }
            ]
        });
        editor.commands.add($43897c58e8fc0f5a$var$ITALIC$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$ITALIC$1));
        editor.keystrokes.set("CTRL+I", $43897c58e8fc0f5a$var$ITALIC$1);
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Italic text"),
                    keystroke: "CTRL+I"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/italic/italicui
*/ const $43897c58e8fc0f5a$var$ITALIC = "italic";
/**
* The italic UI feature. It introduces the Italic button.
*/ var $43897c58e8fc0f5a$export$ce4de39254ab0228 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ItalicUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$ITALIC,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$3feafef056916dd7),
            keystroke: "CTRL+I",
            label: t("Italic")
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$ITALIC, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:italic", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/italic
*/ /**
* The italic feature.
*
* For a detailed overview check the {@glink features/basic-styles Basic styles feature} guide
* and the {@glink api/basic-styles package page}.
*
* This is a "glue" plugin which loads the {@link module:basic-styles/italic/italicediting~ItalicEditing} and
* {@link module:basic-styles/italic/italicui~ItalicUI} plugins.
*/ var $43897c58e8fc0f5a$export$1cfcf4275506b1c6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$f1f3452d687ffd0a,
            $43897c58e8fc0f5a$export$ce4de39254ab0228
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Italic";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/strikethrough/strikethroughediting
*/ const $43897c58e8fc0f5a$var$STRIKETHROUGH$1 = "strikethrough";
/**
* The strikethrough editing feature.
*
* It registers the `'strikethrough'` command, the <kbd>Ctrl+Shift+X</kbd> keystroke and introduces the
* `strikethroughsthrough` attribute in the model which renders to the view
* as a `<s>` element.
*/ var $43897c58e8fc0f5a$export$f3b194b6047082c0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StrikethroughEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$STRIKETHROUGH$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$STRIKETHROUGH$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$STRIKETHROUGH$1,
            view: "s",
            upcastAlso: [
                "del",
                "strike",
                {
                    styles: {
                        "text-decoration": "line-through"
                    }
                }
            ]
        });
        editor.commands.add($43897c58e8fc0f5a$var$STRIKETHROUGH$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$STRIKETHROUGH$1));
        editor.keystrokes.set("CTRL+SHIFT+X", "strikethrough");
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Strikethrough text"),
                    keystroke: "CTRL+SHIFT+X"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/strikethrough/strikethroughui
*/ const $43897c58e8fc0f5a$var$STRIKETHROUGH = "strikethrough";
/**
* The strikethrough UI feature. It introduces the Strikethrough button.
*/ var $43897c58e8fc0f5a$export$89ef195f8879a5a5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StrikethroughUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$STRIKETHROUGH,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$2e0f33c68ec2356e),
            keystroke: "CTRL+SHIFT+X",
            label: t("Strikethrough")
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$STRIKETHROUGH, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:strikethrough", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/strikethrough
*/ /**
* The strikethrough feature.
*
* For a detailed overview check the {@glink features/basic-styles Basic styles feature} guide
* and the {@glink api/basic-styles package page}.
*
* This is a "glue" plugin which loads the {@link module:basic-styles/strikethrough/strikethroughediting~StrikethroughEditing} and
* {@link module:basic-styles/strikethrough/strikethroughui~StrikethroughUI} plugins.
*/ var $43897c58e8fc0f5a$export$53f33388b3b5115f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$f3b194b6047082c0,
            $43897c58e8fc0f5a$export$89ef195f8879a5a5
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Strikethrough";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/subscript/subscriptediting
*/ const $43897c58e8fc0f5a$var$SUBSCRIPT$1 = "subscript";
/**
* The subscript editing feature.
*
* It registers the `sub` command and introduces the `sub` attribute in the model which renders to the view
* as a `<sub>` element.
*/ var $43897c58e8fc0f5a$export$254649a9d9572856 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SubscriptEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$SUBSCRIPT$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$SUBSCRIPT$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$SUBSCRIPT$1,
            view: "sub",
            upcastAlso: [
                {
                    styles: {
                        "vertical-align": "sub"
                    }
                }
            ]
        });
        editor.commands.add($43897c58e8fc0f5a$var$SUBSCRIPT$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$SUBSCRIPT$1));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/subscript/subscriptui
*/ const $43897c58e8fc0f5a$var$SUBSCRIPT = "subscript";
/**
* The subscript UI feature. It introduces the Subscript button.
*/ var $43897c58e8fc0f5a$export$ec8d643f10c192af = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SubscriptUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$SUBSCRIPT,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$5834a66e6db90bd0),
            label: t("Subscript")
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$SUBSCRIPT, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:subscript", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/subscript
*/ /**
* The subscript feature.
*
* It loads the {@link module:basic-styles/subscript/subscriptediting~SubscriptEditing} and
* {@link module:basic-styles/subscript/subscriptui~SubscriptUI} plugins.
*/ var $43897c58e8fc0f5a$export$54eb3b8088f84d2b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$254649a9d9572856,
            $43897c58e8fc0f5a$export$ec8d643f10c192af
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Subscript";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/superscript/superscriptediting
*/ const $43897c58e8fc0f5a$var$SUPERSCRIPT$1 = "superscript";
/**
* The superscript editing feature.
*
* It registers the `super` command and introduces the `super` attribute in the model which renders to the view
* as a `<super>` element.
*/ var $43897c58e8fc0f5a$export$c5e0a4dca3cef7f5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SuperscriptEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$SUPERSCRIPT$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$SUPERSCRIPT$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$SUPERSCRIPT$1,
            view: "sup",
            upcastAlso: [
                {
                    styles: {
                        "vertical-align": "super"
                    }
                }
            ]
        });
        editor.commands.add($43897c58e8fc0f5a$var$SUPERSCRIPT$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$SUPERSCRIPT$1));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/superscript/superscriptui
*/ const $43897c58e8fc0f5a$var$SUPERSCRIPT = "superscript";
/**
* The superscript UI feature. It introduces the Superscript button.
*/ var $43897c58e8fc0f5a$export$4a21663bf86f8e2a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SuperscriptUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$SUPERSCRIPT,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$bd9211873848bcce),
            label: t("Superscript")
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$SUPERSCRIPT, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:superscript", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/superscript
*/ /**
* The superscript feature.
*
* It loads the {@link module:basic-styles/superscript/superscriptediting~SuperscriptEditing} and
* {@link module:basic-styles/superscript/superscriptui~SuperscriptUI} plugins.
*/ var $43897c58e8fc0f5a$export$a4eac561e2e9d419 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$c5e0a4dca3cef7f5,
            $43897c58e8fc0f5a$export$4a21663bf86f8e2a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Superscript";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/underline/underlineediting
*/ const $43897c58e8fc0f5a$var$UNDERLINE$1 = "underline";
/**
* The underline editing feature.
*
* It registers the `'underline'` command, the <kbd>Ctrl+U</kbd> keystroke
* and introduces the `underline` attribute in the model which renders to the view as an `<u>` element.
*/ var $43897c58e8fc0f5a$export$70f65b41bc1cb0cb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "UnderlineEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.model.schema.extend("$text", {
            allowAttributes: $43897c58e8fc0f5a$var$UNDERLINE$1
        });
        editor.model.schema.setAttributeProperties($43897c58e8fc0f5a$var$UNDERLINE$1, {
            isFormatting: true,
            copyOnEnter: true
        });
        editor.conversion.attributeToElement({
            model: $43897c58e8fc0f5a$var$UNDERLINE$1,
            view: "u",
            upcastAlso: {
                styles: {
                    "text-decoration": "underline"
                }
            }
        });
        editor.commands.add($43897c58e8fc0f5a$var$UNDERLINE$1, new $43897c58e8fc0f5a$export$a35e66a9ed27e45e(editor, $43897c58e8fc0f5a$var$UNDERLINE$1));
        editor.keystrokes.set("CTRL+U", "underline");
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Underline text"),
                    keystroke: "CTRL+U"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/underline/underlineui
*/ const $43897c58e8fc0f5a$var$UNDERLINE = "underline";
/**
* The underline UI feature. It introduces the Underline button.
*/ var $43897c58e8fc0f5a$export$d4184df2c9c26f63 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "UnderlineUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const createButton = $43897c58e8fc0f5a$export$b4662c7a2efe2e01({
            editor: editor,
            commandName: $43897c58e8fc0f5a$var$UNDERLINE,
            plugin: this,
            icon: (0, $e8dc502aba5ac3f5$export$25f9abeb294dfbd0),
            label: t("Underline"),
            keystroke: "CTRL+U"
        });
        editor.ui.componentFactory.add($43897c58e8fc0f5a$var$UNDERLINE, ()=>createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:underline", ()=>createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module basic-styles/underline
*/ /**
* The underline feature.
*
* For a detailed overview check the {@glink features/basic-styles Basic styles feature} guide
* and the {@glink api/basic-styles package page}.
*
* This is a "glue" plugin which loads the {@link module:basic-styles/underline/underlineediting~UnderlineEditing} and
* {@link module:basic-styles/underline/underlineui~UnderlineUI} plugins.
*/ var $43897c58e8fc0f5a$export$741ee5bff4f2bc22 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $43897c58e8fc0f5a$export$70f65b41bc1cb0cb,
            $43897c58e8fc0f5a$export$d4184df2c9c26f63
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Underline";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns attributes that should be preserved on the enter keystroke.
*
* Filtering is realized based on `copyOnEnter` attribute property. Read more about attribute properties
* {@link module:engine/model/schema~ModelSchema#setAttributeProperties here}.
*
* @param schema Model's schema.
* @param allAttributes Attributes to filter.
* @internal
*/ function* $c871651c8276dc61$export$b1d719019e4bdf35(schema, allAttributes) {
    for (const attribute of allAttributes)if (attribute && schema.getAttributeProperties(attribute[0]).copyOnEnter) yield attribute;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module enter/entercommand
*/ /**
* Enter command used by the {@link module:enter/enter~Enter Enter feature} to handle the <kbd>Enter</kbd> keystroke.
*/ var $c871651c8276dc61$export$94e417ac7df3c302 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ execute() {
        this.editor.model.change((writer)=>{
            this.enterBlock(writer);
            this.fire("afterExecute", {
                writer: writer
            });
        });
    }
    /**
	* Splits a block where the document selection is placed, in the way how the <kbd>Enter</kbd> key is expected to work:
	*
	* ```
	* <p>Foo[]bar</p>   ->   <p>Foo</p><p>[]bar</p>
	* <p>Foobar[]</p>   ->   <p>Foobar</p><p>[]</p>
	* <p>Fo[ob]ar</p>   ->   <p>Fo</p><p>[]ar</p>
	* ```
	*
	* In some cases, the split will not happen:
	*
	* ```
	* // The selection parent is a limit element:
	* <figcaption>A[bc]d</figcaption>   ->   <figcaption>A[]d</figcaption>
	*
	* // The selection spans over multiple elements:
	* <h>x[x</h><p>y]y<p>   ->   <h>x</h><p>[]y</p>
	* ```
	*
	* @param writer Writer to use when performing the enter action.
	* @returns Boolean indicating if the block was split.
	*/ enterBlock(writer) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const schema = model.schema;
        const isSelectionEmpty = selection.isCollapsed;
        const range = selection.getFirstRange();
        const startElement = range.start.parent;
        const endElement = range.end.parent;
        if (schema.isLimit(startElement) || schema.isLimit(endElement)) {
            if (!isSelectionEmpty && startElement == endElement) model.deleteContent(selection);
            return false;
        }
        if (isSelectionEmpty) {
            const attributesToCopy = $c871651c8276dc61$export$b1d719019e4bdf35(writer.model.schema, selection.getAttributes());
            $c871651c8276dc61$var$splitBlock(writer, range.start);
            writer.setSelectionAttribute(attributesToCopy);
            return true;
        } else {
            const leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
            const isContainedWithinOneElement = startElement == endElement;
            model.deleteContent(selection, {
                leaveUnmerged: leaveUnmerged
            });
            if (leaveUnmerged) {
                if (isContainedWithinOneElement) {
                    $c871651c8276dc61$var$splitBlock(writer, selection.focus);
                    return true;
                } else writer.setSelection(endElement, 0);
            }
        }
        return false;
    }
};
function $c871651c8276dc61$var$splitBlock(writer, splitPos) {
    writer.split(splitPos);
    writer.setSelection(splitPos.parent.nextSibling, 0);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module enter/enterobserver
*/ const $c871651c8276dc61$var$ENTER_EVENT_TYPES = {
    insertParagraph: {
        isSoft: false
    },
    insertLineBreak: {
        isSoft: true
    }
};
/**
* Enter observer introduces the {@link module:engine/view/document~ViewDocument#event:enter `Document#enter`} event.
*/ var $c871651c8276dc61$export$c3aad45786e6d018 = class extends (0, $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b) {
    /**
	* @inheritDoc
	*/ constructor(view){
        super(view);
        const doc = this.document;
        let shiftPressed = false;
        doc.on("keydown", (evt, data)=>{
            shiftPressed = data.shiftKey;
        });
        doc.on("beforeinput", (evt, data)=>{
            if (!this.isEnabled) return;
            let inputType = data.inputType;
            if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari && shiftPressed && inputType == "insertParagraph") inputType = "insertLineBreak";
            const domEvent = data.domEvent;
            const enterEventSpec = $c871651c8276dc61$var$ENTER_EVENT_TYPES[inputType];
            if (!enterEventSpec) return;
            const event = new (0, $b9b9f2bdf9c6137f$export$56609df77c04b70e)(doc, "enter", data.targetRanges[0]);
            doc.fire(event, new (0, $b9b9f2bdf9c6137f$export$7f51b38da3783c21)(view, domEvent, {
                isSoft: enterEventSpec.isSoft
            }));
            if (event.stop.called) evt.stop();
        });
    }
    /**
	* @inheritDoc
	*/ observe() {}
    /**
	* @inheritDoc
	*/ stopObserving() {}
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module enter/enter
*/ /**
* This plugin handles the <kbd>Enter</kbd> keystroke (hard line break) in the editor.
*
* See also the {@link module:enter/shiftenter~ShiftEnter} plugin.
*
* For more information about this feature see the {@glink api/enter package page}.
*/ var $c871651c8276dc61$export$64a2c9e77ce3aa7a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Enter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    init() {
        const editor = this.editor;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const t = this.editor.t;
        view.addObserver($c871651c8276dc61$export$c3aad45786e6d018);
        editor.commands.add("enter", new $c871651c8276dc61$export$94e417ac7df3c302(editor));
        this.listenTo(viewDocument, "enter", (evt, data)=>{
            if (!viewDocument.isComposing) data.preventDefault();
            if (data.isSoft) return;
            editor.execute("enter");
            view.scrollToTheSelection();
        }, {
            priority: "low"
        });
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Insert a hard break (a new paragraph)"),
                    keystroke: "Enter"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module enter/shiftentercommand
*/ /**
* ShiftEnter command. It is used by the {@link module:enter/shiftenter~ShiftEnter ShiftEnter feature} to handle
* the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke.
*/ var $c871651c8276dc61$export$b8bec7ffa345c1bd = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        const doc = model.document;
        model.change((writer)=>{
            $c871651c8276dc61$var$softBreakAction(model, writer, doc.selection);
            this.fire("afterExecute", {
                writer: writer
            });
        });
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.isEnabled = $c871651c8276dc61$var$isEnabled(model.schema, doc.selection);
    }
};
/**
* Checks whether the ShiftEnter command should be enabled in the specified selection.
*/ function $c871651c8276dc61$var$isEnabled(schema, selection) {
    if (selection.rangeCount > 1) return false;
    const anchorPos = selection.anchor;
    if (!anchorPos || !schema.checkChild(anchorPos, "softBreak")) return false;
    const range = selection.getFirstRange();
    const startElement = range.start.parent;
    const endElement = range.end.parent;
    if (($c871651c8276dc61$var$isInsideLimitElement(startElement, schema) || $c871651c8276dc61$var$isInsideLimitElement(endElement, schema)) && startElement !== endElement) return false;
    return true;
}
/**
* Creates a break in the way that the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke is expected to work.
*/ function $c871651c8276dc61$var$softBreakAction(model, writer, selection) {
    const isSelectionEmpty = selection.isCollapsed;
    const range = selection.getFirstRange();
    const startElement = range.start.parent;
    const endElement = range.end.parent;
    const isContainedWithinOneElement = startElement == endElement;
    if (isSelectionEmpty) $c871651c8276dc61$var$insertBreak(model, writer, range.end, selection.getAttributes());
    else {
        const leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
        model.deleteContent(selection, {
            leaveUnmerged: leaveUnmerged
        });
        if (isContainedWithinOneElement) $c871651c8276dc61$var$insertBreak(model, writer, selection.focus, selection.getAttributes());
        else if (leaveUnmerged) writer.setSelection(endElement, 0);
    }
}
/**
* Inserts a softBreak with applicable attributes.
*/ function $c871651c8276dc61$var$insertBreak(model, writer, position, selectionAttributes) {
    const attributes = Array.from($c871651c8276dc61$export$b1d719019e4bdf35(model.schema, selectionAttributes));
    const breakLineElement = writer.createElement("softBreak", attributes);
    model.insertContent(breakLineElement, position);
    writer.setSelection(breakLineElement, "after");
}
/**
* Checks whether the specified `element` is a child of the limit element.
*
* Checking whether the `<p>` element is inside a limit element:
*   - `<$root><p>Text.</p></$root> => false`
*   - `<$root><limitElement><p>Text</p></limitElement></$root> => true`
*/ function $c871651c8276dc61$var$isInsideLimitElement(element, schema) {
    if (element.is("rootElement")) return false;
    return schema.isLimit(element) || $c871651c8276dc61$var$isInsideLimitElement(element.parent, schema);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module enter/shiftenter
*/ /**
* This plugin handles the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke (soft line break) in the editor.
*
* See also the {@link module:enter/enter~Enter} plugin.
*
* For more information about this feature see the {@glink api/enter package page}.
*/ var $c871651c8276dc61$export$f74dddee9c33418e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ShiftEnter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const t = this.editor.t;
        schema.register("softBreak", {
            allowWhere: "$text",
            allowAttributesOf: "$text",
            isInline: true
        });
        conversion.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
        });
        conversion.for("downcast").elementToElement({
            model: "softBreak",
            view: (modelElement, { writer: writer })=>writer.createEmptyElement("br")
        });
        view.addObserver($c871651c8276dc61$export$c3aad45786e6d018);
        editor.commands.add("shiftEnter", new $c871651c8276dc61$export$b8bec7ffa345c1bd(editor));
        editor.model.document.registerPostFixer((writer)=>$c871651c8276dc61$var$removeStaleSoftBreakAttributes(writer));
        this.listenTo(viewDocument, "enter", (evt, data)=>{
            if (!viewDocument.isComposing) data.preventDefault();
            if (!data.isSoft) return;
            editor.execute("shiftEnter");
            view.scrollToTheSelection();
        }, {
            priority: "low"
        });
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
                    keystroke: "Shift+Enter"
                }
            ]
        });
    }
};
/**
* The post-fixer that removes attributes from stale soft-break elements.
*/ function $c871651c8276dc61$var$removeStaleSoftBreakAttributes(writer) {
    const parentsToCheck = /* @__PURE__ */ new Set();
    for (const change of writer.model.document.differ.getChanges())if (change.type == "insert" || change.type == "remove") /* v8 ignore else -- @preserve */ {
        if (change.position.parent.is("element")) parentsToCheck.add(change.position.parent);
    } else if (change.type == "attribute") /* v8 ignore else -- @preserve */ {
        if (change.range.start.parent.is("element")) parentsToCheck.add(change.range.start.parent);
    }
    let wasChanged = false;
    for (const parent of parentsToCheck)for (const child of parent.getChildren()){
        if (!child.is("element", "softBreak")) continue;
        const nextSibling = child.nextSibling;
        if (!nextSibling || nextSibling.is("element")) continue;
        const attributesToRemove = Array.from(child.getAttributes()).filter(([key, value])=>!$c871651c8276dc61$var$hasSameAttribute(nextSibling, key, value));
        for (const [key] of attributesToRemove){
            writer.removeAttribute(key, child);
            wasChanged = true;
        }
    }
    return wasChanged;
}
/**
* Returns `true` if the given node has the same attribute as the one provided in the parameters.
*/ function $c871651c8276dc61$var$hasSameAttribute(node, key, value) {
    return node?.getAttribute(key) === value;
}






/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module block-quote/blockquotecommand
*/ /**
* The block quote command plugin.
*
* @extends module:core/command~Command
*/ var $bf98a02724d3a932$export$9491e851eb091ab6 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command. When the command {@link #value is on}, all top-most block quotes within
	* the selection will be removed. If it is off, all selected blocks will be wrapped with
	* a block quote.
	*
	* @fires execute
	* @param options Command options.
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply a block quote,
	* otherwise the command will remove the block quote. If not set, the command will act basing on its current value.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = options.forceValue === void 0 ? !this.value : options.forceValue;
        model.change((writer)=>{
            if (!value) this._removeQuote(writer, blocks.filter($bf98a02724d3a932$var$findQuote));
            else {
                const blocksToQuote = blocks.filter((block)=>{
                    return $bf98a02724d3a932$var$findQuote(block) || $bf98a02724d3a932$var$checkCanBeQuoted(schema, block);
                });
                this._applyQuote(writer, blocksToQuote);
            }
        });
    }
    /**
	* Checks the command's {@link #value}.
	*/ _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        return !!(firstBlock && $bf98a02724d3a932$var$findQuote(firstBlock));
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        if (this.value) return true;
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if (!firstBlock) return false;
        return $bf98a02724d3a932$var$checkCanBeQuoted(schema, firstBlock);
    }
    /**
	* Removes the quote from given blocks.
	*
	* If blocks which are supposed to be "unquoted" are in the middle of a quote,
	* start it or end it, then the quote will be split (if needed) and the blocks
	* will be moved out of it, so other quoted blocks remained quoted.
	*/ _removeQuote(writer, blocks) {
        $bf98a02724d3a932$var$getRangesOfBlockGroups(writer, blocks).reverse().forEach((groupRange)=>{
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) writer.split(groupRange.end);
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    /**
	* Applies the quote to given blocks.
	*/ _applyQuote(writer, blocks) {
        const quotesToMerge = [];
        $bf98a02724d3a932$var$getRangesOfBlockGroups(writer, blocks).reverse().forEach((groupRange)=>{
            let quote = $bf98a02724d3a932$var$findQuote(groupRange.start);
            if (!quote) {
                quote = writer.createElement("blockQuote");
                writer.wrap(groupRange, quote);
            }
            quotesToMerge.push(quote);
        });
        quotesToMerge.reverse().reduce((currentQuote, nextQuote)=>{
            if (currentQuote.nextSibling == nextQuote) {
                writer.merge(writer.createPositionAfter(currentQuote));
                return currentQuote;
            }
            return nextQuote;
        });
    }
};
function $bf98a02724d3a932$var$findQuote(elementOrPosition) {
    return elementOrPosition.parent.name == "blockQuote" ? elementOrPosition.parent : null;
}
/**
* Returns a minimal array of ranges containing groups of subsequent blocks.
*
* content:         abcdefgh
* blocks:          [ a, b, d, f, g, h ]
* output ranges:   [ab]c[d]e[fgh]
*/ function $bf98a02724d3a932$var$getRangesOfBlockGroups(writer, blocks) {
    let startPosition;
    let i = 0;
    const ranges = [];
    while(i < blocks.length){
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) startPosition = writer.createPositionBefore(block);
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
/**
* Checks whether <bQ> can wrap the block.
*/ function $bf98a02724d3a932$var$checkCanBeQuoted(schema, block) {
    const parentContext = schema.createContext(block.parent);
    if (!schema.checkChild(parentContext, "blockQuote")) return false;
    if (!schema.checkChild(parentContext.push("blockQuote"), block)) return false;
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module block-quote/blockquoteediting
*/ /**
* The block quote editing.
*
* Introduces the `'blockQuote'` command and the `'blockQuote'` model element.
*
* @extends module:core/plugin~Plugin
*/ var $bf98a02724d3a932$export$9423b03e1c6f4657 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BlockQuoteEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        editor.commands.add("blockQuote", new $bf98a02724d3a932$export$9491e851eb091ab6(editor));
        schema.register("blockQuote", {
            inheritAllFrom: "$container"
        });
        editor.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
        });
        editor.model.document.registerPostFixer((writer)=>{
            const changes = editor.model.document.differ.getChanges();
            for (const entry of changes)if (entry.type == "insert") {
                const element = entry.position.nodeAfter;
                if (!element) continue;
                if (element.is("element", "blockQuote") && element.isEmpty) {
                    writer.remove(element);
                    return true;
                } else if (element.is("element", "blockQuote") && !schema.checkChild(entry.position, element)) {
                    writer.unwrap(element);
                    return true;
                } else if (element.is("element")) {
                    const range = writer.createRangeIn(element);
                    for (const child of range.getItems())if (child.is("element", "blockQuote") && !schema.checkChild(writer.createPositionBefore(child), child)) {
                        writer.unwrap(child);
                        return true;
                    }
                }
            } else if (entry.type == "remove") {
                const parent = entry.position.parent;
                if (parent.is("element", "blockQuote") && parent.isEmpty) {
                    writer.remove(parent);
                    return true;
                }
            }
            return false;
        });
        const viewDocument = this.editor.editing.view.document;
        const selection = editor.model.document.selection;
        const blockQuoteCommand = editor.commands.get("blockQuote");
        this.listenTo(viewDocument, "enter", (evt, data)=>{
            if (!selection.isCollapsed || !blockQuoteCommand.value) return;
            if (selection.getLastPosition().parent.isEmpty) {
                editor.execute("blockQuote");
                editor.editing.view.scrollToTheSelection();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "blockquote"
        });
        this.listenTo(viewDocument, "delete", (evt, data)=>{
            if (data.direction != "backward" || !selection.isCollapsed || !blockQuoteCommand.value) return;
            const positionParent = selection.getLastPosition().parent;
            if (positionParent.isEmpty && !positionParent.previousSibling) {
                editor.execute("blockQuote");
                editor.editing.view.scrollToTheSelection();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "blockquote"
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module block-quote/blockquoteui
*/ /**
* The block quote UI plugin.
*
* It introduces the `'blockQuote'` button.
*
* @extends module:core/plugin~Plugin
*/ var $bf98a02724d3a932$export$7e0a916db7f236d6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BlockQuoteUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("blockQuote", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:blockQuote", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
            buttonView.set({
                role: "menuitemcheckbox"
            });
            return buttonView;
        });
    }
    /**
	* Creates a button for block quote command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("blockQuote");
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Block quote"),
            icon: (0, $e8dc502aba5ac3f5$export$2478ed0e296e2752),
            isToggleable: true
        });
        view.bind("isEnabled").to(command, "isEnabled");
        view.bind("isOn").to(command, "value");
        this.listenTo(view, "execute", ()=>{
            editor.execute("blockQuote");
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module block-quote/blockquote
*/ /**
* The block quote plugin.
*
* For more information about this feature check the {@glink api/block-quote package page}.
*
* This is a "glue" plugin which loads the {@link module:block-quote/blockquoteediting~BlockQuoteEditing block quote editing feature}
* and {@link module:block-quote/blockquoteui~BlockQuoteUI block quote UI feature}.
*
* @extends module:core/plugin~Plugin
*/ var $bf98a02724d3a932$export$181f102f0a3746b9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $bf98a02724d3a932$export$9423b03e1c6f4657,
            $bf98a02724d3a932$export$7e0a916db7f236d6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BlockQuote";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 







/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/highlightstack
*/ const $5547ab21e02f1e9e$var$WidgetHighlightStackBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* Class used to handle the correct order of highlights on elements.
*
* When different highlights are applied to same element the correct order should be preserved:
*
* * highlight with highest priority should be applied,
* * if two highlights have same priority - sort by CSS class provided in
* {@link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor}.
*
* This way, highlight will be applied with the same rules it is applied on texts.
*/ var $5547ab21e02f1e9e$export$d65a654c8aa35a18 = class extends $5547ab21e02f1e9e$var$WidgetHighlightStackBase {
    _stack = [];
    /**
	* Adds highlight descriptor to the stack.
	*
	* @fires change:top
	*/ add(descriptor, writer) {
        const stack = this._stack;
        const oldTop = stack[0];
        this._insertDescriptor(descriptor);
        const newTop = stack[0];
        if (oldTop !== newTop && !$5547ab21e02f1e9e$var$compareDescriptors(oldTop, newTop)) this.fire("change:top", {
            oldDescriptor: oldTop,
            newDescriptor: newTop,
            writer: writer
        });
    }
    /**
	* Removes highlight descriptor from the stack.
	*
	* @fires change:top
	* @param id Id of the descriptor to remove.
	*/ remove(id, writer) {
        const stack = this._stack;
        const oldTop = stack[0];
        this._removeDescriptor(id);
        const newTop = stack[0];
        if (oldTop !== newTop && !$5547ab21e02f1e9e$var$compareDescriptors(oldTop, newTop)) this.fire("change:top", {
            oldDescriptor: oldTop,
            newDescriptor: newTop,
            writer: writer
        });
    }
    /**
	* Inserts a given descriptor in correct place in the stack. It also takes care about updating information
	* when descriptor with same id is already present.
	*/ _insertDescriptor(descriptor) {
        const stack = this._stack;
        const index = stack.findIndex((item)=>item.id === descriptor.id);
        if ($5547ab21e02f1e9e$var$compareDescriptors(descriptor, stack[index])) return;
        if (index > -1) stack.splice(index, 1);
        let i = 0;
        while(stack[i] && $5547ab21e02f1e9e$var$shouldABeBeforeB(stack[i], descriptor))i++;
        stack.splice(i, 0, descriptor);
    }
    /**
	* Removes descriptor with given id from the stack.
	*
	* @param id Descriptor's id.
	*/ _removeDescriptor(id) {
        const stack = this._stack;
        const index = stack.findIndex((item)=>item.id === id);
        if (index > -1) stack.splice(index, 1);
    }
};
/**
* Compares two descriptors by checking their priority and class list.
*
* @returns Returns true if both descriptors are defined and have same priority and classes.
*/ function $5547ab21e02f1e9e$var$compareDescriptors(a, b) {
    return a && b && a.priority == b.priority && $5547ab21e02f1e9e$var$classesToString(a.classes) == $5547ab21e02f1e9e$var$classesToString(b.classes);
}
/**
* Checks whenever first descriptor should be placed in the stack before second one.
*/ function $5547ab21e02f1e9e$var$shouldABeBeforeB(a, b) {
    if (a.priority > b.priority) return true;
    else if (a.priority < b.priority) return false;
    return $5547ab21e02f1e9e$var$classesToString(a.classes) > $5547ab21e02f1e9e$var$classesToString(b.classes);
}
/**
* Converts CSS classes passed with {@link module:engine/conversion/downcasthelpers~DowncastHighlightDescriptor} to
* sorted string.
*/ function $5547ab21e02f1e9e$var$classesToString(classes) {
    return Array.isArray(classes) ? classes.sort().join(",") : classes;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/utils
*/ /**
* CSS class added to each widget element.
*/ const $5547ab21e02f1e9e$export$5cb2748b3e9b9b4a = "ck-widget";
/**
* CSS class added to currently selected widget element.
*/ const $5547ab21e02f1e9e$export$530df57e72ade019 = "ck-widget_selected";
/**
* Returns `true` if given {@link module:engine/view/node~ViewNode} is an {@link module:engine/view/element~ViewElement} and a widget.
*/ function $5547ab21e02f1e9e$export$33101d01ca587c36(node) {
    if (!node.is("element")) return false;
    return !!node.getCustomProperty("widget");
}
/**
* Converts the given {@link module:engine/view/element~ViewElement} to a widget in the following way:
*
* * sets the `contenteditable` attribute to `"false"`,
* * adds the `ck-widget` CSS class,
* * adds a custom {@link module:engine/view/element~ViewElement#getFillerOffset `getFillerOffset()`} method returning `null`,
* * adds a custom property allowing to recognize widget elements by using {@link ~isWidget `isWidget()`},
* * implements the {@link ~setHighlightHandling view highlight on widgets}.
*
* This function needs to be used in conjunction with
* {@link module:engine/conversion/downcasthelpers~DowncastHelpers downcast conversion helpers}
* like {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToElement `elementToElement()`}.
* Moreover, typically you will want to use `toWidget()` only for `editingDowncast`, while keeping the `dataDowncast` clean.
*
* For example, in order to convert a `<widget>` model element to `<div class="widget">` in the view, you can define
* such converters:
*
* ```ts
* editor.conversion.for( 'editingDowncast' )
* 	.elementToElement( {
* 		model: 'widget',
* 		view: ( modelItem, { writer } ) => {
* 			const div = writer.createContainerElement( 'div', { class: 'widget' } );
*
* 			return toWidget( div, writer, { label: 'some widget' } );
* 		}
* 	} );
*
* editor.conversion.for( 'dataDowncast' )
* 	.elementToElement( {
* 		model: 'widget',
* 		view: ( modelItem, { writer } ) => {
* 			return writer.createContainerElement( 'div', { class: 'widget' } );
* 		}
* 	} );
* ```
*
* See the full source code of the widget (with a nested editable) schema definition and converters in
* [this sample](https://github.com/ckeditor/ckeditor5-widget/blob/master/tests/manual/widget-with-nestededitable.js).
*
* @param options Additional options.
* @param options.label Element's label provided to the {@link ~setLabel} function. It can be passed as
* a plain string or a function returning a string. It represents the widget for assistive technologies (like screen readers).
* @param options.hasSelectionHandle If `true`, the widget will have a selection handle added.
* @returns Returns the same element.
*/ function $5547ab21e02f1e9e$export$83925c2318996255(element, writer, options = {}) {
    if (!element.is("containerElement")) /**
	* The element passed to `toWidget()` must be a {@link module:engine/view/containerelement~ViewContainerElement}
	* instance.
	*
	* @error widget-to-widget-wrong-element-type
	* @param {any} element The view element passed to `toWidget()`.
	*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("widget-to-widget-wrong-element-type", null, {
        element: element
    });
    writer.setAttribute("contenteditable", "false", element);
    writer.addClass($5547ab21e02f1e9e$export$5cb2748b3e9b9b4a, element);
    writer.setCustomProperty("widget", true, element);
    element.getFillerOffset = $5547ab21e02f1e9e$var$getFillerOffset;
    writer.setCustomProperty("widgetLabel", [], element);
    if (options.label) $5547ab21e02f1e9e$export$4f65e594f6031297(element, options.label);
    if (options.hasSelectionHandle) $5547ab21e02f1e9e$var$addSelectionHandle(element, writer);
    $5547ab21e02f1e9e$export$f1c5d3cd160a812b(element, writer);
    return element;
}
/**
* Default handler for adding a highlight on a widget.
* It adds CSS class and attributes basing on the given highlight descriptor.
*/ function $5547ab21e02f1e9e$var$addHighlight(element, descriptor, writer) {
    if (descriptor.classes) writer.addClass((0, $c7bc2cb7e2db0227$export$45b10814cc054894)(descriptor.classes), element);
    if (descriptor.attributes) for(const key in descriptor.attributes)writer.setAttribute(key, descriptor.attributes[key], element);
}
/**
* Default handler for removing a highlight from a widget.
* It removes CSS class and attributes basing on the given highlight descriptor.
*/ function $5547ab21e02f1e9e$var$removeHighlight(element, descriptor, writer) {
    if (descriptor.classes) writer.removeClass((0, $c7bc2cb7e2db0227$export$45b10814cc054894)(descriptor.classes), element);
    if (descriptor.attributes) for(const key in descriptor.attributes)writer.removeAttribute(key, element);
}
/**
* Sets highlight handling methods. Uses {@link module:widget/highlightstack~WidgetHighlightStack} to
* properly determine which highlight descriptor should be used at given time.
*/ function $5547ab21e02f1e9e$export$f1c5d3cd160a812b(element, writer, add = $5547ab21e02f1e9e$var$addHighlight, remove = $5547ab21e02f1e9e$var$removeHighlight) {
    const stack = new $5547ab21e02f1e9e$export$d65a654c8aa35a18();
    stack.on("change:top", (evt, data)=>{
        if (data.oldDescriptor) remove(element, data.oldDescriptor, data.writer);
        if (data.newDescriptor) add(element, data.newDescriptor, data.writer);
    });
    const addHighlightCallback = (element, descriptor, writer)=>stack.add(descriptor, writer);
    const removeHighlightCallback = (element, id, writer)=>stack.remove(id, writer);
    writer.setCustomProperty("addHighlight", addHighlightCallback, element);
    writer.setCustomProperty("removeHighlight", removeHighlightCallback, element);
}
/**
* Sets label for given element.
* It can be passed as a plain string or a function returning a string. Function will be called each time label is retrieved by
* {@link ~getLabel `getLabel()`}.
*/ function $5547ab21e02f1e9e$export$4f65e594f6031297(element, labelOrCreator) {
    element.getCustomProperty("widgetLabel").push(labelOrCreator);
}
/**
* Returns the label of the provided element.
*/ function $5547ab21e02f1e9e$export$236350842f3cd9bc(element) {
    return element.getCustomProperty("widgetLabel").reduce((prev, current)=>{
        if (typeof current === "function") return prev ? prev + ". " + current() : current();
        else return prev ? prev + ". " + current : current;
    }, "");
}
/**
* Adds functionality to the provided {@link module:engine/view/editableelement~ViewEditableElement} to act as a widget's editable:
*
* * sets the `contenteditable` attribute to `true` when
* {@link module:engine/view/editableelement~ViewEditableElement#isReadOnly} is `false`,
* otherwise sets it to `false`,
* * adds the `ck-editor__editable` and `ck-editor__nested-editable` CSS classes,
* * adds the `ck-editor__nested-editable_focused` CSS class when the editable is focused and removes it when it is blurred.
* * implements the {@link ~setHighlightHandling view highlight on widget's editable}.
* * sets the `role` attribute to `textbox` for accessibility purposes.
*
* Similarly to {@link ~toWidget `toWidget()`} this function should be used in `editingDowncast` only and it is usually
* used together with {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToElement `elementToElement()`}.
*
* For example, in order to convert a `<nested>` model element to `<div class="nested">` in the view, you can define
* such converters:
*
* ```ts
* editor.conversion.for( 'editingDowncast' )
* 	.elementToElement( {
* 		model: 'nested',
* 		view: ( modelItem, { writer } ) => {
* 			const div = writer.createEditableElement( 'div', { class: 'nested' } );
*
* 			return toWidgetEditable( nested, writer, { label: 'label for editable' } );
* 		}
* 	} );
*
* editor.conversion.for( 'dataDowncast' )
* 	.elementToElement( {
* 		model: 'nested',
* 		view: ( modelItem, { writer } ) => {
* 			return writer.createContainerElement( 'div', { class: 'nested' } );
* 		}
* 	} );
* ```
*
* See the full source code of the widget (with nested editable) schema definition and converters in
* [this sample](https://github.com/ckeditor/ckeditor5-widget/blob/master/tests/manual/widget-with-nestededitable.js).
*
* @param options Additional options.
* @param options.label Editable's label used by assistive technologies (e.g. screen readers).
* @param options.withAriaRole Whether to add the role="textbox" attribute on the editable. Defaults to `true`.
* @returns Returns the same element that was provided in the `editable` parameter
*/ function $5547ab21e02f1e9e$export$f2153e4522f49b8e(editable, writer, options = {}) {
    writer.addClass([
        "ck-editor__editable",
        "ck-editor__nested-editable"
    ], editable);
    if (options.withAriaRole !== false) writer.setAttribute("role", "textbox", editable);
    if (!editable.isReadOnly) writer.setAttribute("tabindex", "-1", editable);
    if (options.label) writer.setAttribute("aria-label", options.label, editable);
    writer.setAttribute("contenteditable", editable.isReadOnly ? "false" : "true", editable);
    editable.on("change:isReadOnly", (evt, property, isReadonly)=>{
        writer.setAttribute("contenteditable", isReadonly ? "false" : "true", editable);
        if (isReadonly) writer.removeAttribute("tabindex", editable);
        else writer.setAttribute("tabindex", "-1", editable);
    });
    editable.on("change:isFocused", (evt, property, is)=>{
        if (is) writer.addClass("ck-editor__nested-editable_focused", editable);
        else writer.removeClass("ck-editor__nested-editable_focused", editable);
    });
    $5547ab21e02f1e9e$export$f1c5d3cd160a812b(editable, writer);
    return editable;
}
/**
* Returns a model range which is optimal (in terms of UX) for inserting a widget block.
*
* For instance, if a selection is in the middle of a paragraph, the collapsed range before this paragraph
* will be returned so that it is not split. If the selection is at the end of a paragraph,
* the collapsed range after this paragraph will be returned.
*
* Note: If the selection is placed in an empty block, the range in that block will be returned. If that range
* is then passed to {@link module:engine/model/model~Model#insertContent}, the block will be fully replaced
* by the inserted widget block.
*
* @param selection The selection based on which the insertion position should be calculated.
* @param model Model instance.
* @returns The optimal range.
*/ function $5547ab21e02f1e9e$export$d03cbafb1cb45bb(selection, model) {
    const selectedElement = selection.getSelectedElement();
    if (selectedElement) {
        const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(selection);
        if (typeAroundFakeCaretPosition) return model.createRange(model.createPositionAt(selectedElement, typeAroundFakeCaretPosition));
    }
    return model.schema.findOptimalInsertionRange(selection);
}
/**
* A util to be used in order to map view positions to correct model positions when implementing a widget
* which renders non-empty view element for an empty model element.
*
* For example:
*
* ```
* // Model:
* <placeholder type="name"></placeholder>
*
* // View:
* <span class="placeholder">name</span>
* ```
*
* In such case, view positions inside `<span>` cannot be correctly mapped to the model (because the model element is empty).
* To handle mapping positions inside `<span class="placeholder">` to the model use this util as follows:
*
* ```ts
* editor.editing.mapper.on(
* 	'viewToModelPosition',
* 	viewToModelPositionOutsideModelElement( model, viewElement => viewElement.hasClass( 'placeholder' ) )
* );
* ```
*
* The callback will try to map the view offset of selection to an expected model position.
*
* 1. When the position is at the end (or in the middle) of the inline widget:
*
* ```
* // View:
* <p>foo <span class="placeholder">name|</span> bar</p>
*
* // Model:
* <paragraph>foo <placeholder type="name"></placeholder>| bar</paragraph>
* ```
*
* 2. When the position is at the beginning of the inline widget:
*
* ```
* // View:
* <p>foo <span class="placeholder">|name</span> bar</p>
*
* // Model:
* <paragraph>foo |<placeholder type="name"></placeholder> bar</paragraph>
* ```
*
* @param model Model instance on which the callback operates.
* @param viewElementMatcher Function that is passed a view element and should return `true` if the custom mapping
* should be applied to the given view element.
*/ function $5547ab21e02f1e9e$export$e01ba404d5efe794(model, viewElementMatcher) {
    return (evt, data)=>{
        const { mapper: mapper, viewPosition: viewPosition } = data;
        const viewParent = mapper.findMappedViewAncestor(viewPosition);
        if (!viewElementMatcher(viewParent)) return;
        const modelParent = mapper.toModelElement(viewParent);
        data.modelPosition = model.createPositionAt(modelParent, viewPosition.isAtStart ? "before" : "after");
    };
}
/**
* Default filler offset function applied to all widget elements.
*/ function $5547ab21e02f1e9e$var$getFillerOffset() {
    return null;
}
/**
* Adds a drag handle to the widget.
*/ function $5547ab21e02f1e9e$var$addSelectionHandle(widgetElement, writer) {
    const selectionHandle = writer.createUIElement("div", {
        class: "ck ck-widget__selection-handle"
    }, function(domDocument) {
        const domElement = this.toDomElement(domDocument);
        const icon = new (0, $29fd27cb9bdab9d2$export$212c60ac61334981)();
        icon.set("content", (0, $e8dc502aba5ac3f5$export$da3a225fdca174e1));
        icon.render();
        domElement.appendChild(icon.element);
        return domElement;
    });
    writer.insert(writer.createPositionAt(widgetElement, 0), selectionHandle);
    writer.addClass([
        "ck-widget_with-selection-handle"
    ], widgetElement);
}
/**
* Starting from a DOM resize host element (an element that receives dimensions as a result of resizing),
* this helper returns the width of the found ancestor element.
*
*	* It searches up to 5 levels of ancestors only.
*
* The search crosses shadow DOM boundaries, so for a resize host inside a shadow root it continues
* through the host into the surrounding (light) DOM instead of stopping at the boundary.
*
* @param domResizeHost Resize host DOM element that receives dimensions as a result of resizing.
* @returns Width of ancestor element in pixels or 0 if no ancestor with a computed width has been found.
*/ function $5547ab21e02f1e9e$export$6ec49425c093db63(domResizeHost) {
    const getElementComputedWidth = (element)=>{
        const { width: width, paddingLeft: paddingLeft, paddingRight: paddingRight } = element.ownerDocument.defaultView.getComputedStyle(element);
        return parseFloat(width) - (parseFloat(paddingLeft) || 0) - (parseFloat(paddingRight) || 0);
    };
    const domResizeHostParent = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(domResizeHost);
    if (!domResizeHostParent) return 0;
    let parentWidth = getElementComputedWidth(domResizeHostParent);
    const ancestorLevelLimit = 5;
    let currentLevel = 0;
    let checkedElement = domResizeHostParent;
    while(isNaN(parentWidth)){
        checkedElement = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(checkedElement);
        if (++currentLevel > ancestorLevelLimit) return 0;
        parentWidth = getElementComputedWidth(checkedElement);
    }
    return parentWidth;
}
/**
* Calculates a relative width of a `domResizeHost` compared to its ancestor in percents.
*
* @param domResizeHost Resize host DOM element.
* @returns Percentage value between 0 and 100.
*/ function $5547ab21e02f1e9e$export$cdbfddbf190d7f9c(domResizeHost, resizeHostRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domResizeHost)) {
    const parentWidth = $5547ab21e02f1e9e$export$6ec49425c093db63(domResizeHost);
    if (!parentWidth) return 0;
    return resizeHostRect.width / parentWidth * 100;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgettypearound/utils
*/ /**
* The name of the type around model selection attribute responsible for
* displaying a fake caret next to a selected widget.
*
* @internal
*/ const $5547ab21e02f1e9e$export$c96090de6dab4a7d = "widget-type-around";
/**
* Checks if an element is a widget that qualifies to get the widget type around UI.
*/ function $5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(viewElement, modelElement, schema) {
    return !!viewElement && $5547ab21e02f1e9e$export$33101d01ca587c36(viewElement) && !schema.isInline(modelElement);
}
/**
* For the passed HTML element, this helper finds the closest widget type around button ancestor.
*
* @internal
*/ function $5547ab21e02f1e9e$export$32e63e9f51bea494(domElement) {
    return domElement.closest(".ck-widget__type-around__button");
}
/**
* For the passed widget type around button element, this helper determines at which position
* the paragraph would be inserted into the content if, for instance, the button was
* clicked by the user.
*
* @internal
* @returns The position of the button.
*/ function $5547ab21e02f1e9e$export$c82859d45fbaa19d(domElement) {
    return domElement.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
}
/**
* For the passed HTML element, this helper returns the closest view widget ancestor.
*
* @internal
*/ function $5547ab21e02f1e9e$export$af5b778f11026790(domElement, domConverter) {
    const widgetDomElement = domElement.closest(".ck-widget");
    return domConverter.mapDomToView(widgetDomElement);
}
/**
* For the passed selection instance, it returns the position of the fake caret displayed next to a widget.
*
* **Note**: If the fake caret is not currently displayed, `null` is returned.
*
* @internal
* @returns The position of the fake caret or `null` when none is present.
*/ function $5547ab21e02f1e9e$export$6421c3137f413d40(selection) {
    return selection.getAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
}
/**
* Looks for the `copyOnEnter` text formatting attributes (e.g. bold, font color) carried by the last piece
* of inline content on the sibling that directly precedes a run of one or more consecutive block widgets.
*
* Used when the user inserts a new paragraph next to a widget (e.g. an image or a table) via the type-around
* UI: the new, empty paragraph should continue whatever formatting was active right before the widget,
* instead of starting unformatted:
*
* ```
* <paragraph><$text bold="true">Bar</$text></paragraph><imageBlock></imageBlock>
* ```
*
* Only the attributes carried by the *last* inline child of that sibling are considered - whatever precedes
* it doesn't matter, because it's the last piece of content that reflects what the user was typing right
* before reaching the widget:
*
* ```
* // "bold" IS recovered here: "Bar", the last child, is bold. "Foo" not being bold is irrelevant.
* <paragraph>Foo<$text bold="true">Bar</$text></paragraph><imageBlock></imageBlock>
* ```
*
* If there is more than one widget in a row, the search continues past all of them until a sibling with
* actual content (or the boundary of the parent) is found:
*
* ```
* <paragraph><$text bold="true">Bar</$text></paragraph><imageBlock></imageBlock><imageBlock></imageBlock>
* ```
*
* @param schema Model's schema.
* @param widgetElement The widget model element.
* @internal
*/ function $5547ab21e02f1e9e$var$getCopyOnEnterTextAttributesBeforeWidgets(schema, widgetElement) {
    let sibling = widgetElement;
    while(sibling && sibling.is("element") && schema.isObject(sibling))sibling = sibling.previousSibling;
    if (!sibling?.is("element")) return [];
    if (sibling.isEmpty) {
        const selectionAttributes = $5547ab21e02f1e9e$var$extractStoredSelectionAttributes(sibling.getAttributes());
        return Array.from((0, $c871651c8276dc61$export$b1d719019e4bdf35)(schema, selectionAttributes));
    }
    const lastChild = sibling.getChild(sibling.childCount - 1);
    if (!schema.isInline(lastChild)) return [];
    return Array.from((0, $c871651c8276dc61$export$b1d719019e4bdf35)(schema, lastChild.getAttributes()));
}
/**
* Extracts the selection attributes stored on an empty block.
*/ function* $5547ab21e02f1e9e$var$extractStoredSelectionAttributes(iterator) {
    for (const [attributeKey, attributeValue] of iterator){
        if (!(0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._isStoreAttributeKey(attributeKey)) continue;
        yield [
            (0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._dropStoreAttributeKeyPrefix(attributeKey),
            attributeValue
        ];
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgettypearound/widgettypearound
*/ const $5547ab21e02f1e9e$var$POSSIBLE_INSERTION_POSITIONS = [
    "before",
    "after"
];
const $5547ab21e02f1e9e$var$RETURN_ARROW_ICON_ELEMENT = new DOMParser().parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)((0, $e8dc502aba5ac3f5$export$2fae954303ecc7ac)), "image/svg+xml").firstChild;
const $5547ab21e02f1e9e$var$PLUGIN_DISABLED_EDITING_ROOT_CLASS = "ck-widget__type-around_disabled";
/**
* A plugin that allows users to type around widgets where normally it is impossible to place the caret due
* to limitations of web browsers. These "tight spots" occur, for instance, before (or after) a widget being
* the first (or last) child of its parent or between two block widgets.
*
* This plugin extends the {@link module:widget/widget~Widget `Widget`} plugin and injects the user interface
* with two buttons into each widget instance in the editor. Each of the buttons can be clicked by the
* user if the widget is next to the "tight spot". Once clicked, a paragraph is created with the selection anchored
* in it so that users can type (or insert content, paste, etc.) straight away.
*/ var $5547ab21e02f1e9e$export$8bc340fe234703a0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A reference to the model widget element that has the fake caret active
	* on either side of it. It is later used to remove CSS classes associated with the fake caret
	* when the widget no longer needs it.
	*/ _currentFakeCaretModelElement = null;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "WidgetTypeAround";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        this.on("change:isEnabled", (evt, data, isEnabled)=>{
            editingView.change((writer)=>{
                for (const root of editingView.document.roots)if (isEnabled) writer.removeClass($5547ab21e02f1e9e$var$PLUGIN_DISABLED_EDITING_ROOT_CLASS, root);
                else writer.addClass($5547ab21e02f1e9e$var$PLUGIN_DISABLED_EDITING_ROOT_CLASS, root);
            });
            if (!isEnabled) editor.model.change((writer)=>{
                writer.removeSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
            });
        });
        this._enableTypeAroundUIInjection();
        this._enableInsertingParagraphsOnButtonClick();
        this._enableInsertingParagraphsOnEnterKeypress();
        this._enableInsertingParagraphsOnTypingKeystroke();
        this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows();
        this._enableDeleteIntegration();
        this._enableInsertContentIntegration();
        this._enableInsertObjectIntegration();
        this._enableDeleteContentIntegration();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._currentFakeCaretModelElement = null;
    }
    /**
	* Inserts a new paragraph next to a widget element with the selection anchored in it.
	*
	* **Note**: This method is heavily user-oriented and will both focus the editing view and scroll
	* the viewport to the selection in the inserted paragraph.
	*
	* @param widgetModelElement The model widget element next to which a paragraph is inserted.
	* @param position The position where the paragraph is inserted. Either `'before'` or `'after'` the widget.
	*/ _insertParagraph(widgetModelElement, position) {
        const editor = this.editor;
        const { model: model } = editor;
        const { schema: schema } = model;
        const editingView = editor.editing.view;
        const attributesToCopy = schema.getAttributesWithProperty(widgetModelElement, "copyOnReplace", true);
        const selectionAttributes = $5547ab21e02f1e9e$var$getCopyOnEnterTextAttributesBeforeWidgets(schema, widgetModelElement);
        model.change((writer)=>{
            if (editor.execute("insertParagraph", {
                position: editor.model.createPositionAt(widgetModelElement, position),
                attributes: attributesToCopy
            })) writer.setSelectionAttribute(selectionAttributes);
        });
        editingView.focus();
        editingView.scrollToTheSelection();
    }
    /**
	* A wrapper for the {@link module:utils/emittermixin~Emitter#listenTo} method that executes the callbacks only
	* when the plugin {@link #isEnabled is enabled}.
	*
	* @param emitter The object that fires the event.
	* @param event The name of the event.
	* @param callback The function to be called on event.
	* @param options Additional options.
	*/ _listenToIfEnabled(emitter, event, callback, options) {
        this.listenTo(emitter, event, (...args)=>{
            if (this.isEnabled) callback(...args);
        }, options);
    }
    /**
	* Similar to {@link #_insertParagraph}, this method inserts a paragraph except that it
	* does not expect a position. Instead, it performs the insertion next to a selected widget
	* according to the `widget-type-around` model selection attribute value (fake caret position).
	*
	* Because this method requires the `widget-type-around` attribute to be set,
	* the insertion can only happen when the widget's fake caret is active (e.g. activated
	* using the keyboard).
	*
	* @returns Returns `true` when the paragraph was inserted (the attribute was present) and `false` otherwise.
	*/ _insertParagraphAccordingToFakeCaretPosition() {
        const modelSelection = this.editor.model.document.selection;
        const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(modelSelection);
        if (!typeAroundFakeCaretPosition) return false;
        const selectedModelElement = modelSelection.getSelectedElement();
        this._insertParagraph(selectedModelElement, typeAroundFakeCaretPosition);
        return true;
    }
    /**
	* Creates a listener in the editing conversion pipeline that injects the widget type around
	* UI into every single widget instance created in the editor.
	*
	* The UI is delivered as a {@link module:engine/view/uielement~ViewUIElement}
	* wrapper which renders DOM buttons that users can use to insert paragraphs.
	*/ _enableTypeAroundUIInjection() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const t = editor.locale.t;
        const buttonTitles = {
            before: t("Insert paragraph before block"),
            after: t("Insert paragraph after block")
        };
        editor.editing.downcastDispatcher.on("insert", (evt, data, conversionApi)=>{
            const viewElement = conversionApi.mapper.toViewElement(data.item);
            if (!viewElement) return;
            if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(viewElement, data.item, schema)) {
                $5547ab21e02f1e9e$var$injectUIIntoWidget(conversionApi.writer, buttonTitles, viewElement);
                viewElement.getCustomProperty("widgetLabel").push(()=>{
                    return this.isEnabled ? t("Press Enter to type after or press Shift + Enter to type before the widget") : "";
                });
            }
        }, {
            priority: "low"
        });
    }
    /**
	* Brings support for the fake caret that appears when either:
	*
	* * the selection moves to a widget from a position next to it using arrow keys,
	* * the arrow key is pressed when the widget is already selected.
	*
	* The fake caret lets the user know that they can start typing or just press
	* <kbd>Enter</kbd> to insert a paragraph at the position next to a widget as suggested by the fake caret.
	*
	* The fake caret disappears when the user changes the selection or the editor
	* gets blurred.
	*
	* The whole idea is as follows:
	*
	* 1. A user does one of the 2 scenarios described at the beginning.
	* 2. The "keydown" listener is executed and the decision is made whether to show or hide the fake caret.
	* 3. If it should show up, the `widget-type-around` model selection attribute is set indicating
	*    on which side of the widget it should appear.
	* 4. The selection dispatcher reacts to the selection attribute and sets CSS classes responsible for the
	*    fake caret on the view widget.
	* 5. If the fake caret should disappear, the selection attribute is removed and the dispatcher
	*    does the CSS class clean-up in the view.
	* 6. Additionally, `change:range` and `FocusTracker#isFocused` listeners also remove the selection
	*    attribute (the former also removes widget CSS classes).
	*/ _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
        const editor = this.editor;
        const model = editor.model;
        const modelSelection = model.document.selection;
        const schema = model.schema;
        const editingView = editor.editing.view;
        this._listenToIfEnabled(editingView.document, "arrowKey", (evt, domEventData)=>{
            this._handleArrowKeyPress(evt, domEventData);
        }, {
            context: [
                $5547ab21e02f1e9e$export$33101d01ca587c36,
                "$text"
            ],
            priority: "high"
        });
        this._listenToIfEnabled(modelSelection, "change:range", (evt, data)=>{
            if (!data.directChange) return;
            editor.model.change((writer)=>{
                writer.removeSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
            });
        });
        this._listenToIfEnabled(model.document, "change:data", ()=>{
            const selectedModelElement = modelSelection.getSelectedElement();
            if (selectedModelElement) {
                const selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);
                if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(selectedViewElement, selectedModelElement, schema)) return;
            }
            editor.model.change((writer)=>{
                writer.removeSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
            });
        });
        this._listenToIfEnabled(editor.editing.downcastDispatcher, "selection", (evt, data, conversionApi)=>{
            const writer = conversionApi.writer;
            if (this._currentFakeCaretModelElement) {
                const selectedViewElement = conversionApi.mapper.toViewElement(this._currentFakeCaretModelElement);
                if (selectedViewElement) {
                    writer.removeClass($5547ab21e02f1e9e$var$POSSIBLE_INSERTION_POSITIONS.map(positionToWidgetCssClass), selectedViewElement);
                    this._currentFakeCaretModelElement = null;
                }
            }
            const selectedModelElement = data.selection.getSelectedElement();
            if (!selectedModelElement) return;
            const selectedViewElement = conversionApi.mapper.toViewElement(selectedModelElement);
            if (!$5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(selectedViewElement, selectedModelElement, schema)) return;
            const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(data.selection);
            if (!typeAroundFakeCaretPosition) return;
            writer.addClass(positionToWidgetCssClass(typeAroundFakeCaretPosition), selectedViewElement);
            this._currentFakeCaretModelElement = selectedModelElement;
        });
        this._listenToIfEnabled(editor.ui.focusTracker, "change:isFocused", (evt, name, isFocused)=>{
            if (!isFocused) editor.model.change((writer)=>{
                writer.removeSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
            });
        });
        function positionToWidgetCssClass(position) {
            return `ck-widget_type-around_show-fake-caret_${position}`;
        }
    }
    /**
	* A listener executed on each "keydown" in the view document, a part of
	* {@link #_enableTypeAroundFakeCaretActivationUsingKeyboardArrows}.
	*
	* It decides whether the arrow keypress should activate the fake caret or not (also whether it should
	* be deactivated).
	*
	* The fake caret activation is done by setting the `widget-type-around` model selection attribute
	* in this listener, and stopping and preventing the event that would normally be handled by the widget
	* plugin that is responsible for the regular keyboard navigation near/across all widgets (that
	* includes inline widgets, which are ignored by the widget type around plugin).
	*/ _handleArrowKeyPress(evt, domEventData) {
        const editor = this.editor;
        const model = editor.model;
        const modelSelection = model.document.selection;
        const schema = model.schema;
        const editingView = editor.editing.view;
        if (domEventData.shiftKey) return;
        const keyCode = domEventData.keyCode;
        const isForward = (0, $c7bc2cb7e2db0227$export$5fc5d3db3d467e64)(keyCode, editor.locale.contentLanguageDirection);
        const selectedViewElement = editingView.document.selection.getSelectedElement();
        const selectedModelElement = editor.editing.mapper.toModelElement(selectedViewElement);
        let shouldStopAndPreventDefault;
        /* v8 ignore else -- @preserve */ if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(selectedViewElement, selectedModelElement, schema)) shouldStopAndPreventDefault = this._handleArrowKeyPressOnSelectedWidget(isForward);
        else if (modelSelection.isCollapsed) shouldStopAndPreventDefault = this._handleArrowKeyPressWhenSelectionNextToAWidget(isForward);
        else if (!domEventData.shiftKey) shouldStopAndPreventDefault = this._handleArrowKeyPressWhenNonCollapsedSelection(isForward);
        if (shouldStopAndPreventDefault) {
            domEventData.preventDefault();
            evt.stop();
        }
    }
    /**
	* Handles the keyboard navigation on "keydown" when a widget is currently selected and activates or deactivates
	* the fake caret for that widget, depending on the current value of the `widget-type-around` model
	* selection attribute and the direction of the pressed arrow key.
	*
	* @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
	* as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
	* @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
	* process the event any further. Returns `false` otherwise.
	*/ _handleArrowKeyPressOnSelectedWidget(isForward) {
        const model = this.editor.model;
        const modelSelection = model.document.selection;
        const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(modelSelection);
        return model.change((writer)=>{
            if (typeAroundFakeCaretPosition) {
                if (!(typeAroundFakeCaretPosition === (isForward ? "after" : "before"))) {
                    writer.removeSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d);
                    return true;
                }
            } else {
                writer.setSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d, isForward ? "after" : "before");
                return true;
            }
            return false;
        });
    }
    /**
	* Handles the keyboard navigation on "keydown" when **no** widget is selected but the selection is **directly** next
	* to one and upon the fake caret should become active for this widget upon arrow keypress
	* (AKA entering/selecting the widget).
	*
	* **Note**: This code mirrors the implementation from the widget plugin but also adds the selection attribute.
	* Unfortunately, there is no safe way to let the widget plugin do the selection part first and then just set the
	* selection attribute here in the widget type around plugin. This is why this code must duplicate some from the widget plugin.
	*
	* @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
	* as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
	* @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
	* process the event any further. Returns `false` otherwise.
	*/ _handleArrowKeyPressWhenSelectionNextToAWidget(isForward) {
        const editor = this.editor;
        const model = editor.model;
        const schema = model.schema;
        const widgetPlugin = editor.plugins.get("Widget");
        const modelElementNextToSelection = widgetPlugin._getObjectElementNextToSelection(isForward);
        const viewElementNextToSelection = editor.editing.mapper.toViewElement(modelElementNextToSelection);
        if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(viewElementNextToSelection, modelElementNextToSelection, schema)) {
            model.change((writer)=>{
                widgetPlugin._setSelectionOverElement(modelElementNextToSelection);
                writer.setSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d, isForward ? "before" : "after");
            });
            return true;
        }
        return false;
    }
    /**
	* Handles the keyboard navigation on "keydown" when a widget is currently selected (together with some other content)
	* and the widget is the first or last element in the selection. It activates or deactivates the fake caret for that widget.
	*
	* @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
	* as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
	* @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
	* process the event any further. Returns `false` otherwise.
	*/ _handleArrowKeyPressWhenNonCollapsedSelection(isForward) {
        const editor = this.editor;
        const model = editor.model;
        const schema = model.schema;
        const mapper = editor.editing.mapper;
        const modelSelection = model.document.selection;
        const selectedModelNode = isForward ? modelSelection.getLastPosition().nodeBefore : modelSelection.getFirstPosition().nodeAfter;
        const selectedViewNode = mapper.toViewElement(selectedModelNode);
        if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(selectedViewNode, selectedModelNode, schema)) {
            model.change((writer)=>{
                writer.setSelection(selectedModelNode, "on");
                writer.setSelectionAttribute($5547ab21e02f1e9e$export$c96090de6dab4a7d, isForward ? "after" : "before");
            });
            return true;
        }
        return false;
    }
    /**
	* Registers a `mousedown` listener for the view document which intercepts events
	* coming from the widget type around UI, which happens when a user clicks one of the buttons
	* that insert a paragraph next to a widget.
	*/ _enableInsertingParagraphsOnButtonClick() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        this._listenToIfEnabled(editingView.document, "mousedown", (evt, domEventData)=>{
            const button = $5547ab21e02f1e9e$export$32e63e9f51bea494(domEventData.domTarget);
            if (!button) return;
            const buttonPosition = $5547ab21e02f1e9e$export$c82859d45fbaa19d(button);
            const widgetViewElement = $5547ab21e02f1e9e$export$af5b778f11026790(button, editingView.domConverter);
            const widgetModelElement = editor.editing.mapper.toModelElement(widgetViewElement);
            this._insertParagraph(widgetModelElement, buttonPosition);
            domEventData.preventDefault();
            evt.stop();
        });
    }
    /**
	* Creates the <kbd>Enter</kbd> key listener on the view document that allows the user to insert a paragraph
	* near the widget when either:
	*
	* * The fake caret was first activated using the arrow keys,
	* * The entire widget is selected in the model.
	*
	* In the first case, the new paragraph is inserted according to the `widget-type-around` selection
	* attribute (see {@link #_handleArrowKeyPress}).
	*
	* In the second case, the new paragraph is inserted based on whether a soft (<kbd>Shift</kbd>+<kbd>Enter</kbd>) keystroke
	* was pressed or not.
	*/ _enableInsertingParagraphsOnEnterKeypress() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const editingView = editor.editing.view;
        this._listenToIfEnabled(editingView.document, "enter", (evt, domEventData)=>{
            if (evt.eventPhase != "atTarget") return;
            const selectedModelElement = selection.getSelectedElement();
            const selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);
            const schema = editor.model.schema;
            let wasHandled;
            if (this._insertParagraphAccordingToFakeCaretPosition()) wasHandled = true;
            else if ($5547ab21e02f1e9e$export$4c8d7dcf8ddc7d53(selectedViewElement, selectedModelElement, schema)) {
                this._insertParagraph(selectedModelElement, domEventData.isSoft ? "before" : "after");
                wasHandled = true;
            }
            if (wasHandled) {
                domEventData.preventDefault();
                evt.stop();
            }
        }, {
            context: $5547ab21e02f1e9e$export$33101d01ca587c36
        });
    }
    /**
	* Similar to the {@link #_enableInsertingParagraphsOnEnterKeypress}, it allows the user
	* to insert a paragraph next to a widget when the fake caret was activated using arrow
	* keys but it responds to typing instead of <kbd>Enter</kbd>.
	*
	* Listener enabled by this method will insert a new paragraph according to the `widget-type-around`
	* model selection attribute as the user simply starts typing, which creates the impression that the fake caret
	* behaves like a real one rendered by the browser (AKA your text appears where the caret was).
	*
	* **Note**: At the moment this listener creates 2 undo steps: one for the `insertParagraph` command
	* and another one for actual typing. It is not a disaster but this may need to be fixed
	* sooner or later.
	*/ _enableInsertingParagraphsOnTypingKeystroke() {
        const viewDocument = this.editor.editing.view.document;
        this._listenToIfEnabled(viewDocument, "insertText", (evt, data)=>{
            if (this._insertParagraphAccordingToFakeCaretPosition()) data.selection = viewDocument.selection;
        }, {
            priority: "high"
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this._listenToIfEnabled(viewDocument, "keydown", (evt, data)=>{
            if (data.keyCode == 229) this._insertParagraphAccordingToFakeCaretPosition();
        });
        else this._listenToIfEnabled(viewDocument, "compositionstart", ()=>{
            this._insertParagraphAccordingToFakeCaretPosition();
        }, {
            priority: "highest"
        });
    }
    /**
	* It creates a "delete" event listener on the view document to handle cases when the <kbd>Delete</kbd> or <kbd>Backspace</kbd>
	* is pressed and the fake caret is currently active.
	*
	* The fake caret should create an illusion of a real browser caret so that when it appears before or after
	* a widget, pressing <kbd>Delete</kbd> or <kbd>Backspace</kbd> should remove a widget or delete the content
	* before or after a widget (depending on the content surrounding the widget).
	*/ _enableDeleteIntegration() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const model = editor.model;
        const schema = model.schema;
        this._listenToIfEnabled(editingView.document, "delete", (evt, domEventData)=>{
            if (evt.eventPhase != "atTarget") return;
            const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(model.document.selection);
            if (!typeAroundFakeCaretPosition) return;
            const direction = domEventData.direction;
            const selectedModelWidget = model.document.selection.getSelectedElement();
            const isFakeCaretBefore = typeAroundFakeCaretPosition === "before";
            const isDeleteForward = direction == "forward";
            if (isFakeCaretBefore === isDeleteForward) editor.execute("delete", {
                selection: model.createSelection(selectedModelWidget, "on")
            });
            else {
                const range = schema.getNearestSelectionRange(model.createPositionAt(selectedModelWidget, typeAroundFakeCaretPosition), direction);
                if (range) {
                    if (!range.isCollapsed) model.change((writer)=>{
                        writer.setSelection(range);
                        editor.execute(isDeleteForward ? "deleteForward" : "delete");
                    });
                    else {
                        const probe = model.createSelection(range.start);
                        model.modifySelection(probe, {
                            direction: direction
                        });
                        if (!probe.focus.isEqual(range.start)) model.change((writer)=>{
                            writer.setSelection(range);
                            editor.execute(isDeleteForward ? "deleteForward" : "delete");
                        });
                        else {
                            const deepestEmptyRangeAncestor = $5547ab21e02f1e9e$var$getDeepestEmptyElementAncestor(schema, range.start.parent);
                            model.deleteContent(model.createSelection(deepestEmptyRangeAncestor, "on"), {
                                doNotAutoparagraph: true
                            });
                        }
                    }
                }
            }
            domEventData.preventDefault();
            evt.stop();
        }, {
            context: $5547ab21e02f1e9e$export$33101d01ca587c36
        });
    }
    /**
	* Attaches the {@link module:engine/model/model~Model#event:insertContent} event listener that, for instance, allows the user to paste
	* content near a widget when the fake caret is first activated using the arrow keys.
	*
	* The content is inserted according to the `widget-type-around` selection attribute (see {@link #_handleArrowKeyPress}).
	*/ _enableInsertContentIntegration() {
        const editor = this.editor;
        const model = this.editor.model;
        const documentSelection = model.document.selection;
        this._listenToIfEnabled(editor.model, "insertContent", (evt, [content, selectable])=>{
            if (selectable && !selectable.is("documentSelection")) return;
            const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(documentSelection);
            if (!typeAroundFakeCaretPosition) return;
            evt.stop();
            return model.change((writer)=>{
                const selectedElement = documentSelection.getSelectedElement();
                const position = model.createPositionAt(selectedElement, typeAroundFakeCaretPosition);
                const selection = writer.createSelection(position);
                const result = model.insertContent(content, selection);
                writer.setSelection(selection);
                return result;
            });
        }, {
            priority: "high"
        });
    }
    /**
	* Attaches the {@link module:engine/model/model~Model#event:insertObject} event listener that modifies the
	* `options.findOptimalPosition`parameter to position of fake caret in relation to selected element
	* to reflect user's intent of desired insertion position.
	*
	* The object is inserted according to the `widget-type-around` selection attribute (see {@link #_handleArrowKeyPress}).
	*/ _enableInsertObjectIntegration() {
        const editor = this.editor;
        const documentSelection = this.editor.model.document.selection;
        this._listenToIfEnabled(editor.model, "insertObject", (evt, args)=>{
            const [, selectable, options = {}] = args;
            if (selectable && !selectable.is("documentSelection")) return;
            const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(documentSelection);
            if (!typeAroundFakeCaretPosition) return;
            options.findOptimalPosition = typeAroundFakeCaretPosition;
            args[3] = options;
        }, {
            priority: "high"
        });
    }
    /**
	* Attaches the {@link module:engine/model/model~Model#event:deleteContent} event listener to block the event when the fake
	* caret is active.
	*
	* This is required for cases that trigger {@link module:engine/model/model~Model#deleteContent `model.deleteContent()`}
	* before calling {@link module:engine/model/model~Model#insertContent `model.insertContent()`} like, for instance,
	* plain text pasting.
	*/ _enableDeleteContentIntegration() {
        const editor = this.editor;
        const documentSelection = this.editor.model.document.selection;
        this._listenToIfEnabled(editor.model, "deleteContent", (evt, [selection])=>{
            if (selection && !selection.is("documentSelection")) return;
            if ($5547ab21e02f1e9e$export$6421c3137f413d40(documentSelection)) evt.stop();
        }, {
            priority: "high"
        });
    }
};
/**
* Injects the type around UI into a view widget instance.
*/ function $5547ab21e02f1e9e$var$injectUIIntoWidget(viewWriter, buttonTitles, widgetViewElement) {
    const typeAroundWrapper = viewWriter.createUIElement("div", {
        class: "ck ck-reset_all ck-widget__type-around"
    }, function(domDocument) {
        const wrapperDomElement = this.toDomElement(domDocument);
        $5547ab21e02f1e9e$var$injectButtons(wrapperDomElement, buttonTitles);
        $5547ab21e02f1e9e$var$injectFakeCaret(wrapperDomElement);
        return wrapperDomElement;
    });
    viewWriter.insert(viewWriter.createPositionAt(widgetViewElement, "end"), typeAroundWrapper);
}
/**
* FYI: Not using the IconView class because each instance would need to be destroyed to avoid memory leaks
* and it's pretty hard to figure out when a view (widget) is gone for good so it's cheaper to use raw
* <svg> here.
*/ function $5547ab21e02f1e9e$var$injectButtons(wrapperDomElement, buttonTitles) {
    for (const position of $5547ab21e02f1e9e$var$POSSIBLE_INSERTION_POSITIONS){
        const buttonTemplate = new (0, $29fd27cb9bdab9d2$export$14416b8d99d47caa)({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-widget__type-around__button",
                    `ck-widget__type-around__button_${position}`
                ],
                title: buttonTitles[position],
                "aria-hidden": "true"
            },
            children: [
                wrapperDomElement.ownerDocument.importNode($5547ab21e02f1e9e$var$RETURN_ARROW_ICON_ELEMENT, true)
            ]
        });
        wrapperDomElement.appendChild(buttonTemplate.render());
    }
}
function $5547ab21e02f1e9e$var$injectFakeCaret(wrapperDomElement) {
    const caretTemplate = new (0, $29fd27cb9bdab9d2$export$14416b8d99d47caa)({
        tag: "div",
        attributes: {
            class: [
                "ck",
                "ck-widget__type-around__fake-caret"
            ]
        }
    });
    wrapperDomElement.appendChild(caretTemplate.render());
}
/**
* Returns the ancestor of an element closest to the root which is empty. For instance,
* for `<baz>`:
*
* ```
* <foo>abc<bar><baz></baz></bar></foo>
* ```
*
* it returns `<bar>`.
*/ function $5547ab21e02f1e9e$var$getDeepestEmptyElementAncestor(schema, element) {
    let deepestEmptyAncestor = element;
    for (const ancestor of element.getAncestors({
        parentFirst: true
    })){
        if (ancestor.childCount > 1 || schema.isLimit(ancestor)) break;
        deepestEmptyAncestor = ancestor;
    }
    return deepestEmptyAncestor;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/verticalnavigation
*/ /**
* Returns 'keydown' handler for up/down arrow keys that modifies the caret movement if it's in a text line next to an object.
*
* @param editing The editing controller.
*/ function $5547ab21e02f1e9e$export$fdff979f63c3b029(editing) {
    const model = editing.model;
    return (evt, data)=>{
        const arrowUpPressed = data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowup;
        const arrowDownPressed = data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowdown;
        const expandSelection = data.shiftKey;
        const selection = model.document.selection;
        if (!arrowUpPressed && !arrowDownPressed) return;
        const isForward = arrowDownPressed;
        const range = $5547ab21e02f1e9e$var$findTextRangeFromSelection(editing, selection, isForward);
        if (!range) return;
        if (range.isCollapsed) {
            if (selection.isCollapsed) return;
            else if (expandSelection) return;
        }
        if (range.isCollapsed || $5547ab21e02f1e9e$var$isSingleLineRange(editing, range, isForward)) {
            model.change((writer)=>{
                const newPosition = isForward ? range.end : range.start;
                if (expandSelection) {
                    const newSelection = model.createSelection(selection.anchor);
                    newSelection.setFocus(newPosition);
                    writer.setSelection(newSelection);
                } else writer.setSelection(newPosition);
            });
            evt.stop();
            data.preventDefault();
            data.stopPropagation();
        }
    };
}
/**
* Finds the range between selection and closest limit element (in the direction of navigation).
* The position next to limit element is adjusted to the closest allowed `$text` position.
*
* Returns `null` if, according to the schema, the resulting range cannot contain a `$text` element.
*
* @param editing The editing controller.
* @param selection The current selection.
* @param isForward The expected navigation direction.
*/ function $5547ab21e02f1e9e$var$findTextRangeFromSelection(editing, selection, isForward) {
    const model = editing.model;
    if (isForward) {
        const startPosition = selection.focus;
        const endPosition = $5547ab21e02f1e9e$var$getNearestNonInlineLimit(model, startPosition, "forward");
        if (!endPosition) return;
        const range = model.createRange(startPosition, endPosition);
        const lastRangePosition = $5547ab21e02f1e9e$var$getNearestTextPosition(model.schema, range, "backward");
        /* v8 ignore else -- @preserve */ if (lastRangePosition) return model.createRange(startPosition, lastRangePosition);
    } else {
        const endPosition = selection.focus;
        const startPosition = $5547ab21e02f1e9e$var$getNearestNonInlineLimit(model, endPosition, "backward");
        if (!startPosition) return;
        const range = model.createRange(startPosition, endPosition);
        const firstRangePosition = $5547ab21e02f1e9e$var$getNearestTextPosition(model.schema, range, "forward");
        /* v8 ignore else -- @preserve */ if (firstRangePosition) return model.createRange(firstRangePosition, endPosition);
    }
}
/**
* Finds the limit element position that is closest to startPosition.
*
* @param direction Search direction.
*/ function $5547ab21e02f1e9e$var$getNearestNonInlineLimit(model, startPosition, direction) {
    const schema = model.schema;
    const range = model.createRangeIn(startPosition.root);
    const walkerValueType = direction == "forward" ? "elementStart" : "elementEnd";
    for (const { previousPosition: previousPosition, item: item, type: type } of range.getWalker({
        startPosition: startPosition,
        direction: direction
    })){
        if (schema.isLimit(item) && !schema.isInline(item)) return previousPosition;
        if (type == walkerValueType && schema.isBlock(item)) return null;
    }
    return null;
}
/**
* Basing on the provided range, finds the first or last (depending on `direction`) position inside the range
* that can contain `$text` (according to schema).
*
* @param schema The schema.
* @param range The range to find the position in.
* @param direction Search direction.
* @returns The nearest selection position.
*
*/ function $5547ab21e02f1e9e$var$getNearestTextPosition(schema, range, direction) {
    const position = direction == "backward" ? range.end : range.start;
    if (schema.checkChild(position, "$text")) return position;
    for (const { nextPosition: nextPosition } of range.getWalker({
        direction: direction
    }))if (schema.checkChild(nextPosition, "$text")) return nextPosition;
}
/**
* Checks if the DOM range corresponding to the provided model range renders as a single line by analyzing DOMRects
* (verifying if they visually wrap content to the next line).
*
* @param editing The editing controller.
* @param modelRange The current table cell content range.
* @param isForward The expected navigation direction.
*/ function $5547ab21e02f1e9e$var$isSingleLineRange(editing, modelRange, isForward) {
    const model = editing.model;
    const domConverter = editing.view.domConverter;
    if (isForward) {
        const probe = model.createSelection(modelRange.start);
        model.modifySelection(probe);
        if (!probe.focus.isAtEnd && !modelRange.start.isEqual(probe.focus)) modelRange = model.createRange(probe.focus, modelRange.end);
    }
    const viewRange = editing.mapper.toViewRange(modelRange);
    const domRange = domConverter.viewRangeToDom(viewRange);
    const rects = (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d).getDomRangeRects(domRange);
    let boundaryVerticalPosition;
    for (const rect of rects){
        if (boundaryVerticalPosition === void 0) {
            boundaryVerticalPosition = Math.round(rect.bottom);
            continue;
        }
        if (Math.round(rect.top) >= boundaryVerticalPosition) return false;
        boundaryVerticalPosition = Math.max(boundaryVerticalPosition, Math.round(rect.bottom));
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widget
*/ /**
* The widget plugin. It enables base support for widgets.
*
* See {@glink api/widget package page} for more details and documentation.
*
* This plugin enables multiple behaviors required by widgets:
*
* * The model to view selection converter for the editing pipeline (it handles widget custom selection rendering).
* If a converted selection wraps around a widget element, that selection is marked as
* {@link module:engine/view/selection~ViewSelection#isFake fake}. Additionally, the `ck-widget_selected` CSS class
* is added to indicate that widget has been selected.
* * The mouse and keyboard events handling on and around widget elements.
*/ var $5547ab21e02f1e9e$export$a829527ff4e4114a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Holds previously selected widgets.
	*/ _previouslySelected = /* @__PURE__ */ new Set();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Widget";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $5547ab21e02f1e9e$export$8bc340fe234703a0,
            (0, $f1defb5a0a139b4c$export$bfadae053a633538)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const t = editor.t;
        this.editor.editing.downcastDispatcher.on("selection", (evt, data, conversionApi)=>{
            const viewWriter = conversionApi.writer;
            const modelSelection = data.selection;
            if (modelSelection.isCollapsed) return;
            const selectedModelElement = modelSelection.getSelectedElement();
            if (!selectedModelElement) return;
            const selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);
            if (!$5547ab21e02f1e9e$export$33101d01ca587c36(selectedViewElement)) return;
            if (!conversionApi.consumable.consume(modelSelection, "selection")) return;
            viewWriter.setSelection(viewWriter.createRangeOn(selectedViewElement), {
                fake: true,
                label: $5547ab21e02f1e9e$export$236350842f3cd9bc(selectedViewElement)
            });
        });
        this.editor.editing.downcastDispatcher.on("selection", (evt, data, conversionApi)=>{
            this._clearPreviouslySelectedWidgets(conversionApi.writer);
            const viewWriter = conversionApi.writer;
            const viewSelection = viewWriter.document.selection;
            let lastMarked = null;
            for (const range of viewSelection.getRanges())for (const value of range){
                const node = value.item;
                if ($5547ab21e02f1e9e$export$33101d01ca587c36(node) && !$5547ab21e02f1e9e$var$isChild(node, lastMarked)) {
                    viewWriter.addClass($5547ab21e02f1e9e$export$530df57e72ade019, node);
                    this._previouslySelected.add(node);
                    lastMarked = node;
                }
            }
        }, {
            priority: "low"
        });
        view.addObserver((0, $b9b9f2bdf9c6137f$export$7bb344c59ad5b029));
        view.addObserver((0, $b9b9f2bdf9c6137f$export$6b46599a2e720b2));
        this.listenTo(viewDocument, "mousedown", (...args)=>this._onMousedown(...args));
        this.listenTo(viewDocument, "pointerdown", (...args)=>this._onPointerdown(...args));
        this.listenTo(viewDocument, "arrowKey", (...args)=>{
            this._handleSelectionChangeOnArrowKeyPress(...args);
        }, {
            context: [
                $5547ab21e02f1e9e$export$33101d01ca587c36,
                "$text"
            ]
        });
        this.listenTo(viewDocument, "arrowKey", (...args)=>{
            this._preventDefaultOnArrowKeyPress(...args);
        }, {
            context: "$root"
        });
        this.listenTo(viewDocument, "arrowKey", $5547ab21e02f1e9e$export$fdff979f63c3b029(this.editor.editing), {
            context: "$text"
        });
        this.listenTo(viewDocument, "delete", (evt, data)=>{
            if (this._handleDelete(data.direction == "forward")) {
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "$root"
        });
        this.listenTo(viewDocument, "tab", (evt, data)=>{
            if (this._selectNextEditable(data.shiftKey ? "backward" : "forward")) {
                view.scrollToTheSelection();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: (node)=>$5547ab21e02f1e9e$export$33101d01ca587c36(node) || node.is("editableElement"),
            priority: "low"
        });
        this.listenTo(viewDocument, "keydown", (evt, data)=>{
            if (data.keystroke != (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).esc) return;
            if (this._selectAncestorWidget()) {
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: (node)=>node.is("editableElement"),
            priority: "low"
        });
        editor.accessibility.addKeystrokeInfoGroup({
            id: "widget",
            label: t("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
            keystrokes: [
                {
                    label: t("Move focus from an editable area back to the parent widget"),
                    keystroke: "Esc"
                },
                {
                    label: t("Insert a new paragraph directly after a widget"),
                    keystroke: "Enter"
                },
                {
                    label: t("Insert a new paragraph directly before a widget"),
                    keystroke: "Shift+Enter"
                },
                {
                    label: t("Move the caret to allow typing directly before a widget"),
                    keystroke: [
                        [
                            "arrowup"
                        ],
                        [
                            "arrowleft"
                        ]
                    ]
                },
                {
                    label: t("Move the caret to allow typing directly after a widget"),
                    keystroke: [
                        [
                            "arrowdown"
                        ],
                        [
                            "arrowright"
                        ]
                    ]
                }
            ]
        });
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:mousedown mousedown} events on widget elements.
	*/ _onMousedown(eventInfo, domEventData) {
        const element = domEventData.target;
        if (!element) return;
        if (domEventData.domEvent.detail >= 3) {
            if (this._selectBlockContent(element)) domEventData.preventDefault();
        }
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:pointerdown pointerdown} events on widget elements.
	*/ _onPointerdown(eventInfo, domEventData) {
        if (!domEventData.domEvent.isPrimary) return;
        if ($5547ab21e02f1e9e$export$32e63e9f51bea494(domEventData.domTarget)) return;
        const editor = this.editor;
        const view = editor.editing.view;
        const viewDocument = view.document;
        let element = domEventData.target;
        if (!element) return;
        if (!$5547ab21e02f1e9e$export$33101d01ca587c36(element)) {
            const editableOrWidgetElement = $5547ab21e02f1e9e$var$findClosestEditableOrWidgetAncestor(element);
            if (!editableOrWidgetElement) return;
            if ($5547ab21e02f1e9e$export$33101d01ca587c36(editableOrWidgetElement)) element = editableOrWidgetElement;
            else {
                const clickTargetFromPoint = $5547ab21e02f1e9e$var$getElementFromMouseEvent(editor, domEventData);
                if (clickTargetFromPoint && $5547ab21e02f1e9e$export$33101d01ca587c36(clickTargetFromPoint)) element = clickTargetFromPoint;
                else return;
            }
        }
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid || (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS) domEventData.preventDefault();
        if (!viewDocument.isFocused) view.focus();
        const modelElement = editor.editing.mapper.toModelElement(element);
        this._setSelectionOverElement(modelElement);
    }
    /**
	* Selects entire block content, e.g. on triple click it selects entire paragraph.
	*/ _selectBlockContent(element) {
        const editor = this.editor;
        const model = editor.model;
        const mapper = editor.editing.mapper;
        const schema = model.schema;
        const viewElement = mapper.findMappedViewAncestor(this.editor.editing.view.createPositionAt(element, 0));
        const modelElement = $5547ab21e02f1e9e$var$findTextBlockAncestor(mapper.toModelElement(viewElement), model.schema);
        if (!modelElement) return false;
        model.change((writer)=>{
            const nextTextBlock = !schema.isLimit(modelElement) ? $5547ab21e02f1e9e$var$findNextTextBlock(writer.createPositionAfter(modelElement), schema) : null;
            const start = writer.createPositionAt(modelElement, 0);
            const end = nextTextBlock ? writer.createPositionAt(nextTextBlock, 0) : writer.createPositionAt(modelElement, "end");
            writer.setSelection(writer.createRange(start, end));
        });
        return true;
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:keydown keydown} events and changes
	* the model selection when:
	*
	* * arrow key is pressed when the widget is selected,
	* * the selection is next to a widget and the widget should become selected upon the arrow key press.
	*
	* See {@link #_preventDefaultOnArrowKeyPress}.
	*/ _handleSelectionChangeOnArrowKeyPress(eventInfo, domEventData) {
        const keyCode = domEventData.keyCode;
        const model = this.editor.model;
        const schema = model.schema;
        const modelSelection = model.document.selection;
        const selectedElement = modelSelection.getSelectedElement();
        const direction = (0, $c7bc2cb7e2db0227$export$ad185f2969a88a73)(keyCode, this.editor.locale.contentLanguageDirection);
        const isForward = direction == "down" || direction == "right";
        const isVerticalNavigation = direction == "up" || direction == "down";
        if (!domEventData.shiftKey && !modelSelection.isCollapsed) {
            if ($5547ab21e02f1e9e$var$hasObjectAtEdge(modelSelection, schema)) {
                const position = isForward ? modelSelection.getLastPosition() : modelSelection.getFirstPosition();
                const newRange = schema.getNearestSelectionRange(position, isForward ? "forward" : "backward");
                if (newRange) {
                    model.change((writer)=>{
                        writer.setSelection(newRange);
                    });
                    domEventData.preventDefault();
                    eventInfo.stop();
                }
            }
            return;
        }
        const originalSelection = $5547ab21e02f1e9e$var$getModelSelectionAdjusted(model, isForward);
        const probe = model.createSelection(originalSelection);
        model.modifySelection(probe, {
            direction: isForward ? "forward" : "backward"
        });
        if (probe.isEqual(originalSelection)) return;
        if (probe.focus.isTouching(originalSelection.focus) && schema.checkChild(probe.focus.parent, "$text") && (isForward ? !probe.focus.isAtEnd : !probe.focus.isAtStart)) model.modifySelection(probe, {
            direction: isForward ? "forward" : "backward"
        });
        const lastSelectedNode = isForward ? originalSelection.focus.nodeBefore : originalSelection.focus.nodeAfter;
        const nodeBeforeProbe = probe.focus.nodeBefore;
        const nodeAfterProbe = probe.focus.nodeAfter;
        const lastProbeNode = isForward ? nodeBeforeProbe : nodeAfterProbe;
        if (domEventData.shiftKey) {
            if (selectedElement && schema.isObject(selectedElement) || lastProbeNode && schema.isObject(lastProbeNode) || lastSelectedNode && schema.isObject(lastSelectedNode)) {
                model.change((writer)=>{
                    writer.setSelection(probe);
                });
                domEventData.preventDefault();
                eventInfo.stop();
            }
        } else if (lastProbeNode && schema.isObject(lastProbeNode)) {
            if (schema.isInline(lastProbeNode) && isVerticalNavigation) return;
            model.change((writer)=>{
                writer.setSelection(lastProbeNode, "on");
            });
            domEventData.preventDefault();
            eventInfo.stop();
        }
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:keydown keydown} events and prevents
	* the default browser behavior to make sure the fake selection is not being moved from a fake selection
	* container.
	*
	* See {@link #_handleSelectionChangeOnArrowKeyPress}.
	*/ _preventDefaultOnArrowKeyPress(eventInfo, domEventData) {
        const model = this.editor.model;
        const schema = model.schema;
        const objectElement = model.document.selection.getSelectedElement();
        if (objectElement && schema.isObject(objectElement)) {
            domEventData.preventDefault();
            eventInfo.stop();
        }
    }
    /**
	* Handles delete keys: backspace and delete.
	*
	* @param isForward Set to true if delete was performed in forward direction.
	* @returns Returns `true` if keys were handled correctly.
	*/ _handleDelete(isForward) {
        const modelSelection = this.editor.model.document.selection;
        if (!this.editor.model.canEditAt(modelSelection)) return;
        if (!modelSelection.isCollapsed) return;
        const objectElement = this._getObjectElementNextToSelection(isForward);
        if (objectElement) {
            this.editor.model.change((writer)=>{
                let previousNode = modelSelection.anchor.parent;
                while(previousNode.isEmpty){
                    const nodeToRemove = previousNode;
                    previousNode = nodeToRemove.parent;
                    writer.remove(nodeToRemove);
                }
                this._setSelectionOverElement(objectElement);
            });
            return true;
        }
    }
    /**
	* Sets {@link module:engine/model/selection~ModelSelection document's selection} over given element.
	*
	* @internal
	*/ _setSelectionOverElement(element) {
        this.editor.model.change((writer)=>{
            writer.setSelection(writer.createRangeOn(element));
        });
    }
    /**
	* Checks if {@link module:engine/model/element~ModelElement element} placed next to the current
	* {@link module:engine/model/selection~ModelSelection model selection} exists and is marked in
	* {@link module:engine/model/schema~ModelSchema schema} as `object`.
	*
	* @internal
	* @param forward Direction of checking.
	*/ _getObjectElementNextToSelection(forward) {
        const model = this.editor.model;
        const schema = model.schema;
        const modelSelection = model.document.selection;
        const probe = model.createSelection(modelSelection);
        model.modifySelection(probe, {
            direction: forward ? "forward" : "backward"
        });
        if (probe.isEqual(modelSelection)) return null;
        const objectElement = forward ? probe.focus.nodeBefore : probe.focus.nodeAfter;
        if (objectElement && schema.isObject(objectElement)) return objectElement;
        return null;
    }
    /**
	* Removes CSS class from previously selected widgets.
	*/ _clearPreviouslySelectedWidgets(writer) {
        for (const widget of this._previouslySelected)writer.removeClass($5547ab21e02f1e9e$export$530df57e72ade019, widget);
        this._previouslySelected.clear();
    }
    /**
	* Moves the document selection into the next editable or block widget.
	*/ _selectNextEditable(direction) {
        const editing = this.editor.editing;
        const view = editing.view;
        const model = this.editor.model;
        const viewSelection = view.document.selection;
        const modelSelection = model.document.selection;
        let startPosition;
        if (modelSelection.rangeCount > 1) {
            const selectionRange = modelSelection.isBackward ? modelSelection.getFirstRange() : modelSelection.getLastRange();
            startPosition = editing.mapper.toViewPosition(direction == "forward" ? selectionRange.end : selectionRange.start);
        } else startPosition = direction == "forward" ? viewSelection.getFirstPosition() : viewSelection.getLastPosition();
        const modelRange = this._findNextFocusRange(startPosition, direction);
        if (modelRange) {
            model.change((writer)=>{
                writer.setSelection(modelRange);
            });
            return true;
        }
        return false;
    }
    /**
	* Looks for next focus point in the document starting from the given view position and direction.
	* The focus point is either a block widget or an editable.
	*
	* @internal
	*/ _findNextFocusRange(startPosition, direction) {
        const editing = this.editor.editing;
        const view = editing.view;
        const model = this.editor.model;
        const viewSelection = view.document.selection;
        const editableElement = viewSelection.editableElement;
        const editablePath = editableElement.getPath();
        let selectedElement = viewSelection.getSelectedElement();
        if (selectedElement && !$5547ab21e02f1e9e$export$33101d01ca587c36(selectedElement)) selectedElement = null;
        const viewRange = direction == "forward" ? view.createRange(startPosition, view.createPositionAt(startPosition.root, "end")) : view.createRange(view.createPositionAt(startPosition.root, 0), startPosition);
        for (const { nextPosition: nextPosition } of viewRange.getWalker({
            direction: direction
        })){
            const item = nextPosition.parent;
            if ($5547ab21e02f1e9e$export$33101d01ca587c36(item) && item != selectedElement) {
                const modelElement = editing.mapper.toModelElement(item);
                if (!model.schema.isBlock(modelElement)) continue;
                if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(editablePath, item.getPath()) != "extension") return model.createRangeOn(modelElement);
            } else if (item.is("editableElement")) {
                if (item == editableElement && !selectedElement) continue;
                const modelPosition = editing.mapper.toModelPosition(nextPosition);
                const newRange = model.schema.getNearestSelectionRange(modelPosition, direction);
                if (!newRange) continue;
                if (item == editableElement && selectedElement) return newRange;
                if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(editablePath, item.getPath()) != "extension") return model.createRangeIn(model.schema.getLimitElement(newRange));
                return newRange;
            }
        }
        return null;
    }
    /**
	* Updates the document selection so that it selects first ancestor widget.
	*/ _selectAncestorWidget() {
        const editor = this.editor;
        const mapper = editor.editing.mapper;
        const positionParent = editor.editing.view.document.selection.getFirstPosition().parent;
        const viewElement = (positionParent.is("$text") ? positionParent.parent : positionParent).findAncestor($5547ab21e02f1e9e$export$33101d01ca587c36);
        if (!viewElement) return false;
        const modelElement = mapper.toModelElement(viewElement);
        if (!modelElement) return false;
        editor.model.change((writer)=>{
            writer.setSelection(modelElement, "on");
        });
        return true;
    }
};
/**
* Returns true if there is an object on an edge of the given selection.
*/ function $5547ab21e02f1e9e$var$hasObjectAtEdge(modelSelection, schema) {
    const firstPosition = modelSelection.getFirstPosition();
    const lastPosition = modelSelection.getLastPosition();
    const firstSelectedNode = firstPosition.nodeAfter;
    const lastSelectedNode = lastPosition.nodeBefore;
    return !!firstSelectedNode && schema.isObject(firstSelectedNode) || !!lastSelectedNode && schema.isObject(lastSelectedNode);
}
/**
* Returns new instance of the model selection adjusted for fake caret and selection direction on widgets.
*/ function $5547ab21e02f1e9e$var$getModelSelectionAdjusted(model, isForward) {
    const modelSelection = model.document.selection;
    const selectedElement = modelSelection.getSelectedElement();
    const typeAroundFakeCaretPosition = $5547ab21e02f1e9e$export$6421c3137f413d40(modelSelection);
    if (selectedElement && typeAroundFakeCaretPosition == "before") return model.createSelection(selectedElement, "before");
    else if (selectedElement && typeAroundFakeCaretPosition == "after") return model.createSelection(selectedElement, "after");
    return model.createSelection(modelSelection.getRanges(), {
        backward: !!selectedElement && model.schema.isObject(selectedElement) ? !isForward : modelSelection.isBackward
    });
}
/**
* Finds the closest ancestor element that is either an editable element or a widget.
*
* @param element The element from which to start searching.
* @returns The closest ancestor element that is either an editable element or a widget, or null if none is found.
*/ function $5547ab21e02f1e9e$var$findClosestEditableOrWidgetAncestor(element) {
    let currentElement = element;
    while(currentElement){
        if (currentElement.is("editableElement") || $5547ab21e02f1e9e$export$33101d01ca587c36(currentElement)) return currentElement;
        currentElement = currentElement.parent;
    }
    return null;
}
/**
* Retrieves the ViewElement associated with a mouse event in the editing view.
*
* @param view The editing view.
* @param domEventData The DOM event data containing the mouse event.
* @returns The ViewElement associated with the mouse event, or null if not found.
*/ function $5547ab21e02f1e9e$var$getElementFromMouseEvent(editor, domEventData) {
    const view = editor.editing.view;
    const domRange = (0, $c7bc2cb7e2db0227$export$70a9dc425da3f6b0)(domEventData.domEvent);
    let viewRange;
    if (domRange) viewRange = view.domConverter.domRangeToView(domRange);
    else viewRange = view.createRange(view.createPositionAt(domEventData.target, 0));
    if (!viewRange) return null;
    const viewPosition = viewRange.start;
    if (!viewPosition.parent) return null;
    let viewNode = viewPosition.parent;
    if (viewPosition.parent.is("editableElement") || $5547ab21e02f1e9e$var$hasNoCaretPosition(editor, viewPosition.parent)) {
        /* v8 ignore else -- @preserve */ if (viewPosition.isAtEnd && viewPosition.nodeBefore) viewNode = viewPosition.nodeBefore;
        else if (viewPosition.isAtStart && viewPosition.nodeAfter) viewNode = viewPosition.nodeAfter;
    }
    if (viewNode.is("$text")) return viewNode.parent;
    return viewNode;
}
/**
* Whether the caret cannot sit in `node` itself, that is whether the model element it maps to does not accept
* `$text`.
*
* A block quote is such an element: it holds blocks rather than text, so a click in the strip of its own padding
* beside a block widget resolves to a position with nowhere for the caret to go. The browser then drops the
* selection instead of moving it, the click is discarded, and the editor restores the previous selection. Such a
* click is resolved to the widget instead, the way a click beside a widget in an editable already is.
*
* Answers `false` for anything that is not a mapped element, so an unmapped node is left to the caller's other
* checks rather than treated as caret-less.
*/ function $5547ab21e02f1e9e$var$hasNoCaretPosition(editor, node) {
    if (!node.is("element") || $5547ab21e02f1e9e$export$33101d01ca587c36(node)) return false;
    const modelElement = editor.editing.mapper.toModelElement(node);
    return !!modelElement && !editor.model.schema.checkChild(modelElement, "$text");
}
/**
* Checks whether the specified `element` is a child of the `parent` element.
*
* @param element An element to check.
* @param parent A parent for the element.
*/ function $5547ab21e02f1e9e$var$isChild(element, parent) {
    if (!parent) return false;
    return Array.from(element.getAncestors()).includes(parent);
}
/**
* Returns nearest text block ancestor.
*/ function $5547ab21e02f1e9e$var$findTextBlockAncestor(modelElement, schema) {
    for (const element of modelElement.getAncestors({
        includeSelf: true,
        parentFirst: true
    })){
        if (schema.checkChild(element, "$text")) return element;
        if (schema.isLimit(element) && !schema.isObject(element)) break;
    }
    return null;
}
/**
* Returns next text block where could put selection.
*/ function $5547ab21e02f1e9e$var$findNextTextBlock(position, schema) {
    const treeWalker = new (0, $b9b9f2bdf9c6137f$export$c24047420d7ab789)({
        startPosition: position
    });
    for (const { item: item } of treeWalker){
        if (schema.isLimit(item) || !item.is("element")) return null;
        if (schema.checkChild(item, "$text")) return item;
    }
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgettoolbarrepository
*/ /**
* Widget toolbar repository plugin. A central point for registering widget toolbars. This plugin handles the whole
* toolbar rendering process and exposes a concise API.
*
* To add a toolbar for your widget use the {@link ~WidgetToolbarRepository#register `WidgetToolbarRepository#register()`} method.
*
* The following example comes from the {@link module:image/imagetoolbar~ImageToolbar} plugin:
*
* ```ts
* class ImageToolbar extends Plugin {
* 	static get requires(): PluginDependenciesOf<[ WidgetToolbarRepository ]> {
* 		return [ WidgetToolbarRepository ];
* 	}
*
* 	afterInit() {
* 		const editor = this.editor;
* 		const widgetToolbarRepository = editor.plugins.get( WidgetToolbarRepository );
*
* 		widgetToolbarRepository.register( 'image', {
* 			items: editor.config.get( 'image.toolbar' ),
* 			getRelatedElement: getClosestSelectedImageWidget
* 		} );
* 	}
* }
* ```
*/ var $5547ab21e02f1e9e$export$c46c0a800280391d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A map of toolbar definitions.
	*/ _toolbarDefinitions = /* @__PURE__ */ new Map();
    _balloon;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "WidgetToolbarRepository";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (editor.plugins.has("BalloonToolbar")) {
            const balloonToolbar = editor.plugins.get("BalloonToolbar");
            this.listenTo(balloonToolbar, "show", (evt)=>{
                if ($5547ab21e02f1e9e$var$isWidgetSelected(editor.editing.view.document.selection)) evt.stop();
            }, {
                priority: "high"
            });
        }
        this._balloon = this.editor.plugins.get("ContextualBalloon");
        this.on("change:isEnabled", ()=>{
            this._updateToolbarsVisibility();
        });
        this.listenTo(editor.ui, "update", ()=>{
            this._updateToolbarsVisibility();
        });
        this.listenTo(editor.ui.focusTracker, "change:isFocused", ()=>{
            this._updateToolbarsVisibility();
        }, {
            priority: "low"
        });
    }
    destroy() {
        super.destroy();
        for (const toolbarConfig of this._toolbarDefinitions.values())toolbarConfig.view.destroy();
    }
    /**
	* Registers toolbar in the WidgetToolbarRepository. It renders it in the `ContextualBalloon` based on the value of the invoked
	* `getRelatedElement` function. Toolbar items are gathered from `items` array.
	* The balloon's CSS class is by default `ck-toolbar-container` and may be override with the `balloonClassName` option.
	*
	* Note: This method should be called in the {@link module:core/plugin~PluginInterface#afterInit `Plugin#afterInit()`}
	* callback (or later) to make sure that the given toolbar items were already registered by other plugins.
	*
	* @param toolbarId An id for the toolbar. Used to
	* @param options Detailed options
	* @param options.ariaLabel Label used by assistive technologies to describe this toolbar element.
	* @param options.items Array of toolbar items.
	* @param options.getRelatedElement Callback which returns an element the toolbar should be attached to.
	* @param options.balloonClassName CSS class for the widget balloon.
	*/ register(toolbarId, { ariaLabel: ariaLabel, items: items, getRelatedElement: getRelatedElement, balloonClassName: balloonClassName = "ck-toolbar-container", positions: positions }) {
        if (!items.length) {
            /**
			* When {@link module:widget/widgettoolbarrepository~WidgetToolbarRepository#register registering} a new widget toolbar, you
			* need to provide a non-empty array with the items that will be inserted into the toolbar.
			*
			* If you see this error when integrating the editor, you likely forgot to configure one of the widget toolbars.
			*
			* See for instance:
			*
			* * {@link module:table/tableconfig~TableConfig#contentToolbar `config.table.contentToolbar`}
			* * {@link module:image/imageconfig~ImageConfig#toolbar `config.image.toolbar`}
			*
			* @error widget-toolbar-no-items
			* @param {string} toolbarId The id of the toolbar that has not been configured correctly.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("widget-toolbar-no-items", {
                toolbarId: toolbarId
            });
            return;
        }
        const editor = this.editor;
        const t = editor.t;
        const toolbarView = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(editor.locale);
        toolbarView.ariaLabel = ariaLabel || t("Widget toolbar");
        if (this._toolbarDefinitions.has(toolbarId)) /**
		* Toolbar with the given id was already added.
		*
		* @error widget-toolbar-duplicated
		* @param {string} toolbarId Toolbar id.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("widget-toolbar-duplicated", this, {
            toolbarId: toolbarId
        });
        const toolbarDefinition = {
            view: toolbarView,
            getRelatedElement: getRelatedElement,
            balloonClassName: balloonClassName,
            itemsConfig: items,
            positions: positions,
            initialized: false
        };
        editor.ui.addToolbar(toolbarView, {
            isContextual: true,
            beforeFocus: ()=>{
                const relatedElement = getRelatedElement(editor.editing.view.document.selection);
                if (relatedElement) this._showToolbar(toolbarDefinition, relatedElement);
            },
            afterBlur: ()=>{
                this._hideToolbar(toolbarDefinition);
            }
        });
        this._toolbarDefinitions.set(toolbarId, toolbarDefinition);
    }
    /**
	* Iterates over stored toolbars and makes them visible or hidden.
	*/ _updateToolbarsVisibility() {
        let maxRelatedElementDepth = 0;
        let deepestRelatedElement = null;
        let deepestToolbarDefinition = null;
        for (const definition of this._toolbarDefinitions.values()){
            const relatedElement = definition.getRelatedElement(this.editor.editing.view.document.selection);
            if (!this.isEnabled || !relatedElement) {
                if (this._isToolbarInBalloon(definition)) this._hideToolbar(definition);
            } else if (!this.editor.ui.focusTracker.isFocused) {
                if (this._isToolbarVisible(definition)) this._hideToolbar(definition);
            } else {
                const relatedElementDepth = relatedElement.getAncestors().length;
                if (relatedElementDepth > maxRelatedElementDepth) {
                    maxRelatedElementDepth = relatedElementDepth;
                    deepestRelatedElement = relatedElement;
                    deepestToolbarDefinition = definition;
                }
            }
        }
        if (deepestToolbarDefinition) this._showToolbar(deepestToolbarDefinition, deepestRelatedElement);
    }
    /**
	* Hides the given toolbar.
	*/ _hideToolbar(toolbarDefinition) {
        this._balloon.remove(toolbarDefinition.view);
        this.stopListening(this._balloon, "change:visibleView");
    }
    /**
	* Shows up the toolbar if the toolbar is not visible.
	* Otherwise, repositions the toolbar's balloon when toolbar's view is the most top view in balloon stack.
	*
	* It might happen here that the toolbar's view is under another view. Then do nothing as the other toolbar view
	* should be still visible after the {@link module:ui/editorui/editorui~EditorUI#event:update}.
	*/ _showToolbar(toolbarDefinition, relatedElement) {
        if (this._isToolbarVisible(toolbarDefinition)) $5547ab21e02f1e9e$var$repositionContextualBalloon(this.editor, relatedElement, toolbarDefinition.positions);
        else if (!this._isToolbarInBalloon(toolbarDefinition)) {
            if (!toolbarDefinition.initialized) {
                toolbarDefinition.initialized = true;
                toolbarDefinition.view.fillFromConfig(toolbarDefinition.itemsConfig, this.editor.ui.componentFactory);
            }
            this._balloon.add({
                view: toolbarDefinition.view,
                position: $5547ab21e02f1e9e$var$getBalloonPositionData(this.editor, relatedElement, toolbarDefinition.positions),
                balloonClassName: toolbarDefinition.balloonClassName
            });
            this.listenTo(this._balloon, "change:visibleView", ()=>{
                for (const definition of this._toolbarDefinitions.values())if (this._isToolbarVisible(definition)) {
                    const relatedElement = definition.getRelatedElement(this.editor.editing.view.document.selection);
                    $5547ab21e02f1e9e$var$repositionContextualBalloon(this.editor, relatedElement, toolbarDefinition.positions);
                }
            });
        }
    }
    _isToolbarVisible(toolbar) {
        return this._balloon.visibleView === toolbar.view;
    }
    _isToolbarInBalloon(toolbar) {
        return this._balloon.hasView(toolbar.view);
    }
};
function $5547ab21e02f1e9e$var$repositionContextualBalloon(editor, relatedElement, positions) {
    const balloon = editor.plugins.get("ContextualBalloon");
    const position = $5547ab21e02f1e9e$var$getBalloonPositionData(editor, relatedElement, positions);
    balloon.updatePosition(position);
}
function $5547ab21e02f1e9e$var$getBalloonPositionData(editor, relatedElement, positions) {
    const editingView = editor.editing.view;
    const defaultPositions = (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions;
    return {
        target: editingView.domConverter.mapViewToDom(relatedElement),
        positions: positions || [
            defaultPositions.northArrowSouth,
            defaultPositions.northArrowSouthWest,
            defaultPositions.northArrowSouthEast,
            defaultPositions.southArrowNorth,
            defaultPositions.southArrowNorthWest,
            defaultPositions.southArrowNorthEast,
            defaultPositions.viewportStickyNorth
        ]
    };
}
function $5547ab21e02f1e9e$var$isWidgetSelected(selection) {
    const viewElement = selection.getSelectedElement();
    return !!(viewElement && $5547ab21e02f1e9e$export$33101d01ca587c36(viewElement));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgetresize/resizerstate
*/ const $5547ab21e02f1e9e$var$WidgetResizeStateBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Stores the internal state of a single resizable object.
*/ var $5547ab21e02f1e9e$export$4e3495794efbf5f0 = class extends $5547ab21e02f1e9e$var$WidgetResizeStateBase {
    /**
	* The reference point of the resizer where the dragging started. It is used to measure the distance the user cursor
	* traveled, so how much the image should be enlarged.
	* This information is only known after the DOM was rendered, so it will be updated later.
	*
	* @internal
	*/ _referenceCoordinates;
    /**
	* Resizer options.
	*/ _options;
    /**
	* The original width (pixels) of the resized object when the resize process was started.
	*
	* @readonly
	*/ _originalWidth;
    /**
	* The original height (pixels) of the resized object when the resize process was started.
	*
	* @readonly
	*/ _originalHeight;
    /**
	* The original width (percents) of the resized object when the resize process was started.
	*
	* @readonly
	*/ _originalWidthPercents;
    /**
	* A width to height ratio of the resized image.
	*
	* @readonly
	*/ _aspectRatio;
    /**
	* @param options Resizer options.
	*/ constructor(options){
        super();
        this.set("activeHandlePosition", null);
        this.set("proposedWidthPercents", null);
        this.set("proposedWidth", null);
        this.set("proposedHeight", null);
        this.set("proposedHandleHostWidth", null);
        this.set("proposedHandleHostHeight", null);
        this._options = options;
        this._referenceCoordinates = null;
    }
    /**
	* The original width (pixels) of the resized object when the resize process was started.
	*/ get originalWidth() {
        return this._originalWidth;
    }
    /**
	* The original height (pixels) of the resized object when the resize process was started.
	*/ get originalHeight() {
        return this._originalHeight;
    }
    /**
	* The original width (percents) of the resized object when the resize process was started.
	*/ get originalWidthPercents() {
        return this._originalWidthPercents;
    }
    /**
	* A width to height ratio of the resized image.
	*/ get aspectRatio() {
        return this._aspectRatio;
    }
    /**
	*
	* @param domResizeHandle The handle used to calculate the reference point.
	*/ begin(domResizeHandle, domHandleHost, domResizeHost) {
        const clientRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domHandleHost);
        this.activeHandlePosition = $5547ab21e02f1e9e$var$getHandlePosition(domResizeHandle);
        this._referenceCoordinates = $5547ab21e02f1e9e$var$getAbsoluteBoundaryPoint(domHandleHost, $5547ab21e02f1e9e$var$getOppositePosition(this.activeHandlePosition));
        this._originalWidth = clientRect.width;
        this._originalHeight = clientRect.height;
        this._aspectRatio = clientRect.width / clientRect.height;
        const widthStyle = domResizeHost.style.width;
        if (widthStyle && widthStyle.match(/^\d+(\.\d*)?%$/)) this._originalWidthPercents = parseFloat(widthStyle);
        else this._originalWidthPercents = $5547ab21e02f1e9e$export$cdbfddbf190d7f9c(domResizeHost, clientRect);
    }
    update(newSize) {
        this.proposedWidth = newSize.width;
        this.proposedHeight = newSize.height;
        this.proposedWidthPercents = newSize.widthPercents;
        this.proposedHandleHostWidth = newSize.handleHostWidth;
        this.proposedHandleHostHeight = newSize.handleHostHeight;
    }
};
/**
* Returns coordinates of the top-left corner of an element, relative to the document's top-left corner.
*
* @param resizerPosition The position of the resize handle, e.g. `"top-left"`, `"bottom-right"`.
*/ function $5547ab21e02f1e9e$var$getAbsoluteBoundaryPoint(element, resizerPosition) {
    const elementRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(element);
    const positionParts = resizerPosition.split("-");
    const ret = {
        x: positionParts[1] == "right" ? elementRect.right : elementRect.left,
        y: positionParts[0] == "bottom" ? elementRect.bottom : elementRect.top
    };
    ret.x += element.ownerDocument.defaultView.scrollX;
    ret.y += element.ownerDocument.defaultView.scrollY;
    return ret;
}
/**
* @param resizerPosition The expected resizer position, like `"top-left"`, `"bottom-right"`.
* @returns A prefixed HTML class name for the resizer element.
*/ function $5547ab21e02f1e9e$var$getResizerHandleClass(resizerPosition) {
    return `ck-widget__resizer__handle-${resizerPosition}`;
}
/**
* Determines the position of a given resize handle.
*
* @param domHandle Handle used to calculate the reference point.
* @returns Returns a string like `"top-left"` or `undefined` if not matched.
*/ function $5547ab21e02f1e9e$var$getHandlePosition(domHandle) {
    for (const position of [
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left"
    ])if (domHandle.classList.contains($5547ab21e02f1e9e$var$getResizerHandleClass(position))) return position;
}
/**
* @param position Like `"top-left"`.
* @returns Inverted `position`, e.g. it returns `"bottom-right"` if `"top-left"` was given as `position`.
*/ function $5547ab21e02f1e9e$var$getOppositePosition(position) {
    const parts = position.split("-");
    const replacements = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    };
    return `${replacements[parts[0]]}-${replacements[parts[1]]}`;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgetresize/sizeview
*/ /**
* A view displaying the proposed new element size during the resizing.
*
* @internal
*/ var $5547ab21e02f1e9e$export$60c141bb79c11ad9 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    constructor(){
        super();
        const bind = this.bindTemplate;
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-size-view",
                    bind.to("_viewPosition", (value)=>value ? `ck-orientation-${value}` : "")
                ],
                style: {
                    display: bind.if("_isVisible", "none", (visible)=>!visible)
                }
            },
            children: [
                {
                    text: bind.to("_label")
                }
            ]
        });
    }
    /**
	* A method used for binding the `SizeView` instance properties to the `ResizeState` instance observable properties.
	*
	* @internal
	* @param options An object defining the resizer options, used for setting the proper size label.
	* @param resizeState The `ResizeState` class instance, used for keeping the `SizeView` state up to date.
	*/ _bindToState(options, resizeState) {
        this.bind("_isVisible").to(resizeState, "proposedWidth", resizeState, "proposedHeight", (width, height)=>width !== null && height !== null);
        this.bind("_label").to(resizeState, "proposedHandleHostWidth", resizeState, "proposedHandleHostHeight", resizeState, "proposedWidthPercents", (width, height, widthPercents)=>{
            if (options.unit === "px") return `${width}\xd7${height}`;
            else return `${widthPercents}%`;
        });
        this.bind("_viewPosition").to(resizeState, "activeHandlePosition", resizeState, "proposedHandleHostWidth", resizeState, "proposedHandleHostHeight", (position, width, height)=>width < 50 || height < 50 ? "above-center" : position);
    }
    /**
	* A method used for cleaning up. It removes the bindings and hides the view.
	*
	* @internal
	*/ _dismiss() {
        this.unbind();
        this._isVisible = false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgetresize/resizer
*/ const $5547ab21e02f1e9e$var$WidgetResizerBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Represents a resizer for a single resizable object.
*/ var $5547ab21e02f1e9e$export$9cacf875bb4bb6b4 = class extends $5547ab21e02f1e9e$var$WidgetResizerBase {
    /**
	* Stores the state of the resizable host geometry, such as the original width, the currently proposed height, etc.
	*
	* Note that a new state is created for each resize transaction.
	*/ _state;
    /**
	* A view displaying the proposed new element size during the resizing.
	*/ _sizeView;
    /**
	* Options passed to the {@link #constructor}.
	*/ _options;
    /**
	* A wrapper that is controlled by the resizer. This is usually a widget element.
	*/ _viewResizerWrapper = null;
    /**
	* The width of the resized {@link module:widget/widgetresize~WidgetResizerOptions#viewElement viewElement} before the resizing started.
	*/ _initialViewWidth;
    /**
	* @param options Resizer options.
	*/ constructor(options){
        super();
        this._options = options;
        this.set("isEnabled", true);
        this.set("isSelected", false);
        this.bind("isVisible").to(this, "isEnabled", this, "isSelected", (isEnabled, isSelected)=>isEnabled && isSelected);
        this.decorate("begin");
        this.decorate("cancel");
        this.decorate("commit");
        this.decorate("updateSize");
        this.on("commit", (event)=>{
            if (!this.state.proposedWidth && !this.state.proposedWidthPercents) {
                this._cleanup();
                event.stop();
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Stores the state of the resizable host geometry, such as the original width, the currently proposed height, etc.
	*
	* Note that a new state is created for each resize transaction.
	*/ get state() {
        return this._state;
    }
    /**
	* Makes resizer visible in the UI.
	*/ show() {
        this._options.editor.editing.view.change((writer)=>{
            writer.removeClass("ck-hidden", this._viewResizerWrapper);
        });
    }
    /**
	* Hides resizer in the UI.
	*/ hide() {
        this._options.editor.editing.view.change((writer)=>{
            writer.addClass("ck-hidden", this._viewResizerWrapper);
        });
    }
    /**
	* Attaches the resizer to the DOM.
	*/ attach() {
        const that = this;
        const widgetElement = this._options.viewElement;
        this._options.editor.editing.view.change((writer)=>{
            const viewResizerWrapper = writer.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__resizer"
            }, function(domDocument) {
                const domElement = this.toDomElement(domDocument);
                that._appendHandles(domElement);
                that._appendSizeUI(domElement);
                return domElement;
            });
            writer.insert(writer.createPositionAt(widgetElement, "end"), viewResizerWrapper);
            writer.addClass("ck-widget_with-resizer", widgetElement);
            this._viewResizerWrapper = viewResizerWrapper;
            if (!this.isVisible) this.hide();
        });
        this.on("change:isVisible", ()=>{
            if (this.isVisible) {
                this.show();
                this.redraw();
            } else this.hide();
        });
    }
    /**
	* Starts the resizing process.
	*
	* Creates a new {@link #state} for the current process.
	*
	* @fires begin
	* @param domResizeHandle Clicked handle.
	*/ begin(domResizeHandle) {
        this._state = new $5547ab21e02f1e9e$export$4e3495794efbf5f0(this._options);
        this._sizeView._bindToState(this._options, this.state);
        this._initialViewWidth = this._options.viewElement.getStyle("width");
        this.state.begin(domResizeHandle, this._getHandleHost(), this._getResizeHost());
    }
    /**
	* Updates the proposed size based on `domEventData`.
	*
	* @fires updateSize
	*/ updateSize(domEventData) {
        const newSize = this._proposeNewSize(domEventData);
        this._options.editor.editing.view.change((writer)=>{
            const unit = this._options.unit || "%";
            const newWidth = (unit === "%" ? newSize.widthPercents : newSize.width) + unit;
            writer.setStyle("width", newWidth, this._options.viewElement);
        });
        const domHandleHost = this._getHandleHost();
        const domHandleHostRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domHandleHost);
        const handleHostWidth = Math.round(domHandleHostRect.width);
        const handleHostHeight = Math.round(domHandleHostRect.height);
        const domResizeHostRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domHandleHost);
        newSize.width = Math.round(domResizeHostRect.width);
        newSize.height = Math.round(domResizeHostRect.height);
        this.redraw(domHandleHostRect);
        this.state.update({
            ...newSize,
            handleHostWidth: handleHostWidth,
            handleHostHeight: handleHostHeight
        });
    }
    /**
	* Applies the geometry proposed with the resizer.
	*
	* @fires commit
	*/ commit() {
        const unit = this._options.unit || "%";
        const newValue = (unit === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + unit;
        this._options.editor.editing.view.change(()=>{
            this._cleanup();
            this._options.onCommit(newValue);
        });
    }
    /**
	* Cancels and rejects the proposed resize dimensions, hiding the UI.
	*
	* @fires cancel
	*/ cancel() {
        this._cleanup();
    }
    /**
	* Destroys the resizer.
	*/ destroy() {
        this.cancel();
    }
    /**
	* Redraws the resizer.
	*
	* @param handleHostRect Handle host rectangle might be given to improve performance.
	*/ redraw(handleHostRect) {
        const domWrapper = this._domResizerWrapper;
        if (!domWrapper?.isConnected) return;
        const widgetWrapper = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(domWrapper);
        const handleHost = this._getHandleHost();
        const resizerWrapper = this._viewResizerWrapper;
        const currentDimensions = [
            resizerWrapper.getStyle("width"),
            resizerWrapper.getStyle("height"),
            resizerWrapper.getStyle("left"),
            resizerWrapper.getStyle("top")
        ];
        let newDimensions;
        if (widgetWrapper.isSameNode(handleHost)) {
            const clientRect = handleHostRect || new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(handleHost);
            newDimensions = [
                clientRect.width + "px",
                clientRect.height + "px",
                void 0,
                void 0
            ];
        } else newDimensions = [
            handleHost.offsetWidth + "px",
            handleHost.offsetHeight + "px",
            handleHost.offsetLeft + "px",
            handleHost.offsetTop + "px"
        ];
        if ((0, $c7bc2cb7e2db0227$export$fc16749c794bf6ff)(currentDimensions, newDimensions) !== "same") this._options.editor.editing.view.change((writer)=>{
            writer.setStyle({
                width: newDimensions[0],
                height: newDimensions[1],
                left: newDimensions[2],
                top: newDimensions[3]
            }, resizerWrapper);
        });
    }
    containsHandle(domElement) {
        return (0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(this._domResizerWrapper, domElement);
    }
    static isResizeHandle(domElement) {
        return domElement.classList.contains("ck-widget__resizer__handle");
    }
    /**
	* Cleans up the context state.
	*/ _cleanup() {
        this._sizeView._dismiss();
        this._options.editor.editing.view.change((writer)=>{
            writer.setStyle("width", this._initialViewWidth, this._options.viewElement);
        });
    }
    /**
	* Calculates the proposed size as the resize handles are dragged.
	*
	* @param domEventData Event data that caused the size update request. It should be used to calculate the proposed size.
	*/ _proposeNewSize(domEventData) {
        const state = this.state;
        const currentCoordinates = $5547ab21e02f1e9e$var$extractCoordinates(domEventData);
        const isCentered = this._options.isCentered ? this._options.isCentered(this) : true;
        const enlargement = {
            x: state._referenceCoordinates.x - (currentCoordinates.x + state.originalWidth),
            y: currentCoordinates.y - state.originalHeight - state._referenceCoordinates.y
        };
        if (isCentered && state.activeHandlePosition.endsWith("-right")) enlargement.x = currentCoordinates.x - (state._referenceCoordinates.x + state.originalWidth);
        if (isCentered) enlargement.x *= 2;
        let width = Math.abs(state.originalWidth + enlargement.x);
        let height = Math.abs(state.originalHeight + enlargement.y);
        if ((width / state.aspectRatio > height ? "width" : "height") == "width") height = width / state.aspectRatio;
        else width = height * state.aspectRatio;
        return {
            width: Math.round(width),
            height: Math.round(height),
            widthPercents: Math.min(Math.round(state.originalWidthPercents / state.originalWidth * width * 100) / 100, 100)
        };
    }
    /**
	* Obtains the resize host.
	*
	* Resize host is an object that receives dimensions which are the result of resizing.
	*/ _getResizeHost() {
        const widgetWrapper = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(this._domResizerWrapper);
        return this._options.getResizeHost(widgetWrapper);
    }
    /**
	* Obtains the handle host.
	*
	* Handle host is an object that the handles are aligned to.
	*
	* Handle host will not always be an entire widget itself. Take an image as an example. The image widget
	* contains an image and a caption. Only the image should be surrounded with handles.
	*/ _getHandleHost() {
        const widgetWrapper = (0, $c7bc2cb7e2db0227$export$169e5491001d3ed6)(this._domResizerWrapper);
        return this._options.getHandleHost(widgetWrapper);
    }
    /**
	* DOM container of the entire resize UI.
	*
	* Note that this property will have a value only after the element bound with the resizer is rendered
	* (otherwise `null`).
	*/ get _domResizerWrapper() {
        return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
    }
    /**
	* Renders the resize handles in the DOM.
	*
	* @param domElement The resizer wrapper.
	*/ _appendHandles(domElement) {
        for (const currentPosition of [
            "top-left",
            "top-right",
            "bottom-right",
            "bottom-left"
        ])domElement.appendChild(new (0, $29fd27cb9bdab9d2$export$14416b8d99d47caa)({
            tag: "div",
            attributes: {
                class: `ck-widget__resizer__handle ${$5547ab21e02f1e9e$var$getResizerClass(currentPosition)}`
            }
        }).render());
    }
    /**
	* Sets up the {@link #_sizeView} property and adds it to the passed `domElement`.
	*/ _appendSizeUI(domElement) {
        this._sizeView = new $5547ab21e02f1e9e$export$60c141bb79c11ad9();
        this._sizeView.render();
        domElement.appendChild(this._sizeView.element);
    }
};
/**
* @param resizerPosition Expected resizer position like `"top-left"`, `"bottom-right"`.
* @returns A prefixed HTML class name for the resizer element
*/ function $5547ab21e02f1e9e$var$getResizerClass(resizerPosition) {
    return `ck-widget__resizer__handle-${resizerPosition}`;
}
function $5547ab21e02f1e9e$var$extractCoordinates(event) {
    return {
        x: event.pageX,
        y: event.pageY
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module widget/widgetresize
*/ /**
* The widget resize feature plugin.
*
* Use the {@link module:widget/widgetresize~WidgetResize#attachTo} method to create a resizer for the specified widget.
*/ var $5547ab21e02f1e9e$export$5584c2e1cd85ebe9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A map of resizers created using this plugin instance.
	*/ _resizers = /* @__PURE__ */ new Map();
    _observer;
    _redrawSelectedResizerThrottled;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "WidgetResize";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editing = this.editor.editing;
        const domDocument = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.document;
        this.set("selectedResizer", null);
        this.set("_activeResizer", null);
        editing.view.addObserver((0, $b9b9f2bdf9c6137f$export$7bb344c59ad5b029));
        this._observer = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
        this.listenTo(editing.view.document, "mousedown", this._mouseDownListener.bind(this), {
            priority: "high"
        });
        this._observer.listenTo(domDocument, "mousemove", this._mouseMoveListener.bind(this));
        this._observer.listenTo(domDocument, "mouseup", this._mouseUpListener.bind(this));
        this._redrawSelectedResizerThrottled = (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(()=>this.redrawSelectedResizer(), 200);
        this.editor.ui.on("update", this._redrawSelectedResizerThrottled);
        this.editor.model.document.on("change", ()=>{
            for (const [viewElement, resizer] of this._resizers)if (!viewElement.isAttached()) {
                this._resizers.delete(viewElement);
                resizer.destroy();
            }
        }, {
            priority: "lowest"
        });
        this._observer.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize", this._redrawSelectedResizerThrottled);
        const viewSelection = this.editor.editing.view.document.selection;
        viewSelection.on("change", ()=>{
            const selectedElement = viewSelection.getSelectedElement();
            const resizer = this.getResizerByViewElement(selectedElement) || null;
            if (resizer) this.select(resizer);
            else this.deselect();
        });
    }
    /**
	* Redraws the selected resizer if there is any selected resizer and if it is visible.
	*/ redrawSelectedResizer() {
        if (this.selectedResizer && this.selectedResizer.isVisible) this.selectedResizer.redraw();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._observer.stopListening();
        for (const resizer of this._resizers.values())resizer.destroy();
        this._redrawSelectedResizerThrottled.cancel();
    }
    /**
	* Marks resizer as selected.
	*/ select(resizer) {
        this.deselect();
        this.selectedResizer = resizer;
        this.selectedResizer.isSelected = true;
    }
    /**
	* Deselects currently set resizer.
	*/ deselect() {
        if (this.selectedResizer) this.selectedResizer.isSelected = false;
        this.selectedResizer = null;
    }
    /**
	* @param options Resizer options.
	*/ attachTo(options) {
        const resizer = new $5547ab21e02f1e9e$export$9cacf875bb4bb6b4(options);
        const plugins = this.editor.plugins;
        resizer.attach();
        if (plugins.has("WidgetToolbarRepository")) {
            const widgetToolbarRepository = plugins.get("WidgetToolbarRepository");
            resizer.on("begin", ()=>{
                widgetToolbarRepository.forceDisabled("resize");
            }, {
                priority: "lowest"
            });
            resizer.on("cancel", ()=>{
                widgetToolbarRepository.clearForceDisabled("resize");
            }, {
                priority: "highest"
            });
            resizer.on("commit", ()=>{
                widgetToolbarRepository.clearForceDisabled("resize");
            }, {
                priority: "highest"
            });
        }
        this._resizers.set(options.viewElement, resizer);
        const selectedElement = this.editor.editing.view.document.selection.getSelectedElement();
        if (this.getResizerByViewElement(selectedElement) == resizer) this.select(resizer);
        return resizer;
    }
    /**
	* Returns a resizer created for a given view element (widget element).
	*
	* @param viewElement View element associated with the resizer.
	*/ getResizerByViewElement(viewElement) {
        return this._resizers.get(viewElement);
    }
    /**
	* Returns a resizer that contains a given resize handle.
	*/ _getResizerByHandle(domResizeHandle) {
        for (const resizer of this._resizers.values())if (resizer.containsHandle(domResizeHandle)) return resizer;
    }
    /**
	* @param domEventData Native DOM event.
	*/ _mouseDownListener(event, domEventData) {
        const resizeHandle = domEventData.domTarget;
        if (!$5547ab21e02f1e9e$export$9cacf875bb4bb6b4.isResizeHandle(resizeHandle)) return;
        this._activeResizer = this._getResizerByHandle(resizeHandle) || null;
        if (this._activeResizer) {
            this._activeResizer.begin(resizeHandle);
            event.stop();
            domEventData.preventDefault();
        }
    }
    /**
	* @param domEventData Native DOM event.
	*/ _mouseMoveListener(event, domEventData) {
        if (this._activeResizer) this._activeResizer.updateSize(domEventData);
    }
    _mouseUpListener() {
        if (this._activeResizer) {
            this._activeResizer.commit();
            this._activeResizer = null;
        }
    }
};





/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module bookmark/ui/bookmarkformview
*/ /**
* The bookmark form view controller class.
*
* See {@link module:bookmark/ui/bookmarkformview~BookmarkFormView}.
*/ var $acba6d1585a37b53$export$cf202654f5996fcf = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the form.
	*/ focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
    /**
	* The ID input view.
	*/ idInputView;
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A button used to submit the form.
	*/ saveButtonView;
    /**
	* A collection of form child views in the form.
	*/ children;
    /**
	* An array of form validators used by {@link #isValid}.
	*/ _validators;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* Creates an instance of the {@link module:bookmark/ui/bookmarkformview~BookmarkFormView} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	* @param validators  Form validators used by {@link #isValid}.
	*/ constructor(locale, validators){
        super(locale);
        this._validators = validators;
        this.backButtonView = this._createBackButton();
        this.saveButtonView = this._createSaveButton();
        this.idInputView = this._createIdInput();
        this.children = this.createCollection([
            this._createHeaderView()
        ]);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.idInputView,
                this.saveButtonView
            ],
            class: [
                "ck-form__row_with-submit",
                "ck-form__row_large-top-padding",
                "ck-form__row_large-bottom-padding"
            ]
        }));
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("cancel");
            cancel();
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-bookmark-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.backButtonView,
            this.idInputView,
            this.saveButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist {@link #_focusables} in the form.
	*/ focus() {
        this.idInputView.focus();
    }
    /**
	* Validates the form and returns `false` when some fields are invalid.
	*/ isValid() {
        this.resetFormStatus();
        for (const validator of this._validators){
            const errorText = validator(this);
            if (errorText) {
                this.idInputView.errorText = errorText;
                return false;
            }
        }
        return true;
    }
    /**
	* Cleans up the supplementary error and information text of the {@link #idInputView}
	* bringing them back to the state when the form has been displayed for the first time.
	*
	* See {@link #isValid}.
	*/ resetFormStatus() {
        this.idInputView.errorText = null;
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates a save button view that saves the bookmark.
	*/ _createSaveButton() {
        const t = this.locale.t;
        const saveButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        saveButton.set({
            label: t("Save"),
            withText: true,
            type: "submit",
            class: "ck-button-action ck-button_standard"
        });
        return saveButton;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Bookmark")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates a labeled input view.
	*
	* @returns Labeled field view instance.
	*/ _createIdInput() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        labeledInput.label = t("Bookmark name");
        labeledInput.infoText = t("Enter the bookmark name without spaces.");
        labeledInput.class = "ck-labeled-field-view_full-width";
        return labeledInput;
    }
    /**
	* The native DOM `value` of the {@link #idInputView} element.
	*
	* **Note**: Do not confuse it with the {@link module:ui/inputtext/inputtextview~InputTextView#value}
	* which works one way only and may not represent the actual state of the component in the DOM.
	*/ get id() {
        const { element: element } = this.idInputView.fieldView;
        if (!element) return null;
        return element.value.trim();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module bookmark/utils
*/ /**
* Returns `true` if the bookmark id is valid; otherwise, returns `false`.
*
* @internal
*/ function $acba6d1585a37b53$export$f1fbb233e56f13a(id) {
    if (!id || typeof id !== "string") return false;
    if (/\s/.test(id)) return false;
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The insert bookmark command.
*
* The command is registered by {@link module:bookmark/bookmarkediting~BookmarkEditing} as `'insertBookmark'`.
*
* To insert a bookmark element at place where is the current collapsed selection or where is the beginning of document selection,
* execute the command passing the bookmark id as a parameter:
*
* ```ts
* editor.execute( 'insertBookmark', { bookmarkId: 'foo_bar' } );
* ```
*/ var $acba6d1585a37b53$export$28797325684f7348 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const position = this._getPositionToInsertBookmark(selection);
        this.isEnabled = !!position;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Command options.
	* @param options.bookmarkId The value of the `bookmarkId` attribute.
	*/ execute(options) {
        if (!options) return;
        const { bookmarkId: bookmarkId } = options;
        if (!$acba6d1585a37b53$export$f1fbb233e56f13a(bookmarkId)) {
            /**
			* Insert bookmark command can be executed only with a valid name.
			*
			* A valid bookmark name must be a non-empty string and must not contain any spaces.
			*
			* @error insert-bookmark-command-executed-with-invalid-name
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("insert-bookmark-command-executed-with-invalid-name");
            return;
        }
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        model.change((writer)=>{
            let position = this._getPositionToInsertBookmark(selection);
            if (!model.schema.checkChild(position, "bookmark")) {
                const newPosition = editor.execute("insertParagraph", {
                    position: position
                });
                if (!newPosition) return;
                position = newPosition;
            }
            const bookmarkElement = writer.createElement("bookmark", {
                ...Object.fromEntries(selection.getAttributes()),
                bookmarkId: bookmarkId
            });
            model.insertObject(bookmarkElement, position, null, {
                setSelection: "on"
            });
        });
    }
    /**
	* Returns the position where the bookmark can be inserted. And if it is not possible to insert a bookmark,
	* check if it is possible to insert a paragraph.
	*/ _getPositionToInsertBookmark(selection) {
        const model = this.editor.model;
        const schema = model.schema;
        const firstRange = selection.getFirstRange();
        const startPosition = firstRange.start;
        if ($acba6d1585a37b53$var$isBookmarkAllowed(startPosition, schema)) return startPosition;
        for (const { previousPosition: previousPosition, item: item } of firstRange){
            if (item.is("element") && schema.checkChild(item, "$text") && $acba6d1585a37b53$var$isBookmarkAllowed(item, schema)) return model.createPositionAt(item, 0);
            if ($acba6d1585a37b53$var$isBookmarkAllowed(previousPosition, schema)) return previousPosition;
        }
        return null;
    }
};
/**
* Verify if the given position allows for bookmark insertion. Verify if auto-paragraphing could help.
*/ function $acba6d1585a37b53$var$isBookmarkAllowed(position, schema) {
    if (schema.checkChild(position, "bookmark")) return true;
    if (!schema.checkChild(position, "paragraph")) return false;
    return schema.checkChild("paragraph", "bookmark");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module bookmark/updatebookmarkcommand
*/ /**
* The update bookmark command.
*
* The command is registered by {@link module:bookmark/bookmarkediting~BookmarkEditing} as `'updateBookmark'`.
*
* To update the `bookmarkId` of current selected bookmark element, execute the command passing the bookmark id as a parameter:
*
* ```ts
* editor.execute( 'updateBookmark', { bookmarkId: 'newId' } );
* ```
*/ var $acba6d1585a37b53$export$366620db042e49a7 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const selectedBookmark = $acba6d1585a37b53$var$getSelectedBookmark(selection);
        this.isEnabled = !!selectedBookmark;
        this.value = selectedBookmark ? selectedBookmark.getAttribute("bookmarkId") : void 0;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Command options.
	* @param options.bookmarkId The new value of the `bookmarkId` attribute to set.
	*/ execute(options) {
        if (!options) return;
        const { bookmarkId: bookmarkId } = options;
        if (!$acba6d1585a37b53$export$f1fbb233e56f13a(bookmarkId)) {
            /**
			* Update bookmark command can be executed only with a valid name.
			*
			* A valid bookmark name must be a non-empty string and must not contain any spaces.
			*
			* @error update-bookmark-command-executed-with-invalid-name
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("update-bookmark-command-executed-with-invalid-name");
            return;
        }
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedBookmark = $acba6d1585a37b53$var$getSelectedBookmark(selection);
        if (selectedBookmark) model.change((writer)=>{
            writer.setAttribute("bookmarkId", bookmarkId, selectedBookmark);
        });
    }
};
/**
* Returns the selected `bookmark` element in the model, if any.
*/ function $acba6d1585a37b53$var$getSelectedBookmark(selection) {
    const element = selection.getSelectedElement();
    if (!!element && element.is("element", "bookmark")) return element;
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module bookmark/bookmarkediting
*/ /**
* The bookmark editing plugin.
*/ var $acba6d1585a37b53$export$20fa66bd04332290 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A collection of bookmarks elements in the document.
	*/ _bookmarkElements = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BookmarkEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "BKM";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("bookmark", {
            toolbar: [
                "bookmarkPreview",
                "|",
                "editBookmark",
                "removeBookmark"
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const { editor: editor } = this;
        this._defineSchema();
        this._defineConverters();
        editor.commands.add("insertBookmark", new $acba6d1585a37b53$export$28797325684f7348(editor));
        editor.commands.add("updateBookmark", new $acba6d1585a37b53$export$366620db042e49a7(editor));
        this.listenTo(editor.model.document, "change:data", ()=>{
            this._trackBookmarkElements();
        });
    }
    /**
	* Returns the model element for the given bookmark ID if it exists.
	*/ getElementForBookmarkId(bookmarkId) {
        for (const [element, id] of this._bookmarkElements)if (id == bookmarkId) return element;
        return null;
    }
    /**
	* Returns all unique bookmark names existing in the content.
	*/ getAllBookmarkNames() {
        return new Set(this._bookmarkElements.values());
    }
    /**
	* Defines the schema for the bookmark feature.
	*/ _defineSchema() {
        this.editor.model.schema.register("bookmark", {
            inheritAllFrom: "$inlineObject",
            allowAttributes: "bookmarkId",
            disallowAttributes: [
                "linkHref",
                "htmlA"
            ]
        });
    }
    /**
	* Defines the converters for the bookmark feature.
	*/ _defineConverters() {
        const { editor: editor } = this;
        const { conversion: conversion, t: t } = editor;
        editor.data.htmlProcessor.domConverter.registerInlineObjectMatcher((element)=>$acba6d1585a37b53$var$upcastMatcher(element));
        editor.editing.view.domConverter.registerInlineObjectMatcher((element)=>$acba6d1585a37b53$var$upcastMatcher(element, false));
        conversion.for("dataDowncast").elementToElement({
            model: {
                name: "bookmark",
                attributes: [
                    "bookmarkId"
                ]
            },
            view: (modelElement, { writer: writer })=>{
                return writer.createEmptyElement("a", {
                    "id": modelElement.getAttribute("bookmarkId")
                });
            }
        });
        conversion.for("editingDowncast").elementToElement({
            model: {
                name: "bookmark",
                attributes: [
                    "bookmarkId"
                ]
            },
            view: (modelElement, { writer: writer })=>{
                const id = modelElement.getAttribute("bookmarkId");
                const containerElement = writer.createContainerElement("a", {
                    id: id,
                    class: "ck-bookmark"
                }, [
                    this._createBookmarkUIElement(writer)
                ]);
                writer.setCustomProperty("bookmark", true, containerElement);
                this._bookmarkElements.set(modelElement, id);
                const labelCreator = ()=>`${id} ${t("bookmark widget")}`;
                return (0, $5547ab21e02f1e9e$export$83925c2318996255)(containerElement, writer, {
                    label: labelCreator
                });
            }
        });
        conversion.for("upcast").add((dispatcher)=>dispatcher.on("element:a", $acba6d1585a37b53$var$dataViewModelAnchorInsertion(editor)));
    }
    /**
	* Creates a UI element for the `bookmark` representation in editing view.
	*/ _createBookmarkUIElement(writer) {
        return writer.createUIElement("span", {
            class: "ck-bookmark__icon"
        }, function(domDocument) {
            const domElement = this.toDomElement(domDocument);
            const icon = new (0, $29fd27cb9bdab9d2$export$212c60ac61334981)();
            icon.set({
                content: (0, $e8dc502aba5ac3f5$export$ad8f165eec14886a),
                isColorInherited: false
            });
            icon.render();
            domElement.appendChild(icon.element);
            return domElement;
        });
    }
    /**
	* Tracking the added or removed bookmark elements.
	*/ _trackBookmarkElements() {
        this._bookmarkElements.forEach((id, element)=>{
            if (element.root.rootName === "$graveyard") this._bookmarkElements.delete(element);
        });
    }
};
/**
* A helper function to match an `anchor` element which must contain `id` or `name` attribute but without `href` attribute,
* also when `expectEmpty` is set to `true` but the element is not empty matcher should not match any element.
*
* @param element The element to be checked.
* @param expectEmpty Default set to `true`, when set to `false` matcher expects that `anchor` is not empty;
* in editing pipeline it's not empty because it contains the `UIElement`.
*/ function $acba6d1585a37b53$var$upcastMatcher(element, expectEmpty = true) {
    if (!(element.name === "a")) return null;
    if (expectEmpty && !element.isEmpty) return null;
    const hasIdAttribute = element.hasAttribute("id");
    const hasNameAttribute = element.hasAttribute("name");
    const hasHrefAttribute = element.hasAttribute("href");
    if (hasIdAttribute && !hasHrefAttribute) return {
        name: true,
        attributes: [
            "id"
        ]
    };
    if (hasNameAttribute && !hasHrefAttribute) return {
        name: true,
        attributes: [
            "name"
        ]
    };
    return null;
}
/**
* A view-to-model converter that handles converting pointed or wrapped anchors with `id` and/or `name` attributes.
*
* @returns Returns a conversion callback.
*/ function $acba6d1585a37b53$var$dataViewModelAnchorInsertion(editor) {
    return (evt, data, conversionApi)=>{
        const viewItem = data.viewItem;
        const match = $acba6d1585a37b53$var$upcastMatcher(viewItem, false);
        if (!match || !conversionApi.consumable.test(viewItem, match)) return;
        if (!$acba6d1585a37b53$var$isEnabledNonEmptyAnchorConversion(editor) && !viewItem.isEmpty) return;
        const modelWriter = conversionApi.writer;
        const anchorId = viewItem.getAttribute("id");
        const anchorName = viewItem.getAttribute("name");
        const bookmarkId = anchorId || anchorName;
        const bookmark = modelWriter.createElement("bookmark", {
            bookmarkId: bookmarkId
        });
        if (!conversionApi.safeInsert(bookmark, data.modelCursor)) return;
        conversionApi.consumable.consume(viewItem, match);
        if (anchorId === anchorName) conversionApi.consumable.consume(viewItem, {
            attributes: [
                "name"
            ]
        });
        conversionApi.updateConversionResult(bookmark, data);
        const { modelCursor: modelCursor, modelRange: modelRange } = conversionApi.convertChildren(viewItem, data.modelCursor);
        data.modelCursor = modelCursor;
        data.modelRange = modelWriter.createRange(data.modelRange.start, modelRange.end);
    };
}
/**
* Normalize the bookmark configuration option `enableNonEmptyAnchorConversion`.
*/ function $acba6d1585a37b53$var$isEnabledNonEmptyAnchorConversion(editor) {
    const enableNonEmptyAnchorConversion = editor.config.get("bookmark.enableNonEmptyAnchorConversion");
    return enableNonEmptyAnchorConversion !== void 0 ? enableNonEmptyAnchorConversion : true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME = "bookmark-ui";
/**
* The UI plugin of the bookmark feature.
*
* It registers the `'bookmark'` UI button in the editor's {@link module:ui/componentfactory~ComponentFactory component factory}
* which inserts the `bookmark` element upon selection.
*/ var $acba6d1585a37b53$export$324452712111ec84 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The form view displayed inside the balloon.
	*/ formView = null;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $acba6d1585a37b53$export$20fa66bd04332290,
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c),
            (0, $5547ab21e02f1e9e$export$c46c0a800280391d)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "BookmarkUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        this._balloon = editor.plugins.get((0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c));
        if (editor.plugins.has("LinkUI")) this._registerLinkProvider();
        this._registerComponents();
        editor.conversion.for("editingDowncast").markerToHighlight({
            model: $acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME,
            view: {
                classes: [
                    "ck-fake-bookmark-selection"
                ]
            }
        });
        editor.conversion.for("editingDowncast").markerToElement({
            model: $acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME,
            view: (data, { writer: writer })=>{
                if (!data.markerRange.isCollapsed) return null;
                const markerElement = writer.createUIElement("span");
                writer.addClass([
                    "ck-fake-bookmark-selection",
                    "ck-fake-bookmark-selection_collapsed"
                ], markerElement);
                return markerElement;
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const t = editor.locale.t;
        const widgetToolbarRepository = this.editor.plugins.get((0, $5547ab21e02f1e9e$export$c46c0a800280391d));
        const defaultPositions = (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions;
        widgetToolbarRepository.register("bookmark", {
            ariaLabel: t("Bookmark toolbar"),
            items: editor.config.get("bookmark.toolbar"),
            getRelatedElement: $acba6d1585a37b53$var$getSelectedBookmarkWidget,
            balloonClassName: "ck-bookmark-balloon ck-toolbar-container",
            positions: [
                defaultPositions.southArrowNorth,
                defaultPositions.southArrowNorthMiddleWest,
                defaultPositions.southArrowNorthMiddleEast,
                defaultPositions.southArrowNorthWest,
                defaultPositions.southArrowNorthEast,
                defaultPositions.northArrowSouth,
                defaultPositions.northArrowSouthMiddleWest,
                defaultPositions.northArrowSouthMiddleEast,
                defaultPositions.northArrowSouthWest,
                defaultPositions.northArrowSouthEast,
                defaultPositions.viewportStickyNorth
            ]
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this.formView) this.formView.destroy();
    }
    /**
	* Creates views.
	*/ _createViews() {
        this.formView = this._createFormView();
        this._enableUserBalloonInteractions();
    }
    /**
	* Creates the {@link module:bookmark/ui/bookmarkformview~BookmarkFormView} instance.
	*/ _createFormView() {
        const editor = this.editor;
        const locale = editor.locale;
        const t = locale.t;
        const insertBookmarkCommand = editor.commands.get("insertBookmark");
        const updateBookmarkCommand = editor.commands.get("updateBookmark");
        const commands = [
            insertBookmarkCommand,
            updateBookmarkCommand
        ];
        const formView = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($acba6d1585a37b53$export$cf202654f5996fcf))(locale, $acba6d1585a37b53$var$getFormValidators(editor));
        formView.idInputView.fieldView.bind("value").to(updateBookmarkCommand, "value");
        formView.saveButtonView.bind("label").to(updateBookmarkCommand, "value", (value)=>value ? t("Save") : t("Insert"));
        formView.idInputView.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>areEnabled.some((isEnabled)=>isEnabled));
        formView.saveButtonView.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>areEnabled.some((isEnabled)=>isEnabled));
        this.listenTo(formView, "cancel", ()=>{
            this._hideFormView();
        });
        this.listenTo(formView, "submit", ()=>{
            if (formView.isValid()) {
                const value = formView.id;
                if (this._getSelectedBookmarkElement()) editor.execute("updateBookmark", {
                    bookmarkId: value
                });
                else editor.execute("insertBookmark", {
                    bookmarkId: value
                });
                this._hideFormView();
            }
        });
        this.listenTo(formView.idInputView, "change:errorText", ()=>{
            editor.ui.update();
        });
        return formView;
    }
    /**
	* Creates link form menu list entry, so it'll be possible to access
	* the list of the bookmarks from the link form.
	*/ _registerLinkProvider() {
        const t = this.editor.locale.t;
        const linksUI = this.editor.plugins.get("LinkUI");
        const bookmarkEditing = this.editor.plugins.get($acba6d1585a37b53$export$20fa66bd04332290);
        const getListItems = ()=>Array.from(bookmarkEditing.getAllBookmarkNames()).sort((a, b)=>a.localeCompare(b)).map((bookmarkId)=>({
                    id: bookmarkId,
                    href: `#${bookmarkId}`,
                    label: bookmarkId,
                    icon: (0, $e8dc502aba5ac3f5$export$3f43d461a1b0411e)
                }));
        const getItem = (href)=>{
            const bookmark = [
                ...bookmarkEditing.getAllBookmarkNames()
            ].find((item)=>`#${item}` === href);
            if (!bookmark) return null;
            return {
                href: href,
                label: bookmark,
                icon: (0, $e8dc502aba5ac3f5$export$37bba31b62772ac),
                tooltip: t("Scroll to bookmark")
            };
        };
        linksUI.registerLinksListProvider({
            label: t("Bookmarks"),
            emptyListPlaceholder: t("No bookmarks available."),
            navigate: ({ href: href })=>this._scrollToBookmark(href),
            getListItems: getListItems,
            getItem: getItem
        });
    }
    /**
	* Scrolls the editor to the bookmark with the given id.
	*/ _scrollToBookmark(href) {
        const bookmarkElement = this.editor.plugins.get($acba6d1585a37b53$export$20fa66bd04332290).getElementForBookmarkId(href.slice(1));
        if (!bookmarkElement) return false;
        this.editor.model.change((writer)=>{
            writer.setSelection(bookmarkElement, "on");
        });
        this.editor.editing.view.scrollToTheSelection({
            alignToTop: true,
            forceScroll: true
        });
        return true;
    }
    /**
	* Creates a toolbar Bookmark button. Clicking this button will show
	* a {@link #_balloon} attached to the selection.
	*/ _registerComponents() {
        const editor = this.editor;
        editor.ui.componentFactory.add("bookmark", ()=>{
            const buttonView = this._createBookmarkButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:bookmark", ()=>{
            return this._createBookmarkButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
        editor.ui.componentFactory.add("bookmarkPreview", (locale)=>{
            const updateBookmarkCommand = editor.commands.get("updateBookmark");
            const label = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
            label.extendTemplate({
                attributes: {
                    class: [
                        "ck-bookmark-toolbar__preview"
                    ]
                }
            });
            label.bind("text").to(updateBookmarkCommand, "value");
            return label;
        });
        editor.ui.componentFactory.add("editBookmark", (locale)=>{
            const updateBookmarkCommand = editor.commands.get("updateBookmark");
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            button.set({
                label: t("Edit bookmark"),
                icon: (0, $e8dc502aba5ac3f5$export$20da9dff06d8cce3),
                tooltip: true
            });
            button.bind("isEnabled").to(updateBookmarkCommand);
            this.listenTo(button, "execute", ()=>{
                this._showFormView();
            });
            return button;
        });
        editor.ui.componentFactory.add("removeBookmark", (locale)=>{
            const deleteCommand = editor.commands.get("delete");
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            button.set({
                label: t("Remove bookmark"),
                icon: (0, $e8dc502aba5ac3f5$export$634dbcc269865bc0),
                tooltip: true
            });
            button.bind("isEnabled").to(deleteCommand);
            this.listenTo(button, "execute", ()=>{
                editor.execute("delete");
                editor.editing.view.focus();
            });
            return button;
        });
    }
    /**
	* Creates a button for `bookmark` command to use either in toolbar or in menu bar.
	*/ _createBookmarkButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const view = new ButtonClass(locale);
        const insertCommand = editor.commands.get("insertBookmark");
        const updateCommand = editor.commands.get("updateBookmark");
        const t = locale.t;
        view.set({
            label: t("Bookmark"),
            icon: (0, $e8dc502aba5ac3f5$export$7e626e36f15bda71)
        });
        this.listenTo(view, "execute", ()=>{
            editor.editing.view.scrollToTheSelection();
            this._showFormView();
        });
        view.bind("isEnabled").toMany([
            insertCommand,
            updateCommand
        ], "isEnabled", (...areEnabled)=>areEnabled.some((isEnabled)=>isEnabled));
        view.bind("isOn").to(updateCommand, "value", (value)=>!!value);
        return view;
    }
    /**
	* Attaches actions that control whether the balloon panel containing the
	* {@link #formView} is visible or not.
	*/ _enableUserBalloonInteractions() {
        this.editor.keystrokes.set("Esc", (data, cancel)=>{
            if (this._isFormVisible) {
                this._hideFormView();
                cancel();
            }
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this.formView,
            activator: ()=>this._isFormInPanel,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>{
                this._hideFormView(false);
            }
        });
    }
    /**
	* Adds the {@link #formView} to the {@link #_balloon}.
	*/ _addFormView() {
        if (!this.formView) this._createViews();
        if (this._isFormInPanel) return;
        const updateBookmarkCommand = this.editor.commands.get("updateBookmark");
        this.formView.disableCssTransitions();
        this.formView.resetFormStatus();
        this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
        });
        this.formView.backButtonView.isVisible = updateBookmarkCommand.isEnabled;
        this.formView.idInputView.fieldView.value = updateBookmarkCommand.value || "";
        if (this._balloon.visibleView === this.formView) this.formView.idInputView.fieldView.select();
        this.formView.enableCssTransitions();
    }
    /**
	* Removes the {@link #formView} from the {@link #_balloon}.
	*/ _removeFormView(updateFocus = true) {
        this.formView.saveButtonView.focus();
        this.formView.idInputView.fieldView.reset();
        this._balloon.remove(this.formView);
        if (updateFocus) this.editor.editing.view.focus();
        this._hideFakeVisualSelection();
    }
    /**
	* Shows the {@link #formView}.
	*/ _showFormView() {
        if (!this.formView) this._createViews();
        if (!this._getSelectedBookmarkElement()) this._showFakeVisualSelection();
        this._addFormView();
        this._balloon.showStack("main");
        this._startUpdatingUI();
    }
    /**
	* Removes the {@link #formView} from the {@link #_balloon}.
	*/ _hideFormView(updateFocus = true) {
        if (!this._isFormInPanel) return;
        const editor = this.editor;
        this.stopListening(editor.ui, "update");
        this.stopListening(this._balloon, "change:visibleView");
        if (updateFocus) editor.editing.view.focus();
        this._removeFormView(updateFocus);
        this._hideFakeVisualSelection();
    }
    /**
	* Makes the UI react to the {@link module:ui/editorui/editorui~EditorUI#event:update} event to
	* reposition itself when the editor UI should be refreshed.
	*
	* See: {@link #_hideFormView} to learn when the UI stops reacting to the `update` event.
	*/ _startUpdatingUI() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        let prevSelectedBookmark = this._getSelectedBookmarkElement();
        let prevSelectionParent = getSelectionParent();
        const update = ()=>{
            const selectedBookmark = this._getSelectedBookmarkElement();
            const selectionParent = getSelectionParent();
            if (prevSelectedBookmark && !selectedBookmark || !prevSelectedBookmark && selectionParent !== prevSelectionParent) this._hideFormView();
            else if (this._isFormVisible) this._balloon.updatePosition(this._getBalloonPositionData());
            prevSelectedBookmark = selectedBookmark;
            prevSelectionParent = selectionParent;
        };
        function getSelectionParent() {
            return viewDocument.selection.focus.getAncestors().reverse().find((node)=>node.is("element"));
        }
        this.listenTo(editor.ui, "update", update);
        this.listenTo(this._balloon, "change:visibleView", update);
    }
    /**
	* Returns `true` when {@link #formView} is in the {@link #_balloon}.
	*/ get _isFormInPanel() {
        return !!this.formView && this._balloon.hasView(this.formView);
    }
    /**
	* Returns `true` when {@link #formView} is in the {@link #_balloon} and it is currently visible.
	*/ get _isFormVisible() {
        return !!this.formView && this._balloon.visibleView == this.formView;
    }
    /**
	* Returns positioning options for the {@link #_balloon}. They control the way the balloon is attached
	* to the target element or selection.
	*/ _getBalloonPositionData() {
        const view = this.editor.editing.view;
        const model = this.editor.model;
        let target;
        const bookmarkElement = this._getSelectedBookmarkElement();
        if (model.markers.has($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME)) {
            const markerViewElements = Array.from(this.editor.editing.mapper.markerNameToElements($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME));
            const newRange = view.createRange(view.createPositionBefore(markerViewElements[0]), view.createPositionAfter(markerViewElements[markerViewElements.length - 1]));
            target = view.domConverter.viewRangeToDom(newRange);
        } else if (bookmarkElement) target = ()=>{
            const mapper = this.editor.editing.mapper;
            const domConverter = view.domConverter;
            const viewElement = mapper.toViewElement(bookmarkElement);
            return domConverter.mapViewToDom(viewElement);
        };
        if (!target) return;
        return {
            target: target
        };
    }
    /**
	* Returns the bookmark {@link module:engine/view/attributeelement~ViewAttributeElement} under
	* the {@link module:engine/view/document~ViewDocument editing view's} selection or `null`
	* if there is none.
	*/ _getSelectedBookmarkElement() {
        const element = this.editor.model.document.selection.getSelectedElement();
        if (element && element.is("element", "bookmark")) return element;
        return null;
    }
    /**
	* Displays a fake visual selection when the contextual balloon is displayed.
	*
	* This adds a 'bookmark-ui' marker into the document that is rendered as a highlight on selected text fragment.
	*/ _showFakeVisualSelection() {
        const model = this.editor.model;
        model.change((writer)=>{
            const range = model.document.selection.getFirstRange();
            if (model.markers.has($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME)) writer.updateMarker($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME, {
                range: range
            });
            else if (range.start.isAtEnd) {
                const startPosition = range.start.getLastMatchingPosition(({ item: item })=>!model.schema.isContent(item), {
                    boundaries: range
                });
                writer.addMarker($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME, {
                    usingOperation: false,
                    affectsData: false,
                    range: writer.createRange(startPosition, range.end)
                });
            } else writer.addMarker($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME, {
                usingOperation: false,
                affectsData: false,
                range: range
            });
        });
    }
    /**
	* Hides the fake visual selection created in {@link #_showFakeVisualSelection}.
	*/ _hideFakeVisualSelection() {
        const model = this.editor.model;
        if (model.markers.has($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME)) model.change((writer)=>{
            writer.removeMarker($acba6d1585a37b53$var$VISUAL_SELECTION_MARKER_NAME);
        });
    }
};
/**
* Returns bookmark form validation callbacks.
*/ function $acba6d1585a37b53$var$getFormValidators(editor) {
    const { t: t } = editor;
    const bookmarkEditing = editor.plugins.get($acba6d1585a37b53$export$20fa66bd04332290);
    return [
        (form)=>{
            if (!form.id) return t("Bookmark must not be empty.");
        },
        (form)=>{
            if (form.id && /\s/.test(form.id)) return t("Bookmark name cannot contain space characters.");
        },
        (form)=>{
            const selectedElement = editor.model.document.selection.getSelectedElement();
            const existingBookmarkForId = bookmarkEditing.getElementForBookmarkId(form.id);
            if (selectedElement === existingBookmarkForId) return;
            if (existingBookmarkForId) return t("Bookmark name already exists.");
        }
    ];
}
/**
* Returns the currently selected bookmark view element.
*/ function $acba6d1585a37b53$var$getSelectedBookmarkWidget(selection) {
    const element = selection.getSelectedElement();
    if (!element || !(0, $5547ab21e02f1e9e$export$33101d01ca587c36)(element) || !element.getCustomProperty("bookmark")) return null;
    return element;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module bookmark/bookmark
*/ /**
* The bookmark feature.
*
* For a detailed overview, check the {@glink features/bookmarks Bookmarks} feature guide.
*/ var $acba6d1585a37b53$export$301ef70c5c7bdf65 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Bookmark";
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $acba6d1585a37b53$export$20fa66bd04332290,
            $acba6d1585a37b53$export$324452712111ec84,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 

/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


//#region src/function/identity.ts
/**
* Returns the input value unchanged.
*
* @template T - The type of the input value.
* @param x - The value to be returned.
* @returns The input value.
*
* @example
* // Returns 5
* identity(5);
*
* @example
* // Returns 'hello'
* identity('hello');
*
* @example
* // Returns { key: 'value' }
* identity({ key: 'value' });
*/ function $ff2b49e1e631aaa4$export$f0954fd7d5368655(x) {
    return x;
}


//#region src/object/mapValues.ts
/**
* Creates a new object with the same keys as the given object, but with values generated
* by running each own enumerable property of the object through the iteratee function.
*
* @template T - The type of the object.
* @template K - The type of the keys in the object.
* @template V - The type of the new values generated by the iteratee function.
*
* @param object - The object to iterate over.
* @param getNewValue - The function invoked per own enumerable property.
* @returns Returns the new mapped object.
*
* @example
* // Example usage:
* const obj = { a: 1, b: 2 };
* const result = mapValues(obj, (value) => value * 2);
* console.log(result); // { a: 2, b: 4 }
*/ function $b5e20cae22ddf119$export$825e789796ab7275(object, getNewValue) {
    const result = {};
    const keys = Object.keys(object);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = object[key];
        result[key] = getNewValue(value, key, object);
    }
    return result;
}




//#region src/compat/object/property.ts
/**
* Creates a function that returns the value at a given path of an object.
*
* @template T - The type of object.
* @template R - The type of the value to return.
* @param path - The path of the property to get.
* @returns Returns a new function that takes an object and returns the value at the specified path.
*
* @example
* const getObjectValue = property('a.b.c');
* const result = getObjectValue({ a: { b: { c: 3 } } });
* console.log(result); // => 3
*
* @example
* const getObjectValue = property(['a', 'b', 'c']);
* const result = getObjectValue({ a: { b: { c: 3 } } });
* console.log(result); // => 3
*/ function $2a590c26162abc88$export$d541bacb2bda4494(path) {
    return function(object) {
        return (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(object, path);
    };
}



//#region src/object/cloneDeep.ts
/**
* Creates a deep clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeep(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = cloneDeep(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an array with nested objects
* const arr = [1, { a: 1 }, [1, 2, 3]];
* const clonedArr = cloneDeep(arr);
* arr[1].a = 2;
* console.log(arr); // [1, { a: 2 }, [1, 2, 3]]
* console.log(clonedArr); // [1, { a: 1 }, [1, 2, 3]]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = cloneDeep(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an object with nested objects
* const obj = { a: 1, b: { c: 1 } };
* const clonedObj = cloneDeep(obj);
* obj.b.c = 2;
* console.log(obj); // { a: 1, b: { c: 2 } }
* console.log(clonedObj); // { a: 1, b: { c: 1 } }
* console.log(clonedObj === obj); // false
*/ function $42c0889a67a197a5$export$629a2bd3f5a49ecc(obj) {
    return (0, $2998c9886974d5e9$export$c02997b71e1192aa)(obj, void 0, obj, /* @__PURE__ */ new Map(), void 0);
}







//#region src/compat/predicate/isMatchWith.ts
/**
* Performs a deep comparison between a target value and a source pattern to determine if they match,
* using a custom comparison function for fine-grained control over the matching logic.
*
* This function recursively traverses both values, calling the custom compare function for each
* property/element pair. If the compare function returns a boolean, that result is used directly.
* If it returns undefined, the default matching behavior continues recursively.
*
* The matching behavior varies by data type:
* - **Objects**: Matches if all properties in the source exist in the target and match
* - **Arrays**: Matches if all elements in the source array can be found in the target array (order-independent)
* - **Maps**: Matches if all key-value pairs in the source Map exist and match in the target Map
* - **Sets**: Matches if all elements in the source Set can be found in the target Set
* - **Functions**: Matches using strict equality, or object comparison if the function has properties
* - **Primitives**: Matches using strict equality
*
* Special cases:
* - Empty arrays, Maps, and Sets always match any target
* - An empty object matches any target at the top level, but at nested levels it only matches object targets
* - `null` and `undefined` source values have specific matching rules
* - Circular references are handled using an internal stack to prevent infinite recursion
*
* @param target - The value to be tested for matching
* @param source - The pattern/template to match against
* @param [compare] - Optional custom comparison function that receives:
*   - `objValue` - The value from the target at the current path
*   - `srcValue` - The value from the source at the current path
*   - `key` - The property key or array index being compared
*   - `object` - The parent object/array from the target
*   - `source` - The parent object/array from the source
*   - `stack` - Internal Map used for circular reference detection
*   Should return `true` for a match, `false` for no match, or `undefined` to continue with default behavior
*
* @returns `true` if the target matches the source pattern, `false` otherwise
*
* @example
* // Basic matching without custom comparator
* isMatchWith({ a: 1, b: 2 }, { a: 1 }); // true
* isMatchWith([1, 2, 3], [1, 3]); // true
*
* @example
* // Custom comparison for case-insensitive string matching
* const caseInsensitiveCompare = (objVal, srcVal) => {
*   if (typeof objVal === 'string' && typeof srcVal === 'string') {
*     return objVal.toLowerCase() === srcVal.toLowerCase();
*   }
*   return undefined; // Use default behavior for non-strings
* };
*
* isMatchWith(
*   { name: 'JOHN', age: 30 },
*   { name: 'john' },
*   caseInsensitiveCompare
* ); // true
*
* @example
* // Custom comparison for range matching
* const rangeCompare = (objVal, srcVal, key) => {
*   if (key === 'age' && typeof srcVal === 'object' && srcVal.min !== undefined) {
*     return objVal >= srcVal.min && objVal <= srcVal.max;
*   }
*   return undefined;
* };
*
* isMatchWith(
*   { name: 'John', age: 25 },
*   { age: { min: 18, max: 30 } },
*   rangeCompare
* ); // true
*/ function $5c915058ede3c362$export$4a897dfaa5ec0c53(target, source, compare) {
    if (typeof compare !== "function") return $5c915058ede3c362$export$4a897dfaa5ec0c53(target, source, ()=>void 0);
    return $5c915058ede3c362$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== void 0) return Boolean(isEqual);
        return $5c915058ede3c362$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack, false);
    }, /* @__PURE__ */ new Map(), true);
}
function $5c915058ede3c362$var$isMatchWithInternal(target, source, compare, stack, isRoot = false) {
    if (source === target) return true;
    switch(typeof source){
        case "object":
            return $5c915058ede3c362$var$isObjectMatch(target, source, compare, stack, isRoot);
        case "function":
            if (Object.keys(source).length > 0) return $5c915058ede3c362$var$isMatchWithInternal(target, {
                ...source
            }, compare, stack, isRoot);
            return (0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(target, source);
        default:
            if (!(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(target)) return (0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(target, source);
            if (isRoot) {
                if (typeof source === "string") return source === "";
                return true;
            }
            return (0, $6c0fdfdc0dc6ac8c$export$9663ddc1cf085b32)(target, source);
    }
}
function $5c915058ede3c362$var$isObjectMatch(target, source, compare, stack, isRoot = false) {
    if (source == null) return true;
    if (Array.isArray(source)) return $5c915058ede3c362$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $5c915058ede3c362$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $5c915058ede3c362$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null) return isRoot && keys.length === 0;
    if (isRoot) {
        if ((0, $f6e1f14e6ef1ca2f$export$c3825b437cbdea5c)(target)) target = Object(target);
    } else {
        const tag = (0, $c84544af3ff2d0ac$export$dad497fe1f6e27c0)(target);
        if (tag !== "[object Object]" && tag !== "[object Arguments]") return false;
    }
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!(key in target)) return false;
            if (source[key] === void 0 && target[key] !== void 0) return false;
            if (source[key] === null && target[key] !== null) return false;
            if (!compare(target[key], source[key], key, target, source, stack)) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $5c915058ede3c362$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries())if (compare(target.get(key), sourceValue, key, target, source, stack) === false) return false;
    return true;
}
function $5c915058ede3c362$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = /* @__PURE__ */ new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            if (compare(targetItem, sourceItem, i, target, source, stack)) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $5c915058ede3c362$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $5c915058ede3c362$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}


//#region src/compat/predicate/isMatch.ts
/**
* Checks if the target matches the source by comparing their structures and values.
* This function supports deep comparison for objects, arrays, maps, and sets.
*
* @param target - The target value to match against.
* @param source - The source value to match with.
* @returns Returns `true` if the target matches the source, otherwise `false`.
*
* @example
* // Basic usage
* isMatch({ a: 1, b: 2 }, { a: 1 }); // true
*
* @example
* // Matching arrays
* isMatch([1, 2, 3], [1, 2, 3]); // true
*
* @example
* // Matching maps
* const targetMap = new Map([['key1', 'value1'], ['key2', 'value2']]);
* const sourceMap = new Map([['key1', 'value1']]);
* isMatch(targetMap, sourceMap); // true
*
* @example
* // Matching sets
* const targetSet = new Set([1, 2, 3]);
* const sourceSet = new Set([1, 2]);
* isMatch(targetSet, sourceSet); // true
*/ function $9e42e1792851ca01$export$b74c33566721f70f(target, source) {
    return (0, $5c915058ede3c362$export$4a897dfaa5ec0c53)(target, source, ()=>void 0);
}


//#region src/compat/predicate/matches.ts
/**
* Creates a function that performs a deep comparison between a given target and the source object.
*
* @template T
* @template V
* @param source - The source object to create the matcher from.
* @returns Returns a function that takes a target object and returns `true` if the target matches the source, otherwise `false`.
*
* @example
* // Basic usage
* const matcher = matches({ a: 1, b: 2 });
* matcher({ a: 1, b: 2, c: 3 }); // true
* matcher({ a: 1, c: 3 }); // false
*
* @example
* // Matching arrays
* const arrayMatcher = matches([1, 2, 3]);
* arrayMatcher([1, 2, 3, 4]); // true
* arrayMatcher([4, 5, 6]); // false
*
* @example
* // Matching objects with nested structures
* const nestedMatcher = matches({ a: { b: 2 } });
* nestedMatcher({ a: { b: 2, c: 3 } }); // true
* nestedMatcher({ a: { c: 3 } }); // false
*/ function $f6d2a36f591e4de5$export$de994efd351b291c(source) {
    source = (0, $42c0889a67a197a5$export$629a2bd3f5a49ecc)(source);
    return (target)=>{
        return (0, $9e42e1792851ca01$export$b74c33566721f70f)(target, source);
    };
}











//#region src/compat/object/has.ts
/**
* Checks if a given path exists within an object.
*
* You can provide the path as a single property key, an array of property keys,
* or a string representing a deep path.
*
* If the path is an index and the object is an array or an arguments object, the function will verify
* if the index is valid and within the bounds of the array or arguments object, even if the array or
* arguments object is sparse (i.e., not all indexes are defined).
*
* @param object - The object to query.
* @param path - The path to check. This can be a single property key,
*        an array of property keys, or a string representing a deep path.
* @returns Returns `true` if the path exists in the object, `false` otherwise.
*
* @example
*
* const obj = { a: { b: { c: 3 } } };
*
* has(obj, 'a'); // true
* has(obj, ['a', 'b']); // true
* has(obj, ['a', 'b', 'c']); // true
* has(obj, 'a.b.c'); // true
* has(obj, 'a.b.d'); // false
* has(obj, ['a', 'b', 'c', 'd']); // false
* has([], 0); // false
* has([1, 2, 3], 2); // true
* has([1, 2, 3], 5); // false
*/ function $509c94e86b712a6b$export$a4f4bb6b1453fff5(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === "string" && (0, $671e243dbeff607e$export$88ed3a5a87f128f0)(path) && !(path in Object(object))) resolvedPath = (0, $18fb98e16e6d1601$export$440836a238ff8548)(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = (0, $60c0e84f71bed535$export$c0d0115e766e14c3)(resolvedPath[i]);
        if (current == null || !Object.hasOwn(current, key)) {
            if (!((Array.isArray(current) || (0, $01e9c819d0970ac4$export$dbbb9d8cd6fff001)(current)) && (0, $821a38fbe0a02313$export$ba3dc792055c2f45)(key) && Number(key) < current.length)) return false;
        }
        current = current[key];
    }
    return true;
}


//#region src/compat/predicate/matchesProperty.ts
/**
* Creates a function that checks if a given target object matches a specific property value.
*
* The returned function takes a target object and determines if the property at the
* specified path within the target object is equal to the given value.
*
* @param property - The property path to check within the target object.
*     This can be a single property key or an array of property keys.
* @param source - The value to compare against the property value in the target object.
*
* @returns A function that takes a target object and returns
*     `true` if the property value at the given path in the target object matches the provided value,
*     otherwise returns `false`.
*
* @example
* // Using a single property key
* const checkName = matchesProperty('name', 'Alice');
* console.log(checkName({ name: 'Alice' })); // true
* console.log(checkName({ name: 'Bob' })); // false
*
* // Using an array of property keys
* const checkNested = matchesProperty(['address', 'city'], 'New York');
* console.log(checkNested({ address: { city: 'New York' } })); // true
* console.log(checkNested({ address: { city: 'Los Angeles' } })); // false
*/ function $6948c144cc996225$export$d3e698d53f63efcd(property, source) {
    switch(typeof property){
        case "object":
            if (Object.is(property?.valueOf(), -0)) property = "-0";
            break;
        case "number":
            property = (0, $60c0e84f71bed535$export$c0d0115e766e14c3)(property);
            break;
    }
    source = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(source);
    return function(target) {
        const result = (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(target, property);
        if (result === void 0) return (0, $509c94e86b712a6b$export$a4f4bb6b1453fff5)(target, property);
        if (source === void 0) return result === void 0;
        return (0, $9e42e1792851ca01$export$b74c33566721f70f)(result, source);
    };
}


//#region src/compat/util/iteratee.ts
/**
* Creates a function that returns a value from an element in a collection.
*
* You can call `iteratee` with the following types of arguments:
*
* - **Function**: Returns the function as-is, which will be called with the element from the collection.
* - **Property name**: Returns the value of the specified property from the element.
* - **Property-value pair**: Returns a boolean indicating whether the element's property matches the given value.
* - **Partial object**: Returns a boolean indicating whether the element matches the properties of the partial object.
*
* If you don't provide any arguments or pass `null`, this function will return a function that simply returns its input unchanged.
*
* @param value - The value to convert to an iteratee.
* @returns Returns the new iteratee function.
* @example
* const func = iteratee();
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [{ a: 1 }, { a: 2 }, { a: 3 }]
*
* const func = iteratee((object) => object.a);
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [1, 2, 3]
*
* const func = iteratee('a');
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [1, 2, 3]
*
* const func = iteratee({ a: 1 });
* [{ a: 1 }, { a: 2 }, { a: 3 }].find(func) // => { a: 1 }
*
* const func = iteratee(['a', 1]);
* [{ a: 1 }, { a: 2 }, { a: 3 }].find(func) // => { a: 1 }
*/ function $0abe2fbaeda42eb6$export$e6b1ca5afaaa20ac(value) {
    if (value == null) return 0, $ff2b49e1e631aaa4$export$f0954fd7d5368655;
    switch(typeof value){
        case "function":
            return value;
        case "object":
            if (Array.isArray(value) && value.length === 2) return (0, $6948c144cc996225$export$d3e698d53f63efcd)(value[0], value[1]);
            return (0, $f6d2a36f591e4de5$export$de994efd351b291c)(value);
        default:
            return (0, $2a590c26162abc88$export$d541bacb2bda4494)(value);
    }
}


//#region src/compat/object/mapValues.ts
/**
* Creates a new object with the same keys as the given object, but with values generated
* by running each own enumerable property of the object through the iteratee function.
*
* @template T - The type of the object.
* @template K - The type of the keys in the object.
* @template V - The type of the new values generated by the iteratee function.
*
* @param object - The object to iterate over.
* @param [getNewValue] -
*        The function invoked per own enumerable property, or a path to generate new values.
* @returns Returns the new mapped object.
*
* @example
* // Example usage:
* const obj = { a: 1, b: 2 };
* const result = mapValues(obj, (value) => value * 2);
* console.log(result); // { a: 2, b: 4 }
*/ function $df7a9104588c92f3$export$825e789796ab7275(object, getNewValue = (0, $ff2b49e1e631aaa4$export$f0954fd7d5368655)) {
    if (object == null) return {};
    return (0, $b5e20cae22ddf119$export$825e789796ab7275)(object, (0, $0abe2fbaeda42eb6$export$e6b1ca5afaaa20ac)(getNewValue));
}




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/utils/plaintexttohtml
*/ /**
* Converts plain text to its HTML-ized version.
*
* @param text The plain text to convert.
* @returns HTML generated from the plain text.
*/ function $4fa913ac1af6a08c$export$a288b66b8f10ffac(text) {
    text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;");
    if (text.includes("</p><p>") || text.includes("<br>")) text = `<p>${text}</p>`;
    return text;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/clipboardobserver
*/ /**
* Clipboard events observer.
*
* Fires the following events:
*
* * {@link module:engine/view/document~ViewDocument#event:clipboardInput},
* * {@link module:engine/view/document~ViewDocument#event:paste},
* * {@link module:engine/view/document~ViewDocument#event:copy},
* * {@link module:engine/view/document~ViewDocument#event:cut},
* * {@link module:engine/view/document~ViewDocument#event:drop},
* * {@link module:engine/view/document~ViewDocument#event:dragover},
* * {@link module:engine/view/document~ViewDocument#event:dragging},
* * {@link module:engine/view/document~ViewDocument#event:dragstart},
* * {@link module:engine/view/document~ViewDocument#event:dragend},
* * {@link module:engine/view/document~ViewDocument#event:dragenter},
* * {@link module:engine/view/document~ViewDocument#event:dragleave}.
*
* **Note**: This observer is not available by default (ckeditor5-engine does not add it on its own).
* To make it available, it needs to be added to {@link module:engine/view/document~ViewDocument} by using
* the {@link module:engine/view/view~EditingView#addObserver `View#addObserver()`} method. Alternatively, you can load the
* {@link module:clipboard/clipboard~Clipboard} plugin which adds this observer automatically (because it uses it).
*/ var $4fa913ac1af6a08c$export$fe2cb86f10559d29 = class extends (0, $b9b9f2bdf9c6137f$export$fc1db128570de841) {
    domEventType = [
        "paste",
        "copy",
        "cut",
        "drop",
        "dragover",
        "dragstart",
        "dragend",
        "dragenter",
        "dragleave"
    ];
    constructor(view){
        super(view);
        const viewDocument = this.document;
        this.listenTo(viewDocument, "paste", handleInput("clipboardInput"), {
            priority: "low"
        });
        this.listenTo(viewDocument, "drop", handleInput("clipboardInput"), {
            priority: "low"
        });
        this.listenTo(viewDocument, "dragover", handleInput("dragging"), {
            priority: "low"
        });
        function handleInput(type) {
            return (evt, data)=>{
                data.preventDefault();
                const targetRanges = data.dropRange ? [
                    data.dropRange
                ] : null;
                const dataTransfer = data.dataTransfer;
                const eventInfo = new (0, $c7bc2cb7e2db0227$export$3f63aa522937812c)(viewDocument, type);
                let content = "";
                if (dataTransfer.getData("text/html")) content = dataTransfer.getData("text/html");
                else if (dataTransfer.getData("text/plain")) content = $4fa913ac1af6a08c$export$a288b66b8f10ffac(dataTransfer.getData("text/plain"));
                viewDocument.fire(eventInfo, {
                    dataTransfer: dataTransfer,
                    content: content,
                    method: evt.name,
                    targetRanges: targetRanges,
                    target: data.target,
                    domEvent: data.domEvent
                });
                if (eventInfo.stop.called) data.stopPropagation();
            };
        }
    }
    onDomEvent(domEvent) {
        const nativeDataTransfer = "clipboardData" in domEvent ? domEvent.clipboardData : domEvent.dataTransfer;
        const cacheFiles = domEvent.type == "drop" || domEvent.type == "paste";
        const evtData = {
            dataTransfer: new (0, $b9b9f2bdf9c6137f$export$1eefed0a4af75b0b)(nativeDataTransfer, {
                cacheFiles: cacheFiles
            })
        };
        if (domEvent.type == "drop" || domEvent.type == "dragover") {
            const domRange = (0, $c7bc2cb7e2db0227$export$70a9dc425da3f6b0)(domEvent);
            evtData.dropRange = domRange && this.view.domConverter.domRangeToView(domRange);
        }
        this.fire(domEvent.type, domEvent, evtData);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/utils/normalizeclipboarddata
*/ /**
* Removes some popular browser quirks out of the clipboard data (HTML).
* Removes all HTML comments. These are considered an internal thing and it makes little sense if they leak into the editor data.
*
* @param data The HTML data to normalize.
* @returns Normalized HTML.
* @internal
*/ function $4fa913ac1af6a08c$export$5b5994a8150e2345(data) {
    return data.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (fullMatch, spaces)=>{
        if (spaces.length == 1) return " ";
        return spaces;
    }).replace(/<!--[\s\S]*?-->/g, "");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $4fa913ac1af6a08c$var$smallPaddingElements = [
    "figcaption",
    "li"
];
const $4fa913ac1af6a08c$var$listElements = [
    "ol",
    "ul"
];
/**
* Converts {@link module:engine/view/item~ViewItem view item} and all of its children to plain text.
*
* @param converter The converter instance.
* @param viewItem View item to convert.
* @returns Plain text representation of `viewItem`.
*/ function $4fa913ac1af6a08c$export$7c1b962cbec163d6(converter, viewItem) {
    if (viewItem.is("$text") || viewItem.is("$textProxy")) return viewItem.data;
    if (viewItem.is("element", "img") && viewItem.hasAttribute("alt")) return viewItem.getAttribute("alt");
    if (viewItem.is("element", "br")) return "\n";
    /**
	* Item is a document fragment, attribute element or container element. It doesn't
	* have it's own text value, so we need to convert its children elements.
	*/ let text = "";
    let prev = null;
    for (const child of viewItem.getChildren()){
        text += $4fa913ac1af6a08c$var$newLinePadding(child, prev) + $4fa913ac1af6a08c$export$7c1b962cbec163d6(converter, child);
        prev = child;
    }
    if (viewItem.is("rawElement")) {
        const tempElement = document.implementation.createHTMLDocument("").createElement("div");
        viewItem.render(tempElement, converter);
        text += $4fa913ac1af6a08c$var$domElementToPlainText(tempElement);
    }
    return text;
}
/**
* Recursively converts DOM element and all of its children to plain text.
*/ function $4fa913ac1af6a08c$var$domElementToPlainText(element) {
    let text = "";
    if (element.nodeType === Node.TEXT_NODE) return element.textContent;
    else if (element.tagName === "BR") return "\n";
    for (const child of element.childNodes)text += $4fa913ac1af6a08c$var$domElementToPlainText(child);
    return text;
}
/**
* Returns new line padding to prefix the given elements with.
*/ function $4fa913ac1af6a08c$var$newLinePadding(element, previous) {
    if (!previous) return "";
    if (element.is("element", "li") && !element.isEmpty && element.getChild(0).is("containerElement")) return "\n\n";
    if ($4fa913ac1af6a08c$var$listElements.includes(element.name) && $4fa913ac1af6a08c$var$listElements.includes(previous.name)) /**
	* Because `<ul>` and `<ol>` are ViewAttributeElements, two consecutive lists will not have any padding between
	* them (see the `if` statement below). To fix this, we need to make an exception for this case.
	*/ return "\n\n";
    if (!element.is("containerElement") && !previous.is("containerElement")) return "";
    if ($4fa913ac1af6a08c$var$smallPaddingElements.includes(element.name) || $4fa913ac1af6a08c$var$smallPaddingElements.includes(previous.name)) return "\n";
    if (element.is("element") && element.getCustomProperty("dataPipeline:transparentRendering") || previous.is("element") && previous.getCustomProperty("dataPipeline:transparentRendering")) return "";
    return "\n\n";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/clipboardmarkersutils
*/ /**
* Part of the clipboard logic. Responsible for collecting markers from selected fragments
* and restoring them with proper positions in pasted elements.
*
* @internal
*/ var $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Map of marker names that can be copied.
	*
	* @internal
	*/ _markersToCopy = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ClipboardMarkersUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Registers marker name as copyable in clipboard pipeline.
	*
	* @param markerName Name of marker that can be copied.
	* @param config Configuration that describes what can be performed on specified marker.
	* @internal
	*/ _registerMarkerToCopy(markerName, config) {
        this._markersToCopy.set(markerName, config);
    }
    /**
	* Performs copy markers on provided selection and paste it to fragment returned from `getCopiedFragment`.
	*
	* 	1. Picks all markers in provided selection.
	* 	2. Inserts fake markers to document.
	* 	3. Gets copied selection fragment from document.
	* 	4. Removes fake elements from fragment and document.
	* 	5. Inserts markers in the place of removed fake markers.
	*
	* Due to selection modification, when inserting items, `getCopiedFragment` must *always* operate on `writer.model.document.selection'.
	* Do not use any other custom selection object within callback, as this will lead to out-of-bounds exceptions in rare scenarios.
	*
	* @param action Type of clipboard action.
	* @param selection Selection to be checked.
	* @param getCopiedFragment	Callback that performs copy of selection and returns it as fragment.
	* @internal
	*/ _copySelectedFragmentWithMarkers(action, selection, getCopiedFragment = (writer)=>writer.model.getSelectedContent(writer.model.document.selection)) {
        return this.editor.model.change((writer)=>{
            const oldSelection = writer.model.document.selection;
            writer.setSelection(selection);
            const sourceSelectionInsertedMarkers = this._insertFakeMarkersIntoSelection(writer, writer.model.document.selection, action);
            const fragment = getCopiedFragment(writer);
            const fakeMarkersRangesInsideRange = this._removeFakeMarkersInsideElement(writer, fragment);
            for (const [markerName, elements] of Object.entries(sourceSelectionInsertedMarkers)){
                fakeMarkersRangesInsideRange[markerName] ||= writer.createRangeIn(fragment);
                for (const element of elements)writer.remove(element);
            }
            fragment.markers.clear();
            for (const [markerName, range] of Object.entries(fakeMarkersRangesInsideRange))fragment.markers.set(markerName, range);
            writer.setSelection(oldSelection);
            return fragment;
        });
    }
    /**
	* Performs paste of markers on already pasted element.
	*
	* 	1. Inserts fake markers that are present in fragment element (such fragment will be processed in `getPastedDocumentElement`).
	* 	2. Calls `getPastedDocumentElement` and gets element that is inserted into root model.
	* 	3. Removes all fake markers present in transformed element.
	* 	4. Inserts new markers with removed fake markers ranges into pasted fragment.
	*
	* There are multiple edge cases that have to be considered before calling this function:
	*
	* 	* `markers` are inserted into the same element that must be later transformed inside `getPastedDocumentElement`.
	* 	* Fake marker elements inside `getPastedDocumentElement` can be cloned, but their ranges cannot overlap.
	* 	* If `duplicateOnPaste` is `true` in marker config then associated marker ID is regenerated before pasting.
	*
	* @param markers Object that maps marker name to corresponding range.
	* @param getPastedDocumentElement Getter used to get target markers element.
	* @internal
	*/ _pasteMarkersIntoTransformedElement(markers, getPastedDocumentElement) {
        const pasteMarkers = this._getPasteMarkersFromRangeMap(markers);
        return this.editor.model.change((writer)=>{
            const sourceFragmentFakeMarkers = this._insertFakeMarkersElements(writer, pasteMarkers);
            const transformedElement = getPastedDocumentElement(writer);
            const removedFakeMarkers = this._removeFakeMarkersInsideElement(writer, transformedElement);
            for (const element of Object.values(sourceFragmentFakeMarkers).flat())writer.remove(element);
            for (const [markerName, range] of Object.entries(removedFakeMarkers))if (!writer.model.markers.has(markerName)) writer.addMarker(markerName, {
                usingOperation: true,
                affectsData: true,
                range: range
            });
            return transformedElement;
        });
    }
    /**
	* Pastes document fragment with markers to document.
	* If `duplicateOnPaste` is `true` in marker config then associated markers IDs
	* are regenerated before pasting to avoid markers duplications in content.
	*
	* @param fragment Document fragment that should contain already processed by pipeline markers.
	* @internal
	*/ _pasteFragmentWithMarkers(fragment) {
        const pasteMarkers = this._getPasteMarkersFromRangeMap(fragment.markers);
        fragment.markers.clear();
        for (const copyableMarker of pasteMarkers)fragment.markers.set(copyableMarker.name, copyableMarker.range);
        return this.editor.model.insertContent(fragment);
    }
    /**
	* In some situations we have to perform copy on selected fragment with certain markers. This function allows to temporarily bypass
	* restrictions on markers that we want to copy.
	*
	* This function executes `executor()` callback. For the duration of the callback, if the clipboard pipeline is used to copy
	* content, markers with the specified name will be copied to the clipboard as well.
	*
	* @param markerName Which markers should be copied.
	* @param executor Callback executed.
	* @param config Optional configuration flags used to copy (such like partial copy flag).
	* @internal
	*/ _forceMarkersCopy(markerName, executor, config = {
        allowedActions: "all",
        copyPartiallySelected: true,
        duplicateOnPaste: true
    }) {
        const before = this._markersToCopy.get(markerName);
        this._markersToCopy.set(markerName, config);
        executor();
        if (before) this._markersToCopy.set(markerName, before);
        else this._markersToCopy.delete(markerName);
    }
    /**
	* Checks if marker can be copied.
	*
	* @param markerName Name of checked marker.
	* @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
	* @internal
	*/ _isMarkerCopyable(markerName, action) {
        const config = this._getMarkerClipboardConfig(markerName);
        if (!config) return false;
        if (!action) return true;
        const { allowedActions: allowedActions } = config;
        return allowedActions === "all" || allowedActions.includes(action);
    }
    /**
	* Checks if marker has any clipboard copy behavior configuration.
	*
	* @param markerName Name of checked marker.
	*/ _hasMarkerConfiguration(markerName) {
        return !!this._getMarkerClipboardConfig(markerName);
    }
    /**
	* Returns marker's configuration flags passed during registration.
	*
	* @param markerName Name of marker that should be returned.
	* @internal
	*/ _getMarkerClipboardConfig(markerName) {
        const [markerNamePrefix] = markerName.split(":");
        return this._markersToCopy.get(markerNamePrefix) || null;
    }
    /**
	* First step of copying markers. It looks for markers intersecting with given selection and inserts `$marker` elements
	* at positions where document markers start or end. This way `$marker` elements can be easily copied together with
	* the rest of the content of the selection.
	*
	* @param writer An instance of the model writer.
	* @param selection Selection to be checked.
	* @param action Type of clipboard action.
	*/ _insertFakeMarkersIntoSelection(writer, selection, action) {
        const copyableMarkers = this._getCopyableMarkersFromSelection(writer, selection, action);
        return this._insertFakeMarkersElements(writer, copyableMarkers);
    }
    /**
	* Returns array of markers that can be copied in specified selection.
	*
	* If marker cannot be copied partially (according to `copyPartiallySelected` configuration flag) and
	* is not present entirely in any selection range then it will be skipped.
	*
	* @param writer An instance of the model writer.
	* @param selection  Selection which will be checked.
	* @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
	*/ _getCopyableMarkersFromSelection(writer, selection, action) {
        const selectionRanges = Array.from(selection.getRanges());
        const markersInRanges = new Set(selectionRanges.flatMap((selectionRange)=>Array.from(writer.model.markers.getMarkersIntersectingRange(selectionRange))));
        const isSelectionMarkerCopyable = (marker)=>{
            if (!this._isMarkerCopyable(marker.name, action)) return false;
            const { copyPartiallySelected: copyPartiallySelected } = this._getMarkerClipboardConfig(marker.name);
            if (!copyPartiallySelected) {
                const markerRange = marker.getRange();
                return selectionRanges.some((selectionRange)=>selectionRange.containsRange(markerRange, true));
            }
            return true;
        };
        return Array.from(markersInRanges).filter(isSelectionMarkerCopyable).map((copyableMarker)=>{
            return {
                name: action === "dragstart" ? this._getUniqueMarkerName(copyableMarker.name) : copyableMarker.name,
                range: copyableMarker.getRange()
            };
        });
    }
    /**
	* Picks all markers from markers map that can be pasted.
	* If `duplicateOnPaste` is `true`, it regenerates their IDs to ensure uniqueness.
	* If marker is not registered, it will be kept in the array anyway.
	*
	* @param markers Object that maps marker name to corresponding range.
	* @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
	*/ _getPasteMarkersFromRangeMap(markers, action = null) {
        const { model: model } = this.editor;
        return (markers instanceof Map ? Array.from(markers.entries()) : Object.entries(markers)).flatMap(([markerName, range])=>{
            if (!this._hasMarkerConfiguration(markerName)) return [
                {
                    name: markerName,
                    range: range
                }
            ];
            if (this._isMarkerCopyable(markerName, action)) {
                const copyMarkerConfig = this._getMarkerClipboardConfig(markerName);
                const isInGraveyard = model.markers.has(markerName) && model.markers.get(markerName).getRange().root.rootName === "$graveyard";
                if (copyMarkerConfig.duplicateOnPaste || isInGraveyard) markerName = this._getUniqueMarkerName(markerName);
                return [
                    {
                        name: markerName,
                        range: range
                    }
                ];
            }
            return [];
        });
    }
    /**
	* Inserts specified array of fake markers elements to document and assigns them `type` and `name` attributes.
	* Fake markers elements are used to calculate position of markers on pasted fragment that were transformed during
	* steps between copy and paste.
	*
	* @param writer An instance of the model writer.
	* @param markers Array of markers that will be inserted.
	*/ _insertFakeMarkersElements(writer, markers) {
        const mappedMarkers = {};
        const sortedMarkers = markers.flatMap((marker)=>{
            const { start: start, end: end } = marker.range;
            return [
                {
                    position: start,
                    marker: marker,
                    type: "start"
                },
                {
                    position: end,
                    marker: marker,
                    type: "end"
                }
            ];
        }).sort(({ position: posA }, { position: posB })=>posA.isBefore(posB) ? 1 : -1);
        for (const { position: position, marker: marker, type: type } of sortedMarkers){
            const fakeMarker = writer.createElement("$marker", {
                "data-name": marker.name,
                "data-type": type
            });
            if (!mappedMarkers[marker.name]) mappedMarkers[marker.name] = [];
            mappedMarkers[marker.name].push(fakeMarker);
            writer.insert(fakeMarker, position);
        }
        return mappedMarkers;
    }
    /**
	* Removes all `$marker` elements from the given document fragment.
	*
	* Returns an object where keys are marker names, and values are ranges corresponding to positions
	* where `$marker` elements were inserted.
	*
	* If the document fragment had only one `$marker` element for given marker (start or end) the other boundary is set automatically
	* (to the end or start of the document fragment, respectively).
	*
	* @param writer An instance of the model writer.
	* @param rootElement The element to be checked.
	*/ _removeFakeMarkersInsideElement(writer, rootElement) {
        const fakeMarkersRanges = this._getAllFakeMarkersFromElement(writer, rootElement).reduce((acc, fakeMarker)=>{
            const position = fakeMarker.markerElement && writer.createPositionBefore(fakeMarker.markerElement);
            let prevFakeMarker = acc[fakeMarker.name];
            let skipAssign = false;
            if (prevFakeMarker?.start && prevFakeMarker?.end) {
                if (this._getMarkerClipboardConfig(fakeMarker.name).duplicateOnPaste) acc[this._getUniqueMarkerName(fakeMarker.name)] = acc[fakeMarker.name];
                else skipAssign = true;
                prevFakeMarker = null;
            }
            if (!skipAssign) acc[fakeMarker.name] = {
                ...prevFakeMarker,
                [fakeMarker.type]: position
            };
            if (fakeMarker.markerElement) writer.remove(fakeMarker.markerElement);
            return acc;
        }, {});
        return (0, $df7a9104588c92f3$export$825e789796ab7275)(fakeMarkersRanges, (range)=>new (0, $b9b9f2bdf9c6137f$export$a3091252a5e626ba)(range.start || writer.createPositionFromPath(rootElement, [
                0
            ]), range.end || writer.createPositionAt(rootElement, "end")));
    }
    /**
	* Returns array that contains list of fake markers with corresponding `$marker` elements.
	*
	* For each marker, there can be two `$marker` elements or only one (if the document fragment contained
	* only the beginning or only the end of a marker).
	*
	* @param writer An instance of the model writer.
	* @param rootElement The element to be checked.
	*/ _getAllFakeMarkersFromElement(writer, rootElement) {
        const foundFakeMarkers = Array.from(writer.createRangeIn(rootElement)).flatMap(({ item: item })=>{
            if (!item.is("element", "$marker")) return [];
            return [
                {
                    markerElement: item,
                    name: item.getAttribute("data-name"),
                    type: item.getAttribute("data-type")
                }
            ];
        });
        const prependFakeMarkers = [];
        const appendFakeMarkers = [];
        for (const fakeMarker of foundFakeMarkers){
            if (fakeMarker.type === "end") {
                if (!foundFakeMarkers.some((otherFakeMarker)=>otherFakeMarker.name === fakeMarker.name && otherFakeMarker.type === "start")) prependFakeMarkers.push({
                    markerElement: null,
                    name: fakeMarker.name,
                    type: "start"
                });
            }
            if (fakeMarker.type === "start") {
                if (!foundFakeMarkers.some((otherFakeMarker)=>otherFakeMarker.name === fakeMarker.name && otherFakeMarker.type === "end")) appendFakeMarkers.unshift({
                    markerElement: null,
                    name: fakeMarker.name,
                    type: "end"
                });
            }
        }
        return [
            ...prependFakeMarkers,
            ...foundFakeMarkers,
            ...appendFakeMarkers
        ];
    }
    /**
	* When copy of markers occurs we have to make sure that pasted markers have different names
	* than source markers. This functions helps with assigning unique part to marker name to
	* prevent duplicated markers error.
	*
	* @param name Name of marker
	*/ _getUniqueMarkerName(name) {
        const parts = name.split(":");
        const newId = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)().substring(1, 6);
        if (parts.length === 3) return `${parts.slice(0, 2).join(":")}:${newId}`;
        return `${parts.join(":")}:${newId}`;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/clipboardpipeline
*/ /**
* The clipboard pipeline feature. It is responsible for intercepting the `paste` and `drop` events and
* passing the pasted content through a series of events in order to insert it into the editor's content.
* It also handles the `cut` and `copy` events to fill the native clipboard with the serialized editor's data.
*
* # Input pipeline
*
* The behavior of the default handlers (all at a `low` priority):
*
* ## Event: `paste` or `drop`
*
* 1. Translates the event data.
* 2. Fires the {@link module:engine/view/document~ViewDocument#event:clipboardInput `view.Document#clipboardInput`} event.
*
* ## Event: `view.Document#clipboardInput`
*
* 1. If the `data.content` event field is already set (by some listener on a higher priority), it takes this content and fires the event
*    from the last point.
* 2. Otherwise, it retrieves `text/html` or `text/plain` from `data.dataTransfer`.
* 3. Normalizes the raw data by applying simple filters on string data.
* 4. Processes the raw data to {@link module:engine/view/documentfragment~ViewDocumentFragment `view.DocumentFragment`} with the
*    {@link module:engine/controller/datacontroller~DataController#htmlProcessor `DataController#htmlProcessor`}.
* 5. Fires the {@link module:clipboard/clipboardpipeline~ClipboardPipeline#event:inputTransformation
*   `ClipboardPipeline#inputTransformation`} event with the view document fragment in the `data.content` event field.
*
* ## Event: `ClipboardPipeline#inputTransformation`
*
* 1. Converts {@link module:engine/view/documentfragment~ViewDocumentFragment `view.DocumentFragment`} from the `data.content` field to
*    {@link module:engine/model/documentfragment~ModelDocumentFragment `model.DocumentFragment`}.
* 2. Fires the {@link module:clipboard/clipboardpipeline~ClipboardPipeline#event:contentInsertion `ClipboardPipeline#contentInsertion`}
*    event with the model document fragment in the `data.content` event field.
*    **Note**: The `ClipboardPipeline#contentInsertion` event is fired within a model change block to allow other handlers
*    to run in the same block without post-fixers called in between (i.e., the selection post-fixer).
*
* ## Event: `ClipboardPipeline#contentInsertion`
*
* 1. Calls {@link module:engine/model/model~Model#insertContent `model.insertContent()`} to insert `data.content`
*    at the current selection position.
*
* # Output pipeline
*
* The behavior of the default handlers (all at a `low` priority):
*
* ## Event: `copy`, `cut` or `dragstart`
*
* 1. Retrieves the selected {@link module:engine/model/documentfragment~ModelDocumentFragment `model.DocumentFragment`} by calling
*    {@link module:engine/model/model~Model#getSelectedContent `model#getSelectedContent()`}.
* 2. Converts the model document fragment to {@link module:engine/view/documentfragment~ViewDocumentFragment `view.DocumentFragment`}.
* 3. Fires the {@link module:engine/view/document~ViewDocument#event:clipboardOutput `view.Document#clipboardOutput`} event
*    with the view document fragment in the `data.content` event field.
*
* ## Event: `view.Document#clipboardOutput`
*
* 1. Processes `data.content` to HTML and plain text with the
*    {@link module:engine/controller/datacontroller~DataController#htmlProcessor `DataController#htmlProcessor`}.
* 2. Updates the `data.dataTransfer` data for `text/html` and `text/plain` with the processed data.
* 3. For the `cut` method, calls {@link module:engine/model/model~Model#deleteContent `model.deleteContent()`}
*    on the current selection.
*
* Read more about the clipboard integration in the {@glink framework/deep-dive/clipboard clipboard deep-dive} guide.
*/ var $4fa913ac1af6a08c$export$c85ef510b9161d09 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ClipboardPipeline";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.editing.view.addObserver($4fa913ac1af6a08c$export$fe2cb86f10559d29);
        this._setupPasteDrop();
        this._setupCopyCut();
    }
    /**
	* Fires Clipboard `'outputTransformation'` event for given parameters.
	*
	* @internal
	*/ _fireOutputTransformationEvent(dataTransfer, selection, method) {
        const clipboardMarkersUtils = this.editor.plugins.get("ClipboardMarkersUtils");
        this.editor.model.enqueueChange({
            isUndoable: method === "cut"
        }, ()=>{
            const documentFragment = clipboardMarkersUtils._copySelectedFragmentWithMarkers(method, selection);
            this.fire("outputTransformation", {
                dataTransfer: dataTransfer,
                content: documentFragment,
                method: method
            });
        });
    }
    /**
	* The clipboard paste pipeline.
	*/ _setupPasteDrop() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const clipboardMarkersUtils = this.editor.plugins.get("ClipboardMarkersUtils");
        this.listenTo(viewDocument, "clipboardInput", (evt, data)=>{
            if (data.method == "paste" && !editor.model.canEditAt(editor.model.document.selection)) evt.stop();
        }, {
            priority: "highest"
        });
        this.listenTo(viewDocument, "clipboardInput", (evt, data)=>{
            const dataTransfer = data.dataTransfer;
            const eventInfo = new (0, $c7bc2cb7e2db0227$export$3f63aa522937812c)(this, "inputTransformation");
            const sourceEditorId = dataTransfer.getData("application/ckeditor5-editor-id") || null;
            const content = typeof data.content == "string" ? this.editor.data.htmlProcessor.toView($4fa913ac1af6a08c$export$5b5994a8150e2345(data.content)) : data.content;
            this.fire(eventInfo, {
                content: content,
                dataTransfer: dataTransfer,
                sourceEditorId: sourceEditorId,
                extraContent: data.extraContent,
                targetRanges: data.targetRanges,
                method: data.method
            });
            if (eventInfo.stop.called) evt.stop();
            view.scrollToTheSelection();
        }, {
            priority: "low"
        });
        this.listenTo(this, "inputTransformation", (evt, data)=>{
            if (data.content.isEmpty) return;
            const modelFragment = this.editor.data.toModel(data.content, "$clipboardHolder");
            if (modelFragment.childCount == 0) return;
            evt.stop();
            model.change(()=>{
                this.fire("contentInsertion", {
                    content: modelFragment,
                    method: data.method,
                    sourceEditorId: data.sourceEditorId,
                    dataTransfer: data.dataTransfer,
                    targetRanges: data.targetRanges
                });
            });
        }, {
            priority: "low"
        });
        this.listenTo(this, "contentInsertion", (evt, data)=>{
            data.resultRange = clipboardMarkersUtils._pasteFragmentWithMarkers(data.content);
        }, {
            priority: "low"
        });
    }
    /**
	* The clipboard copy/cut pipeline.
	*/ _setupCopyCut() {
        const editor = this.editor;
        const modelDocument = editor.model.document;
        const viewDocument = editor.editing.view.document;
        const onCopyCut = (evt, data)=>{
            const dataTransfer = data.dataTransfer;
            data.preventDefault();
            this._fireOutputTransformationEvent(dataTransfer, modelDocument.selection, evt.name);
        };
        this.listenTo(viewDocument, "copy", onCopyCut, {
            priority: "low"
        });
        this.listenTo(viewDocument, "cut", (evt, data)=>{
            if (!editor.model.canEditAt(editor.model.document.selection)) data.preventDefault();
            else onCopyCut(evt, data);
        }, {
            priority: "low"
        });
        this.listenTo(this, "outputTransformation", (evt, data)=>{
            const content = editor.data.toView(data.content, {
                isClipboardPipeline: true
            });
            viewDocument.fire("clipboardOutput", {
                dataTransfer: data.dataTransfer,
                content: content,
                method: data.method
            });
        }, {
            priority: "low"
        });
        this.listenTo(viewDocument, "clipboardOutput", (evt, data)=>{
            if (!data.content.isEmpty) {
                data.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(data.content));
                data.dataTransfer.setData("text/plain", $4fa913ac1af6a08c$export$7c1b962cbec163d6(editor.data.htmlProcessor.domConverter, data.content));
                data.dataTransfer.setData("application/ckeditor5-editor-id", this.editor.id);
            }
            if (data.method == "cut") editor.model.deleteContent(modelDocument.selection);
        }, {
            priority: "low"
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/lineview
*/ /* istanbul ignore file -- @preserve */ const $4fa913ac1af6a08c$var$toPx = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The horizontal drop target line view.
*
* @internal
*/ var $4fa913ac1af6a08c$export$5de3079b49989bea = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* @inheritDoc
	*/ constructor(){
        super();
        const bind = this.bindTemplate;
        this.set({
            isVisible: false,
            left: null,
            top: null,
            width: null
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-clipboard-drop-target-line",
                    bind.if("isVisible", "ck-hidden", (value)=>!value)
                ],
                style: {
                    left: bind.to("left", (left)=>$4fa913ac1af6a08c$var$toPx(left)),
                    top: bind.to("top", (top)=>$4fa913ac1af6a08c$var$toPx(top)),
                    width: bind.to("width", (width)=>$4fa913ac1af6a08c$var$toPx(width))
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/dragdroptarget
*/ /**
* Part of the Drag and Drop handling. Responsible for finding and displaying the drop target.
*
* @internal
*/ var $4fa913ac1af6a08c$export$22279ba5631c7f0d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A delayed callback removing the drop marker.
	*
	* @internal
	*/ removeDropMarkerDelayed = (0, $c7bc2cb7e2db0227$export$1391212d75b2ee65)(()=>this.removeDropMarker(), 40);
    /**
	* A throttled callback updating the drop marker.
	*/ _updateDropMarkerThrottled = (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)((targetRange)=>this._updateDropMarker(targetRange), 40);
    /**
	* A throttled callback reconverting the drop parker.
	*/ _reconvertMarkerThrottled = (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(()=>{
        if (this.editor.model.markers.has("drop-target")) this.editor.editing.reconvertMarker("drop-target");
    }, 0);
    /**
	* The horizontal drop target line view.
	*/ _dropTargetLineView = new $4fa913ac1af6a08c$export$5de3079b49989bea();
    /**
	* DOM Emitter.
	*/ _domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
    /**
	* Map of document scrollable elements.
	*/ _scrollables = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DragDropTarget";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this._setupDropMarker();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._domEmitter.stopListening();
        for (const { resizeObserver: resizeObserver } of this._scrollables.values())resizeObserver.destroy();
        this._updateDropMarkerThrottled.cancel();
        this.removeDropMarkerDelayed.cancel();
        this._reconvertMarkerThrottled.cancel();
        return super.destroy();
    }
    /**
	* Finds the drop target range and updates the drop marker.
	*
	* @return The updated drop target range or null if no valid range was found.
	* @internal
	*/ updateDropMarker(targetViewElement, targetViewRanges, clientX, clientY, blockMode, draggedRange) {
        this.removeDropMarkerDelayed.cancel();
        const targetRange = $4fa913ac1af6a08c$var$findDropTargetRange(this.editor, targetViewElement, targetViewRanges, clientX, clientY, blockMode, draggedRange);
        /* istanbul ignore next -- @preserve */ if (!targetRange) return null;
        if (draggedRange && draggedRange.containsRange(targetRange)) {
            this.removeDropMarker();
            return null;
        }
        if (targetRange && !this.editor.model.canEditAt(targetRange)) {
            this.removeDropMarker();
            return null;
        }
        this._updateDropMarkerThrottled(targetRange);
        return targetRange;
    }
    /**
	* Finds the final drop target range.
	*
	* @internal
	*/ getFinalDropRange(targetViewElement, targetViewRanges, clientX, clientY, blockMode, draggedRange) {
        const targetRange = $4fa913ac1af6a08c$var$findDropTargetRange(this.editor, targetViewElement, targetViewRanges, clientX, clientY, blockMode, draggedRange);
        this.removeDropMarker();
        return targetRange;
    }
    /**
	* Removes the drop target marker.
	*
	* @internal
	*/ removeDropMarker() {
        const model = this.editor.model;
        this.removeDropMarkerDelayed.cancel();
        this._updateDropMarkerThrottled.cancel();
        this._dropTargetLineView.isVisible = false;
        if (model.markers.has("drop-target")) model.change((writer)=>{
            writer.removeMarker("drop-target");
        });
    }
    /**
	* Creates downcast conversion for the drop target marker.
	*/ _setupDropMarker() {
        const editor = this.editor;
        editor.ui.view.body.add(this._dropTargetLineView);
        editor.conversion.for("editingDowncast").markerToHighlight({
            model: "drop-target",
            view: {
                classes: [
                    "ck-clipboard-drop-target-range"
                ]
            }
        });
        editor.conversion.for("editingDowncast").markerToElement({
            model: "drop-target",
            view: (data, { writer: writer })=>{
                if (editor.model.schema.checkChild(data.markerRange.start, "$text")) {
                    this._dropTargetLineView.isVisible = false;
                    return this._createDropTargetPosition(writer);
                } else if (data.markerRange.isCollapsed) this._updateDropTargetLine(data.markerRange);
                else this._dropTargetLineView.isVisible = false;
            }
        });
    }
    /**
	* Updates the drop target marker to the provided range.
	*
	* @param targetRange The range to set the marker to.
	*/ _updateDropMarker(targetRange) {
        const editor = this.editor;
        const markers = editor.model.markers;
        editor.model.change((writer)=>{
            if (markers.has("drop-target")) {
                if (!markers.get("drop-target").getRange().isEqual(targetRange)) writer.updateMarker("drop-target", {
                    range: targetRange
                });
            } else writer.addMarker("drop-target", {
                range: targetRange,
                usingOperation: false,
                affectsData: false
            });
        });
    }
    /**
	* Creates the UI element for vertical (in-line) drop target.
	*/ _createDropTargetPosition(writer) {
        return writer.createUIElement("span", {
            class: "ck ck-clipboard-drop-target-position"
        }, function(domDocument) {
            const domElement = this.toDomElement(domDocument);
            domElement.append("\u2060", domDocument.createElement("span"), "\u2060");
            return domElement;
        });
    }
    /**
	* Updates the horizontal drop target line.
	*/ _updateDropTargetLine(range) {
        const editing = this.editor.editing;
        const nodeBefore = range.start.nodeBefore;
        const nodeAfter = range.start.nodeAfter;
        const nodeParent = range.start.parent;
        const viewElementBefore = nodeBefore ? editing.mapper.toViewElement(nodeBefore) : null;
        const domElementBefore = viewElementBefore ? editing.view.domConverter.mapViewToDom(viewElementBefore) : null;
        const viewElementAfter = nodeAfter ? editing.mapper.toViewElement(nodeAfter) : null;
        const domElementAfter = viewElementAfter ? editing.view.domConverter.mapViewToDom(viewElementAfter) : null;
        const viewElementParent = editing.mapper.toViewElement(nodeParent);
        if (!viewElementParent) return;
        const domElementParent = editing.view.domConverter.mapViewToDom(viewElementParent);
        const domScrollableRect = this._getScrollableRect(viewElementParent);
        const { scrollX: scrollX, scrollY: scrollY } = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window;
        const rectBefore = domElementBefore ? new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domElementBefore) : null;
        const rectAfter = domElementAfter ? new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domElementAfter) : null;
        const rectParent = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domElementParent).excludeScrollbarsAndBorders();
        const above = rectBefore ? rectBefore.bottom : rectParent.top;
        const below = rectAfter ? rectAfter.top : rectParent.bottom;
        const parentStyle = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domElementParent);
        const top = above <= below ? (above + below) / 2 : below;
        if (domScrollableRect.top < top && top < domScrollableRect.bottom) {
            const left = rectParent.left + parseFloat(parentStyle.paddingLeft);
            const right = rectParent.right - parseFloat(parentStyle.paddingRight);
            const leftClamped = Math.max(left + scrollX, domScrollableRect.left);
            const rightClamped = Math.min(right + scrollX, domScrollableRect.right);
            this._dropTargetLineView.set({
                isVisible: true,
                left: leftClamped,
                top: top + scrollY,
                width: rightClamped - leftClamped
            });
        } else this._dropTargetLineView.isVisible = false;
    }
    /**
	* Finds the closest scrollable element rect for the given view element.
	*/ _getScrollableRect(viewElement) {
        const rootName = viewElement.root.rootName;
        let domScrollable;
        if (this._scrollables.has(rootName)) domScrollable = this._scrollables.get(rootName).domElement;
        else {
            const domElement = this.editor.editing.view.domConverter.mapViewToDom(viewElement);
            domScrollable = (0, $c7bc2cb7e2db0227$export$eb6c9aac129b0a9e)(domElement);
            this._domEmitter.listenTo(domScrollable, "scroll", this._reconvertMarkerThrottled, {
                usePassive: true
            });
            const resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(domScrollable, this._reconvertMarkerThrottled);
            this._scrollables.set(rootName, {
                domElement: domScrollable,
                resizeObserver: resizeObserver
            });
        }
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domScrollable).excludeScrollbarsAndBorders();
    }
};
/**
* Returns fixed selection range for given position and target element.
*/ function $4fa913ac1af6a08c$var$findDropTargetRange(editor, targetViewElement, targetViewRanges, clientX, clientY, blockMode, draggedRange) {
    const model = editor.model;
    const mapper = editor.editing.mapper;
    let modelElement = $4fa913ac1af6a08c$var$getClosestMappedModelElement(editor, targetViewElement);
    while(modelElement){
        if (!blockMode) {
            if (model.schema.checkChild(modelElement, "$text")) {
                if (targetViewRanges) {
                    const targetViewPosition = targetViewRanges[0].start;
                    const targetModelPosition = mapper.toModelPosition(targetViewPosition);
                    if (!draggedRange || Array.from(draggedRange.getItems({
                        shallow: true
                    })).some((item)=>model.schema.checkChild(targetModelPosition, item))) {
                        if (model.schema.checkChild(targetModelPosition, "$text")) return model.createRange(targetModelPosition);
                        else if (targetViewPosition) return $4fa913ac1af6a08c$var$findDropTargetRangeForElement(editor, $4fa913ac1af6a08c$var$getClosestMappedModelElement(editor, targetViewPosition.parent), clientX, clientY);
                    }
                }
            } else if (model.schema.isInline(modelElement)) return $4fa913ac1af6a08c$var$findDropTargetRangeForElement(editor, modelElement, clientX, clientY);
        }
        if (model.schema.isBlock(modelElement)) return $4fa913ac1af6a08c$var$findDropTargetRangeForElement(editor, modelElement, clientX, clientY);
        else if (model.schema.checkChild(modelElement, "$block")) {
            const childNodes = Array.from(modelElement.getChildren()).filter((node)=>node.is("element") && !$4fa913ac1af6a08c$var$shouldIgnoreElement(editor, node));
            let startIndex = 0;
            let endIndex = childNodes.length;
            if (endIndex == 0) return model.createRange(model.createPositionAt(modelElement, "end"));
            while(startIndex < endIndex - 1){
                const middleIndex = Math.floor((startIndex + endIndex) / 2);
                if ($4fa913ac1af6a08c$var$findElementSide(editor, childNodes[middleIndex], clientX, clientY) == "before") endIndex = middleIndex;
                else startIndex = middleIndex;
            }
            return $4fa913ac1af6a08c$var$findDropTargetRangeForElement(editor, childNodes[startIndex], clientX, clientY);
        }
        modelElement = modelElement.parent;
    }
    return null;
}
/**
* Returns true for elements which should be ignored.
*/ function $4fa913ac1af6a08c$var$shouldIgnoreElement(editor, modelElement) {
    const mapper = editor.editing.mapper;
    const domConverter = editor.editing.view.domConverter;
    const viewElement = mapper.toViewElement(modelElement);
    if (!viewElement) return true;
    const domElement = domConverter.mapViewToDom(viewElement);
    return (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domElement).float != "none";
}
/**
* Returns target range relative to the given element.
*/ function $4fa913ac1af6a08c$var$findDropTargetRangeForElement(editor, modelElement, clientX, clientY) {
    const model = editor.model;
    return model.createRange(model.createPositionAt(modelElement, $4fa913ac1af6a08c$var$findElementSide(editor, modelElement, clientX, clientY)));
}
/**
* Resolves whether drop marker should be before or after the given element.
*/ function $4fa913ac1af6a08c$var$findElementSide(editor, modelElement, clientX, clientY) {
    const mapper = editor.editing.mapper;
    const domConverter = editor.editing.view.domConverter;
    const viewElement = mapper.toViewElement(modelElement);
    const domElement = domConverter.mapViewToDom(viewElement);
    const rect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domElement);
    if (editor.model.schema.isInline(modelElement)) return clientX < (rect.left + rect.right) / 2 ? "before" : "after";
    else return clientY < (rect.top + rect.bottom) / 2 ? "before" : "after";
}
/**
* Returns the closest model element for the specified view element.
*/ function $4fa913ac1af6a08c$var$getClosestMappedModelElement(editor, element) {
    const mapper = editor.editing.mapper;
    const view = editor.editing.view;
    const targetModelElement = mapper.toModelElement(element);
    if (targetModelElement) return targetModelElement;
    const viewPosition = view.createPositionBefore(element);
    const viewElement = mapper.findMappedViewAncestor(viewPosition);
    return mapper.toModelElement(viewElement);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/dragdropblocktoolbar
*/ /**
* Integration of a block Drag and Drop support with the block toolbar.
*
* @internal
*/ var $4fa913ac1af6a08c$export$2192bbb1ead20a40 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Whether current dragging is started by block toolbar button dragging.
	*/ _isBlockDragging = false;
    /**
	* DOM Emitter.
	*/ _domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DragDropBlockToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        this.listenTo(editor, "change:isReadOnly", (evt, name, isReadOnly)=>{
            if (isReadOnly) {
                this.forceDisabled("readOnlyMode");
                this._isBlockDragging = false;
            } else this.clearForceDisabled("readOnlyMode");
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this.forceDisabled("noAndroidSupport");
        if (editor.plugins.has("BlockToolbar")) {
            const element = editor.plugins.get("BlockToolbar").buttonView.element;
            this._domEmitter.listenTo(element, "dragstart", (evt, data)=>this._handleBlockDragStart(data));
            this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "dragover", (evt, data)=>this._handleBlockDragging(data));
            this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "drop", (evt, data)=>this._handleBlockDragging(data));
            this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "dragend", ()=>this._handleBlockDragEnd(), {
                useCapture: true
            });
            if (this.isEnabled) element.setAttribute("draggable", "true");
            this.on("change:isEnabled", (evt, name, isEnabled)=>{
                element.setAttribute("draggable", isEnabled ? "true" : "false");
            });
        }
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._domEmitter.stopListening();
        return super.destroy();
    }
    /**
	* The `dragstart` event handler.
	*/ _handleBlockDragStart(domEvent) {
        if (!this.isEnabled) return;
        const model = this.editor.model;
        const selection = model.document.selection;
        const view = this.editor.editing.view;
        const blocks = Array.from(selection.getSelectedBlocks());
        const draggedRange = model.createRange(model.createPositionBefore(blocks[0]), model.createPositionAfter(blocks[blocks.length - 1]));
        model.change((writer)=>writer.setSelection(draggedRange));
        this._isBlockDragging = true;
        view.focus();
        view.getObserver($4fa913ac1af6a08c$export$fe2cb86f10559d29).onDomEvent(domEvent);
    }
    /**
	* The `dragover` and `drop` event handler.
	*/ _handleBlockDragging(domEvent) {
        if (!this.isEnabled || !this._isBlockDragging) return;
        const clientX = domEvent.clientX + (this.editor.locale.contentLanguageDirection == "ltr" ? 100 : -100);
        const clientY = domEvent.clientY;
        const view = this.editor.editing.view;
        const target = $4fa913ac1af6a08c$var$getTargetAcrossRoots(view, clientX, clientY);
        if (!target) return;
        view.getObserver($4fa913ac1af6a08c$export$fe2cb86f10559d29).onDomEvent({
            ...domEvent,
            type: domEvent.type,
            dataTransfer: domEvent.dataTransfer,
            target: target,
            clientX: clientX,
            clientY: clientY,
            preventDefault: ()=>domEvent.preventDefault(),
            stopPropagation: ()=>domEvent.stopPropagation()
        });
    }
    /**
	* The `dragend` event handler.
	*/ _handleBlockDragEnd() {
        this._isBlockDragging = false;
    }
};
/**
* Returns the topmost `.ck-editor__editable`-contained element at the given point, resolved across
* every DOM root the editing view knows about (including open and closed shadow roots).
*/ function $4fa913ac1af6a08c$var$getTargetAcrossRoots(view, x, y) {
    const shadowRoots = /* @__PURE__ */ new Set();
    for (const domRoot of view.domRoots.values()){
        const root = domRoot.getRootNode();
        if ((0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(root)) shadowRoots.add(root);
    }
    const target = (0, $c7bc2cb7e2db0227$export$7ec1070137f7ab66)(x, y, Array.from(shadowRoots));
    return target && target.closest(".ck-editor__editable") ? target : null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/dragdrop
*/ /**
* The drag and drop feature. It works on top of the {@link module:clipboard/clipboardpipeline~ClipboardPipeline}.
*
* Read more about the clipboard integration in the {@glink framework/deep-dive/clipboard clipboard deep-dive} guide.
*
* @internal
*/ var $4fa913ac1af6a08c$export$b4a441ca74fcf9d2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The live range over the original content that is being dragged.
	*/ _draggedRange;
    /**
	* The UID of current dragging that is used to verify if the drop started in the same editor as the drag start.
	*
	* **Note**: This is a workaround for broken 'dragend' events (they are not fired if the source text node got removed).
	*/ _draggingUid;
    /**
	* The reference to the model element that currently has a `draggable` attribute set (it is set while dragging).
	*/ _draggableElement;
    /**
	* A delayed callback removing draggable attributes.
	*/ _clearDraggableAttributesDelayed = (0, $c7bc2cb7e2db0227$export$1391212d75b2ee65)(()=>this._clearDraggableAttributes(), 40);
    /**
	* Whether the dragged content can be dropped only in block context.
	*/ _blockMode = false;
    /**
	* DOM Emitter.
	*/ _domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
    /**
	* The DOM element used to generate dragged preview image.
	*/ _previewContainer;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DragDrop";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $4fa913ac1af6a08c$export$c85ef510b9161d09,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a),
            $4fa913ac1af6a08c$export$22279ba5631c7f0d,
            $4fa913ac1af6a08c$export$2192bbb1ead20a40
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const view = editor.editing.view;
        this._draggedRange = null;
        this._draggingUid = "";
        this._draggableElement = null;
        view.addObserver($4fa913ac1af6a08c$export$fe2cb86f10559d29);
        view.addObserver((0, $b9b9f2bdf9c6137f$export$6b46599a2e720b2));
        this._setupDragging();
        this._setupContentInsertionIntegration();
        this._setupClipboardInputIntegration();
        this._setupDraggableAttributeHandling();
        this.listenTo(editor, "change:isReadOnly", (evt, name, isReadOnly)=>{
            if (isReadOnly) this.forceDisabled("readOnlyMode");
            else this.clearForceDisabled("readOnlyMode");
        });
        this.on("change:isEnabled", (evt, name, isEnabled)=>{
            if (!isEnabled) this._finalizeDragging(false);
        });
        if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this.forceDisabled("noAndroidSupport");
    }
    /**
	* @inheritDoc
	*/ destroy() {
        if (this._draggedRange) {
            this._draggedRange.detach();
            this._draggedRange = null;
        }
        if (this._previewContainer) this._previewContainer.remove();
        this._domEmitter.stopListening();
        this._clearDraggableAttributesDelayed.cancel();
        return super.destroy();
    }
    /**
	* Drag and drop events handling.
	*/ _setupDragging() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        const viewDocument = view.document;
        const dragDropTarget = editor.plugins.get($4fa913ac1af6a08c$export$22279ba5631c7f0d);
        this.listenTo(viewDocument, "dragstart", (evt, data)=>{
            if (data.target?.is("editableElement")) {
                data.preventDefault();
                return;
            }
            this._prepareDraggedRange(data.target);
            if (!this._draggedRange) {
                data.preventDefault();
                return;
            }
            this._draggingUid = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
            const canEditAtDraggedRange = this.isEnabled && editor.model.canEditAt(this._draggedRange);
            data.dataTransfer.effectAllowed = canEditAtDraggedRange ? "copyMove" : "copy";
            data.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
            const draggedSelection = model.createSelection(this._draggedRange.toRange());
            this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(data.dataTransfer, draggedSelection, "dragstart");
            const { dataTransfer: dataTransfer, domTarget: domTarget, domEvent: domEvent } = data;
            const { clientX: clientX } = domEvent;
            this._updatePreview({
                dataTransfer: dataTransfer,
                domTarget: domTarget,
                clientX: clientX
            });
            data.stopPropagation();
            if (!canEditAtDraggedRange) {
                this._draggedRange.detach();
                this._draggedRange = null;
                this._draggingUid = "";
            }
        }, {
            priority: "low"
        });
        this.listenTo(viewDocument, "dragend", (evt, data)=>{
            this._finalizeDragging(!data.dataTransfer.isCanceled && data.dataTransfer.dropEffect == "move");
        }, {
            priority: "low"
        });
        this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "dragend", ()=>{
            this._blockMode = false;
        }, {
            useCapture: true
        });
        this.listenTo(viewDocument, "dragenter", ()=>{
            if (!this.isEnabled) return;
            view.focus();
        });
        this.listenTo(viewDocument, "dragleave", ()=>{
            dragDropTarget.removeDropMarkerDelayed();
        });
        this.listenTo(viewDocument, "dragging", (evt, data)=>{
            if (!this.isEnabled) {
                data.dataTransfer.dropEffect = "none";
                return;
            }
            const { clientX: clientX, clientY: clientY } = data.domEvent;
            if (!dragDropTarget.updateDropMarker(data.target, data.targetRanges, clientX, clientY, this._blockMode, this._draggedRange)) {
                data.dataTransfer.dropEffect = "none";
                return;
            }
            if (!this._draggedRange) data.dataTransfer.dropEffect = "copy";
            if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko) {
                if (data.dataTransfer.effectAllowed == "copy") data.dataTransfer.dropEffect = "copy";
                else if ([
                    "all",
                    "copyMove"
                ].includes(data.dataTransfer.effectAllowed)) data.dataTransfer.dropEffect = "move";
            }
            evt.stop();
        }, {
            priority: "low"
        });
    }
    /**
	* Integration with the `clipboardInput` event.
	*/ _setupClipboardInputIntegration() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        const dragDropTarget = editor.plugins.get($4fa913ac1af6a08c$export$22279ba5631c7f0d);
        this.listenTo(viewDocument, "clipboardInput", (evt, data)=>{
            if (data.method != "drop") return;
            const { clientX: clientX, clientY: clientY } = data.domEvent;
            const targetRange = dragDropTarget.getFinalDropRange(data.target, data.targetRanges, clientX, clientY, this._blockMode, this._draggedRange);
            if (!targetRange) {
                this._finalizeDragging(false);
                evt.stop();
                return;
            }
            if (this._draggedRange && this._draggingUid != data.dataTransfer.getData("application/ckeditor5-dragging-uid")) {
                this._draggedRange.detach();
                this._draggedRange = null;
                this._draggingUid = "";
            }
            if ($4fa913ac1af6a08c$var$getFinalDropEffect(data.dataTransfer) == "move" && this._draggedRange && this._draggedRange.containsRange(targetRange, true)) {
                this._finalizeDragging(false);
                evt.stop();
                return;
            }
            data.targetRanges = [
                editor.editing.mapper.toViewRange(targetRange)
            ];
        }, {
            priority: "high"
        });
    }
    /**
	* Integration with the `contentInsertion` event of the clipboard pipeline.
	*/ _setupContentInsertionIntegration() {
        const clipboardPipeline = this.editor.plugins.get($4fa913ac1af6a08c$export$c85ef510b9161d09);
        clipboardPipeline.on("contentInsertion", (evt, data)=>{
            if (!this.isEnabled || data.method !== "drop") return;
            const ranges = data.targetRanges.map((viewRange)=>this.editor.editing.mapper.toModelRange(viewRange));
            this.editor.model.change((writer)=>writer.setSelection(ranges));
        }, {
            priority: "high"
        });
        clipboardPipeline.on("contentInsertion", (evt, data)=>{
            if (!this.isEnabled || data.method !== "drop") return;
            const isMove = $4fa913ac1af6a08c$var$getFinalDropEffect(data.dataTransfer) == "move";
            const isSuccess = !data.resultRange || !data.resultRange.isCollapsed;
            this._finalizeDragging(isSuccess && isMove);
        }, {
            priority: "lowest"
        });
    }
    /**
	* Adds listeners that add the `draggable` attribute to the elements while the mouse button is down so the dragging could start.
	*/ _setupDraggableAttributeHandling() {
        const editor = this.editor;
        const view = editor.editing.view;
        const viewDocument = view.document;
        this.listenTo(viewDocument, "pointerdown", (evt, data)=>{
            if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid || !data) return;
            this._clearDraggableAttributesDelayed.cancel();
            let draggableElement = $4fa913ac1af6a08c$var$findDraggableWidget(data.target);
            if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink && !editor.isReadOnly && !draggableElement && !viewDocument.selection.isCollapsed) {
                const selectedElement = viewDocument.selection.getSelectedElement();
                if (!selectedElement || !(0, $5547ab21e02f1e9e$export$33101d01ca587c36)(selectedElement)) draggableElement = viewDocument.selection.editableElement;
            }
            if (draggableElement) {
                view.change((writer)=>{
                    writer.setAttribute("draggable", "true", draggableElement);
                });
                this._draggableElement = editor.editing.mapper.toModelElement(draggableElement);
            }
        });
        this.listenTo(viewDocument, "pointerup", ()=>{
            if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isAndroid) this._clearDraggableAttributesDelayed();
        });
    }
    /**
	* Removes the `draggable` attribute from the element that was used for dragging.
	*/ _clearDraggableAttributes() {
        const editing = this.editor.editing;
        editing.view.change((writer)=>{
            if (this._draggableElement && this._draggableElement.root.rootName != "$graveyard") writer.removeAttribute("draggable", editing.mapper.toViewElement(this._draggableElement));
            this._draggableElement = null;
        });
    }
    /**
	* Deletes the dragged content from its original range and clears the dragging state.
	*
	* @param moved Whether the move succeeded.
	*/ _finalizeDragging(moved) {
        const editor = this.editor;
        const model = editor.model;
        editor.plugins.get($4fa913ac1af6a08c$export$22279ba5631c7f0d).removeDropMarker();
        this._clearDraggableAttributes();
        if (editor.plugins.has("WidgetToolbarRepository")) editor.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop");
        this._draggingUid = "";
        if (this._previewContainer) {
            this._previewContainer.remove();
            this._previewContainer = void 0;
        }
        if (!this._draggedRange) return;
        if (moved && this.isEnabled) model.change((writer)=>{
            const selection = model.createSelection(this._draggedRange);
            model.deleteContent(selection, {
                doNotAutoparagraph: true
            });
            const selectionParent = selection.getFirstPosition().parent;
            if (selectionParent.isEmpty && !model.schema.checkChild(selectionParent, "$text") && model.schema.checkChild(selectionParent, "paragraph")) writer.insertElement("paragraph", selectionParent, 0);
        });
        this._draggedRange.detach();
        this._draggedRange = null;
    }
    /**
	* Sets the dragged source range based on event target and document selection.
	*/ _prepareDraggedRange(target) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const draggableWidget = target ? $4fa913ac1af6a08c$var$findDraggableWidget(target) : null;
        if (draggableWidget) {
            const modelElement = editor.editing.mapper.toModelElement(draggableWidget);
            this._draggedRange = (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f).fromRange(model.createRangeOn(modelElement));
            this._blockMode = model.schema.isBlock(modelElement);
            if (editor.plugins.has("WidgetToolbarRepository")) editor.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
            return;
        }
        if (selection.isCollapsed && !selection.getFirstPosition().parent.isEmpty) return;
        const blocks = Array.from(selection.getSelectedBlocks());
        const draggedRange = selection.getFirstRange();
        if (blocks.length == 0) {
            this._draggedRange = (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f).fromRange(draggedRange);
            return;
        }
        const blockRange = $4fa913ac1af6a08c$var$getRangeIncludingFullySelectedParents(model, blocks);
        if (blocks.length > 1) {
            this._draggedRange = (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f).fromRange(blockRange);
            this._blockMode = true;
        } else if (blocks.length == 1) {
            const touchesBlockEdges = draggedRange.start.isTouching(blockRange.start) && draggedRange.end.isTouching(blockRange.end);
            this._draggedRange = (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f).fromRange(touchesBlockEdges ? blockRange : draggedRange);
            this._blockMode = touchesBlockEdges;
        }
        model.change((writer)=>writer.setSelection(this._draggedRange.toRange()));
    }
    /**
	* Updates the dragged preview image.
	*/ _updatePreview({ dataTransfer: dataTransfer, domTarget: domTarget, clientX: clientX }) {
        const view = this.editor.editing.view;
        const editable = view.document.selection.editableElement;
        const domEditable = view.domConverter.mapViewToDom(editable);
        const computedStyle = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domEditable);
        const editableDocument = domEditable.ownerDocument;
        if (!this._previewContainer) this._previewContainer = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(editableDocument, "div", {
            style: "position: fixed; left: -999999px;"
        });
        else if (this._previewContainer.firstElementChild) this._previewContainer.removeChild(this._previewContainer.firstElementChild);
        const editableRoot = domEditable.getRootNode();
        if ((0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(editableRoot)) editableRoot.appendChild(this._previewContainer);
        else editableDocument.body.appendChild(this._previewContainer);
        const preview = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(editableDocument, "div");
        preview.className = "ck ck-content ck-clipboard-preview";
        const domRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domEditable);
        const domEditablePaddingLeft = parseFloat(computedStyle.paddingLeft);
        const domEditablePaddingRight = parseFloat(computedStyle.paddingRight);
        const editableWidth = parseFloat(computedStyle.width) - domEditablePaddingLeft - domEditablePaddingRight;
        if (!(0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(domEditable, domTarget)) {
            if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS) {
                const offsetLeft = domRect.left - clientX + domEditablePaddingLeft;
                preview.style.width = `${editableWidth + offsetLeft}px`;
                preview.style.paddingLeft = `${offsetLeft}px`;
            } else {
                preview.style.width = `${editableWidth}px`;
                preview.style.backgroundColor = "var(--ck-color-base-background)";
            }
        } else if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isiOS) {
            preview.style.maxWidth = `${editableWidth}px`;
            preview.style.padding = "10px";
            preview.style.minWidth = "200px";
            preview.style.minHeight = "20px";
            preview.style.boxSizing = "border-box";
            preview.style.backgroundColor = "var(--ck-color-base-background)";
        } else return;
        view.domConverter.setContentOf(preview, dataTransfer.getData("text/html"));
        dataTransfer.setDragImage(preview, 0, 0);
        this._previewContainer.appendChild(preview);
    }
};
/**
* Returns the drop effect that should be a result of dragging the content.
* This function is handling a quirk when checking the effect in the 'drop' DOM event.
*/ function $4fa913ac1af6a08c$var$getFinalDropEffect(dataTransfer) {
    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isGecko) return dataTransfer.dropEffect;
    return [
        "all",
        "copyMove"
    ].includes(dataTransfer.effectAllowed) ? "move" : "copy";
}
/**
* Returns a widget element that should be dragged.
*/ function $4fa913ac1af6a08c$var$findDraggableWidget(target) {
    if (target.is("editableElement")) return null;
    if (target.hasClass("ck-widget__selection-handle")) return target.findAncestor((0, $5547ab21e02f1e9e$export$33101d01ca587c36));
    if ((0, $5547ab21e02f1e9e$export$33101d01ca587c36)(target)) return target;
    const ancestor = target.findAncestor((node)=>(0, $5547ab21e02f1e9e$export$33101d01ca587c36)(node) || node.is("editableElement"));
    if ((0, $5547ab21e02f1e9e$export$33101d01ca587c36)(ancestor)) return ancestor;
    return null;
}
/**
* Recursively checks if common parent of provided elements doesn't have any other children. If that's the case,
* it returns range including this parent. Otherwise, it returns only the range from first to last element.
*
* Example:
*
* <blockQuote>
*   <paragraph>[Test 1</paragraph>
*   <paragraph>Test 2</paragraph>
*   <paragraph>Test 3]</paragraph>
* <blockQuote>
*
* Because all elements inside the `blockQuote` are selected, the range is extended to include the `blockQuote` too.
* If only first and second paragraphs would be selected, the range would not include it.
*/ function $4fa913ac1af6a08c$var$getRangeIncludingFullySelectedParents(model, elements) {
    const firstElement = elements[0];
    const lastElement = elements[elements.length - 1];
    const parent = firstElement.getCommonAncestor(lastElement);
    const startPosition = model.createPositionBefore(firstElement);
    const endPosition = model.createPositionAfter(lastElement);
    if (parent && parent.is("element") && !model.schema.isLimit(parent)) {
        const parentRange = model.createRangeOn(parent);
        const touchesStart = startPosition.isTouching(parentRange.start);
        const touchesEnd = endPosition.isTouching(parentRange.end);
        if (touchesStart && touchesEnd) return $4fa913ac1af6a08c$var$getRangeIncludingFullySelectedParents(model, [
            parent
        ]);
    }
    return model.createRange(startPosition, endPosition);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/pasteplaintext
*/ /**
* The plugin detects the user's intention to paste plain text.
*
* For example, it detects the <kbd>Ctrl/Cmd</kbd> + <kbd>Shift</kbd> + <kbd>V</kbd> keystroke.
*/ var $4fa913ac1af6a08c$export$b4006255c81151fa = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PastePlainText";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $4fa913ac1af6a08c$export$c85ef510b9161d09
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        const selection = model.document.selection;
        view.addObserver($4fa913ac1af6a08c$export$fe2cb86f10559d29);
        editor.plugins.get($4fa913ac1af6a08c$export$c85ef510b9161d09).on("contentInsertion", (evt, data)=>{
            if (!$4fa913ac1af6a08c$var$isUnformattedInlineContent(data.content, model)) return;
            model.change((writer)=>{
                const textAttributes = Array.from(selection.getAttributes()).filter(([key])=>model.schema.getAttributeProperties(key).isFormatting);
                if (!selection.isCollapsed) model.deleteContent(selection, {
                    doNotAutoparagraph: true
                });
                textAttributes.push(...selection.getAttributes());
                const range = writer.createRangeIn(data.content);
                for (const item of range.getItems())for (const attribute of textAttributes)if (model.schema.checkAttribute(item, attribute[0])) writer.setAttribute(attribute[0], attribute[1], item);
            });
        });
    }
};
/**
* Returns true if specified `documentFragment` represents the unformatted inline content.
*/ function $4fa913ac1af6a08c$var$isUnformattedInlineContent(documentFragment, model) {
    let range = model.createRangeIn(documentFragment);
    if (documentFragment.childCount == 1) {
        const child = documentFragment.getChild(0);
        if (child.is("element") && model.schema.isBlock(child) && !model.schema.isObject(child) && !model.schema.isLimit(child)) range = model.createRangeIn(child);
    }
    for (const child of range.getItems()){
        if (!model.schema.isInline(child)) return false;
        if (Array.from(child.getAttributeKeys()).find((key)=>model.schema.getAttributeProperties(key).isFormatting)) return false;
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module clipboard/clipboard
*/ /**
* The clipboard feature.
*
* Read more about the clipboard integration in the {@glink framework/deep-dive/clipboard clipboard deep-dive} guide.
*
* This is a "glue" plugin which loads the following plugins:
* * {@link module:clipboard/clipboardpipeline~ClipboardPipeline}
* * {@link module:clipboard/dragdrop~DragDrop}
* * {@link module:clipboard/pasteplaintext~PastePlainText}
*/ var $4fa913ac1af6a08c$export$8b44c43c7d8f0830 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Clipboard";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a,
            $4fa913ac1af6a08c$export$c85ef510b9161d09,
            $4fa913ac1af6a08c$export$b4a441ca74fcf9d2,
            $4fa913ac1af6a08c$export$b4006255c81151fa
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Copy selected content"),
                    keystroke: "CTRL+C"
                },
                {
                    label: t("Paste content"),
                    keystroke: "CTRL+V"
                },
                {
                    label: t("Paste content as plain text"),
                    keystroke: "CTRL+SHIFT+V"
                }
            ]
        });
    }
};




//#region src/string/upperFirst.ts
/**
* Converts the first character of string to upper case.
*
* @param str - The string that is to be changed
* @returns The converted string.
*
* @example
* const convertedStr1 = upperFirst('fred') // returns 'Fred'
* const convertedStr2 = upperFirst('Fred') // returns 'Fred'
* const convertedStr3 = upperFirst('FRED') // returns 'FRED'
*/ function $8996f6bb21c2fb55$export$3061f22cd819074d(str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}



//#region src/compat/string/upperFirst.ts
/**
* Converts the first character of string to upper case.
*
* @param str - The string that is to be changed
* @returns The converted string.
*
* @example
* const convertedStr1 = upperFirst('fred') // returns 'Fred'
* const convertedStr2 = upperFirst('Fred') // returns 'Fred'
* const convertedStr3 = upperFirst('FRED') // returns 'FRED'
*/ function $b526c7ea7ac79ca6$export$3061f22cd819074d(str) {
    return (0, $8996f6bb21c2fb55$export$3061f22cd819074d)((0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(str));
}





/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/basecommand
*/ /**
* Base class for the undo feature commands: {@link module:undo/undocommand~UndoCommand} and {@link module:undo/redocommand~RedoCommand}.
*/ var $d1f24276bd81b655$export$48406b0526f7d192 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Stack of items stored by the command. These are pairs of:
	*
	* * {@link module:engine/model/batch~Batch batch} saved by the command,
	* * {@link module:engine/model/selection~ModelSelection selection} state at the moment of saving the batch.
	*/ _stack = [];
    /**
	* Stores all batches that were created by this command.
	*
	* @internal
	*/ _createdBatches = /* @__PURE__ */ new WeakSet();
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.refresh();
        this._isEnabledBasedOnSelection = false;
        this.listenTo(editor.data, "set", (evt, data)=>{
            data[1] = {
                ...data[1]
            };
            const options = data[1];
            if (!options.batchType) options.batchType = {
                isUndoable: false
            };
        }, {
            priority: "high"
        });
        this.listenTo(editor.data, "set", (evt, data)=>{
            if (!data[1].batchType.isUndoable) this.clearStack();
        });
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._stack.length > 0;
    }
    /**
	* Returns all batches created by this command.
	*/ get createdBatches() {
        return this._createdBatches;
    }
    /**
	* Stores a batch in the command, together with the selection state of the {@link module:engine/model/document~ModelDocument document}
	* created by the editor which this command is registered to.
	*
	* @param batch The batch to add.
	*/ addBatch(batch) {
        const docSelection = this.editor.model.document.selection;
        const selection = {
            ranges: docSelection.hasOwnRange ? Array.from(docSelection.getRanges()) : [],
            isBackward: docSelection.isBackward
        };
        this._stack.push({
            batch: batch,
            selection: selection
        });
        this.refresh();
    }
    /**
	* Removes all items from the stack.
	*/ clearStack() {
        this._stack = [];
        this.refresh();
    }
    /**
	* Restores the {@link module:engine/model/document~ModelDocument#selection document selection} state after a batch was undone.
	*
	* @param ranges Ranges to be restored.
	* @param isBackward A flag describing whether the restored range was selected forward or backward.
	* @param operations Operations which has been applied since selection has been stored.
	*/ _restoreSelection(ranges, isBackward, operations) {
        const model = this.editor.model;
        const document = model.document;
        const selectionRanges = [];
        const transformedRangeGroups = ranges.map((range)=>range.getTransformedByOperations(operations));
        const allRanges = transformedRangeGroups.flat();
        for (const rangeGroup of transformedRangeGroups){
            const transformed = rangeGroup.filter((range)=>range.root != document.graveyard).filter((range)=>!$d1f24276bd81b655$var$isRangeContainedByAnyOtherRange(range, allRanges));
            if (!transformed.length) continue;
            $d1f24276bd81b655$var$normalizeRanges(transformed);
            selectionRanges.push(transformed[0]);
        }
        if (selectionRanges.length) model.change((writer)=>{
            writer.setSelection(selectionRanges, {
                backward: isBackward
            });
        });
    }
    /**
	* Undoes a batch by reversing that batch, transforming reversed batch and finally applying it.
	* This is a helper method for {@link #execute}.
	*
	* @param batchToUndo The batch to be undone.
	* @param undoingBatch The batch that will contain undoing changes.
	*/ _undo(batchToUndo, undoingBatch) {
        const model = this.editor.model;
        const document = model.document;
        this._createdBatches.add(undoingBatch);
        const operationsToUndo = batchToUndo.operations.slice().filter((operation)=>operation.isDocumentOperation);
        operationsToUndo.reverse();
        for (const operationToUndo of operationsToUndo){
            const nextBaseVersion = operationToUndo.baseVersion + 1;
            const historyOperations = Array.from(document.history.getOperations(nextBaseVersion));
            const reversedOperations = (0, $b9b9f2bdf9c6137f$export$96d3a21d249d408c)([
                operationToUndo.getReversed()
            ], historyOperations, {
                useRelations: true,
                document: this.editor.model.document,
                padWithNoOps: false,
                forceWeakRemove: true
            }).operationsA;
            for (let operation of reversedOperations){
                const affectedSelectable = operation.affectedSelectable;
                if (affectedSelectable && !model.canEditAt(affectedSelectable)) operation = new (0, $b9b9f2bdf9c6137f$export$61a108126838e575)(operation.baseVersion);
                undoingBatch.addOperation(operation);
                model.applyOperation(operation);
                document.history.setOperationAsUndone(operationToUndo, operation);
            }
        }
    }
};
/**
* Normalizes list of ranges by joining intersecting or "touching" ranges.
*
* @param ranges Ranges to be normalized.
*/ function $d1f24276bd81b655$var$normalizeRanges(ranges) {
    ranges.sort((a, b)=>a.start.isBefore(b.start) ? -1 : 1);
    for(let i = 1; i < ranges.length; i++){
        const joinedRange = ranges[i - 1].getJoined(ranges[i], true);
        if (joinedRange) {
            i--;
            ranges.splice(i, 2, joinedRange);
        }
    }
}
function $d1f24276bd81b655$var$isRangeContainedByAnyOtherRange(range, ranges) {
    return ranges.some((otherRange)=>otherRange !== range && otherRange.containsRange(range, true));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/undocommand
*/ /**
* The undo command stores {@link module:engine/model/batch~Batch batches} applied to the
* {@link module:engine/model/document~ModelDocument document} and is able to undo a batch by reversing it and transforming by
* batches from {@link module:engine/model/document~ModelDocument#history history} that happened after the reversed batch.
*
* The undo command also takes care of restoring the {@link module:engine/model/document~ModelDocument#selection document selection}.
*/ var $d1f24276bd81b655$export$ec41d893a411310a = class extends $d1f24276bd81b655$export$48406b0526f7d192 {
    /**
	* Executes the command. This method reverts a {@link module:engine/model/batch~Batch batch} added to the command's stack, transforms
	* and applies the reverted version on the {@link module:engine/model/document~ModelDocument document} and removes the batch from
	* the stack. Then, it restores the {@link module:engine/model/document~ModelDocument#selection document selection}.
	*
	* @fires execute
	* @fires revert
	* @param batch A batch that should be undone. If not set, the last added batch will be undone.
	*/ execute(batch = null) {
        const batchIndex = batch ? this._stack.findIndex((a)=>a.batch == batch) : this._stack.length - 1;
        const item = this._stack.splice(batchIndex, 1)[0];
        const undoingBatch = this.editor.model.createBatch({
            isUndo: true
        });
        this.editor.model.enqueueChange(undoingBatch, ()=>{
            this._undo(item.batch, undoingBatch);
            const operations = this.editor.model.document.history.getOperations(item.batch.baseVersion);
            this._restoreSelection(item.selection.ranges, item.selection.isBackward, operations);
        });
        this.fire("revert", item.batch, undoingBatch);
        this.refresh();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/redocommand
*/ /**
* The redo command stores {@link module:engine/model/batch~Batch batches} that were used to undo a batch by
* {@link module:undo/undocommand~UndoCommand}. It is able to redo a previously undone batch by reversing the undoing
* batches created by `UndoCommand`. The reversed batch is transformed by all the batches from
* {@link module:engine/model/document~ModelDocument#history history} that happened after the reversed undo batch.
*
* The redo command also takes care of restoring the {@link module:engine/model/document~ModelDocument#selection document selection}.
*/ var $d1f24276bd81b655$export$a6d4bd73a7c8bccc = class extends $d1f24276bd81b655$export$48406b0526f7d192 {
    /**
	* Executes the command. This method reverts the last {@link module:engine/model/batch~Batch batch} added to
	* the command's stack, applies the reverted and transformed version on the
	* {@link module:engine/model/document~ModelDocument document} and removes the batch from the stack.
	* Then, it restores the {@link module:engine/model/document~ModelDocument#selection document selection}.
	*
	* @fires execute
	*/ execute() {
        const item = this._stack.pop();
        const redoingBatch = this.editor.model.createBatch({
            isUndo: true
        });
        this.editor.model.enqueueChange(redoingBatch, ()=>{
            const nextBaseVersion = item.batch.operations[item.batch.operations.length - 1].baseVersion + 1;
            const operations = this.editor.model.document.history.getOperations(nextBaseVersion);
            this._restoreSelection(item.selection.ranges, item.selection.isBackward, operations);
            this._undo(item.batch, redoingBatch);
        });
        this.fire("revert", item.batch, redoingBatch);
        this.refresh();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/undoediting
*/ /**
* The undo engine feature.
*
* It introduces the `'undo'` and `'redo'` commands to the editor.
*/ var $d1f24276bd81b655$export$4f2e69f0d6e23933 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The command that manages the undo {@link module:engine/model/batch~Batch batches} stack (history).
	* Created and registered during the {@link #init feature initialization}.
	*/ _undoCommand;
    /**
	* The command that manages the redo {@link module:engine/model/batch~Batch batches} stack (history).
	* Created and registered during the {@link #init feature initialization}.
	*/ _redoCommand;
    /**
	* Keeps track of which batches were registered in undo.
	*/ _batchRegistry = /* @__PURE__ */ new WeakSet();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "UndoEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        this._undoCommand = new $d1f24276bd81b655$export$ec41d893a411310a(editor);
        this._redoCommand = new $d1f24276bd81b655$export$a6d4bd73a7c8bccc(editor);
        editor.commands.add("undo", this._undoCommand);
        editor.commands.add("redo", this._redoCommand);
        this.listenTo(editor.model, "applyOperation", (evt, args)=>{
            const operation = args[0];
            if (!operation.isDocumentOperation) return;
            const batch = operation.batch;
            const isRedoBatch = this._redoCommand.createdBatches.has(batch);
            const isUndoBatch = this._undoCommand.createdBatches.has(batch);
            if (this._batchRegistry.has(batch)) return;
            this._batchRegistry.add(batch);
            if (!batch.isUndoable) return;
            if (isRedoBatch) this._undoCommand.addBatch(batch);
            else if (!isUndoBatch) {
                this._undoCommand.addBatch(batch);
                this._redoCommand.clearStack();
            }
        }, {
            priority: "highest"
        });
        this.listenTo(this._undoCommand, "revert", (evt, undoneBatch, undoingBatch)=>{
            this._redoCommand.addBatch(undoingBatch);
        });
        editor.keystrokes.set("CTRL+Z", "undo");
        editor.keystrokes.set("CTRL+Y", "redo");
        editor.keystrokes.set("CTRL+SHIFT+Z", "redo");
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Undo"),
                    keystroke: "CTRL+Z"
                },
                {
                    label: t("Redo"),
                    keystroke: [
                        [
                            "CTRL+Y"
                        ],
                        [
                            "CTRL+SHIFT+Z"
                        ]
                    ]
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/undoui
*/ /**
* The undo UI feature. It introduces the `'undo'` and `'redo'` buttons to the editor.
*/ var $d1f24276bd81b655$export$d7d1ee8bab2a751a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "UndoUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const locale = editor.locale;
        const t = editor.t;
        const localizedUndoIcon = locale.uiLanguageDirection == "ltr" ? (0, $e8dc502aba5ac3f5$export$25d76e2a7827833e) : (0, $e8dc502aba5ac3f5$export$1d0eab454e4ed93b);
        const localizedRedoIcon = locale.uiLanguageDirection == "ltr" ? (0, $e8dc502aba5ac3f5$export$1d0eab454e4ed93b) : (0, $e8dc502aba5ac3f5$export$25d76e2a7827833e);
        this._addButtonsToFactory("undo", t("Undo"), "CTRL+Z", localizedUndoIcon);
        this._addButtonsToFactory("redo", t("Redo"), "CTRL+Y", localizedRedoIcon);
    }
    /**
	* Creates a button for the specified command.
	*
	* @param name Command name.
	* @param label Button label.
	* @param keystroke Command keystroke.
	* @param Icon Source of the icon.
	*/ _addButtonsToFactory(name, label, keystroke, Icon) {
        const editor = this.editor;
        editor.ui.componentFactory.add(name, ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa), name, label, keystroke, Icon);
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:" + name, ()=>{
            return this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53), name, label, keystroke, Icon);
        });
    }
    /**
	* TODO
	*/ _createButton(ButtonClass, name, label, keystroke, Icon) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get(name);
        const view = new ButtonClass(locale);
        view.set({
            label: label,
            icon: Icon,
            keystroke: keystroke
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute(name);
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module undo/undo
*/ /**
* The undo feature.
*
* This is a "glue" plugin which loads the {@link module:undo/undoediting~UndoEditing undo editing feature}
* and the {@link module:undo/undoui~UndoUI undo UI feature}.
*
* Below is an explanation of the undo mechanism working together with {@link module:engine/model/history~History History}:
*
* Whenever an {@link module:engine/model/operation/operation~Operation operation} is applied to the
* {@link module:engine/model/document~ModelDocument document}, it is saved to `History` as is.
* The {@link module:engine/model/batch~Batch batch} that owns that operation is also saved, in
* {@link module:undo/undocommand~UndoCommand}, together with the selection that was present in the document before the
* operation was applied. A batch is saved instead of the operation because changes are undone batch-by-batch, not operation-by-operation
* and a batch is seen as one undo step.
*
* After changes happen to the document, the `History` and `UndoCommand` stack can be represented as follows:
*
* ```
*    History                            Undo stack
* ==============             ==================================
* [operation A1]                      [  batch A  ]
* [operation B1]                      [  batch B  ]
* [operation B2]                      [  batch C  ]
* [operation C1]
* [operation C2]
* [operation B3]
* [operation C3]
* ```
*
* Where operations starting with the same letter are from same batch.
*
* Undoing a batch means that a set of operations which will reverse the effects of that batch needs to be generated.
* For example, if a batch added several letters, undoing the batch should remove them. It is important to apply undoing
* operations in the reversed order, so if a batch has operation `X`, `Y`, `Z`, reversed operations `Zr`, `Yr` and `Xr`
* need to be applied. Otherwise reversed operation `Xr` would operate on a wrong document state, because operation `X`
* does not know that operations `Y` and `Z` happened.
*
* After operations from an undone batch got {@link module:engine/model/operation/operation~Operation#getReversed reversed},
* one needs to make sure if they are ready to be applied. In the scenario above, operation `C3` is the last operation and `C3r`
* bases on up-to-date document state, so it can be applied to the document.
*
* ```
*      History                             Undo stack
* =================             ==================================
* [ operation A1  ]                      [  batch A  ]
* [ operation B1  ]                      [  batch B  ]
* [ operation B2  ]             [   processing undoing batch C   ]
* [ operation C1  ]
* [ operation C2  ]
* [ operation B3  ]
* [ operation C3  ]
* [ operation C3r ]
* ```
*
* Next is operation `C2`, reversed to `C2r`. `C2r` bases on `C2`, so it bases on the wrong document state. It needs to be
* transformed by operations from history that happened after it, so it "knows" about them. Let us assume that `C2' = C2r * B3 * C3 * C3r`,
* where `*` means "transformed by". Rest of operations from that batch are processed in the same fashion.
*
* ```
*      History                             Undo stack                                      Redo stack
* =================             ==================================             ==================================
* [ operation A1  ]                      [  batch A  ]                                    [ batch Cr ]
* [ operation B1  ]                      [  batch B  ]
* [ operation B2  ]
* [ operation C1  ]
* [ operation C2  ]
* [ operation B3  ]
* [ operation C3  ]
* [ operation C3r ]
* [ operation C2' ]
* [ operation C1' ]
* ```
*
* Selective undo works on the same basis, however, instead of undoing the last batch in the undo stack, any batch can be undone.
* The same algorithm applies: operations from a batch (i.e. `A1`) are reversed and then transformed by operations stored in history.
*
* Redo also is very similar to undo. It has its own stack that is filled with undoing (reversed batches). Operations from
* the batch that is re-done are reversed-back, transformed in proper order and applied to the document.
*
* ```
*      History                             Undo stack                                      Redo stack
* =================             ==================================             ==================================
* [ operation A1  ]                      [  batch A  ]
* [ operation B1  ]                      [  batch B  ]
* [ operation B2  ]                      [ batch Crr ]
* [ operation C1  ]
* [ operation C2  ]
* [ operation B3  ]
* [ operation C3  ]
* [ operation C3r ]
* [ operation C2' ]
* [ operation C1' ]
* [ operation C1'r]
* [ operation C2'r]
* [ operation C3rr]
* ```
*/ var $d1f24276bd81b655$export$897c9ed706d8ea48 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $d1f24276bd81b655$export$4f2e69f0d6e23933,
            $d1f24276bd81b655$export$d7d1ee8bab2a751a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Undo";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};








//#region src/compat/function/identity.ts
function $acd02b7d9a3a0986$export$f0954fd7d5368655(x) {
    return x;
}


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/utils
*/ /**
* Creates a view element representing the inline image.
*
* ```html
* <span class="image-inline"><img></img></span>
* ```
*
* Note that `alt` and `src` attributes are converted separately, so they are not included.
*
* @internal
*/ function $7c22895ca0418c15$export$396de7f0526904d1(writer) {
    return writer.createContainerElement("span", {
        class: "image-inline"
    }, writer.createEmptyElement("img"));
}
/**
* Creates a view element representing the block image.
*
* ```html
* <figure class="image"><img></img></figure>
* ```
*
* Note that `alt` and `src` attributes are converted separately, so they are not included.
*
* @internal
*/ function $7c22895ca0418c15$export$22b9b37acbcfa427(writer) {
    return writer.createContainerElement("figure", {
        class: "image"
    }, [
        writer.createEmptyElement("img"),
        writer.createSlot("children")
    ]);
}
/**
* A function returning a `MatcherPattern` for a particular type of View images.
*
* @deprecated
* @internal
* @param matchImageType The type of created image.
*/ function $7c22895ca0418c15$export$f94ce80b8a63645c(editor, matchImageType) {
    const imageUtils = editor.plugins.get("ImageUtils");
    const areBothImagePluginsLoaded = editor.plugins.has("ImageInlineEditing") && editor.plugins.has("ImageBlockEditing");
    return (element)=>{
        if (!imageUtils.isInlineImageView(element)) return null;
        if (!areBothImagePluginsLoaded) return getPositiveMatchPattern(element);
        if ($7c22895ca0418c15$var$getViewImageType(element, imageUtils) !== matchImageType) return null;
        return getPositiveMatchPattern(element);
    };
    function getPositiveMatchPattern(element) {
        const pattern = {
            name: true
        };
        if (element.hasAttribute("src")) pattern.attributes = [
            "src"
        ];
        return pattern;
    }
}
/**
* Resolves the model image type (`'imageBlock'` or `'imageInline'`) that a given `<img>` view element represents,
* based purely on its view structure.
*
* An `<img>` is treated as a block image when it has a `display: block` style or is wrapped in a block image figure
* (`<figure class="image">`, also `<figure class="image"><a>...</a></figure>` added by the `LinkImage` plugin).
* Otherwise it is treated as an inline image.
*
* Note that this only reflects the view representation - it does not check whether the resolved type is allowed by the
* schema at the insertion position.
*
* @internal
* @param element The `<img>` view element to resolve the type for.
* @param imageUtils The `ImageUtils` plugin instance.
*/ function $7c22895ca0418c15$var$getViewImageType(element, imageUtils) {
    return element.getStyle("display") == "block" || element.findAncestor(imageUtils.isBlockImageView) ? "imageBlock" : "imageInline";
}
/**
* Checks whether the given image type can be placed at the specified position - either directly (or after hoisting
* to an allowed ancestor) or, for inline images, wrapped in an auto-created paragraph.
*
* This is the predicate that decides whether a block image may land at a position or must degrade to an inline image
* (for example, inside an `$inlineRoot` that disallows block content) and, symmetrically, whether an inline image may
* become a block image. `isParagraphable()` is always `false` for `imageBlock` (a block object never fits in a
* paragraph), so the auto-paragraph relaxation only applies to the inline target.
*
* @internal
* @param schema The model schema to check against.
* @param position The position at which the image type should be placed.
* @param imageType The image type to check.
*/ function $7c22895ca0418c15$var$isImageTypePlaceable(schema, position, imageType) {
    return !!schema.findAllowedParent(position, imageType) || (0, $b9b9f2bdf9c6137f$export$576a60d33a9343e9)(position, imageType, schema);
}
/**
* Considering the current model selection, it returns the name of the model image element
* (`'imageBlock'` or `'imageInline'`) that will make most sense from the UX perspective if a new
* image was inserted (also: uploaded, dropped, pasted) at that selection.
*
* The assumption is that inserting images into empty blocks or on other block widgets should
* produce block images. Inline images should be inserted in other cases, e.g. in paragraphs
* that already contain some text.
*
* @internal
*/ function $7c22895ca0418c15$export$c2ad1be5db89b488(schema, selection) {
    const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
    if (!firstBlock || schema.isObject(firstBlock)) return "imageBlock";
    if (firstBlock.isEmpty && firstBlock.name != "listItem") return "imageBlock";
    return "imageInline";
}
/**
* Returns parsed value of the size, but only if it contains unit: px.
*
* @internal
*/ function $7c22895ca0418c15$export$fccb0d1d556e3d9c(size) {
    if (size && size.endsWith("px")) return parseInt(size);
    return null;
}
/**
* Returns true if both styles (width and height) are set.
*
* If both image styles: width & height are set, they will override the image width & height attributes in the
* browser. In this case, the image looks the same as if these styles were applied to attributes instead of styles.
* That's why we can upcast these styles to width & height attributes instead of resizedWidth and resizedHeight.
*
* @internal
*/ function $7c22895ca0418c15$export$f12d3d28bbd41988(viewElement) {
    const widthStyle = $7c22895ca0418c15$export$fccb0d1d556e3d9c(viewElement.getStyle("width"));
    const heightStyle = $7c22895ca0418c15$export$fccb0d1d556e3d9c(viewElement.getStyle("height"));
    return !!(widthStyle && heightStyle);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $7c22895ca0418c15$var$IMAGE_WIDGETS_CLASSES_MATCH_REGEXP = /^(image|image-inline)$/;
/**
* A set of helpers related to images.
*/ var $7c22895ca0418c15$export$698882cf06df44aa = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* DOM Emitter.
	*/ _domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Checks if the provided model element is an `image` or `imageInline`.
	*/ isImage(modelElement) {
        return this.isInlineImage(modelElement) || this.isBlockImage(modelElement);
    }
    /**
	* Checks if the provided view element represents an inline image.
	*
	* Also, see {@link module:image/imageutils~ImageUtils#isImageWidget}.
	*/ isInlineImageView(element) {
        return !!element && element.is("element", "img");
    }
    /**
	* Checks if the provided view element represents a block image.
	*
	* Also, see {@link module:image/imageutils~ImageUtils#isImageWidget}.
	*/ isBlockImageView(element) {
        return !!element && element.is("element", "figure") && element.hasClass("image");
    }
    /**
	* Handles inserting single file. This method unifies image insertion using {@link module:widget/utils~findOptimalInsertionRange}
	* method.
	*
	* ```ts
	* const imageUtils = editor.plugins.get( 'ImageUtils' );
	*
	* imageUtils.insertImage( { src: 'path/to/image.jpg' } );
	* ```
	*
	* @param attributes Attributes of the inserted image.
	* This method filters out the attributes which are disallowed by the {@link module:engine/model/schema~ModelSchema}.
	* @param selectable Place to insert the image. If not specified,
	* the {@link module:widget/utils~findOptimalInsertionRange} logic will be applied for the block images
	* and `model.document.selection` for the inline images.
	*
	* **Note**: If `selectable` is passed, this helper will not be able to set selection attributes (such as `linkHref`)
	* and apply them to the new image. In this case, make sure all selection attributes are passed in `attributes`.
	*
	* @param imageType Image type of inserted image. If not specified,
	* it will be determined automatically depending of editor config or place of the insertion.
	* @param options.setImageSizes Specifies whether the image `width` and `height` attributes should be set automatically.
	* The default is `true`.
	* @return The inserted model image element.
	*/ insertImage(attributes = {}, selectable = null, imageType = null, options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const determinedImageType = $7c22895ca0418c15$var$determineImageTypeForInsertion(editor, selectable || selection, imageType);
        attributes = {
            ...Object.fromEntries(selection.getAttributes()),
            ...attributes
        };
        for(const attributeName in attributes)if (!model.schema.checkAttribute(determinedImageType, attributeName)) delete attributes[attributeName];
        return model.change((writer)=>{
            const { setImageSizes: setImageSizes = true } = options;
            const imageElement = writer.createElement(determinedImageType, attributes);
            model.insertObject(imageElement, selectable, null, {
                setSelection: "on",
                findOptimalPosition: !selectable && determinedImageType != "imageInline" ? "auto" : void 0
            });
            if (imageElement.parent) {
                if (setImageSizes) this.setImageNaturalSizeAttributes(imageElement);
                return imageElement;
            }
            return null;
        });
    }
    /**
	* Reads original image sizes and sets them as `width` and `height`.
	*
	* The `src` attribute may not be available if the user is using an upload adapter. In such a case,
	* this method is called again after the upload process is complete and the `src` attribute is available.
	*/ setImageNaturalSizeAttributes(imageElement) {
        const src = imageElement.getAttribute("src");
        if (!src) return;
        if (imageElement.getAttribute("width") || imageElement.getAttribute("height")) return;
        this.editor.model.change((writer)=>{
            const img = new (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.Image();
            this._domEmitter.listenTo(img, "load", ()=>{
                if (!imageElement.getAttribute("width") && !imageElement.getAttribute("height")) this.editor.model.enqueueChange(writer.batch, (writer)=>{
                    writer.setAttribute("width", img.naturalWidth, imageElement);
                    writer.setAttribute("height", img.naturalHeight, imageElement);
                });
                this._domEmitter.stopListening(img, "load");
            });
            img.src = src;
        });
    }
    /**
	* Returns an image widget editing view element if one is selected or is among the selection's ancestors.
	*/ getClosestSelectedImageWidget(selection) {
        const selectionPosition = selection.getFirstPosition();
        if (!selectionPosition) return null;
        const viewElement = selection.getSelectedElement();
        if (viewElement && this.isImageWidget(viewElement)) return viewElement;
        let parent = selectionPosition.parent;
        while(parent){
            if (parent.is("element") && this.isImageWidget(parent)) return parent;
            parent = parent.parent;
        }
        return null;
    }
    /**
	* Returns a image model element if one is selected or is among the selection's ancestors.
	*/ getClosestSelectedImageElement(selection) {
        const selectedElement = selection.getSelectedElement();
        return this.isImage(selectedElement) ? selectedElement : selection.getFirstPosition().findAncestor("imageBlock");
    }
    /**
	* Returns an image widget editing view based on the passed image view.
	*/ getImageWidgetFromImageView(imageView) {
        return imageView.findAncestor({
            classes: $7c22895ca0418c15$var$IMAGE_WIDGETS_CLASSES_MATCH_REGEXP
        });
    }
    /**
	* Checks if image can be inserted at current model selection.
	*
	* @internal
	*/ isImageAllowed() {
        const selection = this.editor.model.document.selection;
        return $7c22895ca0418c15$var$isImageAllowedInParent(this.editor, selection) && $7c22895ca0418c15$var$isNotInsideImage(selection);
    }
    /**
	* Converts a given {@link module:engine/view/element~ViewElement} to an image widget:
	* * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property} allowing to recognize the image widget
	* element.
	* * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
	*
	* @param writer An instance of the view writer.
	* @param label The element's label. It will be concatenated with the image `alt` attribute if one is present.
	*/ toImageWidget(viewElement, writer, label) {
        writer.setCustomProperty("image", true, viewElement);
        const labelCreator = ()=>{
            const altText = this.findViewImgElement(viewElement).getAttribute("alt");
            return altText ? `${altText} ${label}` : label;
        };
        return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer, {
            label: labelCreator
        });
    }
    /**
	* Checks if a given view element is an image widget.
	*/ isImageWidget(viewElement) {
        return !!viewElement.getCustomProperty("image") && (0, $5547ab21e02f1e9e$export$33101d01ca587c36)(viewElement);
    }
    /**
	* Checks if the provided model element is an `image`.
	*/ isBlockImage(modelElement) {
        return !!modelElement && modelElement.is("element", "imageBlock");
    }
    /**
	* Checks if the provided model element is an `imageInline`.
	*/ isInlineImage(modelElement) {
        return !!modelElement && modelElement.is("element", "imageInline");
    }
    /**
	* Get the view `<img>` from another view element, e.g. a widget (`<figure class="image">`), a link (`<a>`).
	*
	* The `<img>` can be located deep in other elements, so this helper performs a deep tree search.
	*/ findViewImgElement(figureView) {
        if (this.isInlineImageView(figureView)) return figureView;
        const editingView = this.editor.editing.view;
        for (const { item: item } of editingView.createRangeIn(figureView))if (this.isInlineImageView(item)) return item;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._domEmitter.stopListening();
        return super.destroy();
    }
};
/**
* Checks if image is allowed by schema in optimal insertion parent.
*/ function $7c22895ca0418c15$var$isImageAllowedInParent(editor, selection) {
    if ($7c22895ca0418c15$var$determineImageTypeForInsertion(editor, selection, null) == "imageBlock") return $7c22895ca0418c15$var$isBlockImageAllowedAtInsertion(editor.model, selection);
    return editor.model.schema.checkChild(selection.focus, "imageInline");
}
/**
* Checks if selection is not placed inside an image (e.g. its caption).
*/ function $7c22895ca0418c15$var$isNotInsideImage(selection) {
    return [
        ...selection.focus.getAncestors()
    ].every((ancestor)=>!ancestor.is("element", "imageBlock"));
}
/**
* Returns a node that will be used to insert image with `model.insertContent`.
*/ function $7c22895ca0418c15$var$getInsertImageParent(selection, model) {
    const parent = (0, $5547ab21e02f1e9e$export$d03cbafb1cb45bb)(selection, model).start.parent;
    if (parent.isEmpty && !parent.is("rootElement")) return parent.parent;
    return parent;
}
/**
* Checks whether a block image is allowed by the schema at the optimal insertion point for the given selectable
* (e.g. it is not allowed inside `$inlineRoot` or any other inline-only container).
*/ function $7c22895ca0418c15$var$isBlockImageAllowedAtInsertion(model, selectable) {
    const insertionParent = $7c22895ca0418c15$var$getInsertImageParent(selectable.is("position") ? model.createSelection(selectable) : selectable, model);
    return model.schema.checkChild(insertionParent, "imageBlock");
}
/**
* Determine image element type name depending on editor config or place of insertion.
*
* @param imageType Image element type name. Used to force return of provided element name,
* but only if there is proper plugin enabled.
*/ function $7c22895ca0418c15$var$determineImageTypeForInsertion(editor, selectable, imageType) {
    const schema = editor.model.schema;
    const configImageInsertType = editor.config.get("image.insert.type");
    if (!editor.plugins.has("ImageBlockEditing")) return "imageInline";
    if (!editor.plugins.has("ImageInlineEditing")) return "imageBlock";
    if (imageType) return imageType;
    if (!$7c22895ca0418c15$var$isBlockImageAllowedAtInsertion(editor.model, selectable)) return "imageInline";
    if (configImageInsertType === "inline") return "imageInline";
    if (configImageInsertType !== "auto") return "imageBlock";
    if (selectable.is("selection")) return $7c22895ca0418c15$export$c2ad1be5db89b488(schema, selectable);
    return schema.checkChild(selectable, "imageInline") ? "imageInline" : "imageBlock";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/autoimage
*/ const $7c22895ca0418c15$var$IMAGE_URL_REGEXP = new RegExp(String(/^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source + /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/.source + /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source + /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source));
/**
* The auto-image plugin. It recognizes image links in the pasted content and embeds
* them shortly after they are injected into the document.
*/ var $7c22895ca0418c15$export$bc656b7c988c8f2d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $4fa913ac1af6a08c$export$8b44c43c7d8f0830),
            $7c22895ca0418c15$export$698882cf06df44aa,
            (0, $d1f24276bd81b655$export$897c9ed706d8ea48),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AutoImage";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The paste–to–embed `setTimeout` ID. Stored as a property to allow
	* cleaning of the timeout.
	*/ _timeoutId;
    /**
	* The position where the `<imageBlock>` element will be inserted after the timeout,
	* determined each time a new content is pasted into the document.
	*/ _positionToInsert;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._timeoutId = null;
        this._positionToInsert = null;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const modelDocument = editor.model.document;
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "inputTransformation", ()=>{
            const firstRange = modelDocument.selection.getFirstRange();
            const leftLivePosition = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(firstRange.start);
            leftLivePosition.stickiness = "toPrevious";
            const rightLivePosition = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(firstRange.end);
            rightLivePosition.stickiness = "toNext";
            modelDocument.once("change:data", ()=>{
                this._embedImageBetweenPositions(leftLivePosition, rightLivePosition);
                leftLivePosition.detach();
                rightLivePosition.detach();
            }, {
                priority: "high"
            });
        });
        editor.commands.get("undo").on("execute", ()=>{
            if (this._timeoutId) {
                (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.clearTimeout(this._timeoutId);
                this._positionToInsert.detach();
                this._timeoutId = null;
                this._positionToInsert = null;
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Analyzes the part of the document between provided positions in search for a URL representing an image.
	* When the URL is found, it is automatically converted into an image.
	*
	* @param leftPosition Left position of the selection.
	* @param rightPosition Right position of the selection.
	*/ _embedImageBetweenPositions(leftPosition, rightPosition) {
        const editor = this.editor;
        const urlRange = new (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f)(leftPosition, rightPosition);
        const walker = urlRange.getWalker({
            ignoreElementEnd: true
        });
        const selectionAttributes = Object.fromEntries(editor.model.document.selection.getAttributes());
        const imageUtils = this.editor.plugins.get("ImageUtils");
        let src = "";
        for (const node of walker)if (node.item.is("$textProxy")) src += node.item.data;
        src = src.trim();
        if (!src.match($7c22895ca0418c15$var$IMAGE_URL_REGEXP)) {
            urlRange.detach();
            return;
        }
        this._positionToInsert = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(leftPosition);
        this._timeoutId = setTimeout(()=>{
            if (!editor.commands.get("insertImage").isEnabled) {
                urlRange.detach();
                return;
            }
            editor.model.change((writer)=>{
                this._timeoutId = null;
                writer.remove(urlRange);
                urlRange.detach();
                let insertionPosition;
                if (this._positionToInsert.root.rootName !== "$graveyard") insertionPosition = this._positionToInsert.toPosition();
                imageUtils.insertImage({
                    ...selectionAttributes,
                    src: src
                }, insertionPosition);
                this._positionToInsert.detach();
                this._positionToInsert = null;
            });
            editor.plugins.get("Delete").requestUndoOnBackspace();
        }, 100);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetextalternative/imagetextalternativecommand
*/ /**
* The image text alternative command. It is used to change the `alt` attribute of `<imageBlock>` and `<imageInline>` model elements.
*/ var $7c22895ca0418c15$export$b4f5c697ef3acd5b = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const element = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!element;
        if (this.isEnabled && element.hasAttribute("alt")) this.value = element.getAttribute("alt");
        else this.value = false;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options
	* @param options.newValue The new value of the `alt` attribute to set.
	*/ execute(options) {
        const editor = this.editor;
        const imageUtils = editor.plugins.get("ImageUtils");
        const model = editor.model;
        const imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
        model.change((writer)=>{
            writer.setAttribute("alt", options.newValue, imageElement);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetextalternative/imagetextalternativeediting
*/ /**
* The image text alternative editing plugin.
*
* Registers the `'imageTextAlternative'` command.
*/ var $7c22895ca0418c15$export$e7b530daad14f685 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageTextAlternativeEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.commands.add("imageTextAlternative", new $7c22895ca0418c15$export$b4f5c697ef3acd5b(this.editor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetextalternative/ui/textalternativeformview
*/ /**
* The TextAlternativeFormView class.
*
* @internal
*/ var $7c22895ca0418c15$export$e3b28856724d1926 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* An input with a label.
	*/ labeledInput;
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A button used to submit the form.
	*/ saveButtonView;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of views which can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.backButtonView = this._createBackButton();
        this.saveButtonView = this._createSaveButton();
        this.labeledInput = this._createLabeledInputView();
        this.children = this.createCollection([
            this._createHeaderView()
        ]);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.labeledInput,
                this.saveButtonView
            ],
            class: [
                "ck-form__row_with-submit",
                "ck-form__row_large-top-padding",
                "ck-form__row_large-bottom-padding"
            ]
        }));
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("cancel");
            cancel();
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-text-alternative-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.backButtonView,
            this.labeledInput,
            this.saveButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates a save button view that text alternative the image.
	*/ _createSaveButton() {
        const t = this.locale.t;
        const saveButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        saveButton.set({
            label: t("Save"),
            withText: true,
            type: "submit",
            class: "ck-button-action ck-button_standard"
        });
        return saveButton;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Text Alternative")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates an input with a label.
	*
	* @returns Labeled field view instance.
	*/ _createLabeledInputView() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        labeledInput.label = t("Text alternative");
        labeledInput.class = "ck-labeled-field-view_full-width";
        return labeledInput;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A helper utility that positions the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} instance
* with respect to the image in the editor content, if one is selected.
*
* @param editor The editor instance.
* @internal
*/ function $7c22895ca0418c15$export$d8a424a5be4190ef(editor) {
    const balloon = editor.plugins.get("ContextualBalloon");
    if (editor.plugins.get("ImageUtils").getClosestSelectedImageWidget(editor.editing.view.document.selection)) {
        const position = $7c22895ca0418c15$export$52e4a080611dda72(editor);
        balloon.updatePosition(position);
    }
}
/**
* Returns the positioning options that control the geometry of the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} with respect
* to the selected element in the editor content.
*
* @param editor The editor instance.
* @internal
*/ function $7c22895ca0418c15$export$52e4a080611dda72(editor) {
    const editingView = editor.editing.view;
    const defaultPositions = (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions;
    const imageUtils = editor.plugins.get("ImageUtils");
    return {
        target: editingView.domConverter.mapViewToDom(imageUtils.getClosestSelectedImageWidget(editingView.document.selection)),
        positions: [
            defaultPositions.northArrowSouth,
            defaultPositions.northWestArrowSouthWest,
            defaultPositions.northEastArrowSouthEast,
            defaultPositions.southArrowNorth,
            defaultPositions.southWestArrowNorthWest,
            defaultPositions.southEastArrowNorthEast,
            defaultPositions.viewportStickyNorth
        ]
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetextalternative/imagetextalternativeui
*/ /**
* The image text alternative UI plugin.
*
* The plugin uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon}.
*/ var $7c22895ca0418c15$export$af4c43376f1ef970 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* A form containing a textarea and buttons, used to change the `alt` text value.
	*/ _form;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageTextAlternativeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this._createButton();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this._form) this._form.destroy();
    }
    /**
	* Creates a button showing the balloon panel for changing the image text alternative and
	* registers it in the editor {@link module:ui/componentfactory~ComponentFactory ComponentFactory}.
	*/ _createButton() {
        const editor = this.editor;
        const t = editor.t;
        editor.ui.componentFactory.add("imageTextAlternative", (locale)=>{
            const command = editor.commands.get("imageTextAlternative");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                label: t("Change image text alternative"),
                icon: (0, $e8dc502aba5ac3f5$export$fcce8fc510acb082),
                tooltip: true
            });
            view.bind("isEnabled").to(command, "isEnabled");
            view.bind("isOn").to(command, "value", (value)=>!!value);
            this.listenTo(view, "execute", ()=>{
                this._showForm();
            });
            return view;
        });
    }
    /**
	* Creates the {@link module:image/imagetextalternative/ui/textalternativeformview~TextAlternativeFormView}
	* form.
	*/ _createForm() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        const imageUtils = editor.plugins.get("ImageUtils");
        this._balloon = this.editor.plugins.get("ContextualBalloon");
        this._form = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($7c22895ca0418c15$export$e3b28856724d1926))(editor.locale);
        this._form.render();
        this.listenTo(this._form, "submit", ()=>{
            editor.execute("imageTextAlternative", {
                newValue: this._form.labeledInput.fieldView.element.value
            });
            this._hideForm(true);
        });
        this.listenTo(this._form, "cancel", ()=>{
            this._hideForm(true);
        });
        this.listenTo(editor.ui, "update", ()=>{
            if (!imageUtils.getClosestSelectedImageWidget(viewDocument.selection)) this._hideForm(true);
            else if (this._isVisible) $7c22895ca0418c15$export$d8a424a5be4190ef(editor);
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this._form,
            activator: ()=>this._isVisible,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>this._hideForm()
        });
    }
    /**
	* Shows the {@link #_form} in the {@link #_balloon}.
	*/ _showForm() {
        if (this._isVisible) return;
        if (!this._form) this._createForm();
        const editor = this.editor;
        const command = editor.commands.get("imageTextAlternative");
        const labeledInput = this._form.labeledInput;
        this._form.disableCssTransitions();
        if (!this._isInBalloon) this._balloon.add({
            view: this._form,
            position: $7c22895ca0418c15$export$52e4a080611dda72(editor)
        });
        labeledInput.fieldView.value = labeledInput.fieldView.element.value = command.value || "";
        this._form.labeledInput.fieldView.select();
        this._form.enableCssTransitions();
    }
    /**
	* Removes the {@link #_form} from the {@link #_balloon}.
	*
	* @param focusEditable Controls whether the editing view is focused afterwards.
	*/ _hideForm(focusEditable = false) {
        if (!this._isInBalloon) return;
        if (this._form.focusTracker.isFocused) this._form.saveButtonView.focus();
        this._balloon.remove(this._form);
        if (focusEditable) this.editor.editing.view.focus();
    }
    /**
	* Returns `true` when the {@link #_form} is the visible view in the {@link #_balloon}.
	*/ get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
    }
    /**
	* Returns `true` when the {@link #_form} is in the {@link #_balloon}.
	*/ get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetextalternative
*/ /**
* The image text alternative plugin.
*
* For a detailed overview, check the {@glink features/images/images-styles image styles} documentation.
*
* This is a "glue" plugin which loads the
*  {@link module:image/imagetextalternative/imagetextalternativeediting~ImageTextAlternativeEditing}
* and {@link module:image/imagetextalternative/imagetextalternativeui~ImageTextAlternativeUI} plugins.
*/ var $7c22895ca0418c15$export$496687810c56d547 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$e7b530daad14f685,
            $7c22895ca0418c15$export$af4c43376f1ef970
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageTextAlternative";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a function that converts the image view representation:
*
* ```html
* <figure class="image"><img src="..." alt="..."></img></figure>
* ```
*
* to the model representation:
*
* ```html
* <imageBlock src="..." alt="..."></imageBlock>
* ```
*
* The entire content of the `<figure>` element except the first `<img>` is being converted as children
* of the `<imageBlock>` model element.
*
* @internal
*/ function $7c22895ca0418c15$export$29a9b326e63c481a(imageUtils) {
    const converter = (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.test(data.viewItem, {
            name: true,
            classes: "image"
        })) return;
        const viewImage = imageUtils.findViewImgElement(data.viewItem);
        if (!viewImage || !conversionApi.consumable.test(viewImage, {
            name: true
        })) return;
        if (!$7c22895ca0418c15$var$isImageTypePlaceable(conversionApi.schema, data.modelCursor, "imageBlock")) return;
        conversionApi.consumable.consume(data.viewItem, {
            name: true,
            classes: "image"
        });
        const conversionResult = conversionApi.convertItem(viewImage, data.modelCursor);
        /* istanbul ignore if: defensive guard for the `ModelRange | null` return type -- @preserve */ if (!conversionResult.modelRange) {
            conversionApi.consumable.revert(data.viewItem, {
                name: true,
                classes: "image"
            });
            return;
        }
        const modelImage = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(conversionResult.modelRange.getItems());
        if (!modelImage) {
            conversionApi.consumable.revert(data.viewItem, {
                name: true,
                classes: "image"
            });
            return;
        }
        conversionApi.convertChildren(data.viewItem, modelImage);
        conversionApi.updateConversionResult(modelImage, data);
    };
    return (dispatcher)=>{
        dispatcher.on("element:figure", converter);
    };
}
/**
* Returns a function that upcasts an `<img>` element to either an `imageBlock` or an `imageInline` model element.
*
* The image type is first determined from the view structure (see {@link module:image/image/utils~getViewImageType}):
* an `<img>` wrapped in a `<figure class="image">` or styled with `display: block` becomes an `imageBlock`, otherwise
* an `imageInline`.
*
* That structural type is then verified against the schema at the insertion position. If it cannot be placed there -
* neither directly (or after hoisting to an allowed ancestor) nor wrapped in an auto-created paragraph - the converter
* falls back to `matchImageType`. This is what allows a block image to degrade to an inline image inside an inline root
* (and, symmetrically, an inline image to become a block image in a context that only accepts block images) instead of
* being dropped.
*
* Both `ImageBlockEditing` and `ImageInlineEditing` register this converter, each passing the type it falls back to.
* When only one of them is loaded, that single type is always produced.
*
* @internal
* @param matchImageType The image type to fall back to when the type resolved from the view cannot be placed at the
* insertion position.
* @param imageUtils The `ImageUtils` plugin instance.
*/ function $7c22895ca0418c15$var$upcastImg(matchImageType, imageUtils) {
    const converter = (evt, data, conversionApi)=>{
        let imageType = $7c22895ca0418c15$var$getViewImageType(data.viewItem, imageUtils);
        const attributes = data.viewItem.hasAttribute("src") ? {
            src: data.viewItem.getAttribute("src")
        } : void 0;
        const consumables = {
            name: true,
            attributes: Object.keys(attributes || {})
        };
        if (!conversionApi.consumable.test(data.viewItem, consumables)) return;
        if (imageType != matchImageType && !$7c22895ca0418c15$var$isImageTypePlaceable(conversionApi.schema, data.modelCursor, imageType)) imageType = matchImageType;
        const modelElement = conversionApi.writer.createElement(imageType, attributes);
        if (!conversionApi.safeInsert(modelElement, data.modelCursor)) return;
        conversionApi.consumable.consume(data.viewItem, consumables);
        conversionApi.convertChildren(data.viewItem, modelElement);
        conversionApi.updateConversionResult(modelElement, data);
    };
    return (dispatcher)=>{
        dispatcher.on("element:img", converter);
    };
}
/**
* Returns a function that converts the image view representation:
*
* ```html
* <picture><source ... /><source ... />...<img ... /></picture>
* ```
*
* to the model representation as the `sources` attribute:
*
* ```html
* <image[Block|Inline] ... sources="..."></image[Block|Inline]>
* ```
*
* @internal
*/ function $7c22895ca0418c15$export$2731255a52770d78(imageUtils) {
    const sourceAttributeNames = [
        "srcset",
        "media",
        "type",
        "sizes"
    ];
    const converter = (evt, data, conversionApi)=>{
        const pictureViewElement = data.viewItem;
        if (!conversionApi.consumable.test(pictureViewElement, {
            name: true
        })) return;
        const sources = /* @__PURE__ */ new Map();
        for (const childSourceElement of pictureViewElement.getChildren())if (childSourceElement.is("element", "source")) {
            const attributes = {};
            for (const name of sourceAttributeNames)if (childSourceElement.hasAttribute(name)) {
                if (conversionApi.consumable.test(childSourceElement, {
                    attributes: name
                })) attributes[name] = childSourceElement.getAttribute(name);
            }
            if (Object.keys(attributes).length) sources.set(childSourceElement, attributes);
        }
        const imgViewElement = imageUtils.findViewImgElement(pictureViewElement);
        if (!imgViewElement) return;
        let modelImage = data.modelCursor.parent;
        if (!modelImage.is("element", "imageBlock")) {
            const conversionResult = conversionApi.convertItem(imgViewElement, data.modelCursor);
            data.modelRange = conversionResult.modelRange;
            data.modelCursor = conversionResult.modelCursor;
            /* istanbul ignore if: defensive guard for the `ModelRange | null` return type -- @preserve */ if (!conversionResult.modelRange) return;
            modelImage = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(conversionResult.modelRange.getItems());
            if (!modelImage) return;
        }
        conversionApi.consumable.consume(pictureViewElement, {
            name: true
        });
        for (const [sourceElement, attributes] of sources)conversionApi.consumable.consume(sourceElement, {
            attributes: Object.keys(attributes)
        });
        if (sources.size) conversionApi.writer.setAttribute("sources", Array.from(sources.values()), modelImage);
        conversionApi.convertChildren(pictureViewElement, modelImage);
    };
    return (dispatcher)=>{
        dispatcher.on("element:picture", converter);
    };
}
/**
* Converter used to convert the `srcset` model image attribute to the `srcset` and `sizes` attributes in the view.
*
* @internal
* @param imageType The type of the image.
*/ function $7c22895ca0418c15$export$e754d7901cbdb7a2(imageUtils, imageType) {
    const converter = (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const writer = conversionApi.writer;
        const element = conversionApi.mapper.toViewElement(data.item);
        const img = imageUtils.findViewImgElement(element);
        if (data.attributeNewValue === null) {
            writer.removeAttribute("srcset", img);
            writer.removeAttribute("sizes", img);
        } else if (data.attributeNewValue) {
            writer.setAttribute("srcset", data.attributeNewValue, img);
            writer.setAttribute("sizes", "100vw", img);
        }
    };
    return (dispatcher)=>{
        dispatcher.on(`attribute:srcset:${imageType}`, converter);
    };
}
/**
* Converts the `source` model attribute to the `<picture><source /><source />...<img /></picture>`
* view structure.
*
* @internal
*/ function $7c22895ca0418c15$export$f901a8a9475c3a60(imageUtils) {
    const converter = (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const viewWriter = conversionApi.writer;
        const element = conversionApi.mapper.toViewElement(data.item);
        const imgElement = imageUtils.findViewImgElement(element);
        const attributeNewValue = data.attributeNewValue;
        if (attributeNewValue && attributeNewValue.length) {
            const attributeElements = [];
            let viewElement = imgElement.parent;
            while(viewElement && viewElement.is("attributeElement")){
                const parentElement = viewElement.parent;
                viewWriter.unwrap(viewWriter.createRangeOn(imgElement), viewElement);
                attributeElements.unshift(viewElement);
                viewElement = parentElement;
            }
            const hasPictureElement = imgElement.parent.is("element", "picture");
            const pictureElement = hasPictureElement ? imgElement.parent : viewWriter.createContainerElement("picture", null);
            if (!hasPictureElement) viewWriter.insert(viewWriter.createPositionBefore(imgElement), pictureElement);
            viewWriter.remove(viewWriter.createRangeIn(pictureElement));
            viewWriter.insert(viewWriter.createPositionAt(pictureElement, "end"), attributeNewValue.map((sourceAttributes)=>{
                return viewWriter.createEmptyElement("source", sourceAttributes);
            }));
            viewWriter.move(viewWriter.createRangeOn(imgElement), viewWriter.createPositionAt(pictureElement, "end"));
            for (const attributeElement of attributeElements)viewWriter.wrap(viewWriter.createRangeOn(pictureElement), attributeElement);
        } else if (imgElement.parent.is("element", "picture")) {
            const pictureElement = imgElement.parent;
            viewWriter.move(viewWriter.createRangeOn(imgElement), viewWriter.createPositionBefore(pictureElement));
            viewWriter.remove(pictureElement);
        }
    };
    return (dispatcher)=>{
        dispatcher.on("attribute:sources:imageBlock", converter);
        dispatcher.on("attribute:sources:imageInline", converter);
    };
}
/**
* Converter used to convert a given image attribute from the model to the view.
*
* @internal
* @param imageType The type of the image.
* @param attributeKey The name of the attribute to convert.
*/ function $7c22895ca0418c15$export$3235cbd006772833(imageUtils, imageType, attributeKey) {
    const converter = (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const viewWriter = conversionApi.writer;
        const element = conversionApi.mapper.toViewElement(data.item);
        const img = imageUtils.findViewImgElement(element);
        viewWriter.setAttribute(data.attributeKey, data.attributeNewValue || "", img);
    };
    return (dispatcher)=>{
        dispatcher.on(`attribute:${attributeKey}:${imageType}`, converter);
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/imageloadobserver
*/ /**
* Observes all new images added to the {@link module:engine/view/document~ViewDocument},
* fires {@link module:engine/view/document~ViewDocument#event:imageLoaded} and
* {@link module:engine/view/document~ViewDocument#event:layoutChanged} event every time when the new image
* has been loaded.
*
* **Note:** This event is not fired for images that has been added to the document and rendered as `complete` (already loaded).
*/ var $7c22895ca0418c15$export$201f2e45e6b19560 = class extends (0, $b9b9f2bdf9c6137f$export$c1cbdee04e18ea8b) {
    /**
	* @inheritDoc
	*/ observe(domRoot) {
        this.listenTo(domRoot, "load", (event, domEvent)=>{
            const domElement = domEvent.target;
            if (this.checkShouldIgnoreEventFromTarget(domElement)) return;
            if (domElement.tagName == "IMG") this._fireEvents(domEvent);
        }, {
            useCapture: true
        });
    }
    /**
	* @inheritDoc
	*/ stopObserving(domRoot) {
        this.stopListening(domRoot);
    }
    /**
	* Fires {@link module:engine/view/document~ViewDocument#event:layoutChanged} and
	* {@link module:engine/view/document~ViewDocument#event:imageLoaded}
	* if observer {@link #isEnabled is enabled}.
	*
	* @param domEvent The DOM event.
	*/ _fireEvents(domEvent) {
        if (this.isEnabled) {
            this.document.fire("layoutChanged");
            this.document.fire("imageLoaded", domEvent);
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/insertimagecommand
*/ /**
* Insert image command.
*
* The command is registered by the {@link module:image/image/imageediting~ImageEditing} plugin as `insertImage`
* and it is also available via aliased `imageInsert` name.
*
* In order to insert an image at the current selection position
* (according to the {@link module:widget/utils~findOptimalInsertionRange} algorithm),
* execute the command and specify the image source:
*
* ```ts
* editor.execute( 'insertImage', { source: 'http://url.to.the/image' } );
* ```
*
* It is also possible to insert multiple images at once:
*
* ```ts
* editor.execute( 'insertImage', {
* 	source:  [
* 		'path/to/image.jpg',
* 		'path/to/other-image.jpg'
* 	]
* } );
* ```
*
* If you want to take the full control over the process, you can specify individual model attributes:
*
* ```ts
* editor.execute( 'insertImage', {
* 	source:  [
* 		{ src: 'path/to/image.jpg', alt: 'First alt text' },
* 		{ src: 'path/to/other-image.jpg', alt: 'Second alt text', customAttribute: 'My attribute value' }
* 	]
* } );
* ```
*/ var $7c22895ca0418c15$export$205a8c97eb6e3111 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        const configImageInsertType = editor.config.get("image.insert.type");
        if (!editor.plugins.has("ImageBlockEditing")) {
            if (configImageInsertType === "block") /**
			* The {@link module:image/imageblock~ImageBlock} plugin must be enabled to allow inserting block images. See
			* {@link module:image/imageconfig~ImageInsertConfig#type} to learn more.
			*
			* @error image-block-plugin-required
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-block-plugin-required");
        }
        if (!editor.plugins.has("ImageInlineEditing")) {
            if (configImageInsertType === "inline") /**
			* The {@link module:image/imageinline~ImageInline} plugin must be enabled to allow inserting inline images. See
			* {@link module:image/imageconfig~ImageInsertConfig#type} to learn more.
			*
			* @error image-inline-plugin-required
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-inline-plugin-required");
        }
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const imageUtils = this.editor.plugins.get("ImageUtils");
        this.isEnabled = imageUtils.isImageAllowed();
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Options for the executed command.
	* @param options.imageType The type of the image to insert. If not specified, the type will be determined automatically.
	* @param options.source The image source or an array of image sources to insert.
	* @param options.breakBlock If set to `true`, the block at the selection start will be broken before inserting the image.
	* See the documentation of the command to learn more about accepted formats.
	*/ execute(options) {
        const sourceDefinitions = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.source);
        const selection = this.editor.model.document.selection;
        const imageUtils = this.editor.plugins.get("ImageUtils");
        const selectionAttributes = Object.fromEntries(selection.getAttributes());
        sourceDefinitions.forEach((sourceDefinition, index)=>{
            const selectedElement = selection.getSelectedElement();
            if (typeof sourceDefinition === "string") sourceDefinition = {
                src: sourceDefinition
            };
            if (index && selectedElement && imageUtils.isImage(selectedElement)) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                imageUtils.insertImage({
                    ...sourceDefinition,
                    ...selectionAttributes
                }, position, options.imageType);
            } else if (options.breakBlock) imageUtils.insertImage({
                ...sourceDefinition,
                ...selectionAttributes
            }, selection.getFirstPosition(), options.imageType);
            else imageUtils.insertImage({
                ...sourceDefinition,
                ...selectionAttributes
            }, null, options.imageType);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/replaceimagesourcecommand
*/ /**
* Replace image source command.
*
* Changes image source to the one provided. Can be executed as follows:
*
* ```ts
* editor.execute( 'replaceImageSource', { source: 'http://url.to.the/image' } );
* ```
*/ var $7c22895ca0418c15$export$361999a13627bc99 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    constructor(editor){
        super(editor);
        this.decorate("cleanupImage");
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const imageUtils = this.editor.plugins.get("ImageUtils");
        const element = this.editor.model.document.selection.getSelectedElement();
        this.isEnabled = imageUtils.isImage(element);
        this.value = this.isEnabled ? element.getAttribute("src") : null;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Options for the executed command.
	* @param options.source The image source to replace.
	*/ execute(options) {
        const image = this.editor.model.document.selection.getSelectedElement();
        const imageUtils = this.editor.plugins.get("ImageUtils");
        this.editor.model.change((writer)=>{
            writer.setAttribute("src", options.source, image);
            this.cleanupImage(writer, image);
            imageUtils.setImageNaturalSizeAttributes(image);
        });
    }
    /**
	* Cleanup image attributes that are not relevant to the new source.
	*
	* Removed attributes are: 'srcset', 'sizes', 'sources', 'width', 'height', 'alt'.
	*
	* This method is decorated, to allow custom cleanup logic.
	* For example, to remove 'myImageId' attribute after 'src' has changed:
	*
	* ```ts
	* replaceImageSourceCommand.on( 'cleanupImage', ( eventInfo, [ writer, image ] ) => {
	* 	writer.removeAttribute( 'myImageId', image );
	* } );
	* ```
	*/ cleanupImage(writer, image) {
        writer.removeAttribute("srcset", image);
        writer.removeAttribute("sizes", image);
        /**
		* In case responsive images some attributes should be cleaned up.
		* Check: https://github.com/ckeditor/ckeditor5/issues/15093
		*/ writer.removeAttribute("sources", image);
        writer.removeAttribute("width", image);
        writer.removeAttribute("height", image);
        writer.removeAttribute("alt", image);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/imageediting
*/ /**
* The image engine plugin. This module loads common code shared between
* {@link module:image/image/imageinlineediting~ImageInlineEditing} and
* {@link module:image/image/imageblockediting~ImageBlockEditing} plugins.
*
* This plugin registers the {@link module:image/image/insertimagecommand~InsertImageCommand 'insertImage'} command.
*/ var $7c22895ca0418c15$export$2cb8e8efa7161979 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const conversion = editor.conversion;
        editor.editing.view.addObserver($7c22895ca0418c15$export$201f2e45e6b19560);
        conversion.for("upcast").attributeToAttribute({
            view: {
                name: "img",
                key: "alt"
            },
            model: "alt"
        }).attributeToAttribute({
            view: {
                name: "img",
                key: "srcset"
            },
            model: "srcset"
        });
        const insertImageCommand = new $7c22895ca0418c15$export$205a8c97eb6e3111(editor);
        const replaceImageSourceCommand = new $7c22895ca0418c15$export$361999a13627bc99(editor);
        editor.commands.add("insertImage", insertImageCommand);
        editor.commands.add("replaceImageSource", replaceImageSourceCommand);
        editor.commands.add("imageInsert", insertImageCommand);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagesizeattributes
*/ /**
* This plugin enables `width` and `height` attributes in inline and block image elements.
*/ var $7c22895ca0418c15$export$1fa52a06e71b6864 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageSizeAttributes";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._registerSchema();
        this._registerConverters("imageBlock");
        this._registerConverters("imageInline");
    }
    /**
	* Registers the `width` and `height` attributes for inline and block images.
	*/ _registerSchema() {
        const schema = this.editor.model.schema;
        if (this.editor.plugins.has("ImageBlockEditing")) schema.extend("imageBlock", {
            allowAttributes: [
                "width",
                "height"
            ]
        });
        if (this.editor.plugins.has("ImageInlineEditing")) schema.extend("imageInline", {
            allowAttributes: [
                "width",
                "height"
            ]
        });
    }
    /**
	* Registers converters for `width` and `height` attributes.
	*/ _registerConverters(imageType) {
        const editor = this.editor;
        const imageUtils = editor.plugins.get("ImageUtils");
        const viewElementName = imageType === "imageBlock" ? "figure" : "img";
        editor.conversion.for("upcast").attributeToAttribute({
            view: {
                name: viewElementName,
                styles: {
                    width: /.+/
                }
            },
            model: {
                key: "width",
                value: (viewElement)=>{
                    if ($7c22895ca0418c15$export$f12d3d28bbd41988(viewElement)) return $7c22895ca0418c15$export$fccb0d1d556e3d9c(viewElement.getStyle("width"));
                    return null;
                }
            }
        }).attributeToAttribute({
            view: {
                name: viewElementName,
                key: "width"
            },
            model: "width"
        }).attributeToAttribute({
            view: {
                name: viewElementName,
                styles: {
                    height: /.+/
                }
            },
            model: {
                key: "height",
                value: (viewElement)=>{
                    if ($7c22895ca0418c15$export$f12d3d28bbd41988(viewElement)) return $7c22895ca0418c15$export$fccb0d1d556e3d9c(viewElement.getStyle("height"));
                    return null;
                }
            }
        }).attributeToAttribute({
            view: {
                name: viewElementName,
                key: "height"
            },
            model: "height"
        });
        editor.conversion.for("editingDowncast").add((dispatcher)=>{
            attachDowncastConverter(dispatcher, "width", "width", true, true);
            attachDowncastConverter(dispatcher, "height", "height", true, true);
        });
        editor.conversion.for("dataDowncast").add((dispatcher)=>{
            attachDowncastConverter(dispatcher, "width", "width", false);
            attachDowncastConverter(dispatcher, "height", "height", false);
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:img", (evt, data, conversionApi)=>{
                const width = data.viewItem.getAttribute("width");
                const height = data.viewItem.getAttribute("height");
                if (width && height) conversionApi.consumable.consume(data.viewItem, {
                    styles: [
                        "aspect-ratio"
                    ]
                });
            });
        });
        function attachDowncastConverter(dispatcher, modelAttributeName, viewAttributeName, setRatioForInlineImage, isEditingDowncast = false) {
            dispatcher.on(`attribute:${modelAttributeName}:${imageType}`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const viewWriter = conversionApi.writer;
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                const img = imageUtils.findViewImgElement(viewElement);
                if (data.attributeNewValue !== null) viewWriter.setAttribute(viewAttributeName, data.attributeNewValue, img);
                else viewWriter.removeAttribute(viewAttributeName, img);
                const width = data.item.getAttribute("width");
                const height = data.item.getAttribute("height");
                const hasSizes = width && height;
                if (hasSizes && isEditingDowncast) viewWriter.setAttribute("loading", "lazy", img);
                if (data.item.hasAttribute("sources")) return;
                const isResized = data.item.hasAttribute("resizedWidth");
                if (imageType === "imageInline" && !isResized && !setRatioForInlineImage) return;
                if (hasSizes) viewWriter.setStyle("aspect-ratio", `${width}/${height}`, img);
            });
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The image type command. It changes the type of a selected image, depending on the configuration.
*/ var $7c22895ca0418c15$export$df809909be8c7fec = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Model element name the command converts to.
	*/ _modelElementName;
    /**
	* @inheritDoc
	*
	* @param modelElementName Model element name the command converts to.
	*/ constructor(editor, modelElementName){
        super(editor);
        this._modelElementName = modelElementName;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const model = editor.model;
        const schema = model.schema;
        const imageUtils = editor.plugins.get("ImageUtils");
        const element = imageUtils.getClosestSelectedImageElement(model.document.selection);
        if (!(this._modelElementName === "imageBlock" ? imageUtils.isInlineImage(element) : imageUtils.isBlockImage(element))) {
            this.isEnabled = false;
            return;
        }
        const position = model.createPositionBefore(element);
        this.isEnabled = $7c22895ca0418c15$var$isImageTypePlaceable(schema, position, this._modelElementName);
    }
    /**
	* Executes the command and changes the type of a selected image.
	*
	* @fires execute
	* @param options.setImageSizes Specifies whether the image `width` and `height` attributes should be set automatically.
	* The default is `true`.
	* @returns An object containing references to old and new model image elements
	* (for before and after the change) so external integrations can hook into the decorated
	* `execute` event and handle this change. `null` if the type change failed.
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = this.editor.model;
        const imageUtils = editor.plugins.get("ImageUtils");
        const oldElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
        const attributes = Object.fromEntries(oldElement.getAttributes());
        if (!attributes.src && !attributes.uploadId) return null;
        return model.change((writer)=>{
            const { setImageSizes: setImageSizes = true } = options;
            const markers = Array.from(model.markers).filter((marker)=>marker.getRange().containsItem(oldElement));
            const newElement = imageUtils.insertImage(attributes, model.createSelection(oldElement, "on"), this._modelElementName, {
                setImageSizes: setImageSizes
            });
            if (!newElement) return null;
            const newElementRange = writer.createRangeOn(newElement);
            for (const marker of markers){
                const markerRange = marker.getRange();
                const range = markerRange.root.rootName != "$graveyard" ? markerRange.getJoined(newElementRange, true) : newElementRange;
                writer.updateMarker(marker, {
                    range: range
                });
            }
            return {
                oldElement: oldElement,
                newElement: newElement
            };
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/imageplaceholder
*/ /**
* Adds support for image placeholder that is automatically removed when the image is loaded.
*/ var $7c22895ca0418c15$export$3f37af283f8fb843 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImagePlaceholder";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._setupSchema();
        this._setupConversion();
        this._setupLoadListener();
    }
    /**
	* Extends model schema.
	*/ _setupSchema() {
        const schema = this.editor.model.schema;
        if (schema.isRegistered("imageBlock")) schema.extend("imageBlock", {
            allowAttributes: [
                "placeholder"
            ]
        });
        if (schema.isRegistered("imageInline")) schema.extend("imageInline", {
            allowAttributes: [
                "placeholder"
            ]
        });
    }
    /**
	* Registers converters.
	*/ _setupConversion() {
        const editor = this.editor;
        const conversion = editor.conversion;
        const imageUtils = editor.plugins.get("ImageUtils");
        conversion.for("editingDowncast").add((dispatcher)=>{
            dispatcher.on("attribute:placeholder", (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.test(data.item, evt.name)) return;
                if (!data.item.is("element", "imageBlock") && !data.item.is("element", "imageInline")) return;
                conversionApi.consumable.consume(data.item, evt.name);
                const viewWriter = conversionApi.writer;
                const element = conversionApi.mapper.toViewElement(data.item);
                const img = imageUtils.findViewImgElement(element);
                if (data.attributeNewValue) {
                    viewWriter.addClass("image_placeholder", img);
                    viewWriter.setStyle("background-image", `url(${data.attributeNewValue})`, img);
                    viewWriter.setCustomProperty("editingPipeline:doNotReuseOnce", true, img);
                } else {
                    viewWriter.removeClass("image_placeholder", img);
                    viewWriter.removeStyle("background-image", img);
                }
            });
        });
    }
    /**
	* Prepares listener for image load.
	*/ _setupLoadListener() {
        const editor = this.editor;
        const model = editor.model;
        const editing = editor.editing;
        const editingView = editing.view;
        const imageUtils = editor.plugins.get("ImageUtils");
        editingView.addObserver($7c22895ca0418c15$export$201f2e45e6b19560);
        this.listenTo(editingView.document, "imageLoaded", (evt, domEvent)=>{
            const imgViewElement = editingView.domConverter.mapDomToView(domEvent.target);
            if (!imgViewElement) return;
            const viewElement = imageUtils.getImageWidgetFromImageView(imgViewElement);
            if (!viewElement) return;
            const modelElement = editing.mapper.toModelElement(viewElement);
            if (!modelElement || !modelElement.hasAttribute("placeholder")) return;
            model.enqueueChange({
                isUndoable: false
            }, (writer)=>{
                writer.removeAttribute("placeholder", modelElement);
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/imageblockediting
*/ /**
* The image block plugin.
*
* It registers:
*
* * `<imageBlock>` as a block element in the document schema, and allows `alt`, `src` and `srcset` attributes.
* * converters for editing and data pipelines.,
* * {@link module:image/image/imagetypecommand~ImageTypeCommand `'imageTypeBlock'`} command that converts inline images into
* block images.
*/ var $7c22895ca0418c15$export$23a23e79feddcf18 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$2cb8e8efa7161979,
            $7c22895ca0418c15$export$1fa52a06e71b6864,
            $7c22895ca0418c15$export$698882cf06df44aa,
            $7c22895ca0418c15$export$3f37af283f8fb843,
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageBlockEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.register("imageBlock", {
            inheritAllFrom: "$blockObject",
            allowAttributes: [
                "alt",
                "src",
                "srcset"
            ]
        });
        this._setupConversion();
        if (editor.plugins.has("ImageInlineEditing")) {
            editor.commands.add("imageTypeBlock", new $7c22895ca0418c15$export$df809909be8c7fec(this.editor, "imageBlock"));
            this._setupClipboardIntegration();
        }
    }
    /**
	* Configures conversion pipelines to support upcasting and downcasting
	* block images (block image widgets) and their attributes.
	*/ _setupConversion() {
        const editor = this.editor;
        const t = editor.t;
        const conversion = editor.conversion;
        const imageUtils = editor.plugins.get("ImageUtils");
        conversion.for("dataDowncast").elementToStructure({
            model: "imageBlock",
            view: (modelElement, { writer: writer })=>$7c22895ca0418c15$export$22b9b37acbcfa427(writer)
        });
        conversion.for("editingDowncast").elementToStructure({
            model: "imageBlock",
            view: (modelElement, { writer: writer })=>imageUtils.toImageWidget($7c22895ca0418c15$export$22b9b37acbcfa427(writer), writer, t("image widget"))
        });
        conversion.for("downcast").add($7c22895ca0418c15$export$3235cbd006772833(imageUtils, "imageBlock", "src")).add($7c22895ca0418c15$export$3235cbd006772833(imageUtils, "imageBlock", "alt")).add($7c22895ca0418c15$export$e754d7901cbdb7a2(imageUtils, "imageBlock"));
        conversion.for("upcast").add($7c22895ca0418c15$var$upcastImg("imageBlock", imageUtils)).add($7c22895ca0418c15$export$29a9b326e63c481a(imageUtils));
    }
    /**
	* Integrates the plugin with the clipboard pipeline.
	*
	* Idea is that the feature should recognize the user's intent when an **inline** image is
	* pasted or dropped. If such an image is pasted/dropped:
	*
	* * into an empty block (e.g. an empty paragraph),
	* * on another object (e.g. some block widget).
	*
	* it gets converted into a block image on the fly. We assume this is the user's intent
	* if they decided to put their image there.
	*
	* See the `ImageInlineEditing` for the similar integration that works in the opposite direction.
	*
	* The feature also sets image `width` and `height` attributes on paste.
	*/ _setupClipboardIntegration() {
        const editor = this.editor;
        const model = editor.model;
        const editingView = editor.editing.view;
        const imageUtils = editor.plugins.get("ImageUtils");
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "inputTransformation", (evt, data)=>{
            const docFragmentChildren = Array.from(data.content.getChildren());
            let modelRange;
            if (!docFragmentChildren.every(imageUtils.isInlineImageView)) return;
            if (data.targetRanges) modelRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
            else modelRange = model.document.selection.getFirstRange();
            const selection = model.createSelection(modelRange);
            const selectionPosition = selection.getFirstPosition();
            if (!!selectionPosition && $7c22895ca0418c15$var$isImageTypePlaceable(model.schema, selectionPosition, "imageBlock") && $7c22895ca0418c15$export$c2ad1be5db89b488(model.schema, selection) === "imageBlock") {
                const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(editingView.document);
                const blockViewImages = docFragmentChildren.map((inlineViewImage)=>writer.createElement("figure", {
                        class: "image"
                    }, inlineViewImage));
                data.content = writer.createDocumentFragment(blockViewImages);
            }
        });
        this.listenTo(clipboardPipeline, "contentInsertion", (evt, data)=>{
            if (data.method !== "paste") return;
            model.change((writer)=>{
                const range = writer.createRangeIn(data.content);
                for (const item of range.getItems())if (item.is("element", "imageBlock")) imageUtils.setImageNaturalSizeAttributes(item);
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsert/ui/imageinsertformview
*/ /**
* The view displayed in the insert image dropdown.
*
* See {@link module:image/imageinsert/imageinsertui~ImageInsertUI}.
*
* @internal
*/ var $7c22895ca0418c15$export$3ce584c710d850e8 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* A collection of the defined integrations for inserting the images.
	*/ children;
    /**
	* Creates a view for the dropdown panel of {@link module:image/imageinsert/imageinsertui~ImageInsertUI}.
	*
	* @param locale The localization services instance.
	* @param integrations An integrations object that contains components (or tokens for components) to be shown in the panel view.
	*/ constructor(locale, integrations = []){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this.children = this.createCollection();
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        for (const view of integrations){
            this.children.add(view);
            this._focusables.add(view);
            if (view instanceof (0, $29fd27cb9bdab9d2$export$8a82f5df0c7d8945)) this._focusables.addMany(view.children);
        }
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-image-insert-form"
                ],
                tabindex: -1
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        for (const view of this._focusables)this.focusTracker.add(view.element);
        this.keystrokes.listenTo(this.element);
        const stopPropagation = (data)=>data.stopPropagation();
        this.keystrokes.set("arrowright", stopPropagation);
        this.keystrokes.set("arrowleft", stopPropagation);
        this.keystrokes.set("arrowup", stopPropagation);
        this.keystrokes.set("arrowdown", stopPropagation);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the first {@link #_focusables focusable} in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsert/imageinsertui
*/ /**
* The image insert dropdown plugin.
*
* For a detailed overview, check the {@glink features/images/image-upload/image-upload Image upload feature}
* and {@glink features/images/images-inserting Insert images via source URL} documentation.
*
* Adds the `'insertImage'` dropdown to the {@link module:ui/componentfactory~ComponentFactory UI component factory}
* and also the `imageInsert` dropdown as an alias for backward compatibility.
*
* Adds the `'menuBar:insertImage'` sub-menu to the {@link module:ui/componentfactory~ComponentFactory UI component factory}, which is
* by default added to the `'Insert'` menu.
*/ var $7c22895ca0418c15$export$3946c48aa73e9ec1 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInsertUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* The dropdown view responsible for displaying the image insert UI.
	*/ dropdownView;
    /**
	* Registered integrations map.
	*/ _integrations = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("image.insert.integrations", [
            "upload",
            "assetManager",
            "url"
        ]);
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const imageUtils = editor.plugins.get("ImageUtils");
        this.set("isImageSelected", false);
        this.listenTo(editor.model.document, "change", ()=>{
            this.isImageSelected = imageUtils.isImage(selection.getSelectedElement());
        });
        const componentCreator = (locale)=>this._createToolbarComponent(locale);
        const menuBarComponentCreator = (locale)=>this._createMenuBarComponent(locale);
        editor.ui.componentFactory.add("insertImage", componentCreator);
        editor.ui.componentFactory.add("imageInsert", componentCreator);
        editor.ui.componentFactory.add("menuBar:insertImage", menuBarComponentCreator);
    }
    /**
	* Registers the insert image dropdown integration.
	*/ registerIntegration({ name: name, observable: observable, buttonViewCreator: buttonViewCreator, formViewCreator: formViewCreator, menuBarButtonViewCreator: menuBarButtonViewCreator, requiresForm: requiresForm = false, override: override = false }) {
        if (this._integrations.has(name) && !override) /**
		* There are two insert-image integrations registered with the same name.
		*
		* Make sure that you do not load multiple asset manager plugins.
		*
		* @error image-insert-integration-exists
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-insert-integration-exists", {
            name: name
        });
        this._integrations.set(name, {
            observable: observable,
            buttonViewCreator: buttonViewCreator,
            menuBarButtonViewCreator: menuBarButtonViewCreator,
            formViewCreator: formViewCreator,
            requiresForm: requiresForm
        });
    }
    /**
	* Creates the toolbar component.
	*/ _createToolbarComponent(locale) {
        const editor = this.editor;
        const t = locale.t;
        const integrations = this._prepareIntegrations();
        if (!integrations.length) return null;
        let dropdownButton;
        const firstIntegration = integrations[0];
        if (integrations.length == 1) {
            if (!firstIntegration.requiresForm) return firstIntegration.buttonViewCreator(true);
            dropdownButton = firstIntegration.buttonViewCreator(true);
        } else {
            const actionButton = firstIntegration.buttonViewCreator(false);
            dropdownButton = new (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9)(locale, actionButton);
            dropdownButton.tooltip = true;
            dropdownButton.bind("label").to(this, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace image") : t("Insert image"));
        }
        const dropdownView = this.dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, dropdownButton);
        const observables = integrations.map(({ observable: observable })=>typeof observable == "function" ? observable() : observable);
        dropdownView.bind("isEnabled").toMany(observables, "isEnabled", (...isEnabled)=>isEnabled.some((isEnabled)=>isEnabled));
        dropdownView.once("change:isOpen", ()=>{
            const integrationViews = integrations.flatMap(({ formViewCreator: formViewCreator })=>formViewCreator(integrations.length == 1));
            const imageInsertFormView = new $7c22895ca0418c15$export$3ce584c710d850e8(editor.locale, integrationViews);
            dropdownView.panelView.children.add(imageInsertFormView);
        });
        return dropdownView;
    }
    /**
	* Creates the menu bar component.
	*/ _createMenuBarComponent(locale) {
        const t = locale.t;
        const integrations = this._prepareIntegrations();
        if (!integrations.length) return null;
        const integrationViews = integrations.flatMap(({ menuBarButtonViewCreator: menuBarButtonViewCreator })=>menuBarButtonViewCreator(integrations.length == 1));
        const resultView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
        const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
        resultView.panelView.children.add(listView);
        resultView.buttonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$ce763e1c75a88f49),
            label: t("Image")
        });
        for (const integrationView of integrationViews){
            const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, resultView);
            listItemView.children.add(integrationView);
            listView.items.add(listItemView);
            integrationView.delegate("execute").to(resultView);
        }
        return resultView;
    }
    /**
	* Validates the integrations list.
	*/ _prepareIntegrations() {
        const items = this.editor.config.get("image.insert.integrations");
        const result = [];
        if (!items.length) {
            /**
			* The insert image feature requires a list of integrations to be provided in the editor configuration.
			*
			* The default list of integrations is `upload`, `assetManager`, `url`. Those integrations are included
			* in the insert image dropdown if the given feature plugin is loaded. You should omit the `integrations`
			* configuration key to use the default set or provide a selected list of integrations that should be used.
			*
			* @error image-insert-integrations-not-specified
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-insert-integrations-not-specified");
            return result;
        }
        for (const item of items){
            if (!this._integrations.has(item)) {
                if (![
                    "upload",
                    "assetManager",
                    "url"
                ].includes(item)) /**
				* The specified insert image integration name is unknown or the providing plugin is not loaded in the editor.
				*
				* @error image-insert-unknown-integration
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-insert-unknown-integration", {
                    item: item
                });
                continue;
            }
            result.push(this._integrations.get(item));
        }
        if (!result.length) /**
		* The image insert feature requires integrations to be registered by separate features.
		*
		* The `insertImage` toolbar button requires integrations to be registered by other features.
		* For example {@link module:image/imageupload~ImageUpload ImageUpload},
		* {@link module:image/imageinsert~ImageInsert ImageInsert},
		* {@link module:image/imageinsertviaurl~ImageInsertViaUrl ImageInsertViaUrl},
		* {@link module:ckbox/ckbox~CKBox CKBox}
		*
		* @error image-insert-integrations-not-registered
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-insert-integrations-not-registered");
        return result;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageblock
*/ /**
* The image block plugin.
*
* This is a "glue" plugin which loads the following plugins:
*
* * {@link module:image/image/imageblockediting~ImageBlockEditing},
* * {@link module:image/imagetextalternative~ImageTextAlternative}.
*
* Usually, it is used in conjunction with other plugins from this package. See the {@glink api/image package page}
* for more information.
*/ var $7c22895ca0418c15$export$37a52fa31b599ac5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$23a23e79feddcf18,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a),
            $7c22895ca0418c15$export$496687810c56d547,
            $7c22895ca0418c15$export$3946c48aa73e9ec1
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageBlock";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image/imageinlineediting
*/ /**
* The image inline plugin.
*
* It registers:
*
* * `<imageInline>` as an inline element in the document schema, and allows `alt`, `src` and `srcset` attributes.
* * converters for editing and data pipelines.
* * {@link module:image/image/imagetypecommand~ImageTypeCommand `'imageTypeInline'`} command that converts block images into
* inline images.
*/ var $7c22895ca0418c15$export$dc0ea412859d6d2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$2cb8e8efa7161979,
            $7c22895ca0418c15$export$1fa52a06e71b6864,
            $7c22895ca0418c15$export$698882cf06df44aa,
            $7c22895ca0418c15$export$3f37af283f8fb843,
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInlineEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.register("imageInline", {
            inheritAllFrom: "$inlineObject",
            allowAttributes: [
                "alt",
                "src",
                "srcset"
            ],
            disallowIn: [
                "caption"
            ]
        });
        this._setupConversion();
        if (editor.plugins.has("ImageBlockEditing")) {
            editor.commands.add("imageTypeInline", new $7c22895ca0418c15$export$df809909be8c7fec(this.editor, "imageInline"));
            this._setupClipboardIntegration();
        }
    }
    /**
	* Configures conversion pipelines to support upcasting and downcasting
	* inline images (inline image widgets) and their attributes.
	*/ _setupConversion() {
        const editor = this.editor;
        const t = editor.t;
        const conversion = editor.conversion;
        const imageUtils = editor.plugins.get("ImageUtils");
        conversion.for("dataDowncast").elementToElement({
            model: "imageInline",
            view: (modelElement, { writer: writer })=>writer.createEmptyElement("img")
        });
        conversion.for("editingDowncast").elementToStructure({
            model: "imageInline",
            view: (modelElement, { writer: writer })=>imageUtils.toImageWidget($7c22895ca0418c15$export$396de7f0526904d1(writer), writer, t("image widget"))
        });
        conversion.for("downcast").add($7c22895ca0418c15$export$3235cbd006772833(imageUtils, "imageInline", "src")).add($7c22895ca0418c15$export$3235cbd006772833(imageUtils, "imageInline", "alt")).add($7c22895ca0418c15$export$e754d7901cbdb7a2(imageUtils, "imageInline"));
        conversion.for("upcast").add($7c22895ca0418c15$var$upcastImg("imageInline", imageUtils));
    }
    /**
	* Integrates the plugin with the clipboard pipeline.
	*
	* Idea is that the feature should recognize the user's intent when an **block** image is
	* pasted or dropped. If such an image is pasted/dropped into a non-empty block
	* (e.g. a paragraph with some text) it gets converted into an inline image on the fly.
	*
	* We assume this is the user's intent if they decided to put their image there.
	*
	* **Note**: If a block image has a caption, it will not be converted to an inline image
	* to avoid the confusion. Captions are added on purpose and they should never be lost
	* in the clipboard pipeline.
	*
	* See the `ImageBlockEditing` for the similar integration that works in the opposite direction.
	*
	* The feature also sets image `width` and `height` attributes when pasting.
	*/ _setupClipboardIntegration() {
        const editor = this.editor;
        const model = editor.model;
        const editingView = editor.editing.view;
        const imageUtils = editor.plugins.get("ImageUtils");
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "inputTransformation", (evt, data)=>{
            const docFragmentChildren = Array.from(data.content.getChildren());
            let modelRange;
            if (!docFragmentChildren.every(imageUtils.isBlockImageView)) return;
            if (data.targetRanges) modelRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
            else modelRange = model.document.selection.getFirstRange();
            const selection = model.createSelection(modelRange);
            const selectionPosition = selection.getFirstPosition();
            if (!(!!selectionPosition && $7c22895ca0418c15$var$isImageTypePlaceable(model.schema, selectionPosition, "imageBlock")) || $7c22895ca0418c15$export$c2ad1be5db89b488(model.schema, selection) === "imageInline") {
                const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(editingView.document);
                const inlineViewImages = docFragmentChildren.map((blockViewImage)=>{
                    if (blockViewImage.childCount === 1) {
                        Array.from(blockViewImage.getAttributes()).forEach((attribute)=>writer.setAttribute(...attribute, imageUtils.findViewImgElement(blockViewImage)));
                        return blockViewImage.getChild(0);
                    } else return blockViewImage;
                });
                data.content = writer.createDocumentFragment(inlineViewImages);
            }
        });
        this.listenTo(clipboardPipeline, "contentInsertion", (evt, data)=>{
            if (data.method !== "paste") return;
            model.change((writer)=>{
                const range = writer.createRangeIn(data.content);
                for (const item of range.getItems())if (item.is("element", "imageInline")) imageUtils.setImageNaturalSizeAttributes(item);
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinline
*/ /**
* The image inline plugin.
*
* This is a "glue" plugin which loads the following plugins:
*
* * {@link module:image/image/imageinlineediting~ImageInlineEditing},
* * {@link module:image/imagetextalternative~ImageTextAlternative}.
*
* Usually, it is used in conjunction with other plugins from this package. See the {@glink api/image package page}
* for more information.
*/ var $7c22895ca0418c15$export$e52eb2fe1356fc5d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$dc0ea412859d6d2,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a),
            $7c22895ca0418c15$export$496687810c56d547,
            $7c22895ca0418c15$export$3946c48aa73e9ec1
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInline";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/image
*/ /**
* The image plugin.
*
* For a detailed overview, check the {@glink features/images/images-overview image feature} documentation.
*
* This is a "glue" plugin which loads the following plugins:
*
* * {@link module:image/imageblock~ImageBlock},
* * {@link module:image/imageinline~ImageInline},
*
* Usually, it is used in conjunction with other plugins from this package. See the {@glink api/image package page}
* for more information.
*/ var $7c22895ca0418c15$export$3e431a229df88919 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$37a52fa31b599ac5,
            $7c22895ca0418c15$export$e52eb2fe1356fc5d
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Image";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The image caption utilities plugin.
*/ var $7c22895ca0418c15$export$1408b2123fdf413a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageCaptionUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* Returns the caption model element from a given image element. Returns `null` if no caption is found.
	*/ getCaptionFromImageModelElement(imageModelElement) {
        for (const node of imageModelElement.getChildren())if (!!node && node.is("element", "caption")) return node;
        return null;
    }
    /**
	* Returns the caption model element for a model selection. Returns `null` if the selection has no caption element ancestor.
	*/ getCaptionFromModelSelection(selection) {
        const imageUtils = this.editor.plugins.get("ImageUtils");
        const captionElement = selection.getFirstPosition().findAncestor("caption");
        if (!captionElement) return null;
        if (imageUtils.isBlockImage(captionElement.parent)) return captionElement;
        return null;
    }
    /**
	* {@link module:engine/view/matcher~Matcher} pattern. Checks if a given element is a `<figcaption>` element that is placed
	* inside the image `<figure>` element.
	* @returns Returns the object accepted by {@link module:engine/view/matcher~Matcher} or `null` if the element
	* cannot be matched.
	*/ matchImageCaptionViewElement(element) {
        const imageUtils = this.editor.plugins.get("ImageUtils");
        if (element.name == "figcaption" && imageUtils.isBlockImageView(element.parent)) return {
            name: true
        };
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The toggle image caption command.
*
* This command is registered by {@link module:image/imagecaption/imagecaptionediting~ImageCaptionEditing} as the
* `'toggleImageCaption'` editor command.
*
* Executing this command:
*
* * either adds or removes the image caption of a selected image (depending on whether the caption is present or not),
* * removes the image caption if the selection is anchored in one.
*
* ```ts
* // Toggle the presence of the caption.
* editor.execute( 'toggleImageCaption' );
* ```
*
* **Note**: Upon executing this command, the selection will be set on the image if previously anchored in the caption element.
*
* **Note**: You can move the selection to the caption right away as it shows up upon executing this command by using
* the `focusCaptionOnShow` option:
*
* ```ts
* editor.execute( 'toggleImageCaption', { focusCaptionOnShow: true } );
* ```
*/ var $7c22895ca0418c15$export$9f2ea57051dd2a57 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        const imageUtils = editor.plugins.get("ImageUtils");
        if (!editor.plugins.has($7c22895ca0418c15$export$23a23e79feddcf18)) {
            this.isEnabled = false;
            this.value = false;
            return;
        }
        const selection = editor.model.document.selection;
        const selectedElement = selection.getSelectedElement();
        if (!selectedElement) {
            const ancestorCaptionElement = imageCaptionUtils.getCaptionFromModelSelection(selection);
            this.isEnabled = !!ancestorCaptionElement;
            this.value = !!ancestorCaptionElement;
            return;
        }
        this.isEnabled = imageUtils.isImage(selectedElement);
        if (this.isEnabled && imageUtils.isInlineImage(selectedElement)) {
            const position = editor.model.createPositionBefore(selectedElement);
            this.isEnabled = $7c22895ca0418c15$var$isImageTypePlaceable(editor.model.schema, position, "imageBlock");
        }
        if (!this.isEnabled) this.value = false;
        else this.value = !!imageCaptionUtils.getCaptionFromImageModelElement(selectedElement);
    }
    /**
	* Executes the command.
	*
	* ```ts
	* editor.execute( 'toggleImageCaption' );
	* ```
	*
	* @param options Options for the executed command.
	* @param options.focusCaptionOnShow When true and the caption shows up, the selection will be moved into it straight away.
	* @fires execute
	*/ execute(options = {}) {
        const { focusCaptionOnShow: focusCaptionOnShow } = options;
        this.editor.model.change((writer)=>{
            if (this.value) this._hideImageCaption(writer);
            else this._showImageCaption(writer, focusCaptionOnShow);
        });
    }
    /**
	* Shows the caption of the `<imageBlock>` or `<imageInline>`. Also:
	*
	* * it converts `<imageInline>` to `<imageBlock>` to show the caption,
	* * it attempts to restore the caption content from the `ImageCaptionEditing` caption registry,
	* * it moves the selection to the caption right away, it the `focusCaptionOnShow` option was set.
	*/ _showImageCaption(writer, focusCaptionOnShow) {
        const selection = this.editor.model.document.selection;
        const imageCaptionEditing = this.editor.plugins.get("ImageCaptionEditing");
        const imageUtils = this.editor.plugins.get("ImageUtils");
        let selectedImage = selection.getSelectedElement();
        const savedCaption = imageCaptionEditing._getSavedCaption(selectedImage);
        if (imageUtils.isInlineImage(selectedImage)) {
            this.editor.execute("imageTypeBlock");
            selectedImage = selection.getSelectedElement();
        }
        const newCaptionElement = savedCaption || writer.createElement("caption");
        writer.append(newCaptionElement, selectedImage);
        if (focusCaptionOnShow) writer.setSelection(newCaptionElement, "in");
    }
    /**
	* Hides the caption of a selected image (or an image caption the selection is anchored to).
	*
	* The content of the caption is stored in the `ImageCaptionEditing` caption registry to make this
	* a reversible action.
	*/ _hideImageCaption(writer) {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const imageCaptionEditing = editor.plugins.get("ImageCaptionEditing");
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        let selectedImage = selection.getSelectedElement();
        let captionElement;
        if (selectedImage) captionElement = imageCaptionUtils.getCaptionFromImageModelElement(selectedImage);
        else {
            captionElement = imageCaptionUtils.getCaptionFromModelSelection(selection);
            selectedImage = captionElement.parent;
        }
        imageCaptionEditing._saveCaption(selectedImage, captionElement);
        writer.setSelection(selectedImage, "on");
        writer.remove(captionElement);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagecaption/imagecaptionediting
*/ /**
* The image caption engine plugin. It is responsible for:
*
* * registering converters for the caption element,
* * registering converters for the caption model attribute,
* * registering the {@link module:image/imagecaption/toggleimagecaptioncommand~ToggleImageCaptionCommand `toggleImageCaption`} command.
*/ var $7c22895ca0418c15$export$58b4091e93563961 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa,
            $7c22895ca0418c15$export$1408b2123fdf413a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageCaptionEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* A map that keeps saved JSONified image captions and image model elements they are
	* associated with.
	*
	* To learn more about this system, see {@link #_saveCaption}.
	*/ _savedCaptionsMap;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._savedCaptionsMap = /* @__PURE__ */ new WeakMap();
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        if (!schema.isRegistered("caption")) schema.register("caption", {
            allowIn: "imageBlock",
            allowContentOf: "$block",
            isLimit: true
        });
        else schema.extend("caption", {
            allowIn: "imageBlock"
        });
        editor.commands.add("toggleImageCaption", new $7c22895ca0418c15$export$9f2ea57051dd2a57(this.editor));
        this._setupConversion();
        this._setupImageTypeCommandsIntegration();
        this._registerCaptionReconversion();
    }
    /**
	* Configures conversion pipelines to support upcasting and downcasting
	* image captions.
	*/ _setupConversion() {
        const editor = this.editor;
        const view = editor.editing.view;
        const imageUtils = editor.plugins.get("ImageUtils");
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        const t = editor.t;
        editor.conversion.for("upcast").elementToElement({
            view: (element)=>imageCaptionUtils.matchImageCaptionViewElement(element),
            model: "caption"
        });
        editor.conversion.for("dataDowncast").elementToElement({
            model: "caption",
            view: (modelElement, { writer: writer })=>{
                if (!imageUtils.isBlockImage(modelElement.parent)) return null;
                return writer.createContainerElement("figcaption");
            }
        });
        editor.conversion.for("editingDowncast").elementToElement({
            model: "caption",
            view: (modelElement, { writer: writer })=>{
                if (!imageUtils.isBlockImage(modelElement.parent)) return null;
                const figcaptionElement = writer.createEditableElement("figcaption");
                writer.setCustomProperty("imageCaption", true, figcaptionElement);
                figcaptionElement.placeholder = t("Enter image caption");
                (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
                    view: view,
                    element: figcaptionElement,
                    keepOnFocus: true
                });
                const imageAlt = modelElement.parent.getAttribute("alt");
                const label = imageAlt ? t("Caption for image: %0", [
                    imageAlt
                ]) : t("Caption for the image");
                return (0, $5547ab21e02f1e9e$export$f2153e4522f49b8e)(figcaptionElement, writer, {
                    label: label
                });
            }
        });
    }
    /**
	* Integrates with {@link module:image/image/imagetypecommand~ImageTypeCommand image type commands}
	* to make sure the caption is preserved when the type of an image changes so it can be restored
	* in the future if the user decides they want their caption back.
	*/ _setupImageTypeCommandsIntegration() {
        const editor = this.editor;
        const imageUtils = editor.plugins.get("ImageUtils");
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        const imageTypeInlineCommand = editor.commands.get("imageTypeInline");
        const imageTypeBlockCommand = editor.commands.get("imageTypeBlock");
        const handleImageTypeChange = (evt)=>{
            if (!evt.return) return;
            const { oldElement: oldElement, newElement: newElement } = evt.return;
            /* istanbul ignore if: paranoid check -- @preserve */ if (!oldElement) return;
            if (imageUtils.isBlockImage(oldElement)) {
                const oldCaptionElement = imageCaptionUtils.getCaptionFromImageModelElement(oldElement);
                if (oldCaptionElement) {
                    this._saveCaption(newElement, oldCaptionElement);
                    return;
                }
            }
            const savedOldElementCaption = this._getSavedCaption(oldElement);
            if (savedOldElementCaption) this._saveCaption(newElement, savedOldElementCaption);
        };
        if (imageTypeInlineCommand) this.listenTo(imageTypeInlineCommand, "execute", handleImageTypeChange, {
            priority: "low"
        });
        if (imageTypeBlockCommand) this.listenTo(imageTypeBlockCommand, "execute", handleImageTypeChange, {
            priority: "low"
        });
    }
    /**
	* Returns the saved {@link module:engine/model/element~ModelElement#toJSON JSONified} caption
	* of an image model element.
	*
	* See {@link #_saveCaption}.
	*
	* @internal
	* @param imageModelElement The model element the caption should be returned for.
	* @returns The model caption element or `null` if there is none.
	*/ _getSavedCaption(imageModelElement) {
        const jsonObject = this._savedCaptionsMap.get(imageModelElement);
        return jsonObject ? (0, $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31).fromJSON(jsonObject) : null;
    }
    /**
	* Saves a {@link module:engine/model/element~ModelElement#toJSON JSONified} caption for
	* an image element to allow restoring it in the future.
	*
	* A caption is saved every time it gets hidden and/or the type of an image changes. The
	* user should be able to restore it on demand.
	*
	* **Note**: The caption cannot be stored in the image model element attribute because,
	* for instance, when the model state propagates to collaborators, the attribute would get
	* lost (mainly because it does not convert to anything when the caption is hidden) and
	* the states of collaborators' models would de-synchronize causing numerous issues.
	*
	* See {@link #_getSavedCaption}.
	*
	* @internal
	* @param imageModelElement The model element the caption is saved for.
	* @param caption The caption model element to be saved.
	*/ _saveCaption(imageModelElement, caption) {
        this._savedCaptionsMap.set(imageModelElement, caption.toJSON());
    }
    /**
	* Reconverts image caption when image alt attribute changes.
	* The change of alt attribute is reflected in caption's aria-label attribute.
	*/ _registerCaptionReconversion() {
        const editor = this.editor;
        const model = editor.model;
        const imageUtils = editor.plugins.get("ImageUtils");
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        model.document.on("change:data", ()=>{
            const changes = model.document.differ.getChanges();
            for (const change of changes){
                if (change.attributeKey !== "alt") continue;
                const image = change.range.start.nodeAfter;
                if (imageUtils.isBlockImage(image)) {
                    const caption = imageCaptionUtils.getCaptionFromImageModelElement(image);
                    if (!caption) return;
                    editor.editing.reconvertItem(caption);
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagecaption/imagecaptionui
*/ /**
* The image caption UI plugin. It introduces the `'toggleImageCaption'` UI button.
*/ var $7c22895ca0418c15$export$72cec3629280b3d6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$1408b2123fdf413a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageCaptionUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const imageCaptionUtils = editor.plugins.get("ImageCaptionUtils");
        const t = editor.t;
        editor.ui.componentFactory.add("toggleImageCaption", (locale)=>{
            const command = editor.commands.get("toggleImageCaption");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                icon: (0, $e8dc502aba5ac3f5$export$ccdbc3d0432988b9),
                tooltip: true,
                isToggleable: true
            });
            view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
            view.bind("label").to(command, "value", (value)=>value ? t("Toggle caption off") : t("Toggle caption on"));
            this.listenTo(view, "execute", ()=>{
                editor.execute("toggleImageCaption", {
                    focusCaptionOnShow: true
                });
                const modelCaptionElement = imageCaptionUtils.getCaptionFromModelSelection(editor.model.document.selection);
                if (modelCaptionElement) {
                    const figcaptionElement = editor.editing.mapper.toViewElement(modelCaptionElement);
                    editingView.scrollToTheSelection();
                    editingView.change((writer)=>{
                        writer.addClass("image__caption_highlighted", figcaptionElement);
                    });
                }
                editor.editing.view.focus();
            });
            return view;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagecaption
*/ /**
* The image caption plugin.
*
* For a detailed overview, check the {@glink features/images/images-captions image caption} documentation.
*/ var $7c22895ca0418c15$export$b767941ef6c6912b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$58b4091e93563961,
            $7c22895ca0418c15$export$72cec3629280b3d6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageCaption";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Creates a regular expression used to test for image files.
*
* ```ts
* const imageType = createImageTypeRegExp( [ 'png', 'jpeg', 'svg+xml', 'vnd.microsoft.icon' ] );
*
* console.log( 'is supported image', imageType.test( file.type ) );
* ```
*/ function $7c22895ca0418c15$export$bece23978737eec2(types) {
    const regExpSafeNames = types.map((type)=>type.replace("+", "\\+"));
    return new RegExp(`^image\\/(${regExpSafeNames.join("|")})$`);
}
/**
* Creates a promise that fetches the image local source (Base64 or blob) and resolves with a `File` object.
*
* @internal
* @param image Image whose source to fetch.
* @returns A promise which resolves when an image source is fetched and converted to a `File` instance.
* It resolves with a `File` object. If there were any errors during file processing, the promise will be rejected.
*/ function $7c22895ca0418c15$export$3b4dfa0d76709b55(image) {
    return new Promise((resolve, reject)=>{
        const imageSrc = image.getAttribute("src");
        fetch(imageSrc).then((resource)=>resource.blob()).then((blob)=>{
            const mimeType = $7c22895ca0418c15$var$getImageMimeType(blob, imageSrc);
            const filename = `image.${mimeType.replace("image/", "")}`;
            resolve(new File([
                blob
            ], filename, {
                type: mimeType
            }));
        }).catch((err)=>{
            return err && err.name === "TypeError" ? $7c22895ca0418c15$var$convertLocalImageOnCanvas(imageSrc).then(resolve).catch(reject) : reject(err);
        });
    });
}
/**
* Checks whether a given node is an image element with a local source (Base64 or blob).
*
* @param node The node to check.
* @internal
*/ function $7c22895ca0418c15$export$7d9a33c10f7f2db4(imageUtils, node) {
    if (!imageUtils.isInlineImageView(node) || !node.getAttribute("src")) return false;
    return !!node.getAttribute("src").match(/^data:image\/\w+;base64,/g) || !!node.getAttribute("src").match(/^blob:/g);
}
/**
* Extracts an image type based on its blob representation or its source.
* @param blob Image blob representation.
* @param src Image `src` attribute value.
*/ function $7c22895ca0418c15$var$getImageMimeType(blob, src) {
    if (blob.type) return blob.type;
    else if (src.match(/data:(image\/\w+);base64/)) return src.match(/data:(image\/\w+);base64/)[1].toLowerCase();
    else return "image/jpeg";
}
/**
* Creates a promise that converts the image local source (Base64 or blob) to a blob using canvas and resolves
* with a `File` object.
* @param imageSrc Image `src` attribute value.
* @returns A promise which resolves when an image source is converted to a `File` instance.
* It resolves with a `File` object. If there were any errors during file processing, the promise will be rejected.
*/ function $7c22895ca0418c15$var$convertLocalImageOnCanvas(imageSrc) {
    return $7c22895ca0418c15$var$getBlobFromCanvas(imageSrc).then((blob)=>{
        const mimeType = $7c22895ca0418c15$var$getImageMimeType(blob, imageSrc);
        const filename = `image.${mimeType.replace("image/", "")}`;
        return new File([
            blob
        ], filename, {
            type: mimeType
        });
    });
}
/**
* Creates a promise that resolves with a `Blob` object converted from the image source (Base64 or blob).
* @param imageSrc Image `src` attribute value.
*/ function $7c22895ca0418c15$var$getBlobFromCanvas(imageSrc) {
    return new Promise((resolve, reject)=>{
        const image = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.createElement("img");
        image.addEventListener("load", ()=>{
            const canvas = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            canvas.getContext("2d").drawImage(image, 0, 0);
            canvas.toBlob((blob)=>blob ? resolve(blob) : reject());
        });
        image.addEventListener("error", ()=>reject());
        image.src = imageSrc;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageupload/imageuploadui
*/ /**
* The image upload button plugin.
*
* For a detailed overview, check the {@glink features/images/image-upload/image-upload Image upload feature} documentation.
*
* Adds the `'uploadImage'` button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}
* and also the `imageUpload` button as an alias for backward compatibility.
*
* Adds the `'menuBar:uploadImage'` menu button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}.
*
* It also integrates with the `insertImage` toolbar component and `menuBar:insertImage` menu component, which are the default components
* through which image upload is available.
*/ var $7c22895ca0418c15$export$21e22db9cb7636df = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageUploadUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("uploadImage", ()=>this._createToolbarButton());
        editor.ui.componentFactory.add("imageUpload", ()=>this._createToolbarButton());
        editor.ui.componentFactory.add("menuBar:uploadImage", ()=>this._createMenuBarButton("standalone"));
        if (editor.plugins.has("ImageInsertUI")) editor.plugins.get("ImageInsertUI").registerIntegration({
            name: "upload",
            observable: ()=>editor.commands.get("uploadImage"),
            buttonViewCreator: ()=>this._createToolbarButton(),
            formViewCreator: ()=>this._createDropdownButton(),
            menuBarButtonViewCreator: (isOnly)=>this._createMenuBarButton(isOnly ? "insertOnly" : "insertNested")
        });
    }
    /**
	* Creates the base for various kinds of the button component provided by this feature.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("uploadImage");
        const imageTypes = editor.config.get("image.upload.types");
        const imageTypesRegExp = $7c22895ca0418c15$export$bece23978737eec2(imageTypes);
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            acceptedType: imageTypes.map((type)=>`image/${type}`).join(","),
            allowMultipleFiles: true,
            label: t("Upload from computer"),
            icon: (0, $e8dc502aba5ac3f5$export$1bc502c48e40c39)
        });
        view.bind("isEnabled").to(command);
        view.on("done", (evt, files)=>{
            const imagesToUpload = Array.from(files).filter((file)=>imageTypesRegExp.test(file.type));
            if (imagesToUpload.length) {
                editor.execute("uploadImage", {
                    file: imagesToUpload
                });
                editor.editing.view.focus();
            }
        });
        return view;
    }
    /**
	* Creates a simple toolbar button, with an icon and a tooltip.
	*/ _createToolbarButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const uploadImageCommand = this.editor.commands.get("uploadImage");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$82dd186dd0e8fed2));
        button.tooltip = true;
        button.bind("label").to(imageInsertUI, "isImageSelected", uploadImageCommand, "isAccessAllowed", (isImageSelected, isAccessAllowed)=>{
            if (!isAccessAllowed) return t("You have no image upload permissions.");
            return isImageSelected ? t("Replace image from computer") : t("Upload image from computer");
        });
        return button;
    }
    /**
	* Creates a button for the dropdown view, with an icon, text and no tooltip.
	*/ _createDropdownButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$82dd186dd0e8fed2));
        button.withText = true;
        button.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace from computer") : t("Upload from computer"));
        button.on("execute", ()=>{
            imageInsertUI.dropdownView.isOpen = false;
        });
        return button;
    }
    /**
	* Creates a button for the menu bar.
	*/ _createMenuBarButton(type) {
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$5f8c3e2cf36794ec));
        button.withText = true;
        switch(type){
            case "standalone":
                button.label = t("Image from computer");
                break;
            case "insertOnly":
                button.label = t("Image");
                break;
            case "insertNested":
                button.label = t("From computer");
        }
        return button;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageupload/imageuploadprogress
*/ /**
* The image upload progress plugin.
* It shows a placeholder when the image is read from the disk and a progress bar while the image is uploading.
*/ var $7c22895ca0418c15$export$7ec8ba77907346bb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageUploadProgress";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The image placeholder that is displayed before real image data can be accessed.
	*
	* For the record, this image is a 1x1 px GIF with an aspect ratio set by CSS.
	*/ placeholder;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (editor.plugins.has("ImageBlockEditing")) editor.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange);
        if (editor.plugins.has("ImageInlineEditing")) editor.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
    }
    /**
	* This method is called each time the image `uploadStatus` attribute is changed.
	*
	* @param evt An object containing information about the fired event.
	* @param data Additional information about the change.
	*/ uploadStatusChange = (evt, data, conversionApi)=>{
        const editor = this.editor;
        const modelImage = data.item;
        const uploadId = modelImage.getAttribute("uploadId");
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const imageUtils = editor.plugins.get("ImageUtils");
        const fileRepository = editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51));
        const status = uploadId ? data.attributeNewValue : null;
        const placeholder = this.placeholder;
        const viewFigure = editor.editing.mapper.toViewElement(modelImage);
        const viewWriter = conversionApi.writer;
        if (status == "reading") {
            $7c22895ca0418c15$var$_startAppearEffect(viewFigure, viewWriter);
            $7c22895ca0418c15$var$_showPlaceholder(imageUtils, placeholder, viewFigure, viewWriter);
            return;
        }
        if (status == "uploading") {
            const loader = fileRepository.loaders.get(uploadId);
            $7c22895ca0418c15$var$_startAppearEffect(viewFigure, viewWriter);
            if (!loader) $7c22895ca0418c15$var$_showPlaceholder(imageUtils, placeholder, viewFigure, viewWriter);
            else {
                $7c22895ca0418c15$var$_hidePlaceholder(viewFigure, viewWriter);
                $7c22895ca0418c15$var$_showProgressBar(viewFigure, viewWriter, loader, editor.editing.view);
                $7c22895ca0418c15$var$_displayLocalImage(imageUtils, viewFigure, viewWriter, loader);
            }
            return;
        }
        if (status == "complete" && fileRepository.loaders.get(uploadId)) $7c22895ca0418c15$var$_showCompleteIcon(viewFigure, viewWriter, editor.editing.view);
        $7c22895ca0418c15$var$_hideProgressBar(viewFigure, viewWriter);
        $7c22895ca0418c15$var$_hidePlaceholder(viewFigure, viewWriter);
        $7c22895ca0418c15$var$_stopAppearEffect(viewFigure, viewWriter);
    };
};
/**
* Adds ck-appear class to the image figure if one is not already applied.
*/ function $7c22895ca0418c15$var$_startAppearEffect(viewFigure, writer) {
    if (!viewFigure.hasClass("ck-appear")) writer.addClass("ck-appear", viewFigure);
}
/**
* Removes ck-appear class to the image figure if one is not already removed.
*/ function $7c22895ca0418c15$var$_stopAppearEffect(viewFigure, writer) {
    writer.removeClass("ck-appear", viewFigure);
}
/**
* Shows placeholder together with infinite progress bar on given image figure.
*/ function $7c22895ca0418c15$var$_showPlaceholder(imageUtils, placeholder, viewFigure, writer) {
    if (!viewFigure.hasClass("ck-image-upload-placeholder")) writer.addClass("ck-image-upload-placeholder", viewFigure);
    const viewImg = imageUtils.findViewImgElement(viewFigure);
    if (viewImg.getAttribute("src") !== placeholder) writer.setAttribute("src", placeholder, viewImg);
    if (!$7c22895ca0418c15$var$_getUIElement(viewFigure, "placeholder")) writer.insert(writer.createPositionAfter(viewImg), $7c22895ca0418c15$var$_createPlaceholder(writer));
}
/**
* Removes placeholder together with infinite progress bar on given image figure.
*/ function $7c22895ca0418c15$var$_hidePlaceholder(viewFigure, writer) {
    if (viewFigure.hasClass("ck-image-upload-placeholder")) writer.removeClass("ck-image-upload-placeholder", viewFigure);
    $7c22895ca0418c15$var$_removeUIElement(viewFigure, writer, "placeholder");
}
/**
* Shows progress bar displaying upload progress.
* Attaches it to the file loader to update when upload percentace is changed.
*/ function $7c22895ca0418c15$var$_showProgressBar(viewFigure, writer, loader, view) {
    const progressBar = $7c22895ca0418c15$var$_createProgressBar(writer);
    writer.insert(writer.createPositionAt(viewFigure, "end"), progressBar);
    loader.on("change:uploadedPercent", (evt, name, value)=>{
        view.change((writer)=>{
            writer.setStyle("width", value + "%", progressBar);
        });
    });
}
/**
* Hides upload progress bar.
*/ function $7c22895ca0418c15$var$_hideProgressBar(viewFigure, writer) {
    $7c22895ca0418c15$var$_removeUIElement(viewFigure, writer, "progressBar");
}
/**
* Shows complete icon and hides after a certain amount of time.
*/ function $7c22895ca0418c15$var$_showCompleteIcon(viewFigure, writer, view) {
    const completeIcon = writer.createUIElement("div", {
        class: "ck-image-upload-complete-icon"
    });
    writer.insert(writer.createPositionAt(viewFigure, "end"), completeIcon);
    setTimeout(()=>{
        view.change((writer)=>writer.remove(writer.createRangeOn(completeIcon)));
    }, 3e3);
}
/**
* Create progress bar element using {@link module:engine/view/uielement~ViewUIElement}.
*/ function $7c22895ca0418c15$var$_createProgressBar(writer) {
    const progressBar = writer.createUIElement("div", {
        class: "ck-progress-bar"
    });
    writer.setCustomProperty("progressBar", true, progressBar);
    return progressBar;
}
/**
* Create placeholder element using {@link module:engine/view/uielement~ViewUIElement}.
*/ function $7c22895ca0418c15$var$_createPlaceholder(writer) {
    const placeholder = writer.createUIElement("div", {
        class: "ck-upload-placeholder-loader"
    });
    writer.setCustomProperty("placeholder", true, placeholder);
    return placeholder;
}
/**
* Returns {@link module:engine/view/uielement~ViewUIElement} of given unique property from image figure element.
* Returns `undefined` if element is not found.
*/ function $7c22895ca0418c15$var$_getUIElement(imageFigure, uniqueProperty) {
    for (const child of imageFigure.getChildren())if (child.getCustomProperty(uniqueProperty)) return child;
}
/**
* Removes {@link module:engine/view/uielement~ViewUIElement} of given unique property from image figure element.
*/ function $7c22895ca0418c15$var$_removeUIElement(viewFigure, writer, uniqueProperty) {
    const element = $7c22895ca0418c15$var$_getUIElement(viewFigure, uniqueProperty);
    if (element) writer.remove(writer.createRangeOn(element));
}
/**
* Displays local data from file loader.
*/ function $7c22895ca0418c15$var$_displayLocalImage(imageUtils, viewFigure, writer, loader) {
    if (loader.data) {
        const viewImg = imageUtils.findViewImgElement(viewFigure);
        writer.setAttribute("src", loader.data, viewImg);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageupload/uploadimagecommand
*/ /**
* The upload image command.
*
* The command is registered by the {@link module:image/imageupload/imageuploadediting~ImageUploadEditing} plugin as `uploadImage`
* and it is also available via aliased `imageUpload` name.
*
* In order to upload an image at the current selection position
* (according to the {@link module:widget/utils~findOptimalInsertionRange} algorithm),
* execute the command and pass the native image file instance:
*
* ```ts
* this.listenTo( editor.editing.view.document, 'clipboardInput', ( evt, data ) => {
* 	// Assuming that only images were pasted:
* 	const images = Array.from( data.dataTransfer.files );
*
* 	// Upload the first image:
* 	editor.execute( 'uploadImage', { file: images[ 0 ] } );
* } );
* ```
*
* It is also possible to insert multiple images at once:
*
* ```ts
* editor.execute( 'uploadImage', {
* 	file: [
* 		file1,
* 		file2
* 	]
* } );
* ```
*/ var $7c22895ca0418c15$export$c44ee9d38091de06 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Creates an instance of the `imageUlpoad` command. When executed, the command upload one of
	* the currently selected image from computer.
	*
	* @param editor The editor instance.
	*/ constructor(editor){
        super(editor);
        this.set("isAccessAllowed", true);
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const imageUtils = editor.plugins.get("ImageUtils");
        const selectedElement = editor.model.document.selection.getSelectedElement();
        this.isEnabled = imageUtils.isImageAllowed() || imageUtils.isImage(selectedElement);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Options for the executed command.
	* @param options.file The image file or an array of image files to upload.
	*/ execute(options) {
        const files = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.file);
        const selection = this.editor.model.document.selection;
        const imageUtils = this.editor.plugins.get("ImageUtils");
        const selectionAttributes = Object.fromEntries(selection.getAttributes());
        files.forEach((file, index)=>{
            const selectedElement = selection.getSelectedElement();
            if (index && selectedElement && imageUtils.isImage(selectedElement)) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                this._uploadImage(file, selectionAttributes, position);
            } else this._uploadImage(file, selectionAttributes);
        });
    }
    /**
	* Handles uploading single file.
	*/ _uploadImage(file, attributes, position) {
        const editor = this.editor;
        const loader = editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51)).createLoader(file);
        const imageUtils = editor.plugins.get("ImageUtils");
        if (!loader) return;
        imageUtils.insertImage({
            ...attributes,
            uploadId: loader.id
        }, position);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageupload/imageuploadediting
*/ /**
* The editing part of the image upload feature. It registers the `'uploadImage'` command
* and the `imageUpload` command as an aliased name.
*
* When an image is uploaded, it fires the {@link ~ImageUploadEditing#event:uploadComplete `uploadComplete`} event
* that allows adding custom attributes to the {@link module:engine/model/element~ModelElement image element}.
*/ var $7c22895ca0418c15$export$7cd72690bdb810ee = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51),
            (0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd),
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09),
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    static get pluginName() {
        return "ImageUploadEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* An internal mapping of {@link module:upload/filerepository~FileLoader#id file loader UIDs} and
	* model elements during the upload.
	*
	* Model element of the uploaded image can change, for instance, when {@link module:image/image/imagetypecommand~ImageTypeCommand}
	* is executed as a result of adding caption or changing image style. As a result, the upload logic must keep track of the model
	* element (reference) and resolve the upload for the correct model element (instead of the one that landed in the `$graveyard`
	* after image type changed).
	*/ _uploadImageElements;
    /**
	* An internal mapping of {@link module:upload/filerepository~FileLoader#id file loader UIDs} and
	* upload responses for handling images dragged during their upload process. When such images are later
	* dropped, their original upload IDs no longer exist in the registry (as the original upload completed).
	* This map preserves the upload responses to properly handle such cases.
	*/ _uploadedImages = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("image", {
            upload: {
                types: [
                    "jpeg",
                    "png",
                    "gif",
                    "bmp",
                    "webp",
                    "tiff"
                ]
            }
        });
        this._uploadImageElements = /* @__PURE__ */ new Map();
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const doc = editor.model.document;
        const conversion = editor.conversion;
        const fileRepository = editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51));
        const imageUtils = editor.plugins.get("ImageUtils");
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        const imageTypes = $7c22895ca0418c15$export$bece23978737eec2(editor.config.get("image.upload.types"));
        const uploadImageCommand = new $7c22895ca0418c15$export$c44ee9d38091de06(editor);
        editor.commands.add("uploadImage", uploadImageCommand);
        editor.commands.add("imageUpload", uploadImageCommand);
        conversion.for("upcast").attributeToAttribute({
            view: {
                name: "img",
                key: "uploadId"
            },
            model: "uploadId"
        }).add((dispatcher)=>dispatcher.on("element:img", (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.test(data.viewItem, {
                    attributes: [
                        "data-ck-upload-id"
                    ]
                })) return;
                const uploadId = data.viewItem.getAttribute("data-ck-upload-id");
                if (!uploadId) return;
                if (!data.modelRange) return;
                const [modelElement] = Array.from(data.modelRange.getItems({
                    shallow: true
                }));
                const loader = fileRepository.loaders.get(uploadId);
                /* v8 ignore else -- @preserve */ if (modelElement) {
                    conversionApi.writer.setAttribute("uploadId", uploadId, modelElement);
                    conversionApi.consumable.consume(data.viewItem, {
                        attributes: [
                            "data-ck-upload-id"
                        ]
                    });
                    if (loader && loader.data) conversionApi.writer.setAttribute("uploadStatus", loader.status, modelElement);
                }
            }, {
                priority: "low"
            }));
        this.listenTo(editor.editing.view.document, "clipboardInput", (evt, data)=>{
            if ($7c22895ca0418c15$export$52f0605d7e56afdf(data.dataTransfer)) return;
            const images = Array.from(data.dataTransfer.files).filter((file)=>{
                if (!file) return false;
                return imageTypes.test(file.type);
            });
            if (!images.length) return;
            evt.stop();
            editor.model.change((writer)=>{
                if (data.targetRanges) writer.setSelection(data.targetRanges.map((viewRange)=>editor.editing.mapper.toModelRange(viewRange)));
                editor.execute("uploadImage", {
                    file: images
                });
            });
            if (!editor.commands.get("uploadImage").isAccessAllowed) {
                const notification = editor.plugins.get("Notification");
                const t = editor.locale.t;
                notification.showWarning(t("You have no image upload permissions."), {
                    namespace: "image"
                });
            }
        });
        this.listenTo(clipboardPipeline, "inputTransformation", (evt, data)=>{
            const fetchableImages = Array.from(editor.editing.view.createRangeIn(data.content)).map((value)=>value.item).filter((viewElement)=>$7c22895ca0418c15$export$7d9a33c10f7f2db4(imageUtils, viewElement) && !viewElement.getAttribute("uploadProcessed")).map((viewElement)=>{
                return {
                    promise: $7c22895ca0418c15$export$3b4dfa0d76709b55(viewElement),
                    imageElement: viewElement
                };
            });
            if (!fetchableImages.length) return;
            const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(editor.editing.view.document);
            for (const fetchableImage of fetchableImages){
                writer.setAttribute("uploadProcessed", true, fetchableImage.imageElement);
                const loader = fileRepository.createLoader(fetchableImage.promise);
                if (loader) {
                    writer.setAttribute("src", "", fetchableImage.imageElement);
                    writer.setAttribute("uploadId", loader.id, fetchableImage.imageElement);
                }
            }
        });
        editor.editing.view.document.on("dragover", (evt, data)=>{
            data.preventDefault();
        });
        doc.on("change", ()=>{
            const changes = doc.differ.getChanges({
                includeChangesInGraveyard: true
            }).reverse();
            const insertedImagesIds = /* @__PURE__ */ new Set();
            for (const entry of changes)if (entry.type == "insert" && entry.name != "$text") {
                const item = entry.position.nodeAfter;
                const isInsertedInGraveyard = entry.position.root.rootName == "$graveyard";
                for (const imageElement of $7c22895ca0418c15$var$getImagesFromChangeItem(editor, item)){
                    const uploadId = imageElement.getAttribute("uploadId");
                    const uploadStatus = imageElement.getAttribute("uploadStatus");
                    if (!uploadId || uploadStatus == "complete") continue;
                    const loader = fileRepository.loaders.get(uploadId);
                    if (!loader) {
                        if (!isInsertedInGraveyard && this._uploadedImages.has(uploadId)) editor.model.enqueueChange({
                            isUndoable: false
                        }, (writer)=>{
                            writer.setAttribute("uploadStatus", "complete", imageElement);
                            this.fire("uploadComplete", {
                                data: this._uploadedImages.get(uploadId),
                                imageElement: imageElement
                            });
                        });
                        continue;
                    }
                    if (isInsertedInGraveyard) {
                        if (!insertedImagesIds.has(uploadId)) /* v8 ignore else -- @preserve */ {
                            if (Array.from(this._uploadImageElements.get(uploadId)).every((element)=>element.root.rootName == "$graveyard")) loader.abort();
                        }
                    } else {
                        insertedImagesIds.add(uploadId);
                        if (!this._uploadImageElements.has(uploadId)) this._uploadImageElements.set(uploadId, /* @__PURE__ */ new Set([
                            imageElement
                        ]));
                        else this._uploadImageElements.get(uploadId).add(imageElement);
                        if (loader.status == "idle") this._readAndUpload(loader);
                    }
                }
            }
        });
        this.on("uploadComplete", (evt, { imageElement: imageElement, data: data })=>{
            const urls = data.urls ? data.urls : data;
            this.editor.model.change((writer)=>{
                writer.setAttribute("src", urls.default, imageElement);
                this._parseAndSetSrcsetAttributeOnImage(urls, imageElement, writer);
                imageUtils.setImageNaturalSizeAttributes(imageElement);
            });
        }, {
            priority: "low"
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const schema = this.editor.model.schema;
        if (this.editor.plugins.has("ImageBlockEditing")) {
            schema.extend("imageBlock", {
                allowAttributes: [
                    "uploadId",
                    "uploadStatus"
                ]
            });
            this._registerConverters("imageBlock");
        }
        if (this.editor.plugins.has("ImageInlineEditing")) {
            schema.extend("imageInline", {
                allowAttributes: [
                    "uploadId",
                    "uploadStatus"
                ]
            });
            this._registerConverters("imageInline");
        }
    }
    /**
	* Reads and uploads an image.
	*
	* The image is read from the disk and as a Base64-encoded string it is set temporarily to
	* `image[src]`. When the image is successfully uploaded, the temporary data is replaced with the target
	* image's URL (the URL to the uploaded image on the server).
	*/ _readAndUpload(loader) {
        const editor = this.editor;
        const model = editor.model;
        const t = editor.locale.t;
        const fileRepository = editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51));
        const notification = editor.plugins.get((0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd));
        const imageUtils = editor.plugins.get("ImageUtils");
        const imageUploadElements = this._uploadImageElements;
        model.enqueueChange({
            isUndoable: false
        }, (writer)=>{
            const elements = imageUploadElements.get(loader.id);
            for (const element of elements)writer.setAttribute("uploadStatus", "reading", element);
        });
        return loader.read().then(()=>{
            const promise = loader.upload();
            /* v8 ignore else -- @preserve */ if (editor.ui) editor.ui.ariaLiveAnnouncer.announce(t("Uploading image"));
            for (const imageElement of imageUploadElements.get(loader.id)){
                /* istanbul ignore next -- @preserve */ if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari) {
                    const viewFigure = editor.editing.mapper.toViewElement(imageElement);
                    const viewImg = imageUtils.findViewImgElement(viewFigure);
                    editor.editing.view.once("render", ()=>{
                        if (!viewImg.parent) return;
                        const domFigure = editor.editing.view.domConverter.mapViewToDom(viewImg.parent);
                        if (!domFigure) return;
                        const originalDisplay = domFigure.style.display;
                        domFigure.style.display = "none";
                        domFigure._ckHack = domFigure.offsetHeight;
                        domFigure.style.display = originalDisplay;
                    });
                }
                model.enqueueChange({
                    isUndoable: false
                }, (writer)=>{
                    writer.setAttribute("uploadStatus", "uploading", imageElement);
                });
            }
            return promise;
        }).then((data)=>{
            model.enqueueChange({
                isUndoable: false
            }, (writer)=>{
                for (const imageElement of imageUploadElements.get(loader.id)){
                    writer.setAttribute("uploadStatus", "complete", imageElement);
                    this.fire("uploadComplete", {
                        data: data,
                        imageElement: imageElement
                    });
                }
                /* v8 ignore else -- @preserve */ if (editor.ui) editor.ui.ariaLiveAnnouncer.announce(t("Image upload complete"));
                this._uploadedImages.set(loader.id, data);
            });
            clean();
        }).catch((error)=>{
            /* v8 ignore else -- @preserve */ if (editor.ui) editor.ui.ariaLiveAnnouncer.announce(t("Error during image upload"));
            if (loader.status !== "error" && loader.status !== "aborted") throw error;
            if (loader.status == "error" && error) notification.showWarning(error, {
                title: t("Upload failed"),
                namespace: "upload"
            });
            model.enqueueChange({
                isUndoable: false
            }, (writer)=>{
                for (const imageElement of imageUploadElements.get(loader.id))if (imageElement.root.rootName !== "$graveyard") writer.remove(imageElement);
            });
            clean();
        });
        function clean() {
            model.enqueueChange({
                isUndoable: false
            }, (writer)=>{
                for (const imageElement of imageUploadElements.get(loader.id)){
                    writer.removeAttribute("uploadId", imageElement);
                    writer.removeAttribute("uploadStatus", imageElement);
                }
                imageUploadElements.delete(loader.id);
            });
            fileRepository.destroyLoader(loader);
        }
    }
    /**
	* Creates the `srcset` attribute based on a given file upload response and sets it as an attribute to a specific image element.
	*
	* @param data Data object from which `srcset` will be created.
	* @param image The image element on which the `srcset` attribute will be set.
	*/ _parseAndSetSrcsetAttributeOnImage(data, image, writer) {
        let maxWidth = 0;
        const srcsetAttribute = Object.keys(data).filter((key)=>{
            const width = parseInt(key, 10);
            if (!isNaN(width)) {
                maxWidth = Math.max(maxWidth, width);
                return true;
            }
        }).map((key)=>`${data[key]} ${key}w`).join(", ");
        if (srcsetAttribute != "") {
            const attributes = {
                srcset: srcsetAttribute
            };
            if (!image.hasAttribute("width") && !image.hasAttribute("height")) attributes.width = maxWidth;
            writer.setAttributes(attributes, image);
        }
    }
    /**
	* Registers image upload converters.
	*
	* @param imageType The type of the image.
	*/ _registerConverters(imageType) {
        const { conversion: conversion, plugins: plugins } = this.editor;
        const fileRepository = plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51));
        const imageUtils = plugins.get($7c22895ca0418c15$export$698882cf06df44aa);
        conversion.for("dataDowncast").add((dispatcher)=>{
            dispatcher.on(`attribute:uploadId:${imageType}`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.test(data.item, evt.name)) return;
                const loader = fileRepository.loaders.get(data.attributeNewValue);
                if (!loader || !loader.data) return null;
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                const img = imageUtils.findViewImgElement(viewElement);
                /* v8 ignore else -- @preserve */ if (img) {
                    conversionApi.consumable.consume(data.item, evt.name);
                    conversionApi.writer.setAttribute("data-ck-upload-id", loader.id, img);
                }
            });
        });
    }
};
/**
* TODO move this to the clipboard package.
*
* Returns `true` if non-empty `text/html` is included in the data transfer.
*/ function $7c22895ca0418c15$export$52f0605d7e56afdf(dataTransfer) {
    return Array.from(dataTransfer.types).includes("text/html") && dataTransfer.getData("text/html") !== "";
}
function $7c22895ca0418c15$var$getImagesFromChangeItem(editor, item) {
    const imageUtils = editor.plugins.get("ImageUtils");
    return Array.from(editor.model.createRangeOn(item)).filter((value)=>imageUtils.isImage(value.item)).map((value)=>value.item);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageupload
*/ /**
* The image upload plugin.
*
* For a detailed overview, check the {@glink features/images/image-upload/image-upload image upload feature} documentation.
*
* This plugin does not do anything directly, but it loads a set of specific plugins to enable image uploading:
*
* * {@link module:image/imageupload/imageuploadediting~ImageUploadEditing},
* * {@link module:image/imageupload/imageuploadui~ImageUploadUI},
* * {@link module:image/imageupload/imageuploadprogress~ImageUploadProgress}.
*/ var $7c22895ca0418c15$export$6083e5dee0802eaa = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageUpload";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$7cd72690bdb810ee,
            $7c22895ca0418c15$export$21e22db9cb7636df,
            $7c22895ca0418c15$export$7ec8ba77907346bb
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsert/ui/imageinserturlview
*/ /**
* The insert an image via URL view.
*
* See {@link module:image/imageinsert/imageinsertviaurlui~ImageInsertViaUrlUI}.
*
* @internal
*/ var $7c22895ca0418c15$export$9cc1b84b5c2372f1 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* The URL input field view.
	*/ urlInputView;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Creates a view for the dropdown panel of {@link module:image/imageinsert/imageinsertui~ImageInsertUI}.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.set("imageURLInputValue", "");
        this.set("isImageSelected", false);
        this.set("isEnabled", true);
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.urlInputView = this._createUrlInputView();
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-image-insert-url"
                ],
                tabindex: "-1"
            },
            children: [
                this.urlInputView,
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-image-insert-url__action-row"
                        ]
                    }
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Creates the {@link #urlInputView}.
	*/ _createUrlInputView() {
        const locale = this.locale;
        const t = locale.t;
        const urlInputView = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        urlInputView.bind("label").to(this, "isImageSelected", (value)=>value ? t("Update image URL") : t("Insert image via URL"));
        urlInputView.bind("isEnabled").to(this);
        urlInputView.fieldView.inputMode = "url";
        urlInputView.fieldView.placeholder = "https://example.com/image.png";
        urlInputView.fieldView.bind("value").to(this, "imageURLInputValue", (value)=>value || "");
        urlInputView.fieldView.on("input", ()=>{
            this.imageURLInputValue = urlInputView.fieldView.element.value.trim();
        });
        return urlInputView;
    }
    /**
	* Focuses the view.
	*/ focus() {
        this.urlInputView.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsert/imageinsertviaurlui
*/ /**
* The image insert via URL plugin (UI part).
*
* The plugin introduces two UI components to the {@link module:ui/componentfactory~ComponentFactory UI component factory}:
*
* * the `'insertImageViaUrl'` toolbar button,
* * the `'menuBar:insertImageViaUrl'` menu bar component.
*
* It also integrates with the `insertImage` toolbar component and `menuBar:insertImage` menu component, which are default components
* through which inserting image via URL is available.
*/ var $7c22895ca0418c15$export$cff994ead1ef17b8 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _imageInsertUI;
    _formView;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInsertViaUrlUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$3946c48aa73e9ec1,
            (0, $29fd27cb9bdab9d2$export$3ddf2d174ce01153)
        ];
    }
    init() {
        this.editor.ui.componentFactory.add("insertImageViaUrl", ()=>this._createToolbarButton());
        this.editor.ui.componentFactory.add("menuBar:insertImageViaUrl", ()=>this._createMenuBarButton("standalone"));
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        this._imageInsertUI.registerIntegration({
            name: "url",
            observable: ()=>this.editor.commands.get("insertImage"),
            buttonViewCreator: ()=>this._createToolbarButton(),
            formViewCreator: ()=>this._createDropdownButton(),
            menuBarButtonViewCreator: (isOnly)=>this._createMenuBarButton(isOnly ? "insertOnly" : "insertNested")
        });
    }
    /**
	* Creates the base for various kinds of the button component provided by this feature.
	*/ _createInsertUrlButton(ButtonClass) {
        const button = new ButtonClass(this.editor.locale);
        button.icon = (0, $e8dc502aba5ac3f5$export$ec40730d4a74e656);
        button.on("execute", ()=>{
            this._showModal();
        });
        return button;
    }
    /**
	* Creates a simple toolbar button, with an icon and a tooltip.
	*/ _createToolbarButton() {
        const t = this.editor.locale.t;
        const button = this._createInsertUrlButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.tooltip = true;
        button.bind("label").to(this._imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Update image URL") : t("Insert image via URL"));
        return button;
    }
    /**
	* Creates a button for the dropdown view, with an icon, text and no tooltip.
	*/ _createDropdownButton() {
        const t = this.editor.locale.t;
        const button = this._createInsertUrlButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.withText = true;
        button.bind("label").to(this._imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Update image URL") : t("Insert via URL"));
        return button;
    }
    /**
	* Creates a button for the menu bar.
	*/ _createMenuBarButton(type) {
        const t = this.editor.locale.t;
        const button = this._createInsertUrlButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        button.withText = true;
        switch(type){
            case "standalone":
                button.label = t("Image via URL");
                break;
            case "insertOnly":
                button.label = t("Image");
                break;
            case "insertNested":
                button.label = t("Via URL");
        }
        return button;
    }
    /**
	* Creates the form view used to submit the image URL.
	*/ _createInsertUrlView() {
        const editor = this.editor;
        const locale = editor.locale;
        const replaceImageSourceCommand = editor.commands.get("replaceImageSource");
        const insertImageCommand = editor.commands.get("insertImage");
        const imageInsertUrlView = new $7c22895ca0418c15$export$9cc1b84b5c2372f1(locale);
        imageInsertUrlView.bind("isImageSelected").to(this._imageInsertUI);
        imageInsertUrlView.bind("isEnabled").toMany([
            insertImageCommand,
            replaceImageSourceCommand
        ], "isEnabled", (...isEnabled)=>isEnabled.some((isCommandEnabled)=>isCommandEnabled));
        return imageInsertUrlView;
    }
    /**
	* Shows the insert image via URL form view in a modal.
	*/ _showModal() {
        const editor = this.editor;
        const t = editor.locale.t;
        const dialog = editor.plugins.get("Dialog");
        if (!this._formView) {
            this._formView = this._createInsertUrlView();
            this._formView.on("submit", ()=>this._handleSave());
        }
        const replaceImageSourceCommand = editor.commands.get("replaceImageSource");
        this._formView.imageURLInputValue = replaceImageSourceCommand.value || "";
        dialog.show({
            id: "insertImageViaUrl",
            title: t("Image via URL"),
            isModal: true,
            content: this._formView,
            actionButtons: [
                {
                    label: t("Cancel"),
                    withText: true,
                    onExecute: ()=>dialog.hide()
                },
                {
                    label: this._imageInsertUI.isImageSelected ? t("Save") : t("Insert"),
                    class: "ck-button-action",
                    withText: true,
                    onExecute: ()=>this._handleSave()
                }
            ]
        });
    }
    /**
	* Executes appropriate command depending on selection and form value.
	*/ _handleSave() {
        if (this.editor.commands.get("replaceImageSource").isEnabled) this.editor.execute("replaceImageSource", {
            source: this._formView.imageURLInputValue
        });
        else this.editor.execute("insertImage", {
            source: this._formView.imageURLInputValue
        });
        this.editor.plugins.get("Dialog").hide();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsertviaurl
*/ /**
* The image insert via URL plugin.
*
* For a detailed overview, check the {@glink features/images/images-inserting
* Insert images via source URL} documentation.
*
* This plugin does not do anything directly, but it loads a set of specific plugins
* to enable image inserting via implemented integrations:
*
* * {@link module:image/imageinsert/imageinsertui~ImageInsertUI},
*/ var $7c22895ca0418c15$export$960b605706c57550 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInsertViaUrl";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$cff994ead1ef17b8,
            $7c22895ca0418c15$export$3946c48aa73e9ec1
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageinsert
*/ /**
* The image insert plugin.
*
* For a detailed overview, check the {@glink features/images/image-upload/image-upload Image upload feature}
* and {@glink features/images/images-inserting Insert images via source URL} documentation.
*
* This plugin does not do anything directly, but it loads a set of specific plugins
* to enable image uploading or inserting via implemented integrations:
*
* * {@link module:image/imageupload~ImageUpload}
* * {@link module:image/imageinsert/imageinsertui~ImageInsertUI}
*/ var $7c22895ca0418c15$export$f6ee6ac9ea28fa1b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageInsert";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$6083e5dee0802eaa,
            $7c22895ca0418c15$export$960b605706c57550,
            $7c22895ca0418c15$export$3946c48aa73e9ec1
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize/resizeimagecommand
*/ /**
* The resize image command. Currently, it only supports the width attribute.
*/ var $7c22895ca0418c15$export$61952c947fa205c8 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const element = editor.plugins.get("ImageUtils").getClosestSelectedImageElement(editor.model.document.selection);
        this.isEnabled = !!element;
        if (!element || !element.hasAttribute("resizedWidth")) this.value = null;
        else this.value = {
            width: element.getAttribute("resizedWidth"),
            height: null
        };
    }
    /**
	* Executes the command.
	*
	* ```ts
	* // Sets the width to 50%:
	* editor.execute( 'resizeImage', { width: '50%' } );
	*
	* // Removes the width attribute:
	* editor.execute( 'resizeImage', { width: null } );
	* ```
	*
	* @param options
	* @param options.width The new width of the image.
	* @fires execute
	*/ execute(options) {
        const editor = this.editor;
        const model = editor.model;
        const imageUtils = editor.plugins.get("ImageUtils");
        const imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
        this.value = {
            width: options.width,
            height: null
        };
        if (imageElement) model.change((writer)=>{
            writer.setAttribute("resizedWidth", options.width, imageElement);
            writer.removeAttribute("resizedHeight", imageElement);
            imageUtils.setImageNaturalSizeAttributes(imageElement);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The image resize editing feature.
*
* It adds the ability to resize each image using handles or manually by
* {@link module:image/imageresize/imageresizebuttons~ImageResizeButtons} buttons.
*/ var $7c22895ca0418c15$export$494e63434faae288 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageResizeEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "IR";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("image", {
            resizeUnit: "%",
            resizeOptions: [
                {
                    name: "resizeImage:original",
                    value: null,
                    icon: "original"
                },
                {
                    name: "resizeImage:custom",
                    value: "custom",
                    icon: "custom"
                },
                {
                    name: "resizeImage:25",
                    value: "25",
                    icon: "small"
                },
                {
                    name: "resizeImage:50",
                    value: "50",
                    icon: "medium"
                },
                {
                    name: "resizeImage:75",
                    value: "75",
                    icon: "large"
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const resizeImageCommand = new $7c22895ca0418c15$export$61952c947fa205c8(editor);
        this._registerConverters("imageBlock");
        this._registerConverters("imageInline");
        editor.commands.add("resizeImage", resizeImageCommand);
        editor.commands.add("imageResize", resizeImageCommand);
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._registerSchema();
    }
    _registerSchema() {
        const schema = this.editor.model.schema;
        if (this.editor.plugins.has("ImageBlockEditing")) {
            schema.extend("imageBlock", {
                allowAttributes: [
                    "resizedWidth",
                    "resizedHeight"
                ]
            });
            schema.setAttributeProperties("resizedWidth", {
                isFormatting: true
            });
            schema.setAttributeProperties("resizedHeight", {
                isFormatting: true
            });
        }
        if (this.editor.plugins.has("ImageInlineEditing")) {
            schema.extend("imageInline", {
                allowAttributes: [
                    "resizedWidth",
                    "resizedHeight"
                ]
            });
            schema.setAttributeProperties("resizedWidth", {
                isFormatting: true
            });
            schema.setAttributeProperties("resizedHeight", {
                isFormatting: true
            });
        }
    }
    /**
	* Registers image resize converters.
	*
	* @param imageType The type of the image.
	*/ _registerConverters(imageType) {
        const editor = this.editor;
        const imageUtils = editor.plugins.get("ImageUtils");
        editor.conversion.for("downcast").add((dispatcher)=>dispatcher.on(`attribute:resizedWidth:${imageType}`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const viewWriter = conversionApi.writer;
                const viewImg = conversionApi.mapper.toViewElement(data.item);
                if (data.attributeNewValue !== null) {
                    viewWriter.setStyle("width", data.attributeNewValue, viewImg);
                    viewWriter.addClass("image_resized", viewImg);
                } else {
                    viewWriter.removeStyle("width", viewImg);
                    viewWriter.removeClass("image_resized", viewImg);
                }
            }));
        editor.conversion.for("dataDowncast").attributeToAttribute({
            model: {
                name: imageType,
                key: "resizedHeight"
            },
            view: (modelAttributeValue)=>({
                    key: "style",
                    value: {
                        "height": modelAttributeValue
                    }
                })
        });
        editor.conversion.for("editingDowncast").add((dispatcher)=>dispatcher.on(`attribute:resizedHeight:${imageType}`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const viewWriter = conversionApi.writer;
                const viewImg = conversionApi.mapper.toViewElement(data.item);
                const target = imageType === "imageInline" ? imageUtils.findViewImgElement(viewImg) : viewImg;
                if (data.attributeNewValue !== null) viewWriter.setStyle("height", data.attributeNewValue, target);
                else viewWriter.removeStyle("height", target);
            }));
        editor.conversion.for("upcast").attributeToAttribute({
            view: {
                name: imageType === "imageBlock" ? "figure" : "img",
                styles: {
                    width: /.+/
                }
            },
            model: {
                key: "resizedWidth",
                value: (viewElement)=>{
                    if ($7c22895ca0418c15$export$f12d3d28bbd41988(viewElement)) return null;
                    return viewElement.getStyle("width");
                }
            }
        });
        editor.conversion.for("upcast").attributeToAttribute({
            view: {
                name: imageType === "imageBlock" ? "figure" : "img",
                styles: {
                    height: /.+/
                }
            },
            model: {
                key: "resizedHeight",
                value: (viewElement)=>{
                    if ($7c22895ca0418c15$export$f12d3d28bbd41988(viewElement)) return null;
                    return viewElement.getStyle("height");
                }
            }
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on(`element:${imageType === "imageBlock" ? "figure" : "img"}`, (evt, data, conversionApi)=>{
                conversionApi.consumable.consume(data.viewItem, {
                    classes: [
                        "image_resized"
                    ]
                });
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize/imageresizebuttons
*/ const $7c22895ca0418c15$var$RESIZE_ICONS = /* #__PURE__ */ (()=>({
        small: (0, $e8dc502aba5ac3f5$export$d5ebd621e65c3406),
        medium: (0, $e8dc502aba5ac3f5$export$d617f0cc61264eda),
        large: (0, $e8dc502aba5ac3f5$export$62e00d4298f7a20b),
        custom: (0, $e8dc502aba5ac3f5$export$8877d472d8bae6e3),
        original: (0, $e8dc502aba5ac3f5$export$76e3fa0e80a872d8)
    }))();
/**
* The image resize buttons plugin.
*
* It adds a possibility to resize images using the toolbar dropdown or individual buttons, depending on the plugin configuration.
*/ var $7c22895ca0418c15$export$5ce1df0482e76716 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$494e63434faae288
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageResizeButtons";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The resize unit.
	* @default '%'
	*/ _resizeUnit;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._resizeUnit = editor.config.get("image.resizeUnit");
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const options = editor.config.get("image.resizeOptions");
        const command = editor.commands.get("resizeImage");
        this.bind("isEnabled").to(command);
        for (const option of options)this._registerImageResizeButton(option);
        this._registerImageResizeDropdown(options);
    }
    /**
	* A helper function that creates a standalone button component for the plugin.
	*
	* @param option A model of the resize option.
	*/ _registerImageResizeButton(option) {
        const editor = this.editor;
        const { name: name, value: value, icon: icon } = option;
        editor.ui.componentFactory.add(name, (locale)=>{
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const command = editor.commands.get("resizeImage");
            const labelText = this._getOptionLabelValue(option, true);
            if (!$7c22895ca0418c15$var$RESIZE_ICONS[icon]) /**
			* When configuring {@link module:image/imageconfig~ImageConfig#resizeOptions `config.image.resizeOptions`} for standalone
			* buttons, a valid `icon` token must be set for each option.
			*
			* See all valid options described in the
			* {@link module:image/imageconfig~ImageResizeOption plugin configuration}.
			*
			* @error imageresizebuttons-missing-icon
			* @param {module:image/imageconfig~ImageResizeOption} option Invalid image resize option.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("imageresizebuttons-missing-icon", editor, option);
            button.set({
                label: labelText,
                icon: $7c22895ca0418c15$var$RESIZE_ICONS[icon],
                tooltip: labelText,
                isToggleable: true
            });
            button.bind("isEnabled").to(this);
            if (editor.plugins.has("ImageCustomResizeUI") && $7c22895ca0418c15$var$isCustomImageResizeOption(option)) {
                const customResizeUI = editor.plugins.get("ImageCustomResizeUI");
                this.listenTo(button, "execute", ()=>{
                    customResizeUI._showForm(this._resizeUnit);
                });
            } else {
                const optionValueWithUnit = value ? value + this._resizeUnit : null;
                button.bind("isOn").to(command, "value", command, "isEnabled", $7c22895ca0418c15$var$getIsOnButtonCallback(optionValueWithUnit));
                this.listenTo(button, "execute", ()=>{
                    editor.execute("resizeImage", {
                        width: optionValueWithUnit
                    });
                });
            }
            return button;
        });
    }
    /**
	* A helper function that creates a dropdown component for the plugin containing all the resize options defined in
	* the editor configuration.
	*
	* @param options An array of configured options.
	*/ _registerImageResizeDropdown(options) {
        const editor = this.editor;
        const t = editor.t;
        const originalSizeOption = options.find((option)=>!option.value);
        const componentCreator = (locale)=>{
            const command = editor.commands.get("resizeImage");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$78bc6c5c028686b7));
            const dropdownButton = dropdownView.buttonView;
            const accessibleLabel = t("Resize image");
            dropdownButton.set({
                tooltip: accessibleLabel,
                commandValue: originalSizeOption.value,
                icon: $7c22895ca0418c15$var$RESIZE_ICONS.medium,
                isToggleable: true,
                label: this._getOptionLabelValue(originalSizeOption),
                withText: true,
                class: "ck-resize-image-button",
                ariaLabel: accessibleLabel,
                ariaLabelledBy: void 0
            });
            dropdownButton.bind("label").to(command, "value", (commandValue)=>{
                if (commandValue && commandValue.width) return commandValue.width;
                else return this._getOptionLabelValue(originalSizeOption);
            });
            dropdownView.bind("isEnabled").to(this);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, ()=>this._getResizeDropdownListItemDefinitions(options, command), {
                ariaLabel: t("Image resize list"),
                role: "menu"
            });
            this.listenTo(dropdownView, "execute", (evt)=>{
                if ("onClick" in evt.source) evt.source.onClick();
                else {
                    editor.execute(evt.source.commandName, {
                        width: evt.source.commandValue
                    });
                    editor.editing.view.focus();
                }
            });
            return dropdownView;
        };
        editor.ui.componentFactory.add("resizeImage", componentCreator);
        editor.ui.componentFactory.add("imageResize", componentCreator);
    }
    /**
	* A helper function for creating an option label value string.
	*
	* @param option A resize option object.
	* @param forTooltip An optional flag for creating a tooltip label.
	* @returns A user-defined label combined from the numeric value and the resize unit or the default label
	* for reset options (`Original`).
	*/ _getOptionLabelValue(option, forTooltip = false) {
        const t = this.editor.t;
        if (option.label) return option.label;
        else if (forTooltip) {
            if ($7c22895ca0418c15$var$isCustomImageResizeOption(option)) return t("Custom image size");
            else if (option.value) return t("Resize image to %0", option.value + this._resizeUnit);
            else return t("Resize image to the original size");
        } else if ($7c22895ca0418c15$var$isCustomImageResizeOption(option)) return t("Custom");
        else if (option.value) return option.value + this._resizeUnit;
        else return t("Original");
    }
    /**
	* A helper function that parses the resize options and returns list item definitions ready for use in the dropdown.
	*
	* @param options The resize options.
	* @param command The resize image command.
	* @returns Dropdown item definitions.
	*/ _getResizeDropdownListItemDefinitions(options, command) {
        const { editor: editor } = this;
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        const optionsWithSerializedValues = options.map((option)=>{
            if ($7c22895ca0418c15$var$isCustomImageResizeOption(option)) return {
                ...option,
                valueWithUnits: "custom"
            };
            if (!option.value) return {
                ...option,
                valueWithUnits: null
            };
            return {
                ...option,
                valueWithUnits: `${option.value}${this._resizeUnit}`
            };
        });
        for (const option of optionsWithSerializedValues){
            let definition;
            if (editor.plugins.has("ImageCustomResizeUI") && $7c22895ca0418c15$var$isCustomImageResizeOption(option)) {
                const customResizeUI = editor.plugins.get("ImageCustomResizeUI");
                definition = {
                    type: "button",
                    model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                        label: this._getOptionLabelValue(option),
                        role: "menuitemradio",
                        withText: true,
                        icon: null,
                        onClick: ()=>{
                            customResizeUI._showForm(this._resizeUnit);
                        }
                    })
                };
                const allDropdownValues = Object.values(optionsWithSerializedValues).map((option)=>option.valueWithUnits);
                definition.model.bind("isOn").to(command, "value", command, "isEnabled", $7c22895ca0418c15$var$getIsOnCustomButtonCallback(allDropdownValues));
            } else {
                definition = {
                    type: "button",
                    model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                        commandName: "resizeImage",
                        commandValue: option.valueWithUnits,
                        label: this._getOptionLabelValue(option),
                        role: "menuitemradio",
                        withText: true,
                        icon: null
                    })
                };
                definition.model.bind("isOn").to(command, "value", command, "isEnabled", $7c22895ca0418c15$var$getIsOnButtonCallback(option.valueWithUnits));
            }
            definition.model.bind("isEnabled").to(command, "isEnabled");
            itemDefinitions.add(definition);
        }
        return itemDefinitions;
    }
};
/**
* A helper that checks if provided option triggers custom resize balloon.
*/ function $7c22895ca0418c15$var$isCustomImageResizeOption(option) {
    return option.value === "custom";
}
/**
* A helper function for setting the `isOn` state of buttons in value bindings.
*/ function $7c22895ca0418c15$var$getIsOnButtonCallback(value) {
    return (commandValue, isEnabled)=>{
        const objectCommandValue = commandValue;
        if (objectCommandValue === void 0 || !isEnabled) return false;
        if (value === null && objectCommandValue === value) return true;
        return objectCommandValue !== null && objectCommandValue.width === value;
    };
}
/**
* A helper function for setting the `isOn` state of custom size button in value bindings.
*/ function $7c22895ca0418c15$var$getIsOnCustomButtonCallback(allDropdownValues) {
    return (commandValue, isEnabled)=>!allDropdownValues.some((dropdownValue)=>$7c22895ca0418c15$var$getIsOnButtonCallback(dropdownValue)(commandValue, isEnabled));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $7c22895ca0418c15$var$RESIZABLE_IMAGES_CSS_SELECTOR = "figure.image.ck-widget > img,figure.image.ck-widget > picture > img,figure.image.ck-widget > a > img,figure.image.ck-widget > a > picture > img,span.image-inline.ck-widget > img,span.image-inline.ck-widget > picture > img";
const $7c22895ca0418c15$var$RESIZED_IMAGE_CLASS = "image_resized";
/**
* The image resize by handles feature.
*
* It adds the ability to resize each image using handles or manually by
* {@link module:image/imageresize/imageresizebuttons~ImageResizeButtons} buttons.
*/ var $7c22895ca0418c15$export$7a2394a13c531f3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9),
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageResizeHandles";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const command = this.editor.commands.get("resizeImage");
        this.bind("isEnabled").to(command);
        this._setupResizerCreator();
    }
    /**
	* Attaches the listeners responsible for creating a resizer for each image, except for images inside the HTML embed preview.
	*/ _setupResizerCreator() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const imageUtils = editor.plugins.get("ImageUtils");
        editingView.addObserver($7c22895ca0418c15$export$201f2e45e6b19560);
        this.listenTo(editingView.document, "imageLoaded", (evt, domEvent)=>{
            if (!domEvent.target.matches($7c22895ca0418c15$var$RESIZABLE_IMAGES_CSS_SELECTOR)) return;
            const domConverter = editor.editing.view.domConverter;
            const imageView = domConverter.domToView(domEvent.target);
            const widgetView = imageUtils.getImageWidgetFromImageView(imageView);
            let resizer = this.editor.plugins.get((0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9)).getResizerByViewElement(widgetView);
            if (resizer) {
                resizer.redraw();
                return;
            }
            const mapper = editor.editing.mapper;
            const imageModel = mapper.toModelElement(widgetView);
            resizer = editor.plugins.get((0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9)).attachTo({
                unit: editor.config.get("image.resizeUnit"),
                modelElement: imageModel,
                viewElement: widgetView,
                editor: editor,
                getHandleHost (domWidgetElement) {
                    return domWidgetElement.querySelector("img");
                },
                getResizeHost () {
                    return domConverter.mapViewToDom(mapper.toViewElement(imageModel));
                },
                isCentered () {
                    return imageModel.getAttribute("imageStyle") == "alignCenter";
                },
                onCommit (newValue) {
                    editingView.change((writer)=>{
                        writer.removeClass($7c22895ca0418c15$var$RESIZED_IMAGE_CLASS, widgetView);
                    });
                    editor.execute("resizeImage", {
                        width: newValue
                    });
                }
            });
            resizer.on("updateSize", ()=>{
                if (!widgetView.hasClass($7c22895ca0418c15$var$RESIZED_IMAGE_CLASS)) editingView.change((writer)=>{
                    writer.addClass($7c22895ca0418c15$var$RESIZED_IMAGE_CLASS, widgetView);
                });
                const target = imageModel.name === "imageInline" ? imageView : widgetView;
                if (target.getStyle("height")) editingView.change((writer)=>{
                    writer.removeStyle("height", target);
                });
            });
            resizer.bind("isEnabled").to(this);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Finds model, view and DOM element for selected image element. Returns `null` if there is no image selected.
*
* @param editor Editor instance.
* @internal
*/ function $7c22895ca0418c15$export$e0af856567cd8f74(editor) {
    const { editing: editing } = editor;
    const imageModelElement = editor.plugins.get("ImageUtils").getClosestSelectedImageElement(editor.model.document.selection);
    if (!imageModelElement) return null;
    const imageViewElement = editing.mapper.toViewElement(imageModelElement);
    return {
        model: imageModelElement,
        view: imageViewElement,
        dom: editing.view.domConverter.mapViewToDom(imageViewElement)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize/utils/getselectedimagewidthinunits
*/ /**
* Returns image width in specified units. It is width of image after resize.
*
* 	* If image is not selected or command is disabled then `null` will be returned.
* 	* If image is not fully loaded (and it is impossible to determine its natural size) then `null` will be returned.
*	* If `targetUnit` percentage is passed then it will return width percentage of image related to its accessors.
*
* @param editor Editor instance.
* @param targetUnit Unit in which dimension will be returned.
* @returns Parsed image width after resize (with unit).
* @internal
*/ function $7c22895ca0418c15$export$f3d52d5778d5c9eb(editor, targetUnit) {
    const imageNodes = $7c22895ca0418c15$export$e0af856567cd8f74(editor);
    if (!imageNodes) return null;
    const parsedResizedWidth = (0, $c7bc2cb7e2db0227$export$75edd0f9cff526b0)(imageNodes.model.getAttribute("resizedWidth") || null);
    if (!parsedResizedWidth) return null;
    if (parsedResizedWidth.unit === targetUnit) return parsedResizedWidth;
    const imageParentWidthPx = (0, $5547ab21e02f1e9e$export$6ec49425c093db63)(imageNodes.dom);
    const imageHolderDimension = {
        unit: "px",
        value: new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(imageNodes.dom).width
    };
    return (0, $c7bc2cb7e2db0227$export$5fa337c2fe4d899a)(imageParentWidthPx, imageHolderDimension, targetUnit);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize/ui/imagecustomresizeformview
*/ /**
* The ImageCustomResizeFormView class.
*
* @internal
*/ var $7c22895ca0418c15$export$32374aedfbb6fcd1 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Resize unit shortcut.
	*/ unit;
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A button used to submit the form.
	*/ saveButtonView;
    /**
	* An input with a label.
	*/ labeledInput;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of views which can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* An array of form validators used by {@link #isValid}.
	*/ _validators;
    /**
	* @inheritDoc
	*/ constructor(locale, unit, validators){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.unit = unit;
        this.backButtonView = this._createBackButton();
        this.saveButtonView = this._createSaveButton();
        this.labeledInput = this._createLabeledInputView();
        this.children = this.createCollection([
            this._createHeaderView()
        ]);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.labeledInput,
                this.saveButtonView
            ],
            class: [
                "ck-form__row_with-submit",
                "ck-form__row_large-top-padding",
                "ck-form__row_large-bottom-padding"
            ]
        }));
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this._validators = validators;
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("cancel");
            cancel();
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-image-custom-resize-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.backButtonView,
            this.labeledInput,
            this.saveButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates a save button view that resize the image.
	*/ _createSaveButton() {
        const t = this.locale.t;
        const saveButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        saveButton.set({
            label: t("Save"),
            withText: true,
            type: "submit",
            class: "ck-button-action"
        });
        return saveButton;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Image Resize")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates an input with a label.
	*
	* @returns Labeled field view instance.
	*/ _createLabeledInputView() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$616b4440975f3e79));
        labeledInput.label = t("Resize image (in %0)", this.unit);
        labeledInput.class = "ck-labeled-field-view_full-width";
        labeledInput.fieldView.set({
            step: .1
        });
        return labeledInput;
    }
    /**
	* Validates the form and returns `false` when some fields are invalid.
	*/ isValid() {
        this.resetFormStatus();
        for (const validator of this._validators){
            const errorText = validator(this);
            if (errorText) {
                this.labeledInput.errorText = errorText;
                return false;
            }
        }
        return true;
    }
    /**
	* Cleans up the supplementary error and information text of the {@link #labeledInput}
	* bringing them back to the state when the form has been displayed for the first time.
	*
	* See {@link #isValid}.
	*/ resetFormStatus() {
        this.labeledInput.errorText = null;
    }
    /**
	* The native DOM `value` of the input element of {@link #labeledInput}.
	*/ get rawSize() {
        const { element: element } = this.labeledInput.fieldView;
        if (!element) return null;
        return element.value;
    }
    /**
	* Get numeric value of size. Returns `null` if value of size input element in {@link #labeledInput}.is not a number.
	*/ get parsedSize() {
        const { rawSize: rawSize } = this;
        if (rawSize === null) return null;
        const parsed = Number.parseFloat(rawSize);
        if (Number.isNaN(parsed)) return null;
        return parsed;
    }
    /**
	* Returns serialized image input size with unit.
	* Returns `null` if value of size input element in {@link #labeledInput}.is not a number.
	*/ get sizeWithUnits() {
        const { parsedSize: parsedSize, unit: unit } = this;
        if (parsedSize === null) return null;
        return `${parsedSize}${unit}`;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns min and max value of resize image in specified unit.
*
* @param editor Editor instance.
* @param targetUnit Unit in which dimension will be returned.
* @returns Possible resize range in numeric form.
* @internal
*/ function $7c22895ca0418c15$export$a04a613691f2c852(editor, targetUnit) {
    const imageNodes = $7c22895ca0418c15$export$e0af856567cd8f74(editor);
    if (!imageNodes) return null;
    const imageParentWidthPx = (0, $5547ab21e02f1e9e$export$6ec49425c093db63)(imageNodes.dom);
    const minimumImageWidth = (0, $c7bc2cb7e2db0227$export$75edd0f9cff526b0)(window.getComputedStyle(imageNodes.dom).minWidth) || {
        value: 1,
        unit: "px"
    };
    return {
        unit: targetUnit,
        lower: Math.max(.1, (0, $c7bc2cb7e2db0227$export$5fa337c2fe4d899a)(imageParentWidthPx, minimumImageWidth, targetUnit).value),
        upper: targetUnit === "px" ? imageParentWidthPx : 100
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize/imagecustomresizeui
*/ /**
* The custom resize image UI plugin.
*
* The plugin uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon}.
*/ var $7c22895ca0418c15$export$7ba8a0ad3e34023b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* A form containing a textarea and buttons, used to change the `alt` text value.
	*/ _form;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageCustomResizeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this._form) this._form.destroy();
    }
    /**
	* Creates the {@link module:image/imageresize/ui/imagecustomresizeformview~ImageCustomResizeFormView}
	* form.
	*/ _createForm(unit) {
        const editor = this.editor;
        this._balloon = this.editor.plugins.get("ContextualBalloon");
        this._form = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($7c22895ca0418c15$export$32374aedfbb6fcd1))(editor.locale, unit, $7c22895ca0418c15$var$getFormValidators(editor));
        this._form.render();
        this.listenTo(this._form, "submit", ()=>{
            if (this._form.isValid()) {
                editor.execute("resizeImage", {
                    width: this._form.sizeWithUnits
                });
                this._hideForm(true);
            }
        });
        this.listenTo(this._form.labeledInput, "change:errorText", ()=>{
            editor.ui.update();
        });
        this.listenTo(this._form, "cancel", ()=>{
            this._hideForm(true);
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this._form,
            activator: ()=>this._isVisible,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>this._hideForm()
        });
    }
    /**
	* Shows the {@link #_form} in the {@link #_balloon}.
	*
	* @internal
	*/ _showForm(unit) {
        if (this._isVisible) return;
        if (!this._form) this._createForm(unit);
        const editor = this.editor;
        const labeledInput = this._form.labeledInput;
        this._form.disableCssTransitions();
        this._form.resetFormStatus();
        if (!this._isInBalloon) this._balloon.add({
            view: this._form,
            position: $7c22895ca0418c15$export$52e4a080611dda72(editor)
        });
        const currentParsedWidth = $7c22895ca0418c15$export$f3d52d5778d5c9eb(editor, unit);
        const initialInputValue = currentParsedWidth ? currentParsedWidth.value.toFixed(1) : "";
        const possibleRange = $7c22895ca0418c15$export$a04a613691f2c852(editor, unit);
        labeledInput.fieldView.value = labeledInput.fieldView.element.value = initialInputValue;
        if (possibleRange) Object.assign(labeledInput.fieldView, {
            min: possibleRange.lower.toFixed(1),
            max: Math.ceil(possibleRange.upper).toFixed(1)
        });
        this._form.labeledInput.fieldView.select();
        this._form.enableCssTransitions();
    }
    /**
	* Removes the {@link #_form} from the {@link #_balloon}.
	*
	* @param focusEditable Controls whether the editing view is focused afterwards.
	*/ _hideForm(focusEditable = false) {
        if (!this._isInBalloon) return;
        if (this._form.focusTracker.isFocused) this._form.saveButtonView.focus();
        this._balloon.remove(this._form);
        if (focusEditable) this.editor.editing.view.focus();
    }
    /**
	* Returns `true` when the {@link #_form} is the visible view in the {@link #_balloon}.
	*/ get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
    }
    /**
	* Returns `true` when the {@link #_form} is in the {@link #_balloon}.
	*/ get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
    }
};
/**
* Returns image resize form validation callbacks.
*
* @param editor Editor instance.
*/ function $7c22895ca0418c15$var$getFormValidators(editor) {
    const t = editor.t;
    return [
        (form)=>{
            if (form.rawSize.trim() === "") return t("The value must not be empty.");
            if (form.parsedSize === null) return t("The value should be a plain number.");
        }
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imageresize
*/ /**
* The image resize plugin.
*
* It adds a possibility to resize each image using handles.
*/ var $7c22895ca0418c15$export$3603d4ba9bf0dcf7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$494e63434faae288,
            $7c22895ca0418c15$export$7a2394a13c531f3,
            $7c22895ca0418c15$export$7ba8a0ad3e34023b,
            $7c22895ca0418c15$export$5ce1df0482e76716
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageResize";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The image style command. It is used to apply {@link module:image/imageconfig~ImageStyleConfig#options image style option}
* to a selected image.
*
* **Note**: Executing this command may change the image model element if the desired style requires an image of a different
* type. See {@link module:image/imagestyle/imagestylecommand~ImageStyleCommand#execute} to learn more.
*/ var $7c22895ca0418c15$export$76bfc4aaa447ab01 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* An object containing names of default style options for the inline and block images.
	* If there is no default style option for the given image type in the configuration,
	* the name will be `false`.
	*/ _defaultStyles;
    /**
	* The styles handled by this command.
	*/ _styles;
    /**
	* Creates an instance of the image style command. When executed, the command applies one of
	* {@link module:image/imageconfig~ImageStyleConfig#options style options} to the currently selected image.
	*
	* @param editor The editor instance.
	* @param styles The style options that this command supports.
	*/ constructor(editor, styles){
        super(editor);
        this._defaultStyles = {
            imageBlock: false,
            imageInline: false
        };
        this._styles = new Map(styles.map((style)=>{
            if (style.isDefault) for (const modelElementName of style.modelElements)this._defaultStyles[modelElementName] = style.name;
            return [
                style.name,
                style
            ];
        }));
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const element = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!element;
        if (!this.isEnabled) this.value = false;
        else if (element.hasAttribute("imageStyle")) this.value = element.getAttribute("imageStyle");
        else this.value = this._defaultStyles[element.name];
    }
    /**
	* Returns whether the style with the given name can be applied to the currently selected image.
	*
	* Applying a style may internally trigger a type conversion (block ↔ inline) when the style
	* supports only the opposite type. If that conversion would be rejected by the schema (for
	* example, converting an inline image to a block image inside `$inlineRoot`), this style
	* cannot be applied even though the command itself is enabled. UI components representing
	* individual styles should reflect this per-style state in their `isEnabled`.
	*/ isStyleEnabled(styleName) {
        if (!this.isEnabled) return false;
        const imageUtils = this.editor.plugins.get("ImageUtils");
        const element = imageUtils.getClosestSelectedImageElement(this.editor.model.document.selection);
        if (!element || !this._styles.has(styleName)) return false;
        if (!this.shouldConvertImageType(styleName, element)) return true;
        const typeCommandName = imageUtils.isBlockImage(element) ? "imageTypeInline" : "imageTypeBlock";
        const typeCommand = this.editor.commands.get(typeCommandName);
        return !!typeCommand && typeCommand.isEnabled;
    }
    /**
	* Executes the command and applies the style to the currently selected image:
	*
	* ```ts
	* editor.execute( 'imageStyle', { value: 'side' } );
	* ```
	*
	* **Note**: Executing this command may change the image model element if the desired style requires an image
	* of a different type. Learn more about {@link module:image/imageconfig~ImageStyleOptionDefinition#modelElements model element}
	* configuration for the style option.
	*
	* @param options.value The name of the style (as configured in {@link module:image/imageconfig~ImageStyleConfig#options}).
	* @param options.setImageSizes Specifies whether the image `width` and `height` attributes should be set automatically.
	* The default is `true`.
	* @fires execute
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const imageUtils = editor.plugins.get("ImageUtils");
        if (options.value && !this.isStyleEnabled(options.value)) return;
        model.change((writer)=>{
            const requestedStyle = options.value;
            const { setImageSizes: setImageSizes = true } = options;
            let imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
            if (requestedStyle && this.shouldConvertImageType(requestedStyle, imageElement)) {
                this.editor.execute(imageUtils.isBlockImage(imageElement) ? "imageTypeInline" : "imageTypeBlock", {
                    setImageSizes: setImageSizes
                });
                imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
            }
            if (!requestedStyle || this._styles.get(requestedStyle).isDefault) writer.removeAttribute("imageStyle", imageElement);
            else writer.setAttribute("imageStyle", requestedStyle, imageElement);
            if (setImageSizes) imageUtils.setImageNaturalSizeAttributes(imageElement);
        });
    }
    /**
	* Returns `true` if requested style change would trigger the image type change.
	*
	* @param requestedStyle The name of the style (as configured in {@link module:image/imageconfig~ImageStyleConfig#options}).
	* @param imageElement The image model element.
	*/ shouldConvertImageType(requestedStyle, imageElement) {
        return !this._styles.get(requestedStyle).modelElements.includes(imageElement.name);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagestyle/utils
*/ /**
* Default image style options provided by the plugin that can be referred in the {@link module:image/imageconfig~ImageConfig#styles}
* configuration.
*
* There are available 5 styles focused on formatting:
*
* * **`'alignLeft'`** aligns the inline or block image to the left and wraps it with the text using the `image-style-align-left` class,
* * **`'alignRight'`** aligns the inline or block image to the right and wraps it with the text using the `image-style-align-right` class,
* * **`'alignCenter'`** centers the block image using the `image-style-align-center` class,
* * **`'alignBlockLeft'`** aligns the block image to the left using the `image-style-block-align-left` class,
* * **`'alignBlockRight'`** aligns the block image to the right using the `image-style-block-align-right` class,
*
* and 3 semantic styles:
*
* * **`'inline'`** is an inline image without any CSS class,
* * **`'block'`** is a block image without any CSS class,
* * **`'side'`** is a block image styled with the `image-style-side` CSS class.
*
* @internal
*/ const $7c22895ca0418c15$export$39b11f1480c4d21b = {
    get inline () {
        return {
            name: "inline",
            title: "In line",
            icon: (0, $e8dc502aba5ac3f5$export$de8b7d50233806bc),
            modelElements: [
                "imageInline"
            ],
            isDefault: true
        };
    },
    get alignLeft () {
        return {
            name: "alignLeft",
            title: "Left aligned image",
            icon: (0, $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e),
            modelElements: [
                "imageBlock",
                "imageInline"
            ],
            className: "image-style-align-left"
        };
    },
    get alignBlockLeft () {
        return {
            name: "alignBlockLeft",
            title: "Left aligned image",
            icon: (0, $e8dc502aba5ac3f5$export$109641c0512af225),
            modelElements: [
                "imageBlock"
            ],
            className: "image-style-block-align-left"
        };
    },
    get alignCenter () {
        return {
            name: "alignCenter",
            title: "Centered image",
            icon: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
            modelElements: [
                "imageBlock"
            ],
            className: "image-style-align-center"
        };
    },
    get alignRight () {
        return {
            name: "alignRight",
            title: "Right aligned image",
            icon: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738),
            modelElements: [
                "imageBlock",
                "imageInline"
            ],
            className: "image-style-align-right"
        };
    },
    get alignBlockRight () {
        return {
            name: "alignBlockRight",
            title: "Right aligned image",
            icon: (0, $e8dc502aba5ac3f5$export$12c57266ee03e50a),
            modelElements: [
                "imageBlock"
            ],
            className: "image-style-block-align-right"
        };
    },
    get block () {
        return {
            name: "block",
            title: "Centered image",
            icon: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
            modelElements: [
                "imageBlock"
            ],
            isDefault: true
        };
    },
    get side () {
        return {
            name: "side",
            title: "Side image",
            icon: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738),
            modelElements: [
                "imageBlock"
            ],
            className: "image-style-side"
        };
    }
};
/**
* Default image style icons provided by the plugin that can be referred in the {@link module:image/imageconfig~ImageConfig#styles}
* configuration.
*
* See {@link module:image/imageconfig~ImageStyleOptionDefinition#icon} to learn more.
*
* There are 7 default icons available: `'full'`, `'left'`, `'inlineLeft'`, `'center'`, `'right'`, `'inlineRight'`, and `'inline'`.
*
* @internal
*/ const $7c22895ca0418c15$export$1dff802a7792e3ed = /* #__PURE__ */ (()=>({
        full: (0, $e8dc502aba5ac3f5$export$4385231065a264c8),
        left: (0, $e8dc502aba5ac3f5$export$109641c0512af225),
        right: (0, $e8dc502aba5ac3f5$export$12c57266ee03e50a),
        center: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
        inlineLeft: (0, $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e),
        inlineRight: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738),
        inline: (0, $e8dc502aba5ac3f5$export$de8b7d50233806bc)
    }))();
/**
* Default drop-downs provided by the plugin that can be referred in the {@link module:image/imageconfig~ImageConfig#toolbar}
* configuration. The drop-downs are containers for the {@link module:image/imageconfig~ImageStyleConfig#options image style options}.
*
* If both of the `ImageEditing` plugins are loaded, there are 2 predefined drop-downs available:
*
* * **`'imageStyle:wrapText'`**, which contains the `alignLeft` and `alignRight` options, that is,
* those that wraps the text around the image,
* * **`'imageStyle:breakText'`**, which contains the `alignBlockLeft`, `alignCenter` and `alignBlockRight` options, that is,
* those that breaks the text around the image.
*
* @internal
*/ const $7c22895ca0418c15$export$762dd5064be74c36 = [
    {
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: [
            "imageStyle:alignLeft",
            "imageStyle:alignRight"
        ]
    },
    {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: [
            "imageStyle:alignBlockLeft",
            "imageStyle:block",
            "imageStyle:alignBlockRight"
        ]
    }
];
/**
* Returns the style with a given `name` from an array of styles.
*
* @internal
*/ function $7c22895ca0418c15$var$getStyleDefinitionByName(name, styles) {
    for (const style of styles)if (style.name === name) return style;
}
/**
* Returns a list of the normalized and validated image style options.
*
* @param config
* @param config.isInlinePluginLoaded
* Determines whether the {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`} plugin has been loaded.
* @param config.isBlockPluginLoaded
* Determines whether the {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`} plugin has been loaded.
* @param config.configuredStyles
* The image styles configuration provided in the image styles {@link module:image/imageconfig~ImageConfig#styles configuration}
* as a default or custom value.
* @returns
* * Each of options contains a complete icon markup.
* * The image style options not supported by any of the loaded plugins are filtered out.
*/ function $7c22895ca0418c15$var$normalizeStyles(config) {
    return (config.configuredStyles.options || []).map((arrangement)=>$7c22895ca0418c15$var$normalizeDefinition(arrangement)).filter((arrangement)=>$7c22895ca0418c15$var$isValidOption(arrangement, config));
}
/**
* Returns the default image styles configuration depending on the loaded image editing plugins.
*
* @param isInlinePluginLoaded
* Determines whether the {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`} plugin has been loaded.
*
* @param isBlockPluginLoaded
* Determines whether the {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`} plugin has been loaded.
*
* @returns
* It returns an object with the lists of the image style options and groups defined as strings related to the
* {@link module:image/imagestyle/utils#DEFAULT_OPTIONS default options}
*/ function $7c22895ca0418c15$var$getDefaultStylesConfiguration(isBlockPluginLoaded, isInlinePluginLoaded) {
    if (isBlockPluginLoaded && isInlinePluginLoaded) return {
        options: [
            "inline",
            "alignLeft",
            "alignRight",
            "alignCenter",
            "alignBlockLeft",
            "alignBlockRight",
            "block",
            "side"
        ]
    };
    else if (isBlockPluginLoaded) return {
        options: [
            "block",
            "side"
        ]
    };
    else if (isInlinePluginLoaded) return {
        options: [
            "inline",
            "alignLeft",
            "alignRight"
        ]
    };
    return {};
}
/**
* Returns a list of the available predefined drop-downs' definitions depending on the loaded image editing plugins.
*/ function $7c22895ca0418c15$var$getDefaultDropdownDefinitions(pluginCollection) {
    if (pluginCollection.has("ImageBlockEditing") && pluginCollection.has("ImageInlineEditing")) return [
        ...$7c22895ca0418c15$export$762dd5064be74c36
    ];
    else return [];
}
/**
* Normalizes an image style option or group provided in the {@link module:image/imageconfig~ImageConfig#styles}
* and returns it in a {@link module:image/imageconfig~ImageStyleOptionDefinition}/
*/ function $7c22895ca0418c15$var$normalizeDefinition(definition) {
    if (typeof definition === "string") {
        if (!$7c22895ca0418c15$export$39b11f1480c4d21b[definition]) definition = {
            name: definition
        };
        else definition = {
            ...$7c22895ca0418c15$export$39b11f1480c4d21b[definition]
        };
    } else definition = $7c22895ca0418c15$var$extendStyle($7c22895ca0418c15$export$39b11f1480c4d21b[definition.name], definition);
    if (typeof definition.icon === "string") definition.icon = $7c22895ca0418c15$export$1dff802a7792e3ed[definition.icon] || definition.icon;
    return definition;
}
/**
* Checks if the image style option is valid:
* * if it has the modelElements fields defined and filled,
* * if the defined modelElements are supported by any of the loaded image editing plugins.
* It also displays a console warning these conditions are not met.
*
* @param option image style option
*/ function $7c22895ca0418c15$var$isValidOption(option, { isBlockPluginLoaded: isBlockPluginLoaded, isInlinePluginLoaded: isInlinePluginLoaded }) {
    const { modelElements: modelElements, name: name } = option;
    if (!modelElements || !modelElements.length || !name) {
        $7c22895ca0418c15$var$warnInvalidStyle({
            style: option
        });
        return false;
    } else {
        const supportedElements = [
            isBlockPluginLoaded ? "imageBlock" : null,
            isInlinePluginLoaded ? "imageInline" : null
        ];
        if (!modelElements.some((elementName)=>supportedElements.includes(elementName))) {
            /**
			* In order to work correctly, each image style {@link module:image/imageconfig~ImageStyleOptionDefinition option}
			* requires specific model elements (also: types of images) to be supported by the editor.
			*
			* Model element names to which the image style option can be applied are defined in the
			* {@link module:image/imageconfig~ImageStyleOptionDefinition#modelElements} property of the style option
			* definition.
			*
			* Explore the warning in the console to find out precisely which option is not supported and which editor plugins
			* are missing. Make sure these plugins are loaded in your editor to get this image style option working.
			*
			* @error image-style-missing-dependency
			* @param {string} style The name of the unsupported option.
			* @param {Array.<string>} missingPlugins The names of the plugins one of which has to be loaded for the particular option.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-style-missing-dependency", {
                style: option,
                missingPlugins: modelElements.map((name)=>name === "imageBlock" ? "ImageBlockEditing" : "ImageInlineEditing")
            });
            return false;
        }
    }
    return true;
}
/**
* Extends the default style with a style provided by the developer.
* Note: Don't override the custom–defined style object, clone it instead.
*/ function $7c22895ca0418c15$var$extendStyle(source, style) {
    const extendedStyle = {
        ...style
    };
    for(const prop in source)if (!Object.prototype.hasOwnProperty.call(style, prop)) extendedStyle[prop] = source[prop];
    return extendedStyle;
}
/**
* Displays a console warning with the 'image-style-configuration-definition-invalid' error.
*/ function $7c22895ca0418c15$var$warnInvalidStyle(info) {
    /**
	* The image style definition provided in the configuration is invalid.
	*
	* Please make sure the definition implements properly one of the following:
	*
	* * {@link module:image/imageconfig~ImageStyleOptionDefinition image style option definition},
	* * {@link module:image/imageconfig~ImageStyleDropdownDefinition image style dropdown definition}
	*
	* @error image-style-configuration-definition-invalid
	* @param {object} info The information about the invalid definition.
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("image-style-configuration-definition-invalid", info);
}
/**
* @internal
*/ const $7c22895ca0418c15$export$47fd453fdf2ace8d = {
    normalizeStyles: $7c22895ca0418c15$var$normalizeStyles,
    getDefaultStylesConfiguration: $7c22895ca0418c15$var$getDefaultStylesConfiguration,
    getDefaultDropdownDefinitions: $7c22895ca0418c15$var$getDefaultDropdownDefinitions,
    warnInvalidStyle: $7c22895ca0418c15$var$warnInvalidStyle
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagestyle/converters
*/ /**
* Returns a converter for the `imageStyle` attribute. It can be used for adding, changing and removing the attribute.
*
* @param styles An array containing available image style options.
* @returns A model-to-view attribute converter.
* @internal
*/ function $7c22895ca0418c15$export$c69a80ba892f592d(styles) {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const newStyle = $7c22895ca0418c15$var$getStyleDefinitionByName(data.attributeNewValue, styles);
        const oldStyle = $7c22895ca0418c15$var$getStyleDefinitionByName(data.attributeOldValue, styles);
        const viewElement = conversionApi.mapper.toViewElement(data.item);
        const viewWriter = conversionApi.writer;
        if (oldStyle) viewWriter.removeClass(oldStyle.className, viewElement);
        if (newStyle) viewWriter.addClass(newStyle.className, viewElement);
    };
}
/**
* Returns a view-to-model converter converting image CSS classes to a proper value in the model.
*
* @param styles Image style options for which the converter is created.
* @returns A view-to-model converter.
* @internal
*/ function $7c22895ca0418c15$export$8bd32cc400a9da68(styles) {
    const nonDefaultStyles = {
        imageInline: styles.filter((style)=>!style.isDefault && style.modelElements.includes("imageInline")),
        imageBlock: styles.filter((style)=>!style.isDefault && style.modelElements.includes("imageBlock"))
    };
    return (evt, data, conversionApi)=>{
        if (!data.modelRange) return;
        const viewElement = data.viewItem;
        const modelImageElement = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(data.modelRange.getItems());
        if (!modelImageElement) return;
        if (!conversionApi.schema.checkAttribute(modelImageElement, "imageStyle")) return;
        for (const style of nonDefaultStyles[modelImageElement.name])if (conversionApi.consumable.consume(viewElement, {
            classes: style.className
        })) conversionApi.writer.setAttribute("imageStyle", style.name, modelImageElement);
        $7c22895ca0418c15$var$normalizeFloatToDefinitionStyle(conversionApi, viewElement, modelImageElement, styles);
    };
}
/**
* A helper function that attempts to convert the `float` CSS style into a corresponding `imageStyle` attribute.
*
* It maps `float: left` and `float: right` to standard alignment styles (e.g. `'alignLeft'`, `'alignRight'`),
* but only if the target style definition matches one of the {@link module:image/image/utils~DEFAULT_OPTIONS default options}.
*/ function $7c22895ca0418c15$var$normalizeFloatToDefinitionStyle(conversionApi, viewElement, modelElement, styles) {
    if (!conversionApi.consumable.test(viewElement, {
        styles: [
            "float"
        ]
    })) return;
    let floatStyleName = null;
    switch(viewElement.getStyle("float")){
        case "left":
            floatStyleName = "alignLeft";
            break;
        case "right":
            floatStyleName = "alignRight";
    }
    if (!floatStyleName) return;
    const definition = $7c22895ca0418c15$var$getStyleDefinitionByName(floatStyleName, styles);
    if (!definition) return;
    const builtinDefinition = $7c22895ca0418c15$export$39b11f1480c4d21b[definition.name];
    if (!(0, $a48d2f3392454588$export$248d38f6296296c5)(definition, builtinDefinition)) return;
    conversionApi.writer.setAttribute("imageStyle", floatStyleName, modelElement);
    conversionApi.consumable.consume(viewElement, {
        styles: [
            "float"
        ]
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagestyle/imagestyleediting
*/ /**
* The image style engine plugin. It sets the default configuration, creates converters and registers
* {@link module:image/imagestyle/imagestylecommand~ImageStyleCommand ImageStyleCommand}.
*/ var $7c22895ca0418c15$export$99ecff162e62689 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageStyleEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* It contains a list of the normalized and validated style options.
	*
	* * Each option contains a complete icon markup.
	* * The style options not supported by any of the loaded image editing plugins (
	* {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`} or
	* {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`}) are filtered out.
	*
	* @internal
	* @readonly
	*/ normalizedStyles;
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const isBlockPluginLoaded = editor.plugins.has("ImageBlockEditing");
        const isInlinePluginLoaded = editor.plugins.has("ImageInlineEditing");
        editor.config.define("image.styles", $7c22895ca0418c15$export$47fd453fdf2ace8d.getDefaultStylesConfiguration(isBlockPluginLoaded, isInlinePluginLoaded));
        this.normalizedStyles = $7c22895ca0418c15$export$47fd453fdf2ace8d.normalizeStyles({
            configuredStyles: editor.config.get("image.styles"),
            isBlockPluginLoaded: isBlockPluginLoaded,
            isInlinePluginLoaded: isInlinePluginLoaded
        });
        this._setupConversion(isBlockPluginLoaded, isInlinePluginLoaded);
        this._setupPostFixer();
        editor.commands.add("imageStyle", new $7c22895ca0418c15$export$76bfc4aaa447ab01(editor, this.normalizedStyles));
    }
    /**
	* Sets the editor conversion taking the presence of
	* {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`}
	* and {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`} plugins into consideration.
	*/ _setupConversion(isBlockPluginLoaded, isInlinePluginLoaded) {
        const editor = this.editor;
        const schema = editor.model.schema;
        const modelToViewConverter = $7c22895ca0418c15$export$c69a80ba892f592d(this.normalizedStyles);
        const viewToModelConverter = $7c22895ca0418c15$export$8bd32cc400a9da68(this.normalizedStyles);
        editor.editing.downcastDispatcher.on("attribute:imageStyle", modelToViewConverter);
        editor.data.downcastDispatcher.on("attribute:imageStyle", modelToViewConverter);
        if (isBlockPluginLoaded) {
            schema.extend("imageBlock", {
                allowAttributes: "imageStyle"
            });
            schema.setAttributeProperties("imageStyle", {
                isFormatting: true,
                blockAlignment: $7c22895ca0418c15$var$getBlockAlignmentAttributeProperty(this.normalizedStyles)
            });
            editor.data.upcastDispatcher.on("element:figure", viewToModelConverter, {
                priority: "low"
            });
        }
        if (isInlinePluginLoaded) {
            schema.extend("imageInline", {
                allowAttributes: "imageStyle"
            });
            schema.setAttributeProperties("imageStyle", {
                isFormatting: true
            });
            editor.data.upcastDispatcher.on("element:img", viewToModelConverter, {
                priority: "low"
            });
        }
    }
    /**
	* Registers a post-fixer that will make sure that the style attribute value is correct for a specific image type (block vs inline).
	*/ _setupPostFixer() {
        const editor = this.editor;
        const document = editor.model.document;
        const imageUtils = editor.plugins.get($7c22895ca0418c15$export$698882cf06df44aa);
        const stylesMap = new Map(this.normalizedStyles.map((style)=>[
                style.name,
                style
            ]));
        document.registerPostFixer((writer)=>{
            let changed = false;
            for (const change of document.differ.getChanges())if (change.type == "insert" || change.type == "attribute" && change.attributeKey == "imageStyle") {
                let element = change.type == "insert" ? change.position.nodeAfter : change.range.start.nodeAfter;
                if (element && element.is("element", "paragraph") && element.childCount > 0) element = element.getChild(0);
                if (!imageUtils.isImage(element)) continue;
                const imageStyle = element.getAttribute("imageStyle");
                if (!imageStyle) continue;
                const imageStyleDefinition = stylesMap.get(imageStyle);
                if (!imageStyleDefinition || !imageStyleDefinition.modelElements.includes(element.name)) {
                    writer.removeAttribute("imageStyle", element);
                    changed = true;
                }
            }
            return changed;
        });
    }
};
/**
* Returns a mapping of generic alignment values ('left', 'right', 'center') to their corresponding
* block image alignment style names.
*
* This function is particularly useful for scenarios like `td[align]` conversion, which needs to know
* exactly how to map a generic `align` attribute to the correct alignment value. This mapping is necessary
* because the actual alignment value can differ depending on the target element type (e.g., block images
* vs. tables).
*
* @param styles An array of available image style option definitions.
* @returns A record mapping basic alignments to their valid, block-specific style names.
*/ function $7c22895ca0418c15$var$getBlockAlignmentAttributeProperty(styles) {
    const pickFirstSupported = (...names)=>{
        const found = names.map((name)=>$7c22895ca0418c15$var$getStyleDefinitionByName(name, styles)).find((definition)=>definition?.modelElements.includes("imageBlock"));
        if (!found) return;
        return {
            isDefault: !!found.isDefault,
            value: found.name
        };
    };
    return Object.fromEntries(Object.entries({
        left: [
            "alignBlockLeft",
            "alignLeft"
        ],
        right: [
            "alignBlockRight",
            "alignRight"
        ],
        center: [
            "block",
            "alignCenter"
        ]
    }).map(([align, names])=>[
            align,
            pickFirstSupported(...names)
        ]).filter(([, resolved])=>resolved !== void 0));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagestyle/imagestyleui
*/ /**
* The image style UI plugin.
*
* It registers buttons corresponding to the {@link module:image/imageconfig~ImageConfig#styles} configuration.
* It also registers the {@link module:image/imagestyle/utils#DEFAULT_DROPDOWN_DEFINITIONS default drop-downs} and the
* custom drop-downs defined by the developer in the {@link module:image/imageconfig~ImageConfig#toolbar} configuration.
*/ var $7c22895ca0418c15$export$e64327a749bab1f9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$99ecff162e62689
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageStyleUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Returns the default localized style titles provided by the plugin.
	*
	* The following localized titles corresponding with
	* {@link module:image/imagestyle/utils#DEFAULT_OPTIONS} are available:
	*
	* * `'Wrap text'`,
	* * `'Break text'`,
	* * `'In line'`,
	* * `'Full size image'`,
	* * `'Side image'`,
	* * `'Left aligned image'`,
	* * `'Centered image'`,
	* * `'Right aligned image'`
	*/ get localizedDefaultStylesTitles() {
        const t = this.editor.t;
        return {
            "Wrap text": t("Wrap text"),
            "Break text": t("Break text"),
            "In line": t("In line"),
            "Full size image": t("Full size image"),
            "Side image": t("Side image"),
            "Left aligned image": t("Left aligned image"),
            "Centered image": t("Centered image"),
            "Right aligned image": t("Right aligned image")
        };
    }
    /**
	* @inheritDoc
	*/ init() {
        const plugins = this.editor.plugins;
        const toolbarConfig = this.editor.config.get("image.toolbar") || [];
        const definedStyles = $7c22895ca0418c15$var$translateStyles(plugins.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
        for (const styleConfig of definedStyles)this._createButton(styleConfig);
        const definedDropdowns = $7c22895ca0418c15$var$translateStyles([
            ...toolbarConfig.filter((0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)),
            ...$7c22895ca0418c15$export$47fd453fdf2ace8d.getDefaultDropdownDefinitions(plugins)
        ], this.localizedDefaultStylesTitles);
        for (const dropdownConfig of definedDropdowns)this._createDropdown(dropdownConfig, definedStyles);
    }
    /**
	* Creates a dropdown and stores it in the editor {@link module:ui/componentfactory~ComponentFactory}.
	*/ _createDropdown(dropdownConfig, definedStyles) {
        const factory = this.editor.ui.componentFactory;
        factory.add(dropdownConfig.name, (locale)=>{
            let defaultButton;
            const { defaultItem: defaultItem, items: items, title: title } = dropdownConfig;
            const buttonViews = items.filter((itemName)=>definedStyles.find(({ name: name })=>$7c22895ca0418c15$var$getUIComponentName(name) === itemName)).map((buttonName)=>{
                const button = factory.create(buttonName);
                if (buttonName === defaultItem) defaultButton = button;
                return button;
            });
            if (items.length !== buttonViews.length) $7c22895ca0418c15$export$47fd453fdf2ace8d.warnInvalidStyle({
                dropdown: dropdownConfig
            });
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
            const splitButtonView = dropdownView.buttonView;
            const splitButtonViewArrow = splitButtonView.arrowView;
            (0, $29fd27cb9bdab9d2$export$c39319333c19bdd7)(dropdownView, buttonViews, {
                enableActiveItemFocusOnDropdownOpen: true
            });
            splitButtonView.set({
                label: $7c22895ca0418c15$var$getDropdownButtonTitle(title, defaultButton.label),
                class: null,
                tooltip: true
            });
            splitButtonViewArrow.unbind("label");
            splitButtonViewArrow.set({
                label: title
            });
            splitButtonView.bind("icon").toMany(buttonViews, "isOn", (...areOn)=>{
                const index = areOn.findIndex((0, $acd02b7d9a3a0986$export$f0954fd7d5368655));
                return index < 0 ? defaultButton.icon : buttonViews[index].icon;
            });
            splitButtonView.bind("label").toMany(buttonViews, "isOn", (...areOn)=>{
                const index = areOn.findIndex((0, $acd02b7d9a3a0986$export$f0954fd7d5368655));
                return $7c22895ca0418c15$var$getDropdownButtonTitle(title, index < 0 ? defaultButton.label : buttonViews[index].label);
            });
            splitButtonView.bind("isOn").toMany(buttonViews, "isOn", (...areOn)=>areOn.some((0, $acd02b7d9a3a0986$export$f0954fd7d5368655)));
            splitButtonView.bind("class").toMany(buttonViews, "isOn", (...areOn)=>areOn.some((0, $acd02b7d9a3a0986$export$f0954fd7d5368655)) ? "ck-splitbutton_flatten" : void 0);
            splitButtonView.on("execute", ()=>{
                if (!buttonViews.some(({ isOn: isOn })=>isOn)) defaultButton.fire("execute");
                else dropdownView.isOpen = !dropdownView.isOpen;
            });
            dropdownView.bind("isEnabled").toMany(buttonViews, "isEnabled", (...areEnabled)=>areEnabled.some((0, $acd02b7d9a3a0986$export$f0954fd7d5368655)));
            this.listenTo(dropdownView, "execute", ()=>{
                this.editor.editing.view.focus();
            });
            return dropdownView;
        });
    }
    /**
	* Creates a button and stores it in the editor {@link module:ui/componentfactory~ComponentFactory}.
	*/ _createButton(buttonConfig) {
        const buttonName = buttonConfig.name;
        this.editor.ui.componentFactory.add($7c22895ca0418c15$var$getUIComponentName(buttonName), (locale)=>{
            const editor = this.editor;
            const command = editor.commands.get("imageStyle");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                label: buttonConfig.title,
                icon: buttonConfig.icon,
                tooltip: true,
                isToggleable: true
            });
            const reactiveSources = [
                command
            ];
            const imageTypeBlock = editor.commands.get("imageTypeBlock");
            const imageTypeInline = editor.commands.get("imageTypeInline");
            if (imageTypeBlock) reactiveSources.push(imageTypeBlock);
            if (imageTypeInline) reactiveSources.push(imageTypeInline);
            view.bind("isEnabled").toMany(reactiveSources, "isEnabled", ()=>command.isStyleEnabled(buttonName));
            view.bind("isOn").to(command, "value", (value)=>value === buttonName);
            view.on("execute", this._executeCommand.bind(this, buttonName));
            return view;
        });
    }
    _executeCommand(name) {
        this.editor.execute("imageStyle", {
            value: name
        });
        this.editor.editing.view.focus();
    }
};
/**
* Returns the translated `title` from the passed styles array.
*/ function $7c22895ca0418c15$var$translateStyles(styles, titles) {
    for (const style of styles)if (titles[style.title]) style.title = titles[style.title];
    return styles;
}
/**
* Returns the image style component name with the "imageStyle:" prefix.
*/ function $7c22895ca0418c15$var$getUIComponentName(name) {
    return `imageStyle:${name}`;
}
/**
* Returns title for the splitbutton containing the dropdown title and default action item title.
*/ function $7c22895ca0418c15$var$getDropdownButtonTitle(dropdownTitle, buttonTitle) {
    return (dropdownTitle ? dropdownTitle + ": " : "") + buttonTitle;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagestyle
*/ /**
* The image style plugin.
*
* For a detailed overview of the image styles feature, check the {@glink features/images/images-styles documentation}.
*
* This is a "glue" plugin which loads the following plugins:
* * {@link module:image/imagestyle/imagestyleediting~ImageStyleEditing},
* * {@link module:image/imagestyle/imagestyleui~ImageStyleUI}
*
* It provides a default configuration, which can be extended or overwritten.
* Read more about the {@link module:image/imageconfig~ImageConfig#styles image styles configuration}.
*/ var $7c22895ca0418c15$export$ba2c579b6e9f00f2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$99ecff162e62689,
            $7c22895ca0418c15$export$e64327a749bab1f9
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageStyle";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/imagetoolbar
*/ /**
* The image toolbar plugin. It creates and manages the image toolbar (the toolbar displayed when an image is selected).
*
* For an overview, check the {@glink features/images/images-overview#image-contextual-toolbar image contextual toolbar} documentation.
*
* Instances of toolbar components (e.g. buttons) are created using the editor's
* {@link module:ui/componentfactory~ComponentFactory component factory}
* based on the {@link module:image/imageconfig~ImageConfig#toolbar `image.toolbar` configuration option}.
*
* The toolbar uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon}.
*/ var $7c22895ca0418c15$export$10f56897f0313dc5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $5547ab21e02f1e9e$export$c46c0a800280391d),
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const t = editor.t;
        const widgetToolbarRepository = editor.plugins.get((0, $5547ab21e02f1e9e$export$c46c0a800280391d));
        const imageUtils = editor.plugins.get("ImageUtils");
        widgetToolbarRepository.register("image", {
            ariaLabel: t("Image toolbar"),
            items: $7c22895ca0418c15$var$normalizeDeclarativeConfig(editor.config.get("image.toolbar") || []),
            getRelatedElement: (selection)=>imageUtils.getClosestSelectedImageWidget(selection)
        });
    }
};
/**
* Convert the dropdown definitions to their keys registered in the ComponentFactory.
* The registration precess should be handled by the plugin which handles the UI of a particular feature.
*/ function $7c22895ca0418c15$var$normalizeDeclarativeConfig(config) {
    return config.map((item)=>(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(item) ? item.name : item);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module image/pictureediting
*/ /**
* This plugin enables the [`<picture>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/picture) element support in the editor.
*
* * It enables the `sources` model attribute on `imageBlock` and `imageInline` model elements
* (brought by {@link module:image/imageblock~ImageBlock} and {@link module:image/imageinline~ImageInline}, respectively).
* * It translates the `sources` model element to the view (also: data) structure that may look as follows:
*
* ```html
* <p>Inline image using picture:
* 	<picture>
* 		<source media="(min-width: 800px)" srcset="image-large.webp" type="image/webp">
* 		<source media="(max-width: 800px)" srcset="image-small.webp" type="image/webp">
* 		<!-- Other sources as specified in the "sources" model attribute... -->
* 		<img src="image.png" alt="An image using picture" />
* 	</picture>
* </p>
*
* <p>Block image using picture:</p>
* <figure class="image">
* 	<picture>
* 		<source media="(min-width: 800px)" srcset="image-large.webp" type="image/webp">
* 		<source media="(max-width: 800px)" srcset="image-small.webp" type="image/webp">
* 		<!-- Other sources as specified in the "sources" model attribute... -->
* 		<img src="image.png" alt="An image using picture" />
* 	</picture>
* 	<figcaption>Caption of the image</figcaption>
* </figure>
* ```
*
* **Note:** The value of the `sources` {@glink framework/architecture/editing-engine#changing-the-model model attribute}
* in both examples equals:
*
* ```css
* [
* 	{
* 		media: '(min-width: 800px)',
* 		srcset: 'image-large.webp',
* 		type: 'image/webp'
* 	},
* 	{
* 		media: '(max-width: 800px)',
* 		srcset: 'image-small.webp',
* 		type: 'image/webp'
* 	}
* ]
* ```
*
* * It integrates with the {@link module:image/imageupload~ImageUpload} plugin so images uploaded in the editor
* automatically render using `<picture>` if the {@glink features/images/image-upload/image-upload upload adapter}
* supports image sources and provides neccessary data.
*
* @private
*/ var $7c22895ca0418c15$export$ee5c7d7da5e0c82f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $7c22895ca0418c15$export$2cb8e8efa7161979,
            $7c22895ca0418c15$export$698882cf06df44aa
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PictureEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        if (editor.plugins.has("ImageBlockEditing")) editor.model.schema.extend("imageBlock", {
            allowAttributes: [
                "sources"
            ]
        });
        if (editor.plugins.has("ImageInlineEditing")) editor.model.schema.extend("imageInline", {
            allowAttributes: [
                "sources"
            ]
        });
        this._setupConversion();
        this._setupImageUploadEditingIntegration();
    }
    /**
	* Configures conversion pipelines to support upcasting and downcasting images using the `<picture>` view element
	* and the model `sources` attribute.
	*/ _setupConversion() {
        const editor = this.editor;
        const conversion = editor.conversion;
        const imageUtils = editor.plugins.get("ImageUtils");
        conversion.for("upcast").add($7c22895ca0418c15$export$2731255a52770d78(imageUtils));
        conversion.for("downcast").add($7c22895ca0418c15$export$f901a8a9475c3a60(imageUtils));
    }
    /**
	* Makes it possible for uploaded images to get the `sources` model attribute and the `<picture>...</picture>`
	* view structure out-of-the-box if relevant data is provided along the
	* {@link module:image/imageupload/imageuploadediting~ImageUploadEditing#event:uploadComplete} event.
	*/ _setupImageUploadEditingIntegration() {
        const editor = this.editor;
        if (!editor.plugins.has("ImageUploadEditing")) return;
        const imageUploadEditing = editor.plugins.get("ImageUploadEditing");
        this.listenTo(imageUploadEditing, "uploadComplete", (evt, { imageElement: imageElement, data: data })=>{
            const sources = data.sources;
            if (!sources) return;
            editor.model.change((writer)=>{
                writer.setAttributes({
                    sources: sources
                }, imageElement);
            });
        });
    }
};


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/utils/automaticdecorators
*/ /**
* Helper class that ties together all {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition} and provides
* the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement downcast dispatchers} for them.
*/ var $8fb2b7bcf5f9e330$export$f36a59e654373cb4 = class {
    /**
	* Stores the definition of {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition automatic decorators}.
	* This data is used as a source for a downcast dispatcher to create a proper conversion to output data.
	*/ _definitions = /* @__PURE__ */ new Set();
    /**
	* A callback that checks if a decorator can be applied to a given element.
	* Returns `true` if there is a conflict preventing the decorator from being applied.
	*/ _conflictChecker;
    /**
	* Gives information about the number of decorators stored in the {@link module:link/utils/automaticdecorators~AutomaticLinkDecorators}
	* instance.
	*/ get length() {
        return this._definitions.size;
    }
    /**
	* Sets a callback that checks if a decorator can be applied to a given element.
	*
	* @param checker A function that returns `true` if there is a conflict preventing the decorator from being applied.
	*/ setConflictChecker(checker) {
        this._conflictChecker = checker;
    }
    /**
	* Adds automatic decorator objects or an array with them to be used during downcasting.
	*
	* @param item A configuration object of automatic rules for decorating links. It might also be an array of such objects.
	*/ add(item) {
        if (Array.isArray(item)) item.forEach((item)=>this._definitions.add(item));
        else this._definitions.add(item);
    }
    /**
	* Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method.
	*
	* @returns A dispatcher function used as conversion helper in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
	*/ getDispatcher() {
        return (dispatcher)=>{
            const elementCreator = (item, viewWriter)=>{
                const viewElement = viewWriter.createAttributeElement("a", item.attributes, {
                    priority: 5
                });
                if (item.classes) viewWriter.addClass(item.classes, viewElement);
                for(const key in item.styles)viewWriter.setStyle(key, item.styles[key], viewElement);
                viewWriter.setCustomProperty("link", true, viewElement);
                return viewElement;
            };
            const createConverter = (isApplyingConverter)=>{
                return (evt, data, conversionApi)=>{
                    if (!data.attributeKey.startsWith("link")) return;
                    if (data.attributeKey == "linkHref" && !conversionApi.consumable.test(data.item, "attribute:linkHref")) return;
                    if (!data.item.is("selection") && !conversionApi.schema.isInline(data.item)) return;
                    for (const decorator of this._definitions)if (decorator.callback(data.item.getAttribute("linkHref")) && !this._conflictChecker?.(decorator, data.item) && isApplyingConverter) {
                        if (data.item.is("selection")) conversionApi.writer.wrap(conversionApi.writer.document.selection.getFirstRange(), elementCreator(decorator, conversionApi.writer));
                        else conversionApi.writer.wrap(conversionApi.mapper.toViewRange(data.range), elementCreator(decorator, conversionApi.writer));
                    } else conversionApi.writer.unwrap(conversionApi.mapper.toViewRange(data.range), elementCreator(decorator, conversionApi.writer));
                };
            };
            dispatcher.on("attribute", createConverter(false), {
                priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 1
            });
            dispatcher.on("attribute", createConverter(true), {
                priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 2
            });
        };
    }
    /**
	* Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method
	* when linking images.
	*
	* @returns A dispatcher function used as conversion helper in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
	*/ getDispatcherForLinkedImage() {
        return (dispatcher)=>{
            const createConverter = (isApplyingConverter)=>{
                return (evt, data, { writer: writer, mapper: mapper })=>{
                    if (!data.item.is("element", "imageBlock") || !data.attributeKey.startsWith("link")) return;
                    const viewFigure = mapper.toViewElement(data.item);
                    const linkInImage = Array.from(viewFigure.getChildren()).find((child)=>child.is("element", "a"));
                    if (!linkInImage) return;
                    for (const decorator of this._definitions){
                        const attributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(decorator.attributes);
                        if (decorator.callback(data.item.getAttribute("linkHref")) && !this._conflictChecker?.(decorator, data.item) && isApplyingConverter) {
                            for (const [key, val] of attributes)if (key === "class") writer.addClass(val, linkInImage);
                            else writer.setAttribute(key, val, false, linkInImage);
                            if (decorator.classes) writer.addClass(decorator.classes, linkInImage);
                            for(const key in decorator.styles)writer.setStyle(key, decorator.styles[key], linkInImage);
                        } else {
                            for (const [key, val] of attributes)if (key === "class") writer.removeClass(val, linkInImage);
                            else writer.removeAttribute(key, val, linkInImage);
                            if (decorator.classes) writer.removeClass(decorator.classes, linkInImage);
                            for(const key in decorator.styles)writer.removeStyle(key, linkInImage);
                        }
                    }
                };
            };
            dispatcher.on("attribute", createConverter(false), {
                priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 1
            });
            dispatcher.on("attribute", createConverter(true), {
                priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 2
            });
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $8fb2b7bcf5f9e330$var$ATTRIBUTE_WHITESPACES = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
const $8fb2b7bcf5f9e330$var$SAFE_URL_TEMPLATE = "^(?:(?:<protocols>):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))";
const $8fb2b7bcf5f9e330$var$EMAIL_REG_EXP = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i;
const $8fb2b7bcf5f9e330$var$PROTOCOL_REG_EXP = /^((\w+:(\/{2,})?)|(\W))/i;
const $8fb2b7bcf5f9e330$var$DEFAULT_LINK_PROTOCOLS = [
    "https?",
    "ftps?",
    "mailto"
];
/**
* A keystroke used by the {@link module:link/linkui~LinkUI link UI feature}.
*/ const $8fb2b7bcf5f9e330$export$1dbe65c3c53297ae = "Ctrl+K";
/**
* Returns `true` if a given view node is the link element.
*/ function $8fb2b7bcf5f9e330$export$a8faa48da8fdb1ce(node) {
    return node.is("attributeElement") && !!node.getCustomProperty("link");
}
/**
* Creates a link {@link module:engine/view/attributeelement~ViewAttributeElement} with the provided `href` attribute.
*/ function $8fb2b7bcf5f9e330$export$7bdf5fe7039d8570(href, { writer: writer }) {
    const linkElement = writer.createAttributeElement("a", {
        href: href
    }, {
        priority: 5
    });
    writer.setCustomProperty("link", true, linkElement);
    return linkElement;
}
/**
* Returns a safe URL based on a given value.
*
* A URL is considered safe if it is safe for the user (does not contain any malicious code).
*
* If a URL is considered unsafe, a simple `"#"` is returned.
*
* @internal
*/ function $8fb2b7bcf5f9e330$export$633294874bd755f8(url, allowedProtocols = $8fb2b7bcf5f9e330$var$DEFAULT_LINK_PROTOCOLS) {
    const urlString = String(url);
    const protocolsList = allowedProtocols.join("|");
    return $8fb2b7bcf5f9e330$var$isSafeUrl(urlString, new RegExp(`${$8fb2b7bcf5f9e330$var$SAFE_URL_TEMPLATE.replace("<protocols>", protocolsList)}`, "i")) ? urlString : "#";
}
/**
* Checks whether the given URL is safe for the user (does not contain any malicious code).
*/ function $8fb2b7bcf5f9e330$var$isSafeUrl(url, customRegexp) {
    return !!url.replace($8fb2b7bcf5f9e330$var$ATTRIBUTE_WHITESPACES, "").match(customRegexp);
}
/**
* Returns the {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`} configuration processed
* to respect the locale of the editor, i.e. to display the {@link module:link/linkconfig~LinkDecoratorManualDefinition label}
* in the correct language.
*
* **Note**: Only the few most commonly used labels are translated automatically. Other labels should be manually
* translated in the {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`} configuration.
*
* @param t Shorthand for {@link module:utils/locale~Locale#t Locale#t}.
* @param decorators The decorator reference where the label values should be localized.
* @internal
*/ function $8fb2b7bcf5f9e330$export$c40c7b7bf773469a(t, decorators) {
    const localizedDecoratorsLabels = {
        "Open in a new tab": t("Open in a new tab"),
        "Downloadable": t("Downloadable")
    };
    decorators.forEach((decorator)=>{
        if ("label" in decorator && localizedDecoratorsLabels[decorator.label]) decorator.label = localizedDecoratorsLabels[decorator.label];
        return decorator;
    });
    return decorators;
}
/**
* Converts an object with defined decorators to a normalized array of decorators. The `id` key is added for each decorator and
* is used as the attribute's name in the model.
*
* @internal
*/ function $8fb2b7bcf5f9e330$export$84599613e97699a4(decorators) {
    const retArray = [];
    if (decorators) for (const [key, value] of Object.entries(decorators)){
        const decorator = Object.assign({}, value, {
            id: `link${(0, $b526c7ea7ac79ca6$export$3061f22cd819074d)(key)}`
        });
        retArray.push(decorator);
    }
    return retArray;
}
/**
* Returns `true` if the specified `element` can be linked (the element allows the `linkHref` attribute).
*/ function $8fb2b7bcf5f9e330$export$efb0511802bf7c14(element, schema) {
    if (!element) return false;
    return schema.checkAttribute(element.name, "linkHref");
}
/**
* Returns `true` if the specified `value` is an email.
*
* @internal
*/ function $8fb2b7bcf5f9e330$export$ba6a1691605eae8e(value) {
    return $8fb2b7bcf5f9e330$var$EMAIL_REG_EXP.test(value);
}
/**
* Adds the protocol prefix to the specified `link` when:
*
* * it does not contain it already, and there is a {@link module:link/linkconfig~LinkConfig#defaultProtocol `defaultProtocol` }
* configuration value provided,
* * or the link is an email address.
*/ function $8fb2b7bcf5f9e330$export$18bb33376634e28b(link, defaultProtocol) {
    const protocol = $8fb2b7bcf5f9e330$export$ba6a1691605eae8e(link) ? "mailto:" : defaultProtocol;
    const isProtocolNeeded = !!protocol && !$8fb2b7bcf5f9e330$export$5d6cb5719fe25096(link);
    return link && isProtocolNeeded ? protocol + link : link;
}
/**
* Checks if protocol is already included in the link.
*
* @internal
*/ function $8fb2b7bcf5f9e330$export$5d6cb5719fe25096(link) {
    return $8fb2b7bcf5f9e330$var$PROTOCOL_REG_EXP.test(link);
}
/**
* Opens the link in a new browser tab.
*/ function $8fb2b7bcf5f9e330$export$a625f03606271415(link) {
    window.open(link, "_blank", "noopener");
}
/**
* Returns a text of a link range.
*
* If the returned value is `undefined`, the range contains elements other than text nodes.
*/ function $8fb2b7bcf5f9e330$export$fe7def88017c1dfc(range) {
    let text = "";
    for (const item of range.getItems()){
        if (!item.is("$text") && !item.is("$textProxy")) return;
        text += item.data;
    }
    return text;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/utils/conflictingdecorators
*/ /**
* Checks if two decorators conflict with each other.
*
* Decorators conflict when they share the same HTML attribute names (excluding mergeable attributes)
* or style properties.
*
* @internal
* @param a The first decorator.
* @param b The second decorator.
*/ function $8fb2b7bcf5f9e330$var$areDecoratorsConflicting(a, b) {
    if (a.attributes && b.attributes) {
        if (Object.keys(a.attributes).some((key)=>!isMergeableAttribute(key) && key in b.attributes)) return true;
    }
    if (a.styles && b.styles) {
        if (Object.keys(a.styles).some((key)=>key in b.styles)) return true;
    }
    return false;
    function isMergeableAttribute(key) {
        return key === "class" || key === "style" || key === "rel";
    }
}
/**
* Resolves conflicting manual decorators by automatically disabling decorators that share
* the same HTML attributes with newly enabled decorators.
*
* @internal
* @param options Configuration object.
* @param options.decoratorStates Initial decorator states.
* @param options.allDecorators Collection of all manual decorators.
* @returns Updated decorator states with conflicts resolved.
*/ function $8fb2b7bcf5f9e330$var$resolveConflictingDecorators({ decoratorStates: decoratorStates, allDecorators: allDecorators }) {
    const resolved = {
        ...decoratorStates
    };
    for(const name in decoratorStates)if (decoratorStates[name] && isNewlyAddedDecorator(name)) {
        const conflicts = $8fb2b7bcf5f9e330$var$getConflictingManualDecorators(name, allDecorators);
        for (const conflict of conflicts)resolved[conflict] = false;
    }
    function isNewlyAddedDecorator(name) {
        return allDecorators.some((item)=>item.id === name && !item.value);
    }
    return resolved;
}
/**
* Returns array of decorator names that conflict with the given decorator.
* Decorators conflict when they share the same HTML attribute names or style properties.
*
* @param decoratorId The id/name of the manual decorator to check for conflicts.
* @param manualDecorators Collection of all manual decorators.
* @returns Array of conflicting decorator names.
*/ function $8fb2b7bcf5f9e330$var$getConflictingManualDecorators(decoratorId, manualDecorators) {
    const decorator = manualDecorators.find((item)=>item.id === decoratorId);
    /* istanbul ignore next -- @preserve */ if (!decorator) return [];
    return manualDecorators.filter((otherDecorator)=>otherDecorator.id !== decoratorId && $8fb2b7bcf5f9e330$var$areDecoratorsConflicting(decorator, otherDecorator)).map((item)=>item.id);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkcommand
*/ /**
* The link command. It is used by the {@link module:link/link~Link link feature}.
*/ var $8fb2b7bcf5f9e330$export$716db6c6fd6cbe7b = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A collection of {@link module:link/utils/manualdecorator~LinkManualDecorator manual decorators}
	* corresponding to the {@link module:link/linkconfig~LinkConfig#decorators decorator configuration}.
	*
	* You can consider it a model with states of manual decorators added to the currently selected link.
	*/ manualDecorators = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    /**
	* An instance of the helper that ties together all {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition}
	* that are used by the {@glink features/link link} and the {@glink features/images/images-linking linking images} features.
	*/ automaticDecorators = new $8fb2b7bcf5f9e330$export$f36a59e654373cb4();
    /**
	* Synchronizes the state of {@link #manualDecorators} with the currently present elements in the model.
	*/ restoreManualDecoratorStates() {
        for (const manualDecorator of this.manualDecorators)manualDecorator.value = this._getDecoratorStateFromModel(manualDecorator.id);
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedElement = selection.getSelectedElement() || (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if ($8fb2b7bcf5f9e330$export$efb0511802bf7c14(selectedElement, model.schema)) {
            this.value = selectedElement.getAttribute("linkHref");
            this.isEnabled = model.schema.checkAttribute(selectedElement, "linkHref");
        } else {
            this.value = selection.getAttribute("linkHref");
            this.isEnabled = model.schema.checkAttributeInSelection(selection, "linkHref");
        }
        for (const manualDecorator of this.manualDecorators)manualDecorator.value = this._getDecoratorStateFromModel(manualDecorator.id);
    }
    /**
	* Executes the command.
	*
	* When the selection is non-collapsed, the `linkHref` attribute will be applied to nodes inside the selection, but only to
	* those nodes where the `linkHref` attribute is allowed (disallowed nodes will be omitted).
	*
	* When the selection is collapsed and is not inside the text with the `linkHref` attribute, a
	* new {@link module:engine/model/text~ModelText text node} with the `linkHref` attribute will be inserted in place of the caret, but
	* only if such element is allowed in this place. The `_data` of the inserted text will equal the `href` parameter.
	* The selection will be updated to wrap the just inserted text node.
	*
	* When the selection is collapsed and inside the text with the `linkHref` attribute, the attribute value will be updated.
	*
	* # Decorators and model attribute management
	*
	* There is an optional argument to this command that applies or removes model
	* {@glink framework/architecture/editing-engine#text-attributes text attributes} brought by
	* {@link module:link/utils/manualdecorator~LinkManualDecorator manual link decorators}.
	*
	* Text attribute names in the model correspond to the entries in the {@link module:link/linkconfig~LinkConfig#decorators
	* configuration}.
	* For every decorator configured, a model text attribute exists with the "link" prefix. For example, a `'linkMyDecorator'` attribute
	* corresponds to `'myDecorator'` in the configuration.
	*
	* To learn more about link decorators, check out the {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`}
	* documentation.
	*
	* Here is how to manage decorator attributes with the link command:
	*
	* ```ts
	* const linkCommand = editor.commands.get( 'link' );
	*
	* // Adding a new decorator attribute.
	* linkCommand.execute( 'http://example.com', {
	* 	linkIsExternal: true
	* } );
	*
	* // Removing a decorator attribute from the selection.
	* linkCommand.execute( 'http://example.com', {
	* 	linkIsExternal: false
	* } );
	*
	* // Adding multiple decorator attributes at the same time.
	* linkCommand.execute( 'http://example.com', {
	* 	linkIsExternal: true,
	* 	linkIsDownloadable: true,
	* } );
	*
	* // Removing and adding decorator attributes at the same time.
	* linkCommand.execute( 'http://example.com', {
	* 	linkIsExternal: false,
	* 	linkFoo: true,
	* 	linkIsDownloadable: false,
	* } );
	* ```
	*
	* **Note**: If the decorator attribute name is not specified, its state remains untouched.
	*
	* **Note**: {@link module:link/unlinkcommand~UnlinkCommand#execute `UnlinkCommand#execute()`} removes all
	* decorator attributes.
	*
	* An optional parameter called `displayedText` is to add or update text of the link that represents the `href`. For example:
	*
	* ```ts
	* const linkCommand = editor.commands.get( 'link' );
	*
	* // Adding a new link with `displayedText` attribute.
	* linkCommand.execute( 'http://example.com', {}, 'Example' );
	* ```
	*
	* The above code will create an anchor like this:
	*
	* ```html
	* <a href="http://example.com">Example</a>
	* ```
	*
	* @fires execute
	* @param href Link destination.
	* @param manualDecoratorIds The information about manual decorator attributes to be applied or removed upon execution.
	* @param displayedText Text of the link.
	*/ execute(href, manualDecoratorIds = {}, displayedText) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const resolvedDecoratorsIds = $8fb2b7bcf5f9e330$var$resolveConflictingDecorators({
            allDecorators: Array.from(this.manualDecorators),
            decoratorStates: manualDecoratorIds
        });
        const truthyManualDecorators = [];
        const falsyManualDecorators = [];
        for(const name in resolvedDecoratorsIds)if (resolvedDecoratorsIds[name]) truthyManualDecorators.push(name);
        else falsyManualDecorators.push(name);
        model.change((writer)=>{
            const updateLinkAttributes = (itemOrRange)=>{
                writer.setAttribute("linkHref", href, itemOrRange);
                truthyManualDecorators.forEach((item)=>writer.setAttribute(item, true, itemOrRange));
                falsyManualDecorators.forEach((item)=>writer.removeAttribute(item, itemOrRange));
            };
            const updateLinkTextIfNeeded = (range, linkHref)=>{
                const linkText = $8fb2b7bcf5f9e330$export$fe7def88017c1dfc(range);
                if (!linkText) return range;
                let newText = displayedText;
                if (!newText) newText = linkHref && linkHref == linkText ? href : linkText;
                if (newText != linkText) {
                    const fragment = writer.createDocumentFragment();
                    for (const item of range.getItems()){
                        const text = item;
                        writer.append(writer.createText(text.data, text.getAttributes()), fragment);
                    }
                    const fragRange = writer.createRangeIn(fragment);
                    const changes = $8fb2b7bcf5f9e330$var$findChanges(linkText, newText);
                    let insertsLength = 0;
                    for (const { offset: offset, actual: actual, expected: expected } of changes){
                        const updatedOffset = offset + insertsLength;
                        const subRange = writer.createRange(fragRange.start.getShiftedBy(updatedOffset), fragRange.start.getShiftedBy(updatedOffset + actual.length));
                        const attributes = $8fb2b7bcf5f9e330$var$getLinkPartTextNode(subRange, fragRange).getAttributes();
                        const formattingAttributes = Array.from(attributes).filter(([key])=>model.schema.getAttributeProperties(key).isFormatting);
                        const newTextNode = writer.createText(expected, formattingAttributes);
                        updateLinkAttributes(newTextNode);
                        writer.remove(subRange);
                        writer.insert(newTextNode, subRange.start);
                        insertsLength += expected.length;
                    }
                    model.insertContent(fragment, range);
                    return writer.createRange(range.start, range.start.getShiftedBy(newText.length));
                }
            };
            const collapseSelectionAtLinkEnd = (linkRange)=>{
                const { plugins: plugins } = this.editor;
                writer.setSelection(linkRange.end);
                if (plugins.has("TwoStepCaretMovement")) plugins.get("TwoStepCaretMovement")._handleForwardMovement();
                else for (const key of [
                    "linkHref",
                    ...truthyManualDecorators,
                    ...falsyManualDecorators
                ])writer.removeSelectionAttribute(key);
            };
            if (selection.isCollapsed) {
                const position = selection.getFirstPosition();
                if (selection.hasAttribute("linkHref")) {
                    const linkHref = selection.getAttribute("linkHref");
                    const linkRange = (0, $f1defb5a0a139b4c$export$67d698a4bb9f8c2a)(position, "linkHref", linkHref, model);
                    const newLinkRange = updateLinkTextIfNeeded(linkRange, linkHref);
                    updateLinkAttributes(newLinkRange || linkRange);
                    if (newLinkRange) collapseSelectionAtLinkEnd(newLinkRange);
                } else if (href !== "") {
                    const attributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(selection.getAttributes());
                    attributes.set("linkHref", href);
                    truthyManualDecorators.forEach((item)=>{
                        attributes.set(item, true);
                    });
                    collapseSelectionAtLinkEnd(model.insertContent(writer.createText(displayedText || href, attributes), position));
                }
            } else {
                const selectionRanges = Array.from(selection.getRanges());
                const ranges = model.schema.getValidRanges(selectionRanges, "linkHref");
                const allowedRanges = [];
                for (const element of selection.getSelectedBlocks())if (model.schema.checkAttribute(element, "linkHref")) allowedRanges.push(writer.createRangeOn(element));
                const rangesToUpdate = allowedRanges.slice();
                for (const range of ranges)if (this._isRangeToUpdate(range, allowedRanges)) rangesToUpdate.push(range);
                const stickyPseudoRanges = selectionRanges.map((range)=>({
                        start: (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(range.start, "toPrevious"),
                        end: (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(range.end, "toNext")
                    }));
                for (let range of rangesToUpdate){
                    const linkHref = (range.start.textNode || range.start.nodeAfter).getAttribute("linkHref");
                    range = updateLinkTextIfNeeded(range, linkHref) || range;
                    updateLinkAttributes(range);
                }
                writer.setSelection(stickyPseudoRanges.map((pseudoRange)=>{
                    const start = pseudoRange.start.toPosition();
                    const end = pseudoRange.end.toPosition();
                    pseudoRange.start.detach();
                    pseudoRange.end.detach();
                    return model.createRange(start, end);
                }));
            }
        });
        this.restoreManualDecoratorStates();
    }
    /**
	* Provides information whether a decorator with a given name is present in the currently processed selection.
	*
	* @param decoratorName The name of the manual decorator used in the model
	* @returns The information whether a given decorator is currently present in the selection.
	*/ _getDecoratorStateFromModel(decoratorName) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedElement = selection.getSelectedElement();
        if ($8fb2b7bcf5f9e330$export$efb0511802bf7c14(selectedElement, model.schema)) return selectedElement.getAttribute(decoratorName);
        return selection.getAttribute(decoratorName);
    }
    /**
	* Checks whether specified `range` is inside an element that accepts the `linkHref` attribute.
	*
	* @param range A range to check.
	* @param allowedRanges An array of ranges created on elements where the attribute is accepted.
	*/ _isRangeToUpdate(range, allowedRanges) {
        for (const allowedRange of allowedRanges)if (allowedRange.containsRange(range)) return false;
        return true;
    }
};
/**
* Compares two strings and returns an array of changes needed to transform one into another.
* Uses the diff utility to find the differences and groups them into chunks containing information
* about the offset and actual/expected content.
*
* @param oldText The original text to compare.
* @param newText The new text to compare against.
* @returns Array of change objects containing offset and actual/expected content.
*
* @example
* findChanges( 'hello world', 'hi there' );
*
* Returns:
* [
* 	{
* 		"offset": 1,
* 		"actual": "ello",
* 		"expected": "i"
* 	},
* 	{
* 		"offset": 2,
* 		"actual": "wo",
* 		"expected": "the"
* 	},
* 	{
* 		"offset": 3,
* 		"actual": "ld",
* 		"expected": "e"
* 	}
* ]
*/ function $8fb2b7bcf5f9e330$var$findChanges(oldText, newText) {
    const changes = (0, $c7bc2cb7e2db0227$export$a37e3c603d7117e5)(oldText, newText);
    const counter = {
        equal: 0,
        insert: 0,
        delete: 0
    };
    const result = [];
    let actualSlice = "";
    let expectedSlice = "";
    for (const action of [
        ...changes,
        null
    ]){
        if (action == "insert") expectedSlice += newText[counter.equal + counter.insert];
        else if (action == "delete") actualSlice += oldText[counter.equal + counter.delete];
        else if (actualSlice.length || expectedSlice.length) {
            result.push({
                offset: counter.equal,
                actual: actualSlice,
                expected: expectedSlice
            });
            actualSlice = "";
            expectedSlice = "";
        }
        if (action) counter[action]++;
    }
    return result;
}
/**
* Returns text node withing the link range that should be updated.
*
* @param range Partial link range.
* @param linkRange Range of the entire link.
* @returns Text node.
*/ function $8fb2b7bcf5f9e330$var$getLinkPartTextNode(range, linkRange) {
    if (!range.isCollapsed) return (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(range.getItems());
    const position = range.start;
    if (position.textNode) return position.textNode;
    if (!position.nodeBefore || position.isEqual(linkRange.start)) return position.nodeAfter;
    else return position.nodeBefore;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/unlinkcommand
*/ /**
* The unlink command. It is used by the {@link module:link/link~Link link plugin}.
*/ var $8fb2b7bcf5f9e330$export$38087f0d35082d9f = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedElement = selection.getSelectedElement();
        if ($8fb2b7bcf5f9e330$export$efb0511802bf7c14(selectedElement, model.schema)) this.isEnabled = model.schema.checkAttribute(selectedElement, "linkHref");
        else this.isEnabled = model.schema.checkAttributeInSelection(selection, "linkHref");
    }
    /**
	* Executes the command.
	*
	* When the selection is collapsed, it removes the `linkHref` attribute from each node with the same `linkHref` attribute value.
	* When the selection is non-collapsed, it removes the `linkHref` attribute from each node in selected ranges.
	*
	* # Decorators
	*
	* If {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`} is specified,
	* all configured decorators are removed together with the `linkHref` attribute.
	*
	* @fires execute
	*/ execute() {
        const editor = this.editor;
        const model = this.editor.model;
        const selection = model.document.selection;
        const linkCommand = editor.commands.get("link");
        model.change((writer)=>{
            const rangesToUnlink = selection.isCollapsed ? [
                (0, $f1defb5a0a139b4c$export$67d698a4bb9f8c2a)(selection.getFirstPosition(), "linkHref", selection.getAttribute("linkHref"), model)
            ] : model.schema.getValidRanges(selection.getRanges(), "linkHref");
            for (const range of rangesToUnlink){
                writer.removeAttribute("linkHref", range);
                if (linkCommand) for (const manualDecorator of linkCommand.manualDecorators)writer.removeAttribute(manualDecorator.id, range);
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/utils/manualdecorator
*/ const $8fb2b7bcf5f9e330$var$LinkManualDecoratorBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* Helper class that stores manual decorators with observable {@link module:link/utils/manualdecorator~LinkManualDecorator#value}
* to support integration with the UI state. An instance of this class is a model with the state of individual manual decorators.
* These decorators are kept as collections in {@link module:link/linkcommand~LinkCommand#manualDecorators}.
*/ var $8fb2b7bcf5f9e330$export$dcf6126a517c874e = class extends $8fb2b7bcf5f9e330$var$LinkManualDecoratorBase {
    /**
	* An ID of a manual decorator which is the name of the attribute in the model, for example: 'linkManualDecorator0'.
	*/ id;
    /**
	* The default value of manual decorator.
	*/ defaultValue;
    /**
	* The label used in the user interface to toggle the manual decorator.
	*/ label;
    /**
	* A set of attributes added to downcasted data when the decorator is activated for a specific link.
	* Attributes should be added in a form of attributes defined in {@link module:engine/view/elementdefinition~ViewElementDefinition}.
	*/ attributes;
    /**
	* A set of classes added to downcasted data when the decorator is activated for a specific link.
	* Classes should be added in a form of classes defined in {@link module:engine/view/elementdefinition~ViewElementDefinition}.
	*/ classes;
    /**
	* A set of styles added to downcasted data when the decorator is activated for a specific link.
	* Styles should be added in a form of styles defined in {@link module:engine/view/elementdefinition~ViewElementDefinition}.
	*/ styles;
    /**
	* Creates a new instance of {@link module:link/utils/manualdecorator~LinkManualDecorator}.
	*
	* @param options The configuration object.
	*/ constructor({ id: id, label: label, attributes: attributes, classes: classes, styles: styles, defaultValue: defaultValue }){
        super();
        this.id = id;
        this.set("value", void 0);
        this.defaultValue = defaultValue;
        this.label = label;
        this.attributes = attributes;
        this.classes = classes;
        this.styles = styles;
    }
    /**
	* Returns {@link module:engine/view/matcher~MatcherPattern} with decorator attributes.
	*
	* @internal
	*/ _createPattern() {
        return {
            attributes: this.attributes,
            classes: this.classes,
            styles: this.styles
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkediting
*/ const $8fb2b7bcf5f9e330$var$HIGHLIGHT_CLASS = "ck-link_selected";
const $8fb2b7bcf5f9e330$var$DECORATOR_AUTOMATIC = "automatic";
const $8fb2b7bcf5f9e330$var$DECORATOR_MANUAL = "manual";
const $8fb2b7bcf5f9e330$var$EXTERNAL_LINKS_REGEXP = /^(https?:)?\/\//;
/**
* The link engine feature.
*
* It introduces the `linkHref="url"` attribute in the model which renders to the view as a `<a href="url">` element
* as well as `'link'` and `'unlink'` commands.
*/ var $8fb2b7bcf5f9e330$export$8c435103e27cd12e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A list of functions that handles opening links. If any of them returns `true`, the link is considered to be opened.
	*/ _linkOpeners = [];
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f1defb5a0a139b4c$export$b521f49d1c4c3786),
            (0, $f1defb5a0a139b4c$export$f5b8910cec6cf069),
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09)
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("link", {
            allowCreatingEmptyLinks: false,
            addTargetToExternalLinks: false,
            toolbar: [
                "linkPreview",
                "|",
                "editLink",
                "linkProperties",
                "unlink"
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const allowedProtocols = this.editor.config.get("link.allowedProtocols");
        editor.model.schema.extend("$text", {
            allowAttributes: "linkHref"
        });
        editor.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: $8fb2b7bcf5f9e330$export$7bdf5fe7039d8570
        });
        editor.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: (href, conversionApi)=>{
                return $8fb2b7bcf5f9e330$export$7bdf5fe7039d8570($8fb2b7bcf5f9e330$export$633294874bd755f8(href, allowedProtocols), conversionApi);
            }
        });
        editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "a",
                attributes: {
                    href: true
                }
            },
            model: {
                key: "linkHref",
                value: (viewElement)=>viewElement.getAttribute("href")
            }
        });
        editor.commands.add("link", new $8fb2b7bcf5f9e330$export$716db6c6fd6cbe7b(editor));
        editor.commands.add("unlink", new $8fb2b7bcf5f9e330$export$38087f0d35082d9f(editor));
        const linkDecorators = $8fb2b7bcf5f9e330$export$c40c7b7bf773469a(editor.t, $8fb2b7bcf5f9e330$export$84599613e97699a4(editor.config.get("link.decorators")));
        this._enableAutomaticDecorators(linkDecorators.filter((item)=>item.mode === $8fb2b7bcf5f9e330$var$DECORATOR_AUTOMATIC));
        this._enableManualDecorators(linkDecorators.filter((item)=>item.mode === $8fb2b7bcf5f9e330$var$DECORATOR_MANUAL));
        editor.plugins.get((0, $f1defb5a0a139b4c$export$b521f49d1c4c3786)).registerAttribute("linkHref");
        (0, $f1defb5a0a139b4c$export$cec5d5ee2c77a35c)(editor, "linkHref", "a", $8fb2b7bcf5f9e330$var$HIGHLIGHT_CLASS);
        this._enableLinkOpen();
        this._enableSelectionAttributesFixer();
        this._enableClipboardIntegration();
        this._enableDecoratorConflictPostfixer();
    }
    /**
	* Registers a function that opens links in a new browser tab.
	*
	* @param linkOpener The function that opens a link in a new browser tab.
	* @internal
	*/ _registerLinkOpener(linkOpener) {
        this._linkOpeners.push(linkOpener);
    }
    /**
	* Processes an array of configured {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition automatic decorators}
	* and registers a {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast dispatcher}
	* for each one of them. Downcast dispatchers are obtained using the
	* {@link module:link/utils/automaticdecorators~AutomaticLinkDecorators#getDispatcher} method.
	*
	* **Note**: This method also activates the automatic external link decorator if enabled with
	* {@link module:link/linkconfig~LinkConfig#addTargetToExternalLinks `config.link.addTargetToExternalLinks`}.
	*/ _enableAutomaticDecorators(automaticDecoratorDefinitions) {
        const editor = this.editor;
        const command = editor.commands.get("link");
        const automaticDecorators = command.automaticDecorators;
        if (editor.config.get("link.addTargetToExternalLinks")) automaticDecorators.add({
            id: "linkIsExternal",
            mode: $8fb2b7bcf5f9e330$var$DECORATOR_AUTOMATIC,
            callback: (url)=>!!url && $8fb2b7bcf5f9e330$var$EXTERNAL_LINKS_REGEXP.test(url),
            attributes: {
                target: "_blank",
                rel: "noopener noreferrer"
            }
        });
        automaticDecorators.add(automaticDecoratorDefinitions);
        automaticDecorators.setConflictChecker((automaticDecorator, modelItem)=>{
            for (const manualDecorator of command.manualDecorators){
                if (!modelItem.hasAttribute(manualDecorator.id)) continue;
                if ($8fb2b7bcf5f9e330$var$areDecoratorsConflicting(automaticDecorator, manualDecorator)) return true;
            }
        });
        if (automaticDecorators.length) editor.conversion.for("downcast").add(automaticDecorators.getDispatcher());
    }
    /**
	* Processes an array of configured {@link module:link/linkconfig~LinkDecoratorManualDefinition manual decorators},
	* transforms them into {@link module:link/utils/manualdecorator~LinkManualDecorator} instances and stores them in the
	* {@link module:link/linkcommand~LinkCommand#manualDecorators} collection (a model for manual decorators state).
	*
	* Also registers an {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement attribute-to-element}
	* converter for each manual decorator and extends the {@link module:engine/model/schema~ModelSchema model's schema}
	* with adequate model attributes.
	*/ _enableManualDecorators(manualDecoratorDefinitions) {
        if (!manualDecoratorDefinitions.length) return;
        const editor = this.editor;
        const manualDecorators = editor.commands.get("link").manualDecorators;
        manualDecoratorDefinitions.forEach((decoratorDefinition)=>{
            editor.model.schema.extend("$text", {
                allowAttributes: decoratorDefinition.id
            });
            const decorator = new $8fb2b7bcf5f9e330$export$dcf6126a517c874e(decoratorDefinition);
            manualDecorators.add(decorator);
            editor.conversion.for("downcast").add((dispatcher)=>{
                const elementCreator = (writer)=>{
                    const element = writer.createAttributeElement("a", decorator.attributes, {
                        priority: 5
                    });
                    if (decorator.classes) writer.addClass(decorator.classes, element);
                    for(const key in decorator.styles)writer.setStyle(key, decorator.styles[key], element);
                    writer.setCustomProperty("link", true, element);
                    return element;
                };
                const createConverter = (isApplyingConverter)=>{
                    return (evt, data, conversionApi)=>{
                        if (!data.item.is("selection") && !conversionApi.schema.isInline(data.item)) return;
                        if (!isApplyingConverter && data.attributeOldValue) {
                            if (!conversionApi.consumable.test(data.item, evt.name)) return;
                            conversionApi.writer.unwrap(conversionApi.mapper.toViewRange(data.range), elementCreator(conversionApi.writer));
                        }
                        if (isApplyingConverter && data.attributeNewValue) {
                            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                            if (data.item.is("selection")) conversionApi.writer.wrap(conversionApi.writer.document.selection.getFirstRange(), elementCreator(conversionApi.writer));
                            else conversionApi.writer.wrap(conversionApi.mapper.toViewRange(data.range), elementCreator(conversionApi.writer));
                        }
                    };
                };
                dispatcher.on(`attribute:${decorator.id}`, createConverter(false), {
                    priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 1
                });
                dispatcher.on(`attribute:${decorator.id}`, createConverter(true), {
                    priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 2
                });
            });
            editor.conversion.for("upcast").elementToAttribute({
                view: {
                    name: "a",
                    ...decorator._createPattern()
                },
                model: {
                    key: decorator.id
                }
            });
        });
    }
    /**
	* Attaches handlers for {@link module:engine/view/document~ViewDocument#event:enter} and
	* {@link module:engine/view/document~ViewDocument#event:click} to enable link following.
	*/ _enableLinkOpen() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        const handleLinkOpening = (url)=>{
            if (!this._linkOpeners.some((opener)=>opener(url))) $8fb2b7bcf5f9e330$export$a625f03606271415(url);
        };
        this.listenTo(viewDocument, "click", (evt, data)=>{
            if (!((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isMac ? data.domEvent.metaKey : data.domEvent.ctrlKey)) return;
            let clickedElement = data.domTarget;
            if (clickedElement.tagName.toLowerCase() != "a") clickedElement = clickedElement.closest("a");
            if (!clickedElement) return;
            const url = clickedElement.getAttribute("href");
            if (!url) return;
            evt.stop();
            data.preventDefault();
            handleLinkOpening(url);
        }, {
            context: "$capture"
        });
        this.listenTo(viewDocument, "keydown", (evt, data)=>{
            const url = editor.commands.get("link").value;
            if (!(!!url && data.keyCode === (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).enter && data.altKey)) return;
            evt.stop();
            handleLinkOpening(url);
        });
    }
    /**
	* Watches the ModelDocumentSelection attribute changes and removes link decorator attributes when the linkHref attribute is removed.
	*
	* This is to ensure that there is no left-over link decorator attributes on the document selection that is no longer in a link.
	*/ _enableSelectionAttributesFixer() {
        const model = this.editor.model;
        const selection = model.document.selection;
        this.listenTo(selection, "change:attribute", (evt, { attributeKeys: attributeKeys })=>{
            if (!attributeKeys.includes("linkHref") || selection.hasAttribute("linkHref")) return;
            model.change((writer)=>{
                $8fb2b7bcf5f9e330$var$removeLinkAttributesFromSelection(writer, $8fb2b7bcf5f9e330$var$getLinkAttributesAllowedOnText(model.schema));
            });
        });
    }
    /**
	* Enables URL fixing on pasting.
	*/ _enableClipboardIntegration() {
        const editor = this.editor;
        const model = editor.model;
        const defaultProtocol = this.editor.config.get("link.defaultProtocol");
        if (!defaultProtocol) return;
        this.listenTo(editor.plugins.get("ClipboardPipeline"), "contentInsertion", (evt, data)=>{
            model.change((writer)=>{
                const range = writer.createRangeIn(data.content);
                for (const item of range.getItems())if (item.hasAttribute("linkHref")) {
                    const newLink = $8fb2b7bcf5f9e330$export$18bb33376634e28b(item.getAttribute("linkHref"), defaultProtocol);
                    writer.setAttribute("linkHref", newLink, item);
                }
            });
        });
    }
    /**
	* Registers a postfixer that resolves conflicting decorator attributes on elements.
	*/ _enableDecoratorConflictPostfixer() {
        const editor = this.editor;
        const model = editor.model;
        const linkCommand = editor.commands.get("link");
        model.document.registerPostFixer((writer)=>{
            let hasChanged = false;
            const changes = model.document.differ.getChanges();
            const elementsToCheck = /* @__PURE__ */ new Set();
            const manualDecoratorAttributeKeys = new Set(linkCommand.manualDecorators.map((decorator)=>decorator.id));
            for (const change of changes){
                if (change.type === "attribute") {
                    if (change.attributeKey !== "linkHref" && !manualDecoratorAttributeKeys.has(change.attributeKey)) continue;
                    for (const item of change.range.getItems())if (item.hasAttribute("linkHref")) elementsToCheck.add(item);
                }
                if (change.type === "insert" && change.attributes.has("linkHref") && change.position.nodeAfter) elementsToCheck.add(change.position.nodeAfter);
            }
            for (const item of elementsToCheck){
                const appliedDecorators = [];
                for (const manualDecorator of linkCommand.manualDecorators){
                    if (!item.hasAttribute(manualDecorator.id)) continue;
                    for(let i = appliedDecorators.length - 1; i >= 0; i--){
                        const appliedDecorator = appliedDecorators[i];
                        if ($8fb2b7bcf5f9e330$var$areDecoratorsConflicting(appliedDecorator, manualDecorator)) {
                            writer.removeAttribute(appliedDecorator.id, item);
                            appliedDecorators.splice(i, 1);
                            hasChanged = true;
                        }
                    }
                    appliedDecorators.push(manualDecorator);
                }
            }
            return hasChanged;
        });
    }
};
/**
* Make the selection free of link-related model attributes.
* All link-related model attributes start with "link". That includes not only "linkHref"
* but also all decorator attributes (they have dynamic names), or even custom plugins.
*/ function $8fb2b7bcf5f9e330$var$removeLinkAttributesFromSelection(writer, linkAttributes) {
    writer.removeSelectionAttribute("linkHref");
    for (const attribute of linkAttributes)writer.removeSelectionAttribute(attribute);
}
/**
* Returns an array containing names of the attributes allowed on `$text` that describes the link item.
*/ function $8fb2b7bcf5f9e330$var$getLinkAttributesAllowedOnText(schema) {
    return schema.getDefinition("$text").allowAttributes.filter((attribute)=>attribute.startsWith("link"));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/ui/linkpreviewbuttonview
*/ /**
* The link button class. Rendered as an `<a>` tag with link opening in a new tab.
*
* Provides a custom `navigate` cancelable event.
*/ var $8fb2b7bcf5f9e330$export$fe000144b50e6cfa = class extends (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa) {
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set({
            href: void 0,
            withText: true
        });
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-link-toolbar__preview"
                ],
                href: bind.to("href"),
                target: "_blank",
                rel: "noopener noreferrer"
            },
            on: {
                click: bind.to((evt)=>{
                    if (this.href) {
                        const cancel = ()=>evt.preventDefault();
                        this.fire("navigate", this.href, cancel);
                    }
                })
            }
        });
        this.template.tag = "a";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/ui/linkformview
*/ /**
* The link form view.
*/ var $8fb2b7bcf5f9e330$export$d71c98a9e49d0ca1 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the form.
	*/ focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* The Save button view.
	*/ saveButtonView;
    /**
	* A button that opens the {@link module:link/ui/linkpropertiesview~LinkPropertiesView} allowing the user to
	* configure manual decorators for the link handled by this form.
	*/ manualDecoratorsButtonView;
    /**
	* The "Displayed text" input view.
	*/ displayedTextInputView;
    /**
	* The URL input view.
	*/ urlInputView;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of child views in the providers list.
	*/ providersListChildren;
    /**
	* An array of form validators used by {@link #isValid}.
	*/ _validators;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* Creates an instance of the {@link module:link/ui/linkformview~LinkFormView} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	* @param validators  Form validators used by {@link #isValid}.
	*/ constructor(locale, validators){
        super(locale);
        this._validators = validators;
        this.backButtonView = this._createBackButton();
        this.saveButtonView = this._createSaveButton();
        this.manualDecoratorsButtonView = this._createManualDecoratorsButton();
        this.displayedTextInputView = this._createDisplayedTextInput();
        this.urlInputView = this._createUrlInput();
        this.providersListChildren = this.createCollection();
        this.children = this.createCollection([
            this._createHeaderView()
        ]);
        this._createFormChildren();
        this.listenTo(this.providersListChildren, "add", ()=>{
            this.stopListening(this.providersListChildren, "add");
            this.children.add(this._createProvidersListView());
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-link-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.urlInputView,
            this.manualDecoratorsButtonView,
            this.saveButtonView,
            ...this.providersListChildren,
            this.backButtonView,
            this.displayedTextInputView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist {@link #_focusables} in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Validates the form and returns `false` when some fields are invalid.
	*/ isValid() {
        this.resetFormStatus();
        for (const validator of this._validators){
            const errorText = validator(this);
            if (errorText) {
                this.urlInputView.errorText = errorText;
                return false;
            }
        }
        return true;
    }
    /**
	* Cleans up the supplementary error and information text of the {@link #urlInputView}
	* bringing them back to the state when the form has been displayed for the first time.
	*
	* See {@link #isValid}.
	*/ resetFormStatus() {
        this.urlInputView.errorText = null;
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates a save button view that inserts the link.
	*/ _createSaveButton() {
        const t = this.locale.t;
        const saveButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        saveButton.set({
            label: t("Insert"),
            tooltip: false,
            withText: true,
            type: "submit",
            class: "ck-button-action ck-button_standard"
        });
        return saveButton;
    }
    /**
	* Creates a button that opens the link properties view.
	*/ _createManualDecoratorsButton() {
        const t = this.locale.t;
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        button.set({
            label: t("Link properties"),
            icon: (0, $e8dc502aba5ac3f5$export$f8295d9ceeb6d2d6),
            tooltip: true,
            isVisible: false
        });
        button.delegate("execute").to(this, "showDecorators");
        return button;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Link")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates a view for the providers list.
	*/ _createProvidersListView() {
        const providersListView = new (0, $29fd27cb9bdab9d2$export$84d0dd190d551cd1)(this.locale);
        providersListView.extendTemplate({
            attributes: {
                class: [
                    "ck-link-form__providers-list"
                ]
            }
        });
        providersListView.items.bindTo(this.providersListChildren).using((def)=>{
            const listItemView = new (0, $29fd27cb9bdab9d2$export$41fd379e664153d8)(this.locale);
            listItemView.children.add(def);
            return listItemView;
        });
        return providersListView;
    }
    /**
	* Creates a labeled input view for the "Displayed text" field.
	*/ _createDisplayedTextInput() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        labeledInput.label = t("Displayed text");
        labeledInput.class = "ck-labeled-field-view_full-width";
        return labeledInput;
    }
    /**
	* Creates a labeled input view for the URL field.
	*
	* @returns Labeled field view instance.
	*/ _createUrlInput() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        labeledInput.fieldView.inputMode = "url";
        labeledInput.label = t("Link URL");
        labeledInput.class = "ck-labeled-field-view_full-width";
        return labeledInput;
    }
    /**
	* Populates the {@link #children} collection of the form.
	*/ _createFormChildren() {
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(this.locale, {
            children: [
                this.displayedTextInputView
            ],
            class: [
                "ck-form__row_large-top-padding"
            ]
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(this.locale, {
            children: [
                this.urlInputView,
                this.manualDecoratorsButtonView,
                this.saveButtonView
            ],
            class: [
                "ck-form__row_with-submit",
                "ck-form__row_large-bottom-padding"
            ]
        }));
    }
    /**
	* The native DOM `value` of the {@link #urlInputView} element.
	*
	* **Note**: Do not confuse it with the {@link module:ui/inputtext/inputtextview~InputTextView#value}
	* which works one way only and may not represent the actual state of the component in the DOM.
	*/ get url() {
        const { element: element } = this.urlInputView.fieldView;
        if (!element) return null;
        return element.value.trim();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/ui/linkprovideritemsview
*/ /**
* The link provider items view.
*/ var $8fb2b7bcf5f9e330$export$51896a75a11ab260 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the form.
	*/ focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* The List view of links buttons.
	*/ listView;
    /**
	* The collection of child views, which is bind with the `listView`.
	*/ listChildren;
    /**
	* The view displayed when the list is empty.
	*/ emptyListInformation;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* Creates an instance of the {@link module:link/ui/linkprovideritemsview~LinkProviderItemsView} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.listChildren = this.createCollection();
        this.backButtonView = this._createBackButton();
        this.listView = this._createListView();
        this.emptyListInformation = this._createEmptyLinksListItemView();
        this.children = this.createCollection([
            this._createHeaderView(),
            this.emptyListInformation
        ]);
        this.set("title", "");
        this.set("emptyListPlaceholder", "");
        this.set("hasItems", false);
        this.listenTo(this.listChildren, "change", ()=>{
            this.hasItems = this.listChildren.length > 0;
        });
        this.on("change:hasItems", (evt, propName, hasItems)=>{
            if (hasItems) {
                this.children.remove(this.emptyListInformation);
                this.children.add(this.listView);
            } else {
                this.children.remove(this.listView);
                this.children.add(this.emptyListInformation);
            }
        });
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("cancel");
            cancel();
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-link-providers"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        [
            this.listView,
            this.backButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist {@link #_focusables} in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Creates a view for the list at the bottom.
	*/ _createListView() {
        const listView = new (0, $29fd27cb9bdab9d2$export$84d0dd190d551cd1)(this.locale);
        listView.extendTemplate({
            attributes: {
                class: [
                    "ck-link-providers__list"
                ]
            }
        });
        listView.items.bindTo(this.listChildren).using((button)=>{
            const listItemView = new (0, $29fd27cb9bdab9d2$export$41fd379e664153d8)(this.locale);
            listItemView.children.add(button);
            return listItemView;
        });
        return listView;
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale);
        header.bind("label").to(this, "title");
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates an info view for an empty list.
	*/ _createEmptyLinksListItemView() {
        const view = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(this.locale);
        view.setTemplate({
            tag: "p",
            attributes: {
                class: [
                    "ck",
                    "ck-link__empty-list-info"
                ]
            },
            children: [
                {
                    text: this.bindTemplate.to("emptyListPlaceholder")
                }
            ]
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/ui/linkpropertiesview
*/ /**
* The link properties view controller class.
*
* See {@link module:link/ui/linkpropertiesview~LinkPropertiesView}.
*/ var $8fb2b7bcf5f9e330$export$58dc0267730d62e1 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the form.
	*/ focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of {@link module:ui/button/switchbuttonview~SwitchButtonView},
	* which corresponds to {@link module:link/linkcommand~LinkCommand#manualDecorators manual decorators}
	* configured in the editor.
	*/ listChildren;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* Creates an instance of the {@link module:link/ui/linkpropertiesview~LinkPropertiesView} class.
	*
	* Also see {@link #render}.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.backButtonView = this._createBackButton();
        this.listChildren = this.createCollection();
        this.children = this.createCollection([
            this._createHeaderView(),
            this._createListView()
        ]);
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-link-properties"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("back");
            cancel();
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        [
            ...this.listChildren,
            this.backButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist {@link #_focusables} in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Creates a back button view.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "back");
        return backButton;
    }
    /**
	* Creates a header view for the form.
	*/ _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Link properties")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    /**
	* Creates a form view that displays the {@link #listChildren} collection.
	*/ _createListView() {
        const listView = new (0, $29fd27cb9bdab9d2$export$84d0dd190d551cd1)(this.locale);
        listView.extendTemplate({
            attributes: {
                class: [
                    "ck-link__list"
                ]
            }
        });
        listView.items.bindTo(this.listChildren).using((item)=>{
            const listItemView = new (0, $29fd27cb9bdab9d2$export$41fd379e664153d8)(this.locale);
            listItemView.children.add(item);
            return listItemView;
        });
        return listView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/ui/linkbuttonview
*/ /**
* Represents a view for a dropdown menu button.
*/ var $8fb2b7bcf5f9e330$export$21feaad9e6769fe2 = class extends (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa) {
    /**
	* An icon that displays an arrow to indicate a direction of the menu.
	*/ arrowView;
    /**
	* Creates an instance of the dropdown menu button view.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.set({
            withText: true
        });
        this.arrowView = this._createArrowView();
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-link__button"
                ]
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.children.add(this.arrowView);
    }
    /**
	* Creates the arrow view instance.
	*
	* @private
	*/ _createArrowView() {
        const arrowView = new (0, $29fd27cb9bdab9d2$export$212c60ac61334981)();
        arrowView.content = (0, $e8dc502aba5ac3f5$export$ce5b94cabe8af42c);
        return arrowView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkui
*/ const $8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME = "link-ui";
/**
* The link UI plugin. It introduces the `'link'` and `'unlink'` buttons and support for the <kbd>Ctrl+K</kbd> keystroke.
*
* It uses the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
*/ var $8fb2b7bcf5f9e330$export$bef56d19827a3ee9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The toolbar view displayed inside of the balloon.
	*/ toolbarView = null;
    /**
	* The form view displayed inside the balloon.
	*/ formView = null;
    /**
	* The view displaying links list.
	*/ linkProviderItemsView = null;
    /**
	* The form view displaying properties link settings.
	*/ propertiesView = null;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* The collection of the link providers.
	*/ _linksProviders = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c),
            $8fb2b7bcf5f9e330$export$8c435103e27cd12e
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        this.set("selectedLinkableText", void 0);
        editor.editing.view.addObserver((0, $b9b9f2bdf9c6137f$export$2386d691512b3680));
        this._balloon = editor.plugins.get((0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c));
        this._registerComponents();
        this._registerEditingOpeners();
        this._enableBalloonActivators();
        editor.conversion.for("editingDowncast").markerToHighlight({
            model: $8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME,
            view: {
                classes: [
                    "ck-fake-link-selection"
                ]
            }
        });
        editor.conversion.for("editingDowncast").markerToElement({
            model: $8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME,
            view: (data, { writer: writer })=>{
                if (!data.markerRange.isCollapsed) return null;
                const markerElement = writer.createUIElement("span");
                writer.addClass([
                    "ck-fake-link-selection",
                    "ck-fake-link-selection_collapsed"
                ], markerElement);
                return markerElement;
            }
        });
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Create link"),
                    keystroke: $8fb2b7bcf5f9e330$export$1dbe65c3c53297ae
                },
                {
                    label: t("Move out of a link"),
                    keystroke: [
                        [
                            "arrowleft",
                            "arrowleft"
                        ],
                        [
                            "arrowright",
                            "arrowright"
                        ]
                    ]
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this.propertiesView) this.propertiesView.destroy();
        if (this.formView) this.formView.destroy();
        if (this.toolbarView) this.toolbarView.destroy();
        if (this.linkProviderItemsView) this.linkProviderItemsView.destroy();
    }
    /**
	* Registers list of buttons below the link form view that
	* open a list of links provided by the clicked provider.
	*/ registerLinksListProvider(provider) {
        const insertIndex = this._linksProviders.filter((existing)=>(existing.order || 0) <= (provider.order || 0)).length;
        this._linksProviders.add(provider, insertIndex);
    }
    /**
	* Creates views.
	*/ _createViews() {
        const linkCommand = this.editor.commands.get("link");
        this.toolbarView = this._createToolbarView();
        this.formView = this._createFormView();
        if (linkCommand.manualDecorators.length) this.propertiesView = this._createPropertiesView();
        this._enableUserBalloonInteractions();
    }
    /**
	* Creates the ToolbarView instance.
	*/ _createToolbarView() {
        const editor = this.editor;
        const toolbarView = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(editor.locale);
        const linkCommand = editor.commands.get("link");
        toolbarView.class = "ck-link-toolbar";
        let toolbarItems = editor.config.get("link.toolbar");
        if (!linkCommand.manualDecorators.length) toolbarItems = toolbarItems.filter((item)=>item !== "linkProperties");
        toolbarView.fillFromConfig(toolbarItems, editor.ui.componentFactory);
        toolbarView.keystrokes.set("Esc", (data, cancel)=>{
            this._hideUI();
            cancel();
        });
        toolbarView.keystrokes.set($8fb2b7bcf5f9e330$export$1dbe65c3c53297ae, (data, cancel)=>{
            this._addFormView();
            cancel();
        });
        editor.ui.addToolbar(toolbarView, {
            isContextual: true,
            beforeFocus: ()=>{
                if (this._getSelectedLinkElement() && !this._isToolbarVisible) this._showUI(true);
            },
            afterBlur: ()=>{
                this._hideUI(false);
            }
        });
        return toolbarView;
    }
    /**
	* Creates the {@link module:link/ui/linkformview~LinkFormView} instance.
	*/ _createFormView() {
        const editor = this.editor;
        const t = editor.locale.t;
        const linkCommand = editor.commands.get("link");
        const defaultProtocol = editor.config.get("link.defaultProtocol");
        const formView = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($8fb2b7bcf5f9e330$export$d71c98a9e49d0ca1))(editor.locale, $8fb2b7bcf5f9e330$var$getFormValidators(editor));
        formView.displayedTextInputView.bind("isEnabled").to(this, "selectedLinkableText", (value)=>value !== void 0);
        formView.urlInputView.bind("isEnabled").to(linkCommand, "isEnabled");
        formView.saveButtonView.bind("isEnabled").to(linkCommand, "isEnabled");
        formView.saveButtonView.bind("label").to(linkCommand, "value", (value)=>value ? t("Update") : t("Insert"));
        this.listenTo(formView, "submit", ()=>{
            if (formView.isValid()) {
                const url = formView.urlInputView.fieldView.element.value;
                const parsedUrl = $8fb2b7bcf5f9e330$export$18bb33376634e28b(url, defaultProtocol);
                const displayedText = formView.displayedTextInputView.fieldView.element.value;
                editor.execute("link", parsedUrl, this._getDecoratorSwitchesState(), displayedText !== this.selectedLinkableText ? displayedText : void 0);
                this._closeFormView();
            }
        });
        this.listenTo(formView.urlInputView, "change:errorText", ()=>{
            editor.ui.update();
        });
        this.listenTo(formView, "cancel", ()=>{
            this._closeFormView();
        });
        formView.keystrokes.set("Esc", (data, cancel)=>{
            this._closeFormView();
            cancel();
        });
        formView.providersListChildren.bindTo(this._linksProviders).using((provider)=>this._createLinksListProviderButton(provider));
        formView.manualDecoratorsButtonView.isVisible = linkCommand.manualDecorators.length > 0;
        this.listenTo(formView, "showDecorators", ()=>{
            this._addPropertiesView();
        });
        return formView;
    }
    /**
	* Creates a sorted array of buttons with link names.
	*/ _createLinkProviderListView(provider) {
        return provider.getListItems().map(({ href: href, label: label, icon: icon })=>{
            const buttonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)();
            buttonView.set({
                label: label,
                icon: icon,
                tooltip: false,
                withText: true
            });
            buttonView.on("execute", ()=>{
                this.formView.resetFormStatus();
                this.formView.urlInputView.fieldView.value = href;
                this.editor.editing.view.focus();
                this._removeLinksProviderView();
                this.formView.focus();
            });
            return buttonView;
        });
    }
    /**
	* Creates a view for links provider.
	*/ _createLinkProviderItemsView(provider) {
        const editor = this.editor;
        const t = editor.locale.t;
        const view = new $8fb2b7bcf5f9e330$export$51896a75a11ab260(editor.locale);
        const { emptyListPlaceholder: emptyListPlaceholder, label: label } = provider;
        view.emptyListPlaceholder = emptyListPlaceholder || t("No links available");
        view.title = label;
        this.listenTo(view, "cancel", ()=>{
            editor.editing.view.focus();
            this._removeLinksProviderView();
            this.formView.focus();
        });
        return view;
    }
    /**
	* Creates the {@link module:link/ui/linkpropertiesview~LinkPropertiesView} instance.
	*/ _createPropertiesView() {
        const editor = this.editor;
        const linkCommand = this.editor.commands.get("link");
        const view = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($8fb2b7bcf5f9e330$export$58dc0267730d62e1))(editor.locale);
        this.listenTo(view, "back", ()=>{
            if (this._isFormInPanel) {
                this._removePropertiesView();
                this.formView.focus();
            } else {
                editor.editing.view.focus();
                this._removePropertiesView();
            }
        });
        view.listChildren.bindTo(linkCommand.manualDecorators).using((manualDecorator)=>{
            const button = new (0, $29fd27cb9bdab9d2$export$bb3c559d00882ebd)(editor.locale);
            button.set({
                label: manualDecorator.label,
                withText: true
            });
            button.bind("isOn").toMany([
                manualDecorator,
                linkCommand
            ], "value", (decoratorValue, commandValue)=>{
                return commandValue === void 0 && decoratorValue === void 0 ? !!manualDecorator.defaultValue : !!decoratorValue;
            });
            button.on("execute", ()=>{
                const newValue = !button.isOn;
                if (linkCommand.value !== void 0) editor.execute("link", linkCommand.value, {
                    ...this._getDecoratorSwitchesState(),
                    [manualDecorator.id]: newValue
                });
                else this._togglePendingManualDecorator(manualDecorator, newValue);
            });
            return button;
        });
        return view;
    }
    /**
	* Obtains the state of the manual decorators.
	*/ _getDecoratorSwitchesState() {
        const linkCommand = this.editor.commands.get("link");
        return Array.from(linkCommand.manualDecorators).reduce((accumulator, manualDecorator)=>{
            const value = linkCommand.value === void 0 && manualDecorator.value === void 0 ? manualDecorator.defaultValue : manualDecorator.value;
            return {
                ...accumulator,
                [manualDecorator.id]: !!value
            };
        }, {});
    }
    /**
	* Toggles the state of a manual decorator while a new link is being created, that is, before it is
	* inserted into the document. Since there is no link (and no command value) to execute the `'link'`
	* command against yet, the new state is kept on the decorator's own observable
	* {@link module:link/utils/manualdecorator~LinkManualDecorator#value} instead of the model.
	*/ _togglePendingManualDecorator(manualDecorator, newValue) {
        const linkCommand = this.editor.commands.get("link");
        const allDecorators = Array.from(linkCommand.manualDecorators);
        const decoratorStates = this._getDecoratorSwitchesState();
        const previousDecoratorStates = allDecorators.map((decorator)=>({
                id: decorator.id,
                attributes: decorator.attributes,
                styles: decorator.styles,
                value: decoratorStates[decorator.id]
            }));
        decoratorStates[manualDecorator.id] = newValue;
        const resolvedStates = $8fb2b7bcf5f9e330$var$resolveConflictingDecorators({
            decoratorStates: decoratorStates,
            allDecorators: previousDecoratorStates
        });
        for (const decorator of allDecorators)decorator.value = resolvedStates[decorator.id];
    }
    /**
	* Clears the state of all manual decorators that may have been toggled while creating a link that,
	* in the end, was never inserted into the document (for example, the user canceled the form).
	*/ _resetPendingManualDecoratorsState() {
        const linkCommand = this.editor.commands.get("link");
        for (const manualDecorator of linkCommand.manualDecorators)manualDecorator.value = void 0;
    }
    /**
	* Registers listeners used in editing plugin, used to open links.
	*/ _registerEditingOpeners() {
        this.editor.plugins.get($8fb2b7bcf5f9e330$export$8c435103e27cd12e)._registerLinkOpener((href)=>{
            const match = this._getLinkProviderLinkByHref(href);
            if (!match) return false;
            const { item: item, provider: provider } = match;
            if (provider.navigate) return provider.navigate(item);
            return false;
        });
    }
    /**
	* Registers components in the ComponentFactory.
	*/ _registerComponents() {
        const editor = this.editor;
        editor.ui.componentFactory.add("link", ()=>{
            const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.set({
                tooltip: true
            });
            return button;
        });
        editor.ui.componentFactory.add("menuBar:link", ()=>{
            const button = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
            button.set({
                role: "menuitemcheckbox"
            });
            return button;
        });
        editor.ui.componentFactory.add("linkPreview", (locale)=>{
            const button = new $8fb2b7bcf5f9e330$export$fe000144b50e6cfa(locale);
            const allowedProtocols = editor.config.get("link.allowedProtocols");
            const linkCommand = editor.commands.get("link");
            const t = locale.t;
            button.bind("isEnabled").to(linkCommand, "value", (href)=>!!href);
            button.bind("href").to(linkCommand, "value", (href)=>{
                return href && $8fb2b7bcf5f9e330$export$633294874bd755f8(href, allowedProtocols);
            });
            const setHref = (href)=>{
                if (href === "") {
                    button.label = t("This link has no URL");
                    button.icon = void 0;
                    button.tooltip = false;
                    return;
                }
                if (!href) {
                    button.label = void 0;
                    button.icon = void 0;
                    button.tooltip = t("Open link in new tab");
                    return;
                }
                const selectedLinksProviderLink = this._getLinkProviderLinkByHref(href);
                if (selectedLinksProviderLink) {
                    const { label: label, tooltip: tooltip, icon: icon } = selectedLinksProviderLink.item;
                    button.label = label;
                    button.tooltip = tooltip || false;
                    button.icon = icon;
                } else {
                    button.label = href;
                    button.icon = void 0;
                    button.tooltip = t("Open link in new tab");
                }
            };
            setHref(linkCommand.value);
            this.listenTo(linkCommand, "change:value", (evt, name, href)=>{
                setHref(href);
            });
            this.listenTo(button, "navigate", (evt, href, cancel)=>{
                const selectedLinksProviderLink = this._getLinkProviderLinkByHref(href);
                if (!selectedLinksProviderLink) return;
                const { provider: provider, item: item } = selectedLinksProviderLink;
                const { navigate: navigate } = provider;
                if (navigate && navigate(item)) {
                    evt.stop();
                    cancel();
                }
            });
            return button;
        });
        editor.ui.componentFactory.add("unlink", (locale)=>{
            const unlinkCommand = editor.commands.get("unlink");
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            button.set({
                label: t("Unlink"),
                icon: (0, $e8dc502aba5ac3f5$export$c3a99d63f29863e8),
                tooltip: true
            });
            button.bind("isEnabled").to(unlinkCommand);
            this.listenTo(button, "execute", ()=>{
                editor.execute("unlink");
                this._hideUI();
            });
            return button;
        });
        editor.ui.componentFactory.add("editLink", (locale)=>{
            const linkCommand = editor.commands.get("link");
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            button.set({
                label: t("Edit link"),
                icon: (0, $e8dc502aba5ac3f5$export$20da9dff06d8cce3),
                tooltip: true
            });
            button.bind("isEnabled").to(linkCommand);
            this.listenTo(button, "execute", ()=>{
                this._addFormView();
            });
            return button;
        });
        editor.ui.componentFactory.add("linkProperties", (locale)=>{
            const linkCommand = editor.commands.get("link");
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            button.set({
                label: t("Link properties"),
                icon: (0, $e8dc502aba5ac3f5$export$f8295d9ceeb6d2d6),
                tooltip: true
            });
            button.bind("isEnabled").to(linkCommand, "isEnabled", linkCommand, "value", linkCommand, "manualDecorators", (isEnabled, href, manualDecorators)=>isEnabled && href !== void 0 && manualDecorators.length > 0);
            this.listenTo(button, "execute", ()=>{
                this._addPropertiesView();
            });
            return button;
        });
    }
    /**
	* Creates a links button view.
	*/ _createLinksListProviderButton(linkProvider) {
        const locale = this.editor.locale;
        const linksButton = new $8fb2b7bcf5f9e330$export$21feaad9e6769fe2(locale);
        linksButton.set({
            label: linkProvider.label
        });
        this.listenTo(linksButton, "execute", ()=>{
            this._showLinksProviderView(linkProvider);
        });
        return linksButton;
    }
    /**
	* Creates a button for link command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("link");
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Link"),
            icon: (0, $e8dc502aba5ac3f5$export$23da1e9f164f7ea1),
            keystroke: $8fb2b7bcf5f9e330$export$1dbe65c3c53297ae,
            isToggleable: true
        });
        view.bind("isEnabled").to(command, "isEnabled");
        view.bind("isOn").to(command, "value", (value)=>!!value);
        this.listenTo(view, "execute", ()=>{
            editor.editing.view.scrollToTheSelection();
            this._showUI(true);
            if (this._getSelectedLinkElement()) this._addFormView();
        });
        return view;
    }
    /**
	* Attaches actions that control whether the balloon panel containing the
	* {@link #formView} should be displayed.
	*/ _enableBalloonActivators() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        this.listenTo(viewDocument, "click", ()=>{
            if (this._getSelectedLinkElement()) this._showUI();
        });
        editor.keystrokes.set($8fb2b7bcf5f9e330$export$1dbe65c3c53297ae, (keyEvtData, cancel)=>{
            cancel();
            if (editor.commands.get("link").isEnabled) {
                editor.editing.view.scrollToTheSelection();
                this._showUI(true);
            }
        });
    }
    /**
	* Attaches actions that control whether the balloon panel containing the
	* {@link #formView} is visible or not.
	*/ _enableUserBalloonInteractions() {
        this.editor.keystrokes.set("Tab", (data, cancel)=>{
            if (this._isToolbarVisible && !this.toolbarView.focusTracker.isFocused) {
                this.toolbarView.focus();
                cancel();
            }
        }, {
            priority: "high"
        });
        this.editor.keystrokes.set("Esc", (data, cancel)=>{
            if (this._isUIVisible) {
                this._hideUI();
                cancel();
            }
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this.formView,
            activator: ()=>this._isUIInPanel,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>{
                this._hideUI(false);
            }
        });
    }
    /**
	* Adds the {@link #toolbarView} to the {@link #_balloon}.
	*
	* @internal
	*/ _addToolbarView() {
        if (!this.toolbarView) this._createViews();
        if (this._isToolbarInPanel) return;
        this._balloon.add({
            view: this.toolbarView,
            position: this._getBalloonPositionData(),
            balloonClassName: "ck-toolbar-container"
        });
    }
    /**
	* Adds the {@link #formView} to the {@link #_balloon}.
	*/ _addFormView() {
        if (!this.formView) this._createViews();
        if (this._isFormInPanel) return;
        const linkCommand = this.editor.commands.get("link");
        this.formView.disableCssTransitions();
        this.formView.resetFormStatus();
        this.formView.backButtonView.isVisible = linkCommand.isEnabled && linkCommand.value !== void 0;
        this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
        });
        this.selectedLinkableText = this._getSelectedLinkableText();
        this.formView.displayedTextInputView.fieldView.value = this.selectedLinkableText || "";
        this.formView.urlInputView.fieldView.value = linkCommand.value || "";
        if (this._balloon.visibleView === this.formView) this.formView.urlInputView.fieldView.select();
        this.formView.enableCssTransitions();
    }
    /**
	* Adds the {@link #propertiesView} to the {@link #_balloon}.
	*/ _addPropertiesView() {
        if (!this.propertiesView) this._createViews();
        if (this._arePropertiesInPanel) return;
        this.propertiesView.disableCssTransitions();
        this._balloon.add({
            view: this.propertiesView,
            position: this._getBalloonPositionData()
        });
        this.propertiesView.enableCssTransitions();
        this.propertiesView.focus();
    }
    /**
	* Shows the view with links provided by the given provider.
	*/ _showLinksProviderView(provider) {
        if (this.linkProviderItemsView) this._removeLinksProviderView();
        this.linkProviderItemsView = this._createLinkProviderItemsView(provider);
        this._addLinkProviderItemsView(provider);
    }
    /**
	* Adds the {@link #linkProviderItemsView} to the {@link #_balloon}.
	*/ _addLinkProviderItemsView(provider) {
        this.linkProviderItemsView.listChildren.clear();
        this.linkProviderItemsView.listChildren.addMany(this._createLinkProviderListView(provider));
        this._balloon.add({
            view: this.linkProviderItemsView,
            position: this._getBalloonPositionData()
        });
        this.linkProviderItemsView.focus();
    }
    /**
	* Closes the form view. Decides whether the balloon should be hidden completely or if the action view should be shown. This is
	* decided upon the link command value (which has a value if the document selection is in the link).
	*/ _closeFormView() {
        const linkCommand = this.editor.commands.get("link");
        this.selectedLinkableText = void 0;
        if (linkCommand.value !== void 0) this._removeFormView();
        else this._hideUI();
    }
    /**
	* Removes the {@link #propertiesView} from the {@link #_balloon}.
	*/ _removePropertiesView() {
        if (this._arePropertiesInPanel) this._balloon.remove(this.propertiesView);
    }
    /**
	* Removes the {@link #linkProviderItemsView} from the {@link #_balloon}.
	*/ _removeLinksProviderView() {
        if (this._isLinksListInPanel) this._balloon.remove(this.linkProviderItemsView);
    }
    /**
	* Removes the {@link #formView} from the {@link #_balloon}.
	*/ _removeFormView(updateFocus = true) {
        if (this._isFormInPanel) {
            const linkCommand = this.editor.commands.get("link");
            this.formView.saveButtonView.focus();
            this.formView.displayedTextInputView.fieldView.reset();
            this.formView.urlInputView.fieldView.reset();
            if (linkCommand.value === void 0) this._resetPendingManualDecoratorsState();
            this._balloon.remove(this.formView);
            if (updateFocus) this.editor.editing.view.focus();
            this._hideFakeVisualSelection();
        }
    }
    /**
	* Shows the correct UI type. It is either {@link #formView} or {@link #toolbarView}.
	*
	* @internal
	*/ _showUI(forceVisible = false) {
        if (!this.formView) this._createViews();
        if (!this._getSelectedLinkElement()) {
            this._showFakeVisualSelection();
            this._addToolbarView();
            if (forceVisible) this._balloon.showStack("main");
            this._addFormView();
        } else {
            if (this._isToolbarVisible) this._addFormView();
            else this._addToolbarView();
            if (forceVisible) this._balloon.showStack("main");
        }
        this._startUpdatingUI();
    }
    /**
	* Removes the {@link #formView} from the {@link #_balloon}.
	*
	* See {@link #_addFormView}, {@link #_addToolbarView}.
	*/ _hideUI(updateFocus = true) {
        const editor = this.editor;
        if (!this._isUIInPanel) return;
        this.stopListening(editor.ui, "update");
        this.stopListening(this._balloon, "change:visibleView");
        if (updateFocus) editor.editing.view.focus();
        this._removeLinksProviderView();
        this._removePropertiesView();
        this._removeFormView(updateFocus);
        if (this._isToolbarInPanel) this._balloon.remove(this.toolbarView);
        this._hideFakeVisualSelection();
    }
    /**
	* Makes the UI react to the {@link module:ui/editorui/editorui~EditorUI#event:update} event to
	* reposition itself when the editor UI should be refreshed.
	*
	* See: {@link #_hideUI} to learn when the UI stops reacting to the `update` event.
	*/ _startUpdatingUI() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        let prevSelectedLink = this._getSelectedLinkElement();
        let prevSelectionParent = getSelectionParent();
        const update = ()=>{
            const selectedLink = this._getSelectedLinkElement();
            const selectionParent = getSelectionParent();
            if (prevSelectedLink && !selectedLink || !prevSelectedLink && selectionParent !== prevSelectionParent) this._hideUI();
            else if (this._isUIVisible) this._balloon.updatePosition(this._getBalloonPositionData());
            prevSelectedLink = selectedLink;
            prevSelectionParent = selectionParent;
        };
        function getSelectionParent() {
            return viewDocument.selection.focus.getAncestors().reverse().find((node)=>node.is("element"));
        }
        this.listenTo(editor.ui, "update", update);
        this.listenTo(this._balloon, "change:visibleView", update);
    }
    /**
	* Returns `true` when {@link #propertiesView} is in the {@link #_balloon}.
	*/ get _arePropertiesInPanel() {
        return !!this.propertiesView && this._balloon.hasView(this.propertiesView);
    }
    /**
	* Returns `true` when {@link #linkProviderItemsView} is in the {@link #_balloon}.
	*/ get _isLinksListInPanel() {
        return !!this.linkProviderItemsView && this._balloon.hasView(this.linkProviderItemsView);
    }
    /**
	* Returns `true` when {@link #formView} is in the {@link #_balloon}.
	*/ get _isFormInPanel() {
        return !!this.formView && this._balloon.hasView(this.formView);
    }
    /**
	* Returns `true` when {@link #toolbarView} is in the {@link #_balloon}.
	*/ get _isToolbarInPanel() {
        return !!this.toolbarView && this._balloon.hasView(this.toolbarView);
    }
    /**
	* Returns `true` when {@link #propertiesView} is in the {@link #_balloon} and it is
	* currently visible.
	*/ get _isPropertiesVisible() {
        return !!this.propertiesView && this._balloon.visibleView === this.propertiesView;
    }
    /**
	* Returns `true` when {@link #formView} is in the {@link #_balloon} and it is
	* currently visible.
	*/ get _isFormVisible() {
        return !!this.formView && this._balloon.visibleView == this.formView;
    }
    /**
	* Returns `true` when {@link #toolbarView} is in the {@link #_balloon} and it is
	* currently visible.
	*/ get _isToolbarVisible() {
        return !!this.toolbarView && this._balloon.visibleView === this.toolbarView;
    }
    /**
	* Returns `true` when {@link #propertiesView}, {@link #toolbarView}, {@link #linkProviderItemsView}
	* or {@link #formView} is in the {@link #_balloon}.
	*/ get _isUIInPanel() {
        return this._arePropertiesInPanel || this._isLinksListInPanel || this._isFormInPanel || this._isToolbarInPanel;
    }
    /**
	* Returns `true` when {@link #propertiesView}, {@link #linkProviderItemsView}, {@link #toolbarView}
	* or {@link #formView} is in the {@link #_balloon} and it is currently visible.
	*/ get _isUIVisible() {
        return this._isPropertiesVisible || this._isLinksListInPanel || this._isFormVisible || this._isToolbarVisible;
    }
    /**
	* Returns positioning options for the {@link #_balloon}. They control the way the balloon is attached
	* to the target element or selection.
	*
	* If the selection is collapsed and inside a link element, the panel will be attached to the
	* entire link element. Otherwise, it will be attached to the selection.
	*/ _getBalloonPositionData() {
        const view = this.editor.editing.view;
        const viewDocument = view.document;
        if (this.editor.model.markers.has($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME)) {
            const markerViewElements = this.editor.editing.mapper.markerNameToElements($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME);
            if (markerViewElements) {
                const markerViewElementsArray = Array.from(markerViewElements);
                const newRange = view.createRange(view.createPositionBefore(markerViewElementsArray[0]), view.createPositionAfter(markerViewElementsArray[markerViewElementsArray.length - 1]));
                return {
                    target: view.domConverter.viewRangeToDom(newRange)
                };
            }
        }
        return {
            target: ()=>{
                const targetLink = this._getSelectedLinkElement();
                return targetLink ? view.domConverter.mapViewToDom(targetLink) : view.domConverter.viewRangeToDom(viewDocument.selection.getFirstRange());
            }
        };
    }
    /**
	* Returns the link {@link module:engine/view/attributeelement~ViewAttributeElement} under
	* the {@link module:engine/view/document~ViewDocument editing view's} selection or `null`
	* if there is none.
	*
	* **Note**: For a non–collapsed selection, the link element is returned when **fully**
	* selected and the **only** element within the selection boundaries, or when
	* a linked widget is selected.
	*/ _getSelectedLinkElement() {
        const view = this.editor.editing.view;
        const selection = view.document.selection;
        const selectedElement = selection.getSelectedElement();
        if (selection.isCollapsed || selectedElement && (0, $5547ab21e02f1e9e$export$33101d01ca587c36)(selectedElement)) return $8fb2b7bcf5f9e330$var$findLinkElementAncestor(selection.getFirstPosition());
        else {
            const range = selection.getFirstRange().getTrimmed();
            const startLink = $8fb2b7bcf5f9e330$var$findLinkElementAncestor(range.start);
            const endLink = $8fb2b7bcf5f9e330$var$findLinkElementAncestor(range.end);
            if (!startLink || startLink != endLink) return null;
            if (view.createRangeIn(startLink).getTrimmed().isEqual(range)) return startLink;
            else return null;
        }
    }
    /**
	* Returns selected link text content.
	* If link is not selected it returns the selected text.
	* If selection or link includes non text node (inline object or block) then returns undefined.
	*/ _getSelectedLinkableText() {
        const model = this.editor.model;
        const editing = this.editor.editing;
        const selectedLink = this._getSelectedLinkElement();
        if (!selectedLink) return $8fb2b7bcf5f9e330$export$fe7def88017c1dfc(model.document.selection.getFirstRange());
        const viewLinkRange = editing.view.createRangeOn(selectedLink);
        const linkRange = editing.mapper.toModelRange(viewLinkRange);
        return $8fb2b7bcf5f9e330$export$fe7def88017c1dfc(linkRange);
    }
    /**
	* Returns a provider by its URL.
	*
	* @param href URL of the link.
	* @returns Link provider and item or `null` if not found.
	*/ _getLinkProviderLinkByHref(href) {
        if (!href) return null;
        for (const provider of this._linksProviders){
            const item = provider.getItem ? provider.getItem(href) : provider.getListItems().find((item)=>item.href === href);
            if (item) return {
                provider: provider,
                item: item
            };
        }
        return null;
    }
    /**
	* Displays a fake visual selection when the contextual balloon is displayed.
	*
	* This adds a 'link-ui' marker into the document that is rendered as a highlight on selected text fragment.
	*/ _showFakeVisualSelection() {
        const model = this.editor.model;
        model.change((writer)=>{
            const range = model.document.selection.getFirstRange();
            if (model.markers.has($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME)) writer.updateMarker($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME, {
                range: range
            });
            else if (range.start.isAtEnd) {
                const startPosition = range.start.getLastMatchingPosition(({ item: item })=>!model.schema.isContent(item), {
                    boundaries: range
                });
                writer.addMarker($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME, {
                    usingOperation: false,
                    affectsData: false,
                    range: writer.createRange(startPosition, range.end)
                });
            } else writer.addMarker($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME, {
                usingOperation: false,
                affectsData: false,
                range: range
            });
        });
    }
    /**
	* Hides the fake visual selection created in {@link #_showFakeVisualSelection}.
	*/ _hideFakeVisualSelection() {
        const model = this.editor.model;
        if (model.markers.has($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME)) model.change((writer)=>{
            writer.removeMarker($8fb2b7bcf5f9e330$var$VISUAL_SELECTION_MARKER_NAME);
        });
    }
};
/**
* Returns a link element if there's one among the ancestors of the provided `Position`.
*
* @param View position to analyze.
* @returns Link element at the position or null.
*/ function $8fb2b7bcf5f9e330$var$findLinkElementAncestor(position) {
    return position.getAncestors().find((ancestor)=>$8fb2b7bcf5f9e330$export$a8faa48da8fdb1ce(ancestor)) || null;
}
/**
* Returns link form validation callbacks.
*
* @param editor Editor instance.
*/ function $8fb2b7bcf5f9e330$var$getFormValidators(editor) {
    const t = editor.t;
    const allowCreatingEmptyLinks = editor.config.get("link.allowCreatingEmptyLinks");
    return [
        (form)=>{
            if (!allowCreatingEmptyLinks && !form.url.length) return t("Link URL must not be empty.");
        }
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/autolink
*/ const $8fb2b7bcf5f9e330$var$MIN_LINK_LENGTH_WITH_SPACE_AT_END = 4;
const $8fb2b7bcf5f9e330$var$URL_REG_EXP = /* @__PURE__ */ new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63}))|localhost)(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
const $8fb2b7bcf5f9e330$var$URL_GROUP_IN_MATCH = 2;
/**
* The autolink plugin.
*/ var $8fb2b7bcf5f9e330$export$8c78d64a32116441 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f1defb5a0a139b4c$export$bfadae053a633538),
            $8fb2b7bcf5f9e330$export$8c435103e27cd12e
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AutoLink";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const selection = this.editor.model.document.selection;
        selection.on("change:range", ()=>{
            this.isEnabled = !selection.anchor.parent.is("element", "codeBlock");
        });
        this._enableTypingHandling();
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._enableEnterHandling();
        this._enableShiftEnterHandling();
        this._enablePasteLinking();
    }
    /**
	* For given position, returns a range that includes the whole link that contains the position.
	*
	* If position is not inside a link, returns `null`.
	*/ _expandLinkRange(model, position) {
        if (position.textNode && position.textNode.hasAttribute("linkHref")) return (0, $f1defb5a0a139b4c$export$67d698a4bb9f8c2a)(position, "linkHref", position.textNode.getAttribute("linkHref"), model);
        else return null;
    }
    /**
	* Extends the document selection to includes all links that intersects with given `selectedRange`.
	*/ _selectEntireLinks(writer, selectedRange) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selStart = selection.getFirstPosition();
        const selEnd = selection.getLastPosition();
        let updatedSelection = selectedRange.getJoined(this._expandLinkRange(model, selStart) || selectedRange);
        if (updatedSelection) updatedSelection = updatedSelection.getJoined(this._expandLinkRange(model, selEnd) || selectedRange);
        if (updatedSelection && (updatedSelection.start.isBefore(selStart) || updatedSelection.end.isAfter(selEnd))) writer.setSelection(updatedSelection);
    }
    /**
	* Enables autolinking on pasting a URL when some content is selected.
	*/ _enablePasteLinking() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        const linkCommand = editor.commands.get("link");
        clipboardPipeline.on("inputTransformation", (evt, data)=>{
            if (!this.isEnabled || !linkCommand.isEnabled || selection.isCollapsed || data.method !== "paste") return;
            if (selection.rangeCount > 1) return;
            const selectedRange = selection.getFirstRange();
            const newLink = data.dataTransfer.getData("text/plain");
            if (!newLink) return;
            const matches = newLink.match($8fb2b7bcf5f9e330$var$URL_REG_EXP);
            if (matches && matches[2] === newLink) {
                model.change((writer)=>{
                    this._selectEntireLinks(writer, selectedRange);
                    linkCommand.execute(newLink);
                });
                evt.stop();
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Enables autolinking on typing.
	*/ _enableTypingHandling() {
        const editor = this.editor;
        const watcher = new (0, $f1defb5a0a139b4c$export$72f65615ddd53ad4)(editor.model, (text)=>{
            let mappedText = text;
            if (!$8fb2b7bcf5f9e330$var$isSingleSpaceAtTheEnd(mappedText)) return;
            mappedText = mappedText.slice(0, -1);
            if ("!.:,;?".includes(mappedText[mappedText.length - 1])) mappedText = mappedText.slice(0, -1);
            const url = $8fb2b7bcf5f9e330$var$getUrlAtTextEnd(mappedText);
            if (url) return {
                url: url,
                removedTrailingCharacters: text.length - mappedText.length
            };
        });
        watcher.on("matched:data", (evt, data)=>{
            const { batch: batch, range: range, url: url, removedTrailingCharacters: removedTrailingCharacters } = data;
            if (!batch.isTyping) return;
            const linkEnd = range.end.getShiftedBy(-removedTrailingCharacters);
            const linkStart = linkEnd.getShiftedBy(-url.length);
            const linkRange = editor.model.createRange(linkStart, linkEnd);
            this._applyAutoLink(url, linkRange);
        });
        watcher.bind("isEnabled").to(this);
    }
    /**
	* Enables autolinking on the <kbd>Enter</kbd> key.
	*/ _enableEnterHandling() {
        const editor = this.editor;
        const model = editor.model;
        const enterCommand = editor.commands.get("enter");
        if (!enterCommand) return;
        enterCommand.on("execute", ()=>{
            const position = model.document.selection.getFirstPosition();
            let rangeToCheck;
            if (position.parent.previousSibling?.is("element")) rangeToCheck = model.createRangeIn(position.parent.previousSibling);
            else rangeToCheck = model.createRange(model.createPositionAt(position.parent, 0), position);
            this._checkAndApplyAutoLinkOnRange(rangeToCheck);
        });
    }
    /**
	* Enables autolinking on the <kbd>Shift</kbd>+<kbd>Enter</kbd> keyboard shortcut.
	*/ _enableShiftEnterHandling() {
        const editor = this.editor;
        const model = editor.model;
        const shiftEnterCommand = editor.commands.get("shiftEnter");
        if (!shiftEnterCommand) return;
        shiftEnterCommand.on("execute", ()=>{
            const position = model.document.selection.getFirstPosition();
            const rangeToCheck = model.createRange(model.createPositionAt(position.parent, 0), position.getShiftedBy(-1));
            this._checkAndApplyAutoLinkOnRange(rangeToCheck);
        });
    }
    /**
	* Checks if the passed range contains a linkable text.
	*/ _checkAndApplyAutoLinkOnRange(rangeToCheck) {
        const model = this.editor.model;
        const { text: text, range: range } = (0, $f1defb5a0a139b4c$export$fbaa9c739dad3a12)(rangeToCheck, model);
        const url = $8fb2b7bcf5f9e330$var$getUrlAtTextEnd(text);
        if (url) {
            const linkRange = model.createRange(range.end.getShiftedBy(-url.length), range.end);
            this._applyAutoLink(url, linkRange);
        }
    }
    /**
	* Applies a link on a given range if the link should be applied.
	*
	* @param url The URL to link.
	* @param range The text range to apply the link attribute to.
	*/ _applyAutoLink(url, range) {
        const model = this.editor.model;
        const defaultProtocol = this.editor.config.get("link.defaultProtocol");
        const fullUrl = $8fb2b7bcf5f9e330$export$18bb33376634e28b(url, defaultProtocol);
        if (!this.isEnabled || !$8fb2b7bcf5f9e330$var$isLinkAllowedOnRange(range, model) || !$8fb2b7bcf5f9e330$export$5d6cb5719fe25096(fullUrl) || $8fb2b7bcf5f9e330$var$linkIsAlreadySet(range)) return;
        this._persistAutoLink(fullUrl, range);
    }
    /**
	* Enqueues autolink changes in the model.
	*
	* @param url The URL to link.
	* @param range The text range to apply the link attribute to.
	*/ _persistAutoLink(url, range) {
        const model = this.editor.model;
        const deletePlugin = this.editor.plugins.get("Delete");
        model.enqueueChange((writer)=>{
            writer.setAttribute("linkHref", url, range);
            model.enqueueChange(()=>{
                deletePlugin.requestUndoOnBackspace();
            });
        });
    }
};
function $8fb2b7bcf5f9e330$var$isSingleSpaceAtTheEnd(text) {
    return text.length > $8fb2b7bcf5f9e330$var$MIN_LINK_LENGTH_WITH_SPACE_AT_END && text[text.length - 1] === " " && text[text.length - 2] !== " ";
}
function $8fb2b7bcf5f9e330$var$getUrlAtTextEnd(text) {
    const match = $8fb2b7bcf5f9e330$var$URL_REG_EXP.exec(text);
    return match ? match[$8fb2b7bcf5f9e330$var$URL_GROUP_IN_MATCH] : null;
}
function $8fb2b7bcf5f9e330$var$isLinkAllowedOnRange(range, model) {
    return model.schema.checkAttributeInSelection(model.createSelection(range), "linkHref");
}
function $8fb2b7bcf5f9e330$var$linkIsAlreadySet(range) {
    const item = range.start.nodeAfter;
    return !!item && item.hasAttribute("linkHref");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/link
*/ /**
* The link plugin.
*
* This is a "glue" plugin that loads the {@link module:link/linkediting~LinkEditing link editing feature}
* and {@link module:link/linkui~LinkUI link UI feature}.
*/ var $8fb2b7bcf5f9e330$export$a6c7ac8248d6e38a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $8fb2b7bcf5f9e330$export$8c435103e27cd12e,
            $8fb2b7bcf5f9e330$export$bef56d19827a3ee9,
            $8fb2b7bcf5f9e330$export$8c78d64a32116441
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Link";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkimageediting
*/ /**
* The link image engine feature.
*
* It accepts the `linkHref="url"` attribute in the model for the {@link module:image/image~Image `<imageBlock>`} element
* which allows linking images.
*/ var $8fb2b7bcf5f9e330$export$759c4e03eee9da45 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $7c22895ca0418c15$export$2cb8e8efa7161979),
            (0, $7c22895ca0418c15$export$698882cf06df44aa),
            $8fb2b7bcf5f9e330$export$8c435103e27cd12e
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkImageEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const schema = editor.model.schema;
        if (editor.plugins.has("ImageBlockEditing")) schema.extend("imageBlock", {
            allowAttributes: [
                "linkHref"
            ]
        });
        editor.conversion.for("upcast").add($8fb2b7bcf5f9e330$var$upcastLink(editor));
        editor.conversion.for("downcast").add($8fb2b7bcf5f9e330$var$downcastImageLink(editor));
        this._enableAutomaticDecorators();
        this._enableManualDecorators();
    }
    /**
	* Processes {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition automatic decorators} definitions and
	* attaches proper converters that will work when linking an image.`
	*/ _enableAutomaticDecorators() {
        const editor = this.editor;
        const automaticDecorators = editor.commands.get("link").automaticDecorators;
        if (automaticDecorators.length) editor.conversion.for("downcast").add(automaticDecorators.getDispatcherForLinkedImage());
    }
    /**
	* Processes transformed {@link module:link/utils/manualdecorator~LinkManualDecorator} instances and attaches proper converters
	* that will work when linking an image.
	*/ _enableManualDecorators() {
        const editor = this.editor;
        const command = editor.commands.get("link");
        for (const decorator of command.manualDecorators){
            if (editor.plugins.has("ImageBlockEditing")) editor.model.schema.extend("imageBlock", {
                allowAttributes: decorator.id
            });
            if (editor.plugins.has("ImageInlineEditing")) editor.model.schema.extend("imageInline", {
                allowAttributes: decorator.id
            });
            editor.conversion.for("downcast").add($8fb2b7bcf5f9e330$var$downcastImageLinkManualDecorator(decorator));
            editor.conversion.for("upcast").add($8fb2b7bcf5f9e330$var$upcastImageLinkManualDecorator(editor, decorator));
        }
    }
};
/**
* Returns a converter for linked block images that consumes the "href" attribute
* if a link contains an image.
*
* @param editor The editor instance.
*/ function $8fb2b7bcf5f9e330$var$upcastLink(editor) {
    const isImageInlinePluginLoaded = editor.plugins.has("ImageInlineEditing");
    const imageUtils = editor.plugins.get("ImageUtils");
    return (dispatcher)=>{
        dispatcher.on("element:a", (evt, data, conversionApi)=>{
            const viewLink = data.viewItem;
            const imageInLink = imageUtils.findViewImgElement(viewLink);
            if (!imageInLink) return;
            const blockImageView = imageInLink.findAncestor((element)=>imageUtils.isBlockImageView(element));
            if (isImageInlinePluginLoaded && !blockImageView) return;
            const consumableAttributes = {
                attributes: [
                    "href"
                ]
            };
            if (!conversionApi.consumable.test(viewLink, consumableAttributes)) return;
            const linkHref = viewLink.getAttribute("href");
            const modelElement = data.modelCursor.parent;
            if (modelElement.is("element", "imageBlock")) {
                conversionApi.writer.setAttribute("linkHref", linkHref, modelElement);
                conversionApi.consumable.consume(viewLink, consumableAttributes);
            }
        }, {
            priority: "high"
        });
    };
}
/**
* Creates a converter that adds `<a>` to linked block image view elements.
*/ function $8fb2b7bcf5f9e330$var$downcastImageLink(editor) {
    const imageUtils = editor.plugins.get("ImageUtils");
    return (dispatcher)=>{
        dispatcher.on("attribute:linkHref:imageBlock", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
            const viewFigure = conversionApi.mapper.toViewElement(data.item);
            const writer = conversionApi.writer;
            const linkInImage = Array.from(viewFigure.getChildren()).find((child)=>child.is("element", "a"));
            const viewImage = imageUtils.findViewImgElement(viewFigure);
            const viewImgOrPicture = viewImage.parent.is("element", "picture") ? viewImage.parent : viewImage;
            if (linkInImage) {
                if (data.attributeNewValue) writer.setAttribute("href", data.attributeNewValue, linkInImage);
                else {
                    writer.move(writer.createRangeOn(viewImgOrPicture), writer.createPositionAt(viewFigure, 0));
                    writer.remove(linkInImage);
                }
            } else {
                const linkElement = writer.createContainerElement("a", {
                    href: data.attributeNewValue
                });
                writer.insert(writer.createPositionAt(viewFigure, 0), linkElement);
                writer.move(writer.createRangeOn(viewImgOrPicture), writer.createPositionAt(linkElement, 0));
            }
        }, {
            priority: "high"
        });
    };
}
/**
* Returns a converter that decorates the `<a>` element when the image is the link label.
*/ function $8fb2b7bcf5f9e330$var$downcastImageLinkManualDecorator(decorator) {
    return (dispatcher)=>{
        const createConverter = (isApplyingConverter)=>{
            return (evt, data, conversionApi)=>{
                const viewFigure = conversionApi.mapper.toViewElement(data.item);
                const linkInImage = Array.from(viewFigure.getChildren()).find((child)=>child.is("element", "a"));
                if (!linkInImage) return;
                if (!isApplyingConverter && data.attributeOldValue) {
                    for (const [key, val] of (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(decorator.attributes))conversionApi.writer.removeAttribute(key, val, linkInImage);
                    if (decorator.classes) conversionApi.writer.removeClass(decorator.classes, linkInImage);
                    for(const key in decorator.styles)conversionApi.writer.removeStyle(key, linkInImage);
                }
                if (isApplyingConverter && data.attributeNewValue) {
                    for (const [key, val] of (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(decorator.attributes))conversionApi.writer.setAttribute(key, val, false, linkInImage);
                    if (decorator.classes) conversionApi.writer.addClass(decorator.classes, linkInImage);
                    for(const key in decorator.styles)conversionApi.writer.setStyle(key, decorator.styles[key], linkInImage);
                }
            };
        };
        dispatcher.on(`attribute:${decorator.id}:imageBlock`, createConverter(false), {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 1
        });
        dispatcher.on(`attribute:${decorator.id}:imageBlock`, createConverter(true), {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).high - 2
        });
    };
}
/**
* Returns a converter that checks whether manual decorators should be applied to the link.
*/ function $8fb2b7bcf5f9e330$var$upcastImageLinkManualDecorator(editor, decorator) {
    const isImageInlinePluginLoaded = editor.plugins.has("ImageInlineEditing");
    const imageUtils = editor.plugins.get("ImageUtils");
    return (dispatcher)=>{
        dispatcher.on("element:a", (evt, data, conversionApi)=>{
            const viewLink = data.viewItem;
            const imageInLink = imageUtils.findViewImgElement(viewLink);
            if (!imageInLink) return;
            const blockImageView = imageInLink.findAncestor((element)=>imageUtils.isBlockImageView(element));
            if (isImageInlinePluginLoaded && !blockImageView) return;
            const result = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)(decorator._createPattern()).match(viewLink);
            if (!result) return;
            if (!conversionApi.consumable.test(viewLink, result.match)) return;
            const modelElement = data.modelCursor.parent;
            if (modelElement?.is("element", "imageBlock")) {
                conversionApi.writer.setAttribute(decorator.id, true, modelElement);
                conversionApi.consumable.consume(viewLink, result.match);
            }
        }, {
            priority: "high"
        });
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkimageui
*/ /**
* The link image UI plugin.
*
* This plugin provides the `'linkImage'` button that can be displayed in the {@link module:image/imagetoolbar~ImageToolbar}.
* It can be used to wrap images in links.
*/ var $8fb2b7bcf5f9e330$export$303586952da99dee = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $8fb2b7bcf5f9e330$export$8c435103e27cd12e,
            $8fb2b7bcf5f9e330$export$bef56d19827a3ee9,
            (0, $7c22895ca0418c15$export$23a23e79feddcf18)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkImageUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        this.listenTo(viewDocument, "click", (evt, data)=>{
            if (this._isSelectedLinkedImage(editor.model.document.selection)) {
                data.preventDefault();
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this._createToolbarLinkImageButton();
    }
    /**
	* Creates a `LinkImageUI` button view.
	*
	* Clicking this button shows a {@link module:link/linkui~LinkUI#_balloon} attached to the selection.
	* When an image is already linked, the view shows {@link module:link/linkui~LinkUI#toolbarView} or
	* {@link module:link/linkui~LinkUI#formView} if it is not.
	*/ _createToolbarLinkImageButton() {
        const editor = this.editor;
        const t = editor.t;
        editor.ui.componentFactory.add("linkImage", (locale)=>{
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const plugin = editor.plugins.get("LinkUI");
            const linkCommand = editor.commands.get("link");
            button.set({
                isEnabled: true,
                label: t("Link image"),
                icon: (0, $e8dc502aba5ac3f5$export$23da1e9f164f7ea1),
                keystroke: $8fb2b7bcf5f9e330$export$1dbe65c3c53297ae,
                tooltip: true,
                isToggleable: true
            });
            button.bind("isEnabled").to(linkCommand, "isEnabled");
            button.bind("isOn").to(linkCommand, "value", (value)=>!!value);
            this.listenTo(button, "execute", ()=>{
                if (this._isSelectedLinkedImage(editor.model.document.selection)) plugin._addToolbarView();
                else plugin._showUI(true);
            });
            return button;
        });
    }
    /**
	* Returns true if a linked image (either block or inline) is the only selected element
	* in the model document.
	*/ _isSelectedLinkedImage(selection) {
        const selectedModelElement = selection.getSelectedElement();
        return this.editor.plugins.get("ImageUtils").isImage(selectedModelElement) && selectedModelElement.hasAttribute("linkHref");
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module link/linkimage
*/ /**
* The `LinkImage` plugin.
*
* This is a "glue" plugin that loads the {@link module:link/linkimageediting~LinkImageEditing link image editing feature}
* and {@link module:link/linkimageui~LinkImageUI link image UI feature}.
*/ var $8fb2b7bcf5f9e330$export$bcc977cfad2218ee = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $8fb2b7bcf5f9e330$export$759c4e03eee9da45,
            $8fb2b7bcf5f9e330$export$303586952da99dee
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkImage";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


var $3f8ba748c4f424e3$var$q = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "#",
    "$",
    "%",
    "*",
    "+",
    ",",
    "-",
    ".",
    ":",
    ";",
    "=",
    "?",
    "@",
    "[",
    "]",
    "^",
    "_",
    "{",
    "|",
    "}",
    "~"
], $3f8ba748c4f424e3$var$x = (t)=>{
    let e = 0;
    for(let r = 0; r < t.length; r++){
        let n = t[r], l = $3f8ba748c4f424e3$var$q.indexOf(n);
        e = e * 83 + l;
    }
    return e;
}, $3f8ba748c4f424e3$var$p = (t, e)=>{
    var r = "";
    for(let n = 1; n <= e; n++){
        let l = Math.floor(t) / Math.pow(83, e - n) % 83;
        r += $3f8ba748c4f424e3$var$q[Math.floor(l)];
    }
    return r;
};
var $3f8ba748c4f424e3$var$f = (t)=>{
    let e = t / 255;
    return e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
}, $3f8ba748c4f424e3$var$h = (t)=>{
    let e = Math.max(0, Math.min(1, t));
    return e <= .0031308 ? Math.trunc(e * 3294.6 + .5) : Math.trunc((1.055 * Math.pow(e, .4166666666666667) - .055) * 255 + .5);
}, $3f8ba748c4f424e3$var$F = (t)=>t < 0 ? -1 : 1, $3f8ba748c4f424e3$var$M = (t, e)=>$3f8ba748c4f424e3$var$F(t) * Math.pow(Math.abs(t), e);
var $3f8ba748c4f424e3$export$2191b9da168c6cf0 = class extends Error {
    constructor(e){
        super(e), this.name = "ValidationError", this.message = e;
    }
};
var $3f8ba748c4f424e3$var$C = (t)=>{
    if (!t || t.length < 6) throw new $3f8ba748c4f424e3$export$2191b9da168c6cf0("The blurhash string must be at least 6 characters");
    let e = $3f8ba748c4f424e3$var$x(t[0]), r = Math.floor(e / 9) + 1, n = e % 9 + 1;
    if (t.length !== 4 + 2 * n * r) throw new $3f8ba748c4f424e3$export$2191b9da168c6cf0(`blurhash length mismatch: length is ${t.length} but it should be ${4 + 2 * n * r}`);
}, $3f8ba748c4f424e3$export$dd2c1290f799dc27 = (t)=>{
    try {
        $3f8ba748c4f424e3$var$C(t);
    } catch (e) {
        return {
            result: !1,
            errorReason: e.message
        };
    }
    return {
        result: !0
    };
}, $3f8ba748c4f424e3$var$z = (t)=>{
    let e = t >> 16, r = t >> 8 & 255, n = t & 255;
    return [
        $3f8ba748c4f424e3$var$f(e),
        $3f8ba748c4f424e3$var$f(r),
        $3f8ba748c4f424e3$var$f(n)
    ];
}, $3f8ba748c4f424e3$var$L = (t, e)=>{
    let r = Math.floor(t / 361), n = Math.floor(t / 19) % 19, l = t % 19;
    return [
        $3f8ba748c4f424e3$var$M((r - 9) / 9, 2) * e,
        $3f8ba748c4f424e3$var$M((n - 9) / 9, 2) * e,
        $3f8ba748c4f424e3$var$M((l - 9) / 9, 2) * e
    ];
}, $3f8ba748c4f424e3$var$U = (t, e, r, n)=>{
    $3f8ba748c4f424e3$var$C(t), n = n | 1;
    let l = $3f8ba748c4f424e3$var$x(t[0]), m = Math.floor(l / 9) + 1, b = l % 9 + 1, i = ($3f8ba748c4f424e3$var$x(t[1]) + 1) / 166, u = new Array(b * m);
    for(let o = 0; o < u.length; o++)if (o === 0) {
        let a = $3f8ba748c4f424e3$var$x(t.substring(2, 6));
        u[o] = $3f8ba748c4f424e3$var$z(a);
    } else {
        let a = $3f8ba748c4f424e3$var$x(t.substring(4 + o * 2, 6 + o * 2));
        u[o] = $3f8ba748c4f424e3$var$L(a, i * n);
    }
    let c = e * 4, s = new Uint8ClampedArray(c * r);
    for(let o = 0; o < r; o++)for(let a = 0; a < e; a++){
        let y = 0, B = 0, R = 0;
        for(let w = 0; w < m; w++)for(let P = 0; P < b; P++){
            let G = Math.cos(Math.PI * a * P / e) * Math.cos(Math.PI * o * w / r), T = u[P + w * b];
            y += T[0] * G, B += T[1] * G, R += T[2] * G;
        }
        let V = $3f8ba748c4f424e3$var$h(y), I = $3f8ba748c4f424e3$var$h(B), E = $3f8ba748c4f424e3$var$h(R);
        s[4 * a + 0 + o * c] = V, s[4 * a + 1 + o * c] = I, s[4 * a + 2 + o * c] = E, s[4 * a + 3 + o * c] = 255;
    }
    return s;
}, $3f8ba748c4f424e3$export$2f872c0f2117be69 = $3f8ba748c4f424e3$var$U;
var $3f8ba748c4f424e3$var$A = 4, $3f8ba748c4f424e3$var$D = (t, e, r, n)=>{
    let l = 0, m = 0, b = 0, g = e * $3f8ba748c4f424e3$var$A;
    for(let u = 0; u < e; u++){
        let c = $3f8ba748c4f424e3$var$A * u;
        for(let s = 0; s < r; s++){
            let o = c + s * g, a = n(u, s);
            l += a * $3f8ba748c4f424e3$var$f(t[o]), m += a * $3f8ba748c4f424e3$var$f(t[o + 1]), b += a * $3f8ba748c4f424e3$var$f(t[o + 2]);
        }
    }
    let i = 1 / (e * r);
    return [
        l * i,
        m * i,
        b * i
    ];
}, $3f8ba748c4f424e3$var$$ = (t)=>{
    let e = $3f8ba748c4f424e3$var$h(t[0]), r = $3f8ba748c4f424e3$var$h(t[1]), n = $3f8ba748c4f424e3$var$h(t[2]);
    return (e << 16) + (r << 8) + n;
}, $3f8ba748c4f424e3$var$H = (t, e)=>{
    let r = Math.floor(Math.max(0, Math.min(18, Math.floor($3f8ba748c4f424e3$var$M(t[0] / e, .5) * 9 + 9.5)))), n = Math.floor(Math.max(0, Math.min(18, Math.floor($3f8ba748c4f424e3$var$M(t[1] / e, .5) * 9 + 9.5)))), l = Math.floor(Math.max(0, Math.min(18, Math.floor($3f8ba748c4f424e3$var$M(t[2] / e, .5) * 9 + 9.5))));
    return r * 361 + n * 19 + l;
}, $3f8ba748c4f424e3$var$O = (t, e, r, n, l)=>{
    if (n < 1 || n > 9 || l < 1 || l > 9) throw new $3f8ba748c4f424e3$export$2191b9da168c6cf0("BlurHash must have between 1 and 9 components");
    if (e * r * 4 !== t.length) throw new $3f8ba748c4f424e3$export$2191b9da168c6cf0("Width and height must match the pixels array");
    let m = [];
    for(let s = 0; s < l; s++)for(let o = 0; o < n; o++){
        let a = o == 0 && s == 0 ? 1 : 2, y = $3f8ba748c4f424e3$var$D(t, e, r, (B, R)=>a * Math.cos(Math.PI * o * B / e) * Math.cos(Math.PI * s * R / r));
        m.push(y);
    }
    let b = m[0], g = m.slice(1), i = "", u = n - 1 + (l - 1) * 9;
    i += $3f8ba748c4f424e3$var$p(u, 1);
    let c;
    if (g.length > 0) {
        let s = Math.max(...g.map((a)=>Math.max(...a))), o = Math.floor(Math.max(0, Math.min(82, Math.floor(s * 166 - .5))));
        c = (o + 1) / 166, i += $3f8ba748c4f424e3$var$p(o, 1);
    } else c = 1, i += $3f8ba748c4f424e3$var$p(0, 1);
    return i += $3f8ba748c4f424e3$var$p($3f8ba748c4f424e3$var$$(b), 4), g.forEach((s)=>{
        i += $3f8ba748c4f424e3$var$p($3f8ba748c4f424e3$var$H(s, c), 2);
    }), i;
}, $3f8ba748c4f424e3$export$c564cdbbe6da493 = $3f8ba748c4f424e3$var$O;




/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 

/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module cloud-services/token/token
*/ const $308936d8e01dd630$var$DEFAULT_OPTIONS = {
    autoRefresh: true
};
const $308936d8e01dd630$var$DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME = 36e5;
const $308936d8e01dd630$var$TOKEN_FAILED_REFRESH_TIMEOUT_TIME = 5e3;
const $308936d8e01dd630$var$TokenBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The class representing the token used for communication with CKEditor Cloud Services.
* The value of the token is retrieved from the specified URL and refreshed every 1 hour by default.
* If the token retrieval fails, the token will automatically retry in 5 seconds intervals.
*/ var $308936d8e01dd630$export$50792b0e93539fde = class Token extends $308936d8e01dd630$var$TokenBase {
    /**
	* Base refreshing function.
	*/ _refresh;
    /**
	* Cached token options.
	*/ _options;
    /**
	* `setTimeout()` id for a token refresh when {@link module:cloud-services/token/token~CloudServicesTokenOptions auto refresh}
	* is enabled.
	*/ _tokenRefreshTimeout;
    /**
	* Flag indicating whether the token has been destroyed.
	*/ _isDestroyed = false;
    /**
	* Creates `Token` instance.
	* Method `init` should be called after using the constructor or use `create` method instead.
	*
	* @param tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
	* value is a function it has to match the {@link module:cloud-services/token/token~Token#refreshToken} interface.
	*/ constructor(tokenUrlOrRefreshToken, options = {}){
        super();
        if (!tokenUrlOrRefreshToken) /**
		* A `tokenUrl` must be provided as the first constructor argument.
		*
		* @error token-missing-token-url
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("token-missing-token-url", this);
        if (options.initValue) this._validateTokenValue(options.initValue);
        this.set("value", options.initValue);
        if (typeof tokenUrlOrRefreshToken === "function") this._refresh = tokenUrlOrRefreshToken;
        else this._refresh = ()=>$308936d8e01dd630$var$defaultRefreshToken(tokenUrlOrRefreshToken);
        this._options = {
            ...$308936d8e01dd630$var$DEFAULT_OPTIONS,
            ...options
        };
    }
    /**
	* Initializes the token.
	*/ init() {
        return new Promise((resolve, reject)=>{
            if (!this.value) {
                this.refreshToken().then(resolve).catch(reject);
                return;
            }
            if (this._options.autoRefresh) this._registerRefreshTokenTimeout();
            resolve(this);
        });
    }
    /**
	* Refresh token method. Useful in a method form as it can be overridden in tests.
	*
	* This method will be invoked periodically based on the token expiry date after first call to keep the token up-to-date
	* (requires {@link module:cloud-services/token/token~CloudServicesTokenOptions auto refresh option} to be set).
	*
	* If the token refresh fails, the method will retry in 5 seconds intervals until success or the token gets
	* {@link #destroy destroyed}.
	*/ refreshToken() {
        const autoRefresh = this._options.autoRefresh;
        return this._refresh().then((value)=>{
            this._validateTokenValue(value);
            this.set("value", value);
            if (autoRefresh) this._registerRefreshTokenTimeout();
            return this;
        }).catch((err)=>{
            /**
			* You will see this warning when the CKEditor {@link module:cloud-services/token/token~Token token} could not be refreshed.
			* This may be a result of a network error, a token endpoint (server) error, or an invalid
			* {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl token URL configuration}.
			*
			* If this warning repeats, please make sure that the configuration is correct and that the token
			* endpoint is up and running. {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl Learn more}
			* about token configuration.
			*
			* **Note:** If the token's {@link module:cloud-services/token/token~CloudServicesTokenOptions auto refresh option}
			* is enabled, attempts to refresh will be made until success or token's
			* {@link module:cloud-services/token/token~Token#destroy destruction}.
			*
			* @error token-refresh-failed
			* @param {boolean} autoRefresh Whether the token will keep auto refreshing.
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("token-refresh-failed", {
                autoRefresh: autoRefresh
            });
            if (autoRefresh) this._registerRefreshTokenTimeout($308936d8e01dd630$var$TOKEN_FAILED_REFRESH_TIMEOUT_TIME);
            throw err;
        });
    }
    /**
	* Destroys token instance. Stops refreshing.
	*/ destroy() {
        this._isDestroyed = true;
        clearTimeout(this._tokenRefreshTimeout);
    }
    /**
	* Checks whether the provided token follows the JSON Web Tokens (JWT) format.
	*
	* @param tokenValue The token to validate.
	*/ _validateTokenValue(tokenValue) {
        const isString = typeof tokenValue === "string";
        const isPlainString = !/^".*"$/.test(tokenValue);
        const isJWTFormat = isString && tokenValue.split(".").length === 3;
        if (!(isPlainString && isJWTFormat)) /**
		* The provided token must follow the [JSON Web Tokens](https://jwt.io/introduction/) format.
		*
		* @error token-not-in-jwt-format
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("token-not-in-jwt-format", this);
    }
    /**
	* Registers a refresh token timeout for the time taken from token.
	*/ _registerRefreshTokenTimeout(timeoutTime) {
        clearTimeout(this._tokenRefreshTimeout);
        if (this._isDestroyed) return;
        const tokenRefreshTimeoutTime = timeoutTime || this._getTokenRefreshTimeoutTime();
        this._tokenRefreshTimeout = setTimeout(()=>{
            this.refreshToken();
        }, tokenRefreshTimeoutTime);
    }
    /**
	* Returns token refresh timeout time calculated from expire time in the token payload.
	*
	* If the token parse fails or the token payload doesn't contain, the default DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME is returned.
	*/ _getTokenRefreshTimeoutTime() {
        try {
            const [, binaryTokenPayload] = this.value.split(".");
            const { exp: tokenExpireTime } = JSON.parse(atob(binaryTokenPayload));
            if (!tokenExpireTime) return $308936d8e01dd630$var$DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME;
            if (tokenExpireTime > 2147483647) console.warn("Token expiration time exceeds 32-bit integer range. This might cause unpredictable token refresh timing. Token expiration time should always be provided in seconds.", {
                tokenExpireTime: tokenExpireTime
            });
            return Math.floor((tokenExpireTime * 1e3 - Date.now()) / 2);
        } catch  {
            return $308936d8e01dd630$var$DEFAULT_TOKEN_REFRESH_TIMEOUT_TIME;
        }
    }
    /**
	* Creates a initialized {@link module:cloud-services/token/token~Token} instance.
	*
	* @param tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
	* value is a function it has to match the {@link module:cloud-services/token/token~Token#refreshToken} interface.
	*/ static create(tokenUrlOrRefreshToken, options = {}) {
        return new Token(tokenUrlOrRefreshToken, options).init();
    }
};
/**
* This function is called in a defined interval by the {@link ~Token} class. It also can be invoked manually.
* It should return a promise, which resolves with the new token value.
* If any error occurs it should return a rejected promise with an error message.
*/ function $308936d8e01dd630$var$defaultRefreshToken(tokenUrl) {
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open("GET", tokenUrl);
        xhr.addEventListener("load", ()=>{
            const statusCode = xhr.status;
            const xhrResponse = xhr.response;
            if (statusCode < 200 || statusCode > 299) /**
			* Cannot download new token from the provided url.
			*
			* @error token-cannot-download-new-token
			*/ return reject(new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("token-cannot-download-new-token", null));
            return resolve(xhrResponse);
        });
        xhr.addEventListener("error", ()=>reject(/* @__PURE__ */ new Error("Network Error")));
        xhr.addEventListener("abort", ()=>reject(/* @__PURE__ */ new Error("Abort")));
        xhr.send();
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $308936d8e01dd630$var$BASE64_HEADER_REG_EXP = /^data:(\S*?);base64,/;
const $308936d8e01dd630$var$FileUploaderBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$1f0c3be316c44594)();
/**
* FileUploader class used to upload single file.
*/ var $308936d8e01dd630$export$1a5cb5295a7d2749 = class extends $308936d8e01dd630$var$FileUploaderBase {
    /**
	* A file that is being uploaded.
	*/ file;
    xhr;
    /**
	* CKEditor Cloud Services access token.
	*/ _token;
    /**
	* CKEditor Cloud Services API address.
	*/ _apiAddress;
    /**
	* Creates `FileUploader` instance.
	*
	* @param fileOrData A blob object or a data string encoded with Base64.
	* @param token Token used for authentication.
	* @param apiAddress API address.
	*/ constructor(fileOrData, token, apiAddress){
        super();
        if (!fileOrData) /**
		* File must be provided as the first argument.
		*
		* @error fileuploader-missing-file
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("fileuploader-missing-file", null);
        if (!token) /**
		* Token must be provided as the second argument.
		*
		* @error fileuploader-missing-token
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("fileuploader-missing-token", null);
        if (!apiAddress) /**
		* Api address must be provided as the third argument.
		*
		* @error fileuploader-missing-api-address
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("fileuploader-missing-api-address", null);
        this.file = $308936d8e01dd630$var$_isBase64(fileOrData) ? $308936d8e01dd630$var$_base64ToBlob(fileOrData) : fileOrData;
        this._token = token;
        this._apiAddress = apiAddress;
    }
    /**
	* Registers callback on `progress` event.
	*/ onProgress(callback) {
        this.on("progress", (event, data)=>callback(data));
        return this;
    }
    /**
	* Registers callback on `error` event. Event is called once when error occurs.
	*/ onError(callback) {
        this.once("error", (event, data)=>callback(data));
        return this;
    }
    /**
	* Aborts upload process.
	*/ abort() {
        this.xhr.abort();
    }
    /**
	* Sends XHR request to API.
	*/ send() {
        this._prepareRequest();
        this._attachXHRListeners();
        return this._sendRequest();
    }
    /**
	* Prepares XHR request.
	*/ _prepareRequest() {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", this._apiAddress);
        xhr.setRequestHeader("Authorization", this._token.value);
        xhr.responseType = "json";
        this.xhr = xhr;
    }
    /**
	* Attaches listeners to the XHR.
	*/ _attachXHRListeners() {
        const xhr = this.xhr;
        const onError = (message)=>{
            return ()=>this.fire("error", message);
        };
        xhr.addEventListener("error", onError("Network Error"));
        xhr.addEventListener("abort", onError("Abort"));
        /* v8 ignore else -- @preserve */ if (xhr.upload) xhr.upload.addEventListener("progress", (event)=>{
            if (event.lengthComputable) this.fire("progress", {
                total: event.total,
                uploaded: event.loaded
            });
        });
        xhr.addEventListener("load", ()=>{
            const statusCode = xhr.status;
            const xhrResponse = xhr.response;
            if (statusCode < 200 || statusCode > 299) return this.fire("error", xhrResponse.message || xhrResponse.error);
        });
    }
    /**
	* Sends XHR request.
	*/ _sendRequest() {
        const formData = new FormData();
        const xhr = this.xhr;
        formData.append("file", this.file);
        return new Promise((resolve, reject)=>{
            xhr.addEventListener("load", ()=>{
                const statusCode = xhr.status;
                const xhrResponse = xhr.response;
                if (statusCode < 200 || statusCode > 299) {
                    if (xhrResponse.message) /**
					* Uploading file failed.
					*
					* @error fileuploader-uploading-data-failed
					*/ return reject(new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("fileuploader-uploading-data-failed", this, {
                        message: xhrResponse.message
                    }));
                    return reject(xhrResponse.error);
                }
                return resolve(xhrResponse);
            });
            xhr.addEventListener("error", ()=>reject(/* @__PURE__ */ new Error("Network Error")));
            xhr.addEventListener("abort", ()=>reject(/* @__PURE__ */ new Error("Abort")));
            xhr.send(formData);
        });
    }
};
/**
* Transforms Base64 string data into file.
*
* @param base64 String data.
*/ function $308936d8e01dd630$var$_base64ToBlob(base64, sliceSize = 512) {
    try {
        const contentType = base64.match($308936d8e01dd630$var$BASE64_HEADER_REG_EXP)[1];
        const base64Data = atob(base64.replace($308936d8e01dd630$var$BASE64_HEADER_REG_EXP, ""));
        const byteArrays = [];
        for(let offset = 0; offset < base64Data.length; offset += sliceSize){
            const slice = base64Data.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for(let i = 0; i < slice.length; i++)byteNumbers[i] = slice.charCodeAt(i);
            byteArrays.push(new Uint8Array(byteNumbers));
        }
        return new Blob(byteArrays, {
            type: contentType
        });
    } catch  {
        /**
		* Problem with decoding Base64 image data.
		*
		* @error fileuploader-decoding-image-data-error
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("fileuploader-decoding-image-data-error", null);
    }
}
/**
* Checks that string is Base64.
*/ function $308936d8e01dd630$var$_isBase64(string) {
    if (typeof string !== "string") return false;
    return !!string.match($308936d8e01dd630$var$BASE64_HEADER_REG_EXP)?.length;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module cloud-services/uploadgateway/uploadgateway
*/ /**
* UploadGateway abstracts file uploads to CKEditor Cloud Services.
*/ var $308936d8e01dd630$export$edc491820c14b45d = class {
    /**
	* CKEditor Cloud Services access token.
	*/ _token;
    /**
	* CKEditor Cloud Services API address.
	*/ _apiAddress;
    /**
	* Creates `UploadGateway` instance.
	*
	* @param token Token used for authentication.
	* @param apiAddress API address.
	*/ constructor(token, apiAddress){
        if (!token) /**
		* Token must be provided.
		*
		* @error uploadgateway-missing-token
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("uploadgateway-missing-token", null);
        if (!apiAddress) /**
		* Api address must be provided.
		*
		* @error uploadgateway-missing-api-address
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("uploadgateway-missing-api-address", null);
        this._token = token;
        this._apiAddress = apiAddress;
    }
    /**
	* Creates a {@link module:cloud-services/uploadgateway/fileuploader~FileUploader} instance that wraps
	* file upload process. The file is being sent at a time when the
	* {@link module:cloud-services/uploadgateway/fileuploader~FileUploader#send} method is called.
	*
	* ```ts
	* const token = await Token.create( 'https://token-endpoint' );
	* new UploadGateway( token, 'https://example.org' )
	* 	.upload( 'FILE' )
	* 	.onProgress( ( data ) => console.log( data ) )
	* 	.send()
	* 	.then( ( response ) => console.log( response ) );
	* ```
	*
	* @param {Blob|String} fileOrData A blob object or a data string encoded with Base64.
	* @returns {module:cloud-services/uploadgateway/fileuploader~FileUploader} Returns `FileUploader` instance.
	*/ upload(fileOrData) {
        return new $308936d8e01dd630$export$1a5cb5295a7d2749(fileOrData, this._token, this._apiAddress);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module cloud-services/cloudservicescore
*/ /**
* The `CloudServicesCore` plugin exposes the base API for communication with CKEditor Cloud Services.
*/ var $308936d8e01dd630$export$9e621b433e03cbb = class extends (0, $7ca4ca5784e50ca9$export$a3df350528b28529) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CloudServicesCore";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Creates the {@link module:cloud-services/token/token~Token} instance.
	*
	* @param tokenUrlOrRefreshToken Endpoint address to download the token or a callback that provides the token. If the
	* value is a function it has to match the {@link module:cloud-services/token/token~Token#refreshToken} interface.
	* @param options.initValue Initial value of the token.
	* @param options.autoRefresh Specifies whether to start the refresh automatically.
	*/ createToken(tokenUrlOrRefreshToken, options) {
        return new $308936d8e01dd630$export$50792b0e93539fde(tokenUrlOrRefreshToken, options);
    }
    /**
	* Creates the {@link module:cloud-services/uploadgateway/uploadgateway~UploadGateway} instance.
	*
	* @param token Token used for authentication.
	* @param apiAddress API address.
	*/ createUploadGateway(token, apiAddress) {
        return new $308936d8e01dd630$export$edc491820c14b45d(token, apiAddress);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module cloud-services/cloudservices
*/ /**
* Plugin introducing the integration between CKEditor 5 and CKEditor Cloud Services .
*
* It initializes the token provider based on
* the {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig `config.cloudService`}.
*/ var $308936d8e01dd630$export$c8fb568fd3d3ad20 = class extends (0, $7ca4ca5784e50ca9$export$a3df350528b28529) {
    /**
	* The authentication token URL for CKEditor Cloud Services or a callback to the token value promise. See the
	* {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl} for more details.
	*/ tokenUrl;
    /**
	* The URL to which the files should be uploaded.
	*/ uploadUrl;
    /**
	* The URL for web socket communication, used by the `RealTimeCollaborativeEditing` plugin. Every customer (organization in the CKEditor
	* Ecosystem dashboard) has their own, unique URLs to communicate with CKEditor Cloud Services. The URL can be found in the
	* CKEditor Ecosystem customer dashboard.
	*
	* Note: Unlike most plugins, `RealTimeCollaborativeEditing` is not included in any CKEditor 5 build and needs to be installed manually.
	* Check [Collaboration overview](https://ckeditor.com/docs/ckeditor5/latest/features/collaboration/overview.html) for more details.
	*/ webSocketUrl;
    /**
	* An optional parameter used for integration with CKEditor Cloud Services when uploading the editor build to cloud services.
	*
	* Whenever the editor build or the configuration changes, this parameter should be set to a new, unique value to differentiate
	* the new bundle (build + configuration) from the old ones.
	*/ bundleVersion;
    /**
	* Specifies whether the token should be automatically refreshed when it expires.
	*/ autoRefresh = true;
    /**
	* Other plugins use this token for the authorization process. It handles token requesting and refreshing.
	* Its value is `null` when {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl} is not provided.
	*
	* @readonly
	*/ token = null;
    /**
	* A map of token object instances keyed by the token URLs.
	*/ _tokens = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CloudServices";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $308936d8e01dd630$export$9e621b433e03cbb
        ];
    }
    /**
	* @inheritDoc
	*/ async init() {
        const options = this.context.config.get("cloudServices") || {};
        for (const [key, value] of Object.entries(options))this[key] = value;
        if (!this.tokenUrl) {
            this.token = null;
            return;
        }
        const uninitializedToken = this.context.plugins.get("CloudServicesCore").createToken(this.tokenUrl, {
            autoRefresh: this.autoRefresh
        });
        try {
            this.token = await uninitializedToken.init();
            this._tokens.set(this.tokenUrl, this.token);
        } catch (error) {
            uninitializedToken.destroy();
            throw error;
        }
    }
    /**
	* Registers an additional authentication token URL for CKEditor Cloud Services or a callback to the token value promise. See the
	* {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl} for more details.
	*
	* @param tokenUrl The authentication token URL for CKEditor Cloud Services or a callback to the token value promise.
	*/ async registerTokenUrl(tokenUrl) {
        if (this._tokens.has(tokenUrl)) return this.getTokenFor(tokenUrl);
        const token = await this.context.plugins.get("CloudServicesCore").createToken(tokenUrl, {
            autoRefresh: this.autoRefresh
        }).init();
        this._tokens.set(tokenUrl, token);
        return token;
    }
    /**
	* Returns an authentication token provider previously registered by {@link #registerTokenUrl}.
	*
	* @param tokenUrl The authentication token URL for CKEditor Cloud Services or a callback to the token value promise.
	*/ getTokenFor(tokenUrl) {
        const token = this._tokens.get(tokenUrl);
        if (!token) /**
		* The provided `tokenUrl` was not registered by {@link module:cloud-services/cloudservices~CloudServices#registerTokenUrl}.
		*
		* @error cloudservices-token-not-registered
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("cloudservices-token-not-registered", this);
        return token;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        for (const token of this._tokens.values())token.destroy();
    }
};



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboxui
*/ /**
* Introduces UI components for the `CKBox` plugin.
*
* The plugin introduces two UI components to the {@link module:ui/componentfactory~ComponentFactory UI component factory}:
*
* * the `'ckbox'` toolbar button,
* * the `'menuBar:ckbox'` menu bar component, which is by default added to the `'Insert'` menu.
*
* It also integrates with the `insertImage` toolbar component and `menuBar:insertImage` menu component.
*/ var $25ed63831c0cafe6$export$db3ed49e2487bf33 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        if (!editor.commands.get("ckbox")) return;
        editor.ui.componentFactory.add("ckbox", ()=>this._createFileToolbarButton());
        editor.ui.componentFactory.add("menuBar:ckbox", ()=>this._createFileMenuBarButton());
        if (editor.plugins.has("ImageInsertUI")) editor.plugins.get("ImageInsertUI").registerIntegration({
            name: "assetManager",
            observable: ()=>editor.commands.get("ckbox"),
            buttonViewCreator: ()=>this._createImageToolbarButton(),
            formViewCreator: ()=>this._createImageDropdownButton(),
            menuBarButtonViewCreator: (isOnly)=>this._createImageMenuBarButton(isOnly ? "insertOnly" : "insertNested")
        });
    }
    /**
	* Creates the base for various kinds of the button component provided by this feature.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const view = new ButtonClass(locale);
        const command = editor.commands.get("ckbox");
        view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
        view.on("execute", ()=>{
            editor.execute("ckbox");
        });
        return view;
    }
    /**
	* Creates a simple toolbar button for files management, with an icon and a tooltip.
	*/ _createFileToolbarButton() {
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$3ffee1eb83242296);
        button.label = t("Open file manager");
        button.tooltip = true;
        return button;
    }
    /**
	* Creates a simple toolbar button for images management, with an icon and a tooltip.
	*/ _createImageToolbarButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace image with file manager") : t("Insert image with file manager"));
        button.tooltip = true;
        return button;
    }
    /**
	* Creates a button for images management for the dropdown view, with an icon, text and no tooltip.
	*/ _createImageDropdownButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.withText = true;
        button.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace with file manager") : t("Insert with file manager"));
        button.on("execute", ()=>{
            imageInsertUI.dropdownView.isOpen = false;
        });
        return button;
    }
    /**
	* Creates a button for files management for the menu bar.
	*/ _createFileMenuBarButton() {
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        button.icon = (0, $e8dc502aba5ac3f5$export$3ffee1eb83242296);
        button.withText = true;
        button.label = t("File");
        return button;
    }
    /**
	* Creates a button for images management for the menu bar.
	*/ _createImageMenuBarButton(type) {
        const translateVariableKey = this.editor.locale.t;
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.withText = true;
        switch(type){
            case "insertOnly":
                button.label = translateVariableKey("Image");
                break;
            case "insertNested":
                button.label = t("With file manager");
        }
        return button;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Converts image source set provided by the CKBox into an object containing:
* - responsive URLs for the "webp" image format,
* - one fallback URL for browsers that do not support the "webp" format.
*
* @internal
*/ function $25ed63831c0cafe6$export$9828801b54bf1c4d(imageUrls) {
    const responsiveUrls = [];
    let maxWidth = 0;
    for(const key in imageUrls){
        const width = parseInt(key, 10);
        if (!isNaN(width)) {
            if (width > maxWidth) maxWidth = width;
            responsiveUrls.push(`${imageUrls[key]} ${key}w`);
        }
    }
    const imageSources = [
        {
            srcset: responsiveUrls.join(","),
            sizes: `(max-width: ${maxWidth}px) 100vw, ${maxWidth}px`,
            type: "image/webp"
        }
    ];
    return {
        imageFallbackUrl: imageUrls.default,
        imageSources: imageSources
    };
}
/**
* Returns a workspace id to use for communication with the CKBox service.
*
* @param defaultWorkspaceId The default workspace to use taken from editor config.
* @internal
*/ function $25ed63831c0cafe6$export$b6b48bb90194cf08(token, defaultWorkspaceId) {
    const [, binaryTokenPayload] = token.value.split(".");
    const payload = JSON.parse(atob(binaryTokenPayload));
    const workspaces = payload.auth?.ckbox?.workspaces || [
        payload.aud
    ];
    if (!defaultWorkspaceId) return workspaces[0];
    if (payload.auth?.ckbox?.role == "superadmin" || workspaces.includes(defaultWorkspaceId)) return defaultWorkspaceId;
    return null;
}
/**
* Default resolution for decoding blurhash values.
* Relatively small values must be used in order to ensure acceptable performance.
*/ const $25ed63831c0cafe6$var$BLUR_RESOLUTION = 32;
/**
* Generates an image data URL from its `blurhash` representation.
*
* @internal
*/ function $25ed63831c0cafe6$export$7a61342298f95609(hash) {
    if (!hash) return;
    try {
        const resolutionInPx = `${$25ed63831c0cafe6$var$BLUR_RESOLUTION}px`;
        const canvas = document.createElement("canvas");
        canvas.setAttribute("width", resolutionInPx);
        canvas.setAttribute("height", resolutionInPx);
        const ctx = canvas.getContext("2d");
        /* istanbul ignore next -- @preserve */ if (!ctx) return;
        const imageData = ctx.createImageData($25ed63831c0cafe6$var$BLUR_RESOLUTION, $25ed63831c0cafe6$var$BLUR_RESOLUTION);
        const decoded = (0, $3f8ba748c4f424e3$export$2f872c0f2117be69)(hash, $25ed63831c0cafe6$var$BLUR_RESOLUTION, $25ed63831c0cafe6$var$BLUR_RESOLUTION);
        imageData.data.set(decoded);
        ctx.putImageData(imageData, 0, 0);
        return canvas.toDataURL();
    } catch  {
        return;
    }
}
/**
* Sends the HTTP request.
*
* @internal
* @param options Configuration options
* @param options.url The URL where the request will be sent.
* @param options.signal The AbortSignal to abort the request when needed.
* @param options.authorization The authorization token for the request.
* @param options.method The HTTP method (default: 'GET').
* @param options.data Additional data to send.
* @param options.onUploadProgress A callback informing about the upload progress.
*/ function $25ed63831c0cafe6$export$dfd2ec4d263788f5({ url: url, method: method = "GET", data: data, onUploadProgress: onUploadProgress, signal: signal, authorization: authorization }) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url.toString());
    xhr.setRequestHeader("Authorization", authorization);
    xhr.setRequestHeader("CKBox-Version", "CKEditor 5");
    xhr.responseType = "json";
    const abortCallback = ()=>{
        xhr.abort();
    };
    return new Promise((resolve, reject)=>{
        signal.throwIfAborted();
        signal.addEventListener("abort", abortCallback);
        xhr.addEventListener("loadstart", ()=>{
            signal.addEventListener("abort", abortCallback);
        });
        xhr.addEventListener("loadend", ()=>{
            signal.removeEventListener("abort", abortCallback);
        });
        xhr.addEventListener("error", ()=>{
            reject();
        });
        xhr.addEventListener("abort", ()=>{
            reject();
        });
        xhr.addEventListener("load", ()=>{
            const response = xhr.response;
            if (!response || response.statusCode >= 400) return reject(response && response.message);
            resolve(response);
        });
        /* istanbul ignore else -- @preserve */ if (onUploadProgress) xhr.upload.addEventListener("progress", (evt)=>{
            onUploadProgress(evt);
        });
        xhr.send(data);
    });
}
const $25ed63831c0cafe6$var$MIME_TO_EXTENSION = {
    "image/gif": "gif",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
    "image/bmp": "bmp",
    "image/tiff": "tiff"
};
/**
* Returns an extension a typical file in the specified `mimeType` format would have.
*
* @internal
*/ function $25ed63831c0cafe6$export$62530f70bc6897d6(mimeType) {
    return $25ed63831c0cafe6$var$MIME_TO_EXTENSION[mimeType];
}
/**
* Tries to fetch the given `url` and returns 'content-type' of the response.
*
* @internal
*/ async function $25ed63831c0cafe6$export$2b87a1bb8a08dd5b(url, options) {
    try {
        const response = await fetch(url, {
            method: "HEAD",
            cache: "force-cache",
            ...options
        });
        if (!response.ok) return "";
        return response.headers.get("content-type") || "";
    } catch  {
        return "";
    }
}
/**
* Returns an extension from the given value.
*
* @internal
*/ function $25ed63831c0cafe6$export$80b793fe628787ee(file) {
    return file.name.match(/\.(?<ext>[^.]+)$/).groups.ext.toLowerCase();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $25ed63831c0cafe6$var$ASSET_INSERTION_WAIT_TIMEOUT = 1e3;
/**
* The CKBox command. It is used by the {@link module:ckbox/ckboxediting~CKBoxEditing CKBox editing feature} to open the CKBox file manager.
* The file manager allows inserting an image or a link to a file into the editor content.
*
* ```ts
* editor.execute( 'ckbox' );
* ```
*
* **Note:** This command uses other features to perform the following tasks:
* - To insert images it uses the {@link module:image/image/insertimagecommand~InsertImageCommand 'insertImage'} command from the
* {@link module:image/image~Image Image feature}.
* - To insert links to other files it uses the {@link module:link/linkcommand~LinkCommand 'link'} command from the
* {@link module:link/link~Link Link feature}.
*/ var $25ed63831c0cafe6$export$ee9e5f9108325ff0 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A set of all chosen assets. They are stored temporarily and they are automatically removed 1 second after being chosen.
	* Chosen assets have to be "remembered" for a while to be able to map the given asset with the element inserted into the model.
	* This association map is then used to set the ID on the model element.
	*
	* All chosen assets are automatically removed after the timeout, because (theoretically) it may happen that they will never be
	* inserted into the model, even if the {@link module:link/linkcommand~LinkCommand `'link'`} command or the
	* {@link module:image/image/insertimagecommand~InsertImageCommand `'insertImage'`} command is enabled. Such a case may arise when
	* another plugin blocks the command execution. Then, in order not to keep the chosen (but not inserted) assets forever, we delete
	* them automatically to prevent memory leakage. The 1 second timeout is enough to insert the asset into the model and extract the
	* ID from the chosen asset.
	*
	* The assets are stored only if
	* the {@link module:ckbox/ckboxconfig~CKBoxConfig#ignoreDataId `config.ckbox.ignoreDataId`} option is set to `false` (by default).
	*
	* @internal
	*/ _chosenAssets = /* @__PURE__ */ new Set();
    /**
	* The DOM element that acts as a mounting point for the CKBox dialog.
	*/ _wrapper = null;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._initListeners();
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* @inheritDoc
	*/ execute() {
        this.fire("ckbox:open");
    }
    /**
	* Indicates if the CKBox dialog is already opened.
	*
	* @protected
	* @returns {Boolean}
	*/ _getValue() {
        return this._wrapper !== null;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*/ _checkEnabled() {
        const imageCommand = this.editor.commands.get("insertImage");
        const linkCommand = this.editor.commands.get("link");
        if (!imageCommand.isEnabled && !linkCommand.isEnabled) return false;
        return true;
    }
    /**
	* Creates the options object for the CKBox dialog.
	*
	* @returns The object with properties:
	* - theme The theme for CKBox dialog.
	* - language The language for CKBox dialog.
	* - tokenUrl The token endpoint URL.
	* - serviceOrigin The base URL of the API service.
	* - forceDemoLabel Whether to force "Powered by CKBox" link.
	* - assets.onChoose The callback function invoked after choosing the assets.
	* - dialog.onClose The callback function invoked after closing the CKBox dialog.
	* - dialog.width The dialog width in pixels.
	* - dialog.height The dialog height in pixels.
	* - categories.icons Allows setting custom icons for categories.
	* - view.openLastView Sets if the last view visited by the user will be reopened
	* on the next startup.
	* - view.startupFolderId Sets the ID of the folder that will be opened on startup.
	* - view.startupCategoryId Sets the ID of the category that will be opened on startup.
	* - view.hideMaximizeButton Sets whether to hide the ‘Maximize’ button.
	* - view.componentsHideTimeout Sets timeout after which upload components are hidden
	* after completed upload.
	* - view.dialogMinimizeTimeout Sets timeout after which upload dialog is minimized
	* after completed upload.
	*/ _prepareOptions() {
        const ckboxConfig = this.editor.config.get("ckbox");
        const dialog = ckboxConfig.dialog;
        const categories = ckboxConfig.categories;
        const view = ckboxConfig.view;
        const upload = ckboxConfig.upload;
        return {
            theme: ckboxConfig.theme,
            language: ckboxConfig.language,
            tokenUrl: ckboxConfig.tokenUrl,
            serviceOrigin: ckboxConfig.serviceOrigin,
            forceDemoLabel: ckboxConfig.forceDemoLabel,
            choosableFileExtensions: ckboxConfig.choosableFileExtensions,
            assets: {
                onChoose: (assets)=>this.fire("ckbox:choose", assets)
            },
            dialog: {
                onClose: ()=>this.fire("ckbox:close"),
                width: dialog && dialog.width,
                height: dialog && dialog.height
            },
            categories: categories && {
                icons: categories.icons
            },
            view: view && {
                openLastView: view.openLastView,
                startupFolderId: view.startupFolderId,
                startupCategoryId: view.startupCategoryId,
                hideMaximizeButton: view.hideMaximizeButton
            },
            upload: upload && {
                componentsHideTimeout: upload.componentsHideTimeout,
                dialogMinimizeTimeout: upload.dialogMinimizeTimeout
            }
        };
    }
    /**
	* Initializes various event listeners for the `ckbox:*` events, because all functionality of the `ckbox` command is event-based.
	*/ _initListeners() {
        const editor = this.editor;
        const model = editor.model;
        const shouldInsertDataId = !editor.config.get("ckbox.ignoreDataId");
        const downloadableFilesConfig = editor.config.get("ckbox.downloadableFiles");
        this.on("ckbox", ()=>{
            this.refresh();
        }, {
            priority: "low"
        });
        this.on("ckbox:open", ()=>{
            if (!this.isEnabled || this.value) return;
            this._wrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "div", {
                class: "ck ckbox-wrapper"
            });
            document.body.appendChild(this._wrapper);
            window.CKBox.mount(this._wrapper, this._prepareOptions());
        });
        this.on("ckbox:close", ()=>{
            if (!this.value) return;
            this._wrapper.remove();
            this._wrapper = null;
            editor.editing.view.focus();
        });
        this.on("ckbox:choose", (evt, assets)=>{
            if (!this.isEnabled) return;
            const imageCommand = editor.commands.get("insertImage");
            const linkCommand = editor.commands.get("link");
            const assetsToProcess = $25ed63831c0cafe6$var$prepareAssets({
                assets: assets,
                downloadableFilesConfig: downloadableFilesConfig,
                isImageAllowed: imageCommand.isEnabled,
                isLinkAllowed: linkCommand.isEnabled
            });
            const assetsCount = assetsToProcess.length;
            if (assetsCount === 0) return;
            model.change((writer)=>{
                for (const asset of assetsToProcess){
                    const isLastAsset = asset === assetsToProcess[assetsCount - 1];
                    const isSingleAsset = assetsCount === 1;
                    this._insertAsset(asset, isLastAsset, writer, isSingleAsset);
                    if (shouldInsertDataId) {
                        setTimeout(()=>this._chosenAssets.delete(asset), $25ed63831c0cafe6$var$ASSET_INSERTION_WAIT_TIMEOUT);
                        this._chosenAssets.add(asset);
                    }
                }
            });
            editor.editing.view.focus();
        });
        this.listenTo(editor, "destroy", ()=>{
            this.fire("ckbox:close");
            this._chosenAssets.clear();
        });
    }
    /**
	* Inserts the asset into the model.
	*
	* @param asset The asset to be inserted.
	* @param isLastAsset Indicates if the current asset is the last one from the chosen set.
	* @param writer An instance of the model writer.
	* @param isSingleAsset It's true when only one asset is processed.
	*/ _insertAsset(asset, isLastAsset, writer, isSingleAsset) {
        const selection = this.editor.model.document.selection;
        writer.removeSelectionAttribute("linkHref");
        if (asset.type === "image") this._insertImage(asset);
        else this._insertLink(asset, writer, isSingleAsset);
        if (!isLastAsset) writer.setSelection(selection.getLastPosition());
    }
    /**
	* Inserts the image by calling the `insertImage` command.
	*
	* @param asset The asset to be inserted.
	*/ _insertImage(asset) {
        const editor = this.editor;
        const { imageFallbackUrl: imageFallbackUrl, imageSources: imageSources, imageTextAlternative: imageTextAlternative, imageWidth: imageWidth, imageHeight: imageHeight, imagePlaceholder: imagePlaceholder } = asset.attributes;
        editor.execute("insertImage", {
            source: {
                src: imageFallbackUrl,
                sources: imageSources,
                alt: imageTextAlternative,
                width: imageWidth,
                height: imageHeight,
                ...imagePlaceholder ? {
                    placeholder: imagePlaceholder
                } : null
            }
        });
    }
    /**
	* Inserts the link to the asset by calling the `link` command.
	*
	* @param asset The asset to be inserted.
	* @param writer An instance of the model writer.
	* @param isSingleAsset It's true when only one asset is processed.
	*/ _insertLink(asset, writer, isSingleAsset) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const { linkName: linkName, linkHref: linkHref } = asset.attributes;
        if (selection.isCollapsed) {
            const selectionAttributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(selection.getAttributes());
            const textNode = writer.createText(linkName, selectionAttributes);
            if (!isSingleAsset) {
                const selectionLastPosition = selection.getLastPosition();
                const parentElement = selectionLastPosition.parent;
                if (!(parentElement.name === "paragraph" && parentElement.isEmpty)) editor.execute("insertParagraph", {
                    position: selectionLastPosition
                });
                const range = model.insertContent(textNode);
                writer.setSelection(range);
                editor.execute("link", linkHref);
                return;
            }
            const range = model.insertContent(textNode);
            writer.setSelection(range);
        }
        editor.execute("link", linkHref);
    }
};
/**
* Parses the chosen assets into the internal data format. Filters out chosen assets that are not allowed.
*/ function $25ed63831c0cafe6$var$prepareAssets({ downloadableFilesConfig: downloadableFilesConfig, assets: assets, isImageAllowed: isImageAllowed, isLinkAllowed: isLinkAllowed }) {
    return assets.map((asset)=>$25ed63831c0cafe6$var$isImage(asset) ? {
            id: asset.data.id,
            type: "image",
            attributes: $25ed63831c0cafe6$export$84e8e23bbb749fab(asset)
        } : {
            id: asset.data.id,
            type: "link",
            attributes: $25ed63831c0cafe6$var$prepareLinkAssetAttributes(asset, downloadableFilesConfig)
        }).filter((asset)=>asset.type === "image" ? isImageAllowed : isLinkAllowed);
}
/**
* Parses the assets attributes into the internal data format.
*
* @internal
*/ function $25ed63831c0cafe6$export$84e8e23bbb749fab(asset) {
    const { imageFallbackUrl: imageFallbackUrl, imageSources: imageSources } = $25ed63831c0cafe6$export$9828801b54bf1c4d(asset.data.imageUrls);
    const { description: description, width: width, height: height, blurHash: blurHash } = asset.data.metadata;
    const imagePlaceholder = $25ed63831c0cafe6$export$7a61342298f95609(blurHash);
    return {
        imageFallbackUrl: imageFallbackUrl,
        imageSources: imageSources,
        imageTextAlternative: description || "",
        imageWidth: width,
        imageHeight: height,
        ...imagePlaceholder ? {
            imagePlaceholder: imagePlaceholder
        } : null
    };
}
/**
* Parses the assets attributes into the internal data format.
*
* @param asset The asset to prepare the attributes for.
* @param config The CKBox download asset configuration.
*/ function $25ed63831c0cafe6$var$prepareLinkAssetAttributes(asset, config) {
    return {
        linkName: asset.data.name,
        linkHref: $25ed63831c0cafe6$var$getAssetUrl(asset, config)
    };
}
/**
* Checks whether the asset is an image.
*/ function $25ed63831c0cafe6$var$isImage(asset) {
    const metadata = asset.data.metadata;
    if (!metadata) return false;
    return metadata.width && metadata.height;
}
/**
* Creates the URL for the asset.
*
* @param asset The asset to create the URL for.
* @param config The CKBox download asset configuration.
*/ function $25ed63831c0cafe6$var$getAssetUrl(asset, config) {
    const url = new URL(asset.data.url);
    if ($25ed63831c0cafe6$var$isDownloadableAsset(asset, config)) url.searchParams.set("download", "true");
    return url.toString();
}
/**
* Determines if download should be enabled for given asset based on configuration.
*
* @param asset The asset to check.
* @param config The CKBox download asset configuration.
*/ function $25ed63831c0cafe6$var$isDownloadableAsset(asset, config) {
    if (typeof config === "function") return config(asset);
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboxutils
*/ const $25ed63831c0cafe6$var$DEFAULT_CKBOX_THEME_NAME = "lark";
/**
* The CKBox utilities plugin.
*/ var $25ed63831c0cafe6$export$3a6c52c4616d7522 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* CKEditor Cloud Services access token.
	*/ _token;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $308936d8e01dd630$export$c8fb568fd3d3ad20)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const hasConfiguration = !!editor.config.get("ckbox");
        const isLibraryLoaded = !!window.CKBox;
        if (!hasConfiguration && !isLibraryLoaded) return;
        editor.config.define("ckbox", {
            serviceOrigin: "https://api.ckbox.io",
            defaultUploadCategories: null,
            ignoreDataId: false,
            language: editor.locale.uiLanguage,
            theme: $25ed63831c0cafe6$var$DEFAULT_CKBOX_THEME_NAME,
            tokenUrl: editor.config.get("cloudServices.tokenUrl")
        });
        const cloudServices = editor.plugins.get((0, $308936d8e01dd630$export$c8fb568fd3d3ad20));
        const cloudServicesTokenUrl = editor.config.get("cloudServices.tokenUrl");
        const ckboxTokenUrl = editor.config.get("ckbox.tokenUrl");
        if (!ckboxTokenUrl) /**
		* The {@link module:ckbox/ckboxconfig~CKBoxConfig#tokenUrl `config.ckbox.tokenUrl`} or the
		* {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig#tokenUrl `config.cloudServices.tokenUrl`}
		* configuration is required for the CKBox plugin.
		*
		* ```ts
		* ClassicEditor.create( {
		* 	attachTo: document.createElement( 'div' ),
		* 	ckbox: {
		* 		tokenUrl: "YOUR_TOKEN_URL"
		* 		// ...
		* 	}
		* 	// ...
		* } );
		* ```
		*
		* @error ckbox-plugin-missing-token-url
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ckbox-plugin-missing-token-url", this);
        if (ckboxTokenUrl == cloudServicesTokenUrl) this._token = Promise.resolve(cloudServices.token);
        else this._token = cloudServices.registerTokenUrl(ckboxTokenUrl);
        this._token = this._token.then(async (token)=>{
            await this._authorizePrivateCategoriesAccess(token.value);
            return token;
        });
    }
    /**
	* Returns a token used by the CKBox plugin for communication with the CKBox service.
	*/ getToken() {
        return this._token;
    }
    /**
	* The ID of workspace to use when uploading an image.
	*/ async getWorkspaceId() {
        const t = this.editor.t;
        const cannotAccessDefaultWorkspaceError = t("Cannot access default workspace.");
        const defaultWorkspaceId = this.editor.config.get("ckbox.defaultUploadWorkspaceId");
        const workspaceId = $25ed63831c0cafe6$export$b6b48bb90194cf08(await this._token, defaultWorkspaceId);
        if (workspaceId == null) {
            /**
			* The user is not authorized to access the workspace defined in  the`ckbox.defaultUploadWorkspaceId` configuration.
			*
			* @error ckbox-access-default-workspace-error
			*/ (0, $c7bc2cb7e2db0227$export$58da9968c3170cb1)("ckbox-access-default-workspace-error");
            throw cannotAccessDefaultWorkspaceError;
        }
        return workspaceId;
    }
    /**
	* Resolves a promise with an object containing a category with which the uploaded file is associated or an error code.
	*/ async getCategoryIdForFile(fileOrUrl, options) {
        const t = this.editor.t;
        const cannotFindCategoryError = t("Cannot determine a category for the uploaded file.");
        const noConnectionError = t("No internet connection. Check your connection and try again.");
        if ((0, $c7bc2cb7e2db0227$export$a81aa9769d155ec5)()) throw noConnectionError;
        const defaultCategories = this.editor.config.get("ckbox.defaultUploadCategories");
        const allCategoriesPromise = this._getAvailableCategories(options);
        const extension = typeof fileOrUrl == "string" ? $25ed63831c0cafe6$export$62530f70bc6897d6(await $25ed63831c0cafe6$export$2b87a1bb8a08dd5b(fileOrUrl, options)) : $25ed63831c0cafe6$export$80b793fe628787ee(fileOrUrl);
        const allCategories = await allCategoriesPromise;
        if (!allCategories) throw (0, $c7bc2cb7e2db0227$export$a81aa9769d155ec5)() ? noConnectionError : cannotFindCategoryError;
        if (defaultCategories) {
            const userCategory = Object.keys(defaultCategories).find((category)=>{
                return defaultCategories[category].find((e)=>e.toLowerCase() == extension);
            });
            if (userCategory) {
                const serverCategory = allCategories.find((category)=>category.id === userCategory || category.name === userCategory);
                if (!serverCategory) throw cannotFindCategoryError;
                return serverCategory.id;
            }
        }
        const category = allCategories.find((category)=>category.extensions.find((e)=>e.toLowerCase() == extension));
        if (!category) throw (0, $c7bc2cb7e2db0227$export$a81aa9769d155ec5)() ? noConnectionError : cannotFindCategoryError;
        return category.id;
    }
    /**
	* Resolves a promise with an array containing available categories with which the uploaded file can be associated.
	*
	* If the API returns limited results, the method will collect all items.
	*/ async _getAvailableCategories(options) {
        const ITEMS_PER_REQUEST = 50;
        const editor = this.editor;
        const token = this._token;
        const { signal: signal } = options;
        const serviceOrigin = editor.config.get("ckbox.serviceOrigin");
        const workspaceId = await this.getWorkspaceId();
        try {
            const result = [];
            let offset = 0;
            let remainingItems;
            do {
                const data = await fetchCategories(offset);
                result.push(...data.items);
                remainingItems = data.totalCount - (offset + ITEMS_PER_REQUEST);
                offset += ITEMS_PER_REQUEST;
            }while (remainingItems > 0);
            return result;
        } catch  {
            signal.throwIfAborted();
            /**
			* Fetching a list of available categories with which an uploaded file can be associated failed.
			*
			* @error ckbox-fetch-category-http-error
			*/ (0, $c7bc2cb7e2db0227$export$58da9968c3170cb1)("ckbox-fetch-category-http-error");
            return;
        }
        async function fetchCategories(offset) {
            const categoryUrl = new URL("categories", serviceOrigin);
            categoryUrl.searchParams.set("limit", String(ITEMS_PER_REQUEST));
            categoryUrl.searchParams.set("offset", String(offset));
            categoryUrl.searchParams.set("workspaceId", workspaceId);
            return $25ed63831c0cafe6$export$dfd2ec4d263788f5({
                url: categoryUrl,
                signal: signal,
                authorization: (await token).value
            });
        }
    }
    /**
	* Authorize private categories access to the CKBox service. Request sets cookie for the current domain,
	* that allows user to preview images from private categories.
	*/ async _authorizePrivateCategoriesAccess(token) {
        const serviceUrl = this.editor.config.get("ckbox.serviceOrigin");
        const formData = new FormData();
        formData.set("token", token);
        await fetch(`${serviceUrl}/categories/authorizePrivateAccess`, {
            method: "POST",
            credentials: "include",
            mode: "no-cors",
            body: formData
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboxuploadadapter
*/ /**
* A plugin that enables file uploads in CKEditor 5 using the CKBox server–side connector.
* See the {@glink features/file-management/ckbox CKBox file manager integration} guide to learn how to configure
* and use this feature as well as find out more about the full integration with the file manager
* provided by the {@link module:ckbox/ckbox~CKBox} plugin.
*
* Check out the {@glink features/images/image-upload/image-upload Image upload overview} guide to learn about
* other ways to upload images into CKEditor 5.
*/ var $25ed63831c0cafe6$export$f6a5cde555893cb4 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $7c22895ca0418c15$export$7cd72690bdb810ee),
            (0, $7c22895ca0418c15$export$7ec8ba77907346bb),
            (0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51),
            $25ed63831c0cafe6$export$754522567f942cfd
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxUploadAdapter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ async afterInit() {
        const editor = this.editor;
        const hasConfiguration = !!editor.config.get("ckbox");
        const isLibraryLoaded = !!window.CKBox;
        if (!hasConfiguration && !isLibraryLoaded) return;
        const fileRepository = editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51));
        const ckboxUtils = editor.plugins.get($25ed63831c0cafe6$export$3a6c52c4616d7522);
        fileRepository.createUploadAdapter = (loader)=>new $25ed63831c0cafe6$var$Adapter(loader, editor, ckboxUtils);
        const shouldInsertDataId = !editor.config.get("ckbox.ignoreDataId");
        const imageUploadEditing = editor.plugins.get((0, $7c22895ca0418c15$export$7cd72690bdb810ee));
        if (shouldInsertDataId) imageUploadEditing.on("uploadComplete", (evt, { imageElement: imageElement, data: data })=>{
            editor.model.change((writer)=>{
                writer.setAttribute("ckboxImageId", data.ckboxImageId, imageElement);
            });
        });
    }
};
/**
* Upload adapter for CKBox.
*/ var $25ed63831c0cafe6$var$Adapter = class {
    /**
	* FileLoader instance to use during the upload.
	*/ loader;
    /**
	* CKEditor Cloud Services access token.
	*/ token;
    /**
	* The editor instance.
	*/ editor;
    /**
	* The abort controller for aborting asynchronous processes.
	*/ controller;
    /**
	* The base URL where all requests should be sent.
	*/ serviceOrigin;
    /**
	* The reference to CKBoxUtils plugin.
	*/ ckboxUtils;
    /**
	* Creates a new adapter instance.
	*/ constructor(loader, editor, ckboxUtils){
        this.loader = loader;
        this.token = ckboxUtils.getToken();
        this.ckboxUtils = ckboxUtils;
        this.editor = editor;
        this.controller = new AbortController();
        this.serviceOrigin = editor.config.get("ckbox.serviceOrigin");
    }
    /**
	* Starts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#upload
	*/ async upload() {
        const ckboxUtils = this.ckboxUtils;
        const t = this.editor.t;
        const file = await this.loader.file;
        const category = await ckboxUtils.getCategoryIdForFile(file, {
            signal: this.controller.signal
        });
        const uploadUrl = new URL("assets", this.serviceOrigin);
        const formData = new FormData();
        uploadUrl.searchParams.set("workspaceId", await ckboxUtils.getWorkspaceId());
        formData.append("categoryId", category);
        formData.append("file", file);
        const requestConfig = {
            method: "POST",
            url: uploadUrl,
            data: formData,
            onUploadProgress: (evt)=>{
                /* istanbul ignore else -- @preserve */ if (evt.lengthComputable) {
                    this.loader.uploadTotal = evt.total;
                    this.loader.uploaded = evt.loaded;
                }
            },
            signal: this.controller.signal,
            authorization: (await this.token).value
        };
        return $25ed63831c0cafe6$export$dfd2ec4d263788f5(requestConfig).then(async (data)=>{
            const imageUrls = $25ed63831c0cafe6$export$9828801b54bf1c4d(data.imageUrls);
            return {
                ckboxImageId: data.id,
                default: imageUrls.imageFallbackUrl,
                sources: imageUrls.imageSources
            };
        }).catch(()=>{
            const genericError = t("Cannot upload file:") + ` ${file.name}.`;
            return Promise.reject(genericError);
        });
    }
    /**
	* Aborts the upload process.
	*
	* @see module:upload/filerepository~UploadAdapter#abort
	*/ abort() {
        this.controller.abort();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboxediting
*/ const $25ed63831c0cafe6$var$COMMAND_FORCE_DISABLE_ID = "NoPermission";
/**
* The CKBox editing feature. It introduces the {@link module:ckbox/ckboxcommand~CKBoxCommand CKBox command} and
* {@link module:ckbox/ckboxuploadadapter~CKBoxUploadAdapter CKBox upload adapter}.
*/ var $25ed63831c0cafe6$export$754522567f942cfd = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $8fb2b7bcf5f9e330$export$8c435103e27cd12e),
            (0, $7c22895ca0418c15$export$ee5c7d7da5e0c82f),
            $25ed63831c0cafe6$export$f6a5cde555893cb4,
            $25ed63831c0cafe6$export$3a6c52c4616d7522
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!this._shouldBeInitialised()) return;
        this._checkImagePlugins();
        if ($25ed63831c0cafe6$var$isLibraryLoaded()) editor.commands.add("ckbox", new $25ed63831c0cafe6$export$ee9e5f9108325ff0(editor));
        $25ed63831c0cafe6$var$isUploadPermissionGranted(editor).then((isCreateAssetAllowed)=>{
            if (!isCreateAssetAllowed) this._blockImageCommands();
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        if (!this._shouldBeInitialised()) return;
        if (!editor.config.get("ckbox.ignoreDataId")) {
            this._initSchema();
            this._initConversion();
            this._initFixers();
        }
    }
    /**
	* Returns true only when the integrator intentionally wants to use the plugin, i.e. when the `config.ckbox` exists or
	* the CKBox JavaScript library is loaded.
	*/ _shouldBeInitialised() {
        return !!this.editor.config.get("ckbox") || $25ed63831c0cafe6$var$isLibraryLoaded();
    }
    /**
	* Blocks `uploadImage` and `ckboxImageEdit` commands.
	*/ _blockImageCommands() {
        const editor = this.editor;
        const uploadImageCommand = editor.commands.get("uploadImage");
        const imageEditingCommand = editor.commands.get("ckboxImageEdit");
        if (uploadImageCommand) {
            uploadImageCommand.isAccessAllowed = false;
            uploadImageCommand.forceDisabled($25ed63831c0cafe6$var$COMMAND_FORCE_DISABLE_ID);
        }
        if (imageEditingCommand) imageEditingCommand.forceDisabled($25ed63831c0cafe6$var$COMMAND_FORCE_DISABLE_ID);
    }
    /**
	* Checks if at least one image plugin is loaded.
	*/ _checkImagePlugins() {
        const editor = this.editor;
        if (!editor.plugins.has("ImageBlockEditing") && !editor.plugins.has("ImageInlineEditing")) /**
		* The CKBox feature requires one of the following plugins to be loaded to work correctly:
		*
		* * {@link module:image/imageblock~ImageBlock},
		* * {@link module:image/imageinline~ImageInline},
		* * {@link module:image/image~Image} (loads both `ImageBlock` and `ImageInline`)
		*
		* Please make sure your editor configuration is correct.
		*
		* @error ckbox-plugin-image-feature-missing
		* @param {module:core/editor/editor~Editor} editor The editor instance.
		*/ (0, $c7bc2cb7e2db0227$export$58da9968c3170cb1)("ckbox-plugin-image-feature-missing", editor);
    }
    /**
	* Extends the schema to allow the `ckboxImageId` and `ckboxLinkId` attributes for links and images.
	*/ _initSchema() {
        const schema = this.editor.model.schema;
        schema.extend("$text", {
            allowAttributes: "ckboxLinkId"
        });
        if (schema.isRegistered("imageBlock")) schema.extend("imageBlock", {
            allowAttributes: [
                "ckboxImageId",
                "ckboxLinkId"
            ]
        });
        if (schema.isRegistered("imageInline")) schema.extend("imageInline", {
            allowAttributes: [
                "ckboxImageId",
                "ckboxLinkId"
            ]
        });
        schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("linkHref")) return false;
        }, "ckboxLinkId");
    }
    /**
	* Configures the upcast and downcast conversions for the `ckboxImageId` and `ckboxLinkId` attributes.
	*/ _initConversion() {
        const editor = this.editor;
        editor.conversion.for("downcast").add((dispatcher)=>{
            dispatcher.on("attribute:ckboxLinkId:imageBlock", (evt, data, conversionApi)=>{
                const { writer: writer, mapper: mapper, consumable: consumable } = conversionApi;
                if (!consumable.consume(data.item, evt.name)) return;
                const linkInImage = [
                    ...mapper.toViewElement(data.item).getChildren()
                ].find((child)=>child.name === "a");
                if (!linkInImage) return;
                if (data.item.hasAttribute("ckboxLinkId")) writer.setAttribute("data-ckbox-resource-id", data.item.getAttribute("ckboxLinkId"), linkInImage);
                else writer.removeAttribute("data-ckbox-resource-id", linkInImage);
            }, {
                priority: "low"
            });
            dispatcher.on("attribute:ckboxLinkId", (evt, data, conversionApi)=>{
                const { writer: writer, mapper: mapper, consumable: consumable } = conversionApi;
                if (!consumable.consume(data.item, evt.name)) return;
                if (data.attributeOldValue) {
                    const viewElement = $25ed63831c0cafe6$var$createLinkElement(writer, data.attributeOldValue);
                    writer.unwrap(mapper.toViewRange(data.range), viewElement);
                }
                if (data.attributeNewValue) {
                    const viewElement = $25ed63831c0cafe6$var$createLinkElement(writer, data.attributeNewValue);
                    if (data.item.is("selection")) {
                        const viewSelection = writer.document.selection;
                        writer.wrap(viewSelection.getFirstRange(), viewElement);
                    } else writer.wrap(mapper.toViewRange(data.range), viewElement);
                }
            }, {
                priority: "low"
            });
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:a", (evt, data, conversionApi)=>{
                const { writer: writer, consumable: consumable } = conversionApi;
                if (!data.viewItem.getAttribute("href")) return;
                if (!consumable.consume(data.viewItem, {
                    attributes: [
                        "data-ckbox-resource-id"
                    ]
                })) return;
                const attributeValue = data.viewItem.getAttribute("data-ckbox-resource-id");
                if (!attributeValue) return;
                if (data.modelRange) for (let item of data.modelRange.getItems()){
                    if (item.is("$textProxy")) item = item.textNode;
                    if ($25ed63831c0cafe6$var$shouldUpcastAttributeForNode(item)) writer.setAttribute("ckboxLinkId", attributeValue, item);
                }
                else {
                    const modelElement = data.modelCursor.nodeBefore || data.modelCursor.parent;
                    writer.setAttribute("ckboxLinkId", attributeValue, modelElement);
                }
            }, {
                priority: "low"
            });
        });
        editor.conversion.for("downcast").attributeToAttribute({
            model: "ckboxImageId",
            view: "data-ckbox-resource-id"
        });
        editor.conversion.for("upcast").elementToAttribute({
            model: {
                key: "ckboxImageId",
                value: (viewElement)=>viewElement.getAttribute("data-ckbox-resource-id")
            },
            view: {
                attributes: {
                    "data-ckbox-resource-id": /[\s\S]+/
                }
            }
        });
        const replaceImageSourceCommand = editor.commands.get("replaceImageSource");
        if (replaceImageSourceCommand) this.listenTo(replaceImageSourceCommand, "cleanupImage", (_, [writer, image])=>{
            writer.removeAttribute("ckboxImageId", image);
        });
    }
    /**
	* Registers post-fixers that add or remove the `ckboxLinkId` and `ckboxImageId` attributes.
	*/ _initFixers() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        model.document.registerPostFixer($25ed63831c0cafe6$var$syncDataIdPostFixer(editor));
        model.document.registerPostFixer($25ed63831c0cafe6$var$injectSelectionPostFixer(selection));
    }
};
/**
* A post-fixer that synchronizes the asset ID with the model element.
*/ function $25ed63831c0cafe6$var$syncDataIdPostFixer(editor) {
    return (writer)=>{
        let changed = false;
        const model = editor.model;
        const ckboxCommand = editor.commands.get("ckbox");
        if (!ckboxCommand) return changed;
        for (const entry of model.document.differ.getChanges()){
            if (entry.type !== "insert" && entry.type !== "attribute") continue;
            const range = entry.type === "insert" ? new (0, $b9b9f2bdf9c6137f$export$a3091252a5e626ba)(entry.position, entry.position.getShiftedBy(entry.length)) : entry.range;
            const isLinkHrefAttributeRemoval = entry.type === "attribute" && entry.attributeKey === "linkHref" && entry.attributeNewValue === null;
            for (const item of range.getItems()){
                if (isLinkHrefAttributeRemoval && item.hasAttribute("ckboxLinkId")) {
                    writer.removeAttribute("ckboxLinkId", item);
                    changed = true;
                    continue;
                }
                const assets = $25ed63831c0cafe6$var$findAssetsForItem(item, ckboxCommand._chosenAssets);
                for (const asset of assets){
                    const attributeName = asset.type === "image" ? "ckboxImageId" : "ckboxLinkId";
                    if (asset.id === item.getAttribute(attributeName)) continue;
                    writer.setAttribute(attributeName, asset.id, item);
                    changed = true;
                }
            }
        }
        return changed;
    };
}
/**
* A post-fixer that removes the `ckboxLinkId` from the selection if it does not represent a link anymore.
*/ function $25ed63831c0cafe6$var$injectSelectionPostFixer(selection) {
    return (writer)=>{
        if (!selection.hasAttribute("linkHref") && selection.hasAttribute("ckboxLinkId")) {
            writer.removeSelectionAttribute("ckboxLinkId");
            return true;
        }
        return false;
    };
}
/**
* Tries to find the asset that is associated with the model element by comparing the attributes:
* - the image fallback URL with the `src` attribute for images,
* - the link URL with the `href` attribute for links.
*
* For any model element, zero, one or more than one asset can be found (e.g. a linked image may be associated with the link asset and the
* image asset).
*/ function $25ed63831c0cafe6$var$findAssetsForItem(item, assets) {
    const isImageElement = item.is("element", "imageInline") || item.is("element", "imageBlock");
    const isLinkElement = item.hasAttribute("linkHref");
    return [
        ...assets
    ].filter((asset)=>{
        if (asset.type === "image" && isImageElement) return asset.attributes.imageFallbackUrl === item.getAttribute("src");
        if (asset.type === "link" && isLinkElement) return asset.attributes.linkHref === item.getAttribute("linkHref");
    });
}
/**
* Creates view link element with the requested ID.
*/ function $25ed63831c0cafe6$var$createLinkElement(writer, id) {
    const viewElement = writer.createAttributeElement("a", {
        "data-ckbox-resource-id": id
    }, {
        priority: 5
    });
    writer.setCustomProperty("link", true, viewElement);
    return viewElement;
}
/**
* Checks if the model element may have the `ckboxLinkId` attribute.
*/ function $25ed63831c0cafe6$var$shouldUpcastAttributeForNode(node) {
    if (node.is("$text")) return true;
    if (node.is("element", "imageInline") || node.is("element", "imageBlock")) return true;
    return false;
}
/**
* Returns true if the CKBox library is loaded, false otherwise.
*/ function $25ed63831c0cafe6$var$isLibraryLoaded() {
    return !!window.CKBox;
}
/**
* Checks is access allowed to upload assets.
*/ async function $25ed63831c0cafe6$var$isUploadPermissionGranted(editor) {
    const ckboxUtils = editor.plugins.get($25ed63831c0cafe6$export$3a6c52c4616d7522);
    const origin = editor.config.get("ckbox.serviceOrigin");
    const url = new URL("permissions", origin);
    const { value: value } = await ckboxUtils.getToken();
    const response = await $25ed63831c0cafe6$export$dfd2ec4d263788f5({
        url: url,
        authorization: value,
        signal: new AbortController().signal
    });
    return Object.values(response).some((category)=>category["asset:create"]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckbox
*/ /**
* The CKBox feature, a bridge between the CKEditor 5 WYSIWYG editor and the CKBox file manager and uploader.
*
* This is a "glue" plugin which enables:
*
* * {@link module:ckbox/ckboxediting~CKBoxEditing},
* * {@link module:ckbox/ckboxui~CKBoxUI},
*
* See the {@glink features/file-management/ckbox CKBox integration} guide to learn how to configure and use this feature.
*
* Check out the {@glink features/images/image-upload/image-upload Image upload} guide to learn about other ways to upload
* images into CKEditor 5.
*/ var $25ed63831c0cafe6$export$73e53d20f104f7b7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBox";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $25ed63831c0cafe6$export$754522567f942cfd,
            $25ed63831c0cafe6$export$db3ed49e2487bf33
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboximageedit/utils
*/ /**
* @internal
*/ function $25ed63831c0cafe6$export$b2d98788b635e116(allowExternalImagesEditing) {
    const checkUrl = $25ed63831c0cafe6$var$createUrlChecker(allowExternalImagesEditing);
    return (element)=>{
        if (!(element.is("element", "imageInline") || element.is("element", "imageBlock"))) return false;
        if (element.hasAttribute("ckboxImageId")) return true;
        if (element.hasAttribute("src")) return checkUrl(element.getAttribute("src"));
        return false;
    };
}
function $25ed63831c0cafe6$var$createUrlChecker(allowExternalImagesEditing) {
    if (Array.isArray(allowExternalImagesEditing)) {
        const urlMatchers = allowExternalImagesEditing.map($25ed63831c0cafe6$var$createUrlChecker);
        return (src)=>urlMatchers.some((matcher)=>matcher(src));
    }
    if (allowExternalImagesEditing == "origin") {
        const origin = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.location.origin;
        return (src)=>new URL(src, (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.baseURI).origin == origin;
    }
    if (typeof allowExternalImagesEditing == "function") return allowExternalImagesEditing;
    if (allowExternalImagesEditing instanceof RegExp) return (src)=>!!(src.match(allowExternalImagesEditing) || src.replace(/^https?:\/\//, "").match(allowExternalImagesEditing));
    return ()=>false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboximageedit/ckboximageeditcommand
*/ /**
* The CKBox edit image command.
*
* Opens the CKBox dialog for editing the image.
*/ var $25ed63831c0cafe6$export$c682843f1ee13ee3 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The DOM element that acts as a mounting point for the CKBox Edit Image dialog.
	*/ _wrapper = null;
    /**
	* The states of image processing in progress.
	*/ _processInProgress = /* @__PURE__ */ new Set();
    /**
	* Determines if the element can be edited.
	*/ _canEdit;
    /**
	* A wrapper function to prepare mount options. Ensures that at most one preparation is in-flight.
	*/ _prepareOptions;
    /**
	* CKBox's onClose function runs before the final cleanup, potentially causing
	* page layout changes after it finishes. To address this, we use a setTimeout hack
	* to ensure that floating elements on the page maintain their correct position.
	*
	* See: https://github.com/ckeditor/ckeditor5/issues/16153.
	*/ _updateUiDelayed = (0, $c7bc2cb7e2db0227$export$1391212d75b2ee65)(()=>this.editor.ui.update(), 0);
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.value = false;
        this._canEdit = $25ed63831c0cafe6$export$b2d98788b635e116(editor.config.get("ckbox.allowExternalImagesEditing"));
        this._prepareOptions = (0, $c7bc2cb7e2db0227$export$fa449de2c34088fe)((signal, state)=>this._prepareOptionsAbortable(signal, state));
        this._prepareListeners();
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        this.value = this._getValue();
        const selectedElement = editor.model.document.selection.getSelectedElement();
        this.isEnabled = !!selectedElement && this._canEdit(selectedElement) && !this._checkIfElementIsBeingProcessed(selectedElement);
    }
    /**
	* Opens the CKBox Image Editor dialog for editing the image.
	*/ execute() {
        if (this._getValue()) return;
        const wrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "div", {
            class: "ck ckbox-wrapper"
        });
        this._wrapper = wrapper;
        this.value = true;
        document.body.appendChild(this._wrapper);
        const processingState = {
            element: this.editor.model.document.selection.getSelectedElement(),
            controller: new AbortController()
        };
        this._prepareOptions(processingState).then((options)=>window.CKBox.mountImageEditor(wrapper, options), (error)=>{
            if (this._wrapper !== wrapper) return;
            const editor = this.editor;
            const t = editor.t;
            editor.plugins.get((0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd)).showWarning(typeof error == "string" ? error : t("Failed to determine category of edited image."), {
                namespace: "ckbox"
            });
            console.error(error);
            this._handleImageEditorClose();
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._handleImageEditorClose();
        this._prepareOptions.abort();
        this._updateUiDelayed.cancel();
        for (const state of this._processInProgress.values())state.controller.abort();
        super.destroy();
    }
    /**
	* Indicates if the CKBox Image Editor dialog is already opened.
	*/ _getValue() {
        return this._wrapper !== null;
    }
    /**
	* Creates the options object for the CKBox Image Editor dialog.
	*/ async _prepareOptionsAbortable(signal, state) {
        const editor = this.editor;
        const ckboxConfig = editor.config.get("ckbox");
        const ckboxUtils = editor.plugins.get($25ed63831c0cafe6$export$3a6c52c4616d7522);
        const { element: element } = state;
        let imageMountOptions;
        const ckboxImageId = element.getAttribute("ckboxImageId");
        if (ckboxImageId) imageMountOptions = {
            assetId: ckboxImageId
        };
        else {
            const imageUrl = new URL(element.getAttribute("src"), document.baseURI).href;
            imageMountOptions = {
                imageUrl: imageUrl,
                uploadCategoryId: await ckboxUtils.getCategoryIdForFile(imageUrl, {
                    signal: signal
                })
            };
        }
        return {
            ...imageMountOptions,
            imageEditing: {
                allowOverwrite: false
            },
            tokenUrl: ckboxConfig.tokenUrl,
            language: ckboxConfig.language,
            ...ckboxConfig.serviceOrigin && {
                serviceOrigin: ckboxConfig.serviceOrigin
            },
            onClose: ()=>this._handleImageEditorClose(),
            onSave: (asset)=>this._handleImageEditorSave(state, asset)
        };
    }
    /**
	* Initializes event lister for an event of removing an image.
	*/ _prepareListeners() {
        this.listenTo(this.editor.model.document, "change:data", ()=>{
            this._getProcessingStatesOfDeletedImages().forEach((processingState)=>{
                processingState.controller.abort();
            });
        });
    }
    /**
	* Gets processing states of images that have been deleted in the mean time.
	*/ _getProcessingStatesOfDeletedImages() {
        const states = [];
        for (const state of this._processInProgress.values())if (state.element.root.rootName == "$graveyard") states.push(state);
        return states;
    }
    _checkIfElementIsBeingProcessed(selectedElement) {
        for (const { element: element } of this._processInProgress)if ((0, $a48d2f3392454588$export$248d38f6296296c5)(element, selectedElement)) return true;
        return false;
    }
    /**
	* Closes the CKBox Image Editor dialog.
	*/ _handleImageEditorClose() {
        if (!this._wrapper) return;
        this._wrapper.remove();
        this._wrapper = null;
        this.editor.editing.view.focus();
        this._updateUiDelayed();
        this.refresh();
    }
    /**
	* Save edited image. In case server respond with "success" replace with edited image,
	* otherwise show notification error.
	*/ _handleImageEditorSave(state, asset) {
        const t = this.editor.locale.t;
        const notification = this.editor.plugins.get((0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd));
        const pendingActions = this.editor.plugins.get((0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5));
        const action = pendingActions.add(t("Processing the edited image."));
        this._processInProgress.add(state);
        this._showImageProcessingIndicator(state.element, asset);
        this.refresh();
        this._waitForAssetProcessed(asset.data.id, state.controller.signal).then((asset)=>{
            this._replaceImage(state.element, asset);
        }, (error)=>{
            this.editor.editing.reconvertItem(state.element);
            if (state.controller.signal.aborted) return;
            if (!error || error instanceof (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)) notification.showWarning((0, $c7bc2cb7e2db0227$export$a81aa9769d155ec5)() ? t("No internet connection. Check your connection and try again.") : t("Server failed to process the image."), {
                namespace: "ckbox"
            });
            else console.error(error);
        }).finally(()=>{
            this._processInProgress.delete(state);
            pendingActions.remove(action);
            this.refresh();
        });
    }
    /**
	* Get asset's status on server. If server responds with "success" status then
	* image is already proceeded and ready for saving.
	*/ async _getAssetStatusFromServer(id, signal) {
        const ckboxUtils = this.editor.plugins.get($25ed63831c0cafe6$export$3a6c52c4616d7522);
        const url = new URL("assets/" + id, this.editor.config.get("ckbox.serviceOrigin"));
        const response = await $25ed63831c0cafe6$export$dfd2ec4d263788f5({
            url: url,
            signal: signal,
            authorization: (await ckboxUtils.getToken()).value
        });
        const status = response.metadata.metadataProcessingStatus;
        if (!status || status == "queued") /**
		* Image has not been processed yet.
		*
		* @error ckbox-image-not-processed
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ckbox-image-not-processed");
        return {
            data: {
                ...response
            }
        };
    }
    /**
	* Waits for an asset to be processed.
	* It retries retrieving asset status from the server in case of failure.
	*/ async _waitForAssetProcessed(id, signal) {
        const result = await (0, $c7bc2cb7e2db0227$export$9369b12211e1fce4)(()=>this._getAssetStatusFromServer(id, signal), {
            signal: signal,
            maxAttempts: 5
        });
        if (result.data.metadata.metadataProcessingStatus != "success") /**
		* The image processing failed.
		*
		* @error ckbox-image-processing-failed
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ckbox-image-processing-failed");
        return result;
    }
    /**
	* Shows processing indicator while image is processing.
	*
	* @param asset Data about certain asset.
	*/ _showImageProcessingIndicator(element, asset) {
        const editor = this.editor;
        editor.editing.view.change((writer)=>{
            const imageElementView = editor.editing.mapper.toViewElement(element);
            const img = this.editor.plugins.get("ImageUtils").findViewImgElement(imageElementView);
            writer.removeStyle("aspect-ratio", img);
            writer.setAttribute("width", asset.data.metadata.width, img);
            writer.setAttribute("height", asset.data.metadata.height, img);
            writer.setStyle("width", `${asset.data.metadata.width}px`, img);
            writer.setStyle("height", `${asset.data.metadata.height}px`, img);
            writer.addClass("image-processing", imageElementView);
        });
    }
    /**
	* Replace the edited image with the new one.
	*/ _replaceImage(element, asset) {
        const editor = this.editor;
        const { imageFallbackUrl: imageFallbackUrl, imageSources: imageSources, imageWidth: imageWidth, imageHeight: imageHeight, imagePlaceholder: imagePlaceholder } = $25ed63831c0cafe6$export$84e8e23bbb749fab(asset);
        const previousSelectionRanges = Array.from(editor.model.document.selection.getRanges());
        editor.model.change((writer)=>{
            writer.setSelection(element, "on");
            editor.execute("insertImage", {
                imageType: element.is("element", "imageInline") ? "imageInline" : null,
                source: {
                    src: imageFallbackUrl,
                    sources: imageSources,
                    width: imageWidth,
                    height: imageHeight,
                    ...imagePlaceholder ? {
                        placeholder: imagePlaceholder
                    } : null,
                    ...element.hasAttribute("alt") ? {
                        alt: element.getAttribute("alt")
                    } : null
                }
            });
            const previousChildren = element.getChildren();
            element = editor.model.document.selection.getSelectedElement();
            for (const child of previousChildren)writer.append(writer.cloneElement(child), element);
            writer.setAttribute("ckboxImageId", asset.data.id, element);
            writer.setSelection(previousSelectionRanges);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboximageedit/ckboximageeditediting
*/ /**
* The CKBox image edit editing plugin.
*/ var $25ed63831c0cafe6$export$8bbf4efc41b2e460 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxImageEditEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $25ed63831c0cafe6$export$754522567f942cfd,
            $25ed63831c0cafe6$export$3a6c52c4616d7522,
            (0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5),
            (0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd),
            (0, $7c22895ca0418c15$export$698882cf06df44aa),
            (0, $7c22895ca0418c15$export$2cb8e8efa7161979)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const { editor: editor } = this;
        const imageEditCommand = new $25ed63831c0cafe6$export$c682843f1ee13ee3(editor);
        editor.commands.add("ckboxImageEdit", imageEditCommand);
        if ((0, $c7bc2cb7e2db0227$export$d5ff8d8a62c25e80)()) {
            /**
			* The CKBox image editor is not available, because the application enforces Trusted Types with the
			* `require-trusted-types-for 'script'` CSP directive. The image editor writes HTML in a way that this directive
			* rejects, and the editor cannot change how it does that. Choosing assets in CKBox still works.
			*
			* The editor disables its own **Edit image** button. The **Edit** button in the CKBox dialog is part of CKBox, so
			* it stays available, but the image editor that it opens cannot load the image either.
			*
			* For a detailed overview, check the {@glink getting-started/setup/csp#known-limitations Content Security
			* Policy} guide.
			*
			* @error ckbox-image-edit-unavailable-with-trusted-types
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("ckbox-image-edit-unavailable-with-trusted-types");
            imageEditCommand.forceDisabled("trustedTypes");
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboximageedit/ckboximageeditui
*/ /**
* The UI plugin of the CKBox image edit feature.
*
* It registers the `'ckboxImageEdit'` UI button in the editor's {@link module:ui/componentfactory~ComponentFactory component factory}
* that allows you to open the CKBox dialog and edit the image.
*/ var $25ed63831c0cafe6$export$7e7e8f10bdc318f6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxImageEditUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("ckboxImageEdit", (locale)=>{
            const command = editor.commands.get("ckboxImageEdit");
            const uploadImageCommand = editor.commands.get("uploadImage");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const t = locale.t;
            view.set({
                icon: (0, $e8dc502aba5ac3f5$export$3875818f0ac85745),
                tooltip: true
            });
            view.bind("label").to(uploadImageCommand, "isAccessAllowed", (isAccessAllowed)=>isAccessAllowed ? t("Edit image") : t("You have no image editing permissions."));
            view.bind("isOn").to(command, "value", command, "isEnabled", (value, isEnabled)=>value && isEnabled);
            view.bind("isEnabled").to(command);
            this.listenTo(view, "execute", ()=>{
                editor.execute("ckboxImageEdit");
                editor.editing.view.focus();
            });
            return view;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckbox/ckboximageedit
*/ /**
* The CKBox image edit feature.
*/ var $25ed63831c0cafe6$export$558eca40594f53b3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKBoxImageEdit";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $25ed63831c0cafe6$export$8bbf4efc41b2e460,
            $25ed63831c0cafe6$export$7e7e8f10bdc318f6
        ];
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 





/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckfinder/ckfinderui
*/ /**
* Introduces UI components for `CKFinder` plugin.
*
* The plugin introduces two UI components to the {@link module:ui/componentfactory~ComponentFactory UI component factory}:
*
* * the `'ckfinder'` toolbar button,
* * the `'menuBar:ckfinder'` menu bar component, which is by default added to the `'Insert'` menu.
*
* It also integrates with the `insertImage` toolbar component and `menuBar:insertImage` menu component.
*/ var $1b35fec9bb40f81b$export$271ef229a1075722 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKFinderUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("ckfinder", ()=>this._createFileToolbarButton());
        editor.ui.componentFactory.add("menuBar:ckfinder", ()=>this._createFileMenuBarButton());
        /* v8 ignore else -- @preserve */ if (editor.plugins.has("ImageInsertUI")) editor.plugins.get("ImageInsertUI").registerIntegration({
            name: "assetManager",
            observable: ()=>editor.commands.get("ckfinder"),
            buttonViewCreator: ()=>this._createImageToolbarButton(),
            formViewCreator: ()=>this._createImageDropdownButton(),
            menuBarButtonViewCreator: (isOnly)=>this._createImageMenuBarButton(isOnly ? "insertOnly" : "insertNested")
        });
    }
    /**
	* Creates the base for various kinds of the button component provided by this feature.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const view = new ButtonClass(locale);
        const command = editor.commands.get("ckfinder");
        view.bind("isEnabled").to(command);
        view.on("execute", ()=>{
            editor.execute("ckfinder");
            editor.editing.view.focus();
        });
        return view;
    }
    /**
	* Creates a simple toolbar button for files management, with an icon and a tooltip.
	*/ _createFileToolbarButton() {
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$3ffee1eb83242296);
        button.label = t("Insert image or file");
        button.tooltip = true;
        return button;
    }
    /**
	* Creates a simple toolbar button for images management, with an icon and a tooltip.
	*/ _createImageToolbarButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace image with file manager") : t("Insert image with file manager"));
        button.tooltip = true;
        return button;
    }
    /**
	* Creates a button for images management for the dropdown view, with an icon, text and no tooltip.
	*/ _createImageDropdownButton() {
        const t = this.editor.locale.t;
        const imageInsertUI = this.editor.plugins.get("ImageInsertUI");
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.withText = true;
        button.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected)=>isImageSelected ? t("Replace with file manager") : t("Insert with file manager"));
        button.on("execute", ()=>{
            imageInsertUI.dropdownView.isOpen = false;
        });
        return button;
    }
    /**
	* Creates a button for files management for the menu bar.
	*/ _createFileMenuBarButton() {
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        button.icon = (0, $e8dc502aba5ac3f5$export$3ffee1eb83242296);
        button.withText = true;
        button.label = t("File");
        return button;
    }
    /**
	* Creates a button for images management for the menu bar.
	*/ _createImageMenuBarButton(type) {
        const translateVariableKey = this.editor.locale.t;
        const t = this.editor.locale.t;
        const button = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        button.icon = (0, $e8dc502aba5ac3f5$export$a3743a0d9f1cf347);
        button.withText = true;
        switch(type){
            case "insertOnly":
                button.label = translateVariableKey("Image");
                break;
            case "insertNested":
                button.label = t("With file manager");
        }
        return button;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckfinder/ckfindercommand
*/ /**
* The CKFinder command. It is used by the {@link module:ckfinder/ckfinderediting~CKFinderEditing CKFinder editing feature}
* to open the CKFinder file manager to insert an image or a link to a file into the editor content.
*
* ```ts
* editor.execute( 'ckfinder' );
* ```
*
* **Note:** This command uses other features to perform tasks:
* - To insert images the {@link module:image/image/insertimagecommand~InsertImageCommand 'insertImage'} command
* from the {@link module:image/image~Image Image feature}.
* - To insert links to files the {@link module:link/linkcommand~LinkCommand 'link'} command
* from the {@link module:link/link~Link Link feature}.
*/ var $1b35fec9bb40f81b$export$4e4fd5e942e440ae = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
        this.stopListening(this.editor.model.document, "change");
        this.listenTo(this.editor.model.document, "change", ()=>this.refresh(), {
            priority: "low"
        });
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const imageCommand = this.editor.commands.get("insertImage");
        const linkCommand = this.editor.commands.get("link");
        this.isEnabled = imageCommand.isEnabled || linkCommand.isEnabled;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const editor = this.editor;
        const openerMethod = this.editor.config.get("ckfinder.openerMethod") || "modal";
        if (openerMethod != "popup" && openerMethod != "modal") /**
		* The `ckfinder.openerMethod` must be one of: "popup" or "modal".
		*
		* @error ckfinder-unknown-openermethod
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ckfinder-unknown-openermethod", editor);
        const options = this.editor.config.get("ckfinder.options") || {};
        options.chooseFiles = true;
        const originalOnInit = options.onInit;
        if (!options.language) options.language = editor.locale.uiLanguage;
        options.onInit = (finder)=>{
            if (originalOnInit) originalOnInit(finder);
            finder.on("files:choose", (evt)=>{
                const files = evt.data.files.toArray();
                const links = files.filter((file)=>!file.isImage());
                const images = files.filter((file)=>file.isImage());
                for (const linkFile of links)editor.execute("link", linkFile.getUrl());
                const imagesUrls = [];
                for (const image of images){
                    const url = image.getUrl();
                    imagesUrls.push(url ? url : finder.request("file:getProxyUrl", {
                        file: image
                    }));
                }
                if (imagesUrls.length) $1b35fec9bb40f81b$var$insertImages(editor, imagesUrls);
            });
            finder.on("file:choose:resizedImage", (evt)=>{
                const resizedUrl = evt.data.resizedUrl;
                if (!resizedUrl) {
                    const notification = editor.plugins.get("Notification");
                    const t = editor.locale.t;
                    notification.showWarning(t("Could not obtain resized image URL."), {
                        title: t("Selecting resized image failed"),
                        namespace: "ckfinder"
                    });
                    return;
                }
                $1b35fec9bb40f81b$var$insertImages(editor, [
                    resizedUrl
                ]);
            });
        };
        window.CKFinder[openerMethod](options);
    }
};
function $1b35fec9bb40f81b$var$insertImages(editor, urls) {
    if (!editor.commands.get("insertImage").isEnabled) {
        const notification = editor.plugins.get("Notification");
        const t = editor.locale.t;
        notification.showWarning(t("Could not insert image at the current position."), {
            title: t("Inserting image failed"),
            namespace: "ckfinder"
        });
        return;
    }
    editor.execute("insertImage", {
        source: urls
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckfinder/ckfinderediting
*/ /**
* The CKFinder editing feature. It introduces the {@link module:ckfinder/ckfindercommand~CKFinderCommand CKFinder command}.
*/ var $1b35fec9bb40f81b$export$b0b2dd0f9d36ef8e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKFinderEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$14834abbfce3b8cd),
            (0, $8fb2b7bcf5f9e330$export$8c435103e27cd12e)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("ImageBlockEditing") && !editor.plugins.has("ImageInlineEditing")) /**
		* CKFinder requires at least one plugin providing support for images loaded in the editor. Please
		* make sure either:
		*
		* * {@link module:image/image~Image} (which loads both types of images),
		* * or {@link module:image/imageblock~ImageBlock},
		* * or {@link module:image/imageinline~ImageInline}.
		*
		* is loaded in your editor configuration.
		*
		* @error ckfinder-missing-image-plugin
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("ckfinder-missing-image-plugin", editor);
        editor.commands.add("ckfinder", new $1b35fec9bb40f81b$export$4e4fd5e942e440ae(editor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module ckfinder/ckfinder
*/ /**
* The CKFinder feature, a bridge between the CKEditor 5 WYSIWYG editor and the
* [CKFinder](https://ckeditor.com/ckfinder) file manager and uploader.
*
* This is a "glue" plugin which enables:
*
* * {@link module:ckfinder/ckfinderediting~CKFinderEditing},
* * {@link module:ckfinder/ckfinderui~CKFinderUI},
* * {@link module:adapter-ckfinder/uploadadapter~CKFinderUploadAdapter}.
*
* See the {@glink features/file-management/ckfinder "CKFinder integration" guide} to learn how to configure
* and use this feature.
*
* Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload" guide} to learn about
* other ways to upload images into CKEditor 5.
*/ var $1b35fec9bb40f81b$export$7ecb7f71abb61ffe = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CKFinder";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $8fb2b7bcf5f9e330$export$a6c7ac8248d6e38a),
            (0, $c1535c9df13f8c33$export$83349e247298922),
            $1b35fec9bb40f81b$export$b0b2dd0f9d36ef8e,
            $1b35fec9bb40f81b$export$271ef229a1075722
        ];
    }
};




/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 






/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns code block languages as defined in `config.codeBlock.languages` but processed:
*
* * To consider the editor localization, i.e. to display {@link module:code-block/codeblockconfig~CodeBlockLanguageDefinition}
* in the correct language. There is no way to use {@link module:utils/locale~Locale#t} when the user
* configuration is defined because the editor does not exist yet.
* * To make sure each definition has a CSS class associated with it even if not specified
* in the original configuration.
*
* @internal
*/ function $22de0190197b1839$export$f5f9c752442d5940(editor) {
    const t = editor.t;
    const languageDefs = editor.config.get("codeBlock.languages");
    for (const def of languageDefs){
        if (def.label === "Plain text") def.label = t("Plain text");
        if (def.class === void 0) def.class = `language-${def.language}`;
    }
    return languageDefs;
}
/**
* Returns an object associating certain language definition properties with others. For instance:
*
* For:
*
* ```ts
* const definitions = {
* 	{ language: 'php', class: 'language-php', label: 'PHP' },
* 	{ language: 'javascript', class: 'js', label: 'JavaScript' },
* };
*
* getPropertyAssociation( definitions, 'class', 'language' );
* ```
*
* returns:
*
* ```ts
* {
* 	'language-php': 'php',
* 	'js': 'javascript'
* }
* ```
*
* and
*
* ```ts
* getPropertyAssociation( definitions, 'language', 'label' );
* ```
*
* returns:
*
* ```ts
* {
* 	'php': 'PHP',
* 	'javascript': 'JavaScript'
* }
* ```
*
* @internal
*/ function $22de0190197b1839$export$aa3389bf54ce8366(languageDefs, key, value) {
    const association = {};
    for (const def of languageDefs)if (key === "class") {
        const newKey = def[key].split(" ").shift();
        association[newKey] = def[value];
    } else association[def[key]] = def[value];
    return association;
}
/**
* For a given model text node, it returns white spaces that precede other characters in that node.
* This corresponds to the indentation part of the code block line.
*
* @internal
*/ function $22de0190197b1839$export$11c6b0ec790ae770(textNode) {
    return textNode.data.match(/^(\s*)/)[0];
}
/**
* For plain text containing the code (a snippet), it returns a document fragment containing
* view text nodes separated by `<br>` elements (in place of new line characters "\n"), for instance:
*
* Input:
*
* ```ts
* "foo()\n
* bar()"
* ```
*
* Output:
*
* ```html
* <DocumentFragment>
* 	"foo()"
* 	<br/>
* 	"bar()"
* </DocumentFragment>
* ```
*
* @param text The raw code text to be converted.
* @internal
*/ function $22de0190197b1839$export$caeed18593224c92(writer, text) {
    const fragment = writer.createDocumentFragment();
    const textLines = text.split("\n");
    const items = textLines.reduce((nodes, line, lineIndex)=>{
        nodes.push(line);
        if (lineIndex < textLines.length - 1) nodes.push(writer.createElement("br"));
        return nodes;
    }, []);
    writer.appendChild(items, fragment);
    return fragment;
}
/**
* Returns an array of all model positions within the selection that represent code block lines.
*
* If the selection is collapsed, it returns the exact selection anchor position:
*
* ```html
* <codeBlock>[]foo</codeBlock>        ->     <codeBlock>^foo</codeBlock>
* <codeBlock>foo[]bar</codeBlock>     ->     <codeBlock>foo^bar</codeBlock>
* ```
*
* Otherwise, it returns positions **before** each text node belonging to all code blocks contained by the selection:
*
* ```html
* <codeBlock>                                <codeBlock>
*     foo[bar                                   ^foobar
*     <softBreak></softBreak>         ->        <softBreak></softBreak>
*     baz]qux                                   ^bazqux
* </codeBlock>                               </codeBlock>
* ```
*
* It also works across other non–code blocks:
*
* ```html
* <codeBlock>                                <codeBlock>
*     foo[bar                                   ^foobar
* </codeBlock>                               </codeBlock>
* <paragraph>text</paragraph>         ->     <paragraph>text</paragraph>
* <codeBlock>                                <codeBlock>
*     baz]qux                                   ^bazqux
* </codeBlock>                               </codeBlock>
* ```
*
* **Note:** The positions are in reverse order so they do not get outdated when iterating over them and
* the writer inserts or removes elements at the same time.
*
* **Note:** The position is located after the leading white spaces in the text node.
*
* @internal
*/ function $22de0190197b1839$export$f1cdfcffa228fc87(model) {
    const selection = model.document.selection;
    const positions = [];
    if (selection.isCollapsed) return [
        selection.anchor
    ];
    const walker = selection.getFirstRange().getWalker({
        ignoreElementEnd: true,
        direction: "backward"
    });
    for (const { item: item } of walker){
        let node = item.is("$textProxy") ? item.textNode : item;
        const parent = node.parent;
        if (!parent.is("element", "codeBlock") || node.is("element", "softBreak")) continue;
        while(node.previousSibling && !node.previousSibling.is("element", "softBreak"))node = node.previousSibling;
        const startOffset = !node.is("$text") ? node.startOffset : node.startOffset + $22de0190197b1839$export$11c6b0ec790ae770(node).length;
        const position = model.createPositionAt(parent, startOffset);
        if (positions.every((pos)=>!pos.isEqual(position))) positions.push(position);
    }
    return positions;
}
/**
* Checks if any of the blocks within the model selection is a code block.
*
* @internal
*/ function $22de0190197b1839$export$180dfdc74dc8916(selection) {
    const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
    return !!firstBlock && firstBlock.is("element", "codeBlock");
}
/**
* Checks if an {@link module:engine/model/element~ModelElement Element} can become a code block.
*
* @param schema Model's schema.
* @param element The element to be checked.
* @returns Check result.
* @internal
*/ function $22de0190197b1839$export$692e0ad1de59f2ce(schema, element) {
    if (element.is("rootElement") || schema.isLimit(element)) return false;
    return schema.checkChild(element.parent, "codeBlock");
}
/**
* Get the translated message read by the screen reader when you enter or exit an element with your cursor.
*
* @internal
*/ function $22de0190197b1839$export$c5d8652c4a7df5ff(t, languageDefs, element, direction) {
    const languagesToLabels = $22de0190197b1839$export$aa3389bf54ce8366(languageDefs, "language", "label");
    const codeBlockLanguage = element.getAttribute("language");
    if (codeBlockLanguage in languagesToLabels) {
        const language = languagesToLabels[codeBlockLanguage];
        if (direction === "enter") return t("Entering %0 code snippet", language);
        return t("Leaving %0 code snippet", language);
    }
    if (direction === "enter") return t("Entering code snippet");
    return t("Leaving code snippet");
}
/**
* For given position, finds the closest position that is at the beginning of a line of code and returns a text node that is at the
* beginning of the line (or `null` if there's no text node at the beginning of a given line).
*
* Line beings at the start of a code block element and after each `softBreak` element.
*
* Note: even though code block doesn't allow inline elements other than `<softBreak>` by default, some features may overwrite this rule,
* so such inline elements are taken into account.
*
* Some examples of expected results:
*
* ```
* <codeBlock>^</codeBlock>                                ->   null
* <codeBlock>^foobar</codeBlock>                          ->   <codeBlock>[foobar]</codeBlock>
* <codeBlock>foobar^</codeBlock>                          ->   <codeBlock>[foobar]</codeBlock>
* <codeBlock>foo^bar</codeBlock>                          ->   <codeBlock>[foobar]</codeBlock>
* <codeBlock>foo^<softBreak />bar</codeBlock>             ->   <codeBlock>[foo]<softBreak />bar</codeBlock>
* <codeBlock>foo<softBreak />bar^</codeBlock>             ->   <codeBlock>foo<softBreak />[bar]</codeBlock>
* <codeBlock>foo<softBreak />b^ar</codeBlock>             ->   <codeBlock>foo<softBreak />[bar]</codeBlock>
* <codeBlock>foo<softBreak />^bar</codeBlock>             ->   <codeBlock>foo<softBreak />[bar]</codeBlock>
* <codeBlock>^<element /></codeBlock>                     ->   null
* <codeBlock><element />^</codeBlock>                     ->   null
* <codeBlock>foo^<element /></codeBlock>                  ->   <codeBlock>[foo]<element /></codeBlock>
* <codeBlock>foo<element />^</codeBlock>                  ->   <codeBlock>[foo]<element /></codeBlock>
* <codeBlock>foo<element />bar^</codeBlock>               ->   <codeBlock>[foo]<element />bar</codeBlock>
* <codeBlock><element />bar^</codeBlock>                  ->   null
* <codeBlock>foo<softBreak />^<softBreak /></codeBlock>   ->   null
* <codeBlock>foo<softBreak />^<element /></codeBlock>     ->   null
* <codeBlock>foo<softBreak /><element />^</codeBlock>     ->   null
* <codeBlock>foo<softBreak />bar<element />^</codeBlock>  ->   <codeBlock>foo<softBreak />[bar]<element /></codeBlock>
* <codeBlock>foo<softBreak /><element />ba^r</codeBlock>  ->   null
* ```
*
* @internal
*/ function $22de0190197b1839$export$a6f878452bd4841a(position, model) {
    if (position.textNode) position = model.createPositionBefore(position.textNode);
    while(position.nodeBefore && !position.nodeBefore.is("element", "softBreak"))position = model.createPositionBefore(position.nodeBefore);
    const nodeAtStart = position.nodeAfter;
    return nodeAtStart && nodeAtStart.is("$text") ? nodeAtStart : null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The code block command plugin.
*/ var $22de0190197b1839$export$fbf98c7e88a1c585 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Contains the last used language.
	*/ _lastLanguage;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._lastLanguage = null;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command. When the command {@link #value is on}, all topmost code blocks within
	* the selection will be removed. If it is off, all selected blocks will be flattened and
	* wrapped by a code block.
	*
	* @fires execute
	* @param options Command options.
	* @param options.language The code block language.
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply a code block,
	* otherwise the command will remove the code block. If not set, the command will act basing on its current value.
	* @param options.usePreviousLanguageChoice If set on `true` and the `options.language` is not specified, the command
	* will apply the previous language (if the command was already executed) when inserting the `codeBlock` element.
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const firstLanguageInConfig = $22de0190197b1839$export$f5f9c752442d5940(editor)[0];
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = options.forceValue == void 0 ? !this.value : options.forceValue;
        const language = $22de0190197b1839$var$getLanguage(options, this._lastLanguage, firstLanguageInConfig.language);
        model.change((writer)=>{
            if (value) this._applyCodeBlock(writer, blocks, language);
            else this._removeCodeBlock(writer, blocks);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        return !!firstBlock?.is("element", "codeBlock") ? firstBlock.getAttribute("language") : false;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        if (this.value) return true;
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if (!firstBlock) return false;
        return $22de0190197b1839$export$692e0ad1de59f2ce(schema, firstBlock);
    }
    _applyCodeBlock(writer, blocks, language) {
        this._lastLanguage = language;
        const schema = this.editor.model.schema;
        const allowedBlocks = blocks.filter((block)=>$22de0190197b1839$export$692e0ad1de59f2ce(schema, block));
        for (const block of allowedBlocks){
            writer.rename(block, "codeBlock");
            writer.setAttribute("language", language, block);
            schema.removeDisallowedAttributes([
                block
            ], writer);
            Array.from(block.getChildren()).filter((child)=>!schema.checkChild(block, child)).forEach((child)=>writer.remove(child));
        }
        allowedBlocks.reverse().forEach((currentBlock, i)=>{
            const nextBlock = allowedBlocks[i + 1];
            if (currentBlock.previousSibling === nextBlock) {
                writer.appendElement("softBreak", nextBlock);
                writer.merge(writer.createPositionBefore(currentBlock));
            }
        });
    }
    _removeCodeBlock(writer, blocks) {
        const codeBlocks = blocks.filter((block)=>block.is("element", "codeBlock"));
        for (const block of codeBlocks){
            const range = writer.createRangeOn(block);
            for (const item of Array.from(range.getItems()).reverse())if (item.is("element", "softBreak") && item.parent.is("element", "codeBlock")) {
                const { position: position } = writer.split(writer.createPositionBefore(item));
                const elementAfter = position.nodeAfter;
                writer.rename(elementAfter, "paragraph");
                writer.removeAttribute("language", elementAfter);
                writer.remove(item);
            }
            writer.rename(block, "paragraph");
            writer.removeAttribute("language", block);
        }
    }
};
/**
* Picks the language for the new code block. If any language is passed as an option,
* it will be returned. Else, if option usePreviousLanguageChoice is true and some
* code block was already created (lastLanguage is not null) then previously used
* language will be returned. If not, it will return default language.
*/ function $22de0190197b1839$var$getLanguage(options, lastLanguage, defaultLanguage) {
    if (options.language) return options.language;
    if (options.usePreviousLanguageChoice && lastLanguage) return lastLanguage;
    return defaultLanguage;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module code-block/indentcodeblockcommand
*/ /**
* The code block indentation increase command plugin.
*/ var $22de0190197b1839$export$c427003590377116 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A sequence of characters added to the line when the command is executed.
	*/ _indentSequence;
    constructor(editor){
        super(editor);
        this._indentSequence = editor.config.get("codeBlock.indentSequence");
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command. When the command {@link #isEnabled is enabled}, the indentation of the
	* code lines in the selection will be increased.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        model.change((writer)=>{
            const positions = $22de0190197b1839$export$f1cdfcffa228fc87(model);
            for (const position of positions){
                const indentSequenceTextElement = writer.createText(this._indentSequence);
                model.insertContent(indentSequenceTextElement, position);
            }
        });
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*/ _checkEnabled() {
        if (!this._indentSequence) return false;
        return $22de0190197b1839$export$180dfdc74dc8916(this.editor.model.document.selection);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The code block indentation decrease command plugin.
*/ var $22de0190197b1839$export$d6a97b42636693ee = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A sequence of characters removed from the line when the command is executed.
	*/ _indentSequence;
    constructor(editor){
        super(editor);
        this._indentSequence = editor.config.get("codeBlock.indentSequence");
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command. When the command {@link #isEnabled is enabled}, the indentation of the
	* code lines in the selection will be decreased.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        model.change(()=>{
            const positions = $22de0190197b1839$export$f1cdfcffa228fc87(model);
            for (const position of positions){
                const range = $22de0190197b1839$var$getLastOutdentableSequenceRange(model, position, this._indentSequence);
                if (range) model.deleteContent(model.createSelection(range));
            }
        });
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @private
	* @returns {Boolean} Whether the command should be enabled.
	*/ _checkEnabled() {
        if (!this._indentSequence) return false;
        const model = this.editor.model;
        if (!$22de0190197b1839$export$180dfdc74dc8916(model.document.selection)) return false;
        return $22de0190197b1839$export$f1cdfcffa228fc87(model).some((position)=>{
            return $22de0190197b1839$var$getLastOutdentableSequenceRange(model, position, this._indentSequence);
        });
    }
};
function $22de0190197b1839$var$getLastOutdentableSequenceRange(model, position, sequence) {
    const nodeAtPosition = $22de0190197b1839$export$a6f878452bd4841a(position, model);
    if (!nodeAtPosition) return null;
    const leadingWhiteSpaces = $22de0190197b1839$export$11c6b0ec790ae770(nodeAtPosition);
    const lastIndexOfSequence = leadingWhiteSpaces.lastIndexOf(sequence);
    if (lastIndexOfSequence + sequence.length !== leadingWhiteSpaces.length) return null;
    if (lastIndexOfSequence === -1) return null;
    const { parent: parent, startOffset: startOffset } = nodeAtPosition;
    return model.createRange(model.createPositionAt(parent, startOffset + lastIndexOfSequence), model.createPositionAt(parent, startOffset + lastIndexOfSequence + sequence.length));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A model-to-view (both editing and data) converter for the `codeBlock` element.
*
* Sample input:
*
* ```html
* <codeBlock language="javascript">foo();<softBreak></softBreak>bar();</codeBlock>
* ```
*
* Sample output (editing):
*
* ```html
* <pre data-language="JavaScript"><code class="language-javascript">foo();<br />bar();</code></pre>
* ```
*
* Sample output (data, see {@link module:code-block/converters~modelToDataViewSoftBreakInsertion}):
*
* ```html
* <pre><code class="language-javascript">foo();\nbar();</code></pre>
* ```
*
* @param languageDefs The normalized language configuration passed to the feature.
* @param useLabels When `true`, the `<pre>` element will get a `data-language` attribute with a
* human–readable label of the language. Used only in the editing.
* @returns Returns a conversion callback.
* @internal
*/ function $22de0190197b1839$export$cb57a82d83f6cc5b(model, languageDefs, useLabels = false) {
    const languagesToClasses = $22de0190197b1839$export$aa3389bf54ce8366(languageDefs, "language", "class");
    const languagesToLabels = $22de0190197b1839$export$aa3389bf54ce8366(languageDefs, "language", "label");
    return (evt, data, conversionApi)=>{
        const { writer: writer, mapper: mapper, consumable: consumable } = conversionApi;
        if (!consumable.consume(data.item, "insert")) return;
        const codeBlockLanguage = data.item.getAttribute("language");
        const targetViewPosition = mapper.toViewPosition(model.createPositionBefore(data.item));
        const preAttributes = {};
        if (useLabels) {
            preAttributes["data-language"] = languagesToLabels[codeBlockLanguage];
            preAttributes.spellcheck = "false";
        }
        const codeAttributes = languagesToClasses[codeBlockLanguage] ? {
            class: languagesToClasses[codeBlockLanguage]
        } : void 0;
        const code = writer.createContainerElement("code", codeAttributes);
        const pre = writer.createContainerElement("pre", preAttributes, code);
        writer.insert(targetViewPosition, pre);
        mapper.bindElements(data.item, code);
    };
}
/**
* A model-to-data view converter for the new line (`softBreak`) separator.
*
* Sample input:
*
* ```html
* <codeBlock ...>foo();<softBreak></softBreak>bar();</codeBlock>
* ```
*
* Sample output:
*
* ```html
* <pre><code ...>foo();\nbar();</code></pre>
* ```
*
* @returns Returns a conversion callback.
* @internal
*/ function $22de0190197b1839$export$e47c2c8f81ebf49d(model) {
    return (evt, data, conversionApi)=>{
        if (data.item.parent.name !== "codeBlock") return;
        const { writer: writer, mapper: mapper, consumable: consumable } = conversionApi;
        if (!consumable.consume(data.item, "insert")) return;
        const position = mapper.toViewPosition(model.createPositionBefore(data.item));
        writer.insert(position, writer.createText("\n"));
    };
}
/**
* A view-to-model converter for `<pre>` with the `<code>` HTML.
*
* Sample input:
*
* ```html
* <pre><code class="language-javascript">foo();bar();</code></pre>
* ```
*
* Sample output:
*
* ```html
* <codeBlock language="javascript">foo();bar();</codeBlock>
* ```
*
* @param languageDefs The normalized language configuration passed to the feature.
* @returns Returns a conversion callback.
* @internal
*/ function $22de0190197b1839$export$ccba91173ea3b98f(editingView, languageDefs) {
    const classesToLanguages = $22de0190197b1839$export$aa3389bf54ce8366(languageDefs, "class", "language");
    const defaultLanguageName = languageDefs[0].language;
    return (evt, data, conversionApi)=>{
        const viewCodeElement = data.viewItem;
        const viewPreElement = viewCodeElement.parent;
        if (!viewPreElement || !viewPreElement.is("element", "pre")) return;
        if (data.modelCursor.findAncestor("codeBlock")) return;
        const { consumable: consumable, writer: writer } = conversionApi;
        if (!consumable.test(viewCodeElement, {
            name: true
        })) return;
        const codeBlock = writer.createElement("codeBlock");
        const viewChildClasses = [
            ...viewCodeElement.getClassNames()
        ];
        if (!viewChildClasses.length) viewChildClasses.push("");
        for (const className of viewChildClasses){
            const language = classesToLanguages[className];
            if (language) {
                consumable.consume(viewCodeElement, {
                    classes: [
                        className
                    ]
                });
                writer.setAttribute("language", language, codeBlock);
                break;
            }
        }
        if (!codeBlock.hasAttribute("language")) writer.setAttribute("language", defaultLanguageName, codeBlock);
        conversionApi.convertChildren(viewCodeElement, codeBlock);
        if (!conversionApi.safeInsert(codeBlock, data.modelCursor)) return;
        consumable.consume(viewCodeElement, {
            name: true
        });
        conversionApi.updateConversionResult(codeBlock, data);
    };
}
/**
* A view-to-model converter for new line characters in `<pre>`.
*
* Sample input:
*
* ```html
* <pre><code class="language-javascript">foo();\nbar();</code></pre>
* ```
*
* Sample output:
*
* ```html
* <codeBlock language="javascript">foo();<softBreak></softBreak>bar();</codeBlock>
* ```
*
* @returns {Function} Returns a conversion callback.
* @internal
*/ function $22de0190197b1839$export$33dcdf59a2f5f73() {
    return (evt, data, { consumable: consumable, writer: writer })=>{
        let position = data.modelCursor;
        if (!consumable.test(data.viewItem)) return;
        if (!position.findAncestor("codeBlock")) return;
        consumable.consume(data.viewItem);
        const textLines = data.viewItem.data.split("\n").map((data)=>writer.createText(data));
        const lastLine = textLines[textLines.length - 1];
        for (const node of textLines){
            writer.insert(node, position);
            position = position.getShiftedBy(node.offsetSize);
            if (node !== lastLine) {
                const softBreak = writer.createElement("softBreak");
                writer.insert(softBreak, position);
                position = writer.createPositionAfter(softBreak);
            }
        }
        data.modelRange = writer.createRange(data.modelCursor, position);
        data.modelCursor = position;
    };
}
/**
* A view-to-model converter that handles orphan text nodes (white spaces, new lines, etc.)
* that surround `<code>` inside `<pre>`.
*
* Sample input:
*
* ```html
* // White spaces
* <pre> <code>foo()</code> </pre>
*
* // White spaces
* <pre>      <code>foo()</code>      </pre>
*
* // White spaces
* <pre>			<code>foo()</code>			</pre>
*
* // New lines
* <pre>
* 	<code>foo()</code>
* </pre>
*
* // Redundant text
* <pre>ABC<code>foo()</code>DEF</pre>
* ```
*
* Unified output for each case:
*
* ```html
* <codeBlock language="plaintext">foo()</codeBlock>
* ```
*
* @returns Returns a conversion callback.
* @internal
*/ function $22de0190197b1839$export$4be3a6ac40203a13() {
    return (evt, data, { consumable: consumable })=>{
        const preElement = data.viewItem;
        if (preElement.findAncestor("pre")) return;
        const preChildren = Array.from(preElement.getChildren());
        const childCodeElement = preChildren.find((node)=>node.is("element", "code"));
        if (!childCodeElement) return;
        for (const child of preChildren){
            if (child === childCodeElement || !child.is("$text")) continue;
            consumable.consume(child, {
                name: true
            });
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module code-block/codeblockediting
*/ const $22de0190197b1839$var$DEFAULT_ELEMENT = "paragraph";
/**
* The editing part of the code block feature.
*
* Introduces the `'codeBlock'` command and the `'codeBlock'` model element.
*/ var $22de0190197b1839$export$ce7797df97a43067 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeBlockEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $c871651c8276dc61$export$f74dddee9c33418e)
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("codeBlock", {
            languages: [
                {
                    language: "plaintext",
                    label: "Plain text"
                },
                {
                    language: "c",
                    label: "C"
                },
                {
                    language: "cs",
                    label: "C#"
                },
                {
                    language: "cpp",
                    label: "C++"
                },
                {
                    language: "css",
                    label: "CSS"
                },
                {
                    language: "diff",
                    label: "Diff"
                },
                {
                    language: "go",
                    label: "Go"
                },
                {
                    language: "html",
                    label: "HTML"
                },
                {
                    language: "java",
                    label: "Java"
                },
                {
                    language: "javascript",
                    label: "JavaScript"
                },
                {
                    language: "php",
                    label: "PHP"
                },
                {
                    language: "python",
                    label: "Python"
                },
                {
                    language: "ruby",
                    label: "Ruby"
                },
                {
                    language: "typescript",
                    label: "TypeScript"
                },
                {
                    language: "xml",
                    label: "XML"
                }
            ],
            indentSequence: "	"
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const model = editor.model;
        const view = editor.editing.view;
        const normalizedLanguagesDefs = $22de0190197b1839$export$f5f9c752442d5940(editor);
        editor.commands.add("codeBlock", new $22de0190197b1839$export$fbf98c7e88a1c585(editor));
        editor.commands.add("indentCodeBlock", new $22de0190197b1839$export$c427003590377116(editor));
        editor.commands.add("outdentCodeBlock", new $22de0190197b1839$export$d6a97b42636693ee(editor));
        this.listenTo(view.document, "tab", (evt, data)=>{
            const commandName = data.shiftKey ? "outdentCodeBlock" : "indentCodeBlock";
            if (!editor.commands.get(commandName).isEnabled) return;
            editor.execute(commandName);
            data.stopPropagation();
            data.preventDefault();
            evt.stop();
        }, {
            context: "pre"
        });
        schema.register("codeBlock", {
            allowWhere: "$block",
            allowChildren: "$text",
            disallowChildren: "$inlineObject",
            allowAttributes: [
                "language"
            ],
            allowAttributesOf: "$listItem",
            isBlock: true
        });
        schema.addAttributeCheck((context, attributeName)=>{
            const parent = context.getItem(context.length - 2);
            if (schema.getAttributeProperties(attributeName).isFormatting && parent && parent.name == "codeBlock") return false;
        });
        editor.editing.downcastDispatcher.on("insert:codeBlock", $22de0190197b1839$export$cb57a82d83f6cc5b(model, normalizedLanguagesDefs, true));
        editor.data.downcastDispatcher.on("insert:codeBlock", $22de0190197b1839$export$cb57a82d83f6cc5b(model, normalizedLanguagesDefs));
        editor.data.downcastDispatcher.on("insert:softBreak", $22de0190197b1839$export$e47c2c8f81ebf49d(model), {
            priority: "high"
        });
        editor.data.upcastDispatcher.on("element:code", $22de0190197b1839$export$ccba91173ea3b98f(view, normalizedLanguagesDefs));
        editor.data.upcastDispatcher.on("text", $22de0190197b1839$export$33dcdf59a2f5f73());
        editor.data.upcastDispatcher.on("element:pre", $22de0190197b1839$export$4be3a6ac40203a13(), {
            priority: "high"
        });
        this.listenTo(editor.editing.view.document, "clipboardInput", (evt, data)=>{
            let insertionRange = model.createRange(model.document.selection.anchor);
            if (data.targetRanges) insertionRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
            if (!insertionRange.start.parent.is("element", "codeBlock")) return;
            const text = data.dataTransfer.getData("text/plain");
            const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(editor.editing.view.document);
            data.content = $22de0190197b1839$export$caeed18593224c92(writer, text);
        });
        if (editor.plugins.has("ClipboardPipeline")) editor.plugins.get((0, $4fa913ac1af6a08c$export$c85ef510b9161d09)).on("contentInsertion", (evt, data)=>{
            const model = editor.model;
            const selection = model.document.selection;
            if (!selection.anchor.parent.is("element", "codeBlock")) return;
            model.change((writer)=>{
                const contentRange = writer.createRangeIn(data.content);
                for (const item of [
                    ...contentRange.getItems()
                ])if (item.is("node") && !schema.checkChild(selection.anchor, item)) writer.remove(item);
            });
        });
        this.listenTo(model, "getSelectedContent", (evt, [selection])=>{
            const anchor = selection.anchor;
            if (selection.isCollapsed || !anchor.parent.is("element", "codeBlock") || !anchor.hasSameParentAs(selection.focus)) return;
            model.change((writer)=>{
                const docFragment = evt.return;
                if (anchor.parent.is("element") && (docFragment.childCount > 1 || selection.containsEntireContent(anchor.parent))) {
                    const codeBlock = writer.createElement("codeBlock", anchor.parent.getAttributes());
                    writer.append(docFragment, codeBlock);
                    const newDocumentFragment = writer.createDocumentFragment();
                    writer.append(codeBlock, newDocumentFragment);
                    evt.return = newDocumentFragment;
                    return;
                }
                const textNode = docFragment.getChild(0);
                if (schema.checkAttribute(textNode, "code")) writer.setAttribute("code", true, textNode);
            });
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const commands = editor.commands;
        const indent = commands.get("indent");
        const outdent = commands.get("outdent");
        if (indent) indent.registerChildCommand(commands.get("indentCodeBlock"), {
            priority: "highest"
        });
        if (outdent) outdent.registerChildCommand(commands.get("outdentCodeBlock"));
        this.listenTo(editor.editing.view.document, "enter", (evt, data)=>{
            if (!editor.model.document.selection.getLastPosition().parent.is("element", "codeBlock")) return;
            if (!$22de0190197b1839$var$leaveBlockStartOnEnter(editor, data.isSoft) && !$22de0190197b1839$var$leaveBlockEndOnEnter(editor, data.isSoft)) $22de0190197b1839$var$breakLineOnEnter(editor);
            data.preventDefault();
            evt.stop();
        }, {
            context: "pre"
        });
        this._initAriaAnnouncements();
    }
    /**
	* Observe when user enters or leaves code block and set proper aria value in global live announcer.
	* This allows screen readers to indicate when the user has entered and left the specified code block.
	*
	* @internal
	*/ _initAriaAnnouncements() {
        const { model: model, ui: ui, t: t } = this.editor;
        const languageDefs = $22de0190197b1839$export$f5f9c752442d5940(this.editor);
        let lastFocusedCodeBlock = null;
        model.document.selection.on("change:range", ()=>{
            const focusParent = model.document.selection.focus.parent;
            if (!ui || lastFocusedCodeBlock === focusParent || !focusParent.is("element")) return;
            if (lastFocusedCodeBlock && lastFocusedCodeBlock.is("element", "codeBlock")) ui.ariaLiveAnnouncer.announce($22de0190197b1839$export$c5d8652c4a7df5ff(t, languageDefs, lastFocusedCodeBlock, "leave"));
            if (focusParent.is("element", "codeBlock")) ui.ariaLiveAnnouncer.announce($22de0190197b1839$export$c5d8652c4a7df5ff(t, languageDefs, focusParent, "enter"));
            lastFocusedCodeBlock = focusParent;
        });
    }
};
/**
* Normally, when the Enter (or Shift+Enter) key is pressed, a soft line break is to be added to the
* code block. Let's try to follow the indentation of the previous line when possible, for instance:
*
* ```html
* // Before pressing enter (or shift enter)
* <codeBlock>
* "    foo()"[]                   // Indent of 4 spaces.
* </codeBlock>
*
* // After pressing:
* <codeBlock>
* "    foo()"                 // Indent of 4 spaces.
* <softBreak></softBreak>     // A new soft break created by pressing enter.
* "    "[]                    // Retain the indent of 4 spaces.
* </codeBlock>
* ```
*/ function $22de0190197b1839$var$breakLineOnEnter(editor) {
    const model = editor.model;
    const modelDoc = model.document;
    const lastSelectionPosition = modelDoc.selection.getLastPosition();
    let leadingWhiteSpaces;
    const node = $22de0190197b1839$export$a6f878452bd4841a(lastSelectionPosition, model);
    if (node && node.is("$text")) leadingWhiteSpaces = $22de0190197b1839$export$11c6b0ec790ae770(node);
    editor.model.change((writer)=>{
        editor.execute("shiftEnter");
        if (leadingWhiteSpaces) writer.insertText(leadingWhiteSpaces, modelDoc.selection.anchor);
    });
}
/**
* Leave the code block when Enter (but NOT Shift+Enter) has been pressed twice at the beginning
* of the code block:
*
* ```html
* // Before:
* <codeBlock>[]<softBreak></softBreak>foo</codeBlock>
*
* // After pressing:
* <paragraph>[]</paragraph><codeBlock>foo</codeBlock>
* ```
*
* @param isSoftEnter When `true`, enter was pressed along with <kbd>Shift</kbd>.
* @returns `true` when selection left the block. `false` if stayed.
*/ function $22de0190197b1839$var$leaveBlockStartOnEnter(editor, isSoftEnter) {
    const modelDoc = editor.model.document;
    const view = editor.editing.view;
    const lastSelectionPosition = modelDoc.selection.getLastPosition();
    const nodeAfter = lastSelectionPosition.nodeAfter;
    if (isSoftEnter || !modelDoc.selection.isCollapsed || !lastSelectionPosition.isAtStart) return false;
    if (!$22de0190197b1839$var$isSoftBreakNode(nodeAfter)) return false;
    editor.model.change((writer)=>{
        editor.execute("enter");
        const newBlock = modelDoc.selection.anchor.parent.previousSibling;
        writer.rename(newBlock, $22de0190197b1839$var$DEFAULT_ELEMENT);
        writer.setSelection(newBlock, "in");
        editor.model.schema.removeDisallowedAttributes([
            newBlock
        ], writer);
        writer.remove(nodeAfter);
    });
    view.scrollToTheSelection();
    return true;
}
/**
* Leave the code block when Enter (but NOT Shift+Enter) has been pressed twice at the end
* of the code block:
*
* ```html
* // Before:
* <codeBlock>foo[]</codeBlock>
*
* // After first press:
* <codeBlock>foo<softBreak></softBreak>[]</codeBlock>
*
* // After second press:
* <codeBlock>foo</codeBlock><paragraph>[]</paragraph>
* ```
*
* @param isSoftEnter When `true`, enter was pressed along with <kbd>Shift</kbd>.
* @returns `true` when selection left the block. `false` if stayed.
*/ function $22de0190197b1839$var$leaveBlockEndOnEnter(editor, isSoftEnter) {
    const model = editor.model;
    const modelDoc = model.document;
    const view = editor.editing.view;
    const lastSelectionPosition = modelDoc.selection.getLastPosition();
    const nodeBefore = lastSelectionPosition.nodeBefore;
    let emptyLineRangeToRemoveOnEnter;
    if (isSoftEnter || !modelDoc.selection.isCollapsed || !lastSelectionPosition.isAtEnd || !nodeBefore || !nodeBefore.previousSibling) return false;
    if ($22de0190197b1839$var$isSoftBreakNode(nodeBefore) && $22de0190197b1839$var$isSoftBreakNode(nodeBefore.previousSibling)) emptyLineRangeToRemoveOnEnter = model.createRange(model.createPositionBefore(nodeBefore.previousSibling), model.createPositionAfter(nodeBefore));
    else if ($22de0190197b1839$var$isEmptyishTextNode(nodeBefore) && $22de0190197b1839$var$isSoftBreakNode(nodeBefore.previousSibling) && $22de0190197b1839$var$isSoftBreakNode(nodeBefore.previousSibling.previousSibling)) emptyLineRangeToRemoveOnEnter = model.createRange(model.createPositionBefore(nodeBefore.previousSibling.previousSibling), model.createPositionAfter(nodeBefore));
    else if ($22de0190197b1839$var$isEmptyishTextNode(nodeBefore) && $22de0190197b1839$var$isSoftBreakNode(nodeBefore.previousSibling) && $22de0190197b1839$var$isEmptyishTextNode(nodeBefore.previousSibling.previousSibling) && nodeBefore.previousSibling.previousSibling && $22de0190197b1839$var$isSoftBreakNode(nodeBefore.previousSibling.previousSibling.previousSibling)) emptyLineRangeToRemoveOnEnter = model.createRange(model.createPositionBefore(nodeBefore.previousSibling.previousSibling.previousSibling), model.createPositionAfter(nodeBefore));
    else return false;
    editor.model.change((writer)=>{
        writer.remove(emptyLineRangeToRemoveOnEnter);
        editor.execute("enter");
        const newBlock = modelDoc.selection.anchor.parent;
        writer.rename(newBlock, $22de0190197b1839$var$DEFAULT_ELEMENT);
        editor.model.schema.removeDisallowedAttributes([
            newBlock
        ], writer);
    });
    view.scrollToTheSelection();
    return true;
}
function $22de0190197b1839$var$isEmptyishTextNode(node) {
    return node && node.is("$text") && !node.data.match(/\S/);
}
function $22de0190197b1839$var$isSoftBreakNode(node) {
    return node && node.is("element", "softBreak");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module code-block/codeblockui
*/ /**
* The code block UI plugin.
*
* Introduces the `'codeBlock'` dropdown.
*/ var $22de0190197b1839$export$b382115d3f9be1f6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeBlockUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const componentFactory = editor.ui.componentFactory;
        const normalizedLanguageDefs = $22de0190197b1839$export$f5f9c752442d5940(editor);
        const itemDefinitions = this._getLanguageListItemDefinitions(normalizedLanguageDefs);
        const command = editor.commands.get("codeBlock");
        componentFactory.add("codeBlock", (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
            const splitButtonView = dropdownView.buttonView;
            const accessibleLabel = t("Insert code block");
            splitButtonView.set({
                label: accessibleLabel,
                tooltip: true,
                icon: (0, $e8dc502aba5ac3f5$export$b3d4fc19a235faba),
                isToggleable: true
            });
            splitButtonView.bind("isOn").to(command, "value", (value)=>!!value);
            splitButtonView.on("execute", ()=>{
                editor.execute("codeBlock", {
                    usePreviousLanguageChoice: true
                });
                editor.editing.view.focus();
            });
            dropdownView.on("execute", (evt)=>{
                editor.execute("codeBlock", {
                    language: evt.source._codeBlockLanguage,
                    forceValue: true
                });
                editor.editing.view.focus();
            });
            dropdownView.class = "ck-code-block-dropdown";
            dropdownView.bind("isEnabled").to(command);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, itemDefinitions, {
                role: "menu",
                ariaLabel: accessibleLabel
            });
            return dropdownView;
        });
        componentFactory.add("menuBar:codeBlock", (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                role: "menuitem",
                label: t("Code block"),
                icon: (0, $e8dc502aba5ac3f5$export$b3d4fc19a235faba)
            });
            menuView.bind("isEnabled").to(command);
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            listView.set({
                ariaLabel: t("Insert code block")
            });
            for (const definition of itemDefinitions){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.bind(...Object.keys(definition.model)).to(definition.model);
                buttonView.set({
                    isToggleable: true,
                    role: "menuitemcheckbox"
                });
                buttonView.delegate("execute").to(menuView);
                buttonView.on("execute", ()=>{
                    editor.execute("codeBlock", {
                        language: definition.model._codeBlockLanguage,
                        forceValue: command.value == definition.model._codeBlockLanguage ? false : true
                    });
                    editor.editing.view.focus();
                });
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            menuView.panelView.children.add(listView);
            return menuView;
        });
    }
    /**
	* A helper returning a collection of the `codeBlock` dropdown items representing languages
	* available for the user to choose from.
	*/ _getLanguageListItemDefinitions(normalizedLanguageDefs) {
        const command = this.editor.commands.get("codeBlock");
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        for (const languageDef of normalizedLanguageDefs){
            const definition = {
                type: "button",
                model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                    _codeBlockLanguage: languageDef.language,
                    label: languageDef.label,
                    role: "menuitemradio",
                    withText: true
                })
            };
            definition.model.bind("isOn").to(command, "value", (value)=>{
                return value === definition.model._codeBlockLanguage;
            });
            itemDefinitions.add(definition);
        }
        return itemDefinitions;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module code-block/codeblock
*/ /**
* The code block plugin.
*
* For more information about this feature check the {@glink api/code-block package page} and the
* {@glink features/code-blocks code block} feature guide.
*
* This is a "glue" plugin that loads the {@link module:code-block/codeblockediting~CodeBlockEditing code block editing feature}
* and the {@link module:code-block/codeblockui~CodeBlockUI code block UI feature}.
*/ var $22de0190197b1839$export$6c415d1fdae3dfdb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $22de0190197b1839$export$ce7797df97a43067,
            $22de0190197b1839$export$b382115d3f9be1f6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeBlock";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};



/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module easy-image/cloudservicesuploadadapter
*/ /**
* A plugin that enables upload to [CKEditor Cloud Services](https://ckeditor.com/ckeditor-cloud-services/).
*
* It is mainly used by the {@link module:easy-image/easyimage~EasyImage} feature.
*
* After enabling this adapter you need to configure the CKEditor Cloud Services integration through
* {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig `config.cloudServices`}.
*/ var $b0a292d57bbde1dc$export$24f552030829510c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _uploadGateway;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CloudServicesUploadAdapter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $308936d8e01dd630$export$c8fb568fd3d3ad20),
            (0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const cloudServices = editor.plugins.get((0, $308936d8e01dd630$export$c8fb568fd3d3ad20));
        const token = cloudServices.token;
        const uploadUrl = cloudServices.uploadUrl;
        if (!token) return;
        const cloudServicesCore = editor.plugins.get("CloudServicesCore");
        this._uploadGateway = cloudServicesCore.createUploadGateway(token, uploadUrl);
        editor.plugins.get((0, $fd8e3f82b47092fc$export$db17b98b9d8ffd51)).createUploadAdapter = (loader)=>{
            return new $b0a292d57bbde1dc$var$Adapter(this._uploadGateway, loader);
        };
    }
};
var $b0a292d57bbde1dc$var$Adapter = class {
    uploadGateway;
    loader;
    fileUploader;
    constructor(uploadGateway, loader){
        this.uploadGateway = uploadGateway;
        this.loader = loader;
    }
    upload() {
        return this.loader.file.then((file)=>{
            this.fileUploader = this.uploadGateway.upload(file);
            this.fileUploader.on("progress", (evt, data)=>{
                this.loader.uploadTotal = data.total;
                this.loader.uploaded = data.uploaded;
            });
            return this.fileUploader.send();
        });
    }
    abort() {
        this.fileUploader.abort();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module easy-image/easyimage
*/ /**
* The Easy Image feature, which makes the image upload in CKEditor 5 possible with virtually zero
* server setup. A part of the [CKEditor Cloud Services](https://ckeditor.com/ckeditor-cloud-services/)
* family.
*
* This is a "glue" plugin which enables:
*
* * {@link module:easy-image/cloudservicesuploadadapter~CloudServicesUploadAdapter}.
*
* This plugin requires plugin to be present in the editor configuration:
*
* * {@link module:image/image~Image},
* * {@link module:image/imageupload~ImageUpload},
*
* See the [Easy Image Quick Start guide](https://ckeditor.com/docs/cs/latest/guides/easy-image/quick-start.html) to learn how to configure
* and use this feature.
*
* Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload" guide} to learn about
* other ways to upload images into CKEditor 5.
*
* **Note**: After enabling the Easy Image plugin you need to configure the
* [CKEditor Cloud Services](https://ckeditor.com/ckeditor-cloud-services/)
* integration through {@link module:cloud-services/cloudservicesconfig~CloudServicesConfig `config.cloudServices`}.
*/ var $b0a292d57bbde1dc$export$3da9e25a7afe430c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "EasyImage";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $b0a292d57bbde1dc$export$24f552030829510c,
            (0, $7c22895ca0418c15$export$6083e5dee0802eaa)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("ImageBlockEditing") && !editor.plugins.has("ImageInlineEditing")) /**
		* The Easy Image feature requires one of the following plugins to be loaded to work correctly:
		*
		* * {@link module:image/imageblock~ImageBlock},
		* * {@link module:image/imageinline~ImageInline},
		* * {@link module:image/image~Image} (loads both `ImageBlock` and `ImageInline`)
		*
		* Please make sure your editor configuration is correct.
		*
		* @error easy-image-image-feature-missing
		* @param {module:core/editor/editor~Editor} editor The editor instance.
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("easy-image-image-feature-missing", editor);
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-balloon/ballooneditorui
*/ /**
* The balloon editor UI class.
*/ var $db012fb8b7c2c86f$export$bcf5b117c496ba1d = class extends (0, $29fd27cb9bdab9d2$export$19609b17c3b0114) {
    /**
	* The main (top–most) view of the editor UI.
	*/ view;
    /**
	* Creates an instance of the balloon editor UI class.
	*
	* @param editor The editor instance.
	* @param view The view of the UI.
	*/ constructor(editor, view){
        super(editor);
        this.view = view;
    }
    /**
	* @inheritDoc
	*/ get element() {
        return this.view.editable.element;
    }
    /**
	* Initializes the UI.
	*/ init() {
        const editor = this.editor;
        const view = this.view;
        const editingView = editor.editing.view;
        const editable = view.editable;
        const editingRoot = editingView.document.getRoot();
        editable.name = editingRoot.rootName;
        editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(editor, editingRoot.rootName);
        editable.isMainFrameEditingRoot = true;
        view.render();
        const editableElement = editable.element;
        this.setEditableElement(editable.name, editableElement);
        editable.bind("isFocused").to(this.focusTracker);
        editingView.attachDomRoot(editableElement);
        this._initPlaceholder();
        this.initMenuBar(this.view.menuBarView);
        this.fire("ready");
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        const view = this.view;
        const editingView = this.editor.editing.view;
        if (editingView.getDomRoot(view.editable.name)) editingView.detachDomRoot(view.editable.name);
        view.destroy();
    }
    /**
	* Enable the placeholder text on the editing root.
	*/ _initPlaceholder() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const editingRoot = editingView.document.getRoot();
        const placeholder = editor.config.get("roots")[editingRoot.rootName].placeholder;
        if (placeholder) editingRoot.placeholder = placeholder;
        (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
            view: editingView,
            element: editingRoot,
            isDirectHost: this.view.editable.isInlineRoot,
            keepOnFocus: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-balloon/ballooneditoruiview
*/ /**
* Contextual editor UI view. Uses the {@link module:ui/editableui/inline/inlineeditableuiview~InlineEditableUIView}.
*/ var $db012fb8b7c2c86f$export$3b0054f4bfca43e7 = class extends (0, $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c) {
    /**
	* Editable UI view.
	*/ editable;
    /**
	* Menu bar view instance.
	*/ menuBarView;
    /**
	* Creates an instance of the balloon editor UI view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param editingView The editing view instance this view is related to.
	* @param editableElement The editable element. If not specified, it will be automatically created by
	* {@link module:ui/editableui/editableuiview~EditableUIView}. Otherwise, the given element will be used.
	* @param label When set, this value will be used as an accessible `aria-label` of the
	* {@link module:ui/editableui/editableuiview~EditableUIView editable view}.
	*/ constructor(locale, editingView, editableElement, label){
        super(locale);
        this.editable = new (0, $29fd27cb9bdab9d2$export$7a9e58c3d1414b)(locale, editingView, editableElement, {
            label: label
        });
        this.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(locale);
        this.menuBarView.extendTemplate({
            attributes: {
                class: [
                    "ck-reset_all",
                    "ck-rounded-corners"
                ],
                dir: locale.uiLanguageDirection
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.registerChild(this.editable);
        this.registerChild(this.menuBarView);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-balloon/ballooneditor
*/ const $db012fb8b7c2c86f$var$BalloonEditorBase = /* #__PURE__ */ (0, $7ca4ca5784e50ca9$export$d727bee3703dbc10)((0, $7ca4ca5784e50ca9$export$7cda8d932e2f33c0));
/**
* The balloon editor implementation (Medium-like editor).
* It uses an inline editable and a toolbar based on the {@link module:ui/toolbar/balloon/balloontoolbar~BalloonToolbar}.
* See the {@glink examples/builds/balloon-editor demo}.
*
* In order to create a balloon editor instance, use the static
* {@link module:editor-balloon/ballooneditor~BalloonEditor.create `BalloonEditor.create()`} method.
*/ var $db012fb8b7c2c86f$export$b941c5635799a0e7 = class extends $db012fb8b7c2c86f$var$BalloonEditorBase {
    /**
	* @inheritDoc
	*/ static get editorName() {
        return "BalloonEditor";
    }
    /**
	* @inheritDoc
	*/ ui;
    constructor(sourceElementOrDataOrConfig, config = {}){
        const { sourceElementOrData: sourceElementOrData, editorConfig: editorConfig } = (0, $7ca4ca5784e50ca9$export$4bbd8134967c9cee)(sourceElementOrDataOrConfig, config);
        super(editorConfig);
        (0, $7ca4ca5784e50ca9$export$30c905284d284ef1)(sourceElementOrData, this.config);
        const editableElement = this.config.get("roots").main.element;
        if ($db012fb8b7c2c86f$var$isElement$1(editableElement)) {
            this.sourceElement = editableElement;
            (0, $7ca4ca5784e50ca9$export$a7d1ef409587e25)(this, editableElement);
        }
        const plugins = this.config.get("plugins");
        plugins.push((0, $29fd27cb9bdab9d2$export$cbc3f15db3a8b2ec));
        this.config.set("plugins", plugins);
        this.config.define("balloonToolbar", this.config.get("toolbar"));
        this.model.document.createRoot(this.config.get("roots").main.modelElement);
        (0, $7ca4ca5784e50ca9$export$58a114a982b34496)(this);
        const view = new $db012fb8b7c2c86f$export$3b0054f4bfca43e7(this.locale, this.editing.view, editableElement, this.config.get("roots").main.label);
        this.ui = new $db012fb8b7c2c86f$export$bcf5b117c496ba1d(this, view);
        (0, $7ca4ca5784e50ca9$export$49c9860462f722d8)(this);
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* Updates the original editor element with the data if the
	* {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
	* configuration option is set to `true`.
	*/ async destroy() {
        const data = this.getData();
        this.ui.destroy();
        await super.destroy();
        if (this.sourceElement) this.updateSourceElement(data);
    }
    static async create(sourceElementOrDataOrConfig, config = {}) {
        const editor = new this(sourceElementOrDataOrConfig, config);
        await editor.initPlugins();
        (0, $7ca4ca5784e50ca9$export$d1de9dbb66389037)(editor);
        await editor.ui.init();
        await editor.data.init(editor.config.get("roots").main.initialData);
        editor.fire("ready");
        return editor;
    }
};
function $db012fb8b7c2c86f$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-classic/classiceditorui
*/ /**
* The classic editor UI class.
*/ var $214c629190e85ae1$export$ff81e6d71dcf048e = class extends (0, $29fd27cb9bdab9d2$export$19609b17c3b0114) {
    /**
	* The main (top–most) view of the editor UI.
	*/ view;
    /**
	* A normalized `config.toolbar` object.
	*/ _toolbarConfig;
    /**
	* The element replacer instance used to hide the editor's source element.
	*/ _elementReplacer;
    /**
	* Creates an instance of the classic editor UI class.
	*
	* @param editor The editor instance.
	* @param view The view of the UI.
	*/ constructor(editor, view){
        super(editor);
        this.view = view;
        this._toolbarConfig = (0, $29fd27cb9bdab9d2$export$cddba3238a31417a)(editor.config.get("toolbar"));
        this._elementReplacer = new (0, $c7bc2cb7e2db0227$export$d2f12916c0c3be76)();
        this.listenTo(editor.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
    }
    /**
	* @inheritDoc
	*/ get element() {
        return this.view.element;
    }
    /**
	* Initializes the UI.
	*
	* @param replacementElement The DOM element that will be the source for the created editor.
	*/ init(replacementElement) {
        const editor = this.editor;
        const view = this.view;
        const editingView = editor.editing.view;
        const editable = view.editable;
        const editingRoot = editingView.document.getRoot();
        editable.name = editingRoot.rootName;
        editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(editor, editingRoot.rootName);
        editable.isMainFrameEditingRoot = true;
        view.render();
        const editableElement = editable.element;
        this.setEditableElement(editable.name, editableElement);
        view.editable.bind("isFocused").to(this.focusTracker);
        editingView.attachDomRoot(editableElement);
        if (replacementElement) this._elementReplacer.replace(replacementElement, this.element);
        this._initPlaceholder();
        this._initToolbar();
        if (view.menuBarView) this.initMenuBar(view.menuBarView);
        this._initDialogPluginIntegration();
        this._initContextualBalloonIntegration();
        this.fire("ready");
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        const view = this.view;
        const editingView = this.editor.editing.view;
        this._elementReplacer.restore();
        if (editingView.getDomRoot(view.editable.name)) editingView.detachDomRoot(view.editable.name);
        view.destroy();
    }
    /**
	* Initializes the editor toolbar.
	*/ _initToolbar() {
        const view = this.view;
        view.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused");
        view.stickyPanel.limiterElement = view.element;
        view.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({ visualTop: visualTop })=>visualTop || 0);
        view.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory);
        this.addToolbar(view.toolbar);
    }
    /**
	* Enable the placeholder text on the editing root.
	*/ _initPlaceholder() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const editingRoot = editingView.document.getRoot();
        const sourceElement = editor.sourceElement;
        let placeholderText;
        const placeholder = editor.config.get("roots")[this.view.editable.name].placeholder;
        if (placeholder) placeholderText = placeholder;
        if (!placeholderText && sourceElement && sourceElement.tagName.toLowerCase() === "textarea") placeholderText = sourceElement.getAttribute("placeholder");
        if (placeholderText) editingRoot.placeholder = placeholderText;
        (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
            view: editingView,
            element: editingRoot,
            isDirectHost: this.view.editable.isInlineRoot,
            keepOnFocus: true
        });
    }
    /**
	* Provides an integration between the sticky toolbar and {@link module:ui/panel/balloon/contextualballoon contextual balloon plugin}.
	* It allows the contextual balloon to consider the height of the
	* {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel}. It prevents the balloon from overlapping
	* the sticky toolbar by adjusting the balloon's position using viewport offset configuration.
	*/ _initContextualBalloonIntegration() {
        if (!this.editor.plugins.has("ContextualBalloon")) return;
        const { stickyPanel: stickyPanel } = this.view;
        const contextualBalloon = this.editor.plugins.get("ContextualBalloon");
        contextualBalloon.on("getPositionOptions", (evt)=>{
            const position = evt.return;
            if (!position || !stickyPanel.isSticky || !stickyPanel.element) return;
            const stickyPanelHeight = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(stickyPanel.element).height;
            const target = typeof position.target === "function" ? position.target() : position.target;
            const limiter = typeof position.limiter === "function" ? position.limiter() : position.limiter;
            if (target && limiter && new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(target).height >= new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(limiter).height - stickyPanelHeight) return;
            const viewportOffsetConfig = {
                ...position.viewportOffsetConfig
            };
            const newTopViewportOffset = (viewportOffsetConfig.top || 0) + stickyPanelHeight;
            evt.return = {
                ...position,
                viewportOffsetConfig: {
                    ...viewportOffsetConfig,
                    top: newTopViewportOffset
                }
            };
        }, {
            priority: "low"
        });
        const updateBalloonPosition = ()=>{
            if (contextualBalloon.visibleView) contextualBalloon.updatePosition();
        };
        this.listenTo(stickyPanel, "change:isSticky", updateBalloonPosition);
        this.listenTo(this.editor.ui, "change:viewportOffset", updateBalloonPosition);
    }
    /**
	* Provides an integration between the sticky toolbar and {@link module:utils/dom/scroll~scrollViewportToShowTarget}.
	* It allows the UI-agnostic engine method to consider the geometry of the
	* {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel} that pins to the
	* edge of the viewport and can obscure the user caret after scrolling the window.
	*
	* @param evt The `scrollToTheSelection` event info.
	* @param data The payload carried by the `scrollToTheSelection` event.
	* @param originalArgs The original arguments passed to `scrollViewportToShowTarget()` method (see implementation to learn more).
	*/ _handleScrollToTheSelectionWithStickyPanel(evt, data, originalArgs) {
        const stickyPanel = this.view.stickyPanel;
        if (stickyPanel.isSticky) {
            const stickyPanelHeight = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(stickyPanel.element).height;
            data.viewportOffset.top += stickyPanelHeight;
        } else {
            const scrollViewportOnPanelGettingSticky = ()=>{
                this.editor.editing.view.scrollToTheSelection(originalArgs);
            };
            this.listenTo(stickyPanel, "change:isSticky", scrollViewportOnPanelGettingSticky);
            setTimeout(()=>{
                this.stopListening(stickyPanel, "change:isSticky", scrollViewportOnPanelGettingSticky);
            }, 20);
        }
    }
    /**
	* Provides an integration between the sticky toolbar and {@link module:ui/dialog/dialog the Dialog plugin}.
	*
	* It moves the dialog down to ensure that the
	* {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel sticky panel}
	* used by the editor UI will not get obscured by the dialog when the dialog uses one of its automatic positions.
	*/ _initDialogPluginIntegration() {
        if (!this.editor.plugins.has("Dialog")) return;
        const stickyPanel = this.view.stickyPanel;
        const dialogPlugin = this.editor.plugins.get("Dialog");
        dialogPlugin.on("show", ()=>{
            const dialogView = dialogPlugin.view;
            dialogView.on("moveTo", (evt, data)=>{
                if (!stickyPanel.isSticky || dialogView.wasMoved || dialogView.isModal) return;
                const stickyPanelContentRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(stickyPanel.contentPanelElement);
                if (data[1] < stickyPanelContentRect.bottom + (0, $29fd27cb9bdab9d2$export$9adfefb9e06546bf).defaultOffset) data[1] = stickyPanelContentRect.bottom + (0, $29fd27cb9bdab9d2$export$9adfefb9e06546bf).defaultOffset;
            }, {
                priority: "high"
            });
        }, {
            priority: "low"
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-classic/classiceditoruiview
*/ /**
* Classic editor UI view. Uses an inline editable and a sticky toolbar, all
* enclosed in a boxed UI view.
*/ var $214c629190e85ae1$export$116eb2a2bcf38eb2 = class extends (0, $29fd27cb9bdab9d2$export$dbf7aa4890ad2bdb) {
    /**
	* Sticky panel view instance. This is a parent view of a {@link #toolbar}
	* that makes toolbar sticky.
	*/ stickyPanel;
    /**
	* Toolbar view instance.
	*/ toolbar;
    /**
	* Editable UI view.
	*/ editable;
    /**
	* Creates an instance of the classic editor UI view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param editingView The editing view instance this view is related to.
	* @param options Configuration options for the view instance.
	* @param options.shouldToolbarGroupWhenFull When set `true` enables automatic items grouping
	* in the main {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#toolbar toolbar}.
	* See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
	* @param options.editableElement A {@link module:core/editor/editorconfig~ViewRootElementDefinition}
	* describing the editable element to create inside the UI box. When omitted, a default `<div>` is used.
	* @param options.label When set, this value will be used as an accessible `aria-label` of the
	* {@link module:ui/editableui/editableuiview~EditableUIView editable view}.
	*/ constructor(locale, editingView, options = {}){
        super(locale);
        this.stickyPanel = new (0, $29fd27cb9bdab9d2$export$26092d970033229e)(locale);
        this.toolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale, {
            shouldGroupWhenFull: options.shouldToolbarGroupWhenFull
        });
        if (options.useMenuBar) this.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(locale);
        this.editable = new (0, $29fd27cb9bdab9d2$export$7a9e58c3d1414b)(locale, editingView, options.editableElement, {
            label: options.label
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        if (this.menuBarView) this.stickyPanel.content.addMany([
            this.menuBarView,
            this.toolbar
        ]);
        else this.stickyPanel.content.add(this.toolbar);
        this.top.add(this.stickyPanel);
        this.main.add(this.editable);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-classic/classiceditor
*/ const $214c629190e85ae1$var$ClassicEditorBase = /* #__PURE__ */ (0, $7ca4ca5784e50ca9$export$d727bee3703dbc10)((0, $7ca4ca5784e50ca9$export$7cda8d932e2f33c0));
/**
* The classic editor implementation. It uses an inline editable and a sticky toolbar, all enclosed in a boxed UI.
* See the {@glink examples/builds/classic-editor demo}.
*
* In order to create a classic editor instance, use the static
* {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`} method.
*/ var $214c629190e85ae1$export$9abc99ab116ac079 = class extends $214c629190e85ae1$var$ClassicEditorBase {
    /**
	* @inheritDoc
	*/ static get editorName() {
        return "ClassicEditor";
    }
    /**
	* @inheritDoc
	*/ ui;
    constructor(sourceElementOrDataOrConfig, config = {}){
        const { sourceElementOrData: sourceElementOrData, editorConfig: editorConfig } = (0, $7ca4ca5784e50ca9$export$4bbd8134967c9cee)(sourceElementOrDataOrConfig, config);
        super(editorConfig);
        (0, $7ca4ca5784e50ca9$export$30c905284d284ef1)(sourceElementOrData, this.config, "main", true);
        const sourceElement = this.config.get("attachTo");
        this.config.define("menuBar.isVisible", false);
        if ($214c629190e85ae1$var$isElement$1(sourceElement)) {
            if (!sourceElement.isConnected) /**
			* Cannot initialize the editor because the provided source element is not attached to the DOM and cannot be replaced.
			*
			* @error editor-source-element-not-attached
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("editor-source-element-not-attached", null);
            this.sourceElement = sourceElement;
        }
        this.model.document.createRoot(this.config.get("roots").main.modelElement);
        (0, $7ca4ca5784e50ca9$export$58a114a982b34496)(this);
        const shouldToolbarGroupWhenFull = !this.config.get("toolbar.shouldNotGroupWhenFull");
        const menuBarConfig = this.config.get("menuBar");
        const editableElement = this.config.get("roots").main.element;
        const view = new $214c629190e85ae1$export$116eb2a2bcf38eb2(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: shouldToolbarGroupWhenFull,
            useMenuBar: menuBarConfig.isVisible,
            label: this.config.get("roots").main.label,
            editableElement: editableElement
        });
        this.ui = new $214c629190e85ae1$export$ff81e6d71dcf048e(this, view);
        (0, $7ca4ca5784e50ca9$export$49c9860462f722d8)(this);
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* Updates the original editor element with the data if the
	* {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
	* configuration option is set to `true`.
	*/ async destroy() {
        if (this.sourceElement) this.updateSourceElement();
        this.ui.destroy();
        await super.destroy();
    }
    static async create(sourceElementOrDataOrConfig, config = {}) {
        const editor = new this(sourceElementOrDataOrConfig, config);
        await editor.initPlugins();
        (0, $7ca4ca5784e50ca9$export$d1de9dbb66389037)(editor);
        await editor.ui.init(editor.config.get("attachTo") || null);
        await editor.data.init(editor.config.get("roots").main.initialData);
        editor.fire("ready");
        return editor;
    }
};
function $214c629190e85ae1$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-decoupled/decouplededitorui
*/ /**
* The decoupled editor UI class.
*/ var $90d4e75e7b7634a0$export$e22b6207ace1e33d = class extends (0, $29fd27cb9bdab9d2$export$19609b17c3b0114) {
    /**
	* The main (top–most) view of the editor UI.
	*/ view;
    /**
	* Creates an instance of the decoupled editor UI class.
	*
	* @param editor The editor instance.
	* @param view The view of the UI.
	*/ constructor(editor, view){
        super(editor);
        this.view = view;
    }
    /**
	* Initializes the UI.
	*/ init() {
        const editor = this.editor;
        const view = this.view;
        const editingView = editor.editing.view;
        const editable = view.editable;
        const editingRoot = editingView.document.getRoot();
        editable.name = editingRoot.rootName;
        editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(editor, editingRoot.rootName);
        editable.isMainFrameEditingRoot = true;
        view.render();
        const editableElement = editable.element;
        this.setEditableElement(editable.name, editableElement);
        view.editable.bind("isFocused").to(this.focusTracker);
        editingView.attachDomRoot(editableElement);
        this._initPlaceholder();
        this._initToolbar();
        this.initMenuBar(this.view.menuBarView);
        this.fire("ready");
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        const view = this.view;
        const editingView = this.editor.editing.view;
        if (editingView.getDomRoot(view.editable.name)) editingView.detachDomRoot(view.editable.name);
        view.destroy();
    }
    /**
	* Initializes the inline editor toolbar and its panel.
	*/ _initToolbar() {
        const editor = this.editor;
        const view = this.view;
        view.toolbar.fillFromConfig(editor.config.get("toolbar"), this.componentFactory);
        this.addToolbar(view.toolbar);
    }
    /**
	* Enable the placeholder text on the editing root.
	*/ _initPlaceholder() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const editingRoot = editingView.document.getRoot();
        const placeholder = editor.config.get("roots")[editingRoot.rootName].placeholder;
        if (placeholder) editingRoot.placeholder = placeholder;
        (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
            view: editingView,
            element: editingRoot,
            isDirectHost: this.view.editable.isInlineRoot,
            keepOnFocus: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-decoupled/decouplededitoruiview
*/ /**
* The decoupled editor UI view. It is a virtual view providing an inline
* {@link module:editor-decoupled/decouplededitoruiview~DecoupledEditorUIView#editable},
* {@link module:editor-decoupled/decouplededitoruiview~DecoupledEditorUIView#toolbar}, and a
* {@link module:editor-decoupled/decouplededitoruiview~DecoupledEditorUIView#menuBarView} but without any
* specific arrangement of the components in the DOM.
*
* See {@link module:editor-decoupled/decouplededitor~DecoupledEditor.create `DecoupledEditor.create()`}
* to learn more about this view.
*/ var $90d4e75e7b7634a0$export$9f848c30024e3555 = class extends (0, $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c) {
    /**
	* The main toolbar of the decoupled editor UI.
	*/ toolbar;
    /**
	* The editable of the decoupled editor UI.
	*/ editable;
    /**
	* Menu bar view instance.
	*/ menuBarView;
    /**
	* Creates an instance of the decoupled editor UI view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param editingView The editing view instance this view is related to.
	* @param options Configuration options for the view instance.
	* @param options.editableElement The editable element. If not specified, it will be automatically created by
	* {@link module:ui/editableui/editableuiview~EditableUIView}. Otherwise, the given element will be used.
	* @param options.shouldToolbarGroupWhenFull When set `true` enables automatic items grouping
	* in the main {@link module:editor-decoupled/decouplededitoruiview~DecoupledEditorUIView#toolbar toolbar}.
	* See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
	* @param options.label When set, this value will be used as an accessible `aria-label` of the
	* {@link module:ui/editableui/editableuiview~EditableUIView editable view}.
	*/ constructor(locale, editingView, options = {}){
        super(locale);
        this.toolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale, {
            shouldGroupWhenFull: options.shouldToolbarGroupWhenFull
        });
        this.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(locale);
        this.editable = new (0, $29fd27cb9bdab9d2$export$7a9e58c3d1414b)(locale, editingView, options.editableElement, {
            label: options.label
        });
        this.toolbar.extendTemplate({
            attributes: {
                class: [
                    "ck-reset_all",
                    "ck-rounded-corners"
                ],
                dir: locale.uiLanguageDirection
            }
        });
        this.menuBarView.extendTemplate({
            attributes: {
                class: [
                    "ck-reset_all",
                    "ck-rounded-corners"
                ],
                dir: locale.uiLanguageDirection
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.registerChild([
            this.menuBarView,
            this.toolbar,
            this.editable
        ]);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-decoupled/decouplededitor
*/ const $90d4e75e7b7634a0$var$DecoupledEditorBase = /* #__PURE__ */ (0, $7ca4ca5784e50ca9$export$d727bee3703dbc10)((0, $7ca4ca5784e50ca9$export$7cda8d932e2f33c0));
/**
* The decoupled editor implementation. It provides an inline editable and a toolbar. However, unlike other editors,
* it does not render these components anywhere in the DOM unless configured.
*
* This type of an editor is dedicated to integrations which require a customized UI with an open
* structure, allowing developers to specify the exact location of the interface.
*
* See the document editor {@glink examples/builds/document-editor demo} to learn about possible use cases
* for the decoupled editor.
*
* In order to create a decoupled editor instance, use the static
* {@link module:editor-decoupled/decouplededitor~DecoupledEditor.create `DecoupledEditor.create()`} method.
*
* Note that you will need to attach the editor toolbar and menu bar to your web page manually, in a desired place,
* after the editor is initialized.
*/ var $90d4e75e7b7634a0$export$9598e7e1aadeab45 = class extends $90d4e75e7b7634a0$var$DecoupledEditorBase {
    /**
	* @inheritDoc
	*/ static get editorName() {
        return "DecoupledEditor";
    }
    /**
	* @inheritDoc
	*/ ui;
    constructor(sourceElementOrDataOrConfig, config = {}){
        const { sourceElementOrData: sourceElementOrData, editorConfig: editorConfig } = (0, $7ca4ca5784e50ca9$export$4bbd8134967c9cee)(sourceElementOrDataOrConfig, config);
        super(editorConfig);
        (0, $7ca4ca5784e50ca9$export$30c905284d284ef1)(sourceElementOrData, this.config);
        const editableElement = this.config.get("roots").main.element;
        if ($90d4e75e7b7634a0$var$isElement$1(editableElement)) {
            this.sourceElement = editableElement;
            (0, $7ca4ca5784e50ca9$export$a7d1ef409587e25)(this, editableElement);
        }
        this.model.document.createRoot(this.config.get("roots").main.modelElement);
        (0, $7ca4ca5784e50ca9$export$58a114a982b34496)(this);
        const shouldToolbarGroupWhenFull = !this.config.get("toolbar.shouldNotGroupWhenFull");
        const view = new $90d4e75e7b7634a0$export$9f848c30024e3555(this.locale, this.editing.view, {
            editableElement: editableElement,
            shouldToolbarGroupWhenFull: shouldToolbarGroupWhenFull,
            label: this.config.get("roots").main.label
        });
        this.ui = new $90d4e75e7b7634a0$export$e22b6207ace1e33d(this, view);
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* Updates the original editor element with the data if the
	* {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
	* configuration option is set to `true`.
	*
	* **Note**: The decoupled editor does not remove the toolbar and editable when destroyed. You can
	* do that yourself in the destruction chain:
	*
	* ```ts
	* editor.destroy()
	* 	.then( () => {
	* 		// Remove the toolbar from DOM.
	* 		editor.ui.view.toolbar.element.remove();
	*
	* 		// Remove the editable from DOM.
	* 		editor.ui.view.editable.element.remove();
	*
	* 		console.log( 'Editor was destroyed' );
	* 	} );
	* ```
	*/ async destroy() {
        const data = this.getData();
        this.ui.destroy();
        await super.destroy();
        if (this.sourceElement) this.updateSourceElement(data);
    }
    static async create(sourceElementOrDataOrConfig, config = {}) {
        const editor = new this(sourceElementOrDataOrConfig, config);
        await editor.initPlugins();
        (0, $7ca4ca5784e50ca9$export$d1de9dbb66389037)(editor);
        await editor.ui.init();
        await editor.data.init(editor.config.get("roots").main.initialData);
        editor.fire("ready");
        return editor;
    }
};
function $90d4e75e7b7634a0$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-inline/inlineeditorui
*/ /**
* The inline editor UI class.
*
* @extends module:ui/editorui/editorui~EditorUI
*/ var $85903122cb082902$export$336d1adb11b44fcb = class extends (0, $29fd27cb9bdab9d2$export$19609b17c3b0114) {
    /**
	* The main (top–most) view of the editor UI.
	*/ view;
    /**
	* A normalized `config.toolbar` object.
	*/ _toolbarConfig;
    /**
	* Creates an instance of the inline editor UI class.
	*
	* @param editor The editor instance.
	* @param view The view of the UI.
	*/ constructor(editor, view){
        super(editor);
        this.view = view;
        this._toolbarConfig = (0, $29fd27cb9bdab9d2$export$cddba3238a31417a)(editor.config.get("toolbar"));
    }
    /**
	* @inheritDoc
	*/ get element() {
        return this.view.editable.element;
    }
    /**
	* Initializes the UI.
	*/ init() {
        const editor = this.editor;
        const view = this.view;
        const editingView = editor.editing.view;
        const editable = view.editable;
        const editingRoot = editingView.document.getRoot();
        editable.name = editingRoot.rootName;
        editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(editor, editingRoot.rootName);
        editable.isMainFrameEditingRoot = true;
        view.render();
        const editableElement = editable.element;
        this.setEditableElement(editable.name, editableElement);
        editable.bind("isFocused").to(this.focusTracker);
        editingView.attachDomRoot(editableElement);
        this._initPlaceholder();
        this._initToolbar();
        if (view.menuBarView) this.initMenuBar(view.menuBarView);
        this.fire("ready");
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        const view = this.view;
        const editingView = this.editor.editing.view;
        if (editingView.getDomRoot(view.editable.name)) editingView.detachDomRoot(view.editable.name);
        view.destroy();
    }
    /**
	* Initializes the inline editor toolbar and its panel.
	*/ _initToolbar() {
        const editor = this.editor;
        const view = this.view;
        const editableElement = view.editable.element;
        const toolbar = view.toolbar;
        view.panel.bind("isVisible").to(this.focusTracker, "isFocused");
        view.bind("viewportTopOffset").to(this, "viewportOffset", ({ visualTop: visualTop })=>visualTop || 0);
        view.listenTo(editor.ui, "update", ()=>{
            if (view.panel.isVisible) view.panel.pin({
                target: editableElement,
                positions: view.panelPositions
            });
        });
        toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory);
        this.addToolbar(toolbar);
    }
    /**
	* Enable the placeholder text on the editing root.
	*/ _initPlaceholder() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const editingRoot = editingView.document.getRoot();
        const placeholder = editor.config.get("roots")[editingRoot.rootName].placeholder;
        if (placeholder) editingRoot.placeholder = placeholder;
        (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
            view: editingView,
            element: editingRoot,
            isDirectHost: this.view.editable.isInlineRoot,
            keepOnFocus: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-inline/inlineeditoruiview
*/ const $85903122cb082902$var$toPx = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* Inline editor UI view. Uses an nline editable and a floating toolbar.
*/ var $85903122cb082902$export$4a295ed835f032a = class extends (0, $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c) {
    /**
	* A floating toolbar view instance.
	*/ toolbar;
    /**
	* A balloon panel view instance.
	*/ panel;
    /**
	* A set of positioning functions used by the {@link #panel} to float around
	* {@link #element editableElement}.
	*
	* The positioning functions are as follows:
	*
	* * West:
	*
	* ```
	* [ Panel ]
	* +------------------+
	* | #editableElement |
	* +------------------+
	*
	* +------------------+
	* | #editableElement |
	* |[ Panel ]         |
	* |                  |
	* +------------------+
	*
	* +------------------+
	* | #editableElement |
	* +------------------+
	* [ Panel ]
	* ```
	*
	* * East:
	*
	* ```
	*            [ Panel ]
	* +------------------+
	* | #editableElement |
	* +------------------+
	*
	* +------------------+
	* | #editableElement |
	* |         [ Panel ]|
	* |                  |
	* +------------------+
	*
	* +------------------+
	* | #editableElement |
	* +------------------+
	*            [ Panel ]
	* ```
	*
	* See: {@link module:utils/dom/position~DomOptimalPositionOptions#positions}.
	*/ panelPositions;
    /**
	* Editable UI view.
	*/ editable;
    /**
	* An instance of the resize observer that helps dynamically determine the geometry of the toolbar
	* and manage items that do not fit into a single row.
	*
	* **Note:** Created in {@link #render}.
	*/ _resizeObserver;
    /**
	* Creates an instance of the inline editor UI view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param editingView The editing view instance this view is related to.
	* @param editableElement The editable element. If not specified, it will be automatically created by
	* {@link module:ui/editableui/editableuiview~EditableUIView}. Otherwise, the given element will be used.
	* @param options Configuration options for the view instance.
	* @param options.shouldToolbarGroupWhenFull When set `true` enables automatic items grouping
	* in the main {@link module:editor-inline/inlineeditoruiview~InlineEditorUIView#toolbar toolbar}.
	* See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
	* @param options.label When set, this value will be used as an accessible `aria-label` of the
	* {@link module:ui/editableui/editableuiview~EditableUIView editable view}.
	*/ constructor(locale, editingView, editableElement, options = {}){
        super(locale);
        this.toolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale, {
            shouldGroupWhenFull: options.shouldToolbarGroupWhenFull,
            isFloating: true
        });
        if (options.useMenuBar) this.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(locale);
        this.set("viewportTopOffset", 0);
        this.panel = new (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c)(locale);
        this.panelPositions = this._getPanelPositions();
        this.panel.extendTemplate({
            attributes: {
                class: "ck-toolbar-container"
            }
        });
        this.editable = new (0, $29fd27cb9bdab9d2$export$7a9e58c3d1414b)(locale, editingView, editableElement, {
            label: options.label
        });
        this._resizeObserver = null;
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.body.add(this.panel);
        this.registerChild(this.editable);
        if (this.menuBarView) this.panel.content.addMany([
            this.menuBarView,
            this.toolbar
        ]);
        else this.panel.content.add(this.toolbar);
        if (this.toolbar.options.shouldGroupWhenFull) {
            const editableElement = this.editable.element;
            this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(editableElement, ()=>{
                this.toolbar.maxWidth = $85903122cb082902$var$toPx(new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(editableElement).width);
            });
        }
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this._resizeObserver) this._resizeObserver.destroy();
    }
    /**
	* Determines the panel top position of the {@link #panel} in {@link #panelPositions}.
	*
	* @param editableRect Rect of the {@link #element}.
	* @param panelRect Rect of the {@link #panel}.
	*/ _getPanelPositionTop(editableRect, panelRect) {
        let top;
        if (editableRect.top > panelRect.height + this.viewportTopOffset) top = editableRect.top - panelRect.height;
        else if (editableRect.bottom > panelRect.height + this.viewportTopOffset + 50) top = this.viewportTopOffset;
        else top = editableRect.bottom;
        return top;
    }
    /**
	* Returns the positions for {@link #panelPositions}.
	*
	* See: {@link module:utils/dom/position~DomOptimalPositionOptions#positions}.
	*/ _getPanelPositions() {
        const positions = [
            (editableRect, panelRect)=>{
                return {
                    top: this._getPanelPositionTop(editableRect, panelRect),
                    left: editableRect.left,
                    name: "toolbar_west",
                    config: {
                        withArrow: false
                    }
                };
            },
            (editableRect, panelRect)=>{
                return {
                    top: this._getPanelPositionTop(editableRect, panelRect),
                    left: editableRect.left + editableRect.width - panelRect.width,
                    name: "toolbar_east",
                    config: {
                        withArrow: false
                    }
                };
            }
        ];
        if (this.locale.uiLanguageDirection === "ltr") return positions;
        else return positions.reverse();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-inline/inlineeditor
*/ const $85903122cb082902$var$InlineEditorBase = /* #__PURE__ */ (0, $7ca4ca5784e50ca9$export$d727bee3703dbc10)((0, $7ca4ca5784e50ca9$export$7cda8d932e2f33c0));
/**
* The inline editor implementation. It uses an inline editable and a floating toolbar.
* See the {@glink examples/builds/inline-editor demo}.
*
* In order to create a inline editor instance, use the static
* {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`} method.
*/ var $85903122cb082902$export$daaca9c1047b1596 = class extends $85903122cb082902$var$InlineEditorBase {
    /**
	* @inheritDoc
	*/ static get editorName() {
        return "InlineEditor";
    }
    /**
	* @inheritDoc
	*/ ui;
    constructor(sourceElementOrDataOrConfig, config = {}){
        const { sourceElementOrData: sourceElementOrData, editorConfig: editorConfig } = (0, $7ca4ca5784e50ca9$export$4bbd8134967c9cee)(sourceElementOrDataOrConfig, config);
        super(editorConfig);
        (0, $7ca4ca5784e50ca9$export$30c905284d284ef1)(sourceElementOrData, this.config);
        const editableElement = this.config.get("roots").main.element;
        if ($85903122cb082902$var$isElement$1(editableElement)) {
            this.sourceElement = editableElement;
            (0, $7ca4ca5784e50ca9$export$a7d1ef409587e25)(this, editableElement);
        }
        this.config.define("menuBar.isVisible", false);
        this.model.document.createRoot(this.config.get("roots").main.modelElement);
        (0, $7ca4ca5784e50ca9$export$58a114a982b34496)(this);
        const shouldToolbarGroupWhenFull = !this.config.get("toolbar.shouldNotGroupWhenFull");
        const menuBarConfig = this.config.get("menuBar");
        const view = new $85903122cb082902$export$4a295ed835f032a(this.locale, this.editing.view, editableElement, {
            shouldToolbarGroupWhenFull: shouldToolbarGroupWhenFull,
            useMenuBar: menuBarConfig.isVisible,
            label: this.config.get("roots").main.label
        });
        this.ui = new $85903122cb082902$export$336d1adb11b44fcb(this, view);
        (0, $7ca4ca5784e50ca9$export$49c9860462f722d8)(this);
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* Updates the original editor element with the data if the
	* {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
	* configuration option is set to `true`.
	*/ async destroy() {
        const data = this.getData();
        this.ui.destroy();
        await super.destroy();
        if (this.sourceElement) this.updateSourceElement(data);
    }
    static async create(sourceElementOrDataOrConfig, config = {}) {
        const editor = new this(sourceElementOrDataOrConfig, config);
        await editor.initPlugins();
        (0, $7ca4ca5784e50ca9$export$d1de9dbb66389037)(editor);
        await editor.ui.init();
        await editor.data.init(editor.config.get("roots").main.initialData);
        editor.fire("ready");
        return editor;
    }
};
function $85903122cb082902$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-multi-root/multirooteditorui
*/ /**
* The multi-root editor UI class.
*/ var $9b20cb33ca5e2ee8$export$8474ad0cf78a0f6d = class extends (0, $29fd27cb9bdab9d2$export$19609b17c3b0114) {
    /**
	* The main (top–most) view of the editor UI.
	*/ view;
    /**
	* The editable element that was focused the last time when any of the editables had focus.
	*/ _lastFocusedEditableElement;
    /**
	* Creates an instance of the multi-root editor UI class.
	*
	* @param editor The editor instance.
	* @param view The view of the UI.
	*/ constructor(editor, view){
        super(editor);
        this.view = view;
        this._lastFocusedEditableElement = null;
    }
    /**
	* Initializes the UI.
	*/ init() {
        const view = this.view;
        const editor = this.editor;
        for (const editable of Object.values(this.view.editables))editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(editor, editable.name);
        view.render();
        this.focusTracker.on("change:focusedElement", (evt, name, focusedElement)=>{
            for (const editable of Object.values(this.view.editables))if (focusedElement === editable.element) this._lastFocusedEditableElement = editable.element;
        });
        this.focusTracker.on("change:isFocused", (evt, name, isFocused)=>{
            if (!isFocused) this._lastFocusedEditableElement = null;
        });
        for (const editable of Object.values(this.view.editables))this.addEditable(editable);
        this._initToolbar();
        this.initMenuBar(this.view.menuBarView);
        this.fire("ready");
    }
    /**
	* Adds the editable to the editor UI.
	*
	* After the editable is added to the editor UI it can be considered "active".
	*
	* The editable is attached to the editor editing pipeline, which means that it will be updated as the editor model updates and
	* changing its content will be reflected in the editor model. Keystrokes, focus handling and placeholder are initialized.
	*
	* @param editable The editable instance to add.
	* @param placeholder Placeholder for the editable element. If not set, placeholder value from the
	* {@link module:core/editor/editorconfig~EditorConfig#placeholder editor configuration} will be used (if it was provided).
	*/ addEditable(editable, placeholder) {
        editable.isMainFrameEditingRoot = true;
        const editableElement = editable.element;
        this.editor.editing.view.attachDomRoot(editableElement, editable.name);
        this.setEditableElement(editable.name, editableElement);
        editable.bind("isFocused").to(this.focusTracker, "isFocused", this.focusTracker, "focusedElement", (isFocused, focusedElement)=>{
            if (!isFocused) return false;
            if (focusedElement === editableElement) return true;
            else return this._lastFocusedEditableElement === editableElement;
        });
        this._initPlaceholder(editable, placeholder);
    }
    /**
	* Removes the editable instance from the editor UI.
	*
	* Removed editable can be considered "deactivated".
	*
	* The editable is detached from the editing pipeline, so model changes are no longer reflected in it. All handling added in
	* {@link #addEditable} is removed.
	*
	* @param editable Editable to remove from the editor UI.
	*/ removeEditable(editable) {
        const editingView = this.editor.editing.view;
        if (editingView.getDomRoot(editable.name)) editingView.detachDomRoot(editable.name);
        editable.unbind("isFocused");
        this.removeEditableElement(editable.name);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        for (const editable of Object.values(this.view.editables))this.removeEditable(editable);
        this.view.destroy();
    }
    /**
	* Initializes the editor main toolbar and its panel.
	*/ _initToolbar() {
        const editor = this.editor;
        const view = this.view;
        view.toolbar.fillFromConfig(editor.config.get("toolbar"), this.componentFactory);
        this.addToolbar(view.toolbar);
    }
    /**
	* Enables the placeholder text on a given editable.
	*
	* @param editable Editable on which the placeholder should be set.
	* @param placeholder Placeholder for the editable element. If not set, placeholder value from the
	* {@link module:core/editor/editorconfig~EditorConfig#placeholder editor configuration} will be used (if it was provided).
	*/ _initPlaceholder(editable, placeholder) {
        if (!placeholder) placeholder = this.editor.config.get("roots")[editable.name]?.placeholder;
        const editingView = this.editor.editing.view;
        const editingRoot = editingView.document.getRoot(editable.name);
        if (placeholder) editingRoot.placeholder = placeholder;
        (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
            view: editingView,
            element: editingRoot,
            isDirectHost: editable.isInlineRoot,
            keepOnFocus: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-multi-root/multirooteditoruiview
*/ /**
* The multi-root editor UI view. It is a virtual view providing an inline
* {@link module:editor-multi-root/multirooteditoruiview~MultiRootEditorUIView#editable} and a
* {@link module:editor-multi-root/multirooteditoruiview~MultiRootEditorUIView#toolbar}, but without any
* specific arrangement of the components in the DOM.
*
* See {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`}
* to learn more about this view.
*/ var $9b20cb33ca5e2ee8$export$686889c7ec79c0cf = class extends (0, $29fd27cb9bdab9d2$export$afaa6d8c8ffac07c) {
    /**
	* The main toolbar of the multi-root editor UI.
	*/ toolbar;
    /**
	* Editable elements used by the multi-root editor UI.
	*/ editables;
    editable;
    /**
	* Menu bar view instance.
	*/ menuBarView;
    /**
	* The editing view instance this view is related to.
	*/ _editingView;
    /**
	* Creates an instance of the multi-root editor UI view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param editingView The editing view instance this view is related to.
	* @param editableNames Names for all editable views. For each name, one
	* {@link module:ui/editableui/inline/inlineeditableuiview~InlineEditableUIView `InlineEditableUIView`} instance will be initialized.
	* @param options Configuration options for the view instance.
	* @param options.editableElements The editable elements to be used, assigned to their names. If not specified, they will be
	* automatically created by {@link module:ui/editableui/inline/inlineeditableuiview~InlineEditableUIView `InlineEditableUIView`}
	* instances.
	* @param options.shouldToolbarGroupWhenFull When set to `true` enables automatic items grouping
	* in the main {@link module:editor-multi-root/multirooteditoruiview~MultiRootEditorUIView#toolbar toolbar}.
	* See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
	* @param options.label When set, this value will be used as an accessible `aria-label` of the
	* {@link module:ui/editableui/editableuiview~EditableUIView editable view} elements.
	*/ constructor(locale, editingView, editableNames, options = {}){
        super(locale);
        this._editingView = editingView;
        this.toolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale, {
            shouldGroupWhenFull: options.shouldToolbarGroupWhenFull
        });
        this.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(locale);
        this.editables = {};
        for (const editableName of editableNames){
            const editableElement = options.editableElements?.[editableName];
            let { label: label } = options;
            if (typeof label === "object") label = label[editableName];
            this.createEditable(editableName, editableElement, label);
        }
        this.editable = Object.values(this.editables)[0];
        this.toolbar.extendTemplate({
            attributes: {
                class: [
                    "ck-reset_all",
                    "ck-rounded-corners"
                ],
                dir: locale.uiLanguageDirection
            }
        });
        this.menuBarView.extendTemplate({
            attributes: {
                class: [
                    "ck-reset_all",
                    "ck-rounded-corners"
                ],
                dir: locale.uiLanguageDirection
            }
        });
    }
    /**
	* Creates an editable instance with given name and registers it in the editor UI view.
	*
	* If `editableElement` is provided, the editable instance will be created on top of it. Otherwise, the editor will create a new
	* DOM element and use it instead.
	*
	* @param editableName The name for the editable.
	* @param editableElement DOM element for which the editable should be created.
	* @param label The accessible editable label used by assistive technologies.
	* @returns The created editable instance.
	*/ createEditable(editableName, editableElement, label) {
        const editable = new (0, $29fd27cb9bdab9d2$export$7a9e58c3d1414b)(this.locale, this._editingView, editableElement, {
            label: label
        });
        this.editables[editableName] = editable;
        editable.name = editableName;
        if (this.isRendered) this.registerChild(editable);
        return editable;
    }
    /**
	* Destroys and removes the editable from the editor UI view.
	*
	* @param editableName The name of the editable that should be removed.
	*/ removeEditable(editableName) {
        const editable = this.editables[editableName];
        if (this.isRendered) this.deregisterChild(editable);
        delete this.editables[editableName];
        editable.destroy();
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.registerChild(Object.values(this.editables));
        this.registerChild(this.toolbar);
        this.registerChild(this.menuBarView);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module editor-multi-root/multirooteditor
*/ /**
* The multi-root editor implementation.
*
* The multi-root editor provides multiple inline editable elements and a toolbar. All editable areas are controlled by one editor
* instance, which means that they share common configuration, document ID, or undo stack.
*
* This type of editor is dedicated to integrations which require a customized UI with an open structure, featuring multiple editable areas,
* allowing developers to have a control over the exact location of these editable areas.
*
* In order to create a multi-root editor instance, use the static
* {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`} method.
*
* Note that you will need to attach the editor toolbar to your web page manually, in a desired place, after the editor is initialized.
*/ var $9b20cb33ca5e2ee8$export$89d5be4f0efa0b65 = class extends (0, $7ca4ca5784e50ca9$export$7cda8d932e2f33c0) {
    /**
	* @inheritDoc
	*/ static get editorName() {
        return "MultiRootEditor";
    }
    /**
	* @inheritDoc
	*/ ui;
    /**
	* The elements on which the editor has been initialized.
	*/ sourceElements;
    /**
	* A set of lock IDs for enabling or disabling particular root.
	*/ _readOnlyRootLocks = /* @__PURE__ */ new Map();
    constructor(sourceElementsOrDataOrConfig, config = {}){
        const { sourceElementsOrData: sourceElementsOrData, editorConfig: editorConfig } = (0, $7ca4ca5784e50ca9$export$61c65c2e6b0dda5e)(sourceElementsOrDataOrConfig, config);
        super(editorConfig);
        (0, $7ca4ca5784e50ca9$export$30c905284d284ef1)(sourceElementsOrData, this.config, false);
        $9b20cb33ca5e2ee8$var$normalizeRootsAttributesConfig(this.config);
        $9b20cb33ca5e2ee8$var$normalizeRootEditableOptionsConfig(this.config);
        if (this.config.get("lazyRoots")) /**
		* Using deprecated `config.lazyRoots` configuration option.
		* Use `config.roots.<rootName>.lazyLoad` instead.
		*
		* @error multi-root-editor-root-deprecated-config-lazy-roots
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-root-deprecated-config-lazy-roots", null);
        const rootsConfig = Object.entries(this.config.get("roots"));
        this.sourceElements = {};
        const editableElements = {};
        for (const [rootName, rootConfig] of rootsConfig){
            const editableElement = $9b20cb33ca5e2ee8$var$getRootEditableElement(rootConfig);
            if (!editableElement) continue;
            if ($9b20cb33ca5e2ee8$var$isElement$1(editableElement)) {
                this.sourceElements[rootName] = editableElement;
                (0, $7ca4ca5784e50ca9$export$a7d1ef409587e25)(this, editableElement);
            }
            editableElements[rootName] = editableElement;
        }
        this.editing.view.document.roots.on("add", (evt, viewRoot)=>{
            viewRoot.unbind("isReadOnly");
            viewRoot.bind("isReadOnly").to(this.editing.view.document, "isReadOnly", (isReadOnly)=>{
                return isReadOnly || this._readOnlyRootLocks.has(viewRoot.rootName);
            });
            viewRoot.on("change:isReadOnly", (evt, prop, value)=>{
                const viewRange = this.editing.view.createRangeIn(viewRoot);
                for (const viewItem of viewRange.getItems())if (viewItem.is("editableElement")) {
                    viewItem.unbind("isReadOnly");
                    viewItem.isReadOnly = value;
                }
            });
        });
        for (const [rootName, rootConfig] of rootsConfig){
            const root = this.model.document.createRoot(rootConfig.modelElement, rootName);
            if (rootConfig.lazyLoad) root._isLoaded = false;
        }
        this.registerRootAttribute("$rootEditableOptions");
        (0, $7ca4ca5784e50ca9$export$58a114a982b34496)(this);
        const options = {
            shouldToolbarGroupWhenFull: !this.config.get("toolbar.shouldNotGroupWhenFull"),
            editableElements: editableElements,
            label: $9b20cb33ca5e2ee8$var$extractRootsConfigField(this.config.get("roots"), "label")
        };
        const view = new $9b20cb33ca5e2ee8$export$686889c7ec79c0cf(this.locale, this.editing.view, $9b20cb33ca5e2ee8$var$getNonLazyLoadRootsNames(rootsConfig), options);
        this.ui = new $9b20cb33ca5e2ee8$export$8474ad0cf78a0f6d(this, view);
        this.model.document.on("change:data", ()=>{
            const changedRoots = this.model.document.differ.getChangedRoots();
            for (const changes of changedRoots){
                const root = this.model.document.getRoot(changes.name);
                if (changes.state == "detached") this.fire("detachRoot", root);
            }
            for (const changes of changedRoots){
                const root = this.model.document.getRoot(changes.name);
                if (changes.state == "attached") this.fire("addRoot", root);
            }
        });
        this.listenTo(this.model, "canEditAt", (evt, [selection])=>{
            if (!selection) return;
            let selectionInReadOnlyRoot = false;
            for (const range of selection.getRanges()){
                const root = range.root;
                if (this._readOnlyRootLocks.has(root.rootName)) {
                    selectionInReadOnlyRoot = true;
                    break;
                }
            }
            if (selectionInReadOnlyRoot) {
                evt.return = false;
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.decorate("loadRoot");
        this.on("loadRoot", (evt, [rootName])=>{
            const root = this.model.document.getRoot(rootName);
            if (!root) /**
			* The root to load does not exist.
			*
			* @error multi-root-editor-load-root-no-root
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-load-root-no-root", this, {
                rootName: rootName
            });
            if (root._isLoaded) {
                /**
				* The root to load was already loaded before. The `loadRoot()` call has no effect.
				*
				* @error multi-root-editor-load-root-already-loaded
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("multi-root-editor-load-root-already-loaded");
                evt.stop();
            }
        }, {
            priority: "highest"
        });
        verifyLicenseKey(this);
        function verifyLicenseKey(editor) {
            const licenseKey = editor.config.get("licenseKey");
            const decodedPayload = (0, $c7bc2cb7e2db0227$export$9cbd9a924c44d1b7)(licenseKey);
            if (!decodedPayload) return;
            if ((0, $c7bc2cb7e2db0227$export$817c47d6329f7631)(decodedPayload, "MRE")) {
                editor.enableReadOnlyMode(Symbol("invalidLicense"));
                editor._showLicenseError("featureNotAllowed", "Multi-root editor");
            }
        }
    }
    /**
	* Destroys the editor instance, releasing all resources used by it.
	*
	* Updates the original editor element with the data if the
	* {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
	* configuration option is set to `true`.
	*
	* **Note**: The multi-root editor does not remove the toolbar and editable when destroyed. You can
	* do that yourself in the destruction chain, if you need to:
	*
	* ```ts
	* editor.destroy().then( () => {
	* 	// Remove the toolbar from DOM.
	* 	editor.ui.view.toolbar.element.remove();
	*
	* 	// Remove editable elements from DOM.
	* 	for ( const editable of Object.values( editor.ui.view.editables ) ) {
	* 	    editable.element.remove();
	* 	}
	*
	* 	console.log( 'Editor was destroyed' );
	* } );
	* ```
	*/ async destroy() {
        const shouldUpdateSourceElement = this.config.get("updateSourceElementOnDestroy");
        const data = {};
        for (const rootName of Object.keys(this.sourceElements))data[rootName] = shouldUpdateSourceElement ? this.getData({
            rootName: rootName
        }) : "";
        this.ui.destroy();
        await super.destroy();
        for (const rootName of Object.keys(this.sourceElements))(0, $c7bc2cb7e2db0227$export$38bb620396ade7f9)(this.sourceElements[rootName], data[rootName]);
    }
    addRoot(rootName, options = {}) {
        const initialData = options.initialData || options.data || "";
        const modelAttributes = {
            ...options.modelAttributes || options.attributes
        };
        const modelElement = options.modelElement || options.elementName || "$root";
        if (!this.model.schema.isLimit(modelElement)) /**
		* The model root element must be a {@link module:engine/model/schema~ModelSchemaItemDefinition#isLimit limit element}.
		* The element name specified in
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#addRoot:ROOT_CONFIG `addRoot()`}
		* options must be registered in the schema
		* with `isLimit` set to `true`.
		*
		* @error multi-root-editor-add-root-element-is-not-limit
		* @param rootName The name of the root that uses a non-limit element.
		* @param elementName The name of the model element used for the root.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-add-root-element-is-not-limit", this, {
            rootName: rootName,
            elementName: modelElement
        });
        if ($9b20cb33ca5e2ee8$var$isElement$1(options.element)) /**
		* Passing an existing DOM element as the `element` option of
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#addRoot:ROOT_CONFIG `addRoot()`}
		* is not supported and will be ignored. The
		* `addRoot()` method only registers the model root; the DOM editable is created later by
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#createEditable `createEditable()`}.
		*
		* Pass a tag name string (e.g. `'h1'`) or a
		* {@link module:engine/view/elementdefinition~ViewElementDefinition view element definition}
		* instead, or omit the option to create a default `<div>`.
		*
		* @error multi-root-editor-add-root-element-option-ignored
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("multi-root-editor-add-root-element-option-ignored");
        $9b20cb33ca5e2ee8$var$setRootEditableOptions(modelAttributes, options);
        if (options.description != null && !("$description" in modelAttributes)) modelAttributes.$description = options.description;
        if (options.title != null && !("$title" in modelAttributes)) modelAttributes.$title = options.title;
        const _addRoot = (writer)=>{
            const root = writer.addRoot(rootName, modelElement);
            if (initialData) writer.insert(this.data.parse(initialData, root), root, 0);
            for (const key of Object.keys(modelAttributes)){
                this.registerRootAttribute(key);
                writer.setAttribute(key, modelAttributes[key], root);
            }
        };
        if (options.isUndoable) this.model.change(_addRoot);
        else this.model.enqueueChange({
            isUndoable: false
        }, _addRoot);
    }
    /**
	* Detaches a root from the editor.
	*
	* ```ts
	* editor.detachRoot( 'myRoot' );
	* ```
	*
	* A detached root is not entirely removed from the editor model, however it can be considered removed.
	*
	* After a root is detached all its children are removed, all markers inside it are removed, and whenever something is inserted to it,
	* it is automatically removed as well. Finally, a detached root is not returned by
	* {@link module:engine/model/document~ModelDocument#getRootNames} by default.
	*
	* It is possible to re-add a previously detached root calling {@link #addRoot}.
	*
	* Whenever a root is detached, the editor instance will fire {@link #event:detachRoot `detachRoot` event}. The event is also
	* called when the root is detached indirectly, e.g. by the undo feature or on a remote client during real-time collaboration.
	*
	* Note, that this method only detached a root in the editor model. It **does not** destroy the DOM editable element linked with
	* the root and it **does not** remove the DOM element from the DOM structure of your application.
	*
	* To properly remove a DOM editable element after a root was detached, listen to {@link #event:detachRoot `detachRoot` event}
	* and call {@link #detachEditable}. Then, remove the DOM element from your application.
	*
	* ```ts
	* editor.on( 'detachRoot', ( evt, root ) => {
	* 	const editableElement = editor.detachEditable( root );
	*
	* 	// You may want to do an additional DOM clean-up here.
	*
	* 	editableElement.remove();
	* } );
	*
	* // ...
	*
	* editor.detachRoot( 'myRoot' ); // Will detach the root, and remove the DOM editable element.
	* ```
	*
	* By setting `isUndoable` flag to `true`, you can allow for re-adding the root using the undo feature.
	*
	* Additionally, you can group detaching multiple roots in one undo step. This can be useful if the roots are combined into one,
	* bigger UI element, and you want them all to be re-added together.
	*
	* ```ts
	* editor.model.change( () => {
	* 	editor.detachRoot( 'left-row-3', true );
	* 	editor.detachRoot( 'center-row-3', true );
	* 	editor.detachRoot( 'right-row-3', true );
	* } );
	* ```
	*
	* @param rootName Name of the root to detach.
	* @param isUndoable Whether detaching the root can be undone (using the undo feature) or not.
	*/ detachRoot(rootName, isUndoable = false) {
        if (isUndoable) this.model.change((writer)=>writer.detachRoot(rootName));
        else this.model.enqueueChange({
            isUndoable: false
        }, (writer)=>writer.detachRoot(rootName));
    }
    createEditable(root, optionsOrPlaceholder, label) {
        let placeholder;
        let element;
        if (!optionsOrPlaceholder || typeof optionsOrPlaceholder === "string") placeholder = optionsOrPlaceholder;
        else {
            placeholder = optionsOrPlaceholder?.placeholder;
            label = optionsOrPlaceholder?.label;
            element = optionsOrPlaceholder?.element;
        }
        const rootEditableConfig = root.getAttribute("$rootEditableOptions") || {};
        const editableElement = (0, $7ca4ca5784e50ca9$export$f646a7cd436ca16e)(element || rootEditableConfig.element);
        const editable = this.ui.view.createEditable(root.rootName, editableElement, label || rootEditableConfig.label);
        editable.isInlineRoot = !(0, $7ca4ca5784e50ca9$export$d4e62b677f4a6c36)(this, root.rootName);
        this.ui.addEditable(editable, placeholder || rootEditableConfig.placeholder);
        this.editing.view.forceRender();
        return editable.element;
    }
    /**
	* Detaches the DOM editable element that was attached to the given root.
	*
	* @param root Root for which the editable element should be detached.
	* @returns The DOM element that was detached. You may want to remove it from your application DOM structure.
	*/ detachEditable(root) {
        const rootName = root.rootName;
        const editable = this.ui.view.editables[rootName];
        this.ui.removeEditable(editable);
        this.ui.view.removeEditable(rootName);
        return editable.element;
    }
    /**
	* Loads a root that has previously been declared in
	* {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots.<rootName>.lazyLoad`} configuration option.
	*
	* **Important! Lazy roots loading is an experimental feature, and may become deprecated. Be advised of the following
	* known limitations:**
	*
	* * **Real-time collaboration integrations that use
	* [uploaded editor bundles](https://ckeditor.com/docs/cs/latest/guides/collaboration/editor-bundle.html) are not supported. Using
	* lazy roots will lead to unexpected behavior and data loss.**
	* * **Revision history feature will read and process the whole document on editor initialization, possibly defeating the purpose
	* of using the lazy roots loading. Additionally, when the document is loaded for the first time, all roots need to be loaded,
	* to make sure that the initial revision data includes all roots. Otherwise, you may experience data loss.**
	* * **Multiple features, that require full document data to be loaded, will produce incorrect or confusing results if not all
	* roots are loaded. These include: bookmarks, find and replace, word count, pagination, document exports, document outline,
	* and table of contents.**
	*
	* Only roots specified in the editor config can be loaded. A root cannot be loaded multiple times. A root cannot be unloaded and
	* loading a root cannot be reverted using the undo feature.
	*
	* When a root becomes loaded, it will be treated by the editor as though it was just added. This, among others, means that all
	* related events and mechanisms will be fired, including {@link ~MultiRootEditor#event:addRoot `addRoot` event},
	* {@link module:engine/model/document~ModelDocument#event:change `model.Document` `change` event}, model post-fixers and conversion.
	*
	* Until the root becomes loaded, all above mechanisms are suppressed.
	*
	* This method is {@link module:utils/observablemixin~Observable#decorate decorated}.
	*
	* Note that attributes loaded together with a root are automatically registered.
	*
	* See also {@link ~MultiRootEditor#registerRootAttribute `MultiRootEditor#registerRootAttribute()`} and
	* {@link module:core/editor/editorconfig~EditorConfig#roots `config.roots.<rootName>.modelAttributes` configuration option}.
	*
	* When this method is used in real-time collaboration environment, its effects become asynchronous as the editor will first synchronize
	* with the remote editing session, before the root is added to the editor.
	*
	* If the root has been already loaded by any other client, the additional data passed in `loadRoot()` parameters will be ignored.
	*
	* @param rootName Name of the root to load.
	* @param options Additional options for the loaded root.
	* @fires loadRoot
	*/ loadRoot(rootName, { data: data = "", attributes: attributes = {} } = {}) {
        const root = this.model.document.getRoot(rootName);
        this.model.enqueueChange({
            isUndoable: false
        }, (writer)=>{
            if (data) writer.insert(this.data.parse(data, root), root, 0);
            for (const key of Object.keys(attributes)){
                this.registerRootAttribute(key);
                writer.setAttribute(key, attributes[key], root);
            }
            root._isLoaded = true;
            this.model.document.differ._bufferRootLoad(root);
        });
    }
    /**
	* Returns the document data for all attached roots.
	*
	* @param options Additional configuration for the retrieved data.
	* Editor features may introduce more configuration options that can be set through this parameter.
	* @param options.trim Whether returned data should be trimmed. This option is set to `'empty'` by default,
	* which means that whenever editor content is considered empty, an empty string is returned. To turn off trimming
	* use `'none'`. In such cases exact content will be returned (for example `'<p>&nbsp;</p>'` for an empty editor).
	* @returns The full document data.
	*/ getFullData(options) {
        const data = {};
        for (const rootName of this.model.document.getRootNames())data[rootName] = this.data.get({
            ...options,
            rootName: rootName
        });
        return data;
    }
    /**
	* Returns attributes for all attached roots.
	*
	* Note: all and only {@link ~MultiRootEditor#registerRootAttribute registered} roots attributes will be returned.
	* If a registered root attribute is not set for a given root, `null` will be returned.
	*
	* @returns Object with roots attributes. Keys are roots names, while values are attributes set on given root.
	*/ getRootsAttributes() {
        const rootsAttributes = {};
        for (const rootName of this.model.document.getRootNames())rootsAttributes[rootName] = this.getRootAttributes(rootName);
        return rootsAttributes;
    }
    /**
	* Switches given editor root to the read-only mode.
	*
	* In contrary to {@link module:core/editor/editor~Editor#enableReadOnlyMode `enableReadOnlyMode()`}, which switches the whole editor
	* to the read-only mode, this method turns only a particular root to the read-only mode. This can be useful when you want to prevent
	* editing only a part of the editor content.
	*
	* When you switch a root to the read-only mode, you need provide a unique identifier (`lockId`) that will identify this request. You
	* will need to provide the same `lockId` when you will want to
	* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#enableRoot re-enable} the root.
	*
	* ```ts
	* const model = editor.model;
	* const myRoot = model.document.getRoot( 'myRoot' );
	*
	* editor.disableRoot( 'myRoot', 'my-lock' );
	* model.canEditAt( myRoot ); // `false`
	*
	* editor.disableRoot( 'myRoot', 'other-lock' );
	* editor.disableRoot( 'myRoot', 'other-lock' ); // Multiple locks with the same ID have no effect.
	* model.canEditAt( myRoot ); // `false`
	*
	* editor.enableRoot( 'myRoot', 'my-lock' );
	* model.canEditAt( myRoot ); // `false`
	*
	* editor.enableRoot( 'myRoot', 'other-lock' );
	* model.canEditAt( myRoot ); // `true`
	* ```
	*
	* See also {@link module:core/editor/editor~Editor#enableReadOnlyMode `Editor#enableReadOnlyMode()`} and
	* {@link module:editor-multi-root/multirooteditor~MultiRootEditor#enableRoot `MultiRootEditor#enableRoot()`}.
	*
	* @param rootName Name of the root to switch to read-only mode.
	* @param lockId A unique ID for setting the editor to the read-only state.
	*/ disableRoot(rootName, lockId) {
        if (rootName == "$graveyard") /**
		* You cannot disable the `$graveyard` root.
		*
		* @error multi-root-editor-cannot-disable-graveyard-root
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-cannot-disable-graveyard-root", this);
        const locksForGivenRoot = this._readOnlyRootLocks.get(rootName);
        if (locksForGivenRoot) locksForGivenRoot.add(lockId);
        else {
            this._readOnlyRootLocks.set(rootName, /* @__PURE__ */ new Set([
                lockId
            ]));
            const editableRootElement = this.editing.view.document.getRoot(rootName);
            editableRootElement.isReadOnly = true;
            Array.from(this.commands.commands()).forEach((command)=>command.affectsData && command.refresh());
        }
    }
    /**
	* Removes given read-only lock from the given root.
	*
	* See {@link module:editor-multi-root/multirooteditor~MultiRootEditor#disableRoot `disableRoot()`}.
	*
	* @param rootName Name of the root to switch back from the read-only mode.
	* @param lockId A unique ID for setting the editor to the read-only state.
	*/ enableRoot(rootName, lockId) {
        const locksForGivenRoot = this._readOnlyRootLocks.get(rootName);
        if (!locksForGivenRoot || !locksForGivenRoot.has(lockId)) return;
        if (locksForGivenRoot.size === 1) {
            this._readOnlyRootLocks.delete(rootName);
            const editableRootElement = this.editing.view.document.getRoot(rootName);
            editableRootElement.isReadOnly = this.isReadOnly;
            Array.from(this.commands.commands()).forEach((command)=>command.affectsData && command.refresh());
        } else locksForGivenRoot.delete(lockId);
    }
    static async create(sourceElementsOrDataOrConfig, config = {}) {
        const editor = new this(sourceElementsOrDataOrConfig, config);
        await editor.initPlugins();
        (0, $7ca4ca5784e50ca9$export$d1de9dbb66389037)(editor);
        await editor.ui.init();
        const initialData = $9b20cb33ca5e2ee8$var$extractRootsConfigField(editor.config.get("roots"), "initialData");
        editor._verifyRootsWithInitialData(initialData);
        await editor.data.init(initialData);
        editor.fire("ready");
        return editor;
    }
    /**
	* @internal
	*/ _verifyRootsWithInitialData(initialData) {
        for (const rootName of this.model.document.getRootNames())if (!(rootName in initialData)) /**
		* Editor roots do not match the
		* {@link module:core/editor/editorconfig~EditorConfig#initialData `initialData` configuration}.
		*
		* This may happen for one of the two reasons:
		*
		* * Configuration error. The `sourceElementsOrData` parameter in
		* {@link module:editor-multi-root/multirooteditor~MultiRootEditor.create `MultiRootEditor.create()`} contains different
		* roots than {@link module:core/editor/editorconfig~EditorConfig#initialData `initialData` configuration}.
		* * As the editor was initialized, the {@link module:core/editor/editorconfig~EditorConfig#initialData `initialData`}
		* configuration value or the state of the editor roots has been changed.
		*
		* @error multi-root-editor-root-initial-data-mismatch
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-root-initial-data-mismatch", null);
        for (const rootName of Object.keys(initialData)){
            const root = this.model.document.getRoot(rootName);
            if (!root || !root.isAttached()) throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-root-initial-data-mismatch", null);
        }
    }
};
/**
* Returns names of roots that are not lazy-loaded.
*/ function $9b20cb33ca5e2ee8$var$getNonLazyLoadRootsNames(rootsConfig) {
    return rootsConfig.filter(([, { lazyLoad: lazyLoad }])=>!lazyLoad).map(([rootName])=>rootName);
}
/**
* Collects a specific field from the editor configuration for all roots.
* Returns a simple map of root names and values of the specified field.
* If a root does not have the specified field defined, it is not included in the returned object.
*/ function $9b20cb33ca5e2ee8$var$extractRootsConfigField(rootsConfig, key) {
    return Object.fromEntries(Object.entries(rootsConfig).filter(([, config])=>!config.lazyLoad).map(([rootName, config])=>[
            rootName,
            config[key]
        ]).filter(([, value])=>value !== void 0));
}
/**
* Normalize legacy `config.rootsAttributes` config option to `config.roots.<rootName>.modelAttributes`.
*/ function $9b20cb33ca5e2ee8$var$normalizeRootsAttributesConfig(config) {
    if (config.get("rootsAttributes")) {
        const rootsAttributes = config.get("rootsAttributes");
        const rootsConfig = config.get("roots");
        for (const [rootName, attributes] of Object.entries(rootsAttributes)){
            const rootConfig = rootsConfig[rootName];
            if (!rootConfig) /**
			* Trying to set attributes on a non-existing root.
			*
			* Roots specified in `config.rootsAttributes` do not match initial editor roots.
			*
			* @error multi-root-editor-root-attributes-no-root
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-root-attributes-no-root", null);
            if (Object.keys(rootConfig.modelAttributes || {}).length) /**
			* Trying to set attributes using deprecated `config.rootsAttributes` on a root that has already
			* defined attributes using `config.roots.<rootName>.modelAttributes`.
			*
			* @error multi-root-editor-root-attributes-conflict
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("multi-root-editor-root-attributes-conflict", null);
            config.set(`roots.${rootName}.modelAttributes`, attributes);
        }
    }
}
/**
* Normalize `placeholder` and `label` from `config.roots.<rootName>` into the `$rootEditableOptions` root model attribute,
* stored under `config.roots.<rootName>.modelAttributes`. This way the attribute is registered, set on initial data load
* and shipped through RTC initial-data path together with the rest of `modelAttributes`.
*
* This is also required by the revision history feature: on editor load, RH compares the latest revision data against
* `initialData` and `modelAttributes` passed to the editor and logs a warning if they do not match. Because `$rootEditableOptions`
* ends up in the revision data, it must also be present in `modelAttributes` (even as an empty object when no options
* are configured), otherwise the comparison reports a spurious mismatch.
*/ function $9b20cb33ca5e2ee8$var$normalizeRootEditableOptionsConfig(config) {
    const rootsConfig = config.get("roots");
    for (const [rootName, rootConfig] of Object.entries(rootsConfig)){
        if (rootConfig.modelAttributes?.$rootEditableOptions) continue;
        const modelAttributes = {
            ...rootConfig.modelAttributes
        };
        $9b20cb33ca5e2ee8$var$setRootEditableOptions(modelAttributes, rootConfig);
        config.set(`roots.${rootName}.modelAttributes`, modelAttributes);
    }
}
/**
* Mutates the given `modelAttributes` map by adding the `$rootEditableOptions` entry derived from `placeholder`, `label`
* and `element`. If `$rootEditableOptions` is already present, the map is left untouched.
*
* The `element` is normalized into canonical form ({@link module:core/editor/editorconfig~ViewRootElementDefinition})
* before being persisted. A raw DOM element is local to this editor instance - it cannot be replicated through
* RTC, so it is silently dropped here. Callers that want to surface a warning (e.g. `addRoot()`) should do so before
* invoking this function.
*/ function $9b20cb33ca5e2ee8$var$setRootEditableOptions(modelAttributes, { placeholder: placeholder, label: label, element: element }) {
    if ("$rootEditableOptions" in modelAttributes) return;
    const storageElement = $9b20cb33ca5e2ee8$var$isElement$1(element) ? void 0 : (0, $7ca4ca5784e50ca9$export$f646a7cd436ca16e)(element);
    modelAttributes.$rootEditableOptions = {
        ...placeholder && {
            placeholder: placeholder
        },
        ...label && {
            label: label
        },
        ...storageElement && {
            element: storageElement
        }
    };
}
function $9b20cb33ca5e2ee8$var$isElement$1(value) {
    return (0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(value);
}
/**
* Returns the canonical editable element descriptor for the given root config.
*
* Falls back to `$rootEditableOptions.element` so remote RTC clients - which do not see the originator's
* `config.roots.<name>.element` - can recreate the configured editable shape from the model attributes
* they receive. The result is normalized here in case the attribute was pre-supplied without going
* through `setRootEditableOptions()` (e.g. a caller writing `modelAttributes.$rootEditableOptions` directly).
*/ function $9b20cb33ca5e2ee8$var$getRootEditableElement(rootConfig) {
    const rootEditableOptions = rootConfig.modelAttributes?.$rootEditableOptions;
    return (0, $7ca4ca5784e50ca9$export$f646a7cd436ca16e)(rootConfig.element || rootEditableOptions?.element);
}





/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module select-all/selectallcommand
*/ /**
* The select all command.
*
* It is used by the {@link module:select-all/selectallediting~SelectAllEditing select all editing feature} to handle
* the <kbd>Ctrl/⌘</kbd>+<kbd>A</kbd> keystroke.
*
* Executing this command changes the {@glink framework/architecture/editing-engine#model model}
* selection so it contains the entire content of the editable root of the editor the selection is
* {@link module:engine/model/selection~ModelSelection#anchor anchored} in.
*
* If the selection was anchored in a {@glink framework/tutorials/widgets/implementing-a-block-widget nested editable}
* (e.g. a caption of an image), the new selection will contain its entire content. Successive executions of this command
* will expand the selection to encompass more and more content up to the entire editable root of the editor.
*/ var $31d505632cc2d57a$export$aba6776b85b6b5f9 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        const selection = model.document.selection;
        let scopeElement = model.schema.getLimitElement(selection);
        if (selection.containsEntireContent(scopeElement) || !$31d505632cc2d57a$var$isSelectAllScope(model.schema, scopeElement)) do {
            scopeElement = scopeElement.parent;
            if (!scopeElement) return;
        }while (!$31d505632cc2d57a$var$isSelectAllScope(model.schema, scopeElement));
        model.change((writer)=>{
            writer.setSelection(scopeElement, "in");
        });
    }
};
/**
* Checks whether the element is a valid select-all scope. Returns true, if the element is a
* {@link module:engine/model/schema~ModelSchema#isLimit limit}, and can contain any text or paragraph.
*
* @param schema Schema to check against.
* @param element Model element.
*/ function $31d505632cc2d57a$var$isSelectAllScope(schema, element) {
    return schema.isLimit(element) && (schema.checkChild(element, "$text") || schema.checkChild(element, "paragraph"));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module select-all/selectallediting
*/ const $31d505632cc2d57a$var$SELECT_ALL_KEYSTROKE = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$970afd9da919f686)("Ctrl+A");
/**
* The select all editing feature.
*
* It registers the `'selectAll'` {@link module:select-all/selectallcommand~SelectAllCommand command}
* and the <kbd>Ctrl/⌘</kbd>+<kbd>A</kbd> keystroke listener which executes it.
*/ var $31d505632cc2d57a$export$cee31d8f97e4e868 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SelectAllEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const viewDocument = editor.editing.view.document;
        editor.commands.add("selectAll", new $31d505632cc2d57a$export$aba6776b85b6b5f9(editor));
        this.listenTo(viewDocument, "keydown", (eventInfo, domEventData)=>{
            if ((0, $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb)(domEventData) === $31d505632cc2d57a$var$SELECT_ALL_KEYSTROKE) {
                editor.execute("selectAll");
                domEventData.preventDefault();
            }
        });
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Select all"),
                    keystroke: "CTRL+A"
                }
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module select-all/selectallui
*/ /**
* The select all UI feature.
*
* It registers the `'selectAll'` UI button in the editor's
* {@link module:ui/componentfactory~ComponentFactory component factory}. When clicked, the button
* executes the {@link module:select-all/selectallcommand~SelectAllCommand select all command}.
*/ var $31d505632cc2d57a$export$bed8b06f4372755d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SelectAllUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("selectAll", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:selectAll", ()=>{
            return this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
    }
    /**
	* Creates a button for select all command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("selectAll");
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Select all"),
            icon: (0, $e8dc502aba5ac3f5$export$5be171d1c905ebb6),
            keystroke: "Ctrl+A"
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute("selectAll");
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module select-all/selectall
*/ /**
* The select all feature.
*
* This is a "glue" plugin which loads the {@link module:select-all/selectallediting~SelectAllEditing select all editing feature}
* and the {@link module:select-all/selectallui~SelectAllUI select all UI feature}.
*
* Please refer to the documentation of individual features to learn more.
*/ var $31d505632cc2d57a$export$c64c854179faeaa8 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $31d505632cc2d57a$export$cee31d8f97e4e868,
            $31d505632cc2d57a$export$bed8b06f4372755d
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SelectAll";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};





/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module essentials/essentials
*/ /**
* A plugin including all essential editing features. It represents a set of features that enables similar functionalities
* to a `<textarea>` element.
*
* It includes:
*
* * {@link module:ui/editorui/accessibilityhelp/accessibilityhelp~AccessibilityHelp},
* * {@link module:clipboard/clipboard~Clipboard},
* * {@link module:enter/enter~Enter},
* * {@link module:select-all/selectall~SelectAll},
* * {@link module:enter/shiftenter~ShiftEnter},
* * {@link module:typing/typing~Typing},
* * {@link module:undo/undo~Undo}.
*
* This plugin set does not define any block-level containers (such as {@link module:paragraph/paragraph~Paragraph}).
* If your editor is supposed to handle block content, make sure to include it.
*/ var $de969e057c99c515$export$9232476bfd6c1299 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$a96e32aec1700e7e),
            (0, $4fa913ac1af6a08c$export$8b44c43c7d8f0830),
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a),
            (0, $31d505632cc2d57a$export$c64c854179faeaa8),
            (0, $c871651c8276dc61$export$f74dddee9c33418e),
            (0, $f1defb5a0a139b4c$export$3997e86453ee41f3),
            (0, $d1f24276bd81b655$export$897c9ed706d8ea48)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Essentials";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/ui/findandreplaceformview
*/ /**
* The find and replace form view class.
*
* See {@link module:find-and-replace/ui/findandreplaceformview~FindAndReplaceFormView}.
*/ var $a1bbd39e96f49b7d$export$3f1c355b2c7e2a3e = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A collection of child views.
	*/ children;
    /**
	* The find in text input view that stores the searched string.
	*
	* @internal
	*/ _findInputView;
    /**
	* The replace input view.
	*/ _replaceInputView;
    /**
	* The find button view that initializes the search process.
	*/ _findButtonView;
    /**
	* The find previous button view.
	*/ _findPrevButtonView;
    /**
	* The find next button view.
	*/ _findNextButtonView;
    /**
	* A collapsible view aggregating the advanced search options.
	*/ _advancedOptionsCollapsibleView;
    /**
	* A switch button view controlling the "Match case" option.
	*/ _matchCaseSwitchView;
    /**
	* A switch button view controlling the "Whole words only" option.
	*/ _wholeWordsOnlySwitchView;
    /**
	* The replace button view.
	*/ _replaceButtonView;
    /**
	* The replace all button view.
	*/ _replaceAllButtonView;
    /**
	* The `div` aggregating the inputs.
	*/ _inputsDivView;
    /**
	* The `div` aggregating the action buttons.
	*/ _actionButtonsDivView;
    /**
	* Tracks information about the DOM focus in the form.
	*/ _focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ _keystrokes;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ focusCycler;
    /**
	* Creates a view of find and replace form.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        const t = locale.t;
        this.children = this.createCollection();
        this.set("matchCount", 0);
        this.set("highlightOffset", 0);
        this.set("isDirty", false);
        this.set("_areCommandsEnabled", {});
        this.set("_resultsCounterText", "");
        this.set("_matchCase", false);
        this.set("_wholeWordsOnly", false);
        this.bind("_searchResultsFound").to(this, "matchCount", this, "isDirty", (matchCount, isDirty)=>{
            return matchCount > 0 && !isDirty;
        });
        this._findInputView = this._createInputField(t("Find in text\u2026"));
        this._findPrevButtonView = this._createButton({
            label: t("Previous result"),
            class: "ck-button-prev",
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            keystroke: "Shift+F3",
            tooltip: true
        });
        this._findNextButtonView = this._createButton({
            label: t("Next result"),
            class: "ck-button-next",
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            keystroke: "F3",
            tooltip: true
        });
        this._replaceInputView = this._createInputField(t("Replace with\u2026"), "ck-labeled-field-replace");
        this._inputsDivView = this._createInputsDiv();
        this._matchCaseSwitchView = this._createMatchCaseSwitch();
        this._wholeWordsOnlySwitchView = this._createWholeWordsOnlySwitch();
        this._advancedOptionsCollapsibleView = this._createAdvancedOptionsCollapsible();
        this._replaceAllButtonView = this._createButton({
            label: t("Replace all"),
            class: "ck-button-replaceall ck-button_standard",
            withText: true
        });
        this._replaceButtonView = this._createButton({
            label: t("Replace"),
            class: "ck-button-replace ck-button_standard",
            withText: true
        });
        this._findButtonView = this._createButton({
            label: t("Find"),
            class: "ck-button-find ck-button-action ck-button_standard",
            withText: true
        });
        this._actionButtonsDivView = this._createActionButtonsDiv();
        this._focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this._keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this.focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this._focusTracker,
            keystrokeHandler: this._keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.children.addMany([
            this._inputsDivView,
            this._advancedOptionsCollapsibleView,
            this._actionButtonsDivView
        ]);
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-find-and-replace-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        this._initFocusCycling();
        this._initKeystrokeHandling();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._focusTracker.destroy();
        this._keystrokes.destroy();
    }
    /**
	* @inheritDoc
	*/ focus(direction) {
        if (direction === -1) this.focusCycler.focusLast();
        else this.focusCycler.focusFirst();
    }
    /**
	* Resets the form before re-appearing.
	*
	* It clears error messages, hides the match counter and disables the replace feature
	* until the next hit of the "Find" button.
	*
	* **Note**: It does not reset inputs and options, though. This way the form works better in editors with
	* disappearing toolbar (e.g. BalloonEditor): hiding the toolbar by accident (together with the find and replace UI)
	* does not require filling the entire form again.
	*/ reset() {
        this._findInputView.errorText = null;
        this.isDirty = true;
    }
    /**
	* Returns the value of the find input.
	*/ get _textToFind() {
        return this._findInputView.fieldView.element.value;
    }
    /**
	* Returns the value of the replace input.
	*/ get _textToReplace() {
        return this._replaceInputView.fieldView.element.value;
    }
    /**
	* Configures and returns the `<div>` aggregating all form inputs.
	*/ _createInputsDiv() {
        const locale = this.locale;
        const t = locale.t;
        const inputsDivView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(locale);
        this._findInputView.fieldView.on("input", ()=>{
            this.isDirty = true;
        });
        this._findPrevButtonView.delegate("execute").to(this, "findPrevious");
        this._findNextButtonView.delegate("execute").to(this, "findNext");
        this._findPrevButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", ({ findPrevious: findPrevious })=>findPrevious);
        this._findNextButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", ({ findNext: findNext })=>findNext);
        this._injectFindResultsCounter();
        this._replaceInputView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", ({ replace: replace }, resultsFound)=>replace && resultsFound);
        this._replaceInputView.bind("infoText").to(this._replaceInputView, "isEnabled", this._replaceInputView, "isFocused", (isEnabled, isFocused)=>{
            if (isEnabled || !isFocused) return "";
            return t("Tip: Find some text first in order to replace it.");
        });
        inputsDivView.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-find-and-replace-form__inputs"
                ]
            },
            children: [
                this._findInputView,
                this._findPrevButtonView,
                this._findNextButtonView,
                this._replaceInputView
            ]
        });
        return inputsDivView;
    }
    /**
	* The action performed when the {@link #_findButtonView} is pressed.
	*/ _onFindButtonExecute() {
        if (!this._textToFind) {
            const t = this.t;
            this._findInputView.errorText = t("Text to find must not be empty.");
            return;
        }
        this.isDirty = false;
        this.fire("findNext", {
            searchText: this._textToFind,
            matchCase: this._matchCase,
            wholeWords: this._wholeWordsOnly
        });
    }
    /**
	* Configures an injects the find results counter displaying a "N of M" label of the {@link #_findInputView}.
	*/ _injectFindResultsCounter() {
        const locale = this.locale;
        const t = locale.t;
        const bind = this.bindTemplate;
        const resultsCounterView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(this.locale);
        this.bind("_resultsCounterText").to(this, "highlightOffset", this, "matchCount", (highlightOffset, matchCount)=>t("%0 of %1", [
                highlightOffset,
                matchCount
            ]));
        resultsCounterView.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-results-counter",
                    bind.if("isDirty", "ck-hidden")
                ]
            },
            children: [
                {
                    text: bind.to("_resultsCounterText")
                }
            ]
        });
        const updateFindInputPadding = ()=>{
            const inputElement = this._findInputView.fieldView.element;
            if (!inputElement || !(0, $c7bc2cb7e2db0227$export$795910f5f15a9633)(inputElement)) return;
            const counterWidth = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(resultsCounterView.element).width;
            const paddingPropertyName = locale.uiLanguageDirection === "ltr" ? "paddingRight" : "paddingLeft";
            if (!counterWidth) inputElement.style[paddingPropertyName] = "";
            else inputElement.style[paddingPropertyName] = `calc( 2 * var(--ck-spacing-standard) + ${counterWidth}px )`;
        };
        this.on("change:_resultsCounterText", updateFindInputPadding, {
            priority: "low"
        });
        this.on("change:isDirty", updateFindInputPadding, {
            priority: "low"
        });
        this._findInputView.template.children[0].children.push(resultsCounterView);
    }
    /**
	* Creates the collapsible view aggregating the advanced search options.
	*/ _createAdvancedOptionsCollapsible() {
        const t = this.locale.t;
        const collapsible = new (0, $29fd27cb9bdab9d2$export$8a82f5df0c7d8945)(this.locale, [
            this._matchCaseSwitchView,
            this._wholeWordsOnlySwitchView
        ]);
        collapsible.set({
            label: t("Advanced options"),
            isCollapsed: true
        });
        return collapsible;
    }
    /**
	* Configures and returns the `<div>` element aggregating all form action buttons.
	*/ _createActionButtonsDiv() {
        const actionsDivView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(this.locale);
        this._replaceButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", ({ replace: replace }, resultsFound)=>replace && resultsFound);
        this._replaceAllButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", ({ replaceAll: replaceAll }, resultsFound)=>replaceAll && resultsFound);
        this._replaceButtonView.on("execute", ()=>{
            this.fire("replace", {
                searchText: this._textToFind,
                replaceText: this._textToReplace
            });
        });
        this._replaceAllButtonView.on("execute", ()=>{
            this.fire("replaceAll", {
                searchText: this._textToFind,
                replaceText: this._textToReplace
            });
            this.focus();
        });
        this._findButtonView.on("execute", this._onFindButtonExecute.bind(this));
        actionsDivView.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-find-and-replace-form__actions"
                ]
            },
            children: [
                this._replaceAllButtonView,
                this._replaceButtonView,
                this._findButtonView
            ]
        });
        return actionsDivView;
    }
    /**
	* Creates, configures and returns and instance of a dropdown allowing users to narrow
	* the search criteria down. The dropdown has a list with switch buttons for each option.
	*/ _createMatchCaseSwitch() {
        const t = this.locale.t;
        const matchCaseSwitchButton = new (0, $29fd27cb9bdab9d2$export$bb3c559d00882ebd)(this.locale);
        matchCaseSwitchButton.set({
            label: t("Match case"),
            withText: true
        });
        matchCaseSwitchButton.bind("isOn").to(this, "_matchCase");
        matchCaseSwitchButton.on("execute", ()=>{
            this._matchCase = !this._matchCase;
            this.isDirty = true;
        });
        return matchCaseSwitchButton;
    }
    /**
	* Creates, configures and returns and instance of a dropdown allowing users to narrow
	* the search criteria down. The dropdown has a list with switch buttons for each option.
	*/ _createWholeWordsOnlySwitch() {
        const t = this.locale.t;
        const wholeWordsOnlySwitchButton = new (0, $29fd27cb9bdab9d2$export$bb3c559d00882ebd)(this.locale);
        wholeWordsOnlySwitchButton.set({
            label: t("Whole words only"),
            withText: true
        });
        wholeWordsOnlySwitchButton.bind("isOn").to(this, "_wholeWordsOnly");
        wholeWordsOnlySwitchButton.on("execute", ()=>{
            this._wholeWordsOnly = !this._wholeWordsOnly;
            this.isDirty = true;
        });
        return wholeWordsOnlySwitchButton;
    }
    /**
	* Initializes the {@link #_focusables} and {@link #_focusTracker} to allow navigation
	* using <kbd>Tab</kbd> and <kbd>Shift</kbd>+<kbd>Tab</kbd> keystrokes in the right order.
	*/ _initFocusCycling() {
        [
            this._findInputView,
            this._findPrevButtonView,
            this._findNextButtonView,
            this._replaceInputView,
            this._advancedOptionsCollapsibleView.buttonView,
            this._matchCaseSwitchView,
            this._wholeWordsOnlySwitchView,
            this._replaceAllButtonView,
            this._replaceButtonView,
            this._findButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this._focusTracker.add(v.element);
        });
    }
    /**
	* Initializes the keystroke handling in the form.
	*/ _initKeystrokeHandling() {
        const stopPropagation = (data)=>data.stopPropagation();
        const stopPropagationAndPreventDefault = (data)=>{
            data.stopPropagation();
            data.preventDefault();
        };
        this._keystrokes.listenTo(this.element);
        this._keystrokes.set("f3", (event)=>{
            stopPropagationAndPreventDefault(event);
            this._findNextButtonView.fire("execute");
        });
        this._keystrokes.set("shift+f3", (event)=>{
            stopPropagationAndPreventDefault(event);
            this._findPrevButtonView.fire("execute");
        });
        this._keystrokes.set("enter", (event)=>{
            const target = event.target;
            if (target === this._findInputView.fieldView.element) {
                if (this._areCommandsEnabled.findNext) this._findNextButtonView.fire("execute");
                else this._findButtonView.fire("execute");
                stopPropagationAndPreventDefault(event);
            } else if (target === this._replaceInputView.fieldView.element && !this.isDirty) {
                this._replaceButtonView.fire("execute");
                stopPropagationAndPreventDefault(event);
            }
        });
        this._keystrokes.set("shift+enter", (event)=>{
            if (event.target !== this._findInputView.fieldView.element) return;
            if (this._areCommandsEnabled.findPrevious) this._findPrevButtonView.fire("execute");
            else this._findButtonView.fire("execute");
            stopPropagationAndPreventDefault(event);
        });
        this._keystrokes.set("arrowright", stopPropagation);
        this._keystrokes.set("arrowleft", stopPropagation);
        this._keystrokes.set("arrowup", stopPropagation);
        this._keystrokes.set("arrowdown", stopPropagation);
    }
    /**
	* Creates a button view.
	*
	* @param options The properties of the `ButtonView`.
	* @returns The button view instance.
	*/ _createButton(options) {
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        button.set(options);
        return button;
    }
    /**
	* Creates a labeled input view.
	*
	* @param label The input label.
	* @returns The labeled input view instance.
	*/ _createInputField(label, className) {
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        labeledInput.label = label;
        labeledInput.class = className;
        return labeledInput;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findandreplaceui
*/ /**
* The default find and replace UI.
*
* It registers the `'findAndReplace'` UI button in the editor's {@link module:ui/componentfactory~ComponentFactory component factory}.
* that uses the {@link module:find-and-replace/findandreplace~FindAndReplace FindAndReplace} plugin API.
*/ var $a1bbd39e96f49b7d$export$ebe465c0d9bd0961 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$3ddf2d174ce01153)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FindAndReplaceUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* A reference to the find and replace form view.
	*/ formView;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("findAndReplace.uiType", "dialog");
        this.formView = null;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const isUiUsingDropdown = editor.config.get("findAndReplace.uiType") === "dropdown";
        const findCommand = editor.commands.get("find");
        const t = this.editor.t;
        editor.ui.componentFactory.add("findAndReplace", ()=>{
            let view;
            if (isUiUsingDropdown) {
                view = this._createDropdown();
                view.bind("isEnabled").to(findCommand);
            } else view = this._createDialogButtonForToolbar();
            editor.keystrokes.set("Ctrl+F", (data, cancelEvent)=>{
                if (!findCommand.isEnabled) return;
                if (view instanceof (0, $29fd27cb9bdab9d2$export$30eba291eb702857)) {
                    const dropdownButtonView = view.buttonView;
                    if (!dropdownButtonView.isOn) dropdownButtonView.fire("execute");
                } else if (view.isOn) editor.plugins.get("Dialog").view.focus();
                else view.fire("execute");
                cancelEvent();
            });
            return view;
        });
        if (!isUiUsingDropdown) editor.ui.componentFactory.add("menuBar:findAndReplace", ()=>{
            return this._createDialogButtonForMenuBar();
        });
        editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Find in the document"),
                    keystroke: "CTRL+F"
                }
            ]
        });
    }
    /**
	* Creates a dropdown containing the find and replace form.
	*/ _createDropdown() {
        const editor = this.editor;
        const t = editor.locale.t;
        const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(editor.locale);
        dropdownView.once("change:isOpen", ()=>{
            this.formView = this._createFormView();
            this.formView.children.add(new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(editor.locale, {
                label: t("Find and replace")
            }), 0);
            dropdownView.panelView.children.add(this.formView);
        });
        dropdownView.on("change:isOpen", (event, name, isOpen)=>{
            if (isOpen) this._setupFormView();
            else this.fire("searchReseted");
        }, {
            priority: "low"
        });
        dropdownView.buttonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$dd9478159cd90ed0),
            label: t("Find and replace"),
            keystroke: "CTRL+F",
            tooltip: true
        });
        return dropdownView;
    }
    /**
	* Creates a button that opens a dialog with the find and replace form.
	*/ _createDialogButtonForToolbar() {
        const editor = this.editor;
        const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
        const dialog = editor.plugins.get("Dialog");
        buttonView.set({
            tooltip: true
        });
        buttonView.bind("isOn").to(dialog, "id", (id)=>id === "findAndReplace");
        buttonView.on("execute", ()=>{
            if (buttonView.isOn) dialog.hide();
            else this._showDialog();
        });
        return buttonView;
    }
    /**
	* Creates a button for for menu bar that will show find and replace dialog.
	*/ _createDialogButtonForMenuBar() {
        const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        const dialogPlugin = this.editor.plugins.get("Dialog");
        const dialog = this.editor.plugins.get("Dialog");
        buttonView.set({
            role: "menuitemcheckbox",
            isToggleable: true
        });
        buttonView.bind("isOn").to(dialog, "id", (id)=>id === "findAndReplace");
        buttonView.on("execute", ()=>{
            if (dialogPlugin.id === "findAndReplace") {
                dialogPlugin.hide();
                return;
            }
            this._showDialog();
        });
        return buttonView;
    }
    /**
	* Creates a button for find and replace command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const findCommand = editor.commands.get("find");
        const buttonView = new ButtonClass(editor.locale);
        const t = editor.locale.t;
        buttonView.bind("isEnabled").to(findCommand);
        buttonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$dd9478159cd90ed0),
            label: t("Find and replace"),
            keystroke: "CTRL+F"
        });
        return buttonView;
    }
    /**
	* Shows the find and replace dialog.
	*/ _showDialog() {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        const t = editor.locale.t;
        if (!this.formView) this.formView = this._createFormView();
        dialog.show({
            id: "findAndReplace",
            title: t("Find and replace"),
            content: this.formView,
            position: (0, $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb).EDITOR_TOP_SIDE,
            onShow: ()=>{
                this._setupFormView();
            },
            onHide: ()=>{
                this.fire("searchReseted");
            }
        });
    }
    /**
	* Sets up the form view for the findN and replace.
	*/ _createFormView() {
        const editor = this.editor;
        const formView = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($a1bbd39e96f49b7d$export$3f1c355b2c7e2a3e))(editor.locale);
        const commands = editor.commands;
        const editingState = this.editor.plugins.get("FindAndReplaceEditing").state;
        formView.bind("highlightOffset").to(editingState, "highlightedOffset");
        formView.listenTo(editingState.results, "change", ()=>{
            formView.matchCount = editingState.results.length;
        });
        const findNextCommand = commands.get("findNext");
        const findPreviousCommand = commands.get("findPrevious");
        const replaceCommand = commands.get("replace");
        const replaceAllCommand = commands.get("replaceAll");
        formView.bind("_areCommandsEnabled").to(findNextCommand, "isEnabled", findPreviousCommand, "isEnabled", replaceCommand, "isEnabled", replaceAllCommand, "isEnabled", (findNext, findPrevious, replace, replaceAll)=>({
                findNext: findNext,
                findPrevious: findPrevious,
                replace: replace,
                replaceAll: replaceAll
            }));
        formView.delegate("findNext", "findPrevious", "replace", "replaceAll").to(this);
        formView.on("change:isDirty", (evt, data, isDirty)=>{
            if (isDirty) this.fire("searchReseted");
        });
        return formView;
    }
    /**
	* Clears the find and replace form and focuses the search text field.
	*/ _setupFormView() {
        this.formView.disableCssTransitions();
        this.formView.reset();
        this.formView._findInputView.fieldView.select();
        this.formView.enableCssTransitions();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findcommand
*/ /**
* The find command. It is used by the {@link module:find-and-replace/findandreplace~FindAndReplace find and replace feature}.
*/ var $a1bbd39e96f49b7d$export$22c8fda1b9d51588 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The find and replace state object used for command operations.
	*/ _state;
    /**
	* Creates a new `FindCommand` instance.
	*
	* @param editor The editor on which this command will be used.
	* @param state An object to hold plugin state.
	*/ constructor(editor, state){
        super(editor);
        this.isEnabled = true;
        this.affectsData = false;
        this._state = state;
    }
    /**
	* Executes the command.
	*
	* @param callbackOrText
	* @param options Options object.
	* @param options.matchCase If set to `true`, the letter case will be matched.
	* @param options.wholeWords If set to `true`, only whole words that match `callbackOrText` will be matched.
	*
	* @fires execute
	*/ execute(callbackOrText, { matchCase: matchCase, wholeWords: wholeWords } = {}) {
        const { editor: editor } = this;
        const { model: model } = editor;
        const findAndReplaceUtils = editor.plugins.get("FindAndReplaceUtils");
        let findCallback;
        let callbackSearchText = "";
        if (typeof callbackOrText === "string") findCallback = (...args)=>({
                results: findAndReplaceUtils.findByTextCallback(callbackOrText, {
                    matchCase: matchCase,
                    wholeWords: wholeWords
                })(...args),
                searchText: callbackOrText
            });
        else findCallback = callbackOrText;
        const oldCallback = findCallback;
        findCallback = (...args)=>{
            const result = oldCallback(...args);
            if (result && "searchText" in result) callbackSearchText = result.searchText;
            return result;
        };
        const results = model.document.getRootNames().reduce((currentResults, rootName)=>findAndReplaceUtils.updateFindResultFromRange(model.createRangeIn(model.document.getRoot(rootName)), model, findCallback, currentResults), null);
        this._state.clear(model);
        this._state.results.addMany(results);
        this._state.highlightedResult = results.get(0);
        this._state.searchText = callbackSearchText;
        /* v8 ignore next -- @preserve */ if (findCallback) this._state.lastSearchCallback = findCallback;
        this._state.matchCase = !!matchCase;
        this._state.matchWholeWords = !!wholeWords;
        return {
            results: results,
            findCallback: findCallback
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $a1bbd39e96f49b7d$var$FindAndReplaceStateBase = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$316ae78324a4e1c0)();
/**
* The object storing find and replace plugin state for a given editor instance.
*/ var $a1bbd39e96f49b7d$export$5e824e1dbce7bece = class extends $a1bbd39e96f49b7d$var$FindAndReplaceStateBase {
    /**
	* Creates an instance of the state.
	*/ constructor(model){
        super();
        this.set("results", new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)());
        this.set("highlightedResult", null);
        this.set("highlightedOffset", 0);
        this.set("searchText", "");
        this.set("replaceText", "");
        this.set("lastSearchCallback", null);
        this.set("matchCase", false);
        this.set("matchWholeWords", false);
        this.results.on("change", (eventInfo, { removed: removed, index: index })=>{
            if (Array.from(removed).length) {
                let highlightedResultRemoved = false;
                model.change((writer)=>{
                    for (const removedResult of removed){
                        if (this.highlightedResult === removedResult) highlightedResultRemoved = true;
                        if (model.markers.has(removedResult.marker.name)) writer.removeMarker(removedResult.marker);
                    }
                });
                if (highlightedResultRemoved) {
                    const nextHighlightedIndex = index >= this.results.length ? 0 : index;
                    this.highlightedResult = this.results.get(nextHighlightedIndex);
                }
            }
        });
        this.on("change:highlightedResult", ()=>{
            this.refreshHighlightOffset(model);
        });
    }
    /**
	* Cleans the state up and removes markers from the model.
	*/ clear(model) {
        this.searchText = "";
        model.change((writer)=>{
            if (this.highlightedResult) {
                const oldMatchId = this.highlightedResult.marker.name.split(":")[1];
                const oldMarker = model.markers.get(`findResultHighlighted:${oldMatchId}`);
                if (oldMarker) writer.removeMarker(oldMarker);
            }
            [
                ...this.results
            ].forEach(({ marker: marker })=>{
                writer.removeMarker(marker);
            });
        });
        this.results.clear();
    }
    /**
	* Refreshes the highlight result offset based on it's index within the result list.
	*/ refreshHighlightOffset(model) {
        const { highlightedResult: highlightedResult, results: results } = this;
        if (highlightedResult) this.highlightedOffset = $a1bbd39e96f49b7d$export$42192f7fb653e259(model, [
            ...results
        ]).indexOf(highlightedResult) + 1;
        else this.highlightedOffset = 0;
    }
};
/**
* Sorts search results by marker positions. Make sure that the results are sorted in the same order as they appear in the document
* to avoid issues with the `find next` command. Apparently, the order of the results in the state might be different than the order
* of the markers in the model.
*
* @internal
*/ function $a1bbd39e96f49b7d$export$42192f7fb653e259(model, results) {
    const sortMapping = {
        before: -1,
        same: 0,
        after: 1,
        different: 1
    };
    return model.document.getRootNames().flatMap((rootName)=>results.filter((result)=>result.marker.getStart().root.rootName === rootName).sort((a, b)=>sortMapping[a.marker.getStart().compareWith(b.marker.getStart())]));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/replacecommandbase
*/ var $a1bbd39e96f49b7d$export$fefed69dcb807d3e = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The find and replace state object used for command operations.
	*/ _state;
    /**
	* Creates a new `ReplaceCommand` instance.
	*
	* @param editor Editor on which this command will be used.
	* @param state An object to hold plugin state.
	*/ constructor(editor, state){
        super(editor);
        this.isEnabled = true;
        this._state = state;
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* Common logic for both `replace` commands.
	* Replace a given find result by a string or a callback.
	*
	* @param result A single result from the find command.
	*/ _replace(replacementText, result) {
        const { model: model } = this.editor;
        const range = result.marker.getRange();
        if (!model.canEditAt(range)) return;
        model.change((writer)=>{
            if (range.root.rootName === "$graveyard") {
                this._state.results.remove(result);
                return;
            }
            let textAttributes = {};
            for (const item of range.getItems())if (item.is("$text") || item.is("$textProxy")) {
                textAttributes = item.getAttributes();
                break;
            }
            model.insertContent(writer.createText(replacementText, textAttributes), range);
            if (this._state.results.has(result)) this._state.results.remove(result);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The replace command. It is used by the {@link module:find-and-replace/findandreplace~FindAndReplace find and replace feature}.
*/ var $a1bbd39e96f49b7d$export$73da8104ccb148bb = class extends $a1bbd39e96f49b7d$export$fefed69dcb807d3e {
    /**
	* Replace a given find result by a string or a callback.
	*
	* @param result A single result from the find command.
	*
	* @fires execute
	*/ execute(replacementText, result) {
        const oldHighlightOffset = Math.max(this._state.highlightedOffset - 1, 0);
        this._replace(replacementText, result);
        if (this._state.results.length) {
            const sortedResults = $a1bbd39e96f49b7d$export$42192f7fb653e259(this.editor.model, [
                ...this._state.results
            ]);
            this._state.highlightedResult = sortedResults[oldHighlightOffset % sortedResults.length];
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/replaceallcommand
*/ /**
* The replace all command. It is used by the {@link module:find-and-replace/findandreplace~FindAndReplace find and replace feature}.
*/ var $a1bbd39e96f49b7d$export$3f7edd8e0e87094f = class extends $a1bbd39e96f49b7d$export$fefed69dcb807d3e {
    /**
	* Replaces all the occurrences of `textToReplace` with a given `newText` string.
	*
	* ```ts
	*	replaceAllCommand.execute( 'replaceAll', 'new text replacement', 'text to replace' );
	* ```
	*
	* Alternatively you can call it from editor instance:
	*
	* ```ts
	*	editor.execute( 'replaceAll', 'new text', 'old text' );
	* ```
	*
	* @param newText Text that will be inserted to the editor for each match.
	* @param textToReplace Text to be replaced or a collection of matches
	* as returned by the find command.
	*
	* @fires module:core/command~Command#event:execute
	*/ execute(newText, textToReplace) {
        const { editor: editor } = this;
        const { model: model } = editor;
        const findAndReplaceUtils = editor.plugins.get("FindAndReplaceUtils");
        const results = textToReplace instanceof (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec) ? textToReplace : model.document.getRootNames().reduce((currentResults, rootName)=>findAndReplaceUtils.updateFindResultFromRange(model.createRangeIn(model.document.getRoot(rootName)), model, findAndReplaceUtils.findByTextCallback(textToReplace, this._state), currentResults), null);
        if (results.length) model.change(()=>{
            [
                ...results
            ].forEach((searchResult)=>{
                this._replace(newText, searchResult);
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findnextcommand
*/ /**
* The find next command. Moves the highlight to the next search result.
*
* It is used by the {@link module:find-and-replace/findandreplace~FindAndReplace find and replace feature}.
*/ var $a1bbd39e96f49b7d$export$86a94bf312edcfa9 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The find and replace state object used for command operations.
	*/ _state;
    /**
	* Creates a new `FindNextCommand` instance.
	*
	* @param editor The editor on which this command will be used.
	* @param state An object to hold plugin state.
	*/ constructor(editor, state){
        super(editor);
        this.affectsData = false;
        this._state = state;
        this.isEnabled = false;
        this.listenTo(this._state.results, "change", ()=>{
            this.isEnabled = this._state.results.length > 1;
        });
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._state.results.length > 1;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const results = this._state.results;
        const currentIndex = results.getIndex(this._state.highlightedResult);
        const nextIndex = currentIndex + 1 >= results.length ? 0 : currentIndex + 1;
        this._state.highlightedResult = this._state.results.get(nextIndex);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findpreviouscommand
*/ /**
* The find previous command. Moves the highlight to the previous search result.
*
* It is used by the {@link module:find-and-replace/findandreplace~FindAndReplace find and replace feature}.
*/ var $a1bbd39e96f49b7d$export$c58d7038d04a3b26 = class extends $a1bbd39e96f49b7d$export$86a94bf312edcfa9 {
    /**
	* @inheritDoc
	*/ execute() {
        const currentIndex = this._state.results.getIndex(this._state.highlightedResult);
        const previousIndex = currentIndex - 1 < 0 ? this._state.results.length - 1 : currentIndex - 1;
        this._state.highlightedResult = this._state.results.get(previousIndex);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A set of helpers related to find and replace.
*/ var $a1bbd39e96f49b7d$export$8172ac102f7d57c3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FindAndReplaceUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Executes findCallback and updates search results list.
	*
	* @param range The model range to scan for matches.
	* @param model The model.
	* @param findCallback The callback that should return `true` if provided text matches the search term.
	* @param startResults An optional collection of find matches that the function should
	* start with. This would be a collection returned by a previous `updateFindResultFromRange()` call.
	* @returns A collection of objects describing find match.
	*
	* An example structure:
	*
	* ```js
	* {
	*	id: resultId,
	*	label: foundItem.label,
	*	marker
	*	}
	* ```
	*/ updateFindResultFromRange(range, model, findCallback, startResults) {
        const results = startResults || new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        const checkIfResultAlreadyOnList = (marker)=>results.find((markerItem)=>{
                const { marker: resultsMarker } = markerItem;
                const resultRange = resultsMarker.getRange();
                const markerRange = marker.getRange();
                return resultRange.isEqual(markerRange);
            });
        model.change((writer)=>{
            const processTextContainer = (item)=>{
                let foundItems = findCallback({
                    item: item,
                    text: this.rangeToText(model.createRangeIn(item))
                });
                if (!foundItems) return;
                if ("results" in foundItems) foundItems = foundItems.results;
                foundItems.forEach((foundItem)=>{
                    const resultId = `findResult:${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
                    const marker = writer.addMarker(resultId, {
                        usingOperation: false,
                        affectsData: false,
                        range: writer.createRange(writer.createPositionAt(item, foundItem.start), writer.createPositionAt(item, foundItem.end))
                    });
                    const index = $a1bbd39e96f49b7d$var$findInsertIndex(results, marker);
                    if (!checkIfResultAlreadyOnList(marker)) results.add({
                        id: resultId,
                        label: foundItem.label,
                        marker: marker
                    }, index);
                });
            };
            const rangeContainer = range.start.parent;
            if (model.schema.checkChild(rangeContainer, "$text") && model.schema.isLimit(rangeContainer)) processTextContainer(rangeContainer);
            else [
                ...range
            ].forEach(({ type: type, item: item })=>{
                if (type === "elementStart" && model.schema.checkChild(item, "$text")) processTextContainer(item);
            });
        });
        return results;
    }
    /**
	* Returns text representation of a range. The returned text length should be the same as range length.
	* In order to achieve this, this function will replace inline elements (text-line) as new line character ("\n").
	*
	* @param range The model range.
	* @returns The text content of the provided range.
	*/ rangeToText(range) {
        return Array.from(range.getItems({
            shallow: true
        })).reduce((rangeText, node)=>{
            if (!(node.is("$text") || node.is("$textProxy"))) return `${rangeText}\n`;
            return rangeText + node.data;
        }, "");
    }
    /**
	* Creates a text matching callback for a specified search term and matching options.
	*
	* @param searchTerm The search term.
	* @param options Matching options.
	* 	- options.matchCase=false If set to `true` letter casing will be ignored.
	* 	- options.wholeWords=false If set to `true` only whole words that match `callbackOrText` will be matched.
	*/ findByTextCallback(searchTerm, options) {
        let flags = "gu";
        if (!options.matchCase) flags += "i";
        let regExpQuery = `(${(0, $16b28203d45236dc$export$7c57da42ce8e346f)(searchTerm)})`;
        if (options.wholeWords) {
            const nonLetterGroup = "[^a-zA-Z\xc0-\u024F\u1E00-\u1EFF]";
            if (!new RegExp("^" + nonLetterGroup).test(searchTerm)) regExpQuery = `(^|${nonLetterGroup}|_)${regExpQuery}`;
            if (!new RegExp(nonLetterGroup + "$").test(searchTerm)) regExpQuery = `${regExpQuery}(?=_|${nonLetterGroup}|$)`;
        }
        const regExp = new RegExp(regExpQuery, flags);
        function findCallback({ text: text }) {
            return [
                ...text.matchAll(regExp)
            ].map($a1bbd39e96f49b7d$var$regexpMatchToFindResult);
        }
        return findCallback;
    }
};
function $a1bbd39e96f49b7d$var$findInsertIndex(resultsList, markerToInsert) {
    const result = resultsList.find(({ marker: marker })=>{
        return markerToInsert.getStart().isBefore(marker.getStart());
    });
    return result ? resultsList.getIndex(result) : resultsList.length;
}
/**
*  Maps RegExp match result to find result.
*/ function $a1bbd39e96f49b7d$var$regexpMatchToFindResult(matchResult) {
    const lastGroupIndex = matchResult.length - 1;
    let startOffset = matchResult.index;
    if (matchResult.length === 3) startOffset += matchResult[1].length;
    return {
        label: matchResult[lastGroupIndex],
        start: startOffset,
        end: startOffset + matchResult[lastGroupIndex].length
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findandreplaceediting
*/ const $a1bbd39e96f49b7d$var$HIGHLIGHT_CLASS = "ck-find-result_selected";
/**
* Implements the editing part for find and replace plugin. For example conversion, commands etc.
*/ var $a1bbd39e96f49b7d$export$a43f49f5b478ab77 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a1bbd39e96f49b7d$export$8172ac102f7d57c3
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FindAndReplaceEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "FAR";
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* An object storing the find and replace state within a given editor instance.
	*/ state;
    /**
	* @inheritDoc
	*/ init() {
        this.state = new $a1bbd39e96f49b7d$export$5e824e1dbce7bece(this.editor.model);
        this.set("_isSearchActive", false);
        this._defineConverters();
        this._defineCommands();
        this.listenTo(this.state, "change:highlightedResult", (eventInfo, name, newValue, oldValue)=>{
            const { model: model } = this.editor;
            model.change((writer)=>{
                if (oldValue) {
                    const oldMatchId = oldValue.marker.name.split(":")[1];
                    const oldMarker = model.markers.get(`findResultHighlighted:${oldMatchId}`);
                    if (oldMarker) writer.removeMarker(oldMarker);
                }
                if (newValue) {
                    const newMatchId = newValue.marker.name.split(":")[1];
                    writer.addMarker(`findResultHighlighted:${newMatchId}`, {
                        usingOperation: false,
                        affectsData: false,
                        range: newValue.marker.getRange()
                    });
                }
            });
        });
        /* v8 ignore next -- @preserve */ const scrollToHighlightedResult = (eventInfo, name, newValue)=>{
            if (newValue) {
                const domConverter = this.editor.editing.view.domConverter;
                const viewRange = this.editor.editing.mapper.toViewRange(newValue.marker.getRange());
                (0, $c7bc2cb7e2db0227$export$a79393a569aee68b)({
                    target: domConverter.viewRangeToDom(viewRange),
                    viewportOffset: 40
                });
            }
        };
        const debouncedScrollListener = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(scrollToHighlightedResult.bind(this), 32);
        this.listenTo(this.state, "change:highlightedResult", debouncedScrollListener, {
            priority: "low"
        });
        this.listenTo(this.editor, "destroy", debouncedScrollListener.cancel);
        this.on("change:_isSearchActive", (evt, name, isSearchActive)=>{
            if (isSearchActive) this.listenTo(this.editor.model.document, "change:data", this._onDocumentChange);
            else this.stopListening(this.editor.model.document, "change:data", this._onDocumentChange);
        });
    }
    /**
	* Initiate a search.
	*/ find(callbackOrText, findAttributes) {
        this._isSearchActive = true;
        this.editor.execute("find", callbackOrText, findAttributes);
        return this.state.results;
    }
    /**
	* Stops active results from updating, and clears out the results.
	*/ stop() {
        this.state.clear(this.editor.model);
        this._isSearchActive = false;
    }
    /**
	* Sets up the commands.
	*/ _defineCommands() {
        this.editor.commands.add("find", new $a1bbd39e96f49b7d$export$22c8fda1b9d51588(this.editor, this.state));
        this.editor.commands.add("findNext", new $a1bbd39e96f49b7d$export$86a94bf312edcfa9(this.editor, this.state));
        this.editor.commands.add("findPrevious", new $a1bbd39e96f49b7d$export$c58d7038d04a3b26(this.editor, this.state));
        this.editor.commands.add("replace", new $a1bbd39e96f49b7d$export$73da8104ccb148bb(this.editor, this.state));
        this.editor.commands.add("replaceAll", new $a1bbd39e96f49b7d$export$3f7edd8e0e87094f(this.editor, this.state));
    }
    /**
	* Sets up the marker downcast converters for search results highlighting.
	*/ _defineConverters() {
        const { editor: editor } = this;
        editor.conversion.for("editingDowncast").markerToHighlight({
            model: "findResult",
            view: ({ markerName: markerName })=>{
                const [, id] = markerName.split(":");
                return {
                    name: "span",
                    classes: [
                        "ck-find-result"
                    ],
                    attributes: {
                        "data-find-result": id
                    }
                };
            }
        });
        editor.conversion.for("editingDowncast").markerToHighlight({
            model: "findResultHighlighted",
            view: ({ markerName: markerName })=>{
                const [, id] = markerName.split(":");
                return {
                    name: "span",
                    classes: [
                        $a1bbd39e96f49b7d$var$HIGHLIGHT_CLASS
                    ],
                    attributes: {
                        "data-find-result": id
                    }
                };
            }
        });
    }
    /**
	* Reacts to document changes in order to update search list.
	*/ _onDocumentChange = ()=>{
        const changedNodes = /* @__PURE__ */ new Set();
        const removedMarkers = /* @__PURE__ */ new Set();
        const model = this.editor.model;
        const { results: results } = this.state;
        const changes = model.document.differ.getChanges();
        const changedMarkers = model.document.differ.getChangedMarkers();
        changes.forEach((change)=>{
            if (!change.position) return;
            if (change.name === "$text" || change.position.nodeAfter && model.schema.isInline(change.position.nodeAfter)) {
                changedNodes.add(change.position.parent);
                [
                    ...model.markers.getMarkersAtPosition(change.position)
                ].forEach((markerAtChange)=>{
                    removedMarkers.add(markerAtChange.name);
                });
            } else if (change.type === "insert" && change.position.nodeAfter) changedNodes.add(change.position.nodeAfter);
        });
        changedMarkers.forEach(({ name: name, data: { newRange: newRange } })=>{
            if (newRange && newRange.start.root.rootName === "$graveyard") removedMarkers.add(name);
        });
        changedNodes.forEach((node)=>{
            [
                ...model.markers.getMarkersIntersectingRange(model.createRangeIn(node))
            ].forEach((marker)=>removedMarkers.add(marker.name));
        });
        removedMarkers.forEach((markerName)=>{
            if (!results.has(markerName)) {
                if (markerName.startsWith("findResult:")) {
                    const orphanMarker = model.markers.get(markerName);
                    /* v8 ignore else -- @preserve */ if (orphanMarker) model.change((writer)=>writer.removeMarker(orphanMarker));
                }
                return;
            }
            if (results.get(markerName) === this.state.highlightedResult) this.state.highlightedResult = null;
            results.remove(markerName);
        });
        const changedSearchResults = [];
        const findAndReplaceUtils = this.editor.plugins.get("FindAndReplaceUtils");
        changedNodes.forEach((nodeToCheck)=>{
            const searchRange = nodeToCheck.is("rootElement") ? model.createRangeIn(nodeToCheck) : model.createRangeOn(nodeToCheck);
            const changedNodeSearchResults = findAndReplaceUtils.updateFindResultFromRange(searchRange, model, this.state.lastSearchCallback, results);
            changedSearchResults.push(...changedNodeSearchResults);
        });
        changedMarkers.forEach((markerToCheck)=>{
            if (markerToCheck.name.startsWith("findResult")) return;
            /* v8 ignore else -- @preserve */ if (markerToCheck.data.newRange) {
                const changedNodeSearchResults = findAndReplaceUtils.updateFindResultFromRange(markerToCheck.data.newRange, model, this.state.lastSearchCallback, results);
                changedSearchResults.push(...changedNodeSearchResults);
            }
        });
        if (!this.state.highlightedResult && changedSearchResults.length) this.state.highlightedResult = changedSearchResults[0];
        else this.state.refreshHighlightOffset(model);
    };
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module find-and-replace/findandreplace
*/ /**
* The find and replace plugin.
*
* For a detailed overview, check the {@glink features/find-and-replace Find and replace feature documentation}.
*
* This is a "glue" plugin which loads the following plugins:
*
* * The {@link module:find-and-replace/findandreplaceediting~FindAndReplaceEditing find and replace editing feature},
* * The {@link module:find-and-replace/findandreplaceui~FindAndReplaceUI find and replace UI feature}
*/ var $a1bbd39e96f49b7d$export$a1e2e02dc910c90d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a1bbd39e96f49b7d$export$a43f49f5b478ab77,
            $a1bbd39e96f49b7d$export$ebe465c0d9bd0961
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FindAndReplace";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const ui = this.editor.plugins.get("FindAndReplaceUI");
        const findAndReplaceEditing = this.editor.plugins.get("FindAndReplaceEditing");
        const state = findAndReplaceEditing.state;
        ui.on("findNext", (event, data)=>{
            if (data) {
                state.searchText = data.searchText;
                findAndReplaceEditing.find(data.searchText, data);
            } else this.editor.execute("findNext");
        });
        ui.on("findPrevious", (event, data)=>{
            if (data && state.searchText !== data.searchText) findAndReplaceEditing.find(data.searchText);
            else this.editor.execute("findPrevious");
        });
        ui.on("replace", (event, data)=>{
            if (state.searchText !== data.searchText) findAndReplaceEditing.find(data.searchText);
            const highlightedResult = state.highlightedResult;
            if (highlightedResult) this.editor.execute("replace", data.replaceText, highlightedResult);
        });
        ui.on("replaceAll", (event, data)=>{
            if (state.searchText !== data.searchText) findAndReplaceEditing.find(data.searchText);
            this.editor.execute("replaceAll", data.replaceText, state.results);
        });
        ui.on("searchReseted", ()=>{
            state.clear(this.editor.model);
            findAndReplaceEditing.stop();
        });
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontcommand
*/ /**
* The base font command.
*/ var $9831d3c11b45f6e3$export$97c542b0001a602a = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A model attribute on which this command operates.
	*/ attributeKey;
    /**
	* Creates an instance of the command.
	*
	* @param editor Editor instance.
	* @param attributeKey The name of a model attribute on which this command operates.
	*/ constructor(editor, attributeKey){
        super(editor);
        this.attributeKey = attributeKey;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.value = doc.selection.getAttribute(this.attributeKey);
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }
    /**
	* Executes the command. Applies the `value` of the {@link #attributeKey} to the selection.
	* If no `value` is passed, it removes the attribute from the selection.
	*
	* @param options Options for the executed command.
	* @param options.value The value to apply.
	* @fires execute
	*/ execute(options = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const value = options.value;
        const batch = options.batch;
        const updateAttribute = (writer)=>{
            if (selection.isCollapsed) {
                if (value) writer.setSelectionAttribute(this.attributeKey, value);
                else writer.removeSelectionAttribute(this.attributeKey);
            } else {
                const ranges = model.schema.getValidRanges(selection.getRanges(), this.attributeKey, {
                    includeEmptyRanges: true
                });
                for (const range of ranges){
                    let itemOrRange = range;
                    let attributeKey = this.attributeKey;
                    if (range.isCollapsed) {
                        itemOrRange = range.start.parent;
                        attributeKey = (0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey(this.attributeKey);
                    }
                    if (value) writer.setAttribute(attributeKey, value, itemOrRange);
                    else writer.removeAttribute(attributeKey, itemOrRange);
                }
            }
        };
        if (batch) model.enqueueChange(batch, (writer)=>{
            updateAttribute(writer);
        });
        else model.change((writer)=>{
            updateAttribute(writer);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The name of the font size plugin.
*/ const $9831d3c11b45f6e3$var$FONT_SIZE = "fontSize";
/**
* The name of the font family plugin.
*/ const $9831d3c11b45f6e3$var$FONT_FAMILY = "fontFamily";
/**
* The name of the font color plugin.
*/ const $9831d3c11b45f6e3$var$FONT_COLOR = "fontColor";
/**
* The name of the font background color plugin.
*/ const $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR = "fontBackgroundColor";
/**
* Builds a proper converter definition out of input data.
*
* @internal
*/ function $9831d3c11b45f6e3$export$acfab3c3c2202a8d(modelAttributeKey, options) {
    const definition = {
        model: {
            key: modelAttributeKey,
            values: []
        },
        view: {},
        upcastAlso: {}
    };
    for (const option of options){
        definition.model.values.push(option.model);
        definition.view[option.model] = option.view;
        if (option.upcastAlso) definition.upcastAlso[option.model] = option.upcastAlso;
    }
    return definition;
}
/**
* A {@link module:font/fontcolor~FontColor font color} and
* {@link module:font/fontbackgroundcolor~FontBackgroundColor font background color} helper
* responsible for upcasting data to the model.
*
* **Note**: The `styleAttr` parameter should be either `'color'` or `'background-color'`.
*
* @internal
*/ function $9831d3c11b45f6e3$export$b5292efbf92d6fea(styleAttr) {
    return (viewElement)=>$9831d3c11b45f6e3$var$normalizeColorCode(viewElement.getStyle(styleAttr));
}
/**
* A {@link module:font/fontcolor~FontColor font color} and
* {@link module:font/fontbackgroundcolor~FontBackgroundColor font background color} helper
* responsible for downcasting a color attribute to a `<span>` element.
*
* **Note**: The `styleAttr` parameter should be either `'color'` or `'background-color'`.
*
* @internal
*/ function $9831d3c11b45f6e3$export$fb1df1c5a7807832(styleAttr) {
    return (modelAttributeValue, { writer: writer })=>writer.createAttributeElement("span", {
            style: `${styleAttr}:${modelAttributeValue}`
        }, {
            priority: 7
        });
}
/**
* A helper that adds {@link module:ui/colorselector/colorselectorview~ColorSelectorView} to the color dropdown with proper initial values.
*
* @param options Configuration options
* @param options.dropdownView The dropdown view to which a {@link module:ui/colorselector/colorselectorview~ColorSelectorView}
* will be added.
* @param options.colors An array with definitions representing colors to be displayed in the color selector.
* @param options.columns The number of columns in the color grid.
* @param options.removeButtonLabel The label for the button responsible for removing the color.
* @param options.colorPickerLabel The label for the color picker button.
* @param options.documentColorsLabel The label for the section with document colors.
* @param options.documentColorsCount The number of document colors inside the dropdown.
* @param options.colorPickerViewConfig Configuration of the color picker view.
* @returns The new color selector view.
* @internal
*/ function $9831d3c11b45f6e3$export$3dacc5bd9b2e519e({ dropdownView: dropdownView, colors: colors, columns: columns, removeButtonLabel: removeButtonLabel, colorPickerLabel: colorPickerLabel, documentColorsLabel: documentColorsLabel, documentColorsCount: documentColorsCount, colorPickerViewConfig: colorPickerViewConfig }) {
    const locale = dropdownView.locale;
    const colorSelectorView = new (0, $29fd27cb9bdab9d2$export$840fffd5af8d58e0)(locale, {
        colors: colors,
        columns: columns,
        removeButtonLabel: removeButtonLabel,
        colorPickerLabel: colorPickerLabel,
        documentColorsLabel: documentColorsLabel,
        documentColorsCount: documentColorsCount,
        colorPickerViewConfig: colorPickerViewConfig
    });
    dropdownView.colorSelectorView = colorSelectorView;
    dropdownView.panelView.children.add(colorSelectorView);
    return colorSelectorView;
}
/**
* Fixes the color value string.
*/ function $9831d3c11b45f6e3$var$normalizeColorCode(value) {
    return value.replace(/\s/g, "");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The font family command. It is used by {@link module:font/fontfamily/fontfamilyediting~FontFamilyEditing}
* to apply the font family.
*
* ```ts
* editor.execute( 'fontFamily', { value: 'Arial' } );
* ```
*
* **Note**: Executing the command without the value removes the attribute from the model.
*/ var $9831d3c11b45f6e3$export$f111d9fc90f42a36 = class extends $9831d3c11b45f6e3$export$97c542b0001a602a {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor, $9831d3c11b45f6e3$var$FONT_FAMILY);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Normalizes the {@link module:font/fontconfig~FontFamilyConfig#options configuration options}
* to the {@link module:font/fontconfig~FontFamilyOption} format.
*
* @param configuredOptions An array of options taken from the configuration.
* @internal
*/ function $9831d3c11b45f6e3$export$154856e115528feb(configuredOptions) {
    return configuredOptions.map($9831d3c11b45f6e3$var$getOptionDefinition$1).filter((option)=>option !== void 0);
}
/**
* Normalizes the CSS `font-family` property value to an array of unquoted and trimmed font faces.
*
* @internal
*/ function $9831d3c11b45f6e3$var$normalizeFontFamilies(fontDefinition) {
    return fontDefinition.replace(/["']/g, "").split(",").map((name)=>name.trim());
}
/**
* Returns an option definition either created from string shortcut.
* If object is passed then this method will return it without alternating it. Returns undefined for item than cannot be parsed.
*
*/ function $9831d3c11b45f6e3$var$getOptionDefinition$1(option) {
    if (typeof option === "object") return option;
    if (option === "default") return {
        title: "Default",
        model: void 0
    };
    if (typeof option !== "string") return;
    return $9831d3c11b45f6e3$var$generateFontPreset(option);
}
/**
* Creates a predefined preset for pixel size. It deconstructs font-family like string into full configuration option.
* A font definition is passed as coma delimited set of font family names. Font names might be quoted.
*
* @param fontDefinition A font definition form configuration.
*/ function $9831d3c11b45f6e3$var$generateFontPreset(fontDefinition) {
    const fontNames = $9831d3c11b45f6e3$var$normalizeFontFamilies(fontDefinition);
    const firstFontName = fontNames[0];
    const cssFontNames = fontNames.map($9831d3c11b45f6e3$var$normalizeFontNameForCSS).join(", ");
    return {
        title: firstFontName,
        model: cssFontNames,
        view: {
            name: "span",
            styles: {
                "font-family": cssFontNames
            },
            priority: 7
        }
    };
}
/**
* Normalizes font name for the style attribute. It adds braces (') if font name contains spaces.
*/ function $9831d3c11b45f6e3$var$normalizeFontNameForCSS(fontName) {
    fontName = fontName.trim();
    if (fontName.indexOf(" ") > 0) fontName = `'${fontName}'`;
    return fontName;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontfamily/fontfamilyediting
*/ /**
* The font family editing feature.
*
* It introduces the {@link module:font/fontfamily/fontfamilycommand~FontFamilyCommand command} and
* the `fontFamily` attribute in the {@link module:engine/model/model~Model model} which renders
* in the {@link module:engine/view/view view} as an inline `<span>` element (`<span style="font-family: Arial">`),
* depending on the {@link module:font/fontconfig~FontFamilyConfig configuration}.
*/ var $9831d3c11b45f6e3$export$fe2972cb06cab8d7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontFamilyEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define($9831d3c11b45f6e3$var$FONT_FAMILY, {
            options: [
                "default",
                "Arial, Helvetica, sans-serif",
                "Courier New, Courier, monospace",
                "Georgia, serif",
                "Lucida Sans Unicode, Lucida Grande, sans-serif",
                "Tahoma, Geneva, sans-serif",
                "Times New Roman, Times, serif",
                "Trebuchet MS, Helvetica, sans-serif",
                "Verdana, Geneva, sans-serif"
            ],
            supportAllValues: false
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: $9831d3c11b45f6e3$var$FONT_FAMILY
        });
        editor.model.schema.setAttributeProperties($9831d3c11b45f6e3$var$FONT_FAMILY, {
            isFormatting: true,
            copyOnEnter: true
        });
        const options = $9831d3c11b45f6e3$export$154856e115528feb(editor.config.get("fontFamily.options")).filter((item)=>item.model);
        const definition = $9831d3c11b45f6e3$export$acfab3c3c2202a8d($9831d3c11b45f6e3$var$FONT_FAMILY, options);
        if (editor.config.get("fontFamily.supportAllValues")) {
            this._prepareAnyValueConverters();
            this._prepareCompatibilityConverter();
        } else editor.conversion.attributeToElement(definition);
        editor.commands.add($9831d3c11b45f6e3$var$FONT_FAMILY, new $9831d3c11b45f6e3$export$f111d9fc90f42a36(editor));
    }
    /**
	* These converters enable keeping any value found as `style="font-family: *"` as a value of an attribute on a text even
	* if it is not defined in the plugin configuration.
	*/ _prepareAnyValueConverters() {
        const editor = this.editor;
        editor.conversion.for("downcast").attributeToElement({
            model: $9831d3c11b45f6e3$var$FONT_FAMILY,
            view: (attributeValue, { writer: writer })=>{
                return writer.createAttributeElement("span", {
                    style: "font-family:" + attributeValue
                }, {
                    priority: 7
                });
            }
        });
        editor.conversion.for("upcast").elementToAttribute({
            model: {
                key: $9831d3c11b45f6e3$var$FONT_FAMILY,
                value: (viewElement)=>viewElement.getStyle("font-family")
            },
            view: {
                name: "span",
                styles: {
                    "font-family": /.*/
                }
            }
        });
    }
    /**
	* Adds support for legacy `<font face="..">` formatting.
	*/ _prepareCompatibilityConverter() {
        this.editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "font",
                attributes: {
                    "face": /.*/
                }
            },
            model: {
                key: $9831d3c11b45f6e3$var$FONT_FAMILY,
                value: (viewElement)=>viewElement.getAttribute("face")
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontfamily/fontfamilyui
*/ /**
* The font family UI plugin. It introduces the `'fontFamily'` dropdown.
*/ var $9831d3c11b45f6e3$export$22e3b3ff1fbf130e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontFamilyUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const options = this._getLocalizedOptions();
        const command = editor.commands.get($9831d3c11b45f6e3$var$FONT_FAMILY);
        const accessibleLabel = t("Font Family");
        const listOptions = $9831d3c11b45f6e3$var$_prepareListOptions$1(options, command);
        editor.ui.componentFactory.add($9831d3c11b45f6e3$var$FONT_FAMILY, (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, listOptions, {
                role: "menu",
                ariaLabel: accessibleLabel
            });
            dropdownView.buttonView.set({
                label: accessibleLabel,
                icon: (0, $e8dc502aba5ac3f5$export$6a130398be26b750),
                tooltip: true
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: "ck-font-family-dropdown"
                }
            });
            dropdownView.bind("isEnabled").to(command);
            this.listenTo(dropdownView, "execute", (evt)=>{
                editor.execute(evt.source.commandName, {
                    value: evt.source.commandParam
                });
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add(`menuBar:${$9831d3c11b45f6e3$var$FONT_FAMILY}`, (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                label: accessibleLabel,
                icon: (0, $e8dc502aba5ac3f5$export$6a130398be26b750)
            });
            menuView.bind("isEnabled").to(command);
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            for (const definition of listOptions){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.set({
                    role: "menuitemradio",
                    isToggleable: true
                });
                buttonView.bind(...Object.keys(definition.model)).to(definition.model);
                buttonView.delegate("execute").to(menuView);
                buttonView.on("execute", ()=>{
                    editor.execute(definition.model.commandName, {
                        value: definition.model.commandParam
                    });
                    editor.editing.view.focus();
                });
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            menuView.panelView.children.add(listView);
            return menuView;
        });
    }
    /**
	* Returns options as defined in `config.fontFamily.options` but processed to account for
	* editor localization, i.e. to display {@link module:font/fontconfig~FontFamilyOption}
	* in the correct language.
	*
	* Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
	* when the user configuration is defined because the editor does not exist yet.
	*/ _getLocalizedOptions() {
        const editor = this.editor;
        const t = editor.t;
        return $9831d3c11b45f6e3$export$154856e115528feb(editor.config.get($9831d3c11b45f6e3$var$FONT_FAMILY).options).map((option)=>{
            if (option.title === "Default") option.title = t("Default");
            return option;
        });
    }
};
/**
* Prepares FontFamily dropdown items.
*/ function $9831d3c11b45f6e3$var$_prepareListOptions$1(options, command) {
    const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    for (const option of options){
        const def = {
            type: "button",
            model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                commandName: $9831d3c11b45f6e3$var$FONT_FAMILY,
                commandParam: option.model,
                label: option.title,
                role: "menuitemradio",
                withText: true
            })
        };
        def.model.bind("isOn").to(command, "value", (value)=>{
            if (value === option.model) return true;
            if (!value || !option.model) return false;
            return $9831d3c11b45f6e3$var$normalizeFontFamilies(value)[0].toLowerCase() === $9831d3c11b45f6e3$var$normalizeFontFamilies(option.model)[0].toLowerCase();
        });
        if (option.view && typeof option.view !== "string" && option.view.styles) def.model.set("labelStyle", `font-family: ${option.view.styles["font-family"]}`);
        itemDefinitions.add(def);
    }
    return itemDefinitions;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontfamily
*/ /**
* The font family plugin.
*
* For a detailed overview, check the {@glink features/font font feature} documentatiom
* and the {@glink api/font package page}.
*
* This is a "glue" plugin which loads the {@link module:font/fontfamily/fontfamilyediting~FontFamilyEditing} and
* {@link module:font/fontfamily/fontfamilyui~FontFamilyUI} features in the editor.
*/ var $9831d3c11b45f6e3$export$cd0608c167c7849e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9831d3c11b45f6e3$export$fe2972cb06cab8d7,
            $9831d3c11b45f6e3$export$22e3b3ff1fbf130e
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontFamily";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The font size command. It is used by {@link module:font/fontsize/fontsizeediting~FontSizeEditing}
* to apply the font size.
*
* ```ts
* editor.execute( 'fontSize', { value: 'small' } );
* ```
*
* **Note**: Executing the command without the value removes the attribute from the model.
*/ var $9831d3c11b45f6e3$export$f106699dfbecca7c = class extends $9831d3c11b45f6e3$export$97c542b0001a602a {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor, $9831d3c11b45f6e3$var$FONT_SIZE);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontsize/utils
*/ /**
* Normalizes and translates the {@link module:font/fontconfig~FontSizeConfig#options configuration options}
* to the {@link module:font/fontconfig~FontSizeOption} format.
*
* @param configuredOptions An array of options taken from the configuration.
* @internal
*/ function $9831d3c11b45f6e3$export$88939c7379f2ee7f(configuredOptions) {
    return configuredOptions.map((item)=>$9831d3c11b45f6e3$var$getOptionDefinition(item)).filter((option)=>option !== void 0);
}
const $9831d3c11b45f6e3$var$namedPresets = {
    get tiny () {
        return {
            title: "Tiny",
            model: "tiny",
            view: {
                name: "span",
                classes: "text-tiny",
                priority: 7
            }
        };
    },
    get small () {
        return {
            title: "Small",
            model: "small",
            view: {
                name: "span",
                classes: "text-small",
                priority: 7
            }
        };
    },
    get big () {
        return {
            title: "Big",
            model: "big",
            view: {
                name: "span",
                classes: "text-big",
                priority: 7
            }
        };
    },
    get huge () {
        return {
            title: "Huge",
            model: "huge",
            view: {
                name: "span",
                classes: "text-huge",
                priority: 7
            }
        };
    }
};
/**
* Returns an option definition either from preset or creates one from number shortcut.
* If object is passed then this method will return it without alternating it. Returns undefined for item than cannot be parsed.
*/ function $9831d3c11b45f6e3$var$getOptionDefinition(option) {
    if (typeof option === "number") option = String(option);
    if (typeof option === "object" && $9831d3c11b45f6e3$var$isFullItemDefinition(option)) return $9831d3c11b45f6e3$var$attachPriority(option);
    const preset = $9831d3c11b45f6e3$var$findPreset(option);
    if (preset) return $9831d3c11b45f6e3$var$attachPriority(preset);
    if (option === "default") return {
        model: void 0,
        title: "Default"
    };
    if ($9831d3c11b45f6e3$var$isNumericalDefinition(option)) return;
    return $9831d3c11b45f6e3$var$generatePixelPreset(option);
}
/**
* Creates a predefined preset for pixel size.
* @param definition Font size in pixels.
* @returns
*/ function $9831d3c11b45f6e3$var$generatePixelPreset(definition) {
    if (typeof definition === "string") definition = {
        title: definition,
        model: `${parseFloat(definition)}px`
    };
    definition.view = {
        name: "span",
        styles: {
            "font-size": definition.model
        }
    };
    return $9831d3c11b45f6e3$var$attachPriority(definition);
}
/**
* Adds the priority to the view element definition if missing. It's required due to https://github.com/ckeditor/ckeditor5/issues/2291
*/ function $9831d3c11b45f6e3$var$attachPriority(definition) {
    if (definition.view && typeof definition.view !== "string" && !definition.view.priority) definition.view.priority = 7;
    return definition;
}
/**
* Returns a prepared preset definition. If passed an object, a name of preset should be defined as `model` value.
*
* @param definition.model A preset name.
*/ function $9831d3c11b45f6e3$var$findPreset(definition) {
    return typeof definition === "string" ? $9831d3c11b45f6e3$var$namedPresets[definition] : $9831d3c11b45f6e3$var$namedPresets[definition.model];
}
/**
* We treat `definition` as completed if it is an object that contains `title`, `model` and `view` values.
*/ function $9831d3c11b45f6e3$var$isFullItemDefinition(definition) {
    return definition.title && definition.model && definition.view;
}
function $9831d3c11b45f6e3$var$isNumericalDefinition(definition) {
    let numberValue;
    if (typeof definition === "object") {
        if (!definition.model) /**
		* Provided value as an option for {@link module:font/fontsize~FontSize} seems to invalid.
		*
		* See valid examples described in the {@link module:font/fontconfig~FontSizeConfig#options plugin configuration}.
		*
		* @error font-size-invalid-definition
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("font-size-invalid-definition", null, definition);
        else numberValue = parseFloat(definition.model);
    } else numberValue = parseFloat(definition);
    return isNaN(numberValue);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontsize/fontsizeediting
*/ const $9831d3c11b45f6e3$var$styleFontSize = [
    "x-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
];
/**
* The font size editing feature.
*
* It introduces the {@link module:font/fontsize/fontsizecommand~FontSizeCommand command} and the `fontSize`
* attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
* as a `<span>` element with either:
* * a style attribute (`<span style="font-size:12px">...</span>`),
* * or a class attribute (`<span class="text-small">...</span>`)
*
* depending on the {@link module:font/fontconfig~FontSizeConfig configuration}.
*/ var $9831d3c11b45f6e3$export$eea8666408d8afc0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontSizeEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define($9831d3c11b45f6e3$var$FONT_SIZE, {
            options: [
                "tiny",
                "small",
                "default",
                "big",
                "huge"
            ],
            supportAllValues: false
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: $9831d3c11b45f6e3$var$FONT_SIZE
        });
        editor.model.schema.setAttributeProperties($9831d3c11b45f6e3$var$FONT_SIZE, {
            isFormatting: true,
            copyOnEnter: true
        });
        const supportAllValues = editor.config.get("fontSize.supportAllValues");
        const options = $9831d3c11b45f6e3$export$88939c7379f2ee7f(this.editor.config.get("fontSize.options")).filter((item)=>item.model);
        const definition = $9831d3c11b45f6e3$export$acfab3c3c2202a8d($9831d3c11b45f6e3$var$FONT_SIZE, options);
        if (supportAllValues) {
            this._prepareAnyValueConverters(definition);
            this._prepareCompatibilityConverter();
        } else editor.conversion.attributeToElement(definition);
        editor.commands.add($9831d3c11b45f6e3$var$FONT_SIZE, new $9831d3c11b45f6e3$export$f106699dfbecca7c(editor));
    }
    /**
	* These converters enable keeping any value found as `style="font-size: *"` as a value of an attribute on a text even
	* if it is not defined in the plugin configuration.
	*
	* @param definition Converter definition out of input data.
	*/ _prepareAnyValueConverters(definition) {
        const editor = this.editor;
        const presets = definition.model.values.filter((value)=>{
            return !(0, $b9b9f2bdf9c6137f$export$1c20de4d9563b5aa)(String(value)) && !(0, $b9b9f2bdf9c6137f$export$573cb1d40169758d)(String(value));
        });
        if (presets.length) /**
		* If {@link module:font/fontconfig~FontSizeConfig#supportAllValues `config.fontSize.supportAllValues`} is `true`,
		* you need to use numerical values as font size options.
		*
		* See valid examples described in the {@link module:font/fontconfig~FontSizeConfig#options plugin configuration}.
		*
		* @error font-size-invalid-use-of-named-presets
		* @param {Array.<string>} presets Invalid values.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("font-size-invalid-use-of-named-presets", null, {
            presets: presets
        });
        editor.conversion.for("downcast").attributeToElement({
            model: $9831d3c11b45f6e3$var$FONT_SIZE,
            view: (attributeValue, { writer: writer })=>{
                if (!attributeValue) return;
                return writer.createAttributeElement("span", {
                    style: "font-size:" + attributeValue
                }, {
                    priority: 7
                });
            }
        });
        editor.conversion.for("upcast").elementToAttribute({
            model: {
                key: $9831d3c11b45f6e3$var$FONT_SIZE,
                value: (viewElement)=>viewElement.getStyle("font-size")
            },
            view: {
                name: "span",
                styles: {
                    "font-size": /.*/
                }
            }
        });
    }
    /**
	* Adds support for legacy `<font size="..">` formatting.
	*/ _prepareCompatibilityConverter() {
        this.editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "font",
                attributes: {
                    "size": /^[+-]?\d{1,3}$/
                }
            },
            model: {
                key: $9831d3c11b45f6e3$var$FONT_SIZE,
                value: (viewElement)=>{
                    const value = viewElement.getAttribute("size");
                    const isRelative = value[0] === "-" || value[0] === "+";
                    let size = parseInt(value, 10);
                    if (isRelative) size = 3 + size;
                    const maxSize = $9831d3c11b45f6e3$var$styleFontSize.length - 1;
                    return $9831d3c11b45f6e3$var$styleFontSize[Math.min(Math.max(size, 0), maxSize)];
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontsize/fontsizeui
*/ /**
* The font size UI plugin. It introduces the `'fontSize'` dropdown.
*/ var $9831d3c11b45f6e3$export$ccbcc614075247a6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontSizeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const options = this._getLocalizedOptions();
        const command = editor.commands.get($9831d3c11b45f6e3$var$FONT_SIZE);
        const accessibleLabel = t("Font Size");
        const listOptions = $9831d3c11b45f6e3$var$_prepareListOptions(options, command);
        editor.ui.componentFactory.add($9831d3c11b45f6e3$var$FONT_SIZE, (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, listOptions, {
                role: "menu",
                ariaLabel: accessibleLabel
            });
            dropdownView.buttonView.set({
                label: accessibleLabel,
                icon: (0, $e8dc502aba5ac3f5$export$22a74c9119a12cf9),
                tooltip: true
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: [
                        "ck-font-size-dropdown"
                    ]
                }
            });
            dropdownView.bind("isEnabled").to(command);
            this.listenTo(dropdownView, "execute", (evt)=>{
                editor.execute(evt.source.commandName, {
                    value: evt.source.commandParam
                });
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add(`menuBar:${$9831d3c11b45f6e3$var$FONT_SIZE}`, (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                label: accessibleLabel,
                icon: (0, $e8dc502aba5ac3f5$export$22a74c9119a12cf9)
            });
            menuView.bind("isEnabled").to(command);
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            for (const definition of listOptions){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.set({
                    role: "menuitemradio",
                    isToggleable: true
                });
                buttonView.bind(...Object.keys(definition.model)).to(definition.model);
                buttonView.delegate("execute").to(menuView);
                buttonView.on("execute", ()=>{
                    editor.execute(definition.model.commandName, {
                        value: definition.model.commandParam
                    });
                    editor.editing.view.focus();
                });
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            menuView.panelView.children.add(listView);
            return menuView;
        });
    }
    /**
	* Returns options as defined in `config.fontSize.options` but processed to account for
	* editor localization, i.e. to display {@link module:font/fontconfig~FontSizeOption}
	* in the correct language.
	*
	* Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
	* when the user configuration is defined because the editor does not exist yet.
	*/ _getLocalizedOptions() {
        const editor = this.editor;
        const t = editor.t;
        const localizedTitles = {
            Default: t("Default"),
            Tiny: t("Tiny"),
            Small: t("Small"),
            Big: t("Big"),
            Huge: t("Huge")
        };
        return $9831d3c11b45f6e3$export$88939c7379f2ee7f(editor.config.get($9831d3c11b45f6e3$var$FONT_SIZE).options).map((option)=>{
            const title = localizedTitles[option.title];
            if (title && title != option.title) option = Object.assign({}, option, {
                title: title
            });
            return option;
        });
    }
};
/**
* Prepares FontSize dropdown items.
*/ function $9831d3c11b45f6e3$var$_prepareListOptions(options, command) {
    const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    for (const option of options){
        const def = {
            type: "button",
            model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                commandName: $9831d3c11b45f6e3$var$FONT_SIZE,
                commandParam: option.model,
                label: option.title,
                class: "ck-fontsize-option",
                role: "menuitemradio",
                withText: true
            })
        };
        if (option.view && typeof option.view !== "string") {
            if (option.view.styles) def.model.set("labelStyle", `font-size:${option.view.styles["font-size"]}`);
            if (option.view.classes) def.model.set("class", `${def.model.class} ${option.view.classes}`);
        }
        def.model.bind("isOn").to(command, "value", (value)=>value === option.model);
        itemDefinitions.add(def);
    }
    return itemDefinitions;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontsize
*/ /**
* The font size plugin.
*
* For a detailed overview, check the {@glink features/font font feature} documentation
* and the {@glink api/font package page}.
*
* This is a "glue" plugin which loads the {@link module:font/fontsize/fontsizeediting~FontSizeEditing} and
* {@link module:font/fontsize/fontsizeui~FontSizeUI} features in the editor.
*/ var $9831d3c11b45f6e3$export$80f2abd03de5ca5a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9831d3c11b45f6e3$export$eea8666408d8afc0,
            $9831d3c11b45f6e3$export$ccbcc614075247a6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontSize";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Normalizes and translates the {@link module:font/fontconfig~FontSizeConfig#options configuration options}
	* to the {@link module:font/fontconfig~FontSizeOption} format.
	*
	* @param options An array of options taken from the configuration.
	*/ normalizeSizeOptions(options) {
        return $9831d3c11b45f6e3$export$88939c7379f2ee7f(options);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The font color command. It is used by {@link module:font/fontcolor/fontcolorediting~FontColorEditing}
* to apply the font color.
*
* ```ts
* editor.execute( 'fontColor', { value: 'rgb(250, 20, 20)' } );
* ```
*
* **Note**: Executing the command with the `null` value removes the attribute from the model.
*/ var $9831d3c11b45f6e3$export$d629a6fe04568f3a = class extends $9831d3c11b45f6e3$export$97c542b0001a602a {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor, $9831d3c11b45f6e3$var$FONT_COLOR);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontcolor/fontcolorediting
*/ /**
* The font color editing feature.
*
* It introduces the {@link module:font/fontcolor/fontcolorcommand~FontColorCommand command} and
* the `fontColor` attribute in the {@link module:engine/model/model~Model model} which renders
* in the {@link module:engine/view/view view} as a `<span>` element (`<span style="color: ...">`),
* depending on the {@link module:font/fontconfig~FontColorConfig configuration}.
*/ var $9831d3c11b45f6e3$export$d88e59c631a8f9d7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontColorEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define($9831d3c11b45f6e3$var$FONT_COLOR, {
            colors: (0, $29fd27cb9bdab9d2$export$fdf79bef57893a8d),
            columns: (0, $29fd27cb9bdab9d2$export$d573929527255e12)
        });
        editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "span",
                styles: {
                    "color": /[\s\S]+/
                }
            },
            model: {
                key: $9831d3c11b45f6e3$var$FONT_COLOR,
                value: $9831d3c11b45f6e3$export$b5292efbf92d6fea("color")
            }
        });
        editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "font",
                attributes: {
                    "color": /^#?\w+$/
                }
            },
            model: {
                key: $9831d3c11b45f6e3$var$FONT_COLOR,
                value: (viewElement)=>viewElement.getAttribute("color")
            }
        });
        editor.conversion.for("downcast").attributeToElement({
            model: $9831d3c11b45f6e3$var$FONT_COLOR,
            view: $9831d3c11b45f6e3$export$fb1df1c5a7807832("color")
        });
        editor.commands.add($9831d3c11b45f6e3$var$FONT_COLOR, new $9831d3c11b45f6e3$export$d629a6fe04568f3a(editor));
        editor.model.schema.extend("$text", {
            allowAttributes: $9831d3c11b45f6e3$var$FONT_COLOR
        });
        editor.model.schema.setAttributeProperties($9831d3c11b45f6e3$var$FONT_COLOR, {
            isFormatting: true,
            copyOnEnter: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/ui/colorui
*/ /**
* The color UI plugin which isolates the common logic responsible for displaying dropdowns with color grids.
*
* It is used to create the `'fontBackgroundColor'` and `'fontColor'` dropdowns, each hosting
* a {@link module:ui/colorselector/colorselectorview~ColorSelectorView}.
*/ var $9831d3c11b45f6e3$export$d1135883823ccec6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The name of the command which will be executed when a color tile is clicked.
	*/ commandName;
    /**
	* The name of this component in the {@link module:ui/componentfactory~ComponentFactory}.
	* Also the configuration scope name in `editor.config`.
	*/ componentName;
    /**
	* The SVG icon used by the dropdown.
	*/ icon;
    /**
	* The label used by the dropdown.
	*/ dropdownLabel;
    /**
	* The number of columns in the color grid.
	*/ columns;
    /**
	* Creates a plugin which introduces a dropdown with a pre–configured
	* {@link module:ui/colorselector/colorselectorview~ColorSelectorView}.
	*
	* @param editor An editor instance.
	* @param config The configuration object.
	* @param config.commandName The name of the command which will be executed when a color tile is clicked.
	* @param config.componentName The name of the dropdown in the {@link module:ui/componentfactory~ComponentFactory}
	* and the configuration scope name in `editor.config`.
	* @param config.icon The SVG icon used by the dropdown.
	* @param config.dropdownLabel The label used by the dropdown.
	*/ constructor(editor, { commandName: commandName, componentName: componentName, icon: icon, dropdownLabel: dropdownLabel }){
        super(editor);
        this.commandName = commandName;
        this.componentName = componentName;
        this.icon = icon;
        this.dropdownLabel = dropdownLabel;
        this.columns = editor.config.get(`${this.componentName}.columns`);
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const locale = editor.locale;
        const t = locale.t;
        const command = editor.commands.get(this.commandName);
        const componentConfig = editor.config.get(this.componentName);
        const colorsConfig = (0, $29fd27cb9bdab9d2$export$ee5a86b42a248fe4)(componentConfig.colors);
        const localizedColors = (0, $29fd27cb9bdab9d2$export$8609308dd8d581de)(locale, colorsConfig);
        const documentColorsCount = componentConfig.documentColors;
        const hasColorPicker = componentConfig.colorPicker !== false;
        editor.ui.componentFactory.add(this.componentName, (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            let dropdownContentRendered = false;
            const colorSelectorView = $9831d3c11b45f6e3$export$3dacc5bd9b2e519e({
                dropdownView: dropdownView,
                colors: localizedColors.map((option)=>({
                        label: option.label,
                        color: option.model,
                        options: {
                            hasBorder: option.hasBorder
                        }
                    })),
                columns: this.columns,
                removeButtonLabel: t("Remove color"),
                colorPickerLabel: t("Color picker"),
                documentColorsLabel: documentColorsCount !== 0 ? t("Document colors") : "",
                documentColorsCount: documentColorsCount === void 0 ? this.columns : documentColorsCount,
                colorPickerViewConfig: hasColorPicker ? componentConfig.colorPicker || {} : false
            });
            colorSelectorView.bind("selectedColor").to(command, "value");
            dropdownView.buttonView.set({
                label: this.dropdownLabel,
                icon: this.icon,
                tooltip: true
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: "ck-color-ui-dropdown"
                }
            });
            dropdownView.panelView.extendTemplate({
                attributes: {
                    class: "ck-dropdown__panel_fit-content"
                }
            });
            dropdownView.bind("isEnabled").to(command);
            colorSelectorView.on("execute", (evt, data)=>{
                if (dropdownView.isOpen) editor.execute(this.commandName, {
                    value: data.value,
                    batch: this._undoStepBatch
                });
                if (data.source !== "colorPicker") editor.editing.view.focus();
                if (data.source === "colorPickerSaveButton") dropdownView.isOpen = false;
            });
            colorSelectorView.on("colorPicker:show", ()=>{
                this._undoStepBatch = editor.model.createBatch();
            });
            colorSelectorView.on("colorPicker:cancel", ()=>{
                if (this._undoStepBatch.operations.length) {
                    dropdownView.isOpen = false;
                    editor.execute("undo", this._undoStepBatch);
                }
                editor.editing.view.focus();
            });
            dropdownView.on("change:isOpen", (evt, name, isVisible)=>{
                if (!dropdownContentRendered) {
                    dropdownContentRendered = true;
                    dropdownView.colorSelectorView.appendUI();
                }
                if (isVisible) {
                    if (documentColorsCount !== 0) colorSelectorView.updateDocumentColors(editor.model, this.componentName);
                    colorSelectorView.updateSelectedColors();
                    colorSelectorView.showColorGridsFragment();
                }
            });
            (0, $29fd27cb9bdab9d2$export$52d62fb5806f208)(dropdownView, ()=>dropdownView.colorSelectorView.colorGridsFragmentView.staticColorsGrid.items.find((item)=>item.isOn));
            return dropdownView;
        });
        editor.ui.componentFactory.add(`menuBar:${this.componentName}`, (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                label: this.dropdownLabel,
                icon: this.icon
            });
            menuView.bind("isEnabled").to(command);
            let contentRendered = false;
            const colorSelectorView = new (0, $29fd27cb9bdab9d2$export$840fffd5af8d58e0)(locale, {
                colors: localizedColors.map((option)=>({
                        label: option.label,
                        color: option.model,
                        options: {
                            hasBorder: option.hasBorder
                        }
                    })),
                columns: this.columns,
                removeButtonLabel: t("Remove color"),
                colorPickerLabel: t("Color picker"),
                documentColorsLabel: documentColorsCount !== 0 ? t("Document colors") : "",
                documentColorsCount: documentColorsCount === void 0 ? this.columns : documentColorsCount,
                colorPickerViewConfig: false
            });
            colorSelectorView.bind("selectedColor").to(command, "value");
            colorSelectorView.delegate("execute").to(menuView);
            colorSelectorView.on("execute", (evt, data)=>{
                editor.execute(this.commandName, {
                    value: data.value,
                    batch: this._undoStepBatch
                });
                editor.editing.view.focus();
            });
            menuView.on("change:isOpen", (evt, name, isVisible)=>{
                if (!contentRendered) {
                    contentRendered = true;
                    colorSelectorView.appendUI();
                }
                if (isVisible) {
                    if (documentColorsCount !== 0) colorSelectorView.updateDocumentColors(editor.model, this.componentName);
                    colorSelectorView.updateSelectedColors();
                    colorSelectorView.showColorGridsFragment();
                }
            });
            menuView.panelView.extendTemplate({
                attributes: {
                    class: "ck-menu-bar__menu__panel_fit-content"
                }
            });
            menuView.panelView.children.add(colorSelectorView);
            return menuView;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontcolor/fontcolorui
*/ /**
* The font color UI plugin. It introduces the `'fontColor'` dropdown.
*/ var $9831d3c11b45f6e3$export$459d0178e1680a86 = class extends $9831d3c11b45f6e3$export$d1135883823ccec6 {
    /**
	* @inheritDoc
	*/ constructor(editor){
        const t = editor.locale.t;
        super(editor, {
            commandName: $9831d3c11b45f6e3$var$FONT_COLOR,
            componentName: $9831d3c11b45f6e3$var$FONT_COLOR,
            icon: (0, $e8dc502aba5ac3f5$export$31253b9d9ec5390e),
            dropdownLabel: t("Font Color")
        });
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontColorUI";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontcolor
*/ /**
* The font color plugin.
*
* For a detailed overview, check the {@glink features/font font feature} documentation
* and the {@glink api/font package page}.
*
* This is a "glue" plugin which loads the {@link module:font/fontcolor/fontcolorediting~FontColorEditing} and
* {@link module:font/fontcolor/fontcolorui~FontColorUI} features in the editor.
*/ var $9831d3c11b45f6e3$export$df33c55a31a69b45 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9831d3c11b45f6e3$export$d88e59c631a8f9d7,
            $9831d3c11b45f6e3$export$459d0178e1680a86
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontColor";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The font background color command. It is used by
* {@link module:font/fontbackgroundcolor/fontbackgroundcolorediting~FontBackgroundColorEditing}
* to apply the font background color.
*
* ```ts
* editor.execute( 'fontBackgroundColor', { value: 'rgb(250, 20, 20)' } );
* ```
*
* **Note**: Executing the command with the `null` value removes the attribute from the model.
*/ var $9831d3c11b45f6e3$export$b90ee8b16488ad3c = class extends $9831d3c11b45f6e3$export$97c542b0001a602a {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor, $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontbackgroundcolor/fontbackgroundcolorediting
*/ /**
* The font background color editing feature.
*
* It introduces the {@link module:font/fontbackgroundcolor/fontbackgroundcolorcommand~FontBackgroundColorCommand command} and
* the `fontBackgroundColor` attribute in the {@link module:engine/model/model~Model model} which renders
* in the {@link module:engine/view/view view} as a `<span>` element (`<span style="background-color: ...">`),
* depending on the {@link module:font/fontconfig~FontColorConfig configuration}.
*/ var $9831d3c11b45f6e3$export$bba184224dc4044a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontBackgroundColorEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define($9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR, {
            colors: (0, $29fd27cb9bdab9d2$export$fdf79bef57893a8d),
            columns: (0, $29fd27cb9bdab9d2$export$d573929527255e12)
        });
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$422a7ff0e667c6c8));
        editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "span",
                styles: {
                    "background-color": /[\s\S]+/
                }
            },
            model: {
                key: $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR,
                value: $9831d3c11b45f6e3$export$b5292efbf92d6fea("background-color")
            }
        });
        editor.conversion.for("downcast").attributeToElement({
            model: $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR,
            view: $9831d3c11b45f6e3$export$fb1df1c5a7807832("background-color")
        });
        editor.commands.add($9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR, new $9831d3c11b45f6e3$export$b90ee8b16488ad3c(editor));
        editor.model.schema.extend("$text", {
            allowAttributes: $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR
        });
        editor.model.schema.setAttributeProperties($9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR, {
            isFormatting: true,
            copyOnEnter: true
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontbackgroundcolor/fontbackgroundcolorui
*/ /**
* The font background color UI plugin. It introduces the `'fontBackgroundColor'` dropdown.
*/ var $9831d3c11b45f6e3$export$9d6d749b59978889 = class extends $9831d3c11b45f6e3$export$d1135883823ccec6 {
    /**
	* @inheritDoc
	*/ constructor(editor){
        const t = editor.locale.t;
        super(editor, {
            commandName: $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR,
            componentName: $9831d3c11b45f6e3$var$FONT_BACKGROUND_COLOR,
            icon: (0, $e8dc502aba5ac3f5$export$4117c670ac25fa00),
            dropdownLabel: t("Font Background Color")
        });
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontBackgroundColorUI";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/fontbackgroundcolor
*/ /**
* The font background color plugin.
*
* For a detailed overview, check the {@glink features/font font feature} documentation
* and the {@glink api/font package page}.
*
* This is a "glue" plugin which loads
* the {@link module:font/fontbackgroundcolor/fontbackgroundcolorediting~FontBackgroundColorEditing} and
* {@link module:font/fontbackgroundcolor/fontbackgroundcolorui~FontBackgroundColorUI} features in the editor.
*/ var $9831d3c11b45f6e3$export$e203e013b6559cf = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9831d3c11b45f6e3$export$bba184224dc4044a,
            $9831d3c11b45f6e3$export$9d6d749b59978889
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FontBackgroundColor";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module font/font
*/ /**
* A plugin that enables a set of text styling features:
*
* * {@link module:font/fontsize~FontSize},
* * {@link module:font/fontfamily~FontFamily}.
* * {@link module:font/fontcolor~FontColor},
* * {@link module:font/fontbackgroundcolor~FontBackgroundColor}.
*
* For a detailed overview, check the {@glink features/font Font feature} documentation
* and the {@glink api/font package page}.
*/ var $9831d3c11b45f6e3$export$89abf52a030e56ee = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9831d3c11b45f6e3$export$cd0608c167c7849e,
            $9831d3c11b45f6e3$export$80f2abd03de5ca5a,
            $9831d3c11b45f6e3$export$df33c55a31a69b45,
            $9831d3c11b45f6e3$export$e203e013b6559cf
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Font";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/handlers/integrations/contextualballoon
*/ /**
* Registers a `getPositionOptions` correction on the ContextualBalloon plugin so that
* balloons are offset below the fullscreen toolbar and menu bar.
*/ function $ffc93f5670039158$var$registerFullscreenBalloonOffsetCorrection(editor, wrapper) {
    if (!editor.plugins.has("ContextualBalloon")) return ()=>{};
    const contextualBalloon = editor.plugins.get("ContextualBalloon");
    const fullscreenStickyNorth = $ffc93f5670039158$var$createFullscreenStickyNorthPosition(wrapper);
    const listener = (evt)=>{
        const result = evt.return;
        if (!result?.positions?.includes((0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.viewportStickyNorth)) return;
        const topBarHeight = $ffc93f5670039158$var$getFullscreenTopBarHeight(wrapper);
        if (!topBarHeight) return;
        const viewportOffsetConfig = {
            ...result.viewportOffsetConfig
        };
        evt.return = {
            ...result,
            positions: [
                ...result.positions,
                fullscreenStickyNorth
            ],
            viewportOffsetConfig: {
                ...viewportOffsetConfig,
                top: (viewportOffsetConfig.top || 0) + topBarHeight
            }
        };
    };
    contextualBalloon.on("getPositionOptions", listener, {
        priority: "low"
    });
    if (contextualBalloon.visibleView) contextualBalloon.updatePosition();
    return ()=>{
        contextualBalloon.off("getPositionOptions", listener);
        if (contextualBalloon.visibleView) contextualBalloon.updatePosition();
    };
}
/**
* A drop-in replacement for `BalloonPanelView.defaultPositions.viewportStickyNorth` for fullscreen mode.
*
* The original uses `document.body` as the scrollable boundary. In fullscreen the editor sits in a
* `position: fixed` wrapper that is removed from normal document flow, so the body may shrink to just
* a few pixels - less than the toolbar height. When that happens the body no longer intersects the
* constrained viewport and the function returns `null`, causing the balloon to fall back to a position
* that overlaps the toolbar.
*/ function $ffc93f5670039158$var$createFullscreenStickyNorthPosition(wrapper) {
    const { stickyVerticalOffset: stickyVerticalOffset } = (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c);
    return (targetRect, balloonRect, viewportRect)=>{
        const boundaryRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(wrapper).getIntersection(viewportRect.getVisible());
        if (!boundaryRect) return null;
        const visibleBoundaryRect = boundaryRect.getVisible();
        if (!targetRect.getIntersection(visibleBoundaryRect)) return null;
        if (!(visibleBoundaryRect.top - targetRect.top - stickyVerticalOffset < balloonRect.height && visibleBoundaryRect.bottom - targetRect.bottom < balloonRect.height)) return null;
        return {
            top: visibleBoundaryRect.top + stickyVerticalOffset,
            left: targetRect.left + targetRect.width / 2 - balloonRect.width / 2,
            name: "arrowless",
            config: {
                withArrow: false
            }
        };
    };
}
/**
* Returns the combined height of the toolbar and menu-bar slots inside the fullscreen wrapper.
*/ function $ffc93f5670039158$var$getFullscreenTopBarHeight(wrapper) {
    const toolbarSlot = wrapper.querySelector("[data-ck-fullscreen=\"toolbar\"]");
    const menuBarSlot = wrapper.querySelector("[data-ck-fullscreen=\"menu-bar\"]");
    return (toolbarSlot ? new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(toolbarSlot).height : 0) + (menuBarSlot ? new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(menuBarSlot).height : 0);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/handlers/abstracteditorhandler
*/ const $ffc93f5670039158$var$DIALOG_OFFSET = 28;
const $ffc93f5670039158$var$LIGHT_DOM_STYLES = `
	/* Disable scrollbars that can be present due to the rest of the website content. */
	html.ck-fullscreen-scroll-locked,
	body.ck-fullscreen-scroll-locked {
		overflow: hidden;
	}

	/* CKBox wrappers have z-index of 9999, let's bump them over the dialog's to ensure visibility like outside fullscreen mode. */
	body.ck-fullscreen .ckbox:not(#n) {
		--ckbox-z-index-root: calc(var(--ck-z-dialog, 100000) + 1);

		/*
		 * Safari composites \`overflow: auto\` scroll layers (like \`.ck-fullscreen__editable-wrapper\`) on top of
		 * sibling stacking contexts regardless of z-index. Setting \`position: absolute\` promotes \`.ckbox\` to its
		 * own compositing layer, which Safari then sorts correctly above the editable wrapper's layer.
		 */
		position: absolute;
	}

	body.ck-fullscreen .ckbox:not(#n) .ckbox-img-editor {
		--ckbox-z-index-preview: calc(var(--ck-z-dialog, 100000) + 1);
	}
`;
/**
* The abstract editor type handler.
*
* This class defines some actions and behaviors that are applied when fullscreen mode is toggled, and which are common
* regardless of the editor type. Then, specific classes like `ClassicEditorHandler` or `DecoupledEditorHandler`
* extend this class with actions specific for these editor types.
*
* Extend this class to provide fullscreen mode handling for unsupported editor types,
* or if you wish to heavily customize the default behavior.
*
* The only method that is necessary to provide when extending this class is {@link #defaultOnEnter}. However, make sure to
* familiarize yourself with the below full list of actions taken by `FullscreenAbstractEditorHandler` to understand
* what is covered by default, and what should be provided by you.
*
* When entering the fullscreen mode, the {@link #enable} method is called. It creates the properly styled container
* and handles the editor features that need it, in the following order:
*
* 1. Saves the scroll positions of all ancestors of the editable element to restore them after leaving the fullscreen mode.
* 2. Executes the {@link #defaultOnEnter} method to move the proper editor UI elements to the fullscreen mode.
* **If you extend the abstract handler, you should override this method** to move the elements that are specific to your editor type, like:
* 	editable, toolbar, menu bar.
* 	Use {@link #moveToFullscreen} method for this purpose to ensure they are automatically cleaned up after leaving the fullscreen mode.
* 3. Adds proper classes to the `<body>` and `<html>` elements to block page scrolling, adjust `z-index` etc.
*
* Steps 4-12 are only executed if the corresponding features are used.
*
* 4. If presence list is used, moves it to the fullscreen mode container.
* 5. If document outline is used, moves it to the fullscreen mode.
* 6. If pagination is used, adjusts it's configuration for the changed view.
* 7. If annotations are used, moves them to the fullscreen mode.
* 8. If revision history is used, overrides the callbacks to show the revision viewer in the fullscreen mode.
* 9. If AI Tabs is used, moves it to the fullscreen mode.
* 10. If source editing and document outline are both used, registers a callback hiding the document outline header in source editing mode.
* 11. Changes the position of some dialogs to utilize the empty space on the right side of the editable element.
* 12. If custom container is used, hides all other elements in it to ensure they don't create an empty unscrollable space.
*
* Then finally:
*
* 13. Adjusts the visibility of the left and right sidebars based on the available space.
* 14. Sets up a resize observer to adjust the visibility of the left and right sidebars dynamically.
* 15. Executes the configured {@link module:fullscreen/fullscreenconfig~FullscreenConfig#onEnterCallback
* 	`config.fullscreen.onEnterCallback`} function.
* 	By default, it returns the fullscreen mode container element so it can be further customized.
*
* When leaving the fullscreen mode, the {@link #disable} method is called. It does the following:
*
* 1. Execute the configured {@link module:fullscreen/fullscreenconfig~FullscreenConfig#onLeaveCallback
* 	`config.fullscreen.onLeaveCallback`} function.
* 2. Remove the classes added to the `<body>` and `<html>` elements.
* 3. If document outline is used, restore its default container.
* 4. If annotations are used, restore their original state (UI, filters etc).
* 5. If revision history is used, restore the original callbacks.
* 7. If AI Tabs is used, restore it to the original state.
* 8. If source editing and document outline are both used, restore the document outline header.
* 9. Restore all moved elements to their original place.
* 10. Destroy the fullscreen mode container.
* 11. If the editor has a toolbar, switch its behavior to the one configured in the
* 	{@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} property.
* 12. Restore the scroll positions of all ancestors of the editable element.
* 13. If pagination is used, restore its default configuration.
* 14. Restore default dialogs positions.
*
* This class is exported to allow for custom extensions.
*/ var $ffc93f5670039158$export$a14d853ab0c5df4a = class {
    /**
	* Maps placeholder names to placeholder elements and moved elements.
	*/ _placeholderMap;
    /**
	* The wrapper element that holds the fullscreen mode layout.
	*/ _wrapper = null;
    /**
	* The document object in which the editor is located.
	*/ _document;
    /**
	* The element or shadow root the {@link #_wrapper} is mounted in – not to be confused with the *root* that
	* wrapper ends up living in, which is what the editor's own overlay layer is mounted in. Resolved when the
	* wrapper is created and reused until it is destroyed – see {@link #_getWrapperMountTarget}.
	*/ _wrapperMountTarget = null;
    /**
	* Whether the fullscreen mode covers the viewport, which is the case unless the integrator provided a
	* `fullscreen.container` other than the mount target that would be resolved anyway. It decides both the
	* positioning of the wrapper and the page scroll blocking, and cannot be derived from the position of the
	* wrapper in the DOM: mounted in a shadow root, it is not a child of the `<body>` element either way.
	* Resolved together with {@link #_wrapperMountTarget}.
	*/ _coversViewport = false;
    /**
	* The host of the shadow root the fullscreen mode is mounted in, when it was marked with the `ck-fullscreen`
	* class next to the `<body>` element. `null` for a mount target in the light DOM, which needs no marking.
	*/ _markedHostElement = null;
    /**
	* Data of the annotations UIs that were active before entering the fullscreen mode.
	*/ _annotationsUIsData = null;
    /**
	* The pagination body collection that is used in the fullscreen mode.
	* If we don't move pagination lines to the fullscreen wrapper, they won't be visible.
	*/ _paginationBodyCollection = null;
    /**
	* Whether the left sidebar collapse button is created.
	*/ _hasLeftCollapseButton = false;
    /**
	* The button that toggles the visibility of the left sidebar.
	*/ _collapseLeftSidebarButton = null;
    /**
	* The resize observer that is used to adjust the visibility of the left and right sidebars dynamically.
	*/ _resizeObserver = null;
    /**
	* The width of the expanded left and right sidebars in the fullscreen mode. Necessary for logic checking if they should be visible.
	*/ _sidebarsWidths = {
        left: 0,
        right: 0
    };
    /**
	* Whether the left sidebar should be kept hidden even if there is enough space for it. It's set to `true` when user
	* collapses the left sidebar with a button. Behavior is reset when exiting the fullscreen mode.
	*/ _keepLeftSidebarHidden = false;
    /**
	* Temporary flag used to ignore the first automatic layout adjustment logic when user collapses the left sidebar with a button.
	* It is then immediately set back to `false`.
	*/ _forceShowLeftSidebar = false;
    /**
	* A cleanup function returned by `registerFullscreenBalloonOffsetCorrection`.
	*/ _disableContextualBalloonPositionHandler = ()=>{};
    /**
	* A callback that hides the document outline header when the source editing mode is enabled.
	* Document outline element itself is hidden by source editing plugin.
	*/ /* v8 ignore start -- @preserve */ _sourceEditingCallback = (_evt, _name, value)=>{
        this.getWrapper().querySelector(".ck-fullscreen__document-outline-header").style.display = value ? "none" : "";
    };
    /* v8 ignore stop -- @preserve */ /**
	* A map of elements that were hidden when entering the fullscreen mode.
	* It is used to restore their previous visibility when leaving the fullscreen mode and avoid showing elements
	* that were hidden before entering the fullscreen mode.
	*/ _hiddenElements = /* @__PURE__ */ new Map();
    /**
	* A map matching the ancestors of the editable element with their scroll positions before entering fullscreen mode.
	*/ _savedAncestorsScrollPositions = /* @__PURE__ */ new Map();
    /**
	* A callback that shows the revision viewer, stored to restore the original one after exiting the fullscreen mode.
	*/ _showRevisionViewerCallback = null;
    /**
	* A callback that closes the revision viewer, stored to restore the original one after exiting the fullscreen mode.
	*/ _closeRevisionViewerCallback = null;
    /**
	* A map of AI Tabs data that were set before entering the fullscreen mode.
	*/ _aiTabsData = null;
    /**
	* @inheritDoc
	*/ constructor(editor){
        this._placeholderMap = /* @__PURE__ */ new Map();
        if (editor.plugins.has("RevisionHistory")) {
            this._showRevisionViewerCallback = editor.config.get("revisionHistory").showRevisionViewerCallback;
            this._closeRevisionViewerCallback = editor.config.get("revisionHistory").closeRevisionViewerCallback;
        }
        this._editor = editor;
        this._document = this._editor.sourceElement ? this._editor.sourceElement.ownerDocument : (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document;
        editor.on("destroy", ()=>{
            this.destroy();
            if (this._resizeObserver) this._resizeObserver.destroy();
        });
    }
    /**
	* Returns the element or shadow root the fullscreen mode is mounted in: the configured `fullscreen.container`,
	* otherwise the shared `ui.overlayContainer`, otherwise the root the editor lives in (so that the editor UI moved
	* to the fullscreen mode keeps the styles adopted by that root).
	*
	* The root is resolved from the editable element when the wrapper is created rather than from the source element
	* in the constructor: an editor may still be detached then (a decoupled editor is often inserted into the
	* document – possibly into a shadow root – only after it has been created), and a detached node has no root to
	* resolve.
	*/ _getWrapperMountTarget() {
        if (!this._wrapperMountTarget) {
            const editableElement = this._editor.ui.getEditableElement();
            const defaultMountTarget = this._editor.config.get("ui.overlayContainer") || editableElement && (0, $c7bc2cb7e2db0227$export$da615035af2261f1)(editableElement) || this._document.body;
            this._wrapperMountTarget = this._editor.config.get("fullscreen.container") || defaultMountTarget;
            this._coversViewport = this._wrapperMountTarget === defaultMountTarget || this._wrapperMountTarget === this._document.body;
        }
        return this._wrapperMountTarget;
    }
    /**
	* Moves the given element to the fullscreen mode container, leaving a placeholder in its place.
	*/ moveToFullscreen(elementToMove, placeholderName) {
        const placeholderElement = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div");
        placeholderElement.setAttribute("data-ck-fullscreen-placeholder", placeholderName);
        elementToMove.replaceWith(placeholderElement);
        this.getWrapper().querySelector(`[data-ck-fullscreen="${placeholderName}"]`).append(elementToMove);
        this._placeholderMap.set(placeholderName, {
            placeholderElement: placeholderElement,
            movedElement: elementToMove
        });
    }
    /**
	* Returns a single moved element to its original place.
	*/ restoreMovedElementLocation(placeholderName) {
        if (!this._placeholderMap.has(placeholderName)) return;
        const { placeholderElement: placeholderElement, movedElement: movedElement } = this._placeholderMap.get(placeholderName);
        placeholderElement.replaceWith(movedElement);
        placeholderElement.remove();
        this._placeholderMap.delete(placeholderName);
        if (this._placeholderMap.size === 0) this._destroyWrapper();
    }
    /**
	* Returns the fullscreen mode wrapper element.
	*/ getWrapper() {
        if (!this._wrapper) {
            const wrapperMountTarget = this._getWrapperMountTarget();
            this._wrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
                class: "ck ck-fullscreen__main-wrapper"
            });
            if (!this._coversViewport) this._wrapper.classList.add("ck-fullscreen__main-wrapper_custom-container");
            this._wrapper.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(`
				<div class="ck ck-fullscreen__top-wrapper ck-reset_all">
					<div class="ck ck-fullscreen__menu-bar" data-ck-fullscreen="menu-bar"></div>
					<div class="ck ck-fullscreen__toolbar" data-ck-fullscreen="toolbar"></div>
				</div>
				<div class="ck ck-fullscreen__editable-wrapper">
					<div class="ck ck-fullscreen__sidebar ck-fullscreen__left-sidebar" data-ck-fullscreen="left-sidebar"></div>
					<div class="ck ck-fullscreen__editable" data-ck-fullscreen="editable">
						<div class="ck ck-fullscreen__pagination-view" data-ck-fullscreen="pagination-view"></div>
					</div>
					<div class="ck ck-fullscreen__sidebar ck-fullscreen__right-sidebar" data-ck-fullscreen="right-sidebar"></div>
					<div class="ck ck-fullscreen__right-edge" data-ck-fullscreen="right-edge"></div>
				</div>
				<div class="ck ck-fullscreen__bottom-wrapper">
					<div class="ck ck-fullscreen__body-wrapper" data-ck-fullscreen="body-wrapper"></div>
				</div>
			`);
            wrapperMountTarget.appendChild(this._wrapper);
            this._editor.ui.shadowRootRegistry.registerNode(this._wrapper);
        }
        return this._wrapper;
    }
    /**
	* Enables the fullscreen mode. It executes the editor-specific enable handler and then the configured callback.
	*/ enable() {
        this._saveAncestorsScrollPositions(this._editor.ui.getEditableElement());
        this._getWrapperMountTarget();
        this.defaultOnEnter();
        if (this._coversViewport) {
            (0, $c7bc2cb7e2db0227$export$f6603621d2165759)(this._document, $ffc93f5670039158$var$LIGHT_DOM_STYLES);
            this._document.documentElement.classList.add("ck-fullscreen", "ck-fullscreen-scroll-locked");
            this._document.body.classList.add("ck-fullscreen", "ck-fullscreen-scroll-locked");
            const wrapperMountRoot = this._getWrapperMountTarget().getRootNode();
            if ((0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(wrapperMountRoot)) {
                this._markedHostElement = wrapperMountRoot.host;
                this._markedHostElement.classList.add("ck-fullscreen");
            }
        }
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("PresenceListUI")) this._generatePresenceListContainer();
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("DocumentOutlineUI")) this._generateDocumentOutlineContainer();
        if (this._hasLeftCollapseButton) this._generateCollapseButton();
        /* v8 ignore next -- @preserve */ if (this._editor.plugins.has("Pagination") && this._editor.plugins.get("Pagination").isEnabled) {
            const paginationRenderer = this._editor.plugins.get("PaginationRenderer");
            paginationRenderer.setupScrollableAncestor();
            this._paginationBodyCollection = new (0, $29fd27cb9bdab9d2$export$f96d1f01684ec5c2)(this._editor.locale);
            this._paginationBodyCollection.attachToDom(this.getWrapper().querySelector("[data-ck-fullscreen=\"body-wrapper\"]"));
            paginationRenderer.linesRepository.setViewCollection(this._paginationBodyCollection);
            this._editor.once("destroy", ()=>{
                this._paginationBodyCollection.destroy();
            });
        }
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("AnnotationsUIs")) this._overrideAnnotationsUIs();
        if (this._editor.plugins.has("RevisionHistory")) {
            /* v8 ignore if -- @preserve */ if (this._editor.plugins.get("RevisionHistory").isRevisionViewerOpen) this._editor.config.get("revisionHistory.closeRevisionViewerCallback")();
            this._overrideRevisionHistoryCallbacks();
        }
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("AITabs")) this._handleAITabsTransfer();
        if (this._editor.plugins.has("SourceEditing") && this._editor.plugins.has("DocumentOutlineUI")) this._editor.plugins.get("SourceEditing").on("change:isSourceEditingMode", this._sourceEditingCallback);
        const elementsToKeepVisible = [
            this.getWrapper(),
            this._editor.ui.view.body.bodyCollectionContainer,
            this._editor.config.get("ui.overlayContainer") || null
        ];
        for (const element of (this._editor.config.get("fullscreen.container") || this._document.body).children)if (!elementsToKeepVisible.some((node)=>(0, $c7bc2cb7e2db0227$export$f65a70da047b67c6)(element, node)) && !element.classList.contains("ck-body-wrapper") && !element.classList.contains("ckbox-wrapper") && element.style.display !== "none") {
            this._hiddenElements.set(element, element.style.display);
            element.style.display = "none";
        }
        this._sidebarsWidths = {
            left: this._wrapper.querySelector(".ck-fullscreen__left-sidebar").scrollWidth,
            right: this._wrapper.querySelector(".ck-fullscreen__right-sidebar").scrollWidth
        };
        this._adjustVisibleElements();
        this._setupResizeObserver();
        this._disableContextualBalloonPositionHandler = $ffc93f5670039158$var$registerFullscreenBalloonOffsetCorrection(this._editor, this.getWrapper());
        if (this._editor.plugins.has("Dialog")) this._registerFullscreenDialogPositionAdjustments();
        this._editor.ui.update();
        if (this._editor.config.get("fullscreen.onEnterCallback")) this._editor.config.get("fullscreen.onEnterCallback")(this.getWrapper());
    }
    /**
	* Disables the fullscreen mode by restoring all moved elements and destroying the fullscreen container.
	*/ disable() {
        if (this._editor.config.get("fullscreen.onLeaveCallback")) this._editor.config.get("fullscreen.onLeaveCallback")(this.getWrapper());
        this._document.documentElement.classList.remove("ck-fullscreen", "ck-fullscreen-scroll-locked");
        this._document.body.classList.remove("ck-fullscreen", "ck-fullscreen-scroll-locked");
        this._unmarkHostElement();
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("DocumentOutlineUI")) this._restoreDocumentOutlineDefaultContainer();
        /* v8 ignore if -- @preserve */ if (this._annotationsUIsData) this._restoreAnnotationsUIs();
        if (this._editor.plugins.has("RevisionHistory")) this._restoreRevisionHistoryCallbacks();
        /* v8 ignore if -- @preserve */ if (this._editor.plugins.has("AITabs")) this._restoreAITabs();
        if (this._editor.plugins.has("SourceEditing") && this._editor.plugins.has("DocumentOutlineUI")) this._editor.plugins.get("SourceEditing").off("change:isSourceEditingMode", this._sourceEditingCallback);
        for (const placeholderName of this._placeholderMap.keys())this.restoreMovedElementLocation(placeholderName);
        this._destroyWrapper();
        if (this._editor.ui.view.toolbar) this._editor.ui.view.toolbar.switchBehavior(this._editor.config.get("toolbar.shouldNotGroupWhenFull") === true ? "static" : "dynamic");
        for (const [ancestor, value] of this._savedAncestorsScrollPositions)ancestor.scrollTo({
            left: value.scrollLeft,
            top: value.scrollTop,
            behavior: "instant"
        });
        this._savedAncestorsScrollPositions.clear();
        /* v8 ignore next -- @preserve */ if (this._editor.plugins.has("Pagination") && this._editor.plugins.get("Pagination").isEnabled) {
            const paginationRenderer = this._editor.plugins.get("PaginationRenderer");
            paginationRenderer.setupScrollableAncestor();
            paginationRenderer.linesRepository.setViewCollection(this._editor.ui.view.body);
            this._paginationBodyCollection.destroy();
        }
        if (this._editor.plugins.has("Dialog")) this._unregisterFullscreenDialogPositionAdjustments();
        this._disableContextualBalloonPositionHandler();
        this._keepLeftSidebarHidden = false;
        this._resizeObserver?.destroy();
        this._editor.ui.update();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        for (const { placeholderElement: placeholderElement, movedElement: movedElement } of this._placeholderMap.values()){
            placeholderElement.remove();
            movedElement.remove();
        }
        this._destroyWrapper();
        this._document.documentElement.classList.remove("ck-fullscreen", "ck-fullscreen-scroll-locked");
        this._document.body.classList.remove("ck-fullscreen", "ck-fullscreen-scroll-locked");
        this._unmarkHostElement();
    }
    /**
	* Removes the `ck-fullscreen` class from the element it was added to next to the `<body>` and `<html>` elements.
	* The element is remembered instead of being resolved again, because the wrapper's mount target is forgotten before this runs.
	*/ _unmarkHostElement() {
        if (this._markedHostElement) {
            this._markedHostElement.classList.remove("ck-fullscreen");
            this._markedHostElement = null;
        }
    }
    /**
	* A function that moves the editor UI elements to the fullscreen mode. It should be set by the particular editor type handler.
	*
	* Returns the fullscreen mode wrapper element so it can be further customized via
	* `fullscreen.onEnterCallback` configuration property.
	*/ defaultOnEnter() {
        return this.getWrapper();
    }
    /**
	* Destroys the fullscreen mode wrapper.
	*/ _destroyWrapper() {
        if (!this._wrapper) return;
        this._editor.ui.shadowRootRegistry.unregisterNode(this._wrapper);
        this._wrapper.remove();
        this._wrapper = null;
        this._wrapperMountTarget = null;
        this._coversViewport = false;
        for (const [element, displayValue] of this._hiddenElements)element.style.display = displayValue;
        this._hiddenElements.clear();
    }
    /**
	* Checks if the PresenceListUI plugin is available and moves its elements to fullscreen mode.
	*/ /* v8 ignore next -- @preserve */ _generatePresenceListContainer() {
        const t = this._editor.t;
        const wrapper = this.getWrapper();
        const presenceListElement = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
            class: "ck ck-fullscreen__left-sidebar-item"
        });
        presenceListElement.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(`
			<div class="ck ck-fullscreen__left-sidebar-header"></div>
			<div class="ck ck-fullscreen__presence-list" data-ck-fullscreen="presence-list"></div>
		`);
        presenceListElement.firstElementChild.innerText = t("Connected users");
        if (!wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar-sticky\"]")) wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar\"]").appendChild((0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
            class: "ck ck-fullscreen__left-sidebar-sticky",
            "data-ck-fullscreen": "left-sidebar-sticky"
        }));
        wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar-sticky\"]").appendChild(presenceListElement);
        const presenceListUI = this._editor.plugins.get("PresenceListUI");
        this.moveToFullscreen(presenceListUI.view.element, "presence-list");
        this._hasLeftCollapseButton = true;
    }
    /**
	* Checks if the DocumentOutlineUI plugin is available and moves its elements to fullscreen mode.
	*/ /* v8 ignore next -- @preserve */ _generateDocumentOutlineContainer() {
        const t = this._editor.t;
        const wrapper = this.getWrapper();
        const documentOutlineHeaderElement = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
            class: "ck-fullscreen__left-sidebar-item ck-fullscreen__left-sidebar-item--no-margin"
        });
        documentOutlineHeaderElement.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(`
			<div class="ck ck-fullscreen__left-sidebar-header ck-fullscreen__document-outline-header"></div>
		`);
        documentOutlineHeaderElement.firstElementChild.innerText = t("Document outline");
        const documentOutlineBodyWrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
            class: "ck ck-fullscreen__left-sidebar-item ck-fullscreen__document-outline-wrapper"
        });
        documentOutlineBodyWrapper.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(`
			<div class="ck ck-fullscreen__document-outline" data-ck-fullscreen="document-outline"></div>
		`);
        if (!wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar-sticky\"]")) wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar\"]").appendChild((0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(this._document, "div", {
            class: "ck ck-fullscreen__left-sidebar-sticky",
            "data-ck-fullscreen": "left-sidebar-sticky"
        }));
        wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar\"]").appendChild(documentOutlineBodyWrapper);
        wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar-sticky\"]").appendChild(documentOutlineHeaderElement);
        const documentOutlineUI = this._editor.plugins.get("DocumentOutlineUI");
        documentOutlineUI.view.documentOutlineContainer = wrapper.querySelector("[data-ck-fullscreen=\"left-sidebar\"]");
        this.moveToFullscreen(documentOutlineUI.view.element, "document-outline");
        this._hasLeftCollapseButton = true;
    }
    /**
	* Restores the default value of documentOutlineContainer, which is modified in fullscreen mode.
	*/ /* v8 ignore next -- @preserve */ _restoreDocumentOutlineDefaultContainer() {
        const documentOutlineUI = this._editor.plugins.get("DocumentOutlineUI");
        documentOutlineUI.view.documentOutlineContainer = documentOutlineUI.view.element;
    }
    /* v8 ignore next -- @preserve */ _generateCollapseButton() {
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this._editor.locale);
        const leftSidebarContainer = this.getWrapper().querySelector(".ck-fullscreen__left-sidebar");
        const t = this._editor.t;
        button.set({
            label: t("Toggle sidebar"),
            class: "ck-fullscreen__left-sidebar-toggle-button ck-button_surface",
            tooltip: t("Hide left sidebar"),
            tooltipPosition: "se",
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3)
        });
        button.on("execute", ()=>{
            if (leftSidebarContainer.classList.contains("ck-fullscreen__left-sidebar--collapsed")) {
                this._forceShowLeftSidebar = true;
                this._keepLeftSidebarHidden = false;
                this._showLeftSidebar();
            } else {
                this._keepLeftSidebarHidden = true;
                this._hideLeftSidebar();
            }
            this._editor.editing.view.focus();
        });
        button.render();
        this._collapseLeftSidebarButton = button;
        leftSidebarContainer.prepend(button.element);
    }
    /**
	* Stores the current state of the annotations UIs to restore it when leaving fullscreen mode and switches the UI to the wide sidebar.
	*/ /* v8 ignore next -- @preserve */ _overrideAnnotationsUIs() {
        const annotationsUIs = this._editor.plugins.get("AnnotationsUIs");
        this._annotationsUIsData = new Map(annotationsUIs.uisData);
        annotationsUIs.deactivateAll();
        const sidebarPlugin = this._editor.plugins.get("Sidebar");
        if (!sidebarPlugin.container) {
            sidebarPlugin.setContainer(this.getWrapper().querySelector("[data-ck-fullscreen=\"right-sidebar\"]"));
            this._switchAnnotationsUI("wideSidebar");
            this.moveToFullscreen(sidebarPlugin.container.firstElementChild, "right-sidebar");
        } else {
            this._switchAnnotationsUI("wideSidebar");
            this.moveToFullscreen(sidebarPlugin.container.firstElementChild, "right-sidebar");
            sidebarPlugin.setContainer(this.getWrapper().querySelector("[data-ck-fullscreen=\"right-sidebar\"]"));
        }
    }
    /**
	* Restores the saved state of the annotations UIs.
	*/ /* v8 ignore next -- @preserve */ _restoreAnnotationsUIs() {
        const sidebarPlugin = this._editor.plugins.get("Sidebar");
        const sidebarContainer = sidebarPlugin.context.config.get("sidebar.container");
        if (sidebarContainer) sidebarPlugin.setContainer(sidebarContainer);
        const annotationsUIs = this._editor.plugins.get("AnnotationsUIs");
        annotationsUIs.deactivateAll();
        for (const [uiName, data] of [
            ...this._annotationsUIsData
        ])annotationsUIs.activate(uiName, data.filter);
        this._annotationsUIsData = null;
    }
    /**
	* Modifies the revision history viewer callbacks to display the viewer in the fullscreen mode.
	*/ _overrideRevisionHistoryCallbacks() {
        /* v8 ignore next -- @preserve */ this._editor.config.set("revisionHistory.showRevisionViewerCallback", async ()=>{
            const revisionViewerEditor = await this._showRevisionViewerCallback();
            if (this._editor.plugins.has("DocumentOutlineUI")) this.getWrapper().querySelector(".ck-fullscreen__document-outline-header").style.display = "none";
            this.restoreMovedElementLocation("editable");
            this.restoreMovedElementLocation("toolbar");
            this.restoreMovedElementLocation("right-sidebar");
            if (this._annotationsUIsData) this._restoreAnnotationsUIs();
            if (this._editor.ui.view.menuBarView) this._editor.ui.view.menuBarView.disable();
            this.moveToFullscreen(revisionViewerEditor.ui.getEditableElement(), "editable");
            this.moveToFullscreen(revisionViewerEditor.ui.view.toolbar.element, "toolbar");
            this.moveToFullscreen(this._editor.config.get("revisionHistory.viewerSidebarContainer"), "right-sidebar");
            return revisionViewerEditor;
        });
        /* v8 ignore next -- @preserve */ this._editor.config.set("revisionHistory.closeRevisionViewerCallback", async ()=>{
            this.restoreMovedElementLocation("toolbar");
            this.restoreMovedElementLocation("editable");
            this.restoreMovedElementLocation("right-sidebar");
            if (this._editor.plugins.has("DocumentOutlineUI")) this.getWrapper().querySelector(".ck-fullscreen__document-outline-header").style.display = "";
            this.moveToFullscreen(this._editor.ui.getEditableElement(), "editable");
            this.moveToFullscreen(this._editor.ui.view.toolbar.element, "toolbar");
            await this._closeRevisionViewerCallback();
            if (this._editor.plugins.has("AnnotationsUIs")) this._overrideAnnotationsUIs();
            if (this._editor.ui.view.menuBarView) this._editor.ui.view.menuBarView.enable();
        });
    }
    /**
	* Resets the revision history viewer callbacks to their original values.
	*/ _restoreRevisionHistoryCallbacks() {
        /* v8 ignore next -- @preserve */ this._editor.config.set("revisionHistory.showRevisionViewerCallback", async ()=>{
            return this._showRevisionViewerCallback();
        });
        /* v8 ignore next -- @preserve */ this._editor.config.set("revisionHistory.closeRevisionViewerCallback", async ()=>{
            return this._closeRevisionViewerCallback();
        });
    }
    /**
	* Adjusts the position of the open dialog to the editable moved to the fullscreen mode, and adds an event listener when
	* the dialog opens to adjust its position in fullscreen mode, utilizing the empty space on the right side of the editable element.
	*/ _registerFullscreenDialogPositionAdjustments() {
        const dialog = this._editor.plugins.get("Dialog");
        const dialogView = dialog.view;
        this._setNewDialogPosition();
        if (dialogView && !dialogView.wasMoved) dialogView.updatePosition();
        dialog.on("change:isOpen", this.updateDialogPositionCallback, {
            priority: "highest"
        });
    }
    /**
	* Removes an event listener that adjusts the dialog's position in fullscreen mode.
	*/ _unregisterFullscreenDialogPositionAdjustments() {
        const dialog = this._editor.plugins.get("Dialog");
        const dialogView = dialog.view;
        if (dialogView && dialogView.position === null) dialogView.position = (0, $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb).EDITOR_TOP_SIDE;
        if (dialogView && !dialogView.wasMoved) dialogView.updatePosition();
        dialog.off("change:isOpen", this.updateDialogPositionCallback);
    }
    /**
	* Stores a bound reference to the _updateDialogPosition method, allowing it to be attached and detached from change event.
	*/ updateDialogPositionCallback = this._updateDialogPosition.bind(this);
    /**
	* If dialog is open, adjust its positioning.
	*/ _updateDialogPosition(_evt, _name, isOpen) {
        if (isOpen) this._setNewDialogPosition();
    }
    /**
	* Adjusts the dialog position to utilize the empty space on the right side of the editable.
	* The new dialog position should be on the right side of the fullscreen view with a 30px margin.
	* Only dialogs with the position set to "editor-top-side" and not dragged by the user should have their position changed.
	*/ _setNewDialogPosition() {
        const dialogView = this._editor.plugins.get("Dialog").view;
        if (!dialogView || dialogView.position !== (0, $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb).EDITOR_TOP_SIDE || dialogView.wasMoved) return;
        const keepRightEdgeContainerVisible = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._wrapper.querySelector(".ck-fullscreen__right-edge")).getVisible();
        const relativeContainer = keepRightEdgeContainerVisible ? this._wrapper.querySelector(".ck-fullscreen__right-edge") : this._wrapper;
        const relativeContainerRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(relativeContainer).getVisible();
        const editorContainerRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._wrapper.querySelector(".ck-fullscreen__editable")).getVisible();
        const dialogRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(dialogView.element.querySelector(".ck-dialog")).getVisible();
        const scrollOffset = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._wrapper.querySelector(".ck-fullscreen__editable-wrapper")).excludeScrollbarsAndBorders().getVisible().width - new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this._wrapper.querySelector(".ck-fullscreen__editable-wrapper")).getVisible().width;
        if (relativeContainerRect && editorContainerRect && dialogRect) {
            dialogView.position = null;
            const leftOffset = keepRightEdgeContainerVisible ? relativeContainerRect.left - dialogRect.width - $ffc93f5670039158$var$DIALOG_OFFSET : relativeContainerRect.left + relativeContainerRect.width - dialogRect.width - $ffc93f5670039158$var$DIALOG_OFFSET + scrollOffset;
            dialogView.moveTo(leftOffset, editorContainerRect.top);
        }
    }
    /**
	* Saves the scroll positions of all ancestors of the given element.
	*/ _saveAncestorsScrollPositions(domElement) {
        let element = (0, $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a)(domElement);
        if (!element) return;
        while(element){
            const overflowY = element.style.overflowY || (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(element).overflowY;
            const overflowX = element.style.overflowX || (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(element).overflowX;
            if (overflowY === "auto" || overflowY === "scroll" || overflowX === "auto" || overflowX === "scroll") this._savedAncestorsScrollPositions.set(element, {
                scrollLeft: element.scrollLeft,
                scrollTop: element.scrollTop
            });
            else if (element.tagName === "HTML") this._savedAncestorsScrollPositions.set(element, {
                scrollLeft: element.scrollLeft,
                scrollTop: element.scrollTop
            });
            element = (0, $c7bc2cb7e2db0227$export$17eefa9b72eb0e2a)(element);
        }
    }
    /**
	* Stores the current state of the AI Tabs and moves it to the fullscreen mode.
	*/ _handleAITabsTransfer() {
        const aiTabs = this._editor.plugins.get("AITabs");
        this._aiTabsData = {
            side: aiTabs.side,
            type: aiTabs.type,
            container: aiTabs.container
        };
        this.moveToFullscreen(aiTabs.view.element, "right-edge");
        aiTabs.side = "right";
        aiTabs.type = "sidebar";
        aiTabs.container = this.getWrapper().querySelector("[data-ck-fullscreen=\"right-edge\"]");
        aiTabs.view.element.addEventListener("transitionend", this._aiTabsTransitionEndCallback);
    }
    /**
	* Checks the transition event to see if it's changing the width of the AI tabs and if so, adjusts the visible fullscreen mode elements.
	*/ _handleAISidebarTransitions(evt) {
        const aiTabs = this._editor.plugins.get("AITabs");
        if (evt.target === aiTabs.view.element && evt.propertyName.includes("width")) this._adjustVisibleElements();
    }
    /**
	* Restores the state of the AI Tabs to the original values.
	*/ _restoreAITabs() {
        const aiTabs = this._editor.plugins.get("AITabs");
        aiTabs.side = this._aiTabsData?.side;
        aiTabs.type = this._aiTabsData?.type;
        aiTabs.container = this._aiTabsData?.container ?? null;
        this._aiTabsData = null;
        aiTabs.view.element.removeEventListener("transitionend", this._aiTabsTransitionEndCallback);
    }
    /**
	* Adjusts the visibility of the left and right sidebars based on the available space.
	*/ _adjustVisibleElements() {
        const editableWrapper = this._wrapper.querySelector(".ck-fullscreen__editable-wrapper");
        if (this._forceShowLeftSidebar) {
            this._forceShowLeftSidebar = false;
            return;
        }
        if (editableWrapper.scrollWidth > editableWrapper.clientWidth) {
            this._hideLeftSidebar();
            if (editableWrapper.scrollWidth > editableWrapper.clientWidth) this._hideRightSidebar();
        } else {
            let actualWidth = [
                ...editableWrapper.children
            ].reduce((acc, child)=>acc + child.scrollWidth, 0);
            /* v8 ignore else -- @preserve */ if (actualWidth + this._sidebarsWidths.right < editableWrapper.clientWidth) {
                this._showRightSidebar();
                actualWidth = [
                    ...editableWrapper.children
                ].reduce((acc, child)=>acc + child.scrollWidth, 0);
            }
            if (actualWidth + this._sidebarsWidths.left < editableWrapper.clientWidth && !this._keepLeftSidebarHidden) this._showLeftSidebar();
        }
    }
    /**
	* Switches the annotations UI to the requested one.
	*/ /* v8 ignore next -- @preserve */ _switchAnnotationsUI(uiName) {
        const annotationsUIs = this._editor.plugins.get("AnnotationsUIs");
        annotationsUIs.deactivateAll();
        const annotationsFilters = /* @__PURE__ */ new Map();
        for (const [uiName, data] of [
            ...this._annotationsUIsData
        ])if (data.filter !== annotationsUIs.defaultFilter) annotationsFilters.set(uiName, data.filter);
        if (annotationsFilters.has(uiName)) annotationsUIs.activate(uiName, annotationsFilters.get(uiName));
        else if (annotationsFilters.size) annotationsUIs.activate(uiName, (annotation)=>[
                ...annotationsFilters.values()
            ].some((filter)=>filter(annotation)));
        else annotationsUIs.switchTo(uiName);
    }
    /**
	* Sets up a resize observer to adjust the visibility of the left and right sidebars dynamically.
	*/ _setupResizeObserver() {
        const wrapper = this._wrapper.querySelector(".ck-fullscreen__editable-wrapper");
        if (this._resizeObserver) this._resizeObserver.destroy();
        this._resizeObserver = new (0, $c7bc2cb7e2db0227$export$9caf76241ca21a11)(wrapper, ()=>{
            this._adjustVisibleElements();
        });
    }
    /**
	* Hides the left sidebar. Works only if there is anything to hide.
	*/ /* v8 ignore next -- @preserve */ _hideLeftSidebar() {
        const t = this._editor.t;
        if (this._collapseLeftSidebarButton) {
            this._wrapper.querySelector(".ck-fullscreen__left-sidebar").classList.add("ck-fullscreen__left-sidebar--collapsed");
            this._collapseLeftSidebarButton.icon = (0, $e8dc502aba5ac3f5$export$7b19f5c5fdff86c4);
            this._collapseLeftSidebarButton.tooltip = t("Show left sidebar");
        }
    }
    /**
	* Shows the left sidebar. Works only if there is anything to show.
	*/ /* v8 ignore next -- @preserve */ _showLeftSidebar() {
        const t = this._editor.t;
        if (this._collapseLeftSidebarButton) {
            this._wrapper.querySelector(".ck-fullscreen__left-sidebar").classList.remove("ck-fullscreen__left-sidebar--collapsed");
            this._collapseLeftSidebarButton.icon = (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3);
            this._collapseLeftSidebarButton.tooltip = t("Hide left sidebar");
        }
    }
    /**
	* Hides the right sidebar. Works only if there is anything to hide.
	*/ _hideRightSidebar() {
        if (this._wrapper.querySelector(".ck-fullscreen__right-sidebar").firstChild) {
            this._switchAnnotationsUI("narrowSidebar");
            this._wrapper.querySelector(".ck-fullscreen__right-sidebar").classList.add("ck-fullscreen__right-sidebar--collapsed");
        }
    }
    /**
	* Shows the right sidebar. Works only if there is anything to show.
	*/ _showRightSidebar() {
        if (this._wrapper.querySelector(".ck-fullscreen__right-sidebar").firstChild) {
            this._switchAnnotationsUI("wideSidebar");
            this._wrapper.querySelector(".ck-fullscreen__right-sidebar").classList.remove("ck-fullscreen__right-sidebar--collapsed");
        }
    }
    /**
	* Handler for AI tabs `transitionend`; must be the same reference in `addEventListener` / `removeEventListener`.
	*/ _aiTabsTransitionEndCallback = (evt)=>{
        this._handleAISidebarTransitions(evt);
    };
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/handlers/classiceditorhandler
*/ /**
* The classic editor fullscreen mode handler.
*/ var $ffc93f5670039158$export$a19a7b415d94f350 = class extends $ffc93f5670039158$export$a14d853ab0c5df4a {
    /**
	* An editor instance.
	*/ _editor;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._editor = editor;
    }
    /**
	* A function that moves the editor UI elements to the fullscreen mode.
	*/ defaultOnEnter() {
        const editorUI = this._editor.ui;
        const editorUIView = editorUI.view;
        const editable = editorUI.getEditableElement();
        /* v8 ignore next -- @preserve */ if (this._editor.plugins.has("Pagination") && this._editor.plugins.get("Pagination").isEnabled) {
            const paginationViewElement = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(editable)?.querySelector(".ck-pagination-view");
            if (paginationViewElement) this.moveToFullscreen(paginationViewElement, "pagination-view");
        }
        this.moveToFullscreen(editable, "editable");
        this.moveToFullscreen(editorUIView.toolbar.element, "toolbar");
        editorUIView.toolbar.switchBehavior(this._editor.config.get("fullscreen.toolbar.shouldNotGroupWhenFull") === true ? "static" : "dynamic");
        this.getWrapper().setAttribute("dir", editorUIView.element.getAttribute("dir"));
        this.getWrapper().classList.add("ck-rounded-corners");
        if (this._editor.config.get("fullscreen.menuBar.isVisible")) {
            if (!editorUIView.menuBarView) {
                editorUIView.menuBarView = new (0, $29fd27cb9bdab9d2$export$7215546daccd56dc)(this._editor.locale);
                editorUIView.menuBarView.render();
                editorUI.initMenuBar(editorUIView.menuBarView);
            }
            this.moveToFullscreen(editorUIView.menuBarView.element, "menu-bar");
        }
        return this.getWrapper();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The decoupled editor fullscreen mode handler.
*/ var $ffc93f5670039158$export$dd9ac6fb538b0b4d = class extends $ffc93f5670039158$export$a14d853ab0c5df4a {
    /**
	* An editor instance.
	*/ _editor;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._editor = editor;
    }
    /**
	* A function that moves the editor UI elements to the fullscreen mode.
	*/ defaultOnEnter() {
        const editable = this._editor.ui.getEditableElement();
        /* v8 ignore next -- @preserve */ if (this._editor.plugins.has("Pagination") && this._editor.plugins.get("Pagination").isEnabled) {
            const paginationViewElement = (0, $c7bc2cb7e2db0227$export$4e12058fc4d51d56)(editable)?.querySelector(".ck-pagination-view");
            if (paginationViewElement) this.moveToFullscreen(paginationViewElement, "pagination-view");
        }
        this.moveToFullscreen(editable, "editable");
        this.moveToFullscreen(this._editor.ui.view.toolbar.element, "toolbar");
        this._editor.ui.view.toolbar.switchBehavior(this._editor.config.get("fullscreen.toolbar.shouldNotGroupWhenFull") === true ? "static" : "dynamic");
        if (this._editor.config.get("fullscreen.menuBar.isVisible")) this.moveToFullscreen(this._editor.ui.view.menuBarView.element, "menu-bar");
        return this.getWrapper();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/fullscreencommand
*/ /**
* A command toggling the fullscreen mode.
*/ var $ffc93f5670039158$export$c33d244c1e1ee309 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Specialized class handling the fullscreen mode toggling for a specific editor type.
	*
	* If you want to add support for a new editor type (for now, only Classic and Decoupled editors are handled),
	* create a custom handler that extends `FullscreenAbstractEditorHandler` and replace `fullscreenHandler` with it after
	* editor initialization:
	*
	* ```ts
	* // See the details of how to implement a custom handler in the `FullscreenAbstractEditorHandler` class API docs.
	* class CustomEditorHandler extends FullscreenAbstractEditorHandler {}
	*
	* CustomEditorClass.create()
	* 	.then( ( editor ) => {
	* 		editor.commands.get( 'toggleFullscreen' ).fullscreenHandler = new CustomEditorHandler( editor );
	* 	} );
	* ```
	*/ fullscreenHandler;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
        this.isEnabled = true;
        this.value = false;
        if ($ffc93f5670039158$var$isClassicEditor(editor)) this.fullscreenHandler = new $ffc93f5670039158$export$a19a7b415d94f350(editor);
        else if ($ffc93f5670039158$var$isDecoupledEditor(editor)) this.fullscreenHandler = new $ffc93f5670039158$export$dd9ac6fb538b0b4d(editor);
        else this.fullscreenHandler = new $ffc93f5670039158$export$a14d853ab0c5df4a(editor);
    }
    /**
	* Toggles the fullscreen mode.
	*/ execute() {
        if (this.value) this._disableFullscreenMode();
        else this._enableFullscreenMode();
    }
    /**
	* Enables the fullscreen mode.
	*/ _enableFullscreenMode() {
        this.fullscreenHandler.enable();
        this.value = true;
    }
    /**
	* Disables the fullscreen mode.
	*/ _disableFullscreenMode() {
        this.fullscreenHandler.disable();
        this.value = false;
    }
};
/**
* Classic editor typeguard.
*/ function $ffc93f5670039158$var$isClassicEditor(editor) {
    return editor.constructor.editorName === "ClassicEditor";
}
/**
* Decoupled editor typeguard.
*/ function $ffc93f5670039158$var$isDecoupledEditor(editor) {
    return editor.constructor.editorName === "DecoupledEditor";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/fullscreenediting
*/ /**
* A plugin that registers the fullscreen mode command.
*/ var $ffc93f5670039158$export$36bf975ace8a18f6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FullscreenEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("fullscreen.menuBar.isVisible", true);
        editor.config.define("fullscreen.toolbar.shouldNotGroupWhenFull", editor.config.get("toolbar.shouldNotGroupWhenFull") === true);
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.commands.add("toggleFullscreen", new $ffc93f5670039158$export$c33d244c1e1ee309(this.editor));
        const t = this.editor.locale.t;
        this.editor.keystrokes.set("Ctrl+Shift+F", (evt, cancel)=>{
            this.editor.execute("toggleFullscreen");
            if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink) {
                this.editor.editing.view.document.isFocused = false;
                this.editor.ui.view.toolbar.focusTracker.focusedElement = null;
            }
            this.editor.editing.view.scrollToTheSelection();
            this.editor.editing.view.focus();
            cancel();
        });
        this.editor.accessibility.addKeystrokeInfos({
            keystrokes: [
                {
                    label: t("Toggle fullscreen mode"),
                    keystroke: "CTRL+SHIFT+F"
                }
            ],
            categoryId: "navigation"
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/fullscreenui
*/ const $ffc93f5670039158$var$COMMAND_NAME = "toggleFullscreen";
/**
* A plugin registering the fullscreen mode buttons.
*/ var $ffc93f5670039158$export$7411bd8c814ae497 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ffc93f5670039158$export$36bf975ace8a18f6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FullscreenUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("fullscreen", ()=>this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)));
        editor.ui.componentFactory.add("menuBar:fullscreen", ()=>this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
    /**
	* Creates a button that toggles the fullscreen mode.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const t = editor.t;
        const command = editor.commands.get($ffc93f5670039158$var$COMMAND_NAME);
        const view = new ButtonClass(editor.locale);
        view.set({
            isToggleable: true
        });
        view.bind("isEnabled").to(command, "isEnabled");
        view.bind("isOn").to(command, "value");
        if (view instanceof (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)) view.set({
            role: "menuitemcheckbox",
            label: t("Fullscreen mode")
        });
        else {
            view.bind("icon").to(command, "value", (value)=>value ? (0, $e8dc502aba5ac3f5$export$98b1ae70ec39316e) : (0, $e8dc502aba5ac3f5$export$7180bd615122b78e));
            view.bind("label").to(command, "value", (value)=>value ? t("Leave fullscreen mode") : t("Enter fullscreen mode"));
            view.set({
                tooltip: true
            });
        }
        this.listenTo(view, "execute", ()=>{
            editor.execute($ffc93f5670039158$var$COMMAND_NAME);
            if (!(0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isBlink) this.editor.ui.view.toolbar.focusTracker.focusedElement = null;
            editor.editing.view.scrollToTheSelection();
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module fullscreen/fullscreen
*/ /**
* The fullscreen mode feature.
*/ var $ffc93f5670039158$export$159cd03be7087f39 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ffc93f5670039158$export$36bf975ace8a18f6,
            $ffc93f5670039158$export$7411bd8c814ae497
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Fullscreen";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 
/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paragraph/paragraphcommand
*/ /**
* The paragraph command.
*/ var $f6000c35cc5ce21e$export$85ca9d637f622eff = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    constructor(editor){
        super(editor);
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const document = model.document;
        const block = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(document.selection.getSelectedBlocks());
        this.value = !!block && block.is("element", "paragraph");
        this.isEnabled = !!block && $f6000c35cc5ce21e$var$checkCanBecomeParagraph(block, model.schema);
    }
    /**
	* Executes the command. All the blocks (see {@link module:engine/model/schema~ModelSchema}) in the selection
	* will be turned to paragraphs.
	*
	* @fires execute
	* @param options Options for the executed command.
	* @param options.selection The selection that the command should be applied to. By default,
	* if not provided, the command is applied to the {@link module:engine/model/document~ModelDocument#selection}.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const document = model.document;
        const selection = options.selection || document.selection;
        if (!model.canEditAt(selection)) return;
        model.change((writer)=>{
            const blocks = selection.getSelectedBlocks();
            for (const block of blocks)if (!block.is("element", "paragraph") && $f6000c35cc5ce21e$var$checkCanBecomeParagraph(block, model.schema)) writer.rename(block, "paragraph");
        });
    }
};
/**
* Checks whether the given block can be replaced by a paragraph.
*
* @param block A block to be tested.
* @param schema The schema of the document.
*/ function $f6000c35cc5ce21e$var$checkCanBecomeParagraph(block, schema) {
    return schema.checkChild(block.parent, "paragraph") && !schema.isObject(block);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paragraph/insertparagraphcommand
*/ /**
* The insert paragraph command. It inserts a new paragraph at a specific
* {@link module:engine/model/position~ModelPosition document position}.
*
* ```ts
* // Insert a new paragraph before an element in the document.
* editor.execute( 'insertParagraph', {
*   position: editor.model.createPositionBefore( element )
* } );
* ```
*
* If a paragraph is disallowed in the context of the specific position, the command
* will attempt to split position ancestors to find a place where it is possible
* to insert a paragraph.
*
* **Note**: This command moves the selection to the inserted paragraph.
*/ var $f6000c35cc5ce21e$export$5f754660e1549f24 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    constructor(editor){
        super(editor);
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* Executes the command.
	*
	* @param options Options for the executed command.
	* @param options.position The model position at which the new paragraph will be inserted.
	* @param options.attributes Attributes keys and values to set on a inserted paragraph.
	* @fires execute
	*/ execute(options) {
        const model = this.editor.model;
        const attributes = options.attributes;
        let position = options.position;
        if (!model.canEditAt(position)) return null;
        return model.change((writer)=>{
            position = this._findPositionToInsertParagraph(position, writer);
            if (!position) return null;
            const paragraph = writer.createElement("paragraph");
            if (attributes) model.schema.setAllowedAttributes(paragraph, attributes, writer);
            model.insertContent(paragraph, position);
            writer.setSelection(paragraph, "in");
            return writer.createPositionAt(paragraph, 0);
        });
    }
    /**
	* Returns the best position to insert a new paragraph.
	*/ _findPositionToInsertParagraph(position, writer) {
        const model = this.editor.model;
        if (model.schema.checkChild(position, "paragraph")) return position;
        const allowedParent = model.schema.findAllowedParent(position, "paragraph");
        if (!allowedParent) return null;
        const positionParent = position.parent;
        const isTextAllowed = model.schema.checkChild(positionParent, "$text");
        if (positionParent.isEmpty || isTextAllowed && position.isAtEnd) return model.createPositionAfter(positionParent);
        if (!positionParent.isEmpty && isTextAllowed && position.isAtStart) return model.createPositionBefore(positionParent);
        return writer.split(position, allowedParent).position;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paragraph/paragraph
*/ /**
* The paragraph feature for the editor.
*
* It introduces the `<paragraph>` element in the model which renders as a `<p>` element in the DOM and data.
*
* It also brings two editors commands:
*
* * The {@link module:paragraph/paragraphcommand~ParagraphCommand `'paragraph'`} command that converts all
* blocks in the model selection into paragraphs.
* * The {@link module:paragraph/insertparagraphcommand~InsertParagraphCommand `'insertParagraph'`} command
* that inserts a new paragraph at a specified location in the model.
*/ var $f6000c35cc5ce21e$export$358a232cca1ab2ac = class Paragraph extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Paragraph";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        editor.commands.add("paragraph", new $f6000c35cc5ce21e$export$85ca9d637f622eff(editor));
        editor.commands.add("insertParagraph", new $f6000c35cc5ce21e$export$5f754660e1549f24(editor));
        model.schema.register("paragraph", {
            inheritAllFrom: "$block"
        });
        editor.conversion.elementToElement({
            model: "paragraph",
            view: "p"
        });
        editor.conversion.for("upcast").elementToElement({
            model: (viewElement, { writer: writer })=>{
                if (!Paragraph.paragraphLikeElements.has(viewElement.name)) return null;
                if (viewElement.isEmpty) return null;
                return writer.createElement("paragraph");
            },
            view: /.+/,
            converterPriority: "low"
        });
    }
    /**
	* A list of element names which should be treated by the autoparagraphing algorithms as
	* paragraph-like. This means that e.g. the following content:
	*
	* ```html
	* <h1>Foo</h1>
	* <table>
	*   <tr>
	*     <td>X</td>
	*     <td>
	*       <ul>
	*         <li>Y</li>
	*         <li>Z</li>
	*       </ul>
	*     </td>
	*   </tr>
	* </table>
	* ```
	*
	* contains five paragraph-like elements: `<h1>`, two `<td>`s and two `<li>`s.
	* Hence, if none of the features is going to convert those elements the above content will be automatically handled
	* by the paragraph feature and converted to:
	*
	* ```html
	* <p>Foo</p>
	* <p>X</p>
	* <p>Y</p>
	* <p>Z</p>
	* ```
	*
	* Note: The `<td>` containing two `<li>` elements was ignored as the innermost paragraph-like elements
	* have a priority upon conversion.
	*/ static paragraphLikeElements = /* @__PURE__ */ new Set([
        "blockquote",
        "dd",
        "div",
        "dt",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "li",
        "p",
        "td",
        "th"
    ]);
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paragraph/paragraphbuttonui
*/ /**
* This plugin defines the `'paragraph'` button. It can be used together with
* {@link module:heading/headingbuttonsui~HeadingButtonsUI} to replace the standard heading dropdown.
*
* This plugin is not loaded automatically by the {@link module:paragraph/paragraph~Paragraph} plugin. It must
* be added manually.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., Heading, Paragraph, HeadingButtonsUI, ParagraphButtonUI ]
*     toolbar: [ 'paragraph', 'heading1', 'heading2', 'heading3' ]
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $f6000c35cc5ce21e$export$264a07d2ecb76a92 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f6000c35cc5ce21e$export$358a232cca1ab2ac
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.ui.componentFactory.add("paragraph", (locale)=>{
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const command = editor.commands.get("paragraph");
            view.label = t("Paragraph");
            view.icon = (0, $e8dc502aba5ac3f5$export$dd7301757b50d467);
            view.tooltip = true;
            view.isToggleable = true;
            view.bind("isEnabled").to(command);
            view.bind("isOn").to(command, "value");
            view.on("execute", ()=>{
                editor.execute("paragraph");
            });
            return view;
        });
    }
};






/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/headingcommand
*/ /**
* The heading command. It is used by the {@link module:heading/heading~Heading heading feature} to apply headings.
*/ var $794b0589489e3c66$export$af719ebb885546ef = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Set of defined model's elements names that this command support.
	* See {@link module:heading/headingconfig~HeadingOption}.
	*/ modelElements;
    /**
	* Creates an instance of the command.
	*
	* @param editor Editor instance.
	* @param modelElements Names of the element which this command can apply in the model.
	*/ constructor(editor, modelElements){
        super(editor);
        this.modelElements = modelElements;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const block = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this.editor.model.document.selection.getSelectedBlocks());
        this.value = !!block && this.modelElements.includes(block.name) && block.name;
        this.isEnabled = !!block && this.modelElements.some((heading)=>$794b0589489e3c66$var$checkCanBecomeHeading(block, heading, this.editor.model.schema));
    }
    /**
	* Executes the command. Applies the heading to the selected blocks or, if the first selected
	* block is a heading already, turns selected headings (of this level only) to paragraphs.
	*
	* @param options.value Name of the element which this command will apply in the model.
	* @fires execute
	*/ execute(options) {
        const model = this.editor.model;
        const document = model.document;
        const modelElement = options.value;
        model.change((writer)=>{
            const blocks = Array.from(document.selection.getSelectedBlocks()).filter((block)=>{
                return $794b0589489e3c66$var$checkCanBecomeHeading(block, modelElement, model.schema);
            });
            for (const block of blocks)if (!block.is("element", modelElement)) writer.rename(block, modelElement);
        });
    }
};
/**
* Checks whether the given block can be replaced by a specific heading.
*
* @param block A block to be tested.
* @param heading Command element name in the model.
* @param schema The schema of the document.
*/ function $794b0589489e3c66$var$checkCanBecomeHeading(block, heading, schema) {
    return schema.checkChild(block.parent, heading) && !schema.isObject(block);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/headingediting
*/ const $794b0589489e3c66$var$defaultModelElement = "paragraph";
/**
* The headings engine feature. It handles switching between block formats &ndash; headings and paragraph.
* This class represents the engine part of the heading feature. See also {@link module:heading/heading~Heading}.
* It introduces `heading1`-`headingN` commands which allow to convert paragraphs into headings.
*/ var $794b0589489e3c66$export$fd295feb3b47fd9c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HeadingEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("heading", {
            options: [
                {
                    model: "paragraph",
                    title: "Paragraph",
                    class: "ck-heading_paragraph"
                },
                {
                    model: "heading1",
                    view: "h2",
                    title: "Heading 1",
                    class: "ck-heading_heading1"
                },
                {
                    model: "heading2",
                    view: "h3",
                    title: "Heading 2",
                    class: "ck-heading_heading2"
                },
                {
                    model: "heading3",
                    view: "h4",
                    title: "Heading 3",
                    class: "ck-heading_heading3"
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f6000c35cc5ce21e$export$358a232cca1ab2ac)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const options = editor.config.get("heading.options");
        const modelElements = [];
        for (const option of options){
            if (option.model === "paragraph") continue;
            editor.model.schema.register(option.model, {
                inheritAllFrom: "$block"
            });
            editor.conversion.elementToElement(option);
            modelElements.push(option.model);
        }
        this._addDefaultH1Conversion(editor);
        editor.commands.add("heading", new $794b0589489e3c66$export$af719ebb885546ef(editor, modelElements));
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const enterCommand = editor.commands.get("enter");
        const options = editor.config.get("heading.options");
        if (enterCommand) this.listenTo(enterCommand, "afterExecute", (evt, data)=>{
            const positionParent = editor.model.document.selection.getFirstPosition().parent;
            if (options.some((option)=>positionParent.is("element", option.model)) && !positionParent.is("element", $794b0589489e3c66$var$defaultModelElement) && positionParent.childCount === 0) data.writer.rename(positionParent, $794b0589489e3c66$var$defaultModelElement);
        });
    }
    /**
	* Adds default conversion for `h1` -> `heading1` with a low priority.
	*
	* @param editor Editor instance on which to add the `h1` conversion.
	*/ _addDefaultH1Conversion(editor) {
        editor.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low + 1
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns heading options as defined in `config.heading.options` but processed to consider
* the editor localization, i.e. to display {@link module:heading/headingconfig~HeadingOption}
* in the correct language.
*
* Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
* when the user configuration is defined because the editor does not exist yet.
*
* @internal
*/ function $794b0589489e3c66$export$df39164bcb96fc11(editor) {
    const t = editor.t;
    const localizedTitles = {
        "Paragraph": t("Paragraph"),
        "Heading 1": t("Heading 1"),
        "Heading 2": t("Heading 2"),
        "Heading 3": t("Heading 3"),
        "Heading 4": t("Heading 4"),
        "Heading 5": t("Heading 5"),
        "Heading 6": t("Heading 6")
    };
    return editor.config.get("heading.options").map((option)=>{
        const title = localizedTitles[option.title];
        if (title && title != option.title) option.title = title;
        return option;
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/headingui
*/ /**
* The headings UI feature. It introduces the `headings` dropdown.
*/ var $794b0589489e3c66$export$bf492c5b2093606a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HeadingUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const options = $794b0589489e3c66$export$df39164bcb96fc11(editor);
        const defaultTitle = t("Choose heading");
        const accessibleLabel = t("Heading");
        editor.ui.componentFactory.add("heading", (locale)=>{
            const titles = {};
            const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
            const headingCommand = editor.commands.get("heading");
            const paragraphCommand = editor.commands.get("paragraph");
            const commands = [
                headingCommand
            ];
            for (const option of options){
                const def = {
                    type: "button",
                    model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                        label: option.title,
                        class: option.class,
                        role: "menuitemradio",
                        withText: true
                    })
                };
                if (option.model === "paragraph") {
                    def.model.bind("isOn").to(paragraphCommand, "value");
                    def.model.set("commandName", "paragraph");
                    commands.push(paragraphCommand);
                } else {
                    def.model.bind("isOn").to(headingCommand, "value", (value)=>value === option.model);
                    def.model.set({
                        commandName: "heading",
                        commandValue: option.model
                    });
                }
                itemDefinitions.add(def);
                titles[option.model] = option.title;
            }
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, itemDefinitions, {
                ariaLabel: accessibleLabel,
                role: "menu"
            });
            dropdownView.buttonView.set({
                ariaLabel: accessibleLabel,
                ariaLabelledBy: void 0,
                isOn: false,
                withText: true,
                tooltip: accessibleLabel
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: [
                        "ck-heading-dropdown"
                    ]
                }
            });
            dropdownView.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>{
                return areEnabled.some((isEnabled)=>isEnabled);
            });
            dropdownView.buttonView.bind("label").to(headingCommand, "value", paragraphCommand, "value", (heading, paragraph)=>{
                const whichModel = paragraph ? "paragraph" : heading;
                if (typeof whichModel === "boolean") return defaultTitle;
                if (!titles[whichModel]) return defaultTitle;
                return titles[whichModel];
            });
            dropdownView.buttonView.bind("ariaLabel").to(headingCommand, "value", paragraphCommand, "value", (heading, paragraph)=>{
                const whichModel = paragraph ? "paragraph" : heading;
                if (typeof whichModel === "boolean") return accessibleLabel;
                if (!titles[whichModel]) return accessibleLabel;
                return `${titles[whichModel]}, ${accessibleLabel}`;
            });
            this.listenTo(dropdownView, "execute", (evt)=>{
                const { commandName: commandName, commandValue: commandValue } = evt.source;
                editor.execute(commandName, commandValue ? {
                    value: commandValue
                } : void 0);
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add("menuBar:heading", (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            const headingCommand = editor.commands.get("heading");
            const paragraphCommand = editor.commands.get("paragraph");
            const commands = [
                headingCommand
            ];
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            menuView.set({
                class: "ck-heading-dropdown"
            });
            listView.set({
                ariaLabel: t("Heading"),
                role: "menu"
            });
            menuView.buttonView.set({
                label: t("Heading")
            });
            menuView.panelView.children.add(listView);
            for (const option of options){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
                buttonView.set({
                    isToggleable: true,
                    label: option.title,
                    role: "menuitemradio",
                    class: option.class
                });
                buttonView.delegate("execute").to(menuView);
                buttonView.on("execute", ()=>{
                    const commandName = option.model === "paragraph" ? "paragraph" : "heading";
                    editor.execute(commandName, {
                        value: option.model
                    });
                    editor.editing.view.focus();
                });
                if (option.model === "paragraph") {
                    buttonView.bind("isOn").to(paragraphCommand, "value");
                    commands.push(paragraphCommand);
                } else buttonView.bind("isOn").to(headingCommand, "value", (value)=>value === option.model);
            }
            menuView.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>{
                return areEnabled.some((isEnabled)=>isEnabled);
            });
            return menuView;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/heading
*/ /**
* The headings feature.
*
* For a detailed overview, check the {@glink features/headings Headings feature} guide
* and the {@glink api/heading package page}.
*
* This is a "glue" plugin which loads the {@link module:heading/headingediting~HeadingEditing heading editing feature}
* and {@link module:heading/headingui~HeadingUI heading UI feature}.
*
* @extends module:core/plugin~Plugin
*/ var $794b0589489e3c66$export$a8a3e93435678ff9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $794b0589489e3c66$export$fd295feb3b47fd9c,
            $794b0589489e3c66$export$bf492c5b2093606a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Heading";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/headingbuttonsui
*/ const $794b0589489e3c66$var$defaultIcons = /* #__PURE__ */ (()=>({
        heading1: (0, $e8dc502aba5ac3f5$export$bac470d93529d4c7),
        heading2: (0, $e8dc502aba5ac3f5$export$1802ef05a0e02fcb),
        heading3: (0, $e8dc502aba5ac3f5$export$b1fdd40685827e35),
        heading4: (0, $e8dc502aba5ac3f5$export$1453f3b4cc22752),
        heading5: (0, $e8dc502aba5ac3f5$export$6d7f7031d9f2177d),
        heading6: (0, $e8dc502aba5ac3f5$export$81e8db89b599e5e6)
    }))();
/**
* The `HeadingButtonsUI` plugin defines a set of UI buttons that can be used instead of the
* standard drop down component.
*
* This feature is not enabled by default by the {@link module:heading/heading~Heading} plugin and needs to be
* installed manually to the editor configuration.
*
* Plugin introduces button UI elements, which names are same as `model` property from {@link module:heading/headingconfig~HeadingOption}.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., Heading, Paragraph, HeadingButtonsUI, ParagraphButtonUI ]
*     heading: {
*       options: [
*         { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
*         { model: 'heading1', view: 'h2', title: 'Heading 1', class: 'ck-heading_heading1' },
*         { model: 'heading2', view: 'h3', title: 'Heading 2', class: 'ck-heading_heading2' },
*         { model: 'heading3', view: 'h4', title: 'Heading 3', class: 'ck-heading_heading3' }
*       ]
*      },
*      toolbar: [ 'paragraph', 'heading1', 'heading2', 'heading3' ]
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*
* NOTE: The `'paragraph'` button is defined in by the {@link module:paragraph/paragraphbuttonui~ParagraphButtonUI} plugin
* which needs to be loaded manually as well.
*
* It is possible to use custom icons by providing `icon` config option in {@link module:heading/headingconfig~HeadingOption}.
* For the default configuration standard icons are used.
*/ var $794b0589489e3c66$export$1a42c692577d2930 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ init() {
        $794b0589489e3c66$export$df39164bcb96fc11(this.editor).filter((item)=>item.model !== "paragraph").map((item)=>this._createButton(item));
    }
    /**
	* Creates single button view from provided configuration option.
	*/ _createButton(option) {
        const editor = this.editor;
        editor.ui.componentFactory.add(option.model, (locale)=>{
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const command = editor.commands.get("heading");
            view.label = option.title;
            view.icon = option.icon || $794b0589489e3c66$var$defaultIcons[option.model];
            view.tooltip = true;
            view.isToggleable = true;
            view.bind("isEnabled").to(command);
            view.bind("isOn").to(command, "value", (value)=>value == option.model);
            view.on("execute", ()=>{
                editor.execute("heading", {
                    value: option.model
                });
                editor.editing.view.focus();
            });
            return view;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module heading/title
*/ const $794b0589489e3c66$var$titleLikeElements = /* @__PURE__ */ new Set([
    "paragraph",
    "heading1",
    "heading2",
    "heading3",
    "heading4",
    "heading5",
    "heading6"
]);
/**
* The Title plugin.
*
* It splits the document into `Title` and `Body` sections.
*/ var $794b0589489e3c66$export$f99233281efd08a0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A reference to an empty paragraph in the body
	* created when there is no element in the body for the placeholder purposes.
	*/ _bodyPlaceholder = /* @__PURE__ */ new Map();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Title";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f6000c35cc5ce21e$export$358a232cca1ab2ac)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        model.schema.register("title", {
            isBlock: true,
            allowIn: "$root"
        });
        model.schema.register("title-content", {
            isBlock: true,
            allowIn: "title",
            allowAttributes: [
                "alignment"
            ]
        });
        model.schema.extend("$text", {
            allowIn: "title-content"
        });
        model.schema.addAttributeCheck((context)=>{
            if (context.endsWith("title-content $text")) return false;
        });
        editor.editing.mapper.on("modelToViewPosition", $794b0589489e3c66$var$mapModelPositionToView(editor.editing.view));
        editor.data.mapper.on("modelToViewPosition", $794b0589489e3c66$var$mapModelPositionToView(editor.editing.view));
        editor.conversion.for("downcast").elementToElement({
            model: "title-content",
            view: "h1"
        });
        editor.conversion.for("downcast").add((dispatcher)=>dispatcher.on("insert:title", (evt, data, conversionApi)=>{
                conversionApi.consumable.consume(data.item, evt.name);
            }));
        editor.data.upcastDispatcher.on("element:h1", $794b0589489e3c66$var$dataViewModelH1Insertion, {
            priority: "high"
        });
        editor.data.upcastDispatcher.on("element:h2", $794b0589489e3c66$var$dataViewModelH1Insertion, {
            priority: "high"
        });
        editor.data.upcastDispatcher.on("element:h3", $794b0589489e3c66$var$dataViewModelH1Insertion, {
            priority: "high"
        });
        model.document.registerPostFixer((writer)=>this._fixTitleContent(writer));
        model.document.registerPostFixer((writer)=>this._fixTitleElement(writer));
        model.document.registerPostFixer((writer)=>this._fixBodyElement(writer));
        model.document.registerPostFixer((writer)=>this._fixExtraParagraph(writer));
        this._attachPlaceholders();
        this._attachTabPressHandling();
        this._warnIfNoSupportedRoot();
    }
    /**
	* Logs a single warning when none of the editor's roots can host the title structure. The Title feature
	* only operates on roots whose `modelElement` is the default `$root`; roots configured with a custom
	* `modelElement` are silently skipped at runtime. If no root supports the structure, the plugin is
	* effectively a no-op and the integrator likely wants to know.
	*/ _warnIfNoSupportedRoot() {
        const model = this.editor.model;
        for (const root of model.document.getRoots())if (model.schema.checkChild(root, "title")) return;
        /**
		* The Title feature was loaded, but none of the editor's roots supports the `title` element. The feature
		* only operates on roots whose `modelElement` is the default `$root`; roots configured with a custom
		* `modelElement` (including `$inlineRoot`) are silently skipped, so `getTitle()` / `getBody()` fall back
		* to the regular data getter and no title structure is ever inserted.
		*
		* To use the Title feature, ensure at least one root uses the default `$root` model element. Otherwise,
		* remove the Title plugin from this editor's plugin list.
		*
		* @error title-no-supported-root
		*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("title-no-supported-root");
    }
    /**
	* Returns the title of the document. Note that because this plugin does not allow any formatting inside
	* the title element, the output of this method will be a plain text, with no HTML tags.
	*
	* It is not recommended to use this method together with features that insert markers to the
	* data output, like comments or track changes features. If such markers start in the title and end in the
	* body, the result of this method might be incorrect.
	*
	* @param options Additional configuration passed to the conversion process.
	* See {@link module:engine/controller/datacontroller~DataController#get `DataController#get`}.
	* @returns The title of the document.
	*/ getTitle(options = {}) {
        const rootName = options.rootName ? options.rootName : void 0;
        const titleElement = this._getTitleElement(rootName);
        if (!titleElement) return "";
        const titleContentElement = titleElement.getChild(0);
        return this.editor.data.stringify(titleContentElement, options);
    }
    /**
	* Returns the body of the document.
	*
	* Note that it is not recommended to use this method together with features that insert markers to the
	* data output, like comments or track changes features. If such markers start in the title and end in the
	* body, the result of this method might be incorrect.
	*
	* @param options Additional configuration passed to the conversion process.
	* See {@link module:engine/controller/datacontroller~DataController#get `DataController#get`}.
	* @returns The body of the document.
	*/ getBody(options = {}) {
        const editor = this.editor;
        const data = editor.data;
        const model = editor.model;
        const rootName = options.rootName ? options.rootName : void 0;
        const root = editor.model.document.getRoot(rootName);
        if (!model.schema.checkChild(root, "title")) return data.get({
            ...options,
            rootName: root.rootName
        });
        const firstChild = root.getChild(0);
        if (!firstChild || !firstChild.is("element", "title")) return "";
        const view = editor.editing.view;
        const viewWriter = new (0, $b9b9f2bdf9c6137f$export$c1f00b82a18dfdda)(view.document);
        const rootRange = model.createRangeIn(root);
        const viewDocumentFragment = viewWriter.createDocumentFragment();
        const bodyStartPosition = model.createPositionAfter(firstChild);
        const bodyRange = model.createRange(bodyStartPosition, model.createPositionAt(root, "end"));
        const markers = /* @__PURE__ */ new Map();
        for (const marker of model.markers){
            const intersection = bodyRange.getIntersection(marker.getRange());
            if (intersection) markers.set(marker.name, intersection);
        }
        data.mapper.clearBindings();
        data.mapper.bindElements(root, viewDocumentFragment);
        data.downcastDispatcher.convert(rootRange, markers, viewWriter, options);
        viewWriter.remove(viewWriter.createRangeOn(viewDocumentFragment.getChild(0)));
        return editor.data.processor.toData(viewDocumentFragment);
    }
    /**
	* Returns the `title` element when it is in the document. Returns `undefined` otherwise.
	*/ _getTitleElement(rootName) {
        const model = this.editor.model;
        const root = model.document.getRoot(rootName);
        if (!model.schema.checkChild(root, "title")) return;
        for (const child of root.getChildren())if ($794b0589489e3c66$var$isTitle(child)) return child;
    }
    /**
	* Model post-fixer callback that ensures that `title` has only one `title-content` child.
	* All additional children should be moved after the `title` element and renamed to a paragraph.
	*/ _fixTitleContent(writer) {
        let changed = false;
        for (const rootName of this.editor.model.document.getRootNames()){
            const title = this._getTitleElement(rootName);
            if (!title || title.maxOffset === 1) continue;
            const titleChildren = Array.from(title.getChildren());
            titleChildren.shift();
            for (const titleChild of titleChildren){
                writer.move(writer.createRangeOn(titleChild), title, "after");
                writer.rename(titleChild, "paragraph");
            }
            changed = true;
        }
        return changed;
    }
    /**
	* Model post-fixer callback that creates a title element when it is missing,
	* takes care of the correct position of it and removes additional title elements.
	*/ _fixTitleElement(writer) {
        let changed = false;
        const model = this.editor.model;
        for (const modelRoot of this.editor.model.document.getRoots()){
            if (!model.schema.checkChild(modelRoot, "title")) continue;
            const titleElements = Array.from(modelRoot.getChildren()).filter($794b0589489e3c66$var$isTitle);
            const firstTitleElement = titleElements[0];
            const firstRootChild = modelRoot.getChild(0);
            if (firstRootChild.is("element", "title")) {
                if (titleElements.length > 1) {
                    $794b0589489e3c66$var$fixAdditionalTitleElements(titleElements, writer, model);
                    changed = true;
                }
                continue;
            }
            if (!firstTitleElement && !$794b0589489e3c66$var$titleLikeElements.has(firstRootChild.name)) {
                const title = writer.createElement("title");
                writer.insert(title, modelRoot);
                writer.insertElement("title-content", title);
                changed = true;
                continue;
            }
            if ($794b0589489e3c66$var$titleLikeElements.has(firstRootChild.name)) $794b0589489e3c66$var$changeElementToTitle(firstRootChild, writer, model);
            else writer.move(writer.createRangeOn(firstTitleElement), modelRoot, 0);
            $794b0589489e3c66$var$fixAdditionalTitleElements(titleElements, writer, model);
            changed = true;
        }
        return changed;
    }
    /**
	* Model post-fixer callback that adds an empty paragraph at the end of the document
	* when it is needed for the placeholder purposes.
	*/ _fixBodyElement(writer) {
        const schema = this.editor.model.schema;
        let changed = false;
        for (const rootName of this.editor.model.document.getRootNames()){
            const modelRoot = this.editor.model.document.getRoot(rootName);
            if (modelRoot.childCount < 2 && schema.checkChild(modelRoot, "title")) {
                const placeholder = writer.createElement("paragraph");
                writer.insert(placeholder, modelRoot, 1);
                this._bodyPlaceholder.set(rootName, placeholder);
                changed = true;
            }
        }
        return changed;
    }
    /**
	* Model post-fixer callback that removes a paragraph from the end of the document
	* if it was created for the placeholder purposes and is not needed anymore.
	*/ _fixExtraParagraph(writer) {
        let changed = false;
        for (const rootName of this.editor.model.document.getRootNames()){
            const root = this.editor.model.document.getRoot(rootName);
            const placeholder = this._bodyPlaceholder.get(rootName);
            if (!placeholder) continue;
            if ($794b0589489e3c66$var$shouldRemoveLastParagraph(placeholder, root)) {
                this._bodyPlaceholder.delete(rootName);
                writer.remove(placeholder);
                changed = true;
            }
        }
        return changed;
    }
    /**
	* Attaches the `Title` and `Body` placeholders to the title and/or content.
	*/ _attachPlaceholders() {
        const editor = this.editor;
        const t = editor.t;
        const view = editor.editing.view;
        const sourceElement = editor.sourceElement;
        const titlePlaceholder = editor.config.get("title.placeholder") || t("Type your title");
        editor.editing.downcastDispatcher.on("insert:title-content", (evt, data, conversionApi)=>{
            const element = conversionApi.mapper.toViewElement(data.item);
            element.placeholder = titlePlaceholder;
            (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
                view: view,
                element: element,
                keepOnFocus: true
            });
        });
        const bodyViewElements = /* @__PURE__ */ new Map();
        view.document.registerPostFixer((writer)=>{
            let hasChanged = false;
            for (const viewRoot of view.document.roots){
                if (viewRoot.isEmpty) continue;
                const modelRoot = editor.editing.mapper.toModelElement(viewRoot);
                if (!editor.model.schema.checkChild(modelRoot, "title")) continue;
                const body = viewRoot.getChild(1);
                const oldBody = bodyViewElements.get(viewRoot.rootName);
                if (body !== oldBody) {
                    if (oldBody) {
                        (0, $b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36)(writer, oldBody);
                        writer.removeAttribute("data-placeholder", oldBody);
                    }
                    const bodyPlaceholder = editor.config.get("roots")[viewRoot.rootName]?.placeholder || $794b0589489e3c66$var$isTextArea(sourceElement) && sourceElement.getAttribute("placeholder") || t("Type or paste your content here.");
                    writer.setAttribute("data-placeholder", bodyPlaceholder, body);
                    bodyViewElements.set(viewRoot.rootName, body);
                    hasChanged = true;
                }
                if ((0, $b9b9f2bdf9c6137f$export$41f5caf1b5456035)(body, true) && viewRoot.childCount === 2 && body.name === "p") hasChanged = (0, $b9b9f2bdf9c6137f$export$8c7c5b4ed6e42344)(writer, body) ? true : hasChanged;
                else hasChanged = (0, $b9b9f2bdf9c6137f$export$cebe7eb5bd55fb36)(writer, body) ? true : hasChanged;
            }
            return hasChanged;
        });
    }
    /**
	* Creates navigation between the title and body sections using <kbd>Tab</kbd> and <kbd>Shift</kbd>+<kbd>Tab</kbd> keys.
	*/ _attachTabPressHandling() {
        const editor = this.editor;
        const model = editor.model;
        editor.keystrokes.set("TAB", (data, cancel)=>{
            model.change((writer)=>{
                const selection = model.document.selection;
                const selectedElements = Array.from(selection.getSelectedBlocks());
                if (selectedElements.length === 1 && selectedElements[0].is("element", "title-content")) {
                    const firstBodyElement = selection.getFirstPosition().root.getChild(1);
                    writer.setSelection(firstBodyElement, 0);
                    cancel();
                }
            });
        });
        editor.keystrokes.set("SHIFT + TAB", (data, cancel)=>{
            model.change((writer)=>{
                const selection = model.document.selection;
                if (!selection.isCollapsed) return;
                const selectedElement = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
                const selectionPosition = selection.getFirstPosition();
                const root = editor.model.document.getRoot(selectionPosition.root.rootName);
                if (!model.schema.checkChild(root, "title")) return;
                const title = root.getChild(0);
                if (selectedElement === root.getChild(1) && selectionPosition.isAtStart) {
                    writer.setSelection(title.getChild(0), 0);
                    cancel();
                }
            });
        });
    }
};
/**
* A view-to-model converter for the h1 that appears at the beginning of the document (a title element).
*
* Matches only the synthetic upcast parent named `$root` (the default generic root element). Title is not supported
* for roots whose `modelElement` is customized, so this converter intentionally does not fire on them.
*
* @see module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element
* @param evt An object containing information about the fired event.
* @param data An object containing conversion input, a placeholder for conversion output and possibly other values.
* @param conversionApi Conversion interface to be used by the callback.
*/ function $794b0589489e3c66$var$dataViewModelH1Insertion(evt, data, conversionApi) {
    const modelCursor = data.modelCursor;
    const viewItem = data.viewItem;
    if (!modelCursor.isAtStart || !modelCursor.parent.is("element", "$root")) return;
    if (!conversionApi.consumable.consume(viewItem, {
        name: true
    })) return;
    const modelWriter = conversionApi.writer;
    const title = modelWriter.createElement("title");
    const titleContent = modelWriter.createElement("title-content");
    modelWriter.append(titleContent, title);
    modelWriter.insert(title, modelCursor);
    conversionApi.convertChildren(viewItem, titleContent);
    conversionApi.updateConversionResult(title, data);
}
/**
* Maps position from the beginning of the model `title` element to the beginning of the view `h1` element.
*
* ```html
* <title>^<title-content>Foo</title-content></title> -> <h1>^Foo</h1>
* ```
*/ function $794b0589489e3c66$var$mapModelPositionToView(editingView) {
    return (evt, data)=>{
        const positionParent = data.modelPosition.parent;
        if (!positionParent.is("element", "title")) return;
        const modelTitleElement = positionParent.parent;
        const viewElement = data.mapper.toViewElement(modelTitleElement);
        data.viewPosition = editingView.createPositionAt(viewElement, 0);
        evt.stop();
    };
}
/**
* @returns Returns true when given element is a title. Returns false otherwise.
*/ function $794b0589489e3c66$var$isTitle(element) {
    return element.is("element", "title");
}
/**
* Changes the given element to the title element.
*/ function $794b0589489e3c66$var$changeElementToTitle(element, writer, model) {
    const title = writer.createElement("title");
    writer.insert(title, element, "before");
    writer.insert(element, title, 0);
    writer.rename(element, "title-content");
    model.schema.removeDisallowedAttributes([
        element
    ], writer);
}
/**
* Loops over the list of title elements and fixes additional ones.
*
* @returns Returns true when there was any change. Returns false otherwise.
*/ function $794b0589489e3c66$var$fixAdditionalTitleElements(titleElements, writer, model) {
    let hasChanged = false;
    for (const title of titleElements)if (title.index !== 0) {
        $794b0589489e3c66$var$fixTitleElement(title, writer, model);
        hasChanged = true;
    }
    return hasChanged;
}
/**
* Changes given title element to a paragraph or removes it when it is empty.
*/ function $794b0589489e3c66$var$fixTitleElement(title, writer, model) {
    const child = title.getChild(0);
    if (child.isEmpty) {
        writer.remove(title);
        return;
    }
    writer.move(writer.createRangeOn(child), title, "before");
    writer.rename(child, "paragraph");
    writer.remove(title);
    model.schema.removeDisallowedAttributes([
        child
    ], writer);
}
/**
* Returns true when the last paragraph in the document was created only for the placeholder
* purpose and it's not needed anymore. Returns false otherwise.
*/ function $794b0589489e3c66$var$shouldRemoveLastParagraph(placeholder, root) {
    if (!placeholder.is("element", "paragraph") || placeholder.childCount) return false;
    if (root.childCount <= 2 || root.getChild(root.childCount - 1) !== placeholder) return false;
    return true;
}
/**
* Returns true when given element is a DOM textarea.
*/ function $794b0589489e3c66$var$isTextArea(sourceElement) {
    return !!sourceElement && sourceElement.tagName.toLowerCase() === "textarea";
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module highlight/highlightcommand
*/ /**
* The highlight command. It is used by the {@link module:highlight/highlightediting~HighlightEditing highlight feature}
* to apply the text highlighting.
*
* ```ts
* editor.execute( 'highlight', { value: 'greenMarker' } );
* ```
*
* **Note**: Executing the command without a value removes the attribute from the model. If the selection is collapsed
* inside a text with the highlight attribute, the command will remove the attribute from the entire range
* of that text.
*/ var $3b6898961e362311$export$a9f76829c17866b9 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.value = doc.selection.getAttribute("highlight");
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, "highlight");
    }
    /**
	* Executes the command.
	*
	* @param options Options for the executed command.
	* @param options.value The value to apply.
	*
	* @fires execute
	*/ execute(options = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const highlighter = options.value;
        model.change((writer)=>{
            if (selection.isCollapsed) {
                const position = selection.getFirstPosition();
                if (selection.hasAttribute("highlight")) {
                    const isSameHighlight = (value)=>{
                        return value.item.hasAttribute("highlight") && value.item.getAttribute("highlight") === this.value;
                    };
                    const highlightStart = position.getLastMatchingPosition(isSameHighlight, {
                        direction: "backward"
                    });
                    const highlightEnd = position.getLastMatchingPosition(isSameHighlight);
                    const highlightRange = writer.createRange(highlightStart, highlightEnd);
                    if (!highlighter || this.value === highlighter) {
                        if (!position.isEqual(highlightEnd)) writer.removeAttribute("highlight", highlightRange);
                        writer.removeSelectionAttribute("highlight");
                    } else {
                        if (!position.isEqual(highlightEnd)) writer.setAttribute("highlight", highlighter, highlightRange);
                        writer.setSelectionAttribute("highlight", highlighter);
                    }
                } else if (highlighter) writer.setSelectionAttribute("highlight", highlighter);
            } else {
                const ranges = model.schema.getValidRanges(selection.getRanges(), "highlight", {
                    includeEmptyRanges: true
                });
                for (const range of ranges){
                    let itemOrRange = range;
                    let attributeKey = "highlight";
                    if (range.isCollapsed) {
                        itemOrRange = range.start.parent;
                        attributeKey = (0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey("highlight");
                    }
                    if (highlighter) writer.setAttribute(attributeKey, highlighter, itemOrRange);
                    else writer.removeAttribute(attributeKey, itemOrRange);
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module highlight/highlightediting
*/ /**
* The highlight editing feature. It introduces the {@link module:highlight/highlightcommand~HighlightCommand command} and the `highlight`
* attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
* as a `<mark>` element with a `class` attribute (`<mark class="marker-green">...</mark>`) depending
* on the {@link module:highlight/highlightconfig~HighlightConfig configuration}.
*/ var $3b6898961e362311$export$331b23479fec08b0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HighlightEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("highlight", {
            options: [
                {
                    model: "yellowMarker",
                    class: "marker-yellow",
                    title: "Yellow marker",
                    color: "var(--ck-content-highlight-marker-yellow)",
                    type: "marker"
                },
                {
                    model: "greenMarker",
                    class: "marker-green",
                    title: "Green marker",
                    color: "var(--ck-content-highlight-marker-green)",
                    type: "marker"
                },
                {
                    model: "pinkMarker",
                    class: "marker-pink",
                    title: "Pink marker",
                    color: "var(--ck-content-highlight-marker-pink)",
                    type: "marker"
                },
                {
                    model: "blueMarker",
                    class: "marker-blue",
                    title: "Blue marker",
                    color: "var(--ck-content-highlight-marker-blue)",
                    type: "marker"
                },
                {
                    model: "redPen",
                    class: "pen-red",
                    title: "Red pen",
                    color: "var(--ck-content-highlight-pen-red)",
                    type: "pen"
                },
                {
                    model: "greenPen",
                    class: "pen-green",
                    title: "Green pen",
                    color: "var(--ck-content-highlight-pen-green)",
                    type: "pen"
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: "highlight"
        });
        const options = editor.config.get("highlight.options");
        editor.conversion.attributeToElement($3b6898961e362311$var$_buildDefinition(options));
        editor.commands.add("highlight", new $3b6898961e362311$export$a9f76829c17866b9(editor));
    }
};
/**
* Converts the options array to a converter definition.
*
* @param options An array with configured options.
*/ function $3b6898961e362311$var$_buildDefinition(options) {
    const definition = {
        model: {
            key: "highlight",
            values: []
        },
        view: {}
    };
    for (const option of options){
        definition.model.values.push(option.model);
        definition.view[option.model] = {
            name: "mark",
            classes: option.class
        };
    }
    return definition;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module highlight/highlightui
*/ /**
* The default highlight UI plugin. It introduces:
*
* * The `'highlight'` dropdown,
* * The `'removeHighlight'` and `'highlight:*'` buttons.
*
* The default configuration includes the following buttons:
*
* * `'highlight:yellowMarker'`
* * `'highlight:greenMarker'`
* * `'highlight:pinkMarker'`
* * `'highlight:blueMarker'`
* * `'highlight:redPen'`
* * `'highlight:greenPen'`
*
* See the {@link module:highlight/highlightconfig~HighlightConfig#options configuration} to learn more
* about the defaults.
*/ var $3b6898961e362311$export$8ac6c6b9caf8c915 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Returns the localized option titles provided by the plugin.
	*
	* The following localized titles corresponding with default
	* {@link module:highlight/highlightconfig~HighlightConfig#options} are available:
	*
	* * `'Yellow marker'`,
	* * `'Green marker'`,
	* * `'Pink marker'`,
	* * `'Blue marker'`,
	* * `'Red pen'`,
	* * `'Green pen'`.
	*/ get localizedOptionTitles() {
        const t = this.editor.t;
        return {
            "Yellow marker": t("Yellow marker"),
            "Green marker": t("Green marker"),
            "Pink marker": t("Pink marker"),
            "Blue marker": t("Blue marker"),
            "Red pen": t("Red pen"),
            "Green pen": t("Green pen")
        };
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HighlightUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const options = this.editor.config.get("highlight.options");
        for (const option of options)this._addHighlighterButton(option);
        this._addRemoveHighlightButton();
        this._addDropdown(options);
        this._addMenuBarButton(options);
    }
    /**
	* Creates the "Remove highlight" button.
	*/ _addRemoveHighlightButton() {
        const t = this.editor.t;
        const command = this.editor.commands.get("highlight");
        this._addButton("removeHighlight", t("Remove highlight"), (0, $e8dc502aba5ac3f5$export$6ce1521e49717004), null, (button)=>{
            button.bind("isEnabled").to(command, "isEnabled");
        });
    }
    /**
	* Creates a toolbar button from the provided highlight option.
	*/ _addHighlighterButton(option) {
        const command = this.editor.commands.get("highlight");
        this._addButton("highlight:" + option.model, option.title, $3b6898961e362311$var$getIconForType(option.type), option.model, decorateHighlightButton);
        function decorateHighlightButton(button) {
            button.bind("isEnabled").to(command, "isEnabled");
            button.bind("isOn").to(command, "value", (value)=>value === option.model);
            button.iconView.fillColor = option.color;
            button.isToggleable = true;
        }
    }
    /**
	* Internal method for creating highlight buttons.
	*
	* @param name The name of the button.
	* @param label The label for the button.
	* @param icon The button icon.
	* @param value The `value` property passed to the executed command.
	* @param decorateButton A callback getting ButtonView instance so that it can be further customized.
	*/ _addButton(name, label, icon, value, decorateButton) {
        const editor = this.editor;
        editor.ui.componentFactory.add(name, (locale)=>{
            const buttonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const localized = this.localizedOptionTitles[label] ? this.localizedOptionTitles[label] : label;
            buttonView.set({
                label: localized,
                icon: icon,
                tooltip: true
            });
            buttonView.on("execute", ()=>{
                editor.execute("highlight", {
                    value: value
                });
                editor.editing.view.focus();
            });
            decorateButton(buttonView);
            return buttonView;
        });
    }
    /**
	* Creates the split button dropdown UI from the provided highlight options.
	*/ _addDropdown(options) {
        const editor = this.editor;
        const t = editor.t;
        const componentFactory = editor.ui.componentFactory;
        const startingHighlighter = options[0];
        const optionsMap = options.reduce((retVal, option)=>{
            retVal[option.model] = option;
            return retVal;
        }, {});
        componentFactory.add("highlight", (locale)=>{
            const command = editor.commands.get("highlight");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
            const splitButtonView = dropdownView.buttonView;
            splitButtonView.set({
                label: t("Highlight"),
                tooltip: true,
                lastExecuted: startingHighlighter.model,
                commandValue: startingHighlighter.model,
                isToggleable: true
            });
            splitButtonView.bind("icon").to(command, "value", (value)=>$3b6898961e362311$var$getIconForType(getActiveOption(value, "type")));
            splitButtonView.bind("color").to(command, "value", (value)=>getActiveOption(value, "color"));
            splitButtonView.bind("commandValue").to(command, "value", (value)=>getActiveOption(value, "model"));
            splitButtonView.bind("isOn").to(command, "value", (value)=>!!value);
            splitButtonView.delegate("execute").to(dropdownView);
            const buttonsCreator = ()=>{
                const buttons = options.map((option)=>{
                    const buttonView = componentFactory.create("highlight:" + option.model);
                    this.listenTo(buttonView, "execute", ()=>{
                        dropdownView.buttonView.set({
                            lastExecuted: option.model
                        });
                    });
                    return buttonView;
                });
                buttons.push(new (0, $29fd27cb9bdab9d2$export$1b338a24f9f00519)());
                buttons.push(componentFactory.create("removeHighlight"));
                return buttons;
            };
            dropdownView.bind("isEnabled").to(command, "isEnabled");
            (0, $29fd27cb9bdab9d2$export$c39319333c19bdd7)(dropdownView, buttonsCreator, {
                enableActiveItemFocusOnDropdownOpen: true,
                ariaLabel: t("Text highlight toolbar")
            });
            $3b6898961e362311$var$bindToolbarIconStyleToActiveColor(dropdownView);
            splitButtonView.on("execute", ()=>{
                editor.execute("highlight", {
                    value: splitButtonView.commandValue
                });
            });
            this.listenTo(dropdownView, "execute", ()=>{
                editor.editing.view.focus();
            });
            /**
			* Returns active highlighter option depending on current command value.
			* If current is not set or it is the same as last execute this method will return the option key (like icon or color)
			* of last executed highlighter. Otherwise it will return option key for current one.
			*/ function getActiveOption(current, key) {
                const whichHighlighter = !current || current === splitButtonView.lastExecuted ? splitButtonView.lastExecuted : current;
                return optionsMap[whichHighlighter][key];
            }
            return dropdownView;
        });
    }
    /**
	* Creates the menu bar button for highlight including submenu with available options.
	*/ _addMenuBarButton(options) {
        const editor = this.editor;
        const t = editor.t;
        const command = editor.commands.get("highlight");
        editor.ui.componentFactory.add("menuBar:highlight", (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                label: t("Highlight"),
                icon: $3b6898961e362311$var$getIconForType("marker")
            });
            menuView.bind("isEnabled").to(command);
            menuView.buttonView.iconView.fillColor = "transparent";
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            for (const option of options){
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.set({
                    label: option.title,
                    icon: $3b6898961e362311$var$getIconForType(option.type),
                    role: "menuitemradio",
                    isToggleable: true
                });
                buttonView.iconView.fillColor = option.color;
                buttonView.delegate("execute").to(menuView);
                buttonView.bind("isOn").to(command, "value", (value)=>value === option.model);
                buttonView.on("execute", ()=>{
                    editor.execute("highlight", {
                        value: option.model
                    });
                    editor.editing.view.focus();
                });
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            listView.items.add(new (0, $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0)(locale));
            const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
            const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
            buttonView.set({
                label: t("Remove highlight"),
                icon: (0, $e8dc502aba5ac3f5$export$6ce1521e49717004)
            });
            buttonView.delegate("execute").to(menuView);
            buttonView.on("execute", ()=>{
                editor.execute("highlight", {
                    value: null
                });
                editor.editing.view.focus();
            });
            listItemView.children.add(buttonView);
            listView.items.add(listItemView);
            menuView.panelView.children.add(listView);
            return menuView;
        });
    }
};
/**
* Extends split button icon style to reflect last used button style.
*/ function $3b6898961e362311$var$bindToolbarIconStyleToActiveColor(dropdownView) {
    dropdownView.buttonView.actionView.iconView.bind("fillColor").to(dropdownView.buttonView, "color");
}
/**
* Returns icon for given highlighter type.
*/ function $3b6898961e362311$var$getIconForType(type) {
    return type === "marker" ? (0, $e8dc502aba5ac3f5$export$e3e30194a664a060) : (0, $e8dc502aba5ac3f5$export$738188e7152fb4f8);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module highlight/highlight
*/ /**
* The highlight plugin.
*
* For a detailed overview, check the {@glink features/highlight Highlight feature} documentation.
*
* This is a "glue" plugin which loads the {@link module:highlight/highlightediting~HighlightEditing} and
* {@link module:highlight/highlightui~HighlightUI} plugins.
*/ var $3b6898961e362311$export$39dbc3f558091353 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $3b6898961e362311$export$331b23479fec08b0,
            $3b6898961e362311$export$8ac6c6b9caf8c915
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Highlight";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The horizontal line command.
*
* The command is registered by {@link module:horizontal-line/horizontallineediting~HorizontalLineEditing} as `'horizontalLine'`.
*
* To insert a horizontal line at the current selection, execute the command:
*
* ```ts
* editor.execute( 'horizontalLine' );
* ```
*/ var $f033989b7dde230e$export$f4157d08c68a1180 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        this.isEnabled = $f033989b7dde230e$var$isHorizontalLineAllowedInParent(selection, schema, model);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        model.change((writer)=>{
            const horizontalElement = writer.createElement("horizontalLine");
            model.insertObject(horizontalElement, null, null, {
                setSelection: "after"
            });
        });
    }
};
/**
* Checks if a horizontal line is allowed by the schema in the optimal insertion parent.
*
* @param model Model instance.
*/ function $f033989b7dde230e$var$isHorizontalLineAllowedInParent(selection, schema, model) {
    const parent = $f033989b7dde230e$var$getInsertHorizontalLineParent(selection, model);
    return schema.checkChild(parent, "horizontalLine");
}
/**
* Returns a node that will be used to insert a horizontal line with `model.insertContent` to check if the horizontal line can be
* placed there.
*
* @param model Model instance.
*/ function $f033989b7dde230e$var$getInsertHorizontalLineParent(selection, model) {
    const parent = (0, $5547ab21e02f1e9e$export$d03cbafb1cb45bb)(selection, model).start.parent;
    if (parent.isEmpty && !parent.is("rootElement")) return parent.parent;
    return parent;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module horizontal-line/horizontallineediting
*/ /**
* The horizontal line editing feature.
*/ var $f033989b7dde230e$export$4bee524030652408 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HorizontalLineEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const t = editor.t;
        const conversion = editor.conversion;
        schema.register("horizontalLine", {
            inheritAllFrom: "$blockObject"
        });
        conversion.for("dataDowncast").elementToElement({
            model: "horizontalLine",
            view: (modelElement, { writer: writer })=>{
                return writer.createEmptyElement("hr");
            }
        });
        conversion.for("editingDowncast").elementToStructure({
            model: "horizontalLine",
            view: (modelElement, { writer: writer })=>{
                const label = t("Horizontal line");
                const viewWrapper = writer.createContainerElement("div", null, writer.createEmptyElement("hr"));
                writer.addClass("ck-horizontal-line", viewWrapper);
                writer.setCustomProperty("hr", true, viewWrapper);
                return $f033989b7dde230e$var$toHorizontalLineWidget(viewWrapper, writer, label);
            }
        });
        conversion.for("upcast").elementToElement({
            view: "hr",
            model: "horizontalLine"
        });
        editor.commands.add("horizontalLine", new $f033989b7dde230e$export$f4157d08c68a1180(editor));
    }
};
/**
* Converts a given {@link module:engine/view/element~ViewElement} to a horizontal line widget:
* * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property} allowing to
*   recognize the horizontal line widget element.
* * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
*
* @param writer An instance of the view writer.
*/ function $f033989b7dde230e$var$toHorizontalLineWidget(viewElement, writer, label) {
    writer.setCustomProperty("horizontalLine", true, viewElement);
    return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer, {
        label: label
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module horizontal-line/horizontallineui
*/ /**
* The horizontal line UI plugin.
*/ var $f033989b7dde230e$export$c1ef6f53b5f30855 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HorizontalLineUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("horizontalLine", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:horizontalLine", ()=>{
            return this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
    }
    /**
	* Creates a button for horizontal line command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("horizontalLine");
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Horizontal line"),
            icon: (0, $e8dc502aba5ac3f5$export$b03f1fdb262e3614)
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute("horizontalLine");
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module horizontal-line/horizontalline
*/ /**
* The horizontal line feature.
*
* It provides the possibility to insert a horizontal line into the rich-text editor.
*
* For a detailed overview, check the {@glink features/horizontal-line Horizontal line feature} documentation.
*/ var $f033989b7dde230e$export$a7746b673cb91227 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f033989b7dde230e$export$4bee524030652408,
            $f033989b7dde230e$export$c1ef6f53b5f30855,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HorizontalLine";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The insert HTML embed element command.
*
* The command is registered by {@link module:html-embed/htmlembedediting~HtmlEmbedEditing} as `'htmlEmbed'`.
*
* To insert an empty HTML embed element at the current selection, execute the command:
*
* ```ts
* editor.execute( 'htmlEmbed' );
* ```
*
* You can specify the initial content of a new HTML embed in the argument:
*
* ```ts
* editor.execute( 'htmlEmbed', '<b>Initial content.</b>' );
* ```
*
* To update the content of the HTML embed, select it in the model and pass the content in the argument:
*
* ```ts
* editor.execute( 'htmlEmbed', '<b>New content of an existing embed.</b>' );
* ```
*/ var $87246941c19d7df4$export$92f7fac1b3899006 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const selectedRawHtmlElement = $87246941c19d7df4$var$getSelectedRawHtmlModelWidget(selection);
        this.isEnabled = $87246941c19d7df4$var$isHtmlEmbedAllowedInParent(selection, schema, model);
        this.value = selectedRawHtmlElement ? selectedRawHtmlElement.getAttribute("value") || "" : null;
    }
    /**
	* Executes the command, which either:
	*
	* * creates and inserts a new HTML embed element if none was selected,
	* * updates the content of the HTML embed if one was selected.
	*
	* @fires execute
	* @param value When passed, the value (content) will be set on a new embed or a selected one.
	*/ execute(value) {
        const model = this.editor.model;
        const selection = model.document.selection;
        model.change((writer)=>{
            let htmlEmbedElement;
            if (this.value !== null) htmlEmbedElement = $87246941c19d7df4$var$getSelectedRawHtmlModelWidget(selection);
            else {
                htmlEmbedElement = writer.createElement("rawHtml");
                model.insertObject(htmlEmbedElement, null, null, {
                    setSelection: "on"
                });
            }
            writer.setAttribute("value", value, htmlEmbedElement);
        });
    }
};
/**
* Checks if an HTML embed is allowed by the schema in the optimal insertion parent.
*/ function $87246941c19d7df4$var$isHtmlEmbedAllowedInParent(selection, schema, model) {
    const parent = $87246941c19d7df4$var$getInsertHtmlEmbedParent(selection, model);
    return schema.checkChild(parent, "rawHtml");
}
/**
* Returns a node that will be used to insert a html embed with `model.insertContent` to check if a html embed element can be placed there.
*/ function $87246941c19d7df4$var$getInsertHtmlEmbedParent(selection, model) {
    const parent = (0, $5547ab21e02f1e9e$export$d03cbafb1cb45bb)(selection, model).start.parent;
    if (parent.isEmpty && !parent.is("rootElement")) return parent.parent;
    return parent;
}
/**
* Returns the selected HTML embed element in the model, if any.
*/ function $87246941c19d7df4$var$getSelectedRawHtmlModelWidget(selection) {
    const selectedElement = selection.getSelectedElement();
    if (selectedElement && selectedElement.is("element", "rawHtml")) return selectedElement;
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-embed/htmlembedediting
*/ /**
* The HTML embed editing feature.
*/ var $87246941c19d7df4$export$f3dbd0efcd88a96 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Keeps references to {@link module:ui/button/buttonview~ButtonView edit, save, and cancel} button instances created for
	* each widget so they can be destroyed if they are no longer in DOM after the editing view was re-rendered.
	*/ _widgetButtonViewReferences = /* @__PURE__ */ new Set();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HtmlEmbedEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "HE";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("htmlEmbed", {
            showPreviews: false,
            sanitizeHtml: (rawHtml)=>{
                /**
				* When using the HTML embed feature with the `config.htmlEmbed.showPreviews` set to `true`, it is strongly recommended to
				* define a sanitize function that will clean up the input HTML in order to avoid XSS vulnerability.
				*
				* For a detailed overview, check the {@glink features/html/html-embed HTML embed feature} documentation.
				*
				* @error html-embed-provide-sanitize-function
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("html-embed-provide-sanitize-function");
                return {
                    html: rawHtml,
                    hasChanged: false
                };
            }
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.register("rawHtml", {
            inheritAllFrom: "$blockObject",
            allowAttributes: [
                "value"
            ]
        });
        editor.commands.add("htmlEmbed", new $87246941c19d7df4$export$92f7fac1b3899006(editor));
        this._setupConversion();
    }
    /**
	* Prepares converters for the feature.
	*/ _setupConversion() {
        const editor = this.editor;
        const t = editor.t;
        const view = editor.editing.view;
        const widgetButtonViewReferences = this._widgetButtonViewReferences;
        const htmlEmbedConfig = editor.config.get("htmlEmbed");
        this.editor.editing.view.on("render", ()=>{
            for (const buttonView of widgetButtonViewReferences){
                if (buttonView.element && buttonView.element.isConnected) return;
                buttonView.destroy();
                widgetButtonViewReferences.delete(buttonView);
            }
        }, {
            priority: "lowest"
        });
        editor.data.registerRawContentMatcher({
            name: "div",
            classes: "raw-html-embed"
        });
        editor.conversion.for("upcast").elementToElement({
            view: {
                name: "div",
                classes: "raw-html-embed"
            },
            model: (viewElement, { writer: writer })=>{
                return writer.createElement("rawHtml", {
                    value: viewElement.getCustomProperty("$rawContent")
                });
            }
        });
        editor.conversion.for("dataDowncast").elementToElement({
            model: "rawHtml",
            view: (modelElement, { writer: writer })=>{
                return writer.createRawElement("div", {
                    class: "raw-html-embed"
                }, function(domElement) {
                    domElement.innerHTML = (0, $c7bc2cb7e2db0227$export$defce004797fe3da)(modelElement.getAttribute("value") || "");
                });
            }
        });
        editor.conversion.for("editingDowncast").elementToStructure({
            model: {
                name: "rawHtml",
                attributes: [
                    "value"
                ]
            },
            view: (modelElement, { writer: writer })=>{
                let domContentWrapper;
                let state;
                let props;
                const viewContentWrapper = writer.createRawElement("div", {
                    class: "raw-html-embed__content-wrapper"
                }, function(domElement) {
                    domContentWrapper = domElement;
                    renderContent({
                        editor: editor,
                        domElement: domElement,
                        state: state,
                        props: props
                    });
                    domContentWrapper.addEventListener("mousedown", ()=>{
                        if (state.isEditable) {
                            const model = editor.model;
                            if (model.document.selection.getSelectedElement() !== modelElement) model.change((writer)=>writer.setSelection(modelElement, "on"));
                        }
                    }, true);
                });
                const rawHtmlApi = {
                    makeEditable () {
                        state = Object.assign({}, state, {
                            isEditable: true
                        });
                        renderContent({
                            domElement: domContentWrapper,
                            editor: editor,
                            state: state,
                            props: props
                        });
                        view.change((writer)=>{
                            writer.setAttribute("data-cke-ignore-events", "true", viewContentWrapper);
                        });
                        domContentWrapper.querySelector("textarea").focus();
                    },
                    save (newValue) {
                        if (newValue !== state.getRawHtmlValue()) {
                            editor.execute("htmlEmbed", newValue);
                            editor.editing.view.focus();
                        } else this.cancel();
                    },
                    cancel () {
                        state = Object.assign({}, state, {
                            isEditable: false
                        });
                        renderContent({
                            domElement: domContentWrapper,
                            editor: editor,
                            state: state,
                            props: props
                        });
                        editor.editing.view.focus();
                        view.change((writer)=>{
                            writer.removeAttribute("data-cke-ignore-events", viewContentWrapper);
                        });
                    }
                };
                state = {
                    showPreviews: htmlEmbedConfig.showPreviews,
                    isEditable: false,
                    getRawHtmlValue: ()=>modelElement.getAttribute("value") || ""
                };
                props = {
                    sanitizeHtml: htmlEmbedConfig.sanitizeHtml,
                    textareaPlaceholder: t("Paste raw HTML here..."),
                    onEditClick () {
                        rawHtmlApi.makeEditable();
                    },
                    onSaveClick (newValue) {
                        rawHtmlApi.save(newValue);
                    },
                    onCancelClick () {
                        rawHtmlApi.cancel();
                    }
                };
                const viewContainer = writer.createContainerElement("div", {
                    class: "raw-html-embed",
                    "data-html-embed-label": t("HTML snippet"),
                    dir: editor.locale.uiLanguageDirection
                }, viewContentWrapper);
                writer.setCustomProperty("rawHtmlApi", rawHtmlApi, viewContainer);
                writer.setCustomProperty("rawHtml", true, viewContainer);
                return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewContainer, writer, {
                    label: t("HTML snippet"),
                    hasSelectionHandle: true
                });
            }
        });
        function renderContent({ editor: editor, domElement: domElement, state: state, props: props }) {
            domElement.textContent = "";
            const domDocument = domElement.ownerDocument;
            let domTextarea;
            if (state.isEditable) {
                domTextarea = createDomTextarea({
                    domDocument: domDocument,
                    state: state,
                    props: {
                        isDisabled: false,
                        placeholder: props.textareaPlaceholder
                    }
                });
                domElement.append(domTextarea);
            } else if (state.showPreviews) {
                const previewContainerProps = {
                    sanitizeHtml: props.sanitizeHtml
                };
                domElement.append(createPreviewContainer({
                    domDocument: domDocument,
                    state: state,
                    props: previewContainerProps,
                    editor: editor
                }));
            } else {
                const textareaProps = {
                    isDisabled: true,
                    placeholder: props.textareaPlaceholder
                };
                domElement.append(createDomTextarea({
                    domDocument: domDocument,
                    state: state,
                    props: textareaProps
                }));
            }
            const buttonsWrapperProps = {
                onEditClick: props.onEditClick,
                onSaveClick: ()=>{
                    props.onSaveClick(domTextarea.value);
                },
                onCancelClick: props.onCancelClick
            };
            domElement.prepend(createDomButtonsWrapper({
                editor: editor,
                domDocument: domDocument,
                state: state,
                props: buttonsWrapperProps
            }));
        }
        function createDomButtonsWrapper({ editor: editor, domDocument: domDocument, state: state, props: props }) {
            const domButtonsWrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domDocument, "div", {
                class: "raw-html-embed__buttons-wrapper"
            });
            if (state.isEditable) {
                const saveButtonView = $87246941c19d7df4$var$createUIButton(editor, "save", props.onSaveClick);
                const cancelButtonView = $87246941c19d7df4$var$createUIButton(editor, "cancel", props.onCancelClick);
                domButtonsWrapper.append(saveButtonView.element, cancelButtonView.element);
                widgetButtonViewReferences.add(saveButtonView).add(cancelButtonView);
            } else {
                const editButtonView = $87246941c19d7df4$var$createUIButton(editor, "edit", props.onEditClick);
                domButtonsWrapper.append(editButtonView.element);
                widgetButtonViewReferences.add(editButtonView);
            }
            return domButtonsWrapper;
        }
        function createDomTextarea({ domDocument: domDocument, state: state, props: props }) {
            const domTextarea = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domDocument, "textarea", {
                placeholder: props.placeholder,
                class: "ck ck-reset ck-input ck-input-text raw-html-embed__source"
            });
            domTextarea.disabled = props.isDisabled;
            domTextarea.value = state.getRawHtmlValue();
            return domTextarea;
        }
        function createPreviewContainer({ editor: editor, domDocument: domDocument, state: state, props: props }) {
            const sanitizedOutput = props.sanitizeHtml(state.getRawHtmlValue());
            const placeholderText = state.getRawHtmlValue().length > 0 ? t("No preview available") : t("Empty snippet content");
            const domPreviewPlaceholder = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domDocument, "div", {
                class: "ck ck-reset_all raw-html-embed__preview-placeholder"
            }, placeholderText);
            const domPreviewContent = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domDocument, "div", {
                class: "raw-html-embed__preview-content",
                dir: editor.locale.contentLanguageDirection
            });
            const domDocumentFragment = domDocument.createRange().createContextualFragment((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(sanitizedOutput.html));
            domPreviewContent.appendChild(domDocumentFragment);
            return (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domDocument, "div", {
                class: "raw-html-embed__preview"
            }, [
                domPreviewPlaceholder,
                domPreviewContent
            ]);
        }
    }
};
/**
* Returns a UI button view that can be used in conversion.
*/ function $87246941c19d7df4$var$createUIButton(editor, type, onClick) {
    const { t: t } = editor.locale;
    const buttonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(editor.locale);
    const command = editor.commands.get("htmlEmbed");
    buttonView.set({
        class: `raw-html-embed__${type}-button`,
        icon: (0, $e8dc502aba5ac3f5$export$20da9dff06d8cce3),
        tooltip: true,
        tooltipPosition: editor.locale.uiLanguageDirection === "rtl" ? "e" : "w"
    });
    buttonView.render();
    if (type === "edit") {
        buttonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$20da9dff06d8cce3),
            label: t("Edit source")
        });
        buttonView.bind("isEnabled").to(command);
    } else if (type === "save") {
        buttonView.set({
            icon: (0, $e8dc502aba5ac3f5$export$41713cd023818a26),
            label: t("Save changes")
        });
        buttonView.bind("isEnabled").to(command);
    } else buttonView.set({
        icon: (0, $e8dc502aba5ac3f5$export$6102dea6073ecfc0),
        label: t("Cancel")
    });
    buttonView.on("execute", onClick);
    return buttonView;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-embed/htmlembedui
*/ /**
* The HTML embed UI plugin.
*/ var $87246941c19d7df4$export$885325241b70517c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HtmlEmbedUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.locale.t;
        editor.ui.componentFactory.add("htmlEmbed", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true,
                label: t("Insert HTML")
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:htmlEmbed", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
            buttonView.set({
                label: t("HTML snippet")
            });
            return buttonView;
        });
    }
    /**
	* Creates a button for html embed command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const command = editor.commands.get("htmlEmbed");
        const view = new ButtonClass(editor.locale);
        view.set({
            icon: (0, $e8dc502aba5ac3f5$export$32881376bf9e1b12)
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute("htmlEmbed");
            editor.editing.view.focus();
            editor.editing.view.document.selection.getSelectedElement().getCustomProperty("rawHtmlApi").makeEditable();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-embed/htmlembed
*/ /**
* The HTML embed feature.
*
* It allows inserting HTML snippets directly into the editor.
*
* For a detailed overview, check the {@glink features/html/html-embed HTML embed feature} documentation.
*/ var $87246941c19d7df4$export$58544e612b6e2f80 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $87246941c19d7df4$export$f3dbd0efcd88a96,
            $87246941c19d7df4$export$885325241b70517c,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HtmlEmbed";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



//#region src/string/deburr.ts
const $14eb309cebb6626d$var$deburrMap = new Map([
    [
        "\xc6",
        "Ae"
    ],
    [
        "\xd0",
        "D"
    ],
    [
        "\xd8",
        "O"
    ],
    [
        "\xde",
        "Th"
    ],
    [
        "\xdf",
        "ss"
    ],
    [
        "\xe6",
        "ae"
    ],
    [
        "\xf0",
        "d"
    ],
    [
        "\xf8",
        "o"
    ],
    [
        "\xfe",
        "th"
    ],
    [
        "\u0110",
        "D"
    ],
    [
        "\u0111",
        "d"
    ],
    [
        "\u0126",
        "H"
    ],
    [
        "\u0127",
        "h"
    ],
    [
        "\u0131",
        "i"
    ],
    [
        "\u0132",
        "IJ"
    ],
    [
        "\u0133",
        "ij"
    ],
    [
        "\u0138",
        "k"
    ],
    [
        "\u013F",
        "L"
    ],
    [
        "\u0140",
        "l"
    ],
    [
        "\u0141",
        "L"
    ],
    [
        "\u0142",
        "l"
    ],
    [
        "\u0149",
        "'n"
    ],
    [
        "\u014A",
        "N"
    ],
    [
        "\u014B",
        "n"
    ],
    [
        "\u0152",
        "Oe"
    ],
    [
        "\u0153",
        "oe"
    ],
    [
        "\u0166",
        "T"
    ],
    [
        "\u0167",
        "t"
    ],
    [
        "\u017F",
        "s"
    ]
]);
/**
* Converts a string by replacing special characters and diacritical marks with their ASCII equivalents.
* For example, "Crème brûlée" becomes "Creme brulee".
*
* @param str - The input string to be deburred.
* @returns The deburred string with special characters replaced by their ASCII equivalents.
*
* @example
* // Basic usage:
* deburr('Æthelred') // returns 'Aethelred'
*
* @example
* // Handling diacritical marks:
* deburr('München') // returns 'Munchen'
*
* @example
* // Special characters:
* deburr('Crème brûlée') // returns 'Creme brulee'
*/ function $14eb309cebb6626d$export$287ac32fb11582f5(str) {
    str = str.normalize("NFD");
    let result = "";
    for(let i = 0; i < str.length; i++){
        const char = str[i];
        if (char >= "\u0300" && char <= "\u036F" || char >= "\u20D0" && char <= "\u20FF" || char >= "\uFE20" && char <= "\uFE2F") continue;
        result += $14eb309cebb6626d$var$deburrMap.get(char) ?? char;
    }
    return result;
}



//#region src/compat/string/deburr.ts
/**
* Converts a string by replacing special characters and diacritical marks with their ASCII equivalents.
* For example, "Crème brûlée" becomes "Creme brulee".
*
* @param str - The input string to be deburred.
* @returns The deburred string with special characters replaced by their ASCII equivalents.
*
* @example
* // Basic usage:
* deburr('Æthelred') // returns 'Aethelred'
*
* @example
* // Handling diacritical marks:
* deburr('München') // returns 'Munchen'
*
* @example
* // Special characters:
* deburr('Crème brûlée') // returns 'Creme brulee'
*/ function $43df74f2226ae468$export$287ac32fb11582f5(str) {
    return (0, $14eb309cebb6626d$export$287ac32fb11582f5)((0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(str));
}



//#region src/compat/string/words.ts
const $8cfc2a7fd6a6ffe5$var$rNonCharLatin = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\xd7\\xf7";
const $8cfc2a7fd6a6ffe5$var$rUnicodeUpper = "\\p{Lu}";
const $8cfc2a7fd6a6ffe5$var$rUnicodeLower = "\\p{Ll}";
const $8cfc2a7fd6a6ffe5$var$rMisc = "(?:[\\p{Lm}\\p{Lo}]\\p{M}*)";
const $8cfc2a7fd6a6ffe5$var$rNumber = "\\d";
const $8cfc2a7fd6a6ffe5$var$rUnicodeOptContrLower = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?";
const $8cfc2a7fd6a6ffe5$var$rUnicodeOptContrUpper = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?";
const $8cfc2a7fd6a6ffe5$var$rUnicodeBreak = `[\\p{Z}\\p{P}${$8cfc2a7fd6a6ffe5$var$rNonCharLatin}]`;
const $8cfc2a7fd6a6ffe5$var$rUnicodeMiscUpper = `(?:${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}|${$8cfc2a7fd6a6ffe5$var$rMisc})`;
const $8cfc2a7fd6a6ffe5$var$rUnicodeMiscLower = `(?:${$8cfc2a7fd6a6ffe5$var$rUnicodeLower}|${$8cfc2a7fd6a6ffe5$var$rMisc})`;
let $8cfc2a7fd6a6ffe5$var$rUnicodeWord;
function $8cfc2a7fd6a6ffe5$var$getUnicodeWordPattern() {
    if ($8cfc2a7fd6a6ffe5$var$rUnicodeWord == null) $8cfc2a7fd6a6ffe5$var$rUnicodeWord = RegExp([
        `${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}?${$8cfc2a7fd6a6ffe5$var$rUnicodeLower}+${$8cfc2a7fd6a6ffe5$var$rUnicodeOptContrLower}(?=${$8cfc2a7fd6a6ffe5$var$rUnicodeBreak}|${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}|$)`,
        `${$8cfc2a7fd6a6ffe5$var$rUnicodeMiscUpper}+${$8cfc2a7fd6a6ffe5$var$rUnicodeOptContrUpper}(?=${$8cfc2a7fd6a6ffe5$var$rUnicodeBreak}|${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}${$8cfc2a7fd6a6ffe5$var$rUnicodeMiscLower}|$)`,
        `${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}?${$8cfc2a7fd6a6ffe5$var$rUnicodeMiscLower}+${$8cfc2a7fd6a6ffe5$var$rUnicodeOptContrLower}`,
        `${$8cfc2a7fd6a6ffe5$var$rUnicodeUpper}+${$8cfc2a7fd6a6ffe5$var$rUnicodeOptContrUpper}`,
        `${$8cfc2a7fd6a6ffe5$var$rNumber}*(?:1ST|2ND|3RD|(?![123])${$8cfc2a7fd6a6ffe5$var$rNumber}TH)(?=\\b|[a-z_])`,
        `${$8cfc2a7fd6a6ffe5$var$rNumber}*(?:1st|2nd|3rd|(?![123])${$8cfc2a7fd6a6ffe5$var$rNumber}th)(?=\\b|[A-Z_])`,
        `${$8cfc2a7fd6a6ffe5$var$rNumber}+`,
        "\\p{Emoji_Presentation}",
        "\\p{Extended_Pictographic}"
    ].join("|"), "gu");
    return $8cfc2a7fd6a6ffe5$var$rUnicodeWord;
}
/**
* Splits `string` into an array of its words.
*
* @param str - The string or object that is to be split into words.
* @param [pattern] - The pattern to match words.
* @returns Returns the words of `string`.
*
* @example
* const wordsArray1 = words('fred, barney, & pebbles');
* // => ['fred', 'barney', 'pebbles']
*/ function $8cfc2a7fd6a6ffe5$export$cd80a8f028a50810(str, pattern, guard) {
    const input = (0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(str);
    if (guard || pattern === void 0) pattern = $8cfc2a7fd6a6ffe5$var$getUnicodeWordPattern();
    if (typeof pattern === "number") pattern = pattern.toString();
    return Array.from(input.match(pattern) ?? []).filter((x)=>x !== "");
}



//#region src/compat/_internal/normalizeForCase.ts
function $fc6dff58a1e9c11f$export$4c641c2486ea3e39(str) {
    if (typeof str !== "string") str = (0, $a4d3c4fa68340755$export$f84e8e69fd4488a5)(str);
    return str.replace(/['\u2019]/g, "");
}


//#region src/compat/string/startCase.ts
/**
* Converts the first character of each word in a string to uppercase and the remaining characters to lowercase.
*
* Start case is the naming convention in which each word is written with an initial capital letter.
* @param str - The string to convert.
* @returns The converted string.
*
* @example
* const result1 = startCase('hello world');  // result will be 'Hello World'
* const result2 = startCase('HELLO WORLD');  // result will be 'HELLO WORLD'
* const result3 = startCase('hello-world');  // result will be 'Hello World'
* const result4 = startCase('hello_world');  // result will be 'Hello World'
*/ function $b99a820a03b0a14b$export$adfcc6ec7d9b3f5(str) {
    const words$1 = (0, $8cfc2a7fd6a6ffe5$export$cd80a8f028a50810)((0, $fc6dff58a1e9c11f$export$4c641c2486ea3e39)((0, $43df74f2226ae468$export$287ac32fb11582f5)(str)).trim());
    let result = "";
    for(let i = 0; i < words$1.length; i++){
        const word = words$1[i];
        if (result) result += " ";
        if (word === word.toUpperCase()) result += word;
        else result += word[0].toUpperCase() + word.slice(1).toLowerCase();
    }
    return result;
}



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Helper function for the downcast converter. Updates attributes on the given view element.
*
* @param writer The view writer.
* @param oldViewAttributes The previous GHS attribute value.
* @param newViewAttributes The current GHS attribute value.
* @param viewElement The view element to update.
* @internal
*/ function $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(writer, oldViewAttributes, newViewAttributes, viewElement) {
    if (oldViewAttributes) $50e4d8c8f321fe5d$export$d1eac40bc1fbac6d(writer, oldViewAttributes, viewElement);
    if (newViewAttributes) $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, newViewAttributes, viewElement);
}
/**
* Helper function for the downcast converter. Sets attributes on the given view element.
*
* @param writer The view writer.
* @param viewAttributes The GHS attribute value.
* @param viewElement The view element to update.
* @internal
*/ function $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, viewAttributes, viewElement) {
    if (viewAttributes.attributes) for (const [key, value] of Object.entries(viewAttributes.attributes))writer.setAttribute(key, value, viewElement);
    if (viewAttributes.styles) writer.setStyle(viewAttributes.styles, viewElement);
    if (viewAttributes.classes) writer.addClass(viewAttributes.classes, viewElement);
}
/**
* Helper function for the downcast converter. Removes attributes on the given view element.
*
* @param writer The view writer.
* @param viewAttributes The GHS attribute value.
* @param viewElement The view element to update.
* @internal
*/ function $50e4d8c8f321fe5d$export$d1eac40bc1fbac6d(writer, viewAttributes, viewElement) {
    if (viewAttributes.attributes) for (const [key] of Object.entries(viewAttributes.attributes))writer.removeAttribute(key, viewElement);
    if (viewAttributes.styles) for (const style of Object.keys(viewAttributes.styles))writer.removeStyle(style, viewElement);
    if (viewAttributes.classes) writer.removeClass(viewAttributes.classes, viewElement);
}
/**
* Merges view element attribute objects.
*
* @internal
*/ function $50e4d8c8f321fe5d$export$e87137e359a36e2e(target, source) {
    const result = (0, $99832fb02f3659fb$export$629a2bd3f5a49ecc)(target);
    let key = "attributes";
    for(key in source)if (key == "classes") result[key] = Array.from(/* @__PURE__ */ new Set([
        ...target[key] || [],
        ...source[key]
    ]));
    else result[key] = {
        ...target[key],
        ...source[key]
    };
    return result;
}
function $50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, subject, callback) {
    const oldValue = item.getAttribute(ghsAttributeName);
    const newValue = {};
    for (const kind of [
        "attributes",
        "styles",
        "classes"
    ]){
        if (kind != subject) {
            if (oldValue && oldValue[kind]) newValue[kind] = oldValue[kind];
            continue;
        }
        if (subject == "classes") {
            const values = new Set(oldValue && oldValue.classes || []);
            callback(values);
            if (values.size) newValue[kind] = Array.from(values);
            continue;
        }
        const values = new Map(Object.entries(oldValue && oldValue[kind] || {}));
        callback(values);
        if (values.size) newValue[kind] = Object.fromEntries(values);
    }
    if (Object.keys(newValue).length) {
        if (item.is("documentSelection")) writer.setSelectionAttribute(ghsAttributeName, newValue);
        else writer.setAttribute(ghsAttributeName, newValue, item);
    } else if (oldValue) {
        if (item.is("documentSelection")) writer.removeSelectionAttribute(ghsAttributeName);
        else writer.removeAttribute(ghsAttributeName, item);
    }
}
/**
* Strips the `styles`, and `classes` keys from the GHS attribute value on the given item.
*
* @internal
*/ function $50e4d8c8f321fe5d$var$removeFormatting(ghsAttributeName, itemRange, writer) {
    for (const item of itemRange.getItems({
        shallow: true
    })){
        const value = item.getAttribute(ghsAttributeName);
        if (value && value.attributes && Object.keys(value.attributes).length) {
            if (Object.keys(value).length > 1) writer.setAttribute(ghsAttributeName, {
                attributes: value.attributes
            }, item);
        } else writer.removeAttribute(ghsAttributeName, item);
    }
}
/**
* Transforms passed string to PascalCase format. Examples:
* * `div` => `Div`
* * `h1` => `H1`
* * `table` => `Table`
*
* @internal
*/ function $50e4d8c8f321fe5d$export$1dc1aca1f2b5fd25(data) {
    return (0, $b99a820a03b0a14b$export$adfcc6ec7d9b3f5)(data).replace(/ /g, "");
}
/**
* Returns the attribute name of the model element that holds raw HTML attributes.
*
* @internal
*/ function $50e4d8c8f321fe5d$export$395cfe6a282469b9(viewElementName) {
    return `html${$50e4d8c8f321fe5d$export$1dc1aca1f2b5fd25(viewElementName)}Attributes`;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* View-to-model conversion helper for object elements.
*
* Preserves object element content in `htmlContent` attribute.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$4e187ae03d42336c({ model: modelName }) {
    return (viewElement, conversionApi)=>{
        return conversionApi.writer.createElement(modelName, {
            htmlContent: viewElement.getCustomProperty("$rawContent")
        });
    };
}
/**
* Conversion helper converting an object element to an HTML object widget.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$2d5a9048504298c9(editor, { view: viewName, isInline: isInline }) {
    const t = editor.t;
    return (modelElement, { writer: writer })=>{
        const widgetLabel = t("HTML object");
        const viewElement = $50e4d8c8f321fe5d$export$1c80172b00cd66ac(viewName, modelElement, writer);
        const viewAttributes = modelElement.getAttribute($50e4d8c8f321fe5d$export$395cfe6a282469b9(viewName));
        writer.addClass("html-object-embed__content", viewElement);
        if (viewAttributes) $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, viewAttributes, viewElement);
        const viewContainer = writer.createContainerElement(isInline ? "span" : "div", {
            class: "html-object-embed",
            "data-html-object-embed-label": widgetLabel
        }, viewElement);
        return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewContainer, writer, {
            label: widgetLabel
        });
    };
}
/**
* Creates object view element from the given model element.
*
* @internal
*/ function $50e4d8c8f321fe5d$export$1c80172b00cd66ac(viewName, modelElement, writer) {
    return writer.createRawElement(viewName, null, (domElement, domConverter)=>{
        domConverter.setContentOf(domElement, modelElement.getAttribute("htmlContent"));
    });
}
/**
* View-to-attribute conversion helper preserving inline element attributes on `$text`.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$55453af0b2999a35({ view: viewName, model: attributeKey, allowEmpty: allowEmpty }, dataFilter) {
    return (dispatcher)=>{
        dispatcher.on(`element:${viewName}`, (evt, data, conversionApi)=>{
            let viewAttributes = dataFilter.processViewAttributes(data.viewItem, conversionApi);
            if (!viewAttributes && !conversionApi.consumable.test(data.viewItem, {
                name: true
            })) return;
            viewAttributes = viewAttributes || {};
            conversionApi.consumable.consume(data.viewItem, {
                name: true
            });
            if (!data.modelRange) data = Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
            if (allowEmpty && data.modelRange.isCollapsed && Object.keys(viewAttributes).length) {
                const modelElement = conversionApi.writer.createElement("htmlEmptyElement");
                if (!conversionApi.safeInsert(modelElement, data.modelCursor)) return;
                const parts = conversionApi.getSplitParts(modelElement);
                data.modelRange = conversionApi.writer.createRange(data.modelRange.start, conversionApi.writer.createPositionAfter(parts[parts.length - 1]));
                conversionApi.updateConversionResult(modelElement, data);
                setAttributeOnItem(modelElement, viewAttributes, conversionApi);
                return;
            }
            for (const node of data.modelRange.getItems())setAttributeOnItem(node, viewAttributes, conversionApi);
        }, {
            priority: "low"
        });
    };
    function setAttributeOnItem(node, viewAttributes, conversionApi) {
        if (conversionApi.schema.checkAttribute(node, attributeKey)) {
            const nodeAttributes = node.getAttribute(attributeKey);
            const attributesToAdd = $50e4d8c8f321fe5d$export$e87137e359a36e2e(viewAttributes, nodeAttributes || {});
            conversionApi.writer.setAttribute(attributeKey, attributesToAdd, node);
        }
    }
}
/**
* Conversion helper converting an empty inline model element to an HTML element or widget.
*
* @internal
*/ function $50e4d8c8f321fe5d$export$445710c283dd57a5({ model: attributeKey, view: viewName }, asWidget) {
    return (item, { writer: writer, consumable: consumable })=>{
        if (!item.hasAttribute(attributeKey)) return null;
        const viewElement = writer.createContainerElement(viewName);
        const attributeValue = item.getAttribute(attributeKey);
        consumable.consume(item, `attribute:${attributeKey}`);
        $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, attributeValue, viewElement);
        viewElement.getFillerOffset = ()=>null;
        return asWidget ? (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer) : viewElement;
    };
}
/**
* Attribute-to-view conversion helper applying attributes to view element preserved on `$text`.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$6553d6a3f1c62cab({ priority: priority, view: viewName }) {
    return (attributeValue, conversionApi)=>{
        if (!attributeValue) return;
        const { writer: writer } = conversionApi;
        const viewElement = writer.createAttributeElement(viewName, null, {
            priority: priority
        });
        $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, attributeValue, viewElement);
        return viewElement;
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on block element.
*
* All matched attributes will be preserved on `html*Attributes` attribute.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$5dab40fe165daba5({ view: viewName }, dataFilter) {
    return (dispatcher)=>{
        dispatcher.on(`element:${viewName}`, (evt, data, conversionApi)=>{
            if (!data.modelRange || data.modelRange.isCollapsed) return;
            const viewAttributes = dataFilter.processViewAttributes(data.viewItem, conversionApi);
            if (!viewAttributes) return;
            conversionApi.writer.setAttribute($50e4d8c8f321fe5d$export$395cfe6a282469b9(data.viewItem.name), viewAttributes, data.modelRange);
        }, {
            priority: "low"
        });
    };
}
/**
* Model-to-view conversion helper applying attributes preserved in `html*Attributes` attribute
* for block elements.
*
* @returns Returns a conversion callback.
* @internal
*/ function $50e4d8c8f321fe5d$export$191f7098d98d50df({ view: viewName, model: modelName }) {
    return (dispatcher)=>{
        dispatcher.on(`attribute:${$50e4d8c8f321fe5d$export$395cfe6a282469b9(viewName)}:${modelName}`, (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
            const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
            const viewWriter = conversionApi.writer;
            const viewElement = conversionApi.mapper.toViewElement(data.item);
            $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(viewWriter, attributeOldValue, attributeNewValue, viewElement);
        });
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Skipped elements due to HTML deprecation:
* * noframes (not sure if we should provide support for this element. CKE4 is not supporting frameset and frame,
*   but it will unpack <frameset><noframes>foobar</noframes></frameset> to <noframes>foobar</noframes>, so there
*   may be some content loss. Although using noframes as a standalone element seems invalid)
* * keygen (this one is also empty)
* * applet (support is limited mostly to old IE)
* * basefont (this one is also empty)
* * isindex (basically no support for modern browsers at all)
*
* Skipped elements due to lack empty element support:
* * hr
* * area
* * br
* * command
* * map
* * wbr
* * colgroup -> col
*
* Skipped elements due to complexity:
* * datalist with option elements used as a data source for input[list] element
*
* Skipped elements as they are handled as an object content:
* * track
* * source
* * option
* * param
* * optgroup
*
* Skipped full page HTML elements:
* * body
* * html
* * title
* * head
* * meta
* * link
* * etc...
*
* Skipped hidden elements:
* noscript
*
* When adding elements to this list, update the feature guide listing, too.
*
* @internal
*/ const $50e4d8c8f321fe5d$export$ebba2c8c30a556b1 = {
    block: [
        {
            model: "codeBlock",
            view: "pre"
        },
        {
            model: "paragraph",
            view: "p"
        },
        {
            model: "blockQuote",
            view: "blockquote"
        },
        {
            model: "listItem",
            view: "li"
        },
        {
            model: "pageBreak",
            view: "div"
        },
        {
            model: "rawHtml",
            view: "div"
        },
        {
            model: "table",
            view: "table"
        },
        {
            model: "tableRow",
            view: "tr"
        },
        {
            model: "tableCell",
            view: "td"
        },
        {
            model: "tableCell",
            view: "th"
        },
        {
            model: "tableColumnGroup",
            view: "colgroup"
        },
        {
            model: "tableColumn",
            view: "col"
        },
        {
            model: "caption",
            view: "caption"
        },
        {
            model: "caption",
            view: "figcaption"
        },
        {
            model: "imageBlock",
            view: "img"
        },
        {
            model: "imageInline",
            view: "img"
        },
        {
            model: "horizontalLine",
            view: "hr"
        },
        {
            model: "htmlP",
            view: "p",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlBlockquote",
            view: "blockquote",
            modelSchema: {
                inheritAllFrom: "$container"
            }
        },
        {
            model: "htmlTable",
            view: "table",
            modelSchema: {
                allowWhere: "$block",
                isBlock: true
            }
        },
        {
            model: "htmlTbody",
            view: "tbody",
            modelSchema: {
                allowIn: "htmlTable",
                isBlock: false
            }
        },
        {
            model: "htmlThead",
            view: "thead",
            modelSchema: {
                allowIn: "htmlTable",
                isBlock: false
            }
        },
        {
            model: "htmlTfoot",
            view: "tfoot",
            modelSchema: {
                allowIn: "htmlTable",
                isBlock: false
            }
        },
        {
            model: "htmlCaption",
            view: "caption",
            modelSchema: {
                allowIn: "htmlTable",
                allowChildren: "$text",
                isBlock: false
            }
        },
        {
            model: "htmlColgroup",
            view: "colgroup",
            modelSchema: {
                allowIn: "htmlTable",
                allowChildren: "col",
                isBlock: false
            }
        },
        {
            model: "htmlCol",
            view: "col",
            modelSchema: {
                allowIn: "htmlColgroup",
                isBlock: false
            }
        },
        {
            model: "htmlTr",
            view: "tr",
            modelSchema: {
                allowIn: [
                    "htmlTable",
                    "htmlThead",
                    "htmlTbody",
                    "htmlTfoot"
                ],
                isLimit: true
            }
        },
        {
            model: "htmlTd",
            view: "td",
            modelSchema: {
                allowIn: "htmlTr",
                allowContentOf: "$container",
                isLimit: true,
                isBlock: false
            }
        },
        {
            model: "htmlTh",
            view: "th",
            modelSchema: {
                allowIn: "htmlTr",
                allowContentOf: "$container",
                isLimit: true,
                isBlock: false
            }
        },
        {
            model: "htmlFigure",
            view: "figure",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlFigcaption",
            view: "figcaption",
            modelSchema: {
                allowIn: "htmlFigure",
                allowChildren: "$text",
                isBlock: false
            }
        },
        {
            model: "htmlAddress",
            view: "address",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlAside",
            view: "aside",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlMain",
            view: "main",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlDetails",
            view: "details",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlSummary",
            view: "summary",
            modelSchema: {
                allowChildren: [
                    "htmlH1",
                    "htmlH2",
                    "htmlH3",
                    "htmlH4",
                    "htmlH5",
                    "htmlH6",
                    "$text"
                ],
                allowIn: "htmlDetails",
                isBlock: false
            }
        },
        {
            model: "htmlDiv",
            view: "div",
            paragraphLikeModel: "htmlDivParagraph",
            modelSchema: {
                inheritAllFrom: "$container"
            }
        },
        {
            model: "htmlFieldset",
            view: "fieldset",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlLegend",
            view: "legend",
            modelSchema: {
                allowIn: "htmlFieldset",
                allowChildren: "$text"
            }
        },
        {
            model: "htmlHeader",
            view: "header",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlFooter",
            view: "footer",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlForm",
            view: "form",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlHgroup",
            view: "hgroup",
            modelSchema: {
                allowWhere: "$container",
                allowChildren: [
                    "paragraph",
                    "htmlP",
                    "htmlH1",
                    "htmlH2",
                    "htmlH3",
                    "htmlH4",
                    "htmlH5",
                    "htmlH6"
                ],
                isBlock: false
            }
        },
        {
            model: "htmlH1",
            view: "h1",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlH2",
            view: "h2",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlH3",
            view: "h3",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlH4",
            view: "h4",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlH5",
            view: "h5",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlH6",
            view: "h6",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "$htmlList",
            modelSchema: {
                allowWhere: "$container",
                allowChildren: [
                    "$htmlList",
                    "htmlLi"
                ],
                isBlock: false
            }
        },
        {
            model: "htmlDir",
            view: "dir",
            modelSchema: {
                inheritAllFrom: "$htmlList"
            }
        },
        {
            model: "htmlMenu",
            view: "menu",
            modelSchema: {
                inheritAllFrom: "$htmlList"
            }
        },
        {
            model: "htmlUl",
            view: "ul",
            modelSchema: {
                inheritAllFrom: "$htmlList"
            }
        },
        {
            model: "htmlOl",
            view: "ol",
            modelSchema: {
                inheritAllFrom: "$htmlList"
            }
        },
        {
            model: "htmlLi",
            view: "li",
            modelSchema: {
                allowIn: "$htmlList",
                allowChildren: "$text",
                isBlock: false
            }
        },
        {
            model: "htmlPre",
            view: "pre",
            modelSchema: {
                inheritAllFrom: "$block"
            }
        },
        {
            model: "htmlArticle",
            view: "article",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlSection",
            view: "section",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlNav",
            view: "nav",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlDl",
            view: "dl",
            modelSchema: {
                allowWhere: "$container",
                allowChildren: [
                    "htmlDt",
                    "htmlDd",
                    "htmlDiv"
                ],
                allowAttributesOf: [
                    "$container"
                ],
                isBlock: false
            }
        },
        {
            model: "htmlDt",
            view: "dt",
            modelSchema: {
                allowChildren: "$block",
                allowIn: "htmlDiv",
                isBlock: false
            }
        },
        {
            model: "htmlDd",
            view: "dd",
            modelSchema: {
                allowChildren: "$block",
                allowIn: "htmlDiv",
                isBlock: false
            }
        },
        {
            model: "htmlCenter",
            view: "center",
            modelSchema: {
                inheritAllFrom: "$container",
                isBlock: false
            }
        },
        {
            model: "htmlHr",
            view: "hr",
            isEmpty: true,
            modelSchema: {
                inheritAllFrom: "$blockObject"
            }
        }
    ],
    inline: [
        {
            model: "htmlLiAttributes",
            view: "li",
            appliesToBlock: true,
            coupledAttribute: "listItemId"
        },
        {
            model: "htmlOlAttributes",
            view: "ol",
            appliesToBlock: true,
            coupledAttribute: "listItemId"
        },
        {
            model: "htmlUlAttributes",
            view: "ul",
            appliesToBlock: true,
            coupledAttribute: "listItemId"
        },
        {
            model: "htmlFigureAttributes",
            view: "figure",
            appliesToBlock: "table"
        },
        {
            model: "htmlTheadAttributes",
            view: "thead",
            appliesToBlock: "table"
        },
        {
            model: "htmlTfootAttributes",
            view: "tfoot",
            appliesToBlock: "table"
        },
        {
            model: "htmlTbodyAttributes",
            view: "tbody",
            appliesToBlock: "table"
        },
        {
            model: "htmlFigureAttributes",
            view: "figure",
            appliesToBlock: "imageBlock"
        },
        {
            model: "htmlAcronym",
            view: "acronym",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlTt",
            view: "tt",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlFont",
            view: "font",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlTime",
            view: "time",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlVar",
            view: "var",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlBig",
            view: "big",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlSmall",
            view: "small",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlSamp",
            view: "samp",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlQ",
            view: "q",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlOutput",
            view: "output",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlKbd",
            view: "kbd",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlBdi",
            view: "bdi",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlBdo",
            view: "bdo",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlAbbr",
            view: "abbr",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlA",
            view: "a",
            priority: 5,
            coupledAttribute: "linkHref",
            attributeProperties: {
                isFormatting: true
            }
        },
        {
            model: "htmlStrong",
            view: "strong",
            coupledAttribute: "bold",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlB",
            view: "b",
            coupledAttribute: "bold",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlI",
            view: "i",
            coupledAttribute: "italic",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlEm",
            view: "em",
            coupledAttribute: "italic",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlS",
            view: "s",
            coupledAttribute: "strikethrough",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlDel",
            view: "del",
            coupledAttribute: "strikethrough",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlIns",
            view: "ins",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlU",
            view: "u",
            coupledAttribute: "underline",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlSub",
            view: "sub",
            coupledAttribute: "subscript",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlSup",
            view: "sup",
            coupledAttribute: "superscript",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlCode",
            view: "code",
            coupledAttribute: "code",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlMark",
            view: "mark",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlSpan",
            view: "span",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlCite",
            view: "cite",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlLabel",
            view: "label",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlDfn",
            view: "dfn",
            attributeProperties: {
                copyOnEnter: true,
                isFormatting: true
            }
        },
        {
            model: "htmlObject",
            view: "object",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlIframe",
            view: "iframe",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlInput",
            view: "input",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlButton",
            view: "button",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlTextarea",
            view: "textarea",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlSelect",
            view: "select",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlVideo",
            view: "video",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlEmbed",
            view: "embed",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlOembed",
            view: "oembed",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlAudio",
            view: "audio",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlImg",
            view: "img",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlCanvas",
            view: "canvas",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlMeter",
            view: "meter",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlProgress",
            view: "progress",
            isObject: true,
            modelSchema: {
                inheritAllFrom: "$inlineObject"
            }
        },
        {
            model: "htmlScript",
            view: "script",
            modelSchema: {
                allowWhere: [
                    "$text",
                    "$block"
                ],
                isInline: true
            }
        },
        {
            model: "htmlStyle",
            view: "style",
            modelSchema: {
                allowWhere: [
                    "$text",
                    "$block"
                ],
                isInline: true
            }
        },
        {
            model: "htmlCustomElement",
            view: "$customElement",
            modelSchema: {
                allowWhere: [
                    "$text",
                    "$block"
                ],
                allowAttributesOf: "$inlineObject",
                isInline: true
            }
        }
    ]
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/dataschema
*/ /**
* Holds representation of the extended HTML document type definitions to be used by the
* editor in HTML support.
*
* Data schema is represented by data schema definitions.
*
* To add new definition for block element,
* use {@link module:html-support/dataschema~DataSchema#registerBlockElement} method:
*
* ```ts
* dataSchema.registerBlockElement( {
* 	view: 'section',
* 	model: 'my-section',
* 	modelSchema: {
* 		inheritAllFrom: '$block'
* 	}
* } );
* ```
*
* To add new definition for inline element,
* use {@link module:html-support/dataschema~DataSchema#registerInlineElement} method:
*
* ```
* dataSchema.registerInlineElement( {
* 	view: 'span',
* 	model: 'my-span',
* 	attributeProperties: {
* 		copyOnEnter: true
* 	}
* } );
* ```
*/ var $50e4d8c8f321fe5d$export$80c7772e4612893e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A map of registered data schema definitions.
	*/ _definitions = [];
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DataSchema";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        for (const definition of $50e4d8c8f321fe5d$export$ebba2c8c30a556b1.block)this.registerBlockElement(definition);
        for (const definition of $50e4d8c8f321fe5d$export$ebba2c8c30a556b1.inline)this.registerInlineElement(definition);
    }
    /**
	* Add new data schema definition describing block element.
	*/ registerBlockElement(definition) {
        this._definitions.push({
            ...definition,
            isBlock: true
        });
    }
    /**
	* Add new data schema definition describing inline element.
	*/ registerInlineElement(definition) {
        this._definitions.push({
            ...definition,
            isInline: true
        });
    }
    /**
	* Updates schema definition describing block element with new properties.
	*
	* Creates new scheme if it doesn't exist.
	* Array properties are concatenated with original values.
	*
	* @param definition Definition update.
	*/ extendBlockElement(definition) {
        this._extendDefinition({
            ...definition,
            isBlock: true
        });
    }
    /**
	* Updates schema definition describing inline element with new properties.
	*
	* Creates new scheme if it doesn't exist.
	* Array properties are concatenated with original values.
	*
	* @param definition Definition update.
	*/ extendInlineElement(definition) {
        this._extendDefinition({
            ...definition,
            isInline: true
        });
    }
    /**
	* Returns all definitions matching the given view name.
	*
	* @param includeReferences Indicates if this method should also include definitions of referenced models.
	*/ getDefinitionsForView(viewName, includeReferences = false) {
        const definitions = /* @__PURE__ */ new Set();
        for (const definition of this._getMatchingViewDefinitions(viewName)){
            if (includeReferences) for (const reference of this._getReferences(definition.model))definitions.add(reference);
            definitions.add(definition);
        }
        return definitions;
    }
    /**
	* Returns definitions matching the given model name.
	*/ getDefinitionsForModel(modelName) {
        return this._definitions.filter((definition)=>definition.model == modelName);
    }
    /**
	* Returns definitions matching the given view name.
	*/ _getMatchingViewDefinitions(viewName) {
        return this._definitions.filter((def)=>def.view && $50e4d8c8f321fe5d$var$testViewName(viewName, def.view));
    }
    /**
	* Resolves all definition references registered for the given data schema definition.
	*
	* @param modelName Data schema model name.
	*/ *_getReferences(modelName) {
        const inheritProperties = [
            "inheritAllFrom",
            "inheritTypesFrom",
            "allowWhere",
            "allowContentOf",
            "allowAttributesOf"
        ];
        const definitions = this._definitions.filter((definition)=>definition.model == modelName);
        for (const { modelSchema: modelSchema } of definitions){
            if (!modelSchema) continue;
            for (const property of inheritProperties)for (const referenceName of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(modelSchema[property] || [])){
                const definitions = this._definitions.filter((definition)=>definition.model == referenceName);
                for (const definition of definitions)if (referenceName !== modelName) {
                    yield* this._getReferences(definition.model);
                    yield definition;
                }
            }
        }
    }
    /**
	* Updates schema definition with new properties.
	*
	* Creates new scheme if it doesn't exist.
	* Array properties are concatenated with original values.
	*
	* @param definition Definition update.
	*/ _extendDefinition(definition) {
        const currentDefinitions = Array.from(this._definitions.entries()).filter(([, currentDefinition])=>currentDefinition.model == definition.model);
        if (currentDefinitions.length == 0) {
            this._definitions.push(definition);
            return;
        }
        for (const [idx, currentDefinition] of currentDefinitions)this._definitions[idx] = (0, $8bb08980612c5c43$export$2ee76fde9ffe109d)({}, currentDefinition, definition, (target, source)=>{
            return Array.isArray(target) ? target.concat(source) : void 0;
        });
    }
};
/**
* Test view name against the given pattern.
*/ function $50e4d8c8f321fe5d$var$testViewName(pattern, viewName) {
    if (typeof pattern === "string") return pattern === viewName;
    if (pattern instanceof RegExp) return pattern.test(viewName);
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/datafilter
*/ /**
* Allows to validate elements and element attributes registered by {@link module:html-support/dataschema~DataSchema}.
*
* To enable registered element in the editor, use {@link module:html-support/datafilter~DataFilter#allowElement} method:
*
* ```ts
* dataFilter.allowElement( 'section' );
* ```
*
* You can also allow or disallow specific element attributes:
*
* ```ts
* // Allow `data-foo` attribute on `section` element.
* dataFilter.allowAttributes( {
* 	name: 'section',
* 	attributes: {
* 		'data-foo': true
* 	}
* } );
*
* // Disallow `color` style attribute on 'section' element.
* dataFilter.disallowAttributes( {
* 	name: 'section',
* 	styles: {
* 		color: /[\s\S]+/
* 	}
* } );
* ```
*
* To apply the information about allowed and disallowed attributes in custom integration plugin,
* use the {@link module:html-support/datafilter~DataFilter#processViewAttributes `processViewAttributes()`} method.
*/ var $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* An instance of the {@link module:html-support/dataschema~DataSchema}.
	*/ _dataSchema;
    /**
	* {@link module:engine/view/matcher~Matcher Matcher} instance describing rules upon which
	* content attributes should be allowed.
	*/ _allowedAttributes;
    /**
	* {@link module:engine/view/matcher~Matcher Matcher} instance describing rules upon which
	* content attributes should be disallowed.
	*/ _disallowedAttributes;
    /**
	* Allowed element definitions by {@link module:html-support/datafilter~DataFilter#allowElement} method.
	*/ _allowedElements;
    /**
	* Disallowed element names by {@link module:html-support/datafilter~DataFilter#disallowElement} method.
	*/ _disallowedElements;
    /**
	* Indicates if {@link module:engine/controller/datacontroller~DataController editor's data controller}
	* data has been already initialized.
	*/ _dataInitialized;
    /**
	* Cached map of coupled attributes. Keys are the feature attributes names
	* and values are arrays with coupled GHS attributes names.
	*/ _coupledAttributes;
    constructor(editor){
        super(editor);
        this._dataSchema = editor.plugins.get("DataSchema");
        this._allowedAttributes = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)();
        this._disallowedAttributes = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)();
        this._allowedElements = /* @__PURE__ */ new Set();
        this._disallowedElements = /* @__PURE__ */ new Set();
        this._dataInitialized = false;
        this._coupledAttributes = null;
        this._registerElementsAfterInit();
        this._registerElementHandlers();
        this._registerCoupledAttributesPostFixer();
        this._registerAssociatedHtmlAttributesPostFixer();
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DataFilter";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$80c7772e4612893e,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* Load a configuration of one or many elements, where their attributes should be allowed.
	*
	* **Note**: Rules will be applied just before next data pipeline data init or set.
	*
	* @param config Configuration of elements that should have their attributes accepted in the editor.
	*/ loadAllowedConfig(config) {
        for (const pattern of config){
            const elementName = pattern.name || /[\s\S]+/;
            const rules = $50e4d8c8f321fe5d$var$splitRules(pattern);
            this.allowElement(elementName);
            rules.forEach((pattern)=>this.allowAttributes(pattern));
        }
    }
    /**
	* Load a configuration of one or many elements, where their attributes should be disallowed.
	*
	* **Note**: Rules will be applied just before next data pipeline data init or set.
	*
	* @param config Configuration of elements that should have their attributes rejected from the editor.
	*/ loadDisallowedConfig(config) {
        for (const pattern of config){
            const elementName = pattern.name || /[\s\S]+/;
            const rules = $50e4d8c8f321fe5d$var$splitRules(pattern);
            if (rules.length == 0) this.disallowElement(elementName);
            else rules.forEach((pattern)=>this.disallowAttributes(pattern));
        }
    }
    /**
	* Load a configuration of one or many elements, where when empty should be allowed.
	*
	* **Note**: It modifies DataSchema so must be loaded before registering filtering rules.
	*
	* @param config Configuration of elements that should be preserved even if empty.
	*/ loadAllowedEmptyElementsConfig(config) {
        for (const elementName of config)this.allowEmptyElement(elementName);
    }
    /**
	* Allow the given element in the editor context.
	*
	* This method will only allow elements described by the {@link module:html-support/dataschema~DataSchema} used
	* to create data filter.
	*
	* **Note**: Rules will be applied just before next data pipeline data init or set.
	*
	* @param viewName String or regular expression matching view name.
	*/ allowElement(viewName) {
        for (const definition of this._dataSchema.getDefinitionsForView(viewName, true)){
            this._addAllowedElement(definition);
            this._coupledAttributes = null;
        }
    }
    /**
	* Disallow the given element in the editor context.
	*
	* This method will only disallow elements described by the {@link module:html-support/dataschema~DataSchema} used
	* to create data filter.
	*
	* @param viewName String or regular expression matching view name.
	*/ disallowElement(viewName) {
        for (const definition of this._dataSchema.getDefinitionsForView(viewName, false))this._disallowedElements.add(definition.view);
    }
    /**
	* Allow the given empty element in the editor context.
	*
	* This method will only allow elements described by the {@link module:html-support/dataschema~DataSchema} used
	* to create data filter.
	*
	* **Note**: It modifies DataSchema so must be called before registering filtering rules.
	*
	* @param viewName String or regular expression matching view name.
	*/ allowEmptyElement(viewName) {
        for (const definition of this._dataSchema.getDefinitionsForView(viewName, true))if (definition.isInline) this._dataSchema.extendInlineElement({
            ...definition,
            allowEmpty: true
        });
    }
    /**
	* Allow the given attributes for view element allowed by {@link #allowElement} method.
	*
	* @param config Pattern matching all attributes which should be allowed.
	*/ allowAttributes(config) {
        this._allowedAttributes.add(config);
    }
    /**
	* Disallow the given attributes for view element allowed by {@link #allowElement} method.
	*
	* @param config Pattern matching all attributes which should be disallowed.
	*/ disallowAttributes(config) {
        this._disallowedAttributes.add(config);
    }
    /**
	* Processes all allowed and disallowed attributes on the view element by consuming them and returning the allowed ones.
	*
	* This method applies the configuration set up by {@link #allowAttributes `allowAttributes()`}
	* and {@link #disallowAttributes `disallowAttributes()`} over the given view element by consuming relevant attributes.
	* It returns the allowed attributes that were found on the given view element for further processing by integration code.
	*
	* ```ts
	* dispatcher.on( 'element:myElement', ( evt, data, conversionApi ) => {
	* 	// Get rid of disallowed and extract all allowed attributes from a viewElement.
	* 	const viewAttributes = dataFilter.processViewAttributes( data.viewItem, conversionApi );
	* 	// Do something with them, i.e. store inside a model as a dictionary.
	* 	if ( viewAttributes ) {
	* 		conversionApi.writer.setAttribute( 'htmlAttributesOfMyElement', viewAttributes, data.modelRange );
	* 	}
	* } );
	* ```
	*
	* @see module:engine/conversion/viewconsumable~ViewConsumable#consume
	*
	* @returns Object with following properties:
	* - attributes Set with matched attribute names.
	* - styles Set with matched style names.
	* - classes Set with matched class names.
	*/ processViewAttributes(viewElement, conversionApi) {
        const { consumable: consumable } = conversionApi;
        $50e4d8c8f321fe5d$var$matchAndConsumeAttributes(viewElement, this._disallowedAttributes, consumable);
        return $50e4d8c8f321fe5d$var$prepareGHSAttribute(viewElement, $50e4d8c8f321fe5d$var$matchAndConsumeAttributes(viewElement, this._allowedAttributes, consumable));
    }
    /**
	* Adds allowed element definition and fires registration event.
	*/ _addAllowedElement(definition) {
        if (this._allowedElements.has(definition)) return;
        this._allowedElements.add(definition);
        if ("appliesToBlock" in definition && typeof definition.appliesToBlock == "string") {
            for (const relatedDefinition of this._dataSchema.getDefinitionsForModel(definition.appliesToBlock))if (relatedDefinition.isBlock) this._addAllowedElement(relatedDefinition);
        }
        if (this._dataInitialized) this.editor.data.once("set", ()=>{
            this._fireRegisterEvent(definition);
        }, {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).highest + 1
        });
    }
    /**
	* Registers elements allowed by {@link module:html-support/datafilter~DataFilter#allowElement} method
	* once {@link module:engine/controller/datacontroller~DataController editor's data controller} is initialized.
	*/ _registerElementsAfterInit() {
        this.editor.data.on("init", ()=>{
            this._dataInitialized = true;
            for (const definition of this._allowedElements)this._fireRegisterEvent(definition);
        }, {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).highest + 1
        });
    }
    /**
	* Registers default element handlers.
	*/ _registerElementHandlers() {
        this.on("register", (evt, definition)=>{
            const schema = this.editor.model.schema;
            if (definition.isObject && !schema.isRegistered(definition.model)) this._registerObjectElement(definition);
            else if (definition.isBlock) this._registerBlockElement(definition);
            else if (definition.isInline) this._registerInlineElement(definition);
            else /**
			* The definition cannot be handled by the data filter.
			*
			* Make sure that the registered definition is correct.
			*
			* @error data-filter-invalid-definition
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("data-filter-invalid-definition", null, definition);
            evt.stop();
        }, {
            priority: "lowest"
        });
    }
    /**
	* Registers a model post-fixer that is removing coupled GHS attributes of inline elements. Those attributes
	* are removed if a coupled feature attribute is removed.
	*
	* For example, consider following HTML:
	*
	* ```html
	* <a href="foo.html" id="myId">bar</a>
	* ```
	*
	* Which would be upcasted to following text node in the model:
	*
	* ```html
	* <$text linkHref="foo.html" htmlA="{ attributes: { id: 'myId' } }">bar</$text>
	* ```
	*
	* When the user removes the link from that text (using UI), only `linkHref` attribute would be removed:
	*
	* ```html
	* <$text htmlA="{ attributes: { id: 'myId' } }">bar</$text>
	* ```
	*
	* The `htmlA` attribute would stay in the model and would cause GHS to generate an `<a>` element.
	* This is incorrect from UX point of view, as the user wanted to remove the whole link (not only `href`).
	*/ _registerCoupledAttributesPostFixer() {
        const model = this.editor.model;
        const selection = model.document.selection;
        model.document.registerPostFixer((writer)=>{
            const changes = model.document.differ.getChanges();
            let changed = false;
            const coupledAttributes = this._getCoupledAttributesMap();
            for (const change of changes){
                if (change.type != "attribute" || change.attributeNewValue !== null) continue;
                const attributeKeys = coupledAttributes.get(change.attributeKey);
                if (!attributeKeys) continue;
                for (const { item: item } of change.range.getWalker())for (const attributeKey of attributeKeys)if (item.hasAttribute(attributeKey)) {
                    writer.removeAttribute(attributeKey, item);
                    changed = true;
                }
            }
            return changed;
        });
        this.listenTo(selection, "change:attribute", (evt, { attributeKeys: attributeKeys })=>{
            const removeAttributes = /* @__PURE__ */ new Set();
            const coupledAttributes = this._getCoupledAttributesMap();
            for (const attributeKey of attributeKeys){
                if (selection.hasAttribute(attributeKey)) continue;
                const coupledAttributeKeys = coupledAttributes.get(attributeKey);
                if (!coupledAttributeKeys) continue;
                for (const coupledAttributeKey of coupledAttributeKeys)if (selection.hasAttribute(coupledAttributeKey)) removeAttributes.add(coupledAttributeKey);
            }
            if (removeAttributes.size == 0) return;
            model.change((writer)=>{
                for (const attributeKey of removeAttributes)writer.removeSelectionAttribute(attributeKey);
            });
        });
    }
    /**
	* Removes `html*Attributes` attributes from incompatible elements.
	*
	* For example, consider the following HTML:
	*
	* ```html
	* <heading2 htmlH2Attributes="...">foobar[]</heading2>
	* ```
	*
	* Pressing `enter` creates a new `paragraph` element that inherits
	* the `htmlH2Attributes` attribute from `heading2`.
	*
	* ```html
	* <heading2 htmlH2Attributes="...">foobar</heading2>
	* <paragraph htmlH2Attributes="...">[]</paragraph>
	* ```
	*
	* This postfixer ensures that this doesn't happen, and that elements can
	* only have `html*Attributes` associated with them,
	* e.g.: `htmlPAttributes` for `<p>`, `htmlDivAttributes` for `<div>`, etc.
	*
	* With it enabled, pressing `enter` at the end of `<heading2>` will create
	* a new paragraph without the `htmlH2Attributes` attribute.
	*
	* ```html
	* <heading2 htmlH2Attributes="...">foobar</heading2>
	* <paragraph>[]</paragraph>
	* ```
	*/ _registerAssociatedHtmlAttributesPostFixer() {
        const model = this.editor.model;
        model.document.registerPostFixer((writer)=>{
            const changes = model.document.differ.getChanges();
            let changed = false;
            for (const change of changes){
                if (change.type !== "insert" || change.name === "$text") continue;
                for (const attr of change.attributes.keys()){
                    if (!attr.startsWith("html") || !attr.endsWith("Attributes")) continue;
                    if (!model.schema.checkAttribute(change.name, attr)) {
                        writer.removeAttribute(attr, change.position.nodeAfter);
                        changed = true;
                    }
                }
            }
            return changed;
        });
    }
    /**
	* Collects the map of coupled attributes. The returned map is keyed by the feature attribute name
	* and coupled GHS attribute names are stored in the value array.
	*/ _getCoupledAttributesMap() {
        if (this._coupledAttributes) return this._coupledAttributes;
        this._coupledAttributes = /* @__PURE__ */ new Map();
        for (const definition of this._allowedElements)if (definition.coupledAttribute && definition.model) {
            const attributeNames = this._coupledAttributes.get(definition.coupledAttribute);
            if (attributeNames) attributeNames.push(definition.model);
            else this._coupledAttributes.set(definition.coupledAttribute, [
                definition.model
            ]);
        }
        return this._coupledAttributes;
    }
    /**
	* Fires `register` event for the given element definition.
	*/ _fireRegisterEvent(definition) {
        if (definition.view && this._disallowedElements.has(definition.view)) return;
        this.fire(definition.view ? `register:${definition.view}` : "register", definition);
    }
    /**
	* Registers object element and attribute converters for the given data schema definition.
	*/ _registerObjectElement(definition) {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const { view: viewName, model: modelName } = definition;
        schema.register(modelName, definition.modelSchema);
        /* v8 ignore next: paranoid check -- @preserve */ if (!viewName) return;
        schema.extend(definition.model, {
            allowAttributes: [
                $50e4d8c8f321fe5d$export$395cfe6a282469b9(viewName),
                "htmlContent"
            ]
        });
        editor.data.registerRawContentMatcher({
            name: viewName
        });
        conversion.for("upcast").elementToElement({
            view: viewName,
            model: $50e4d8c8f321fe5d$export$4e187ae03d42336c(definition),
            converterPriority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low + 2
        });
        conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, this));
        conversion.for("editingDowncast").elementToStructure({
            model: {
                name: modelName,
                attributes: [
                    $50e4d8c8f321fe5d$export$395cfe6a282469b9(viewName)
                ]
            },
            view: $50e4d8c8f321fe5d$export$2d5a9048504298c9(editor, definition)
        });
        conversion.for("dataDowncast").elementToElement({
            model: modelName,
            view: (modelElement, { writer: writer })=>{
                return $50e4d8c8f321fe5d$export$1c80172b00cd66ac(viewName, modelElement, writer);
            }
        });
        conversion.for("dataDowncast").add($50e4d8c8f321fe5d$export$191f7098d98d50df(definition));
    }
    /**
	* Registers block element and attribute converters for the given data schema definition.
	*/ _registerBlockElement(definition) {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const { view: viewName, model: modelName } = definition;
        if (!schema.isRegistered(definition.model)) {
            if (!definition.modelSchema) return;
            schema.register(definition.model, definition.modelSchema);
            if (!viewName) return;
            conversion.for("upcast").elementToElement({
                model: modelName,
                view: viewName,
                converterPriority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low + 2
            });
            conversion.for("downcast").elementToElement({
                model: modelName,
                view: (modelElement, { writer: writer })=>definition.isEmpty ? writer.createEmptyElement(viewName) : writer.createContainerElement(viewName)
            });
        }
        if (!viewName) return;
        schema.extend(definition.model, {
            allowAttributes: $50e4d8c8f321fe5d$export$395cfe6a282469b9(viewName)
        });
        conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, this));
        conversion.for("downcast").add($50e4d8c8f321fe5d$export$191f7098d98d50df(definition));
    }
    /**
	* Registers inline element and attribute converters for the given data schema definition.
	*
	* Extends `$text` model schema to allow the given definition model attribute and its properties.
	*/ _registerInlineElement(definition) {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const attributeKey = definition.model;
        if (definition.appliesToBlock) return;
        schema.extend("$text", {
            allowAttributes: attributeKey
        });
        if (definition.attributeProperties) schema.setAttributeProperties(attributeKey, definition.attributeProperties);
        conversion.for("upcast").add($50e4d8c8f321fe5d$export$55453af0b2999a35(definition, this));
        conversion.for("downcast").attributeToElement({
            model: attributeKey,
            view: $50e4d8c8f321fe5d$export$6553d6a3f1c62cab(definition)
        });
        if (!definition.allowEmpty) return;
        schema.setAttributeProperties(attributeKey, {
            copyFromObject: false
        });
        if (!schema.isRegistered("htmlEmptyElement")) {
            schema.register("htmlEmptyElement", {
                inheritAllFrom: "$inlineObject"
            });
            const hasHtmlAttributes = (element)=>Array.from(element.getAttributeKeys()).some((key)=>key.startsWith("html"));
            editor.model.document.registerPostFixer((writer)=>{
                const changes = editor.model.document.differ.getChanges();
                const elementsToRemove = /* @__PURE__ */ new Set();
                for (const change of changes){
                    if (change.type === "remove") continue;
                    if (change.type === "attribute" && change.attributeNewValue === null) {
                        for (const { item: item } of change.range)if (item.is("element", "htmlEmptyElement") && !hasHtmlAttributes(item)) elementsToRemove.add(item);
                    }
                    if (change.type === "insert" && change.position.nodeAfter) {
                        const insertedElement = change.position.nodeAfter;
                        for (const { item: item } of writer.createRangeOn(insertedElement))if (item.is("element", "htmlEmptyElement") && !hasHtmlAttributes(item)) elementsToRemove.add(item);
                    }
                }
                for (const element of elementsToRemove)writer.remove(element);
                return elementsToRemove.size > 0;
            });
        }
        editor.data.htmlProcessor.domConverter.registerInlineObjectMatcher((element)=>{
            if (element.name == definition.view && element.isEmpty && Array.from(element.getAttributeKeys()).length) return {
                name: true
            };
            return null;
        });
        conversion.for("editingDowncast").elementToElement({
            model: "htmlEmptyElement",
            view: $50e4d8c8f321fe5d$export$445710c283dd57a5(definition, true)
        });
        conversion.for("dataDowncast").elementToElement({
            model: "htmlEmptyElement",
            view: $50e4d8c8f321fe5d$export$445710c283dd57a5(definition)
        });
    }
};
/**
* Matches and consumes matched attributes.
*
* @returns Object with following properties:
* - attributes Array with matched attribute names.
* - classes Array with matched class names.
* - styles Array with matched style names.
*/ function $50e4d8c8f321fe5d$var$matchAndConsumeAttributes(viewElement, matcher, consumable) {
    const matches = matcher.matchAll(viewElement) || [];
    const stylesProcessor = viewElement.document.stylesProcessor;
    return matches.reduce((result, { match: match })=>{
        for (const [key, token] of match.attributes || [])if (key == "style") {
            const style = token;
            const sortedRelatedStyles = stylesProcessor.getRelatedStyles(style).filter((relatedStyle)=>relatedStyle.split("-").length > style.split("-").length).sort((a, b)=>b.split("-").length - a.split("-").length);
            for (const relatedStyle of sortedRelatedStyles)if (consumable.consume(viewElement, {
                styles: [
                    relatedStyle
                ]
            })) result.styles.push(relatedStyle);
            if (consumable.consume(viewElement, {
                styles: [
                    style
                ]
            })) result.styles.push(style);
        } else if (key == "class") {
            const className = token;
            if (consumable.consume(viewElement, {
                classes: [
                    className
                ]
            })) result.classes.push(className);
        } else if (consumable.consume(viewElement, {
            attributes: [
                key
            ]
        })) result.attributes.push(key);
        return result;
    }, {
        attributes: [],
        classes: [],
        styles: []
    });
}
/**
* Prepares the GHS attribute value as an object with element attributes' values.
*/ function $50e4d8c8f321fe5d$var$prepareGHSAttribute(viewElement, { attributes: attributes, classes: classes, styles: styles }) {
    if (!attributes.length && !classes.length && !styles.length) return null;
    return {
        ...attributes.length && {
            attributes: $50e4d8c8f321fe5d$var$getAttributes(viewElement, attributes)
        },
        ...styles.length && {
            styles: $50e4d8c8f321fe5d$var$getReducedStyles(viewElement, styles)
        },
        ...classes.length && {
            classes: classes
        }
    };
}
/**
* Returns attributes as an object with names and values.
*/ function $50e4d8c8f321fe5d$var$getAttributes(viewElement, attributes) {
    const attributesObject = {};
    for (const key of attributes){
        const value = viewElement.getAttribute(key);
        if (value !== void 0 && (0, $c7bc2cb7e2db0227$export$c8238713f6b74780)(key)) attributesObject[key] = value;
    }
    return attributesObject;
}
/**
* Returns styles as an object reduced to shorthand notation without redundant entries.
*/ function $50e4d8c8f321fe5d$var$getReducedStyles(viewElement, styles) {
    const stylesMap = new (0, $b9b9f2bdf9c6137f$export$a256655bfa1a33f5)(viewElement.document.stylesProcessor);
    for (const key of styles){
        const styleValue = viewElement.getStyle(key);
        if (styleValue !== void 0) stylesMap.set(key, styleValue);
    }
    return Object.fromEntries(stylesMap.getStylesEntries());
}
/**
* Matcher by default has to match **all** patterns to count it as an actual match. Splitting the pattern
* into separate patterns means that any matched pattern will be count as a match.
*
* @param pattern Pattern to split.
* @param attributeName Name of the attribute to split (e.g. 'attributes', 'classes', 'styles').
*/ function $50e4d8c8f321fe5d$var$splitPattern(pattern, attributeName) {
    const { name: name } = pattern;
    const attributeValue = pattern[attributeName];
    if ((0, $cfdff0c7ad4315d7$export$53b83ca8eaab0383)(attributeValue)) return Object.entries(attributeValue).map(([key, value])=>({
            name: name,
            [attributeName]: {
                [key]: value
            }
        }));
    if (Array.isArray(attributeValue)) return attributeValue.map((value)=>({
            name: name,
            [attributeName]: [
                value
            ]
        }));
    return [
        pattern
    ];
}
/**
* Rules are matched in conjunction (AND operation), but we want to have a match if *any* of the rules is matched (OR operation).
* By splitting the rules we force the latter effect.
*/ function $50e4d8c8f321fe5d$var$splitRules(rules) {
    const { name: name, attributes: attributes, classes: classes, styles: styles } = rules;
    const splitRules = [];
    if (attributes) splitRules.push(...$50e4d8c8f321fe5d$var$splitPattern({
        name: name,
        attributes: attributes
    }, "attributes"));
    if (classes) splitRules.push(...$50e4d8c8f321fe5d$var$splitPattern({
        name: name,
        classes: classes
    }, "classes"));
    if (styles) splitRules.push(...$50e4d8c8f321fe5d$var$splitPattern({
        name: name,
        styles: styles
    }, "styles"));
    return splitRules;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Provides the General HTML Support integration with {@link module:code-block/codeblock~CodeBlock Code Block} feature.
*/ var $50e4d8c8f321fe5d$export$610b280ae9ae60c0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CodeBlockElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        if (!this.editor.plugins.has("CodeBlockEditing")) return;
        const dataFilter = this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.on("register:pre", (evt, definition)=>{
            if (definition.model !== "codeBlock") return;
            const editor = this.editor;
            const schema = editor.model.schema;
            const conversion = editor.conversion;
            schema.extend("codeBlock", {
                allowAttributes: [
                    "htmlPreAttributes",
                    "htmlContentAttributes"
                ]
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelCodeBlockAttributeConverter(dataFilter));
            conversion.for("downcast").add($50e4d8c8f321fe5d$var$modelToViewCodeBlockAttributeConverter());
            evt.stop();
        });
    }
};
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:code-block/codeblock~CodeBlock Code Block}
* feature model element.
*
* Attributes are preserved as a value of `html*Attributes` model attribute.
* @param dataFilter
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelCodeBlockAttributeConverter(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:code", (evt, data, conversionApi)=>{
            const viewCodeElement = data.viewItem;
            const viewPreElement = viewCodeElement.parent;
            if (!viewPreElement || !viewPreElement.is("element", "pre")) return;
            if (!data.modelRange) return;
            preserveElementAttributes(viewPreElement, "htmlPreAttributes");
            preserveElementAttributes(viewCodeElement, "htmlContentAttributes");
            function preserveElementAttributes(viewElement, attributeName) {
                const viewAttributes = dataFilter.processViewAttributes(viewElement, conversionApi);
                if (viewAttributes) conversionApi.writer.setAttribute(attributeName, viewAttributes, data.modelRange);
            }
        }, {
            priority: "low"
        });
    };
}
/**
* Model-to-view conversion helper applying attributes from {@link module:code-block/codeblock~CodeBlock Code Block}
* feature model element.
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$modelToViewCodeBlockAttributeConverter() {
    return (dispatcher)=>{
        dispatcher.on("attribute:htmlPreAttributes:codeBlock", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
            const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
            const viewPreElement = conversionApi.mapper.toViewElement(data.item).parent;
            $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewPreElement);
        });
        dispatcher.on("attribute:htmlContentAttributes:codeBlock", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
            const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
            const viewCodeElement = conversionApi.mapper.toViewElement(data.item);
            $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewCodeElement);
        });
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Provides the General HTML Support integration for elements which can behave like sectioning element (e.g. article) or
* element accepting only inline content (e.g. paragraph).
*
* The distinction between this two content models is important for choosing correct schema model and proper content conversion.
* As an example, it ensures that:
*
* * children elements paragraphing is enabled for sectioning elements only,
* * element and its content can be correctly handled by editing view (splitting and merging elements),
* * model element HTML is semantically correct and easier to work with.
*
* If element contains any block element, it will be treated as a sectioning element and registered using
* {@link module:html-support/dataschema~HtmlSupportDataSchemaDefinition#model} and
* {@link module:html-support/dataschema~HtmlSupportDataSchemaDefinition#modelSchema} in editor schema.
* Otherwise, it will be registered under
* {@link module:html-support/dataschema~HtmlSupportDataSchemaBlockElementDefinition#paragraphLikeModel} model
* name with model schema accepting only inline content (inheriting from `$block`).
*/ var $50e4d8c8f321fe5d$export$77cc837ad8837bcb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "DualContentModelElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96).on("register", (evt, definition)=>{
            const blockDefinition = definition;
            const editor = this.editor;
            const schema = editor.model.schema;
            const conversion = editor.conversion;
            if (!blockDefinition.paragraphLikeModel) return;
            if (schema.isRegistered(blockDefinition.model) || schema.isRegistered(blockDefinition.paragraphLikeModel)) return;
            const paragraphLikeModelDefinition = {
                model: blockDefinition.paragraphLikeModel,
                view: blockDefinition.view
            };
            schema.register(blockDefinition.model, blockDefinition.modelSchema);
            schema.register(paragraphLikeModelDefinition.model, {
                inheritAllFrom: "$block"
            });
            conversion.for("upcast").elementToElement({
                view: blockDefinition.view,
                model: (viewElement, { writer: writer })=>{
                    if (this._hasBlockContent(viewElement)) return writer.createElement(blockDefinition.model);
                    return writer.createElement(paragraphLikeModelDefinition.model);
                },
                converterPriority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low + .5
            });
            conversion.for("downcast").elementToElement({
                view: blockDefinition.view,
                model: blockDefinition.model
            });
            this._addAttributeConversion(blockDefinition);
            conversion.for("downcast").elementToElement({
                view: paragraphLikeModelDefinition.view,
                model: paragraphLikeModelDefinition.model
            });
            this._addAttributeConversion(paragraphLikeModelDefinition);
            evt.stop();
        });
    }
    /**
	* Checks whether the given view element includes any other block element.
	*/ _hasBlockContent(viewElement) {
        const view = this.editor.editing.view;
        const blockElements = view.domConverter.blockElements;
        for (const viewItem of view.createRangeIn(viewElement).getItems())if (viewItem.is("element") && blockElements.includes(viewItem.name)) return true;
        return false;
    }
    /**
	* Adds attribute filtering conversion for the given data schema.
	*/ _addAttributeConversion(definition) {
        const editor = this.editor;
        const conversion = editor.conversion;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        editor.model.schema.extend(definition.model, {
            allowAttributes: $50e4d8c8f321fe5d$export$395cfe6a282469b9(definition.view)
        });
        conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, dataFilter));
        conversion.for("downcast").add($50e4d8c8f321fe5d$export$191f7098d98d50df(definition));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/heading
*/ /**
* Provides the General HTML Support integration with {@link module:heading/heading~Heading Heading} feature.
*/ var $50e4d8c8f321fe5d$export$e487eebdc6448e97 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$80c7772e4612893e,
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HeadingElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("HeadingEditing")) return;
        const options = editor.config.get("heading.options");
        this.registerHeadingElements(editor, options);
    }
    /**
	* Registers all elements supported by HeadingEditing to enable custom attributes for those elements.
	*/ registerHeadingElements(editor, options) {
        const dataSchema = editor.plugins.get($50e4d8c8f321fe5d$export$80c7772e4612893e);
        const headerModels = [];
        for (const option of options)if ("model" in option && "view" in option) {
            dataSchema.registerBlockElement({
                view: option.view,
                model: option.model
            });
            headerModels.push(option.model);
        }
        dataSchema.extendBlockElement({
            model: "htmlHgroup",
            modelSchema: {
                allowChildren: headerModels
            }
        });
        dataSchema.extendBlockElement({
            model: "htmlSummary",
            modelSchema: {
                allowChildren: headerModels
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns the first view element descendant matching the given view name.
* Includes view element itself.
*
* @internal
*/ function $50e4d8c8f321fe5d$export$791007abe73933a6(writer, containerElement, elementName) {
    const range = writer.createRangeOn(containerElement);
    for (const { item: item } of range.getWalker())if (item.is("element", elementName)) return item;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/image
*/ /**
* Provides the General HTML Support integration with the {@link module:image/image~Image Image} feature.
*/ var $50e4d8c8f321fe5d$export$baad3c9d369bf18 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ImageElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("ImageInlineEditing") && !editor.plugins.has("ImageBlockEditing")) return;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.on("register:figure", ()=>{
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelFigureAttributeConverter$1(dataFilter));
        });
        dataFilter.on("register:img", (evt, definition)=>{
            if (definition.model !== "imageBlock" && definition.model !== "imageInline") return;
            if (schema.isRegistered("imageBlock")) schema.extend("imageBlock", {
                allowAttributes: [
                    "htmlImgAttributes",
                    "htmlFigureAttributes",
                    "htmlLinkAttributes"
                ]
            });
            if (schema.isRegistered("imageInline")) schema.extend("imageInline", {
                allowAttributes: [
                    "htmlA",
                    "htmlImgAttributes"
                ]
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelImageAttributeConverter(dataFilter));
            conversion.for("downcast").add($50e4d8c8f321fe5d$var$modelToViewImageAttributeConverter());
            if (editor.plugins.has("LinkImage")) conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelLinkImageAttributeConverter(dataFilter, editor));
            evt.stop();
        });
    }
};
/**
* View-to-model conversion helper preserving allowed attributes on the {@link module:image/image~Image Image}
* feature model element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelImageAttributeConverter(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:img", (evt, data, conversionApi)=>{
            if (!data.modelRange) return;
            const viewImageElement = data.viewItem;
            const viewAttributes = dataFilter.processViewAttributes(viewImageElement, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute("htmlImgAttributes", viewAttributes, data.modelRange);
        }, {
            priority: "low"
        });
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:image/image~Image Image}
* feature model element from link view element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelLinkImageAttributeConverter(dataFilter, editor) {
    const imageUtils = editor.plugins.get("ImageUtils");
    return (dispatcher)=>{
        dispatcher.on("element:a", (evt, data, conversionApi)=>{
            const viewLink = data.viewItem;
            if (!imageUtils.findViewImgElement(viewLink)) return;
            const modelImage = data.modelCursor.parent;
            if (!modelImage.is("element", "imageBlock")) return;
            const viewAttributes = dataFilter.processViewAttributes(viewLink, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute("htmlLinkAttributes", viewAttributes, modelImage);
        }, {
            priority: "low"
        });
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:image/image~Image Image}
* feature model element from figure view element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelFigureAttributeConverter$1(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:figure", (evt, data, conversionApi)=>{
            const viewFigureElement = data.viewItem;
            if (!data.modelRange || !viewFigureElement.hasClass("image")) return;
            const viewAttributes = dataFilter.processViewAttributes(viewFigureElement, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute("htmlFigureAttributes", viewAttributes, data.modelRange);
        }, {
            priority: "low"
        });
    };
}
/**
* A model-to-view conversion helper applying attributes from the {@link module:image/image~Image Image}
* feature.
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$modelToViewImageAttributeConverter() {
    return (dispatcher)=>{
        addInlineAttributeConversion("htmlImgAttributes");
        addBlockAttributeConversion("img", "htmlImgAttributes");
        addBlockAttributeConversion("figure", "htmlFigureAttributes");
        addBlockAttributeConversion("a", "htmlLinkAttributes");
        function addInlineAttributeConversion(attributeName) {
            dispatcher.on(`attribute:${attributeName}:imageInline`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
                const viewElement = conversionApi.mapper.toViewElement(data.item);
                $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewElement);
            }, {
                priority: "low"
            });
        }
        function addBlockAttributeConversion(elementName, attributeName) {
            dispatcher.on(`attribute:${attributeName}:imageBlock`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.test(data.item, evt.name)) return;
                const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
                const containerElement = conversionApi.mapper.toViewElement(data.item);
                const viewElement = $50e4d8c8f321fe5d$export$791007abe73933a6(conversionApi.writer, containerElement, elementName);
                if (viewElement) {
                    $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewElement);
                    conversionApi.consumable.consume(data.item, evt.name);
                }
            }, {
                priority: "low"
            });
            if (elementName === "a") dispatcher.on("attribute:linkHref:imageBlock", (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, "attribute:htmlLinkAttributes:imageBlock")) return;
                const containerElement = conversionApi.mapper.toViewElement(data.item);
                const viewElement = $50e4d8c8f321fe5d$export$791007abe73933a6(conversionApi.writer, containerElement, "a");
                $50e4d8c8f321fe5d$export$38c7989c142fe34(conversionApi.writer, data.item.getAttribute("htmlLinkAttributes"), viewElement);
            }, {
                priority: "low"
            });
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/mediaembed
*/ /**
* Provides the General HTML Support integration with {@link module:media-embed/mediaembed~MediaEmbed Media Embed} feature.
*/ var $50e4d8c8f321fe5d$export$3a0392b9bc51c13f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("MediaEmbed") || editor.config.get("mediaEmbed.previewsInData")) return;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const dataFilter = this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        const dataSchema = this.editor.plugins.get($50e4d8c8f321fe5d$export$80c7772e4612893e);
        const mediaElementName = editor.config.get("mediaEmbed.elementName");
        dataSchema.registerBlockElement({
            model: "media",
            view: mediaElementName
        });
        dataFilter.on("register:figure", ()=>{
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelFigureAttributesConverter(dataFilter));
        });
        dataFilter.on(`register:${mediaElementName}`, (evt, definition)=>{
            if (definition.model !== "media") return;
            schema.extend("media", {
                allowAttributes: [
                    $50e4d8c8f321fe5d$export$395cfe6a282469b9(mediaElementName),
                    "htmlFigureAttributes"
                ]
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelMediaAttributesConverter(dataFilter, mediaElementName));
            conversion.for("dataDowncast").add($50e4d8c8f321fe5d$var$modelToViewMediaAttributeConverter(mediaElementName));
            evt.stop();
        });
    }
};
function $50e4d8c8f321fe5d$var$viewToModelMediaAttributesConverter(dataFilter, mediaElementName) {
    const upcastMedia = (evt, data, conversionApi)=>{
        const viewMediaElement = data.viewItem;
        preserveElementAttributes(viewMediaElement, $50e4d8c8f321fe5d$export$395cfe6a282469b9(mediaElementName));
        function preserveElementAttributes(viewElement, attributeName) {
            const viewAttributes = dataFilter.processViewAttributes(viewElement, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute(attributeName, viewAttributes, data.modelRange);
        }
    };
    return (dispatcher)=>{
        dispatcher.on(`element:${mediaElementName}`, upcastMedia, {
            priority: "low"
        });
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:media-embed/mediaembed~MediaEmbed MediaEmbed}
* feature model element from figure view element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelFigureAttributesConverter(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:figure", (evt, data, conversionApi)=>{
            const viewFigureElement = data.viewItem;
            if (!data.modelRange || !viewFigureElement.hasClass("media")) return;
            const viewAttributes = dataFilter.processViewAttributes(viewFigureElement, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute("htmlFigureAttributes", viewAttributes, data.modelRange);
        }, {
            priority: "low"
        });
    };
}
function $50e4d8c8f321fe5d$var$modelToViewMediaAttributeConverter(mediaElementName) {
    return (dispatcher)=>{
        addAttributeConversionDispatcherHandler(mediaElementName, $50e4d8c8f321fe5d$export$395cfe6a282469b9(mediaElementName));
        addAttributeConversionDispatcherHandler("figure", "htmlFigureAttributes");
        function addAttributeConversionDispatcherHandler(elementName, attributeName) {
            dispatcher.on(`attribute:${attributeName}:media`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
                const containerElement = conversionApi.mapper.toViewElement(data.item);
                const viewElement = $50e4d8c8f321fe5d$export$791007abe73933a6(conversionApi.writer, containerElement, elementName);
                $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewElement);
            });
        }
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/script
*/ /**
* Provides the General HTML Support for `script` elements.
*/ var $50e4d8c8f321fe5d$export$5c2885129541421a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ScriptElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const dataFilter = this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.on("register:script", (evt, definition)=>{
            const editor = this.editor;
            const schema = editor.model.schema;
            const conversion = editor.conversion;
            schema.register("htmlScript", definition.modelSchema);
            schema.extend("htmlScript", {
                allowAttributes: [
                    "htmlScriptAttributes",
                    "htmlContent"
                ],
                isContent: true
            });
            editor.data.registerRawContentMatcher({
                name: "script"
            });
            conversion.for("upcast").elementToElement({
                view: "script",
                model: $50e4d8c8f321fe5d$export$4e187ae03d42336c(definition)
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, dataFilter));
            conversion.for("downcast").elementToElement({
                model: "htmlScript",
                view: (modelElement, { writer: writer })=>{
                    return $50e4d8c8f321fe5d$export$1c80172b00cd66ac("script", modelElement, writer);
                }
            });
            conversion.for("downcast").add($50e4d8c8f321fe5d$export$191f7098d98d50df(definition));
            evt.stop();
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $50e4d8c8f321fe5d$var$STYLE_ATTRIBUTES_TO_PROPAGATE = [
    "width",
    "max-width",
    "min-width",
    "height",
    "min-height",
    "max-height"
];
/**
* Provides the General HTML Support integration with {@link module:table/table~Table Table} feature.
*/ var $50e4d8c8f321fe5d$export$f018ab41b89c5ae7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("TableEditing")) return;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        const tableUtils = editor.plugins.get("TableUtils");
        dataFilter.on("register:figure", ()=>{
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelFigureAttributeConverter(dataFilter));
        });
        dataFilter.on("register:table", (evt, definition)=>{
            if (definition.model !== "table") return;
            schema.extend("table", {
                allowAttributes: [
                    "htmlTableAttributes",
                    "htmlFigureAttributes",
                    "htmlTheadAttributes",
                    "htmlTbodyAttributes",
                    "htmlTfootAttributes"
                ]
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$var$viewToModelTableAttributeConverter(dataFilter));
            conversion.for("downcast").add($50e4d8c8f321fe5d$var$modelToViewTableAttributeConverter());
            editor.model.document.registerPostFixer($50e4d8c8f321fe5d$var$createHeadingRowsPostFixer(editor.model, tableUtils));
            evt.stop();
        });
    }
};
/**
* Creates a model post-fixer for thead, tbody and tfoot GHS related attributes.
*/ function $50e4d8c8f321fe5d$var$createHeadingRowsPostFixer(model, tableUtils) {
    return (writer)=>{
        const changes = model.document.differ.getChanges();
        let wasFixed = false;
        for (const change of changes){
            if (change.type != "attribute" || change.attributeKey != "headingRows" && change.attributeKey != "footerRows") continue;
            const table = change.range.start.nodeAfter;
            const hasTHeadAttributes = table.getAttribute("htmlTheadAttributes");
            const hasTBodyAttributes = table.getAttribute("htmlTbodyAttributes");
            const hasTFootAttributes = table.getAttribute("htmlTfootAttributes");
            if (hasTHeadAttributes && change.attributeKey === "headingRows" && !change.attributeNewValue) {
                writer.removeAttribute("htmlTheadAttributes", table);
                wasFixed = true;
            }
            if (hasTFootAttributes && change.attributeKey === "footerRows" && !change.attributeNewValue) {
                writer.removeAttribute("htmlTfootAttributes", table);
                wasFixed = true;
            }
            if (hasTBodyAttributes) {
                if ((table.getAttribute("headingRows") || 0) + (table.getAttribute("footerRows") || 0) == tableUtils.getRows(table)) {
                    writer.removeAttribute("htmlTbodyAttributes", table);
                    wasFixed = true;
                }
            }
        }
        return wasFixed;
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:table/table~Table Table}
* feature model element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelTableAttributeConverter(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            if (!data.modelRange) return;
            const viewTableElement = data.viewItem;
            conversionApi.consumable.consume(viewTableElement, {
                classes: "table"
            });
            preserveElementAttributes(viewTableElement, "htmlTableAttributes");
            for (const childNode of viewTableElement.getChildren()){
                if (childNode.is("element", "thead")) preserveElementAttributes(childNode, "htmlTheadAttributes");
                if (childNode.is("element", "tfoot")) preserveElementAttributes(childNode, "htmlTfootAttributes");
                if (childNode.is("element", "tbody")) preserveElementAttributes(childNode, "htmlTbodyAttributes");
            }
            function preserveElementAttributes(viewElement, attributeName) {
                const viewAttributes = dataFilter.processViewAttributes(viewElement, conversionApi);
                if (viewAttributes) conversionApi.writer.setAttribute(attributeName, viewAttributes, data.modelRange);
            }
        }, {
            priority: "low"
        });
    };
}
/**
* View-to-model conversion helper preserving allowed attributes on {@link module:table/table~Table Table}
* feature model element from figure view element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelFigureAttributeConverter(dataFilter) {
    return (dispatcher)=>{
        dispatcher.on("element:figure", (evt, data, conversionApi)=>{
            const viewFigureElement = data.viewItem;
            if (!data.modelRange || !viewFigureElement.hasClass("table")) return;
            const viewAttributes = dataFilter.processViewAttributes(viewFigureElement, conversionApi);
            if (viewAttributes) conversionApi.writer.setAttribute("htmlFigureAttributes", viewAttributes, data.modelRange);
        }, {
            priority: "low"
        });
    };
}
/**
* Model-to-view conversion helper applying attributes from {@link module:table/table~Table Table}
* feature.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$modelToViewTableAttributeConverter() {
    return (dispatcher)=>{
        addAttributeConversionDispatcherHandler("table", "htmlTableAttributes");
        addAttributeConversionDispatcherHandler("figure", "htmlFigureAttributes");
        addAttributeConversionDispatcherHandler("thead", "htmlTheadAttributes");
        addAttributeConversionDispatcherHandler("tbody", "htmlTbodyAttributes");
        addAttributeConversionDispatcherHandler("tfoot", "htmlTfootAttributes");
        function addAttributeConversionDispatcherHandler(elementName, attributeName) {
            dispatcher.on(`attribute:${attributeName}:table`, (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.test(data.item, evt.name)) return;
                const containerElement = conversionApi.mapper.toViewElement(data.item);
                const viewElement = $50e4d8c8f321fe5d$export$791007abe73933a6(conversionApi.writer, containerElement, elementName);
                if (!viewElement) return;
                conversionApi.consumable.consume(data.item, evt.name);
                if (attributeName === "htmlTableAttributes" && containerElement !== viewElement) {
                    const oldAttributes = $50e4d8c8f321fe5d$var$splitAttributesForFigureAndTable(data.attributeOldValue);
                    const newAttributes = $50e4d8c8f321fe5d$var$splitAttributesForFigureAndTable(data.attributeNewValue);
                    $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, oldAttributes.tableAttributes, newAttributes.tableAttributes, viewElement);
                    $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, oldAttributes.figureAttributes, newAttributes.figureAttributes, containerElement);
                } else $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, data.attributeOldValue, data.attributeNewValue, viewElement);
            });
        }
    };
}
/**
* Splits styles based on the `STYLE_ATTRIBUTES_TO_PROPAGATE` pattern that should be moved to the parent element
* and those that should remain on element.
*/ function $50e4d8c8f321fe5d$var$splitAttributesForFigureAndTable(data) {
    const figureAttributes = {};
    const tableAttributes = {
        ...data
    };
    if (!data || !("styles" in data)) return {
        figureAttributes: figureAttributes,
        tableAttributes: tableAttributes
    };
    tableAttributes.styles = {};
    for (const [key, value] of Object.entries(data.styles))if ($50e4d8c8f321fe5d$var$STYLE_ATTRIBUTES_TO_PROPAGATE.includes(key)) figureAttributes.styles = {
        ...figureAttributes.styles,
        [key]: value
    };
    else tableAttributes.styles = {
        ...tableAttributes.styles,
        [key]: value
    };
    return {
        figureAttributes: figureAttributes,
        tableAttributes: tableAttributes
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/style
*/ /**
* Provides the General HTML Support for `style` elements.
*/ var $50e4d8c8f321fe5d$export$4058fd4f2df3043 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StyleElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const dataFilter = this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.on("register:style", (evt, definition)=>{
            const editor = this.editor;
            const schema = editor.model.schema;
            const conversion = editor.conversion;
            schema.register("htmlStyle", definition.modelSchema);
            schema.extend("htmlStyle", {
                allowAttributes: [
                    "htmlStyleAttributes",
                    "htmlContent"
                ],
                isContent: true
            });
            editor.data.registerRawContentMatcher({
                name: "style"
            });
            conversion.for("upcast").elementToElement({
                view: "style",
                model: $50e4d8c8f321fe5d$export$4e187ae03d42336c(definition)
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, dataFilter));
            conversion.for("downcast").elementToElement({
                model: "htmlStyle",
                view: (modelElement, { writer: writer })=>{
                    return $50e4d8c8f321fe5d$export$1c80172b00cd66ac("style", modelElement, writer);
                }
            });
            conversion.for("downcast").add($50e4d8c8f321fe5d$export$191f7098d98d50df(definition));
            evt.stop();
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/list
*/ /**
* Provides the General HTML Support integration with the {@link module:list/list~List List} feature.
*/ var $50e4d8c8f321fe5d$export$ec380505e509d7c9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("ListEditing")) return;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        const listEditing = editor.plugins.get("ListEditing");
        const listUtils = editor.plugins.get("ListUtils");
        const viewElements = [
            "ul",
            "ol",
            "li"
        ];
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "htmlLiAttributes",
            setAttributeOnDowncast: $50e4d8c8f321fe5d$export$38c7989c142fe34
        });
        listEditing.registerDowncastStrategy({
            scope: "list",
            attributeName: "htmlUlAttributes",
            setAttributeOnDowncast: $50e4d8c8f321fe5d$export$38c7989c142fe34
        });
        listEditing.registerDowncastStrategy({
            scope: "list",
            attributeName: "htmlOlAttributes",
            setAttributeOnDowncast: $50e4d8c8f321fe5d$export$38c7989c142fe34
        });
        dataFilter.on("register", (evt, definition)=>{
            if (!viewElements.includes(definition.view)) return;
            evt.stop();
            if (schema.checkAttribute("$block", "htmlLiAttributes")) return;
            const allowAttributes = viewElements.map((element)=>$50e4d8c8f321fe5d$export$395cfe6a282469b9(element));
            schema.extend("$listItem", {
                allowAttributes: allowAttributes
            });
            conversion.for("upcast").add((dispatcher)=>{
                dispatcher.on("element:ul", $50e4d8c8f321fe5d$var$viewToModelListAttributeConverter("htmlUlAttributes", "list", dataFilter), {
                    priority: "low"
                });
                dispatcher.on("element:ol", $50e4d8c8f321fe5d$var$viewToModelListAttributeConverter("htmlOlAttributes", "list", dataFilter), {
                    priority: "low"
                });
                dispatcher.on("element:li", $50e4d8c8f321fe5d$var$viewToModelListAttributeConverter("htmlLiAttributes", "item", dataFilter), {
                    priority: "low"
                });
            });
        });
        listEditing.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node, previousNodeInList: previousNodeInList } of listNodes){
                if (!previousNodeInList) continue;
                if (previousNodeInList.getAttribute("listType") == node.getAttribute("listType")) {
                    const attribute = $50e4d8c8f321fe5d$var$getAttributeFromListType(previousNodeInList.getAttribute("listType"));
                    const value = previousNodeInList.getAttribute(attribute);
                    if (!(0, $a48d2f3392454588$export$248d38f6296296c5)(node.getAttribute(attribute), value) && writer.model.schema.checkAttribute(node, attribute)) {
                        if (value === void 0) writer.removeAttribute(attribute, node);
                        else writer.setAttribute(attribute, value, node);
                        evt.return = true;
                    }
                }
                if (previousNodeInList.getAttribute("listItemId") == node.getAttribute("listItemId")) {
                    const value = previousNodeInList.getAttribute("htmlLiAttributes");
                    if (!(0, $a48d2f3392454588$export$248d38f6296296c5)(node.getAttribute("htmlLiAttributes"), value) && writer.model.schema.checkAttribute(node, "htmlLiAttributes")) {
                        if (value === void 0) writer.removeAttribute("htmlLiAttributes", node);
                        else writer.setAttribute("htmlLiAttributes", value, node);
                        evt.return = true;
                    }
                }
            }
        });
        listEditing.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node } of listNodes){
                const listType = node.getAttribute("listType");
                if (!listUtils.isNumberedListType(listType) && node.getAttribute("htmlOlAttributes")) {
                    writer.removeAttribute("htmlOlAttributes", node);
                    evt.return = true;
                }
                if (listUtils.isNumberedListType(listType) && node.getAttribute("htmlUlAttributes")) {
                    writer.removeAttribute("htmlUlAttributes", node);
                    evt.return = true;
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        if (!editor.commands.get("indentList")) return;
        const indentList = editor.commands.get("indentList");
        this.listenTo(indentList, "afterExecute", (evt, changedBlocks)=>{
            editor.model.change((writer)=>{
                for (const node of changedBlocks){
                    const attribute = $50e4d8c8f321fe5d$var$getAttributeFromListType(node.getAttribute("listType"));
                    if (!editor.model.schema.checkAttribute(node, attribute)) continue;
                    writer.removeAttribute(attribute, node);
                }
            });
        });
    }
};
/**
* View-to-model conversion helper preserving allowed attributes on {@link TODO}
* feature model element.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$viewToModelListAttributeConverter(attributeName, scope, dataFilter) {
    return (evt, data, conversionApi)=>{
        const viewElement = data.viewItem;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        const viewAttributes = dataFilter.processViewAttributes(viewElement, conversionApi);
        if (scope === "list" && !viewAttributes) return;
        const store = conversionApi.store;
        store.htmlSupportItemToClosestList ??= /* @__PURE__ */ new Map();
        const itemToClosestList = store.htmlSupportItemToClosestList;
        const closestList = scope === "item" ? $50e4d8c8f321fe5d$var$findClosestListAncestor(viewElement) : null;
        for (const item of data.modelRange.getItems({
            shallow: true
        })){
            if (!item.hasAttribute("listItemId")) continue;
            if (scope === "item") {
                if (itemToClosestList.has(item)) continue;
                itemToClosestList.set(item, closestList);
            } else if (itemToClosestList.get(item) !== viewElement) continue;
            if (viewAttributes && conversionApi.writer.model.schema.checkAttribute(item, attributeName)) conversionApi.writer.setAttribute(attributeName, viewAttributes, item);
        }
    };
}
/**
* Walks up the view tree from the given element and returns the first `<ul>`/`<ol>` ancestor,
* or `null` if there isn't one.
*/ function $50e4d8c8f321fe5d$var$findClosestListAncestor(viewElement) {
    let node = viewElement.parent;
    while(node){
        if (node.is("element", "ul") || node.is("element", "ol")) return node;
        node = node.parent;
    }
    return null;
}
/**
* Returns HTML attribute name based on provided list type.
*/ function $50e4d8c8f321fe5d$var$getAttributeFromListType(listType) {
    return listType === "numbered" || listType == "customNumbered" ? "htmlOlAttributes" : "htmlUlAttributes";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/horizontalline
*/ /**
* Provides the General HTML Support integration with the {@link module:horizontal-line/horizontalline~HorizontalLine} feature.
*/ var $50e4d8c8f321fe5d$export$3bd06e97dd1cf6b9 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HorizontalLineElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("HorizontalLineEditing")) return;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.on("register:hr", (evt, definition)=>{
            if (definition.model !== "horizontalLine") return;
            schema.extend("horizontalLine", {
                allowAttributes: [
                    "htmlHrAttributes"
                ]
            });
            conversion.for("upcast").add($50e4d8c8f321fe5d$export$5dab40fe165daba5(definition, dataFilter));
            conversion.for("downcast").add($50e4d8c8f321fe5d$var$modelToViewHorizontalLineAttributeConverter());
            evt.stop();
        });
    }
};
/**
* A model-to-view conversion helper applying attributes from the
* {@link module:horizontal-line/horizontalline~HorizontalLine HorizontalLine} feature.
*
* @returns Returns a conversion callback.
*/ function $50e4d8c8f321fe5d$var$modelToViewHorizontalLineAttributeConverter() {
    return (dispatcher)=>{
        dispatcher.on("attribute:htmlHrAttributes:horizontalLine", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.test(data.item, evt.name)) return;
            const { attributeOldValue: attributeOldValue, attributeNewValue: attributeNewValue } = data;
            const containerElement = conversionApi.mapper.toViewElement(data.item);
            const viewElement = $50e4d8c8f321fe5d$export$791007abe73933a6(conversionApi.writer, containerElement, "hr");
            if (viewElement) {
                $50e4d8c8f321fe5d$export$d59e97e9c560cbf5(conversionApi.writer, attributeOldValue, attributeNewValue, viewElement);
                conversionApi.consumable.consume(data.item, evt.name);
            }
        }, {
            priority: "low"
        });
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Provides the General HTML Support integration for `iframe` elements with a mandatory sandbox attribute.
*/ var $50e4d8c8f321fe5d$export$f71297259343c18d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "IframeElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.config.define("htmlSupport.htmlIframeSandbox", true);
        this._setupSandboxConversion();
    }
    /**
	* Sets up the conversion to enforce the sandbox attribute on `iframe` elements.
	*/ _setupSandboxConversion() {
        const { plugins: plugins, config: config, conversion: conversion } = this.editor;
        const dataFilter = plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        const iframeSandboxConfig = config.get("htmlSupport.htmlIframeSandbox");
        if (iframeSandboxConfig === false) return;
        const allowedSandboxFlags = Array.isArray(iframeSandboxConfig) ? Array.from(iframeSandboxConfig) : [];
        dataFilter.on("register:iframe", (_, definition)=>{
            conversion.for("editingDowncast").add((dispatcher)=>{
                dispatcher.on(`insert:${definition.model}`, (_, data, conversionApi)=>{
                    const { mapper: mapper, writer: writer } = conversionApi;
                    const viewElement = mapper.toViewElement(data.item);
                    for (const { item: item } of writer.createRangeOn(viewElement)){
                        if (!item.is("element", "iframe")) continue;
                        if (item.hasAttribute("sandbox")) {
                            const sandboxValues = /* @__PURE__ */ new Set();
                            const existingSandbox = item.getAttribute("sandbox");
                            for (const value of existingSandbox.trim().split(/\s+/))if (allowedSandboxFlags.includes(value)) sandboxValues.add(value);
                            writer.setAttribute("sandbox", Array.from(sandboxValues).join(" "), item);
                        } else writer.setAttribute("sandbox", allowedSandboxFlags.join(" "), item);
                    }
                }, {
                    priority: "lowest"
                });
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/integrations/customelement
*/ /**
* Provides the General HTML Support for custom elements (not registered in the {@link module:html-support/dataschema~DataSchema}).
*/ var $50e4d8c8f321fe5d$export$1d433caac7de8662 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96,
            $50e4d8c8f321fe5d$export$80c7772e4612893e
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "CustomElementSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const dataFilter = this.editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        const dataSchema = this.editor.plugins.get($50e4d8c8f321fe5d$export$80c7772e4612893e);
        dataFilter.on("register:$customElement", (evt, definition)=>{
            evt.stop();
            const editor = this.editor;
            const schema = editor.model.schema;
            const conversion = editor.conversion;
            const unsafeElements = editor.editing.view.domConverter.unsafeElements;
            const preLikeElements = editor.data.htmlProcessor.domConverter.preElements;
            schema.register(definition.model, definition.modelSchema);
            schema.extend(definition.model, {
                allowAttributes: [
                    "htmlElementName",
                    "htmlCustomElementAttributes",
                    "htmlContent"
                ],
                isContent: true
            });
            editor.data.htmlProcessor.domConverter.registerRawContentMatcher({
                name: "template"
            });
            conversion.for("upcast").elementToElement({
                view: /.*/,
                model: (viewElement, conversionApi)=>{
                    if (viewElement.name == "$comment") return null;
                    /* istanbul ignore next -- @preserve */ if (!$50e4d8c8f321fe5d$var$isValidElementName(viewElement.name)) return null;
                    if (dataSchema.getDefinitionsForView(viewElement.name).size) return null;
                    if (!unsafeElements.includes(viewElement.name)) unsafeElements.push(viewElement.name);
                    if (!preLikeElements.includes(viewElement.name)) preLikeElements.push(viewElement.name);
                    const modelElement = conversionApi.writer.createElement(definition.model, {
                        htmlElementName: viewElement.name
                    });
                    const htmlAttributes = dataFilter.processViewAttributes(viewElement, conversionApi);
                    if (htmlAttributes) conversionApi.writer.setAttribute("htmlCustomElementAttributes", htmlAttributes, modelElement);
                    let htmlContent;
                    if (viewElement.is("element", "template") && viewElement.getCustomProperty("$rawContent")) htmlContent = viewElement.getCustomProperty("$rawContent");
                    else {
                        const documentFragment = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(viewElement.document).createDocumentFragment(viewElement);
                        const domFragment = editor.data.htmlProcessor.domConverter.viewToDom(documentFragment);
                        const domElement = domFragment.firstChild;
                        while(domElement.firstChild)domFragment.appendChild(domElement.firstChild);
                        domElement.remove();
                        htmlContent = editor.data.htmlProcessor.htmlWriter.getHtml(domFragment);
                    }
                    conversionApi.writer.setAttribute("htmlContent", htmlContent, modelElement);
                    for (const { item: item } of editor.editing.view.createRangeIn(viewElement))conversionApi.consumable.consume(item, {
                        name: true
                    });
                    return modelElement;
                },
                converterPriority: "low"
            });
            conversion.for("editingDowncast").elementToElement({
                model: {
                    name: definition.model,
                    attributes: [
                        "htmlElementName",
                        "htmlCustomElementAttributes",
                        "htmlContent"
                    ]
                },
                view: (modelElement, { writer: writer })=>{
                    const viewName = modelElement.getAttribute("htmlElementName");
                    const viewElement = writer.createRawElement(viewName);
                    if (modelElement.hasAttribute("htmlCustomElementAttributes")) $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, modelElement.getAttribute("htmlCustomElementAttributes"), viewElement);
                    return viewElement;
                }
            });
            conversion.for("dataDowncast").elementToElement({
                model: {
                    name: definition.model,
                    attributes: [
                        "htmlElementName",
                        "htmlCustomElementAttributes",
                        "htmlContent"
                    ]
                },
                view: (modelElement, { writer: writer })=>{
                    const viewName = modelElement.getAttribute("htmlElementName");
                    const htmlContent = modelElement.getAttribute("htmlContent");
                    const viewElement = writer.createRawElement(viewName, null, (domElement, domConverter)=>{
                        domConverter.setContentOf(domElement, htmlContent);
                    });
                    if (modelElement.hasAttribute("htmlCustomElementAttributes")) $50e4d8c8f321fe5d$export$38c7989c142fe34(writer, modelElement.getAttribute("htmlCustomElementAttributes"), viewElement);
                    return viewElement;
                }
            });
        });
    }
};
/**
* Returns true if name is valid for a DOM element name.
*/ function $50e4d8c8f321fe5d$var$isValidElementName(name) {
    try {
        document.createElement(name);
    } catch  {
        /* istanbul ignore next -- @preserve */ return false;
    }
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/generalhtmlsupport
*/ /**
* The General HTML Support feature.
*
* This is a "glue" plugin which initializes the {@link module:html-support/datafilter~DataFilter data filter} configuration
* and features integration with the General HTML Support.
*/ var $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "GeneralHtmlSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $50e4d8c8f321fe5d$export$bf2cd9c1afd10b96,
            $50e4d8c8f321fe5d$export$610b280ae9ae60c0,
            $50e4d8c8f321fe5d$export$77cc837ad8837bcb,
            $50e4d8c8f321fe5d$export$e487eebdc6448e97,
            $50e4d8c8f321fe5d$export$baad3c9d369bf18,
            $50e4d8c8f321fe5d$export$3a0392b9bc51c13f,
            $50e4d8c8f321fe5d$export$5c2885129541421a,
            $50e4d8c8f321fe5d$export$f018ab41b89c5ae7,
            $50e4d8c8f321fe5d$export$4058fd4f2df3043,
            $50e4d8c8f321fe5d$export$ec380505e509d7c9,
            $50e4d8c8f321fe5d$export$3bd06e97dd1cf6b9,
            $50e4d8c8f321fe5d$export$f71297259343c18d,
            $50e4d8c8f321fe5d$export$1d433caac7de8662
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const dataFilter = editor.plugins.get($50e4d8c8f321fe5d$export$bf2cd9c1afd10b96);
        dataFilter.loadAllowedEmptyElementsConfig(editor.config.get("htmlSupport.allowEmpty") || []);
        dataFilter.loadAllowedConfig(editor.config.get("htmlSupport.allow") || []);
        dataFilter.loadDisallowedConfig(editor.config.get("htmlSupport.disallow") || []);
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this.editor.commands.get("removeFormat")?.registerCustomAttribute((attributeName)=>attributeName.startsWith("html") && attributeName.endsWith("Attributes"), $50e4d8c8f321fe5d$var$removeFormatting);
    }
    /**
	* Returns a GHS model attribute name related to a given view element name.
	*
	* @internal
	* @param viewElementName A view element name.
	*/ getGhsAttributeNameForElement(viewElementName) {
        const dataSchema = this.editor.plugins.get("DataSchema");
        const definitions = Array.from(dataSchema.getDefinitionsForView(viewElementName, false));
        const inlineDefinition = definitions.find((definition)=>definition.isInline && !definitions[0].isObject);
        if (inlineDefinition) return inlineDefinition.model;
        return $50e4d8c8f321fe5d$export$395cfe6a282469b9(viewElementName);
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it includes the given class name.
	*
	* @internal
	* @param viewElementName A view element name.
	* @param className The css class to add.
	* @param selectable The selection or element to update.
	*/ addModelHtmlClass(viewElementName, className, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "classes", (classes)=>{
                for (const value of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(className))classes.add(value);
            });
        });
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it does not include the given class name.
	*
	* @internal
	* @param viewElementName A view element name.
	* @param className The css class to remove.
	* @param selectable The selection or element to update.
	*/ removeModelHtmlClass(viewElementName, className, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "classes", (classes)=>{
                for (const value of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(className))classes.delete(value);
            });
        });
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it includes the given attribute.
	*
	* @param viewElementName A view element name.
	* @param attributes The object with attributes to set.
	* @param selectable The selection or element to update.
	*/ setModelHtmlAttributes(viewElementName, attributes, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "attributes", (attributesMap)=>{
                for (const [key, value] of Object.entries(attributes))attributesMap.set(key, value);
            });
        });
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it does not include the given attribute.
	*
	* @param viewElementName A view element name.
	* @param attributeName The attribute name (or names) to remove.
	* @param selectable The selection or element to update.
	*/ removeModelHtmlAttributes(viewElementName, attributeName, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "attributes", (attributesMap)=>{
                for (const key of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(attributeName))attributesMap.delete(key);
            });
        });
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it includes a given style.
	*
	* @param viewElementName A view element name.
	* @param styles The object with styles to set.
	* @param selectable The selection or element to update.
	*/ setModelHtmlStyles(viewElementName, styles, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "styles", (stylesMap)=>{
                for (const [key, value] of Object.entries(styles))stylesMap.set(key, value);
            });
        });
    }
    /**
	* Updates GHS model attribute for a specified view element name, so it does not include a given style.
	*
	* @param viewElementName A view element name.
	* @param properties The style (or styles list) to remove.
	* @param selectable The selection or element to update.
	*/ removeModelHtmlStyles(viewElementName, properties, selectable) {
        const model = this.editor.model;
        const ghsAttributeName = this.getGhsAttributeNameForElement(viewElementName);
        model.change((writer)=>{
            for (const item of $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName))$50e4d8c8f321fe5d$export$d7a4fae41c1b6e36(writer, item, ghsAttributeName, "styles", (stylesMap)=>{
                for (const key of (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(properties))stylesMap.delete(key);
            });
        });
    }
};
/**
* Returns an iterator over an items in the selectable that accept given GHS attribute.
*/ function* $50e4d8c8f321fe5d$var$getItemsToUpdateGhsAttribute(model, selectable, ghsAttributeName) {
    if (!selectable) return;
    if (!(Symbol.iterator in selectable) && selectable.is("documentSelection") && selectable.isCollapsed) {
        if (model.schema.checkAttributeInSelection(selectable, ghsAttributeName)) yield selectable;
    } else for (const range of $50e4d8c8f321fe5d$var$getValidRangesForSelectable(model, selectable, ghsAttributeName))yield* range.getItems({
        shallow: true
    });
}
/**
* Translates a given selectable to an iterable of ranges.
*/ function $50e4d8c8f321fe5d$var$getValidRangesForSelectable(model, selectable, ghsAttributeName) {
    if (!(Symbol.iterator in selectable) && (selectable.is("node") || selectable.is("$text") || selectable.is("$textProxy"))) {
        if (model.schema.checkAttribute(selectable, ghsAttributeName)) return [
            model.createRangeOn(selectable)
        ];
        else return [];
    } else return model.schema.getValidRanges(model.createSelection(selectable).getRanges(), ghsAttributeName);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The HTML comment feature. It preserves the HTML comments (`<!-- -->`) in the editor data.
*
* For a detailed overview, check the {@glink features/html/html-comments HTML comment feature documentation}.
*/ var $50e4d8c8f321fe5d$export$72b518ef2f32b6e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "HtmlComment";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const loadedCommentsContent = /* @__PURE__ */ new Map();
        editor.data.processor.skipComments = false;
        editor.model.schema.extend("$root", {
            allowAttributes: "$comment"
        });
        editor.model.schema.addAttributeCheck((context, attributeName)=>{
            if (attributeName.startsWith("$comment:") && editor.model.schema.checkAttribute(context, "$comment")) return true;
        });
        editor.conversion.for("upcast").elementToMarker({
            view: "$comment",
            model: (viewElement)=>{
                const markerName = `$comment:${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
                const commentContent = viewElement.getCustomProperty("$rawContent");
                loadedCommentsContent.set(markerName, commentContent);
                return markerName;
            }
        });
        editor.conversion.for("dataDowncast").markerToElement({
            model: "$comment",
            view: (modelElement, { writer: writer })=>{
                let root = void 0;
                for (const rootName of this.editor.model.document.getRootNames()){
                    root = this.editor.model.document.getRoot(rootName);
                    if (root.hasAttribute(modelElement.markerName)) break;
                }
                const markerName = modelElement.markerName;
                const commentContent = root.getAttribute(markerName);
                const comment = writer.createUIElement("$comment");
                writer.setCustomProperty("$rawContent", commentContent, comment);
                return comment;
            }
        });
        editor.model.document.registerPostFixer((writer)=>{
            let changed = false;
            const markers = editor.model.document.differ.getChangedMarkers().filter((marker)=>marker.name.startsWith("$comment:"));
            for (const marker of markers){
                const { oldRange: oldRange, newRange: newRange } = marker.data;
                if (oldRange && newRange && oldRange.root == newRange.root) continue;
                if (oldRange) {
                    const oldRoot = oldRange.root;
                    if (oldRoot.hasAttribute(marker.name)) {
                        writer.removeAttribute(marker.name, oldRoot);
                        changed = true;
                    }
                }
                if (newRange) {
                    const newRoot = newRange.root;
                    if (newRoot.rootName == "$graveyard") {
                        writer.removeMarker(marker.name);
                        changed = true;
                    } else if (!newRoot.hasAttribute(marker.name)) {
                        writer.setAttribute(marker.name, loadedCommentsContent.get(marker.name) || "", newRoot);
                        changed = true;
                    }
                }
            }
            return changed;
        });
        editor.data.on("set", ()=>{
            for (const commentMarker of editor.model.markers.getMarkersGroup("$comment"))this.removeHtmlComment(commentMarker.name);
        }, {
            priority: "high"
        });
        editor.model.on("deleteContent", (evt, [selection])=>{
            for (const range of selection.getRanges()){
                const limitElement = editor.model.schema.getLimitElement(range);
                const firstPosition = editor.model.createPositionAt(limitElement, 0);
                const lastPosition = editor.model.createPositionAt(limitElement, "end");
                let affectedCommentIDs;
                if (firstPosition.isTouching(range.start) && lastPosition.isTouching(range.end)) affectedCommentIDs = this.getHtmlCommentsInRange(editor.model.createRange(firstPosition, lastPosition));
                else affectedCommentIDs = this.getHtmlCommentsInRange(range, {
                    skipBoundaries: true
                });
                for (const commentMarkerID of affectedCommentIDs)this.removeHtmlComment(commentMarkerID);
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Creates an HTML comment on the specified position and returns its ID.
	*
	* *Note*: If two comments are created at the same position, the second comment will be inserted before the first one.
	*
	* @returns Comment ID. This ID can be later used to e.g. remove the comment from the content.
	*/ createHtmlComment(position, content) {
        const id = (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
        const model = this.editor.model;
        const root = model.document.getRoot(position.root.rootName);
        const markerName = `$comment:${id}`;
        return model.change((writer)=>{
            const range = writer.createRange(position);
            writer.addMarker(markerName, {
                usingOperation: true,
                affectsData: true,
                range: range
            });
            writer.setAttribute(markerName, content, root);
            return markerName;
        });
    }
    /**
	* Removes an HTML comment with the given comment ID.
	*
	* It does nothing and returns `false` if the comment with the given ID does not exist.
	* Otherwise it removes the comment and returns `true`.
	*
	* Note that a comment can be removed also by removing the content around the comment.
	*
	* @param commentID The ID of the comment to be removed.
	* @returns `true` when the comment with the given ID was removed, `false` otherwise.
	*/ removeHtmlComment(commentID) {
        const editor = this.editor;
        const marker = editor.model.markers.get(commentID);
        if (!marker) return false;
        editor.model.change((writer)=>{
            writer.removeMarker(marker);
        });
        return true;
    }
    /**
	* Gets the HTML comment data for the comment with a given ID.
	*
	* Returns `null` if the comment does not exist.
	*/ getHtmlCommentData(commentID) {
        const marker = this.editor.model.markers.get(commentID);
        if (!marker) return null;
        let content = "";
        for (const root of this.editor.model.document.getRoots())if (root.hasAttribute(commentID)) {
            content = root.getAttribute(commentID);
            break;
        }
        return {
            content: content,
            position: marker.getStart()
        };
    }
    /**
	* Gets all HTML comments in the given range.
	*
	* By default, it includes comments at the range boundaries.
	*
	* @param range The range to search for HTML comments.
	* @param options Additional options.
	* @param options.skipBoundaries When set to `true` the range boundaries will be skipped.
	* @returns HTML comment IDs
	*/ getHtmlCommentsInRange(range, { skipBoundaries: skipBoundaries = false } = {}) {
        const includeBoundaries = !skipBoundaries;
        return Array.from(this.editor.model.markers.getMarkersGroup("$comment")).filter((marker)=>isCommentMarkerInRange(marker, range)).map((marker)=>marker.name);
        function isCommentMarkerInRange(commentMarker, range) {
            const position = commentMarker.getRange().start;
            return (position.isAfter(range.start) || includeBoundaries && position.isEqual(range.start)) && (position.isBefore(range.end) || includeBoundaries && position.isEqual(range.end));
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/htmlpagedataprocessor
*/ /**
* The full page HTML data processor class.
* This data processor implementation uses HTML as input and output data.
*/ var $50e4d8c8f321fe5d$export$726c6728ed972e1d = class extends (0, $b9b9f2bdf9c6137f$export$770f0f0cb3c9452) {
    /**
	* @inheritDoc
	*/ toView(data) {
        if (!/<(?:html|body|head|meta)(?:\s[^>]*)?>/i.test(data.trim().slice(0, 1e4))) return super.toView(data);
        let docType = "";
        let xmlDeclaration = "";
        data = data.trim().replace(/<\?xml\s[^?]*\?>/i, (match)=>{
            xmlDeclaration = match;
            return "";
        });
        data = data.trim().replace(/^<!DOCTYPE\s[^>]*?>/i, (match)=>{
            docType = match;
            return "";
        });
        const domFragment = this._toDom(data);
        const viewFragment = this.domConverter.domToView(domFragment, {
            skipComments: this.skipComments
        });
        const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(viewFragment.document);
        writer.setCustomProperty("$fullPageDocument", domFragment.ownerDocument.documentElement.outerHTML, viewFragment);
        const headStylesElements = Array.from(domFragment.ownerDocument.querySelectorAll("head style")).filter((item)=>!!item.textContent).map((item)=>({
                css: item.textContent,
                attributes: $50e4d8c8f321fe5d$var$extractSafeStyleAttributes(item)
            }));
        writer.setCustomProperty("$fullPageHeadStyles", headStylesElements, viewFragment);
        if (docType) writer.setCustomProperty("$fullPageDocType", docType, viewFragment);
        if (xmlDeclaration) writer.setCustomProperty("$fullPageXmlDeclaration", xmlDeclaration, viewFragment);
        return viewFragment;
    }
    /**
	* @inheritDoc
	*/ toData(viewFragment) {
        let data = super.toData(viewFragment);
        const page = viewFragment.getCustomProperty("$fullPageDocument");
        const docType = viewFragment.getCustomProperty("$fullPageDocType");
        const xmlDeclaration = viewFragment.getCustomProperty("$fullPageXmlDeclaration");
        if (page) {
            data = page.replace(/<\/body\s*>/, data + "$&");
            if (docType) data = docType + "\n" + data;
            if (xmlDeclaration) data = xmlDeclaration + "\n" + data;
        }
        return data;
    }
};
/**
* Returns the allowlisted attributes of the given `<style>` element.
*/ function $50e4d8c8f321fe5d$var$extractSafeStyleAttributes(styleElement) {
    return [
        "media",
        "type",
        "title"
    ].reduce((attributes, name)=>{
        const value = styleElement.getAttribute(name);
        if (value !== null) attributes[name] = value;
        return attributes;
    }, Object.create(null));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module html-support/fullpage
*/ /**
* The full page editing feature. It preserves the whole HTML page in the editor data.
*/ var $50e4d8c8f321fe5d$export$b52d4538ba1e05b3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Style elements injected into the DOM by this plugin instance.
	*/ _injectedStyleElements = /* @__PURE__ */ new Set();
    /**
	* Cancels an injection that is waiting for the editing root to be connected to a document. `null` when there
	* is none pending.
	*/ _cancelPendingInjection = null;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "FullPage";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "FPH";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("htmlSupport.fullPage", {
            allowRenderStylesFromHead: false,
            sanitizeCss: (rawCss)=>{
                /**
				* When using the Full page with the `config.htmlSupport.fullPage.allowRenderStylesFromHead` set to `true`,
				* it is strongly recommended to define a sanitize function that will clean up the CSS
				* which is present in the `<head>` in editors content in order to avoid XSS vulnerability.
				*
				* For a detailed overview, check the {@glink features/html/full-page-html Full page HTML feature} documentation.
				*
				* @error css-full-page-provide-sanitize-function
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("css-full-page-provide-sanitize-function");
                return {
                    css: rawCss,
                    hasChanged: false
                };
            }
        });
        editor.data.processor = new $50e4d8c8f321fe5d$export$726c6728ed972e1d(editor.data.viewDocument);
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const properties = [
            "$fullPageDocument",
            "$fullPageDocType",
            "$fullPageXmlDeclaration",
            "$fullPageHeadStyles"
        ];
        editor.model.schema.extend("$root", {
            allowAttributes: properties
        });
        editor.data.on("toModel", (evt, [viewElementOrFragment])=>{
            const root = editor.model.document.getRoot();
            editor.model.change((writer)=>{
                for (const name of properties){
                    const value = viewElementOrFragment.getCustomProperty(name);
                    if (value) writer.setAttribute(name, value, root);
                }
            });
            this._syncStylesFromHead(root);
        }, {
            priority: "low"
        });
        editor.data.on("toView", (evt, [modelElementOrFragment])=>{
            if (!modelElementOrFragment.is("rootElement")) return;
            const root = modelElementOrFragment;
            const viewFragment = evt.return;
            if (!root.hasAttribute("$fullPageDocument")) return;
            const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(viewFragment.document);
            for (const name of properties){
                const value = root.getAttribute(name);
                if (value) writer.setCustomProperty(name, value, viewFragment);
            }
        }, {
            priority: "low"
        });
        editor.data.on("set", ()=>{
            const root = editor.model.document.getRoot();
            editor.model.change((writer)=>{
                for (const name of properties)if (root.hasAttribute(name)) writer.removeAttribute(name, root);
            });
        }, {
            priority: "high"
        });
        editor.data.on("get", (evt, args)=>{
            if (!args[0]) args[0] = {};
            args[0].trim = false;
        }, {
            priority: "high"
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._cancelPendingInjection?.();
        this._removeStyleElementsFromDom();
    }
    /**
	* Renders the `<style>` elements from the full page data in the tree the editor lives in – the `<head>` of its
	* document, or the shadow root hosting it – replacing the ones rendered before.
	*
	* That tree is only known once the editing root is connected to a document, which does not have to be the case
	* when this is called: a `DecoupledEditor` editable, and the editable of any editor created from a data string,
	* is mounted by the integrator at an arbitrary point in time. The injection waits for it.
	*/ _syncStylesFromHead(root) {
        if (!$50e4d8c8f321fe5d$var$isAllowedRenderStylesFromHead(this.editor)) return;
        const domRootElement = $50e4d8c8f321fe5d$var$getDomRootElement(this.editor, root);
        if (!domRootElement) return;
        this._cancelPendingInjection?.();
        this._cancelPendingInjection = (0, $c7bc2cb7e2db0227$export$c6a09612176c4440)(domRootElement, ()=>{
            this._cancelPendingInjection = null;
            this._removeStyleElementsFromDom();
            this._renderStyleElementsInDom(root, $50e4d8c8f321fe5d$var$getStylesInjectionTarget(domRootElement));
        });
    }
    /**
	* Removes the `<style>` elements injected by the plugin. Elements are tracked by reference, as they may live
	* in a `ShadowRoot` rather than in the main document.
	*/ _removeStyleElementsFromDom() {
        for (const style of this._injectedStyleElements)style.remove();
        this._injectedStyleElements.clear();
    }
    /**
	* Renders the `<style>` elements from the full page data in the given target. CSS content is sanitized before
	* rendering.
	*/ _renderStyleElementsInDom(root, target) {
        const styleElements = root.getAttribute("$fullPageHeadStyles");
        if (!styleElements) return;
        const sanitizeCss = this.editor.config.get("htmlSupport.fullPage.sanitizeCss");
        for (const { css: css, attributes: attributes } of styleElements){
            const styleElement = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(target.ownerDocument, "style", attributes);
            styleElement.textContent = sanitizeCss(css).css;
            target.append(styleElement);
            this._injectedStyleElements.add(styleElement);
        }
    }
};
/**
* Returns where the `<style>` elements from the full page data should be rendered for the given editing root: the
* shadow root hosting it, or the `<head>` of its document.
*/ function $50e4d8c8f321fe5d$var$getStylesInjectionTarget(domRootElement) {
    const root = domRootElement.getRootNode();
    return (0, $c7bc2cb7e2db0227$export$af51f0f06c0f328a)(root) ? root : domRootElement.ownerDocument.head;
}
/**
* Returns the DOM element the given model root is rendered in, or `null` when no editing root is bound to it yet.
*/ function $50e4d8c8f321fe5d$var$getDomRootElement(editor, root) {
    const viewRootElement = editor.editing.mapper.toViewElement(root);
    return viewRootElement && editor.editing.view.domConverter.mapViewToDom(viewRootElement) || null;
}
/**
* Normalize the Full page configuration option `allowRenderStylesFromHead`.
*/ function $50e4d8c8f321fe5d$var$isAllowedRenderStylesFromHead(editor) {
    return editor.config.get("htmlSupport.fullPage.allowRenderStylesFromHead");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE = "htmlEmptyBlock";
/**
* This plugin allows for preserving empty block elements in the editor content
* instead of automatically filling them with block fillers (`&nbsp;`).
*
* This is useful when you want to:
*
* * Preserve empty block elements exactly as they were in the source HTML.
* * Allow for styling empty blocks with CSS (block fillers can interfere with height/margin).
* * Maintain compatibility with external systems that expect empty blocks to remain empty.
*
* Known limitations:
*
* * Empty blocks may not work correctly with revision history features.
* * Keyboard navigation through the document might behave unexpectedly, especially when
*   navigating through structures like lists and tables.
*
* For example, this allows for HTML like:
*
* ```html
* <p></p>
* <p class="spacer"></p>
* <td></td>
* ```
* to remain empty instead of being converted to:
*
* ```html
* <p>&nbsp;</p>
* <p class="spacer">&nbsp;</p>
* <td>&nbsp;</td>
* ```
*/ var $50e4d8c8f321fe5d$export$1780f2a178bda818 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "EmptyBlock";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const { model: model, conversion: conversion, plugins: plugins, config: config } = this.editor;
        const schema = model.schema;
        const preserveEmptyBlocksInEditingView = config.get("htmlSupport.preserveEmptyBlocksInEditingView");
        schema.extend("$block", {
            allowAttributes: [
                $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE
            ]
        });
        schema.extend("$container", {
            allowAttributes: [
                $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE
            ]
        });
        if (schema.isRegistered("tableCell")) schema.extend("tableCell", {
            allowAttributes: [
                $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE
            ]
        });
        if (preserveEmptyBlocksInEditingView) conversion.for("downcast").add($50e4d8c8f321fe5d$var$createEmptyBlockDowncastConverter());
        else conversion.for("dataDowncast").add($50e4d8c8f321fe5d$var$createEmptyBlockDowncastConverter());
        conversion.for("upcast").add($50e4d8c8f321fe5d$var$createEmptyBlockUpcastConverter(schema));
        if (plugins.has("ClipboardPipeline")) this._registerClipboardPastingHandler();
    }
    /**
	* Handle clipboard paste events:
	*
	* * It does not affect *copying* content from the editor, only *pasting*.
	* * When content is pasted from another editor instance with `<p></p>`,
	*   the `&nbsp;` filler is added, so the getData result is `<p>&nbsp;</p>`.
	* * When content is pasted from the same editor instance with `<p></p>`,
	*   the `&nbsp;` filler is not added, so the getData result is `<p></p>`.
	*/ _registerClipboardPastingHandler() {
        const clipboardPipeline = this.editor.plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "contentInsertion", (evt, data)=>{
            if (data.sourceEditorId === this.editor.id) return;
            this.editor.model.change((writer)=>{
                for (const { item: item } of writer.createRangeIn(data.content))if (item.is("element") && item.hasAttribute($50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE)) writer.removeAttribute($50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE, item);
            });
        });
    }
};
/**
* Creates a downcast converter for handling empty blocks.
* This converter prevents filler elements from being added to elements marked as empty blocks.
*/ function $50e4d8c8f321fe5d$var$createEmptyBlockDowncastConverter() {
    return (dispatcher)=>{
        dispatcher.on(`attribute:${$50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE}`, (evt, data, conversionApi)=>{
            const { mapper: mapper, consumable: consumable } = conversionApi;
            const { item: item } = data;
            if (!consumable.consume(item, evt.name)) return;
            const viewElement = mapper.toViewElement(item);
            if (viewElement && data.attributeNewValue) viewElement.getFillerOffset = ()=>null;
        });
    };
}
/**
* Creates an upcast converter for handling empty blocks.
* The converter detects empty elements and marks them with the empty block attribute.
*/ function $50e4d8c8f321fe5d$var$createEmptyBlockUpcastConverter(schema) {
    return (dispatcher)=>{
        dispatcher.on("element", (evt, data, conversionApi)=>{
            const { viewItem: viewItem, modelRange: modelRange } = data;
            if (!viewItem.is("element") || !viewItem.isEmpty || viewItem.getCustomProperty("$hasBlockFiller")) return;
            const modelElement = modelRange && modelRange.start.nodeAfter;
            if (!modelElement || !schema.checkAttribute(modelElement, $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE)) return;
            conversionApi.writer.setAttribute($50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE, true, modelElement);
            if (modelElement.childCount != 1) return;
            const firstModelChild = modelElement.getChild(0);
            if (firstModelChild.is("element", "paragraph") && schema.checkAttribute(firstModelChild, $50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE)) conversionApi.writer.setAttribute($50e4d8c8f321fe5d$var$EMPTY_BLOCK_MODEL_ATTRIBUTE, true, firstModelChild);
        }, {
            priority: "lowest"
        });
    };
}




/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 










//#region src/compat/predicate/isNil.ts
/**
* Checks if a given value is null or undefined.
*
* This function tests whether the provided value is either `null` or `undefined`.
* It returns `true` if the value is `null` or `undefined`, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `null` or `undefined`.
*
* @param x - The value to test for null or undefined.
* @returns `true` if the value is null or undefined, `false` otherwise.
*
* @example
* const value1 = null;
* const value2 = undefined;
* const value3 = 42;
* const result1 = isNil(value1); // true
* const result2 = isNil(value2); // true
* const result3 = isNil(value3); // false
*/ function $d0399299326f0fcd$export$984f70f9382f5d27(x) {
    return x == null;
}



//#region src/compat/object/pick.ts
/**
* Creates a new object composed of the picked object properties.
*
* This function takes an object and an array of keys, and returns a new object that
* includes only the properties corresponding to the specified keys.
*
* @template T - The type of object.
* @template U - The type of keys to pick.
* @param object - The object to pick keys from.
* @param props - An array of keys to be picked from the object. received keys goes through a flattening process before being used.
* @returns A new object with the specified keys picked.
*
* @example
* const obj = { a: 1, b: 2, c: 3 };
* const result = pick(obj, ['a', 'c']);
* // result will be { a: 1, c: 3 }
*
* // each path can be passed individually as an argument
* const obj = { a: 1, b: 2, c: 3 };
* const result = pick(obj, 'a', 'c');
* // result will be { a: 1, c: 3 }
*
* // pick a key over a path
* const obj = { 'a.b': 1, a: { b: 2 } };
* const result = pick(obj, 'a.b');
* // result will be { 'a.b': 1 }
*/ function $5c99339e8ae3aa36$export$357523c63a2253b9(object, ...keysArr) {
    if ((0, $d0399299326f0fcd$export$984f70f9382f5d27)(object)) return {};
    const result = {};
    for(let i = 0; i < keysArr.length; i++){
        let keys = keysArr[i];
        switch(typeof keys){
            case "object":
                if (!Array.isArray(keys)) {
                    if ((0, $63d5569bd28740d6$export$1e2f57719e155213)(keys)) keys = Array.from(keys);
                    else keys = [
                        keys
                    ];
                }
                break;
            case "string":
            case "symbol":
            case "number":
                keys = [
                    keys
                ];
                break;
        }
        for (const key of keys){
            const value = (0, $380d1989ac14ff6b$export$3988ae62b71be9a3)(object, key);
            if (value === void 0 && !(0, $509c94e86b712a6b$export$a4f4bb6b1453fff5)(object, key)) continue;
            if (typeof key === "string" && Object.hasOwn(object, key)) result[key] = object[key];
            else (0, $56bb5d9ef9e7bd30$export$adaa4cf7ef1b65be)(result, key, value);
        }
    }
    return result;
}



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list/utils/listwalker
*/ /**
* Document list blocks iterator.
*
* @internal
*/ var $ab0101fae4fd036b$export$20d2bb1761c58007 = class {
    /**
	* The start list item block element.
	*/ _startElement;
    /**
	* The reference indent. Initialized by the indent of the start block.
	*/ _referenceIndent;
    /**
	* The iterating direction.
	*/ _isForward;
    /**
	* Whether start block should be included in the result (if it's matching other criteria).
	*/ _includeSelf;
    /**
	* Additional attributes that must be the same for each block.
	*/ _sameAttributes;
    /**
	* Whether blocks with the same indent level as the start block should be included in the result.
	*/ _sameIndent;
    /**
	* Whether blocks with a lower indent level than the start block should be included in the result.
	*/ _lowerIndent;
    /**
	* Whether blocks with a higher indent level than the start block should be included in the result.
	*/ _higherIndent;
    /**
	* Creates a document list iterator.
	*
	* @param startElement The start list item block element.
	* @param options.direction The iterating direction.
	* @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
	* @param options.sameAttributes Additional attributes that must be the same for each block.
	* @param options.sameIndent Whether blocks with the same indent level as the start block should be included
	* in the result.
	* @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
	* in the result.
	* @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
	* in the result.
	*/ constructor(startElement, options){
        this._startElement = startElement;
        this._referenceIndent = startElement.getAttribute("listIndent");
        this._isForward = options.direction == "forward";
        this._includeSelf = !!options.includeSelf;
        this._sameAttributes = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(options.sameAttributes || []);
        this._sameIndent = !!options.sameIndent;
        this._lowerIndent = !!options.lowerIndent;
        this._higherIndent = !!options.higherIndent;
    }
    /**
	* Performs only first step of iteration and returns the result.
	*
	* @param startElement The start list item block element.
	* @param options.direction The iterating direction.
	* @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
	* @param options.sameAttributes Additional attributes that must be the same for each block.
	* @param options.sameIndent Whether blocks with the same indent level as the start block should be included
	* in the result.
	* @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
	* in the result.
	* @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
	* in the result.
	*/ static first(startElement, options) {
        const iterator = new this(startElement, options)[Symbol.iterator]();
        return (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(iterator);
    }
    /**
	* Iterable interface.
	*/ *[Symbol.iterator]() {
        const nestedItems = [];
        for (const { node: node } of new $ab0101fae4fd036b$export$35b0a621484ad300(this._getStartNode(), this._isForward ? "forward" : "backward")){
            const indent = node.getAttribute("listIndent");
            if (indent < this._referenceIndent) {
                if (!this._lowerIndent) break;
                this._referenceIndent = indent;
            } else if (indent > this._referenceIndent) {
                if (!this._higherIndent) continue;
                if (!this._isForward) {
                    nestedItems.push(node);
                    continue;
                }
            } else {
                if (!this._sameIndent) {
                    if (this._higherIndent) {
                        if (nestedItems.length) {
                            yield* nestedItems;
                            nestedItems.length = 0;
                        }
                        break;
                    }
                    continue;
                }
                if (this._sameAttributes.some((attr)=>node.getAttribute(attr) !== this._startElement.getAttribute(attr))) break;
            }
            if (nestedItems.length) {
                yield* nestedItems;
                nestedItems.length = 0;
            }
            yield node;
        }
    }
    /**
	* Returns the model element to start iterating.
	*/ _getStartNode() {
        if (this._includeSelf) return this._startElement;
        return this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
    }
};
/**
* Iterates sibling list blocks starting from the given node.
*
* @internal
*/ var $ab0101fae4fd036b$export$35b0a621484ad300 = class {
    _node;
    _isForward;
    _previousNodesByIndent = [];
    _previous = null;
    _previousNodeIndent = null;
    /**
	* @param node The model node.
	* @param direction Iteration direction.
	*/ constructor(node, direction = "forward"){
        this._node = node;
        this._isForward = direction === "forward";
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        if (!$ab0101fae4fd036b$export$d0c47194f8840044(this._node)) return {
            done: true,
            value: void 0
        };
        const nodeIndent = this._node.getAttribute("listIndent");
        let previousNodeInList = null;
        if (this._previous) {
            const previousNodeIndent = this._previousNodeIndent;
            if (nodeIndent > previousNodeIndent) this._previousNodesByIndent[previousNodeIndent] = this._previous;
            else if (nodeIndent < previousNodeIndent) {
                previousNodeInList = this._previousNodesByIndent[nodeIndent] || null;
                this._previousNodesByIndent.length = nodeIndent;
            } else previousNodeInList = this._previous;
        }
        const value = {
            node: this._node,
            previous: this._previous,
            previousNodeInList: previousNodeInList
        };
        this._previous = this._node;
        this._previousNodeIndent = nodeIndent;
        this._node = this._isForward ? this._node.nextSibling : this._node.previousSibling;
        return {
            value: value,
            done: false
        };
    }
};
/**
* The iterable protocol over the list elements.
*
* @internal
*/ var $ab0101fae4fd036b$export$75774bc5b259919e = class {
    _listHead;
    /**
	* @param listHead The head element of a list.
	*/ constructor(listHead){
        this._listHead = listHead;
    }
    /**
	* List blocks iterator.
	*
	* Iterates over all blocks of a list.
	*/ [Symbol.iterator]() {
        return new $ab0101fae4fd036b$export$35b0a621484ad300(this._listHead);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The list item ID generator.
*
* @internal
*/ var $ab0101fae4fd036b$export$3f9105797bf11127 = class {
    /**
	* Returns the next ID.
	*
	* @internal
	*/ /* istanbul ignore next: static function definition -- @preserve */ static next() {
        return (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)();
    }
};
/**
* Returns true if the given model node is a list item block.
*
* @internal
*/ function $ab0101fae4fd036b$export$d0c47194f8840044(node) {
    return !!node && node.is("element") && node.hasAttribute("listItemId");
}
/**
* Returns an array with all elements that represents the same list item.
*
* It means that values for `listIndent`, and `listItemId` for all items are equal.
*
* @internal
* @param listItem Starting list item element.
* @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
* in the result.
*/ function $ab0101fae4fd036b$export$8498b9023b0db3dd(listItem, options = {}) {
    return [
        ...$ab0101fae4fd036b$export$751560b055ff70d6(listItem, {
            ...options,
            direction: "backward"
        }),
        ...$ab0101fae4fd036b$export$751560b055ff70d6(listItem, {
            ...options,
            direction: "forward"
        })
    ];
}
/**
* Returns an array with elements that represents the same list item in the specified direction.
*
* It means that values for `listIndent` and `listItemId` for all items are equal.
*
* **Note**: For backward search the provided item is not included, but for forward search it is included in the result.
*
* @internal
* @param listItem Starting list item element.
* @param options.direction Walking direction.
* @param options.higherIndent Whether blocks with a higher indent level than the start block should be included in the result.
*/ function $ab0101fae4fd036b$export$751560b055ff70d6(listItem, options = {}) {
    const isForward = options.direction == "forward";
    const items = Array.from(new $ab0101fae4fd036b$export$20d2bb1761c58007(listItem, {
        ...options,
        includeSelf: isForward,
        sameIndent: true,
        sameAttributes: "listItemId"
    }));
    return isForward ? items : items.reverse();
}
/**
* Returns a list items nested inside the given list item.
*
* @internal
*/ function $ab0101fae4fd036b$export$2f38a7337e7cf2c9(listItem) {
    return Array.from(new $ab0101fae4fd036b$export$20d2bb1761c58007(listItem, {
        direction: "forward",
        higherIndent: true
    }));
}
/**
* Returns array of all blocks/items of the same list as given block (same indent, same type and properties).
*
* @internal
* @param listItem Starting list item element.
* @param options Additional list walker options to modify the range of returned list items.
*/ function $ab0101fae4fd036b$export$b96a65611bf6847(listItem, options) {
    const backwardBlocks = new $ab0101fae4fd036b$export$20d2bb1761c58007(listItem, {
        sameIndent: true,
        sameAttributes: "listType",
        ...options
    });
    const forwardBlocks = new $ab0101fae4fd036b$export$20d2bb1761c58007(listItem, {
        sameIndent: true,
        sameAttributes: "listType",
        includeSelf: true,
        direction: "forward",
        ...options
    });
    return [
        ...Array.from(backwardBlocks).reverse(),
        ...forwardBlocks
    ];
}
/**
* Check if the given block is the first in the list item.
*
* @internal
* @param listBlock The list block element.
*/ function $ab0101fae4fd036b$export$f3f5b10432a99ae7(listBlock) {
    if (!$ab0101fae4fd036b$export$20d2bb1761c58007.first(listBlock, {
        sameIndent: true,
        sameAttributes: "listItemId"
    })) return true;
    return false;
}
/**
* Check if the given block is the last in the list item.
*
* @internal
*/ function $ab0101fae4fd036b$export$81db3a00cd478af0(listBlock) {
    if (!$ab0101fae4fd036b$export$20d2bb1761c58007.first(listBlock, {
        direction: "forward",
        sameIndent: true,
        sameAttributes: "listItemId"
    })) return true;
    return false;
}
/**
* Expands the given list of selected blocks to include the leading and tailing blocks of partially selected list items.
*
* @internal
* @param blocks The list of selected blocks.
* @param options.withNested Whether should include nested list items.
*/ function $ab0101fae4fd036b$export$b32096908b994f87(blocks, options = {}) {
    blocks = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(blocks);
    const higherIndent = options.withNested !== false;
    const allBlocks = /* @__PURE__ */ new Set();
    for (const block of blocks)for (const itemBlock of $ab0101fae4fd036b$export$8498b9023b0db3dd(block, {
        higherIndent: higherIndent
    }))allBlocks.add(itemBlock);
    return $ab0101fae4fd036b$export$4e5f887877418a7a(allBlocks);
}
/**
* Expands the given list of selected blocks to include all the items of the lists they're in.
*
* @internal
* @param blocks The list of selected blocks.
*/ function $ab0101fae4fd036b$export$dc8c7f1b370743d6(blocks) {
    blocks = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(blocks);
    const allBlocks = /* @__PURE__ */ new Set();
    for (const block of blocks)for (const itemBlock of $ab0101fae4fd036b$export$b96a65611bf6847(block))allBlocks.add(itemBlock);
    return $ab0101fae4fd036b$export$4e5f887877418a7a(allBlocks);
}
/**
* Splits the list item just before the provided list block.
*
* @internal
* @param listBlock The list block element.
* @param writer The model writer.
* @returns The array of updated blocks.
*/ function $ab0101fae4fd036b$export$8b1f40cf36190214(listBlock, writer) {
    const blocks = $ab0101fae4fd036b$export$751560b055ff70d6(listBlock, {
        direction: "forward"
    });
    const id = $ab0101fae4fd036b$export$3f9105797bf11127.next();
    for (const block of blocks)writer.setAttribute("listItemId", id, block);
    return blocks;
}
/**
* Merges the list item with the parent list item.
*
* @internal
* @param listBlock The list block element.
* @param parentBlock The list block element to merge with.
* @param writer The model writer.
* @returns The array of updated blocks.
*/ function $ab0101fae4fd036b$export$57fdd408bc95329a(listBlock, parentBlock, writer) {
    const attributes = {};
    for (const [key, value] of parentBlock.getAttributes())if (key.startsWith("list")) attributes[key] = value;
    const blocks = $ab0101fae4fd036b$export$751560b055ff70d6(listBlock, {
        direction: "forward"
    });
    for (const block of blocks)writer.setAttributes(attributes, block);
    return blocks;
}
/**
* Increases indentation of given list blocks.
*
* @internal
* @param blocks The block or iterable of blocks.
* @param writer The model writer.
* @param options Additional options.
* @param options.expand Whether should expand the list of blocks to include complete list items.
* @param options.indentBy The number of levels the indentation should change (could be negative).
* @param options.attributeNames List of attribute names to remove when a block leaves the list (when blockIndent < 0).
*/ function $ab0101fae4fd036b$export$e1fc764985b10e55(blocks, writer, { expand: expand, indentBy: indentBy = 1, attributeNames: attributeNames }) {
    blocks = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(blocks);
    const allBlocks = expand ? $ab0101fae4fd036b$export$b32096908b994f87(blocks) : blocks;
    for (const block of allBlocks){
        const blockIndent = block.getAttribute("listIndent") + indentBy;
        if (blockIndent < 0) $ab0101fae4fd036b$export$324d61a46bf03ca2(block, writer, attributeNames);
        else writer.setAttribute("listIndent", blockIndent, block);
    }
    return allBlocks;
}
/**
* Decreases indentation of given list of blocks. If the indentation of some blocks matches the indentation
* of surrounding blocks, they get merged together.
*
* @internal
* @param blocks The block or iterable of blocks.
* @param writer The model writer.
* @param options Additional options.
* @param options.attributeNames List of attribute names to remove when a block leaves the list (when blockIndent < 0).
*/ function $ab0101fae4fd036b$export$18f41798ffd5494(blocks, writer, { attributeNames: attributeNames }) {
    blocks = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(blocks);
    const allBlocks = $ab0101fae4fd036b$export$b32096908b994f87(blocks);
    const visited = /* @__PURE__ */ new Set();
    const referenceIndent = Math.min(...allBlocks.map((block)=>block.getAttribute("listIndent")));
    const parentBlocks = /* @__PURE__ */ new Map();
    for (const block of allBlocks)parentBlocks.set(block, $ab0101fae4fd036b$export$20d2bb1761c58007.first(block, {
        lowerIndent: true
    }));
    for (const block of allBlocks){
        if (visited.has(block)) continue;
        visited.add(block);
        const blockIndent = block.getAttribute("listIndent") - 1;
        if (blockIndent < 0) {
            $ab0101fae4fd036b$export$324d61a46bf03ca2(block, writer, attributeNames);
            continue;
        }
        if (block.getAttribute("listIndent") == referenceIndent && parentBlocks.get(block)) {
            const mergedBlocks = $ab0101fae4fd036b$var$mergeListItemIfNotLast(block, parentBlocks.get(block), writer);
            for (const mergedBlock of mergedBlocks)visited.add(mergedBlock);
            if (mergedBlocks.length) continue;
        }
        writer.setAttribute("listIndent", blockIndent, block);
    }
    return $ab0101fae4fd036b$export$4e5f887877418a7a(visited);
}
/**
* Removes all list attributes from the given blocks.
*
* @internal
* @param blocks The block or iterable of blocks.
* @param writer The model writer.
* @param attributeNames List of attribute names to remove.
* @returns Array of altered blocks.
*/ function $ab0101fae4fd036b$export$324d61a46bf03ca2(blocks, writer, attributeNames) {
    blocks = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(blocks);
    for (const block of blocks)if (block.is("element", "listItem")) writer.rename(block, "paragraph");
    for (const block of blocks)for (const attributeKey of block.getAttributeKeys())if (attributeNames.includes(attributeKey)) writer.removeAttribute(attributeKey, block);
    return blocks;
}
/**
* Checks whether the given blocks are related to a single list item.
*
* @internal
* @param blocks The list block elements.
*/ function $ab0101fae4fd036b$export$c9462903d4dfebea(blocks) {
    if (!blocks.length) return false;
    const firstItemId = blocks[0].getAttribute("listItemId");
    if (!firstItemId) return false;
    return !blocks.some((item)=>item.getAttribute("listItemId") != firstItemId);
}
/**
* Modifies the indents of list blocks following the given list block so the indentation is valid after
* the given block is no longer a list item.
*
* @internal
* @param lastBlock The last list block that has become a non-list element.
* @param writer The model writer.
* @returns Array of altered blocks.
*/ function $ab0101fae4fd036b$export$2b5ebdd44cb6b5a2(lastBlock, writer) {
    const changedBlocks = [];
    let currentIndent = Number.POSITIVE_INFINITY;
    for (const { node: node } of new $ab0101fae4fd036b$export$35b0a621484ad300(lastBlock.nextSibling)){
        const indent = node.getAttribute("listIndent");
        if (indent == 0) break;
        if (indent < currentIndent) currentIndent = indent;
        const newIndent = indent - currentIndent;
        writer.setAttribute("listIndent", newIndent, node);
        changedBlocks.push(node);
    }
    return changedBlocks;
}
/**
* Returns the array of given blocks sorted by model indexes (document order).
*
* @internal
*/ function $ab0101fae4fd036b$export$4e5f887877418a7a(blocks) {
    return Array.from(blocks).filter((block)=>block.root.rootName !== "$graveyard").sort((a, b)=>a.index - b.index);
}
/**
* Returns a selected block object. If a selected object is inline or when there is no selected
* object, `null` is returned.
*
* @internal
* @param model The instance of editor model.
* @returns Selected block object or `null`.
*/ function $ab0101fae4fd036b$export$a4dd452805552056(model) {
    const selectedElement = model.document.selection.getSelectedElement();
    if (!selectedElement) return null;
    if (model.schema.isObject(selectedElement) && model.schema.isBlock(selectedElement)) return selectedElement;
    return null;
}
/**
* Checks whether the given block can be replaced by a listItem.
*
* Note that this is possible only when multiBlock = false option is set in feature config.
*
* @param block A block to be tested.
* @param schema The schema of the document.
* @internal
*/ function $ab0101fae4fd036b$export$5bb20d38abd83b41(block, schema) {
    return schema.checkChild(block.parent, "listItem") && schema.checkChild(block, "$text") && !schema.isObject(block);
}
/**
* Returns true if listType is of type `numbered` or `customNumbered`.
*
* @internal
*/ function $ab0101fae4fd036b$export$a36753f029939118(listType) {
    return listType == "numbered" || listType == "customNumbered";
}
/**
* Checks if the given list item block is the first block of the first item in its list at the given indent.
*
* Walks back over previous siblings and returns:
* - `true` if it reaches a non-list block or a list block at a lower indent (a new list begins here),
* - `false` if it finds a same-indent block of the same `listItemId` (a continuation of the current item) or of the same
*   `listType` (the visible list already has earlier items),
* - `true` if it finds a same-indent block of a different `listType` and a different `listItemId` (a different list ends; ours
*   starts here),
* - `false` if the loop ends (it reaches the first non-list-item block, or no more previous siblings) while passing only
*   higher-indent blocks (those blocks live inside an intermediate skip-level `<li style="list-style-type:none">` wrapper
*   at our indent).
*
* For example, in the model:
*
* ```
* '  # aaa'
* '# bbb'
* ```
*
* `bbb` is preceded by a higher-indent block `aaa`, which in the view is rendered inside an intermediate
* skip-level wrapper at indent 0:
*
* ```html
* <ol>
*   <li style="list-style-type:none">
*     <ol>
*       <li>aaa</li>
*     </ol>
*   </li>
*   <li>bbb</li>
* </ol>
* ```
*
* So `bbb` is the second visible item in the outer list and the function returns `false`.
*/ function $ab0101fae4fd036b$var$isFirstListItemInList(listItem) {
    const itemIndent = listItem.getAttribute("listIndent");
    const itemListType = listItem.getAttribute("listType");
    const itemListItemId = listItem.getAttribute("listItemId");
    let previous = listItem.previousSibling;
    let sawHigherIndent = false;
    while($ab0101fae4fd036b$export$d0c47194f8840044(previous)){
        const previousIndent = previous.getAttribute("listIndent");
        if (previousIndent < itemIndent) return true;
        if (previousIndent === itemIndent) {
            if (previous.getAttribute("listItemId") === itemListItemId) return false;
            return previous.getAttribute("listType") !== itemListType;
        }
        sawHigherIndent = true;
        previous = previous.previousSibling;
    }
    return !sawHigherIndent;
}
/**
* Merges a given block to the given parent block if parent is a list item and there is no more blocks in the same item.
*/ function $ab0101fae4fd036b$var$mergeListItemIfNotLast(block, parentBlock, writer) {
    if ($ab0101fae4fd036b$export$751560b055ff70d6(parentBlock, {
        direction: "forward"
    }).pop().index > block.index) return $ab0101fae4fd036b$export$57fdd408bc95329a(block, parentBlock, writer);
    return [];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list/listindentcommand
*/ /**
* The document list indent command. It is used by the {@link module:list/list~List list feature}.
*/ var $ab0101fae4fd036b$export$6047ce71187af101 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Determines by how much the command will change the list item's indent attribute.
	*/ _direction;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param indentDirection The direction of indent. If it is equal to `backward`, the command
	* will outdent a list item.
	*/ constructor(editor, indentDirection){
        super(editor);
        this._direction = indentDirection;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Indents or outdents (depending on the {@link #constructor}'s `indentDirection` parameter) selected list items.
	*
	* @fires execute
	* @fires afterExecute
	*/ execute() {
        const editor = this.editor;
        const model = editor.model;
        const blocks = $ab0101fae4fd036b$var$getSelectedListBlocks(model.document.selection);
        const attributeNames = editor.plugins.get("ListEditing").getListAttributeNames();
        model.change((writer)=>{
            const changedBlocks = [];
            if ($ab0101fae4fd036b$export$c9462903d4dfebea(blocks) && !$ab0101fae4fd036b$export$f3f5b10432a99ae7(blocks[0])) {
                if (this._direction == "forward") changedBlocks.push(...$ab0101fae4fd036b$export$e1fc764985b10e55(blocks, writer, {
                    attributeNames: attributeNames
                }));
                changedBlocks.push(...$ab0101fae4fd036b$export$8b1f40cf36190214(blocks[0], writer));
            } else if (this._direction == "forward") changedBlocks.push(...$ab0101fae4fd036b$export$e1fc764985b10e55(blocks, writer, {
                expand: true,
                attributeNames: attributeNames
            }));
            else changedBlocks.push(...$ab0101fae4fd036b$export$18f41798ffd5494(blocks, writer, {
                attributeNames: attributeNames
            }));
            for (const block of changedBlocks){
                if (!block.hasAttribute("listType")) continue;
                const previousItemBlock = $ab0101fae4fd036b$export$20d2bb1761c58007.first(block, {
                    sameIndent: true
                });
                if (previousItemBlock) writer.setAttribute("listType", previousItemBlock.getAttribute("listType"), block);
            }
            this._fireAfterExecute(changedBlocks);
        });
    }
    /**
	* Fires the `afterExecute` event.
	*
	* @param changedBlocks The changed list elements.
	*/ _fireAfterExecute(changedBlocks) {
        this.fire("afterExecute", $ab0101fae4fd036b$export$4e5f887877418a7a(new Set(changedBlocks)));
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        let blocks = $ab0101fae4fd036b$var$getSelectedListBlocks(this.editor.model.document.selection);
        let firstBlock = blocks[0];
        if (!firstBlock) return false;
        if (this._direction == "backward") return true;
        if ($ab0101fae4fd036b$export$c9462903d4dfebea(blocks) && !$ab0101fae4fd036b$export$f3f5b10432a99ae7(blocks[0])) return true;
        if (this.editor.config.get("list.enableSkipLevelLists")) return true;
        blocks = $ab0101fae4fd036b$export$b32096908b994f87(blocks);
        firstBlock = blocks[0];
        const siblingItem = $ab0101fae4fd036b$export$20d2bb1761c58007.first(firstBlock, {
            sameIndent: true
        });
        if (!siblingItem) return false;
        if (siblingItem.getAttribute("listType") == firstBlock.getAttribute("listType")) return true;
        return false;
    }
};
/**
* Returns an array of selected blocks truncated to the first non list block element.
*/ function $ab0101fae4fd036b$var$getSelectedListBlocks(selection) {
    const blocks = Array.from(selection.getSelectedBlocks());
    const firstNonListBlockIndex = blocks.findIndex((block)=>!$ab0101fae4fd036b$export$d0c47194f8840044(block));
    if (firstNonListBlockIndex != -1) blocks.length = firstNonListBlockIndex;
    return blocks;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The list command. It is used by the {@link module:list/list~List list feature}.
*/ var $ab0101fae4fd036b$export$ba93ee87858e1659 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The type of the list created by the command.
	*/ type;
    /**
	* List Walker options that change the range of the list items to be changed when the selection is collapsed within a list item.
	*
	* In a multi-level list, when the selection is collapsed within a list item, instead of changing only the list items of the same list
	* type and current indent level, the entire list structure is changed (all list items at all indent levels of any list type).
	*/ _listWalkerOptions;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param type List type that will be handled by this command.
	*/ constructor(editor, type, options = {}){
        super(editor);
        this.type = type;
        this._listWalkerOptions = options.multiLevel ? {
            higherIndent: true,
            lowerIndent: true,
            sameAttributes: []
        } : void 0;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the list command.
	*
	* @fires execute
	* @fires afterExecute
	* @param options Command options.
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will try to convert the
	* selected items and potentially the neighbor elements to the proper list items. If set to `false` it will convert selected elements
	* to paragraphs. If not set, the command will toggle selected elements to list items or paragraphs, depending on the selection.
	* @param options.additionalAttributes Additional attributes that are set for list items when the command is executed.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const document1 = model.document;
        const selectedBlockObject = $ab0101fae4fd036b$export$a4dd452805552056(model);
        const blocks = Array.from(document1.selection.getSelectedBlocks()).filter((block)=>model.schema.checkAttribute(block, "listType") || $ab0101fae4fd036b$export$5bb20d38abd83b41(block, model.schema));
        const turnOff = options.forceValue !== void 0 ? !options.forceValue : this.value;
        model.change((writer)=>{
            if (turnOff) {
                const lastBlock = blocks[blocks.length - 1];
                const attributeNames = this.editor.plugins.get("ListEditing").getListAttributeNames();
                const itemBlocks = $ab0101fae4fd036b$export$751560b055ff70d6(lastBlock, {
                    direction: "forward"
                });
                const changedBlocks = [];
                if (itemBlocks.length > 1) changedBlocks.push(...$ab0101fae4fd036b$export$8b1f40cf36190214(itemBlocks[1], writer));
                changedBlocks.push(...$ab0101fae4fd036b$export$324d61a46bf03ca2(blocks, writer, attributeNames));
                changedBlocks.push(...$ab0101fae4fd036b$export$2b5ebdd44cb6b5a2(lastBlock, writer));
                this._fireAfterExecute(changedBlocks);
            } else if ((selectedBlockObject || document1.selection.isCollapsed) && $ab0101fae4fd036b$export$d0c47194f8840044(blocks[0])) {
                const changedBlocks = $ab0101fae4fd036b$export$b96a65611bf6847(selectedBlockObject || blocks[0], this._listWalkerOptions);
                for (const block of changedBlocks)writer.setAttributes({
                    ...options.additionalAttributes,
                    listType: this.type
                }, block);
                this._fireAfterExecute(changedBlocks);
            } else {
                const changedBlocks = [];
                for (const block of blocks)if (!block.hasAttribute("listType")) {
                    if (!block.is("element", "listItem") && $ab0101fae4fd036b$export$5bb20d38abd83b41(block, model.schema)) writer.rename(block, "listItem");
                    writer.setAttributes({
                        ...options.additionalAttributes,
                        listIndent: 0,
                        listItemId: $ab0101fae4fd036b$export$3f9105797bf11127.next(),
                        listType: this.type
                    }, block);
                    changedBlocks.push(block);
                } else for (const node of $ab0101fae4fd036b$export$b32096908b994f87(block, {
                    withNested: false
                }))if (node.getAttribute("listType") != this.type) {
                    writer.setAttributes({
                        ...options.additionalAttributes,
                        listType: this.type
                    }, node);
                    changedBlocks.push(node);
                }
                this._fireAfterExecute(changedBlocks);
            }
        });
    }
    /**
	* Fires the `afterExecute` event.
	*
	* @param changedBlocks The changed list elements.
	*/ _fireAfterExecute(changedBlocks) {
        this.fire("afterExecute", $ab0101fae4fd036b$export$4e5f887877418a7a(new Set(changedBlocks)));
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const selection = this.editor.model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        if (!blocks.length) return false;
        for (const block of blocks)if (block.getAttribute("listType") != this.type) return false;
        return true;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        if (!blocks.length) return false;
        if (this.value) return true;
        for (const block of blocks)if (schema.checkAttribute(block, "listType") || $ab0101fae4fd036b$export$5bb20d38abd83b41(block, schema)) return true;
        return false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list/listmergecommand
*/ /**
* The document list merge command. It is used by the {@link module:list/list~List list feature}.
*/ var $ab0101fae4fd036b$export$122668825ef5b4c0 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Whether list item should be merged before or after the selected block.
	*/ _direction;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param direction Whether list item should be merged before or after the selected block.
	*/ constructor(editor, direction){
        super(editor);
        this._direction = direction;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Merges list blocks together (depending on the {@link #constructor}'s `direction` parameter).
	*
	* @fires execute
	* @fires afterExecute
	* @param options Command options.
	* @param options.shouldMergeOnBlocksContentLevel When set `true`, merging will be performed together
	* with {@link module:engine/model/model~Model#deleteContent} to get rid of the inline content in the selection or take advantage
	* of the heuristics in `deleteContent()` that helps convert lists into paragraphs in certain cases.
	*/ execute({ shouldMergeOnBlocksContentLevel: shouldMergeOnBlocksContentLevel = false } = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const changedBlocks = [];
        const attributeNames = editor.plugins.get("ListEditing").getListAttributeNames();
        model.change((writer)=>{
            const { firstElement: firstElement, lastElement: lastElement } = this._getMergeSubjectElements(selection, shouldMergeOnBlocksContentLevel);
            if (!firstElement || !lastElement) return;
            const firstIndent = firstElement.getAttribute("listIndent") || 0;
            const lastIndent = lastElement.getAttribute("listIndent");
            const lastElementId = lastElement.getAttribute("listItemId");
            if (firstIndent != lastIndent) {
                const nestedLastElementBlocks = $ab0101fae4fd036b$export$2f38a7337e7cf2c9(lastElement);
                changedBlocks.push(...$ab0101fae4fd036b$export$e1fc764985b10e55([
                    lastElement,
                    ...nestedLastElementBlocks
                ], writer, {
                    indentBy: firstIndent - lastIndent,
                    expand: firstIndent < lastIndent,
                    attributeNames: attributeNames
                }));
            }
            if (shouldMergeOnBlocksContentLevel) {
                let sel = selection;
                if (selection.isCollapsed) sel = writer.createSelection(writer.createRange(writer.createPositionAt(firstElement, "end"), writer.createPositionAt(lastElement, 0)));
                model.deleteContent(sel, {
                    doNotResetEntireContent: selection.isCollapsed
                });
                const lastElementAfterDelete = sel.getLastPosition().parent;
                const nextSibling = lastElementAfterDelete.nextSibling;
                changedBlocks.push(lastElementAfterDelete);
                if (nextSibling && nextSibling !== lastElement && nextSibling.getAttribute("listItemId") == lastElementId) changedBlocks.push(...$ab0101fae4fd036b$export$57fdd408bc95329a(nextSibling, lastElementAfterDelete, writer));
            } else changedBlocks.push(...$ab0101fae4fd036b$export$57fdd408bc95329a(lastElement, firstElement, writer));
            this._fireAfterExecute(changedBlocks);
        });
    }
    /**
	* Fires the `afterExecute` event.
	*
	* @param changedBlocks The changed list elements.
	*/ _fireAfterExecute(changedBlocks) {
        this.fire("afterExecute", $ab0101fae4fd036b$export$4e5f887877418a7a(new Set(changedBlocks)));
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedBlockObject = $ab0101fae4fd036b$export$a4dd452805552056(model);
        if (selection.isCollapsed || selectedBlockObject) {
            const positionParent = selectedBlockObject || selection.getFirstPosition().parent;
            if (!$ab0101fae4fd036b$export$d0c47194f8840044(positionParent)) return false;
            const siblingNode = this._direction == "backward" ? positionParent.previousSibling : positionParent.nextSibling;
            if (!siblingNode) return false;
            if ($ab0101fae4fd036b$export$c9462903d4dfebea([
                positionParent,
                siblingNode
            ])) return false;
        } else {
            const lastPosition = selection.getLastPosition();
            const firstPosition = selection.getFirstPosition();
            if (lastPosition.parent === firstPosition.parent) return false;
            if (!$ab0101fae4fd036b$export$d0c47194f8840044(lastPosition.parent)) return false;
        }
        return true;
    }
    /**
	* Returns the boundary elements the merge should be executed for. These are not necessarily selection's first
	* and last position parents but sometimes sibling or even further blocks depending on the context.
	*
	* @param selection The selection the merge is executed for.
	* @param shouldMergeOnBlocksContentLevel When `true`, merge is performed together with
	* {@link module:engine/model/model~Model#deleteContent} to remove the inline content within the selection.
	*/ _getMergeSubjectElements(selection, shouldMergeOnBlocksContentLevel) {
        const model = this.editor.model;
        const selectedBlockObject = $ab0101fae4fd036b$export$a4dd452805552056(model);
        let firstElement, lastElement;
        if (selection.isCollapsed || selectedBlockObject) {
            const positionParent = selectedBlockObject || selection.getFirstPosition().parent;
            const isFirstBlock = $ab0101fae4fd036b$export$f3f5b10432a99ae7(positionParent);
            if (this._direction == "backward") {
                lastElement = positionParent;
                if (isFirstBlock && !shouldMergeOnBlocksContentLevel) {
                    firstElement = $ab0101fae4fd036b$export$20d2bb1761c58007.first(positionParent, {
                        sameIndent: true,
                        lowerIndent: true
                    });
                    if (!firstElement && $ab0101fae4fd036b$export$d0c47194f8840044(positionParent.previousSibling)) firstElement = positionParent.previousSibling;
                } else firstElement = positionParent.previousSibling;
            } else {
                firstElement = positionParent;
                lastElement = positionParent.nextSibling;
            }
        } else {
            firstElement = selection.getFirstPosition().parent;
            lastElement = selection.getLastPosition().parent;
        }
        return {
            firstElement: firstElement,
            lastElement: lastElement
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The document list split command that splits the list item at the selection.
*
* It is used by the {@link module:list/list~List list feature}.
*/ var $ab0101fae4fd036b$export$e6fdcf59e0274d3e = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Whether list item should be split before or after the selected block.
	*/ _direction;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param direction Whether list item should be split before or after the selected block.
	*/ constructor(editor, direction){
        super(editor);
        this._direction = direction;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Splits the list item at the selection.
	*
	* @fires execute
	* @fires afterExecute
	*/ execute() {
        this.editor.model.change((writer)=>{
            const changedBlocks = $ab0101fae4fd036b$export$8b1f40cf36190214(this._getStartBlock(), writer);
            this._fireAfterExecute(changedBlocks);
        });
    }
    /**
	* Fires the `afterExecute` event.
	*
	* @param changedBlocks The changed list elements.
	*/ _fireAfterExecute(changedBlocks) {
        this.fire("afterExecute", $ab0101fae4fd036b$export$4e5f887877418a7a(new Set(changedBlocks)));
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const selection = this.editor.model.document.selection;
        const block = this._getStartBlock();
        return selection.isCollapsed && $ab0101fae4fd036b$export$d0c47194f8840044(block) && !$ab0101fae4fd036b$export$f3f5b10432a99ae7(block);
    }
    /**
	* Returns the model element that is the main focus of the command (according to the current selection and command direction).
	*/ _getStartBlock() {
        const positionParent = this.editor.model.document.selection.getFirstPosition().parent;
        return this._direction == "before" ? positionParent : positionParent.nextSibling;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting/listitemboldintegration
*/ /**
* The list item bold integration plugin.
*/ var $ab0101fae4fd036b$export$4169340fb52ea30b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListItemBoldIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const ListFormatting = editor.plugins.get("ListFormatting");
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        if (!editor.plugins.has("BoldEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        ListFormatting.registerFormatAttribute("bold", "listItemBold");
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemBold",
            setAttributeOnDowncast (writer, value, viewElement, options) {
                /* v8 ignore next -- Downcast callbacks are only registered for meaningful list marker formatting values. */ if (value) {
                    writer.addClass("ck-list-marker-bold", viewElement);
                    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari && !(options && options.dataPipeline)) writer.setStyle("--ck-content-list-marker-dummy-bold", "0", viewElement);
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        if (!editor.plugins.has("BoldEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        model.schema.extend("$listItem", {
            allowAttributes: "listItemBold"
        });
        model.schema.setAttributeProperties("listItemBold", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "listItemBold");
        editor.conversion.for("upcast").attributeToAttribute({
            model: "listItemBold",
            view: {
                name: "li",
                classes: "ck-list-marker-bold"
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting/listitemitalicintegration
*/ /**
* The list item italic integration plugin.
*/ var $ab0101fae4fd036b$export$426cc8fe938c9d9d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListItemItalicIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const ListFormatting = editor.plugins.get("ListFormatting");
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        if (!editor.plugins.has("ItalicEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        ListFormatting.registerFormatAttribute("italic", "listItemItalic");
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemItalic",
            setAttributeOnDowncast (writer, value, viewElement, options) {
                /* v8 ignore next -- Downcast callbacks are only registered for meaningful list marker formatting values. */ if (value) {
                    writer.addClass("ck-list-marker-italic", viewElement);
                    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari && !(options && options.dataPipeline)) writer.setStyle("--ck-content-list-marker-dummy-italic", "0", viewElement);
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        if (!editor.plugins.has("ItalicEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        model.schema.extend("$listItem", {
            allowAttributes: "listItemItalic"
        });
        model.schema.setAttributeProperties("listItemItalic", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "listItemItalic");
        editor.conversion.for("upcast").attributeToAttribute({
            model: "listItemItalic",
            view: {
                name: "li",
                classes: "ck-list-marker-italic"
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting/listitemfontsizeintegration
*/ /**
* The list item font size integration plugin.
*/ var $ab0101fae4fd036b$export$cf30dc64a72a6a4f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListItemFontSizeIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const ListFormatting = editor.plugins.get("ListFormatting");
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        if (!editor.plugins.has("FontSizeEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        const normalizedFontSizeOptions = (0, $9831d3c11b45f6e3$export$88939c7379f2ee7f)(editor.config.get("fontSize.options"));
        ListFormatting.registerFormatAttribute("fontSize", "listItemFontSize");
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemFontSize",
            setAttributeOnDowncast (writer, value, viewElement, options) {
                /* v8 ignore next -- Downcast callbacks are only registered for meaningful list marker formatting values. */ if (value) {
                    const fontSizeOption = normalizedFontSizeOptions.find((option)=>option.model == value);
                    if (fontSizeOption && fontSizeOption.view && typeof fontSizeOption.view != "string") {
                        if (fontSizeOption.view.styles) {
                            writer.addClass("ck-list-marker-font-size", viewElement);
                            writer.setStyle("--ck-content-list-marker-font-size", fontSizeOption.view.styles["font-size"], viewElement);
                        } else if (fontSizeOption.view.classes) {
                            writer.addClass(`ck-list-marker-font-size-${value}`, viewElement);
                            if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isSafari && !(options && options.dataPipeline)) writer.setStyle("--ck-content-list-marker-dummy-font-size", "0", viewElement);
                        }
                    } else {
                        writer.addClass("ck-list-marker-font-size", viewElement);
                        writer.setStyle("--ck-content-list-marker-font-size", value, viewElement);
                    }
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        if (!editor.plugins.has("FontSizeEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        model.schema.extend("$listItem", {
            allowAttributes: "listItemFontSize"
        });
        model.schema.setAttributeProperties("listItemFontSize", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "listItemFontSize");
        editor.conversion.for("upcast").elementToAttribute({
            model: {
                key: "listItemFontSize",
                value: (viewElement)=>viewElement.getStyle("--ck-content-list-marker-font-size")
            },
            view: {
                name: "li",
                classes: "ck-list-marker-font-size",
                styles: {
                    "--ck-content-list-marker-font-size": /.*/
                }
            }
        });
        const fontSizeOptions = (0, $9831d3c11b45f6e3$export$88939c7379f2ee7f)(editor.config.get("fontSize.options"));
        for (const option of fontSizeOptions)/* v8 ignore next -- Normalized font size options used by the integration provide model and view values. */ if (option.model && option.view) editor.conversion.for("upcast").elementToAttribute({
            model: {
                key: "listItemFontSize",
                value: option.model
            },
            view: {
                name: "li",
                classes: `ck-list-marker-font-size-${option.model}`
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting/listitemfontcolorintegration
*/ /**
* The list item font color integration plugin.
*/ var $ab0101fae4fd036b$export$a9f972c9dcc53e96 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListItemFontColorIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const ListFormatting = editor.plugins.get("ListFormatting");
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        if (!editor.plugins.has("FontColorEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        ListFormatting.registerFormatAttribute("fontColor", "listItemFontColor");
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemFontColor",
            setAttributeOnDowncast (writer, value, viewElement) {
                /* v8 ignore next -- Downcast callbacks are only registered for meaningful list marker formatting values. */ if (value) {
                    writer.addClass("ck-list-marker-color", viewElement);
                    writer.setStyle("--ck-content-list-marker-color", value, viewElement);
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        if (!editor.plugins.has("FontColorEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        model.schema.extend("$listItem", {
            allowAttributes: "listItemFontColor"
        });
        model.schema.setAttributeProperties("listItemFontColor", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "listItemFontColor");
        editor.conversion.for("upcast").attributeToAttribute({
            model: {
                key: "listItemFontColor",
                value: (viewElement)=>{
                    return viewElement.getStyle("--ck-content-list-marker-color");
                }
            },
            view: {
                name: "li",
                classes: "ck-list-marker-color",
                styles: {
                    "--ck-content-list-marker-color": /.*/
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting/listitemfontfamilyintegration
*/ /**
* The list item font family integration plugin.
*/ var $ab0101fae4fd036b$export$9471d3f1c6c778bb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListItemFontFamilyIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const ListFormatting = editor.plugins.get("ListFormatting");
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        if (!editor.plugins.has("FontFamilyEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        ListFormatting.registerFormatAttribute("fontFamily", "listItemFontFamily");
        listEditing.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemFontFamily",
            setAttributeOnDowncast (writer, value, viewElement) {
                /* v8 ignore next -- Downcast callbacks are only registered for meaningful list marker formatting values. */ if (value) {
                    writer.addClass("ck-list-marker-font-family", viewElement);
                    writer.setStyle("--ck-content-list-marker-font-family", value, viewElement);
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        if (!editor.plugins.has("FontFamilyEditing") || !this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        model.schema.extend("$listItem", {
            allowAttributes: "listItemFontFamily"
        });
        model.schema.setAttributeProperties("listItemFontFamily", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "listItemFontFamily");
        editor.conversion.for("upcast").attributeToAttribute({
            model: {
                key: "listItemFontFamily",
                value: (viewElement)=>{
                    return viewElement.getStyle("--ck-content-list-marker-font-family");
                }
            },
            view: {
                name: "li",
                classes: "ck-list-marker-font-family",
                styles: {
                    "--ck-content-list-marker-font-family": /.*/
                }
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listformatting
*/ /**
* The list formatting plugin.
*
* It enables integration with formatting plugins to style the list marker.
* The list marker is styled based on the consistent formatting applied to the content of the list item.
*
* The list of supported formatting plugins includes:
* * Font color.
* * Font size.
* * Font family.
* * Bold.
* * Italic.
*/ var $ab0101fae4fd036b$export$7e276964ef921d70 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The list of loaded formatting.
	*/ _loadedFormatting = {};
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListFormatting";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$4169340fb52ea30b,
            $ab0101fae4fd036b$export$426cc8fe938c9d9d,
            $ab0101fae4fd036b$export$cf30dc64a72a6a4f,
            $ab0101fae4fd036b$export$a9f972c9dcc53e96,
            $ab0101fae4fd036b$export$9471d3f1c6c778bb
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("list.enableListItemMarkerFormatting", true);
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        if (!this.editor.config.get("list.enableListItemMarkerFormatting")) return;
        this._registerPostfixerForListItemFormatting();
    }
    /**
	* Registers a postfixer that ensures that the list item formatting attribute is consistent with the formatting
	* applied to the content of the list item.
	*/ _registerPostfixerForListItemFormatting() {
        const model = this.editor.model;
        model.document.registerPostFixer((writer)=>{
            const changes = model.document.differ.getChanges();
            const modifiedListItems = /* @__PURE__ */ new Set();
            let returnValue = false;
            for (const entry of changes)if (entry.type === "attribute") {
                if (entry.attributeKey == "listItemId" || entry.attributeKey == "listType" || this._isInlineOrSelectionFormatting(entry.attributeKey) || Object.values(this._loadedFormatting).includes(entry.attributeKey)) {
                    if ($ab0101fae4fd036b$export$d0c47194f8840044(entry.range.start.nodeAfter)) modifiedListItems.add(entry.range.start.nodeAfter);
                    else if ($ab0101fae4fd036b$export$d0c47194f8840044(entry.range.start.parent)) modifiedListItems.add(entry.range.start.parent);
                }
            } else {
                if ($ab0101fae4fd036b$export$d0c47194f8840044(entry.position.nodeAfter)) modifiedListItems.add(entry.position.nodeAfter);
                if ($ab0101fae4fd036b$export$d0c47194f8840044(entry.position.nodeBefore)) modifiedListItems.add(entry.position.nodeBefore);
                if ($ab0101fae4fd036b$export$d0c47194f8840044(entry.position.parent)) modifiedListItems.add(entry.position.parent);
                if (entry.type == "insert" && entry.name != "$text") {
                    const range = writer.createRangeIn(entry.position.nodeAfter);
                    for (const item of range.getItems())if ($ab0101fae4fd036b$export$d0c47194f8840044(item)) modifiedListItems.add(item);
                }
            }
            for (const listItem of modifiedListItems){
                const formats = $ab0101fae4fd036b$var$getListItemConsistentFormat(model, listItem, Object.keys(this._loadedFormatting));
                for (const [formatAttributeName, formatValue] of Object.entries(formats)){
                    const listItemFormatAttributeName = this._loadedFormatting[formatAttributeName];
                    if (formatValue && $ab0101fae4fd036b$var$setFormattingToListItem(writer, listItem, listItemFormatAttributeName, formatValue)) returnValue = true;
                    else if (!formatValue && $ab0101fae4fd036b$var$removeFormattingFromListItem(writer, listItem, listItemFormatAttributeName)) returnValue = true;
                }
            }
            return returnValue;
        });
    }
    /**
	* Registers an integration between a default attribute (e.g., `fontFamily`) and a new attribute
	* intended specifically for list item elements (e.g., `listItemFontFamily`).
	*
	* These attributes are later used by the postfixer logic to determine whether to add the new attribute
	* to the list item element, based on whether there is a consistent default formatting attribute
	* applied within its content.
	*/ registerFormatAttribute(formatAttribute, listItemFormatAttribute) {
        this._loadedFormatting[formatAttribute] = listItemFormatAttribute;
    }
    /**
	* Returns true if the given model attribute name is a supported inline formatting attribute.
	*/ _isInlineOrSelectionFormatting(attributeKey) {
        return attributeKey.replace(/^selection:/, "") in this._loadedFormatting;
    }
};
/**
* Returns the consistent format of the list item element.
* If the list item contains multiple blocks, it checks only the first block.
*/ function $ab0101fae4fd036b$var$getListItemConsistentFormat(model, listItem, attributeKeys) {
    if ($ab0101fae4fd036b$export$f3f5b10432a99ae7(listItem)) return $ab0101fae4fd036b$var$getSingleListItemConsistentFormat(model, listItem, attributeKeys);
    return $ab0101fae4fd036b$var$getSingleListItemConsistentFormat(model, $ab0101fae4fd036b$export$8498b9023b0db3dd(listItem)[0], attributeKeys);
}
/**
* Returns the consistent format of a single list item element.
*/ function $ab0101fae4fd036b$var$getSingleListItemConsistentFormat(model, listItem, attributeKeys) {
    if (!$ab0101fae4fd036b$var$isNumberedOrBulletedList(listItem) || model.schema.isLimit(listItem)) return Object.fromEntries(attributeKeys.map((attributeKey)=>[
            attributeKey
        ]));
    if (listItem.isEmpty) return Object.fromEntries(attributeKeys.map((attributeKey)=>[
            attributeKey,
            listItem.getAttribute(`selection:${attributeKey}`)
        ]));
    const attributesToCheck = new Set(attributeKeys);
    const valuesMap = {};
    const walker = model.createRangeIn(listItem).getWalker({
        ignoreElementEnd: true
    });
    for (const { item: item } of walker){
        for (const attributeKey of attributesToCheck)if (model.schema.checkAttribute(item, attributeKey)) {
            const formatAttribute = item.getAttribute(attributeKey);
            if (formatAttribute === void 0) {
                attributesToCheck.delete(attributeKey);
                valuesMap[attributeKey] = void 0;
            } else if (valuesMap[attributeKey] === void 0) valuesMap[attributeKey] = formatAttribute;
            else if (valuesMap[attributeKey] !== formatAttribute) {
                attributesToCheck.delete(attributeKey);
                valuesMap[attributeKey] = void 0;
            }
        } else if (!(attributeKey in valuesMap)) valuesMap[attributeKey] = void 0;
        if (!attributesToCheck.size) break;
        if (model.schema.isLimit(item)) walker.jumpTo(model.createPositionAfter(item));
    }
    return valuesMap;
}
/**
* Adds the specified formatting attribute to the list item element.
*/ function $ab0101fae4fd036b$var$setFormattingToListItem(writer, listItem, attributeKey, attributeValue) {
    const listItemBlocks = $ab0101fae4fd036b$export$8498b9023b0db3dd(listItem);
    let wasChanged = false;
    for (const listItem of listItemBlocks)if (!listItem.hasAttribute(attributeKey) || listItem.getAttribute(attributeKey) !== attributeValue) {
        writer.setAttribute(attributeKey, attributeValue, listItem);
        wasChanged = true;
    }
    return wasChanged;
}
/**
* Removes the specified formatting attribute from the list item element.
*/ function $ab0101fae4fd036b$var$removeFormattingFromListItem(writer, listItem, attributeKey) {
    const listItemBlocks = $ab0101fae4fd036b$export$8498b9023b0db3dd(listItem);
    let wasChanged = false;
    for (const listItem of listItemBlocks)if (listItem.hasAttribute(attributeKey)) {
        writer.removeAttribute(attributeKey, listItem);
        wasChanged = true;
    }
    return wasChanged;
}
/**
* Checks if the given list type is a numbered or bulleted list.
*/ function $ab0101fae4fd036b$var$isNumberedOrBulletedList(listItem) {
    return [
        "numbered",
        "bulleted",
        "customNumbered",
        "customBulleted"
    ].includes(listItem.getAttribute("listType"));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A set of helpers related to document lists.
*/ var $ab0101fae4fd036b$export$f2e7765fb620050 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Expands the given list of selected blocks to include all the items of the lists they're in.
	*
	* @param blocks The list of selected blocks.
	*/ expandListBlocksToCompleteList(blocks) {
        return $ab0101fae4fd036b$export$dc8c7f1b370743d6(blocks);
    }
    /**
	* Check if the given block is the first in the list item.
	*
	* @param listBlock The list block element.
	*/ isFirstBlockOfListItem(listBlock) {
        return $ab0101fae4fd036b$export$f3f5b10432a99ae7(listBlock);
    }
    /**
	* Returns true if the given model node is a list item block.
	*
	* @param node A model node.
	*/ isListItemBlock(node) {
        return $ab0101fae4fd036b$export$d0c47194f8840044(node);
    }
    /**
	* Expands the given list of selected blocks to include the leading and tailing blocks of partially selected list items.
	*
	* @param blocks The list of selected blocks.
	* @param options.withNested Whether should include nested list items.
	*/ expandListBlocksToCompleteItems(blocks, options = {}) {
        return $ab0101fae4fd036b$export$b32096908b994f87(blocks, options);
    }
    /**
	* Returns true if listType is of type `numbered` or `customNumbered`.
	*/ isNumberedListType(listType) {
        return $ab0101fae4fd036b$export$a36753f029939118(listType);
    }
    /**
	* Returns true if the given list item is the first item in the list.
	*/ isFirstListItemInList(listItem) {
        return $ab0101fae4fd036b$var$isFirstListItemInList(listItem);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Checks if view element is a list type (ul or ol).
*
* @internal
*/ function $ab0101fae4fd036b$export$9f22b5e32be1c52e(viewElement) {
    return viewElement.is("element", "ol") || viewElement.is("element", "ul");
}
/**
* Checks if view element is a list item (li).
*
* @internal
*/ function $ab0101fae4fd036b$export$d3cf4865a690bdfb(viewElement) {
    return viewElement.is("element", "li");
}
/**
* Calculates the indent value for a list item. Handles HTML compliant and non-compliant lists.
*
* Also, fixes non HTML compliant lists indents:
*
* ```
* before:                                     fixed list:
* OL                                          OL
* |-> LI (parent LIs: 0)                      |-> LI     (indent: 0)
*     |-> OL                                  |-> OL
*         |-> OL                                  |
*         |   |-> OL                              |
*         |       |-> OL                          |
*         |           |-> LI (parent LIs: 1)      |-> LI (indent: 1)
*         |-> LI (parent LIs: 1)                  |-> LI (indent: 1)
*
* before:                                     fixed list:
* OL                                          OL
* |-> OL                                      |
*     |-> OL                                  |
*          |-> OL                             |
*              |-> LI (parent LIs: 0)         |-> LI        (indent: 0)
*
* before:                                     fixed list:
* OL                                          OL
* |-> LI (parent LIs: 0)                      |-> LI         (indent: 0)
* |-> OL                                          |-> OL
*     |-> LI (parent LIs: 0)                          |-> LI (indent: 1)
* ```
*
* @internal
*/ function $ab0101fae4fd036b$export$d08397f1029c703f(listItem) {
    let indent = 0;
    let parent = listItem.parent;
    while(parent){
        if ($ab0101fae4fd036b$export$d3cf4865a690bdfb(parent)) indent++;
        else {
            const previousSibling = parent.previousSibling;
            if (previousSibling && $ab0101fae4fd036b$export$d3cf4865a690bdfb(previousSibling)) indent++;
        }
        parent = parent.parent;
    }
    return indent;
}
/**
* Creates a list attribute element (ol or ul).
*
* @internal
*/ function $ab0101fae4fd036b$export$c50e1cec3321ad85(writer, indent, type, id = $ab0101fae4fd036b$export$68e773c60c8992a(type, indent)) {
    return writer.createAttributeElement($ab0101fae4fd036b$export$4355c723328eff77(type), null, {
        priority: 2 * indent / 100 - 100,
        id: id
    });
}
/**
* Creates a list item attribute element (li).
*
* @internal
*/ function $ab0101fae4fd036b$export$5abfa2bb7fef0726(writer, indent, id) {
    return writer.createAttributeElement("li", null, {
        priority: (2 * indent + 1) / 100 - 100,
        id: id
    });
}
/**
* Returns a view element name for the given list type.
*
* @internal
*/ function $ab0101fae4fd036b$export$4355c723328eff77(type) {
    return type == "numbered" || type == "customNumbered" ? "ol" : "ul";
}
/**
* Returns a view element ID for the given list type and indent.
*
* @internal
*/ function $ab0101fae4fd036b$export$68e773c60c8992a(type, indent) {
    return `list-${type}-${indent}`;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Based on the provided positions looks for the list head and stores it in the provided map.
*
* @internal
* @param position The search starting position.
* @param itemToListHead The map from list item element to the list head element.
* @param visited A set of elements that were already visited.
*/ function $ab0101fae4fd036b$export$dba9d9c15520cbdd(position, itemToListHead, visited) {
    const previousNode = position.nodeBefore;
    if (!$ab0101fae4fd036b$export$d0c47194f8840044(previousNode)) {
        const item = position.nodeAfter;
        if ($ab0101fae4fd036b$export$d0c47194f8840044(item)) itemToListHead.add(item);
    } else {
        let listHead = previousNode;
        for (const { node: node } of new $ab0101fae4fd036b$export$35b0a621484ad300(listHead, "backward")){
            listHead = node;
            if (visited.has(listHead)) return;
            visited.add(listHead);
            if (itemToListHead.has(previousNode)) return;
        }
        itemToListHead.add(listHead);
    }
}
/**
* Scans the list starting from the given list head element and fixes items' indentation.
*
* @internal
* @param listNodes The iterable of list nodes.
* @param writer The model writer.
* @returns Whether the model was modified.
*/ function $ab0101fae4fd036b$export$9ccd8a7aad456e5d(listNodes, writer) {
    let maxIndent = 0;
    let prevIndent = -1;
    let fixBy = null;
    let applied = false;
    for (const { node: node } of listNodes){
        const itemIndent = node.getAttribute("listIndent");
        if (itemIndent > maxIndent) {
            let newIndent;
            if (fixBy === null) {
                fixBy = itemIndent - maxIndent;
                newIndent = maxIndent;
            } else {
                if (fixBy > itemIndent) fixBy = itemIndent;
                newIndent = itemIndent - fixBy;
            }
            if (newIndent > prevIndent + 1) newIndent = prevIndent + 1;
            writer.setAttribute("listIndent", newIndent, node);
            applied = true;
            prevIndent = newIndent;
        } else {
            fixBy = null;
            maxIndent = itemIndent + 1;
            prevIndent = itemIndent;
        }
    }
    return applied;
}
/**
* Scans the list starting from the given list head element and fixes items' types.
*
* @internal
* @param listNodes The iterable of list nodes.
* @param seenIds The set of already known IDs.
* @param writer The model writer.
* @returns Whether the model was modified.
*/ function $ab0101fae4fd036b$export$c24dc3e276a2943d(listNodes, seenIds, writer) {
    const visited = /* @__PURE__ */ new Set();
    let applied = false;
    for (const { node: node } of listNodes){
        if (visited.has(node)) continue;
        let listType = node.getAttribute("listType");
        let listItemId = node.getAttribute("listItemId");
        if (seenIds.has(listItemId)) listItemId = $ab0101fae4fd036b$export$3f9105797bf11127.next();
        seenIds.add(listItemId);
        if (node.is("element", "listItem")) {
            if (node.getAttribute("listItemId") != listItemId) {
                writer.setAttribute("listItemId", listItemId, node);
                applied = true;
            }
            continue;
        }
        for (const block of $ab0101fae4fd036b$export$751560b055ff70d6(node, {
            direction: "forward"
        })){
            visited.add(block);
            if (block.getAttribute("listType") != listType) {
                listItemId = $ab0101fae4fd036b$export$3f9105797bf11127.next();
                listType = block.getAttribute("listType");
            }
            if (block.getAttribute("listItemId") != listItemId) {
                writer.setAttribute("listItemId", listItemId, block);
                applied = true;
            }
        }
    }
    return applied;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a consuming upcast converter for skip-level list item wrappers. It detects intermediate `<li>` elements
* with `list-style-type:none` (generated by the skip-level downcast or by external sources) and consumes them
* without producing a model element, so they don't end up as empty list items in the model.
*
* The wrapper `<li>` is consumed, but its children (nested lists) are converted normally. Because `getIndent()`
* counts all ancestor `<li>` elements (including the consumed wrapper), nested items receive the correct indent
* values that reflect the skip-level gap.
*
* Only `<li>` elements whose sole meaningful content is a nested `<ul>`/`<ol>` are treated as intermediate wrappers.
* Anything else (text, paragraphs, custom elements, even an empty `<li>` with `list-style-type:none` carrying only
* attributes) falls through to the regular list item upcast, so its data and attributes can be preserved by GHS
* or other plugins.
*
* @internal
*/ function $ab0101fae4fd036b$var$listItemSkipLevelConsumer() {
    return (evt, data, conversionApi)=>{
        const viewItem = data.viewItem;
        if (viewItem.getStyle("list-style-type") !== "none") return;
        if (!$ab0101fae4fd036b$var$isSkipLevelWrapper(viewItem)) return;
        if (!conversionApi.consumable.consume(viewItem, {
            name: true
        })) return;
        const { modelRange: modelRange, modelCursor: modelCursor } = conversionApi.convertChildren(viewItem, data.modelCursor);
        data.modelRange = modelRange;
        data.modelCursor = modelCursor;
    };
}
/**
* Checks whether a `<li>` view element is a skip-level intermediate wrapper, i.e. its only child is a nested
* `<ul>`/`<ol>`. Any other content (text, `<br>`, `<p>`, custom elements, NBSP, etc.) disqualifies the element,
* so it is upcast as a regular list item.
*/ function $ab0101fae4fd036b$var$isSkipLevelWrapper(viewItem) {
    let hasNestedList = false;
    for (const child of viewItem.getChildren()){
        if (child.is("element", "ul") || child.is("element", "ol")) {
            hasNestedList = true;
            continue;
        }
        return false;
    }
    return hasNestedList;
}
/**
* Returns the upcast converter for list items. It's supposed to work after the block converters (content inside list items) are converted.
*
* @internal
*/ function $ab0101fae4fd036b$export$cbd2f0808e1e6729() {
    return (evt, data, conversionApi)=>{
        const { writer: writer, schema: schema } = conversionApi;
        if (!data.modelRange) return;
        const items = Array.from(data.modelRange.getItems({
            shallow: true
        })).filter((item)=>schema.checkAttribute(item, "listItemId"));
        if (!items.length) return;
        if (items.every((item)=>item.hasAttribute("listItemId"))) return;
        const listItemId = data.viewItem.getAttribute("data-list-item-id") || $ab0101fae4fd036b$export$3f9105797bf11127.next();
        conversionApi.consumable.consume(data.viewItem, {
            attributes: "data-list-item-id"
        });
        const listIndent = $ab0101fae4fd036b$export$d08397f1029c703f(data.viewItem);
        let listType = data.viewItem.parent && data.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
        const firstItemListType = items[0].getAttribute("listType");
        if (firstItemListType) listType = firstItemListType;
        const attributes = {
            listItemId: listItemId,
            listIndent: listIndent,
            listType: listType
        };
        for (const item of items)if (!item.hasAttribute("listItemId")) writer.setAttributes(attributes, item);
        if (items.length > 1) {
            if (items[1].getAttribute("listItemId") != attributes.listItemId) conversionApi.keepEmptyElement(items[0]);
        }
    };
}
/**
* Returns a model document change:data event listener that triggers conversion of related items if needed.
*
* @internal
* @param model The editor model.
* @param editing The editing controller.
* @param attributeNames The list of all model list attributes (including registered strategies).
* @param listEditing The document list editing plugin.
*/ function $ab0101fae4fd036b$export$87e650915c787246(model, editing, attributeNames, listEditing) {
    return ()=>{
        const changes = model.document.differ.getChanges();
        const itemsToRefresh = [];
        const itemToListHead = /* @__PURE__ */ new Set();
        const changedItems = /* @__PURE__ */ new Set();
        const visited = /* @__PURE__ */ new Set();
        for (const entry of changes)if (entry.type == "insert" && entry.name != "$text") {
            $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position, itemToListHead, visited);
            if (!entry.attributes.has("listItemId")) $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position.getShiftedBy(entry.length), itemToListHead, visited);
            else changedItems.add(entry.position.nodeAfter);
        } else if (entry.type == "remove" && entry.attributes.has("listItemId")) $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position, itemToListHead, visited);
        else if (entry.type == "attribute") {
            const item = entry.range.start.nodeAfter;
            if (attributeNames.includes(entry.attributeKey)) {
                $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.range.start, itemToListHead, visited);
                if (entry.attributeNewValue === null) {
                    $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.range.start.getShiftedBy(1), itemToListHead, visited);
                    if (doesItemBlockRequiresRefresh(item)) itemsToRefresh.push(item);
                } else changedItems.add(item);
            } else if ($ab0101fae4fd036b$export$d0c47194f8840044(item)) {
                if (doesItemBlockRequiresRefresh(item)) itemsToRefresh.push(item);
            }
        }
        for (const listHead of itemToListHead.values())itemsToRefresh.push(...collectListItemsToRefresh(listHead, changedItems));
        for (const item of new Set(itemsToRefresh))editing.reconvertItem(item);
    };
    function collectListItemsToRefresh(listHead, changedItems) {
        const itemsToRefresh = [];
        const visited = /* @__PURE__ */ new Set();
        const stack = [];
        for (const { node: node, previous: previous } of new $ab0101fae4fd036b$export$35b0a621484ad300(listHead)){
            if (visited.has(node)) continue;
            const itemIndent = node.getAttribute("listIndent");
            if (previous && itemIndent < previous.getAttribute("listIndent")) stack.length = itemIndent + 1;
            stack[itemIndent] = {
                modelAttributes: getListModelAttributes(node),
                modelElement: node
            };
            fillStackForIntermediates(node, itemIndent, stack);
            const blocks = $ab0101fae4fd036b$export$751560b055ff70d6(node, {
                direction: "forward"
            });
            for (const block of blocks){
                visited.add(block);
                if (doesItemBlockRequiresRefresh(block, blocks)) itemsToRefresh.push(block);
                else if (doesItemWrappingRequiresRefresh(block, stack, changedItems)) itemsToRefresh.push(block);
            }
        }
        return itemsToRefresh;
    }
    function getListModelAttributes(item) {
        return Object.fromEntries(Array.from(item.getAttributes()).filter(([key])=>attributeNames.includes(key)));
    }
    function fillStackForIntermediates(node, itemIndent, stack) {
        for(let i = itemIndent - 1; i >= 0; i--){
            if (stack[i]) break;
            const siblingAtIndent = $ab0101fae4fd036b$var$findSiblingListItemAt(node, i);
            let ancestorAtLowerIndent = null;
            if (!siblingAtIndent) {
                for(let k = i - 1; k >= 0; k--)if (stack[k]) {
                    ancestorAtLowerIndent = stack[k].modelElement;
                    break;
                }
            }
            const referenceItem = siblingAtIndent || ancestorAtLowerIndent || node;
            stack[i] = {
                modelAttributes: {
                    ...getListModelAttributes(referenceItem),
                    listItemId: `list-item-skip-${i}`,
                    listIndent: i
                },
                modelElement: referenceItem
            };
        }
    }
    function doesItemBlockRequiresRefresh(item, blocks) {
        const viewElement = editing.mapper.toViewElement(item);
        if (!viewElement) return false;
        if (isItemBlockInsideStructureSlot(viewElement)) return true;
        if (listEditing.fire("checkElement", {
            modelElement: item,
            viewElement: viewElement
        })) return true;
        if (!item.is("element", "paragraph") && !item.is("element", "listItem")) return false;
        const useBogus = $ab0101fae4fd036b$var$shouldUseBogusParagraph(item, attributeNames, blocks);
        if (useBogus && viewElement.is("element", "p")) return true;
        else if (!useBogus && viewElement.is("element", "span")) return true;
        return false;
    }
    function isItemBlockInsideStructureSlot(viewElement) {
        viewElement = viewElement.parent;
        while(viewElement.is("attributeElement") && [
            "ol",
            "ul",
            "li"
        ].includes(viewElement.name))viewElement = viewElement.parent;
        if (viewElement.getCustomProperty("$structureSlotParent") && !editing.mapper.toModelElement(viewElement)) return true;
        return false;
    }
    function doesItemWrappingRequiresRefresh(item, stack, changedItems) {
        if (changedItems.has(item)) return false;
        const viewElement = editing.mapper.toViewElement(item);
        let indent = stack.length - 1;
        for(let element = viewElement.parent; !element.is("editableElement"); element = element.parent){
            const isListItemElement = $ab0101fae4fd036b$export$d3cf4865a690bdfb(element);
            const isListElement = $ab0101fae4fd036b$export$9f22b5e32be1c52e(element);
            if (!isListElement && !isListItemElement) continue;
            /* v8 ignore next -- Defensive guard for transient skip-level list stack gaps. */ if (stack[indent]) {
                const eventName = `checkAttributes:${isListItemElement ? "item" : "list"}`;
                if (listEditing.fire(eventName, {
                    viewElement: element,
                    modelAttributes: stack[indent].modelAttributes,
                    modelReferenceElement: stack[indent].modelElement
                })) break;
            }
            if (isListElement) {
                indent--;
                if (indent < 0) return false;
            }
        }
        return true;
    }
}
/**
* Returns the list item downcast converter.
*
* @internal
* @param attributeNames A list of attribute names that should be converted if they are set.
* @param strategies The strategies.
* @param model The model.
*/ function $ab0101fae4fd036b$export$af7cb30b5106666e(attributeNames, strategies, model, { dataPipeline: dataPipeline, enableSkipLevelLists: enableSkipLevelLists }) {
    const consumer = $ab0101fae4fd036b$var$createAttributesConsumer(attributeNames, strategies);
    return (evt, data, conversionApi)=>{
        const { writer: writer, mapper: mapper, consumable: consumable } = conversionApi;
        const listItem = data.item;
        if (!attributeNames.includes(data.attributeKey)) return;
        if (!consumer(listItem, consumable)) return;
        const options = {
            ...conversionApi.options,
            dataPipeline: dataPipeline,
            enableSkipLevelLists: enableSkipLevelLists
        };
        const viewElement = $ab0101fae4fd036b$export$d084e601ea328f2b(listItem, mapper, model, writer);
        $ab0101fae4fd036b$var$removeCustomMarkerElements(viewElement, writer, mapper);
        $ab0101fae4fd036b$var$unwrapListItemBlock(viewElement, writer);
        $ab0101fae4fd036b$var$wrapListItemBlock(listItem, $ab0101fae4fd036b$var$insertCustomMarkerElements(listItem, viewElement, strategies, writer, options), strategies, writer, options);
    };
}
/**
* The 'remove' downcast converter for custom markers.
*
* @internal
*/ function $ab0101fae4fd036b$export$c7d83fb38fe1706a(schema) {
    return (evt, data, conversionApi)=>{
        const { writer: writer, mapper: mapper } = conversionApi;
        const elementName = evt.name.split(":")[1];
        if (!schema.checkAttribute(elementName, "listItemId")) return;
        const viewStart = mapper.toViewPosition(data.position);
        const modelEnd = data.position.getShiftedBy(data.length);
        const viewEnd = mapper.toViewPosition(modelEnd, {
            isPhantom: true
        });
        const viewElement = writer.createRange(viewStart, viewEnd).getTrimmed().end.nodeBefore;
        /* istanbul ignore next -- @preserve */ if (!viewElement) return;
        $ab0101fae4fd036b$var$removeCustomMarkerElements(viewElement, writer, mapper);
    };
}
/**
* Returns the bogus paragraph view element creator. A bogus paragraph is used if a list item contains only a single block or nested list.
*
* @internal
* @param attributeNames The list of all model list attributes (including registered strategies).
*/ function $ab0101fae4fd036b$export$fa60ff23de27619d(attributeNames, { dataPipeline: dataPipeline } = {}) {
    return (modelElement, { writer: writer })=>{
        if (!$ab0101fae4fd036b$var$shouldUseBogusParagraph(modelElement, attributeNames)) return null;
        if (!dataPipeline) return writer.createContainerElement("span", {
            class: "ck-list-bogus-paragraph"
        });
        const viewElement = writer.createContainerElement("p");
        writer.setCustomProperty("dataPipeline:transparentRendering", true, viewElement);
        return viewElement;
    };
}
/**
* Helper for mapping mode to view elements. It's using positions mapping instead of mapper.toViewElement( element )
* to find outermost view element. This is for cases when mapping is using inner view element like in the code blocks (pre > code).
*
* @internal
* @param element The model element.
* @param mapper The mapper instance.
* @param model The model.
* @param writer The view downcast writer.
*/ function $ab0101fae4fd036b$export$d084e601ea328f2b(element, mapper, model, writer) {
    const modelRange = model.createRangeOn(element);
    const viewWalker = mapper.toViewRange(modelRange).getTrimmed().getWalker();
    for (const { item: item } of viewWalker)if (item.is("element") && item.getCustomProperty("listItemMarker")) viewWalker.jumpTo(writer.createPositionAfter(item));
    else if (item.is("element") && !item.getCustomProperty("listItemWrapper")) return item;
}
/**
* The model to view custom position mapping for cases when marker is injected at the beginning of a block.
*
* @internal
*/ function $ab0101fae4fd036b$export$ff3aeb25a4655fd9(strategies, view) {
    return (evt, data)=>{
        if (data.modelPosition.offset > 0) return;
        const positionParent = data.modelPosition.parent;
        if (!$ab0101fae4fd036b$export$d0c47194f8840044(positionParent)) return;
        if (!strategies.some((strategy)=>strategy.scope == "itemMarker" && strategy.canInjectMarkerIntoElement && strategy.canInjectMarkerIntoElement(positionParent))) return;
        const viewElement = data.mapper.toViewElement(positionParent);
        const viewRange = view.createRangeIn(viewElement);
        const viewWalker = viewRange.getWalker();
        let positionAfterLastMarker = viewRange.start;
        for (const { item: item } of viewWalker){
            if (item.is("element") && data.mapper.toModelElement(item) || item.is("$textProxy")) break;
            /* v8 ignore next -- Depends on custom marker internals in mapper position translation. */ if (item.is("element") && item.getCustomProperty("listItemMarker")) {
                positionAfterLastMarker = view.createPositionAfter(item);
                viewWalker.skip(({ previousPosition: previousPosition })=>!previousPosition.isEqual(positionAfterLastMarker));
            }
        }
        data.viewPosition = positionAfterLastMarker;
    };
}
/**
* Removes a custom marker elements and item wrappers related to that marker.
*/ function $ab0101fae4fd036b$var$removeCustomMarkerElements(viewElement, viewWriter, mapper) {
    while(viewElement.parent.is("attributeElement") && viewElement.parent.getCustomProperty("listItemWrapper"))viewWriter.unwrap(viewWriter.createRangeOn(viewElement), viewElement.parent);
    const markersToRemove = [];
    collectMarkersToRemove(viewWriter.createPositionBefore(viewElement).getWalker({
        direction: "backward"
    }));
    collectMarkersToRemove(viewWriter.createRangeIn(viewElement).getWalker());
    for (const marker of markersToRemove)viewWriter.remove(marker);
    function collectMarkersToRemove(viewWalker) {
        for (const { item: item } of viewWalker){
            if (item.is("element") && mapper.toModelElement(item)) break;
            if (item.is("element") && item.getCustomProperty("listItemMarker")) markersToRemove.push(item);
        }
    }
}
/**
* Inserts a custom marker elements and wraps first block of a list item if marker requires it.
*/ function $ab0101fae4fd036b$var$insertCustomMarkerElements(listItem, viewElement, strategies, writer, { dataPipeline: dataPipeline }) {
    let viewRange = writer.createRangeOn(viewElement);
    if (!$ab0101fae4fd036b$export$f3f5b10432a99ae7(listItem)) return viewRange;
    for (const strategy of strategies){
        if (strategy.scope != "itemMarker") continue;
        const markerElement = strategy.createElement(writer, listItem, {
            dataPipeline: dataPipeline
        });
        if (!markerElement) continue;
        writer.setCustomProperty("listItemMarker", true, markerElement);
        if (strategy.canInjectMarkerIntoElement && strategy.canInjectMarkerIntoElement(listItem)) writer.insert(writer.createPositionAt(viewElement, 0), markerElement);
        else {
            writer.insert(viewRange.start, markerElement);
            viewRange = writer.createRange(writer.createPositionBefore(markerElement), writer.createPositionAfter(viewElement));
        }
        if (!strategy.createWrapperElement || !strategy.canWrapElement) continue;
        const wrapper = strategy.createWrapperElement(writer, listItem, {
            dataPipeline: dataPipeline
        });
        writer.setCustomProperty("listItemWrapper", true, wrapper);
        if (strategy.canWrapElement(listItem)) viewRange = writer.wrap(viewRange, wrapper);
        else {
            viewRange = writer.wrap(writer.createRangeOn(markerElement), wrapper);
            viewRange = writer.createRange(viewRange.start, writer.createPositionAfter(viewElement));
        }
    }
    return viewRange;
}
/**
* Unwraps all ol, ul, and li attribute elements that are wrapping the provided view element.
*/ function $ab0101fae4fd036b$var$unwrapListItemBlock(viewElement, viewWriter) {
    let attributeElement = viewElement.parent;
    while(attributeElement.is("attributeElement") && [
        "ul",
        "ol",
        "li"
    ].includes(attributeElement.name)){
        const parentElement = attributeElement.parent;
        viewWriter.unwrap(viewWriter.createRangeOn(viewElement), attributeElement);
        attributeElement = parentElement;
    }
}
/**
* Wraps the given list item with appropriate attribute elements for ul, ol, and li.
*
* For skip-level lists (where indent gaps exist, e.g. indent 0 → indent 2), this function
* generates intermediate wrapper pairs (ul/ol + li) at each missing level. These intermediate
* wrappers are invisible (`list-style-type: none` on the li). Scope `'list'` strategies are
* applied so the wrapper element (ul/ol) carries the same classes and styles as real list
* wrappers, while scope `'item'` strategies are skipped since there is no model element
* backing the intermediate level.
*/ function $ab0101fae4fd036b$var$wrapListItemBlock(listItem, viewRange, strategies, writer, options) {
    if (!listItem.hasAttribute("listIndent")) return;
    const listItemIndent = listItem.getAttribute("listIndent");
    const enableSkipLevelLists = options.enableSkipLevelLists;
    let currentListItem = listItem;
    for(let indent = listItemIndent; indent >= 0; indent--){
        const isIntermediate = currentListItem.getAttribute("listIndent") !== indent;
        if (isIntermediate) {
            const referenceItem = $ab0101fae4fd036b$var$findSiblingListItemAt(listItem, indent) || currentListItem;
            const listType = referenceItem.getAttribute("listType");
            const listItemViewElement = $ab0101fae4fd036b$export$5abfa2bb7fef0726(writer, indent, `list-item-skip-${indent}`);
            const listViewElement = $ab0101fae4fd036b$export$c50e1cec3321ad85(writer, indent, listType);
            writer.setStyle("list-style-type", "none", listItemViewElement);
            for (const strategy of strategies)if (strategy.scope == "list" && referenceItem.hasAttribute(strategy.attributeName)) strategy.setAttributeOnDowncast(writer, referenceItem.getAttribute(strategy.attributeName), listViewElement, options, referenceItem);
            viewRange = writer.wrap(viewRange, listItemViewElement);
            viewRange = writer.wrap(viewRange, listViewElement);
        } else {
            const listItemViewElement = $ab0101fae4fd036b$export$5abfa2bb7fef0726(writer, indent, currentListItem.getAttribute("listItemId"));
            const listViewElement = $ab0101fae4fd036b$export$c50e1cec3321ad85(writer, indent, currentListItem.getAttribute("listType"));
            for (const strategy of strategies)if ((strategy.scope == "list" || strategy.scope == "item") && currentListItem.hasAttribute(strategy.attributeName)) strategy.setAttributeOnDowncast(writer, currentListItem.getAttribute(strategy.attributeName), strategy.scope == "list" ? listViewElement : listItemViewElement, options, currentListItem);
            viewRange = writer.wrap(viewRange, listItemViewElement);
            viewRange = writer.wrap(viewRange, listViewElement);
        }
        if (indent == 0) break;
        if (!isIntermediate) {
            const nextListItem = $ab0101fae4fd036b$export$20d2bb1761c58007.first(currentListItem, {
                lowerIndent: true
            });
            if (nextListItem) currentListItem = nextListItem;
            else if (!enableSkipLevelLists) break;
        }
    }
}
/**
* Walks forward from the given list item through model siblings to find the first list item block
* at exactly the specified indent level. Stops when it encounters a non-list block or a list item
* at a lower indent (which means we left the current subtree).
*/ function $ab0101fae4fd036b$var$findSiblingListItemAt(listItem, targetIndent) {
    let node = listItem.nextSibling;
    while(node && $ab0101fae4fd036b$export$d0c47194f8840044(node)){
        const indent = node.getAttribute("listIndent");
        if (indent < targetIndent) return null;
        if (indent === targetIndent) return node;
        node = node.nextSibling;
    }
    return null;
}
function $ab0101fae4fd036b$var$createAttributesConsumer(attributeNames, strategies) {
    const nonConsumingAttributes = strategies.filter((strategy)=>strategy.consume === false).map((strategy)=>strategy.attributeName);
    return (node, consumable)=>{
        const events = [];
        for (const attributeName of attributeNames)if (node.hasAttribute(attributeName) && !nonConsumingAttributes.includes(attributeName)) events.push(`attribute:${attributeName}`);
        if (!events.every((event)=>consumable.test(node, event) !== false)) return false;
        events.forEach((event)=>consumable.consume(node, event));
        return true;
    };
}
function $ab0101fae4fd036b$var$shouldUseBogusParagraph(item, attributeNames, blocks = $ab0101fae4fd036b$export$8498b9023b0db3dd(item)) {
    if (!$ab0101fae4fd036b$export$d0c47194f8840044(item)) return false;
    for (const attributeKey of item.getAttributeKeys()){
        if (attributeKey.startsWith("selection:") || attributeKey == "htmlEmptyBlock") continue;
        if (!attributeNames.includes(attributeKey)) return false;
    }
    return blocks.length < 2;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list/listediting
*/ /**
* A list of base list model attributes.
*/ const $ab0101fae4fd036b$var$LIST_BASE_ATTRIBUTES = [
    "listType",
    "listIndent",
    "listItemId"
];
/**
* The editing part of the document-list feature. It handles creating, editing and removing lists and list items.
*/ var $ab0101fae4fd036b$export$3886a37ee979f1f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The list of registered downcast strategies.
	*/ _downcastStrategies = [];
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538),
            $ab0101fae4fd036b$export$f2e7765fb620050,
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09),
            $ab0101fae4fd036b$export$7e276964ef921d70
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("list.multiBlock", true);
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const multiBlock = editor.config.get("list.multiBlock");
        if (editor.plugins.has("LegacyListEditing")) /**
		* The `List` feature cannot be loaded together with the `LegacyList` plugin.
		*
		* @error list-feature-conflict
		* @param {string} conflictPlugin Name of the plugin.
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("list-feature-conflict", this, {
            conflictPlugin: "LegacyListEditing"
        });
        model.schema.register("$listItem", {
            allowAttributes: $ab0101fae4fd036b$var$LIST_BASE_ATTRIBUTES
        });
        if (multiBlock) {
            model.schema.extend("$container", {
                allowAttributesOf: "$listItem"
            });
            model.schema.extend("$block", {
                allowAttributesOf: "$listItem"
            });
            model.schema.extend("$blockObject", {
                allowAttributesOf: "$listItem"
            });
        } else model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributesOf: "$listItem"
        });
        for (const attribute of $ab0101fae4fd036b$var$LIST_BASE_ATTRIBUTES)model.schema.setAttributeProperties(attribute, {
            copyOnReplace: true
        });
        editor.commands.add("numberedList", new $ab0101fae4fd036b$export$ba93ee87858e1659(editor, "numbered"));
        editor.commands.add("bulletedList", new $ab0101fae4fd036b$export$ba93ee87858e1659(editor, "bulleted"));
        editor.commands.add("customNumberedList", new $ab0101fae4fd036b$export$ba93ee87858e1659(editor, "customNumbered", {
            multiLevel: true
        }));
        editor.commands.add("customBulletedList", new $ab0101fae4fd036b$export$ba93ee87858e1659(editor, "customBulleted", {
            multiLevel: true
        }));
        editor.commands.add("indentList", new $ab0101fae4fd036b$export$6047ce71187af101(editor, "forward"));
        editor.commands.add("outdentList", new $ab0101fae4fd036b$export$6047ce71187af101(editor, "backward"));
        editor.commands.add("splitListItemBefore", new $ab0101fae4fd036b$export$e6fdcf59e0274d3e(editor, "before"));
        editor.commands.add("splitListItemAfter", new $ab0101fae4fd036b$export$e6fdcf59e0274d3e(editor, "after"));
        if (multiBlock) {
            editor.commands.add("mergeListItemBackward", new $ab0101fae4fd036b$export$122668825ef5b4c0(editor, "backward"));
            editor.commands.add("mergeListItemForward", new $ab0101fae4fd036b$export$122668825ef5b4c0(editor, "forward"));
        }
        this._setupDeleteIntegration();
        this._setupEnterIntegration();
        this._setupTabIntegration();
        this._setupClipboardIntegration();
        this._setupAccessibilityIntegration();
        this._setupListItemIdConversionStrategy();
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const commands = this.editor.commands;
        const indent = commands.get("indent");
        const outdent = commands.get("outdent");
        if (indent) indent.registerChildCommand(commands.get("indentList"), {
            priority: "high"
        });
        if (outdent) outdent.registerChildCommand(commands.get("outdentList"), {
            priority: "lowest"
        });
        this._setupModelPostFixing();
        this._setupConversion();
    }
    /**
	* Registers a downcast strategy.
	*
	* **Note**: Strategies must be registered in the `Plugin#init()` phase so that it can be applied
	* in the `ListEditing#afterInit()`.
	*
	* @param strategy The downcast strategy to register.
	*/ registerDowncastStrategy(strategy) {
        this._downcastStrategies.push(strategy);
    }
    /**
	* Returns list of model attribute names that should affect downcast conversion.
	*/ getListAttributeNames() {
        return [
            ...$ab0101fae4fd036b$var$LIST_BASE_ATTRIBUTES,
            ...this._downcastStrategies.map((strategy)=>strategy.attributeName)
        ];
    }
    /**
	* Attaches the listener to the {@link module:engine/view/document~ViewDocument#event:delete} event and handles backspace/delete
	* keys in and around document lists.
	*/ _setupDeleteIntegration() {
        const editor = this.editor;
        const mergeBackwardCommand = editor.commands.get("mergeListItemBackward");
        const mergeForwardCommand = editor.commands.get("mergeListItemForward");
        this.listenTo(editor.editing.view.document, "delete", (evt, data)=>{
            const selection = editor.model.document.selection;
            if ($ab0101fae4fd036b$export$a4dd452805552056(editor.model)) return;
            editor.model.change(()=>{
                const firstPosition = selection.getFirstPosition();
                if (selection.isCollapsed && data.direction == "backward") {
                    if (!firstPosition.isAtStart) return;
                    const positionParent = firstPosition.parent;
                    if (!$ab0101fae4fd036b$export$d0c47194f8840044(positionParent)) return;
                    const previousBlock = $ab0101fae4fd036b$export$20d2bb1761c58007.first(positionParent, {
                        sameAttributes: "listType",
                        sameIndent: true
                    });
                    const hasNoMergeTarget = positionParent.getAttribute("listIndent") === 0 || !$ab0101fae4fd036b$export$d0c47194f8840044(positionParent.previousSibling);
                    if (!previousBlock && hasNoMergeTarget) {
                        if (!$ab0101fae4fd036b$export$81db3a00cd478af0(positionParent)) editor.execute("splitListItemAfter");
                        editor.execute("outdentList");
                    } else {
                        if (!mergeBackwardCommand || !mergeBackwardCommand.isEnabled) return;
                        mergeBackwardCommand.execute({
                            shouldMergeOnBlocksContentLevel: $ab0101fae4fd036b$var$shouldMergeOnBlocksContentLevel(editor.model, "backward")
                        });
                    }
                    data.preventDefault();
                    evt.stop();
                } else {
                    if (selection.isCollapsed && !selection.getLastPosition().isAtEnd) return;
                    if (!mergeForwardCommand || !mergeForwardCommand.isEnabled) return;
                    mergeForwardCommand.execute({
                        shouldMergeOnBlocksContentLevel: $ab0101fae4fd036b$var$shouldMergeOnBlocksContentLevel(editor.model, "forward")
                    });
                    data.preventDefault();
                    evt.stop();
                }
            });
        }, {
            context: "li"
        });
    }
    /**
	* Attaches a listener to the {@link module:engine/view/document~ViewDocument#event:enter} event and handles enter key press
	* in document lists.
	*/ _setupEnterIntegration() {
        const editor = this.editor;
        const model = editor.model;
        const commands = editor.commands;
        const enterCommand = commands.get("enter");
        this.listenTo(editor.editing.view.document, "enter", (evt, data)=>{
            const doc = model.document;
            const positionParent = doc.selection.getFirstPosition().parent;
            if (doc.selection.isCollapsed && $ab0101fae4fd036b$export$d0c47194f8840044(positionParent) && positionParent.isEmpty && !data.isSoft) {
                const isFirstBlock = $ab0101fae4fd036b$export$f3f5b10432a99ae7(positionParent);
                const isLastBlock = $ab0101fae4fd036b$export$81db3a00cd478af0(positionParent);
                if (isFirstBlock && isLastBlock) {
                    editor.execute("outdentList");
                    data.preventDefault();
                    evt.stop();
                } else if (isFirstBlock && !isLastBlock) {
                    editor.execute("splitListItemAfter");
                    data.preventDefault();
                    evt.stop();
                } else if (isLastBlock) {
                    editor.execute("splitListItemBefore");
                    data.preventDefault();
                    evt.stop();
                }
            }
        }, {
            context: "li"
        });
        this.listenTo(enterCommand, "afterExecute", ()=>{
            const splitCommand = commands.get("splitListItemBefore");
            splitCommand.refresh();
            if (!splitCommand.isEnabled) return;
            const positionParent = editor.model.document.selection.getLastPosition().parent;
            if ($ab0101fae4fd036b$export$8498b9023b0db3dd(positionParent).length === 2) splitCommand.execute();
        });
    }
    /**
	* Attaches a listener to the {@link module:engine/view/document~ViewDocument#event:tab} event and handles tab key and tab+shift keys
	* presses in document lists.
	*/ _setupTabIntegration() {
        const editor = this.editor;
        this.listenTo(editor.editing.view.document, "tab", (evt, data)=>{
            const commandName = data.shiftKey ? "outdentList" : "indentList";
            if (this.editor.commands.get(commandName).isEnabled) {
                editor.execute(commandName);
                data.stopPropagation();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "li"
        });
    }
    /**
	* Registers the conversion helpers for the document-list feature.
	*/ _setupConversion() {
        const editor = this.editor;
        const model = editor.model;
        const attributeNames = this.getListAttributeNames();
        const multiBlock = editor.config.get("list.multiBlock");
        const elementName = multiBlock ? "paragraph" : "listItem";
        const enableSkipLevelLists = !!editor.config.get("list.enableSkipLevelLists");
        editor.conversion.for("upcast").elementToElement({
            view: "li",
            model: (viewElement, { writer: writer })=>writer.createElement(elementName, {
                    listType: ""
                })
        }).elementToElement({
            view: "p",
            model: (viewElement, { writer: writer })=>{
                if (viewElement.parent && viewElement.parent.is("element", "li")) return writer.createElement(elementName, {
                    listType: ""
                });
                return null;
            },
            converterPriority: "high"
        }).add((dispatcher)=>{
            dispatcher.on("element:p", (evt, data, conversionApi)=>{
                const viewElement = data.viewItem;
                if (!viewElement.parent || !viewElement.parent.is("element", "li")) return;
                if (viewElement.isEmpty) return;
                if (!viewElement.getAttributeKeys().next().done) return;
                for (const sibling of viewElement.parent.getChildren()){
                    if (sibling === viewElement) continue;
                    if (sibling.is("element", "ol") || sibling.is("element", "ul")) continue;
                    return;
                }
                conversionApi.consumable.consume(viewElement, {
                    name: true
                });
                const { modelRange: modelRange, modelCursor: modelCursor } = conversionApi.convertChildren(viewElement, data.modelCursor);
                data.modelRange = modelRange;
                data.modelCursor = modelCursor;
            }, {
                priority: "highest"
            });
            if (enableSkipLevelLists) dispatcher.on("element:li", $ab0101fae4fd036b$var$listItemSkipLevelConsumer(), {
                priority: "high"
            });
            dispatcher.on("element:li", $ab0101fae4fd036b$export$cbd2f0808e1e6729());
        });
        if (!multiBlock) editor.conversion.for("downcast").elementToElement({
            model: "listItem",
            view: "p"
        });
        editor.conversion.for("editingDowncast").elementToElement({
            model: elementName,
            view: $ab0101fae4fd036b$export$fa60ff23de27619d(attributeNames),
            converterPriority: "high"
        }).add((dispatcher)=>{
            dispatcher.on("attribute", $ab0101fae4fd036b$export$af7cb30b5106666e(attributeNames, this._downcastStrategies, model, {
                enableSkipLevelLists: enableSkipLevelLists
            }));
            dispatcher.on("remove", $ab0101fae4fd036b$export$c7d83fb38fe1706a(model.schema));
        });
        editor.conversion.for("dataDowncast").elementToElement({
            model: elementName,
            view: $ab0101fae4fd036b$export$fa60ff23de27619d(attributeNames, {
                dataPipeline: true
            }),
            converterPriority: "high"
        }).add((dispatcher)=>{
            dispatcher.on("attribute", $ab0101fae4fd036b$export$af7cb30b5106666e(attributeNames, this._downcastStrategies, model, {
                dataPipeline: true,
                enableSkipLevelLists: enableSkipLevelLists
            }));
        });
        const modelToViewPositionMapper = $ab0101fae4fd036b$export$ff3aeb25a4655fd9(this._downcastStrategies, editor.editing.view);
        editor.editing.mapper.on("modelToViewPosition", modelToViewPositionMapper);
        editor.data.mapper.on("modelToViewPosition", modelToViewPositionMapper);
        this.listenTo(model.document, "change:data", $ab0101fae4fd036b$export$87e650915c787246(model, editor.editing, attributeNames, this), {
            priority: "high"
        });
        this.on("checkAttributes:item", (evt, { viewElement: viewElement, modelAttributes: modelAttributes })=>{
            if (viewElement.id != modelAttributes.listItemId) {
                evt.return = true;
                evt.stop();
            }
        });
        this.on("checkAttributes:list", (evt, { viewElement: viewElement, modelAttributes: modelAttributes })=>{
            if (viewElement.name != $ab0101fae4fd036b$export$4355c723328eff77(modelAttributes.listType) || viewElement.id != $ab0101fae4fd036b$export$68e773c60c8992a(modelAttributes.listType, modelAttributes.listIndent)) {
                evt.return = true;
                evt.stop();
            }
        });
    }
    /**
	* Registers model post-fixers.
	*/ _setupModelPostFixing() {
        const model = this.editor.model;
        const attributeNames = this.getListAttributeNames();
        model.document.registerPostFixer((writer)=>$ab0101fae4fd036b$var$modelChangePostFixer$1(model, writer, attributeNames, this));
        if (!this.editor.config.get("list.enableSkipLevelLists")) this.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            evt.return = $ab0101fae4fd036b$export$9ccd8a7aad456e5d(listNodes, writer) || evt.return;
        }, {
            priority: "high"
        });
        this.on("postFixer", (evt, { listNodes: listNodes, writer: writer, seenIds: seenIds })=>{
            evt.return = $ab0101fae4fd036b$export$c24dc3e276a2943d(listNodes, seenIds, writer) || evt.return;
        }, {
            priority: "high"
        });
    }
    /**
	* Integrates the feature with the clipboard via {@link module:engine/model/model~Model#insertContent} and
	* {@link module:engine/model/model~Model#getSelectedContent}.
	*/ _setupClipboardIntegration() {
        const model = this.editor.model;
        const clipboardPipeline = this.editor.plugins.get("ClipboardPipeline");
        this.listenTo(model, "insertContent", $ab0101fae4fd036b$var$createModelIndentPasteFixer(model), {
            priority: "high"
        });
        this.listenTo(clipboardPipeline, "outputTransformation", (evt, data)=>{
            model.change((writer)=>{
                const allContentChildren = Array.from(data.content.getChildren());
                const lastItem = allContentChildren[allContentChildren.length - 1];
                if (allContentChildren.length > 1 && lastItem.is("element") && lastItem.isEmpty) {
                    if (allContentChildren.slice(0, -1).every($ab0101fae4fd036b$export$d0c47194f8840044)) writer.remove(lastItem);
                }
                if (data.method == "copy" || data.method == "cut") {
                    const allChildren = Array.from(data.content.getChildren());
                    /* v8 ignore next -- Clipboard output normally reaches this cleanup only for selected single list items. */ if ($ab0101fae4fd036b$export$c9462903d4dfebea(allChildren)) $ab0101fae4fd036b$export$324d61a46bf03ca2(allChildren, writer, this.getListAttributeNames());
                }
            });
        });
    }
    /**
	* Informs editor accessibility features about keystrokes brought by the plugin.
	*/ _setupAccessibilityIntegration() {
        const editor = this.editor;
        const t = editor.t;
        editor.accessibility.addKeystrokeInfoGroup({
            id: "list",
            label: t("Keystrokes that can be used in a list"),
            keystrokes: [
                {
                    label: t("Increase list item indent"),
                    keystroke: "Tab"
                },
                {
                    label: t("Decrease list item indent"),
                    keystroke: "Shift+Tab"
                }
            ]
        });
    }
    /**
	* Convert `listItemId` attribute to `data-list-item-id` attribute on the view element in both downcast pipelines.
	*/ _setupListItemIdConversionStrategy() {
        this.registerDowncastStrategy({
            scope: "item",
            attributeName: "listItemId",
            setAttributeOnDowncast (writer, attributeValue, viewElement, options) {
                if (options && (options.skipListItemIds || options.isClipboardPipeline)) return;
                writer.setAttribute("data-list-item-id", attributeValue, viewElement);
            }
        });
    }
};
/**
* Post-fixer that reacts to changes on document and fixes incorrect model states (invalid `listItemId` and `listIndent` values).
*
* In the example below, there is a correct list structure.
* Then the middle element is removed so the list structure will become incorrect:
*
* ```xml
* <paragraph listType="bulleted" listItemId="a" listIndent=0>Item 1</paragraph>
* <paragraph listType="bulleted" listItemId="b" listIndent=1>Item 2</paragraph>   <--- this is removed.
* <paragraph listType="bulleted" listItemId="c" listIndent=2>Item 3</paragraph>
* ```
*
* The list structure after the middle element is removed:
*
* ```xml
* <paragraph listType="bulleted" listItemId="a" listIndent=0>Item 1</paragraph>
* <paragraph listType="bulleted" listItemId="c" listIndent=2>Item 3</paragraph>
* ```
*
* Should become:
*
* ```xml
* <paragraph listType="bulleted" listItemId="a" listIndent=0>Item 1</paragraph>
* <paragraph listType="bulleted" listItemId="c" listIndent=1>Item 3</paragraph>   <--- note that indent got post-fixed.
* ```
*
* @param model The data model.
* @param writer The writer to do changes with.
* @param attributeNames The list of all model list attributes (including registered strategies).
* @param ListEditing The document list editing plugin.
* @returns `true` if any change has been applied, `false` otherwise.
*/ function $ab0101fae4fd036b$var$modelChangePostFixer$1(model, writer, attributeNames, listEditing) {
    const changes = model.document.differ.getChanges();
    const visited = /* @__PURE__ */ new Set();
    const itemToListHead = /* @__PURE__ */ new Set();
    const multiBlock = listEditing.editor.config.get("list.multiBlock");
    let applied = false;
    for (const entry of changes){
        if (entry.type == "insert" && entry.name != "$text") {
            const item = entry.position.nodeAfter;
            if (!model.schema.checkAttribute(item, "listItemId")) {
                for (const attributeName of Array.from(item.getAttributeKeys()))if (attributeNames.includes(attributeName)) {
                    writer.removeAttribute(attributeName, item);
                    applied = true;
                }
            }
            $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position, itemToListHead, visited);
            if (!entry.attributes.has("listItemId")) $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position.getShiftedBy(entry.length), itemToListHead, visited);
            for (const { item: innerItem, previousPosition: previousPosition } of model.createRangeIn(item))if ($ab0101fae4fd036b$export$d0c47194f8840044(innerItem)) $ab0101fae4fd036b$export$dba9d9c15520cbdd(previousPosition, itemToListHead, visited);
        } else if (entry.type == "remove") $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.position, itemToListHead, visited);
        else if (entry.type == "attribute" && attributeNames.includes(entry.attributeKey)) {
            $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.range.start, itemToListHead, visited);
            if (entry.attributeNewValue === null) $ab0101fae4fd036b$export$dba9d9c15520cbdd(entry.range.start.getShiftedBy(1), itemToListHead, visited);
        }
        if (!multiBlock && entry.type == "attribute" && $ab0101fae4fd036b$var$LIST_BASE_ATTRIBUTES.includes(entry.attributeKey)) {
            const element = entry.range.start.nodeAfter;
            if (entry.attributeNewValue === null && element && element.is("element", "listItem")) {
                writer.rename(element, "paragraph");
                applied = true;
            } else if (entry.attributeOldValue === null && element && element.is("element") && element.name != "listItem") {
                writer.rename(element, "listItem");
                applied = true;
            }
        }
    }
    const seenIds = /* @__PURE__ */ new Set();
    for (const listHead of itemToListHead.values())applied = listEditing.fire("postFixer", {
        listNodes: new $ab0101fae4fd036b$export$75774bc5b259919e(listHead),
        listHead: listHead,
        writer: writer,
        seenIds: seenIds
    }) || applied;
    return applied;
}
/**
* A fixer for pasted content that includes list items.
*
* It fixes indentation of pasted list items so the pasted items match correctly to the context they are pasted into.
*
* Example:
*
* ```xml
* <paragraph listType="bulleted" listItemId="a" listIndent="0">A</paragraph>
* <paragraph listType="bulleted" listItemId="b" listIndent="1">B^</paragraph>
* // At ^ paste:  <paragraph listType="numbered" listItemId="x" listIndent="0">X</paragraph>
* //              <paragraph listType="numbered" listItemId="y" listIndent="1">Y</paragraph>
* <paragraph listType="bulleted" listItemId="c" listIndent="2">C</paragraph>
* ```
*
* Should become:
*
* ```xml
* <paragraph listType="bulleted" listItemId="a" listIndent="0">A</paragraph>
* <paragraph listType="bulleted" listItemId="b" listIndent="1">BX</paragraph>
* <paragraph listType="bulleted" listItemId="y" listIndent="2">Y/paragraph>
* <paragraph listType="bulleted" listItemId="c" listIndent="2">C</paragraph>
* ```
*/ function $ab0101fae4fd036b$var$createModelIndentPasteFixer(model) {
    return (evt, [content, selectable])=>{
        const items = (content.is("documentFragment") ? Array.from(content.getChildren()) : [
            content
        ]).filter((item)=>!model.schema.isInline(item));
        if (!items.length) return;
        const position = (selectable ? model.createSelection(selectable) : model.document.selection).getFirstPosition();
        let refItem;
        if ($ab0101fae4fd036b$export$d0c47194f8840044(position.parent)) refItem = position.parent;
        else if ($ab0101fae4fd036b$export$d0c47194f8840044(position.nodeBefore) && $ab0101fae4fd036b$export$d0c47194f8840044(position.nodeAfter)) refItem = position.nodeBefore;
        else return;
        model.change((writer)=>{
            const refType = refItem.getAttribute("listType");
            const refIndent = refItem.getAttribute("listIndent");
            const firstElementIndent = items[0].getAttribute("listIndent") || 0;
            const indentDiff = Math.max(refIndent - firstElementIndent, 0);
            for (const item of items){
                const isListItem = $ab0101fae4fd036b$export$d0c47194f8840044(item);
                if (refItem.is("element", "listItem") && item.is("element", "paragraph")) /**
				* When paragraphs or a plain text list is pasted into a simple list, convert
				* the `<paragraphs>' to `<listItem>' to avoid breaking the target list.
				*
				* See https://github.com/ckeditor/ckeditor5/issues/13826.
				*/ writer.rename(item, "listItem");
                writer.setAttributes({
                    listIndent: (isListItem ? item.getAttribute("listIndent") : 0) + indentDiff,
                    listItemId: isListItem ? item.getAttribute("listItemId") : $ab0101fae4fd036b$export$3f9105797bf11127.next(),
                    listType: refType
                }, item);
            }
        });
    };
}
/**
* Decides whether the merge should be accompanied by the model's `deleteContent()`, for instance, to get rid of the inline
* content in the selection or take advantage of the heuristics in `deleteContent()` that helps convert lists into paragraphs
* in certain cases.
*/ function $ab0101fae4fd036b$var$shouldMergeOnBlocksContentLevel(model, direction) {
    const selection = model.document.selection;
    if (!selection.isCollapsed) return !$ab0101fae4fd036b$export$a4dd452805552056(model);
    if (direction === "forward") return true;
    const positionParent = selection.getFirstPosition().parent;
    const previousSibling = positionParent.previousSibling;
    if (model.schema.isObject(previousSibling)) return false;
    if (previousSibling.isEmpty) return true;
    return $ab0101fae4fd036b$export$c9462903d4dfebea([
        positionParent,
        previousSibling
    ]);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Helper method for creating toolbar and menu buttons and linking them with an appropriate command.
*
* @internal
* @param editor The editor instance to which the UI component will be added.
* @param commandName The name of the command.
* @param label The button label.
* @param icon The source of the icon.
*/ function $ab0101fae4fd036b$export$351213da81ee126a(editor, commandName, label, icon) {
    editor.ui.componentFactory.add(commandName, ()=>{
        const buttonView = $ab0101fae4fd036b$var$_createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa), editor, commandName, label, icon);
        buttonView.set({
            tooltip: true,
            isToggleable: true
        });
        return buttonView;
    });
    editor.ui.componentFactory.add(`menuBar:${commandName}`, ()=>{
        const buttonView = $ab0101fae4fd036b$var$_createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53), editor, commandName, label, icon);
        buttonView.set({
            role: "menuitemcheckbox",
            isToggleable: true
        });
        return buttonView;
    });
}
/**
* Creates a button to use either in toolbar or in menu bar.
*/ function $ab0101fae4fd036b$var$_createButton(ButtonClass, editor, commandName, label, icon) {
    const command = editor.commands.get(commandName);
    const view = new ButtonClass(editor.locale);
    view.set({
        label: label,
        icon: icon
    });
    view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
    view.on("execute", ()=>{
        editor.execute(commandName);
        editor.editing.view.focus();
    });
    return view;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list/listui
*/ /**
* The list UI feature. It introduces the `'numberedList'` and `'bulletedList'` buttons that
* allow to convert paragraphs to and from list items and indent or outdent them.
*/ var $ab0101fae4fd036b$export$e3443e3fb7ec7350 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const t = this.editor.t;
        if (!this.editor.ui.componentFactory.has("numberedList")) $ab0101fae4fd036b$export$351213da81ee126a(this.editor, "numberedList", t("Numbered List"), (0, $e8dc502aba5ac3f5$export$8cf58c969bb2bf96));
        if (!this.editor.ui.componentFactory.has("bulletedList")) $ab0101fae4fd036b$export$351213da81ee126a(this.editor, "bulletedList", t("Bulleted List"), (0, $e8dc502aba5ac3f5$export$368e6033157c630e));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/list
*/ /**
* The list feature.
*
* This is a "glue" plugin that loads the {@link module:list/list/listediting~ListEditing  list
* editing feature} and {@link module:list/list/listui~ListUI list UI feature}.
*/ var $ab0101fae4fd036b$export$54c2e3dc7acea9f5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f,
            $ab0101fae4fd036b$export$e3443e3fb7ec7350
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "List";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/liststartcommand
*/ /**
* The list start index command. It changes the `listStart` attribute of the selected list items,
* letting the user to choose the starting point of an ordered list.
* It is used by the {@link module:list/listproperties~ListProperties list properties feature}.
*/ var $ab0101fae4fd036b$export$cbe8ed814912829f = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const value = this._getValue();
        this.value = value;
        this.isEnabled = value != null;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Execute options.
	* @param options.startIndex The list start index.
	*/ execute({ startIndex: startIndex = 1 } = {}) {
        const model = this.editor.model;
        const document1 = model.document;
        let blocks = Array.from(document1.selection.getSelectedBlocks()).filter((block)=>$ab0101fae4fd036b$export$d0c47194f8840044(block) && $ab0101fae4fd036b$export$a36753f029939118(block.getAttribute("listType")));
        blocks = $ab0101fae4fd036b$export$dc8c7f1b370743d6(blocks);
        model.change((writer)=>{
            for (const block of blocks)writer.setAttribute("listStart", startIndex >= 0 ? startIndex : 1, block);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const document1 = this.editor.model.document;
        const block = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(document1.selection.getSelectedBlocks());
        if (block && $ab0101fae4fd036b$export$d0c47194f8840044(block) && $ab0101fae4fd036b$export$a36753f029939118(block.getAttribute("listType"))) return block.getAttribute("listStart");
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/utils/style
*/ const $ab0101fae4fd036b$var$LIST_STYLE_TO_LIST_TYPE = {};
const $ab0101fae4fd036b$var$LIST_STYLE_TO_TYPE_ATTRIBUTE = {};
const $ab0101fae4fd036b$var$TYPE_ATTRIBUTE_TO_LIST_STYLE = {};
const $ab0101fae4fd036b$var$LIST_STYLE_TYPES = [
    {
        listStyle: "disc",
        typeAttribute: "disc",
        listType: "bulleted"
    },
    {
        listStyle: "circle",
        typeAttribute: "circle",
        listType: "bulleted"
    },
    {
        listStyle: "square",
        typeAttribute: "square",
        listType: "bulleted"
    },
    {
        listStyle: "decimal",
        typeAttribute: "1",
        listType: "numbered"
    },
    {
        listStyle: "decimal-leading-zero",
        typeAttribute: null,
        listType: "numbered"
    },
    {
        listStyle: "lower-roman",
        typeAttribute: "i",
        listType: "numbered"
    },
    {
        listStyle: "upper-roman",
        typeAttribute: "I",
        listType: "numbered"
    },
    {
        listStyle: "lower-alpha",
        typeAttribute: "a",
        listType: "numbered"
    },
    {
        listStyle: "upper-alpha",
        typeAttribute: "A",
        listType: "numbered"
    },
    {
        listStyle: "lower-latin",
        typeAttribute: "a",
        listType: "numbered"
    },
    {
        listStyle: "upper-latin",
        typeAttribute: "A",
        listType: "numbered"
    },
    {
        listStyle: "arabic-indic",
        typeAttribute: null,
        listType: "numbered"
    }
];
for (const { listStyle: listStyle, typeAttribute: typeAttribute, listType: listType } of $ab0101fae4fd036b$var$LIST_STYLE_TYPES){
    $ab0101fae4fd036b$var$LIST_STYLE_TO_LIST_TYPE[listStyle] = listType;
    $ab0101fae4fd036b$var$LIST_STYLE_TO_TYPE_ATTRIBUTE[listStyle] = typeAttribute;
    if (typeAttribute) $ab0101fae4fd036b$var$TYPE_ATTRIBUTE_TO_LIST_STYLE[typeAttribute] = listStyle;
}
/**
* Gets all the style types supported by given list type.
*
* @internal
*/ function $ab0101fae4fd036b$export$6e4ac01a18f66b64() {
    return $ab0101fae4fd036b$var$LIST_STYLE_TYPES.map((x)=>x.listStyle);
}
/**
* Checks whether the given list-style-type is supported by numbered or bulleted list.
*
* @internal
*/ function $ab0101fae4fd036b$export$450b5cebcf5f5a66(listStyleType) {
    return $ab0101fae4fd036b$var$LIST_STYLE_TO_LIST_TYPE[listStyleType] || null;
}
/**
* Converts `type` attribute of `<ul>` or `<ol>` elements to `list-style-type` equivalent.
*
* @internal
*/ function $ab0101fae4fd036b$export$6c45b09970a1db9d(value) {
    return $ab0101fae4fd036b$var$TYPE_ATTRIBUTE_TO_LIST_STYLE[value] || null;
}
/**
* Converts `list-style-type` style to `type` attribute of `<ul>` or `<ol>` elements.
*
* @internal
*/ function $ab0101fae4fd036b$export$f5b598c2e1915236(value) {
    return $ab0101fae4fd036b$var$LIST_STYLE_TO_TYPE_ATTRIBUTE[value] || null;
}
/**
* Normalizes list style by converting aliases to their canonical form.
*
* @internal
* @param listStyle The list style value to normalize.
* @returns The canonical form of the list style.
*
* @example
* normalizeListStyle( 'lower-alpha' ); // Returns 'lower-latin'
* normalizeListStyle( 'upper-alpha' ); // Returns 'upper-latin'
* normalizeListStyle( 'disc' ); // Returns 'disc'
*/ function $ab0101fae4fd036b$export$3cff595a549af8ba(listStyle) {
    switch(listStyle){
        case "lower-alpha":
            return "lower-latin";
        case "upper-alpha":
            return "upper-latin";
        default:
            return listStyle;
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/liststylecommand
*/ /**
* The list style command. It changes `listStyle` attribute of the selected list items,
* letting the user choose styles for the list item markers.
* It is used by the {@link module:list/listproperties~ListProperties list properties feature}.
*/ var $ab0101fae4fd036b$export$cb41ff31dada418e = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The default type of the list style.
	*/ defaultType;
    /**
	* The list of supported style types by this command.
	*/ _supportedTypes;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param defaultType The list type that will be used by default if the value was not specified during
	* the command execution.
	* @param supportedTypes The list of supported style types by this command.
	*/ constructor(editor, defaultType, supportedTypes){
        super(editor);
        this.defaultType = defaultType;
        this._supportedTypes = supportedTypes;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.type The type of the list style, e.g. `'disc'` or `'square'`. If `null` is specified, the default
	* style will be applied.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const document1 = model.document;
        model.change((writer)=>{
            this._tryToConvertItemsToList(options);
            let blocks = Array.from(document1.selection.getSelectedBlocks()).filter((block)=>block.hasAttribute("listType"));
            if (!blocks.length) return;
            blocks = $ab0101fae4fd036b$export$dc8c7f1b370743d6(blocks);
            for (const block of blocks)writer.setAttribute("listStyle", options.type || this.defaultType, block);
        });
    }
    /**
	* Checks if the given style type is supported by this plugin.
	*/ isStyleTypeSupported(value) {
        if (!this._supportedTypes) return true;
        return this._supportedTypes.includes(value);
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const listItem = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this.editor.model.document.selection.getSelectedBlocks());
        if ($ab0101fae4fd036b$export$d0c47194f8840044(listItem)) return listItem.getAttribute("listStyle");
        return null;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const editor = this.editor;
        const numberedList = editor.commands.get("numberedList");
        const bulletedList = editor.commands.get("bulletedList");
        return numberedList.isEnabled || bulletedList.isEnabled;
    }
    /**
	* Check if the provided list style is valid. Also change the selection to a list if it's not set yet.
	*
	* @param options.type The type of the list style. If `null` is specified, the function does nothing.
	*/ _tryToConvertItemsToList(options) {
        if (!options.type) return;
        const listType = $ab0101fae4fd036b$export$450b5cebcf5f5a66(options.type);
        if (!listType) return;
        const editor = this.editor;
        const commandName = `${listType}List`;
        if (!editor.commands.get(commandName).value) editor.execute(commandName);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/listreversedcommand
*/ /**
* The list reversed command. It changes the `listReversed` attribute of the selected list items,
* letting the user to choose the order of an ordered list.
* It is used by the {@link module:list/listproperties~ListProperties list properties feature}.
*/ var $ab0101fae4fd036b$export$d5c5730329c8797c = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const value = this._getValue();
        this.value = value;
        this.isEnabled = value != null;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.reversed Whether the list should be reversed.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const document1 = model.document;
        let blocks = Array.from(document1.selection.getSelectedBlocks()).filter((block)=>$ab0101fae4fd036b$export$d0c47194f8840044(block) && block.getAttribute("listType") == "numbered");
        blocks = $ab0101fae4fd036b$export$dc8c7f1b370743d6(blocks);
        model.change((writer)=>{
            for (const block of blocks)writer.setAttribute("listReversed", !!options.reversed, block);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*/ _getValue() {
        const document1 = this.editor.model.document;
        const block = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(document1.selection.getSelectedBlocks());
        if ($ab0101fae4fd036b$export$d0c47194f8840044(block) && block.getAttribute("listType") == "numbered") return block.getAttribute("listReversed");
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a converter that consumes the `style`, `reversed`, and `start` attributes.
* In `style`, it searches for the `list-style-type` definition.
* If not found, the `"default"` value will be used.
*
* @internal
* @param strategy
*/ function $ab0101fae4fd036b$export$29cbbf2065576dd3(strategy) {
    return (evt, data, conversionApi)=>{
        const { writer: writer, schema: schema, consumable: consumable } = conversionApi;
        if (consumable.test(data.viewItem, strategy.viewConsumables) === false) return;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        let applied = false;
        for (const item of data.modelRange.getItems({
            shallow: true
        })){
            if (!schema.checkAttribute(item, strategy.attributeName)) continue;
            if (!strategy.appliesToListItem(item)) continue;
            if (item.hasAttribute(strategy.attributeName)) continue;
            writer.setAttribute(strategy.attributeName, strategy.getAttributeOnUpcast(data.viewItem), item);
            applied = true;
        }
        if (applied) consumable.consume(data.viewItem, strategy.viewConsumables);
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/listpropertiesutils
*/ /**
* A set of helpers related to document lists.
*/ var $ab0101fae4fd036b$export$9b35279589653d4b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListPropertiesUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Gets all the style types supported by given list type.
	*/ getAllSupportedStyleTypes() {
        return $ab0101fae4fd036b$export$6e4ac01a18f66b64();
    }
    /**
	* Checks whether the given list-style-type is supported by numbered or bulleted list.
	*/ getListTypeFromListStyleType(listStyleType) {
        return $ab0101fae4fd036b$export$450b5cebcf5f5a66(listStyleType);
    }
    /**
	* Converts `type` attribute of `<ul>` or `<ol>` elements to `list-style-type` equivalent.
	*/ getListStyleTypeFromTypeAttribute(value) {
        return $ab0101fae4fd036b$export$6c45b09970a1db9d(value);
    }
    /**
	* Converts `list-style-type` style to `type` attribute of `<ul>` or `<ol>` elements.
	*/ getTypeAttributeFromListStyleType(value) {
        return $ab0101fae4fd036b$export$f5b598c2e1915236(value);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/utils/config
*/ /**
* Normalizes {@link module:list/listconfig~ListPropertiesConfig} in the configuration of the list properties feature.
* The structure of normalized list properties options looks as follows:
*
* ```ts
* {
* 	styles: {
* 		listTypes: [ 'bulleted', 'numbered' ],
* 		useAttribute: false
* 	},
* 	startIndex: true,
* 	reversed: true
* }
* ```
*
* @internal
* @param config The list properties {@link module:list/listconfig~ListPropertiesConfig config}.
* @returns An object with normalized list properties options.
*/ function $ab0101fae4fd036b$export$9add8b1ec04ab807(config) {
    const { startIndex: startIndex, reversed: reversed, styles: styles } = config;
    return {
        styles: $ab0101fae4fd036b$var$getNormalizedStylesConfig(styles),
        startIndex: startIndex || false,
        reversed: reversed || false
    };
}
/**
* Normalizes styles in the configuration of the list properties feature.
* The structure of normalized list properties options looks as follows:
*
* ```ts
* {
* 	listTypes: [ 'bulleted', 'numbered' ],
* 	useAttribute: false
* }
* ```
*
* @param styles The list properties styles.
* @returns An object with normalized list properties styles.
*/ function $ab0101fae4fd036b$var$getNormalizedStylesConfig(styles) {
    const normalizedConfig = {
        listTypes: [
            "bulleted",
            "numbered"
        ],
        useAttribute: false,
        listStyleTypes: {
            numbered: [
                "decimal",
                "decimal-leading-zero",
                "lower-roman",
                "upper-roman",
                "lower-latin",
                "upper-latin"
            ],
            bulleted: [
                "disc",
                "circle",
                "square"
            ]
        }
    };
    if (styles === true) return normalizedConfig;
    if (!styles) {
        normalizedConfig.listTypes = [];
        normalizedConfig.listStyleTypes = {};
    } else if (Array.isArray(styles) || typeof styles == "string") {
        normalizedConfig.listTypes = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(styles);
        normalizedConfig.listStyleTypes = (0, $5c99339e8ae3aa36$export$357523c63a2253b9)(normalizedConfig.listStyleTypes, normalizedConfig.listTypes);
    } else {
        normalizedConfig.listTypes = styles.listTypes ? (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(styles.listTypes) : normalizedConfig.listTypes;
        normalizedConfig.useAttribute = !!styles.useAttribute;
        if (styles.listStyleTypes) normalizedConfig.listStyleTypes = styles.listStyleTypes;
        else normalizedConfig.listStyleTypes = (0, $5c99339e8ae3aa36$export$357523c63a2253b9)(normalizedConfig.listStyleTypes, normalizedConfig.listTypes);
    }
    return normalizedConfig;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/listpropertiesediting
*/ const $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1 = "default";
/**
* The document list properties engine feature.
*
* It registers the `'listStyle'`, `'listReversed'` and `'listStart'` commands if they are enabled in the configuration.
* Read more in {@link module:list/listconfig~ListPropertiesConfig}.
*/ var $ab0101fae4fd036b$export$9c8ffd43470a1979 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f,
            $ab0101fae4fd036b$export$9b35279589653d4b
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListPropertiesEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "LP";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("list.properties", {
            styles: true,
            startIndex: false,
            reversed: false
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        const strategies = $ab0101fae4fd036b$var$createAttributeStrategies$1(editor.config.get("list.properties"));
        for (const strategy of strategies){
            strategy.addCommand(editor);
            model.schema.extend("$listItem", {
                allowAttributes: strategy.attributeName
            });
            listEditing.registerDowncastStrategy({
                scope: "list",
                attributeName: strategy.attributeName,
                setAttributeOnDowncast (writer, attributeValue, viewElement) {
                    strategy.setAttributeOnDowncast(writer, attributeValue, viewElement);
                }
            });
        }
        editor.conversion.for("upcast").add((dispatcher)=>{
            for (const strategy of strategies){
                dispatcher.on("element:ol", $ab0101fae4fd036b$export$29cbbf2065576dd3(strategy));
                dispatcher.on("element:ul", $ab0101fae4fd036b$export$29cbbf2065576dd3(strategy));
            }
        });
        listEditing.on("checkAttributes:list", (evt, { viewElement: viewElement, modelAttributes: modelAttributes, modelReferenceElement: modelReferenceElement })=>{
            for (const strategy of strategies){
                if (!strategy.appliesToListItem(modelReferenceElement)) continue;
                if (strategy.getAttributeOnUpcast(viewElement) != modelAttributes[strategy.attributeName]) {
                    evt.return = true;
                    evt.stop();
                }
            }
        });
        this.listenTo(editor.commands.get("indentList"), "afterExecute", (evt, changedBlocks)=>{
            model.change((writer)=>{
                for (const node of changedBlocks)for (const strategy of strategies)if (strategy.appliesToListItem(node)) writer.setAttribute(strategy.attributeName, strategy.defaultValue, node);
            });
        });
        listEditing.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node } of listNodes)for (const strategy of strategies){
                if (strategy.hasValidAttribute(node)) continue;
                if (strategy.appliesToListItem(node)) writer.setAttribute(strategy.attributeName, strategy.defaultValue, node);
                else writer.removeAttribute(strategy.attributeName, node);
                evt.return = true;
            }
        });
        listEditing.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node, previousNodeInList: previousNodeInList } of listNodes){
                if (!previousNodeInList) continue;
                if (previousNodeInList.getAttribute("listType") != node.getAttribute("listType")) continue;
                for (const strategy of strategies){
                    const { attributeName: attributeName } = strategy;
                    if (!strategy.appliesToListItem(node)) continue;
                    const value = previousNodeInList.getAttribute(attributeName);
                    if (node.getAttribute(attributeName) != value) {
                        writer.setAttribute(attributeName, value, node);
                        evt.return = true;
                    }
                }
            }
        });
    }
};
/**
* Creates an array of strategies for dealing with enabled listItem attributes.
*/ function $ab0101fae4fd036b$var$createAttributeStrategies$1(enabledProperties) {
    const strategies = [];
    const normalizedConfig = $ab0101fae4fd036b$export$9add8b1ec04ab807(enabledProperties);
    if (enabledProperties.styles) {
        const useAttribute = normalizedConfig.styles.useAttribute;
        strategies.push({
            attributeName: "listStyle",
            defaultValue: $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1,
            viewConsumables: {
                styles: "list-style-type"
            },
            addCommand (editor) {
                let supportedTypes = $ab0101fae4fd036b$export$6e4ac01a18f66b64();
                if (useAttribute) supportedTypes = supportedTypes.filter((styleType)=>!!$ab0101fae4fd036b$export$f5b598c2e1915236(styleType));
                editor.commands.add("listStyle", new $ab0101fae4fd036b$export$cb41ff31dada418e(editor, $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1, supportedTypes));
            },
            appliesToListItem (item) {
                return item.getAttribute("listType") == "numbered" || item.getAttribute("listType") == "bulleted";
            },
            hasValidAttribute (item) {
                if (!this.appliesToListItem(item)) return !item.hasAttribute("listStyle");
                if (!item.hasAttribute("listStyle")) return false;
                const value = item.getAttribute("listStyle");
                if (value == $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1) return true;
                return $ab0101fae4fd036b$export$450b5cebcf5f5a66(value) == item.getAttribute("listType");
            },
            setAttributeOnDowncast (writer, listStyle, element) {
                if (listStyle && listStyle !== $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1) {
                    if (useAttribute) {
                        const value = $ab0101fae4fd036b$export$f5b598c2e1915236(listStyle);
                        if (value) {
                            writer.setAttribute("type", value, element);
                            return;
                        }
                    } else {
                        writer.setStyle("list-style-type", listStyle, element);
                        return;
                    }
                }
                writer.removeStyle("list-style-type", element);
                writer.removeAttribute("type", element);
            },
            getAttributeOnUpcast (listParent) {
                const style = listParent.getStyle("list-style-type");
                if (style) return $ab0101fae4fd036b$export$3cff595a549af8ba(style);
                const attribute = listParent.getAttribute("type");
                if (attribute) return $ab0101fae4fd036b$export$6c45b09970a1db9d(attribute);
                return $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE$1;
            }
        });
    }
    if (enabledProperties.reversed) strategies.push({
        attributeName: "listReversed",
        defaultValue: false,
        viewConsumables: {
            attributes: "reversed"
        },
        addCommand (editor) {
            editor.commands.add("listReversed", new $ab0101fae4fd036b$export$d5c5730329c8797c(editor));
        },
        appliesToListItem (item) {
            return item.getAttribute("listType") == "numbered";
        },
        hasValidAttribute (item) {
            return this.appliesToListItem(item) == item.hasAttribute("listReversed");
        },
        setAttributeOnDowncast (writer, listReversed, element) {
            if (listReversed) writer.setAttribute("reversed", "reversed", element);
            else writer.removeAttribute("reversed", element);
        },
        getAttributeOnUpcast (listParent) {
            return listParent.hasAttribute("reversed");
        }
    });
    if (enabledProperties.startIndex) strategies.push({
        attributeName: "listStart",
        defaultValue: 1,
        viewConsumables: {
            attributes: "start"
        },
        addCommand (editor) {
            editor.commands.add("listStart", new $ab0101fae4fd036b$export$cbe8ed814912829f(editor));
        },
        appliesToListItem (item) {
            return $ab0101fae4fd036b$export$a36753f029939118(item.getAttribute("listType"));
        },
        hasValidAttribute (item) {
            return this.appliesToListItem(item) == item.hasAttribute("listStart");
        },
        setAttributeOnDowncast (writer, listStart, element) {
            if (listStart == 0 || listStart > 1) writer.setAttribute("start", listStart, element);
            else writer.removeAttribute("start", element);
        },
        getAttributeOnUpcast (listParent) {
            const startAttributeValue = listParent.getAttribute("start");
            return startAttributeValue >= 0 ? startAttributeValue : 1;
        }
    });
    return strategies;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/ui/listpropertiesview
*/ /**
* The list properties view to be displayed in the list dropdown.
*
* Contains a grid of available list styles and, for numbered list, also the list start index and reversed fields.
*
* @internal
*/ var $ab0101fae4fd036b$export$bdb651a4f6a3114d = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A collection of the child views.
	*/ children;
    /**
	* A view that renders the grid of list styles.
	*/ stylesView = null;
    /**
	* A collapsible view that hosts additional list property fields ({@link #startIndexFieldView} and
	* {@link #reversedSwitchButtonView}) to visually separate them from the {@link #stylesView grid of styles}.
	*
	* **Note**: Only present when:
	* * the view represents **numbered** list properties,
	* * and the {@link #stylesView} is rendered,
	* * and either {@link #startIndexFieldView} or {@link #reversedSwitchButtonView} is rendered.
	*
	* @readonly
	*/ additionalPropertiesCollapsibleView = null;
    /**
	* A labeled number field allowing the user to set the start index of the list.
	*
	* **Note**: Only present when the view represents **numbered** list properties.
	*
	* @readonly
	*/ startIndexFieldView = null;
    /**
	* A switch button allowing the user to make the edited list reversed.
	*
	* **Note**: Only present when the view represents **numbered** list properties.
	*
	* @readonly
	*/ reversedSwitchButtonView = null;
    /**
	* Tracks information about the DOM focus in the view.
	*/ focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
    /**
	* A collection of views that can be focused in the properties view.
	*/ focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
    /**
	* Helps cycling over {@link #focusables} in the view.
	*/ focusCycler;
    /**
	* Creates an instance of the list properties view.
	*
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param options Options of the view.
	* @param options.enabledProperties An object containing the configuration of enabled list property names.
	* Allows conditional rendering the sub-components of the properties view.
	* @param options.styleButtonViews A list of style buttons to be rendered
	* inside the styles grid. The grid will not be rendered when `enabledProperties` does not include the `'styles'` key.
	* @param options.styleGridAriaLabel An assistive technologies label set on the grid of styles (if the grid is rendered).
	*/ constructor(locale, { enabledProperties: enabledProperties, styleButtonViews: styleButtonViews, styleGridAriaLabel: styleGridAriaLabel }){
        super(locale);
        const elementCssClasses = [
            "ck",
            "ck-list-properties"
        ];
        this.children = this.createCollection();
        this.focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        if (styleButtonViews && styleButtonViews.length) {
            this.stylesView = this._createStylesView(styleButtonViews, styleGridAriaLabel);
            this.children.add(this.stylesView);
        } else elementCssClasses.push("ck-list-properties_without-styles");
        if (enabledProperties.startIndex || enabledProperties.reversed) {
            this._addNumberedListPropertyViews(enabledProperties);
            elementCssClasses.push("ck-list-properties_with-numbered-properties");
        }
        this.setTemplate({
            tag: "div",
            attributes: {
                class: elementCssClasses
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        if (this.stylesView) {
            this.focusables.add(this.stylesView);
            this.focusTracker.add(this.stylesView.element);
            if (this.startIndexFieldView || this.reversedSwitchButtonView) {
                this.focusables.add(this.children.last.buttonView);
                this.focusTracker.add(this.children.last.buttonView.element);
            }
            for (const item of this.stylesView.children)this.stylesView.focusTracker.add(item.element);
            (0, $29fd27cb9bdab9d2$export$4c1942d3074fe5f4)({
                keystrokeHandler: this.stylesView.keystrokes,
                focusTracker: this.stylesView.focusTracker,
                gridItems: this.stylesView.children,
                numberOfColumns: ()=>(0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(this.stylesView.element).getPropertyValue("grid-template-columns").split(" ").length,
                uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
            });
        }
        if (this.startIndexFieldView) {
            this.focusables.add(this.startIndexFieldView);
            this.focusTracker.add(this.startIndexFieldView.element);
            const stopPropagation = (data)=>data.stopPropagation();
            this.keystrokes.set("arrowright", stopPropagation);
            this.keystrokes.set("arrowleft", stopPropagation);
            this.keystrokes.set("arrowup", stopPropagation);
            this.keystrokes.set("arrowdown", stopPropagation);
        }
        if (this.reversedSwitchButtonView) {
            this.focusables.add(this.reversedSwitchButtonView);
            this.focusTracker.add(this.reversedSwitchButtonView.element);
        }
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ focus() {
        this.focusCycler.focusFirst();
    }
    /**
	* @inheritDoc
	*/ focusLast() {
        this.focusCycler.focusLast();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Creates the list styles grid.
	*
	* @param styleButtons Buttons to be placed in the grid.
	* @param styleGridAriaLabel The assistive technology label of the grid.
	*/ _createStylesView(styleButtons, styleGridAriaLabel) {
        const stylesView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(this.locale);
        stylesView.children = stylesView.createCollection();
        stylesView.children.addMany(styleButtons);
        stylesView.setTemplate({
            tag: "div",
            attributes: {
                "aria-label": styleGridAriaLabel,
                class: [
                    "ck",
                    "ck-list-styles-list"
                ]
            },
            children: stylesView.children
        });
        stylesView.children.delegate("execute").to(this);
        stylesView.focus = function() {
            for (const child of this.children)if (child instanceof (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa) && child.isOn) {
                child.focus();
                return;
            }
            this.children.first.focus();
        };
        stylesView.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        stylesView.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        stylesView.render();
        stylesView.keystrokes.listenTo(stylesView.element);
        return stylesView;
    }
    /**
	* Renders {@link #startIndexFieldView} and/or {@link #reversedSwitchButtonView} depending on the configuration of the properties view.
	*
	* @param enabledProperties An object containing the configuration of enabled list property names
	* (see {@link #constructor}).
	*/ _addNumberedListPropertyViews(enabledProperties) {
        const t = this.locale.t;
        const numberedPropertyViews = [];
        if (enabledProperties.startIndex) {
            this.startIndexFieldView = this._createStartIndexField();
            numberedPropertyViews.push(this.startIndexFieldView);
        }
        if (enabledProperties.reversed) {
            this.reversedSwitchButtonView = this._createReversedSwitchButton();
            numberedPropertyViews.push(this.reversedSwitchButtonView);
        }
        if (this.stylesView) {
            this.additionalPropertiesCollapsibleView = new (0, $29fd27cb9bdab9d2$export$8a82f5df0c7d8945)(this.locale, numberedPropertyViews);
            this.additionalPropertiesCollapsibleView.set({
                label: t("List properties"),
                isCollapsed: true
            });
            this.additionalPropertiesCollapsibleView.buttonView.bind("isEnabled").toMany(numberedPropertyViews, "isEnabled", (...areEnabled)=>areEnabled.some((isEnabled)=>isEnabled));
            this.additionalPropertiesCollapsibleView.buttonView.on("change:isEnabled", (evt, data, isEnabled)=>{
                if (!isEnabled) this.additionalPropertiesCollapsibleView.isCollapsed = true;
            });
            this.children.add(this.additionalPropertiesCollapsibleView);
        } else this.children.addMany(numberedPropertyViews);
    }
    /**
	* Creates the list start index labeled field.
	*/ _createStartIndexField() {
        const t = this.locale.t;
        const startIndexFieldView = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$616b4440975f3e79));
        startIndexFieldView.set({
            label: t("Start at"),
            class: "ck-numbered-list-properties__start-index"
        });
        startIndexFieldView.fieldView.set({
            min: 0,
            step: 1,
            value: 1,
            inputMode: "numeric"
        });
        startIndexFieldView.fieldView.on("input", ()=>{
            const inputElement = startIndexFieldView.fieldView.element;
            const startIndex = inputElement.valueAsNumber;
            if (Number.isNaN(startIndex)) {
                startIndexFieldView.errorText = t("Invalid start index value.");
                return;
            }
            if (!inputElement.checkValidity()) startIndexFieldView.errorText = t("Start index must be greater than 0.");
            else this.fire("listStart", {
                startIndex: startIndex
            });
        });
        return startIndexFieldView;
    }
    /**
	* Creates the reversed list switch button.
	*/ _createReversedSwitchButton() {
        const t = this.locale.t;
        const reversedButtonView = new (0, $29fd27cb9bdab9d2$export$bb3c559d00882ebd)(this.locale);
        reversedButtonView.set({
            withText: true,
            label: t("Reversed order"),
            class: "ck-numbered-list-properties__reversed-order"
        });
        reversedButtonView.delegate("execute").to(this, "listReversed");
        return reversedButtonView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties/listpropertiesui
*/ /**
* The list properties UI plugin. It introduces the extended `'bulletedList'` and `'numberedList'` toolbar
* buttons that allow users to control such aspects of list as the marker, start index or order.
*
* **Note**: Buttons introduced by this plugin override implementations from the {@link module:list/list/listui~ListUI}
* (because they share the same names).
*/ var $ab0101fae4fd036b$export$ad7529ae09e99074 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListPropertiesUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    init() {
        const editor = this.editor;
        const t = editor.locale.t;
        const propertiesConfig = editor.config.get("list.properties");
        const normalizedConfig = $ab0101fae4fd036b$export$9add8b1ec04ab807(propertiesConfig);
        const stylesListTypes = normalizedConfig.styles.listTypes;
        if (stylesListTypes.includes("bulleted")) {
            const styleDefinitions = [
                {
                    label: t("Toggle the disc list style"),
                    tooltip: t("Disc"),
                    type: "disc",
                    icon: (0, $e8dc502aba5ac3f5$export$fc09f3e2a4c01af2)
                },
                {
                    label: t("Toggle the circle list style"),
                    tooltip: t("Circle"),
                    type: "circle",
                    icon: (0, $e8dc502aba5ac3f5$export$20b3a853460b572d)
                },
                {
                    label: t("Toggle the square list style"),
                    tooltip: t("Square"),
                    type: "square",
                    icon: (0, $e8dc502aba5ac3f5$export$e0694167faa6e519)
                }
            ];
            const buttonLabel = t("Bulleted List");
            const styleGridAriaLabel = t("Bulleted list styles toolbar");
            const commandName = "bulletedList";
            editor.ui.componentFactory.add(commandName, $ab0101fae4fd036b$var$getDropdownViewCreator({
                editor: editor,
                normalizedConfig: normalizedConfig,
                parentCommandName: commandName,
                buttonLabel: buttonLabel,
                buttonIcon: (0, $e8dc502aba5ac3f5$export$368e6033157c630e),
                styleGridAriaLabel: styleGridAriaLabel,
                styleDefinitions: styleDefinitions
            }));
            editor.ui.componentFactory.add(`menuBar:${commandName}`, $ab0101fae4fd036b$var$getMenuBarStylesMenuCreator({
                editor: editor,
                normalizedConfig: normalizedConfig,
                parentCommandName: commandName,
                buttonLabel: buttonLabel,
                styleGridAriaLabel: styleGridAriaLabel,
                styleDefinitions: styleDefinitions
            }));
        }
        if (stylesListTypes.includes("numbered") || propertiesConfig.startIndex || propertiesConfig.reversed) {
            const styleDefinitions = [
                {
                    label: t("Toggle the decimal list style"),
                    tooltip: t("Decimal"),
                    type: "decimal",
                    icon: (0, $e8dc502aba5ac3f5$export$74e351a6539a1711)
                },
                {
                    label: t("Toggle the decimal with leading zero list style"),
                    tooltip: t("Decimal with leading zero"),
                    type: "decimal-leading-zero",
                    icon: (0, $e8dc502aba5ac3f5$export$c720d164e64a9c5d)
                },
                {
                    label: t("Toggle the lower\u2013roman list style"),
                    tooltip: t("Lower\u2013roman"),
                    type: "lower-roman",
                    icon: (0, $e8dc502aba5ac3f5$export$7b30e2981f4a59e2)
                },
                {
                    label: t("Toggle the upper\u2013roman list style"),
                    tooltip: t("Upper-roman"),
                    type: "upper-roman",
                    icon: (0, $e8dc502aba5ac3f5$export$66cbb0c8ed453255)
                },
                {
                    label: t("Toggle the lower\u2013latin list style"),
                    tooltip: t("Lower-latin"),
                    type: "lower-latin",
                    icon: (0, $e8dc502aba5ac3f5$export$c3c2f8ecd2b13747)
                },
                {
                    label: t("Toggle the upper\u2013latin list style"),
                    tooltip: t("Upper-latin"),
                    type: "upper-latin",
                    icon: (0, $e8dc502aba5ac3f5$export$6d77053cfbac4c75)
                },
                {
                    label: t("Toggle the arabic-indic list style"),
                    tooltip: t("Arabic-indic"),
                    type: "arabic-indic",
                    icon: (0, $e8dc502aba5ac3f5$export$def316efafc017e5)
                }
            ];
            const buttonLabel = t("Numbered List");
            const styleGridAriaLabel = t("Numbered list styles toolbar");
            const commandName = "numberedList";
            editor.ui.componentFactory.add(commandName, $ab0101fae4fd036b$var$getDropdownViewCreator({
                editor: editor,
                normalizedConfig: normalizedConfig,
                parentCommandName: commandName,
                buttonLabel: buttonLabel,
                buttonIcon: (0, $e8dc502aba5ac3f5$export$8cf58c969bb2bf96),
                styleGridAriaLabel: styleGridAriaLabel,
                styleDefinitions: styleDefinitions
            }));
            if (stylesListTypes.includes("numbered")) editor.ui.componentFactory.add(`menuBar:${commandName}`, $ab0101fae4fd036b$var$getMenuBarStylesMenuCreator({
                editor: editor,
                normalizedConfig: normalizedConfig,
                parentCommandName: commandName,
                buttonLabel: buttonLabel,
                styleGridAriaLabel: styleGridAriaLabel,
                styleDefinitions: styleDefinitions
            }));
        }
    }
};
/**
* A helper that returns a function that creates a split button with a toolbar in the dropdown,
* which in turn contains buttons allowing users to change list styles in the context of the current selection.
*
* @param options.editor
* @param options.normalizedConfig List properties configuration.
* @param options.parentCommandName The name of the higher-order editor command associated with
* the set of particular list styles (e.g. "bulletedList" for "disc", "circle", and "square" styles).
* @param options.buttonLabel Label of the main part of the split button.
* @param options.buttonIcon The SVG string of an icon for the main part of the split button.
* @param options.styleGridAriaLabel The ARIA label for the styles grid in the split button dropdown.
* @param options.styleDefinitions Definitions of the style buttons.
* @returns A function that can be passed straight into {@link module:ui/componentfactory~ComponentFactory#add}.
*/ function $ab0101fae4fd036b$var$getDropdownViewCreator({ editor: editor, normalizedConfig: normalizedConfig, parentCommandName: parentCommandName, buttonLabel: buttonLabel, buttonIcon: buttonIcon, styleGridAriaLabel: styleGridAriaLabel, styleDefinitions: styleDefinitions }) {
    const parentCommand = editor.commands.get(parentCommandName);
    return (locale)=>{
        const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
        const mainButtonView = dropdownView.buttonView;
        dropdownView.bind("isEnabled").to(parentCommand);
        dropdownView.class = "ck-list-styles-dropdown";
        mainButtonView.on("execute", ()=>{
            editor.execute(parentCommandName);
            editor.editing.view.focus();
        });
        mainButtonView.set({
            label: buttonLabel,
            icon: buttonIcon,
            tooltip: true,
            isToggleable: true
        });
        mainButtonView.bind("isOn").to(parentCommand, "value", (value)=>!!value);
        dropdownView.once("change:isOpen", ()=>{
            const listPropertiesView = $ab0101fae4fd036b$var$createListPropertiesView({
                editor: editor,
                normalizedConfig: normalizedConfig,
                dropdownView: dropdownView,
                parentCommandName: parentCommandName,
                styleGridAriaLabel: styleGridAriaLabel,
                styleDefinitions: styleDefinitions
            });
            dropdownView.panelView.children.add(listPropertiesView);
        });
        dropdownView.on("execute", ()=>{
            editor.editing.view.focus();
        });
        return dropdownView;
    };
}
/**
* A helper that returns a function (factory) that creates individual buttons used by users to change styles
* of lists.
*
* @param options.editor
* @param options.listStyleCommand The instance of the `ListStylesCommand` class.
* @param options.parentCommandName The name of the higher-order command associated with a
* particular list style (e.g. "bulletedList" is associated with "square" and "numberedList" is associated with "roman").
* @returns A function that can be passed straight into {@link module:ui/componentfactory~ComponentFactory#add}.
*/ function $ab0101fae4fd036b$var$getStyleButtonCreator({ editor: editor, listStyleCommand: listStyleCommand, parentCommandName: parentCommandName }) {
    const locale = editor.locale;
    const parentCommand = editor.commands.get(parentCommandName);
    return ({ label: label, type: type, icon: icon, tooltip: tooltip })=>{
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        button.set({
            label: label,
            icon: icon,
            tooltip: tooltip
        });
        button.bind("isOn").to(listStyleCommand, "value", (value)=>value === type);
        button.on("execute", ()=>{
            if (parentCommand.value) {
                if (listStyleCommand.value === type) editor.execute(parentCommandName);
                else if (listStyleCommand.value !== type) editor.execute("listStyle", {
                    type: type
                });
            } else editor.model.change(()=>{
                editor.execute("listStyle", {
                    type: type
                });
            });
        });
        return button;
    };
}
/**
* A helper that creates the properties view for the individual style dropdown.
*
* @param options.editor Editor instance.
* @param options.normalizedConfig List properties configuration.
* @param options.dropdownView Styles dropdown view that hosts the properties view.
* @param options.parentCommandName The name of the higher-order editor command associated with
* the set of particular list styles (e.g. "bulletedList" for "disc", "circle", and "square" styles).
* @param options.styleDefinitions Definitions of the style buttons.
* @param options.styleGridAriaLabel An assistive technologies label set on the grid of styles (if the grid is rendered).
*/ function $ab0101fae4fd036b$var$createListPropertiesView({ editor: editor, normalizedConfig: normalizedConfig, dropdownView: dropdownView, parentCommandName: parentCommandName, styleDefinitions: styleDefinitions, styleGridAriaLabel: styleGridAriaLabel }) {
    const locale = editor.locale;
    const enabledProperties = {
        ...normalizedConfig,
        ...parentCommandName != "numberedList" ? {
            startIndex: false,
            reversed: false
        } : null
    };
    const listType = parentCommandName.replace("List", "");
    let styleButtonViews = null;
    if (normalizedConfig.styles.listTypes.includes(listType)) {
        const listStyleCommand = editor.commands.get("listStyle");
        const styleButtonCreator = $ab0101fae4fd036b$var$getStyleButtonCreator({
            editor: editor,
            parentCommandName: parentCommandName,
            listStyleCommand: listStyleCommand
        });
        const configuredListStylesTypes = normalizedConfig.styles.listStyleTypes;
        let filteredDefinitions = styleDefinitions;
        /* v8 ignore next -- Normalized config always provides listStyleTypes for enabled styles. */ if (configuredListStylesTypes) {
            const allowedTypes = configuredListStylesTypes[listType];
            if (allowedTypes) filteredDefinitions = styleDefinitions.filter((def)=>allowedTypes.includes(def.type));
        }
        const isStyleTypeSupported = $ab0101fae4fd036b$var$getStyleTypeSupportChecker(listStyleCommand);
        styleButtonViews = filteredDefinitions.filter(isStyleTypeSupported).map(styleButtonCreator);
    }
    const listPropertiesView = new $ab0101fae4fd036b$export$bdb651a4f6a3114d(locale, {
        styleGridAriaLabel: styleGridAriaLabel,
        enabledProperties: enabledProperties,
        styleButtonViews: styleButtonViews
    });
    if (normalizedConfig.styles.listTypes.includes(listType)) (0, $29fd27cb9bdab9d2$export$52d62fb5806f208)(dropdownView, ()=>{
        return listPropertiesView.stylesView.children.find((child)=>child.isOn);
    });
    if (enabledProperties.startIndex) {
        const listStartCommand = editor.commands.get("listStart");
        listPropertiesView.startIndexFieldView.bind("isEnabled").to(listStartCommand);
        listPropertiesView.startIndexFieldView.fieldView.bind("value").to(listStartCommand);
        listPropertiesView.on("listStart", (evt, data)=>editor.execute("listStart", data));
    }
    if (enabledProperties.reversed) {
        const listReversedCommand = editor.commands.get("listReversed");
        listPropertiesView.reversedSwitchButtonView.bind("isEnabled").to(listReversedCommand);
        listPropertiesView.reversedSwitchButtonView.bind("isOn").to(listReversedCommand, "value", (value)=>!!value);
        listPropertiesView.on("listReversed", ()=>{
            const isReversed = listReversedCommand.value;
            editor.execute("listReversed", {
                reversed: !isReversed
            });
        });
    }
    listPropertiesView.delegate("execute").to(dropdownView);
    return listPropertiesView;
}
/**
* A helper that creates the list style submenu for menu bar.
*
* @param editor Editor instance.
* @param normalizedConfig List properties configuration.
* @param parentCommandName Name of the list command.
* @param buttonLabel Label of the menu button.
* @param styleGridAriaLabel ARIA label of the styles grid.
*/ function $ab0101fae4fd036b$var$getMenuBarStylesMenuCreator({ editor: editor, normalizedConfig: normalizedConfig, parentCommandName: parentCommandName, buttonLabel: buttonLabel, styleGridAriaLabel: styleGridAriaLabel, styleDefinitions: styleDefinitions }) {
    return (locale)=>{
        const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
        const listCommand = editor.commands.get(parentCommandName);
        const listStyleCommand = editor.commands.get("listStyle");
        const isStyleTypeSupported = $ab0101fae4fd036b$var$getStyleTypeSupportChecker(listStyleCommand);
        const styleButtonCreator = $ab0101fae4fd036b$var$getStyleButtonCreator({
            editor: editor,
            parentCommandName: parentCommandName,
            listStyleCommand: listStyleCommand
        });
        const configuredListStylesTypes = normalizedConfig.styles.listStyleTypes;
        let filteredDefinitions = styleDefinitions;
        /* v8 ignore next -- Normalized config always provides listStyleTypes for enabled styles. */ if (configuredListStylesTypes) {
            const allowedTypes = configuredListStylesTypes[listCommand.type];
            if (allowedTypes) filteredDefinitions = styleDefinitions.filter((def)=>allowedTypes.includes(def.type));
        }
        const styleButtonViews = filteredDefinitions.filter(isStyleTypeSupported).map(styleButtonCreator);
        const listPropertiesView = new $ab0101fae4fd036b$export$bdb651a4f6a3114d(locale, {
            styleGridAriaLabel: styleGridAriaLabel,
            enabledProperties: {
                ...normalizedConfig,
                startIndex: false,
                reversed: false
            },
            styleButtonViews: styleButtonViews
        });
        listPropertiesView.delegate("execute").to(menuView);
        menuView.buttonView.set({
            label: buttonLabel,
            icon: parentCommandName === "bulletedList" ? (0, $e8dc502aba5ac3f5$export$368e6033157c630e) : (0, $e8dc502aba5ac3f5$export$8cf58c969bb2bf96)
        });
        menuView.panelView.children.add(listPropertiesView);
        menuView.bind("isEnabled").to(listCommand, "isEnabled");
        menuView.on("execute", ()=>{
            editor.editing.view.focus();
        });
        return menuView;
    };
}
function $ab0101fae4fd036b$var$getStyleTypeSupportChecker(listStyleCommand) {
    if (typeof listStyleCommand.isStyleTypeSupported == "function") return (styleDefinition)=>listStyleCommand.isStyleTypeSupported(styleDefinition.type);
    else return ()=>true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/listproperties
*/ /**
* The list properties feature.
*
* This is a "glue" plugin that loads the
* {@link module:list/listproperties/listpropertiesediting~ListPropertiesEditing list properties
* editing feature} and the {@link module:list/listproperties/listpropertiesui~ListPropertiesUI list properties UI feature}.
*/ var $ab0101fae4fd036b$export$bd13c9a60af74697 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$9c8ffd43470a1979,
            $ab0101fae4fd036b$export$ad7529ae09e99074
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListProperties";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/todolist/checktodolistcommand
*/ /**
* The check to-do command.
*
* The command is registered by the {@link module:list/todolist/todolistediting~TodoListEditing} as
* the `checkTodoList` editor command.
*/ var $ab0101fae4fd036b$export$cb0f1e9f790e56cd = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.on("execute", ()=>{
            this.refresh();
        }, {
            priority: "highest"
        });
    }
    /**
	* Updates the command's {@link #value} and {@link #isEnabled} properties based on the current selection.
	*/ refresh() {
        const selectedElements = this._getSelectedItems();
        this.value = this._getValue(selectedElements);
        this.isEnabled = !!selectedElements.length;
    }
    /**
	* Executes the command.
	*
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply
	* the attribute. Otherwise, the command will remove the attribute. If not set, the command will look for its current
	* value to decide what it should do.
	*/ execute(options = {}) {
        this.editor.model.change((writer)=>{
            const selectedElements = this._getSelectedItems();
            const value = options.forceValue === void 0 ? !this._getValue(selectedElements) : options.forceValue;
            for (const element of selectedElements)if (value) writer.setAttribute("todoListChecked", true, element);
            else writer.removeAttribute("todoListChecked", element);
        });
    }
    /**
	* Returns a value for the command.
	*/ _getValue(selectedElements) {
        return selectedElements.every((element)=>element.getAttribute("todoListChecked"));
    }
    /**
	* Gets all to-do list items selected by the {@link module:engine/model/selection~ModelSelection}.
	*/ _getSelectedItems() {
        const model = this.editor.model;
        const schema = model.schema;
        const selectionRange = model.document.selection.getFirstRange();
        const startElement = selectionRange.start.parent;
        const elements = [];
        if (schema.checkAttribute(startElement, "todoListChecked")) elements.push(...$ab0101fae4fd036b$export$8498b9023b0db3dd(startElement));
        for (const item of selectionRange.getItems({
            shallow: true
        }))if (schema.checkAttribute(item, "todoListChecked") && !elements.includes(item)) elements.push(...$ab0101fae4fd036b$export$8498b9023b0db3dd(item));
        return elements;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/todolist/todocheckboxchangeobserver
*/ /**
* Observes all to-do list checkboxes state changes.
*
* Note that this observer is not available by default. To make it available it needs to be added to
* {@link module:engine/view/view~EditingView} by {@link module:engine/view/view~EditingView#addObserver} method.
*
* @internal
*/ var $ab0101fae4fd036b$export$98e93a58e503dc1f = class extends (0, $b9b9f2bdf9c6137f$export$fc1db128570de841) {
    /**
	* @inheritDoc
	*/ domEventType = [
        "change"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        if (domEvent.target) {
            const viewTarget = this.view.domConverter.mapDomToView(domEvent.target);
            if (viewTarget && viewTarget.is("element", "input") && viewTarget.getAttribute("type") == "checkbox" && viewTarget.findAncestor({
                classes: "todo-list__label"
            })) this.fire("todoCheckboxChange", domEvent);
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/todolist/todolistediting
*/ const $ab0101fae4fd036b$var$ITEM_TOGGLE_KEYSTROKE$1 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$970afd9da919f686)("Ctrl+Enter");
/**
* The engine of the to-do list feature. It handles creating, editing and removing to-do lists and their items.
*
* It registers the entire functionality of the {@link module:list/list/listediting~ListEditing list editing plugin}
* and extends it with the commands:
*
* - `'todoList'`,
* - `'checkTodoList'`,
*/ var $ab0101fae4fd036b$export$aa28c1c3555f670b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TodoListEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$3886a37ee979f1f
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const editing = editor.editing;
        const listEditing = editor.plugins.get($ab0101fae4fd036b$export$3886a37ee979f1f);
        const elementName = editor.config.get("list.multiBlock") ? "paragraph" : "listItem";
        editor.commands.add("todoList", new $ab0101fae4fd036b$export$ba93ee87858e1659(editor, "todo"));
        editor.commands.add("checkTodoList", new $ab0101fae4fd036b$export$cb0f1e9f790e56cd(editor));
        editing.view.addObserver($ab0101fae4fd036b$export$98e93a58e503dc1f);
        model.schema.extend("$listItem", {
            allowAttributes: "todoListChecked"
        });
        model.schema.addAttributeCheck((context)=>{
            const item = context.last;
            if (!item.getAttribute("listItemId") || item.getAttribute("listType") != "todo") return false;
        }, "todoListChecked");
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:input", $ab0101fae4fd036b$var$todoItemInputConverter());
            dispatcher.on("element:li", $ab0101fae4fd036b$var$todoListItemUpcastConverter(), {
                priority: "low"
            });
            dispatcher.on("element:label", $ab0101fae4fd036b$var$elementUpcastConsumingConverter({
                name: "label",
                classes: "todo-list__label"
            }));
            dispatcher.on("element:label", $ab0101fae4fd036b$var$elementUpcastConsumingConverter({
                name: "label",
                classes: [
                    "todo-list__label",
                    "todo-list__label_without-description"
                ]
            }));
            dispatcher.on("element:span", $ab0101fae4fd036b$var$elementUpcastConsumingConverter({
                name: "span",
                classes: "todo-list__label__description"
            }));
            dispatcher.on("element:ul", $ab0101fae4fd036b$var$attributeUpcastConsumingConverter({
                name: "ul",
                classes: "todo-list"
            }));
        });
        editor.conversion.for("downcast").elementToElement({
            model: elementName,
            view: (element, { writer: writer })=>{
                if ($ab0101fae4fd036b$var$isDescriptionBlock(element, listEditing.getListAttributeNames())) return writer.createContainerElement("span", {
                    class: "todo-list__label__description"
                });
            },
            converterPriority: "highest"
        });
        listEditing.registerDowncastStrategy({
            scope: "list",
            attributeName: "listType",
            setAttributeOnDowncast (writer, value, element) {
                if (value == "todo") writer.addClass("todo-list", element);
                else writer.removeClass("todo-list", element);
            }
        });
        listEditing.registerDowncastStrategy({
            scope: "itemMarker",
            attributeName: "todoListChecked",
            createElement (writer, modelElement, { dataPipeline: dataPipeline }) {
                if (modelElement.getAttribute("listType") != "todo") return null;
                const viewElement = writer.createUIElement("input", {
                    type: "checkbox",
                    ...modelElement.getAttribute("todoListChecked") ? {
                        checked: "checked"
                    } : null,
                    ...dataPipeline ? {
                        disabled: "disabled"
                    } : {
                        tabindex: "-1"
                    }
                });
                if (dataPipeline) return viewElement;
                const wrapper = writer.createContainerElement("span", {
                    contenteditable: "false"
                }, viewElement);
                wrapper.getFillerOffset = ()=>null;
                return wrapper;
            },
            canWrapElement (modelElement) {
                return $ab0101fae4fd036b$var$isDescriptionBlock(modelElement, listEditing.getListAttributeNames());
            },
            createWrapperElement (writer, modelElement, { dataPipeline: dataPipeline }) {
                const classes = [
                    "todo-list__label"
                ];
                if (!$ab0101fae4fd036b$var$isDescriptionBlock(modelElement, listEditing.getListAttributeNames())) classes.push("todo-list__label_without-description");
                return writer.createAttributeElement(dataPipeline ? "label" : "span", {
                    class: classes.join(" ")
                });
            }
        });
        listEditing.on("checkElement", (evt, { modelElement: modelElement, viewElement: viewElement })=>{
            const isFirstTodoModelParagraphBlock = $ab0101fae4fd036b$var$isDescriptionBlock(modelElement, listEditing.getListAttributeNames());
            if (viewElement.hasClass("todo-list__label__description") != isFirstTodoModelParagraphBlock) {
                evt.return = true;
                evt.stop();
            }
        });
        listEditing.on("checkElement", (evt, { modelElement: modelElement, viewElement: viewElement })=>{
            const isFirstTodoModelItemBlock = modelElement.getAttribute("listType") == "todo" && $ab0101fae4fd036b$export$f3f5b10432a99ae7(modelElement);
            let hasViewItemMarker = false;
            const viewWalker = editor.editing.view.createPositionBefore(viewElement).getWalker({
                direction: "backward"
            });
            for (const { item: item } of viewWalker){
                if (item.is("element") && editor.editing.mapper.toModelElement(item)) break;
                if (item.is("element", "input") && item.getAttribute("type") == "checkbox") hasViewItemMarker = true;
            }
            if (hasViewItemMarker != isFirstTodoModelItemBlock) {
                evt.return = true;
                evt.stop();
            }
        });
        listEditing.on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node, previousNodeInList: previousNodeInList } of listNodes){
                if (!previousNodeInList) continue;
                if (previousNodeInList.getAttribute("listItemId") != node.getAttribute("listItemId")) continue;
                const previousHasAttribute = previousNodeInList.hasAttribute("todoListChecked");
                const nodeHasAttribute = node.hasAttribute("todoListChecked");
                if (nodeHasAttribute && !previousHasAttribute) {
                    writer.removeAttribute("todoListChecked", node);
                    evt.return = true;
                } else if (!nodeHasAttribute && previousHasAttribute) {
                    writer.setAttribute("todoListChecked", true, node);
                    evt.return = true;
                }
            }
        });
        model.document.registerPostFixer((writer)=>{
            const changes = model.document.differ.getChanges();
            let wasFixed = false;
            for (const change of changes)if (change.type == "attribute" && change.attributeKey == "listType") {
                const element = change.range.start.nodeAfter;
                if (change.attributeOldValue == "todo" && element.hasAttribute("todoListChecked")) {
                    writer.removeAttribute("todoListChecked", element);
                    wasFixed = true;
                }
            } else if (change.type == "insert" && change.name != "$text") {
                for (const { item: item } of writer.createRangeOn(change.position.nodeAfter))if (item.is("element") && item.getAttribute("listType") != "todo" && item.hasAttribute("todoListChecked")) {
                    writer.removeAttribute("todoListChecked", item);
                    wasFixed = true;
                }
            }
            return wasFixed;
        });
        this.listenTo(editing.view.document, "keydown", (evt, data)=>{
            if ((0, $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb)(data) === $ab0101fae4fd036b$var$ITEM_TOGGLE_KEYSTROKE$1) {
                editor.execute("checkTodoList");
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(editing.view.document, "todoCheckboxChange", (evt, data)=>{
            const viewTarget = data.target;
            if (!viewTarget || !viewTarget.is("element", "input")) return;
            const viewPositionAfter = editing.view.createPositionAfter(viewTarget);
            const modelElement = editing.mapper.toModelPosition(viewPositionAfter).parent;
            /* v8 ignore next -- Defensive guard for externally fired observer events outside to-do list inputs. */ if (modelElement && $ab0101fae4fd036b$export$d0c47194f8840044(modelElement) && modelElement.getAttribute("listType") == "todo") this._handleCheckmarkChange(modelElement);
        });
        this.listenTo(editing.view.document, "arrowKey", $ab0101fae4fd036b$var$jumpOverCheckmarkOnSideArrowKeyPress$1(model, editor.locale), {
            context: "$text"
        });
        this.listenTo(editing.mapper, "viewToModelPosition", (evt, data)=>{
            const viewParent = data.viewPosition.parent;
            const isStartOfListItem = viewParent.is("attributeElement", "li") && data.viewPosition.offset == 0;
            const isStartOfListLabel = $ab0101fae4fd036b$var$isLabelElement(viewParent) && data.viewPosition.offset <= 1;
            const isInInputWrapper = viewParent.is("element", "span") && viewParent.getAttribute("contenteditable") == "false" && $ab0101fae4fd036b$var$isLabelElement(viewParent.parent);
            if (!isStartOfListItem && !isStartOfListLabel && !isInInputWrapper) return;
            const nodeAfter = data.modelPosition.nodeAfter;
            /* v8 ignore next -- Defensive mapper guard for view positions outside to-do list widgets. */ if (nodeAfter && nodeAfter.getAttribute("listType") == "todo") data.modelPosition = model.createPositionAt(nodeAfter, 0);
        }, {
            priority: "low"
        });
        this._initAriaAnnouncements();
    }
    /**
	* Handles the checkbox element change, moves the selection to the corresponding model item to make it possible
	* to toggle the `todoListChecked` attribute using the command, and restores the selection position.
	*
	* Some say it's a hack :) Moving the selection only for executing the command on a certain node and restoring it after,
	* is not a clear solution. We need to design an API for using commands beyond the selection range.
	* See https://github.com/ckeditor/ckeditor5/issues/1954.
	*/ _handleCheckmarkChange(listItem) {
        const editor = this.editor;
        const model = editor.model;
        const previousSelectionRanges = Array.from(model.document.selection.getRanges());
        model.change((writer)=>{
            writer.setSelection(listItem, "end");
            editor.execute("checkTodoList");
            writer.setSelection(previousSelectionRanges);
        });
    }
    /**
	* Observe when user enters or leaves todo list and set proper aria value in global live announcer.
	* This allows screen readers to indicate when the user has entered and left the specified todo list.
	*
	* @internal
	*/ _initAriaAnnouncements() {
        const { model: model, ui: ui, t: t } = this.editor;
        let lastFocusedCodeBlock = null;
        if (!ui) return;
        model.document.selection.on("change:range", ()=>{
            const focusParent = model.document.selection.focus.parent;
            const lastElementIsTodoList = $ab0101fae4fd036b$var$isTodoListItemElement(lastFocusedCodeBlock);
            const currentElementIsTodoList = $ab0101fae4fd036b$var$isTodoListItemElement(focusParent);
            if (lastElementIsTodoList && !currentElementIsTodoList) ui.ariaLiveAnnouncer.announce(t("Leaving a to-do list"));
            else if (!lastElementIsTodoList && currentElementIsTodoList) ui.ariaLiveAnnouncer.announce(t("Entering a to-do list"));
            lastFocusedCodeBlock = focusParent;
        });
    }
};
/**
* Returns an upcast converter for to-do list items.
*/ function $ab0101fae4fd036b$var$todoListItemUpcastConverter() {
    return (evt, data, conversionApi)=>{
        const { writer: writer, schema: schema } = conversionApi;
        if (!data.modelRange) return;
        const groupedItems = Array.from(data.modelRange.getItems({
            shallow: true
        })).filter((item)=>item.getAttribute("listType") === "todo" && schema.checkAttribute(item, "listItemId")).reduce((acc, item)=>{
            const listItemId = item.getAttribute("listItemId");
            if (!acc.has(listItemId)) acc.set(listItemId, $ab0101fae4fd036b$export$8498b9023b0db3dd(item));
            return acc;
        }, /* @__PURE__ */ new Map());
        for (const [, items] of groupedItems.entries())if (items.some((item)=>item.getAttribute("todoListChecked"))) for (const item of items)writer.setAttribute("todoListChecked", true, item);
    };
}
/**
* Returns an upcast converter that detects a to-do list checkbox and marks the list item as a to-do list.
*/ function $ab0101fae4fd036b$var$todoItemInputConverter() {
    return (evt, data, conversionApi)=>{
        const modelCursor = data.modelCursor;
        const modelItem = modelCursor.parent;
        const viewItem = data.viewItem;
        if (!conversionApi.consumable.test(viewItem, {
            name: true
        })) return;
        if (viewItem.getAttribute("type") != "checkbox" || !modelCursor.isAtStart || !modelItem.hasAttribute("listType")) return;
        conversionApi.consumable.consume(viewItem, {
            name: true
        });
        const writer = conversionApi.writer;
        writer.setAttribute("listType", "todo", modelItem);
        if (data.viewItem.hasAttribute("checked")) writer.setAttribute("todoListChecked", true, modelItem);
        data.modelRange = writer.createRange(modelCursor);
    };
}
/**
* Returns an upcast converter that consumes element matching the given matcher pattern.
*/ function $ab0101fae4fd036b$var$elementUpcastConsumingConverter(matcherPattern) {
    const matcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)(matcherPattern);
    return (evt, data, conversionApi)=>{
        const matcherResult = matcher.match(data.viewItem);
        if (!matcherResult) return;
        if (!conversionApi.consumable.consume(data.viewItem, matcherResult.match)) return;
        Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
    };
}
/**
* Returns an upcast converter that consumes attributes matching the given matcher pattern.
*/ function $ab0101fae4fd036b$var$attributeUpcastConsumingConverter(matcherPattern) {
    const matcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)(matcherPattern);
    return (evt, data, conversionApi)=>{
        const matcherResult = matcher.match(data.viewItem);
        if (!matcherResult) return;
        const match = matcherResult.match;
        match.name = false;
        conversionApi.consumable.consume(data.viewItem, match);
    };
}
/**
* Returns true if the given list item block should be converted as a description block of a to-do list item.
*/ function $ab0101fae4fd036b$var$isDescriptionBlock(modelElement, listAttributeNames) {
    return (modelElement.is("element", "paragraph") || modelElement.is("element", "listItem")) && modelElement.getAttribute("listType") == "todo" && $ab0101fae4fd036b$export$f3f5b10432a99ae7(modelElement) && $ab0101fae4fd036b$var$hasOnlyListAttributes(modelElement, listAttributeNames);
}
/**
* Returns true if only attributes from the given list are present on the model element.
*/ function $ab0101fae4fd036b$var$hasOnlyListAttributes(modelElement, attributeNames) {
    for (const attributeKey of modelElement.getAttributeKeys()){
        if (attributeKey.startsWith("selection:")) continue;
        if (!attributeNames.includes(attributeKey)) return false;
    }
    return true;
}
/**
* Jump at the start and end of a to-do list item.
*/ function $ab0101fae4fd036b$var$jumpOverCheckmarkOnSideArrowKeyPress$1(model, locale) {
    return (eventInfo, domEventData)=>{
        const direction = (0, $c7bc2cb7e2db0227$export$ad185f2969a88a73)(domEventData.keyCode, locale.contentLanguageDirection);
        const schema = model.schema;
        const selection = model.document.selection;
        if (!selection.isCollapsed) return;
        const position = selection.getFirstPosition();
        const parent = position.parent;
        if (direction == "right" && position.isAtEnd) {
            const newRange = schema.getNearestSelectionRange(model.createPositionAfter(parent), "forward");
            if (!newRange) return;
            const newRangeParent = newRange.start.parent;
            if (newRangeParent && $ab0101fae4fd036b$export$d0c47194f8840044(newRangeParent) && newRangeParent.getAttribute("listType") == "todo") {
                model.change((writer)=>writer.setSelection(newRange));
                domEventData.preventDefault();
                domEventData.stopPropagation();
                eventInfo.stop();
            }
        } else if (direction == "left" && position.isAtStart && $ab0101fae4fd036b$export$d0c47194f8840044(parent) && parent.getAttribute("listType") == "todo") {
            const newRange = schema.getNearestSelectionRange(model.createPositionBefore(parent), "backward");
            if (!newRange) return;
            model.change((writer)=>writer.setSelection(newRange));
            domEventData.preventDefault();
            domEventData.stopPropagation();
            eventInfo.stop();
        }
    };
}
/**
* Returns true if the given element is a label element of a to-do list item.
*/ function $ab0101fae4fd036b$var$isLabelElement(viewElement) {
    return !!viewElement && viewElement.is("attributeElement") && viewElement.hasClass("todo-list__label");
}
/**
* Returns true if the given element is a list item model element of a to-do list.
*/ function $ab0101fae4fd036b$var$isTodoListItemElement(element) {
    if (!element) return false;
    if (!element.is("element", "paragraph") && !element.is("element", "listItem")) return false;
    return element.getAttribute("listType") == "todo";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/todolist/todolistui
*/ /**
* The to-do list UI feature. It introduces the `'todoList'` button that
* allows to convert elements to and from to-do list items and to indent or outdent them.
*/ var $ab0101fae4fd036b$export$b53f321a39a26d73 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TodoListUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const t = this.editor.t;
        $ab0101fae4fd036b$export$351213da81ee126a(this.editor, "todoList", t("To-do List"), (0, $e8dc502aba5ac3f5$export$573bad8c14308a));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/todolist
*/ /**
* The to-do list feature.
*
* This is a "glue" plugin that loads the {@link module:list/todolist/todolistediting~TodoListEditing to-do list
* editing feature} and the {@link module:list/todolist/todolistui~TodoListUI to-do list UI feature}.
*/ var $ab0101fae4fd036b$export$1637e515a5a47691 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$aa28c1c3555f670b,
            $ab0101fae4fd036b$export$b53f321a39a26d73
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TodoList";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The list command. It is used by the {@link module:list/legacylist~LegacyList legacy list feature}.
*/ var $ab0101fae4fd036b$export$b0985fe0ab85ecbb = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The type of the list created by the command.
	*/ type;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param type List type that will be handled by this command.
	*/ constructor(editor, type){
        super(editor);
        this.type = type;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the list command.
	*
	* @fires execute
	* @param options Command options.
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will try to convert the
	* selected items and potentially the neighbor elements to the proper list items. If set to `false`, it will convert selected elements
	* to paragraphs. If not set, the command will toggle selected elements to list items or paragraphs, depending on the selection.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const document1 = model.document;
        const blocks = Array.from(document1.selection.getSelectedBlocks()).filter((block)=>$ab0101fae4fd036b$var$checkCanBecomeListItem(block, model.schema));
        const turnOff = options.forceValue !== void 0 ? !options.forceValue : this.value;
        model.change((writer)=>{
            if (turnOff) {
                let next = blocks[blocks.length - 1].nextSibling;
                let currentIndent = Number.POSITIVE_INFINITY;
                let changes = [];
                while(next && next.name == "listItem" && next.getAttribute("listIndent") !== 0){
                    const indent = next.getAttribute("listIndent");
                    if (indent < currentIndent) currentIndent = indent;
                    const newIndent = indent - currentIndent;
                    changes.push({
                        element: next,
                        listIndent: newIndent
                    });
                    next = next.nextSibling;
                }
                changes = changes.reverse();
                for (const item of changes)writer.setAttribute("listIndent", item.listIndent, item.element);
            }
            if (!turnOff) {
                let lowestIndent = Number.POSITIVE_INFINITY;
                for (const item of blocks)if (item.is("element", "listItem") && item.getAttribute("listIndent") < lowestIndent) lowestIndent = item.getAttribute("listIndent");
                lowestIndent = lowestIndent === 0 ? 1 : lowestIndent;
                $ab0101fae4fd036b$var$_fixType(blocks, true, lowestIndent);
                $ab0101fae4fd036b$var$_fixType(blocks, false, lowestIndent);
            }
            for (const element of blocks.reverse())if (turnOff && element.name == "listItem") writer.rename(element, "paragraph");
            else if (!turnOff && element.name != "listItem") {
                writer.setAttributes({
                    listType: this.type,
                    listIndent: 0
                }, element);
                writer.rename(element, "listItem");
            } else if (!turnOff && element.name == "listItem" && element.getAttribute("listType") != this.type) writer.setAttribute("listType", this.type, element);
            /**
			* Event fired by the {@link #execute} method.
			*
			* It allows to execute an action after executing the {@link ~ListCommand#execute} method, for example adjusting
			* attributes of changed blocks.
			*
			* @protected
			* @event _executeCleanup
			*/ this.fire("_executeCleanup", blocks);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const listItem = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this.editor.model.document.selection.getSelectedBlocks());
        return !!listItem && listItem.is("element", "listItem") && listItem.getAttribute("listType") == this.type;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        if (this.value) return true;
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if (!firstBlock) return false;
        return $ab0101fae4fd036b$var$checkCanBecomeListItem(firstBlock, schema);
    }
};
/**
* Helper function used when one or more list item have their type changed. Fixes type of other list items
* that are affected by the change (are in same lists) but are not directly in selection. The function got extracted
* not to duplicated code, as same fix has to be performed before and after selection.
*
* @param blocks Blocks that are in selection.
* @param isBackward Specified whether fix will be applied for blocks before first selected block (`true`)
* or blocks after last selected block (`false`).
* @param lowestIndent Lowest indent among selected blocks.
*/ function $ab0101fae4fd036b$var$_fixType(blocks, isBackward, lowestIndent) {
    const startingItem = isBackward ? blocks[0] : blocks[blocks.length - 1];
    if (startingItem.is("element", "listItem")) {
        let item = startingItem[isBackward ? "previousSibling" : "nextSibling"];
        let currentIndent = startingItem.getAttribute("listIndent");
        while(item && item.is("element", "listItem") && item.getAttribute("listIndent") >= lowestIndent){
            if (currentIndent > item.getAttribute("listIndent")) currentIndent = item.getAttribute("listIndent");
            if (item.getAttribute("listIndent") == currentIndent) blocks[isBackward ? "unshift" : "push"](item);
            item = item[isBackward ? "previousSibling" : "nextSibling"];
        }
    }
}
/**
* Checks whether the given block can be replaced by a listItem.
*
* @param block A block to be tested.
* @param schema The schema of the document.
*/ function $ab0101fae4fd036b$var$checkCanBecomeListItem(block, schema) {
    return schema.checkChild(block.parent, "listItem") && !schema.isObject(block);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The list indent command. It is used by the {@link module:list/legacylist~LegacyList legacy list feature}.
*/ var $ab0101fae4fd036b$export$e6e2bd367a1e01fb = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Determines by how much the command will change the list item's indent attribute.
	*/ _indentBy;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param indentDirection The direction of indent. If it is equal to `backward`, the command will outdent a list item.
	*/ constructor(editor, indentDirection){
        super(editor);
        this._indentBy = indentDirection == "forward" ? 1 : -1;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Indents or outdents (depending on the {@link #constructor}'s `indentDirection` parameter) selected list items.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        const doc = model.document;
        let itemsToChange = Array.from(doc.selection.getSelectedBlocks());
        model.change((writer)=>{
            const lastItem = itemsToChange[itemsToChange.length - 1];
            let next = lastItem.nextSibling;
            while(next && next.name == "listItem" && next.getAttribute("listIndent") > lastItem.getAttribute("listIndent")){
                itemsToChange.push(next);
                next = next.nextSibling;
            }
            if (this._indentBy < 0) itemsToChange = itemsToChange.reverse();
            for (const item of itemsToChange){
                const indent = item.getAttribute("listIndent") + this._indentBy;
                if (indent < 0) writer.rename(item, "paragraph");
                else writer.setAttribute("listIndent", indent, item);
            }
            this.fire("_executeCleanup", itemsToChange);
        });
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const listItem = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this.editor.model.document.selection.getSelectedBlocks());
        if (!listItem || !listItem.is("element", "listItem")) return false;
        if (this._indentBy > 0) {
            const indent = listItem.getAttribute("listIndent");
            const type = listItem.getAttribute("listType");
            let prev = listItem.previousSibling;
            while(prev && prev.is("element", "listItem") && prev.getAttribute("listIndent") >= indent){
                if (prev.getAttribute("listIndent") == indent) return prev.getAttribute("listType") == type;
                prev = prev.previousSibling;
            }
            return false;
        }
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylist/legacyutils
*/ /**
* Creates a list item {@link module:engine/view/containerelement~ViewContainerElement}.
*
* @internal
* @param writer The writer instance.
*/ function $ab0101fae4fd036b$var$createViewListItemElement(writer) {
    const viewItem = writer.createContainerElement("li");
    viewItem.getFillerOffset = $ab0101fae4fd036b$var$getListItemFillerOffset;
    return viewItem;
}
/**
* Helper function that creates a `<ul><li></li></ul>` or (`<ol>`) structure out of the given `modelItem` model `listItem` element.
* Then, it binds the created view list item (`<li>`) with the model `listItem` element.
* The function then returns the created view list item (`<li>`).
*
* @internal
* @param modelItem Model list item.
* @param conversionApi Conversion interface.
* @returns View list element.
*/ function $ab0101fae4fd036b$var$generateLiInUl(modelItem, conversionApi) {
    const mapper = conversionApi.mapper;
    const viewWriter = conversionApi.writer;
    const listType = modelItem.getAttribute("listType") == "numbered" ? "ol" : "ul";
    const viewItem = $ab0101fae4fd036b$var$createViewListItemElement(viewWriter);
    const viewList = viewWriter.createContainerElement(listType, null);
    viewWriter.insert(viewWriter.createPositionAt(viewList, 0), viewItem);
    mapper.bindElements(modelItem, viewItem);
    return viewItem;
}
/**
* Helper function that inserts a view list at a correct place and merges it with its siblings.
* It takes a model list item element (`modelItem`) and a corresponding view list item element (`injectedItem`). The view list item
* should be in a view list element (`<ul>` or `<ol>`) and should be its only child.
* See comments below to better understand the algorithm.
*
* @internal
* @param modelItem Model list item.
* @param injectedItem
* @param conversionApi Conversion interface.
* @param model The model instance.
*/ function $ab0101fae4fd036b$var$injectViewList(modelItem, injectedItem, conversionApi, model) {
    const injectedList = injectedItem.parent;
    const mapper = conversionApi.mapper;
    const viewWriter = conversionApi.writer;
    let insertPosition;
    const refItem = $ab0101fae4fd036b$var$getSiblingListItem(modelItem.previousSibling, {
        sameIndent: true,
        smallerIndent: true,
        listIndent: modelItem.getAttribute("listIndent")
    });
    const prevItem = modelItem.previousSibling;
    if (refItem && refItem.getAttribute("listIndent") == modelItem.getAttribute("listIndent")) {
        const viewItem = mapper.toViewElement(refItem);
        insertPosition = viewWriter.breakContainer(viewWriter.createPositionAfter(viewItem));
    } else if (prevItem && prevItem.name == "listItem") {
        insertPosition = mapper.toViewPosition(model.createPositionAt(prevItem, "end"));
        const mappedViewAncestor = mapper.findMappedViewAncestor(insertPosition);
        const nestedList = $ab0101fae4fd036b$var$findNestedList(mappedViewAncestor);
        if (nestedList) insertPosition = viewWriter.createPositionBefore(nestedList);
        else insertPosition = viewWriter.createPositionAt(mappedViewAncestor, "end");
    } else insertPosition = mapper.toViewPosition(model.createPositionBefore(modelItem));
    insertPosition = $ab0101fae4fd036b$var$positionAfterUiElements(insertPosition);
    viewWriter.insert(insertPosition, injectedList);
    if (prevItem && prevItem.name == "listItem") {
        const prevView = mapper.toViewElement(prevItem);
        const walker = viewWriter.createRange(viewWriter.createPositionAt(prevView, 0), insertPosition).getWalker({
            ignoreElementEnd: true
        });
        for (const value of walker)if (value.item.is("element", "li")) {
            const breakPosition = viewWriter.breakContainer(viewWriter.createPositionBefore(value.item));
            const viewList = value.item.parent;
            const targetPosition = viewWriter.createPositionAt(injectedItem, "end");
            $ab0101fae4fd036b$var$mergeViewLists(viewWriter, targetPosition.nodeBefore, targetPosition.nodeAfter);
            viewWriter.move(viewWriter.createRangeOn(viewList), targetPosition);
            walker._position = breakPosition;
        }
    } else {
        const nextViewList = injectedList.nextSibling;
        if (nextViewList && (nextViewList.is("element", "ul") || nextViewList.is("element", "ol"))) {
            let lastSubChild = null;
            for (const child of nextViewList.getChildren()){
                const modelChild = mapper.toModelElement(child);
                if (modelChild && modelChild.getAttribute("listIndent") > modelItem.getAttribute("listIndent")) lastSubChild = child;
                else break;
            }
            if (lastSubChild) {
                viewWriter.breakContainer(viewWriter.createPositionAfter(lastSubChild));
                viewWriter.move(viewWriter.createRangeOn(lastSubChild.parent), viewWriter.createPositionAt(injectedItem, "end"));
            }
        }
    }
    $ab0101fae4fd036b$var$mergeViewLists(viewWriter, injectedList, injectedList.nextSibling);
    $ab0101fae4fd036b$var$mergeViewLists(viewWriter, injectedList.previousSibling, injectedList);
}
function $ab0101fae4fd036b$var$mergeViewLists(viewWriter, firstList, secondList) {
    if (!firstList || !secondList || firstList.name != "ul" && firstList.name != "ol") return null;
    if (firstList.name != secondList.name || firstList.getAttribute("class") !== secondList.getAttribute("class")) return null;
    return viewWriter.mergeContainers(viewWriter.createPositionAfter(firstList));
}
/**
* Helper function that for a given `view.Position`, returns a `view.Position` that is after all `view.UIElement`s that
* are after the given position.
*
* For example:
* `<container:p>foo^<ui:span></ui:span><ui:span></ui:span>bar</container:p>`
* For position ^, the position before "bar" will be returned.
*
* @internal
*/ function $ab0101fae4fd036b$var$positionAfterUiElements(viewPosition) {
    return viewPosition.getLastMatchingPosition((value)=>value.item.is("uiElement"));
}
/**
* Helper function that searches for a previous list item sibling of a given model item that meets the given criteria
* passed by the options object.
*
* @internal
* @param options Search criteria.
* @param options.sameIndent Whether the sought sibling should have the same indentation.
* @param options.smallerIndent Whether the sought sibling should have a smaller indentation.
* @param options.listIndent The reference indentation.
* @param options.direction Walking direction.
*/ function $ab0101fae4fd036b$var$getSiblingListItem(modelItem, options) {
    const sameIndent = !!options.sameIndent;
    const smallerIndent = !!options.smallerIndent;
    const indent = options.listIndent;
    let item = modelItem;
    while(item && item.name == "listItem"){
        const itemIndent = item.getAttribute("listIndent");
        if (sameIndent && indent == itemIndent || smallerIndent && indent > itemIndent) return item;
        if (options.direction === "forward") item = item.nextSibling;
        else item = item.previousSibling;
    }
    return null;
}
/**
* Returns a first list view element that is direct child of the given view element.
*
* @internal
*/ function $ab0101fae4fd036b$var$findNestedList(viewElement) {
    for (const node of viewElement.getChildren())if (node.name == "ul" || node.name == "ol") return node;
    return null;
}
/**
* Returns an array with all `listItem` elements that represent the same list.
*
* It means that values of `listIndent`, `listType`, `listStyle`, `listReversed` and `listStart` for all items are equal.
*
* Additionally, if the `position` is inside a list item, that list item will be returned as well.
*
* @internal
* @param position Starting position.
* @param direction Walking direction.
*/ function $ab0101fae4fd036b$var$getSiblingNodes(position, direction) {
    const items = [];
    const listItem = position.parent;
    const walkerOptions = {
        ignoreElementEnd: false,
        startPosition: position,
        shallow: true,
        direction: direction
    };
    const limitIndent = listItem.getAttribute("listIndent");
    const nodes = [
        ...new (0, $b9b9f2bdf9c6137f$export$c24047420d7ab789)(walkerOptions)
    ].filter((value)=>value.item.is("element")).map((value)=>value.item);
    for (const element of nodes){
        if (!element.is("element", "listItem")) break;
        if (element.getAttribute("listIndent") < limitIndent) break;
        if (element.getAttribute("listIndent") > limitIndent) continue;
        if (element.getAttribute("listType") !== listItem.getAttribute("listType")) break;
        if (element.getAttribute("listStyle") !== listItem.getAttribute("listStyle")) break;
        if (element.getAttribute("listReversed") !== listItem.getAttribute("listReversed")) break;
        if (element.getAttribute("listStart") !== listItem.getAttribute("listStart")) break;
        if (direction === "backward") items.unshift(element);
        else items.push(element);
    }
    return items;
}
/**
* Returns an array with all `listItem` elements in the model selection.
*
* It returns all the items even if only a part of the list is selected, including items that belong to nested lists.
* If no list is selected, it returns an empty array.
* The order of the elements is not specified.
*
* @internal
*/ function $ab0101fae4fd036b$var$getSelectedListItems(model) {
    let listItems = [
        ...model.document.selection.getSelectedBlocks()
    ].filter((element)=>element.is("element", "listItem")).map((element)=>{
        const position = model.change((writer)=>writer.createPositionAt(element, 0));
        return [
            ...$ab0101fae4fd036b$var$getSiblingNodes(position, "backward"),
            ...$ab0101fae4fd036b$var$getSiblingNodes(position, "forward")
        ];
    }).flat();
    listItems = [
        ...new Set(listItems)
    ];
    return listItems;
}
const $ab0101fae4fd036b$var$BULLETED_LIST_STYLE_TYPES = [
    "disc",
    "circle",
    "square"
];
const $ab0101fae4fd036b$var$NUMBERED_LIST_STYLE_TYPES = [
    "decimal",
    "decimal-leading-zero",
    "lower-roman",
    "upper-roman",
    "lower-latin",
    "upper-latin"
];
/**
* Checks whether the given list-style-type is supported by numbered or bulleted list.
*
* @internal
*/ function $ab0101fae4fd036b$var$getListTypeFromListStyleType$1(listStyleType) {
    if ($ab0101fae4fd036b$var$BULLETED_LIST_STYLE_TYPES.includes(listStyleType)) return "bulleted";
    if ($ab0101fae4fd036b$var$NUMBERED_LIST_STYLE_TYPES.includes(listStyleType)) return "numbered";
    return null;
}
/**
* Implementation of getFillerOffset for view list item element.
*
* @returns Block filler offset or `null` if block filler is not needed.
*/ function $ab0101fae4fd036b$var$getListItemFillerOffset() {
    const hasOnlyLists = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol");
    if (this.isEmpty || hasOnlyLists) return 0;
    return (0, $b9b9f2bdf9c6137f$export$1f46ac43c71ac4b4).call(this);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A set of helpers related to legacy lists.
*/ var $ab0101fae4fd036b$export$524231a73a76f974 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyListUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* Checks whether the given list-style-type is supported by numbered or bulleted list.
	*/ getListTypeFromListStyleType(listStyleType) {
        return $ab0101fae4fd036b$var$getListTypeFromListStyleType$1(listStyleType);
    }
    /**
	* Returns an array with all `listItem` elements in the model selection.
	*
	* It returns all the items even if only a part of the list is selected, including items that belong to nested lists.
	* If no list is selected, it returns an empty array.
	* The order of the elements is not specified.
	*/ getSelectedListItems(model) {
        return $ab0101fae4fd036b$var$getSelectedListItems(model);
    }
    /**
	* Returns an array with all `listItem` elements that represent the same list.
	*
	* It means that values of `listIndent`, `listType`, `listStyle`, `listReversed` and `listStart` for all items are equal.
	*
	* Additionally, if the `position` is inside a list item, that list item will be returned as well.
	*
	* @param position Starting position.
	* @param direction Walking direction.
	*/ getSiblingNodes(position, direction) {
        return $ab0101fae4fd036b$var$getSiblingNodes(position, direction);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylist/legacyconverters
*/ /**
* A model-to-view converter for the `listItem` model element insertion.
*
* It creates a `<ul><li></li><ul>` (or `<ol>`) view structure out of a `listItem` model element, inserts it at the correct
* position, and merges the list with surrounding lists (if available).
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert
* @param model Model instance.
*/ function $ab0101fae4fd036b$var$modelViewInsertion$1(model) {
    return (evt, data, conversionApi)=>{
        const consumable = conversionApi.consumable;
        if (!consumable.test(data.item, "insert") || !consumable.test(data.item, "attribute:listType") || !consumable.test(data.item, "attribute:listIndent")) return;
        consumable.consume(data.item, "insert");
        consumable.consume(data.item, "attribute:listType");
        consumable.consume(data.item, "attribute:listIndent");
        const modelItem = data.item;
        const viewItem = $ab0101fae4fd036b$var$generateLiInUl(modelItem, conversionApi);
        $ab0101fae4fd036b$var$injectViewList(modelItem, viewItem, conversionApi, model);
    };
}
/**
* A model-to-view converter for the `listItem` model element removal.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:remove
* @param model Model instance.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$modelViewRemove(model) {
    return (evt, data, conversionApi)=>{
        const viewItem = conversionApi.mapper.toViewPosition(data.position).getLastMatchingPosition((value)=>!value.item.is("element", "li")).nodeAfter;
        const viewWriter = conversionApi.writer;
        viewWriter.breakContainer(viewWriter.createPositionBefore(viewItem));
        viewWriter.breakContainer(viewWriter.createPositionAfter(viewItem));
        const viewList = viewItem.parent;
        const viewListPrev = viewList.previousSibling;
        const removeRange = viewWriter.createRangeOn(viewList);
        const removed = viewWriter.remove(removeRange);
        if (viewListPrev && viewListPrev.nextSibling) $ab0101fae4fd036b$var$mergeViewLists(viewWriter, viewListPrev, viewListPrev.nextSibling);
        $ab0101fae4fd036b$var$hoistNestedLists(conversionApi.mapper.toModelElement(viewItem).getAttribute("listIndent") + 1, data.position, removeRange.start, viewItem, conversionApi, model);
        for (const child of viewWriter.createRangeIn(removed).getItems())conversionApi.mapper.unbindViewElement(child);
        evt.stop();
    };
}
/**
* A model-to-view converter for the `type` attribute change on the `listItem` model element.
*
* This change means that the `<li>` element parent changes from `<ul>` to `<ol>` (or vice versa). This is accomplished
* by breaking view elements and changing their name. The next {@link module:list/legacylist/legacyconverters~modelViewMergeAfterChangeType}
* converter will attempt to merge split nodes.
*
* Splitting this conversion into 2 steps makes it possible to add an additional conversion in the middle.
* Check {@link module:list/legacytodolist/legacytodolistconverters~modelViewChangeType} to see an example of it.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute
*/ const $ab0101fae4fd036b$var$modelViewChangeType$1 = (evt, data, conversionApi)=>{
    if (!conversionApi.consumable.test(data.item, evt.name)) return;
    const viewItem = conversionApi.mapper.toViewElement(data.item);
    const viewWriter = conversionApi.writer;
    viewWriter.breakContainer(viewWriter.createPositionBefore(viewItem));
    viewWriter.breakContainer(viewWriter.createPositionAfter(viewItem));
    const viewList = viewItem.parent;
    const listName = data.attributeNewValue == "numbered" ? "ol" : "ul";
    viewWriter.rename(listName, viewList);
};
/**
* A model-to-view converter that attempts to merge nodes split by {@link module:list/legacylist/legacyconverters~modelViewChangeType}.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute
*/ const $ab0101fae4fd036b$var$modelViewMergeAfterChangeType = (evt, data, conversionApi)=>{
    conversionApi.consumable.consume(data.item, evt.name);
    const viewList = conversionApi.mapper.toViewElement(data.item).parent;
    const viewWriter = conversionApi.writer;
    $ab0101fae4fd036b$var$mergeViewLists(viewWriter, viewList, viewList.nextSibling);
    $ab0101fae4fd036b$var$mergeViewLists(viewWriter, viewList.previousSibling, viewList);
};
/**
* A model-to-view converter for the `listIndent` attribute change on the `listItem` model element.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute
* @param model Model instance.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$modelViewChangeIndent(model) {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, "attribute:listIndent")) return;
        const viewItem = conversionApi.mapper.toViewElement(data.item);
        const viewWriter = conversionApi.writer;
        viewWriter.breakContainer(viewWriter.createPositionBefore(viewItem));
        viewWriter.breakContainer(viewWriter.createPositionAfter(viewItem));
        const viewList = viewItem.parent;
        const viewListPrev = viewList.previousSibling;
        const removeRange = viewWriter.createRangeOn(viewList);
        viewWriter.remove(removeRange);
        if (viewListPrev && viewListPrev.nextSibling) $ab0101fae4fd036b$var$mergeViewLists(viewWriter, viewListPrev, viewListPrev.nextSibling);
        $ab0101fae4fd036b$var$hoistNestedLists(data.attributeOldValue + 1, data.range.start, removeRange.start, viewItem, conversionApi, model);
        $ab0101fae4fd036b$var$injectViewList(data.item, viewItem, conversionApi, model);
        for (const child of data.item.getChildren())conversionApi.consumable.consume(child, "insert");
    };
}
/**
* A special model-to-view converter introduced by the {@link module:list/legacylist~LegacyList list feature}. This converter is fired for
* insert change of every model item, and should be fired before the actual converter. The converter checks whether the inserted
* model item is a non-`listItem` element. If it is, and it is inserted inside a view list, the converter breaks the
* list so the model element is inserted to the view parent element corresponding to its model parent element.
*
* The converter prevents such situations:
*
* ```xml
* // Model:                        // View:
* <listItem>foo</listItem>         <ul>
* <listItem>bar</listItem>             <li>foo</li>
*                                      <li>bar</li>
*                                  </ul>
*
* // After change:                 // Correct view guaranteed by this converter:
* <listItem>foo</listItem>         <ul><li>foo</li></ul><p>xxx</p><ul><li>bar</li></ul>
* <paragraph>xxx</paragraph>       // Instead of this wrong view state:
* <listItem>bar</listItem>         <ul><li>foo</li><p>xxx</p><li>bar</li></ul>
* ```
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert
*/ const $ab0101fae4fd036b$var$modelViewSplitOnInsert = (evt, data, conversionApi)=>{
    if (!conversionApi.consumable.test(data.item, evt.name)) return;
    if (data.item.name != "listItem") {
        let viewPosition = conversionApi.mapper.toViewPosition(data.range.start);
        const viewWriter = conversionApi.writer;
        const lists = [];
        while(viewPosition.parent.name == "ul" || viewPosition.parent.name == "ol"){
            viewPosition = viewWriter.breakContainer(viewPosition);
            if (viewPosition.parent.name != "li") break;
            const removeStart = viewPosition;
            const removeEnd = viewWriter.createPositionAt(viewPosition.parent, "end");
            if (!removeStart.isEqual(removeEnd)) {
                const removed = viewWriter.remove(viewWriter.createRange(removeStart, removeEnd));
                lists.push(removed);
            }
            viewPosition = viewWriter.createPositionAfter(viewPosition.parent);
        }
        if (lists.length > 0) {
            for(let i = 0; i < lists.length; i++){
                const previousList = viewPosition.nodeBefore;
                viewPosition = viewWriter.insert(viewPosition, lists[i]).end;
                if (i > 0) {
                    const mergePos = $ab0101fae4fd036b$var$mergeViewLists(viewWriter, previousList, previousList.nextSibling);
                    if (mergePos && mergePos.parent == previousList) viewPosition.offset--;
                }
            }
            $ab0101fae4fd036b$var$mergeViewLists(viewWriter, viewPosition.nodeBefore, viewPosition.nodeAfter);
        }
    }
};
/**
* A special model-to-view converter introduced by the {@link module:list/legacylist~LegacyList list feature}. This converter takes care of
* merging view lists after something is removed or moved from near them.
*
* Example:
*
* ```xml
* // Model:                        // View:
* <listItem>foo</listItem>         <ul><li>foo</li></ul>
* <paragraph>xxx</paragraph>       <p>xxx</p>
* <listItem>bar</listItem>         <ul><li>bar</li></ul>
*
* // After change:                 // Correct view guaranteed by this converter:
* <listItem>foo</listItem>         <ul>
* <listItem>bar</listItem>             <li>foo</li>
*                                      <li>bar</li>
*                                  </ul>
* ```
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:remove
*/ const $ab0101fae4fd036b$var$modelViewMergeAfter = (evt, data, conversionApi)=>{
    const viewPosition = conversionApi.mapper.toViewPosition(data.position);
    const viewItemPrev = viewPosition.nodeBefore;
    const viewItemNext = viewPosition.nodeAfter;
    $ab0101fae4fd036b$var$mergeViewLists(conversionApi.writer, viewItemPrev, viewItemNext);
};
/**
* A view-to-model converter that converts the `<li>` view elements into the `listItem` model elements.
*
* To set correct values of the `listType` and `listIndent` attributes the converter:
* * checks `<li>`'s parent,
* * stores and increases the `conversionApi.store.indent` value when `<li>`'s sub-items are converted.
*
* @internal
* @see module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element
*/ const $ab0101fae4fd036b$var$viewModelConverter = (evt, data, conversionApi)=>{
    if (conversionApi.consumable.consume(data.viewItem, {
        name: true
    })) {
        const writer = conversionApi.writer;
        const listItem = writer.createElement("listItem");
        const indent = $ab0101fae4fd036b$var$getIndent$1(data.viewItem);
        writer.setAttribute("listIndent", indent, listItem);
        const type = data.viewItem.parent && data.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
        writer.setAttribute("listType", type, listItem);
        if (!conversionApi.safeInsert(listItem, data.modelCursor)) return;
        const nextPosition = $ab0101fae4fd036b$var$viewToModelListItemChildrenConverter(listItem, data.viewItem.getChildren(), conversionApi);
        data.modelRange = writer.createRange(data.modelCursor, nextPosition);
        conversionApi.updateConversionResult(listItem, data);
    }
};
/**
* A view-to-model converter for the `<ul>` and `<ol>` view elements that cleans the input view of garbage.
* This is mostly to clean whitespaces from between the `<li>` view elements inside the view list element, however, also
* incorrect data can be cleared if the view was incorrect.
*
* @internal
* @see module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element
*/ const $ab0101fae4fd036b$var$cleanList = (evt, data, conversionApi)=>{
    if (conversionApi.consumable.test(data.viewItem, {
        name: true
    })) {
        const children = Array.from(data.viewItem.getChildren());
        for (const child of children)if (!(child.is("element", "li") || $ab0101fae4fd036b$var$isList(child))) child._remove();
    }
};
/**
* A view-to-model converter for the `<li>` elements that cleans whitespace formatting from the input view.
*
* @internal
* @see module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element
*/ const $ab0101fae4fd036b$var$cleanListItem = (evt, data, conversionApi)=>{
    if (conversionApi.consumable.test(data.viewItem, {
        name: true
    })) {
        if (data.viewItem.childCount === 0) return;
        const children = [
            ...data.viewItem.getChildren()
        ];
        let foundList = false;
        for (const child of children){
            if (foundList && !$ab0101fae4fd036b$var$isList(child)) child._remove();
            if ($ab0101fae4fd036b$var$isList(child)) foundList = true;
        }
    }
};
/**
* Returns a callback for model position to view position mapping for {@link module:engine/conversion/mapper~Mapper}. The callback fixes
* positions between the `listItem` elements that would be incorrectly mapped because of how list items are represented in the model
* and in the view.
*
* @internal
*/ function $ab0101fae4fd036b$var$modelToViewPosition(view) {
    return (evt, data)=>{
        if (data.isPhantom) return;
        const modelItem = data.modelPosition.nodeBefore;
        if (modelItem && modelItem.is("element", "listItem")) {
            const viewItem = data.mapper.toViewElement(modelItem);
            const topmostViewList = viewItem.getAncestors().find($ab0101fae4fd036b$var$isList);
            const walker = view.createPositionAt(viewItem, 0).getWalker();
            for (const value of walker)if (value.type == "elementStart" && value.item.is("element", "li")) {
                data.viewPosition = value.previousPosition;
                break;
            } else if (value.type == "elementEnd" && value.item == topmostViewList) {
                data.viewPosition = value.nextPosition;
                break;
            }
        }
    };
}
/**
* The callback for view position to model position mapping for {@link module:engine/conversion/mapper~Mapper}. The callback fixes
* positions between the `<li>` elements that would be incorrectly mapped because of how list items are represented in the model
* and in the view.
*
* @internal
* @see module:engine/conversion/mapper~Mapper#event:viewToModelPosition
* @param model Model instance.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$viewToModelPosition(model) {
    return (evt, data)=>{
        const viewPos = data.viewPosition;
        const viewParent = viewPos.parent;
        const mapper = data.mapper;
        if (viewParent.name == "ul" || viewParent.name == "ol") {
            if (!viewPos.isAtEnd) {
                const modelNode = mapper.toModelElement(viewPos.nodeAfter);
                data.modelPosition = model.createPositionBefore(modelNode);
            } else {
                const modelNode = mapper.toModelElement(viewPos.nodeBefore);
                const modelLength = mapper.getModelLength(viewPos.nodeBefore);
                data.modelPosition = model.createPositionBefore(modelNode).getShiftedBy(modelLength);
            }
            evt.stop();
        } else if (viewParent.name == "li" && viewPos.nodeBefore && (viewPos.nodeBefore.name == "ul" || viewPos.nodeBefore.name == "ol")) {
            const modelNode = mapper.toModelElement(viewParent);
            let modelLength = 1;
            let viewList = viewPos.nodeBefore;
            while(viewList && $ab0101fae4fd036b$var$isList(viewList)){
                modelLength += mapper.getModelLength(viewList);
                viewList = viewList.previousSibling;
            }
            data.modelPosition = model.createPositionBefore(modelNode).getShiftedBy(modelLength);
            evt.stop();
        }
    };
}
/**
* Post-fixer that reacts to changes on document and fixes incorrect model states.
*
* In the example below, there is a correct list structure.
* Then the middle element is removed so the list structure will become incorrect:
*
* ```xml
* <listItem listType="bulleted" listIndent=0>Item 1</listItem>
* <listItem listType="bulleted" listIndent=1>Item 2</listItem>   <--- this is removed.
* <listItem listType="bulleted" listIndent=2>Item 3</listItem>
* ```
*
* The list structure after the middle element is removed:
*
* ```xml
* <listItem listType="bulleted" listIndent=0>Item 1</listItem>
* <listItem listType="bulleted" listIndent=2>Item 3</listItem>
* ```
*
* Should become:
*
* ```xml
* <listItem listType="bulleted" listIndent=0>Item 1</listItem>
* <listItem listType="bulleted" listIndent=1>Item 3</listItem>   <--- note that indent got post-fixed.
* ```
*
* @internal
* @param model The data model.
* @param writer The writer to do changes with.
* @returns `true` if any change has been applied, `false` otherwise.
*/ function $ab0101fae4fd036b$var$modelChangePostFixer(model, writer) {
    const changes = model.document.differ.getChanges();
    const itemToListHead = /* @__PURE__ */ new Map();
    let applied = false;
    for (const entry of changes)if (entry.type == "insert" && entry.name == "listItem") _addListToFix(entry.position);
    else if (entry.type == "insert" && entry.name != "listItem") {
        if (entry.name != "$text") {
            const item = entry.position.nodeAfter;
            if (item.hasAttribute("listIndent")) {
                writer.removeAttribute("listIndent", item);
                applied = true;
            }
            if (item.hasAttribute("listType")) {
                writer.removeAttribute("listType", item);
                applied = true;
            }
            if (item.hasAttribute("listStyle")) {
                writer.removeAttribute("listStyle", item);
                applied = true;
            }
            if (item.hasAttribute("listReversed")) {
                writer.removeAttribute("listReversed", item);
                applied = true;
            }
            if (item.hasAttribute("listStart")) {
                writer.removeAttribute("listStart", item);
                applied = true;
            }
            for (const innerItem of Array.from(model.createRangeIn(item)).filter((e)=>e.item.is("element", "listItem")))_addListToFix(innerItem.previousPosition);
        }
        _addListToFix(entry.position.getShiftedBy(entry.length));
    } else if (entry.type == "remove" && entry.name == "listItem") _addListToFix(entry.position);
    else if (entry.type == "attribute" && entry.attributeKey == "listIndent") _addListToFix(entry.range.start);
    else if (entry.type == "attribute" && entry.attributeKey == "listType") _addListToFix(entry.range.start);
    for (const listHead of itemToListHead.values()){
        _fixListIndents(listHead);
        _fixListTypes(listHead);
    }
    return applied;
    function _addListToFix(position) {
        const previousNode = position.nodeBefore;
        if (!previousNode || !previousNode.is("element", "listItem")) {
            const item = position.nodeAfter;
            if (item && item.is("element", "listItem")) itemToListHead.set(item, item);
        } else {
            let listHead = previousNode;
            if (itemToListHead.has(listHead)) return;
            for(let previousSibling = listHead.previousSibling; previousSibling && previousSibling.is("element", "listItem"); previousSibling = listHead.previousSibling){
                listHead = previousSibling;
                if (itemToListHead.has(listHead)) return;
            }
            itemToListHead.set(previousNode, listHead);
        }
    }
    function _fixListIndents(item) {
        let maxIndent = 0;
        let fixBy = null;
        while(item && item.is("element", "listItem")){
            const itemIndent = item.getAttribute("listIndent");
            if (itemIndent > maxIndent) {
                let newIndent;
                if (fixBy === null) {
                    fixBy = itemIndent - maxIndent;
                    newIndent = maxIndent;
                } else {
                    if (fixBy > itemIndent) fixBy = itemIndent;
                    newIndent = itemIndent - fixBy;
                }
                writer.setAttribute("listIndent", newIndent, item);
                applied = true;
            } else {
                fixBy = null;
                maxIndent = item.getAttribute("listIndent") + 1;
            }
            item = item.nextSibling;
        }
    }
    function _fixListTypes(item) {
        let typesStack = [];
        let prev = null;
        while(item && item.is("element", "listItem")){
            const itemIndent = item.getAttribute("listIndent");
            if (prev && prev.getAttribute("listIndent") > itemIndent) typesStack = typesStack.slice(0, itemIndent + 1);
            if (itemIndent != 0) {
                if (typesStack[itemIndent]) {
                    const type = typesStack[itemIndent];
                    if (item.getAttribute("listType") != type) {
                        writer.setAttribute("listType", type, item);
                        applied = true;
                    }
                } else typesStack[itemIndent] = item.getAttribute("listType");
            }
            prev = item;
            item = item.nextSibling;
        }
    }
}
/**
* A fixer for pasted content that includes list items.
*
* It fixes indentation of pasted list items so the pasted items match correctly to the context they are pasted into.
*
* Example:
*
* ```xml
* <listItem listType="bulleted" listIndent=0>A</listItem>
* <listItem listType="bulleted" listIndent=1>B^</listItem>
* // At ^ paste:  <listItem listType="bulleted" listIndent=4>X</listItem>
* //              <listItem listType="bulleted" listIndent=5>Y</listItem>
* <listItem listType="bulleted" listIndent=2>C</listItem>
* ```
*
* Should become:
*
* ```xml
* <listItem listType="bulleted" listIndent=0>A</listItem>
* <listItem listType="bulleted" listIndent=1>BX</listItem>
* <listItem listType="bulleted" listIndent=2>Y/listItem>
* <listItem listType="bulleted" listIndent=2>C</listItem>
* ```
*
* @internal
*/ const $ab0101fae4fd036b$var$modelIndentPasteFixer = function(evt, [content, selectable]) {
    const model = this;
    let item = content.is("documentFragment") ? content.getChild(0) : content;
    let selection;
    if (!selectable) selection = model.document.selection;
    else selection = model.createSelection(selectable);
    if (item && item.is("element", "listItem")) {
        const pos = selection.getFirstPosition();
        let refItem = null;
        if (pos.parent.is("element", "listItem")) refItem = pos.parent;
        else if (pos.nodeBefore && pos.nodeBefore.is("element", "listItem")) refItem = pos.nodeBefore;
        if (refItem) {
            const indentChange = refItem.getAttribute("listIndent");
            if (indentChange > 0) while(item && item.is("element", "listItem")){
                item._setAttribute("listIndent", item.getAttribute("listIndent") + indentChange);
                item = item.nextSibling;
            }
        }
    }
};
/**
* Helper function that converts children of a given `<li>` view element into corresponding model elements.
* The function maintains proper order of elements if model `listItem` is split during the conversion
* due to block children conversion.
*
* @param listItemModel List item model element to which converted children will be inserted.
* @param viewChildren View elements which will be converted.
* @param conversionApi Conversion interface to be used by the callback.
* @returns Position on which next elements should be inserted after children conversion.
*/ function $ab0101fae4fd036b$var$viewToModelListItemChildrenConverter(listItemModel, viewChildren, conversionApi) {
    const { writer: writer, schema: schema } = conversionApi;
    let nextPosition = writer.createPositionAfter(listItemModel);
    for (const child of viewChildren)if (child.name == "ul" || child.name == "ol") nextPosition = conversionApi.convertItem(child, nextPosition).modelCursor;
    else {
        const result = conversionApi.convertItem(child, writer.createPositionAt(listItemModel, "end"));
        const convertedChild = result.modelRange.start.nodeAfter;
        if (convertedChild && convertedChild.is("element") && !schema.checkChild(listItemModel, convertedChild.name)) {
            if (result.modelCursor.parent.is("element", "listItem")) listItemModel = result.modelCursor.parent;
            else listItemModel = $ab0101fae4fd036b$var$findNextListItem(result.modelCursor);
            nextPosition = writer.createPositionAfter(listItemModel);
        }
    }
    return nextPosition;
}
/**
* Helper function that seeks for a next list item starting from given `startPosition`.
*/ function $ab0101fae4fd036b$var$findNextListItem(startPosition) {
    const treeWalker = new (0, $b9b9f2bdf9c6137f$export$c24047420d7ab789)({
        startPosition: startPosition
    });
    let value;
    do value = treeWalker.next();
    while (!value.value.item.is("element", "listItem"));
    return value.value.item;
}
/**
* Helper function that takes all children of given `viewRemovedItem` and moves them in a correct place, according
* to other given parameters.
*/ function $ab0101fae4fd036b$var$hoistNestedLists(nextIndent, modelRemoveStartPosition, viewRemoveStartPosition, viewRemovedItem, conversionApi, model) {
    const prevModelItem = $ab0101fae4fd036b$var$getSiblingListItem(modelRemoveStartPosition.nodeBefore, {
        sameIndent: true,
        smallerIndent: true,
        listIndent: nextIndent
    });
    const mapper = conversionApi.mapper;
    const viewWriter = conversionApi.writer;
    const prevIndent = prevModelItem ? prevModelItem.getAttribute("listIndent") : null;
    let insertPosition;
    if (!prevModelItem) insertPosition = viewRemoveStartPosition;
    else if (prevIndent == nextIndent) {
        const prevViewList = mapper.toViewElement(prevModelItem).parent;
        insertPosition = viewWriter.createPositionAfter(prevViewList);
    } else {
        const modelPosition = model.createPositionAt(prevModelItem, "end");
        insertPosition = mapper.toViewPosition(modelPosition);
    }
    insertPosition = $ab0101fae4fd036b$var$positionAfterUiElements(insertPosition);
    for (const child of [
        ...viewRemovedItem.getChildren()
    ])if ($ab0101fae4fd036b$var$isList(child)) {
        insertPosition = viewWriter.move(viewWriter.createRangeOn(child), insertPosition).end;
        $ab0101fae4fd036b$var$mergeViewLists(viewWriter, child, child.nextSibling);
        $ab0101fae4fd036b$var$mergeViewLists(viewWriter, child.previousSibling, child);
    }
}
/**
* Checks if view element is a list type (ul or ol).
*/ function $ab0101fae4fd036b$var$isList(viewElement) {
    return viewElement.is("element", "ol") || viewElement.is("element", "ul");
}
/**
* Calculates the indent value for a list item. Handles HTML compliant and non-compliant lists.
*
* Also, fixes non HTML compliant lists indents:
*
* ```
* before:                                     fixed list:
* OL                                          OL
* |-> LI (parent LIs: 0)                      |-> LI     (indent: 0)
*     |-> OL                                  |-> OL
*         |-> OL                                  |
*         |   |-> OL                              |
*         |       |-> OL                          |
*         |           |-> LI (parent LIs: 1)      |-> LI (indent: 1)
*         |-> LI (parent LIs: 1)                  |-> LI (indent: 1)
*
* before:                                     fixed list:
* OL                                          OL
* |-> OL                                      |
*     |-> OL                                  |
*          |-> OL                             |
*              |-> LI (parent LIs: 0)         |-> LI        (indent: 0)
*
* before:                                     fixed list:
* OL                                          OL
* |-> LI (parent LIs: 0)                      |-> LI         (indent: 0)
* |-> OL                                          |-> OL
*     |-> LI (parent LIs: 0)                          |-> LI (indent: 1)
* ```
*/ function $ab0101fae4fd036b$var$getIndent$1(listItem) {
    let indent = 0;
    let parent = listItem.parent;
    while(parent){
        if (parent.is("element", "li")) indent++;
        else {
            const previousSibling = parent.previousSibling;
            if (previousSibling && previousSibling.is("element", "li")) indent++;
        }
        parent = parent.parent;
    }
    return indent;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylist/legacylistediting
*/ /**
* The engine of the list feature. It handles creating, editing and removing lists and list items.
*
* It registers the `'numberedList'`, `'bulletedList'`, `'indentList'` and `'outdentList'` commands.
*/ var $ab0101fae4fd036b$export$789bc88fac08ff14 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyListEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $c871651c8276dc61$export$64a2c9e77ce3aa7a),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538),
            $ab0101fae4fd036b$export$524231a73a76f974
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: [
                "listType",
                "listIndent"
            ]
        });
        const data = editor.data;
        const editing = editor.editing;
        editor.model.document.registerPostFixer((writer)=>$ab0101fae4fd036b$var$modelChangePostFixer(editor.model, writer));
        editing.mapper.registerViewToModelLength("li", $ab0101fae4fd036b$var$getViewListItemLength);
        data.mapper.registerViewToModelLength("li", $ab0101fae4fd036b$var$getViewListItemLength);
        editing.mapper.on("modelToViewPosition", $ab0101fae4fd036b$var$modelToViewPosition(editing.view));
        editing.mapper.on("viewToModelPosition", $ab0101fae4fd036b$var$viewToModelPosition(editor.model));
        data.mapper.on("modelToViewPosition", $ab0101fae4fd036b$var$modelToViewPosition(editing.view));
        editor.conversion.for("editingDowncast").add((dispatcher)=>{
            dispatcher.on("insert", $ab0101fae4fd036b$var$modelViewSplitOnInsert, {
                priority: "high"
            });
            dispatcher.on("insert:listItem", $ab0101fae4fd036b$var$modelViewInsertion$1(editor.model));
            dispatcher.on("attribute:listType:listItem", $ab0101fae4fd036b$var$modelViewChangeType$1, {
                priority: "high"
            });
            dispatcher.on("attribute:listType:listItem", $ab0101fae4fd036b$var$modelViewMergeAfterChangeType, {
                priority: "low"
            });
            dispatcher.on("attribute:listIndent:listItem", $ab0101fae4fd036b$var$modelViewChangeIndent(editor.model));
            dispatcher.on("remove:listItem", $ab0101fae4fd036b$var$modelViewRemove(editor.model));
            dispatcher.on("remove", $ab0101fae4fd036b$var$modelViewMergeAfter, {
                priority: "low"
            });
        });
        editor.conversion.for("dataDowncast").add((dispatcher)=>{
            dispatcher.on("insert", $ab0101fae4fd036b$var$modelViewSplitOnInsert, {
                priority: "high"
            });
            dispatcher.on("insert:listItem", $ab0101fae4fd036b$var$modelViewInsertion$1(editor.model));
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:ul", $ab0101fae4fd036b$var$cleanList, {
                priority: "high"
            });
            dispatcher.on("element:ol", $ab0101fae4fd036b$var$cleanList, {
                priority: "high"
            });
            dispatcher.on("element:li", $ab0101fae4fd036b$var$cleanListItem, {
                priority: "high"
            });
            dispatcher.on("element:li", $ab0101fae4fd036b$var$viewModelConverter);
        });
        editor.model.on("insertContent", $ab0101fae4fd036b$var$modelIndentPasteFixer, {
            priority: "high"
        });
        editor.commands.add("numberedList", new $ab0101fae4fd036b$export$b0985fe0ab85ecbb(editor, "numbered"));
        editor.commands.add("bulletedList", new $ab0101fae4fd036b$export$b0985fe0ab85ecbb(editor, "bulleted"));
        editor.commands.add("indentList", new $ab0101fae4fd036b$export$e6e2bd367a1e01fb(editor, "forward"));
        editor.commands.add("outdentList", new $ab0101fae4fd036b$export$e6e2bd367a1e01fb(editor, "backward"));
        const viewDocument = editing.view.document;
        this.listenTo(viewDocument, "enter", (evt, data)=>{
            const doc = this.editor.model.document;
            const positionParent = doc.selection.getLastPosition().parent;
            if (doc.selection.isCollapsed && positionParent.name == "listItem" && positionParent.isEmpty) {
                this.editor.execute("outdentList");
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "li"
        });
        this.listenTo(viewDocument, "delete", (evt, data)=>{
            if (data.direction !== "backward") return;
            const selection = this.editor.model.document.selection;
            if (!selection.isCollapsed) return;
            const firstPosition = selection.getFirstPosition();
            if (!firstPosition.isAtStart) return;
            const positionParent = firstPosition.parent;
            if (positionParent.name !== "listItem") return;
            if (positionParent.previousSibling && positionParent.previousSibling.name === "listItem") return;
            this.editor.execute("outdentList");
            data.preventDefault();
            evt.stop();
        }, {
            context: "li"
        });
        this.listenTo(editor.editing.view.document, "tab", (evt, data)=>{
            const commandName = data.shiftKey ? "outdentList" : "indentList";
            if (this.editor.commands.get(commandName).isEnabled) {
                editor.execute(commandName);
                data.stopPropagation();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "li"
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const commands = this.editor.commands;
        const indent = commands.get("indent");
        const outdent = commands.get("outdent");
        if (indent) indent.registerChildCommand(commands.get("indentList"));
        if (outdent) outdent.registerChildCommand(commands.get("outdentList"));
    }
};
function $ab0101fae4fd036b$var$getViewListItemLength(element) {
    let length = 1;
    for (const child of element.getChildren())if (child.name == "ul" || child.name == "ol") for (const item of child.getChildren())length += $ab0101fae4fd036b$var$getViewListItemLength(item);
    return length;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylist
*/ /**
* The legacy list feature.
*
* This is a "glue" plugin that loads the {@link module:list/legacylist/legacylistediting~LegacyListEditing legacy list editing feature}
* and {@link module:list/list/listui~ListUI list UI feature}.
*/ var $ab0101fae4fd036b$export$fa3aeef8647a977c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$789bc88fac08ff14,
            $ab0101fae4fd036b$export$e3443e3fb7ec7350
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyList";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylistproperties/legacyliststylecommand
*/ /**
* The list style command. It changes the `listStyle` attribute of the selected list items.
*
* If the list type (numbered or bulleted) can be inferred from the passed style type,
* the command tries to convert selected items to a list of that type.
* It is used by the {@link module:list/legacylistproperties~LegacyListProperties legacy list properties feature}.
*/ var $ab0101fae4fd036b$export$cb91c1a875d9f992 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The default type of the list style.
	*/ defaultType;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param defaultType The list type that will be used by default if the value was not specified during
	* the command execution.
	*/ constructor(editor, defaultType){
        super(editor);
        this.defaultType = defaultType;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.type The type of the list style, e.g. `'disc'` or `'square'`. If `null` is specified, the default
	* style will be applied.
	*/ execute(options = {}) {
        this._tryToConvertItemsToList(options);
        const model = this.editor.model;
        const listItems = $ab0101fae4fd036b$var$getSelectedListItems(model);
        if (!listItems.length) return;
        model.change((writer)=>{
            for (const item of listItems)writer.setAttribute("listStyle", options.type || this.defaultType, item);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const listItem = this.editor.model.document.selection.getFirstPosition().parent;
        if (listItem && listItem.is("element", "listItem")) return listItem.getAttribute("listStyle");
        return null;
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        const editor = this.editor;
        const numberedList = editor.commands.get("numberedList");
        const bulletedList = editor.commands.get("bulletedList");
        return numberedList.isEnabled || bulletedList.isEnabled;
    }
    /**
	* Checks if the provided list style is valid. Also changes the selection to a list if it's not set yet.
	*
	* @param options Additional options.
	* @param options.type The type of the list style. If `null` is specified, the function does nothing.
	*/ _tryToConvertItemsToList(options) {
        if (!options.type) return;
        const listType = $ab0101fae4fd036b$var$getListTypeFromListStyleType$1(options.type);
        /* istanbul ignore next -- @preserve */ if (!listType) return;
        const editor = this.editor;
        const commandName = `${listType}List`;
        if (!editor.commands.get(commandName).value) editor.execute(commandName);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylistproperties/legacylistreversedcommand
*/ /**
* The reversed list command. It changes the `listReversed` attribute of the selected list items. As a result, the list order will be
* reversed.
* It is used by the {@link module:list/legacylistproperties~LegacyListProperties legacy list properties feature}.
*/ var $ab0101fae4fd036b$export$3c3f7d0a08f82f89 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const value = this._getValue();
        this.value = value;
        this.isEnabled = value != null;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.reversed Whether the list should be reversed.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const listItems = $ab0101fae4fd036b$var$getSelectedListItems(model).filter((item)=>item.getAttribute("listType") == "numbered");
        model.change((writer)=>{
            for (const item of listItems)writer.setAttribute("listReversed", !!options.reversed, item);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const listItem = this.editor.model.document.selection.getFirstPosition().parent;
        if (listItem && listItem.is("element", "listItem") && listItem.getAttribute("listType") == "numbered") return listItem.getAttribute("listReversed");
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylistproperties/legacyliststartcommand
*/ /**
* The list start index command. It changes the `listStart` attribute of the selected list items.
* It is used by the {@link module:list/legacylistproperties~LegacyListProperties legacy list properties feature}.
*/ var $ab0101fae4fd036b$export$61e05286ace22dca = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const value = this._getValue();
        this.value = value;
        this.isEnabled = value != null;
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Execute options.
	* @param options.startIndex The list start index.
	*/ execute({ startIndex: startIndex = 1 } = {}) {
        const model = this.editor.model;
        const listItems = $ab0101fae4fd036b$var$getSelectedListItems(model).filter((item)=>item.getAttribute("listType") == "numbered");
        model.change((writer)=>{
            for (const item of listItems)writer.setAttribute("listStart", startIndex >= 0 ? startIndex : 1, item);
        });
    }
    /**
	* Checks the command's {@link #value}.
	*
	* @returns The current value.
	*/ _getValue() {
        const listItem = this.editor.model.document.selection.getFirstPosition().parent;
        if (listItem && listItem.is("element", "listItem") && listItem.getAttribute("listType") == "numbered") return listItem.getAttribute("listStart");
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylistproperties/legacylistpropertiesediting
*/ const $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE = "default";
/**
* The engine of the list properties feature.
*
* It sets the value for the `listItem` attribute of the {@link module:list/legacylist~LegacyList `<listItem>`} element that
* allows modifying the list style type.
*
* It registers the `'listStyle'`, `'listReversed'` and `'listStart'` commands if they are enabled in the configuration.
* Read more in {@link module:list/listconfig~ListPropertiesConfig}.
*/ var $ab0101fae4fd036b$export$24fff2df026750ad = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$789bc88fac08ff14
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyListPropertiesEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("list", {
            properties: {
                styles: true,
                startIndex: false,
                reversed: false
            }
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const strategies = $ab0101fae4fd036b$var$createAttributeStrategies(editor.config.get("list.properties"));
        model.schema.extend("listItem", {
            allowAttributes: strategies.map((s)=>s.attributeName)
        });
        for (const strategy of strategies)strategy.addCommand(editor);
        this.listenTo(editor.commands.get("indentList"), "_executeCleanup", $ab0101fae4fd036b$var$fixListAfterIndentListCommand(editor, strategies));
        this.listenTo(editor.commands.get("outdentList"), "_executeCleanup", $ab0101fae4fd036b$var$fixListAfterOutdentListCommand(editor, strategies));
        this.listenTo(editor.commands.get("bulletedList"), "_executeCleanup", $ab0101fae4fd036b$var$restoreDefaultListStyle(editor));
        this.listenTo(editor.commands.get("numberedList"), "_executeCleanup", $ab0101fae4fd036b$var$restoreDefaultListStyle(editor));
        model.document.registerPostFixer($ab0101fae4fd036b$var$fixListAttributesOnListItemElements(editor, strategies));
        editor.conversion.for("upcast").add($ab0101fae4fd036b$var$upcastListItemAttributes(strategies));
        editor.conversion.for("downcast").add($ab0101fae4fd036b$var$downcastListItemAttributes(strategies));
        this._mergeListAttributesWhileMergingLists(strategies);
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        if (editor.commands.get("todoList")) editor.model.document.registerPostFixer($ab0101fae4fd036b$var$removeListItemAttributesFromTodoList(editor));
    }
    /**
	* Starts listening to {@link module:engine/model/model~Model#deleteContent} and checks whether two lists will be merged into a single
	* one after deleting the content.
	*
	* The purpose of this action is to adjust the `listStyle`, `listReversed` and `listStart` values
	* for the list that was merged.
	*
	* Consider the following model's content:
	*
	* ```xml
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 1</listItem>
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 2</listItem>
	* <paragraph>[A paragraph.]</paragraph>
	* <listItem listIndent="0" listType="bulleted" listStyle="circle">UL List item 1</listItem>
	* <listItem listIndent="0" listType="bulleted" listStyle="circle">UL List item 2</listItem>
	* ```
	*
	* After removing the paragraph element, the second list will be merged into the first one.
	* We want to inherit the `listStyle` attribute for the second list from the first one.
	*
	* ```xml
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 1</listItem>
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 2</listItem>
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 1</listItem>
	* <listItem listIndent="0" listType="bulleted" listStyle="square">UL List item 2</listItem>
	* ```
	*
	* See https://github.com/ckeditor/ckeditor5/issues/7879.
	*
	* @param attributeStrategies Strategies for the enabled attributes.
	*/ _mergeListAttributesWhileMergingLists(attributeStrategies) {
        const model = this.editor.model;
        let firstMostOuterItem;
        this.listenTo(model, "deleteContent", (evt, [selection])=>{
            const firstPosition = selection.getFirstPosition();
            const lastPosition = selection.getLastPosition();
            if (firstPosition.parent === lastPosition.parent) return;
            if (!firstPosition.parent.is("element", "listItem")) return;
            const nextSibling = lastPosition.parent.nextSibling;
            if (!nextSibling || !nextSibling.is("element", "listItem")) return;
            const mostOuterItemList = $ab0101fae4fd036b$var$getSiblingListItem(firstPosition.parent, {
                sameIndent: true,
                listIndent: nextSibling.getAttribute("listIndent")
            });
            if (!mostOuterItemList) return;
            if (mostOuterItemList.getAttribute("listType") === nextSibling.getAttribute("listType")) firstMostOuterItem = mostOuterItemList;
        }, {
            priority: "high"
        });
        this.listenTo(model, "deleteContent", ()=>{
            if (!firstMostOuterItem) return;
            model.change((writer)=>{
                const secondListMostOuterItem = $ab0101fae4fd036b$var$getSiblingListItem(firstMostOuterItem.nextSibling, {
                    sameIndent: true,
                    listIndent: firstMostOuterItem.getAttribute("listIndent"),
                    direction: "forward"
                });
                if (!secondListMostOuterItem) {
                    firstMostOuterItem = null;
                    return;
                }
                const items = [
                    secondListMostOuterItem,
                    ...$ab0101fae4fd036b$var$getSiblingNodes(writer.createPositionAt(secondListMostOuterItem, 0), "forward")
                ];
                for (const listItem of items)for (const strategy of attributeStrategies)if (strategy.appliesToListItem(listItem)) {
                    const attributeName = strategy.attributeName;
                    const value = firstMostOuterItem.getAttribute(attributeName);
                    writer.setAttribute(attributeName, value, listItem);
                }
            });
            firstMostOuterItem = null;
        }, {
            priority: "low"
        });
    }
};
/**
* Creates an array of strategies for dealing with enabled listItem attributes.
*/ function $ab0101fae4fd036b$var$createAttributeStrategies(enabledProperties) {
    const strategies = [];
    if (enabledProperties.styles) strategies.push({
        attributeName: "listStyle",
        defaultValue: $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE,
        addCommand (editor) {
            editor.commands.add("listStyle", new $ab0101fae4fd036b$export$cb91c1a875d9f992(editor, $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE));
        },
        appliesToListItem () {
            return true;
        },
        setAttributeOnDowncast (writer, listStyle, element) {
            if (listStyle && listStyle !== $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE) writer.setStyle("list-style-type", listStyle, element);
            else writer.removeStyle("list-style-type", element);
        },
        getAttributeOnUpcast (listParent) {
            return $ab0101fae4fd036b$export$3cff595a549af8ba(listParent.getStyle("list-style-type")) || $ab0101fae4fd036b$var$DEFAULT_LIST_TYPE;
        }
    });
    if (enabledProperties.reversed) strategies.push({
        attributeName: "listReversed",
        defaultValue: false,
        addCommand (editor) {
            editor.commands.add("listReversed", new $ab0101fae4fd036b$export$3c3f7d0a08f82f89(editor));
        },
        appliesToListItem (item) {
            return item.getAttribute("listType") == "numbered";
        },
        setAttributeOnDowncast (writer, listReversed, element) {
            if (listReversed) writer.setAttribute("reversed", "reversed", element);
            else writer.removeAttribute("reversed", element);
        },
        getAttributeOnUpcast (listParent) {
            return listParent.hasAttribute("reversed");
        }
    });
    if (enabledProperties.startIndex) strategies.push({
        attributeName: "listStart",
        defaultValue: 1,
        addCommand (editor) {
            editor.commands.add("listStart", new $ab0101fae4fd036b$export$61e05286ace22dca(editor));
        },
        appliesToListItem (item) {
            return item.getAttribute("listType") == "numbered";
        },
        setAttributeOnDowncast (writer, listStart, element) {
            if (listStart == 0 || listStart > 1) writer.setAttribute("start", listStart, element);
            else writer.removeAttribute("start", element);
        },
        getAttributeOnUpcast (listParent) {
            const startAttributeValue = listParent.getAttribute("start");
            return startAttributeValue >= 0 ? startAttributeValue : 1;
        }
    });
    return strategies;
}
/**
* Returns a converter consumes the `style`, `reversed` and `start` attribute.
* In `style` it searches for the `list-style-type` definition.
* If not found, the `"default"` value will be used.
*/ function $ab0101fae4fd036b$var$upcastListItemAttributes(attributeStrategies) {
    return (dispatcher)=>{
        dispatcher.on("element:li", (evt, data, conversionApi)=>{
            if (!data.modelRange) return;
            const listParent = data.viewItem.parent;
            const listItem = data.modelRange.start.nodeAfter || data.modelRange.end.nodeBefore;
            for (const strategy of attributeStrategies)if (strategy.appliesToListItem(listItem)) {
                const listStyle = strategy.getAttributeOnUpcast(listParent);
                conversionApi.writer.setAttribute(strategy.attributeName, listStyle, listItem);
            }
        }, {
            priority: "low"
        });
    };
}
/**
* Returns a converter that adds `reversed`, `start` attributes and adds `list-style-type` definition as a value for the `style` attribute.
* The `"default"` values are removed and not present in the view/data.
*/ function $ab0101fae4fd036b$var$downcastListItemAttributes(attributeStrategies) {
    return (dispatcher)=>{
        for (const strategy of attributeStrategies)dispatcher.on(`attribute:${strategy.attributeName}:listItem`, (evt, data, conversionApi)=>{
            const viewWriter = conversionApi.writer;
            const currentElement = data.item;
            const previousElement = $ab0101fae4fd036b$var$getSiblingListItem(currentElement.previousSibling, {
                sameIndent: true,
                listIndent: currentElement.getAttribute("listIndent"),
                direction: "backward"
            });
            const viewItem = conversionApi.mapper.toViewElement(currentElement);
            if (!areRepresentingSameList(currentElement, previousElement)) viewWriter.breakContainer(viewWriter.createPositionBefore(viewItem));
            strategy.setAttributeOnDowncast(viewWriter, data.attributeNewValue, viewItem.parent);
        }, {
            priority: "low"
        });
    };
    /**
	* Checks whether specified list items belong to the same list.
	*/ function areRepresentingSameList(listItem1, listItem2) {
        return listItem2 && listItem1.getAttribute("listType") === listItem2.getAttribute("listType") && listItem1.getAttribute("listIndent") === listItem2.getAttribute("listIndent") && listItem1.getAttribute("listStyle") === listItem2.getAttribute("listStyle") && listItem1.getAttribute("listReversed") === listItem2.getAttribute("listReversed") && listItem1.getAttribute("listStart") === listItem2.getAttribute("listStart");
    }
}
/**
* When indenting list, nested list should clear its value for the attributes or inherit from nested lists.
*
* ■ List item 1.
* ■ List item 2.[]
* ■ List item 3.
* editor.execute( 'indentList' );
*
* ■ List item 1.
*     ○ List item 2.[]
* ■ List item 3.
*/ function $ab0101fae4fd036b$var$fixListAfterIndentListCommand(editor, attributeStrategies) {
    return (evt, changedItems)=>{
        const root = changedItems[0];
        const rootIndent = root.getAttribute("listIndent");
        const itemsToUpdate = changedItems.filter((item)=>item.getAttribute("listIndent") === rootIndent);
        let previousSibling = null;
        if (root.previousSibling.getAttribute("listIndent") + 1 !== rootIndent) previousSibling = $ab0101fae4fd036b$var$getSiblingListItem(root.previousSibling, {
            sameIndent: true,
            direction: "backward",
            listIndent: rootIndent
        });
        editor.model.change((writer)=>{
            for (const item of itemsToUpdate)for (const strategy of attributeStrategies)if (strategy.appliesToListItem(item)) {
                const valueToSet = previousSibling == null ? strategy.defaultValue : previousSibling.getAttribute(strategy.attributeName);
                writer.setAttribute(strategy.attributeName, valueToSet, item);
            }
        });
    };
}
/**
* When outdenting a list, a nested list should copy attribute values
* from the previous sibling list item including the same value for the `listIndent` value.
*
* ■ List item 1.
*     ○ List item 2.[]
* ■ List item 3.
*
* editor.execute( 'outdentList' );
*
* ■ List item 1.
* ■ List item 2.[]
* ■ List item 3.
*/ function $ab0101fae4fd036b$var$fixListAfterOutdentListCommand(editor, attributeStrategies) {
    return (evt, changedItems)=>{
        changedItems = changedItems.reverse().filter((item)=>item.is("element", "listItem"));
        if (!changedItems.length) return;
        const indent = changedItems[0].getAttribute("listIndent");
        const listType = changedItems[0].getAttribute("listType");
        let listItem = changedItems[0].previousSibling;
        if (listItem.is("element", "listItem")) while(listItem.getAttribute("listIndent") !== indent)listItem = listItem.previousSibling;
        else listItem = null;
        if (!listItem) listItem = changedItems[changedItems.length - 1].nextSibling;
        if (!listItem || !listItem.is("element", "listItem")) return;
        if (listItem.getAttribute("listType") !== listType) return;
        editor.model.change((writer)=>{
            const itemsToUpdate = changedItems.filter((item)=>item.getAttribute("listIndent") === indent);
            for (const item of itemsToUpdate)for (const strategy of attributeStrategies)if (strategy.appliesToListItem(item)) {
                const attributeName = strategy.attributeName;
                const valueToSet = listItem.getAttribute(attributeName);
                writer.setAttribute(attributeName, valueToSet, item);
            }
        });
    };
}
/**
* Each `listItem` element must have specified the `listStyle`, `listReversed` and `listStart` attributes
* if they are enabled and supported by its `listType`.
* This post-fixer checks whether inserted elements `listItem` elements should inherit the attribute values from
* their sibling nodes or should use the default values.
*
* Paragraph[]
* ■ List item 1. // [listStyle="square", listType="bulleted"]
* ■ List item 2. // ...
* ■ List item 3. // ...
*
* editor.execute( 'bulletedList' )
*
* ■ Paragraph[]  // [listStyle="square", listType="bulleted"]
* ■ List item 1. // [listStyle="square", listType="bulleted"]
* ■ List item 2.
* ■ List item 3.
*
* It also covers a such change:
*
* [Paragraph 1
* Paragraph 2]
* ■ List item 1. // [listStyle="square", listType="bulleted"]
* ■ List item 2. // ...
* ■ List item 3. // ...
*
* editor.execute( 'numberedList' )
*
* 1. [Paragraph 1 // [listStyle="default", listType="numbered"]
* 2. Paragraph 2] // [listStyle="default", listType="numbered"]
* ■ List item 1.  // [listStyle="square", listType="bulleted"]
* ■ List item 2.  // ...
* ■ List item 3.  // ...
*/ function $ab0101fae4fd036b$var$fixListAttributesOnListItemElements(editor, attributeStrategies) {
    return (writer)=>{
        let wasFixed = false;
        const insertedListItems = $ab0101fae4fd036b$var$getChangedListItems(editor.model.document.differ.getChanges()).filter((item)=>{
            return item.getAttribute("listType") !== "todo";
        });
        if (!insertedListItems.length) return wasFixed;
        let existingListItem = insertedListItems[insertedListItems.length - 1].nextSibling;
        if (!existingListItem || !existingListItem.is("element", "listItem")) {
            existingListItem = insertedListItems[0].previousSibling;
            if (existingListItem) {
                const indent = insertedListItems[0].getAttribute("listIndent");
                while(existingListItem.is("element", "listItem") && existingListItem.getAttribute("listIndent") !== indent){
                    existingListItem = existingListItem.previousSibling;
                    if (!existingListItem) break;
                }
            }
        }
        for (const strategy of attributeStrategies){
            const attributeName = strategy.attributeName;
            for (const item of insertedListItems){
                if (!strategy.appliesToListItem(item)) {
                    writer.removeAttribute(attributeName, item);
                    continue;
                }
                if (!item.hasAttribute(attributeName)) {
                    if ($ab0101fae4fd036b$var$shouldInheritListType(existingListItem, item, strategy)) writer.setAttribute(attributeName, existingListItem.getAttribute(attributeName), item);
                    else writer.setAttribute(attributeName, strategy.defaultValue, item);
                    wasFixed = true;
                } else {
                    const previousSibling = item.previousSibling;
                    if ($ab0101fae4fd036b$var$shouldInheritListTypeFromPreviousItem(previousSibling, item, strategy.attributeName)) {
                        writer.setAttribute(attributeName, previousSibling.getAttribute(attributeName), item);
                        wasFixed = true;
                    }
                }
            }
        }
        return wasFixed;
    };
}
/**
* Checks whether the `listStyle`, `listReversed` and `listStart` attributes
* should be copied from the `baseItem` element.
*
* The attribute should be copied if the inserted element does not have defined it and
* the value for the element is other than default in the base element.
*/ function $ab0101fae4fd036b$var$shouldInheritListType(baseItem, itemToChange, attributeStrategy) {
    if (!baseItem) return false;
    const baseListAttribute = baseItem.getAttribute(attributeStrategy.attributeName);
    if (!baseListAttribute) return false;
    if (baseListAttribute == attributeStrategy.defaultValue) return false;
    if (baseItem.getAttribute("listType") !== itemToChange.getAttribute("listType")) return false;
    return true;
}
/**
* Checks whether the `listStyle`, `listReversed` and `listStart` attributes
* should be copied from previous list item.
*
* The attribute should be copied if there's a mismatch of styles of the pasted list into a nested list.
* Top-level lists are not normalized as we allow side-by-side list of different types.
*/ function $ab0101fae4fd036b$var$shouldInheritListTypeFromPreviousItem(previousItem, itemToChange, attributeName) {
    if (!previousItem || !previousItem.is("element", "listItem")) return false;
    if (itemToChange.getAttribute("listType") !== previousItem.getAttribute("listType")) return false;
    const previousItemIndent = previousItem.getAttribute("listIndent");
    if (previousItemIndent < 1 || previousItemIndent !== itemToChange.getAttribute("listIndent")) return false;
    const previousItemListAttribute = previousItem.getAttribute(attributeName);
    if (!previousItemListAttribute || previousItemListAttribute === itemToChange.getAttribute(attributeName)) return false;
    return true;
}
/**
* Removes the `listStyle`, `listReversed` and `listStart` attributes from "todo" list items.
*/ function $ab0101fae4fd036b$var$removeListItemAttributesFromTodoList(editor) {
    return (writer)=>{
        const todoListItems = $ab0101fae4fd036b$var$getChangedListItems(editor.model.document.differ.getChanges()).filter((item)=>{
            return item.getAttribute("listType") === "todo" && (item.hasAttribute("listStyle") || item.hasAttribute("listReversed") || item.hasAttribute("listStart"));
        });
        if (!todoListItems.length) return false;
        for (const item of todoListItems){
            writer.removeAttribute("listStyle", item);
            writer.removeAttribute("listReversed", item);
            writer.removeAttribute("listStart", item);
        }
        return true;
    };
}
/**
* Restores the `listStyle` attribute after changing the list type.
*/ function $ab0101fae4fd036b$var$restoreDefaultListStyle(editor) {
    return (evt, changedItems)=>{
        changedItems = changedItems.filter((item)=>item.is("element", "listItem"));
        editor.model.change((writer)=>{
            for (const item of changedItems)writer.removeAttribute("listStyle", item);
        });
    };
}
/**
* Returns the `listItem` that was inserted or changed.
*
* @param changes The changes list returned by the differ.
*/ function $ab0101fae4fd036b$var$getChangedListItems(changes) {
    const items = [];
    for (const change of changes){
        const item = $ab0101fae4fd036b$var$getItemFromChange(change);
        if (item && item.is("element", "listItem")) items.push(item);
    }
    return items;
}
function $ab0101fae4fd036b$var$getItemFromChange(change) {
    if (change.type === "attribute") return change.range.start.nodeAfter;
    if (change.type === "insert") return change.position.nodeAfter;
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacylistproperties
*/ /**
* The legacy list properties feature.
*
* This is a "glue" plugin that loads the {@link module:list/legacylistproperties/legacylistpropertiesediting~LegacyListPropertiesEditing
* legacy list properties editing feature} and the
* {@link module:list/listproperties/listpropertiesui~ListPropertiesUI list properties UI feature}.
*/ var $ab0101fae4fd036b$export$d8829e2fa15d408d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$24fff2df026750ad,
            $ab0101fae4fd036b$export$ad7529ae09e99074
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyListProperties";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacytodolist/legacychecktodolistcommand
*/ const $ab0101fae4fd036b$var$attributeKey = "todoListChecked";
/**
* The check to-do command.
*
* The command is registered by the {@link module:list/legacytodolist/legacytodolistediting~LegacyTodoListEditing} as
* the `checkTodoList` editor command and it is also available via aliased `todoListCheck` name.
*/ var $ab0101fae4fd036b$export$8c4497b463a13fcf = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* A list of to-do list items selected by the {@link module:engine/model/selection~ModelSelection}.
	*
	* @internal
	*/ _selectedElements;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._selectedElements = [];
        this.on("execute", ()=>{
            this.refresh();
        }, {
            priority: "highest"
        });
    }
    /**
	* Updates the command's {@link #value} and {@link #isEnabled} properties based on the current selection.
	*/ refresh() {
        this._selectedElements = this._getSelectedItems();
        this.value = this._selectedElements.every((element)=>!!element.getAttribute($ab0101fae4fd036b$var$attributeKey));
        this.isEnabled = !!this._selectedElements.length;
    }
    /**
	* Gets all to-do list items selected by the {@link module:engine/model/selection~ModelSelection}.
	*/ _getSelectedItems() {
        const model = this.editor.model;
        const schema = model.schema;
        const selectionRange = model.document.selection.getFirstRange();
        const startElement = selectionRange.start.parent;
        const elements = [];
        if (schema.checkAttribute(startElement, $ab0101fae4fd036b$var$attributeKey)) elements.push(startElement);
        for (const item of selectionRange.getItems())if (schema.checkAttribute(item, $ab0101fae4fd036b$var$attributeKey) && !elements.includes(item)) elements.push(item);
        return elements;
    }
    /**
	* Executes the command.
	*
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply
	* the attribute. Otherwise, the command will remove the attribute. If not set, the command will look for its current
	* value to decide what it should do.
	*/ execute(options = {}) {
        this.editor.model.change((writer)=>{
            for (const element of this._selectedElements)if (options.forceValue === void 0 ? !this.value : options.forceValue) writer.setAttribute($ab0101fae4fd036b$var$attributeKey, true, element);
            else writer.removeAttribute($ab0101fae4fd036b$var$attributeKey, element);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A model-to-view converter for the `listItem` model element insertion.
*
* It converts the `listItem` model element to an unordered list with a {@link module:engine/view/uielement~ViewUIElement checkbox element}
* at the beginning of each list item. It also merges the list with surrounding lists (if available).
*
* It is used by {@link module:engine/controller/editingcontroller~EditingController}.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert
* @param model Model instance.
* @param onCheckboxChecked Callback function.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$modelViewInsertion(model, onCheckboxChecked) {
    return (evt, data, conversionApi)=>{
        const consumable = conversionApi.consumable;
        if (!consumable.test(data.item, "insert") || !consumable.test(data.item, "attribute:listType") || !consumable.test(data.item, "attribute:listIndent")) return;
        if (data.item.getAttribute("listType") != "todo") return;
        const modelItem = data.item;
        consumable.consume(modelItem, "insert");
        consumable.consume(modelItem, "attribute:listType");
        consumable.consume(modelItem, "attribute:listIndent");
        consumable.consume(modelItem, "attribute:todoListChecked");
        const viewWriter = conversionApi.writer;
        const viewItem = $ab0101fae4fd036b$var$generateLiInUl(modelItem, conversionApi);
        const checkmarkElement = $ab0101fae4fd036b$var$createCheckmarkElement(modelItem, viewWriter, !!modelItem.getAttribute("todoListChecked"), onCheckboxChecked);
        const span = viewWriter.createContainerElement("span", {
            class: "todo-list__label__description"
        });
        viewWriter.addClass("todo-list", viewItem.parent);
        viewWriter.insert(viewWriter.createPositionAt(viewItem, 0), checkmarkElement);
        viewWriter.insert(viewWriter.createPositionAfter(checkmarkElement), span);
        $ab0101fae4fd036b$var$injectViewList(modelItem, viewItem, conversionApi, model);
    };
}
/**
* A model-to-view converter for the `listItem` model element insertion.
*
* It is used by {@link module:engine/controller/datacontroller~DataController}.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:insert
* @param model Model instance.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$dataModelViewInsertion(model) {
    return (evt, data, conversionApi)=>{
        const consumable = conversionApi.consumable;
        if (!consumable.test(data.item, "insert") || !consumable.test(data.item, "attribute:listType") || !consumable.test(data.item, "attribute:listIndent")) return;
        if (data.item.getAttribute("listType") != "todo") return;
        const modelItem = data.item;
        consumable.consume(modelItem, "insert");
        consumable.consume(modelItem, "attribute:listType");
        consumable.consume(modelItem, "attribute:listIndent");
        consumable.consume(modelItem, "attribute:todoListChecked");
        const viewWriter = conversionApi.writer;
        const viewItem = $ab0101fae4fd036b$var$generateLiInUl(modelItem, conversionApi);
        viewWriter.addClass("todo-list", viewItem.parent);
        const label = viewWriter.createContainerElement("label", {
            class: "todo-list__label"
        });
        const checkbox = viewWriter.createEmptyElement("input", {
            type: "checkbox",
            disabled: "disabled"
        });
        const span = viewWriter.createContainerElement("span", {
            class: "todo-list__label__description"
        });
        if (modelItem.getAttribute("todoListChecked")) viewWriter.setAttribute("checked", "checked", checkbox);
        viewWriter.insert(viewWriter.createPositionAt(viewItem, 0), label);
        viewWriter.insert(viewWriter.createPositionAt(label, 0), checkbox);
        viewWriter.insert(viewWriter.createPositionAfter(checkbox), span);
        $ab0101fae4fd036b$var$injectViewList(modelItem, viewItem, conversionApi, model);
    };
}
/**
* A view-to-model converter for the checkbox element inside a view list item.
*
* It changes the `listType` of the model `listItem` to a `todo` value.
* When a view checkbox element is marked as checked, an additional `todoListChecked="true"` attribute is added to the model item.
*
* It is used by {@link module:engine/controller/datacontroller~DataController}.
*
* @internal
* @see module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element
*/ const $ab0101fae4fd036b$var$dataViewModelCheckmarkInsertion = (evt, data, conversionApi)=>{
    const modelCursor = data.modelCursor;
    const modelItem = modelCursor.parent;
    const viewItem = data.viewItem;
    if (viewItem.getAttribute("type") != "checkbox" || modelItem.name != "listItem" || !modelCursor.isAtStart) return;
    if (!conversionApi.consumable.consume(viewItem, {
        name: true
    })) return;
    const writer = conversionApi.writer;
    writer.setAttribute("listType", "todo", modelItem);
    if (data.viewItem.hasAttribute("checked")) writer.setAttribute("todoListChecked", true, modelItem);
    data.modelRange = writer.createRange(modelCursor);
};
/**
* A model-to-view converter for the `listType` attribute change on the `listItem` model element.
*
* This change means that the `<li>` element parent changes to `<ul class="todo-list">` and a
* {@link module:engine/view/uielement~ViewUIElement checkbox UI element} is added at the beginning
* of the list item element (or vice versa).
*
* This converter is preceded by {@link module:list/legacylist/legacyconverters~modelViewChangeType} and followed by
* {@link module:list/legacylist/legacyconverters~modelViewMergeAfterChangeType} to handle splitting and merging surrounding lists
* of the same type.
*
* It is used by {@link module:engine/controller/editingcontroller~EditingController}.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute
* @param onCheckedChange Callback fired after clicking the checkbox UI element.
* @param view Editing view controller.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$modelViewChangeType(onCheckedChange, view) {
    return (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const viewItem = conversionApi.mapper.toViewElement(data.item);
        const viewWriter = conversionApi.writer;
        const labelElement = $ab0101fae4fd036b$var$findLabel(viewItem, view);
        if (data.attributeNewValue == "todo") {
            const isChecked = !!data.item.getAttribute("todoListChecked");
            const checkmarkElement = $ab0101fae4fd036b$var$createCheckmarkElement(data.item, viewWriter, isChecked, onCheckedChange);
            const span = viewWriter.createContainerElement("span", {
                class: "todo-list__label__description"
            });
            const itemRange = viewWriter.createRangeIn(viewItem);
            const nestedList = $ab0101fae4fd036b$var$findNestedList(viewItem);
            const descriptionStart = $ab0101fae4fd036b$var$positionAfterUiElements(itemRange.start);
            const descriptionEnd = nestedList ? viewWriter.createPositionBefore(nestedList) : itemRange.end;
            const descriptionRange = viewWriter.createRange(descriptionStart, descriptionEnd);
            viewWriter.addClass("todo-list", viewItem.parent);
            viewWriter.move(descriptionRange, viewWriter.createPositionAt(span, 0));
            viewWriter.insert(viewWriter.createPositionAt(viewItem, 0), checkmarkElement);
            viewWriter.insert(viewWriter.createPositionAfter(checkmarkElement), span);
        } else if (data.attributeOldValue == "todo") {
            const descriptionSpan = $ab0101fae4fd036b$var$findDescription(viewItem, view);
            viewWriter.removeClass("todo-list", viewItem.parent);
            viewWriter.remove(labelElement);
            viewWriter.move(viewWriter.createRangeIn(descriptionSpan), viewWriter.createPositionBefore(descriptionSpan));
            viewWriter.remove(descriptionSpan);
        }
    };
}
/**
* A model-to-view converter for the `todoListChecked` attribute change on the `listItem` model element.
*
* It marks the {@link module:engine/view/uielement~ViewUIElement checkbox UI element} as checked.
*
* It is used by {@link module:engine/controller/editingcontroller~EditingController}.
*
* @internal
* @see module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:attribute
* @param onCheckedChange Callback fired after clicking the checkbox UI element.
* @returns Returns a conversion callback.
*/ function $ab0101fae4fd036b$var$modelViewChangeChecked(onCheckedChange) {
    return (evt, data, conversionApi)=>{
        if (data.item.getAttribute("listType") != "todo") return;
        if (!conversionApi.consumable.consume(data.item, "attribute:todoListChecked")) return;
        const { mapper: mapper, writer: viewWriter } = conversionApi;
        const isChecked = !!data.item.getAttribute("todoListChecked");
        const oldCheckmarkElement = mapper.toViewElement(data.item).getChild(0);
        const newCheckmarkElement = $ab0101fae4fd036b$var$createCheckmarkElement(data.item, viewWriter, isChecked, onCheckedChange);
        viewWriter.insert(viewWriter.createPositionAfter(oldCheckmarkElement), newCheckmarkElement);
        viewWriter.remove(oldCheckmarkElement);
    };
}
/**
* A model-to-view position at zero offset mapper.
*
* This helper ensures that position inside todo-list in the view is mapped after the checkbox.
*
* It only handles the position at the beginning of a list item as other positions are properly mapped be the default mapper.
*
* @internal
*/ function $ab0101fae4fd036b$var$mapModelToViewPosition(view) {
    return (evt, data)=>{
        const modelPosition = data.modelPosition;
        const parent = modelPosition.parent;
        if (!parent.is("element", "listItem") || parent.getAttribute("listType") != "todo") return;
        const descSpan = $ab0101fae4fd036b$var$findDescription(data.mapper.toViewElement(parent), view);
        if (descSpan) data.viewPosition = data.mapper.findPositionIn(descSpan, modelPosition.offset);
    };
}
/**
* Creates a checkbox UI element.
*/ function $ab0101fae4fd036b$var$createCheckmarkElement(modelItem, viewWriter, isChecked, onChange) {
    return viewWriter.createUIElement("label", {
        class: "todo-list__label",
        contenteditable: false
    }, function(domDocument) {
        const checkbox = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(document, "input", {
            type: "checkbox",
            tabindex: "-1"
        });
        if (isChecked) checkbox.setAttribute("checked", "checked");
        checkbox.addEventListener("change", ()=>onChange(modelItem));
        const domElement = this.toDomElement(domDocument);
        domElement.appendChild(checkbox);
        return domElement;
    });
}
function $ab0101fae4fd036b$var$findLabel(viewItem, view) {
    const range = view.createRangeIn(viewItem);
    for (const value of range)if (value.item.is("uiElement", "label")) return value.item;
}
function $ab0101fae4fd036b$var$findDescription(viewItem, view) {
    const range = view.createRangeIn(viewItem);
    for (const value of range)if (value.item.is("containerElement", "span") && value.item.hasClass("todo-list__label__description")) return value.item;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $ab0101fae4fd036b$var$ITEM_TOGGLE_KEYSTROKE = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$970afd9da919f686)("Ctrl+Enter");
/**
* The engine of the to-do list feature. It handles creating, editing and removing to-do lists and their items.
*
* It registers the entire functionality of the {@link module:list/legacylist/legacylistediting~LegacyListEditing legacy list editing
* plugin} and extends it with the commands:
*
* - `'todoList'`,
* - `'checkTodoList'`,
* - `'todoListCheck'` as an alias for `checkTodoList` command.
*/ var $ab0101fae4fd036b$export$82ad92bb8b026354 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyTodoListEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$789bc88fac08ff14
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const { editing: editing, data: data, model: model } = editor;
        model.schema.extend("listItem", {
            allowAttributes: [
                "todoListChecked"
            ]
        });
        model.schema.addAttributeCheck((context, attributeName)=>{
            const item = context.last;
            if (attributeName == "todoListChecked" && item.name == "listItem" && item.getAttribute("listType") != "todo") return false;
        });
        editor.commands.add("todoList", new $ab0101fae4fd036b$export$b0985fe0ab85ecbb(editor, "todo"));
        const checkTodoListCommand = new $ab0101fae4fd036b$export$8c4497b463a13fcf(editor);
        editor.commands.add("checkTodoList", checkTodoListCommand);
        editor.commands.add("todoListCheck", checkTodoListCommand);
        data.downcastDispatcher.on("insert:listItem", $ab0101fae4fd036b$var$dataModelViewInsertion(model), {
            priority: "high"
        });
        data.upcastDispatcher.on("element:input", $ab0101fae4fd036b$var$dataViewModelCheckmarkInsertion, {
            priority: "high"
        });
        editing.downcastDispatcher.on("insert:listItem", $ab0101fae4fd036b$var$modelViewInsertion(model, (listItem)=>this._handleCheckmarkChange(listItem)), {
            priority: "high"
        });
        editing.downcastDispatcher.on("attribute:listType:listItem", $ab0101fae4fd036b$var$modelViewChangeType((listItem)=>this._handleCheckmarkChange(listItem), editing.view));
        editing.downcastDispatcher.on("attribute:todoListChecked:listItem", $ab0101fae4fd036b$var$modelViewChangeChecked((listItem)=>this._handleCheckmarkChange(listItem)));
        editing.mapper.on("modelToViewPosition", $ab0101fae4fd036b$var$mapModelToViewPosition(editing.view));
        data.mapper.on("modelToViewPosition", $ab0101fae4fd036b$var$mapModelToViewPosition(editing.view));
        this.listenTo(editing.view.document, "arrowKey", $ab0101fae4fd036b$var$jumpOverCheckmarkOnSideArrowKeyPress(model, editor.locale), {
            context: "li"
        });
        this.listenTo(editing.view.document, "keydown", (evt, data)=>{
            if ((0, $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb)(data) === $ab0101fae4fd036b$var$ITEM_TOGGLE_KEYSTROKE) {
                editor.execute("checkTodoList");
                evt.stop();
            }
        }, {
            priority: "high"
        });
        const listItemsToFix = /* @__PURE__ */ new Set();
        this.listenTo(model, "applyOperation", (evt, args)=>{
            const operation = args[0];
            if (operation.type == "rename" && operation.oldName == "listItem") {
                const item = operation.position.nodeAfter;
                if (item.hasAttribute("todoListChecked")) listItemsToFix.add(item);
            } else if (operation.type == "changeAttribute" && operation.key == "listType" && operation.oldValue === "todo") {
                for (const item of operation.range.getItems())if (item.hasAttribute("todoListChecked") && item.getAttribute("listType") !== "todo") listItemsToFix.add(item);
            }
        });
        model.document.registerPostFixer((writer)=>{
            let hasChanged = false;
            for (const listItem of listItemsToFix){
                writer.removeAttribute("todoListChecked", listItem);
                hasChanged = true;
            }
            listItemsToFix.clear();
            return hasChanged;
        });
        this._initAriaAnnouncements();
    }
    /**
	* Handles the checkbox element change, moves the selection to the corresponding model item to make it possible
	* to toggle the `todoListChecked` attribute using the command, and restores the selection position.
	*
	* Some say it's a hack :) Moving the selection only for executing the command on a certain node and restoring it after,
	* is not a clear solution. We need to design an API for using commands beyond the selection range.
	* See https://github.com/ckeditor/ckeditor5/issues/1954.
	*/ _handleCheckmarkChange(listItem) {
        const editor = this.editor;
        const model = editor.model;
        const previousSelectionRanges = Array.from(model.document.selection.getRanges());
        model.change((writer)=>{
            writer.setSelection(listItem, "end");
            editor.execute("checkTodoList");
            writer.setSelection(previousSelectionRanges);
        });
    }
    /**
	* Observe when user enters or leaves todo list and set proper aria value in global live announcer.
	* This allows screen readers to indicate when the user has entered and left the specified todo list.
	*
	* @internal
	*/ _initAriaAnnouncements() {
        const { model: model, ui: ui, t: t } = this.editor;
        let lastFocusedCodeBlock = null;
        if (!ui) return;
        model.document.selection.on("change:range", ()=>{
            const focusParent = model.document.selection.focus.parent;
            const lastElementIsTodoList = $ab0101fae4fd036b$var$isLegacyTodoListItemElement(lastFocusedCodeBlock);
            const currentElementIsTodoList = $ab0101fae4fd036b$var$isLegacyTodoListItemElement(focusParent);
            if (lastElementIsTodoList && !currentElementIsTodoList) ui.ariaLiveAnnouncer.announce(t("Leaving a to-do list"));
            else if (!lastElementIsTodoList && currentElementIsTodoList) ui.ariaLiveAnnouncer.announce(t("Entering a to-do list"));
            lastFocusedCodeBlock = focusParent;
        });
    }
};
/**
* Handles the left/right (LTR/RTL content) arrow key and moves the selection at the end of the previous block element
* if the selection is just after the checkbox element. In other words, it jumps over the checkbox element when
* moving the selection to the left/right (LTR/RTL).
*
* @returns Callback for 'keydown' events.
*/ function $ab0101fae4fd036b$var$jumpOverCheckmarkOnSideArrowKeyPress(model, locale) {
    return (eventInfo, domEventData)=>{
        if ((0, $c7bc2cb7e2db0227$export$ad185f2969a88a73)(domEventData.keyCode, locale.contentLanguageDirection) != "left") return;
        const schema = model.schema;
        const selection = model.document.selection;
        if (!selection.isCollapsed) return;
        const position = selection.getFirstPosition();
        const parent = position.parent;
        if (parent.name === "listItem" && parent.getAttribute("listType") == "todo" && position.isAtStart) {
            const newRange = schema.getNearestSelectionRange(model.createPositionBefore(parent), "backward");
            if (newRange) model.change((writer)=>writer.setSelection(newRange));
            domEventData.preventDefault();
            domEventData.stopPropagation();
            eventInfo.stop();
        }
    };
}
/**
* Returns true if the given element is a list item model element of a to-do list.
*/ function $ab0101fae4fd036b$var$isLegacyTodoListItemElement(element) {
    return !!element && element.is("element", "listItem") && element.getAttribute("listType") === "todo";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module list/legacytodolist
*/ /**
* The legacy to-do list feature.
*
* This is a "glue" plugin that loads the {@link module:list/legacytodolist/legacytodolistediting~LegacyTodoListEditing legacy to-do list
* editing feature} and the {@link module:list/todolist/todolistui~TodoListUI to-do list UI feature}.
*/ var $ab0101fae4fd036b$export$576d365d6f9a3414 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ab0101fae4fd036b$export$82ad92bb8b026354,
            $ab0101fae4fd036b$export$b53f321a39a26d73
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LegacyTodoList";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ var $ab0101fae4fd036b$export$70013dd6d18f7929 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AdjacentListsSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.register("listSeparator", {
            allowWhere: "$block",
            isBlock: true
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:ol", $ab0101fae4fd036b$var$listSeparatorUpcastConverter());
            dispatcher.on("element:ul", $ab0101fae4fd036b$var$listSeparatorUpcastConverter());
        }).elementToElement({
            model: "listSeparator",
            view: "ck-list-separator"
        });
        editor.conversion.for("editingDowncast").elementToElement({
            model: "listSeparator",
            view: {
                name: "div",
                classes: [
                    "ck-list-separator",
                    "ck-hidden"
                ]
            }
        });
        editor.conversion.for("dataDowncast").elementToElement({
            model: "listSeparator",
            view: (modelElement, conversionApi)=>{
                const viewElement = conversionApi.writer.createContainerElement("ck-list-separator");
                conversionApi.writer.setCustomProperty("dataPipeline:transparentRendering", true, viewElement);
                viewElement.getFillerOffset = ()=>null;
                return viewElement;
            }
        });
    }
};
/**
* Inserts a list separator element between two lists of the same type (`ol` + `ol` or `ul` + `ul`).
*/ function $ab0101fae4fd036b$var$listSeparatorUpcastConverter() {
    return (evt, data, conversionApi)=>{
        const element = data.viewItem;
        const nextSibling = element.nextSibling;
        if (!nextSibling) return;
        if (element.name !== nextSibling.name) return;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        const writer = conversionApi.writer;
        const modelElement = writer.createElement("listSeparator");
        if (!conversionApi.safeInsert(modelElement, data.modelCursor)) return;
        const parts = conversionApi.getSplitParts(modelElement);
        data.modelRange = writer.createRange(data.modelRange.start, writer.createPositionAfter(parts[parts.length - 1]));
        conversionApi.updateConversionResult(modelElement, data);
    };
}


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentediting
*/ /**
* The indent editing feature.
*
* This plugin registers the `'indent'` and `'outdent'` commands.
*
* **Note**: In order for the commands to work, at least one of the compatible features is required. Read more in the
* {@link module:indent/indent~Indent indent feature} API documentation.
*/ var $fad37f7205186735$export$777db8cc44dac779 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "IndentEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.commands.add("indent", new (0, $7ca4ca5784e50ca9$export$83b9598429c26b85)(editor));
        editor.commands.add("outdent", new (0, $7ca4ca5784e50ca9$export$83b9598429c26b85)(editor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentui
*/ /**
* The indent UI feature.
*
* This plugin registers the `'indent'` and `'outdent'` buttons.
*
* **Note**: In order for the commands to work, at least one of the compatible features is required. Read more in
* the {@link module:indent/indent~Indent indent feature} API documentation.
*/ var $fad37f7205186735$export$22935f389f580939 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "IndentUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const locale = editor.locale;
        const t = editor.t;
        const localizedIndentIcon = locale.uiLanguageDirection == "ltr" ? (0, $e8dc502aba5ac3f5$export$6c638b4f8a44828d) : (0, $e8dc502aba5ac3f5$export$d69403c92e089a83);
        const localizedOutdentIcon = locale.uiLanguageDirection == "ltr" ? (0, $e8dc502aba5ac3f5$export$d69403c92e089a83) : (0, $e8dc502aba5ac3f5$export$6c638b4f8a44828d);
        this._defineButton("indent", t("Increase indent"), localizedIndentIcon);
        this._defineButton("outdent", t("Decrease indent"), localizedOutdentIcon);
    }
    /**
	* Defines UI buttons for both toolbar and menu bar.
	*/ _defineButton(commandName, label, icon) {
        const editor = this.editor;
        editor.ui.componentFactory.add(commandName, ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa), commandName, label, icon);
            buttonView.set({
                tooltip: true
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:" + commandName, ()=>{
            return this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53), commandName, label, icon);
        });
    }
    /**
	* Creates a button to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass, commandName, label, icon) {
        const editor = this.editor;
        const command = editor.commands.get(commandName);
        const view = new ButtonClass(editor.locale);
        view.set({
            label: label,
            icon: icon
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute(commandName);
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indent
*/ /**
* The indent feature.
*
* This plugin acts as a single entry point plugin for other features that implement indentation of elements like lists or paragraphs.
*
* The compatible features are:
*
* * The {@link module:list/list~List} or {@link module:list/list/listediting~ListEditing} feature for list indentation.
* * The {@link module:indent/indentblock~IndentBlock} feature for block indentation.
*
* This is a "glue" plugin that loads the following plugins:
*
* * The {@link module:indent/indentediting~IndentEditing indent editing feature}.
* * The {@link module:indent/indentui~IndentUI indent UI feature}.
*
* The dependent plugins register the `'indent'` and `'outdent'` commands and introduce the `'indent'` and `'outdent'` buttons
* that allow to increase or decrease text indentation of supported elements.
*
* **Note**: In order for the commands and buttons to work, at least one of compatible features is required.
*/ var $fad37f7205186735$export$e883eb7bc5d8ee6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Indent";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $fad37f7205186735$export$777db8cc44dac779,
            $fad37f7205186735$export$22935f389f580939
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentblockcommand
*/ /**
* The indent block command.
*
* The command is registered by the {@link module:indent/indentblock~IndentBlock} as `'indentBlock'` for indenting blocks and
* `'outdentBlock'` for outdenting blocks.
*
* To increase block indentation at the current selection, execute the command:
*
* ```ts
* editor.execute( 'indentBlock' );
* ```
*
* To decrease block indentation at the current selection, execute the command:
*
* ```ts
* editor.execute( 'outdentBlock' );
* ```
*/ var $fad37f7205186735$export$923432daa31aca33 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The command's indentation behavior.
	*/ _indentBehavior;
    /**
	* Creates an instance of the command.
	*/ constructor(editor, indentBehavior){
        super(editor);
        this._indentBehavior = indentBehavior;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const block = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(model.document.selection.getSelectedBlocks());
        if (!block || !this._isIndentationChangeAllowed(block)) {
            this.isEnabled = false;
            return;
        }
        this.isEnabled = this._indentBehavior.checkEnabled(block.getAttribute("blockIndent"));
    }
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        const blocksToChange = this._getBlocksToChange();
        model.change((writer)=>{
            for (const block of blocksToChange){
                const currentIndent = block.getAttribute("blockIndent");
                const nextIndent = this._indentBehavior.getNextIndent(currentIndent);
                if (nextIndent) writer.setAttribute("blockIndent", nextIndent, block);
                else writer.removeAttribute("blockIndent", block);
            }
        });
    }
    /**
	* Returns blocks from selection that should have blockIndent selection set.
	*/ _getBlocksToChange() {
        const selection = this.editor.model.document.selection;
        return Array.from(selection.getSelectedBlocks()).filter((block)=>this._isIndentationChangeAllowed(block));
    }
    /**
	* Returns false if indentation cannot be applied, i.e.:
	* - for blocks disallowed by schema declaration
	* - for blocks in Document Lists (disallowed forward indentation only). See https://github.com/ckeditor/ckeditor5/issues/14155.
	* Otherwise returns true.
	*/ _isIndentationChangeAllowed(element) {
        const editor = this.editor;
        if (!editor.model.schema.checkAttribute(element, "blockIndent")) return false;
        if (!editor.plugins.has("ListUtils")) return true;
        if (!this._indentBehavior.isForward) return true;
        return !editor.plugins.get("ListUtils").isListItemBlock(element);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The block indentation behavior that uses offsets to set indentation.
*
* @internal
*/ var $fad37f7205186735$export$7e275801b94e8f25 = class {
    /**
	* The direction of indentation.
	*/ isForward;
    /**
	* The offset of the next indentation step.
	*/ offset;
    /**
	* Indentation unit.
	*/ unit;
    /**
	* Creates an instance of the indentation behavior.
	*
	* @param config.direction The direction of indentation.
	* @param config.offset The offset of the next indentation step.
	* @param config.unit Indentation unit.
	*/ constructor(config){
        this.isForward = config.direction === "forward";
        this.offset = config.offset;
        this.unit = config.unit;
    }
    /**
	* @inheritDoc
	*/ checkEnabled(indentAttributeValue) {
        const currentOffset = parseFloat(indentAttributeValue || "0");
        return this.isForward || currentOffset > 0;
    }
    /**
	* @inheritDoc
	*/ getNextIndent(indentAttributeValue) {
        const currentOffset = parseFloat(indentAttributeValue || "0");
        const isSameUnit = !indentAttributeValue || indentAttributeValue.endsWith(this.unit);
        if (currentOffset < 0) return;
        if (!isSameUnit) return this.isForward ? this.offset + this.unit : void 0;
        const offsetToSet = currentOffset + (this.isForward ? this.offset : -this.offset);
        return offsetToSet > 0 ? offsetToSet + this.unit : void 0;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The block indentation behavior that uses classes to set indentation.
*
* @internal
*/ var $fad37f7205186735$export$5133f8bf4dab3b4e = class {
    /**
	* The direction of indentation.
	*/ isForward;
    /**
	* A list of classes used for indentation.
	*/ classes;
    /**
	* Creates an instance of the indentation behavior.
	*
	* @param config.direction The direction of indentation.
	* @param config.classes A list of classes used for indentation.
	*/ constructor(config){
        this.isForward = config.direction === "forward";
        this.classes = config.classes;
    }
    /**
	* @inheritDoc
	*/ checkEnabled(indentAttributeValue) {
        const currentIndex = this.classes.indexOf(indentAttributeValue);
        if (this.isForward) return currentIndex < this.classes.length - 1;
        else return currentIndex >= 0;
    }
    /**
	* @inheritDoc
	*/ getNextIndent(indentAttributeValue) {
        const nextIndex = this.classes.indexOf(indentAttributeValue) + (this.isForward ? 1 : -1);
        const nextIndexClamped = Math.min(nextIndex, this.classes.length - 1);
        return this.classes[nextIndexClamped];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/integrations/indentblocklistcommand
*/ /**
* The indent block list command.
*
* The command is registered by the {@link module:indent/integrations/indentblocklistintegration~IndentBlockListIntegration} as
* `'indentBlockList'` for indenting lists and `'outdentBlockList'` for outdenting lists.
*
* To increase/decrease block indentation of the list the selection must be at the start of the first top–level list item
* in the list.
*
* To increase block indentation of the list, execute the command:
*
* ```ts
* editor.execute( 'indentBlockList' );
* ```
*
* To decrease block indentation of the list, execute the command:
*
* ```ts
* editor.execute( 'outdentBlockList' );
* ```
*/ var $fad37f7205186735$export$289fcf9bea14d9c8 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The command's indentation behavior.
	*/ _indentBehavior;
    /**
	* Creates an instance of the command.
	*/ constructor(editor, indentBehavior){
        super(editor);
        this._indentBehavior = indentBehavior;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const listItem = this._getFirstListItemIfSelectionIsAtListStart(this.editor.model.document.selection);
        this.isEnabled = !!listItem && this._indentBehavior.checkEnabled(listItem.getAttribute("blockIndentList"));
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options Command options.
	* @param options.firstListOnly When `true`, indentation is applied only to the first list at the beginning of the selection.
	* When `false` or omitted, indentation is applied to all lists of the selection.
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const listUtils = editor.plugins.get("ListUtils");
        model.change((writer)=>{
            const listItem = this._getFirstListItemIfSelectionIsAtListStart(selection);
            const listItems = [];
            if (!options.firstListOnly) {
                const blocks = Array.from(selection.getSelectedBlocks());
                for (const block of blocks)if ((0, $ab0101fae4fd036b$export$d0c47194f8840044)(block) && block.getAttribute("listIndent") === 0 && model.schema.checkAttribute(block, "blockIndentList")) listItems.push(block);
            } else listItems.push(listItem);
            const expandedListItems = listUtils.expandListBlocksToCompleteList(listItems);
            for (const item of expandedListItems){
                const currentIndent = item.getAttribute("blockIndentList");
                const nextIndent = this._indentBehavior.getNextIndent(currentIndent);
                if (nextIndent) writer.setAttribute("blockIndentList", nextIndent, item);
                else writer.removeAttribute("blockIndentList", item);
            }
        });
    }
    /**
	* Returns the list item at the beginning of the current selection if it is the first top–level list item in the list.
	* Otherwise, returns `null`.
	*/ _getFirstListItemIfSelectionIsAtListStart(selection) {
        const position = selection.getFirstPosition();
        const listUtils = this.editor.plugins.get("ListUtils");
        const parent = position.parent;
        const schema = this.editor.model.schema;
        if (position.isAtStart && (0, $ab0101fae4fd036b$export$d0c47194f8840044)(parent) && parent.getAttribute("listIndent") == 0 && schema.checkAttribute(parent, "blockIndentList") && listUtils.isFirstListItemInList(parent)) return parent;
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/integrations/indentblocklistitemcommand
*/ /**
* The indent block list item command.
*
* The command is registered by the {@link module:indent/integrations/indentblocklistintegration~IndentBlockListIntegration} as
* `'indentBlockListItem'` for indenting list items and `'outdentBlockListItem'` for outdenting list items.
*
* It's only possible to reset the block indentation of a list item to `0`.
* This means that if a list item has negative block indentation, the command will only allow forward indentation
* to make it possible to reset it to `0` and if a list item has positive block indentation, the command
* will only allow backward indentation to make it possible to reset it to `0`.
*
* To increase block indentation of the list item, execute the command:
*
* ```ts
* editor.execute( 'indentBlockListItem' );
* ```
*
* To decrease block indentation of the list item, execute the command:
*
* ```ts
* editor.execute( 'outdentBlockListItem' );
* ```
*/ var $fad37f7205186735$export$572b3f016f20af7 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The command's indentation behavior.
	*/ _indentBehavior;
    /**
	* Creates an instance of the command.
	*/ constructor(editor, indentBehavior){
        super(editor);
        this._indentBehavior = indentBehavior;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._getAffectedListItems().length > 0;
    }
    /**
	* @inheritDoc
	*/ execute() {
        this.editor.model.change((writer)=>{
            for (const block of this._getAffectedListItems())writer.removeAttribute("blockIndentListItem", block);
        });
    }
    /**
	* Returns an array of list items which block indentation should be changed.
	*/ _getAffectedListItems() {
        const selection = this.editor.model.document.selection;
        const listUtils = this.editor.plugins.get("ListUtils");
        const blocksInSelection = Array.from(selection.getSelectedBlocks());
        return listUtils.expandListBlocksToCompleteItems(blocksInSelection).filter((block)=>this._isIndentationChangeAllowed(block));
    }
    /**
	* Returns `true` if changing the block indentation is allowed for the given list item.
	*/ _isIndentationChangeAllowed(element) {
        if (!element.hasAttribute("blockIndentListItem")) return false;
        return this._indentBehavior.checkEnabled(element.getAttribute("blockIndentListItem"));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentcommandbehavior/resetindentusingoffset
*/ /**
* The list item block indentation behavior that resets offset-based indentation toward zero.
*
* Unlike {@link module:indent/indentcommandbehavior/indentusingoffset~IndentUsingOffset}, this behavior
* is enabled only when the current indentation value can be moved toward zero:
* - for forward direction only when the current offset is negative,
* - for backward direction only when the current offset is positive.
*
* @internal
*/ var $fad37f7205186735$var$ResetIndentUsingOffset = class extends $fad37f7205186735$export$7e275801b94e8f25 {
    /**
	* @inheritDoc
	*/ checkEnabled(indentAttributeValue) {
        const currentOffset = parseFloat(indentAttributeValue);
        return this.isForward && currentOffset < 0 || !this.isForward && currentOffset > 0;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentcommandbehavior/resetindentusingclasses
*/ /**
* The list item block indentation behavior that resets class-based indentation toward zero.
*
* Unlike {@link module:indent/indentcommandbehavior/indentusingclasses~IndentUsingClasses}, this behavior
* is enabled only in the backward (outdent) direction when a class-based indentation is set.
* This is because class-based indentation values cannot be negative, so the only way to reset
* them to zero is to remove the class by outdenting.
*
* @internal
*/ var $fad37f7205186735$var$ResetIndentUsingClasses = class extends $fad37f7205186735$export$5133f8bf4dab3b4e {
    /**
	* @inheritDoc
	*/ checkEnabled(indentAttributeValue) {
        return !this.isForward && !!indentAttributeValue;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* This integration enables using block indentation feature with lists.
*/ var $fad37f7205186735$export$e46c16aaa6a98a29 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "IndentBlockListIntegration";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!this.editor.plugins.has("ListEditing")) return;
        const config = editor.config.get("indentBlock");
        if (config.classes && config.classes.length) {
            this._setupConversionUsingClasses(config.classes, "ol", "blockIndentList", "list");
            this._setupConversionUsingClasses(config.classes, "ul", "blockIndentList", "list");
            this._setupConversionUsingClasses(config.classes, "li", "blockIndentListItem", "item");
            editor.commands.add("indentBlockList", new $fad37f7205186735$export$289fcf9bea14d9c8(editor, new $fad37f7205186735$export$5133f8bf4dab3b4e({
                direction: "forward",
                classes: config.classes
            })));
            editor.commands.add("outdentBlockList", new $fad37f7205186735$export$289fcf9bea14d9c8(editor, new $fad37f7205186735$export$5133f8bf4dab3b4e({
                direction: "backward",
                classes: config.classes
            })));
            editor.commands.add("indentBlockListItem", new $fad37f7205186735$export$572b3f016f20af7(editor, new $fad37f7205186735$var$ResetIndentUsingClasses({
                direction: "forward",
                classes: config.classes
            })));
            editor.commands.add("outdentBlockListItem", new $fad37f7205186735$export$572b3f016f20af7(editor, new $fad37f7205186735$var$ResetIndentUsingClasses({
                direction: "backward",
                classes: config.classes
            })));
        } else {
            editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$45e932fc987e4c1e));
            this._setupConversionUsingOffset("ol", "blockIndentList", "list");
            this._setupConversionUsingOffset("ul", "blockIndentList", "list");
            this._setupConversionUsingOffset("li", "blockIndentListItem", "item");
            editor.commands.add("indentBlockList", new $fad37f7205186735$export$289fcf9bea14d9c8(editor, new $fad37f7205186735$export$7e275801b94e8f25({
                direction: "forward",
                offset: config.offset,
                unit: config.unit
            })));
            editor.commands.add("outdentBlockList", new $fad37f7205186735$export$289fcf9bea14d9c8(editor, new $fad37f7205186735$export$7e275801b94e8f25({
                direction: "backward",
                offset: config.offset,
                unit: config.unit
            })));
            editor.commands.add("indentBlockListItem", new $fad37f7205186735$export$572b3f016f20af7(editor, new $fad37f7205186735$var$ResetIndentUsingOffset({
                direction: "forward",
                offset: config.offset,
                unit: config.unit
            })));
            editor.commands.add("outdentBlockListItem", new $fad37f7205186735$export$572b3f016f20af7(editor, new $fad37f7205186735$var$ResetIndentUsingOffset({
                direction: "backward",
                offset: config.offset,
                unit: config.unit
            })));
        }
        editor.plugins.get("ListEditing").on("postFixer", (evt, { listNodes: listNodes, writer: writer })=>{
            for (const { node: node, previousNodeInList: previousNodeInList } of listNodes){
                if (!previousNodeInList) continue;
                if (previousNodeInList.getAttribute("listType") != node.getAttribute("listType")) continue;
                if ($fad37f7205186735$var$ensureIndentValuesConsistency("blockIndentList", node, previousNodeInList, writer)) evt.return = true;
                if (previousNodeInList.getAttribute("listItemId") != node.getAttribute("listItemId")) continue;
                if ($fad37f7205186735$var$ensureIndentValuesConsistency("blockIndentListItem", node, previousNodeInList, writer)) evt.return = true;
            }
        });
        this.listenTo(editor.editing.view.document, "tab", (evt, data)=>{
            const commandName = data.shiftKey ? "outdentBlockList" : "indentBlockList";
            if (this.editor.commands.get(commandName).isEnabled) {
                editor.execute(commandName, {
                    firstListOnly: true
                });
                data.stopPropagation();
                data.preventDefault();
                evt.stop();
            }
        }, {
            context: "li",
            priority: "high"
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const model = editor.model;
        const schema = model.schema;
        if (!editor.plugins.has("ListEditing")) return;
        schema.extend("$listItem", {
            allowAttributes: [
                "blockIndentList",
                "blockIndentListItem"
            ]
        });
        schema.setAttributeProperties("blockIndentList", {
            isFormatting: true
        });
        schema.setAttributeProperties("blockIndentListItem", {
            isFormatting: true
        });
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "blockIndentList");
        model.schema.addAttributeCheck((context)=>{
            if (!context.last.getAttribute("listItemId")) return false;
        }, "blockIndentListItem");
        const clearBlockIndentAttributesOnListIndentChange = (_evt, changedBlocks)=>{
            editor.model.change((writer)=>{
                for (const node of changedBlocks)if (node.hasAttribute("listItemId")) {
                    if (node.hasAttribute("blockIndentList")) writer.removeAttribute("blockIndentList", node);
                    if (node.hasAttribute("blockIndentListItem")) writer.removeAttribute("blockIndentListItem", node);
                }
            });
        };
        const indentListCommand = editor.commands.get("indentList");
        const outdentListCommand = editor.commands.get("outdentList");
        if (indentListCommand) this.listenTo(indentListCommand, "afterExecute", clearBlockIndentAttributesOnListIndentChange);
        if (outdentListCommand) this.listenTo(outdentListCommand, "afterExecute", clearBlockIndentAttributesOnListIndentChange);
        const indentCommand = editor.commands.get("indent");
        const outdentCommand = editor.commands.get("outdent");
        indentCommand.registerChildCommand(editor.commands.get("indentBlockList"), {
            priority: "highest"
        });
        outdentCommand.registerChildCommand(editor.commands.get("outdentBlockList"));
        indentCommand.registerChildCommand(editor.commands.get("indentBlockListItem"));
        outdentCommand.registerChildCommand(editor.commands.get("outdentBlockListItem"));
    }
    /**
	* Setups conversion for list block indent using offset.
	*/ _setupConversionUsingOffset(element, attributeName, scope) {
        const editor = this.editor;
        const locale = editor.locale;
        const conversion = editor.conversion;
        const marginProperty = locale.contentLanguageDirection === "rtl" ? "margin-right" : "margin-left";
        const listEditing = editor.plugins.get("ListEditing");
        conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on(`element:${element}`, $fad37f7205186735$var$listBlockIndentUpcastConverter(attributeName, (item)=>item.getStyle(marginProperty), (consumable, item)=>consumable.consume(item, {
                    styles: marginProperty
                })), {
                priority: "low"
            });
        });
        listEditing.registerDowncastStrategy({
            scope: scope,
            attributeName: attributeName,
            setAttributeOnDowncast (writer, value, element) {
                if (value) writer.setStyle(marginProperty, value, element);
            }
        });
    }
    /**
	* Setups conversion for list block indent using classes.
	*/ _setupConversionUsingClasses(classes, element, attributeName, scope) {
        const editor = this.editor;
        const conversion = editor.conversion;
        const listEditing = editor.plugins.get("ListEditing");
        conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on(`element:${element}`, $fad37f7205186735$var$listBlockIndentUpcastConverter(attributeName, (item)=>classes.find((cls)=>item.hasClass(cls)), (consumable, item, value)=>consumable.consume(item, {
                    classes: value
                })), {
                priority: "low"
            });
        });
        listEditing.registerDowncastStrategy({
            scope: scope,
            attributeName: attributeName,
            setAttributeOnDowncast (writer, value, element) {
                if (value) writer.addClass(value, element);
            }
        });
    }
};
/**
* Returns an upcast converter for block list indentation.
*
* @param attributeName The name of the model attribute.
* @param getValue A function to get the value from the view element.
* @param consume A function to consume the view element.
* @returns A callback for the upcast conversion.
*/ function $fad37f7205186735$var$listBlockIndentUpcastConverter(attributeName, getValue, consume) {
    return (evt, data, conversionApi)=>{
        const { writer: writer, consumable: consumable } = conversionApi;
        if (!data.modelRange) Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
        const value = getValue(data.viewItem);
        if (value === void 0) return;
        let applied = false;
        let indentLevel;
        for (const item of data.modelRange.getItems({
            shallow: true
        })){
            if (indentLevel === void 0) indentLevel = item.getAttribute("listIndent");
            if (item.hasAttribute(attributeName)) continue;
            if (item.getAttribute("listIndent") !== indentLevel) continue;
            writer.setAttribute(attributeName, value, item);
            applied = true;
        }
        if (applied) consume(consumable, data.viewItem, value);
    };
}
/**
* Ensures that two nodes have the same value of the given attribute.
* If the values are different, the attribute value from the previous node is applied to the given node.
* Returns true if the attribute value was changed, false otherwise.
*/ function $fad37f7205186735$var$ensureIndentValuesConsistency(attributeName, node, previousNodeInList, writer) {
    const prevNodeIndentListValue = previousNodeInList.getAttribute(attributeName);
    if (node.getAttribute(attributeName) === prevNodeIndentListValue) return false;
    if (prevNodeIndentListValue) writer.setAttribute(attributeName, prevNodeIndentListValue, node);
    else writer.removeAttribute(attributeName, node);
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module indent/indentblock
*/ const $fad37f7205186735$var$DEFAULT_ELEMENTS = [
    "paragraph",
    "heading1",
    "heading2",
    "heading3",
    "heading4",
    "heading5",
    "heading6"
];
/**
* The block indentation feature.
*
* It registers the `'indentBlock'` and `'outdentBlock'` commands.
*
* If the plugin {@link module:indent/indent~Indent} is defined, it also attaches the `'indentBlock'` and `'outdentBlock'` commands to
* the `'indent'` and `'outdent'` commands.
*/ var $fad37f7205186735$export$e10df386f5781d2e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("indentBlock", {
            offset: 40,
            unit: "px"
        });
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "IndentBlock";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $fad37f7205186735$export$e46c16aaa6a98a29
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const configuration = editor.config.get("indentBlock");
        if (configuration.classes && configuration.classes.length) {
            this._setupConversionUsingClasses(configuration.classes);
            editor.commands.add("indentBlock", new $fad37f7205186735$export$923432daa31aca33(editor, new $fad37f7205186735$export$5133f8bf4dab3b4e({
                direction: "forward",
                classes: configuration.classes
            })));
            editor.commands.add("outdentBlock", new $fad37f7205186735$export$923432daa31aca33(editor, new $fad37f7205186735$export$5133f8bf4dab3b4e({
                direction: "backward",
                classes: configuration.classes
            })));
        } else {
            editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$45e932fc987e4c1e));
            this._setupConversionUsingOffset();
            editor.commands.add("indentBlock", new $fad37f7205186735$export$923432daa31aca33(editor, new $fad37f7205186735$export$7e275801b94e8f25({
                direction: "forward",
                offset: configuration.offset,
                unit: configuration.unit
            })));
            editor.commands.add("outdentBlock", new $fad37f7205186735$export$923432daa31aca33(editor, new $fad37f7205186735$export$7e275801b94e8f25({
                direction: "backward",
                offset: configuration.offset,
                unit: configuration.unit
            })));
        }
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const indentCommand = editor.commands.get("indent");
        const outdentCommand = editor.commands.get("outdent");
        const options = editor.config.get("heading.options");
        (options && options.map((option)=>option.model) || $fad37f7205186735$var$DEFAULT_ELEMENTS).forEach((elementName)=>{
            if (schema.isRegistered(elementName)) schema.extend(elementName, {
                allowAttributes: "blockIndent"
            });
        });
        schema.setAttributeProperties("blockIndent", {
            isFormatting: true
        });
        indentCommand.registerChildCommand(editor.commands.get("indentBlock"));
        outdentCommand.registerChildCommand(editor.commands.get("outdentBlock"));
    }
    /**
	* Setups conversion for using offset indents.
	*/ _setupConversionUsingOffset() {
        const conversion = this.editor.conversion;
        const marginProperty = this.editor.locale.contentLanguageDirection === "rtl" ? "margin-right" : "margin-left";
        conversion.for("upcast").attributeToAttribute({
            view: {
                styles: {
                    [marginProperty]: /[\s\S]+/
                }
            },
            model: {
                key: "blockIndent",
                value: (viewElement)=>{
                    if (!viewElement.is("element", "li")) return viewElement.getStyle(marginProperty);
                }
            }
        });
        conversion.for("downcast").attributeToAttribute({
            model: "blockIndent",
            view: (modelAttributeValue)=>{
                return {
                    key: "style",
                    value: {
                        [marginProperty]: modelAttributeValue
                    }
                };
            }
        });
    }
    /**
	* Setups conversion for using classes.
	*/ _setupConversionUsingClasses(classes) {
        const definition = {
            model: {
                key: "blockIndent",
                values: []
            },
            view: {}
        };
        for (const className of classes){
            definition.model.values.push(className);
            definition.view[className] = {
                key: "class",
                value: [
                    className
                ]
            };
        }
        this.editor.conversion.attributeToAttribute(definition);
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module language/utils
*/ /**
* Returns the language attribute value in a human-readable text format:
*
* ```
* <languageCode>:<textDirection>
* ```
*
* * `languageCode` - The language code used for the `lang` attribute in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
* * `textDirection` - One of the following values: `rtl` or `ltr`, indicating the reading direction of the language.
*
* See the {@link module:core/editor/editorconfig~LanguageConfig#textPartLanguage text part language configuration}
* for more information about language properties.
*
* If the `textDirection` argument is omitted, it will be automatically detected based on `languageCode`.
*
* @param languageCode The language code in the ISO 639-1 format.
* @param textDirection The language text direction. Automatically detected if omitted.
* @internal
*/ function $1a12f63565a6ddfa$export$9f1fd049a950aacd(languageCode, textDirection) {
    textDirection = textDirection || (0, $c7bc2cb7e2db0227$export$3720542e60e4e185)(languageCode);
    return `${languageCode}:${textDirection}`;
}
/**
* Retrieves language properties converted to attribute value by the
* {@link module:language/utils~stringifyLanguageAttribute stringifyLanguageAttribute} function.
*
* @internal
* @param str The attribute value.
* @returns The object with properties:
* * languageCode - The language code in the ISO 639 format.
* * textDirection - The language text direction.
*/ function $1a12f63565a6ddfa$export$c1329f8df9a3c889(str) {
    const [languageCode, textDirection] = str.split(":");
    return {
        languageCode: languageCode,
        textDirection: textDirection
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The text part language command plugin.
*/ var $1a12f63565a6ddfa$export$8e986f03fb5af12c = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.value = this._getValueFromFirstAllowedNode();
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, "language");
    }
    /**
	* Executes the command. Applies the attribute to the selection or removes it from the selection.
	*
	* If `languageCode` is set to `false` or a `null` value, it will remove attributes. Otherwise, it will set
	* the attribute in the `{@link #value value}` format.
	*
	* The execution result differs, depending on the {@link module:engine/model/document~ModelDocument#selection}:
	*
	* * If the selection is on a range, the command applies the attribute to all nodes in that range
	* (if they are allowed to have this attribute by the {@link module:engine/model/schema~ModelSchema schema}).
	* * If the selection is collapsed in a non-empty node, the command applies the attribute to the
	* {@link module:engine/model/document~ModelDocument#selection} itself (note that typed characters copy attributes from the selection).
	* * If the selection is collapsed in an empty node, the command applies the attribute to the parent node of the selection (note
	* that the selection inherits all attributes from a node if it is in an empty node).
	*
	* @fires execute
	* @param options Command options.
	* @param options.languageCode The language code to be applied to the model.
	* @param options.textDirection The language text direction.
	*/ execute({ languageCode: languageCode, textDirection: textDirection } = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const value = languageCode ? $1a12f63565a6ddfa$export$9f1fd049a950aacd(languageCode, textDirection) : false;
        model.change((writer)=>{
            if (selection.isCollapsed) {
                if (value) writer.setSelectionAttribute("language", value);
                else writer.removeSelectionAttribute("language");
            } else {
                const ranges = model.schema.getValidRanges(selection.getRanges(), "language", {
                    includeEmptyRanges: true
                });
                for (const range of ranges){
                    let itemOrRange = range;
                    let attributeKey = "language";
                    if (range.isCollapsed) {
                        itemOrRange = range.start.parent;
                        attributeKey = (0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey("language");
                    }
                    if (value) writer.setAttribute(attributeKey, value, itemOrRange);
                    else writer.removeAttribute(attributeKey, itemOrRange);
                }
            }
        });
    }
    /**
	* Returns the attribute value of the first node in the selection that allows the attribute.
	* For a collapsed selection it returns the selection attribute.
	*
	* @returns The attribute value.
	*/ _getValueFromFirstAllowedNode() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        if (selection.isCollapsed) return selection.getAttribute("language") || false;
        for (const range of selection.getRanges())for (const item of range.getItems())if (schema.checkAttribute(item, "language")) return item.getAttribute("language") || false;
        return false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The text part language editing.
*
* Introduces the `'textPartLanguage'` command and the `'language'` model element attribute.
*/ var $1a12f63565a6ddfa$export$fb0d65645de052f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TextPartLanguageEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("language", {
            textPartLanguage: [
                {
                    title: "Arabic",
                    languageCode: "ar"
                },
                {
                    title: "French",
                    languageCode: "fr"
                },
                {
                    title: "Spanish",
                    languageCode: "es"
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.model.schema.extend("$text", {
            allowAttributes: "language"
        });
        editor.model.schema.setAttributeProperties("language", {
            copyOnEnter: true
        });
        this._defineConverters();
        editor.commands.add("textPartLanguage", new $1a12f63565a6ddfa$export$8e986f03fb5af12c(editor));
    }
    /**
	* @private
	*/ _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for("upcast").elementToAttribute({
            model: {
                key: "language",
                value: (viewElement)=>{
                    const languageCode = viewElement.getAttribute("lang");
                    const textDirection = viewElement.getAttribute("dir");
                    return $1a12f63565a6ddfa$export$9f1fd049a950aacd(languageCode, textDirection);
                }
            },
            view: {
                name: "span",
                attributes: {
                    lang: /[\s\S]+/
                }
            }
        });
        conversion.for("downcast").attributeToElement({
            model: "language",
            view: (attributeValue, { writer: writer }, data)=>{
                if (!attributeValue) return;
                if (!data.item.is("$textProxy") && !data.item.is("documentSelection")) return;
                const { languageCode: languageCode, textDirection: textDirection } = $1a12f63565a6ddfa$export$c1329f8df9a3c889(attributeValue);
                return writer.createAttributeElement("span", {
                    lang: languageCode,
                    dir: textDirection
                });
            }
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module language/textpartlanguageui
*/ /**
* The text part language UI plugin.
*
* It introduces the `'language'` dropdown.
*/ var $1a12f63565a6ddfa$export$b57b11a4a699d5eb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TextPartLanguageUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        const defaultTitle = t("Choose language");
        const accessibleLabel = t("Language");
        editor.ui.componentFactory.add("textPartLanguage", (locale)=>{
            const { definitions: definitions, titles: titles } = this._getItemMetadata();
            const languageCommand = editor.commands.get("textPartLanguage");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, definitions, {
                ariaLabel: accessibleLabel,
                role: "menu"
            });
            dropdownView.buttonView.set({
                ariaLabel: accessibleLabel,
                ariaLabelledBy: void 0,
                isOn: false,
                withText: true,
                tooltip: accessibleLabel
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: [
                        "ck-text-fragment-language-dropdown"
                    ]
                }
            });
            dropdownView.bind("isEnabled").to(languageCommand, "isEnabled");
            dropdownView.buttonView.bind("label").to(languageCommand, "value", (value)=>{
                return value && titles[value] || defaultTitle;
            });
            dropdownView.buttonView.bind("ariaLabel").to(languageCommand, "value", (value)=>{
                const selectedLanguageTitle = value && titles[value];
                if (!selectedLanguageTitle) return accessibleLabel;
                return `${selectedLanguageTitle}, ${accessibleLabel}`;
            });
            this.listenTo(dropdownView, "execute", (evt)=>{
                languageCommand.execute({
                    languageCode: evt.source.languageCode,
                    textDirection: evt.source.textDirection
                });
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add("menuBar:textPartLanguage", (locale)=>{
            const { definitions: definitions } = this._getItemMetadata();
            const languageCommand = editor.commands.get("textPartLanguage");
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            menuView.buttonView.set({
                label: accessibleLabel
            });
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            listView.set({
                ariaLabel: t("Language"),
                role: "menu"
            });
            for (const definition of definitions){
                if (definition.type != "button") {
                    listView.items.add(new (0, $29fd27cb9bdab9d2$export$3fb5f6e5384c5fb0)(locale));
                    continue;
                }
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(locale);
                buttonView.set({
                    role: "menuitemradio",
                    isToggleable: true
                });
                buttonView.bind(...Object.keys(definition.model)).to(definition.model);
                buttonView.delegate("execute").to(menuView);
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            }
            menuView.bind("isEnabled").to(languageCommand, "isEnabled");
            menuView.panelView.children.add(listView);
            menuView.on("execute", (evt)=>{
                languageCommand.execute({
                    languageCode: evt.source.languageCode,
                    textDirection: evt.source.textDirection
                });
                editor.editing.view.focus();
            });
            return menuView;
        });
    }
    /**
	* Returns metadata for dropdown and menu items.
	*/ _getItemMetadata() {
        const editor = this.editor;
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        const titles = {};
        const languageCommand = editor.commands.get("textPartLanguage");
        const options = editor.config.get("language.textPartLanguage");
        const t = editor.locale.t;
        const removeTitle = t("Remove language");
        itemDefinitions.add({
            type: "button",
            model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                label: removeTitle,
                languageCode: false,
                withText: true
            })
        });
        itemDefinitions.add({
            type: "separator"
        });
        for (const option of options){
            const def = {
                type: "button",
                model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                    label: option.title,
                    languageCode: option.languageCode,
                    role: "menuitemradio",
                    textDirection: option.textDirection,
                    withText: true
                })
            };
            const language = $1a12f63565a6ddfa$export$9f1fd049a950aacd(option.languageCode, option.textDirection);
            def.model.bind("isOn").to(languageCommand, "value", (value)=>value === language);
            itemDefinitions.add(def);
            titles[language] = option.title;
        }
        return {
            definitions: itemDefinitions,
            titles: titles
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module language/textpartlanguage
*/ /**
* The text part language feature.
*
* This feature allows setting a language of the document's text part to support
* [WCAG 3.1.2 Language of Parts](https://www.w3.org/TR/UNDERSTANDING-WCAG20/meaning-other-lang-id.html) specification.
*
* To change the editor's UI language, refer to the {@glink getting-started/setup/ui-language Setting the UI language} guide.
*
* For more information about this feature, check the {@glink api/language package page} as well as the {@glink features/language
* Text part language} feature guide.
*
* This is a "glue" plugin which loads the
* {@link module:language/textpartlanguageediting~TextPartLanguageEditing text part language editing feature}
* and the {@link module:language/textpartlanguageui~TextPartLanguageUI text part language UI feature}.
*/ var $1a12f63565a6ddfa$export$bec80c50b4ab156 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $1a12f63565a6ddfa$export$fb0d65645de052f,
            $1a12f63565a6ddfa$export$b57b11a4a699d5eb
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TextPartLanguage";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};





/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 








/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a function that converts the model "url" attribute to the view representation.
*
* Depending on the configuration, the view representation can be "semantic" (for the data pipeline):
*
* ```html
* <figure class="media">
* 	<oembed url="foo"></oembed>
* </figure>
* ```
*
* or "non-semantic" (for the editing view pipeline):
*
* ```html
* <figure class="media">
* 	<div data-oembed-url="foo">[ non-semantic media preview for "foo" ]</div>
* </figure>
* ```
*
* **Note:** Changing the model "url" attribute replaces the entire content of the
* `<figure>` in the view.
*
* @param registry The registry providing
* the media and their content.
* @param options options object with following properties:
* - elementName When set, overrides the default element name for semantic media embeds.
* - renderMediaPreview When `true`, the converter will create the view in the non-semantic form.
* - renderForEditingView When `true`, the converter will create a view specific for the
* editing pipeline (e.g. including CSS classes, content placeholders).
*
* @internal
*/ function $a013102e0bac7fe2$export$edce555db3dc6d2d(registry, options) {
    const converter = (evt, data, conversionApi)=>{
        if (!conversionApi.consumable.consume(data.item, evt.name)) return;
        const url = data.attributeNewValue;
        const viewWriter = conversionApi.writer;
        const figure = conversionApi.mapper.toViewElement(data.item);
        const mediaContentElement = [
            ...figure.getChildren()
        ].find((child)=>child.getCustomProperty("media-content"));
        viewWriter.remove(mediaContentElement);
        const mediaViewElement = registry.getMediaViewElement(viewWriter, url, options);
        viewWriter.insert(viewWriter.createPositionAt(figure, 0), mediaViewElement);
    };
    return (dispatcher)=>{
        dispatcher.on("attribute:url:media", converter);
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Converts a given {@link module:engine/view/element~ViewElement} to a media embed widget:
* * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property}
* allowing to recognize the media widget element.
* * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
*
* @param writer An instance of the view writer.
* @param label The element's label.
* @internal
*/ function $a013102e0bac7fe2$export$b3a7ce307c6a9f8d(viewElement, writer, label) {
    writer.setCustomProperty("media", true, viewElement);
    return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer, {
        label: label
    });
}
/**
* Returns a media widget editing view element if one is selected.
*
* @internal
*/ function $a013102e0bac7fe2$export$3a7cbcf8a9330686(selection) {
    const viewElement = selection.getSelectedElement();
    if (viewElement && $a013102e0bac7fe2$export$c91ae9626683d7a7(viewElement)) return viewElement;
    return null;
}
/**
* Checks if a given view element is a media widget.
*
* @internal
*/ function $a013102e0bac7fe2$export$c91ae9626683d7a7(viewElement) {
    return !!viewElement.getCustomProperty("media") && (0, $5547ab21e02f1e9e$export$33101d01ca587c36)(viewElement);
}
/**
* Creates a view element representing the media. Either a "semantic" one for the data pipeline:
*
* ```html
* <figure class="media">
* 	<oembed url="foo"></oembed>
* </figure>
* ```
*
* or a "non-semantic" (for the editing view pipeline):
*
* ```html
* <figure class="media">
* 	<div data-oembed-url="foo">[ non-semantic media preview for "foo" ]</div>
* </figure>
* ```
*
* @internal
*/ function $a013102e0bac7fe2$export$1c1f5415931ed711(writer, registry, url, options) {
    return writer.createContainerElement("figure", {
        class: "media"
    }, [
        registry.getMediaViewElement(writer, url, options),
        writer.createSlot()
    ]);
}
/**
* Returns a selected media element in the model, if any.
*
* @internal
*/ function $a013102e0bac7fe2$export$7d10b9adbd1016cb(selection) {
    const selectedElement = selection.getSelectedElement();
    if (selectedElement && selectedElement.is("element", "media")) return selectedElement;
    return null;
}
/**
* Creates a media element and inserts it into the model.
*
* **Note**: This method will use {@link module:engine/model/model~Model#insertContent `model.insertContent()`} logic of inserting content
* if no `insertPosition` is passed.
*
* @param url An URL of an embeddable media.
* @param findOptimalPosition If true it will try to find optimal position to insert media without breaking content
* in which a selection is.
* @internal
*/ function $a013102e0bac7fe2$export$903bb2626485ac41(model, url, selectable, findOptimalPosition) {
    model.change((writer)=>{
        const mediaElement = writer.createElement("media", {
            url: url
        });
        model.insertObject(mediaElement, selectable, null, {
            setSelection: "on",
            findOptimalPosition: findOptimalPosition ? "auto" : void 0
        });
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The insert media command.
*
* The command is registered by the {@link module:media-embed/mediaembedediting~MediaEmbedEditing} as `'mediaEmbed'`.
*
* To insert media at the current selection, execute the command and specify the URL:
*
* ```ts
* editor.execute( 'mediaEmbed', 'http://url.to.the/media' );
* ```
*/ var $a013102e0bac7fe2$export$c99ee3f28cac4223 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedMedia = $a013102e0bac7fe2$export$7d10b9adbd1016cb(selection);
        this.value = selectedMedia ? selectedMedia.getAttribute("url") : void 0;
        this.isEnabled = $a013102e0bac7fe2$var$isMediaSelected(selection) || $a013102e0bac7fe2$var$isAllowedInParent(selection, model);
    }
    /**
	* Executes the command, which either:
	*
	* * updates the URL of the selected media,
	* * inserts the new media into the editor and puts the selection around it.
	*
	* @fires execute
	* @param url The URL of the media.
	*/ execute(url) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const selectedMedia = $a013102e0bac7fe2$export$7d10b9adbd1016cb(selection);
        if (selectedMedia) model.change((writer)=>{
            writer.setAttribute("url", url, selectedMedia);
        });
        else $a013102e0bac7fe2$export$903bb2626485ac41(model, url, selection, true);
    }
};
/**
* Checks if the media embed is allowed in the parent.
*/ function $a013102e0bac7fe2$var$isAllowedInParent(selection, model) {
    let parent = (0, $5547ab21e02f1e9e$export$d03cbafb1cb45bb)(selection, model).start.parent;
    if (parent.isEmpty && !model.schema.isLimit(parent)) parent = parent.parent;
    return model.schema.checkChild(parent, "media");
}
/**
* Checks if the media object is selected.
*/ function $a013102e0bac7fe2$var$isMediaSelected(selection) {
    const element = selection.getSelectedElement();
    return !!element && element.name === "media";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaregistry
*/ const $a013102e0bac7fe2$var$mediaPlaceholderIconViewBox = "0 0 64 42";
/**
* A bridge between the raw media content provider definitions and the editor view content.
*
* It helps translating media URLs to corresponding {@link module:engine/view/element~ViewElement view elements}.
*
* Mostly used by the {@link module:media-embed/mediaembedediting~MediaEmbedEditing} plugin.
*/ var $a013102e0bac7fe2$export$3fed5438d4f09080 = class {
    /**
	* The {@link module:utils/locale~Locale} instance.
	*/ locale;
    /**
	* The media provider definitions available for the registry. Usually corresponding with the
	* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig media configuration}.
	*/ providerDefinitions;
    /**
	* Creates an instance of the {@link module:media-embed/mediaregistry~MediaRegistry} class.
	*
	* @param locale The localization services instance.
	* @param config The configuration of the media embed feature.
	*/ constructor(locale, config){
        const providers = config.providers;
        const extraProviders = config.extraProviders || [];
        const removedProviders = new Set(config.removeProviders);
        const providerDefinitions = providers.concat(extraProviders).filter((provider)=>{
            const name = provider.name;
            if (!name) {
                /**
				* One of the providers (or extra providers) specified in the media embed configuration
				* has no name and will not be used by the editor. In order to get this media
				* provider working, double check your editor configuration.
				*
				* @error media-embed-no-provider-name
				*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("media-embed-no-provider-name", {
                    provider: provider
                });
                return false;
            }
            return !removedProviders.has(name);
        });
        this.locale = locale;
        this.providerDefinitions = providerDefinitions;
    }
    /**
	* Checks whether the passed URL is representing a certain media type allowed in the editor.
	*
	* @param url The URL to be checked
	*/ hasMedia(url) {
        return !!this._getMedia(url);
    }
    /**
	* For the given media URL string and options, it returns the {@link module:engine/view/element~ViewElement view element}
	* representing that media.
	*
	* **Note:** If no URL is specified, an empty view element is returned.
	*
	* @param writer The view writer used to produce a view element.
	* @param url The URL to be translated into a view element.
	*/ getMediaViewElement(writer, url, options) {
        return this._getMedia(url).getViewElement(writer, options);
    }
    /**
	* Returns a `Media` instance for the given URL.
	*
	* @param url The URL of the media.
	* @returns The `Media` instance or `null` when there is none.
	*/ _getMedia(url) {
        if (!url) return new $a013102e0bac7fe2$var$Media(this.locale);
        url = url.trim();
        for (const definition of this.providerDefinitions){
            const previewRenderer = definition.html;
            const pattern = (0, $c7bc2cb7e2db0227$export$45b10814cc054894)(definition.url);
            for (const subPattern of pattern){
                const match = this._getUrlMatches(url, subPattern);
                if (match) return new $a013102e0bac7fe2$var$Media(this.locale, url, match, previewRenderer);
            }
        }
        return null;
    }
    /**
	* Tries to match `url` to `pattern`.
	*
	* @param url The URL of the media.
	* @param pattern The pattern that should accept the media URL.
	*/ _getUrlMatches(url, pattern) {
        let match = url.match(pattern);
        if (match) return match;
        let rawUrl = url.replace(/^https?:\/\//, "");
        match = rawUrl.match(pattern);
        if (match) return match;
        rawUrl = rawUrl.replace(/^www\./, "");
        match = rawUrl.match(pattern);
        if (match) return match;
        return null;
    }
};
/**
* Represents media defined by the provider configuration.
*
* It can be rendered to the {@link module:engine/view/element~ViewElement view element} and used in the editing or data pipeline.
*/ var $a013102e0bac7fe2$var$Media = class {
    /**
	* The URL this Media instance represents.
	*/ url;
    /**
	* Shorthand for {@link module:utils/locale~Locale#t}.
	*
	* @see module:utils/locale~Locale#t
	*/ _locale;
    /**
	* The output of the `RegExp.match` which validated the {@link #url} of this media.
	*/ _match;
    /**
	* The function returning the HTML string preview of this media.
	*/ _previewRenderer;
    constructor(locale, url, match, previewRenderer){
        this.url = this._getValidUrl(url);
        this._locale = locale;
        this._match = match;
        this._previewRenderer = previewRenderer;
    }
    /**
	* Returns the view element representation of the media.
	*
	* @param writer The view writer used to produce a view element.
	*/ getViewElement(writer, options) {
        const attributes = {};
        let viewElement;
        if (options.renderForEditingView || options.renderMediaPreview && this.url && this._previewRenderer) {
            if (this.url) attributes["data-oembed-url"] = this.url;
            if (options.renderForEditingView) attributes.class = "ck-media__wrapper";
            const mediaHtml = this._getPreviewHtml(options);
            viewElement = writer.createRawElement("div", attributes, (domElement, domConverter)=>{
                domConverter.setContentOf(domElement, mediaHtml);
            });
        } else {
            if (this.url) attributes.url = this.url;
            viewElement = writer.createEmptyElement(options.elementName, attributes);
        }
        writer.setCustomProperty("media-content", true, viewElement);
        return viewElement;
    }
    /**
	* Returns the HTML string of the media content preview.
	*/ _getPreviewHtml(options) {
        if (this._previewRenderer) return this._previewRenderer(this._match);
        else {
            if (this.url && options.renderForEditingView) return this._getPlaceholderHtml();
            return "";
        }
    }
    /**
	* Returns the placeholder HTML when the media has no content preview.
	*/ _getPlaceholderHtml() {
        const icon = new (0, $29fd27cb9bdab9d2$export$212c60ac61334981)();
        const t = this._locale.t;
        icon.content = (0, $e8dc502aba5ac3f5$export$55c39fa63267dcf8);
        icon.viewBox = $a013102e0bac7fe2$var$mediaPlaceholderIconViewBox;
        return new (0, $29fd27cb9bdab9d2$export$14416b8d99d47caa)({
            tag: "div",
            attributes: {
                class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [
                {
                    tag: "div",
                    attributes: {
                        class: "ck-media__placeholder__icon"
                    },
                    children: [
                        icon
                    ]
                },
                {
                    tag: "a",
                    attributes: {
                        class: "ck-media__placeholder__url",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: this.url,
                        "data-cke-tooltip-text": t("Open media in new tab")
                    },
                    children: [
                        {
                            tag: "span",
                            attributes: {
                                class: "ck-media__placeholder__url__text"
                            },
                            children: [
                                this.url
                            ]
                        }
                    ]
                }
            ]
        }).render().outerHTML;
    }
    /**
	* Returns the full URL to the specified media.
	*
	* @param url The URL of the media.
	*/ _getValidUrl(url) {
        if (!url) return null;
        if (url.match(/^https?/)) return url;
        return "https://" + url;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedediting
*/ /**
* The media embed editing feature.
*/ var $a013102e0bac7fe2$export$6a94509908b7440 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The media registry managing the media providers in the editor.
	*/ registry;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("mediaEmbed", {
            elementName: "oembed",
            providers: [
                {
                    name: "dailymotion",
                    url: [
                        /^dailymotion\.com\/video\/(\w+)/,
                        /^dai.ly\/(\w+)/
                    ],
                    html: (match)=>{
                        return `<div><iframe src="https://www.dailymotion.com/embed/video/${match[1]}" width="1280" height="720" style="width: 100%; height: auto; aspect-ratio: 16 / 9; border: 0; display: block;" frameborder="0" allowfullscreen allow="autoplay"></iframe></div>`;
                    }
                },
                {
                    name: "spotify",
                    url: [
                        /^open\.spotify\.com\/(artist\/\w+)/,
                        /^open\.spotify\.com\/(album\/\w+)/,
                        /^open\.spotify\.com\/(track\/\w+)/
                    ],
                    html: (match)=>{
                        const id = match[1];
                        const isTrack = id.startsWith("track/");
                        return `<div><iframe src="https://open.spotify.com/embed/${id}" width="300" height="${isTrack ? "80" : "378"}" style="${isTrack ? "width: 100%; height: 80px; border: 0; display: block;" : "width: 100%; height: auto; aspect-ratio: 100 / 126; border: 0; display: block;"}" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`;
                    }
                },
                {
                    name: "youtube",
                    url: [
                        /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
                        /^(?:m\.)?youtube\.com\/shorts\/([\w-]+)(?:\?t=(\d+))?/,
                        /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
                        /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
                        /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/
                    ],
                    html: (match)=>{
                        const id = match[1];
                        const time = match[2];
                        return `<div><iframe src="https://www.youtube.com/embed/${id}${time ? `?start=${time}` : ""}" width="1280" height="720" style="width: 100%; height: auto; aspect-ratio: 16 / 9; border: 0; display: block;" frameborder="0" allow="autoplay; encrypted-media" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>`;
                    }
                },
                {
                    name: "vimeo",
                    url: [
                        /^vimeo\.com\/(\d+)/,
                        /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                        /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                        /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                        /^player\.vimeo\.com\/video\/(\d+)/
                    ],
                    html: (match)=>{
                        return `<div><iframe src="https://player.vimeo.com/video/${match[1]}" width="1280" height="720" style="width: 100%; height: auto; aspect-ratio: 16 / 9; border: 0; display: block;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`;
                    }
                },
                {
                    name: "instagram",
                    url: [
                        /^instagram\.com\/p\/(\w+)/,
                        /^instagram\.com\/reel\/(\w+)/
                    ]
                },
                {
                    name: "twitter",
                    url: [
                        /^twitter\.com/,
                        /^x\.com/
                    ]
                },
                {
                    name: "googleMaps",
                    url: [
                        /^google\.com\/maps/,
                        /^goo\.gl\/maps/,
                        /^maps\.google\.com/,
                        /^maps\.app\.goo\.gl/
                    ]
                },
                {
                    name: "flickr",
                    url: /^flickr\.com/
                },
                {
                    name: "facebook",
                    url: /^facebook\.com/
                }
            ]
        });
        this.registry = new $a013102e0bac7fe2$export$3fed5438d4f09080(editor.locale, editor.config.get("mediaEmbed"));
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const t = editor.t;
        const conversion = editor.conversion;
        const renderMediaPreview = editor.config.get("mediaEmbed.previewsInData");
        const elementName = editor.config.get("mediaEmbed.elementName");
        const registry = this.registry;
        editor.commands.add("mediaEmbed", new $a013102e0bac7fe2$export$c99ee3f28cac4223(editor));
        schema.register("media", {
            inheritAllFrom: "$blockObject",
            allowAttributes: [
                "url"
            ]
        });
        conversion.for("dataDowncast").elementToStructure({
            model: "media",
            view: (modelElement, { writer: writer })=>{
                const url = modelElement.getAttribute("url");
                return $a013102e0bac7fe2$export$1c1f5415931ed711(writer, registry, url, {
                    elementName: elementName,
                    renderMediaPreview: !!url && renderMediaPreview
                });
            }
        });
        conversion.for("dataDowncast").add($a013102e0bac7fe2$export$edce555db3dc6d2d(registry, {
            elementName: elementName,
            renderMediaPreview: renderMediaPreview
        }));
        conversion.for("editingDowncast").elementToStructure({
            model: "media",
            view: (modelElement, { writer: writer })=>{
                const url = modelElement.getAttribute("url");
                const figure = $a013102e0bac7fe2$export$1c1f5415931ed711(writer, registry, url, {
                    elementName: elementName,
                    renderForEditingView: true
                });
                return $a013102e0bac7fe2$export$b3a7ce307c6a9f8d(figure, writer, t("media widget"));
            }
        });
        conversion.for("editingDowncast").add($a013102e0bac7fe2$export$edce555db3dc6d2d(registry, {
            elementName: elementName,
            renderForEditingView: true
        }));
        conversion.for("upcast").elementToElement({
            view: (element)=>[
                    "oembed",
                    elementName
                ].includes(element.name) && element.getAttribute("url") ? {
                    name: true
                } : null,
            model: (viewMedia, { writer: writer })=>{
                const url = viewMedia.getAttribute("url");
                if (registry.hasMedia(url)) return writer.createElement("media", {
                    url: url
                });
                return null;
            }
        }).elementToElement({
            view: {
                name: "div",
                attributes: {
                    "data-oembed-url": true
                }
            },
            model: (viewMedia, { writer: writer })=>{
                const url = viewMedia.getAttribute("data-oembed-url");
                if (registry.hasMedia(url)) return writer.createElement("media", {
                    url: url
                });
                return null;
            }
        }).add((dispatcher)=>{
            const converter = (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.viewItem, {
                    name: true,
                    classes: "media"
                })) return;
                const { modelRange: modelRange, modelCursor: modelCursor } = conversionApi.convertChildren(data.viewItem, data.modelCursor);
                data.modelRange = modelRange;
                data.modelCursor = modelCursor;
                if (!(0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(modelRange.getItems())) conversionApi.consumable.revert(data.viewItem, {
                    name: true,
                    classes: "media"
                });
            };
            dispatcher.on("element:figure", converter);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/automediaembed
*/ const $a013102e0bac7fe2$var$URL_REGEXP = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
/**
* The auto-media embed plugin. It recognizes media links in the pasted content and embeds
* them shortly after they are injected into the document.
*/ var $a013102e0bac7fe2$export$6272cbe4b22dad8a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $4fa913ac1af6a08c$export$8b44c43c7d8f0830),
            (0, $f1defb5a0a139b4c$export$bfadae053a633538),
            (0, $d1f24276bd81b655$export$897c9ed706d8ea48)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "AutoMediaEmbed";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The paste–to–embed `setTimeout` ID. Stored as a property to allow
	* cleaning of the timeout.
	*/ _timeoutId;
    /**
	* The position where the `<media>` element will be inserted after the timeout,
	* determined each time the new content is pasted into the document.
	*/ _positionToInsert;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._timeoutId = null;
        this._positionToInsert = null;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const modelDocument = editor.model.document;
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "inputTransformation", ()=>{
            const firstRange = modelDocument.selection.getFirstRange();
            const leftLivePosition = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(firstRange.start);
            leftLivePosition.stickiness = "toPrevious";
            const rightLivePosition = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(firstRange.end);
            rightLivePosition.stickiness = "toNext";
            modelDocument.once("change:data", ()=>{
                this._embedMediaBetweenPositions(leftLivePosition, rightLivePosition);
                leftLivePosition.detach();
                rightLivePosition.detach();
            }, {
                priority: "high"
            });
        });
        editor.commands.get("undo").on("execute", ()=>{
            if (this._timeoutId) {
                (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.clearTimeout(this._timeoutId);
                this._positionToInsert.detach();
                this._timeoutId = null;
                this._positionToInsert = null;
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Analyzes the part of the document between provided positions in search for a URL representing media.
	* When the URL is found, it is automatically converted into media.
	*
	* @param leftPosition Left position of the selection.
	* @param rightPosition Right position of the selection.
	*/ _embedMediaBetweenPositions(leftPosition, rightPosition) {
        const editor = this.editor;
        const mediaRegistry = editor.plugins.get($a013102e0bac7fe2$export$6a94509908b7440).registry;
        const urlRange = new (0, $b9b9f2bdf9c6137f$export$a20b9237842cdd3f)(leftPosition, rightPosition);
        const walker = urlRange.getWalker({
            ignoreElementEnd: true
        });
        let url = "";
        for (const node of walker)if (node.item.is("$textProxy")) url += node.item.data;
        url = url.trim();
        if (!url.match($a013102e0bac7fe2$var$URL_REGEXP)) {
            urlRange.detach();
            return;
        }
        if (!mediaRegistry.hasMedia(url)) {
            urlRange.detach();
            return;
        }
        if (!editor.commands.get("mediaEmbed").isEnabled) {
            urlRange.detach();
            return;
        }
        this._positionToInsert = (0, $b9b9f2bdf9c6137f$export$e9dab424d71bca79).fromPosition(leftPosition);
        this._timeoutId = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.setTimeout(()=>{
            editor.model.change((writer)=>{
                this._timeoutId = null;
                writer.remove(urlRange);
                urlRange.detach();
                let insertionPosition = null;
                if (this._positionToInsert.root.rootName !== "$graveyard") insertionPosition = this._positionToInsert;
                $a013102e0bac7fe2$export$903bb2626485ac41(editor.model, url, insertionPosition, false);
                this._positionToInsert.detach();
                this._positionToInsert = null;
            });
            editor.plugins.get((0, $f1defb5a0a139b4c$export$bfadae053a633538)).requestUndoOnBackspace();
        }, 100);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/ui/mediaformview
*/ /**
* The media form view controller class.
*
* See {@link module:media-embed/ui/mediaformview~MediaFormView}.
*/ var $a013102e0bac7fe2$export$1bdce6213739702a = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* The URL input view.
	*/ urlInputView;
    /**
	* An array of form validators used by {@link #isValid}.
	*/ _validators;
    /**
	* The default info text for the {@link #urlInputView}.
	*/ _urlInputViewInfoDefault;
    /**
	* The info text with an additional tip for the {@link #urlInputView},
	* displayed when the input has some value.
	*/ _urlInputViewInfoTip;
    /**
	* @param validators Form validators used by {@link #isValid}.
	* @param locale The localization services instance.
	*/ constructor(validators, locale){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.set("mediaURLInputValue", "");
        this.urlInputView = this._createUrlInput();
        this._validators = validators;
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-media-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: [
                this.urlInputView
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        this.focusTracker.add(this.urlInputView.element);
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the {@link #urlInputView}.
	*/ focus() {
        this.urlInputView.focus();
    }
    /**
	* The native DOM `value` of the {@link #urlInputView} element.
	*
	* **Note**: Do not confuse it with the {@link module:ui/inputtext/inputtextview~InputTextView#value}
	* which works one way only and may not represent the actual state of the component in the DOM.
	*/ get url() {
        return this.urlInputView.fieldView.element.value.trim();
    }
    set url(url) {
        this.urlInputView.fieldView.value = url.trim();
    }
    /**
	* Validates the form and returns `false` when some fields are invalid.
	*/ isValid() {
        this.resetFormStatus();
        for (const validator of this._validators){
            const errorText = validator(this);
            if (errorText) {
                this.urlInputView.errorText = errorText;
                return false;
            }
        }
        return true;
    }
    /**
	* Cleans up the supplementary error and information text of the {@link #urlInputView}
	* bringing them back to the state when the form has been displayed for the first time.
	*
	* See {@link #isValid}.
	*/ resetFormStatus() {
        this.urlInputView.errorText = null;
        this.urlInputView.infoText = this._urlInputViewInfoDefault;
    }
    /**
	* Creates a labeled input view.
	*
	* @returns Labeled input view instance.
	*/ _createUrlInput() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        const inputField = labeledInput.fieldView;
        this._urlInputViewInfoDefault = t("Paste the media URL in the input.");
        this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster.");
        labeledInput.label = t("Media URL");
        labeledInput.infoText = this._urlInputViewInfoDefault;
        inputField.inputMode = "url";
        inputField.on("input", ()=>{
            labeledInput.infoText = inputField.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault;
            this.mediaURLInputValue = inputField.element.value.trim();
        });
        return labeledInput;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedui
*/ /**
* The media embed UI plugin.
*/ var $a013102e0bac7fe2$export$60ecac3c530df78 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$6a94509908b7440,
            (0, $29fd27cb9bdab9d2$export$3ddf2d174ce01153)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    _formView;
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("mediaEmbed", ()=>{
            const t = this.editor.locale.t;
            const button = this._createDialogButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.tooltip = true;
            button.label = t("Insert media");
            return button;
        });
        editor.ui.componentFactory.add("menuBar:mediaEmbed", ()=>{
            const t = this.editor.locale.t;
            const button = this._createDialogButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
            button.label = t("Media");
            return button;
        });
    }
    /**
	* Creates a button for menu bar that will show media embed dialog.
	*/ _createDialogButton(ButtonClass) {
        const editor = this.editor;
        const buttonView = new ButtonClass(editor.locale);
        const command = editor.commands.get("mediaEmbed");
        const dialogPlugin = this.editor.plugins.get("Dialog");
        buttonView.icon = (0, $e8dc502aba5ac3f5$export$6819bb515dea7c36);
        buttonView.bind("isEnabled").to(command, "isEnabled");
        buttonView.on("execute", ()=>{
            if (dialogPlugin.id === "mediaEmbed") dialogPlugin.hide();
            else this._showDialog();
        });
        return buttonView;
    }
    _showDialog() {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        const command = editor.commands.get("mediaEmbed");
        const t = editor.locale.t;
        const isMediaSelected = command.value !== void 0;
        if (!this._formView) {
            const registry = editor.plugins.get($a013102e0bac7fe2$export$6a94509908b7440).registry;
            this._formView = new ((0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($a013102e0bac7fe2$export$1bdce6213739702a))($a013102e0bac7fe2$var$getFormValidators$1(editor.t, registry), editor.locale);
            this._formView.on("submit", ()=>this._handleSubmitForm());
        }
        dialog.show({
            id: "mediaEmbed",
            title: t("Media embed"),
            content: this._formView,
            isModal: true,
            onShow: ()=>{
                this._formView.url = command.value || "";
                this._formView.resetFormStatus();
                this._formView.urlInputView.fieldView.select();
            },
            actionButtons: [
                {
                    label: t("Cancel"),
                    withText: true,
                    onExecute: ()=>dialog.hide()
                },
                {
                    label: isMediaSelected ? t("Save") : t("Insert"),
                    class: "ck-button-action",
                    withText: true,
                    onExecute: ()=>this._handleSubmitForm()
                }
            ]
        });
    }
    _handleSubmitForm() {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        if (this._formView.isValid()) {
            editor.execute("mediaEmbed", this._formView.url);
            dialog.hide();
            editor.editing.view.focus();
        }
    }
};
function $a013102e0bac7fe2$var$getFormValidators$1(t, registry) {
    return [
        (form)=>{
            if (!form.url.length) return t("The URL must not be empty.");
        },
        (form)=>{
            if (!registry.hasMedia(form.url)) return t("This media URL is not supported.");
        }
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembed
*/ /**
* The media embed plugin.
*
* For a detailed overview, check the {@glink features/media-embed/media-embed Media Embed feature documentation}.
*
* This is a "glue" plugin which loads the following plugins:
*
* * The {@link module:media-embed/mediaembedediting~MediaEmbedEditing media embed editing feature},
* * The {@link module:media-embed/mediaembedui~MediaEmbedUI media embed UI feature} and
* * The {@link module:media-embed/automediaembed~AutoMediaEmbed auto-media embed feature}.
*/ var $a013102e0bac7fe2$export$4b6510ff30f01098 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$6a94509908b7440,
            $a013102e0bac7fe2$export$60ecac3c530df78,
            $a013102e0bac7fe2$export$6272cbe4b22dad8a,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbed";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle/constants
*/ /**
* Built-in style options provided by the plugin. Integrators can refer to these by
* name in {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles`}
* to opt out, override individual fields, or coexist with custom styles.
*
* @internal
*/ const $a013102e0bac7fe2$var$DEFAULT_OPTIONS = {
    alignLeft: {
        name: "alignLeft",
        title: "Left aligned media",
        icon: (0, $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e),
        className: "media-style-align-left"
    },
    alignBlockLeft: {
        name: "alignBlockLeft",
        title: "Left aligned media",
        icon: (0, $e8dc502aba5ac3f5$export$109641c0512af225),
        className: "media-style-block-align-left"
    },
    alignCenter: {
        name: "alignCenter",
        title: "Centered media",
        icon: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
        isDefault: true
    },
    alignBlockRight: {
        name: "alignBlockRight",
        title: "Right aligned media",
        icon: (0, $e8dc502aba5ac3f5$export$12c57266ee03e50a),
        className: "media-style-block-align-right"
    },
    alignRight: {
        name: "alignRight",
        title: "Right aligned media",
        icon: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738),
        className: "media-style-align-right"
    }
};
/**
* Short icon-name aliases that can be used as the `icon` value in a media style
* option definition. Matches the alias set exposed by the image styles feature so
* the two APIs feel symmetrical.
*
* @internal
*/ const $a013102e0bac7fe2$var$DEFAULT_ICONS = {
    inlineLeft: (0, $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e),
    left: (0, $e8dc502aba5ac3f5$export$109641c0512af225),
    center: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
    right: (0, $e8dc502aba5ac3f5$export$12c57266ee03e50a),
    inlineRight: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738)
};
/**
* Built-in dropdown groupings. Each entry references built-in style component names. If any
* items are filtered out by configuration, the dropdown is rebuilt from the remaining names
* (or skipped entirely if fewer than two remain).
*
* @internal
*/ const $a013102e0bac7fe2$var$DEFAULT_DROPDOWN_DEFINITIONS = [
    {
        name: "mediaEmbed:wrapText",
        title: "Wrap text",
        items: [
            "mediaEmbed:alignLeft",
            "mediaEmbed:alignRight"
        ],
        defaultItem: "mediaEmbed:alignLeft"
    },
    {
        name: "mediaEmbed:breakText",
        title: "Break text",
        items: [
            "mediaEmbed:alignBlockLeft",
            "mediaEmbed:alignCenter",
            "mediaEmbed:alignBlockRight"
        ],
        defaultItem: "mediaEmbed:alignCenter"
    }
];
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle/utils
*/ /**
* Normalizes the {@link module:media-embed/mediaembedconfig~MediaStyleConfig#options style options}
* provided by the integrator. Each entry is resolved into a full
* {@link module:media-embed/mediaembedconfig~MediaStyleOptionDefinition} and invalid entries
* are filtered out with a console warning.
*
* @internal
*/ function $a013102e0bac7fe2$var$normalizeStyles(configuredStyles) {
    return (configuredStyles.options || []).map((entry)=>$a013102e0bac7fe2$var$normalizeDefinition(entry)).filter((entry)=>$a013102e0bac7fe2$var$isValidOption(entry));
}
/**
* Resolves a single config entry into a style option definition. A string entry is first
* promoted to its object form (`{ name }`) and then shallow-merged on top of the matching
* built-in default — entries without a matching built-in pass through unchanged and are
* rejected by {@link ~isValidOption} if they lack required fields.
*
* Also resolves icon-name aliases (`'left'`, `'inlineLeft'`, etc.) to the corresponding
* SVG sources from {@link module:media-embed/mediaembedstyle/constants~DEFAULT_ICONS}.
*/ function $a013102e0bac7fe2$var$normalizeDefinition(entry) {
    const override = typeof entry === "string" ? {
        name: entry
    } : entry;
    const definition = {
        ...$a013102e0bac7fe2$var$DEFAULT_OPTIONS[override.name],
        ...override
    };
    if (typeof definition.icon === "string" && $a013102e0bac7fe2$var$DEFAULT_ICONS[definition.icon]) definition.icon = $a013102e0bac7fe2$var$DEFAULT_ICONS[definition.icon];
    return definition;
}
/**
* Validates a normalized style option. `name`, `title`, and `icon` are always required.
* `className` is required unless the entry is the default style (defaults encode as
* attribute-absence and intentionally have no class). Emits a console warning and returns
* `false` when any of these checks fails.
*/ function $a013102e0bac7fe2$var$isValidOption(option) {
    if (!option.name || !option.title || !option.icon || !option.isDefault && !option.className) {
        $a013102e0bac7fe2$var$warnInvalidStyle({
            style: option
        });
        return false;
    }
    return true;
}
function $a013102e0bac7fe2$var$warnInvalidStyle(info) {
    /**
	* The media style configuration provided in the editor config is invalid. The warning is
	* emitted in two situations:
	*
	* * An entry in {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles.options`}
	*   does not reference a built-in style by name (`'alignLeft'`, `'alignBlockLeft'`,
	*   `'alignCenter'`, `'alignBlockRight'`, `'alignRight'`) and does not follow the
	*   {@link module:media-embed/mediaembedconfig~MediaStyleOptionDefinition} shape —
	*   `name`, `title`, `icon`, and (unless `isDefault: true`) `className` are required.
	*   The offending entry is reported under the `style` parameter.
	* * A dropdown entry placed inline in
	*   {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#toolbar `config.mediaEmbed.toolbar`}
	*   does not follow the {@link module:media-embed/mediaembedconfig~MediaStyleDropdownDefinition} shape
	*   (`name` and every `items[]` entry must use the full `mediaEmbed:` prefix, `defaultItem` must
	*   be one of the `items`, `title` must be a non-empty string), or its `items[]` reference styles
	*   that are not in the resolved
	*   {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles`} list.
	*   The offending entry is reported under the `dropdown` parameter.
	*
	* @error media-style-configuration-definition-invalid
	*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("media-style-configuration-definition-invalid", info);
}
/**
* Type guard for toolbar config entries shaped like a media style dropdown definition. The
* discriminator is `defaultItem` — generic toolbar groupings use `items` + `label` and never
* carry a `defaultItem` field.
*
* @internal
*/ function $a013102e0bac7fe2$var$isMediaStyleDropdown(item) {
    return typeof item === "object" && item !== null && typeof item.defaultItem === "string";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedtoolbar
*/ /**
* The media embed toolbar plugin. It creates a toolbar for media embed that shows up when the media element is selected.
*
* Instances of toolbar components (e.g. buttons) are created based on the
* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#toolbar `media.toolbar` configuration option}.
*/ var $a013102e0bac7fe2$export$c43aa1d69e50b495 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $5547ab21e02f1e9e$export$c46c0a800280391d)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get((0, $5547ab21e02f1e9e$export$c46c0a800280391d)).register("mediaEmbed", {
            ariaLabel: t("Media toolbar"),
            items: $a013102e0bac7fe2$var$normalizeDeclarativeConfig(editor.ui.componentFactory, editor.config.get("mediaEmbed.toolbar") || []),
            getRelatedElement: $a013102e0bac7fe2$export$3a7cbcf8a9330686
        });
    }
};
/**
* Flattens dropdown definitions to their factory names, dropping any `mediaEmbed:`-prefixed
* name the style UI did not register — otherwise the toolbar crashes with `componentfactory-item-missing`.
* Non-string entries (e.g. generic `{ label, items }` toolbar groupings) pass through unchanged.
*/ function $a013102e0bac7fe2$var$normalizeDeclarativeConfig(factory, config) {
    return config.map((item)=>$a013102e0bac7fe2$var$isMediaStyleDropdown(item) ? item.name : item).filter((item)=>typeof item !== "string" || !item.startsWith("mediaEmbed:") || factory.has(item));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/resizemediaembedcommand
*/ /**
* The resize media embed command.
*/ var $a013102e0bac7fe2$export$8332cbc2003ef0c5 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const element = $a013102e0bac7fe2$export$7d10b9adbd1016cb(this.editor.model.document.selection);
        this.isEnabled = !!element;
        if (!element || !element.hasAttribute("resizedWidth")) this.value = null;
        else this.value = element.getAttribute("resizedWidth");
    }
    /**
	* Executes the command.
	*
	* ```ts
	* // Sets the width as a percentage of the parent width:
	* editor.execute( 'resizeMediaEmbed', { width: '50%' } );
	*
	* // Removes the resize and restores the default width:
	* editor.execute( 'resizeMediaEmbed', { width: null } );
	* ```
	*
	* @param options
	* @param options.width The new width of the media embed as a CSS `width` value
	* (e.g. `'50%'`), or `null` to remove the resize.
	* @fires execute
	*/ execute(options) {
        const model = this.editor.model;
        const mediaElement = $a013102e0bac7fe2$export$7d10b9adbd1016cb(model.document.selection);
        if (mediaElement) model.change((writer)=>{
            writer.setAttribute("resizedWidth", options.width, mediaElement);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/constants
*/ /**
* The view class applied to a resized media embed figure.
*
* Shared between the editing plugin (which toggles it via downcast of `resizedWidth` and consumes
* it on upcast) and the handles plugin (which adds it during drag and strips it on commit), so
* both layers agree on the exact class name.
*
* @internal
*/ const $a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS = "media_resized";
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The media embed resize editing feature.
*
* It adds the ability to resize each media embed using handles.
*/ var $a013102e0bac7fe2$export$e6a71d8230d6d42c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$6a94509908b7440
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedResizeEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "MER";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("mediaEmbed", {
            resizeUnit: "%",
            resizeOptions: [
                {
                    name: "resizeMediaEmbed:original",
                    value: null,
                    icon: "original"
                },
                {
                    name: "resizeMediaEmbed:custom",
                    value: "custom",
                    icon: "custom"
                },
                {
                    name: "resizeMediaEmbed:25",
                    value: "25",
                    icon: "small"
                },
                {
                    name: "resizeMediaEmbed:50",
                    value: "50",
                    icon: "medium"
                },
                {
                    name: "resizeMediaEmbed:75",
                    value: "75",
                    icon: "large"
                }
            ]
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.commands.add("resizeMediaEmbed", new $a013102e0bac7fe2$export$8332cbc2003ef0c5(editor));
        this._registerConverters();
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        this._registerSchema();
    }
    _registerSchema() {
        const schema = this.editor.model.schema;
        schema.extend("media", {
            allowAttributes: [
                "resizedWidth"
            ]
        });
        schema.setAttributeProperties("resizedWidth", {
            isFormatting: true
        });
    }
    /**
	* Registers media embed resize converters.
	*/ _registerConverters() {
        const editor = this.editor;
        editor.conversion.for("downcast").add((dispatcher)=>dispatcher.on("attribute:resizedWidth:media", (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const viewWriter = conversionApi.writer;
                const figure = conversionApi.mapper.toViewElement(data.item);
                if (data.attributeNewValue !== null) {
                    viewWriter.setStyle("width", data.attributeNewValue, figure);
                    viewWriter.addClass($a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS, figure);
                } else {
                    viewWriter.removeStyle("width", figure);
                    viewWriter.removeClass($a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS, figure);
                }
            }));
        editor.conversion.for("upcast").attributeToAttribute({
            view: {
                name: "figure",
                styles: {
                    width: /.+/
                }
            },
            model: {
                key: "resizedWidth",
                value: (viewElement)=>{
                    if (!viewElement.hasClass("media")) return null;
                    return viewElement.getStyle("width");
                }
            }
        });
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:figure", (evt, data, conversionApi)=>{
                conversionApi.consumable.consume(data.viewItem, {
                    classes: [
                        $a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS
                    ]
                });
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The media embed resize by handles feature.
*
* It adds the ability to resize each media embed using handles.
*/ var $a013102e0bac7fe2$export$f9292815a0bddb92 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedResizeHandles";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const command = this.editor.commands.get("resizeMediaEmbed");
        this.bind("isEnabled").to(command);
        this._setupResizerCreator();
    }
    /**
	* Attaches a resizer to every newly inserted media widget. Walks only the ranges
	* reported by the differ — never the whole document — so unrelated inserts (e.g.
	* pressing Enter to create a paragraph) cost only the differ check.
	*
	* Each resizer's `isEnabled` is bound to the plugin in {@link #_attachResizer},
	* so it auto-tracks the resize command's state.
	*/ _setupResizerCreator() {
        const editor = this.editor;
        const model = editor.model;
        const widgetResize = editor.plugins.get((0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9));
        this.listenTo(model.document, "change:data", ()=>{
            for (const change of model.document.differ.getChanges()){
                if (change.type !== "insert" || change.name === "$text") continue;
                const insertedRange = model.createRange(change.position, change.position.getShiftedBy(change.length));
                for (const item of insertedRange.getItems()){
                    if (!item.is("element", "media")) continue;
                    const viewElement = editor.editing.mapper.toViewElement(item);
                    /* v8 ignore next -- @preserve */ if (!viewElement) continue;
                    /* v8 ignore else -- @preserve */ if (!widgetResize.getResizerByViewElement(viewElement)) this._attachResizer(item, viewElement);
                }
            }
        }, {
            priority: "low"
        });
    }
    /**
	* Attaches a resizer to a single media widget.
	*/ _attachResizer(modelElement, widgetView) {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const resizer = editor.plugins.get((0, $5547ab21e02f1e9e$export$5584c2e1cd85ebe9)).attachTo({
            unit: editor.config.get("mediaEmbed.resizeUnit"),
            modelElement: modelElement,
            viewElement: widgetView,
            editor: editor,
            getHandleHost: (domWidgetElement)=>domWidgetElement.querySelector(".ck-media__wrapper"),
            getResizeHost: (domWidgetElement)=>domWidgetElement,
            onCommit: (newValue)=>{
                editingView.change((writer)=>writer.removeClass($a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS, widgetView));
                editor.execute("resizeMediaEmbed", {
                    width: newValue
                });
            }
        });
        resizer.bind("isEnabled").to(this);
        resizer.on("updateSize", ()=>{
            if (!widgetView.hasClass("media_resized")) editingView.change((writer)=>writer.addClass($a013102e0bac7fe2$var$RESIZED_MEDIA_CLASS, widgetView));
        });
        editingView.once("render", ()=>resizer.redraw());
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/mediaembedresizebuttons
*/ const $a013102e0bac7fe2$var$RESIZE_ICONS = /* #__PURE__ */ (()=>({
        small: (0, $e8dc502aba5ac3f5$export$d5ebd621e65c3406),
        medium: (0, $e8dc502aba5ac3f5$export$d617f0cc61264eda),
        large: (0, $e8dc502aba5ac3f5$export$62e00d4298f7a20b),
        custom: (0, $e8dc502aba5ac3f5$export$8877d472d8bae6e3),
        original: (0, $e8dc502aba5ac3f5$export$76e3fa0e80a872d8)
    }))();
/**
* The media embed resize buttons plugin.
*
* It adds a possibility to resize media embeds using the toolbar dropdown or individual buttons,
* depending on the plugin configuration.
*/ var $a013102e0bac7fe2$export$4101f4ac14dc7ab0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$e6a71d8230d6d42c
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedResizeButtons";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    _resizeUnit;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._resizeUnit = editor.config.get("mediaEmbed.resizeUnit");
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const options = editor.config.get("mediaEmbed.resizeOptions");
        const command = editor.commands.get("resizeMediaEmbed");
        this.bind("isEnabled").to(command);
        for (const option of options)this._registerMediaEmbedResizeButton(option);
        this._registerMediaEmbedResizeDropdown(options);
    }
    /**
	* Creates a standalone button component for the given resize option.
	*/ _registerMediaEmbedResizeButton(option) {
        const editor = this.editor;
        const { name: name, value: value, icon: icon } = option;
        editor.ui.componentFactory.add(name, (locale)=>{
            const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            const command = editor.commands.get("resizeMediaEmbed");
            const labelText = this._getOptionLabelValue(option, true);
            if (!$a013102e0bac7fe2$var$RESIZE_ICONS[icon]) /**
			* When configuring {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#resizeOptions
			* `config.mediaEmbed.resizeOptions`} for standalone buttons, a valid `icon` token must be set for each option.
			*
			* See all valid options described in the
			* {@link module:media-embed/mediaembedconfig~MediaEmbedResizeOption plugin configuration}.
			*
			* @error mediaembedresizebuttons-missing-icon
			* @param {module:media-embed/mediaembedconfig~MediaEmbedResizeOption} option Invalid media embed resize option.
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("mediaembedresizebuttons-missing-icon", editor, option);
            button.set({
                label: labelText,
                icon: $a013102e0bac7fe2$var$RESIZE_ICONS[icon],
                tooltip: labelText,
                isToggleable: true
            });
            button.bind("isEnabled").to(this);
            if (editor.plugins.has("MediaEmbedCustomResizeUI") && $a013102e0bac7fe2$var$isCustomMediaEmbedResizeOption(option)) {
                const customResizeUI = editor.plugins.get("MediaEmbedCustomResizeUI");
                this.listenTo(button, "execute", ()=>{
                    customResizeUI._showForm(this._resizeUnit);
                });
            } else {
                const optionValueWithUnit = value ? value + this._resizeUnit : null;
                button.bind("isOn").to(command, "value", command, "isEnabled", $a013102e0bac7fe2$var$getIsOnButtonCallback(optionValueWithUnit));
                this.listenTo(button, "execute", ()=>{
                    editor.execute("resizeMediaEmbed", {
                        width: optionValueWithUnit
                    });
                });
            }
            return button;
        });
    }
    /**
	* Creates the dropdown component containing all resize options.
	*/ _registerMediaEmbedResizeDropdown(options) {
        const editor = this.editor;
        const t = editor.t;
        const originalSizeOption = options.find((option)=>!option.value);
        const componentCreator = (locale)=>{
            const command = editor.commands.get("resizeMediaEmbed");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$78bc6c5c028686b7));
            const dropdownButton = dropdownView.buttonView;
            const accessibleLabel = t("Resize media");
            dropdownButton.set({
                tooltip: accessibleLabel,
                commandValue: originalSizeOption ? originalSizeOption.value : null,
                icon: $a013102e0bac7fe2$var$RESIZE_ICONS.medium,
                isToggleable: true,
                label: originalSizeOption ? this._getOptionLabelValue(originalSizeOption) : "",
                withText: true,
                class: "ck-resize-media-embed-button",
                ariaLabel: accessibleLabel,
                ariaLabelledBy: void 0
            });
            dropdownButton.bind("label").to(command, "value", (commandValue)=>{
                if (commandValue) return commandValue;
                return originalSizeOption ? this._getOptionLabelValue(originalSizeOption) : "";
            });
            dropdownView.bind("isEnabled").to(this);
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, ()=>this._getResizeDropdownListItemDefinitions(options, command), {
                ariaLabel: t("Media resize list"),
                role: "menu"
            });
            this.listenTo(dropdownView, "execute", (evt)=>{
                if ("onClick" in evt.source) evt.source.onClick();
                else {
                    editor.execute(evt.source.commandName, {
                        width: evt.source.commandValue
                    });
                    editor.editing.view.focus();
                }
            });
            return dropdownView;
        };
        editor.ui.componentFactory.add("resizeMediaEmbed", componentCreator);
    }
    /**
	* Returns a label for the given resize option.
	*/ _getOptionLabelValue(option, forTooltip = false) {
        const t = this.editor.t;
        if (option.label) return option.label;
        const isCustom = $a013102e0bac7fe2$var$isCustomMediaEmbedResizeOption(option);
        if (forTooltip) {
            if (isCustom) return t("Custom media size");
            return option.value ? t("Resize media to %0", option.value + this._resizeUnit) : t("Resize media to the original size");
        }
        if (isCustom) return t("Custom");
        return option.value ? option.value + this._resizeUnit : t("Original");
    }
    /**
	* Returns list item definitions for the resize dropdown.
	*/ _getResizeDropdownListItemDefinitions(options, command) {
        const { editor: editor } = this;
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        const optionsWithSerializedValues = options.map((option)=>{
            if ($a013102e0bac7fe2$var$isCustomMediaEmbedResizeOption(option)) return {
                ...option,
                valueWithUnits: "custom"
            };
            if (!option.value) return {
                ...option,
                valueWithUnits: null
            };
            return {
                ...option,
                valueWithUnits: `${option.value}${this._resizeUnit}`
            };
        });
        for (const option of optionsWithSerializedValues){
            let definition;
            if (editor.plugins.has("MediaEmbedCustomResizeUI") && $a013102e0bac7fe2$var$isCustomMediaEmbedResizeOption(option)) {
                const customResizeUI = editor.plugins.get("MediaEmbedCustomResizeUI");
                definition = {
                    type: "button",
                    model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                        label: this._getOptionLabelValue(option),
                        role: "menuitemradio",
                        withText: true,
                        icon: null,
                        onClick: ()=>{
                            customResizeUI._showForm(this._resizeUnit);
                        }
                    })
                };
                const allDropdownValues = Object.values(optionsWithSerializedValues).map((option)=>option.valueWithUnits);
                definition.model.bind("isOn").to(command, "value", command, "isEnabled", $a013102e0bac7fe2$var$getIsOnCustomButtonCallback(allDropdownValues));
            } else {
                definition = {
                    type: "button",
                    model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                        commandName: "resizeMediaEmbed",
                        commandValue: option.valueWithUnits,
                        label: this._getOptionLabelValue(option),
                        role: "menuitemradio",
                        withText: true,
                        icon: null
                    })
                };
                definition.model.bind("isOn").to(command, "value", command, "isEnabled", $a013102e0bac7fe2$var$getIsOnButtonCallback(option.valueWithUnits));
            }
            definition.model.bind("isEnabled").to(command, "isEnabled");
            itemDefinitions.add(definition);
        }
        return itemDefinitions;
    }
};
function $a013102e0bac7fe2$var$isCustomMediaEmbedResizeOption(option) {
    return option.value === "custom";
}
function $a013102e0bac7fe2$var$getIsOnButtonCallback(value) {
    return (commandValue, isEnabled)=>{
        if (commandValue === void 0 || !isEnabled) return false;
        return commandValue === value;
    };
}
function $a013102e0bac7fe2$var$getIsOnCustomButtonCallback(allDropdownValues) {
    return (commandValue, isEnabled)=>!allDropdownValues.some((dropdownValue)=>$a013102e0bac7fe2$var$getIsOnButtonCallback(dropdownValue)(commandValue, isEnabled));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Finds model, view and DOM element for selected media embed element.
* Returns `null` if there is no media embed selected.
*
* @param editor Editor instance.
* @internal
*/ function $a013102e0bac7fe2$var$getSelectedMediaEmbedEditorNodes(editor) {
    const { editing: editing } = editor;
    const mediaModelElement = $a013102e0bac7fe2$export$7d10b9adbd1016cb(editor.model.document.selection);
    if (!mediaModelElement) return null;
    const mediaViewElement = editing.mapper.toViewElement(mediaModelElement);
    return {
        model: mediaModelElement,
        view: mediaViewElement,
        dom: editing.view.domConverter.mapViewToDom(mediaViewElement)
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/utils/getselectedmediaembedwidthinunits
*/ /**
* Returns media embed width in specified units after resize.
*
* 	* If no media embed is selected or command is disabled, `null` will be returned.
*	* If `targetUnit` percentage is passed then it will return width percentage relative to its ancestor.
*
* @param editor Editor instance.
* @param targetUnit Unit in which dimension will be returned.
* @returns Parsed media embed width after resize (with unit).
* @internal
*/ function $a013102e0bac7fe2$var$getSelectedMediaEmbedWidthInUnits(editor, targetUnit) {
    const mediaNodes = $a013102e0bac7fe2$var$getSelectedMediaEmbedEditorNodes(editor);
    if (!mediaNodes) return null;
    const parsedResizedWidth = (0, $c7bc2cb7e2db0227$export$75edd0f9cff526b0)(mediaNodes.model.getAttribute("resizedWidth") || null);
    if (!parsedResizedWidth) return null;
    if (parsedResizedWidth.unit === targetUnit) return parsedResizedWidth;
    const mediaParentWidthPx = (0, $5547ab21e02f1e9e$export$6ec49425c093db63)(mediaNodes.dom);
    const mediaHolderDimension = {
        unit: "px",
        value: new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(mediaNodes.dom).width
    };
    return (0, $c7bc2cb7e2db0227$export$5fa337c2fe4d899a)(mediaParentWidthPx, mediaHolderDimension, targetUnit);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns the min and max resize values for the selected media embed in the specified unit.
*
* @param editor Editor instance.
* @param targetUnit Unit in which dimension will be returned.
* @returns Possible resize range in numeric form.
* @internal
*/ function $a013102e0bac7fe2$var$getSelectedMediaEmbedPossibleResizeRange(editor, targetUnit) {
    const mediaNodes = $a013102e0bac7fe2$var$getSelectedMediaEmbedEditorNodes(editor);
    if (!mediaNodes) return null;
    const mediaParentWidthPx = (0, $5547ab21e02f1e9e$export$6ec49425c093db63)(mediaNodes.dom);
    const minimumMediaWidth = (0, $c7bc2cb7e2db0227$export$75edd0f9cff526b0)(window.getComputedStyle(mediaNodes.dom).minWidth) || {
        value: 1,
        unit: "px"
    };
    return {
        unit: targetUnit,
        lower: Math.max(.1, (0, $c7bc2cb7e2db0227$export$5fa337c2fe4d899a)(mediaParentWidthPx, minimumMediaWidth, targetUnit).value),
        upper: targetUnit === "px" ? mediaParentWidthPx : 100
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/ui/mediaembedcustomresizeformview
*/ /**
* The MediaEmbedCustomResizeFormView class.
*
* @internal
*/ var $a013102e0bac7fe2$var$MediaEmbedCustomResizeFormView = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Resize unit shortcut.
	*/ unit;
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A button used to submit the form.
	*/ saveButtonView;
    /**
	* An input with a label.
	*/ labeledInput;
    /**
	* A collection of child views.
	*/ children;
    /**
	* A collection of views which can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* An array of form validators used by {@link #isValid}.
	*/ _validators;
    /**
	* @inheritDoc
	*/ constructor(locale, unit, validators){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.unit = unit;
        this.backButtonView = this._createBackButton();
        this.saveButtonView = this._createSaveButton();
        this.labeledInput = this._createLabeledInputView();
        this.children = this.createCollection([
            this._createHeaderView()
        ]);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.labeledInput,
                this.saveButtonView
            ],
            class: [
                "ck-form__row_with-submit",
                "ck-form__row_large-top-padding",
                "ck-form__row_large-bottom-padding"
            ]
        }));
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this._validators = validators;
        this.keystrokes.set("Esc", (data, cancel)=>{
            this.fire("cancel");
            cancel();
        });
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-media-embed-custom-resize-form",
                    "ck-responsive-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.backButtonView,
            this.labeledInput,
            this.saveButtonView
        ].forEach((v)=>{
            this._focusables.add(v);
            this.focusTracker.add(v.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    _createSaveButton() {
        const t = this.locale.t;
        const saveButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        saveButton.set({
            label: t("Save"),
            withText: true,
            type: "submit",
            class: "ck-button-action"
        });
        return saveButton;
    }
    _createHeaderView() {
        const t = this.locale.t;
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(this.locale, {
            label: t("Media Resize")
        });
        header.children.add(this.backButtonView, 0);
        return header;
    }
    _createLabeledInputView() {
        const t = this.locale.t;
        const labeledInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(this.locale, (0, $29fd27cb9bdab9d2$export$616b4440975f3e79));
        labeledInput.label = t("Resize media (in %0)", this.unit);
        labeledInput.class = "ck-labeled-field-view_full-width";
        labeledInput.fieldView.set({
            min: .1,
            step: .1
        });
        return labeledInput;
    }
    /**
	* Validates the form and returns `false` when some fields are invalid.
	*/ isValid() {
        this.resetFormStatus();
        for (const validator of this._validators){
            const errorText = validator(this);
            if (errorText) {
                this.labeledInput.errorText = errorText;
                return false;
            }
        }
        return true;
    }
    /**
	* Cleans up error and information text of {@link #labeledInput}.
	*/ resetFormStatus() {
        this.labeledInput.errorText = null;
    }
    /**
	* The native DOM `value` of the input element of {@link #labeledInput}.
	*/ get rawSize() {
        const { element: element } = this.labeledInput.fieldView;
        if (!element) return null;
        return element.value;
    }
    /**
	* Get numeric value of size. Returns `null` if value is not a number.
	*/ get parsedSize() {
        const { rawSize: rawSize } = this;
        if (rawSize === null) return null;
        const parsed = Number.parseFloat(rawSize);
        if (Number.isNaN(parsed)) return null;
        return parsed;
    }
    /**
	* Returns serialized media embed input size with unit.
	* Returns `null` if value is not a number.
	*/ get sizeWithUnits() {
        const { parsedSize: parsedSize, unit: unit } = this;
        if (parsedSize === null) return null;
        return `${parsedSize}${unit}`;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize/mediaembedcustomresizeui
*/ /**
* The custom resize media embed UI plugin.
*
* The plugin uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon}.
*/ var $a013102e0bac7fe2$export$ac3bcb2e2a305599 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* A form used to set the custom resize width.
	*/ _form;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedCustomResizeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this._form) this._form.destroy();
    }
    /**
	* Creates the {@link module:media-embed/mediaembedresize/ui/mediaembedcustomresizeformview~MediaEmbedCustomResizeFormView} form.
	*/ _createForm(unit) {
        const editor = this.editor;
        this._balloon = this.editor.plugins.get("ContextualBalloon");
        const FormViewClass = (0, $29fd27cb9bdab9d2$export$715574b9e52d1468)($a013102e0bac7fe2$var$MediaEmbedCustomResizeFormView);
        this._form = new FormViewClass(editor.locale, unit, $a013102e0bac7fe2$var$getFormValidators(editor));
        this._form.render();
        this.listenTo(this._form, "submit", ()=>{
            if (this._form.isValid()) {
                editor.execute("resizeMediaEmbed", {
                    width: this._form.sizeWithUnits
                });
                this._hideForm(true);
            }
        });
        this.listenTo(this._form.labeledInput, "change:errorText", ()=>{
            editor.ui.update();
        });
        this.listenTo(this._form, "cancel", ()=>{
            this._hideForm(true);
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this._form,
            activator: ()=>this._isVisible,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>this._hideForm()
        });
    }
    /**
	* Shows the {@link #_form} in the {@link #_balloon}.
	*
	* @internal
	*/ _showForm(unit) {
        if (this._isVisible) return;
        if (!this._form) this._createForm(unit);
        const editor = this.editor;
        const labeledInput = this._form.labeledInput;
        this._form.disableCssTransitions();
        this._form.resetFormStatus();
        /* v8 ignore else -- @preserve */ if (!this._isInBalloon) this._balloon.add({
            view: this._form,
            position: $a013102e0bac7fe2$var$getBalloonPositionData(editor)
        });
        const currentParsedWidth = $a013102e0bac7fe2$var$getSelectedMediaEmbedWidthInUnits(editor, unit);
        const initialInputValue = currentParsedWidth ? currentParsedWidth.value.toFixed(1) : "";
        const possibleRange = $a013102e0bac7fe2$var$getSelectedMediaEmbedPossibleResizeRange(editor, unit);
        labeledInput.fieldView.value = labeledInput.fieldView.element.value = initialInputValue;
        if (possibleRange) Object.assign(labeledInput.fieldView, {
            min: possibleRange.lower.toFixed(1),
            max: Math.ceil(possibleRange.upper).toFixed(1)
        });
        this._form.labeledInput.fieldView.select();
        this._form.enableCssTransitions();
    }
    /**
	* Removes the {@link #_form} from the {@link #_balloon}.
	*
	* @param focusEditable Controls whether the editing view is focused afterwards.
	*/ _hideForm(focusEditable = false) {
        if (!this._isInBalloon) return;
        if (this._form.focusTracker.isFocused) this._form.saveButtonView.focus();
        this._balloon.remove(this._form);
        if (focusEditable) this.editor.editing.view.focus();
    }
    /**
	* Returns `true` when the {@link #_form} is the visible view in the {@link #_balloon}.
	*/ get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
    }
    /**
	* Returns `true` when the {@link #_form} is in the {@link #_balloon}.
	*/ get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
    }
};
function $a013102e0bac7fe2$var$getBalloonPositionData(editor) {
    const editingView = editor.editing.view;
    const defaultPositions = (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions;
    return {
        target: editingView.domConverter.mapViewToDom($a013102e0bac7fe2$export$3a7cbcf8a9330686(editingView.document.selection)),
        positions: [
            defaultPositions.northArrowSouth,
            defaultPositions.northArrowSouthWest,
            defaultPositions.northArrowSouthEast,
            defaultPositions.southArrowNorth,
            defaultPositions.southArrowNorthWest,
            defaultPositions.southArrowNorthEast,
            defaultPositions.viewportStickyNorth
        ]
    };
}
function $a013102e0bac7fe2$var$getFormValidators(editor) {
    const t = editor.t;
    return [
        (form)=>{
            if (form.rawSize.trim() === "") return t("The value must not be empty.");
            if (form.parsedSize === null) return t("The value should be a plain number.");
        }
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedresize
*/ /**
* The media embed resize plugin.
*
* It adds a possibility to resize each media embed using handles, toolbar buttons,
* or a balloon-hosted custom-width input.
*/ var $a013102e0bac7fe2$export$34cbf3e4601bf1e1 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$e6a71d8230d6d42c,
            $a013102e0bac7fe2$export$f9292815a0bddb92,
            $a013102e0bac7fe2$export$ac3bcb2e2a305599,
            $a013102e0bac7fe2$export$4101f4ac14dc7ab0
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedResize";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle/mediaembedstylecommand
*/ /**
* The media embed style command. It is used to apply a style option (e.g. an alignment) to a
* selected media embed.
*
* The set of accepted style values comes from the resolved
* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles`}
* options. Values not in that set are silently rejected by {@link #execute}.
*/ var $a013102e0bac7fe2$export$a21ec899a0621d02 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Resolved styles indexed by `name`. Used to look up the `isDefault` flag at execute time
	* (any default-marked style clears the attribute) and to validate that a requested style
	* is part of the resolved options list.
	*/ _styles;
    /**
	* The `name` of the first style with `isDefault: true` in the resolved options, or `null`
	* when the integrator did not designate a default. Exposed via {@link #value} when the
	* selected media has no `mediaStyle` attribute, so the default-state UI button can light up.
	* Does not gate the "clear attribute" branch in {@link #execute} — that uses the per-style
	* `isDefault` flag so multi-default configs behave consistently with the downcast.
	*/ _defaultStyleName;
    /**
	* Creates an instance of the media embed style command.
	*
	* @param editor The editor instance.
	* @param styles The resolved list of style options that this command will accept.
	*/ constructor(editor, styles){
        super(editor);
        this._styles = new Map(styles.map((style)=>[
                style.name,
                style
            ]));
        const defaultStyle = styles.find((style)=>style.isDefault);
        this._defaultStyleName = defaultStyle ? defaultStyle.name : null;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const element = $a013102e0bac7fe2$export$7d10b9adbd1016cb(this.editor.model.document.selection);
        this.isEnabled = !!element;
        if (!element) this.value = false;
        else if (element.hasAttribute("mediaStyle")) {
            const styleName = element.getAttribute("mediaStyle");
            this.value = this._styles.has(styleName) ? styleName : this._defaultStyleName ?? false;
        } else this.value = this._defaultStyleName ?? false;
    }
    /**
	* Executes the command and applies the chosen style to the currently selected media embed.
	*
	* ```ts
	* editor.execute( 'mediaStyle', { value: 'alignLeft' } );
	* editor.execute( 'mediaStyle', { value: 'alignCenter' } ); // removes the attribute — alignCenter is the built-in default
	* editor.execute( 'mediaStyle', { value: null } );          // removes the attribute
	* ```
	*
	* The default style is encoded on the model as the absence of the `mediaStyle` attribute.
	* Passing any `isDefault: true` style name (or `null`) therefore clears the attribute. Values
	* that are neither falsy, an `isDefault` style, nor present in the resolved options list are
	* silently rejected.
	*
	* @param options
	* @param options.value The name of the style to apply, or `null` to clear the alignment.
	* @fires execute
	*/ execute(options) {
        const model = this.editor.model;
        const element = $a013102e0bac7fe2$export$7d10b9adbd1016cb(model.document.selection);
        const requestedStyle = options.value;
        if (!requestedStyle || this._styles.get(requestedStyle)?.isDefault) {
            model.change((writer)=>{
                writer.removeAttribute("mediaStyle", element);
            });
            return;
        }
        if (!this._styles.has(requestedStyle)) return;
        model.change((writer)=>{
            writer.setAttribute("mediaStyle", requestedStyle, element);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle/mediaembedstyleediting
*/ /**
* The media embed style engine plugin. It extends the schema with the `mediaStyle` attribute,
* registers the {@link module:media-embed/mediaembedstyle/mediaembedstylecommand~MediaEmbedStyleCommand} command,
* and adds the converters that apply alignment CSS classes to the figure.
*/ var $a013102e0bac7fe2$export$cff6be3684e94764 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The resolved list of media style options. Built once from
	* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles`}
	* during {@link #init} and consumed by both the command and the UI plugin (single source of truth).
	*
	* @internal
	* @readonly
	*/ normalizedStyles;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$6a94509908b7440
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedStyleEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        editor.config.define("mediaEmbed.styles", {
            options: Object.keys($a013102e0bac7fe2$var$DEFAULT_OPTIONS)
        });
        this.normalizedStyles = $a013102e0bac7fe2$var$normalizeStyles(editor.config.get("mediaEmbed.styles"));
        schema.extend("media", {
            allowAttributes: [
                "mediaStyle"
            ]
        });
        schema.setAttributeProperties("mediaStyle", {
            isFormatting: true
        });
        editor.commands.add("mediaStyle", new $a013102e0bac7fe2$export$a21ec899a0621d02(editor, this.normalizedStyles));
        this._registerConverters();
    }
    /**
	* Registers the downcast and upcast converters for the `mediaStyle` attribute.
	*/ _registerConverters() {
        const editor = this.editor;
        const styleClassMap = new Map(this.normalizedStyles.filter((style)=>!style.isDefault && style.className).map((style)=>[
                style.name,
                style.className
            ]));
        editor.conversion.for("downcast").add((dispatcher)=>dispatcher.on("attribute:mediaStyle:media", (evt, data, conversionApi)=>{
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const figure = conversionApi.mapper.toViewElement(data.item);
                const viewWriter = conversionApi.writer;
                const oldClass = styleClassMap.get(data.attributeOldValue);
                const newClass = styleClassMap.get(data.attributeNewValue);
                if (oldClass) viewWriter.removeClass(oldClass, figure);
                if (newClass) viewWriter.addClass(newClass, figure);
            }));
        editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:figure", (_evt, data, conversionApi)=>{
                if (!data.modelRange) return;
                const modelElement = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(data.modelRange.getItems());
                if (!modelElement || !modelElement.is("element", "media")) return;
                for (const [styleName, className] of styleClassMap)if (conversionApi.consumable.consume(data.viewItem, {
                    classes: className
                })) conversionApi.writer.setAttribute("mediaStyle", styleName, modelElement);
            }, {
                priority: "low"
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle/mediaembedstyleui
*/ /**
* The media embed style UI plugin.
*
* It registers a button for every style in the resolved
* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#styles `config.mediaEmbed.styles`}
* list, and the default split-button dropdowns (`mediaEmbed:wrapText`, `mediaEmbed:breakText`)
* — filtered to the styles that survived configuration. The resulting components can be placed
* in the {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#toolbar media embed toolbar}.
*/ var $a013102e0bac7fe2$export$df064793a9c81fd6 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$cff6be3684e94764
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedStyleUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const titles = this._getLocalizedTitles();
        for (const button of this._getButtonDefinitions(titles))this._createButton(button);
        for (const dropdown of this._getDropdownDefinitions(titles))this._createDropdown(dropdown);
    }
    /**
	* Returns the alignment button definitions sourced from the resolved options list.
	*/ _getButtonDefinitions(titles) {
        return this.editor.plugins.get($a013102e0bac7fe2$export$cff6be3684e94764).normalizedStyles.map((option)=>({
                name: option.name,
                label: titles[option.title] || option.title,
                icon: option.icon
            }));
    }
    /**
	* Returns the localized titles of the built-in styles and dropdowns.
	*/ _getLocalizedTitles() {
        const t = this.editor.t;
        return {
            "Left aligned media": t("Left aligned media"),
            "Centered media": t("Centered media"),
            "Right aligned media": t("Right aligned media"),
            "Wrap text": t("Wrap text"),
            "Break text": t("Break text")
        };
    }
    /**
	* Returns the split-button dropdown definitions, filtered to the styles present in the
	* resolved options list. Combines the {@link module:media-embed/mediaembedstyle/constants~DEFAULT_DROPDOWN_DEFINITIONS
	* built-in dropdowns} with custom dropdowns declared inline in
	* {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#toolbar `config.mediaEmbed.toolbar`}.
	*
	* A dropdown with fewer than two items is skipped — a single-item dropdown carries no value
	* over the flat button. If the configured `defaultItem` was filtered out, the first surviving
	* item becomes the default.
	*
	* When a *custom* dropdown's items reference styles that are not in the resolved options list,
	* a console warning is emitted (the integrator's config was not fully honored). Built-in
	* dropdowns auto-skip silently — they are added by the plugin, not the integrator.
	*/ _getDropdownDefinitions(titles) {
        const editing = this.editor.plugins.get($a013102e0bac7fe2$export$cff6be3684e94764);
        const availableComponentNames = new Set(editing.normalizedStyles.map(({ name: name })=>`mediaEmbed:${name}`));
        const dropdowns = [];
        const resolveDropdown = (definition, warnOnFilter)=>{
            const items = definition.items.filter((itemName)=>availableComponentNames.has(itemName));
            if (warnOnFilter && items.length !== definition.items.length) $a013102e0bac7fe2$var$warnInvalidDropdown({
                dropdown: definition
            });
            if (items.length < 2) return;
            const defaultItem = availableComponentNames.has(definition.defaultItem) ? definition.defaultItem : items[0];
            dropdowns.push({
                name: definition.name,
                title: titles[definition.title] || definition.title,
                items: items,
                defaultItem: defaultItem
            });
        };
        for (const definition of $a013102e0bac7fe2$var$DEFAULT_DROPDOWN_DEFINITIONS)resolveDropdown(definition, false);
        for (const definition of this._collectCustomDropdowns())resolveDropdown(definition, true);
        return dropdowns;
    }
    /**
	* Scans `config.mediaEmbed.toolbar` for entries shaped like a dropdown definition
	* (objects with both `items` and `defaultItem`) and returns the valid ones. `defaultItem`
	* is the discriminator between our split-button dropdowns and generic toolbar groupings
	* (which use `items` + `label` and have no `defaultItem`).
	*
	* Invalid entries (wrong name prefix, `defaultItem` missing from `items`) are warned and
	* dropped here. Items that reference filtered-out styles are filtered later by
	* {@link #_getDropdownDefinitions}, alongside the same logic that applies to built-in
	* dropdowns.
	*/ _collectCustomDropdowns() {
        return (this.editor.config.get("mediaEmbed.toolbar") || []).filter((item)=>$a013102e0bac7fe2$var$isMediaStyleDropdown(item) && $a013102e0bac7fe2$var$isValidCustomDropdown(item));
    }
    /**
	* Registers a single alignment toggle button in the component factory.
	*/ _createButton(definition) {
        const editor = this.editor;
        const componentName = `mediaEmbed:${definition.name}`;
        editor.ui.componentFactory.add(componentName, (locale)=>{
            const command = editor.commands.get("mediaStyle");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                label: definition.label,
                icon: definition.icon,
                tooltip: true,
                isToggleable: true
            });
            view.bind("isEnabled").to(command, "isEnabled");
            view.bind("isOn").to(command, "value", (value)=>value === definition.name);
            view.on("execute", ()=>{
                editor.execute("mediaStyle", {
                    value: definition.name
                });
                editor.editing.view.focus();
            });
            return view;
        });
    }
    /**
	* Registers a split-button dropdown grouping a set of alignment buttons. The action button
	* reflects whichever child option is currently `isOn`, falling back to the dropdown's
	* `defaultItem` when nothing is active.
	*/ _createDropdown(definition) {
        const editor = this.editor;
        const factory = editor.ui.componentFactory;
        factory.add(definition.name, (locale)=>{
            const buttonViews = definition.items.map((itemName)=>factory.create(itemName));
            const defaultButton = buttonViews[definition.items.indexOf(definition.defaultItem)];
            const activeOrDefault = (...areOn)=>{
                const index = areOn.findIndex(Boolean);
                return index < 0 ? defaultButton : buttonViews[index];
            };
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
            const splitButtonView = dropdownView.buttonView;
            (0, $29fd27cb9bdab9d2$export$c39319333c19bdd7)(dropdownView, buttonViews, {
                enableActiveItemFocusOnDropdownOpen: true
            });
            splitButtonView.set({
                label: $a013102e0bac7fe2$var$getDropdownButtonTitle(definition.title, defaultButton.label),
                class: null,
                tooltip: true
            });
            splitButtonView.arrowView.unbind("label");
            splitButtonView.arrowView.set({
                label: definition.title
            });
            splitButtonView.bind("icon").toMany(buttonViews, "isOn", (...areOn)=>activeOrDefault(...areOn).icon);
            splitButtonView.bind("label").toMany(buttonViews, "isOn", (...areOn)=>$a013102e0bac7fe2$var$getDropdownButtonTitle(definition.title, activeOrDefault(...areOn).label));
            splitButtonView.bind("isOn").toMany(buttonViews, "isOn", (...areOn)=>areOn.some(Boolean));
            splitButtonView.bind("class").toMany(buttonViews, "isOn", (...areOn)=>areOn.some(Boolean) ? "ck-splitbutton_flatten" : void 0);
            this.listenTo(splitButtonView, "execute", ()=>{
                if (buttonViews.some(({ isOn: isOn })=>isOn)) dropdownView.isOpen = !dropdownView.isOpen;
                else defaultButton.fire("execute");
            });
            dropdownView.bind("isEnabled").toMany(buttonViews, "isEnabled", (...areEnabled)=>areEnabled.some(Boolean));
            this.listenTo(dropdownView, "execute", ()=>{
                editor.editing.view.focus();
            });
            return dropdownView;
        });
    }
};
/**
* Combines the dropdown title and the default action item label for the split-button label.
*/ function $a013102e0bac7fe2$var$getDropdownButtonTitle(dropdownTitle, buttonTitle) {
    return `${dropdownTitle}: ${buttonTitle}`;
}
/**
* Validates a user-supplied dropdown definition. Emits a console warning under
* `media-style-configuration-definition-invalid` and returns `false` when any of these rules is
* broken: `name` must start with `mediaEmbed:`, `title` must be a non-empty string, `items` must
* be non-empty and every entry must be a `mediaEmbed:`-prefixed string, and `defaultItem` must be
* one of the `items`.
*
* Item-membership against the resolved styles is checked separately, downstream, alongside the
* same logic that applies to built-in dropdowns.
*/ function $a013102e0bac7fe2$var$isValidCustomDropdown(definition) {
    const valid = definition.name.startsWith("mediaEmbed:") && typeof definition.title === "string" && definition.title.length > 0 && definition.items.length > 0 && definition.items.every((name)=>typeof name === "string" && name.startsWith("mediaEmbed:")) && definition.items.includes(definition.defaultItem);
    if (!valid) $a013102e0bac7fe2$var$warnInvalidDropdown({
        dropdown: definition
    });
    return valid;
}
/**
* Emits a console warning under `media-style-configuration-definition-invalid` for an invalid
* or partially-honored dropdown definition. Called from {@link ~isValidCustomDropdown} for
* structural problems and from {@link MediaEmbedStyleUI#_getDropdownDefinitions} when items
* reference styles that are not in the resolved options list.
*/ function $a013102e0bac7fe2$var$warnInvalidDropdown(info) {
    (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("media-style-configuration-definition-invalid", info);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module media-embed/mediaembedstyle
*/ /**
* The media embed style plugin.
*
* This is a "glue" plugin which loads the following plugins:
* * {@link module:media-embed/mediaembedstyle/mediaembedstyleediting~MediaEmbedStyleEditing},
* * {@link module:media-embed/mediaembedstyle/mediaembedstyleui~MediaEmbedStyleUI}
*
* For a detailed overview, check the {@glink features/media-embed/media-embed-styles Media embed styles feature documentation}.
*/ var $a013102e0bac7fe2$export$7bd8ac8b9f41f018 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a013102e0bac7fe2$export$cff6be3684e94764,
            $a013102e0bac7fe2$export$df064793a9c81fd6
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MediaEmbedStyle";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/mentioncommand
*/ const $a0b6f63298957c68$var$BRACKET_PAIRS = {
    "(": ")",
    "[": "]",
    "{": "}"
};
/**
* The mention command.
*
* The command is registered by {@link module:mention/mentionediting~MentionEditing} as `'mention'`.
*
* To insert a mention into a range, execute the command and specify a mention object with a range to replace:
*
* ```ts
* const focus = editor.model.document.selection.focus;
*
* // It will replace one character before the selection focus with the '#1234' text
* // with the mention attribute filled with passed attributes.
* editor.execute( 'mention', {
* 	marker: '#',
* 	mention: {
* 		id: '#1234',
* 		name: 'Foo',
* 		title: 'Big Foo'
* 	},
* 	range: editor.model.createRange( focus.getShiftedBy( -1 ), focus )
* } );
*
* // It will replace one character before the selection focus with the 'The "Big Foo"' text
* // with the mention attribute filled with passed attributes.
* editor.execute( 'mention', {
* 	marker: '#',
* 	mention: {
* 		id: '#1234',
* 		name: 'Foo',
* 		title: 'Big Foo'
* 	},
* 	text: 'The "Big Foo"',
* 	range: editor.model.createRange( focus.getShiftedBy( -1 ), focus )
* } );
*	```
*/ var $a0b6f63298957c68$export$fb53ed5a1149ada0 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._isEnabledBasedOnSelection = false;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, "mention");
    }
    /**
	* Executes the command.
	*
	* @param options Options for the executed command.
	* @param options.mention The mention object to insert. When a string is passed, it will be used to create a plain
	* object with the name attribute that equals the passed string.
	* @param options.marker The marker character (e.g. `'@'`).
	* @param options.text The text of the inserted mention. Defaults to the full mention string composed from `marker` and
	* `mention` string or `mention.id` if an object is passed.
	* @param options.range The range to replace.
	* Note that the replaced range might be shorter than the inserted text with the mention attribute.
	* @fires execute
	*/ execute(options) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const mentionData = typeof options.mention == "string" ? {
            id: options.mention
        } : options.mention;
        const mentionID = mentionData.id;
        const range = options.range || selection.getFirstRange();
        if (!model.canEditAt(range)) return;
        const mentionText = options.text || mentionID;
        const mention = $a0b6f63298957c68$export$3b5e252dd78b0fe8({
            _text: mentionText,
            id: mentionID
        }, mentionData);
        if (!mentionID.startsWith(options.marker)) /**
		* The feed item ID must start with the marker character(s).
		*
		* Correct mention feed setting:
		*
		* ```ts
		* mentions: [
		* 	{
		* 		marker: '@',
		* 		feed: [ '@Ann', '@Barney', ... ]
		* 	}
		* ]
		* ```
		*
		* Incorrect mention feed setting:
		*
		* ```ts
		* mentions: [
		* 	{
		* 		marker: '@',
		* 		feed: [ 'Ann', 'Barney', ... ]
		* 	}
		* ]
		* ```
		*
		* See {@link module:mention/mentionconfig~MentionConfig}.
		*
		* @error mentioncommand-incorrect-id
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("mentioncommand-incorrect-id", this);
        model.change((writer)=>{
            const currentAttributes = (0, $c7bc2cb7e2db0227$export$e98af36a72b77685)(selection.getAttributes());
            const attributesWithMention = new Map(currentAttributes.entries());
            attributesWithMention.set("mention", mention);
            const insertionRange = model.insertContent(writer.createText(mentionText, attributesWithMention), range);
            const nodeBefore = insertionRange.start.nodeBefore;
            const nodeAfter = insertionRange.end.nodeAfter;
            const isFollowedByWhiteSpace = nodeAfter && nodeAfter.is("$text") && nodeAfter.data.startsWith(" ");
            let isInsertedInBrackets = false;
            if (nodeBefore && nodeAfter && nodeBefore.is("$text") && nodeAfter.is("$text")) {
                const precedingCharacter = nodeBefore.data.slice(-1);
                const isPrecededByOpeningBracket = precedingCharacter in $a0b6f63298957c68$var$BRACKET_PAIRS;
                const isFollowedByBracketClosure = isPrecededByOpeningBracket && nodeAfter.data.startsWith($a0b6f63298957c68$var$BRACKET_PAIRS[precedingCharacter]);
                isInsertedInBrackets = isPrecededByOpeningBracket && isFollowedByBracketClosure;
            }
            if (!isInsertedInBrackets && !isFollowedByWhiteSpace) model.insertContent(writer.createText(" ", currentAttributes), range.start.getShiftedBy(mentionText.length));
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/mentionediting
*/ /**
* The mention editing feature.
*
* It introduces the {@link module:mention/mentioncommand~MentionCommand command} and the `mention`
* attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
* as a `<span class="mention" data-mention="@mention">`.
*/ var $a0b6f63298957c68$export$69d27e973f42b9f5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MentionEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const doc = model.document;
        model.schema.extend("$text", {
            allowAttributes: "mention"
        });
        model.schema.addAttributeCheck((context)=>{
            if (context.endsWith("codeBlock $text")) return false;
        }, "mention");
        editor.conversion.for("upcast").elementToAttribute({
            view: {
                name: "span",
                attributes: "data-mention",
                classes: "mention"
            },
            model: {
                key: "mention",
                value: (viewElement)=>$a0b6f63298957c68$export$fd6086423d98c37c(viewElement)
            }
        });
        editor.conversion.for("downcast").attributeToElement({
            model: "mention",
            view: $a0b6f63298957c68$var$createViewMentionElement
        });
        editor.conversion.for("downcast").add($a0b6f63298957c68$var$preventPartialMentionDowncast);
        doc.registerPostFixer((writer)=>$a0b6f63298957c68$var$removePartialMentionPostFixer(writer, doc, model.schema));
        doc.registerPostFixer((writer)=>$a0b6f63298957c68$var$extendAttributeOnMentionPostFixer(writer, doc));
        doc.registerPostFixer((writer)=>$a0b6f63298957c68$var$selectionMentionAttributePostFixer(writer, doc));
        editor.commands.add("mention", new $a0b6f63298957c68$export$fb53ed5a1149ada0(editor));
    }
};
/**
* @internal
*/ function $a0b6f63298957c68$export$3b5e252dd78b0fe8(baseMentionData, data) {
    return Object.assign({
        uid: (0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)().slice(0, 8)
    }, baseMentionData, data || {});
}
/**
* Creates a mention attribute value from the provided view element and optional data.
*
* This function is exposed as
* {@link module:mention/mention~Mention#toMentionAttribute `editor.plugins.get( 'Mention' ).toMentionAttribute()`}.
*
* @internal
*/ function $a0b6f63298957c68$export$fd6086423d98c37c(viewElementOrMention, data) {
    const dataMention = viewElementOrMention.getAttribute("data-mention");
    const textNode = viewElementOrMention.getChild(0);
    if (!textNode) return;
    const dataUid = viewElementOrMention.getAttribute("data-mention-uid");
    return $a0b6f63298957c68$export$3b5e252dd78b0fe8({
        id: dataMention,
        _text: textNode.data
    }, dataUid ? {
        uid: dataUid,
        ...data
    } : data);
}
/**
* A converter that blocks partial mention from being converted.
*
* This converter is registered with 'highest' priority in order to consume mention attribute before it is converted by
* any other converters. This converter only consumes partial mention - those whose `_text` attribute is not equal to text with mention
* attribute. This may happen when copying part of mention text.
*/ function $a0b6f63298957c68$var$preventPartialMentionDowncast(dispatcher) {
    dispatcher.on("attribute:mention", (evt, data, conversionApi)=>{
        const mention = data.attributeNewValue;
        if (!data.item.is("$textProxy") || !mention) return;
        const start = data.range.start;
        if ((start.textNode || start.nodeAfter).data != mention._text) conversionApi.consumable.consume(data.item, evt.name);
    }, {
        priority: "highest"
    });
}
/**
* Creates a mention element from the mention data.
*/ function $a0b6f63298957c68$var$createViewMentionElement(mention, { writer: writer, options: options }) {
    if (!mention) return;
    return writer.createAttributeElement("span", {
        class: "mention",
        "data-mention": mention.id,
        ...!options.isClipboardPipeline && {
            "data-mention-uid": mention.uid
        }
    }, {
        id: mention.uid,
        priority: 20
    });
}
/**
* Model post-fixer that disallows typing with selection when the selection is placed after the text node with the mention attribute or
* before a text node with mention attribute.
*/ function $a0b6f63298957c68$var$selectionMentionAttributePostFixer(writer, doc) {
    const selection = doc.selection;
    const focus = selection.focus;
    if (selection.isCollapsed && selection.hasAttribute("mention") && $a0b6f63298957c68$var$shouldNotTypeWithMentionAt(focus)) {
        writer.removeSelectionAttribute("mention");
        return true;
    }
    return false;
}
/**
* Helper function to detect if mention attribute should be removed from selection.
* This check makes only sense if the selection has mention attribute.
*
* The mention attribute should be removed from a selection when selection focus is placed:
* a) after a text node
* b) the position is at parents start - the selection will set attributes from node after.
*/ function $a0b6f63298957c68$var$shouldNotTypeWithMentionAt(position) {
    const isAtStart = position.isAtStart;
    return position.nodeBefore && position.nodeBefore.is("$text") || isAtStart;
}
/**
* Model post-fixer that removes the mention attribute from the modified text node.
*/ function $a0b6f63298957c68$var$removePartialMentionPostFixer(writer, doc, schema) {
    const changes = doc.differ.getChanges();
    let wasChanged = false;
    for (const change of changes){
        if (change.type == "attribute") continue;
        const position = change.position;
        if (change.name == "$text") {
            const nodeAfterInsertedTextNode = position.textNode && position.textNode.nextSibling;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(position.textNode, writer) || wasChanged;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(nodeAfterInsertedTextNode, writer) || wasChanged;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(position.nodeBefore, writer) || wasChanged;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(position.nodeAfter, writer) || wasChanged;
        }
        if (change.name != "$text" && change.type == "insert") {
            const insertedNode = position.nodeAfter;
            for (const item of writer.createRangeIn(insertedNode).getItems())wasChanged = $a0b6f63298957c68$var$checkAndFix(item, writer) || wasChanged;
        }
        if (change.type == "insert" && schema.isInline(change.name)) {
            const nodeAfterInserted = position.nodeAfter && position.nodeAfter.nextSibling;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(position.nodeBefore, writer) || wasChanged;
            wasChanged = $a0b6f63298957c68$var$checkAndFix(nodeAfterInserted, writer) || wasChanged;
        }
    }
    return wasChanged;
}
/**
* This post-fixer will extend the attribute applied on the part of the mention so the whole text node of the mention will have
* the added attribute.
*/ function $a0b6f63298957c68$var$extendAttributeOnMentionPostFixer(writer, doc) {
    const changes = doc.differ.getChanges();
    let wasChanged = false;
    for (const change of changes)if (change.type === "attribute" && change.attributeKey != "mention") {
        const nodeBefore = change.range.start.nodeBefore;
        const nodeAfter = change.range.end.nodeAfter;
        for (const node of [
            nodeBefore,
            nodeAfter
        ])if ($a0b6f63298957c68$var$isBrokenMentionNode(node) && node.getAttribute(change.attributeKey) != change.attributeNewValue) {
            writer.setAttribute(change.attributeKey, change.attributeNewValue, node);
            wasChanged = true;
        }
    }
    return wasChanged;
}
/**
* Checks if a node has a correct mention attribute if present.
* Returns `true` if the node is text and has a mention attribute whose text does not match the expected mention text.
*/ function $a0b6f63298957c68$var$isBrokenMentionNode(node) {
    if (!node || !(node.is("$text") || node.is("$textProxy")) || !node.hasAttribute("mention")) return false;
    return node.data != node.getAttribute("mention")._text;
}
/**
* Fixes a mention on a text node if it needs a fix.
*/ function $a0b6f63298957c68$var$checkAndFix(textNode, writer) {
    if ($a0b6f63298957c68$var$isBrokenMentionNode(textNode)) {
        writer.removeAttribute("mention", textNode);
        return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/ui/mentionsview
*/ /**
* The mention ui view.
*/ var $a0b6f63298957c68$export$30cd1d5e8ce2c28d = class extends (0, $29fd27cb9bdab9d2$export$84d0dd190d551cd1) {
    selected;
    position;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        this.extendTemplate({
            attributes: {
                class: [
                    "ck-mentions"
                ],
                tabindex: "-1"
            }
        });
    }
    /**
	* {@link #select Selects} the first item.
	*/ selectFirst() {
        this.select(0);
    }
    /**
	* Selects next item to the currently {@link #select selected}.
	*
	* If the last item is already selected, it will select the first item.
	*/ selectNext() {
        const item = this.selected;
        const index = this.items.getIndex(item);
        this.select(index + 1);
    }
    /**
	* Selects previous item to the currently {@link #select selected}.
	*
	* If the first item is already selected, it will select the last item.
	*/ selectPrevious() {
        const item = this.selected;
        const index = this.items.getIndex(item);
        this.select(index - 1);
    }
    /**
	* Marks item at a given index as selected.
	*
	* Handles selection cycling when passed index is out of bounds:
	* - if the index is lower than 0, it will select the last item,
	* - if the index is higher than the last item index, it will select the first item.
	*
	* @param index Index of an item to be marked as selected.
	*/ select(index) {
        let indexToGet = 0;
        if (index > 0 && index < this.items.length) indexToGet = index;
        else if (index < 0) indexToGet = this.items.length - 1;
        const item = this.items.get(indexToGet);
        if (this.selected === item) return;
        if (this.selected) this.selected.removeHighlight();
        item.highlight();
        this.selected = item;
        if (!this._isItemVisibleInScrolledArea(item)) this.element.scrollTop = item.element.offsetTop;
    }
    /**
	* Triggers the `execute` event on the {@link #select selected} item.
	*/ executeSelected() {
        this.selected.fire("execute");
    }
    /**
	* Checks if an item is visible in the scrollable area.
	*
	* The item is considered visible when:
	* - its top boundary is inside the scrollable rect
	* - its bottom boundary is inside the scrollable rect (the whole item must be visible)
	*/ _isItemVisibleInScrolledArea(item) {
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.element).contains(new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(item.element));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/ui/domwrapperview
*/ /**
* This class wraps DOM element as a CKEditor5 UI View.
*
* It allows to render any DOM element and use it in mentions list.
*/ var $a0b6f63298957c68$export$e28c866df2677437 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* The DOM element for which wrapper was created.
	*/ domElement;
    /**
	* Creates an instance of {@link module:mention/ui/domwrapperview~MentionDomWrapperView} class.
	*
	* Also see {@link #render}.
	*/ constructor(locale, domElement){
        super(locale);
        this.template = void 0;
        this.domElement = domElement;
        this.domElement.classList.add("ck-button", "ck-list-item-button");
        this.set("isOn", false);
        this.on("change:isOn", (evt, name, isOn)=>{
            if (isOn) {
                this.domElement.classList.add("ck-on");
                this.domElement.classList.remove("ck-off");
            } else {
                this.domElement.classList.add("ck-off");
                this.domElement.classList.remove("ck-on");
            }
        });
        this.listenTo(this.domElement, "click", ()=>{
            this.fire("execute");
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.element = this.domElement;
    }
    /**
	* Focuses the DOM element.
	*/ focus() {
        this.domElement.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/ui/mentionlistitemview
*/ var $a0b6f63298957c68$export$34ac78239b4c3c80 = class extends (0, $29fd27cb9bdab9d2$export$41fd379e664153d8) {
    item;
    marker;
    constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("isHighlighted", false);
        this.extendTemplate({
            attributes: {
                class: [
                    bind.if("isHighlighted", "ck-mentions__item_focused")
                ]
            }
        });
    }
    highlight() {
        this.isHighlighted = true;
    }
    removeHighlight() {
        this.isHighlighted = false;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/mentionui
*/ const $a0b6f63298957c68$var$VERTICAL_SPACING = 3;
const $a0b6f63298957c68$var$defaultHandledKeyCodes = [
    (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowup,
    (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowdown,
    (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).esc
];
const $a0b6f63298957c68$var$defaultCommitKeyCodes = [
    (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).enter,
    (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).tab
];
/**
* The mention UI feature.
*/ var $a0b6f63298957c68$export$9e293d7d236029b5 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The mention view.
	*/ _mentionsView;
    /**
	* Stores mention feeds configurations.
	*/ _mentionsConfigurations;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    _items = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    _lastRequested;
    /**
	* Debounced feed requester. It uses `es-toolkit#debounce` method to delay function call.
	*/ _requestFeedDebounced;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "MentionUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._mentionsView = this._createMentionView();
        this._mentionsConfigurations = /* @__PURE__ */ new Map();
        this._requestFeedDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(this._requestFeed, 100);
        editor.config.define("mention", {
            feeds: []
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const commitKeys = editor.config.get("mention.commitKeys") || $a0b6f63298957c68$var$defaultCommitKeyCodes;
        const handledKeyCodes = $a0b6f63298957c68$var$defaultHandledKeyCodes.concat(commitKeys);
        this._balloon = editor.plugins.get((0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c));
        editor.editing.view.document.on("keydown", (evt, data)=>{
            if (isHandledKey(data.keyCode) && this._isUIVisible) {
                data.preventDefault();
                evt.stop();
                if (data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowdown) this._mentionsView.selectNext();
                if (data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).arrowup) this._mentionsView.selectPrevious();
                if (commitKeys.includes(data.keyCode)) this._mentionsView.executeSelected();
                if (data.keyCode == (0, $c7bc2cb7e2db0227$export$6d3e562ac77a9517).esc) this._hideUIAndRemoveMarker();
            }
        }, {
            priority: "highest"
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: this._mentionsView,
            activator: ()=>this._isUIVisible,
            contextElements: ()=>[
                    this._balloon.view.element
                ],
            callback: ()=>this._hideUIAndRemoveMarker()
        });
        const feeds = editor.config.get("mention.feeds");
        for (const mentionDescription of feeds){
            const { feed: feed, marker: marker, dropdownLimit: dropdownLimit } = mentionDescription;
            if (!$a0b6f63298957c68$var$isValidMentionMarker(marker)) /**
			* The marker must be a single character.
			*
			* Correct markers: `'@'`, `'#'`.
			*
			* Incorrect markers: `'$$'`, `'[@'`.
			*
			* See {@link module:mention/mentionconfig~MentionConfig}.
			*
			* @error mentionconfig-incorrect-marker
			* @param {string} marker Configured marker
			*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("mentionconfig-incorrect-marker", null, {
                marker: marker
            });
            const definition = {
                marker: marker,
                feedCallback: typeof feed == "function" ? feed.bind(this.editor) : $a0b6f63298957c68$var$createFeedCallback(feed),
                itemRenderer: mentionDescription.itemRenderer,
                dropdownLimit: dropdownLimit
            };
            this._mentionsConfigurations.set(marker, definition);
        }
        this._setupTextWatcher(feeds);
        this.listenTo(editor, "change:isReadOnly", ()=>{
            this._hideUIAndRemoveMarker();
        });
        this.on("requestFeed:response", (evt, data)=>this._handleFeedResponse(data));
        this.on("requestFeed:error", ()=>this._hideUIAndRemoveMarker());
        /**
		* Checks if a given key code is handled by the mention UI.
		*/ function isHandledKey(keyCode) {
            return handledKeyCodes.includes(keyCode);
        }
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._mentionsView.destroy();
    }
    /**
	* Returns true when {@link #_mentionsView} is in the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon} and it is
	* currently visible.
	*/ get _isUIVisible() {
        return this._balloon.visibleView === this._mentionsView;
    }
    /**
	* Creates the {@link #_mentionsView}.
	*/ _createMentionView() {
        const locale = this.editor.locale;
        const mentionsView = new $a0b6f63298957c68$export$30cd1d5e8ce2c28d(locale);
        mentionsView.items.bindTo(this._items).using((data)=>{
            const { item: item, marker: marker } = data;
            const { dropdownLimit: markerDropdownLimit } = this._mentionsConfigurations.get(marker);
            const dropdownLimit = markerDropdownLimit || this.editor.config.get("mention.dropdownLimit") || 10;
            if (mentionsView.items.length >= dropdownLimit) return null;
            const listItemView = new $a0b6f63298957c68$export$34ac78239b4c3c80(locale);
            const view = this._renderItem(item, marker);
            view.delegate("execute").to(listItemView);
            listItemView.children.add(view);
            listItemView.item = item;
            listItemView.marker = marker;
            listItemView.on("execute", ()=>{
                mentionsView.fire("execute", {
                    item: item,
                    marker: marker
                });
            });
            return listItemView;
        });
        mentionsView.on("execute", (evt, data)=>{
            const editor = this.editor;
            const model = editor.model;
            const item = data.item;
            const marker = data.marker;
            const mentionMarker = editor.model.markers.get("mention");
            const end = model.createPositionAt(model.document.selection.focus);
            const start = model.createPositionAt(mentionMarker.getStart());
            const range = model.createRange(start, end);
            this._hideUIAndRemoveMarker();
            editor.execute("mention", {
                mention: item,
                text: item.text,
                marker: marker,
                range: range
            });
            editor.editing.view.focus();
        });
        return mentionsView;
    }
    /**
	* Returns item renderer for the marker.
	*/ _getItemRenderer(marker) {
        const { itemRenderer: itemRenderer } = this._mentionsConfigurations.get(marker);
        return itemRenderer;
    }
    /**
	* Requests a feed from a configured callbacks.
	*/ _requestFeed(marker, feedText) {
        this._lastRequested = feedText;
        const { feedCallback: feedCallback } = this._mentionsConfigurations.get(marker);
        const feedResponse = feedCallback(feedText);
        if (!(feedResponse instanceof Promise)) {
            this.fire("requestFeed:response", {
                feed: feedResponse,
                marker: marker,
                feedText: feedText
            });
            return;
        }
        feedResponse.then((response)=>{
            if (this._lastRequested == feedText) this.fire("requestFeed:response", {
                feed: response,
                marker: marker,
                feedText: feedText
            });
            else this.fire("requestFeed:discarded", {
                feed: response,
                marker: marker,
                feedText: feedText
            });
        }).catch((error)=>{
            this.fire("requestFeed:error", {
                error: error
            });
            /**
			* The callback used for obtaining mention autocomplete feed thrown and error and the mention UI was hidden or
			* not displayed at all.
			*
			* @error mention-feed-callback-error
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("mention-feed-callback-error", {
                marker: marker
            });
        });
    }
    /**
	* Registers a text watcher for the marker.
	*/ _setupTextWatcher(feeds) {
        const editor = this.editor;
        const feedsWithPattern = feeds.map((feed)=>({
                ...feed,
                pattern: $a0b6f63298957c68$export$46fbcaa083741921(feed.marker, feed.minimumCharacters || 0)
            }));
        const watcher = new (0, $f1defb5a0a139b4c$export$72f65615ddd53ad4)(editor.model, $a0b6f63298957c68$var$createTestCallback(feedsWithPattern));
        watcher.on("matched", (evt, data)=>{
            const markerDefinition = $a0b6f63298957c68$var$getLastValidMarkerInText(feedsWithPattern, data.text);
            const focus = editor.model.document.selection.focus;
            const markerPosition = editor.model.createPositionAt(focus.parent, markerDefinition.position);
            if ($a0b6f63298957c68$var$isPositionInExistingMention(focus) || $a0b6f63298957c68$var$isMarkerInExistingMention(markerPosition)) {
                this._hideUIAndRemoveMarker();
                return;
            }
            const feedText = $a0b6f63298957c68$var$requestFeedText(markerDefinition, data.text);
            const matchedTextLength = markerDefinition.marker.length + feedText.length;
            const start = focus.getShiftedBy(-matchedTextLength);
            const end = focus.getShiftedBy(-feedText.length);
            const markerRange = editor.model.createRange(start, end);
            if ($a0b6f63298957c68$var$checkIfStillInCompletionMode(editor)) {
                const mentionMarker = editor.model.markers.get("mention");
                editor.model.change((writer)=>{
                    writer.updateMarker(mentionMarker, {
                        range: markerRange
                    });
                });
            } else editor.model.change((writer)=>{
                writer.addMarker("mention", {
                    range: markerRange,
                    usingOperation: false,
                    affectsData: false
                });
            });
            this._requestFeedDebounced(markerDefinition.marker, feedText);
        });
        watcher.on("unmatched", ()=>{
            this._hideUIAndRemoveMarker();
        });
        const mentionCommand = editor.commands.get("mention");
        watcher.bind("isEnabled").to(mentionCommand);
        return watcher;
    }
    /**
	* Handles the feed response event data.
	*/ _handleFeedResponse(data) {
        const { feed: feed, marker: marker } = data;
        if (!$a0b6f63298957c68$var$checkIfStillInCompletionMode(this.editor)) return;
        if (!this.editor.commands.get("mention").isEnabled) {
            this._hideUIAndRemoveMarker();
            return;
        }
        this._items.clear();
        for (const feedItem of feed){
            const item = typeof feedItem != "object" ? {
                id: feedItem,
                text: feedItem
            } : feedItem;
            this._items.add({
                item: item,
                marker: marker
            });
        }
        const mentionMarker = this.editor.model.markers.get("mention");
        if (this._items.length) this._showOrUpdateUI(mentionMarker);
        else this._hideUIAndRemoveMarker();
    }
    /**
	* Shows the mentions balloon. If the panel is already visible, it will reposition it.
	*/ _showOrUpdateUI(markerMarker) {
        if (this._isUIVisible) this._balloon.updatePosition(this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position));
        else this._balloon.add({
            view: this._mentionsView,
            position: this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position),
            singleViewMode: true,
            balloonClassName: "ck-mention-balloon"
        });
        this._mentionsView.position = this._balloon.view.position;
        this._mentionsView.selectFirst();
    }
    /**
	* Hides the mentions balloon and removes the 'mention' marker from the markers collection.
	*/ _hideUIAndRemoveMarker() {
        if (this._balloon.hasView(this._mentionsView)) this._balloon.remove(this._mentionsView);
        if ($a0b6f63298957c68$var$checkIfStillInCompletionMode(this.editor)) this.editor.model.change((writer)=>writer.removeMarker("mention"));
        this._mentionsView.position = void 0;
    }
    /**
	* Renders a single item in the autocomplete list.
	*/ _renderItem(item, marker) {
        const editor = this.editor;
        let view;
        let label = item.id;
        const renderer = this._getItemRenderer(marker);
        if (renderer) {
            const renderResult = renderer(item);
            if (typeof renderResult != "string") view = new $a0b6f63298957c68$export$e28c866df2677437(editor.locale, renderResult);
            else label = renderResult;
        }
        if (!view) {
            const buttonView = new (0, $29fd27cb9bdab9d2$export$244268489b08fe2c)(editor.locale);
            buttonView.label = label;
            buttonView.withText = true;
            view = buttonView;
        }
        return view;
    }
    /**
	* Creates a position options object used to position the balloon panel.
	*
	* @param mentionMarker
	* @param preferredPosition The name of the last matched position name.
	*/ _getBalloonPanelPositionData(mentionMarker, preferredPosition) {
        const editor = this.editor;
        const editing = editor.editing;
        const domConverter = editing.view.domConverter;
        const mapper = editing.mapper;
        const uiLanguageDirection = editor.locale.uiLanguageDirection;
        return {
            target: ()=>{
                let modelRange = mentionMarker.getRange();
                if (modelRange.start.root.rootName == "$graveyard") modelRange = editor.model.document.selection.getFirstRange();
                const viewRange = mapper.toViewRange(modelRange);
                return (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d).getDomRangeRects(domConverter.viewRangeToDom(viewRange)).pop();
            },
            limiter: ()=>{
                const view = this.editor.editing.view;
                const editableElement = view.document.selection.editableElement;
                if (editableElement) return view.domConverter.mapViewToDom(editableElement.root);
                return null;
            },
            positions: $a0b6f63298957c68$var$getBalloonPanelPositions(preferredPosition, uiLanguageDirection)
        };
    }
};
/**
* Returns the balloon positions data callbacks.
*/ function $a0b6f63298957c68$var$getBalloonPanelPositions(preferredPosition, uiLanguageDirection) {
    const positions = {
        "caret_se": (targetRect, balloonRect, viewportRect)=>{
            return {
                top: targetRect.bottom + $a0b6f63298957c68$var$VERTICAL_SPACING,
                left: $a0b6f63298957c68$var$fitLeftInViewport(targetRect.right, balloonRect, viewportRect),
                name: "caret_se",
                config: {
                    withArrow: false
                }
            };
        },
        "caret_ne": (targetRect, balloonRect, viewportRect)=>{
            return {
                top: targetRect.top - balloonRect.height - $a0b6f63298957c68$var$VERTICAL_SPACING,
                left: $a0b6f63298957c68$var$fitLeftInViewport(targetRect.right, balloonRect, viewportRect),
                name: "caret_ne",
                config: {
                    withArrow: false
                }
            };
        },
        "caret_sw": (targetRect, balloonRect, viewportRect)=>{
            return {
                top: targetRect.bottom + $a0b6f63298957c68$var$VERTICAL_SPACING,
                left: $a0b6f63298957c68$var$fitLeftInViewport(targetRect.right - balloonRect.width, balloonRect, viewportRect),
                name: "caret_sw",
                config: {
                    withArrow: false
                }
            };
        },
        "caret_nw": (targetRect, balloonRect, viewportRect)=>{
            return {
                top: targetRect.top - balloonRect.height - $a0b6f63298957c68$var$VERTICAL_SPACING,
                left: $a0b6f63298957c68$var$fitLeftInViewport(targetRect.right - balloonRect.width, balloonRect, viewportRect),
                name: "caret_nw",
                config: {
                    withArrow: false
                }
            };
        }
    };
    if (Object.prototype.hasOwnProperty.call(positions, preferredPosition)) return [
        positions[preferredPosition]
    ];
    return uiLanguageDirection !== "rtl" ? [
        positions.caret_se,
        positions.caret_sw,
        positions.caret_ne,
        positions.caret_nw
    ] : [
        positions.caret_sw,
        positions.caret_se,
        positions.caret_nw,
        positions.caret_ne
    ];
}
/**
* Keeps the panel within the viewport horizontally, so it does not get cut off
* when the caret is close to the screen edge (e.g. on mobile).
*
* See https://github.com/ckeditor/ckeditor5/issues/20182.
*/ function $a0b6f63298957c68$var$fitLeftInViewport(left, balloonRect, viewportRect) {
    return Math.max(viewportRect.left, Math.min(left, viewportRect.right - balloonRect.width));
}
/**
* Returns a marker definition of the last valid occurring marker in a given string.
* If there is no valid marker in a string, it returns undefined.
*
* Example of returned object:
*
* ```ts
* {
* 	marker: '@',
* 	position: 4,
* 	minimumCharacters: 0
* }
* ````
*
* @param feedsWithPattern Registered feeds in editor for mention plugin with created RegExp for matching marker.
* @param text String to find the marker in
* @returns Matched marker's definition
*/ function $a0b6f63298957c68$var$getLastValidMarkerInText(feedsWithPattern, text) {
    let lastValidMarker;
    for (const feed of feedsWithPattern){
        const currentMarkerLastIndex = text.lastIndexOf(feed.marker);
        if (currentMarkerLastIndex > 0 && !text.substring(currentMarkerLastIndex - 1).match(feed.pattern)) continue;
        if (!lastValidMarker || currentMarkerLastIndex >= lastValidMarker.position) lastValidMarker = {
            marker: feed.marker,
            position: currentMarkerLastIndex,
            minimumCharacters: feed.minimumCharacters,
            pattern: feed.pattern
        };
    }
    return lastValidMarker;
}
/**
* Creates a RegExp pattern for the marker.
*
* Function has to be exported to achieve 100% code coverage.
*
* @internal
*/ function $a0b6f63298957c68$export$46fbcaa083741921(marker, minimumCharacters) {
    const numberOfCharacters = minimumCharacters == 0 ? "*" : `{${minimumCharacters},}`;
    const openAfterCharacters = (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).features.isRegExpUnicodePropertySupported ? "\\p{Ps}\\p{Pi}\"'" : "\\(\\[{\"'";
    const mentionCharacters = ".";
    marker = marker.replace(/[.*+?^${}()\-|[\]\\]/g, "\\$&");
    const pattern = `(?:^|[ ${openAfterCharacters}])(${marker})(${mentionCharacters}${numberOfCharacters})$`;
    return new RegExp(pattern, "u");
}
/**
* Creates a test callback for the marker to be used in the text watcher instance.
*
* @param feedsWithPattern Feeds of mention plugin configured in editor with RegExp to match marker in text
*/ function $a0b6f63298957c68$var$createTestCallback(feedsWithPattern) {
    const textMatcher = (text)=>{
        const markerDefinition = $a0b6f63298957c68$var$getLastValidMarkerInText(feedsWithPattern, text);
        if (!markerDefinition) return false;
        let splitStringFrom = 0;
        if (markerDefinition.position !== 0) splitStringFrom = markerDefinition.position - 1;
        const textToTest = text.substring(splitStringFrom);
        return markerDefinition.pattern.test(textToTest);
    };
    return textMatcher;
}
/**
* Creates a text matcher from the marker.
*/ function $a0b6f63298957c68$var$requestFeedText(markerDefinition, text) {
    let splitStringFrom = 0;
    if (markerDefinition.position !== 0) splitStringFrom = markerDefinition.position - 1;
    const regExp = $a0b6f63298957c68$export$46fbcaa083741921(markerDefinition.marker, 0);
    return text.substring(splitStringFrom).match(regExp)[2];
}
/**
* The default feed callback.
*/ function $a0b6f63298957c68$var$createFeedCallback(feedItems) {
    return (feedText)=>{
        return feedItems.filter((item)=>{
            return (typeof item == "string" ? item : String(item.id)).toLowerCase().includes(feedText.toLowerCase());
        });
    };
}
/**
* Checks if position in inside or right after a text with a mention.
*/ function $a0b6f63298957c68$var$isPositionInExistingMention(position) {
    const hasMention = position.textNode && position.textNode.hasAttribute("mention");
    const nodeBefore = position.nodeBefore;
    return hasMention || nodeBefore && nodeBefore.is("$text") && nodeBefore.hasAttribute("mention");
}
/**
* Checks if the closest marker offset is at the beginning of a mention.
*
* See https://github.com/ckeditor/ckeditor5/issues/11400.
*/ function $a0b6f63298957c68$var$isMarkerInExistingMention(markerPosition) {
    const nodeAfter = markerPosition.nodeAfter;
    return nodeAfter && nodeAfter.is("$text") && nodeAfter.hasAttribute("mention");
}
/**
* Checks if string is a valid mention marker.
*/ function $a0b6f63298957c68$var$isValidMentionMarker(marker) {
    return !!marker;
}
/**
* Checks the mention plugins is in completion mode (e.g. when typing is after a valid mention string like @foo).
*/ function $a0b6f63298957c68$var$checkIfStillInCompletionMode(editor) {
    return editor.model.markers.has("mention");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module mention/mention
*/ /**
* The mention plugin.
*
* For a detailed overview, check the {@glink features/mentions Mention feature} guide.
*/ var $a0b6f63298957c68$export$e891316fea657d90 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    toMentionAttribute(viewElement, data) {
        return $a0b6f63298957c68$export$fd6086423d98c37c(viewElement, data);
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Mention";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a0b6f63298957c68$export$69d27e973f42b9f5,
            $a0b6f63298957c68$export$9e293d7d236029b5
        ];
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module minimap/minimapiframeview
*/ const $6babb0a728b7781a$var$toPx$1 = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The internal `<iframe>` view that hosts the minimap content.
*
* @internal
*/ var $6babb0a728b7781a$export$5de6b9a25b0ef417 = class extends (0, $29fd27cb9bdab9d2$export$fe1e47b5631a50b2) {
    /**
	* Cached view constructor options for re-use in other methods.
	*/ _options;
    /**
	* Creates an instance of the internal minimap iframe.
	*/ constructor(locale, options){
        super(locale);
        const bind = this.bindTemplate;
        this.set("top", 0);
        this.set("height", 0);
        this._options = options;
        this.extendTemplate({
            attributes: {
                tabindex: -1,
                "aria-hidden": "true",
                class: [
                    "ck-minimap__iframe"
                ],
                style: {
                    top: bind.to("top", (top)=>$6babb0a728b7781a$var$toPx$1(top)),
                    height: bind.to("height", (height)=>$6babb0a728b7781a$var$toPx$1(height))
                }
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        return super.render().then(()=>{
            this._prepareDocument();
        });
    }
    /**
	* Sets the new height of the iframe.
	*/ setHeight(newHeight) {
        this.height = newHeight;
    }
    /**
	* Sets the top offset of the iframe to move it around vertically.
	*/ setTopOffset(newOffset) {
        this.top = newOffset;
    }
    /**
	* Sets the internal structure of the `<iframe>` readying it to display the
	* minimap element.
	*/ _prepareDocument() {
        const iframeDocument = this.element.contentWindow.document;
        const domRootClone = iframeDocument.adoptNode(this._options.domRootClone);
        const boxStyles = this._options.useSimplePreview ? `
			.ck.ck-editor__editable_inline img {
				filter: contrast( 0 );
			}

			p, li, a, figcaption, span {
				background: hsl(0, 0%, 80%) !important;
				color: hsl(0, 0%, 80%) !important;
			}

			h1, h2, h3, h4 {
				background: hsl(0, 0%, 60%) !important;
				color: hsl(0, 0%, 60%) !important;
			}
		` : "";
        const html = `<!DOCTYPE html><html lang="en">
			<head>
				<meta charset="utf-8">
				<meta name="viewport" content="width=device-width, initial-scale=1">
				${this._options.pageStyles.map((definition)=>{
            if (typeof definition === "string") return `<style>${definition}</style>`;
            else return `<link rel="stylesheet" type="text/css" href="${definition.href}">`;
        }).join("\n")}
				<style>
					html, body {
						margin: 0 !important;
						padding: 0 !important;
					}

					html {
						overflow: hidden;
					}

					body {
						transform: scale( ${this._options.scaleRatio} );
						transform-origin: 0 0;
						overflow: visible;
					}

					.ck.ck-editor__editable_inline {
						margin: 0 !important;
						border-color: transparent !important;
						outline-color: transparent !important;
						box-shadow: none !important;
					}

					.ck.ck-content {
						background: white;
					}

					${boxStyles}
				</style>
			</head>
			<body class="${this._options.extraClasses || ""}"></body>
		</html>`;
        iframeDocument.open();
        iframeDocument.write((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(html));
        iframeDocument.close();
        iframeDocument.body.appendChild(domRootClone);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module minimap/minimappositiontrackerview
*/ const $6babb0a728b7781a$var$toPx = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The position tracker visualizing the visible subset of the content. Displayed over the minimap.
*
* @internal
*/ var $6babb0a728b7781a$export$9bf29ef5155c1f06 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("height", 0);
        this.set("top", 0);
        this.set("scrollProgress", 0);
        this.set("_isDragging", false);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-minimap__position-tracker",
                    bind.if("_isDragging", "ck-minimap__position-tracker_dragging")
                ],
                style: {
                    top: bind.to("top", (top)=>$6babb0a728b7781a$var$toPx(top)),
                    height: bind.to("height", (height)=>$6babb0a728b7781a$var$toPx(height))
                },
                "data-progress": bind.to("scrollProgress")
            },
            on: {
                mousedown: bind.to(()=>{
                    this._isDragging = true;
                })
            }
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mousemove", (evt, data)=>{
            if (!this._isDragging) return;
            this.fire("drag", data.movementY);
        }, {
            useCapture: true
        });
        this.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document, "mouseup", ()=>{
            this._isDragging = false;
        }, {
            useCapture: true
        });
    }
    /**
	* Sets the new height of the tracker to visualize the subset of the content visible to the user.
	*/ setHeight(newHeight) {
        this.height = newHeight;
    }
    /**
	* Sets the top offset of the tracker to move it around vertically.
	*/ setTopOffset(newOffset) {
        this.top = newOffset;
    }
    /**
	* Sets the scroll progress (in %) to inform the user using a label when the tracker is being dragged.
	*/ setScrollProgress(newProgress) {
        this.scrollProgress = newProgress;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module minimap/minimapview
*/ /**
* The main view of the minimap. It renders the original content but scaled down with a tracker element
* visualizing the subset of the content visible to the user and allowing interactions (scrolling, dragging).
*
* @internal
*/ var $6babb0a728b7781a$export$dd205db65c226d50 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* An instance of the tracker view displayed over the minimap.
	*/ _positionTrackerView;
    /**
	* The scale ratio of the minimap relative to the original editing DOM root with the content.
	*/ _scaleRatio;
    /**
	* An instance of the iframe view that hosts the minimap.
	*/ _minimapIframeView;
    /**
	* Creates an instance of the minimap view.
	*/ constructor({ locale: locale, scaleRatio: scaleRatio, pageStyles: pageStyles, extraClasses: extraClasses, useSimplePreview: useSimplePreview, domRootClone: domRootClone }){
        super(locale);
        const bind = this.bindTemplate;
        this._positionTrackerView = new $6babb0a728b7781a$export$9bf29ef5155c1f06(locale);
        this._positionTrackerView.delegate("drag").to(this);
        this._scaleRatio = scaleRatio;
        this._minimapIframeView = new $6babb0a728b7781a$export$5de6b9a25b0ef417(locale, {
            useSimplePreview: useSimplePreview,
            pageStyles: pageStyles,
            extraClasses: extraClasses,
            scaleRatio: scaleRatio,
            domRootClone: domRootClone
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-minimap"
                ]
            },
            children: [
                this._positionTrackerView
            ],
            on: {
                click: bind.to(this._handleMinimapClick.bind(this)),
                wheel: bind.to(this._handleMinimapMouseWheel.bind(this))
            }
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._minimapIframeView.destroy();
        super.destroy();
    }
    /**
	* Returns the DOM {@link module:utils/dom/rect~Rect} height of the minimap.
	*/ get height() {
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(this.element).height;
    }
    /**
	* Returns the number of available space (pixels) the position tracker (visible subset of the content) can use to scroll vertically.
	*/ get scrollHeight() {
        return Math.max(0, Math.min(this.height, this._minimapIframeView.height) - this._positionTrackerView.height);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this._minimapIframeView.render();
        this.element.appendChild(this._minimapIframeView.element);
    }
    /**
	* Sets the new height of the minimap (in px) to respond to the changes in the original editing DOM root.
	*
	* **Note**:The provided value should be the `offsetHeight` of the original editing DOM root.
	*/ setContentHeight(newHeight) {
        this._minimapIframeView.setHeight(newHeight * this._scaleRatio);
    }
    /**
	* Sets the minimap scroll progress.
	*
	* The minimap scroll progress is linked to the original editing DOM root and its scrollable container (ancestor).
	* Changing the progress will alter the vertical position of the minimap (and its position tracker) and give the user an accurate
	* overview of the visible document.
	*
	* **Note**: The value should be between 0 and 1. 0 when the DOM root has not been scrolled, 1 when the
	* scrolling has reached the end.
	*/ setScrollProgress(newScrollProgress) {
        const iframeView = this._minimapIframeView;
        const positionTrackerView = this._positionTrackerView;
        if (iframeView.height < this.height) {
            iframeView.setTopOffset(0);
            positionTrackerView.setTopOffset((iframeView.height - positionTrackerView.height) * newScrollProgress);
        } else {
            const totalOffset = iframeView.height - this.height;
            iframeView.setTopOffset(-totalOffset * newScrollProgress);
            positionTrackerView.setTopOffset((this.height - positionTrackerView.height) * newScrollProgress);
        }
        positionTrackerView.setScrollProgress(Math.round(newScrollProgress * 100));
    }
    /**
	* Sets the new height of the tracker (in px) to visualize the subset of the content visible to the user.
	*/ setPositionTrackerHeight(trackerHeight) {
        this._positionTrackerView.setHeight(trackerHeight * this._scaleRatio);
    }
    /**
	* @param data DOM event data
	*/ _handleMinimapClick(data) {
        const positionTrackerView = this._positionTrackerView;
        if (data.target === positionTrackerView.element) return;
        const trackerViewRect = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(positionTrackerView.element);
        const percentage = (data.clientY - trackerViewRect.top - trackerViewRect.height / 2) / this._minimapIframeView.height;
        this.fire("click", percentage);
    }
    /**
	* @param data DOM event data
	*/ _handleMinimapMouseWheel(data) {
        this.fire("drag", data.deltaY * this._scaleRatio);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module minimap/utils
*/ /**
* Clones the editing view DOM root by using a dedicated pair of {@link module:engine/view/renderer~ViewRenderer} and
* {@link module:engine/view/domconverter~ViewDomConverter}. The DOM root clone updates incrementally to stay in sync with the
* source root.
*
* @internal
* @param editor The editor instance the original editing root belongs to.
* @param rootName The name of the root to clone.
* @returns The editing root DOM clone element.
*/ function $6babb0a728b7781a$export$e8d2c2cd52baff09(editor, rootName) {
    const viewDocument = editor.editing.view.document;
    const viewRoot = viewDocument.getRoot(rootName);
    const domConverter = new (0, $b9b9f2bdf9c6137f$export$f7719161406171fa)(viewDocument);
    const renderer = new (0, $b9b9f2bdf9c6137f$export$90ab2f690fef43b1)(domConverter, viewDocument.selection);
    const domRootClone = editor.editing.view.getDomRoot().cloneNode();
    domConverter.bindElements(domRootClone, viewRoot);
    renderer.markToSync("children", viewRoot);
    renderer.markToSync("attributes", viewRoot);
    viewRoot.on("change:children", (evt, node)=>renderer.markToSync("children", node));
    viewRoot.on("change:attributes", (evt, node)=>renderer.markToSync("attributes", node));
    viewRoot.on("change:text", (evt, node)=>renderer.markToSync("text", node));
    renderer.render();
    editor.editing.view.on("render", ()=>renderer.render());
    editor.on("destroy", ()=>{
        domConverter.unbindDomElement(domRootClone);
    });
    return domRootClone;
}
/**
* Harvests all web page styles, for instance, to allow re-using them in an `<iframe>` preserving the look of the content.
*
* The returned data format is as follows:
*
* ```ts
* [
* 	'p { color: red; ... } h2 { font-size: 2em; ... } ...',
* 	'.spacing { padding: 1em; ... }; ...',
* 	'...',
* 	{ href: 'http://link.to.external.stylesheet' },
* 	{ href: '...' }
* ]
* ```
*
* **Note**: For stylesheets with `href` different than window origin, an object is returned because
* accessing rules of these styles may cause CORS errors (depending on the configuration of the web page).
*
* @internal
*/ function $6babb0a728b7781a$export$565a0a69dad33d66() {
    return Array.from((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.styleSheets).map((styleSheet)=>{
        if (styleSheet.href && !styleSheet.href.startsWith((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.location.origin)) return {
            href: styleSheet.href
        };
        return Array.from(styleSheet.cssRules).filter((rule)=>!(rule instanceof CSSMediaRule)).map((rule)=>rule.cssText).join(" \n");
    });
}
/**
* Gets dimensions rectangle according to passed DOM element. Returns whole window's size for `body` element.
*
* @internal
*/ function $6babb0a728b7781a$export$181820a2a618a19f(domElement) {
    return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domElement === (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body ? (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window : domElement);
}
/**
* Gets client height according to passed DOM element. Returns window's height for `body` element.
*
* @internal
*/ function $6babb0a728b7781a$export$35b9f582246500bb(domElement) {
    return domElement === (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body ? (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.innerHeight : domElement.clientHeight;
}
/**
* Returns the DOM element itself if it's not a `body` element, whole window otherwise.
*
* @internal
*/ function $6babb0a728b7781a$export$9672b99dc7406c86(domElement) {
    return domElement === (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body ? (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window : domElement;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module minimap/minimap
*/ /**
* The content minimap feature.
*/ var $6babb0a728b7781a$export$a8b4308ba35ee473 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Minimap";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* The reference to the view of the minimap.
	*/ _minimapView;
    /**
	* The DOM element closest to the editable element of the editor as returned
	* by {@link module:ui/editorui/editorui~EditorUI#getEditableElement}.
	*/ _scrollableRootAncestor;
    /**
	* The DOM element closest to the editable element of the editor as returned
	* by {@link module:ui/editorui/editorui~EditorUI#getEditableElement}.
	*/ _editingRootElement;
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        this._minimapView = null;
        this._scrollableRootAncestor = null;
        this.listenTo(editor.ui, "ready", this._onUiReady.bind(this));
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this._minimapView.destroy();
        this._minimapView.element.remove();
    }
    /**
	* Initializes the minimap view element and starts the layout synchronization
	* on the editing view `render` event.
	*/ _onUiReady() {
        const editor = this.editor;
        const editingRootElement = this._editingRootElement = editor.ui.getEditableElement();
        this._scrollableRootAncestor = (0, $c7bc2cb7e2db0227$export$eb6c9aac129b0a9e)(editingRootElement);
        if (!editingRootElement.isConnected) {
            editor.ui.once("update", this._onUiReady.bind(this));
            return;
        }
        this._initializeMinimapView();
        this.listenTo(editor.editing.view, "render", ()=>{
            if (editor.state !== "ready") return;
            this._syncMinimapToEditingRootScrollPosition();
        });
        this._syncMinimapToEditingRootScrollPosition();
    }
    /**
	* Initializes the minimap view and attaches listeners that make it responsive to the environment (document)
	* but also allow the minimap to control the document (scroll position).
	*/ _initializeMinimapView() {
        const editor = this.editor;
        const locale = editor.locale;
        const useSimplePreview = editor.config.get("minimap.useSimplePreview");
        const minimapContainerElement = editor.config.get("minimap.container");
        const scrollableRootAncestor = this._scrollableRootAncestor;
        const editingRootElementWidth = $6babb0a728b7781a$export$181820a2a618a19f(this._editingRootElement).width;
        const minimapScaleRatio = $6babb0a728b7781a$export$181820a2a618a19f(minimapContainerElement).width / editingRootElementWidth;
        const minimapView = this._minimapView = new $6babb0a728b7781a$export$dd205db65c226d50({
            locale: locale,
            scaleRatio: minimapScaleRatio,
            pageStyles: $6babb0a728b7781a$export$565a0a69dad33d66(),
            extraClasses: editor.config.get("minimap.extraClasses"),
            useSimplePreview: useSimplePreview,
            domRootClone: $6babb0a728b7781a$export$e8d2c2cd52baff09(editor)
        });
        minimapView.render();
        minimapView.listenTo(scrollableRootAncestor.getRootNode(), "scroll", (evt, data)=>{
            if (scrollableRootAncestor === (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body) {
                if (data.target !== (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document) return;
            } else if (data.target !== scrollableRootAncestor) return;
            this._syncMinimapToEditingRootScrollPosition();
        }, {
            useCapture: true,
            usePassive: true
        });
        minimapView.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize", ()=>{
            this._syncMinimapToEditingRootScrollPosition();
        });
        minimapView.on("drag", (evt, movementY)=>{
            let movementYPercentage;
            if (minimapView.scrollHeight === 0) movementYPercentage = 0;
            else movementYPercentage = movementY / minimapView.scrollHeight;
            const absoluteScrollProgress = movementYPercentage * (scrollableRootAncestor.scrollHeight - $6babb0a728b7781a$export$35b9f582246500bb(scrollableRootAncestor));
            $6babb0a728b7781a$export$9672b99dc7406c86(scrollableRootAncestor).scrollBy(0, Math.round(absoluteScrollProgress));
        });
        minimapView.on("click", (evt, percentage)=>{
            const absoluteScrollProgress = percentage * scrollableRootAncestor.scrollHeight;
            $6babb0a728b7781a$export$9672b99dc7406c86(scrollableRootAncestor).scrollBy(0, Math.round(absoluteScrollProgress));
        });
        minimapContainerElement.appendChild(minimapView.element);
    }
    /**
	* @private
	*/ _syncMinimapToEditingRootScrollPosition() {
        const editingRootElement = this._editingRootElement;
        const minimapView = this._minimapView;
        minimapView.setContentHeight(editingRootElement.offsetHeight);
        const editingRootRect = $6babb0a728b7781a$export$181820a2a618a19f(editingRootElement);
        const scrollableRootAncestorRect = $6babb0a728b7781a$export$181820a2a618a19f(this._scrollableRootAncestor);
        let scrollProgress;
        if (!scrollableRootAncestorRect.getIntersection(editingRootRect)) return;
        if (scrollableRootAncestorRect.contains(editingRootRect)) scrollProgress = 0;
        else if (editingRootRect.top > scrollableRootAncestorRect.top) scrollProgress = 0;
        else {
            scrollProgress = (editingRootRect.top - scrollableRootAncestorRect.top) / (scrollableRootAncestorRect.height - editingRootRect.height);
            scrollProgress = Math.max(0, Math.min(scrollProgress, 1));
        }
        minimapView.setPositionTrackerHeight(scrollableRootAncestorRect.getIntersection(editingRootRect).height);
        minimapView.setScrollProgress(scrollProgress);
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module page-break/pagebreakcommand
*/ /**
* The page break command.
*
* The command is registered by {@link module:page-break/pagebreakediting~PageBreakEditing} as `'pageBreak'`.
*
* To insert a page break at the current selection, execute the command:
*
*		editor.execute( 'pageBreak' );
*/ var $8dd32444b4017c96$export$57d6a549818b3506 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        this.isEnabled = $8dd32444b4017c96$var$isPageBreakAllowedInParent(selection, schema, model);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        model.change((writer)=>{
            const pageBreakElement = writer.createElement("pageBreak");
            model.insertObject(pageBreakElement, null, null, {
                setSelection: "after"
            });
        });
    }
};
/**
* Checks if a page break is allowed by the schema in the optimal insertion parent.
*/ function $8dd32444b4017c96$var$isPageBreakAllowedInParent(selection, schema, model) {
    const parent = $8dd32444b4017c96$var$getInsertPageBreakParent(selection, model);
    return schema.checkChild(parent, "pageBreak");
}
/**
* Returns a node that will be used to insert a page break with `model.insertContent` to check if the page break can be placed there.
*/ function $8dd32444b4017c96$var$getInsertPageBreakParent(selection, model) {
    const parent = (0, $5547ab21e02f1e9e$export$d03cbafb1cb45bb)(selection, model).start.parent;
    if (parent.isEmpty && !parent.is("rootElement")) return parent.parent;
    return parent;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module page-break/pagebreakediting
*/ /**
* The page break editing feature.
*/ var $8dd32444b4017c96$export$d692d282cfbed7c3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PageBreakEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "PB";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const t = editor.t;
        const conversion = editor.conversion;
        schema.register("pageBreak", {
            inheritAllFrom: "$blockObject"
        });
        conversion.for("dataDowncast").elementToStructure({
            model: "pageBreak",
            view: (modelElement, { writer: writer })=>{
                return writer.createContainerElement("div", {
                    class: "page-break",
                    style: "page-break-after: always"
                }, writer.createContainerElement("span", {
                    style: "display: none"
                }));
            }
        });
        conversion.for("editingDowncast").elementToStructure({
            model: "pageBreak",
            view: (modelElement, { writer: writer })=>{
                const label = t("Page break");
                const viewWrapper = writer.createContainerElement("div");
                const viewLabelElement = writer.createRawElement("span", {
                    class: "page-break__label"
                }, function(domElement) {
                    domElement.innerText = t("Page break");
                });
                writer.addClass("page-break", viewWrapper);
                writer.insert(writer.createPositionAt(viewWrapper, 0), viewLabelElement);
                return $8dd32444b4017c96$var$toPageBreakWidget(viewWrapper, writer, label);
            }
        });
        conversion.for("upcast").elementToElement({
            view: (element)=>{
                const hasPageBreakBefore = element.getStyle("page-break-before") == "always";
                const hasPageBreakAfter = element.getStyle("page-break-after") == "always";
                if (!hasPageBreakBefore && !hasPageBreakAfter) return null;
                if (element.childCount == 1) {
                    const viewSpan = element.getChild(0);
                    if (!viewSpan.is("element", "span") || viewSpan.getStyle("display") != "none") return null;
                } else if (element.childCount > 1) return null;
                return {
                    name: true,
                    styles: [
                        ...hasPageBreakBefore ? [
                            "page-break-before"
                        ] : [],
                        ...hasPageBreakAfter ? [
                            "page-break-after"
                        ] : []
                    ],
                    ...element.hasClass("page-break") && {
                        classes: [
                            "page-break"
                        ]
                    }
                };
            },
            model: "pageBreak",
            converterPriority: "high"
        });
        editor.commands.add("pageBreak", new $8dd32444b4017c96$export$57d6a549818b3506(editor));
    }
};
/**
* Converts a given {@link module:engine/view/element~ViewElement} to a page break widget:
* * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property} allowing to
*   recognize the page break widget element.
* * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
*/ function $8dd32444b4017c96$var$toPageBreakWidget(viewElement, writer, label) {
    writer.setCustomProperty("pageBreak", true, viewElement);
    return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer, {
        label: label
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module page-break/pagebreakui
*/ /**
* The page break UI plugin.
*/ var $8dd32444b4017c96$export$b9c03df8f97137ba = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PageBreakUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("pageBreak", ()=>{
            const view = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            view.set({
                tooltip: true
            });
            return view;
        });
        editor.ui.componentFactory.add("menuBar:pageBreak", ()=>this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
    /**
	* Creates a button for page break command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("pageBreak");
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Page break"),
            icon: (0, $e8dc502aba5ac3f5$export$610436cce4c8959f)
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute("pageBreak");
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module page-break/pagebreak
*/ /**
* The page break feature.
*
* It provides the possibility to insert a page break into the rich-text editor.
*
* For a detailed overview, check the {@glink features/page-break Page break feature} documentation.
*/ var $8dd32444b4017c96$export$9423c247516c9fc8 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $8dd32444b4017c96$export$d692d282cfbed7c3,
            $8dd32444b4017c96$export$b9c03df8f97137ba,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PageBreak";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};



/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Transforms `<a>` elements which are bookmarks by moving their children after the element.
*
* @internal
*/ function $c9a106b2ac3205bf$export$4bd3ae42e1922040(documentFragment, writer) {
    const elementsToChange = [];
    for (const value of writer.createRangeIn(documentFragment)){
        const element = value.item;
        if (element.is("element", "a") && !element.hasAttribute("href") && (element.hasAttribute("id") || element.hasAttribute("name"))) elementsToChange.push(element);
    }
    for (const element of elementsToChange){
        const index = element.parent.getChildIndex(element) + 1;
        const children = element.getChildren();
        writer.insertChild(index, children, element.parent);
        if ($c9a106b2ac3205bf$var$isHiddenBookmarkAnchor(element)) writer.remove(element);
    }
}
/**
* Checks whether the given element is a hidden or auto-generated bookmark anchor.
*
* Editors like MS Word and Google Docs use the `name` attribute (rather than `id`)
* for bookmarks. Furthermore, they reserve `_`-prefixed bookmark names for
* auto-generated anchors (e.g., Table of Contents or internal hyperlinks) and
* do not allow users to manually create custom bookmarks starting with an underscore.
*
* @param element The element to check.
* @returns True if the element is a hidden bookmark anchor, false otherwise.
*/ function $c9a106b2ac3205bf$var$isHiddenBookmarkAnchor(element) {
    const name = element.getAttribute("name");
    return !!name && name.startsWith("_");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/utils
*/ /**
* Normalizes CSS length value to 'px'.
*
* @internal
*/ function $c9a106b2ac3205bf$export$83f51b87ae43affe(value) {
    const numericValue = parseFloat(value);
    if (value.endsWith("pt")) return $c9a106b2ac3205bf$export$35fc22a9f46edcd4(numericValue * 96 / 72);
    else if (value.endsWith("pc")) return $c9a106b2ac3205bf$export$35fc22a9f46edcd4(numericValue * 1152 / 72);
    else if (value.endsWith("in")) return $c9a106b2ac3205bf$export$35fc22a9f46edcd4(numericValue * 96);
    else if (value.endsWith("cm")) return $c9a106b2ac3205bf$export$35fc22a9f46edcd4(numericValue * 96 / 2.54);
    else if (value.endsWith("mm")) return $c9a106b2ac3205bf$export$35fc22a9f46edcd4(numericValue / 10 * 96 / 2.54);
    return value;
}
/**
* Returns true for value with 'px' unit.
*
* @internal
*/ function $c9a106b2ac3205bf$export$5faea1e8af8ff33f(value) {
    return value !== void 0 && value.endsWith("px");
}
/**
* Returns a rounded 'px' value.
*
* @internal
*/ function $c9a106b2ac3205bf$export$35fc22a9f46edcd4(value) {
    return Math.round(value) + "px";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/list
*/ /**
* Transforms Word specific list-like elements to the semantic HTML lists.
*
* Lists in Word are represented by block elements with special attributes like:
*
* ```xml
* <p class=MsoListParagraphCxSpFirst style='mso-list:l1 level1 lfo1'>...</p> // Paragraph based list.
* <h1 style='mso-list:l0 level1 lfo1'>...</h1> // Heading 1 based list.
* ```
*
* @param documentFragment The view structure to be transformed.
* @param stylesString Styles from which list-like elements styling will be extracted.
* @param hasMultiLevelListPlugin Whether the editor has the multi-level list plugin enabled.
* @param enableSkipLevelLists Whether to enable skip-level lists.
* @internal
*/ function $c9a106b2ac3205bf$export$9adba5c627109c96(documentFragment, stylesString, hasMultiLevelListPlugin, enableSkipLevelLists = false) {
    if (!documentFragment.childCount) return;
    const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(documentFragment.document);
    const itemLikeElements = $c9a106b2ac3205bf$var$findAllItemLikeElements(documentFragment, writer);
    if (!itemLikeElements.length) return;
    const encounteredLists = [];
    const stack = [];
    let topLevelListInfo = $c9a106b2ac3205bf$var$createTopLevelListInfo();
    for (const itemLikeElement of itemLikeElements)if (itemLikeElement.indent !== void 0) {
        if (!$c9a106b2ac3205bf$var$isListContinuation(itemLikeElement)) {
            $c9a106b2ac3205bf$var$applyIndentationToTopLevelList(writer, stack, topLevelListInfo);
            topLevelListInfo = $c9a106b2ac3205bf$var$createTopLevelListInfo();
            encounteredLists.length = 1;
            stack.length = 0;
        }
        const originalListId = `${itemLikeElement.id}:${itemLikeElement.indent}`;
        const indent = enableSkipLevelLists ? itemLikeElement.indent - 1 : Math.min(itemLikeElement.indent - 1, stack.length);
        if (indent < stack.length && stack[indent].id !== itemLikeElement.id) {
            if (indent == 0 && topLevelListInfo.canApplyMarginOnList && topLevelListInfo.topLevelListItemElements.length > 0) {
                $c9a106b2ac3205bf$var$applyIndentationToTopLevelList(writer, stack, topLevelListInfo);
                topLevelListInfo = $c9a106b2ac3205bf$var$createTopLevelListInfo();
            }
            encounteredLists.length = indent;
            stack.length = indent;
        }
        if (indent < stack.length - 1) {
            encounteredLists.length = indent + 1;
            stack.length = indent + 1;
        }
        const listStyle = $c9a106b2ac3205bf$var$detectListStyle(itemLikeElement, stylesString);
        while(stack.length < indent){
            const intermediateList = writer.createElement(listStyle.type);
            const intermediateListItem = writer.createElement("li");
            writer.setStyle("list-style-type", "none", intermediateListItem);
            if (stack.length == 0) {
                const parent = itemLikeElement.element.parent;
                const index = parent.getChildIndex(itemLikeElement.element) + 1;
                writer.insertChild(index, intermediateList, parent);
            } else {
                const parentListItems = stack[stack.length - 1].listItemElements;
                writer.appendChild(intermediateList, parentListItems[parentListItems.length - 1]);
            }
            writer.appendChild(intermediateListItem, intermediateList);
            stack.push({
                ...itemLikeElement,
                listElement: intermediateList,
                listItemElements: [
                    intermediateListItem
                ],
                isIntermediate: true,
                marginLeft: void 0
            });
        }
        if (indent > stack.length - 1 || stack[indent].listElement.name != listStyle.type) {
            if (listStyle.type == "ol" && itemLikeElement.id !== void 0 && encounteredLists[indent] && encounteredLists[indent][originalListId]) listStyle.startIndex = encounteredLists[indent][originalListId];
            const listElement = $c9a106b2ac3205bf$var$createNewEmptyList(listStyle, writer, hasMultiLevelListPlugin);
            if (stack.length == 0) {
                const parent = itemLikeElement.element.parent;
                const index = parent.getChildIndex(itemLikeElement.element) + 1;
                writer.insertChild(index, listElement, parent);
            } else if (indent == 0) {
                const existingList = stack[0].listElement;
                const listParent = existingList.parent;
                const insertIndex = listParent.getChildIndex(existingList) + 1;
                writer.insertChild(insertIndex, listElement, listParent);
            } else {
                const parentListItems = stack[indent - 1].listItemElements;
                writer.appendChild(listElement, parentListItems[parentListItems.length - 1]);
            }
            stack[indent] = {
                ...itemLikeElement,
                listElement: listElement,
                listItemElements: []
            };
            if (itemLikeElement.id !== void 0) {
                if (!encounteredLists[indent]) encounteredLists[indent] = {};
                encounteredLists[indent][originalListId] = listStyle.startIndex || 1;
            }
        } else if (stack[indent].isIntermediate) {
            $c9a106b2ac3205bf$var$applyListStyleToElement(stack[indent].listElement, listStyle, writer, hasMultiLevelListPlugin);
            stack[indent] = {
                ...itemLikeElement,
                listElement: stack[indent].listElement,
                listItemElements: stack[indent].listItemElements
            };
            /* v8 ignore else -- @preserve */ if (itemLikeElement.id !== void 0) {
                /* v8 ignore else -- @preserve */ if (!encounteredLists[indent]) encounteredLists[indent] = {};
                encounteredLists[indent][originalListId] = listStyle.startIndex || 1;
            }
        }
        const listItem = itemLikeElement.element.name == "li" ? itemLikeElement.element : writer.createElement("li");
        $c9a106b2ac3205bf$var$applyListItemMarginLeftAndUpdateTopLevelInfo(writer, stack, topLevelListInfo, itemLikeElement, listItem, indent);
        writer.appendChild(listItem, stack[indent].listElement);
        stack[indent].listItemElements.push(listItem);
        if (itemLikeElement.id !== void 0 && encounteredLists[indent]) encounteredLists[indent][originalListId]++;
        if (itemLikeElement.element != listItem) writer.appendChild(itemLikeElement.element, listItem);
        $c9a106b2ac3205bf$var$removeBulletElement(itemLikeElement.element, writer);
        writer.removeStyle("text-indent", itemLikeElement.element);
        writer.removeStyle("margin-left", itemLikeElement.element);
    } else {
        const stackItem = stack.find((stackItem)=>stackItem.marginLeft == itemLikeElement.marginLeft);
        if (stackItem) {
            const listItems = stackItem.listItemElements;
            writer.appendChild(itemLikeElement.element, listItems[listItems.length - 1]);
            writer.removeStyle("margin-left", itemLikeElement.element);
            stack.length = stack.indexOf(stackItem) + 1;
            encounteredLists.length = stack.length + 1;
        } else {
            $c9a106b2ac3205bf$var$applyIndentationToTopLevelList(writer, stack, topLevelListInfo);
            topLevelListInfo = $c9a106b2ac3205bf$var$createTopLevelListInfo();
            stack.length = 0;
        }
    }
    $c9a106b2ac3205bf$var$applyIndentationToTopLevelList(writer, stack, topLevelListInfo);
}
function $c9a106b2ac3205bf$var$applyListItemMarginLeftAndUpdateTopLevelInfo(writer, stack, topLevelListInfo, itemLikeElement, listItem, indent) {
    if (itemLikeElement.marginLeft === void 0) {
        if (indent == 0) topLevelListInfo.canApplyMarginOnList = false;
        return;
    }
    const listItemBlockMarginLeft = parseFloat(itemLikeElement.marginLeft);
    let currentListBlockIndent = 0;
    for(let ancestorIndex = 0; ancestorIndex < stack.length - 1; ancestorIndex++){
        const ancestorListItems = stack[ancestorIndex].listItemElements;
        const ancestorMargin = ancestorListItems[ancestorListItems.length - 1].getStyle("margin-left");
        if (ancestorMargin !== void 0) currentListBlockIndent += parseFloat(ancestorMargin);
    }
    currentListBlockIndent += stack.length * 40;
    const adjustedListItemIndent = listItemBlockMarginLeft - currentListBlockIndent;
    const listItemBlockMarginLeftPx = adjustedListItemIndent !== 0 ? $c9a106b2ac3205bf$export$35fc22a9f46edcd4(adjustedListItemIndent) : void 0;
    if (listItemBlockMarginLeftPx) {
        writer.setStyle("margin-left", listItemBlockMarginLeftPx, listItem);
        if (indent == 0 && topLevelListInfo.canApplyMarginOnList) {
            if (topLevelListInfo.marginLeft === void 0) topLevelListInfo.marginLeft = listItemBlockMarginLeftPx;
            if (listItemBlockMarginLeftPx !== topLevelListInfo.marginLeft) topLevelListInfo.canApplyMarginOnList = false;
            topLevelListInfo.topLevelListItemElements.push(listItem);
        }
    }
}
function $c9a106b2ac3205bf$var$createTopLevelListInfo() {
    return {
        marginLeft: void 0,
        canApplyMarginOnList: true,
        topLevelListItemElements: []
    };
}
/**
* Sets margin-left style to the top-level list if all its items have the same margin-left.
* If margin-left is set on the list, it is removed from all its items to avoid doubling of margins.
*/ function $c9a106b2ac3205bf$var$applyIndentationToTopLevelList(writer, stack, topLevelListInfo) {
    if (topLevelListInfo.canApplyMarginOnList && topLevelListInfo.marginLeft && topLevelListInfo.topLevelListItemElements.length > 0) {
        writer.setStyle("margin-left", topLevelListInfo.marginLeft, stack[0].listElement);
        for (const topLevelListItem of topLevelListInfo.topLevelListItemElements)writer.removeStyle("margin-left", topLevelListItem);
    }
}
/**
* Removes paragraph wrapping content inside a list item.
*
* @internal
*/ function $c9a106b2ac3205bf$export$5e5c708e22065a7(documentFragment, writer) {
    for (const value of writer.createRangeIn(documentFragment)){
        const element = value.item;
        if (element.is("element", "li")) {
            const firstChild = element.getChild(0);
            if (firstChild && firstChild.is("element", "p")) writer.unwrapElement(firstChild);
        }
    }
}
/**
* Finds all list-like elements in a given document fragment.
*
* @param documentFragment Document fragment in which to look for list-like nodes.
* @returns Array of found list-like items. Each item is an object containing
* @internal
*/ function $c9a106b2ac3205bf$var$findAllItemLikeElements(documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const itemLikeElements = [];
    const foundMargins = /* @__PURE__ */ new Set();
    for (const item of range.getItems()){
        if (!item.is("element") || !item.name.match(/^(p|h\d+|li|div)$/)) continue;
        let marginLeft = $c9a106b2ac3205bf$var$getMarginLeftNormalized(item);
        if (marginLeft !== void 0 && parseFloat(marginLeft) == 0 && !Array.from(item.getClassNames()).find((className)=>className.startsWith("MsoList"))) marginLeft = void 0;
        if (item.hasStyle("mso-list") && item.getStyle("mso-list") !== "none" || marginLeft !== void 0 && foundMargins.has(marginLeft)) {
            const itemData = $c9a106b2ac3205bf$var$getListItemData(item);
            itemLikeElements.push({
                element: item,
                id: itemData.id,
                order: itemData.order,
                indent: itemData.indent,
                marginLeft: marginLeft
            });
            if (marginLeft !== void 0) foundMargins.add(marginLeft);
        } else foundMargins.clear();
    }
    return itemLikeElements;
}
/**
* Whether the given element is possibly a list continuation. Previous element was wrapped into a list
* or the current element already is inside a list.
*/ function $c9a106b2ac3205bf$var$isListContinuation(currentItem) {
    let previousSibling = currentItem.element.previousSibling;
    while(previousSibling && $c9a106b2ac3205bf$var$isStrayInlineMarker(previousSibling))previousSibling = previousSibling.previousSibling;
    if (!previousSibling) {
        const parent = currentItem.element.parent;
        return $c9a106b2ac3205bf$var$isList(parent) && (!parent.previousSibling || $c9a106b2ac3205bf$var$isList(parent.previousSibling));
    }
    return $c9a106b2ac3205bf$var$isList(previousSibling);
}
/**
* True for empty inline elements Word emits as residue between paragraphs (`<span>`, `<a>`, `<o:p>`).
* Used by `isListContinuation` to look past these when checking whether the prior block is a list —
* they're layout artefacts, not real content.
*/ function $c9a106b2ac3205bf$var$isStrayInlineMarker(node) {
    return node.is("element") && node.childCount === 0 && /^(?:span|a|o:p)$/.test(node.name);
}
function $c9a106b2ac3205bf$var$isList(element) {
    return element.is("element", "ol") || element.is("element", "ul");
}
/**
* Extracts list item style from the provided CSS.
*
* List item style is extracted from the CSS stylesheet. Each list with its specific style attribute
* value (`mso-list:l1 level1 lfo1`) has its dedicated properties in a CSS stylesheet defined with a selector like:
*
* ```css
* @list l1:level1 { ... }
* ```
*
* It contains `mso-level-number-format` property which defines list numbering/bullet style. If this property
* is not defined it means default `decimal` numbering.
*
* Here CSS string representation is used as `mso-level-number-format` property is an invalid CSS property
* and will be removed during CSS parsing.
*
* @param listLikeItem List-like item for which list style will be searched for. Usually
* a result of `findAllItemLikeElements()` function.
* @param stylesString CSS stylesheet.
* @returns An object with properties:
*
* * type - List type, could be `ul` or `ol`.
* * startIndex - List start index, valid only for ordered lists.
* * style - List style, for example: `decimal`, `lower-roman`, etc. It is extracted
*     directly from Word stylesheet and adjusted to represent proper values for the CSS `list-style-type` property.
*     If it cannot be adjusted, the `null` value is returned.
*/ function $c9a106b2ac3205bf$var$detectListStyle(listLikeItem, stylesString) {
    const listStyleRegexp = new RegExp(`@list l${listLikeItem.id}:level${listLikeItem.indent}\\s*({[^}]*)`, "gi");
    const listStyleTypeRegex = /mso-level-number-format:([^;]{0,100});/gi;
    const listStartIndexRegex = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi;
    const legalStyleListRegex = new RegExp(`@list\\s+l${listLikeItem.id}:level\\d\\s*{[^{]*mso-level-text:"%\\d\\\\.`, "gi");
    const multiLevelNumberFormatTypeRegex = new RegExp(`@list l${listLikeItem.id}:level\\d\\s*{[^{]*mso-level-number-format:`, "gi");
    const legalStyleListMatch = legalStyleListRegex.exec(stylesString);
    const multiLevelNumberFormatMatch = multiLevelNumberFormatTypeRegex.exec(stylesString);
    const islegalStyleList = legalStyleListMatch && !multiLevelNumberFormatMatch;
    const listStyleMatch = listStyleRegexp.exec(stylesString);
    let listStyleType = "decimal";
    let type = "ol";
    let startIndex = null;
    if (listStyleMatch && listStyleMatch[1]) {
        const listStyleTypeMatch = listStyleTypeRegex.exec(listStyleMatch[1]);
        if (listStyleTypeMatch && listStyleTypeMatch[1]) {
            listStyleType = listStyleTypeMatch[1].trim();
            type = listStyleType !== "bullet" && listStyleType !== "image" ? "ol" : "ul";
        }
        if (listStyleType === "bullet") {
            const bulletedStyle = $c9a106b2ac3205bf$var$findBulletedListStyle(listLikeItem.element);
            if (bulletedStyle) listStyleType = bulletedStyle;
        } else {
            const listStartIndexMatch = listStartIndexRegex.exec(listStyleMatch[1]);
            if (listStartIndexMatch && listStartIndexMatch[1]) startIndex = parseInt(listStartIndexMatch[1]);
        }
        if (islegalStyleList) type = "ol";
    }
    return {
        type: type,
        startIndex: startIndex,
        style: $c9a106b2ac3205bf$var$mapListStyleDefinition(listStyleType),
        isLegalStyleList: islegalStyleList
    };
}
/**
* Tries to extract the `list-style-type` value based on the marker element for bulleted list.
*/ function $c9a106b2ac3205bf$var$findBulletedListStyle(element) {
    if (element.name == "li" && element.parent.name == "ul" && element.parent.hasAttribute("type")) return element.parent.getAttribute("type");
    const listMarkerElement = $c9a106b2ac3205bf$var$findListMarkerNode(element);
    if (!listMarkerElement) return null;
    const listMarker = listMarkerElement._data;
    if (listMarker === "o") return "circle";
    else if (listMarker === "\xb7") return "disc";
    else if (listMarker === "\xa7") return "square";
    return null;
}
/**
* Tries to find a text node that represents the marker element (list-style-type).
*/ function $c9a106b2ac3205bf$var$findListMarkerNode(element) {
    if (element.getChild(0).is("$text")) return null;
    for (const childNode of element.getChildren()){
        if (!childNode.is("element", "span")) continue;
        const textNodeOrElement = childNode.getChild(0);
        if (!textNodeOrElement) continue;
        if (textNodeOrElement.is("$text")) return textNodeOrElement;
        return textNodeOrElement.getChild(0);
    }
    /* v8 ignore next -- @preserve */ return null;
}
/**
* Parses the `list-style-type` value extracted directly from the Word CSS stylesheet and returns proper CSS definition.
*/ function $c9a106b2ac3205bf$var$mapListStyleDefinition(value) {
    if (value.startsWith("arabic-leading-zero")) return "decimal-leading-zero";
    switch(value){
        case "alpha-upper":
            return "upper-alpha";
        case "alpha-lower":
            return "lower-alpha";
        case "roman-upper":
            return "upper-roman";
        case "roman-lower":
            return "lower-roman";
        case "circle":
        case "disc":
        case "square":
            return value;
        default:
            return null;
    }
}
/**
* Creates a new list OL/UL element.
*/ function $c9a106b2ac3205bf$var$createNewEmptyList(listStyle, writer, hasMultiLevelListPlugin) {
    const list = writer.createElement(listStyle.type);
    $c9a106b2ac3205bf$var$applyListStyleToElement(list, listStyle, writer, hasMultiLevelListPlugin);
    return list;
}
/**
* Applies `list-style-type`, `start`, and the `legal-list` class to a list element based on the detected
* list style. Used both when creating a fresh list and when a real item claims a previously-intermediate
* wrapper (which was created without any of these).
*/ function $c9a106b2ac3205bf$var$applyListStyleToElement(list, listStyle, writer, hasMultiLevelListPlugin) {
    if (listStyle.style) writer.setStyle("list-style-type", listStyle.style, list);
    if (listStyle.startIndex && listStyle.startIndex > 1) writer.setAttribute("start", listStyle.startIndex, list);
    if (listStyle.isLegalStyleList && hasMultiLevelListPlugin) writer.addClass("legal-list", list);
}
/**
* Extracts list item information from Word specific list-like element style:
*
* ```
* `style="mso-list:l1 level1 lfo1"`
* ```
*
* where:
*
* ```
* * `l1` is a list id (however it does not mean this is a continuous list - see https://github.com/ckeditor/ckeditor5/issues/43),
* * `level1` is a list item indentation level,
* * `lfo1` is a list insertion order in a document.
* ```
*
* @param element Element from which style data is extracted.
*/ function $c9a106b2ac3205bf$var$getListItemData(element) {
    const listStyle = element.getStyle("mso-list");
    if (listStyle === void 0) return {};
    const idMatch = listStyle.match(/(^|\s{1,100})l(\d+)/i);
    const orderMatch = listStyle.match(/\s{0,100}lfo(\d+)/i);
    const indentMatch = listStyle.match(/\s{0,100}level(\d+)/i);
    if (idMatch && orderMatch && indentMatch) return {
        id: idMatch[2],
        order: orderMatch[1],
        indent: parseInt(indentMatch[1])
    };
    return {
        indent: 1
    };
}
/**
* Removes span with a numbering/bullet from a given element.
*/ function $c9a106b2ac3205bf$var$removeBulletElement(element, writer) {
    const bulletMatcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: "span",
        styles: {
            "mso-list": "Ignore"
        }
    });
    const range = writer.createRangeIn(element);
    for (const value of range)if (value.type === "elementStart" && bulletMatcher.match(value.item)) writer.remove(value.item);
}
/**
* Returns element left margin normalized to 'px' if possible.
*/ function $c9a106b2ac3205bf$var$getMarginLeftNormalized(element) {
    const value = element.getStyle("margin-left");
    if (value === void 0 || value.endsWith("px")) return value;
    return $c9a106b2ac3205bf$export$83f51b87ae43affe(value);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/image
*/ /**
* Replaces source attribute of all `<img>` elements representing regular
* images (not the Word shapes) with inlined base64 image representation extracted from RTF or Blob data.
*
* @param documentFragment Document fragment on which transform images.
* @param rtfData The RTF data from which images representation will be used.
* @internal
*/ function $c9a106b2ac3205bf$export$30e1fc38319cbe59(documentFragment, rtfData) {
    if (!documentFragment.childCount) return;
    const upcastWriter = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(documentFragment.document);
    const shapesIds = $c9a106b2ac3205bf$var$findAllShapesIds(documentFragment, upcastWriter);
    $c9a106b2ac3205bf$var$removeAllImgElementsRepresentingShapes(shapesIds, documentFragment, upcastWriter);
    $c9a106b2ac3205bf$var$insertMissingImgs(shapesIds, documentFragment, upcastWriter);
    $c9a106b2ac3205bf$var$removeAllShapeElements(documentFragment, upcastWriter);
    const images = $c9a106b2ac3205bf$var$findAllImageElementsWithLocalSource(documentFragment, upcastWriter);
    if (images.length) $c9a106b2ac3205bf$var$replaceImagesFileSourceWithInlineRepresentation(images, $c9a106b2ac3205bf$var$extractImageDataFromRtf(rtfData), upcastWriter);
}
/**
* Converts given HEX string to base64 representation.
*
* @internal
* @param hexString The HEX string to be converted.
* @returns Base64 representation of a given HEX string.
*/ function $c9a106b2ac3205bf$export$481d3f1604dc1e71(hexString) {
    return btoa(hexString.match(/\w{2}/g).map((char)=>{
        return String.fromCharCode(parseInt(char, 16));
    }).join(""));
}
/**
* Finds all shapes (`<v:*>...</v:*>`) ids. Shapes can represent images (canvas)
* or Word shapes (which does not have RTF or Blob representation).
*
* @param documentFragment Document fragment from which to extract shape ids.
* @returns Array of shape ids.
*/ function $c9a106b2ac3205bf$var$findAllShapesIds(documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const shapeElementsMatcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: /v:(.+)/
    });
    const shapesIds = [];
    for (const value of range){
        if (value.type != "elementStart") continue;
        const el = value.item;
        const previousSibling = el.previousSibling;
        const prevSiblingName = previousSibling && previousSibling.is("element") ? previousSibling.name : null;
        const exceptionIds = [
            "Chart"
        ];
        const isElementAShape = shapeElementsMatcher.match(el);
        const hasElementGfxdataAttribute = el.getAttribute("o:gfxdata");
        const isPreviousSiblingAShapeType = prevSiblingName === "v:shapetype";
        const isElementIdInExceptionsArray = hasElementGfxdataAttribute && exceptionIds.some((item)=>el.getAttribute("id").includes(item));
        if (isElementAShape && hasElementGfxdataAttribute && !isPreviousSiblingAShapeType && !isElementIdInExceptionsArray) shapesIds.push(value.item.getAttribute("id"));
    }
    return shapesIds;
}
/**
* Removes all `<img>` elements which represents Word shapes and not regular images.
*
* @param shapesIds Shape ids which will be checked against `<img>` elements.
* @param documentFragment Document fragment from which to remove `<img>` elements.
*/ function $c9a106b2ac3205bf$var$removeAllImgElementsRepresentingShapes(shapesIds, documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const imageElementsMatcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: "img"
    });
    const imgs = [];
    for (const value of range)if (value.item.is("element") && imageElementsMatcher.match(value.item)) {
        const el = value.item;
        const shapes = el.getAttribute("v:shapes") ? el.getAttribute("v:shapes").split(" ") : [];
        if (shapes.length && shapes.every((shape)=>shapesIds.indexOf(shape) > -1)) imgs.push(el);
        else if (!el.getAttribute("src")) imgs.push(el);
    }
    for (const img of imgs)writer.remove(img);
}
/**
* Removes all shape elements (`<v:*>...</v:*>`) so they do not pollute the output structure.
*
* @param documentFragment Document fragment from which to remove shape elements.
*/ function $c9a106b2ac3205bf$var$removeAllShapeElements(documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const shapeElementsMatcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: /v:(.+)/
    });
    const shapes = [];
    for (const value of range)if (value.type == "elementStart" && shapeElementsMatcher.match(value.item)) shapes.push(value.item);
    for (const shape of shapes)writer.remove(shape);
}
/**
* Inserts `img` tags if there is none after a shape.
*/ function $c9a106b2ac3205bf$var$insertMissingImgs(shapeIds, documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const shapes = [];
    for (const value of range)if (value.type == "elementStart" && value.item.is("element", "v:shape")) {
        const id = value.item.getAttribute("id");
        if (shapeIds.includes(id)) continue;
        if (!containsMatchingImg(value.item.parent.getChildren(), id)) shapes.push(value.item);
    }
    for (const shape of shapes){
        const attrs = {
            src: findSrc(shape)
        };
        if (shape.hasAttribute("alt")) attrs.alt = shape.getAttribute("alt");
        const img = writer.createElement("img", attrs);
        writer.insertChild(shape.index + 1, img, shape.parent);
    }
    function containsMatchingImg(nodes, id) {
        for (const node of nodes)/* v8 ignore else -- @preserve */ if (node.is("element")) {
            if (node.name == "img" && node.getAttribute("v:shapes") == id) return true;
            if (containsMatchingImg(node.getChildren(), id)) return true;
        }
        return false;
    }
    function findSrc(shape) {
        for (const child of shape.getChildren())/* v8 ignore else -- @preserve */ if (child.is("element") && child.getAttribute("src")) return child.getAttribute("src");
    }
}
/**
* Finds all `<img>` elements in a given document fragment which have source pointing to local `file://` resource.
* This function also tracks the index position of each image in the document, which is essential for
* precise matching with hexadecimal representations in RTF data.
*
* @param documentFragment Document fragment in which to look for `<img>` elements.
* @returns Array of found images along with their position index in the document.
*/ function $c9a106b2ac3205bf$var$findAllImageElementsWithLocalSource(documentFragment, writer) {
    const range = writer.createRangeIn(documentFragment);
    const imageElementsMatcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: "img"
    });
    const imgs = [];
    let currentImageIndex = 0;
    for (const value of range)if (value.item.is("element") && imageElementsMatcher.match(value.item)) {
        if (value.item.getAttribute("src").startsWith("file://")) imgs.push({
            element: value.item,
            imageIndex: currentImageIndex
        });
        currentImageIndex++;
    }
    return imgs;
}
/**
* Extracts all images HEX representations from a given RTF data.
*
* @param rtfData The RTF data from which to extract images HEX representation.
* @returns Array of found HEX representations. Each array item is an object containing:
*
* * hex Image representation in HEX format.
* * type Type of image, `image/png` or `image/jpeg`.
*/ function $c9a106b2ac3205bf$var$extractImageDataFromRtf(rtfData) {
    if (!rtfData) return [];
    const regexPictureHeader = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/;
    const regexPicture = new RegExp("(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}", "g");
    const images = rtfData.match(regexPicture);
    const result = [];
    if (images) for (const image of images){
        let imageType = false;
        if (image.includes("\\pngblip")) imageType = "image/png";
        else if (image.includes("\\jpegblip")) imageType = "image/jpeg";
        if (imageType) result.push({
            hex: image.replace(regexPictureHeader, "").replace(/[^\da-fA-F]/g, ""),
            type: imageType
        });
    }
    return result;
}
/**
* Replaces `src` attribute value of all given images with the corresponding base64 image representation.
* Uses the image index to precisely match with the correct hexadecimal representation from RTF data.
*
* @param imageElements Array of image elements along with their indices which will have their sources replaced.
* @param imagesHexSources Array of images hex sources (usually the result of `extractImageDataFromRtf()` function).
* Contains hexadecimal representations of ALL images in the document, not just those with `file://` URLs.
* In XML documents, the same image might be defined both as base64 in HTML and as hexadecimal in RTF data.
*/ function $c9a106b2ac3205bf$var$replaceImagesFileSourceWithInlineRepresentation(imageElements, imagesHexSources, writer) {
    for(let i = 0; i < imageElements.length; i++){
        const { element: element, imageIndex: imageIndex } = imageElements[i];
        const rtfHexSource = imagesHexSources[imageIndex];
        if (rtfHexSource) {
            const newSrc = `data:${rtfHexSource.type};base64,${$c9a106b2ac3205bf$export$481d3f1604dc1e71(rtfHexSource.hex)}`;
            writer.setAttribute("src", newSrc, element);
        }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/removemsattributes
*/ /**
* Cleanup MS attributes like styles, attributes and elements.
*
* @param documentFragment element `data.content` obtained from clipboard.
* @internal
*/ function $c9a106b2ac3205bf$export$dd64fc053cc87433(documentFragment) {
    const elementsToUnwrap = [];
    const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(documentFragment.document);
    for (const { item: item } of writer.createRangeIn(documentFragment)){
        if (!item.is("element")) continue;
        for (const className of item.getClassNames())if (/\bmso/gi.exec(className)) writer.removeClass(className, item);
        for (const styleName of item.getStyleNames())if (/\bmso/gi.exec(styleName)) writer.removeStyle(styleName, item);
        if (item.is("element", "w:sdt") || item.is("element", "w:sdtpr") && item.isEmpty || item.is("element", "o:p") && item.isEmpty) elementsToUnwrap.push(item);
    }
    for (const item of elementsToUnwrap){
        const itemParent = item.parent;
        const childIndex = itemParent.getChildIndex(item);
        writer.insertChild(childIndex, item.getChildren(), itemParent);
        writer.remove(item);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Applies border none for table and cells without a border specified.
* Normalizes style length units to px.
* Handles left block table alignment.
*
* @internal
*/ function $c9a106b2ac3205bf$export$7b36ea229edc5700(documentFragment, writer, hasTablePropertiesPlugin = false) {
    for (const item of writer.createRangeIn(documentFragment).getItems()){
        if (!item.is("element", "table") && !item.is("element", "td") && !item.is("element", "th")) continue;
        if (hasTablePropertiesPlugin && item.is("element", "table")) {
            const directParent = item.parent?.is("element", "div") ? item.parent : null;
            const grandParent = item.parent?.parent?.is("element", "div") ? item.parent.parent : null;
            const divParent = directParent ?? grandParent;
            if (divParent && divParent.getAttribute("align") === "center" && !item.getAttribute("align")) {
                writer.setStyle("margin-left", "auto", item);
                writer.setStyle("margin-right", "auto", item);
            } else if (divParent && divParent.getAttribute("align") === "right" && !item.getAttribute("align")) {
                writer.setStyle("margin-left", "auto", item);
                writer.setStyle("margin-right", "0", item);
            } else if (!divParent && !item.getAttribute("align")) {
                writer.setStyle("margin-left", "0", item);
                writer.setStyle("margin-right", "auto", item);
            }
        }
        const sides = [
            "left",
            "top",
            "right",
            "bottom"
        ];
        if (sides.every((side)=>!item.hasStyle(`border-${side}-style`))) writer.setStyle("border-style", "none", item);
        else for (const side of sides)if (!item.hasStyle(`border-${side}-style`)) writer.setStyle(`border-${side}-style`, "none", item);
        const props = [
            "width",
            "height",
            ...sides.map((side)=>`border-${side}-width`),
            ...sides.map((side)=>`padding-${side}`)
        ];
        for (const prop of props)if (item.hasStyle(prop)) writer.setStyle(prop, $c9a106b2ac3205bf$export$83f51b87ae43affe(item.getStyle(prop)), item);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Removes the `width:0px` style from table pasted from Google Sheets and `width="0"` attribute from Word tables.
*
* @param documentFragment element `data.content` obtained from clipboard
* @internal
*/ function $c9a106b2ac3205bf$export$d2c36232415711f8(documentFragment, writer) {
    for (const child of writer.createRangeIn(documentFragment).getItems())if (child.is("element", "table")) {
        if (child.getStyle("width") === "0px") writer.removeStyle("width", child);
        if (child.getAttribute("width") === "0") writer.removeAttribute("width", child);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Replaces MS Word specific footnotes references and definitions with proper elements.
*
* Things to know about MS Word footnotes:
*
* * Footnote references in Word are marked with `mso-footnote-id` style.
* * Word does not support nested footnotes, so references within definitions are ignored.
* * Word appends extra spaces after footnote references within definitions, which are trimmed.
* * Footnote definitions list is marked with `mso-element: footnote-list` style it contain `mso-element: footnote` elements.
* * Footnote definition might contain tables, lists and other elements, not only text. They are placed directly within `li` element,
* without any wrapper (in opposition to text content of the definition, which is placed within `MsoFootnoteText` element).
*
* Example pseudo document showing MS Word footnote structure:
*
* ```html
* <p>Text with footnote<a style='mso-footnote-id:ftn1'>[1]</a> reference.</p>
*
* <div style='mso-element:footnote-list'>
* 	<div style='mso-element:footnote' id=ftn1>
* 		<p class=MsoFootnoteText><a style='mso-footnote-id:ftn1'>[1]</a> Footnote content</p>
* 		<table class="MsoTableGrid">...</table>
* 	</div>
* </div>
* ```
*
* Will be transformed into:
*
* ```html
* <p>Text with footnote<sup class="footnote"><a id="ref-footnote-ftn1" href="#footnote-ftn1">1</a></sup> reference.</p>
*
* <div class="footnotes">
* 	<hr class="footnotes-divider">
* 	<ol class="footnotes-list">
* 		<li class="footnote-definition" id="footnote-ftn1">
* 			<a href="#ref-footnote-ftn1" class="footnote-backlink">^</a>
* 			<div class="footnote-content">
* 				<p>Footnote content</p>
* 				<table>...</table>
* 			</div>
* 		</li>
* 	</ol>
* </div>
* ```
*
* @param documentFragment `data.content` obtained from clipboard.
* @param writer The view writer instance.
* @internal
*/ function $c9a106b2ac3205bf$var$replaceMSFootnotes(documentFragment, writer) {
    const msFootnotesRefs = /* @__PURE__ */ new Map();
    const msFootnotesDefs = /* @__PURE__ */ new Map();
    let msFootnotesDefinitionsList = null;
    for (const { item: item } of writer.createRangeIn(documentFragment)){
        if (!item.is("element")) continue;
        if (item.getStyle("mso-element") === "footnote-list") {
            msFootnotesDefinitionsList = item;
            continue;
        }
        if (item.hasStyle("mso-footnote-id")) {
            const msFootnoteDef = item.findAncestor("element", (el)=>el.getStyle("mso-element") === "footnote");
            if (msFootnoteDef) {
                const msFootnoteDefId = msFootnoteDef.getAttribute("id");
                msFootnotesDefs.set(msFootnoteDefId, msFootnoteDef);
            } else {
                const msFootnoteRefId = item.getStyle("mso-footnote-id");
                msFootnotesRefs.set(msFootnoteRefId, item);
            }
            continue;
        }
    }
    if (!msFootnotesRefs.size || !msFootnotesDefinitionsList) return;
    const footnotesList = $c9a106b2ac3205bf$var$createFootnotesListContainerElement(writer);
    writer.replace(msFootnotesDefinitionsList, footnotesList.wrapper);
    for (const [footnoteId, msFootnoteRef] of msFootnotesRefs){
        const msFootnoteDef = msFootnotesDefs.get(footnoteId);
        if (!msFootnoteDef) continue;
        writer.replace(msFootnoteRef, $c9a106b2ac3205bf$var$createFootnoteRefViewElement(writer, footnoteId));
        const defElements = $c9a106b2ac3205bf$var$createFootnoteDefViewElement(writer, footnoteId);
        $c9a106b2ac3205bf$var$removeMSReferences(writer, msFootnoteDef);
        for (const child of msFootnoteDef.getChildren()){
            let clonedChild = child;
            /* v8 ignore else -- @preserve */ if (child.is("element")) clonedChild = writer.clone(child, true);
            writer.appendChild(clonedChild, defElements.content);
        }
        writer.appendChild(defElements.listItem, footnotesList.list);
    }
}
/**
* Removes all MS Office specific references from the given element.
*
* It also removes leading space from text nodes following the references, as MS Word adds
* them to separate the reference from the rest of the text.
*
* @param writer The view writer.
* @param element The element to trim.
* @returns The trimmed element.
*/ function $c9a106b2ac3205bf$var$removeMSReferences(writer, element) {
    const elementsToRemove = [];
    const textNodesToTrim = [];
    for (const { item: item } of writer.createRangeIn(element))if (item.is("element") && item.getStyle("mso-footnote-id")) {
        elementsToRemove.unshift(item);
        const { nextSibling: nextSibling } = item;
        if (nextSibling?.is("$text") && nextSibling.data.startsWith(" ")) textNodesToTrim.unshift(nextSibling);
    }
    for (const element of elementsToRemove)writer.remove(element);
    for (const textNode of textNodesToTrim){
        const trimmedData = textNode.data.substring(1);
        if (trimmedData.length > 0) {
            const parent = textNode.parent;
            const index = parent.getChildIndex(textNode);
            const newTextNode = writer.createText(trimmedData);
            writer.remove(textNode);
            writer.insertChild(index, newTextNode, parent);
        } else writer.remove(textNode);
    }
    return element;
}
/**
* Creates a footnotes list container element.
*
* @param writer The view writer instance.
* @returns The footnotes list container element and list itself.
*/ function $c9a106b2ac3205bf$var$createFootnotesListContainerElement(writer) {
    const divider = writer.createElement("hr", {
        class: "footnotes-divider"
    });
    const list = writer.createElement("ol", {
        class: "footnotes-list"
    });
    return {
        list: list,
        wrapper: writer.createElement("div", {
            class: "footnotes"
        }, [
            divider,
            list
        ])
    };
}
/**
* Creates a footnote reference view element.
*
* @param writer The view writer instance.
* @param footnoteId The footnote ID.
* @returns The footnote reference view element.
*/ function $c9a106b2ac3205bf$var$createFootnoteRefViewElement(writer, footnoteId) {
    const sup = writer.createElement("sup", {
        class: "footnote"
    });
    const link = writer.createElement("a", {
        id: `ref-${footnoteId}`,
        href: `#${footnoteId}`
    });
    writer.appendChild(link, sup);
    return sup;
}
/**
* Creates a footnote definition view element with a backlink and a content container.
*
* @param writer The view writer instance.
* @param footnoteId The footnote ID.
* @returns An object containing the list item element, backlink and content container.
*/ function $c9a106b2ac3205bf$var$createFootnoteDefViewElement(writer, footnoteId) {
    const listItem = writer.createElement("li", {
        id: footnoteId,
        class: "footnote-definition"
    });
    const backLink = writer.createElement("a", {
        href: `#ref-${footnoteId}`,
        class: "footnote-backlink"
    });
    const content = writer.createElement("div", {
        class: "footnote-content"
    });
    writer.appendChild(writer.createText("^"), backLink);
    writer.appendChild(backLink, listItem);
    writer.appendChild(content, listItem);
    return {
        listItem: listItem,
        content: content
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $c9a106b2ac3205bf$var$msWordMatch1 = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i;
const $c9a106b2ac3205bf$var$msWordMatch2 = /xmlns:o="urn:schemas-microsoft-com/i;
const $c9a106b2ac3205bf$var$msExcelMatch = /<meta\s*name="?generator"?\s*content="?microsoft\s*excel\s*\d+"?\/?>/i;
/**
* Normalizer for the content pasted from Microsoft Word.
*/ var $c9a106b2ac3205bf$export$1cd0637fe3df2a0e = class {
    document;
    hasMultiLevelListPlugin;
    hasTablePropertiesPlugin;
    enableSkipLevelLists;
    /**
	* Creates a new `PasteFromOfficeMSWordNormalizer` instance.
	*
	* @param document View document.
	*/ constructor(document, hasMultiLevelListPlugin = false, hasTablePropertiesPlugin = false, enableSkipLevelLists = false){
        this.document = document;
        this.hasMultiLevelListPlugin = hasMultiLevelListPlugin;
        this.hasTablePropertiesPlugin = hasTablePropertiesPlugin;
        this.enableSkipLevelLists = enableSkipLevelLists;
    }
    /**
	* @inheritDoc
	*/ isActive(htmlString) {
        return $c9a106b2ac3205bf$var$msWordMatch1.test(htmlString) || $c9a106b2ac3205bf$var$msWordMatch2.test(htmlString) || $c9a106b2ac3205bf$var$msExcelMatch.test(htmlString);
    }
    /**
	* @inheritDoc
	*/ execute(data) {
        const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(this.document);
        const stylesString = data.extraContent.stylesString;
        $c9a106b2ac3205bf$export$4bd3ae42e1922040(data.content, writer);
        $c9a106b2ac3205bf$export$9adba5c627109c96(data.content, stylesString, this.hasMultiLevelListPlugin, this.enableSkipLevelLists);
        $c9a106b2ac3205bf$export$30e1fc38319cbe59(data.content, data.dataTransfer.getData("text/rtf"));
        $c9a106b2ac3205bf$export$7b36ea229edc5700(data.content, writer, this.hasTablePropertiesPlugin);
        $c9a106b2ac3205bf$export$d2c36232415711f8(data.content, writer);
        $c9a106b2ac3205bf$var$replaceMSFootnotes(data.content, writer);
        $c9a106b2ac3205bf$export$dd64fc053cc87433(data.content);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Removes the `<b>` tag wrapper added by Google Docs to a copied content.
*
* @param documentFragment element `data.content` obtained from clipboard
* @internal
*/ function $c9a106b2ac3205bf$export$7618b3e80e487b9b(documentFragment, writer) {
    for (const child of documentFragment.getChildren())if (child.is("element", "b") && child.getStyle("font-weight") === "normal") {
        const childIndex = documentFragment.getChildIndex(child);
        writer.remove(child);
        writer.insertChild(childIndex, child.getChildren(), documentFragment);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/br
*/ /**
* Transforms `<br>` elements that are siblings to some block element into a paragraphs.
*
* @param documentFragment The view structure to be transformed.
* @internal
*/ function $c9a106b2ac3205bf$export$b1c60bb9f9320d4b(documentFragment, writer) {
    const viewDocument = new (0, $b9b9f2bdf9c6137f$export$c26285651732fb36)(writer.document.stylesProcessor);
    const domConverter = new (0, $b9b9f2bdf9c6137f$export$f7719161406171fa)(viewDocument, {
        renderingMode: "data"
    });
    const blockElements = domConverter.blockElements;
    const inlineObjectElements = domConverter.inlineObjectElements;
    const elementsToReplace = [];
    for (const value of writer.createRangeIn(documentFragment)){
        const element = value.item;
        if (element.is("element", "br")) {
            const nextSibling = $c9a106b2ac3205bf$var$findSibling(element, "forward", writer, {
                blockElements: blockElements,
                inlineObjectElements: inlineObjectElements
            });
            const previousSibling = $c9a106b2ac3205bf$var$findSibling(element, "backward", writer, {
                blockElements: blockElements,
                inlineObjectElements: inlineObjectElements
            });
            const nextSiblingIsBlock = $c9a106b2ac3205bf$var$isBlockViewElement(nextSibling, blockElements);
            if ($c9a106b2ac3205bf$var$isBlockViewElement(previousSibling, blockElements) || nextSiblingIsBlock) elementsToReplace.push(element);
        }
    }
    for (const element of elementsToReplace)if (element.hasClass("Apple-interchange-newline")) writer.remove(element);
    else writer.replace(element, writer.createElement("p"));
}
/**
* Returns sibling node, threats inline elements as transparent (but should stop on an inline objects).
*/ function $c9a106b2ac3205bf$var$findSibling(viewElement, direction, writer, { blockElements: blockElements, inlineObjectElements: inlineObjectElements }) {
    let position = writer.createPositionAt(viewElement, direction == "forward" ? "after" : "before");
    position = position.getLastMatchingPosition(({ item: item })=>item.is("element") && !blockElements.includes(item.name) && !inlineObjectElements.includes(item.name), {
        direction: direction
    });
    return direction == "forward" ? position.nodeAfter : position.nodeBefore;
}
/**
* Returns true for view elements that are listed as block view elements.
*/ function $c9a106b2ac3205bf$var$isBlockViewElement(node, blockElements) {
    return !!node && node.is("element") && blockElements.includes(node.name);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Replaces tab characters with spaces in text nodes that are inside elements styled with `white-space: pre-wrap`.
*
* This is a workaround for incorrect detection of pre-like formatting in the DOM converter for pasted Google Docs documents.
* When an element uses `white-space: pre-wrap`, the editor reduces tab characters to a single space, causing
* inconsistent spacing in pasted content. This function replaces tabs with spaces to ensure visual consistency.
* This is intended as a temporary solution.
*
* See: https://github.com/ckeditor/ckeditor5/issues/18995
*
* @param documentFragment The `data.content` element obtained from the clipboard.
* @param writer The upcast writer used to manipulate the view structure.
* @param tabWidth The number of spaces to replace each tab with. Defaults to 8.
* @internal
*/ function $c9a106b2ac3205bf$var$replaceTabsWithinPreWithSpaces(documentFragment, writer, tabWidth) {
    const textNodesToReplace = /* @__PURE__ */ new Set();
    for (const child of writer.createRangeIn(documentFragment).getItems()){
        if (!child.is("view:$textProxy") || !child.data.includes("	")) continue;
        if ($c9a106b2ac3205bf$var$hasPreWrapParent(child.parent)) textNodesToReplace.add(child.textNode);
    }
    for (const textNode of textNodesToReplace)$c9a106b2ac3205bf$var$replaceTabsInTextNode(textNode, writer, tabWidth);
}
/**
* Checks if element or any of its parents has `white-space: pre-wrap` style.
*/ function $c9a106b2ac3205bf$var$hasPreWrapParent(element) {
    let parent = element;
    while(parent){
        if (parent.is("element")) {
            if (parent.getStyle?.("white-space") === "pre-wrap") return true;
        }
        parent = parent.parent;
    }
    return false;
}
/**
* Replaces all tabs with spaces in the given text node.
*/ function $c9a106b2ac3205bf$var$replaceTabsInTextNode(textNode, writer, tabWidth) {
    const { parent: parent, data: data } = textNode;
    const replacedData = data.replaceAll("	", " ".repeat(tabWidth));
    const index = parent.getChildIndex(textNode);
    writer.remove(textNode);
    writer.insertChild(index, writer.createText(replacedData), parent);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/normalizers/googledocsnormalizer
*/ const $c9a106b2ac3205bf$var$googleDocsMatch = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
/**
* Normalizer for the content pasted from Google Docs.
*
* @internal
*/ var $c9a106b2ac3205bf$export$fecf035d8e30fc05 = class {
    document;
    /**
	* Creates a new `GoogleDocsNormalizer` instance.
	*
	* @param document View document.
	*/ constructor(document){
        this.document = document;
    }
    /**
	* @inheritDoc
	*/ isActive(htmlString) {
        return $c9a106b2ac3205bf$var$googleDocsMatch.test(htmlString);
    }
    /**
	* @inheritDoc
	*/ execute(data) {
        const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(this.document);
        $c9a106b2ac3205bf$export$7618b3e80e487b9b(data.content, writer);
        $c9a106b2ac3205bf$export$5e5c708e22065a7(data.content, writer);
        $c9a106b2ac3205bf$export$b1c60bb9f9320d4b(data.content, writer);
        $c9a106b2ac3205bf$var$replaceTabsWithinPreWithSpaces(data.content, writer, 8);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Removes the `xmlns` attribute from table pasted from Google Sheets.
*
* @param documentFragment element `data.content` obtained from clipboard
* @internal
*/ function $c9a106b2ac3205bf$export$a65291822278b3e9(documentFragment, writer) {
    for (const child of documentFragment.getChildren())if (child.is("element", "table") && child.hasAttribute("xmlns")) writer.removeAttribute("xmlns", child);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Removes the `<google-sheets-html-origin>` tag wrapper added by Google Sheets to a copied content.
*
* @param documentFragment element `data.content` obtained from clipboard
* @internal
*/ function $c9a106b2ac3205bf$export$2ced5528d32f3d7(documentFragment, writer) {
    for (const child of documentFragment.getChildren())/* v8 ignore else -- @preserve */ if (child.is("element", "google-sheets-html-origin")) {
        const childIndex = documentFragment.getChildIndex(child);
        writer.remove(child);
        writer.insertChild(childIndex, child.getChildren(), documentFragment);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Removes `<style>` block added by Google Sheets to a copied content.
*
* @param documentFragment element `data.content` obtained from clipboard
* @internal
*/ function $c9a106b2ac3205bf$export$b1e492b61888a091(documentFragment, writer) {
    for (const child of Array.from(documentFragment.getChildren()))if (child.is("element", "style")) writer.remove(child);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/normalizers/googlesheetsnormalizer
*/ const $c9a106b2ac3205bf$var$googleSheetsMatch = /<google-sheets-html-origin/i;
/**
* Normalizer for the content pasted from Google Sheets.
*
* @internal
*/ var $c9a106b2ac3205bf$export$9fd5c9640da6ef98 = class {
    document;
    /**
	* Creates a new `GoogleSheetsNormalizer` instance.
	*
	* @param document View document.
	*/ constructor(document){
        this.document = document;
    }
    /**
	* @inheritDoc
	*/ isActive(htmlString) {
        return $c9a106b2ac3205bf$var$googleSheetsMatch.test(htmlString);
    }
    /**
	* @inheritDoc
	*/ execute(data) {
        const writer = new (0, $b9b9f2bdf9c6137f$export$562b90ad4b8bb065)(this.document);
        $c9a106b2ac3205bf$export$2ced5528d32f3d7(data.content, writer);
        $c9a106b2ac3205bf$export$a65291822278b3e9(data.content, writer);
        $c9a106b2ac3205bf$export$d2c36232415711f8(data.content, writer);
        $c9a106b2ac3205bf$export$b1e492b61888a091(data.content, writer);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/space
*/ /**
* Replaces last space preceding elements closing tag with `&nbsp;`. Such operation prevents spaces from being removed
* during further DOM/View processing (see especially {@link module:engine/view/domconverter~ViewDomConverter#_processDomInlineNodes}).
* This method also takes into account Word specific `<o:p></o:p>` empty tags.
* Additionally multiline sequences of spaces and new lines between tags are removed (see
* https://github.com/ckeditor/ckeditor5-paste-from-office/issues/39
* and https://github.com/ckeditor/ckeditor5-paste-from-office/issues/40).
*
* @param htmlString HTML string in which spacing should be normalized.
* @returns Input HTML with spaces normalized.
* @internal
*/ function $c9a106b2ac3205bf$export$5491e5afc0575fe(htmlString) {
    return $c9a106b2ac3205bf$var$normalizeSafariSpaceSpans($c9a106b2ac3205bf$var$normalizeSafariSpaceSpans(htmlString)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/(<span\s+style=['"]letter-spacing:[^'"]+?['"]>)[\r\n]+(<\/span>)/g, "$1 $2").replace(/ <\//g, "\xA0</").replace(/ <o:p><\/o:p>/g, "\xA0<o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
}
/**
* Normalizes spacing in special Word `spacerun spans` (`<span style='mso-spacerun:yes'>\s+</span>`) by replacing
* all spaces with `&nbsp; ` pairs. This prevents spaces from being removed during further DOM/View processing
* (see especially {@link module:engine/view/domconverter~ViewDomConverter#_processDomInlineNodes}).
*
* @param htmlDocument Native `Document` object in which spacing should be normalized.
* @internal
*/ function $c9a106b2ac3205bf$export$92c05b2f5ff607e1(htmlDocument) {
    htmlDocument.querySelectorAll("span[style*=spacerun]").forEach((el)=>{
        const htmlElement = el;
        const innerTextLength = htmlElement.innerText.length || 0;
        htmlElement.innerText = Array(innerTextLength + 1).join("\xA0 ").substr(0, innerTextLength);
    });
}
/**
* Normalizes specific spacing generated by Safari when content pasted from Word (`<span class="Apple-converted-space"> </span>`)
* by replacing all spaces sequences longer than 1 space with `&nbsp; ` pairs. This prevents spaces from being removed during
* further DOM/View processing (see especially {@link module:engine/view/domconverter~ViewDomConverter#_processDataFromDomText}).
*
* This function is similar to {@link module:clipboard/utils/normalizeclipboarddata normalizeClipboardData util} but uses
* regular spaces / &nbsp; sequence for replacement.
*
* @param htmlString HTML string in which spacing should be normalized
* @returns Input HTML with spaces normalized.
* @internal
*/ function $c9a106b2ac3205bf$var$normalizeSafariSpaceSpans(htmlString) {
    return htmlString.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (fullMatch, spaces)=>{
        return spaces.length === 1 ? " " : Array(spaces.length + 1).join("\xA0 ").substr(0, spaces.length);
    });
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/filters/parse
*/ /**
* Parses the provided HTML extracting contents of `<body>` and `<style>` tags.
*
* @param htmlString HTML string to be parsed.
*/ function $c9a106b2ac3205bf$export$1e6fb54312fe144d(htmlString, stylesProcessor) {
    const domParser = new DOMParser();
    htmlString = htmlString.replace(/<!--\[if gte vml 1]>/g, "");
    htmlString = htmlString.replace(/<o:SmartTagType(?:\s+[^\s>=]+(?:="[^"]*")?)*\s*\/?>/gi, "");
    const normalizedHtml = $c9a106b2ac3205bf$export$5491e5afc0575fe($c9a106b2ac3205bf$var$cleanContentAfterBody(htmlString));
    const htmlDocument = domParser.parseFromString((0, $c7bc2cb7e2db0227$export$defce004797fe3da)(normalizedHtml), "text/html");
    $c9a106b2ac3205bf$export$92c05b2f5ff607e1(htmlDocument);
    $c9a106b2ac3205bf$var$removeInBodyStyleBlocks(htmlDocument);
    const bodyString = htmlDocument.body.innerHTML;
    const bodyView = $c9a106b2ac3205bf$var$documentToView(htmlDocument, stylesProcessor);
    const stylesObject = $c9a106b2ac3205bf$var$extractStyles(htmlDocument);
    return {
        body: bodyView,
        bodyString: bodyString,
        styles: stylesObject.styles,
        stylesString: stylesObject.stylesString
    };
}
/**
* Transforms native `Document` object into {@link module:engine/view/documentfragment~ViewDocumentFragment}. Comments are skipped.
*
* @param htmlDocument Native `Document` object to be transformed.
*/ function $c9a106b2ac3205bf$var$documentToView(htmlDocument, stylesProcessor) {
    const viewDocument = new (0, $b9b9f2bdf9c6137f$export$c26285651732fb36)(stylesProcessor);
    const domConverter = new (0, $b9b9f2bdf9c6137f$export$f7719161406171fa)(viewDocument, {
        renderingMode: "data"
    });
    const fragment = htmlDocument.createDocumentFragment();
    const nodes = htmlDocument.body.childNodes;
    while(nodes.length > 0)fragment.appendChild(nodes[0]);
    return domConverter.domToView(fragment, {
        skipComments: true
    });
}
/**
* Removes all `<style>` elements found inside the `<body>` of the provided `htmlDocument`.
*
* This guards against sources that place (or flatten) a `<style>` block into the body, where its CSS text
* would otherwise be converted to visible text. Styles located in the `<head>` are not affected.
*
* @param htmlDocument Native `Document` object to be cleaned.
*/ function $c9a106b2ac3205bf$var$removeInBodyStyleBlocks(htmlDocument) {
    for (const style of Array.from(htmlDocument.body.querySelectorAll("style")))style.remove();
}
/**
* Extracts both `CSSStyleSheet` and string representation from all `style` elements available in a provided `htmlDocument`.
*
* @param htmlDocument Native `Document` object from which styles will be extracted.
*/ function $c9a106b2ac3205bf$var$extractStyles(htmlDocument) {
    const styles = [];
    const stylesString = [];
    const styleTags = Array.from(htmlDocument.getElementsByTagName("style"));
    for (const style of styleTags)if (style.sheet && style.sheet.cssRules && style.sheet.cssRules.length) {
        styles.push(style.sheet);
        stylesString.push(style.innerHTML);
    }
    return {
        styles: styles,
        stylesString: stylesString.join(" ")
    };
}
/**
* Removes leftover content from between closing </body> and closing </html> tag:
*
* ```html
* <html><body><p>Foo Bar</p></body><span>Fo</span></html> -> <html><body><p>Foo Bar</p></body></html>
* ```
*
* This function is used as specific browsers (Edge) add some random content after `body` tag when pasting from Word.
* @param htmlString The HTML string to be cleaned.
* @returns The HTML string with leftover content removed.
*/ function $c9a106b2ac3205bf$var$cleanContentAfterBody(htmlString) {
    const bodyCloseTag = "</body>";
    const htmlCloseTag = "</html>";
    const bodyCloseIndex = htmlString.indexOf(bodyCloseTag);
    if (bodyCloseIndex < 0) return htmlString;
    const htmlCloseIndex = htmlString.indexOf(htmlCloseTag, bodyCloseIndex + 7);
    return htmlString.substring(0, bodyCloseIndex + 7) + (htmlCloseIndex >= 0 ? htmlString.substring(htmlCloseIndex) : "");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module paste-from-office/pastefromoffice
*/ /**
* The Paste from Office plugin.
*
* This plugin handles content pasted from Office apps and transforms it (if necessary)
* to a valid structure which can then be understood by the editor features.
*
* Transformation is made by a set of predefined {@link module:paste-from-office/normalizer~PasteFromOfficeNormalizer normalizers}.
* This plugin includes following normalizers:
* * {@link module:paste-from-office/normalizers/mswordnormalizer~PasteFromOfficeMSWordNormalizer Microsoft Word normalizer}
* * {@link module:paste-from-office/normalizers/googledocsnormalizer~GoogleDocsNormalizer Google Docs normalizer}
*
* For more information about this feature check the {@glink api/paste-from-office package page}.
*/ var $c9a106b2ac3205bf$export$cb15bc3be08b1f4e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The priority array of registered normalizers.
	*/ _normalizers = [];
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PasteFromOffice";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "PFO";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
        const viewDocument = editor.editing.view.document;
        const hasMultiLevelListPlugin = this.editor.plugins.has("MultiLevelListEditing");
        const hasTablePropertiesPlugin = this.editor.plugins.has("TablePropertiesEditing");
        const enableSkipLevelLists = !!this.editor.config.get("list.enableSkipLevelLists");
        this.registerNormalizer(new $c9a106b2ac3205bf$export$1cd0637fe3df2a0e(viewDocument, hasMultiLevelListPlugin, hasTablePropertiesPlugin, enableSkipLevelLists));
        this.registerNormalizer(new $c9a106b2ac3205bf$export$fecf035d8e30fc05(viewDocument));
        this.registerNormalizer(new $c9a106b2ac3205bf$export$9fd5c9640da6ef98(viewDocument));
        viewDocument.on("clipboardInput", (evt, data)=>{
            if (typeof data.content != "string") return;
            const htmlString = data.dataTransfer.getData("text/html");
            if (this._normalizers.find(({ normalizer: normalizer })=>normalizer.isActive(htmlString))) {
                const parsedData = $c9a106b2ac3205bf$export$1e6fb54312fe144d(data.content, viewDocument.stylesProcessor);
                data.content = parsedData.body;
                data.extraContent = {
                    ...parsedData,
                    isTransformedWithPasteFromOffice: true
                };
            }
        }, {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low + 10
        });
        clipboardPipeline.on("inputTransformation", (evt, data)=>{
            if (!data.extraContent || !data.extraContent.isTransformedWithPasteFromOffice) return;
            const htmlString = data.dataTransfer.getData("text/html");
            const normalizers = this._normalizers.filter(({ normalizer: normalizer })=>normalizer.isActive(htmlString));
            for (const { normalizer: normalizer } of normalizers)normalizer.execute(data);
        }, {
            priority: "high"
        });
    }
    /**
	* Registers a normalizer with the given priority.
	*/ registerNormalizer(normalizer, priority) {
        (0, $c7bc2cb7e2db0227$export$d415007a4e865351)(this._normalizers, {
            normalizer: normalizer,
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).get(priority)
        });
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module remove-format/removeformatui
*/ const $ff6b002ce176248b$var$REMOVE_FORMAT = "removeFormat";
/**
* The remove format UI plugin. It registers the `'removeFormat'` button which can be
* used in the toolbar.
*/ var $ff6b002ce176248b$export$65c2f159aa957c11 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RemoveFormatUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add($ff6b002ce176248b$var$REMOVE_FORMAT, ()=>{
            const view = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            view.set({
                tooltip: true
            });
            return view;
        });
        editor.ui.componentFactory.add(`menuBar:${$ff6b002ce176248b$var$REMOVE_FORMAT}`, ()=>this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)));
    }
    /**
	* Creates a button for remove format command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get($ff6b002ce176248b$var$REMOVE_FORMAT);
        const view = new ButtonClass(editor.locale);
        const t = locale.t;
        view.set({
            label: t("Remove Format"),
            icon: (0, $e8dc502aba5ac3f5$export$548c63ef546ca223)
        });
        view.bind("isEnabled").to(command, "isEnabled");
        this.listenTo(view, "execute", ()=>{
            editor.execute($ff6b002ce176248b$var$REMOVE_FORMAT);
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The remove format command.
*
* It is used by the {@link module:remove-format/removeformat~RemoveFormat remove format feature}
* to clear the formatting in the selection.
*
* ```ts
* editor.execute( 'removeFormat' );
* ```
*/ var $ff6b002ce176248b$export$871e982dde0e3e7a = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* List of all registered custom attribute handlers.
	*/ _customAttributesHandlers = [];
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        this.isEnabled = !!(0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this._getFormattingItems(model.document.selection));
    }
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        model.change((writer)=>{
            for (const item of this._getFormattingItems(model.document.selection))if (item.is("selection")) for (const attributeName of this._getFormattingAttributes(item))writer.removeSelectionAttribute(attributeName);
            else {
                const itemRange = writer.createRangeOn(item);
                for (const attributeName of this._getFormattingAttributes(item))this._removeFormatting(attributeName, item, itemRange, writer);
            }
        });
    }
    /**
	* Registers a custom attribute handler that will be used to determine if an attribute is formatting and how to remove it.
	*
	* @internal
	*/ registerCustomAttribute(isFormatting, removeFormatting) {
        this._customAttributesHandlers.push({
            isFormatting: isFormatting,
            removeFormatting: removeFormatting
        });
    }
    /**
	* Helper method that removes a formatting attribute from an item either using custom callbacks or writer remove attribute.
	*/ _removeFormatting(attributeName, item, itemRange, writer) {
        let customHandled = false;
        const nonSelectionAttributeName = $ff6b002ce176248b$var$toNonSelectionAttribute(attributeName);
        for (const { isFormatting: isFormatting, removeFormatting: removeFormatting } of this._customAttributesHandlers)if (isFormatting(nonSelectionAttributeName, item)) {
            removeFormatting(attributeName, itemRange, writer);
            customHandled = true;
        }
        if (!customHandled) writer.removeAttribute(attributeName, itemRange);
    }
    /**
	* Returns an iterable of items in a selection (including the selection itself) that have formatting model
	* attributes to be removed by the feature.
	*/ *_getFormattingItems(selection) {
        const model = this.editor.model;
        const schema = model.schema;
        const itemHasRemovableFormatting = (item)=>{
            return !!(0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(this._getFormattingAttributes(item));
        };
        for (const curRange of selection.getRanges())for (const item of curRange.getItems()){
            if (schema.isBlock(item) && curRange.end.isTouching(model.createPositionAt(item, 0))) continue;
            if (itemHasRemovableFormatting(item)) yield item;
        }
        for (const block of selection.getSelectedBlocks())if (itemHasRemovableFormatting(block)) yield block;
        if (itemHasRemovableFormatting(selection)) yield selection;
    }
    /**
	* Returns an iterable of formatting attributes of a given model item.
	*
	* **Note:** Formatting items have the `isFormatting` property set to `true`.
	*
	* @returns The names of formatting attributes found in a given item.
	*/ *_getFormattingAttributes(item) {
        const { schema: schema } = this.editor.model;
        for (const [attributeName] of item.getAttributes()){
            const nonSelectionAttributeName = $ff6b002ce176248b$var$toNonSelectionAttribute(attributeName);
            for (const { isFormatting: isFormatting } of this._customAttributesHandlers)if (isFormatting(nonSelectionAttributeName, item)) yield attributeName;
            const attributeProperties = schema.getAttributeProperties(nonSelectionAttributeName);
            if (attributeProperties && attributeProperties.isFormatting) yield attributeName;
        }
    }
};
/**
* Helper function that converts a selection attribute name to a non-selection one. E.g. `selection:bold` to `bold`.
*/ function $ff6b002ce176248b$var$toNonSelectionAttribute(attributeName) {
    return attributeName.replace(/^selection:/, "");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module remove-format/removeformatediting
*/ /**
* The remove format editing plugin.
*
* It registers the {@link module:remove-format/removeformatcommand~RemoveFormatCommand removeFormat} command.
*/ var $ff6b002ce176248b$export$f7a448adcbb9d079 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RemoveFormatEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "RF";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.commands.add("removeFormat", new $ff6b002ce176248b$export$871e982dde0e3e7a(editor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module remove-format/removeformat
*/ /**
* The remove format plugin.
*
* This is a "glue" plugin which loads the {@link module:remove-format/removeformatediting~RemoveFormatEditing}
* and {@link module:remove-format/removeformatui~RemoveFormatUI} plugins.
*
* For a detailed overview, check out the {@glink features/remove-format remove format} feature documentation.
*/ var $ff6b002ce176248b$export$c278e9e5f105cb7f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ff6b002ce176248b$export$f7a448adcbb9d079,
            $ff6b002ce176248b$export$65c2f159aa957c11
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RemoveFormat";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a single "restricted-editing-exception" marker at a given position. Contrary to
* {@link module:engine/model/markercollection~MarkerCollection#getMarkersAtPosition}, it returns a marker also when the position is
* equal to one of the marker's start or end positions.
*
* @internal
*/ function $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, position) {
    for (const marker of editor.model.markers)if ($ecc0a50125d75ca3$export$43433cd79978ce7($ecc0a50125d75ca3$var$getExceptionRange(marker, editor.model), position)) {
        if (marker.name.startsWith("restrictedEditingException:")) return marker;
    }
}
/**
* Checks if the position is fully contained in the range. Positions equal to range start or end are considered "in".
*
* @internal
*/ function $ecc0a50125d75ca3$export$43433cd79978ce7(range, position) {
    return range.containsPosition(position) || range.end.isEqual(position) || range.start.isEqual(position);
}
/**
* Checks if the selection is fully contained in the marker. Positions on marker boundaries are considered "in".
*
* ```xml
* <marker>[]foo</marker> -> true
* <marker>f[oo]</marker> -> true
* <marker>f[oo</marker> ba]r -> false
* <marker>foo</marker> []bar -> false
* ```
*
* @internal
*/ function $ecc0a50125d75ca3$export$3eaa8d748db9e833(selection, model, marker) {
    if (!marker) return false;
    const markerRange = $ecc0a50125d75ca3$var$getExceptionRange(marker, model);
    if (selection.isCollapsed) return $ecc0a50125d75ca3$export$43433cd79978ce7(markerRange, selection.focus);
    return markerRange.containsRange(selection.getFirstRange(), true);
}
/**
* Returns the marker range asjusted to the inside of exception wrapper element if needed.
*
* @internal
*/ function $ecc0a50125d75ca3$var$getExceptionRange(marker, model) {
    const markerRange = marker.getRange();
    const wrapperElement = markerRange.getContainedElement();
    if (wrapperElement && wrapperElement.is("element", "restrictedEditingException")) return model.createRangeIn(wrapperElement);
    return markerRange;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The command that allows navigation across the exceptions in the edited document.
*/ var $ecc0a50125d75ca3$export$354e9e38daf87824 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The direction of the command.
	*/ _direction;
    /**
	* Creates an instance of the command.
	*
	* @param editor The editor instance.
	* @param direction The direction that the command works.
	*/ constructor(editor, direction){
        super(editor);
        this.affectsData = false;
        this._direction = direction;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Executes the command.
	*
	* @fires execute
	*/ execute() {
        const position = $ecc0a50125d75ca3$var$getNearestExceptionRange(this.editor.model, this._direction);
        if (!position) return;
        this.editor.model.change((writer)=>{
            writer.setSelection(position);
        });
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        return !!$ecc0a50125d75ca3$var$getNearestExceptionRange(this.editor.model, this._direction);
    }
};
/**
* Returns the range of the exception marker closest to the last position of the model selection.
*/ function $ecc0a50125d75ca3$var$getNearestExceptionRange(model, direction) {
    const selectionPosition = model.document.selection.getFirstPosition();
    const markerRanges = [];
    for (const marker of model.markers.getMarkersGroup("restrictedEditingException")){
        const markerRange = $ecc0a50125d75ca3$var$getExceptionRange(marker, model);
        const isMarkerRangeTouching = selectionPosition.isTouching(markerRange.start) && selectionPosition.hasSameParentAs(markerRange.start) || selectionPosition.isTouching(markerRange.end) && selectionPosition.hasSameParentAs(markerRange.end);
        if (markerRange.containsPosition(selectionPosition) || isMarkerRangeTouching) continue;
        if (direction === "forward" && markerRange.start.isAfter(selectionPosition)) markerRanges.push(markerRange);
        else if (direction === "backward" && markerRange.end.isBefore(selectionPosition)) markerRanges.push(markerRange);
    }
    if (!markerRanges.length) return;
    return markerRanges.sort((rangeA, rangeB)=>{
        if (direction === "forward") return rangeA.start.isAfter(rangeB.start) ? 1 : -1;
        else return rangeA.start.isBefore(rangeB.start) ? 1 : -1;
    }).shift();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $ecc0a50125d75ca3$var$HIGHLIGHT_CLASS = "restricted-editing-exception_selected";
/**
* Adds a visual highlight style to a restricted editing exception that the selection is anchored to.
*
* The highlight is turned on by adding the `.restricted-editing-exception_selected` class to the
* exception in the view:
*
* * The class is removed before the conversion starts, as callbacks added with the `'highest'` priority
* to {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} events.
* * The class is added in the view post-fixer, after other changes in the model tree are converted to the view.
*
* This way, adding and removing the highlight does not interfere with conversion.
*
* @internal
*/ function $ecc0a50125d75ca3$export$2d589b6e82fa677f(editor) {
    const view = editor.editing.view;
    const model = editor.model;
    const highlightedMarkers = /* @__PURE__ */ new Set();
    view.document.registerPostFixer((writer)=>{
        const modelSelection = model.document.selection;
        const marker = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, modelSelection.anchor);
        if (!marker) return false;
        const modelWrapperElement = marker.getRange().getContainedElement();
        if (modelWrapperElement && modelWrapperElement.is("element", "restrictedEditingException")) {
            const viewElement = editor.editing.mapper.toViewElement(modelWrapperElement);
            writer.addClass($ecc0a50125d75ca3$var$HIGHLIGHT_CLASS, viewElement);
            highlightedMarkers.add(viewElement);
        } else for (const viewElement of editor.editing.mapper.markerNameToElements(marker.name)){
            writer.addClass($ecc0a50125d75ca3$var$HIGHLIGHT_CLASS, viewElement);
            highlightedMarkers.add(viewElement);
        }
        return false;
    });
    editor.conversion.for("editingDowncast").add((dispatcher)=>{
        dispatcher.on("insert", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("remove", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("attribute", removeHighlight, {
            priority: "highest"
        });
        dispatcher.on("cleanSelection", removeHighlight);
        function removeHighlight() {
            view.change((writer)=>{
                for (const item of highlightedMarkers.values()){
                    writer.removeClass($ecc0a50125d75ca3$var$HIGHLIGHT_CLASS, item);
                    highlightedMarkers.delete(item);
                }
            });
        }
    });
}
/**
* A post-fixer that prevents removing a collapsed marker from the document.
*
* @internal
*/ function $ecc0a50125d75ca3$export$8391c1ff8f239030(editor) {
    return (writer)=>{
        let changeApplied = false;
        for (const { name: name, data: data } of editor.model.document.differ.getChangedMarkers())if (name.startsWith("restrictedEditingException") && data.newRange && data.newRange.root.rootName == "$graveyard") {
            writer.updateMarker(name, {
                range: writer.createRange(writer.createPositionAt(data.oldRange.start))
            });
            changeApplied = true;
        }
        return changeApplied;
    };
}
/**
* A post-fixer that extends a marker when the user types on its boundaries.
*
* @internal
*/ function $ecc0a50125d75ca3$export$d607c64d990a3f0(editor) {
    return (writer)=>{
        let changeApplied = false;
        const schema = editor.model.schema;
        for (const change of editor.model.document.differ.getChanges())if (change.type == "insert" && schema.checkChild("$block", change.name)) {
            changeApplied = $ecc0a50125d75ca3$var$_tryExtendMarkerStart(editor, change.position, change.length, writer) || changeApplied;
            changeApplied = $ecc0a50125d75ca3$var$_tryExtendMarkedEnd(editor, change.position, change.length, writer) || changeApplied;
        }
        return changeApplied;
    };
}
/**
* A view highlight-to-marker conversion helper.
*
* @param config Conversion configuration.
* @internal
*/ function $ecc0a50125d75ca3$export$16bdaa0903195b10(config) {
    return (dispatcher)=>dispatcher.on("element", (evt, data, conversionApi)=>{
            const { writer: writer } = conversionApi;
            const matcherResult = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)(config.view).match(data.viewItem);
            if (!matcherResult) return;
            const match = matcherResult.match;
            match.name = true;
            if (!conversionApi.consumable.test(data.viewItem, match)) return;
            let position = data.modelCursor;
            let wrapperElement = null;
            if (config.useWrapperElement) {
                if (!conversionApi.schema.checkChild(position, "restrictedEditingException")) return;
                wrapperElement = writer.createElement("restrictedEditingException");
                writer.insert(wrapperElement, position);
                position = writer.createPositionAt(wrapperElement, 0);
            }
            const { modelRange: convertedChildrenRange } = conversionApi.convertChildren(data.viewItem, position);
            conversionApi.consumable.consume(data.viewItem, match);
            const markerName = config.model();
            const fakeMarkerStart = writer.createElement("$marker", {
                "data-name": markerName
            });
            const fakeMarkerEnd = writer.createElement("$marker", {
                "data-name": markerName
            });
            if (wrapperElement) {
                writer.insert(fakeMarkerStart, writer.createPositionBefore(wrapperElement));
                writer.insert(fakeMarkerEnd, writer.createPositionAfter(wrapperElement));
            } else {
                writer.insert(fakeMarkerEnd, convertedChildrenRange.end);
                writer.insert(fakeMarkerStart, convertedChildrenRange.start);
            }
            data.modelRange = writer.createRange(writer.createPositionBefore(fakeMarkerStart), writer.createPositionAfter(fakeMarkerEnd));
            data.modelCursor = data.modelRange.end;
        });
}
/**
* Extend marker if change detected on marker's start position.
*/ function $ecc0a50125d75ca3$var$_tryExtendMarkerStart(editor, position, length, writer) {
    const markerAtStart = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, position.getShiftedBy(length));
    if (markerAtStart && markerAtStart.getStart().isEqual(position.getShiftedBy(length))) {
        writer.updateMarker(markerAtStart, {
            range: writer.createRange(markerAtStart.getStart().getShiftedBy(-length), markerAtStart.getEnd())
        });
        return true;
    }
    return false;
}
/**
* Extend marker if change detected on marker's end position.
*/ function $ecc0a50125d75ca3$var$_tryExtendMarkedEnd(editor, position, length, writer) {
    const markerAtEnd = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, position);
    if (markerAtEnd && markerAtEnd.getEnd().isEqual(position)) {
        writer.updateMarker(markerAtEnd, {
            range: writer.createRange(markerAtEnd.getStart(), markerAtEnd.getEnd().getShiftedBy(length))
        });
        return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingmodeediting
*/ const $ecc0a50125d75ca3$var$COMMAND_FORCE_DISABLE_ID = "RestrictedEditingMode";
/**
* The restricted editing mode editing feature.
*
* * It introduces the exception marker group that renders to `<span>` elements with the `restricted-editing-exception` CSS class.
* * It registers the `'goToPreviousRestrictedEditingException'` and `'goToNextRestrictedEditingException'` commands.
* * It also enables highlighting exception markers that are selected.
*/ var $ecc0a50125d75ca3$export$b915274b0c192cfe = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Command names that are enabled outside the non-restricted regions.
	*/ _alwaysEnabled;
    /**
	* Commands allowed in non-restricted areas.
	*
	* Commands always enabled combine typing feature commands: `'input'`, `'insertText'`, `'delete'`, and `'deleteForward'` with
	* commands defined in the feature configuration.
	*/ _allowedInException;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RestrictedEditingModeEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "RED";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("restrictedEditing", {
            allowedCommands: [
                "bold",
                "italic",
                "link",
                "unlink"
            ],
            allowedAttributes: [
                "bold",
                "italic",
                "linkHref"
            ]
        });
        this._alwaysEnabled = /* @__PURE__ */ new Set([
            "undo",
            "redo"
        ]);
        this._allowedInException = /* @__PURE__ */ new Set([
            "input",
            "insertText",
            "delete",
            "deleteForward"
        ]);
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        editor.config.get("restrictedEditing.allowedCommands").forEach((commandName)=>this._allowedInException.add(commandName));
        this._setupSchema();
        this._setupConversion();
        this._setupCommandsToggling();
        this._setupRestrictions();
        editor.commands.add("goToPreviousRestrictedEditingException", new $ecc0a50125d75ca3$export$354e9e38daf87824(editor, "backward"));
        editor.commands.add("goToNextRestrictedEditingException", new $ecc0a50125d75ca3$export$354e9e38daf87824(editor, "forward"));
        this.listenTo(editingView.document, "tab", (evt, data)=>{
            const commandName = !data.shiftKey ? "goToNextRestrictedEditingException" : "goToPreviousRestrictedEditingException";
            if (editor.commands.get(commandName).isEnabled) {
                editor.execute(commandName);
                data.preventDefault();
                data.stopPropagation();
            }
            evt.stop();
        }, {
            context: "$capture"
        });
        this.listenTo(editingView.document, "keydown", $ecc0a50125d75ca3$var$getSelectAllHandler(editor), {
            priority: "high"
        });
        editingView.change((writer)=>{
            for (const root of editingView.document.roots)writer.addClass("ck-restricted-editing_mode_restricted", root);
        });
        editor.data.on("set", ()=>{
            editor.model.change((writer)=>{
                for (const marker of editor.model.markers.getMarkersGroup("restrictedEditingException"))writer.removeMarker(marker.name);
            });
        }, {
            priority: "high"
        });
    }
    /**
	* Makes the given command always enabled in the restricted editing mode (regardless
	* of selection location).
	*
	* To enable some commands in non-restricted areas of the content use
	* {@link module:restricted-editing/restrictededitingconfig~RestrictedEditingConfig#allowedCommands} configuration option.
	*
	* @param commandName Name of the command to enable.
	*/ enableCommand(commandName) {
        this.editor.commands.get(commandName).clearForceDisabled($ecc0a50125d75ca3$var$COMMAND_FORCE_DISABLE_ID);
        this._alwaysEnabled.add(commandName);
    }
    /**
	* Registers block exception wrapper in the schema.
	*/ _setupSchema() {
        this.editor.model.schema.register("restrictedEditingException", {
            allowWhere: "$block",
            allowContentOf: "$container",
            isLimit: true
        });
    }
    /**
	* Sets up the restricted mode editing conversion:
	*
	* * ucpast & downcast converters,
	* * marker highlighting in the edting area,
	* * marker post-fixers.
	*/ _setupConversion() {
        const editor = this.editor;
        const doc = editor.model.document;
        let markerNumber = 0;
        editor.conversion.for("upcast").add($ecc0a50125d75ca3$export$16bdaa0903195b10({
            view: {
                name: "span",
                classes: "restricted-editing-exception"
            },
            model: ()=>{
                markerNumber++;
                return `restrictedEditingException:inline:${markerNumber}`;
            }
        }));
        editor.conversion.for("upcast").add($ecc0a50125d75ca3$export$16bdaa0903195b10({
            view: {
                name: "div",
                classes: "restricted-editing-exception"
            },
            model: ()=>{
                markerNumber++;
                return `restrictedEditingException:block:${markerNumber}`;
            },
            useWrapperElement: true
        }));
        editor.conversion.for("downcast").elementToElement({
            model: "restrictedEditingException",
            view: {
                name: "div",
                classes: "restricted-editing-exception"
            }
        });
        editor.conversion.for("downcast").add((dispatcher)=>{
            dispatcher.on("addMarker:restrictedEditingException:inline", (evt, data, conversionApi)=>{
                if (!data.item) return;
                if (data.item.is("selection") || !conversionApi.schema.isInline(data.item)) return;
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;
                const viewWriter = conversionApi.writer;
                const viewElement = viewWriter.createAttributeElement("span", {
                    class: "restricted-editing-exception"
                }, {
                    id: data.markerName,
                    priority: -10
                });
                const viewRange = conversionApi.mapper.toViewRange(data.range);
                const rangeAfterWrap = viewWriter.wrap(viewRange, viewElement);
                for (const element of rangeAfterWrap.getItems())if (element.is("attributeElement") && element.isSimilar(viewElement)) {
                    conversionApi.mapper.bindElementToMarker(element, data.markerName);
                    break;
                }
            });
        });
        editor.conversion.for("downcast").markerToHighlight({
            model: "restrictedEditingException:inline",
            view: ()=>{
                return {
                    name: "span",
                    classes: "restricted-editing-exception",
                    priority: -10
                };
            }
        });
        editor.conversion.for("editingDowncast").markerToElement({
            model: "restrictedEditingException:inline",
            view: (markerData, { writer: writer })=>{
                return writer.createUIElement("span", {
                    class: "restricted-editing-exception restricted-editing-exception_collapsed"
                });
            }
        });
        editor.conversion.for("dataDowncast").markerToElement({
            model: "restrictedEditingException:inline",
            view: (markerData, { writer: writer })=>{
                return writer.createEmptyElement("span", {
                    class: "restricted-editing-exception"
                });
            }
        });
        doc.registerPostFixer($ecc0a50125d75ca3$export$d607c64d990a3f0(editor));
        doc.registerPostFixer($ecc0a50125d75ca3$export$8391c1ff8f239030(editor));
        doc.registerPostFixer($ecc0a50125d75ca3$var$ensureNewMarkerIsFlatPostFixer(editor));
        $ecc0a50125d75ca3$export$2d589b6e82fa677f(editor);
    }
    /**
	* Setups additional editing restrictions beyond command toggling:
	*
	* * delete content range trimming
	* * disabling input command outside exception marker
	* * restricting clipboard holder to text only
	* * restricting text attributes in content
	*/ _setupRestrictions() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const viewDoc = editor.editing.view.document;
        const clipboard = editor.plugins.get("ClipboardPipeline");
        this.listenTo(model, "deleteContent", $ecc0a50125d75ca3$var$restrictDeleteContent(editor), {
            priority: "high"
        });
        const insertTextCommand = editor.commands.get("insertText");
        if (insertTextCommand) this.listenTo(insertTextCommand, "execute", $ecc0a50125d75ca3$var$disallowInputExecForWrongRange(editor), {
            priority: "high"
        });
        this.listenTo(clipboard, "contentInsertion", (evt, data)=>{
            if (!$ecc0a50125d75ca3$var$isRangeInsideSingleMarker(editor, selection.getFirstRange())) evt.stop();
            const marker = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, selection.focus);
            if (marker && marker.name.startsWith("restrictedEditingException:inline:")) {
                const allowedAttributes = editor.config.get("restrictedEditing.allowedAttributes");
                model.change((writer)=>{
                    const content = writer.createDocumentFragment();
                    const textNodes = Array.from(writer.createRangeIn(data.content).getItems()).filter((node)=>node.is("$textProxy"));
                    for (const item of textNodes){
                        for (const attr of item.getAttributeKeys())if (!allowedAttributes.includes(attr)) writer.removeAttribute(attr, item);
                        writer.append(item, content);
                    }
                    data.content = content;
                });
            }
        });
        this.listenTo(viewDoc, "clipboardOutput", (evt, data)=>{
            if (data.method == "cut" && !$ecc0a50125d75ca3$var$isRangeInsideSingleMarker(editor, selection.getFirstRange())) evt.stop();
        }, {
            priority: "high"
        });
        model.schema.addChildCheck((context)=>{
            if (context.startsWith("$clipboardHolder")) return false;
        }, "restrictedEditingException");
    }
    /**
	* Sets up the command toggling which enables or disables commands based on the user selection.
	*/ _setupCommandsToggling() {
        const doc = this.editor.model.document;
        this._disableCommands();
        this.listenTo(doc.selection, "change", this._checkCommands.bind(this));
        this.listenTo(doc, "change:data", this._checkCommands.bind(this));
    }
    /**
	* Checks if commands should be enabled or disabled based on the current selection.
	*/ _checkCommands() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        if (selection.rangeCount > 1) {
            this._disableCommands();
            return;
        }
        const marker = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, selection.focus);
        this._disableCommands();
        if ($ecc0a50125d75ca3$export$3eaa8d748db9e833(selection, editor.model, marker)) this._enableCommands(marker);
    }
    /**
	* Enables commands in non-restricted regions.
	*/ _enableCommands(marker) {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        for (const [commandName, command] of editor.commands){
            if (!command.affectsData || this._alwaysEnabled.has(commandName)) continue;
            if (!marker.name.startsWith("restrictedEditingException:block:") && !this._allowedInException.has(commandName)) continue;
            if ($ecc0a50125d75ca3$var$isDeleteCommandOnMarkerBoundaries(commandName, selection, $ecc0a50125d75ca3$var$getExceptionRange(marker, editor.model))) continue;
            command.clearForceDisabled($ecc0a50125d75ca3$var$COMMAND_FORCE_DISABLE_ID);
        }
    }
    /**
	* Disables commands outside non-restricted regions.
	*/ _disableCommands() {
        const editor = this.editor;
        for (const [commandName, command] of editor.commands){
            if (!command.affectsData || this._alwaysEnabled.has(commandName)) continue;
            command.forceDisabled($ecc0a50125d75ca3$var$COMMAND_FORCE_DISABLE_ID);
        }
    }
};
/**
* Helper for handling Ctrl+A keydown behaviour.
*/ function $ecc0a50125d75ca3$var$getSelectAllHandler(editor) {
    return (eventInfo, domEventData)=>{
        if ((0, $c7bc2cb7e2db0227$export$9a0a9c75ccef13fb)(domEventData) != (0, $c7bc2cb7e2db0227$export$970afd9da919f686)("Ctrl+A")) return;
        const model = editor.model;
        const selection = editor.model.document.selection;
        const marker = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, selection.focus);
        if (!marker) return;
        const selectionRange = selection.getFirstRange();
        const markerRange = $ecc0a50125d75ca3$var$getExceptionRange(marker, editor.model);
        if (markerRange.containsRange(selectionRange, true) || selection.isCollapsed) {
            eventInfo.stop();
            domEventData.preventDefault();
            domEventData.stopPropagation();
            model.change((writer)=>{
                writer.setSelection(markerRange);
            });
        }
    };
}
/**
* Additional rule for enabling "delete" and "deleteForward" commands if selection is on range boundaries:
*
* Does not allow to enable command when selection focus is:
* - is on marker start - "delete" - to prevent removing content before marker
* - is on marker end - "deleteForward" - to prevent removing content after marker
*/ function $ecc0a50125d75ca3$var$isDeleteCommandOnMarkerBoundaries(commandName, selection, markerRange) {
    if (commandName == "delete" && selection.isCollapsed && markerRange.start.isTouching(selection.focus)) return true;
    if (commandName == "deleteForward" && selection.isCollapsed && markerRange.end.isTouching(selection.focus)) return true;
    return false;
}
/**
* Ensures that model.deleteContent() does not delete outside exception markers ranges.
*
* The enforced restrictions are:
* - only execute deleteContent() inside exception markers
* - restrict passed selection to exception marker
*/ function $ecc0a50125d75ca3$var$restrictDeleteContent(editor) {
    return (evt, args)=>{
        const [selection] = args;
        const marker = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, selection.focus) || $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, selection.anchor);
        if (!marker) {
            evt.stop();
            return;
        }
        if (selection.isCollapsed) return;
        const allowedToDelete = $ecc0a50125d75ca3$var$getExceptionRange(marker, editor.model).getIntersection(selection.getFirstRange());
        if (selection.is("documentSelection")) editor.model.change((writer)=>{
            writer.setSelection(allowedToDelete);
        });
        else selection.setTo(allowedToDelete);
    };
}
/**
* Ensures that input command is executed with a range that is inside exception marker.
*
* This restriction is due to fact that using native spell check changes text outside exception marker.
*/ function $ecc0a50125d75ca3$var$disallowInputExecForWrongRange(editor) {
    return (evt, args)=>{
        const [options] = args;
        const { range: range } = options;
        if (!range) return;
        if (!$ecc0a50125d75ca3$var$isRangeInsideSingleMarker(editor, range)) evt.stop();
    };
}
function $ecc0a50125d75ca3$var$isRangeInsideSingleMarker(editor, range) {
    const markerAtStart = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, range.start);
    const markerAtEnd = $ecc0a50125d75ca3$export$5ac0f1c835cafec1(editor, range.end);
    return markerAtStart && markerAtEnd && markerAtEnd === markerAtStart;
}
/**
* Checks if new marker range is flat. Non-flat ranges might appear during upcast conversion in nested structures, ie tables.
*
* Note: This marker fixer only consider case which is possible to create using StandardEditing mode plugin.
* Markers created by developer in the data might break in many other ways.
*
* See https://github.com/ckeditor/ckeditor5/issues/6003.
*/ function $ecc0a50125d75ca3$var$ensureNewMarkerIsFlatPostFixer(editor) {
    return (writer)=>{
        let changeApplied = false;
        const changedMarkers = editor.model.document.differ.getChangedMarkers();
        for (const { data: data, name: name } of changedMarkers){
            if (!name.startsWith("restrictedEditingException")) continue;
            const newRange = data.newRange;
            if (!data.oldRange && !newRange.isFlat) {
                const start = newRange.start;
                const end = newRange.end;
                const startIsHigherInTree = start.path.length > end.path.length;
                const fixedStart = startIsHigherInTree ? newRange.start : writer.createPositionAt(end.parent, 0);
                const fixedEnd = startIsHigherInTree ? writer.createPositionAt(start.parent, "end") : newRange.end;
                writer.updateMarker(name, {
                    range: writer.createRange(fixedStart, fixedEnd)
                });
                changeApplied = true;
            }
        }
        return changeApplied;
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingmodeui
*/ /**
* The restricted editing mode UI feature.
*
* It introduces the `'restrictedEditing'` dropdown that offers tools to navigate between exceptions across
* the document.
*/ var $ecc0a50125d75ca3$export$670fe023f38cde12 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RestrictedEditingModeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.ui.componentFactory.add("restrictedEditing", (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            const listItems = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
            this._getButtonDefinitions().forEach(({ commandName: commandName, label: label, keystroke: keystroke })=>{
                listItems.add(this._getButtonDefinition(commandName, label, keystroke));
            });
            (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, listItems, {
                role: "menu"
            });
            dropdownView.buttonView.set({
                label: t("Navigate editable regions"),
                icon: (0, $e8dc502aba5ac3f5$export$c49b0ff75638404d),
                tooltip: true,
                isEnabled: true,
                isOn: false
            });
            this.listenTo(dropdownView, "execute", (evt)=>{
                const { _commandName: _commandName } = evt.source;
                editor.execute(_commandName);
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add("menuBar:restrictedEditing", (locale)=>{
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            const listView = new (0, $29fd27cb9bdab9d2$export$1c0bdb901b0ce8b1)(locale);
            listView.set({
                ariaLabel: t("Navigate editable regions"),
                role: "menu"
            });
            menuView.buttonView.set({
                label: t("Navigate editable regions"),
                icon: (0, $e8dc502aba5ac3f5$export$c49b0ff75638404d)
            });
            menuView.panelView.children.add(listView);
            this._getButtonDefinitions().forEach(({ commandName: commandName, label: label, keystroke: keystroke })=>{
                const listItemView = new (0, $29fd27cb9bdab9d2$export$b8932d143ba0ac18)(locale, menuView);
                const buttonView = this._createMenuBarButton(label, commandName, keystroke);
                buttonView.delegate("execute").to(menuView);
                listItemView.children.add(buttonView);
                listView.items.add(listItemView);
            });
            return menuView;
        });
    }
    /**
	* Creates a button for restricted editing command to use in menu bar.
	*/ _createMenuBarButton(label, commandName, keystroke) {
        const editor = this.editor;
        const command = editor.commands.get(commandName);
        const view = new (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53)(editor.locale);
        view.set({
            label: label,
            keystroke: keystroke,
            isEnabled: true,
            isOn: false
        });
        view.bind("isEnabled").to(command);
        this.listenTo(view, "execute", ()=>{
            editor.execute(commandName);
            editor.editing.view.focus();
        });
        return view;
    }
    /**
	* Returns a definition of the navigation button to be used in the dropdown.
	*
	* @param commandName The name of the command that the button represents.
	* @param label The translated label of the button.
	* @param keystroke The button keystroke.
	*/ _getButtonDefinition(commandName, label, keystroke) {
        const command = this.editor.commands.get(commandName);
        const definition = {
            type: "button",
            model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                label: label,
                withText: true,
                keystroke: keystroke,
                withKeystroke: true,
                role: "menuitem",
                _commandName: commandName
            })
        };
        definition.model.bind("isEnabled").to(command, "isEnabled");
        return definition;
    }
    /**
	* Returns definitions for UI buttons.
	*
	* @internal
	*/ _getButtonDefinitions() {
        const t = this.editor.locale.t;
        return [
            {
                commandName: "goToPreviousRestrictedEditingException",
                label: t("Previous editable region"),
                keystroke: "Shift+Tab"
            },
            {
                commandName: "goToNextRestrictedEditingException",
                label: t("Next editable region"),
                keystroke: "Tab"
            }
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingmode
*/ /**
* The restricted editing mode plugin.
*
* This is a "glue" plugin which loads the following plugins:
*
* * The {@link module:restricted-editing/restrictededitingmodeediting~RestrictedEditingModeEditing restricted mode editing feature}.
* * The {@link module:restricted-editing/restrictededitingmodeui~RestrictedEditingModeUI restricted mode UI feature}.
*/ var $ecc0a50125d75ca3$export$82eceed768436562 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "RestrictedEditingMode";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $ecc0a50125d75ca3$export$b915274b0c192cfe,
            $ecc0a50125d75ca3$export$670fe023f38cde12
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingexceptioncommand
*/ /**
* The command that toggles exceptions from the restricted editing on text.
*/ var $ecc0a50125d75ca3$export$b6edebf88bff4a98 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const doc = model.document;
        this.value = !!doc.selection.getAttribute("restrictedEditingException");
        this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, "restrictedEditingException");
    }
    /**
	* @inheritDoc
	*/ execute(options = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const valueToSet = options.forceValue === void 0 ? !this.value : options.forceValue;
        model.change((writer)=>{
            const ranges = model.schema.getValidRanges(selection.getRanges(), "restrictedEditingException");
            if (selection.isCollapsed) {
                if (valueToSet) writer.setSelectionAttribute("restrictedEditingException", valueToSet);
                else {
                    const isSameException = (value)=>{
                        return value.item.getAttribute("restrictedEditingException") === this.value;
                    };
                    const focus = selection.focus;
                    const exceptionStart = focus.getLastMatchingPosition(isSameException, {
                        direction: "backward"
                    });
                    const exceptionEnd = focus.getLastMatchingPosition(isSameException);
                    writer.removeSelectionAttribute("restrictedEditingException");
                    if (!(focus.isEqual(exceptionStart) || focus.isEqual(exceptionEnd))) writer.removeAttribute("restrictedEditingException", writer.createRange(exceptionStart, exceptionEnd));
                }
            } else for (const range of ranges)if (valueToSet) writer.setAttribute("restrictedEditingException", valueToSet, range);
            else writer.removeAttribute("restrictedEditingException", range);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingexceptionblockcommand
*/ /**
* The command that toggles exception blocks for the restricted editing.
*/ var $ecc0a50125d75ca3$export$1ebe35f5535c6d89 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    /**
	* Wraps or unwraps the selected blocks with non-restricted area.
	*
	* @fires execute
	* @param options Command options.
	* @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply a block exception,
	* otherwise the command will remove the block exception. If not set, the command will act basing on its current value.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = options.forceValue === void 0 ? !this.value : options.forceValue;
        model.change((writer)=>{
            if (!value) {
                const blocksToUnwrap = blocks.map((block)=>{
                    return $ecc0a50125d75ca3$var$findExceptionContentBlock(block);
                }).filter((exception)=>!!exception);
                this._removeException(writer, blocksToUnwrap);
            } else {
                const blocksToWrap = blocks.filter((block)=>{
                    return $ecc0a50125d75ca3$var$findException(block) || $ecc0a50125d75ca3$var$checkCanBeWrapped(schema, block);
                });
                this._applyException(writer, blocksToWrap);
            }
        });
    }
    /**
	* Checks the command's {@link #value}.
	*/ _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        return !!(firstBlock && $ecc0a50125d75ca3$var$findException(firstBlock));
    }
    /**
	* Checks whether the command can be enabled in the current context.
	*
	* @returns Whether the command should be enabled.
	*/ _checkEnabled() {
        if (this.value) return true;
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks());
        if (!firstBlock) return false;
        return $ecc0a50125d75ca3$var$checkCanBeWrapped(schema, firstBlock);
    }
    /**
	* Unwraps the exception from given blocks.
	*
	* If blocks which are supposed to be unwrapped are in the middle of an exception,
	* start it or end it, then the exception will be split (if needed) and the blocks
	* will be moved out of it, so other exception blocks remained wrapped.
	*/ _removeException(writer, blocks) {
        $ecc0a50125d75ca3$var$getRangesOfBlockGroups(writer, blocks).reverse().forEach((groupRange)=>{
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) writer.split(groupRange.end);
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    /**
	* Applies the exception to given blocks.
	*/ _applyException(writer, blocks) {
        const schema = this.editor.model.schema;
        const exceptionsToMerge = [];
        $ecc0a50125d75ca3$var$getRangesOfBlockGroups(writer, blocks).reverse().forEach((groupRange)=>{
            let exception = $ecc0a50125d75ca3$var$findException(groupRange.start);
            if (!exception) {
                exception = writer.createElement("restrictedEditingException");
                writer.wrap(groupRange, exception);
            }
            exceptionsToMerge.push(exception);
        });
        exceptionsToMerge.reverse();
        if (exceptionsToMerge.length) {
            const previousSibling = exceptionsToMerge.at(0).previousSibling;
            const nextSibling = exceptionsToMerge.at(-1).nextSibling;
            if (previousSibling?.is("element", "restrictedEditingException")) exceptionsToMerge.unshift(previousSibling);
            if (nextSibling?.is("element", "restrictedEditingException")) exceptionsToMerge.push(nextSibling);
        }
        exceptionsToMerge.reduce((currentException, nextException)=>{
            if (currentException.nextSibling == nextException) {
                writer.merge(writer.createPositionAfter(currentException));
                return currentException;
            }
            return nextException;
        });
        schema.removeDisallowedAttributes(blocks, writer);
    }
};
function $ecc0a50125d75ca3$var$findException(elementOrPosition) {
    return elementOrPosition.findAncestor("restrictedEditingException", {
        includeSelf: true
    });
}
function $ecc0a50125d75ca3$var$findExceptionContentBlock(element) {
    let node = element;
    while(node.parent){
        if (node.parent.name == "restrictedEditingException") return node;
        node = node.parent;
    }
    return null;
}
/**
* Returns a minimal array of ranges containing groups of subsequent blocks.
*
* content:         abcdefgh
* blocks:          [ a, b, d, f, g, h ]
* output ranges:   [ab]c[d]e[fgh]
*/ function $ecc0a50125d75ca3$var$getRangesOfBlockGroups(writer, blocks) {
    let startPosition;
    let i = 0;
    const ranges = [];
    while(i < blocks.length){
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) startPosition = writer.createPositionBefore(block);
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
/**
* Checks whether exception can wrap the block.
*/ function $ecc0a50125d75ca3$var$checkCanBeWrapped(schema, block) {
    const parentContext = schema.createContext(block.parent);
    if (!schema.checkChild(parentContext, "restrictedEditingException")) return false;
    if (!schema.checkChild(parentContext.push("restrictedEditingException"), block)) return false;
    return true;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/restrictededitingexceptionautocommand
*/ /**
* The command that toggles exceptions from the restricted editing on text or on blocks.
*/ var $ecc0a50125d75ca3$export$2a99a5ea3083701c = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The inline exception command.
	*/ _inlineCommand;
    /**
	* The block exception command.
	*/ _blockCommand;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._inlineCommand = editor.commands.get("restrictedEditingException");
        this._blockCommand = editor.commands.get("restrictedEditingExceptionBlock");
    }
    /**
	* @inheritDoc
	*/ refresh() {
        this.value = this._inlineCommand.value || this._blockCommand.value;
        this.isEnabled = this._inlineCommand.isEnabled || this._blockCommand.isEnabled;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const editor = this.editor;
        if (this._inlineCommand.value) editor.execute("restrictedEditingException");
        else if (this._blockCommand.value) editor.execute("restrictedEditingExceptionBlock");
        else if (this._inlineCommand.isEnabled && !this._blockCommand.isEnabled) editor.execute("restrictedEditingException");
        else if (this._blockCommand.isEnabled && !this._inlineCommand.isEnabled) editor.execute("restrictedEditingExceptionBlock");
        else {
            const schema = editor.model.schema;
            const selection = editor.model.document.selection;
            const selectedElement = selection.getSelectedElement();
            if (selection.isCollapsed || selectedElement && schema.isObject(selectedElement) && schema.isBlock(selectedElement) || (0, $c7bc2cb7e2db0227$export$85b9a36db797e02b)(selection.getSelectedBlocks()) > 1) editor.execute("restrictedEditingExceptionBlock");
            else editor.execute("restrictedEditingException");
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/standardeditingmodeediting
*/ /**
* The standard editing mode editing feature.
*
* * It introduces the `restrictedEditingException` text attribute that is rendered as
* a `<span>` element with the `restricted-editing-exception` CSS class.
* * It registers the `'restrictedEditingException'` command.
*/ var $ecc0a50125d75ca3$export$312dd49bb49ca52d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StandardEditingModeEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        schema.extend("$text", {
            allowAttributes: [
                "restrictedEditingException"
            ]
        });
        schema.register("restrictedEditingException", {
            allowWhere: "$container",
            allowContentOf: "$container"
        });
        schema.addChildCheck((context)=>{
            for (const item of context)if (item.name == "restrictedEditingException") return false;
        }, "restrictedEditingException");
        schema.addAttributeCheck((context)=>{
            for (const item of context)if (item.name == "restrictedEditingException") return false;
        }, "restrictedEditingException");
        editor.model.document.registerPostFixer((writer)=>{
            const changes = editor.model.document.differ.getChanges();
            const unwrap = /* @__PURE__ */ new Set();
            const remove = /* @__PURE__ */ new Set();
            const merge = /* @__PURE__ */ new Set();
            let changed = false;
            for (const entry of changes)if (entry.type == "insert") {
                const range = writer.createRange(entry.position, entry.position.getShiftedBy(entry.length));
                for (const child of range.getItems())if (child.is("element", "restrictedEditingException")) {
                    if (!schema.checkChild(writer.createPositionBefore(child), child)) unwrap.add(child);
                    else if (child.isEmpty) remove.add(child);
                    else merge.add(child);
                } else if (child.is("$textProxy") && child.hasAttribute("restrictedEditingException") && !schema.checkAttribute(child, "restrictedEditingException")) {
                    writer.removeAttribute("restrictedEditingException", child);
                    changed = true;
                }
            } else if (entry.type == "remove") {
                const parent = entry.position.parent;
                if (parent.is("element", "restrictedEditingException") && parent.isEmpty) remove.add(parent);
                for (const child of parent.getChildren())if (child.is("element", "restrictedEditingException")) merge.add(child);
            }
            for (const child of unwrap){
                writer.unwrap(child);
                changed = true;
            }
            for (const child of remove){
                writer.remove(child);
                changed = true;
            }
            for (const child of merge){
                if (child.root.rootName == "$graveyard") continue;
                const nodeBefore = child.previousSibling;
                const nodeAfter = child.nextSibling;
                if (nodeBefore && nodeBefore.is("element", "restrictedEditingException")) writer.merge(writer.createPositionBefore(child));
                if (nodeAfter && nodeAfter.is("element", "restrictedEditingException")) writer.merge(writer.createPositionAfter(child));
            }
            return changed;
        });
        editor.conversion.for("upcast").elementToAttribute({
            model: "restrictedEditingException",
            view: {
                name: "span",
                classes: "restricted-editing-exception"
            }
        }).elementToElement({
            model: "restrictedEditingException",
            view: {
                name: "div",
                classes: "restricted-editing-exception"
            }
        });
        $ecc0a50125d75ca3$var$registerFallbackUpcastConverter(editor);
        editor.conversion.for("downcast").attributeToElement({
            model: "restrictedEditingException",
            view: (modelAttributeValue, { writer: writer })=>{
                if (modelAttributeValue) return writer.createAttributeElement("span", {
                    class: "restricted-editing-exception"
                }, {
                    priority: -10
                });
            }
        }).elementToElement({
            model: "restrictedEditingException",
            view: {
                name: "div",
                classes: "restricted-editing-exception"
            }
        });
        editor.commands.add("restrictedEditingException", new $ecc0a50125d75ca3$export$b6edebf88bff4a98(editor));
        editor.commands.add("restrictedEditingExceptionBlock", new $ecc0a50125d75ca3$export$1ebe35f5535c6d89(editor));
        editor.commands.add("restrictedEditingExceptionAuto", new $ecc0a50125d75ca3$export$2a99a5ea3083701c(editor));
        editor.editing.view.change((writer)=>{
            for (const root of editor.editing.view.document.roots)writer.addClass("ck-restricted-editing_mode_standard", root);
        });
    }
};
/**
* Fallback upcast converter for empty exception span inside a table cell.
*/ function $ecc0a50125d75ca3$var$registerFallbackUpcastConverter(editor) {
    const matcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
        name: "span",
        classes: "restricted-editing-exception"
    });
    editor.conversion.for("upcast").add((dispatcher)=>dispatcher.on("element:span", (evt, data, conversionApi)=>{
            const matcherResult = matcher.match(data.viewItem);
            if (!matcherResult) return;
            const match = matcherResult.match;
            if (!conversionApi.consumable.test(data.viewItem, match)) return;
            const modelText = conversionApi.writer.createText(" ", {
                restrictedEditingException: true
            });
            if (!conversionApi.safeInsert(modelText, data.modelCursor)) return;
            conversionApi.consumable.consume(data.viewItem, match);
            data.modelRange = conversionApi.writer.createRange(data.modelCursor, data.modelCursor.getShiftedBy(modelText.offsetSize));
            data.modelCursor = data.modelRange.end;
        }, {
            priority: "low"
        }));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/standardeditingmodeui
*/ /**
* The standard editing mode UI feature.
*
* It introduces the `'restrictedEditingException'` button that marks text as unrestricted for editing.
*/ var $ecc0a50125d75ca3$export$6e58ab30e3541f41 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StandardEditingModeUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const componentFactory = editor.ui.componentFactory;
        componentFactory.add("restrictedEditingException:dropdown", (locale)=>{
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            const t = locale.t;
            const buttons = [
                componentFactory.create("restrictedEditingException:inline"),
                componentFactory.create("restrictedEditingException:block")
            ];
            for (const button of buttons)button.set({
                withText: true,
                tooltip: false
            });
            (0, $29fd27cb9bdab9d2$export$c39319333c19bdd7)(dropdownView, buttons, {
                enableActiveItemFocusOnDropdownOpen: true,
                isVertical: true,
                ariaLabel: t("Enable editing")
            });
            dropdownView.buttonView.set({
                label: t("Enable editing"),
                icon: (0, $e8dc502aba5ac3f5$export$34c248d31dc7803c),
                tooltip: true
            });
            dropdownView.extendTemplate({
                attributes: {
                    class: "ck-restricted-editing-dropdown"
                }
            });
            dropdownView.bind("isEnabled").toMany(buttons, "isEnabled", (...areEnabled)=>{
                return areEnabled.some((isEnabled)=>isEnabled);
            });
            this.listenTo(dropdownView, "execute", ()=>{
                editor.editing.view.focus();
            });
            return dropdownView;
        });
        componentFactory.add("restrictedEditingException:inline", ()=>{
            const button = this._createButton("restrictedEditingException", (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.set({
                tooltip: true
            });
            return button;
        });
        componentFactory.add("restrictedEditingException:block", ()=>{
            const button = this._createButton("restrictedEditingExceptionBlock", (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.set({
                tooltip: true
            });
            return button;
        });
        componentFactory.add("menuBar:restrictedEditingException:inline", ()=>{
            return this._createButton("restrictedEditingException", (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
        componentFactory.add("menuBar:restrictedEditingException:block", ()=>{
            return this._createButton("restrictedEditingExceptionBlock", (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
        componentFactory.add("restrictedEditingException:auto", ()=>{
            const button = this._createButton("restrictedEditingExceptionAuto", (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.set({
                tooltip: true
            });
            return button;
        });
        componentFactory.add("menuBar:restrictedEditingException:auto", ()=>{
            return this._createButton("restrictedEditingExceptionAuto", (0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
        componentFactory.add("restrictedEditingException", ()=>{
            return componentFactory.create("restrictedEditingException:inline");
        });
        componentFactory.add("menuBar:restrictedEditingException", ()=>{
            return componentFactory.create("menuBar:restrictedEditingException:inline");
        });
    }
    /**
	* Creates a button for restricted editing exception command to use either in toolbar or in menu bar.
	*/ _createButton(commandName, ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = this.editor.commands.get(commandName);
        const view = new ButtonClass(locale);
        const t = locale.t;
        view.icon = (0, $e8dc502aba5ac3f5$export$34c248d31dc7803c);
        view.isToggleable = true;
        view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
        if (commandName == "restrictedEditingExceptionAuto") view.bind("label").to(command, "value", (value)=>{
            return value ? t("Disable editing") : t("Enable editing");
        });
        else if (commandName == "restrictedEditingExceptionBlock") view.bind("label").to(command, "value", (value)=>{
            return value ? t("Disable block editing") : t("Enable block editing");
        });
        else view.bind("label").to(command, "value", (value)=>{
            return value ? t("Disable inline editing") : t("Enable inline editing");
        });
        this.listenTo(view, "execute", ()=>{
            editor.execute(commandName);
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module restricted-editing/standardeditingmode
*/ /**
* The standard editing mode plugin.
*
* This is a "glue" plugin that loads the following plugins:
*
* * The {@link module:restricted-editing/standardeditingmodeediting~StandardEditingModeEditing standard mode editing feature}.
* * The {@link module:restricted-editing/standardeditingmodeui~StandardEditingModeUI standard mode UI feature}.
*/ var $ecc0a50125d75ca3$export$3be6b4d32545abb = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StandardEditingMode";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    static get requires() {
        return [
            $ecc0a50125d75ca3$export$312dd49bb49ca52d,
            $ecc0a50125d75ca3$export$6e58ab30e3541f41
        ];
    }
};



/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 


/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module show-blocks/showblockscommand
*/ const $a07634ecec72c442$var$CLASS_NAME = "ck-show-blocks";
const $a07634ecec72c442$var$TEXT_PLACEHOLDER = "__TEXT__";
const $a07634ecec72c442$var$SHOW_BLOCKS_LABELS = /* #__PURE__ */ (()=>[
        [
            "address",
            "ADDRESS"
        ],
        [
            "aside",
            "ASIDE"
        ],
        [
            "blockquote",
            "BLOCKQUOTE"
        ],
        [
            "details",
            "DETAILS"
        ],
        [
            "div",
            "DIV"
        ],
        [
            "footer",
            "FOOTER"
        ],
        [
            "h1",
            "H1"
        ],
        [
            "h2",
            "H2"
        ],
        [
            "h3",
            "H3"
        ],
        [
            "h4",
            "H4"
        ],
        [
            "h5",
            "H5"
        ],
        [
            "h6",
            "H6"
        ],
        [
            "header",
            "HEADER"
        ],
        [
            "main",
            "MAIN"
        ],
        [
            "nav",
            "NAV"
        ],
        [
            "pre",
            "PRE"
        ],
        [
            "ol",
            "OL"
        ],
        [
            "ul",
            "UL"
        ],
        [
            "p",
            "P"
        ],
        [
            "section",
            "SECTION"
        ],
        [
            "figcaption",
            "FIGCAPTION"
        ]
    ])();
const $a07634ecec72c442$var$SHOW_BLOCKS_LABEL_SVG_TEMPLATE = /* #__PURE__ */ (()=>({
        ltr: `<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>${$a07634ecec72c442$var$TEXT_PLACEHOLDER}</text></svg>`,
        rtl: `<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>${$a07634ecec72c442$var$TEXT_PLACEHOLDER}</text></svg>`
    }))();
/**
* The show blocks command.
*
* Displays the HTML element names for content blocks.
*/ var $a07634ecec72c442$export$da0ca84cba180e26 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
        this.value = false;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const view = this.editor.editing.view;
        this.isEnabled = Array.from(view.document.roots).some((root)=>$a07634ecec72c442$var$isBlockRoot(this.editor, root));
    }
    /**
	* Toggles the visibility of content blocks.
	* Only roots that accept block-level content are affected.
	*/ execute() {
        const view = this.editor.editing.view;
        view.change((writer)=>{
            for (const root of view.document.roots){
                if (!$a07634ecec72c442$var$isBlockRoot(this.editor, root)) continue;
                if (!root.hasClass($a07634ecec72c442$var$CLASS_NAME)) {
                    $a07634ecec72c442$var$setBlockLabelStyles(writer, root);
                    writer.addClass($a07634ecec72c442$var$CLASS_NAME, root);
                    this.value = true;
                } else {
                    writer.removeClass($a07634ecec72c442$var$CLASS_NAME, root);
                    this.value = false;
                }
            }
        });
    }
};
/**
* Checks whether the given view root corresponds to a model root that accepts block-level content.
* Inline roots (e.g. roots restricted to `$inlineObject` content) are excluded.
*/ function $a07634ecec72c442$var$isBlockRoot(editor, root) {
    const modelRoot = editor.model.document.getRoot(root.rootName);
    return editor.model.schema.checkChild(modelRoot, "$block");
}
/**
* Sets the CSS variables with the block labels as background images on the root element.
*/ function $a07634ecec72c442$var$setBlockLabelStyles(writer, root) {
    if (root.getStyle("--ck-show-blocks-label-address-ltr")) return;
    for (const [key, label] of $a07634ecec72c442$var$SHOW_BLOCKS_LABELS){
        writer.setStyle(`--ck-show-blocks-label-${key}-ltr`, $a07634ecec72c442$var$getLabelUrl(label, "ltr"), root);
        writer.setStyle(`--ck-show-blocks-label-${key}-rtl`, $a07634ecec72c442$var$getLabelUrl(label, "rtl"), root);
    }
}
/**
* Generates a data URL with an SVG image containing the label text.
*/ function $a07634ecec72c442$var$getLabelUrl(label, direction) {
    return `url("data:image/svg+xml;utf8,${$a07634ecec72c442$var$SHOW_BLOCKS_LABEL_SVG_TEMPLATE[direction].replace($a07634ecec72c442$var$TEXT_PLACEHOLDER, label)}")`;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module show-blocks/showblocksediting
*/ /**
* The show blocks editing plugin.
*/ var $a07634ecec72c442$export$d3457d2a9e8e7258 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ShowBlocksEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const { editor: editor } = this;
        editor.commands.add("showBlocks", new $a07634ecec72c442$export$da0ca84cba180e26(editor));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module show-blocks/showblocksui
*/ /**
* The UI plugin of the show blocks feature.
*
* It registers the `'showBlocks'` UI button in the editor's {@link module:ui/componentfactory~ComponentFactory component factory}
* that toggles the visibility of the HTML element names of content blocks.
*/ var $a07634ecec72c442$export$fcddc782c5ca537e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ShowBlocksUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("showBlocks", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                tooltip: true,
                icon: (0, $e8dc502aba5ac3f5$export$d3b56579d316b709)
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:showBlocks", ()=>{
            return this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
    }
    /**
	* Creates a button for show blocks command to use either in toolbar or in menu bar.
	*/ _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const command = editor.commands.get("showBlocks");
        const view = new ButtonClass(locale);
        const t = locale.t;
        view.set({
            label: t("Show blocks"),
            isToggleable: true,
            role: "menuitemcheckbox"
        });
        view.bind("isEnabled").to(command);
        view.bind("isOn").to(command, "value", command, "isEnabled", (value, isEnabled)=>value && isEnabled);
        this.listenTo(view, "execute", ()=>{
            editor.execute("showBlocks");
            editor.editing.view.focus();
        });
        return view;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module show-blocks/showblocks
*/ /**
* The show blocks feature.
*
* For a detailed overview, check the {@glink features/show-blocks Show blocks} feature guide.
*/ var $a07634ecec72c442$export$a8f0a9b50fede859 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ShowBlocks";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $a07634ecec72c442$export$d3457d2a9e8e7258,
            $a07634ecec72c442$export$fcddc782c5ca537e
        ];
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module source-editing/sourceediting
*/ const $15820aed140fcb11$var$COMMAND_FORCE_DISABLE_ID = "SourceEditingMode";
/**
* The source editing feature.
*
* It provides the possibility to view and edit the source of the document.
*
* For a detailed overview, check the {@glink features/source-editing/source-editing source editing feature documentation} and the
* {@glink api/source-editing package page}.
*/ var $15820aed140fcb11$export$60a3cfdb2f0fca54 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SourceEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5)
        ];
    }
    /**
	* The element replacer instance used to replace the editing roots with the wrapper elements containing the document source.
	*/ _elementReplacer;
    /**
	* Maps all root names to wrapper elements containing the document source.
	*/ _replacedRoots;
    /**
	* Maps all root names to their document data.
	*/ _dataFromRoots;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.set("isSourceEditingMode", false);
        this._elementReplacer = new (0, $c7bc2cb7e2db0227$export$d2f12916c0c3be76)();
        this._replacedRoots = /* @__PURE__ */ new Map();
        this._dataFromRoots = /* @__PURE__ */ new Map();
        editor.config.define("sourceEditing.allowCollaborationFeatures", false);
    }
    /**
	* @inheritDoc
	*/ init() {
        this._checkCompatibility();
        const editor = this.editor;
        const t = editor.locale.t;
        editor.ui.componentFactory.add("sourceEditing", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            buttonView.set({
                label: t("Source"),
                icon: (0, $e8dc502aba5ac3f5$export$fee690a0bb150b1d),
                tooltip: true,
                class: "ck-source-editing-button"
            });
            return buttonView;
        });
        editor.ui.componentFactory.add("menuBar:sourceEditing", ()=>{
            const buttonView = this._createButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
            buttonView.set({
                label: t("Show source"),
                role: "menuitemcheckbox"
            });
            return buttonView;
        });
        if (this._isAllowedToHandleSourceEditingMode()) {
            this.on("change:isSourceEditingMode", (evt, name, isSourceEditingMode)=>{
                if (isSourceEditingMode) {
                    this._hideVisibleDialog();
                    this._showSourceEditing();
                    this._disableCommands();
                } else {
                    this._hideSourceEditing();
                    this._enableCommands();
                }
            });
            this.on("change:isEnabled", (evt, name, isEnabled)=>this._handleReadOnlyMode(!isEnabled));
            this.listenTo(editor, "change:isReadOnly", (evt, name, isReadOnly)=>this._handleReadOnlyMode(isReadOnly));
        }
        editor.data.on("get", ()=>{
            if (this.isSourceEditingMode) this.updateEditorData();
        }, {
            priority: "high"
        });
    }
    /**
	* Updates the source data in all hidden editing roots.
	*/ updateEditorData() {
        const editor = this.editor;
        const data = {};
        for (const [rootName, domSourceEditingElementWrapper] of this._replacedRoots){
            const oldData = this._dataFromRoots.get(rootName);
            const newData = domSourceEditingElementWrapper.dataset.value;
            if (oldData !== newData) {
                data[rootName] = newData;
                this._dataFromRoots.set(rootName, newData);
            }
        }
        if (Object.keys(data).length) editor.data.set(data, {
            batchType: {
                isUndoable: true
            },
            suppressErrorInCollaboration: true
        });
    }
    _checkCompatibility() {
        const editor = this.editor;
        const allowCollaboration = editor.config.get("sourceEditing.allowCollaborationFeatures");
        if (!allowCollaboration && editor.plugins.has("RealTimeCollaborativeEditing")) /**
		* Source editing feature is not fully compatible with real-time collaboration,
		* and using it may lead to data loss. Please read
		* {@glink features/source-editing/source-editing#limitations-and-incompatibilities source editing feature guide} to learn more.
		*
		* If you understand the possible risk of data loss, you can enable the source editing
		* by setting the
		* {@link module:source-editing/sourceeditingconfig~SourceEditingConfig#allowCollaborationFeatures}
		* configuration flag to `true`.
		*
		* @error source-editing-incompatible-with-real-time-collaboration
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("source-editing-incompatible-with-real-time-collaboration", null);
        if (!allowCollaboration && [
            "CommentsEditing",
            "TrackChangesEditing",
            "RevisionHistory"
        ].some((pluginName)=>editor.plugins.has(pluginName))) console.warn("You initialized the editor with the source editing feature and at least one of the collaboration features. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the collaboration features.");
        if (editor.plugins.has("RestrictedEditingModeEditing")) console.warn("You initialized the editor with the source editing feature and restricted editing feature. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the restricted editing feature.");
    }
    /**
	* Creates source editing wrappers that replace each editing root. Each wrapper contains the document source from the corresponding
	* root.
	*
	* The wrapper element contains a textarea and it solves the problem, that the textarea element cannot auto expand its height based on
	* the content it contains. The solution is to make the textarea more like a plain div element, which expands in height as much as it
	* needs to, in order to display the whole document source without scrolling. The wrapper element is a parent for the textarea and for
	* the pseudo-element `::after`, that replicates the look, content, and position of the textarea. The pseudo-element replica is hidden,
	* but it is styled to be an identical visual copy of the textarea with the same content. Then, the wrapper is a grid container and both
	* of its children (the textarea and the `::after` pseudo-element) are positioned within a CSS grid to occupy the same grid cell. The
	* content in the pseudo-element `::after` is set in CSS and it stretches the grid to the appropriate size based on the textarea value.
	* Since both children occupy the same grid cell, both have always the same height.
	*/ _showSourceEditing() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const model = editor.model;
        model.change((writer)=>{
            writer.setSelection(null);
            writer.removeSelectionAttribute(model.document.selection.getAttributeKeys());
        });
        for (const [rootName, domRootElement] of editingView.domRoots){
            const data = $15820aed140fcb11$var$formatSource(editor.data.get({
                rootName: rootName
            }));
            const domSourceEditingElementTextarea = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domRootElement.ownerDocument, "textarea", {
                rows: "1",
                "aria-label": "Source code editing area"
            });
            const domSourceEditingElementWrapper = (0, $c7bc2cb7e2db0227$export$c8a8987d4410bf2d)(domRootElement.ownerDocument, "div", {
                class: "ck-source-editing-area",
                "data-value": data
            }, [
                domSourceEditingElementTextarea
            ]);
            domSourceEditingElementTextarea.value = data;
            domSourceEditingElementTextarea.setSelectionRange(0, 0);
            domSourceEditingElementTextarea.addEventListener("input", ()=>{
                domSourceEditingElementWrapper.dataset.value = domSourceEditingElementTextarea.value;
                editor.ui.update();
            });
            domSourceEditingElementTextarea.addEventListener("keydown", (evt)=>{
                const key = evt.key.toLowerCase();
                if ((evt.ctrlKey || evt.metaKey) && !evt.altKey && (key === "z" || key === "y")) {
                    evt.stopImmediatePropagation();
                    if ((0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).isMac && key === "y") {
                        evt.preventDefault();
                        domRootElement.ownerDocument.execCommand("redo");
                    }
                }
            });
            editingView.change((writer)=>{
                const viewRoot = editingView.document.getRoot(rootName);
                writer.addClass("ck-hidden", viewRoot);
            });
            editor.ui.setEditableElement("sourceEditing:" + rootName, domSourceEditingElementTextarea);
            this._replacedRoots.set(rootName, domSourceEditingElementWrapper);
            this._elementReplacer.replace(domRootElement, domSourceEditingElementWrapper);
            this._dataFromRoots.set(rootName, data);
        }
        this._hideDocumentOutline();
        this._refreshAnnotationsVisibility();
        this._focusSourceEditing();
    }
    /**
	* Restores all hidden editing roots and sets the source data in them.
	*/ _hideSourceEditing() {
        const editingView = this.editor.editing.view;
        this.updateEditorData();
        editingView.change((writer)=>{
            for (const [rootName] of this._replacedRoots)writer.removeClass("ck-hidden", editingView.document.getRoot(rootName));
        });
        this._elementReplacer.restore();
        this._replacedRoots.clear();
        this._dataFromRoots.clear();
        this._showDocumentOutline();
        this._refreshAnnotationsVisibility();
        editingView.focus();
    }
    /**
	* Hides the document outline if it is configured.
	*/ _hideDocumentOutline() {
        if (this.editor.plugins.has("DocumentOutlineUI")) this.editor.plugins.get("DocumentOutlineUI").view.element.style.display = "none";
    }
    /**
	* Shows the document outline if it was hidden when entering the source editing.
	*/ _showDocumentOutline() {
        if (this.editor.plugins.has("DocumentOutlineUI")) this.editor.plugins.get("DocumentOutlineUI").view.element.style.display = "";
    }
    /**
	* Hides the annotations when entering the source editing mode and shows back them after leaving it.
	*/ _refreshAnnotationsVisibility() {
        if (this.editor.plugins.has("Annotations")) this.editor.plugins.get("Annotations").refreshVisibility();
    }
    /**
	* Focuses the textarea containing document source from the first editing root.
	*/ _focusSourceEditing() {
        const editor = this.editor;
        const [domSourceEditingElementWrapper] = this._replacedRoots.values();
        const textarea = domSourceEditingElementWrapper.querySelector("textarea");
        editor.editing.view.document.isFocused = false;
        textarea.focus();
    }
    /**
	* Disables all commands.
	*/ _disableCommands() {
        const editor = this.editor;
        for (const command of editor.commands.commands())command.forceDisabled($15820aed140fcb11$var$COMMAND_FORCE_DISABLE_ID);
        if (editor.plugins.has("CommentsArchiveUI")) editor.plugins.get("CommentsArchiveUI").forceDisabled($15820aed140fcb11$var$COMMAND_FORCE_DISABLE_ID);
    }
    /**
	* Clears forced disable for all commands, that was previously set through {@link #_disableCommands}.
	*/ _enableCommands() {
        const editor = this.editor;
        for (const command of editor.commands.commands())command.clearForceDisabled($15820aed140fcb11$var$COMMAND_FORCE_DISABLE_ID);
        if (editor.plugins.has("CommentsArchiveUI")) editor.plugins.get("CommentsArchiveUI").clearForceDisabled($15820aed140fcb11$var$COMMAND_FORCE_DISABLE_ID);
    }
    /**
	* Adds or removes the `readonly` attribute from the textarea from all roots, if document source mode is active.
	*
	* @param isReadOnly Indicates whether all textarea elements should be read-only.
	*/ _handleReadOnlyMode(isReadOnly) {
        if (!this.isSourceEditingMode) return;
        for (const [, domSourceEditingElementWrapper] of this._replacedRoots)domSourceEditingElementWrapper.querySelector("textarea").readOnly = isReadOnly;
    }
    /**
	* Checks, if the plugin is allowed to handle the source editing mode by itself. Currently, the source editing mode is supported only
	* for the {@link module:editor-classic/classiceditor~ClassicEditor classic editor}.
	*/ _isAllowedToHandleSourceEditingMode() {
        const editable = this.editor.ui.view.editable;
        return editable && !editable.hasExternalElement;
    }
    /**
	* If any {@link module:ui/dialog/dialogview~DialogView editor dialog} is currently visible, hide it.
	*/ _hideVisibleDialog() {
        if (this.editor.plugins.has("Dialog")) {
            const dialogPlugin = this.editor.plugins.get("Dialog");
            if (dialogPlugin.isOpen) dialogPlugin.hide();
        }
    }
    _createButton(ButtonClass) {
        const editor = this.editor;
        const buttonView = new ButtonClass(editor.locale);
        buttonView.set({
            withText: true,
            isToggleable: true
        });
        buttonView.bind("isOn").to(this, "isSourceEditingMode");
        buttonView.bind("isEnabled").to(this, "isEnabled", editor, "isReadOnly", editor.plugins.get((0, $7ca4ca5784e50ca9$export$55d9b916408ffdd5)), "hasAny", (isEnabled, isEditorReadOnly, hasAnyPendingActions)=>{
            if (!isEnabled) return false;
            if (isEditorReadOnly) return false;
            if (hasAnyPendingActions) return false;
            return true;
        });
        this.listenTo(buttonView, "execute", ()=>{
            this.isSourceEditingMode = !this.isSourceEditingMode;
        });
        return buttonView;
    }
};
/**
* Formats the content for a better readability.
*
* For a non-HTML source the unchanged input string is returned.
*
* @param input Input string to check.
*/ function $15820aed140fcb11$var$formatSource(input) {
    if (!$15820aed140fcb11$var$isHtml(input)) return input;
    return (0, $c7bc2cb7e2db0227$export$3a8092d2fb888271)(input);
}
/**
* Checks, if the document source is HTML. It is sufficient to just check the first character from the document data.
*
* @param input Input string to check.
*/ function $15820aed140fcb11$var$isHtml(input) {
    return input.startsWith("<");
}


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 




/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/ui/charactergridview
*/ /**
* A grid of character tiles. It allows browsing special characters and selecting the character to
* be inserted into the content.
*
* @internal
*/ var $9e1e186f2006f2be$export$12fa2b4c33cbd01d = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A collection of the child tile views. Each tile represents a particular character.
	*/ tiles;
    /**
	* Tracks information about the DOM focus in the grid.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Creates an instance of a character grid containing tiles representing special characters.
	*
	* @param locale The localization services instance.
	*/ constructor(locale){
        super(locale);
        this.tiles = this.createCollection();
        this.setTemplate({
            tag: "div",
            children: [
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-character-grid__tiles"
                        ]
                    },
                    children: this.tiles
                }
            ],
            attributes: {
                class: [
                    "ck",
                    "ck-character-grid"
                ]
            }
        });
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        (0, $29fd27cb9bdab9d2$export$4c1942d3074fe5f4)({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.tiles,
            numberOfColumns: ()=>(0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(this.element.firstChild).getPropertyValue("grid-template-columns").split(" ").length,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
    }
    /**
	* Creates a new tile for the grid.
	*
	* @param character A human-readable character displayed as the label (e.g. "ε").
	* @param name The name of the character (e.g. "greek small letter epsilon").
	*/ createTile(character, name) {
        const tile = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        tile.set({
            label: character,
            withText: true,
            class: "ck-character-grid__tile"
        });
        tile.extendTemplate({
            attributes: {
                title: name
            },
            on: {
                mouseover: tile.bindTemplate.to("mouseover"),
                focus: tile.bindTemplate.to("focus")
            }
        });
        tile.on("mouseover", ()=>{
            this.fire("tileHover", {
                name: name,
                character: character
            });
        });
        tile.on("focus", ()=>{
            this.fire("tileFocus", {
                name: name,
                character: character
            });
        });
        tile.on("execute", ()=>{
            this.fire("execute", {
                name: name,
                character: character
            });
        });
        return tile;
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        for (const item of this.tiles)this.focusTracker.add(item.element);
        this.tiles.on("change", (eventInfo, { added: added, removed: removed })=>{
            if (added.length > 0) for (const item of added)this.focusTracker.add(item.element);
            if (removed.length > 0) for (const item of removed)this.focusTracker.remove(item.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.keystrokes.destroy();
        this.focusTracker.destroy();
    }
    /**
	* Focuses the first focusable in {@link ~CharacterGridView#tiles}.
	*/ focus() {
        this.tiles.first.focus();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The view displaying detailed information about a special character glyph, e.g. upon
* hovering it with a mouse.
*
* @internal
*/ var $9e1e186f2006f2be$export$5d627a8192d1e892 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.set("character", null);
        this.set("name", null);
        this.bind("code").to(this, "character", $9e1e186f2006f2be$var$characterToUnicodeString);
        this.setTemplate({
            tag: "div",
            children: [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck-character-info__name"
                        ]
                    },
                    children: [
                        {
                            text: bind.to("name", (name)=>name ? name : "\u200B")
                        }
                    ]
                },
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck-character-info__code"
                        ]
                    },
                    children: [
                        {
                            text: bind.to("code")
                        }
                    ]
                }
            ],
            attributes: {
                class: [
                    "ck",
                    "ck-character-info"
                ]
            }
        });
    }
};
/**
* Converts a character into a "Unicode string", for instance:
*
* "$" -> "U+0024"
*
* Returns an empty string when the character is `null`.
*/ function $9e1e186f2006f2be$var$characterToUnicodeString(character) {
    if (character === null) return "";
    return "U+" + ("0000" + character.codePointAt(0).toString(16)).slice(-4);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/ui/specialcharactersview
*/ /**
* A view that glues pieces of the special characters dropdown panel together:
*
* * the navigation view (allows selecting the category),
* * the grid view (displays characters as a grid),
* * and the info view (displays detailed info about a specific character).
*
* @internal
*/ var $9e1e186f2006f2be$export$b3761192df259463 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A collection of the focusable children of the view.
	*/ items;
    /**
	* Tracks information about the DOM focus in the view.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* Helps cycling over focusable {@link #items} in the view.
	*/ _focusCycler;
    /**
	* An instance of the `SpecialCharactersCategoriesView`.
	*/ categoriesView;
    /**
	* An instance of the `CharacterGridView`.
	*/ gridView;
    /**
	* An instance of the `CharacterInfoView`.
	*/ infoView;
    /**
	* Creates an instance of the `SpecialCharactersView`.
	*/ constructor(locale, categoriesView, gridView, infoView){
        super(locale);
        this.categoriesView = categoriesView;
        this.gridView = gridView;
        this.infoView = infoView;
        this.items = this.createCollection();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this.items,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "div",
            children: [
                this.categoriesView,
                this.gridView,
                this.infoView
            ],
            attributes: {
                tabindex: "-1"
            }
        });
        this.items.add(this.categoriesView);
        this.items.add(this.gridView);
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this.focusTracker.add(this.categoriesView.element);
        this.focusTracker.add(this.gridView.element);
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the first focusable in {@link #items}.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/ui/specialcharacterscategoriesview
*/ /**
* A class representing the navigation part of the special characters UI. It is responsible
* for describing the feature and allowing the user to select a particular character group.
*
* @internal
*/ var $9e1e186f2006f2be$export$7dab0421e111321d = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    _groupNames;
    _dropdownView;
    /**
	* Creates an instance of the {@link module:special-characters/ui/specialcharacterscategoriesview~SpecialCharactersCategoriesView}
	* class.
	*
	* @param locale The localization services instance.
	* @param groupNames The names of the character groups.
	*/ constructor(locale, groupNames){
        super(locale);
        this.set("currentGroupName", Array.from(groupNames.entries())[0][0]);
        this._groupNames = groupNames;
        this._dropdownView = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$78775bf7bbba162f));
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-character-categories"
                ]
            },
            children: [
                this._dropdownView
            ]
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this._setupDropdown();
    }
    /**
	* @inheritDoc
	*/ focus() {
        this._dropdownView.focus();
    }
    /**
	* Creates dropdown item list, sets up bindings and fills properties.
	*/ _setupDropdown() {
        const items = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        for (const [name, label] of this._groupNames){
            const item = {
                type: "button",
                model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                    name: name,
                    label: label,
                    role: "menuitemradio",
                    withText: true
                })
            };
            item.model.bind("isOn").to(this, "currentGroupName", (value)=>{
                return value === name;
            });
            items.add(item);
        }
        const t = this.locale.t;
        const accessibleLabel = t("Category");
        this._dropdownView.set({
            label: accessibleLabel,
            isEmpty: false
        });
        this._dropdownView.fieldView.panelPosition = this.locale.uiLanguageDirection === "rtl" ? "se" : "sw";
        this._dropdownView.fieldView.buttonView.set({
            withText: true,
            tooltip: accessibleLabel,
            ariaLabel: accessibleLabel,
            ariaLabelledBy: void 0,
            isOn: false
        });
        this._dropdownView.fieldView.buttonView.bind("label").to(this, "currentGroupName", (value)=>this._groupNames.get(value));
        this._dropdownView.fieldView.on("execute", ({ source: source })=>{
            this.currentGroupName = source.name;
        });
        (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(this._dropdownView.fieldView, items, {
            ariaLabel: accessibleLabel,
            role: "menu"
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharacters
*/ const $9e1e186f2006f2be$var$ALL_SPECIAL_CHARACTERS_GROUP = "All";
/**
* The special characters feature.
*
* Introduces the `'specialCharacters'` dropdown.
*/ var $9e1e186f2006f2be$export$975324e80dcb631e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Registered characters. A pair of a character name and its symbol.
	*/ _characters;
    /**
	* Registered groups. Each group contains a displayed label and a collection with symbol names.
	*/ _groups;
    /**
	* A label describing the "All" special characters category.
	*/ _allSpecialCharactersGroupLabel;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $f1defb5a0a139b4c$export$3997e86453ee41f3),
            (0, $29fd27cb9bdab9d2$export$3ddf2d174ce01153)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharacters";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "SCH";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        const t = editor.t;
        this._characters = /* @__PURE__ */ new Map();
        this._groups = /* @__PURE__ */ new Map();
        this._allSpecialCharactersGroupLabel = t("All");
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("specialCharacters", ()=>{
            const button = this._createDialogButton((0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa));
            button.set({
                tooltip: true
            });
            return button;
        });
        editor.ui.componentFactory.add("menuBar:specialCharacters", ()=>{
            return this._createDialogButton((0, $29fd27cb9bdab9d2$export$6d96eff7641aad53));
        });
    }
    /**
	* Adds a collection of special characters to the specified group. The title of a special character must be unique.
	*
	* **Note:** The "All" category name is reserved by the plugin and cannot be used as a new name for a special
	* characters category.
	*/ addItems(groupName, items, options = {
        label: groupName
    }) {
        if (groupName === $9e1e186f2006f2be$var$ALL_SPECIAL_CHARACTERS_GROUP) /**
		* The name "All" for a special category group cannot be used because it is a special category that displays all
		* available special characters.
		*
		* @error special-character-invalid-group-name
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("special-character-invalid-group-name", null);
        const group = this._getGroup(groupName, options.label);
        for (const item of items){
            group.items.add(item.title);
            this._characters.set(item.title, item.character);
        }
    }
    /**
	* Returns special character groups in an order determined based on configuration and registration sequence.
	*/ getGroups() {
        const groups = Array.from(this._groups.keys());
        const order = this.editor.config.get("specialCharacters.order") || [];
        const invalidGroup = order.find((item)=>!groups.includes(item));
        if (invalidGroup) /**
		* One of the special character groups in the "specialCharacters.order" configuration doesn't exist.
		*
		* @error special-character-invalid-order-group-name
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("special-character-invalid-order-group-name", null, {
            invalidGroup: invalidGroup
        });
        return /* @__PURE__ */ new Set([
            ...order,
            ...groups
        ]);
    }
    /**
	* Returns a collection of special characters symbol names (titles).
	*/ getCharactersForGroup(groupName) {
        if (groupName === $9e1e186f2006f2be$var$ALL_SPECIAL_CHARACTERS_GROUP) return new Set(this._characters.keys());
        const group = this._groups.get(groupName);
        if (group) return group.items;
    }
    /**
	* Returns the symbol of a special character for the specified name. If the special character could not be found, `undefined`
	* is returned.
	*
	* @param title The title of a special character.
	*/ getCharacter(title) {
        return this._characters.get(title);
    }
    /**
	* Returns a group of special characters. If the group with the specified name does not exist, it will be created.
	*
	* @param groupName The name of the group to create.
	* @param label The label describing the new group.
	*/ _getGroup(groupName, label) {
        if (!this._groups.has(groupName)) this._groups.set(groupName, {
            items: /* @__PURE__ */ new Set(),
            label: label
        });
        return this._groups.get(groupName);
    }
    /**
	* Updates the symbol grid depending on the currently selected character group.
	*/ _updateGrid(currentGroupName, gridView) {
        gridView.tiles.clear();
        const characterTitles = this.getCharactersForGroup(currentGroupName);
        for (const title of characterTitles){
            const character = this.getCharacter(title);
            gridView.tiles.add(gridView.createTile(character, title));
        }
    }
    /**
	* Initializes the dropdown, used for lazy loading.
	*
	* @returns An object with `categoriesView`, `gridView` and `infoView` properties, containing UI parts.
	*/ _createDropdownPanelContent(locale) {
        const groupEntries = Array.from(this.getGroups()).map((name)=>[
                name,
                this._groups.get(name).label
            ]);
        const specialCharsGroups = new Map([
            [
                $9e1e186f2006f2be$var$ALL_SPECIAL_CHARACTERS_GROUP,
                this._allSpecialCharactersGroupLabel
            ],
            ...groupEntries
        ]);
        const categoriesView = new $9e1e186f2006f2be$export$7dab0421e111321d(locale, specialCharsGroups);
        const gridView = new $9e1e186f2006f2be$export$12fa2b4c33cbd01d(locale);
        const infoView = new $9e1e186f2006f2be$export$5d627a8192d1e892(locale);
        gridView.on("tileHover", (evt, data)=>{
            infoView.set(data);
        });
        gridView.on("tileFocus", (evt, data)=>{
            infoView.set(data);
        });
        categoriesView.on("change:currentGroupName", (evt, propertyName, newValue)=>{
            this._updateGrid(newValue, gridView);
        });
        this._updateGrid(categoriesView.currentGroupName, gridView);
        return {
            categoriesView: categoriesView,
            gridView: gridView,
            infoView: infoView
        };
    }
    /**
	* Creates a button for toolbar and menu bar that will show special characters dialog.
	*/ _createDialogButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const buttonView = new ButtonClass(editor.locale);
        const command = editor.commands.get("insertText");
        const t = locale.t;
        const dialogPlugin = this.editor.plugins.get("Dialog");
        buttonView.set({
            label: t("Special characters"),
            icon: (0, $e8dc502aba5ac3f5$export$ff198a8945f3463c),
            isToggleable: true
        });
        buttonView.bind("isOn").to(dialogPlugin, "id", (id)=>id === "specialCharacters");
        buttonView.bind("isEnabled").to(command, "isEnabled");
        buttonView.on("execute", ()=>{
            if (dialogPlugin.id === "specialCharacters") {
                dialogPlugin.hide();
                return;
            }
            this._showDialog();
        });
        return buttonView;
    }
    _showDialog() {
        const editor = this.editor;
        const dialog = editor.plugins.get("Dialog");
        const locale = editor.locale;
        const t = locale.t;
        const { categoriesView: categoriesView, gridView: gridView, infoView: infoView } = this._createDropdownPanelContent(locale);
        const content = new $9e1e186f2006f2be$export$b3761192df259463(locale, categoriesView, gridView, infoView);
        gridView.on("execute", (evt, data)=>{
            editor.execute("insertText", {
                text: data.character
            });
        });
        dialog.show({
            id: "specialCharacters",
            title: t("Special characters"),
            className: "ck-special-characters",
            content: content,
            position: (0, $29fd27cb9bdab9d2$export$2cfff24ebf6e24eb).EDITOR_TOP_SIDE
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharactersarrows
*/ /**
* A plugin that provides special characters for the "Arrows" category.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersArrows ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$1b9f5d816af3af83 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersArrows";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get("SpecialCharacters").addItems("Arrows", [
            {
                title: t("leftwards simple arrow"),
                character: "\u2190"
            },
            {
                title: t("rightwards simple arrow"),
                character: "\u2192"
            },
            {
                title: t("upwards simple arrow"),
                character: "\u2191"
            },
            {
                title: t("downwards simple arrow"),
                character: "\u2193"
            },
            {
                title: t("leftwards double arrow"),
                character: "\u21D0"
            },
            {
                title: t("rightwards double arrow"),
                character: "\u21D2"
            },
            {
                title: t("upwards double arrow"),
                character: "\u21D1"
            },
            {
                title: t("downwards double arrow"),
                character: "\u21D3"
            },
            {
                title: t("leftwards dashed arrow"),
                character: "\u21E0"
            },
            {
                title: t("rightwards dashed arrow"),
                character: "\u21E2"
            },
            {
                title: t("upwards dashed arrow"),
                character: "\u21E1"
            },
            {
                title: t("downwards dashed arrow"),
                character: "\u21E3"
            },
            {
                title: t("leftwards arrow to bar"),
                character: "\u21E4"
            },
            {
                title: t("rightwards arrow to bar"),
                character: "\u21E5"
            },
            {
                title: t("upwards arrow to bar"),
                character: "\u2912"
            },
            {
                title: t("downwards arrow to bar"),
                character: "\u2913"
            },
            {
                title: t("up down arrow with base"),
                character: "\u21A8"
            },
            {
                title: t("back with leftwards arrow above"),
                character: "\uD83D\uDD19"
            },
            {
                title: t("end with leftwards arrow above"),
                character: "\uD83D\uDD1A"
            },
            {
                title: t("on with exclamation mark with left right arrow above"),
                character: "\uD83D\uDD1B"
            },
            {
                title: t("soon with rightwards arrow above"),
                character: "\uD83D\uDD1C"
            },
            {
                title: t("top with upwards arrow above"),
                character: "\uD83D\uDD1D"
            }
        ], {
            label: t("Arrows")
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharacterstext
*/ /**
* A plugin that provides special characters for the "Text" category.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersText ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$b79162679599ed1c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersText";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get("SpecialCharacters").addItems("Text", [
            {
                character: "\u2039",
                title: t("Single left-pointing angle quotation mark")
            },
            {
                character: "\u203A",
                title: t("Single right-pointing angle quotation mark")
            },
            {
                character: "\xab",
                title: t("Left-pointing double angle quotation mark")
            },
            {
                character: "\xbb",
                title: t("Right-pointing double angle quotation mark")
            },
            {
                character: "\u2018",
                title: t("Left single quotation mark")
            },
            {
                character: "\u2019",
                title: t("Right single quotation mark")
            },
            {
                character: "\u201C",
                title: t("Left double quotation mark")
            },
            {
                character: "\u201D",
                title: t("Right double quotation mark")
            },
            {
                character: "\u201A",
                title: t("Single low-9 quotation mark")
            },
            {
                character: "\u201E",
                title: t("Double low-9 quotation mark")
            },
            {
                character: "\xa1",
                title: t("Inverted exclamation mark")
            },
            {
                character: "\xbf",
                title: t("Inverted question mark")
            },
            {
                character: "\u2025",
                title: t("Two dot leader")
            },
            {
                character: "\u2026",
                title: t("Horizontal ellipsis")
            },
            {
                character: "\u2021",
                title: t("Double dagger")
            },
            {
                character: "\u2030",
                title: t("Per mille sign")
            },
            {
                character: "\u2031",
                title: t("Per ten thousand sign")
            },
            {
                character: "\u203C",
                title: t("Double exclamation mark")
            },
            {
                character: "\u2048",
                title: t("Question exclamation mark")
            },
            {
                character: "\u2049",
                title: t("Exclamation question mark")
            },
            {
                character: "\u2047",
                title: t("Double question mark")
            },
            {
                character: "\xa9",
                title: t("Copyright sign")
            },
            {
                character: "\xae",
                title: t("Registered sign")
            },
            {
                character: "\u2122",
                title: t("Trade mark sign")
            },
            {
                character: "\xa7",
                title: t("Section sign")
            },
            {
                character: "\xb6",
                title: t("Paragraph sign")
            },
            {
                character: "\u204B",
                title: t("Reversed paragraph sign")
            }
        ], {
            label: t("Text")
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharactersmathematical
*/ /**
* A plugin that provides special characters for the "Mathematical" category.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersMathematical ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$d31e39cf6e2199f2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersMathematical";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get("SpecialCharacters").addItems("Mathematical", [
            {
                character: "<",
                title: t("Less-than sign")
            },
            {
                character: ">",
                title: t("Greater-than sign")
            },
            {
                character: "\u2264",
                title: t("Less-than or equal to")
            },
            {
                character: "\u2265",
                title: t("Greater-than or equal to")
            },
            {
                character: "\u2013",
                title: t("En dash")
            },
            {
                character: "\u2014",
                title: t("Em dash")
            },
            {
                character: "\xaf",
                title: t("Macron")
            },
            {
                character: "\u203E",
                title: t("Overline")
            },
            {
                character: "\xb0",
                title: t("Degree sign")
            },
            {
                character: "\u2212",
                title: t("Minus sign")
            },
            {
                character: "\xb1",
                title: t("Plus-minus sign")
            },
            {
                character: "\xf7",
                title: t("Division sign")
            },
            {
                character: "\u2044",
                title: t("Fraction slash")
            },
            {
                character: "\xd7",
                title: t("Multiplication sign")
            },
            {
                character: "\u0192",
                title: t("Latin small letter f with hook")
            },
            {
                character: "\u222B",
                title: t("Integral")
            },
            {
                character: "\u2211",
                title: t("N-ary summation")
            },
            {
                character: "\u221E",
                title: t("Infinity")
            },
            {
                character: "\u221A",
                title: t("Square root")
            },
            {
                character: "\u223C",
                title: t("Tilde operator")
            },
            {
                character: "\u2245",
                title: t("Approximately equal to")
            },
            {
                character: "\u2248",
                title: t("Almost equal to")
            },
            {
                character: "\u2260",
                title: t("Not equal to")
            },
            {
                character: "\u2261",
                title: t("Identical to")
            },
            {
                character: "\u2208",
                title: t("Element of")
            },
            {
                character: "\u2209",
                title: t("Not an element of")
            },
            {
                character: "\u220B",
                title: t("Contains as member")
            },
            {
                character: "\u220F",
                title: t("N-ary product")
            },
            {
                character: "\u2227",
                title: t("Logical and")
            },
            {
                character: "\u2228",
                title: t("Logical or")
            },
            {
                character: "\xac",
                title: t("Not sign")
            },
            {
                character: "\u2229",
                title: t("Intersection")
            },
            {
                character: "\u222A",
                title: t("Union")
            },
            {
                character: "\u2202",
                title: t("Partial differential")
            },
            {
                character: "\u2200",
                title: t("For all")
            },
            {
                character: "\u2203",
                title: t("There exists")
            },
            {
                character: "\u2205",
                title: t("Empty set")
            },
            {
                character: "\u2207",
                title: t("Nabla")
            },
            {
                character: "\u2217",
                title: t("Asterisk operator")
            },
            {
                character: "\u221D",
                title: t("Proportional to")
            },
            {
                character: "\u2220",
                title: t("Angle")
            },
            {
                character: "\xbc",
                title: t("Vulgar fraction one quarter")
            },
            {
                character: "\xbd",
                title: t("Vulgar fraction one half")
            },
            {
                character: "\xbe",
                title: t("Vulgar fraction three quarters")
            }
        ], {
            label: t("Mathematical")
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharacterslatin
*/ /**
* A plugin that provides special characters for the "Latin" category.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersLatin ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$c996ce567901bee7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersLatin";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get("SpecialCharacters").addItems("Latin", [
            {
                character: "\u0100",
                title: t("Latin capital letter a with macron")
            },
            {
                character: "\u0101",
                title: t("Latin small letter a with macron")
            },
            {
                character: "\u0102",
                title: t("Latin capital letter a with breve")
            },
            {
                character: "\u0103",
                title: t("Latin small letter a with breve")
            },
            {
                character: "\u0104",
                title: t("Latin capital letter a with ogonek")
            },
            {
                character: "\u0105",
                title: t("Latin small letter a with ogonek")
            },
            {
                character: "\u0106",
                title: t("Latin capital letter c with acute")
            },
            {
                character: "\u0107",
                title: t("Latin small letter c with acute")
            },
            {
                character: "\u0108",
                title: t("Latin capital letter c with circumflex")
            },
            {
                character: "\u0109",
                title: t("Latin small letter c with circumflex")
            },
            {
                character: "\u010A",
                title: t("Latin capital letter c with dot above")
            },
            {
                character: "\u010B",
                title: t("Latin small letter c with dot above")
            },
            {
                character: "\u010C",
                title: t("Latin capital letter c with caron")
            },
            {
                character: "\u010D",
                title: t("Latin small letter c with caron")
            },
            {
                character: "\u010E",
                title: t("Latin capital letter d with caron")
            },
            {
                character: "\u010F",
                title: t("Latin small letter d with caron")
            },
            {
                character: "\u0110",
                title: t("Latin capital letter d with stroke")
            },
            {
                character: "\u0111",
                title: t("Latin small letter d with stroke")
            },
            {
                character: "\u0112",
                title: t("Latin capital letter e with macron")
            },
            {
                character: "\u0113",
                title: t("Latin small letter e with macron")
            },
            {
                character: "\u0114",
                title: t("Latin capital letter e with breve")
            },
            {
                character: "\u0115",
                title: t("Latin small letter e with breve")
            },
            {
                character: "\u0116",
                title: t("Latin capital letter e with dot above")
            },
            {
                character: "\u0117",
                title: t("Latin small letter e with dot above")
            },
            {
                character: "\u0118",
                title: t("Latin capital letter e with ogonek")
            },
            {
                character: "\u0119",
                title: t("Latin small letter e with ogonek")
            },
            {
                character: "\u011A",
                title: t("Latin capital letter e with caron")
            },
            {
                character: "\u011B",
                title: t("Latin small letter e with caron")
            },
            {
                character: "\u011C",
                title: t("Latin capital letter g with circumflex")
            },
            {
                character: "\u011D",
                title: t("Latin small letter g with circumflex")
            },
            {
                character: "\u011E",
                title: t("Latin capital letter g with breve")
            },
            {
                character: "\u011F",
                title: t("Latin small letter g with breve")
            },
            {
                character: "\u0120",
                title: t("Latin capital letter g with dot above")
            },
            {
                character: "\u0121",
                title: t("Latin small letter g with dot above")
            },
            {
                character: "\u0122",
                title: t("Latin capital letter g with cedilla")
            },
            {
                character: "\u0123",
                title: t("Latin small letter g with cedilla")
            },
            {
                character: "\u0124",
                title: t("Latin capital letter h with circumflex")
            },
            {
                character: "\u0125",
                title: t("Latin small letter h with circumflex")
            },
            {
                character: "\u0126",
                title: t("Latin capital letter h with stroke")
            },
            {
                character: "\u0127",
                title: t("Latin small letter h with stroke")
            },
            {
                character: "\u0128",
                title: t("Latin capital letter i with tilde")
            },
            {
                character: "\u0129",
                title: t("Latin small letter i with tilde")
            },
            {
                character: "\u012A",
                title: t("Latin capital letter i with macron")
            },
            {
                character: "\u012B",
                title: t("Latin small letter i with macron")
            },
            {
                character: "\u012C",
                title: t("Latin capital letter i with breve")
            },
            {
                character: "\u012D",
                title: t("Latin small letter i with breve")
            },
            {
                character: "\u012E",
                title: t("Latin capital letter i with ogonek")
            },
            {
                character: "\u012F",
                title: t("Latin small letter i with ogonek")
            },
            {
                character: "\u0130",
                title: t("Latin capital letter i with dot above")
            },
            {
                character: "\u0131",
                title: t("Latin small letter dotless i")
            },
            {
                character: "\u0132",
                title: t("Latin capital ligature ij")
            },
            {
                character: "\u0133",
                title: t("Latin small ligature ij")
            },
            {
                character: "\u0134",
                title: t("Latin capital letter j with circumflex")
            },
            {
                character: "\u0135",
                title: t("Latin small letter j with circumflex")
            },
            {
                character: "\u0136",
                title: t("Latin capital letter k with cedilla")
            },
            {
                character: "\u0137",
                title: t("Latin small letter k with cedilla")
            },
            {
                character: "\u0138",
                title: t("Latin small letter kra")
            },
            {
                character: "\u0139",
                title: t("Latin capital letter l with acute")
            },
            {
                character: "\u013A",
                title: t("Latin small letter l with acute")
            },
            {
                character: "\u013B",
                title: t("Latin capital letter l with cedilla")
            },
            {
                character: "\u013C",
                title: t("Latin small letter l with cedilla")
            },
            {
                character: "\u013D",
                title: t("Latin capital letter l with caron")
            },
            {
                character: "\u013E",
                title: t("Latin small letter l with caron")
            },
            {
                character: "\u013F",
                title: t("Latin capital letter l with middle dot")
            },
            {
                character: "\u0140",
                title: t("Latin small letter l with middle dot")
            },
            {
                character: "\u0141",
                title: t("Latin capital letter l with stroke")
            },
            {
                character: "\u0142",
                title: t("Latin small letter l with stroke")
            },
            {
                character: "\u0143",
                title: t("Latin capital letter n with acute")
            },
            {
                character: "\u0144",
                title: t("Latin small letter n with acute")
            },
            {
                character: "\u0145",
                title: t("Latin capital letter n with cedilla")
            },
            {
                character: "\u0146",
                title: t("Latin small letter n with cedilla")
            },
            {
                character: "\u0147",
                title: t("Latin capital letter n with caron")
            },
            {
                character: "\u0148",
                title: t("Latin small letter n with caron")
            },
            {
                character: "\u0149",
                title: t("Latin small letter n preceded by apostrophe")
            },
            {
                character: "\u014A",
                title: t("Latin capital letter eng")
            },
            {
                character: "\u014B",
                title: t("Latin small letter eng")
            },
            {
                character: "\u014C",
                title: t("Latin capital letter o with macron")
            },
            {
                character: "\u014D",
                title: t("Latin small letter o with macron")
            },
            {
                character: "\u014E",
                title: t("Latin capital letter o with breve")
            },
            {
                character: "\u014F",
                title: t("Latin small letter o with breve")
            },
            {
                character: "\u0150",
                title: t("Latin capital letter o with double acute")
            },
            {
                character: "\u0151",
                title: t("Latin small letter o with double acute")
            },
            {
                character: "\u0152",
                title: t("Latin capital ligature oe")
            },
            {
                character: "\u0153",
                title: t("Latin small ligature oe")
            },
            {
                character: "\u0154",
                title: t("Latin capital letter r with acute")
            },
            {
                character: "\u0155",
                title: t("Latin small letter r with acute")
            },
            {
                character: "\u0156",
                title: t("Latin capital letter r with cedilla")
            },
            {
                character: "\u0157",
                title: t("Latin small letter r with cedilla")
            },
            {
                character: "\u0158",
                title: t("Latin capital letter r with caron")
            },
            {
                character: "\u0159",
                title: t("Latin small letter r with caron")
            },
            {
                character: "\u015A",
                title: t("Latin capital letter s with acute")
            },
            {
                character: "\u015B",
                title: t("Latin small letter s with acute")
            },
            {
                character: "\u015C",
                title: t("Latin capital letter s with circumflex")
            },
            {
                character: "\u015D",
                title: t("Latin small letter s with circumflex")
            },
            {
                character: "\u015E",
                title: t("Latin capital letter s with cedilla")
            },
            {
                character: "\u015F",
                title: t("Latin small letter s with cedilla")
            },
            {
                character: "\u0160",
                title: t("Latin capital letter s with caron")
            },
            {
                character: "\u0161",
                title: t("Latin small letter s with caron")
            },
            {
                character: "\u0162",
                title: t("Latin capital letter t with cedilla")
            },
            {
                character: "\u0163",
                title: t("Latin small letter t with cedilla")
            },
            {
                character: "\u0164",
                title: t("Latin capital letter t with caron")
            },
            {
                character: "\u0165",
                title: t("Latin small letter t with caron")
            },
            {
                character: "\u0166",
                title: t("Latin capital letter t with stroke")
            },
            {
                character: "\u0167",
                title: t("Latin small letter t with stroke")
            },
            {
                character: "\u0168",
                title: t("Latin capital letter u with tilde")
            },
            {
                character: "\u0169",
                title: t("Latin small letter u with tilde")
            },
            {
                character: "\u016A",
                title: t("Latin capital letter u with macron")
            },
            {
                character: "\u016B",
                title: t("Latin small letter u with macron")
            },
            {
                character: "\u016C",
                title: t("Latin capital letter u with breve")
            },
            {
                character: "\u016D",
                title: t("Latin small letter u with breve")
            },
            {
                character: "\u016E",
                title: t("Latin capital letter u with ring above")
            },
            {
                character: "\u016F",
                title: t("Latin small letter u with ring above")
            },
            {
                character: "\u0170",
                title: t("Latin capital letter u with double acute")
            },
            {
                character: "\u0171",
                title: t("Latin small letter u with double acute")
            },
            {
                character: "\u0172",
                title: t("Latin capital letter u with ogonek")
            },
            {
                character: "\u0173",
                title: t("Latin small letter u with ogonek")
            },
            {
                character: "\u0174",
                title: t("Latin capital letter w with circumflex")
            },
            {
                character: "\u0175",
                title: t("Latin small letter w with circumflex")
            },
            {
                character: "\u0176",
                title: t("Latin capital letter y with circumflex")
            },
            {
                character: "\u0177",
                title: t("Latin small letter y with circumflex")
            },
            {
                character: "\u0178",
                title: t("Latin capital letter y with diaeresis")
            },
            {
                character: "\u0179",
                title: t("Latin capital letter z with acute")
            },
            {
                character: "\u017A",
                title: t("Latin small letter z with acute")
            },
            {
                character: "\u017B",
                title: t("Latin capital letter z with dot above")
            },
            {
                character: "\u017C",
                title: t("Latin small letter z with dot above")
            },
            {
                character: "\u017D",
                title: t("Latin capital letter z with caron")
            },
            {
                character: "\u017E",
                title: t("Latin small letter z with caron")
            },
            {
                character: "\u017F",
                title: t("Latin small letter long s")
            }
        ], {
            label: t("Latin")
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharacterscurrency
*/ /**
* A plugin that provides special characters for the "Currency" category.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersCurrency ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$76b6bfb6713b6162 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersCurrency";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get("SpecialCharacters").addItems("Currency", [
            {
                character: "$",
                title: t("Dollar sign")
            },
            {
                character: "\u20AC",
                title: t("Euro sign")
            },
            {
                character: "\xa5",
                title: t("Yen sign")
            },
            {
                character: "\xa3",
                title: t("Pound sign")
            },
            {
                character: "\xa2",
                title: t("Cent sign")
            },
            {
                character: "\u20A0",
                title: t("Euro-currency sign")
            },
            {
                character: "\u20A1",
                title: t("Colon sign")
            },
            {
                character: "\u20A2",
                title: t("Cruzeiro sign")
            },
            {
                character: "\u20A3",
                title: t("French franc sign")
            },
            {
                character: "\u20A4",
                title: t("Lira sign")
            },
            {
                character: "\xa4",
                title: t("Currency sign")
            },
            {
                character: "\u20BF",
                title: t("Bitcoin sign")
            },
            {
                character: "\u20A5",
                title: t("Mill sign")
            },
            {
                character: "\u20A6",
                title: t("Naira sign")
            },
            {
                character: "\u20A7",
                title: t("Peseta sign")
            },
            {
                character: "\u20A8",
                title: t("Rupee sign")
            },
            {
                character: "\u20A9",
                title: t("Won sign")
            },
            {
                character: "\u20AA",
                title: t("New sheqel sign")
            },
            {
                character: "\u20AB",
                title: t("Dong sign")
            },
            {
                character: "\u20AD",
                title: t("Kip sign")
            },
            {
                character: "\u20AE",
                title: t("Tugrik sign")
            },
            {
                character: "\u20AF",
                title: t("Drachma sign")
            },
            {
                character: "\u20B0",
                title: t("German penny sign")
            },
            {
                character: "\u20B1",
                title: t("Peso sign")
            },
            {
                character: "\u20B2",
                title: t("Guarani sign")
            },
            {
                character: "\u20B3",
                title: t("Austral sign")
            },
            {
                character: "\u20B4",
                title: t("Hryvnia sign")
            },
            {
                character: "\u20B5",
                title: t("Cedi sign")
            },
            {
                character: "\u20B6",
                title: t("Livre tournois sign")
            },
            {
                character: "\u20B7",
                title: t("Spesmilo sign")
            },
            {
                character: "\u20B8",
                title: t("Tenge sign")
            },
            {
                character: "\u20B9",
                title: t("Indian rupee sign")
            },
            {
                character: "\u20BA",
                title: t("Turkish lira sign")
            },
            {
                character: "\u20BB",
                title: t("Nordic mark sign")
            },
            {
                character: "\u20BC",
                title: t("Manat sign")
            },
            {
                character: "\u20BD",
                title: t("Ruble sign")
            }
        ], {
            label: t("Currency")
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module special-characters/specialcharactersessentials
*/ /**
* A plugin combining a basic set of characters for the special characters plugin.
*
* ```ts
* ClassicEditor
*   .create( {
*     plugins: [ ..., SpecialCharacters, SpecialCharactersEssentials ],
*   } )
*   .then( ... )
*   .catch( ... );
* ```
*/ var $9e1e186f2006f2be$export$4782b5bbc1b4fcd7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "SpecialCharactersEssentials";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $9e1e186f2006f2be$export$76b6bfb6713b6162,
            $9e1e186f2006f2be$export$b79162679599ed1c,
            $9e1e186f2006f2be$export$d31e39cf6e2199f2,
            $9e1e186f2006f2be$export$1b9f5d816af3af83,
            $9e1e186f2006f2be$export$c996ce567901bee7
        ];
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 





/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A class representing an individual button (style) in the grid. Renders a rich preview of the style.
*
* @internal
*/ var $006803d1f21b9692$export$24bc3ea5f703eced = class extends (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa) {
    /**
	* Definition of the style the button will apply when executed.
	*/ styleDefinition;
    /**
	* The view rendering the preview of the style.
	*/ previewView;
    /**
	* Creates an instance of the {@link module:style/ui/stylegridbuttonview~StyleGridButtonView} class.
	*
	* @param locale The localization services instance.
	* @param styleDefinition Definition of the style.
	*/ constructor(locale, styleDefinition){
        super(locale);
        this.styleDefinition = styleDefinition;
        this.previewView = this._createPreview();
        this.set({
            label: styleDefinition.name,
            class: "ck-style-grid__button",
            withText: true
        });
        this.extendTemplate({
            attributes: {
                role: "option"
            }
        });
        this.children.add(this.previewView, 0);
    }
    /**
	* Creates the view representing the preview of the style.
	*/ _createPreview() {
        const previewView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(this.locale);
        previewView.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-reset_all-excluded",
                    "ck-style-grid__button__preview",
                    "ck-content"
                ],
                "aria-hidden": "true"
            },
            children: [
                this.styleDefinition.previewTemplate
            ]
        });
        return previewView;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/ui/stylegridview
*/ /**
* A class representing a grid of styles ({@link module:style/ui/stylegridbuttonview~StyleGridButtonView buttons}).
* Allows users to select a style.
*
* @internal
*/ var $006803d1f21b9692$export$280e29a4ca26787f = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about the DOM focus in the view.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of style {@link module:style/ui/stylegridbuttonview~StyleGridButtonView buttons}.
	*/ children;
    /**
	* Creates an instance of the {@link module:style/ui/stylegridview~StyleGridView} class.
	*
	* @param locale The localization services instance.
	* @param styleDefinitions Definitions of the styles.
	*/ constructor(locale, styleDefinitions){
        super(locale);
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.set("activeStyles", []);
        this.set("enabledStyles", []);
        this.children = this.createCollection();
        this.children.delegate("execute").to(this);
        for (const definition of styleDefinitions){
            const gridTileView = new $006803d1f21b9692$export$24bc3ea5f703eced(locale, definition);
            this.children.add(gridTileView);
        }
        this.on("change:activeStyles", ()=>{
            for (const child of this.children)child.isOn = this.activeStyles.includes(child.styleDefinition.name);
        });
        this.on("change:enabledStyles", ()=>{
            for (const child of this.children)child.isEnabled = this.enabledStyles.includes(child.styleDefinition.name);
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-style-grid"
                ],
                role: "listbox"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        for (const child of this.children)this.focusTracker.add(child.element);
        (0, $29fd27cb9bdab9d2$export$4c1942d3074fe5f4)({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.children,
            numberOfColumns: 3,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Focuses the first style button in the grid.
	*/ focus() {
        this.children.first.focus();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/ui/stylegroupview
*/ /**
* A class representing a group of styles (e.g. "block" or "inline").
*
* Renders a {@link module:style/ui/stylegridview~StyleGridView style grid} and a label.
*
* @internal
*/ var $006803d1f21b9692$export$15705f6115dbf652 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* The styles grid of the group.
	*/ gridView;
    /**
	* The label of the group.
	*/ labelView;
    /**
	* Creates an instance of the {@link module:style/ui/stylegroupview~StyleGroupView} class.
	*
	* @param locale The localization services instance.
	* @param label The localized label of the group.
	* @param styleDefinitions Definitions of the styles in the group.
	*/ constructor(locale, label, styleDefinitions){
        super(locale);
        this.labelView = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        this.labelView.text = label;
        this.gridView = new $006803d1f21b9692$export$280e29a4ca26787f(locale, styleDefinitions);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-style-panel__style-group"
                ],
                role: "group",
                "aria-labelledby": this.labelView.id
            },
            children: [
                this.labelView,
                this.gridView
            ]
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/ui/stylepanelview
*/ /**
* A class representing a panel with available content styles. It renders styles in button grids, grouped
* in categories.
*
* @internal
*/ var $006803d1f21b9692$export$713ca60399dbfc76 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Tracks information about DOM focus in the panel.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of panel children.
	*/ children;
    /**
	* A view representing block styles group.
	*/ blockStylesGroupView;
    /**
	* A view representing inline styles group
	*/ inlineStylesGroupView;
    /**
	* A collection of views that can be focused in the panel.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the panel.
	*/ _focusCycler;
    /**
	* Creates an instance of the {@link module:style/ui/stylegroupview~StyleGroupView} class.
	*
	* @param locale The localization services instance.
	* @param styleDefinitions Normalized definitions of the styles.
	*/ constructor(locale, styleDefinitions){
        super(locale);
        const t = locale.t;
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.children = this.createCollection();
        this.blockStylesGroupView = new $006803d1f21b9692$export$15705f6115dbf652(locale, t("Block styles"), styleDefinitions.block);
        this.inlineStylesGroupView = new $006803d1f21b9692$export$15705f6115dbf652(locale, t("Text styles"), styleDefinitions.inline);
        this.set("activeStyles", []);
        this.set("enabledStyles", []);
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: [
                    "shift + tab"
                ],
                focusNext: [
                    "tab"
                ]
            }
        });
        if (styleDefinitions.block.length) this.children.add(this.blockStylesGroupView);
        if (styleDefinitions.inline.length) this.children.add(this.inlineStylesGroupView);
        this.blockStylesGroupView.gridView.delegate("execute").to(this);
        this.inlineStylesGroupView.gridView.delegate("execute").to(this);
        this.blockStylesGroupView.gridView.bind("activeStyles", "enabledStyles").to(this, "activeStyles", "enabledStyles");
        this.inlineStylesGroupView.gridView.bind("activeStyles", "enabledStyles").to(this, "activeStyles", "enabledStyles");
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-style-panel"
                ]
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        this._focusables.add(this.blockStylesGroupView.gridView);
        this._focusables.add(this.inlineStylesGroupView.gridView);
        this.focusTracker.add(this.blockStylesGroupView.gridView.element);
        this.focusTracker.add(this.inlineStylesGroupView.gridView.element);
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Focuses the first focusable element in the panel.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Focuses the last focusable element in the panel.
	*/ focusLast() {
        this._focusCycler.focusLast();
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/styleutils
*/ const $006803d1f21b9692$var$NON_PREVIEWABLE_ELEMENT_NAMES = [
    "caption",
    "colgroup",
    "dd",
    "dt",
    "figcaption",
    "legend",
    "li",
    "optgroup",
    "option",
    "rp",
    "rt",
    "summary",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
];
var $006803d1f21b9692$export$eee2ff7773f924b0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _htmlSupport;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StyleUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.decorate("isStyleEnabledForBlock");
        this.decorate("isStyleActiveForBlock");
        this.decorate("getAffectedBlocks");
        this.decorate("isStyleEnabledForInlineSelection");
        this.decorate("isStyleActiveForInlineSelection");
        this.decorate("getAffectedInlineSelectable");
        this.decorate("getStylePreview");
        this.decorate("configureGHSDataFilter");
    }
    /**
	* @inheritDoc
	*/ init() {
        this._htmlSupport = this.editor.plugins.get("GeneralHtmlSupport");
    }
    /**
	* Normalizes {@link module:style/styleconfig~StyleConfig#definitions} in the configuration of the styles feature.
	* The structure of normalized styles looks as follows:
	*
	* ```ts
	* {
	* 	block: [
	* 		<module:style/style~StyleDefinition>,
	* 		<module:style/style~StyleDefinition>,
	* 		...
	* 	],
	* 	inline: [
	* 		<module:style/style~StyleDefinition>,
	* 		<module:style/style~StyleDefinition>,
	* 		...
	* 	]
	* }
	* ```
	*
	* @returns An object with normalized style definitions grouped into `block` and `inline` categories (arrays).
	*/ normalizeConfig(dataSchema, styleDefinitions = []) {
        const normalizedDefinitions = {
            block: [],
            inline: []
        };
        for (const definition of styleDefinitions){
            const modelElements = [];
            const ghsAttributes = [];
            for (const ghsDefinition of dataSchema.getDefinitionsForView(definition.element)){
                const appliesToBlock = "appliesToBlock" in ghsDefinition ? ghsDefinition.appliesToBlock : false;
                if (ghsDefinition.isBlock || appliesToBlock) {
                    if (typeof appliesToBlock == "string") modelElements.push(appliesToBlock);
                    else if (ghsDefinition.isBlock) {
                        const ghsBlockDefinition = ghsDefinition;
                        modelElements.push(ghsDefinition.model);
                        if (ghsBlockDefinition.paragraphLikeModel) modelElements.push(ghsBlockDefinition.paragraphLikeModel);
                    }
                } else ghsAttributes.push(ghsDefinition.model);
            }
            const previewTemplate = this.getStylePreview(definition, [
                {
                    text: "AaBbCcDdEeFfGgHhIiJj"
                }
            ]);
            if (modelElements.length) normalizedDefinitions.block.push({
                ...definition,
                previewTemplate: previewTemplate,
                modelElements: modelElements,
                isBlock: true
            });
            else normalizedDefinitions.inline.push({
                ...definition,
                previewTemplate: previewTemplate,
                ghsAttributes: ghsAttributes
            });
        }
        return normalizedDefinitions;
    }
    /**
	* Verifies if the given style is applicable to the provided block element.
	*
	* @internal
	*/ isStyleEnabledForBlock(definition, block) {
        const model = this.editor.model;
        const attributeName = this._htmlSupport.getGhsAttributeNameForElement(definition.element);
        if (!model.schema.checkAttribute(block, attributeName)) return false;
        return definition.modelElements.includes(block.name);
    }
    /**
	* Returns true if the given style is applied to the specified block element.
	*
	* @internal
	*/ isStyleActiveForBlock(definition, block) {
        const attributeName = this._htmlSupport.getGhsAttributeNameForElement(definition.element);
        const ghsAttributeValue = block.getAttribute(attributeName);
        return this.hasAllClasses(ghsAttributeValue, definition.classes);
    }
    /**
	* Returns an array of block elements that style should be applied to.
	*
	* @internal
	*/ getAffectedBlocks(definition, block) {
        if (definition.modelElements.includes(block.name)) return [
            block
        ];
        return null;
    }
    /**
	* Verifies if the given style is applicable to the provided document selection.
	*
	* @internal
	*/ isStyleEnabledForInlineSelection(definition, selection) {
        const model = this.editor.model;
        for (const ghsAttributeName of definition.ghsAttributes)if (model.schema.checkAttributeInSelection(selection, ghsAttributeName)) return true;
        return false;
    }
    /**
	* Returns true if the given style is applied to the specified document selection.
	*
	* @internal
	*/ isStyleActiveForInlineSelection(definition, selection) {
        for (const ghsAttributeName of definition.ghsAttributes){
            const ghsAttributeValue = this._getValueFromFirstAllowedNode(selection, ghsAttributeName);
            if (this.hasAllClasses(ghsAttributeValue, definition.classes)) return true;
        }
        return false;
    }
    /**
	* Returns a selectable that given style should be applied to.
	*
	* @internal
	*/ getAffectedInlineSelectable(definition, selection) {
        return selection;
    }
    /**
	* Returns the `TemplateDefinition` used by styles dropdown to render style preview.
	*
	* @internal
	*/ getStylePreview(definition, children) {
        const { element: element, classes: classes } = definition;
        return {
            tag: $006803d1f21b9692$var$isPreviewable(element) ? element : "div",
            attributes: {
                class: classes
            },
            children: children
        };
    }
    /**
	* Verifies if all classes are present in the given GHS attribute.
	*
	* @internal
	*/ hasAllClasses(ghsAttributeValue, classes) {
        return (0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(ghsAttributeValue) && $006803d1f21b9692$var$hasClassesProperty(ghsAttributeValue) && classes.every((className)=>ghsAttributeValue.classes.includes(className));
    }
    /**
	* This is where the styles feature configures the GHS feature. This method translates normalized
	* {@link module:style/styleconfig~StyleDefinition style definitions} to
	* {@link module:engine/view/matcher~MatcherObjectPattern matcher patterns} and feeds them to the GHS
	* {@link module:html-support/datafilter~DataFilter} plugin.
	*
	* @internal
	*/ configureGHSDataFilter({ block: block, inline: inline }) {
        const ghsDataFilter = this.editor.plugins.get("DataFilter");
        ghsDataFilter.loadAllowedConfig(block.map($006803d1f21b9692$var$normalizedStyleDefinitionToMatcherPattern));
        ghsDataFilter.loadAllowedConfig(inline.map($006803d1f21b9692$var$normalizedStyleDefinitionToMatcherPattern));
    }
    /**
	* Checks the attribute value of the first node in the selection that allows the attribute.
	* For the collapsed selection, returns the selection attribute.
	*
	* @param selection The document selection.
	* @param attributeName Name of the GHS attribute.
	* @returns The attribute value.
	*/ _getValueFromFirstAllowedNode(selection, attributeName) {
        const schema = this.editor.model.schema;
        if (selection.isCollapsed) return selection.getAttribute(attributeName);
        for (const range of selection.getRanges())for (const item of range.getItems())if (schema.checkAttribute(item, attributeName)) return item.getAttribute(attributeName);
        return null;
    }
};
/**
* Checks if given object has `classes` property which is an array.
*
* @param obj Object to check.
*/ function $006803d1f21b9692$var$hasClassesProperty(obj) {
    return Boolean(obj.classes) && Array.isArray(obj.classes);
}
/**
* Decides whether an element should be created in the preview or a substitute `<div>` should
* be used instead. This avoids previewing a standalone `<td>`, `<li>`, etc. without a parent.
*
* @param elementName Name of the element
* @returns Boolean indicating whether the element can be rendered.
*/ function $006803d1f21b9692$var$isPreviewable(elementName) {
    return !$006803d1f21b9692$var$NON_PREVIEWABLE_ELEMENT_NAMES.includes(elementName);
}
/**
* Translates a normalized style definition to a view matcher pattern.
*/ function $006803d1f21b9692$var$normalizedStyleDefinitionToMatcherPattern({ element: element, classes: classes }) {
    return {
        name: element,
        classes: classes
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/styleui
*/ /**
* The UI plugin of the style feature .
*
* It registers the `'style'` UI dropdown in the editor's {@link module:ui/componentfactory~ComponentFactory component factory}
* that displays a grid of styles and allows changing styles of the content.
*/ var $006803d1f21b9692$export$53301cebd84c41b8 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StyleUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $006803d1f21b9692$export$eee2ff7773f924b0
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const dataSchema = editor.plugins.get("DataSchema");
        const styleUtils = editor.plugins.get("StyleUtils");
        const styleDefinitions = editor.config.get("style.definitions");
        const normalizedStyleDefinitions = styleUtils.normalizeConfig(dataSchema, styleDefinitions);
        editor.ui.componentFactory.add("style", (locale)=>{
            const t = locale.t;
            const dropdown = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            const styleCommand = editor.commands.get("style");
            dropdown.once("change:isOpen", ()=>{
                const panelView = new $006803d1f21b9692$export$713ca60399dbfc76(locale, normalizedStyleDefinitions);
                dropdown.panelView.children.add(panelView);
                panelView.delegate("execute").to(dropdown);
                panelView.bind("activeStyles").to(styleCommand, "value");
                panelView.bind("enabledStyles").to(styleCommand, "enabledStyles");
            });
            dropdown.bind("isEnabled").to(styleCommand);
            dropdown.buttonView.withText = true;
            dropdown.buttonView.bind("label").to(styleCommand, "value", (value)=>{
                if (value.length > 1) return t("Multiple styles");
                else if (value.length === 1) return value[0];
                else return t("Styles");
            });
            dropdown.bind("class").to(styleCommand, "value", (value)=>{
                const classes = [
                    "ck-style-dropdown"
                ];
                if (value.length > 1) classes.push("ck-style-dropdown_multiple-active");
                return classes.join(" ");
            });
            dropdown.on("execute", (evt)=>{
                editor.execute("style", {
                    styleName: evt.source.styleDefinition.name
                });
                editor.editing.view.focus();
            });
            return dropdown;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Style command.
*
* Applies and removes styles from selection and elements.
*/ var $006803d1f21b9692$export$151dea30672d5ee2 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* Normalized definitions of the styles.
	*/ _styleDefinitions;
    /**
	* The StyleUtils plugin.
	*/ _styleUtils;
    /**
	* Creates an instance of the command.
	*
	* @param editor Editor on which this command will be used.
	* @param styleDefinitions Normalized definitions of the styles.
	*/ constructor(editor, styleDefinitions){
        super(editor);
        this.set("value", []);
        this.set("enabledStyles", []);
        this._styleDefinitions = styleDefinitions;
        this._styleUtils = this.editor.plugins.get($006803d1f21b9692$export$eee2ff7773f924b0);
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const value = /* @__PURE__ */ new Set();
        const enabledStyles = /* @__PURE__ */ new Set();
        for (const definition of this._styleDefinitions.inline){
            if (this._styleUtils.isStyleEnabledForInlineSelection(definition, selection)) enabledStyles.add(definition.name);
            if (this._styleUtils.isStyleActiveForInlineSelection(definition, selection)) value.add(definition.name);
        }
        const firstBlock = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getSelectedBlocks()) || selection.getFirstPosition().parent;
        /* v8 ignore else -- @preserve */ if (firstBlock) {
            const ancestorBlocks = firstBlock.getAncestors({
                includeSelf: true,
                parentFirst: true
            });
            for (const block of ancestorBlocks){
                if (block.is("rootElement")) break;
                for (const definition of this._styleDefinitions.block){
                    if (!this._styleUtils.isStyleEnabledForBlock(definition, block)) continue;
                    enabledStyles.add(definition.name);
                    if (this._styleUtils.isStyleActiveForBlock(definition, block)) value.add(definition.name);
                }
                if (model.schema.isObject(block)) break;
            }
        }
        this.enabledStyles = Array.from(enabledStyles).sort();
        this.isEnabled = this.enabledStyles.length > 0;
        this.value = this.isEnabled ? Array.from(value).sort() : [];
    }
    /**
	* Executes the command &ndash; applies the style classes to the selection or removes it from the selection.
	*
	* If the command value already contains the requested style, it will remove the style classes. Otherwise, it will set it.
	*
	* The execution result differs, depending on the {@link module:engine/model/document~ModelDocument#selection} and the
	* style type (inline or block):
	*
	* * When applying inline styles:
	*   * If the selection is on a range, the command applies the style classes to all nodes in that range.
	*   * If the selection is collapsed in a non-empty node, the command applies the style classes to the
	* {@link module:engine/model/document~ModelDocument#selection}.
	*
	* * When applying block styles:
	*   * If the selection is on a range, the command applies the style classes to the nearest block parent element.
	*
	* @fires execute
	* @param options Command options.
	* @param options.styleName Style name matching the one defined in the
	* {@link module:style/styleconfig~StyleConfig#definitions configuration}.
	* @param options.forceValue Whether the command should add given style (`true`) or remove it (`false`) from the selection.
	* If not set (default), the command will toggle the style basing on the first selected node. Note, that this will not force
	* setting a style on an element that cannot receive given style.
	*/ execute({ styleName: styleName, forceValue: forceValue }) {
        if (!this.enabledStyles.includes(styleName)) {
            /**
			* Style command can be executed only with a correct style name.
			*
			* This warning may be caused by:
			*
			* * passing a name that is not specified in the {@link module:style/styleconfig~StyleConfig#definitions configuration}
			* (e.g. a CSS class name),
			* * when trying to apply a style that is not allowed on a given element.
			*
			* @error style-command-executed-with-incorrect-style-name
			*/ (0, $c7bc2cb7e2db0227$export$ebd6064652549ce9)("style-command-executed-with-incorrect-style-name");
            return;
        }
        const model = this.editor.model;
        const selection = model.document.selection;
        const htmlSupport = this.editor.plugins.get("GeneralHtmlSupport");
        const allDefinitions = [
            ...this._styleDefinitions.inline,
            ...this._styleDefinitions.block
        ];
        const activeDefinitions = allDefinitions.filter(({ name: name })=>this.value.includes(name));
        const definition = allDefinitions.find(({ name: name })=>name == styleName);
        const shouldAddStyle = forceValue === void 0 ? !this.value.includes(definition.name) : forceValue;
        model.change(()=>{
            let selectables;
            if ($006803d1f21b9692$var$isBlockStyleDefinition(definition)) selectables = this._findAffectedBlocks($006803d1f21b9692$var$getBlocksFromSelection(selection), definition);
            else selectables = [
                this._styleUtils.getAffectedInlineSelectable(definition, selection)
            ];
            for (const selectable of selectables)if (shouldAddStyle) htmlSupport.addModelHtmlClass(definition.element, definition.classes, selectable);
            else htmlSupport.removeModelHtmlClass(definition.element, $006803d1f21b9692$var$getDefinitionExclusiveClasses(activeDefinitions, definition), selectable);
        });
    }
    /**
	* Returns a set of elements that should be affected by the block-style change.
	*/ _findAffectedBlocks(selectedBlocks, definition) {
        const blocks = /* @__PURE__ */ new Set();
        for (const selectedBlock of selectedBlocks){
            const ancestorBlocks = selectedBlock.getAncestors({
                includeSelf: true,
                parentFirst: true
            });
            for (const block of ancestorBlocks){
                if (block.is("rootElement")) break;
                const affectedBlocks = this._styleUtils.getAffectedBlocks(definition, block);
                if (affectedBlocks) {
                    for (const affectedBlock of affectedBlocks)blocks.add(affectedBlock);
                    break;
                }
            }
        }
        return blocks;
    }
};
/**
* Returns classes that are defined only in the supplied definition and not in any other active definition. It's used
* to ensure that classes used by other definitions are preserved when a style is removed.
* See https://github.com/ckeditor/ckeditor5/issues/11748.
*
* @param activeDefinitions All currently active definitions affecting selected element(s).
* @param definition Definition whose classes will be compared with all other active definition classes.
* @returns Array of classes exclusive to the supplied definition.
*/ function $006803d1f21b9692$var$getDefinitionExclusiveClasses(activeDefinitions, definition) {
    return activeDefinitions.reduce((classes, currentDefinition)=>{
        if (currentDefinition.name === definition.name) return classes;
        return classes.filter((className)=>!currentDefinition.classes.includes(className));
    }, definition.classes);
}
/**
* Checks if provided style definition is of type block.
*/ function $006803d1f21b9692$var$isBlockStyleDefinition(definition) {
    return "isBlock" in definition;
}
/**
* Gets block elements from selection. If there are none, returns first selected element.
* @param selection Current document's selection.
* @returns Selected blocks if there are any, first selected element otherwise.
*/ function $006803d1f21b9692$var$getBlocksFromSelection(selection) {
    const blocks = Array.from(selection.getSelectedBlocks());
    if (blocks.length) return blocks;
    return [
        selection.getFirstPosition().parent
    ];
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/integrations/list
*/ var $006803d1f21b9692$export$62c45190ae69d92b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _listUtils;
    _styleUtils;
    _htmlSupport;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "ListStyleSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $006803d1f21b9692$export$eee2ff7773f924b0,
            (0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("ListEditing")) return;
        this._styleUtils = editor.plugins.get($006803d1f21b9692$export$eee2ff7773f924b0);
        this._listUtils = this.editor.plugins.get("ListUtils");
        this._htmlSupport = this.editor.plugins.get((0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c));
        this.listenTo(this._styleUtils, "isStyleEnabledForBlock", (evt, [definition, block])=>{
            if (this._isStyleEnabledForBlock(definition, block)) {
                evt.return = true;
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "isStyleActiveForBlock", (evt, [definition, block])=>{
            if (this._isStyleActiveForBlock(definition, block)) {
                evt.return = true;
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "getAffectedBlocks", (evt, [definition, block])=>{
            const blocks = this._getAffectedBlocks(definition, block);
            if (blocks) {
                evt.return = blocks;
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "getStylePreview", (evt, [definition, children])=>{
            const templateDefinition = this._getStylePreview(definition, children);
            if (templateDefinition) {
                evt.return = templateDefinition;
                evt.stop();
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Verifies if the given style is applicable to the provided block element.
	*/ _isStyleEnabledForBlock(definition, block) {
        const model = this.editor.model;
        if (![
            "ol",
            "ul",
            "li"
        ].includes(definition.element)) return false;
        if (!this._listUtils.isListItemBlock(block)) return false;
        const attributeName = this._htmlSupport.getGhsAttributeNameForElement(definition.element);
        if (definition.element == "ol" || definition.element == "ul") {
            if (!model.schema.checkAttribute(block, attributeName)) return false;
            const viewElementName = this._listUtils.isNumberedListType(block.getAttribute("listType")) ? "ol" : "ul";
            return definition.element == viewElementName;
        } else return model.schema.checkAttribute(block, attributeName);
    }
    /**
	* Returns true if the given style is applied to the specified block element.
	*/ _isStyleActiveForBlock(definition, block) {
        const attributeName = this._htmlSupport.getGhsAttributeNameForElement(definition.element);
        const ghsAttributeValue = block.getAttribute(attributeName);
        return this._styleUtils.hasAllClasses(ghsAttributeValue, definition.classes);
    }
    /**
	* Returns an array of block elements that style should be applied to.
	*/ _getAffectedBlocks(definition, block) {
        if (!this._isStyleEnabledForBlock(definition, block)) return null;
        if (definition.element == "li") return this._listUtils.expandListBlocksToCompleteItems(block, {
            withNested: false
        });
        else return this._listUtils.expandListBlocksToCompleteList(block);
    }
    /**
	* Returns a view template definition for the style preview.
	*/ _getStylePreview(definition, children) {
        const { element: element, classes: classes } = definition;
        if (element == "ol" || element == "ul") return {
            tag: element,
            attributes: {
                class: classes
            },
            children: [
                {
                    tag: "li",
                    children: children
                }
            ]
        };
        else if (element == "li") return {
            tag: "ol",
            children: [
                {
                    tag: element,
                    attributes: {
                        class: classes
                    },
                    children: children
                }
            ]
        };
        return null;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/integrations/table
*/ var $006803d1f21b9692$export$b7ce437cb659cc8a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _tableUtils;
    _styleUtils;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableStyleSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $006803d1f21b9692$export$eee2ff7773f924b0
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("TableEditing")) return;
        this._styleUtils = editor.plugins.get($006803d1f21b9692$export$eee2ff7773f924b0);
        this._tableUtils = this.editor.plugins.get("TableUtils");
        this.listenTo(this._styleUtils, "isStyleEnabledForBlock", (evt, [definition, block])=>{
            if (this._isApplicable(definition, block)) {
                evt.return = this._isStyleEnabledForBlock(definition, block);
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "getAffectedBlocks", (evt, [definition, block])=>{
            if (this._isApplicable(definition, block)) {
                evt.return = this._getAffectedBlocks(definition, block);
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "configureGHSDataFilter", (evt, [{ block: block }])=>{
            this.editor.plugins.get("DataFilter").loadAllowedConfig(block.filter((definition)=>definition.element == "figcaption").map((definition)=>({
                    name: "caption",
                    classes: definition.classes
                })));
        });
    }
    /**
	* Checks if this plugin's custom logic should be applied for defintion-block pair.
	*
	* @param definition Style definition that is being considered.
	* @param block Block element to check if should be styled.
	* @returns True if the defintion-block pair meet the plugin criteria, false otherwise.
	*/ _isApplicable(definition, block) {
        if ([
            "td",
            "th"
        ].includes(definition.element)) return block.name == "tableCell";
        if ([
            "thead",
            "tbody",
            "tfoot"
        ].includes(definition.element)) return block.name == "table";
        return false;
    }
    /**
	* Checks if the style definition should be applied to selected block.
	*
	* @param definition Style definition that is being considered.
	* @param block Block element to check if should be styled.
	* @returns True if the block should be style with the style description, false otherwise.
	*/ _isStyleEnabledForBlock(definition, block) {
        if ([
            "td",
            "th"
        ].includes(definition.element)) {
            const location = this._tableUtils.getCellLocation(block);
            const table = block.parent.parent;
            const headingRows = table.getAttribute("headingRows") || 0;
            const headingColumns = table.getAttribute("headingColumns") || 0;
            const isHeadingCell = location.row < headingRows || location.column < headingColumns;
            if (definition.element == "th") return isHeadingCell;
            else return !isHeadingCell;
        }
        /* v8 ignore else -- @preserve */ if ([
            "thead",
            "tbody",
            "tfoot"
        ].includes(definition.element)) {
            const headingRows = block.getAttribute("headingRows") || 0;
            const footerRows = block.getAttribute("footerRows") || 0;
            if (definition.element == "thead") return headingRows > 0;
            else if (definition.element == "tfoot") return footerRows > 0;
            else return headingRows + footerRows < this._tableUtils.getRows(block);
        }
        /* v8 ignore next -- @preserve */ return false;
    }
    /**
	* Gets all blocks that the style should be applied to.
	*
	* @param definition Style definition that is being considered.
	* @param block A block element from selection.
	* @returns An array with the block that was passed as an argument if meets the criteria, null otherwise.
	*/ _getAffectedBlocks(definition, block) {
        if (!this._isStyleEnabledForBlock(definition, block)) return null;
        return [
            block
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/integrations/link
*/ var $006803d1f21b9692$export$869974afdc485552 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    _styleUtils;
    _htmlSupport;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "LinkStyleSupport";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $006803d1f21b9692$export$eee2ff7773f924b0,
            (0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c)
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        if (!editor.plugins.has("LinkEditing")) return;
        this._styleUtils = editor.plugins.get($006803d1f21b9692$export$eee2ff7773f924b0);
        this._htmlSupport = this.editor.plugins.get((0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c));
        this.listenTo(this._styleUtils, "isStyleEnabledForInlineSelection", (evt, [definition, selection])=>{
            if (definition.element == "a") {
                evt.return = this._isStyleEnabled(definition, selection);
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "isStyleActiveForInlineSelection", (evt, [definition, selection])=>{
            if (definition.element == "a") {
                evt.return = this._isStyleActive(definition, selection);
                evt.stop();
            }
        }, {
            priority: "high"
        });
        this.listenTo(this._styleUtils, "getAffectedInlineSelectable", (evt, [definition, selection])=>{
            if (definition.element != "a") return;
            const selectable = this._getAffectedSelectable(definition, selection);
            /* v8 ignore else -- @preserve */ if (selectable) {
                evt.return = selectable;
                evt.stop();
            }
        }, {
            priority: "high"
        });
    }
    /**
	* Verifies if the given style is applicable to the provided document selection.
	*/ _isStyleEnabled(definition, selection) {
        const model = this.editor.model;
        if (selection.isCollapsed) return selection.hasAttribute("linkHref");
        for (const range of selection.getRanges())for (const item of range.getItems())if ((item.is("$textProxy") || model.schema.isInline(item)) && item.hasAttribute("linkHref")) return true;
        return false;
    }
    /**
	* Returns true if the given style is applied to the specified document selection.
	*/ _isStyleActive(definition, selection) {
        const model = this.editor.model;
        const attributeName = this._htmlSupport.getGhsAttributeNameForElement(definition.element);
        if (selection.isCollapsed) {
            if (selection.hasAttribute("linkHref")) {
                const ghsAttributeValue = selection.getAttribute(attributeName);
                if (this._styleUtils.hasAllClasses(ghsAttributeValue, definition.classes)) return true;
            }
            return false;
        }
        for (const range of selection.getRanges())for (const item of range.getItems())if ((item.is("$textProxy") || model.schema.isInline(item)) && item.hasAttribute("linkHref")) {
            const ghsAttributeValue = item.getAttribute(attributeName);
            return this._styleUtils.hasAllClasses(ghsAttributeValue, definition.classes);
        }
        return false;
    }
    /**
	* Returns a selectable that given style should be applied to.
	*/ _getAffectedSelectable(definition, selection) {
        const model = this.editor.model;
        if (selection.isCollapsed) {
            const linkHref = selection.getAttribute("linkHref");
            return (0, $f1defb5a0a139b4c$export$67d698a4bb9f8c2a)(selection.getFirstPosition(), "linkHref", linkHref, model);
        }
        const ranges = [];
        for (const range of selection.getRanges()){
            const expandedRange = model.createRange($006803d1f21b9692$var$expandAttributePosition(range.start, "linkHref", true, model), $006803d1f21b9692$var$expandAttributePosition(range.end, "linkHref", false, model));
            for (const item of expandedRange.getItems())if ((item.is("$textProxy") || model.schema.isInline(item)) && item.hasAttribute("linkHref")) ranges.push(this.editor.model.createRangeOn(item));
        }
        return $006803d1f21b9692$var$normalizeRanges(ranges);
    }
};
/**
* Walks forward or backward (depends on the `lookBack` flag), node by node, as long as they have the same attribute value
* and returns a position just before or after (depends on the `lookBack` flag) the last matched node.
*/ function $006803d1f21b9692$var$expandAttributePosition(position, attributeName, lookBack, model) {
    const referenceNode = position.textNode || (lookBack ? position.nodeAfter : position.nodeBefore);
    if (!referenceNode || !referenceNode.hasAttribute(attributeName)) return position;
    const attributeValue = referenceNode.getAttribute(attributeName);
    return (0, $f1defb5a0a139b4c$export$a6e075de01e9ca89)(position, attributeName, attributeValue, lookBack, model);
}
/**
* Normalizes list of ranges by joining intersecting or "touching" ranges.
*
* Note: It assumes that ranges are sorted.
*/ function $006803d1f21b9692$var$normalizeRanges(ranges) {
    for(let i = 1; i < ranges.length; i++){
        const joinedRange = ranges[i - 1].getJoined(ranges[i]);
        if (joinedRange) ranges.splice(--i, 2, joinedRange);
    }
    return ranges;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/styleediting
*/ /**
* The style engine feature.
*
* It configures the {@glink features/html/general-html-support General HTML Support feature} based on
* {@link module:style/styleconfig~StyleConfig#definitions configured style definitions} and introduces the
* {@link module:style/stylecommand~StyleCommand style command} that applies styles to the content of the document.
*/ var $006803d1f21b9692$export$bf235ec18bcbe080 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "StyleEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c),
            $006803d1f21b9692$export$eee2ff7773f924b0,
            $006803d1f21b9692$export$62c45190ae69d92b,
            $006803d1f21b9692$export$b7ce437cb659cc8a,
            $006803d1f21b9692$export$869974afdc485552
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const dataSchema = editor.plugins.get("DataSchema");
        const styleUtils = editor.plugins.get("StyleUtils");
        const styleDefinitions = editor.config.get("style.definitions");
        const normalizedStyleDefinitions = styleUtils.normalizeConfig(dataSchema, styleDefinitions);
        editor.commands.add("style", new $006803d1f21b9692$export$151dea30672d5ee2(editor, normalizedStyleDefinitions));
        styleUtils.configureGHSDataFilter(normalizedStyleDefinitions);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module style/style
*/ /**
* The style plugin.
*
* This is a "glue" plugin that loads the {@link module:style/styleediting~StyleEditing style editing feature}
* and {@link module:style/styleui~StyleUI style UI feature}.
*/ var $006803d1f21b9692$export$d9e45bc13d335801 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Style";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $006803d1f21b9692$export$bf235ec18bcbe080,
            $006803d1f21b9692$export$53301cebd84c41b8
        ];
    }
};


/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 








/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ const $f1b97c36043e973c$var$ALIGN_VALUES_REG_EXP$1 = /^(left|center|right)$/;
const $f1b97c36043e973c$var$FLOAT_VALUES_REG_EXP = /^(left|none|right)$/;
/**
* Conversion helper for upcasting attributes using normalized styles.
*
* @param options.modelAttribute The attribute to set.
* @param options.styleName The style name to convert.
* @param options.attributeName The HTML attribute name to convert.
* @param options.attributeType The HTML attribute type for value normalization.
* @param options.viewElement The view element name that should be converted.
* @param options.defaultValue The default value for the specified `modelAttribute`.
* @param options.shouldUpcast The function which returns `true` if style should be upcasted from this element.
* @internal
*/ function $f1b97c36043e973c$export$d738fe580628bde5(conversion, options) {
    const { modelAttribute: modelAttribute, styleName: styleName, attributeName: attributeName, attributeType: attributeType, viewElement: viewElement, defaultValue: defaultValue, shouldUpcast: shouldUpcast = ()=>true, reduceBoxSides: reduceBoxSides = false } = options;
    conversion.for("upcast").attributeToAttribute({
        view: {
            name: viewElement,
            styles: {
                [styleName]: /[\s\S]+/
            }
        },
        model: {
            key: modelAttribute,
            value: (viewElement, conversionApi, data)=>{
                if (!shouldUpcast(viewElement)) return;
                const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "", data);
                const normalized = viewElement.getNormalizedStyle(styleName);
                const value = reduceBoxSides ? $f1b97c36043e973c$var$reduceBoxSidesValue(normalized) : normalized;
                if (localDefaultValue !== value) return value;
                conversionApi.consumable.consume(viewElement, {
                    styles: styleName
                });
            }
        }
    });
    if (attributeName) conversion.for("upcast").attributeToAttribute({
        view: {
            name: viewElement,
            attributes: {
                [attributeName]: /.+/
            }
        },
        model: {
            key: modelAttribute,
            value: (viewElement, conversionApi, data)=>{
                if (viewElement.name == "figure" || viewElement.hasStyle(styleName) || viewElement.name == "table" && viewElement.parent.name == "figure" && viewElement.parent.hasStyle(styleName)) return;
                const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "", data);
                let value = viewElement.getAttribute(attributeName);
                if (value && attributeType == "length") {
                    const parsedValue = parseFloat(value);
                    if (isNaN(parsedValue)) value = localDefaultValue;
                    else value = parsedValue + (value.includes("%") ? "%" : "px");
                }
                if (localDefaultValue !== value) return value;
                conversionApi.consumable.consume(viewElement, {
                    attributes: attributeName
                });
            }
        }
    });
}
/**
* Conversion helper for upcasting border styles for view elements.
*
* @param editor The editor instance.
* @param defaultBorder The default border values.
* @param defaultBorder.color The default `borderColor` value.
* @param defaultBorder.style The default `borderStyle` value.
* @param defaultBorder.width The default `borderWidth` value.
* @internal
*/ function $f1b97c36043e973c$export$fd4c67f8267d3604(editor, viewElementName, modelAttributes, defaultBorder) {
    const { conversion: conversion } = editor;
    conversion.for("upcast").add((dispatcher)=>{
        dispatcher.on(`element:${viewElementName}`, (evt, data, conversionApi)=>{
            const { modelRange: modelRange, viewItem: viewItem } = data;
            if (!modelRange) return;
            const stylesToConsume = [
                "border-top-width",
                "border-top-color",
                "border-top-style",
                "border-bottom-width",
                "border-bottom-color",
                "border-bottom-style",
                "border-right-width",
                "border-right-color",
                "border-right-style",
                "border-left-width",
                "border-left-color",
                "border-left-style"
            ].filter((styleName)=>viewItem.hasStyle(styleName));
            const viewTable = viewItem.is("element", "table") ? viewItem : viewItem.findAncestor("table");
            const hasTableBorderAttribute = viewTable.hasAttribute("border");
            if (!stylesToConsume.length && !hasTableBorderAttribute) return;
            const matcherPattern = {
                styles: stylesToConsume
            };
            if (!conversionApi.consumable.test(viewItem, matcherPattern)) return;
            const modelElement = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(modelRange.getItems({
                shallow: true
            }));
            const tableModelElement = modelElement.findAncestor("table", {
                includeSelf: true
            });
            let localDefaultBorder = defaultBorder;
            if (tableModelElement && tableModelElement.getAttribute("tableType") == "layout") localDefaultBorder = {
                style: "none",
                color: "",
                width: ""
            };
            conversionApi.consumable.consume(viewItem, matcherPattern);
            const normalizedBorder = {
                style: viewItem.getNormalizedStyle("border-style"),
                color: viewItem.getNormalizedStyle("border-color"),
                width: viewItem.getNormalizedStyle("border-width")
            };
            if (hasTableBorderAttribute && conversionApi.consumable.test(viewTable, {
                attributes: "border"
            })) {
                const borderValue = parseFloat(viewTable.getAttribute("border") || "1");
                const borderPx = Number.isNaN(borderValue) || !Number.isFinite(borderValue) || borderValue < 0 || viewItem.name != "table" && borderValue > 1 ? "1px" : `${borderValue}px`;
                normalizedBorder.width = {
                    top: borderPx,
                    bottom: borderPx,
                    right: borderPx,
                    left: borderPx,
                    ...normalizedBorder.width || {}
                };
                if (viewItem.is("element", "table")) conversionApi.consumable.consume(viewTable, {
                    attributes: "border"
                });
            }
            const reducedBorder = {
                style: $f1b97c36043e973c$var$reduceBoxSidesValue(normalizedBorder.style),
                color: $f1b97c36043e973c$var$reduceBoxSidesValue(normalizedBorder.color),
                width: $f1b97c36043e973c$var$reduceBoxSidesValue(normalizedBorder.width)
            };
            if (reducedBorder.style !== localDefaultBorder.style) conversionApi.writer.setAttribute(modelAttributes.style, reducedBorder.style, modelElement);
            if (reducedBorder.color !== localDefaultBorder.color) conversionApi.writer.setAttribute(modelAttributes.color, reducedBorder.color, modelElement);
            if (reducedBorder.width !== localDefaultBorder.width) conversionApi.writer.setAttribute(modelAttributes.width, reducedBorder.width, modelElement);
        });
    });
}
/**
* Conversion helper for downcasting an attribute to a style.
*
* @internal
*/ function $f1b97c36043e973c$export$2140815f28869319(conversion, options) {
    const { modelElement: modelElement, modelAttribute: modelAttribute, styleName: styleName } = options;
    conversion.for("downcast").attributeToAttribute({
        model: {
            name: modelElement,
            key: modelAttribute
        },
        view: (modelAttributeValue)=>({
                key: "style",
                value: {
                    [styleName]: modelAttributeValue
                }
            })
    });
}
/**
* Conversion helper for downcasting attributes from the model table to a view table (not to `<figure>`).
*
* @internal
*/ function $f1b97c36043e973c$export$f7b72872f2c8e2ea(conversion, options) {
    const { modelAttribute: modelAttribute, styleName: styleName } = options;
    conversion.for("downcast").add((dispatcher)=>{
        dispatcher.on(`attribute:${modelAttribute}:table`, (evt, data, conversionApi)=>{
            const { item: item, attributeNewValue: attributeNewValue } = data;
            const { mapper: mapper, writer: writer } = conversionApi;
            if (!conversionApi.consumable.consume(data.item, evt.name)) return;
            const table = Array.from(mapper.toViewElement(item).getChildren()).find((child)=>child.is("element", "table"));
            if (attributeNewValue) writer.setStyle(styleName, attributeNewValue, table);
            else writer.removeStyle(styleName, table);
        });
    });
}
/**
* Returns the default value for table or table cell property adjusted for layout tables.
*
* @internal
*/ function $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, layoutTableDefault, data) {
    const modelElement = data.modelRange && (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(data.modelRange.getItems({
        shallow: true
    }));
    const tableElement = modelElement && modelElement.is("element") && modelElement.findAncestor("table", {
        includeSelf: true
    });
    if (tableElement && tableElement.getAttribute("tableType") === "layout") return layoutTableDefault;
    return defaultValue;
}
/**
* Reduces the full top, right, bottom, left object to a single string if all sides are equal.
* Returns original style otherwise.
*/ function $f1b97c36043e973c$var$reduceBoxSidesValue(style) {
    if (!style) return;
    const sides = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    if (!sides.every((side)=>style[side])) return style;
    const topSideStyle = style.top;
    if (!sides.every((side)=>style[side] === topSideStyle)) return style;
    return topSideStyle;
}
/**
* Conversion helper for upcasting the `cellpadding` table attribute.
*
* @param editor The editor instance.
* @param viewElementName The view element name that should be converted.
* @param defaultPadding The default padding value.
* @internal
*/ function $f1b97c36043e973c$var$upcastTableCellPaddingAttribute(editor, viewElementName, defaultPadding) {
    const { conversion: conversion } = editor;
    conversion.for("upcast").add((dispatcher)=>{
        dispatcher.on(`element:${viewElementName}`, (evt, data, conversionApi)=>{
            const { modelRange: modelRange, viewItem: viewItem } = data;
            if (!modelRange) return;
            if (viewItem.is("element", "table")) {
                conversionApi.consumable.consume(viewItem, {
                    attributes: "cellpadding"
                });
                return;
            }
            const viewTable = viewItem.findAncestor("table");
            if (!viewTable.hasAttribute("cellpadding") || !conversionApi.consumable.test(viewTable, {
                attributes: "cellpadding"
            })) return;
            const modelElement = modelRange?.start?.nodeAfter;
            const cellpaddingValue = parseFloat(viewTable.getAttribute("cellpadding") || "1");
            const cellpaddingPx = Number.isNaN(cellpaddingValue) || !Number.isFinite(cellpaddingValue) || cellpaddingValue < 0 ? "0px" : `${cellpaddingValue}px`;
            const tableCellPaddings = modelElement.getAttribute("tableCellPadding");
            if (!tableCellPaddings) {
                if (defaultPadding !== cellpaddingPx) conversionApi.writer.setAttribute("tableCellPadding", cellpaddingPx, modelElement);
            } else if (typeof tableCellPaddings === "object") {
                const normalizedPaddings = {
                    ...defaultPadding !== cellpaddingPx && {
                        top: cellpaddingPx
                    },
                    ...defaultPadding !== cellpaddingPx && {
                        right: cellpaddingPx
                    },
                    ...defaultPadding !== cellpaddingPx && {
                        bottom: cellpaddingPx
                    },
                    ...defaultPadding !== cellpaddingPx && {
                        left: cellpaddingPx
                    },
                    ...tableCellPaddings
                };
                conversionApi.writer.setAttribute("tableCellPadding", normalizedPaddings, modelElement);
            }
        }, {
            priority: "low"
        });
    });
}
/**
* Default table alignment options.
*/ const $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS = {
    left: {
        className: "table-style-align-left"
    },
    center: {
        className: "table-style-align-center"
    },
    right: {
        className: "table-style-align-right"
    },
    blockLeft: {
        className: "table-style-block-align-left"
    },
    blockRight: {
        className: "table-style-block-align-right"
    }
};
/**
* Configuration for upcasting table alignment from view to model.
*/ const $f1b97c36043e973c$var$upcastTableAlignmentConfig = [
    {
        view: {
            name: /^(table|figure)$/,
            styles: {
                float: $f1b97c36043e973c$var$FLOAT_VALUES_REG_EXP
            }
        },
        getAlign: (viewElement)=>{
            let align = viewElement.getStyle("float");
            if (align === "none") align = "center";
            return align;
        },
        getConsumables (viewElement) {
            const float = viewElement.getStyle("float");
            const styles = [
                "float"
            ];
            if (float === "left" && viewElement.hasStyle("margin-right")) styles.push("margin-right");
            else if (float === "right" && viewElement.hasStyle("margin-left")) styles.push("margin-left");
            return {
                styles: styles
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            styles: {
                "margin-left": "auto",
                "margin-right": "auto"
            }
        },
        getAlign: ()=>"center",
        getConsumables: ()=>{
            return {
                styles: [
                    "margin-left",
                    "margin-right"
                ]
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            key: "class",
            value: "table-style-align-left"
        },
        getAlign: ()=>"left",
        getConsumables () {
            return {
                classes: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.left.className
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            key: "class",
            value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.right.className
        },
        getAlign: ()=>"right",
        getConsumables () {
            return {
                classes: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.right.className
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            key: "class",
            value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.center.className
        },
        getAlign: ()=>"center",
        getConsumables () {
            return {
                classes: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.center.className
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            key: "class",
            value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockLeft.className
        },
        getAlign: ()=>"blockLeft",
        getConsumables () {
            return {
                classes: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockLeft.className
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            key: "class",
            value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockRight.className
        },
        getAlign: ()=>"blockRight",
        getConsumables () {
            return {
                classes: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockRight.className
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            styles: {
                "margin-left": "0",
                "margin-right": "auto"
            }
        },
        getAlign: ()=>"blockLeft",
        getConsumables () {
            return {
                styles: [
                    "margin-left",
                    "margin-right"
                ]
            };
        }
    },
    {
        view: {
            name: /^(table|figure)$/,
            styles: {
                "margin-left": "auto",
                "margin-right": "0"
            }
        },
        getAlign: ()=>"blockRight",
        getConsumables () {
            return {
                styles: [
                    "margin-left",
                    "margin-right"
                ]
            };
        }
    },
    {
        view: {
            name: "table",
            attributes: {
                align: $f1b97c36043e973c$var$ALIGN_VALUES_REG_EXP$1
            }
        },
        getAlign: (viewElement)=>viewElement.getAttribute("align"),
        getConsumables () {
            return {
                attributes: "align"
            };
        }
    }
];
const $f1b97c36043e973c$var$downcastTableAlignmentConfig = {
    center: {
        align: "center",
        style: "margin-left: auto; margin-right: auto;",
        className: "table-style-align-center"
    },
    left: {
        align: "left",
        style: "float: left;",
        className: "table-style-align-left"
    },
    right: {
        align: "right",
        style: "float: right;",
        className: "table-style-align-right"
    },
    blockLeft: {
        align: void 0,
        style: "margin-left: 0; margin-right: auto;",
        className: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockLeft.className
    },
    blockRight: {
        align: void 0,
        style: "margin-left: auto; margin-right: 0;",
        className: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockRight.className
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table iterator class. It allows to iterate over table cells. For each cell the iterator yields
* {@link module:table/tablewalker~TableSlot} with proper table cell attributes.
*/ var $f1b97c36043e973c$export$6c270156410e802f = class {
    /**
	* The walker's table element.
	*
	* @internal
	*/ _table;
    /**
	* A row index from which this iterator will start.
	*/ _startRow;
    /**
	* A row index at which this iterator will end.
	*/ _endRow;
    /**
	* If set, the table walker will only output cells from a given column and following ones or cells that overlap them.
	*/ _startColumn;
    /**
	* If set, the table walker will only output cells up to a given column.
	*/ _endColumn;
    /**
	* Enables output of spanned cells that are normally not yielded.
	*/ _includeAllSlots;
    /**
	* Row indexes to skip from the iteration.
	*/ _skipRows;
    /**
	* The current row index.
	*
	* @internal
	*/ _row;
    /**
	* The index of the current row element in the table.
	*
	* @internal
	*/ _rowIndex;
    /**
	* The current column index.
	*
	* @internal
	*/ _column;
    /**
	* The cell index in a parent row. For spanned cells when {@link #_includeAllSlots} is set to `true`,
	* this represents the index of the next table cell.
	*
	* @internal
	*/ _cellIndex;
    /**
	* Holds a map of spanned cells in a table.
	*/ _spannedCells;
    /**
	* Index of the next column where a cell is anchored.
	*/ _nextCellAtColumn;
    /**
	* Indicates whether the iterator jumped to (or close to) the start row, ignoring rows that don't need to be traversed.
	*/ _jumpedToStartRow = false;
    /**
	* Creates an instance of the table walker.
	*
	* The table walker iterates internally by traversing the table from row index = 0 and column index = 0.
	* It walks row by row and column by column in order to output values defined in the constructor.
	* By default it will output only the locations that are occupied by a cell. To include also spanned rows and columns,
	* pass the `includeAllSlots` option to the constructor.
	*
	* The most important values of the iterator are column and row indexes of a cell.
	*
	* See {@link module:table/tablewalker~TableSlot} what values are returned by the table walker.
	*
	* To iterate over a given row:
	*
	* ```ts
	* const tableWalker = new TableWalker( table, { startRow: 1, endRow: 2 } );
	*
	* for ( const tableSlot of tableWalker ) {
	*   console.log( 'A cell at row', tableSlot.row, 'and column', tableSlot.column );
	* }
	* ```
	*
	* For instance the code above for the following table:
	*
	*  +----+----+----+----+----+----+
	*  | 00      | 02 | 03 | 04 | 05 |
	*  |         +----+----+----+----+
	*  |         | 12      | 14 | 15 |
	*  |         +----+----+----+    +
	*  |         | 22           |    |
	*  |----+----+----+----+----+    +
	*  | 30 | 31 | 32 | 33 | 34 |    |
	*  +----+----+----+----+----+----+
	*
	* will log in the console:
	*
	*  'A cell at row 1 and column 2'
	*  'A cell at row 1 and column 4'
	*  'A cell at row 1 and column 5'
	*  'A cell at row 2 and column 2'
	*
	* To also iterate over spanned cells:
	*
	* ```ts
	* const tableWalker = new TableWalker( table, { row: 1, includeAllSlots: true } );
	*
	* for ( const tableSlot of tableWalker ) {
	*   console.log( 'Slot at', tableSlot.row, 'x', tableSlot.column, ':', tableSlot.isAnchor ? 'is anchored' : 'is spanned' );
	* }
	* ```
	*
	* will log in the console for the table from the previous example:
	*
	*  'Cell at 1 x 0 : is spanned'
	*  'Cell at 1 x 1 : is spanned'
	*  'Cell at 1 x 2 : is anchored'
	*  'Cell at 1 x 3 : is spanned'
	*  'Cell at 1 x 4 : is anchored'
	*  'Cell at 1 x 5 : is anchored'
	*
	* **Note**: Option `row` is a shortcut that sets both `startRow` and `endRow` to the same row.
	* (Use either `row` or `startRow` and `endRow` but never together). Similarly the `column` option sets both `startColumn`
	* and `endColumn` to the same column (Use either `column` or `startColumn` and `endColumn` but never together).
	*
	* @param table A table over which the walker iterates.
	* @param options An object with configuration.
	* @param options.row A row index for which this iterator will output cells. Can't be used together with `startRow` and `endRow`.
	* @param options.startRow A row index from which this iterator should start. Can't be used together with `row`. Default value is 0.
	* @param options.endRow A row index at which this iterator should end. Can't be used together with `row`.
	* @param options.column A column index for which this iterator will output cells.
	* Can't be used together with `startColumn` and `endColumn`.
	* @param options.startColumn A column index from which this iterator should start.
	* Can't be used together with `column`. Default value is 0.
	* @param options.endColumn A column index at which this iterator should end. Can't be used together with `column`.
	* @param options.includeAllSlots Also return values for spanned cells. Default value is "false".
	*/ constructor(table, options = {}){
        this._table = table;
        this._startRow = options.row !== void 0 ? options.row : options.startRow || 0;
        this._endRow = options.row !== void 0 ? options.row : options.endRow;
        this._startColumn = options.column !== void 0 ? options.column : options.startColumn || 0;
        this._endColumn = options.column !== void 0 ? options.column : options.endColumn;
        this._includeAllSlots = !!options.includeAllSlots;
        this._skipRows = /* @__PURE__ */ new Set();
        this._row = 0;
        this._rowIndex = 0;
        this._column = 0;
        this._cellIndex = 0;
        this._spannedCells = /* @__PURE__ */ new Map();
        this._nextCellAtColumn = -1;
    }
    /**
	* Iterable interface.
	*/ [Symbol.iterator]() {
        return this;
    }
    /**
	* Gets the next table walker's value.
	*
	* @returns The next table walker's value.
	*/ next() {
        if (this._canJumpToStartRow()) this._jumpToNonSpannedRowClosestToStartRow();
        const row = this._table.getChild(this._rowIndex);
        if (!row || this._isOverEndRow()) return {
            done: true,
            value: void 0
        };
        if (!row.is("element", "tableRow")) {
            this._rowIndex++;
            return this.next();
        }
        if (this._isOverEndColumn()) return this._advanceToNextRow();
        let outValue = null;
        const spanData = this._getSpanned();
        if (spanData) {
            if (this._includeAllSlots && !this._shouldSkipSlot()) outValue = this._formatOutValue(spanData.cell, spanData.row, spanData.column);
        } else {
            const cell = row.getChild(this._cellIndex);
            if (!cell) return this._advanceToNextRow();
            const colspan = parseInt(cell.getAttribute("colspan") || "1");
            const rowspan = parseInt(cell.getAttribute("rowspan") || "1");
            if (colspan > 1 || rowspan > 1) this._recordSpans(cell, rowspan, colspan);
            if (!this._shouldSkipSlot()) outValue = this._formatOutValue(cell);
            this._nextCellAtColumn = this._column + colspan;
        }
        this._column++;
        if (this._column == this._nextCellAtColumn) this._cellIndex++;
        return outValue || this.next();
    }
    /**
	* Marks a row to skip in the next iteration. It will also skip cells from the current row if there are any cells from the current row
	* to output.
	*
	* @param row The row index to skip.
	*/ skipRow(row) {
        this._skipRows.add(row);
    }
    /**
	* Advances internal cursor to the next row.
	*/ _advanceToNextRow() {
        this._row++;
        this._rowIndex++;
        this._column = 0;
        this._cellIndex = 0;
        this._nextCellAtColumn = -1;
        return this.next();
    }
    /**
	* Checks if the current row is over {@link #_endRow}.
	*/ _isOverEndRow() {
        return this._endRow !== void 0 && this._row > this._endRow;
    }
    /**
	* Checks if the current cell is over {@link #_endColumn}
	*/ _isOverEndColumn() {
        return this._endColumn !== void 0 && this._column > this._endColumn;
    }
    /**
	* A common method for formatting the iterator's output value.
	*
	* @param cell The table cell to output.
	* @param anchorRow The row index of a cell anchor slot.
	* @param anchorColumn The column index of a cell anchor slot.
	*/ _formatOutValue(cell, anchorRow = this._row, anchorColumn = this._column) {
        return {
            done: false,
            value: new $f1b97c36043e973c$export$f5a51e638805e4bf(this, cell, anchorRow, anchorColumn)
        };
    }
    /**
	* Checks if the current slot should be skipped.
	*/ _shouldSkipSlot() {
        const rowIsMarkedAsSkipped = this._skipRows.has(this._row);
        const rowIsBeforeStartRow = this._row < this._startRow;
        const columnIsBeforeStartColumn = this._column < this._startColumn;
        const columnIsAfterEndColumn = this._endColumn !== void 0 && this._column > this._endColumn;
        return rowIsMarkedAsSkipped || rowIsBeforeStartRow || columnIsBeforeStartColumn || columnIsAfterEndColumn;
    }
    /**
	* Returns the cell element that is spanned over the current cell location.
	*/ _getSpanned() {
        const rowMap = this._spannedCells.get(this._row);
        if (!rowMap) return null;
        return rowMap.get(this._column) || null;
    }
    /**
	* Updates spanned cells map relative to the current cell location and its span dimensions.
	*
	* @param cell A cell that is spanned.
	* @param rowspan Cell height.
	* @param colspan Cell width.
	*/ _recordSpans(cell, rowspan, colspan) {
        const data = {
            cell: cell,
            row: this._row,
            column: this._column
        };
        for(let rowToUpdate = this._row; rowToUpdate < this._row + rowspan; rowToUpdate++)for(let columnToUpdate = this._column; columnToUpdate < this._column + colspan; columnToUpdate++)if (rowToUpdate != this._row || columnToUpdate != this._column) this._markSpannedCell(rowToUpdate, columnToUpdate, data);
    }
    /**
	* Marks the cell location as spanned by another cell.
	*
	* @param row The row index of the cell location.
	* @param column The column index of the cell location.
	* @param data A spanned cell details (cell element, anchor row and column).
	*/ _markSpannedCell(row, column, data) {
        if (!this._spannedCells.has(row)) this._spannedCells.set(row, /* @__PURE__ */ new Map());
        this._spannedCells.get(row).set(column, data);
    }
    /**
	* Checks if part of the table can be skipped.
	*/ _canJumpToStartRow() {
        return !!this._startRow && this._startRow > 0 && !this._jumpedToStartRow;
    }
    /**
	* Sets the current row to `this._startRow` or the first row before it that has the number of cells
	* equal to the number of columns in the table.
	*
	* Example:
	* 	+----+----+----+
	*  | 00 | 01 | 02 |
	*  |----+----+----+
	*  | 10      | 12 |
	*  |         +----+
	*  |         | 22 |
	*  |         +----+
	*  |         | 32 | <--- Start row
	*  +----+----+----+
	*  | 40 | 41 | 42 |
	*  +----+----+----+
	*
	* If the 4th row is a `this._startRow`, this method will:
	* 1.) Count the number of columns this table has based on the first row (3 columns in this case).
	* 2.) Check if the 4th row contains 3 cells. It doesn't, so go to the row before it.
	* 3.) Check if the 3rd row contains 3 cells. It doesn't, so go to the row before it.
	* 4.) Check if the 2nd row contains 3 cells. It does, so set the current row to that row.
	*
	* Setting the current row this way is necessary to let the `next()`  method loop over the cells
	* spanning multiple rows or columns and update the `this._spannedCells` property.
	*/ _jumpToNonSpannedRowClosestToStartRow() {
        const firstRowLength = this._getRowLength(0);
        for(let i = this._startRow; !this._jumpedToStartRow; i--)if (firstRowLength === this._getRowLength(i)) {
            this._row = i;
            this._rowIndex = i;
            this._jumpedToStartRow = true;
        }
    }
    /**
	* Returns a number of columns in a row taking `colspan` into consideration.
	*/ _getRowLength(rowIndex) {
        return [
            ...this._table.getChild(rowIndex).getChildren()
        ].reduce((cols, row)=>{
            return cols + parseInt(row.getAttribute("colspan") || "1");
        }, 0);
    }
};
/**
* An object returned by {@link module:table/tablewalker~TableWalker} when traversing table cells.
*/ var $f1b97c36043e973c$export$f5a51e638805e4bf = class {
    /**
	* The current table cell.
	*/ cell;
    /**
	* The row index of a table slot.
	*/ row;
    /**
	* The column index of a table slot.
	*/ column;
    /**
	* The row index of a cell anchor slot.
	*/ cellAnchorRow;
    /**
	* The column index of a cell anchor slot.
	*/ cellAnchorColumn;
    /**
	* The index of the current cell in the parent row.
	*/ _cellIndex;
    /**
	* The index of the current row element in the table.
	*/ _rowIndex;
    /**
	* The table element.
	*/ _table;
    /**
	* Creates an instance of the table walker value.
	*
	* @param tableWalker The table walker instance.
	* @param cell The current table cell.
	* @param anchorRow The row index of a cell anchor slot.
	* @param anchorColumn The column index of a cell anchor slot.
	*/ constructor(tableWalker, cell, anchorRow, anchorColumn){
        this.cell = cell;
        this.row = tableWalker._row;
        this.column = tableWalker._column;
        this.cellAnchorRow = anchorRow;
        this.cellAnchorColumn = anchorColumn;
        this._cellIndex = tableWalker._cellIndex;
        this._rowIndex = tableWalker._rowIndex;
        this._table = tableWalker._table;
    }
    /**
	* Whether the cell is anchored in the current slot.
	*/ get isAnchor() {
        return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
    }
    /**
	* The width of a cell defined by a `colspan` attribute. If the model attribute is not present, it is set to `1`.
	*/ get cellWidth() {
        return parseInt(this.cell.getAttribute("colspan") || "1");
    }
    /**
	* The height of a cell defined by a `rowspan` attribute. If the model attribute is not present, it is set to `1`.
	*/ get cellHeight() {
        return parseInt(this.cell.getAttribute("rowspan") || "1");
    }
    /**
	* The index of the current row element in the table.
	*/ get rowIndex() {
        return this._rowIndex;
    }
    /**
	* Returns the {@link module:engine/model/position~ModelPosition} before the table slot.
	*/ getPositionBefore() {
        return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
    }
};
/**
* This `TableSlot`'s getter (property) was removed in CKEditor 5 v20.0.0.
*
* Check out the new `TableWalker`'s API in the documentation.
*
* @error tableslot-getter-removed
* @param getterName
*/ /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Checks if the given cell type represents a header cell.
*
* @param cellType The type of the table cell.
* @returns `true` if the cell type represents a header cell, `false` otherwise.
*/ function $f1b97c36043e973c$export$2d92a71c9e04bd6b(cellType) {
    return cellType === "header" || cellType === "header-row" || cellType === "header-column";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A common method to update the numeric value. If a value is the default one, it will be unset.
*
* @internal
* @param key An attribute key.
* @param value The new attribute value.
* @param item A model item on which the attribute will be set.
* @param defaultValue The default attribute value. If a value is lower or equal, it will be unset.
*/ function $f1b97c36043e973c$export$fd08c984b28fd00a(key, value, item, writer, defaultValue = 1) {
    if (value !== void 0 && value !== null && defaultValue !== void 0 && defaultValue !== null && value > defaultValue) writer.setAttribute(key, value, item);
    else writer.removeAttribute(key, item);
}
/**
* A common method to create an empty table cell. It creates a proper model structure as a table cell must have at least one block inside.
*
* @internal
* @param writer The model writer.
* @param insertPosition The position at which the table cell should be inserted.
* @param attributes The element attributes.
* @returns Created table cell.
*/ function $f1b97c36043e973c$export$6912bf35f0593a83(writer, insertPosition, attributes = {}) {
    const tableCell = writer.createElement("tableCell", attributes);
    writer.insertElement("paragraph", tableCell);
    writer.insert(tableCell, insertPosition);
    return tableCell;
}
/**
* Checks if a table cell belongs to the heading column section.
*
* @internal
*/ function $f1b97c36043e973c$export$af1346de080b7559(tableUtils, tableCell) {
    const table = tableCell.parent.parent;
    const headingColumns = parseInt(table.getAttribute("headingColumns") || "0");
    const { column: column } = tableUtils.getCellLocation(tableCell);
    return !!headingColumns && column < headingColumns;
}
/**
* Enables conversion for an attribute for simple view-model mappings.
*
* @internal
* @param options.defaultValue The default value for the specified `modelAttribute`.
*/ function $f1b97c36043e973c$export$4a7d23a24c55b64d(schema, conversion, options) {
    const { modelAttribute: modelAttribute } = options;
    schema.extend("tableCell", {
        allowAttributes: [
            modelAttribute
        ]
    });
    schema.setAttributeProperties(modelAttribute, {
        isFormatting: true
    });
    $f1b97c36043e973c$export$d738fe580628bde5(conversion, {
        viewElement: /^(td|th)$/,
        ...options
    });
    $f1b97c36043e973c$export$2140815f28869319(conversion, {
        modelElement: "tableCell",
        ...options
    });
}
/**
* Depending on the position of the selection we either return the table under cursor or look for the table higher in the hierarchy.
*
* @internal
*/ function $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection) {
    const selectedElement = selection.getSelectedElement();
    if (selectedElement && selectedElement.is("element", "table")) return selectedElement;
    return selection.getFirstPosition().findAncestor("table");
}
/**
* Groups table cells by their parent table.
*
* @internal
*/ function $f1b97c36043e973c$var$groupCellsByTable(tableCells) {
    const tableMap = /* @__PURE__ */ new Map();
    for (const tableCell of tableCells){
        const table = tableCell.findAncestor("table");
        if (!tableMap.has(table)) tableMap.set(table, []);
        tableMap.get(table).push(tableCell);
    }
    return tableMap;
}
/**
* Checks if all cells in a given row or column are header cells.
*
* @internal
*/ function $f1b97c36043e973c$var$isEntireCellsLineHeader({ table: table, row: row, column: column }) {
    const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
        row: row,
        column: column
    });
    for (const { cell: cell } of tableWalker){
        const cellType = cell.getAttribute("tableCellType");
        if (!$f1b97c36043e973c$export$2d92a71c9e04bd6b(cellType)) return false;
    }
    return true;
}
/**
* Checks whether the `tableCellType` attribute is enabled in the editor schema and the experimental flag is set.
*
* @internal
*/ function $f1b97c36043e973c$var$isTableCellTypeEnabled(editor) {
    return editor.model.schema.checkAttribute("tableCell", "tableCellType");
}
/**
* Yields every empty block (typically a `paragraph`) found inside the given table's cells.
*
* @internal
*/ function* $f1b97c36043e973c$var$getEmptyTableCellBlocks(table) {
    for (const row of table.getChildren()){
        if (!row.is("element", "tableRow")) continue;
        for (const cell of row.getChildren()){
            if (!cell.is("element", "tableCell")) continue;
            for (const block of cell.getChildren())if (block.is("element") && block.isEmpty) yield block;
        }
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a cropped table according to given dimensions.

* To return a cropped table that starts at first row and first column and end in third row and column:
*
* ```ts
* const croppedTable = cropTableToDimensions( table, {
*   startRow: 1,
*   endRow: 3,
*   startColumn: 1,
*   endColumn: 3
* }, writer );
* ```
*
* Calling the code above for the table below:
*
*        0   1   2   3   4                      0   1   2
*      ┌───┬───┬───┬───┬───┐
*   0  │ a │ b │ c │ d │ e │
*      ├───┴───┤   ├───┴───┤                  ┌───┬───┬───┐
*   1  │ f     │   │ g     │                  │   │   │ g │  0
*      ├───┬───┴───┼───┬───┤   will return:   ├───┴───┼───┤
*   2  │ h │ i     │ j │ k │                  │ i     │ j │  1
*      ├───┤       ├───┤   │                  │       ├───┤
*   3  │ l │       │ m │   │                  │       │ m │  2
*      ├───┼───┬───┤   ├───┤                  └───────┴───┘
*   4  │ n │ o │ p │   │ q │
*      └───┴───┴───┴───┴───┘
*
* @internal
*/ function $f1b97c36043e973c$export$4fd6c7e514948ca9(sourceTable, cropDimensions, writer) {
    const { startRow: startRow, startColumn: startColumn, endRow: endRow, endColumn: endColumn } = cropDimensions;
    const croppedTable = writer.createElement("table");
    const sourceTableType = sourceTable.getAttribute("tableType");
    if (sourceTableType) writer.setAttribute("tableType", sourceTableType, croppedTable);
    const cropHeight = endRow - startRow + 1;
    for(let i = 0; i < cropHeight; i++)writer.insertElement("tableRow", croppedTable, "end");
    const tableMap = [
        ...new $f1b97c36043e973c$export$6c270156410e802f(sourceTable, {
            startRow: startRow,
            endRow: endRow,
            startColumn: startColumn,
            endColumn: endColumn,
            includeAllSlots: true
        })
    ];
    for (const { row: sourceRow, column: sourceColumn, cell: tableCell, isAnchor: isAnchor, cellAnchorRow: cellAnchorRow, cellAnchorColumn: cellAnchorColumn } of tableMap){
        const rowInCroppedTable = sourceRow - startRow;
        const row = croppedTable.getChild(rowInCroppedTable);
        if (!isAnchor) {
            if (cellAnchorRow < startRow || cellAnchorColumn < startColumn) $f1b97c36043e973c$export$6912bf35f0593a83(writer, writer.createPositionAt(row, "end"));
        } else {
            const tableCellCopy = writer.cloneElement(tableCell);
            writer.append(tableCellCopy, row);
            $f1b97c36043e973c$export$482c6ce78bd60281(tableCellCopy, sourceRow, sourceColumn, endRow, endColumn, writer);
        }
    }
    $f1b97c36043e973c$var$addHeadingsToCroppedTable(croppedTable, sourceTable, startRow, startColumn, writer);
    $f1b97c36043e973c$var$addFootersToCroppedTable(croppedTable, sourceTable, startRow, endRow, writer);
    return croppedTable;
}
/**
* Returns slot info of cells that starts above and overlaps a given row.
*
* In a table below, passing `overlapRow = 3`
*
*     ┌───┬───┬───┬───┬───┐
*  0  │ a │ b │ c │ d │ e │
*     │   ├───┼───┼───┼───┤
*  1  │   │ f │ g │ h │ i │
*     ├───┤   ├───┼───┤   │
*  2  │ j │   │ k │ l │   │
*     │   │   │   ├───┼───┤
*  3  │   │   │   │ m │ n │  <- overlap row to check
*     ├───┼───┤   │   ├───│
*  4  │ o │ p │   │   │ q │
*     └───┴───┴───┴───┴───┘
*
* will return slot info for cells: "j", "f", "k".
*
* @internal
* @param table The table to check.
* @param overlapRow The index of the row to check.
* @param startRow row to start analysis. Use it when it is known that the cells above that row will not overlap. Default value is 0.
*/ function $f1b97c36043e973c$export$fe40d87a82c3f66b(table, overlapRow, startRow = 0) {
    const cells = [];
    const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
        startRow: startRow,
        endRow: overlapRow - 1
    });
    for (const slotInfo of tableWalker){
        const { row: row, cellHeight: cellHeight } = slotInfo;
        const cellEndRow = row + cellHeight - 1;
        if (row < overlapRow && overlapRow <= cellEndRow) cells.push(slotInfo);
    }
    return cells;
}
/**
* Splits the table cell horizontally.
*
* @internal
* @returns Created table cell, if any were created.
*/ function $f1b97c36043e973c$export$a6095ae3c4be1312(tableCell, splitRow, writer) {
    const tableRow = tableCell.parent;
    const table = tableRow.parent;
    const rowIndex = tableRow.index;
    const rowspan = parseInt(tableCell.getAttribute("rowspan"));
    const newRowspan = splitRow - rowIndex;
    const newCellAttributes = {};
    const newCellRowSpan = rowspan - newRowspan;
    if (newCellRowSpan > 1) newCellAttributes.rowspan = newCellRowSpan;
    const colspan = parseInt(tableCell.getAttribute("colspan") || "1");
    if (colspan > 1) newCellAttributes.colspan = colspan;
    const startRow = rowIndex;
    const endRow = startRow + newRowspan;
    const tableMap = [
        ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
            startRow: startRow,
            endRow: endRow,
            includeAllSlots: true
        })
    ];
    let newCell = null;
    let columnIndex;
    for (const tableSlot of tableMap){
        const { row: row, column: column, cell: cell } = tableSlot;
        if (cell === tableCell && columnIndex === void 0) columnIndex = column;
        if (columnIndex !== void 0 && columnIndex === column && row === endRow) newCell = $f1b97c36043e973c$export$6912bf35f0593a83(writer, tableSlot.getPositionBefore(), newCellAttributes);
    }
    $f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", newRowspan, tableCell, writer);
    return newCell;
}
/**
* Returns slot info of cells that starts before and overlaps a given column.
*
* In a table below, passing `overlapColumn = 3`
*
*    0   1   2   3   4
*  ┌───────┬───────┬───┐
*  │ a     │ b     │ c │
*  │───┬───┴───────┼───┤
*  │ d │ e         │ f │
*  ├───┼───┬───────┴───┤
*  │ g │ h │ i         │
*  ├───┼───┼───┬───────┤
*  │ j │ k │ l │ m     │
*  ├───┼───┴───┼───┬───┤
*  │ n │ o     │ p │ q │
*  └───┴───────┴───┴───┘
*                ^
*                Overlap column to check
*
* will return slot info for cells: "b", "e", "i".
*
* @internal
* @param table The table to check.
* @param overlapColumn The index of the column to check.
*/ function $f1b97c36043e973c$export$3c25e8e245f1d08c(table, overlapColumn) {
    const cellsToSplit = [];
    const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table);
    for (const slotInfo of tableWalker){
        const { column: column, cellWidth: cellWidth } = slotInfo;
        const cellEndColumn = column + cellWidth - 1;
        if (column < overlapColumn && overlapColumn <= cellEndColumn) cellsToSplit.push(slotInfo);
    }
    return cellsToSplit;
}
/**
* Splits the table cell vertically.
*
* @internal
* @param columnIndex The table cell column index.
* @param splitColumn The index of column to split cell on.
* @returns Created table cell.
*/ function $f1b97c36043e973c$export$da7153964952c988(tableCell, columnIndex, splitColumn, writer) {
    const colspan = parseInt(tableCell.getAttribute("colspan"));
    const newColspan = splitColumn - columnIndex;
    const newCellAttributes = {};
    const newCellColSpan = colspan - newColspan;
    if (newCellColSpan > 1) newCellAttributes.colspan = newCellColSpan;
    const rowspan = parseInt(tableCell.getAttribute("rowspan") || "1");
    if (rowspan > 1) newCellAttributes.rowspan = rowspan;
    const newCell = $f1b97c36043e973c$export$6912bf35f0593a83(writer, writer.createPositionAfter(tableCell), newCellAttributes);
    $f1b97c36043e973c$export$fd08c984b28fd00a("colspan", newColspan, tableCell, writer);
    return newCell;
}
/**
* Adjusts table cell dimensions to not exceed limit row and column.
*
* If table cell width (or height) covers a column (or row) that is after a limit column (or row)
* this method will trim "colspan" (or "rowspan") attribute so the table cell will fit in a defined limits.
*
* @internal
*/ function $f1b97c36043e973c$export$482c6ce78bd60281(tableCell, cellRow, cellColumn, limitRow, limitColumn, writer) {
    const colspan = parseInt(tableCell.getAttribute("colspan") || "1");
    const rowspan = parseInt(tableCell.getAttribute("rowspan") || "1");
    if (cellColumn + colspan - 1 > limitColumn) {
        const trimmedSpan = limitColumn - cellColumn + 1;
        $f1b97c36043e973c$export$fd08c984b28fd00a("colspan", trimmedSpan, tableCell, writer, 1);
    }
    if (cellRow + rowspan - 1 > limitRow) {
        const trimmedSpan = limitRow - cellRow + 1;
        $f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", trimmedSpan, tableCell, writer, 1);
    }
}
/**
* Sets proper heading attributes to a cropped table.
*/ function $f1b97c36043e973c$var$addHeadingsToCroppedTable(croppedTable, sourceTable, startRow, startColumn, writer) {
    const headingRows = parseInt(sourceTable.getAttribute("headingRows") || "0");
    if (headingRows > 0) {
        const headingRowsInCrop = headingRows - startRow;
        $f1b97c36043e973c$export$fd08c984b28fd00a("headingRows", headingRowsInCrop, croppedTable, writer, 0);
    }
    const headingColumns = parseInt(sourceTable.getAttribute("headingColumns") || "0");
    if (headingColumns > 0) {
        const headingColumnsInCrop = headingColumns - startColumn;
        $f1b97c36043e973c$export$fd08c984b28fd00a("headingColumns", headingColumnsInCrop, croppedTable, writer, 0);
    }
}
/**
* Sets footer row attributes to a cropped table.
*/ function $f1b97c36043e973c$var$addFootersToCroppedTable(croppedTable, sourceTable, startRow, endRow, writer) {
    const maxRows = Array.from(sourceTable.getChildren()).reduce((count, row)=>row.is("element", "tableRow") ? count + 1 : count, 0);
    const footerRows = parseInt(sourceTable.getAttribute("footerRows") || "0");
    const footerIndex = maxRows - footerRows;
    if (footerRows < 1) return;
    let footerRowsInCrop = 0;
    if (endRow >= footerIndex) footerRowsInCrop = endRow - Math.max(footerIndex, startRow) + 1;
    $f1b97c36043e973c$export$fd08c984b28fd00a("footerRows", footerRowsInCrop, croppedTable, writer, 0);
}
/**
* Removes columns that have no cells anchored.
*
* In table below:
*
*     +----+----+----+----+----+----+----+
*     | 00 | 01      | 03 | 04      | 06 |
*     +----+----+----+----+         +----+
*     | 10 | 11      | 13 |         | 16 |
*     +----+----+----+----+----+----+----+
*     | 20 | 21      | 23 | 24      | 26 |
*     +----+----+----+----+----+----+----+
*                  ^--- empty ---^
*
* Will remove columns 2 and 5.
*
* **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
* To remove a column from a table use {@link module:table/tableutils~TableUtils#removeColumns `TableUtils.removeColumns()`}.
*
* @internal
* @returns True if removed some columns.
*/ function $f1b97c36043e973c$export$866099f77e94f777(table, tableUtils) {
    const width = tableUtils.getColumns(table);
    const columnsMap = new Array(width).fill(0);
    for (const { column: column } of new $f1b97c36043e973c$export$6c270156410e802f(table))columnsMap[column]++;
    const emptyColumns = columnsMap.reduce((result, cellsCount, column)=>{
        return cellsCount ? result : [
            ...result,
            column
        ];
    }, []);
    if (emptyColumns.length > 0) {
        const emptyColumn = emptyColumns[emptyColumns.length - 1];
        tableUtils.removeColumns(table, {
            at: emptyColumn
        });
        return true;
    }
    return false;
}
/**
* Removes rows that have no cells anchored.
*
* In table below:
*
*     +----+----+----+
*     | 00 | 01 | 02 |
*     +----+----+----+
*     | 10 | 11 | 12 |
*     +    +    +    +
*     |    |    |    | <-- empty
*     +----+----+----+
*     | 30 | 31 | 32 |
*     +----+----+----+
*     | 40      | 42 |
*     +         +    +
*     |         |    | <-- empty
*     +----+----+----+
*     | 60 | 61 | 62 |
*     +----+----+----+
*
* Will remove rows 2 and 5.
*
* **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
* To remove a row from a table use {@link module:table/tableutils~TableUtils#removeRows `TableUtils.removeRows()`}.
*
* @internal
* @returns True if removed some rows.
*/ function $f1b97c36043e973c$export$68f82b103583321d(table, tableUtils) {
    const emptyRows = [];
    const tableRowCount = tableUtils.getRows(table);
    for(let rowIndex = 0; rowIndex < tableRowCount; rowIndex++)if (table.getChild(rowIndex).isEmpty) emptyRows.push(rowIndex);
    if (emptyRows.length > 0) {
        const emptyRow = emptyRows[emptyRows.length - 1];
        tableUtils.removeRows(table, {
            at: emptyRow
        });
        return true;
    }
    return false;
}
/**
* Removes rows and columns that have no cells anchored.
*
* In table below:
*
*     +----+----+----+----+
*     | 00      | 02      |
*     +----+----+         +
*     | 10      |         |
*     +----+----+----+----+
*     | 20      | 22 | 23 |
*     +         +    +    +
*     |         |    |    | <-- empty row
*     +----+----+----+----+
*             ^--- empty column
*
* Will remove row 3 and column 1.
*
* **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
* To remove a rows from a table use {@link module:table/tableutils~TableUtils#removeRows `TableUtils.removeRows()`} and
* {@link module:table/tableutils~TableUtils#removeColumns `TableUtils.removeColumns()`} to remove a column.
*
* @internal
*/ function $f1b97c36043e973c$export$5ef8873941f24b00(table, tableUtils) {
    if (!$f1b97c36043e973c$export$866099f77e94f777(table, tableUtils)) $f1b97c36043e973c$export$68f82b103583321d(table, tableUtils);
}
/**
* Returns adjusted last row index if selection covers part of a row with empty slots (spanned by other cells).
* The `dimensions.lastRow` is equal to last row index but selection might be bigger.
*
* This happens *only* on rectangular selection so we analyze a case like this:
*
*        +---+---+---+---+
*      0 | a | b | c | d |
*        +   +   +---+---+
*      1 |   | e | f | g |
*        +   +---+   +---+
*      2 |   | h |   | i | <- last row, each cell has rowspan = 2,
*        +   +   +   +   +    so we need to return 3, not 2
*      3 |   |   |   |   |
*        +---+---+---+---+
*
* @internal
* @returns Adjusted last row index.
*/ function $f1b97c36043e973c$export$abc118df6412c45a(table, dimensions) {
    const lastRowMap = Array.from(new $f1b97c36043e973c$export$6c270156410e802f(table, {
        startColumn: dimensions.firstColumn,
        endColumn: dimensions.lastColumn,
        row: dimensions.lastRow
    }));
    if (lastRowMap.every(({ cellHeight: cellHeight })=>cellHeight === 1)) return dimensions.lastRow;
    const rowspanAdjustment = lastRowMap[0].cellHeight - 1;
    return dimensions.lastRow + rowspanAdjustment;
}
/**
* Returns adjusted last column index if selection covers part of a column with empty slots (spanned by other cells).
* The `dimensions.lastColumn` is equal to last column index but selection might be bigger.
*
* This happens *only* on rectangular selection so we analyze a case like this:
*
*       0   1   2   3
*     +---+---+---+---+
*     | a             |
*     +---+---+---+---+
*     | b | c | d     |
*     +---+---+---+---+
*     | e     | f     |
*     +---+---+---+---+
*     | g | h         |
*     +---+---+---+---+
*               ^
*              last column, each cell has colspan = 2, so we need to return 3, not 2
*
* @internal
* @returns Adjusted last column index.
*/ function $f1b97c36043e973c$export$637b4fa83bfe055a(table, dimensions) {
    const lastColumnMap = Array.from(new $f1b97c36043e973c$export$6c270156410e802f(table, {
        startRow: dimensions.firstRow,
        endRow: dimensions.lastRow,
        column: dimensions.lastColumn
    }));
    if (lastColumnMap.every(({ cellWidth: cellWidth })=>cellWidth === 1)) return dimensions.lastColumn;
    const colspanAdjustment = lastColumnMap[0].cellWidth - 1;
    return dimensions.lastColumn + colspanAdjustment;
}
/**
* Get view `<table>` element from the wrapper.
*/ function $f1b97c36043e973c$var$getViewTableFromWrapper(wrapperView) {
    for (const wrapperChild of wrapperView.getChildren())if (wrapperChild.is("element", "table")) return wrapperChild;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a function that converts the table view representation:
*
* ```xml
* <figure class="table"><table>...</table></figure>
* ```
*
* to the model representation:
*
* ```xml
* <table></table>
* ```
*
* @internal
*/ function $f1b97c36043e973c$export$e0821ce489e36326() {
    return (dispatcher)=>{
        dispatcher.on("element:figure", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.test(data.viewItem, {
                name: true,
                classes: "table"
            })) return;
            const viewTable = $f1b97c36043e973c$var$getViewTableFromWrapper(data.viewItem);
            if (!viewTable || !conversionApi.consumable.test(viewTable, {
                name: true
            })) return;
            conversionApi.consumable.consume(data.viewItem, {
                name: true,
                classes: "table"
            });
            const conversionResult = conversionApi.convertItem(viewTable, data.modelCursor);
            /* istanbul ignore if: defensive guard for the `ModelRange | null` return type -- @preserve */ if (!conversionResult.modelRange) {
                conversionApi.consumable.revert(data.viewItem, {
                    name: true,
                    classes: "table"
                });
                return;
            }
            const modelTable = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(conversionResult.modelRange.getItems());
            if (!modelTable || !modelTable.is("element", "table")) {
                conversionApi.consumable.revert(data.viewItem, {
                    name: true,
                    classes: "table"
                });
                if (!conversionResult.modelRange.isCollapsed) {
                    data.modelRange = conversionResult.modelRange;
                    data.modelCursor = conversionResult.modelCursor;
                }
                return;
            }
            conversionApi.convertChildren(data.viewItem, conversionApi.writer.createPositionAt(modelTable, "end"));
            conversionApi.updateConversionResult(modelTable, data);
        });
    };
}
/**
* View table element to model table element conversion helper.
*
* This conversion helper converts the table element as well as table rows.
*
* @param options Conversion options.
* @param options.enableFooters If set to `true` the `footerRows` attribute will be upcasted.
* @returns Conversion helper.
* @internal
*/ function $f1b97c36043e973c$export$cca6e092b997f07e(options) {
    return (dispatcher)=>{
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            const viewTable = data.viewItem;
            if (!conversionApi.consumable.test(viewTable, {
                name: true
            })) return;
            const { rows: rows, headingRows: headingRows, headingColumns: headingColumns, footerRows: footerRows } = $f1b97c36043e973c$var$scanTable(viewTable);
            const attributes = {};
            if (headingColumns) attributes.headingColumns = headingColumns;
            if (headingRows) attributes.headingRows = headingRows;
            if (options.enableFooters && footerRows) attributes.footerRows = footerRows;
            const table = conversionApi.writer.createElement("table", attributes);
            if (!conversionApi.safeInsert(table, data.modelCursor)) return;
            conversionApi.consumable.consume(viewTable, {
                name: true
            });
            rows.forEach((row)=>conversionApi.convertItem(row, conversionApi.writer.createPositionAt(table, "end")));
            conversionApi.convertChildren(viewTable, conversionApi.writer.createPositionAt(table, "end"));
            if (table.isEmpty) {
                const row = conversionApi.writer.createElement("tableRow");
                conversionApi.writer.insert(row, conversionApi.writer.createPositionAt(table, "end"));
                $f1b97c36043e973c$export$6912bf35f0593a83(conversionApi.writer, conversionApi.writer.createPositionAt(row, "end"));
            }
            conversionApi.updateConversionResult(table, data);
        });
    };
}
/**
* A conversion helper that skips empty <tr> elements from upcasting at the beginning of the table.
*
* An empty row is considered a table model error but when handling clipboard data there could be rows that contain only row-spanned cells
* and empty TR-s are used to maintain the table structure (also {@link module:table/tablewalker~TableWalker} assumes that there are only
* rows that have related `tableRow` elements).
*
* *Note:* Only the first empty rows are removed because they have no meaning and it solves the issue
* of an improper table with all empty rows.
*
* @internal
* @returns Conversion helper.
*/ function $f1b97c36043e973c$export$bf3822e3bf8136cb() {
    return (dispatcher)=>{
        dispatcher.on("element:tr", (evt, data)=>{
            if (data.viewItem.isEmpty && data.modelCursor.index == 0) evt.stop();
        }, {
            priority: "high"
        });
    };
}
/**
* A converter that ensures an empty paragraph is inserted in a table cell if no other content was converted.
*
* @internal
* @returns Conversion helper.
*/ function $f1b97c36043e973c$export$cad4726fdac140ee(elementName) {
    return (dispatcher)=>{
        dispatcher.on(`element:${elementName}`, (evt, data, { writer: writer })=>{
            if (!data.modelRange) return;
            const tableCell = data.modelRange.start.nodeAfter;
            const modelCursor = writer.createPositionAt(tableCell, 0);
            if (data.viewItem.isEmpty) {
                writer.insertElement("paragraph", modelCursor);
                return;
            }
            const childNodes = Array.from(tableCell.getChildren());
            if (childNodes.every((node)=>node.is("element", "$marker"))) {
                const paragraph = writer.createElement("paragraph");
                writer.insert(paragraph, writer.createPositionAt(tableCell, 0));
                for (const node of childNodes)writer.move(writer.createRangeOn(node), writer.createPositionAt(paragraph, "end"));
            }
        }, {
            priority: "low"
        });
    };
}
/**
* Scans table rows and extracts required metadata from the table:
*
* headingRows    - The number of rows that go as table headers.
* headingColumns - The maximum number of row headings.
* rows           - Sorted `<tr>` elements as they should go into the model - ie. if `<thead>` is inserted after `<tbody>` in the view.
*
* @param viewTable The view table element.
* @returns The table metadata.
*/ function $f1b97c36043e973c$var$scanTable(viewTable) {
    let headingColumns = void 0;
    let shouldAccumulateHeadingRows = true;
    const headRows = [];
    const bodyRows = [];
    const footRows = [];
    let firstTheadElement = null;
    let firstTfoot = null;
    const tableChildren = Array.from(viewTable.getChildren());
    for(let childIndex = 0; childIndex < tableChildren.length; childIndex++){
        const tableChild = tableChildren[childIndex];
        if (tableChild.name !== "tbody" && tableChild.name !== "thead" && tableChild.name !== "tfoot") continue;
        if (tableChild.name === "thead" && !firstTheadElement) {
            shouldAccumulateHeadingRows = true;
            firstTheadElement = tableChild;
        }
        const trs = Array.from(tableChild.getChildren()).filter((el)=>el.is("element", "tr"));
        let maxPrevColumns = null;
        let arePrecedingChildrenFooters = null;
        for (const tr of trs){
            const trColumns = Array.from(tr.getChildren()).filter((el)=>el.is("element", "td") || el.is("element", "th"));
            if (tableChild.name === "tfoot") {
                firstTfoot ||= {
                    element: tableChild,
                    rows: trs
                };
                shouldAccumulateHeadingRows = false;
                const isFirstTfoot = firstTfoot.element === tableChild;
                if (!isFirstTfoot && arePrecedingChildrenFooters === null) for(let i = childIndex; i < tableChildren.length; i++){
                    arePrecedingChildrenFooters = tableChildren[i].name === "tfoot";
                    if (!arePrecedingChildrenFooters) break;
                }
                if (isFirstTfoot) {
                    footRows.push(tr);
                    continue;
                }
                if (arePrecedingChildrenFooters !== false) {
                    footRows.splice(footRows.length - firstTfoot.rows.length, 0, tr);
                    continue;
                }
            }
            if (firstTheadElement && tableChild === firstTheadElement || tableChild.name === "tbody" && trColumns.length > 0 && (maxPrevColumns === null || trColumns.length === maxPrevColumns) && trColumns.every((e)=>e.is("element", "th")) && shouldAccumulateHeadingRows) {
                headRows.push(tr);
                shouldAccumulateHeadingRows = true;
            } else {
                bodyRows.push(tr);
                shouldAccumulateHeadingRows = false;
            }
            maxPrevColumns = Math.max(maxPrevColumns || 0, trColumns.length);
        }
    }
    const bodyMatrix = $f1b97c36043e973c$var$generateCellMatrix(bodyRows);
    for (const rowSlots of bodyMatrix){
        let index = 0;
        while(index < rowSlots.length){
            if (rowSlots[index]?.name !== "th") break;
            index += 1;
        }
        if (headingColumns === void 0 || index < headingColumns) headingColumns = index;
    }
    return {
        headingRows: headRows.length,
        headingColumns: headingColumns || 0,
        footerRows: footRows.length,
        rows: [
            ...headRows,
            ...bodyRows,
            ...footRows
        ]
    };
}
/**
* Takes an array of `<tr>` elements and generates a "matrix" (square
* two-dimensional array) describing which `<th>`s and `<td>`s fill which
* "slots", factoring in `rowspan`s and `colspan`s. For example, given
*
* ```xml
* <table>
*   <tr> <td>11</td> <td rowspan="2">12-22</td> <td>13</td> </tr>
*   <tr> <td>21</td> <td>23</td> </tr>
*   <tr> <td colspan="2">31-32</td> <td>33</rd> </tr>
* </table>
* ```
*
* The result would be (with cell elements' text content in place of the element
* objects for readability):
*
* ```js
* [
*   [ '11', '12-22', '13' ],
*   [ '21', '12-22', '23' ],
*   [ '31-32', '31-32', '33' ],
* ]
* ```
*
* This allows for a computation of heading columns that factors in the case
* where a cell from a previous rows with a `rowspan` attribute effectively adds
* an additional header cell to a subsequent row.
*
* There are also cases where cells are "missing" from a row. A simple one is
* the case where a row simply has fewer cells than another row in the same
* table. But another is one where a row has a cell with a `rowspan` that
* effectively adds a cell to a subsequent row "off the end" of the row. In this
* case, there will be a `null` value instead of an element object in that
* position. For example,
*
* ```xml
* <table>
*   <tr> <td>11</td> <td>12</td> <td rowspan="2">13-23</td> </tr>
*   <tr> <td>21</td> </tr>
*   <tr> <td>31</td> </tr>
* </table>
* ```
*
* would result in
*
* ```js
* [
*   [ '11', '12', '13-23' ],
*   [ '21', null, '13-23' ],
*   [ '31', null, null ]
* ]
* ```
*
* @param trs the array of `<tr>` elements
* @returns the cell matrix
*/ function $f1b97c36043e973c$var$generateCellMatrix(trs) {
    let prevRowspans = /* @__PURE__ */ new Map();
    let maxColumns = 0;
    const slots = trs.map((tr)=>{
        const curSlots = [];
        const children = Array.from(tr.getChildren()).filter((child)=>child.name === "th" || child.name === "td");
        const curRowspans = /* @__PURE__ */ new Map();
        while(children.length || curSlots.length < maxColumns){
            const rowSpan = prevRowspans.get(curSlots.length);
            if (rowSpan && rowSpan.remaining > 0) curSlots.push(rowSpan.cell);
            else {
                const cell = children.shift();
                if (cell) {
                    const colspan = parseInt(cell.getAttribute("colspan") || "1");
                    const rowspan = parseInt(cell.getAttribute("rowspan") || "1");
                    for(let i = 0; i < colspan; i++){
                        if (rowspan > 1) curRowspans.set(curSlots.length, {
                            cell: cell,
                            remaining: rowspan - 1
                        });
                        curSlots.push(cell);
                    }
                } else {
                    curSlots.push(null);
                    continue;
                }
            }
        }
        for (const [index, entry] of prevRowspans.entries()){
            entry.remaining -= 1;
            if (entry.remaining > 0 && !curRowspans.has(index)) curRowspans.set(index, entry);
        }
        prevRowspans = curRowspans;
        maxColumns = Math.max(maxColumns, curSlots.length);
        return curSlots;
    });
    for (const rowSlots of slots)while(rowSlots.length < maxColumns)rowSlots.push(null);
    return slots;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecolumnresize/constants
*/ /**
* The minimum column width given as a percentage value. Used in situations when the table is not yet rendered, so it is impossible to
* calculate how many percentage of the table width would be {@link ~COLUMN_MIN_WIDTH_IN_PIXELS minimum column width in pixels}.
*
* @internal
*/ const $f1b97c36043e973c$export$8e6105298b7ed015 = 5;
/**
* The minimum column width in pixels when the maximum table width is known.
* This value is an equivalent of `10%` of the default editor width (600px).
*
* @internal
*/ const $f1b97c36043e973c$export$ecf591a3bc8019bd = 40;
/**
* Determines how many digits after the decimal point are used to store the column width as a percentage value.
*
* @internal
*/ const $f1b97c36043e973c$export$a73d71f043c3be63 = 2;
/**
* The distance in pixels that the mouse has to move to start resizing the column.
*
* @internal
*/ const $f1b97c36043e973c$export$edb7a43b614e556 = 3;
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns all the inserted or changed table model elements in a given change set. Only the tables
* with 'columnsWidth' attribute are taken into account. The returned set may be empty.
*
* Most notably if an entire table is removed it will not be included in returned set.
*
* @internal
* @param model The model to collect the affected elements from.
* @returns A set of table model elements.
*/ function $f1b97c36043e973c$export$8bf560a2affb342f(model) {
    const affectedTables = /* @__PURE__ */ new Set();
    for (const change of model.document.differ.getChanges()){
        let referencePosition = null;
        switch(change.type){
            case "insert":
                referencePosition = [
                    "table",
                    "tableRow",
                    "tableCell"
                ].includes(change.name) ? change.position : null;
                break;
            case "remove":
                referencePosition = [
                    "tableRow",
                    "tableCell"
                ].includes(change.name) ? change.position : null;
                break;
            case "attribute":
                if (change.range.start.nodeAfter) referencePosition = [
                    "table",
                    "tableRow",
                    "tableCell"
                ].includes(change.range.start.nodeAfter.name) ? change.range.start : null;
        }
        if (!referencePosition) continue;
        const tableNode = referencePosition.nodeAfter && referencePosition.nodeAfter.is("element", "table") ? referencePosition.nodeAfter : referencePosition.findAncestor("table");
        for (const node of model.createRangeOn(tableNode).getItems()){
            if (!node.is("element", "table")) continue;
            if (!$f1b97c36043e973c$export$3003b92ca07186d3(node)) continue;
            affectedTables.add(node);
        }
    }
    return affectedTables;
}
/**
* Calculates the percentage of the minimum column width given in pixels for a given table.
*
* @internal
* @param modelTable A table model element.
* @param editor The editor instance.
* @returns The minimal column width in percentage.
*/ function $f1b97c36043e973c$export$f62189fd06b2c56(modelTable, editor) {
    return 4000 / $f1b97c36043e973c$export$27dbffe8026332af(modelTable, editor);
}
/**
* Calculates the table width in pixels.
*
* @internal
* @param modelTable A table model element.
* @param editor The editor instance.
* @returns The width of the table in pixels.
*/ function $f1b97c36043e973c$export$27dbffe8026332af(modelTable, editor) {
    const referenceElement = $f1b97c36043e973c$var$getChildrenViewElement(modelTable, "tbody", editor) || $f1b97c36043e973c$var$getChildrenViewElement(modelTable, "thead", editor) || $f1b97c36043e973c$var$getChildrenViewElement(modelTable, "tfoot", editor);
    return $f1b97c36043e973c$export$4be6b7a1d8b56248(editor.editing.view.domConverter.mapViewToDom(referenceElement));
}
/**
* Returns the a view element with a given name that is nested directly in a `<table>` element
* related to a given `modelTable`.
*
* @param elementName Name of a view to be looked for, e.g. `'colgroup`', `'thead`'.
* @returns Matched view or `undefined` otherwise.
*/ function $f1b97c36043e973c$var$getChildrenViewElement(modelTable, elementName, editor) {
    return [
        ...[
            ...editor.editing.mapper.toViewElement(modelTable).getChildren()
        ].find((node)=>node.is("element", "table")).getChildren()
    ].find((node)=>node.is("element", elementName));
}
/**
* Returns the computed width (in pixels) of the DOM element without padding and borders.
*
* @internal
* @param domElement A DOM element.
* @returns The width of the DOM element in pixels.
*/ function $f1b97c36043e973c$export$4be6b7a1d8b56248(domElement) {
    const styles = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domElement);
    if (styles.boxSizing === "border-box") return parseFloat(styles.width) - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight) - parseFloat(styles.borderLeftWidth) - parseFloat(styles.borderRightWidth);
    else return parseFloat(styles.width);
}
/**
* Returns the width (in pixels) of a given DOM element's content that's actually available to its children -
* with the element's own vertical scrollbar subtracted where that's still needed.
*
* @internal
* @param domElement A DOM element.
* @returns The width available to the element's children, in pixels.
*/ function $f1b97c36043e973c$var$getContainerContentWidth(domElement) {
    const styles = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domElement);
    const width = $f1b97c36043e973c$export$4be6b7a1d8b56248(domElement);
    if (styles.boxSizing !== "border-box") return width;
    return width - Math.max(domElement.offsetWidth - domElement.clientWidth - parseFloat(styles.borderLeftWidth) - parseFloat(styles.borderRightWidth), 0);
}
/**
* Returns the inner pixel width of a given editing root, or `null` if the root has no
* DOM element attached yet (e.g. it hasn't been rendered for the first time).
*
* @internal
*/ function $f1b97c36043e973c$var$getEditableContentWidth(editor, rootName) {
    const domRoot = editor.editing.view.getDomRoot(rootName);
    if (!domRoot) return null;
    return $f1b97c36043e973c$var$getContainerContentWidth(domRoot);
}
/**
* Returns the column indexes on the left and right edges of a cell. They differ if the cell spans
* across multiple columns.
*
* @internal
* @param cell A table cell model element.
* @param tableUtils The Table Utils plugin instance.
* @returns An object containing the indexes of the left and right edges of the cell.
*/ function $f1b97c36043e973c$export$a9ac57172d51c643(cell, tableUtils) {
    const cellColumnIndex = tableUtils.getCellLocation(cell).column;
    return {
        leftEdge: cellColumnIndex,
        rightEdge: cellColumnIndex + (cell.getAttribute("colspan") || 1) - 1
    };
}
/**
* Rounds the provided value to a fixed-point number with defined number of digits after the decimal point.
*
* @internal
* @param value A number to be rounded.
* @returns The rounded number.
*/ function $f1b97c36043e973c$export$288dd660ff522bf9(value) {
    const multiplier = Math.pow(10, 2);
    return Math.round((typeof value === "number" ? value : parseFloat(value)) * multiplier) / multiplier;
}
/**
* Clamps the number within the inclusive lower (min) and upper (max) bounds. Returned number is rounded using the
* {@link ~toPrecision `toPrecision()`} function.
*
* @internal
* @param number A number to be clamped.
* @param min A lower bound.
* @param max An upper bound.
* @returns The clamped number.
*/ function $f1b97c36043e973c$export$1433524e656d1e11(number, min, max) {
    if (number <= min) return $f1b97c36043e973c$export$288dd660ff522bf9(min);
    if (number >= max) return $f1b97c36043e973c$export$288dd660ff522bf9(max);
    return $f1b97c36043e973c$export$288dd660ff522bf9(number);
}
/**
* Creates an array with defined length and fills all elements with defined value.
*
* @internal
* @param length The length of the array.
* @param value The value to fill the array with.
* @returns An array with defined length and filled with defined value.
*/ function $f1b97c36043e973c$export$34e93823086e0ea7(length, value) {
    return Array(length).fill(value);
}
/**
* Sums all array values that can be parsed to a float.
*
* @internal
* @param array An array of numbers.
* @returns The sum of all array values.
*/ function $f1b97c36043e973c$export$a2421b6a51bb9cb5(array) {
    return array.map((value)=>typeof value === "number" ? value : parseFloat(value)).filter((value)=>!Number.isNaN(value)).reduce((result, item)=>result + item, 0);
}
/**
* Makes sure that the sum of the widths from all columns is 100%. If the sum of all the widths is not equal 100%, all the widths are
* changed proportionally so that they all sum back to 100%. If there are columns without specified width, the amount remaining
* after assigning the known widths will be distributed equally between them.
*
* @internal
* @param columnWidths An array of column widths.
* @returns An array of column widths guaranteed to sum up to 100%.
*/ function $f1b97c36043e973c$export$3f6a26999910654(columnWidths) {
    const hasPixels = columnWidths.some((width)=>typeof width === "string" && width.endsWith("px"));
    const hasPercentages = columnWidths.some((width)=>typeof width === "string" && width.endsWith("%"));
    if (hasPixels && !hasPercentages) return columnWidths.map((width)=>width === "auto" || width === void 0 ? "auto" : `${$f1b97c36043e973c$export$288dd660ff522bf9(width)}px`);
    let normalizedWidths = $f1b97c36043e973c$var$calculateMissingColumnWidths(columnWidths.map((width)=>{
        if (width === "auto" || width === void 0) return "auto";
        return parseFloat(width.replace("%", ""));
    }));
    const totalWidth = $f1b97c36043e973c$export$a2421b6a51bb9cb5(normalizedWidths);
    if (totalWidth !== 100) normalizedWidths = normalizedWidths.map((width)=>$f1b97c36043e973c$export$288dd660ff522bf9(width * 100 / totalWidth)).map((columnWidth, columnIndex, width)=>{
        if (!(columnIndex === width.length - 1)) return columnWidth;
        const totalWidth = $f1b97c36043e973c$export$a2421b6a51bb9cb5(width);
        return $f1b97c36043e973c$export$288dd660ff522bf9(columnWidth + 100 - totalWidth);
    });
    return normalizedWidths.map((width)=>width + "%");
}
/**
* Initializes the column widths by parsing the attribute value and calculating the uninitialized column widths. The special value 'auto'
* indicates that width for the column must be calculated. The width of such uninitialized column is calculated as follows:
* - If there is enough free space in the table for all uninitialized columns to have at least the minimum allowed width for all of them,
*   then set this width equally for all uninitialized columns.
* - Otherwise, just set the minimum allowed width for all uninitialized columns. The sum of all column widths will be greater than 100%,
*   but then it will be adjusted proportionally to 100% in {@link #normalizeColumnWidths `normalizeColumnWidths()`}.
*
* @param columnWidths An array of column widths.
* @returns An array with 'auto' values replaced with calculated widths.
*/ function $f1b97c36043e973c$var$calculateMissingColumnWidths(columnWidths) {
    const numberOfUninitializedColumns = columnWidths.filter((columnWidth)=>columnWidth === "auto").length;
    if (numberOfUninitializedColumns === 0) return columnWidths.map((columnWidth)=>$f1b97c36043e973c$export$288dd660ff522bf9(columnWidth));
    const totalWidthOfInitializedColumns = $f1b97c36043e973c$export$a2421b6a51bb9cb5(columnWidths);
    const widthForUninitializedColumn = Math.max((100 - totalWidthOfInitializedColumns) / numberOfUninitializedColumns, 5);
    return columnWidths.map((columnWidth)=>columnWidth === "auto" ? widthForUninitializedColumn : columnWidth).map((columnWidth)=>$f1b97c36043e973c$export$288dd660ff522bf9(columnWidth));
}
/**
* Calculates the total horizontal space taken by the cell. That includes:
*  * width,
*  * left and red padding,
*  * border width.
*
* @internal
* @param domCell A DOM cell element.
* @returns Width in pixels without `px` at the end.
*/ function $f1b97c36043e973c$export$c2cfc1723152f6a(domCell) {
    const styles = (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.getComputedStyle(domCell);
    if (styles.boxSizing === "border-box") return parseInt(styles.width);
    else return parseFloat(styles.width) + parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight) + parseFloat(styles.borderWidth);
}
/**
* Updates column elements to match columns widths.
*
* @internal
* @param columns
* @param tableColumnGroup
* @param normalizedWidths
* @param writer
*/ function $f1b97c36043e973c$export$96fdad66d97345fc(columns, tableColumnGroup, normalizedWidths, writer) {
    for(let i = 0; i < Math.max(normalizedWidths.length, columns.length); i++){
        const column = columns[i];
        const columnWidth = normalizedWidths[i];
        if (!columnWidth) writer.remove(column);
        else if (!column) writer.appendElement("tableColumn", {
            columnWidth: columnWidth
        }, tableColumnGroup);
        else writer.setAttribute("columnWidth", columnWidth, column);
    }
}
/**
* Returns a 'tableColumnGroup' element from the 'table'.
*
* @internal
* @param element A 'table' or 'tableColumnGroup' element.
* @returns A 'tableColumnGroup' element.
*/ function $f1b97c36043e973c$export$3003b92ca07186d3(element) {
    if (element.is("element", "tableColumnGroup")) return element;
    const children = element.getChildren();
    return Array.from(children).find((element)=>element.is("element", "tableColumnGroup"));
}
/**
* Returns an array of 'tableColumn' elements. It may be empty if there's no `tableColumnGroup` element.
*
* @internal
* @param element A 'table' or 'tableColumnGroup' element.
* @returns An array of 'tableColumn' elements.
*/ function $f1b97c36043e973c$export$93a5df62948110b3(element) {
    const columnGroupElement = $f1b97c36043e973c$export$3003b92ca07186d3(element);
    if (!columnGroupElement) return [];
    return Array.from(columnGroupElement.getChildren());
}
/**
* Returns an array of table column widths.
*
* @internal
* @param element A 'table' or 'tableColumnGroup' element.
* @returns An array of table column widths.
*/ function $f1b97c36043e973c$export$704df7f93ae962f7(element) {
    return $f1b97c36043e973c$export$93a5df62948110b3(element).map((column)=>column.getAttribute("columnWidth"));
}
/**
* Tells whether a table is in the pixel width mode, that is, its `tableWidth` attribute is expressed in pixels.
* The `tableWidth` unit is the single source of truth for the whole table's width mode.
*
* @internal
* @param table A 'table' model element.
*/ function $f1b97c36043e973c$var$isTableWidthInPixels(table) {
    const tableWidth = table.getAttribute("tableWidth");
    return typeof tableWidth === "string" && tableWidth.trim().endsWith("px");
}
/**
* Tells whether the given column widths are expressed in pixels.
*
* @internal
* @param columnWidths An array of column widths.
*/ function $f1b97c36043e973c$var$isColumnWidthsInPixels(columnWidths) {
    return columnWidths.some((width)=>typeof width === "string" && width.endsWith("px"));
}
/**
* Translates the `colSpan` model attribute into additional column widths and returns the resulting array.
*
* @internal
* @param element A 'table' or 'tableColumnGroup' element.
* @param writer A writer instance.
* @returns An array of table column widths.
*/ function $f1b97c36043e973c$export$2ceda7f294e7025c(element, writer) {
    return $f1b97c36043e973c$export$93a5df62948110b3(element).reduce((acc, element)=>{
        const columnWidth = element.getAttribute("columnWidth");
        const colSpan = element.getAttribute("colSpan");
        if (!colSpan) {
            acc.push(columnWidth);
            return acc;
        }
        for(let i = 0; i < colSpan; i++)acc.push(columnWidth);
        writer.removeAttribute("colSpan", element);
        return acc;
    }, []);
}
/**
* Removes the `tableCellWidth` attribute from every cell of the given table. Once a column is resized (with the resize
* handler or the column-width command), a per-cell width is obsolete - the column width governs the layout - so it is
* dropped to keep the model clean.
*
* @internal
*/ function $f1b97c36043e973c$var$removeCellWidthsFromTable(writer, table) {
    for (const row of table.getChildren()){
        if (!row.is("element", "tableRow")) continue;
        for (const cell of row.getChildren())writer.removeAttribute("tableCellWidth", cell);
    }
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableutils
*/ /**
* The table utilities plugin.
*/ var $f1b97c36043e973c$export$b8747c538ef18c7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableUtils";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.decorate("insertColumns");
        this.decorate("insertRows");
    }
    /**
	* Returns the table cell location as an object with table row and table column indexes.
	*
	* For instance, in the table below:
	*
	*      0   1   2   3
	*    +---+---+---+---+
	*  0 | a     | b | c |
	*    +       +   +---+
	*  1 |       |   | d |
	*    +---+---+   +---+
	*  2 | e     |   | f |
	*    +---+---+---+---+
	*
	* the method will return:
	*
	* ```ts
	* const cellA = table.getNodeByPath( [ 0, 0 ] );
	* editor.plugins.get( 'TableUtils' ).getCellLocation( cellA );
	* // will return { row: 0, column: 0 }
	*
	* const cellD = table.getNodeByPath( [ 1, 0 ] );
	* editor.plugins.get( 'TableUtils' ).getCellLocation( cellD );
	* // will return { row: 1, column: 3 }
	* ```
	*
	* @returns Returns a `{row, column}` object.
	*/ getCellLocation(tableCell) {
        const tableRow = tableCell.parent;
        const table = tableRow.parent;
        const rowIndex = table.getChildIndex(tableRow);
        const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
            row: rowIndex
        });
        for (const { cell: cell, row: row, column: column } of tableWalker)if (cell === tableCell) return {
            row: row,
            column: column
        };
    }
    /**
	* Creates an empty table with a proper structure. The table needs to be inserted into the model,
	* for example, by using the {@link module:engine/model/model~Model#insertContent} function.
	*
	* ```ts
	* model.change( ( writer ) => {
	*   // Create a table of 2 rows and 7 columns:
	*   const table = tableUtils.createTable( writer, { rows: 2, columns: 7 } );
	*
	*   // Insert a table to the model at the best position taking the current selection:
	*   model.insertContent( table );
	* }
	* ```
	*
	* @param writer The model writer.
	* @param options.rows The number of rows to create. Default value is 2.
	* @param options.columns The number of columns to create. Default value is 2.
	* @param options.headingRows The number of heading rows. Default value is 0.
	* @param options.headingColumns The number of heading columns. Default value is 0.
	* @param options.footerRows The number of footer rows. Default value is 0.
	* @returns The created table element.
	*/ createTable(writer, options) {
        const table = writer.createElement("table");
        $f1b97c36043e973c$var$createEmptyRows(writer, table, 0, options.rows || 2, options.columns || 2);
        if (options.footerRows) this.setFooterRowsCount(writer, table, options.footerRows);
        if (options.headingRows) this.setHeadingRowsCount(writer, table, options.headingRows);
        if (options.headingColumns) this.setHeadingColumnsCount(writer, table, options.headingColumns);
        return table;
    }
    /**
	* Inserts rows into a table.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).insertRows( table, { at: 1, rows: 2 } );
	* ```
	*
	* Assuming the table on the left, the above code will transform it to the table on the right:
	*
	*  row index
	*    0 +---+---+---+       `at` = 1,      +---+---+---+ 0
	*      | a | b | c |       `rows` = 2,    | a | b | c |
	*    1 +   +---+---+   <-- insert here    +   +---+---+ 1
	*      |   | d | e |                      |   |   |   |
	*    2 +   +---+---+       will give:     +   +---+---+ 2
	*      |   | f | g |                      |   |   |   |
	*    3 +---+---+---+                      +   +---+---+ 3
	*                                         |   | d | e |
	*                                         +   +---+---+ 4
	*                                         +   + f | g |
	*                                         +---+---+---+ 5
	*
	* @param table The table model element where the rows will be inserted.
	* @param options.at The row index at which the rows will be inserted.  Default value is 0.
	* @param options.rows The number of rows to insert.  Default value is 1.
	* @param options.copyStructureFromAbove The flag for copying row structure. Note that
	* the row structure will not be copied if this option is not provided.
	*/ insertRows(table, options = {}) {
        const model = this.editor.model;
        const insertAt = options.at || 0;
        const rowsToInsert = options.rows || 1;
        const isCopyStructure = options.copyStructureFromAbove !== void 0;
        const copyStructureFrom = options.copyStructureFromAbove ? insertAt - 1 : insertAt;
        const cellTypeEnabled = $f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor);
        const scopedHeaders = !!this.editor.config.get("table.tableCellProperties.scopedHeaders");
        const rows = this.getRows(table);
        const columns = this.getColumns(table);
        if (insertAt > rows) /**
		* The `options.at` points at a row position that does not exist.
		*
		* @error tableutils-insertrows-insert-out-of-range
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("tableutils-insertrows-insert-out-of-range", this, {
            options: options
        });
        model.change((writer)=>{
            let headingRows = table.getAttribute("headingRows") || 0;
            let footerRows = table.getAttribute("footerRows") || 0;
            if (headingRows > insertAt) headingRows += rowsToInsert;
            if (footerRows && insertAt > rows - footerRows) footerRows += rowsToInsert;
            if (!isCopyStructure && (insertAt === 0 || insertAt === rows)) {
                const rows = $f1b97c36043e973c$var$createEmptyRows(writer, table, insertAt, rowsToInsert, columns);
                if (cellTypeEnabled) for(let rowOffset = 0; rowOffset < rows.length; rowOffset++){
                    const row = rows[rowOffset];
                    for(let columnIndex = 0; columnIndex < columns; columnIndex++)$f1b97c36043e973c$var$updateTableCellType({
                        table: table,
                        writer: writer,
                        cell: row[columnIndex],
                        row: insertAt + rowOffset,
                        column: columnIndex,
                        scopedHeaders: scopedHeaders
                    });
                }
            } else {
                const tableIterator = new $f1b97c36043e973c$export$6c270156410e802f(table, {
                    endRow: isCopyStructure ? Math.max(insertAt, copyStructureFrom) : insertAt
                });
                const rowColSpansMap = new Array(columns).fill(1);
                for (const { row: row, column: column, cellHeight: cellHeight, cellWidth: cellWidth, cell: cell } of tableIterator){
                    const lastCellRow = row + cellHeight - 1;
                    const isOverlappingInsertedRow = row < insertAt && insertAt <= lastCellRow;
                    const isReferenceRow = row <= copyStructureFrom && copyStructureFrom <= lastCellRow;
                    if (isOverlappingInsertedRow) {
                        writer.setAttribute("rowspan", cellHeight + rowsToInsert, cell);
                        rowColSpansMap[column] = -cellWidth;
                    } else if (isCopyStructure && isReferenceRow) rowColSpansMap[column] = cellWidth;
                }
                for(let rowIndex = 0; rowIndex < rowsToInsert; rowIndex++){
                    const tableRow = writer.createElement("tableRow");
                    writer.insert(tableRow, table, insertAt);
                    for(let cellIndex = 0; cellIndex < rowColSpansMap.length; cellIndex++){
                        const colspan = rowColSpansMap[cellIndex];
                        const insertPosition = writer.createPositionAt(tableRow, "end");
                        if (colspan > 0) {
                            const insertedCell = $f1b97c36043e973c$export$6912bf35f0593a83(writer, insertPosition, colspan > 1 ? {
                                colspan: colspan
                            } : void 0);
                            if (cellTypeEnabled) $f1b97c36043e973c$var$updateTableCellType({
                                table: table,
                                writer: writer,
                                cell: insertedCell,
                                row: insertAt + rowIndex,
                                column: cellIndex,
                                scopedHeaders: scopedHeaders
                            });
                        }
                        cellIndex += Math.abs(colspan) - 1;
                    }
                }
            }
            this.setFooterRowsCount(writer, table, footerRows);
            this.setHeadingRowsCount(writer, table, headingRows, {
                updateCellType: false
            });
        });
    }
    /**
	* Inserts columns into a table.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).insertColumns( table, { at: 1, columns: 2 } );
	* ```
	*
	* Assuming the table on the left, the above code will transform it to the table on the right:
	*
	*  0   1   2   3                   0   1   2   3   4   5
	*  +---+---+---+                   +---+---+---+---+---+
	*  | a     | b |                   | a             | b |
	*  +       +---+                   +               +---+
	*  |       | c |                   |               | c |
	*  +---+---+---+     will give:    +---+---+---+---+---+
	*  | d | e | f |                   | d |   |   | e | f |
	*  +---+   +---+                   +---+---+---+   +---+
	*  | g |   | h |                   | g |   |   |   | h |
	*  +---+---+---+                   +---+---+---+---+---+
	*  | i         |                   | i                 |
	*  +---+---+---+                   +---+---+---+---+---+
	*      ^---- insert here, `at` = 1, `columns` = 2
	*
	* @param table The table model element where the columns will be inserted.
	* @param options.at The column index at which the columns will be inserted. Default value is 0.
	* @param options.columns The number of columns to insert. Default value is 1.
	*/ insertColumns(table, options = {}) {
        const model = this.editor.model;
        const insertAt = options.at || 0;
        const columnsToInsert = options.columns || 1;
        const cellTypeEnabled = $f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor);
        const scopedHeaders = !!this.editor.config.get("table.tableCellProperties.scopedHeaders");
        model.change((writer)=>{
            let headingColumns = table.getAttribute("headingColumns");
            if (insertAt < headingColumns) headingColumns += columnsToInsert;
            const tableColumns = this.getColumns(table);
            if (insertAt === 0 || tableColumns === insertAt) {
                let rowIndex = 0;
                for (const tableRow of table.getChildren()){
                    if (!tableRow.is("element", "tableRow")) continue;
                    const insertedCells = $f1b97c36043e973c$var$createCells(columnsToInsert, writer, writer.createPositionAt(tableRow, insertAt ? "end" : 0));
                    if (cellTypeEnabled) for(let columnOffset = 0; columnOffset < insertedCells.length; columnOffset++)$f1b97c36043e973c$var$updateTableCellType({
                        table: table,
                        writer: writer,
                        cell: insertedCells[columnOffset],
                        row: rowIndex,
                        column: insertAt + columnOffset,
                        scopedHeaders: scopedHeaders
                    });
                    rowIndex++;
                }
            } else {
                const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
                    column: insertAt,
                    includeAllSlots: true
                });
                for (const tableSlot of tableWalker){
                    const { row: row, cell: cell, cellAnchorColumn: cellAnchorColumn, cellAnchorRow: cellAnchorRow, cellWidth: cellWidth, cellHeight: cellHeight } = tableSlot;
                    if (cellAnchorColumn < insertAt) {
                        writer.setAttribute("colspan", cellWidth + columnsToInsert, cell);
                        const lastCellRow = cellAnchorRow + cellHeight - 1;
                        for(let i = row; i <= lastCellRow; i++)tableWalker.skipRow(i);
                    } else {
                        const insertedCells = $f1b97c36043e973c$var$createCells(columnsToInsert, writer, tableSlot.getPositionBefore());
                        if (cellTypeEnabled) for(let columnOffset = 0; columnOffset < insertedCells.length; columnOffset++)$f1b97c36043e973c$var$updateTableCellType({
                            table: table,
                            writer: writer,
                            cell: insertedCells[columnOffset],
                            row: row,
                            column: insertAt + columnOffset,
                            scopedHeaders: scopedHeaders
                        });
                    }
                }
            }
            this.setHeadingColumnsCount(writer, table, headingColumns, {
                updateCellType: false
            });
        });
    }
    /**
	* Removes rows from the given `table`.
	*
	* This method re-calculates the table geometry including `rowspan` attribute of table cells overlapping removed rows
	* and table headings values.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).removeRows( table, { at: 1, rows: 2 } );
	* ```
	*
	* Executing the above code in the context of the table on the left will transform its structure as presented on the right:
	*
	*  row index
	*      ┌───┬───┬───┐        `at` = 1        ┌───┬───┬───┐
	*    0 │ a │ b │ c │        `rows` = 2      │ a │ b │ c │ 0
	*      │   ├───┼───┤                        │   ├───┼───┤
	*    1 │   │ d │ e │  <-- remove from here  │   │ d │ g │ 1
	*      │   │   ├───┤        will give:      ├───┼───┼───┤
	*    2 │   │   │ f │                        │ h │ i │ j │ 2
	*      │   │   ├───┤                        └───┴───┴───┘
	*    3 │   │   │ g │
	*      ├───┼───┼───┤
	*    4 │ h │ i │ j │
	*      └───┴───┴───┘
	*
	* @param options.at The row index at which the removing rows will start.
	* @param options.rows The number of rows to remove. Default value is 1.
	*/ removeRows(table, options) {
        const model = this.editor.model;
        const rowsToRemove = options.rows || 1;
        const rowCount = this.getRows(table);
        const first = options.at;
        const last = first + rowsToRemove - 1;
        if (last > rowCount - 1) /**
		* The `options.at` param must point at existing row and `options.rows` must not exceed the rows in the table.
		*
		* @error tableutils-removerows-row-index-out-of-range
		*/ throw new (0, $c7bc2cb7e2db0227$export$4e727b0db6c2de10)("tableutils-removerows-row-index-out-of-range", this, {
            table: table,
            options: options
        });
        model.change((writer)=>{
            const indexesObject = {
                first: first,
                last: last
            };
            const { cellsToMove: cellsToMove, cellsToTrim: cellsToTrim } = $f1b97c36043e973c$var$getCellsToMoveAndTrimOnRemoveRow(table, indexesObject);
            if (cellsToMove.size) $f1b97c36043e973c$var$moveCellsToRow(table, last + 1, cellsToMove, writer);
            for(let i = last; i >= first; i--)writer.remove(table.getChild(i));
            for (const { rowspan: rowspan, cell: cell } of cellsToTrim)$f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", rowspan, cell, writer);
            $f1b97c36043e973c$var$updateHeadingRows(table, indexesObject, writer);
            $f1b97c36043e973c$var$updateFooterRows(table, rowCount, indexesObject, writer);
            if (!$f1b97c36043e973c$export$866099f77e94f777(table, this)) $f1b97c36043e973c$export$68f82b103583321d(table, this);
            if ($f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)) {
                let headingRows = table.getAttribute("headingRows") || 0;
                const totalRows = this.getRows(table);
                while(headingRows < totalRows && $f1b97c36043e973c$var$isEntireCellsLineHeader({
                    table: table,
                    row: headingRows
                }))headingRows++;
                this.setHeadingRowsCount(writer, table, headingRows, {
                    updateCellType: false
                });
            }
        });
    }
    /**
	* Removes columns from the given `table`.
	*
	* This method re-calculates the table geometry including the `colspan` attribute of table cells overlapping removed columns
	* and table headings values.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).removeColumns( table, { at: 1, columns: 2 } );
	* ```
	*
	* Executing the above code in the context of the table on the left will transform its structure as presented on the right:
	*
	*    0   1   2   3   4                       0   1   2
	*  ┌───────────────┬───┐                   ┌───────┬───┐
	*  │ a             │ b │                   │ a     │ b │
	*  │               ├───┤                   │       ├───┤
	*  │               │ c │                   │       │ c │
	*  ├───┬───┬───┬───┼───┤     will give:    ├───┬───┼───┤
	*  │ d │ e │ f │ g │ h │                   │ d │ g │ h │
	*  ├───┼───┼───┤   ├───┤                   ├───┤   ├───┤
	*  │ i │ j │ k │   │ l │                   │ i │   │ l │
	*  ├───┴───┴───┴───┴───┤                   ├───┴───┴───┤
	*  │ m                 │                   │ m         │
	*  └───────────────────┘                   └───────────┘
	*        ^---- remove from here, `at` = 1, `columns` = 2
	*
	* @param options.at The row index at which the removing columns will start.
	* @param options.columns The number of columns to remove.
	*/ removeColumns(table, options) {
        const model = this.editor.model;
        const first = options.at;
        const columnsToRemove = options.columns || 1;
        const last = options.at + columnsToRemove - 1;
        model.change((writer)=>{
            $f1b97c36043e973c$var$adjustHeadingColumns(table, {
                first: first,
                last: last
            }, writer);
            const tableColumns = $f1b97c36043e973c$export$93a5df62948110b3(table);
            for(let removedColumnIndex = last; removedColumnIndex >= first; removedColumnIndex--){
                for (const { cell: cell, column: column, cellWidth: cellWidth } of [
                    ...new $f1b97c36043e973c$export$6c270156410e802f(table)
                ])if (column <= removedColumnIndex && cellWidth > 1 && column + cellWidth > removedColumnIndex) $f1b97c36043e973c$export$fd08c984b28fd00a("colspan", cellWidth - 1, cell, writer);
                else if (column === removedColumnIndex) writer.remove(cell);
                if (tableColumns[removedColumnIndex]) {
                    const adjacentColumn = removedColumnIndex === 0 ? tableColumns[1] : tableColumns[removedColumnIndex - 1];
                    const removedColumnWidthAttribute = tableColumns[removedColumnIndex].getAttribute("columnWidth");
                    const removedColumnWidth = parseFloat(removedColumnWidthAttribute);
                    const adjacentColumnWidth = parseFloat(adjacentColumn.getAttribute("columnWidth"));
                    writer.remove(tableColumns[removedColumnIndex]);
                    const unit = removedColumnWidthAttribute.trim().endsWith("px") ? "px" : "%";
                    writer.setAttribute("columnWidth", `${removedColumnWidth + adjacentColumnWidth}${unit}`, adjacentColumn);
                }
            }
            if (!$f1b97c36043e973c$export$68f82b103583321d(table, this)) $f1b97c36043e973c$export$866099f77e94f777(table, this);
            if ($f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)) {
                let headingColumns = table.getAttribute("headingColumns") || 0;
                const totalColumns = this.getColumns(table);
                while(headingColumns < totalColumns && $f1b97c36043e973c$var$isEntireCellsLineHeader({
                    table: table,
                    column: headingColumns
                }))headingColumns++;
                this.setHeadingColumnsCount(writer, table, headingColumns, {
                    updateCellType: false
                });
            }
        });
    }
    /**
	* Divides a table cell vertically into several ones.
	*
	* The cell will be visually split into more cells by updating colspans of other cells in a column
	* and inserting cells (columns) after that cell.
	*
	* In the table below, if cell "a" is split into 3 cells:
	*
	*  +---+---+---+
	*  | a | b | c |
	*  +---+---+---+
	*  | d | e | f |
	*  +---+---+---+
	*
	* it will result in the table below:
	*
	*  +---+---+---+---+---+
	*  | a |   |   | b | c |
	*  +---+---+---+---+---+
	*  | d         | e | f |
	*  +---+---+---+---+---+
	*
	* So cell "d" will get its `colspan` updated to `3` and 2 cells will be added (2 columns will be created).
	*
	* Splitting a cell that already has a `colspan` attribute set will distribute the cell `colspan` evenly and the remainder
	* will be left to the original cell:
	*
	*  +---+---+---+
	*  | a         |
	*  +---+---+---+
	*  | b | c | d |
	*  +---+---+---+
	*
	* Splitting cell "a" with `colspan=3` into 2 cells will create 1 cell with a `colspan=a` and cell "a" that will have `colspan=2`:
	*
	*  +---+---+---+
	*  | a     |   |
	*  +---+---+---+
	*  | b | c | d |
	*  +---+---+---+
	*/ splitCellVertically(tableCell, numberOfCells = 2) {
        const model = this.editor.model;
        const table = tableCell.parent.parent;
        const rowspan = parseInt(tableCell.getAttribute("rowspan") || "1");
        const colspan = parseInt(tableCell.getAttribute("colspan") || "1");
        model.change((writer)=>{
            if (colspan > 1) {
                const { newCellsSpan: newCellsSpan, updatedSpan: updatedSpan } = $f1b97c36043e973c$var$breakSpanEvenly(colspan, numberOfCells);
                $f1b97c36043e973c$export$fd08c984b28fd00a("colspan", updatedSpan, tableCell, writer);
                const newCellsAttributes = {};
                if (newCellsSpan > 1) newCellsAttributes.colspan = newCellsSpan;
                if (rowspan > 1) newCellsAttributes.rowspan = rowspan;
                $f1b97c36043e973c$var$createCells(colspan > numberOfCells ? numberOfCells - 1 : colspan - 1, writer, writer.createPositionAfter(tableCell), newCellsAttributes);
            }
            if (colspan < numberOfCells) {
                const cellsToInsert = numberOfCells - colspan;
                const tableMap = [
                    ...new $f1b97c36043e973c$export$6c270156410e802f(table)
                ];
                const { column: splitCellColumn } = tableMap.find(({ cell: cell })=>cell === tableCell);
                const cellsToUpdate = tableMap.filter(({ cell: cell, cellWidth: cellWidth, column: column })=>{
                    const isOnSameColumn = cell !== tableCell && column === splitCellColumn;
                    const spansOverColumn = column < splitCellColumn && column + cellWidth > splitCellColumn;
                    return isOnSameColumn || spansOverColumn;
                });
                for (const { cell: cell, cellWidth: cellWidth } of cellsToUpdate)writer.setAttribute("colspan", cellWidth + cellsToInsert, cell);
                const newCellsAttributes = {};
                if (rowspan > 1) newCellsAttributes.rowspan = rowspan;
                $f1b97c36043e973c$var$createCells(cellsToInsert, writer, writer.createPositionAfter(tableCell), newCellsAttributes);
                const headingColumns = table.getAttribute("headingColumns") || 0;
                if (headingColumns > splitCellColumn) $f1b97c36043e973c$export$fd08c984b28fd00a("headingColumns", headingColumns + cellsToInsert, table, writer);
            }
        });
    }
    /**
	* Divides a table cell horizontally into several ones.
	*
	* The cell will be visually split into more cells by updating rowspans of other cells in the row and inserting rows with a single cell
	* below.
	*
	* If in the table below cell "b" is split into 3 cells:
	*
	*  +---+---+---+
	*  | a | b | c |
	*  +---+---+---+
	*  | d | e | f |
	*  +---+---+---+
	*
	* It will result in the table below:
	*
	*  +---+---+---+
	*  | a | b | c |
	*  +   +---+   +
	*  |   |   |   |
	*  +   +---+   +
	*  |   |   |   |
	*  +---+---+---+
	*  | d | e | f |
	*  +---+---+---+
	*
	* So cells "a" and "b" will get their `rowspan` updated to `3` and 2 rows with a single cell will be added.
	*
	* Splitting a cell that already has a `rowspan` attribute set will distribute the cell `rowspan` evenly and the remainder
	* will be left to the original cell:
	*
	*  +---+---+---+
	*  | a | b | c |
	*  +   +---+---+
	*  |   | d | e |
	*  +   +---+---+
	*  |   | f | g |
	*  +   +---+---+
	*  |   | h | i |
	*  +---+---+---+
	*
	* Splitting cell "a" with `rowspan=4` into 3 cells will create 2 cells with a `rowspan=1` and cell "a" will have `rowspan=2`:
	*
	*  +---+---+---+
	*  | a | b | c |
	*  +   +---+---+
	*  |   | d | e |
	*  +---+---+---+
	*  |   | f | g |
	*  +---+---+---+
	*  |   | h | i |
	*  +---+---+---+
	*/ splitCellHorizontally(tableCell, numberOfCells = 2) {
        const model = this.editor.model;
        const tableRow = tableCell.parent;
        const table = tableRow.parent;
        const splitCellRow = table.getChildIndex(tableRow);
        const rowspan = parseInt(tableCell.getAttribute("rowspan") || "1");
        const colspan = parseInt(tableCell.getAttribute("colspan") || "1");
        model.change((writer)=>{
            if (rowspan > 1) {
                const tableMap = [
                    ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
                        startRow: splitCellRow,
                        endRow: splitCellRow + rowspan - 1,
                        includeAllSlots: true
                    })
                ];
                const { newCellsSpan: newCellsSpan, updatedSpan: updatedSpan } = $f1b97c36043e973c$var$breakSpanEvenly(rowspan, numberOfCells);
                $f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", updatedSpan, tableCell, writer);
                const { column: cellColumn } = tableMap.find(({ cell: cell })=>cell === tableCell);
                const newCellsAttributes = {};
                if (newCellsSpan > 1) newCellsAttributes.rowspan = newCellsSpan;
                if (colspan > 1) newCellsAttributes.colspan = colspan;
                let distanceFromLastCellSpan = 0;
                for (const tableSlot of tableMap){
                    const { column: column, row: row } = tableSlot;
                    const isAfterSplitCell = row >= splitCellRow + updatedSpan;
                    const isOnSameColumn = column === cellColumn;
                    if (distanceFromLastCellSpan >= newCellsSpan && isOnSameColumn) distanceFromLastCellSpan = 0;
                    if (isAfterSplitCell && isOnSameColumn) {
                        if (!distanceFromLastCellSpan) $f1b97c36043e973c$var$createCells(1, writer, tableSlot.getPositionBefore(), newCellsAttributes);
                        distanceFromLastCellSpan++;
                    }
                }
            }
            if (rowspan < numberOfCells) {
                const cellsToInsert = numberOfCells - rowspan;
                const rowCountBefore = this.getRows(table);
                const tableMap = [
                    ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
                        startRow: 0,
                        endRow: splitCellRow
                    })
                ];
                for (const { cell: cell, cellHeight: cellHeight, row: row } of tableMap)if (cell !== tableCell && row + cellHeight > splitCellRow) {
                    const rowspanToSet = cellHeight + cellsToInsert;
                    writer.setAttribute("rowspan", rowspanToSet, cell);
                }
                const newCellsAttributes = {};
                if (colspan > 1) newCellsAttributes.colspan = colspan;
                $f1b97c36043e973c$var$createEmptyRows(writer, table, splitCellRow + 1, cellsToInsert, 1, newCellsAttributes);
                const headingRows = table.getAttribute("headingRows") || 0;
                if (headingRows > splitCellRow) $f1b97c36043e973c$export$fd08c984b28fd00a("headingRows", headingRows + cellsToInsert, table, writer);
                const footerRows = table.getAttribute("footerRows") || 0;
                if (rowCountBefore - footerRows <= splitCellRow) $f1b97c36043e973c$export$fd08c984b28fd00a("footerRows", footerRows + cellsToInsert, table, writer);
            }
        });
    }
    /**
	* Returns the number of columns for a given table.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).getColumns( table );
	* ```
	*
	* @param table The table to analyze.
	*/ getColumns(table) {
        return [
            ...table.getChild(0).getChildren()
        ].filter((node)=>node.is("element", "tableCell")).reduce((columns, row)=>{
            return columns + parseInt(row.getAttribute("colspan") || "1");
        }, 0);
    }
    /**
	* Returns the number of rows for a given table. Any other element present in the table model is omitted.
	*
	* ```ts
	* editor.plugins.get( 'TableUtils' ).getRows( table );
	* ```
	*
	* @param table The table to analyze.
	*/ getRows(table) {
        return Array.from(table.getChildren()).reduce((rowCount, child)=>child.is("element", "tableRow") ? rowCount + 1 : rowCount, 0);
    }
    /**
	* Creates an instance of the table walker.
	*
	* The table walker iterates internally by traversing the table from row index = 0 and column index = 0.
	* It walks row by row and column by column in order to output values defined in the options.
	* By default it will output only the locations that are occupied by a cell. To include also spanned rows and columns,
	* pass the `includeAllSlots` option.
	*
	* @internal
	* @param table A table over which the walker iterates.
	* @param options An object with configuration.
	*/ createTableWalker(table, options = {}) {
        return new $f1b97c36043e973c$export$6c270156410e802f(table, options);
    }
    /**
	* Returns all model table cells that are fully selected (from the outside)
	* within the provided model selection's ranges.
	*
	* To obtain the cells selected from the inside, use
	* {@link #getTableCellsContainingSelection}.
	*/ getSelectedTableCells(selection) {
        const cells = [];
        for (const range of this.sortRanges(selection.getRanges())){
            const element = range.getContainedElement();
            if (element && element.is("element", "tableCell")) cells.push(element);
        }
        return cells;
    }
    /**
	* Sets the number of footer rows for the given `table`.
	*
	* * If number of footer rows is greater than the number of rows in the table, it will be truncated to the number of rows.
	* * If footer rows and heading rows overlap, the number of heading rows will be adjusted
	*
	* It'll have no effect if {@link module:table/tableconfig~TableConfig#enableFooters `table.enableFooters`} is set to `false`.
	*
	* @param writer The model writer.
	* @param table The table model element.
	* @param footerRows The number of footer rows to set.
	*/ setFooterRowsCount(writer, table, footerRows) {
        if (!this.editor.config.get("table.enableFooters")) return;
        const headingRows = table.getAttribute("headingRows") || 0;
        const totalRows = this.getRows(table);
        const truncatedFooterRows = Math.min(footerRows, totalRows);
        $f1b97c36043e973c$export$fd08c984b28fd00a("footerRows", truncatedFooterRows, table, writer, 0);
        if (headingRows + truncatedFooterRows > totalRows) {
            const newHeadingRows = totalRows - truncatedFooterRows;
            this.setHeadingRowsCount(writer, table, newHeadingRows);
        }
    }
    /**
	* Sets the number of heading rows for the given `table`.
	*
	* If number of heading rows is greater than the number of rows in the table,
	* it will be truncated to the number of rows.
	*
	* @param writer The model writer.
	* @param table The table model element.
	* @param headingRows The number of heading rows to set.
	* @param options Additional options.
	* @param options.updateCellType If set to `false` it will only update the `headingRows` attribute
	* without updating the cell types in the table. Default is `true`.
	* @param options.resetFormerHeadingCells If set to `true`, it will check if the rows that are no longer in the heading section
	* should be updated to body cells. Default is `true`.
	* @param options.autoExpand If set to `true`, it will check if the following rows look like a header and expand the heading section.
	* Default is `true`.
	*/ setHeadingRowsCount(writer, table, headingRows, options = {}) {
        const { updateCellType: updateCellType = true, resetFormerHeadingCells: resetFormerHeadingCells = true, autoExpand: autoExpand = true } = options;
        const totalRows = this.getRows(table);
        const scopedHeaders = !!this.editor.config.get("table.tableCellProperties.scopedHeaders");
        const oldHeadingRows = table.getAttribute("headingRows") || 0;
        let truncatedHeadingRows = Math.min(headingRows, totalRows);
        if (truncatedHeadingRows === oldHeadingRows) return;
        $f1b97c36043e973c$export$fd08c984b28fd00a("headingRows", truncatedHeadingRows, table, writer, 0);
        const footerRows = table.getAttribute("footerRows") || 0;
        if (truncatedHeadingRows + footerRows > totalRows) {
            const newFooterRows = totalRows - truncatedHeadingRows;
            this.setFooterRowsCount(writer, table, newFooterRows);
        }
        if (!$f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)) return;
        if (updateCellType) {
            for (const { cell: cell, row: row, column: column } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
                endRow: truncatedHeadingRows - 1
            }))$f1b97c36043e973c$var$updateTableCellType({
                table: table,
                writer: writer,
                cell: cell,
                row: row,
                column: column,
                scopedHeaders: scopedHeaders
            });
            if (resetFormerHeadingCells && truncatedHeadingRows < oldHeadingRows) for(let row = truncatedHeadingRows; row < oldHeadingRows; row++){
                if (!$f1b97c36043e973c$var$isEntireCellsLineHeader({
                    table: table,
                    row: row
                })) break;
                for (const { cell: cell, row: cellRow, column: column } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
                    row: row
                }))$f1b97c36043e973c$var$updateTableCellType({
                    table: table,
                    writer: writer,
                    cell: cell,
                    row: cellRow,
                    column: column,
                    scopedHeaders: scopedHeaders
                });
            }
        }
        if (autoExpand && truncatedHeadingRows > oldHeadingRows) {
            while(truncatedHeadingRows < totalRows && $f1b97c36043e973c$var$isEntireCellsLineHeader({
                table: table,
                row: truncatedHeadingRows
            }))truncatedHeadingRows++;
            $f1b97c36043e973c$export$fd08c984b28fd00a("headingRows", truncatedHeadingRows, table, writer, 0);
        }
    }
    /**
	* Sets the number of heading columns for the given `table`.
	*
	* If number of heading columns is greater than the number of columns in the table,
	* it will be truncated to the number of columns.
	*
	* @param writer The model writer to use.
	* @param table The table model element.
	* @param headingColumns The number of heading columns to set.
	* @param options Additional options.
	* @param options.updateCellType If set to `false` it will only update the `headingColumns` attribute
	* without updating the cell types in the table. Default is `true`.
	* @param options.resetFormerHeadingCells If set to `true`, it will check if the columns that are no longer in the heading section
	* should be updated to body cells. Default is `true`.
	* @param options.autoExpand If set to `true`, it will check if the following columns look like a header and expand the heading section.
	* Default is `true`.
	*/ setHeadingColumnsCount(writer, table, headingColumns, options = {}) {
        const { updateCellType: updateCellType = true, resetFormerHeadingCells: resetFormerHeadingCells = true, autoExpand: autoExpand = true } = options;
        const totalColumns = this.getColumns(table);
        const oldHeadingColumns = table.getAttribute("headingColumns") || 0;
        const scopedHeaders = !!this.editor.config.get("table.tableCellProperties.scopedHeaders");
        let truncatedHeadingColumns = Math.min(headingColumns, totalColumns);
        if (truncatedHeadingColumns === oldHeadingColumns) return;
        $f1b97c36043e973c$export$fd08c984b28fd00a("headingColumns", truncatedHeadingColumns, table, writer, 0);
        if (!$f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)) return;
        if (updateCellType) {
            for (const { cell: cell, row: row, column: column } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
                endColumn: truncatedHeadingColumns - 1
            }))$f1b97c36043e973c$var$updateTableCellType({
                table: table,
                writer: writer,
                cell: cell,
                row: row,
                column: column,
                scopedHeaders: scopedHeaders
            });
            if (resetFormerHeadingCells && truncatedHeadingColumns < oldHeadingColumns) for(let column = truncatedHeadingColumns; column < oldHeadingColumns; column++){
                if (!$f1b97c36043e973c$var$isEntireCellsLineHeader({
                    table: table,
                    column: column
                })) break;
                for (const { cell: cell, row: row, column: cellColumn } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
                    column: column
                }))$f1b97c36043e973c$var$updateTableCellType({
                    table: table,
                    writer: writer,
                    cell: cell,
                    row: row,
                    column: cellColumn,
                    scopedHeaders: scopedHeaders
                });
            }
        }
        if (autoExpand && truncatedHeadingColumns > oldHeadingColumns) {
            while(truncatedHeadingColumns < totalColumns && $f1b97c36043e973c$var$isEntireCellsLineHeader({
                table: table,
                column: truncatedHeadingColumns
            }))truncatedHeadingColumns++;
            $f1b97c36043e973c$export$fd08c984b28fd00a("headingColumns", truncatedHeadingColumns, table, writer, 0);
        }
    }
    /**
	* Returns all model table cells that the provided model selection's ranges
	* {@link module:engine/model/range~ModelRange#start} inside.
	*
	* To obtain the cells selected from the outside, use
	* {@link #getSelectedTableCells}.
	*/ getTableCellsContainingSelection(selection) {
        const cells = [];
        for (const range of selection.getRanges()){
            const cellWithSelection = range.start.findAncestor("tableCell");
            if (cellWithSelection) cells.push(cellWithSelection);
        }
        return cells;
    }
    /**
	* Returns all model table cells that are either completely selected
	* by selection ranges or host selection range
	* {@link module:engine/model/range~ModelRange#start start positions} inside them.
	*
	* Combines {@link #getTableCellsContainingSelection} and
	* {@link #getSelectedTableCells}.
	*/ getSelectionAffectedTableCells(selection) {
        const selectedCells = this.getSelectedTableCells(selection);
        if (selectedCells.length) return selectedCells;
        return this.getTableCellsContainingSelection(selection);
    }
    /**
	* Returns an object with the `first` and `last` row index contained in the given `tableCells`.
	*
	* ```ts
	* const selectedTableCells = getSelectedTableCells( editor.model.document.selection );
	*
	* const { first, last } = getRowIndexes( selectedTableCells );
	*
	* console.log( `Selected rows: ${ first } to ${ last }` );
	* ```
	*
	* @returns Returns an object with the `first` and `last` table row indexes.
	*/ getRowIndexes(tableCells) {
        const indexes = tableCells.map((cell)=>cell.parent.index);
        return this._getFirstLastIndexesObject(indexes);
    }
    /**
	* Returns an object with the `first` and `last` column index contained in the given `tableCells`.
	*
	* ```ts
	* const selectedTableCells = getSelectedTableCells( editor.model.document.selection );
	*
	* const { first, last } = getColumnIndexes( selectedTableCells );
	*
	* console.log( `Selected columns: ${ first } to ${ last }` );
	* ```
	*
	* @returns Returns an object with the `first` and `last` table column indexes.
	*/ getColumnIndexes(tableCells) {
        const table = tableCells[0].findAncestor("table");
        const indexes = [
            ...new $f1b97c36043e973c$export$6c270156410e802f(table)
        ].filter((entry)=>tableCells.includes(entry.cell)).map((entry)=>entry.column);
        return this._getFirstLastIndexesObject(indexes);
    }
    /**
	* Checks if the selection contains cells that do not exceed rectangular selection.
	*
	* In a table below:
	*
	*  ┌───┬───┬───┬───┐
	*  │ a │ b │ c │ d │
	*  ├───┴───┼───┤   │
	*  │ e     │ f │   │
	*  │       ├───┼───┤
	*  │       │ g │ h │
	*  └───────┴───┴───┘
	*
	* Valid selections are these which create a solid rectangle (without gaps), such as:
	*   - a, b (two horizontal cells)
	*   - c, f (two vertical cells)
	*   - a, b, e (cell "e" spans over four cells)
	*   - c, d, f (cell d spans over a cell in the row below)
	*
	* While an invalid selection would be:
	*   - a, c (the unselected cell "b" creates a gap)
	*   - f, g, h (cell "d" spans over a cell from the row of "f" cell - thus creates a gap)
	*/ isSelectionRectangular(selectedTableCells) {
        if (selectedTableCells.length < 2 || !this._areCellInTheSameTableSection(selectedTableCells)) return false;
        const rows = /* @__PURE__ */ new Set();
        const columns = /* @__PURE__ */ new Set();
        let areaOfSelectedCells = 0;
        for (const tableCell of selectedTableCells){
            const { row: row, column: column } = this.getCellLocation(tableCell);
            const rowspan = parseInt(tableCell.getAttribute("rowspan")) || 1;
            const colspan = parseInt(tableCell.getAttribute("colspan")) || 1;
            rows.add(row);
            columns.add(column);
            if (rowspan > 1) rows.add(row + rowspan - 1);
            if (colspan > 1) columns.add(column + colspan - 1);
            areaOfSelectedCells += rowspan * colspan;
        }
        return $f1b97c36043e973c$var$getBiggestRectangleArea(rows, columns) == areaOfSelectedCells;
    }
    /**
	* Returns array of sorted ranges.
	*/ sortRanges(ranges) {
        return Array.from(ranges).sort($f1b97c36043e973c$var$compareRangeOrder);
    }
    /**
	* Helper method to get an object with `first` and `last` indexes from an unsorted array of indexes.
	*/ _getFirstLastIndexesObject(indexes) {
        const allIndexesSorted = indexes.sort((indexA, indexB)=>indexA - indexB);
        return {
            first: allIndexesSorted[0],
            last: allIndexesSorted[allIndexesSorted.length - 1]
        };
    }
    /**
	* Checks if the selection does not mix a header (column or row) with other cells.
	*
	* For instance, in the table below valid selections consist of cells with the same letter only.
	* So, a-a (same heading row and column) or d-d (body cells) are valid while c-d or a-b are not.
	*
	* header columns
	*    ↓   ↓
	*  ┌───┬───┬───┬───┐
	*  │ a │ a │ b │ b │  ← header row
	*  ├───┼───┼───┼───┤
	*  │ c │ c │ d │ d │
	*  ├───┼───┼───┼───┤
	*  │ c │ c │ d │ d │
	*  └───┴───┴───┴───┘
	*/ _areCellInTheSameTableSection(tableCells) {
        const table = tableCells[0].findAncestor("table");
        const totalRows = this.getRows(table);
        const rowIndexes = this.getRowIndexes(tableCells);
        const headingRows = parseInt(table.getAttribute("headingRows")) || 0;
        const footerRows = parseInt(table.getAttribute("footerRows")) || 0;
        if (!this._areIndexesInSameHeadingSection(rowIndexes, headingRows) || !this._areIndexesInSameFooterSection(rowIndexes, totalRows, footerRows)) return false;
        const columnIndexes = this.getColumnIndexes(tableCells);
        const headingColumns = parseInt(table.getAttribute("headingColumns")) || 0;
        return this._areIndexesInSameHeadingSection(columnIndexes, headingColumns);
    }
    /**
	* Unified check if table rows/columns indexes are in the same heading/body section.
	*/ _areIndexesInSameHeadingSection({ first: first, last: last }, headingSectionSize) {
        return first < headingSectionSize === last < headingSectionSize;
    }
    /**
	* Unified check if table rows indexes are in the same footer/body section.
	*/ _areIndexesInSameFooterSection({ first: first, last: last }, totalRows, footerRows) {
        const footerStartIndex = totalRows - footerRows;
        return first >= footerStartIndex === last >= footerStartIndex;
    }
};
/**
* Creates empty rows at the given index in an existing table.
*
* @param insertAt The row index of row insertion.
* @param rows The number of rows to create.
* @param tableCellToInsert The number of cells to insert in each row.
*/ function $f1b97c36043e973c$var$createEmptyRows(writer, table, insertAt, rows, tableCellToInsert, attributes = {}) {
    const insertedRows = [];
    for(let i = 0; i < rows; i++){
        const tableRow = writer.createElement("tableRow");
        writer.insert(tableRow, table, insertAt);
        insertedRows.push($f1b97c36043e973c$var$createCells(tableCellToInsert, writer, writer.createPositionAt(tableRow, "end"), attributes));
    }
    return insertedRows;
}
/**
* Creates cells at a given position.
*
* @param cells The number of cells to create
*/ function $f1b97c36043e973c$var$createCells(cells, writer, insertPosition, attributes = {}) {
    const createdCells = [];
    let currentPosition = insertPosition;
    for(let i = 0; i < cells; i++){
        const cell = $f1b97c36043e973c$export$6912bf35f0593a83(writer, currentPosition, attributes);
        createdCells.push(cell);
        currentPosition = writer.createPositionAfter(cell);
    }
    return createdCells;
}
/**
* Evenly distributes the span of a cell to a number of provided cells.
* The resulting spans will always be integer values.
*
* For instance breaking a span of 7 into 3 cells will return:
*
* ```ts
* { newCellsSpan: 2, updatedSpan: 3 }
* ```
*
* as two cells will have a span of 2 and the remainder will go the first cell so its span will change to 3.
*
* @param span The span value do break.
* @param numberOfCells The number of resulting spans.
*/ function $f1b97c36043e973c$var$breakSpanEvenly(span, numberOfCells) {
    if (span < numberOfCells) return {
        newCellsSpan: 1,
        updatedSpan: 1
    };
    const newCellsSpan = Math.floor(span / numberOfCells);
    return {
        newCellsSpan: newCellsSpan,
        updatedSpan: span - newCellsSpan * numberOfCells + newCellsSpan
    };
}
/**
* Updates heading columns attribute if removing a row from head section.
*/ function $f1b97c36043e973c$var$adjustHeadingColumns(table, removedColumnIndexes, writer) {
    const headingColumns = table.getAttribute("headingColumns") || 0;
    if (headingColumns && removedColumnIndexes.first < headingColumns) {
        const headingsRemoved = Math.min(headingColumns - 1, removedColumnIndexes.last) - removedColumnIndexes.first + 1;
        writer.setAttribute("headingColumns", headingColumns - headingsRemoved, table);
    }
}
/**
* Calculates a new heading rows value for removing rows from heading section.
*/ function $f1b97c36043e973c$var$updateHeadingRows(table, { first: first, last: last }, writer) {
    const headingRows = table.getAttribute("headingRows") || 0;
    if (first < headingRows) {
        const newRows = last < headingRows ? headingRows - (last - first + 1) : first;
        $f1b97c36043e973c$export$fd08c984b28fd00a("headingRows", newRows, table, writer, 0);
    }
}
/**
* Calculates a new footer rows value for removing rows from footer section.
*/ function $f1b97c36043e973c$var$updateFooterRows(table, totalRows, { first: first, last: last }, writer) {
    if (!table.hasAttribute("footerRows")) return;
    const footerRows = table.getAttribute("footerRows");
    const footerIndex = totalRows - footerRows;
    if (last >= footerIndex) {
        const newRows = first >= footerIndex ? footerRows - (last - first + 1) : totalRows - 1 - last;
        $f1b97c36043e973c$export$fd08c984b28fd00a("footerRows", newRows, table, writer, 0);
    }
}
/**
* Finds cells that will be:
* - trimmed - Cells that are "above" removed rows sections and overlap the removed section - their rowspan must be trimmed.
* - moved - Cells from removed rows section might stick out of. These cells are moved to the next row after a removed section.
*
* Sample table with overlapping & sticking out cells:
*
*      +----+----+----+----+----+
*      | 00 | 01 | 02 | 03 | 04 |
*      +----+    +    +    +    +
*      | 10 |    |    |    |    |
*      +----+----+    +    +    +
*      | 20 | 21 |    |    |    | <-- removed row
*      +    +    +----+    +    +
*      |    |    | 32 |    |    | <-- removed row
*      +----+    +    +----+    +
*      | 40 |    |    | 43 |    |
*      +----+----+----+----+----+
*
* In a table above:
* - cells to trim: '02', '03' & '04'.
* - cells to move: '21' & '32'.
*/ function $f1b97c36043e973c$var$getCellsToMoveAndTrimOnRemoveRow(table, { first: first, last: last }) {
    const cellsToMove = /* @__PURE__ */ new Map();
    const cellsToTrim = [];
    for (const { row: row, column: column, cellHeight: cellHeight, cell: cell } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
        endRow: last
    })){
        const lastRowOfCell = row + cellHeight - 1;
        if (row >= first && row <= last && lastRowOfCell > last) {
            const rowSpanToSet = cellHeight - (last - row + 1);
            cellsToMove.set(column, {
                cell: cell,
                rowspan: rowSpanToSet
            });
        }
        if (row < first && lastRowOfCell >= first) {
            let rowspanAdjustment;
            if (lastRowOfCell >= last) rowspanAdjustment = last - first + 1;
            else rowspanAdjustment = lastRowOfCell - first + 1;
            cellsToTrim.push({
                cell: cell,
                rowspan: cellHeight - rowspanAdjustment
            });
        }
    }
    return {
        cellsToMove: cellsToMove,
        cellsToTrim: cellsToTrim
    };
}
function $f1b97c36043e973c$var$moveCellsToRow(table, targetRowIndex, cellsToMove, writer) {
    const tableRowMap = [
        ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
            includeAllSlots: true,
            row: targetRowIndex
        })
    ];
    const row = table.getChild(targetRowIndex);
    let previousCell;
    for (const { column: column, cell: cell, isAnchor: isAnchor } of tableRowMap)if (cellsToMove.has(column)) {
        const { cell: cellToMove, rowspan: rowspan } = cellsToMove.get(column);
        const targetPosition = previousCell ? writer.createPositionAfter(previousCell) : writer.createPositionAt(row, 0);
        writer.move(writer.createRangeOn(cellToMove), targetPosition);
        $f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", rowspan, cellToMove, writer);
        previousCell = cellToMove;
    } else if (isAnchor) previousCell = cell;
}
function $f1b97c36043e973c$var$compareRangeOrder(rangeA, rangeB) {
    const posA = rangeA.start;
    const posB = rangeB.start;
    return posA.isBefore(posB) ? -1 : 1;
}
/**
* Calculates the area of a maximum rectangle that can span over the provided row & column indexes.
*/ function $f1b97c36043e973c$var$getBiggestRectangleArea(rows, columns) {
    const rowsIndexes = Array.from(rows.values());
    const columnIndexes = Array.from(columns.values());
    const lastRow = Math.max(...rowsIndexes);
    const firstRow = Math.min(...rowsIndexes);
    const lastColumn = Math.max(...columnIndexes);
    const firstColumn = Math.min(...columnIndexes);
    return (lastRow - firstRow + 1) * (lastColumn - firstColumn + 1);
}
/**
* Updates the `tableCellType` attribute of a table cell based on its position in the table
* and the table's `headingRows` and `headingColumns` attributes.
*/ function $f1b97c36043e973c$var$updateTableCellType({ writer: writer, table: table, row: row, column: column, cell: cell, scopedHeaders: scopedHeaders }) {
    const headingRows = table.getAttribute("headingRows") || 0;
    const headingColumns = table.getAttribute("headingColumns") || 0;
    if (row >= headingRows && column >= headingColumns) {
        writer.removeAttribute("tableCellType", cell);
        return;
    }
    let headerCellType = "header";
    if (scopedHeaders) {
        if (row < headingRows) headerCellType = "header-column";
        else headerCellType = "header-row";
    }
    writer.setAttribute("tableCellType", headerCellType, cell);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a string if all four values of box sides are equal.
*
* If a string is passed, it is treated as a single value (pass-through).
*
* ```ts
* // Returns 'foo':
* getSingleValue( { top: 'foo', right: 'foo', bottom: 'foo', left: 'foo' } );
* getSingleValue( 'foo' );
*
* // Returns undefined:
* getSingleValue( { top: 'foo', right: 'foo', bottom: 'bar', left: 'foo' } );
* getSingleValue( { top: 'foo', right: 'foo' } );
* ```
*
* @internal
*/ function $f1b97c36043e973c$export$6baee843575e6ef2(objectOrString) {
    if (!objectOrString || !(0, $f5c24f51e6d4a764$export$a6cdc56e425d0d0a)(objectOrString)) return objectOrString;
    const { top: top, right: right, bottom: bottom, left: left } = objectOrString;
    if (top == right && right == bottom && bottom == left) return top;
}
/**
* Adds a unit to a value if the value is a number or a string representing a number.
*
* **Note**: It does nothing to non-numeric values.
*
* ```ts
* getSingleValue( 25, 'px' ); // '25px'
* getSingleValue( 25, 'em' ); // '25em'
* getSingleValue( '25em', 'px' ); // '25em'
* getSingleValue( 'foo', 'px' ); // 'foo'
* ```
*
* @internal
* @param defaultUnit A default unit added to a numeric value.
*/ function $f1b97c36043e973c$export$d3891b194d68f193(value, defaultUnit) {
    const numericValue = parseFloat(value);
    if (Number.isNaN(numericValue)) return value;
    if (String(numericValue) !== String(value)) return value;
    return `${numericValue}${defaultUnit}`;
}
/**
* Returns the normalized configuration.
*
* @internal
* @param config The configuration to normalize.
* @param options Options used to determine which properties should be added.
*/ function $f1b97c36043e973c$export$6f5bcdb88bd6afde(config, options = {}) {
    const normalizedConfig = {
        borderStyle: "none",
        borderWidth: "",
        borderColor: "",
        backgroundColor: "",
        width: "",
        height: "",
        ...config
    };
    if (options.includeAlignmentProperty && !normalizedConfig.alignment) normalizedConfig.alignment = "center";
    if (options.includePaddingProperty && !normalizedConfig.padding) normalizedConfig.padding = "";
    if (options.includeVerticalAlignmentProperty && !normalizedConfig.verticalAlignment) normalizedConfig.verticalAlignment = "middle";
    if (options.includeHorizontalAlignmentProperty && !normalizedConfig.horizontalAlignment) normalizedConfig.horizontalAlignment = options.isRightToLeftContent ? "right" : "left";
    return normalizedConfig;
}
/**
* Returns the normalized default table properties.
*
* @internal
* @param config The configuration to normalize.
* @param options Options used to determine which properties should be added.
*/ function $f1b97c36043e973c$export$c0582ddd10a12af8(config, options) {
    return $f1b97c36043e973c$export$6f5bcdb88bd6afde({
        borderStyle: "double",
        borderColor: "hsl(0, 0%, 70%)",
        borderWidth: "1px",
        ...config
    }, options);
}
/**
* Returns the normalized default cell properties.
*
* @internal
* @param config The configuration to normalize.
* @param options Options used to determine which properties should be added.
*/ function $f1b97c36043e973c$export$a9dfabf838746e9b(config, options) {
    return $f1b97c36043e973c$export$6f5bcdb88bd6afde({
        borderStyle: "solid",
        borderColor: "hsl(0, 0%, 75%)",
        borderWidth: "1px",
        ...config
    }, options);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Model table element to view table element conversion helper.
*
* @internal
*/ function $f1b97c36043e973c$export$2c94aff3e633fc56(tableUtils, options) {
    return (table, { writer: writer })=>{
        const headingRows = table.getAttribute("headingRows") || 0;
        const footerRows = table.getAttribute("footerRows") || 0;
        const tableElement = writer.createContainerElement("table", null, []);
        const figureElement = writer.createContainerElement("figure", {
            class: "table"
        }, tableElement);
        const totalRows = tableUtils.getRows(table);
        if (headingRows > 0) writer.insert(writer.createPositionAt(tableElement, "end"), writer.createContainerElement("thead", null, writer.createSlot((element)=>element.is("element", "tableRow") && element.index < headingRows)));
        if (headingRows + footerRows < totalRows) writer.insert(writer.createPositionAt(tableElement, "end"), writer.createContainerElement("tbody", null, writer.createSlot((element)=>element.is("element", "tableRow") && element.index >= headingRows && element.index < totalRows - footerRows)));
        if (footerRows > 0) writer.insert(writer.createPositionAt(tableElement, "end"), writer.createContainerElement("tfoot", null, writer.createSlot((element)=>element.is("element", "tableRow") && element.index >= totalRows - footerRows)));
        for (const { positionOffset: positionOffset, filter: filter } of options.additionalSlots)writer.insert(writer.createPositionAt(tableElement, positionOffset), writer.createSlot(filter));
        writer.insert(writer.createPositionAt(tableElement, "after"), writer.createSlot((element)=>{
            if (element.is("element", "tableRow")) return false;
            return !options.additionalSlots.some(({ filter: filter })=>filter(element));
        }));
        return options.asWidget ? $f1b97c36043e973c$var$toTableWidget(figureElement, writer) : figureElement;
    };
}
/**
* Model table row element to view `<tr>` element conversion helper.
*
* @internal
* @returns Element creator.
*/ function $f1b97c36043e973c$export$1af7c99bf35fb0e2() {
    return (tableRow, { writer: writer })=>{
        return tableRow.isEmpty ? writer.createEmptyElement("tr") : writer.createContainerElement("tr");
    };
}
/**
* Model table cell element to view `<td>` or `<th>` element conversion helper.
*
* This conversion helper will create proper `<th>` elements for table cells that are in the heading section (heading row or column)
* and `<td>` otherwise.
*
* @internal
* @param options.asWidget If set to `true`, the downcast conversion will produce a widget.
* @param options.cellTypeEnabled If returns `true`, the downcast conversion will use the `tableCellType` attribute to determine cell type.
* @returns Element creator.
*/ function $f1b97c36043e973c$export$51569edd66125795(options) {
    return (tableCell, { writer: writer })=>{
        if (options.cellTypeEnabled?.()) {
            const tableCellType = tableCell.getAttribute("tableCellType");
            return createCellElement(writer, $f1b97c36043e973c$export$2d92a71c9e04bd6b(tableCellType) ? "th" : "td");
        }
        const tableRow = tableCell.parent;
        const table = tableRow.parent;
        const rowIndex = table.getChildIndex(tableRow);
        const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
            row: rowIndex
        });
        const headingRows = table.getAttribute("headingRows") || 0;
        const headingColumns = table.getAttribute("headingColumns") || 0;
        let result = null;
        for (const tableSlot of tableWalker)if (tableSlot.cell == tableCell) {
            result = createCellElement(writer, tableSlot.row < headingRows || tableSlot.column < headingColumns ? "th" : "td");
            break;
        }
        return result;
    };
    function createCellElement(writer, name) {
        return options.asWidget ? (0, $5547ab21e02f1e9e$export$f2153e4522f49b8e)(writer.createEditableElement(name), writer, {
            withAriaRole: false
        }) : writer.createContainerElement(name);
    }
}
/**
* Overrides paragraph inside table cell conversion.
*
* This converter:
* * should be used to override default paragraph conversion.
* * It will only convert `<paragraph>` placed directly inside `<tableCell>`.
* * For a single paragraph without attributes it returns `<span>` to simulate data table.
* * For all other cases it returns `<p>` element.
*
* @internal
* @param options.asWidget If set to `true`, the downcast conversion will produce a widget.
* @returns Element creator.
*/ function $f1b97c36043e973c$export$decc54eda7c35758(options = {}) {
    return (modelElement, { writer: writer })=>{
        if (!modelElement.parent.is("element", "tableCell")) return null;
        if (!$f1b97c36043e973c$export$f14d638013924718(modelElement)) return null;
        if (options.asWidget) return writer.createContainerElement("span", {
            class: "ck-table-bogus-paragraph"
        });
        else {
            const viewElement = writer.createContainerElement("p");
            writer.setCustomProperty("dataPipeline:transparentRendering", true, viewElement);
            return viewElement;
        }
    };
}
/**
* Checks if given model `<paragraph>` is an only child of a parent (`<tableCell>`) and if it has any attribute set.
*
* The paragraph should be converted in the editing view to:
*
* * If returned `true` - to a `<span class="ck-table-bogus-paragraph">`
* * If returned `false` - to a `<p>`
*
* @internal
*/ function $f1b97c36043e973c$export$f14d638013924718(modelElement) {
    return modelElement.parent.childCount == 1 && !$f1b97c36043e973c$var$hasAnyAttribute(modelElement);
}
/**
* Converts a given {@link module:engine/view/element~ViewElement} to a table widget:
* * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property}
* allowing to recognize the table widget element.
* * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
*
* @param writer An instance of the view writer.
* @param label The element's label. It will be concatenated with the table `alt` attribute if one is present.
*/ function $f1b97c36043e973c$var$toTableWidget(viewElement, writer) {
    writer.setCustomProperty("table", true, viewElement);
    return (0, $5547ab21e02f1e9e$export$83925c2318996255)(viewElement, writer, {
        hasSelectionHandle: true
    });
}
/**
* Checks if an element has any attributes set.
*/ function $f1b97c36043e973c$var$hasAnyAttribute(element) {
    for (const attributeKey of element.getAttributeKeys()){
        if (attributeKey.startsWith("selection:") || attributeKey == "htmlEmptyBlock") continue;
        return true;
    }
    return false;
}
/**
* Downcasts a plain table (also used in the clipboard pipeline).
*/ function $f1b97c36043e973c$var$convertPlainTable(editor) {
    return (table, conversionApi)=>{
        const hasPlainTableOutput = editor.plugins.has("PlainTableOutput");
        const isClipboardPipeline = conversionApi.options.isClipboardPipeline;
        const stripFigureTagWithLayoutTable = $f1b97c36043e973c$var$shouldStripFigureTagWithLayoutTable(editor, table);
        if (hasPlainTableOutput || stripFigureTagWithLayoutTable || isClipboardPipeline) return $f1b97c36043e973c$var$downcastPlainTable(table, conversionApi, editor);
        return null;
    };
}
/**
* Downcasts a plain table caption (also used in the clipboard pipeline).
*/ function $f1b97c36043e973c$var$convertPlainTableCaption(editor) {
    return (modelElement, { writer: writer, options: options })=>{
        const hasPlainTableOutput = editor.plugins.has("PlainTableOutput");
        const isClipboardPipeline = options.isClipboardPipeline;
        const stripFigureTagWithLayoutTable = $f1b97c36043e973c$var$shouldStripFigureTagWithLayoutTable(editor, modelElement);
        if (!(hasPlainTableOutput || stripFigureTagWithLayoutTable || isClipboardPipeline)) return null;
        if (modelElement.parent.name === "table") return writer.createContainerElement("caption");
        return null;
    };
}
/**
* Downcasts a plain table.
*
* @param table Table model element.
* @param conversionApi The conversion API object.
* @param editor The editor instance.
* @returns Created element.
*/ function $f1b97c36043e973c$var$downcastPlainTable(table, conversionApi, editor) {
    const tableUtils = editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
    const writer = conversionApi.writer;
    const totalRows = tableUtils.getRows(table);
    const headingRows = table.getAttribute("headingRows") || 0;
    const footerRows = table.getAttribute("footerRows") || 0;
    const footerIndex = totalRows - footerRows;
    const headRowsSlot = writer.createSlot((element)=>element.is("element", "tableRow") && element.index < headingRows);
    const bodyRowsSlot = writer.createSlot((element)=>element.is("element", "tableRow") && element.index >= headingRows && element.index < footerIndex);
    const footerRowsSlot = writer.createSlot((element)=>element.is("element", "tableRow") && element.index >= footerIndex);
    const childrenSlot = writer.createSlot((element)=>!element.is("element", "tableRow"));
    const theadElement = writer.createContainerElement("thead", null, headRowsSlot);
    const tbodyElement = writer.createContainerElement("tbody", null, bodyRowsSlot);
    const tfootElement = writer.createContainerElement("tfoot", null, footerRowsSlot);
    const tableContentElements = [];
    if (headingRows) tableContentElements.push(theadElement);
    if (headingRows + footerRows < totalRows) tableContentElements.push(tbodyElement);
    if (footerRows) tableContentElements.push(tfootElement);
    const tableAttributes = {
        class: "table"
    };
    if (editor.plugins.has("TablePropertiesEditing") && conversionApi.options.isClipboardPipeline) {
        const defaultTableProperties = $f1b97c36043e973c$export$c0582ddd10a12af8(editor.config.get("table.tableProperties.defaultProperties"), {
            includeAlignmentProperty: true
        });
        const tableAlignment = table.getAttribute("tableAlignment");
        let localDefaultValue = defaultTableProperties.alignment;
        if (table.getAttribute("tableType") === "layout") localDefaultValue = "";
        const tableAlignmentValue = tableAlignment || localDefaultValue;
        if (tableAlignmentValue) {
            tableAttributes.class += " " + $f1b97c36043e973c$var$downcastTableAlignmentConfig[tableAlignmentValue].className;
            tableAttributes.style = $f1b97c36043e973c$var$downcastTableAlignmentConfig[tableAlignmentValue].style;
            if ($f1b97c36043e973c$var$downcastTableAlignmentConfig[tableAlignmentValue].align !== void 0) tableAttributes.align = $f1b97c36043e973c$var$downcastTableAlignmentConfig[tableAlignmentValue].align;
        }
    }
    return writer.createContainerElement("table", tableAttributes, [
        childrenSlot,
        ...tableContentElements
    ]);
}
/**
* Registers border and background attributes converters for plain tables or when the clipboard pipeline is used.
*/ function $f1b97c36043e973c$var$downcastTableBorderAndBackgroundAttributes(editor) {
    for (const [styleName, modelAttribute] of Object.entries({
        "border-width": "tableBorderWidth",
        "border-color": "tableBorderColor",
        "border-style": "tableBorderStyle",
        "background-color": "tableBackgroundColor"
    }))editor.conversion.for("dataDowncast").add((dispatcher)=>{
        return dispatcher.on(`attribute:${modelAttribute}:table`, (evt, data, conversionApi)=>{
            const { item: item, attributeNewValue: attributeNewValue } = data;
            const { mapper: mapper, writer: writer } = conversionApi;
            const hasPlainTableOutput = editor.plugins.has("PlainTableOutput");
            const isClipboardPipeline = conversionApi.options.isClipboardPipeline;
            const stripFigureTagWithLayoutTable = $f1b97c36043e973c$var$shouldStripFigureTagWithLayoutTable(editor, item);
            if (!(hasPlainTableOutput || stripFigureTagWithLayoutTable || isClipboardPipeline)) return;
            if (!conversionApi.consumable.consume(item, evt.name)) return;
            const table = mapper.toViewElement(item);
            if (attributeNewValue) writer.setStyle(styleName, attributeNewValue, table);
            else writer.removeStyle(styleName, table);
        }, {
            priority: "high"
        });
    });
}
/**
* Returns `true` if the figure tag should be stripped when using layout tables and when `tableType` is `layout`
* or `stripFigureFromContentTable` option is set to `true`, `false` otherwise.
*
* @param editor The editor instance.
* @param modelElement The model element to check.
* @returns `true` if the figure tag should be stripped, `false` otherwise.
*/ function $f1b97c36043e973c$var$shouldStripFigureTagWithLayoutTable(editor, modelElement) {
    const hasTableLayout = editor.plugins.has("TableLayoutEditing");
    const stripFigureFromContentTable = editor.config.get("table.tableLayout.stripFigureFromContentTable") ?? false;
    const tableType = modelElement.findAncestor("table", {
        includeSelf: true
    })?.getAttribute("tableType");
    return hasTableLayout && (stripFigureFromContentTable || tableType === "layout");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/inserttablecommand
*/ /**
* The insert table command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'insertTable'` editor command.
*
* To insert a table at the current selection, execute the command and specify the dimensions:
*
* ```ts
* editor.execute( 'insertTable', { rows: 20, columns: 5 } );
* ```
*/ var $f1b97c36043e973c$export$9907a752830c7653 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const schema = model.schema;
        this.isEnabled = $f1b97c36043e973c$var$isAllowedInParent$1(selection, schema);
    }
    /**
	* Executes the command.
	*
	* Inserts a table with the given number of rows and columns into the editor.
	*
	* @param options.rows The number of rows to create in the inserted table. Default value is 2.
	* @param options.columns The number of columns to create in the inserted table. Default value is 2.
	* @param options.headingRows The number of heading rows. If not provided it will default to
	* {@link module:table/tableconfig~TableConfig#defaultHeadings `config.table.defaultHeadings.rows`} table config.
	* @param options.headingColumns The number of heading columns. If not provided it will default to
	* {@link module:table/tableconfig~TableConfig#defaultHeadings `config.table.defaultHeadings.columns`} table config.
	* @param options.footerRows The number of footer rows. If not provided it will default to
	* {@link module:table/tableconfig~TableConfig#defaultFooters `config.table.defaultFooters`} table config.
	* This option is ignored when {@link module:table/tableconfig~TableConfig#enableFooters `config.table.enableFooters`} is `false`.
	* @param options.inheritTextFormattingAttributes Whether every empty cell should inherit the `copyOnEnter` text
	* formatting attributes (e.g. bold, font color) that were uniformly active in the content right before
	* the table, so that whichever cell the user starts typing in first continues that formatting. Defaults
	* to `true`.
	* @fires execute
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const tableUtils = editor.plugins.get("TableUtils");
        const areTableFootersEnabled = !!editor.config.get("table.enableFooters");
        const defaultRows = editor.config.get("table.defaultHeadings.rows");
        const defaultColumns = editor.config.get("table.defaultHeadings.columns");
        const defaultFooterRows = editor.config.get("table.defaultFooters");
        if (options.headingRows === void 0 && defaultRows) options.headingRows = defaultRows;
        if (options.headingColumns === void 0 && defaultColumns) options.headingColumns = defaultColumns;
        if (areTableFootersEnabled && options.footerRows === void 0 && defaultFooterRows) options.footerRows = defaultFooterRows;
        if (!areTableFootersEnabled && "footerRows" in options) delete options.footerRows;
        model.change((writer)=>{
            const selectionAttributesToCopy = Array.from((0, $c871651c8276dc61$export$b1d719019e4bdf35)(model.schema, selection.getAttributes()));
            const table = tableUtils.createTable(writer, options);
            model.insertObject(table, null, null, {
                findOptimalPosition: "auto"
            });
            writer.setSelection(writer.createPositionAt(table.getNodeByPath([
                0,
                0,
                0
            ]), 0));
            if (options.inheritTextFormattingAttributes !== false && selectionAttributesToCopy.length) for (const cellBlock of $f1b97c36043e973c$var$getEmptyTableCellBlocks(table))for (const [key, value] of selectionAttributesToCopy)writer.setAttribute((0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey(key), value, cellBlock);
        });
    }
};
/**
* Checks if the table is allowed in the parent.
*/ function $f1b97c36043e973c$var$isAllowedInParent$1(selection, schema) {
    const positionParent = selection.getFirstPosition().parent;
    const validParent = positionParent === positionParent.root ? positionParent : positionParent.parent;
    return schema.checkChild(validParent, "table");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/insertrowcommand
*/ /**
* The insert row command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'insertTableRowBelow'` and
* `'insertTableRowAbove'` editor commands.
*
* To insert a row below the selected cell, execute the following command:
*
* ```ts
* editor.execute( 'insertTableRowBelow' );
* ```
*
* To insert a row above the selected cell, execute the following command:
*
* ```ts
* editor.execute( 'insertTableRowAbove' );
* ```
*/ var $f1b97c36043e973c$export$59824d5e29c20d3b = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The order of insertion relative to the row in which the caret is located.
	*/ order;
    /**
	* Creates a new `InsertRowCommand` instance.
	*
	* @param editor The editor on which this command will be used.
	* @param options.order The order of insertion relative to the row in which the caret is located.
	* Possible values: `"above"` and `"below"`. Default value is "below"
	*/ constructor(editor, options = {}){
        super(editor);
        this.order = options.order || "below";
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const isAnyCellSelected = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(selection).length;
        this.isEnabled = isAnyCellSelected;
    }
    /**
	* Executes the command.
	*
	* Depending on the command's {@link #order} value, it inserts a row `'below'` or `'above'` the row in which selection is set.
	*
	* @fires execute
	*/ execute() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const tableUtils = editor.plugins.get("TableUtils");
        const insertAbove = this.order === "above";
        const affectedTableCells = tableUtils.getSelectionAffectedTableCells(selection);
        const rowIndexes = tableUtils.getRowIndexes(affectedTableCells);
        const row = insertAbove ? rowIndexes.first : rowIndexes.last;
        const table = affectedTableCells[0].findAncestor("table");
        tableUtils.insertRows(table, {
            at: insertAbove ? row : row + 1,
            copyStructureFromAbove: !insertAbove
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/insertcolumncommand
*/ /**
* The insert column command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'insertTableColumnLeft'` and
* `'insertTableColumnRight'` editor commands.
*
* To insert a column to the left of the selected cell, execute the following command:
*
* ```ts
* editor.execute( 'insertTableColumnLeft' );
* ```
*
* To insert a column to the right of the selected cell, execute the following command:
*
* ```ts
* editor.execute( 'insertTableColumnRight' );
* ```
*/ var $f1b97c36043e973c$export$4e446306fa8b3296 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The order of insertion relative to the column in which the caret is located.
	*/ order;
    /**
	* Creates a new `InsertColumnCommand` instance.
	*
	* @param editor An editor on which this command will be used.
	* @param options.order The order of insertion relative to the column in which the caret is located.
	* Possible values: `"left"` and `"right"`. Default value is "right".
	*/ constructor(editor, options = {}){
        super(editor);
        this.order = options.order || "right";
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const isAnyCellSelected = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(selection).length;
        this.isEnabled = isAnyCellSelected;
    }
    /**
	* Executes the command.
	*
	* Depending on the command's {@link #order} value, it inserts a column to the `'left'` or `'right'` of the column
	* in which the selection is set.
	*
	* @fires execute
	*/ execute() {
        const editor = this.editor;
        const selection = editor.model.document.selection;
        const tableUtils = editor.plugins.get("TableUtils");
        const insertBefore = this.order === "left";
        const affectedTableCells = tableUtils.getSelectionAffectedTableCells(selection);
        const columnIndexes = tableUtils.getColumnIndexes(affectedTableCells);
        const column = insertBefore ? columnIndexes.first : columnIndexes.last;
        const table = affectedTableCells[0].findAncestor("table");
        tableUtils.insertColumns(table, {
            columns: 1,
            at: insertBefore ? column : column + 1
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/splitcellcommand
*/ /**
* The split cell command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'splitTableCellVertically'`
* and `'splitTableCellHorizontally'`  editor commands.
*
* You can split any cell vertically or horizontally by executing this command. When multiple cells are selected, each of them
* is split, and the whole operation is a single undo step. For example, to split the selected table cells vertically:
*
* ```ts
* editor.execute( 'splitTableCellVertically' );
* ```
*/ var $f1b97c36043e973c$export$9906cc304dfd468 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The direction that indicates which cell will be split.
	*/ direction;
    /**
	* Creates a new `SplitCellCommand` instance.
	*
	* @param editor The editor on which this command will be used.
	* @param options.direction Indicates whether the command should split cells `'horizontally'` or `'vertically'`.
	*/ constructor(editor, options = {}){
        super(editor);
        this.direction = options.direction || "horizontally";
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selectedCells = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = selectedCells.length > 0;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const tableCells = tableUtils.getSelectionAffectedTableCells(this.editor.model.document.selection);
        const isHorizontal = this.direction === "horizontally";
        this.editor.model.change(()=>{
            for (const tableCell of tableCells)if (isHorizontal) tableUtils.splitCellHorizontally(tableCell, 2);
            else tableUtils.splitCellVertically(tableCell, 2);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The merge cell command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'mergeTableCellRight'`, `'mergeTableCellLeft'`,
* `'mergeTableCellUp'` and `'mergeTableCellDown'` editor commands.
*
* To merge a table cell at the current selection with another cell, execute the command corresponding with the preferred direction.
*
* For example, to merge with a cell to the right:
*
* ```ts
* editor.execute( 'mergeTableCellRight' );
* ```
*
* **Note**: If a table cell has a different [`rowspan`](https://www.w3.org/TR/html50/tabular-data.html#attr-tdth-rowspan)
* (for `'mergeTableCellRight'` and `'mergeTableCellLeft'`) or [`colspan`](https://www.w3.org/TR/html50/tabular-data.html#attr-tdth-colspan)
* (for `'mergeTableCellUp'` and `'mergeTableCellDown'`), the command will be disabled.
*/ var $f1b97c36043e973c$export$c9cb39ad3f750704 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The direction that indicates which cell will be merged with the currently selected one.
	*/ direction;
    /**
	* Whether the merge is horizontal (left/right) or vertical (up/down).
	*/ isHorizontal;
    /**
	* Creates a new `MergeCellCommand` instance.
	*
	* @param editor The editor on which this command will be used.
	* @param options.direction Indicates which cell to merge with the currently selected one.
	* Possible values are: `'left'`, `'right'`, `'up'` and `'down'`.
	*/ constructor(editor, options){
        super(editor);
        this.direction = options.direction;
        this.isHorizontal = this.direction == "right" || this.direction == "left";
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const cellToMerge = this._getMergeableCell();
        this.value = cellToMerge;
        this.isEnabled = !!cellToMerge;
    }
    /**
	* Executes the command.
	*
	* Depending on the command's {@link #direction} value, it will merge the cell that is to the `'left'`, `'right'`, `'up'` or `'down'`.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        const doc = model.document;
        const tableCell = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(doc.selection)[0];
        const cellToMerge = this.value;
        const direction = this.direction;
        model.change((writer)=>{
            const isMergeNext = direction == "right" || direction == "down";
            const cellToExpand = isMergeNext ? tableCell : cellToMerge;
            const cellToRemove = isMergeNext ? cellToMerge : tableCell;
            const removedTableCellRow = cellToRemove.parent;
            $f1b97c36043e973c$var$mergeTableCells$1(cellToRemove, cellToExpand, writer);
            const spanAttribute = this.isHorizontal ? "colspan" : "rowspan";
            const cellSpan = parseInt(tableCell.getAttribute(spanAttribute) || "1");
            const cellToMergeSpan = parseInt(cellToMerge.getAttribute(spanAttribute) || "1");
            writer.setAttribute(spanAttribute, cellSpan + cellToMergeSpan, cellToExpand);
            writer.setSelection(writer.createRangeIn(cellToExpand));
            const tableUtils = this.editor.plugins.get("TableUtils");
            const table = removedTableCellRow.findAncestor("table");
            $f1b97c36043e973c$export$5ef8873941f24b00(table, tableUtils);
        });
    }
    /**
	* Returns a cell that can be merged with the current cell depending on the command's direction.
	*/ _getMergeableCell() {
        const doc = this.editor.model.document;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const tableCell = tableUtils.getTableCellsContainingSelection(doc.selection)[0];
        if (!tableCell) return;
        const cellToMerge = this.isHorizontal ? $f1b97c36043e973c$var$getHorizontalCell(tableCell, this.direction, tableUtils) : $f1b97c36043e973c$var$getVerticalCell(tableCell, this.direction, tableUtils);
        if (!cellToMerge) return;
        const spanAttribute = this.isHorizontal ? "rowspan" : "colspan";
        const span = parseInt(tableCell.getAttribute(spanAttribute) || "1");
        if (parseInt(cellToMerge.getAttribute(spanAttribute) || "1") === span) return cellToMerge;
    }
};
/**
* Returns the cell that can be merged horizontally.
*/ function $f1b97c36043e973c$var$getHorizontalCell(tableCell, direction, tableUtils) {
    const table = tableCell.parent.parent;
    const horizontalCell = direction == "right" ? tableCell.nextSibling : tableCell.previousSibling;
    const hasHeadingColumns = (table.getAttribute("headingColumns") || 0) > 0;
    if (!horizontalCell) return;
    const cellOnLeft = direction == "right" ? tableCell : horizontalCell;
    const cellOnRight = direction == "right" ? horizontalCell : tableCell;
    const { column: leftCellColumn } = tableUtils.getCellLocation(cellOnLeft);
    const { column: rightCellColumn } = tableUtils.getCellLocation(cellOnRight);
    const leftCellSpan = parseInt(cellOnLeft.getAttribute("colspan") || "1");
    const isCellOnLeftInHeadingColumn = $f1b97c36043e973c$export$af1346de080b7559(tableUtils, cellOnLeft);
    const isCellOnRightInHeadingColumn = $f1b97c36043e973c$export$af1346de080b7559(tableUtils, cellOnRight);
    if (hasHeadingColumns && isCellOnLeftInHeadingColumn != isCellOnRightInHeadingColumn) return;
    return leftCellColumn + leftCellSpan === rightCellColumn ? horizontalCell : void 0;
}
/**
* Returns the cell that can be merged vertically.
*/ function $f1b97c36043e973c$var$getVerticalCell(tableCell, direction, tableUtils) {
    const tableRow = tableCell.parent;
    const table = tableRow.parent;
    const rowIndex = table.getChildIndex(tableRow);
    const rows = tableUtils.getRows(table);
    if (direction == "down" && rowIndex === rows - 1 || direction == "up" && rowIndex === 0) return null;
    const rowspan = parseInt(tableCell.getAttribute("rowspan") || "1");
    const headingRows = table.getAttribute("headingRows") || 0;
    const footerRows = table.getAttribute("footerRows") || 0;
    const footerIndex = rows - footerRows;
    const isMergeUpWithBodyCell = direction == "up" && rowIndex === footerIndex;
    const isMergeUpWithHeadCell = direction == "up" && rowIndex === headingRows;
    const isMergeDownWithBodyCell = direction == "down" && rowIndex + rowspan === headingRows;
    const isMergeDownWithFootCell = direction == "down" && rowIndex + rowspan === footerIndex;
    if (headingRows && (isMergeDownWithBodyCell || isMergeUpWithHeadCell)) return null;
    if (footerRows && (isMergeUpWithBodyCell || isMergeDownWithFootCell)) return null;
    const currentCellRowSpan = parseInt(tableCell.getAttribute("rowspan") || "1");
    const rowOfCellToMerge = direction == "down" ? rowIndex + currentCellRowSpan : rowIndex;
    const tableMap = [
        ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
            endRow: rowOfCellToMerge
        })
    ];
    const mergeColumn = tableMap.find((value)=>value.cell === tableCell).column;
    const cellToMergeData = tableMap.find(({ row: row, cellHeight: cellHeight, column: column })=>{
        if (column !== mergeColumn) return false;
        if (direction == "down") return row === rowOfCellToMerge;
        else return rowOfCellToMerge === row + cellHeight;
    });
    return cellToMergeData && cellToMergeData.cell ? cellToMergeData.cell : null;
}
/**
* Merges two table cells. It will ensure that after merging cells with an empty paragraph, the resulting table cell will only have one
* paragraph. If one of the merged table cells is empty, the merged table cell will have the contents of the non-empty table cell.
* If both are empty, the merged table cell will have only one empty paragraph.
*/ function $f1b97c36043e973c$var$mergeTableCells$1(cellToRemove, cellToExpand, writer) {
    if (!$f1b97c36043e973c$var$isEmpty$2(cellToRemove)) {
        if ($f1b97c36043e973c$var$isEmpty$2(cellToExpand)) writer.remove(writer.createRangeIn(cellToExpand));
        writer.move(writer.createRangeIn(cellToRemove), writer.createPositionAt(cellToExpand, "end"));
    }
    writer.remove(cellToRemove);
}
/**
* Checks if the passed table cell contains an empty paragraph.
*/ function $f1b97c36043e973c$var$isEmpty$2(tableCell) {
    const firstTableChild = tableCell.getChild(0);
    return tableCell.childCount == 1 && firstTableChild.is("element", "paragraph") && firstTableChild.isEmpty;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/removerowcommand
*/ /**
* The remove row command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'removeTableRow'` editor command.
*
* To remove the row containing the selected cell, execute the command:
*
* ```ts
* editor.execute( 'removeTableRow' );
* ```
*/ var $f1b97c36043e973c$export$d6b85d28467bc6ff = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const selectedCells = tableUtils.getSelectionAffectedTableCells(this.editor.model.document.selection);
        const firstCell = selectedCells[0];
        if (firstCell) {
            const table = firstCell.findAncestor("table");
            const lastRowIndex = tableUtils.getRows(table) - 1;
            const selectedRowIndexes = tableUtils.getRowIndexes(selectedCells);
            const areAllRowsSelected = selectedRowIndexes.first === 0 && selectedRowIndexes.last === lastRowIndex;
            this.isEnabled = !areAllRowsSelected;
        } else this.isEnabled = false;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const referenceCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const removedRowIndexes = tableUtils.getRowIndexes(referenceCells);
        const firstCell = referenceCells[0];
        const table = firstCell.findAncestor("table");
        const columnIndexToFocus = tableUtils.getCellLocation(firstCell).column;
        model.change((writer)=>{
            const rowsToRemove = removedRowIndexes.last - removedRowIndexes.first + 1;
            tableUtils.removeRows(table, {
                at: removedRowIndexes.first,
                rows: rowsToRemove
            });
            const cellToFocus = $f1b97c36043e973c$var$getCellToFocus$1(table, removedRowIndexes.first, columnIndexToFocus, tableUtils.getRows(table));
            writer.setSelection(writer.createPositionAt(cellToFocus, 0));
        });
    }
};
/**
* Returns a cell that should be focused before removing the row, belonging to the same column as the currently focused cell.
* - If the row was not the last one, the cell to focus will be in the row that followed it (before removal).
* - If the row was the last one, the cell to focus will be in the row that preceded it (before removal).
*/ function $f1b97c36043e973c$var$getCellToFocus$1(table, removedRowIndex, columnToFocus, tableRowCount) {
    const row = table.getChild(Math.min(removedRowIndex, tableRowCount - 1));
    let cellToFocus = row.getChild(0);
    let column = 0;
    for (const tableCell of row.getChildren()){
        if (column > columnToFocus) return cellToFocus;
        cellToFocus = tableCell;
        column += parseInt(tableCell.getAttribute("colspan") || "1");
    }
    return cellToFocus;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/removecolumncommand
*/ /**
* The remove column command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'removeTableColumn'` editor command.
*
* To remove the column containing the selected cell, execute the command:
*
* ```ts
* editor.execute( 'removeTableColumn' );
* ```
*/ var $f1b97c36043e973c$export$854919f54e726761 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const selectedCells = tableUtils.getSelectionAffectedTableCells(this.editor.model.document.selection);
        const firstCell = selectedCells[0];
        if (firstCell) {
            const table = firstCell.findAncestor("table");
            const tableColumnCount = tableUtils.getColumns(table);
            const { first: first, last: last } = tableUtils.getColumnIndexes(selectedCells);
            this.isEnabled = last - first < tableColumnCount - 1;
        } else this.isEnabled = false;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const [firstCell, lastCell] = $f1b97c36043e973c$var$getBoundaryCells(this.editor.model.document.selection, tableUtils);
        const table = firstCell.parent.parent;
        const tableMap = [
            ...new $f1b97c36043e973c$export$6c270156410e802f(table)
        ];
        const removedColumnIndexes = {
            first: tableMap.find((value)=>value.cell === firstCell).column,
            last: tableMap.find((value)=>value.cell === lastCell).column
        };
        const cellToFocus = $f1b97c36043e973c$var$getCellToFocus(tableMap, firstCell, lastCell, removedColumnIndexes);
        this.editor.model.change((writer)=>{
            const columnsToRemove = removedColumnIndexes.last - removedColumnIndexes.first + 1;
            tableUtils.removeColumns(table, {
                at: removedColumnIndexes.first,
                columns: columnsToRemove
            });
            writer.setSelection(writer.createPositionAt(cellToFocus, 0));
        });
    }
};
/**
* Returns a proper table cell to focus after removing a column.
* - selection is on last table cell it will return previous cell.
*/ function $f1b97c36043e973c$var$getCellToFocus(tableMap, firstCell, lastCell, removedColumnIndexes) {
    if (parseInt(lastCell.getAttribute("colspan") || "1") > 1) return lastCell;
    else if (firstCell.previousSibling || lastCell.nextSibling) return lastCell.nextSibling || firstCell.previousSibling;
    else if (removedColumnIndexes.first) return tableMap.reverse().find(({ column: column })=>{
        return column < removedColumnIndexes.first;
    }).cell;
    else return tableMap.reverse().find(({ column: column })=>{
        return column > removedColumnIndexes.last;
    }).cell;
}
/**
* Returns helper object returning the first and the last cell contained in given selection, based on DOM order.
*/ function $f1b97c36043e973c$var$getBoundaryCells(selection, tableUtils) {
    const referenceCells = tableUtils.getSelectionAffectedTableCells(selection);
    const firstCell = referenceCells[0];
    const lastCell = referenceCells.pop();
    const returnValue = [
        firstCell,
        lastCell
    ];
    return firstCell.isBefore(lastCell) ? returnValue : returnValue.reverse();
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/setheaderrowcommand
*/ /**
* The header row command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableColumnHeader'` editor command.
*
* You can make the row containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element) by executing:
*
* ```ts
* editor.execute( 'setTableRowHeader' );
* ```
*
* **Note:** All preceding rows will also become headers. If the current row is already a header, executing this command
* will make it a regular row back again (including the following rows).
*/ var $f1b97c36043e973c$export$487ae55658dd1a76 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        if (selectedCells.length === 0) {
            this.isEnabled = false;
            this.value = false;
            return;
        }
        const table = selectedCells[0].findAncestor("table");
        this.isEnabled = model.schema.checkAttribute(table, "headingRows");
        this.value = selectedCells.every((cell)=>this._isInHeading(cell, cell.parent.parent));
    }
    /**
	* Executes the command.
	*
	* When the selection is in a non-header row, the command will set the `headingRows` table attribute to cover that row.
	*
	* When the selection is already in a header row, it will set `headingRows` so the heading section will end before that row.
	*
	* @fires execute
	* @param options.forceValue If set, the command will set (`true`) or unset (`false`) the header rows according to
	* the `forceValue` parameter instead of the current model state.
	*/ execute(options = {}) {
        if (options.forceValue === this.value) return;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const table = selectedCells[0].findAncestor("table");
        const { first: first, last: last } = tableUtils.getRowIndexes(selectedCells);
        const headingRowsToSet = this.value ? first : last + 1;
        const currentHeadingRows = table.getAttribute("headingRows") || 0;
        model.change((writer)=>{
            if (headingRowsToSet) {
                const overlappingCells = $f1b97c36043e973c$export$fe40d87a82c3f66b(table, headingRowsToSet, headingRowsToSet > currentHeadingRows ? currentHeadingRows : 0);
                for (const { cell: cell } of overlappingCells)$f1b97c36043e973c$export$a6095ae3c4be1312(cell, headingRowsToSet, writer);
            }
            tableUtils.setHeadingRowsCount(writer, table, headingRowsToSet);
        });
    }
    /**
	* Checks if a table cell is in the heading section.
	*/ _isInHeading(tableCell, table) {
        const headingRows = parseInt(table.getAttribute("headingRows") || "0");
        return !!headingRows && tableCell.parent.index < headingRows;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/setfooterrowcommand
*/ /**
* The footer row command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableFooterRow'` editor command.
*
* You can make the row containing the selected cell a footer by executing:
*
* ```ts
* editor.execute( 'setTableFooterRow' );
* ```
*
* **Note:** All following rows will also become footers. If the current row is already a footer, executing this command
* will make it a regular row back again (including the preceding rows).
*/ var $f1b97c36043e973c$export$aed34ea48e8b266c = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        if (selectedCells.length === 0) {
            this.isEnabled = false;
            this.value = false;
            return;
        }
        const table = selectedCells[0].findAncestor("table");
        this.isEnabled = model.schema.checkAttribute(table, "footerRows");
        this.value = selectedCells.every((cell)=>this._isInFooter(cell, table));
    }
    /**
	* Executes the command.
	*
	* When the selection is in a non-footer row, the command will set the `footerRows` table attribute to cover that row.
	*
	* When the selection is already in a footer row, it will set `footerRows` so the footer section will start after that row.
	*
	* @fires execute
	* @param options.forceValue If set, the command will set (`true`) or unset (`false`) the footer rows according to
	* the `forceValue` parameter instead of the current model state.
	*/ execute(options = {}) {
        if (options.forceValue === this.value) return;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const table = selectedCells[0].findAncestor("table");
        const { first: first, last: last } = tableUtils.getRowIndexes(selectedCells);
        const totalRows = tableUtils.getRows(table);
        const footerRowsToSet = this.value ? totalRows - (last + 1) : totalRows - first;
        const currentFooterRows = table.getAttribute("footerRows") || 0;
        model.change((writer)=>{
            if (footerRowsToSet) {
                const splitRow = totalRows - footerRowsToSet;
                const currentSplitRow = totalRows - currentFooterRows;
                const overlappingCells = $f1b97c36043e973c$export$fe40d87a82c3f66b(table, splitRow, splitRow > currentSplitRow ? currentSplitRow : 0);
                for (const { cell: cell } of overlappingCells)$f1b97c36043e973c$export$a6095ae3c4be1312(cell, splitRow, writer);
            }
            tableUtils.setFooterRowsCount(writer, table, footerRowsToSet);
        });
    }
    /**
	* Checks if a table cell is in the footer section.
	*/ _isInFooter(tableCell, table) {
        const footerRows = parseInt(table.getAttribute("footerRows") || "0");
        const totalRows = this.editor.plugins.get("TableUtils").getRows(table);
        const rowIndex = tableCell.parent.index;
        return !!footerRows && rowIndex >= totalRows - footerRows;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/setheadercolumncommand
*/ /**
* The header column command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableColumnHeader'` editor command.
*
* You can make the column containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element)
* by executing:
*
* ```ts
* editor.execute( 'setTableColumnHeader' );
* ```
*
* **Note:** All preceding columns will also become headers. If the current column is already a header, executing this command
* will make it a regular column back again (including the following columns).
*/ var $f1b97c36043e973c$export$2f0ed7ef58ff489c = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        if (selectedCells.length === 0) {
            this.isEnabled = false;
            this.value = false;
            return;
        }
        const table = selectedCells[0].findAncestor("table");
        this.isEnabled = model.schema.checkAttribute(table, "headingColumns");
        this.value = selectedCells.every((cell)=>$f1b97c36043e973c$export$af1346de080b7559(tableUtils, cell));
    }
    /**
	* Executes the command.
	*
	* When the selection is in a non-header column, the command will set the `headingColumns` table attribute to cover that column.
	*
	* When the selection is already in a header column, it will set `headingColumns` so the heading section will end before that column.
	*
	* @fires execute
	* @param options.forceValue If set, the command will set (`true`) or unset (`false`) the header columns according to
	* the `forceValue` parameter instead of the current model state.
	*/ execute(options = {}) {
        if (options.forceValue === this.value) return;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const table = selectedCells[0].findAncestor("table");
        const { first: first, last: last } = tableUtils.getColumnIndexes(selectedCells);
        const headingColumnsToSet = this.value ? first : last + 1;
        model.change((writer)=>{
            if (headingColumnsToSet) {
                const overlappingCells = $f1b97c36043e973c$export$3c25e8e245f1d08c(table, headingColumnsToSet);
                for (const { cell: cell, column: column } of overlappingCells)$f1b97c36043e973c$export$da7153964952c988(cell, column, headingColumnsToSet, writer);
            }
            tableUtils.setHeadingColumnsCount(writer, table, headingColumnsToSet);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The merge cells command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'mergeTableCells'` editor command.
*
* For example, to merge selected table cells:
*
* ```ts
* editor.execute( 'mergeTableCells' );
* ```
*/ var $f1b97c36043e973c$export$9c9ace2781a3aa4a = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const selectedTableCells = tableUtils.getSelectedTableCells(this.editor.model.document.selection);
        this.isEnabled = tableUtils.isSelectionRectangular(selectedTableCells);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	*/ execute() {
        const model = this.editor.model;
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        model.change((writer)=>{
            const selectedTableCells = tableUtils.getSelectedTableCells(model.document.selection);
            const firstTableCell = selectedTableCells.shift();
            const { mergeWidth: mergeWidth, mergeHeight: mergeHeight } = $f1b97c36043e973c$var$getMergeDimensions(firstTableCell, selectedTableCells, tableUtils);
            $f1b97c36043e973c$export$fd08c984b28fd00a("colspan", mergeWidth, firstTableCell, writer);
            $f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", mergeHeight, firstTableCell, writer);
            for (const tableCell of selectedTableCells)$f1b97c36043e973c$var$mergeTableCells(tableCell, firstTableCell, writer);
            const table = firstTableCell.findAncestor("table");
            $f1b97c36043e973c$export$5ef8873941f24b00(table, tableUtils);
            writer.setSelection(firstTableCell, "in");
        });
    }
};
/**
*  Merges two table cells. It will ensure that after merging cells with empty paragraphs the resulting table cell will only have one
* paragraph. If one of the merged table cells is empty, the merged table cell will have contents of the non-empty table cell.
* If both are empty, the merged table cell will have only one empty paragraph.
*/ function $f1b97c36043e973c$var$mergeTableCells(cellBeingMerged, targetCell, writer) {
    if (!$f1b97c36043e973c$var$isEmpty$1(cellBeingMerged)) {
        if ($f1b97c36043e973c$var$isEmpty$1(targetCell)) writer.remove(writer.createRangeIn(targetCell));
        writer.move(writer.createRangeIn(cellBeingMerged), writer.createPositionAt(targetCell, "end"));
    }
    writer.remove(cellBeingMerged);
}
/**
* Checks if the passed table cell contains an empty paragraph.
*/ function $f1b97c36043e973c$var$isEmpty$1(tableCell) {
    const firstTableChild = tableCell.getChild(0);
    return tableCell.childCount == 1 && firstTableChild.is("element", "paragraph") && firstTableChild.isEmpty;
}
function $f1b97c36043e973c$var$getMergeDimensions(firstTableCell, selectedTableCells, tableUtils) {
    let maxWidthOffset = 0;
    let maxHeightOffset = 0;
    for (const tableCell of selectedTableCells){
        const { row: row, column: column } = tableUtils.getCellLocation(tableCell);
        maxWidthOffset = $f1b97c36043e973c$var$getMaxOffset(tableCell, column, maxWidthOffset, "colspan");
        maxHeightOffset = $f1b97c36043e973c$var$getMaxOffset(tableCell, row, maxHeightOffset, "rowspan");
    }
    const { row: firstCellRow, column: firstCellColumn } = tableUtils.getCellLocation(firstTableCell);
    return {
        mergeWidth: maxWidthOffset - firstCellColumn,
        mergeHeight: maxHeightOffset - firstCellRow
    };
}
function $f1b97c36043e973c$var$getMaxOffset(tableCell, start, currentMaxOffset, which) {
    const dimensionValue = parseInt(tableCell.getAttribute(which) || "1");
    return Math.max(currentMaxOffset, start + dimensionValue);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/selectrowcommand
*/ /**
* The select row command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'selectTableRow'` editor command.
*
* To select the rows containing the selected cells, execute the command:
*
* ```ts
* editor.execute( 'selectTableRow' );
* ```
*/ var $f1b97c36043e973c$export$61c487fd051128f0 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selectedCells = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = selectedCells.length > 0;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const model = this.editor.model;
        const tableUtils = this.editor.plugins.get("TableUtils");
        const referenceCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const rowIndexes = tableUtils.getRowIndexes(referenceCells);
        const table = referenceCells[0].findAncestor("table");
        const rangesToSelect = [];
        for(let rowIndex = rowIndexes.first; rowIndex <= rowIndexes.last; rowIndex++)for (const cell of table.getChild(rowIndex).getChildren())rangesToSelect.push(model.createRangeOn(cell));
        model.change((writer)=>{
            writer.setSelection(rangesToSelect);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/selectcolumncommand
*/ /**
* The select column command.
*
* The command is registered by {@link module:table/tableediting~TableEditing} as the `'selectTableColumn'` editor command.
*
* To select the columns containing the selected cells, execute the command:
*
* ```ts
* editor.execute( 'selectTableColumn' );
* ```
*/ var $f1b97c36043e973c$export$f75d5a89646e5411 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.affectsData = false;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selectedCells = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = selectedCells.length > 0;
    }
    /**
	* @inheritDoc
	*/ execute() {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const model = this.editor.model;
        const referenceCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const firstCell = referenceCells[0];
        const lastCell = referenceCells.pop();
        const table = firstCell.findAncestor("table");
        const startLocation = tableUtils.getCellLocation(firstCell);
        const endLocation = tableUtils.getCellLocation(lastCell);
        const startColumn = Math.min(startLocation.column, endLocation.column);
        const endColumn = Math.max(startLocation.column, endLocation.column);
        const rangesToSelect = [];
        for (const cellInfo of new $f1b97c36043e973c$export$6c270156410e802f(table, {
            startColumn: startColumn,
            endColumn: endColumn
        }))rangesToSelect.push(model.createRangeOn(cellInfo.cell));
        model.change((writer)=>{
            writer.setSelection(rangesToSelect);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Injects a table layout post-fixer into the model.
*
* The role of the table layout post-fixer is to ensure that the table rows have the correct structure
* after a {@link module:engine/model/model~Model#change `change()`} block was executed.
*
* The correct structure means that:
*
* * All table rows have the same size.
* * None of the table cells extend vertically beyond their section (either header or body).
* * A table cell has always at least one element as a child.
*
* If the table structure is not correct, the post-fixer will automatically correct it in two steps:
*
* 1. It will clip table cells that extend beyond their section.
* 2. It will add empty table cells to the rows that are narrower than the widest table row.
*
* ## Clipping overlapping table cells
*
* Such situation may occur when pasting a table (or a part of a table) to the editor from external sources.
*
* For example, see the following table which has a cell (FOO) with the rowspan attribute (2):
*
* ```xml
* <table headingRows="1">
*   <tableRow>
*     <tableCell rowspan="2"><paragraph>FOO</paragraph></tableCell>
*     <tableCell colspan="2"><paragraph>BAR</paragraph></tableCell>
*   </tableRow>
*   <tableRow>
*     <tableCell><paragraph>BAZ</paragraph></tableCell>
*     <tableCell><paragraph>XYZ</paragraph></tableCell>
*   </tableRow>
* </table>
* ```
*
* It will be rendered in the view as:
*
* ```xml
* <table>
*   <thead>
*     <tr>
*       <td rowspan="2">FOO</td>
*       <td colspan="2">BAR</td>
*     </tr>
*   </thead>
*   <tbody>
*     <tr>
*       <td>BAZ</td>
*       <td>XYZ</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* In the above example the table will be rendered as a table with two rows: one in the header and second one in the body.
* The table cell (FOO) cannot span over multiple rows as it would extend from the header to the body section.
* The `rowspan` attribute must be changed to (1). The value (1) is the default value of the `rowspan` attribute
* so the `rowspan` attribute will be removed from the model.
*
* The table cell with BAZ in the content will be in the first column of the table.
*
* ## Adding missing table cells
*
* The table post-fixer will insert empty table cells to equalize table row sizes (the number of columns).
* The size of a table row is calculated by counting column spans of table cells, both horizontal (from the same row) and
* vertical (from the rows above).
*
* In the above example, the table row in the body section of the table is narrower then the row from the header: it has two cells
* with the default colspan (1). The header row has one cell with colspan (1) and the second with colspan (2).
* The table cell (FOO) does not extend beyond the head section (and as such will be fixed in the first step of this post-fixer).
* The post-fixer will add a missing table cell to the row in the body section of the table.
*
* The table from the above example will be fixed and rendered to the view as below:
*
* ```xml
* <table>
*   <thead>
*     <tr>
*       <td rowspan="2">FOO</td>
*       <td colspan="2">BAR</td>
*     </tr>
*   </thead>
*   <tbody>
*     <tr>
*       <td>BAZ</td>
*       <td>XYZ</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* ## Collaboration and undo - Expectations vs post-fixer results
*
* The table post-fixer only ensures proper structure without a deeper analysis of the nature of the change. As such, it might lead
* to a structure which was not intended by the user. In particular, it will also fix undo steps (in conjunction with collaboration)
* in which the editor content might not return to the original state.
*
* This will usually happen when one or more users change the size of the table.
*
* As an example see the table below:
*
* ```xml
* <table>
*   <tbody>
*     <tr>
*       <td>11</td>
*       <td>12</td>
*     </tr>
*     <tr>
*       <td>21</td>
*       <td>22</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* and the user actions:
*
* 1. Both users have a table with two rows and two columns.
* 2. User A adds a column at the end of the table. This will insert empty table cells to two rows.
* 3. User B adds a row at the end of the table. This will insert a row with two empty table cells.
* 4. Both users will have a table as below:
*
* ```xml
* <table>
*   <tbody>
*     <tr>
*       <td>11</td>
*       <td>12</td>
*       <td>(empty, inserted by A)</td>
*     </tr>
*     <tr>
*       <td>21</td>
*       <td>22</td>
*       <td>(empty, inserted by A)</td>
*     </tr>
*     <tr>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by B)</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* The last row is shorter then others so the table post-fixer will add an empty row to the last row:
*
* ```xml
* <table>
*   <tbody>
*     <tr>
*       <td>11</td>
*       <td>12</td>
*       <td>(empty, inserted by A)</td>
*     </tr>
*     <tr>
*       <td>21</td>
*       <td>22</td>
*       <td>(empty, inserted by A)</td>
*     </tr>
*     <tr>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by the post-fixer)</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* Unfortunately undo does not know the nature of the changes and depending on which user applies the post-fixer changes, undoing them
* might lead to a broken table. If User B undoes inserting the column to the table, the undo engine will undo only the operations of
* inserting empty cells to rows from the initial table state (row 1 and 2) but the cell in the post-fixed row will remain:
*
* ```xml
* <table>
*   <tbody>
*     <tr>
*       <td>11</td>
*       <td>12</td>
*     </tr>
*     <tr>
*       <td>21</td>
*       <td>22</td>
*     </tr>
*     <tr>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by a post-fixer)</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* After undo, the table post-fixer will detect that two rows are shorter than others and will fix the table to:
*
* ```xml
* <table>
*   <tbody>
*     <tr>
*       <td>11</td>
*       <td>12</td>
*       <td>(empty, inserted by a post-fixer after undo)</td>
*     </tr>
*     <tr>
*       <td>21</td>
*       <td>22</td>
*       <td>(empty, inserted by a post-fixer after undo)</td>
*     </tr>
*     <tr>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by B)</td>
*       <td>(empty, inserted by a post-fixer)</td>
*     </tr>
*   </tbody>
* </table>
* ```
*
* @internal
*/ function $f1b97c36043e973c$export$14bf905c06f1d4c(model) {
    model.document.registerPostFixer((writer)=>$f1b97c36043e973c$var$tableLayoutPostFixer(writer, model));
}
/**
* The table layout post-fixer.
*/ function $f1b97c36043e973c$var$tableLayoutPostFixer(writer, model) {
    const changes = model.document.differ.getChanges();
    let wasFixed = false;
    const analyzedTables = /* @__PURE__ */ new Set();
    for (const entry of changes){
        let table = null;
        if (entry.type == "insert" && entry.name == "table") table = entry.position.nodeAfter;
        if ((entry.type == "insert" || entry.type == "remove") && (entry.name == "tableRow" || entry.name == "tableCell")) table = entry.position.findAncestor("table");
        if ($f1b97c36043e973c$var$isTableAttributeEntry(entry)) table = entry.range.start.findAncestor("table");
        if (table && !analyzedTables.has(table)) {
            wasFixed = $f1b97c36043e973c$var$fixTableCellsRowspan(table, writer) || wasFixed;
            wasFixed = $f1b97c36043e973c$var$fixTableRowsSizes(table, writer) || wasFixed;
            analyzedTables.add(table);
        }
    }
    return wasFixed;
}
/**
* Fixes the invalid value of the `rowspan` attribute because a table cell cannot vertically extend beyond the table section it belongs to.
*
* @returns Returns `true` if the table was fixed.
*/ function $f1b97c36043e973c$var$fixTableCellsRowspan(table, writer) {
    let wasFixed = false;
    const cellsToTrim = $f1b97c36043e973c$var$findCellsToTrim(table);
    if (cellsToTrim.length) {
        wasFixed = true;
        for (const data of cellsToTrim)$f1b97c36043e973c$export$fd08c984b28fd00a("rowspan", data.rowspan, data.cell, writer, 1);
    }
    return wasFixed;
}
/**
* Makes all table rows in a table the same size.
*
* @returns Returns `true` if the table was fixed.
*/ function $f1b97c36043e973c$var$fixTableRowsSizes(table, writer) {
    let wasFixed = false;
    const childrenLengths = $f1b97c36043e973c$var$getChildrenLengths(table);
    const rowsToRemove = [];
    for (const [rowIndex, size] of childrenLengths.entries())if (!size && table.getChild(rowIndex).is("element", "tableRow")) rowsToRemove.push(rowIndex);
    if (rowsToRemove.length) {
        wasFixed = true;
        for (const rowIndex of rowsToRemove.reverse()){
            writer.remove(table.getChild(rowIndex));
            childrenLengths.splice(rowIndex, 1);
        }
    }
    const rowsLengths = childrenLengths.filter((row, rowIndex)=>table.getChild(rowIndex).is("element", "tableRow"));
    const tableSize = rowsLengths[0];
    if (!rowsLengths.every((length)=>length === tableSize)) {
        const maxColumns = rowsLengths.reduce((prev, current)=>current > prev ? current : prev, 0);
        for (const [rowIndex, size] of rowsLengths.entries()){
            const columnsToInsert = maxColumns - size;
            if (columnsToInsert) {
                for(let i = 0; i < columnsToInsert; i++)$f1b97c36043e973c$export$6912bf35f0593a83(writer, writer.createPositionAt(table.getChild(rowIndex), "end"));
                wasFixed = true;
            }
        }
    }
    return wasFixed;
}
/**
* Searches for table cells that extend beyond the table section to which they belong to. It will return an array of objects
* that stores table cells to be trimmed and the correct value of the `rowspan` attribute to set.
*/ function $f1b97c36043e973c$var$findCellsToTrim(table) {
    const headingRows = parseInt(table.getAttribute("headingRows") || "0");
    const footerRows = parseInt(table.getAttribute("footerRows") || "0");
    const maxRows = Array.from(table.getChildren()).reduce((count, row)=>row.is("element", "tableRow") ? count + 1 : count, 0);
    const footerIndex = maxRows - footerRows;
    const cellsToTrim = [];
    for (const { row: row, cell: cell, cellHeight: cellHeight } of new $f1b97c36043e973c$export$6c270156410e802f(table)){
        if (cellHeight < 2) continue;
        const isInHeader = row < headingRows;
        const isInFooter = row >= footerIndex;
        let rowLimit;
        if (isInHeader) rowLimit = headingRows;
        else if (isInFooter) rowLimit = maxRows;
        else rowLimit = footerIndex;
        if (row + cellHeight > rowLimit) {
            const newRowspan = rowLimit - row;
            cellsToTrim.push({
                cell: cell,
                rowspan: newRowspan
            });
        }
    }
    return cellsToTrim;
}
/**
* Returns an array with lengths of rows assigned to the corresponding row index.
*/ function $f1b97c36043e973c$var$getChildrenLengths(table) {
    const lengths = new Array(table.childCount).fill(0);
    for (const { rowIndex: rowIndex } of new $f1b97c36043e973c$export$6c270156410e802f(table, {
        includeAllSlots: true
    }))lengths[rowIndex]++;
    return lengths;
}
/**
* Checks if the differ entry for an attribute change is one of the table's attributes.
*/ function $f1b97c36043e973c$var$isTableAttributeEntry(entry) {
    if (entry.type !== "attribute") return false;
    const key = entry.attributeKey;
    return key === "headingRows" || key === "colspan" || key === "rowspan";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Injects a table cell post-fixer into the model which inserts a `paragraph` element into empty table cells.
*
* A table cell must contain at least one block element as a child. An empty table cell will have an empty `paragraph` as a child.
*
* ```xml
* <table>
*   <tableRow>
*      <tableCell></tableCell>
*   </tableRow>
* </table>
* ```
*
* Will be fixed to:
*
* ```xml
* <table>
*   <tableRow>
*      <tableCell><paragraph></paragraph></tableCell>
*   </tableRow>
* </table>
* ```
*
* @internal
*/ function $f1b97c36043e973c$export$7f2623f60360bc94(model) {
    model.document.registerPostFixer((writer)=>$f1b97c36043e973c$var$tableCellContentsPostFixer(writer, model));
}
/**
* The table cell contents post-fixer.
*/ function $f1b97c36043e973c$var$tableCellContentsPostFixer(writer, model) {
    const changes = model.document.differ.getChanges();
    let wasFixed = false;
    for (const entry of changes){
        if (entry.type == "insert" && entry.name == "table") wasFixed = $f1b97c36043e973c$var$fixTable(entry.position.nodeAfter, writer) || wasFixed;
        if (entry.type == "insert" && entry.name == "tableRow") wasFixed = $f1b97c36043e973c$var$fixTableRow(entry.position.nodeAfter, writer) || wasFixed;
        if (entry.type == "insert" && entry.name == "tableCell") wasFixed = $f1b97c36043e973c$var$fixTableCellContent(entry.position.nodeAfter, writer) || wasFixed;
        if ((entry.type == "remove" || entry.type == "insert") && $f1b97c36043e973c$var$checkTableCellChange(entry)) wasFixed = $f1b97c36043e973c$var$fixTableCellContent(entry.position.parent, writer) || wasFixed;
    }
    return wasFixed;
}
/**
* Fixes all table cells in a table.
*/ function $f1b97c36043e973c$var$fixTable(table, writer) {
    let wasFixed = false;
    for (const row of table.getChildren())if (row.is("element", "tableRow")) wasFixed = $f1b97c36043e973c$var$fixTableRow(row, writer) || wasFixed;
    return wasFixed;
}
/**
* Fixes all table cells in a table row.
*/ function $f1b97c36043e973c$var$fixTableRow(tableRow, writer) {
    let wasFixed = false;
    for (const tableCell of tableRow.getChildren())wasFixed = $f1b97c36043e973c$var$fixTableCellContent(tableCell, writer) || wasFixed;
    return wasFixed;
}
/**
* Fixes all table cell content by:
* - Adding a paragraph to a table cell without any child.
* - Wrapping direct $text in a `<paragraph>`.
*/ function $f1b97c36043e973c$var$fixTableCellContent(tableCell, writer) {
    if (tableCell.childCount == 0) {
        writer.insertElement("paragraph", tableCell);
        return true;
    }
    const textNodes = Array.from(tableCell.getChildren()).filter((child)=>child.is("$text"));
    for (const child of textNodes)writer.wrap(writer.createRangeOn(child), "paragraph");
    return !!textNodes.length;
}
/**
* Checks if a differ change should fix the table cell. This happens on:
* - Removing content from the table cell (i.e. `tableCell` can be left empty).
* - Adding a text node directly into a table cell.
*/ function $f1b97c36043e973c$var$checkTableCellChange(entry) {
    if (!entry.position.parent.is("element", "tableCell")) return false;
    return entry.type == "insert" && entry.name == "$text" || entry.type == "remove";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Injects a table structure post-fixer into the model.
*
* It checks if the `headingRows` and `footerRows` attributes do not overlap.
* If they overlap, the `footerRows` attribute is corrected.
*
* We prefer `headingRows` over `footerRows` because changing `headingRows` would require updating
* the `tableCellType` attribute of the cells in the row, which is not required when changing `footerRows`.
*
* @param editor The editor instance.
*/ function $f1b97c36043e973c$var$injectTableStructurePostFixer(editor) {
    const { model: model } = editor;
    const tableUtils = editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
    model.document.registerPostFixer((writer)=>{
        let changed = false;
        const changes = model.document.differ.getChanges();
        const tables = /* @__PURE__ */ new Set();
        for (const entry of changes){
            let table = null;
            if (entry.type == "attribute" && (entry.attributeKey == "headingRows" || entry.attributeKey == "footerRows")) table = entry.range.start.nodeAfter;
            else if (entry.type == "insert" && entry.name == "tableRow") table = entry.position.parent;
            else if (entry.type == "remove" && entry.name == "tableRow") table = entry.position.parent;
            if (table && table.is("element", "table")) tables.add(table);
        }
        for (const table of tables)if ($f1b97c36043e973c$var$fixTableSections(tableUtils, writer, table)) changed = true;
        return changed;
    });
}
/**
* Fixes table sections by ensuring that `headingRows` and `footerRows` do not overlap.
*/ function $f1b97c36043e973c$var$fixTableSections(tableUtils, writer, table) {
    const headingRows = table.getAttribute("headingRows") || 0;
    const footerRows = table.getAttribute("footerRows") || 0;
    const rows = tableUtils.getRows(table);
    if (headingRows + footerRows > rows) {
        const value = Math.max(0, rows - headingRows);
        $f1b97c36043e973c$export$fd08c984b28fd00a("footerRows", value, table, writer, 0);
        return true;
    }
    return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A table headings refresh handler which marks the table cells or rows in the differ to have it re-rendered
* if the headings attribute changed.
*
* Table heading rows and heading columns are represented in the model by a `headingRows` and `headingColumns` attributes.
*
* When table headings attribute changes, all the cells/rows are marked to re-render to change between `<td>` and `<th>`.
*
* @internal
*/ function $f1b97c36043e973c$export$9626d3a2587d385a(model, editing) {
    const differ = model.document.differ;
    const movedRows = /* @__PURE__ */ new Set();
    const rowsToReconvert = /* @__PURE__ */ new Set();
    const cellsToReconvert = /* @__PURE__ */ new Set();
    for (const change of differ.getChanges()){
        let table;
        if (change.type == "attribute") {
            const element = change.range.start.nodeAfter;
            if (!element || !element.is("element", "table")) continue;
            if (change.attributeKey != "headingRows" && change.attributeKey != "headingColumns" && change.attributeKey != "footerRows") continue;
            table = element;
        } else if (change.name == "tableRow" || change.name == "tableCell") table = change.position.findAncestor("table");
        if (!table) continue;
        if (change.type == "insert" && change.name == "tableRow" && editing.mapper.toViewElement(change.position.nodeAfter)) movedRows.add(change.position.nodeAfter);
        const headingRows = table.getAttribute("headingRows") || 0;
        const headingColumns = table.getAttribute("headingColumns") || 0;
        const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(table);
        for (const tableSlot of tableWalker){
            const viewElement = editing.mapper.toViewElement(tableSlot.cell);
            if (!viewElement || !viewElement.is("element")) continue;
            const expectedElementName = tableSlot.row < headingRows || tableSlot.column < headingColumns ? "th" : "td";
            if (viewElement.name != expectedElementName) {
                cellsToReconvert.add(tableSlot.cell);
                if (movedRows.has(tableSlot.cell.parent)) rowsToReconvert.add(tableSlot.cell.parent);
            }
        }
    }
    for (const item of rowsToReconvert)editing.reconvertItem(item);
    for (const item of cellsToReconvert)editing.reconvertItem(item);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* A table cell refresh handler which marks the table cell in the differ to have it re-rendered.
*
* Model `paragraph` inside a table cell can be rendered as `<span>` or `<p>`. It is rendered as `<span>` if this is the only block
* element in that table cell and it does not have any attributes. It is rendered as `<p>` otherwise.
*
* When table cell content changes, for example a second `paragraph` element is added, we need to ensure that the first `paragraph` is
* re-rendered so it changes from `<span>` to `<p>`. The easiest way to do it is to re-render the entire table cell.
*
* @internal
*/ function $f1b97c36043e973c$export$697f2045471ce215(model, editing) {
    const differ = model.document.differ;
    const cellsToCheck = /* @__PURE__ */ new Set();
    for (const change of differ.getChanges()){
        const parent = change.type == "attribute" ? change.range.start.parent : change.position.parent;
        if (parent.is("element", "tableCell")) cellsToCheck.add(parent);
    }
    for (const tableCell of cellsToCheck.values()){
        const paragraphsToRefresh = Array.from(tableCell.getChildren()).filter((child)=>$f1b97c36043e973c$var$shouldRefresh(child, editing.mapper));
        for (const paragraph of paragraphsToRefresh)editing.reconvertItem(paragraph);
    }
}
/**
* Check if given model element needs refreshing.
*/ function $f1b97c36043e973c$var$shouldRefresh(child, mapper) {
    if (!child.is("element", "paragraph")) return false;
    const viewElement = mapper.toViewElement(child);
    if (!viewElement) return false;
    return $f1b97c36043e973c$export$f14d638013924718(child) !== viewElement.is("element", "span");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableediting
*/ /**
* The table editing feature.
*/ var $f1b97c36043e973c$export$b5fa926abf3ddb23 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Handlers for creating additional slots in the table.
	*/ _additionalSlots;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this._additionalSlots = [];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const schema = model.schema;
        const conversion = editor.conversion;
        const tableUtils = editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        editor.config.define("table.enableFooters", false);
        const useFooterElement = !!editor.config.get("table.enableFooters");
        schema.register("table", {
            inheritAllFrom: "$blockObject",
            allowAttributes: [
                "headingRows",
                "headingColumns",
                ...useFooterElement ? [
                    "footerRows"
                ] : []
            ]
        });
        schema.register("tableRow", {
            allowIn: "table",
            isLimit: true
        });
        schema.register("tableCell", {
            allowContentOf: "$container",
            allowIn: "tableRow",
            allowAttributes: [
                "colspan",
                "rowspan"
            ],
            isLimit: true,
            isSelectable: true
        });
        conversion.for("upcast").add($f1b97c36043e973c$export$e0821ce489e36326());
        conversion.for("upcast").add($f1b97c36043e973c$export$cca6e092b997f07e({
            enableFooters: useFooterElement
        }));
        conversion.for("editingDowncast").elementToStructure({
            model: {
                name: "table",
                attributes: [
                    "headingRows",
                    ...useFooterElement ? [
                        "footerRows"
                    ] : []
                ]
            },
            view: $f1b97c36043e973c$export$2c94aff3e633fc56(tableUtils, {
                asWidget: true,
                additionalSlots: this._additionalSlots
            })
        });
        conversion.for("dataDowncast").elementToStructure({
            model: {
                name: "table",
                attributes: [
                    "headingRows",
                    ...useFooterElement ? [
                        "footerRows"
                    ] : []
                ]
            },
            view: $f1b97c36043e973c$export$2c94aff3e633fc56(tableUtils, {
                additionalSlots: this._additionalSlots
            })
        });
        conversion.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
        });
        conversion.for("upcast").add($f1b97c36043e973c$export$bf3822e3bf8136cb());
        conversion.for("downcast").elementToElement({
            model: "tableRow",
            view: $f1b97c36043e973c$export$1af7c99bf35fb0e2()
        });
        conversion.for("upcast").elementToElement({
            model: "tableCell",
            view: "td"
        });
        conversion.for("upcast").elementToElement({
            model: "tableCell",
            view: "th"
        });
        conversion.for("upcast").add($f1b97c36043e973c$export$cad4726fdac140ee("td"));
        conversion.for("upcast").add($f1b97c36043e973c$export$cad4726fdac140ee("th"));
        conversion.for("editingDowncast").elementToElement({
            model: "tableCell",
            view: $f1b97c36043e973c$export$51569edd66125795({
                asWidget: true,
                cellTypeEnabled: ()=>$f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)
            })
        });
        conversion.for("dataDowncast").elementToElement({
            model: "tableCell",
            view: $f1b97c36043e973c$export$51569edd66125795({
                cellTypeEnabled: ()=>$f1b97c36043e973c$var$isTableCellTypeEnabled(this.editor)
            })
        });
        conversion.for("editingDowncast").elementToElement({
            model: "paragraph",
            view: $f1b97c36043e973c$export$decc54eda7c35758({
                asWidget: true
            }),
            converterPriority: "high"
        });
        conversion.for("dataDowncast").elementToElement({
            model: "paragraph",
            view: $f1b97c36043e973c$export$decc54eda7c35758(),
            converterPriority: "high"
        });
        conversion.for("downcast").attributeToAttribute({
            model: "colspan",
            view: "colspan"
        });
        conversion.for("upcast").attributeToAttribute({
            model: {
                key: "colspan",
                value: $f1b97c36043e973c$var$upcastCellSpan("colspan")
            },
            view: "colspan"
        });
        conversion.for("downcast").attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
        });
        conversion.for("upcast").attributeToAttribute({
            model: {
                key: "rowspan",
                value: $f1b97c36043e973c$var$upcastCellSpan("rowspan")
            },
            view: "rowspan"
        });
        this._addPlainTableOutputConverters();
        editor.config.define("table.defaultHeadings.rows", 0);
        editor.config.define("table.defaultHeadings.columns", 0);
        editor.config.define("table.defaultFooters", 0);
        editor.config.define("table.showHiddenBorders", true);
        if (editor.config.get("table.showHiddenBorders")) editor.editing.view.change((writer)=>{
            for (const root of editor.editing.view.document.roots)writer.addClass("ck-table-show-hidden-borders", root);
        });
        editor.commands.add("insertTable", new $f1b97c36043e973c$export$9907a752830c7653(editor));
        editor.commands.add("insertTableRowAbove", new $f1b97c36043e973c$export$59824d5e29c20d3b(editor, {
            order: "above"
        }));
        editor.commands.add("insertTableRowBelow", new $f1b97c36043e973c$export$59824d5e29c20d3b(editor, {
            order: "below"
        }));
        editor.commands.add("insertTableColumnLeft", new $f1b97c36043e973c$export$4e446306fa8b3296(editor, {
            order: "left"
        }));
        editor.commands.add("insertTableColumnRight", new $f1b97c36043e973c$export$4e446306fa8b3296(editor, {
            order: "right"
        }));
        editor.commands.add("removeTableRow", new $f1b97c36043e973c$export$d6b85d28467bc6ff(editor));
        editor.commands.add("removeTableColumn", new $f1b97c36043e973c$export$854919f54e726761(editor));
        editor.commands.add("splitTableCellVertically", new $f1b97c36043e973c$export$9906cc304dfd468(editor, {
            direction: "vertically"
        }));
        editor.commands.add("splitTableCellHorizontally", new $f1b97c36043e973c$export$9906cc304dfd468(editor, {
            direction: "horizontally"
        }));
        editor.commands.add("mergeTableCells", new $f1b97c36043e973c$export$9c9ace2781a3aa4a(editor));
        editor.commands.add("mergeTableCellRight", new $f1b97c36043e973c$export$c9cb39ad3f750704(editor, {
            direction: "right"
        }));
        editor.commands.add("mergeTableCellLeft", new $f1b97c36043e973c$export$c9cb39ad3f750704(editor, {
            direction: "left"
        }));
        editor.commands.add("mergeTableCellDown", new $f1b97c36043e973c$export$c9cb39ad3f750704(editor, {
            direction: "down"
        }));
        editor.commands.add("mergeTableCellUp", new $f1b97c36043e973c$export$c9cb39ad3f750704(editor, {
            direction: "up"
        }));
        editor.commands.add("setTableColumnHeader", new $f1b97c36043e973c$export$2f0ed7ef58ff489c(editor));
        editor.commands.add("setTableRowHeader", new $f1b97c36043e973c$export$487ae55658dd1a76(editor));
        if (useFooterElement) editor.commands.add("setTableFooterRow", new $f1b97c36043e973c$export$aed34ea48e8b266c(editor));
        editor.commands.add("selectTableRow", new $f1b97c36043e973c$export$61c487fd051128f0(editor));
        editor.commands.add("selectTableColumn", new $f1b97c36043e973c$export$f75d5a89646e5411(editor));
        $f1b97c36043e973c$export$14bf905c06f1d4c(model);
        $f1b97c36043e973c$export$7f2623f60360bc94(model);
        if (useFooterElement) $f1b97c36043e973c$var$injectTableStructurePostFixer(editor);
        this.listenTo(model.document, "change:data", ()=>{
            if (!$f1b97c36043e973c$var$isTableCellTypeEnabled(editor)) $f1b97c36043e973c$export$9626d3a2587d385a(model, editor.editing);
            $f1b97c36043e973c$export$697f2045471ce215(model, editor.editing);
        });
    }
    /**
	* Registers downcast handler for the additional table slot.
	*/ registerAdditionalSlot(slotHandler) {
        this._additionalSlots.push(slotHandler);
    }
    /**
	* Adds converters for plain table output. These converters are used either when the `PlainTableOutput` plugin is loaded
	* or when content is processed by the clipboard pipeline, ensuring that pasted tables are not wrapped in a <figure> element.
	*/ _addPlainTableOutputConverters() {
        const editor = this.editor;
        editor.conversion.for("dataDowncast").elementToStructure({
            model: "table",
            view: $f1b97c36043e973c$var$convertPlainTable(editor),
            converterPriority: "high"
        });
        if (editor.plugins.has("TableCaptionEditing")) editor.conversion.for("dataDowncast").elementToElement({
            model: "caption",
            view: $f1b97c36043e973c$var$convertPlainTableCaption(editor),
            converterPriority: "high"
        });
        if (editor.plugins.has("TablePropertiesEditing")) $f1b97c36043e973c$var$downcastTableBorderAndBackgroundAttributes(editor);
    }
};
/**
* Returns fixed colspan and rowspan attrbutes values.
*
* @param type colspan or rowspan.
* @returns conversion value function.
*/ function $f1b97c36043e973c$var$upcastCellSpan(type) {
    return (cell)=>{
        const span = parseInt(cell.getAttribute(type));
        if (Number.isNaN(span) || span <= 0) return null;
        return span;
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/ui/inserttableview
*/ /**
* The table size view.
*
* It renders a 10x10 grid to choose the inserted table size.
*
* @internal
*/ var $f1b97c36043e973c$export$55b6381dac33ed7e = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A collection of table size box items.
	*/ items;
    /**
	* Listen to `keydown` events fired in this view's main element.
	*/ keystrokes;
    /**
	* Tracks information about the DOM focus in the grid.
	*/ focusTracker;
    /**
	* @inheritDoc
	*/ constructor(locale){
        super(locale);
        const bind = this.bindTemplate;
        this.items = this._createGridCollection();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.set("rows", 0);
        this.set("columns", 0);
        this.bind("label").to(this, "columns", this, "rows", (columns, rows)=>`${rows} \xd7 ${columns}`);
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck"
                ]
            },
            children: [
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck-insert-table-dropdown__grid"
                        ]
                    },
                    on: {
                        "mouseover@.ck-insert-table-dropdown-grid-box": bind.to("boxover")
                    },
                    children: this.items
                },
                {
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-insert-table-dropdown__label"
                        ],
                        "aria-hidden": true
                    },
                    children: [
                        {
                            text: bind.to("label")
                        }
                    ]
                }
            ],
            on: {
                mousedown: bind.to((evt)=>{
                    evt.preventDefault();
                }),
                click: bind.to(()=>{
                    this.fire("execute");
                })
            }
        });
        this.on("boxover", (evt, domEvt)=>{
            const { row: row, column: column } = domEvt.target.dataset;
            this.items.get((parseInt(row, 10) - 1) * 10 + (parseInt(column, 10) - 1)).focus();
        });
        this.focusTracker.on("change:focusedElement", (evt, name, focusedElement)=>{
            if (!focusedElement) return;
            const { row: row, column: column } = focusedElement.dataset;
            this.set({
                rows: parseInt(row),
                columns: parseInt(column)
            });
        });
        this.on("change:columns", ()=>this._highlightGridBoxes());
        this.on("change:rows", ()=>this._highlightGridBoxes());
    }
    render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4c1942d3074fe5f4)({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.items,
            numberOfColumns: 10,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
        for (const item of this.items)this.focusTracker.add(item.element);
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Resets the rows and columns selection.
	*/ reset() {
        this.set({
            rows: 1,
            columns: 1
        });
    }
    /**
	* @inheritDoc
	*/ focus() {
        this.items.get(0).focus();
    }
    /**
	* @inheritDoc
	*/ focusLast() {
        this.items.get(0).focus();
    }
    /**
	* Highlights grid boxes depending on rows and columns selected.
	*/ _highlightGridBoxes() {
        const rows = this.rows;
        const columns = this.columns;
        this.items.map((boxView, index)=>{
            const itemRow = Math.floor(index / 10);
            const itemColumn = index % 10;
            const isOn = itemRow < rows && itemColumn < columns;
            boxView.set("isOn", isOn);
        });
    }
    /**
	* Creates a new Button for the grid.
	*
	* @param locale The locale instance.
	* @param row Row number.
	* @param column Column number.
	* @param label The grid button label.
	*/ _createGridButton(locale, row, column, label) {
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        button.set({
            label: label,
            class: "ck-insert-table-dropdown-grid-box"
        });
        button.extendTemplate({
            attributes: {
                "data-row": row,
                "data-column": column
            }
        });
        return button;
    }
    /**
	* @returns A view collection containing boxes to be placed in a table grid.
	*/ _createGridCollection() {
        const boxes = [];
        for(let index = 0; index < 100; index++){
            const row = Math.floor(index / 10);
            const column = index % 10;
            const label = `${row + 1} \xd7 ${column + 1}`;
            boxes.push(this._createGridButton(this.locale, row + 1, column + 1, label));
        }
        return this.createCollection(boxes);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableui
*/ /**
* The table UI plugin. It introduces:
*
* * The `'insertTable'` dropdown,
* * The `'menuBar:insertTable'` menu bar menu,
* * The `'tableColumn'` dropdown,
* * The `'tableRow'` dropdown,
* * The `'mergeTableCells'` split button.
*
* The `'tableColumn'`, `'tableRow'` and `'mergeTableCells'` dropdowns work best with {@link module:table/tabletoolbar~TableToolbar}.
*/ var $f1b97c36043e973c$export$b2bb66d048987d4d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        const isContentLtr = editor.locale.contentLanguageDirection === "ltr";
        const areTableFootersEnabled = !!editor.config.get("table.enableFooters");
        editor.ui.componentFactory.add("insertTable", (locale)=>{
            const command = editor.commands.get("insertTable");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            dropdownView.bind("isEnabled").to(command);
            dropdownView.buttonView.set({
                icon: (0, $e8dc502aba5ac3f5$export$84f497075f5b07be),
                label: t("Insert table"),
                tooltip: true
            });
            let insertTableView;
            dropdownView.on("change:isOpen", ()=>{
                if (insertTableView) return;
                insertTableView = new $f1b97c36043e973c$export$55b6381dac33ed7e(locale);
                dropdownView.panelView.children.add(insertTableView);
                insertTableView.delegate("execute").to(dropdownView);
                dropdownView.on("execute", ()=>{
                    editor.execute("insertTable", {
                        rows: insertTableView.rows,
                        columns: insertTableView.columns
                    });
                    editor.editing.view.focus();
                });
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add("menuBar:insertTable", (locale)=>{
            const command = editor.commands.get("insertTable");
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            const insertTableView = new $f1b97c36043e973c$export$55b6381dac33ed7e(locale);
            insertTableView.delegate("execute").to(menuView);
            menuView.on("change:isOpen", (event, name, isOpen)=>{
                if (!isOpen) insertTableView.reset();
            });
            insertTableView.on("execute", ()=>{
                editor.execute("insertTable", {
                    rows: insertTableView.rows,
                    columns: insertTableView.columns
                });
                editor.editing.view.focus();
            });
            menuView.buttonView.set({
                label: t("Table"),
                icon: (0, $e8dc502aba5ac3f5$export$84f497075f5b07be)
            });
            menuView.panelView.children.add(insertTableView);
            menuView.bind("isEnabled").to(command);
            return menuView;
        });
        editor.ui.componentFactory.add("tableColumn", (locale)=>{
            const options = [
                {
                    type: "switchbutton",
                    model: {
                        commandName: "setTableColumnHeader",
                        label: t("Header column"),
                        bindIsOn: true
                    }
                },
                {
                    type: "separator"
                },
                {
                    type: "button",
                    model: {
                        commandName: isContentLtr ? "insertTableColumnLeft" : "insertTableColumnRight",
                        label: t("Insert column left")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: isContentLtr ? "insertTableColumnRight" : "insertTableColumnLeft",
                        label: t("Insert column right")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "removeTableColumn",
                        label: t("Delete column")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "selectTableColumn",
                        label: t("Select column")
                    }
                }
            ];
            return this._prepareDropdown(t("Column"), (0, $e8dc502aba5ac3f5$export$8f3defc247629bdb), options, locale);
        });
        editor.ui.componentFactory.add("tableRow", (locale)=>{
            const options = [
                {
                    type: "switchbutton",
                    model: {
                        commandName: "setTableRowHeader",
                        label: t("Header row"),
                        bindIsOn: true
                    }
                },
                areTableFootersEnabled && {
                    type: "switchbutton",
                    model: {
                        commandName: "setTableFooterRow",
                        label: t("Footer row"),
                        bindIsOn: true
                    }
                },
                {
                    type: "separator"
                },
                {
                    type: "button",
                    model: {
                        commandName: "insertTableRowAbove",
                        label: t("Insert row above")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "insertTableRowBelow",
                        label: t("Insert row below")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "removeTableRow",
                        label: t("Delete row")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "selectTableRow",
                        label: t("Select row")
                    }
                }
            ].filter(Boolean);
            return this._prepareDropdown(t("Row"), (0, $e8dc502aba5ac3f5$export$b5a8f408cb97d6f8), options, locale);
        });
        editor.ui.componentFactory.add("mergeTableCells", (locale)=>{
            const options = [
                {
                    type: "button",
                    model: {
                        commandName: "mergeTableCellUp",
                        label: t("Merge cell up")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: isContentLtr ? "mergeTableCellRight" : "mergeTableCellLeft",
                        label: t("Merge cell right")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "mergeTableCellDown",
                        label: t("Merge cell down")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: isContentLtr ? "mergeTableCellLeft" : "mergeTableCellRight",
                        label: t("Merge cell left")
                    }
                },
                {
                    type: "separator"
                },
                {
                    type: "button",
                    model: {
                        commandName: "splitTableCellVertically",
                        label: t("Split cell vertically")
                    }
                },
                {
                    type: "button",
                    model: {
                        commandName: "splitTableCellHorizontally",
                        label: t("Split cell horizontally")
                    }
                }
            ];
            return this._prepareMergeSplitButtonDropdown(t("Merge cells"), (0, $e8dc502aba5ac3f5$export$2c52ce7602b10937), options, locale);
        });
    }
    /**
	* Creates a dropdown view from a set of options.
	*
	* @param label The dropdown button label.
	* @param icon An icon for the dropdown button.
	* @param options The list of options for the dropdown.
	*/ _prepareDropdown(label, icon, options, locale) {
        const editor = this.editor;
        const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
        const commands = this._fillDropdownWithListOptions(dropdownView, options);
        dropdownView.buttonView.set({
            label: label,
            icon: icon,
            tooltip: true
        });
        dropdownView.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>{
            return areEnabled.some((isEnabled)=>isEnabled);
        });
        this.listenTo(dropdownView, "execute", (evt)=>{
            editor.execute(evt.source.commandName);
            if (!(evt.source instanceof (0, $29fd27cb9bdab9d2$export$bb3c559d00882ebd))) editor.editing.view.focus();
        });
        return dropdownView;
    }
    /**
	* Creates a dropdown view with a {@link module:ui/dropdown/button/splitbuttonview~SplitButtonView} for
	* merge (and split)–related commands.
	*
	* @param label The dropdown button label.
	* @param icon An icon for the dropdown button.
	* @param options The list of options for the dropdown.
	*/ _prepareMergeSplitButtonDropdown(label, icon, options, locale) {
        const editor = this.editor;
        const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9));
        const mergeCommandName = "mergeTableCells";
        const mergeCommand = editor.commands.get(mergeCommandName);
        const commands = this._fillDropdownWithListOptions(dropdownView, options);
        dropdownView.buttonView.set({
            label: label,
            icon: icon,
            tooltip: true,
            isEnabled: true
        });
        dropdownView.bind("isEnabled").toMany([
            mergeCommand,
            ...commands
        ], "isEnabled", (...areEnabled)=>{
            return areEnabled.some((isEnabled)=>isEnabled);
        });
        this.listenTo(dropdownView.buttonView, "execute", ()=>{
            editor.execute(mergeCommandName);
            editor.editing.view.focus();
        });
        this.listenTo(dropdownView, "execute", (evt)=>{
            editor.execute(evt.source.commandName);
            editor.editing.view.focus();
        });
        return dropdownView;
    }
    /**
	* Injects a {@link module:ui/list/listview~ListView} into the passed dropdown with buttons
	* which execute editor commands as configured in passed options.
	*
	* @param options The list of options for the dropdown.
	* @returns Commands the list options are interacting with.
	*/ _fillDropdownWithListOptions(dropdownView, options) {
        const editor = this.editor;
        const commands = [];
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        for (const option of options)$f1b97c36043e973c$var$addListOption(option, editor, commands, itemDefinitions);
        (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, itemDefinitions);
        return commands;
    }
};
/**
* Adds an option to a list view.
*
* @param option A configuration option.
* @param commands The list of commands to update.
* @param itemDefinitions A collection of dropdown items to update with the given option.
*/ function $f1b97c36043e973c$var$addListOption(option, editor, commands, itemDefinitions) {
    if (option.type === "button" || option.type === "switchbutton") {
        const model = option.model = new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)(option.model);
        const { commandName: commandName, bindIsOn: bindIsOn } = option.model;
        const command = editor.commands.get(commandName);
        commands.push(command);
        model.set({
            commandName: commandName
        });
        model.bind("isEnabled").to(command);
        if (bindIsOn) model.bind("isOn").to(command, "value");
        model.set({
            withText: true
        });
    }
    itemDefinitions.add(option);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableselection
*/ /**
* This plugin enables the advanced table cells, rows and columns selection.
* It is loaded automatically by the {@link module:table/table~Table} plugin.
*/ var $f1b97c36043e973c$export$d1314ebcfd9d7a36 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableSelection";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b8747c538ef18c7,
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const model = editor.model;
        const view = editor.editing.view;
        this.listenTo(model, "deleteContent", (evt, args)=>this._handleDeleteContent(evt, args), {
            priority: "high"
        });
        this.listenTo(view.document, "insertText", (evt, data)=>this._handleInsertTextEvent(evt, data), {
            priority: "high"
        });
        this._defineSelectionConverter();
        this._enablePluginDisabling();
    }
    /**
	* Returns the currently selected table cells or `null` if it is not a table cells selection.
	*/ getSelectedTableCells() {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const selection = this.editor.model.document.selection;
        const selectedCells = tableUtils.getSelectedTableCells(selection);
        if (selectedCells.length == 0) return null;
        return selectedCells;
    }
    /**
	* Returns the selected table fragment as a document fragment.
	*/ getSelectionAsFragment() {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const selectedCells = this.getSelectedTableCells();
        if (!selectedCells) return null;
        return this.editor.model.change((writer)=>{
            const documentFragment = writer.createDocumentFragment();
            const { first: firstColumn, last: lastColumn } = tableUtils.getColumnIndexes(selectedCells);
            const { first: firstRow, last: lastRow } = tableUtils.getRowIndexes(selectedCells);
            const sourceTable = selectedCells[0].findAncestor("table");
            let adjustedLastRow = lastRow;
            let adjustedLastColumn = lastColumn;
            if (tableUtils.isSelectionRectangular(selectedCells)) {
                const dimensions = {
                    firstColumn: firstColumn,
                    lastColumn: lastColumn,
                    firstRow: firstRow,
                    lastRow: lastRow
                };
                adjustedLastRow = $f1b97c36043e973c$export$abc118df6412c45a(sourceTable, dimensions);
                adjustedLastColumn = $f1b97c36043e973c$export$637b4fa83bfe055a(sourceTable, dimensions);
            }
            const table = $f1b97c36043e973c$export$4fd6c7e514948ca9(sourceTable, {
                startRow: firstRow,
                startColumn: firstColumn,
                endRow: adjustedLastRow,
                endColumn: adjustedLastColumn
            }, writer);
            writer.insert(table, documentFragment, 0);
            return documentFragment;
        });
    }
    /**
	* Sets the model selection based on given anchor and target cells (can be the same cell).
	* Takes care of setting the backward flag.
	*
	* ```ts
	* const modelRoot = editor.model.document.getRoot();
	* const firstCell = modelRoot.getNodeByPath( [ 0, 0, 0 ] );
	* const lastCell = modelRoot.getNodeByPath( [ 0, 0, 1 ] );
	*
	* const tableSelection = editor.plugins.get( 'TableSelection' );
	* tableSelection.setCellSelection( firstCell, lastCell );
	* ```
	*/ setCellSelection(anchorCell, targetCell) {
        const cellsToSelect = this._getCellsToSelect(anchorCell, targetCell);
        this.editor.model.change((writer)=>{
            writer.setSelection(cellsToSelect.cells.map((cell)=>writer.createRangeOn(cell)), {
                backward: cellsToSelect.backward
            });
        });
    }
    /**
	* Returns the focus cell from the current selection.
	*/ getFocusCell() {
        const element = [
            ...this.editor.model.document.selection.getRanges()
        ].pop().getContainedElement();
        if (element && element.is("element", "tableCell")) return element;
        return null;
    }
    /**
	* Returns the anchor cell from the current selection.
	*/ getAnchorCell() {
        const selection = this.editor.model.document.selection;
        const element = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(selection.getRanges()).getContainedElement();
        if (element && element.is("element", "tableCell")) return element;
        return null;
    }
    /**
	* Defines a selection converter which marks the selected cells with a specific class.
	*
	* The real DOM selection is put in the last cell. Since the order of ranges is dependent on whether the
	* selection is backward or not, the last cell will usually be close to the "focus" end of the selection
	* (a selection has anchor and focus).
	*
	* The real DOM selection is then hidden with CSS.
	*/ _defineSelectionConverter() {
        const editor = this.editor;
        const highlighted = /* @__PURE__ */ new Set();
        editor.conversion.for("editingDowncast").add((dispatcher)=>dispatcher.on("selection", (evt, data, conversionApi)=>{
                const viewWriter = conversionApi.writer;
                clearHighlightedTableCells(viewWriter);
                const selectedCells = this.getSelectedTableCells();
                if (!selectedCells) return;
                for (const tableCell of selectedCells){
                    const viewElement = conversionApi.mapper.toViewElement(tableCell);
                    viewWriter.addClass("ck-editor__editable_selected", viewElement);
                    highlighted.add(viewElement);
                }
                const lastViewCell = conversionApi.mapper.toViewElement(selectedCells[selectedCells.length - 1]);
                viewWriter.setSelection(lastViewCell, 0);
            }, {
                priority: "lowest"
            }));
        function clearHighlightedTableCells(viewWriter) {
            for (const previouslyHighlighted of highlighted)viewWriter.removeClass("ck-editor__editable_selected", previouslyHighlighted);
            highlighted.clear();
        }
    }
    /**
	* Creates a listener that reacts to changes in {@link #isEnabled} and, if the plugin was disabled,
	* it collapses the multi-cell selection to a regular selection placed inside a table cell.
	*
	* This listener helps features that disable the table selection plugin bring the selection
	* to a clear state they can work with (for instance, because they don't support multiple cell selection).
	*/ _enablePluginDisabling() {
        const editor = this.editor;
        this.on("change:isEnabled", ()=>{
            if (!this.isEnabled) {
                const selectedCells = this.getSelectedTableCells();
                if (!selectedCells) return;
                editor.model.change((writer)=>{
                    const position = writer.createPositionAt(selectedCells[0], 0);
                    const range = editor.model.schema.getNearestSelectionRange(position);
                    writer.setSelection(range);
                });
            }
        });
    }
    /**
	* Overrides the default `model.deleteContent()` behavior over a selected table fragment.
	*
	* @param args Delete content method arguments.
	*/ _handleDeleteContent(event, args) {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const selection = args[0];
        const options = args[1];
        const model = this.editor.model;
        const isBackward = !options || options.direction == "backward";
        const selectedTableCells = tableUtils.getSelectedTableCells(selection);
        if (!selectedTableCells.length) return;
        event.stop();
        model.change((writer)=>{
            const tableCellToSelect = selectedTableCells[isBackward ? selectedTableCells.length - 1 : 0];
            model.change((writer)=>{
                for (const tableCell of selectedTableCells)model.deleteContent(writer.createSelection(tableCell, "in"));
            });
            const rangeToSelect = model.schema.getNearestSelectionRange(writer.createPositionAt(tableCellToSelect, 0));
            if (selection.is("documentSelection")) writer.setSelection(rangeToSelect);
            else selection.setTo(rangeToSelect);
        });
    }
    /**
	* This handler makes it possible to remove the content of all selected cells by starting to type.
	* If you take a look at {@link #_defineSelectionConverter} you will find out that despite the multi-cell selection being set
	* in the model, the view selection is collapsed in the last cell (because most browsers are unable to render multi-cell selections;
	* yes, it's a hack).
	*
	* When multiple cells are selected in the model and the user starts to type, the
	* {@link module:engine/view/document~ViewDocument#event:insertText} event carries information provided by the
	* beforeinput DOM  event, that in turn only knows about this collapsed DOM selection in the last cell.
	*
	* As a result, the selected cells have no chance to be cleaned up. To fix this, this listener intercepts
	* the event and injects the custom view selection in the data that translates correctly to the actual state
	* of the multi-cell selection in the model.
	*
	* @param data Insert text event data.
	*/ _handleInsertTextEvent(evt, data) {
        const editor = this.editor;
        const selectedCells = this.getSelectedTableCells();
        if (!selectedCells) return;
        const view = editor.editing.view;
        const mapper = editor.editing.mapper;
        const viewRanges = selectedCells.map((tableCell)=>view.createRangeOn(mapper.toViewElement(tableCell)));
        data.selection = view.createSelection(viewRanges);
        data.preventDefault();
    }
    /**
	* Returns an array of table cells that should be selected based on the
	* given anchor cell and target (focus) cell.
	*
	* The cells are returned in a reverse direction if the selection is backward.
	*/ _getCellsToSelect(anchorCell, targetCell) {
        const tableUtils = this.editor.plugins.get("TableUtils");
        const startLocation = tableUtils.getCellLocation(anchorCell);
        const endLocation = tableUtils.getCellLocation(targetCell);
        const startRow = Math.min(startLocation.row, endLocation.row);
        const endRow = Math.max(startLocation.row, endLocation.row);
        const startColumn = Math.min(startLocation.column, endLocation.column);
        const endColumnExtraColspan = parseInt(targetCell.getAttribute("colspan") || "1") - 1;
        const endColumn = Math.max(startLocation.column, endLocation.column + endColumnExtraColspan);
        const selectionMap = new Array(endRow - startRow + 1).fill(null).map(()=>[]);
        const walkerOptions = {
            startRow: startRow,
            endRow: endRow,
            startColumn: startColumn,
            endColumn: endColumn
        };
        for (const { row: row, cell: cell } of new $f1b97c36043e973c$export$6c270156410e802f(anchorCell.findAncestor("table"), walkerOptions))selectionMap[row - startRow].push(cell);
        const flipVertically = endLocation.row < startLocation.row;
        const flipHorizontally = endLocation.column < startLocation.column;
        if (flipVertically) selectionMap.reverse();
        if (flipHorizontally) selectionMap.forEach((row)=>row.reverse());
        return {
            cells: selectionMap.flat(),
            backward: flipVertically || flipHorizontally
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* This plugin adds support for copying/cutting/pasting fragments of tables.
* It is loaded automatically by the {@link module:table/table~Table} plugin.
*/ var $f1b97c36043e973c$export$69e981600a7b4dcd = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableClipboard";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a),
            (0, $4fa913ac1af6a08c$export$c85ef510b9161d09),
            $f1b97c36043e973c$export$d1314ebcfd9d7a36,
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const viewDocument = this.editor.editing.view.document;
        this.listenTo(viewDocument, "copy", (evt, data)=>this._onCopyCut(evt, data));
        this.listenTo(viewDocument, "cut", (evt, data)=>this._onCopyCut(evt, data));
        this._listenToContentInsertion();
        this.decorate("_replaceTableSlotCell");
    }
    /**
	* Sets up listening for events from the clipboard pipeline to properly handle
	* table content merging during paste/drop operations.
	*
	* When a user is dragging and dropping a table, we want to insert the entire table into
	* a table cell instead of merging table contents. For paste and other events,
	* the normal table merge behavior is applied.
	*/ _listenToContentInsertion() {
        const { editor: editor } = this;
        const clipboardPipeline = editor.plugins.get((0, $4fa913ac1af6a08c$export$c85ef510b9161d09));
        const tableSelection = editor.plugins.get($f1b97c36043e973c$export$d1314ebcfd9d7a36);
        let isPaste = false;
        clipboardPipeline.on("contentInsertion", (evt, data)=>{
            isPaste = data.method === "paste";
        });
        this.listenTo(editor.model, "insertContent", (evt, [content, selectable])=>{
            if (isPaste || tableSelection.getSelectedTableCells() !== null) this._onInsertContent(evt, content, selectable);
        }, {
            priority: "high"
        });
        clipboardPipeline.on("contentInsertion", ()=>{
            isPaste = false;
        }, {
            priority: "lowest"
        });
    }
    /**
	* Copies table content to a clipboard on "copy" & "cut" events.
	*
	* @param evt An object containing information about the handled event.
	* @param data Clipboard event data.
	*/ _onCopyCut(evt, data) {
        const view = this.editor.editing.view;
        const tableSelection = this.editor.plugins.get($f1b97c36043e973c$export$d1314ebcfd9d7a36);
        const clipboardMarkersUtils = this.editor.plugins.get((0, $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a));
        if (!tableSelection.getSelectedTableCells()) return;
        if (evt.name == "cut" && !this.editor.model.canEditAt(this.editor.model.document.selection)) return;
        data.preventDefault();
        evt.stop();
        this.editor.model.enqueueChange({
            isUndoable: evt.name === "cut"
        }, ()=>{
            const documentFragment = clipboardMarkersUtils._copySelectedFragmentWithMarkers(evt.name, this.editor.model.document.selection, ()=>tableSelection.getSelectionAsFragment());
            view.document.fire("clipboardOutput", {
                dataTransfer: data.dataTransfer,
                content: this.editor.data.toView(documentFragment),
                method: evt.name
            });
        });
    }
    /**
	* Overrides default {@link module:engine/model/model~Model#insertContent `model.insertContent()`} method to handle pasting table inside
	* selected table fragment.
	*
	* Depending on selected table fragment:
	* - If a selected table fragment is smaller than paste table it will crop pasted table to match dimensions.
	* - If dimensions are equal it will replace selected table fragment with a pasted table contents.
	*
	* @param content The content to insert.
	* @param selectable The selection into which the content should be inserted.
	* If not provided the current model document selection will be used.
	*/ _onInsertContent(evt, content, selectable) {
        if (selectable && !selectable.is("documentSelection")) return;
        const model = this.editor.model;
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const clipboardMarkersUtils = this.editor.plugins.get((0, $4fa913ac1af6a08c$export$4d1f8baf43f4dc3a));
        const pastedTable = this.getTableIfOnlyTableInContent(content, model);
        if (!pastedTable) return;
        const selectedTableCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        if (!selectedTableCells.length) {
            $f1b97c36043e973c$export$5ef8873941f24b00(pastedTable, tableUtils);
            return;
        }
        evt.stop();
        if (content.is("documentFragment")) clipboardMarkersUtils._pasteMarkersIntoTransformedElement(content.markers, (writer)=>this._replaceSelectedCells(pastedTable, selectedTableCells, writer));
        else this.editor.model.change((writer)=>{
            this._replaceSelectedCells(pastedTable, selectedTableCells, writer);
        });
    }
    /**
	* Inserts provided `selectedTableCells` into `pastedTable`.
	*/ _replaceSelectedCells(pastedTable, selectedTableCells, writer) {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const pastedDimensions = {
            width: tableUtils.getColumns(pastedTable),
            height: tableUtils.getRows(pastedTable)
        };
        const selection = $f1b97c36043e973c$var$prepareTableForPasting(selectedTableCells, pastedDimensions, writer, tableUtils);
        const selectionHeight = selection.lastRow - selection.firstRow + 1;
        const selectionWidth = selection.lastColumn - selection.firstColumn + 1;
        const cropDimensions = {
            startRow: 0,
            startColumn: 0,
            endRow: Math.min(selectionHeight, pastedDimensions.height) - 1,
            endColumn: Math.min(selectionWidth, pastedDimensions.width) - 1
        };
        pastedTable = $f1b97c36043e973c$export$4fd6c7e514948ca9(pastedTable, cropDimensions, writer);
        const selectedTable = selectedTableCells[0].findAncestor("table");
        const cellsToSelect = this._replaceSelectedCellsWithPasted(pastedTable, pastedDimensions, selectedTable, selection, writer, tableUtils);
        if (this.editor.plugins.get("TableSelection").isEnabled) {
            const selectionRanges = tableUtils.sortRanges(cellsToSelect.map((cell)=>writer.createRangeOn(cell)));
            writer.setSelection(selectionRanges);
        } else writer.setSelection(cellsToSelect[0], 0);
        return selectedTable;
    }
    /**
	* Replaces the part of selectedTable with pastedTable.
	*/ _replaceSelectedCellsWithPasted(pastedTable, pastedDimensions, selectedTable, selection, writer, tableUtils) {
        const { width: pastedWidth, height: pastedHeight } = pastedDimensions;
        const pastedTableLocationMap = $f1b97c36043e973c$var$createLocationMap(pastedTable, pastedWidth, pastedHeight);
        const selectedTableMap = [
            ...new $f1b97c36043e973c$export$6c270156410e802f(selectedTable, {
                startRow: selection.firstRow,
                endRow: selection.lastRow,
                startColumn: selection.firstColumn,
                endColumn: selection.lastColumn,
                includeAllSlots: true
            })
        ];
        const cellsToSelect = [];
        let insertPosition;
        for (const tableSlot of selectedTableMap){
            const { row: row, column: column } = tableSlot;
            if (column === selection.firstColumn) insertPosition = tableSlot.getPositionBefore();
            const pastedRow = row - selection.firstRow;
            const pastedColumn = column - selection.firstColumn;
            const pastedCell = pastedTableLocationMap[pastedRow % pastedHeight][pastedColumn % pastedWidth];
            const cellToInsert = pastedCell ? writer.cloneElement(pastedCell) : null;
            const newTableCell = this._replaceTableSlotCell(tableSlot, cellToInsert, insertPosition, writer);
            if (!newTableCell) continue;
            $f1b97c36043e973c$export$482c6ce78bd60281(newTableCell, row, column, selection.lastRow, selection.lastColumn, writer);
            cellsToSelect.push(newTableCell);
            insertPosition = writer.createPositionAfter(newTableCell);
        }
        const headingRows = parseInt(selectedTable.getAttribute("headingRows") || "0");
        const headingColumns = parseInt(selectedTable.getAttribute("headingColumns") || "0");
        const footerRows = parseInt(selectedTable.getAttribute("footerRows") || "0");
        const footerIndex = tableUtils.getRows(selectedTable) - footerRows;
        const areHeadingRowsIntersectingSelection = selection.firstRow < headingRows && headingRows <= selection.lastRow;
        const areHeadingColumnsIntersectingSelection = selection.firstColumn < headingColumns && headingColumns <= selection.lastColumn;
        const areFooterRowsIntersectingSelection = selection.firstRow < footerIndex && footerIndex <= selection.lastRow;
        if (areHeadingRowsIntersectingSelection) {
            const newCells = $f1b97c36043e973c$var$doHorizontalSplit(selectedTable, headingRows, {
                first: selection.firstColumn,
                last: selection.lastColumn
            }, writer, selection.firstRow);
            cellsToSelect.push(...newCells);
        }
        if (areHeadingColumnsIntersectingSelection) {
            const newCells = $f1b97c36043e973c$var$doVerticalSplit(selectedTable, headingColumns, {
                first: selection.firstRow,
                last: selection.lastRow
            }, writer);
            cellsToSelect.push(...newCells);
        }
        if (areFooterRowsIntersectingSelection) {
            const newCells = $f1b97c36043e973c$var$doHorizontalSplit(selectedTable, footerIndex, {
                first: selection.firstColumn,
                last: selection.lastColumn
            }, writer, selection.firstRow);
            cellsToSelect.push(...newCells);
        }
        return cellsToSelect;
    }
    /**
	* Replaces a single table slot.
	*
	* @returns Inserted table cell or null if slot should remain empty.
	* @private
	*/ _replaceTableSlotCell(tableSlot, cellToInsert, insertPosition, writer) {
        const { cell: cell, isAnchor: isAnchor } = tableSlot;
        if (isAnchor) writer.remove(cell);
        if (!cellToInsert) return null;
        writer.insert(cellToInsert, insertPosition);
        return cellToInsert;
    }
    /**
	* Extracts the table for pasting into a table.
	*
	* @param content The content to insert.
	* @param model The editor model.
	*/ getTableIfOnlyTableInContent(content, model) {
        if (!content.is("documentFragment") && !content.is("element")) return null;
        if (content.is("element", "table")) return content;
        if (content.childCount == 1 && content.getChild(0).is("element", "table")) return content.getChild(0);
        const contentRange = model.createRangeIn(content);
        for (const element of contentRange.getItems())if (element.is("element", "table")) {
            const rangeBefore = model.createRange(contentRange.start, model.createPositionBefore(element));
            if (model.hasContent(rangeBefore, {
                ignoreWhitespaces: true
            })) return null;
            const rangeAfter = model.createRange(model.createPositionAfter(element), contentRange.end);
            if (model.hasContent(rangeAfter, {
                ignoreWhitespaces: true
            })) return null;
            return element;
        }
        return null;
    }
};
/**
* Prepares a table for pasting and returns adjusted selection dimensions.
*/ function $f1b97c36043e973c$var$prepareTableForPasting(selectedTableCells, pastedDimensions, writer, tableUtils) {
    const selectedTable = selectedTableCells[0].findAncestor("table");
    const columnIndexes = tableUtils.getColumnIndexes(selectedTableCells);
    const rowIndexes = tableUtils.getRowIndexes(selectedTableCells);
    const selection = {
        firstColumn: columnIndexes.first,
        lastColumn: columnIndexes.last,
        firstRow: rowIndexes.first,
        lastRow: rowIndexes.last
    };
    const shouldExpandSelection = selectedTableCells.length === 1;
    if (shouldExpandSelection) {
        selection.lastRow += pastedDimensions.height - 1;
        selection.lastColumn += pastedDimensions.width - 1;
        $f1b97c36043e973c$var$expandTableSize(selectedTable, selection.lastRow + 1, selection.lastColumn + 1, tableUtils);
    }
    if (shouldExpandSelection || !tableUtils.isSelectionRectangular(selectedTableCells)) $f1b97c36043e973c$var$splitCellsToRectangularSelection(selectedTable, selection, writer);
    else {
        selection.lastRow = $f1b97c36043e973c$export$abc118df6412c45a(selectedTable, selection);
        selection.lastColumn = $f1b97c36043e973c$export$637b4fa83bfe055a(selectedTable, selection);
    }
    return selection;
}
/**
* Expand table (in place) to expected size.
*/ function $f1b97c36043e973c$var$expandTableSize(table, expectedHeight, expectedWidth, tableUtils) {
    const tableWidth = tableUtils.getColumns(table);
    const tableHeight = tableUtils.getRows(table);
    if (expectedWidth > tableWidth) tableUtils.insertColumns(table, {
        at: tableWidth,
        columns: expectedWidth - tableWidth
    });
    if (expectedHeight > tableHeight) tableUtils.insertRows(table, {
        at: tableHeight,
        rows: expectedHeight - tableHeight
    });
}
/**
* Returns two-dimensional array that is addressed by [ row ][ column ] that stores cells anchored at given location.
*
* At given row & column location it might be one of:
*
* * cell - cell from pasted table anchored at this location.
* * null - if no cell is anchored at this location.
*
* For instance, from a table below:
*
*   +----+----+----+----+
*   | 00 | 01 | 02 | 03 |
*   +    +----+----+----+
*   |    | 11      | 13 |
*   +----+         +----+
*   | 20 |         | 23 |
*   +----+----+----+----+
*
* The method will return an array (numbers represents cell element):
*
* ```ts
* const map = [
*   [ '00', '01', '02', '03' ],
*   [ null, '11', null, '13' ],
*   [ '20', null, null, '23' ]
* ]
* ```
*
* This allows for a quick access to table at give row & column. For instance to access table cell "13" from pasted table call:
*
* ```ts
* const cell = map[ 1 ][ 3 ]
* ```
*/ function $f1b97c36043e973c$var$createLocationMap(table, width, height) {
    const map = new Array(height).fill(null).map(()=>new Array(width).fill(null));
    for (const { column: column, row: row, cell: cell } of new $f1b97c36043e973c$export$6c270156410e802f(table))map[row][column] = cell;
    return map;
}
/**
* Make selected cells rectangular by splitting the cells that stand out from a rectangular selection.
*
* In the table below a selection is shown with "::" and slots with anchor cells are named.
*
* +----+----+----+----+----+                    +----+----+----+----+----+
* | 00 | 01 | 02 | 03      |                    | 00 | 01 | 02 | 03      |
* +    +----+    +----+----+                    |    ::::::::::::::::----+
* |    | 11 |    | 13 | 14 |                    |    ::11 |    | 13:: 14 |    <- first row
* +----+----+    +    +----+                    +----::---|    |   ::----+
* | 20 | 21 |    |    | 24 |   select cells:    | 20 ::21 |    |   :: 24 |
* +----+----+    +----+----+     11 -> 33       +----::---|    |---::----+
* | 30      |    | 33 | 34 |                    | 30 ::   |    | 33:: 34 |    <- last row
* +         +    +----+    +                    |    ::::::::::::::::    +
* |         |    | 43 |    |                    |         |    | 43 |    |
* +----+----+----+----+----+                    +----+----+----+----+----+
*                                                      ^          ^
*                                                     first & last columns
*
* Will update table to:
*
*                       +----+----+----+----+----+
*                       | 00 | 01 | 02 | 03      |
*                       +    +----+----+----+----+
*                       |    | 11 |    | 13 | 14 |
*                       +----+----+    +    +----+
*                       | 20 | 21 |    |    | 24 |
*                       +----+----+    +----+----+
*                       | 30 |    |    | 33 | 34 |
*                       +    +----+----+----+    +
*                       |    |    |    | 43 |    |
*                       +----+----+----+----+----+
*
* In th example above:
* - Cell "02" which have `rowspan = 4` must be trimmed at first and at after last row.
* - Cell "03" which have `rowspan = 2` and `colspan = 2` must be trimmed at first column and after last row.
* - Cells "00", "03" & "30" which cannot be cut by this algorithm as they are outside the trimmed area.
* - Cell "13" cannot be cut as it is inside the trimmed area.
*/ function $f1b97c36043e973c$var$splitCellsToRectangularSelection(table, dimensions, writer) {
    const { firstRow: firstRow, lastRow: lastRow, firstColumn: firstColumn, lastColumn: lastColumn } = dimensions;
    const rowIndexes = {
        first: firstRow,
        last: lastRow
    };
    const columnIndexes = {
        first: firstColumn,
        last: lastColumn
    };
    $f1b97c36043e973c$var$doVerticalSplit(table, firstColumn, rowIndexes, writer);
    $f1b97c36043e973c$var$doVerticalSplit(table, lastColumn + 1, rowIndexes, writer);
    $f1b97c36043e973c$var$doHorizontalSplit(table, firstRow, columnIndexes, writer);
    $f1b97c36043e973c$var$doHorizontalSplit(table, lastRow + 1, columnIndexes, writer, firstRow);
}
function $f1b97c36043e973c$var$doHorizontalSplit(table, splitRow, limitColumns, writer, startRow = 0) {
    if (splitRow < 1) return;
    return $f1b97c36043e973c$export$fe40d87a82c3f66b(table, splitRow, startRow).filter(({ column: column, cellWidth: cellWidth })=>$f1b97c36043e973c$var$isAffectedBySelection(column, cellWidth, limitColumns)).map(({ cell: cell })=>$f1b97c36043e973c$export$a6095ae3c4be1312(cell, splitRow, writer));
}
function $f1b97c36043e973c$var$doVerticalSplit(table, splitColumn, limitRows, writer) {
    if (splitColumn < 1) return;
    return $f1b97c36043e973c$export$3c25e8e245f1d08c(table, splitColumn).filter(({ row: row, cellHeight: cellHeight })=>$f1b97c36043e973c$var$isAffectedBySelection(row, cellHeight, limitRows)).map(({ cell: cell, column: column })=>$f1b97c36043e973c$export$da7153964952c988(cell, column, splitColumn, writer));
}
/**
* Checks if cell at given row (column) is affected by a rectangular selection defined by first/last column (row).
*
* The same check is used for row as for column.
*/ function $f1b97c36043e973c$var$isAffectedBySelection(index, span, limit) {
    const endIndex = index + span - 1;
    const { first: first, last: last } = limit;
    return index >= first && index <= last || index < first && endIndex >= first;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablekeyboard
*/ /**
* This plugin enables keyboard navigation for tables.
* It is loaded automatically by the {@link module:table/table~Table} plugin.
*/ var $f1b97c36043e973c$export$fb90accabe662254 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableKeyboard";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$d1314ebcfd9d7a36,
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        const t = editor.t;
        this.listenTo(viewDocument, "arrowKey", (...args)=>this._onArrowKey(...args), {
            context: "table"
        });
        this.listenTo(viewDocument, "tab", (...args)=>this._handleTabOnSelectedTable(...args), {
            context: "figure"
        });
        this.listenTo(viewDocument, "tab", (...args)=>this._handleTab(...args), {
            context: [
                "th",
                "td"
            ]
        });
        editor.accessibility.addKeystrokeInfoGroup({
            id: "table",
            label: t("Keystrokes that can be used in a table cell"),
            keystrokes: [
                {
                    label: t("Move the selection to the next cell"),
                    keystroke: "Tab"
                },
                {
                    label: t("Move the selection to the previous cell"),
                    keystroke: "Shift+Tab"
                },
                {
                    label: t("Insert a new table row (when in the last cell of a table)"),
                    keystroke: "Tab"
                },
                {
                    label: t("Navigate through the table"),
                    keystroke: [
                        [
                            "arrowup"
                        ],
                        [
                            "arrowright"
                        ],
                        [
                            "arrowdown"
                        ],
                        [
                            "arrowleft"
                        ]
                    ]
                }
            ]
        });
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:tab tab} events for the <kbd>Tab</kbd> key executed
	* when the table widget is selected.
	*/ _handleTabOnSelectedTable(bubblingEventInfo, domEventData) {
        const selectedElement = this.editor.model.document.selection.getSelectedElement();
        if (!selectedElement || !selectedElement.is("element", "table")) return;
        domEventData.stopPropagation();
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:tab tab} events for the <kbd>Tab</kbd> key executed
	* inside table cells.
	*/ _handleTab(bubblingEventInfo, domEventData) {
        const editor = this.editor;
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const tableSelection = this.editor.plugins.get("TableSelection");
        const selection = editor.model.document.selection;
        const isForward = !domEventData.shiftKey;
        let tableCell = tableUtils.getTableCellsContainingSelection(selection)[0];
        if (!tableCell) tableCell = tableSelection.getFocusCell();
        if (!tableCell) return;
        domEventData.stopPropagation();
        const tableRow = tableCell.parent;
        const table = tableRow.parent;
        const currentRowIndex = table.getChildIndex(tableRow);
        const isLastCellInRow = tableRow.getChildIndex(tableCell) === tableRow.childCount - 1;
        const isLastRow = currentRowIndex === tableUtils.getRows(table) - 1;
        if (isForward && isLastRow && isLastCellInRow) editor.execute("insertTableRowBelow");
    }
    /**
	* Handles {@link module:engine/view/document~ViewDocument#event:keydown keydown} events.
	*/ _onArrowKey(eventInfo, domEventData) {
        const editor = this.editor;
        const keyCode = domEventData.keyCode;
        const direction = (0, $c7bc2cb7e2db0227$export$ad185f2969a88a73)(keyCode, editor.locale.contentLanguageDirection);
        if (this._handleArrowKeys(direction, domEventData.shiftKey)) {
            domEventData.preventDefault();
            domEventData.stopPropagation();
            eventInfo.stop();
        }
    }
    /**
	* Handles arrow keys to move the selection around the table.
	*
	* @param direction The direction of the arrow key.
	* @param expandSelection If the current selection should be expanded.
	* @returns Returns `true` if key was handled.
	*/ _handleArrowKeys(direction, expandSelection) {
        const tableUtils = this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        const tableSelection = this.editor.plugins.get("TableSelection");
        const model = this.editor.model;
        const selection = model.document.selection;
        const isForward = [
            "right",
            "down"
        ].includes(direction);
        const selectedCells = tableUtils.getSelectedTableCells(selection);
        if (selectedCells.length) {
            let focusCell;
            if (expandSelection) focusCell = tableSelection.getFocusCell();
            else focusCell = isForward ? selectedCells[selectedCells.length - 1] : selectedCells[0];
            this._navigateFromCellInDirection(focusCell, direction, expandSelection);
            return true;
        }
        const tableCell = selection.focus.findAncestor("tableCell");
        /* istanbul ignore if: paranoid check -- @preserve */ if (!tableCell) return false;
        if (!selection.isCollapsed) {
            if (expandSelection) {
                if (selection.isBackward == isForward && !selection.containsEntireContent(tableCell)) return false;
            } else {
                const selectedElement = selection.getSelectedElement();
                if (!selectedElement || !model.schema.isObject(selectedElement)) return false;
            }
        }
        if (this._isSelectionAtCellEdge(selection, tableCell, isForward)) {
            this._navigateFromCellInDirection(tableCell, direction, expandSelection);
            return true;
        }
        return false;
    }
    /**
	* Returns `true` if the selection is at the boundary of a table cell according to the navigation direction.
	*
	* @param selection The current selection.
	* @param tableCell The current table cell element.
	* @param isForward The expected navigation direction.
	*/ _isSelectionAtCellEdge(selection, tableCell, isForward) {
        const model = this.editor.model;
        const schema = this.editor.model.schema;
        const focus = isForward ? selection.getLastPosition() : selection.getFirstPosition();
        if (!schema.getLimitElement(focus).is("element", "tableCell")) return model.createPositionAt(tableCell, isForward ? "end" : 0).isTouching(focus);
        const probe = model.createSelection(focus);
        model.modifySelection(probe, {
            direction: isForward ? "forward" : "backward"
        });
        return focus.isEqual(probe.focus);
    }
    /**
	* Moves the selection from the given table cell in the specified direction.
	*
	* @param focusCell The table cell that is current multi-cell selection focus.
	* @param direction Direction in which selection should move.
	* @param expandSelection If the current selection should be expanded. Default value is false.
	*/ _navigateFromCellInDirection(focusCell, direction, expandSelection = false) {
        const model = this.editor.model;
        const table = focusCell.findAncestor("table");
        const tableMap = [
            ...new $f1b97c36043e973c$export$6c270156410e802f(table, {
                includeAllSlots: true
            })
        ];
        const { row: lastRow, column: lastColumn } = tableMap[tableMap.length - 1];
        const currentCellInfo = tableMap.find(({ cell: cell })=>cell == focusCell);
        let { row: row, column: column } = currentCellInfo;
        switch(direction){
            case "left":
                column--;
                break;
            case "up":
                row--;
                break;
            case "right":
                column += currentCellInfo.cellWidth;
                break;
            case "down":
                row += currentCellInfo.cellHeight;
        }
        if (row < 0 || row > lastRow || column < 0 && row <= 0 || column > lastColumn && row >= lastRow) {
            model.change((writer)=>{
                writer.setSelection(writer.createRangeOn(table));
            });
            return;
        }
        if (column < 0) {
            column = expandSelection ? 0 : lastColumn;
            row--;
        } else if (column > lastColumn) {
            column = expandSelection ? lastColumn : 0;
            row++;
        }
        const cellToSelect = tableMap.find((cellInfo)=>cellInfo.row == row && cellInfo.column == column).cell;
        const isForward = [
            "right",
            "down"
        ].includes(direction);
        const tableSelection = this.editor.plugins.get("TableSelection");
        if (expandSelection && tableSelection.isEnabled) {
            const anchorCell = tableSelection.getAnchorCell() || focusCell;
            tableSelection.setCellSelection(anchorCell, cellToSelect);
        } else {
            const positionToSelect = model.createPositionAt(cellToSelect, isForward ? 0 : "end");
            model.change((writer)=>{
                writer.setSelection(positionToSelect);
            });
        }
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablemouse/mouseeventsobserver
*/ /**
* The mouse selection event observer.
*
* It registers listeners for the following DOM events:
*
* - `'mousemove'`
* - `'mouseleave'`
*
* Note that this observer is disabled by default. To enable this observer, it needs to be added to
* {@link module:engine/view/view~EditingView} using the {@link module:engine/view/view~EditingView#addObserver} method.
*
* The observer is registered by the {@link module:table/tableselection~TableSelection} plugin.
*
* @internal
*/ var $f1b97c36043e973c$export$7815c0a315f5e2c5 = class extends (0, $b9b9f2bdf9c6137f$export$fc1db128570de841) {
    domEventType = [
        "mousemove",
        "mouseleave"
    ];
    /**
	* @inheritDoc
	*/ onDomEvent(domEvent) {
        this.fire(domEvent.type, domEvent);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablemouse
*/ /**
* This plugin enables a table cells' selection with the mouse.
* It is loaded automatically by the {@link module:table/table~Table} plugin.
*/ var $f1b97c36043e973c$export$f8de06c6255dbfa2 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableMouse";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$d1314ebcfd9d7a36,
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.editing.view.addObserver($f1b97c36043e973c$export$7815c0a315f5e2c5);
        this._enableShiftClickSelection();
        this._enableMouseDragSelection();
    }
    /**
	* Enables making cells selection by <kbd>Shift</kbd>+click. Creates a selection from the cell which previously held
	* the selection to the cell which was clicked. It can be the same cell, in which case it selects a single cell.
	*/ _enableShiftClickSelection() {
        const editor = this.editor;
        const tableUtils = editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
        let blockSelectionChange = false;
        const tableSelection = editor.plugins.get($f1b97c36043e973c$export$d1314ebcfd9d7a36);
        this.listenTo(editor.editing.view.document, "mousedown", (evt, domEventData)=>{
            const selection = editor.model.document.selection;
            if (!this.isEnabled || !tableSelection.isEnabled) return;
            if (!domEventData.domEvent.shiftKey) return;
            const anchorCell = tableSelection.getAnchorCell() || tableUtils.getTableCellsContainingSelection(selection)[0];
            if (!anchorCell) return;
            const targetCell = this._getModelTableCellFromDomEvent(domEventData);
            if (targetCell && $f1b97c36043e973c$var$haveSameTableParent(anchorCell, targetCell)) {
                blockSelectionChange = true;
                tableSelection.setCellSelection(anchorCell, targetCell);
                domEventData.preventDefault();
            }
        });
        this.listenTo(editor.editing.view.document, "mouseup", ()=>{
            blockSelectionChange = false;
        });
        this.listenTo(editor.editing.view.document, "selectionChange", (evt)=>{
            if (blockSelectionChange) evt.stop();
        }, {
            priority: "highest"
        });
    }
    /**
	* Enables making cells selection by dragging.
	*
	* The selection is made only on mousemove. Mouse tracking is started on mousedown.
	* However, the cells selection is enabled only after the mouse cursor left the anchor cell.
	* Thanks to that normal text selection within one cell works just fine. However, you can still select
	* just one cell by leaving the anchor cell and moving back to it.
	*/ _enableMouseDragSelection() {
        const editor = this.editor;
        let anchorCell, targetCell;
        let beganCellSelection = false;
        let blockSelectionChange = false;
        const tableSelection = editor.plugins.get($f1b97c36043e973c$export$d1314ebcfd9d7a36);
        this.listenTo(editor.editing.view.document, "mousedown", (evt, domEventData)=>{
            if (!this.isEnabled || !tableSelection.isEnabled) return;
            if (domEventData.domEvent.shiftKey || domEventData.domEvent.ctrlKey || domEventData.domEvent.altKey) return;
            anchorCell = this._getModelTableCellFromDomEvent(domEventData);
        });
        this.listenTo(editor.editing.view.document, "mousemove", (evt, domEventData)=>{
            if (!domEventData.domEvent.buttons) return;
            if (!anchorCell) return;
            const newTargetCell = this._getModelTableCellFromDomEvent(domEventData);
            if (newTargetCell && $f1b97c36043e973c$var$haveSameTableParent(anchorCell, newTargetCell)) {
                targetCell = newTargetCell;
                if (!beganCellSelection && targetCell != anchorCell) beganCellSelection = true;
            }
            if (!beganCellSelection) return;
            blockSelectionChange = true;
            tableSelection.setCellSelection(anchorCell, targetCell);
            domEventData.preventDefault();
        });
        this.listenTo(editor.editing.view.document, "mouseup", ()=>{
            beganCellSelection = false;
            blockSelectionChange = false;
            anchorCell = null;
            targetCell = null;
        });
        this.listenTo(editor.editing.view.document, "selectionChange", (evt)=>{
            if (blockSelectionChange) evt.stop();
        }, {
            priority: "highest"
        });
    }
    /**
	* Returns the model table cell element based on the target element of the passed DOM event.
	*
	* @returns Returns the table cell or `undefined`.
	*/ _getModelTableCellFromDomEvent(domEventData) {
        const viewTargetElement = domEventData.target;
        const viewPosition = this.editor.editing.view.createPositionAt(viewTargetElement, 0);
        return this.editor.editing.mapper.toModelPosition(viewPosition).parent.findAncestor("tableCell", {
            includeSelf: true
        });
    }
};
function $f1b97c36043e973c$var$haveSameTableParent(cellA, cellB) {
    return cellA.parent.parent == cellB.parent.parent;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/table
*/ /**
* The table plugin.
*
* For a detailed overview, check the {@glink features/tables/tables Table feature documentation}.
*
* This is a "glue" plugin that loads the following table features:
*
* * {@link module:table/tableediting~TableEditing editing feature},
* * {@link module:table/tableselection~TableSelection selection feature},
* * {@link module:table/tablekeyboard~TableKeyboard keyboard navigation feature},
* * {@link module:table/tablemouse~TableMouse mouse selection feature},
* * {@link module:table/tableclipboard~TableClipboard clipboard feature},
* * {@link module:table/tableui~TableUI UI feature}.
*/ var $f1b97c36043e973c$export$54ec01a60f47d33d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23,
            $f1b97c36043e973c$export$b2bb66d048987d4d,
            $f1b97c36043e973c$export$d1314ebcfd9d7a36,
            $f1b97c36043e973c$export$f8de06c6255dbfa2,
            $f1b97c36043e973c$export$fb90accabe662254,
            $f1b97c36043e973c$export$69e981600a7b4dcd,
            (0, $5547ab21e02f1e9e$export$a829527ff4e4114a)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "Table";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/plaintableoutput
*/ /**
* The plain table output feature.
*
* This feature strips the `<figure>` tag from the table data. This is because this tag is not supported
* by most popular email clients and removing it ensures compatibility.
*/ var $f1b97c36043e973c$export$748de3f91ac0c3d3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "PlainTableOutput";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$54ec01a60f47d33d
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:table", (evt, data, conversionApi)=>{
                conversionApi.consumable.consume(data.viewItem, {
                    classes: "table"
                });
            });
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Depending on the position of the selection either return the selected table or the table higher in the hierarchy.
*
* @internal
*/ function $f1b97c36043e973c$export$6eb262e884d1feb7(selection) {
    const selectedTable = $f1b97c36043e973c$export$8a49eeff155197c8(selection);
    if (selectedTable) return selectedTable;
    return $f1b97c36043e973c$export$12bf7673dfde59f0(selection);
}
/**
* Returns a table widget editing view element if one is selected.
*
* @internal
*/ function $f1b97c36043e973c$export$8a49eeff155197c8(selection) {
    const viewElement = selection.getSelectedElement();
    if (viewElement && $f1b97c36043e973c$var$isTableWidget(viewElement)) return viewElement;
    return null;
}
/**
* Returns a table widget editing view element if one is among the selection's ancestors.
*
* @internal
*/ function $f1b97c36043e973c$export$12bf7673dfde59f0(selection) {
    const selectionPosition = selection.getFirstPosition();
    if (!selectionPosition) return null;
    let parent = selectionPosition.parent;
    while(parent){
        if (parent.is("element") && $f1b97c36043e973c$var$isTableWidget(parent)) return parent;
        parent = parent.parent;
    }
    return null;
}
/**
* Checks if a given view element is a table widget.
*
* @internal
*/ function $f1b97c36043e973c$var$isTableWidget(viewNode) {
    return viewNode.is("element") && !!viewNode.getCustomProperty("table") && (0, $5547ab21e02f1e9e$export$33101d01ca587c36)(viewNode);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tabletoolbar
*/ /**
* The table toolbar class. It creates toolbars for the table feature and its content (for now only for the table cell content).
*
* The table toolbar shows up when a table widget is selected. Its components (e.g. buttons) are created based on the
* {@link module:table/tableconfig~TableConfig#tableToolbar `table.tableToolbar` configuration option}.
*
* Table content toolbar shows up when the selection is inside the content of a table. It creates its component based on the
* {@link module:table/tableconfig~TableConfig#contentToolbar `table.contentToolbar` configuration option}.
*/ var $f1b97c36043e973c$export$6a2d8ec0c309d683 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $5547ab21e02f1e9e$export$c46c0a800280391d)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableToolbar";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const t = editor.t;
        const widgetToolbarRepository = editor.plugins.get((0, $5547ab21e02f1e9e$export$c46c0a800280391d));
        const tableContentToolbarItems = editor.config.get("table.contentToolbar");
        const tableToolbarItems = editor.config.get("table.tableToolbar");
        if (tableContentToolbarItems) widgetToolbarRepository.register("tableContent", {
            ariaLabel: t("Table toolbar"),
            items: tableContentToolbarItems,
            getRelatedElement: $f1b97c36043e973c$export$12bf7673dfde59f0
        });
        if (tableToolbarItems) widgetToolbarRepository.register("table", {
            ariaLabel: t("Table toolbar"),
            items: tableToolbarItems,
            getRelatedElement: $f1b97c36043e973c$export$8a49eeff155197c8
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/ui/colorinputview
*/ /**
* The color input view class. It allows the user to type in a color (hex, rgb, etc.)
* or choose it from the configurable color palette with a preview.
*
* @internal
*/ var $f1b97c36043e973c$export$a1470eecab978ae8 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* A cached reference to the options passed to the constructor.
	*/ options;
    /**
	* Tracks information about the DOM focus in the view.
	*/ focusTracker;
    /**
	* Helps cycling over focusable children in the input view.
	*/ focusCycler;
    /**
	* A collection of views that can be focused in the view.
	*/ _focusables;
    /**
	* An instance of the dropdown allowing to select a color from a grid.
	*/ dropdownView;
    /**
	* An instance of the input allowing the user to type a color value.
	*/ inputView;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* The flag that indicates whether the user is still typing.
	* If set to true, it means that the text input field ({@link #inputView}) still has the focus.
	* So, we should interrupt the user by replacing the input's value.
	*/ _stillTyping;
    /**
	* Creates an instance of the color input view.
	*
	* @param locale The locale instance.
	* @param options The input options.
	* @param options.colorDefinitions The colors to be displayed in the palette inside the input's dropdown.
	* @param options.columns The number of columns in which the colors will be displayed.
	* @param options.defaultColorValue If specified, the color input view will replace the "Remove color" button with
	* the "Restore default" button. Instead of clearing the input field, the default color value will be set.
	*/ constructor(locale, options){
        super(locale);
        this.set("value", "");
        this.set("isReadOnly", false);
        this.set("isFocused", false);
        this.set("isEmpty", true);
        this.options = options;
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this.dropdownView = this._createDropdownView();
        this.inputView = this._createInputTextView();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this._stillTyping = false;
        this.focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        this.setTemplate({
            tag: "div",
            attributes: {
                class: [
                    "ck",
                    "ck-input-color"
                ]
            },
            children: [
                this.dropdownView,
                this.inputView
            ]
        });
        this.on("change:value", (evt, name, inputValue)=>this._setInputValue(inputValue));
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        [
            this.inputView,
            this.dropdownView.buttonView
        ].forEach((view)=>{
            this.focusTracker.add(view.element);
            this._focusables.add(view);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* Focuses the view.
	*/ focus(direction) {
        if (direction === -1) this.focusCycler.focusLast();
        else this.focusCycler.focusFirst();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Creates and configures the {@link #dropdownView}.
	*/ _createDropdownView() {
        const locale = this.locale;
        const t = locale.t;
        const bind = this.bindTemplate;
        const colorSelector = this._createColorSelector(locale);
        const dropdown = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
        const colorPreview = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)();
        colorPreview.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck",
                    "ck-input-color__button__preview"
                ],
                style: {
                    backgroundColor: bind.to("value")
                }
            },
            children: [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "ck",
                            "ck-input-color__button__preview__no-color-indicator",
                            bind.if("value", "ck-hidden", (value)=>value != "")
                        ]
                    }
                }
            ]
        });
        dropdown.buttonView.extendTemplate({
            attributes: {
                class: "ck-input-color__button"
            }
        });
        dropdown.buttonView.children.add(colorPreview);
        dropdown.buttonView.label = t("Color picker");
        dropdown.buttonView.tooltip = true;
        dropdown.panelView.extendTemplate({
            attributes: {
                class: "ck-dropdown__panel_fit-content"
            }
        });
        dropdown.panelPosition = locale.uiLanguageDirection === "rtl" ? "se" : "sw";
        dropdown.panelView.children.add(colorSelector);
        dropdown.bind("isEnabled").to(this, "isReadOnly", (value)=>!value);
        let colorSelectorRendered = false;
        dropdown.on("change:isOpen", (evt, name, isVisible)=>{
            if (!colorSelectorRendered) {
                colorSelectorRendered = true;
                colorSelector.appendUI();
            }
            if (isVisible) {
                colorSelector.updateSelectedColors();
                colorSelector.showColorGridsFragment();
            }
        });
        return dropdown;
    }
    /**
	* Creates and configures an instance of {@link module:ui/inputtext/inputtextview~InputTextView}.
	*
	* @returns A configured instance to be set as {@link #inputView}.
	*/ _createInputTextView() {
        const locale = this.locale;
        const inputView = new (0, $29fd27cb9bdab9d2$export$75906a940df4ae45)(locale);
        inputView.extendTemplate({
            on: {
                blur: inputView.bindTemplate.to("blur")
            }
        });
        inputView.value = this.value;
        inputView.bind("isReadOnly", "hasError").to(this);
        this.bind("isFocused", "isEmpty").to(inputView);
        inputView.on("input", ()=>{
            const inputValue = inputView.element.value;
            const mappedColor = this.options.colorDefinitions.find((def)=>inputValue === def.label);
            this._stillTyping = true;
            this.value = mappedColor && mappedColor.color || inputValue;
        });
        inputView.on("blur", ()=>{
            this._stillTyping = false;
            this._setInputValue(inputView.element.value);
        });
        inputView.delegate("input").to(this);
        return inputView;
    }
    /**
	* Creates and configures the panel with "color grid" and "color picker" inside the {@link #dropdownView}.
	*/ _createColorSelector(locale) {
        const t = locale.t;
        const defaultColor = this.options.defaultColorValue || "";
        const removeColorButtonLabel = defaultColor ? t("Restore default") : t("Remove color");
        const colorSelector = new (0, $29fd27cb9bdab9d2$export$840fffd5af8d58e0)(locale, {
            colors: this.options.colorDefinitions,
            columns: this.options.columns ?? (0, $29fd27cb9bdab9d2$export$d573929527255e12),
            removeButtonLabel: removeColorButtonLabel,
            colorPickerLabel: t("Color picker"),
            colorPickerViewConfig: this.options.colorPickerConfig === false ? false : {
                ...this.options.colorPickerConfig,
                hideInput: true
            }
        });
        colorSelector.on("execute", (evt, data)=>{
            if (data.source === "colorPickerSaveButton") {
                this.dropdownView.isOpen = false;
                return;
            }
            this.value = data.value || defaultColor;
            this.fire("input");
            if (data.source !== "colorPicker") this.dropdownView.isOpen = false;
        });
        /**
		* Color is saved before changes in color picker. In case "cancel button" is pressed
		* this color will be applied.
		*/ let backupColor = this.value;
        colorSelector.on("colorPicker:cancel", ()=>{
            /**
			* Revert color to previous value before changes in color picker.
			*/ this.value = backupColor;
            this.fire("input");
            this.dropdownView.isOpen = false;
        });
        colorSelector.on("colorPicker:show", ()=>{
            /**
			* Save color value before changes in color picker.
			*/ backupColor = this.value;
        });
        colorSelector.bind("selectedColor").to(this, "value");
        return colorSelector;
    }
    /**
	* Sets {@link #inputView}'s value property to the color value or color label,
	* if there is one and the user is not typing.
	*
	* Handles cases like:
	*
	* * Someone picks the color in the grid.
	* * The color is set from the plugin level.
	*
	* @param inputValue Color value to be set.
	*/ _setInputValue(inputValue) {
        if (!this._stillTyping) {
            const normalizedInputValue = $f1b97c36043e973c$var$normalizeColor(inputValue);
            const mappedColor = this.options.colorDefinitions.find((def)=>normalizedInputValue === $f1b97c36043e973c$var$normalizeColor(def.color));
            if (mappedColor) this.inputView.value = mappedColor.label;
            else this.inputView.value = inputValue || "";
        }
    }
};
/**
* Normalizes color value, by stripping extensive whitespace.
* For example., transforms:
* * `   rgb(  25 50    0 )` to `rgb(25 50 0)`,
* * "\t  rgb(  25 ,  50,0 )		" to `rgb(25 50 0)`.
*
* @param colorString The value to be normalized.
*/ function $f1b97c36043e973c$var$normalizeColor(colorString) {
    return colorString.replace(/([(,])\s+/g, "$1").replace(/^\s+|\s+(?=[),\s]|$)/g, "").replace(/,|\s/g, " ");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/utils/ui/table-properties
*/ const $f1b97c36043e973c$var$isEmpty = (val)=>val === "";
/**
* Returns an object containing pairs of CSS border style values and their localized UI
* labels. Used by {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView}
* and {@link module:table/tableproperties/ui/tablepropertiesview~TablePropertiesView}.
*
* @internal
* @param t The "t" function provided by the editor that is used to localize strings.
*/ function $f1b97c36043e973c$export$b091a4233b1c3c0e(t) {
    return {
        none: t("None"),
        solid: t("Solid"),
        dotted: t("Dotted"),
        dashed: t("Dashed"),
        double: t("Double"),
        groove: t("Groove"),
        ridge: t("Ridge"),
        inset: t("Inset"),
        outset: t("Outset")
    };
}
/**
* Returns a localized error string that can be displayed next to color (background, border)
* fields that have an invalid value.
*
* @internal
* @param t The "t" function provided by the editor that is used to localize strings.
*/ function $f1b97c36043e973c$export$1a2f83aec824ae53(t) {
    return t("The color is invalid. Try \"#FF0000\" or \"rgb(255,0,0)\" or \"red\".");
}
/**
* Returns a localized error string that can be displayed next to length (padding, border width)
* fields that have an invalid value.
*
* @internal
* @param t The "t" function provided by the editor that is used to localize strings.
*/ function $f1b97c36043e973c$export$46dc479228bc03c5(t) {
    return t("The value is invalid. Try \"10px\" or \"2em\" or simply \"2\".");
}
/**
* Returns `true` when the passed value is an empty string or a valid CSS color expression.
* Otherwise, `false` is returned.
*
* See {@link module:engine/view/styles/utils~isColorStyleValue}.
*
* @internal
*/ function $f1b97c36043e973c$export$370a0c0da4507ee8(value) {
    value = value.trim().toLowerCase();
    return $f1b97c36043e973c$var$isEmpty(value) || (0, $b9b9f2bdf9c6137f$export$4a7c3f499aa3bc3c)(value);
}
/**
* Returns `true` when the passed value is an empty string, a number without a unit or a valid CSS length expression.
* Otherwise, `false` is returned.
*
* See {@link module:engine/view/styles/utils~isLengthStyleValue}.
* See {@link module:engine/view/styles/utils~isPercentageStyleValue}.
*
* @internal
*/ function $f1b97c36043e973c$export$529621552bb8a6ba(value) {
    value = value.trim();
    return $f1b97c36043e973c$var$isEmpty(value) || $f1b97c36043e973c$var$isNumberString(value) || (0, $b9b9f2bdf9c6137f$export$1c20de4d9563b5aa)(value) || (0, $b9b9f2bdf9c6137f$export$573cb1d40169758d)(value);
}
/**
* Returns `true` when the passed value is an empty string, a number without a unit or a valid CSS length expression.
* Otherwise, `false` is returned.
*
* See {@link module:engine/view/styles/utils~isLengthStyleValue}.
*
* @internal
*/ function $f1b97c36043e973c$export$2e984cc58f31fbb7(value) {
    value = value.trim();
    return $f1b97c36043e973c$var$isEmpty(value) || $f1b97c36043e973c$var$isNumberString(value) || (0, $b9b9f2bdf9c6137f$export$1c20de4d9563b5aa)(value);
}
/**
* Generates item definitions for a UI dropdown that allows changing the border style of a table or a table cell.
*
* @internal
* @param defaultStyle The default border.
*/ function $f1b97c36043e973c$export$9c9d3add93f76391(view, defaultStyle) {
    const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    const styleLabels = $f1b97c36043e973c$export$b091a4233b1c3c0e(view.t);
    for(const style in styleLabels){
        const definition = {
            type: "button",
            model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                _borderStyleValue: style,
                label: styleLabels[style],
                role: "menuitemradio",
                withText: true
            })
        };
        if (style === "none") definition.model.bind("isOn").to(view, "borderStyle", (value)=>{
            if (defaultStyle === "none") return !value;
            return value === style;
        });
        else definition.model.bind("isOn").to(view, "borderStyle", (value)=>{
            return value === style;
        });
        itemDefinitions.add(definition);
    }
    return itemDefinitions;
}
/**
* A helper that fills a toolbar with buttons that:
*
* * have some labels,
* * have some icons,
* * set a certain UI view property value upon execution.
*
* @internal
* @param options Configuration options
* @param options.view The view that has the observable property.
* @param options.icons Object with button icons.
* @param options.toolbar The toolbar to fill with buttons.
* @param options.labels Object with button labels.
* @param options.propertyName The name of the observable property in the view.
* @param options.nameToValue A function that maps a button name to a value. By default names are the same as values.
* @param options.defaultValue Default value for the property.
*/ function $f1b97c36043e973c$export$5fdc8ac304f25e14(options) {
    const { view: view, icons: icons, toolbar: toolbar, labels: labels, propertyName: propertyName, nameToValue: nameToValue, defaultValue: defaultValue } = options;
    for(const name in labels){
        const button = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(view.locale);
        button.set({
            role: "radio",
            isToggleable: true,
            label: labels[name],
            icon: icons[name],
            tooltip: labels[name]
        });
        const buttonValue = nameToValue ? nameToValue(name) : name;
        button.bind("isOn").to(view, propertyName, (value)=>{
            let valueToCompare = value;
            if (value === "" && defaultValue) valueToCompare = defaultValue;
            return buttonValue === valueToCompare;
        });
        button.on("execute", ()=>{
            if (!defaultValue && buttonValue && view[propertyName] === buttonValue) view[propertyName] = void 0;
            else view[propertyName] = buttonValue;
        });
        toolbar.items.add(button);
    }
}
/**
* A default color palette used by various user interfaces related to tables, for instance,
* by {@link module:table/tablecellproperties/tablecellpropertiesui~TableCellPropertiesUI} or
* {@link module:table/tableproperties/tablepropertiesui~TablePropertiesUI}.
*
* The color palette follows the {@link module:table/tableconfig~TableColorConfig table color configuration format}
* and is shared with the other features that display a color grid. See
* {@link module:ui/colorgrid/colors~defaultColors} for its contents.
*
* @internal
*/ const $f1b97c36043e973c$export$a80c205843e19358 = (0, $29fd27cb9bdab9d2$export$fdf79bef57893a8d);
/**
* Returns a creator for a color input with a label.
*
* For given options, it returns a function that creates an instance of a
* {@link module:table/ui/colorinputview~ColorInputView color input} logically related to
* a {@link module:ui/labeledfield/labeledfieldview~LabeledFieldView labeled view} in the DOM.
*
* The helper does the following:
*
* * It sets the color input `id` and `ariaDescribedById` attributes.
* * It binds the color input `isReadOnly` to the labeled view.
* * It binds the color input `hasError` to the labeled view.
* * It enables a logic that cleans up the error when the user starts typing in the color input.
*
* Usage:
*
* ```ts
* const colorInputCreator = getLabeledColorInputCreator( {
*   colorConfig: [ ... ],
*   columns: 3,
* } );
*
* const labeledInputView = new LabeledFieldView( locale, colorInputCreator );
* console.log( labeledInputView.view ); // A color input instance.
* ```
*
* @internal
* @param options Color input options.
* @param options.colorConfig The configuration of the color palette displayed in the input's dropdown.
* @param options.columns The configuration of the number of columns the color palette consists of in the input's dropdown.
* @param options.defaultColorValue If specified, the color input view will replace the "Remove color" button with
* the "Restore default" button. Instead of clearing the input field, the default color value will be set.
* @param options.colorPickerConfig The configuration of the color picker. You could disable it or define your output format.
*/ function $f1b97c36043e973c$export$a69845a6512a5a97(options) {
    return (labeledFieldView, viewUid, statusUid)=>{
        const colorInputView = new $f1b97c36043e973c$export$a1470eecab978ae8(labeledFieldView.locale, {
            colorDefinitions: $f1b97c36043e973c$var$colorConfigToColorGridDefinitions(options.colorConfig),
            columns: options.columns,
            defaultColorValue: options.defaultColorValue,
            colorPickerConfig: options.colorPickerConfig
        });
        colorInputView.inputView.set({
            id: viewUid,
            ariaDescribedById: statusUid
        });
        colorInputView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (value)=>!value);
        colorInputView.bind("hasError").to(labeledFieldView, "errorText", (value)=>!!value);
        colorInputView.on("input", ()=>{
            labeledFieldView.errorText = null;
        });
        labeledFieldView.bind("isEmpty", "isFocused").to(colorInputView);
        return colorInputView;
    };
}
/**
* A simple helper method to detect number strings.
* I allows full number notation, so omitting 0 is not allowed:
*/ function $f1b97c36043e973c$var$isNumberString(value) {
    const parsedValue = parseFloat(value);
    return !Number.isNaN(parsedValue) && value === String(parsedValue);
}
function $f1b97c36043e973c$var$colorConfigToColorGridDefinitions(colorConfig) {
    return colorConfig.map((item)=>({
            color: item.model,
            label: item.label,
            options: {
                hasBorder: item.hasBorder
            }
        }));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellproperties/ui/tablecellpropertiesview
*/ /**
* The class representing a table cell properties form, allowing users to customize
* certain style aspects of a table cell, for instance, border, padding, text alignment, etc..
*/ var $f1b97c36043e973c$export$6fe31bfd98e3caef = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Options passed to the view. See {@link #constructor} to learn more.
	*/ options;
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of child views in the form.
	*/ children;
    /**
	* A dropdown that allows selecting the style of the table cell border.
	*/ borderStyleDropdown;
    /**
	* An input that allows specifying the width of the table cell border.
	*/ borderWidthInput;
    /**
	* An input that allows specifying the color of the table cell border.
	*/ borderColorInput;
    /**
	* An input that allows specifying the table cell background color.
	*/ backgroundInput;
    /**
	* A dropdown that allows selecting the type of the table cell (data or header).
	*/ cellTypeDropdown;
    /**
	* An input that allows specifying the table cell padding.
	*/ paddingInput;
    /**
	* An input that allows specifying the table cell width.
	*/ widthInput;
    /**
	* An input that allows specifying the table cell height.
	*/ heightInput;
    /**
	* A toolbar with buttons that allow changing the horizontal text alignment in a table cell.
	*/ horizontalAlignmentToolbar;
    /**
	* A toolbar with buttons that allow changing the vertical text alignment in a table cell.
	*/ verticalAlignmentToolbar;
    /**
	* The "Save" button view.
	*/ saveButtonView;
    /**
	* The "Cancel" button view.
	*/ cancelButtonView;
    /**
	* The "Back" button view.
	*/ backButtonView;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param options Additional configuration of the view.
	* @param options.borderColors A configuration of the border color palette used by the
	* {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView#borderColorInput}.
	* @param options.backgroundColors A configuration of the background color palette used by the
	* {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView#backgroundInput}.
	* @param options.defaultTableCellProperties The default table cell properties.
	*/ constructor(locale, options){
        super(locale);
        this.set({
            borderStyle: "",
            borderWidth: "",
            borderColor: "",
            padding: "",
            backgroundColor: "",
            width: "",
            height: "",
            horizontalAlignment: "",
            verticalAlignment: "",
            cellType: ""
        });
        this.options = options;
        const { borderStyleDropdown: borderStyleDropdown, borderWidthInput: borderWidthInput, borderColorInput: borderColorInput, borderRowLabel: borderRowLabel } = this._createBorderFields();
        const { backgroundRowLabel: backgroundRowLabel, backgroundInput: backgroundInput } = this._createBackgroundFields();
        const { cellTypeRowLabel: cellTypeRowLabel, cellTypeDropdown: cellTypeDropdown } = this._createCellTypeField();
        const { widthInput: widthInput, operatorLabel: operatorLabel, heightInput: heightInput, dimensionsLabel: dimensionsLabel } = this._createDimensionFields();
        const { horizontalAlignmentToolbar: horizontalAlignmentToolbar, verticalAlignmentToolbar: verticalAlignmentToolbar, alignmentLabel: alignmentLabel } = this._createAlignmentFields();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.children = this.createCollection();
        this.borderStyleDropdown = borderStyleDropdown;
        this.borderWidthInput = borderWidthInput;
        this.borderColorInput = borderColorInput;
        this.backgroundInput = backgroundInput;
        this.cellTypeDropdown = cellTypeDropdown;
        this.paddingInput = this._createPaddingField();
        this.widthInput = widthInput;
        this.heightInput = heightInput;
        this.horizontalAlignmentToolbar = horizontalAlignmentToolbar;
        this.verticalAlignmentToolbar = verticalAlignmentToolbar;
        const { saveButtonView: saveButtonView, cancelButtonView: cancelButtonView } = this._createActionButtons();
        this.saveButtonView = saveButtonView;
        this.cancelButtonView = cancelButtonView;
        this.backButtonView = this._createBackButton();
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        const header = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(locale, {
            label: this.t("Cell properties")
        });
        header.children.add(this.backButtonView, 0);
        this.children.add(header);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            labelView: borderRowLabel,
            children: [
                borderRowLabel,
                borderStyleDropdown,
                borderWidthInput,
                borderColorInput
            ],
            class: "ck-table-form__border-row"
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    labelView: cellTypeRowLabel,
                    children: [
                        cellTypeRowLabel,
                        cellTypeDropdown
                    ],
                    class: "ck-table-form__cell-type-row"
                }),
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    labelView: backgroundRowLabel,
                    children: [
                        backgroundRowLabel,
                        backgroundInput
                    ],
                    class: "ck-table-form__background-row"
                })
            ]
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    labelView: dimensionsLabel,
                    children: [
                        dimensionsLabel,
                        widthInput,
                        operatorLabel,
                        heightInput
                    ],
                    class: "ck-table-form__dimensions-row"
                }),
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    children: [
                        this.paddingInput
                    ],
                    class: "ck-table-cell-properties-form__padding-row"
                })
            ]
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            labelView: alignmentLabel,
            children: [
                alignmentLabel,
                horizontalAlignmentToolbar,
                verticalAlignmentToolbar
            ],
            class: "ck-table-cell-properties-form__alignment-row"
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.cancelButtonView,
                this.saveButtonView
            ],
            class: [
                "ck-table-form__action-row"
            ]
        }));
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-table-form",
                    "ck-table-cell-properties-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.borderColorInput,
            this.backgroundInput
        ].forEach((view)=>{
            this._focusCycler.chain(view.fieldView.focusCycler);
        });
        [
            this.borderStyleDropdown,
            this.borderColorInput,
            this.borderWidthInput,
            this.cellTypeDropdown,
            this.backgroundInput,
            this.widthInput,
            this.heightInput,
            this.paddingInput,
            this.horizontalAlignmentToolbar,
            this.verticalAlignmentToolbar,
            this.cancelButtonView,
            this.saveButtonView,
            this.backButtonView
        ].forEach((view)=>{
            this._focusables.add(view);
            this.focusTracker.add(view.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist focusable field in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #borderStyleDropdown},
	* * {@link #borderWidthInput},
	* * {@link #borderColorInput}.
	*/ _createBorderFields() {
        const defaultTableCellProperties = this.options.defaultTableCellProperties;
        const defaultBorder = {
            style: defaultTableCellProperties.borderStyle,
            width: defaultTableCellProperties.borderWidth,
            color: defaultTableCellProperties.borderColor
        };
        const colorInputCreator = $f1b97c36043e973c$export$a69845a6512a5a97({
            colorConfig: this.options.borderColors,
            columns: this.options.colorGridColumns,
            defaultColorValue: defaultBorder.color,
            colorPickerConfig: this.options.colorPickerConfig
        });
        const locale = this.locale;
        const t = this.t;
        const accessibleLabel = t("Style");
        const borderRowLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        borderRowLabel.text = t("Border");
        const styleLabels = $f1b97c36043e973c$export$b091a4233b1c3c0e(t);
        const borderStyleDropdown = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$78775bf7bbba162f));
        borderStyleDropdown.set({
            label: accessibleLabel,
            class: "ck-table-form__border-style"
        });
        borderStyleDropdown.fieldView.buttonView.set({
            ariaLabel: accessibleLabel,
            ariaLabelledBy: void 0,
            isOn: false,
            withText: true,
            tooltip: accessibleLabel
        });
        borderStyleDropdown.fieldView.buttonView.bind("label").to(this, "borderStyle", (value)=>{
            return styleLabels[value ? value : "none"];
        });
        borderStyleDropdown.fieldView.on("execute", (evt)=>{
            this.borderStyle = evt.source._borderStyleValue;
        });
        borderStyleDropdown.bind("isEmpty").to(this, "borderStyle", (value)=>!value);
        (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(borderStyleDropdown.fieldView, $f1b97c36043e973c$export$9c9d3add93f76391(this, defaultBorder.style), {
            role: "menu",
            ariaLabel: accessibleLabel
        });
        const borderWidthInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        borderWidthInput.set({
            label: t("Width"),
            class: "ck-table-form__border-width"
        });
        borderWidthInput.fieldView.bind("value").to(this, "borderWidth");
        borderWidthInput.bind("isEnabled").to(this, "borderStyle", $f1b97c36043e973c$var$isBorderStyleSet$1);
        borderWidthInput.fieldView.on("input", ()=>{
            this.borderWidth = borderWidthInput.fieldView.element.value;
        });
        const borderColorInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, colorInputCreator);
        borderColorInput.set({
            label: t("Color"),
            class: "ck-table-form__border-color"
        });
        borderColorInput.fieldView.bind("value").to(this, "borderColor");
        borderColorInput.bind("isEnabled").to(this, "borderStyle", $f1b97c36043e973c$var$isBorderStyleSet$1);
        borderColorInput.fieldView.on("input", ()=>{
            this.borderColor = borderColorInput.fieldView.value;
        });
        this.on("change:borderStyle", (evt, name, newValue, oldValue)=>{
            if (!$f1b97c36043e973c$var$isBorderStyleSet$1(newValue)) {
                this.borderColor = "";
                this.borderWidth = "";
            }
            if (!$f1b97c36043e973c$var$isBorderStyleSet$1(oldValue)) {
                this.borderColor = defaultBorder.color;
                this.borderWidth = defaultBorder.width;
            }
        });
        return {
            borderRowLabel: borderRowLabel,
            borderStyleDropdown: borderStyleDropdown,
            borderColorInput: borderColorInput,
            borderWidthInput: borderWidthInput
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #backgroundInput}.
	*/ _createBackgroundFields() {
        const locale = this.locale;
        const t = this.t;
        const backgroundRowLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        backgroundRowLabel.text = t("Background");
        const colorInputCreator = $f1b97c36043e973c$export$a69845a6512a5a97({
            colorConfig: this.options.backgroundColors,
            columns: this.options.colorGridColumns,
            defaultColorValue: this.options.defaultTableCellProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
        });
        const backgroundInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, colorInputCreator);
        backgroundInput.set({
            label: t("Color"),
            class: "ck-table-cell-properties-form__background"
        });
        backgroundInput.fieldView.bind("value").to(this, "backgroundColor");
        backgroundInput.fieldView.on("input", ()=>{
            this.backgroundColor = backgroundInput.fieldView.value;
        });
        return {
            backgroundRowLabel: backgroundRowLabel,
            backgroundInput: backgroundInput
        };
    }
    /**
	* Create cell type field.
	*
	* * {@link #cellTypeDropdown}.
	*
	* @internal
	*/ _createCellTypeField() {
        const locale = this.locale;
        const t = this.t;
        const cellTypeRowLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        cellTypeRowLabel.text = t("Cell type");
        const cellTypeLabels = this._cellTypeLabels;
        const cellTypeDropdown = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$78775bf7bbba162f));
        cellTypeDropdown.set({
            label: t("Cell type"),
            class: "ck-table-cell-properties-form__cell-type"
        });
        cellTypeDropdown.fieldView.buttonView.set({
            ariaLabel: t("Cell type"),
            ariaLabelledBy: void 0,
            isOn: false,
            withText: true,
            tooltip: t("Cell type")
        });
        cellTypeDropdown.fieldView.buttonView.bind("label").to(this, "cellType", (value)=>{
            return cellTypeLabels[value || "data"];
        });
        cellTypeDropdown.fieldView.on("execute", (evt)=>{
            this.cellType = evt.source._cellTypeValue;
        });
        cellTypeDropdown.bind("isEmpty").to(this, "cellType", (value)=>!value);
        (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(cellTypeDropdown.fieldView, this._getCellTypeDefinitions(), {
            role: "menu",
            ariaLabel: t("Cell type")
        });
        return {
            cellTypeRowLabel: cellTypeRowLabel,
            cellTypeDropdown: cellTypeDropdown
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #widthInput}.
	* * {@link #heightInput}.
	*/ _createDimensionFields() {
        const locale = this.locale;
        const t = this.t;
        const dimensionsLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        dimensionsLabel.text = t("Dimensions");
        const widthInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        widthInput.set({
            label: t("Width"),
            class: "ck-table-form__dimensions-row__width"
        });
        widthInput.fieldView.bind("value").to(this, "width");
        widthInput.fieldView.on("input", ()=>{
            this.width = widthInput.fieldView.element.value;
        });
        const operatorLabel = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(locale);
        operatorLabel.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck-table-form__dimension-operator"
                ]
            },
            children: [
                {
                    text: "\xd7"
                }
            ]
        });
        const heightInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        heightInput.set({
            label: t("Height"),
            class: "ck-table-form__dimensions-row__height"
        });
        heightInput.fieldView.bind("value").to(this, "height");
        heightInput.fieldView.on("input", ()=>{
            this.height = heightInput.fieldView.element.value;
        });
        return {
            dimensionsLabel: dimensionsLabel,
            widthInput: widthInput,
            operatorLabel: operatorLabel,
            heightInput: heightInput
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #paddingInput}.
	*/ _createPaddingField() {
        const locale = this.locale;
        const t = this.t;
        const paddingInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        paddingInput.set({
            label: t("Padding"),
            class: "ck-table-cell-properties-form__padding"
        });
        paddingInput.fieldView.bind("value").to(this, "padding");
        paddingInput.fieldView.on("input", ()=>{
            this.padding = paddingInput.fieldView.element.value;
        });
        return paddingInput;
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #horizontalAlignmentToolbar},
	* * {@link #verticalAlignmentToolbar}.
	*/ _createAlignmentFields() {
        const locale = this.locale;
        const t = this.t;
        const alignmentLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        const ALIGNMENT_ICONS = {
            left: (0, $e8dc502aba5ac3f5$export$df3b17223210ab85),
            center: (0, $e8dc502aba5ac3f5$export$a36e1e8e01d62636),
            right: (0, $e8dc502aba5ac3f5$export$bd03fac3c90d8fee),
            justify: (0, $e8dc502aba5ac3f5$export$e9b166ff0ced1423),
            top: (0, $e8dc502aba5ac3f5$export$f53e4c3135e2e1b3),
            middle: (0, $e8dc502aba5ac3f5$export$29541e77ab082032),
            bottom: (0, $e8dc502aba5ac3f5$export$828b0812a275deff)
        };
        alignmentLabel.text = t("Table cell text alignment");
        const horizontalAlignmentToolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale);
        const isContentRTL = locale.contentLanguageDirection === "rtl";
        horizontalAlignmentToolbar.set({
            isCompact: true,
            role: "radiogroup",
            ariaLabel: t("Horizontal text alignment toolbar"),
            class: "ck-table-cell-properties-form__horizontal-alignment-toolbar"
        });
        $f1b97c36043e973c$export$5fdc8ac304f25e14({
            view: this,
            icons: ALIGNMENT_ICONS,
            toolbar: horizontalAlignmentToolbar,
            labels: this._horizontalAlignmentLabels,
            propertyName: "horizontalAlignment",
            nameToValue: (name)=>{
                if (isContentRTL) {
                    if (name === "left") return "right";
                    else if (name === "right") return "left";
                }
                return name;
            },
            defaultValue: this.options.defaultTableCellProperties.horizontalAlignment
        });
        const verticalAlignmentToolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale);
        verticalAlignmentToolbar.set({
            isCompact: true,
            role: "radiogroup",
            ariaLabel: t("Vertical text alignment toolbar"),
            class: "ck-table-cell-properties-form__vertical-alignment-toolbar"
        });
        $f1b97c36043e973c$export$5fdc8ac304f25e14({
            view: this,
            icons: ALIGNMENT_ICONS,
            toolbar: verticalAlignmentToolbar,
            labels: this._verticalAlignmentLabels,
            propertyName: "verticalAlignment",
            defaultValue: this.options.defaultTableCellProperties.verticalAlignment
        });
        return {
            horizontalAlignmentToolbar: horizontalAlignmentToolbar,
            verticalAlignmentToolbar: verticalAlignmentToolbar,
            alignmentLabel: alignmentLabel
        };
    }
    /**
	* Creates the following form controls:
	*
	* * {@link #saveButtonView},
	* * {@link #cancelButtonView}.
	*/ _createActionButtons() {
        const locale = this.locale;
        const t = this.t;
        const saveButtonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        const cancelButtonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        const fieldsThatShouldValidateToSave = [
            this.borderWidthInput,
            this.borderColorInput,
            this.backgroundInput,
            this.paddingInput
        ];
        saveButtonView.set({
            label: t("Save"),
            class: "ck-button-action ck-button_standard",
            type: "submit",
            withText: true
        });
        saveButtonView.bind("isEnabled").toMany(fieldsThatShouldValidateToSave, "errorText", (...errorTexts)=>{
            return errorTexts.every((errorText)=>!errorText);
        });
        cancelButtonView.set({
            label: t("Cancel"),
            withText: true,
            class: "ck-button_standard"
        });
        cancelButtonView.delegate("execute").to(this, "cancel");
        return {
            saveButtonView: saveButtonView,
            cancelButtonView: cancelButtonView
        };
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Creates the cell type dropdown definitions.
	*/ _getCellTypeDefinitions() {
        const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
        const labels = this._cellTypeLabels;
        const types = [
            "data",
            "header"
        ];
        if (this.options.showScopedHeaderOptions) types.push("header-column", "header-row");
        for (const type of types){
            const definition = {
                type: "button",
                model: new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
                    _cellTypeValue: type,
                    label: labels[type],
                    role: "menuitemradio",
                    withText: true
                })
            };
            definition.model.bind("isOn").to(this, "cellType", (value)=>value === type);
            itemDefinitions.add(definition);
        }
        return itemDefinitions;
    }
    /**
	* Provides localized labels for {@link #horizontalAlignmentToolbar} buttons.
	*/ get _horizontalAlignmentLabels() {
        const locale = this.locale;
        const t = this.t;
        const left = t("Align cell text to the left");
        const center = t("Align cell text to the center");
        const right = t("Align cell text to the right");
        const justify = t("Justify cell text");
        if (locale.uiLanguageDirection === "rtl") return {
            right: right,
            center: center,
            left: left,
            justify: justify
        };
        else return {
            left: left,
            center: center,
            right: right,
            justify: justify
        };
    }
    /**
	* Provides localized labels for {@link #verticalAlignmentToolbar} buttons.
	*/ get _verticalAlignmentLabels() {
        const t = this.t;
        return {
            top: t("Align cell text to the top"),
            middle: t("Align cell text to the middle"),
            bottom: t("Align cell text to the bottom")
        };
    }
    /**
	* Provides localized labels for {@link #cellTypeDropdown}.
	*/ get _cellTypeLabels() {
        const t = this.t;
        return {
            data: t("Data cell"),
            header: t("Header cell"),
            "header-column": t("Column header"),
            "header-row": t("Row header")
        };
    }
};
function $f1b97c36043e973c$var$isBorderStyleSet$1(value) {
    return value !== "none";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/utils/ui/contextualballoon
*/ const $f1b97c36043e973c$var$BALLOON_POSITIONS = /* #__PURE__ */ (()=>[
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.northArrowSouth,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.northArrowSouthWest,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.northArrowSouthEast,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.southArrowNorth,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.southArrowNorthWest,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.southArrowNorthEast,
        (0, $29fd27cb9bdab9d2$export$fa83a894fd8a5d2c).defaultPositions.viewportStickyNorth
    ])();
/**
* A helper utility that positions the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} instance
* with respect to the table in the editor content, if one is selected.
*
* @internal
* @param editor The editor instance.
* @param target Either "cell" or "table". Determines the target the balloon will be attached to.
*/ function $f1b97c36043e973c$export$6873846109289138(editor, target) {
    const balloon = editor.plugins.get("ContextualBalloon");
    const selection = editor.editing.view.document.selection;
    let position;
    if (target === "cell") {
        if ($f1b97c36043e973c$export$12bf7673dfde59f0(selection)) position = $f1b97c36043e973c$export$8204ddf050364bf7(editor);
    } else if ($f1b97c36043e973c$export$6eb262e884d1feb7(selection)) position = $f1b97c36043e973c$export$d0050425c94c519b(editor);
    if (position) balloon.updatePosition(position);
}
/**
* Returns the positioning options that control the geometry of the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} with respect
* to the selected table in the editor content.
*
* @param editor The editor instance.
*/ function $f1b97c36043e973c$export$d0050425c94c519b(editor) {
    const selection = editor.model.document.selection;
    const modelTable = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
    const viewTable = editor.editing.mapper.toViewElement(modelTable);
    return {
        target: editor.editing.view.domConverter.mapViewToDom(viewTable),
        positions: $f1b97c36043e973c$var$BALLOON_POSITIONS
    };
}
/**
* Returns the positioning options that control the geometry of the
* {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} with respect
* to the selected table cell in the editor content.
*
* @param editor The editor instance.
* @internal
*/ function $f1b97c36043e973c$export$8204ddf050364bf7(editor) {
    const mapper = editor.editing.mapper;
    const domConverter = editor.editing.view.domConverter;
    const selection = editor.model.document.selection;
    if (selection.rangeCount > 1) return {
        target: ()=>$f1b97c36043e973c$var$createBoundingRect(selection.getRanges(), editor),
        positions: $f1b97c36043e973c$var$BALLOON_POSITIONS
    };
    const modelTableCell = $f1b97c36043e973c$var$getTableCellAtPosition(selection.getFirstPosition());
    const viewTableCell = mapper.toViewElement(modelTableCell);
    return {
        target: domConverter.mapViewToDom(viewTableCell),
        positions: $f1b97c36043e973c$var$BALLOON_POSITIONS
    };
}
/**
* Returns the first selected table cell from a multi-cell or in-cell selection.
*
* @param position Document position.
*/ function $f1b97c36043e973c$var$getTableCellAtPosition(position) {
    return position.nodeAfter && position.nodeAfter.is("element", "tableCell") ? position.nodeAfter : position.findAncestor("tableCell");
}
/**
* Returns bounding rectangle for given model ranges.
*
* @param ranges Model ranges that the bounding rect should be returned for.
* @param editor The editor instance.
*/ function $f1b97c36043e973c$var$createBoundingRect(ranges, editor) {
    const mapper = editor.editing.mapper;
    const domConverter = editor.editing.view.domConverter;
    const rects = Array.from(ranges).map((range)=>{
        const modelTableCell = $f1b97c36043e973c$var$getTableCellAtPosition(range.start);
        const viewTableCell = mapper.toViewElement(modelTableCell);
        return new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domConverter.mapViewToDom(viewTableCell));
    });
    return (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d).getBoundingRect(rects);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellproperties/tablecellpropertiesui
*/ const $f1b97c36043e973c$var$ERROR_TEXT_TIMEOUT$1 = 500;
const $f1b97c36043e973c$var$propertyToCommandMap$1 = {
    borderStyle: "tableCellBorderStyle",
    borderColor: "tableCellBorderColor",
    borderWidth: "tableCellBorderWidth",
    height: "tableCellHeight",
    width: "tableCellWidth",
    padding: "tableCellPadding",
    backgroundColor: "tableCellBackgroundColor",
    horizontalAlignment: "tableCellHorizontalAlignment",
    verticalAlignment: "tableCellVerticalAlignment",
    cellType: "tableCellType"
};
/**
* The table cell properties UI plugin. It introduces the `'tableCellProperties'` button
* that opens a form allowing to specify the visual styling of a table cell.
*
* It uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
*/ var $f1b97c36043e973c$export$feb9c41b6e3eb6e3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The default table cell properties.
	*/ _defaultContentTableCellProperties;
    /**
	* The default layout table cell properties.
	*/ _defaultLayoutTableCellProperties;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* The cell properties form view displayed inside the balloon.
	*/ view;
    /**
	* The cell properties form view displayed inside the balloon (content table).
	*/ _viewWithContentTableDefaults;
    /**
	* The cell properties form view displayed inside the balloon (layout table).
	*/ _viewWithLayoutTableDefaults;
    /**
	* The batch used to undo all changes made by the form (which are live, as the user types)
	* when "Cancel" was pressed. Each time the view is shown, a new batch is created.
	*/ _undoStepBatch;
    /**
	* Flag used to indicate whether view is ready to execute update commands
	* (it finished loading initial data).
	*/ _isReady;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCellPropertiesUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("table.tableCellProperties", {
            borderColors: $f1b97c36043e973c$export$a80c205843e19358,
            backgroundColors: $f1b97c36043e973c$export$a80c205843e19358,
            colorGridColumns: (0, $29fd27cb9bdab9d2$export$d573929527255e12)
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = editor.t;
        this._defaultContentTableCellProperties = $f1b97c36043e973c$export$a9dfabf838746e9b(editor.config.get("table.tableCellProperties.defaultProperties"), {
            includeVerticalAlignmentProperty: true,
            includeHorizontalAlignmentProperty: true,
            includePaddingProperty: true,
            isRightToLeftContent: editor.locale.contentLanguageDirection === "rtl"
        });
        this._defaultLayoutTableCellProperties = $f1b97c36043e973c$export$6f5bcdb88bd6afde(void 0, {
            includeVerticalAlignmentProperty: true,
            includeHorizontalAlignmentProperty: true,
            isRightToLeftContent: editor.locale.contentLanguageDirection === "rtl"
        });
        this._balloon = editor.plugins.get((0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c));
        this.view = null;
        this._isReady = false;
        editor.ui.componentFactory.add("tableCellProperties", (locale)=>{
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                label: t("Cell properties"),
                icon: (0, $e8dc502aba5ac3f5$export$be160212d9876860),
                tooltip: true
            });
            this.listenTo(view, "execute", ()=>this._showView());
            const commands = Object.values($f1b97c36043e973c$var$propertyToCommandMap$1).map((commandName)=>editor.commands.get(commandName)).filter((val)=>!!val);
            view.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>areEnabled.some((isCommandEnabled)=>isCommandEnabled));
            return view;
        });
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this.view) this.view.destroy();
    }
    /**
	* Creates the {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView} instance.
	*
	* @returns The cell properties form view instance.
	*/ _createPropertiesView(defaultTableCellProperties) {
        const editor = this.editor;
        const config = editor.config.get("table.tableCellProperties");
        const scopedHeaders = !!editor.config.get("table.tableCellProperties.scopedHeaders");
        const borderColorsConfig = (0, $29fd27cb9bdab9d2$export$ee5a86b42a248fe4)(config.borderColors);
        const localizedBorderColors = (0, $29fd27cb9bdab9d2$export$8609308dd8d581de)(editor.locale, borderColorsConfig);
        const backgroundColorsConfig = (0, $29fd27cb9bdab9d2$export$ee5a86b42a248fe4)(config.backgroundColors);
        const localizedBackgroundColors = (0, $29fd27cb9bdab9d2$export$8609308dd8d581de)(editor.locale, backgroundColorsConfig);
        const hasColorPicker = config.colorPicker !== false;
        const view = new $f1b97c36043e973c$export$6fe31bfd98e3caef(editor.locale, {
            borderColors: localizedBorderColors,
            backgroundColors: localizedBackgroundColors,
            defaultTableCellProperties: defaultTableCellProperties,
            colorGridColumns: config.colorGridColumns,
            colorPickerConfig: hasColorPicker ? config.colorPicker || {} : false,
            showScopedHeaderOptions: scopedHeaders
        });
        const t = editor.t;
        view.render();
        this.listenTo(view, "submit", ()=>{
            this._hideView();
        });
        this.listenTo(view, "cancel", ()=>{
            if (this._undoStepBatch.operations.length) editor.execute("undo", this._undoStepBatch);
            this._hideView();
        });
        view.keystrokes.set("Esc", (data, cancel)=>{
            this._hideView();
            cancel();
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: view,
            activator: ()=>this._isViewInBalloon,
            contextElements: [
                this._balloon.view.element
            ],
            callback: ()=>this._hideView()
        });
        const colorErrorText = $f1b97c36043e973c$export$1a2f83aec824ae53(t);
        const lengthErrorText = $f1b97c36043e973c$export$46dc479228bc03c5(t);
        view.on("change:borderStyle", this._getPropertyChangeCallback("tableCellBorderStyle"));
        view.on("change:borderColor", this._getValidatedPropertyChangeCallback({
            viewField: view.borderColorInput,
            commandName: "tableCellBorderColor",
            errorText: colorErrorText,
            validator: $f1b97c36043e973c$export$370a0c0da4507ee8
        }));
        view.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
            viewField: view.borderWidthInput,
            commandName: "tableCellBorderWidth",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$2e984cc58f31fbb7
        }));
        view.on("change:padding", this._getValidatedPropertyChangeCallback({
            viewField: view.paddingInput,
            commandName: "tableCellPadding",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$529621552bb8a6ba
        }));
        view.on("change:width", this._getValidatedPropertyChangeCallback({
            viewField: view.widthInput,
            commandName: "tableCellWidth",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$529621552bb8a6ba
        }));
        view.on("change:height", this._getValidatedPropertyChangeCallback({
            viewField: view.heightInput,
            commandName: "tableCellHeight",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$529621552bb8a6ba
        }));
        view.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
            viewField: view.backgroundInput,
            commandName: "tableCellBackgroundColor",
            errorText: colorErrorText,
            validator: $f1b97c36043e973c$export$370a0c0da4507ee8
        }));
        view.on("change:horizontalAlignment", this._getPropertyChangeCallback("tableCellHorizontalAlignment"));
        view.on("change:verticalAlignment", this._getPropertyChangeCallback("tableCellVerticalAlignment"));
        const cellTypeCommand = editor.commands.get("tableCellType");
        if (cellTypeCommand) {
            view.cellTypeDropdown.bind("isEnabled").to(cellTypeCommand, "isEnabled");
            view.on("change:cellType", this._getPropertyChangeCallback("tableCellType"));
        }
        return view;
    }
    /**
	* In this method the "editor data -> UI" binding is happening.
	*
	* When executed, this method obtains selected cell property values from various table commands
	* and passes them to the {@link #view}.
	*
	* This way, the UI stays up–to–date with the editor data.
	*/ _fillViewFormFromCommandValues() {
        const commands = this.editor.commands;
        const borderStyleCommand = commands.get("tableCellBorderStyle");
        Object.entries($f1b97c36043e973c$var$propertyToCommandMap$1).flatMap(([property, commandName])=>{
            const effectiveCommandName = property === "width" ? this._getWidthCommandName() : commandName;
            const command = commands.get(effectiveCommandName);
            if (!command) return [];
            const propertyKey = property;
            let defaultValue;
            if (propertyKey === "cellType") defaultValue = "";
            else defaultValue = this.view === this._viewWithContentTableDefaults ? this._defaultContentTableCellProperties[propertyKey] || "" : this._defaultLayoutTableCellProperties[propertyKey] || "";
            return [
                [
                    property,
                    command.value || defaultValue
                ]
            ];
        }).forEach(([property, value])=>{
            if ((property === "borderColor" || property === "borderWidth") && borderStyleCommand.value === "none") return;
            this.view.set(property, value);
        });
        this._isReady = true;
    }
    /**
	* Shows the {@link #view} in the {@link #_balloon}.
	*
	* **Note**: Each time a view is shown, a new {@link #_undoStepBatch} is created. It contains
	* all changes made to the document when the view is visible, allowing a single undo step
	* for all of them.
	*/ _showView() {
        const editor = this.editor;
        const viewTable = $f1b97c36043e973c$export$6eb262e884d1feb7(editor.editing.view.document.selection);
        const modelTable = viewTable && editor.editing.mapper.toModelElement(viewTable);
        const useDefaults = !modelTable || modelTable.getAttribute("tableType") !== "layout";
        if (useDefaults && !this._viewWithContentTableDefaults) this._viewWithContentTableDefaults = this._createPropertiesView(this._defaultContentTableCellProperties);
        else if (!useDefaults && !this._viewWithLayoutTableDefaults) this._viewWithLayoutTableDefaults = this._createPropertiesView(this._defaultLayoutTableCellProperties);
        this.view = useDefaults ? this._viewWithContentTableDefaults : this._viewWithLayoutTableDefaults;
        this.listenTo(editor.ui, "update", ()=>{
            this._updateView();
        });
        this._fillViewFormFromCommandValues();
        this._balloon.add({
            view: this.view,
            position: $f1b97c36043e973c$export$8204ddf050364bf7(editor)
        });
        this._undoStepBatch = editor.model.createBatch();
        this.view.focus();
    }
    /**
	* Removes the {@link #view} from the {@link #_balloon}.
	*/ _hideView() {
        const editor = this.editor;
        this.stopListening(editor.ui, "update");
        this._isReady = false;
        this.view.saveButtonView.focus();
        this._balloon.remove(this.view);
        this.editor.editing.view.focus();
    }
    /**
	* Repositions the {@link #_balloon} or hides the {@link #view} if a table cell is no longer selected.
	*/ _updateView() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        if (!$f1b97c36043e973c$export$12bf7673dfde59f0(viewDocument.selection)) this._hideView();
        else if (this._isViewVisible) $f1b97c36043e973c$export$6873846109289138(editor, "cell");
    }
    /**
	* Returns `true` when the {@link #view} is visible in the {@link #_balloon}.
	*/ get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
    }
    /**
	* Returns `true` when the {@link #view} is in the {@link #_balloon}.
	*/ get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
    }
    /**
	* Creates a callback that when executed upon the {@link #view view's} property change
	* executes a related editor command with the new property value.
	*
	* @param commandName The default value of the command.
	*/ _getPropertyChangeCallback(commandName) {
        return (evt, propertyName, newValue)=>{
            if (!this._isReady) return;
            this.editor.execute(commandName, {
                value: newValue,
                batch: this._undoStepBatch
            });
        };
    }
    /**
	* Creates a callback that when executed upon the {@link #view view's} property change:
	* * Executes a related editor command with the new property value if the value is valid,
	* * Or sets the error text next to the invalid field, if the value did not pass the validation.
	*/ _getValidatedPropertyChangeCallback(options) {
        const { commandName: commandName, viewField: viewField, validator: validator, errorText: errorText } = options;
        const setErrorTextDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(()=>{
            viewField.errorText = errorText;
        }, $f1b97c36043e973c$var$ERROR_TEXT_TIMEOUT$1);
        return (evt, propertyName, newValue)=>{
            setErrorTextDebounced.cancel();
            if (!this._isReady) return;
            if (validator(newValue)) {
                const executedCommandName = commandName === "tableCellWidth" ? this._getWidthCommandName() : commandName;
                this.editor.execute(executedCommandName, {
                    value: newValue,
                    batch: this._undoStepBatch
                });
                viewField.errorText = null;
            } else setErrorTextDebounced();
        };
    }
    /**
	* Returns the command that drives the width field. When the table is resized and the selection maps onto a single
	* column, the width field is bound to (and executes) the `'tableColumnWidth'` command, so the width applies to the
	* column instead of being set as a per-cell width that the column group would shadow. Otherwise it falls back to
	* the `'tableCellWidth'` command.
	*/ _getWidthCommandName() {
        const columnWidthCommand = this.editor.commands.get("tableColumnWidth");
        return columnWidthCommand && columnWidthCommand.isEnabled ? "tableColumnWidth" : "tableCellWidth";
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellproperties/commands/tablecellpropertycommand
*/ /**
* The table cell attribute command.
*
* The command is a base command for other table cell property commands.
*/ var $f1b97c36043e973c$export$2178ae9d5401b613 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The attribute that will be set by the command.
	*/ attributeName;
    /**
	* The default value for the attribute.
	*
	* @readonly
	*/ _defaultValue;
    /**
	* The default value for the attribute for the content table.
	*/ _defaultContentTableValue;
    /**
	* The default value for the attribute for the layout table.
	*/ _defaultLayoutTableValue;
    /**
	* Creates a new `TableCellPropertyCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param attributeName Table cell attribute name.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, attributeName, defaultValue){
        super(editor);
        this.attributeName = attributeName;
        this._defaultContentTableValue = defaultValue;
        switch(attributeName){
            case "tableCellType":
                this._defaultLayoutTableValue = "data";
                break;
            case "tableCellBorderStyle":
                this._defaultLayoutTableValue = "none";
                break;
            case "tableCellHorizontalAlignment":
                this._defaultLayoutTableValue = "left";
                break;
            case "tableCellVerticalAlignment":
                this._defaultLayoutTableValue = "middle";
                break;
            default:
                this._defaultLayoutTableValue = void 0;
        }
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const selectedTableCells = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(selection);
        const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
        this._defaultValue = !table || table.getAttribute("tableType") !== "layout" ? this._defaultContentTableValue : this._defaultLayoutTableValue;
        this.isEnabled = !!selectedTableCells.length;
        this.value = this._getSingleValue(selectedTableCells);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.value If set, the command will set the attribute on selected table cells.
	* If it is not set, the command will remove the attribute from the selected table cells.
	* @param options.batch Pass the model batch instance to the command to aggregate changes,
	* for example to allow a single undo step for multiple executions.
	*/ execute(options = {}) {
        const { value: value, batch: batch } = options;
        const model = this.editor.model;
        const tableCells = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(model.document.selection);
        const valueToSet = this._getValueToSet(value);
        model.enqueueChange(batch, (writer)=>{
            if (valueToSet) tableCells.forEach((tableCell)=>writer.setAttribute(this.attributeName, valueToSet, tableCell));
            else tableCells.forEach((tableCell)=>writer.removeAttribute(this.attributeName, tableCell));
            this.fire("afterExecute", {
                writer: writer,
                tableCells: tableCells,
                valueToSet: valueToSet
            });
        });
    }
    /**
	* Returns the attribute value for a table cell.
	*/ _getAttribute(tableCell) {
        if (!tableCell) return;
        const value = tableCell.getAttribute(this.attributeName);
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* Returns the proper model value. It can be used to add a default unit to numeric values.
	*/ _getValueToSet(value) {
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* Returns a single value for all selected table cells. If the value is the same for all cells,
	* it will be returned (`undefined` otherwise).
	*/ _getSingleValue(tableCells) {
        const firstCellValue = this._getAttribute(tableCells[0]);
        return tableCells.every((tableCells)=>this._getAttribute(tableCells) === firstCellValue) ? firstCellValue : void 0;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell width command.
*
* The command is registered by the {@link module:table/tablecellwidth/tablecellwidthediting~TableCellWidthEditing} as
* the `'tableCellWidth'` editor command.
*
* To change the width of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellWidth', {
*   value: '50px'
* } );
* ```
*
* **Note**: This command adds a default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableCellWidth', {
*   value: '50'
* } );
* ```
*
* will set the `width` attribute to `'50px'` in the model.
*/ var $f1b97c36043e973c$export$6ca41880660ce9ce = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellWidthCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellWidth", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        value = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellwidth/tablecellwidthediting
*/ /**
* The table cell width editing feature.
*
* Introduces `tableCellWidth` table cell model attribute alongside with its converters
* and a command.
*/ var $f1b97c36043e973c$export$48aba5f5e4c82d6a = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCellWidthEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const defaultTableCellProperties = $f1b97c36043e973c$export$a9dfabf838746e9b(editor.config.get("table.tableCellProperties.defaultProperties"));
        $f1b97c36043e973c$export$4a7d23a24c55b64d(editor.model.schema, editor.conversion, {
            modelAttribute: "tableCellWidth",
            styleName: "width",
            attributeName: "width",
            attributeType: "length",
            defaultValue: defaultTableCellProperties.width
        });
        editor.commands.add("tableCellWidth", new $f1b97c36043e973c$export$6ca41880660ce9ce(editor, defaultTableCellProperties.width));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell padding command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellPadding'` editor command.
*
* To change the padding of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellPadding', {
*   value: '5px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableCellPadding', {
*   value: '5'
* } );
* ```
*
* will set the `padding` attribute to `'5px'` in the model.
*/ var $f1b97c36043e973c$export$d29a1ba5e4ddb9bb = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellPaddingCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellPadding", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getAttribute(tableCell) {
        if (!tableCell) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(tableCell.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        const newValue = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (newValue === this._defaultValue) return;
        return newValue;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell height command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellHeight'` editor command.
*
* To change the height of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellHeight', {
*   value: '50px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableCellHeight', {
*   value: '50'
* } );
* ```
*
* will set the `height` attribute to `'50px'` in the model.
*/ var $f1b97c36043e973c$export$121193ec3a95d532 = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellHeightCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellHeight", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        const newValue = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (newValue === this._defaultValue) return;
        return newValue;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell background color command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellBackgroundColor'` editor command.
*
* To change the background color of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellBackgroundColor', {
*   value: '#f00'
* } );
* ```
*/ var $f1b97c36043e973c$export$b66c66d6ce2ef88f = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellBackgroundColorCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellBackgroundColor", defaultValue);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell vertical alignment command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellVerticalAlignment'` editor command.
*
* To change the vertical text alignment of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellVerticalAlignment', {
*   value: 'top'
* } );
* ```
*
* The following values, corresponding to the
* [`vertical-align` CSS attribute](https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align), are allowed:
*
* * `'top'`
* * `'bottom'`
*
* The `'middle'` value is the default one so there is no need to set it.
*/ var $f1b97c36043e973c$export$4a070a93ca7f8ea5 = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellVerticalAlignmentCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value for the "alignment" attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellVerticalAlignment", defaultValue);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell horizontal alignment command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellHorizontalAlignment'` editor command.
*
* To change the horizontal text alignment of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellHorizontalAlignment', {
*  value: 'right'
* } );
* ```
*/ var $f1b97c36043e973c$export$9a628ba1194ec046 = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellHorizontalAlignmentCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value for the "alignment" attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellHorizontalAlignment", defaultValue);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell border style command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellBorderStyle'` editor command.
*
* To change the border style of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellBorderStyle', {
*   value: 'dashed'
* } );
* ```
*/ var $f1b97c36043e973c$export$ab314ec9cae1a284 = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellBorderStyleCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellBorderStyle", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getAttribute(tableCell) {
        if (!tableCell) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(tableCell.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell border color command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellBorderColor'` editor command.
*
* To change the border color of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellBorderColor', {
*   value: '#f00'
* } );
* ```
*/ var $f1b97c36043e973c$export$b0fcb6c4ecb2c16 = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellBorderColorCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellBorderColor", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getAttribute(tableCell) {
        if (!tableCell) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(tableCell.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell border width command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellBorderWidth'` editor command.
*
* To change the border width of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellBorderWidth', {
*   value: '5px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableCellBorderWidth', {
*   value: '5'
* } );
* ```
*
* will set the `borderWidth` attribute to `'5px'` in the model.
*/ var $f1b97c36043e973c$export$f723cf93d4d0169d = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellBorderWidthCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableCellBorderWidth", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getAttribute(tableCell) {
        if (!tableCell) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(tableCell.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        const newValue = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (newValue === this._defaultValue) return;
        return newValue;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell type command.
*
* The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
* the `'tableCellType'` editor command.
*
* To change the type of selected cells, execute the command:
*
* ```ts
* editor.execute( 'tableCellType', {
*   value: 'header'
* } );
* ```
*
* The `value` can be either `'header'` or `'data'`.
* It'll return `undefined` if multiple types are selected.
*/ var $f1b97c36043e973c$export$b4a84c419c0d707f = class extends $f1b97c36043e973c$export$2178ae9d5401b613 {
    /**
	* Creates a new `TableCellTypeCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	*/ constructor(editor){
        super(editor, "tableCellType", "data");
        this.on("afterExecute", (_, data)=>{
            const { writer: writer, tableCells: tableCells } = data;
            $f1b97c36043e973c$var$updateTablesHeadingAttributes(this.editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7), writer, $f1b97c36043e973c$var$groupCellsByTable(tableCells).keys());
        });
    }
    /**
	* @inheritDoc
	*/ refresh() {
        super.refresh();
        const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(this.editor.model.document.selection);
        if (this.isEnabled && table && table.getAttribute("tableType") === "layout") this.isEnabled = false;
    }
    /**
	* Returns the attribute value for a table cell.
	*/ _getAttribute(tableCell) {
        return tableCell?.getAttribute(this.attributeName) || "data";
    }
};
/**
* Updates the `headingRows` and `headingColumns` attributes of the given tables
* based on the `tableCellType` of their cells.
*/ function $f1b97c36043e973c$var$updateTablesHeadingAttributes(tableUtils, writer, tables) {
    let changed = false;
    for (const table of tables){
        let headingRows = table.getAttribute("headingRows") || 0;
        let headingColumns = table.getAttribute("headingColumns") || 0;
        const footerRows = table.getAttribute("footerRows") || 0;
        const footerIndex = tableUtils.getRows(table) - footerRows;
        const processColumnsFirst = headingColumns > headingRows;
        if (processColumnsFirst) {
            const newHeadingColumns = $f1b97c36043e973c$var$getAdjustedHeadingSectionSize(tableUtils, table, "column", headingColumns, headingRows);
            if (newHeadingColumns !== headingColumns) {
                tableUtils.setHeadingColumnsCount(writer, table, newHeadingColumns, {
                    updateCellType: false
                });
                headingColumns = newHeadingColumns;
                changed = true;
            }
        }
        let newHeadingRows = $f1b97c36043e973c$var$getAdjustedHeadingSectionSize(tableUtils, table, "row", headingRows, headingColumns);
        if (footerRows > 0) newHeadingRows = Math.min(newHeadingRows, footerIndex);
        if (newHeadingRows !== headingRows) {
            tableUtils.setHeadingRowsCount(writer, table, newHeadingRows, {
                updateCellType: false
            });
            headingRows = newHeadingRows;
            changed = true;
        }
        if (!processColumnsFirst) {
            const newHeadingColumns = $f1b97c36043e973c$var$getAdjustedHeadingSectionSize(tableUtils, table, "column", headingColumns, headingRows);
            if (newHeadingColumns !== headingColumns) {
                tableUtils.setHeadingColumnsCount(writer, table, newHeadingColumns, {
                    updateCellType: false
                });
                changed = true;
            }
        }
    }
    return changed;
}
/**
* Calculates the adjusted size of a heading section (rows or columns).
*
* The algorithm iterates through rows (or columns) to determine if they should be part of the heading section.
* A row/column is included if:
* 1. All its cells are of type 'header'.
* 2. AND it contains at least one header cell that is NOT already covered by the perpendicular heading section.
*
* This check prevents the algorithm from aggressively expanding the heading section when cells are already
* headers due to the other dimension.
*
* Consider a 2x2 table where all cells are headers:
*
* ```
*    C0  C1
*   +---+---+
* R0| H | H |
*   +---+---+
* R1| H | H |
*   +---+---+
* ```
*
* If `headingColumns=2`, both C0 and C1 are heading columns.
* If we want `headingRows=1` (only R0), the algorithm must NOT include R1, even though R1 consists of header cells.
* R1's cells are headers because of C0 and C1.
*
* Without this check, the algorithm would see that R1 is all headers and force `headingRows` to 2.
* This would prevent the user from reducing `headingRows` from 2 to 1 without converting R1 cells to 'data'
* (which would incorrectly break C0 and C1).
*/ function $f1b97c36043e973c$var$getAdjustedHeadingSectionSize(tableUtils, table, mode, currentSize, perpendicularHeadingSize) {
    const totalRowsOrColumns = mode === "row" ? tableUtils.getRows(table) : tableUtils.getColumns(table);
    let size = currentSize;
    for(let currentIndex = 0; currentIndex < totalRowsOrColumns; currentIndex++){
        const walker = new $f1b97c36043e973c$export$6c270156410e802f(table, {
            [mode]: currentIndex
        });
        let allCellsAreHeaders = true;
        let hasHeaderOutsidePerpendicularSection = false;
        for (const { cell: cell, row: row, column: column } of walker){
            if (!$f1b97c36043e973c$export$2d92a71c9e04bd6b(cell.getAttribute("tableCellType"))) {
                allCellsAreHeaders = false;
                break;
            }
            if ((mode === "row" ? column : row) >= perpendicularHeadingSize) hasHeaderOutsidePerpendicularSection = true;
        }
        if (!allCellsAreHeaders) return Math.min(size, currentIndex);
        if (hasHeaderOutsidePerpendicularSection) size = Math.max(size, currentIndex + 1);
    }
    return Math.min(size, totalRowsOrColumns);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellproperties/tablecellpropertiesediting
*/ const $f1b97c36043e973c$var$VALIGN_VALUES_REG_EXP = /^(top|middle|bottom)$/;
const $f1b97c36043e973c$var$ALIGN_VALUES_REG_EXP = /^(left|center|right|justify)$/;
/**
* The table cell properties editing feature.
*
* Introduces table cell model attributes and their conversion:
*
* - border: `tableCellBorderStyle`, `tableCellBorderColor` and `tableCellBorderWidth`
* - background color: `tableCellBackgroundColor`
* - cell padding: `tableCellPadding`
* - horizontal and vertical alignment: `tableCellHorizontalAlignment`, `tableCellVerticalAlignment`
* - cell width and height: `tableCellWidth`, `tableCellHeight`
*
* It also registers commands used to manipulate the above attributes:
*
* - border: the `'tableCellBorderStyle'`, `'tableCellBorderColor'` and `'tableCellBorderWidth'` commands
* - background color: the `'tableCellBackgroundColor'` command
* - cell padding: the `'tableCellPadding'` command
* - horizontal and vertical alignment: the `'tableCellHorizontalAlignment'` and `'tableCellVerticalAlignment'` commands
* - width and height: the `'tableCellWidth'` and `'tableCellHeight'` commands
*/ var $f1b97c36043e973c$export$cdc6e01bfcee8e6e = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCellPropertiesEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "TCP";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23,
            $f1b97c36043e973c$export$48aba5f5e4c82d6a
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        editor.config.define("table.tableCellProperties.defaultProperties", {});
        const defaultTableCellProperties = $f1b97c36043e973c$export$a9dfabf838746e9b(editor.config.get("table.tableCellProperties.defaultProperties"), {
            includeVerticalAlignmentProperty: true,
            includeHorizontalAlignmentProperty: true,
            includePaddingProperty: true,
            isRightToLeftContent: editor.locale.contentLanguageDirection === "rtl"
        });
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$46159d29aabaeb2c));
        $f1b97c36043e973c$var$enableBorderProperties$1(editor, {
            color: defaultTableCellProperties.borderColor,
            style: defaultTableCellProperties.borderStyle,
            width: defaultTableCellProperties.borderWidth
        });
        editor.commands.add("tableCellBorderStyle", new $f1b97c36043e973c$export$ab314ec9cae1a284(editor, defaultTableCellProperties.borderStyle));
        editor.commands.add("tableCellBorderColor", new $f1b97c36043e973c$export$b0fcb6c4ecb2c16(editor, defaultTableCellProperties.borderColor));
        editor.commands.add("tableCellBorderWidth", new $f1b97c36043e973c$export$f723cf93d4d0169d(editor, defaultTableCellProperties.borderWidth));
        $f1b97c36043e973c$export$4a7d23a24c55b64d(schema, conversion, {
            modelAttribute: "tableCellHeight",
            styleName: "height",
            attributeName: "height",
            attributeType: "length",
            defaultValue: defaultTableCellProperties.height
        });
        editor.commands.add("tableCellHeight", new $f1b97c36043e973c$export$121193ec3a95d532(editor, defaultTableCellProperties.height));
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$9ba7212def70900f));
        $f1b97c36043e973c$export$4a7d23a24c55b64d(schema, conversion, {
            modelAttribute: "tableCellPadding",
            styleName: "padding",
            reduceBoxSides: true,
            defaultValue: defaultTableCellProperties.padding
        });
        $f1b97c36043e973c$var$enableTableCellPaddingAttribute(editor, defaultTableCellProperties.padding);
        editor.commands.add("tableCellPadding", new $f1b97c36043e973c$export$d29a1ba5e4ddb9bb(editor, defaultTableCellProperties.padding));
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$422a7ff0e667c6c8));
        $f1b97c36043e973c$export$4a7d23a24c55b64d(schema, conversion, {
            modelAttribute: "tableCellBackgroundColor",
            styleName: "background-color",
            attributeName: "bgcolor",
            attributeType: "color",
            defaultValue: defaultTableCellProperties.backgroundColor
        });
        editor.commands.add("tableCellBackgroundColor", new $f1b97c36043e973c$export$b66c66d6ce2ef88f(editor, defaultTableCellProperties.backgroundColor));
        $f1b97c36043e973c$var$enableHorizontalAlignmentProperty(schema, conversion, defaultTableCellProperties.horizontalAlignment);
        $f1b97c36043e973c$var$enableLegacyHorizontalAlignmentAttribute(conversion);
        editor.commands.add("tableCellHorizontalAlignment", new $f1b97c36043e973c$export$9a628ba1194ec046(editor, defaultTableCellProperties.horizontalAlignment));
        $f1b97c36043e973c$var$enableVerticalAlignmentProperty(schema, conversion, defaultTableCellProperties.verticalAlignment);
        editor.commands.add("tableCellVerticalAlignment", new $f1b97c36043e973c$export$4a070a93ca7f8ea5(editor, defaultTableCellProperties.verticalAlignment));
        $f1b97c36043e973c$var$enableCellTypeProperty(editor);
        editor.commands.add("tableCellType", new $f1b97c36043e973c$export$b4a84c419c0d707f(editor));
    }
};
/**
* Enables the `'tableCellBorderStyle'`, `'tableCellBorderColor'` and `'tableCellBorderWidth'` attributes for table cells.
*
* @param editor The editor instance.
* @param defaultBorder The default border values.
* @param defaultBorder.color The default `tableCellBorderColor` value.
* @param defaultBorder.style The default `tableCellBorderStyle` value.
* @param defaultBorder.width The default `tableCellBorderWidth` value.
*/ function $f1b97c36043e973c$var$enableBorderProperties$1(editor, defaultBorder) {
    const { conversion: conversion } = editor;
    const { schema: schema } = editor.model;
    const modelAttributes = {
        width: "tableCellBorderWidth",
        color: "tableCellBorderColor",
        style: "tableCellBorderStyle"
    };
    schema.extend("tableCell", {
        allowAttributes: Object.values(modelAttributes)
    });
    for (const modelAttribute of Object.values(modelAttributes))schema.setAttributeProperties(modelAttribute, {
        isFormatting: true
    });
    $f1b97c36043e973c$export$fd4c67f8267d3604(editor, "td", modelAttributes, defaultBorder);
    $f1b97c36043e973c$export$fd4c67f8267d3604(editor, "th", modelAttributes, defaultBorder);
    $f1b97c36043e973c$export$2140815f28869319(conversion, {
        modelElement: "tableCell",
        modelAttribute: modelAttributes.style,
        styleName: "border-style"
    });
    $f1b97c36043e973c$export$2140815f28869319(conversion, {
        modelElement: "tableCell",
        modelAttribute: modelAttributes.color,
        styleName: "border-color"
    });
    $f1b97c36043e973c$export$2140815f28869319(conversion, {
        modelElement: "tableCell",
        modelAttribute: modelAttributes.width,
        styleName: "border-width"
    });
}
/**
* Enables the `'tableCellHorizontalAlignment'` attribute for table cells.
*
* @param defaultValue The default horizontal alignment value.
*/ function $f1b97c36043e973c$var$enableHorizontalAlignmentProperty(schema, conversion, defaultValue) {
    schema.extend("tableCell", {
        allowAttributes: [
            "tableCellHorizontalAlignment"
        ]
    });
    schema.setAttributeProperties("tableCellHorizontalAlignment", {
        isFormatting: true
    });
    conversion.for("downcast").attributeToAttribute({
        model: {
            name: "tableCell",
            key: "tableCellHorizontalAlignment"
        },
        view: (alignment)=>({
                key: "style",
                value: {
                    "text-align": alignment
                }
            })
    });
    conversion.for("upcast").attributeToAttribute({
        view: {
            name: /^(td|th)$/,
            styles: {
                "text-align": $f1b97c36043e973c$var$ALIGN_VALUES_REG_EXP
            }
        },
        model: {
            key: "tableCellHorizontalAlignment",
            value: (viewElement, conversionApi, data)=>{
                const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "left", data);
                const align = viewElement.getStyle("text-align");
                if (align !== localDefaultValue) return align;
                conversionApi.consumable.consume(viewElement, {
                    styles: "text-align"
                });
            }
        }
    });
}
/**
* Upcasts legacy `td[align]` property to proper block alignment attributes in child elements.
* If there is no block alignment property supported on the element, then the `alignment` fallback will be used.
*
* See: https://github.com/ckeditor/ckeditor5/issues/20042
*/ function $f1b97c36043e973c$var$enableLegacyHorizontalAlignmentAttribute(conversion) {
    conversion.for("upcast").add((dispatcher)=>{
        const matcher = new (0, $b9b9f2bdf9c6137f$export$20214574ec94167d)({
            name: /^(td|th)$/,
            attributes: {
                align: $f1b97c36043e973c$var$ALIGN_VALUES_REG_EXP
            }
        });
        dispatcher.on("element", (evt, data, conversionApi)=>{
            if (!matcher.match(data.viewItem)) return;
            const modelElement = data.modelRange?.start.nodeAfter;
            /* istanbul ignore if -- @preserve */ if (!modelElement?.is("element")) return;
            const alignValue = data.viewItem.getAttribute("align");
            if (!conversionApi.consumable.consume(data.viewItem, {
                attributes: [
                    "align"
                ]
            })) return;
            for (const child of modelElement.getChildren())/* v8 ignore else -- A table cell only contains block elements, so its children are always elements. */ if (child.is("element")) applyAlignmentToChild(child, alignValue, conversionApi);
        }, {
            priority: "low"
        });
    });
    function applyAlignmentToChild(child, alignValue, { schema: schema, writer: writer }) {
        const definition = schema.getDefinition(child);
        /* v8 ignore else -- A converted child element is always registered in the schema, so it always has a definition. */ if (definition) for (const attrName of definition.allowAttributes){
            if (child.hasAttribute(attrName)) continue;
            const { blockAlignment: blockAlignment } = schema.getAttributeProperties(attrName);
            if (!blockAlignment) continue;
            const mappedValue = (typeof blockAlignment === "function" ? blockAlignment(child) : blockAlignment)[alignValue];
            if (mappedValue && !mappedValue.isDefault) writer.setAttribute(attrName, mappedValue.value, child);
            return;
        }
    }
}
/**
* Enables the `'verticalAlignment'` attribute for table cells.
*
* @param defaultValue The default vertical alignment value.
*/ function $f1b97c36043e973c$var$enableVerticalAlignmentProperty(schema, conversion, defaultValue) {
    schema.extend("tableCell", {
        allowAttributes: [
            "tableCellVerticalAlignment"
        ]
    });
    schema.setAttributeProperties("tableCellVerticalAlignment", {
        isFormatting: true
    });
    conversion.for("downcast").attributeToAttribute({
        model: {
            name: "tableCell",
            key: "tableCellVerticalAlignment"
        },
        view: (alignment)=>({
                key: "style",
                value: {
                    "vertical-align": alignment
                }
            })
    });
    conversion.for("upcast").attributeToAttribute({
        view: {
            name: /^(td|th)$/,
            styles: {
                "vertical-align": $f1b97c36043e973c$var$VALIGN_VALUES_REG_EXP
            }
        },
        model: {
            key: "tableCellVerticalAlignment",
            value: (viewElement, conversionApi, data)=>{
                const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "middle", data);
                const align = viewElement.getStyle("vertical-align");
                if (align !== localDefaultValue) return align;
                conversionApi.consumable.consume(viewElement, {
                    styles: "vertical-align"
                });
            }
        }
    }).attributeToAttribute({
        view: {
            name: /^(td|th)$/,
            attributes: {
                valign: $f1b97c36043e973c$var$VALIGN_VALUES_REG_EXP
            }
        },
        model: {
            key: "tableCellVerticalAlignment",
            value: (viewElement, conversionApi, data)=>{
                const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "middle", data);
                const valign = viewElement.getAttribute("valign");
                if (valign !== localDefaultValue) return valign;
                conversionApi.consumable.consume(viewElement, {
                    attributes: "valign"
                });
            }
        }
    });
}
/**
* Enables the `tableCellType` attribute for table cells.
*/ function $f1b97c36043e973c$var$enableCellTypeProperty(editor) {
    const { model: model, conversion: conversion, editing: editing, config: config } = editor;
    const { schema: schema } = model;
    config.define("table.tableCellProperties.scopedHeaders", true);
    const scopedHeaders = !!config.get("table.tableCellProperties.scopedHeaders");
    const tableUtils = editor.plugins.get($f1b97c36043e973c$export$b8747c538ef18c7);
    schema.extend("tableCell", {
        allowAttributes: [
            "tableCellType"
        ]
    });
    schema.setAttributeProperties("tableCellType", {
        isFormatting: true
    });
    schema.addAttributeCheck((context)=>{
        if (Array.from(context).reverse().find((item)=>item.name === "table")?.getAttribute("tableType") === "layout") return false;
    }, "tableCellType");
    conversion.for("upcast").add((dispatcher)=>{
        dispatcher.on("element:th", (evt, data, conversionApi)=>{
            const { writer: writer } = conversionApi;
            const { modelRange: modelRange } = data;
            const modelElement = modelRange?.start.nodeAfter;
            if (modelElement?.is("element", "tableCell") && !modelElement.hasAttribute("tableCellType")) writer.setAttribute("tableCellType", "header", modelElement);
        });
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            const { writer: writer } = conversionApi;
            const { modelRange: modelRange } = data;
            const modelElement = modelRange?.start.nodeAfter;
            if (modelElement?.is("element", "table") && modelElement.getAttribute("tableType") === "layout") for (const { cell: cell } of new $f1b97c36043e973c$export$6c270156410e802f(modelElement)){
                const tableCellType = cell.getAttribute("tableCellType");
                if ($f1b97c36043e973c$export$2d92a71c9e04bd6b(tableCellType)) {
                    writer.setAttribute("tableType", "content", modelElement);
                    break;
                }
            }
        }, {
            priority: (0, $c7bc2cb7e2db0227$export$7b4ff1aef3781895).low - 1
        });
    });
    if (scopedHeaders) {
        conversion.for("downcast").attributeToAttribute({
            model: {
                name: "tableCell",
                key: "tableCellType"
            },
            view: (modelAttributeValue)=>{
                switch(modelAttributeValue){
                    case "header-row":
                        return {
                            key: "scope",
                            value: "row"
                        };
                    case "header-column":
                        return {
                            key: "scope",
                            value: "col"
                        };
                }
            }
        });
        conversion.for("upcast").add((dispatcher)=>{
            dispatcher.on("element:th", (_, data, conversionApi)=>{
                const { writer: writer, consumable: consumable } = conversionApi;
                const { viewItem: viewItem, modelRange: modelRange } = data;
                const modelElement = modelRange?.start.nodeAfter;
                if (!modelElement) return;
                if (modelElement.getAttribute("tableCellType") === "header" && consumable.consume(viewItem, {
                    attributes: [
                        "scope"
                    ]
                })) switch(viewItem.getAttribute("scope")){
                    case "row":
                        writer.setAttribute("tableCellType", "header-row", modelElement);
                        break;
                    case "col":
                        writer.setAttribute("tableCellType", "header-column", modelElement);
                }
            });
        });
    }
    model.document.registerPostFixer((writer)=>{
        const changes = model.document.differ.getChanges();
        const tablesToCheck = /* @__PURE__ */ new Set();
        for (const change of changes){
            if (change.type === "attribute" && (change.attributeKey === "headingRows" || change.attributeKey === "headingColumns")) {
                const table = change.range.start.nodeAfter;
                if (table?.is("element", "table") && table.root.rootName !== "$graveyard") tablesToCheck.add(table);
            }
            if (change.type === "attribute" && change.attributeKey === "tableCellType") {
                const cell = change.range.start.nodeAfter;
                if (cell?.is("element", "tableCell") && cell.root.rootName !== "$graveyard") {
                    const table = cell.findAncestor("table");
                    /* v8 ignore else -- A table cell always lives inside a table, so it always has a table ancestor here. */ if (table) tablesToCheck.add(table);
                }
            }
            if (change.type === "insert" && change.position.nodeAfter) {
                for (const { item: item } of model.createRangeOn(change.position.nodeAfter))if (item.is("element", "tableCell") && item.getAttribute("tableCellType") && item.root.rootName !== "$graveyard") {
                    const table = item.findAncestor("table");
                    /* v8 ignore else -- An inserted table cell always lives inside a table, so it always has a table ancestor here. */ if (table) tablesToCheck.add(table);
                }
            }
        }
        return $f1b97c36043e973c$var$updateTablesHeadingAttributes(tableUtils, writer, tablesToCheck);
    });
    model.document.on("change:data", ()=>{
        const { differ: differ } = model.document;
        const cellsToReconvert = /* @__PURE__ */ new Set();
        for (const change of differ.getChanges())if (change.type === "attribute" && change.attributeKey === "tableCellType") {
            const tableCell = change.range.start.nodeAfter;
            if (tableCell.is("element", "tableCell")) cellsToReconvert.add(tableCell);
        }
        for (const tableCell of cellsToReconvert){
            const viewElement = editing.mapper.toViewElement(tableCell);
            const cellType = tableCell.getAttribute("tableCellType");
            const expectedElementName = $f1b97c36043e973c$export$2d92a71c9e04bd6b(cellType) ? "th" : "td";
            if (viewElement?.name !== expectedElementName) editing.reconvertItem(tableCell);
        }
    });
}
/**
* Enables the upcasting of the `cellpadding` attribute from table to table cells padding.
*
* @param editor The editor instance.
* @param defaultPadding The default padding value.
*/ function $f1b97c36043e973c$var$enableTableCellPaddingAttribute(editor, defaultPadding) {
    $f1b97c36043e973c$var$upcastTableCellPaddingAttribute(editor, "td", defaultPadding);
    $f1b97c36043e973c$var$upcastTableCellPaddingAttribute(editor, "th", defaultPadding);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecellproperties
*/ /**
* The table cell properties feature. Enables support for setting properties of table cells (size, border, background, etc.).
*
* Read more in the {@glink features/tables/tables-styling Table and cell styling tools} section.
* See also the {@link module:table/tableproperties~TableProperties} plugin.
*
* This is a "glue" plugin that loads the
* {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing table cell properties editing feature} and
* the {@link module:table/tablecellproperties/tablecellpropertiesui~TableCellPropertiesUI table cell properties UI feature}.
*/ var $f1b97c36043e973c$export$2358d0339cefe84d = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCellProperties";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$cdc6e01bfcee8e6e,
            $f1b97c36043e973c$export$feb9c41b6e3eb6e3
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablelayout/tablelayoutui
*/ /**
* The table layout UI plugin. It introduces:
*
* * The `'insertTableLayout'` dropdown,
* * The `'menuBar:insertTableLayout'` menu bar menu.
*/ var $f1b97c36043e973c$export$cc70d806b34a5604 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableLayoutUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const t = this.editor.t;
        editor.ui.componentFactory.add("insertTableLayout", (locale)=>{
            const command = editor.commands.get("insertTableLayout");
            const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale);
            dropdownView.bind("isEnabled").to(command);
            dropdownView.buttonView.set({
                icon: (0, $e8dc502aba5ac3f5$export$40566f18736a7d62),
                label: t("Insert table layout"),
                tooltip: true
            });
            let insertTableLayoutView;
            dropdownView.on("change:isOpen", ()=>{
                if (insertTableLayoutView) return;
                insertTableLayoutView = new $f1b97c36043e973c$export$55b6381dac33ed7e(locale);
                dropdownView.panelView.children.add(insertTableLayoutView);
                insertTableLayoutView.delegate("execute").to(dropdownView);
                dropdownView.on("execute", ()=>{
                    editor.execute("insertTableLayout", {
                        rows: insertTableLayoutView.rows,
                        columns: insertTableLayoutView.columns
                    });
                    editor.editing.view.focus();
                });
            });
            return dropdownView;
        });
        editor.ui.componentFactory.add("menuBar:insertTableLayout", (locale)=>{
            const command = editor.commands.get("insertTableLayout");
            const menuView = new (0, $29fd27cb9bdab9d2$export$4ba688433f6c2b4f)(locale);
            const insertTableLayoutView = new $f1b97c36043e973c$export$55b6381dac33ed7e(locale);
            insertTableLayoutView.delegate("execute").to(menuView);
            menuView.on("change:isOpen", (event, name, isOpen)=>{
                if (!isOpen) insertTableLayoutView.reset();
            });
            insertTableLayoutView.on("execute", ()=>{
                editor.execute("insertTableLayout", {
                    rows: insertTableLayoutView.rows,
                    columns: insertTableLayoutView.columns
                });
                editor.editing.view.focus();
            });
            menuView.buttonView.set({
                label: t("Table layout"),
                icon: (0, $e8dc502aba5ac3f5$export$40566f18736a7d62)
            });
            menuView.panelView.children.add(insertTableLayoutView);
            menuView.bind("isEnabled").to(command);
            return menuView;
        });
        editor.ui.componentFactory.add("tableType", ()=>{
            const editor = this.editor;
            const t = editor.t;
            const button = new (0, $29fd27cb9bdab9d2$export$78bc6c5c028686b7)(editor.locale);
            button.set({
                label: t("Table type"),
                icon: (0, $e8dc502aba5ac3f5$export$f0a4ba08c77f7861),
                tooltip: true
            });
            return $f1b97c36043e973c$var$createTableTypeDropdown(editor, button);
        });
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const { editor: editor } = this;
        const { ui: ui, plugins: plugins } = editor;
        if (!editor.plugins.has("TablePropertiesUI")) return;
        const tablePropertiesUI = plugins.get("TablePropertiesUI");
        ui.componentFactory.add("tableProperties", (locale)=>{
            const baseButton = tablePropertiesUI._createTablePropertiesButton();
            const splitButtonView = new (0, $29fd27cb9bdab9d2$export$5981ef7d837e6d9)(locale, baseButton);
            return $f1b97c36043e973c$var$createTableTypeDropdown(editor, splitButtonView);
        });
    }
};
/**
* Creates a dropdown for the table type selection.
*
* @param editor The editor instance.
* @param dropdownButton The button view that will be used as the dropdown trigger.
* @returns A dropdown view containing table type options.
*/ function $f1b97c36043e973c$var$createTableTypeDropdown(editor, dropdownButton) {
    const t = editor.t;
    const locale = editor.locale;
    const tableTypeCommand = editor.commands.get("tableType");
    const dropdownView = (0, $29fd27cb9bdab9d2$export$3384a5f07adc0073)(locale, dropdownButton);
    const itemsDefinitions = $f1b97c36043e973c$var$createTableLayoutTypeDropdownItems(editor);
    (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(dropdownView, itemsDefinitions, {
        ariaLabel: t("Table type options"),
        role: "menu"
    });
    dropdownButton.tooltip = t("Choose table type");
    dropdownView.on("execute", (evt)=>{
        const tableType = evt.source.tableType;
        if (tableType) tableTypeCommand.execute(tableType);
    });
    return dropdownView;
}
/**
* Creates dropdown items for table type selection.
*
* @param editor The editor instance.
* @returns A collection of dropdown items for the table type dropdown.
*/ function $f1b97c36043e973c$var$createTableLayoutTypeDropdownItems(editor) {
    const t = editor.t;
    const tableTypeCommand = editor.commands.get("tableType");
    const itemDefinitions = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    itemDefinitions.add($f1b97c36043e973c$var$createTableTypeDropdownItem(tableTypeCommand, "layout", t("Layout table")));
    itemDefinitions.add($f1b97c36043e973c$var$createTableTypeDropdownItem(tableTypeCommand, "content", t("Content table")));
    return itemDefinitions;
}
/**
* Creates a dropdown item for a specific table type.
*
* @param tableTypeCommand The table type command.
* @param type The table type value ('layout' or 'content').
* @param label The localized label for the dropdown item.
* @returns The dropdown item definition.
*/ function $f1b97c36043e973c$var$createTableTypeDropdownItem(tableTypeCommand, type, label) {
    const model = new (0, $29fd27cb9bdab9d2$export$7e4e5b0077d30e7b)({
        label: label,
        role: "menuitemradio",
        withText: true,
        tableType: type
    });
    model.bind("isEnabled").to(tableTypeCommand, "isEnabled");
    model.bind("isOn").to(tableTypeCommand, "value", (value)=>value === type);
    return {
        type: "button",
        model: model
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/commands/inserttablelayoutcommand
*/ /**
* The insert table layout command.
*
* The command is registered by {@link module:table/tablelayout/tablelayoutediting~TableLayoutEditing}
* as the `'insertTableLayout'` editor command.
*
* To insert a layout table at the current selection, execute the command and specify the dimensions:
*
* ```ts
* editor.execute( 'insertTableLayout', { rows: 20, columns: 5 } );
* ```
*/ var $f1b97c36043e973c$export$db98139396fbbc89 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const schema = model.schema;
        this.isEnabled = $f1b97c36043e973c$var$isAllowedInParent(selection, schema);
    }
    /**
	* Executes the command.
	*
	* Inserts a layout table with the given number of rows and columns into the editor.
	*
	* @param options.rows The number of rows to create in the inserted table. Default value is 2.
	* @param options.columns The number of columns to create in the inserted table. Default value is 2.
	* @param options.inheritTextFormattingAttributes Whether every empty cell should inherit the `copyOnEnter` text
	* formatting attributes (e.g. bold, font color) that were uniformly active in the content right before
	* the table, so that whichever cell the user starts typing in first continues that formatting. Defaults
	* to `true`.
	* @fires execute
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const tableUtils = editor.plugins.get("TableUtils");
        model.change((writer)=>{
            const selectionAttributesToCopy = Array.from((0, $c871651c8276dc61$export$b1d719019e4bdf35)(model.schema, selection.getAttributes()));
            const normalizedOptions = {
                rows: options.rows || 2,
                columns: options.columns || 2
            };
            const table = tableUtils.createTable(writer, normalizedOptions);
            writer.setAttribute("tableType", "layout", table);
            model.insertObject(table, null, null, {
                findOptimalPosition: "auto"
            });
            const singleColumnWidth = `${100 / normalizedOptions.columns}%`;
            const columnWidths = Array(normalizedOptions.columns).fill(singleColumnWidth);
            editor.commands.get("resizeColumnWidths").execute({
                tableWidth: "100%",
                columnWidths: columnWidths,
                table: table
            });
            writer.setSelection(writer.createPositionAt(table.getNodeByPath([
                0,
                0,
                0
            ]), 0));
            if (options.inheritTextFormattingAttributes !== false && selectionAttributesToCopy.length) for (const cellBlock of $f1b97c36043e973c$var$getEmptyTableCellBlocks(table))for (const [key, value] of selectionAttributesToCopy)writer.setAttribute((0, $b9b9f2bdf9c6137f$export$7ad0b188284367aa)._getStoreAttributeKey(key), value, cellBlock);
        });
    }
};
/**
* Checks if the table is allowed in the parent.
*/ function $f1b97c36043e973c$var$isAllowedInParent(selection, schema) {
    const positionParent = selection.getFirstPosition().parent;
    const validParent = positionParent === positionParent.root ? positionParent : positionParent.parent;
    return schema.checkChild(validParent, "table");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Command used by the {@link module:table/tablecolumnresize~TableColumnResize Table column resize feature} that
* updates the width of the whole table as well as its individual columns.
*/ var $f1b97c36043e973c$export$dca8435fe31c61fe = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        this.isEnabled = true;
    }
    /**
	* Updated the `tableWidth` attribute of the table and the `columnWidth` attribute of the columns of that table.
	*/ execute(options = {}) {
        const { model: model, plugins: plugins } = this.editor;
        let { table: table = model.document.selection.getSelectedElement(), columnWidths: columnWidths, tableWidth: tableWidth } = options;
        if (columnWidths) columnWidths = Array.isArray(columnWidths) ? columnWidths : columnWidths.split(",");
        model.change((writer)=>{
            if (tableWidth) writer.setAttribute("tableWidth", tableWidth, table);
            else writer.removeAttribute("tableWidth", table);
            const tableColumnGroup = plugins.get("TableColumnResizeEditing").getColumnGroupElement(table);
            if (!columnWidths && !tableColumnGroup) return;
            if (!columnWidths) return writer.remove(tableColumnGroup);
            const widths = $f1b97c36043e973c$export$3f6a26999910654(columnWidths);
            $f1b97c36043e973c$var$removeCellWidthsFromTable(writer, table);
            if (!tableColumnGroup) {
                const colGroupElement = writer.createElement("tableColumnGroup");
                widths.forEach((columnWidth)=>writer.appendElement("tableColumn", {
                        columnWidth: columnWidth
                    }, colGroupElement));
                writer.append(colGroupElement, table);
            } else Array.from(tableColumnGroup.getChildren()).forEach((column, index)=>writer.setAttribute("columnWidth", widths[index], column));
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecolumnresize/commands/tablecolumnwidthcommand
*/ /**
* The table column width command.
*
* The command is registered by the {@link module:table/tablecolumnresize/tablecolumnresizeediting~TableColumnResizeEditing}
* as the `'tableColumnWidth'` editor command.
*
* It sets the width of every column covered by the selected cells (keeping the whole table's width mode consistent),
* so the change actually takes effect in a resized table - where a per-cell width would be shadowed by the column
* group. The command is enabled whenever the selection maps onto the columns of a resized, regular table.
*
* ```ts
* editor.execute( 'tableColumnWidth', {
*   value: '150px'
* } );
* ```
*
* **Note**: This command adds a default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableColumnWidth', {
*   value: '150'
* } );
* ```
*
* will set the column width to `'150px'`.
*/ var $f1b97c36043e973c$export$fd0937e3f89d934f = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const tableUtils = editor.plugins.get("TableUtils");
        const tableColumnResize = editor.plugins.get("TableColumnResizeEditing");
        const tableCells = tableUtils.getSelectionAffectedTableCells(editor.model.document.selection);
        const columns = tableColumnResize.getColumnIndexesForCells(tableCells);
        if (!columns) {
            this.isEnabled = false;
            this.value = null;
            return;
        }
        this.isEnabled = true;
        this.value = tableColumnResize.getTableColumnElements(columns.table)[columns.columnIndexes[0]].getAttribute("columnWidth");
    }
    /**
	* @inheritDoc
	*/ execute(options = {}) {
        const editor = this.editor;
        const model = editor.model;
        const tableUtils = editor.plugins.get("TableUtils");
        const tableColumnResize = editor.plugins.get("TableColumnResizeEditing");
        const value = $f1b97c36043e973c$export$d3891b194d68f193(options.value, "px");
        const tableCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
        const columns = tableColumnResize.getColumnIndexesForCells(tableCells);
        if (!value || !columns || Number.isNaN(parseFloat(value))) return;
        model.enqueueChange(options.batch, (writer)=>{
            tableColumnResize.applyColumnWidths(writer, columns.table, columns.columnIndexes, value);
            $f1b97c36043e973c$var$removeCellWidthsFromTable(writer, columns.table);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a upcast helper that ensures the number of `<tableColumn>` elements corresponds to the actual number of columns in the table,
* because the input data might have too few or too many <col> elements.
*
* @internal
*/ function $f1b97c36043e973c$export$d5f83028c28c81c8(tableUtilsPlugin) {
    return (dispatcher)=>dispatcher.on("element:colgroup", (evt, data, conversionApi)=>{
            const modelTable = data.modelCursor.findAncestor("table");
            const tableColumnGroup = $f1b97c36043e973c$export$3003b92ca07186d3(modelTable);
            if (!tableColumnGroup) return;
            const columnElements = $f1b97c36043e973c$export$93a5df62948110b3(tableColumnGroup);
            const columnsCount = tableUtilsPlugin.getColumns(modelTable);
            let columnWidths = $f1b97c36043e973c$export$2ceda7f294e7025c(tableColumnGroup, conversionApi.writer);
            columnWidths = Array.from({
                length: columnsCount
            }, (_, index)=>columnWidths[index] || "auto");
            if (columnWidths.length != columnElements.length || columnWidths.includes("auto")) $f1b97c36043e973c$export$96fdad66d97345fc(columnElements, tableColumnGroup, $f1b97c36043e973c$export$3f6a26999910654(columnWidths), conversionApi.writer);
        }, {
            priority: "low"
        });
}
/**
* Returns downcast helper for adding `ck-table-resized` class if there is a `<tableColumnGroup>` element inside the table.
*
* @internal
*/ function $f1b97c36043e973c$export$bb8179edbe51c14d() {
    return (dispatcher)=>dispatcher.on("insert:table", (evt, data, conversionApi)=>{
            const viewWriter = conversionApi.writer;
            const modelTable = data.item;
            const viewElement = conversionApi.mapper.toViewElement(modelTable);
            const viewTable = viewElement.is("element", "table") ? viewElement : Array.from(viewElement.getChildren()).find((viewChild)=>viewChild.is("element", "table"));
            if ($f1b97c36043e973c$export$3003b92ca07186d3(modelTable)) viewWriter.addClass("ck-table-resized", viewTable);
            else viewWriter.removeClass("ck-table-resized", viewTable);
        }, {
            priority: "low"
        });
}
/**
* Returns a upcast helper that removes the `ck-table-resized` class from the table element.
*
* @internal
*/ function $f1b97c36043e973c$var$upcastTableResizedClass() {
    return (dispatcher)=>{
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            conversionApi.consumable.consume(data.viewItem, {
                classes: "ck-table-resized"
            });
        });
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecolumnresize/tablecolumnresizeediting
*/ const $f1b97c36043e973c$var$toPx = /* #__PURE__ */ (0, $c7bc2cb7e2db0227$export$d48be2db27a3a8d3)("px");
/**
* The table column resize editing plugin.
*/ var $f1b97c36043e973c$export$7efa1f1b6529b993 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A temporary storage for the required data needed to correctly calculate the widths of the resized columns. This storage is
	* initialized when column resizing begins, and is purged upon completion.
	*/ _resizingData;
    /**
	* DOM emitter.
	*/ _domEmitter;
    /**
	* A local reference to the {@link module:table/tableutils~TableUtils} plugin.
	*/ _tableUtilsPlugin;
    /**
	* Starting mouse position data used to add a threshold to the resizing process.
	*/ _initialMouseEventData = null;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23,
            $f1b97c36043e973c$export$b8747c538ef18c7
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableColumnResizeEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "TCR";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.set("_isResizingActive", false);
        this.set("_isResizingAllowed", true);
        this._resizingData = null;
        this._domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
        this._tableUtilsPlugin = editor.plugins.get("TableUtils");
        this.on("change:_isResizingAllowed", (evt, name, value)=>{
            const classAction = value ? "removeClass" : "addClass";
            editor.editing.view.change((writer)=>{
                for (const root of editor.editing.view.document.roots)writer[classAction]("ck-column-resize_disabled", editor.editing.view.document.getRoot(root.rootName));
            });
        });
        this.on("change:_isResizingActive", (evt, name, value)=>{
            const classAction = value ? "add" : "remove";
            (0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).document.body.classList[classAction]("ck-table-column-resize__resizing-cursor");
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        this._extendSchema();
        this._registerPostFixer();
        this._registerConverters();
        this._registerResizingListeners();
        this._registerResizerInserter();
        this.decorate("_setResizingTableWidth");
        this.decorate("_getResizingTableWidth");
        const editor = this.editor;
        const columnResizePlugin = editor.plugins.get("TableColumnResize");
        editor.plugins.get("TableEditing").registerAdditionalSlot({
            filter: (element)=>element.is("element", "tableColumnGroup"),
            positionOffset: 0
        });
        const tableWidthsCommand = new $f1b97c36043e973c$export$dca8435fe31c61fe(editor);
        editor.commands.add("resizeTableWidth", tableWidthsCommand);
        editor.commands.add("resizeColumnWidths", tableWidthsCommand);
        editor.commands.add("tableColumnWidth", new $f1b97c36043e973c$export$fd0937e3f89d934f(editor));
        this.bind("_isResizingAllowed").to(editor, "isReadOnly", columnResizePlugin, "isEnabled", tableWidthsCommand, "isEnabled", (isEditorReadOnly, isPluginEnabled, isTableWidthsCommandCommandEnabled)=>!isEditorReadOnly && isPluginEnabled && isTableWidthsCommandCommandEnabled);
    }
    /**
	* @inheritDoc
	*/ afterInit() {
        const editor = this.editor;
        const tableWidthCommand = editor.commands.get("tableWidth");
        if (tableWidthCommand) {
            this.listenTo(tableWidthCommand, "execute", (evt, args)=>{
                const options = args[0] || (args[0] = {});
                if (!options.batch) options.batch = editor.model.createBatch();
            }, {
                priority: "high"
            });
            this.listenTo(tableWidthCommand, "execute", (evt, args)=>{
                const options = args[0];
                const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(editor.model.document.selection);
                editor.model.enqueueChange(options.batch, (writer)=>this._reconcileColumnUnits(writer, table));
            }, {
                priority: "low"
            });
        }
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._domEmitter.stopListening();
        this._isResizingActive = false;
        super.destroy();
    }
    /**
	* The table for which a column resize is currently in progress, or `null` if no resize is active.
	* Only one table can be resized at a time.
	*/ get resizingTable() {
        return this._resizingData ? this._resizingData.elements.modelTable : null;
    }
    /**
	* Returns a 'tableColumnGroup' element from the 'table'.
	*
	* @param element A 'table' or 'tableColumnGroup' element.
	* @returns A 'tableColumnGroup' element.
	*/ getColumnGroupElement(element) {
        return $f1b97c36043e973c$export$3003b92ca07186d3(element);
    }
    /**
	* Returns an array of 'tableColumn' elements.
	*
	* @param element A 'table' or 'tableColumnGroup' element.
	* @returns An array of 'tableColumn' elements.
	*/ getTableColumnElements(element) {
        return $f1b97c36043e973c$export$93a5df62948110b3(element);
    }
    /**
	* Returns an array of table column widths.
	*
	* @param element A 'table' or 'tableColumnGroup' element.
	* @returns An array of table column widths.
	*/ getTableColumnsWidths(element) {
        return $f1b97c36043e973c$export$704df7f93ae962f7(element);
    }
    /**
	* Returns the table and the sorted, unique indexes of the columns covered by the given cells (a `colspan` cell
	* covers several columns). Returns `null` when the selection cannot be mapped onto columns - a non-resized table
	* or an irregular column structure.
	*
	* @param cells An array of 'tableCell' model elements.
	*/ getColumnIndexesForCells(cells) {
        const table = cells.length ? cells[0].findAncestor("table") : null;
        if (!table) return null;
        const columns = $f1b97c36043e973c$export$93a5df62948110b3(table);
        if (!columns.length || columns.length !== this._tableUtilsPlugin.getColumns(table) || columns.some((column)=>column.hasAttribute("colSpan"))) return null;
        const columnIndexes = /* @__PURE__ */ new Set();
        for (const cell of cells){
            const { leftEdge: leftEdge, rightEdge: rightEdge } = $f1b97c36043e973c$export$a9ac57172d51c643(cell, this._tableUtilsPlugin);
            for(let index = leftEdge; index <= rightEdge; index++)columnIndexes.add(index);
        }
        return {
            table: table,
            columnIndexes: Array.from(columnIndexes).sort((indexA, indexB)=>indexA - indexB)
        };
    }
    /**
	* Applies the given width to every column in `columnIndexes`, keeping the whole table's width mode consistent
	* (see {@link module:table/tablecolumnresize/utils~isTableWidthInPixels}).
	*
	* @param writer A model writer instance.
	* @param table A 'table' model element.
	* @param columnIndexes Indexes of the columns the width is applied to.
	* @param value The width to apply. May be expressed in pixels or as a percentage.
	*/ applyColumnWidths(writer, table, columnIndexes, value) {
        if ($f1b97c36043e973c$var$isTableWidthInPixels(table)) $f1b97c36043e973c$var$applyPixelColumnWidths(writer, table, columnIndexes, value);
        else this._applyPercentageColumnWidths(writer, table, columnIndexes, value);
    }
    /**
	* Converts the column widths of a resized table to the unit of the table's own width (`px` or `%`), so a table
	* width change (in the table properties) also switches the columns' unit. It is a no-op when the table is not
	* resized or the columns already use that unit.
	*/ _reconcileColumnUnits(writer, table) {
        const tableColumnGroup = $f1b97c36043e973c$export$3003b92ca07186d3(table);
        if (!tableColumnGroup) return;
        const columnWidths = $f1b97c36043e973c$export$704df7f93ae962f7(tableColumnGroup);
        const tableIsPixels = $f1b97c36043e973c$var$isTableWidthInPixels(table);
        if (tableIsPixels === $f1b97c36043e973c$var$isColumnWidthsInPixels(columnWidths)) return;
        let reconciledWidths;
        if (tableIsPixels) {
            const tableWidthInPixels = parseFloat(table.getAttribute("tableWidth"));
            reconciledWidths = columnWidths.map((width)=>`${$f1b97c36043e973c$export$288dd660ff522bf9(parseFloat(width) / 100 * tableWidthInPixels)}px`);
        } else {
            const totalWidth = $f1b97c36043e973c$export$a2421b6a51bb9cb5(columnWidths.map((width)=>parseFloat(width)));
            reconciledWidths = columnWidths.map((width)=>`${$f1b97c36043e973c$export$288dd660ff522bf9(parseFloat(width) / totalWidth * 100)}%`);
        }
        $f1b97c36043e973c$export$96fdad66d97345fc($f1b97c36043e973c$export$93a5df62948110b3(tableColumnGroup), tableColumnGroup, reconciledWidths, writer);
    }
    /**
	* Applies a column width in the percentage mode: the target column gets the (clamped) percentage and the remaining
	* columns are redistributed proportionally so that all the widths keep summing up to 100%.
	*/ _applyPercentageColumnWidths(writer, table, columnIndexes, value) {
        const columns = $f1b97c36043e973c$export$93a5df62948110b3(table);
        const widths = $f1b97c36043e973c$export$704df7f93ae962f7(table).map((width)=>parseFloat(width));
        if (columnIndexes.includes(columns.length - 1)) {
            this._growTableToColumnWidths(writer, table, columns, widths, columnIndexes, value);
            return;
        }
        const targetPercentage = value.trim().endsWith("%") ? parseFloat(value) : parseFloat(value) / $f1b97c36043e973c$export$27dbffe8026332af(table, this.editor) * 100;
        const nextWidths = widths.slice();
        for (const band of $f1b97c36043e973c$var$getContiguousBands(columnIndexes)){
            const neighbor = band.end + 1;
            const bandCount = band.indexes.length;
            const available = band.indexes.reduce((sum, index)=>sum + widths[index], widths[neighbor]);
            if (available < 5 * (bandCount + 1)) {
                const equalWidth = available / (bandCount + 1);
                for (const index of band.indexes)nextWidths[index] = equalWidth;
                nextWidths[neighbor] = equalWidth;
                continue;
            }
            const target = $f1b97c36043e973c$export$1433524e656d1e11(targetPercentage, 5, (available - 5) / bandCount);
            for (const index of band.indexes)nextWidths[index] = target;
            nextWidths[neighbor] = available - target * bandCount;
        }
        columns.forEach((columnElement, index)=>{
            writer.setAttribute("columnWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9(nextWidths[index])}%`, columnElement);
        });
    }
    /**
	* Applies a width to the target columns in the percentage mode when the selection reaches the last column. As
	* there is no next column to balance against, the table itself grows or shrinks (like dragging the last column's
	* right edge): every other column keeps its absolute width, so expressed against the resized table their
	* percentages scale, and the table's own width scales by the inverse.
	*/ _growTableToColumnWidths(writer, table, columns, widths, columnIndexes, value) {
        const targetColumns = new Set(columnIndexes);
        const targetCount = columnIndexes.length;
        const otherColumnsShare = 100 - columnIndexes.reduce((sum, index)=>sum + widths[index], 0);
        if (otherColumnsShare <= 0) {
            const equalWidth = 100 / columns.length;
            columns.forEach((columnElement)=>{
                writer.setAttribute("columnWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9(equalWidth)}%`, columnElement);
            });
            return;
        }
        let targetPercentage;
        if (value.trim().endsWith("%")) targetPercentage = parseFloat(value);
        else {
            const pixelWidth = parseFloat(value);
            targetPercentage = pixelWidth / (otherColumnsShare / 100 * $f1b97c36043e973c$export$27dbffe8026332af(table, this.editor) + targetCount * pixelWidth) * 100;
        }
        const target = $f1b97c36043e973c$export$1433524e656d1e11(targetPercentage, 5, Math.max(5, (100 - 5 * (columns.length - targetCount)) / targetCount));
        const scale = (100 - target * targetCount) / otherColumnsShare;
        columns.forEach((columnElement, index)=>{
            const next = targetColumns.has(index) ? target : widths[index] * scale;
            writer.setAttribute("columnWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9(next)}%`, columnElement);
        });
        const tableWidth = parseFloat(table.getAttribute("tableWidth"));
        if (!Number.isNaN(tableWidth)) writer.setAttribute("tableWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9(tableWidth / scale)}%`, table);
    }
    /**
	* Applies `width` to whichever element currently represents the table's actual width - by default the
	* widget's `<figure>`. Passing `null` clears it instead of setting anything.
	*
	* @internal
	*/ _setResizingTableWidth(writer, viewFigure, width) {
        if (width === null) writer.removeStyle("width", viewFigure);
        else writer.setStyle("width", width, viewFigure);
    }
    /**
	* Returns the table's current actual width, read from whichever element holds it - by default the
	* widget's `<figure>`.
	*
	* @internal
	*/ _getResizingTableWidth(viewFigure) {
        return viewFigure.getStyle("width");
    }
    /**
	* Registers new attributes for a table model element.
	*/ _extendSchema() {
        const schema = this.editor.model.schema;
        schema.extend("table", {
            allowAttributes: [
                "tableWidth"
            ]
        });
        schema.register("tableColumnGroup", {
            allowIn: "table",
            isLimit: true
        });
        schema.register("tableColumn", {
            allowIn: "tableColumnGroup",
            allowAttributes: [
                "columnWidth",
                "colSpan"
            ],
            isLimit: true
        });
        schema.setAttributeProperties("columnWidth", {
            isFormatting: true
        });
    }
    /**
	* Registers table column resize post-fixer.
	*
	* It checks if the change from the differ concerns a table-related element or attribute. For detected changes it:
	*  * Adjusts the `columnWidths` attribute to guarantee that the sum of the widths from all columns is 100%.
	*  * Checks if the `columnWidths` attribute gets updated accordingly after columns have been added or removed.
	*/ _registerPostFixer() {
        const model = this.editor.model;
        model.document.registerPostFixer((writer)=>{
            let changed = false;
            for (const table of $f1b97c36043e973c$export$8bf560a2affb342f(model)){
                const tableColumnGroup = this.getColumnGroupElement(table);
                const columns = this.getTableColumnElements(tableColumnGroup);
                const columnWidths = this.getTableColumnsWidths(tableColumnGroup);
                const isPixelMode = $f1b97c36043e973c$var$isColumnWidthsInPixels(columnWidths);
                let normalizedWidths = isPixelMode ? $f1b97c36043e973c$var$normalizePixelColumnWidths(columnWidths, table) : $f1b97c36043e973c$export$3f6a26999910654(columnWidths);
                normalizedWidths = adjustColumnWidths(normalizedWidths, table, this);
                if (isPixelMode && normalizedWidths.length !== columnWidths.length) writer.setAttribute("tableWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9($f1b97c36043e973c$export$a2421b6a51bb9cb5(normalizedWidths))}px`, table);
                else normalizedWidths = $f1b97c36043e973c$var$scalePixelColumnsToTableWidth(normalizedWidths, table);
                if ((0, $a48d2f3392454588$export$248d38f6296296c5)(columnWidths, normalizedWidths)) continue;
                $f1b97c36043e973c$export$96fdad66d97345fc(columns, tableColumnGroup, normalizedWidths, writer);
                changed = true;
            }
            return changed;
        });
        /**
		* Adjusts if necessary the `columnWidths` in case if the number of column has changed.
		*
		* @param columnWidths Note: this array **may be modified** by the function.
		* @param table Table to be checked.
		*/ function adjustColumnWidths(columnWidths, table, plugin) {
            const newTableColumnsCount = plugin._tableUtilsPlugin.getColumns(table);
            if (newTableColumnsCount - columnWidths.length === 0) return columnWidths;
            const isPixelMode = $f1b97c36043e973c$var$isColumnWidthsInPixels(columnWidths);
            const widths = columnWidths.map((width)=>parseFloat(width));
            const cellSet = getAffectedCells(plugin.editor.model.document.differ, table);
            for (const cell of cellSet){
                const currentColumnsDelta = newTableColumnsCount - widths.length;
                if (currentColumnsDelta === 0) continue;
                const hasMoreColumns = currentColumnsDelta > 0;
                const currentColumnIndex = plugin._tableUtilsPlugin.getCellLocation(cell).column;
                if (hasMoreColumns) {
                    const insertedColumnWidth = isPixelMode ? 40 : $f1b97c36043e973c$export$f62189fd06b2c56(table, plugin.editor);
                    const columnWidthsToInsert = $f1b97c36043e973c$export$34e93823086e0ea7(currentColumnsDelta, insertedColumnWidth);
                    widths.splice(currentColumnIndex, 0, ...columnWidthsToInsert);
                } else {
                    const removedColumnWidths = widths.splice(currentColumnIndex, Math.abs(currentColumnsDelta));
                    widths[currentColumnIndex] += $f1b97c36043e973c$export$a2421b6a51bb9cb5(removedColumnWidths);
                }
            }
            return widths.map((width)=>`${width}${isPixelMode ? "px" : "%"}`);
        }
        /**
		* Returns a set of cells that have been changed in a given table.
		*/ function getAffectedCells(differ, table) {
            const cellSet = /* @__PURE__ */ new Set();
            for (const change of differ.getChanges())if (change.type == "insert" && change.position.nodeAfter && change.position.nodeAfter.name == "tableCell" && change.position.nodeAfter.getAncestors().includes(table)) cellSet.add(change.position.nodeAfter);
            else if (change.type == "remove") {
                const referenceNode = change.position.nodeBefore || change.position.nodeAfter;
                if (referenceNode.name == "tableCell" && referenceNode.getAncestors().includes(table)) cellSet.add(referenceNode);
            }
            return cellSet;
        }
    }
    /**
	* Registers table column resize converters.
	*/ _registerConverters() {
        const conversion = this.editor.conversion;
        conversion.for("upcast").attributeToAttribute({
            view: {
                name: /^(figure|table)$/,
                styles: {
                    width: /[\s\S]+/
                }
            },
            model: {
                key: "tableWidth",
                value: (viewElement)=>{
                    if (viewElement.parent.is("element", "figure")) return;
                    return viewElement.getStyle("width");
                }
            }
        });
        conversion.for("downcast").attributeToAttribute({
            model: {
                name: "table",
                key: "tableWidth"
            },
            view: (width)=>({
                    name: "figure",
                    key: "style",
                    value: {
                        width: width
                    }
                })
        });
        conversion.elementToElement({
            model: "tableColumnGroup",
            view: "colgroup"
        });
        conversion.elementToElement({
            model: "tableColumn",
            view: "col"
        });
        conversion.for("downcast").add($f1b97c36043e973c$export$bb8179edbe51c14d());
        conversion.for("upcast").add($f1b97c36043e973c$var$upcastTableResizedClass());
        conversion.for("upcast").add($f1b97c36043e973c$export$d5f83028c28c81c8(this._tableUtilsPlugin));
        conversion.for("upcast").attributeToAttribute({
            view: {
                name: "col",
                styles: {
                    width: /.*/
                }
            },
            model: {
                key: "columnWidth",
                value: (viewElement)=>{
                    const viewColWidth = viewElement.getStyle("width");
                    if (!viewColWidth || !viewColWidth.endsWith("%") && !viewColWidth.endsWith("pt") && !(viewColWidth.endsWith("px") && $f1b97c36043e973c$var$isViewTableWidthInPixels(viewElement))) return "auto";
                    return viewColWidth;
                }
            }
        });
        conversion.for("upcast").attributeToAttribute({
            view: {
                name: "col",
                key: "span"
            },
            model: "colSpan"
        });
        conversion.for("downcast").attributeToAttribute({
            model: {
                name: "tableColumn",
                key: "columnWidth"
            },
            view: (width)=>({
                    key: "style",
                    value: {
                        width: width
                    }
                })
        });
    }
    /**
	* Registers listeners to handle resizing process.
	*/ _registerResizingListeners() {
        const editingView = this.editor.editing.view;
        editingView.addObserver($f1b97c36043e973c$export$7815c0a315f5e2c5);
        editingView.document.on("mouseover", this._onMouseOverHandler.bind(this), {
            priority: "high"
        });
        editingView.document.on("mousedown", this._onMouseDownHandler.bind(this), {
            priority: "high"
        });
        editingView.document.on("mouseout", this._onMouseOutHandler.bind(this), {
            priority: "high"
        });
        this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.document, "mousemove", (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(this._onMouseMoveHandler.bind(this), 50));
        this._domEmitter.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window.document, "mouseup", this._onMouseUpHandler.bind(this));
    }
    /**
	* Calculate and set `top` and `bottom` styles to the column resizer element to fit the height of the table.
	*
	* @param viewResizer The column resizer element.
	*/ _recalculateResizerElement(viewResizer) {
        const editor = this.editor;
        const domConverter = editor.editing.view.domConverter;
        const domTable = domConverter.mapViewToDom(viewResizer.findAncestor("table"));
        const domCell = domConverter.mapViewToDom(viewResizer.findAncestor((item)=>[
                "td",
                "th"
            ].includes(item.name)));
        const rectTable = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domTable);
        const rectCell = new (0, $c7bc2cb7e2db0227$export$c79fc6492f3af13d)(domCell);
        const targetTopPosition = $f1b97c36043e973c$var$toPx(Number((rectTable.top - rectCell.top).toFixed(4)));
        const targetBottomPosition = $f1b97c36043e973c$var$toPx(Number((rectCell.bottom - rectTable.bottom).toFixed(4)));
        editor.editing.view.change((viewWriter)=>{
            viewWriter.setStyle("top", targetTopPosition, viewResizer);
            viewWriter.setStyle("bottom", targetBottomPosition, viewResizer);
        });
    }
    /**
	* Remove `top` and `bottom` styles of the column resizer element.
	*
	* @param viewResizer The column resizer element.
	*/ _resetResizerStyles(viewResizer) {
        this.editor.editing.view.change((viewWriter)=>{
            viewWriter.removeStyle("top", viewResizer);
            viewWriter.removeStyle("bottom", viewResizer);
        });
    }
    /**
	* Handles the `mouseover` event on column resizer element.
	* Recalculates the `top` and `bottom` styles of the column resizer element to fit the height of the table.
	*
	* @param eventInfo An object containing information about the fired event.
	* @param domEventData The data related to the DOM event.
	*/ _onMouseOverHandler(eventInfo, domEventData) {
        const target = domEventData.target;
        if (!target.hasClass("ck-table-column-resizer")) return;
        if (!this._isResizingAllowed) return;
        this._recalculateResizerElement(target);
    }
    /**
	* Handles the `mouseout` event on column resizer element.
	* When resizing is not active, it resets the `top` and `bottom` styles of the column resizer element.
	*
	* @param eventInfo An object containing information about the fired event.
	* @param domEventData The data related to the DOM event.
	*/ _onMouseOutHandler(eventInfo, domEventData) {
        const target = domEventData.target;
        if (!target.hasClass("ck-table-column-resizer")) return;
        if (!this._isResizingAllowed) return;
        if (this._isResizingActive) return;
        this._resetResizerStyles(target);
    }
    /**
	* Handles the `mousedown` event on column resizer element:
	*  * calculates the initial column pixel widths,
	*  * inserts the `<colgroup>` element if it is not present in the `<table>`,
	*  * puts the necessary data in the temporary storage,
	*  * applies the attributes to the `<table>` view element.
	*
	* @param eventInfo An object containing information about the fired event.
	* @param domEventData The data related to the DOM event.
	*/ _onMouseDownHandler(eventInfo, domEventData) {
        const target = domEventData.target;
        if (!target.hasClass("ck-table-column-resizer")) return;
        if (!this._isResizingAllowed) return;
        const editor = this.editor;
        const modelTable = editor.editing.mapper.toModelElement(target.findAncestor("figure"));
        if (!editor.model.canEditAt(modelTable)) return;
        domEventData.preventDefault();
        eventInfo.stop();
        this._initialMouseEventData = domEventData;
    }
    /**
	* Starts the resizing process after the threshold is reached.
	*/ _startResizingAfterThreshold() {
        const domEventData = this._initialMouseEventData;
        const { target: target } = domEventData;
        const modelTable = this.editor.editing.mapper.toModelElement(target.findAncestor("figure"));
        const viewTable = target.findAncestor("table");
        const viewFigure = target.findAncestor("figure");
        const isPixelMode = $f1b97c36043e973c$var$isTableWidthInPixels(modelTable);
        const columnWidthsInPx = _calculateDomColumnWidths(modelTable, this._tableUtilsPlugin, this.editor);
        if (!Array.from(viewTable.getChildren()).find((viewCol)=>viewCol.is("element", "colgroup"))) this.editor.editing.view.change((viewWriter)=>{
            _insertColgroupElement(viewWriter, columnWidthsInPx, viewTable, isPixelMode);
        });
        this._isResizingActive = true;
        this._resizingData = this._getResizingData(domEventData, columnWidthsInPx);
        this.editor.editing.view.change((writer)=>{
            const initialWidth = _applyResizingAttributesToTable(writer, viewTable, this._resizingData);
            this._setResizingTableWidth(writer, viewFigure, initialWidth);
        });
        /**
		* Calculates the DOM columns' widths. It is done by taking the width of the widest cell
		* from each table column (we rely on the  {@link module:table/tablewalker~TableWalker}
		* to determine which column the cell belongs to).
		*
		* @param modelTable A table which columns should be measured.
		* @param tableUtils The Table Utils plugin instance.
		* @param editor The editor instance.
		* @returns Columns' widths expressed in pixels (without unit).
		*/ function _calculateDomColumnWidths(modelTable, tableUtilsPlugin, editor) {
            const columnWidthsInPx = Array(tableUtilsPlugin.getColumns(modelTable));
            const tableWalker = new $f1b97c36043e973c$export$6c270156410e802f(modelTable);
            for (const cellSlot of tableWalker){
                const viewCell = editor.editing.mapper.toViewElement(cellSlot.cell);
                const domCell = editor.editing.view.domConverter.mapViewToDom(viewCell);
                const domCellWidth = $f1b97c36043e973c$export$c2cfc1723152f6a(domCell);
                if (!columnWidthsInPx[cellSlot.column] || domCellWidth < columnWidthsInPx[cellSlot.column]) columnWidthsInPx[cellSlot.column] = $f1b97c36043e973c$export$288dd660ff522bf9(domCellWidth);
            }
            return columnWidthsInPx;
        }
        /**
		* Creates a `<colgroup>` element with `<col>`s and inserts it into a given view table.
		*
		* @param viewWriter A writer instance.
		* @param columnWidthsInPx Column widths.
		* @param viewTable A table view element.
		*/ function _insertColgroupElement(viewWriter, columnWidthsInPx, viewTable, isPixelMode) {
            const colgroup = viewWriter.createContainerElement("colgroup");
            for(let i = 0; i < columnWidthsInPx.length; i++){
                const viewColElement = viewWriter.createEmptyElement("col");
                const columnWidth = isPixelMode ? `${$f1b97c36043e973c$export$288dd660ff522bf9(columnWidthsInPx[i])}px` : `${$f1b97c36043e973c$export$288dd660ff522bf9(columnWidthsInPx[i] / $f1b97c36043e973c$export$a2421b6a51bb9cb5(columnWidthsInPx) * 100)}%`;
                viewWriter.setStyle("width", columnWidth, viewColElement);
                viewWriter.insert(viewWriter.createPositionAt(colgroup, "end"), viewColElement);
            }
            viewWriter.insert(viewWriter.createPositionAt(viewTable, 0), colgroup);
        }
        /**
		* Applies the classes to the view table as the resizing begun, and computes the initial live width.
		*
		* @param viewWriter A writer instance.
		* @param viewTable A table containing the clicked resizer.
		* @param resizingData Data related to the resizing.
		* @returns The table's current width as a `%` string, e.g. for seeding {@link #_setResizingTableWidth}.
		*/ function _applyResizingAttributesToTable(viewWriter, viewTable, resizingData) {
            viewWriter.addClass("ck-table-resized", viewTable);
            viewWriter.addClass("ck-table-column-resizer__active", resizingData.elements.viewResizer);
            if (resizingData.flags.isPixelMode) return `${$f1b97c36043e973c$export$288dd660ff522bf9(parseFloat(resizingData.elements.modelTable.getAttribute("tableWidth")))}px`;
            const figureWidth = Math.max(resizingData.widths.tableWidth, resizingData.widths.viewFigureWidth);
            return `${$f1b97c36043e973c$export$288dd660ff522bf9(figureWidth / resizingData.widths.viewFigureParentWidth * 100)}%`;
        }
    }
    /**
	* Handles the `mousemove` event.
	*  * If resizing process is not in progress, it does nothing.
	*  * If resizing is active but not allowed, it stops the resizing process instantly calling the `mousedown` event handler.
	*  * Otherwise it dynamically updates the widths of the resized columns.
	*
	* @param eventInfo An object containing information about the fired event.
	* @param mouseEventData The native DOM event.
	*/ _onMouseMoveHandler(eventInfo, mouseEventData) {
        if (this._initialMouseEventData) {
            const mouseEvent = this._initialMouseEventData.domEvent;
            if (Math.abs(mouseEventData.clientX - mouseEvent.clientX) >= 3) {
                this._startResizingAfterThreshold();
                this._initialMouseEventData = null;
            } else return;
        }
        if (!this._isResizingActive) return;
        if (!this._isResizingAllowed) {
            this._onMouseUpHandler();
            return;
        }
        const { plugins: plugins } = this.editor;
        const { columnPosition: columnPosition, flags: { isRightEdge: isRightEdge, isTableCentered: isTableCentered, isLtrContent: isLtrContent, isPixelMode: isPixelMode, isTableWidthWithinContainerAtDragStart: isTableWidthWithinContainerAtDragStart, isTableScrollAllowed: isTableScrollAllowed }, elements: { modelTable: modelTable, viewFigure: viewFigure, viewLeftColumn: viewLeftColumn, viewRightColumn: viewRightColumn, viewResizer: viewResizer }, widths: { viewFigureParentWidth: viewFigureParentWidth, tableWidth: tableWidth, leftColumnWidth: leftColumnWidth, rightColumnWidth: rightColumnWidth } } = this._resizingData;
        const dxLowerBound = -leftColumnWidth + 40;
        const isTableScrollActive = !!(plugins.has("TableScrollEditing") ? plugins.get("TableScrollEditing") : null) && isTableScrollAllowed;
        const containerWidth = $f1b97c36043e973c$var$getEditableContentWidth(this.editor, modelTable.root.rootName);
        let dxUpperBound;
        if (isRightEdge) dxUpperBound = isTableScrollActive ? Infinity : viewFigureParentWidth - tableWidth;
        else dxUpperBound = rightColumnWidth - 40;
        const rawDx = mouseEventData.clientX - columnPosition;
        const ltrSign = isLtrContent ? 1 : -1;
        const isCenteredRightEdge = isRightEdge && isTableCentered;
        let dx;
        if (isTableScrollActive && isCenteredRightEdge) {
            const mouseDelta = rawDx * ltrSign;
            let newTableWidth;
            if (isTableWidthWithinContainerAtDragStart) {
                const crossoverPoint = (containerWidth - tableWidth) / 2;
                newTableWidth = mouseDelta <= crossoverPoint ? tableWidth + 2 * mouseDelta : containerWidth + (mouseDelta - crossoverPoint);
            } else {
                const crossoverPoint = containerWidth - tableWidth;
                newTableWidth = mouseDelta >= crossoverPoint ? tableWidth + mouseDelta : containerWidth + 2 * (mouseDelta - crossoverPoint);
            }
            dx = newTableWidth - tableWidth;
        } else dx = rawDx * (ltrSign * (isCenteredRightEdge ? 2 : 1));
        dx = $f1b97c36043e973c$export$1433524e656d1e11(dx, Math.min(dxLowerBound, 0), Math.max(dxUpperBound, 0));
        if (isTableScrollActive && isRightEdge) {
            const resistedTableWidth = $f1b97c36043e973c$var$applyContainerWidthResistance(tableWidth + dx, containerWidth);
            dx = $f1b97c36043e973c$export$1433524e656d1e11(resistedTableWidth - tableWidth, Math.min(dxLowerBound, 0), Math.max(dxUpperBound, 0));
        }
        if (dx === 0) return;
        this.editor.editing.view.change((writer)=>{
            const toWidthValue = (widthInPx, basisInPx)=>isPixelMode ? `${$f1b97c36043e973c$export$288dd660ff522bf9(widthInPx)}px` : `${$f1b97c36043e973c$export$288dd660ff522bf9(widthInPx * 100 / basisInPx)}%`;
            writer.setStyle("width", toWidthValue(leftColumnWidth + dx, tableWidth), viewLeftColumn);
            if (isRightEdge) {
                const tableFigureWidth = isPixelMode ? `${$f1b97c36043e973c$export$288dd660ff522bf9(tableWidth + dx)}px` : `${$f1b97c36043e973c$export$288dd660ff522bf9((tableWidth + dx) * 100 / viewFigureParentWidth)}%`;
                this._setResizingTableWidth(writer, viewFigure, tableFigureWidth);
            } else writer.setStyle("width", toWidthValue(rightColumnWidth - dx, tableWidth), viewRightColumn);
        });
        this._recalculateResizerElement(viewResizer);
    }
    /**
	* Handles the `mouseup` event.
	*  * If resizing process is not in progress, it does nothing.
	*  * If resizing is active but not allowed, it cancels the resizing process restoring the original widths.
	*  * Otherwise it propagates the changes from view to the model by executing the adequate commands.
	*/ _onMouseUpHandler() {
        this._initialMouseEventData = null;
        if (!this._isResizingActive) return;
        const { viewResizer: viewResizer, modelTable: modelTable, viewFigure: viewFigure, viewTable: viewTable, viewColgroup: viewColgroup } = this._resizingData.elements;
        const { isPixelMode: isPixelMode } = this._resizingData.flags;
        const editor = this.editor;
        const editingView = editor.editing.view;
        const tableColumnGroup = this.getColumnGroupElement(modelTable);
        const viewColumns = Array.from(viewColgroup.getChildren()).filter((column)=>column.is("view:element"));
        const columnWidthsAttributeOld = tableColumnGroup ? this.getTableColumnsWidths(tableColumnGroup) : null;
        const columnWidthsAttributeNew = viewColumns.map((column)=>column.getStyle("width"));
        const isColumnWidthsAttributeChanged = !(0, $a48d2f3392454588$export$248d38f6296296c5)(columnWidthsAttributeOld, columnWidthsAttributeNew);
        const tableWidthAttributeOld = modelTable.getAttribute("tableWidth");
        const tableWidthAttributeNew = this._getResizingTableWidth(viewFigure);
        const isTableWidthAttributeChanged = tableWidthAttributeOld !== tableWidthAttributeNew;
        if (isColumnWidthsAttributeChanged || isTableWidthAttributeChanged) {
            if (this._isResizingAllowed) {
                const tableWidthInPixels = $f1b97c36043e973c$export$288dd660ff522bf9(tableWidthAttributeNew);
                const tableWidthInPixelsBeforeResize = $f1b97c36043e973c$export$288dd660ff522bf9(tableWidthAttributeOld);
                const columnWidths = isPixelMode ? columnWidthsAttributeNew.map((width)=>typeof width === "string" && !width.endsWith("px") ? `${$f1b97c36043e973c$export$288dd660ff522bf9(parseFloat(width) / 100 * tableWidthInPixelsBeforeResize)}px` : width) : columnWidthsAttributeNew;
                editor.execute("resizeTableWidth", {
                    table: modelTable,
                    tableWidth: isPixelMode ? `${$f1b97c36043e973c$export$288dd660ff522bf9(tableWidthInPixels)}px` : `${$f1b97c36043e973c$export$288dd660ff522bf9(tableWidthAttributeNew)}%`,
                    columnWidths: columnWidths
                });
            } else editingView.change((writer)=>{
                if (columnWidthsAttributeOld) for (const viewCol of viewColumns)writer.setStyle("width", columnWidthsAttributeOld.shift(), viewCol);
                else writer.remove(viewColgroup);
                if (isTableWidthAttributeChanged) this._setResizingTableWidth(writer, viewFigure, tableWidthAttributeOld || null);
                if (!columnWidthsAttributeOld && !tableWidthAttributeOld) writer.removeClass("ck-table-resized", viewTable);
            });
        }
        editingView.change((writer)=>{
            writer.removeClass("ck-table-column-resizer__active", viewResizer);
        });
        if (!editingView.domConverter.mapViewToDom(viewResizer).matches(":hover")) this._resetResizerStyles(viewResizer);
        this._isResizingActive = false;
        this._resizingData = null;
    }
    /**
	* Retrieves and returns required data needed for the resizing process.
	*
	* @param domEventData The data of the `mousedown` event.
	* @param columnWidths The current widths of the columns.
	* @returns The data needed for the resizing process.
	*/ _getResizingData(domEventData, columnWidths) {
        const editor = this.editor;
        const columnPosition = domEventData.domEvent.clientX;
        const viewResizer = domEventData.target;
        const viewLeftCell = viewResizer.findAncestor((element)=>element.is("element", "td") || element.is("element", "th"));
        const modelLeftCell = editor.editing.mapper.toModelElement(viewLeftCell);
        const modelTable = modelLeftCell.findAncestor("table");
        const leftColumnIndex = $f1b97c36043e973c$export$a9ac57172d51c643(modelLeftCell, this._tableUtilsPlugin).rightEdge;
        const lastColumnIndex = this._tableUtilsPlugin.getColumns(modelTable) - 1;
        let tableAlignment = modelTable.getAttribute("tableAlignment");
        if (modelTable.getAttribute("tableType") !== "layout") {
            tableAlignment ||= editor.config.get("table.tableProperties.defaultProperties.alignment");
            tableAlignment ||= "center";
        }
        const isRightEdge = leftColumnIndex === lastColumnIndex;
        const isLtrContent = editor.locale.contentLanguageDirection !== "rtl";
        const isTableCentered = tableAlignment === "center";
        const isPixelMode = $f1b97c36043e973c$var$isTableWidthInPixels(modelTable);
        const viewTable = viewLeftCell.findAncestor("table");
        const viewFigure = viewTable.findAncestor("figure");
        const viewColgroup = [
            ...viewTable.getChildren()
        ].find((viewCol)=>viewCol.is("element", "colgroup"));
        const viewLeftColumn = viewColgroup.getChild(leftColumnIndex);
        const viewRightColumn = isRightEdge ? void 0 : viewColgroup.getChild(leftColumnIndex + 1);
        const domFigureParent = editor.editing.view.domConverter.mapViewToDom(viewFigure.parent);
        const viewFigureParentWidth = $f1b97c36043e973c$var$getContainerContentWidth(domFigureParent);
        const viewFigureWidth = $f1b97c36043e973c$export$4be6b7a1d8b56248(editor.editing.view.domConverter.mapViewToDom(viewFigure));
        const tableWidth = $f1b97c36043e973c$export$27dbffe8026332af(modelTable, editor);
        const leftColumnWidth = columnWidths[leftColumnIndex];
        const rightColumnWidth = isRightEdge ? void 0 : columnWidths[leftColumnIndex + 1];
        const isTableWidthWithinContainerAtDragStart = tableWidth <= $f1b97c36043e973c$var$getEditableContentWidth(editor, modelTable.root.rootName);
        const tableScrollPlugin = editor.plugins.has("TableScrollEditing") ? editor.plugins.get("TableScrollEditing") : null;
        return {
            columnPosition: columnPosition,
            flags: {
                isRightEdge: isRightEdge,
                isTableCentered: isTableCentered,
                isLtrContent: isLtrContent,
                isPixelMode: isPixelMode,
                isTableWidthWithinContainerAtDragStart: isTableWidthWithinContainerAtDragStart,
                isTableScrollAllowed: !!tableScrollPlugin && tableScrollPlugin._isTableScrollable(modelTable)
            },
            elements: {
                viewResizer: viewResizer,
                modelTable: modelTable,
                viewFigure: viewFigure,
                viewTable: viewTable,
                viewColgroup: viewColgroup,
                viewLeftColumn: viewLeftColumn,
                viewRightColumn: viewRightColumn
            },
            widths: {
                viewFigureWidth: viewFigureWidth,
                viewFigureParentWidth: viewFigureParentWidth,
                tableWidth: tableWidth,
                leftColumnWidth: leftColumnWidth,
                rightColumnWidth: rightColumnWidth
            }
        };
    }
    /**
	* Registers a listener ensuring that each resizable cell have a resizer handle.
	*/ _registerResizerInserter() {
        this.editor.conversion.for("editingDowncast").add((dispatcher)=>{
            dispatcher.on("insert:tableCell", (evt, data, conversionApi)=>{
                const modelElement = data.item;
                const viewElement = conversionApi.mapper.toViewElement(modelElement);
                const viewWriter = conversionApi.writer;
                viewWriter.insert(viewWriter.createPositionAt(viewElement, "end"), viewWriter.createUIElement("div", {
                    class: "ck-table-column-resizer"
                }));
            }, {
                priority: "lowest"
            });
        });
    }
};
/**
* Tells whether the table wrapping the given view `<col>` element is sized in pixels. The width is read from the
* column's own table (or its wrapping `<figure>`), never from an ancestor further up, so a width-less table nested
* inside a wider one is not mistaken for a pixel table.
*/ function $f1b97c36043e973c$var$isViewTableWidthInPixels(viewColElement) {
    const viewTable = viewColElement.findAncestor((element)=>element.is("element", "table"));
    const viewParent = viewTable.parent;
    const width = (viewParent.is("element", "figure") ? viewParent : viewTable).getStyle("width");
    return typeof width === "string" && width.trim().endsWith("px");
}
/**
* In the pixel mode keeps the sum of the column widths equal to the table width. If they differ (for example after a
* manual table width change), the columns are scaled proportionally so that they sum up to the table width. In the
* percentage mode (or when the columns already sum to the table width) it is a no-op.
*/ function $f1b97c36043e973c$var$scalePixelColumnsToTableWidth(columnWidths, table) {
    if (!$f1b97c36043e973c$var$isTableWidthInPixels(table) || !$f1b97c36043e973c$var$isColumnWidthsInPixels(columnWidths)) return columnWidths;
    const tableWidthInPixels = parseFloat(table.getAttribute("tableWidth"));
    const totalWidth = $f1b97c36043e973c$export$a2421b6a51bb9cb5(columnWidths);
    if (!totalWidth || Math.abs(totalWidth - tableWidthInPixels) < .5) return columnWidths;
    const factor = tableWidthInPixels / totalWidth;
    return columnWidths.map((width)=>`${$f1b97c36043e973c$export$288dd660ff522bf9(parseFloat(width) * factor)}px`);
}
/**
* Normalizes a pixel-mode column group to concrete pixel widths. It mirrors {@link ~normalizeColumnWidths} (the
* percentage path): percentages are resolved against the table width, and missing (`auto`/`undefined`) columns are
* filled from the width left over in the table - so the column group never keeps `auto` widths or mixes units, and
* downstream arithmetic never sees a non-pixel value.
*/ function $f1b97c36043e973c$var$normalizePixelColumnWidths(columnWidths, table) {
    const tableWidthInPixels = parseFloat(table.getAttribute("tableWidth"));
    const pixelWidths = columnWidths.map((width)=>{
        if (width === "auto" || width === void 0) return null;
        return width.endsWith("%") ? parseFloat(width) / 100 * tableWidthInPixels : parseFloat(width);
    });
    const missingColumns = pixelWidths.filter((width)=>width === null).length;
    if (missingColumns) {
        const knownWidth = pixelWidths.reduce((sum, width)=>width === null ? sum : sum + width, 0);
        const widthForMissingColumn = Math.max((tableWidthInPixels - knownWidth) / missingColumns, 40);
        return pixelWidths.map((width)=>`${$f1b97c36043e973c$export$288dd660ff522bf9(width === null ? widthForMissingColumn : width)}px`);
    }
    return pixelWidths.map((width)=>`${$f1b97c36043e973c$export$288dd660ff522bf9(width)}px`);
}
/**
* Applies a column width in the pixel mode: the target column gets the absolute width and the table's own width
* grows or shrinks to the sum of all column widths.
*/ function $f1b97c36043e973c$var$applyPixelColumnWidths(writer, table, columnIndexes, value) {
    const columns = $f1b97c36043e973c$export$93a5df62948110b3(table);
    const tableWidthInPixels = parseFloat(table.getAttribute("tableWidth"));
    const toPixels = (width)=>width.trim().endsWith("%") ? parseFloat(width) / 100 * tableWidthInPixels : parseFloat(width);
    const targetPixels = Math.max(toPixels(value), 40);
    const widths = $f1b97c36043e973c$export$704df7f93ae962f7(table).map(toPixels);
    for (const index of columnIndexes)widths[index] = targetPixels;
    const roundedWidths = widths.map((width)=>$f1b97c36043e973c$export$288dd660ff522bf9(width));
    columns.forEach((columnElement, index)=>{
        writer.setAttribute("columnWidth", `${roundedWidths[index]}px`, columnElement);
    });
    writer.setAttribute("tableWidth", `${$f1b97c36043e973c$export$288dd660ff522bf9($f1b97c36043e973c$export$a2421b6a51bb9cb5(roundedWidths))}px`, table);
}
/**
* Splits a sorted list of column indexes into maximal contiguous bands, for example `[ 0, 1, 3 ]` into `[ 0, 1 ]`
* and `[ 3 ]`.
*/ function $f1b97c36043e973c$var$getContiguousBands(columnIndexes) {
    const bands = [];
    for (const index of columnIndexes){
        const lastBand = bands[bands.length - 1];
        if (lastBand && index === lastBand.end + 1) {
            lastBand.indexes.push(index);
            lastBand.end = index;
        } else bands.push({
            indexes: [
                index
            ],
            end: index
        });
    }
    return bands;
}
/**
* Given the table width a drag would naturally produce, returns the width that should actually be applied
* once snapping and growth resistance around the container's width are taken into account:
*
*  * if the natural width lands close to the container's width (on either side), it's pulled to exactly
*    match it,
*  * if the natural width is past the container's width, it stays pinned at the container's width until the
*    drag has gone far enough beyond it (the "resistance" zone) - past that point it keeps growing 1:1,
*    continuing smoothly from where the resistance was overcome instead of jumping,
*  * shrinking below the container's width is never resisted, only snapped when close.
*
* @internal
*/ function $f1b97c36043e973c$var$applyContainerWidthResistance(naturalTableWidth, containerWidth) {
    const distance = naturalTableWidth - containerWidth;
    if (distance < 0) return -distance <= 5 ? containerWidth : naturalTableWidth;
    const resistanceZone = 15;
    return distance <= resistanceZone ? containerWidth : containerWidth + (distance - resistanceZone);
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecolumnresize
*/ /**
* The table column resize feature.
*
* It provides the possibility to set the width of each column in a table using a resize handler.
*/ var $f1b97c36043e973c$export$4fe1d852d43f1a3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$7efa1f1b6529b993,
            $f1b97c36043e973c$export$48aba5f5e4c82d6a
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableColumnResize";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablelayout/commands/tabletypecommand
*/ /**
* The set table type command.
*
* The command is registered by {@link module:table/tablelayout/tablelayoutediting~TableLayoutEditing}
* as the `'tableType'` editor command.
*
* To set the table type at the current selection, execute the command and specify the table type:
*
* ```ts
* editor.execute( 'tableType', 'layout' );
* ```
*/ var $f1b97c36043e973c$export$bb7098f941e4b296 = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const selectedTable = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
        if (selectedTable) {
            this.isEnabled = true;
            this.value = selectedTable.getAttribute("tableType");
        } else {
            this.isEnabled = false;
            this.value = null;
        }
    }
    /**
	* Executes the command.
	*
	* Set table type by the given table type parameter.
	*
	* @param tableType The type of table it should become.
	* @fires execute
	*/ execute(tableType) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
        if (table.getAttribute("tableType") === tableType) return;
        model.change((writer)=>{
            writer.setAttribute("tableType", tableType, table);
            model.schema.removeDisallowedAttributes([
                table
            ], writer);
            const tableChildren = table.getChildren();
            for (const child of tableChildren)if (!model.schema.checkChild(table, child)) writer.remove(child);
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablelayout/tablelayoutediting
*/ const $f1b97c36043e973c$var$TABLE_TYPES = [
    "content",
    "layout"
];
/**
* The table layout editing plugin.
*/ var $f1b97c36043e973c$export$adf95547604b965b = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableLayoutEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "TL";
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$4fe1d852d43f1a3
        ];
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this._defineSchema();
        this._defineConverters();
        this._defineClipboardPasteHandlers();
        this._registerTableTypeAttributePostfixer();
        this.editor.commands.add("insertTableLayout", new $f1b97c36043e973c$export$db98139396fbbc89(this.editor));
        this.editor.commands.add("tableType", new $f1b97c36043e973c$export$bb7098f941e4b296(this.editor));
    }
    /**
	* Defines the schema for the table layout feature.
	*/ _defineSchema() {
        const { schema: schema } = this.editor.model;
        schema.extend("table", {
            allowAttributes: "tableType"
        });
        schema.addChildCheck($f1b97c36043e973c$var$layoutTableCheck, "caption");
        schema.addAttributeCheck($f1b97c36043e973c$var$layoutTableCheck, "headingRows");
        schema.addAttributeCheck($f1b97c36043e973c$var$layoutTableCheck, "headingColumns");
        schema.addAttributeCheck($f1b97c36043e973c$var$layoutTableCheck, "footerRows");
    }
    /**
	* Defines the converters for the table layout feature.
	*/ _defineConverters() {
        const { editor: editor } = this;
        const { conversion: conversion } = editor;
        const preferredExternalTableType = editor.config.get("table.tableLayout.preferredExternalTableType");
        conversion.for("upcast").add($f1b97c36043e973c$var$upcastLayoutTable(editor, preferredExternalTableType));
        conversion.for("dataDowncast").add($f1b97c36043e973c$var$dataDowncastLayoutTable());
        conversion.for("editingDowncast").attributeToAttribute({
            model: {
                key: "tableType",
                values: [
                    "layout",
                    "content"
                ]
            },
            view: {
                layout: {
                    key: "class",
                    value: [
                        "layout-table"
                    ]
                },
                content: {
                    key: "class",
                    value: [
                        "content-table"
                    ]
                }
            }
        });
    }
    /**
	* Handles the clipboard content insertion events.
	*
	* - If the content is from another editor, do not override the table type.
	* - If the content is from another source, set the table type to 'content'.
	*
	* It handles the scenario when user copies `<table></table>` from Word. We do not want to
	* change the table type to `layout` because it is really `content` table.
	*/ _defineClipboardPasteHandlers() {
        const { plugins: plugins } = this.editor;
        if (!plugins.has("ClipboardPipeline")) return;
        const clipboardPipeline = plugins.get("ClipboardPipeline");
        this.listenTo(clipboardPipeline, "contentInsertion", (evt, data)=>{
            if (data.sourceEditorId) return;
            this.editor.model.change((writer)=>{
                for (const { item: item } of writer.createRangeIn(data.content))if (item.is("element", "table")) writer.setAttribute("tableType", "content", item);
            });
        });
    }
    /**
	* Registers a post-fixer that sets the `tableType` attribute to `content` for inserted "default" tables.
	* Also fixes potential issues with the table structure when the `tableType` attribute has been changed.
	*/ _registerTableTypeAttributePostfixer() {
        const editor = this.editor;
        editor.model.document.registerPostFixer((writer)=>{
            const changes = editor.model.document.differ.getChanges();
            let hasChanged = false;
            for (const entry of changes){
                if (entry.type == "insert" && entry.name != "$text") {
                    const element = entry.position.nodeAfter;
                    const range = writer.createRangeOn(element);
                    for (const item of range.getItems())if (item.is("element", "table") && !item.hasAttribute("tableType")) {
                        writer.setAttribute("tableType", "content", item);
                        hasChanged = true;
                    }
                }
                if (entry.type == "attribute" && entry.attributeKey == "tableType") {
                    for (const item of entry.range.getItems())/* v8 ignore else -- `tableType` is only ever set on a single `table`, so the range holds no other items. */ if (item.is("element", "table")) {
                        editor.model.schema.removeDisallowedAttributes([
                            item
                        ], writer);
                        const tableChildren = item.getChildren();
                        for (const child of tableChildren)if (!editor.model.schema.checkChild(item, child)) {
                            writer.remove(child);
                            hasChanged = true;
                        }
                    }
                }
            }
            return hasChanged;
        });
    }
};
/**
* View table element to model table element conversion helper.
*
* This conversion helper overrides the default table converter to meet table layout conditions.
*
* @param editor Editor instance.
* @returns Conversion helper.
*/ function $f1b97c36043e973c$var$upcastLayoutTable(editor, preferredExternalTableType) {
    return (dispatcher)=>{
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            const viewTable = data.viewItem;
            if (!conversionApi.consumable.test(viewTable, {
                name: true
            })) return;
            if ($f1b97c36043e973c$var$resolveTableType(viewTable, preferredExternalTableType) == "content") return;
            const table = conversionApi.writer.createElement("table", {
                tableType: "layout"
            });
            if (!conversionApi.safeInsert(table, data.modelCursor)) return;
            conversionApi.consumable.consume(viewTable, {
                name: true
            });
            conversionApi.consumable.consume(viewTable, {
                attributes: [
                    "role"
                ]
            });
            conversionApi.consumable.consume(viewTable, {
                classes: [
                    "layout-table"
                ]
            });
            if (viewTable.getAttribute("border") === "0") conversionApi.consumable.consume(viewTable, {
                attributes: [
                    "border"
                ]
            });
            for (const tableChild of viewTable.getChildren())if (tableChild.is("element")) {
                for (const row of tableChild.getChildren())if (row.is("element", "tr")) conversionApi.convertItem(row, conversionApi.writer.createPositionAt(table, "end"));
            }
            conversionApi.convertChildren(viewTable, conversionApi.writer.createPositionAt(table, "end"));
            if (table.isEmpty) {
                const row = conversionApi.writer.createElement("tableRow");
                conversionApi.writer.insert(row, conversionApi.writer.createPositionAt(table, "end"));
                $f1b97c36043e973c$export$6912bf35f0593a83(conversionApi.writer, conversionApi.writer.createPositionAt(row, "end"));
            }
            conversionApi.updateConversionResult(table, data);
        }, {
            priority: "high"
        });
        dispatcher.on("element:table", (evt, data, conversionApi)=>{
            const { viewItem: viewItem, modelRange: modelRange } = data;
            if (modelRange) {
                const resolvedType = $f1b97c36043e973c$var$resolveTableType(viewItem, preferredExternalTableType);
                conversionApi.writer.setAttribute("tableType", resolvedType, modelRange);
                $f1b97c36043e973c$var$consumeViewTableClasses(conversionApi.consumable, viewItem);
                if (resolvedType === "content" && viewItem.parent?.is("element", "figure")) $f1b97c36043e973c$var$consumeViewTableClasses(conversionApi.consumable, viewItem.parent);
            }
        }, {
            priority: "low"
        });
    };
}
/**
* Consume all possible classes that determine type of table on provided view item.
*/ function $f1b97c36043e973c$var$consumeViewTableClasses(consumable, viewItem) {
    consumable.consume(viewItem, {
        classes: [
            "layout-table"
        ]
    });
    consumable.consume(viewItem, {
        classes: [
            "content-table"
        ]
    });
}
/**
* Model table container element to view table element conversion helper.
*
* @returns Conversion helper.
*/ function $f1b97c36043e973c$var$dataDowncastLayoutTable() {
    return (dispatcher)=>{
        return dispatcher.on("attribute:tableType:table", (evt, data, conversionApi)=>{
            const { item: item, attributeNewValue: attributeNewValue } = data;
            const { mapper: mapper, writer: writer } = conversionApi;
            if (!conversionApi.consumable.test(item, evt.name)) return;
            const table = mapper.toViewElement(item);
            writer.addClass(`${attributeNewValue}-table`, table);
            if (attributeNewValue == "layout") writer.setAttribute("role", "presentation", table);
            conversionApi.consumable.consume(item, evt.name);
        });
    };
}
/**
* Resolves the table type based on the view table element and the preferred external table type.
*/ function $f1b97c36043e973c$var$resolveTableType(viewTable, preferredExternalTableType) {
    if (viewTable.hasClass("content-table")) return "content";
    if (viewTable.hasClass("layout-table")) return "layout";
    if (preferredExternalTableType && $f1b97c36043e973c$var$TABLE_TYPES.includes(preferredExternalTableType)) return preferredExternalTableType;
    /**
	* Checks if the table is a content table if any of the following conditions are met:
	* - the `<table>` is wrapped with `<figure>`,
	* - the `<table>` has a `<caption>` element.
	*/ if (viewTable.parent.is("element", "figure") || Array.from(viewTable.getChildren()).some((child)=>child.is("element", "caption"))) return "content";
    return "layout";
}
/**
* Checks if the element is a layout table.
* It is used to disallow attributes or children that is managed by `Schema`.
*/ function $f1b97c36043e973c$var$layoutTableCheck(context) {
    if (context.endsWith("table") && context.last.getAttribute("tableType") == "layout") return false;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablelayout
*/ /**
* The table plugin.
*
* For a detailed overview, check the {@glink features/tables/layout-tables Layout table feature documentation}.
*/ var $f1b97c36043e973c$export$62444c3c724b1b20 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableLayout";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$4fe1d852d43f1a3,
            $f1b97c36043e973c$export$adf95547604b965b,
            $f1b97c36043e973c$export$cc70d806b34a5604
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table cell attribute command.
*
* This command is a base command for other table property commands.
*/ var $f1b97c36043e973c$export$afd650c153db78dd = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* The attribute that will be set by the command.
	*/ attributeName;
    /**
	* The default value for the attribute.
	*
	* @readonly
	*/ _defaultValue;
    /**
	* The default value for the attribute for the content table.
	*/ _defaultContentTableValue;
    /**
	* The default value for the attribute for the layout table.
	*/ _defaultLayoutTableValue;
    /**
	* Creates a new `TablePropertyCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param attributeName Table cell attribute name.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, attributeName, defaultValue){
        super(editor);
        this.attributeName = attributeName;
        this._defaultContentTableValue = defaultValue;
        this._defaultLayoutTableValue = attributeName === "tableBorderStyle" ? "none" : void 0;
    }
    /**
	* @inheritDoc
	*/ refresh() {
        const selection = this.editor.model.document.selection;
        const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
        this._defaultValue = !table || table.getAttribute("tableType") !== "layout" ? this._defaultContentTableValue : this._defaultLayoutTableValue;
        this.isEnabled = !!table;
        this.value = this._getValue(table);
    }
    /**
	* Executes the command.
	*
	* @fires execute
	* @param options.value If set, the command will set the attribute on the selected table.
	* If not set, the command will remove the attribute from the selected table.
	* @param options.batch Pass the model batch instance to the command to aggregate changes,
	* for example, to allow a single undo step for multiple executions.
	*/ execute(options = {}) {
        const model = this.editor.model;
        const selection = model.document.selection;
        const { value: value, batch: batch } = options;
        const table = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
        const valueToSet = this._getValueToSet(value);
        model.enqueueChange(batch, (writer)=>{
            if (valueToSet) writer.setAttribute(this.attributeName, valueToSet, table);
            else writer.removeAttribute(this.attributeName, table);
        });
    }
    /**
	* Returns the attribute value for a table.
	*/ _getValue(table) {
        if (!table) return;
        const value = table.getAttribute(this.attributeName);
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* Returns the proper model value. It can be used to add a default unit to numeric values.
	*/ _getValueToSet(value) {
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table background color command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableBackgroundColor'` editor command.
*
* To change the background color of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableBackgroundColor', {
*   value: '#f00'
* } );
* ```
*/ var $f1b97c36043e973c$export$ebc150fadabb96da = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableBackgroundColorCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableBackgroundColor", defaultValue);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table border color command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableBorderColor'` editor command.
*
* To change the border color of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableBorderColor', {
*   value: '#f00'
* } );
* ```
*/ var $f1b97c36043e973c$export$5b4d5fd165531f92 = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableBorderColorCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableBorderColor", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValue(table) {
        if (!table) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(table.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table style border command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableBorderStyle'` editor command.
*
* To change the border style of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableBorderStyle', {
*   value: 'dashed'
* } );
* ```
*/ var $f1b97c36043e973c$export$7cc0a5c9bb9c91e5 = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableBorderStyleCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableBorderStyle", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValue(table) {
        if (!table) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(table.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table width border command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableBorderWidth'` editor command.
*
* To change the border width of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableBorderWidth', {
*   value: '5px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableBorderWidth', {
*   value: '5'
* } );
* ```
*
* will set the `borderWidth` attribute to `'5px'` in the model.
*/ var $f1b97c36043e973c$export$7cbb35eb771cf1f1 = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableBorderWidthCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableBorderWidth", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValue(table) {
        if (!table) return;
        const value = $f1b97c36043e973c$export$6baee843575e6ef2(table.getAttribute(this.attributeName));
        if (value === this._defaultValue) return;
        return value;
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        const newValue = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (newValue === this._defaultValue) return;
        return newValue;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties/commands/tablewidthcommand
*/ /**
* The table width command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableWidth'` editor command.
*
* To change the width of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableWidth', {
*   value: '400px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableWidth', {
*   value: '50'
* } );
* ```
*
* will set the `width` attribute to `'50px'` in the model.
*/ var $f1b97c36043e973c$export$63c9731430d62875 = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableWidthCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableWidth", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        value = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties/commands/tableheightcommand
*/ /**
* The table height command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableHeight'` editor command.
*
* To change the height of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableHeight', {
*   value: '500px'
* } );
* ```
*
* **Note**: This command adds the default `'px'` unit to numeric values. Executing:
*
* ```ts
* editor.execute( 'tableHeight', {
*   value: '50'
* } );
* ```
*
* will set the `height` attribute to `'50px'` in the model.
*/ var $f1b97c36043e973c$export$b47e13ef360d6870 = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableHeightCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value of the attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableHeight", defaultValue);
    }
    /**
	* @inheritDoc
	*/ _getValueToSet(value) {
        value = $f1b97c36043e973c$export$d3891b194d68f193(value, "px");
        if (value === this._defaultValue) return;
        return value;
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The table alignment command.
*
* The command is registered by the {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing} as
* the `'tableAlignment'` editor command.
*
* To change the alignment of the selected table, execute the command:
*
* ```ts
* editor.execute( 'tableAlignment', {
*   value: 'right'
* } );
* ```
*/ var $f1b97c36043e973c$export$f1786db3641b18ff = class extends $f1b97c36043e973c$export$afd650c153db78dd {
    /**
	* Creates a new `TableAlignmentCommand` instance.
	*
	* @param editor An editor in which this command will be used.
	* @param defaultValue The default value for the "alignment" attribute.
	*/ constructor(editor, defaultValue){
        super(editor, "tableAlignment", defaultValue);
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties/tablepropertiesediting
*/ /**
* The table properties editing feature.
*
* Introduces table's model attributes and their conversion:
*
* - border: `tableBorderStyle`, `tableBorderColor` and `tableBorderWidth`
* - background color: `tableBackgroundColor`
* - horizontal alignment: `tableAlignment`
* - width & height: `tableWidth` & `tableHeight`
*
* It also registers commands used to manipulate the above attributes:
*
* - border: `'tableBorderStyle'`, `'tableBorderColor'` and `'tableBorderWidth'` commands
* - background color: `'tableBackgroundColor'`
* - horizontal alignment: `'tableAlignment'`
* - width & height: `'tableWidth'` & `'tableHeight'`
*/ var $f1b97c36043e973c$export$8f19efd9d0f4a12c = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TablePropertiesEditing";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "TCP";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23
        ];
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        editor.config.define("table.tableProperties.defaultProperties", {});
        const defaultTableProperties = $f1b97c36043e973c$export$c0582ddd10a12af8(editor.config.get("table.tableProperties.defaultProperties"), {
            includeAlignmentProperty: true
        });
        const useInlineStyles = editor.config.get("table.tableProperties.alignment.useInlineStyles") === true;
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$45e932fc987e4c1e));
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$46159d29aabaeb2c));
        $f1b97c36043e973c$var$enableBorderProperties(editor, {
            color: defaultTableProperties.borderColor,
            style: defaultTableProperties.borderStyle,
            width: defaultTableProperties.borderWidth
        });
        editor.commands.add("tableBorderColor", new $f1b97c36043e973c$export$5b4d5fd165531f92(editor, defaultTableProperties.borderColor));
        editor.commands.add("tableBorderStyle", new $f1b97c36043e973c$export$7cc0a5c9bb9c91e5(editor, defaultTableProperties.borderStyle));
        editor.commands.add("tableBorderWidth", new $f1b97c36043e973c$export$7cbb35eb771cf1f1(editor, defaultTableProperties.borderWidth));
        $f1b97c36043e973c$var$enableAlignmentProperty(schema, conversion, defaultTableProperties.alignment, useInlineStyles);
        editor.commands.add("tableAlignment", new $f1b97c36043e973c$export$f1786db3641b18ff(editor, defaultTableProperties.alignment));
        $f1b97c36043e973c$var$enableTableToFigureProperty(schema, conversion, {
            modelAttribute: "tableWidth",
            styleName: "width",
            attributeName: "width",
            attributeType: "length",
            defaultValue: defaultTableProperties.width
        });
        editor.commands.add("tableWidth", new $f1b97c36043e973c$export$63c9731430d62875(editor, defaultTableProperties.width));
        $f1b97c36043e973c$var$enableTableToFigureProperty(schema, conversion, {
            modelAttribute: "tableHeight",
            styleName: "height",
            attributeName: "height",
            attributeType: "length",
            defaultValue: defaultTableProperties.height
        });
        editor.commands.add("tableHeight", new $f1b97c36043e973c$export$b47e13ef360d6870(editor, defaultTableProperties.height));
        editor.data.addStyleProcessorRules((0, $b9b9f2bdf9c6137f$export$422a7ff0e667c6c8));
        $f1b97c36043e973c$var$enableProperty$1(schema, conversion, {
            modelAttribute: "tableBackgroundColor",
            styleName: "background-color",
            attributeName: "bgcolor",
            attributeType: "color",
            defaultValue: defaultTableProperties.backgroundColor
        });
        editor.commands.add("tableBackgroundColor", new $f1b97c36043e973c$export$ebc150fadabb96da(editor, defaultTableProperties.backgroundColor));
        $f1b97c36043e973c$var$upcastTableCellPaddingAttribute(editor, "table");
        const viewDoc = editor.editing.view.document;
        this.listenTo(viewDoc, "clipboardOutput", (evt, data)=>{
            editor.editing.view.change((writer)=>{
                for (const { item: item } of writer.createRangeIn(data.content))$f1b97c36043e973c$var$wrapInDivIfNeeded(item, writer);
                data.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(data.content));
            });
        }, {
            priority: "lowest"
        });
    }
};
/**
* Checks whether the view element is a table and if it needs to be wrapped in a div for alignment purposes.
* If so, it wraps it in a div and inserts it into the data content.
*/ function $f1b97c36043e973c$var$wrapInDivIfNeeded(viewItem, writer) {
    if (!viewItem.is("element", "table")) return;
    const alignAttribute = viewItem.getAttribute("align");
    const floatAttribute = viewItem.getStyle("float");
    const marginLeft = viewItem.getStyle("margin-left");
    const marginRight = viewItem.getStyle("margin-right");
    if (alignAttribute && alignAttribute === "center" || floatAttribute && floatAttribute === "right" && alignAttribute && alignAttribute === "right") {
        $f1b97c36043e973c$var$insertWrapperWithAlignment(writer, alignAttribute, viewItem);
        return;
    }
    if (floatAttribute === void 0 && marginLeft === "auto" && marginRight === "0") $f1b97c36043e973c$var$insertWrapperWithAlignment(writer, "right", viewItem);
}
function $f1b97c36043e973c$var$insertWrapperWithAlignment(writer, align, table) {
    const position = writer.createPositionBefore(table);
    const wrapper = writer.createContainerElement("div", {
        align: align
    }, table);
    writer.insert(position, wrapper);
}
/**
* Enables `tableBorderStyle'`, `tableBorderColor'` and `tableBorderWidth'` attributes for table.
*
* @param defaultBorder The default border values.
* @param defaultBorder.color The default `tableBorderColor` value.
* @param defaultBorder.style The default `tableBorderStyle` value.
* @param defaultBorder.width The default `tableBorderWidth` value.
*/ function $f1b97c36043e973c$var$enableBorderProperties(editor, defaultBorder) {
    const { conversion: conversion } = editor;
    const { schema: schema } = editor.model;
    const modelAttributes = {
        width: "tableBorderWidth",
        color: "tableBorderColor",
        style: "tableBorderStyle"
    };
    schema.extend("table", {
        allowAttributes: Object.values(modelAttributes)
    });
    for (const modelAttribute of Object.values(modelAttributes))schema.setAttributeProperties(modelAttribute, {
        isFormatting: true
    });
    $f1b97c36043e973c$export$fd4c67f8267d3604(editor, "table", modelAttributes, defaultBorder);
    $f1b97c36043e973c$export$f7b72872f2c8e2ea(conversion, {
        modelAttribute: modelAttributes.color,
        styleName: "border-color"
    });
    $f1b97c36043e973c$export$f7b72872f2c8e2ea(conversion, {
        modelAttribute: modelAttributes.style,
        styleName: "border-style"
    });
    $f1b97c36043e973c$export$f7b72872f2c8e2ea(conversion, {
        modelAttribute: modelAttributes.width,
        styleName: "border-width"
    });
}
/**
* Enables the `'alignment'` attribute for table.
*
* @param defaultValue The default alignment value.
*/ function $f1b97c36043e973c$var$enableAlignmentProperty(schema, conversion, defaultValue, useInlineStyles) {
    schema.extend("table", {
        allowAttributes: [
            "tableAlignment"
        ]
    });
    schema.setAttributeProperties("tableAlignment", {
        isFormatting: true,
        blockAlignment: (modelElement)=>({
                left: {
                    value: "blockLeft"
                },
                right: {
                    value: "blockRight"
                },
                center: {
                    value: "center",
                    isDefault: modelElement.getAttribute("tableType") !== "layout"
                }
            })
    });
    conversion.for("downcast").attributeToAttribute({
        model: {
            name: "table",
            key: "tableAlignment",
            values: [
                "left",
                "center",
                "right",
                "blockLeft",
                "blockRight"
            ]
        },
        view: {
            left: useInlineStyles ? {
                key: "style",
                value: {
                    float: "left",
                    "margin-right": "var(--ck-content-table-style-spacing, 1.5em)"
                }
            } : {
                key: "class",
                value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.left.className
            },
            right: useInlineStyles ? {
                key: "style",
                value: {
                    float: "right",
                    "margin-left": "var(--ck-content-table-style-spacing, 1.5em)"
                }
            } : {
                key: "class",
                value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.right.className
            },
            center: useInlineStyles ? {
                key: "style",
                value: {
                    "margin-left": "auto",
                    "margin-right": "auto"
                }
            } : {
                key: "class",
                value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.center.className
            },
            blockLeft: useInlineStyles ? {
                key: "style",
                value: {
                    "margin-left": "0",
                    "margin-right": "auto"
                }
            } : {
                key: "class",
                value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockLeft.className
            },
            blockRight: useInlineStyles ? {
                key: "style",
                value: {
                    "margin-left": "auto",
                    "margin-right": "0"
                }
            } : {
                key: "class",
                value: $f1b97c36043e973c$var$DEFAULT_TABLE_ALIGNMENT_OPTIONS.blockRight.className
            }
        },
        converterPriority: "high"
    });
    /**
	* Enables upcasting of the `tableAlignment` attribute.
	*/ $f1b97c36043e973c$var$upcastTableAlignmentConfig.forEach((config)=>{
        conversion.for("upcast").attributeToAttribute({
            view: config.view,
            model: {
                key: "tableAlignment",
                value: (viewElement, conversionApi, data)=>{
                    if ($f1b97c36043e973c$var$isNonTableFigureElement(viewElement)) return;
                    const localDefaultValue = $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "", data);
                    const align = config.getAlign(viewElement);
                    const consumables = config.getConsumables(viewElement);
                    conversionApi.consumable.consume(viewElement, consumables);
                    if (align !== localDefaultValue) return align;
                }
            }
        });
    });
    conversion.for("upcast").add($f1b97c36043e973c$var$upcastTableAlignedDiv(defaultValue));
}
/**
* Returns a function that converts the table view representation:
*
* ```html
* <div align="right"><table>...</table></div>
* <!-- or -->
* <div align="center"><table>...</table></div>
* <!-- or -->
* <div align="left"><table>...</table></div>
* ```
*
* to the model representation:
*
* ```xml
* <table tableAlignment="right|center|left"></table>
* ```
*
* @internal
*/ function $f1b97c36043e973c$var$upcastTableAlignedDiv(defaultValue) {
    return (dispatcher)=>{
        dispatcher.on("element:div", (evt, data, conversionApi)=>{
            if (!conversionApi.consumable.test(data.viewItem, {
                name: true,
                attributes: "align"
            })) return;
            const significantChildren = Array.from(data.viewItem.getChildren()).filter((child)=>{
                if (child.is("$text") || child.is("$textProxy")) return child.data.trim() !== "";
                return true;
            });
            if (significantChildren.length !== 1 || !significantChildren[0].is("element", "table")) return;
            const [viewTable] = significantChildren;
            if (!conversionApi.consumable.test(viewTable, {
                name: true
            })) return;
            conversionApi.consumable.consume(data.viewItem, {
                name: true,
                attributes: "align"
            });
            const conversionResult = conversionApi.convertItem(viewTable, data.modelCursor);
            const modelTable = (0, $c7bc2cb7e2db0227$export$43128fadae87b74a)(conversionResult.modelRange.getItems());
            if (!modelTable || !modelTable.is("element", "table")) {
                conversionApi.consumable.revert(data.viewItem, {
                    name: true,
                    attributes: "align"
                });
                if (conversionResult.modelRange && !conversionResult.modelRange.isCollapsed) {
                    data.modelRange = conversionResult.modelRange;
                    data.modelCursor = conversionResult.modelCursor;
                }
                return;
            }
            const align = $f1b97c36043e973c$var$convertToTableAlignment(data.viewItem.getAttribute("align"), viewTable.getAttribute("align"), $f1b97c36043e973c$export$6ca3286c7cc8243b(defaultValue, "", data));
            if (align) conversionApi.writer.setAttribute("tableAlignment", align, modelTable);
            conversionApi.updateConversionResult(modelTable, data);
        });
    };
}
/**
* Converts div `align` and table `align` attributes to the model `tableAlignment` attribute.
*
* @param divAlign The value of the div `align` attribute.
* @param tableAlign The value of the table `align` attribute.
* @param defaultValue The default alignment value.
* @returns The model `tableAlignment` value or `undefined` if no conversion is needed.
*/ function $f1b97c36043e973c$var$convertToTableAlignment(divAlign, tableAlign, defaultValue) {
    if (divAlign) switch(divAlign){
        case "right":
            if (tableAlign === "right") return "right";
            else if (tableAlign === "left") return "left";
            else return "blockRight";
        case "center":
            return "center";
        case "left":
            return tableAlign === void 0 ? "blockLeft" : "left";
        default:
            return defaultValue;
    }
}
/**
* Enables conversion for an attribute for simple view-model mappings.
*
* @param options.defaultValue The default value for the specified `modelAttribute`.
*/ function $f1b97c36043e973c$var$enableProperty$1(schema, conversion, options) {
    const { modelAttribute: modelAttribute } = options;
    schema.extend("table", {
        allowAttributes: [
            modelAttribute
        ]
    });
    schema.setAttributeProperties(modelAttribute, {
        isFormatting: true
    });
    $f1b97c36043e973c$export$d738fe580628bde5(conversion, {
        viewElement: "table",
        ...options
    });
    $f1b97c36043e973c$export$f7b72872f2c8e2ea(conversion, options);
}
/**
* Enables conversion for an attribute for simple view (figure) to model (table) mappings.
*/ function $f1b97c36043e973c$var$enableTableToFigureProperty(schema, conversion, options) {
    const { modelAttribute: modelAttribute } = options;
    schema.extend("table", {
        allowAttributes: [
            modelAttribute
        ]
    });
    schema.setAttributeProperties(modelAttribute, {
        isFormatting: true
    });
    $f1b97c36043e973c$export$d738fe580628bde5(conversion, {
        viewElement: /^(table|figure)$/,
        shouldUpcast: (viewElement)=>!(viewElement.name == "table" && viewElement.parent.name == "figure" || viewElement.name == "figure" && !viewElement.hasClass("table")),
        ...options
    });
    $f1b97c36043e973c$export$2140815f28869319(conversion, {
        modelElement: "table",
        ...options
    });
}
/**
* Checks whether a given figure element should be ignored when upcasting table properties.
*/ function $f1b97c36043e973c$var$isNonTableFigureElement(viewElement) {
    return viewElement.name == "figure" && !viewElement.hasClass("table");
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties/ui/tablepropertiesview
*/ /**
* The class representing a table properties form, allowing users to customize
* certain style aspects of a table, for instance, border, background color, alignment, etc..
*/ var $f1b97c36043e973c$export$eed5644533fd96b0 = class extends (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220) {
    /**
	* Options passed to the view. See {@link #constructor} to learn more.
	*/ options;
    /**
	* Tracks information about the DOM focus in the form.
	*/ focusTracker;
    /**
	* An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
	*/ keystrokes;
    /**
	* A collection of child views in the form.
	*/ children;
    /**
	* A dropdown that allows selecting the style of the table border.
	*/ borderStyleDropdown;
    /**
	* An input that allows specifying the width of the table border.
	*/ borderWidthInput;
    /**
	* An input that allows specifying the color of the table border.
	*/ borderColorInput;
    /**
	* An input that allows specifying the table background color.
	*/ backgroundInput;
    /**
	* An input that allows specifying the table width.
	*/ widthInput;
    /**
	* An input that allows specifying the table height.
	*/ heightInput;
    /**
	* A toolbar with buttons that allow changing the alignment of an entire table.
	*/ alignmentToolbar;
    /**
	* The "Save" button view.
	*/ saveButtonView;
    /**
	* The "Cancel" button view.
	*/ cancelButtonView;
    /**
	* The Back button view displayed in the header.
	*/ backButtonView;
    /**
	* A collection of views that can be focused in the form.
	*/ _focusables;
    /**
	* Helps cycling over {@link #_focusables} in the form.
	*/ _focusCycler;
    /**
	* @param locale The {@link module:core/editor/editor~Editor#locale} instance.
	* @param options Additional configuration of the view.
	*/ constructor(locale, options){
        super(locale);
        this.set({
            borderStyle: "",
            borderWidth: "",
            borderColor: "",
            backgroundColor: "",
            width: "",
            height: "",
            alignment: ""
        });
        this.options = options;
        const { borderStyleDropdown: borderStyleDropdown, borderWidthInput: borderWidthInput, borderColorInput: borderColorInput, borderRowLabel: borderRowLabel } = this._createBorderFields();
        const { backgroundRowLabel: backgroundRowLabel, backgroundInput: backgroundInput } = this._createBackgroundFields();
        const { widthInput: widthInput, operatorLabel: operatorLabel, heightInput: heightInput, dimensionsLabel: dimensionsLabel } = this._createDimensionFields();
        const { alignmentToolbar: alignmentToolbar, alignmentLabel: alignmentLabel } = this._createAlignmentFields();
        this.focusTracker = new (0, $c7bc2cb7e2db0227$export$fc044e1b74b9ba94)();
        this.keystrokes = new (0, $c7bc2cb7e2db0227$export$a783915b2b108628)();
        this.children = this.createCollection();
        this.borderStyleDropdown = borderStyleDropdown;
        this.borderWidthInput = borderWidthInput;
        this.borderColorInput = borderColorInput;
        this.backgroundInput = backgroundInput;
        this.widthInput = widthInput;
        this.heightInput = heightInput;
        this.alignmentToolbar = alignmentToolbar;
        const { saveButtonView: saveButtonView, cancelButtonView: cancelButtonView } = this._createActionButtons();
        this.saveButtonView = saveButtonView;
        this.cancelButtonView = cancelButtonView;
        this.backButtonView = this._createBackButton();
        this._focusables = new (0, $29fd27cb9bdab9d2$export$ff20b327de53fba7)();
        this._focusCycler = new (0, $29fd27cb9bdab9d2$export$679be10c531010f6)({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
                focusPrevious: "shift + tab",
                focusNext: "tab"
            }
        });
        const headerView = new (0, $29fd27cb9bdab9d2$export$27806e9e63215c18)(locale, {
            label: this.t("Table properties")
        });
        headerView.children.add(this.backButtonView, 0);
        this.children.add(headerView);
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            labelView: borderRowLabel,
            children: [
                borderRowLabel,
                borderStyleDropdown,
                borderWidthInput,
                borderColorInput
            ],
            class: "ck-table-form__border-row"
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    labelView: dimensionsLabel,
                    children: [
                        dimensionsLabel,
                        widthInput,
                        operatorLabel,
                        heightInput
                    ],
                    class: "ck-table-form__dimensions-row"
                }),
                new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
                    labelView: backgroundRowLabel,
                    children: [
                        backgroundRowLabel,
                        backgroundInput
                    ],
                    class: "ck-table-form__background-row"
                })
            ]
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            labelView: alignmentLabel,
            children: [
                alignmentLabel,
                alignmentToolbar
            ],
            class: "ck-table-properties-form__alignment-row"
        }));
        this.children.add(new (0, $29fd27cb9bdab9d2$export$bcc7336b534c1c75)(locale, {
            children: [
                this.cancelButtonView,
                this.saveButtonView
            ],
            class: [
                "ck-table-form__action-row"
            ]
        }));
        this.setTemplate({
            tag: "form",
            attributes: {
                class: [
                    "ck",
                    "ck-form",
                    "ck-table-form",
                    "ck-table-properties-form"
                ],
                tabindex: "-1"
            },
            children: this.children
        });
    }
    /**
	* @inheritDoc
	*/ render() {
        super.render();
        (0, $29fd27cb9bdab9d2$export$4ce568c1357045cd)({
            view: this
        });
        [
            this.borderColorInput,
            this.backgroundInput
        ].forEach((view)=>{
            this._focusCycler.chain(view.fieldView.focusCycler);
        });
        [
            this.borderStyleDropdown,
            this.borderWidthInput,
            this.borderColorInput,
            this.widthInput,
            this.heightInput,
            this.backgroundInput,
            this.alignmentToolbar,
            this.cancelButtonView,
            this.saveButtonView,
            this.backButtonView
        ].forEach((view)=>{
            this._focusables.add(view);
            this.focusTracker.add(view.element);
        });
        this.keystrokes.listenTo(this.element);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        this.focusTracker.destroy();
        this.keystrokes.destroy();
    }
    /**
	* Focuses the fist focusable field in the form.
	*/ focus() {
        this._focusCycler.focusFirst();
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #borderStyleDropdown},
	* * {@link #borderWidthInput},
	* * {@link #borderColorInput}.
	*/ _createBorderFields() {
        const defaultTableProperties = this.options.defaultTableProperties;
        const defaultBorder = {
            style: defaultTableProperties.borderStyle,
            width: defaultTableProperties.borderWidth,
            color: defaultTableProperties.borderColor
        };
        const colorInputCreator = $f1b97c36043e973c$export$a69845a6512a5a97({
            colorConfig: this.options.borderColors,
            columns: this.options.colorGridColumns,
            defaultColorValue: defaultBorder.color,
            colorPickerConfig: this.options.colorPickerConfig
        });
        const locale = this.locale;
        const t = this.t;
        const accessibleLabel = t("Style");
        const borderRowLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        borderRowLabel.text = t("Border");
        const styleLabels = $f1b97c36043e973c$export$b091a4233b1c3c0e(t);
        const borderStyleDropdown = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$78775bf7bbba162f));
        borderStyleDropdown.set({
            label: accessibleLabel,
            class: "ck-table-form__border-style"
        });
        borderStyleDropdown.fieldView.buttonView.set({
            ariaLabel: accessibleLabel,
            ariaLabelledBy: void 0,
            isOn: false,
            withText: true,
            tooltip: accessibleLabel
        });
        borderStyleDropdown.fieldView.buttonView.bind("label").to(this, "borderStyle", (value)=>{
            return styleLabels[value ? value : "none"];
        });
        borderStyleDropdown.fieldView.on("execute", (evt)=>{
            this.borderStyle = evt.source._borderStyleValue;
        });
        borderStyleDropdown.bind("isEmpty").to(this, "borderStyle", (value)=>!value);
        (0, $29fd27cb9bdab9d2$export$d59f2481d69271ab)(borderStyleDropdown.fieldView, $f1b97c36043e973c$export$9c9d3add93f76391(this, defaultBorder.style), {
            role: "menu",
            ariaLabel: accessibleLabel
        });
        const borderWidthInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        borderWidthInput.set({
            label: t("Width"),
            class: "ck-table-form__border-width"
        });
        borderWidthInput.fieldView.bind("value").to(this, "borderWidth");
        borderWidthInput.bind("isEnabled").to(this, "borderStyle", $f1b97c36043e973c$var$isBorderStyleSet);
        borderWidthInput.fieldView.on("input", ()=>{
            this.borderWidth = borderWidthInput.fieldView.element.value;
        });
        const borderColorInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, colorInputCreator);
        borderColorInput.set({
            label: t("Color"),
            class: "ck-table-form__border-color"
        });
        borderColorInput.fieldView.bind("value").to(this, "borderColor");
        borderColorInput.bind("isEnabled").to(this, "borderStyle", $f1b97c36043e973c$var$isBorderStyleSet);
        borderColorInput.fieldView.on("input", ()=>{
            this.borderColor = borderColorInput.fieldView.value;
        });
        this.on("change:borderStyle", (evt, name, newValue, oldValue)=>{
            if (!$f1b97c36043e973c$var$isBorderStyleSet(newValue)) {
                this.borderColor = "";
                this.borderWidth = "";
            }
            if (!$f1b97c36043e973c$var$isBorderStyleSet(oldValue)) {
                this.borderColor = defaultBorder.color;
                this.borderWidth = defaultBorder.width;
            }
        });
        return {
            borderRowLabel: borderRowLabel,
            borderStyleDropdown: borderStyleDropdown,
            borderColorInput: borderColorInput,
            borderWidthInput: borderWidthInput
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #backgroundInput}.
	*/ _createBackgroundFields() {
        const locale = this.locale;
        const t = this.t;
        const backgroundRowLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        backgroundRowLabel.text = t("Background");
        const backgroundInputCreator = $f1b97c36043e973c$export$a69845a6512a5a97({
            colorConfig: this.options.backgroundColors,
            columns: this.options.colorGridColumns,
            defaultColorValue: this.options.defaultTableProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
        });
        const backgroundInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, backgroundInputCreator);
        backgroundInput.set({
            label: t("Color"),
            class: "ck-table-properties-form__background"
        });
        backgroundInput.fieldView.bind("value").to(this, "backgroundColor");
        backgroundInput.fieldView.on("input", ()=>{
            this.backgroundColor = backgroundInput.fieldView.value;
        });
        return {
            backgroundRowLabel: backgroundRowLabel,
            backgroundInput: backgroundInput
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #widthInput},
	* * {@link #heightInput}.
	*/ _createDimensionFields() {
        const locale = this.locale;
        const t = this.t;
        const dimensionsLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        dimensionsLabel.text = t("Dimensions");
        const widthInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        widthInput.set({
            label: t("Width"),
            class: "ck-table-form__dimensions-row__width"
        });
        widthInput.fieldView.bind("value").to(this, "width");
        widthInput.fieldView.on("input", ()=>{
            this.width = widthInput.fieldView.element.value;
        });
        const operatorLabel = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)(locale);
        operatorLabel.setTemplate({
            tag: "span",
            attributes: {
                class: [
                    "ck-table-form__dimension-operator"
                ]
            },
            children: [
                {
                    text: "\xd7"
                }
            ]
        });
        const heightInput = new (0, $29fd27cb9bdab9d2$export$698fc40b8eb40673)(locale, (0, $29fd27cb9bdab9d2$export$549636b2b89b8342));
        heightInput.set({
            label: t("Height"),
            class: "ck-table-form__dimensions-row__height"
        });
        heightInput.fieldView.bind("value").to(this, "height");
        heightInput.fieldView.on("input", ()=>{
            this.height = heightInput.fieldView.element.value;
        });
        return {
            dimensionsLabel: dimensionsLabel,
            widthInput: widthInput,
            operatorLabel: operatorLabel,
            heightInput: heightInput
        };
    }
    /**
	* Creates the following form fields:
	*
	* * {@link #alignmentToolbar}.
	*/ _createAlignmentFields() {
        const locale = this.locale;
        const t = this.t;
        const alignmentLabel = new (0, $29fd27cb9bdab9d2$export$84062398251b1ba)(locale);
        alignmentLabel.text = t("Table Alignment");
        const alignmentToolbar = new (0, $29fd27cb9bdab9d2$export$2e2212e163bc16b8)(locale);
        alignmentToolbar.set({
            role: "radiogroup",
            isCompact: true,
            ariaLabel: t("Table alignment toolbar")
        });
        $f1b97c36043e973c$export$5fdc8ac304f25e14({
            view: this,
            icons: {
                left: (0, $e8dc502aba5ac3f5$export$ed3c3dbf48d69b9e),
                center: (0, $e8dc502aba5ac3f5$export$bb4e522eef459e3d),
                right: (0, $e8dc502aba5ac3f5$export$5fcb2c20a0a41738),
                blockLeft: (0, $e8dc502aba5ac3f5$export$109641c0512af225),
                blockRight: (0, $e8dc502aba5ac3f5$export$12c57266ee03e50a)
            },
            toolbar: alignmentToolbar,
            labels: this._alignmentLabels,
            propertyName: "alignment",
            defaultValue: this.options.defaultTableProperties.alignment
        });
        return {
            alignmentLabel: alignmentLabel,
            alignmentToolbar: alignmentToolbar
        };
    }
    /**
	* Creates the following form controls:
	*
	* * {@link #saveButtonView},
	* * {@link #cancelButtonView}.
	*/ _createActionButtons() {
        const locale = this.locale;
        const t = this.t;
        const saveButtonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        const cancelButtonView = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
        const fieldsThatShouldValidateToSave = [
            this.borderWidthInput,
            this.borderColorInput,
            this.backgroundInput,
            this.widthInput,
            this.heightInput
        ];
        saveButtonView.set({
            label: t("Save"),
            class: "ck-button-action ck-button_standard",
            type: "submit",
            withText: true
        });
        saveButtonView.bind("isEnabled").toMany(fieldsThatShouldValidateToSave, "errorText", (...errorTexts)=>{
            return errorTexts.every((errorText)=>!errorText);
        });
        cancelButtonView.set({
            label: t("Cancel"),
            withText: true,
            class: "ck-button_standard"
        });
        cancelButtonView.delegate("execute").to(this, "cancel");
        return {
            saveButtonView: saveButtonView,
            cancelButtonView: cancelButtonView
        };
    }
    /**
	* Creates a back button view that cancels the form.
	*/ _createBackButton() {
        const t = this.locale.t;
        const backButton = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(this.locale);
        backButton.set({
            class: "ck-button-back",
            label: t("Back"),
            icon: (0, $e8dc502aba5ac3f5$export$93a3c1fcfd0c66b3),
            tooltip: true
        });
        backButton.delegate("execute").to(this, "cancel");
        return backButton;
    }
    /**
	* Provides localized labels for {@link #alignmentToolbar} buttons.
	*/ get _alignmentLabels() {
        const locale = this.locale;
        const t = this.t;
        const blockLeft = t("Align table to the left with no text wrapping");
        const blockRight = t("Align table to the right with no text wrapping");
        const left = t("Align table to the left with text wrapping");
        const center = t("Center table with no text wrapping");
        const right = t("Align table to the right with text wrapping");
        if (locale.uiLanguageDirection === "rtl") return {
            right: right,
            left: left,
            blockRight: blockRight,
            center: center,
            blockLeft: blockLeft
        };
        return {
            blockLeft: blockLeft,
            center: center,
            blockRight: blockRight,
            left: left,
            right: right
        };
    }
};
function $f1b97c36043e973c$var$isBorderStyleSet(value) {
    return value !== "none";
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties/tablepropertiesui
*/ const $f1b97c36043e973c$var$ERROR_TEXT_TIMEOUT = 500;
const $f1b97c36043e973c$var$propertyToCommandMap = {
    borderStyle: "tableBorderStyle",
    borderColor: "tableBorderColor",
    borderWidth: "tableBorderWidth",
    backgroundColor: "tableBackgroundColor",
    width: "tableWidth",
    height: "tableHeight",
    alignment: "tableAlignment"
};
/**
* The table properties UI plugin. It introduces the `'tableProperties'` button
* that opens a form allowing to specify visual styling of an entire table.
*
* It uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
*/ var $f1b97c36043e973c$export$f159b7f242ffd10f = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The default table properties.
	*/ _defaultContentTableProperties;
    /**
	* The default layout table properties.
	*/ _defaultLayoutTableProperties;
    /**
	* The contextual balloon plugin instance.
	*/ _balloon;
    /**
	* The properties form view displayed inside the balloon.
	*/ view = null;
    /**
	* The properties form view displayed inside the balloon (content table).
	*/ _viewWithContentTableDefaults = null;
    /**
	* The properties form view displayed inside the balloon (layout table).
	*/ _viewWithLayoutTableDefaults = null;
    /**
	* The batch used to undo all changes made by the form (which are live, as the user types)
	* when "Cancel" was pressed. Each time the view is shown, a new batch is created.
	*/ _undoStepBatch;
    /**
	* Flag used to indicate whether view is ready to execute update commands
	* (it finished loading initial data).
	*/ _isReady;
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            (0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c)
        ];
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TablePropertiesUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("table.tableProperties", {
            borderColors: $f1b97c36043e973c$export$a80c205843e19358,
            backgroundColors: $f1b97c36043e973c$export$a80c205843e19358,
            colorGridColumns: (0, $29fd27cb9bdab9d2$export$d573929527255e12)
        });
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        this._defaultContentTableProperties = $f1b97c36043e973c$export$c0582ddd10a12af8(editor.config.get("table.tableProperties.defaultProperties"), {
            includeAlignmentProperty: true
        });
        this._defaultLayoutTableProperties = $f1b97c36043e973c$export$6f5bcdb88bd6afde();
        this._balloon = editor.plugins.get((0, $29fd27cb9bdab9d2$export$d474f494ad2d7f9c));
        editor.ui.componentFactory.add("tableProperties", ()=>this._createTablePropertiesButton());
    }
    /**
	* Creates the table properties button.
	*
	* @internal
	*/ _createTablePropertiesButton() {
        const editor = this.editor;
        const t = editor.t;
        const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(editor.locale);
        view.set({
            label: t("Table properties"),
            icon: (0, $e8dc502aba5ac3f5$export$f0a4ba08c77f7861),
            tooltip: true
        });
        this.listenTo(view, "execute", ()=>this._showView());
        const commands = Object.values($f1b97c36043e973c$var$propertyToCommandMap).map((commandName)=>editor.commands.get(commandName));
        view.bind("isEnabled").toMany(commands, "isEnabled", (...areEnabled)=>areEnabled.some((isCommandEnabled)=>isCommandEnabled));
        return view;
    }
    /**
	* @inheritDoc
	*/ destroy() {
        super.destroy();
        if (this.view) this.view.destroy();
    }
    /**
	* Creates the {@link module:table/tableproperties/ui/tablepropertiesview~TablePropertiesView} instance.
	*
	* @returns The table properties form view instance.
	*/ _createPropertiesView(defaultTableProperties) {
        const editor = this.editor;
        const config = editor.config.get("table.tableProperties");
        const borderColorsConfig = (0, $29fd27cb9bdab9d2$export$ee5a86b42a248fe4)(config.borderColors);
        const localizedBorderColors = (0, $29fd27cb9bdab9d2$export$8609308dd8d581de)(editor.locale, borderColorsConfig);
        const backgroundColorsConfig = (0, $29fd27cb9bdab9d2$export$ee5a86b42a248fe4)(config.backgroundColors);
        const localizedBackgroundColors = (0, $29fd27cb9bdab9d2$export$8609308dd8d581de)(editor.locale, backgroundColorsConfig);
        const hasColorPicker = config.colorPicker !== false;
        const view = new $f1b97c36043e973c$export$eed5644533fd96b0(editor.locale, {
            borderColors: localizedBorderColors,
            backgroundColors: localizedBackgroundColors,
            defaultTableProperties: defaultTableProperties,
            colorGridColumns: config.colorGridColumns,
            colorPickerConfig: hasColorPicker ? config.colorPicker || {} : false
        });
        const t = editor.t;
        view.render();
        this.listenTo(view, "submit", ()=>{
            this._hideView();
        });
        this.listenTo(view, "cancel", ()=>{
            if (this._undoStepBatch.operations.length) editor.execute("undo", this._undoStepBatch);
            this._hideView();
        });
        view.keystrokes.set("Esc", (data, cancel)=>{
            this._hideView();
            cancel();
        });
        (0, $29fd27cb9bdab9d2$export$16d2a52659b91b8a)({
            emitter: view,
            activator: ()=>this._isViewInBalloon,
            contextElements: [
                this._balloon.view.element
            ],
            callback: ()=>this._hideView()
        });
        const colorErrorText = $f1b97c36043e973c$export$1a2f83aec824ae53(t);
        const lengthErrorText = $f1b97c36043e973c$export$46dc479228bc03c5(t);
        view.on("change:borderStyle", this._getPropertyChangeCallback("tableBorderStyle"));
        view.on("change:borderColor", this._getValidatedPropertyChangeCallback({
            viewField: view.borderColorInput,
            commandName: "tableBorderColor",
            errorText: colorErrorText,
            validator: $f1b97c36043e973c$export$370a0c0da4507ee8
        }));
        view.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
            viewField: view.borderWidthInput,
            commandName: "tableBorderWidth",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$2e984cc58f31fbb7
        }));
        view.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
            viewField: view.backgroundInput,
            commandName: "tableBackgroundColor",
            errorText: colorErrorText,
            validator: $f1b97c36043e973c$export$370a0c0da4507ee8
        }));
        view.on("change:width", this._getValidatedPropertyChangeCallback({
            viewField: view.widthInput,
            commandName: "tableWidth",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$529621552bb8a6ba
        }));
        view.on("change:height", this._getValidatedPropertyChangeCallback({
            viewField: view.heightInput,
            commandName: "tableHeight",
            errorText: lengthErrorText,
            validator: $f1b97c36043e973c$export$529621552bb8a6ba
        }));
        view.on("change:alignment", this._getPropertyChangeCallback("tableAlignment"));
        return view;
    }
    /**
	* In this method the "editor data -> UI" binding is happening.
	*
	* When executed, this method obtains selected table property values from various table commands
	* and passes them to the {@link #view}.
	*
	* This way, the UI stays up–to–date with the editor data.
	*/ _fillViewFormFromCommandValues() {
        const commands = this.editor.commands;
        const borderStyleCommand = commands.get("tableBorderStyle");
        Object.entries($f1b97c36043e973c$var$propertyToCommandMap).map(([property, commandName])=>{
            const propertyKey = property;
            const defaultValue = this.view === this._viewWithContentTableDefaults ? this._defaultContentTableProperties[propertyKey] || "" : this._defaultLayoutTableProperties[propertyKey] || "";
            return [
                propertyKey,
                commands.get(commandName).value || defaultValue
            ];
        }).forEach(([property, value])=>{
            if ((property === "borderColor" || property === "borderWidth") && borderStyleCommand.value === "none") return;
            this.view.set(property, value);
        });
        this._isReady = true;
    }
    /**
	* Shows the {@link #view} in the {@link #_balloon}.
	*
	* **Note**: Each time a view is shown, the new {@link #_undoStepBatch} is created that contains
	* all changes made to the document when the view is visible, allowing a single undo step
	* for all of them.
	*/ _showView() {
        const editor = this.editor;
        const viewTable = $f1b97c36043e973c$export$6eb262e884d1feb7(editor.editing.view.document.selection);
        const modelTable = viewTable && editor.editing.mapper.toModelElement(viewTable);
        const useDefaults = !modelTable || modelTable.getAttribute("tableType") !== "layout";
        if (useDefaults && !this._viewWithContentTableDefaults) this._viewWithContentTableDefaults = this._createPropertiesView(this._defaultContentTableProperties);
        else if (!useDefaults && !this._viewWithLayoutTableDefaults) this._viewWithLayoutTableDefaults = this._createPropertiesView(this._defaultLayoutTableProperties);
        this.view = useDefaults ? this._viewWithContentTableDefaults : this._viewWithLayoutTableDefaults;
        this.listenTo(editor.ui, "update", ()=>{
            this._updateView();
        });
        this._fillViewFormFromCommandValues();
        this._balloon.add({
            view: this.view,
            position: $f1b97c36043e973c$export$d0050425c94c519b(editor)
        });
        this._undoStepBatch = editor.model.createBatch();
        this.view.focus();
    }
    /**
	* Removes the {@link #view} from the {@link #_balloon}.
	*/ _hideView() {
        const editor = this.editor;
        this.stopListening(editor.ui, "update");
        this._isReady = false;
        this.view.saveButtonView.focus();
        this._balloon.remove(this.view);
        this.editor.editing.view.focus();
    }
    /**
	* Repositions the {@link #_balloon} or hides the {@link #view} if a table is no longer selected.
	*/ _updateView() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;
        if (!$f1b97c36043e973c$export$6eb262e884d1feb7(viewDocument.selection)) this._hideView();
        else if (this._isViewVisible) $f1b97c36043e973c$export$6873846109289138(editor, "table");
    }
    /**
	* Returns `true` when the {@link #view} is the visible in the {@link #_balloon}.
	*/ get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
    }
    /**
	* Returns `true` when the {@link #view} is in the {@link #_balloon}.
	*/ get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
    }
    /**
	* Creates a callback that when executed upon {@link #view view's} property change
	* executes a related editor command with the new property value.
	*
	* If new value will be set to the default value, the command will not be executed.
	*
	* @param commandName The command that will be executed.
	*/ _getPropertyChangeCallback(commandName) {
        return (evt, propertyName, newValue)=>{
            if (!this._isReady) return;
            this.editor.execute(commandName, {
                value: newValue,
                batch: this._undoStepBatch
            });
        };
    }
    /**
	* Creates a callback that when executed upon {@link #view view's} property change:
	* * executes a related editor command with the new property value if the value is valid,
	* * or sets the error text next to the invalid field, if the value did not pass the validation.
	*/ _getValidatedPropertyChangeCallback(options) {
        const { commandName: commandName, viewField: viewField, validator: validator, errorText: errorText } = options;
        const setErrorTextDebounced = (0, $b19df1c2aca1a652$export$61fc7d43ac8f84b0)(()=>{
            viewField.errorText = errorText;
        }, $f1b97c36043e973c$var$ERROR_TEXT_TIMEOUT);
        return (evt, propertyName, newValue)=>{
            setErrorTextDebounced.cancel();
            if (!this._isReady) return;
            if (validator(newValue)) {
                this.editor.execute(commandName, {
                    value: newValue,
                    batch: this._undoStepBatch
                });
                viewField.errorText = null;
            } else setErrorTextDebounced();
        };
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tableproperties
*/ /**
* The table properties feature. Enables support for setting properties of tables (size, border, background, etc.).
*
* Read more in the {@glink features/tables/tables-styling Table and cell styling tools} section.
* See also the {@link module:table/tablecellproperties~TableCellProperties} plugin.
*
* This is a "glue" plugin that loads the
* {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing table properties editing feature} and
* the {@link module:table/tableproperties/tablepropertiesui~TablePropertiesUI table properties UI feature}.
*/ var $f1b97c36043e973c$export$6dad081acd6c9224 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableProperties";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$8f19efd9d0f4a12c,
            $f1b97c36043e973c$export$f159b7f242ffd10f
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Injects a table caption post-fixer into the model.
*
* The role of the table caption post-fixer is to ensure that the table with caption have the correct structure
* after a {@link module:engine/model/model~Model#change `change()`} block was executed.
*
* The correct structure means that:
*
* * If there are many caption model element, they are merged into one model.
* * A final, merged caption model is placed at the end of the table.
*
* @internal
*/ function $f1b97c36043e973c$export$ea943f88b8962418(model) {
    model.document.registerPostFixer((writer)=>$f1b97c36043e973c$var$tableCaptionPostFixer(writer, model));
}
/**
* The table caption post-fixer.
*/ function $f1b97c36043e973c$var$tableCaptionPostFixer(writer, model) {
    const changes = model.document.differ.getChanges();
    let wasFixed = false;
    for (const entry of changes){
        if (entry.type != "insert") continue;
        const positionParent = entry.position.parent;
        if (positionParent.is("element", "table") || entry.name == "table") {
            const table = entry.name == "table" ? entry.position.nodeAfter : positionParent;
            const captionsToMerge = Array.from(table.getChildren()).filter((child)=>child.is("element", "caption"));
            const firstCaption = captionsToMerge.shift();
            if (!firstCaption) continue;
            for (const caption of captionsToMerge){
                writer.move(writer.createRangeIn(caption), firstCaption, "end");
                writer.remove(caption);
            }
            if (firstCaption.nextSibling) {
                writer.move(writer.createRangeOn(firstCaption), table, "end");
                wasFixed = true;
            }
            wasFixed = !!captionsToMerge.length || wasFixed;
        }
    }
    return wasFixed;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Checks if the provided model element is a `table`.
*
* @param modelElement Element to check if it is a table.
* @internal
*/ function $f1b97c36043e973c$export$1ec15407b49260c7(modelElement) {
    return !!modelElement && modelElement.is("element", "table");
}
/**
* Returns the caption model element from a given table element. Returns `null` if no caption is found.
*
* @param tableModelElement Table element in which we will try to find a caption element.
* @internal
*/ function $f1b97c36043e973c$export$d67d386186184bb5(tableModelElement) {
    for (const node of tableModelElement.getChildren())if (node.is("element", "caption")) return node;
    return null;
}
/**
* Returns the caption model element for a model selection. Returns `null` if the selection has no caption element ancestor.
*
* @param selection The selection checked for caption presence.
* @internal
*/ function $f1b97c36043e973c$export$274ec9ac27a6b631(selection) {
    const tableElement = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(selection);
    if (!tableElement) return null;
    return $f1b97c36043e973c$export$d67d386186184bb5(tableElement);
}
/**
* {@link module:engine/view/matcher~Matcher} pattern. Checks if a given element is a caption.
*
* There are two possible forms of the valid caption:
*  - A `<figcaption>` element inside a `<figure class="table">` element.
*  - A `<caption>` inside a <table>.
*
* @returns Returns the object accepted by {@link module:engine/view/matcher~Matcher} or `null` if the element cannot be matched.
* @internal
*/ function $f1b97c36043e973c$export$d5439d6bbf9a4013(element) {
    const parent = element.parent;
    if (element.name == "figcaption" && parent && parent.is("element", "figure") && parent.hasClass("table")) return {
        name: true
    };
    if (element.name == "caption" && parent && parent.is("element", "table")) return {
        name: true
    };
    return null;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecaption/toggletablecaptioncommand
*/ /**
* The toggle table caption command.
*
* This command is registered by {@link module:table/tablecaption/tablecaptionediting~TableCaptionEditing} as the
* `'toggleTableCaption'` editor command.
*
* Executing this command:
*
* * either adds or removes the table caption of a selected table (depending on whether the caption is present or not),
* * removes the table caption if the selection is anchored in one.
*
* ```ts
* // Toggle the presence of the caption.
* editor.execute( 'toggleTableCaption' );
* ```
*
* **Note**: You can move the selection to the caption right away as it shows up upon executing this command by using
* the `focusCaptionOnShow` option:
*
* ```ts
* editor.execute( 'toggleTableCaption', { focusCaptionOnShow: true } );
* ```
*/ var $f1b97c36043e973c$export$d54798c92a6e033a = class extends (0, $7ca4ca5784e50ca9$export$cc7e12c76513e857) {
    /**
	* @inheritDoc
	*/ refresh() {
        const editor = this.editor;
        const tableElement = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(editor.model.document.selection);
        this.isEnabled = !!tableElement && editor.model.schema.checkChild(tableElement, "caption");
        if (!this.isEnabled) this.value = false;
        else this.value = !!$f1b97c36043e973c$export$d67d386186184bb5(tableElement);
    }
    /**
	* Executes the command.
	*
	* ```ts
	* editor.execute( 'toggleTableCaption' );
	* ```
	*
	* @param options Options for the executed command.
	* @param options.focusCaptionOnShow When true and the caption shows up, the selection will be moved into it straight away.
	* @fires execute
	*/ execute({ focusCaptionOnShow: focusCaptionOnShow = false } = {}) {
        this.editor.model.change((writer)=>{
            if (this.value) this._hideTableCaption(writer);
            else this._showTableCaption(writer, focusCaptionOnShow);
        });
    }
    /**
	* Shows the table caption. Also:
	*
	* * it attempts to restore the caption content from the `TableCaptionEditing` caption registry,
	* * it moves the selection to the caption right away, it the `focusCaptionOnShow` option was set.
	*
	* @param focusCaptionOnShow Default focus behavior when showing the caption.
	*/ _showTableCaption(writer, focusCaptionOnShow) {
        const model = this.editor.model;
        const tableElement = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(model.document.selection);
        const newCaptionElement = this.editor.plugins.get("TableCaptionEditing")._getSavedCaption(tableElement) || writer.createElement("caption");
        model.insertContent(newCaptionElement, tableElement, "end");
        if (focusCaptionOnShow) writer.setSelection(newCaptionElement, "in");
    }
    /**
	* Hides the caption of a selected table (or an table caption the selection is anchored to).
	*
	* The content of the caption is stored in the `TableCaptionEditing` caption registry to make this
	* a reversible action.
	*/ _hideTableCaption(writer) {
        const model = this.editor.model;
        const tableElement = $f1b97c36043e973c$export$e1bcb8cb2e3b8de1(model.document.selection);
        const tableCaptionEditing = this.editor.plugins.get("TableCaptionEditing");
        const captionElement = $f1b97c36043e973c$export$d67d386186184bb5(tableElement);
        tableCaptionEditing._saveCaption(tableElement, captionElement);
        model.deleteContent(writer.createSelection(captionElement, "on"));
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecaption/tablecaptionediting
*/ /**
* The table caption editing plugin.
*/ var $f1b97c36043e973c$export$8c2d21e897a86277 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* A map that keeps saved JSONified table captions and table model elements they are
	* associated with.
	*
	* To learn more about this system, see {@link #_saveCaption}.
	*/ _savedCaptionsMap = /* @__PURE__ */ new WeakMap();
    /**
	* A map that keeps generated ids for table captions to reuse them if the same caption is rendered again.
	*/ _captionIdsMapping = /* @__PURE__ */ new WeakMap();
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCaptionEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const view = editor.editing.view;
        const t = editor.t;
        const useCaptionElement = editor.config.get("table.tableCaption.useCaptionElement");
        if (!schema.isRegistered("caption")) schema.register("caption", {
            allowIn: "table",
            allowContentOf: "$block",
            isLimit: true
        });
        else schema.extend("caption", {
            allowIn: "table"
        });
        editor.commands.add("toggleTableCaption", new $f1b97c36043e973c$export$d54798c92a6e033a(this.editor));
        if (useCaptionElement) editor.plugins.get("TableEditing").registerAdditionalSlot({
            filter: (element)=>element.is("element", "caption"),
            positionOffset: "end"
        });
        editor.conversion.for("upcast").elementToElement({
            view: $f1b97c36043e973c$export$d5439d6bbf9a4013,
            model: "caption"
        });
        editor.conversion.for("dataDowncast").elementToElement({
            model: "caption",
            view: (modelElement, { writer: writer })=>{
                if (!$f1b97c36043e973c$export$1ec15407b49260c7(modelElement.parent)) return null;
                return writer.createContainerElement(useCaptionElement ? "caption" : "figcaption");
            }
        });
        editor.conversion.for("editingDowncast").elementToElement({
            model: "caption",
            view: (modelElement, { writer: writer })=>{
                if (!$f1b97c36043e973c$export$1ec15407b49260c7(modelElement.parent)) return null;
                const captionElement = writer.createEditableElement(useCaptionElement ? "caption" : "figcaption");
                writer.setCustomProperty("tableCaption", true, captionElement);
                captionElement.placeholder = t("Enter table caption");
                (0, $b9b9f2bdf9c6137f$export$60a783c4b7d78e80)({
                    view: view,
                    element: captionElement,
                    keepOnFocus: true
                });
                return (0, $5547ab21e02f1e9e$export$f2153e4522f49b8e)(captionElement, writer);
            }
        });
        editor.conversion.for("editingDowncast").add((dispatcher)=>{
            dispatcher.on("insert:table", (evt, data, { writer: writer, mapper: mapper })=>{
                const modelTable = data.item;
                const viewFigure = mapper.toViewElement(modelTable);
                if (!viewFigure) return;
                const viewTable = Array.from(viewFigure.getChildren()).find((child)=>child.is("element", "table"));
                if (!viewTable) return;
                const modelCaption = $f1b97c36043e973c$export$d67d386186184bb5(modelTable);
                if (!modelCaption) {
                    writer.removeAttribute("aria-labelledby", viewTable);
                    return;
                }
                const viewCaption = mapper.toViewElement(modelCaption);
                if (!viewCaption) return;
                let captionId;
                if (viewCaption.hasAttribute("id")) captionId = viewCaption.getAttribute("id");
                else captionId = this._captionIdsMapping.get(modelCaption) ?? `ck-editor__caption_${(0, $c7bc2cb7e2db0227$export$e2a22331486dcca0)()}`;
                this._captionIdsMapping.set(modelCaption, captionId);
                writer.setAttribute("id", captionId, viewCaption);
                writer.setAttribute("aria-labelledby", captionId, viewTable);
            }, {
                priority: "low"
            });
        });
        $f1b97c36043e973c$export$ea943f88b8962418(editor.model);
    }
    /**
	* Returns the saved {@link module:engine/model/element~ModelElement#toJSON JSONified} caption
	* of a table model element.
	*
	* See {@link #_saveCaption}.
	*
	* @internal
	* @param tableModelElement The model element the caption should be returned for.
	* @returns The model caption element or `null` if there is none.
	*/ _getSavedCaption(tableModelElement) {
        const jsonObject = this._savedCaptionsMap.get(tableModelElement);
        return jsonObject ? (0, $b9b9f2bdf9c6137f$export$ce4fb8eac15afe31).fromJSON(jsonObject) : null;
    }
    /**
	* Saves a {@link module:engine/model/element~ModelElement#toJSON JSONified} caption for
	* a table element to allow restoring it in the future.
	*
	* A caption is saved every time it gets hidden. The
	* user should be able to restore it on demand.
	*
	* **Note**: The caption cannot be stored in the table model element attribute because,
	* for instance, when the model state propagates to collaborators, the attribute would get
	* lost (mainly because it does not convert to anything when the caption is hidden) and
	* the states of collaborators' models would de-synchronize causing numerous issues.
	*
	* See {@link #_getSavedCaption}.
	*
	* @internal
	* @param tableModelElement The model element the caption is saved for.
	* @param caption The caption model element to be saved.
	*/ _saveCaption(tableModelElement, caption) {
        this._savedCaptionsMap.set(tableModelElement, caption.toJSON());
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecaption/tablecaptionui
*/ /**
* The table caption UI plugin. It introduces the `'toggleTableCaption'` UI button.
*/ var $f1b97c36043e973c$export$2578ad3158592086 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCaptionUI";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const t = editor.t;
        editor.ui.componentFactory.add("toggleTableCaption", (locale)=>{
            const command = editor.commands.get("toggleTableCaption");
            const view = new (0, $29fd27cb9bdab9d2$export$4ca10aae50aa7bfa)(locale);
            view.set({
                icon: (0, $e8dc502aba5ac3f5$export$ccdbc3d0432988b9),
                tooltip: true,
                isToggleable: true
            });
            view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
            view.bind("label").to(command, "value", (value)=>value ? t("Toggle caption off") : t("Toggle caption on"));
            this.listenTo(view, "execute", ()=>{
                editor.execute("toggleTableCaption", {
                    focusCaptionOnShow: true
                });
                if (command.value) {
                    const modelCaptionElement = $f1b97c36043e973c$export$274ec9ac27a6b631(editor.model.document.selection);
                    const figcaptionElement = editor.editing.mapper.toViewElement(modelCaptionElement);
                    if (!figcaptionElement) return;
                    editingView.scrollToTheSelection();
                    editingView.change((writer)=>{
                        writer.addClass("table__caption_highlighted", figcaptionElement);
                    });
                }
                editor.editing.view.focus();
            });
            return view;
        });
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablecaption
*/ /**
* The table caption plugin.
*/ var $f1b97c36043e973c$export$35468a455d619eb3 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableCaption";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$8c2d21e897a86277,
            $f1b97c36043e973c$export$2578ad3158592086
        ];
    }
};
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablescroll/watchers
*/ /**
* Creates a live collection of all `table` model elements present in the document and keeps it
* up to date as tables are inserted, moved, or removed.
*
* @internal
*/ function $f1b97c36043e973c$var$watchTableModelElements(model) {
    const tables = new (0, $c7bc2cb7e2db0227$export$fb8073518f34e6ec)();
    model.document.on("change", ()=>{
        const documentChanges = model.document.differ.getChanges();
        const insertedTables = /* @__PURE__ */ new Set();
        const movedTables = /* @__PURE__ */ new Set();
        for (const change of documentChanges)if (change.type === "insert" && change.name !== "$text" && change.position.nodeAfter) {
            const range = model.createRangeOn(change.position.nodeAfter);
            for (const item of range.getItems()){
                if (!item.is("element", "table")) continue;
                if (tables.has(item)) movedTables.add(item);
                else insertedTables.add(item);
            }
        }
        for (const table of Array.from(tables)){
            if (table.root.rootName !== "$graveyard") continue;
            insertedTables.delete(table);
            movedTables.delete(table);
            if (tables.has(table)) tables.remove(table);
        }
        for (const table of movedTables)/* v8 ignore else -- @preserve */ if (tables.has(table)) tables.remove(table);
        if (insertedTables.size || movedTables.size) tables.addMany([
            ...insertedTables,
            ...movedTables
        ]);
    });
    return tables;
}
/**
* Observes the DOM width of every editing root and calls `onResize` whenever any of them changes width.
* Height-only changes are ignored, since only a root's width can make a table overflow it.
*
* @internal
*/ function $f1b97c36043e973c$var$watchRootsWidthResize(view, onResize) {
    const observers = /* @__PURE__ */ new Map();
    const lastKnownWidths = /* @__PURE__ */ new Map();
    return $f1b97c36043e973c$var$watchRoots(view, {
        onAttach: (domRoot, rootName)=>{
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const width = entry.contentRect.width;
                    if (lastKnownWidths.get(rootName) === width) continue;
                    lastKnownWidths.set(rootName, width);
                    onResize();
                }
            });
            observer.observe(domRoot);
            observers.set(rootName, observer);
        },
        onDetach: (_, rootName)=>{
            observers.get(rootName).disconnect();
            observers.delete(rootName);
            lastKnownWidths.delete(rootName);
        }
    });
}
/**
* Listens to `scroll` on every editing root and calls `onScroll` for scrolls happening anywhere inside them.
*
* @internal
*/ function $f1b97c36043e973c$var$watchRootsScroll(view, onScroll) {
    const domEmitter = new ((0, $c7bc2cb7e2db0227$export$537a1d64e9da4c8f)())();
    return $f1b97c36043e973c$var$watchRoots(view, {
        onAttach: (domRoot)=>domEmitter.listenTo(domRoot, "scroll", onScroll, {
                useCapture: true
            }),
        onDetach: (domRoot)=>domEmitter.stopListening(domRoot, "scroll", onScroll)
    });
}
/**
* Calls `onAttach` for the DOM element of every editing root, both those present now and those added later,
* and `onDetach` when a root goes away. Returns a function that detaches everything and stops watching.
*/ function $f1b97c36043e973c$var$watchRoots(view, { onAttach: onAttach, onDetach: onDetach }) {
    const { roots: roots } = view.document;
    const attachedRoots = /* @__PURE__ */ new Map();
    const attach = (rootName)=>{
        const domRoot = view.getDomRoot(rootName);
        const previousDomRoot = attachedRoots.get(rootName);
        if (previousDomRoot === domRoot) return;
        if (previousDomRoot) {
            attachedRoots.delete(rootName);
            onDetach(previousDomRoot, rootName);
        }
        if (domRoot) {
            attachedRoots.set(rootName, domRoot);
            onAttach(domRoot, rootName);
        }
    };
    const detach = (rootName)=>{
        const domRoot = attachedRoots.get(rootName);
        if (!domRoot) return;
        attachedRoots.delete(rootName);
        onDetach(domRoot, rootName);
    };
    const onRootAdd = (evt, viewRoot)=>attach(viewRoot.rootName);
    const onRootRemove = (evt, viewRoot)=>detach(viewRoot.rootName);
    const attachAllRoots = ()=>{
        for (const root of roots)attach(root.rootName);
    };
    attachAllRoots();
    roots.on("add", onRootAdd);
    roots.on("remove", onRootRemove);
    view.on("render", attachAllRoots);
    return ()=>{
        roots.off("add", onRootAdd);
        roots.off("remove", onRootRemove);
        view.off("render", attachAllRoots);
        for (const rootName of Array.from(attachedRoots.keys()))detach(rootName);
    };
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablescroll/tablescrollediting
*/ /**
* The table scrolling editing plugin.
*/ var $f1b97c36043e973c$export$4f9553c931a977e0 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* Stops the `scroll` listeners set up by {@link #_watchFiguresScroll}.
	*/ _stopWatchingRootsScroll;
    /**
	* Stops the `resize` observers set up by {@link #_watchRootEditables}.
	*/ _stopWatchingRootsResize;
    /**
	* The throttled recalculation callback set up by {@link #_watchRootEditables}, kept so {@link #destroy}
	* can cancel any call still pending. `undefined` until {@link #init} has run.
	*/ _throttledRecalculateAll;
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableScrollEditing";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$b5fa926abf3ddb23
        ];
    }
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        editor.config.define("table.tableScroll.tableTypes", [
            "content"
        ]);
    }
    /**
	* @inheritDoc
	*/ init() {
        const { editor: editor } = this;
        const tables = $f1b97c36043e973c$var$watchTableModelElements(editor.model);
        this._watchNewTables(tables);
        this._watchRootEditables(tables);
        this._registerConversion();
        this._watchColumnResize();
        this._watchFiguresScroll();
    }
    /**
	* @inheritDoc
	*/ destroy() {
        this._stopWatchingRootsScroll?.();
        this._stopWatchingRootsResize?.();
        this._throttledRecalculateAll?.cancel();
        super.destroy();
    }
    /**
	* Whether a given table may overflow its container and become horizontally scrollable, and whether
	* column/table resizing is allowed to grow it past the container's width.
	*
	* @internal
	*/ _isTableScrollable(table) {
        if (table.parent !== table.root) return false;
        const tableType = table.getAttribute("tableType") || "content";
        return this.editor.config.get("table.tableScroll.tableTypes").includes(tableType);
    }
    /**
	* Determines whether a table overflows its container and applies the corresponding view state:
	* the `ck-table-overflowing` class on the figure, and the actual (possibly container-exceeding)
	* width on the inner `<table>` and a sibling `<figcaption>`, if present.
	*
	* @internal
	*/ _updateTableScrollOverflowState(table, tableWidthOverride) {
        const { editor: editor } = this;
        const containerWidth = $f1b97c36043e973c$var$getEditableContentWidth(editor, table.root.rootName);
        if (containerWidth === null) return;
        const viewFigure = editor.editing.mapper.toViewElement(table);
        if (!viewFigure) return;
        const viewTable = $f1b97c36043e973c$var$findChildElement(viewFigure, "table");
        if (!viewTable) return;
        const viewFigcaption = $f1b97c36043e973c$var$findChildElement(viewFigure, "figcaption");
        let tableWidth = null;
        let hasTableWidthSource = false;
        if (tableWidthOverride !== void 0) {
            tableWidth = tableWidthOverride;
            hasTableWidthSource = true;
        } else if (table.hasAttribute("tableWidth")) {
            tableWidth = table.getAttribute("tableWidth");
            hasTableWidthSource = true;
        }
        if (!hasTableWidthSource) return;
        const isOverflowing = !!tableWidth && this._isTableScrollable(table) && $f1b97c36043e973c$var$isTableWidthOverflowing(tableWidth, containerWidth);
        if (isOverflowing) this._scheduleScrollOffsetSync(viewFigure);
        editor.editing.view.change((writer)=>{
            if (isOverflowing) {
                writer.removeStyle("width", viewFigure);
                writer.addClass("ck-table-overflowing", viewFigure);
                writer.setStyle("width", tableWidth, viewTable);
                if (viewFigcaption) writer.setStyle("width", tableWidth, viewFigcaption);
            } else {
                if (tableWidth) writer.setStyle("width", tableWidth, viewFigure);
                else writer.removeStyle("width", viewFigure);
                if (viewFigcaption) writer.removeStyle("width", viewFigcaption);
                writer.removeClass("ck-table-overflowing", viewFigure);
                writer.removeStyle("width", viewTable);
                writer.removeStyle("--ck-table-scroll-offset", viewFigure);
            }
        });
    }
    /**
	* Schedules a re-read of the widget figure's actual `scrollLeft` into `--ck-table-scroll-offset`, once
	* the render reflecting the change that triggered it has actually happened - see the call site for why
	* this can't just read (and force a reflow for) `scrollLeft` immediately instead.
	*/ _scheduleScrollOffsetSync(viewFigure) {
        const { view: view } = this.editor.editing;
        view.once("render", ()=>{
            const domFigure = view.domConverter.mapViewToDom(viewFigure);
            /* v8 ignore else -- @preserve */ if (domFigure) view.change((writer)=>{
                writer.setStyle("--ck-table-scroll-offset", `${domFigure.scrollLeft}px`, viewFigure);
            });
        });
    }
    /**
	* Registers editing-only downcast listeners that keep overflow state in sync.
	*/ _registerConversion() {
        const { editor: editor } = this;
        editor.conversion.for("editingDowncast").add((dispatcher)=>{
            dispatcher.on("attribute:tableWidth:table", (evt, data)=>{
                this._updateTableScrollOverflowState(data.item, data.attributeNewValue);
            }, {
                priority: "low"
            });
            dispatcher.on("attribute:tableType:table", (evt, data)=>{
                this._updateTableScrollOverflowState(data.item);
            }, {
                priority: "low"
            });
            dispatcher.on("insert:caption", (evt, data)=>{
                const modelTable = data.item.parent;
                if (modelTable?.is("element", "table")) this._updateTableScrollOverflowState(modelTable);
            }, {
                priority: "lowest"
            });
            dispatcher.on("insert:table", (evt, data)=>{
                this._updateTableScrollOverflowState(data.item);
            }, {
                priority: "lowest"
            });
        });
    }
    /**
	* Keeps every overflowing table's `--ck-table-scroll-offset` custom property in sync with its
	* `scrollLeft`, using a single delegated listener instead of one native listener per table.
	*/ _watchFiguresScroll() {
        const { editor: editor } = this;
        const { view: view } = editor.editing;
        const onScroll = (evt, domEvent)=>{
            const domFigure = domEvent.target;
            if (!domFigure.classList?.contains("ck-table-overflowing")) return;
            const viewFigure = view.domConverter.mapDomToView(domFigure);
            if (!viewFigure) return;
            view.change((writer)=>{
                writer.setStyle("--ck-table-scroll-offset", `${domFigure.scrollLeft}px`, viewFigure);
            });
        };
        this._stopWatchingRootsScroll = $f1b97c36043e973c$var$watchRootsScroll(view, onScroll);
    }
    /**
	* Listen for column resize events and updates proper view element size.
	*/ _watchColumnResize() {
        const { editor: editor } = this;
        const { plugins: plugins } = editor;
        if (!plugins.has("TableColumnResizeEditing")) return;
        const columnResizeEditing = plugins.get("TableColumnResizeEditing");
        this.listenTo(columnResizeEditing, "_setResizingTableWidth", (evt, [, viewFigure, width])=>{
            evt.stop();
            const modelTable = editor.editing.mapper.toModelElement(viewFigure);
            this._updateTableScrollOverflowState(modelTable, width);
        }, {
            priority: "high"
        });
        this.listenTo(columnResizeEditing, "_getResizingTableWidth", (evt, [viewFigure])=>{
            evt.stop();
            evt.return = $f1b97c36043e973c$var$getWidthHoldingElement(viewFigure).getStyle("width");
        }, {
            priority: "high"
        });
    }
    /**
	* Re-evaluates the overflow state of every table whenever the window or an editing root is resized.
	*/ _watchRootEditables(tables) {
        const { editor: editor } = this;
        const recalculateAll = ()=>{
            const resizingTable = $f1b97c36043e973c$var$getCurrentlyResizingTable(editor);
            for (const table of tables){
                if (table === resizingTable) continue;
                this._updateTableScrollOverflowState(table);
            }
        };
        this._throttledRecalculateAll = (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(recalculateAll, 100);
        this._stopWatchingRootsResize = $f1b97c36043e973c$var$watchRootsWidthResize(editor.editing.view, this._throttledRecalculateAll);
        editor.ui.view.listenTo((0, $c7bc2cb7e2db0227$export$90b4d2ff6acb88af).window, "resize", this._throttledRecalculateAll);
        editor.once("ready", recalculateAll);
    }
    /**
	* Evaluates the overflow state of every newly inserted table.
	*/ _watchNewTables(tables) {
        this.listenTo(tables, "change", (evt, data)=>{
            for (const table of data.added)this._updateTableScrollOverflowState(table);
        });
    }
};
/**
* Returns the table for which a column resize is currently in progress, if the
* `TableColumnResizeEditing` plugin is loaded and such a resize is active.
*/ function $f1b97c36043e973c$var$getCurrentlyResizingTable(editor) {
    const { plugins: plugins } = editor;
    if (!plugins.has("TableColumnResizeEditing")) return null;
    return plugins.get("TableColumnResizeEditing").resizingTable;
}
/**
* Checks if given table width overflows container width.
*/ function $f1b97c36043e973c$var$isTableWidthOverflowing(tableWidth, containerWidth) {
    if (tableWidth.endsWith("%")) return parseFloat(tableWidth) > 100;
    if (tableWidth.endsWith("px")) return parseFloat(tableWidth) > containerWidth;
    return false;
}
/**
* Returns whichever element - the widget's `<figure>` or its inner `<table>` - currently holds the
* table's actual (possibly container-exceeding) width: the `<table>` while overflowing, the `<figure>`
* otherwise.
*/ function $f1b97c36043e973c$var$getWidthHoldingElement(viewFigure) {
    return viewFigure.hasClass("ck-table-overflowing") ? $f1b97c36043e973c$var$findChildElement(viewFigure, "table") : viewFigure;
}
/**
* Finds a direct child element of `parent` by its name.
*/ function $f1b97c36043e973c$var$findChildElement(parent, elementName) {
    return Array.from(parent.getChildren()).find((child)=>child.is("element", elementName));
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* @module table/tablescroll
*/ var $f1b97c36043e973c$export$8f3a78b46c2eb720 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "TableScroll";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get requires() {
        return [
            $f1b97c36043e973c$export$4f9553c931a977e0
        ];
    }
};







/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */ 



/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* Returns a plain text representation of an element and its children.
*
* @internal
* @returns Plain text representing the model's data.
*/ function $aeb272b2cfa576be$export$b5486e9a77cdc9fe(item) {
    if (item.is("$text") || item.is("$textProxy")) return item.data;
    const element = item;
    let text = "";
    let prev = null;
    for (const child of element.getChildren()){
        const childText = $aeb272b2cfa576be$export$b5486e9a77cdc9fe(child);
        if (prev && prev.is("element")) text += "\n";
        text += childText;
        prev = child;
    }
    return text;
}
/**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ /**
* The word count plugin.
*
* This plugin calculates all words and characters in all {@link module:engine/model/text~ModelText text nodes} available in the model.
* It also provides an HTML element that updates its state whenever the editor content is changed.
*
* The model's data is first converted to plain text using {@link module:word-count/utils~modelElementToPlainText}.
* The number of words and characters in your text are determined based on the created plain text. Please keep in mind
* that every block in the editor is separated with a newline character, which is included in the calculation.
*
* Here are some examples of how the word and character calculations are made:
*
* ```html
* <paragraph>foo</paragraph>
* <paragraph>bar</paragraph>
* // Words: 2, Characters: 7
*
* <paragraph><$text bold="true">foo</$text>bar</paragraph>
* // Words: 1, Characters: 6
*
* <paragraph>*&^%)</paragraph>
* // Words: 0, Characters: 5
*
* <paragraph>foo(bar)</paragraph>
* //Words: 1, Characters: 8
*
* <paragraph>12345</paragraph>
* // Words: 1, Characters: 5
* ```
*/ var $aeb272b2cfa576be$export$732bbbf8768a61f7 = class extends (0, $7ca4ca5784e50ca9$export$901cf72dabf2112a) {
    /**
	* The configuration of this plugin.
	*/ _config;
    /**
	* The reference to a {@link module:ui/view~View view object} that contains the self-updating HTML container.
	*/ _outputView;
    /**
	* A regular expression used to recognize words in the editor's content.
	*/ _wordsMatchRegExp;
    /**
	* @inheritDoc
	*/ constructor(editor){
        super(editor);
        this.set("characters", 0);
        this.set("words", 0);
        Object.defineProperties(this, {
            characters: {
                get () {
                    return this.characters = this._getCharacters(this._getText());
                }
            },
            words: {
                get () {
                    return this.words = this._getWords(this._getText());
                }
            }
        });
        this.set("_wordsLabel", void 0);
        this.set("_charactersLabel", void 0);
        this._config = editor.config.get("wordCount") || {};
        this._outputView = void 0;
        this._wordsMatchRegExp = (0, $c7bc2cb7e2db0227$export$a7b6bc01c63cdfc3).features.isRegExpUnicodePropertySupported ? new RegExp("([\\p{L}\\p{N}]+\\S?)+", "gu") : /([a-zA-Z0-9À-ž]+\S?)+/gu;
    }
    /**
	* @inheritDoc
	*/ static get pluginName() {
        return "WordCount";
    }
    /**
	* @inheritDoc
	* @internal
	*/ static get licenseFeatureCode() {
        return "WC";
    }
    /**
	* @inheritDoc
	*/ static get isOfficialPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ static get isPremiumPlugin() {
        return true;
    }
    /**
	* @inheritDoc
	*/ init() {
        this.editor.model.document.on("change:data", (0, $a6974e6fde7d8b9c$export$de363e709c412c8a)(this._refreshStats.bind(this), 250));
        if (typeof this._config.onUpdate == "function") this.on("update", (evt, data)=>{
            this._config.onUpdate(data);
        });
        if ((0, $7ea5355649bb40ad$export$45a5e7f76e0caa8d)(this._config.container)) this._config.container.appendChild(this.wordCountContainer);
    }
    /**
	* @inheritDoc
	*/ destroy() {
        if (this._outputView) {
            this._outputView.element.remove();
            this._outputView.destroy();
        }
        super.destroy();
    }
    /**
	* Creates a self-updating HTML element. Repeated executions return the same element.
	* The returned element has the following HTML structure:
	*
	* ```html
	* <div class="ck ck-word-count">
	* 	<div class="ck-word-count__words">Words: 4</div>
	* 	<div class="ck-word-count__characters">Characters: 28</div>
	* </div>
	* ```
	*/ get wordCountContainer() {
        const editor = this.editor;
        const t = editor.t;
        const displayWords = editor.config.get("wordCount.displayWords");
        const displayCharacters = editor.config.get("wordCount.displayCharacters");
        const bind = (0, $29fd27cb9bdab9d2$export$14416b8d99d47caa).bind(this, this);
        const children = [];
        if (!this._outputView) {
            this._outputView = new (0, $29fd27cb9bdab9d2$export$27a5bd065ad55220)();
            if (displayWords || displayWords === void 0) {
                this.bind("_wordsLabel").to(this, "words", (words)=>{
                    return t("Words: %0", words);
                });
                children.push({
                    tag: "div",
                    children: [
                        {
                            text: [
                                bind.to("_wordsLabel")
                            ]
                        }
                    ],
                    attributes: {
                        class: "ck-word-count__words"
                    }
                });
            }
            if (displayCharacters || displayCharacters === void 0) {
                this.bind("_charactersLabel").to(this, "characters", (words)=>{
                    return t("Characters: %0", words);
                });
                children.push({
                    tag: "div",
                    children: [
                        {
                            text: [
                                bind.to("_charactersLabel")
                            ]
                        }
                    ],
                    attributes: {
                        class: "ck-word-count__characters"
                    }
                });
            }
            this._outputView.setTemplate({
                tag: "div",
                attributes: {
                    class: [
                        "ck",
                        "ck-word-count"
                    ]
                },
                children: children
            });
            this._outputView.render();
        }
        return this._outputView.element;
    }
    _getText() {
        let txt = "";
        for (const root of this.editor.model.document.getRoots()){
            if (txt !== "") txt += "\n";
            txt += $aeb272b2cfa576be$export$b5486e9a77cdc9fe(root);
        }
        return txt;
    }
    /**
	* Determines the number of characters in the current editor's model.
	*/ _getCharacters(txt) {
        return txt.replace(/\n/g, "").length;
    }
    /**
	* Determines the number of words in the current editor's model.
	*/ _getWords(txt) {
        return (txt.match(this._wordsMatchRegExp) || []).length;
    }
    /**
	* Determines the number of words and characters in the current editor's model and assigns it to {@link #characters} and {@link #words}.
	* It also fires the {@link #event:update}.
	*
	* @fires update
	*/ _refreshStats() {
        const txt = this._getText();
        const words = this.words = this._getWords(txt);
        const characters = this.characters = this._getCharacters(txt);
        this.fire("update", {
            words: words,
            characters: characters
        });
    }
};


 /**
* @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/ 


class $92c35f6e49e322a8$export$7cda8d932e2f33c0 extends (0, $214c629190e85ae1$export$9abc99ab116ac079) {
    static builtinPlugins = [
        (0, $58c9e1b8584bd78b$export$8889c40da46082d3),
        (0, $bf98a02724d3a932$export$181f102f0a3746b9),
        (0, $43897c58e8fc0f5a$export$95aa4184327d6b72),
        (0, $25ed63831c0cafe6$export$73e53d20f104f7b7),
        (0, $1b35fec9bb40f81b$export$7ecb7f71abb61ffe),
        (0, $c1535c9df13f8c33$export$83349e247298922),
        (0, $308936d8e01dd630$export$c8fb568fd3d3ad20),
        (0, $b0a292d57bbde1dc$export$3da9e25a7afe430c),
        (0, $de969e057c99c515$export$9232476bfd6c1299),
        (0, $50e4d8c8f321fe5d$export$4e8c88df3b46ac4c),
        (0, $794b0589489e3c66$export$a8a3e93435678ff9),
        (0, $794b0589489e3c66$export$1a42c692577d2930),
        (0, $7c22895ca0418c15$export$3e431a229df88919),
        (0, $7c22895ca0418c15$export$b767941ef6c6912b),
        (0, $7c22895ca0418c15$export$ba2c579b6e9f00f2),
        (0, $7c22895ca0418c15$export$10f56897f0313dc5),
        (0, $7c22895ca0418c15$export$6083e5dee0802eaa),
        (0, $fad37f7205186735$export$e883eb7bc5d8ee6),
        (0, $43897c58e8fc0f5a$export$1cfcf4275506b1c6),
        (0, $8fb2b7bcf5f9e330$export$a6c7ac8248d6e38a),
        (0, $ab0101fae4fd036b$export$54c2e3dc7acea9f5),
        (0, $a013102e0bac7fe2$export$4b6510ff30f01098),
        (0, $f6000c35cc5ce21e$export$358a232cca1ab2ac),
        (0, $f6000c35cc5ce21e$export$264a07d2ecb76a92),
        (0, $c9a106b2ac3205bf$export$cb15bc3be08b1f4e),
        (0, $7c22895ca0418c15$export$ee5c7d7da5e0c82f),
        (0, $15820aed140fcb11$export$60a3cfdb2f0fca54),
        (0, $006803d1f21b9692$export$d9e45bc13d335801),
        (0, $f1b97c36043e973c$export$54ec01a60f47d33d),
        (0, $f1b97c36043e973c$export$6a2d8ec0c309d683),
        (0, $f1defb5a0a139b4c$export$1ce548c794124571)
    ];
    static defaultConfig = {
        toolbar: {
            items: [
                'paragraph',
                'heading1',
                'heading2',
                'heading3',
                '|',
                'bold',
                'italic',
                'link',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'outdent',
                'indent',
                '|',
                'sourceEditing',
                '|',
                'undo',
                'redo'
            ]
        },
        image: {
            toolbar: [
                'imageStyle:inline',
                'imageStyle:block',
                'imageStyle:side',
                '|',
                'toggleImageCaption',
                'imageTextAlternative'
            ]
        },
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells'
            ]
        },
        language: 'en',
        licenseKey: 'GPL',
        heading: {
            options: [
                {
                    model: 'paragraph',
                    title: 'Paragraph',
                    class: 'ck-heading_paragraph'
                },
                {
                    model: 'heading1',
                    view: 'h1',
                    title: 'Heading 1',
                    class: 'ck-heading_heading1'
                },
                {
                    model: 'heading2',
                    view: 'h2',
                    title: 'Heading 2',
                    class: 'ck-heading_heading2'
                },
                {
                    model: 'heading3',
                    view: 'h3',
                    title: 'Heading 3',
                    class: 'ck-heading_heading3'
                }
            ]
        },
        htmlSupport: {
            allow: [
                {
                    name: 'div',
                    classes: [
                        'otp',
                        'apple-otp'
                    ],
                    attributes: true
                }
            ]
        }
    };
}
function $92c35f6e49e322a8$export$9226a37e1b4df5e7(container = document) {
    container.querySelectorAll("textarea.rich-text").forEach((element)=>{
        $92c35f6e49e322a8$export$7cda8d932e2f33c0.create(element).then((editor)=>{
            editor.ui.view.element.classList.add('rich-text');
            const id = editor.sourceElement.id;
            const toggle = document.querySelector(`[data-toggle-reset-plaintext="${id}"]`);
            const plainText = document.querySelector(`[data-plain-text-for="${id}"]`);
            if (toggle && plainText) toggle.addEventListener("click", ()=>{
                plainText.value = (0, $4fa913ac1af6a08c$export$7c1b962cbec163d6)((0, $b9b9f2bdf9c6137f$export$f7719161406171fa), editor.editing.view.document.getRoot());
            });
        }).catch((error)=>{
            console.error(error);
        });
    });
}


const $6667d9972563ae6f$var$configRequest = (e, form)=>{
    if (e.detail.verb.toLowerCase() != "get") e.detail.parameters._csrf = (0, $df43d05d75fb9bbd$export$c077d53e8672d0e9)(form);
};
const $6667d9972563ae6f$export$3bddea739ad24787 = ()=>{
    document.addEventListener('htmx:configRequest', (e)=>$6667d9972563ae6f$var$configRequest(e));
    document.addEventListener('htmx:afterSettle', (e)=>{
        (0, $71157344672d24b0$export$942ff210707e0e16)(e.detail.elt);
        (0, $92c35f6e49e322a8$export$9226a37e1b4df5e7)(e.detail.elt);
        (0, $0451e076155c8af2$export$60523367a7e10402)(e.detail.elt);
        (0, $0451e076155c8af2$export$7d03d001ca71c65f)(e.detail.elt);
        (0, $0451e076155c8af2$export$e30e8b9f67d70081)();
        const modalClose = [
            ...e.detail.elt.querySelectorAll(".modal-close")
        ];
        modalClose.forEach((btn)=>{
            const modal = btn.closest(".modal");
            if (modal) btn.addEventListener("click", ()=>{
                modal.classList.remove("active");
                modal.setAttribute("aria-hidden", "true");
            });
        });
    });
};




const $383bb8883841a3fe$var$disableSubmit = (elm)=>{
    const icon = document.createElement("i");
    icon.classList.add("icon-spinner-outline", "rotate");
    elm.classList.add("has-icon");
    elm.appendChild(icon);
    elm.disabled = true;
};
function $383bb8883841a3fe$export$91d02d797908de92() {
    const forms = [
        ...document.querySelectorAll("form:not([data-disable-interfere-submit])")
    ];
    forms.forEach((form)=>{
        let submitted = false;
        const submits = form.querySelectorAll('[type="submit"]');
        form.addEventListener("submit", (e)=>{
            if (submitted) e.preventDefault();
            submits.forEach($383bb8883841a3fe$var$disableSubmit);
            submitted = true;
        });
    });
}



(0, $fae8e84091194bdf$export$ed413954a0d25a18)();
(0, $ac3e1fcae237d601$export$ed8a68ffbc322e67)();
(0, $0451e076155c8af2$export$7d03d001ca71c65f)();
(0, $0451e076155c8af2$export$34107ba18b519094)();
(0, $0451e076155c8af2$export$a4db3bf4a43c81e3)();
(0, $0451e076155c8af2$export$a4d38683f8b8b9ce)();
(0, $0451e076155c8af2$export$60523367a7e10402)();
(0, $0451e076155c8af2$export$e30e8b9f67d70081)();
(0, $0451e076155c8af2$export$a11733f716447e79)();
(0, $0451e076155c8af2$export$70070ff97f1a4ca0)();
(0, $383bb8883841a3fe$export$91d02d797908de92)();
(0, $6667d9972563ae6f$export$3bddea739ad24787)();
(0, $92c35f6e49e322a8$export$9226a37e1b4df5e7)();
(0, $71157344672d24b0$export$942ff210707e0e16)();

})();
//# sourceMappingURL=index.js.map
